/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/static/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(656);
	module.exports = __webpack_require__(617);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1149);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(1010)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)(module)))

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(10)
	  , core      = __webpack_require__(64)
	  , hide      = __webpack_require__(38)
	  , redefine  = __webpack_require__(39)
	  , ctx       = __webpack_require__(65)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _localizedStrings = __webpack_require__(618);
	
	var _localizedStrings2 = _interopRequireDefault(_localizedStrings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var strings = new _localizedStrings2.default({
	    en: _extends({
	        amount: 'Amount',
	        noUpcommingStages: 'no upcomming stages',
	        news: 'news',
	        partners: 'partners',
	        hello: 'hello',
	        about: 'about',
	        stages: 'stages',
	        results: 'results',
	        contacts: 'contacts',
	        registration: 'registration',
	        participants: 'participants',
	        participant: 'participant',
	        stage: 'stage',
	        stageInfo: 'Stage info',
	        regulations: 'regulations',
	        registeredSuccessfully: 'Registered successfully',
	        pay: 'pay',
	        timeLeft: 'Time left',
	        register: 'register',
	        registrationClosed: 'Registration to this stage is closed',
	        paymentCanceled: 'Payment canceled',
	        paymentCanceledText: 'Your payment was canceled',
	        agreeOnTerms: 'Agree on terms ',
	        season: 'season',
	        firstName: 'First name',
	        lastName: 'Last name',
	        gender: 'Gender',
	        email: 'Email',
	        phone: 'Phone',
	        friendPhone: 'Friend\'s phone',
	        city: 'City',
	        club: 'Club',
	        payed: 'Payed',
	        submit: 'Submit',
	        male: 'Male',
	        female: 'Female',
	        selectGender: 'Select gender',
	        birthDate: 'Birth date',
	        edit: 'Edit',
	        price: 'Price',
	        distance: 'Distance',
	        noStages: 'No stages',
	        requiredField: 'Required field',
	        minTeamMembers: 'Min. team members:',
	        invalidEmailField: 'Invalid email',
	
	        eventEnded: 'Event ended',
	        hasResults: 'Has results',
	        liveResults: 'Live results',
	
	        title: 'Title',
	        date: 'Date',
	        address: 'address',
	        registrationEnabled: 'Registration enabled',
	
	        isFree: 'Is free',
	        childrenPrice: 'Children price',
	        olderPrice: 'Older price',
	        dateUntil: 'Date until',
	        remove: 'Remove',
	        addPrice: 'Add price',
	        cancel: 'Cancel',
	        noSeasons: 'No seasons',
	        registeredSuccessfullyAndNeedToPay: 'You have registered successfully. You need to pay',
	        registeredSuccessfullyAndGotPayment: 'You have registred successfully and we got your payment.',
	
	        search: 'search',
	        facebook: 'Facebook',
	        instagram: 'Instagram',
	        youtube: 'Youtube',
	        logo: 'Logo',
	        ogImage: 'Social networks image. (1200 X 630 px)',
	        settingsEdit: 'Settings edit',
	        settings: 'Settings',
	        posts: 'Posts',
	        seasons: 'Seasons',
	        viewSite: 'View site',
	        logout: 'Logout',
	        actions: 'Actions',
	        delete: 'Delete',
	        preview: 'Preview',
	        newPost: 'New post',
	        image: 'Image',
	        body: 'body',
	        postEdit: 'Post edit',
	        upload: 'Upload',
	        loading: 'Loading',
	        password: 'Password',
	        eventHasEnded: 'Event has endend',
	        yes: 'Yes',
	        no: 'No',
	        paymentPage: 'Payment page',
	        newParticipant: 'New participant',
	        registerToAllStages: 'Register to all stages',
	        code: 'Code',
	        codeHelperText: 'Code is used when matching routes while registering to all stages',
	        name: 'Name',
	        newStage: 'New stage',
	        stageEdit: 'Stage edit',
	        distanceEdit: 'Distance edit',
	        newDistance: 'New distance',
	        archive: 'Archive',
	        marketingEmailConfirmation: 'I would like to receive marketing emails',
	        publishDate: 'Publish date',
	        newPartner: 'New partner',
	        partnerEdit: 'Partner edit',
	        link: 'Link',
	        export: 'Export',
	        selectStage: 'Select stage',
	        participantsExport: 'Participants export',
	        allParticipantsExport: 'All participants export',
	        order: 'Order',
	        colCount: 'Columns count',
	        stageResults: 'Stage results',
	        noDistances: 'No distances',
	        selectDistance: 'Select distance',
	        noResults: 'No results',
	        selectOrDropFile: 'Select file',
	        doYouWantToRemove: 'Do you want to remove?',
	
	        insurance: 'Insurance',
	        insuranceTextLabel: 'Insurance page label',
	        insuranceTextInRegistration: 'Insurance checkbox text in registration',
	        socialMedia: 'Social media',
	        pages: 'Pages',
	        insuranceText: 'Insurance text',
	        insuranceEnabled: 'Insurance enabled',
	        filters: 'Filters',
	        income: 'Income',
	        medicalConfirmation: 'I am physically ready to run the selected distance and have checked my healt in hospital',
	
	        enLabel: 'In English',
	        ltLabel: 'In Lithuanian',
	
	        displayNews: 'Display news',
	        displayPartners: 'Display partners',
	        singleEventWebsite: 'Single event website',
	        availableMenuItems: 'Available menu items',
	        currentMenuItems: 'Current menu items',
	        add: 'Add',
	
	        title_lt: 'Title in LT',
	        title_en: 'Title in EN',
	        url: 'URL',
	        addToMenu: 'Add to menu',
	        externalRegistration: 'External website registraion',
	        externalRegulationsLink: 'External regulations link',
	        externalRegistrationLink: 'External registration link',
	        externalParticipantsLink: 'External participants link',
	        stageRegulations: 'Regulations',
	        images: 'Images',
	        newImage: 'New image',
	        totalParticipants: 'Total participants',
	        localizationEnabled: 'Localization enabled',
	        globalResultsStage: 'Global results stage',
	        globalResults: 'Global results',
	        registerToCustomStages: 'Register to custom stages',
	        showInMainWindow: 'Show in main window',
	        country: 'Country',
	        participantResultsHistory: 'Participant results history',
	        startSearch: 'Search',
	        participantResults: 'Participant results',
	        weUsePlatform: 'We use',
	        position: 'Position',
	        result: 'Result',
	        resultsPositionFieldValuePos: 'Which col contains position in results file',
	        resultsFileInfo: 'Results file info',
	        diploma: 'Diploma',
	        generateDiploma: 'Generate diploma',
	        diplomaBgImage: 'Diploma BG image(Encoded in base64)',
	        newSeason: 'New season',
	        seasonEdit: 'Season edit',
	        statistics: 'Statistics',
	        login: 'Login',
	        siteConfig: 'Site config',
	        menu: 'Menu',
	        colors: 'Colors',
	        menuColor: 'Menu color',
	        menuHighlightColor: 'Menu Highlight Color',
	        buttonColor: 'Button Color',
	        buttonHoverColor: 'Button Hover Color',
	        partnerCategories: 'Partner categories',
	        newPartnerCategory: 'New partner category',
	        partnerCategoryEdit: 'Partner category edit',
	        partnerCategory: 'Partner category',
	        noCategories: 'No categories',
	
	        gdprConfirmation: 'I agree that my personal data would be collected and used.',
	        gdprPageTitle: 'Personal data collection and use',
	        invalidDateField: 'Invalid date',
	        promoCodes: 'Promo codes',
	        newPromoCode: 'New promo code',
	        codesLeft: 'Codes left',
	        promoCodeEdit: 'Promo code edit',
	        promoCode: 'Promo code',
	        discount: 'Discount',
	        calculating: 'Calculating...',
	
	        paysera: 'Paysera',
	        projectId: 'Project ID',
	        projectPassword: 'Project password',
	        projectHeadTag: 'Project HEAD tag',
	        multipleStageDisplay: 'Multiple stages display on landing',
	
	        webKeywords: 'Web keywords',
	        webDescription: 'Web description',
	
	        tableLink: 'More',
	        seasonPersonIdentifier: 'Season person identifier',
	
	        extraInfo: 'Extra info',
	        displayExtraInfoField: 'Display extra info field on registration',
	        extraInfoFieldRequired: 'Extra info field is required?',
	        extraInfoFieldTitle: 'Extra field text',
	
	        payedFilterLabel: 'Payment status',
	        allPaymentsFilter: 'All',
	        payedFilter: 'Payed',
	        notPayedFilter: 'Not payed',
	
	        invoices: 'Invoices',
	
	        serialNumber: 'Serial'
	
	    }, window.CARE_CONFIG.enMessagesOverride || {}, {
	
	        participantLegendTitle: 'Participant information',
	        paymentInfoLegend: 'Payment info',
	        billingIsCompony: 'Buyer is company?',
	        billingName: 'Buyer',
	        billingEmail: 'Buyer email',
	        billingCompanyCode: 'Company code',
	        billingVatCode: 'VAT code',
	        billingAddress: 'Address',
	        isTeamDistance: 'Is team distance?',
	        maxAgeRestriction: 'Max age to participate',
	
	        teamParticipants: 'Team participants',
	        addTeamMember: 'Add team member',
	        teamName: 'Team name',
	        teamInfo: 'Team info',
	
	        configuration: 'Configuration',
	        seo: 'SEO',
	        age: 'age',
	        registrationClosesDate: 'Registration automatic close date',
	        enableShirtSelection: 'Enable T-shirt selection',
	        shirtSize: 'T-shirt size'
	    }),
	    lt: _extends({
	        amount: 'Suma',
	        seo: 'SEO',
	        ogImage: 'Socialinių tinklų paveikslėlis (1200 X 630 px)',
	
	        noUpcommingStages: 'Nėra artimiausių etapų',
	        news: 'naujienos',
	        partners: 'partneriai',
	        hello: 'pradžia',
	        about: 'apie',
	        stages: 'etapai',
	        results: 'rezultatai',
	        contacts: 'kontaktai',
	        registration: 'registracija',
	        participants: 'dalyviai',
	        participant: 'dalyvis',
	        stage: 'etapas',
	        date: 'Data',
	        regulations: 'nuostatai',
	        registeredSuccessfully: 'Registracija sėkminga',
	        pay: 'Mokėti',
	        timeLeft: 'Iki starto liko',
	        register: 'Registruotis',
	        registrationClosed: 'Registracija uždaryta',
	        paymentCanceled: 'Mokėjimas atšauktas',
	        paymentCanceledText: 'Jūsų mokėjimas atšauktas',
	        stageInfo: 'Etapo informacija',
	        firstName: 'Vardas',
	        lastName: 'Pavardė',
	        gender: 'Lytis',
	        email: 'El. paštas',
	        phone: 'Telefonas',
	        friendPhone: 'Draugo telefonas',
	        city: 'Miestas',
	        club: 'Klubas',
	        payed: 'Apmokėta',
	        submit: 'Išsaugoti',
	        male: 'Vyras',
	        female: 'Moteris',
	        selectGender: 'Pasirinkite lytį',
	        birthDate: 'Gimimo data',
	        edit: 'Redaguoti',
	        addPrice: 'Pridėti kainą',
	        price: 'Kaina',
	        noDistances: 'Nėra distancijų',
	        distance: 'Distancija',
	        noStages: 'Nėra etapų',
	        requiredField: 'Privalomas laukas',
	        minTeamMembers: 'Mažiausiai komandos narių:',
	
	        invalidEmailField: 'Neteisingas el. pašto adresas',
	        eventEnded: 'Renginys jau įvyko',
	        agreeOnTerms: 'Susipažinau ir sutinku su renginio nuostatais',
	        medicalConfirmation: 'Esu fiziškai pasiruošęs dalyvauti pasirinktoje distancijoje ir pasitikrinęs sveikatą gydymo įstaigoje',
	
	        title: 'Pavadinimas',
	        address: 'Adresas',
	        registrationEnabled: 'Registracija įjungta',
	        hasResults: 'Rezultatai',
	        liveResults: 'Rezultatai tiesiogiai',
	        isFree: 'Nemokamas',
	        childrenPrice: 'Kaina vaikams',
	        olderPrice: 'Kaina pensininkams',
	        dateUntil: 'Data iki',
	        rmeove: 'Ištrinti',
	        cancel: 'Atšaukti',
	        season: 'Sezonas',
	        noSeasons: 'Nepasirinktas sezonas',
	
	        registeredSuccessfullyAndNeedToPay: 'Užsiregistravote sėkmingai. Jums reikia sumokėti - ',
	        registeredSuccessfullyAndGotPayment: 'Jūsų registracija sėkminga. Ačiū už jūsų mokėjimą!',
	        search: 'Paieška',
	        facebook: 'Facebook',
	        instagram: 'Instagram',
	        youtube: 'Youtube',
	        logo: 'Logotipas',
	        settingsEdit: 'Nustatymų redagavimas',
	        settings: 'Nustatymai',
	        posts: 'Naujienos',
	        seasons: 'Sezonai',
	        viewSite: 'Į tinklapį',
	        logout: 'Atsijungti',
	        actions: 'Veiksmai',
	        delete: 'Pašalinti',
	        preview: 'Peržiūrėti',
	        newPost: 'Pridėti naujieną',
	        image: 'Paveikslėlis',
	        body: 'Turinys',
	        postEdit: 'Naujienos redagavimas',
	        upload: 'Įkelti',
	        loading: 'Prašome palaukti. Kraunama....',
	        password: 'Slaptažodis',
	        eventHasEnded: 'Renginys jau įvyko. ',
	        yes: 'Taip',
	        no: 'Ne',
	        paymentPage: 'Mokėjimo puslapis',
	        newParticipant: 'Pridėti dalyvį',
	        registerToAllStages: 'Registracija į visus etapus',
	        code: 'Kodas',
	        codeHelperText: 'Kodas naudojamas, etapų susiejimui, registruojantis į visus etapus.',
	        name: 'Pavadinimas',
	        newStage: 'Pridėti etapą',
	        stageEdit: 'Etapo redagavimas',
	        distanceEdit: 'Distancijos redagavimas',
	        newDistance: 'Pridėti distanciją',
	        archive: 'Archyvas',
	        marketingEmailConfirmation: 'Noriu gauti reklaminius pranešimus',
	        publishDate: 'Paskelbimo data',
	        newPartner: 'Pridėti partnerį',
	        partnerEdit: 'Partnerio redagavimas',
	        link: 'Nuoroda',
	        export: 'Eksportavimas',
	        selectStage: 'Pasirinkite etapą',
	        participantsExport: 'Dalyvių eksportavimas',
	        order: 'Tvarka',
	        colCount: 'Stulpelių skaičius',
	        stageResults: 'Etapo rezultatai',
	        selectDistance: 'Pasirinkite distanciją',
	        noResults: 'Nėra rezultatų',
	        selectOrDropFile: 'Pasirinkite bylą',
	        doYouWantToRemove: 'Ar tikrai norite pašalinti?',
	        remove: 'Pašalinti',
	        insurance: 'Draudimas',
	        insuranceTextLabel: 'Draudimo puslapio pavadinimas',
	        insuranceTextInRegistration: 'Draudimo pasirinkimo tekstas, registracijoje',
	        insuranceText: 'Draudimo tekstas',
	        socialMedia: 'Socialiniai tinklai',
	        pages: 'Puslapiai',
	        insuranceEnabled: 'Draudimas galimas',
	        allParticipantsExport: 'Visų dalyvių eksportavimas',
	        filters: 'Filtrai',
	        income: 'Pajamos',
	
	        enLabel: 'Angliškai',
	        ltLabel: 'Lietuviškai',
	
	        displayNews: 'Rodyti naujienas',
	        displayPartners: 'Rodyti partnerius',
	        singleEventWebsite: 'Vieno renginio puslapis',
	        availableMenuItems: 'Galimi meniu įrašai',
	        currentMenuItems: 'Dabartiniai meniu įrašai',
	        add: 'Pridėti',
	        title_lt: 'Pavadinimas LT',
	        title_en: 'Pavadinimas EN',
	        url: 'Adresas',
	        addToMenu: 'Pridėti į meniu',
	        externalRegistration: 'Registracija kitame tinklapyje',
	        externalRegulationsLink: 'Nuoroda į nuostatus kitame tinklapyje',
	        externalRegistrationLink: 'Nuoroda į registraciją kitame tinklapyje',
	        externalParticipantsLink: 'Nuoroda į dalyvius kitame tinklapyje',
	        stageRegulations: 'Nuostatai',
	        images: 'Paveikslėliai',
	        newImage: 'Naujas paveikslėlis',
	        totalParticipants: 'Viso dalyvių',
	        localizationEnabled: 'Įjungta dvikalbystė',
	        globalResultsStage: 'Etapas skirtas rezultatų atvaizdavimui',
	        globalResults: 'Bendri rezultatai',
	        registerToCustomStages: 'Registracija į kelis etapus',
	        showInMainWindow: 'Rodyti pradiniame lange',
	        country: 'Šalis',
	        participantResultsHistory: 'Dalyvių rezultatų istorija',
	        startSearch: 'Ieškoti...',
	        participantResults: 'Dalyvio rezultatų istorija',
	        weUsePlatform: 'Mes naudojame',
	        position: 'Pozicija',
	        result: 'Rezultatas',
	        resultsPositionFieldValuePos: 'Kuriame stulpelyje nurodoma vieta, rezultatų byloje',
	        resultsFileInfo: 'Rezultatų bylos informacija',
	
	        diploma: 'Diplomas',
	        generateDiploma: 'Generuoti diplomą',
	        diplomaBgImage: 'Diplomo pavaikslėlis (Užkoduotas base64)',
	        newSeason: 'Naujas sezonas',
	
	        seasonEdit: 'Sezono redagavimas',
	        statistics: 'Statistika',
	        login: 'Prisijungti',
	        siteConfig: 'Tinklapio nustatymai',
	        menu: 'Meniu',
	        colors: 'Spalvos',
	        menuColor: 'Meniu spalva',
	        menuHighlightColor: 'Menu pažymėjimo spalva',
	        buttonColor: 'Mygtuko spalva',
	        buttonHoverColor: 'Mygtuko pažymėjimo spalva',
	        partnerCategories: 'Partnerių kategorijos',
	        newPartnerCategory: 'Nauja partnerių kategorija',
	        partnerCategoryEdit: 'Partnerių kategorijos redagavimas',
	        noCategories: 'Nėra kategorijų',
	        partnerCategory: 'Partnerių kategorija',
	
	        gdprConfirmation: 'Sutinku, kad mano asmens duomenys būtų tvarkomi.',
	        gdprPageTitle: 'Asmens duomenų tvarkymas',
	        invalidDateField: 'Neteisingas datos formatas',
	
	        promoCodes: 'Nuolaidų kodai',
	        newPromoCode: 'Pridėti nuolaidų kodą',
	        codesLeft: 'Liko kodų',
	        promoCodeEdit: 'Nuolaidų kodo redagavimas',
	        promoCode: 'Nuolaidos kodas',
	        discount: 'Nuolaida',
	        calculating: 'Skaičiuojama...',
	
	        tracking: 'Lankytojų sekimas',
	        facebookPixelCode: 'Facebook pixel kodas',
	        googleAnalyticsCode: 'Google analytics kodas',
	
	        paysera: 'Paysera',
	        projectId: 'Projekto ID',
	        projectPassword: 'Projekto slaptažodis',
	        projectHeadTag: 'Projekto HEAD žyma',
	
	        multipleStageDisplay: 'Etapų rodymas pradiniame puslapyje',
	
	        webKeywords: 'Tinklapio raktažodžiai',
	        webDescription: 'Tinklapio aprašymas',
	
	        tableLink: 'Daugiau',
	        seasonPersonIdentifier: 'Sezono dalyvio identifikatorius',
	
	        extraInfo: 'Papildoma registracijos informacija',
	        displayExtraInfoField: 'Rodyti papildomos informacijos lauką registracijoje',
	        extraInfoFieldTitle: 'Papildomos informacijos lauko tekstas',
	        extraInfoFieldRequired: 'Papildomos informacijos laukas privalomas?',
	
	        payedFilterLabel: 'Mokėjimo statusas',
	        allPaymentsFilter: 'Visi',
	        payedFilter: 'Apmokėta',
	        notPayedFilter: 'Neapmokėta',
	
	        invoices: 'Sąskaitos',
	
	        serialNumber: 'Numeris',
	
	        participantLegendTitle: 'Dalyvio informacija',
	        paymentInfoLegend: 'Mokėtojo informacija',
	        billingIsCompony: 'Perka įmonė?',
	        billingName: 'Pirkėjas',
	        billingEmail: 'Pirkėjo el. paštas',
	        billingCompanyCode: 'Įmonės kodas',
	        billingVatCode: 'PVM kodas',
	        billingAddress: 'Adresas',
	
	        isTeamDistance: 'Komandinė distancija?',
	
	        teamParticipants: 'Kiti komandos nariai',
	        addTeamMember: 'Pridėti komandos narį',
	        teamName: 'Komandos pavadinimas',
	        teamInfo: 'Komandos informacija',
	
	        configuration: 'Tinklapio konfigūracija',
	        maxAgeRestriction: 'Maksimalus amžius dalyvauti',
	        age: 'Amžius',
	
	        registrationClosesDate: 'Registracijos automatinio uždarymo data',
	
	        newPage: 'Naujas puslapis',
	        pageEdit: 'Puslapio redagavimas',
	        showInFooter: 'Rodyti puslapį poraštėje',
	        linkToPage: 'Nuoroda',
	        enableShirtSelection: 'Įjungti marškinėlių pasirinkimą',
	        shirtSize: 'Marškinėlių dydis'
	
	    }, window.CARE_CONFIG.ltMessagesOverride || {})
	});
	exports.default = strings;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(515);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1184);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1183);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1182);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(514);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(516);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	var _interopRequireWildcard = __webpack_require__(160);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(1111));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(475));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(1112));
	
	exports.connect = _connect.default;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;
	
	var _flattenNames = __webpack_require__(1153);
	
	var _flattenNames2 = _interopRequireDefault(_flattenNames);
	
	var _mergeClasses = __webpack_require__(1155);
	
	var _mergeClasses2 = _interopRequireDefault(_mergeClasses);
	
	var _autoprefix = __webpack_require__(1150);
	
	var _autoprefix2 = _interopRequireDefault(_autoprefix);
	
	var _hover2 = __webpack_require__(1152);
	
	var _hover3 = _interopRequireDefault(_hover2);
	
	var _active = __webpack_require__(1151);
	
	var _active2 = _interopRequireDefault(_active);
	
	var _loop2 = __webpack_require__(1154);
	
	var _loop3 = _interopRequireDefault(_loop2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.hover = _hover3.default;
	exports.handleHover = _hover3.default;
	exports.handleActive = _active2.default;
	exports.loop = _loop3.default;
	var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
	  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    activations[_key - 1] = arguments[_key];
	  }
	
	  var activeNames = (0, _flattenNames2.default)(activations);
	  var merged = (0, _mergeClasses2.default)(classes, activeNames);
	  return (0, _autoprefix2.default)(merged);
	};
	
	exports.default = ReactCSS;

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var types = {
	
	    TOGGLE_NAVBAR: null,
	    HIDE_NAVBAR: null,
	    SHOW_NAVBAR: null,
	
	    SUBMIT_USER: 'async',
	    ADMIN_LOAD_USERS: 'async',
	    ADMIN_LOAD_USER: 'async',
	    LOGIN_USER: 'async',
	    LOGOUT: 'async',
	
	    SUBMIT_SEASON: 'async',
	    ADMIN_LOAD_SEASONS: 'async',
	    ADMIN_LOAD_SEASON: 'async',
	    LOAD_SEASONS: 'async',
	
	    SUBMIT_PARTNER: 'async',
	    ADMIN_LOAD_PARTNERS: 'async',
	    ADMIN_LOAD_PARTNER: 'async',
	    LOAD_PARTNERS: 'async',
	    DELETE_PARTNER: 'async',
	
	    SUBMIT_STAGE: 'async',
	    LOAD_STAGES_PAGINATED: 'async',
	    DELETE_STAGE: 'async',
	    // ADMIN_LOAD_STAGE: 'async',
	    ADMIN_UPDATE_STAGE_DISTANCE: 'async',
	    LOAD_STAGES: 'async',
	    LOAD_STAGE: 'async',
	    LOAD_UPCOMING_STAGE: 'async',
	    REGISTRATION_TO_CUSTOM: 'async',
	    LOAD_STAGE_PARTICIPANTS: 'async',
	    SAVE_STAGE_RESULTS: 'async',
	    LOAD_STAGE_RESULTS: 'async',
	    REGISTRATION_TO_ALL: 'async',
	
	    TOGGLE_DISTANCE_MODAL: null,
	    DELETE_DISTANCE: 'async',
	    SUBMIT_DISTANCE: 'async',
	
	    SUBMIT_PARTICIPANT: 'async',
	    LOAD_PARTICIPANTS_PAGINATED: 'async',
	    LOAD_PARTICIPANT: 'async',
	    LOAD_PARTICIPANT_BY_UUID: 'async',
	    INITIALIZE_PARTICIPANT_FORM_DATA: null,
	    DELETE_PARTICIPANT: 'async',
	    SUBMIT_PARTICIPANT_RESULT_SEARCH: 'async',
	    SUBMIT_ADMIN_PARTICIPANT_RESULT_SEARCH: 'async',
	    LOAD_PARTICIPANT_RESULT: 'async',
	    SUBMIT_PARTICIPANT_RESULT: 'async',
	
	    LOAD_PARTICIPANT_RESULT_V2: 'async',
	
	    SUBMIT_POST: 'async',
	    LOAD_POST: 'async',
	    LOAD_POSTS: 'async',
	    LOAD_POSTS_PAGINATED: 'async',
	    DELETE_POST: 'async',
	
	    SUBMIT_SETTINGS: 'async',
	    LOAD_SETTINGS: 'async',
	
	    LOAD_RESULTS: 'async',
	
	    LOAD_STATISTICS: 'async',
	
	    LOAD_IMAGES: 'async',
	    DELETE_IMAGE: 'async',
	
	    SUBMIT_PARTNER_CATEGORY: 'async',
	    ADMIN_LOAD_PARTNER_CATEGORIES: 'async',
	    LOAD_PARTNER_CATEGORIES: 'async',
	    ADMIN_LOAD_PARTNER_CATEGORY: 'async',
	    DELETE_PARTNER_CATEGORY: 'async',
	
	    SUBMIT_PROMO_CODE: 'async',
	    ADMIN_LOAD_PROMO_CODE: 'async',
	    ADMIN_LOAD_PROMO_CODES: 'async',
	    DELETE_PROMO_CODE: 'async',
	
	    ADMIN_LOAD_INVOICE: 'async',
	    ADMIN_LOAD_INVOICES: 'async',
	
	    SUBMIT_PAGE: 'async',
	    LOAD_PAGE: 'async',
	    LOAD_PAGES: 'async',
	    LOAD_PAGES_PAGINATED: 'async',
	    DELETE_PAGE: 'async'
	
	};
	
	/*
	transforms each value:
	
	{
	    FOO: null,
	    BAR: 'async'
	}
	
	becomes
	
	{
	    FOO: 'FOO',
	    BAR: {
	        REQUEST: 'BAR_REQUEST',
	        SUCCESS: 'BAR_SUCCESS',
	        FAILURE: 'BAR_FAILURE',
	        all: ['BAR_REQUEST' 'BAR_SUCCESS', 'BAR_FAILURE']
	    }
	}
	
	*/
	
	Object.keys(types).forEach(function (key) {
	    if (types[key] === 'async') {
	        types[key] = {
	            all: []
	        };
	        ['REQUEST', 'SUCCESS', 'FAILURE'].forEach(function (type) {
	            var full_type = key + '_' + type;
	            types[key][type] = full_type;
	            types[key].all.push(full_type);
	        });
	    } else if (types[key] === null) {
	        types[key] = key;
	    } else {
	        throw new Error('type value must be "async" or null');
	    }
	});
	
	exports.default = types;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1017)();
	}


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Loading;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Loading() {
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'loading-block' },
	        _react2.default.createElement(_icon2.default, { icon: 'loading' })
	    );
	}

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(77);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(228);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(103);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1129);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(481);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1125);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1140);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1126);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1127);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(483);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1128);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(229);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1138);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(488);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1131);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1132);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1136);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(485);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(138)('wks')
	  , uid        = __webpack_require__(88)
	  , Symbol     = __webpack_require__(10).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Alpha = __webpack_require__(1036);
	
	Object.defineProperty(exports, 'Alpha', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Checkboard = __webpack_require__(462);
	
	Object.defineProperty(exports, 'Checkboard', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Checkboard).default;
	  }
	});
	
	var _EditableInput = __webpack_require__(1037);
	
	Object.defineProperty(exports, 'EditableInput', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_EditableInput).default;
	  }
	});
	
	var _Hue = __webpack_require__(1038);
	
	Object.defineProperty(exports, 'Hue', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Raised = __webpack_require__(1039);
	
	Object.defineProperty(exports, 'Raised', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Raised).default;
	  }
	});
	
	var _Saturation = __webpack_require__(1040);
	
	Object.defineProperty(exports, 'Saturation', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Saturation).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(463);
	
	Object.defineProperty(exports, 'ColorWrap', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Swatch = __webpack_require__(1041);
	
	Object.defineProperty(exports, 'Swatch', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatch).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appHeader = __webpack_require__(537);
	
	var _appHeader2 = _interopRequireDefault(_appHeader);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _pageContainer = __webpack_require__(127);
	
	var _pageContainer2 = _interopRequireDefault(_pageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactRouter = __webpack_require__(14);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppContainer = function (_PageContainer) {
	    _inherits(AppContainer, _PageContainer);
	
	    function AppContainer() {
	        _classCallCheck(this, AppContainer);
	
	        return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	    }
	
	    _createClass(AppContainer, [{
	        key: 'buildTitle',
	        value: function buildTitle(text) {
	            if (text) {
	                text = '' + text.charAt(0).toUpperCase() + text.slice(1);
	                return text + ' | ' + (window.CARE_CONFIG.settings.title || '');
	            }
	            return window.CARE_CONFIG.settings.title || '';
	        }
	    }, {
	        key: 'getDocumentTitle',
	        value: function getDocumentTitle(text) {
	            return this.buildTitle(text);
	        }
	    }, {
	        key: 'handlePageResult',
	        value: function handlePageResult(result) {
	            if (result.error) {
	                this.openPage('/');
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'app' },
	                _react2.default.createElement(_appHeader2.default, null),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'site-content' },
	                    this.props.children
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section dark footer' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        window.CARE_CONFIG.footerPages.length > 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'page-links' },
	                            window.CARE_CONFIG.footerPages.map(function (page, index) {
	                                return (0, _languageCookie.isEnglish)() ? _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/page/' + page.slug_en, key: index },
	                                    page.title_en
	                                ) : _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/page/' + page.slug_lt, key: index },
	                                    page.title_lt
	                                );
	                            })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'social' },
	                            window.CARE_CONFIG.settings.youtube_link ? _react2.default.createElement(
	                                'a',
	                                { href: window.CARE_CONFIG.settings.youtube_link, target: '_blank', 'aria-label': 'Youtube' },
	                                _react2.default.createElement(_icon2.default, { icon: 'youtube', size: 'sm' })
	                            ) : null,
	                            window.CARE_CONFIG.settings.facebook_link ? _react2.default.createElement(
	                                'a',
	                                { href: window.CARE_CONFIG.settings.facebook_link, target: '_blank', 'aria-label': 'Facebook' },
	                                _react2.default.createElement(_icon2.default, { icon: 'facebook', size: 'sm' })
	                            ) : null,
	                            window.CARE_CONFIG.settings.instagram_link ? _react2.default.createElement(
	                                'a',
	                                { href: window.CARE_CONFIG.settings.instagram_link, target: '_blank', 'aria-label': 'Instagram' },
	                                _react2.default.createElement(_icon2.default, { icon: 'instagram', size: 'sm' })
	                            ) : null
	                        ),
	                        window.CARE_CONFIG.cardPaymentsEnabled && _react2.default.createElement(
	                            'div',
	                            { className: 'card-logs' },
	                            _react2.default.createElement(_icon2.default, { icon: 'visa', size: 'm' }),
	                            _react2.default.createElement(_icon2.default, { icon: 'mastercard', size: 'm' })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'info' },
	                            _strings2.default.weUsePlatform,
	                            ':',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://www.eventomania.lt?utm_source=footer', className: 'footer-logo' },
	                                _react2.default.createElement('img', { src: __webpack_require__(889), alt: 'Rengini\u0173 platforma' })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppContainer;
	}(_pageContainer2.default);
	
	exports.default = AppContainer;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
	    PropTypes = __webpack_require__(11),
	    withSideEffect = __webpack_require__(1080);
	
	function reducePropsToState(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}
	
	function handleStateChangeOnClient(title) {
	  var nextTitle = title || '';
	  if (nextTitle !== document.title) {
	    document.title = nextTitle;
	  }
	}
	
	function DocumentTitle() {}
	DocumentTitle.prototype = Object.create(React.Component.prototype);
	
	DocumentTitle.displayName = 'DocumentTitle';
	DocumentTitle.propTypes = {
	  title: PropTypes.string.isRequired
	};
	
	DocumentTitle.prototype.render = function() {
	  if (this.props.children) {
	    return React.Children.only(this.props.children);
	  } else {
	    return null;
	  }
	};
	
	module.exports = withSideEffect(
	  reducePropsToState,
	  handleStateChangeOnClient
	)(DocumentTitle);


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(13)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(9)
	  , IE8_DOM_DEFINE = __webpack_require__(258)
	  , toPrimitive    = __webpack_require__(59)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = FormField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FormField(props) {
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        _props$children = props.children,
	        children = _props$children === undefined ? [] : _props$children,
	        _props$after = props.after,
	        after = _props$after === undefined ? null : _props$after,
	        _props$horizontal = props.horizontal,
	        horizontal = _props$horizontal === undefined ? false : _props$horizontal,
	        _props$label = props.label,
	        label = _props$label === undefined ? null : _props$label,
	        _props$name = props.name,
	        name = _props$name === undefined ? null : _props$name,
	        _props$field = props.field,
	        field = _props$field === undefined ? null : _props$field,
	        _props$helperText = props.helperText,
	        helperText = _props$helperText === undefined ? null : _props$helperText,
	        _props$link = props.link,
	        link = _props$link === undefined ? null : _props$link,
	        _props$dots = props.dots,
	        dots = _props$dots === undefined ? true : _props$dots;
	
	
	    var error = field.touched && field.error;
	    return _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)('form-field', name && 'form-field-' + name, className, { error: error, horizontal: horizontal }) },
	        label && _react2.default.createElement(
	            'label',
	            null,
	            ' ',
	            link ? _react2.default.createElement(
	                _reactRouter.Link,
	                { to: link, target: '_blank' },
	                label
	            ) : '' + label + (dots ? ':' : '')
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'field-control' },
	            children
	        ),
	        after,
	        error && _react2.default.createElement(
	            'div',
	            { className: 'error-msg' },
	            error
	        ),
	        helperText && _react2.default.createElement(
	            'div',
	            { className: 'helper-text' },
	            helperText
	        )
	    );
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.translateAPIResponse = translateAPIResponse;
	exports.validateRequiredFields = validateRequiredFields;
	exports.validateEmail = validateEmail;
	exports.validateDate = validateDate;
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//translates error returned by redux-api-middleware into rejection understood by redux-form
	function translateAPIResponse(result) {
	    if (result.error && result.payload.name === 'ApiError' && result.payload.response && result.payload.response.errors) {
	        return Promise.reject(result.payload.response.errors);
	    }
	    return result;
	}
	
	function validateRequiredFields(values, fields, errors) {
	    fields.forEach(function (field) {
	        if (!values[field]) {
	            errors[field] = _strings2.default.requiredField;
	        }
	    });
	    return errors;
	}
	function validateEmail(values, field, errors) {
	    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    if (!re.test(values[field])) {
	        errors[field] = _strings2.default.invalidEmailField;
	    }
	    return errors;
	}
	function validateDate(values, field, errors) {
	    if (!(0, _moment2.default)(values[field]).isValid()) {
	        errors[field] = _strings2.default.invalidDateField;
	    }
	    return errors;
	}

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(73)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouchWithKey = exports.untouch = exports.touchWithKey = exports.touch = exports.swapArrayValues = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.propTypes = exports.initializeWithKey = exports.initialize = exports.getValues = exports.removeArrayValue = exports.reduxForm = exports.reducer = exports.focus = exports.destroy = exports.changeWithKey = exports.change = exports.blur = exports.autofillWithKey = exports.autofill = exports.addArrayValue = exports.actionTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _createAll2 = __webpack_require__(1158);
	
	var _createAll3 = _interopRequireDefault(_createAll2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	var _createAll = (0, _createAll3.default)(isNative, _react2.default, _reactRedux.connect);
	
	var actionTypes = _createAll.actionTypes,
	    addArrayValue = _createAll.addArrayValue,
	    autofill = _createAll.autofill,
	    autofillWithKey = _createAll.autofillWithKey,
	    blur = _createAll.blur,
	    change = _createAll.change,
	    changeWithKey = _createAll.changeWithKey,
	    destroy = _createAll.destroy,
	    focus = _createAll.focus,
	    reducer = _createAll.reducer,
	    reduxForm = _createAll.reduxForm,
	    removeArrayValue = _createAll.removeArrayValue,
	    getValues = _createAll.getValues,
	    initialize = _createAll.initialize,
	    initializeWithKey = _createAll.initializeWithKey,
	    propTypes = _createAll.propTypes,
	    reset = _createAll.reset,
	    startAsyncValidation = _createAll.startAsyncValidation,
	    startSubmit = _createAll.startSubmit,
	    stopAsyncValidation = _createAll.stopAsyncValidation,
	    stopSubmit = _createAll.stopSubmit,
	    swapArrayValues = _createAll.swapArrayValues,
	    touch = _createAll.touch,
	    touchWithKey = _createAll.touchWithKey,
	    untouch = _createAll.untouch,
	    untouchWithKey = _createAll.untouchWithKey;
	exports.actionTypes = actionTypes;
	exports.addArrayValue = addArrayValue;
	exports.autofill = autofill;
	exports.autofillWithKey = autofillWithKey;
	exports.blur = blur;
	exports.change = change;
	exports.changeWithKey = changeWithKey;
	exports.destroy = destroy;
	exports.focus = focus;
	exports.reducer = reducer;
	exports.reduxForm = reduxForm;
	exports.removeArrayValue = removeArrayValue;
	exports.getValues = getValues;
	exports.initialize = initialize;
	exports.initializeWithKey = initializeWithKey;
	exports.propTypes = propTypes;
	exports.reset = reset;
	exports.startAsyncValidation = startAsyncValidation;
	exports.startSubmit = startSubmit;
	exports.stopAsyncValidation = stopAsyncValidation;
	exports.stopSubmit = stopSubmit;
	exports.swapArrayValues = swapArrayValues;
	exports.touch = touch;
	exports.touchWithKey = touchWithKey;
	exports.untouch = untouch;
	exports.untouchWithKey = untouchWithKey;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Alert;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Alert(_ref) {
	    var _ref$type = _ref.type,
	        type = _ref$type === undefined ? 'info' : _ref$type,
	        _ref$children = _ref.children,
	        children = _ref$children === undefined ? null : _ref$children;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'alert alert-' + type },
	        children
	    );
	}

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _form = __webpack_require__(23);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	    _inherits(BaseForm, _Component);
	
	    function BaseForm() {
	        _classCallCheck(this, BaseForm);
	
	        return _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).apply(this, arguments));
	    }
	
	    _createClass(BaseForm, [{
	        key: 'showAlert',
	        value: function showAlert() {
	            return true;
	        }
	    }, {
	        key: 'submit',
	        value: function submit(values) {
	            var _this2 = this;
	
	            var _props = this.props,
	                onSuccessSubmit = _props.onSuccessSubmit,
	                submit = _props.submit;
	
	            var hadId = !values.id;
	            return submit(values).then(_form.translateAPIResponse).then(function (result) {
	                if (_this2.showAlert()) {
	                    alert('Saved');
	                }
	                if (onSuccessSubmit) {
	                    onSuccessSubmit(hadId, result.payload);
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return BaseForm;
	}(_react.Component);
	
	exports.default = BaseForm;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(50);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Button;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRouter = __webpack_require__(14);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function Button(props) {
	    var _props$type = props.type,
	        type = _props$type === undefined ? 'primary' : _props$type,
	        _props$to = props.to,
	        to = _props$to === undefined ? null : _props$to,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        _props$submit = props.submit,
	        submit = _props$submit === undefined ? false : _props$submit,
	        _props$loading = props.loading,
	        loading = _props$loading === undefined ? false : _props$loading,
	        _props$children = props.children,
	        children = _props$children === undefined ? null : _props$children,
	        restprops = _objectWithoutProperties(props, ['type', 'to', 'className', 'submit', 'loading', 'children']);
	
	    var btnprops = _extends({}, restprops, {
	        className: (0, _classnames2.default)(className, 'btn', 'btn-' + type, { 'btn-loading': loading }),
	        type: submit ? 'submit' : 'button'
	    });
	
	    var loadingicon = loading && _react2.default.createElement(_icon2.default, { icon: 'spinner', spin: true, size: 'ss' });
	
	    if (to) {
	        return _react2.default.createElement(
	            _reactRouter.Link,
	            _extends({ to: to }, btnprops),
	            loadingicon,
	            children
	        );
	    }
	
	    return _react2.default.createElement(
	        'button',
	        btnprops,
	        loadingicon,
	        children
	    );
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(293);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _paginator = __webpack_require__(241);
	
	var _paginator2 = _interopRequireDefault(_paginator);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _url = __webpack_require__(128);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DataTable = function (_Component) {
	    _inherits(DataTable, _Component);
	
	    function DataTable() {
	        _classCallCheck(this, DataTable);
	
	        return _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).apply(this, arguments));
	    }
	
	    _createClass(DataTable, [{
	        key: 'onItemClick',
	        value: function onItemClick(item) {
	            if (this.props.clickable) {
	                this.props.clickable(item);
	            }
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                config = _props.config,
	                items = _props.items,
	                loading = _props.loading,
	                className = _props.className,
	                _props$responsive = _props.responsive,
	                responsive = _props$responsive === undefined ? true : _props$responsive;
	
	            if (loading) {
	                return _react2.default.createElement(_loading2.default, null);
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'table',
	                    { className: (0, _classnames2.default)('table', responsive && 'responsive', className) },
	                    _react2.default.createElement(
	                        'thead',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            config.cols.map(function (col, index) {
	                                return _react2.default.createElement(
	                                    'th',
	                                    { key: 'header-' + index },
	                                    col.header
	                                );
	                            })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        items.map(function (item) {
	                            return _react2.default.createElement(
	                                'tr',
	                                { key: 'table-item-' + (item.id || item.uuid), onClick: _this2.onItemClick.bind(_this2, item) },
	                                config.cols.map(function (col, index) {
	                                    var valueDisplay = typeof col.value === 'function' ? col.value(item) : item[col.value];
	                                    if ((0, _url.isValidURL)(valueDisplay)) {
	                                        return _react2.default.createElement(
	                                            'td',
	                                            { key: 'table-col-' + item.id + '-' + index },
	                                            _react2.default.createElement(
	                                                'a',
	                                                { href: valueDisplay },
	                                                _strings2.default.tableLink
	                                            )
	                                        );
	                                    }
	                                    return _react2.default.createElement(
	                                        'td',
	                                        { key: 'table-col-' + item.id + '-' + index },
	                                        col.header && _react2.default.createElement(
	                                            'div',
	                                            { className: 'responsive-header' },
	                                            col.header,
	                                            ':'
	                                        ),
	                                        valueDisplay
	                                    );
	                                })
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(_paginator2.default, { totalPages: this.props.totalPages, currentPage: this.props.page, paginationAction: this.props.loadAction })
	            );
	        }
	    }]);
	
	    return DataTable;
	}(_react.Component);
	
	// export default function DataTable(props) {
	//     const {config, items, loading} = props;
	//     if (loading) {
	//         return (<Loading/>)
	//     }
	//     return (
	//         <div>
	//             <table className="table responsive">
	//                 <thead>
	//                     <tr>
	//                         {config.cols.map((col, index) => {
	//                             return <th key={`header-${index}`}>{col.header}</th>
	//                         })
	// }
	//                     </tr>
	//                 </thead>
	//                 <tbody>
	//                     {items.map(item => {
	//                         return (
	//                             <tr key={`table-item-${item.id || item.uuid}`}>
	//                                 {config.cols.map((col, index) => {
	//                                     let valueDisplay = typeof col.value === 'function'
	//                                         ? col.value(item)
	//                                         : item[col.value];
	//
	//                                     return <td key={`table-col-${item.id}-${index}`}>{valueDisplay}</td>
	//                                 })
	// }
	//                             </tr>
	//                         )
	//                     })
	// }
	//
	//                 </tbody>
	//
	//             </table>
	//
	//             <Paginator totalPages={this.params.total} currentPage={this.props.page}/>
	//         </div>
	//
	//     )
	// }
	
	
	exports.default = DataTable;

/***/ },
/* 33 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitElement = submitElement;
	exports.deleteElement = deleteElement;
	exports.fetchElement = fetchElement;
	exports.fetchElementsPaginated = fetchElementsPaginated;
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	var _url = __webpack_require__(128);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getExternalQueryString(queryData) {
	    if (queryData) {
	        return '&' + (0, _url.getUrlQuery)(queryData);
	    }
	    return '';
	}
	function submitElement() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var values = arguments[1];
	    var type = arguments[2];
	
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: url + (values.id ? '/' + values.id : ''),
	        method: values.id ? 'PUT' : 'POST',
	        body: values,
	        types: type.all
	    });
	}
	
	function deleteElement() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var id = arguments[1];
	    var type = arguments[2];
	
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: url + '/' + id,
	        method: 'DELETE',
	        types: type.all
	    });
	}
	
	function fetchElement() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var itemId = arguments[1];
	    var type = arguments[2];
	
	    if (itemId === 'new') {
	        return {
	            type: type.SUCCESS,
	            payload: {}
	        };
	    } else {
	        return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	            endpoint: url + '/' + itemId,
	            method: 'GET',
	            types: type.all
	        });
	    }
	}
	
	function fetchElementsPaginated() {
	    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var page = arguments[1];
	    var size = arguments[2];
	    var type = arguments[3];
	    var queryData = arguments[4];
	
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: url + '?page=' + page + '&size=' + size + getExternalQueryString(queryData),
	        method: 'GET',
	        types: [{
	            type: type.REQUEST,
	            meta: {
	                page: page,
	                size: size
	            }
	        }, type.SUCCESS, type.FAILURE]
	    });
	}

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pageContainer = __webpack_require__(127);
	
	var _pageContainer2 = _interopRequireDefault(_pageContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdimItemPageContainer = function (_PageContainer) {
	    _inherits(AdimItemPageContainer, _PageContainer);
	
	    function AdimItemPageContainer() {
	        _classCallCheck(this, AdimItemPageContainer);
	
	        return _possibleConstructorReturn(this, (AdimItemPageContainer.__proto__ || Object.getPrototypeOf(AdimItemPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(AdimItemPageContainer, [{
	        key: 'fetchData',
	        value: function fetchData(id) {
	            var _this2 = this;
	
	            this.fetchItem(id).then(function (result) {
	                if (result.error) {
	                    _this2.openPage(_this2.getBaseUrl());
	                }
	            });
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetchData(this.props.params.itemId);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	
	            if (this.props.params.itemId !== nextProps.params.itemId) {
	                this.fetchData(nextProps.params.itemId);
	            }
	        }
	    }, {
	        key: 'onSuccessSubmit',
	        value: function onSuccessSubmit(wasNew, result) {
	            if (wasNew) {
	                this.openPage(this.getBaseUrl() + '/' + result.id);
	            }
	        }
	    }]);
	
	    return AdimItemPageContainer;
	}(_pageContainer2.default);
	
	exports.default = AdimItemPageContainer;

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(21)
	  , createDesc = __webpack_require__(72);
	module.exports = __webpack_require__(20) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(10)
	  , hide      = __webpack_require__(38)
	  , has       = __webpack_require__(33)
	  , SRC       = __webpack_require__(88)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(64).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(13)
	  , defined = __webpack_require__(50)
	  , quot    = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function(string, tag, attribute, value) {
	  var S  = String(defined(string))
	    , p1 = '<' + tag;
	  if(attribute !== '')p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function(NAME, exec){
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function(){
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(109)
	  , defined = __webpack_require__(50);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 42 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getLanguageCookie = getLanguageCookie;
	exports.saveLanguageCookie = saveLanguageCookie;
	exports.isEnglish = isEnglish;
	
	var _reactCookie = __webpack_require__(1073);
	
	var _reactCookie2 = _interopRequireDefault(_reactCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LANGUAGE_COOKIE = 'LANGUAGE_COOKIE';
	function getLanguageCookie() {
	    return _reactCookie2.default.load(LANGUAGE_COOKIE);
	}
	
	function saveLanguageCookie(languageCode) {
	    _reactCookie2.default.save(LANGUAGE_COOKIE, languageCode, {
	        path: '/'
	    });
	}
	
	function isEnglish() {
	    return getLanguageCookie() === 'en';
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(110)
	  , createDesc     = __webpack_require__(72)
	  , toIObject      = __webpack_require__(41)
	  , toPrimitive    = __webpack_require__(59)
	  , has            = __webpack_require__(33)
	  , IE8_DOM_DEFINE = __webpack_require__(258)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(20) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(33)
	  , toObject    = __webpack_require__(28)
	  , IE_PROTO    = __webpack_require__(183)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitStage = submitStage;
	exports.fetchStage = fetchStage;
	exports.loadStages = loadStages;
	exports.fetchStageParticipants = fetchStageParticipants;
	exports.fetchStageResults = fetchStageResults;
	exports.deleteStage = deleteStage;
	exports.submitStageResults = submitStageResults;
	exports.fetchAllStages = fetchAllStages;
	exports.fetchUpcomingStage = fetchUpcomingStage;
	exports.fetchRegistratioToCustom = fetchRegistratioToCustom;
	exports.fetchRegistratioToAll = fetchRegistratioToAll;
	exports.updateStageDistance = updateStageDistance;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/stages';
	
	function submitStage(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_STAGE);
	}
	
	function fetchStage(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.LOAD_STAGE);
	}
	
	function loadStages() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	    var queryData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.LOAD_STAGES_PAGINATED, queryData);
	}
	
	function fetchStageParticipants(itemId) {
	    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	    var queryData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/' + itemId + '/participants', page, size, _types2.default.LOAD_STAGE_PARTICIPANTS, queryData);
	}
	
	function fetchStageResults(itemId) {
	    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;
	    var queryData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/' + itemId + '/results', page, size, _types2.default.LOAD_STAGE_RESULTS, queryData);
	}
	
	function deleteStage(stage) {
	    return (0, _common.deleteElement)(apiUrl, stage.id, _types2.default.DELETE_STAGE);
	}
	
	function submitStageResults(id, values) {
	    var data = new FormData();
	    data.append('file', values.file);
	    data.append('col_count', values.col_count);
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl + '/' + id + '/results',
	        method: 'POST',
	        body: data,
	        types: _types2.default.SAVE_STAGE_RESULTS.all
	    });
	}
	
	function fetchAllStages() {
	    var seasonId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: seasonId ? apiUrl + '?season=' + seasonId : apiUrl,
	        method: 'GET',
	        types: _types2.default.LOAD_STAGES.all
	    });
	}
	
	function fetchUpcomingStage() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl + '/upcoming',
	        method: 'GET',
	        types: _types2.default.LOAD_UPCOMING_STAGE.all
	    });
	}
	
	function fetchRegistratioToCustom() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl + '/registration-to-custom',
	        method: 'GET',
	        types: _types2.default.REGISTRATION_TO_CUSTOM.all
	    });
	}
	
	function fetchRegistratioToAll() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl + '/registration-to-all',
	        method: 'GET',
	        types: _types2.default.REGISTRATION_TO_ALL.all
	    });
	}
	
	function updateStageDistance(distance) {
	    return {
	        type: _types2.default.ADMIN_UPDATE_STAGE_DISTANCE,
	        payload: {
	            distance: distance
	        }
	    };
	}

/***/ },
/* 48 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.paginatedResultReducer = paginatedResultReducer;
	var initialState = exports.initialState = {
	    items: [],
	    loading: false,
	    page: 0,
	    total_pages: 0,
	    total: 0
	};
	
	function paginatedResultReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var ACTION = arguments[1];
	    var action = arguments[2];
	
	    switch (action.type) {
	        case ACTION.REQUEST:
	            //not first page - results will be appended
	            if (action.meta.page) {
	                return _extends({}, state, {
	                    loading: true
	                });
	                //first page - results will be replaced
	            } else {
	                return _extends({}, initialState, {
	                    loading: true
	                });
	            }
	        case ACTION.SUCCESS:
	            return _extends({}, state, {
	                //items: action.payload.page ? [...state.items, ...action.payload.result] : action.payload.result,
	                items: action.payload.result,
	                page: action.payload.page,
	                total_pages: action.payload.total_pages,
	                total: action.payload.total,
	                loading: false
	            });
	        case ACTION.FAILURE:
	            return _extends({}, state, {
	                loading: false
	            });
	        default:
	            return state;
	    }
	}

/***/ },
/* 49 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var fails = __webpack_require__(13);
	
	module.exports = function(method, arg){
	  return !!method && fails(function(){
	    arg ? method.call(null, function(){}, 1) : method.call(null);
	  });
	};

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(289)('wks')
	  , uid    = __webpack_require__(291)
	  , Symbol = __webpack_require__(68).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || uid)('Symbol.' + name));
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(323);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.red = undefined;
	
	var _each = __webpack_require__(998);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _tinycolor = __webpack_require__(1196);
	
	var _tinycolor2 = _interopRequireDefault(_tinycolor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  simpleCheckForValidColor: function simpleCheckForValidColor(data) {
	    var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
	    var checked = 0;
	    var passed = 0;
	    (0, _each2.default)(keysToCheck, function (letter) {
	      if (data[letter]) {
	        checked += 1;
	        if (!isNaN(data[letter])) {
	          passed += 1;
	        }
	        if (letter === 's' || letter === 'l') {
	          var percentPatt = /^\d+%$/;
	          if (percentPatt.test(data[letter])) {
	            passed += 1;
	          }
	        }
	      }
	    });
	    return checked === passed ? data : false;
	  },
	  toState: function toState(data, oldHue) {
	    var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
	    var hsl = color.toHsl();
	    var hsv = color.toHsv();
	    var rgb = color.toRgb();
	    var hex = color.toHex();
	    if (hsl.s === 0) {
	      hsl.h = oldHue || 0;
	      hsv.h = oldHue || 0;
	    }
	    var transparent = hex === '000000' && rgb.a === 0;
	
	    return {
	      hsl: hsl,
	      hex: transparent ? 'transparent' : '#' + hex,
	      rgb: rgb,
	      hsv: hsv,
	      oldHue: data.h || oldHue || hsl.h,
	      source: data.source
	    };
	  },
	  isValidHex: function isValidHex(hex) {
	    // disable hex4 and hex8
	    var lh = String(hex).charAt(0) === '#' ? 1 : 0;
	    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
	  },
	  getContrastingColor: function getContrastingColor(data) {
	    if (!data) {
	      return '#fff';
	    }
	    var col = this.toState(data);
	    if (col.hex === 'transparent') {
	      return 'rgba(0,0,0,0.4)';
	    }
	    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
	    return yiq >= 128 ? '#000' : '#fff';
	  }
	};
	var red = exports.red = {
	  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
	  hex: '#ff0000',
	  rgb: { r: 255, g: 0, b: 0, a: 1 },
	  hsv: { h: 0, s: 1, v: 1, a: 1 }
	};

/***/ },
/* 55 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = select;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSelect = __webpack_require__(1145);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	//redux-form expects onblur to return a value.
	//wrap react-select and modify onblur
	function select(props) {
	    var _onBlur = props.onBlur,
	        options = props.options,
	        _props$value_field = props.value_field,
	        value_field = _props$value_field === undefined ? 'id' : _props$value_field,
	        _props$label_field = props.label_field,
	        label_field = _props$label_field === undefined ? 'name' : _props$label_field,
	        restprops = _objectWithoutProperties(props, ['onBlur', 'options', 'value_field', 'label_field']);
	
	    var t_options = options.map(function (obj) {
	        return { value: obj[value_field], label: obj[label_field] };
	    });
	
	    return _react2.default.createElement(_reactSelect2.default, _extends({ onBlur: function onBlur() {
	            return _onBlur && _onBlur(props.value);
	        }, options: t_options }, restprops));
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx      = __webpack_require__(65)
	  , IObject  = __webpack_require__(109)
	  , toObject = __webpack_require__(28)
	  , toLength = __webpack_require__(24)
	  , asc      = __webpack_require__(659);
	module.exports = function(TYPE, $create){
	  var IS_MAP        = TYPE == 1
	    , IS_FILTER     = TYPE == 2
	    , IS_SOME       = TYPE == 3
	    , IS_EVERY      = TYPE == 4
	    , IS_FIND_INDEX = TYPE == 6
	    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
	    , create        = $create || asc;
	  return function($this, callbackfn, that){
	    var O      = toObject($this)
	      , self   = IObject(O)
	      , f      = ctx(callbackfn, that, 3)
	      , length = toLength(self.length)
	      , index  = 0
	      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
	      , val, res;
	    for(;length > index; index++)if(NO_HOLES || index in self){
	      val = self[index];
	      res = f(val, index, O);
	      if(TYPE){
	        if(IS_MAP)result[index] = res;            // map
	        else if(res)switch(TYPE){
	          case 3: return true;                    // some
	          case 5: return val;                     // find
	          case 6: return index;                   // findIndex
	          case 2: result.push(val);               // filter
	        } else if(IS_EVERY)return false;          // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(3)
	  , core    = __webpack_require__(64)
	  , fails   = __webpack_require__(13);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(15);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1142)();
	}


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Redux middleware for calling an API
	 * @module redux-api-middleware
	 * @requires isomorphic-fetch
	 * @requires lodash.isplainobject
	 * @exports {symbol} CALL_API
	 * @exports {function} isRSAA
	 * @exports {function} validateRSAA
	 * @exports {function} isValidRSAA
	 * @exports {error} InvalidRSAA
	 * @exports {error} InternalError
	 * @exports {error} RequestError
	 * @exports {error} ApiError
	 * @exports {function} getJSON
	 * @exports {ReduxMiddleWare} apiMiddleware
	 */
	
	/**
	 * @typedef {function} ReduxMiddleware
	 * @param {object} store
	 * @returns {ReduxNextHandler}
	 *
	 * @typedef {function} ReduxNextHandler
	 * @param {function} next
	 * @returns {ReduxActionHandler}
	 *
	 * @typedef {function} ReduxActionHandler
	 * @param {object} action
	 * @returns undefined
	 */
	
	'use strict';
	
	var _interopRequireDefault = __webpack_require__(194)['default'];
	
	exports.__esModule = true;
	
	var _CALL_API = __webpack_require__(232);
	
	var _CALL_API2 = _interopRequireDefault(_CALL_API);
	
	var _validation = __webpack_require__(498);
	
	var _errors = __webpack_require__(233);
	
	var _util = __webpack_require__(497);
	
	var _middleware = __webpack_require__(1156);
	
	exports.CALL_API = _CALL_API2['default'];
	exports.isRSAA = _validation.isRSAA;
	exports.validateRSAA = _validation.validateRSAA;
	exports.isValidRSAA = _validation.isValidRSAA;
	exports.InvalidRSAA = _errors.InvalidRSAA;
	exports.InternalError = _errors.InternalError;
	exports.RequestError = _errors.RequestError;
	exports.ApiError = _errors.ApiError;
	exports.getJSON = _util.getJSON;
	exports.apiMiddleware = _middleware.apiMiddleware;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Icon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var sizes = {
	    ss: {
	        width: 19,
	        height: 19
	    },
	    s: {
	        width: 24,
	        height: 24
	    },
	    sm: {
	        width: 35,
	        height: 35
	    },
	    m: {
	        width: 55,
	        height: 55
	    },
	    //same button size as m, but smaller icon
	    mm: {
	        width: 42,
	        height: 42
	    },
	    l: {
	        width: 70,
	        height: 70
	    }
	};
	
	function Icon(props) {
	    var icon = props.icon,
	        _props$size = props.size,
	        size = _props$size === undefined ? 'm' : _props$size,
	        _props$className = props.className,
	        className = _props$className === undefined ? null : _props$className,
	        _props$spin = props.spin,
	        spin = _props$spin === undefined ? false : _props$spin,
	        restprops = _objectWithoutProperties(props, ['icon', 'size', 'className', 'spin']);
	
	    var Ic = __webpack_require__(1250)("./" + icon + '.svg');
	
	    return _react2.default.createElement(Ic, _extends({}, sizes[size], restprops, { className: (0, _classnames2.default)('icon', 'icon-' + size, 'icon-' + icon, { 'icon-spin': !!spin }, className) }));
	}

/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.singleResultReducer = singleResultReducer;
	var singleResultInitialState = exports.singleResultInitialState = {
	    item: {},
	    loading: false
	};
	
	var formatterFuncDefault = function formatterFuncDefault(entity) {
	    return entity;
	};
	
	function singleResultReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : singleResultInitialState;
	    var ACTION = arguments[1];
	    var action = arguments[2];
	    var formatter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : formatterFuncDefault;
	
	    switch (action.type) {
	        case ACTION.REQUEST:
	            return _extends({}, singleResultInitialState, {
	                loading: true
	            });
	
	        case ACTION.SUCCESS:
	            return _extends({}, state, {
	                item: formatter(action.payload),
	                loading: false
	            });
	        case ACTION.FAILURE:
	            return _extends({}, state, {
	                loading: false
	            });
	        default:
	            return state;
	    }
	}

/***/ },
/* 64 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(37);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var Map     = __webpack_require__(274)
	  , $export = __webpack_require__(3)
	  , shared  = __webpack_require__(138)('metadata')
	  , store   = shared.store || (shared.store = new (__webpack_require__(277)));
	
	var getOrCreateMetadataMap = function(target, targetKey, create){
	  var targetMetadata = store.get(target);
	  if(!targetMetadata){
	    if(!create)return undefined;
	    store.set(target, targetMetadata = new Map);
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if(!keyMetadata){
	    if(!create)return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map);
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function(MetadataKey, O, P){
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function(MetadataKey, MetadataValue, O, P){
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function(target, targetKey){
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false)
	    , keys        = [];
	  if(metadataMap)metadataMap.forEach(function(_, key){ keys.push(key); });
	  return keys;
	};
	var toMetaKey = function(it){
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function(O){
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if(__webpack_require__(20)){
	  var LIBRARY             = __webpack_require__(81)
	    , global              = __webpack_require__(10)
	    , fails               = __webpack_require__(13)
	    , $export             = __webpack_require__(3)
	    , $typed              = __webpack_require__(139)
	    , $buffer             = __webpack_require__(190)
	    , ctx                 = __webpack_require__(65)
	    , anInstance          = __webpack_require__(80)
	    , propertyDesc        = __webpack_require__(72)
	    , hide                = __webpack_require__(38)
	    , redefineAll         = __webpack_require__(85)
	    , toInteger           = __webpack_require__(73)
	    , toLength            = __webpack_require__(24)
	    , toIndex             = __webpack_require__(87)
	    , toPrimitive         = __webpack_require__(59)
	    , has                 = __webpack_require__(33)
	    , same                = __webpack_require__(271)
	    , classof             = __webpack_require__(108)
	    , isObject            = __webpack_require__(15)
	    , toObject            = __webpack_require__(28)
	    , isArrayIter         = __webpack_require__(175)
	    , create              = __webpack_require__(82)
	    , getPrototypeOf      = __webpack_require__(45)
	    , gOPN                = __webpack_require__(83).f
	    , getIterFn           = __webpack_require__(192)
	    , uid                 = __webpack_require__(88)
	    , wks                 = __webpack_require__(16)
	    , createArrayMethod   = __webpack_require__(57)
	    , createArrayIncludes = __webpack_require__(129)
	    , speciesConstructor  = __webpack_require__(184)
	    , ArrayIterators      = __webpack_require__(193)
	    , Iterators           = __webpack_require__(97)
	    , $iterDetect         = __webpack_require__(135)
	    , setSpecies          = __webpack_require__(86)
	    , arrayFill           = __webpack_require__(168)
	    , arrayCopyWithin     = __webpack_require__(251)
	    , $DP                 = __webpack_require__(21)
	    , $GOPD               = __webpack_require__(44)
	    , dP                  = $DP.f
	    , gOPD                = $GOPD.f
	    , RangeError          = global.RangeError
	    , TypeError           = global.TypeError
	    , Uint8Array          = global.Uint8Array
	    , ARRAY_BUFFER        = 'ArrayBuffer'
	    , SHARED_BUFFER       = 'Shared' + ARRAY_BUFFER
	    , BYTES_PER_ELEMENT   = 'BYTES_PER_ELEMENT'
	    , PROTOTYPE           = 'prototype'
	    , ArrayProto          = Array[PROTOTYPE]
	    , $ArrayBuffer        = $buffer.ArrayBuffer
	    , $DataView           = $buffer.DataView
	    , arrayForEach        = createArrayMethod(0)
	    , arrayFilter         = createArrayMethod(2)
	    , arraySome           = createArrayMethod(3)
	    , arrayEvery          = createArrayMethod(4)
	    , arrayFind           = createArrayMethod(5)
	    , arrayFindIndex      = createArrayMethod(6)
	    , arrayIncludes       = createArrayIncludes(true)
	    , arrayIndexOf        = createArrayIncludes(false)
	    , arrayValues         = ArrayIterators.values
	    , arrayKeys           = ArrayIterators.keys
	    , arrayEntries        = ArrayIterators.entries
	    , arrayLastIndexOf    = ArrayProto.lastIndexOf
	    , arrayReduce         = ArrayProto.reduce
	    , arrayReduceRight    = ArrayProto.reduceRight
	    , arrayJoin           = ArrayProto.join
	    , arraySort           = ArrayProto.sort
	    , arraySlice          = ArrayProto.slice
	    , arrayToString       = ArrayProto.toString
	    , arrayToLocaleString = ArrayProto.toLocaleString
	    , ITERATOR            = wks('iterator')
	    , TAG                 = wks('toStringTag')
	    , TYPED_CONSTRUCTOR   = uid('typed_constructor')
	    , DEF_CONSTRUCTOR     = uid('def_constructor')
	    , ALL_CONSTRUCTORS    = $typed.CONSTR
	    , TYPED_ARRAY         = $typed.TYPED
	    , VIEW                = $typed.VIEW
	    , WRONG_LENGTH        = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function(O, length){
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function(){
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function(){
	    new Uint8Array(1).set({});
	  });
	
	  var strictToLength = function(it, SAME){
	    if(it === undefined)throw TypeError(WRONG_LENGTH);
	    var number = +it
	      , length = toLength(it);
	    if(SAME && !same(number, length))throw RangeError(WRONG_LENGTH);
	    return length;
	  };
	
	  var toOffset = function(it, BYTES){
	    var offset = toInteger(it);
	    if(offset < 0 || offset % BYTES)throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function(it){
	    if(isObject(it) && TYPED_ARRAY in it)return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function(C, length){
	    if(!(isObject(C) && TYPED_CONSTRUCTOR in C)){
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function(O, list){
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function(C, list){
	    var index  = 0
	      , length = list.length
	      , result = allocate(C, length);
	    while(length > index)result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function(it, key, internal){
	    dP(it, key, {get: function(){ return this._d[internal]; }});
	  };
	
	  var $from = function from(source /*, mapfn, thisArg */){
	    var O       = toObject(source)
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , iterFn  = getIterFn(O)
	      , i, length, values, result, step, iterator;
	    if(iterFn != undefined && !isArrayIter(iterFn)){
	      for(iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++){
	        values.push(step.value);
	      } O = values;
	    }
	    if(mapping && aLen > 2)mapfn = ctx(mapfn, arguments[2], 2);
	    for(i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++){
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/*...items*/){
	    var index  = 0
	      , length = arguments.length
	      , result = allocate(this, length);
	    while(length > index)result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function(){ arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString(){
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /*, end */){
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /*, thisArg */){
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /*, start, end */){ // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /*, thisArg */){
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /*, thisArg */){
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /*, thisArg */){
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /*, thisArg */){
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /*, fromIndex */){
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /*, fromIndex */){
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator){ // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */){ // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /*, thisArg */){
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /*, initialValue */){ // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse(){
	      var that   = this
	        , length = validate(that).length
	        , middle = Math.floor(length / 2)
	        , index  = 0
	        , value;
	      while(index < middle){
	        value         = that[index];
	        that[index++] = that[--length];
	        that[length]  = value;
	      } return that;
	    },
	    some: function some(callbackfn /*, thisArg */){
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn){
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end){
	      var O      = validate(this)
	        , length = O.length
	        , $begin = toIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end){
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /*, offset */){
	    validate(this);
	    var offset = toOffset(arguments[1], 1)
	      , length = this.length
	      , src    = toObject(arrayLike)
	      , len    = toLength(src.length)
	      , index  = 0;
	    if(len + offset > length)throw RangeError(WRONG_LENGTH);
	    while(index < len)this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries(){
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys(){
	      return arrayKeys.call(validate(this));
	    },
	    values: function values(){
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function(target, key){
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key){
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc){
	    if(isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ){
	      target[key] = desc.value;
	      return target;
	    } else return dP(target, key, desc);
	  };
	
	  if(!ALL_CONSTRUCTORS){
	    $GOPD.f = $getDesc;
	    $DP.f   = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty:           $setDesc
	  });
	
	  if(fails(function(){ arrayToString.call({}); })){
	    arrayToString = arrayToLocaleString = function toString(){
	      return arrayJoin.call(this);
	    }
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice:          $slice,
	    set:            $set,
	    constructor:    function(){ /* noop */ },
	    toString:       arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function(){ return this[TYPED_ARRAY]; }
	  });
	
	  module.exports = function(KEY, BYTES, wrapper, CLAMPED){
	    CLAMPED = !!CLAMPED;
	    var NAME       = KEY + (CLAMPED ? 'Clamped' : '') + 'Array'
	      , ISNT_UINT8 = NAME != 'Uint8Array'
	      , GETTER     = 'get' + KEY
	      , SETTER     = 'set' + KEY
	      , TypedArray = global[NAME]
	      , Base       = TypedArray || {}
	      , TAC        = TypedArray && getPrototypeOf(TypedArray)
	      , FORCED     = !TypedArray || !$typed.ABV
	      , O          = {}
	      , TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function(that, index){
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function(that, index, value){
	      var data = that._d;
	      if(CLAMPED)value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function(that, index){
	      dP(that, index, {
	        get: function(){
	          return getter(this, index);
	        },
	        set: function(value){
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if(FORCED){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME, '_d');
	        var index  = 0
	          , offset = 0
	          , buffer, byteLength, length, klass;
	        if(!isObject(data)){
	          length     = strictToLength(data, true)
	          byteLength = length * BYTES;
	          buffer     = new $ArrayBuffer(byteLength);
	        } else if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if($length === undefined){
	            if($len % BYTES)throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if(byteLength < 0)throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if(byteLength + offset > $len)throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if(TYPED_ARRAY in data){
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while(index < length)addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if(!$iterDetect(function(iter){
	      // V8 works with iterators, but fails in many other cases
	      // https://code.google.com/p/v8/issues/detail?id=4552
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)){
	      TypedArray = wrapper(function(that, data, $offset, $length){
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if(!isObject(data))return new Base(strictToLength(data, ISNT_UINT8));
	        if(data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER){
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if(TYPED_ARRAY in data)return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function(key){
	        if(!(key in TypedArray))hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if(!LIBRARY)TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator   = TypedArrayPrototype[ITERATOR]
	      , CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined)
	      , $iterator         = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if(CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)){
	      dP(TypedArrayPrototype, TAG, {
	        get: function(){ return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES,
	      from: $from,
	      of: $of
	    });
	
	    if(!(BYTES_PER_ELEMENT in TypedArrayPrototype))hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, {set: $set});
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, {toString: arrayToString});
	
	    $export($export.P + $export.F * fails(function(){
	      new TypedArray(1).slice();
	    }), NAME, {slice: $slice});
	
	    $export($export.P + $export.F * (fails(function(){
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString()
	    }) || !fails(function(){
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, {toLocaleString: $toLocaleString});
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if(!LIBRARY && !CORRECT_ITER_NAME)hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function(){ /* empty */ };

/***/ },
/* 68 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 69 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitParticipant = submitParticipant;
	exports.fetchParticipant = fetchParticipant;
	exports.fetchParticipantsPaginated = fetchParticipantsPaginated;
	exports.fetchParticipantByUuid = fetchParticipantByUuid;
	exports.initializeParticipantFormData = initializeParticipantFormData;
	exports.deleteParticipant = deleteParticipant;
	exports.fetchParticipantResultV2 = fetchParticipantResultV2;
	exports.fetchParticipantResult = fetchParticipantResult;
	exports.submitParticipantResult = submitParticipantResult;
	exports.submitParticipantResultsSearch = submitParticipantResultsSearch;
	exports.submitAdminParticipantResultsSearch = submitAdminParticipantResultsSearch;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/participants';
	
	function submitParticipant(values) {
	    values.birth_date = (0, _moment2.default)(values.birth_date).format('YYYY-MM-DD');
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_PARTICIPANT);
	}
	
	function fetchParticipant(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.LOAD_PARTICIPANT);
	}
	
	function fetchParticipantsPaginated() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	    var queryData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.LOAD_PARTICIPANTS_PAGINATED, queryData);
	}
	
	function fetchParticipantByUuid(participantUuid) {
	    return (0, _common.fetchElement)(apiUrl + '/uuid', participantUuid, _types2.default.LOAD_PARTICIPANT_BY_UUID);
	}
	
	function initializeParticipantFormData(participant) {
	    return {
	        type: _types2.default.INITIALIZE_PARTICIPANT_FORM_DATA,
	        payload: participant
	    };
	}
	
	function deleteParticipant(participant) {
	    return (0, _common.deleteElement)(apiUrl, participant.id, _types2.default.DELETE_PARTICIPANT);
	}
	
	function fetchParticipantResultV2(itemId) {
	    return (0, _common.fetchElement)(apiUrl + '/results', itemId, _types2.default.LOAD_PARTICIPANT_RESULT_V2);
	}
	
	function fetchParticipantResult(itemId) {
	    return (0, _common.fetchElement)('/api/participant-results', itemId, _types2.default.LOAD_PARTICIPANT_RESULT);
	}
	
	function submitParticipantResult(values) {
	    if (values.titles && typeof values.titles === 'string') {
	        values.title = values.titles.split(',');
	    }
	    if (values.row && typeof values.row === 'string') {
	        values.row = values.row.split(',');
	    }
	    values.birth_date = (0, _moment2.default)(values.birth_date).format('YYYY-MM-DD');
	
	    return (0, _common.submitElement)('/api/participant-results', values, _types2.default.SUBMIT_PARTICIPANT_RESULT);
	}
	
	function submitParticipantResultsSearch(values) {
	    if (values.birth_date) {
	        values.birth_date = (0, _moment2.default)(values.birth_date).format('YYYY-MM-DD');
	    }
	    return (0, _common.submitElement)(apiUrl + '/results', values, _types2.default.SUBMIT_PARTICIPANT_RESULT_SEARCH);
	}
	
	function submitAdminParticipantResultsSearch(values) {
	    if (values.birth_date) {
	        values.birth_date = (0, _moment2.default)(values.birth_date).format('YYYY-MM-DD');
	    }
	    return (0, _common.submitElement)(apiUrl + '/results', values, _types2.default.SUBMIT_ADMIN_PARTICIPANT_RESULT_SEARCH);
	}

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(88)('meta')
	  , isObject = __webpack_require__(15)
	  , has      = __webpack_require__(33)
	  , setDesc  = __webpack_require__(21).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(13)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	var core = module.exports = {version: '1.2.6'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(310),
	    baseIteratee = __webpack_require__(931),
	    baseMap = __webpack_require__(934),
	    isArray = __webpack_require__(46);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 79 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.multipleResultReducer = multipleResultReducer;
	var multipleResultInitialState = exports.multipleResultInitialState = {
	    items: [],
	    loading: false
	};
	
	var formatterFuncDefault = function formatterFuncDefault(entities) {
	    return entities;
	};
	function multipleResultReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : multipleResultInitialState;
	    var ACTION = arguments[1];
	    var action = arguments[2];
	    var formatter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : formatterFuncDefault;
	
	    switch (action.type) {
	        case ACTION.REQUEST:
	
	            return _extends({}, multipleResultInitialState, {
	                loading: true
	            });
	
	        case ACTION.SUCCESS:
	            return _extends({}, state, {
	                items: formatter(action.payload),
	                loading: false
	            });
	        case ACTION.FAILURE:
	            return _extends({}, state, {
	                loading: false
	            });
	        default:
	            return state;
	    }
	}

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 81 */
/***/ function(module, exports) {

	module.exports = false;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(9)
	  , dPs         = __webpack_require__(264)
	  , enumBugKeys = __webpack_require__(171)
	  , IE_PROTO    = __webpack_require__(183)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(170)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(173).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(266)
	  , hiddenKeys = __webpack_require__(171).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(266)
	  , enumBugKeys = __webpack_require__(171);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(39);
	module.exports = function(target, src, safe){
	  for(var key in src)redefine(target, key, src[key], safe);
	  return target;
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(10)
	  , dP          = __webpack_require__(21)
	  , DESCRIPTORS = __webpack_require__(20)
	  , SPECIES     = __webpack_require__(16)('species');
	
	module.exports = function(KEY){
	  var C = global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(73)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 88 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(116),
	    getRawTag = __webpack_require__(961),
	    objectToString = __webpack_require__(988);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(929),
	    getValue = __webpack_require__(962);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 91 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 92 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = fateField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDatetime = __webpack_require__(1074);
	
	var _reactDatetime2 = _interopRequireDefault(_reactDatetime);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	__webpack_require__(223);
	function fateField(props) {
	  var DATE_FORMAT = 'YYYY-MM-DD';
	
	  var _onChange = props.onChange,
	      value = props.value,
	      _props$timeFormat = props.timeFormat,
	      timeFormat = _props$timeFormat === undefined ? 'HH:mm' : _props$timeFormat,
	      _props$noTimeZoneDate = props.noTimeZoneDate,
	      noTimeZoneDate = _props$noTimeZoneDate === undefined ? false : _props$noTimeZoneDate,
	      restprops = _objectWithoutProperties(props, ['onChange', 'value', 'timeFormat', 'noTimeZoneDate']);
	
	  if (value) {
	    if (noTimeZoneDate) {
	      value = (0, _moment2.default)(value, DATE_FORMAT);
	    } else {
	      value = new Date(value);
	    }
	  }
	
	  delete restprops.onFocus;
	  return _react2.default.createElement(_reactDatetime2.default, _extends({ locale: 'lt',
	    onChange: function onChange(value) {
	      if (_moment2.default.isMoment(value) && _onChange) {
	        _onChange(value);
	      }
	    }
	  }, restprops, {
	    dateFormat: DATE_FORMAT,
	    timeFormat: timeFormat,
	    value: value,
	    utc: false
	  }));
	}

/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.removeItem = removeItem;
	function removeItem(items, itemToRemoveId) {
	    var itemsReturn = [];
	    items.forEach(function (item) {
	        if (item.id !== itemToRemoveId) {
	            itemsReturn.push(item);
	        }
	    });
	    return itemsReturn;
	}

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(16)('unscopables')
	  , ArrayProto  = Array.prototype;
	if(ArrayProto[UNSCOPABLES] == undefined)__webpack_require__(38)(ArrayProto, UNSCOPABLES, {});
	module.exports = function(key){
	  ArrayProto[UNSCOPABLES][key] = true;
	};

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(65)
	  , call        = __webpack_require__(260)
	  , isArrayIter = __webpack_require__(175)
	  , anObject    = __webpack_require__(9)
	  , toLength    = __webpack_require__(24)
	  , getIterFn   = __webpack_require__(192)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 97 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(21).f
	  , has = __webpack_require__(33)
	  , TAG = __webpack_require__(16)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , defined = __webpack_require__(50)
	  , fails   = __webpack_require__(13)
	  , spaces  = __webpack_require__(188)
	  , space   = '[' + spaces + ']'
	  , non     = '\u200b\u0085'
	  , ltrim   = RegExp('^' + space + space + '*')
	  , rtrim   = RegExp(space + space + '*$');
	
	var exporter = function(KEY, exec, ALIAS){
	  var exp   = {};
	  var FORCE = fails(function(){
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if(ALIAS)exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function(string, TYPE){
	  string = String(defined(string));
	  if(TYPE & 1)string = string.replace(ltrim, '');
	  if(TYPE & 2)string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(141);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(75);
	
	var _Actions = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(92);
	
	var ReactCurrentOwner = __webpack_require__(467);
	
	var warning = __webpack_require__(204);
	var canDefineProperty = __webpack_require__(470);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(468);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.makeFieldValue = makeFieldValue;
	exports.isFieldValue = isFieldValue;
	var flag = '_isFieldValue';
	var isObject = function isObject(object) {
	  return typeof object === 'object';
	};
	
	function makeFieldValue(object) {
	  if (object && isObject(object)) {
	    // This flag has to be enumerable, because otherwise it is not possible
	    // to serialize object with this field.
	    // The consequence is you lose information that particular field is
	    // field or nested group of fields, so you're not able to fetch
	    // field value from state when it has been affected in some way
	    // by serializing/using immutable and so on.
	    // @fixme marking field as leaf should be made in other way
	    Object.defineProperty(object, flag, { value: true, enumerable: true });
	  }
	  return object;
	}
	
	function isFieldValue(object) {
	  return !!(object && isObject(object) && object[flag]);
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitPost = submitPost;
	exports.fetchPost = fetchPost;
	exports.fetchPostsPaginated = fetchPostsPaginated;
	exports.fetchPostBySlug = fetchPostBySlug;
	exports.deletePost = deletePost;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/posts';
	
	function submitPost(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_POST);
	}
	function fetchPost(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.LOAD_POST);
	}
	
	function fetchPostsPaginated() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.LOAD_POSTS_PAGINATED);
	}
	function fetchPostBySlug(slug) {
	    return (0, _common.fetchElement)(apiUrl + '/slug', slug, _types2.default.LOAD_POST);
	}
	
	function deletePost(post) {
	    return (0, _common.deleteElement)(apiUrl, post.id, _types2.default.DELETE_POST);
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = internalImage;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function internalImage(props) {
	    var filename = props.filename,
	        alt = props.alt;
	
	    if (filename) {
	        return _react2.default.createElement("img", { src: "" + window.CARE_CONFIG.image_storage_base_url_v2 + filename, alt: alt, title: alt, loading: "lazy" });
	    }
	    return null;
	}

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(49)
	  , TAG = __webpack_require__(16)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(49);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 110 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 111 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(196);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(68)
	  , core      = __webpack_require__(74)
	  , ctx       = __webpack_require__(112)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    if(IS_PROTO)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	};
	// type bitmap
	$export.F = 1;  // forced
	$export.G = 2;  // global
	$export.S = 4;  // static
	$export.P = 8;  // proto
	$export.B = 16; // bind
	$export.W = 32; // wrap
	module.exports = $export;

/***/ },
/* 114 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(458);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(309),
	    baseKeys = __webpack_require__(932),
	    isArrayLike = __webpack_require__(153);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 118 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1101);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(60);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitPartner = submitPartner;
	exports.fetchPartner = fetchPartner;
	exports.fetchPartners = fetchPartners;
	exports.deletePartner = deletePartner;
	exports.fetchAllPartners = fetchAllPartners;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/partners';
	
	function submitPartner(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_PARTNER);
	}
	function fetchPartner(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.ADMIN_LOAD_PARTNER);
	}
	
	function fetchPartners() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.ADMIN_LOAD_PARTNERS);
	}
	
	function deletePartner(partner) {
	    return (0, _common.deleteElement)(apiUrl, partner.id, _types2.default.DELETE_PARTNER);
	}
	
	function fetchAllPartners() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl,
	        method: 'GET',
	        types: _types2.default.LOAD_PARTNERS.all
	    });
	}

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitUser = submitUser;
	exports.fetchUser = fetchUser;
	exports.loadUsers = loadUsers;
	exports.login = login;
	exports.logout = logout;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/users';
	
	function submitUser(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_USER);
	}
	function fetchUser(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.ADMIN_LOAD_USER);
	}
	
	function loadUsers() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl, page, size, _types2.default.ADMIN_LOAD_USERS);
	}
	
	function login(values) {
	    return (0, _common.submitElement)('/api/auth/login', values, _types2.default.LOGIN_USER);
	}
	function logout() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: '/api/auth/logout',
	        method: 'POST',
	        types: _types2.default.LOGOUT.all
	    });
	}

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactDropzone = __webpack_require__(465);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _isomorphicFetch = __webpack_require__(304);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _buttonRound = __webpack_require__(538);
	
	var _buttonRound2 = _interopRequireDefault(_buttonRound);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageInput = function (_Component) {
	    _inherits(ImageInput, _Component);
	
	    function ImageInput(props) {
	        _classCallCheck(this, ImageInput);
	
	        var _this = _possibleConstructorReturn(this, (ImageInput.__proto__ || Object.getPrototypeOf(ImageInput)).call(this, props));
	
	        _this.state = {
	            saving: false
	        };
	        return _this;
	    }
	
	    _createClass(ImageInput, [{
	        key: 'removeImage',
	        value: function removeImage() {
	            var _this2 = this;
	
	            var value = this.props.value;
	
	            this.setState({ saving: true });
	            (0, _isomorphicFetch2.default)('/api/images/' + value, { method: 'DELETE' }).then(function (response) {
	                if (response.status >= 200 && response.status < 300) {
	                    return response.json();
	                } else {
	                    throw new Error('failed to upload, resp', response.status);
	                }
	            }).then(function () {
	                if (_this2.props.onChange) {
	                    _this2.props.onChange('');
	                }
	            }).catch(function (e) {
	                console.error('failed to remove image', e);
	            }).then(function () {
	                _this2.setState({ saving: false });
	            });
	        }
	    }, {
	        key: 'onDrop',
	        value: function onDrop(files) {
	            var _this3 = this;
	
	            var data = new FormData();
	            data.append('image', files[0]);
	
	            this.setState({ saving: true });
	
	            (0, _isomorphicFetch2.default)('/api/images/', {
	                method: 'POST',
	                body: data
	            }).then(function (response) {
	                if (response.status >= 200 && response.status < 300) {
	                    return response.json();
	                } else {
	                    throw new Error('failed to upload, resp', response.status);
	                }
	            }).then(function (result) {
	                if (_this3.props.onChange) {
	                    _this3.props.onChange(result.id);
	                    if (_this3.props.onImageUploaded) {
	                        _this3.props.onImageUploaded(result);
	                    }
	                }
	            }).catch(function (e) {
	                console.error('failed to upload image', e);
	            }).then(function () {
	                _this3.setState({ saving: false });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            var _props = this.props,
	                value = _props.value,
	                _props$uploadLabel = _props.uploadLabel,
	                uploadLabel = _props$uploadLabel === undefined ? _strings2.default.upload : _props$uploadLabel,
	                _props$className = _props.className,
	                className = _props$className === undefined ? null : _props$className,
	                _props$iconSize = _props.iconSize,
	                iconSize = _props$iconSize === undefined ? 'sm' : _props$iconSize,
	                _props$inlineImg = _props.inlineImg,
	                inlineImg = _props$inlineImg === undefined ? true : _props$inlineImg;
	
	            return _react2.default.createElement(
	                'div',
	                { className: (0, _classnames2.default)('image-input', className, {
	                        'empty': !value
	                    }, {
	                        'not-empty': !!value
	                    }) },
	                _react2.default.createElement(
	                    _reactDropzone2.default,
	                    { className: 'dropzone', onDrop: this.onDrop.bind(this), accept: 'image/*', multiple: false },
	                    function () {
	                        if (_this4.state.saving) {
	                            return _react2.default.createElement(_icon2.default, { icon: 'spinner', spin: true });
	                        } else if (value) {
	                            if (inlineImg) {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { className: 'image-display' },
	                                    _react2.default.createElement('img', { key: 'img', src: window.CARE_CONFIG.image_storage_base_url + value }),
	                                    _react2.default.createElement(_buttonRound2.default, { title: 'remove image', className: 'remove', key: 'btn', icon: 'trash', type: 'empty', size: 's', onClick: _this4.removeImage.bind(_this4) })
	                                );
	                            } else {
	                                return _react2.default.createElement(
	                                    'div',
	                                    { className: 'delete-msg', onClick: _this4.removeImage.bind(_this4) },
	                                    _react2.default.createElement(_buttonRound2.default, { icon: 'trash', size: iconSize, type: 'empty' }),
	                                    _react2.default.createElement(
	                                        'span',
	                                        null,
	                                        _strings2.default.remove
	                                    )
	                                );
	                            }
	                        } else {
	                            return _react2.default.createElement(
	                                'div',
	                                { className: 'empty-msg' },
	                                _react2.default.createElement(_buttonRound2.default, { icon: 'upload', size: iconSize, type: 'empty' }),
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    uploadLabel
	                                )
	                            );
	                        }
	                    }()
	                )
	            );
	        }
	    }]);
	
	    return ImageInput;
	}(_react.Component);
	
	exports.default = ImageInput;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTextTruncate = __webpack_require__(496);
	
	var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _tinymceReact = __webpack_require__(526);
	
	var _tinymce = __webpack_require__(1247);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(1245);
	
	__webpack_require__(1198);
	
	__webpack_require__(887);
	
	__webpack_require__(1199);
	
	__webpack_require__(1203);
	
	__webpack_require__(1219);
	
	__webpack_require__(1215);
	
	__webpack_require__(1221);
	
	__webpack_require__(1205);
	
	__webpack_require__(1213);
	
	__webpack_require__(1201);
	
	__webpack_require__(1235);
	
	__webpack_require__(1233);
	
	__webpack_require__(1243);
	
	__webpack_require__(1207);
	
	__webpack_require__(1209);
	
	__webpack_require__(1217);
	
	__webpack_require__(1223);
	
	__webpack_require__(1225);
	
	__webpack_require__(1237);
	
	__webpack_require__(1239);
	
	__webpack_require__(1211);
	
	__webpack_require__(1227);
	
	__webpack_require__(1229);
	
	__webpack_require__(1241);
	
	__webpack_require__(1231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TinyMCE so the global var exists
	// eslint-disable-next-line no-unused-vars
	
	
	// Theme
	
	// Toolbar icons
	
	// Editor styles
	
	
	// importing the plugin js.
	
	
	var strip = function strip(html) {
	    var tmp = document.createElement('DIV');
	    tmp.innerHTML = html;
	    return tmp.textContent || tmp.innerText || '';
	};
	
	var TextField = function (_Component) {
	    _inherits(TextField, _Component);
	
	    function TextField(props) {
	        _classCallCheck(this, TextField);
	
	        var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));
	
	        _this.state = {
	            editing: false
	        };
	        return _this;
	    }
	
	    _createClass(TextField, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var value = this.props.value;
	
	            if (this.state.editing) {
	                return _react2.default.createElement(_tinymceReact.Editor, {
	                    value: this.props.value,
	                    onEditorChange: function onEditorChange(value) {
	                        _this2.props.onChange(value);
	                    },
	                    init: {
	                        height: 500,
	                        menubar: true,
	                        extended_valid_elements: 'script[src|type],div[class|data-embed-type|data-embed-id|data-style|data-map-hash|data-from-embed]',
	                        valid_children: '+body[script]',
	                        valid_elements: '*[*]', // allows all elements and attributes
	                        forced_root_block: false,
	                        force_br_newlines: true,
	                        force_p_newlines: false,
	
	                        paste_filter_drop: true,
	                        paste_remove_styles: true,
	                        paste_remove_spans: true,
	                        paste_webkit_styles: 'none', // prevents WebKit from preserving styles
	                        content_style: '.strava-embed-placeholder { background-color: #cbd5dd; border: 1px solid grey;  display: inline-block; width: 100%; pointer-events: none; cursor: default;  } .strava-embed-placeholder::before {content: "Strava embed";}',
	                        plugins: ['advlist autolink lists link image charmap print preview anchor', 'searchreplace visualblocks code fullscreen', 'insertdatetime media table paste code help wordcount'],
	                        toolbar: 'undo redo | formatselect | ' + 'bold italic backcolor | alignleft aligncenter ' + 'alignright alignjustify | bullist numlist outdent indent | ' + 'removeformat | table | paste pastetext | code'
	                    }
	                });
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'text-field' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn', onClick: function onClick() {
	                                _this2.setState({ editing: true });
	                            } },
	                        _strings2.default.edit
	                    ),
	                    _react2.default.createElement(_reactTextTruncate2.default, { line: 10, truncateText: '\u2026', text: strip(value) })
	                );
	            }
	        }
	    }]);
	
	    return TextField;
	}(_react.Component);
	
	exports.default = TextField;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HtmlRenderer = function (_Component) {
	  _inherits(HtmlRenderer, _Component);
	
	  function HtmlRenderer(props) {
	    _classCallCheck(this, HtmlRenderer);
	
	    var _this = _possibleConstructorReturn(this, (HtmlRenderer.__proto__ || Object.getPrototypeOf(HtmlRenderer)).call(this, props));
	
	    _this.containerRef = _react2.default.createRef();
	    _this.loadedScripts = {}; // Tracks already-loaded scripts to avoid duplication
	    return _this;
	  }
	
	  _createClass(HtmlRenderer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setHtmlAndLoadScripts();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.html !== this.props.html) {
	        this.setHtmlAndLoadScripts();
	      }
	    }
	  }, {
	    key: 'setHtmlAndLoadScripts',
	    value: function setHtmlAndLoadScripts() {
	      var _this2 = this;
	
	      if (this.containerRef.current) {
	        // Inject HTML
	        this.containerRef.current.innerHTML = this.props.html;
	
	        // Find all <script src="..."> tags
	        var scriptTags = this.containerRef.current.querySelectorAll('script[src]');
	
	        scriptTags.forEach(function (tag) {
	          var src = tag.getAttribute('src');
	
	          // Skip if script already loaded
	          if (_this2.loadedScripts[src]) return;
	
	          // Create and append new script tag
	          var script = document.createElement('script');
	          script.src = src;
	          script.async = true;
	
	          document.body.appendChild(script);
	          _this2.loadedScripts[src] = true;
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('div', { ref: this.containerRef, className: 'html-renderer' });
	    }
	  }]);
	
	  return HtmlRenderer;
	}(_react.Component);
	
	exports.default = HtmlRenderer;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactRouter = __webpack_require__(14);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageContainer = function (_Component) {
	    _inherits(PageContainer, _Component);
	
	    function PageContainer() {
	        _classCallCheck(this, PageContainer);
	
	        return _possibleConstructorReturn(this, (PageContainer.__proto__ || Object.getPrototypeOf(PageContainer)).apply(this, arguments));
	    }
	
	    _createClass(PageContainer, [{
	        key: 'openPage',
	        value: function openPage(url) {
	            _reactRouter.browserHistory.push(url);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return PageContainer;
	}(_react.Component);
	
	exports.default = PageContainer;

/***/ },
/* 128 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getUrlQuery = getUrlQuery;
	exports.isValidURL = isValidURL;
	exports.paymentUrl = paymentUrl;
	function getUrlQuery(queryParams) {
	    return Object.keys(queryParams).map(function (k) {
	        return encodeURIComponent(k) + '=' + encodeURIComponent(queryParams[k]);
	    }).join('&');
	}
	function isValidURL(str) {
	    var url = void 0;
	
	    try {
	        url = new URL(str);
	    } catch (_) {
	        return false;
	    }
	
	    return url.protocol === 'http:' || url.protocol === 'https:';
	}
	
	function paymentUrl(uuid) {
	    return '/payments/create/' + uuid;
	}

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(41)
	  , toLength  = __webpack_require__(24)
	  , toIndex   = __webpack_require__(87);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(10)
	  , $export           = __webpack_require__(3)
	  , redefine          = __webpack_require__(39)
	  , redefineAll       = __webpack_require__(85)
	  , meta              = __webpack_require__(71)
	  , forOf             = __webpack_require__(96)
	  , anInstance        = __webpack_require__(80)
	  , isObject          = __webpack_require__(15)
	  , fails             = __webpack_require__(13)
	  , $iterDetect       = __webpack_require__(135)
	  , setToStringTag    = __webpack_require__(98)
	  , inheritIfRequired = __webpack_require__(174);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = global[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  var fixMethod = function(KEY){
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a){
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a){
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a){ fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b){ fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if(typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
	    new C().entries().next();
	  }))){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance             = new C
	      // early implementations not supports chaining
	      , HASNT_CHAINING       = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	      // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	      , THROWS_ON_PRIMITIVES = fails(function(){ instance.has(1); })
	      // most early implementations doesn't supports iterables, most modern - not close it correctly
	      , ACCEPT_ITERABLES     = $iterDetect(function(iter){ new C(iter); }) // eslint-disable-line no-new
	      // for early implementations -0 and +0 not the same
	      , BUGGY_ZERO = !IS_WEAK && fails(function(){
	        // V8 ~ Chromium 42- fails only with 5+ elements
	        var $instance = new C()
	          , index     = 5;
	        while(index--)$instance[ADDER](index, index);
	        return !$instance.has(-0);
	      });
	    if(!ACCEPT_ITERABLES){ 
	      C = wrapper(function(target, iterable){
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base, target, C);
	        if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if(THROWS_ON_PRIMITIVES || BUGGY_ZERO){
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if(BUGGY_ZERO || HASNT_CHAINING)fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if(IS_WEAK && proto.clear)delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var hide     = __webpack_require__(38)
	  , redefine = __webpack_require__(39)
	  , fails    = __webpack_require__(13)
	  , defined  = __webpack_require__(50)
	  , wks      = __webpack_require__(16);
	
	module.exports = function(KEY, length, exec){
	  var SYMBOL   = wks(KEY)
	    , fns      = exec(defined, SYMBOL, ''[KEY])
	    , strfn    = fns[0]
	    , rxfn     = fns[1];
	  if(fails(function(){
	    var O = {};
	    O[SYMBOL] = function(){ return 7; };
	    return ''[KEY](O) != 7;
	  })){
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function(string, arg){ return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function(string){ return rxfn.call(string, this); }
	    );
	  }
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(9);
	module.exports = function(){
	  var that   = anObject(this)
	    , result = '';
	  if(that.global)     result += 'g';
	  if(that.ignoreCase) result += 'i';
	  if(that.multiline)  result += 'm';
	  if(that.unicode)    result += 'u';
	  if(that.sticky)     result += 'y';
	  return result;
	};

/***/ },
/* 133 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(15)
	  , cof      = __webpack_require__(49)
	  , MATCH    = __webpack_require__(16)('match');
	module.exports = function(it){
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(16)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(81)|| !__webpack_require__(13)(function(){
	  var K = Math.random();
	  // In FF throws only define methods
	  __defineSetter__.call(null, K, function(){ /* empty */});
	  delete __webpack_require__(10)[K];
	});

/***/ },
/* 137 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10)
	  , hide   = __webpack_require__(38)
	  , uid    = __webpack_require__(88)
	  , TYPED  = uid('typed_array')
	  , VIEW   = uid('view')
	  , ABV    = !!(global.ArrayBuffer && global.DataView)
	  , CONSTR = ABV
	  , i = 0, l = 9, Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while(i < l){
	  if(Typed = global[TypedArrayConstructors[i++]]){
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV:    ABV,
	  CONSTR: CONSTR,
	  TYPED:  TYPED,
	  VIEW:   VIEW
	};

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(198)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(42).setDesc
	  , has = __webpack_require__(199)
	  , TAG = __webpack_require__(52)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(286)
	  , defined = __webpack_require__(197);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 145 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 146 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(974),
	    listCacheDelete = __webpack_require__(975),
	    listCacheGet = __webpack_require__(976),
	    listCacheHas = __webpack_require__(977),
	    listCacheSet = __webpack_require__(978);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(218);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(313),
	    baseAssignValue = __webpack_require__(314);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(972);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(154);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(337),
	    isLength = __webpack_require__(221);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1081);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 156 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(1148);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(155);
	
	var _defaultArrowRenderer = __webpack_require__(493);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(494);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(230);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(231);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(491);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(492);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
				var pref = document.addEventListener ? '' : 'on';
	
				document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
				document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false,
							focusedOption: null
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen,
						focusedOption: null
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (!this.props.closeOnSelect) {
					return;
				}
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value,
								values: valueArray
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'div',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 158 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isValid;
	function isValid(error) {
	  if (Array.isArray(error)) {
	    return error.reduce(function (valid, errorValue) {
	      return valid && isValid(errorValue);
	    }, true);
	  }
	  if (error && typeof error === 'object') {
	    return Object.keys(error).reduce(function (valid, key) {
	      return valid && isValid(error[key]);
	    }, true);
	  }
	  return !error;
	}

/***/ },
/* 159 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(522)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 161 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitPage = submitPage;
	exports.fetchPage = fetchPage;
	exports.fetchPagesPaginated = fetchPagesPaginated;
	exports.fetchPageBySlug = fetchPageBySlug;
	exports.deletePage = deletePage;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/pages';
	
	function submitPage(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_PAGE);
	}
	function fetchPage(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.LOAD_PAGE);
	}
	
	function fetchPagesPaginated() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.LOAD_PAGES_PAGINATED);
	}
	function fetchPageBySlug(slug) {
	    return (0, _common.fetchElement)(apiUrl + '/slug', slug, _types2.default.LOAD_PAGE);
	}
	
	function deletePage(page) {
	    return (0, _common.deleteElement)(apiUrl, page.id, _types2.default.DELETE_PAGE);
	}

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitPartnerCategory = submitPartnerCategory;
	exports.fetchPartnerCategory = fetchPartnerCategory;
	exports.fetchPartnerCategories = fetchPartnerCategories;
	exports.deletePartnerCategory = deletePartnerCategory;
	exports.fetchAllPartnerCategories = fetchAllPartnerCategories;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/partner-categories';
	
	function submitPartnerCategory(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_PARTNER);
	}
	
	function fetchPartnerCategory(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.ADMIN_LOAD_PARTNER_CATEGORY);
	}
	
	function fetchPartnerCategories() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.ADMIN_LOAD_PARTNER_CATEGORIES);
	}
	
	function deletePartnerCategory(partner) {
	    return (0, _common.deleteElement)(apiUrl, partner.id, _types2.default.DELETE_PARTNER_CATEGORY);
	}
	
	function fetchAllPartnerCategories() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl,
	        method: 'GET',
	        types: _types2.default.LOAD_PARTNER_CATEGORIES.all
	    });
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitPromoCode = submitPromoCode;
	exports.fetchPromoCode = fetchPromoCode;
	exports.fetchPromoCodesPaginated = fetchPromoCodesPaginated;
	exports.deletePromoCode = deletePromoCode;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/promo-codes';
	
	function submitPromoCode(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_PROMO_CODE);
	}
	function fetchPromoCode(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.ADMIN_LOAD_PROMO_CODE);
	}
	
	function fetchPromoCodesPaginated() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.ADMIN_LOAD_PROMO_CODES);
	}
	
	function deletePromoCode(partner) {
	    return (0, _common.deleteElement)(apiUrl, partner.id, _types2.default.DELETE_PROMO_CODE);
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitSeason = submitSeason;
	exports.fetchSeason = fetchSeason;
	exports.fetchSeasons = fetchSeasons;
	exports.fetchAllSeasons = fetchAllSeasons;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/seasons';
	
	function submitSeason(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_SEASON);
	}
	function fetchSeason(itemId) {
	    return (0, _common.fetchElement)(apiUrl, itemId, _types2.default.ADMIN_LOAD_SEASON);
	}
	
	function fetchSeasons() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.ADMIN_LOAD_SEASONS);
	}
	
	function fetchAllSeasons() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl,
	        method: 'GET',
	        types: _types2.default.LOAD_SEASONS.all
	    });
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParticipantResultsDisplay = function (_Component) {
	    _inherits(ParticipantResultsDisplay, _Component);
	
	    function ParticipantResultsDisplay() {
	        _classCallCheck(this, ParticipantResultsDisplay);
	
	        return _possibleConstructorReturn(this, (ParticipantResultsDisplay.__proto__ || Object.getPrototypeOf(ParticipantResultsDisplay)).apply(this, arguments));
	    }
	
	    _createClass(ParticipantResultsDisplay, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                items = _props.items,
	                searchParams = _props.searchParams;
	
	            var extraCols = this.props.extraCols || [];
	
	            if (!items.length) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.noResults
	                );
	            }
	
	            var config = {
	                cols: [{
	                    header: _strings2.default.stage,
	                    value: function value(item) {
	                        return item.stage.name;
	                    }
	                }, {
	                    header: _strings2.default.distance,
	                    value: function value(item) {
	                        var distance = '';
	                        item.stage.distances.forEach(function (dist) {
	                            if (dist.code.toLowerCase() === item.distance.toLowerCase()) {
	                                distance = dist.name;
	                            }
	                        });
	                        return distance;
	                        // return item.stage.name
	                    }
	                }, {
	                    header: _strings2.default.date,
	                    value: function value(item) {
	                        return (0, _moment2.default)(item.stage.stage_date).format('YYYY-MM-DD');
	                    }
	                }, {
	                    header: _strings2.default.position,
	                    value: function value(item) {
	                        return item.row[item.stage.results_field_position_poz - 1];
	                    }
	                }, {
	                    header: _strings2.default.result,
	                    value: function value(item) {
	                        return item.row[item.row.length - 1];
	                    }
	                }, {
	                    header: '',
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/stages/' + item.stage.id + '/results',
	                                className: 'btn btn-main-color inline ' },
	                            _strings2.default.stageResults
	                        );
	                    }
	                }].concat(_toConsumableArray(extraCols))
	            };
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                searchParams && _react2.default.createElement(
	                    'h3',
	                    { className: 'first-uppercase' },
	                    _strings2.default.participant,
	                    ': ',
	                    searchParams.first_name,
	                    ' ',
	                    searchParams.last_name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'participant-results-history' },
	                    _react2.default.createElement(_dataTable2.default, { config: config, items: items, responsive: true })
	                )
	            );
	        }
	    }]);
	
	    return ParticipantResultsDisplay;
	}(_react.Component);
	
	exports.default = ParticipantResultsDisplay;

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _seasons = __webpack_require__(165);
	
	var seasonActions = _interopRequireWildcard(_seasons);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SeasonSelection = function (_Component) {
	    _inherits(SeasonSelection, _Component);
	
	    function SeasonSelection() {
	        _classCallCheck(this, SeasonSelection);
	
	        return _possibleConstructorReturn(this, (SeasonSelection.__proto__ || Object.getPrototypeOf(SeasonSelection)).apply(this, arguments));
	    }
	
	    _createClass(SeasonSelection, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.actions.fetchAllSeasons();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var field = this.props.field;
	
	            return _react2.default.createElement(_select2.default, _extends({ clearable: false, options: this.props.seasons.items, noResultsText: _strings2.default.noSeasons,
	                placeholder: _strings2.default.season }, field, { onChange: function onChange(item) {
	                    return field.onChange(item.value);
	                } }));
	        }
	    }]);
	
	    return SeasonSelection;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { seasons: state.season.availableSeasons };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(seasonActions, dispatch)
	    };
	})(SeasonSelection);

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(28)
	  , toIndex  = __webpack_require__(87)
	  , toLength = __webpack_require__(24);
	module.exports = function fill(value /*, start = 0, end = @length */){
	  var O      = toObject(this)
	    , length = toLength(O.length)
	    , aLen   = arguments.length
	    , index  = toIndex(aLen > 1 ? arguments[1] : undefined, length)
	    , end    = aLen > 2 ? arguments[2] : undefined
	    , endPos = end === undefined ? length : toIndex(end, length);
	  while(endPos > index)O[index++] = value;
	  return O;
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(21)
	  , createDesc      = __webpack_require__(72);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15)
	  , document = __webpack_require__(10).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 171 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(16)('match');
	module.exports = function(KEY){
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch(e){
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch(f){ /* empty */ }
	  } return true;
	};

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(10).document && document.documentElement;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var isObject       = __webpack_require__(15)
	  , setPrototypeOf = __webpack_require__(182).set;
	module.exports = function(that, target, C){
	  var P, S = target.constructor;
	  if(S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf){
	    setPrototypeOf(that, P);
	  } return that;
	};

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(97)
	  , ITERATOR   = __webpack_require__(16)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(49);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(82)
	  , descriptor     = __webpack_require__(72)
	  , setToStringTag = __webpack_require__(98)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(38)(IteratorPrototype, __webpack_require__(16)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(81)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(39)
	  , hide           = __webpack_require__(38)
	  , has            = __webpack_require__(33)
	  , Iterators      = __webpack_require__(97)
	  , $iterCreate    = __webpack_require__(177)
	  , setToStringTag = __webpack_require__(98)
	  , getPrototypeOf = __webpack_require__(45)
	  , ITERATOR       = __webpack_require__(16)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 179 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x){
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;

/***/ },
/* 180 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x){
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(10)
	  , macrotask = __webpack_require__(189).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(49)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(15)
	  , anObject = __webpack_require__(9);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(65)(Function.call, __webpack_require__(44).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(138)('keys')
	  , uid    = __webpack_require__(88);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(9)
	  , aFunction = __webpack_require__(37)
	  , SPECIES   = __webpack_require__(16)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(73)
	  , defined   = __webpack_require__(50);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(134)
	  , defined  = __webpack_require__(50);
	
	module.exports = function(that, searchString, NAME){
	  if(isRegExp(searchString))throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(73)
	  , defined   = __webpack_require__(50);
	
	module.exports = function repeat(count){
	  var str = String(defined(this))
	    , res = ''
	    , n   = toInteger(count);
	  if(n < 0 || n == Infinity)throw RangeError("Count can't be negative");
	  for(;n > 0; (n >>>= 1) && (str += str))if(n & 1)res += str;
	  return res;
	};

/***/ },
/* 188 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(65)
	  , invoke             = __webpack_require__(133)
	  , html               = __webpack_require__(173)
	  , cel                = __webpack_require__(170)
	  , global             = __webpack_require__(10)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(49)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global         = __webpack_require__(10)
	  , DESCRIPTORS    = __webpack_require__(20)
	  , LIBRARY        = __webpack_require__(81)
	  , $typed         = __webpack_require__(139)
	  , hide           = __webpack_require__(38)
	  , redefineAll    = __webpack_require__(85)
	  , fails          = __webpack_require__(13)
	  , anInstance     = __webpack_require__(80)
	  , toInteger      = __webpack_require__(73)
	  , toLength       = __webpack_require__(24)
	  , gOPN           = __webpack_require__(83).f
	  , dP             = __webpack_require__(21).f
	  , arrayFill      = __webpack_require__(168)
	  , setToStringTag = __webpack_require__(98)
	  , ARRAY_BUFFER   = 'ArrayBuffer'
	  , DATA_VIEW      = 'DataView'
	  , PROTOTYPE      = 'prototype'
	  , WRONG_LENGTH   = 'Wrong length!'
	  , WRONG_INDEX    = 'Wrong index!'
	  , $ArrayBuffer   = global[ARRAY_BUFFER]
	  , $DataView      = global[DATA_VIEW]
	  , Math           = global.Math
	  , RangeError     = global.RangeError
	  , Infinity       = global.Infinity
	  , BaseBuffer     = $ArrayBuffer
	  , abs            = Math.abs
	  , pow            = Math.pow
	  , floor          = Math.floor
	  , log            = Math.log
	  , LN2            = Math.LN2
	  , BUFFER         = 'buffer'
	  , BYTE_LENGTH    = 'byteLength'
	  , BYTE_OFFSET    = 'byteOffset'
	  , $BUFFER        = DESCRIPTORS ? '_b' : BUFFER
	  , $LENGTH        = DESCRIPTORS ? '_l' : BYTE_LENGTH
	  , $OFFSET        = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	var packIEEE754 = function(value, mLen, nBytes){
	  var buffer = Array(nBytes)
	    , eLen   = nBytes * 8 - mLen - 1
	    , eMax   = (1 << eLen) - 1
	    , eBias  = eMax >> 1
	    , rt     = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0
	    , i      = 0
	    , s      = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0
	    , e, m, c;
	  value = abs(value)
	  if(value != value || value === Infinity){
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if(value * (c = pow(2, -e)) < 1){
	      e--;
	      c *= 2;
	    }
	    if(e + eBias >= 1){
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if(value * c >= 2){
	      e++;
	      c /= 2;
	    }
	    if(e + eBias >= eMax){
	      m = 0;
	      e = eMax;
	    } else if(e + eBias >= 1){
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for(; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for(; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	};
	var unpackIEEE754 = function(buffer, mLen, nBytes){
	  var eLen  = nBytes * 8 - mLen - 1
	    , eMax  = (1 << eLen) - 1
	    , eBias = eMax >> 1
	    , nBits = eLen - 7
	    , i     = nBytes - 1
	    , s     = buffer[i--]
	    , e     = s & 127
	    , m;
	  s >>= 7;
	  for(; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for(; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if(e === 0){
	    e = 1 - eBias;
	  } else if(e === eMax){
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	};
	
	var unpackI32 = function(bytes){
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	};
	var packI8 = function(it){
	  return [it & 0xff];
	};
	var packI16 = function(it){
	  return [it & 0xff, it >> 8 & 0xff];
	};
	var packI32 = function(it){
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	};
	var packF64 = function(it){
	  return packIEEE754(it, 52, 8);
	};
	var packF32 = function(it){
	  return packIEEE754(it, 23, 4);
	};
	
	var addGetter = function(C, key, internal){
	  dP(C[PROTOTYPE], key, {get: function(){ return this[internal]; }});
	};
	
	var get = function(view, bytes, index, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	};
	var set = function(view, bytes, index, conversion, value, isLittleEndian){
	  var numIndex = +index
	    , intIndex = toInteger(numIndex);
	  if(numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH])throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b
	    , start = intIndex + view[$OFFSET]
	    , pack  = conversion(+value);
	  for(var i = 0; i < bytes; i++)store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	};
	
	var validateArrayBufferArguments = function(that, length){
	  anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	  var numberLength = +length
	    , byteLength   = toLength(numberLength);
	  if(numberLength != byteLength)throw RangeError(WRONG_LENGTH);
	  return byteLength;
	};
	
	if(!$typed.ABV){
	  $ArrayBuffer = function ArrayBuffer(length){
	    var byteLength = validateArrayBufferArguments(this, length);
	    this._b       = arrayFill.call(Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength){
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH]
	      , offset       = toInteger(byteOffset);
	    if(offset < 0 || offset > bufferLength)throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if(offset + byteLength > bufferLength)throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if(DESCRIPTORS){
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset){
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset){
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /*, littleEndian */){
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /*, littleEndian */){
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /*, littleEndian */){
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /*, littleEndian */){
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /*, littleEndian */){
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /*, littleEndian */){
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if(!fails(function(){
	    new $ArrayBuffer;     // eslint-disable-line no-new
	  }) || !fails(function(){
	    new $ArrayBuffer(.5); // eslint-disable-line no-new
	  })){
	    $ArrayBuffer = function ArrayBuffer(length){
	      return new BaseBuffer(validateArrayBufferArguments(this, length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for(var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j; ){
	      if(!((key = keys[j++]) in $ArrayBuffer))hide($ArrayBuffer, key, BaseBuffer[key]);
	    };
	    if(!LIBRARY)ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2))
	    , $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if(view.getInt8(0) || !view.getInt8(1))redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value){
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(10)
	  , core           = __webpack_require__(64)
	  , LIBRARY        = __webpack_require__(81)
	  , wksExt         = __webpack_require__(273)
	  , defineProperty = __webpack_require__(21).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(108)
	  , ITERATOR  = __webpack_require__(16)('iterator')
	  , Iterators = __webpack_require__(97);
	module.exports = __webpack_require__(64).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(95)
	  , step             = __webpack_require__(261)
	  , Iterators        = __webpack_require__(97)
	  , toIObject        = __webpack_require__(41);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(178)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 194 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(843);
	var GetIntrinsic = __webpack_require__(298);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ },
/* 196 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 197 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 198 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 199 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(42)
	  , createDesc = __webpack_require__(202);
	module.exports = __webpack_require__(140) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 202 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(200);

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(296);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(101);
	
	var _DOMUtils = __webpack_require__(146);
	
	var _DOMStateStorage = __webpack_require__(301);
	
	var _PathUtils = __webpack_require__(75);
	
	var _ExecutionEnvironment = __webpack_require__(206);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 206 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(895);
	
	var _PathUtils = __webpack_require__(75);
	
	var _runTransitionHook = __webpack_require__(208);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(145);
	
	var _LocationUtils = __webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 209 */
/***/ function(module, exports) {

	module.exports = isPromise;
	module.exports.default = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(979),
	    mapCacheDelete = __webpack_require__(980),
	    mapCacheGet = __webpack_require__(981),
	    mapCacheHas = __webpack_require__(982),
	    mapCacheSet = __webpack_require__(983);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(147),
	    stackClear = __webpack_require__(991),
	    stackDelete = __webpack_require__(992),
	    stackGet = __webpack_require__(993),
	    stackHas = __webpack_require__(994),
	    stackSet = __webpack_require__(995);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(307);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(331);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(918),
	    stubArray = __webpack_require__(340);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(46),
	    isSymbol = __webpack_require__(154);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 217 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 218 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(316),
	    castFunction = __webpack_require__(320);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(53),
	    stubFalse = __webpack_require__(1006);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)(module)))

/***/ },
/* 221 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    getPrototype = __webpack_require__(214),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(480);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(479);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1124);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1123);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 226 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(60);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(60);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(119);
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _getRouteParams = __webpack_require__(1135);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(227);
	
	var _RouteUtils = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(495);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(1147);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Symbol key that carries API call info interpreted by this Redux middleware.
	 *
	 * @constant {symbol}
	 * @access public
	 * @default
	 */
	'use strict';
	
	var _Symbol = __webpack_require__(281)['default'];
	
	exports.__esModule = true;
	var CALL_API = _Symbol('Call API');
	
	exports['default'] = CALL_API;
	module.exports = exports['default'];

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Error class for an RSAA that does not conform to the RSAA definition
	 *
	 * @class InvalidRSAA
	 * @access public
	 * @param {array} validationErrors - an array of validation errors
	 */
	'use strict';
	
	var _inherits = __webpack_require__(840)['default'];
	
	var _classCallCheck = __webpack_require__(839)['default'];
	
	exports.__esModule = true;
	
	var InvalidRSAA = (function (_Error) {
	  _inherits(InvalidRSAA, _Error);
	
	  function InvalidRSAA(validationErrors) {
	    _classCallCheck(this, InvalidRSAA);
	
	    _Error.call(this);
	    this.name = 'InvalidRSAA';
	    this.message = 'Invalid RSAA';
	    this.validationErrors = validationErrors;
	  }
	
	  /**
	   * Error class for a custom `payload` or `meta` function throwing
	   *
	   * @class InternalError
	   * @access public
	   * @param {string} message - the error message
	   */
	  return InvalidRSAA;
	})(Error);
	
	var InternalError = (function (_Error2) {
	  _inherits(InternalError, _Error2);
	
	  function InternalError(message) {
	    _classCallCheck(this, InternalError);
	
	    _Error2.call(this);
	    this.name = 'InternalError';
	    this.message = message;
	  }
	
	  /**
	   * Error class for an error raised trying to make an API call
	   *
	   * @class RequestError
	   * @access public
	   * @param {string} message - the error message
	   */
	  return InternalError;
	})(Error);
	
	var RequestError = (function (_Error3) {
	  _inherits(RequestError, _Error3);
	
	  function RequestError(message) {
	    _classCallCheck(this, RequestError);
	
	    _Error3.call(this);
	    this.name = 'RequestError';
	    this.message = message;
	  }
	
	  /**
	   * Error class for an API response outside the 200 range
	   *
	   * @class ApiError
	   * @access public
	   * @param {number} status - the status code of the API response
	   * @param {string} statusText - the status text of the API response
	   * @param {object} response - the parsed JSON response of the API server if the
	   *  'Content-Type' header signals a JSON response
	   */
	  return RequestError;
	})(Error);
	
	var ApiError = (function (_Error4) {
	  _inherits(ApiError, _Error4);
	
	  function ApiError(status, statusText, response) {
	    _classCallCheck(this, ApiError);
	
	    _Error4.call(this);
	    this.name = 'ApiError';
	    this.status = status;
	    this.statusText = statusText;
	    this.response = response;
	    this.message = status + ' - ' + statusText;
	  }
	
	  return ApiError;
	})(Error);
	
	exports.InvalidRSAA = InvalidRSAA;
	exports.InternalError = InternalError;
	exports.RequestError = RequestError;
	exports.ApiError = ApiError;

/***/ },
/* 234 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var ADD_ARRAY_VALUE = exports.ADD_ARRAY_VALUE = 'redux-form/ADD_ARRAY_VALUE';
	var AUTOFILL = exports.AUTOFILL = 'redux-form/AUTOFILL';
	var BLUR = exports.BLUR = 'redux-form/BLUR';
	var CHANGE = exports.CHANGE = 'redux-form/CHANGE';
	var DESTROY = exports.DESTROY = 'redux-form/DESTROY';
	var FOCUS = exports.FOCUS = 'redux-form/FOCUS';
	var INITIALIZE = exports.INITIALIZE = 'redux-form/INITIALIZE';
	var REMOVE_ARRAY_VALUE = exports.REMOVE_ARRAY_VALUE = 'redux-form/REMOVE_ARRAY_VALUE';
	var RESET = exports.RESET = 'redux-form/RESET';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = 'redux-form/START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = 'redux-form/START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = 'redux-form/STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = 'redux-form/STOP_SUBMIT';
	var SUBMIT_FAILED = exports.SUBMIT_FAILED = 'redux-form/SUBMIT_FAILED';
	var SWAP_ARRAY_VALUES = exports.SWAP_ARRAY_VALUES = 'redux-form/SWAP_ARRAY_VALUES';
	var TOUCH = exports.TOUCH = 'redux-form/TOUCH';
	var UNTOUCH = exports.UNTOUCH = 'redux-form/UNTOUCH';

/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = mapValues;
	/**
	 * Maps all the values in the given object through the given function and saves them, by key, to a result object
	 */
	function mapValues(obj, fn) {
	  return obj ? Object.keys(obj).reduce(function (accumulator, key) {
	    var _extends2;
	
	    return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = fn(obj[key], key), _extends2));
	  }, {}) : obj;
	}

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initialState = exports.globalErrorKey = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _initialState, _behaviors;
	
	var _actionTypes = __webpack_require__(234);
	
	var _mapValues = __webpack_require__(235);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _read = __webpack_require__(512);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _write = __webpack_require__(513);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValuesFromState = __webpack_require__(508);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	var _initializeState = __webpack_require__(510);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	var _resetState = __webpack_require__(1175);
	
	var _resetState2 = _interopRequireDefault(_resetState);
	
	var _setErrors = __webpack_require__(1176);
	
	var _setErrors2 = _interopRequireDefault(_setErrors);
	
	var _fieldValue = __webpack_require__(105);
	
	var _normalizeFields = __webpack_require__(1171);
	
	var _normalizeFields2 = _interopRequireDefault(_normalizeFields);
	
	var _createInitialState = __webpack_require__(501);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var globalErrorKey = exports.globalErrorKey = '_error';
	
	var initialState = exports.initialState = (_initialState = {
	  _active: undefined,
	  _asyncValidating: false
	}, _initialState[globalErrorKey] = undefined, _initialState._initialized = false, _initialState._submitting = false, _initialState._submitFailed = false, _initialState);
	
	var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ADD_ARRAY_VALUE] = function (state, _ref) {
	  var path = _ref.path,
	      index = _ref.index,
	      value = _ref.value,
	      fields = _ref.fields;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var newValue = value !== null && typeof value === 'object' ? (0, _initializeState2.default)(value, fields || Object.keys(value)) : (0, _fieldValue.makeFieldValue)({ value: value });
	  if (index === undefined) {
	    arrayCopy.push(newValue);
	  } else {
	    arrayCopy.splice(index, 0, newValue);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref2) {
	  var field = _ref2.field,
	      value = _ref2.value;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value$autof = _extends({}, previous, { value: value, autofilled: true }),
	        asyncError = _previous$value$autof.asyncError,
	        submitError = _previous$value$autof.submitError,
	        result = _objectWithoutProperties(_previous$value$autof, ['asyncError', 'submitError']);
	
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.BLUR] = function (state, _ref3) {
	  var field = _ref3.field,
	      value = _ref3.value,
	      touch = _ref3.touch;
	
	  var _active = state._active,
	      stateCopy = _objectWithoutProperties(state, ['_active']);
	
	  if (_active && _active !== field) {
	    // remove _active from state
	    stateCopy._active = _active;
	  }
	  return (0, _write2.default)(field, function (previous) {
	    var result = _extends({}, previous);
	    if (value !== undefined) {
	      result.value = value;
	    }
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, stateCopy);
	}, _behaviors[_actionTypes.CHANGE] = function (state, _ref4) {
	  var field = _ref4.field,
	      value = _ref4.value,
	      touch = _ref4.touch;
	
	  return (0, _write2.default)(field, function (previous) {
	    var _previous$value = _extends({}, previous, { value: value }),
	        asyncError = _previous$value.asyncError,
	        submitError = _previous$value.submitError,
	        autofilled = _previous$value.autofilled,
	        result = _objectWithoutProperties(_previous$value, ['asyncError', 'submitError', 'autofilled']);
	
	    if (touch) {
	      result.touched = true;
	    }
	    return (0, _fieldValue.makeFieldValue)(result);
	  }, state);
	}, _behaviors[_actionTypes.DESTROY] = function () {
	  return undefined;
	}, _behaviors[_actionTypes.FOCUS] = function (state, _ref5) {
	  var field = _ref5.field;
	
	  var stateCopy = (0, _write2.default)(field, function (previous) {
	    return (0, _fieldValue.makeFieldValue)(_extends({}, previous, { visited: true }));
	  }, state);
	  stateCopy._active = field;
	  return stateCopy;
	}, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref6) {
	  var data = _ref6.data,
	      fields = _ref6.fields,
	      overwriteValues = _ref6.overwriteValues;
	
	  return (0, _createInitialState2.default)(data, fields, state, overwriteValues);
	}, _behaviors[_actionTypes.REMOVE_ARRAY_VALUE] = function (state, _ref7) {
	  var path = _ref7.path,
	      indexOfValue = _ref7.index,
	      predicate = _ref7.predicate;
	
	  var array = (0, _read2.default)(path, state);
	  var stateCopy = _extends({}, state);
	  var arrayCopy = array ? [].concat(array) : [];
	  var index = void 0;
	
	  if (predicate) {
	    index = arrayCopy.findIndex(predicate);
	  } else {
	    index = indexOfValue;
	  }
	
	  if (index === undefined) {
	    arrayCopy.pop();
	  } else if (isNaN(index)) {
	    delete arrayCopy[index];
	  } else {
	    arrayCopy.splice(index, 1);
	  }
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.RESET] = function (state) {
	  var _extends2;
	
	  return _extends({}, (0, _resetState2.default)(state), (_extends2 = {
	    _active: undefined,
	    _asyncValidating: false
	  }, _extends2[globalErrorKey] = undefined, _extends2._initialized = state._initialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	}, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref8) {
	  var field = _ref8.field;
	
	  return _extends({}, state, {
	    _asyncValidating: field || true
	  });
	}, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	  return _extends({}, state, {
	    _submitting: true
	  });
	}, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref9) {
	  var _extends3;
	
	  var errors = _ref9.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'asyncError'), (_extends3 = {
	    _asyncValidating: false
	  }, _extends3[globalErrorKey] = errors && errors[globalErrorKey], _extends3));
	}, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref10) {
	  var _extends4;
	
	  var errors = _ref10.errors;
	
	  return _extends({}, (0, _setErrors2.default)(state, errors, 'submitError'), (_extends4 = {}, _extends4[globalErrorKey] = errors && errors[globalErrorKey], _extends4._submitting = false, _extends4._submitFailed = !!(errors && Object.keys(errors).length), _extends4));
	}, _behaviors[_actionTypes.SUBMIT_FAILED] = function (state) {
	  return _extends({}, state, {
	    _submitFailed: true
	  });
	}, _behaviors[_actionTypes.SWAP_ARRAY_VALUES] = function (state, _ref11) {
	  var path = _ref11.path,
	      indexA = _ref11.indexA,
	      indexB = _ref11.indexB;
	
	  var array = (0, _read2.default)(path, state);
	  var arrayLength = array.length;
	  if (indexA === indexB || isNaN(indexA) || isNaN(indexB) || indexA >= arrayLength || indexB >= arrayLength) {
	    return state; // do nothing
	  }
	  var stateCopy = _extends({}, state);
	  var arrayCopy = [].concat(array);
	  arrayCopy[indexA] = array[indexB];
	  arrayCopy[indexB] = array[indexA];
	  return (0, _write2.default)(path, arrayCopy, stateCopy);
	}, _behaviors[_actionTypes.TOUCH] = function (state, _ref12) {
	  var fields = _ref12.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      return (0, _fieldValue.makeFieldValue)(_extends({}, value, { touched: true }));
	    }, accumulator);
	  }, state));
	}, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref13) {
	  var fields = _ref13.fields;
	
	  return _extends({}, state, fields.reduce(function (accumulator, field) {
	    return (0, _write2.default)(field, function (value) {
	      if (value) {
	        var touched = value.touched,
	            rest = _objectWithoutProperties(value, ['touched']);
	
	        return (0, _fieldValue.makeFieldValue)(rest);
	      }
	      return (0, _fieldValue.makeFieldValue)(value);
	    }, accumulator);
	  }, state));
	}, _behaviors);
	
	var reducer = function reducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var behavior = behaviors[action.type];
	  return behavior ? behavior(state, action) : state;
	};
	
	function formReducer() {
	  var _extends10;
	
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var form = action.form,
	      key = action.key,
	      rest = _objectWithoutProperties(action, ['form', 'key']); // eslint-disable-line no-redeclare
	
	
	  if (!form) {
	    return state;
	  }
	  if (key) {
	    var _extends7, _extends8;
	
	    if (action.type === _actionTypes.DESTROY) {
	      var _extends6;
	
	      return _extends({}, state, (_extends6 = {}, _extends6[form] = state[form] && Object.keys(state[form]).reduce(function (accumulator, stateKey) {
	        var _extends5;
	
	        return stateKey === key ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[stateKey] = state[form][stateKey], _extends5));
	      }, {}), _extends6));
	    }
	    return _extends({}, state, (_extends8 = {}, _extends8[form] = _extends({}, state[form], (_extends7 = {}, _extends7[key] = reducer((state[form] || {})[key], rest), _extends7)), _extends8));
	  }
	  if (action.type === _actionTypes.DESTROY) {
	    return Object.keys(state).reduce(function (accumulator, formName) {
	      var _extends9;
	
	      return formName === form ? accumulator : _extends({}, accumulator, (_extends9 = {}, _extends9[formName] = state[formName], _extends9));
	    }, {});
	  }
	  return _extends({}, state, (_extends10 = {}, _extends10[form] = reducer(state[form], rest), _extends10));
	}
	
	/**
	 * Adds additional functionality to the reducer
	 */
	function decorate(target) {
	  target.plugin = function plugin(reducers) {
	    var _this = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(reducers, function (pluginReducer, key) {
	        return pluginReducer(result[key] || initialState, action);
	      }));
	    });
	  };
	
	  target.normalize = function normalize(normalizers) {
	    var _this2 = this;
	
	    // use 'function' keyword to enable 'this'
	    return decorate(function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var result = _this2(state, action);
	      return _extends({}, result, (0, _mapValues2.default)(normalizers, function (formNormalizers, form) {
	        var runNormalize = function runNormalize(previous, currentResult) {
	          var previousValues = (0, _getValuesFromState2.default)(_extends({}, initialState, previous));
	          var formResult = _extends({}, initialState, currentResult);
	          var values = (0, _getValuesFromState2.default)(formResult);
	          return (0, _normalizeFields2.default)(formNormalizers, formResult, previous, values, previousValues);
	        };
	        if (action.key) {
	          var _extends11;
	
	          return _extends({}, result[form], (_extends11 = {}, _extends11[action.key] = runNormalize(state[form][action.key], result[form][action.key]), _extends11));
	        }
	        return runNormalize(state[form], result[form]);
	      }));
	    });
	  };
	
	  return target;
	}
	
	exports.default = decorate(formReducer);

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(521);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isBeforeInputEventAvailable = exports.mergePlugins = exports.isTextareaOrInput = exports.uuid = exports.configHandlers = exports.configHandlers2 = exports.isFunction = void 0;
	var EditorPropTypes_1 = __webpack_require__(239);
	var isFunction = function (x) { return typeof x === 'function'; };
	exports.isFunction = isFunction;
	var isEventProp = function (name) { return name in EditorPropTypes_1.eventPropTypes; };
	var eventAttrToEventName = function (attrName) { return attrName.substr(2); };
	var configHandlers2 = function (handlerLookup, on, off, adapter, prevProps, props, boundHandlers) {
	    var prevEventKeys = Object.keys(prevProps).filter(isEventProp);
	    var currEventKeys = Object.keys(props).filter(isEventProp);
	    var removedKeys = prevEventKeys.filter(function (key) { return props[key] === undefined; });
	    var addedKeys = currEventKeys.filter(function (key) { return prevProps[key] === undefined; });
	    removedKeys.forEach(function (key) {
	        // remove event handler
	        var eventName = eventAttrToEventName(key);
	        var wrappedHandler = boundHandlers[eventName];
	        off(eventName, wrappedHandler);
	        delete boundHandlers[eventName];
	    });
	    addedKeys.forEach(function (key) {
	        var wrappedHandler = adapter(handlerLookup, key);
	        var eventName = eventAttrToEventName(key);
	        boundHandlers[eventName] = wrappedHandler;
	        on(eventName, wrappedHandler);
	    });
	};
	exports.configHandlers2 = configHandlers2;
	var configHandlers = function (editor, prevProps, props, boundHandlers, lookup) {
	    return exports.configHandlers2(lookup, editor.on.bind(editor), editor.off.bind(editor), function (handlerLookup, key) { return function (e) { var _a; return (_a = handlerLookup(key)) === null || _a === void 0 ? void 0 : _a(e, editor); }; }, prevProps, props, boundHandlers);
	};
	exports.configHandlers = configHandlers;
	var unique = 0;
	var uuid = function (prefix) {
	    var time = Date.now();
	    var random = Math.floor(Math.random() * 1000000000);
	    unique++;
	    return prefix + '_' + random + unique + String(time);
	};
	exports.uuid = uuid;
	var isTextareaOrInput = function (element) {
	    return element !== null && (element.tagName.toLowerCase() === 'textarea' || element.tagName.toLowerCase() === 'input');
	};
	exports.isTextareaOrInput = isTextareaOrInput;
	var normalizePluginArray = function (plugins) {
	    if (typeof plugins === 'undefined' || plugins === '') {
	        return [];
	    }
	    return Array.isArray(plugins) ? plugins : plugins.split(' ');
	};
	// eslint-disable-next-line max-len
	var mergePlugins = function (initPlugins, inputPlugins) { return normalizePluginArray(initPlugins).concat(normalizePluginArray(inputPlugins)); };
	exports.mergePlugins = mergePlugins;
	var isBeforeInputEventAvailable = function () { return window.InputEvent && typeof InputEvent.prototype.getTargetRanges === 'function'; };
	exports.isBeforeInputEventAvailable = isBeforeInputEventAvailable;


/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EditorPropTypes = exports.eventPropTypes = void 0;
	var PropTypes = __webpack_require__(528);
	exports.eventPropTypes = {
	    onActivate: PropTypes.func,
	    onAddUndo: PropTypes.func,
	    onBeforeAddUndo: PropTypes.func,
	    onBeforeExecCommand: PropTypes.func,
	    onBeforeGetContent: PropTypes.func,
	    onBeforeRenderUI: PropTypes.func,
	    onBeforeSetContent: PropTypes.func,
	    onBeforePaste: PropTypes.func,
	    onBlur: PropTypes.func,
	    onChange: PropTypes.func,
	    onClearUndos: PropTypes.func,
	    onClick: PropTypes.func,
	    onContextMenu: PropTypes.func,
	    onCopy: PropTypes.func,
	    onCut: PropTypes.func,
	    onDblclick: PropTypes.func,
	    onDeactivate: PropTypes.func,
	    onDirty: PropTypes.func,
	    onDrag: PropTypes.func,
	    onDragDrop: PropTypes.func,
	    onDragEnd: PropTypes.func,
	    onDragGesture: PropTypes.func,
	    onDragOver: PropTypes.func,
	    onDrop: PropTypes.func,
	    onExecCommand: PropTypes.func,
	    onFocus: PropTypes.func,
	    onFocusIn: PropTypes.func,
	    onFocusOut: PropTypes.func,
	    onGetContent: PropTypes.func,
	    onHide: PropTypes.func,
	    onInit: PropTypes.func,
	    onKeyDown: PropTypes.func,
	    onKeyPress: PropTypes.func,
	    onKeyUp: PropTypes.func,
	    onLoadContent: PropTypes.func,
	    onMouseDown: PropTypes.func,
	    onMouseEnter: PropTypes.func,
	    onMouseLeave: PropTypes.func,
	    onMouseMove: PropTypes.func,
	    onMouseOut: PropTypes.func,
	    onMouseOver: PropTypes.func,
	    onMouseUp: PropTypes.func,
	    onNodeChange: PropTypes.func,
	    onObjectResizeStart: PropTypes.func,
	    onObjectResized: PropTypes.func,
	    onObjectSelected: PropTypes.func,
	    onPaste: PropTypes.func,
	    onPostProcess: PropTypes.func,
	    onPostRender: PropTypes.func,
	    onPreProcess: PropTypes.func,
	    onProgressState: PropTypes.func,
	    onRedo: PropTypes.func,
	    onRemove: PropTypes.func,
	    onReset: PropTypes.func,
	    onSaveContent: PropTypes.func,
	    onSelectionChange: PropTypes.func,
	    onSetAttrib: PropTypes.func,
	    onSetContent: PropTypes.func,
	    onShow: PropTypes.func,
	    onSubmit: PropTypes.func,
	    onUndo: PropTypes.func,
	    onVisualAid: PropTypes.func
	};
	exports.EditorPropTypes = __assign({ apiKey: PropTypes.string, id: PropTypes.string, inline: PropTypes.bool, init: PropTypes.object, initialValue: PropTypes.string, onEditorChange: PropTypes.func, outputFormat: PropTypes.oneOf(['html', 'text']), value: PropTypes.string, tagName: PropTypes.string, cloudChannel: PropTypes.string, plugins: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), toolbar: PropTypes.oneOfType([PropTypes.string, PropTypes.array]), disabled: PropTypes.bool, textareaName: PropTypes.string, tinymceScriptSrc: PropTypes.string, scriptLoading: PropTypes.shape({
	        async: PropTypes.bool,
	        defer: PropTypes.bool,
	        delay: PropTypes.number
	    }) }, exports.eventPropTypes);


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandableContent = function (_Component) {
	    _inherits(ExpandableContent, _Component);
	
	    function ExpandableContent() {
	        _classCallCheck(this, ExpandableContent);
	
	        return _possibleConstructorReturn(this, (ExpandableContent.__proto__ || Object.getPrototypeOf(ExpandableContent)).apply(this, arguments));
	    }
	
	    _createClass(ExpandableContent, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                "div",
	                { className: "expandable-content" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "header-section" },
	                    this.props.title
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "content-section" },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return ExpandableContent;
	}(_react.Component);
	
	exports.default = ExpandableContent;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Paginator = function (_Component) {
	    _inherits(Paginator, _Component);
	
	    function Paginator(props) {
	        _classCallCheck(this, Paginator);
	
	        var _this = _possibleConstructorReturn(this, (Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call(this, props));
	
	        _this.state = {
	            pageRangeDisplayed: 5,
	            marginPagesDisplayed: 5
	        };
	        return _this;
	    }
	
	    _createClass(Paginator, [{
	        key: 'getPaginationItems',
	        value: function getPaginationItems() {
	            var items = [];
	            var selected = this.props.currentPage;
	            var pageCount = this.props.totalPages;
	            var pageRangeDisplayed = this.state.pageRangeDisplayed;
	
	            if (pageCount <= pageRangeDisplayed) {
	                for (var i = 0; i < pageCount; i++) {
	                    var page = i + 1;
	                    items['key' + i] = page;
	                }
	            } else {
	                var leftSide = pageRangeDisplayed / 2,
	                    rightSide = pageRangeDisplayed - leftSide;
	
	                if (selected > pageCount - pageRangeDisplayed / 2) {
	                    rightSide = pageCount - selected;
	                    leftSide = pageRangeDisplayed - rightSide;
	                } else if (selected < pageRangeDisplayed / 2) {
	                    leftSide = selected;
	                    rightSide = pageRangeDisplayed - leftSide;
	                }
	
	                var index = void 0,
	                    _page = void 0,
	                    breakView = void 0;
	
	                for (index = 0; index < pageCount; index++) {
	                    _page = index + 1;
	                    var pageView = _page;
	
	                    if (_page <= this.state.marginPagesDisplayed) {
	                        items['key' + index] = pageView;
	                        continue;
	                    }
	
	                    if (_page > pageCount - this.state.marginPagesDisplayed) {
	                        items['key' + index] = pageView;
	                        continue;
	                    }
	                    if (index >= selected - leftSide && index <= selected + rightSide) {
	                        items['key' + index] = pageView;
	                        continue;
	                    }
	
	                    var keys = Object.keys(items),
	                        breakLabelKey = keys[keys.length - 1],
	                        breakLabelValue = items[breakLabelKey];
	
	                    if (breakLabelValue !== breakView) {
	                        breakView = 'BREAK';
	                        items['key' + index] = breakView;
	                    }
	                }
	            }
	
	            return items;
	        }
	    }, {
	        key: 'getUrlForPage',
	        value: function getUrlForPage(page) {
	            var baseUrl = this.props.baseUrl;
	
	            if (page) {
	                return baseUrl + '/page/' + page;
	            }
	            return baseUrl;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                currentPage = _props.currentPage,
	                paginationAction = _props.paginationAction;
	
	            var items = this.getPaginationItems();
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'paginator' },
	                    Object.keys(items).map(function (key) {
	                        var page = items[key];
	                        if (page === 'BREAK') {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: 'page-' + page + '-' + key },
	                                _react2.default.createElement(
	                                    'a',
	                                    null,
	                                    '...'
	                                )
	                            );
	                        }
	                        return _react2.default.createElement(
	                            'li',
	                            { key: 'page-' + page, className: (0, _classnames2.default)({
	                                    'active': page - 1 === currentPage
	                                }) },
	                            paginationAction ? _react2.default.createElement(
	                                'a',
	                                { onClick: function onClick() {
	                                        paginationAction({
	                                            page: page - 1
	                                        });
	                                    } },
	                                page
	                            ) : _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: _this2.getUrlForPage(page - 1) },
	                                page
	                            )
	                        );
	                    })
	                ),
	                _react2.default.createElement('div', null)
	            );
	        }
	    }]);
	
	    return Paginator;
	}(_react.Component);
	
	exports.default = Paginator;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _dateField = __webpack_require__(93);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _genderField = __webpack_require__(542);
	
	var _genderField2 = _interopRequireDefault(_genderField);
	
	var _distanceSelect = __webpack_require__(247);
	
	var _distanceSelect2 = _interopRequireDefault(_distanceSelect);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _languageCookie = __webpack_require__(43);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _countries = __webpack_require__(642);
	
	var _shirtField = __webpack_require__(543);
	
	var _shirtField2 = _interopRequireDefault(_shirtField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'first_name', 'last_name', 'birth_date', 'phone', 'friend_phone', 'city', 'club', 'email', 'gender', 'stageId', 'distanceId', 'createdAt', 'payed', 'payment', 'uuid', 'agree_on_regulations', 'medical_confirmation', 'participate_in_insurance', 'marketing_email', 'country', 'gdpr_confirmation', 'promo_code', 'related_participant_identifier', 'extra_info', 'billing_is_company', 'billing_name', 'billing_email', 'billing_company_code', 'billing_company_vat', 'billing_company_address', 'team_participants[].first_name', 'team_participants[].last_name', 'team_participants[].gender', 'team_name', 'shirt_size', 'custom_field'];
	
	function validate(values, formInstance) {
	
	  var errors = {
	    _error: null
	  };
	  errors = (0, _form.validateRequiredFields)(values, ['first_name', 'last_name', 'birth_date', 'phone', 'email', 'distanceId', 'stageId', 'gender', 'agree_on_regulations', 'medical_confirmation', 'gdpr_confirmation'], errors);
	
	  if (window.CARE_CONFIG.invoicesEnabled && !values.id) {
	
	    errors = (0, _form.validateRequiredFields)(values, ['billing_name', 'billing_email'], errors);
	    errors = (0, _form.validateEmail)(values, 'billing_email', errors);
	  }
	  if (window.CARE_CONFIG.customParticipantField && window.CARE_CONFIG.customParticipantField.required) {
	    errors = (0, _form.validateRequiredFields)(values, ['custom_field'], errors);
	  }
	
	  var selectedStage = formInstance.stages.find(function (stage) {
	    return stage.id === formInstance.form.stageId.value;
	  });
	  var selectedDistance = selectedStage ? selectedStage.distances.find(function (distance) {
	    return distance.id === formInstance.form.distanceId.value;
	  }) : null;
	
	  if (selectedStage && selectedStage.display_extra_info_field && selectedStage.extra_info_field_required) {
	    errors = (0, _form.validateRequiredFields)(values, ['extra_info'], errors);
	  }
	
	  if (selectedDistance && selectedDistance.is_team_distance) {
	    if (!values.team_name) {
	      errors.team_name = _strings2.default.requiredField;
	    }
	    if (values.team_participants.length < window.CARE_CONFIG.registrationValidations.minTeamMembers) {
	      errors.team_name = _strings2.default.minTeamMembers + ' ' + window.CARE_CONFIG.registrationValidations.minTeamMembers;
	    }
	    if (values.team_participants) {
	      var teamParticipantsErrors = [];
	
	      values.team_participants.forEach(function (teamParticipant, index) {
	        var participantErrors = {};
	        if (!teamParticipant.first_name) {
	          participantErrors['first_name'] = _strings2.default.requiredField;
	        }
	        if (!teamParticipant.last_name) {
	          participantErrors['last_name'] = _strings2.default.requiredField;
	        }
	        if (!teamParticipant.gender) {
	          participantErrors['gender'] = _strings2.default.requiredField;
	        }
	        teamParticipantsErrors[index] = participantErrors;
	      });
	      if (teamParticipantsErrors.length > 0) {
	        errors.team_participants = teamParticipantsErrors;
	      }
	    }
	  }
	
	  errors = (0, _form.validateEmail)(values, 'email', errors);
	  errors = (0, _form.validateDate)(values, 'birth_date', errors);
	
	  return errors;
	}
	
	var ParticipantForm = function (_BaseForm) {
	  _inherits(ParticipantForm, _BaseForm);
	
	  function ParticipantForm(props) {
	    _classCallCheck(this, ParticipantForm);
	
	    var _this = _possibleConstructorReturn(this, (ParticipantForm.__proto__ || Object.getPrototypeOf(ParticipantForm)).call(this, props));
	
	    _this.state = {
	      price: null,
	      calculating: false
	    };
	    return _this;
	  }
	
	  _createClass(ParticipantForm, [{
	    key: 'showAlert',
	    value: function showAlert() {
	      var _props$showAlert = this.props.showAlert,
	          showAlert = _props$showAlert === undefined ? true : _props$showAlert;
	
	
	      return showAlert;
	    }
	  }, {
	    key: 'calculatePrice',
	    value: function calculatePrice() {
	      var _this2 = this;
	
	      var _props$values = this.props.values,
	          stageId = _props$values.stageId,
	          distanceId = _props$values.distanceId,
	          birth_date = _props$values.birth_date,
	          createdAt = _props$values.createdAt,
	          promo_code = _props$values.promo_code;
	
	
	      if (birth_date) {
	        birth_date = (0, _moment2.default)(birth_date).format('YYYY-MM-DD');
	      }
	      if (createdAt) {
	        createdAt = (0, _moment2.default)(createdAt).format('YYYY-MM-DD');
	      }
	
	      if (distanceId && birth_date && stageId) {
	        this.setState({ calculating: true });
	        fetch('/api/participant/calculate-price?distanceId=' + (distanceId ? distanceId : '') + '&stageId=' + (stageId ? stageId : '') + '&birth_date=' + (birth_date ? birth_date : '') + '&created_at=' + (createdAt ? createdAt : '') + '&promo=' + (promo_code ? promo_code : '')).then(function (response) {
	          if (response.status >= 200 && response.status < 300) {
	            return response.json();
	          } else {
	            return Promise.reject(response);
	          }
	        }).then(function (response) {
	          _this2.setState({ price: response.price, calculating: false });
	        }).catch(function (resp) {
	          resp.json().then(function (response) {
	            if (response.errors) {
	              alert(response.errors);
	            }
	          });
	        });
	      }
	    }
	  }, {
	    key: 'getInsuranceLabel',
	    value: function getInsuranceLabel() {
	      return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.insurance_text_in_registration_en : window.CARE_CONFIG.settings.insurance_text_in_registration;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var _props$values2 = this.props.values,
	          stageId = _props$values2.stageId,
	          distanceId = _props$values2.distanceId,
	          birth_date = _props$values2.birth_date,
	          promo_code = _props$values2.promo_code;
	
	      if (prevProps.values.stageId !== stageId || prevProps.values.distanceId !== distanceId || prevProps.values.birth_date !== birth_date || prevProps.values.promo_code !== promo_code) {
	        this.calculatePrice();
	      }
	    }
	  }, {
	    key: 'renderCustomField',
	    value: function renderCustomField(field) {
	      var fieldUI = void 0;
	      var fieldConfig = window.CARE_CONFIG.customParticipantField;
	      if (fieldConfig.type === 'select') {
	        fieldUI = _react2.default.createElement(_select2.default, _extends({ clearable: false, options: fieldConfig.values, noResultsText: '', placeholder: '' }, field, {
	          onChange: function onChange(item) {
	            return field.onChange(item.value);
	          } }));
	      }
	      if (fieldConfig.type === 'text') {
	        fieldUI = _react2.default.createElement('input', _extends({ ref: 'name', placeholder: fieldConfig.label, type: 'text' }, field));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-row-new' },
	        _react2.default.createElement(
	          _formField2.default,
	          { label: fieldConfig.label, name: 'gender', field: field },
	          fieldUI
	        )
	      );
	    }
	  }, {
	    key: 'updateInvoiceProperty',
	    value: function updateInvoiceProperty(changedProperty) {
	      var _props$fields = this.props.fields,
	          first_name = _props$fields.first_name,
	          last_name = _props$fields.last_name,
	          email = _props$fields.email,
	          billing_name = _props$fields.billing_name,
	          billing_email = _props$fields.billing_email;
	
	      if (['first_name', 'last_name'].includes(changedProperty)) {
	        billing_name.onChange(first_name.value + ' ' + last_name.value);
	      }
	      if (changedProperty === 'email') {
	        billing_email.onChange(email.value);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          stages = _props.stages,
	          submitting = _props.submitting,
	          error = _props.error,
	          handleSubmit = _props.handleSubmit,
	          _props$disableStageSe = _props.disableStageSelect,
	          disableStageSelect = _props$disableStageSe === undefined ? false : _props$disableStageSe,
	          _props$displayPayed = _props.displayPayed,
	          displayPayed = _props$displayPayed === undefined ? false : _props$displayPayed,
	          _props$fields2 = _props.fields,
	          first_name = _props$fields2.first_name,
	          last_name = _props$fields2.last_name,
	          birth_date = _props$fields2.birth_date,
	          phone = _props$fields2.phone,
	          friend_phone = _props$fields2.friend_phone,
	          city = _props$fields2.city,
	          club = _props$fields2.club,
	          email = _props$fields2.email,
	          gender = _props$fields2.gender,
	          stageId = _props$fields2.stageId,
	          distanceId = _props$fields2.distanceId,
	          payed = _props$fields2.payed,
	          agree_on_regulations = _props$fields2.agree_on_regulations,
	          medical_confirmation = _props$fields2.medical_confirmation,
	          participate_in_insurance = _props$fields2.participate_in_insurance,
	          marketing_email = _props$fields2.marketing_email,
	          country = _props$fields2.country,
	          gdpr_confirmation = _props$fields2.gdpr_confirmation,
	          promo_code = _props$fields2.promo_code,
	          related_participant_identifier = _props$fields2.related_participant_identifier,
	          billing_is_company = _props$fields2.billing_is_company,
	          billing_name = _props$fields2.billing_name,
	          billing_email = _props$fields2.billing_email,
	          billing_company_code = _props$fields2.billing_company_code,
	          billing_company_vat = _props$fields2.billing_company_vat,
	          billing_company_address = _props$fields2.billing_company_address,
	          team_participants = _props$fields2.team_participants,
	          team_name = _props$fields2.team_name,
	          extra_info = _props$fields2.extra_info,
	          custom_field = _props$fields2.custom_field,
	          shirt_size = _props$fields2.shirt_size;
	      var _props$values3 = this.props.values,
	          id = _props$values3.id,
	          payment = _props$values3.payment;
	      var price = this.state.price;
	
	      var selectedStage = stages.find(function (stage) {
	        return stage.id === stageId.value;
	      });
	      var isBillingDisabled = id !== null && id !== undefined;
	      var selectedDistance = selectedStage ? selectedStage.distances.find(function (distance) {
	        return distance.id === distanceId.value;
	      }) : null;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submit.bind(this)) },
	          error && _react2.default.createElement(
	            _alert2.default,
	            { type: 'error' },
	            error
	          ),
	          related_participant_identifier.value && _react2.default.createElement(
	            'div',
	            null,
	            _strings2.default.seasonPersonIdentifier,
	            ': ',
	            related_participant_identifier.value
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'distance-price-row' },
	            _react2.default.createElement(_distanceSelect2.default, { stageField: stageId, distanceField: distanceId,
	              disableStageSelect: disableStageSelect }),
	            _react2.default.createElement(
	              'div',
	              { className: 'price-display' },
	              _react2.default.createElement(
	                'span',
	                { className: 'price-title' },
	                _strings2.default.price,
	                ':'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'amount-display' },
	                price !== null ? price : payment ? payment.price : 0
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'legend',
	              null,
	              _strings2.default.participantLegendTitle
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row-new' },
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.firstName, name: 'name', field: first_name },
	                _react2.default.createElement('input', _extends({ ref: 'name', placeholder: _strings2.default.firstName, type: 'text' }, first_name, { onBlur: function onBlur() {
	                    first_name.onBlur();
	                    if (!isBillingDisabled) {
	                      _this3.updateInvoiceProperty('first_name');
	                    }
	                  } }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.lastName, name: 'last_name', field: last_name },
	                _react2.default.createElement('input', _extends({ ref: 'last_name', placeholder: _strings2.default.lastName, type: 'text' }, last_name, {
	                  onBlur: function onBlur() {
	                    last_name.onBlur();
	                    if (!isBillingDisabled) {
	                      _this3.updateInvoiceProperty('last_name');
	                    }
	                  }
	                }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.gender, name: 'gender', field: gender },
	                _react2.default.createElement(_genderField2.default, { field: gender })
	              ),
	              selectedDistance && selectedDistance.enable_shirt_selection ? _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.shirtSize, name: 'shirt_size', field: shirt_size },
	                _react2.default.createElement(_shirtField2.default, { field: shirt_size })
	              ) : null
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row-new' },
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.birthDate, name: 'birth_date', field: birth_date },
	                _react2.default.createElement(_dateField2.default, _extends({}, birth_date, { timeFormat: false, noTimeZoneDate: true,
	                  viewMode: 'years' }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.email, name: 'email', field: email },
	                _react2.default.createElement('input', _extends({ ref: 'email', placeholder: _strings2.default.email, type: 'text' }, email, {
	                  onBlur: function onBlur() {
	                    last_name.onBlur();
	                    if (!isBillingDisabled) {
	                      _this3.updateInvoiceProperty('email');
	                    }
	                  }
	                }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.phone, name: 'phone', field: phone },
	                _react2.default.createElement('input', _extends({ ref: 'phone', placeholder: _strings2.default.phone, type: 'text' }, phone))
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row-new' },
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.friendPhone, name: 'friend_phone', field: friend_phone },
	                _react2.default.createElement('input', _extends({ ref: 'friend_phone', placeholder: _strings2.default.friendPhone, type: 'text' }, friend_phone))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.city, name: 'city', field: city },
	                _react2.default.createElement('input', _extends({ ref: 'city', placeholder: _strings2.default.city, type: 'text' }, city))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.club, name: 'club', field: club },
	                _react2.default.createElement('input', _extends({ ref: 'club', placeholder: _strings2.default.club, type: 'text' }, club))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.country, name: 'country', field: country },
	                window.CARE_CONFIG.countrySelectionEnabled ? _react2.default.createElement(_select2.default, _extends({}, country, { clearable: false, options: (0, _countries.getCountries)(),
	                  placeholder: _strings2.default.country, onChange: function onChange(item) {
	                    return country.onChange(item.value);
	                  } })) : _react2.default.createElement('input', _extends({ ref: 'country', placeholder: _strings2.default.country, type: 'text' }, country))
	              )
	            ),
	            window.CARE_CONFIG.customParticipantField && this.renderCustomField(custom_field)
	          ),
	          selectedDistance && selectedDistance.is_team_distance && _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'legend',
	              null,
	              _strings2.default.teamInfo
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row-new' },
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.teamName, name: 'team_name', field: team_name },
	                _react2.default.createElement('input', _extends({ ref: 'team_name', placeholder: _strings2.default.teamName, type: 'text' }, team_name))
	              )
	            ),
	            _react2.default.createElement(
	              'legend',
	              null,
	              _strings2.default.teamParticipants
	            ),
	            team_participants.map(function (teamParticipants, index) {
	              return _react2.default.createElement(
	                'div',
	                { className: 'form-row-new', key: index },
	                _react2.default.createElement(
	                  _formField2.default,
	                  { label: _strings2.default.firstName, name: 'name', field: teamParticipants.first_name },
	                  _react2.default.createElement('input', _extends({ ref: 'name', placeholder: _strings2.default.firstName,
	                    type: 'text' }, teamParticipants.first_name))
	                ),
	                _react2.default.createElement(
	                  _formField2.default,
	                  { label: _strings2.default.lastName, name: 'last_name', field: teamParticipants.last_name },
	                  _react2.default.createElement('input', _extends({ ref: 'last_name', placeholder: _strings2.default.lastName,
	                    type: 'text' }, teamParticipants.last_name))
	                ),
	                _react2.default.createElement(
	                  _formField2.default,
	                  { label: _strings2.default.gender, name: 'gender', field: teamParticipants.gender },
	                  _react2.default.createElement(_genderField2.default, { field: teamParticipants.gender })
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'button-col' },
	                  _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn-red', onClick: function onClick() {
	                        team_participants.removeField(index);
	                      } },
	                    _strings2.default.remove
	                  )
	                )
	              );
	            }),
	            _react2.default.createElement(
	              'a',
	              { className: 'btn m-top-10 m-bot-10', onClick: function onClick() {
	                  team_participants.addField();
	                } },
	              _react2.default.createElement('i', null),
	              ' ',
	              _strings2.default.addTeamMember
	            )
	          ),
	          window.CARE_CONFIG.invoicesEnabled && !isBillingDisabled && _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'legend',
	              null,
	              _strings2.default.paymentInfoLegend
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.billingIsCompony, name: 'billing_is_company', field: billing_is_company,
	                className: 'checkbox-field',
	                dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, billing_is_company, { disabled: isBillingDisabled }))
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'form-row-new' },
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.billingName, name: 'billing_name', field: billing_name },
	                _react2.default.createElement('input', _extends({ ref: 'billing_name', placeholder: _strings2.default.billingName, type: 'text' }, billing_name, {
	                  disabled: isBillingDisabled }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.billingEmail, name: 'billing_email', field: billing_email },
	                _react2.default.createElement('input', _extends({ ref: 'billing_email', placeholder: _strings2.default.billingEmail, type: 'text' }, billing_email, {
	                  disabled: isBillingDisabled }))
	              )
	            ),
	            billing_is_company.value && _react2.default.createElement(
	              'div',
	              { className: 'form-row-new' },
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.billingCompanyCode, name: 'billing_company_code',
	                  field: billing_company_code },
	                _react2.default.createElement('input', _extends({ ref: 'billing_company_code', placeholder: _strings2.default.billingCompanyCode,
	                  type: 'text' }, billing_company_code, { disabled: isBillingDisabled }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.billingVatCode, name: 'billing_company_vat',
	                  field: billing_company_vat },
	                _react2.default.createElement('input', _extends({ ref: 'billing_company_vat', placeholder: _strings2.default.billingVatCode,
	                  type: 'text' }, billing_company_vat, { disabled: isBillingDisabled }))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.billingAddress, name: 'billing_company_address',
	                  field: billing_company_address },
	                _react2.default.createElement('input', _extends({ ref: 'billing_company_address', placeholder: _strings2.default.billingAddress,
	                  type: 'text' }, billing_company_address, { disabled: isBillingDisabled }))
	              )
	            )
	          ),
	          window.CARE_CONFIG.discountEnabled && _react2.default.createElement(
	            'div',
	            { className: 'form-row-new' },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.promoCode, name: 'club', field: promo_code },
	              _react2.default.createElement('input', _extends({ ref: 'promo_code', placeholder: _strings2.default.promoCode, type: 'text' }, promo_code, {
	                disabled: id != null }))
	            )
	          ),
	          selectedStage && selectedStage.display_extra_info_field ? _react2.default.createElement(
	            'div',
	            { className: 'form-row-new' },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: selectedStage.extra_info_field_title, name: 'extra_info', field: extra_info },
	              _react2.default.createElement('input', _extends({ ref: 'title', placeholder: selectedStage.extra_info_field_title, type: 'text' }, extra_info))
	            )
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'form-row-new force-col' },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.gdprConfirmation, name: 'gdpr_confirmation',
	                field: gdpr_confirmation, className: 'checkbox-field', dots: false, link: '/gdpr' },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, gdpr_confirmation))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.agreeOnTerms, name: 'agree_on_regulations',
	                field: agree_on_regulations, className: 'checkbox-field',
	                link: '/stages/' + stageId.value + '/regulations', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, agree_on_regulations))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.medicalConfirmation, name: 'medical_confirmation',
	                field: medical_confirmation, className: 'checkbox-field', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, medical_confirmation))
	            ),
	            selectedStage && selectedStage.insurance_enabled ? _react2.default.createElement(
	              _formField2.default,
	              { label: this.getInsuranceLabel(), name: 'participate_in_insurance',
	                field: participate_in_insurance, className: 'checkbox-field', link: '/insurance',
	                dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, participate_in_insurance))
	            ) : null,
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.marketingEmailConfirmation, name: 'marketing_email',
	                field: marketing_email, className: 'checkbox-field', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, marketing_email))
	            )
	          ),
	          displayPayed ? _react2.default.createElement(
	            _formField2.default,
	            { label: _strings2.default.payed, name: 'payed', field: payed, className: 'checkbox-field',
	              dots: false },
	            _react2.default.createElement('input', _extends({ type: 'checkbox' }, payed))
	          ) : null,
	          _react2.default.createElement(
	            'div',
	            { className: 'actions-row' },
	            this.state.calculating ? _react2.default.createElement(
	              'div',
	              null,
	              _strings2.default.calculating
	            ) : _react2.default.createElement(
	              _button2.default,
	              { loading: submitting, submit: true, disabled: submitting, type: 'main-color' },
	              _strings2.default.submit
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ParticipantForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'participant-form',
	  fields: fields,
	  validate: validate,
	  destroyOnUnmount: true
	}, function (state) {
	  return {
	    initialValues: state.participant.participant,
	    stages: state.stage.availableStages.items
	  };
	})(ParticipantForm);

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _dateField = __webpack_require__(93);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['first_name', 'last_name', 'birth_date'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['first_name', 'last_name'], errors);
	    return errors;
	}
	
	var ParticipantResultHistoryForm = function (_BaseForm) {
	    _inherits(ParticipantResultHistoryForm, _BaseForm);
	
	    function ParticipantResultHistoryForm() {
	        _classCallCheck(this, ParticipantResultHistoryForm);
	
	        return _possibleConstructorReturn(this, (ParticipantResultHistoryForm.__proto__ || Object.getPrototypeOf(ParticipantResultHistoryForm)).apply(this, arguments));
	    }
	
	    _createClass(ParticipantResultHistoryForm, [{
	        key: 'showAlert',
	        value: function showAlert() {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                first_name = _props$fields.first_name,
	                last_name = _props$fields.last_name,
	                birth_date = _props$fields.birth_date;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'participant-result-history-form' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-row' },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.firstName, name: 'name', field: first_name },
	                            _react2.default.createElement('input', _extends({ ref: 'name', placeholder: _strings2.default.firstName, type: 'text' }, first_name))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.lastName, name: 'last_name', field: last_name },
	                            _react2.default.createElement('input', _extends({ ref: 'last_name', placeholder: _strings2.default.lastName, type: 'text' }, last_name))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.birthDate, name: 'birth_date', field: birth_date },
	                            _react2.default.createElement(_dateField2.default, _extends({}, birth_date, { timeFormat: false, noTimeZoneDate: true, viewMode: 'years' }))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'main-color' },
	                            _strings2.default.startSearch
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ParticipantResultHistoryForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'participant-result-history-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	})(ParticipantResultHistoryForm);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PartnersDisplay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _partnerDisplay = __webpack_require__(552);
	
	var _partnerDisplay2 = _interopRequireDefault(_partnerDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getCategoryPartners(catId, partners) {
	    return partners.filter(function (partner) {
	        return partner.partnerCategoryId === catId;
	    });
	}
	
	function buildPartnersPrintData(partners) {
	    var availableCategories = [],
	        result = [];
	    partners.forEach(function (partner) {
	        if (partner.partnerCategory && !availableCategories.some(function (item) {
	            return item.id === partner.partnerCategory.id;
	        })) {
	            availableCategories.push(partner.partnerCategory);
	        }
	    });
	    availableCategories.forEach(function (cat) {
	        result.push({
	            category: cat,
	            order: cat.order,
	            partners: getCategoryPartners(cat.id, partners)
	        });
	    });
	    result.push({
	        category: null,
	        order: null,
	        partners: getCategoryPartners(null, partners)
	    });
	    return result.sort(function (a, b) {
	        return a.order - b.order;
	    });
	}
	
	function PartnersDisplay(props) {
	    var partners = props.partners;
	
	    var grouped = buildPartnersPrintData(partners);
	    return _react2.default.createElement(
	        'div',
	        { className: 'partner-groups' },
	        grouped.map(function (item) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'partner-group', key: item.category ? item.category.id : new Date().getTime() },
	                item.category && _react2.default.createElement(
	                    'h4',
	                    { className: 'group-title' },
	                    item.category.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'partners-list' },
	                    item.partners.map(function (partner) {
	                        return _react2.default.createElement(_partnerDisplay2.default, { partner: partner, key: 'partner-' + partner.id });
	                    })
	                )
	            );
	        })
	    );
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PostsList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _internalImageV = __webpack_require__(107);
	
	var _internalImageV2 = _interopRequireDefault(_internalImageV);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactTextTruncate = __webpack_require__(496);
	
	var _reactTextTruncate2 = _interopRequireDefault(_reactTextTruncate);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PostsList(props) {
	    var posts = props.posts;
	
	    var strip = function strip(html) {
	        var tmp = document.createElement('DIV');
	        tmp.innerHTML = html;
	        return tmp.textContent || tmp.innerText || '';
	    };
	
	    return _react2.default.createElement(
	        'ul',
	        { className: 'posts-list' },
	        posts.map(function (post) {
	            return _react2.default.createElement(
	                'li',
	                { key: post.id + '-post-list-item' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'featured-image' },
	                    _react2.default.createElement(_internalImageV2.default, { filename: post.image ? post.image.filename : undefined, alt: post.title })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'post-content' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'post-title' },
	                        _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/post/' + post.slug },
	                            post.title
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'date-display' },
	                        (0, _moment2.default)(post.publish_date).format('YYYY-MM-DD')
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_reactTextTruncate2.default, { line: 5, truncateText: '\u2026', text: strip(post.body) })
	                    )
	                )
	            );
	        })
	    );
	}
	
	//textTruncateChild={<Link to = {
	//     `/post/${post.slug}`
	// } className="btn btn-main-color"> Read on >< /Link>}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _distanceSelect = __webpack_require__(247);
	
	var _distanceSelect2 = _interopRequireDefault(_distanceSelect);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'code', 'codes_left', 'discount', 'distanceId', 'stageId'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['code', 'codes_left', 'discount', 'distanceId', 'stageId'], errors);
	    return errors;
	}
	
	var PromoCodeForm = function (_BaseForm) {
	    _inherits(PromoCodeForm, _BaseForm);
	
	    function PromoCodeForm() {
	        _classCallCheck(this, PromoCodeForm);
	
	        return _possibleConstructorReturn(this, (PromoCodeForm.__proto__ || Object.getPrototypeOf(PromoCodeForm)).apply(this, arguments));
	    }
	
	    _createClass(PromoCodeForm, [{
	        key: 'onStageSelect',
	        value: function onStageSelect() {
	            var fields = this.props.fields;
	
	            fields.distanceId.onChange(null);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                code = _props$fields.code,
	                codes_left = _props$fields.codes_left,
	                discount = _props$fields.discount,
	                stageId = _props$fields.stageId,
	                distanceId = _props$fields.distanceId;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(_distanceSelect2.default, { stageField: stageId, distanceField: distanceId, disableStageSelect: false, onStageSelect: this.onStageSelect.bind(this), onlyThisSeason: true }),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.code, name: 'name', field: code },
	                        _react2.default.createElement('input', _extends({ ref: 'name', placeholder: _strings2.default.code, type: 'text' }, code))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.codesLeft, name: 'codes_left', field: codes_left },
	                        _react2.default.createElement('input', _extends({ ref: 'codes_left', type: 'number', placeholder: '0' }, codes_left))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.discount, name: 'discount', field: discount },
	                        _react2.default.createElement('input', _extends({ ref: 'discount', type: 'number', placeholder: '0' }, discount))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PromoCodeForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'promo-code-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.promoCodes.promoCode.item };
	})(PromoCodeForm);

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var singleEventWebsite = window.CARE_CONFIG.settings.single_event_website;
	
	var DistanceSelection = function (_Component) {
	    _inherits(DistanceSelection, _Component);
	
	    function DistanceSelection() {
	        _classCallCheck(this, DistanceSelection);
	
	        return _possibleConstructorReturn(this, (DistanceSelection.__proto__ || Object.getPrototypeOf(DistanceSelection)).apply(this, arguments));
	    }
	
	    _createClass(DistanceSelection, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            if (this.props.onlyThisSeason) {
	                this.props.actions.fetchAllStages(window.CARE_CONFIG.settings.season.id);
	            } else {
	                this.props.actions.fetchAllStages();
	            }
	        }
	    }, {
	        key: 'getStage',
	        value: function getStage(id) {
	            var stages = this.props.stages;
	
	            var stageById = void 0;
	            stages.forEach(function (stage) {
	                if (stage.id === id) {
	                    stageById = stage;
	                }
	            });
	            return stageById;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                stages = _props.stages,
	                stageField = _props.stageField,
	                _props$distanceField = _props.distanceField,
	                distanceField = _props$distanceField === undefined ? false : _props$distanceField,
	                _props$disableStageSe = _props.disableStageSelect,
	                disableStageSelect = _props$disableStageSe === undefined ? false : _props$disableStageSe;
	
	            this.distances = [];
	            if (stageField.value) {
	                var stage = this.getStage(stageField.value);
	                if (stage) {
	                    this.distances = stage.distances;
	                }
	            }
	            var renderStageSelect = !(singleEventWebsite && disableStageSelect);
	            return _react2.default.createElement(
	                'div',
	                { className: 'form-row-new' },
	                renderStageSelect && _react2.default.createElement(
	                    _formField2.default,
	                    { label: _strings2.default.stage, name: 'stage', field: stageField },
	                    _react2.default.createElement(_select2.default, _extends({ clearable: false, options: stages, noResultsText: _strings2.default.noStages, placeholder: _strings2.default.stage }, stageField, { disabled: disableStageSelect, onChange: function onChange(event) {
	                            stageField.onChange(event.value);
	                            if (stageField.value !== event.value) {
	                                distanceField.onChange(null);
	                            }
	                            if (_this2.props.onStageSelect) {
	                                _this2.props.onStageSelect(event.value);
	                            }
	                        } }))
	                ),
	                _react2.default.createElement(
	                    _formField2.default,
	                    { label: _strings2.default.distance, name: 'distance', field: distanceField },
	                    _react2.default.createElement(_select2.default, _extends({}, distanceField, { clearable: false, options: this.distances, noResultsText: _strings2.default.noDistances, placeholder: _strings2.default.distance, onChange: function onChange(event) {
	                            distanceField.onChange(event.value);
	                        } }))
	                )
	            );
	        }
	    }]);
	
	    return DistanceSelection;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stages: state.stage.availableStages.items };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(stageActions, dispatch)
	    };
	})(DistanceSelection);

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DistanceSelection = function (_Component) {
	    _inherits(DistanceSelection, _Component);
	
	    function DistanceSelection(props) {
	        _classCallCheck(this, DistanceSelection);
	
	        var _this = _possibleConstructorReturn(this, (DistanceSelection.__proto__ || Object.getPrototypeOf(DistanceSelection)).call(this, props));
	
	        _this.state = {
	            distances: [],
	            stage: null,
	            selectedDistance: null,
	            selectedSeason: window.CARE_CONFIG.settings.season ? window.CARE_CONFIG.settings.season.id : null
	        };
	        return _this;
	    }
	
	    _createClass(DistanceSelection, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchAllStages();
	        }
	    }, {
	        key: 'getStage',
	        value: function getStage(id) {
	            var stages = this.props.stages;
	
	            var stageById = void 0;
	            stages.forEach(function (stage) {
	                if (stage.id === id) {
	                    stageById = stage;
	                }
	            });
	            return stageById;
	        }
	    }, {
	        key: 'onStageChange',
	        value: function onStageChange(stageField) {
	            var distances = [];
	            if (stageField.value) {
	                var stage = this.getStage(stageField.value);
	                if (stage) {
	                    distances = stage.distances;
	                }
	            }
	            this.onChage({ stage: stageField, selectedDistance: null, distances: distances });
	        }
	    }, {
	        key: 'onChage',
	        value: function onChage(newState) {
	            var newStateUpdated = _extends({}, this.state, newState);
	            this.setState(newState);
	            if (this.props.onChange) {
	                this.props.onChange({ stage: newStateUpdated.stage, distance: newStateUpdated.selectedDistance, season: newStateUpdated.selectedSeason });
	            }
	        }
	    }, {
	        key: 'onDistanceChange',
	        value: function onDistanceChange(distance) {
	            this.onChage({ selectedDistance: distance });
	        }
	    }, {
	        key: 'onSeasonChange',
	        value: function onSeasonChange(season) {
	            this.onChage({ selectedSeason: season, selectedDistance: null, stage: null });
	        }
	    }, {
	        key: 'getSeasons',
	        value: function getSeasons(stages) {
	            var seasons = [];
	            stages.forEach(function (stage) {
	                seasons.push(stage.season);
	            });
	            var filtered = [];
	            return seasons.filter(function (season) {
	                if (filtered.indexOf(season.id) > -1) {
	                    return false;
	                } else {
	                    filtered.push(season.id);
	                    return true;
	                }
	            });
	        }
	    }, {
	        key: 'getStages',
	        value: function getStages(season, stages) {
	            return stages.filter(function (stage) {
	                return stage.season.id === season;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stages = this.props.stages;
	
	            var seasons = this.getSeasons(stages);
	            var stageItems = this.getStages(this.state.selectedSeason, stages);
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_select2.default, { options: seasons, clearable: false, value: this.state.selectedSeason,
	                    noResultsText: _strings2.default.noSeasons, placeholder: _strings2.default.season,
	                    onChange: this.onSeasonChange.bind(this), simpleValue: true }),
	                _react2.default.createElement(_select2.default, { options: stageItems, clearable: false, value: this.state.stage,
	                    noResultsText: _strings2.default.noStages, placeholder: _strings2.default.stage,
	                    onChange: this.onStageChange.bind(this) }),
	                _react2.default.createElement(_select2.default, { options: this.state.distances, clearable: false, value: this.state.selectedDistance,
	                    noResultsText: _strings2.default.noDistances, placeholder: _strings2.default.distance,
	                    onChange: this.onDistanceChange.bind(this) })
	            );
	        }
	    }]);
	
	    return DistanceSelection;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stages: state.stage.availableStages.items };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(stageActions, dispatch)
	    };
	})(DistanceSelection);

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(14);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesPageContainer = function (_AppContainer) {
	    _inherits(StagesPageContainer, _AppContainer);
	
	    function StagesPageContainer() {
	        _classCallCheck(this, StagesPageContainer);
	
	        return _possibleConstructorReturn(this, (StagesPageContainer.__proto__ || Object.getPrototypeOf(StagesPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StagesPageContainer, [{
	        key: 'getSeasonId',
	        value: function getSeasonId() {
	            return this.props.params.seasonId ? this.props.params.seasonId : window.CARE_CONFIG.settings.season.id;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchAllStages(this.getSeasonId());
	        }
	    }, {
	        key: 'renderRegistrationButton',
	        value: function renderRegistrationButton(stage) {
	            if (stage.registration_enabled) {
	                if (stage.external_website_registration) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-main-color inline first-uppercase', href: stage.external_registration_link },
	                        _strings2.default.registration
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/stages/' + stage.id + '/registration', className: 'btn btn-main-color inline first-uppercase' },
	                    _strings2.default.registration
	                );
	            }
	        }
	    }, {
	        key: 'renderResultsButton',
	        value: function renderResultsButton(stage) {
	            if (stage.has_results) {
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/stages/' + stage.id + '/results', className: 'btn btn-main-color inline first-uppercase mt-10' },
	                    _strings2.default.results
	                );
	            }
	        }
	    }, {
	        key: 'renderRegisterToAllButton',
	        value: function renderRegisterToAllButton(stages) {
	            return stages.filter(function (stage) {
	                return stage.register_to_all_stages && stage.registration_enabled;
	            }).map(function (stage) {
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { key: 'register-to-all-' + new Date().getTime(), to: '/stages/' + stage.id + '/registration', className: 'btn btn-main-color inline first-uppercase' },
	                    _strings2.default.registerToAllStages
	                );
	            });
	        }
	    }, {
	        key: 'renderRegisterToCustomStages',
	        value: function renderRegisterToCustomStages(stages) {
	            return stages.filter(function (stage) {
	                return stage.register_to_custom_stages && stage.registration_enabled;
	            }).map(function (stage) {
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { key: 'register-to-custom-' + new Date().getTime(), to: '/stages/' + stage.id + '/registration', className: 'btn btn-main-color inline first-uppercase mb-20' },
	                    stage.name
	                );
	            });
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable(stages) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'table',
	                { className: 'table responsive' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _strings2.default.stage
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _strings2.default.date
	                        ),
	                        _react2.default.createElement('th', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    stages.filter(function (stage) {
	                        return !stage.register_to_all_stages && !stage.global_results_stage && !stage.register_to_custom_stages;
	                    }).map(function (stage) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: 'stage-' + stage.id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                stage.name
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                (0, _moment2.default)(stage.stage_date).format('YYYY-MM-DD HH:mm')
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'actions' },
	                                _this2.renderRegistrationButton(stage),
	                                _this2.renderResultsButton(stage),
	                                stage.external_website_registration ? _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-main-color inline first-uppercase', href: stage.external_participants_link },
	                                    _strings2.default.participants
	                                ) : _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/stages/' + stage.id + '/participants', className: 'btn btn-main-color inline first-uppercase' },
	                                    _strings2.default.participants
	                                ),
	                                stage.external_website_registration ? _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-main-color inline first-uppercase', href: stage.external_regulations_link },
	                                    _strings2.default.regulations
	                                ) : _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/stages/' + stage.id + '/regulations', className: 'btn btn-main-color inline first-uppercase' },
	                                    _strings2.default.regulations
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'mb-30' },
	                    this.renderRegisterToAllButton(this.props.stages.items)
	                ),
	                this.renderRegisterToCustomStages(this.props.stages.items),
	                this.renderTable(this.props.stages.items)
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.stages) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.stages
	                            )
	                        ),
	                        this.props.stages.loading ? _react2.default.createElement(_loading2.default, null) : this.renderContent()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StagesPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stages: state.stage.availableStages };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stageActions), dispatch)
	    };
	})(StagesPageContainer);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(49);
	module.exports = function(it, msg){
	  if(typeof it != 'number' && cof(it) != 'Number')throw TypeError(msg);
	  return +it;
	};

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(28)
	  , toIndex  = __webpack_require__(87)
	  , toLength = __webpack_require__(24);
	
	module.exports = [].copyWithin || function copyWithin(target/*= 0*/, start/*= 0, end = @length*/){
	  var O     = toObject(this)
	    , len   = toLength(O.length)
	    , to    = toIndex(target, len)
	    , from  = toIndex(start, len)
	    , end   = arguments.length > 2 ? arguments[2] : undefined
	    , count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to)
	    , inc   = 1;
	  if(from < to && to < from + count){
	    inc  = -1;
	    from += count - 1;
	    to   += count - 1;
	  }
	  while(count-- > 0){
	    if(from in O)O[to] = O[from];
	    else delete O[to];
	    to   += inc;
	    from += inc;
	  } return O;
	};

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(96);
	
	module.exports = function(iter, ITERATOR){
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(37)
	  , toObject  = __webpack_require__(28)
	  , IObject   = __webpack_require__(109)
	  , toLength  = __webpack_require__(24);
	
	module.exports = function(that, callbackfn, aLen, memo, isRight){
	  aFunction(callbackfn);
	  var O      = toObject(that)
	    , self   = IObject(O)
	    , length = toLength(O.length)
	    , index  = isRight ? length - 1 : 0
	    , i      = isRight ? -1 : 1;
	  if(aLen < 2)for(;;){
	    if(index in self){
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if(isRight ? index < 0 : length <= index){
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for(;isRight ? index >= 0 : length > index; index += i)if(index in self){
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction  = __webpack_require__(37)
	  , isObject   = __webpack_require__(15)
	  , invoke     = __webpack_require__(133)
	  , arraySlice = [].slice
	  , factories  = {};
	
	var construct = function(F, len, args){
	  if(!(len in factories)){
	    for(var n = [], i = 0; i < len; i++)n[i] = 'a[' + i + ']';
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /*, args... */){
	  var fn       = aFunction(this)
	    , partArgs = arraySlice.call(arguments, 1);
	  var bound = function(/* args... */){
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if(isObject(fn.prototype))bound.prototype = fn.prototype;
	  return bound;
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP          = __webpack_require__(21).f
	  , create      = __webpack_require__(82)
	  , redefineAll = __webpack_require__(85)
	  , ctx         = __webpack_require__(65)
	  , anInstance  = __webpack_require__(80)
	  , defined     = __webpack_require__(50)
	  , forOf       = __webpack_require__(96)
	  , $iterDefine = __webpack_require__(178)
	  , step        = __webpack_require__(261)
	  , setSpecies  = __webpack_require__(86)
	  , DESCRIPTORS = __webpack_require__(20)
	  , fastKey     = __webpack_require__(71).fastKey
	  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        anInstance(this, C, 'forEach');
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(DESCRIPTORS)dP(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(108)
	  , from    = __webpack_require__(252);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll       = __webpack_require__(85)
	  , getWeak           = __webpack_require__(71).getWeak
	  , anObject          = __webpack_require__(9)
	  , isObject          = __webpack_require__(15)
	  , anInstance        = __webpack_require__(80)
	  , forOf             = __webpack_require__(96)
	  , createArrayMethod = __webpack_require__(57)
	  , $has              = __webpack_require__(33)
	  , arrayFind         = createArrayMethod(5)
	  , arrayFindIndex    = createArrayMethod(6)
	  , id                = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function(that){
	  return that._l || (that._l = new UncaughtFrozenStore);
	};
	var UncaughtFrozenStore = function(){
	  this.a = [];
	};
	var findUncaughtFrozen = function(store, key){
	  return arrayFind(store.a, function(it){
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function(key){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)return entry[1];
	  },
	  has: function(key){
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function(key, value){
	    var entry = findUncaughtFrozen(this, key);
	    if(entry)entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function(key){
	    var index = arrayFindIndex(this.a, function(it){
	      return it[0] === key;
	    });
	    if(~index)this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      anInstance(that, C, NAME, '_i');
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key){
	        if(!isObject(key))return false;
	        var data = getWeak(key);
	        if(data === true)return uncaughtFrozenStore(this).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var data = getWeak(anObject(key), true);
	    if(data === true)uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(20) && !__webpack_require__(13)(function(){
	  return Object.defineProperty(__webpack_require__(170)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(15)
	  , floor    = Math.floor;
	module.exports = function isInteger(it){
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(9);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 261 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 262 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x){
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(84)
	  , gOPS     = __webpack_require__(137)
	  , pIE      = __webpack_require__(110)
	  , toObject = __webpack_require__(28)
	  , IObject  = __webpack_require__(109)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(13)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(21)
	  , anObject = __webpack_require__(9)
	  , getKeys  = __webpack_require__(84);
	
	module.exports = __webpack_require__(20) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(41)
	  , gOPN      = __webpack_require__(83).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(33)
	  , toIObject    = __webpack_require__(41)
	  , arrayIndexOf = __webpack_require__(129)(false)
	  , IE_PROTO     = __webpack_require__(183)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(84)
	  , toIObject = __webpack_require__(41)
	  , isEnum    = __webpack_require__(110).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN     = __webpack_require__(83)
	  , gOPS     = __webpack_require__(137)
	  , anObject = __webpack_require__(9)
	  , Reflect  = __webpack_require__(10).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it){
	  var keys       = gOPN.f(anObject(it))
	    , getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(10).parseFloat
	  , $trim       = __webpack_require__(99).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(188) + '-0') !== -Infinity ? function parseFloat(str){
	  var string = $trim(String(str), 3)
	    , result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(10).parseInt
	  , $trim     = __webpack_require__(99).trim
	  , ws        = __webpack_require__(188)
	  , hex       = /^[\-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix){
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

/***/ },
/* 271 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(24)
	  , repeat   = __webpack_require__(187)
	  , defined  = __webpack_require__(50);
	
	module.exports = function(that, maxLength, fillString, left){
	  var S            = String(defined(that))
	    , stringLength = S.length
	    , fillStr      = fillString === undefined ? ' ' : String(fillString)
	    , intMaxLength = toLength(maxLength);
	  if(intMaxLength <= stringLength || fillStr == '')return S;
	  var fillLen = intMaxLength - stringLength
	    , stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if(stringFiller.length > fillLen)stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(16);

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(255);
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(130)('Map', function(get){
	  return function Map(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if(__webpack_require__(20) && /./g.flags != 'g')__webpack_require__(21).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(132)
	});

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(255);
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(130)('Set', function(get){
	  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value){
	    return strong.def(this, value = value === 0 ? 0 : value, value);
	  }
	}, strong);

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var each         = __webpack_require__(57)(0)
	  , redefine     = __webpack_require__(39)
	  , meta         = __webpack_require__(71)
	  , assign       = __webpack_require__(263)
	  , weak         = __webpack_require__(257)
	  , isObject     = __webpack_require__(15)
	  , getWeak      = meta.getWeak
	  , isExtensible = Object.isExtensible
	  , uncaughtFrozenStore = weak.ufstore
	  , tmp          = {}
	  , InternalMap;
	
	var wrapper = function(get){
	  return function WeakMap(){
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key){
	    if(isObject(key)){
	      var data = getWeak(key);
	      if(data === true)return uncaughtFrozenStore(this).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value){
	    return weak.def(this, key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(130)('WeakMap', wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
	  InternalMap = weak.getConstructor(wrapper);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function(key){
	    var proto  = $WeakMap.prototype
	      , method = proto[key];
	    redefine(proto, key, function(a, b){
	      // store frozen objects on internal weakmap shim
	      if(isObject(a) && !isExtensible(a)){
	        if(!this._f)this._f = new InternalMap;
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(846), __esModule: true };

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(847), __esModule: true };

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(848), __esModule: true };

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(849), __esModule: true };

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$assign = __webpack_require__(838)["default"];
	
	exports["default"] = _Object$assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	exports.__esModule = true;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(841);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	module.exports = { "default": module.exports, __esModule: true };
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(298);
	
	var callBind = __webpack_require__(195);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(111)
	  , TAG = __webpack_require__(52)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(111);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(201)
	  , $export        = __webpack_require__(113)
	  , redefine       = __webpack_require__(203)
	  , hide           = __webpack_require__(200)
	  , has            = __webpack_require__(199)
	  , Iterators      = __webpack_require__(114)
	  , $iterCreate    = __webpack_require__(860)
	  , setToStringTag = __webpack_require__(142)
	  , getProto       = __webpack_require__(42).getProto
	  , ITERATOR       = __webpack_require__(52)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if($native){
	    var IteratorPrototype = getProto($default.call(new Base));
	    // Set @@toStringTag to native iterators
	    setToStringTag(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    // fix Array#{values, @@iterator}.name in V8 / FF
	    if(DEF_VALUES && $native.name !== VALUES){
	      VALUES_BUG = true;
	      $default = function values(){ return $native.call(this); };
	    }
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES  ? $default : getMethod(VALUES),
	      keys:    IS_SET      ? $default : getMethod(KEYS),
	      entries: !DEF_VALUES ? $default : getMethod('entries')
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(42).getDesc
	  , isObject = __webpack_require__(141)
	  , anObject = __webpack_require__(100);
	var check = function(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function(test, buggy, set){
	      try {
	        set = __webpack_require__(112)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch(e){ buggy = true; }
	      return function setPrototypeOf(O, proto){
	        check(O, proto);
	        if(buggy)O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(68)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 290 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 291 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 292 */
/***/ function(module, exports) {



/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(92);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(883);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window && typeof window.process !== 'undefined' && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document && 'WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window && window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ("production").DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(458);
	var isArguments = __webpack_require__(902);
	var is = __webpack_require__(1012);
	var isRegex = __webpack_require__(905);
	var flags = __webpack_require__(1186);
	var isDate = __webpack_require__(903);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ },
/* 296 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/eventomania-dark.png?ed423ebc76666ead41911c159d4adb91";

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(894)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(299);
	var hasOwn = __webpack_require__(893);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(892);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(208);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1019);
	
	var _runTransitionHook = __webpack_require__(208);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(101);
	
	var _PathUtils = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(1248);
	module.exports = self.fetch.bind(self);


/***/ },
/* 305 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(907),
	    isArguments = __webpack_require__(305),
	    keysIn = __webpack_require__(909);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 308 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(939),
	    isArguments = __webpack_require__(336),
	    isArray = __webpack_require__(46),
	    isBuffer = __webpack_require__(220),
	    isIndex = __webpack_require__(327),
	    isTypedArray = __webpack_require__(338);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 310 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 311 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 312 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(314),
	    eq = __webpack_require__(218);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(956);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(316),
	    createBaseEach = __webpack_require__(954);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(924),
	    keys = __webpack_require__(117);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(321),
	    toKey = __webpack_require__(152);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(311),
	    isArray = __webpack_require__(46);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(927),
	    isObjectLike = __webpack_require__(91);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(335);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(46),
	    isKey = __webpack_require__(216),
	    stringToPath = __webpack_require__(996),
	    toString = __webpack_require__(1009);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(914),
	    arraySome = __webpack_require__(919),
	    cacheHas = __webpack_require__(942);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 323 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(318),
	    getSymbols = __webpack_require__(215),
	    keys = __webpack_require__(117);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(311),
	    getPrototype = __webpack_require__(214),
	    getSymbols = __webpack_require__(215),
	    stubArray = __webpack_require__(340);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(910),
	    Map = __webpack_require__(210),
	    Promise = __webpack_require__(912),
	    Set = __webpack_require__(913),
	    WeakMap = __webpack_require__(915),
	    baseGetTag = __webpack_require__(89),
	    toSource = __webpack_require__(333);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 327 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 331 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 333 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69),
	    now = __webpack_require__(1004),
	    toNumber = __webpack_require__(1008);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(926),
	    isObjectLike = __webpack_require__(91);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isObject = __webpack_require__(69);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(930),
	    baseUnary = __webpack_require__(941),
	    nodeUtil = __webpack_require__(987);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(309),
	    baseKeysIn = __webpack_require__(933),
	    isArrayLike = __webpack_require__(153);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 340 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.materialColors = factory();
	  }
	})(this, function() {
	  return {"red":{"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"},"pink":{"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"},"purple":{"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"},"deepPurple":{"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"},"indigo":{"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"},"blue":{"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"},"lightBlue":{"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"},"cyan":{"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"},"teal":{"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"},"green":{"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"},"lightGreen":{"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"},"lime":{"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"},"yellow":{"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"},"amber":{"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"},"orange":{"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"},"deepOrange":{"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"},"brown":{"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"},"grey":{"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"},"blueGrey":{"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"},"darkText":{"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"},"lightText":{"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"},"darkIcons":{"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"},"lightIcons":{"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"},"white":"#ffffff","black":"#000000"};
	});


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(2)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 456 */
/***/ function(module, exports) {

	'use strict';
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(456);
	
	module.exports = function getPolyfill() {
		return typeof Object.is === 'function' ? Object.is : implementation;
	};


/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(459);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1014);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 459 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 460 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 461 */
/***/ function(module, exports) {

	'use strict';
	
	function isObject(what) {
	    return typeof what === 'object' && what !== null;
	}
	
	// Sorta yanked from https://github.com/joyent/node/blob/aa3b4b4/lib/util.js#L560
	// with some tiny modifications
	function isError(what) {
	    var toString = {}.toString.call(what);
	    return isObject(what) &&
	        toString === '[object Error]' ||
	        toString === '[object Exception]' || // Firefox NS_ERROR_FAILURE Exceptions
	        what instanceof Error;
	}
	
	module.exports = {
	    isObject: isObject,
	    isError: isError
	};

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Checkboard = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _checkboard = __webpack_require__(1068);
	
	var checkboard = _interopRequireWildcard(_checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checkboard = exports.Checkboard = function Checkboard(_ref) {
	  var white = _ref.white,
	      grey = _ref.grey,
	      size = _ref.size,
	      renderers = _ref.renderers,
	      borderRadius = _ref.borderRadius,
	      boxShadow = _ref.boxShadow;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      grid: {
	        borderRadius: borderRadius,
	        boxShadow: boxShadow,
	        absolute: '0px 0px 0px 0px',
	        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.grid });
	};
	
	Checkboard.defaultProps = {
	  size: 8,
	  white: 'transparent',
	  grey: 'rgba(0,0,0,.08)',
	  renderers: {}
	};
	
	exports.default = Checkboard;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ColorWrap = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debounce = __webpack_require__(334);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
	  var ColorPicker = function (_ref) {
	    _inherits(ColorPicker, _ref);
	
	    function ColorPicker(props) {
	      _classCallCheck(this, ColorPicker);
	
	      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
	
	      _this.handleChange = function (data, event) {
	        var isValidColor = _color2.default.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
	          _this.props.onChange && _this.props.onChange(colors, event);
	        }
	      };
	
	      _this.handleSwatchHover = function (data, event) {
	        var isValidColor = _color2.default.simpleCheckForValidColor(data);
	        if (isValidColor) {
	          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
	          _this.setState(colors);
	          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
	        }
	      };
	
	      _this.state = _extends({}, _color2.default.toState(props.color, 0));
	
	      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
	        fn(data, event);
	      }, 100);
	      return _this;
	    }
	
	    _createClass(ColorPicker, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        this.setState(_extends({}, _color2.default.toState(nextProps.color, this.state.oldHue)));
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var optionalEvents = {};
	        if (this.props.onSwatchHover) {
	          optionalEvents.onSwatchHover = this.handleSwatchHover;
	        }
	
	        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
	          onChange: this.handleChange
	        }, optionalEvents));
	      }
	    }]);
	
	    return ColorPicker;
	  }(_react.PureComponent || _react.Component);
	
	  ColorPicker.propTypes = _extends({}, Picker.propTypes);
	
	  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
	    color: {
	      h: 250,
	      s: 0.50,
	      l: 0.20,
	      a: 1
	    }
	  });
	
	  return ColorPicker;
	};
	
	exports.default = ColorWrap;

/***/ },
/* 464 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1),__webpack_require__(11)):"function"==typeof define&&define.amd?define(["react","prop-types"],t):"object"==typeof exports?exports.Dropzone=t(require("react"),require("prop-types")):e.Dropzone=t(e.React,e.PropTypes)}(this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function u(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function c(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(1),p=r(f),d=n(2),v=r(d),h=n(3),g=n(5),y=r(g),m=function(e){function t(e,n){a(this,t);var r=u(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e,n));return r.renderChildren=function(e,t,n,o){return"function"==typeof e?e(s({},r.state,{isDragActive:t,isDragAccept:n,isDragReject:o})):e},r.composeHandlers=r.composeHandlers.bind(r),r.onClick=r.onClick.bind(r),r.onDocumentDrop=r.onDocumentDrop.bind(r),r.onDragEnter=r.onDragEnter.bind(r),r.onDragLeave=r.onDragLeave.bind(r),r.onDragOver=r.onDragOver.bind(r),r.onDragStart=r.onDragStart.bind(r),r.onDrop=r.onDrop.bind(r),r.onFileDialogCancel=r.onFileDialogCancel.bind(r),r.onInputElementClick=r.onInputElementClick.bind(r),r.setRef=r.setRef.bind(r),r.setRefs=r.setRefs.bind(r),r.isFileDialogActive=!1,r.state={draggedFiles:[],acceptedFiles:[],rejectedFiles:[]},r}return c(t,e),l(t,[{key:"componentDidMount",value:function(){var e=this.props.preventDropOnDocument;this.dragTargets=[],e&&(document.addEventListener("dragover",h.onDocumentDragOver,!1),document.addEventListener("drop",this.onDocumentDrop,!1)),this.fileInputEl.addEventListener("click",this.onInputElementClick,!1),window.addEventListener("focus",this.onFileDialogCancel,!1)}},{key:"componentWillUnmount",value:function(){this.props.preventDropOnDocument&&(document.removeEventListener("dragover",h.onDocumentDragOver),document.removeEventListener("drop",this.onDocumentDrop)),null!=this.fileInputEl&&this.fileInputEl.removeEventListener("click",this.onInputElementClick,!1),window.removeEventListener("focus",this.onFileDialogCancel,!1)}},{key:"composeHandlers",value:function(e){return this.props.disabled?null:e}},{key:"onDocumentDrop",value:function(e){this.node&&this.node.contains(e.target)||(e.preventDefault(),this.dragTargets=[])}},{key:"onDragStart",value:function(e){this.props.onDragStart&&this.props.onDragStart.call(this,e)}},{key:"onDragEnter",value:function(e){var t=this;e.preventDefault(),-1===this.dragTargets.indexOf(e.target)&&this.dragTargets.push(e.target),Promise.resolve(this.props.getDataTransferItems(e)).then(function(e){t.setState({isDragActive:!0,draggedFiles:e})}),this.props.onDragEnter&&this.props.onDragEnter.call(this,e)}},{key:"onDragOver",value:function(e){e.preventDefault(),e.stopPropagation();try{e.dataTransfer.dropEffect=this.isFileDialogActive?"none":"copy"}catch(e){}return this.props.onDragOver&&this.props.onDragOver.call(this,e),!1}},{key:"onDragLeave",value:function(e){var t=this;e.preventDefault(),this.dragTargets=this.dragTargets.filter(function(n){return n!==e.target&&t.node.contains(n)}),this.dragTargets.length>0||(this.setState({isDragActive:!1,draggedFiles:[]}),this.props.onDragLeave&&this.props.onDragLeave.call(this,e))}},{key:"onDrop",value:function(e){var t=this,n=this.props,r=n.onDrop,o=n.onDropAccepted,a=n.onDropRejected,u=n.multiple,c=n.disablePreview,s=n.accept,l=n.getDataTransferItems;e.preventDefault(),this.dragTargets=[],this.isFileDialogActive=!1,this.draggedFiles=null,this.setState({isDragActive:!1,draggedFiles:[]}),Promise.resolve(l(e)).then(function(n){var l=[],f=[];n.forEach(function(e){if(!c)try{e.preview=window.URL.createObjectURL(e)}catch(e){}(0,h.fileAccepted)(e,s)&&(0,h.fileMatchSize)(e,t.props.maxSize,t.props.minSize)?l.push(e):f.push(e)}),u||f.push.apply(f,i(l.splice(1))),r&&r.call(t,l,f,e),f.length>0&&a&&a.call(t,f,e),l.length>0&&o&&o.call(t,l,e)})}},{key:"onClick",value:function(e){var t=this.props,n=t.onClick;t.disableClick||(e.stopPropagation(),n&&n.call(this,e),(0,h.isIeOrEdge)()?setTimeout(this.open.bind(this),0):this.open())}},{key:"onInputElementClick",value:function(e){e.stopPropagation(),this.props.inputProps&&this.props.inputProps.onClick&&this.props.inputProps.onClick()}},{key:"onFileDialogCancel",value:function(){var e=this,t=this.props.onFileDialogCancel;this.isFileDialogActive&&setTimeout(function(){if(null!=e.fileInputEl){e.fileInputEl.files.length||(e.isFileDialogActive=!1)}"function"==typeof t&&t()},300)}},{key:"setRef",value:function(e){this.node=e}},{key:"setRefs",value:function(e){this.fileInputEl=e}},{key:"open",value:function(){this.isFileDialogActive=!0,this.fileInputEl.value=null,this.fileInputEl.click()}},{key:"render",value:function(){var e=this.props,t=e.accept,n=e.acceptClassName,r=e.activeClassName,i=e.children,a=e.disabled,u=e.disabledClassName,c=e.inputProps,l=e.multiple,f=e.name,d=e.rejectClassName,v=o(e,["accept","acceptClassName","activeClassName","children","disabled","disabledClassName","inputProps","multiple","name","rejectClassName"]),g=v.acceptStyle,m=v.activeStyle,b=v.className,D=void 0===b?"":b,x=v.disabledStyle,O=v.rejectStyle,S=v.style,C=o(v,["acceptStyle","activeStyle","className","disabledStyle","rejectStyle","style"]),j=this.state,E=j.isDragActive,w=j.draggedFiles,_=w.length,k=l||_<=1,P=_>0&&(0,h.allFilesAccepted)(w,this.props.accept),A=_>0&&(!P||!k),F=!(D||S||m||g||O||x);E&&r&&(D+=" "+r),P&&n&&(D+=" "+n),A&&d&&(D+=" "+d),a&&u&&(D+=" "+u),F&&(S=y.default.default,m=y.default.active,g=y.default.active,O=y.default.rejected,x=y.default.disabled);var T=s({position:"relative"},S);m&&E&&(T=s({},T,m)),g&&P&&(T=s({},T,g)),O&&A&&(T=s({},T,O)),x&&a&&(T=s({},T,x));var I={accept:t,disabled:a,type:"file",style:s({position:"absolute",top:0,right:0,bottom:0,left:0,opacity:1e-5,pointerEvents:"none"},c.style),multiple:h.supportMultiple&&l,ref:this.setRefs,onChange:this.onDrop,autoComplete:"off"};f&&f.length&&(I.name=f);var M=(C.acceptedFiles,C.preventDropOnDocument,C.disablePreview,C.disableClick,C.onDropAccepted,C.onDropRejected,C.onFileDialogCancel,C.maxSize,C.minSize,C.getDataTransferItems,o(C,["acceptedFiles","preventDropOnDocument","disablePreview","disableClick","onDropAccepted","onDropRejected","onFileDialogCancel","maxSize","minSize","getDataTransferItems"]));return p.default.createElement("div",s({className:D,style:T},M,{onClick:this.composeHandlers(this.onClick),onDragStart:this.composeHandlers(this.onDragStart),onDragEnter:this.composeHandlers(this.onDragEnter),onDragOver:this.composeHandlers(this.onDragOver),onDragLeave:this.composeHandlers(this.onDragLeave),onDrop:this.composeHandlers(this.onDrop),ref:this.setRef,"aria-disabled":a}),this.renderChildren(i,E,P,A),p.default.createElement("input",s({},c,I)))}}]),t}(p.default.Component);t.default=m,m.propTypes={accept:v.default.oneOfType([v.default.string,v.default.arrayOf(v.default.string)]),children:v.default.oneOfType([v.default.node,v.default.func]),disableClick:v.default.bool,disabled:v.default.bool,disablePreview:v.default.bool,preventDropOnDocument:v.default.bool,inputProps:v.default.object,multiple:v.default.bool,name:v.default.string,maxSize:v.default.number,minSize:v.default.number,className:v.default.string,activeClassName:v.default.string,acceptClassName:v.default.string,rejectClassName:v.default.string,disabledClassName:v.default.string,style:v.default.object,activeStyle:v.default.object,acceptStyle:v.default.object,rejectStyle:v.default.object,disabledStyle:v.default.object,getDataTransferItems:v.default.func,onClick:v.default.func,onDrop:v.default.func,onDropAccepted:v.default.func,onDropRejected:v.default.func,onDragStart:v.default.func,onDragEnter:v.default.func,onDragOver:v.default.func,onDragLeave:v.default.func,onFileDialogCancel:v.default.func},m.defaultProps={preventDropOnDocument:!0,disabled:!1,disablePreview:!1,disableClick:!1,inputProps:{},multiple:!0,maxSize:1/0,minSize:0,getDataTransferItems:h.getDataTransferItems},e.exports=t.default},function(t,n){t.exports=e},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){var t=[];if(e.dataTransfer){var n=e.dataTransfer;n.files&&n.files.length?t=n.files:n.items&&n.items.length&&(t=n.items)}else e.target&&e.target.files&&(t=e.target.files);return Array.prototype.slice.call(t)}function o(e,t){return"application/x-moz-file"===e.type||(0,p.default)(e,t)}function i(e,t,n){return e.size<=t&&e.size>=n}function a(e,t){return e.every(function(e){return o(e,t)})}function u(e){e.preventDefault()}function c(e){return-1!==e.indexOf("MSIE")||-1!==e.indexOf("Trident/")}function s(e){return-1!==e.indexOf("Edge/")}function l(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.navigator.userAgent;return c(e)||s(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.supportMultiple=void 0,t.getDataTransferItems=r,t.fileAccepted=o,t.fileMatchSize=i,t.allFilesAccepted=a,t.onDocumentDragOver=u,t.isIeOrEdge=l;var f=n(4),p=function(e){return e&&e.__esModule?e:{default:e}}(f);t.supportMultiple="undefined"==typeof document||!document||!document.createElement||"multiple"in document.createElement("input")},function(e,t){e.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=13)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){var n=e.exports={version:"2.5.0"};"number"==typeof __e&&(__e=n)},function(e,t,n){e.exports=!n(4)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("wks"),o=n(9),i=n(0).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t,n){var r=n(0),o=n(2),i=n(8),a=n(22),u=n(10),c=function(e,t,n){var s,l,f,p,d=e&c.F,v=e&c.G,h=e&c.S,g=e&c.P,y=e&c.B,m=v?r:h?r[t]||(r[t]={}):(r[t]||{}).prototype,b=v?o:o[t]||(o[t]={}),D=b.prototype||(b.prototype={});v&&(n=t);for(s in n)l=!d&&m&&void 0!==m[s],f=(l?m:n)[s],p=y&&l?u(f,r):g&&"function"==typeof f?u(Function.call,f):f,m&&a(m,s,f,e&c.U),b[s]!=f&&i(b,s,p),g&&D[s]!=f&&(D[s]=f)};r.core=o,c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c},function(e,t,n){var r=n(16),o=n(21);e.exports=n(3)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){var r=n(24);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(28),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(e&&t){var n=Array.isArray(t)?t:t.split(","),r=e.name||"",o=e.type||"",i=o.replace(/\/.*$/,"");return n.some(function(e){var t=e.trim();return"."===t.charAt(0)?r.toLowerCase().endsWith(t.toLowerCase()):t.endsWith("/*")?i===t.replace(/\/.*$/,""):o===t})}return!0},n(14),n(34)},function(e,t,n){n(15),e.exports=n(2).Array.some},function(e,t,n){"use strict";var r=n(7),o=n(25)(3);r(r.P+r.F*!n(33)([].some,!0),"Array",{some:function(e){return o(this,e,arguments[1])}})},function(e,t,n){var r=n(17),o=n(18),i=n(20),a=Object.defineProperty;t.f=n(3)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){var r=n(1);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){e.exports=!n(3)&&!n(4)(function(){return 7!=Object.defineProperty(n(19)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(1),o=n(0).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){var r=n(1);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can't convert object to primitive value")}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t,n){var r=n(0),o=n(8),i=n(23),a=n(9)("src"),u=Function.toString,c=(""+u).split("toString");n(2).inspectSource=function(e){return u.call(e)},(e.exports=function(e,t,n,u){var s="function"==typeof n;s&&(i(n,"name")||o(n,"name",t)),e[t]!==n&&(s&&(i(n,a)||o(n,a,e[t]?""+e[t]:c.join(String(t)))),e===r?e[t]=n:u?e[t]?e[t]=n:o(e,t,n):(delete e[t],o(e,t,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[a]||u.call(this)})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){var r=n(10),o=n(26),i=n(27),a=n(12),u=n(29);e.exports=function(e,t){var n=1==e,c=2==e,s=3==e,l=4==e,f=6==e,p=5==e||f,d=t||u;return function(t,u,v){for(var h,g,y=i(t),m=o(y),b=r(u,v,3),D=a(m.length),x=0,O=n?d(t,D):c?d(t,0):void 0;D>x;x++)if((p||x in m)&&(h=m[x],g=b(h,x,y),e))if(n)O[x]=g;else if(g)switch(e){case 3:return!0;case 5:return h;case 6:return x;case 2:O.push(h)}else if(l)return!1;return f?-1:s||l?l:O}}},function(e,t,n){var r=n(5);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(11);e.exports=function(e){return Object(r(e))}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t,n){var r=n(30);e.exports=function(e,t){return new(r(e))(t)}},function(e,t,n){var r=n(1),o=n(31),i=n(6)("species");e.exports=function(e){var t;return o(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!o(t.prototype)||(t=void 0),r(t)&&null===(t=t[i])&&(t=void 0)),void 0===t?Array:t}},function(e,t,n){var r=n(5);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(0),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return o[e]||(o[e]={})}},function(e,t,n){"use strict";var r=n(4);e.exports=function(e,t){return!!e&&r(function(){t?e.call(null,function(){},1):e.call(null)})}},function(e,t,n){n(35),e.exports=n(2).String.endsWith},function(e,t,n){"use strict";var r=n(7),o=n(12),i=n(36),a="".endsWith;r(r.P+r.F*n(38)("endsWith"),"String",{endsWith:function(e){var t=i(this,e,"endsWith"),n=arguments.length>1?arguments[1]:void 0,r=o(t.length),u=void 0===n?r:Math.min(o(n),r),c=String(e);return a?a.call(t,c,u):t.slice(u-c.length,u)===c}})},function(e,t,n){var r=n(37),o=n(11);e.exports=function(e,t,n){if(r(t))throw TypeError("String#"+n+" doesn't accept regex!");return String(o(e))}},function(e,t,n){var r=n(1),o=n(5),i=n(6)("match");e.exports=function(e){var t;return r(e)&&(void 0!==(t=e[i])?!!t:"RegExp"==o(e))}},function(e,t,n){var r=n(6)("match");e.exports=function(e){var t=/./;try{"/./"[e](t)}catch(n){try{return t[r]=!1,!"/./"[e](t)}catch(e){}}return!0}}])},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default={rejected:{borderStyle:"solid",borderColor:"#c66",backgroundColor:"#eee"},disabled:{opacity:.5},active:{borderStyle:"solid",borderColor:"#6c6",backgroundColor:"#eee"},default:{width:200,height:200,borderWidth:2,borderColor:"#666",borderStyle:"dashed",borderRadius:5}},e.exports=t.default}])});
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(156),
	    _assign = __webpack_require__(92);
	
	var ReactNoopUpdateQueue = __webpack_require__(469);
	
	var canDefineProperty = __webpack_require__(470);
	var emptyObject = __webpack_require__(888);
	var invariant = __webpack_require__(144);
	var lowPriorityWarning = __webpack_require__(1097);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 467 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 468 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(204);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 471 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.tryForceFallback = tryForceFallback;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error('react-modal: No elements were found for selector ' + selector + '.');
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === 'string') {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = 'length' in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function tryForceFallback() {
	  if (document && document.body) {
	    // force fallback to document.body
	    setElement(document.body);
	    return true;
	  }
	  return false;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement && !tryForceFallback()) {
	    throw new Error(['react-modal: Cannot fallback to `document.body`, because it\'s not ready or available.', 'If you are doing server-side rendering, use this function to defined an element.', '`Modal.setAppElement(el)` to make this accessible']);
	  }
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || globalElement).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || globalElement).removeAttribute('aria-hidden');
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = document.body;
	}

/***/ },
/* 472 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.get = get;
	exports.add = add;
	exports.remove = remove;
	exports.totalCount = totalCount;
	var classListMap = {};
	
	function get() {
	  return classListMap;
	}
	
	function add(bodyClass) {
	  // Set variable and default if none
	  if (!classListMap[bodyClass]) {
	    classListMap[bodyClass] = 0;
	  }
	  classListMap[bodyClass] += 1;
	  return bodyClass;
	}
	
	function remove(bodyClass) {
	  if (classListMap[bodyClass]) {
	    classListMap[bodyClass] -= 1;
	  }
	  return bodyClass;
	}
	
	function totalCount() {
	  return Object.keys(classListMap).reduce(function (acc, curr) {
	    return acc + classListMap[curr];
	  }, 0);
	}

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _exenv = __webpack_require__(884);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	exports.default = SafeHTMLElement;
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidden(el) {
	  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === 'none';
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidden(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(tabbable);
	}
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(160);
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(237));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(520));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(159));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(161));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(1121));
	
	var _invariant = _interopRequireDefault(__webpack_require__(1122));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(119);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(1118));
	
	var _PropTypes = __webpack_require__(477);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(478));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1119));
	
	var _warning = _interopRequireDefault(__webpack_require__(224));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 479 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 480 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(228);
	
	var _ContextUtils = __webpack_require__(227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 482 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(77);
	
	var _PatternUtils = __webpack_require__(103);
	
	var _InternalPropTypes = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 484 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(303);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(302);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(900);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(488);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(104);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1133);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1130);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1137);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1134);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1139);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(303);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(302);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(157);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(495);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(230);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(231);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(157);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator,
				    showNewOptionAtTop = _props2.showNewOptionAtTop;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						if (showNewOptionAtTop) {
							filteredOptions.unshift(this._createPlaceholderOption);
						} else {
							filteredOptions.push(this._createPlaceholderOption);
						}
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
		showNewOptionAtTop: true
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func,
	
		// Where to show prompt/placeholder option text.
		// true: new option prompt at top of list (default)
		// false: new option prompt at bottom of list
		showNewOptionAtTop: _propTypes2.default.bool
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(1146);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 495 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(1), __webpack_require__(11)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(exports, require("react"), require("prop-types"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod.exports, global.React, global.propTypes);
	    global.undefined = mod.exports;
	  }
	})(void 0, function (exports, _react, _propTypes) {
	  "use strict";
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	  exports.default = undefined;
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function _typeof(obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function _typeof(obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _objectWithoutProperties(source, excluded) {
	    if (source == null) return {};
	
	    var target = _objectWithoutPropertiesLoose(source, excluded);
	
	    var key, i;
	
	    if (Object.getOwnPropertySymbols) {
	      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	      for (i = 0; i < sourceSymbolKeys.length; i++) {
	        key = sourceSymbolKeys[i];
	        if (excluded.indexOf(key) >= 0) continue;
	        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	        target[key] = source[key];
	      }
	    }
	
	    return target;
	  }
	
	  function _objectWithoutPropertiesLoose(source, excluded) {
	    if (source == null) return {};
	    var target = {};
	    var sourceKeys = Object.keys(source);
	    var key, i;
	
	    for (i = 0; i < sourceKeys.length; i++) {
	      key = sourceKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      target[key] = source[key];
	    }
	
	    return target;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (_typeof(call) === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  var TextTruncate = function (_Component) {
	    _inherits(TextTruncate, _Component);
	
	    function TextTruncate() {
	      var _getPrototypeOf2;
	
	      var _this;
	
	      _classCallCheck(this, TextTruncate);
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TextTruncate)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	      _defineProperty(_assertThisInitialized(_this), "onResize", function () {
	        if (_this.rafId) {
	          window.cancelAnimationFrame(_this.rafId);
	        }
	
	        _this.rafId = window.requestAnimationFrame(_this.update.bind(_assertThisInitialized(_this)));
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "onToggled", function (truncated) {
	        typeof _this.props.onToggled === 'function' && setTimeout(function () {
	          return _this.props.onToggled(truncated);
	        }, 0);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "onTruncated", function () {
	        typeof _this.props.onTruncated === 'function' && setTimeout(function () {
	          return _this.props.onTruncated();
	        }, 0);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "onCalculated", function () {
	        typeof _this.props.onCalculated === 'function' && setTimeout(function () {
	          return _this.props.onCalculated();
	        }, 0);
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "update", function () {
	        var style = window.getComputedStyle(_this.scope);
	        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family'], style['letter-spacing']].join(' ');
	        _this.canvas.font = font;
	
	        _this.forceUpdate();
	      });
	
	      return _this;
	    }
	
	    _createClass(TextTruncate, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var canvas = document.createElement('canvas');
	        var docFragment = document.createDocumentFragment();
	        var style = window.getComputedStyle(this.scope);
	        var font = [style['font-weight'], style['font-style'], style['font-size'], style['font-family']].join(' ');
	        docFragment.appendChild(canvas);
	        this.canvas = canvas.getContext('2d');
	        this.canvas.font = font;
	        this.forceUpdate();
	        window.addEventListener('resize', this.onResize);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.onResize);
	
	        if (this.rafId) {
	          window.cancelAnimationFrame(this.rafId);
	        }
	      }
	    }, {
	      key: "measureWidth",
	      value: function measureWidth(text) {
	        return Math.ceil(this.canvas.measureText(text).width);
	      }
	    }, {
	      key: "getRenderText",
	      value: function getRenderText() {
	        var _this$props = this.props,
	            containerClassName = _this$props.containerClassName,
	            element = _this$props.element,
	            line = _this$props.line,
	            onCalculated = _this$props.onCalculated,
	            onTruncated = _this$props.onTruncated,
	            onToggled = _this$props.onToggled,
	            text = _this$props.text,
	            textElement = _this$props.textElement,
	            textTruncateChild = _this$props.textTruncateChild,
	            truncateText = _this$props.truncateText,
	            maxCalculateTimes = _this$props.maxCalculateTimes,
	            props = _objectWithoutProperties(_this$props, ["containerClassName", "element", "line", "onCalculated", "onTruncated", "onToggled", "text", "textElement", "textTruncateChild", "truncateText", "maxCalculateTimes"]);
	
	        var scopeWidth = this.scope.getBoundingClientRect().width; // return if display:none
	
	        if (scopeWidth === 0) {
	          return null;
	        } // return if all of text can be displayed
	
	
	        if (scopeWidth >= this.measureWidth(text)) {
	          this.onToggled(false);
	          return (0, _react.createElement)(textElement, props, text);
	        }
	
	        var childText = '';
	
	        if (textTruncateChild && typeof textTruncateChild.type === 'string') {
	          var type = textTruncateChild.type;
	
	          if (type.indexOf('span') >= 0 || type.indexOf('a') >= 0) {
	            childText = textTruncateChild.props.children;
	          }
	        }
	
	        var currentPos = 1;
	        var maxTextLength = text.length;
	        var truncatedText = '';
	        var splitPos = 0;
	        var startPos = 0;
	        var displayLine = line;
	        var width = 0;
	        var lastIsEng = false;
	        var isPrevLineWithoutSpace = false;
	        var lastPos = 0;
	        var lastSpaceIndex = -1;
	        var ext = '';
	        var loopCnt = 0;
	
	        while (displayLine-- > 0) {
	          ext = displayLine ? '' : truncateText + (childText ? ' ' + childText : '');
	
	          while (currentPos <= maxTextLength) {
	            truncatedText = text.substr(startPos, currentPos);
	            width = this.measureWidth(truncatedText + ext);
	
	            if (width < scopeWidth) {
	              splitPos = text.indexOf(' ', currentPos + 1);
	
	              if (splitPos === -1) {
	                currentPos += 1;
	                lastIsEng = false;
	              } else {
	                lastIsEng = true;
	                currentPos = splitPos;
	              }
	            } else {
	              do {
	                if (loopCnt++ >= maxCalculateTimes) {
	                  break;
	                }
	
	                truncatedText = text.substr(startPos, currentPos);
	
	                if (!displayLine) {
	                  currentPos--;
	                }
	
	                if (truncatedText[truncatedText.length - 1] === ' ') {
	                  truncatedText = text.substr(startPos, currentPos - 1);
	                }
	
	                if (lastIsEng) {
	                  lastSpaceIndex = truncatedText.lastIndexOf(' ');
	
	                  if (lastSpaceIndex > -1) {
	                    currentPos = lastSpaceIndex;
	
	                    if (displayLine) {
	                      currentPos++;
	                    }
	
	                    truncatedText = text.substr(startPos, currentPos);
	                  } else {
	                    currentPos--;
	                    truncatedText = text.substr(startPos, currentPos);
	                  }
	                } else {
	                  currentPos--;
	                  truncatedText = text.substr(startPos, currentPos);
	                }
	
	                width = this.measureWidth(truncatedText + ext);
	              } while (width >= scopeWidth && truncatedText.length > 0);
	
	              startPos += currentPos;
	              break;
	            }
	          }
	
	          if (currentPos >= maxTextLength) {
	            startPos = maxTextLength;
	            break;
	          }
	
	          if (lastIsEng && !isPrevLineWithoutSpace && text.substr(lastPos, currentPos).indexOf(' ') === -1) {
	            isPrevLineWithoutSpace = text.substr(lastPos, currentPos).indexOf(' ') === -1;
	            displayLine--;
	          }
	
	          lastPos = currentPos + 1;
	        }
	
	        if (startPos === maxTextLength) {
	          this.onToggled(false);
	          return (0, _react.createElement)(textElement, props, text);
	        }
	
	        this.onTruncated();
	        this.onToggled(true);
	        return _react2["default"].createElement("span", props, (0, _react.createElement)(textElement, props, text.substr(0, startPos) + truncateText + ' '), textTruncateChild);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this2 = this;
	
	        var _this$props2 = this.props,
	            element = _this$props2.element,
	            text = _this$props2.text,
	            _this$props2$style = _this$props2.style,
	            style = _this$props2$style === void 0 ? {} : _this$props2$style,
	            containerClassName = _this$props2.containerClassName,
	            line = _this$props2.line,
	            onCalculated = _this$props2.onCalculated,
	            onTruncated = _this$props2.onTruncated,
	            onToggled = _this$props2.onToggled,
	            textElement = _this$props2.textElement,
	            textTruncateChild = _this$props2.textTruncateChild,
	            truncateText = _this$props2.truncateText,
	            maxCalculateTimes = _this$props2.maxCalculateTimes,
	            props = _objectWithoutProperties(_this$props2, ["element", "text", "style", "containerClassName", "line", "onCalculated", "onTruncated", "onToggled", "textElement", "textTruncateChild", "truncateText", "maxCalculateTimes"]);
	
	        var fontWeight = style.fontWeight,
	            fontStyle = style.fontStyle,
	            fontSize = style.fontSize,
	            fontFamily = style.fontFamily;
	        var renderText = this.scope && line ? this.getRenderText() : (0, _react.createElement)(textElement, props, text);
	        ;
	        var rootProps = {
	          ref: function ref(el) {
	            _this2.scope = el;
	          },
	          className: containerClassName,
	          style: {
	            overflow: 'hidden',
	            fontWeight: fontWeight,
	            fontStyle: fontStyle,
	            fontSize: fontSize,
	            fontFamily: fontFamily
	          }
	        };
	        this.scope && this.onCalculated();
	        return (0, _react.createElement)(element, rootProps, renderText);
	      }
	    }]);
	
	    return TextTruncate;
	  }(_react.Component);
	
	  _defineProperty(TextTruncate, "propTypes", {
	    containerClassName: _propTypes2["default"].string,
	    element: _propTypes2["default"].string,
	    line: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].bool]),
	    onCalculated: _propTypes2["default"].func,
	    onTruncated: _propTypes2["default"].func,
	    onToggled: _propTypes2["default"].func,
	    text: _propTypes2["default"].string,
	    textElement: _propTypes2["default"].node,
	    textTruncateChild: _propTypes2["default"].node,
	    truncateText: _propTypes2["default"].string,
	    maxCalculateTimes: _propTypes2["default"].number
	  });
	
	  _defineProperty(TextTruncate, "defaultProps", {
	    element: 'div',
	    line: 1,
	    text: '',
	    textElement: 'span',
	    truncateText: '…',
	    maxCalculateTimes: 10
	  });
	
	  exports.default = TextTruncate;
	  ;
	  module.exports = exports.default;
	});


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(282)['default'];
	
	var _regeneratorRuntime = __webpack_require__(283)['default'];
	
	var _Promise = __webpack_require__(280)['default'];
	
	exports.__esModule = true;
	
	var _errors = __webpack_require__(233);
	
	/**
	 * Extract JSON body from a server response
	 *
	 * @function getJSON
	 * @access public
	 * @param {object} res - A raw response object
	 * @returns {promise|undefined}
	 */
	function getJSON(res) {
	  var contentType, emptyCodes;
	  return _regeneratorRuntime.async(function getJSON$(context$1$0) {
	    while (1) switch (context$1$0.prev = context$1$0.next) {
	      case 0:
	        contentType = res.headers.get('Content-Type');
	        emptyCodes = [204, 205];
	
	        if (!(! ~emptyCodes.indexOf(res.status) && contentType && ~contentType.indexOf('json'))) {
	          context$1$0.next = 8;
	          break;
	        }
	
	        context$1$0.next = 5;
	        return _regeneratorRuntime.awrap(res.json());
	
	      case 5:
	        return context$1$0.abrupt('return', context$1$0.sent);
	
	      case 8:
	        context$1$0.next = 10;
	        return _regeneratorRuntime.awrap(_Promise.resolve());
	
	      case 10:
	        return context$1$0.abrupt('return', context$1$0.sent);
	
	      case 11:
	      case 'end':
	        return context$1$0.stop();
	    }
	  }, null, this);
	}
	
	/**
	 * Blow up string or symbol types into full-fledged type descriptors,
	 *   and add defaults
	 *
	 * @function normalizeTypeDescriptors
	 * @access private
	 * @param {array} types - The [CALL_API].types from a validated RSAA
	 * @returns {array}
	 */
	function normalizeTypeDescriptors(types) {
	  var requestType = types[0];
	  var successType = types[1];
	  var failureType = types[2];
	
	  if (typeof requestType === 'string' || typeof requestType === 'symbol') {
	    requestType = { type: requestType };
	  }
	
	  if (typeof successType === 'string' || typeof successType === 'symbol') {
	    successType = { type: successType };
	  }
	  successType = _extends({
	    payload: function payload(action, state, res) {
	      return getJSON(res);
	    }
	  }, successType);
	
	  if (typeof failureType === 'string' || typeof failureType === 'symbol') {
	    failureType = { type: failureType };
	  }
	  failureType = _extends({
	    payload: function payload(action, state, res) {
	      return getJSON(res).then(function (json) {
	        return new _errors.ApiError(res.status, res.statusText, json);
	      });
	    }
	  }, failureType);
	
	  return [requestType, successType, failureType];
	}
	
	/**
	 * Evaluate a type descriptor to an FSA
	 *
	 * @function actionWith
	 * @access private
	 * @param {object} descriptor - A type descriptor
	 * @param {array} args - The array of arguments for `payload` and `meta` function properties
	 * @returns {object}
	 */
	function actionWith(descriptor, args) {
	  return _regeneratorRuntime.async(function actionWith$(context$1$0) {
	    while (1) switch (context$1$0.prev = context$1$0.next) {
	      case 0:
	        context$1$0.prev = 0;
	        context$1$0.next = 3;
	        return _regeneratorRuntime.awrap(typeof descriptor.payload === 'function' ? descriptor.payload.apply(descriptor, args) : descriptor.payload);
	
	      case 3:
	        descriptor.payload = context$1$0.sent;
	        context$1$0.next = 10;
	        break;
	
	      case 6:
	        context$1$0.prev = 6;
	        context$1$0.t0 = context$1$0['catch'](0);
	
	        descriptor.payload = new _errors.InternalError(context$1$0.t0.message);
	        descriptor.error = true;
	
	      case 10:
	        context$1$0.prev = 10;
	        context$1$0.next = 13;
	        return _regeneratorRuntime.awrap(typeof descriptor.meta === 'function' ? descriptor.meta.apply(descriptor, args) : descriptor.meta);
	
	      case 13:
	        descriptor.meta = context$1$0.sent;
	        context$1$0.next = 21;
	        break;
	
	      case 16:
	        context$1$0.prev = 16;
	        context$1$0.t1 = context$1$0['catch'](10);
	
	        delete descriptor.meta;
	        descriptor.payload = new _errors.InternalError(context$1$0.t1.message);
	        descriptor.error = true;
	
	      case 21:
	        return context$1$0.abrupt('return', descriptor);
	
	      case 22:
	      case 'end':
	        return context$1$0.stop();
	    }
	  }, null, this, [[0, 6], [10, 16]]);
	}
	
	exports.getJSON = getJSON;
	exports.normalizeTypeDescriptors = normalizeTypeDescriptors;
	exports.actionWith = actionWith;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireDefault = __webpack_require__(194)['default'];
	
	exports.__esModule = true;
	
	var _CALL_API = __webpack_require__(232);
	
	var _CALL_API2 = _interopRequireDefault(_CALL_API);
	
	var _lodashIsplainobject = __webpack_require__(306);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	/**
	 * Is the given action a plain JavaScript object with a [CALL_API] property?
	 *
	 * @function isRSAA
	 * @access public
	 * @param {object} action - The action to check
	 * @returns {boolean}
	 */
	function isRSAA(action) {
	  return _lodashIsplainobject2['default'](action) && action.hasOwnProperty(_CALL_API2['default']);
	}
	
	/**
	 * Is the given object a valid type descriptor?
	 *
	 * @function isValidTypeDescriptor
	 * @access private
	 * @param {object} obj - The object to check agains the type descriptor definition
	 * @returns {boolean}
	 */
	function isValidTypeDescriptor(obj) {
	  var validKeys = ['type', 'payload', 'meta'];
	
	  if (!_lodashIsplainobject2['default'](obj)) {
	    return false;
	  }
	  for (var key in obj) {
	    if (! ~validKeys.indexOf(key)) {
	      return false;
	    }
	  }
	  if (!('type' in obj)) {
	    return false;
	  } else if (typeof obj.type !== 'string' && typeof obj.type !== 'symbol') {
	    return false;
	  }
	
	  return true;
	}
	
	/**
	 * Checks an action against the RSAA definition, returning a (possibly empty)
	 * array of validation errors.
	 *
	 * @function validateRSAA
	 * @access public
	 * @param {object} action - The action to check against the RSAA definition
	 * @returns {array}
	 */
	function validateRSAA(action) {
	  var validationErrors = [];
	  var validCallAPIKeys = ['endpoint', 'method', 'body', 'headers', 'credentials', 'bailout', 'types'];
	  var validMethods = ['GET', 'HEAD', 'POST', 'PUT', 'PATCH', 'DELETE', 'OPTIONS'];
	  var validCredentials = ['omit', 'same-origin', 'include'];
	
	  if (!isRSAA(action)) {
	    validationErrors.push('RSAAs must be plain JavaScript objects with a [CALL_API] property');
	    return validationErrors;
	  }
	
	  for (var key in action) {
	    if (key !== [_CALL_API2['default']]) {
	      validationErrors.push('Invalid root key: ' + key);
	    }
	  }
	
	  var callAPI = action[_CALL_API2['default']];
	  if (!_lodashIsplainobject2['default'](callAPI)) {
	    validationErrors.push('[CALL_API] property must be a plain JavaScript object');
	  }
	  for (var key in callAPI) {
	    if (! ~validCallAPIKeys.indexOf(key)) {
	      validationErrors.push('Invalid [CALL_API] key: ' + key);
	    }
	  }
	
	  var endpoint = callAPI.endpoint;
	  var method = callAPI.method;
	  var headers = callAPI.headers;
	  var credentials = callAPI.credentials;
	  var types = callAPI.types;
	  var bailout = callAPI.bailout;
	
	  if (typeof endpoint === 'undefined') {
	    validationErrors.push('[CALL_API] must have an endpoint property');
	  } else if (typeof endpoint !== 'string' && typeof endpoint !== 'function') {
	    validationErrors.push('[CALL_API].endpoint property must be a string or a function');
	  }
	  if (typeof method === 'undefined') {
	    validationErrors.push('[CALL_API] must have a method property');
	  } else if (typeof method !== 'string') {
	    validationErrors.push('[CALL_API].method property must be a string');
	  } else if (! ~validMethods.indexOf(method.toUpperCase())) {
	    validationErrors.push('Invalid [CALL_API].method: ' + method.toUpperCase());
	  }
	
	  if (typeof headers !== 'undefined' && !_lodashIsplainobject2['default'](headers) && typeof headers !== 'function') {
	    validationErrors.push('[CALL_API].headers property must be undefined, a plain JavaScript object, or a function');
	  }
	  if (typeof credentials !== 'undefined') {
	    if (typeof credentials !== 'string') {
	      validationErrors.push('[CALL_API].credentials property must be undefined, or a string');
	    } else if (! ~validCredentials.indexOf(credentials)) {
	      validationErrors.push('Invalid [CALL_API].credentials: ' + credentials);
	    }
	  }
	  if (typeof bailout !== 'undefined' && typeof bailout !== 'boolean' && typeof bailout !== 'function') {
	    validationErrors.push('[CALL_API].bailout property must be undefined, a boolean, or a function');
	  }
	
	  if (typeof types === 'undefined') {
	    validationErrors.push('[CALL_API] must have a types property');
	  } else if (!Array.isArray(types) || types.length !== 3) {
	    validationErrors.push('[CALL_API].types property must be an array of length 3');
	  } else {
	    var requestType = types[0];
	    var successType = types[1];
	    var failureType = types[2];
	
	    if (typeof requestType !== 'string' && typeof requestType !== 'symbol' && !isValidTypeDescriptor(requestType)) {
	      validationErrors.push('Invalid request type');
	    }
	    if (typeof successType !== 'string' && typeof successType !== 'symbol' && !isValidTypeDescriptor(successType)) {
	      validationErrors.push('Invalid success type');
	    }
	    if (typeof failureType !== 'string' && typeof failureType !== 'symbol' && !isValidTypeDescriptor(failureType)) {
	      validationErrors.push('Invalid failure type');
	    }
	  }
	
	  return validationErrors;
	}
	
	/**
	 * Is the given action a valid RSAA?
	 *
	 * @function isValidRSAA
	 * @access public
	 * @param {object} action - The action to check against the RSAA definition
	 * @returns {boolean}
	 */
	function isValidRSAA(action) {
	  return !validateRSAA(action).length;
	}
	
	exports.isRSAA = isRSAA;
	exports.isValidTypeDescriptor = isValidTypeDescriptor;
	exports.validateRSAA = validateRSAA;
	exports.isValidRSAA = isValidRSAA;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.untouch = exports.touch = exports.swapArrayValues = exports.submitFailed = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.reset = exports.removeArrayValue = exports.initialize = exports.focus = exports.destroy = exports.change = exports.blur = exports.autofill = exports.addArrayValue = undefined;
	
	var _actionTypes = __webpack_require__(234);
	
	var _isFunction = __webpack_require__(1169);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addArrayValue = exports.addArrayValue = function addArrayValue(path, value, index, fields) {
	  return { type: _actionTypes.ADD_ARRAY_VALUE, path: path, value: value, index: index, fields: fields };
	};
	
	var autofill = exports.autofill = function autofill(field, value) {
	  return { type: _actionTypes.AUTOFILL, field: field, value: value };
	};
	
	var blur = exports.blur = function blur(field, value) {
	  return { type: _actionTypes.BLUR, field: field, value: value };
	};
	
	var change = exports.change = function change(field, value) {
	  return { type: _actionTypes.CHANGE, field: field, value: value };
	};
	
	var destroy = exports.destroy = function destroy() {
	  return { type: _actionTypes.DESTROY };
	};
	
	var focus = exports.focus = function focus(field) {
	  return { type: _actionTypes.FOCUS, field: field };
	};
	
	var initialize = exports.initialize = function initialize(data, fields) {
	  var overwriteValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!Array.isArray(fields)) {
	    throw new Error('must provide fields array to initialize() action creator');
	  }
	  return { type: _actionTypes.INITIALIZE, data: data, fields: fields, overwriteValues: overwriteValues };
	};
	
	var removeArrayValue = exports.removeArrayValue = function removeArrayValue(path, indexOrPredicate) {
	  var index = void 0;
	  var predicate = void 0;
	
	  if ((0, _isFunction2.default)(indexOrPredicate)) {
	    predicate = indexOrPredicate;
	  } else {
	    index = indexOrPredicate;
	  }
	
	  return { type: _actionTypes.REMOVE_ARRAY_VALUE, path: path, index: index, predicate: predicate };
	};
	
	var reset = exports.reset = function reset() {
	  return { type: _actionTypes.RESET };
	};
	
	var startAsyncValidation = exports.startAsyncValidation = function startAsyncValidation(field) {
	  return { type: _actionTypes.START_ASYNC_VALIDATION, field: field };
	};
	
	var startSubmit = exports.startSubmit = function startSubmit() {
	  return { type: _actionTypes.START_SUBMIT };
	};
	
	var stopAsyncValidation = exports.stopAsyncValidation = function stopAsyncValidation(errors) {
	  return { type: _actionTypes.STOP_ASYNC_VALIDATION, errors: errors };
	};
	
	var stopSubmit = exports.stopSubmit = function stopSubmit(errors) {
	  return { type: _actionTypes.STOP_SUBMIT, errors: errors };
	};
	
	var submitFailed = exports.submitFailed = function submitFailed() {
	  return { type: _actionTypes.SUBMIT_FAILED };
	};
	
	var swapArrayValues = exports.swapArrayValues = function swapArrayValues(path, indexA, indexB) {
	  return { type: _actionTypes.SWAP_ARRAY_VALUES, path: path, indexA: indexA, indexB: indexB };
	};
	
	var touch = exports.touch = function touch() {
	  for (var _len = arguments.length, fields = Array(_len), _key = 0; _key < _len; _key++) {
	    fields[_key] = arguments[_key];
	  }
	
	  return { type: _actionTypes.TOUCH, fields: fields };
	};
	
	var untouch = exports.untouch = function untouch() {
	  for (var _len2 = arguments.length, fields = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    fields[_key2] = arguments[_key2];
	  }
	
	  return { type: _actionTypes.UNTOUCH, fields: fields };
	};

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = bindActionData;
	
	var _mapValues = __webpack_require__(235);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds additional properties to the results of the function or map of functions passed
	 */
	function bindActionData(action, data) {
	  if (typeof action === 'function') {
	    return function () {
	      return _extends({}, action.apply(undefined, arguments), data);
	    };
	  }
	  if (typeof action === 'object') {
	    return (0, _mapValues2.default)(action, function (value) {
	      return bindActionData(value, data);
	    });
	  }
	  return action;
	}

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reducer = __webpack_require__(236);
	
	var _initializeState = __webpack_require__(510);
	
	var _initializeState2 = _interopRequireDefault(_initializeState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createInitialState = function createInitialState(data, fields, state) {
	  var _extends2;
	
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var markInitialized = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
	
	  return _extends({}, (0, _initializeState2.default)(data, fields, state, overwriteValues), (_extends2 = {
	    _initData: data,
	    _asyncValidating: false,
	    _active: undefined
	  }, _extends2[_reducer.globalErrorKey] = undefined, _extends2._initialized = markInitialized, _extends2._submitting = false, _extends2._submitFailed = false, _extends2));
	};
	
	exports.default = createInitialState;

/***/ },
/* 502 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var dataKey = exports.dataKey = 'value';
	var createOnDragStart = function createOnDragStart(name, getValue) {
	  return function (event) {
	    event.dataTransfer.setData(dataKey, getValue());
	  };
	};
	
	exports.default = createOnDragStart;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(504);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var _event$target = event.target,
	        type = _event$target.type,
	        value = _event$target.value,
	        checked = _event$target.checked,
	        files = _event$target.files,
	        dataTransfer = event.dataTransfer;
	
	    if (type === 'checkbox') {
	      return checked;
	    }
	    if (type === 'radio') {
	      return checked ? value : '';
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    if (value !== '' && (type === 'number' || type === 'range')) {
	      return parseFloat(value);
	    }
	    return value;
	  }
	  // not an event, so must be either our value or an object containing our value in the 'value' key
	  return event && typeof event === 'object' && Object.keys(event).length === 1 && event.value !== undefined ? event.value : // extract value from { value: value } structure. https://github.com/nikgraf/belle/issues/58
	  event;
	};
	
	exports.default = getValue;

/***/ },
/* 504 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isEvent = __webpack_require__(504);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	
	exports.default = silenceEvent;

/***/ },
/* 506 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getDisplayName;
	function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	}

/***/ },
/* 507 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Given a state[field], get the value.
	 *  Fallback to .initialValue when .value is undefined to prevent double render/initialize cycle.
	 *  See {@link https://github.com/erikras/redux-form/issues/621}.
	 */
	var itemToValue = function itemToValue(_ref) {
	  var value = _ref.value,
	      initialValue = _ref.initialValue;
	  return typeof value !== 'undefined' ? value : initialValue;
	};
	
	var getValue = function getValue(field, state, dest) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = field.substring(0, openIndex);
	    var rest = field.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    var array = state && state[key] || [];
	    if (rest) {
	      if (!dest[key]) {
	        dest[key] = [];
	      }
	      array.forEach(function (item, index) {
	        if (!dest[key][index]) {
	          dest[key][index] = {};
	        }
	        getValue(rest, item, dest[key][index]);
	      });
	    } else {
	      dest[key] = array.map(itemToValue);
	    }
	  } else if (dotIndex > 0) {
	    // subobject field
	    var _key = field.substring(0, dotIndex);
	    var _rest = field.substring(dotIndex + 1);
	    if (!dest[_key]) {
	      dest[_key] = {};
	    }
	    getValue(_rest, state && state[_key] || {}, dest[_key]);
	  } else {
	    dest[field] = state[field] && itemToValue(state[field]);
	  }
	};
	
	var getValues = function getValues(fields, state) {
	  return fields.reduce(function (accumulator, field) {
	    getValue(field, state, accumulator);
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValues;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(105);
	
	/**
	 * A different version of getValues() that does not need the fields array
	 */
	var getValuesFromState = function getValuesFromState(state) {
	  if (!state) {
	    return state;
	  }
	  var keys = Object.keys(state);
	  if (!keys.length) {
	    return undefined;
	  }
	  return keys.reduce(function (accumulator, key) {
	    var field = state[key];
	    if (field) {
	      if ((0, _fieldValue.isFieldValue)(field)) {
	        if (field.value !== undefined) {
	          accumulator[key] = field.value;
	        }
	      } else if (Array.isArray(field)) {
	        accumulator[key] = field.map(function (arrayField) {
	          return (0, _fieldValue.isFieldValue)(arrayField) ? arrayField.value : getValuesFromState(arrayField);
	        });
	      } else if (typeof field === 'object') {
	        var result = getValuesFromState(field);
	
	        if (result && Object.keys(result).length > 0) {
	          accumulator[key] = result;
	        }
	      }
	    }
	    return accumulator;
	  }, {});
	};
	
	exports.default = getValuesFromState;

/***/ },
/* 509 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(105);
	
	var makeEntry = function makeEntry(value, previousValue, overwriteValues) {
	  if (value === undefined && previousValue === undefined) return (0, _fieldValue.makeFieldValue)({});
	  return (0, _fieldValue.makeFieldValue)({
	    initial: value,
	    value: overwriteValues ? value : previousValue
	  });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var initializeState = function initializeState(values, fields) {
	  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var overwriteValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	
	  if (!fields) {
	    throw new Error('fields must be passed when initializing state');
	  }
	  if (!values || !fields.length) {
	    return state;
	  }
	  var initializeField = function initializeField(path, src, dest) {
	    var dotIndex = path.indexOf('.');
	    if (dotIndex === 0) {
	      return initializeField(path.substring(1), src, dest);
	    }
	    var openIndex = path.indexOf('[');
	    var closeIndex = path.indexOf(']');
	    var result = _extends({}, dest) || {};
	    if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	      // is dot notation
	      var key = path.substring(0, dotIndex);
	      result[key] = src[key] && initializeField(path.substring(dotIndex + 1), src[key], result[key] || {});
	    } else if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	      // is array notation
	      if (closeIndex < 0) {
	        throw new Error('found \'[\' but no \']\': \'' + path + '\'');
	      }
	      var _key = path.substring(0, openIndex);
	      var srcArray = src[_key];
	      var destArray = result[_key];
	      var rest = path.substring(closeIndex + 1);
	      if (Array.isArray(srcArray)) {
	        if (rest.length) {
	          // need to keep recursing
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return initializeField(rest, srcValue, destArray && destArray[srcIndex]);
	          });
	        } else {
	          result[_key] = srcArray.map(function (srcValue, srcIndex) {
	            return makeEntry(srcValue, destArray && destArray[srcIndex] && destArray[srcIndex].value, overwriteValues);
	          });
	        }
	      } else {
	        result[_key] = [];
	      }
	    } else {
	      result[path] = makeEntry(src && src[path], dest && dest[path] && dest[path].value, overwriteValues);
	    }
	    return result;
	  };
	  return fields.reduce(function (accumulator, field) {
	    return initializeField(field, values, accumulator);
	  }, _extends({}, state));
	};
	
	exports.default = initializeState;

/***/ },
/* 511 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isChecked = function isChecked(value) {
	  if (typeof value === 'boolean') {
	    return value;
	  }
	  if (typeof value === 'string') {
	    var lower = value.toLowerCase();
	    if (lower === 'true') {
	      return true;
	    }
	    if (lower === 'false') {
	      return false;
	    }
	  }
	  return undefined;
	};
	
	exports.default = isChecked;

/***/ },
/* 512 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Reads any potentially deep value from an object using dot and array syntax
	 */
	var read = function read(path, object) {
	  if (!path || !object) {
	    return object;
	  }
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return read(path.substring(1), object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    // iterate down object tree
	    return read(path.substring(dotIndex + 1), object[path.substring(0, dotIndex)]);
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    if (!index.length) {
	      return object[key];
	    }
	    if (openIndex === 0) {
	      return read(path.substring(closeIndex + 1), object[index]);
	    }
	    if (!object[key]) {
	      return undefined;
	    }
	    return read(path.substring(closeIndex + 1), object[key][index]);
	  }
	  return object[path];
	};
	
	exports.default = read;

/***/ },
/* 513 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Writes any potentially deep value from an object using dot and array syntax,
	 * and returns a new copy of the object.
	 */
	var write = function write(path, value, object) {
	  var _extends7;
	
	  var dotIndex = path.indexOf('.');
	  if (dotIndex === 0) {
	    return write(path.substring(1), value, object);
	  }
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (dotIndex >= 0 && (openIndex < 0 || dotIndex < openIndex)) {
	    var _extends2;
	
	    // is dot notation
	    var key = path.substring(0, dotIndex);
	    return _extends({}, object, (_extends2 = {}, _extends2[key] = write(path.substring(dotIndex + 1), value, object[key] || {}), _extends2));
	  }
	  if (openIndex >= 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    var _extends6;
	
	    // is array notation
	    if (closeIndex < 0) {
	      throw new Error('found [ but no ]');
	    }
	    var _key = path.substring(0, openIndex);
	    var index = path.substring(openIndex + 1, closeIndex);
	    var array = object[_key] || [];
	    var rest = path.substring(closeIndex + 1);
	    if (index) {
	      var _extends4;
	
	      // indexed array
	      if (rest.length) {
	        var _extends3;
	
	        // need to keep recursing
	        var dest = array[index] || {};
	        var arrayCopy = [].concat(array);
	        arrayCopy[index] = write(rest, value, dest);
	        return _extends({}, object || {}, (_extends3 = {}, _extends3[_key] = arrayCopy, _extends3));
	      }
	      var copy = [].concat(array);
	      copy[index] = typeof value === 'function' ? value(copy[index]) : value;
	      return _extends({}, object || {}, (_extends4 = {}, _extends4[_key] = copy, _extends4));
	    }
	    // indexless array
	    if (rest.length) {
	      var _extends5;
	
	      // need to keep recursing
	      if ((!array || !array.length) && typeof value === 'function') {
	        return object; // don't even set a value under [key]
	      }
	      var _arrayCopy = array.map(function (dest) {
	        return write(rest, value, dest);
	      });
	      return _extends({}, object || {}, (_extends5 = {}, _extends5[_key] = _arrayCopy, _extends5));
	    }
	    var result = void 0;
	    if (Array.isArray(value)) {
	      result = value;
	    } else if (object[_key]) {
	      result = array.map(function (dest) {
	        return typeof value === 'function' ? value(dest) : value;
	      });
	    } else if (typeof value === 'function') {
	      return object; // don't even set a value under [key]
	    } else {
	      result = value;
	    }
	    return _extends({}, object || {}, (_extends6 = {}, _extends6[_key] = result, _extends6));
	  }
	  return _extends({}, object, (_extends7 = {}, _extends7[path] = typeof value === 'function' ? value(object[path]) : value, _extends7));
	};
	
	exports.default = write;

/***/ },
/* 514 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(222);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1193);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 516 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 517 */
/***/ function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(517);
	
	var supportsDescriptors = __webpack_require__(115).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1190);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 520 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 521 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  module.exports["default"] = module.exports, module.exports.__esModule = true;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 522 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	
	    module.exports["default"] = module.exports, module.exports.__esModule = true;
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;
	module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ScriptLoader = void 0;
	var Utils_1 = __webpack_require__(238);
	var createState = function () { return ({
	    listeners: [],
	    scriptId: Utils_1.uuid('tiny-script'),
	    scriptLoading: false,
	    scriptLoaded: false
	}); };
	var CreateScriptLoader = function () {
	    var state = createState();
	    var injectScriptTag = function (scriptId, doc, url, async, defer, callback) {
	        var scriptTag = doc.createElement('script');
	        scriptTag.referrerPolicy = 'origin';
	        scriptTag.type = 'application/javascript';
	        scriptTag.id = scriptId;
	        scriptTag.src = url;
	        scriptTag.async = async;
	        scriptTag.defer = defer;
	        var handler = function () {
	            scriptTag.removeEventListener('load', handler);
	            callback();
	        };
	        scriptTag.addEventListener('load', handler);
	        if (doc.head) {
	            doc.head.appendChild(scriptTag);
	        }
	    };
	    var load = function (doc, url, async, defer, delay, callback) {
	        var scriptTagInjection = function () { return injectScriptTag(state.scriptId, doc, url, async, defer, function () {
	            state.listeners.forEach(function (fn) { return fn(); });
	            state.scriptLoaded = true;
	        }); };
	        if (state.scriptLoaded) {
	            callback();
	        }
	        else {
	            state.listeners.push(callback);
	            if (!state.scriptLoading) {
	                state.scriptLoading = true;
	                if (delay > 0) {
	                    setTimeout(scriptTagInjection, delay);
	                }
	                else {
	                    scriptTagInjection();
	                }
	            }
	        }
	    };
	    // Only to be used by tests.
	    var reinitialize = function () {
	        state = createState();
	    };
	    return {
	        load: load,
	        reinitialize: reinitialize
	    };
	};
	var ScriptLoader = CreateScriptLoader();
	exports.ScriptLoader = ScriptLoader;


/***/ },
/* 524 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getTinymce = void 0;
	var getGlobal = function () { return (typeof window !== 'undefined' ? window : global); };
	var getTinymce = function () {
	    var global = getGlobal();
	    return global && global.tinymce ? global.tinymce : null;
	};
	exports.getTinymce = getTinymce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var React = __webpack_require__(1);
	var ScriptLoader_1 = __webpack_require__(523);
	var TinyMCE_1 = __webpack_require__(524);
	var Utils_1 = __webpack_require__(238);
	var EditorPropTypes_1 = __webpack_require__(239);
	var changeEvents = function () { var _a, _b, _c; return ((_c = (_b = (_a = TinyMCE_1.getTinymce()) === null || _a === void 0 ? void 0 : _a.Env) === null || _b === void 0 ? void 0 : _b.browser) === null || _c === void 0 ? void 0 : _c.isIE()) ? 'change keyup compositionend setcontent' : 'change input compositionend setcontent'; };
	var beforeInputEvent = function () { return Utils_1.isBeforeInputEventAvailable() ? 'beforeinput SelectionChange' : 'SelectionChange'; };
	var Editor = /** @class */ (function (_super) {
	    __extends(Editor, _super);
	    function Editor(props) {
	        var _a, _b, _c;
	        var _this = _super.call(this, props) || this;
	        _this.rollbackTimer = undefined;
	        _this.valueCursor = undefined;
	        _this.rollbackChange = function () {
	            var editor = _this.editor;
	            var value = _this.props.value;
	            if (editor && value && value !== _this.currentContent) {
	                editor.undoManager.ignore(function () {
	                    editor.setContent(value);
	                    // only restore cursor on inline editors when they are focused
	                    // as otherwise it will cause a focus grab
	                    if (_this.valueCursor && (!_this.inline || editor.hasFocus())) {
	                        try {
	                            editor.selection.moveToBookmark(_this.valueCursor);
	                        }
	                        catch (e) { /* ignore */ }
	                    }
	                });
	            }
	            _this.rollbackTimer = undefined;
	        };
	        _this.handleBeforeInput = function (_evt) {
	            if (_this.props.value !== undefined && _this.props.value === _this.currentContent && _this.editor) {
	                if (!_this.inline || _this.editor.hasFocus) {
	                    try {
	                        // getBookmark throws exceptions when the editor has not been focused
	                        // possibly only in inline mode but I'm not taking chances
	                        _this.valueCursor = _this.editor.selection.getBookmark(3);
	                    }
	                    catch (e) { /* ignore */ }
	                }
	            }
	        };
	        _this.handleBeforeInputSpecial = function (evt) {
	            if (evt.key === 'Enter' || evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleBeforeInput(evt);
	            }
	        };
	        _this.handleEditorChange = function (_evt) {
	            var editor = _this.editor;
	            if (editor && editor.initialized) {
	                var newContent = editor.getContent();
	                if (_this.props.value !== undefined && _this.props.value !== newContent) {
	                    // start a timer and revert to the value if not applied in time
	                    if (!_this.rollbackTimer) {
	                        _this.rollbackTimer = window.setTimeout(_this.rollbackChange, 200);
	                    }
	                }
	                if (newContent !== _this.currentContent) {
	                    _this.currentContent = newContent;
	                    if (Utils_1.isFunction(_this.props.onEditorChange)) {
	                        var format = _this.props.outputFormat;
	                        var out = format === 'html' ? newContent : editor.getContent({ format: format });
	                        _this.props.onEditorChange(out, editor);
	                    }
	                }
	            }
	        };
	        _this.handleEditorChangeSpecial = function (evt) {
	            if (evt.key === 'Backspace' || evt.key === 'Delete') {
	                _this.handleEditorChange(evt);
	            }
	        };
	        _this.initialise = function () {
	            var target = _this.elementRef.current;
	            if (!target) {
	                return; // Editor has been unmounted
	            }
	            var tinymce = TinyMCE_1.getTinymce();
	            if (!tinymce) {
	                throw new Error('tinymce should have been loaded into global scope');
	            }
	            var finalInit = __assign(__assign({}, _this.props.init), { selector: undefined, target: target, readonly: _this.props.disabled, inline: _this.inline, plugins: Utils_1.mergePlugins(_this.props.init && _this.props.init.plugins, _this.props.plugins), toolbar: _this.props.toolbar || (_this.props.init && _this.props.init.toolbar), setup: function (editor) {
	                    _this.editor = editor;
	                    _this.bindHandlers({});
	                    // When running in inline mode the editor gets the initial value
	                    // from the innerHTML of the element it is initialized on.
	                    // However we don't want to take on the responsibility of sanitizing
	                    // to remove XSS in the react integration so we have a chicken and egg
	                    // problem... We avoid it by sneaking in a set content before the first
	                    // "official" setContent and using TinyMCE to do the sanitization.
	                    if (_this.inline && !Utils_1.isTextareaOrInput(target)) {
	                        editor.once('PostRender', function (_evt) {
	                            editor.setContent(_this.getInitialValue(), { no_events: true });
	                        });
	                    }
	                    if (_this.props.init && Utils_1.isFunction(_this.props.init.setup)) {
	                        _this.props.init.setup(editor);
	                    }
	                }, init_instance_callback: function (editor) {
	                    var _a, _b;
	                    // check for changes that happened since tinymce.init() was called
	                    var initialValue = _this.getInitialValue();
	                    _this.currentContent = (_a = _this.currentContent) !== null && _a !== void 0 ? _a : editor.getContent();
	                    if (_this.currentContent !== initialValue) {
	                        _this.currentContent = initialValue;
	                        // same as resetContent in TinyMCE 5
	                        editor.setContent(initialValue);
	                        editor.undoManager.clear();
	                        editor.undoManager.add();
	                        editor.setDirty(false);
	                    }
	                    var disabled = (_b = _this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    editor.setMode(disabled ? 'readonly' : 'design');
	                    // ensure existing init_instance_callback is called
	                    if (_this.props.init && Utils_1.isFunction(_this.props.init.init_instance_callback)) {
	                        _this.props.init.init_instance_callback(editor);
	                    }
	                } });
	            if (!_this.inline) {
	                target.style.visibility = '';
	            }
	            if (Utils_1.isTextareaOrInput(target)) {
	                target.value = _this.getInitialValue();
	            }
	            tinymce.init(finalInit);
	        };
	        _this.id = _this.props.id || Utils_1.uuid('tiny-react');
	        _this.elementRef = React.createRef();
	        _this.inline = (_c = (_a = _this.props.inline) !== null && _a !== void 0 ? _a : (_b = _this.props.init) === null || _b === void 0 ? void 0 : _b.inline) !== null && _c !== void 0 ? _c : false;
	        _this.boundHandlers = {};
	        return _this;
	    }
	    Editor.prototype.componentDidUpdate = function (prevProps) {
	        var _this = this;
	        var _a, _b;
	        if (this.rollbackTimer) {
	            clearTimeout(this.rollbackTimer);
	            this.rollbackTimer = undefined;
	        }
	        if (this.editor) {
	            this.bindHandlers(prevProps);
	            if (this.editor.initialized) {
	                this.currentContent = (_a = this.currentContent) !== null && _a !== void 0 ? _a : this.editor.getContent();
	                if (typeof this.props.initialValue === 'string' && this.props.initialValue !== prevProps.initialValue) {
	                    // same as resetContent in TinyMCE 5
	                    this.editor.setContent(this.props.initialValue);
	                    this.editor.undoManager.clear();
	                    this.editor.undoManager.add();
	                    this.editor.setDirty(false);
	                }
	                else if (typeof this.props.value === 'string' && this.props.value !== this.currentContent) {
	                    var localEditor_1 = this.editor;
	                    localEditor_1.undoManager.transact(function () {
	                        // inline editors grab focus when restoring selection
	                        // so we don't try to keep their selection unless they are currently focused
	                        var cursor;
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            try {
	                                // getBookmark throws exceptions when the editor has not been focused
	                                // possibly only in inline mode but I'm not taking chances
	                                cursor = localEditor_1.selection.getBookmark(3);
	                            }
	                            catch (e) { /* ignore */ }
	                        }
	                        var valueCursor = _this.valueCursor;
	                        localEditor_1.setContent(_this.props.value);
	                        if (!_this.inline || localEditor_1.hasFocus()) {
	                            for (var _i = 0, _a = [cursor, valueCursor]; _i < _a.length; _i++) {
	                                var bookmark = _a[_i];
	                                if (bookmark) {
	                                    try {
	                                        localEditor_1.selection.moveToBookmark(bookmark);
	                                        _this.valueCursor = bookmark;
	                                        break;
	                                    }
	                                    catch (e) { /* ignore */ }
	                                }
	                            }
	                        }
	                    });
	                }
	                if (this.props.disabled !== prevProps.disabled) {
	                    var disabled = (_b = this.props.disabled) !== null && _b !== void 0 ? _b : false;
	                    this.editor.setMode(disabled ? 'readonly' : 'design');
	                }
	            }
	        }
	    };
	    Editor.prototype.componentDidMount = function () {
	        var _a, _b, _c, _d, _e, _f;
	        if (TinyMCE_1.getTinymce() !== null) {
	            this.initialise();
	        }
	        else if (this.elementRef.current && this.elementRef.current.ownerDocument) {
	            ScriptLoader_1.ScriptLoader.load(this.elementRef.current.ownerDocument, this.getScriptSrc(), (_b = (_a = this.props.scriptLoading) === null || _a === void 0 ? void 0 : _a.async) !== null && _b !== void 0 ? _b : false, (_d = (_c = this.props.scriptLoading) === null || _c === void 0 ? void 0 : _c.defer) !== null && _d !== void 0 ? _d : false, (_f = (_e = this.props.scriptLoading) === null || _e === void 0 ? void 0 : _e.delay) !== null && _f !== void 0 ? _f : 0, this.initialise);
	        }
	    };
	    Editor.prototype.componentWillUnmount = function () {
	        var _this = this;
	        var editor = this.editor;
	        if (editor) {
	            editor.off(changeEvents(), this.handleEditorChange);
	            editor.off(beforeInputEvent(), this.handleBeforeInput);
	            editor.off('keypress', this.handleEditorChangeSpecial);
	            editor.off('keydown', this.handleBeforeInputSpecial);
	            editor.off('NewBlock', this.handleEditorChange);
	            Object.keys(this.boundHandlers).forEach(function (eventName) {
	                editor.off(eventName, _this.boundHandlers[eventName]);
	            });
	            this.boundHandlers = {};
	            editor.remove();
	            this.editor = undefined;
	        }
	    };
	    Editor.prototype.render = function () {
	        return this.inline ? this.renderInline() : this.renderIframe();
	    };
	    Editor.prototype.renderInline = function () {
	        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
	        return React.createElement(tagName, {
	            ref: this.elementRef,
	            id: this.id
	        });
	    };
	    Editor.prototype.renderIframe = function () {
	        return React.createElement('textarea', {
	            ref: this.elementRef,
	            style: { visibility: 'hidden' },
	            name: this.props.textareaName,
	            id: this.id
	        });
	    };
	    Editor.prototype.getScriptSrc = function () {
	        if (typeof this.props.tinymceScriptSrc === 'string') {
	            return this.props.tinymceScriptSrc;
	        }
	        else {
	            var channel = this.props.cloudChannel;
	            var apiKey = this.props.apiKey ? this.props.apiKey : 'no-api-key';
	            return "https://cdn.tiny.cloud/1/" + apiKey + "/tinymce/" + channel + "/tinymce.min.js";
	        }
	    };
	    Editor.prototype.getInitialValue = function () {
	        if (typeof this.props.initialValue === 'string') {
	            return this.props.initialValue;
	        }
	        else if (typeof this.props.value === 'string') {
	            return this.props.value;
	        }
	        else {
	            return '';
	        }
	    };
	    Editor.prototype.bindHandlers = function (prevProps) {
	        var _this = this;
	        if (this.editor !== undefined) {
	            // typescript chokes trying to understand the type of the lookup function
	            Utils_1.configHandlers(this.editor, prevProps, this.props, this.boundHandlers, function (key) { return _this.props[key]; });
	            // check if we should monitor editor changes
	            var isValueControlled = function (p) { return p.onEditorChange !== undefined || p.value !== undefined; };
	            var wasControlled = isValueControlled(prevProps);
	            var nowControlled = isValueControlled(this.props);
	            if (!wasControlled && nowControlled) {
	                this.editor.on(changeEvents(), this.handleEditorChange);
	                this.editor.on(beforeInputEvent(), this.handleBeforeInput);
	                this.editor.on('keydown', this.handleBeforeInputSpecial);
	                this.editor.on('keyup', this.handleEditorChangeSpecial);
	                this.editor.on('NewBlock', this.handleEditorChange);
	            }
	            else if (wasControlled && !nowControlled) {
	                this.editor.off(changeEvents(), this.handleEditorChange);
	                this.editor.off(beforeInputEvent(), this.handleBeforeInput);
	                this.editor.off('keydown', this.handleBeforeInputSpecial);
	                this.editor.off('keyup', this.handleEditorChangeSpecial);
	                this.editor.off('NewBlock', this.handleEditorChange);
	            }
	        }
	    };
	    Editor.propTypes = EditorPropTypes_1.EditorPropTypes;
	    Editor.defaultProps = {
	        cloudChannel: '5'
	    };
	    return Editor;
	}(React.Component));
	exports.Editor = Editor;


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/**
	 * Copyright (c) 2017-present, Ephox, Inc.
	 *
	 * This source code is licensed under the Apache 2 license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Editor = void 0;
	var Editor_1 = __webpack_require__(525);
	Object.defineProperty(exports, "Editor", { enumerable: true, get: function () { return Editor_1.Editor; } });


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(529);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(527)();
	}


/***/ },
/* 529 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleDistanceModal = toggleDistanceModal;
	exports.submitDistance = submitDistance;
	exports.removeDistance = removeDistance;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/distances';
	function toggleDistanceModal() {
	    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    return {
	        type: _types2.default.TOGGLE_DISTANCE_MODAL,
	        payload: {
	            toggle: toggle,
	            distance: distance
	        }
	    };
	}
	function submitDistance(values) {
	    return (0, _common.submitElement)(apiUrl, values, _types2.default.SUBMIT_DISTANCE);
	}
	
	function removeDistance(distance) {
	    return (0, _common.deleteElement)(apiUrl, distance.id, _types2.default.DELETE_DISTANCE);
	}

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.toggleNavBar = toggleNavBar;
	exports.hideNavBar = hideNavBar;
	exports.showNavBar = showNavBar;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toggleNavBar() {
	    return {
	        type: _types2.default.TOGGLE_NAVBAR
	    };
	}
	function hideNavBar() {
	    return {
	        type: _types2.default.HIDE_NAVBAR
	    };
	}
	function showNavBar() {
	    return {
	        type: _types2.default.SHOW_NAVBAR
	    };
	}

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchImages = fetchImages;
	exports.deleteImage = deleteImage;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/images';
	
	function fetchImages() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.LOAD_IMAGES);
	}
	
	function deleteImage(id) {
	    return (0, _common.deleteElement)(apiUrl, id, _types2.default.DELETE_IMAGE);
	}

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchInvoicesPaginated = fetchInvoicesPaginated;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/invoices';
	
	function fetchInvoicesPaginated() {
	    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
	
	    return (0, _common.fetchElementsPaginated)(apiUrl + '/paginated', page, size, _types2.default.ADMIN_LOAD_INVOICES);
	}

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchResults = fetchResults;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/results';
	
	function fetchResults() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl,
	        method: 'GET',
	        types: _types2.default.LOAD_RESULTS.all
	    });
	}

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.submitSettings = submitSettings;
	exports.fetchSettings = fetchSettings;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var apiUrl = '/api/settings';
	
	function submitSettings(values) {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl,
	        method: 'PUT',
	        body: values,
	        types: _types2.default.SUBMIT_SETTINGS.all
	    });
	}
	function fetchSettings() {
	    return _defineProperty({}, _reduxApiMiddleware.CALL_API, {
	        endpoint: apiUrl,
	        method: 'GET',
	        types: _types2.default.LOAD_SETTINGS.all
	    });
	}

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.fetchStatistics = fetchStatistics;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _common = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var apiUrl = '/api/statistics';
	function fetchStatistics() {
	
	    return (0, _common.fetchElement)(apiUrl, '', _types2.default.LOAD_STATISTICS);
	}

/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _internalImageV = __webpack_require__(107);
	
	var _internalImageV2 = _interopRequireDefault(_internalImageV);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _languageCookie = __webpack_require__(43);
	
	var _app = __webpack_require__(531);
	
	var appActions = _interopRequireWildcard(_app);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppHeader = function (_Component) {
	    _inherits(AppHeader, _Component);
	
	    function AppHeader() {
	        _classCallCheck(this, AppHeader);
	
	        return _possibleConstructorReturn(this, (AppHeader.__proto__ || Object.getPrototypeOf(AppHeader)).apply(this, arguments));
	    }
	
	    _createClass(AppHeader, [{
	        key: 'isURL',
	        value: function isURL(str) {
	            var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
	            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
	            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
	            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
	            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
	            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
	            return pattern.test(str);
	        }
	    }, {
	        key: 'onNavigate',
	        value: function onNavigate() {
	            this.props.actions.hideNavBar();
	        }
	    }, {
	        key: 'getLinkDisplay',
	        value: function getLinkDisplay(menu) {
	            var label = (0, _languageCookie.isEnglish)() ? menu.title_en : menu.title_lt;
	            if (this.isURL(menu.url)) {
	                return _react2.default.createElement(
	                    'a',
	                    { href: menu.url },
	                    label
	                );
	            }
	            return _react2.default.createElement(
	                _reactRouter.Link,
	                { to: menu.url, onClick: this.onNavigate.bind(this) },
	                label
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var menu = window.CARE_CONFIG.settings.menu || [];
	            return _react2.default.createElement(
	                'header',
	                { className: 'site-header' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'mobile-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'logo' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/', onClick: this.onNavigate.bind(this) },
	                                _react2.default.createElement(_internalImageV2.default, {
	                                    filename: window.CARE_CONFIG.settings.logo ? window.CARE_CONFIG.settings.logo.filename : undefined,
	                                    alt: window.CARE_CONFIG.settings.title
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'menu-button', onClick: this.props.actions.toggleNavBar },
	                            _react2.default.createElement(_icon2.default, { icon: 'menu', size: 's' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        { className: (0, _classnames2.default)('nav', this.props.expanded && 'active') },
	                        menu.map(function (menu, index) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: index },
	                                _this2.getLinkDisplay(menu)
	                            );
	                        })
	                    ),
	                    window.CARE_CONFIG.settings.localization_enabled ? this.renderLangSwitcher() : null
	                )
	            );
	        }
	    }, {
	        key: 'renderLangSwitcher',
	        value: function renderLangSwitcher() {
	            return _react2.default.createElement(
	                'div',
	                { style: { padding: '8px 15px' } },
	                ['lt', 'en'].map(function (lang) {
	                    return _react2.default.createElement(
	                        'a',
	                        { style: { paddingRight: '10px', textTransform: 'uppercase' }, onClick: function onClick() {
	                                (0, _languageCookie.saveLanguageCookie)(lang);
	                                window.location.reload();
	                            }, key: lang },
	                        _react2.default.createElement('img', { src: __webpack_require__(1249)("./flag-" + lang + '.png'), alt: lang })
	                    );
	                })
	            );
	        }
	    }]);
	
	    return AppHeader;
	}(_react.Component);
	// <li>
	//     <Link to={'/'} onClick={this.onNavigate.bind(this)}>{LocalizedStrings.hello}</Link>
	// </li>
	// <li>
	//     <Link to={'/posts'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.news}</Link>
	// </li>
	// <li>
	//     <Link to={'/regulations'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.regulations}</Link>
	// </li>
	// <li>
	//     <Link to={'/stages'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.stages}</Link>
	// </li>
	// <li>
	//     <Link to={'/results'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.results}</Link>
	// </li>
	//
	// <li>
	//     <Link to={'/archive'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.archive}</Link>
	// </li>
	// <li>
	//     <Link to={'/contact'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.contacts}</Link>
	// </li>
	// <li>
	//     <Link to={'/about'} activeClassName="active" onClick={this.onNavigate.bind(this)}>{LocalizedStrings.about}</Link>
	// </li>
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { expanded: state.app.expandedNav };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, appActions), dispatch)
	    };
	})(AppHeader);

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ButtonRound;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function ButtonRound(props) {
	    var className = props.className,
	        _props$type = props.type,
	        type = _props$type === undefined ? 'primary' : _props$type,
	        _props$active = props.active,
	        active = _props$active === undefined ? false : _props$active,
	        _props$size = props.size,
	        size = _props$size === undefined ? 'm' : _props$size,
	        _props$icon = props.icon,
	        icon = _props$icon === undefined ? 'plus' : _props$icon,
	        _props$onClick = props.onClick,
	        _onClick = _props$onClick === undefined ? null : _props$onClick,
	        restprops = _objectWithoutProperties(props, ['className', 'type', 'active', 'size', 'icon', 'onClick']);
	
	    var classname = (0, _classnames2.default)('btn-round', 'btn-' + type, 'btn-size-' + size, className, { active: active });
	
	    return _react2.default.createElement(
	        'button',
	        _extends({ type: 'button', onClick: function onClick(e) {
	                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                    args[_key - 1] = arguments[_key];
	                }
	
	                if (_onClick) {
	                    e.preventDefault();e.stopPropagation();_onClick.apply(undefined, [e].concat(args));
	                }
	            } }, restprops, { className: classname }),
	        _react2.default.createElement(_icon2.default, { icon: icon, size: size })
	    );
	}

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DistanceSelection = function (_Component) {
	    _inherits(DistanceSelection, _Component);
	
	    function DistanceSelection() {
	        _classCallCheck(this, DistanceSelection);
	
	        return _possibleConstructorReturn(this, (DistanceSelection.__proto__ || Object.getPrototypeOf(DistanceSelection)).apply(this, arguments));
	    }
	
	    _createClass(DistanceSelection, [{
	        key: 'render',
	        value: function render() {
	            if (!this.props.distances) {
	                return null;
	            }
	            return _react2.default.createElement(_select2.default, { clearable: true, options: this.props.distances, noResultsText: _strings2.default.noDistances, placeholder: _strings2.default.distance, onChange: this.props.onChange, value: this.props.value, searchable: false, resetValue: null });
	        }
	    }]);
	
	    return DistanceSelection;
	}(_react.Component);
	
	exports.default = DistanceSelection;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactColor = __webpack_require__(1072);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ColorSelectField = function (_Component) {
	    _inherits(ColorSelectField, _Component);
	
	    function ColorSelectField() {
	        _classCallCheck(this, ColorSelectField);
	
	        return _possibleConstructorReturn(this, (ColorSelectField.__proto__ || Object.getPrototypeOf(ColorSelectField)).apply(this, arguments));
	    }
	
	    _createClass(ColorSelectField, [{
	        key: 'onChange',
	        value: function onChange(color) {
	            var rgb = color.rgb;
	            this.props.onChange(rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a);
	        }
	    }, {
	        key: 'parseString',
	        value: function parseString(string) {
	            if (!string) {
	                return;
	            }
	            var colors = string.split(',');
	            return { r: colors[0], g: colors[1], b: colors[2], a: colors[3] };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(_reactColor.SketchPicker, {
	                color: this.parseString(this.props.value),
	                onChangeComplete: this.onChange.bind(this) });
	        }
	    }]);
	
	    return ColorSelectField;
	}(_react.Component);
	
	exports.default = ColorSelectField;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = fileField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDropzone = __webpack_require__(465);
	
	var _reactDropzone2 = _interopRequireDefault(_reactDropzone);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fileField(props) {
	    var onChange = props.onChange,
	        value = props.value,
	        name = props.name;
	
	    return _react2.default.createElement(
	        _reactDropzone2.default,
	        { onDrop: function onDrop(filesToUpload) {
	                onChange(filesToUpload[0]);
	            }, multiple: false, name: name },
	        value ? value.name : _react2.default.createElement(
	            'div',
	            null,
	            _strings2.default.selectOrDropFile
	        )
	    );
	}

/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = genderSelection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function genderSelection(props) {
	    var field = props.field;
	
	    return _react2.default.createElement(_select2.default, _extends({ clearable: false, options: [{
	            id: 'male',
	            name: _strings2.default.male
	        }, {
	            id: 'female',
	            name: _strings2.default.female
	        }], noResultsText: _strings2.default.selectGender, placeholder: _strings2.default.gender }, field, { onChange: function onChange(item) {
	            return field.onChange(item.value);
	        } }));
	}

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ShirtField;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ShirtField(props) {
	    var field = props.field;
	
	    return _react2.default.createElement(_select2.default, _extends({ clearable: false, options: [{ id: 'XS', name: 'XS' }, { id: 'S', name: 'S' }, { id: 'M', name: 'M' }, { id: 'L', name: 'L' }, { id: 'XL', name: 'XL' }, { id: 'XXL', name: 'XXL' }, { id: 'XXXL', name: 'XXXL' }], placeholder: _strings2.default.shirtSize }, field, { onChange: function onChange(item) {
	            return field.onChange(item.value);
	        } }));
	}

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeTicker = function (_Component) {
	    _inherits(TimeTicker, _Component);
	
	    function TimeTicker(props) {
	        _classCallCheck(this, TimeTicker);
	
	        var _this = _possibleConstructorReturn(this, (TimeTicker.__proto__ || Object.getPrototypeOf(TimeTicker)).call(this, props));
	
	        _this.state = {
	            imageIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(TimeTicker, [{
	        key: "change",
	        value: function change() {
	            var imageIndex = 0;
	            if (this.state.imageIndex + 1 < this.props.images.length) {
	                imageIndex = this.state.imageIndex + 1;
	            }
	            this.setState({ imageIndex: imageIndex });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.interval = setInterval(this.change.bind(this), 5000);
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            clearInterval(this.interval);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement("div", { style: {
	                    backgroundImage: "url(" + this.props.images[this.state.imageIndex] + ")"
	                }, className: "image" });
	        }
	    }]);
	
	    return TimeTicker;
	}(_react.Component);
	
	exports.default = TimeTicker;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _imageField = __webpack_require__(124);
	
	var _imageField2 = _interopRequireDefault(_imageField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['imageId'];
	
	function validate() {
	    return [];
	}
	
	var ImageForm = function (_BaseForm) {
	    _inherits(ImageForm, _BaseForm);
	
	    function ImageForm() {
	        _classCallCheck(this, ImageForm);
	
	        return _possibleConstructorReturn(this, (ImageForm.__proto__ || Object.getPrototypeOf(ImageForm)).apply(this, arguments));
	    }
	
	    _createClass(ImageForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                imageId = _props.fields.imageId;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.image, name: 'image', field: imageId },
	                        _react2.default.createElement(_imageField2.default, _extends({}, imageId, { onImageUploaded: this.props.onImageUploaded }))
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ImageForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'image-form', fields: fields, validate: validate, destroyOnUnmount: true })(ImageForm);

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var availableMenuItems = [{
	    title_key: 'hello',
	    url: '/'
	}, {
	    title_key: 'news',
	    url: '/posts'
	}, {
	    title_key: 'regulations',
	    url: '/regulations'
	}, {
	    title_key: 'stages',
	    url: '/stages'
	}, {
	    title_key: 'results',
	    url: '/results'
	}, {
	    title_key: 'archive',
	    url: '/archive'
	}, {
	    title_key: 'contacts',
	    url: '/contact'
	}, {
	    title_key: 'about',
	    url: '/about'
	}, {
	    title_key: 'participantResults',
	    url: '/participant-results'
	}];
	
	var MenuBuilder = function (_Component) {
	    _inherits(MenuBuilder, _Component);
	
	    function MenuBuilder() {
	        _classCallCheck(this, MenuBuilder);
	
	        return _possibleConstructorReturn(this, (MenuBuilder.__proto__ || Object.getPrototypeOf(MenuBuilder)).apply(this, arguments));
	    }
	
	    _createClass(MenuBuilder, [{
	        key: 'getCurrentMenuValue',
	        value: function getCurrentMenuValue() {
	            return this.props.value || [];
	        }
	    }, {
	        key: 'addDefaultMenuItem',
	        value: function addDefaultMenuItem(item) {
	            this.addItemToMenu({
	                title_en: _strings2.default.props.en[item.title_key],
	                title_lt: _strings2.default.props.lt[item.title_key],
	                url: item.url
	            });
	        }
	    }, {
	        key: 'addItemToMenu',
	        value: function addItemToMenu(item) {
	            var value = this.getCurrentMenuValue();
	            value.push(item);
	            this.props.onChange(value);
	        }
	    }, {
	        key: 'removeItemFromMenu',
	        value: function removeItemFromMenu(index) {
	            var value = this.getCurrentMenuValue();
	            value.splice(index, 1);
	            this.props.onChange(value);
	        }
	    }, {
	        key: 'addNewItemToMenu',
	        value: function addNewItemToMenu() {
	            if (this.titleEnInput.value && this.titleLtInput.value && this.urlInput.value) {
	                this.addItemToMenu({ title_en: this.titleEnInput.value, title_lt: this.titleLtInput.value, url: this.urlInput.value });
	
	                this.titleEnInput.value = '';
	                this.titleLtInput.value = '';
	                this.urlInput.value = '';
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var currentMenuItems = this.getCurrentMenuValue();
	            return _react2.default.createElement(
	                'div',
	                { className: 'menu-builder' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        _strings2.default.availableMenuItems
	                    ),
	                    availableMenuItems.map(function (item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'menu-item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'description' },
	                                _strings2.default[item.title_key],
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'link' },
	                                    item.url
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn', onClick: function onClick() {
	                                        return _this2.addDefaultMenuItem(item);
	                                    } },
	                                _strings2.default.add
	                            )
	                        );
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'menu-item-form' },
	                        _react2.default.createElement('input', { ref: function ref(_ref) {
	                                return _this2.titleEnInput = _ref;
	                            }, placeholder: _strings2.default.title_en }),
	                        _react2.default.createElement('input', { ref: function ref(_ref2) {
	                                return _this2.titleLtInput = _ref2;
	                            }, placeholder: _strings2.default.title_lt }),
	                        _react2.default.createElement('input', { ref: function ref(_ref3) {
	                                return _this2.urlInput = _ref3;
	                            }, placeholder: _strings2.default.url }),
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn', onClick: function onClick() {
	                                    return _this2.addNewItemToMenu();
	                                } },
	                            _strings2.default.addToMenu
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'title' },
	                        _strings2.default.currentMenuItems
	                    ),
	                    currentMenuItems.map(function (item, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'menu-item' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'description' },
	                                item.title_lt,
	                                '(',
	                                item.title_en,
	                                ')',
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'link' },
	                                    item.url
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn', onClick: function onClick() {
	                                        return _this2.removeItemFromMenu(index);
	                                    } },
	                                'x'
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }]);
	
	    return MenuBuilder;
	}(_react.Component);
	
	exports.default = MenuBuilder;

/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = Modal;
	
	var _reactModal = __webpack_require__(1109);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Modal(props) {
	    return _react2.default.createElement(
	        _reactModal2.default,
	        { overlayClassName: 'modal-overlay', className: (0, _classnames2.default)('modal', props.className), isOpen: props.isOpen },
	        props.children
	    );
	}

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _textField = __webpack_require__(125);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'title_lt', 'title_en', 'body_lt', 'body_en', 'show_in_footer', 'order'];
	
	function validate(values) {
	  var errors = {
	    _error: null
	  };
	  errors = (0, _form.validateRequiredFields)(values, ['title_lt', 'title_en'], errors);
	  return errors;
	}
	
	var PageForm = function (_BaseForm) {
	  _inherits(PageForm, _BaseForm);
	
	  function PageForm() {
	    _classCallCheck(this, PageForm);
	
	    return _possibleConstructorReturn(this, (PageForm.__proto__ || Object.getPrototypeOf(PageForm)).apply(this, arguments));
	  }
	
	  _createClass(PageForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          submitting = _props.submitting,
	          error = _props.error,
	          handleSubmit = _props.handleSubmit,
	          _props$fields = _props.fields,
	          title_lt = _props$fields.title_lt,
	          title_en = _props$fields.title_en,
	          body_lt = _props$fields.body_lt,
	          body_en = _props$fields.body_en,
	          show_in_footer = _props$fields.show_in_footer,
	          order = _props$fields.order;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submit.bind(this)) },
	          error && _react2.default.createElement(
	            _alert2.default,
	            { type: 'error' },
	            error
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'legend',
	              null,
	              _strings2.default.ltLabel
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.title, name: 'title', field: title_lt },
	              _react2.default.createElement('input', _extends({ ref: 'title', className: 'border-full larger', placeholder: _strings2.default.title,
	                type: 'text' }, title_lt))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.body, name: 'body', field: body_lt },
	              _react2.default.createElement(_textField2.default, body_lt)
	            )
	          ),
	          _react2.default.createElement(
	            'fieldset',
	            null,
	            _react2.default.createElement(
	              'legend',
	              null,
	              _strings2.default.enLabel
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.title, name: 'title', field: title_en },
	              _react2.default.createElement('input', _extends({ ref: 'title', className: 'border-full larger', placeholder: _strings2.default.title,
	                type: 'text' }, title_en))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.body, name: 'body', field: body_en },
	              _react2.default.createElement(_textField2.default, body_en)
	            )
	          ),
	          _react2.default.createElement(
	            _formField2.default,
	            { label: _strings2.default.showInFooter, name: 'billing_is_company', field: show_in_footer,
	              className: 'checkbox-field',
	              dots: false },
	            _react2.default.createElement('input', _extends({ type: 'checkbox' }, show_in_footer))
	          ),
	          _react2.default.createElement(
	            _formField2.default,
	            { label: _strings2.default.order, name: 'order', field: order },
	            _react2.default.createElement('input', _extends({ ref: 'link', className: 'border-full larger', placeholder: _strings2.default.order,
	              type: 'number' }, order))
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actions-row' },
	            _react2.default.createElement(
	              _button2.default,
	              { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	              _strings2.default.submit
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'page-form',
	  fields: fields,
	  validate: validate,
	  destroyOnUnmount: true
	}, function (state) {
	  return {
	    initialValues: _extends({
	      show_in_footer: false,
	      order: 0
	    }, state.page.page.item)
	  };
	})(PageForm);

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _dateField = __webpack_require__(93);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'first_name', 'last_name', 'birth_date', 'row', 'titles'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['first_name', 'last_name', 'birth_date', 'row', 'titles'], errors);
	    return errors;
	}
	
	var ParticipantResultForm = function (_BaseForm) {
	    _inherits(ParticipantResultForm, _BaseForm);
	
	    function ParticipantResultForm() {
	        _classCallCheck(this, ParticipantResultForm);
	
	        return _possibleConstructorReturn(this, (ParticipantResultForm.__proto__ || Object.getPrototypeOf(ParticipantResultForm)).apply(this, arguments));
	    }
	
	    _createClass(ParticipantResultForm, [{
	        key: 'showAlert',
	        value: function showAlert() {
	            var _props$showAlert = this.props.showAlert,
	                showAlert = _props$showAlert === undefined ? true : _props$showAlert;
	
	
	            return showAlert;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                first_name = _props$fields.first_name,
	                last_name = _props$fields.last_name,
	                birth_date = _props$fields.birth_date,
	                row = _props$fields.row,
	                titles = _props$fields.titles;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'form-row' },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.firstName, name: 'name', field: first_name },
	                            _react2.default.createElement('input', _extends({ ref: 'name', placeholder: _strings2.default.firstName, type: 'text' }, first_name))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.lastName, name: 'last_name', field: last_name },
	                            _react2.default.createElement('input', _extends({ ref: 'last_name', placeholder: _strings2.default.lastName, type: 'text' }, last_name))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.birthDate, name: 'birth_date', field: birth_date },
	                            _react2.default.createElement(_dateField2.default, _extends({}, birth_date, { timeFormat: false, noTimeZoneDate: true,
	                                viewMode: 'years' }))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.result, name: 'row', field: row },
	                        _react2.default.createElement('textarea', _extends({ ref: 'row', placeholder: _strings2.default.result }, row))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.titles, name: 'titles', field: titles },
	                        _react2.default.createElement('textarea', _extends({ ref: 'titles', placeholder: _strings2.default.titles }, titles))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'main-color' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ParticipantResultForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'participant--result-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return {
	        initialValues: state.admin.participant.participant_result.item
	    };
	})(ParticipantResultForm);

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'name', 'order'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['name'], errors);
	    return errors;
	}
	
	var PartnerCategoryForm = function (_BaseForm) {
	    _inherits(PartnerCategoryForm, _BaseForm);
	
	    function PartnerCategoryForm() {
	        _classCallCheck(this, PartnerCategoryForm);
	
	        return _possibleConstructorReturn(this, (PartnerCategoryForm.__proto__ || Object.getPrototypeOf(PartnerCategoryForm)).apply(this, arguments));
	    }
	
	    _createClass(PartnerCategoryForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                order = _props$fields.order;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.name, name: 'name', field: name },
	                        _react2.default.createElement('input', _extends({ ref: 'name', className: 'border-full larger', placeholder: _strings2.default.name,
	                            type: 'text' }, name))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.order, name: 'order', field: order },
	                        _react2.default.createElement('input', _extends({ ref: 'link', className: 'border-full larger', placeholder: _strings2.default.order,
	                            type: 'number' }, order))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnerCategoryForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'partner-category-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.admin.partnerCategories.category };
	})(PartnerCategoryForm);

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(6);
	
	var _partnerCategories = __webpack_require__(163);
	
	var partnerCategoryActions = _interopRequireWildcard(_partnerCategories);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerCategorySelection = function (_Component) {
	    _inherits(PartnerCategorySelection, _Component);
	
	    function PartnerCategorySelection() {
	        _classCallCheck(this, PartnerCategorySelection);
	
	        return _possibleConstructorReturn(this, (PartnerCategorySelection.__proto__ || Object.getPrototypeOf(PartnerCategorySelection)).apply(this, arguments));
	    }
	
	    _createClass(PartnerCategorySelection, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.props.actions.fetchAllPartnerCategories();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var field = this.props.field;
	
	
	            return _react2.default.createElement(_select2.default, _extends({
	                clearable: false,
	                options: this.props.categories.partnerCategories.items,
	                noResultsText: _strings2.default.noCategories,
	                placeholder: _strings2.default.partnerCategory
	            }, field, {
	                onChange: function onChange(item) {
	                    field.onChange(item.value);
	                } }));
	        }
	    }]);
	
	    return PartnerCategorySelection;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { categories: state.partnerCategories };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(partnerCategoryActions, dispatch)
	    };
	})(PartnerCategorySelection);

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = PartnerDisplay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _internalImageV = __webpack_require__(107);
	
	var _internalImageV2 = _interopRequireDefault(_internalImageV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUrl(url) {
	    if (!url.match(/^[a-zA-Z]+:\/\//)) {
	        url = 'http://' + url;
	    }
	    return url;
	}
	function PartnerDisplay(props) {
	    var partner = props.partner;
	
	    if (!partner.image) {
	        return null;
	    }
	    return _react2.default.createElement(
	        'div',
	        { className: 'partner' },
	        partner.link ? _react2.default.createElement(
	            'a',
	            { href: getUrl(partner.link), target: '_blank' },
	            _react2.default.createElement(_internalImageV2.default, { filename: partner.image.filename, alt: partner.name })
	        ) : _react2.default.createElement(_internalImageV2.default, { filename: partner.image.filename, alt: partner.name })
	    );
	}

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _imageField = __webpack_require__(124);
	
	var _imageField2 = _interopRequireDefault(_imageField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _partnerCategorySelect = __webpack_require__(551);
	
	var _partnerCategorySelect2 = _interopRequireDefault(_partnerCategorySelect);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'name', 'imageId', 'link', 'order', 'partnerCategoryId'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['name', 'imageId', 'partnerCategoryId'], errors);
	    return errors;
	}
	
	var PartnerForm = function (_BaseForm) {
	    _inherits(PartnerForm, _BaseForm);
	
	    function PartnerForm() {
	        _classCallCheck(this, PartnerForm);
	
	        return _possibleConstructorReturn(this, (PartnerForm.__proto__ || Object.getPrototypeOf(PartnerForm)).apply(this, arguments));
	    }
	
	    _createClass(PartnerForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                imageId = _props$fields.imageId,
	                link = _props$fields.link,
	                order = _props$fields.order,
	                partnerCategoryId = _props$fields.partnerCategoryId;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.name, name: 'name', field: name },
	                        _react2.default.createElement('input', _extends({ ref: 'name', className: 'border-full larger', placeholder: _strings2.default.name,
	                            type: 'text' }, name))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.link, name: 'link', field: link },
	                        _react2.default.createElement('input', _extends({ ref: 'link', className: 'border-full larger', placeholder: _strings2.default.link,
	                            type: 'text' }, link))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.logo, name: 'logo', field: imageId },
	                        _react2.default.createElement(_imageField2.default, imageId)
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.partnerCategory, name: 'season', field: partnerCategoryId },
	                        _react2.default.createElement(_partnerCategorySelect2.default, { field: partnerCategoryId })
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.order, name: 'order', field: order },
	                        _react2.default.createElement('input', _extends({ ref: 'link', className: 'border-full larger', placeholder: _strings2.default.order,
	                            type: 'number' }, order))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnerForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'partner-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.admin.partners.partner };
	})(PartnerForm);

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _imageField = __webpack_require__(124);
	
	var _imageField2 = _interopRequireDefault(_imageField);
	
	var _textField = __webpack_require__(125);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _form = __webpack_require__(23);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _dateField = __webpack_require__(93);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'title', 'body', 'imageId', 'publish_date'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['title', 'body', 'imageId', 'publish_date'], errors);
	    return errors;
	}
	
	var PostForm = function (_BaseForm) {
	    _inherits(PostForm, _BaseForm);
	
	    function PostForm() {
	        _classCallCheck(this, PostForm);
	
	        return _possibleConstructorReturn(this, (PostForm.__proto__ || Object.getPrototypeOf(PostForm)).apply(this, arguments));
	    }
	
	    _createClass(PostForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                title = _props$fields.title,
	                body = _props$fields.body,
	                imageId = _props$fields.imageId,
	                publish_date = _props$fields.publish_date;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.title, name: 'title', field: title },
	                        _react2.default.createElement('input', _extends({ ref: 'title', className: 'border-full larger', placeholder: _strings2.default.title, type: 'text' }, title))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.image, name: 'featured-image', field: imageId },
	                        _react2.default.createElement(_imageField2.default, imageId)
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.publishDate, name: 'body', field: publish_date },
	                        _react2.default.createElement(_dateField2.default, _extends({}, publish_date, { timeFormat: false }))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.body, name: 'body', field: body },
	                        _react2.default.createElement(_textField2.default, body)
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'post-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.post.post.item };
	})(PostForm);

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _form = __webpack_require__(23);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'name', 'order'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['name'], errors);
	    return errors;
	}
	
	var SeasonForm = function (_BaseForm) {
	    _inherits(SeasonForm, _BaseForm);
	
	    function SeasonForm() {
	        _classCallCheck(this, SeasonForm);
	
	        return _possibleConstructorReturn(this, (SeasonForm.__proto__ || Object.getPrototypeOf(SeasonForm)).apply(this, arguments));
	    }
	
	    _createClass(SeasonForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                order = _props$fields.order;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.season, name: 'name', error: name.visited && name.error,
	                            field: name },
	                        _react2.default.createElement('input', _extends({ ref: 'name', className: 'border-full larger', placeholder: 'Name', type: 'text' }, name))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.order, name: 'order', field: order },
	                        _react2.default.createElement('input', _extends({ ref: 'link', className: 'border-full larger', placeholder: _strings2.default.order,
	                            type: 'number' }, order))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SeasonForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'season-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.season.season.item };
	})(SeasonForm);

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _seasonSelect = __webpack_require__(167);
	
	var _seasonSelect2 = _interopRequireDefault(_seasonSelect);
	
	var _textField = __webpack_require__(125);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _imageField = __webpack_require__(124);
	
	var _imageField2 = _interopRequireDefault(_imageField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _menuBuilder = __webpack_require__(546);
	
	var _menuBuilder2 = _interopRequireDefault(_menuBuilder);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _expandableContent = __webpack_require__(240);
	
	var _expandableContent2 = _interopRequireDefault(_expandableContent);
	
	var _form = __webpack_require__(23);
	
	var _colorSelectField = __webpack_require__(540);
	
	var _colorSelectField2 = _interopRequireDefault(_colorSelectField);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'about_text', 'contacts_text', 'seasonId', 'logoId', 'ogImageId', 'facebook_link', 'youtube_link', 'instagram_link', 'title', 'regulations', 'insurance_text', 'insurance_text_in_registration', 'insurance_text_label', 'archive_text', 'about_text_en', 'contacts_text_en', 'regulations_en', 'insurance_text_en', 'insurance_text_in_registration_en', 'insurance_text_label_en', 'archive_text_en', 'display_news', 'display_partners', 'single_event_website', 'menu', 'localization_enabled', 'menu_color', 'menu_highlight_color', 'button_color', 'button_hover_color', 'fb_pixel_code', 'google_analytics_code', 'multiple_stage_display', 'meta_keywords', 'meta_description'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['seasonId', 'logoId', 'title'], errors);
	    return errors;
	}
	
	var SettingsForm = function (_BaseForm) {
	    _inherits(SettingsForm, _BaseForm);
	
	    function SettingsForm() {
	        _classCallCheck(this, SettingsForm);
	
	        return _possibleConstructorReturn(this, (SettingsForm.__proto__ || Object.getPrototypeOf(SettingsForm)).apply(this, arguments));
	    }
	
	    _createClass(SettingsForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                about_text = _props$fields.about_text,
	                contacts_text = _props$fields.contacts_text,
	                seasonId = _props$fields.seasonId,
	                logoId = _props$fields.logoId,
	                ogImageId = _props$fields.ogImageId,
	                facebook_link = _props$fields.facebook_link,
	                youtube_link = _props$fields.youtube_link,
	                instagram_link = _props$fields.instagram_link,
	                title = _props$fields.title,
	                regulations = _props$fields.regulations,
	                insurance_text = _props$fields.insurance_text,
	                insurance_text_in_registration = _props$fields.insurance_text_in_registration,
	                insurance_text_label = _props$fields.insurance_text_label,
	                archive_text = _props$fields.archive_text,
	                about_text_en = _props$fields.about_text_en,
	                contacts_text_en = _props$fields.contacts_text_en,
	                regulations_en = _props$fields.regulations_en,
	                insurance_text_en = _props$fields.insurance_text_en,
	                insurance_text_in_registration_en = _props$fields.insurance_text_in_registration_en,
	                insurance_text_label_en = _props$fields.insurance_text_label_en,
	                archive_text_en = _props$fields.archive_text_en,
	                display_partners = _props$fields.display_partners,
	                display_news = _props$fields.display_news,
	                single_event_website = _props$fields.single_event_website,
	                menu = _props$fields.menu,
	                localization_enabled = _props$fields.localization_enabled,
	                menu_color = _props$fields.menu_color,
	                menu_highlight_color = _props$fields.menu_highlight_color,
	                button_color = _props$fields.button_color,
	                button_hover_color = _props$fields.button_hover_color,
	                fb_pixel_code = _props$fields.fb_pixel_code,
	                google_analytics_code = _props$fields.google_analytics_code,
	                multiple_stage_display = _props$fields.multiple_stage_display,
	                meta_keywords = _props$fields.meta_keywords,
	                meta_description = _props$fields.meta_description;
	            //about_text_en, contacts_text_en, regulations_en, insurance_text_en, insurance_text_in_registration_en, insurance_text_label_en, archive_text_en
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.siteConfig, expanded: true },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.logo, name: 'logo', field: logoId },
	                            _react2.default.createElement(_imageField2.default, logoId)
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.title, name: 'title', field: title },
	                            _react2.default.createElement('input', _extends({ ref: 'title', placeholder: _strings2.default.title, type: 'text' }, title))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.season, name: 'season', field: seasonId },
	                            _react2.default.createElement(_seasonSelect2.default, { field: seasonId })
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.displayNews, name: 'display_news', field: display_news,
	                                className: 'checkbox-field' },
	                            _react2.default.createElement('input', _extends({ type: 'checkbox' }, display_news))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.displayPartners, name: 'display_partners',
	                                field: display_partners, className: 'checkbox-field' },
	                            _react2.default.createElement('input', _extends({ type: 'checkbox' }, display_partners))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.singleEventWebsite, name: 'single_event_website',
	                                field: single_event_website, className: 'checkbox-field' },
	                            _react2.default.createElement('input', _extends({ type: 'checkbox' }, single_event_website))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.multipleStageDisplay, name: 'multiple_stage_display',
	                                field: multiple_stage_display, className: 'checkbox-field' },
	                            _react2.default.createElement('input', _extends({ type: 'checkbox' }, multiple_stage_display))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.localizationEnabled, name: 'localization_enabled',
	                                field: localization_enabled, className: 'checkbox-field' },
	                            _react2.default.createElement('input', _extends({ type: 'checkbox' }, localization_enabled))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.seo, expanded: true },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.webKeywords, name: 'keywords', field: meta_keywords },
	                            _react2.default.createElement('input', _extends({ placeholder: _strings2.default.webKeywords, type: 'text' }, meta_keywords))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.webDescription, name: 'title', field: meta_description },
	                            _react2.default.createElement('input', _extends({ ref: 'title', placeholder: _strings2.default.webDescription,
	                                type: 'text' }, meta_description))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.ogImage, name: 'ogImageId', field: ogImageId },
	                            _react2.default.createElement(_imageField2.default, ogImageId)
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.pages, expanded: true },
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.about
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'about', field: about_text },
	                                _react2.default.createElement(_textField2.default, about_text)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'about_text_en', field: about_text_en },
	                                _react2.default.createElement(_textField2.default, about_text_en)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.contacts
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'contacts', field: contacts_text },
	                                _react2.default.createElement(_textField2.default, contacts_text)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'contacts_text_en',
	                                    field: contacts_text_en },
	                                _react2.default.createElement(_textField2.default, contacts_text_en)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.regulations
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'regulations', field: regulations },
	                                _react2.default.createElement(_textField2.default, regulations)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'regulations_en', field: regulations_en },
	                                _react2.default.createElement(_textField2.default, regulations_en)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.archive
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'archive', field: archive_text },
	                                _react2.default.createElement(_textField2.default, archive_text)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'archive_text_en', field: archive_text_en },
	                                _react2.default.createElement(_textField2.default, archive_text_en)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.socialMedia, expanded: true },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.facebook, name: 'facebook', field: facebook_link },
	                            _react2.default.createElement('input', _extends({ ref: 'facebook', placeholder: _strings2.default.facebook,
	                                type: 'text' }, facebook_link))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.youtube, name: 'youtube', field: youtube_link },
	                            _react2.default.createElement('input', _extends({ ref: 'youtube', placeholder: _strings2.default.youtube, type: 'text' }, youtube_link))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.instagram, name: 'instagram', field: instagram_link },
	                            _react2.default.createElement('input', _extends({ ref: 'instagram', placeholder: _strings2.default.instagram,
	                                type: 'text' }, instagram_link))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.insurance, expanded: true },
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.insuranceTextInRegistration
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'instagram',
	                                    field: insurance_text_in_registration },
	                                _react2.default.createElement('input', _extends({ ref: 'insurance_text_in_registration',
	                                    type: 'text' }, insurance_text_in_registration))
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'instagram',
	                                    field: insurance_text_in_registration_en },
	                                _react2.default.createElement('input', _extends({ ref: 'insurance_text_in_registration_en',
	                                    type: 'text' }, insurance_text_in_registration_en))
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.insuranceTextLabel
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'insurance_text_label',
	                                    field: insurance_text_label },
	                                _react2.default.createElement('input', _extends({ ref: 'insurance_text_label', type: 'text' }, insurance_text_label))
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'insurance_text_label_en',
	                                    field: insurance_text_label_en },
	                                _react2.default.createElement('input', _extends({ ref: 'insurance_text_label_en', type: 'text' }, insurance_text_label_en))
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'fieldset',
	                            null,
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.insuranceText
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.ltLabel, name: 'insurance_text', field: insurance_text },
	                                _react2.default.createElement(_textField2.default, insurance_text)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.enLabel, name: 'insurance_text_en',
	                                    field: insurance_text_en },
	                                _react2.default.createElement(_textField2.default, insurance_text_en)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.tracking, expanded: true },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.googleAnalyticsCode, name: 'google_analytics_code', field: google_analytics_code },
	                            _react2.default.createElement('input', _extends({ ref: 'google_analytics_code', placeholder: _strings2.default.googleAnalyticsCode,
	                                type: 'text' }, google_analytics_code))
	                        ),
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.facebookPixelCode, name: 'fb_pixel_code', field: fb_pixel_code },
	                            _react2.default.createElement('input', _extends({ ref: 'fb_pixel_code', placeholder: _strings2.default.facebookPixelCode,
	                                type: 'text' }, fb_pixel_code))
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.menu },
	                        _react2.default.createElement(_menuBuilder2.default, menu)
	                    ),
	                    _react2.default.createElement(
	                        _expandableContent2.default,
	                        { title: _strings2.default.colors },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.menuColor, name: 'menu_color', field: menu_color },
	                                _react2.default.createElement(_colorSelectField2.default, menu_color)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.menuHighlightColor, name: 'menu_highlight_color',
	                                    field: menu_highlight_color },
	                                _react2.default.createElement(_colorSelectField2.default, menu_highlight_color)
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'form-row' },
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.buttonColor, name: 'button_color', field: button_color },
	                                _react2.default.createElement(_colorSelectField2.default, button_color)
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.buttonHoverColor, name: 'button_hover_color',
	                                    field: button_hover_color },
	                                _react2.default.createElement(_colorSelectField2.default, button_hover_color)
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SettingsForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'settings-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.settings.settings };
	})(SettingsForm);

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _form = __webpack_require__(23);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	var _dateField = __webpack_require__(93);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'name', 'isFree', 'stageId', 'code', 'enable_shirt_selection', 'is_team_distance', 'prices[].id', 'prices[].price', 'prices[].children_price', 'prices[].older_price', 'prices[].price_until_date', 'max_age_restriction', 'order'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['name', 'code'], errors);
	
	    errors.prices = values.prices.map(function (price) {
	        return (0, _form.validateRequiredFields)(price, ['price', 'price_until_date', 'older_price', 'children_price'], {});
	    });
	    return errors;
	}
	
	var PRICING_CONFIG = window.CARE_CONFIG.pricing;
	
	var DistanceForm = function (_BaseForm) {
	    _inherits(DistanceForm, _BaseForm);
	
	    function DistanceForm() {
	        _classCallCheck(this, DistanceForm);
	
	        return _possibleConstructorReturn(this, (DistanceForm.__proto__ || Object.getPrototypeOf(DistanceForm)).apply(this, arguments));
	    }
	
	    _createClass(DistanceForm, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            setTimeout(function () {
	                return _this2.refs.name.focus();
	            });
	        }
	    }, {
	        key: 'preSubmit',
	        value: function preSubmit(values) {
	            return this.submit(_extends({}, values, {
	                max_age_restriction: values.max_age_restriction || null
	            }));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                name = _props$fields.name,
	                isFree = _props$fields.isFree,
	                prices = _props$fields.prices,
	                code = _props$fields.code,
	                order = _props$fields.order,
	                is_team_distance = _props$fields.is_team_distance,
	                max_age_restriction = _props$fields.max_age_restriction,
	                enable_shirt_selection = _props$fields.enable_shirt_selection;
	
	
	            var labelChildrenPrice = PRICING_CONFIG.customGroups ? _strings2.default.age + ' <= ' + PRICING_CONFIG.ageGroups.children : _strings2.default.childrenPrice;
	            var labelOlderPrice = PRICING_CONFIG.customGroups ? _strings2.default.age + ' >= ' + PRICING_CONFIG.ageGroups.older : _strings2.default.olderPrice;
	            var labelPrice = PRICING_CONFIG.customGroups ? PRICING_CONFIG.ageGroups.children + ' < ' + _strings2.default.age + ' < ' + PRICING_CONFIG.ageGroups.older : _strings2.default.price;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'distance-form' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.preSubmit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.title, name: 'name', field: name },
	                        _react2.default.createElement('input', _extends({ ref: 'name', className: 'border-full larger', placeholder: _strings2.default.title, type: 'text' }, name))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.code, name: 'code', field: code, helperText: _strings2.default.codeHelperText },
	                        _react2.default.createElement('input', _extends({ ref: 'code', className: 'border-full larger', placeholder: _strings2.default.code, type: 'text' }, code))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.order, name: 'order', field: order },
	                        _react2.default.createElement('input', _extends({ ref: 'link', className: 'border-full larger', placeholder: _strings2.default.order, type: 'number' }, order))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.isFree, name: 'isFree', field: isFree, className: 'checkbox-field' },
	                        _react2.default.createElement('input', _extends({ type: 'checkbox' }, isFree))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.isTeamDistance, name: 'isTeamDistance', field: is_team_distance, className: 'checkbox-field' },
	                        _react2.default.createElement('input', _extends({ type: 'checkbox' }, is_team_distance))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.maxAgeRestriction, name: 'max_age_restriction', field: max_age_restriction },
	                        _react2.default.createElement('input', _extends({ ref: 'max_age_restriction', className: 'border-full larger', placeholder: '', type: 'number' }, max_age_restriction))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.enableShirtSelection, name: 'enable_shirt_selection', field: enable_shirt_selection, className: 'checkbox-field' },
	                        _react2.default.createElement('input', _extends({ type: 'checkbox' }, enable_shirt_selection))
	                    ),
	                    prices.map(function (price, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { key: index, className: 'inline-fields' },
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: labelPrice, name: 'price', field: price.price },
	                                _react2.default.createElement('input', _extends({ ref: 'price', className: 'border-full larger', placeholder: labelPrice, type: 'number' }, price.price))
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: labelChildrenPrice, name: 'children_price', field: price.price },
	                                _react2.default.createElement('input', _extends({ ref: 'children_price', className: 'border-full larger', placeholder: labelChildrenPrice, type: 'number' }, price.children_price))
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: labelOlderPrice, name: 'older_price', field: price.price },
	                                _react2.default.createElement('input', _extends({ ref: 'children_price', className: 'border-full larger', placeholder: labelOlderPrice, type: 'number' }, price.older_price))
	                            ),
	                            _react2.default.createElement(
	                                _formField2.default,
	                                { label: _strings2.default.dateUntil, name: 'price_until_date', field: price.price_until_date },
	                                _react2.default.createElement(_dateField2.default, price.price_until_date)
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red', onClick: function onClick() {
	                                        prices.removeField(index);
	                                    } },
	                                _strings2.default.remove
	                            )
	                        );
	                    }),
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn m-top-10 m-bot-10', onClick: function onClick() {
	                                prices.addField();
	                            } },
	                        _react2.default.createElement('i', null),
	                        ' ',
	                        _strings2.default.addPrice
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'button-group' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        ),
	                        _react2.default.createElement(
	                            _button2.default,
	                            { disabled: submitting, onClick: function onClick(e) {
	                                    e.preventDefault();
	                                    _this3.props.cancel();
	                                }, type: 'empty-primary pull-right' },
	                            _strings2.default.cancel
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DistanceForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'distance-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: _extends({
	            isFree: false,
	            is_team_distance: false,
	            max_age_restriction: null,
	            enable_shirt_selection: false
	        }, state.distance.distance) };
	})(DistanceForm);

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = DistanceFormModal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _modal = __webpack_require__(547);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _distanceForm = __webpack_require__(557);
	
	var _distanceForm2 = _interopRequireDefault(_distanceForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function DistanceFormModal(props) {
	    var isOpen = props.isOpen,
	        restprops = _objectWithoutProperties(props, ['isOpen']);
	
	    return _react2.default.createElement(
	        _modal2.default,
	        { className: 'modal big-modal', isOpen: isOpen },
	        _react2.default.createElement(
	            'div',
	            { className: 'modal-content' },
	            _react2.default.createElement(_distanceForm2.default, restprops)
	        )
	    );
	}

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _dateField = __webpack_require__(93);
	
	var _dateField2 = _interopRequireDefault(_dateField);
	
	var _seasonSelect = __webpack_require__(167);
	
	var _seasonSelect2 = _interopRequireDefault(_seasonSelect);
	
	var _textField = __webpack_require__(125);
	
	var _textField2 = _interopRequireDefault(_textField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _form = __webpack_require__(23);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _expandableContent = __webpack_require__(240);
	
	var _expandableContent2 = _interopRequireDefault(_expandableContent);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'name', 'address', 'stage_date', 'seasonId', 'regulations', 'regulations_en', 'registration_enabled', 'has_results', 'register_to_all_stages', 'insurance_enabled', 'live_results', 'external_website_registration', 'external_regulations_link', 'external_registration_link', 'external_participants_link', 'global_results_stage', 'register_to_custom_stages_list', 'register_to_custom_stages', 'show_in_main_window', 'results_field_position_poz', 'diploma_image', 'generate_diploma', 'paysera_project_id', 'paysera_sign_password', 'paysera_head_tag', 'extra_info_field_title', 'extra_info_field_required', 'display_extra_info_field', 'registration_closes_date'];
	
	function validate(values) {
	  var errors = {
	    _error: null
	  };
	  errors = (0, _form.validateRequiredFields)(values, ['name', 'address', 'stage_date', 'seasonId'], errors);
	  if (values.external_website_registration) {
	    errors = (0, _form.validateRequiredFields)(values, ['external_regulations_link', 'external_registration_link', 'external_participants_link'], errors);
	  }
	  return errors;
	}
	
	var StageForm = function (_BaseForm) {
	  _inherits(StageForm, _BaseForm);
	
	  function StageForm() {
	    _classCallCheck(this, StageForm);
	
	    return _possibleConstructorReturn(this, (StageForm.__proto__ || Object.getPrototypeOf(StageForm)).apply(this, arguments));
	  }
	
	  _createClass(StageForm, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          submitting = _props.submitting,
	          error = _props.error,
	          handleSubmit = _props.handleSubmit,
	          _props$fields = _props.fields,
	          name = _props$fields.name,
	          address = _props$fields.address,
	          stage_date = _props$fields.stage_date,
	          seasonId = _props$fields.seasonId,
	          regulations = _props$fields.regulations,
	          registration_enabled = _props$fields.registration_enabled,
	          has_results = _props$fields.has_results,
	          register_to_all_stages = _props$fields.register_to_all_stages,
	          insurance_enabled = _props$fields.insurance_enabled,
	          live_results = _props$fields.live_results,
	          regulations_en = _props$fields.regulations_en,
	          external_website_registration = _props$fields.external_website_registration,
	          external_regulations_link = _props$fields.external_regulations_link,
	          external_registration_link = _props$fields.external_registration_link,
	          external_participants_link = _props$fields.external_participants_link,
	          global_results_stage = _props$fields.global_results_stage,
	          register_to_custom_stages_list = _props$fields.register_to_custom_stages_list,
	          register_to_custom_stages = _props$fields.register_to_custom_stages,
	          show_in_main_window = _props$fields.show_in_main_window,
	          results_field_position_poz = _props$fields.results_field_position_poz,
	          diploma_image = _props$fields.diploma_image,
	          generate_diploma = _props$fields.generate_diploma,
	          paysera_project_id = _props$fields.paysera_project_id,
	          paysera_sign_password = _props$fields.paysera_sign_password,
	          paysera_head_tag = _props$fields.paysera_head_tag,
	          extra_info_field_title = _props$fields.extra_info_field_title,
	          extra_info_field_required = _props$fields.extra_info_field_required,
	          display_extra_info_field = _props$fields.display_extra_info_field,
	          registration_closes_date = _props$fields.registration_closes_date;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'form',
	          { onSubmit: handleSubmit(this.submit.bind(this)) },
	          error && _react2.default.createElement(
	            _alert2.default,
	            { type: 'error' },
	            error
	          ),
	          _react2.default.createElement(
	            _expandableContent2.default,
	            { title: _strings2.default.stageInfo, expanded: true },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.season, name: 'season', field: seasonId },
	              _react2.default.createElement(_seasonSelect2.default, { field: seasonId })
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.title, name: 'name', field: name },
	              _react2.default.createElement('input', _extends({ ref: 'name', className: 'border-full larger', placeholder: _strings2.default.title,
	                type: 'text' }, name))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.date, name: 'address', field: stage_date },
	              _react2.default.createElement(_dateField2.default, stage_date)
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.registrationClosesDate, name: 'registration_closes_date', field: registration_closes_date },
	              _react2.default.createElement(_dateField2.default, registration_closes_date)
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.address, name: 'address', field: address },
	              _react2.default.createElement('input', _extends({ ref: 'address', className: 'border-full larger', placeholder: _strings2.default.address,
	                type: 'text' }, address))
	            )
	          ),
	          _react2.default.createElement(
	            _expandableContent2.default,
	            { title: _strings2.default.regulations, expanded: true },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.ltLabel, name: 'regulations', field: regulations },
	              _react2.default.createElement(_textField2.default, regulations)
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.enLabel, name: 'regulations', field: regulations_en },
	              _react2.default.createElement(_textField2.default, regulations_en)
	            )
	          ),
	          _react2.default.createElement(
	            _expandableContent2.default,
	            { title: _strings2.default.stageInfo, expanded: true },
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.registrationEnabled, name: 'registration_enabled',
	                  field: registration_enabled, className: 'checkbox-field', dots: false },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, registration_enabled))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.hasResults, name: 'has_results', field: has_results,
	                  className: 'checkbox-field', dots: false },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, has_results))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.liveResults, name: 'live_results', field: live_results },
	                _react2.default.createElement('input', _extends({ ref: 'live_results', className: 'border-full larger', type: 'text',
	                  placeholder: _strings2.default.liveResults
	                }, live_results))
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.registerToAllStages, name: 'register_to_all_stages',
	                  field: register_to_all_stages, className: 'checkbox-field', dots: false },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, register_to_all_stages))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.globalResultsStage, name: 'global_results_stage',
	                  field: global_results_stage, className: 'checkbox-field', dots: false },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, global_results_stage))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.registerToCustomStages, name: 'register_to_custom_stages',
	                  field: register_to_custom_stages, className: 'checkbox-field', dots: false },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, register_to_custom_stages))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.registerToCustomStages, name: 'register_to_custom_stages_list',
	                  field: register_to_custom_stages_list },
	                _react2.default.createElement('input', _extends({ ref: 'register_to_custom_stages_list', className: 'border-full larger',
	                  placeholder: _strings2.default.registerToCustomStages,
	                  type: 'text' }, register_to_custom_stages_list))
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                _strings2.default.extraInfo
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.displayExtraInfoField, name: 'display_extra_info_field',
	                  field: display_extra_info_field, className: 'checkbox-field' },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, display_extra_info_field))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.extraInfoFieldTitle, name: 'extra_info_field_title',
	                  field: extra_info_field_title },
	                _react2.default.createElement('input', _extends({ placeholder: _strings2.default.extraInfoFieldTitle, type: 'text' }, extra_info_field_title))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.extraInfoFieldRequired, name: 'extra_info_field_required',
	                  field: extra_info_field_required, className: 'checkbox-field' },
	                _react2.default.createElement('input', _extends({ type: 'checkbox' }, extra_info_field_required))
	              )
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.showInMainWindow, name: 'show_in_main_window',
	                field: show_in_main_window, className: 'checkbox-field', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, show_in_main_window))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.insuranceEnabled, name: 'insurance_enabled',
	                field: insurance_enabled, className: 'checkbox-field', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, insurance_enabled))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.externalRegistration, name: 'external_website_registration',
	                field: external_website_registration, className: 'checkbox-field', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, external_website_registration))
	            ),
	            external_website_registration.value ? _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.externalRegulationsLink, name: 'external_regulations_link',
	                  field: external_regulations_link },
	                _react2.default.createElement('input', _extends({ ref: 'external_regulations_link', className: 'border-full larger',
	                  placeholder: _strings2.default.externalRegulationsLink,
	                  type: 'text' }, external_regulations_link))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.externalRegistrationLink,
	                  name: 'external_registration_link', field: external_registration_link },
	                _react2.default.createElement('input', _extends({ ref: 'external_registration_link', className: 'border-full larger',
	                  placeholder: _strings2.default.externalRegistrationLink,
	                  type: 'text' }, external_registration_link))
	              ),
	              _react2.default.createElement(
	                _formField2.default,
	                { label: _strings2.default.externalParticipantsLink,
	                  name: 'external_participants_link', field: external_participants_link },
	                _react2.default.createElement('input', _extends({ ref: 'external_participants_link', className: 'border-full larger',
	                  placeholder: _strings2.default.externalRegistrationLink,
	                  type: 'text' }, external_participants_link))
	              )
	            ) : null
	          ),
	          _react2.default.createElement(
	            _expandableContent2.default,
	            { title: _strings2.default.resultsFileInfo, expanded: true },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.resultsPositionFieldValuePos,
	                name: 'results_field_position_poz', field: results_field_position_poz },
	              _react2.default.createElement('input', _extends({ ref: 'results_field_position_poz', className: 'border-full larger',
	                placeholder: _strings2.default.resultsPositionFieldValuePos,
	                type: 'number' }, results_field_position_poz))
	            )
	          ),
	          _react2.default.createElement(
	            _expandableContent2.default,
	            { title: _strings2.default.diploma, expanded: true },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.generateDiploma, name: 'generate_diploma',
	                field: generate_diploma, className: 'checkbox-field', dots: false },
	              _react2.default.createElement('input', _extends({ type: 'checkbox' }, generate_diploma))
	            ),
	            generate_diploma.value ? _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.diplomaBgImage, name: 'diploma_image',
	                field: diploma_image },
	              _react2.default.createElement('textarea', _extends({ ref: 'diploma_image', className: 'border-full larger' }, diploma_image))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _expandableContent2.default,
	            { title: _strings2.default.paysera, expanded: false },
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.projectId,
	                name: 'paysera_project_id', field: paysera_project_id },
	              _react2.default.createElement('input', _extends({ ref: 'paysera_project_id', className: 'border-full larger',
	                placeholder: _strings2.default.projectId,
	                type: 'text' }, paysera_project_id))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.projectPassword,
	                name: 'paysera_sign_password', field: paysera_sign_password },
	              _react2.default.createElement('input', _extends({ ref: 'paysera_sign_password', className: 'border-full larger',
	                placeholder: _strings2.default.projectPassword,
	                type: 'text' }, paysera_sign_password))
	            ),
	            _react2.default.createElement(
	              _formField2.default,
	              { label: _strings2.default.projectHeadTag,
	                name: 'paysera_head_tag', field: paysera_head_tag },
	              _react2.default.createElement('input', _extends({ ref: 'paysera_head_tag', className: 'border-full larger',
	                placeholder: _strings2.default.projectHeadTag,
	                type: 'text' }, paysera_head_tag))
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'actions-row' },
	            _react2.default.createElement(
	              _button2.default,
	              { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	              _strings2.default.submit
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return StageForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	  form: 'stage-form',
	  fields: fields,
	  validate: validate,
	  destroyOnUnmount: true
	}, function (state) {
	  return {
	    initialValues: _extends({
	      registration_closes_date: null,
	      registration_enabled: false,
	      has_results: false,
	      register_to_all_stages: false,
	      register_to_custom_stages: false,
	      global_results_stage: false,
	      display_extra_info_field: false,
	      show_in_main_window: false,
	      insurance_enabled: false,
	      external_website_registration: false,
	      extra_info_field_required: false,
	      generate_diploma: false,
	      results_field_position_poz: 0
	    }, state.stage.stage.item)
	  };
	})(StageForm);

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _fileField = __webpack_require__(541);
	
	var _fileField2 = _interopRequireDefault(_fileField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _form = __webpack_require__(23);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['file'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['file'], errors);
	    return errors;
	}
	
	var StageResultsForm = function (_BaseForm) {
	    _inherits(StageResultsForm, _BaseForm);
	
	    function StageResultsForm() {
	        _classCallCheck(this, StageResultsForm);
	
	        return _possibleConstructorReturn(this, (StageResultsForm.__proto__ || Object.getPrototypeOf(StageResultsForm)).apply(this, arguments));
	    }
	
	    _createClass(StageResultsForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                file = _props.fields.file;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _formField2.default,
	                            { label: _strings2.default.file, name: 'file', field: file },
	                            _react2.default.createElement(_fileField2.default, file)
	                        ),
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting, type: 'primary' },
	                            _strings2.default.submit
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StageResultsForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'stage-results-form',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { initialValues: state.stage.stage.item };
	})(StageResultsForm);

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesTable = function (_Component) {
	    _inherits(StagesTable, _Component);
	
	    function StagesTable() {
	        _classCallCheck(this, StagesTable);
	
	        return _possibleConstructorReturn(this, (StagesTable.__proto__ || Object.getPrototypeOf(StagesTable)).apply(this, arguments));
	    }
	
	    _createClass(StagesTable, [{
	        key: 'renderRegistrationButton',
	        value: function renderRegistrationButton(stage) {
	            if (stage.registration_enabled) {
	                if (stage.external_website_registration) {
	                    return _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-main-color inline first-uppercase', href: stage.external_registration_link },
	                        _strings2.default.registration
	                    );
	                }
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/stages/' + stage.id + '/registration', className: 'btn btn-main-color inline first-uppercase' },
	                    _strings2.default.registration
	                );
	            }
	        }
	    }, {
	        key: 'renderResultsButton',
	        value: function renderResultsButton(stage) {
	            if (stage.has_results) {
	                return _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/stages/' + stage.id + '/results', className: 'btn btn-main-color inline first-uppercase mt-10' },
	                    _strings2.default.results
	                );
	            }
	        }
	    }, {
	        key: 'renderTable',
	        value: function renderTable(stages) {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'table',
	                { className: 'table responsive' },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _strings2.default.stage
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _strings2.default.date
	                        ),
	                        _react2.default.createElement('th', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    stages.filter(function (stage) {
	                        return !stage.register_to_all_stages && !stage.global_results_stage && !stage.register_to_custom_stages;
	                    }).map(function (stage) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: 'stage-' + stage.id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                stage.name
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                (0, _moment2.default)(stage.stage_date).format('YYYY-MM-DD HH:mm')
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'actions' },
	                                _this2.renderRegistrationButton(stage),
	                                _this2.renderResultsButton(stage),
	                                stage.external_website_registration ? _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-main-color inline first-uppercase', href: stage.external_participants_link },
	                                    _strings2.default.participants
	                                ) : _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/stages/' + stage.id + '/participants', className: 'btn btn-main-color inline first-uppercase' },
	                                    _strings2.default.participants
	                                ),
	                                stage.external_website_registration ? _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-main-color inline first-uppercase', href: stage.external_regulations_link },
	                                    _strings2.default.regulations
	                                ) : _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/stages/' + stage.id + '/regulations', className: 'btn btn-main-color inline first-uppercase' },
	                                    _strings2.default.regulations
	                                ),
	                                stage.live_results ? _react2.default.createElement(
	                                    'a',
	                                    { className: 'btn btn-main-color',
	                                        href: stage.live_results },
	                                    _strings2.default.liveResults
	                                ) : null
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (this.props.stages.loading) {
	                return _react2.default.createElement(_loading2.default, null);
	            }
	            return this.renderTable(this.props.stages.items);
	        }
	    }]);
	
	    return StagesTable;
	}(_react.Component);
	
	exports.default = StagesTable;

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TimeTicker = function (_Component) {
	    _inherits(TimeTicker, _Component);
	
	    function TimeTicker(props) {
	        _classCallCheck(this, TimeTicker);
	
	        var _this = _possibleConstructorReturn(this, (TimeTicker.__proto__ || Object.getPrototypeOf(TimeTicker)).call(this, props));
	
	        _this.state = {
	            secondsRemaining: 0
	        };
	        return _this;
	    }
	
	    _createClass(TimeTicker, [{
	        key: 'setRemainingTime',
	        value: function setRemainingTime() {
	            var now = new Date();
	            this.setState({
	                timeRemaining: this.props.date.getTime() - now.getTime()
	            });
	        }
	    }, {
	        key: 'tick',
	        value: function tick() {
	            this.setRemainingTime();
	            if (this.state.timeRemaining <= 0) {
	                clearInterval(this.interval);
	            }
	        }
	    }, {
	        key: 'getTimeFormatted',
	        value: function getTimeFormatted(ms) {
	            if (!ms) {
	                return {};
	            }
	            var pad = function pad(n) {
	                return n < 10 ? '0' + n : n;
	            };
	            var days = Math.floor(ms / (24 * 60 * 60 * 1000));
	            var daysms = ms % (24 * 60 * 60 * 1000);
	            var hours = Math.floor(daysms / (60 * 60 * 1000));
	            var hoursms = ms % (60 * 60 * 1000);
	            var minutes = Math.floor(hoursms / (60 * 1000));
	            var minutesms = ms % (60 * 1000);
	            var sec = Math.floor(minutesms / 1000);
	            return { days: days, hours: pad(hours), minutes: pad(minutes), seconds: pad(sec) };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setRemainingTime();
	
	            this.interval = setInterval(this.tick.bind(this), 1000);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearInterval(this.interval);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (this.state.timeRemaining <= 0) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.eventHasEnded
	                );
	            }
	            var dateDisplay = this.getTimeFormatted(this.state.timeRemaining);
	            return _react2.default.createElement(
	                'span',
	                null,
	                '  ',
	                _strings2.default.timeLeft,
	                ':   ',
	                _react2.default.createElement('br', null),
	                '\xA0 ',
	                dateDisplay.days,
	                '\xA0d. ',
	                dateDisplay.hours,
	                ':',
	                dateDisplay.minutes,
	                ':',
	                dateDisplay.seconds
	            );
	        }
	    }]);
	
	    return TimeTicker;
	}(_react.Component);
	
	exports.default = TimeTicker;

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _form = __webpack_require__(23);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['email', 'password'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['email', 'password'], errors);
	    errors = (0, _form.validateEmail)(values, 'email', errors);
	
	    return errors;
	}
	
	var LoginForm = function (_BaseForm) {
	    _inherits(LoginForm, _BaseForm);
	
	    function LoginForm() {
	        _classCallCheck(this, LoginForm);
	
	        return _possibleConstructorReturn(this, (LoginForm.__proto__ || Object.getPrototypeOf(LoginForm)).apply(this, arguments));
	    }
	
	    _createClass(LoginForm, [{
	        key: 'showAlert',
	        value: function showAlert() {
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                email = _props$fields.email,
	                password = _props$fields.password;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'login-form' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.email, name: 'email', error: email.visited && email.error,
	                            field: email },
	                        _react2.default.createElement('input', _extends({ ref: 'email', className: 'border-full larger', placeholder: _strings2.default.email,
	                            type: 'email' }, email))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: _strings2.default.password, name: 'password',
	                            error: password.visited && password.error, field: password },
	                        _react2.default.createElement('input', _extends({ ref: 'password', className: 'border-full larger', placeholder: _strings2.default.password,
	                            type: 'password' }, password))
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'actions-row' },
	                        _react2.default.createElement(
	                            _button2.default,
	                            { loading: submitting, submit: true, disabled: submitting },
	                            _strings2.default.login
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return LoginForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({ form: 'login-form', fields: fields, validate: validate, destroyOnUnmount: true })(LoginForm);

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxForm = __webpack_require__(25);
	
	var _formField = __webpack_require__(22);
	
	var _formField2 = _interopRequireDefault(_formField);
	
	var _baseForm = __webpack_require__(27);
	
	var _baseForm2 = _interopRequireDefault(_baseForm);
	
	var _form = __webpack_require__(23);
	
	var _alert = __webpack_require__(26);
	
	var _alert2 = _interopRequireDefault(_alert);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fields = ['id', 'email', 'password', 'first_name', 'last_name', 'password', 'password_repeat'];
	
	function validate(values) {
	    var errors = {
	        _error: null
	    };
	    errors = (0, _form.validateRequiredFields)(values, ['first_name', 'last_name', 'email'], errors);
	    return errors;
	}
	
	var UserForm = function (_BaseForm) {
	    _inherits(UserForm, _BaseForm);
	
	    function UserForm() {
	        _classCallCheck(this, UserForm);
	
	        return _possibleConstructorReturn(this, (UserForm.__proto__ || Object.getPrototypeOf(UserForm)).apply(this, arguments));
	    }
	
	    _createClass(UserForm, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                submitting = _props.submitting,
	                error = _props.error,
	                handleSubmit = _props.handleSubmit,
	                _props$fields = _props.fields,
	                id = _props$fields.id,
	                email = _props$fields.email,
	                first_name = _props$fields.first_name,
	                last_name = _props$fields.last_name,
	                password = _props$fields.password,
	                password_repeat = _props$fields.password_repeat;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'brand-form' },
	                _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit(this.submit.bind(this)) },
	                    error && _react2.default.createElement(
	                        _alert2.default,
	                        { type: 'error' },
	                        error
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: 'Email', name: 'email', error: email.visited && email.error, field: email },
	                        _react2.default.createElement('input', _extends({ ref: 'email', className: 'border-full larger', placeholder: 'Email', type: 'email' }, email))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: 'First name', name: 'first_name', error: first_name.visited && first_name.error, field: first_name },
	                        _react2.default.createElement('input', _extends({ ref: 'first_name', className: 'border-full larger', placeholder: 'First name', type: 'text' }, first_name))
	                    ),
	                    _react2.default.createElement(
	                        _formField2.default,
	                        { label: 'Last name', name: 'last_name', error: last_name.visited && last_name.error, field: last_name },
	                        _react2.default.createElement('input', _extends({ ref: 'last_name', className: 'border-full larger', placeholder: 'Last name', type: 'text' }, last_name))
	                    ),
	                    !id.value ? _react2.default.createElement(
	                        _formField2.default,
	                        { label: 'Password', name: 'password', error: password.visited && password.error, field: password },
	                        _react2.default.createElement('input', _extends({ ref: 'password', className: 'border-full larger', placeholder: 'Password', type: 'password' }, password))
	                    ) : null,
	                    password.value ? _react2.default.createElement(
	                        _formField2.default,
	                        { label: 'Password repeat', name: 'password_repeat', error: password_repeat.visited && password_repeat.error, field: password_repeat },
	                        _react2.default.createElement('input', _extends({ ref: 'password_repeat', className: 'border-full larger', placeholder: 'Password repeat', type: 'password' }, password_repeat))
	                    ) : null,
	                    _react2.default.createElement(
	                        'button',
	                        { type: 'submit', disabled: submitting },
	                        'Submit'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UserForm;
	}(_baseForm2.default);
	
	exports.default = (0, _reduxForm.reduxForm)({
	    form: 'user',
	    fields: fields,
	    validate: validate,
	    destroyOnUnmount: true
	}, function (state) {
	    return { // mapStateToProps
	        initialValues: state.admin.users.user // will pull state into form's initialValues
	    };
	})(UserForm);

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _users = __webpack_require__(123);
	
	var userActions = _interopRequireWildcard(_users);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminContainer = function (_Component) {
	    _inherits(AdminContainer, _Component);
	
	    function AdminContainer() {
	        _classCallCheck(this, AdminContainer);
	
	        return _possibleConstructorReturn(this, (AdminContainer.__proto__ || Object.getPrototypeOf(AdminContainer)).apply(this, arguments));
	    }
	
	    _createClass(AdminContainer, [{
	        key: 'logout',
	        value: function logout() {
	            this.props.actions.logout();
	            window.USER_LOGGED = false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: 'Admin | ' + window.CARE_CONFIG.settings.title },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'admin-board' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'header' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'branding' },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'http://www.eventomania.lt', activeClassName: 'active' },
	                                _react2.default.createElement('img', { src: __webpack_require__(297) })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'right-col' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'nav' },
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'btn' },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/', activeClassName: 'active' },
	                                        _strings2.default.viewSite
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    { className: 'btn' },
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/', activeClassName: 'active',
	                                            onClick: this.logout.bind(this) },
	                                        _strings2.default.logout
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'left-col' },
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'side-menu' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.statistics
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/seasons/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.seasons
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/stages/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.stages
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/participants/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.participants
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/partners/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.partners
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/partner-categories/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.partnerCategories
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/posts/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.posts
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/pages/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.pages
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/export/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.export
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/images/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.images
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/promo-codes/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.promoCodes
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                window.CARE_CONFIG.invoicesEnabled && _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/invoices/', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.invoices
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/participant-results', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.participantResults
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/settings', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.settings
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _reactRouter.Link,
	                                        { to: '/admin/config', activeClassName: 'active' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'title' },
	                                            _strings2.default.configuration
	                                        ),
	                                        _react2.default.createElement(_icon2.default, { icon: 'chevron-right', size: 'ss' })
	                                    )
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { style: { padding: '8px 15px' } },
	                                ['lt', 'en'].map(function (lang) {
	                                    return _react2.default.createElement(
	                                        'a',
	                                        { style: { paddingRight: '10px', textTransform: 'uppercase' },
	                                            onClick: function onClick() {
	                                                (0, _languageCookie.saveLanguageCookie)(lang);
	                                                window.location.reload();
	                                            }, key: lang },
	                                        lang
	                                    );
	                                })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'right-col' },
	                            this.props.children
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AdminContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function () {
	    return {};
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, userActions), dispatch)
	    };
	})(AdminContainer);

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _statistics = __webpack_require__(536);
	
	var statisticActions = _interopRequireWildcard(_statistics);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactGoogleCharts = __webpack_require__(1087);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeContainer = function (_Component) {
	    _inherits(HomeContainer, _Component);
	
	    function HomeContainer() {
	        _classCallCheck(this, HomeContainer);
	
	        return _possibleConstructorReturn(this, (HomeContainer.__proto__ || Object.getPrototypeOf(HomeContainer)).apply(this, arguments));
	    }
	
	    _createClass(HomeContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchStatistics();
	        }
	    }, {
	        key: 'getIncomeChartData',
	        value: function getIncomeChartData() {
	            if (!this.props.statistics.item.incomeData) {
	                return [];
	            }
	            var data = [[_strings2.default.stage, _strings2.default.income]];
	            this.props.statistics.item.incomeData.forEach(function (stageIncome) {
	                data.push([stageIncome.stageName, parseFloat(stageIncome.sum)]);
	            });
	            return data;
	        }
	    }, {
	        key: 'getParticipantsChartData',
	        value: function getParticipantsChartData() {
	            if (!this.props.statistics.item.participantsData) {
	                return [];
	            }
	            var data = [[_strings2.default.stage, _strings2.default.participants]];
	            this.props.statistics.item.participantsData.forEach(function (stageIncome) {
	                data.push([stageIncome.name, parseFloat(stageIncome.count)]);
	            });
	            return data;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	
	            if (this.props.statistics.loading) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_loading2.default, null)
	                );
	            }
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'chart-item' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'title' },
	                        _strings2.default.income
	                    ),
	                    _react2.default.createElement(_reactGoogleCharts.Chart, { chartType: 'LineChart', data: this.getIncomeChartData(), options: {}, graph_id: 'IncomeChart', width: '100%', height: '400px', legend_toggle: true })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'chart-item' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'title' },
	                        _strings2.default.participants
	                    ),
	                    _react2.default.createElement(_reactGoogleCharts.Chart, { chartType: 'LineChart', data: this.getParticipantsChartData(), options: {}, graph_id: 'ParticipantsChart', width: '100%', height: '400px', legend_toggle: true })
	                )
	            );
	        }
	    }]);
	
	    return HomeContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { statistics: state.statistics.statistics };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, statisticActions), dispatch)
	    };
	})(HomeContainer);

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _distanceSelection = __webpack_require__(248);
	
	var _distanceSelection2 = _interopRequireDefault(_distanceSelection);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExportContainer = function (_Component) {
	    _inherits(ExportContainer, _Component);
	
	    function ExportContainer(props) {
	        _classCallCheck(this, ExportContainer);
	
	        var _this = _possibleConstructorReturn(this, (ExportContainer.__proto__ || Object.getPrototypeOf(ExportContainer)).call(this, props));
	
	        _this.state = {
	            stage: null,
	            distance: null
	        };
	        return _this;
	    }
	
	    _createClass(ExportContainer, [{
	        key: 'onFilterChange',
	        value: function onFilterChange(filterValues) {
	            this.setState(filterValues);
	        }
	    }, {
	        key: 'renderDistanceExports',
	        value: function renderDistanceExports() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_icon2.default, { icon: 'xlsx-file', size: 'ss' }),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/api/export/stage-participants/' + this.state.stage.value, target: '_blank' },
	                        _strings2.default.participantsExport
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_icon2.default, { icon: 'xlsx-file', size: 'ss' }),
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/api/export/stage-participants-all/' + this.state.stage.value, target: '_blank' },
	                        _strings2.default.allParticipantsExport
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.export
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'three-selects' },
	                            _react2.default.createElement(_distanceSelection2.default, { onChange: this.onFilterChange.bind(this) })
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'mt-30' },
	                            this.state.stage ? this.renderDistanceExports() : _strings2.default.selectStage
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ExportContainer;
	}(_react.Component);
	
	exports.default = ExportContainer;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _imageForm = __webpack_require__(545);
	
	var _imageForm2 = _interopRequireDefault(_imageForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ImageContainer = function (_Component) {
	    _inherits(ImageContainer, _Component);
	
	    function ImageContainer(props) {
	        _classCallCheck(this, ImageContainer);
	
	        var _this = _possibleConstructorReturn(this, (ImageContainer.__proto__ || Object.getPrototypeOf(ImageContainer)).call(this, props));
	
	        _this.state = {
	            imageId: null
	        };
	
	        return _this;
	    }
	
	    _createClass(ImageContainer, [{
	        key: 'onImageUploaded',
	        value: function onImageUploaded(values) {
	            this.setState({ imageId: values.id, filename: values.filename });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.newImage
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    _react2.default.createElement(_imageForm2.default, { onImageUploaded: this.onImageUploaded.bind(this) }),
	                    this.state.filename ? _react2.default.createElement(
	                        'div',
	                        null,
	                        _strings2.default.url,
	                        ': ',
	                        '' + window.CARE_CONFIG.image_storage_base_url_v2 + this.state.filename
	                    ) : null
	                )
	            );
	        }
	    }]);
	
	    return ImageContainer;
	}(_react.Component);
	
	exports.default = ImageContainer;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _image = __webpack_require__(532);
	
	var imagesActions = _interopRequireWildcard(_image);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _internalImageV = __webpack_require__(107);
	
	var _internalImageV2 = _interopRequireDefault(_internalImageV);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SeasonsContainer = function (_Component) {
	    _inherits(SeasonsContainer, _Component);
	
	    function SeasonsContainer(props) {
	        _classCallCheck(this, SeasonsContainer);
	
	        var _this = _possibleConstructorReturn(this, (SeasonsContainer.__proto__ || Object.getPrototypeOf(SeasonsContainer)).call(this, props));
	
	        _this.state = {
	            page: 0
	        };
	        return _this;
	    }
	
	    _createClass(SeasonsContainer, [{
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchImages(fetchParams.page, fetchParams.size);
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchImages();
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem(image) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deleteImage(image.id);
	            }
	            return false;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$images = this.props.images,
	                items = _props$images.items,
	                total = _props$images.total,
	                page = _props$images.page,
	                loading = _props$images.loading,
	                total_pages = _props$images.total_pages;
	
	            var config = {
	                cols: [{
	
	                    header: _strings2.default.image,
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'image-display-in-table' },
	                            _react2.default.createElement(_internalImageV2.default, { filename: item.filename, alt: '' })
	                        );
	                    }
	                }, {
	
	                    header: _strings2.default.url,
	                    value: function value(item) {
	                        var url = '' + window.CARE_CONFIG.image_storage_base_url_v2 + item.filename;
	                        return _react2.default.createElement(
	                            'a',
	                            { href: url, target: '_blank' },
	                            url
	                        );
	                    }
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red', onClick: _this2.removeItem.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.images
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/images/new', className: 'btn btn-primary' },
	                        _strings2.default.newImage
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, loading: loading, totalPages: total_pages, loadAction: this.fetch.bind(this) })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SeasonsContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { images: state.images.images };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, imagesActions), dispatch)
	    };
	})(SeasonsContainer);

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _promoCodeForm = __webpack_require__(246);
	
	var _promoCodeForm2 = _interopRequireDefault(_promoCodeForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _promoCodes = __webpack_require__(164);
	
	var promoCodesActions = _interopRequireWildcard(_promoCodes);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerContainer, _AdminItemPageContain);
	
	    function PartnerContainer() {
	        _classCallCheck(this, PartnerContainer);
	
	        return _possibleConstructorReturn(this, (PartnerContainer.__proto__ || Object.getPrototypeOf(PartnerContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/promo-codes';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchPromoCode(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.promoCodeEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_promoCodeForm2.default, { submit: actions.submitPromoCode, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return PartnerContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.promoCodes.promoCode.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, promoCodesActions), dispatch)
	    };
	})(PartnerContainer);

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _invoices = __webpack_require__(533);
	
	var invoiceActions = _interopRequireWildcard(_invoices);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _icon = __webpack_require__(62);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InvoicesContainer = function (_Component) {
	  _inherits(InvoicesContainer, _Component);
	
	  function InvoicesContainer() {
	    _classCallCheck(this, InvoicesContainer);
	
	    return _possibleConstructorReturn(this, (InvoicesContainer.__proto__ || Object.getPrototypeOf(InvoicesContainer)).apply(this, arguments));
	  }
	
	  _createClass(InvoicesContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetch({});
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch(params) {
	      var fetchParams = _extends({}, this.state, params);
	      this.setState(fetchParams);
	      this.props.actions.fetchInvoicesPaginated(fetchParams.page, fetchParams.size);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$invoices = this.props.invoices,
	          items = _props$invoices.items,
	          total = _props$invoices.total,
	          page = _props$invoices.page,
	          loading = _props$invoices.loading,
	          total_pages = _props$invoices.total_pages;
	
	
	      var config = {
	        cols: [{
	          value: 'serial',
	          header: _strings2.default.serialNumber
	        }, {
	          value: 'amount',
	          header: _strings2.default.amount
	        }, {
	          value: function value(item) {
	            return (0, _moment2.default)(item.invoice_date).format('YYYY-MM-DD');
	          },
	          header: _strings2.default.date
	        }, {
	          value: function value(item) {
	            return item.payment.participants.map(function (item) {
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/admin/participants/' + item.id },
	                item.name
	              );
	            });
	          },
	          header: _strings2.default.participants
	        }, {
	          value: function value(item) {
	            return item.payment.participants.map(function (item) {
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/admin/stages/' + item.stage.id },
	                item.stage.name
	              );
	            });
	          },
	          header: _strings2.default.stage
	        }, {
	          value: function value(item) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/api/invoice/export/' + item.id, className: 'btn', target: '_blank' },
	              _strings2.default.preview
	            );
	          },
	          header: _strings2.default.actions
	        }]
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          null,
	          _strings2.default.invoices
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/api/invoices/export', target: '_blank' },
	                _strings2.default.export,
	                _react2.default.createElement(_icon2.default, { icon: 'xlsx-file', size: 'ss' })
	              )
	            ),
	            _react2.default.createElement(_dataTable2.default, { loading: loading, config: config, items: items, page: page, total: total,
	              totalPages: total_pages, loadAction: this.fetch.bind(this) })
	          )
	        )
	      );
	    }
	  }]);
	
	  return InvoicesContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { invoices: state.invoices.invoices };
	}, function (dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, invoiceActions), dispatch)
	  };
	})(InvoicesContainer);

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loginForm = __webpack_require__(563);
	
	var _loginForm2 = _interopRequireDefault(_loginForm);
	
	var _users = __webpack_require__(123);
	
	var userActions = _interopRequireWildcard(_users);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _pageContainer = __webpack_require__(127);
	
	var _pageContainer2 = _interopRequireDefault(_pageContainer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LoginContainer = function (_PageContainer) {
	    _inherits(LoginContainer, _PageContainer);
	
	    function LoginContainer() {
	        _classCallCheck(this, LoginContainer);
	
	        return _possibleConstructorReturn(this, (LoginContainer.__proto__ || Object.getPrototypeOf(LoginContainer)).apply(this, arguments));
	    }
	
	    _createClass(LoginContainer, [{
	        key: 'onSuccessSubmit',
	        value: function onSuccessSubmit() {
	            window.USER_LOGGED = true;
	            this.openPage('/admin/');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var actions = this.props.actions;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'login' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'logo-wrapper' },
	                        _react2.default.createElement('img', { src: __webpack_require__(297) })
	                    ),
	                    _react2.default.createElement(_loginForm2.default, { submit: actions.login, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return LoginContainer;
	}(_pageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function () {
	    return {};
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, userActions), dispatch)
	    };
	})(LoginContainer);

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _page = __webpack_require__(162);
	
	var pageActions = _interopRequireWildcard(_page);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _pageForm = __webpack_require__(548);
	
	var _pageForm2 = _interopRequireDefault(_pageForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerContainer, _AdminItemPageContain);
	
	    function PartnerContainer() {
	        _classCallCheck(this, PartnerContainer);
	
	        return _possibleConstructorReturn(this, (PartnerContainer.__proto__ || Object.getPrototypeOf(PartnerContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/pages';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchPage(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.pageEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_pageForm2.default, { submit: actions.submitPage, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return PartnerContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.page.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, pageActions), dispatch)
	    };
	})(PartnerContainer);

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _page = __webpack_require__(162);
	
	var pageActions = _interopRequireWildcard(_page);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnersContainer = function (_Component) {
	    _inherits(PartnersContainer, _Component);
	
	    function PartnersContainer() {
	        _classCallCheck(this, PartnersContainer);
	
	        return _possibleConstructorReturn(this, (PartnersContainer.__proto__ || Object.getPrototypeOf(PartnersContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnersContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch({});
	        }
	    }, {
	        key: 'removePage',
	        value: function removePage(page) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deletePage(page);
	            }
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchPagesPaginated(fetchParams.page, fetchParams.size);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$pages = this.props.pages,
	                items = _props$pages.items,
	                total = _props$pages.total,
	                page = _props$pages.page,
	                loading = _props$pages.loading,
	                total_pages = _props$pages.total_pages;
	
	
	            var config = {
	                cols: [{
	                    value: 'title_lt',
	                    header: _strings2.default.title
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            null,
	                            'LT: ',
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/page/' + item.slug_lt },
	                                '/page/' + item.slug_lt
	                            ),
	                            ' ',
	                            _react2.default.createElement('br', null),
	                            'EN: ',
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/page/' + item.slug_en },
	                                '/page/' + item.slug_en
	                            )
	                        );
	                    },
	                    header: _strings2.default.linkToPage
	                }, {
	                    value: function value(item) {
	                        return item.show_in_footer ? _strings2.default.yes : _strings2.default.no;
	                    },
	                    header: _strings2.default.showInFooter
	                }, {
	                    value: 'order',
	                    header: _strings2.default.order
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/admin/pages/' + item.id, className: 'btn' },
	                                _strings2.default.edit
	                            ),
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/page/' + item.slug, className: 'btn' },
	                                _strings2.default.preview
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red', onClick: _this2.removePage.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.pages
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/pages/new', className: 'btn btn-primary' },
	                        _strings2.default.newPage
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, totalPages: total_pages, loadAction: this.fetch.bind(this), loading: loading })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnersContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { pages: state.page.pages };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, pageActions), dispatch)
	    };
	})(PartnersContainer);

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _participantResultForm = __webpack_require__(549);
	
	var _participantResultForm2 = _interopRequireDefault(_participantResultForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AdminParticipantContainer = function (_AdminItemPageContain) {
	    _inherits(AdminParticipantContainer, _AdminItemPageContain);
	
	    function AdminParticipantContainer() {
	        _classCallCheck(this, AdminParticipantContainer);
	
	        return _possibleConstructorReturn(this, (AdminParticipantContainer.__proto__ || Object.getPrototypeOf(AdminParticipantContainer)).apply(this, arguments));
	    }
	
	    _createClass(AdminParticipantContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/participant-results';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchParticipantResult(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    'Participant result edit'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_participantResultForm2.default, { submit: actions.submitParticipantResult,
	                        onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return AdminParticipantContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        loading: state.admin.participant.participant_result.loading,
	        item: state.admin.participant.participant_result.item
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(AdminParticipantContainer);

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _participantResultHistoryForm = __webpack_require__(243);
	
	var _participantResultHistoryForm2 = _interopRequireDefault(_participantResultHistoryForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _participantResultsDisplay = __webpack_require__(166);
	
	var _participantResultsDisplay2 = _interopRequireDefault(_participantResultsDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParticipantResultsContainer = function (_Component) {
	    _inherits(ParticipantResultsContainer, _Component);
	
	    function ParticipantResultsContainer(props) {
	        _classCallCheck(this, ParticipantResultsContainer);
	
	        var _this = _possibleConstructorReturn(this, (ParticipantResultsContainer.__proto__ || Object.getPrototypeOf(ParticipantResultsContainer)).call(this, props));
	
	        _this.state = {
	            searchParams: null
	        };
	        return _this;
	    }
	
	    _createClass(ParticipantResultsContainer, [{
	        key: 'executeSearch',
	        value: function executeSearch(params) {
	            this.setState({
	                searchParams: params
	            });
	            return this.props.actions.submitAdminParticipantResultsSearch(params);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var participant_results = this.props.participant_results;
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.participantResults
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_participantResultHistoryForm2.default, { submit: this.executeSearch.bind(this) }),
	                        this.props.participant_results.loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_participantResultsDisplay2.default, { searchParams: this.state.searchParams,
	                            items: participant_results.items || [],
	                            extraCols: [{
	                                header: '', value: function value(item) {
	                                    return _react2.default.createElement(
	                                        'a',
	                                        {
	                                            href: '/admin/participant-results/' + item.id,
	                                            className: 'btn' },
	                                        _strings2.default.edit
	                                    );
	                                }
	                            }] })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ParticipantResultsContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { participant_results: state.admin.participant.participant_results };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(ParticipantResultsContainer);

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _participantForm = __webpack_require__(242);
	
	var _participantForm2 = _interopRequireDefault(_participantForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerContainer, _AdminItemPageContain);
	
	    function PartnerContainer() {
	        _classCallCheck(this, PartnerContainer);
	
	        return _possibleConstructorReturn(this, (PartnerContainer.__proto__ || Object.getPrototypeOf(PartnerContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/participants';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchParticipant(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    'Participant edit'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_participantForm2.default, { submit: actions.submitParticipant, onSuccessSubmit: this.onSuccessSubmit.bind(this), displayPayed: true })
	                )
	            );
	        }
	    }]);
	
	    return PartnerContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.participant.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(PartnerContainer);

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _distanceSelection = __webpack_require__(248);
	
	var _distanceSelection2 = _interopRequireDefault(_distanceSelection);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnersContainer = function (_Component) {
	    _inherits(PartnersContainer, _Component);
	
	    function PartnersContainer(props) {
	        _classCallCheck(this, PartnersContainer);
	
	        var _this = _possibleConstructorReturn(this, (PartnersContainer.__proto__ || Object.getPrototypeOf(PartnersContainer)).call(this, props));
	
	        _this.state = {
	            page: 0,
	            query: '',
	            stage: null,
	            season: window.CARE_CONFIG.settings.season ? window.CARE_CONFIG.settings.season.id : null,
	            distance: null,
	            payed: 'ALL'
	        };
	        return _this;
	    }
	
	    _createClass(PartnersContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch();
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchParticipantsPaginated(fetchParams.page, fetchParams.size, {
	                query: fetchParams.query,
	                stage: fetchParams.stage,
	                season: fetchParams.season,
	                distance: fetchParams.distance,
	                payed: fetchParams.payed
	            });
	        }
	    }, {
	        key: 'handleQueryChange',
	        value: function handleQueryChange(event) {
	            this.fetch({ query: event.target.value, page: 0 });
	        }
	    }, {
	        key: 'removeParticipant',
	        value: function removeParticipant(participant) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deleteParticipant(participant);
	            }
	        }
	    }, {
	        key: 'onFilterChange',
	        value: function onFilterChange(filterValues) {
	            this.fetch({
	                season: filterValues.season,
	                distance: filterValues.distance ? filterValues.distance.value : null,
	                stage: filterValues.stage ? filterValues.stage.value : null,
	                page: 0
	            });
	        }
	    }, {
	        key: 'onPayedChange',
	        value: function onPayedChange(selectedValue) {
	            this.fetch({ payed: selectedValue.value, page: 0 });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$participants = this.props.participants,
	                items = _props$participants.items,
	                total = _props$participants.total,
	                page = _props$participants.page,
	                total_pages = _props$participants.total_pages;
	
	
	            var config = {
	                cols: [{
	                    value: 'displayName',
	                    header: _strings2.default.firstName + ' ' + _strings2.default.lastName
	                }, {
	                    value: function value(item) {
	                        return item.payment.price + ' Eur';
	                    },
	                    header: _strings2.default.price
	                }, {
	                    value: function value(item) {
	                        if (item.price === 0) {
	                            return _strings2.default.isFree;
	                        }
	                        if (item.payed) {
	                            return _strings2.default.yes;
	                        }
	                        return _strings2.default.no;
	                    },
	                    header: _strings2.default.payed
	                }, {
	                    value: function value(item) {
	                        return item.distance ? item.distance.name + ' (' + (item.stage ? item.stage.name : '') + ')' : '';
	                    },
	                    header: _strings2.default.distance
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/admin/participants/' + item.id,
	                                    className: 'btn' },
	                                _strings2.default.edit
	                            ),
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/participant/' + item.uuid,
	                                    className: 'btn' },
	                                _strings2.default.paymentPage
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red',
	                                    onClick: _this2.removeParticipant.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'first-uppercase' },
	                    _strings2.default.participants
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/participants/new', className: 'btn btn-primary' },
	                        _strings2.default.newParticipant
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(
	                            'fieldset',
	                            { className: 'filters' },
	                            _react2.default.createElement(
	                                'legend',
	                                null,
	                                _strings2.default.filters
	                            ),
	                            _react2.default.createElement(
	                                'form',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inline-fields' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-field' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'field-control' },
	                                                _react2.default.createElement('input', { type: 'text', value: this.state.query,
	                                                    onChange: this.handleQueryChange.bind(this),
	                                                    placeholder: _strings2.default.search })
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inline-fields' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'three-selects' },
	                                        _react2.default.createElement(_distanceSelection2.default, { onChange: this.onFilterChange.bind(this) })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inline-fields' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-field' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'select-with-label' },
	                                            _react2.default.createElement(
	                                                'label',
	                                                null,
	                                                _strings2.default.payedFilterLabel
	                                            ),
	                                            _react2.default.createElement(_select2.default, { clearable: false, value: this.state.payed, options: [{ id: 'ALL', 'name': _strings2.default.allPaymentsFilter }, { id: 'PAYED', 'name': _strings2.default.payedFilter }, { id: 'NOT_PAYED', 'name': _strings2.default.notPayedFilter }], noResultsText: '', placeholder: '',
	                                                onChange: this.onPayedChange.bind(this) })
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, totalPages: total_pages,
	                            loadAction: this.fetch.bind(this) })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnersContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { participants: state.participant.participants };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(PartnersContainer);

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _partnerCategories = __webpack_require__(163);
	
	var partnerCategoryActions = _interopRequireWildcard(_partnerCategories);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerCategoriesContainer = function (_Component) {
	    _inherits(PartnerCategoriesContainer, _Component);
	
	    function PartnerCategoriesContainer(props) {
	        _classCallCheck(this, PartnerCategoriesContainer);
	
	        var _this = _possibleConstructorReturn(this, (PartnerCategoriesContainer.__proto__ || Object.getPrototypeOf(PartnerCategoriesContainer)).call(this, props));
	
	        _this.state = {
	            page: 0
	        };
	        return _this;
	    }
	
	    _createClass(PartnerCategoriesContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch({});
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchPartnerCategories(fetchParams.page, fetchParams.size);
	        }
	    }, {
	        key: 'removePartner',
	        value: function removePartner(partner) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deletePartnerCategory(partner);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$categories = this.props.categories,
	                items = _props$categories.items,
	                total = _props$categories.total,
	                page = _props$categories.page,
	                total_pages = _props$categories.total_pages,
	                loading = _props$categories.loading;
	
	
	            var config = {
	                cols: [{
	                    value: 'name',
	                    header: _strings2.default.name
	                }, {
	                    value: 'order',
	                    header: _strings2.default.order
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { className: 'btn',
	                                    to: '/admin/partner-categories/' + item.id },
	                                _strings2.default.edit
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red',
	                                    onClick: _this2.removePartner.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'first-uppercase' },
	                    _strings2.default.partnerCategories
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/partner-categories/new', className: 'btn btn-primary' },
	                        _strings2.default.newPartnerCategory
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, totalPages: total_pages,
	                            loadAction: this.fetch.bind(this), loading: loading })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnerCategoriesContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { categories: state.admin.partnerCategories.categories };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, partnerCategoryActions), dispatch)
	    };
	})(PartnerCategoriesContainer);

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _partnerCategories = __webpack_require__(163);
	
	var partnerCategoriesActions = _interopRequireWildcard(_partnerCategories);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _partnerCategoryForm = __webpack_require__(550);
	
	var _partnerCategoryForm2 = _interopRequireDefault(_partnerCategoryForm);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerCategoryContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerCategoryContainer, _AdminItemPageContain);
	
	    function PartnerCategoryContainer() {
	        _classCallCheck(this, PartnerCategoryContainer);
	
	        return _possibleConstructorReturn(this, (PartnerCategoryContainer.__proto__ || Object.getPrototypeOf(PartnerCategoryContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerCategoryContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/partner-categories';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchPartnerCategory(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.partnerCategoryEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_partnerCategoryForm2.default, { submit: actions.submitPartnerCategory,
	                        onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return PartnerCategoryContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.admin.partnerCategories.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, partnerCategoriesActions), dispatch)
	    };
	})(PartnerCategoryContainer);

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _partnerForm = __webpack_require__(553);
	
	var _partnerForm2 = _interopRequireDefault(_partnerForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _partners = __webpack_require__(122);
	
	var partnersActions = _interopRequireWildcard(_partners);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerContainer, _AdminItemPageContain);
	
	    function PartnerContainer() {
	        _classCallCheck(this, PartnerContainer);
	
	        return _possibleConstructorReturn(this, (PartnerContainer.__proto__ || Object.getPrototypeOf(PartnerContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/partners';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchPartner(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.partnerEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_partnerForm2.default, { submit: actions.submitPartner, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return PartnerContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.admin.partners.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, partnersActions), dispatch)
	    };
	})(PartnerContainer);

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _partners = __webpack_require__(122);
	
	var partnerActions = _interopRequireWildcard(_partners);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnersContainer = function (_Component) {
	    _inherits(PartnersContainer, _Component);
	
	    function PartnersContainer(props) {
	        _classCallCheck(this, PartnersContainer);
	
	        var _this = _possibleConstructorReturn(this, (PartnersContainer.__proto__ || Object.getPrototypeOf(PartnersContainer)).call(this, props));
	
	        _this.state = {
	            page: 0
	        };
	        return _this;
	    }
	
	    _createClass(PartnersContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch({});
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchPartners(fetchParams.page, fetchParams.size);
	        }
	    }, {
	        key: 'removePartner',
	        value: function removePartner(partner) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deletePartner(partner);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$partners = this.props.partners,
	                items = _props$partners.items,
	                total = _props$partners.total,
	                page = _props$partners.page,
	                total_pages = _props$partners.total_pages,
	                loading = _props$partners.loading;
	
	
	            var config = {
	                cols: [{
	                    value: 'name',
	                    header: _strings2.default.name
	                }, {
	                    value: 'order',
	                    header: _strings2.default.order
	                }, {
	                    value: function value(item) {
	                        return item.partnerCategory ? item.partnerCategory.name : '';
	                    },
	                    header: _strings2.default.partnerCategory
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { className: 'btn', to: '/admin/partners/' + item.id },
	                                _strings2.default.edit
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red',
	                                    onClick: _this2.removePartner.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    { className: 'first-uppercase' },
	                    _strings2.default.partners
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/partners/new', className: 'btn btn-primary' },
	                        _strings2.default.newPartner
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, totalPages: total_pages,
	                            loadAction: this.fetch.bind(this), loading: loading })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnersContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { partners: state.admin.partners.partners };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, partnerActions), dispatch)
	    };
	})(PartnersContainer);

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _postForm = __webpack_require__(554);
	
	var _postForm2 = _interopRequireDefault(_postForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _post = __webpack_require__(106);
	
	var postActions = _interopRequireWildcard(_post);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerContainer, _AdminItemPageContain);
	
	    function PartnerContainer() {
	        _classCallCheck(this, PartnerContainer);
	
	        return _possibleConstructorReturn(this, (PartnerContainer.__proto__ || Object.getPrototypeOf(PartnerContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/posts';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchPost(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.postEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_postForm2.default, { submit: actions.submitPost, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return PartnerContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.post.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, postActions), dispatch)
	    };
	})(PartnerContainer);

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _post = __webpack_require__(106);
	
	var postActions = _interopRequireWildcard(_post);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnersContainer = function (_Component) {
	    _inherits(PartnersContainer, _Component);
	
	    function PartnersContainer() {
	        _classCallCheck(this, PartnersContainer);
	
	        return _possibleConstructorReturn(this, (PartnersContainer.__proto__ || Object.getPrototypeOf(PartnersContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnersContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch({});
	        }
	    }, {
	        key: 'removePost',
	        value: function removePost(post) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deletePost(post);
	            }
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchPostsPaginated(fetchParams.page, fetchParams.size);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$posts = this.props.posts,
	                items = _props$posts.items,
	                total = _props$posts.total,
	                page = _props$posts.page,
	                loading = _props$posts.loading,
	                total_pages = _props$posts.total_pages;
	
	
	            var config = {
	                cols: [{
	                    value: 'title',
	                    header: _strings2.default.title
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/admin/posts/' + item.id, className: 'btn' },
	                                _strings2.default.edit
	                            ),
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/post/' + item.slug, className: 'btn' },
	                                _strings2.default.preview
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red', onClick: _this2.removePost.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.posts
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/posts/new', className: 'btn btn-primary' },
	                        _strings2.default.newPost
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, totalPages: total_pages, loadAction: this.fetch.bind(this), loading: loading })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PartnersContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { posts: state.post.posts };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, postActions), dispatch)
	    };
	})(PartnersContainer);

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _promoCodeForm = __webpack_require__(246);
	
	var _promoCodeForm2 = _interopRequireDefault(_promoCodeForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _promoCodes = __webpack_require__(164);
	
	var promoCodesActions = _interopRequireWildcard(_promoCodes);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PartnerContainer = function (_AdminItemPageContain) {
	    _inherits(PartnerContainer, _AdminItemPageContain);
	
	    function PartnerContainer() {
	        _classCallCheck(this, PartnerContainer);
	
	        return _possibleConstructorReturn(this, (PartnerContainer.__proto__ || Object.getPrototypeOf(PartnerContainer)).apply(this, arguments));
	    }
	
	    _createClass(PartnerContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/promo-codes';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchPromoCode(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.promoCodeEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_promoCodeForm2.default, { submit: actions.submitPromoCode, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return PartnerContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.promoCodes.promoCode.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, promoCodesActions), dispatch)
	    };
	})(PartnerContainer);

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _promoCodes = __webpack_require__(164);
	
	var promoCodeActions = _interopRequireWildcard(_promoCodes);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PromoCodesContainer = function (_Component) {
	    _inherits(PromoCodesContainer, _Component);
	
	    function PromoCodesContainer() {
	        _classCallCheck(this, PromoCodesContainer);
	
	        return _possibleConstructorReturn(this, (PromoCodesContainer.__proto__ || Object.getPrototypeOf(PromoCodesContainer)).apply(this, arguments));
	    }
	
	    _createClass(PromoCodesContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.fetch({});
	        }
	    }, {
	        key: 'removeItem',
	        value: function removeItem(post) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.deletePromoCode(post);
	            }
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchPromoCodesPaginated(fetchParams.page, fetchParams.size);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props$promoCodes = this.props.promoCodes,
	                items = _props$promoCodes.items,
	                total = _props$promoCodes.total,
	                page = _props$promoCodes.page,
	                loading = _props$promoCodes.loading,
	                total_pages = _props$promoCodes.total_pages;
	
	
	            var config = {
	                cols: [{
	                    value: 'code',
	                    header: _strings2.default.code
	                }, {
	                    value: 'codes_left',
	                    header: _strings2.default.codesLeft
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'btn-group' },
	                            _react2.default.createElement(
	                                _reactRouter.Link,
	                                { to: '/admin/promo-codes/' + item.id, className: 'btn' },
	                                _strings2.default.edit
	                            ),
	                            _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-red', onClick: _this2.removeItem.bind(_this2, item) },
	                                _strings2.default.delete
	                            )
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.promoCodes
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/promo-codes/new', className: 'btn btn-primary' },
	                        _strings2.default.newPromoCode
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { loading: loading, config: config, items: items, page: page, total: total, totalPages: total_pages, loadAction: this.fetch.bind(this) })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PromoCodesContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { promoCodes: state.promoCodes.promoCodes };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, promoCodeActions), dispatch)
	    };
	})(PromoCodesContainer);

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _seasonForm = __webpack_require__(555);
	
	var _seasonForm2 = _interopRequireDefault(_seasonForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _seasons = __webpack_require__(165);
	
	var seasonsActions = _interopRequireWildcard(_seasons);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SeasonContainer = function (_AdminItemPageContain) {
	    _inherits(SeasonContainer, _AdminItemPageContain);
	
	    function SeasonContainer() {
	        _classCallCheck(this, SeasonContainer);
	
	        return _possibleConstructorReturn(this, (SeasonContainer.__proto__ || Object.getPrototypeOf(SeasonContainer)).apply(this, arguments));
	    }
	
	    _createClass(SeasonContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/seasons';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchSeason(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.seasonEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_seasonForm2.default, { submit: actions.submitSeason, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return SeasonContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.season.season.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, seasonsActions), dispatch)
	    };
	})(SeasonContainer);

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _seasons = __webpack_require__(165);
	
	var seasonsActions = _interopRequireWildcard(_seasons);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SeasonsContainer = function (_Component) {
	    _inherits(SeasonsContainer, _Component);
	
	    function SeasonsContainer() {
	        _classCallCheck(this, SeasonsContainer);
	
	        return _possibleConstructorReturn(this, (SeasonsContainer.__proto__ || Object.getPrototypeOf(SeasonsContainer)).apply(this, arguments));
	    }
	
	    _createClass(SeasonsContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchSeasons();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$seasons = this.props.seasons,
	                items = _props$seasons.items,
	                total = _props$seasons.total,
	                page = _props$seasons.page,
	                loading = _props$seasons.loading;
	
	
	            var config = {
	                cols: [{
	                    value: 'name',
	                    header: _strings2.default.name
	                }, {
	                    value: 'order',
	                    header: _strings2.default.order
	                }, {
	                    value: function value(item) {
	
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/admin/seasons/' + item.id, className: 'btn' },
	                            _strings2.default.edit
	                        );
	                    },
	                    header: _strings2.default.actions
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    _strings2.default.seasons
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'table-actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/admin/seasons/new', className: 'btn btn-primary' },
	                        _strings2.default.newSeason
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total,
	                            loading: loading })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return SeasonsContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { seasons: state.season.seasons };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, seasonsActions), dispatch)
	    };
	})(SeasonsContainer);

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _pageContainer = __webpack_require__(127);
	
	var _pageContainer2 = _interopRequireDefault(_pageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConfigurationContainer = function (_PageContainer) {
	  _inherits(ConfigurationContainer, _PageContainer);
	
	  function ConfigurationContainer(props) {
	    _classCallCheck(this, ConfigurationContainer);
	
	    var _this = _possibleConstructorReturn(this, (ConfigurationContainer.__proto__ || Object.getPrototypeOf(ConfigurationContainer)).call(this, props));
	
	    _this.state = {
	      data: null,
	      loading: true
	    };
	    return _this;
	  }
	
	  _createClass(ConfigurationContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.fetchData();
	    }
	  }, {
	    key: 'fetchData',
	    value: function fetchData() {
	      var _this2 = this;
	
	      fetch('/api/config-info').then(function (response) {
	        if (!response.ok) {
	          throw new Error('Network response was not ok');
	        }
	        return response.json();
	      }).then(function (data) {
	        return _this2.setState({ data: data, loading: false });
	      }).catch(function (error) {
	        return _this2.setState({ error: error, loading: false });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          loading = _state.loading;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'panel' },
	        _react2.default.createElement(
	          'header',
	          { className: 'panel-header' },
	          _strings2.default.configuration
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel-body' },
	          loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                'Paysera'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'ID:'
	                ),
	                ' ',
	                data.paysera.projectId,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Bandomieji mok\u0117jimai:'
	                ),
	                ' ',
	                data.paysera.testPayment ? 'Taip' : 'Ne',
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Mok\u0117jimas i\u0161kart:'
	                ),
	                ' ',
	                data.paysera.instantPayment ? 'Taip' : 'Ne',
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Matomi tik apmok\u0117j\u0119 dalyviai:'
	                ),
	                ' ',
	                data.paysera.onlyPayedParticipants ? 'Taip' : 'Ne',
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                'El. pa\u0161tas'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Siuntimo adresas:'
	                ),
	                ' ',
	                data.email.emailFrom,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'SMTP serveris:'
	                ),
	                ' ',
	                data.email.server,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'SMTP vartotojas:'
	                ),
	                ' ',
	                data.email.smtpUser,
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                'S\u0105skaitos'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'S\u0105skait\u0173 generavimas \u012Fjungtas:'
	                ),
	                ' ',
	                data.invoices.generate ? 'Taip' : 'Ne',
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'S\u0105skait\u0173 serija:'
	                ),
	                ' ',
	                data.invoices.serialPlaceholder,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'S\u0105skait\u0173 i\u0161ra\u0161ymas:'
	                ),
	                ' ',
	                data.invoices.sellerInfo,
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                'Dalyviai'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Dalyvio BARCODE generavimas:'
	                ),
	                ' ',
	                data.participant.barcode ? 'Taip' : 'Ne',
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Minimalus nari\u0173 skai\u010Dius komandos registracijoje:'
	                ),
	                ' ',
	                data.participant.minTeamMembers,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  'Registracijos papildomo lauko konfig\u016Bracija:'
	                ),
	                ' ',
	                data.participant.participantCustomField,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'b',
	                  null,
	                  '\u0160alies pasirinkimas:'
	                ),
	                ' ',
	                data.participant.countrySelection,
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                'Kainos'
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                ' am\u017Eius ',
	                '<=',
	                ' ',
	                data.pricing.ageGroups.children,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                ' ',
	                data.pricing.ageGroups.children,
	                ' ',
	                '<',
	                ' am\u017Eius ',
	                '<',
	                ' ',
	                data.pricing.ageGroups.older,
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                ' am\u017Eius ',
	                '>=',
	                ' ',
	                data.pricing.ageGroups.older,
	                ' '
	              )
	            ),
	            _react2.default.createElement(
	              'fieldset',
	              null,
	              _react2.default.createElement(
	                'legend',
	                null,
	                'Pagrindinio puslapio paveiksl\u0117liai'
	              ),
	              window.CARE_CONFIG.landingImages.map(function (image, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: index },
	                  _react2.default.createElement('img', { src: image, width: 200 })
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ConfigurationContainer;
	}(_pageContainer2.default);
	
	exports.default = ConfigurationContainer;

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _settingsForm = __webpack_require__(556);
	
	var _settingsForm2 = _interopRequireDefault(_settingsForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _settings = __webpack_require__(535);
	
	var settingsActions = _interopRequireWildcard(_settings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SeasonContainer = function (_AdminItemPageContain) {
	    _inherits(SeasonContainer, _AdminItemPageContain);
	
	    function SeasonContainer() {
	        _classCallCheck(this, SeasonContainer);
	
	        return _possibleConstructorReturn(this, (SeasonContainer.__proto__ || Object.getPrototypeOf(SeasonContainer)).apply(this, arguments));
	    }
	
	    _createClass(SeasonContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/settings';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem() {
	            return this.props.actions.fetchSettings();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.settingsEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_settingsForm2.default, { submit: actions.submitSettings })
	                )
	            );
	        }
	    }]);
	
	    return SeasonContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.settings.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, settingsActions), dispatch)
	    };
	})(SeasonContainer);

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _stageForm = __webpack_require__(559);
	
	var _stageForm2 = _interopRequireDefault(_stageForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _stages = __webpack_require__(47);
	
	var stagesActions = _interopRequireWildcard(_stages);
	
	var _distanceActions = __webpack_require__(530);
	
	var distanceActions = _interopRequireWildcard(_distanceActions);
	
	var _distanceModal = __webpack_require__(558);
	
	var _distanceModal2 = _interopRequireDefault(_distanceModal);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _form = __webpack_require__(23);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageContainer = function (_AdminItemPageContain) {
	    _inherits(StageContainer, _AdminItemPageContain);
	
	    function StageContainer() {
	        _classCallCheck(this, StageContainer);
	
	        return _possibleConstructorReturn(this, (StageContainer.__proto__ || Object.getPrototypeOf(StageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StageContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/stages';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchStage(id);
	        }
	    }, {
	        key: 'editDistance',
	        value: function editDistance(distance) {
	            this.props.actions.toggleDistanceModal(true, distance);
	        }
	    }, {
	        key: 'removeDistance',
	        value: function removeDistance(distance) {
	            if (confirm(_strings2.default.doYouWantToRemove)) {
	                this.props.actions.removeDistance(distance).then(_form.translateAPIResponse).catch(function (err) {
	                    alert(err);
	                });
	            }
	        }
	    }, {
	        key: 'renderDistances',
	        value: function renderDistances() {
	            var _this2 = this;
	
	            var stage = this.props.stage;
	
	            if (!stage.distances) {
	                return null;
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.distanceEdit
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    '                ',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'table-actions-row' },
	                        _react2.default.createElement(
	                            'a',
	                            { className: 'btn btn-primary ', onClick: function onClick() {
	                                    _this2.editDistance({ stageId: stage.id });
	                                } },
	                            _strings2.default.newDistance
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'table',
	                        { className: 'table responsive' },
	                        _react2.default.createElement(
	                            'thead',
	                            null,
	                            _react2.default.createElement(
	                                'tr',
	                                null,
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _strings2.default.name
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _strings2.default.code
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _strings2.default.isFree
	                                ),
	                                _react2.default.createElement(
	                                    'td',
	                                    null,
	                                    _strings2.default.actions
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tbody',
	                            null,
	                            stage.distances.map(function (distance) {
	                                return _react2.default.createElement(
	                                    'tr',
	                                    { key: distance.id + '-distance' },
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        distance.name
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        distance.code
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        distance.isFree ? _strings2.default.yes : _strings2.default.no
	                                    ),
	                                    _react2.default.createElement(
	                                        'td',
	                                        null,
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'btn-group' },
	                                            _react2.default.createElement(
	                                                'a',
	                                                { className: 'btn', onClick: function onClick() {
	                                                        _this2.editDistance(distance);
	                                                    } },
	                                                _strings2.default.edit
	                                            ),
	                                            _react2.default.createElement(
	                                                'a',
	                                                { onClick: function onClick() {
	                                                        _this2.removeDistance(distance);
	                                                    }, className: 'btn btn-red' },
	                                                _strings2.default.remove
	                                            )
	                                        )
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'closeDistanceModal',
	        value: function closeDistanceModal() {
	            this.props.actions.toggleDistanceModal(false);
	        }
	    }, {
	        key: 'onDistanceSuccessSubmit',
	        value: function onDistanceSuccessSubmit(wasNew, distance) {
	            this.closeDistanceModal();
	            this.props.actions.updateStageDistance(distance);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading,
	                stage = _props.stage,
	                distanceModal = _props.distanceModal;
	
	
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'panel-header' },
	                        _strings2.default.stageEdit
	                    ),
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_stageForm2.default, { submit: actions.submitStage, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                    )
	                ),
	                stage ? this.renderDistances() : null,
	                _react2.default.createElement(_distanceModal2.default, { isOpen: distanceModal, stage: stage, submit: actions.submitDistance, cancel: this.closeDistanceModal.bind(this), onSuccessSubmit: this.onDistanceSuccessSubmit.bind(this) })
	            );
	        }
	    }]);
	
	    return StageContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.stage.stage.loading, stage: state.stage.stage.item, distanceModal: state.distance.distance_modal };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stagesActions, distanceActions), dispatch)
	    };
	})(StageContainer);

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _stages = __webpack_require__(47);
	
	var stagesActions = _interopRequireWildcard(_stages);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	var _stageResultsForm = __webpack_require__(560);
	
	var _stageResultsForm2 = _interopRequireDefault(_stageResultsForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageResultsContainer = function (_AdminItemPageContain) {
	    _inherits(StageResultsContainer, _AdminItemPageContain);
	
	    function StageResultsContainer() {
	        _classCallCheck(this, StageResultsContainer);
	
	        return _possibleConstructorReturn(this, (StageResultsContainer.__proto__ || Object.getPrototypeOf(StageResultsContainer)).apply(this, arguments));
	    }
	
	    _createClass(StageResultsContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/stages';
	        }
	    }, {
	        key: 'onSuccessSubmit',
	        value: function onSuccessSubmit() {
	            // alert('Saved');
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchStage(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    _strings2.default.stageResults
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    _react2.default.createElement(_stageResultsForm2.default, { submit: function submit(values) {
	                            return _this2.props.actions.submitStageResults(_this2.props.params.itemId, values);
	                        }, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return StageResultsContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.stage.stage.loading, stage: state.stage.stage.item };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stagesActions), dispatch)
	    };
	})(StageResultsContainer);

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _seasonSelect = __webpack_require__(167);
	
	var _seasonSelect2 = _interopRequireDefault(_seasonSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesContainer = function (_Component) {
	  _inherits(StagesContainer, _Component);
	
	  function StagesContainer(props) {
	    _classCallCheck(this, StagesContainer);
	
	    var _this = _possibleConstructorReturn(this, (StagesContainer.__proto__ || Object.getPrototypeOf(StagesContainer)).call(this, props));
	
	    var currentSeason = window.CARE_CONFIG.settings.season;
	    _this.state = {
	      page: 0,
	      season: currentSeason ? currentSeason.id : ''
	    };
	    return _this;
	  }
	
	  _createClass(StagesContainer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.fetch({});
	    }
	  }, {
	    key: 'removeStage',
	    value: function removeStage(stage) {
	      if (confirm(_strings2.default.doYouWantToRemove)) {
	        this.props.actions.deleteStage(stage);
	      }
	    }
	  }, {
	    key: 'fetch',
	    value: function fetch(params) {
	      var fetchParams = _extends({}, this.state, params);
	      this.setState(fetchParams);
	      this.props.actions.loadStages(fetchParams.page, fetchParams.size, {
	        season: fetchParams.season
	      });
	    }
	  }, {
	    key: 'onFilterChange',
	    value: function onFilterChange(filterValues) {
	      this.fetch({
	        season: filterValues ? filterValues : null,
	        page: 0
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$stages = this.props.stages,
	          items = _props$stages.items,
	          total = _props$stages.total,
	          page = _props$stages.page,
	          loading = _props$stages.loading,
	          total_pages = _props$stages.total_pages;
	
	
	      var config = {
	        cols: [{
	          value: 'name',
	          header: _strings2.default.name
	        }, {
	          value: function value(item) {
	            return (0, _moment2.default)(item.stage_date).format('YYYY-MM-DD HH:mm');
	          },
	          header: _strings2.default.date
	        }, {
	          value: function value(item) {
	            return item.season.name;
	          },
	          header: _strings2.default.season
	        }, {
	          value: 'address',
	          header: _strings2.default.address
	        }, {
	          value: function value(item) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'btn-group' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/admin/stages/' + item.id, className: 'btn' },
	                _strings2.default.edit
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { className: 'btn',
	                  to: '/admin/stages/' + item.id + '/results' },
	                _strings2.default.results
	              ),
	              _react2.default.createElement(
	                'a',
	                { className: 'btn btn-red',
	                  onClick: _this2.removeStage.bind(_this2, item) },
	                _strings2.default.delete
	              )
	            );
	          },
	          header: _strings2.default.actions
	        }]
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h3',
	          { className: 'first-uppercase' },
	          _strings2.default.stages
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'table-actions-row' },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/admin/stages/new', className: 'btn btn-primary' },
	            _strings2.default.newStage
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'panel' },
	          _react2.default.createElement(
	            'div',
	            { className: 'panel-body' },
	            _react2.default.createElement(
	              'fieldset',
	              { className: 'filters' },
	              _react2.default.createElement(
	                'legend',
	                null,
	                _strings2.default.filters
	              ),
	              _react2.default.createElement(
	                'form',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'inline-fields' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'two-selects' },
	                    _react2.default.createElement(_seasonSelect2.default, {
	                      field: {
	                        value: this.state.season,
	                        onChange: this.onFilterChange.bind(this)
	                      } })
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total, totalPages: total_pages,
	              loadAction: this.fetch.bind(this), loading: loading })
	          )
	        )
	      );
	    }
	  }]);
	
	  return StagesContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { stages: state.stage.stagesPaginated };
	}, function (dispatch) {
	  return {
	    actions: (0, _redux.bindActionCreators)(_extends({}, stageActions), dispatch)
	  };
	})(StagesContainer);

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userForm = __webpack_require__(564);
	
	var _userForm2 = _interopRequireDefault(_userForm);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _users = __webpack_require__(123);
	
	var userActions = _interopRequireWildcard(_users);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _adminItemPageContainer = __webpack_require__(36);
	
	var _adminItemPageContainer2 = _interopRequireDefault(_adminItemPageContainer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UserContainer = function (_AdminItemPageContain) {
	    _inherits(UserContainer, _AdminItemPageContain);
	
	    function UserContainer() {
	        _classCallCheck(this, UserContainer);
	
	        return _possibleConstructorReturn(this, (UserContainer.__proto__ || Object.getPrototypeOf(UserContainer)).apply(this, arguments));
	    }
	
	    _createClass(UserContainer, [{
	        key: 'getBaseUrl',
	        value: function getBaseUrl() {
	            return '/admin/users';
	        }
	    }, {
	        key: 'fetchItem',
	        value: function fetchItem(id) {
	            return this.props.actions.fetchUser(id);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                actions = _props.actions,
	                loading = _props.loading;
	
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'panel' },
	                _react2.default.createElement(
	                    'header',
	                    { className: 'panel-header' },
	                    'User edit'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel-body' },
	                    loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_userForm2.default, { submit: actions.submitUser, onSuccessSubmit: this.onSuccessSubmit.bind(this) })
	                )
	            );
	        }
	    }]);
	
	    return UserContainer;
	}(_adminItemPageContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { loading: state.admin.users.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, userActions), dispatch)
	    };
	})(UserContainer);

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _users = __webpack_require__(123);
	
	var userActions = _interopRequireWildcard(_users);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UsersContainer = function (_Component) {
	    _inherits(UsersContainer, _Component);
	
	    function UsersContainer() {
	        _classCallCheck(this, UsersContainer);
	
	        return _possibleConstructorReturn(this, (UsersContainer.__proto__ || Object.getPrototypeOf(UsersContainer)).apply(this, arguments));
	    }
	
	    _createClass(UsersContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.loadUsers();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props$users = this.props.users,
	                items = _props$users.items,
	                total = _props$users.total,
	                page = _props$users.page;
	
	
	            var config = {
	                cols: [{
	                    value: 'email',
	                    header: 'Email'
	                }, {
	                    value: function value(item) {
	                        return item.first_name + ' ' + item.last_name;
	                    },
	                    header: 'First name, Last Name'
	                }, {
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { to: '/admin/users/' + item.id },
	                            'Edit'
	                        );
	                    },
	                    header: 'Actions'
	                }]
	            };
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'Users'
	                ),
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/admin/users/new' },
	                    _react2.default.createElement(
	                        _button2.default,
	                        null,
	                        'New User'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'panel' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'panel-body' },
	                        _react2.default.createElement(_dataTable2.default, { config: config, items: items, page: page, total: total })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return UsersContainer;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { users: state.admin.users.result };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, userActions), dispatch)
	    };
	})(UsersContainer);

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(14);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _timeTicker = __webpack_require__(562);
	
	var _timeTicker2 = _interopRequireDefault(_timeTicker);
	
	var _imageSwitcher = __webpack_require__(544);
	
	var _imageSwitcher2 = _interopRequireDefault(_imageSwitcher);
	
	var _partners = __webpack_require__(122);
	
	var partnerActions = _interopRequireWildcard(_partners);
	
	var _post = __webpack_require__(106);
	
	var postActions = _interopRequireWildcard(_post);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _classnames = __webpack_require__(34);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _postsList = __webpack_require__(245);
	
	var _postsList2 = _interopRequireDefault(_postsList);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _partnersDisplay = __webpack_require__(244);
	
	var _partnersDisplay2 = _interopRequireDefault(_partnersDisplay);
	
	var _stagesTable = __webpack_require__(561);
	
	var _stagesTable2 = _interopRequireDefault(_stagesTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var displayNews = window.CARE_CONFIG.settings.display_news;
	var displayPartners = window.CARE_CONFIG.settings.display_partners;
	var multipleStages = window.CARE_CONFIG.settings.multiple_stage_display;
	
	var HomeContainer = function (_AppContainer) {
	    _inherits(HomeContainer, _AppContainer);
	
	    function HomeContainer() {
	        _classCallCheck(this, HomeContainer);
	
	        return _possibleConstructorReturn(this, (HomeContainer.__proto__ || Object.getPrototypeOf(HomeContainer)).apply(this, arguments));
	    }
	
	    _createClass(HomeContainer, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (displayPartners) {
	                this.props.actions.fetchAllPartners();
	            }
	            this.props.actions.fetchUpcomingStage();
	            this.props.actions.fetchRegistratioToAll();
	            this.props.actions.fetchRegistratioToCustom();
	
	            if (displayNews) {
	                this.props.actions.fetchPostsPaginated(0, 5);
	            }
	        }
	    }, {
	        key: 'renderStageActions',
	        value: function renderStageActions(stage) {
	            if (stage.external_website_registration) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'actions-row' },
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-main-color',
	                            href: stage.external_registration_link },
	                        _strings2.default.register
	                    ),
	                    stage.live_results ? _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-main-color',
	                            href: stage.live_results },
	                        _strings2.default.liveResults
	                    ) : null,
	                    _react2.default.createElement(
	                        'a',
	                        { className: 'btn btn-main-color',
	                            href: stage.external_regulations_link },
	                        _strings2.default.regulations
	                    )
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'actions-row' },
	                stage.registration_enabled ? _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'btn btn-main-color', to: '/stages/' + stage.id + '/registration' },
	                    _strings2.default.register
	                ) : null,
	                stage.live_results ? _react2.default.createElement(
	                    'a',
	                    { className: 'btn btn-main-color',
	                        href: stage.live_results },
	                    _strings2.default.liveResults
	                ) : null,
	                _react2.default.createElement(
	                    _reactRouter.Link,
	                    { className: 'btn btn-main-color', to: '/stages/' + stage.id + '/regulations' },
	                    _strings2.default.regulations
	                )
	            );
	        }
	    }, {
	        key: 'renderRegisterToAll',
	        value: function renderRegisterToAll() {
	            if (this.props.registerToAllStages && this.props.registerToAllStages.id) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'actions-row' },
	                    _react2.default.createElement(
	                        _reactRouter.Link,
	                        { className: 'btn btn-main-color',
	                            to: '/stages/' + this.props.registerToAllStages.id + '/registration' },
	                        _strings2.default.registerToAllStages
	                    )
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'renderRegisterToCustom',
	        value: function renderRegisterToCustom() {
	            if (this.props.registerToCustomStages && this.props.registerToCustomStages.stages && this.props.registerToCustomStages.stages.length) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'actions-row' },
	                    this.props.registerToCustomStages.stages.map(function (stage) {
	                        return _react2.default.createElement(
	                            _reactRouter.Link,
	                            { className: 'btn btn-main-color',
	                                to: '/stages/' + stage.id + '/registration', key: stage.id },
	                            stage.name
	                        );
	                    })
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'renderStageInfo',
	        value: function renderStageInfo(stage) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'stage' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'time-display' },
	                    (0, _moment2.default)(stage.stage_date).format('YYYY-MM-DD')
	                ),
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'title' },
	                    stage.name
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'time-left' },
	                    _react2.default.createElement(_timeTicker2.default, { date: new Date(stage.stage_date) })
	                ),
	                this.renderStageActions(stage)
	            );
	        }
	    }, {
	        key: 'renderStageWithActions',
	        value: function renderStageWithActions(stage) {
	            if (!stage || Object.keys(stage).length === 0) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'welcome-text' },
	                    _react2.default.createElement(
	                        'h2',
	                        { className: 'title' },
	                        _strings2.default.noUpcommingStages
	                    ),
	                    this.renderRegisterToAll(),
	                    this.renderRegisterToCustom()
	                );
	            }
	            return _react2.default.createElement(
	                'div',
	                { className: 'welcome-text' },
	                this.renderStageInfo(stage),
	                this.renderRegisterToAll(),
	                this.renderRegisterToCustom()
	            );
	        }
	    }, {
	        key: 'hasManyStages',
	        value: function hasManyStages() {
	            var upcomingStage = this.props.upcomingStage;
	
	            if (upcomingStage.loading || !upcomingStage.item.stages) {
	                return false;
	            }
	            if (multipleStages && upcomingStage.item.stages.length > 2) {
	                return true;
	            }
	            return false;
	        }
	    }, {
	        key: 'renderStages',
	        value: function renderStages() {
	            var _this2 = this;
	
	            var upcomingStage = this.props.upcomingStage;
	
	            if (upcomingStage.loading || !upcomingStage.item.stages) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'welcome-text' },
	                    _react2.default.createElement(_loading2.default, null)
	                );
	            }
	
	            var upcommingStage = upcomingStage.item.stages.length ? upcomingStage.item.stages[0] : null;
	            if (!multipleStages) {
	                return this.renderStageWithActions(upcommingStage);
	            }
	
	            if (upcomingStage.item.stages.length > 2) {
	                return _react2.default.createElement(
	                    'div',
	                    { className: 'stages-table' },
	                    _react2.default.createElement(_stagesTable2.default, { stages: {
	                            items: upcomingStage.item.stages, loading: false
	                        } })
	                );
	            } else return _react2.default.createElement(
	                'div',
	                { className: 'multiple-stages' },
	                upcomingStage.item.stages.map(function (stage) {
	                    return _this2.renderStageInfo(stage);
	                })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle() },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'home' },
	                    _react2.default.createElement(
	                        'div',
	                        { id: 'welcome-page', className: 'welcome-page' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: (0, _classnames2.default)('welcome-images', this.hasManyStages() && 'with-many-stages') },
	                            _react2.default.createElement(_imageSwitcher2.default, { images: window.CARE_CONFIG.landingImages })
	                        ),
	                        this.renderStages()
	                    ),
	                    displayNews && _react2.default.createElement(
	                        'div',
	                        { id: 'about', className: 'page-section' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'title' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _strings2.default.news
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                null,
	                                this.props.posts.loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_postsList2.default, { posts: this.props.posts.items })
	                            )
	                        )
	                    ),
	                    displayPartners && _react2.default.createElement(
	                        'div',
	                        { className: 'page-section grey' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'h3',
	                                { className: 'title' },
	                                _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    _strings2.default.partners
	                                )
	                            ),
	                            this.props.partners.loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_partnersDisplay2.default, { partners: this.props.partners.items })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HomeContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return {
	        partners: state.partner.partners,
	        posts: state.post.posts,
	        upcomingStage: state.stage.upcomingStage,
	        registerToAllStages: state.stage.registerToAllStages.item || null,
	        registerToCustomStages: state.stage.registerToCustomStages.item || null
	    };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, partnerActions, postActions, stageActions), dispatch)
	    };
	})(HomeContainer);

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AboutPageContainer = function (_AppContainer) {
	    _inherits(AboutPageContainer, _AppContainer);
	
	    function AboutPageContainer() {
	        _classCallCheck(this, AboutPageContainer);
	
	        return _possibleConstructorReturn(this, (AboutPageContainer.__proto__ || Object.getPrototypeOf(AboutPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(AboutPageContainer, [{
	        key: 'getContent',
	        value: function getContent() {
	            return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.about_text_en : window.CARE_CONFIG.settings.about_text;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.about) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.about
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'post-body', dangerouslySetInnerHTML: {
	                                __html: this.getContent()
	                            } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AboutPageContainer;
	}(_appContainer2.default);
	
	exports.default = AboutPageContainer;

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchivePageContainer = function (_AppContainer) {
	    _inherits(ArchivePageContainer, _AppContainer);
	
	    function ArchivePageContainer() {
	        _classCallCheck(this, ArchivePageContainer);
	
	        return _possibleConstructorReturn(this, (ArchivePageContainer.__proto__ || Object.getPrototypeOf(ArchivePageContainer)).apply(this, arguments));
	    }
	
	    _createClass(ArchivePageContainer, [{
	        key: 'getContent',
	        value: function getContent() {
	            return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.archive_text_en : window.CARE_CONFIG.settings.archive_text;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.archive) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.archive
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'post-body', dangerouslySetInnerHTML: {
	                                __html: this.getContent()
	                            } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ArchivePageContainer;
	}(_appContainer2.default);
	
	exports.default = ArchivePageContainer;

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactsPageContainer = function (_AppContainer) {
	    _inherits(ContactsPageContainer, _AppContainer);
	
	    function ContactsPageContainer() {
	        _classCallCheck(this, ContactsPageContainer);
	
	        return _possibleConstructorReturn(this, (ContactsPageContainer.__proto__ || Object.getPrototypeOf(ContactsPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(ContactsPageContainer, [{
	        key: 'getContent',
	        value: function getContent() {
	            return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.contacts_text_en : window.CARE_CONFIG.settings.contacts_text;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.contacts) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.contacts
	                            )
	                        ),
	                        _react2.default.createElement('div', { className: 'post-body', dangerouslySetInnerHTML: {
	                                __html: this.getContent()
	                            } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ContactsPageContainer;
	}(_appContainer2.default);
	
	exports.default = ContactsPageContainer;

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GdprPageContainer = function (_AppContainer) {
	    _inherits(GdprPageContainer, _AppContainer);
	
	    function GdprPageContainer() {
	        _classCallCheck(this, GdprPageContainer);
	
	        return _possibleConstructorReturn(this, (GdprPageContainer.__proto__ || Object.getPrototypeOf(GdprPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(GdprPageContainer, [{
	        key: 'renderGdprContent',
	        value: function renderGdprContent() {
	            if ((0, _languageCookie.isEnglish)()) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Why we need your personal data?'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' To be able to send you a confirmation email after registration.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' To be able to send you an email which would remind about the upcoming event you had registered to.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' To be able to see your payment status (either paid or not) in our system. This information will also be publicly shown on page \u201CStages\u201D in Participants table.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' To be able to show your results in addition with other participants on the page \u201CResults\u201D. We also see all participants and their results in our system.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' For you to be able to find all your results from our organized events that you participated in. It will be shown on page \u201CParticipant results\u201D.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' Also, we are using cookies to see where our page visitors came from and to see statistics of the page. IP address is used to find out the geolocation of a visitor and cookies are used for frequency of visits. We use Google Analytics which is GDPR compliant (',
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        href: 'https://support.google.com/analytics/answer/6004245?hl=en&authuser=0' },
	                                    'https://support.google.com/analytics/answer/6004245?hl=en&authuser=0'
	                                ),
	                                ').'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'What data we are collecting and how are we handling it?'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Your full name, gender, birth date, email, phone, country and city you live in and the club you belong to (if it is such a case). We use cookies which collect your IP address and by that we can see the frequency of your visits to this site.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'We store and secure your data for an unlimited time period. The data is used only by the organizer of the event (unless stated differently in Regulations) and can only be transferred if the law requires it.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'We do not use your personal data for direct marketing unless you ticked that you agree to get marketing emails when registering.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'According to GDPR (General Data Protection Regulation) you have these four rights:'
	                        ),
	                        _react2.default.createElement(
	                            'ol',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' To object our legitimate interest to have your data. After your objection we will mark in our system to not contact you again.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'To be forgotten. That means, you can ask us to delete all your data from our system. Also, you can ask to fix your data if it is not up to date anymore.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'To get a copy of data we have about you.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'To ask that we would make you anonymous. This means you won\u2019t be shown publicly between participants or in results.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'If you have any questions about your personal data or you want to use any of your rights, please contact ',
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: 'mailto:info@eventomanija.lt' },
	                            'info@eventomanija.lt'
	                        ),
	                        '. We will answer your question or request within 30 days.'
	                    )
	                );
	            } else {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Kod\u0117l mums reikalingi J\u016Bs\u0173 asmens duomenys:'
	                        ),
	                        _react2.default.createElement(
	                            'ul',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Mes atsi\u0173sime Jums registracijos patvirtinimo lai\u0161k\u0105.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Mes atsi\u0173sime Jums priminim\u0105 apie rengin\u012F, \u012F kur\u012F u\u017Esiregistravote, lai\u0161k\u0105.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Savo sistemoje matysime, ar apmok\u0117jote u\u017E rengin\u012F. \u0160i informacija su J\u016Bs\u0173 pateiktais asmens duomenimis taip pat bus matoma m\u016Bs\u0173 puslapyje Etap\u0173 skiltyje \u201CDalyviai\u201D.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Gal\u0117sime parodyti J\u016Bs\u0173 rezultatus bendroje dalyvi\u0173 rezultat\u0173 lentel\u0117je (Skiltis \u201CRezultatai\u201D).'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'J\u016Bs gal\u0117site susirasti savo rezultatus i\u0161 vis\u0173 m\u016Bs\u0173 rengt\u0173 rengini\u0173 skiltyje \u201CDalyvio rezultat\u0173 istorija\u201D.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Naudodami slapukus mes gal\u0117sime atpa\u017Einti J\u016Bs\u0173 IP adres\u0105 ir nustatyti lankomum\u0105 puslapyje. IP adresas yra naudojamas norint su\u017Einoti svetain\u0117s lankytoj\u0173 geografines vietas, o lankomumas naudojamas puslapio statistikai. Taip pat, mes naudojam\u0117s Google Analytics. Apie j\u0173 duomen\u0173 apsaug\u0105 galite pasiskaityti \u010Dia (',
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://support.google.com/analytics/answer/6004245?hl=en&authuser=0' },
	                                    'https://support.google.com/analytics/answer/6004245?hl=en&authuser=0'
	                                ),
	                                ').'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Kokius duomenis mes renkame ir kaip juos tvarkome?'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Registruodamiesi J\u016Bs pateikiate savo vard\u0105, pavard\u0119, lyt\u012F, gimimo dat\u0105, el. pa\u0161to adres\u0105, telefono numer\u012F. Taip pat, nurodote savo telefono numer\u012F, \u0161al\u012F ir miest\u0105, kuriame gyvenate bei klub\u0105, kuriam priklausote (jei priklausote ir norite tai nurodyti). Savo svetain\u0117je mes naudojame slapukus, kurie atpa\u017E\u012Fsta vartotoj\u0173 IP adresus.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'J\u016Bs\u0173 asmens duomenys yra saugomi m\u016Bs\u0173 serveryje neribot\u0105 laik\u0105. Surinkti duomenys yra naudojami tik renginio organizatoriaus (nebent nuostatuose nurodyta kitaip) ir niekam neperleid\u017Eiami, nebent to reikalauja teismas.'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Tikslin\u0117s rinkodaros tikslais J\u016Bs\u0173 duomen\u0173 nenaudojame, nebent registruodamiesi varnele pa\u017Eym\u0117jote, kad sutinkate gauti reklaminius prane\u0161imus.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'Pagal Bendr\u0105j\u012F Duomen\u0173 Apsaugos Reglament\u0105, J\u016Bs turite \u0161ias keturias teises:'
	                        ),
	                        _react2.default.createElement(
	                            'ol',
	                            null,
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                ' Prie\u0161tarauti m\u016Bs\u0173 teisei laikyti ir naudoti J\u016Bs\u0173 asmens duomenis tam, kad si\u0173stume patvirtinimo ir priminimo lai\u0161kus. Po J\u016Bs\u0173 prie\u0161taravimo mes i\u0161 karto pa\u017Eym\u0117sime savo duombaz\u0117je, kad daugiau su Jumis nekontaktuotume.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Papra\u0161yti duomen\u0173, kuriuos turime surink\u0119 apie Jus, kopijos.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Papra\u0161yti vis\u0173 J\u016Bs\u0173 duomen\u0173 i\u0161trynimo i\u0161 m\u016Bs\u0173 sistemos arba pataisymo.'
	                            ),
	                            _react2.default.createElement(
	                                'li',
	                                null,
	                                'Papra\u0161yti nuasmenininti J\u016Bs\u0173 norimus duomenis. Tai rei\u0161kia, kad J\u016Bs\u0173 duomenys (vardas, pavard\u0117, t.t.) bus nerodomi vie\u0161ai m\u016Bs\u0173 puslapyje.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'D\u0117l klausim\u0173 susijusi\u0173 su J\u016Bs\u0173 duomen\u0173 apsauga kreipkit\u0117s el. pa\u0161tu: ',
	                        _react2.default.createElement(
	                            'a',
	                            {
	                                href: 'mailto:info@eventomanija.lt' },
	                            'info@eventomanija.lt'
	                        ),
	                        '. Atsakymus \u012F klausimus pateiksime ne v\u0117liau kaip per 30 dien\u0173.'
	                    )
	                );
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.gdprPageTitle) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.gdprPageTitle
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'post-body' },
	                            this.renderGdprContent()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GdprPageContainer;
	}(_appContainer2.default);
	
	exports.default = GdprPageContainer;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var InsurancePageContainer = function (_AppContainer) {
	    _inherits(InsurancePageContainer, _AppContainer);
	
	    function InsurancePageContainer() {
	        _classCallCheck(this, InsurancePageContainer);
	
	        return _possibleConstructorReturn(this, (InsurancePageContainer.__proto__ || Object.getPrototypeOf(InsurancePageContainer)).apply(this, arguments));
	    }
	
	    _createClass(InsurancePageContainer, [{
	        key: 'getContent',
	        value: function getContent() {
	            return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.insurance_text_en : window.CARE_CONFIG.settings.insurance_text;
	        }
	    }, {
	        key: 'getTitle',
	        value: function getTitle() {
	            return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.insurance_text_label_en : window.CARE_CONFIG.settings.insurance_text_label;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(this.getTitle()) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement('span', { dangerouslySetInnerHTML: {
	                                    __html: this.getTitle()
	                                } })
	                        ),
	                        _react2.default.createElement('div', { className: 'post-body', dangerouslySetInnerHTML: {
	                                __html: this.getContent()
	                            } })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return InsurancePageContainer;
	}(_appContainer2.default);
	
	exports.default = InsurancePageContainer;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _page = __webpack_require__(162);
	
	var pageActions = _interopRequireWildcard(_page);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _htmlRenderer = __webpack_require__(126);
	
	var _htmlRenderer2 = _interopRequireDefault(_htmlRenderer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageRegistrationPageContainer = function (_AppContainer) {
	    _inherits(StageRegistrationPageContainer, _AppContainer);
	
	    function StageRegistrationPageContainer() {
	        _classCallCheck(this, StageRegistrationPageContainer);
	
	        return _possibleConstructorReturn(this, (StageRegistrationPageContainer.__proto__ || Object.getPrototypeOf(StageRegistrationPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StageRegistrationPageContainer, [{
	        key: 'isEnglish',
	        value: function isEnglish() {
	            return this.props.params.slug === this.props.page.item.slug_en;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchPageBySlug(this.props.params.slug).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'renderBody',
	        value: function renderBody(page) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'title' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        this.isEnglish() ? page.title_en : page.title_lt
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'post-body-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'post-body' },
	                        _react2.default.createElement(_htmlRenderer2.default, { html: this.isEnglish() ? page.body_en : page.body_lt })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var page = this.props.page;
	
	            var postTitle = page.item ? this.isEnglish() ? page.item.title_en : page.item.title_lt : '';
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(postTitle) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    page.loading ? _react2.default.createElement(_loading2.default, null) : this.renderBody(page.item)
	                )
	            );
	        }
	    }]);
	
	    return StageRegistrationPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { page: state.page.page };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, pageActions), dispatch)
	    };
	})(StageRegistrationPageContainer);

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _url = __webpack_require__(128);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageRegistrationPageContainer = function (_AppContainer) {
	    _inherits(StageRegistrationPageContainer, _AppContainer);
	
	    function StageRegistrationPageContainer() {
	        _classCallCheck(this, StageRegistrationPageContainer);
	
	        return _possibleConstructorReturn(this, (StageRegistrationPageContainer.__proto__ || Object.getPrototypeOf(StageRegistrationPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StageRegistrationPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchParticipantByUuid(this.props.params.itemUuid).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'renderPayText',
	        value: function renderPayText() {
	            var participant = this.props.participant;
	
	            if (participant.payment.payed) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.registeredSuccessfullyAndGotPayment
	                );
	            } else {
	                if (!participant.can_pay) {
	                    return null;
	                }
	            }
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.registeredSuccessfullyAndNeedToPay,
	                    participant.payment.price,
	                    'EUR.'
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { href: (0, _url.paymentUrl)(participant.uuid), className: 'btn btn-main-color mt-20' },
	                    _strings2.default.pay,
	                    ' ',
	                    participant.payment.price,
	                    'EUR'
	                )
	            );
	        }
	    }, {
	        key: 'renderFreeText',
	        value: function renderFreeText() {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _strings2.default.registeredSuccessfully
	            );
	        }
	    }, {
	        key: 'renderParticipantInfo',
	        value: function renderParticipantInfo() {
	            var participant = this.props.participant;
	
	            return _react2.default.createElement(
	                'table',
	                { className: 'table', style: {
	                        marginTop: '20px'
	                    } },
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'first-uppercase' },
	                            _strings2.default.participant
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            participant.displayName
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'td',
	                            { className: 'first-uppercase' },
	                            _strings2.default.distance
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            participant.distance ? participant.distance.name : ''
	                        )
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                participant = _props.participant,
	                loading = _props.loading;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.registeredSuccessfully) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.registeredSuccessfully
	                            )
	                        ),
	                        loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(
	                            'div',
	                            null,
	                            participant.payment && participant.payment.price > 0 ? this.renderPayText() : this.renderFreeText(),
	                            this.renderParticipantInfo()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StageRegistrationPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { participant: state.participant.participant, loading: state.participant.loading };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(StageRegistrationPageContainer);

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _participantResultHistoryForm = __webpack_require__(243);
	
	var _participantResultHistoryForm2 = _interopRequireDefault(_participantResultHistoryForm);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _participantResultsDisplay = __webpack_require__(166);
	
	var _participantResultsDisplay2 = _interopRequireDefault(_participantResultsDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParticipantResultsContainer = function (_AppContainer) {
	    _inherits(ParticipantResultsContainer, _AppContainer);
	
	    function ParticipantResultsContainer(props) {
	        _classCallCheck(this, ParticipantResultsContainer);
	
	        var _this = _possibleConstructorReturn(this, (ParticipantResultsContainer.__proto__ || Object.getPrototypeOf(ParticipantResultsContainer)).call(this, props));
	
	        _this.state = {
	            searchParams: null
	        };
	        return _this;
	    }
	
	    _createClass(ParticipantResultsContainer, [{
	        key: 'executeSearch',
	        value: function executeSearch(params) {
	            this.setState({
	                searchParams: params
	            });
	            return this.props.actions.submitParticipantResultsSearch(params);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var participant_results = this.props.participant_results;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.participantResultsHistory) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.participantResultsHistory
	                            )
	                        ),
	                        _react2.default.createElement(_participantResultHistoryForm2.default, { submit: this.executeSearch.bind(this) }),
	                        this.props.participant_results.loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(_participantResultsDisplay2.default, { items: participant_results.items,
	                            searchParams: this.state.searchParams })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ParticipantResultsContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { participant_results: state.participant.participant_results };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(ParticipantResultsContainer);

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _participantResultsDisplay = __webpack_require__(166);
	
	var _participantResultsDisplay2 = _interopRequireDefault(_participantResultsDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ParticipantResultsContainer = function (_AppContainer) {
	    _inherits(ParticipantResultsContainer, _AppContainer);
	
	    function ParticipantResultsContainer() {
	        _classCallCheck(this, ParticipantResultsContainer);
	
	        return _possibleConstructorReturn(this, (ParticipantResultsContainer.__proto__ || Object.getPrototypeOf(ParticipantResultsContainer)).apply(this, arguments));
	    }
	
	    _createClass(ParticipantResultsContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchParticipantResultV2(this.props.params.resultId).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var results = this.props.results;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.participantResultsHistory) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    results.loading || !results.item.participant ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            results.item.participant.first_name,
	                            ' ',
	                            results.item.participant.last_name
	                        ),
	                        _react2.default.createElement(_participantResultsDisplay2.default, { items: results.item.results })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ParticipantResultsContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { results: state.participant.participantV2 };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, participantActions), dispatch)
	    };
	})(ParticipantResultsContainer);

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _partners = __webpack_require__(122);
	
	var partnerActions = _interopRequireWildcard(_partners);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _partnersDisplay = __webpack_require__(244);
	
	var _partnersDisplay2 = _interopRequireDefault(_partnersDisplay);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeContainer = function (_AppContainer) {
	    _inherits(HomeContainer, _AppContainer);
	
	    function HomeContainer() {
	        _classCallCheck(this, HomeContainer);
	
	        return _possibleConstructorReturn(this, (HomeContainer.__proto__ || Object.getPrototypeOf(HomeContainer)).apply(this, arguments));
	    }
	
	    _createClass(HomeContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchAllPartners();
	        }
	    }, {
	        key: 'renderPartners',
	        value: function renderPartners() {
	
	            return _react2.default.createElement(_partnersDisplay2.default, { partners: this.props.partners.items });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.partners) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.partners
	                            )
	                        ),
	                        this.props.partners.loading ? _react2.default.createElement(_loading2.default, null) : this.renderPartners()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HomeContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { partners: state.partner.partners };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, partnerActions), dispatch)
	    };
	})(HomeContainer);

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesPageContainer = function (_AppContainer) {
	    _inherits(StagesPageContainer, _AppContainer);
	
	    function StagesPageContainer() {
	        _classCallCheck(this, StagesPageContainer);
	
	        return _possibleConstructorReturn(this, (StagesPageContainer.__proto__ || Object.getPrototypeOf(StagesPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StagesPageContainer, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.paymentCanceled) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.paymentCanceled
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _strings2.default.paymentCanceledText
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StagesPageContainer;
	}(_appContainer2.default);
	
	exports.default = StagesPageContainer;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _post = __webpack_require__(106);
	
	var postActions = _interopRequireWildcard(_post);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _internalImageV = __webpack_require__(107);
	
	var _internalImageV2 = _interopRequireDefault(_internalImageV);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _htmlRenderer = __webpack_require__(126);
	
	var _htmlRenderer2 = _interopRequireDefault(_htmlRenderer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageRegistrationPageContainer = function (_AppContainer) {
	    _inherits(StageRegistrationPageContainer, _AppContainer);
	
	    function StageRegistrationPageContainer() {
	        _classCallCheck(this, StageRegistrationPageContainer);
	
	        return _possibleConstructorReturn(this, (StageRegistrationPageContainer.__proto__ || Object.getPrototypeOf(StageRegistrationPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StageRegistrationPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchPostBySlug(this.props.params.slug).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'renderBody',
	        value: function renderBody(post) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'h1',
	                    { className: 'title' },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        post.title
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'post-body-container' },
	                    post.image && _react2.default.createElement(_internalImageV2.default, { filename: post.image.filename, alt: post.title }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'post-body' },
	                        _react2.default.createElement(_htmlRenderer2.default, { html: post.body })
	                    )
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var post = this.props.post;
	
	            var postTitle = post.item ? post.item.title : '';
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(postTitle) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    post.loading ? _react2.default.createElement(_loading2.default, null) : this.renderBody(post.item)
	                )
	            );
	        }
	    }]);
	
	    return StageRegistrationPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { post: state.post.post };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, postActions), dispatch)
	    };
	})(StageRegistrationPageContainer);

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _post = __webpack_require__(106);
	
	var postActions = _interopRequireWildcard(_post);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _postsList = __webpack_require__(245);
	
	var _postsList2 = _interopRequireDefault(_postsList);
	
	var _paginator = __webpack_require__(241);
	
	var _paginator2 = _interopRequireDefault(_paginator);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostsPageContainer = function (_AppContainer) {
	    _inherits(PostsPageContainer, _AppContainer);
	
	    function PostsPageContainer() {
	        _classCallCheck(this, PostsPageContainer);
	
	        return _possibleConstructorReturn(this, (PostsPageContainer.__proto__ || Object.getPrototypeOf(PostsPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(PostsPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            var page = 0;
	            if (this.props.params.page) {
	                page = this.props.params.page;
	            }
	            this.props.actions.fetchPostsPaginated(page, 10);
	        }
	    }, {
	        key: 'loadItems',
	        value: function loadItems(props) {
	            var page = 0;
	            if (props.params.page) {
	                page = props.params.page;
	            }
	            this.props.actions.fetchPostsPaginated(page, 10);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if (nextProps.params.page !== this.props.params.page) {
	                this.loadItems(nextProps);
	            }
	        }
	    }, {
	        key: 'renderPosts',
	        value: function renderPosts(posts) {
	            return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(_postsList2.default, { posts: posts.items }),
	                _react2.default.createElement(_paginator2.default, { totalPages: posts.total_pages, currentPage: posts.page, baseUrl: '/posts' })
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var posts = this.props.posts;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.news) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.news
	                            )
	                        ),
	                        posts.loading ? _react2.default.createElement(_loading2.default, null) : this.renderPosts(posts)
	                    )
	                )
	            );
	        }
	    }]);
	
	    return PostsPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { posts: state.post.posts };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, postActions), dispatch)
	    };
	})(PostsPageContainer);

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	var _htmlRenderer = __webpack_require__(126);
	
	var _htmlRenderer2 = _interopRequireDefault(_htmlRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RegulationsPageContainer = function (_AppContainer) {
	    _inherits(RegulationsPageContainer, _AppContainer);
	
	    function RegulationsPageContainer() {
	        _classCallCheck(this, RegulationsPageContainer);
	
	        return _possibleConstructorReturn(this, (RegulationsPageContainer.__proto__ || Object.getPrototypeOf(RegulationsPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(RegulationsPageContainer, [{
	        key: 'getContent',
	        value: function getContent() {
	            return (0, _languageCookie.isEnglish)() ? window.CARE_CONFIG.settings.regulations_en : window.CARE_CONFIG.settings.regulations;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.regulations) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.regulations
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'post-body' },
	                            _react2.default.createElement(_htmlRenderer2.default, { html: this.getContent() })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return RegulationsPageContainer;
	}(_appContainer2.default);
	
	exports.default = RegulationsPageContainer;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _result = __webpack_require__(534);
	
	var resultActions = _interopRequireWildcard(_result);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(14);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResultsPageContainer = function (_AppContainer) {
	    _inherits(ResultsPageContainer, _AppContainer);
	
	    function ResultsPageContainer() {
	        _classCallCheck(this, ResultsPageContainer);
	
	        return _possibleConstructorReturn(this, (ResultsPageContainer.__proto__ || Object.getPrototypeOf(ResultsPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(ResultsPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchResults().then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'groupItems',
	        value: function groupItems() {
	
	            var grouped = {};
	
	            // Group by season.id
	            this.props.results.items.forEach(function (stage) {
	                var seasonId = stage.season.id;
	                if (!grouped[seasonId]) {
	                    grouped[seasonId] = {
	                        season: stage.season,
	                        stages: []
	                    };
	                }
	                grouped[seasonId].stages.push(stage);
	            });
	
	            return Object.values(grouped).sort(function (a, b) {
	                return b.season.order - a.season.order;
	            });
	        }
	    }, {
	        key: 'renderSeasonGroupedResults',
	        value: function renderSeasonGroupedResults(items) {
	            var stages = [];
	            items.forEach(function (stage) {
	                if (stage.global_results_stage) {
	                    stages.push(stage);
	                }
	            });
	            if (!stages.length) {
	                return;
	            }
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'global-results-box' },
	                _react2.default.createElement(
	                    'span',
	                    { className: 'bold mt-10 mr-10' },
	                    _strings2.default.globalResults,
	                    ':'
	                ),
	                stages.map(function (stage) {
	                    return _react2.default.createElement(
	                        _reactRouter.Link,
	                        { to: '/stages/' + stage.id + '/results',
	                            className: 'btn btn-main-color inline first-uppercase mt-10', key: 'stage-' + stage.id },
	                        stage.name
	                    );
	                })
	            );
	        }
	    }, {
	        key: 'renderTableResults',
	        value: function renderTableResults(items) {
	            return _react2.default.createElement(
	                'table',
	                { className: 'table responsive', key: 'table-' + new Date().getTime() },
	                _react2.default.createElement(
	                    'thead',
	                    null,
	                    _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _strings2.default.stage
	                        ),
	                        _react2.default.createElement(
	                            'th',
	                            null,
	                            _strings2.default.date
	                        ),
	                        _react2.default.createElement('th', null)
	                    )
	                ),
	                _react2.default.createElement(
	                    'tbody',
	                    null,
	                    items.filter(function (stage) {
	                        return !stage.global_results_stage;
	                    }).map(function (stage) {
	                        return _react2.default.createElement(
	                            'tr',
	                            { key: 'stage-' + stage.id },
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                stage.name
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                (0, _moment2.default)(stage.stage_date).format('YYYY-MM-DD HH:mm')
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    _reactRouter.Link,
	                                    { to: '/stages/' + stage.id + '/results',
	                                        className: 'btn btn-main-color inline first-uppercase' },
	                                    _strings2.default.results
	                                )
	                            )
	                        );
	                    })
	                )
	            );
	        }
	    }, {
	        key: 'renderResults',
	        value: function renderResults() {
	            var _this2 = this;
	
	            var results = this.props.results;
	
	            var groupedResults = this.groupItems();
	            if (!results.items.length) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.noResults
	                );
	            }
	            return Object.keys(groupedResults).map(function (key) {
	                var record = groupedResults[key];
	                return _react2.default.createElement(
	                    'div',
	                    { key: key },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'season-result-title' },
	                        record.season.name
	                    ),
	                    _this2.renderSeasonGroupedResults(record.stages),
	                    _this2.renderTableResults(record.stages)
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var results = this.props.results;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.results) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.results
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: '' },
	                            results.loading ? _react2.default.createElement(_loading2.default, null) : this.renderResults()
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ResultsPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { results: state.results.results };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, resultActions), dispatch)
	    };
	})(ResultsPageContainer);

/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _stagesPageContainer = __webpack_require__(249);
	
	var _stagesPageContainer2 = _interopRequireDefault(_stagesPageContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesBasePageContainer = function (_StagesPageContainer) {
	    _inherits(StagesBasePageContainer, _StagesPageContainer);
	
	    function StagesBasePageContainer() {
	        _classCallCheck(this, StagesBasePageContainer);
	
	        return _possibleConstructorReturn(this, (StagesBasePageContainer.__proto__ || Object.getPrototypeOf(StagesBasePageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StagesBasePageContainer, [{
	        key: 'getSeasonId',
	        value: function getSeasonId() {
	            return this.props.params.seasonId;
	        }
	    }]);
	
	    return StagesBasePageContainer;
	}(_stagesPageContainer2.default);
	
	exports.default = StagesBasePageContainer;

/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	var _distanceFilter = __webpack_require__(539);
	
	var _distanceFilter2 = _interopRequireDefault(_distanceFilter);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _reactRouter = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageParticipantsPageContainer = function (_AppContainer) {
	    _inherits(StageParticipantsPageContainer, _AppContainer);
	
	    function StageParticipantsPageContainer(props) {
	        _classCallCheck(this, StageParticipantsPageContainer);
	
	        var _this = _possibleConstructorReturn(this, (StageParticipantsPageContainer.__proto__ || Object.getPrototypeOf(StageParticipantsPageContainer)).call(this, props));
	
	        _this.state = {
	            page: 0,
	            query: '',
	            distance: null
	        };
	        return _this;
	    }
	
	    _createClass(StageParticipantsPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
	            this.fetch({});
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            this.props.actions.fetchStageParticipants(this.props.params.itemId, fetchParams.page, fetchParams.size, {
	                query: fetchParams.query,
	                participantType: window.CARE_CONFIG.onlyPayedParticipants ? 'payed' : 'all',
	                distance: fetchParams.distance ? fetchParams.distance.value : ''
	            });
	        }
	    }, {
	        key: 'handleQueryChange',
	        value: function handleQueryChange(event) {
	            this.setState({ value: event.target.value, page: 0 });
	            this.fetch({ query: event.target.value, page: 0 });
	        }
	    }, {
	        key: 'onChangeDistance',
	        value: function onChangeDistance(distance) {
	            if (distance && !distance.value) {
	                distance = null;
	            }
	            this.fetch({ distance: distance, page: 0 });
	        }
	    }, {
	        key: 'onParticipantClick',
	        value: function onParticipantClick(item) {
	            _reactRouter.browserHistory.push('/participant/' + item.uuid);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var config = {
	                cols: [{
	                    value: 'displayName',
	                    header: _strings2.default.firstName + ' ' + _strings2.default.lastName
	                }, {
	                    value: function value(item) {
	                        return item.distance ? item.distance.name : '';
	                    },
	                    header: _strings2.default.distance
	                }, {
	                    value: function value(item) {
	                        if (item.payed) {
	                            return _strings2.default.yes;
	                        }
	                        return _strings2.default.no;
	                    },
	                    header: _strings2.default.payed
	                }, {
	                    value: 'club',
	                    header: _strings2.default.club
	
	                }, {
	                    value: 'city',
	                    header: _strings2.default.city
	                }]
	            };
	            var _props = this.props,
	                stage = _props.stage,
	                stageParticipants = _props.stageParticipants;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.participants) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                stage.item.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.participants
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'filters' },
	                            _react2.default.createElement(
	                                'form',
	                                null,
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inline-fields' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-row' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-field' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'field-control' },
	                                                _react2.default.createElement('input', { type: 'text', value: this.state.query, onChange: this.handleQueryChange.bind(this), placeholder: _strings2.default.search })
	                                            )
	                                        ),
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'form-field' },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'field-control' },
	                                                stage.loading ? null : _react2.default.createElement(_distanceFilter2.default, { distances: stage.item.distances, onChange: this.onChangeDistance.bind(this), value: this.state.distance })
	                                            )
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(_dataTable2.default, { config: config, loading: stageParticipants.loading, items: stageParticipants.items, page: stageParticipants.page, total: stageParticipants.total, totalPages: stageParticipants.total_pages, loadAction: this.fetch.bind(this), className: 'participants-table', responsive: false, clickable: this.onParticipantClick.bind(this) }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'strong m-top-10' },
	                            _strings2.default.totalParticipants,
	                            ': ',
	                            stageParticipants.total
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StageParticipantsPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stage: state.stage.stage, stageParticipants: state.stage.stageParticipants };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stageActions), dispatch)
	    };
	})(StageParticipantsPageContainer);

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _participant = __webpack_require__(70);
	
	var participantActions = _interopRequireWildcard(_participant);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _participantForm = __webpack_require__(242);
	
	var _participantForm2 = _interopRequireDefault(_participantForm);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _url = __webpack_require__(128);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StageRegistrationPageContainer = function (_AppContainer) {
	    _inherits(StageRegistrationPageContainer, _AppContainer);
	
	    function StageRegistrationPageContainer(props) {
	        _classCallCheck(this, StageRegistrationPageContainer);
	
	        var _this = _possibleConstructorReturn(this, (StageRegistrationPageContainer.__proto__ || Object.getPrototypeOf(StageRegistrationPageContainer)).call(this, props));
	
	        _this.state = {
	            done: false
	        };
	        return _this;
	    }
	
	    _createClass(StageRegistrationPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.initializeParticipantFormData({
	                stageId: parseInt(this.props.params.itemId, 10)
	            });
	            this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'onSuccessSubmit',
	        value: function onSuccessSubmit(wasNew, result) {
	            this.setState({
	                done: true
	            });
	            if (window.CARE_CONFIG.instantPayment && !result.payment.payed) {
	                window.location.replace('' + window.CARE_CONFIG.baseUrl + (0, _url.paymentUrl)(result.uuid));
	            } else {
	                _reactRouter.browserHistory.push('/participant/' + result.uuid);
	            }
	        }
	    }, {
	        key: 'renderForm',
	        value: function renderForm() {
	            var _props = this.props,
	                stage = _props.stage,
	                actions = _props.actions;
	
	
	            return stage.item.registration_enabled ? _react2.default.createElement(_participantForm2.default, { submit: actions.submitParticipant, onSuccessSubmit: this.onSuccessSubmit.bind(this), disableStageSelect: true, showAlert: false }) : _react2.default.createElement(
	                'h4',
	                null,
	                _strings2.default.registrationClosed
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stage = this.props.stage;
	
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.registration) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                stage.item.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.registration
	                            )
	                        ),
	                        stage.loading || this.state.done ? _react2.default.createElement(_loading2.default, null) : this.renderForm()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StageRegistrationPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stage: state.stage.stage, participant: state.participant.participant };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stageActions, participantActions), dispatch)
	    };
	})(StageRegistrationPageContainer);

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _languageCookie = __webpack_require__(43);
	
	var _htmlRenderer = __webpack_require__(126);
	
	var _htmlRenderer2 = _interopRequireDefault(_htmlRenderer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesPageContainer = function (_AppContainer) {
	    _inherits(StagesPageContainer, _AppContainer);
	
	    function StagesPageContainer() {
	        _classCallCheck(this, StagesPageContainer);
	
	        return _possibleConstructorReturn(this, (StagesPageContainer.__proto__ || Object.getPrototypeOf(StagesPageContainer)).apply(this, arguments));
	    }
	
	    _createClass(StagesPageContainer, [{
	        key: 'getRegulations',
	        value: function getRegulations(stage) {
	            return (0, _languageCookie.isEnglish)() ? stage.regulations_en : stage.regulations;
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stage = this.props.stage;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.stageRegulations) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                stage.item.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.stageRegulations
	                            )
	                        ),
	                        stage.loading ? _react2.default.createElement(_loading2.default, null) : _react2.default.createElement(
	                            'div',
	                            { className: 'post-body' },
	                            _react2.default.createElement(_htmlRenderer2.default, { html: this.getRegulations(stage.item) })
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StagesPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stage: state.stage.stage };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stageActions), dispatch)
	    };
	})(StagesPageContainer);

/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _stages = __webpack_require__(47);
	
	var stageActions = _interopRequireWildcard(_stages);
	
	var _reactRedux = __webpack_require__(6);
	
	var _redux = __webpack_require__(5);
	
	var _strings = __webpack_require__(4);
	
	var _strings2 = _interopRequireDefault(_strings);
	
	var _loading = __webpack_require__(12);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	var _reactDocumentTitle = __webpack_require__(19);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _select = __webpack_require__(56);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _dataTable = __webpack_require__(32);
	
	var _dataTable2 = _interopRequireDefault(_dataTable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StagesPageContainer = function (_AppContainer) {
	    _inherits(StagesPageContainer, _AppContainer);
	
	    function StagesPageContainer(props) {
	        _classCallCheck(this, StagesPageContainer);
	
	        var _this = _possibleConstructorReturn(this, (StagesPageContainer.__proto__ || Object.getPrototypeOf(StagesPageContainer)).call(this, props));
	
	        _this.state = {
	            page: 0,
	            query: '',
	            distance: null
	        };
	        return _this;
	    }
	
	    _createClass(StagesPageContainer, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            this.props.actions.fetchStage(this.props.params.itemId).then(this.handlePageResult.bind(this));
	        }
	    }, {
	        key: 'fetch',
	        value: function fetch(params) {
	            var fetchParams = _extends({}, this.state, params);
	            this.setState(fetchParams);
	            if (fetchParams.distance) {
	                this.props.actions.fetchStageResults(this.props.params.itemId, fetchParams.page, fetchParams.size, {
	                    query: fetchParams.query,
	                    distance: fetchParams.distance.value
	                });
	            }
	        }
	    }, {
	        key: 'onDistanceChange',
	        value: function onDistanceChange(value) {
	            this.fetch({ distance: value, page: 0 });
	        }
	    }, {
	        key: 'handleQueryChange',
	        value: function handleQueryChange(event) {
	            this.fetch({ query: event.target.value, page: 0 });
	        }
	    }, {
	        key: 'renderContent',
	        value: function renderContent() {
	            if (!this.state.distance) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.selectDistance
	                );
	            }
	            var stageResults = this.props.stageResults;
	
	            if (!this.props.stageResults.items.length) {
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _strings2.default.noResults
	                );
	            } else {
	                var config = {
	                    cols: []
	                };
	                var firstItem = this.props.stageResults.items[0];
	                config.cols.push({
	                    header: '',
	                    value: function value(item) {
	                        return _react2.default.createElement(
	                            'a',
	                            { href: '/participant-results/' + item.id },
	                            item.first_name,
	                            ' ',
	                            item.last_name
	                        );
	                    }
	                });
	                firstItem.titles.slice(3).forEach(function (col, index) {
	                    config.cols.push({
	                        value: function value(item) {
	                            return item.row[index + 3];
	                        },
	                        header: col
	                    });
	                });
	                if (this.props.stage.item.generate_diploma) {
	                    config.cols.push({
	                        header: '',
	                        value: function value(item) {
	                            return _react2.default.createElement(
	                                'a',
	                                { className: 'btn btn-main-color inline ', target: '_blank',
	                                    href: '/api/participant-file/' + item.id },
	                                _strings2.default.diploma
	                            );
	                        }
	                    });
	                }
	                return _react2.default.createElement(_dataTable2.default, { config: config, loading: stageResults.loading, items: stageResults.items,
	                    page: stageResults.page, total: stageResults.total, totalPages: stageResults.total_pages,
	                    loadAction: this.fetch.bind(this) });
	            }
	        }
	    }, {
	        key: 'renderResults',
	        value: function renderResults() {
	            var stage = this.props.stage.item;
	            if (stage.distances) {
	                var distances = stage.distances.sort(function (a, b) {
	                    if (a.order < b.order) {
	                        return -1;
	                    }
	                    if (a.order > b.order) {
	                        return 1;
	                    }
	                    return 0;
	                }).map(function (distance) {
	                    return { id: distance.code, name: distance.name };
	                });
	                return _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'filters' },
	                        _react2.default.createElement(
	                            'form',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'inline-fields' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'form-row' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-field' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'field-control' },
	                                            _react2.default.createElement(_select2.default, { clearable: false, options: distances,
	                                                noResultsText: _strings2.default.noDistances,
	                                                value: this.state.distance, placeholder: _strings2.default.distance,
	                                                onChange: this.onDistanceChange.bind(this) })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: 'form-field' },
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'field-control' },
	                                            _react2.default.createElement('input', { type: 'text', value: this.state.query,
	                                                onChange: this.handleQueryChange.bind(this),
	                                                placeholder: _strings2.default.search })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    ),
	                    this.renderContent()
	                );
	            }
	            return null;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var stage = this.props.stage;
	
	            return _react2.default.createElement(
	                _reactDocumentTitle2.default,
	                { title: this.getDocumentTitle(_strings2.default.stageResults) },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'page-section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container fluid' },
	                        _react2.default.createElement(
	                            'h1',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                stage.item.name
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h3',
	                            { className: 'title' },
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                _strings2.default.stageResults
	                            )
	                        ),
	                        stage.loading ? _react2.default.createElement(_loading2.default, null) : this.renderResults()
	                    )
	                )
	            );
	        }
	    }]);
	
	    return StagesPageContainer;
	}(_appContainer2.default);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	    return { stage: state.stage.stage, stageResults: state.stage.stageResults };
	}, function (dispatch) {
	    return {
	        actions: (0, _redux.bindActionCreators)(_extends({}, stageActions), dispatch)
	    };
	})(StagesPageContainer);

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactGa = __webpack_require__(1083);
	
	var _reactGa2 = _interopRequireDefault(_reactGa);
	
	var _reactFacebookPixel = __webpack_require__(1082);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _ravenJs = __webpack_require__(1023);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _reactDom = __webpack_require__(155);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRedux = __webpack_require__(6);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reactRouterRedux = __webpack_require__(225);
	
	var _store = __webpack_require__(641);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _appContainer = __webpack_require__(18);
	
	var _appContainer2 = _interopRequireDefault(_appContainer);
	
	var _homeContainer = __webpack_require__(596);
	
	var _homeContainer2 = _interopRequireDefault(_homeContainer);
	
	var _adminContainer = __webpack_require__(565);
	
	var _adminContainer2 = _interopRequireDefault(_adminContainer);
	
	var _loginContainer = __webpack_require__(572);
	
	var _loginContainer2 = _interopRequireDefault(_loginContainer);
	
	var _dashboardContainer = __webpack_require__(566);
	
	var _dashboardContainer2 = _interopRequireDefault(_dashboardContainer);
	
	var _usersContainer = __webpack_require__(595);
	
	var _usersContainer2 = _interopRequireDefault(_usersContainer);
	
	var _userContainer = __webpack_require__(594);
	
	var _userContainer2 = _interopRequireDefault(_userContainer);
	
	var _seasonsContainer = __webpack_require__(588);
	
	var _seasonsContainer2 = _interopRequireDefault(_seasonsContainer);
	
	var _seasonContainer = __webpack_require__(587);
	
	var _seasonContainer2 = _interopRequireDefault(_seasonContainer);
	
	var _partnersContainer = __webpack_require__(582);
	
	var _partnersContainer2 = _interopRequireDefault(_partnersContainer);
	
	var _partnerContainer = __webpack_require__(581);
	
	var _partnerContainer2 = _interopRequireDefault(_partnerContainer);
	
	var _partnersPageContainer = __webpack_require__(606);
	
	var _partnersPageContainer2 = _interopRequireDefault(_partnersPageContainer);
	
	var _stagesContainer = __webpack_require__(593);
	
	var _stagesContainer2 = _interopRequireDefault(_stagesContainer);
	
	var _stageContainer = __webpack_require__(591);
	
	var _stageContainer2 = _interopRequireDefault(_stageContainer);
	
	var _stageResultsContainer = __webpack_require__(592);
	
	var _stageResultsContainer2 = _interopRequireDefault(_stageResultsContainer);
	
	var _stagesPageContainer = __webpack_require__(249);
	
	var _stagesPageContainer2 = _interopRequireDefault(_stagesPageContainer);
	
	var _stageRegulationsPageContainer = __webpack_require__(615);
	
	var _stageRegulationsPageContainer2 = _interopRequireDefault(_stageRegulationsPageContainer);
	
	var _stageRegistrationPageContainer = __webpack_require__(614);
	
	var _stageRegistrationPageContainer2 = _interopRequireDefault(_stageRegistrationPageContainer);
	
	var _stageParticipantsPageContainer = __webpack_require__(613);
	
	var _stageParticipantsPageContainer2 = _interopRequireDefault(_stageParticipantsPageContainer);
	
	var _stageResultsPageContainer = __webpack_require__(616);
	
	var _stageResultsPageContainer2 = _interopRequireDefault(_stageResultsPageContainer);
	
	var _postPageContainer = __webpack_require__(608);
	
	var _postPageContainer2 = _interopRequireDefault(_postPageContainer);
	
	var _participantPageContainer = __webpack_require__(603);
	
	var _participantPageContainer2 = _interopRequireDefault(_participantPageContainer);
	
	var _participantsContainer = __webpack_require__(578);
	
	var _participantsContainer2 = _interopRequireDefault(_participantsContainer);
	
	var _participantContainer = __webpack_require__(577);
	
	var _participantContainer2 = _interopRequireDefault(_participantContainer);
	
	var _exportContainer = __webpack_require__(567);
	
	var _exportContainer2 = _interopRequireDefault(_exportContainer);
	
	var _postsContainer = __webpack_require__(584);
	
	var _postsContainer2 = _interopRequireDefault(_postsContainer);
	
	var _postContainer = __webpack_require__(583);
	
	var _postContainer2 = _interopRequireDefault(_postContainer);
	
	var _postsPageContainer = __webpack_require__(609);
	
	var _postsPageContainer2 = _interopRequireDefault(_postsPageContainer);
	
	var _settingsContainer = __webpack_require__(590);
	
	var _settingsContainer2 = _interopRequireDefault(_settingsContainer);
	
	var _configurationContainer = __webpack_require__(589);
	
	var _configurationContainer2 = _interopRequireDefault(_configurationContainer);
	
	var _paymentCanceledPageContainer = __webpack_require__(607);
	
	var _paymentCanceledPageContainer2 = _interopRequireDefault(_paymentCanceledPageContainer);
	
	var _aboutPageContainer = __webpack_require__(597);
	
	var _aboutPageContainer2 = _interopRequireDefault(_aboutPageContainer);
	
	var _contactsPageContainer = __webpack_require__(599);
	
	var _contactsPageContainer2 = _interopRequireDefault(_contactsPageContainer);
	
	var _resultsPageContainer = __webpack_require__(611);
	
	var _resultsPageContainer2 = _interopRequireDefault(_resultsPageContainer);
	
	var _regulationsPageContainer = __webpack_require__(610);
	
	var _regulationsPageContainer2 = _interopRequireDefault(_regulationsPageContainer);
	
	var _insurancePageContainer = __webpack_require__(601);
	
	var _insurancePageContainer2 = _interopRequireDefault(_insurancePageContainer);
	
	var _archivePageContainer = __webpack_require__(598);
	
	var _archivePageContainer2 = _interopRequireDefault(_archivePageContainer);
	
	var _participantResultsPageContainer = __webpack_require__(604);
	
	var _participantResultsPageContainer2 = _interopRequireDefault(_participantResultsPageContainer);
	
	var _participantResultsV2PageContainer = __webpack_require__(605);
	
	var _participantResultsV2PageContainer2 = _interopRequireDefault(_participantResultsV2PageContainer);
	
	var _imagesContainer = __webpack_require__(569);
	
	var _imagesContainer2 = _interopRequireDefault(_imagesContainer);
	
	var _imageContainer = __webpack_require__(568);
	
	var _imageContainer2 = _interopRequireDefault(_imageContainer);
	
	var _participantResultsContainer = __webpack_require__(576);
	
	var _participantResultsContainer2 = _interopRequireDefault(_participantResultsContainer);
	
	var _participantResultContainer = __webpack_require__(575);
	
	var _participantResultContainer2 = _interopRequireDefault(_participantResultContainer);
	
	var _partnerCategoriesContainer = __webpack_require__(579);
	
	var _partnerCategoriesContainer2 = _interopRequireDefault(_partnerCategoriesContainer);
	
	var _partnerCategoryContainer = __webpack_require__(580);
	
	var _partnerCategoryContainer2 = _interopRequireDefault(_partnerCategoryContainer);
	
	var _gdprPageContainer = __webpack_require__(600);
	
	var _gdprPageContainer2 = _interopRequireDefault(_gdprPageContainer);
	
	var _promoCodesContainer = __webpack_require__(586);
	
	var _promoCodesContainer2 = _interopRequireDefault(_promoCodesContainer);
	
	var _promoCodeContainer = __webpack_require__(585);
	
	var _promoCodeContainer2 = _interopRequireDefault(_promoCodeContainer);
	
	var _invoicesContainer = __webpack_require__(571);
	
	var _invoicesContainer2 = _interopRequireDefault(_invoicesContainer);
	
	var _invoiceContainer = __webpack_require__(570);
	
	var _invoiceContainer2 = _interopRequireDefault(_invoiceContainer);
	
	var _pagesContainer = __webpack_require__(574);
	
	var _pagesContainer2 = _interopRequireDefault(_pagesContainer);
	
	var _pageContainer = __webpack_require__(573);
	
	var _pageContainer2 = _interopRequireDefault(_pageContainer);
	
	__webpack_require__(885);
	
	__webpack_require__(886);
	
	var _seasonStagesPageContainer = __webpack_require__(612);
	
	var _seasonStagesPageContainer2 = _interopRequireDefault(_seasonStagesPageContainer);
	
	var _pagePageContainer = __webpack_require__(602);
	
	var _pagePageContainer2 = _interopRequireDefault(_pagePageContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _store2.default)();
	
	// Create an enhanced history that syncs navigation events with the store
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	function requireAuth(nextState, replace) {
	    if (!window.USER_LOGGED) {
	        replace({
	            pathname: '/login',
	            state: {
	                nextPathname: nextState.location.pathname
	            }
	        });
	    }
	}
	
	if (window.CARE_CONFIG.settings.google_analytics_code && window.CARE_CONFIG.settings.google_analytics_code.length) {
	    _reactGa2.default.initialize(window.CARE_CONFIG.settings.google_analytics_code);
	}
	
	if (window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
	    var advancedMatching = {};
	    var options = {
	        autoConfig: true, // set pixel's autoConfig
	        debug: false // enable logs
	    };
	    _reactFacebookPixel2.default.init(window.CARE_CONFIG.settings.fb_pixel_code, advancedMatching, options);
	}
	
	function fireTracking() {
	    if (window.CARE_CONFIG.settings.google_analytics_code && window.CARE_CONFIG.settings.google_analytics_code.length) {
	        _reactGa2.default.pageview(window.location.pathname);
	    }
	    if (window.CARE_CONFIG.settings.fb_pixel_code && window.CARE_CONFIG.settings.fb_pixel_code.length) {
	        _reactFacebookPixel2.default.pageView(window.location.pathname);
	    }
	}
	
	if (window.CARE_CONFIG.trackErrors) {
	    _ravenJs2.default.config('https://3e635e27f4996e983b5bd9659ed6d751@o4507571029540864.ingest.de.sentry.io/4508443031830608').install();
	}
	
	_reactDom2.default.render(_react2.default.createElement(
	    _reactRedux.Provider,
	    { store: store },
	    _react2.default.createElement(
	        _reactRouter.Router,
	        { history: history, onUpdate: fireTracking },
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { path: '/', component: _appContainer2.default },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _homeContainer2.default }),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'stages' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _stagesPageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':seasonId', component: _seasonStagesPageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId/regulations', component: _stageRegulationsPageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId/registration', component: _stageRegistrationPageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId/participants', component: _stageParticipantsPageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId/results', component: _stageResultsPageContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'participant' },
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemUuid', component: _participantPageContainer2.default })
	            ),
	            _react2.default.createElement(_reactRouter.Route, { path: 'insurance', component: _insurancePageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'archive', component: _archivePageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'regulations', component: _regulationsPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'about', component: _aboutPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'results', component: _resultsPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'partners', component: _partnersPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'contact', component: _contactsPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'participant-results', component: _participantResultsPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'participant-results/:resultId', component: _participantResultsV2PageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'gdpr', component: _gdprPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'post/:slug', component: _postPageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'page/:slug', component: _pagePageContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'payment-canceled', component: _paymentCanceledPageContainer2.default }),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'posts' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _postsPageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: 'page/:page', component: _postsPageContainer2.default })
	            )
	        ),
	        _react2.default.createElement(_reactRouter.Route, { path: 'login', component: _loginContainer2.default }),
	        _react2.default.createElement(
	            _reactRouter.Route,
	            { path: 'admin', component: _adminContainer2.default, onEnter: requireAuth },
	            _react2.default.createElement(_reactRouter.IndexRoute, { component: _dashboardContainer2.default }),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'users' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _usersContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _userContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'seasons' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _seasonsContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _seasonContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'partners' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _partnersContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _partnerContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'partner-categories' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _partnerCategoriesContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _partnerCategoryContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'participants' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _participantsContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _participantContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'participant-results' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _participantResultsContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _participantResultContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'images' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _imagesContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _imageContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'promo-codes' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _promoCodesContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _promoCodeContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'invoices' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _invoicesContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _invoiceContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'posts' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _postsContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _postContainer2.default })
	            ),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'pages' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _pagesContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _pageContainer2.default })
	            ),
	            _react2.default.createElement(_reactRouter.Route, { path: 'export', component: _exportContainer2.default }),
	            _react2.default.createElement(
	                _reactRouter.Route,
	                { path: 'stages' },
	                _react2.default.createElement(_reactRouter.IndexRoute, { component: _stagesContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId', component: _stageContainer2.default }),
	                _react2.default.createElement(_reactRouter.Route, { path: ':itemId/results', component: _stageResultsContainer2.default })
	            ),
	            _react2.default.createElement(_reactRouter.Route, { path: 'settings', component: _settingsContainer2.default }),
	            _react2.default.createElement(_reactRouter.Route, { path: 'config', component: _configurationContainer2.default })
	        ),
	        _react2.default.createElement(_reactRouter.Redirect, { from: '*', to: '/' })
	    )
	), document.getElementById('mount'));

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _languageCookie = __webpack_require__(43);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalizedStrings = function () {
	    function LocalizedStrings(props) {
	        _classCallCheck(this, LocalizedStrings);
	
	        this.props = props;
	        var language = (0, _languageCookie.getLanguageCookie)();
	        if (!language) {
	            language = 'lt';
	        }
	        this.setLanguage(language);
	    }
	
	    _createClass(LocalizedStrings, [{
	        key: 'setLanguage',
	        value: function setLanguage(language) {
	
	            if (this.props[language]) {
	                var localizedStrings = _extends({}, this.props[Object.keys(this.props)[0]], this.props[language]);
	                for (var key in localizedStrings) {
	                    if (localizedStrings.hasOwnProperty(key)) {
	                        this[key] = localizedStrings[key];
	                    }
	                }
	            }
	        }
	    }]);
	
	    return LocalizedStrings;
	}();
	
	exports.default = LocalizedStrings;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transformAPIActions = transformAPIActions;
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	//add token, json headers, stringify body to API requests
	function transformAPIActions() {
	    return function (next) {
	        return function (action) {
	
	            if (action[_reduxApiMiddleware.CALL_API]) {
	                var call = action[_reduxApiMiddleware.CALL_API];
	
	                var headers = call.headers || {};
	
	                if (Object.prototype.toString.call(call.body) === '[object FormData]') {
	                    // headers['Content-Type'] = 'multipart/form-data';
	                } else {
	                    if (call.body && typeof call.body !== 'string') {
	                        call.body = JSON.stringify(call.body);
	                        headers['Content-Type'] = 'application/json';
	                    }
	                }
	                call.headers = headers;
	                call.credentials = 'same-origin';
	            }
	            return next(action);
	        };
	    };
	}

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _users = __webpack_require__(624);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _partners = __webpack_require__(623);
	
	var _partners2 = _interopRequireDefault(_partners);
	
	var _participant = __webpack_require__(621);
	
	var _participant2 = _interopRequireDefault(_participant);
	
	var _partnerCategories = __webpack_require__(622);
	
	var _partnerCategories2 = _interopRequireDefault(_partnerCategories);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    users: _users2.default,
	    partners: _partners2.default,
	    participant: _participant2.default,
	    partnerCategories: _partnerCategories2.default
	};

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        default:
	            return _extends({}, state, {
	                participant_results: (0, _multipleResults.multipleResultReducer)(state.participant_results, _types2.default.SUBMIT_ADMIN_PARTICIPANT_RESULT_SEARCH, action),
	                participant_result: (0, _singleResult.singleResultReducer)(state.participant_result, _types2.default.LOAD_PARTICIPANT_RESULT, action)
	            });
	
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _multipleResults = __webpack_require__(79);
	
	var _singleResult = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    participant_results: [],
	    participant_result: _singleResult.singleResultInitialState,
	    loading: false
	};

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = partnersReducer;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _removeItem = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    loading: false
	};
	
	function partnersReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.ADMIN_LOAD_PARTNER_CATEGORY.REQUEST:
	            return _extends({}, state, {
	                category: {},
	                loading: true
	            });
	
	        case _types2.default.ADMIN_LOAD_PARTNER_CATEGORY.SUCCESS:
	
	            return _extends({}, state, {
	                category: action.payload,
	                loading: false
	            });
	
	        case _types2.default.SUBMIT_PARTNER_CATEGORY.SUCCESS:
	            return _extends({}, state, {
	                category: action.payload,
	                loading: false
	            });
	        case _types2.default.DELETE_PARTNER_CATEGORY.SUCCESS:
	            return _extends({}, state, {
	                categories: _extends({}, state.categories, {
	                    items: (0, _removeItem.removeItem)(state.partners.items, action.payload.id)
	                })
	
	            });
	        default:
	            return _extends({}, state, {
	                categories: (0, _paginated_results.paginatedResultReducer)(state.categories, _types2.default.ADMIN_LOAD_PARTNER_CATEGORIES, action)
	            });
	    }
	}

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = partnersReducer;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _removeItem = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    loading: false
	};
	
	function partnersReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.ADMIN_LOAD_PARTNER.REQUEST:
	            return _extends({}, state, {
	                partner: {},
	                loading: true
	            });
	
	        case _types2.default.ADMIN_LOAD_PARTNER.SUCCESS:
	
	            return _extends({}, state, {
	                partner: action.payload,
	                loading: false
	            });
	
	        case _types2.default.SUBMIT_PARTNER.SUCCESS:
	            return _extends({}, state, {
	                partner: action.payload,
	                loading: false
	            });
	        case _types2.default.DELETE_PARTNER.SUCCESS:
	            return _extends({}, state, {
	                partners: _extends({}, state.partners, {
	                    items: (0, _removeItem.removeItem)(state.partners.items, action.payload.id)
	                })
	
	            });
	        default:
	            return _extends({}, state, {
	                partners: (0, _paginated_results.paginatedResultReducer)(state.partners, _types2.default.ADMIN_LOAD_PARTNERS, action)
	            });
	    }
	}

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = usersReducer;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    loading: false
	};
	
	function usersReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	
	    switch (action.type) {
	        case _types2.default.ADMIN_LOAD_USER.REQUEST:
	            return _extends({}, state, {
	                user: {},
	                loading: true
	            });
	
	        case _types2.default.ADMIN_LOAD_USER.SUCCESS:
	
	            return _extends({}, state, {
	                user: action.payload,
	                loading: false
	            });
	
	        case _types2.default.SUBMIT_USER.SUCCESS:
	            return _extends({}, state, {
	                user: action.payload,
	                loading: false
	            });
	        default:
	            return _extends({}, state, {
	                result: (0, _paginated_results.paginatedResultReducer)(state.result, _types2.default.ADMIN_LOAD_USERS, action)
	            });
	    }
	}

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = stagesReducer;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {
	    expandedNav: false
	};
	
	function stagesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.TOGGLE_NAVBAR:
	            return _extends({}, state, {
	                expandedNav: !state.expandedNav
	            });
	        case _types2.default.SHOW_NAVBAR:
	            return _extends({}, state, {
	                expandedNav: true
	            });
	        case _types2.default.HIDE_NAVBAR:
	            return _extends({}, state, {
	                expandedNav: false
	            });
	        default:
	            return state;
	    }
	}

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = stagesReducer;
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = {};
	
	function stagesReducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.TOGGLE_DISTANCE_MODAL:
	            return _extends({}, state, {
	                distance_modal: action.payload.toggle,
	                distance: action.payload.distance
	            });
	
	        default:
	            return state;
	    }
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        case _types2.default.DELETE_IMAGE.SUCCESS:
	            return _extends({}, state, {
	                images: _extends({}, state.images, {
	                    items: (0, _removeItem.removeItem)(state.images.items, action.payload.id)
	                })
	
	            });
	
	        default:
	            return _extends({}, state, {
	                images: (0, _paginated_results.paginatedResultReducer)(state.images, _types2.default.LOAD_IMAGES, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _removeItem = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    images: _paginated_results.initialState
	};

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _reactRouterRedux = __webpack_require__(225);
	
	var _redux = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(25);
	
	var _season = __webpack_require__(637);
	
	var _season2 = _interopRequireDefault(_season);
	
	var _partner = __webpack_require__(632);
	
	var _partner2 = _interopRequireDefault(_partner);
	
	var _stage = __webpack_require__(639);
	
	var _stage2 = _interopRequireDefault(_stage);
	
	var _page = __webpack_require__(630);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _participant = __webpack_require__(631);
	
	var _participant2 = _interopRequireDefault(_participant);
	
	var _post = __webpack_require__(634);
	
	var _post2 = _interopRequireDefault(_post);
	
	var _settings = __webpack_require__(638);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _admin = __webpack_require__(620);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _distance = __webpack_require__(626);
	
	var _distance2 = _interopRequireDefault(_distance);
	
	var _results = __webpack_require__(636);
	
	var _results2 = _interopRequireDefault(_results);
	
	var _app = __webpack_require__(625);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _image = __webpack_require__(627);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _partnerCategories = __webpack_require__(633);
	
	var _partnerCategories2 = _interopRequireDefault(_partnerCategories);
	
	var _promoCodes = __webpack_require__(635);
	
	var _promoCodes2 = _interopRequireDefault(_promoCodes);
	
	var _statistics = __webpack_require__(640);
	
	var _statistics2 = _interopRequireDefault(_statistics);
	
	var _invoices = __webpack_require__(629);
	
	var _invoices2 = _interopRequireDefault(_invoices);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({
	    routing: _reactRouterRedux.routerReducer,
	    form: _reduxForm.reducer,
	    season: _season2.default,
	    partner: _partner2.default,
	    stage: _stage2.default,
	    participant: _participant2.default,
	    post: _post2.default,
	    settings: _settings2.default,
	    distance: _distance2.default,
	    app: _app2.default,
	    results: _results2.default,
	    statistics: _statistics2.default,
	    images: _image2.default,
	    partnerCategories: _partnerCategories2.default,
	    promoCodes: _promoCodes2.default,
	    invoices: _invoices2.default,
	    page: _page2.default,
	    admin: (0, _redux.combineReducers)(_admin2.default)
	});

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        default:
	            return _extends({}, state, {
	                invoices: (0, _paginated_results.paginatedResultReducer)(state.promoCodes, _types2.default.ADMIN_LOAD_INVOICES, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _singleResult = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    invoice: _singleResult.singleResultInitialState
	};

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.DELETE_PAGE.SUCCESS:
	
	            return _extends({}, state, {
	                pages: _extends({}, state.pages, {
	                    items: removePage(state.pages.items, action.payload.id)
	                })
	
	            });
	
	        default:
	            return _extends({}, state, {
	                pages: (0, _paginated_results.paginatedResultReducer)(state.pages, _types2.default.LOAD_PAGES_PAGINATED, action),
	                page: (0, _singleResult.singleResultReducer)(state.page, _types2.default.LOAD_PAGE, action)
	
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _singleResult = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    page: _singleResult.singleResultInitialState,
	    pages: _paginated_results.initialState
	};
	
	function removePage(pages, pageToRemoveId) {
	    var pagesReturn = [];
	    pages.forEach(function (page) {
	        if (page.id !== pageToRemoveId) {
	            pagesReturn.push(page);
	        }
	    });
	    return pagesReturn;
	}

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.INITIALIZE_PARTICIPANT_FORM_DATA:
	            return _extends({}, state, {
	                participant: action.payload
	            });
	        case _types2.default.LOAD_PARTICIPANT.REQUEST:
	        case _types2.default.LOAD_PARTICIPANT_BY_UUID.REQUEST:
	            return _extends({}, state, {
	                participant: initial_state.participant,
	                loading: true
	            });
	        case _types2.default.LOAD_PARTICIPANT.FAILURE:
	        case _types2.default.LOAD_PARTICIPANT_BY_UUID.FAILURE:
	            return _extends({}, state, {
	                participant: initial_state.participant,
	                loading: false
	            });
	        case _types2.default.LOAD_PARTICIPANT.SUCCESS:
	        case _types2.default.LOAD_PARTICIPANT_BY_UUID.SUCCESS:
	            return _extends({}, state, {
	                participant: action.payload,
	                loading: false
	            });
	        case _types2.default.SUBMIT_PARTICIPANT.SUCCESS:
	            return _extends({}, state, {
	                participant: action.payload
	            });
	
	        case _types2.default.DELETE_PARTICIPANT.SUCCESS:
	
	            return _extends({}, state, {
	                participants: _extends({}, state.participants, {
	                    items: (0, _removeItem.removeItem)(state.participants.items, action.payload.id)
	                })
	
	            });
	
	        default:
	            return _extends({}, state, {
	                participantV2: (0, _singleResult.singleResultReducer)(state.post, _types2.default.LOAD_PARTICIPANT_RESULT_V2, action),
	                participants: (0, _paginated_results.paginatedResultReducer)(state.participants, _types2.default.LOAD_PARTICIPANTS_PAGINATED, action),
	                participant_results: (0, _multipleResults.multipleResultReducer)(state.participant_results, _types2.default.SUBMIT_PARTICIPANT_RESULT_SEARCH, action)
	            });
	
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _removeItem = __webpack_require__(94);
	
	var _multipleResults = __webpack_require__(79);
	
	var _singleResult = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    participant: {
	        payment: {}
	    },
	    loading: false
	};

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        default:
	            return _extends({}, state, {
	                partners: (0, _multipleResults.multipleResultReducer)(state.partners, _types2.default.LOAD_PARTNERS, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _multipleResults = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    partners: _multipleResults.multipleResultInitialState
	};

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        default:
	            return _extends({}, state, {
	                partnerCategories: (0, _multipleResults.multipleResultReducer)(state.partnerCategories, _types2.default.LOAD_PARTNER_CATEGORIES, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _multipleResults = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    partnerCategories: _multipleResults.multipleResultInitialState
	};

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.DELETE_POST.SUCCESS:
	
	            return _extends({}, state, {
	                posts: _extends({}, state.posts, {
	                    items: removePost(state.posts.items, action.payload.id)
	                })
	
	            });
	
	        default:
	            return _extends({}, state, {
	                posts: (0, _paginated_results.paginatedResultReducer)(state.posts, _types2.default.LOAD_POSTS_PAGINATED, action),
	                post: (0, _singleResult.singleResultReducer)(state.post, _types2.default.LOAD_POST, action)
	
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _singleResult = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    post: _singleResult.singleResultInitialState,
	    posts: _paginated_results.initialState
	};
	
	function removePost(posts, postToRemoveId) {
	    var postsReturn = [];
	    posts.forEach(function (post) {
	        if (post.id !== postToRemoveId) {
	            postsReturn.push(post);
	        }
	    });
	    return postsReturn;
	}

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.DELETE_PROMO_CODE.SUCCESS:
	
	            return _extends({}, state, {
	                promoCodes: _extends({}, state.promoCodes, {
	                    items: (0, _removeItem.removeItem)(state.promoCodes.items, action.payload.id)
	                })
	            });
	        default:
	            return _extends({}, state, {
	                promoCode: (0, _singleResult.singleResultReducer)(state.promoCode, _types2.default.ADMIN_LOAD_PROMO_CODE, action),
	                promoCodes: (0, _paginated_results.paginatedResultReducer)(state.promoCodes, _types2.default.ADMIN_LOAD_PROMO_CODES, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _singleResult = __webpack_require__(63);
	
	var _removeItem = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    promoCodes: _paginated_results.initialState,
	    promoCode: _singleResult.singleResultInitialState
	};

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	
	        default:
	            return _extends({}, state, {
	                results: (0, _multipleResults.multipleResultReducer)(state.results, _types2.default.LOAD_RESULTS, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _multipleResults = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    results: _multipleResults.multipleResultInitialState
	};

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        default:
	            return _extends({}, state, {
	                season: (0, _singleResult.singleResultReducer)(state.season, _types2.default.ADMIN_LOAD_SEASON, action),
	                seasons: (0, _paginated_results.paginatedResultReducer)(state.seasons, _types2.default.ADMIN_LOAD_SEASONS, action),
	                availableSeasons: (0, _multipleResults.multipleResultReducer)(state.availableSeasons, _types2.default.LOAD_SEASONS, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _paginated_results = __webpack_require__(48);
	
	var _singleResult = __webpack_require__(63);
	
	var _multipleResults = __webpack_require__(79);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    seasons: _paginated_results.initialState,
	    season: _singleResult.singleResultInitialState,
	    availableSeasons: _multipleResults.multipleResultInitialState
	};

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.LOAD_SETTINGS.REQUEST:
	            return _extends({}, state, {
	                loading: true,
	                settings: null
	            });
	        case _types2.default.LOAD_SETTINGS.SUCCESS:
	            return _extends({}, state, {
	                loading: false,
	                settings: action.payload
	            });
	        case _types2.default.LOAD_SEASONS.FAILURE:
	            return _extends({}, state, {
	                loading: false,
	                settings: null
	            });
	
	        default:
	            return state;
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    loading: false
	};

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    switch (action.type) {
	        case _types2.default.SUBMIT_STAGE.SUCCESS:
	            return _extends({}, state, {
	                stage: _extends({}, _singleResult.singleResultInitialState, {
	                    item: action.payload
	                })
	            });
	
	        case _types2.default.ADMIN_UPDATE_STAGE_DISTANCE:
	            return _extends({}, state, {
	                stage: _extends({}, state.stage, {
	                    item: _extends({}, state.stage.item, {
	                        distances: buildDistancesList(state.stage.item.distances, action.payload.distance)
	                    })
	
	                })
	            });
	        case _types2.default.DELETE_DISTANCE.SUCCESS:
	
	            return _extends({}, state, {
	                stage: _extends({}, state.stage, {
	                    item: _extends({}, state.stage.item, {
	                        distances: removeDistance(state.stage.item.distances, action.payload.id)
	                    })
	
	                })
	            });
	        case _types2.default.DELETE_STAGE.SUCCESS:
	
	            return _extends({}, state, {
	                stages: _extends({}, state.stages, {
	                    items: (0, _removeItem.removeItem)(state.stages.items, action.payload.id)
	                })
	
	            });
	        default:
	            return _extends({}, state, {
	                stage: (0, _singleResult.singleResultReducer)(state.stage, _types2.default.LOAD_STAGE, action),
	                upcomingStage: (0, _singleResult.singleResultReducer)(state.upcomingStage, _types2.default.LOAD_UPCOMING_STAGE, action),
	                registerToAllStages: (0, _singleResult.singleResultReducer)(state.registerToAllStages, _types2.default.REGISTRATION_TO_ALL, action),
	                stages: (0, _singleResult.singleResultReducer)(state.upcomingStage, _types2.default.LOAD_UPCOMING_STAGE, action),
	                availableStages: (0, _multipleResults.multipleResultReducer)(state.availableStages, _types2.default.LOAD_STAGES, action),
	                stagesPaginated: (0, _paginated_results.paginatedResultReducer)(state.stagesPaginated, _types2.default.LOAD_STAGES_PAGINATED, action),
	                stageParticipants: (0, _paginated_results.paginatedResultReducer)(state.stageParticipants, _types2.default.LOAD_STAGE_PARTICIPANTS, action),
	                stageResults: (0, _paginated_results.paginatedResultReducer)(state.stageResults, _types2.default.LOAD_STAGE_RESULTS, action),
	                registerToCustomStages: (0, _singleResult.singleResultReducer)(state.registerToCustomStages, _types2.default.REGISTRATION_TO_CUSTOM, action)
	            });
	    }
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _singleResult = __webpack_require__(63);
	
	var _multipleResults = __webpack_require__(79);
	
	var _paginated_results = __webpack_require__(48);
	
	var _removeItem = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    availableStages: _multipleResults.multipleResultInitialState,
	    upcomingStage: _singleResult.singleResultInitialState,
	    registerToAllStages: _singleResult.singleResultInitialState,
	    stage: _singleResult.singleResultInitialState,
	    stagesPaginated: _paginated_results.initialState,
	    stageParticipants: _paginated_results.initialState,
	    stageResults: _paginated_results.initialState,
	
	    registerToCustomStages: _singleResult.singleResultInitialState
	
	};
	
	function removeDistance(distances, distanceToRemoveId) {
	    var distancesReturn = [];
	    distances.forEach(function (distance) {
	        if (distance.id !== distanceToRemoveId) {
	            distancesReturn.push(distance);
	        }
	    });
	    return distancesReturn;
	}
	
	function buildDistancesList(distances, distanceToUpdate) {
	    var found = false;
	    distances = distances.map(function (distance) {
	        if (distance.id === distanceToUpdate.id) {
	            found = true;
	            return distanceToUpdate;
	        }
	        return distance;
	    });
	    if (!found) {
	        distances.push(distanceToUpdate);
	    }
	    return distances;
	}

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial_state;
	    var action = arguments[1];
	
	    return _extends({}, state, {
	        statistics: (0, _singleResult.singleResultReducer)(state.statistics, _types2.default.LOAD_STATISTICS, action)
	    });
	};
	
	var _types = __webpack_require__(8);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _singleResult = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initial_state = {
	    statistics: _singleResult.singleResultInitialState
	};

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(5);
	
	var _reduxApiMiddleware = __webpack_require__(61);
	
	var _reactRouterRedux = __webpack_require__(225);
	
	var _reactRouter = __webpack_require__(14);
	
	var _reduxThunk = __webpack_require__(1181);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(628);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _api = __webpack_require__(619);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore() {
	    var store = (0, _redux.createStore)(_reducers2.default, (0, _redux.compose)((0, _redux.applyMiddleware)(_api.transformAPIActions, _reduxApiMiddleware.apiMiddleware, _reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory)), window.devToolsExtension ? window.devToolsExtension() : function (f) {
	        return f;
	    }));
	
	    //hot reload reducers
	    if (false) {
	        module.hot.accept('./reducers', function () {
	            store.replaceReducer(require('./reducers'));
	        });
	    }
	
	    return store;
	}

/***/ },
/* 642 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCountries = getCountries;
	function getCountries() {
	  return [{ 'id': 'LT', 'name': 'Lietuva' }, { 'id': 'AT', 'name': 'Österreich' }, { 'id': 'BE', 'name': 'België' }, { 'id': 'BG', 'name': 'България' }, { 'id': 'HR', 'name': 'Hrvatska' }, { 'id': 'CY', 'name': 'Κύπρος' }, { 'id': 'CZ', 'name': 'Česko' }, { 'id': 'DK', 'name': 'Danmark' }, { 'id': 'EE', 'name': 'Eesti' }, { 'id': 'FI', 'name': 'Suomi' }, { 'id': 'FR', 'name': 'France' }, { 'id': 'DE', 'name': 'Deutschland' }, { 'id': 'GR', 'name': 'Ελλάδα' }, { 'id': 'HU', 'name': 'Magyarország' }, { 'id': 'IE', 'name': 'Éire' }, { 'id': 'IT', 'name': 'Italia' }, { 'id': 'LV', 'name': 'Latvija' }, { 'id': 'LU', 'name': 'Lëtzebuerg' }, { 'id': 'MT', 'name': 'Malta' }, { 'id': 'NL', 'name': 'Nederland' }, { 'id': 'PL', 'name': 'Polska' }, { 'id': 'PT', 'name': 'Portugal' }, { 'id': 'RO', 'name': 'România' }, { 'id': 'SK', 'name': 'Slovensko' }, { 'id': 'SI', 'name': 'Slovenija' }, { 'id': 'ES', 'name': 'España' }, { 'id': 'SE', 'name': 'Sverige' }, { 'id': 'AF', 'name': 'افغانستان' }, { 'id': 'AL', 'name': 'Shqipëria' }, { 'id': 'DZ', 'name': 'الجزائر' }, { 'id': 'AD', 'name': 'Andorra' }, { 'id': 'AO', 'name': 'Angola' }, { 'id': 'AR', 'name': 'Argentina' }, { 'id': 'AM', 'name': 'Հայաստան' }, { 'id': 'AU', 'name': 'Australia' }, { 'id': 'AZ', 'name': 'Azərbaycan' }, { 'id': 'BH', 'name': 'البحرين' }, { 'id': 'BD', 'name': 'বাংলাদেশ' }, { 'id': 'BY', 'name': 'Беларусь' }, { 'id': 'BJ', 'name': 'Bénin' }, { 'id': 'BO', 'name': 'Bolivia' }, { 'id': 'BR', 'name': 'Brasil' }, { 'id': 'CA', 'name': 'Canada' }, { 'id': 'CL', 'name': 'Chile' }, { 'id': 'CN', 'name': '中国' }, { 'id': 'CO', 'name': 'Colombia' }, { 'id': 'CU', 'name': 'Cuba' }, { 'id': 'EG', 'name': 'مصر' }, { 'id': 'IN', 'name': 'भारत' }, { 'id': 'ID', 'name': 'Indonesia' }, { 'id': 'IR', 'name': 'ایران' }, { 'id': 'IQ', 'name': 'العراق' }, { 'id': 'IL', 'name': 'יִשְרָאֵל' }, { 'id': 'JP', 'name': '日本' }, { 'id': 'KE', 'name': 'Kenya' }, { 'id': 'KR', 'name': '대한민국' }, { 'id': 'LY', 'name': 'ليبيا' }, { 'id': 'MX', 'name': 'México' }, { 'id': 'MA', 'name': 'المغرب' }, { 'id': 'NG', 'name': 'Nigeria' }, { 'id': 'NO', 'name': 'Norge' }, { 'id': 'NZ', 'name': 'New Zealand' }, { 'id': 'PK', 'name': 'پاکستان' }, { 'id': 'RU', 'name': 'Россия' }, { 'id': 'SA', 'name': 'السعودية' }, { 'id': 'RS', 'name': 'Србија' }, { 'id': 'CH', 'name': 'Schweiz' }, { 'id': 'TR', 'name': 'Türkiye' }, { 'id': 'UA', 'name': 'Україна' }, { 'id': 'GB', 'name': 'United Kingdom' }, { 'id': 'US', 'name': 'United States' }, { 'id': 'VN', 'name': 'Việt Nam' }, { 'id': 'ZA', 'name': 'South Africa' }];
	}

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function ChevronLeft(props) {
	    return React.createElement("svg", props, [React.createElement("path", { "d": "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z", "key": 0 }), React.createElement("path", { "d": "M0-.5h24v24H0z", "fill": "none", "key": 1 })]);
	}
	
	ChevronLeft.defaultProps = { "fill": "#000000", "height": "24", "viewBox": "0 0 24 24", "width": "24" };
	
	module.exports = ChevronLeft;
	
	ChevronLeft.default = ChevronLeft;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function ChevronRight(props) {
	    return React.createElement("svg", props, [React.createElement("path", { "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z", "key": 0 }), React.createElement("path", { "d": "M0-.25h24v24H0z", "fill": "none", "key": 1 })]);
	}
	
	ChevronRight.defaultProps = { "fill": "#000000", "height": "24", "viewBox": "0 0 24 24", "width": "24" };
	
	module.exports = ChevronRight;
	
	ChevronRight.default = ChevronRight;

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Facebook(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "key": 0 }, React.createElement("g", { "id": "post-facebook" }, React.createElement("path", { "d": "M459,0H51C22.95,0,0,22.95,0,51v408c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0z\r\n\t\t\t M433.5,51v76.5h-51c-15.3,0-25.5,10.2-25.5,25.5v51h76.5v76.5H357V459h-76.5V280.5h-51V204h51v-63.75\r\n\t\t\tC280.5,91.8,321.3,51,369.75,51H433.5z" }))), React.createElement("g", { "key": 1 }), React.createElement("g", { "key": 2 }), React.createElement("g", { "key": 3 }), React.createElement("g", { "key": 4 }), React.createElement("g", { "key": 5 }), React.createElement("g", { "key": 6 }), React.createElement("g", { "key": 7 }), React.createElement("g", { "key": 8 }), React.createElement("g", { "key": 9 }), React.createElement("g", { "key": 10 }), React.createElement("g", { "key": 11 }), React.createElement("g", { "key": 12 }), React.createElement("g", { "key": 13 }), React.createElement("g", { "key": 14 }), React.createElement("g", { "key": 15 })]);
	}
	
	Facebook.defaultProps = { "version": "1.1", "id": "Capa_1", "x": "0px", "y": "0px", "width": "510px", "height": "510px", "viewBox": "0 0 510 510", "style": { "enableBackground": "new 0 0 510 510" }, "xmlSpace": "preserve" };
	
	module.exports = Facebook;
	
	Facebook.default = Facebook;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Instagram(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "key": 0 }, React.createElement("g", { "id": "post-instagram" }, React.createElement("path", { "d": "M459,0H51C22.95,0,0,22.95,0,51v408c0,28.05,22.95,51,51,51h408c28.05,0,51-22.95,51-51V51C510,22.95,487.05,0,459,0z\r\n\t\t\t M255,153c56.1,0,102,45.9,102,102c0,56.1-45.9,102-102,102c-56.1,0-102-45.9-102-102C153,198.9,198.9,153,255,153z M63.75,459\r\n\t\t\tC56.1,459,51,453.9,51,446.25V229.5h53.55C102,237.15,102,247.35,102,255c0,84.15,68.85,153,153,153c84.15,0,153-68.85,153-153\r\n\t\t\tc0-7.65,0-17.85-2.55-25.5H459v216.75c0,7.65-5.1,12.75-12.75,12.75H63.75z M459,114.75c0,7.65-5.1,12.75-12.75,12.75h-51\r\n\t\t\tc-7.65,0-12.75-5.1-12.75-12.75v-51c0-7.65,5.1-12.75,12.75-12.75h51C453.9,51,459,56.1,459,63.75V114.75z" }))), React.createElement("g", { "key": 1 }), React.createElement("g", { "key": 2 }), React.createElement("g", { "key": 3 }), React.createElement("g", { "key": 4 }), React.createElement("g", { "key": 5 }), React.createElement("g", { "key": 6 }), React.createElement("g", { "key": 7 }), React.createElement("g", { "key": 8 }), React.createElement("g", { "key": 9 }), React.createElement("g", { "key": 10 }), React.createElement("g", { "key": 11 }), React.createElement("g", { "key": 12 }), React.createElement("g", { "key": 13 }), React.createElement("g", { "key": 14 }), React.createElement("g", { "key": 15 })]);
	}
	
	Instagram.defaultProps = { "version": "1.1", "id": "Capa_1", "x": "0px", "y": "0px", "width": "510px", "height": "510px", "viewBox": "0 0 510 510", "style": { "enableBackground": "new 0 0 510 510" }, "xmlSpace": "preserve" };
	
	module.exports = Instagram;
	
	Instagram.default = Instagram;

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Loading(props) {
	    return React.createElement("svg", props, [React.createElement("rect", { "x": "0", "y": "0", "width": "100", "height": "100", "fill": "none", "className": "bk", "key": 0 }), React.createElement("g", { "key": 1 }, [React.createElement("path", { "d": "M50 15A35 35 0 1 0 74.787 25.213", "fill": "none", "stroke": "#2fc296", "strokeWidth": "12px", "key": 0 }), React.createElement("path", { "d": "M50 0L50 30L66 15L50 0", "fill": "#2fc296", "className": "arrow", "key": 1 }), React.createElement("animateTransform", { "attributeName": "transform", "type": "rotate", "from": "0 50 50", "to": "360 50 50", "dur": "1s", "repeatCount": "indefinite", "key": 2 })])]);
	}
	
	Loading.defaultProps = { "width": "198px", "height": "198px", "viewBox": "0 0 100 100", "preserveAspectRatio": "xMidYMid", "className": "uil-reload" };
	
	module.exports = Loading;
	
	Loading.default = Loading;

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Mastercard(props) {
	    return React.createElement("svg", props, [React.createElement("style", { "type": "text/css", "key": 0 }, "\n\t.st0{fill:none;}\n\t.st1{fill:#FF5F00;}\n\t.st2{fill:#EB001B;}\n\t.st3{fill:#F79E1B;}\n"), React.createElement("g", { "key": 1 }, [React.createElement("rect", { "y": "0", "className": "st0", "width": "152.4", "height": "108", "key": 0 }), React.createElement("g", { "key": 1 }, [React.createElement("rect", { "x": "60.4", "y": "25.7", "className": "st1", "width": "31.5", "height": "56.6", "key": 0 }), React.createElement("path", { "className": "st2", "d": "M62.4,54c0-11,5.1-21.5,13.7-28.3c-15.6-12.3-38.3-9.6-50.6,6.1C13.3,47.4,16,70,31.7,82.3\n\t\t\tc13.1,10.3,31.4,10.3,44.5,0C67.5,75.5,62.4,65,62.4,54z", "key": 1 }), React.createElement("path", { "className": "st3", "d": "M134.4,54c0,19.9-16.1,36-36,36c-8.1,0-15.9-2.7-22.2-7.7c15.6-12.3,18.3-34.9,6-50.6c-1.8-2.2-3.8-4.3-6-6\n\t\t\tc15.6-12.3,38.3-9.6,50.5,6.1C131.7,38.1,134.4,45.9,134.4,54z", "key": 2 })])])]);
	}
	
	Mastercard.defaultProps = { "version": "1.1", "id": "Layer_1", "x": "0px", "y": "0px", "viewBox": "0 0 152.4 108", "style": { "enableBackground": "new 0 0 152.4 108" }, "xmlSpace": "preserve" };
	
	module.exports = Mastercard;
	
	Mastercard.default = Mastercard;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Menu(props) {
	    return React.createElement("svg", props, [React.createElement("title", { "key": 0 }, "E777B67B-EF3D-47B8-8546-23013D048AB5"), React.createElement("desc", { "key": 1 }, "Created with sketchtool."), React.createElement("defs", { "key": 2 }), React.createElement("g", { "id": "Main", "stroke": "none", "strokeWidth": "1", "fill": "none", "fillRule": "evenodd", "key": 3 }, React.createElement("g", { "id": "landing_mobile-1-hamburger", "transform": "translate(-325.000000, -25.000000)", "fill": "#444444" }, React.createElement("g", { "id": "Group-4", "transform": "translate(325.000000, 25.000000)" }, [React.createElement("rect", { "id": "Rectangle-17", "x": "0", "y": "0", "width": "25", "height": "3", "key": 0 }), React.createElement("rect", { "id": "Rectangle-17-Copy", "x": "0", "y": "10", "width": "25", "height": "3", "key": 1 }), React.createElement("rect", { "id": "Rectangle-17-Copy-2", "x": "0", "y": "20", "width": "25", "height": "3", "key": 2 })])))]);
	}
	
	Menu.defaultProps = { "width": "25px", "height": "23px", "viewBox": "0 0 25 23", "version": "1.1" };
	
	module.exports = Menu;
	
	Menu.default = Menu;

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Spinner(props) {
	    return React.createElement("svg", props, React.createElement("path", { "d": "M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zm498 206q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-704-704q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm1202 498q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-964-996q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zm1170 498q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zm-640-704q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm530 206q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z" }));
	}
	
	Spinner.defaultProps = { "width": "1792", "height": "1792", "viewBox": "0 0 1792 1792" };
	
	module.exports = Spinner;
	
	Spinner.default = Spinner;

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Trash(props) {
	    return React.createElement("svg", props, [React.createElement("path", { "d": "M0 0h24v24H0V0z", "fill": "none", "key": 0 }), React.createElement("path", { "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z", "key": 1 }), React.createElement("path", { "d": "M0 0h24v24H0z", "fill": "none", "key": 2 })]);
	}
	
	Trash.defaultProps = { "fill": "#000000", "height": "24", "viewBox": "0 0 24 24", "width": "24" };
	
	module.exports = Trash;
	
	Trash.default = Trash;

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Upload(props) {
	    return React.createElement("svg", props, [React.createElement("path", { "d": "M0 0h24v24H0z", "fill": "none", "key": 0 }), React.createElement("path", { "d": "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z", "key": 1 })]);
	}
	
	Upload.defaultProps = { "fill": "#000000", "height": "24", "viewBox": "0 0 24 24", "width": "24" };
	
	module.exports = Upload;
	
	Upload.default = Upload;

/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Visa(props) {
	    return React.createElement("svg", props, [React.createElement("title", { "key": 0 }, "Visa Inc logo - Brandlogos.net"), React.createElement("path", { "d": "M551.23,470c-18.41,0-34.86,9.54-34.86,27.17,0,20.22,29.17,21.61,29.17,31.77,0,4.28-4.9,8.1-13.27,8.1a44.07,44.07,0,0,1-20.76-5.35l-3.8,17.79A64.79,64.79,0,0,0,531.53,554c20.13,0,36-10,36-27.94,0-21.36-29.3-22.72-29.3-32.14,0-3.35,4-7,12.37-7a42,42,0,0,1,17.1,3.89l3.72-17.18A55.64,55.64,0,0,0,551.23,470Zm-168.41,1.3-.45,2.59a86.57,86.57,0,0,1,14.72,4.24c9,3.24,9.62,5.13,11.13,11l16.48,63.54H446.8l34-81.37h-22l-21.87,55.32L428,479.73c-.82-5.37-5-8.43-10-8.43Zm106.88,0-17.29,81.37h21l17.23-81.37h-21Zm117.24,0c-5.07,0-7.75,2.71-9.72,7.46l-30.8,73.91h22l4.26-12.32h26.85l2.59,12.32h19.45l-17-81.37H606.94Zm2.87,22,6.53,30.53h-17.5l11-30.53Z", "transform": "translate(-382.37 -470)", "style": { "fill": "#1434cb" }, "key": 1 })]);
	}
	
	Visa.defaultProps = { "width": "259.25", "height": "84", "viewBox": "0 0 259.25 84" };
	
	module.exports = Visa;
	
	Visa.default = Visa;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function XlsxFile(props) {
	    return React.createElement("svg", props, React.createElement("g", null, React.createElement("g", null, [React.createElement("path", { "d": "M472.929,131.399c-0.031-2.518-0.823-5-2.55-6.961L364.655,3.677c-0.021-0.031-0.052-0.042-0.083-0.073\r\n\t\t\tc-0.631-0.707-1.355-1.287-2.132-1.795c-0.231-0.152-0.462-0.286-0.704-0.421c-0.683-0.365-1.386-0.666-2.121-0.887\r\n\t\t\tc-0.198-0.06-0.377-0.139-0.577-0.194C358.23,0.121,357.41,0,356.571,0H96.757C84.904,0,75.255,9.651,75.255,21.502V526.79\r\n\t\t\tc0,11.858,9.649,21.501,21.502,21.501h354.776c11.862,0,21.502-9.643,21.502-21.501V132.6\r\n\t\t\tC473.035,132.199,472.973,131.795,472.929,131.399z M165.545,508.217l-9.352-18.703c-3.83-7.209-6.278-12.574-9.192-18.547h-0.307\r\n\t\t\tc-2.145,5.973-4.749,11.338-7.966,18.547l-8.585,18.703h-26.662l29.888-52.273l-28.812-51.029h26.822l9.042,18.861\r\n\t\t\tc3.063,6.276,5.364,11.327,7.821,17.155h0.3c2.457-6.594,4.446-11.188,7.047-17.155l8.741-18.861h26.662l-29.118,50.414\r\n\t\t\tl30.657,52.889H165.545z M269.591,508.217h-64.526V404.915h23.452v83.67h41.074V508.217z M308.66,509.739\r\n\t\t\tc-11.795,0-23.439-3.064-29.263-6.282l4.743-19.308c6.287,3.212,15.947,6.43,25.899,6.43c10.735,0,16.399-4.436,16.399-11.192\r\n\t\t\tc0-6.425-4.903-10.109-17.316-14.551c-17.161-5.973-28.354-15.475-28.354-30.498c0-17.623,14.709-31.108,39.087-31.108\r\n\t\t\tc11.639,0,20.232,2.446,26.353,5.212l-5.207,18.852c-4.142-1.99-11.496-4.908-21.613-4.908c-10.115,0-15.013,4.594-15.013,9.969\r\n\t\t\tc0,6.587,5.822,9.5,19.155,14.551c18.237,6.752,26.814,16.246,26.814,30.805C350.346,495.03,337.012,509.739,308.66,509.739z\r\n\t\t\t M420.53,508.217l-9.354-18.703c-3.833-7.209-6.279-12.574-9.198-18.547h-0.294c-2.142,5.973-4.755,11.338-7.975,18.547\r\n\t\t\tl-8.583,18.703h-26.665l29.885-52.273l-28.814-51.029h26.823l9.051,18.861c3.061,6.276,5.354,11.327,7.806,17.155h0.31\r\n\t\t\tc2.446-6.594,4.44-11.188,7.05-17.155l8.736-18.861h26.666l-29.117,50.414l30.65,52.889H420.53z M96.757,365.085V21.507H345.82\r\n\t\t\tv110.015c0,5.935,4.809,10.75,10.751,10.75h94.962l0.01,222.813H96.757z", "key": 0 }), React.createElement("path", { "d": "M310.933,138.004h-83.765h-94.516v40.316v5.375v34.94v5.375v34.939v5.375v40.319h89.141h5.375h83.765h5.376h89.14v-45.694\r\n\t\t\tv-34.939v-40.315v-5.375v-40.316H310.933z M310.933,218.636h-83.765v-34.94h83.765V218.636z M138.028,143.38h83.765v34.94h-83.765\r\n\t\t\tV143.38z M138.028,183.696h83.765v34.94h-83.765V183.696z M138.028,224.011h83.765v34.939h-83.765V224.011z M138.028,299.269\r\n\t\t\tv-34.943h83.765v34.943H138.028z M227.168,299.269v-34.943h83.765v34.943H227.168z M400.078,299.269h-83.77v-34.943h83.764v34.943\r\n\t\t\tH400.078z M400.078,218.636h-83.77v-34.94h83.764v34.94H400.078z M316.309,178.32v-34.94h83.764v34.94H316.309z", "key": 1 })])));
	}
	
	XlsxFile.defaultProps = { "version": "1.1", "id": "Capa_1", "x": "0px", "y": "0px", "width": "548.29px", "height": "548.291px", "viewBox": "0 0 548.29 548.291", "style": { "enableBackground": "new 0 0 548.29 548.291" }, "xmlSpace": "preserve" };
	
	module.exports = XlsxFile;
	
	XlsxFile.default = XlsxFile;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var React = __webpack_require__(1);
	
	function Youtube(props) {
	    return React.createElement("svg", props, [React.createElement("g", { "key": 0 }, React.createElement("g", null, [React.createElement("path", { "d": "M459.954,264.376c-2.471-11.233-7.949-20.653-16.416-28.264c-8.474-7.611-18.227-12.085-29.27-13.418\r\n\t\t\tc-35.02-3.806-87.837-5.708-158.457-5.708c-70.618,0-123.341,1.903-158.174,5.708c-11.227,1.333-21.029,5.807-29.407,13.418\r\n\t\t\tc-8.376,7.614-13.896,17.035-16.562,28.264c-4.948,22.083-7.423,55.391-7.423,99.931c0,45.299,2.475,78.61,7.423,99.93\r\n\t\t\tc2.478,11.225,7.951,20.653,16.421,28.261c8.47,7.614,18.225,11.991,29.263,13.134c35.026,3.997,87.847,5.996,158.461,5.996\r\n\t\t\tc70.609,0,123.44-1.999,158.453-5.996c11.043-1.143,20.748-5.52,29.126-13.134c8.377-7.607,13.897-17.036,16.56-28.261\r\n\t\t\tc4.948-22.083,7.426-55.391,7.426-99.93C467.377,319.007,464.899,285.695,459.954,264.376z M165.025,293.218h-30.549v162.45\r\n\t\t\th-28.549v-162.45h-29.98v-26.837h89.079V293.218z M242.11,455.668H216.7v-15.421c-10.278,11.615-19.989,17.419-29.125,17.419\r\n\t\t\tc-8.754,0-14.275-3.524-16.556-10.564c-1.521-4.568-2.286-11.519-2.286-20.844V314.627h25.41v103.924\r\n\t\t\tc0,6.088,0.096,9.421,0.288,9.993c0.571,3.997,2.568,5.995,5.996,5.995c5.138,0,10.566-3.997,16.274-11.991V314.627h25.41V455.668\r\n\t\t\tz M339.183,413.411c0,13.894-0.855,23.417-2.56,28.558c-3.244,10.462-9.996,15.697-20.273,15.697\r\n\t\t\tc-9.137,0-17.986-5.235-26.556-15.697v13.702h-25.406v-189.29h25.406v61.955c8.189-10.273,17.036-15.413,26.556-15.413\r\n\t\t\tc10.277,0,17.029,5.331,20.273,15.988c1.704,4.948,2.56,14.369,2.56,28.264V413.411z M435.685,390.003h-51.104v24.839\r\n\t\t\tc0,13.134,4.374,19.697,13.131,19.697c6.279,0,10.089-3.422,11.42-10.28c0.376-1.902,0.571-7.706,0.571-17.412h25.981v3.71\r\n\t\t\tc0,9.329-0.195,14.846-0.572,16.563c-0.567,5.133-2.56,10.273-5.995,15.413c-6.852,10.089-17.139,15.133-30.841,15.133\r\n\t\t\tc-13.127,0-23.407-4.855-30.833-14.558c-5.517-7.043-8.275-18.083-8.275-33.12v-49.396c0-15.036,2.662-26.076,7.987-33.119\r\n\t\t\tc7.427-9.705,17.61-14.558,30.557-14.558c12.755,0,22.85,4.853,30.263,14.558c5.146,7.043,7.71,18.083,7.71,33.119V390.003\r\n\t\t\tL435.685,390.003z", "key": 0 }), React.createElement("path", { "d": "M302.634,336.043c-4.38,0-8.658,2.101-12.847,6.283v85.934c4.188,4.186,8.467,6.279,12.847,6.279\r\n\t\t\tc7.419,0,11.14-6.372,11.14-19.13v-60.236C313.773,342.418,310.061,336.043,302.634,336.043z", "key": 1 }), React.createElement("path", { "d": "M397.428,336.043c-8.565,0-12.847,6.475-12.847,19.41v13.134h25.693v-13.134\r\n\t\t\tC410.274,342.511,405.99,336.043,397.428,336.043z", "key": 2 }), React.createElement("path", { "d": "M148.473,113.917v77.375h28.549v-77.375L211.563,0h-29.121l-19.41,75.089L142.759,0h-30.262\r\n\t\t\tc5.33,15.99,11.516,33.785,18.559,53.391C140.003,79.656,145.805,99.835,148.473,113.917z", "key": 3 }), React.createElement("path", { "d": "M249.82,193.291c13.134,0,23.219-4.854,30.262-14.561c5.332-7.043,7.994-18.274,7.994-33.689V95.075\r\n\t\t\tc0-15.225-2.669-26.363-7.994-33.406c-7.043-9.707-17.128-14.561-30.262-14.561c-12.756,0-22.75,4.854-29.98,14.561\r\n\t\t\tc-5.327,7.043-7.992,18.181-7.992,33.406v49.965c0,15.225,2.662,26.457,7.992,33.689\r\n\t\t\tC227.073,188.437,237.063,193.291,249.82,193.291z M237.541,89.935c0-13.134,4.093-19.701,12.279-19.701\r\n\t\t\ts12.275,6.567,12.275,19.701v59.955c0,13.328-4.089,19.985-12.275,19.985s-12.279-6.661-12.279-19.985V89.935z", "key": 4 }), React.createElement("path", { "d": "M328.328,193.291c9.523,0,19.328-5.901,29.413-17.705v15.703h25.981V48.822h-25.981v108.777\r\n\t\t\tc-5.712,8.186-11.133,12.275-16.279,12.275c-3.429,0-5.428-2.093-5.996-6.28c-0.191-0.381-0.287-3.715-0.287-9.994V48.822h-25.981\r\n\t\t\tv112.492c0,9.705,0.767,16.84,2.286,21.411C313.961,189.768,319.574,193.291,328.328,193.291z", "key": 5 })])), React.createElement("g", { "key": 1 }), React.createElement("g", { "key": 2 }), React.createElement("g", { "key": 3 }), React.createElement("g", { "key": 4 }), React.createElement("g", { "key": 5 }), React.createElement("g", { "key": 6 }), React.createElement("g", { "key": 7 }), React.createElement("g", { "key": 8 }), React.createElement("g", { "key": 9 }), React.createElement("g", { "key": 10 }), React.createElement("g", { "key": 11 }), React.createElement("g", { "key": 12 }), React.createElement("g", { "key": 13 }), React.createElement("g", { "key": 14 }), React.createElement("g", { "key": 15 })]);
	}
	
	Youtube.defaultProps = { "version": "1.1", "id": "Capa_1", "x": "0px", "y": "0px", "width": "511.627px", "height": "511.627px", "viewBox": "0 0 511.627 511.627", "style": { "enableBackground": "new 0 0 511.627 511.627" }, "xmlSpace": "preserve" };
	
	module.exports = Youtube;
	
	Youtube.default = Youtube;

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(837);
	
	__webpack_require__(1185);
	
	__webpack_require__(657);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(666);
	module.exports = __webpack_require__(64).RegExp.escape;

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(15)
	  , isArray  = __webpack_require__(176)
	  , SPECIES  = __webpack_require__(16)('species');
	
	module.exports = function(original){
	  var C;
	  if(isArray(original)){
	    C = original.constructor;
	    // cross-realm fallback
	    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
	    if(isObject(C)){
	      C = C[SPECIES];
	      if(C === null)C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(658);
	
	module.exports = function(original, length){
	  return new (speciesConstructor(original))(length);
	};

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject    = __webpack_require__(9)
	  , toPrimitive = __webpack_require__(59)
	  , NUMBER      = 'number';
	
	module.exports = function(hint){
	  if(hint !== 'string' && hint !== NUMBER && hint !== 'default')throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(84)
	  , gOPS    = __webpack_require__(137)
	  , pIE     = __webpack_require__(110);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(84)
	  , toIObject = __webpack_require__(41);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var path      = __webpack_require__(664)
	  , invoke    = __webpack_require__(133)
	  , aFunction = __webpack_require__(37);
	module.exports = function(/* ...pargs */){
	  var fn     = aFunction(this)
	    , length = arguments.length
	    , pargs  = Array(length)
	    , i      = 0
	    , _      = path._
	    , holder = false;
	  while(length > i)if((pargs[i] = arguments[i++]) === _)holder = true;
	  return function(/* ...args */){
	    var that = this
	      , aLen = arguments.length
	      , j = 0, k = 0, args;
	    if(!holder && !aLen)return invoke(fn, pargs, that);
	    args = pargs.slice();
	    if(holder)for(;length > j; j++)if(args[j] === _)args[j] = arguments[k++];
	    while(aLen > k)args.push(arguments[k++]);
	    return invoke(fn, args, that);
	  };
	};

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(10);

/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports = function(regExp, replace){
	  var replacer = replace === Object(replace) ? function(part){
	    return replace[part];
	  } : replace;
	  return function(it){
	    return String(it).replace(regExp, replacer);
	  };
	};

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(3)
	  , $re     = __webpack_require__(665)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', {escape: function escape(it){ return $re(it); }});


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {copyWithin: __webpack_require__(251)});
	
	__webpack_require__(95)('copyWithin');

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $every  = __webpack_require__(57)(4);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */){
	    return $every(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Array', {fill: __webpack_require__(168)});
	
	__webpack_require__(95)('fill');

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $filter = __webpack_require__(57)(2);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */){
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(57)(6)
	  , KEY     = 'findIndex'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(95)(KEY);

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(3)
	  , $find   = __webpack_require__(57)(5)
	  , KEY     = 'find'
	  , forced  = true;
	// Shouldn't skip holes
	if(KEY in [])Array(1)[KEY](function(){ forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn/*, that = undefined */){
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(95)(KEY);

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export  = __webpack_require__(3)
	  , $forEach = __webpack_require__(57)(0)
	  , STRICT   = __webpack_require__(51)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */){
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(65)
	  , $export        = __webpack_require__(3)
	  , toObject       = __webpack_require__(28)
	  , call           = __webpack_require__(260)
	  , isArrayIter    = __webpack_require__(175)
	  , toLength       = __webpack_require__(24)
	  , createProperty = __webpack_require__(169)
	  , getIterFn      = __webpack_require__(192);
	
	$export($export.S + $export.F * !__webpack_require__(135)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , $indexOf      = __webpack_require__(129)(false)
	  , $native       = [].indexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /*, fromIndex = 0 */){
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Array', {isArray: __webpack_require__(176)});

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(41)
	  , arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(109) != Object || !__webpack_require__(51)(arrayJoin)), 'Array', {
	  join: function join(separator){
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export       = __webpack_require__(3)
	  , toIObject     = __webpack_require__(41)
	  , toInteger     = __webpack_require__(73)
	  , toLength      = __webpack_require__(24)
	  , $native       = [].lastIndexOf
	  , NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */){
	    // convert -0 to +0
	    if(NEGATIVE_ZERO)return $native.apply(this, arguments) || 0;
	    var O      = toIObject(this)
	      , length = toLength(O.length)
	      , index  = length - 1;
	    if(arguments.length > 1)index = Math.min(index, toInteger(arguments[1]));
	    if(index < 0)index = length + index;
	    for(;index >= 0; index--)if(index in O)if(O[index] === searchElement)return index || 0;
	    return -1;
	  }
	});

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $map    = __webpack_require__(57)(1);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */){
	    return $map(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export        = __webpack_require__(3)
	  , createProperty = __webpack_require__(169);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  function F(){}
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */){
	    var index  = 0
	      , aLen   = arguments.length
	      , result = new (typeof this == 'function' ? this : Array)(aLen);
	    while(aLen > index)createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(253);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $reduce = __webpack_require__(253);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */){
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export    = __webpack_require__(3)
	  , html       = __webpack_require__(173)
	  , cof        = __webpack_require__(49)
	  , toIndex    = __webpack_require__(87)
	  , toLength   = __webpack_require__(24)
	  , arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(13)(function(){
	  if(html)arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end){
	    var len   = toLength(this.length)
	      , klass = cof(this);
	    end = end === undefined ? len : end;
	    if(klass == 'Array')return arraySlice.call(this, begin, end);
	    var start  = toIndex(begin, len)
	      , upTo   = toIndex(end, len)
	      , size   = toLength(upTo - start)
	      , cloned = Array(size)
	      , i      = 0;
	    for(; i < size; i++)cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $some   = __webpack_require__(57)(3);
	
	$export($export.P + $export.F * !__webpack_require__(51)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */){
	    return $some(this, callbackfn, arguments[1]);
	  }
	});

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(37)
	  , toObject  = __webpack_require__(28)
	  , fails     = __webpack_require__(13)
	  , $sort     = [].sort
	  , test      = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function(){
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function(){
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(51)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn){
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(86)('Array');

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Date', {now: function(){ return new Date().getTime(); }});

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(3)
	  , fails   = __webpack_require__(13)
	  , getTime = Date.prototype.getTime;
	
	var lz = function(num){
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (fails(function(){
	  return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	}) || !fails(function(){
	  new Date(NaN).toISOString();
	})), 'Date', {
	  toISOString: function toISOString(){
	    if(!isFinite(getTime.call(this)))throw RangeError('Invalid time value');
	    var d = this
	      , y = d.getUTCFullYear()
	      , m = d.getUTCMilliseconds()
	      , s = y < 0 ? '-' : y > 9999 ? '+' : '';
	    return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	      '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	      'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	      ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	  }
	});

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export     = __webpack_require__(3)
	  , toObject    = __webpack_require__(28)
	  , toPrimitive = __webpack_require__(59);
	
	$export($export.P + $export.F * __webpack_require__(13)(function(){
	  return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({toISOString: function(){ return 1; }}) !== 1;
	}), 'Date', {
	  toJSON: function toJSON(key){
	    var O  = toObject(this)
	      , pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(16)('toPrimitive')
	  , proto        = Date.prototype;
	
	if(!(TO_PRIMITIVE in proto))__webpack_require__(38)(proto, TO_PRIMITIVE, __webpack_require__(660));

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto    = Date.prototype
	  , INVALID_DATE = 'Invalid Date'
	  , TO_STRING    = 'toString'
	  , $toString    = DateProto[TO_STRING]
	  , getTime      = DateProto.getTime;
	if(new Date(NaN) + '' != INVALID_DATE){
	  __webpack_require__(39)(DateProto, TO_STRING, function toString(){
	    var value = getTime.call(this);
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(3);
	
	$export($export.P, 'Function', {bind: __webpack_require__(254)});

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject       = __webpack_require__(15)
	  , getPrototypeOf = __webpack_require__(45)
	  , HAS_INSTANCE   = __webpack_require__(16)('hasInstance')
	  , FunctionProto  = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if(!(HAS_INSTANCE in FunctionProto))__webpack_require__(21).f(FunctionProto, HAS_INSTANCE, {value: function(O){
	  if(typeof this != 'function' || !isObject(O))return false;
	  if(!isObject(this.prototype))return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while(O = getPrototypeOf(O))if(this.prototype === O)return true;
	  return false;
	}});

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(21).f
	  , createDesc = __webpack_require__(72)
	  , has        = __webpack_require__(33)
	  , FProto     = Function.prototype
	  , nameRE     = /^\s*function ([^ (]*)/
	  , NAME       = 'name';
	
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(20) && dP(FProto, NAME, {
	  configurable: true,
	  get: function(){
	    try {
	      var that = this
	        , name = ('' + that).match(nameRE)[1];
	      has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	      return name;
	    } catch(e){
	      return '';
	    }
	  }
	});

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(3)
	  , log1p   = __webpack_require__(262)
	  , sqrt    = Math.sqrt
	  , $acosh  = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x){
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(3)
	  , $asinh  = Math.asinh;
	
	function asinh(x){
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0 
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {asinh: asinh});

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(3)
	  , $atanh  = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0 
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x){
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(3)
	  , sign    = __webpack_require__(180);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x){
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x){
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(3)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x){
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(3)
	  , $expm1  = __webpack_require__(179);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {expm1: $expm1});

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export   = __webpack_require__(3)
	  , sign      = __webpack_require__(180)
	  , pow       = Math.pow
	  , EPSILON   = pow(2, -52)
	  , EPSILON32 = pow(2, -23)
	  , MAX32     = pow(2, 127) * (2 - EPSILON32)
	  , MIN32     = pow(2, -126);
	
	var roundTiesToEven = function(n){
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	
	$export($export.S, 'Math', {
	  fround: function fround(x){
	    var $abs  = Math.abs(x)
	      , $sign = sign(x)
	      , a, result;
	    if($abs < MIN32)return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	    a = (1 + EPSILON32 / EPSILON) * $abs;
	    result = a - (a - $abs);
	    if(result > MAX32 || result != result)return $sign * Infinity;
	    return $sign * result;
	  }
	});

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(3)
	  , abs     = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2){ // eslint-disable-line no-unused-vars
	    var sum  = 0
	      , i    = 0
	      , aLen = arguments.length
	      , larg = 0
	      , arg, div;
	    while(i < aLen){
	      arg = abs(arguments[i++]);
	      if(larg < arg){
	        div  = larg / arg;
	        sum  = sum * div * div + 1;
	        larg = arg;
	      } else if(arg > 0){
	        div  = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(3)
	  , $imul   = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y){
	    var UINT16 = 0xffff
	      , xn = +x
	      , yn = +y
	      , xl = UINT16 & xn
	      , yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log10: function log10(x){
	    return Math.log(x) / Math.LN10;
	  }
	});

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {log1p: __webpack_require__(262)});

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  log2: function log2(x){
	    return Math.log(x) / Math.LN2;
	  }
	});

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {sign: __webpack_require__(180)});

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(179)
	  , exp     = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x){
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(3)
	  , expm1   = __webpack_require__(179)
	  , exp     = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x){
	    var a = expm1(x = +x)
	      , b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it){
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global            = __webpack_require__(10)
	  , has               = __webpack_require__(33)
	  , cof               = __webpack_require__(49)
	  , inheritIfRequired = __webpack_require__(174)
	  , toPrimitive       = __webpack_require__(59)
	  , fails             = __webpack_require__(13)
	  , gOPN              = __webpack_require__(83).f
	  , gOPD              = __webpack_require__(44).f
	  , dP                = __webpack_require__(21).f
	  , $trim             = __webpack_require__(99).trim
	  , NUMBER            = 'Number'
	  , $Number           = global[NUMBER]
	  , Base              = $Number
	  , proto             = $Number.prototype
	  // Opera ~12 has broken Object#toString
	  , BROKEN_COF        = cof(__webpack_require__(82)(proto)) == NUMBER
	  , TRIM              = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function(argument){
	  var it = toPrimitive(argument, false);
	  if(typeof it == 'string' && it.length > 2){
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0)
	      , third, radix, maxCode;
	    if(first === 43 || first === 45){
	      third = it.charCodeAt(2);
	      if(third === 88 || third === 120)return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if(first === 48){
	      switch(it.charCodeAt(1)){
	        case 66 : case 98  : radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79 : case 111 : radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default : return +it;
	      }
	      for(var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++){
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if(code < 48 || code > maxCode)return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if(!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')){
	  $Number = function Number(value){
	    var it = arguments.length < 1 ? 0 : value
	      , that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function(){ proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for(var keys = __webpack_require__(20) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++){
	    if(has(Base, key = keys[j]) && !has($Number, key)){
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(39)(global, NUMBER, $Number);
	}

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {EPSILON: Math.pow(2, -52)});

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export   = __webpack_require__(3)
	  , _isFinite = __webpack_require__(10).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it){
	    return typeof it == 'number' && _isFinite(it);
	  }
	});

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {isInteger: __webpack_require__(259)});

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number){
	    return number != number;
	  }
	});

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export   = __webpack_require__(3)
	  , isInteger = __webpack_require__(259)
	  , abs       = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number){
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MAX_SAFE_INTEGER: 0x1fffffffffffff});

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Number', {MIN_SAFE_INTEGER: -0x1fffffffffffff});

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(269);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {parseFloat: $parseFloat});

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(270);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {parseInt: $parseInt});

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , toInteger    = __webpack_require__(73)
	  , aNumberValue = __webpack_require__(250)
	  , repeat       = __webpack_require__(187)
	  , $toFixed     = 1..toFixed
	  , floor        = Math.floor
	  , data         = [0, 0, 0, 0, 0, 0]
	  , ERROR        = 'Number.toFixed: incorrect invocation!'
	  , ZERO         = '0';
	
	var multiply = function(n, c){
	  var i  = -1
	    , c2 = c;
	  while(++i < 6){
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function(n){
	  var i = 6
	    , c = 0;
	  while(--i >= 0){
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function(){
	  var i = 6
	    , s = '';
	  while(--i >= 0){
	    if(s !== '' || i === 0 || data[i] !== 0){
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function(x, n, acc){
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function(x){
	  var n  = 0
	    , x2 = x;
	  while(x2 >= 4096){
	    n += 12;
	    x2 /= 4096;
	  }
	  while(x2 >= 2){
	    n  += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128..toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(13)(function(){
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits){
	    var x = aNumberValue(this, ERROR)
	      , f = toInteger(fractionDigits)
	      , s = ''
	      , m = ZERO
	      , e, z, j, k;
	    if(f < 0 || f > 20)throw RangeError(ERROR);
	    if(x != x)return 'NaN';
	    if(x <= -1e21 || x >= 1e21)return String(x);
	    if(x < 0){
	      s = '-';
	      x = -x;
	    }
	    if(x > 1e-21){
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if(e > 0){
	        multiply(0, z);
	        j = f;
	        while(j >= 7){
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while(j >= 23){
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if(f > 0){
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $fails       = __webpack_require__(13)
	  , aNumberValue = __webpack_require__(250)
	  , $toPrecision = 1..toPrecision;
	
	$export($export.P + $export.F * ($fails(function(){
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function(){
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision){
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision); 
	  }
	});

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(3);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(263)});

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', {create: __webpack_require__(82)});

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(20), 'Object', {defineProperties: __webpack_require__(264)});

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(20), 'Object', {defineProperty: __webpack_require__(21).f});

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(15)
	  , meta     = __webpack_require__(71).onFreeze;
	
	__webpack_require__(58)('freeze', function($freeze){
	  return function freeze(it){
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject                 = __webpack_require__(41)
	  , $getOwnPropertyDescriptor = __webpack_require__(44).f;
	
	__webpack_require__(58)('getOwnPropertyDescriptor', function(){
	  return function getOwnPropertyDescriptor(it, key){
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(58)('getOwnPropertyNames', function(){
	  return __webpack_require__(265).f;
	});

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject        = __webpack_require__(28)
	  , $getPrototypeOf = __webpack_require__(45);
	
	__webpack_require__(58)('getPrototypeOf', function(){
	  return function getPrototypeOf(it){
	    return $getPrototypeOf(toObject(it));
	  };
	});

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(15);
	
	__webpack_require__(58)('isExtensible', function($isExtensible){
	  return function isExtensible(it){
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});

/***/ },
/* 733 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(15);
	
	__webpack_require__(58)('isFrozen', function($isFrozen){
	  return function isFrozen(it){
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(15);
	
	__webpack_require__(58)('isSealed', function($isSealed){
	  return function isSealed(it){
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});

/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {is: __webpack_require__(271)});

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(28)
	  , $keys    = __webpack_require__(84);
	
	__webpack_require__(58)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(15)
	  , meta     = __webpack_require__(71).onFreeze;
	
	__webpack_require__(58)('preventExtensions', function($preventExtensions){
	  return function preventExtensions(it){
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(15)
	  , meta     = __webpack_require__(71).onFreeze;
	
	__webpack_require__(58)('seal', function($seal){
	  return function seal(it){
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(3);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(182).set});

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(108)
	  , test    = {};
	test[__webpack_require__(16)('toStringTag')] = 'z';
	if(test + '' != '[object z]'){
	  __webpack_require__(39)(Object.prototype, 'toString', function toString(){
	    return '[object ' + classof(this) + ']';
	  }, true);
	}

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var $export     = __webpack_require__(3)
	  , $parseFloat = __webpack_require__(269);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), {parseFloat: $parseFloat});

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , $parseInt = __webpack_require__(270);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), {parseInt: $parseInt});

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(81)
	  , global             = __webpack_require__(10)
	  , ctx                = __webpack_require__(65)
	  , classof            = __webpack_require__(108)
	  , $export            = __webpack_require__(3)
	  , isObject           = __webpack_require__(15)
	  , aFunction          = __webpack_require__(37)
	  , anInstance         = __webpack_require__(80)
	  , forOf              = __webpack_require__(96)
	  , speciesConstructor = __webpack_require__(184)
	  , task               = __webpack_require__(189).set
	  , microtask          = __webpack_require__(181)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(16)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(85)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(98)($Promise, PROMISE);
	__webpack_require__(86)(PROMISE);
	Wrapper = __webpack_require__(64)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(135)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export   = __webpack_require__(3)
	  , aFunction = __webpack_require__(37)
	  , anObject  = __webpack_require__(9)
	  , rApply    = (__webpack_require__(10).Reflect || {}).apply
	  , fApply    = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(13)(function(){
	  rApply(function(){});
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList){
	    var T = aFunction(target)
	      , L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export    = __webpack_require__(3)
	  , create     = __webpack_require__(82)
	  , aFunction  = __webpack_require__(37)
	  , anObject   = __webpack_require__(9)
	  , isObject   = __webpack_require__(15)
	  , fails      = __webpack_require__(13)
	  , bind       = __webpack_require__(254)
	  , rConstruct = (__webpack_require__(10).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function(){
	  function F(){}
	  return !(rConstruct(function(){}, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function(){
	  rConstruct(function(){});
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /*, newTarget*/){
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if(ARGS_BUG && !NEW_TARGET_BUG)return rConstruct(Target, args, newTarget);
	    if(Target == newTarget){
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch(args.length){
	        case 0: return new Target;
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args));
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto    = newTarget.prototype
	      , instance = create(isObject(proto) ? proto : Object.prototype)
	      , result   = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP          = __webpack_require__(21)
	  , $export     = __webpack_require__(3)
	  , anObject    = __webpack_require__(9)
	  , toPrimitive = __webpack_require__(59);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(13)(function(){
	  Reflect.defineProperty(dP.f({}, 1, {value: 1}), 1, {value: 2});
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes){
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export  = __webpack_require__(3)
	  , gOPD     = __webpack_require__(44).f
	  , anObject = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey){
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(9);
	var Enumerate = function(iterated){
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = []       // keys
	    , key;
	  for(key in iterated)keys.push(key);
	};
	__webpack_require__(177)(Enumerate, 'Object', function(){
	  var that = this
	    , keys = that._k
	    , key;
	  do {
	    if(that._i >= keys.length)return {value: undefined, done: true};
	  } while(!((key = keys[that._i++]) in that._t));
	  return {value: key, done: false};
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target){
	    return new Enumerate(target);
	  }
	});

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD     = __webpack_require__(44)
	  , $export  = __webpack_require__(3)
	  , anObject = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export  = __webpack_require__(3)
	  , getProto = __webpack_require__(45)
	  , anObject = __webpack_require__(9);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target){
	    return getProto(anObject(target));
	  }
	});

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD           = __webpack_require__(44)
	  , getPrototypeOf = __webpack_require__(45)
	  , has            = __webpack_require__(33)
	  , $export        = __webpack_require__(3)
	  , isObject       = __webpack_require__(15)
	  , anObject       = __webpack_require__(9);
	
	function get(target, propertyKey/*, receiver*/){
	  var receiver = arguments.length < 3 ? target : arguments[2]
	    , desc, proto;
	  if(anObject(target) === receiver)return target[propertyKey];
	  if(desc = gOPD.f(target, propertyKey))return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if(isObject(proto = getPrototypeOf(target)))return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', {get: get});

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey){
	    return propertyKey in target;
	  }
	});

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export       = __webpack_require__(3)
	  , anObject      = __webpack_require__(9)
	  , $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target){
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Reflect', {ownKeys: __webpack_require__(268)});

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export            = __webpack_require__(3)
	  , anObject           = __webpack_require__(9)
	  , $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target){
	    anObject(target);
	    try {
	      if($preventExtensions)$preventExtensions(target);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export  = __webpack_require__(3)
	  , setProto = __webpack_require__(182);
	
	if(setProto)$export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto){
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch(e){
	      return false;
	    }
	  }
	});

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP             = __webpack_require__(21)
	  , gOPD           = __webpack_require__(44)
	  , getPrototypeOf = __webpack_require__(45)
	  , has            = __webpack_require__(33)
	  , $export        = __webpack_require__(3)
	  , createDesc     = __webpack_require__(72)
	  , anObject       = __webpack_require__(9)
	  , isObject       = __webpack_require__(15);
	
	function set(target, propertyKey, V/*, receiver*/){
	  var receiver = arguments.length < 4 ? target : arguments[3]
	    , ownDesc  = gOPD.f(anObject(target), propertyKey)
	    , existingDescriptor, proto;
	  if(!ownDesc){
	    if(isObject(proto = getPrototypeOf(target))){
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if(has(ownDesc, 'value')){
	    if(ownDesc.writable === false || !isObject(receiver))return false;
	    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	    existingDescriptor.value = V;
	    dP.f(receiver, propertyKey, existingDescriptor);
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', {set: set});

/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var global            = __webpack_require__(10)
	  , inheritIfRequired = __webpack_require__(174)
	  , dP                = __webpack_require__(21).f
	  , gOPN              = __webpack_require__(83).f
	  , isRegExp          = __webpack_require__(134)
	  , $flags            = __webpack_require__(132)
	  , $RegExp           = global.RegExp
	  , Base              = $RegExp
	  , proto             = $RegExp.prototype
	  , re1               = /a/g
	  , re2               = /a/g
	  // "new" creates a new object, old webkit buggy here
	  , CORRECT_NEW       = new $RegExp(re1) !== re1;
	
	if(__webpack_require__(20) && (!CORRECT_NEW || __webpack_require__(13)(function(){
	  re2[__webpack_require__(16)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))){
	  $RegExp = function RegExp(p, f){
	    var tiRE = this instanceof $RegExp
	      , piRE = isRegExp(p)
	      , fiU  = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function(key){
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function(){ return Base[key]; },
	      set: function(it){ Base[key] = it; }
	    });
	  };
	  for(var keys = gOPN(Base), i = 0; keys.length > i; )proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(39)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(86)('RegExp');

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	// @@match logic
	__webpack_require__(131)('match', 1, function(defined, MATCH, $match){
	  // 21.1.3.11 String.prototype.match(regexp)
	  return [function match(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[MATCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	  }, $match];
	});

/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// @@replace logic
	__webpack_require__(131)('replace', 2, function(defined, REPLACE, $replace){
	  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	  return [function replace(searchValue, replaceValue){
	    'use strict';
	    var O  = defined(this)
	      , fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	    return fn !== undefined
	      ? fn.call(searchValue, O, replaceValue)
	      : $replace.call(String(O), searchValue, replaceValue);
	  }, $replace];
	});

/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	// @@search logic
	__webpack_require__(131)('search', 1, function(defined, SEARCH, $search){
	  // 21.1.3.15 String.prototype.search(regexp)
	  return [function search(regexp){
	    'use strict';
	    var O  = defined(this)
	      , fn = regexp == undefined ? undefined : regexp[SEARCH];
	    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	  }, $search];
	});

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	// @@split logic
	__webpack_require__(131)('split', 2, function(defined, SPLIT, $split){
	  'use strict';
	  var isRegExp   = __webpack_require__(134)
	    , _split     = $split
	    , $push      = [].push
	    , $SPLIT     = 'split'
	    , LENGTH     = 'length'
	    , LAST_INDEX = 'lastIndex';
	  if(
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ){
	    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	    // based on es5-shim implementation, need to rework it
	    $split = function(separator, limit){
	      var string = String(this);
	      if(separator === undefined && limit === 0)return [];
	      // If `separator` is not a regex, use native split
	      if(!isRegExp(separator))return _split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var separator2, match, lastIndex, lastLength, i;
	      // Doesn't need flags gy, but they don't hurt
	      if(!NPCG)separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	      while(match = separatorCopy.exec(string)){
	        // `separatorCopy.lastIndex` is not reliable cross-browser
	        lastIndex = match.index + match[0][LENGTH];
	        if(lastIndex > lastLastIndex){
	          output.push(string.slice(lastLastIndex, match.index));
	          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	          if(!NPCG && match[LENGTH] > 1)match[0].replace(separator2, function(){
	            for(i = 1; i < arguments[LENGTH] - 2; i++)if(arguments[i] === undefined)match[i] = undefined;
	          });
	          if(match[LENGTH] > 1 && match.index < string[LENGTH])$push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if(output[LENGTH] >= splitLimit)break;
	        }
	        if(separatorCopy[LAST_INDEX] === match.index)separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if(lastLastIndex === string[LENGTH]){
	        if(lastLength || !separatorCopy.test(''))output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if('0'[$SPLIT](undefined, 0)[LENGTH]){
	    $split = function(separator, limit){
	      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	    };
	  }
	  // 21.1.3.17 String.prototype.split(separator, limit)
	  return [function split(separator, limit){
	    var O  = defined(this)
	      , fn = separator == undefined ? undefined : separator[SPLIT];
	    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	  }, $split];
	});

/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(275);
	var anObject    = __webpack_require__(9)
	  , $flags      = __webpack_require__(132)
	  , DESCRIPTORS = __webpack_require__(20)
	  , TO_STRING   = 'toString'
	  , $toString   = /./[TO_STRING];
	
	var define = function(fn){
	  __webpack_require__(39)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if(__webpack_require__(13)(function(){ return $toString.call({source: 'a', flags: 'b'}) != '/a/b'; })){
	  define(function toString(){
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if($toString.name != TO_STRING){
	  define(function toString(){
	    return $toString.call(this);
	  });
	}

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(40)('anchor', function(createHTML){
	  return function anchor(name){
	    return createHTML(this, 'a', 'name', name);
	  }
	});

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(40)('big', function(createHTML){
	  return function big(){
	    return createHTML(this, 'big', '', '');
	  }
	});

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(40)('blink', function(createHTML){
	  return function blink(){
	    return createHTML(this, 'blink', '', '');
	  }
	});

/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(40)('bold', function(createHTML){
	  return function bold(){
	    return createHTML(this, 'b', '', '');
	  }
	});

/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(185)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export   = __webpack_require__(3)
	  , toLength  = __webpack_require__(24)
	  , context   = __webpack_require__(186)
	  , ENDS_WITH = 'endsWith'
	  , $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(172)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /*, endPosition = @length */){
	    var that = context(this, searchString, ENDS_WITH)
	      , endPosition = arguments.length > 1 ? arguments[1] : undefined
	      , len    = toLength(that.length)
	      , end    = endPosition === undefined ? len : Math.min(toLength(endPosition), len)
	      , search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(40)('fixed', function(createHTML){
	  return function fixed(){
	    return createHTML(this, 'tt', '', '');
	  }
	});

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(40)('fontcolor', function(createHTML){
	  return function fontcolor(color){
	    return createHTML(this, 'font', 'color', color);
	  }
	});

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(40)('fontsize', function(createHTML){
	  return function fontsize(size){
	    return createHTML(this, 'font', 'size', size);
	  }
	});

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	var $export        = __webpack_require__(3)
	  , toIndex        = __webpack_require__(87)
	  , fromCharCode   = String.fromCharCode
	  , $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x){ // eslint-disable-line no-unused-vars
	    var res  = []
	      , aLen = arguments.length
	      , i    = 0
	      , code;
	    while(aLen > i){
	      code = +arguments[i++];
	      if(toIndex(code, 0x10ffff) !== code)throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export  = __webpack_require__(3)
	  , context  = __webpack_require__(186)
	  , INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(172)(INCLUDES), 'String', {
	  includes: function includes(searchString /*, position = 0 */){
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(40)('italics', function(createHTML){
	  return function italics(){
	    return createHTML(this, 'i', '', '');
	  }
	});

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(185)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(178)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(40)('link', function(createHTML){
	  return function link(url){
	    return createHTML(this, 'a', 'href', url);
	  }
	});

/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var $export   = __webpack_require__(3)
	  , toIObject = __webpack_require__(41)
	  , toLength  = __webpack_require__(24);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite){
	    var tpl  = toIObject(callSite.raw)
	      , len  = toLength(tpl.length)
	      , aLen = arguments.length
	      , res  = []
	      , i    = 0;
	    while(len > i){
	      res.push(String(tpl[i++]));
	      if(i < aLen)res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(187)
	});

/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(40)('small', function(createHTML){
	  return function small(){
	    return createHTML(this, 'small', '', '');
	  }
	});

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export     = __webpack_require__(3)
	  , toLength    = __webpack_require__(24)
	  , context     = __webpack_require__(186)
	  , STARTS_WITH = 'startsWith'
	  , $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(172)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /*, position = 0 */){
	    var that   = context(this, searchString, STARTS_WITH)
	      , index  = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length))
	      , search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(40)('strike', function(createHTML){
	  return function strike(){
	    return createHTML(this, 'strike', '', '');
	  }
	});

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(40)('sub', function(createHTML){
	  return function sub(){
	    return createHTML(this, 'sub', '', '');
	  }
	});

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(40)('sup', function(createHTML){
	  return function sup(){
	    return createHTML(this, 'sup', '', '');
	  }
	});

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(99)('trim', function($trim){
	  return function trim(){
	    return $trim(this, 3);
	  };
	});

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(10)
	  , has            = __webpack_require__(33)
	  , DESCRIPTORS    = __webpack_require__(20)
	  , $export        = __webpack_require__(3)
	  , redefine       = __webpack_require__(39)
	  , META           = __webpack_require__(71).KEY
	  , $fails         = __webpack_require__(13)
	  , shared         = __webpack_require__(138)
	  , setToStringTag = __webpack_require__(98)
	  , uid            = __webpack_require__(88)
	  , wks            = __webpack_require__(16)
	  , wksExt         = __webpack_require__(273)
	  , wksDefine      = __webpack_require__(191)
	  , keyOf          = __webpack_require__(662)
	  , enumKeys       = __webpack_require__(661)
	  , isArray        = __webpack_require__(176)
	  , anObject       = __webpack_require__(9)
	  , toIObject      = __webpack_require__(41)
	  , toPrimitive    = __webpack_require__(59)
	  , createDesc     = __webpack_require__(72)
	  , _create        = __webpack_require__(82)
	  , gOPNExt        = __webpack_require__(265)
	  , $GOPD          = __webpack_require__(44)
	  , $DP            = __webpack_require__(21)
	  , $keys          = __webpack_require__(84)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(83).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(110).f  = $propertyIsEnumerable;
	  __webpack_require__(137).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(81)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(38)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export      = __webpack_require__(3)
	  , $typed       = __webpack_require__(139)
	  , buffer       = __webpack_require__(190)
	  , anObject     = __webpack_require__(9)
	  , toIndex      = __webpack_require__(87)
	  , toLength     = __webpack_require__(24)
	  , isObject     = __webpack_require__(15)
	  , ArrayBuffer  = __webpack_require__(10).ArrayBuffer
	  , speciesConstructor = __webpack_require__(184)
	  , $ArrayBuffer = buffer.ArrayBuffer
	  , $DataView    = buffer.DataView
	  , $isView      = $typed.ABV && ArrayBuffer.isView
	  , $slice       = $ArrayBuffer.prototype.slice
	  , VIEW         = $typed.VIEW
	  , ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {ArrayBuffer: $ArrayBuffer});
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it){
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(13)(function(){
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end){
	    if($slice !== undefined && end === undefined)return $slice.call(anObject(this), start); // FF fix
	    var len    = anObject(this).byteLength
	      , first  = toIndex(start, len)
	      , final  = toIndex(end === undefined ? len : end, len)
	      , result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first))
	      , viewS  = new $DataView(this)
	      , viewT  = new $DataView(result)
	      , index  = 0;
	    while(first < final){
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(86)(ARRAY_BUFFER);

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3);
	$export($export.G + $export.W + $export.F * !__webpack_require__(139).ABV, {
	  DataView: __webpack_require__(190).DataView
	});

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Float32', 4, function(init){
	  return function Float32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Float64', 8, function(init){
	  return function Float64Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int16', 2, function(init){
	  return function Int16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int32', 4, function(init){
	  return function Int32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Int8', 1, function(init){
	  return function Int8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint16', 2, function(init){
	  return function Uint16Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint32', 4, function(init){
	  return function Uint32Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint8', 1, function(init){
	  return function Uint8Array(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	});

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(67)('Uint8', 1, function(init){
	  return function Uint8ClampedArray(data, byteOffset, length){
	    return init(this, data, byteOffset, length);
	  };
	}, true);

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(257);
	
	// 23.4 WeakSet Objects
	__webpack_require__(130)('WeakSet', function(get){
	  return function WeakSet(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value){
	    return weak.def(this, value, true);
	  }
	}, weak, false, true);

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export   = __webpack_require__(3)
	  , $includes = __webpack_require__(129)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /*, fromIndex = 0 */){
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(95)('includes');

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export   = __webpack_require__(3)
	  , microtask = __webpack_require__(181)()
	  , process   = __webpack_require__(10).process
	  , isNode    = __webpack_require__(49)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn){
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(3)
	  , cof     = __webpack_require__(49);
	
	$export($export.S, 'Error', {
	  isError: function isError(it){
	    return cof(it) === 'Error';
	  }
	});

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Map', {toJSON: __webpack_require__(256)('Map')});

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >> 16
	      , v1 = $v >> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1){
	    var $x0 = x0 >>> 0
	      , $x1 = x1 >>> 0
	      , $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(3);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v){
	    var UINT16 = 0xffff
	      , $u = +u
	      , $v = +v
	      , u0 = $u & UINT16
	      , v0 = $v & UINT16
	      , u1 = $u >>> 16
	      , v1 = $v >>> 16
	      , t  = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(28)
	  , aFunction       = __webpack_require__(37)
	  , $defineProperty = __webpack_require__(21);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(20) && $export($export.P + __webpack_require__(136), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter){
	    $defineProperty.f(toObject(this), P, {get: aFunction(getter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export         = __webpack_require__(3)
	  , toObject        = __webpack_require__(28)
	  , aFunction       = __webpack_require__(37)
	  , $defineProperty = __webpack_require__(21);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(20) && $export($export.P + __webpack_require__(136), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter){
	    $defineProperty.f(toObject(this), P, {set: aFunction(setter), enumerable: true, configurable: true});
	  }
	});

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export  = __webpack_require__(3)
	  , $entries = __webpack_require__(267)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it){
	    return $entries(it);
	  }
	});

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export        = __webpack_require__(3)
	  , ownKeys        = __webpack_require__(268)
	  , toIObject      = __webpack_require__(41)
	  , gOPD           = __webpack_require__(44)
	  , createProperty = __webpack_require__(169);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object){
	    var O       = toIObject(object)
	      , getDesc = gOPD.f
	      , keys    = ownKeys(O)
	      , result  = {}
	      , i       = 0
	      , key;
	    while(keys.length > i)createProperty(result, key = keys[i++], getDesc(O, key));
	    return result;
	  }
	});

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(28)
	  , toPrimitive              = __webpack_require__(59)
	  , getPrototypeOf           = __webpack_require__(45)
	  , getOwnPropertyDescriptor = __webpack_require__(44).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(20) && $export($export.P + __webpack_require__(136), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.get;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export                  = __webpack_require__(3)
	  , toObject                 = __webpack_require__(28)
	  , toPrimitive              = __webpack_require__(59)
	  , getPrototypeOf           = __webpack_require__(45)
	  , getOwnPropertyDescriptor = __webpack_require__(44).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(20) && $export($export.P + __webpack_require__(136), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P){
	    var O = toObject(this)
	      , K = toPrimitive(P, true)
	      , D;
	    do {
	      if(D = getOwnPropertyDescriptor(O, K))return D.set;
	    } while(O = getPrototypeOf(O));
	  }
	});

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(3)
	  , $values = __webpack_require__(267)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export     = __webpack_require__(3)
	  , global      = __webpack_require__(10)
	  , core        = __webpack_require__(64)
	  , microtask   = __webpack_require__(181)()
	  , OBSERVABLE  = __webpack_require__(16)('observable')
	  , aFunction   = __webpack_require__(37)
	  , anObject    = __webpack_require__(9)
	  , anInstance  = __webpack_require__(80)
	  , redefineAll = __webpack_require__(85)
	  , hide        = __webpack_require__(38)
	  , forOf       = __webpack_require__(96)
	  , RETURN      = forOf.RETURN;
	
	var getMethod = function(fn){
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function(subscription){
	  var cleanup = subscription._c;
	  if(cleanup){
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function(subscription){
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function(subscription){
	  if(!subscriptionClosed(subscription)){
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function(observer, subscriber){
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup      = subscriber(observer)
	      , subscription = cleanup;
	    if(cleanup != null){
	      if(typeof cleanup.unsubscribe === 'function')cleanup = function(){ subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch(e){
	    observer.error(e);
	    return;
	  } if(subscriptionClosed(this))cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe(){ closeSubscription(this); }
	});
	
	var SubscriptionObserver = function(subscription){
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if(m)return m.call(observer, value);
	      } catch(e){
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value){
	    var subscription = this._s;
	    if(subscriptionClosed(subscription))throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if(!m)throw value;
	      value = m.call(observer, value);
	    } catch(e){
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value){
	    var subscription = this._s;
	    if(!subscriptionClosed(subscription)){
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch(e){
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber){
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer){
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn){
	    var that = this;
	    return new (core.Promise || global.Promise)(function(resolve, reject){
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next : function(value){
	          try {
	            return fn(value);
	          } catch(e){
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x){
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if(method){
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function(observer){
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          try {
	            if(forOf(x, false, function(it){
	              observer.next(it);
	              if(done)return RETURN;
	            }) === RETURN)return;
	          } catch(e){
	            if(done)throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  },
	  of: function of(){
	    for(var i = 0, l = arguments.length, items = Array(l); i < l;)items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function(observer){
	      var done = false;
	      microtask(function(){
	        if(!done){
	          for(var i = 0; i < items.length; ++i){
	            observer.next(items[i]);
	            if(done)return;
	          } observer.complete();
	        }
	      });
	      return function(){ done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function(){ return this; });
	
	$export($export.G, {Observable: $Observable});
	
	__webpack_require__(86)('Observable');

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(66)
	  , anObject                  = __webpack_require__(9)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey){
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	}});

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(66)
	  , anObject               = __webpack_require__(9)
	  , toMetaKey              = metadata.key
	  , getOrCreateMetadataMap = metadata.map
	  , store                  = metadata.store;
	
	metadata.exp({deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */){
	  var targetKey   = arguments.length < 3 ? undefined : toMetaKey(arguments[2])
	    , metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if(metadataMap === undefined || !metadataMap['delete'](metadataKey))return false;
	  if(metadataMap.size)return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	}});

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	var Set                     = __webpack_require__(276)
	  , from                    = __webpack_require__(252)
	  , metadata                = __webpack_require__(66)
	  , anObject                = __webpack_require__(9)
	  , getPrototypeOf          = __webpack_require__(45)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	var ordinaryMetadataKeys = function(O, P){
	  var oKeys  = ordinaryOwnMetadataKeys(O, P)
	    , parent = getPrototypeOf(O);
	  if(parent === null)return oKeys;
	  var pKeys  = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({getMetadataKeys: function getMetadataKeys(target /*, targetKey */){
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(66)
	  , anObject               = __webpack_require__(9)
	  , getPrototypeOf         = __webpack_require__(45)
	  , ordinaryHasOwnMetadata = metadata.has
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	var ordinaryGetMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({getMetadata: function getMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                = __webpack_require__(66)
	  , anObject                = __webpack_require__(9)
	  , ordinaryOwnMetadataKeys = metadata.keys
	  , toMetaKey               = metadata.key;
	
	metadata.exp({getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */){
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	}});

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(66)
	  , anObject               = __webpack_require__(9)
	  , ordinaryGetOwnMetadata = metadata.get
	  , toMetaKey              = metadata.key;
	
	metadata.exp({getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(66)
	  , anObject               = __webpack_require__(9)
	  , getPrototypeOf         = __webpack_require__(45)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	var ordinaryHasMetadata = function(MetadataKey, O, P){
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if(hasOwn)return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var metadata               = __webpack_require__(66)
	  , anObject               = __webpack_require__(9)
	  , ordinaryHasOwnMetadata = metadata.has
	  , toMetaKey              = metadata.key;
	
	metadata.exp({hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */){
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	}});

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var metadata                  = __webpack_require__(66)
	  , anObject                  = __webpack_require__(9)
	  , aFunction                 = __webpack_require__(37)
	  , toMetaKey                 = metadata.key
	  , ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({metadata: function metadata(metadataKey, metadataValue){
	  return function decorator(target, targetKey){
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	}});

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export  = __webpack_require__(3);
	
	$export($export.P + $export.R, 'Set', {toJSON: __webpack_require__(256)('Set')});

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(3)
	  , $at     = __webpack_require__(185)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos){
	    return $at(this, pos);
	  }
	});

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export     = __webpack_require__(3)
	  , defined     = __webpack_require__(50)
	  , toLength    = __webpack_require__(24)
	  , isRegExp    = __webpack_require__(134)
	  , getFlags    = __webpack_require__(132)
	  , RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function(regexp, string){
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(177)($RegExpStringIterator, 'RegExp String', function next(){
	  var match = this._r.exec(this._s);
	  return {value: match, done: match === null};
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp){
	    defined(this);
	    if(!isRegExp(regexp))throw TypeError(regexp + ' is not a regexp!');
	    var S     = String(this)
	      , flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp)
	      , rx    = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(272);
	
	$export($export.P, 'String', {
	  padEnd: function padEnd(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(3)
	  , $pad    = __webpack_require__(272);
	
	$export($export.P, 'String', {
	  padStart: function padStart(maxLength /*, fillString = ' ' */){
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(99)('trimLeft', function($trim){
	  return function trimLeft(){
	    return $trim(this, 1);
	  };
	}, 'trimStart');

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(99)('trimRight', function($trim){
	  return function trimRight(){
	    return $trim(this, 2);
	  };
	}, 'trimEnd');

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(191)('asyncIterator');

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(191)('observable');

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-global
	var $export = __webpack_require__(3);
	
	$export($export.S, 'System', {global: __webpack_require__(10)});

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators    = __webpack_require__(193)
	  , redefine      = __webpack_require__(39)
	  , global        = __webpack_require__(10)
	  , hide          = __webpack_require__(38)
	  , Iterators     = __webpack_require__(97)
	  , wks           = __webpack_require__(16)
	  , ITERATOR      = wks('iterator')
	  , TO_STRING_TAG = wks('toStringTag')
	  , ArrayValues   = Iterators.Array;
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype
	    , key;
	  if(proto){
	    if(!proto[ITERATOR])hide(proto, ITERATOR, ArrayValues);
	    if(!proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    for(key in $iterators)if(!proto[key])redefine(proto, key, $iterators[key], true);
	  }
	}

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(3)
	  , $task   = __webpack_require__(189);
	$export($export.G + $export.B, {
	  setImmediate:   $task.set,
	  clearImmediate: $task.clear
	});

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global     = __webpack_require__(10)
	  , $export    = __webpack_require__(3)
	  , invoke     = __webpack_require__(133)
	  , partial    = __webpack_require__(663)
	  , navigator  = global.navigator
	  , MSIE       = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	var wrap = function(set){
	  return MSIE ? function(fn, time /*, ...args */){
	    return set(invoke(
	      partial,
	      [].slice.call(arguments, 2),
	      typeof fn == 'function' ? fn : Function(fn)
	    ), time);
	  } : set;
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout:  wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(786);
	__webpack_require__(725);
	__webpack_require__(727);
	__webpack_require__(726);
	__webpack_require__(729);
	__webpack_require__(731);
	__webpack_require__(736);
	__webpack_require__(730);
	__webpack_require__(728);
	__webpack_require__(738);
	__webpack_require__(737);
	__webpack_require__(733);
	__webpack_require__(734);
	__webpack_require__(732);
	__webpack_require__(724);
	__webpack_require__(735);
	__webpack_require__(739);
	__webpack_require__(740);
	__webpack_require__(692);
	__webpack_require__(694);
	__webpack_require__(693);
	__webpack_require__(742);
	__webpack_require__(741);
	__webpack_require__(712);
	__webpack_require__(722);
	__webpack_require__(723);
	__webpack_require__(713);
	__webpack_require__(714);
	__webpack_require__(715);
	__webpack_require__(716);
	__webpack_require__(717);
	__webpack_require__(718);
	__webpack_require__(719);
	__webpack_require__(720);
	__webpack_require__(721);
	__webpack_require__(695);
	__webpack_require__(696);
	__webpack_require__(697);
	__webpack_require__(698);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(701);
	__webpack_require__(702);
	__webpack_require__(703);
	__webpack_require__(704);
	__webpack_require__(705);
	__webpack_require__(706);
	__webpack_require__(707);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(773);
	__webpack_require__(778);
	__webpack_require__(785);
	__webpack_require__(776);
	__webpack_require__(768);
	__webpack_require__(769);
	__webpack_require__(774);
	__webpack_require__(779);
	__webpack_require__(781);
	__webpack_require__(764);
	__webpack_require__(765);
	__webpack_require__(766);
	__webpack_require__(767);
	__webpack_require__(770);
	__webpack_require__(771);
	__webpack_require__(772);
	__webpack_require__(775);
	__webpack_require__(777);
	__webpack_require__(780);
	__webpack_require__(782);
	__webpack_require__(783);
	__webpack_require__(784);
	__webpack_require__(687);
	__webpack_require__(689);
	__webpack_require__(688);
	__webpack_require__(691);
	__webpack_require__(690);
	__webpack_require__(676);
	__webpack_require__(674);
	__webpack_require__(680);
	__webpack_require__(677);
	__webpack_require__(683);
	__webpack_require__(685);
	__webpack_require__(673);
	__webpack_require__(679);
	__webpack_require__(670);
	__webpack_require__(684);
	__webpack_require__(668);
	__webpack_require__(682);
	__webpack_require__(681);
	__webpack_require__(675);
	__webpack_require__(678);
	__webpack_require__(667);
	__webpack_require__(669);
	__webpack_require__(672);
	__webpack_require__(671);
	__webpack_require__(686);
	__webpack_require__(193);
	__webpack_require__(758);
	__webpack_require__(763);
	__webpack_require__(275);
	__webpack_require__(759);
	__webpack_require__(760);
	__webpack_require__(761);
	__webpack_require__(762);
	__webpack_require__(743);
	__webpack_require__(274);
	__webpack_require__(276);
	__webpack_require__(277);
	__webpack_require__(798);
	__webpack_require__(787);
	__webpack_require__(788);
	__webpack_require__(793);
	__webpack_require__(796);
	__webpack_require__(797);
	__webpack_require__(791);
	__webpack_require__(794);
	__webpack_require__(792);
	__webpack_require__(795);
	__webpack_require__(789);
	__webpack_require__(790);
	__webpack_require__(744);
	__webpack_require__(745);
	__webpack_require__(746);
	__webpack_require__(747);
	__webpack_require__(748);
	__webpack_require__(751);
	__webpack_require__(749);
	__webpack_require__(750);
	__webpack_require__(752);
	__webpack_require__(753);
	__webpack_require__(754);
	__webpack_require__(755);
	__webpack_require__(757);
	__webpack_require__(756);
	__webpack_require__(799);
	__webpack_require__(825);
	__webpack_require__(828);
	__webpack_require__(827);
	__webpack_require__(829);
	__webpack_require__(830);
	__webpack_require__(826);
	__webpack_require__(831);
	__webpack_require__(832);
	__webpack_require__(810);
	__webpack_require__(813);
	__webpack_require__(809);
	__webpack_require__(807);
	__webpack_require__(808);
	__webpack_require__(811);
	__webpack_require__(812);
	__webpack_require__(802);
	__webpack_require__(824);
	__webpack_require__(833);
	__webpack_require__(801);
	__webpack_require__(803);
	__webpack_require__(805);
	__webpack_require__(804);
	__webpack_require__(806);
	__webpack_require__(815);
	__webpack_require__(816);
	__webpack_require__(818);
	__webpack_require__(817);
	__webpack_require__(820);
	__webpack_require__(819);
	__webpack_require__(821);
	__webpack_require__(822);
	__webpack_require__(823);
	__webpack_require__(800);
	__webpack_require__(814);
	__webpack_require__(836);
	__webpack_require__(835);
	__webpack_require__(834);
	module.exports = __webpack_require__(64);

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(845), __esModule: true };

/***/ },
/* 839 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(278)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(279)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	"use strict";
	
	var _Symbol = __webpack_require__(281)["default"];
	
	var _Object$create = __webpack_require__(278)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(279)["default"];
	
	var _Promise = __webpack_require__(280)["default"];
	
	!(function (global) {
	  "use strict";
	
	  var hasOwn = Object.prototype.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof _Symbol === "function" ? _Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided, then outerFn.prototype instanceof Generator.
	    var generator = _Object$create((outerFn || Generator).prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype;
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function (method) {
	      prototype[method] = function (arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function (genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor ? ctor === GeneratorFunction ||
	    // For the native GeneratorFunction constructor, the best we can
	    // do is to check its .name property.
	    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	  };
	
	  runtime.mark = function (genFun) {
	    if (_Object$setPrototypeOf) {
	      _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = _Object$create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `value instanceof AwaitArgument` to determine if the yielded value is
	  // meant to be awaited. Some may consider the name of this method too
	  // cutesy, but they are curmudgeons.
	  runtime.awrap = function (arg) {
	    return new AwaitArgument(arg);
	  };
	
	  function AwaitArgument(arg) {
	    this.arg = arg;
	  }
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value instanceof AwaitArgument) {
	          return _Promise.resolve(value.arg).then(function (value) {
	            invoke("next", value, resolve, reject);
	          }, function (err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return _Promise.resolve(value).then(function (unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new _Promise(function (resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	      // If enqueue has been called before, then we want to wait until
	      // all previous Promises have been resolved before calling invoke,
	      // so that results are always delivered in the correct order. If
	      // enqueue has not been called before, then it is important to
	      // call invoke immediately, without waiting on a callback to fire,
	      // so that the async generator function has the opportunity to do
	      // any necessary setup in a predictable way. This predictability
	      // is why the Promise constructor synchronously invokes its
	      // executor callback, and why async functions synchronously
	      // execute code before the first await. Since we implement simple
	      // async functions in terms of async generators, it is especially
	      // important to get this right, even though it requires care.
	      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	      // Avoid propagating failures to Promises returned by later
	      // invocations of the iterator.
	      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	    : iter.next().then(function (result) {
	      return result.done ? result.value : iter.next();
	    });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	            // A return or throw (when the delegate iterator has no throw
	            // method) always terminates the yield* loop.
	            context.delegate = null;
	
	            // If the delegate iterator has a return method, give it a
	            // chance to clean up.
	            var returnMethod = delegate.iterator["return"];
	            if (returnMethod) {
	              var record = tryCatch(returnMethod, delegate.iterator, arg);
	              if (record.type === "throw") {
	                // If the return method threw an exception, let that
	                // exception prevail over the original return or throw.
	                method = "throw";
	                arg = record.arg;
	                continue;
	              }
	            }
	
	            if (method === "return") {
	              // Continue with the outer return, now that the delegate
	              // iterator has been terminated.
	              continue;
	            }
	          }
	
	          var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	          if (record.type === "throw") {
	            context.delegate = null;
	
	            // Like returning generator.throw(uncaught), but without the
	            // overhead of an extra function call.
	            method = "throw";
	            arg = record.arg;
	            continue;
	          }
	
	          // Delegate generator ran and handled its own exceptions so
	          // regardless of what the method was, we continue as if it is
	          // "next" with an undefined arg.
	          method = "next";
	          arg = undefined;
	
	          var info = record.arg;
	          if (info.done) {
	            context[delegate.resultName] = info.value;
	            context.next = delegate.nextLoc;
	          } else {
	            state = GenStateSuspendedYield;
	            return info;
	          }
	
	          context.delegate = null;
	        }
	
	        if (method === "next") {
	          if (state === GenStateSuspendedYield) {
	            context.sent = arg;
	          } else {
	            context.sent = undefined;
	          }
	        } else if (method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw arg;
	          }
	
	          if (context.dispatchException(arg)) {
	            // If the dispatched exception was caught by a catch block,
	            // then let that catch block handle the exception normally.
	            method = "next";
	            arg = undefined;
	          }
	        } else if (method === "return") {
	          context.abrupt("return", arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	          var info = {
	            value: record.arg,
	            done: context.done
	          };
	
	          if (record.arg === ContinueSentinel) {
	            if (context.delegate && method === "next") {
	              // Deliberately forget the last sent value so that we don't
	              // accidentally pass it on to the delegate.
	              arg = undefined;
	            }
	          } else {
	            return info;
	          }
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(arg) call above.
	          method = "throw";
	          arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[iteratorSymbol] = function () {
	    return this;
	  };
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function () {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function (object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1,
	            next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function reset(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      this.sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function stop() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function dispatchException(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	        return !!caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function abrupt(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.next = finallyEntry.finallyLoc;
	      } else {
	        this.complete(record);
	      }
	
	      return ContinueSentinel;
	    },
	
	    complete: function complete(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" || record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = record.arg;
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	    },
	
	    finish: function finish(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function _catch(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      return ContinueSentinel;
	    }
	  };
	})(
	// Among the various tricks for obtaining a reference to the global
	// object, this seems to be the most reliable technique that does not
	// use indirect eval (which violates Content Security Policy).
	typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : undefined);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(118)))

/***/ },
/* 842 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(842);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 844 */
/***/ function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(877);
	module.exports = __webpack_require__(74).Object.assign;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(42);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(878);
	module.exports = __webpack_require__(74).Object.setPrototypeOf;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(292);
	__webpack_require__(880);
	__webpack_require__(882);
	__webpack_require__(879);
	module.exports = __webpack_require__(74).Promise;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(881);
	__webpack_require__(292);
	module.exports = __webpack_require__(74).Symbol;

/***/ },
/* 850 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(141)
	  , document = __webpack_require__(68).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var $ = __webpack_require__(42);
	module.exports = function(it){
	  var keys       = $.getKeys(it)
	    , getSymbols = $.getSymbols;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = $.isEnum
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))keys.push(key);
	  }
	  return keys;
	};

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(112)
	  , call        = __webpack_require__(859)
	  , isArrayIter = __webpack_require__(857)
	  , anObject    = __webpack_require__(100)
	  , toLength    = __webpack_require__(873)
	  , getIterFn   = __webpack_require__(875);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(143)
	  , getNames  = __webpack_require__(42).getNames
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toIObject(it));
	};

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(68).document && document.documentElement;

/***/ },
/* 856 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(114)
	  , ITERATOR   = __webpack_require__(52)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(111);
	module.exports = Array.isArray || function(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(100);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $              = __webpack_require__(42)
	  , descriptor     = __webpack_require__(202)
	  , setToStringTag = __webpack_require__(142)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(200)(IteratorPrototype, __webpack_require__(52)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(52)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 862 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	var $         = __webpack_require__(42)
	  , toIObject = __webpack_require__(143);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = $.getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(68)
	  , macrotask = __webpack_require__(872).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(111)(process) == 'process'
	  , head, last, notify;
	
	var flush = function(){
	  var parent, domain, fn;
	  if(isNode && (parent = process.domain)){
	    process.domain = null;
	    parent.exit();
	  }
	  while(head){
	    domain = head.domain;
	    fn     = head.fn;
	    if(domain)domain.enter();
	    fn(); // <- currently we use it only for Promise - try / catch not required
	    if(domain)domain.exit();
	    head = head.next;
	  } last = undefined;
	  if(parent)parent.enter();
	};
	
	// Node.js
	if(isNode){
	  notify = function(){
	    process.nextTick(flush);
	  };
	// browsers with MutationObserver
	} else if(Observer){
	  var toggle = 1
	    , node   = document.createTextNode('');
	  new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	  notify = function(){
	    node.data = toggle = -toggle;
	  };
	// environments with maybe non-completely correct, but existent Promise
	} else if(Promise && Promise.resolve){
	  notify = function(){
	    Promise.resolve().then(flush);
	  };
	// for other environments - macrotask based on:
	// - setImmediate
	// - MessageChannel
	// - window.postMessag
	// - onreadystatechange
	// - setTimeout
	} else {
	  notify = function(){
	    // strange IE + webpack dev server bug - use .call(global)
	    macrotask.call(global, flush);
	  };
	}
	
	module.exports = function asap(fn){
	  var task = {fn: fn, next: undefined, domain: isNode && process.domain};
	  if(last)last.next = task;
	  if(!head){
	    head = task;
	    notify();
	  } last = task;
	};

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.1 Object.assign(target, source, ...)
	var $        = __webpack_require__(42)
	  , toObject = __webpack_require__(874)
	  , IObject  = __webpack_require__(286);
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = __webpack_require__(198)(function(){
	  var a = Object.assign
	    , A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return a({}, A)[S] != 7 || Object.keys(a({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , $$    = arguments
	    , $$len = $$.length
	    , index = 1
	    , getKeys    = $.getKeys
	    , getSymbols = $.getSymbols
	    , isEnum     = $.isEnum;
	  while($$len > index){
	    var S      = IObject($$[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  }
	  return T;
	} : Object.assign;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(203);
	module.exports = function(target, src){
	  for(var key in src)redefine(target, key, src[key]);
	  return target;
	};

/***/ },
/* 867 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y){
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var core        = __webpack_require__(74)
	  , $           = __webpack_require__(42)
	  , DESCRIPTORS = __webpack_require__(140)
	  , SPECIES     = __webpack_require__(52)('species');
	
	module.exports = function(KEY){
	  var C = core[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(100)
	  , aFunction = __webpack_require__(196)
	  , SPECIES   = __webpack_require__(52)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 870 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(290)
	  , defined   = __webpack_require__(197);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(112)
	  , invoke             = __webpack_require__(856)
	  , html               = __webpack_require__(855)
	  , cel                = __webpack_require__(851)
	  , global             = __webpack_require__(68)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listner = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(111)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listner;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listner, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(290)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(197);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(285)
	  , ITERATOR  = __webpack_require__(52)('iterator')
	  , Iterators = __webpack_require__(114);
	module.exports = __webpack_require__(74).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(850)
	  , step             = __webpack_require__(862)
	  , Iterators        = __webpack_require__(114)
	  , toIObject        = __webpack_require__(143);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(287)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(113);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(865)});

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(113);
	$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(288).set});

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(42)
	  , LIBRARY    = __webpack_require__(201)
	  , global     = __webpack_require__(68)
	  , ctx        = __webpack_require__(112)
	  , classof    = __webpack_require__(285)
	  , $export    = __webpack_require__(113)
	  , isObject   = __webpack_require__(141)
	  , anObject   = __webpack_require__(100)
	  , aFunction  = __webpack_require__(196)
	  , strictNew  = __webpack_require__(870)
	  , forOf      = __webpack_require__(853)
	  , setProto   = __webpack_require__(288).set
	  , same       = __webpack_require__(867)
	  , SPECIES    = __webpack_require__(52)('species')
	  , speciesConstructor = __webpack_require__(869)
	  , asap       = __webpack_require__(864)
	  , PROMISE    = 'Promise'
	  , process    = global.process
	  , isNode     = classof(process) == 'process'
	  , P          = global[PROMISE]
	  , empty      = function(){ /* empty */ }
	  , Wrapper;
	
	var testResolve = function(sub){
	  var test = new P(empty), promise;
	  if(sub)test.constructor = function(exec){
	    exec(empty, empty);
	  };
	  (promise = P.resolve(test))['catch'](empty);
	  return promise === test;
	};
	
	var USE_NATIVE = function(){
	  var works = false;
	  function P2(x){
	    var self = new P(x);
	    setProto(self, P2.prototype);
	    return self;
	  }
	  try {
	    works = P && P.resolve && testResolve();
	    setProto(P2, P);
	    P2.prototype = $.create(P.prototype, {constructor: {value: P2}});
	    // actual Firefox has broken subclass support, test that
	    if(!(P2.resolve(5).then(function(){}) instanceof P2)){
	      works = false;
	    }
	    // actual V8 bug, https://code.google.com/p/v8/issues/detail?id=4162
	    if(works && __webpack_require__(140)){
	      var thenableThenGotten = false;
	      P.resolve($.setDesc({}, 'then', {
	        get: function(){ thenableThenGotten = true; }
	      }));
	      works = thenableThenGotten;
	    }
	  } catch(e){ works = false; }
	  return works;
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // library wrapper special case
	  if(LIBRARY && a === P && b === Wrapper)return true;
	  return same(a, b);
	};
	var getConstructor = function(C){
	  var S = anObject(C)[SPECIES];
	  return S != undefined ? S : C;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var PromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve),
	  this.reject  = aFunction(reject)
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(record, isReject){
	  if(record.n)return;
	  record.n = true;
	  var chain = record.c;
	  asap(function(){
	    var value = record.v
	      , ok    = record.s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , result, then;
	      try {
	        if(handler){
	          if(!ok)record.h = true;
	          result = handler === true ? value : handler(value);
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    chain.length = 0;
	    record.n = false;
	    if(isReject)setTimeout(function(){
	      var promise = record.p
	        , handler, console;
	      if(isUnhandled(promise)){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      } record.a = undefined;
	    }, 1);
	  });
	};
	var isUnhandled = function(promise){
	  var record = promise._d
	    , chain  = record.a || record.c
	    , i      = 0
	    , reaction;
	  if(record.h)return false;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var $reject = function(value){
	  var record = this;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  record.v = value;
	  record.s = 2;
	  record.a = record.c.slice();
	  notify(record, true);
	};
	var $resolve = function(value){
	  var record = this
	    , then;
	  if(record.d)return;
	  record.d = true;
	  record = record.r || record; // unwrap
	  try {
	    if(record.p === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      asap(function(){
	        var wrapper = {r: record, d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      record.v = value;
	      record.s = 1;
	      notify(record, false);
	    }
	  } catch(e){
	    $reject.call({r: record, d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  P = function Promise(executor){
	    aFunction(executor);
	    var record = this._d = {
	      p: strictNew(this, P, PROMISE),         // <- promise
	      c: [],                                  // <- awaiting reactions
	      a: undefined,                           // <- checked in isUnhandled reactions
	      s: 0,                                   // <- state
	      d: false,                               // <- done
	      v: undefined,                           // <- value
	      h: false,                               // <- handled rejection
	      n: false                                // <- notify
	    };
	    try {
	      executor(ctx($resolve, record, 1), ctx($reject, record, 1));
	    } catch(err){
	      $reject.call(record, err);
	    }
	  };
	  __webpack_require__(866)(P.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction = new PromiseCapability(speciesConstructor(this, P))
	        , promise  = reaction.promise
	        , record   = this._d;
	      reaction.ok   = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      record.c.push(reaction);
	      if(record.a)record.a.push(reaction);
	      if(record.s)notify(record, false);
	      return promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: P});
	__webpack_require__(142)(P, PROMISE);
	__webpack_require__(868)(PROMISE);
	Wrapper = __webpack_require__(74)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = new PromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (!USE_NATIVE || testResolve(true)), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof P && sameConstructor(x.constructor, this))return x;
	    var capability = new PromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(861)(function(iter){
	  P.all(iter)['catch'](function(){});
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject
	      , values     = [];
	    var abrupt = perform(function(){
	      forOf(iterable, false, values.push, values);
	      var remaining = values.length
	        , results   = Array(remaining);
	      if(remaining)$.each.call(values, function(promise, index){
	        var alreadyCalled = false;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled = true;
	          results[index] = value;
	          --remaining || resolve(results);
	        }, reject);
	      });
	      else resolve(results);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = getConstructor(this)
	      , capability = new PromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(871)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(287)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var $              = __webpack_require__(42)
	  , global         = __webpack_require__(68)
	  , has            = __webpack_require__(199)
	  , DESCRIPTORS    = __webpack_require__(140)
	  , $export        = __webpack_require__(113)
	  , redefine       = __webpack_require__(203)
	  , $fails         = __webpack_require__(198)
	  , shared         = __webpack_require__(289)
	  , setToStringTag = __webpack_require__(142)
	  , uid            = __webpack_require__(291)
	  , wks            = __webpack_require__(52)
	  , keyOf          = __webpack_require__(863)
	  , $names         = __webpack_require__(854)
	  , enumKeys       = __webpack_require__(852)
	  , isArray        = __webpack_require__(858)
	  , anObject       = __webpack_require__(100)
	  , toIObject      = __webpack_require__(143)
	  , createDesc     = __webpack_require__(202)
	  , getDesc        = $.getDesc
	  , setDesc        = $.setDesc
	  , _create        = $.create
	  , getNames       = $names.get
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , setter         = false
	  , HIDDEN         = wks('_hidden')
	  , isEnum         = $.isEnum
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , useNative      = typeof $Symbol == 'function'
	  , ObjectProto    = Object.prototype;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(setDesc({}, 'a', {
	    get: function(){ return setDesc(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = getDesc(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  setDesc(it, key, D);
	  if(protoDesc && it !== ObjectProto)setDesc(ObjectProto, key, protoDesc);
	} : setDesc;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol.prototype);
	  sym._k = tag;
	  DESCRIPTORS && setter && setSymbolDesc(ObjectProto, tag, {
	    configurable: true,
	    set: function(value){
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    }
	  });
	  return sym;
	};
	
	var isSymbol = function(it){
	  return typeof it == 'symbol';
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(D && has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))setDesc(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return setDesc(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key);
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key]
	    ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  var D = getDesc(it = toIObject(it), key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(!has(AllSymbols, key = names[i++]) && key != HIDDEN)result.push(key);
	  return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var names  = getNames(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i)if(has(AllSymbols, key = names[i++]))result.push(AllSymbols[key]);
	  return result;
	};
	var $stringify = function stringify(it){
	  if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	  var args = [it]
	    , i    = 1
	    , $$   = arguments
	    , replacer, $replacer;
	  while($$.length > i)args.push($$[i++]);
	  replacer = args[1];
	  if(typeof replacer == 'function')$replacer = replacer;
	  if($replacer || !isArray(replacer))replacer = function(key, value){
	    if($replacer)value = $replacer.call(this, key, value);
	    if(!isSymbol(value))return value;
	  };
	  args[1] = replacer;
	  return _stringify.apply($JSON, args);
	};
	var buggyJSON = $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	});
	
	// 19.4.1.1 Symbol([description])
	if(!useNative){
	  $Symbol = function Symbol(){
	    if(isSymbol(this))throw TypeError('Symbol is not a constructor');
	    return wrap(uid(arguments.length > 0 ? arguments[0] : undefined));
	  };
	  redefine($Symbol.prototype, 'toString', function toString(){
	    return this._k;
	  });
	
	  isSymbol = function(it){
	    return it instanceof $Symbol;
	  };
	
	  $.create     = $create;
	  $.isEnum     = $propertyIsEnumerable;
	  $.getDesc    = $getOwnPropertyDescriptor;
	  $.setDesc    = $defineProperty;
	  $.setDescs   = $defineProperties;
	  $.getNames   = $names.get = $getOwnPropertyNames;
	  $.getSymbols = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(201)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	}
	
	var symbolStatics = {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    return keyOf(SymbolRegistry, key);
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	};
	// 19.4.2.2 Symbol.hasInstance
	// 19.4.2.3 Symbol.isConcatSpreadable
	// 19.4.2.4 Symbol.iterator
	// 19.4.2.6 Symbol.match
	// 19.4.2.8 Symbol.replace
	// 19.4.2.9 Symbol.search
	// 19.4.2.10 Symbol.species
	// 19.4.2.11 Symbol.split
	// 19.4.2.12 Symbol.toPrimitive
	// 19.4.2.13 Symbol.toStringTag
	// 19.4.2.14 Symbol.unscopables
	$.each.call((
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,' +
	  'species,split,toPrimitive,toStringTag,unscopables'
	).split(','), function(it){
	  var sym = wks(it);
	  symbolStatics[it] = useNative ? sym : wrap(sym);
	});
	
	setter = true;
	
	$export($export.G + $export.W, {Symbol: $Symbol});
	
	$export($export.S, 'Symbol', symbolStatics);
	
	$export($export.S + $export.F * !useNative, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!useNative || buggyJSON), 'JSON', {stringify: $stringify});
	
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(876);
	var Iterators = __webpack_require__(114);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(1011);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 885 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 886 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 887 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/eventomania.png?054fc7ac435f7135bf209283527bf7fe";

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/flag-en.png?2878f64a0217a154e531853f6a822c65";

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "src/images/flag-lt.png?46760b0583912bedd79dc3dac9acda56";

/***/ },
/* 892 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(299);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(300);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ },
/* 895 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(205);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(101);
	
	var _DOMUtils = __webpack_require__(146);
	
	var _DOMStateStorage = __webpack_require__(301);
	
	var _PathUtils = __webpack_require__(75);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(205);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(101);
	
	var _PathUtils = __webpack_require__(75);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(206);
	
	var _BrowserProtocol = __webpack_require__(205);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(897);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(146);
	
	var _createHistory = __webpack_require__(207);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(206);
	
	var _DOMUtils = __webpack_require__(146);
	
	var _HashProtocol = __webpack_require__(896);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(207);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(101);
	
	var _PathUtils = __webpack_require__(75);
	
	var _createHistory = __webpack_require__(207);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 901 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var callBound = __webpack_require__(284);
	
	var $toString = callBound('Object.prototype.toString');
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return $toString(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			$toString(value) !== '[object Array]' &&
			$toString(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ },
/* 903 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Coding standard for this project defined @ https://github.com/MatthewSH/standards/blob/master/JavaScript.md
	'use strict';
	
	exports = module.exports = !!(typeof process !== 'undefined' && process.versions && process.versions.node);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(118)))

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBound = __webpack_require__(284);
	var hasSymbols = __webpack_require__(300)();
	var hasToStringTag = hasSymbols && !!Symbol.toStringTag;
	var has;
	var $exec;
	var isRegexMarker;
	var badStringifier;
	
	if (hasToStringTag) {
		has = callBound('Object.prototype.hasOwnProperty');
		$exec = callBound('RegExp.prototype.exec');
		isRegexMarker = {};
	
		var throwRegexMarker = function () {
			throw isRegexMarker;
		};
		badStringifier = {
			toString: throwRegexMarker,
			valueOf: throwRegexMarker
		};
	
		if (typeof Symbol.toPrimitive === 'symbol') {
			badStringifier[Symbol.toPrimitive] = throwRegexMarker;
		}
	}
	
	var $toString = callBound('Object.prototype.toString');
	var gOPD = Object.getOwnPropertyDescriptor;
	var regexClass = '[object RegExp]';
	
	module.exports = hasToStringTag
		// eslint-disable-next-line consistent-return
		? function isRegex(value) {
			if (!value || typeof value !== 'object') {
				return false;
			}
	
			var descriptor = gOPD(value, 'lastIndex');
			var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
			if (!hasLastIndexDataProperty) {
				return false;
			}
	
			try {
				$exec(value, badStringifier);
			} catch (e) {
				return e === isRegexMarker;
			}
		}
		: function isRegex(value) {
			// In older browsers, typeof regex incorrectly returns 'function'
			if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
				return false;
			}
	
			return $toString(value) === regexClass;
		};


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.loadjs = factory();
	  }
	}(this, function() {
	/**
	 * Global dependencies.
	 * @global {Object} document - DOM
	 */
	
	var devnull = function() {},
	    bundleIdCache = {},
	    bundleResultCache = {},
	    bundleCallbackQueue = {};
	
	
	/**
	 * Subscribe to bundle load event.
	 * @param {string[]} bundleIds - Bundle ids
	 * @param {Function} callbackFn - The callback function
	 */
	function subscribe(bundleIds, callbackFn) {
	  // listify
	  bundleIds = bundleIds.push ? bundleIds : [bundleIds];
	
	  var depsNotFound = [],
	      i = bundleIds.length,
	      numWaiting = i,
	      fn,
	      bundleId,
	      r,
	      q;
	
	  // define callback function
	  fn = function (bundleId, pathsNotFound) {
	    if (pathsNotFound.length) depsNotFound.push(bundleId);
	
	    numWaiting--;
	    if (!numWaiting) callbackFn(depsNotFound);
	  };
	
	  // register callback
	  while (i--) {
	    bundleId = bundleIds[i];
	
	    // execute callback if in result cache
	    r = bundleResultCache[bundleId];
	    if (r) {
	      fn(bundleId, r);
	      continue;
	    }
	
	    // add to callback queue
	    q = bundleCallbackQueue[bundleId] = bundleCallbackQueue[bundleId] || [];
	    q.push(fn);
	  }
	}
	
	
	/**
	 * Publish bundle load event.
	 * @param {string} bundleId - Bundle id
	 * @param {string[]} pathsNotFound - List of files not found
	 */
	function publish(bundleId, pathsNotFound) {
	  // exit if id isn't defined
	  if (!bundleId) return;
	
	  var q = bundleCallbackQueue[bundleId];
	
	  // cache result
	  bundleResultCache[bundleId] = pathsNotFound;
	
	  // exit if queue is empty
	  if (!q) return;
	
	  // empty callback queue
	  while (q.length) {
	    q[0](bundleId, pathsNotFound);
	    q.splice(0, 1);
	  }
	}
	
	
	/**
	 * Load individual file.
	 * @param {string} path - The file path
	 * @param {Function} callbackFn - The callback function
	 */
	function loadFile(path, callbackFn, args, numTries) {
	  var doc = document,
	      async = args.async,
	      maxTries = (args.numRetries || 0) + 1,
	      beforeCallbackFn = args.before || devnull,
	      isCss,
	      e;
	
	  numTries = numTries || 0;
	
	  if (/\.css$/.test(path)) {
	    isCss = true;
	
	    // css
	    e = doc.createElement('link');
	    e.rel = 'stylesheet';
	    e.href = path;
	  } else {
	    // javascript
	    e = doc.createElement('script');
	    e.src = path;
	    e.async = async === undefined ? true : async;
	  }
	
	  e.onload = e.onerror = e.onbeforeload = function (ev) {
	    var result = ev.type[0];
	
	    // Note: The following code isolates IE using `hideFocus` and treats empty
	    // stylesheets as failures to get around lack of onerror support
	    if (isCss && 'hideFocus' in e) {
	      try {
	        if (!e.sheet.cssText.length) result = 'e';
	      } catch (x) {
	        // sheets objects created from load errors don't allow access to
	        // `cssText`
	        result = 'e';
	      }
	    }
	
	    // handle retries in case of load failure
	    if (result == 'e') {
	      // increment counter
	      numTries += 1;
	
	      // exit function and try again
	      if (numTries < maxTries) {
	        return loadFile(path, callbackFn, args, numTries);
	      }
	    }
	
	    // execute callback
	    callbackFn(path, result, ev.defaultPrevented);
	  };
	
	  // execute before callback
	  beforeCallbackFn(path, e);
	
	  // add to document
	  doc.head.appendChild(e);
	}
	
	
	/**
	 * Load multiple files.
	 * @param {string[]} paths - The file paths
	 * @param {Function} callbackFn - The callback function
	 */
	function loadFiles(paths, callbackFn, args) {
	  // listify paths
	  paths = paths.push ? paths : [paths];
	
	  var numWaiting = paths.length,
	      x = numWaiting,
	      pathsNotFound = [],
	      fn,
	      i;
	
	  // define callback function
	  fn = function(path, result, defaultPrevented) {
	    // handle error
	    if (result == 'e') pathsNotFound.push(path);
	
	    // handle beforeload event. If defaultPrevented then that means the load
	    // will be blocked (ex. Ghostery/ABP on Safari)
	    if (result == 'b') {
	      if (defaultPrevented) pathsNotFound.push(path);
	      else return;
	    }
	
	    numWaiting--;
	    if (!numWaiting) callbackFn(pathsNotFound);
	  };
	
	  // load scripts
	  for (i=0; i < x; i++) loadFile(paths[i], fn, args);
	}
	
	
	/**
	 * Initiate script load and register bundle.
	 * @param {(string|string[])} paths - The file paths
	 * @param {(string|Function)} [arg1] - The bundleId or success callback
	 * @param {Function} [arg2] - The success or error callback
	 * @param {Function} [arg3] - The error callback
	 */
	function loadjs(paths, arg1, arg2) {
	  var bundleId,
	      args;
	
	  // bundleId (if string)
	  if (arg1 && arg1.trim) bundleId = arg1;
	
	  // args (default is {})
	  args = (bundleId ? arg2 : arg1) || {};
	
	  // throw error if bundle is already defined
	  if (bundleId) {
	    if (bundleId in bundleIdCache) {
	      throw "LoadJS";
	    } else {
	      bundleIdCache[bundleId] = true;
	    }
	  }
	
	  // load scripts
	  loadFiles(paths, function (pathsNotFound) {
	    // success and error callbacks
	    if (pathsNotFound.length) (args.error || devnull)(pathsNotFound);
	    else (args.success || devnull)();
	
	    // publish bundle load event
	    publish(bundleId, pathsNotFound);
	  }, args);
	}
	
	
	/**
	 * Execute callbacks when dependencies have been satisfied.
	 * @param {(string|string[])} deps - List of bundle ids
	 * @param {Object} args - success/error arguments
	 */
	loadjs.ready = function ready(deps, args) {
	  // subscribe to bundle load event
	  subscribe(deps, function (depsNotFound) {
	    // execute callbacks
	    if (depsNotFound.length) (args.error || devnull)(depsNotFound);
	    else (args.success || devnull)();
	  });
	
	  return loadjs;
	};
	
	
	/**
	 * Manually satisfy bundle dependencies.
	 * @param {string} bundleId - The bundle id
	 */
	loadjs.done = function done(bundleId) {
	  publish(bundleId, []);
	};
	
	
	/**
	 * Reset loadjs dependencies statuses
	 */
	loadjs.reset = function reset() {
	  bundleIdCache = {};
	  bundleResultCache = {};
	  bundleCallbackQueue = {};
	};
	
	
	/**
	 * Determine if bundle has already been defined
	 * @param String} bundleId - The bundle id
	 */
	loadjs.isDefined = function isDefined(bundleId) {
	  return bundleId in bundleIdCache;
	};
	
	
	// export
	return loadjs;
	
	}));


/***/ },
/* 907 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ },
/* 908 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(305),
	    isArray = __webpack_require__(908);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(964),
	    hashDelete = __webpack_require__(965),
	    hashGet = __webpack_require__(966),
	    hashHas = __webpack_require__(967),
	    hashSet = __webpack_require__(968);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(211),
	    setCacheAdd = __webpack_require__(989),
	    setCacheHas = __webpack_require__(990);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90),
	    root = __webpack_require__(53);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 916 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 917 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 918 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 919 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(149),
	    keys = __webpack_require__(117);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(149),
	    keysIn = __webpack_require__(339);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(212),
	    arrayEach = __webpack_require__(308),
	    assignValue = __webpack_require__(313),
	    baseAssign = __webpack_require__(920),
	    baseAssignIn = __webpack_require__(921),
	    cloneBuffer = __webpack_require__(943),
	    copyArray = __webpack_require__(950),
	    copySymbols = __webpack_require__(951),
	    copySymbolsIn = __webpack_require__(952),
	    getAllKeys = __webpack_require__(324),
	    getAllKeysIn = __webpack_require__(959),
	    getTag = __webpack_require__(326),
	    initCloneArray = __webpack_require__(969),
	    initCloneByTag = __webpack_require__(970),
	    initCloneObject = __webpack_require__(971),
	    isArray = __webpack_require__(46),
	    isBuffer = __webpack_require__(220),
	    isObject = __webpack_require__(69),
	    keys = __webpack_require__(117);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(955);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 925 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(212),
	    equalArrays = __webpack_require__(322),
	    equalByTag = __webpack_require__(957),
	    equalObjects = __webpack_require__(958),
	    getTag = __webpack_require__(326),
	    isArray = __webpack_require__(46),
	    isBuffer = __webpack_require__(220),
	    isTypedArray = __webpack_require__(338);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(212),
	    baseIsEqual = __webpack_require__(319);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(337),
	    isMasked = __webpack_require__(973),
	    isObject = __webpack_require__(69),
	    toSource = __webpack_require__(333);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isLength = __webpack_require__(221),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(935),
	    baseMatchesProperty = __webpack_require__(936),
	    identity = __webpack_require__(335),
	    isArray = __webpack_require__(46),
	    property = __webpack_require__(1005);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(217),
	    nativeKeys = __webpack_require__(985);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69),
	    isPrototype = __webpack_require__(217),
	    nativeKeysIn = __webpack_require__(986);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(315),
	    isArrayLike = __webpack_require__(153);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(928),
	    getMatchData = __webpack_require__(960),
	    matchesStrictComparable = __webpack_require__(330);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(319),
	    get = __webpack_require__(1000),
	    hasIn = __webpack_require__(1001),
	    isKey = __webpack_require__(216),
	    isStrictComparable = __webpack_require__(328),
	    matchesStrictComparable = __webpack_require__(330),
	    toKey = __webpack_require__(152);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 937 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(317);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 939 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(116),
	    arrayMap = __webpack_require__(310),
	    isArray = __webpack_require__(46),
	    isSymbol = __webpack_require__(154);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 941 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 942 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(53);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)(module)))

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(213);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(916),
	    arrayReduce = __webpack_require__(312),
	    mapToArray = __webpack_require__(329);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 946 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(917),
	    arrayReduce = __webpack_require__(312),
	    setToArray = __webpack_require__(332);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(116);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(213);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 950 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(149),
	    getSymbols = __webpack_require__(215);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(149),
	    getSymbolsIn = __webpack_require__(325);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(153);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 955 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(90);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(116),
	    Uint8Array = __webpack_require__(307),
	    eq = __webpack_require__(218),
	    equalArrays = __webpack_require__(322),
	    mapToArray = __webpack_require__(329),
	    setToArray = __webpack_require__(332);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(324);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(318),
	    getSymbolsIn = __webpack_require__(325),
	    keysIn = __webpack_require__(339);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(328),
	    keys = __webpack_require__(117);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(116);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 962 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(321),
	    isArguments = __webpack_require__(336),
	    isArray = __webpack_require__(46),
	    isIndex = __webpack_require__(327),
	    isLength = __webpack_require__(221),
	    toKey = __webpack_require__(152);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 965 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(151);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 969 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(213),
	    cloneDataView = __webpack_require__(944),
	    cloneMap = __webpack_require__(945),
	    cloneRegExp = __webpack_require__(946),
	    cloneSet = __webpack_require__(947),
	    cloneSymbol = __webpack_require__(948),
	    cloneTypedArray = __webpack_require__(949);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(923),
	    getPrototype = __webpack_require__(214),
	    isPrototype = __webpack_require__(217);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 972 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(953);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 974 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(148);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(148);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(148);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(148);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(911),
	    ListCache = __webpack_require__(147),
	    Map = __webpack_require__(210);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(150);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(150);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(150);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(150);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1003);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(331);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 986 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(323);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(121)(module)))

/***/ },
/* 988 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 989 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 990 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(147);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 992 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 993 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 994 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(147),
	    Map = __webpack_require__(210),
	    MapCache = __webpack_require__(211);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(984);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(922);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	}
	
	module.exports = cloneDeep;


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(999);


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(308),
	    baseEach = __webpack_require__(315),
	    castFunction = __webpack_require__(320),
	    isArray = __webpack_require__(46);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(317);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(925),
	    hasPath = __webpack_require__(963);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(89),
	    isArray = __webpack_require__(46),
	    isObjectLike = __webpack_require__(91);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(211);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(53);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(937),
	    basePropertyDeep = __webpack_require__(938),
	    isKey = __webpack_require__(216),
	    toKey = __webpack_require__(152);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 1006 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(334),
	    isObject = __webpack_require__(69);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(69),
	    isSymbol = __webpack_require__(154);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(940);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 342,
		"./af.js": 342,
		"./ar": 349,
		"./ar-dz": 343,
		"./ar-dz.js": 343,
		"./ar-kw": 344,
		"./ar-kw.js": 344,
		"./ar-ly": 345,
		"./ar-ly.js": 345,
		"./ar-ma": 346,
		"./ar-ma.js": 346,
		"./ar-sa": 347,
		"./ar-sa.js": 347,
		"./ar-tn": 348,
		"./ar-tn.js": 348,
		"./ar.js": 349,
		"./az": 350,
		"./az.js": 350,
		"./be": 351,
		"./be.js": 351,
		"./bg": 352,
		"./bg.js": 352,
		"./bn": 353,
		"./bn.js": 353,
		"./bo": 354,
		"./bo.js": 354,
		"./br": 355,
		"./br.js": 355,
		"./bs": 356,
		"./bs.js": 356,
		"./ca": 357,
		"./ca.js": 357,
		"./cs": 358,
		"./cs.js": 358,
		"./cv": 359,
		"./cv.js": 359,
		"./cy": 360,
		"./cy.js": 360,
		"./da": 361,
		"./da.js": 361,
		"./de": 364,
		"./de-at": 362,
		"./de-at.js": 362,
		"./de-ch": 363,
		"./de-ch.js": 363,
		"./de.js": 364,
		"./dv": 365,
		"./dv.js": 365,
		"./el": 366,
		"./el.js": 366,
		"./en-au": 367,
		"./en-au.js": 367,
		"./en-ca": 368,
		"./en-ca.js": 368,
		"./en-gb": 369,
		"./en-gb.js": 369,
		"./en-ie": 370,
		"./en-ie.js": 370,
		"./en-nz": 371,
		"./en-nz.js": 371,
		"./eo": 372,
		"./eo.js": 372,
		"./es": 374,
		"./es-do": 373,
		"./es-do.js": 373,
		"./es.js": 374,
		"./et": 375,
		"./et.js": 375,
		"./eu": 376,
		"./eu.js": 376,
		"./fa": 377,
		"./fa.js": 377,
		"./fi": 378,
		"./fi.js": 378,
		"./fo": 379,
		"./fo.js": 379,
		"./fr": 382,
		"./fr-ca": 380,
		"./fr-ca.js": 380,
		"./fr-ch": 381,
		"./fr-ch.js": 381,
		"./fr.js": 382,
		"./fy": 383,
		"./fy.js": 383,
		"./gd": 384,
		"./gd.js": 384,
		"./gl": 385,
		"./gl.js": 385,
		"./gom-latn": 386,
		"./gom-latn.js": 386,
		"./he": 387,
		"./he.js": 387,
		"./hi": 388,
		"./hi.js": 388,
		"./hr": 389,
		"./hr.js": 389,
		"./hu": 390,
		"./hu.js": 390,
		"./hy-am": 391,
		"./hy-am.js": 391,
		"./id": 392,
		"./id.js": 392,
		"./is": 393,
		"./is.js": 393,
		"./it": 394,
		"./it.js": 394,
		"./ja": 395,
		"./ja.js": 395,
		"./jv": 396,
		"./jv.js": 396,
		"./ka": 397,
		"./ka.js": 397,
		"./kk": 398,
		"./kk.js": 398,
		"./km": 399,
		"./km.js": 399,
		"./kn": 400,
		"./kn.js": 400,
		"./ko": 401,
		"./ko.js": 401,
		"./ky": 402,
		"./ky.js": 402,
		"./lb": 403,
		"./lb.js": 403,
		"./lo": 404,
		"./lo.js": 404,
		"./lt": 223,
		"./lt.js": 223,
		"./lv": 405,
		"./lv.js": 405,
		"./me": 406,
		"./me.js": 406,
		"./mi": 407,
		"./mi.js": 407,
		"./mk": 408,
		"./mk.js": 408,
		"./ml": 409,
		"./ml.js": 409,
		"./mr": 410,
		"./mr.js": 410,
		"./ms": 412,
		"./ms-my": 411,
		"./ms-my.js": 411,
		"./ms.js": 412,
		"./my": 413,
		"./my.js": 413,
		"./nb": 414,
		"./nb.js": 414,
		"./ne": 415,
		"./ne.js": 415,
		"./nl": 417,
		"./nl-be": 416,
		"./nl-be.js": 416,
		"./nl.js": 417,
		"./nn": 418,
		"./nn.js": 418,
		"./pa-in": 419,
		"./pa-in.js": 419,
		"./pl": 420,
		"./pl.js": 420,
		"./pt": 422,
		"./pt-br": 421,
		"./pt-br.js": 421,
		"./pt.js": 422,
		"./ro": 423,
		"./ro.js": 423,
		"./ru": 424,
		"./ru.js": 424,
		"./sd": 425,
		"./sd.js": 425,
		"./se": 426,
		"./se.js": 426,
		"./si": 427,
		"./si.js": 427,
		"./sk": 428,
		"./sk.js": 428,
		"./sl": 429,
		"./sl.js": 429,
		"./sq": 430,
		"./sq.js": 430,
		"./sr": 432,
		"./sr-cyrl": 431,
		"./sr-cyrl.js": 431,
		"./sr.js": 432,
		"./ss": 433,
		"./ss.js": 433,
		"./sv": 434,
		"./sv.js": 434,
		"./sw": 435,
		"./sw.js": 435,
		"./ta": 436,
		"./ta.js": 436,
		"./te": 437,
		"./te.js": 437,
		"./tet": 438,
		"./tet.js": 438,
		"./th": 439,
		"./th.js": 439,
		"./tl-ph": 440,
		"./tl-ph.js": 440,
		"./tlh": 441,
		"./tlh.js": 441,
		"./tr": 442,
		"./tr.js": 442,
		"./tzl": 443,
		"./tzl.js": 443,
		"./tzm": 445,
		"./tzm-latn": 444,
		"./tzm-latn.js": 444,
		"./tzm.js": 445,
		"./uk": 446,
		"./uk.js": 446,
		"./ur": 447,
		"./ur.js": 447,
		"./uz": 449,
		"./uz-latn": 448,
		"./uz-latn.js": 448,
		"./uz.js": 449,
		"./vi": 450,
		"./vi.js": 450,
		"./x-pseudo": 451,
		"./x-pseudo.js": 451,
		"./yo": 452,
		"./yo.js": 452,
		"./zh-cn": 453,
		"./zh-cn.js": 453,
		"./zh-hk": 454,
		"./zh-hk.js": 454,
		"./zh-tw": 455,
		"./zh-tw.js": 455
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1010;


/***/ },
/* 1011 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000
	var m = s * 60
	var h = m * 60
	var d = h * 24
	var y = d * 365.25
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function (val, options) {
	  options = options || {}
	  var type = typeof val
	  if (type === 'string' && val.length > 0) {
	    return parse(val)
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ?
				fmtLong(val) :
				fmtShort(val)
	  }
	  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val))
	}
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str)
	  if (str.length > 10000) {
	    return
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str)
	  if (!match) {
	    return
	  }
	  var n = parseFloat(match[1])
	  var type = (match[2] || 'ms').toLowerCase()
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n
	    default:
	      return undefined
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd'
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h'
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm'
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's'
	  }
	  return ms + 'ms'
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms'
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's'
	}


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(115);
	var callBind = __webpack_require__(195);
	
	var implementation = __webpack_require__(456);
	var getPolyfill = __webpack_require__(457);
	var shim = __webpack_require__(1013);
	
	var polyfill = callBind(getPolyfill(), Object);
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(457);
	var define = __webpack_require__(115);
	
	module.exports = function shimObjectIs() {
		var polyfill = getPolyfill();
		define(Object, { is: polyfill }, {
			is: function testObjectIs() {
				return Object.is !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(459); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1018);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(460);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(119);
	var assign = __webpack_require__(92);
	
	var ReactPropTypesSecret = __webpack_require__(460);
	var checkPropTypes = __webpack_require__(1015);
	
	var has = Function.call.bind(Object.prototype.hasOwnProperty);
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1192);
	var objectAssign = __webpack_require__(92);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
	
					key = key.replace(/\[\]$/, '');
	
					if (!result || accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 1020 */
/***/ function(module, exports) {

	'use strict';
	
	function RavenConfigError(message) {
	    this.name = 'RavenConfigError';
	    this.message = message;
	}
	RavenConfigError.prototype = new Error();
	RavenConfigError.prototype.constructor = RavenConfigError;
	
	module.exports = RavenConfigError;


/***/ },
/* 1021 */
/***/ function(module, exports) {

	'use strict';
	
	var wrapMethod = function(console, level, callback) {
	    var originalConsoleLevel = console[level];
	    var originalConsole = console;
	
	    if (!(level in console)) {
	        return;
	    }
	
	    var sentryLevel = level === 'warn'
	        ? 'warning'
	        : level;
	
	    console[level] = function () {
	        var args = [].slice.call(arguments);
	
	        var msg = '' + args.join(' ');
	        var data = {level: sentryLevel, logger: 'console', extra: {'arguments': args}};
	        callback && callback(msg, data);
	
	        // this fails for some browsers. :(
	        if (originalConsoleLevel) {
	            // IE9 doesn't allow calling apply on console functions directly
	            // See: https://stackoverflow.com/questions/5472938/does-ie9-support-console-log-and-is-it-a-real-function#answer-5473193
	            Function.prototype.apply.call(
	                originalConsoleLevel,
	                originalConsole,
	                args
	            );
	        }
	    };
	};
	
	module.exports = {
	    wrapMethod: wrapMethod
	};


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*global XDomainRequest:false, __DEV__:false*/
	'use strict';
	
	var TraceKit = __webpack_require__(1024);
	var stringify = __webpack_require__(1025);
	var RavenConfigError = __webpack_require__(1020);
	var utils = __webpack_require__(461);
	
	var isError = utils.isError,
	    isObject = utils.isObject;
	
	var wrapConsoleMethod = __webpack_require__(1021).wrapMethod;
	
	var dsnKeys = 'source protocol user pass host port path'.split(' '),
	    dsnPattern = /^(?:(\w+):)?\/\/(?:(\w+)(:\w+)?@)?([\w\.-]+)(?::(\d+))?(\/.*)/;
	
	function now() {
	    return +new Date();
	}
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	var _document = _window.document;
	var _navigator = _window.navigator;
	
	// First, check for JSON support
	// If there is no JSON, we no-op the core features of Raven
	// since JSON is required to encode the payload
	function Raven() {
	    this._hasJSON = !!(typeof JSON === 'object' && JSON.stringify);
	    // Raven can run in contexts where there's no document (react-native)
	    this._hasDocument = !isUndefined(_document);
	    this._hasNavigator = !isUndefined(_navigator);
	    this._lastCapturedException = null;
	    this._lastData = null;
	    this._lastEventId = null;
	    this._globalServer = null;
	    this._globalKey = null;
	    this._globalProject = null;
	    this._globalContext = {};
	    this._globalOptions = {
	        logger: 'javascript',
	        ignoreErrors: [],
	        ignoreUrls: [],
	        whitelistUrls: [],
	        includePaths: [],
	        crossOrigin: 'anonymous',
	        collectWindowErrors: true,
	        maxMessageLength: 0,
	        stackTraceLimit: 50,
	        autoBreadcrumbs: true,
	        sampleRate: 1
	    };
	    this._ignoreOnError = 0;
	    this._isRavenInstalled = false;
	    this._originalErrorStackTraceLimit = Error.stackTraceLimit;
	    // capture references to window.console *and* all its methods first
	    // before the console plugin has a chance to monkey patch
	    this._originalConsole = _window.console || {};
	    this._originalConsoleMethods = {};
	    this._plugins = [];
	    this._startTime = now();
	    this._wrappedBuiltIns = [];
	    this._breadcrumbs = [];
	    this._lastCapturedEvent = null;
	    this._keypressTimeout;
	    this._location = _window.location;
	    this._lastHref = this._location && this._location.href;
	    this._resetBackoff();
	
	    for (var method in this._originalConsole) {  // eslint-disable-line guard-for-in
	      this._originalConsoleMethods[method] = this._originalConsole[method];
	    }
	}
	
	/*
	 * The core Raven singleton
	 *
	 * @this {Raven}
	 */
	
	Raven.prototype = {
	    // Hardcode version string so that raven source can be loaded directly via
	    // webpack (using a build step causes webpack #1617). Grunt verifies that
	    // this value matches package.json during build.
	    //   See: https://github.com/getsentry/raven-js/issues/465
	    VERSION: '3.13.1',
	
	    debug: false,
	
	    TraceKit: TraceKit, // alias to TraceKit
	
	    /*
	     * Configure Raven with a DSN and extra options
	     *
	     * @param {string} dsn The public Sentry DSN
	     * @param {object} options Optional set of of global options [optional]
	     * @return {Raven}
	     */
	    config: function(dsn, options) {
	        var self = this;
	
	        if (self._globalServer) {
	                this._logDebug('error', 'Error: Raven has already been configured');
	            return self;
	        }
	        if (!dsn) return self;
	
	        var globalOptions = self._globalOptions;
	
	        // merge in options
	        if (options) {
	            each(options, function(key, value){
	                // tags and extra are special and need to be put into context
	                if (key === 'tags' || key === 'extra' || key === 'user') {
	                    self._globalContext[key] = value;
	                } else {
	                    globalOptions[key] = value;
	                }
	            });
	        }
	
	        self.setDSN(dsn);
	
	        // "Script error." is hard coded into browsers for errors that it can't read.
	        // this is the result of a script being pulled in from an external domain and CORS.
	        globalOptions.ignoreErrors.push(/^Script error\.?$/);
	        globalOptions.ignoreErrors.push(/^Javascript error: Script error\.? on line 0$/);
	
	        // join regexp rules into one big rule
	        globalOptions.ignoreErrors = joinRegExp(globalOptions.ignoreErrors);
	        globalOptions.ignoreUrls = globalOptions.ignoreUrls.length ? joinRegExp(globalOptions.ignoreUrls) : false;
	        globalOptions.whitelistUrls = globalOptions.whitelistUrls.length ? joinRegExp(globalOptions.whitelistUrls) : false;
	        globalOptions.includePaths = joinRegExp(globalOptions.includePaths);
	        globalOptions.maxBreadcrumbs = Math.max(0, Math.min(globalOptions.maxBreadcrumbs || 100, 100)); // default and hard limit is 100
	
	        var autoBreadcrumbDefaults = {
	            xhr: true,
	            console: true,
	            dom: true,
	            location: true
	        };
	
	        var autoBreadcrumbs = globalOptions.autoBreadcrumbs;
	        if ({}.toString.call(autoBreadcrumbs) === '[object Object]') {
	            autoBreadcrumbs = objectMerge(autoBreadcrumbDefaults, autoBreadcrumbs);
	        } else if (autoBreadcrumbs !== false) {
	            autoBreadcrumbs = autoBreadcrumbDefaults;
	        }
	        globalOptions.autoBreadcrumbs = autoBreadcrumbs;
	
	        TraceKit.collectWindowErrors = !!globalOptions.collectWindowErrors;
	
	        // return for chaining
	        return self;
	    },
	
	    /*
	     * Installs a global window.onerror error handler
	     * to capture and report uncaught exceptions.
	     * At this point, install() is required to be called due
	     * to the way TraceKit is set up.
	     *
	     * @return {Raven}
	     */
	    install: function() {
	        var self = this;
	        if (self.isSetup() && !self._isRavenInstalled) {
	            TraceKit.report.subscribe(function () {
	                self._handleOnErrorStackInfo.apply(self, arguments);
	            });
	            self._instrumentTryCatch();
	            if (self._globalOptions.autoBreadcrumbs)
	                self._instrumentBreadcrumbs();
	
	            // Install all of the plugins
	            self._drainPlugins();
	
	            self._isRavenInstalled = true;
	        }
	
	        Error.stackTraceLimit = self._globalOptions.stackTraceLimit;
	        return this;
	    },
	
	    /*
	     * Set the DSN (can be called multiple time unlike config)
	     *
	     * @param {string} dsn The public Sentry DSN
	     */
	    setDSN: function(dsn) {
	        var self = this,
	            uri = self._parseDSN(dsn),
	          lastSlash = uri.path.lastIndexOf('/'),
	          path = uri.path.substr(1, lastSlash);
	
	        self._dsn = dsn;
	        self._globalKey = uri.user;
	        self._globalSecret = uri.pass && uri.pass.substr(1);
	        self._globalProject = uri.path.substr(lastSlash + 1);
	
	        self._globalServer = self._getGlobalServer(uri);
	
	        self._globalEndpoint = self._globalServer +
	            '/' + path + 'api/' + self._globalProject + '/store/';
	
	        // Reset backoff state since we may be pointing at a
	        // new project/server
	        this._resetBackoff();
	    },
	
	    /*
	     * Wrap code within a context so Raven can capture errors
	     * reliably across domains that is executed immediately.
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The callback to be immediately executed within the context
	     * @param {array} args An array of arguments to be called with the callback [optional]
	     */
	    context: function(options, func, args) {
	        if (isFunction(options)) {
	            args = func || [];
	            func = options;
	            options = undefined;
	        }
	
	        return this.wrap(options, func).apply(this, args);
	    },
	
	    /*
	     * Wrap code within a context and returns back a new function to be executed
	     *
	     * @param {object} options A specific set of options for this context [optional]
	     * @param {function} func The function to be wrapped in a new context
	     * @param {function} func A function to call before the try/catch wrapper [optional, private]
	     * @return {function} The newly wrapped functions with a context
	     */
	    wrap: function(options, func, _before) {
	        var self = this;
	        // 1 argument has been passed, and it's not a function
	        // so just return it
	        if (isUndefined(func) && !isFunction(options)) {
	            return options;
	        }
	
	        // options is optional
	        if (isFunction(options)) {
	            func = options;
	            options = undefined;
	        }
	
	        // At this point, we've passed along 2 arguments, and the second one
	        // is not a function either, so we'll just return the second argument.
	        if (!isFunction(func)) {
	            return func;
	        }
	
	        // We don't wanna wrap it twice!
	        try {
	            if (func.__raven__) {
	                return func;
	            }
	
	            // If this has already been wrapped in the past, return that
	            if (func.__raven_wrapper__ ){
	                return func.__raven_wrapper__ ;
	            }
	        } catch (e) {
	            // Just accessing custom props in some Selenium environments
	            // can cause a "Permission denied" exception (see raven-js#495).
	            // Bail on wrapping and return the function as-is (defers to window.onerror).
	            return func;
	        }
	
	        function wrapped() {
	            var args = [], i = arguments.length,
	                deep = !options || options && options.deep !== false;
	
	            if (_before && isFunction(_before)) {
	                _before.apply(this, arguments);
	            }
	
	            // Recursively wrap all of a function's arguments that are
	            // functions themselves.
	            while(i--) args[i] = deep ? self.wrap(options, arguments[i]) : arguments[i];
	
	            try {
	                // Attempt to invoke user-land function
	                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
	                //       means Raven caught an error invoking your application code. This is
	                //       expected behavior and NOT indicative of a bug with Raven.js.
	                return func.apply(this, args);
	            } catch(e) {
	                self._ignoreNextOnError();
	                self.captureException(e, options);
	                throw e;
	            }
	        }
	
	        // copy over properties of the old function
	        for (var property in func) {
	            if (hasKey(func, property)) {
	                wrapped[property] = func[property];
	            }
	        }
	        wrapped.prototype = func.prototype;
	
	        func.__raven_wrapper__ = wrapped;
	        // Signal that this function has been wrapped already
	        // for both debugging and to prevent it to being wrapped twice
	        wrapped.__raven__ = true;
	        wrapped.__inner__ = func;
	
	        return wrapped;
	    },
	
	    /*
	     * Uninstalls the global error handler.
	     *
	     * @return {Raven}
	     */
	    uninstall: function() {
	        TraceKit.report.uninstall();
	
	        this._restoreBuiltIns();
	
	        Error.stackTraceLimit = this._originalErrorStackTraceLimit;
	        this._isRavenInstalled = false;
	
	        return this;
	    },
	
	    /*
	     * Manually capture an exception and send it over to Sentry
	     *
	     * @param {error} ex An exception to be logged
	     * @param {object} options A specific set of options for this error [optional]
	     * @return {Raven}
	     */
	    captureException: function(ex, options) {
	        // If not an Error is passed through, recall as a message instead
	        if (!isError(ex)) {
	            return this.captureMessage(ex, objectMerge({
	                trimHeadFrames: 1,
	                stacktrace: true // if we fall back to captureMessage, default to attempting a new trace
	            }, options));
	        }
	
	        // Store the raw exception object for potential debugging and introspection
	        this._lastCapturedException = ex;
	
	        // TraceKit.report will re-raise any exception passed to it,
	        // which means you have to wrap it in try/catch. Instead, we
	        // can wrap it here and only re-raise if TraceKit.report
	        // raises an exception different from the one we asked to
	        // report on.
	        try {
	            var stack = TraceKit.computeStackTrace(ex);
	            this._handleStackInfo(stack, options);
	        } catch(ex1) {
	            if(ex !== ex1) {
	                throw ex1;
	            }
	        }
	
	        return this;
	    },
	
	    /*
	     * Manually send a message to Sentry
	     *
	     * @param {string} msg A plain message to be captured in Sentry
	     * @param {object} options A specific set of options for this message [optional]
	     * @return {Raven}
	     */
	    captureMessage: function(msg, options) {
	        // config() automagically converts ignoreErrors from a list to a RegExp so we need to test for an
	        // early call; we'll error on the side of logging anything called before configuration since it's
	        // probably something you should see:
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(msg)) {
	            return;
	        }
	
	        options = options || {};
	
	        var data = objectMerge({
	            message: msg + ''  // Make sure it's actually a string
	        }, options);
	
	        if (this._globalOptions.stacktrace || (options && options.stacktrace)) {
	            var ex;
	            // create a stack trace from this point; just trim
	            // off extra frames so they don't include this function call (or
	            // earlier Raven.js library fn calls)
	            try {
	                throw new Error(msg);
	            } catch (ex1) {
	                ex = ex1;
	            }
	
	            // null exception name so `Error` isn't prefixed to msg
	            ex.name = null;
	
	            options = objectMerge({
	                // fingerprint on msg, not stack trace (legacy behavior, could be
	                // revisited)
	                fingerprint: msg,
	                trimHeadFrames: (options.trimHeadFrames || 0) + 1
	            }, options);
	
	            var stack = TraceKit.computeStackTrace(ex);
	            var frames = this._prepareFrames(stack, options);
	            data.stacktrace = {
	                // Sentry expects frames oldest to newest
	                frames: frames.reverse()
	            }
	        }
	
	        // Fire away!
	        this._send(data);
	
	        return this;
	    },
	
	    captureBreadcrumb: function (obj) {
	        var crumb = objectMerge({
	            timestamp: now() / 1000
	        }, obj);
	
	        if (isFunction(this._globalOptions.breadcrumbCallback)) {
	            var result = this._globalOptions.breadcrumbCallback(crumb);
	
	            if (isObject(result) && !isEmptyObject(result)) {
	                crumb = result;
	            } else if (result === false) {
	                return this;
	            }
	        }
	
	        this._breadcrumbs.push(crumb);
	        if (this._breadcrumbs.length > this._globalOptions.maxBreadcrumbs) {
	            this._breadcrumbs.shift();
	        }
	        return this;
	    },
	
	    addPlugin: function(plugin /*arg1, arg2, ... argN*/) {
	        var pluginArgs = [].slice.call(arguments, 1);
	
	        this._plugins.push([plugin, pluginArgs]);
	        if (this._isRavenInstalled) {
	            this._drainPlugins();
	        }
	
	        return this;
	    },
	
	    /*
	     * Set/clear a user to be sent along with the payload.
	     *
	     * @param {object} user An object representing user data [optional]
	     * @return {Raven}
	     */
	    setUserContext: function(user) {
	        // Intentionally do not merge here since that's an unexpected behavior.
	        this._globalContext.user = user;
	
	        return this;
	    },
	
	    /*
	     * Merge extra attributes to be sent along with the payload.
	     *
	     * @param {object} extra An object representing extra data [optional]
	     * @return {Raven}
	     */
	    setExtraContext: function(extra) {
	        this._mergeContext('extra', extra);
	
	        return this;
	    },
	
	    /*
	     * Merge tags to be sent along with the payload.
	     *
	     * @param {object} tags An object representing tags [optional]
	     * @return {Raven}
	     */
	    setTagsContext: function(tags) {
	        this._mergeContext('tags', tags);
	
	        return this;
	    },
	
	    /*
	     * Clear all of the context.
	     *
	     * @return {Raven}
	     */
	    clearContext: function() {
	        this._globalContext = {};
	
	        return this;
	    },
	
	    /*
	     * Get a copy of the current context. This cannot be mutated.
	     *
	     * @return {object} copy of context
	     */
	    getContext: function() {
	        // lol javascript
	        return JSON.parse(stringify(this._globalContext));
	    },
	
	
	    /*
	     * Set environment of application
	     *
	     * @param {string} environment Typically something like 'production'.
	     * @return {Raven}
	     */
	    setEnvironment: function(environment) {
	        this._globalOptions.environment = environment;
	
	        return this;
	    },
	
	    /*
	     * Set release version of application
	     *
	     * @param {string} release Typically something like a git SHA to identify version
	     * @return {Raven}
	     */
	    setRelease: function(release) {
	        this._globalOptions.release = release;
	
	        return this;
	    },
	
	    /*
	     * Set the dataCallback option
	     *
	     * @param {function} callback The callback to run which allows the
	     *                            data blob to be mutated before sending
	     * @return {Raven}
	     */
	    setDataCallback: function(callback) {
	        var original = this._globalOptions.dataCallback;
	        this._globalOptions.dataCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the breadcrumbCallback option
	     *
	     * @param {function} callback The callback to run which allows filtering
	     *                            or mutating breadcrumbs
	     * @return {Raven}
	     */
	    setBreadcrumbCallback: function(callback) {
	        var original = this._globalOptions.breadcrumbCallback;
	        this._globalOptions.breadcrumbCallback = isFunction(callback)
	          ? function (data) { return callback(data, original); }
	          : callback;
	
	        return this;
	    },
	
	    /*
	     * Set the shouldSendCallback option
	     *
	     * @param {function} callback The callback to run which allows
	     *                            introspecting the blob before sending
	     * @return {Raven}
	     */
	    setShouldSendCallback: function(callback) {
	        var original = this._globalOptions.shouldSendCallback;
	        this._globalOptions.shouldSendCallback = isFunction(callback)
	            ? function (data) { return callback(data, original); }
	            : callback;
	
	        return this;
	    },
	
	    /**
	     * Override the default HTTP transport mechanism that transmits data
	     * to the Sentry server.
	     *
	     * @param {function} transport Function invoked instead of the default
	     *                             `makeRequest` handler.
	     *
	     * @return {Raven}
	     */
	    setTransport: function(transport) {
	        this._globalOptions.transport = transport;
	
	        return this;
	    },
	
	    /*
	     * Get the latest raw exception that was captured by Raven.
	     *
	     * @return {error}
	     */
	    lastException: function() {
	        return this._lastCapturedException;
	    },
	
	    /*
	     * Get the last event id
	     *
	     * @return {string}
	     */
	    lastEventId: function() {
	        return this._lastEventId;
	    },
	
	    /*
	     * Determine if Raven is setup and ready to go.
	     *
	     * @return {boolean}
	     */
	    isSetup: function() {
	        if (!this._hasJSON) return false;  // needs JSON support
	        if (!this._globalServer) {
	            if (!this.ravenNotConfiguredError) {
	              this.ravenNotConfiguredError = true;
	              this._logDebug('error', 'Error: Raven has not been configured.');
	            }
	            return false;
	        }
	        return true;
	    },
	
	    afterLoad: function () {
	        // TODO: remove window dependence?
	
	        // Attempt to initialize Raven on load
	        var RavenConfig = _window.RavenConfig;
	        if (RavenConfig) {
	            this.config(RavenConfig.dsn, RavenConfig.config).install();
	        }
	    },
	
	    showReportDialog: function (options) {
	        if (!_document) // doesn't work without a document (React native)
	            return;
	
	        options = options || {};
	
	        var lastEventId = options.eventId || this.lastEventId();
	        if (!lastEventId) {
	            throw new RavenConfigError('Missing eventId');
	        }
	
	        var dsn = options.dsn || this._dsn;
	        if (!dsn) {
	            throw new RavenConfigError('Missing DSN');
	        }
	
	        var encode = encodeURIComponent;
	        var qs = '';
	        qs += '?eventId=' + encode(lastEventId);
	        qs += '&dsn=' + encode(dsn);
	
	        var user = options.user || this._globalContext.user;
	        if (user) {
	            if (user.name)  qs += '&name=' + encode(user.name);
	            if (user.email) qs += '&email=' + encode(user.email);
	        }
	
	        var globalServer = this._getGlobalServer(this._parseDSN(dsn));
	
	        var script = _document.createElement('script');
	        script.async = true;
	        script.src = globalServer + '/api/embed/error-page/' + qs;
	        (_document.head || _document.body).appendChild(script);
	    },
	
	    /**** Private functions ****/
	    _ignoreNextOnError: function () {
	        var self = this;
	        this._ignoreOnError += 1;
	        setTimeout(function () {
	            // onerror should trigger before setTimeout
	            self._ignoreOnError -= 1;
	        });
	    },
	
	    _triggerEvent: function(eventType, options) {
	        // NOTE: `event` is a native browser thing, so let's avoid conflicting wiht it
	        var evt, key;
	
	        if (!this._hasDocument)
	            return;
	
	        options = options || {};
	
	        eventType = 'raven' + eventType.substr(0,1).toUpperCase() + eventType.substr(1);
	
	        if (_document.createEvent) {
	            evt = _document.createEvent('HTMLEvents');
	            evt.initEvent(eventType, true, true);
	        } else {
	            evt = _document.createEventObject();
	            evt.eventType = eventType;
	        }
	
	        for (key in options) if (hasKey(options, key)) {
	            evt[key] = options[key];
	        }
	
	        if (_document.createEvent) {
	            // IE9 if standards
	            _document.dispatchEvent(evt);
	        } else {
	            // IE8 regardless of Quirks or Standards
	            // IE9 if quirks
	            try {
	                _document.fireEvent('on' + evt.eventType.toLowerCase(), evt);
	            } catch(e) {
	                // Do nothing
	            }
	        }
	    },
	
	    /**
	     * Wraps addEventListener to capture UI breadcrumbs
	     * @param evtName the event name (e.g. "click")
	     * @returns {Function}
	     * @private
	     */
	    _breadcrumbEventHandler: function(evtName) {
	        var self = this;
	        return function (evt) {
	            // reset keypress timeout; e.g. triggering a 'click' after
	            // a 'keypress' will reset the keypress debounce so that a new
	            // set of keypresses can be recorded
	            self._keypressTimeout = null;
	
	            // It's possible this handler might trigger multiple times for the same
	            // event (e.g. event propagation through node ancestors). Ignore if we've
	            // already captured the event.
	            if (self._lastCapturedEvent === evt)
	                return;
	
	            self._lastCapturedEvent = evt;
	
	            // try/catch both:
	            // - accessing evt.target (see getsentry/raven-js#838, #768)
	            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
	            //   can throw an exception in some circumstances.
	            var target;
	            try {
	                target = htmlTreeAsString(evt.target);
	            } catch (e) {
	                target = '<unknown>';
	            }
	
	            self.captureBreadcrumb({
	                category: 'ui.' + evtName, // e.g. ui.click, ui.input
	                message: target
	            });
	        };
	    },
	
	    /**
	     * Wraps addEventListener to capture keypress UI events
	     * @returns {Function}
	     * @private
	     */
	    _keypressEventHandler: function() {
	        var self = this,
	            debounceDuration = 1000; // milliseconds
	
	        // TODO: if somehow user switches keypress target before
	        //       debounce timeout is triggered, we will only capture
	        //       a single breadcrumb from the FIRST target (acceptable?)
	        return function (evt) {
	            var target;
	            try {
	                target = evt.target;
	            } catch (e) {
	                // just accessing event properties can throw an exception in some rare circumstances
	                // see: https://github.com/getsentry/raven-js/issues/838
	                return;
	            }
	            var tagName = target && target.tagName;
	
	            // only consider keypress events on actual input elements
	            // this will disregard keypresses targeting body (e.g. tabbing
	            // through elements, hotkeys, etc)
	            if (!tagName || tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)
	                return;
	
	            // record first keypress in a series, but ignore subsequent
	            // keypresses until debounce clears
	            var timeout = self._keypressTimeout;
	            if (!timeout) {
	                self._breadcrumbEventHandler('input')(evt);
	            }
	            clearTimeout(timeout);
	            self._keypressTimeout = setTimeout(function () {
	                self._keypressTimeout = null;
	            }, debounceDuration);
	        };
	    },
	
	    /**
	     * Captures a breadcrumb of type "navigation", normalizing input URLs
	     * @param to the originating URL
	     * @param from the target URL
	     * @private
	     */
	    _captureUrlChange: function(from, to) {
	        var parsedLoc = parseUrl(this._location.href);
	        var parsedTo = parseUrl(to);
	        var parsedFrom = parseUrl(from);
	
	        // because onpopstate only tells you the "new" (to) value of location.href, and
	        // not the previous (from) value, we need to track the value of the current URL
	        // state ourselves
	        this._lastHref = to;
	
	        // Use only the path component of the URL if the URL matches the current
	        // document (almost all the time when using pushState)
	        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host)
	            to = parsedTo.relative;
	        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host)
	            from = parsedFrom.relative;
	
	        this.captureBreadcrumb({
	            category: 'navigation',
	            data: {
	                to: to,
	                from: from
	            }
	        });
	    },
	
	    /**
	     * Install any queued plugins
	     */
	    _instrumentTryCatch: function() {
	        var self = this;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapTimeFn(orig) {
	            return function (fn, t) { // preserve arity
	                // Make a copy of the arguments to prevent deoptimization
	                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                var args = new Array(arguments.length);
	                for(var i = 0; i < args.length; ++i) {
	                    args[i] = arguments[i];
	                }
	                var originalCallback = args[0];
	                if (isFunction(originalCallback)) {
	                    args[0] = self.wrap(originalCallback);
	                }
	
	                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
	                // also supports only two arguments and doesn't care what this is, so we
	                // can just call the original function directly.
	                if (orig.apply) {
	                    return orig.apply(this, args);
	                } else {
	                    return orig(args[0], args[1]);
	                }
	            };
	        }
	
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        function wrapEventTarget(global) {
	            var proto = _window[global] && _window[global].prototype;
	            if (proto && proto.hasOwnProperty && proto.hasOwnProperty('addEventListener')) {
	                fill(proto, 'addEventListener', function(orig) {
	                    return function (evtName, fn, capture, secure) { // preserve arity
	                        try {
	                            if (fn && fn.handleEvent) {
	                                fn.handleEvent = self.wrap(fn.handleEvent);
	                            }
	                        } catch (err) {
	                            // can sometimes get 'Permission denied to access property "handle Event'
	                        }
	
	                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
	                        // so that we don't have more than one wrapper function
	                        var before,
	                            clickHandler,
	                            keypressHandler;
	
	                        if (autoBreadcrumbs && autoBreadcrumbs.dom && (global === 'EventTarget' || global === 'Node')) {
	                            // NOTE: generating multiple handlers per addEventListener invocation, should
	                            //       revisit and verify we can just use one (almost certainly)
	                            clickHandler = self._breadcrumbEventHandler('click');
	                            keypressHandler = self._keypressEventHandler();
	                            before = function (evt) {
	                                // need to intercept every DOM event in `before` argument, in case that
	                                // same wrapped method is re-used for different events (e.g. mousemove THEN click)
	                                // see #724
	                                if (!evt) return;
	
	                                var eventType;
	                                try {
	                                    eventType = evt.type
	                                } catch (e) {
	                                    // just accessing event properties can throw an exception in some rare circumstances
	                                    // see: https://github.com/getsentry/raven-js/issues/838
	                                    return;
	                                }
	                                if (eventType === 'click')
	                                    return clickHandler(evt);
	                                else if (eventType === 'keypress')
	                                    return keypressHandler(evt);
	                            };
	                        }
	                        return orig.call(this, evtName, self.wrap(fn, undefined, before), capture, secure);
	                    };
	                }, wrappedBuiltIns);
	                fill(proto, 'removeEventListener', function (orig) {
	                    return function (evt, fn, capture, secure) {
	                        try {
	                            fn = fn && (fn.__raven_wrapper__ ? fn.__raven_wrapper__  : fn);
	                        } catch (e) {
	                            // ignore, accessing __raven_wrapper__ will throw in some Selenium environments
	                        }
	                        return orig.call(this, evt, fn, capture, secure);
	                    };
	                }, wrappedBuiltIns);
	            }
	        }
	
	        fill(_window, 'setTimeout', wrapTimeFn, wrappedBuiltIns);
	        fill(_window, 'setInterval', wrapTimeFn, wrappedBuiltIns);
	        if (_window.requestAnimationFrame) {
	            fill(_window, 'requestAnimationFrame', function (orig) {
	                return function (cb) {
	                    return orig(self.wrap(cb));
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // event targets borrowed from bugsnag-js:
	        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
	        var eventTargets = ['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'];
	        for (var i = 0; i < eventTargets.length; i++) {
	            wrapEventTarget(eventTargets[i]);
	        }
	    },
	
	
	    /**
	     * Instrument browser built-ins w/ breadcrumb capturing
	     *  - XMLHttpRequests
	     *  - DOM interactions (click/typing)
	     *  - window.location changes
	     *  - console
	     *
	     * Can be disabled or individually configured via the `autoBreadcrumbs` config option
	     */
	    _instrumentBreadcrumbs: function () {
	        var self = this;
	        var autoBreadcrumbs = this._globalOptions.autoBreadcrumbs;
	
	        var wrappedBuiltIns = self._wrappedBuiltIns;
	
	        function wrapProp(prop, xhr) {
	            if (prop in xhr && isFunction(xhr[prop])) {
	                fill(xhr, prop, function (orig) {
	                    return self.wrap(orig);
	                }); // intentionally don't track filled methods on XHR instances
	            }
	        }
	
	        if (autoBreadcrumbs.xhr && 'XMLHttpRequest' in _window) {
	            var xhrproto = XMLHttpRequest.prototype;
	            fill(xhrproto, 'open', function(origOpen) {
	                return function (method, url) { // preserve arity
	
	                    // if Sentry key appears in URL, don't capture
	                    if (isString(url) && url.indexOf(self._globalKey) === -1) {
	                        this.__raven_xhr = {
	                            method: method,
	                            url: url,
	                            status_code: null
	                        };
	                    }
	
	                    return origOpen.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	
	            fill(xhrproto, 'send', function(origSend) {
	                return function (data) { // preserve arity
	                    var xhr = this;
	
	                    function onreadystatechangeHandler() {
	                        if (xhr.__raven_xhr && (xhr.readyState === 1 || xhr.readyState === 4)) {
	                            try {
	                                // touching statusCode in some platforms throws
	                                // an exception
	                                xhr.__raven_xhr.status_code = xhr.status;
	                            } catch (e) { /* do nothing */ }
	                            self.captureBreadcrumb({
	                                type: 'http',
	                                category: 'xhr',
	                                data: xhr.__raven_xhr
	                            });
	                        }
	                    }
	
	                    var props = ['onload', 'onerror', 'onprogress'];
	                    for (var j = 0; j < props.length; j++) {
	                        wrapProp(props[j], xhr);
	                    }
	
	                    if ('onreadystatechange' in xhr && isFunction(xhr.onreadystatechange)) {
	                        fill(xhr, 'onreadystatechange', function (orig) {
	                            return self.wrap(orig, undefined, onreadystatechangeHandler);
	                        } /* intentionally don't track this instrumentation */);
	                    } else {
	                        // if onreadystatechange wasn't actually set by the page on this xhr, we
	                        // are free to set our own and capture the breadcrumb
	                        xhr.onreadystatechange = onreadystatechangeHandler;
	                    }
	
	                    return origSend.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.xhr && 'fetch' in _window) {
	            fill(_window, 'fetch', function(origFetch) {
	                return function (fn, t) { // preserve arity
	                    // Make a copy of the arguments to prevent deoptimization
	                    // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
	                    var args = new Array(arguments.length);
	                    for(var i = 0; i < args.length; ++i) {
	                        args[i] = arguments[i];
	                    }
	
	                    var method = 'GET';
	
	                    if (args[1] && args[1].method) {
	                        method = args[1].method;
	                    }
	
	                    var fetchData = {
	                        method: method,
	                        url: args[0],
	                        status_code: null
	                    };
	
	                    self.captureBreadcrumb({
	                        type: 'http',
	                        category: 'fetch',
	                        data: fetchData
	                    });
	
	                    return origFetch.apply(this, args).then(function (response) {
	                        fetchData.status_code = response.status;
	
	                        return response;
	                    });
	                };
	            }, wrappedBuiltIns);
	        }
	
	        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
	        // to the document. Do this before we instrument addEventListener.
	        if (autoBreadcrumbs.dom && this._hasDocument) {
	            if (_document.addEventListener) {
	                _document.addEventListener('click', self._breadcrumbEventHandler('click'), false);
	                _document.addEventListener('keypress', self._keypressEventHandler(), false);
	            }
	            else {
	                // IE8 Compatibility
	                _document.attachEvent('onclick', self._breadcrumbEventHandler('click'));
	                _document.attachEvent('onkeypress', self._keypressEventHandler());
	            }
	        }
	
	        // record navigation (URL) changes
	        // NOTE: in Chrome App environment, touching history.pushState, *even inside
	        //       a try/catch block*, will cause Chrome to output an error to console.error
	        // borrowed from: https://github.com/angular/angular.js/pull/13945/files
	        var chrome = _window.chrome;
	        var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
	        var hasPushState = !isChromePackagedApp && _window.history && history.pushState;
	        if (autoBreadcrumbs.location && hasPushState) {
	            // TODO: remove onpopstate handler on uninstall()
	            var oldOnPopState = _window.onpopstate;
	            _window.onpopstate = function () {
	                var currentHref = self._location.href;
	                self._captureUrlChange(self._lastHref, currentHref);
	
	                if (oldOnPopState) {
	                    return oldOnPopState.apply(this, arguments);
	                }
	            };
	
	            fill(history, 'pushState', function (origPushState) {
	                // note history.pushState.length is 0; intentionally not declaring
	                // params to preserve 0 arity
	                return function (/* state, title, url */) {
	                    var url = arguments.length > 2 ? arguments[2] : undefined;
	
	                    // url argument is optional
	                    if (url) {
	                        // coerce to string (this is what pushState does)
	                        self._captureUrlChange(self._lastHref, url + '');
	                    }
	
	                    return origPushState.apply(this, arguments);
	                };
	            }, wrappedBuiltIns);
	        }
	
	        if (autoBreadcrumbs.console && 'console' in _window && console.log) {
	            // console
	            var consoleMethodCallback = function (msg, data) {
	                self.captureBreadcrumb({
	                    message: msg,
	                    level: data.level,
	                    category: 'console'
	                });
	            };
	
	            each(['debug', 'info', 'warn', 'error', 'log'], function (_, level) {
	                wrapConsoleMethod(console, level, consoleMethodCallback);
	            });
	        }
	
	    },
	
	    _restoreBuiltIns: function () {
	        // restore any wrapped builtins
	        var builtin;
	        while (this._wrappedBuiltIns.length) {
	            builtin = this._wrappedBuiltIns.shift();
	
	            var obj = builtin[0],
	              name = builtin[1],
	              orig = builtin[2];
	
	            obj[name] = orig;
	        }
	    },
	
	    _drainPlugins: function() {
	        var self = this;
	
	        // FIX ME TODO
	        each(this._plugins, function(_, plugin) {
	            var installer = plugin[0];
	            var args = plugin[1];
	            installer.apply(self, [self].concat(args));
	        });
	    },
	
	    _parseDSN: function(str) {
	        var m = dsnPattern.exec(str),
	            dsn = {},
	            i = 7;
	
	        try {
	            while (i--) dsn[dsnKeys[i]] = m[i] || '';
	        } catch(e) {
	            throw new RavenConfigError('Invalid DSN: ' + str);
	        }
	
	        if (dsn.pass && !this._globalOptions.allowSecretKey) {
	            throw new RavenConfigError('Do not specify your secret key in the DSN. See: http://bit.ly/raven-secret-key');
	        }
	
	        return dsn;
	    },
	
	    _getGlobalServer: function(uri) {
	        // assemble the endpoint from the uri pieces
	        var globalServer = '//' + uri.host +
	            (uri.port ? ':' + uri.port : '');
	
	        if (uri.protocol) {
	            globalServer = uri.protocol + ':' + globalServer;
	        }
	        return globalServer;
	    },
	
	    _handleOnErrorStackInfo: function() {
	        // if we are intentionally ignoring errors via onerror, bail out
	        if (!this._ignoreOnError) {
	            this._handleStackInfo.apply(this, arguments);
	        }
	    },
	
	    _handleStackInfo: function(stackInfo, options) {
	        var frames = this._prepareFrames(stackInfo, options);
	
	        this._triggerEvent('handle', {
	            stackInfo: stackInfo,
	            options: options
	        });
	
	        this._processException(
	            stackInfo.name,
	            stackInfo.message,
	            stackInfo.url,
	            stackInfo.lineno,
	            frames,
	            options
	        );
	    },
	
	    _prepareFrames: function(stackInfo, options) {
	        var self = this;
	        var frames = [];
	        if (stackInfo.stack && stackInfo.stack.length) {
	            each(stackInfo.stack, function(i, stack) {
	                var frame = self._normalizeFrame(stack);
	                if (frame) {
	                    frames.push(frame);
	                }
	            });
	
	            // e.g. frames captured via captureMessage throw
	            if (options && options.trimHeadFrames) {
	                for (var j = 0; j < options.trimHeadFrames && j < frames.length; j++) {
	                    frames[j].in_app = false;
	                }
	            }
	        }
	        frames = frames.slice(0, this._globalOptions.stackTraceLimit);
	        return frames;
	    },
	
	
	    _normalizeFrame: function(frame) {
	        if (!frame.url) return;
	
	        // normalize the frames data
	        var normalized = {
	            filename:   frame.url,
	            lineno:     frame.line,
	            colno:      frame.column,
	            'function': frame.func || '?'
	        };
	
	        normalized.in_app = !( // determine if an exception came from outside of our app
	            // first we check the global includePaths list.
	            !!this._globalOptions.includePaths.test && !this._globalOptions.includePaths.test(normalized.filename) ||
	            // Now we check for fun, if the function name is Raven or TraceKit
	            /(Raven|TraceKit)\./.test(normalized['function']) ||
	            // finally, we do a last ditch effort and check for raven.min.js
	            /raven\.(min\.)?js$/.test(normalized.filename)
	        );
	
	        return normalized;
	    },
	
	    _processException: function(type, message, fileurl, lineno, frames, options) {
	        var stacktrace;
	        if (!!this._globalOptions.ignoreErrors.test && this._globalOptions.ignoreErrors.test(message)) return;
	
	        message += '';
	
	        if (frames && frames.length) {
	            fileurl = frames[0].filename || fileurl;
	            // Sentry expects frames oldest to newest
	            // and JS sends them as newest to oldest
	            frames.reverse();
	            stacktrace = {frames: frames};
	        } else if (fileurl) {
	            stacktrace = {
	                frames: [{
	                    filename: fileurl,
	                    lineno: lineno,
	                    in_app: true
	                }]
	            };
	        }
	
	        if (!!this._globalOptions.ignoreUrls.test && this._globalOptions.ignoreUrls.test(fileurl)) return;
	        if (!!this._globalOptions.whitelistUrls.test && !this._globalOptions.whitelistUrls.test(fileurl)) return;
	
	        var data = objectMerge({
	            // sentry.interfaces.Exception
	            exception: {
	                values: [{
	                    type: type,
	                    value: message,
	                    stacktrace: stacktrace
	                }]
	            },
	            culprit: fileurl
	        }, options);
	
	        // Fire away!
	        this._send(data);
	    },
	
	    _trimPacket: function(data) {
	        // For now, we only want to truncate the two different messages
	        // but this could/should be expanded to just trim everything
	        var max = this._globalOptions.maxMessageLength;
	        if (data.message) {
	            data.message = truncate(data.message, max);
	        }
	        if (data.exception) {
	            var exception = data.exception.values[0];
	            exception.value = truncate(exception.value, max);
	        }
	
	        return data;
	    },
	
	    _getHttpData: function() {
	        if (!this._hasNavigator && !this._hasDocument) return;
	        var httpData = {};
	
	        if (this._hasNavigator && _navigator.userAgent) {
	            httpData.headers = {
	              'User-Agent': navigator.userAgent
	            };
	        }
	
	        if (this._hasDocument) {
	            if (_document.location && _document.location.href) {
	                httpData.url = _document.location.href;
	            }
	            if (_document.referrer) {
	                if (!httpData.headers) httpData.headers = {};
	                httpData.headers.Referer = _document.referrer;
	            }
	        }
	
	        return httpData;
	    },
	
	    _resetBackoff: function() {
	        this._backoffDuration = 0;
	        this._backoffStart = null;
	    },
	
	    _shouldBackoff: function() {
	        return this._backoffDuration && now() - this._backoffStart < this._backoffDuration;
	    },
	
	    /**
	     * Returns true if the in-process data payload matches the signature
	     * of the previously-sent data
	     *
	     * NOTE: This has to be done at this level because TraceKit can generate
	     *       data from window.onerror WITHOUT an exception object (IE8, IE9,
	     *       other old browsers). This can take the form of an "exception"
	     *       data object with a single frame (derived from the onerror args).
	     */
	    _isRepeatData: function (current) {
	        var last = this._lastData;
	
	        if (!last ||
	            current.message !== last.message || // defined for captureMessage
	            current.culprit !== last.culprit)   // defined for captureException/onerror
	            return false;
	
	        // Stacktrace interface (i.e. from captureMessage)
	        if (current.stacktrace || last.stacktrace) {
	            return isSameStacktrace(current.stacktrace, last.stacktrace);
	        }
	        // Exception interface (i.e. from captureException/onerror)
	        else if (current.exception || last.exception) {
	            return isSameException(current.exception, last.exception);
	        }
	
	        return true;
	    },
	
	    _setBackoffState: function(request) {
	        // If we are already in a backoff state, don't change anything
	        if (this._shouldBackoff()) {
	            return;
	        }
	
	        var status = request.status;
	
	        // 400 - project_id doesn't exist or some other fatal
	        // 401 - invalid/revoked dsn
	        // 429 - too many requests
	        if (!(status === 400 || status === 401 || status === 429))
	            return;
	
	        var retry;
	        try {
	            // If Retry-After is not in Access-Control-Expose-Headers, most
	            // browsers will throw an exception trying to access it
	            retry = request.getResponseHeader('Retry-After');
	            retry = parseInt(retry, 10) * 1000; // Retry-After is returned in seconds
	        } catch (e) {
	            /* eslint no-empty:0 */
	        }
	
	
	        this._backoffDuration = retry
	            // If Sentry server returned a Retry-After value, use it
	            ? retry
	            // Otherwise, double the last backoff duration (starts at 1 sec)
	            : this._backoffDuration * 2 || 1000;
	
	        this._backoffStart = now();
	    },
	
	    _send: function(data) {
	        var globalOptions = this._globalOptions;
	
	        var baseData = {
	            project: this._globalProject,
	            logger: globalOptions.logger,
	            platform: 'javascript'
	        }, httpData = this._getHttpData();
	
	        if (httpData) {
	            baseData.request = httpData;
	        }
	
	        // HACK: delete `trimHeadFrames` to prevent from appearing in outbound payload
	        if (data.trimHeadFrames) delete data.trimHeadFrames;
	
	        data = objectMerge(baseData, data);
	
	        // Merge in the tags and extra separately since objectMerge doesn't handle a deep merge
	        data.tags = objectMerge(objectMerge({}, this._globalContext.tags), data.tags);
	        data.extra = objectMerge(objectMerge({}, this._globalContext.extra), data.extra);
	
	        // Send along our own collected metadata with extra
	        data.extra['session:duration'] = now() - this._startTime;
	
	        if (this._breadcrumbs && this._breadcrumbs.length > 0) {
	            // intentionally make shallow copy so that additions
	            // to breadcrumbs aren't accidentally sent in this request
	            data.breadcrumbs = {
	                values: [].slice.call(this._breadcrumbs, 0)
	            };
	        }
	
	        // If there are no tags/extra, strip the key from the payload alltogther.
	        if (isEmptyObject(data.tags)) delete data.tags;
	
	        if (this._globalContext.user) {
	            // sentry.interfaces.User
	            data.user = this._globalContext.user;
	        }
	
	        // Include the environment if it's defined in globalOptions
	        if (globalOptions.environment) data.environment = globalOptions.environment;
	
	        // Include the release if it's defined in globalOptions
	        if (globalOptions.release) data.release = globalOptions.release;
	
	        // Include server_name if it's defined in globalOptions
	        if (globalOptions.serverName) data.server_name = globalOptions.serverName;
	
	        if (isFunction(globalOptions.dataCallback)) {
	            data = globalOptions.dataCallback(data) || data;
	        }
	
	        // Why??????????
	        if (!data || isEmptyObject(data)) {
	            return;
	        }
	
	        // Check if the request should be filtered or not
	        if (isFunction(globalOptions.shouldSendCallback) && !globalOptions.shouldSendCallback(data)) {
	            return;
	        }
	
	        // Backoff state: Sentry server previously responded w/ an error (e.g. 429 - too many requests),
	        // so drop requests until "cool-off" period has elapsed.
	        if (this._shouldBackoff()) {
	            this._logDebug('warn', 'Raven dropped error due to backoff: ', data);
	            return;
	        }
	
	        if (typeof globalOptions.sampleRate === 'number') {
	            if (Math.random() < globalOptions.sampleRate) {
	                this._sendProcessedPayload(data);
	            }
	        } else {
	            this._sendProcessedPayload(data);
	        }
	    },
	
	    _getUuid: function () {
	      return uuid4();
	    },
	
	    _sendProcessedPayload: function(data, callback) {
	        var self = this;
	        var globalOptions = this._globalOptions;
	
	        if (!this.isSetup()) return;
	
	        // Send along an event_id if not explicitly passed.
	        // This event_id can be used to reference the error within Sentry itself.
	        // Set lastEventId after we know the error should actually be sent
	        this._lastEventId = data.event_id || (data.event_id = this._getUuid());
	
	        // Try and clean up the packet before sending by truncating long values
	        data = this._trimPacket(data);
	
	        // ideally duplicate error testing should occur *before* dataCallback/shouldSendCallback,
	        // but this would require copying an un-truncated copy of the data packet, which can be
	        // arbitrarily deep (extra_data) -- could be worthwhile? will revisit
	        if (!this._globalOptions.allowDuplicates && this._isRepeatData(data)) {
	            this._logDebug('warn', 'Raven dropped repeat event: ', data);
	            return;
	        }
	
	        // Store outbound payload after trim
	        this._lastData = data;
	
	        this._logDebug('debug', 'Raven about to send:', data);
	
	        var auth = {
	            sentry_version: '7',
	            sentry_client: 'raven-js/' + this.VERSION,
	            sentry_key: this._globalKey
	        };
	        if (this._globalSecret) {
	            auth.sentry_secret = this._globalSecret;
	        }
	
	        var exception = data.exception && data.exception.values[0];
	        this.captureBreadcrumb({
	            category: 'sentry',
	            message: exception
	                ? (exception.type ? exception.type + ': ' : '') + exception.value
	                : data.message,
	            event_id: data.event_id,
	            level: data.level || 'error' // presume error unless specified
	        });
	
	        var url = this._globalEndpoint;
	        (globalOptions.transport || this._makeRequest).call(this, {
	            url: url,
	            auth: auth,
	            data: data,
	            options: globalOptions,
	            onSuccess: function success() {
	                self._resetBackoff();
	
	                self._triggerEvent('success', {
	                    data: data,
	                    src: url
	                });
	                callback && callback();
	            },
	            onError: function failure(error) {
	                self._logDebug('error', 'Raven transport failed to send: ', error);
	
	                if (error.request) {
	                    self._setBackoffState(error.request);
	                }
	
	                self._triggerEvent('failure', {
	                    data: data,
	                    src: url
	                });
	                error = error || new Error('Raven send failed (no additional details provided)');
	                callback && callback(error);
	            }
	        });
	    },
	
	    _makeRequest: function(opts) {
	        var request = new XMLHttpRequest();
	
	        // if browser doesn't support CORS (e.g. IE7), we are out of luck
	        var hasCORS =
	            'withCredentials' in request ||
	            typeof XDomainRequest !== 'undefined';
	
	        if (!hasCORS) return;
	
	        var url = opts.url;
	
	        if ('withCredentials' in request) {
	            request.onreadystatechange = function () {
	                if (request.readyState !== 4) {
	                    return;
	                } else if (request.status === 200) {
	                    opts.onSuccess && opts.onSuccess();
	                } else if (opts.onError) {
	                    var err = new Error('Sentry error code: ' + request.status);
	                    err.request = request;
	                    opts.onError(err);
	                }
	            };
	        } else {
	            request = new XDomainRequest();
	            // xdomainrequest cannot go http -> https (or vice versa),
	            // so always use protocol relative
	            url = url.replace(/^https?:/, '');
	
	            // onreadystatechange not supported by XDomainRequest
	            if (opts.onSuccess) {
	                request.onload = opts.onSuccess;
	            }
	            if (opts.onError) {
	                request.onerror = function () {
	                    var err = new Error('Sentry error code: XDomainRequest');
	                    err.request = request;
	                    opts.onError(err);
	                }
	            }
	        }
	
	        // NOTE: auth is intentionally sent as part of query string (NOT as custom
	        //       HTTP header) so as to avoid preflight CORS requests
	        request.open('POST', url + '?' + urlencode(opts.auth));
	        request.send(stringify(opts.data));
	    },
	
	    _logDebug: function(level) {
	        if (this._originalConsoleMethods[level] && this.debug) {
	            // In IE<10 console methods do not have their own 'apply' method
	            Function.prototype.apply.call(
	                this._originalConsoleMethods[level],
	                this._originalConsole,
	                [].slice.call(arguments, 1)
	            );
	        }
	    },
	
	    _mergeContext: function(key, context) {
	        if (isUndefined(context)) {
	            delete this._globalContext[key];
	        } else {
	            this._globalContext[key] = objectMerge(this._globalContext[key] || {}, context);
	        }
	    }
	};
	
	/*------------------------------------------------
	 * utils
	 *
	 * conditionally exported for test via Raven.utils
	 =================================================
	 */
	var objectPrototype = Object.prototype;
	
	function isUndefined(what) {
	    return what === void 0;
	}
	
	function isFunction(what) {
	    return typeof what === 'function';
	}
	
	function isString(what) {
	    return objectPrototype.toString.call(what) === '[object String]';
	}
	
	
	function isEmptyObject(what) {
	    for (var _ in what) return false;  // eslint-disable-line guard-for-in, no-unused-vars
	    return true;
	}
	
	function each(obj, callback) {
	    var i, j;
	
	    if (isUndefined(obj.length)) {
	        for (i in obj) {
	            if (hasKey(obj, i)) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    } else {
	        j = obj.length;
	        if (j) {
	            for (i = 0; i < j; i++) {
	                callback.call(null, i, obj[i]);
	            }
	        }
	    }
	}
	
	function objectMerge(obj1, obj2) {
	    if (!obj2) {
	        return obj1;
	    }
	    each(obj2, function(key, value){
	        obj1[key] = value;
	    });
	    return obj1;
	}
	
	function truncate(str, max) {
	    return !max || str.length <= max ? str : str.substr(0, max) + '\u2026';
	}
	
	/**
	 * hasKey, a better form of hasOwnProperty
	 * Example: hasKey(MainHostObject, property) === true/false
	 *
	 * @param {Object} host object to check property
	 * @param {string} key to check
	 */
	function hasKey(object, key) {
	    return objectPrototype.hasOwnProperty.call(object, key);
	}
	
	function joinRegExp(patterns) {
	    // Combine an array of regular expressions and strings into one large regexp
	    // Be mad.
	    var sources = [],
	        i = 0, len = patterns.length,
	        pattern;
	
	    for (; i < len; i++) {
	        pattern = patterns[i];
	        if (isString(pattern)) {
	            // If it's a string, we need to escape it
	            // Taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
	            sources.push(pattern.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1'));
	        } else if (pattern && pattern.source) {
	            // If it's a regexp already, we want to extract the source
	            sources.push(pattern.source);
	        }
	        // Intentionally skip other cases
	    }
	    return new RegExp(sources.join('|'), 'i');
	}
	
	function urlencode(o) {
	    var pairs = [];
	    each(o, function(key, value) {
	        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
	    });
	    return pairs.join('&');
	}
	
	// borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
	// intentionally using regex and not <a/> href parsing trick because React Native and other
	// environments where DOM might not be available
	function parseUrl(url) {
	    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
	    if (!match) return {};
	
	    // coerce to undefined values to empty string so we don't get 'undefined'
	    var query = match[6] || '';
	    var fragment = match[8] || '';
	    return {
	        protocol: match[2],
	        host: match[4],
	        path: match[5],
	        relative: match[5] + query + fragment // everything minus origin
	    };
	}
	function uuid4() {
	    var crypto = _window.crypto || _window.msCrypto;
	
	    if (!isUndefined(crypto) && crypto.getRandomValues) {
	        // Use window.crypto API if available
	        var arr = new Uint16Array(8);
	        crypto.getRandomValues(arr);
	
	        // set 4 in byte 7
	        arr[3] = arr[3] & 0xFFF | 0x4000;
	        // set 2 most significant bits of byte 9 to '10'
	        arr[4] = arr[4] & 0x3FFF | 0x8000;
	
	        var pad = function(num) {
	            var v = num.toString(16);
	            while (v.length < 4) {
	                v = '0' + v;
	            }
	            return v;
	        };
	
	        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) +
	        pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
	    } else {
	        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
	        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
	            var r = Math.random()*16|0,
	                v = c === 'x' ? r : r&0x3|0x8;
	            return v.toString(16);
	        });
	    }
	}
	
	/**
	 * Given a child DOM element, returns a query-selector statement describing that
	 * and its ancestors
	 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
	 * @param elem
	 * @returns {string}
	 */
	function htmlTreeAsString(elem) {
	    /* eslint no-extra-parens:0*/
	    var MAX_TRAVERSE_HEIGHT = 5,
	        MAX_OUTPUT_LEN = 80,
	        out = [],
	        height = 0,
	        len = 0,
	        separator = ' > ',
	        sepLength = separator.length,
	        nextStr;
	
	    while (elem && height++ < MAX_TRAVERSE_HEIGHT) {
	
	        nextStr = htmlElementAsString(elem);
	        // bail out if
	        // - nextStr is the 'html' element
	        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
	        //   (ignore this limit if we are on the first iteration)
	        if (nextStr === 'html' || height > 1 && len + (out.length * sepLength) + nextStr.length >= MAX_OUTPUT_LEN) {
	            break;
	        }
	
	        out.push(nextStr);
	
	        len += nextStr.length;
	        elem = elem.parentNode;
	    }
	
	    return out.reverse().join(separator);
	}
	
	/**
	 * Returns a simple, query-selector representation of a DOM element
	 * e.g. [HTMLElement] => input#foo.btn[name=baz]
	 * @param HTMLElement
	 * @returns {string}
	 */
	function htmlElementAsString(elem) {
	    var out = [],
	        className,
	        classes,
	        key,
	        attr,
	        i;
	
	    if (!elem || !elem.tagName) {
	        return '';
	    }
	
	    out.push(elem.tagName.toLowerCase());
	    if (elem.id) {
	        out.push('#' + elem.id);
	    }
	
	    className = elem.className;
	    if (className && isString(className)) {
	        classes = className.split(/\s+/);
	        for (i = 0; i < classes.length; i++) {
	            out.push('.' + classes[i]);
	        }
	    }
	    var attrWhitelist = ['type', 'name', 'title', 'alt'];
	    for (i = 0; i < attrWhitelist.length; i++) {
	        key = attrWhitelist[i];
	        attr = elem.getAttribute(key);
	        if (attr) {
	            out.push('[' + key + '="' + attr + '"]');
	        }
	    }
	    return out.join('');
	}
	
	/**
	 * Returns true if either a OR b is truthy, but not both
	 */
	function isOnlyOneTruthy(a, b) {
	    return !!(!!a ^ !!b);
	}
	
	/**
	 * Returns true if the two input exception interfaces have the same content
	 */
	function isSameException(ex1, ex2) {
	    if (isOnlyOneTruthy(ex1, ex2))
	        return false;
	
	    ex1 = ex1.values[0];
	    ex2 = ex2.values[0];
	
	    if (ex1.type !== ex2.type ||
	        ex1.value !== ex2.value)
	        return false;
	
	    return isSameStacktrace(ex1.stacktrace, ex2.stacktrace);
	}
	
	/**
	 * Returns true if the two input stack trace interfaces have the same content
	 */
	function isSameStacktrace(stack1, stack2) {
	    if (isOnlyOneTruthy(stack1, stack2))
	        return false;
	
	    var frames1 = stack1.frames;
	    var frames2 = stack2.frames;
	
	    // Exit early if frame count differs
	    if (frames1.length !== frames2.length)
	        return false;
	
	    // Iterate through every frame; bail out if anything differs
	    var a, b;
	    for (var i = 0; i < frames1.length; i++) {
	        a = frames1[i];
	        b = frames2[i];
	        if (a.filename !== b.filename ||
	            a.lineno !== b.lineno ||
	            a.colno !== b.colno ||
	            a['function'] !== b['function'])
	            return false;
	    }
	    return true;
	}
	
	/**
	 * Polyfill a method
	 * @param obj object e.g. `document`
	 * @param name method name present on object e.g. `addEventListener`
	 * @param replacement replacement function
	 * @param track {optional} record instrumentation to an array
	 */
	function fill(obj, name, replacement, track) {
	    var orig = obj[name];
	    obj[name] = replacement(orig);
	    if (track) {
	        track.push([obj, name, orig]);
	    }
	}
	
	if (false) {
	    Raven.utils = {
	        isUndefined: isUndefined,
	        isFunction: isFunction,
	        isString: isString,
	        isObject: isObject,
	        isEmptyObject: isEmptyObject,
	        isError: isError,
	        each: each,
	        objectMerge: objectMerge,
	        truncate: truncate,
	        hasKey: hasKey,
	        joinRegExp: joinRegExp,
	        urlencode: urlencode,
	        uuid4: uuid4,
	        htmlTreeAsString: htmlTreeAsString,
	        htmlElementAsString: htmlElementAsString,
	        parseUrl: parseUrl,
	        fill: fill
	    };
	};
	
	// Deprecations
	Raven.prototype.setUser = Raven.prototype.setUserContext;
	Raven.prototype.setReleaseContext = Raven.prototype.setRelease;
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Enforces a single instance of the Raven client, and the
	 * main entry point for Raven. If you are a consumer of the
	 * Raven library, you SHOULD load this file (vs raven.js).
	 **/
	
	'use strict';
	
	var RavenConstructor = __webpack_require__(1022);
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	var _Raven = _window.Raven;
	
	var Raven = new RavenConstructor();
	
	/*
	 * Allow multiple versions of Raven to be installed.
	 * Strip Raven from the global context and returns the instance.
	 *
	 * @return {Raven}
	 */
	Raven.noConflict = function () {
		_window.Raven = _Raven;
		return Raven;
	};
	
	Raven.afterLoad();
	
	module.exports = Raven;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var utils = __webpack_require__(461);
	
	/*
	 TraceKit - Cross brower stack traces
	
	 This was originally forked from github.com/occ/TraceKit, but has since been
	 largely re-written and is now maintained as part of raven-js.  Tests for
	 this are in test/vendor.
	
	 MIT license
	*/
	
	var TraceKit = {
	    collectWindowErrors: true,
	    debug: false
	};
	
	// This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
	var _window = typeof window !== 'undefined' ? window
	            : typeof global !== 'undefined' ? global
	            : typeof self !== 'undefined' ? self
	            : {};
	
	// global reference to slice
	var _slice = [].slice;
	var UNKNOWN_FUNCTION = '?';
	
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
	var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
	
	function getLocationHref() {
	    if (typeof document === 'undefined' || typeof document.location === 'undefined')
	        return '';
	
	    return document.location.href;
	}
	
	
	/**
	 * TraceKit.report: cross-browser processing of unhandled exceptions
	 *
	 * Syntax:
	 *   TraceKit.report.subscribe(function(stackInfo) { ... })
	 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
	 *   TraceKit.report(exception)
	 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
	 *
	 * Supports:
	 *   - Firefox: full stack trace with line numbers, plus column number
	 *              on top frame; column number is not guaranteed
	 *   - Opera:   full stack trace with line and column numbers
	 *   - Chrome:  full stack trace with line and column numbers
	 *   - Safari:  line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *   - IE:      line and column number for the top frame only; some frames
	 *              may be missing, and column number is not guaranteed
	 *
	 * In theory, TraceKit should work on all of the following versions:
	 *   - IE5.5+ (only 8.0 tested)
	 *   - Firefox 0.9+ (only 3.5+ tested)
	 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
	 *     Exceptions Have Stacktrace to be enabled in opera:config)
	 *   - Safari 3+ (only 4+ tested)
	 *   - Chrome 1+ (only 5+ tested)
	 *   - Konqueror 3.5+ (untested)
	 *
	 * Requires TraceKit.computeStackTrace.
	 *
	 * Tries to catch all unhandled exceptions and report them to the
	 * subscribed handlers. Please note that TraceKit.report will rethrow the
	 * exception. This is REQUIRED in order to get a useful stack trace in IE.
	 * If the exception does not reach the top of the browser, you will only
	 * get a stack trace from the point where TraceKit.report was called.
	 *
	 * Handlers receive a stackInfo object as described in the
	 * TraceKit.computeStackTrace docs.
	 */
	TraceKit.report = (function reportModuleWrapper() {
	    var handlers = [],
	        lastArgs = null,
	        lastException = null,
	        lastExceptionStack = null;
	
	    /**
	     * Add a crash handler.
	     * @param {Function} handler
	     */
	    function subscribe(handler) {
	        installGlobalHandler();
	        handlers.push(handler);
	    }
	
	    /**
	     * Remove a crash handler.
	     * @param {Function} handler
	     */
	    function unsubscribe(handler) {
	        for (var i = handlers.length - 1; i >= 0; --i) {
	            if (handlers[i] === handler) {
	                handlers.splice(i, 1);
	            }
	        }
	    }
	
	    /**
	     * Remove all crash handlers.
	     */
	    function unsubscribeAll() {
	        uninstallGlobalHandler();
	        handlers = [];
	    }
	
	    /**
	     * Dispatch stack information to all handlers.
	     * @param {Object.<string, *>} stack
	     */
	    function notifyHandlers(stack, isWindowError) {
	        var exception = null;
	        if (isWindowError && !TraceKit.collectWindowErrors) {
	          return;
	        }
	        for (var i in handlers) {
	            if (handlers.hasOwnProperty(i)) {
	                try {
	                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
	                } catch (inner) {
	                    exception = inner;
	                }
	            }
	        }
	
	        if (exception) {
	            throw exception;
	        }
	    }
	
	    var _oldOnerrorHandler, _onErrorHandlerInstalled;
	
	    /**
	     * Ensures all global unhandled exceptions are recorded.
	     * Supported by Gecko and IE.
	     * @param {string} message Error message.
	     * @param {string} url URL of script that generated the exception.
	     * @param {(number|string)} lineNo The line number at which the error
	     * occurred.
	     * @param {?(number|string)} colNo The column number at which the error
	     * occurred.
	     * @param {?Error} ex The actual Error object.
	     */
	    function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
	        var stack = null;
	
	        if (lastExceptionStack) {
	            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
	            processLastException();
	        } else if (ex && utils.isError(ex)) {
	            // non-string `ex` arg; attempt to extract stack trace
	
	            // New chrome and blink send along a real error object
	            // Let's just report that like a normal error.
	            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
	            stack = TraceKit.computeStackTrace(ex);
	            notifyHandlers(stack, true);
	        } else {
	            var location = {
	                'url': url,
	                'line': lineNo,
	                'column': colNo
	            };
	
	            var name = undefined;
	            var msg = message; // must be new var or will modify original `arguments`
	            var groups;
	            if ({}.toString.call(message) === '[object String]') {
	                var groups = message.match(ERROR_TYPES_RE);
	                if (groups) {
	                    name = groups[1];
	                    msg = groups[2];
	                }
	            }
	
	            location.func = UNKNOWN_FUNCTION;
	
	            stack = {
	                'name': name,
	                'message': msg,
	                'url': getLocationHref(),
	                'stack': [location]
	            };
	            notifyHandlers(stack, true);
	        }
	
	        if (_oldOnerrorHandler) {
	            return _oldOnerrorHandler.apply(this, arguments);
	        }
	
	        return false;
	    }
	
	    function installGlobalHandler ()
	    {
	        if (_onErrorHandlerInstalled) {
	            return;
	        }
	        _oldOnerrorHandler = _window.onerror;
	        _window.onerror = traceKitWindowOnError;
	        _onErrorHandlerInstalled = true;
	    }
	
	    function uninstallGlobalHandler ()
	    {
	        if (!_onErrorHandlerInstalled) {
	            return;
	        }
	        _window.onerror = _oldOnerrorHandler;
	        _onErrorHandlerInstalled = false;
	        _oldOnerrorHandler = undefined;
	    }
	
	    function processLastException() {
	        var _lastExceptionStack = lastExceptionStack,
	            _lastArgs = lastArgs;
	        lastArgs = null;
	        lastExceptionStack = null;
	        lastException = null;
	        notifyHandlers.apply(null, [_lastExceptionStack, false].concat(_lastArgs));
	    }
	
	    /**
	     * Reports an unhandled Error to TraceKit.
	     * @param {Error} ex
	     * @param {?boolean} rethrow If false, do not re-throw the exception.
	     * Only used for window.onerror to not cause an infinite loop of
	     * rethrowing.
	     */
	    function report(ex, rethrow) {
	        var args = _slice.call(arguments, 1);
	        if (lastExceptionStack) {
	            if (lastException === ex) {
	                return; // already caught by an inner catch block, ignore
	            } else {
	              processLastException();
	            }
	        }
	
	        var stack = TraceKit.computeStackTrace(ex);
	        lastExceptionStack = stack;
	        lastException = ex;
	        lastArgs = args;
	
	        // If the stack trace is incomplete, wait for 2 seconds for
	        // slow slow IE to see if onerror occurs or not before reporting
	        // this exception; otherwise, we will end up with an incomplete
	        // stack trace
	        setTimeout(function () {
	            if (lastException === ex) {
	                processLastException();
	            }
	        }, (stack.incomplete ? 2000 : 0));
	
	        if (rethrow !== false) {
	            throw ex; // re-throw to propagate to the top level (and cause window.onerror)
	        }
	    }
	
	    report.subscribe = subscribe;
	    report.unsubscribe = unsubscribe;
	    report.uninstall = unsubscribeAll;
	    return report;
	}());
	
	/**
	 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
	 *
	 * Syntax:
	 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
	 * Returns:
	 *   s.name              - exception name
	 *   s.message           - exception message
	 *   s.stack[i].url      - JavaScript or HTML file URL
	 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
	 *   s.stack[i].args     - arguments passed to the function, if known
	 *   s.stack[i].line     - line number, if known
	 *   s.stack[i].column   - column number, if known
	 *
	 * Supports:
	 *   - Firefox:  full stack trace with line numbers and unreliable column
	 *               number on top frame
	 *   - Opera 10: full stack trace with line and column numbers
	 *   - Opera 9-: full stack trace with line numbers
	 *   - Chrome:   full stack trace with line and column numbers
	 *   - Safari:   line and column number for the topmost stacktrace element
	 *               only
	 *   - IE:       no line numbers whatsoever
	 *
	 * Tries to guess names of anonymous functions by looking for assignments
	 * in the source code. In IE and Safari, we have to guess source file names
	 * by searching for function bodies inside all page scripts. This will not
	 * work for scripts that are loaded cross-domain.
	 * Here be dragons: some function names may be guessed incorrectly, and
	 * duplicate functions may be mismatched.
	 *
	 * TraceKit.computeStackTrace should only be used for tracing purposes.
	 * Logging of unhandled exceptions should be done with TraceKit.report,
	 * which builds on top of TraceKit.computeStackTrace and provides better
	 * IE support by utilizing the window.onerror event to retrieve information
	 * about the top of the stack.
	 *
	 * Note: In IE and Safari, no stack trace is recorded on the Error object,
	 * so computeStackTrace instead walks its *own* chain of callers.
	 * This means that:
	 *  * in Safari, some methods may be missing from the stack trace;
	 *  * in IE, the topmost function in the stack trace will always be the
	 *    caller of computeStackTrace.
	 *
	 * This is okay for tracing (because you are likely to be calling
	 * computeStackTrace from the function you want to be the topmost element
	 * of the stack trace anyway), but not okay for logging unhandled
	 * exceptions (because your catch block will likely be far away from the
	 * inner function that actually caused the exception).
	 *
	 */
	TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
	    /**
	     * Escapes special characters, except for whitespace, in a string to be
	     * used inside a regular expression as a string literal.
	     * @param {string} text The string.
	     * @return {string} The escaped string literal.
	     */
	    function escapeRegExp(text) {
	        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
	    }
	
	    /**
	     * Escapes special characters in a string to be used inside a regular
	     * expression as a string literal. Also ensures that HTML entities will
	     * be matched the same as their literal friends.
	     * @param {string} body The string.
	     * @return {string} The escaped string.
	     */
	    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
	        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
	    }
	
	    // Contents of Exception in various browsers.
	    //
	    // SAFARI:
	    // ex.message = Can't find variable: qq
	    // ex.line = 59
	    // ex.sourceId = 580238192
	    // ex.sourceURL = http://...
	    // ex.expressionBeginOffset = 96
	    // ex.expressionCaretOffset = 98
	    // ex.expressionEndOffset = 98
	    // ex.name = ReferenceError
	    //
	    // FIREFOX:
	    // ex.message = qq is not defined
	    // ex.fileName = http://...
	    // ex.lineNumber = 59
	    // ex.columnNumber = 69
	    // ex.stack = ...stack trace... (see the example below)
	    // ex.name = ReferenceError
	    //
	    // CHROME:
	    // ex.message = qq is not defined
	    // ex.name = ReferenceError
	    // ex.type = not_defined
	    // ex.arguments = ['aa']
	    // ex.stack = ...stack trace...
	    //
	    // INTERNET EXPLORER:
	    // ex.message = ...
	    // ex.name = ReferenceError
	    //
	    // OPERA:
	    // ex.message = ...message... (see the example below)
	    // ex.name = ReferenceError
	    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
	    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
	
	    /**
	     * Computes stack trace information from the stack property.
	     * Chrome and Gecko use this property.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceFromStackProp(ex) {
	        if (typeof ex.stack === 'undefined' || !ex.stack) return;
	
	        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
	            gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i,
	            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
	            lines = ex.stack.split('\n'),
	            stack = [],
	            parts,
	            element,
	            reference = /^(.*) is undefined$/.exec(ex.message);
	
	        for (var i = 0, j = lines.length; i < j; ++i) {
	            if ((parts = chrome.exec(lines[i]))) {
	                var isNative = parts[2] && parts[2].indexOf('native') !== -1;
	                element = {
	                    'url': !isNative ? parts[2] : null,
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': isNative ? [parts[2]] : [],
	                    'line': parts[3] ? +parts[3] : null,
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ( parts = winjs.exec(lines[i]) ) {
	                element = {
	                    'url': parts[2],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': [],
	                    'line': +parts[3],
	                    'column': parts[4] ? +parts[4] : null
	                };
	            } else if ((parts = gecko.exec(lines[i]))) {
	                element = {
	                    'url': parts[3],
	                    'func': parts[1] || UNKNOWN_FUNCTION,
	                    'args': parts[2] ? parts[2].split(',') : [],
	                    'line': parts[4] ? +parts[4] : null,
	                    'column': parts[5] ? +parts[5] : null
	                };
	            } else {
	                continue;
	            }
	
	            if (!element.func && element.line) {
	                element.func = UNKNOWN_FUNCTION;
	            }
	
	            stack.push(element);
	        }
	
	        if (!stack.length) {
	            return null;
	        }
	
	        if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
	            // FireFox uses this awesome columnNumber property for its top frame
	            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
	            // so adding 1
	            stack[0].column = ex.columnNumber + 1;
	        }
	
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	    }
	
	    /**
	     * Adds information about the first frame to incomplete stack traces.
	     * Safari and IE require this to get complete data on the first frame.
	     * @param {Object.<string, *>} stackInfo Stack trace information from
	     * one of the compute* methods.
	     * @param {string} url The URL of the script that caused an error.
	     * @param {(number|string)} lineNo The line number of the script that
	     * caused an error.
	     * @param {string=} message The error generated by the browser, which
	     * hopefully contains the name of the object that caused the error.
	     * @return {boolean} Whether or not the stack information was
	     * augmented.
	     */
	    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
	        var initial = {
	            'url': url,
	            'line': lineNo
	        };
	
	        if (initial.url && initial.line) {
	            stackInfo.incomplete = false;
	
	            if (!initial.func) {
	                initial.func = UNKNOWN_FUNCTION;
	            }
	
	            if (stackInfo.stack.length > 0) {
	                if (stackInfo.stack[0].url === initial.url) {
	                    if (stackInfo.stack[0].line === initial.line) {
	                        return false; // already in stack trace
	                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
	                        stackInfo.stack[0].line = initial.line;
	                        return false;
	                    }
	                }
	            }
	
	            stackInfo.stack.unshift(initial);
	            stackInfo.partial = true;
	            return true;
	        } else {
	            stackInfo.incomplete = true;
	        }
	
	        return false;
	    }
	
	    /**
	     * Computes stack trace information by walking the arguments.caller
	     * chain at the time the exception occurred. This will cause earlier
	     * frames to be missed but is the only way to get any stack trace in
	     * Safari and IE. The top frame is restored by
	     * {@link augmentStackTraceWithInitialElement}.
	     * @param {Error} ex
	     * @return {?Object.<string, *>} Stack trace information.
	     */
	    function computeStackTraceByWalkingCallerChain(ex, depth) {
	        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
	            stack = [],
	            funcs = {},
	            recursion = false,
	            parts,
	            item,
	            source;
	
	        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
	            if (curr === computeStackTrace || curr === TraceKit.report) {
	                // console.log('skipping internal function');
	                continue;
	            }
	
	            item = {
	                'url': null,
	                'func': UNKNOWN_FUNCTION,
	                'line': null,
	                'column': null
	            };
	
	            if (curr.name) {
	                item.func = curr.name;
	            } else if ((parts = functionName.exec(curr.toString()))) {
	                item.func = parts[1];
	            }
	
	            if (typeof item.func === 'undefined') {
	              try {
	                item.func = parts.input.substring(0, parts.input.indexOf('{'));
	              } catch (e) { }
	            }
	
	            if (funcs['' + curr]) {
	                recursion = true;
	            }else{
	                funcs['' + curr] = true;
	            }
	
	            stack.push(item);
	        }
	
	        if (depth) {
	            // console.log('depth is ' + depth);
	            // console.log('stack is ' + stack.length);
	            stack.splice(0, depth);
	        }
	
	        var result = {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref(),
	            'stack': stack
	        };
	        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
	        return result;
	    }
	
	    /**
	     * Computes a stack trace for an exception.
	     * @param {Error} ex
	     * @param {(string|number)=} depth
	     */
	    function computeStackTrace(ex, depth) {
	        var stack = null;
	        depth = (depth == null ? 0 : +depth);
	
	        try {
	            stack = computeStackTraceFromStackProp(ex);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	
	        try {
	            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
	            if (stack) {
	                return stack;
	            }
	        } catch (e) {
	            if (TraceKit.debug) {
	                throw e;
	            }
	        }
	        return {
	            'name': ex.name,
	            'message': ex.message,
	            'url': getLocationHref()
	        };
	    }
	
	    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
	    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
	
	    return computeStackTrace;
	}());
	
	module.exports = TraceKit;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1025 */
/***/ function(module, exports) {

	'use strict';
	
	/*
	 json-stringify-safe
	 Like JSON.stringify, but doesn't throw on circular references.
	
	 Originally forked from https://github.com/isaacs/json-stringify-safe
	 version 5.0.1 on 3/8/2017 and modified for IE8 compatibility.
	 Tests for this are in test/vendor.
	
	 ISC license: https://github.com/isaacs/json-stringify-safe/blob/master/LICENSE
	*/
	
	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function indexOf(haystack, needle) {
	  for (var i = 0; i < haystack.length; ++i) {
	    if (haystack[i] === needle) return i;
	  }
	  return -1;
	}
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return '[Circular ~]'
	    return '[Circular ~.' + keys.slice(0, indexOf(stack, value)).join('.') + ']'
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = indexOf(stack, this);
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~indexOf(stack, value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	var _AlphaPointer = __webpack_require__(1027);
	
	var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
	  var rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      direction = _ref.direction,
	      style = _ref.style,
	      renderers = _ref.renderers,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      alpha: {
	        radius: '2px',
	        style: style
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'alpha-picker ' + className },
	    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
	      rgb: rgb,
	      hsl: hsl,
	      pointer: pointer,
	      renderers: renderers,
	      onChange: onChange,
	      direction: direction
	    }))
	  );
	};
	
	AlphaPicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _AlphaPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AlphaPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = AlphaPointer;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Block = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	var _BlockSwatches = __webpack_require__(1029);
	
	var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = exports.Block = function Block(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var transparent = hex === 'transparent';
	  var handleChange = function handleChange(hexCode, e) {
	    _color2.default.isValidHex(hexCode) && onChange({
	      hex: hexCode,
	      source: 'hex'
	    }, e);
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        boxShadow: '0 1px rgba(0,0,0,.1)',
	        borderRadius: '6px',
	        position: 'relative'
	      },
	      head: {
	        height: '110px',
	        background: hex,
	        borderRadius: '6px 6px 0 0',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center',
	        position: 'relative'
	      },
	      body: {
	        padding: '10px'
	      },
	      label: {
	        fontSize: '18px',
	        color: _color2.default.getContrastingColor(hex),
	        position: 'relative'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 10px 10px 10px',
	        borderColor: 'transparent transparent ' + hex + ' transparent',
	        position: 'absolute',
	        top: '-10px',
	        left: '50%',
	        marginLeft: '-10px'
	      },
	      input: {
	        width: '100%',
	        fontSize: '12px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '22px',
	        boxShadow: 'inset 0 0 0 1px #ddd',
	        borderRadius: '4px',
	        padding: '0 7px',
	        boxSizing: 'border-box'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      }
	    }
	  }, { 'hide-triangle': triangle === 'hide' });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'block-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.head },
	      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.label },
	        hex
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex,
	        onChange: handleChange
	      })
	    )
	  );
	};
	
	Block.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['top', 'hide'])
	};
	
	Block.defaultProps = {
	  width: 170,
	  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
	  triangle: 'top'
	};
	
	exports.default = (0, _common.ColorWrap)(Block);

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BlockSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
	  var colors = _ref.colors,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginRight: '-10px'
	      },
	      swatch: {
	        width: '22px',
	        height: '22px',
	        float: 'left',
	        marginRight: '10px',
	        marginBottom: '10px',
	        borderRadius: '4px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_common.Swatch, {
	        key: c,
	        color: c,
	        style: styles.swatch,
	        onClick: onClick,
	        onHover: onSwatchHover,
	        focusStyle: {
	          boxShadow: '0 0 4px ' + c
	        }
	      });
	    }),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = BlockSwatches;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Chrome = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	var _ChromeFields = __webpack_require__(1031);
	
	var _ChromeFields2 = _interopRequireDefault(_ChromeFields);
	
	var _ChromePointer = __webpack_require__(1032);
	
	var _ChromePointer2 = _interopRequireDefault(_ChromePointer);
	
	var _ChromePointerCircle = __webpack_require__(1033);
	
	var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chrome = exports.Chrome = function Chrome(_ref) {
	  var onChange = _ref.onChange,
	      disableAlpha = _ref.disableAlpha,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hsv = _ref.hsv,
	      hex = _ref.hex,
	      renderers = _ref.renderers,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        background: '#fff',
	        borderRadius: '2px',
	        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
	        boxSizing: 'initial',
	        width: '225px',
	        fontFamily: 'Menlo'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '55%',
	        position: 'relative',
	        borderRadius: '2px 2px 0 0',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '2px 2px 0 0'
	      },
	      body: {
	        padding: '16px 16px 12px'
	      },
	      controls: {
	        display: 'flex'
	      },
	      color: {
	        width: '32px'
	      },
	      swatch: {
	        marginTop: '6px',
	        width: '16px',
	        height: '16px',
	        borderRadius: '8px',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      active: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '8px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
	        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
	        zIndex: '2'
	      },
	      toggles: {
	        flex: '1'
	      },
	      hue: {
	        height: '10px',
	        position: 'relative',
	        marginBottom: '8px'
	      },
	      Hue: {
	        radius: '2px'
	      },
	      alpha: {
	        height: '10px',
	        position: 'relative'
	      },
	      Alpha: {
	        radius: '2px'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        width: '22px'
	      },
	      alpha: {
	        display: 'none'
	      },
	      hue: {
	        marginBottom: '0px'
	      },
	      swatch: {
	        width: '10px',
	        height: '10px',
	        marginTop: '0px'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'chrome-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        pointer: _ChromePointerCircle2.default,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      _react2.default.createElement(
	        'div',
	        { style: styles.controls, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.color },
	          _react2.default.createElement(
	            'div',
	            { style: styles.swatch },
	            _react2.default.createElement('div', { style: styles.active }),
	            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggles },
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              style: styles.Hue,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              onChange: onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.Alpha, {
	              style: styles.Alpha,
	              rgb: rgb,
	              hsl: hsl,
	              pointer: _ChromePointer2.default,
	              renderers: renderers,
	              onChange: onChange
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(_ChromeFields2.default, {
	        rgb: rgb,
	        hsl: hsl,
	        hex: hex,
	        onChange: onChange,
	        disableAlpha: disableAlpha
	      })
	    )
	  );
	};
	
	Chrome.propTypes = {
	  disableAlpha: _propTypes2.default.bool
	};
	
	Chrome.defaultProps = {
	  disableAlpha: false
	};
	
	exports.default = (0, _common.ColorWrap)(Chrome);

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromeFields = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */
	
	var ChromeFields = exports.ChromeFields = function (_React$Component) {
	  _inherits(ChromeFields, _React$Component);
	
	  function ChromeFields() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChromeFields);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      view: ''
	    }, _this.toggleViews = function () {
	      if (_this.state.view === 'hex') {
	        _this.setState({ view: 'rgb' });
	      } else if (_this.state.view === 'rgb') {
	        _this.setState({ view: 'hsl' });
	      } else if (_this.state.view === 'hsl') {
	        if (_this.props.hsl.a === 1) {
	          _this.setState({ view: 'hex' });
	        } else {
	          _this.setState({ view: 'rgb' });
	        }
	      }
	    }, _this.handleChange = function (data, e) {
	      if (data.hex) {
	        _color2.default.isValidHex(data.hex) && _this.props.onChange({
	          hex: data.hex,
	          source: 'hex'
	        }, e);
	      } else if (data.r || data.g || data.b) {
	        _this.props.onChange({
	          r: data.r || _this.props.rgb.r,
	          g: data.g || _this.props.rgb.g,
	          b: data.b || _this.props.rgb.b,
	          source: 'rgb'
	        }, e);
	      } else if (data.a) {
	        if (data.a < 0) {
	          data.a = 0;
	        } else if (data.a > 1) {
	          data.a = 1;
	        }
	
	        _this.props.onChange({
	          h: _this.props.hsl.h,
	          s: _this.props.hsl.s,
	          l: _this.props.hsl.l,
	          a: Math.round(data.a * 100) / 100,
	          source: 'rgb'
	        }, e);
	      } else if (data.h || data.s || data.l) {
	        _this.props.onChange({
	          h: data.h || _this.props.hsl.h,
	          s: Number(data.s && data.s || _this.props.hsl.s),
	          l: Number(data.l && data.l || _this.props.hsl.l),
	          source: 'hsl'
	        }, e);
	      }
	    }, _this.showHighlight = function (e) {
	      e.target.style.background = '#eee';
	    }, _this.hideHighlight = function (e) {
	      e.target.style.background = 'transparent';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ChromeFields, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.hsl.a === 1 && this.state.view !== 'hex') {
	        this.setState({ view: 'hex' });
	      } else if (this.state.view !== 'rgb' && this.state.view !== 'hsl') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hsl.a !== 1 && this.state.view === 'hex') {
	        this.setState({ view: 'rgb' });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            paddingTop: '16px',
	            display: 'flex'
	          },
	          fields: {
	            flex: '1',
	            display: 'flex',
	            marginLeft: '-6px'
	          },
	          field: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          alpha: {
	            paddingLeft: '6px',
	            width: '100%'
	          },
	          toggle: {
	            width: '32px',
	            textAlign: 'right',
	            position: 'relative'
	          },
	          icon: {
	            marginRight: '-4px',
	            marginTop: '12px',
	            cursor: 'pointer',
	            position: 'relative'
	          },
	          iconHighlight: {
	            position: 'absolute',
	            width: '24px',
	            height: '28px',
	            background: '#eee',
	            borderRadius: '4px',
	            top: '10px',
	            left: '12px',
	            display: 'none'
	          },
	          input: {
	            fontSize: '11px',
	            color: '#333',
	            width: '100%',
	            borderRadius: '2px',
	            border: 'none',
	            boxShadow: 'inset 0 0 0 1px #dadada',
	            height: '21px',
	            textAlign: 'center'
	          },
	          label: {
	            textTransform: 'uppercase',
	            fontSize: '11px',
	            lineHeight: '11px',
	            color: '#969696',
	            textAlign: 'center',
	            display: 'block',
	            marginTop: '12px'
	          },
	          svg: {
	            width: '24px',
	            height: '24px',
	            border: '1px transparent solid',
	            borderRadius: '5px'
	          }
	        },
	        'disableAlpha': {
	          alpha: {
	            display: 'none'
	          }
	        }
	      }, this.props, this.state);
	
	      var fields = void 0;
	      if (this.state.view === 'hex') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'hex', value: this.props.hex,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'rgb') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'r',
	              value: this.props.rgb.r,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'g',
	              value: this.props.rgb.g,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'b',
	              value: this.props.rgb.b,
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.rgb.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      } else if (this.state.view === 'hsl') {
	        fields = _react2.default.createElement(
	          'div',
	          { style: styles.fields, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'h',
	              value: Math.round(this.props.hsl.h),
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 's',
	              value: Math.round(this.props.hsl.s * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.field },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'l',
	              value: Math.round(this.props.hsl.l * 100) + '%',
	              onChange: this.handleChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.alpha },
	            _react2.default.createElement(_common.EditableInput, {
	              style: { input: styles.input, label: styles.label },
	              label: 'a',
	              value: this.props.hsl.a,
	              arrowOffset: 0.01,
	              onChange: this.handleChange
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap, className: 'flexbox-fix' },
	        fields,
	        _react2.default.createElement(
	          'div',
	          { style: styles.toggle },
	          _react2.default.createElement(
	            'div',
	            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
	                return _this2.icon = icon;
	              } },
	            _react2.default.createElement(
	              'svg',
	              {
	                style: styles.svg,
	                viewBox: '0 0 24 24',
	                onMouseOver: this.showHighlight,
	                onMouseEnter: this.showHighlight,
	                onMouseOut: this.hideHighlight
	              },
	              _react2.default.createElement('path', {
	                ref: function ref(iconUp) {
	                  return _this2.iconUp = iconUp;
	                },
	                fill: '#333',
	                d: 'M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z'
	              }),
	              _react2.default.createElement('path', {
	                ref: function ref(iconDown) {
	                  return _this2.iconDown = iconDown;
	                },
	                fill: '#333',
	                d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChromeFields;
	}(_react2.default.Component);
	
	exports.default = ChromeFields;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointer = exports.ChromePointer = function ChromePointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        transform: 'translate(-6px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointer;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChromePointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = ChromePointerCircle;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Circle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _materialColors = __webpack_require__(341);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(17);
	
	var _CircleSwatch = __webpack_require__(1035);
	
	var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Circle = exports.Circle = function Circle(_ref) {
	  var width = _ref.width,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        display: 'flex',
	        flexWrap: 'wrap',
	        marginRight: -circleSpacing,
	        marginBottom: -circleSpacing
	      }
	    }
	  });
	
	  var handleChange = function handleChange(hexCode, e) {
	    return onChange({ hex: hexCode, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'circle-picker ' + className },
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_CircleSwatch2.default, {
	        key: c,
	        color: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover,
	        active: hex === c.toLowerCase(),
	        circleSize: circleSize,
	        circleSpacing: circleSpacing
	      });
	    })
	  );
	};
	
	Circle.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  circleSize: _propTypes2.default.number,
	  circleSpacing: _propTypes2.default.number
	};
	
	Circle.defaultProps = {
	  width: 252,
	  circleSize: 28,
	  circleSpacing: 14,
	  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']]
	};
	
	exports.default = (0, _common.ColorWrap)(Circle);

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CircleSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
	  var color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      hover = _ref.hover,
	      active = _ref.active,
	      circleSize = _ref.circleSize,
	      circleSpacing = _ref.circleSpacing;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: circleSize,
	        height: circleSize,
	        marginRight: circleSpacing,
	        marginBottom: circleSpacing,
	        transform: 'scale(1)',
	        transition: '100ms transform ease'
	      },
	      Swatch: {
	        borderRadius: '50%',
	        background: 'transparent',
	        boxShadow: 'inset 0 0 0 ' + circleSize / 2 + 'px ' + color,
	        transition: '100ms box-shadow ease'
	      }
	    },
	    'hover': {
	      swatch: {
	        transform: 'scale(1.2)'
	      }
	    },
	    'active': {
	      Swatch: {
	        boxShadow: 'inset 0 0 0 3px ' + color
	      }
	    }
	  }, { hover: hover, active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      style: styles.Swatch,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
	    })
	  );
	};
	
	CircleSwatch.defaultProps = {
	  circleSize: 28,
	  circleSpacing: 14
	};
	
	exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Alpha = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _alpha = __webpack_require__(1067);
	
	var alpha = _interopRequireWildcard(_alpha);
	
	var _Checkboard = __webpack_require__(462);
	
	var _Checkboard2 = _interopRequireDefault(_Checkboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Alpha = exports.Alpha = function (_ref) {
	  _inherits(Alpha, _ref);
	
	  function Alpha() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Alpha);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = alpha.calculateChange(e, skip, _this.props, _this.container);
	      change && _this.props.onChange && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleChange);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Alpha, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var rgb = this.props.rgb;
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          alpha: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          checkboard: {
	            absolute: '0px 0px 0px 0px',
	            overflow: 'hidden',
	            borderRadius: this.props.radius
	          },
	          gradient: {
	            absolute: '0px 0px 0px 0px',
	            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          container: {
	            position: 'relative',
	            height: '100%',
	            margin: '0 3px'
	          },
	          pointer: {
	            position: 'absolute',
	            left: rgb.a * 100 + '%'
	          },
	          slider: {
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            marginTop: '1px',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          gradient: {
	            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
	          },
	          pointer: {
	            left: 0,
	            top: rgb.a * 100 + '%'
	          }
	        },
	        'overwrite': _extends({}, this.props.style)
	      }, {
	        vertical: this.props.direction === 'vertical',
	        overwrite: true
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.alpha },
	        _react2.default.createElement(
	          'div',
	          { style: styles.checkboard },
	          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
	        ),
	        _react2.default.createElement('div', { style: styles.gradient }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Alpha;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Alpha;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditableInput = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var EditableInput = exports.EditableInput = function (_ref) {
	  _inherits(EditableInput, _ref);
	
	  function EditableInput(props) {
	    _classCallCheck(this, EditableInput);
	
	    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
	
	    _this.handleBlur = function () {
	      if (_this.state.blurValue) {
	        _this.setState({ value: _this.state.blurValue, blurValue: null });
	      }
	    };
	
	    _this.handleChange = function (e) {
	      if (_this.props.label) {
	        _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, e.target.value), e);
	      } else {
	        _this.props.onChange && _this.props.onChange(e.target.value, e);
	      }
	
	      _this.setState({ value: e.target.value });
	    };
	
	    _this.handleKeyDown = function (e) {
	      // In case `e.target.value` is a percentage remove the `%` character
	      // and update accordingly with a percentage
	      // https://github.com/casesandberg/react-color/issues/383
	      var stringValue = String(e.target.value);
	      var isPercentage = stringValue.indexOf('%') > -1;
	      var number = Number(stringValue.replace(/%/g, ''));
	      if (!isNaN(number)) {
	        var amount = _this.props.arrowOffset || 1;
	
	        // Up
	        if (e.keyCode === 38) {
	          if (_this.props.label !== null) {
	            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number + amount), e);
	          } else {
	            _this.props.onChange && _this.props.onChange(number + amount, e);
	          }
	
	          if (isPercentage) {
	            _this.setState({ value: number + amount + '%' });
	          } else {
	            _this.setState({ value: number + amount });
	          }
	        }
	
	        // Down
	        if (e.keyCode === 40) {
	          if (_this.props.label !== null) {
	            _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, number - amount), e);
	          } else {
	            _this.props.onChange && _this.props.onChange(number - amount, e);
	          }
	
	          if (isPercentage) {
	            _this.setState({ value: number - amount + '%' });
	          } else {
	            _this.setState({ value: number - amount });
	          }
	        }
	      }
	    };
	
	    _this.handleDrag = function (e) {
	      if (_this.props.dragLabel) {
	        var newValue = Math.round(_this.props.value + e.movementX);
	        if (newValue >= 0 && newValue <= _this.props.dragMax) {
	          _this.props.onChange && _this.props.onChange(_defineProperty({}, _this.props.label, newValue), e);
	        }
	      }
	    };
	
	    _this.handleMouseDown = function (e) {
	      if (_this.props.dragLabel) {
	        e.preventDefault();
	        _this.handleDrag(e);
	        window.addEventListener('mousemove', _this.handleDrag);
	        window.addEventListener('mouseup', _this.handleMouseUp);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.unbindEventListeners = function () {
	      window.removeEventListener('mousemove', _this.handleDrag);
	      window.removeEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.state = {
	      value: String(props.value).toUpperCase(),
	      blurValue: String(props.value).toUpperCase()
	    };
	    return _this;
	  }
	
	  _createClass(EditableInput, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var input = this.input;
	      if (nextProps.value !== this.state.value) {
	        if (input === document.activeElement) {
	          this.setState({ blurValue: String(nextProps.value).toUpperCase() });
	        } else {
	          this.setState({ value: String(nextProps.value).toUpperCase(), blurValue: !this.state.blurValue && String(nextProps.value).toUpperCase() });
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          wrap: {
	            position: 'relative'
	          }
	        },
	        'user-override': {
	          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
	          input: this.props.style && this.props.style.input ? this.props.style.input : {},
	          label: this.props.style && this.props.style.label ? this.props.style.label : {}
	        },
	        'dragLabel-true': {
	          label: {
	            cursor: 'ew-resize'
	          }
	        }
	      }, {
	        'user-override': true
	      }, this.props);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.wrap },
	        _react2.default.createElement('input', {
	          style: styles.input,
	          ref: function ref(input) {
	            return _this2.input = input;
	          },
	          value: this.state.value,
	          onKeyDown: this.handleKeyDown,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          placeholder: this.props.placeholder,
	          spellCheck: 'false'
	        }),
	        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
	          'span',
	          { style: styles.label, onMouseDown: this.handleMouseDown },
	          this.props.label
	        ) : null
	      );
	    }
	  }]);
	
	  return EditableInput;
	}(_react.PureComponent || _react.Component);
	
	exports.default = EditableInput;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Hue = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _hue = __webpack_require__(1069);
	
	var hue = _interopRequireWildcard(_hue);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hue = exports.Hue = function (_ref) {
	  _inherits(Hue, _ref);
	
	  function Hue() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Hue);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e, skip) {
	      var change = hue.calculateChange(e, skip, _this.props, _this.container);
	      change && _this.props.onChange && _this.props.onChange(change, e);
	    }, _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    }, _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Hue, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$direction = this.props.direction,
	          direction = _props$direction === undefined ? 'horizontal' : _props$direction;
	
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          hue: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius,
	            boxShadow: this.props.shadow
	          },
	          container: {
	            padding: '0 2px',
	            position: 'relative',
	            height: '100%',
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            left: this.props.hsl.h * 100 / 360 + '%'
	          },
	          slider: {
	            marginTop: '1px',
	            width: '4px',
	            borderRadius: '1px',
	            height: '8px',
	            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
	            background: '#fff',
	            transform: 'translateX(-2px)'
	          }
	        },
	        'vertical': {
	          pointer: {
	            left: '0px',
	            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
	          }
	        }
	      }, { vertical: direction === 'vertical' });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.hue },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'hue-' + direction,
	            style: styles.container,
	            ref: function ref(container) {
	              return _this2.container = container;
	            },
	            onMouseDown: this.handleMouseDown,
	            onTouchMove: this.handleChange,
	            onTouchStart: this.handleChange
	          },
	          _react2.default.createElement(
	            'style',
	            null,
	            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Hue;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Hue;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Raised = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Raised = exports.Raised = function Raised(_ref) {
	  var zDepth = _ref.zDepth,
	      radius = _ref.radius,
	      background = _ref.background,
	      children = _ref.children;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      wrap: {
	        position: 'relative',
	        display: 'inline-block'
	      },
	      content: {
	        position: 'relative'
	      },
	      bg: {
	        absolute: '0px 0px 0px 0px',
	        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
	        borderRadius: radius,
	        background: background
	      }
	    },
	    'zDepth-0': {
	      bg: {
	        boxShadow: 'none'
	      }
	    },
	
	    'zDepth-1': {
	      bg: {
	        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
	      }
	    },
	    'zDepth-2': {
	      bg: {
	        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
	      }
	    },
	    'zDepth-3': {
	      bg: {
	        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
	      }
	    },
	    'zDepth-4': {
	      bg: {
	        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
	      }
	    },
	    'zDepth-5': {
	      bg: {
	        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
	      }
	    },
	    'square': {
	      bg: {
	        borderRadius: '0'
	      }
	    },
	    'circle': {
	      bg: {
	        borderRadius: '50%'
	      }
	    }
	  }, { 'zDepth-1': zDepth === 1 });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.wrap },
	    _react2.default.createElement('div', { style: styles.bg }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.content },
	      children
	    )
	  );
	};
	
	Raised.propTypes = {
	  background: _propTypes2.default.string,
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
	  radius: _propTypes2.default.number
	};
	
	Raised.defaultProps = {
	  background: '#fff',
	  zDepth: 1,
	  radius: 2
	};
	
	exports.default = Raised;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Saturation = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _throttle = __webpack_require__(1007);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _saturation = __webpack_require__(1071);
	
	var saturation = _interopRequireWildcard(_saturation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Saturation = exports.Saturation = function (_ref) {
	  _inherits(Saturation, _ref);
	
	  function Saturation(props) {
	    _classCallCheck(this, Saturation);
	
	    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
	
	    _this.handleChange = function (e, skip) {
	      _this.props.onChange && _this.throttle(_this.props.onChange, saturation.calculateChange(e, skip, _this.props, _this.container), e);
	    };
	
	    _this.handleMouseDown = function (e) {
	      _this.handleChange(e, true);
	      window.addEventListener('mousemove', _this.handleChange);
	      window.addEventListener('mouseup', _this.handleMouseUp);
	    };
	
	    _this.handleMouseUp = function () {
	      _this.unbindEventListeners();
	    };
	
	    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
	      fn(data, e);
	    }, 50);
	    return _this;
	  }
	
	  _createClass(Saturation, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unbindEventListeners();
	    }
	  }, {
	    key: 'unbindEventListeners',
	    value: function unbindEventListeners() {
	      window.removeEventListener('mousemove', this.handleChange);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _ref2 = this.props.style || {},
	          color = _ref2.color,
	          white = _ref2.white,
	          black = _ref2.black,
	          pointer = _ref2.pointer,
	          circle = _ref2.circle;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          color: {
	            absolute: '0px 0px 0px 0px',
	            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
	            borderRadius: this.props.radius
	          },
	          white: {
	            absolute: '0px 0px 0px 0px',
	            borderRadius: this.props.radius
	          },
	          black: {
	            absolute: '0px 0px 0px 0px',
	            boxShadow: this.props.shadow,
	            borderRadius: this.props.radius
	          },
	          pointer: {
	            position: 'absolute',
	            top: -(this.props.hsv.v * 100) + 100 + '%',
	            left: this.props.hsv.s * 100 + '%',
	            cursor: 'default'
	          },
	          circle: {
	            width: '4px',
	            height: '4px',
	            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
	            borderRadius: '50%',
	            cursor: 'hand',
	            transform: 'translate(-2px, -2px)'
	          }
	        },
	        'custom': {
	          color: color,
	          white: white,
	          black: black,
	          pointer: pointer,
	          circle: circle
	        }
	      }, { 'custom': !!this.props.style });
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: styles.color,
	          ref: function ref(container) {
	            return _this2.container = container;
	          },
	          onMouseDown: this.handleMouseDown,
	          onTouchMove: this.handleChange,
	          onTouchStart: this.handleChange
	        },
	        _react2.default.createElement(
	          'style',
	          null,
	          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.white, className: 'saturation-white' },
	          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.pointer },
	            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Saturation;
	}(_react.PureComponent || _react.Component);
	
	exports.default = Saturation;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _interaction = __webpack_require__(1070);
	
	var _ = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ENTER = 13;
	
	var Swatch = exports.Swatch = function Swatch(_ref) {
	  var color = _ref.color,
	      style = _ref.style,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onHover = _ref.onHover,
	      _ref$title = _ref.title,
	      title = _ref$title === undefined ? color : _ref$title,
	      children = _ref.children,
	      focus = _ref.focus,
	      _ref$focusStyle = _ref.focusStyle,
	      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
	
	  var transparent = color === 'transparent';
	  var styles = (0, _reactcss2.default)({
	    default: {
	      swatch: _extends({
	        background: color,
	        height: '100%',
	        width: '100%',
	        cursor: 'pointer',
	        position: 'relative',
	        outline: 'none'
	      }, style, focus ? focusStyle : {})
	    }
	  });
	
	  var handleClick = function handleClick(e) {
	    return onClick(color, e);
	  };
	  var handleKeyDown = function handleKeyDown(e) {
	    return e.keyCode === ENTER && onClick(color, e);
	  };
	  var handleHover = function handleHover(e) {
	    return onHover(color, e);
	  };
	
	  var optionalEvents = {};
	  if (onHover) {
	    optionalEvents.onMouseOver = handleHover;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    _extends({
	      style: styles.swatch,
	      onClick: handleClick,
	      title: title,
	      tabIndex: 0,
	      onKeyDown: handleKeyDown
	    }, optionalEvents),
	    children,
	    transparent && _react2.default.createElement(_.Checkboard, {
	      borderRadius: styles.swatch.borderRadius,
	      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
	    })
	  );
	};
	
	exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Compact = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	var _CompactColor = __webpack_require__(1043);
	
	var _CompactColor2 = _interopRequireDefault(_CompactColor);
	
	var _CompactFields = __webpack_require__(1044);
	
	var _CompactFields2 = _interopRequireDefault(_CompactFields);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Compact = exports.Compact = function Compact(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      Compact: {
	        background: '#f6f6f6',
	        radius: '4px'
	      },
	      compact: {
	        paddingTop: '5px',
	        paddingLeft: '5px',
	        boxSizing: 'initial',
	        width: '240px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else {
	      onChange(data, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    { style: styles.Compact },
	    _react2.default.createElement(
	      'div',
	      { style: styles.compact, className: 'compact-picker ' + className },
	      _react2.default.createElement(
	        'div',
	        null,
	        (0, _map2.default)(colors, function (c) {
	          return _react2.default.createElement(_CompactColor2.default, {
	            key: c,
	            color: c,
	            active: c.toLowerCase() === hex,
	            onClick: handleChange,
	            onSwatchHover: onSwatchHover
	          });
	        }),
	        _react2.default.createElement('div', { style: styles.clear })
	      ),
	      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
	    )
	  );
	};
	
	Compact.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	Compact.defaultProps = {
	  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E']
	};
	
	exports.default = (0, _common.ColorWrap)(Compact);

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactColor = exports.CompactColor = function CompactColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        background: color,
	        width: '15px',
	        height: '15px',
	        float: 'left',
	        marginRight: '5px',
	        marginBottom: '5px',
	        position: 'relative',
	        cursor: 'pointer'
	      },
	      dot: {
	        absolute: '5px 5px 5px 5px',
	        background: _color2.default.getContrastingColor(color),
	        borderRadius: '50%',
	        opacity: '0'
	      }
	    },
	    'active': {
	      dot: {
	        opacity: '1'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      dot: {
	        background: '#000'
	      }
	    },
	    'transparent': {
	      dot: {
	        background: '#000'
	      }
	    }
	  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      style: styles.color,
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement('div', { style: styles.dot })
	  );
	};
	
	exports.default = CompactColor;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CompactFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CompactFields = exports.CompactFields = function CompactFields(_ref) {
	  var hex = _ref.hex,
	      rgb = _ref.rgb,
	      onChange = _ref.onChange;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingBottom: '6px',
	        paddingRight: '5px',
	        position: 'relative'
	      },
	      active: {
	        position: 'absolute',
	        top: '6px',
	        left: '5px',
	        height: '9px',
	        width: '9px',
	        background: hex
	      },
	      HEXwrap: {
	        flex: '6',
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '80%',
	        padding: '0px',
	        paddingLeft: '20%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      HEXlabel: {
	        display: 'none'
	      },
	      RGBwrap: {
	        flex: '3',
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '70%',
	        padding: '0px',
	        paddingLeft: '30%',
	        border: 'none',
	        outline: 'none',
	        background: 'none',
	        fontSize: '12px',
	        color: '#333',
	        height: '16px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '3px',
	        left: '0px',
	        lineHeight: '16px',
	        textTransform: 'uppercase',
	        fontSize: '12px',
	        color: '#999'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else {
	      onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement('div', { style: styles.active }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: 'hex',
	      value: hex,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    })
	  );
	};
	
	exports.default = CompactFields;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Github = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _common = __webpack_require__(17);
	
	var _GithubSwatch = __webpack_require__(1046);
	
	var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Github = exports.Github = function Github(_ref) {
	  var width = _ref.width,
	      colors = _ref.colors,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      triangle = _ref.triangle,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '1px solid rgba(0,0,0,0.2)',
	        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
	        borderRadius: '4px',
	        position: 'relative',
	        padding: '5px',
	        display: 'flex',
	        flexWrap: 'wrap'
	      },
	      triangle: {
	        position: 'absolute',
	        border: '7px solid transparent',
	        borderBottomColor: '#fff'
	      },
	      triangleShadow: {
	        position: 'absolute',
	        border: '8px solid transparent',
	        borderBottomColor: 'rgba(0,0,0,0.15)'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-14px',
	        left: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        left: '9px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-14px',
	        right: '10px'
	      },
	      triangleShadow: {
	        top: '-16px',
	        right: '9px'
	      }
	    },
	    'bottom-left-triangle': {
	      triangle: {
	        top: '35px',
	        left: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        left: '9px',
	        transform: 'rotate(180deg)'
	      }
	    },
	    'bottom-right-triangle': {
	      triangle: {
	        top: '35px',
	        right: '10px',
	        transform: 'rotate(180deg)'
	      },
	      triangleShadow: {
	        top: '37px',
	        right: '9px',
	        transform: 'rotate(180deg)'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right',
	    'bottom-left-triangle': triangle == 'bottom-left',
	    'bottom-right-triangle': triangle === 'bottom-right'
	  });
	
	  var handleChange = function handleChange(hex, e) {
	    return onChange({ hex: hex, source: 'hex' }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'github-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    (0, _map2.default)(colors, function (c) {
	      return _react2.default.createElement(_GithubSwatch2.default, {
	        color: c,
	        key: c,
	        onClick: handleChange,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	Github.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right'])
	};
	
	Github.defaultProps = {
	  width: 200,
	  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Github);

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GithubSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
	  var hover = _ref.hover,
	      color = _ref.color,
	      onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var hoverSwatch = {
	    position: 'relative',
	    zIndex: '2',
	    outline: '2px solid #fff',
	    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
	  };
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        width: '25px',
	        height: '25px',
	        fontSize: '0'
	      }
	    },
	    'hover': {
	      swatch: hoverSwatch
	    }
	  }, { hover: hover });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatch },
	    _react2.default.createElement(_common.Swatch, {
	      color: color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: hoverSwatch
	    })
	  );
	};
	
	exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HuePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	var _HuePointer = __webpack_require__(1048);
	
	var _HuePointer2 = _interopRequireDefault(_HuePointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HuePicker = exports.HuePicker = function HuePicker(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      hsl = _ref.hsl,
	      direction = _ref.direction,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        position: 'relative',
	        width: width,
	        height: height
	      },
	      hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  // Overwrite to provide pure hue color
	  var handleChange = function handleChange(data) {
	    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'hue-picker ' + className },
	    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
	      hsl: hsl,
	      pointer: pointer,
	      onChange: handleChange,
	      direction: direction
	    }))
	  );
	};
	
	HuePicker.defaultProps = {
	  width: '316px',
	  height: '16px',
	  direction: 'horizontal',
	  pointer: _HuePointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
	  var direction = _ref.direction;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '18px',
	        height: '18px',
	        borderRadius: '50%',
	        transform: 'translate(-9px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    },
	    'vertical': {
	      picker: {
	        transform: 'translate(-3px, -9px)'
	      }
	    }
	  }, { vertical: direction === 'vertical' });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Material = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Material = exports.Material = function Material(_ref) {
	  var onChange = _ref.onChange,
	      hex = _ref.hex,
	      rgb = _ref.rgb,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      material: {
	        width: '98px',
	        height: '98px',
	        padding: '16px',
	        fontFamily: 'Roboto'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '2px solid ' + hex,
	        outline: 'none',
	        height: '30px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      Hex: {
	        style: {}
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        width: '100%',
	        marginTop: '12px',
	        fontSize: '15px',
	        color: '#333',
	        padding: '0px',
	        border: '0px',
	        borderBottom: '1px solid #eee',
	        outline: 'none',
	        height: '30px'
	      },
	      RGBlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        fontSize: '11px',
	        color: '#999999',
	        textTransform: 'capitalize'
	      },
	      split: {
	        display: 'flex',
	        marginRight: '-10px',
	        paddingTop: '11px'
	      },
	      third: {
	        flex: '1',
	        paddingRight: '10px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    _common.Raised,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.material, className: 'material-picker ' + className },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	        label: 'hex',
	        value: hex,
	        onChange: handleChange
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.split, className: 'flexbox-fix' },
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'r', value: rgb.r,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'g',
	            value: rgb.g,
	            onChange: handleChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.third },
	          _react2.default.createElement(_common.EditableInput, {
	            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	            label: 'b',
	            value: rgb.b,
	            onChange: handleChange
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _common.ColorWrap)(Material);

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Photoshop = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	var _PhotoshopFields = __webpack_require__(1052);
	
	var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);
	
	var _PhotoshopPointerCircle = __webpack_require__(1054);
	
	var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);
	
	var _PhotoshopPointer = __webpack_require__(1053);
	
	var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);
	
	var _PhotoshopButton = __webpack_require__(1051);
	
	var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);
	
	var _PhotoshopPreviews = __webpack_require__(1055);
	
	var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Photoshop = exports.Photoshop = function (_React$Component) {
	  _inherits(Photoshop, _React$Component);
	
	  function Photoshop(props) {
	    _classCallCheck(this, Photoshop);
	
	    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
	
	    _this.state = {
	      currentColor: props.hex
	    };
	    return _this;
	  }
	
	  _createClass(Photoshop, [{
	    key: 'render',
	    value: function render() {
	      var _props$className = this.props.className,
	          className = _props$className === undefined ? '' : _props$className;
	
	      var styles = (0, _reactcss2.default)({
	        'default': {
	          picker: {
	            background: '#DCDCDC',
	            borderRadius: '4px',
	            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
	            boxSizing: 'initial',
	            width: '513px'
	          },
	          head: {
	            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
	            borderBottom: '1px solid #B1B1B1',
	            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
	            height: '23px',
	            lineHeight: '24px',
	            borderRadius: '4px 4px 0 0',
	            fontSize: '13px',
	            color: '#4D4D4D',
	            textAlign: 'center'
	          },
	          body: {
	            padding: '15px 15px 0',
	            display: 'flex'
	          },
	          saturation: {
	            width: '256px',
	            height: '256px',
	            position: 'relative',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0',
	            overflow: 'hidden'
	          },
	          hue: {
	            position: 'relative',
	            height: '256px',
	            width: '19px',
	            marginLeft: '10px',
	            border: '2px solid #B3B3B3',
	            borderBottom: '2px solid #F0F0F0'
	          },
	          controls: {
	            width: '180px',
	            marginLeft: '10px'
	          },
	          top: {
	            display: 'flex'
	          },
	          previews: {
	            width: '60px'
	          },
	          actions: {
	            flex: '1',
	            marginLeft: '20px'
	          }
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.picker, className: 'photoshop-picker ' + className },
	        _react2.default.createElement(
	          'div',
	          { style: styles.head },
	          this.props.header
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.body, className: 'flexbox-fix' },
	          _react2.default.createElement(
	            'div',
	            { style: styles.saturation },
	            _react2.default.createElement(_common.Saturation, {
	              hsl: this.props.hsl,
	              hsv: this.props.hsv,
	              pointer: _PhotoshopPointerCircle2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.hue },
	            _react2.default.createElement(_common.Hue, {
	              direction: 'vertical',
	              hsl: this.props.hsl,
	              pointer: _PhotoshopPointer2.default,
	              onChange: this.props.onChange
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.controls },
	            _react2.default.createElement(
	              'div',
	              { style: styles.top, className: 'flexbox-fix' },
	              _react2.default.createElement(
	                'div',
	                { style: styles.previews },
	                _react2.default.createElement(_PhotoshopPreviews2.default, {
	                  rgb: this.props.rgb,
	                  currentColor: this.state.currentColor
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: styles.actions },
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
	                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
	                _react2.default.createElement(_PhotoshopFields2.default, {
	                  onChange: this.props.onChange,
	                  rgb: this.props.rgb,
	                  hsv: this.props.hsv,
	                  hex: this.props.hex
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Photoshop;
	}(_react2.default.Component);
	
	Photoshop.propTypes = {
	  header: _propTypes2.default.string
	};
	
	Photoshop.defaultProps = {
	  header: 'Color Picker'
	};
	
	exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopBotton = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopBotton = exports.PhotoshopBotton = function PhotoshopBotton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      children = _ref.children,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      button: {
	        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
	        border: '1px solid #878787',
	        borderRadius: '2px',
	        height: '20px',
	        boxShadow: '0 1px 0 0 #EAEAEA',
	        fontSize: '14px',
	        color: '#000',
	        lineHeight: '20px',
	        textAlign: 'center',
	        marginBottom: '10px',
	        cursor: 'pointer'
	      }
	    },
	    'active': {
	      button: {
	        boxShadow: '0 0 0 1px #878787'
	      }
	    }
	  }, { active: active });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.button, onClick: onClick },
	    label || children
	  );
	};
	
	exports.default = PhotoshopBotton;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPicker = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsv = _ref.hsv,
	      hex = _ref.hex;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        paddingTop: '5px',
	        paddingBottom: '9px',
	        width: '80px',
	        position: 'relative'
	      },
	      divider: {
	        height: '5px'
	      },
	      RGBwrap: {
	        position: 'relative'
	      },
	      RGBinput: {
	        marginLeft: '40%',
	        width: '40%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '5px',
	        fontSize: '13px',
	        paddingLeft: '3px',
	        marginRight: '10px'
	      },
	      RGBlabel: {
	        left: '0px',
	        width: '34px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px',
	        position: 'absolute'
	      },
	      HEXwrap: {
	        position: 'relative'
	      },
	      HEXinput: {
	        marginLeft: '20%',
	        width: '80%',
	        height: '18px',
	        border: '1px solid #888888',
	        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
	        marginBottom: '6px',
	        fontSize: '13px',
	        paddingLeft: '3px'
	      },
	      HEXlabel: {
	        position: 'absolute',
	        top: '0px',
	        left: '0px',
	        width: '14px',
	        textTransform: 'uppercase',
	        fontSize: '13px',
	        height: '18px',
	        lineHeight: '22px'
	      },
	      fieldSymbols: {
	        position: 'absolute',
	        top: '5px',
	        right: '-7px',
	        fontSize: '13px'
	      },
	      symbol: {
	        height: '20px',
	        lineHeight: '22px',
	        paddingBottom: '7px'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    if (data['#']) {
	      _color2.default.isValidHex(data['#']) && onChange({
	        hex: data['#'],
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        source: 'rgb'
	      }, e);
	    } else if (data.h || data.s || data.v) {
	      onChange({
	        h: data.h || hsv.h,
	        s: data.s || hsv.s,
	        v: data.v || hsv.v,
	        source: 'hsv'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields },
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'h',
	      value: Math.round(hsv.h),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 's',
	      value: Math.round(hsv.s * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'v',
	      value: Math.round(hsv.v * 100),
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'r',
	      value: rgb.r,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'g',
	      value: rgb.g,
	      onChange: handleChange
	    }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
	      label: 'b',
	      value: rgb.b,
	      onChange: handleChange
	    }),
	    _react2.default.createElement('div', { style: styles.divider }),
	    _react2.default.createElement(_common.EditableInput, {
	      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
	      label: '#',
	      value: hex.replace('#', ''),
	      onChange: handleChange
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.fieldSymbols },
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '\xB0'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.symbol },
	        '%'
	      )
	    )
	  );
	};
	
	exports.default = PhotoshopPicker;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      triangle: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '4px 0 4px 6px',
	        borderColor: 'transparent transparent transparent #fff',
	        position: 'absolute',
	        top: '1px',
	        left: '1px'
	      },
	      triangleBorder: {
	        width: 0,
	        height: 0,
	        borderStyle: 'solid',
	        borderWidth: '5px 0 5px 8px',
	        borderColor: 'transparent transparent transparent #555'
	      },
	
	      left: {
	        Extend: 'triangleBorder',
	        transform: 'translate(-13px, -4px)'
	      },
	      leftInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      },
	
	      right: {
	        Extend: 'triangleBorder',
	        transform: 'translate(20px, -14px) rotate(180deg)'
	      },
	      rightInside: {
	        Extend: 'triangle',
	        transform: 'translate(-8px, -5px)'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.pointer },
	    _react2.default.createElement(
	      'div',
	      { style: styles.left },
	      _react2.default.createElement('div', { style: styles.leftInside })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.right },
	      _react2.default.createElement('div', { style: styles.rightInside })
	    )
	  );
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPointerCircle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
	  var hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '12px',
	        height: '12px',
	        borderRadius: '6px',
	        boxShadow: 'inset 0 0 0 1px #fff',
	        transform: 'translate(-6px, -6px)'
	      }
	    },
	    'black-outline': {
	      picker: {
	        boxShadow: 'inset 0 0 0 1px #000'
	      }
	    }
	  }, { 'black-outline': hsl.l > 0.5 });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = PhotoshopPointerCircle;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PhotoshopPreviews = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
	  var rgb = _ref.rgb,
	      currentColor = _ref.currentColor;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        border: '1px solid #B3B3B3',
	        borderBottom: '1px solid #F0F0F0',
	        marginBottom: '2px',
	        marginTop: '1px'
	      },
	      new: {
	        height: '34px',
	        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
	      },
	      current: {
	        height: '34px',
	        background: currentColor,
	        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
	      },
	      label: {
	        fontSize: '14px',
	        color: '#000',
	        textAlign: 'center'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'new'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement('div', { style: styles.new }),
	      _react2.default.createElement('div', { style: styles.current })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.label },
	      'current'
	    )
	  );
	};
	
	exports.default = PhotoshopPreviews;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Sketch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	var _SketchFields = __webpack_require__(1057);
	
	var _SketchFields2 = _interopRequireDefault(_SketchFields);
	
	var _SketchPresetColors = __webpack_require__(1058);
	
	var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sketch = exports.Sketch = function Sketch(_ref) {
	  var width = _ref.width,
	      rgb = _ref.rgb,
	      hex = _ref.hex,
	      hsv = _ref.hsv,
	      hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      disableAlpha = _ref.disableAlpha,
	      presetColors = _ref.presetColors,
	      renderers = _ref.renderers,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        padding: '10px 10px 0',
	        boxSizing: 'initial',
	        background: '#fff',
	        borderRadius: '4px',
	        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
	      },
	      saturation: {
	        width: '100%',
	        paddingBottom: '75%',
	        position: 'relative',
	        overflow: 'hidden'
	      },
	      Saturation: {
	        radius: '3px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      controls: {
	        display: 'flex'
	      },
	      sliders: {
	        padding: '4px 0',
	        flex: '1'
	      },
	      color: {
	        width: '24px',
	        height: '24px',
	        position: 'relative',
	        marginTop: '4px',
	        marginLeft: '4px',
	        borderRadius: '3px'
	      },
	      activeColor: {
	        absolute: '0px 0px 0px 0px',
	        borderRadius: '2px',
	        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	      hue: {
	        position: 'relative',
	        height: '10px',
	        overflow: 'hidden'
	      },
	      Hue: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      },
	
	      alpha: {
	        position: 'relative',
	        height: '10px',
	        marginTop: '4px',
	        overflow: 'hidden'
	      },
	      Alpha: {
	        radius: '2px',
	        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
	      }
	    },
	    'disableAlpha': {
	      color: {
	        height: '10px'
	      },
	      hue: {
	        height: '10px'
	      },
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'sketch-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.saturation },
	      _react2.default.createElement(_common.Saturation, {
	        style: styles.Saturation,
	        hsl: hsl,
	        hsv: hsv,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.controls, className: 'flexbox-fix' },
	      _react2.default.createElement(
	        'div',
	        { style: styles.sliders },
	        _react2.default.createElement(
	          'div',
	          { style: styles.hue },
	          _react2.default.createElement(_common.Hue, {
	            style: styles.Hue,
	            hsl: hsl,
	            onChange: onChange
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.alpha },
	          _react2.default.createElement(_common.Alpha, {
	            style: styles.Alpha,
	            rgb: rgb,
	            hsl: hsl,
	            renderers: renderers,
	            onChange: onChange
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.color },
	        _react2.default.createElement(_common.Checkboard, null),
	        _react2.default.createElement('div', { style: styles.activeColor })
	      )
	    ),
	    _react2.default.createElement(_SketchFields2.default, {
	      rgb: rgb,
	      hsl: hsl,
	      hex: hex,
	      onChange: onChange,
	      disableAlpha: disableAlpha
	    }),
	    _react2.default.createElement(_SketchPresetColors2.default, {
	      colors: presetColors,
	      onClick: onChange,
	      onSwatchHover: onSwatchHover
	    })
	  );
	};
	
	Sketch.propTypes = {
	  disableAlpha: _propTypes2.default.bool,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	Sketch.defaultProps = {
	  disableAlpha: false,
	  width: 200,
	  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
	};
	
	exports.default = (0, _common.ColorWrap)(Sketch);

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchFields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-param-reassign */
	
	var SketchFields = exports.SketchFields = function SketchFields(_ref) {
	  var onChange = _ref.onChange,
	      rgb = _ref.rgb,
	      hsl = _ref.hsl,
	      hex = _ref.hex,
	      disableAlpha = _ref.disableAlpha;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      fields: {
	        display: 'flex',
	        paddingTop: '4px'
	      },
	      single: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      alpha: {
	        flex: '1',
	        paddingLeft: '6px'
	      },
	      double: {
	        flex: '2'
	      },
	      input: {
	        width: '80%',
	        padding: '4px 10% 3px',
	        border: 'none',
	        boxShadow: 'inset 0 0 0 1px #ccc',
	        fontSize: '11px'
	      },
	      label: {
	        display: 'block',
	        textAlign: 'center',
	        fontSize: '11px',
	        color: '#222',
	        paddingTop: '3px',
	        paddingBottom: '4px',
	        textTransform: 'capitalize'
	      }
	    },
	    'disableAlpha': {
	      alpha: {
	        display: 'none'
	      }
	    }
	  }, { disableAlpha: disableAlpha });
	
	  var handleChange = function handleChange(data, e) {
	    if (data.hex) {
	      _color2.default.isValidHex(data.hex) && onChange({
	        hex: data.hex,
	        source: 'hex'
	      }, e);
	    } else if (data.r || data.g || data.b) {
	      onChange({
	        r: data.r || rgb.r,
	        g: data.g || rgb.g,
	        b: data.b || rgb.b,
	        a: rgb.a,
	        source: 'rgb'
	      }, e);
	    } else if (data.a) {
	      if (data.a < 0) {
	        data.a = 0;
	      } else if (data.a > 100) {
	        data.a = 100;
	      }
	
	      data.a /= 100;
	      onChange({
	        h: hsl.h,
	        s: hsl.s,
	        l: hsl.l,
	        a: data.a,
	        source: 'rgb'
	      }, e);
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.fields, className: 'flexbox-fix' },
	    _react2.default.createElement(
	      'div',
	      { style: styles.double },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'hex',
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'r',
	        value: rgb.r,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'g',
	        value: rgb.g,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.single },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'b',
	        value: rgb.b,
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '255'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.alpha },
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input, label: styles.label },
	        label: 'a',
	        value: Math.round(rgb.a * 100),
	        onChange: handleChange,
	        dragLabel: 'true',
	        dragMax: '100'
	      })
	    )
	  );
	};
	
	exports.default = SketchFields;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SketchPresetColors = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
	  var colors = _ref.colors,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      colors: {
	        margin: '0 -10px',
	        padding: '10px 0 0 10px',
	        borderTop: '1px solid #eee',
	        display: 'flex',
	        flexWrap: 'wrap',
	        position: 'relative'
	      },
	      swatchWrap: {
	        width: '16px',
	        height: '16px',
	        margin: '0 10px 10px 0'
	      },
	      swatch: {
	        borderRadius: '3px',
	        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
	      }
	    },
	    'no-presets': {
	      colors: {
	        display: 'none'
	      }
	    }
	  }, {
	    'no-presets': !colors || !colors.length
	  });
	
	  var handleClick = function handleClick(hex, e) {
	    onClick({
	      hex: hex,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.colors, className: 'flexbox-fix' },
	    colors.map(function (colorObjOrString) {
	      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
	      var key = '' + c.color + (c.title || '');
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: styles.swatchWrap },
	        _react2.default.createElement(_common.Swatch, _extends({}, c, {
	          style: styles.swatch,
	          onClick: handleClick,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
	          }
	        }))
	      );
	    })
	  );
	};
	
	SketchPresetColors.propTypes = {
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    color: _propTypes2.default.string,
	    title: _propTypes2.default.string
	  })])).isRequired
	};
	
	exports.default = SketchPresetColors;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Slider = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _common = __webpack_require__(17);
	
	var _SliderSwatches = __webpack_require__(1062);
	
	var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);
	
	var _SliderPointer = __webpack_require__(1060);
	
	var _SliderPointer2 = _interopRequireDefault(_SliderPointer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Slider = exports.Slider = function Slider(_ref) {
	  var hsl = _ref.hsl,
	      onChange = _ref.onChange,
	      pointer = _ref.pointer,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      hue: {
	        height: '12px',
	        position: 'relative'
	      },
	      Hue: {
	        radius: '2px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'slider-picker ' + className },
	    _react2.default.createElement(
	      'div',
	      { style: styles.hue },
	      _react2.default.createElement(_common.Hue, {
	        style: styles.Hue,
	        hsl: hsl,
	        pointer: pointer,
	        onChange: onChange
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatches },
	      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
	    )
	  );
	};
	
	Slider.defaultProps = {
	  pointer: _SliderPointer2.default
	};
	
	exports.default = (0, _common.ColorWrap)(Slider);

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderPointer = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderPointer = exports.SliderPointer = function SliderPointer() {
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: '14px',
	        height: '14px',
	        borderRadius: '6px',
	        transform: 'translate(-7px, -1px)',
	        backgroundColor: 'rgb(248, 248, 248)',
	        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
	      }
	    }
	  });
	
	  return _react2.default.createElement('div', { style: styles.picker });
	};
	
	exports.default = SliderPointer;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatch = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
	  var hsl = _ref.hsl,
	      offset = _ref.offset,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      active = _ref.active,
	      first = _ref.first,
	      last = _ref.last;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatch: {
	        height: '12px',
	        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
	        cursor: 'pointer'
	      }
	    },
	    'first': {
	      swatch: {
	        borderRadius: '2px 0 0 2px'
	      }
	    },
	    'last': {
	      swatch: {
	        borderRadius: '0 2px 2px 0'
	      }
	    },
	    'active': {
	      swatch: {
	        transform: 'scaleY(1.8)',
	        borderRadius: '3.6px/2px'
	      }
	    }
	  }, { active: active, first: first, last: last });
	
	  var handleClick = function handleClick(e) {
	    return onClick({
	      h: hsl.h,
	      s: 0.5,
	      l: offset,
	      source: 'hsl'
	    }, e);
	  };
	
	  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
	};
	
	exports.default = SliderSwatch;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SliderSwatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _SliderSwatch = __webpack_require__(1061);
	
	var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
	  var onClick = _ref.onClick,
	      hsl = _ref.hsl;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      swatches: {
	        marginTop: '20px'
	      },
	      swatch: {
	        boxSizing: 'border-box',
	        width: '20%',
	        paddingRight: '1px',
	        float: 'left'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.swatches },
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.80',
	        active: Math.round(hsl.l * 100) / 100 === 0.80 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        first: true
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.65',
	        active: Math.round(hsl.l * 100) / 100 === 0.65 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.50',
	        active: Math.round(hsl.l * 100) / 100 === 0.50 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.35',
	        active: Math.round(hsl.l * 100) / 100 === 0.35 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: styles.swatch },
	      _react2.default.createElement(_SliderSwatch2.default, {
	        hsl: hsl,
	        offset: '.20',
	        active: Math.round(hsl.l * 100) / 100 === 0.20 && Math.round(hsl.s * 100) / 100 === 0.50,
	        onClick: onClick,
	        last: true
	      })
	    ),
	    _react2.default.createElement('div', { style: styles.clear })
	  );
	};
	
	exports.default = SliderSwatches;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Swatches = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _materialColors = __webpack_require__(341);
	
	var material = _interopRequireWildcard(_materialColors);
	
	var _common = __webpack_require__(17);
	
	var _SwatchesGroup = __webpack_require__(1065);
	
	var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Swatches = exports.Swatches = function Swatches(_ref) {
	  var width = _ref.width,
	      height = _ref.height,
	      onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      colors = _ref.colors,
	      hex = _ref.hex,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      picker: {
	        width: width,
	        height: height
	      },
	      overflow: {
	        height: height,
	        overflowY: 'scroll'
	      },
	      body: {
	        padding: '16px 0 6px 16px'
	      },
	      clear: {
	        clear: 'both'
	      }
	    }
	  });
	
	  var handleChange = function handleChange(data, e) {
	    _color2.default.isValidHex(data) && onChange({
	      hex: data,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.picker, className: 'swatches-picker ' + className },
	    _react2.default.createElement(
	      _common.Raised,
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: styles.overflow },
	        _react2.default.createElement(
	          'div',
	          { style: styles.body },
	          (0, _map2.default)(colors, function (group) {
	            return _react2.default.createElement(_SwatchesGroup2.default, {
	              key: group.toString(),
	              group: group,
	              active: hex,
	              onClick: handleChange,
	              onSwatchHover: onSwatchHover
	            });
	          }),
	          _react2.default.createElement('div', { style: styles.clear })
	        )
	      )
	    )
	  );
	};
	
	Swatches.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string))
	
	  /* eslint-disable max-len */
	};Swatches.defaultProps = {
	  width: 320,
	  height: 240,
	  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']]
	};
	
	exports.default = (0, _common.ColorWrap)(Swatches);

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesColor = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
	  var color = _ref.color,
	      _ref$onClick = _ref.onClick,
	      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      first = _ref.first,
	      last = _ref.last,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      color: {
	        width: '40px',
	        height: '24px',
	        cursor: 'pointer',
	        background: color,
	        marginBottom: '1px'
	      },
	      check: {
	        fill: _color2.default.getContrastingColor(color),
	        marginLeft: '8px',
	        display: 'none'
	      }
	    },
	    'first': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '2px 2px 0 0'
	      }
	    },
	    'last': {
	      color: {
	        overflow: 'hidden',
	        borderRadius: '0 0 2px 2px'
	      }
	    },
	    'active': {
	      check: {
	        display: 'block'
	      }
	    },
	    'color-#FFFFFF': {
	      color: {
	        boxShadow: 'inset 0 0 0 1px #ddd'
	      },
	      check: {
	        fill: '#333'
	      }
	    },
	    'transparent': {
	      check: {
	        fill: '#333'
	      }
	    }
	  }, {
	    first: first,
	    last: last,
	    active: active,
	    'color-#FFFFFF': color === '#FFFFFF',
	    'transparent': color === 'transparent'
	  });
	
	  return _react2.default.createElement(
	    _common.Swatch,
	    {
	      color: color,
	      style: styles.color,
	      onClick: onClick,
	      onHover: onSwatchHover,
	      focusStyle: { boxShadow: '0 0 4px ' + color }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: styles.check },
	      _react2.default.createElement(
	        'svg',
	        { style: { width: '24px', height: '24px' }, viewBox: '0 0 24 24' },
	        _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
	      )
	    )
	  );
	};
	
	exports.default = SwatchesColor;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SwatchesGroup = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _SwatchesColor = __webpack_require__(1064);
	
	var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
	  var onClick = _ref.onClick,
	      onSwatchHover = _ref.onSwatchHover,
	      group = _ref.group,
	      active = _ref.active;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      group: {
	        paddingBottom: '10px',
	        width: '40px',
	        float: 'left',
	        marginRight: '10px'
	      }
	    }
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.group },
	    (0, _map2.default)(group, function (color, i) {
	      return _react2.default.createElement(_SwatchesColor2.default, {
	        key: color,
	        color: color,
	        active: color.toLowerCase() === active,
	        first: i === 0,
	        last: i === group.length - 1,
	        onClick: onClick,
	        onSwatchHover: onSwatchHover
	      });
	    })
	  );
	};
	
	exports.default = SwatchesGroup;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Twitter = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactcss = __webpack_require__(7);
	
	var _reactcss2 = _interopRequireDefault(_reactcss);
	
	var _map = __webpack_require__(76);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _color = __webpack_require__(54);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _common = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Twitter = exports.Twitter = function Twitter(_ref) {
	  var onChange = _ref.onChange,
	      onSwatchHover = _ref.onSwatchHover,
	      hex = _ref.hex,
	      colors = _ref.colors,
	      width = _ref.width,
	      triangle = _ref.triangle,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className;
	
	  var styles = (0, _reactcss2.default)({
	    'default': {
	      card: {
	        width: width,
	        background: '#fff',
	        border: '0 solid rgba(0,0,0,0.25)',
	        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
	        borderRadius: '4px',
	        position: 'relative'
	      },
	      body: {
	        padding: '15px 9px 9px 15px'
	      },
	      label: {
	        fontSize: '18px',
	        color: '#fff'
	      },
	      triangle: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent #fff transparent',
	        position: 'absolute'
	      },
	      triangleShadow: {
	        width: '0px',
	        height: '0px',
	        borderStyle: 'solid',
	        borderWidth: '0 9px 10px 9px',
	        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
	        position: 'absolute'
	      },
	      hash: {
	        background: '#F0F0F0',
	        height: '30px',
	        width: '30px',
	        borderRadius: '4px 0 0 4px',
	        float: 'left',
	        color: '#98A1A4',
	        display: 'flex',
	        alignItems: 'center',
	        justifyContent: 'center'
	      },
	      input: {
	        width: '100px',
	        fontSize: '14px',
	        color: '#666',
	        border: '0px',
	        outline: 'none',
	        height: '28px',
	        boxShadow: 'inset 0 0 0 1px #F0F0F0',
	        boxSizing: 'content-box',
	        borderRadius: '0 4px 4px 0',
	        float: 'left',
	        paddingLeft: '8px'
	      },
	      swatch: {
	        width: '30px',
	        height: '30px',
	        float: 'left',
	        borderRadius: '4px',
	        margin: '0 6px 6px 0'
	      },
	      clear: {
	        clear: 'both'
	      }
	    },
	    'hide-triangle': {
	      triangle: {
	        display: 'none'
	      },
	      triangleShadow: {
	        display: 'none'
	      }
	    },
	    'top-left-triangle': {
	      triangle: {
	        top: '-10px',
	        left: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        left: '12px'
	      }
	    },
	    'top-right-triangle': {
	      triangle: {
	        top: '-10px',
	        right: '12px'
	      },
	      triangleShadow: {
	        top: '-11px',
	        right: '12px'
	      }
	    }
	  }, {
	    'hide-triangle': triangle === 'hide',
	    'top-left-triangle': triangle === 'top-left',
	    'top-right-triangle': triangle === 'top-right'
	  });
	
	  var handleChange = function handleChange(hexcode, e) {
	    _color2.default.isValidHex(hexcode) && onChange({
	      hex: hexcode,
	      source: 'hex'
	    }, e);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.card, className: 'twitter-picker ' + className },
	    _react2.default.createElement('div', { style: styles.triangleShadow }),
	    _react2.default.createElement('div', { style: styles.triangle }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.body },
	      (0, _map2.default)(colors, function (c, i) {
	        return _react2.default.createElement(_common.Swatch, {
	          key: i,
	          color: c,
	          hex: c,
	          style: styles.swatch,
	          onClick: handleChange,
	          onHover: onSwatchHover,
	          focusStyle: {
	            boxShadow: '0 0 4px ' + c
	          }
	        });
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.hash },
	        '#'
	      ),
	      _react2.default.createElement(_common.EditableInput, {
	        style: { input: styles.input },
	        value: hex.replace('#', ''),
	        onChange: handleChange
	      }),
	      _react2.default.createElement('div', { style: styles.clear })
	    )
	  );
	};
	
	Twitter.propTypes = {
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
	  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
	};
	
	Twitter.defaultProps = {
	  width: 276,
	  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
	  triangle: 'top-left'
	};
	
	exports.default = (0, _common.ColorWrap)(Twitter);

/***/ },
/* 1067 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
	  e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var a = void 0;
	    if (top < 0) {
	      a = 0;
	    } else if (top > containerHeight) {
	      a = 1;
	    } else {
	      a = Math.round(top * 100 / containerHeight) / 100;
	    }
	
	    if (props.hsl.a !== a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _a = void 0;
	    if (left < 0) {
	      _a = 0;
	    } else if (left > containerWidth) {
	      _a = 1;
	    } else {
	      _a = Math.round(left * 100 / containerWidth) / 100;
	    }
	
	    if (props.a !== _a) {
	      return {
	        h: props.hsl.h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: _a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ },
/* 1068 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var checkboardCache = {};
	
	var render = exports.render = function render(c1, c2, size, serverCanvas) {
	  if (typeof document === 'undefined' && !serverCanvas) {
	    return null;
	  }
	  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
	  canvas.width = size * 2;
	  canvas.height = size * 2;
	  var ctx = canvas.getContext('2d');
	  if (!ctx) {
	    return null;
	  } // If no context can be found, return early.
	  ctx.fillStyle = c1;
	  ctx.fillRect(0, 0, canvas.width, canvas.height);
	  ctx.fillStyle = c2;
	  ctx.fillRect(0, 0, size, size);
	  ctx.translate(size, size);
	  ctx.fillRect(0, 0, size, size);
	  return canvas.toDataURL();
	};
	
	var get = exports.get = function get(c1, c2, size, serverCanvas) {
	  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');
	  var checkboard = render(c1, c2, size, serverCanvas);
	
	  if (checkboardCache[key]) {
	    return checkboardCache[key];
	  }
	  checkboardCache[key] = checkboard;
	  return checkboard;
	};

/***/ },
/* 1069 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
	  e.preventDefault();
	  var containerWidth = container.clientWidth;
	  var containerHeight = container.clientHeight;
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (props.direction === 'vertical') {
	    var h = void 0;
	    if (top < 0) {
	      h = 359;
	    } else if (top > containerHeight) {
	      h = 0;
	    } else {
	      var percent = -(top * 100 / containerHeight) + 100;
	      h = 360 * percent / 100;
	    }
	
	    if (props.hsl.h !== h) {
	      return {
	        h: h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  } else {
	    var _h = void 0;
	    if (left < 0) {
	      _h = 0;
	    } else if (left > containerWidth) {
	      _h = 359;
	    } else {
	      var _percent = left * 100 / containerWidth;
	      _h = 360 * _percent / 100;
	    }
	
	    if (props.hsl.h !== _h) {
	      return {
	        h: _h,
	        s: props.hsl.s,
	        l: props.hsl.l,
	        a: props.hsl.a,
	        source: 'rgb'
	      };
	    }
	  }
	  return null;
	};

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleFocus = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */
	
	
	var handleFocus = exports.handleFocus = function handleFocus(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	  return function (_React$Component) {
	    _inherits(Focus, _React$Component);
	
	    function Focus() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Focus);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
	        return _this.setState({ focus: true });
	      }, _this.handleBlur = function () {
	        return _this.setState({ focus: false });
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(Focus, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(
	          Span,
	          { onFocus: this.handleFocus, onBlur: this.handleBlur },
	          _react2.default.createElement(Component, _extends({}, this.props, this.state))
	        );
	      }
	    }]);
	
	    return Focus;
	  }(_react2.default.Component);
	};

/***/ },
/* 1071 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calculateChange = exports.calculateChange = function calculateChange(e, skip, props, container) {
	  e.preventDefault();
	
	  var _container$getBoundin = container.getBoundingClientRect(),
	      containerWidth = _container$getBoundin.width,
	      containerHeight = _container$getBoundin.height;
	
	  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
	  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
	  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
	  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
	
	  if (left < 0) {
	    left = 0;
	  } else if (left > containerWidth) {
	    left = containerWidth;
	  } else if (top < 0) {
	    top = 0;
	  } else if (top > containerHeight) {
	    top = containerHeight;
	  }
	
	  var saturation = left * 100 / containerWidth;
	  var bright = -(top * 100 / containerHeight) + 100;
	
	  return {
	    h: props.hsl.h,
	    s: saturation,
	    v: bright,
	    a: props.hsl.a,
	    source: 'rgb'
	  };
	};

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;
	
	var _Alpha = __webpack_require__(1026);
	
	Object.defineProperty(exports, 'AlphaPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Alpha).default;
	  }
	});
	
	var _Block = __webpack_require__(1028);
	
	Object.defineProperty(exports, 'BlockPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Block).default;
	  }
	});
	
	var _Circle = __webpack_require__(1034);
	
	Object.defineProperty(exports, 'CirclePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Circle).default;
	  }
	});
	
	var _Chrome = __webpack_require__(1030);
	
	Object.defineProperty(exports, 'ChromePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Chrome).default;
	  }
	});
	
	var _Compact = __webpack_require__(1042);
	
	Object.defineProperty(exports, 'CompactPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Compact).default;
	  }
	});
	
	var _Github = __webpack_require__(1045);
	
	Object.defineProperty(exports, 'GithubPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Github).default;
	  }
	});
	
	var _Hue = __webpack_require__(1047);
	
	Object.defineProperty(exports, 'HuePicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hue).default;
	  }
	});
	
	var _Material = __webpack_require__(1049);
	
	Object.defineProperty(exports, 'MaterialPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Material).default;
	  }
	});
	
	var _Photoshop = __webpack_require__(1050);
	
	Object.defineProperty(exports, 'PhotoshopPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Photoshop).default;
	  }
	});
	
	var _Sketch = __webpack_require__(1056);
	
	Object.defineProperty(exports, 'SketchPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Sketch).default;
	  }
	});
	
	var _Slider = __webpack_require__(1059);
	
	Object.defineProperty(exports, 'SliderPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Slider).default;
	  }
	});
	
	var _Swatches = __webpack_require__(1063);
	
	Object.defineProperty(exports, 'SwatchesPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Swatches).default;
	  }
	});
	
	var _Twitter = __webpack_require__(1066);
	
	Object.defineProperty(exports, 'TwitterPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Twitter).default;
	  }
	});
	
	var _ColorWrap = __webpack_require__(463);
	
	Object.defineProperty(exports, 'CustomPicker', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ColorWrap).default;
	  }
	});
	
	var _Chrome2 = _interopRequireDefault(_Chrome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chrome2.default;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.load = load;
	exports.select = select;
	exports.save = save;
	exports.remove = remove;
	exports.setRawCookie = setRawCookie;
	exports.plugToRequest = plugToRequest;
	
	var _cookie = __webpack_require__(844);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(92);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _isNode = __webpack_require__(904);
	
	var _isNode2 = _interopRequireDefault(_isNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _rawCookie = {};
	var _res = undefined;
	
	function _isResWritable() {
	  return _res && !_res.headersSent;
	}
	
	function load(name, doNotParse, opt) {
	  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie, opt);
	  var cookieVal = cookies && cookies[name];
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (e) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function select(regex) {
	  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie);
	
	  if (!cookies) {
	    return {};
	  }
	
	  if (!regex) {
	    return cookies;
	  }
	
	  return Object.keys(cookies).reduce(function (accumulator, name) {
	    if (!regex.test(name)) {
	      return accumulator;
	    }
	
	    var newCookie = {};
	    newCookie[name] = cookies[name];
	    return (0, _objectAssign2.default)({}, accumulator, newCookie);
	  }, {});
	}
	
	function save(name, val, opt) {
	  _rawCookie[name] = val;
	
	  // allow you to work with cookies as objects.
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    _rawCookie[name] = JSON.stringify(val);
	  }
	
	  // Cookies only work in the browser
	  if (!_isNode2.default) {
	    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
	  }
	
	  if (_isResWritable() && _res.cookie) {
	    var expressOpt = _extends({}, opt);
	    if (expressOpt.maxAge) {
	      // the standard for maxAge is seconds but express uses milliseconds
	      expressOpt.maxAge = opt.maxAge * 1000;
	    }
	
	    _res.cookie(name, val, opt);
	  }
	}
	
	function remove(name, opt) {
	  delete _rawCookie[name];
	
	  if (typeof opt === 'undefined') {
	    opt = {};
	  } else if (typeof opt === 'string') {
	    // Will be deprecated in future versions
	    opt = { path: opt };
	  } else {
	    // Prevent mutation of opt below
	    opt = (0, _objectAssign2.default)({}, opt);
	  }
	
	  if (typeof document !== 'undefined') {
	    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
	    opt.maxAge = 0;
	    document.cookie = _cookie2.default.serialize(name, '', opt);
	  }
	
	  if (_isResWritable() && _res.clearCookie) {
	    _res.clearCookie(name, opt);
	  }
	}
	
	function setRawCookie(rawCookie) {
	  if (rawCookie) {
	    _rawCookie = _cookie2.default.parse(rawCookie);
	  } else {
	    _rawCookie = {};
	  }
	}
	
	function plugToRequest(req, res) {
	  if (req.cookie) {
	    _rawCookie = req.cookie;
	  } else if (req.cookies) {
	    _rawCookie = req.cookies;
	  } else if (req.headers && req.headers.cookie) {
	    setRawCookie(req.headers.cookie);
	  } else {
	    _rawCookie = {};
	  }
	
	  _res = res;
	
	  return function unplug() {
	    _res = null;
	    _rawCookie = {};
	  };
	}
	
	exports.default = {
	  setRawCookie: setRawCookie,
	  load: load,
	  select: select,
	  save: save,
	  remove: remove,
	  plugToRequest: plugToRequest
	};

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(464),
		PropTypes = __webpack_require__(11),
		createClass = __webpack_require__(30),
		moment = __webpack_require__(2),
		React = __webpack_require__(1),
		CalendarContainer = __webpack_require__(1075),
		onClickOutside = __webpack_require__(1110).default
		;
	
	var viewModes = Object.freeze({
		YEARS: 'years',
		MONTHS: 'months',
		DAYS: 'days',
		TIME: 'time',
	});
	
	var TYPES = PropTypes;
	var Datetime = createClass({
		displayName: 'DateTime',
		propTypes: {
			// value: TYPES.object | TYPES.string,
			// defaultValue: TYPES.object | TYPES.string,
			// viewDate: TYPES.object | TYPES.string,
			onFocus: TYPES.func,
			onBlur: TYPES.func,
			onChange: TYPES.func,
			onViewModeChange: TYPES.func,
			onNavigateBack: TYPES.func,
			onNavigateForward: TYPES.func,
			locale: TYPES.string,
			utc: TYPES.bool,
			displayTimeZone: TYPES.string,
			input: TYPES.bool,
			// dateFormat: TYPES.string | TYPES.bool,
			// timeFormat: TYPES.string | TYPES.bool,
			inputProps: TYPES.object,
			timeConstraints: TYPES.object,
			viewMode: TYPES.oneOf([viewModes.YEARS, viewModes.MONTHS, viewModes.DAYS, viewModes.TIME]),
			isValidDate: TYPES.func,
			open: TYPES.bool,
			strictParsing: TYPES.bool,
			closeOnSelect: TYPES.bool,
			closeOnTab: TYPES.bool
		},
	
		getInitialState: function() {
			this.checkTZ( this.props );
			
			var state = this.getStateFromProps( this.props );
	
			if ( state.open === undefined )
				state.open = !this.props.input;
	
			state.currentView = this.props.dateFormat ?
				(this.props.viewMode || state.updateOn || viewModes.DAYS) : viewModes.TIME;
	
			return state;
		},
	
		parseDate: function (date, formats) {
			var parsedDate;
	
			if (date && typeof date === 'string')
				parsedDate = this.localMoment(date, formats.datetime);
			else if (date)
				parsedDate = this.localMoment(date);
	
			if (parsedDate && !parsedDate.isValid())
				parsedDate = null;
	
			return parsedDate;
		},
	
		getStateFromProps: function( props ) {
			var formats = this.getFormats( props ),
				date = props.value || props.defaultValue,
				selectedDate, viewDate, updateOn, inputValue
				;
	
			selectedDate = this.parseDate(date, formats);
	
			viewDate = this.parseDate(props.viewDate, formats);
	
			viewDate = selectedDate ?
				selectedDate.clone().startOf('month') :
				viewDate ? viewDate.clone().startOf('month') : this.localMoment().startOf('month');
	
			updateOn = this.getUpdateOn(formats);
	
			if ( selectedDate )
				inputValue = selectedDate.format(formats.datetime);
			else if ( date.isValid && !date.isValid() )
				inputValue = '';
			else
				inputValue = date || '';
	
			return {
				updateOn: updateOn,
				inputFormat: formats.datetime,
				viewDate: viewDate,
				selectedDate: selectedDate,
				inputValue: inputValue,
				open: props.open
			};
		},
	
		getUpdateOn: function( formats ) {
			if ( formats.date.match(/[lLD]/) ) {
				return viewModes.DAYS;
			} else if ( formats.date.indexOf('M') !== -1 ) {
				return viewModes.MONTHS;
			} else if ( formats.date.indexOf('Y') !== -1 ) {
				return viewModes.YEARS;
			}
	
			return viewModes.DAYS;
		},
	
		getFormats: function( props ) {
			var formats = {
					date: props.dateFormat || '',
					time: props.timeFormat || ''
				},
				locale = this.localMoment( props.date, null, props ).localeData()
				;
	
			if ( formats.date === true ) {
				formats.date = locale.longDateFormat('L');
			}
			else if ( this.getUpdateOn(formats) !== viewModes.DAYS ) {
				formats.time = '';
			}
	
			if ( formats.time === true ) {
				formats.time = locale.longDateFormat('LT');
			}
	
			formats.datetime = formats.date && formats.time ?
				formats.date + ' ' + formats.time :
				formats.date || formats.time
			;
	
			return formats;
		},
	
		componentWillReceiveProps: function( nextProps ) {
			var formats = this.getFormats( nextProps ),
				updatedState = {}
			;
	
			if ( nextProps.value !== this.props.value ||
				formats.datetime !== this.getFormats( this.props ).datetime ) {
				updatedState = this.getStateFromProps( nextProps );
			}
	
			if ( updatedState.open === undefined ) {
				if ( typeof nextProps.open !== 'undefined' ) {
					updatedState.open = nextProps.open;
				} else if ( this.props.closeOnSelect && this.state.currentView !== viewModes.TIME ) {
					updatedState.open = false;
				} else {
					updatedState.open = this.state.open;
				}
			}
	
			if ( nextProps.viewMode !== this.props.viewMode ) {
				updatedState.currentView = nextProps.viewMode;
			}
	
			if ( nextProps.locale !== this.props.locale ) {
				if ( this.state.viewDate ) {
					var updatedViewDate = this.state.viewDate.clone().locale( nextProps.locale );
					updatedState.viewDate = updatedViewDate;
				}
				if ( this.state.selectedDate ) {
					var updatedSelectedDate = this.state.selectedDate.clone().locale( nextProps.locale );
					updatedState.selectedDate = updatedSelectedDate;
					updatedState.inputValue = updatedSelectedDate.format( formats.datetime );
				}
			}
	
			if ( nextProps.utc !== this.props.utc || nextProps.displayTimeZone !== this.props.displayTimeZone ) {
				if ( nextProps.utc ) {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().utc();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().utc();
						updatedState.inputValue = updatedState.selectedDate.format( formats.datetime );
					}
				} else if ( nextProps.displayTimeZone ) {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().tz(nextProps.displayTimeZone);
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().tz(nextProps.displayTimeZone);
						updatedState.inputValue = updatedState.selectedDate.tz(nextProps.displayTimeZone).format( formats.datetime );
					}
				} else {
					if ( this.state.viewDate )
						updatedState.viewDate = this.state.viewDate.clone().local();
					if ( this.state.selectedDate ) {
						updatedState.selectedDate = this.state.selectedDate.clone().local();
						updatedState.inputValue = updatedState.selectedDate.format(formats.datetime);
					}
				}
			}
	
			if ( nextProps.viewDate !== this.props.viewDate ) {
				updatedState.viewDate = moment(nextProps.viewDate);
			}
	
			this.checkTZ( nextProps );
	
			this.setState( updatedState );
		},
	
		onInputChange: function( e ) {
			var value = e.target === null ? e : e.target.value,
				localMoment = this.localMoment( value, this.state.inputFormat ),
				update = { inputValue: value }
				;
	
			if ( localMoment.isValid() && !this.props.value ) {
				update.selectedDate = localMoment;
				update.viewDate = localMoment.clone().startOf('month');
			} else {
				update.selectedDate = null;
			}
	
			return this.setState( update, function() {
				return this.props.onChange( localMoment.isValid() ? localMoment : this.state.inputValue );
			});
		},
	
		onInputKey: function( e ) {
			if ( e.which === 9 && this.props.closeOnTab ) {
				this.closeCalendar();
			}
		},
	
		showView: function( view ) {
			var me = this;
			return function() {
				me.state.currentView !== view && me.props.onViewModeChange( view );
				me.setState({ currentView: view });
			};
		},
	
		setDate: function( type ) {
			var me = this,
				nextViews = {
					month: viewModes.DAYS,
					year: viewModes.MONTHS,
				}
			;
			return function( e ) {
				me.setState({
					viewDate: me.state.viewDate.clone()[ type ]( parseInt(e.target.getAttribute('data-value'), 10) ).startOf( type ),
					currentView: nextViews[ type ]
				});
				me.props.onViewModeChange( nextViews[ type ] );
			};
		},
	
		subtractTime: function( amount, type, toSelected ) {
			var me = this;
			return function() {
				me.props.onNavigateBack( amount, type );
				me.updateTime( 'subtract', amount, type, toSelected );
			};
		},
	
		addTime: function( amount, type, toSelected ) {
			var me = this;
			return function() {
				me.props.onNavigateForward( amount, type );
				me.updateTime( 'add', amount, type, toSelected );
			};
		},
	
		updateTime: function( op, amount, type, toSelected ) {
			var update = {},
				date = toSelected ? 'selectedDate' : 'viewDate';
	
			update[ date ] = this.state[ date ].clone()[ op ]( amount, type );
	
			this.setState( update );
		},
	
		allowedSetTime: ['hours', 'minutes', 'seconds', 'milliseconds'],
		setTime: function( type, value ) {
			var index = this.allowedSetTime.indexOf( type ) + 1,
				state = this.state,
				date = (state.selectedDate || state.viewDate).clone(),
				nextType
				;
	
			// It is needed to set all the time properties
			// to not to reset the time
			date[ type ]( value );
			for (; index < this.allowedSetTime.length; index++) {
				nextType = this.allowedSetTime[index];
				date[ nextType ]( date[nextType]() );
			}
	
			if ( !this.props.value ) {
				this.setState({
					selectedDate: date,
					inputValue: date.format( state.inputFormat )
				});
			}
			this.props.onChange( date );
		},
	
		updateSelectedDate: function( e, close ) {
			var target = e.currentTarget,
				modifier = 0,
				viewDate = this.state.viewDate,
				currentDate = this.state.selectedDate || viewDate,
				date
				;
	
			if (target.className.indexOf('rdtDay') !== -1) {
				if (target.className.indexOf('rdtNew') !== -1)
					modifier = 1;
				else if (target.className.indexOf('rdtOld') !== -1)
					modifier = -1;
	
				date = viewDate.clone()
					.month( viewDate.month() + modifier )
					.date( parseInt( target.getAttribute('data-value'), 10 ) );
			} else if (target.className.indexOf('rdtMonth') !== -1) {
				date = viewDate.clone()
					.month( parseInt( target.getAttribute('data-value'), 10 ) )
					.date( currentDate.date() );
			} else if (target.className.indexOf('rdtYear') !== -1) {
				date = viewDate.clone()
					.month( currentDate.month() )
					.date( currentDate.date() )
					.year( parseInt( target.getAttribute('data-value'), 10 ) );
			}
	
			date.hours( currentDate.hours() )
				.minutes( currentDate.minutes() )
				.seconds( currentDate.seconds() )
				.milliseconds( currentDate.milliseconds() );
	
			if ( !this.props.value ) {
				var open = !( this.props.closeOnSelect && close );
				if ( !open ) {
					this.props.onBlur( date );
				}
	
				this.setState({
					selectedDate: date,
					viewDate: date.clone().startOf('month'),
					inputValue: date.format( this.state.inputFormat ),
					open: open
				});
			} else {
				if ( this.props.closeOnSelect && close ) {
					this.closeCalendar();
				}
			}
	
			this.props.onChange( date );
		},
	
		openCalendar: function( e ) {
			if ( !this.state.open ) {
				this.setState({ open: true }, function() {
					this.props.onFocus( e );
				});
			}
		},
	
		closeCalendar: function() {
			this.setState({ open: false }, function () {
				this.props.onBlur( this.state.selectedDate || this.state.inputValue );
			});
		},
	
		handleClickOutside: function() {
			if ( this.props.input && this.state.open && this.props.open === undefined && !this.props.disableCloseOnClickOutside ) {
				this.setState({ open: false }, function() {
					this.props.onBlur( this.state.selectedDate || this.state.inputValue );
				});
			}
		},
	
		localMoment: function( date, format, props ) {
			props = props || this.props;
			var m = null;
	
			if (props.utc) {
				m = moment.utc(date, format, props.strictParsing);
			} else if (props.displayTimeZone) {
				m = moment.tz(date, format, props.displayTimeZone);
			} else {
				m = moment(date, format, props.strictParsing);
			}
	
			if ( props.locale )
				m.locale( props.locale );
			return m;
		},
	
		checkTZ: function( props ) {
			var con = console;
	
			if ( props.displayTimeZone && !this.tzWarning && !moment.tz ) {
				this.tzWarning = true;
				con && con.error('react-datetime: displayTimeZone prop with value "' + props.displayTimeZone +  '" is used but moment.js timezone is not loaded.');
			}
		},
	
		componentProps: {
			fromProps: ['value', 'isValidDate', 'renderDay', 'renderMonth', 'renderYear', 'timeConstraints'],
			fromState: ['viewDate', 'selectedDate', 'updateOn'],
			fromThis: ['setDate', 'setTime', 'showView', 'addTime', 'subtractTime', 'updateSelectedDate', 'localMoment', 'handleClickOutside']
		},
	
		getComponentProps: function() {
			var me = this,
				formats = this.getFormats( this.props ),
				props = {dateFormat: formats.date, timeFormat: formats.time}
				;
	
			this.componentProps.fromProps.forEach( function( name ) {
				props[ name ] = me.props[ name ];
			});
			this.componentProps.fromState.forEach( function( name ) {
				props[ name ] = me.state[ name ];
			});
			this.componentProps.fromThis.forEach( function( name ) {
				props[ name ] = me[ name ];
			});
	
			return props;
		},
	
		overrideEvent: function( handler, action ) {
			if ( !this.overridenEvents ) {
				this.overridenEvents = {};
			}
	
			if ( !this.overridenEvents[handler] ) {
				var me = this;
				this.overridenEvents[handler] = function( e ) {
					var result;
					if ( me.props.inputProps && me.props.inputProps[handler] ) {
						result = me.props.inputProps[handler]( e );
					}
					if ( result !== false ) {
						action( e );
					}
				};
			}
	
			return this.overridenEvents[handler];
		},
	
		render: function() {
			// TODO: Make a function or clean up this code,
			// logic right now is really hard to follow
			var className = 'rdt' + (this.props.className ?
										( Array.isArray( this.props.className ) ?
										' ' + this.props.className.join( ' ' ) : ' ' + this.props.className) : ''),
				children = [];
	
			if ( this.props.input ) {
				var finalInputProps = assign(
					{ type: 'text', className: 'form-control', value: this.state.inputValue },
					this.props.inputProps,
					{
						onClick: this.overrideEvent( 'onClick', this.openCalendar ),
						onFocus: this.overrideEvent( 'onFocus', this.openCalendar ),
						onChange: this.overrideEvent( 'onChange', this.onInputChange ),
						onKeyDown: this.overrideEvent( 'onKeyDown', this.onInputKey ),
					}
				);
	
				if ( this.props.renderInput ) {
					children = [ React.createElement('div', { key: 'i' }, this.props.renderInput( finalInputProps, this.openCalendar, this.closeCalendar )) ];
				} else {
					children = [ React.createElement('input', assign({ key: 'i' }, finalInputProps ))];
				}
			} else {
				className += ' rdtStatic';
			}
	
			if ( this.props.open || (this.props.open === undefined && this.state.open ) )
				className += ' rdtOpen';
	
			return React.createElement( ClickableWrapper, {className: className, onClickOut: this.handleClickOutside}, children.concat(
				React.createElement( 'div',
					{ key: 'dt', className: 'rdtPicker' },
					React.createElement( CalendarContainer, { view: this.state.currentView, viewProps: this.getComponentProps() })
				)
			));
		}
	});
	
	var ClickableWrapper = onClickOutside( createClass({
		render: function() {
			return React.createElement( 'div', { className: this.props.className }, this.props.children );
		},
		handleClickOutside: function( e ) {
			this.props.onClickOut( e );
		}
	}));
	
	Datetime.defaultProps = {
		className: '',
		defaultValue: '',
		inputProps: {},
		input: true,
		onFocus: function() {},
		onBlur: function() {},
		onChange: function() {},
		onViewModeChange: function() {},
		onNavigateBack: function() {},
		onNavigateForward: function() {},
		timeFormat: true,
		timeConstraints: {},
		dateFormat: true,
		strictParsing: true,
		closeOnSelect: false,
		closeOnTab: true,
		utc: false
	};
	
	// Make moment accessible through the Datetime class
	Datetime.moment = moment;
	
	module.exports = Datetime;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(30),
		DaysView = __webpack_require__(1076),
		MonthsView = __webpack_require__(1077),
		YearsView = __webpack_require__(1079),
		TimeView = __webpack_require__(1078)
		;
	
	var CalendarContainer = createClass({
		viewComponents: {
			days: DaysView,
			months: MonthsView,
			years: YearsView,
			time: TimeView
		},
	
		render: function() {
			return React.createElement( this.viewComponents[ this.props.view ], this.props.viewProps );
		}
	});
	
	module.exports = CalendarContainer;


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(30),
		moment = __webpack_require__(2)
		;
	
	var DateTimePickerDays = createClass({
		render: function() {
			var footer = this.renderFooter(),
				date = this.props.viewDate,
				locale = date.localeData(),
				tableChildren
				;
	
			tableChildren = [
				React.createElement('thead', { key: 'th' }, [
					React.createElement('tr', { key: 'h' }, [
						React.createElement('th', { key: 'p', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'months' )}, React.createElement('span', {}, '‹' )),
						React.createElement('th', { key: 's', className: 'rdtSwitch', onClick: this.props.showView( 'months' ), colSpan: 5, 'data-value': this.props.viewDate.month() }, locale.months( date ) + ' ' + date.year() ),
						React.createElement('th', { key: 'n', className: 'rdtNext', onClick: this.props.addTime( 1, 'months' )}, React.createElement('span', {}, '›' ))
					]),
					React.createElement('tr', { key: 'd'}, this.getDaysOfWeek( locale ).map( function( day, index ) { return React.createElement('th', { key: day + index, className: 'dow'}, day ); }) )
				]),
				React.createElement('tbody', { key: 'tb' }, this.renderDays())
			];
	
			if ( footer )
				tableChildren.push( footer );
	
			return React.createElement('div', { className: 'rdtDays' },
				React.createElement('table', {}, tableChildren )
			);
		},
	
		/**
		 * Get a list of the days of the week
		 * depending on the current locale
		 * @return {array} A list with the shortname of the days
		 */
		getDaysOfWeek: function( locale ) {
			var days = locale._weekdaysMin,
				first = locale.firstDayOfWeek(),
				dow = [],
				i = 0
				;
	
			days.forEach( function( day ) {
				dow[ (7 + ( i++ ) - first) % 7 ] = day;
			});
	
			return dow;
		},
	
		renderDays: function() {
			var date = this.props.viewDate,
				selected = this.props.selectedDate && this.props.selectedDate.clone(),
				prevMonth = date.clone().subtract( 1, 'months' ),
				currentYear = date.year(),
				currentMonth = date.month(),
				weeks = [],
				days = [],
				renderer = this.props.renderDay || this.renderDay,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, isDisabled, dayProps, currentDate
				;
	
			// Go to the last week of the previous month
			prevMonth.date( prevMonth.daysInMonth() ).startOf( 'week' );
			var lastDay = prevMonth.clone().add( 42, 'd' );
	
			while ( prevMonth.isBefore( lastDay ) ) {
				classes = 'rdtDay';
				currentDate = prevMonth.clone();
	
				if ( ( prevMonth.year() === currentYear && prevMonth.month() < currentMonth ) || ( prevMonth.year() < currentYear ) )
					classes += ' rdtOld';
				else if ( ( prevMonth.year() === currentYear && prevMonth.month() > currentMonth ) || ( prevMonth.year() > currentYear ) )
					classes += ' rdtNew';
	
				if ( selected && prevMonth.isSame( selected, 'day' ) )
					classes += ' rdtActive';
	
				if ( prevMonth.isSame( moment(), 'day' ) )
					classes += ' rdtToday';
	
				isDisabled = !isValid( currentDate, selected );
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				dayProps = {
					key: prevMonth.format( 'M_D' ),
					'data-value': prevMonth.date(),
					className: classes
				};
	
				if ( !isDisabled )
					dayProps.onClick = this.updateSelectedDate;
	
				days.push( renderer( dayProps, currentDate, selected ) );
	
				if ( days.length === 7 ) {
					weeks.push( React.createElement('tr', { key: prevMonth.format( 'M_D' )}, days ) );
					days = [];
				}
	
				prevMonth.add( 1, 'd' );
			}
	
			return weeks;
		},
	
		updateSelectedDate: function( event ) {
			this.props.updateSelectedDate( event, true );
		},
	
		renderDay: function( props, currentDate ) {
			return React.createElement('td',  props, currentDate.date() );
		},
	
		renderFooter: function() {
			if ( !this.props.timeFormat )
				return '';
	
			var date = this.props.selectedDate || this.props.viewDate;
	
			return React.createElement('tfoot', { key: 'tf'},
				React.createElement('tr', {},
					React.createElement('td', { onClick: this.props.showView( 'time' ), colSpan: 7, className: 'rdtTimeToggle' }, date.format( this.props.timeFormat ))
				)
			);
		},
	
		alwaysValidDate: function() {
			return 1;
		}
	});
	
	module.exports = DateTimePickerDays;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(30)
	;
	
	var DateTimePickerMonths = createClass({
		render: function() {
			return React.createElement('div', { className: 'rdtMonths' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 1, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2, 'data-value': this.props.viewDate.year() }, this.props.viewDate.year() ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 1, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'months' }, React.createElement('tbody', { key: 'b' }, this.renderMonths()))
			]);
		},
	
		renderMonths: function() {
			var date = this.props.selectedDate,
				month = this.props.viewDate.month(),
				year = this.props.viewDate.year(),
				rows = [],
				i = 0,
				months = [],
				renderer = this.props.renderMonth || this.renderMonth,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay,
				// Date is irrelevant because we're only interested in month
				irrelevantDate = 1
				;
	
			while (i < 12) {
				classes = 'rdtMonth';
				currentMonth =
					this.props.viewDate.clone().set({ year: year, month: i, date: irrelevantDate });
	
				noOfDaysInMonth = currentMonth.endOf( 'month' ).format( 'D' );
				daysInMonth = Array.from({ length: noOfDaysInMonth }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInMonth.find(function( d ) {
					var day = currentMonth.clone().set( 'date', d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( date && i === date.month() && year === date.year() )
					classes += ' rdtActive';
	
				props = {
					key: i,
					'data-value': i,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'months' ?
						this.updateSelectedMonth : this.props.setDate( 'month' ) );
	
				months.push( renderer( props, i, year, date && date.clone() ) );
	
				if ( months.length === 4 ) {
					rows.push( React.createElement('tr', { key: month + '_' + rows.length }, months ) );
					months = [];
				}
	
				i++;
			}
	
			return rows;
		},
	
		updateSelectedMonth: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderMonth: function( props, month ) {
			var localMoment = this.props.viewDate;
			var monthStr = localMoment.localeData().monthsShort( localMoment.month( month ) );
			var strLength = 3;
			// Because some months are up to 5 characters long, we want to
			// use a fixed string length for consistency
			var monthStrFixedLength = monthStr.substring( 0, strLength );
			return React.createElement('td', props, capitalize( monthStrFixedLength ) );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	});
	
	function capitalize( str ) {
		return str.charAt( 0 ).toUpperCase() + str.slice( 1 );
	}
	
	module.exports = DateTimePickerMonths;


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(30),
		assign = __webpack_require__(464)
		;
	
	var DateTimePickerTime = createClass({
		getInitialState: function() {
			return this.calculateState( this.props );
		},
	
		calculateState: function( props ) {
			var date = props.selectedDate || props.viewDate,
				format = props.timeFormat,
				counters = []
				;
	
			if ( format.toLowerCase().indexOf('h') !== -1 ) {
				counters.push('hours');
				if ( format.indexOf('m') !== -1 ) {
					counters.push('minutes');
					if ( format.indexOf('s') !== -1 ) {
						counters.push('seconds');
					}
				}
			}
	
			var hours = date.format( 'H' );
	
			var daypart = false;
			if ( this.state !== null && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
				if ( this.props.timeFormat.indexOf( ' A' ) !== -1 ) {
					daypart = ( hours >= 12 ) ? 'PM' : 'AM';
				} else {
					daypart = ( hours >= 12 ) ? 'pm' : 'am';
				}
			}
	
			return {
				hours: hours,
				minutes: date.format( 'mm' ),
				seconds: date.format( 'ss' ),
				milliseconds: date.format( 'SSS' ),
				daypart: daypart,
				counters: counters
			};
		},
	
		renderCounter: function( type ) {
			if ( type !== 'daypart' ) {
				var value = this.state[ type ];
				if ( type === 'hours' && this.props.timeFormat.toLowerCase().indexOf( ' a' ) !== -1 ) {
					value = ( value - 1 ) % 12 + 1;
	
					if ( value === 0 ) {
						value = 12;
					}
				}
				return React.createElement('div', { key: type, className: 'rdtCounter' }, [
					React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'increase', type ), onContextMenu: this.disableContextMenu }, '▲' ),
					React.createElement('div', { key: 'c', className: 'rdtCount' }, value ),
					React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'decrease', type ), onContextMenu: this.disableContextMenu }, '▼' )
				]);
			}
			return '';
		},
	
		renderDayPart: function() {
			return React.createElement('div', { key: 'dayPart', className: 'rdtCounter' }, [
				React.createElement('span', { key: 'up', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▲' ),
				React.createElement('div', { key: this.state.daypart, className: 'rdtCount' }, this.state.daypart ),
				React.createElement('span', { key: 'do', className: 'rdtBtn', onMouseDown: this.onStartClicking( 'toggleDayPart', 'hours'), onContextMenu: this.disableContextMenu }, '▼' )
			]);
		},
	
		render: function() {
			var me = this,
				counters = []
			;
	
			this.state.counters.forEach( function( c ) {
				if ( counters.length )
					counters.push( React.createElement('div', { key: 'sep' + counters.length, className: 'rdtCounterSeparator' }, ':' ) );
				counters.push( me.renderCounter( c ) );
			});
	
			if ( this.state.daypart !== false ) {
				counters.push( me.renderDayPart() );
			}
	
			if ( this.state.counters.length === 3 && this.props.timeFormat.indexOf( 'S' ) !== -1 ) {
				counters.push( React.createElement('div', { className: 'rdtCounterSeparator', key: 'sep5' }, ':' ) );
				counters.push(
					React.createElement('div', { className: 'rdtCounter rdtMilli', key: 'm' },
						React.createElement('input', { value: this.state.milliseconds, type: 'text', onChange: this.updateMilli } )
						)
					);
			}
	
			return React.createElement('div', { className: 'rdtTime' },
				React.createElement('table', {}, [
					this.renderHeader(),
					React.createElement('tbody', { key: 'b'}, React.createElement('tr', {}, React.createElement('td', {},
						React.createElement('div', { className: 'rdtCounters' }, counters )
					)))
				])
			);
		},
	
		componentWillMount: function() {
			var me = this;
			me.timeConstraints = {
				hours: {
					min: 0,
					max: 23,
					step: 1
				},
				minutes: {
					min: 0,
					max: 59,
					step: 1
				},
				seconds: {
					min: 0,
					max: 59,
					step: 1
				},
				milliseconds: {
					min: 0,
					max: 999,
					step: 1
				}
			};
			['hours', 'minutes', 'seconds', 'milliseconds'].forEach( function( type ) {
				assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
			});
			this.setState( this.calculateState( this.props ) );
		},
	
		componentWillReceiveProps: function( nextProps ) {
			this.setState( this.calculateState( nextProps ) );
		},
	
		updateMilli: function( e ) {
			var milli = parseInt( e.target.value, 10 );
			if ( milli === e.target.value && milli >= 0 && milli < 1000 ) {
				this.props.setTime( 'milliseconds', milli );
				this.setState( { milliseconds: milli } );
			}
		},
	
		renderHeader: function() {
			if ( !this.props.dateFormat )
				return null;
	
			var date = this.props.selectedDate || this.props.viewDate;
			return React.createElement('thead', { key: 'h' }, React.createElement('tr', {},
				React.createElement('th', { className: 'rdtSwitch', colSpan: 4, onClick: this.props.showView( 'days' ) }, date.format( this.props.dateFormat ) )
			));
		},
	
		onStartClicking: function( action, type ) {
			var me = this;
	
			return function() {
				var update = {};
				update[ type ] = me[ action ]( type );
				me.setState( update );
	
				me.timer = setTimeout( function() {
					me.increaseTimer = setInterval( function() {
						update[ type ] = me[ action ]( type );
						me.setState( update );
					}, 70);
				}, 500);
	
				me.mouseUpListener = function() {
					clearTimeout( me.timer );
					clearInterval( me.increaseTimer );
					me.props.setTime( type, me.state[ type ] );
					document.body.removeEventListener( 'mouseup', me.mouseUpListener );
					document.body.removeEventListener( 'touchend', me.mouseUpListener );
				};
	
				document.body.addEventListener( 'mouseup', me.mouseUpListener );
				document.body.addEventListener( 'touchend', me.mouseUpListener );
			};
		},
	
		disableContextMenu: function( event ) {
			event.preventDefault();
			return false;
		},
	
		padValues: {
			hours: 1,
			minutes: 2,
			seconds: 2,
			milliseconds: 3
		},
	
		toggleDayPart: function( type ) { // type is always 'hours'
			var value = parseInt( this.state[ type ], 10) + 12;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		increase: function( type ) {
			var value = parseInt( this.state[ type ], 10) + this.timeConstraints[ type ].step;
			if ( value > this.timeConstraints[ type ].max )
				value = this.timeConstraints[ type ].min + ( value - ( this.timeConstraints[ type ].max + 1 ) );
			return this.pad( type, value );
		},
	
		decrease: function( type ) {
			var value = parseInt( this.state[ type ], 10) - this.timeConstraints[ type ].step;
			if ( value < this.timeConstraints[ type ].min )
				value = this.timeConstraints[ type ].max + 1 - ( this.timeConstraints[ type ].min - value );
			return this.pad( type, value );
		},
	
		pad: function( type, value ) {
			var str = value + '';
			while ( str.length < this.padValues[ type ] )
				str = '0' + str;
			return str;
		},
	});
	
	module.exports = DateTimePickerTime;


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(1),
		createClass = __webpack_require__(30)
	;
	
	var DateTimePickerYears = createClass({
		render: function() {
			var year = parseInt( this.props.viewDate.year() / 10, 10 ) * 10;
	
			return React.createElement('div', { className: 'rdtYears' }, [
				React.createElement('table', { key: 'a' }, React.createElement('thead', {}, React.createElement('tr', {}, [
					React.createElement('th', { key: 'prev', className: 'rdtPrev', onClick: this.props.subtractTime( 10, 'years' )}, React.createElement('span', {}, '‹' )),
					React.createElement('th', { key: 'year', className: 'rdtSwitch', onClick: this.props.showView( 'years' ), colSpan: 2 }, year + '-' + ( year + 9 ) ),
					React.createElement('th', { key: 'next', className: 'rdtNext', onClick: this.props.addTime( 10, 'years' )}, React.createElement('span', {}, '›' ))
				]))),
				React.createElement('table', { key: 'years' }, React.createElement('tbody',  {}, this.renderYears( year )))
			]);
		},
	
		renderYears: function( year ) {
			var years = [],
				i = -1,
				rows = [],
				renderer = this.props.renderYear || this.renderYear,
				selectedDate = this.props.selectedDate,
				isValid = this.props.isValidDate || this.alwaysValidDate,
				classes, props, currentYear, isDisabled, noOfDaysInYear, daysInYear, validDay,
				// Month and date are irrelevant here because
				// we're only interested in the year
				irrelevantMonth = 0,
				irrelevantDate = 1
				;
	
			year--;
			while (i < 11) {
				classes = 'rdtYear';
				currentYear = this.props.viewDate.clone().set(
					{ year: year, month: irrelevantMonth, date: irrelevantDate } );
	
				// Not sure what 'rdtOld' is for, commenting out for now as it's not working properly
				// if ( i === -1 | i === 10 )
					// classes += ' rdtOld';
	
				noOfDaysInYear = currentYear.endOf( 'year' ).format( 'DDD' );
				daysInYear = Array.from({ length: noOfDaysInYear }, function( e, i ) {
					return i + 1;
				});
	
				validDay = daysInYear.find(function( d ) {
					var day = currentYear.clone().dayOfYear( d );
					return isValid( day );
				});
	
				isDisabled = ( validDay === undefined );
	
				if ( isDisabled )
					classes += ' rdtDisabled';
	
				if ( selectedDate && selectedDate.year() === year )
					classes += ' rdtActive';
	
				props = {
					key: year,
					'data-value': year,
					className: classes
				};
	
				if ( !isDisabled )
					props.onClick = ( this.props.updateOn === 'years' ?
						this.updateSelectedYear : this.props.setDate('year') );
	
				years.push( renderer( props, year, selectedDate && selectedDate.clone() ));
	
				if ( years.length === 4 ) {
					rows.push( React.createElement('tr', { key: i }, years ) );
					years = [];
				}
	
				year++;
				i++;
			}
	
			return rows;
		},
	
		updateSelectedYear: function( event ) {
			this.props.updateSelectedDate( event );
		},
	
		renderYear: function( props, year ) {
			return React.createElement('td',  props, year );
		},
	
		alwaysValidDate: function() {
			return 1;
		},
	});
	
	module.exports = DateTimePickerYears;


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(1191));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license React
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),ca=__webpack_require__(1189);function p(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var da=new Set,ea={};function fa(a,b){ha(a,b);ha(a+"Capture",b)}
	function ha(a,b){ea[a]=b;for(a=0;a<b.length;a++)da.add(b[a])}
	var ia=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ja=Object.prototype.hasOwnProperty,ka=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,la=
	{},ma={};function oa(a){if(ja.call(ma,a))return!0;if(ja.call(la,a))return!1;if(ka.test(a))return ma[a]=!0;la[a]=!0;return!1}function pa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function qa(a,b,c,d){if(null===b||"undefined"===typeof b||pa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var z={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){z[a]=new v(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];z[b]=new v(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){z[a]=new v(a,2,!1,a.toLowerCase(),null,!1,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){z[a]=new v(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){z[a]=new v(a,3,!1,a.toLowerCase(),null,!1,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){z[a]=new v(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){z[a]=new v(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){z[a]=new v(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){z[a]=new v(a,5,!1,a.toLowerCase(),null,!1,!1)});var ra=/[\-:]([a-z])/g;function sa(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(ra,
	sa);z[b]=new v(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(ra,sa);z[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(ra,sa);z[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){z[a]=new v(a,1,!1,a.toLowerCase(),null,!1,!1)});
	z.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){z[a]=new v(a,1,!1,a.toLowerCase(),null,!0,!0)});
	function ta(a,b,c,d){var e=z.hasOwnProperty(b)?z[b]:null;if(null!==e?0!==e.type:d||!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1])qa(b,c,e,d)&&(c=null),d||null===e?oa(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c)))}
	var ua=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,va=Symbol.for("react.element"),wa=Symbol.for("react.portal"),ya=Symbol.for("react.fragment"),za=Symbol.for("react.strict_mode"),Aa=Symbol.for("react.profiler"),Ba=Symbol.for("react.provider"),Ca=Symbol.for("react.context"),Da=Symbol.for("react.forward_ref"),Ea=Symbol.for("react.suspense"),Fa=Symbol.for("react.suspense_list"),Ga=Symbol.for("react.memo"),Ha=Symbol.for("react.lazy");Symbol.for("react.scope");Symbol.for("react.debug_trace_mode");
	var Ia=Symbol.for("react.offscreen");Symbol.for("react.legacy_hidden");Symbol.for("react.cache");Symbol.for("react.tracing_marker");var Ja=Symbol.iterator;function Ka(a){if(null===a||"object"!==typeof a)return null;a=Ja&&a[Ja]||a["@@iterator"];return"function"===typeof a?a:null}var A=Object.assign,La;function Ma(a){if(void 0===La)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);La=b&&b[1]||""}return"\n"+La+a}var Na=!1;
	function Oa(a,b){if(!a||Na)return"";Na=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(l){var d=l}Reflect.construct(a,[],b)}else{try{b.call()}catch(l){d=l}a.call(b.prototype)}else{try{throw Error();}catch(l){d=l}a()}}catch(l){if(l&&d&&"string"===typeof l.stack){for(var e=l.stack.split("\n"),
	f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h]){var k="\n"+e[g].replace(" at new "," at ");a.displayName&&k.includes("<anonymous>")&&(k=k.replace("<anonymous>",a.displayName));return k}while(1<=g&&0<=h)}break}}}finally{Na=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Ma(a):""}
	function Pa(a){switch(a.tag){case 5:return Ma(a.type);case 16:return Ma("Lazy");case 13:return Ma("Suspense");case 19:return Ma("SuspenseList");case 0:case 2:case 15:return a=Oa(a.type,!1),a;case 11:return a=Oa(a.type.render,!1),a;case 1:return a=Oa(a.type,!0),a;default:return""}}
	function Qa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ya:return"Fragment";case wa:return"Portal";case Aa:return"Profiler";case za:return"StrictMode";case Ea:return"Suspense";case Fa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ca:return(a.displayName||"Context")+".Consumer";case Ba:return(a._context.displayName||"Context")+".Provider";case Da:var b=a.render;a=a.displayName;a||(a=b.displayName||
	b.name||"",a=""!==a?"ForwardRef("+a+")":"ForwardRef");return a;case Ga:return b=a.displayName||null,null!==b?b:Qa(a.type)||"Memo";case Ha:b=a._payload;a=a._init;try{return Qa(a(b))}catch(c){}}return null}
	function Ra(a){var b=a.type;switch(a.tag){case 24:return"Cache";case 9:return(b.displayName||"Context")+".Consumer";case 10:return(b._context.displayName||"Context")+".Provider";case 18:return"DehydratedFragment";case 11:return a=b.render,a=a.displayName||a.name||"",b.displayName||(""!==a?"ForwardRef("+a+")":"ForwardRef");case 7:return"Fragment";case 5:return b;case 4:return"Portal";case 3:return"Root";case 6:return"Text";case 16:return Qa(b);case 8:return b===za?"StrictMode":"Mode";case 22:return"Offscreen";
	case 12:return"Profiler";case 21:return"Scope";case 13:return"Suspense";case 19:return"SuspenseList";case 25:return"TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"===typeof b)return b.displayName||b.name||null;if("string"===typeof b)return b}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "string":case "undefined":return a;case "object":return a;default:return""}}
	function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
	function Ya(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function ab(a,b){b=b.checked;null!=b&&ta(a,"checked",b,!1)}
	function bb(a,b){ab(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?cb(a,b.type,c):b.hasOwnProperty("defaultValue")&&cb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function db(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function cb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var eb=Array.isArray;
	function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(p(91));return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(p(92));if(eb(c)){if(1<c.length)throw Error(p(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
	function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}function kb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	function lb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?kb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var mb,nb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if("http://www.w3.org/2000/svg"!==a.namespaceURI||"innerHTML"in a)a.innerHTML=b;else{mb=mb||document.createElement("div");mb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=mb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function ob(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var pb={animationIterationCount:!0,aspectRatio:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,
	zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qb=["Webkit","ms","Moz","O"];Object.keys(pb).forEach(function(a){qb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pb[b]=pb[a]})});function rb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||pb.hasOwnProperty(a)&&pb[a]?(""+b).trim():b+"px"}
	function sb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=rb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var tb=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function ub(a,b){if(b){if(tb[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(p(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(p(60));if("object"!==typeof b.dangerouslySetInnerHTML||!("__html"in b.dangerouslySetInnerHTML))throw Error(p(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(p(62));}}
	function vb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var wb=null;function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
	function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(p(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(){}var Ib=!1;function Jb(a,b,c){if(Ib)return a(b,c);Ib=!0;try{return Gb(a,b,c)}finally{if(Ib=!1,null!==zb||null!==Ab)Hb(),Fb()}}
	function Kb(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
	typeof c)throw Error(p(231,b,typeof c));return c}var Lb=!1;if(ia)try{var Mb={};Object.defineProperty(Mb,"passive",{get:function(){Lb=!0}});window.addEventListener("test",Mb,Mb);window.removeEventListener("test",Mb,Mb)}catch(a){Lb=!1}function Nb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var Ob=!1,Pb=null,Qb=!1,Rb=null,Sb={onError:function(a){Ob=!0;Pb=a}};function Tb(a,b,c,d,e,f,g,h,k){Ob=!1;Pb=null;Nb.apply(Sb,arguments)}
	function Ub(a,b,c,d,e,f,g,h,k){Tb.apply(this,arguments);if(Ob){if(Ob){var l=Pb;Ob=!1;Pb=null}else throw Error(p(198));Qb||(Qb=!0,Rb=l)}}function Vb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&4098)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function Wb(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function Xb(a){if(Vb(a)!==a)throw Error(p(188));}
	function Yb(a){var b=a.alternate;if(!b){b=Vb(a);if(null===b)throw Error(p(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return Xb(e),a;if(f===d)return Xb(e),b;f=f.sibling}throw Error(p(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(p(189));}}if(c.alternate!==d)throw Error(p(190));}if(3!==c.tag)throw Error(p(188));return c.stateNode.current===c?a:b}function Zb(a){a=Yb(a);return null!==a?$b(a):null}function $b(a){if(5===a.tag||6===a.tag)return a;for(a=a.child;null!==a;){var b=$b(a);if(null!==b)return b;a=a.sibling}return null}
	var ac=ca.unstable_scheduleCallback,bc=ca.unstable_cancelCallback,cc=ca.unstable_shouldYield,dc=ca.unstable_requestPaint,B=ca.unstable_now,ec=ca.unstable_getCurrentPriorityLevel,fc=ca.unstable_ImmediatePriority,gc=ca.unstable_UserBlockingPriority,hc=ca.unstable_NormalPriority,ic=ca.unstable_LowPriority,jc=ca.unstable_IdlePriority,kc=null,lc=null;function mc(a){if(lc&&"function"===typeof lc.onCommitFiberRoot)try{lc.onCommitFiberRoot(kc,a,void 0,128===(a.current.flags&128))}catch(b){}}
	var oc=Math.clz32?Math.clz32:nc,pc=Math.log,qc=Math.LN2;function nc(a){a>>>=0;return 0===a?32:31-(pc(a)/qc|0)|0}var rc=64,sc=4194304;
	function tc(a){switch(a&-a){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return a&4194240;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return a&130023424;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;
	default:return a}}function uc(a,b){var c=a.pendingLanes;if(0===c)return 0;var d=0,e=a.suspendedLanes,f=a.pingedLanes,g=c&268435455;if(0!==g){var h=g&~e;0!==h?d=tc(h):(f&=g,0!==f&&(d=tc(f)))}else g=c&~e,0!==g?d=tc(g):0!==f&&(d=tc(f));if(0===d)return 0;if(0!==b&&b!==d&&0===(b&e)&&(e=d&-d,f=b&-b,e>=f||16===e&&0!==(f&4194240)))return b;0!==(d&4)&&(d|=c&16);b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-oc(b),e=1<<c,d|=a[c],b&=~e;return d}
	function vc(a,b){switch(a){case 1:case 2:case 4:return b+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return b+5E3;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return-1;case 134217728:case 268435456:case 536870912:case 1073741824:return-1;default:return-1}}
	function wc(a,b){for(var c=a.suspendedLanes,d=a.pingedLanes,e=a.expirationTimes,f=a.pendingLanes;0<f;){var g=31-oc(f),h=1<<g,k=e[g];if(-1===k){if(0===(h&c)||0!==(h&d))e[g]=vc(h,b)}else k<=b&&(a.expiredLanes|=h);f&=~h}}function xc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function yc(){var a=rc;rc<<=1;0===(rc&4194240)&&(rc=64);return a}function zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
	function Ac(a,b,c){a.pendingLanes|=b;536870912!==b&&(a.suspendedLanes=0,a.pingedLanes=0);a=a.eventTimes;b=31-oc(b);a[b]=c}function Bc(a,b){var c=a.pendingLanes&~b;a.pendingLanes=b;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=b;a.mutableReadLanes&=b;a.entangledLanes&=b;b=a.entanglements;var d=a.eventTimes;for(a=a.expirationTimes;0<c;){var e=31-oc(c),f=1<<e;b[e]=0;d[e]=-1;a[e]=-1;c&=~f}}
	function Cc(a,b){var c=a.entangledLanes|=b;for(a=a.entanglements;c;){var d=31-oc(c),e=1<<d;e&b|a[d]&b&&(a[d]|=b);c&=~e}}var C=0;function Dc(a){a&=-a;return 1<a?4<a?0!==(a&268435455)?16:536870912:4:1}var Ec,Fc,Gc,Hc,Ic,Jc=!1,Kc=[],Lc=null,Mc=null,Nc=null,Oc=new Map,Pc=new Map,Qc=[],Rc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
	function Sc(a,b){switch(a){case "focusin":case "focusout":Lc=null;break;case "dragenter":case "dragleave":Mc=null;break;case "mouseover":case "mouseout":Nc=null;break;case "pointerover":case "pointerout":Oc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Pc.delete(b.pointerId)}}
	function Tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a={blockedOn:b,domEventName:c,eventSystemFlags:d,nativeEvent:f,targetContainers:[e]},null!==b&&(b=Cb(b),null!==b&&Fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
	function Uc(a,b,c,d,e){switch(b){case "focusin":return Lc=Tc(Lc,a,b,c,d,e),!0;case "dragenter":return Mc=Tc(Mc,a,b,c,d,e),!0;case "mouseover":return Nc=Tc(Nc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Oc.set(f,Tc(Oc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Pc.set(f,Tc(Pc.get(f)||null,a,b,c,d,e)),!0}return!1}
	function Vc(a){var b=Wc(a.target);if(null!==b){var c=Vb(b);if(null!==c)if(b=c.tag,13===b){if(b=Wb(c),null!==b){a.blockedOn=b;Ic(a.priority,function(){Gc(c)});return}}else if(3===b&&c.stateNode.current.memoizedState.isDehydrated){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
	function Xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=Yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null===c){c=a.nativeEvent;var d=new c.constructor(c.type,c);wb=d;c.target.dispatchEvent(d);wb=null}else return b=Cb(c),null!==b&&Fc(b),a.blockedOn=c,!1;b.shift()}return!0}function Zc(a,b,c){Xc(a)&&c.delete(b)}function $c(){Jc=!1;null!==Lc&&Xc(Lc)&&(Lc=null);null!==Mc&&Xc(Mc)&&(Mc=null);null!==Nc&&Xc(Nc)&&(Nc=null);Oc.forEach(Zc);Pc.forEach(Zc)}
	function ad(a,b){a.blockedOn===b&&(a.blockedOn=null,Jc||(Jc=!0,ca.unstable_scheduleCallback(ca.unstable_NormalPriority,$c)))}
	function bd(a){function b(b){return ad(b,a)}if(0<Kc.length){ad(Kc[0],a);for(var c=1;c<Kc.length;c++){var d=Kc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Lc&&ad(Lc,a);null!==Mc&&ad(Mc,a);null!==Nc&&ad(Nc,a);Oc.forEach(b);Pc.forEach(b);for(c=0;c<Qc.length;c++)d=Qc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Qc.length&&(c=Qc[0],null===c.blockedOn);)Vc(c),null===c.blockedOn&&Qc.shift()}var cd=ua.ReactCurrentBatchConfig,dd=!0;
	function ed(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=1,fd(a,b,c,d)}finally{C=e,cd.transition=f}}function gd(a,b,c,d){var e=C,f=cd.transition;cd.transition=null;try{C=4,fd(a,b,c,d)}finally{C=e,cd.transition=f}}
	function fd(a,b,c,d){if(dd){var e=Yc(a,b,c,d);if(null===e)hd(a,b,d,id,c),Sc(a,d);else if(Uc(e,a,b,c,d))d.stopPropagation();else if(Sc(a,d),b&4&&-1<Rc.indexOf(a)){for(;null!==e;){var f=Cb(e);null!==f&&Ec(f);f=Yc(a,b,c,d);null===f&&hd(a,b,d,id,c);if(f===e)break;e=f}null!==e&&d.stopPropagation()}else hd(a,b,d,null,c)}}var id=null;
	function Yc(a,b,c,d){id=null;a=xb(d);a=Wc(a);if(null!==a)if(b=Vb(a),null===b)a=null;else if(c=b.tag,13===c){a=Wb(b);if(null!==a)return a;a=null}else if(3===c){if(b.stateNode.current.memoizedState.isDehydrated)return 3===b.tag?b.stateNode.containerInfo:null;a=null}else b!==a&&(a=null);id=a;return null}
	function jd(a){switch(a){case "cancel":case "click":case "close":case "contextmenu":case "copy":case "cut":case "auxclick":case "dblclick":case "dragend":case "dragstart":case "drop":case "focusin":case "focusout":case "input":case "invalid":case "keydown":case "keypress":case "keyup":case "mousedown":case "mouseup":case "paste":case "pause":case "play":case "pointercancel":case "pointerdown":case "pointerup":case "ratechange":case "reset":case "resize":case "seeked":case "submit":case "touchcancel":case "touchend":case "touchstart":case "volumechange":case "change":case "selectionchange":case "textInput":case "compositionstart":case "compositionend":case "compositionupdate":case "beforeblur":case "afterblur":case "beforeinput":case "blur":case "fullscreenchange":case "focus":case "hashchange":case "popstate":case "select":case "selectstart":return 1;case "drag":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "mousemove":case "mouseout":case "mouseover":case "pointermove":case "pointerout":case "pointerover":case "scroll":case "toggle":case "touchmove":case "wheel":case "mouseenter":case "mouseleave":case "pointerenter":case "pointerleave":return 4;
	case "message":switch(ec()){case fc:return 1;case gc:return 4;case hc:case ic:return 16;case jc:return 536870912;default:return 16}default:return 16}}var kd=null,ld=null,md=null;function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}
	function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
	function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}A(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
	(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
	var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=A({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=A({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
	a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=A({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=A({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=A({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=A({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=A({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
	Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
	119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
	var Qd=A({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=A({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=A({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=A({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=A({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
	deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=ia&&"CompositionEvent"in window,be=null;ia&&"documentMode"in document&&(be=document.documentMode);var ce=ia&&"TextEvent"in window&&!be,de=ia&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
	function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
	function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
	var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
	function ve(a,b){if("change"===a)return b}var we=!1;if(ia){var xe;if(ia){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));Jb(re,b)}}
	function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge;
	function Ie(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++){var e=c[d];if(!ja.call(b,e)||!He(a[e],b[e]))return!1}return!0}function Je(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Ke(a,b){var c=Je(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Je(c)}}function Le(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Le(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Me(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	function Oe(a){var b=Me(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&c&&c.ownerDocument&&Le(c.ownerDocument.documentElement,c)){if(null!==d&&Ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(a=(b=c.ownerDocument||document)&&b.defaultView||window,a.getSelection){a=a.getSelection();var e=c.textContent.length,f=Math.min(d.start,e);d=void 0===d.end?f:Math.min(d.end,e);!a.extend&&f>d&&(e=d,d=f,f=e);e=Ke(c,f);var g=Ke(c,
	d);e&&g&&(1!==a.rangeCount||a.anchorNode!==e.node||a.anchorOffset!==e.offset||a.focusNode!==g.node||a.focusOffset!==g.offset)&&(b=b.createRange(),b.setStart(e.node,e.offset),a.removeAllRanges(),f>d?(a.addRange(b),a.extend(g.node,g.offset)):(b.setEnd(g.node,g.offset),a.addRange(b)))}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});"function"===typeof c.focus&&c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}}
	var Pe=ia&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
	function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Ne(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Ie(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
	function Ve(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var We={animationend:Ve("Animation","AnimationEnd"),animationiteration:Ve("Animation","AnimationIteration"),animationstart:Ve("Animation","AnimationStart"),transitionend:Ve("Transition","TransitionEnd")},Xe={},Ye={};
	ia&&(Ye=document.createElement("div").style,"AnimationEvent"in window||(delete We.animationend.animation,delete We.animationiteration.animation,delete We.animationstart.animation),"TransitionEvent"in window||delete We.transitionend.transition);function Ze(a){if(Xe[a])return Xe[a];if(!We[a])return a;var b=We[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Ye)return Xe[a]=b[c];return a}var $e=Ze("animationend"),af=Ze("animationiteration"),bf=Ze("animationstart"),cf=Ze("transitionend"),df=new Map,ef="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	function ff(a,b){df.set(a,b);fa(b,[a])}for(var gf=0;gf<ef.length;gf++){var hf=ef[gf],jf=hf.toLowerCase(),kf=hf[0].toUpperCase()+hf.slice(1);ff(jf,"on"+kf)}ff($e,"onAnimationEnd");ff(af,"onAnimationIteration");ff(bf,"onAnimationStart");ff("dblclick","onDoubleClick");ff("focusin","onFocus");ff("focusout","onBlur");ff(cf,"onTransitionEnd");ha("onMouseEnter",["mouseout","mouseover"]);ha("onMouseLeave",["mouseout","mouseover"]);ha("onPointerEnter",["pointerout","pointerover"]);
	ha("onPointerLeave",["pointerout","pointerover"]);fa("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));fa("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));fa("onBeforeInput",["compositionend","keypress","textInput","paste"]);fa("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));fa("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));
	fa("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var lf="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),mf=new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
	function nf(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Ub(d,b,void 0,a);a.currentTarget=null}
	function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;nf(e,h,l);f=k}}}if(Qb)throw a=Rb,Qb=!1,Rb=null,a;}
	function D(a,b){var c=b[of];void 0===c&&(c=b[of]=new Set);var d=a+"__bubble";c.has(d)||(pf(b,a,2,!1),c.add(d))}function qf(a,b,c){var d=0;b&&(d|=4);pf(c,a,d,b)}var rf="_reactListening"+Math.random().toString(36).slice(2);function sf(a){if(!a[rf]){a[rf]=!0;da.forEach(function(b){"selectionchange"!==b&&(mf.has(b)||qf(b,!1,a),qf(b,!0,a))});var b=9===a.nodeType?a:a.ownerDocument;null===b||b[rf]||(b[rf]=!0,qf("selectionchange",!1,b))}}
	function pf(a,b,c,d){switch(jd(b)){case 1:var e=ed;break;case 4:e=gd;break;default:e=fd}c=e.bind(null,b,c,a);e=void 0;!Lb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
	function hd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=Wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Jb(function(){var d=f,e=xb(c),g=[];
	a:{var h=df.get(a);if(void 0!==h){var k=td,n=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":n="focus";k=Fd;break;case "focusout":n="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
	Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case $e:case af:case bf:k=Hd;break;case cf:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var t=0!==(b&4),J=!t&&"scroll"===a,x=t?null!==h?h+"Capture":null:h;t=[];for(var w=d,u;null!==
	w;){u=w;var F=u.stateNode;5===u.tag&&null!==F&&(u=F,null!==x&&(F=Kb(w,x),null!=F&&t.push(tf(w,F,u))));if(J)break;w=w.return}0<t.length&&(h=new k(h,n,null,c,e),g.push({event:h,listeners:t}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&c!==wb&&(n=c.relatedTarget||c.fromElement)&&(Wc(n)||n[uf]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(n=c.relatedTarget||c.toElement,k=d,n=n?Wc(n):null,null!==
	n&&(J=Vb(n),n!==J||5!==n.tag&&6!==n.tag))n=null}else k=null,n=d;if(k!==n){t=Bd;F="onMouseLeave";x="onMouseEnter";w="mouse";if("pointerout"===a||"pointerover"===a)t=Td,F="onPointerLeave",x="onPointerEnter",w="pointer";J=null==k?h:ue(k);u=null==n?h:ue(n);h=new t(F,w+"leave",k,c,e);h.target=J;h.relatedTarget=u;F=null;Wc(e)===d&&(t=new t(x,w+"enter",n,c,e),t.target=u,t.relatedTarget=J,F=t);J=F;if(k&&n)b:{t=k;x=n;w=0;for(u=t;u;u=vf(u))w++;u=0;for(F=x;F;F=vf(F))u++;for(;0<w-u;)t=vf(t),w--;for(;0<u-w;)x=
	vf(x),u--;for(;w--;){if(t===x||null!==x&&t===x.alternate)break b;t=vf(t);x=vf(x)}t=null}else t=null;null!==k&&wf(g,h,k,t,!1);null!==n&&null!==J&&wf(g,J,n,t,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var na=ve;else if(me(h))if(we)na=Fe;else{na=De;var xa=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(na=Ee);if(na&&(na=na(a,d))){ne(g,na,c,e);break a}xa&&xa(a,h,d);"focusout"===a&&(xa=h._wrapperState)&&
	xa.controlled&&"number"===h.type&&cb(h,"number",h.value)}xa=d?ue(d):window;switch(a){case "focusin":if(me(xa)||"true"===xa.contentEditable)Qe=xa,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var $a;if(ae)b:{switch(a){case "compositionstart":var ba="onCompositionStart";break b;case "compositionend":ba="onCompositionEnd";
	break b;case "compositionupdate":ba="onCompositionUpdate";break b}ba=void 0}else ie?ge(a,c)&&(ba="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(ba="onCompositionStart");ba&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==ba?"onCompositionEnd"===ba&&ie&&($a=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),xa=oe(d,ba),0<xa.length&&(ba=new Ld(ba,a,null,c,e),g.push({event:ba,listeners:xa}),$a?ba.data=$a:($a=he(c),null!==$a&&(ba.data=$a))));if($a=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),
	0<d.length&&(e=new Ld("onBeforeInput","beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=$a)}se(g,b)})}function tf(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Kb(a,c),null!=f&&d.unshift(tf(a,f,e)),f=Kb(a,b),null!=f&&d.push(tf(a,f,e)));a=a.return}return d}function vf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
	function wf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Kb(c,f),null!=k&&g.unshift(tf(c,k,h))):e||(k=Kb(c,f),null!=k&&g.push(tf(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}var xf=/\r\n?/g,yf=/\u0000|\uFFFD/g;function zf(a){return("string"===typeof a?a:""+a).replace(xf,"\n").replace(yf,"")}function Af(a,b,c){b=zf(b);if(zf(a)!==b&&c)throw Error(p(425));}function Bf(){}
	var Cf=null,Df=null;function Ef(a,b){return"textarea"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var Ff="function"===typeof setTimeout?setTimeout:void 0,Gf="function"===typeof clearTimeout?clearTimeout:void 0,Hf="function"===typeof Promise?Promise:void 0,Jf="function"===typeof queueMicrotask?queueMicrotask:"undefined"!==typeof Hf?function(a){return Hf.resolve(null).then(a).catch(If)}:Ff;function If(a){setTimeout(function(){throw a;})}
	function Kf(a,b){var c=b,d=0;do{var e=c.nextSibling;a.removeChild(c);if(e&&8===e.nodeType)if(c=e.data,"/$"===c){if(0===d){a.removeChild(e);bd(b);return}d--}else"$"!==c&&"$?"!==c&&"$!"!==c||d++;c=e}while(c);bd(b)}function Lf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break;if(8===b){b=a.data;if("$"===b||"$!"===b||"$?"===b)break;if("/$"===b)return null}}return a}
	function Mf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var Nf=Math.random().toString(36).slice(2),Of="__reactFiber$"+Nf,Pf="__reactProps$"+Nf,uf="__reactContainer$"+Nf,of="__reactEvents$"+Nf,Qf="__reactListeners$"+Nf,Rf="__reactHandles$"+Nf;
	function Wc(a){var b=a[Of];if(b)return b;for(var c=a.parentNode;c;){if(b=c[uf]||c[Of]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Mf(a);null!==a;){if(c=a[Of])return c;a=Mf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[Of]||a[uf];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(p(33));}function Db(a){return a[Pf]||null}var Sf=[],Tf=-1;function Uf(a){return{current:a}}
	function E(a){0>Tf||(a.current=Sf[Tf],Sf[Tf]=null,Tf--)}function G(a,b){Tf++;Sf[Tf]=a.current;a.current=b}var Vf={},H=Uf(Vf),Wf=Uf(!1),Xf=Vf;function Yf(a,b){var c=a.type.contextTypes;if(!c)return Vf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}
	function Zf(a){a=a.childContextTypes;return null!==a&&void 0!==a}function $f(){E(Wf);E(H)}function ag(a,b,c){if(H.current!==Vf)throw Error(p(168));G(H,b);G(Wf,c)}function bg(a,b,c){var d=a.stateNode;b=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in b))throw Error(p(108,Ra(a)||"Unknown",e));return A({},c,d)}
	function cg(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Vf;Xf=H.current;G(H,a);G(Wf,Wf.current);return!0}function dg(a,b,c){var d=a.stateNode;if(!d)throw Error(p(169));c?(a=bg(a,b,Xf),d.__reactInternalMemoizedMergedChildContext=a,E(Wf),E(H),G(H,a)):E(Wf);G(Wf,c)}var eg=null,fg=!1,gg=!1;function hg(a){null===eg?eg=[a]:eg.push(a)}function ig(a){fg=!0;hg(a)}
	function jg(){if(!gg&&null!==eg){gg=!0;var a=0,b=C;try{var c=eg;for(C=1;a<c.length;a++){var d=c[a];do d=d(!0);while(null!==d)}eg=null;fg=!1}catch(e){throw null!==eg&&(eg=eg.slice(a+1)),ac(fc,jg),e;}finally{C=b,gg=!1}}return null}var kg=[],lg=0,mg=null,ng=0,og=[],pg=0,qg=null,rg=1,sg="";function tg(a,b){kg[lg++]=ng;kg[lg++]=mg;mg=a;ng=b}
	function ug(a,b,c){og[pg++]=rg;og[pg++]=sg;og[pg++]=qg;qg=a;var d=rg;a=sg;var e=32-oc(d)-1;d&=~(1<<e);c+=1;var f=32-oc(b)+e;if(30<f){var g=e-e%5;f=(d&(1<<g)-1).toString(32);d>>=g;e-=g;rg=1<<32-oc(b)+e|c<<e|d;sg=f+a}else rg=1<<f|c<<e|d,sg=a}function vg(a){null!==a.return&&(tg(a,1),ug(a,1,0))}function wg(a){for(;a===mg;)mg=kg[--lg],kg[lg]=null,ng=kg[--lg],kg[lg]=null;for(;a===qg;)qg=og[--pg],og[pg]=null,sg=og[--pg],og[pg]=null,rg=og[--pg],og[pg]=null}var xg=null,yg=null,I=!1,zg=null;
	function Ag(a,b){var c=Bg(5,null,null,0);c.elementType="DELETED";c.stateNode=b;c.return=a;b=a.deletions;null===b?(a.deletions=[c],a.flags|=16):b.push(c)}
	function Cg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,xg=a,yg=Lf(b.firstChild),!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,xg=a,yg=null,!0):!1;case 13:return b=8!==b.nodeType?null:b,null!==b?(c=null!==qg?{id:rg,overflow:sg}:null,a.memoizedState={dehydrated:b,treeContext:c,retryLane:1073741824},c=Bg(18,null,null,0),c.stateNode=b,c.return=a,a.child=c,xg=a,yg=
	null,!0):!1;default:return!1}}function Dg(a){return 0!==(a.mode&1)&&0===(a.flags&128)}function Eg(a){if(I){var b=yg;if(b){var c=b;if(!Cg(a,b)){if(Dg(a))throw Error(p(418));b=Lf(c.nextSibling);var d=xg;b&&Cg(a,b)?Ag(d,c):(a.flags=a.flags&-4097|2,I=!1,xg=a)}}else{if(Dg(a))throw Error(p(418));a.flags=a.flags&-4097|2;I=!1;xg=a}}}function Fg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;xg=a}
	function Gg(a){if(a!==xg)return!1;if(!I)return Fg(a),I=!0,!1;var b;(b=3!==a.tag)&&!(b=5!==a.tag)&&(b=a.type,b="head"!==b&&"body"!==b&&!Ef(a.type,a.memoizedProps));if(b&&(b=yg)){if(Dg(a))throw Hg(),Error(p(418));for(;b;)Ag(a,b),b=Lf(b.nextSibling)}Fg(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(p(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){yg=Lf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}yg=
	null}}else yg=xg?Lf(a.stateNode.nextSibling):null;return!0}function Hg(){for(var a=yg;a;)a=Lf(a.nextSibling)}function Ig(){yg=xg=null;I=!1}function Jg(a){null===zg?zg=[a]:zg.push(a)}var Kg=ua.ReactCurrentBatchConfig;
	function Lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(p(309));var d=c.stateNode}if(!d)throw Error(p(147,a));var e=d,f=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===f)return b.ref;b=function(a){var b=e.refs;null===a?delete b[f]:b[f]=a};b._stringRef=f;return b}if("string"!==typeof a)throw Error(p(284));if(!c._owner)throw Error(p(290,a));}return a}
	function Mg(a,b){a=Object.prototype.toString.call(b);throw Error(p(31,"[object Object]"===a?"object with keys {"+Object.keys(b).join(", ")+"}":a));}function Ng(a){var b=a._init;return b(a._payload)}
	function Og(a){function b(b,c){if(a){var d=b.deletions;null===d?(b.deletions=[c],b.flags|=16):d.push(c)}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Pg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return b.flags|=1048576,c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags|=2,c):d;b.flags|=2;return c}function g(b){a&&
	null===b.alternate&&(b.flags|=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Qg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){var f=c.type;if(f===ya)return m(a,b,c.props.children,d,c.key);if(null!==b&&(b.elementType===f||"object"===typeof f&&null!==f&&f.$$typeof===Ha&&Ng(f)===b.type))return d=e(b,c.props),d.ref=Lg(a,b,c),d.return=a,d;d=Rg(c.type,c.key,c.props,null,a.mode,d);d.ref=Lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||
	b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=Sg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Tg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function q(a,b,c){if("string"===typeof b&&""!==b||"number"===typeof b)return b=Qg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case va:return c=Rg(b.type,b.key,b.props,null,a.mode,c),
	c.ref=Lg(a,null,b),c.return=a,c;case wa:return b=Sg(b,a.mode,c),b.return=a,b;case Ha:var d=b._init;return q(a,d(b._payload),c)}if(eb(b)||Ka(b))return b=Tg(b,a.mode,c,null),b.return=a,b;Mg(a,b)}return null}function r(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c&&""!==c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case va:return c.key===e?k(a,b,c,d):null;case wa:return c.key===e?l(a,b,c,d):null;case Ha:return e=c._init,r(a,
	b,e(c._payload),d)}if(eb(c)||Ka(c))return null!==e?null:m(a,b,c,d,null);Mg(a,c)}return null}function y(a,b,c,d,e){if("string"===typeof d&&""!==d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case va:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e);case wa:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e);case Ha:var f=d._init;return y(a,b,c,f(d._payload),e)}if(eb(d)||Ka(d))return a=a.get(c)||null,m(b,a,d,e,null);Mg(b,d)}return null}
	function n(e,g,h,k){for(var l=null,m=null,u=g,w=g=0,x=null;null!==u&&w<h.length;w++){u.index>w?(x=u,u=null):x=u.sibling;var n=r(e,u,h[w],k);if(null===n){null===u&&(u=x);break}a&&u&&null===n.alternate&&b(e,u);g=f(n,g,w);null===m?l=n:m.sibling=n;m=n;u=x}if(w===h.length)return c(e,u),I&&tg(e,w),l;if(null===u){for(;w<h.length;w++)u=q(e,h[w],k),null!==u&&(g=f(u,g,w),null===m?l=u:m.sibling=u,m=u);I&&tg(e,w);return l}for(u=d(e,u);w<h.length;w++)x=y(u,e,w,h[w],k),null!==x&&(a&&null!==x.alternate&&u.delete(null===
	x.key?w:x.key),g=f(x,g,w),null===m?l=x:m.sibling=x,m=x);a&&u.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function t(e,g,h,k){var l=Ka(h);if("function"!==typeof l)throw Error(p(150));h=l.call(h);if(null==h)throw Error(p(151));for(var u=l=null,m=g,w=g=0,x=null,n=h.next();null!==m&&!n.done;w++,n=h.next()){m.index>w?(x=m,m=null):x=m.sibling;var t=r(e,m,n.value,k);if(null===t){null===m&&(m=x);break}a&&m&&null===t.alternate&&b(e,m);g=f(t,g,w);null===u?l=t:u.sibling=t;u=t;m=x}if(n.done)return c(e,
	m),I&&tg(e,w),l;if(null===m){for(;!n.done;w++,n=h.next())n=q(e,n.value,k),null!==n&&(g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);I&&tg(e,w);return l}for(m=d(e,m);!n.done;w++,n=h.next())n=y(m,e,w,n.value,k),null!==n&&(a&&null!==n.alternate&&m.delete(null===n.key?w:n.key),g=f(n,g,w),null===u?l=n:u.sibling=n,u=n);a&&m.forEach(function(a){return b(e,a)});I&&tg(e,w);return l}function J(a,d,f,h){"object"===typeof f&&null!==f&&f.type===ya&&null===f.key&&(f=f.props.children);if("object"===typeof f&&null!==f){switch(f.$$typeof){case va:a:{for(var k=
	f.key,l=d;null!==l;){if(l.key===k){k=f.type;if(k===ya){if(7===l.tag){c(a,l.sibling);d=e(l,f.props.children);d.return=a;a=d;break a}}else if(l.elementType===k||"object"===typeof k&&null!==k&&k.$$typeof===Ha&&Ng(k)===l.type){c(a,l.sibling);d=e(l,f.props);d.ref=Lg(a,l,f);d.return=a;a=d;break a}c(a,l);break}else b(a,l);l=l.sibling}f.type===ya?(d=Tg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Rg(f.type,f.key,f.props,null,a.mode,h),h.ref=Lg(a,d,f),h.return=a,a=h)}return g(a);case wa:a:{for(l=f.key;null!==
	d;){if(d.key===l)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Sg(f,a.mode,h);d.return=a;a=d}return g(a);case Ha:return l=f._init,J(a,d,l(f._payload),h)}if(eb(f))return n(a,d,f,h);if(Ka(f))return t(a,d,f,h);Mg(a,f)}return"string"===typeof f&&""!==f||"number"===typeof f?(f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):
	(c(a,d),d=Qg(f,a.mode,h),d.return=a,a=d),g(a)):c(a,d)}return J}var Ug=Og(!0),Vg=Og(!1),Wg=Uf(null),Xg=null,Yg=null,Zg=null;function $g(){Zg=Yg=Xg=null}function ah(a){var b=Wg.current;E(Wg);a._currentValue=b}function bh(a,b,c){for(;null!==a;){var d=a.alternate;(a.childLanes&b)!==b?(a.childLanes|=b,null!==d&&(d.childLanes|=b)):null!==d&&(d.childLanes&b)!==b&&(d.childLanes|=b);if(a===c)break;a=a.return}}
	function ch(a,b){Xg=a;Zg=Yg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(dh=!0),a.firstContext=null)}function eh(a){var b=a._currentValue;if(Zg!==a)if(a={context:a,memoizedValue:b,next:null},null===Yg){if(null===Xg)throw Error(p(308));Yg=a;Xg.dependencies={lanes:0,firstContext:a}}else Yg=Yg.next=a;return b}var fh=null;function gh(a){null===fh?fh=[a]:fh.push(a)}
	function hh(a,b,c,d){var e=b.interleaved;null===e?(c.next=c,gh(b)):(c.next=e.next,e.next=c);b.interleaved=c;return ih(a,d)}function ih(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}var jh=!1;function kh(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null}}
	function lh(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function mh(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}
	function nh(a,b,c){var d=a.updateQueue;if(null===d)return null;d=d.shared;if(0!==(K&2)){var e=d.pending;null===e?b.next=b:(b.next=e.next,e.next=b);d.pending=b;return ih(a,c)}e=d.interleaved;null===e?(b.next=b,gh(d)):(b.next=e.next,e.next=b);d.interleaved=b;return ih(a,c)}function oh(a,b,c){b=b.updateQueue;if(null!==b&&(b=b.shared,0!==(c&4194240))){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c)}}
	function ph(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
	b;c.lastBaseUpdate=b}
	function qh(a,b,c,d){var e=a.updateQueue;jh=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var m=a.alternate;null!==m&&(m=m.updateQueue,h=m.lastBaseUpdate,h!==g&&(null===h?m.firstBaseUpdate=l:h.next=l,m.lastBaseUpdate=k))}if(null!==f){var q=e.baseState;g=0;m=l=k=null;h=f;do{var r=h.lane,y=h.eventTime;if((d&r)===r){null!==m&&(m=m.next={eventTime:y,lane:0,tag:h.tag,payload:h.payload,callback:h.callback,
	next:null});a:{var n=a,t=h;r=b;y=c;switch(t.tag){case 1:n=t.payload;if("function"===typeof n){q=n.call(y,q,r);break a}q=n;break a;case 3:n.flags=n.flags&-65537|128;case 0:n=t.payload;r="function"===typeof n?n.call(y,q,r):n;if(null===r||void 0===r)break a;q=A({},q,r);break a;case 2:jh=!0}}null!==h.callback&&0!==h.lane&&(a.flags|=64,r=e.effects,null===r?e.effects=[h]:r.push(h))}else y={eventTime:y,lane:r,tag:h.tag,payload:h.payload,callback:h.callback,next:null},null===m?(l=m=y,k=q):m=m.next=y,g|=r;
	h=h.next;if(null===h)if(h=e.shared.pending,null===h)break;else r=h,h=r.next,r.next=null,e.lastBaseUpdate=r,e.shared.pending=null}while(1);null===m&&(k=q);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=m;b=e.shared.interleaved;if(null!==b){e=b;do g|=e.lane,e=e.next;while(e!==b)}else null===f&&(e.shared.lanes=0);rh|=g;a.lanes=g;a.memoizedState=q}}
	function sh(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(p(191,e));e.call(d)}}}var th={},uh=Uf(th),vh=Uf(th),wh=Uf(th);function xh(a){if(a===th)throw Error(p(174));return a}
	function yh(a,b){G(wh,b);G(vh,a);G(uh,th);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:lb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=lb(b,a)}E(uh);G(uh,b)}function zh(){E(uh);E(vh);E(wh)}function Ah(a){xh(wh.current);var b=xh(uh.current);var c=lb(b,a.type);b!==c&&(G(vh,a),G(uh,c))}function Bh(a){vh.current===a&&(E(uh),E(vh))}var L=Uf(0);
	function Ch(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&128))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var Dh=[];
	function Eh(){for(var a=0;a<Dh.length;a++)Dh[a]._workInProgressVersionPrimary=null;Dh.length=0}var Fh=ua.ReactCurrentDispatcher,Gh=ua.ReactCurrentBatchConfig,Hh=0,M=null,N=null,O=null,Ih=!1,Jh=!1,Kh=0,Lh=0;function P(){throw Error(p(321));}function Mh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
	function Nh(a,b,c,d,e,f){Hh=f;M=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;Fh.current=null===a||null===a.memoizedState?Oh:Ph;a=c(d,e);if(Jh){f=0;do{Jh=!1;Kh=0;if(25<=f)throw Error(p(301));f+=1;O=N=null;b.updateQueue=null;Fh.current=Qh;a=c(d,e)}while(Jh)}Fh.current=Rh;b=null!==N&&null!==N.next;Hh=0;O=N=M=null;Ih=!1;if(b)throw Error(p(300));return a}function Sh(){var a=0!==Kh;Kh=0;return a}
	function Th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===O?M.memoizedState=O=a:O=O.next=a;return O}function Uh(){if(null===N){var a=M.alternate;a=null!==a?a.memoizedState:null}else a=N.next;var b=null===O?M.memoizedState:O.next;if(null!==b)O=b,N=a;else{if(null===a)throw Error(p(310));N=a;a={memoizedState:N.memoizedState,baseState:N.baseState,baseQueue:N.baseQueue,queue:N.queue,next:null};null===O?M.memoizedState=O=a:O=O.next=a}return O}
	function Vh(a,b){return"function"===typeof b?b(a):b}
	function Wh(a){var b=Uh(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;var d=N,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){f=e.next;d=d.baseState;var h=g=null,k=null,l=f;do{var m=l.lane;if((Hh&m)===m)null!==k&&(k=k.next={lane:0,action:l.action,hasEagerState:l.hasEagerState,eagerState:l.eagerState,next:null}),d=l.hasEagerState?l.eagerState:a(d,l.action);else{var q={lane:m,action:l.action,hasEagerState:l.hasEagerState,
	eagerState:l.eagerState,next:null};null===k?(h=k=q,g=d):k=k.next=q;M.lanes|=m;rh|=m}l=l.next}while(null!==l&&l!==f);null===k?g=d:k.next=h;He(d,b.memoizedState)||(dh=!0);b.memoizedState=d;b.baseState=g;b.baseQueue=k;c.lastRenderedState=d}a=c.interleaved;if(null!==a){e=a;do f=e.lane,M.lanes|=f,rh|=f,e=e.next;while(e!==a)}else null===e&&(c.lanes=0);return[b.memoizedState,c.dispatch]}
	function Xh(a){var b=Uh(),c=b.queue;if(null===c)throw Error(p(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(dh=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}function Yh(){}
	function Zh(a,b){var c=M,d=Uh(),e=b(),f=!He(d.memoizedState,e);f&&(d.memoizedState=e,dh=!0);d=d.queue;$h(ai.bind(null,c,d,a),[a]);if(d.getSnapshot!==b||f||null!==O&&O.memoizedState.tag&1){c.flags|=2048;bi(9,ci.bind(null,c,d,e,b),void 0,null);if(null===Q)throw Error(p(349));0!==(Hh&30)||di(c,b,e)}return e}function di(a,b,c){a.flags|=16384;a={getSnapshot:b,value:c};b=M.updateQueue;null===b?(b={lastEffect:null,stores:null},M.updateQueue=b,b.stores=[a]):(c=b.stores,null===c?b.stores=[a]:c.push(a))}
	function ci(a,b,c,d){b.value=c;b.getSnapshot=d;ei(b)&&fi(a)}function ai(a,b,c){return c(function(){ei(b)&&fi(a)})}function ei(a){var b=a.getSnapshot;a=a.value;try{var c=b();return!He(a,c)}catch(d){return!0}}function fi(a){var b=ih(a,1);null!==b&&gi(b,a,1,-1)}
	function hi(a){var b=Th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:Vh,lastRenderedState:a};b.queue=a;a=a.dispatch=ii.bind(null,M,a);return[b.memoizedState,a]}
	function bi(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=M.updateQueue;null===b?(b={lastEffect:null,stores:null},M.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function ji(){return Uh().memoizedState}function ki(a,b,c,d){var e=Th();M.flags|=a;e.memoizedState=bi(1|b,c,void 0,void 0===d?null:d)}
	function li(a,b,c,d){var e=Uh();d=void 0===d?null:d;var f=void 0;if(null!==N){var g=N.memoizedState;f=g.destroy;if(null!==d&&Mh(d,g.deps)){e.memoizedState=bi(b,c,f,d);return}}M.flags|=a;e.memoizedState=bi(1|b,c,f,d)}function mi(a,b){return ki(8390656,8,a,b)}function $h(a,b){return li(2048,8,a,b)}function ni(a,b){return li(4,2,a,b)}function oi(a,b){return li(4,4,a,b)}
	function pi(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function qi(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return li(4,4,pi.bind(null,b,a),c)}function ri(){}function si(a,b){var c=Uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Mh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function ti(a,b){var c=Uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Mh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function ui(a,b,c){if(0===(Hh&21))return a.baseState&&(a.baseState=!1,dh=!0),a.memoizedState=c;He(c,b)||(c=yc(),M.lanes|=c,rh|=c,a.baseState=!0);return b}function vi(a,b){var c=C;C=0!==c&&4>c?c:4;a(!0);var d=Gh.transition;Gh.transition={};try{a(!1),b()}finally{C=c,Gh.transition=d}}function wi(){return Uh().memoizedState}
	function xi(a,b,c){var d=yi(a);c={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(zi(a))Ai(b,c);else if(c=hh(a,b,c,d),null!==c){var e=R();gi(c,a,d,e);Bi(c,b,d)}}
	function ii(a,b,c){var d=yi(a),e={lane:d,action:c,hasEagerState:!1,eagerState:null,next:null};if(zi(a))Ai(b,e);else{var f=a.alternate;if(0===a.lanes&&(null===f||0===f.lanes)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.hasEagerState=!0;e.eagerState=h;if(He(h,g)){var k=b.interleaved;null===k?(e.next=e,gh(b)):(e.next=k.next,k.next=e);b.interleaved=e;return}}catch(l){}finally{}c=hh(a,b,e,d);null!==c&&(e=R(),gi(c,a,d,e),Bi(c,b,d))}}
	function zi(a){var b=a.alternate;return a===M||null!==b&&b===M}function Ai(a,b){Jh=Ih=!0;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}function Bi(a,b,c){if(0!==(c&4194240)){var d=b.lanes;d&=a.pendingLanes;c|=d;b.lanes=c;Cc(a,c)}}
	var Rh={readContext:eh,useCallback:P,useContext:P,useEffect:P,useImperativeHandle:P,useInsertionEffect:P,useLayoutEffect:P,useMemo:P,useReducer:P,useRef:P,useState:P,useDebugValue:P,useDeferredValue:P,useTransition:P,useMutableSource:P,useSyncExternalStore:P,useId:P,unstable_isNewReconciler:!1},Oh={readContext:eh,useCallback:function(a,b){Th().memoizedState=[a,void 0===b?null:b];return a},useContext:eh,useEffect:mi,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ki(4194308,
	4,pi.bind(null,b,a),c)},useLayoutEffect:function(a,b){return ki(4194308,4,a,b)},useInsertionEffect:function(a,b){return ki(4,2,a,b)},useMemo:function(a,b){var c=Th();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};d.queue=a;a=a.dispatch=xi.bind(null,M,a);return[d.memoizedState,a]},useRef:function(a){var b=
	Th();a={current:a};return b.memoizedState=a},useState:hi,useDebugValue:ri,useDeferredValue:function(a){return Th().memoizedState=a},useTransition:function(){var a=hi(!1),b=a[0];a=vi.bind(null,a[1]);Th().memoizedState=a;return[b,a]},useMutableSource:function(){},useSyncExternalStore:function(a,b,c){var d=M,e=Th();if(I){if(void 0===c)throw Error(p(407));c=c()}else{c=b();if(null===Q)throw Error(p(349));0!==(Hh&30)||di(d,b,c)}e.memoizedState=c;var f={value:c,getSnapshot:b};e.queue=f;mi(ai.bind(null,d,
	f,a),[a]);d.flags|=2048;bi(9,ci.bind(null,d,f,c,b),void 0,null);return c},useId:function(){var a=Th(),b=Q.identifierPrefix;if(I){var c=sg;var d=rg;c=(d&~(1<<32-oc(d)-1)).toString(32)+c;b=":"+b+"R"+c;c=Kh++;0<c&&(b+="H"+c.toString(32));b+=":"}else c=Lh++,b=":"+b+"r"+c.toString(32)+":";return a.memoizedState=b},unstable_isNewReconciler:!1},Ph={readContext:eh,useCallback:si,useContext:eh,useEffect:$h,useImperativeHandle:qi,useInsertionEffect:ni,useLayoutEffect:oi,useMemo:ti,useReducer:Wh,useRef:ji,useState:function(){return Wh(Vh)},
	useDebugValue:ri,useDeferredValue:function(a){var b=Uh();return ui(b,N.memoizedState,a)},useTransition:function(){var a=Wh(Vh)[0],b=Uh().memoizedState;return[a,b]},useMutableSource:Yh,useSyncExternalStore:Zh,useId:wi,unstable_isNewReconciler:!1},Qh={readContext:eh,useCallback:si,useContext:eh,useEffect:$h,useImperativeHandle:qi,useInsertionEffect:ni,useLayoutEffect:oi,useMemo:ti,useReducer:Xh,useRef:ji,useState:function(){return Xh(Vh)},useDebugValue:ri,useDeferredValue:function(a){var b=Uh();return null===
	N?b.memoizedState=a:ui(b,N.memoizedState,a)},useTransition:function(){var a=Xh(Vh)[0],b=Uh().memoizedState;return[a,b]},useMutableSource:Yh,useSyncExternalStore:Zh,useId:wi,unstable_isNewReconciler:!1};function Ci(a,b){if(a&&a.defaultProps){b=A({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}function Di(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:A({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
	var Ei={isMounted:function(a){return(a=a._reactInternals)?Vb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=R(),e=yi(a),f=mh(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=nh(a,f,e);null!==b&&(gi(b,a,e,d),oh(b,a,e))},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=R(),e=yi(a),f=mh(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);b=nh(a,f,e);null!==b&&(gi(b,a,e,d),oh(b,a,e))},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=R(),d=
	yi(a),e=mh(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=b);b=nh(a,e,d);null!==b&&(gi(b,a,d,c),oh(b,a,d))}};function Fi(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Ie(c,d)||!Ie(e,f):!0}
	function Gi(a,b,c){var d=!1,e=Vf;var f=b.contextType;"object"===typeof f&&null!==f?f=eh(f):(e=Zf(b)?Xf:H.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Yf(a,e):Vf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Ei;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Hi(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Ei.enqueueReplaceState(b,b.state,null)}
	function Ii(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs={};kh(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=eh(f):(f=Zf(b)?Xf:H.current,e.context=Yf(a,f));e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Di(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(b=e.state,
	"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Ei.enqueueReplaceState(e,e.state,null),qh(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4194308)}function Ji(a,b){try{var c="",d=b;do c+=Pa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e,digest:null}}
	function Ki(a,b,c){return{value:a,source:null,stack:null!=c?c:null,digest:null!=b?b:null}}function Li(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Mi="function"===typeof WeakMap?WeakMap:Map;function Ni(a,b,c){c=mh(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Oi||(Oi=!0,Pi=d);Li(a,b)};return c}
	function Qi(a,b,c){c=mh(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)};c.callback=function(){Li(a,b)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){Li(a,b);"function"!==typeof d&&(null===Ri?Ri=new Set([this]):Ri.add(this));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	function Si(a,b,c){var d=a.pingCache;if(null===d){d=a.pingCache=new Mi;var e=new Set;d.set(b,e)}else e=d.get(b),void 0===e&&(e=new Set,d.set(b,e));e.has(c)||(e.add(c),a=Ti.bind(null,a,b,c),b.then(a,a))}function Ui(a){do{var b;if(b=13===a.tag)b=a.memoizedState,b=null!==b?null!==b.dehydrated?!0:!1:!0;if(b)return a;a=a.return}while(null!==a);return null}
	function Vi(a,b,c,d,e){if(0===(a.mode&1))return a===b?a.flags|=65536:(a.flags|=128,c.flags|=131072,c.flags&=-52805,1===c.tag&&(null===c.alternate?c.tag=17:(b=mh(-1,1),b.tag=2,nh(c,b,1))),c.lanes|=1),a;a.flags|=65536;a.lanes=e;return a}var Wi=ua.ReactCurrentOwner,dh=!1;function Xi(a,b,c,d){b.child=null===a?Vg(b,null,c,d):Ug(b,a.child,c,d)}
	function Yi(a,b,c,d,e){c=c.render;var f=b.ref;ch(b,e);d=Nh(a,b,c,d,f,e);c=Sh();if(null!==a&&!dh)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,Zi(a,b,e);I&&c&&vg(b);b.flags|=1;Xi(a,b,d,e);return b.child}
	function $i(a,b,c,d,e){if(null===a){var f=c.type;if("function"===typeof f&&!aj(f)&&void 0===f.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=f,bj(a,b,f,d,e);a=Rg(c.type,null,d,b,b.mode,e);a.ref=b.ref;a.return=b;return b.child=a}f=a.child;if(0===(a.lanes&e)){var g=f.memoizedProps;c=c.compare;c=null!==c?c:Ie;if(c(g,d)&&a.ref===b.ref)return Zi(a,b,e)}b.flags|=1;a=Pg(f,d);a.ref=b.ref;a.return=b;return b.child=a}
	function bj(a,b,c,d,e){if(null!==a){var f=a.memoizedProps;if(Ie(f,d)&&a.ref===b.ref)if(dh=!1,b.pendingProps=d=f,0!==(a.lanes&e))0!==(a.flags&131072)&&(dh=!0);else return b.lanes=a.lanes,Zi(a,b,e)}return cj(a,b,c,d,e)}
	function dj(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode)if(0===(b.mode&1))b.memoizedState={baseLanes:0,cachePool:null,transitions:null},G(ej,fj),fj|=c;else{if(0===(c&1073741824))return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a,cachePool:null,transitions:null},b.updateQueue=null,G(ej,fj),fj|=a,null;b.memoizedState={baseLanes:0,cachePool:null,transitions:null};d=null!==f?f.baseLanes:c;G(ej,fj);fj|=d}else null!==
	f?(d=f.baseLanes|c,b.memoizedState=null):d=c,G(ej,fj),fj|=d;Xi(a,b,e,c);return b.child}function gj(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=512,b.flags|=2097152}function cj(a,b,c,d,e){var f=Zf(c)?Xf:H.current;f=Yf(b,f);ch(b,e);c=Nh(a,b,c,d,f,e);d=Sh();if(null!==a&&!dh)return b.updateQueue=a.updateQueue,b.flags&=-2053,a.lanes&=~e,Zi(a,b,e);I&&d&&vg(b);b.flags|=1;Xi(a,b,c,e);return b.child}
	function hj(a,b,c,d,e){if(Zf(c)){var f=!0;cg(b)}else f=!1;ch(b,e);if(null===b.stateNode)ij(a,b),Gi(b,c,d),Ii(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=eh(l):(l=Zf(c)?Xf:H.current,l=Yf(b,l));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||
	(h!==d||k!==l)&&Hi(b,g,d,l);jh=!1;var r=b.memoizedState;g.state=r;qh(b,d,g,e);k=b.memoizedState;h!==d||r!==k||Wf.current||jh?("function"===typeof m&&(Di(b,c,m,d),k=b.memoizedState),(h=jh||Fi(b,c,h,d,r,k,l))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.flags|=4194308)):
	("function"===typeof g.componentDidMount&&(b.flags|=4194308),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4194308),d=!1)}else{g=b.stateNode;lh(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:Ci(b.type,h);g.props=l;q=b.pendingProps;r=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=eh(k):(k=Zf(c)?Xf:H.current,k=Yf(b,k));var y=c.getDerivedStateFromProps;(m="function"===typeof y||"function"===typeof g.getSnapshotBeforeUpdate)||
	"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==q||r!==k)&&Hi(b,g,d,k);jh=!1;r=b.memoizedState;g.state=r;qh(b,d,g,e);var n=b.memoizedState;h!==q||r!==n||Wf.current||jh?("function"===typeof y&&(Di(b,c,y,d),n=b.memoizedState),(l=jh||Fi(b,c,l,d,r,n,k)||!1)?(m||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,n,k),"function"===typeof g.UNSAFE_componentWillUpdate&&
	g.UNSAFE_componentWillUpdate(d,n,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=1024)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),b.memoizedProps=d,b.memoizedState=n),g.props=d,g.state=n,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&r===
	a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&r===a.memoizedState||(b.flags|=1024),d=!1)}return jj(a,b,c,d,f,e)}
	function jj(a,b,c,d,e,f){gj(a,b);var g=0!==(b.flags&128);if(!d&&!g)return e&&dg(b,c,!1),Zi(a,b,f);d=b.stateNode;Wi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Ug(b,a.child,null,f),b.child=Ug(b,null,h,f)):Xi(a,b,h,f);b.memoizedState=d.state;e&&dg(b,c,!0);return b.child}function kj(a){var b=a.stateNode;b.pendingContext?ag(a,b.pendingContext,b.pendingContext!==b.context):b.context&&ag(a,b.context,!1);yh(a,b.containerInfo)}
	function lj(a,b,c,d,e){Ig();Jg(e);b.flags|=256;Xi(a,b,c,d);return b.child}var mj={dehydrated:null,treeContext:null,retryLane:0};function nj(a){return{baseLanes:a,cachePool:null,transitions:null}}
	function oj(a,b,c){var d=b.pendingProps,e=L.current,f=!1,g=0!==(b.flags&128),h;(h=g)||(h=null!==a&&null===a.memoizedState?!1:0!==(e&2));if(h)f=!0,b.flags&=-129;else if(null===a||null!==a.memoizedState)e|=1;G(L,e&1);if(null===a){Eg(b);a=b.memoizedState;if(null!==a&&(a=a.dehydrated,null!==a))return 0===(b.mode&1)?b.lanes=1:"$!"===a.data?b.lanes=8:b.lanes=1073741824,null;g=d.children;a=d.fallback;return f?(d=b.mode,f=b.child,g={mode:"hidden",children:g},0===(d&1)&&null!==f?(f.childLanes=0,f.pendingProps=
	g):f=pj(g,d,0,null),a=Tg(a,d,c,null),f.return=b,a.return=b,f.sibling=a,b.child=f,b.child.memoizedState=nj(c),b.memoizedState=mj,a):qj(b,g)}e=a.memoizedState;if(null!==e&&(h=e.dehydrated,null!==h))return rj(a,b,g,d,h,e,c);if(f){f=d.fallback;g=b.mode;e=a.child;h=e.sibling;var k={mode:"hidden",children:d.children};0===(g&1)&&b.child!==e?(d=b.child,d.childLanes=0,d.pendingProps=k,b.deletions=null):(d=Pg(e,k),d.subtreeFlags=e.subtreeFlags&14680064);null!==h?f=Pg(h,f):(f=Tg(f,g,c,null),f.flags|=2);f.return=
	b;d.return=b;d.sibling=f;b.child=d;d=f;f=b.child;g=a.child.memoizedState;g=null===g?nj(c):{baseLanes:g.baseLanes|c,cachePool:null,transitions:g.transitions};f.memoizedState=g;f.childLanes=a.childLanes&~c;b.memoizedState=mj;return d}f=a.child;a=f.sibling;d=Pg(f,{mode:"visible",children:d.children});0===(b.mode&1)&&(d.lanes=c);d.return=b;d.sibling=null;null!==a&&(c=b.deletions,null===c?(b.deletions=[a],b.flags|=16):c.push(a));b.child=d;b.memoizedState=null;return d}
	function qj(a,b){b=pj({mode:"visible",children:b},a.mode,0,null);b.return=a;return a.child=b}function sj(a,b,c,d){null!==d&&Jg(d);Ug(b,a.child,null,c);a=qj(b,b.pendingProps.children);a.flags|=2;b.memoizedState=null;return a}
	function rj(a,b,c,d,e,f,g){if(c){if(b.flags&256)return b.flags&=-257,d=Ki(Error(p(422))),sj(a,b,g,d);if(null!==b.memoizedState)return b.child=a.child,b.flags|=128,null;f=d.fallback;e=b.mode;d=pj({mode:"visible",children:d.children},e,0,null);f=Tg(f,e,g,null);f.flags|=2;d.return=b;f.return=b;d.sibling=f;b.child=d;0!==(b.mode&1)&&Ug(b,a.child,null,g);b.child.memoizedState=nj(g);b.memoizedState=mj;return f}if(0===(b.mode&1))return sj(a,b,g,null);if("$!"===e.data){d=e.nextSibling&&e.nextSibling.dataset;
	if(d)var h=d.dgst;d=h;f=Error(p(419));d=Ki(f,d,void 0);return sj(a,b,g,d)}h=0!==(g&a.childLanes);if(dh||h){d=Q;if(null!==d){switch(g&-g){case 4:e=2;break;case 16:e=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:e=32;break;case 536870912:e=268435456;break;default:e=0}e=0!==(e&(d.suspendedLanes|g))?0:e;
	0!==e&&e!==f.retryLane&&(f.retryLane=e,ih(a,e),gi(d,a,e,-1))}tj();d=Ki(Error(p(421)));return sj(a,b,g,d)}if("$?"===e.data)return b.flags|=128,b.child=a.child,b=uj.bind(null,a),e._reactRetry=b,null;a=f.treeContext;yg=Lf(e.nextSibling);xg=b;I=!0;zg=null;null!==a&&(og[pg++]=rg,og[pg++]=sg,og[pg++]=qg,rg=a.id,sg=a.overflow,qg=b);b=qj(b,d.children);b.flags|=4096;return b}function vj(a,b,c){a.lanes|=b;var d=a.alternate;null!==d&&(d.lanes|=b);bh(a.return,b,c)}
	function wj(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.renderingStartTime=0,f.last=d,f.tail=c,f.tailMode=e)}
	function xj(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;Xi(a,b,d.children,c);d=L.current;if(0!==(d&2))d=d&1|2,b.flags|=128;else{if(null!==a&&0!==(a.flags&128))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&vj(a,c,b);else if(19===a.tag)vj(a,c,b);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}G(L,d);if(0===(b.mode&1))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===Ch(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);wj(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===Ch(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}wj(b,!0,c,null,f);break;case "together":wj(b,!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}
	function ij(a,b){0===(b.mode&1)&&null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2)}function Zi(a,b,c){null!==a&&(b.dependencies=a.dependencies);rh|=b.lanes;if(0===(c&b.childLanes))return null;if(null!==a&&b.child!==a.child)throw Error(p(153));if(null!==b.child){a=b.child;c=Pg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Pg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}
	function yj(a,b,c){switch(b.tag){case 3:kj(b);Ig();break;case 5:Ah(b);break;case 1:Zf(b.type)&&cg(b);break;case 4:yh(b,b.stateNode.containerInfo);break;case 10:var d=b.type._context,e=b.memoizedProps.value;G(Wg,d._currentValue);d._currentValue=e;break;case 13:d=b.memoizedState;if(null!==d){if(null!==d.dehydrated)return G(L,L.current&1),b.flags|=128,null;if(0!==(c&b.child.childLanes))return oj(a,b,c);G(L,L.current&1);a=Zi(a,b,c);return null!==a?a.sibling:null}G(L,L.current&1);break;case 19:d=0!==(c&
	b.childLanes);if(0!==(a.flags&128)){if(d)return xj(a,b,c);b.flags|=128}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);G(L,L.current);if(d)break;else return null;case 22:case 23:return b.lanes=0,dj(a,b,c)}return Zi(a,b,c)}var zj,Aj,Bj,Cj;
	zj=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Aj=function(){};
	Bj=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;xh(uh.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "select":e=A({},e,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=Bf)}ub(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&
	(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ea.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,
	c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ea.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&D("scroll",a),f||h===k||(f=[])):(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",c);var l=f;if(b.updateQueue=l)b.flags|=4}};Cj=function(a,b,c,d){c!==d&&(b.flags|=4)};
	function Dj(a,b){if(!I)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function S(a){var b=null!==a.alternate&&a.alternate.child===a.child,c=0,d=0;if(b)for(var e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags&14680064,d|=e.flags&14680064,e.return=a,e=e.sibling;else for(e=a.child;null!==e;)c|=e.lanes|e.childLanes,d|=e.subtreeFlags,d|=e.flags,e.return=a,e=e.sibling;a.subtreeFlags|=d;a.childLanes=c;return b}
	function Ej(a,b,c){var d=b.pendingProps;wg(b);switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return S(b),null;case 1:return Zf(b.type)&&$f(),S(b),null;case 3:d=b.stateNode;zh();E(Wf);E(H);Eh();d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Gg(b)?b.flags|=4:null===a||a.memoizedState.isDehydrated&&0===(b.flags&256)||(b.flags|=1024,null!==zg&&(Fj(zg),zg=null));Aj(a,b);S(b);return null;case 5:Bh(b);var e=xh(wh.current);
	c=b.type;if(null!==a&&null!=b.stateNode)Bj(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=512,b.flags|=2097152);else{if(!d){if(null===b.stateNode)throw Error(p(166));S(b);return null}a=xh(uh.current);if(Gg(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[Of]=b;d[Pf]=f;a=0!==(b.mode&1);switch(c){case "dialog":D("cancel",d);D("close",d);break;case "iframe":case "object":case "embed":D("load",d);break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],d);break;case "source":D("error",d);break;case "img":case "image":case "link":D("error",
	d);D("load",d);break;case "details":D("toggle",d);break;case "input":Za(d,f);D("invalid",d);break;case "select":d._wrapperState={wasMultiple:!!f.multiple};D("invalid",d);break;case "textarea":hb(d,f),D("invalid",d)}ub(c,f);e=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,h,a),e=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(!0!==f.suppressHydrationWarning&&Af(d.textContent,
	h,a),e=["children",""+h]):ea.hasOwnProperty(g)&&null!=h&&"onScroll"===g&&D("scroll",d)}switch(c){case "input":Va(d);db(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=Bf)}d=e;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;"http://www.w3.org/1999/xhtml"===a&&(a=kb(c));"http://www.w3.org/1999/xhtml"===a?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):
	"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[Of]=b;a[Pf]=d;zj(a,b,!1,!1);b.stateNode=a;a:{g=vb(c,d);switch(c){case "dialog":D("cancel",a);D("close",a);e=d;break;case "iframe":case "object":case "embed":D("load",a);e=d;break;case "video":case "audio":for(e=0;e<lf.length;e++)D(lf[e],a);e=d;break;case "source":D("error",a);e=d;break;case "img":case "image":case "link":D("error",
	a);D("load",a);e=d;break;case "details":D("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);D("invalid",a);break;case "option":e=d;break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=A({},d,{value:void 0});D("invalid",a);break;case "textarea":hb(a,d);e=gb(a,d);D("invalid",a);break;default:e=d}ub(c,e);h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?sb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&nb(a,k)):"children"===f?"string"===typeof k?("textarea"!==
	c||""!==k)&&ob(a,k):"number"===typeof k&&ob(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ea.hasOwnProperty(f)?null!=k&&"onScroll"===f&&D("scroll",a):null!=k&&ta(a,f,k,g))}switch(c){case "input":Va(a);db(a,d,!1);break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,
	!0);break;default:"function"===typeof e.onClick&&(a.onclick=Bf)}switch(c){case "button":case "input":case "select":case "textarea":d=!!d.autoFocus;break a;case "img":d=!0;break a;default:d=!1}}d&&(b.flags|=4)}null!==b.ref&&(b.flags|=512,b.flags|=2097152)}S(b);return null;case 6:if(a&&null!=b.stateNode)Cj(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(p(166));c=xh(wh.current);xh(uh.current);if(Gg(b)){d=b.stateNode;c=b.memoizedProps;d[Of]=b;if(f=d.nodeValue!==c)if(a=
	xg,null!==a)switch(a.tag){case 3:Af(d.nodeValue,c,0!==(a.mode&1));break;case 5:!0!==a.memoizedProps.suppressHydrationWarning&&Af(d.nodeValue,c,0!==(a.mode&1))}f&&(b.flags|=4)}else d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[Of]=b,b.stateNode=d}S(b);return null;case 13:E(L);d=b.memoizedState;if(null===a||null!==a.memoizedState&&null!==a.memoizedState.dehydrated){if(I&&null!==yg&&0!==(b.mode&1)&&0===(b.flags&128))Hg(),Ig(),b.flags|=98560,f=!1;else if(f=Gg(b),null!==d&&null!==d.dehydrated){if(null===
	a){if(!f)throw Error(p(318));f=b.memoizedState;f=null!==f?f.dehydrated:null;if(!f)throw Error(p(317));f[Of]=b}else Ig(),0===(b.flags&128)&&(b.memoizedState=null),b.flags|=4;S(b);f=!1}else null!==zg&&(Fj(zg),zg=null),f=!0;if(!f)return b.flags&65536?b:null}if(0!==(b.flags&128))return b.lanes=c,b;d=null!==d;d!==(null!==a&&null!==a.memoizedState)&&d&&(b.child.flags|=8192,0!==(b.mode&1)&&(null===a||0!==(L.current&1)?0===T&&(T=3):tj()));null!==b.updateQueue&&(b.flags|=4);S(b);return null;case 4:return zh(),
	Aj(a,b),null===a&&sf(b.stateNode.containerInfo),S(b),null;case 10:return ah(b.type._context),S(b),null;case 17:return Zf(b.type)&&$f(),S(b),null;case 19:E(L);f=b.memoizedState;if(null===f)return S(b),null;d=0!==(b.flags&128);g=f.rendering;if(null===g)if(d)Dj(f,!1);else{if(0!==T||null!==a&&0!==(a.flags&128))for(a=b.child;null!==a;){g=Ch(a);if(null!==g){b.flags|=128;Dj(f,!1);d=g.updateQueue;null!==d&&(b.updateQueue=d,b.flags|=4);b.subtreeFlags=0;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=14680066,
	g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.subtreeFlags=0,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.subtreeFlags=0,f.deletions=null,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;G(L,L.current&1|2);return b.child}a=
	a.sibling}null!==f.tail&&B()>Gj&&(b.flags|=128,d=!0,Dj(f,!1),b.lanes=4194304)}else{if(!d)if(a=Ch(g),null!==a){if(b.flags|=128,d=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Dj(f,!0),null===f.tail&&"hidden"===f.tailMode&&!g.alternate&&!I)return S(b),null}else 2*B()-f.renderingStartTime>Gj&&1073741824!==c&&(b.flags|=128,d=!0,Dj(f,!1),b.lanes=4194304);f.isBackwards?(g.sibling=b.child,b.child=g):(c=f.last,null!==c?c.sibling=g:b.child=g,f.last=g)}if(null!==f.tail)return b=f.tail,f.rendering=
	b,f.tail=b.sibling,f.renderingStartTime=B(),b.sibling=null,c=L.current,G(L,d?c&1|2:c&1),b;S(b);return null;case 22:case 23:return Hj(),d=null!==b.memoizedState,null!==a&&null!==a.memoizedState!==d&&(b.flags|=8192),d&&0!==(b.mode&1)?0!==(fj&1073741824)&&(S(b),b.subtreeFlags&6&&(b.flags|=8192)):S(b),null;case 24:return null;case 25:return null}throw Error(p(156,b.tag));}
	function Ij(a,b){wg(b);switch(b.tag){case 1:return Zf(b.type)&&$f(),a=b.flags,a&65536?(b.flags=a&-65537|128,b):null;case 3:return zh(),E(Wf),E(H),Eh(),a=b.flags,0!==(a&65536)&&0===(a&128)?(b.flags=a&-65537|128,b):null;case 5:return Bh(b),null;case 13:E(L);a=b.memoizedState;if(null!==a&&null!==a.dehydrated){if(null===b.alternate)throw Error(p(340));Ig()}a=b.flags;return a&65536?(b.flags=a&-65537|128,b):null;case 19:return E(L),null;case 4:return zh(),null;case 10:return ah(b.type._context),null;case 22:case 23:return Hj(),
	null;case 24:return null;default:return null}}var Jj=!1,U=!1,Kj="function"===typeof WeakSet?WeakSet:Set,V=null;function Lj(a,b){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(d){W(a,b,d)}else c.current=null}function Mj(a,b,c){try{c()}catch(d){W(a,b,d)}}var Nj=!1;
	function Oj(a,b){Cf=dd;a=Me();if(Ne(a)){if("selectionStart"in a)var c={start:a.selectionStart,end:a.selectionEnd};else a:{c=(c=a.ownerDocument)&&c.defaultView||window;var d=c.getSelection&&c.getSelection();if(d&&0!==d.rangeCount){c=d.anchorNode;var e=d.anchorOffset,f=d.focusNode;d=d.focusOffset;try{c.nodeType,f.nodeType}catch(F){c=null;break a}var g=0,h=-1,k=-1,l=0,m=0,q=a,r=null;b:for(;;){for(var y;;){q!==c||0!==e&&3!==q.nodeType||(h=g+e);q!==f||0!==d&&3!==q.nodeType||(k=g+d);3===q.nodeType&&(g+=
	q.nodeValue.length);if(null===(y=q.firstChild))break;r=q;q=y}for(;;){if(q===a)break b;r===c&&++l===e&&(h=g);r===f&&++m===d&&(k=g);if(null!==(y=q.nextSibling))break;q=r;r=q.parentNode}q=y}c=-1===h||-1===k?null:{start:h,end:k}}else c=null}c=c||{start:0,end:0}}else c=null;Df={focusedElem:a,selectionRange:c};dd=!1;for(V=b;null!==V;)if(b=V,a=b.child,0!==(b.subtreeFlags&1028)&&null!==a)a.return=b,V=a;else for(;null!==V;){b=V;try{var n=b.alternate;if(0!==(b.flags&1024))switch(b.tag){case 0:case 11:case 15:break;
	case 1:if(null!==n){var t=n.memoizedProps,J=n.memoizedState,x=b.stateNode,w=x.getSnapshotBeforeUpdate(b.elementType===b.type?t:Ci(b.type,t),J);x.__reactInternalSnapshotBeforeUpdate=w}break;case 3:var u=b.stateNode.containerInfo;1===u.nodeType?u.textContent="":9===u.nodeType&&u.documentElement&&u.removeChild(u.documentElement);break;case 5:case 6:case 4:case 17:break;default:throw Error(p(163));}}catch(F){W(b,b.return,F)}a=b.sibling;if(null!==a){a.return=b.return;V=a;break}V=b.return}n=Nj;Nj=!1;return n}
	function Pj(a,b,c){var d=b.updateQueue;d=null!==d?d.lastEffect:null;if(null!==d){var e=d=d.next;do{if((e.tag&a)===a){var f=e.destroy;e.destroy=void 0;void 0!==f&&Mj(b,c,f)}e=e.next}while(e!==d)}}function Qj(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}function Rj(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=c;break;default:a=c}"function"===typeof b?b(a):b.current=a}}
	function Sj(a){var b=a.alternate;null!==b&&(a.alternate=null,Sj(b));a.child=null;a.deletions=null;a.sibling=null;5===a.tag&&(b=a.stateNode,null!==b&&(delete b[Of],delete b[Pf],delete b[of],delete b[Qf],delete b[Rf]));a.stateNode=null;a.return=null;a.dependencies=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.stateNode=null;a.updateQueue=null}function Tj(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Uj(a){a:for(;;){for(;null===a.sibling;){if(null===a.return||Tj(a.return))return null;a=a.return}a.sibling.return=a.return;for(a=a.sibling;5!==a.tag&&6!==a.tag&&18!==a.tag;){if(a.flags&2)continue a;if(null===a.child||4===a.tag)continue a;else a.child.return=a,a=a.child}if(!(a.flags&2))return a.stateNode}}
	function Vj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=Bf));else if(4!==d&&(a=a.child,null!==a))for(Vj(a,b,c),a=a.sibling;null!==a;)Vj(a,b,c),a=a.sibling}
	function Wj(a,b,c){var d=a.tag;if(5===d||6===d)a=a.stateNode,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Wj(a,b,c),a=a.sibling;null!==a;)Wj(a,b,c),a=a.sibling}var X=null,Xj=!1;function Yj(a,b,c){for(c=c.child;null!==c;)Zj(a,b,c),c=c.sibling}
	function Zj(a,b,c){if(lc&&"function"===typeof lc.onCommitFiberUnmount)try{lc.onCommitFiberUnmount(kc,c)}catch(h){}switch(c.tag){case 5:U||Lj(c,b);case 6:var d=X,e=Xj;X=null;Yj(a,b,c);X=d;Xj=e;null!==X&&(Xj?(a=X,c=c.stateNode,8===a.nodeType?a.parentNode.removeChild(c):a.removeChild(c)):X.removeChild(c.stateNode));break;case 18:null!==X&&(Xj?(a=X,c=c.stateNode,8===a.nodeType?Kf(a.parentNode,c):1===a.nodeType&&Kf(a,c),bd(a)):Kf(X,c.stateNode));break;case 4:d=X;e=Xj;X=c.stateNode.containerInfo;Xj=!0;
	Yj(a,b,c);X=d;Xj=e;break;case 0:case 11:case 14:case 15:if(!U&&(d=c.updateQueue,null!==d&&(d=d.lastEffect,null!==d))){e=d=d.next;do{var f=e,g=f.destroy;f=f.tag;void 0!==g&&(0!==(f&2)?Mj(c,b,g):0!==(f&4)&&Mj(c,b,g));e=e.next}while(e!==d)}Yj(a,b,c);break;case 1:if(!U&&(Lj(c,b),d=c.stateNode,"function"===typeof d.componentWillUnmount))try{d.props=c.memoizedProps,d.state=c.memoizedState,d.componentWillUnmount()}catch(h){W(c,b,h)}Yj(a,b,c);break;case 21:Yj(a,b,c);break;case 22:c.mode&1?(U=(d=U)||null!==
	c.memoizedState,Yj(a,b,c),U=d):Yj(a,b,c);break;default:Yj(a,b,c)}}function ak(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Kj);b.forEach(function(b){var d=bk.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
	function ck(a,b){var c=b.deletions;if(null!==c)for(var d=0;d<c.length;d++){var e=c[d];try{var f=a,g=b,h=g;a:for(;null!==h;){switch(h.tag){case 5:X=h.stateNode;Xj=!1;break a;case 3:X=h.stateNode.containerInfo;Xj=!0;break a;case 4:X=h.stateNode.containerInfo;Xj=!0;break a}h=h.return}if(null===X)throw Error(p(160));Zj(f,g,e);X=null;Xj=!1;var k=e.alternate;null!==k&&(k.return=null);e.return=null}catch(l){W(e,b,l)}}if(b.subtreeFlags&12854)for(b=b.child;null!==b;)dk(b,a),b=b.sibling}
	function dk(a,b){var c=a.alternate,d=a.flags;switch(a.tag){case 0:case 11:case 14:case 15:ck(b,a);ek(a);if(d&4){try{Pj(3,a,a.return),Qj(3,a)}catch(t){W(a,a.return,t)}try{Pj(5,a,a.return)}catch(t){W(a,a.return,t)}}break;case 1:ck(b,a);ek(a);d&512&&null!==c&&Lj(c,c.return);break;case 5:ck(b,a);ek(a);d&512&&null!==c&&Lj(c,c.return);if(a.flags&32){var e=a.stateNode;try{ob(e,"")}catch(t){W(a,a.return,t)}}if(d&4&&(e=a.stateNode,null!=e)){var f=a.memoizedProps,g=null!==c?c.memoizedProps:f,h=a.type,k=a.updateQueue;
	a.updateQueue=null;if(null!==k)try{"input"===h&&"radio"===f.type&&null!=f.name&&ab(e,f);vb(h,g);var l=vb(h,f);for(g=0;g<k.length;g+=2){var m=k[g],q=k[g+1];"style"===m?sb(e,q):"dangerouslySetInnerHTML"===m?nb(e,q):"children"===m?ob(e,q):ta(e,m,q,l)}switch(h){case "input":bb(e,f);break;case "textarea":ib(e,f);break;case "select":var r=e._wrapperState.wasMultiple;e._wrapperState.wasMultiple=!!f.multiple;var y=f.value;null!=y?fb(e,!!f.multiple,y,!1):r!==!!f.multiple&&(null!=f.defaultValue?fb(e,!!f.multiple,
	f.defaultValue,!0):fb(e,!!f.multiple,f.multiple?[]:"",!1))}e[Pf]=f}catch(t){W(a,a.return,t)}}break;case 6:ck(b,a);ek(a);if(d&4){if(null===a.stateNode)throw Error(p(162));e=a.stateNode;f=a.memoizedProps;try{e.nodeValue=f}catch(t){W(a,a.return,t)}}break;case 3:ck(b,a);ek(a);if(d&4&&null!==c&&c.memoizedState.isDehydrated)try{bd(b.containerInfo)}catch(t){W(a,a.return,t)}break;case 4:ck(b,a);ek(a);break;case 13:ck(b,a);ek(a);e=a.child;e.flags&8192&&(f=null!==e.memoizedState,e.stateNode.isHidden=f,!f||
	null!==e.alternate&&null!==e.alternate.memoizedState||(fk=B()));d&4&&ak(a);break;case 22:m=null!==c&&null!==c.memoizedState;a.mode&1?(U=(l=U)||m,ck(b,a),U=l):ck(b,a);ek(a);if(d&8192){l=null!==a.memoizedState;if((a.stateNode.isHidden=l)&&!m&&0!==(a.mode&1))for(V=a,m=a.child;null!==m;){for(q=V=m;null!==V;){r=V;y=r.child;switch(r.tag){case 0:case 11:case 14:case 15:Pj(4,r,r.return);break;case 1:Lj(r,r.return);var n=r.stateNode;if("function"===typeof n.componentWillUnmount){d=r;c=r.return;try{b=d,n.props=
	b.memoizedProps,n.state=b.memoizedState,n.componentWillUnmount()}catch(t){W(d,c,t)}}break;case 5:Lj(r,r.return);break;case 22:if(null!==r.memoizedState){gk(q);continue}}null!==y?(y.return=r,V=y):gk(q)}m=m.sibling}a:for(m=null,q=a;;){if(5===q.tag){if(null===m){m=q;try{e=q.stateNode,l?(f=e.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(h=q.stateNode,k=q.memoizedProps.style,g=void 0!==k&&null!==k&&k.hasOwnProperty("display")?k.display:null,h.style.display=
	rb("display",g))}catch(t){W(a,a.return,t)}}}else if(6===q.tag){if(null===m)try{q.stateNode.nodeValue=l?"":q.memoizedProps}catch(t){W(a,a.return,t)}}else if((22!==q.tag&&23!==q.tag||null===q.memoizedState||q===a)&&null!==q.child){q.child.return=q;q=q.child;continue}if(q===a)break a;for(;null===q.sibling;){if(null===q.return||q.return===a)break a;m===q&&(m=null);q=q.return}m===q&&(m=null);q.sibling.return=q.return;q=q.sibling}}break;case 19:ck(b,a);ek(a);d&4&&ak(a);break;case 21:break;default:ck(b,
	a),ek(a)}}function ek(a){var b=a.flags;if(b&2){try{a:{for(var c=a.return;null!==c;){if(Tj(c)){var d=c;break a}c=c.return}throw Error(p(160));}switch(d.tag){case 5:var e=d.stateNode;d.flags&32&&(ob(e,""),d.flags&=-33);var f=Uj(a);Wj(a,f,e);break;case 3:case 4:var g=d.stateNode.containerInfo,h=Uj(a);Vj(a,h,g);break;default:throw Error(p(161));}}catch(k){W(a,a.return,k)}a.flags&=-3}b&4096&&(a.flags&=-4097)}function hk(a,b,c){V=a;ik(a,b,c)}
	function ik(a,b,c){for(var d=0!==(a.mode&1);null!==V;){var e=V,f=e.child;if(22===e.tag&&d){var g=null!==e.memoizedState||Jj;if(!g){var h=e.alternate,k=null!==h&&null!==h.memoizedState||U;h=Jj;var l=U;Jj=g;if((U=k)&&!l)for(V=e;null!==V;)g=V,k=g.child,22===g.tag&&null!==g.memoizedState?jk(e):null!==k?(k.return=g,V=k):jk(e);for(;null!==f;)V=f,ik(f,b,c),f=f.sibling;V=e;Jj=h;U=l}kk(a,b,c)}else 0!==(e.subtreeFlags&8772)&&null!==f?(f.return=e,V=f):kk(a,b,c)}}
	function kk(a){for(;null!==V;){var b=V;if(0!==(b.flags&8772)){var c=b.alternate;try{if(0!==(b.flags&8772))switch(b.tag){case 0:case 11:case 15:U||Qj(5,b);break;case 1:var d=b.stateNode;if(b.flags&4&&!U)if(null===c)d.componentDidMount();else{var e=b.elementType===b.type?c.memoizedProps:Ci(b.type,c.memoizedProps);d.componentDidUpdate(e,c.memoizedState,d.__reactInternalSnapshotBeforeUpdate)}var f=b.updateQueue;null!==f&&sh(b,f,d);break;case 3:var g=b.updateQueue;if(null!==g){c=null;if(null!==b.child)switch(b.child.tag){case 5:c=
	b.child.stateNode;break;case 1:c=b.child.stateNode}sh(b,g,c)}break;case 5:var h=b.stateNode;if(null===c&&b.flags&4){c=h;var k=b.memoizedProps;switch(b.type){case "button":case "input":case "select":case "textarea":k.autoFocus&&c.focus();break;case "img":k.src&&(c.src=k.src)}}break;case 6:break;case 4:break;case 12:break;case 13:if(null===b.memoizedState){var l=b.alternate;if(null!==l){var m=l.memoizedState;if(null!==m){var q=m.dehydrated;null!==q&&bd(q)}}}break;case 19:case 17:case 21:case 22:case 23:case 25:break;
	default:throw Error(p(163));}U||b.flags&512&&Rj(b)}catch(r){W(b,b.return,r)}}if(b===a){V=null;break}c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return}}function gk(a){for(;null!==V;){var b=V;if(b===a){V=null;break}var c=b.sibling;if(null!==c){c.return=b.return;V=c;break}V=b.return}}
	function jk(a){for(;null!==V;){var b=V;try{switch(b.tag){case 0:case 11:case 15:var c=b.return;try{Qj(4,b)}catch(k){W(b,c,k)}break;case 1:var d=b.stateNode;if("function"===typeof d.componentDidMount){var e=b.return;try{d.componentDidMount()}catch(k){W(b,e,k)}}var f=b.return;try{Rj(b)}catch(k){W(b,f,k)}break;case 5:var g=b.return;try{Rj(b)}catch(k){W(b,g,k)}}}catch(k){W(b,b.return,k)}if(b===a){V=null;break}var h=b.sibling;if(null!==h){h.return=b.return;V=h;break}V=b.return}}
	var lk=Math.ceil,mk=ua.ReactCurrentDispatcher,nk=ua.ReactCurrentOwner,ok=ua.ReactCurrentBatchConfig,K=0,Q=null,Y=null,Z=0,fj=0,ej=Uf(0),T=0,pk=null,rh=0,qk=0,rk=0,sk=null,tk=null,fk=0,Gj=Infinity,uk=null,Oi=!1,Pi=null,Ri=null,vk=!1,wk=null,xk=0,yk=0,zk=null,Ak=-1,Bk=0;function R(){return 0!==(K&6)?B():-1!==Ak?Ak:Ak=B()}
	function yi(a){if(0===(a.mode&1))return 1;if(0!==(K&2)&&0!==Z)return Z&-Z;if(null!==Kg.transition)return 0===Bk&&(Bk=yc()),Bk;a=C;if(0!==a)return a;a=window.event;a=void 0===a?16:jd(a.type);return a}function gi(a,b,c,d){if(50<yk)throw yk=0,zk=null,Error(p(185));Ac(a,c,d);if(0===(K&2)||a!==Q)a===Q&&(0===(K&2)&&(qk|=c),4===T&&Ck(a,Z)),Dk(a,d),1===c&&0===K&&0===(b.mode&1)&&(Gj=B()+500,fg&&jg())}
	function Dk(a,b){var c=a.callbackNode;wc(a,b);var d=uc(a,a===Q?Z:0);if(0===d)null!==c&&bc(c),a.callbackNode=null,a.callbackPriority=0;else if(b=d&-d,a.callbackPriority!==b){null!=c&&bc(c);if(1===b)0===a.tag?ig(Ek.bind(null,a)):hg(Ek.bind(null,a)),Jf(function(){0===(K&6)&&jg()}),c=null;else{switch(Dc(d)){case 1:c=fc;break;case 4:c=gc;break;case 16:c=hc;break;case 536870912:c=jc;break;default:c=hc}c=Fk(c,Gk.bind(null,a))}a.callbackPriority=b;a.callbackNode=c}}
	function Gk(a,b){Ak=-1;Bk=0;if(0!==(K&6))throw Error(p(327));var c=a.callbackNode;if(Hk()&&a.callbackNode!==c)return null;var d=uc(a,a===Q?Z:0);if(0===d)return null;if(0!==(d&30)||0!==(d&a.expiredLanes)||b)b=Ik(a,d);else{b=d;var e=K;K|=2;var f=Jk();if(Q!==a||Z!==b)uk=null,Gj=B()+500,Kk(a,b);do try{Lk();break}catch(h){Mk(a,h)}while(1);$g();mk.current=f;K=e;null!==Y?b=0:(Q=null,Z=0,b=T)}if(0!==b){2===b&&(e=xc(a),0!==e&&(d=e,b=Nk(a,e)));if(1===b)throw c=pk,Kk(a,0),Ck(a,d),Dk(a,B()),c;if(6===b)Ck(a,d);
	else{e=a.current.alternate;if(0===(d&30)&&!Ok(e)&&(b=Ik(a,d),2===b&&(f=xc(a),0!==f&&(d=f,b=Nk(a,f))),1===b))throw c=pk,Kk(a,0),Ck(a,d),Dk(a,B()),c;a.finishedWork=e;a.finishedLanes=d;switch(b){case 0:case 1:throw Error(p(345));case 2:Pk(a,tk,uk);break;case 3:Ck(a,d);if((d&130023424)===d&&(b=fk+500-B(),10<b)){if(0!==uc(a,0))break;e=a.suspendedLanes;if((e&d)!==d){R();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=Ff(Pk.bind(null,a,tk,uk),b);break}Pk(a,tk,uk);break;case 4:Ck(a,d);if((d&4194240)===
	d)break;b=a.eventTimes;for(e=-1;0<d;){var g=31-oc(d);f=1<<g;g=b[g];g>e&&(e=g);d&=~f}d=e;d=B()-d;d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*lk(d/1960))-d;if(10<d){a.timeoutHandle=Ff(Pk.bind(null,a,tk,uk),d);break}Pk(a,tk,uk);break;case 5:Pk(a,tk,uk);break;default:throw Error(p(329));}}}Dk(a,B());return a.callbackNode===c?Gk.bind(null,a):null}
	function Nk(a,b){var c=sk;a.current.memoizedState.isDehydrated&&(Kk(a,b).flags|=256);a=Ik(a,b);2!==a&&(b=tk,tk=c,null!==b&&Fj(b));return a}function Fj(a){null===tk?tk=a:tk.push.apply(tk,a)}
	function Ok(a){for(var b=a;;){if(b.flags&16384){var c=b.updateQueue;if(null!==c&&(c=c.stores,null!==c))for(var d=0;d<c.length;d++){var e=c[d],f=e.getSnapshot;e=e.value;try{if(!He(f(),e))return!1}catch(g){return!1}}}c=b.child;if(b.subtreeFlags&16384&&null!==c)c.return=b,b=c;else{if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return!0;b=b.return}b.sibling.return=b.return;b=b.sibling}}return!0}
	function Ck(a,b){b&=~rk;b&=~qk;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-oc(b),d=1<<c;a[c]=-1;b&=~d}}function Ek(a){if(0!==(K&6))throw Error(p(327));Hk();var b=uc(a,0);if(0===(b&1))return Dk(a,B()),null;var c=Ik(a,b);if(0!==a.tag&&2===c){var d=xc(a);0!==d&&(b=d,c=Nk(a,d))}if(1===c)throw c=pk,Kk(a,0),Ck(a,b),Dk(a,B()),c;if(6===c)throw Error(p(345));a.finishedWork=a.current.alternate;a.finishedLanes=b;Pk(a,tk,uk);Dk(a,B());return null}
	function Qk(a,b){var c=K;K|=1;try{return a(b)}finally{K=c,0===K&&(Gj=B()+500,fg&&jg())}}function Rk(a){null!==wk&&0===wk.tag&&0===(K&6)&&Hk();var b=K;K|=1;var c=ok.transition,d=C;try{if(ok.transition=null,C=1,a)return a()}finally{C=d,ok.transition=c,K=b,0===(K&6)&&jg()}}function Hj(){fj=ej.current;E(ej)}
	function Kk(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Gf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;wg(d);switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&$f();break;case 3:zh();E(Wf);E(H);Eh();break;case 5:Bh(d);break;case 4:zh();break;case 13:E(L);break;case 19:E(L);break;case 10:ah(d.type._context);break;case 22:case 23:Hj()}c=c.return}Q=a;Y=a=Pg(a.current,null);Z=fj=b;T=0;pk=null;rk=qk=rh=0;tk=sk=null;if(null!==fh){for(b=
	0;b<fh.length;b++)if(c=fh[b],d=c.interleaved,null!==d){c.interleaved=null;var e=d.next,f=c.pending;if(null!==f){var g=f.next;f.next=e;d.next=g}c.pending=d}fh=null}return a}
	function Mk(a,b){do{var c=Y;try{$g();Fh.current=Rh;if(Ih){for(var d=M.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}Ih=!1}Hh=0;O=N=M=null;Jh=!1;Kh=0;nk.current=null;if(null===c||null===c.return){T=1;pk=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=Z;h.flags|=32768;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k,m=h,q=m.tag;if(0===(m.mode&1)&&(0===q||11===q||15===q)){var r=m.alternate;r?(m.updateQueue=r.updateQueue,m.memoizedState=r.memoizedState,
	m.lanes=r.lanes):(m.updateQueue=null,m.memoizedState=null)}var y=Ui(g);if(null!==y){y.flags&=-257;Vi(y,g,h,f,b);y.mode&1&&Si(f,l,b);b=y;k=l;var n=b.updateQueue;if(null===n){var t=new Set;t.add(k);b.updateQueue=t}else n.add(k);break a}else{if(0===(b&1)){Si(f,l,b);tj();break a}k=Error(p(426))}}else if(I&&h.mode&1){var J=Ui(g);if(null!==J){0===(J.flags&65536)&&(J.flags|=256);Vi(J,g,h,f,b);Jg(Ji(k,h));break a}}f=k=Ji(k,h);4!==T&&(T=2);null===sk?sk=[f]:sk.push(f);f=g;do{switch(f.tag){case 3:f.flags|=65536;
	b&=-b;f.lanes|=b;var x=Ni(f,k,b);ph(f,x);break a;case 1:h=k;var w=f.type,u=f.stateNode;if(0===(f.flags&128)&&("function"===typeof w.getDerivedStateFromError||null!==u&&"function"===typeof u.componentDidCatch&&(null===Ri||!Ri.has(u)))){f.flags|=65536;b&=-b;f.lanes|=b;var F=Qi(f,h,b);ph(f,F);break a}}f=f.return}while(null!==f)}Sk(c)}catch(na){b=na;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}function Jk(){var a=mk.current;mk.current=Rh;return null===a?Rh:a}
	function tj(){if(0===T||3===T||2===T)T=4;null===Q||0===(rh&268435455)&&0===(qk&268435455)||Ck(Q,Z)}function Ik(a,b){var c=K;K|=2;var d=Jk();if(Q!==a||Z!==b)uk=null,Kk(a,b);do try{Tk();break}catch(e){Mk(a,e)}while(1);$g();K=c;mk.current=d;if(null!==Y)throw Error(p(261));Q=null;Z=0;return T}function Tk(){for(;null!==Y;)Uk(Y)}function Lk(){for(;null!==Y&&!cc();)Uk(Y)}function Uk(a){var b=Vk(a.alternate,a,fj);a.memoizedProps=a.pendingProps;null===b?Sk(a):Y=b;nk.current=null}
	function Sk(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&32768)){if(c=Ej(c,b,fj),null!==c){Y=c;return}}else{c=Ij(c,b);if(null!==c){c.flags&=32767;Y=c;return}if(null!==a)a.flags|=32768,a.subtreeFlags=0,a.deletions=null;else{T=6;Y=null;return}}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===T&&(T=5)}function Pk(a,b,c){var d=C,e=ok.transition;try{ok.transition=null,C=1,Wk(a,b,c,d)}finally{ok.transition=e,C=d}return null}
	function Wk(a,b,c,d){do Hk();while(null!==wk);if(0!==(K&6))throw Error(p(327));c=a.finishedWork;var e=a.finishedLanes;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(p(177));a.callbackNode=null;a.callbackPriority=0;var f=c.lanes|c.childLanes;Bc(a,f);a===Q&&(Y=Q=null,Z=0);0===(c.subtreeFlags&2064)&&0===(c.flags&2064)||vk||(vk=!0,Fk(hc,function(){Hk();return null}));f=0!==(c.flags&15990);if(0!==(c.subtreeFlags&15990)||f){f=ok.transition;ok.transition=null;
	var g=C;C=1;var h=K;K|=4;nk.current=null;Oj(a,c);dk(c,a);Oe(Df);dd=!!Cf;Df=Cf=null;a.current=c;hk(c,a,e);dc();K=h;C=g;ok.transition=f}else a.current=c;vk&&(vk=!1,wk=a,xk=e);f=a.pendingLanes;0===f&&(Ri=null);mc(c.stateNode,d);Dk(a,B());if(null!==b)for(d=a.onRecoverableError,c=0;c<b.length;c++)e=b[c],d(e.value,{componentStack:e.stack,digest:e.digest});if(Oi)throw Oi=!1,a=Pi,Pi=null,a;0!==(xk&1)&&0!==a.tag&&Hk();f=a.pendingLanes;0!==(f&1)?a===zk?yk++:(yk=0,zk=a):yk=0;jg();return null}
	function Hk(){if(null!==wk){var a=Dc(xk),b=ok.transition,c=C;try{ok.transition=null;C=16>a?16:a;if(null===wk)var d=!1;else{a=wk;wk=null;xk=0;if(0!==(K&6))throw Error(p(331));var e=K;K|=4;for(V=a.current;null!==V;){var f=V,g=f.child;if(0!==(V.flags&16)){var h=f.deletions;if(null!==h){for(var k=0;k<h.length;k++){var l=h[k];for(V=l;null!==V;){var m=V;switch(m.tag){case 0:case 11:case 15:Pj(8,m,f)}var q=m.child;if(null!==q)q.return=m,V=q;else for(;null!==V;){m=V;var r=m.sibling,y=m.return;Sj(m);if(m===
	l){V=null;break}if(null!==r){r.return=y;V=r;break}V=y}}}var n=f.alternate;if(null!==n){var t=n.child;if(null!==t){n.child=null;do{var J=t.sibling;t.sibling=null;t=J}while(null!==t)}}V=f}}if(0!==(f.subtreeFlags&2064)&&null!==g)g.return=f,V=g;else b:for(;null!==V;){f=V;if(0!==(f.flags&2048))switch(f.tag){case 0:case 11:case 15:Pj(9,f,f.return)}var x=f.sibling;if(null!==x){x.return=f.return;V=x;break b}V=f.return}}var w=a.current;for(V=w;null!==V;){g=V;var u=g.child;if(0!==(g.subtreeFlags&2064)&&null!==
	u)u.return=g,V=u;else b:for(g=w;null!==V;){h=V;if(0!==(h.flags&2048))try{switch(h.tag){case 0:case 11:case 15:Qj(9,h)}}catch(na){W(h,h.return,na)}if(h===g){V=null;break b}var F=h.sibling;if(null!==F){F.return=h.return;V=F;break b}V=h.return}}K=e;jg();if(lc&&"function"===typeof lc.onPostCommitFiberRoot)try{lc.onPostCommitFiberRoot(kc,a)}catch(na){}d=!0}return d}finally{C=c,ok.transition=b}}return!1}function Xk(a,b,c){b=Ji(c,b);b=Ni(a,b,1);a=nh(a,b,1);b=R();null!==a&&(Ac(a,1,b),Dk(a,b))}
	function W(a,b,c){if(3===a.tag)Xk(a,a,c);else for(;null!==b;){if(3===b.tag){Xk(b,a,c);break}else if(1===b.tag){var d=b.stateNode;if("function"===typeof b.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ri||!Ri.has(d))){a=Ji(c,a);a=Qi(b,a,1);b=nh(b,a,1);a=R();null!==b&&(Ac(b,1,a),Dk(b,a));break}}b=b.return}}
	function Ti(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=R();a.pingedLanes|=a.suspendedLanes&c;Q===a&&(Z&c)===c&&(4===T||3===T&&(Z&130023424)===Z&&500>B()-fk?Kk(a,0):rk|=c);Dk(a,b)}function Yk(a,b){0===b&&(0===(a.mode&1)?b=1:(b=sc,sc<<=1,0===(sc&130023424)&&(sc=4194304)));var c=R();a=ih(a,b);null!==a&&(Ac(a,b,c),Dk(a,c))}function uj(a){var b=a.memoizedState,c=0;null!==b&&(c=b.retryLane);Yk(a,c)}
	function bk(a,b){var c=0;switch(a.tag){case 13:var d=a.stateNode;var e=a.memoizedState;null!==e&&(c=e.retryLane);break;case 19:d=a.stateNode;break;default:throw Error(p(314));}null!==d&&d.delete(b);Yk(a,c)}var Vk;
	Vk=function(a,b,c){if(null!==a)if(a.memoizedProps!==b.pendingProps||Wf.current)dh=!0;else{if(0===(a.lanes&c)&&0===(b.flags&128))return dh=!1,yj(a,b,c);dh=0!==(a.flags&131072)?!0:!1}else dh=!1,I&&0!==(b.flags&1048576)&&ug(b,ng,b.index);b.lanes=0;switch(b.tag){case 2:var d=b.type;ij(a,b);a=b.pendingProps;var e=Yf(b,H.current);ch(b,c);e=Nh(null,b,d,a,e,c);var f=Sh();b.flags|=1;"object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof?(b.tag=1,b.memoizedState=null,b.updateQueue=
	null,Zf(d)?(f=!0,cg(b)):f=!1,b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null,kh(b),e.updater=Ei,b.stateNode=e,e._reactInternals=b,Ii(b,d,a,c),b=jj(null,b,d,!0,f,c)):(b.tag=0,I&&f&&vg(b),Xi(null,b,e,c),b=b.child);return b;case 16:d=b.elementType;a:{ij(a,b);a=b.pendingProps;e=d._init;d=e(d._payload);b.type=d;e=b.tag=Zk(d);a=Ci(d,a);switch(e){case 0:b=cj(null,b,d,a,c);break a;case 1:b=hj(null,b,d,a,c);break a;case 11:b=Yi(null,b,d,a,c);break a;case 14:b=$i(null,b,d,Ci(d.type,a),c);break a}throw Error(p(306,
	d,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),cj(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),hj(a,b,d,e,c);case 3:a:{kj(b);if(null===a)throw Error(p(387));d=b.pendingProps;f=b.memoizedState;e=f.element;lh(a,b);qh(b,d,null,c);var g=b.memoizedState;d=g.element;if(f.isDehydrated)if(f={element:d,isDehydrated:!1,cache:g.cache,pendingSuspenseBoundaries:g.pendingSuspenseBoundaries,transitions:g.transitions},b.updateQueue.baseState=
	f,b.memoizedState=f,b.flags&256){e=Ji(Error(p(423)),b);b=lj(a,b,d,c,e);break a}else if(d!==e){e=Ji(Error(p(424)),b);b=lj(a,b,d,c,e);break a}else for(yg=Lf(b.stateNode.containerInfo.firstChild),xg=b,I=!0,zg=null,c=Vg(b,null,d,c),b.child=c;c;)c.flags=c.flags&-3|4096,c=c.sibling;else{Ig();if(d===e){b=Zi(a,b,c);break a}Xi(a,b,d,c)}b=b.child}return b;case 5:return Ah(b),null===a&&Eg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ef(d,e)?g=null:null!==f&&Ef(d,f)&&(b.flags|=32),
	gj(a,b),Xi(a,b,g,c),b.child;case 6:return null===a&&Eg(b),null;case 13:return oj(a,b,c);case 4:return yh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Ug(b,null,d,c):Xi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),Yi(a,b,d,e,c);case 7:return Xi(a,b,b.pendingProps,c),b.child;case 8:return Xi(a,b,b.pendingProps.children,c),b.child;case 12:return Xi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;f=b.memoizedProps;
	g=e.value;G(Wg,d._currentValue);d._currentValue=g;if(null!==f)if(He(f.value,g)){if(f.children===e.children&&!Wf.current){b=Zi(a,b,c);break a}}else for(f=b.child,null!==f&&(f.return=b);null!==f;){var h=f.dependencies;if(null!==h){g=f.child;for(var k=h.firstContext;null!==k;){if(k.context===d){if(1===f.tag){k=mh(-1,c&-c);k.tag=2;var l=f.updateQueue;if(null!==l){l=l.shared;var m=l.pending;null===m?k.next=k:(k.next=m.next,m.next=k);l.pending=k}}f.lanes|=c;k=f.alternate;null!==k&&(k.lanes|=c);bh(f.return,
	c,b);h.lanes|=c;break}k=k.next}}else if(10===f.tag)g=f.type===b.type?null:f.child;else if(18===f.tag){g=f.return;if(null===g)throw Error(p(341));g.lanes|=c;h=g.alternate;null!==h&&(h.lanes|=c);bh(g,c,b);g=f.sibling}else g=f.child;if(null!==g)g.return=f;else for(g=f;null!==g;){if(g===b){g=null;break}f=g.sibling;if(null!==f){f.return=g.return;g=f;break}g=g.return}f=g}Xi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,d=b.pendingProps.children,ch(b,c),e=eh(e),d=d(e),b.flags|=1,Xi(a,b,d,c),
	b.child;case 14:return d=b.type,e=Ci(d,b.pendingProps),e=Ci(d.type,e),$i(a,b,d,e,c);case 15:return bj(a,b,b.type,b.pendingProps,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Ci(d,e),ij(a,b),b.tag=1,Zf(d)?(a=!0,cg(b)):a=!1,ch(b,c),Gi(b,d,e),Ii(b,d,e,c),jj(null,b,d,!0,a,c);case 19:return xj(a,b,c);case 22:return dj(a,b,c)}throw Error(p(156,b.tag));};function Fk(a,b){return ac(a,b)}
	function $k(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.subtreeFlags=this.flags=0;this.deletions=null;this.childLanes=this.lanes=0;this.alternate=null}function Bg(a,b,c,d){return new $k(a,b,c,d)}function aj(a){a=a.prototype;return!(!a||!a.isReactComponent)}
	function Zk(a){if("function"===typeof a)return aj(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Da)return 11;if(a===Ga)return 14}return 2}
	function Pg(a,b){var c=a.alternate;null===c?(c=Bg(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.subtreeFlags=0,c.deletions=null);c.flags=a.flags&14680064;c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
	c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function Rg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)aj(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ya:return Tg(c.children,e,f,b);case za:g=8;e|=8;break;case Aa:return a=Bg(12,c,b,e|2),a.elementType=Aa,a.lanes=f,a;case Ea:return a=Bg(13,c,b,e),a.elementType=Ea,a.lanes=f,a;case Fa:return a=Bg(19,c,b,e),a.elementType=Fa,a.lanes=f,a;case Ia:return pj(c,e,f,b);default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case Ba:g=10;break a;case Ca:g=9;break a;case Da:g=11;
	break a;case Ga:g=14;break a;case Ha:g=16;d=null;break a}throw Error(p(130,null==a?a:typeof a,""));}b=Bg(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Tg(a,b,c,d){a=Bg(7,a,d,b);a.lanes=c;return a}function pj(a,b,c,d){a=Bg(22,a,d,b);a.elementType=Ia;a.lanes=c;a.stateNode={isHidden:!1};return a}function Qg(a,b,c){a=Bg(6,a,null,b);a.lanes=c;return a}
	function Sg(a,b,c){b=Bg(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function al(a,b,c,d,e){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.callbackNode=this.pendingContext=this.context=null;this.callbackPriority=0;this.eventTimes=zc(0);this.expirationTimes=zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=zc(0);this.identifierPrefix=d;this.onRecoverableError=e;this.mutableSourceEagerHydrationData=
	null}function bl(a,b,c,d,e,f,g,h,k){a=new al(a,b,c,h,k);1===b?(b=1,!0===f&&(b|=8)):b=0;f=Bg(3,null,null,b);a.current=f;f.stateNode=a;f.memoizedState={element:d,isDehydrated:c,cache:null,transitions:null,pendingSuspenseBoundaries:null};kh(f);return a}function cl(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:wa,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	function dl(a){if(!a)return Vf;a=a._reactInternals;a:{if(Vb(a)!==a||1!==a.tag)throw Error(p(170));var b=a;do{switch(b.tag){case 3:b=b.stateNode.context;break a;case 1:if(Zf(b.type)){b=b.stateNode.__reactInternalMemoizedMergedChildContext;break a}}b=b.return}while(null!==b);throw Error(p(171));}if(1===a.tag){var c=a.type;if(Zf(c))return bg(a,c,b)}return b}
	function el(a,b,c,d,e,f,g,h,k){a=bl(c,d,!0,a,e,f,g,h,k);a.context=dl(null);c=a.current;d=R();e=yi(c);f=mh(d,e);f.callback=void 0!==b&&null!==b?b:null;nh(c,f,e);a.current.lanes=e;Ac(a,e,d);Dk(a,d);return a}function fl(a,b,c,d){var e=b.current,f=R(),g=yi(e);c=dl(c);null===b.context?b.context=c:b.pendingContext=c;b=mh(f,g);b.payload={element:a};d=void 0===d?null:d;null!==d&&(b.callback=d);a=nh(e,b,g);null!==a&&(gi(a,e,g,f),oh(a,e,g));return g}
	function gl(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function hl(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function il(a,b){hl(a,b);(a=a.alternate)&&hl(a,b)}function jl(){return null}var kl="function"===typeof reportError?reportError:function(a){console.error(a)};function ll(a){this._internalRoot=a}
	ml.prototype.render=ll.prototype.render=function(a){var b=this._internalRoot;if(null===b)throw Error(p(409));fl(a,b,null,null)};ml.prototype.unmount=ll.prototype.unmount=function(){var a=this._internalRoot;if(null!==a){this._internalRoot=null;var b=a.containerInfo;Rk(function(){fl(null,a,null,null)});b[uf]=null}};function ml(a){this._internalRoot=a}
	ml.prototype.unstable_scheduleHydration=function(a){if(a){var b=Hc();a={blockedOn:null,target:a,priority:b};for(var c=0;c<Qc.length&&0!==b&&b<Qc[c].priority;c++);Qc.splice(c,0,a);0===c&&Vc(a)}};function nl(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType)}function ol(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function pl(){}
	function ql(a,b,c,d,e){if(e){if("function"===typeof d){var f=d;d=function(){var a=gl(g);f.call(a)}}var g=el(b,d,a,0,null,!1,!1,"",pl);a._reactRootContainer=g;a[uf]=g.current;sf(8===a.nodeType?a.parentNode:a);Rk();return g}for(;e=a.lastChild;)a.removeChild(e);if("function"===typeof d){var h=d;d=function(){var a=gl(k);h.call(a)}}var k=bl(a,0,!1,null,null,!1,!1,"",pl);a._reactRootContainer=k;a[uf]=k.current;sf(8===a.nodeType?a.parentNode:a);Rk(function(){fl(b,k,c,d)});return k}
	function rl(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f;if("function"===typeof e){var h=e;e=function(){var a=gl(g);h.call(a)}}fl(b,g,a,e)}else g=ql(c,b,a,e,d);return gl(g)}Ec=function(a){switch(a.tag){case 3:var b=a.stateNode;if(b.current.memoizedState.isDehydrated){var c=tc(b.pendingLanes);0!==c&&(Cc(b,c|1),Dk(b,B()),0===(K&6)&&(Gj=B()+500,jg()))}break;case 13:Rk(function(){var b=ih(a,1);if(null!==b){var c=R();gi(b,a,1,c)}}),il(a,1)}};
	Fc=function(a){if(13===a.tag){var b=ih(a,134217728);if(null!==b){var c=R();gi(b,a,134217728,c)}il(a,134217728)}};Gc=function(a){if(13===a.tag){var b=yi(a),c=ih(a,b);if(null!==c){var d=R();gi(c,a,b,d)}il(a,b)}};Hc=function(){return C};Ic=function(a,b){var c=C;try{return C=a,b()}finally{C=c}};
	yb=function(a,b,c){switch(b){case "input":bb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(p(90));Wa(d);bb(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Qk;Hb=Rk;
	var sl={usingClientEntryPoint:!1,Events:[Cb,ue,Db,Eb,Fb,Qk]},tl={findFiberByHostInstance:Wc,bundleType:0,version:"18.3.1",rendererPackageName:"react-dom"};
	var ul={bundleType:tl.bundleType,version:tl.version,rendererPackageName:tl.rendererPackageName,rendererConfig:tl.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ua.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=Zb(a);return null===a?null:a.stateNode},findFiberByHostInstance:tl.findFiberByHostInstance||
	jl,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.3.1-next-f1338f8080-20240426"};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var vl=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!vl.isDisabled&&vl.supportsFiber)try{kc=vl.inject(ul),lc=vl}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=sl;
	exports.createPortal=function(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!nl(b))throw Error(p(200));return cl(a,b,null,c)};exports.createRoot=function(a,b){if(!nl(a))throw Error(p(299));var c=!1,d="",e=kl;null!==b&&void 0!==b&&(!0===b.unstable_strictMode&&(c=!0),void 0!==b.identifierPrefix&&(d=b.identifierPrefix),void 0!==b.onRecoverableError&&(e=b.onRecoverableError));b=bl(a,1,!1,null,null,c,!1,d,e);a[uf]=b.current;sf(8===a.nodeType?a.parentNode:a);return new ll(b)};
	exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(p(188));a=Object.keys(a).join(",");throw Error(p(268,a));}a=Zb(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a){return Rk(a)};exports.hydrate=function(a,b,c){if(!ol(b))throw Error(p(200));return rl(null,a,b,!0,c)};
	exports.hydrateRoot=function(a,b,c){if(!nl(a))throw Error(p(405));var d=null!=c&&c.hydratedSources||null,e=!1,f="",g=kl;null!==c&&void 0!==c&&(!0===c.unstable_strictMode&&(e=!0),void 0!==c.identifierPrefix&&(f=c.identifierPrefix),void 0!==c.onRecoverableError&&(g=c.onRecoverableError));b=el(b,null,a,1,null!=c?c:null,e,!1,f,g);a[uf]=b.current;sf(a);if(d)for(a=0;a<d.length;a++)c=d[a],e=c._getVersion,e=e(c._source),null==b.mutableSourceEagerHydrationData?b.mutableSourceEagerHydrationData=[c,e]:b.mutableSourceEagerHydrationData.push(c,
	e);return new ml(b)};exports.render=function(a,b,c){if(!ol(b))throw Error(p(200));return rl(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!ol(a))throw Error(p(40));return a._reactRootContainer?(Rk(function(){rl(null,null,a,!1,function(){a._reactRootContainer=null;a[uf]=null})}),!0):!1};exports.unstable_batchedUpdates=Qk;
	exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!ol(c))throw Error(p(200));if(null==a||void 0===a._reactInternals)throw Error(p(38));return rl(a,b,c,!1,d)};exports.version="18.3.1-next-f1338f8080-20240426";


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.ReactPixel=t():e.ReactPixel=t()}(this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.i=function(e){return e},t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=1)}([function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}Object.defineProperty(t,"__esModule",{value:!0});var o=!1,i=!1,a=function(){return o||console.warn("Pixel not initialized before using call ReactPixel.init with required params"),o},c=function(){for(var e,t=arguments.length,n=Array(t),o=0;o<t;o++)n[o]=arguments[o];(e=console).info.apply(e,r(["[react-facebook-pixel]"].concat(n)))},f={autoConfig:!0,debug:!1};t.default={init:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:f;!function(e,t,n,r,o,i,a){e.fbq||(o=e.fbq=function(){o.callMethod?o.callMethod.apply(o,arguments):o.queue.push(arguments)},e._fbq||(e._fbq=o),o.push=o,o.loaded=!0,o.version="2.0",o.queue=[],i=t.createElement(n),i.async=!0,i.src=r,a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(i,a))}(window,document,"script","https://connect.facebook.net/en_US/fbevents.js"),e?(!1===n.autoConfig&&fbq("set","autoConfig",!1,e),fbq("init",e,t),o=!0,i=n.debug):console.warn("Please insert pixel id for initializing")},pageView:function(){a()&&(fbq("track","PageView"),i&&c("called fbq('track', 'PageView');"))},track:function(e,t){a()&&(fbq("track",e,t),i&&(c("called fbq('track', '"+e+"');"),t&&c("with data",t)))},trackCustom:function(e,t){a()&&(fbq("trackCustom",e,t),i&&(c("called fbq('trackCustom', '"+e+"');"),t&&c("with data",t)))},fbq:function(e){function t(){return e.apply(this,arguments)}return t.toString=function(){return e.toString()},t}(function(){if(a()){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];fbq.apply(void 0,t),i&&(c("called fbq('"+t.slice(0,2).join("', '")+"')"),t[2]&&c("with data",t[2]))}})}},function(e,t,n){e.exports=n(0)}])});
	//# sourceMappingURL=fb-pixel.js.map

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1), __webpack_require__(11));
		else if(typeof define === 'function' && define.amd)
			define(["react", "prop-types"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root["react"], root["prop-types"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__13__, __WEBPACK_EXTERNAL_MODULE__14__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// define __esModule on exports
	/******/ 	__webpack_require__.r = function(exports) {
	/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
	/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
	/******/ 		}
	/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
	/******/ 	};
	/******/
	/******/ 	// create a fake namespace object
	/******/ 	// mode & 1: value is a module id, require it
	/******/ 	// mode & 2: merge all properties of value into the ns
	/******/ 	// mode & 4: return value when already ns object
	/******/ 	// mode & 8|1: behave like require
	/******/ 	__webpack_require__.t = function(value, mode) {
	/******/ 		if(mode & 1) value = __webpack_require__(value);
	/******/ 		if(mode & 8) return value;
	/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
	/******/ 		var ns = Object.create(null);
	/******/ 		__webpack_require__.r(ns);
	/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
	/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
	/******/ 		return ns;
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 11);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = warn;
	
	function warn(s) {
	  console.warn('[react-ga]', s);
	}
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = trim;
	
	// GA strings need to have leading/trailing whitespace trimmed, and not all
	// browsers have String.prototoype.trim().
	function trim(s) {
	  return s && s.toString().replace(/^\s+|\s+$/g, '');
	}
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addTrackers = addTrackers;
	exports.initialize = initialize;
	exports.ga = ga;
	exports.set = set;
	exports.send = send;
	exports.pageview = pageview;
	exports.modalview = modalview;
	exports.timing = timing;
	exports.event = event;
	exports.exception = exception;
	exports.outboundLink = outboundLink;
	exports["default"] = exports.testModeAPI = exports.plugin = void 0;
	
	var _format2 = _interopRequireDefault(__webpack_require__(3));
	
	var _removeLeadingSlash = _interopRequireDefault(__webpack_require__(7));
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	var _loadGA = _interopRequireDefault(__webpack_require__(8));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _log = _interopRequireDefault(__webpack_require__(9));
	
	var _testModeAPI = _interopRequireDefault(__webpack_require__(10));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';
	
	var _debug = false;
	var _titleCase = true;
	var _testMode = false;
	var _alwaysSendToDefaultTracker = true;
	var _redactEmail = true;
	
	var internalGa = function internalGa() {
	  var _window;
	
	  if (_testMode) return _testModeAPI["default"].ga.apply(_testModeAPI["default"], arguments);
	  if (_isNotBrowser) return false;
	  if (!window.ga) return (0, _warn["default"])('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
	  return (_window = window).ga.apply(_window, arguments);
	};
	
	function _format(s) {
	  return (0, _format2["default"])(s, _titleCase, _redactEmail);
	}
	
	function _gaCommand(trackerNames) {
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var command = args[0];
	
	  if (typeof internalGa === 'function') {
	    if (typeof command !== 'string') {
	      (0, _warn["default"])('ga command must be a string');
	      return;
	    }
	
	    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);
	
	    if (Array.isArray(trackerNames)) {
	      trackerNames.forEach(function (name) {
	        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
	      });
	    }
	  }
	}
	
	function _initialize(gaTrackingID, options) {
	  if (!gaTrackingID) {
	    (0, _warn["default"])('gaTrackingID is required in initialize()');
	    return;
	  }
	
	  if (options) {
	    if (options.debug && options.debug === true) {
	      _debug = true;
	    }
	
	    if (options.titleCase === false) {
	      _titleCase = false;
	    }
	
	    if (options.redactEmail === false) {
	      _redactEmail = false;
	    }
	
	    if (options.useExistingGa) {
	      return;
	    }
	  }
	
	  if (options && options.gaOptions) {
	    internalGa('create', gaTrackingID, options.gaOptions);
	  } else {
	    internalGa('create', gaTrackingID, 'auto');
	  }
	}
	
	function addTrackers(configsOrTrackingId, options) {
	  if (Array.isArray(configsOrTrackingId)) {
	    configsOrTrackingId.forEach(function (config) {
	      if (_typeof(config) !== 'object') {
	        (0, _warn["default"])('All configs must be an object');
	        return;
	      }
	
	      _initialize(config.trackingId, config);
	    });
	  } else {
	    _initialize(configsOrTrackingId, options);
	  }
	
	  return true;
	}
	
	function initialize(configsOrTrackingId, options) {
	  if (options && options.testMode === true) {
	    _testMode = true;
	  } else {
	    if (_isNotBrowser) {
	      return;
	    }
	
	    if (!options || options.standardImplementation !== true) (0, _loadGA["default"])(options);
	  }
	
	  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;
	  addTrackers(configsOrTrackingId, options);
	}
	/**
	 * ga:
	 * Returns the original GA object.
	 */
	
	
	function ga() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (args.length > 0) {
	    internalGa.apply(void 0, args);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('arguments');");
	      (0, _log["default"])("with arguments: ".concat(JSON.stringify(args)));
	    }
	  }
	
	  return window.ga;
	}
	/**
	 * set:
	 * GA tracker set method
	 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function set(fieldsObject, trackerNames) {
	  if (!fieldsObject) {
	    (0, _warn["default"])('`fieldsObject` is required in .set()');
	    return;
	  }
	
	  if (_typeof(fieldsObject) !== 'object') {
	    (0, _warn["default"])('Expected `fieldsObject` arg to be an Object');
	    return;
	  }
	
	  if (Object.keys(fieldsObject).length === 0) {
	    (0, _warn["default"])('empty `fieldsObject` given to .set()');
	  }
	
	  _gaCommand(trackerNames, 'set', fieldsObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('set', fieldsObject);");
	    (0, _log["default"])("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
	  }
	}
	/**
	 * send:
	 * Clone of the low level `ga.send` method
	 * WARNING: No validations will be applied to this
	 * @param  {Object} fieldObject - field object for tracking different analytics
	 * @param  {Array} trackerNames - trackers to send the command to
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function send(fieldObject, trackerNames) {
	  _gaCommand(trackerNames, 'send', fieldObject);
	
	  if (_debug) {
	    (0, _log["default"])("called ga('send', fieldObject);");
	    (0, _log["default"])("with fieldObject: ".concat(JSON.stringify(fieldObject)));
	    (0, _log["default"])("with trackers: ".concat(JSON.stringify(trackerNames)));
	  }
	}
	/**
	 * pageview:
	 * Basic GA pageview tracking
	 * @param  {String} path - the current page page e.g. '/about'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 * @param {String} title - (optional) the page title e. g. 'My Website'
	 */
	
	
	function pageview(rawPath, trackerNames, title) {
	  if (!rawPath) {
	    (0, _warn["default"])('path is required in .pageview()');
	    return;
	  }
	
	  var path = (0, _trim["default"])(rawPath);
	
	  if (path === '') {
	    (0, _warn["default"])('path cannot be an empty string in .pageview()');
	    return;
	  }
	
	  var extraFields = {};
	
	  if (title) {
	    extraFields.title = title;
	  }
	
	  if (typeof ga === 'function') {
	    _gaCommand(trackerNames, 'send', _objectSpread({
	      hitType: 'pageview',
	      page: path
	    }, extraFields));
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      var extraLog = '';
	
	      if (title) {
	        extraLog = " and title: ".concat(title);
	      }
	
	      (0, _log["default"])("with path: ".concat(path).concat(extraLog));
	    }
	  }
	}
	/**
	 * modalview:
	 * a proxy to basic GA pageview tracking to consistently track
	 * modal views that are an equivalent UX to a traditional pageview
	 * @param  {String} modalName e.g. 'add-or-edit-club'
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function modalview(rawModalName, trackerNames) {
	  if (!rawModalName) {
	    (0, _warn["default"])('modalName is required in .modalview(modalName)');
	    return;
	  }
	
	  var modalName = (0, _removeLeadingSlash["default"])((0, _trim["default"])(rawModalName));
	
	  if (modalName === '') {
	    (0, _warn["default"])('modalName cannot be an empty string or a single / in .modalview()');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    var path = "/modal/".concat(modalName);
	
	    _gaCommand(trackerNames, 'send', 'pageview', path);
	
	    if (_debug) {
	      (0, _log["default"])("called ga('send', 'pageview', path);");
	      (0, _log["default"])("with path: ".concat(path));
	    }
	  }
	}
	/**
	 * timing:
	 * GA timing
	 * @param args.category {String} required
	 * @param args.variable {String} required
	 * @param args.value  {Int}  required
	 * @param args.label  {String} required
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function timing() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref.category,
	      variable = _ref.variable,
	      value = _ref.value,
	      label = _ref.label;
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    if (!category || !variable || typeof value !== 'number') {
	      (0, _warn["default"])('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'timing',
	      timingCategory: _format(category),
	      timingVar: _format(variable),
	      timingValue: value
	    };
	
	    if (label) {
	      fieldObject.timingLabel = _format(label);
	    }
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * event:
	 * GA event tracking
	 * @param args.category {String} required
	 * @param args.action {String} required
	 * @param args.label {String} optional
	 * @param args.value {Int} optional
	 * @param args.nonInteraction {boolean} optional
	 * @param args.transport {string} optional
	 * @param {{action: string, category: string}} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function event() {
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      category = _ref2.category,
	      action = _ref2.action,
	      label = _ref2.label,
	      value = _ref2.value,
	      nonInteraction = _ref2.nonInteraction,
	      transport = _ref2.transport,
	      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);
	
	  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!category || !action) {
	      (0, _warn["default"])('args.category AND args.action are required in event()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: _format(category),
	      eventAction: _format(action)
	    }; // Optional Fields
	
	    if (label) {
	      fieldObject.eventLabel = _format(label);
	    }
	
	    if (typeof value !== 'undefined') {
	      if (typeof value !== 'number') {
	        (0, _warn["default"])('Expected `args.value` arg to be a Number.');
	      } else {
	        fieldObject.eventValue = value;
	      }
	    }
	
	    if (typeof nonInteraction !== 'undefined') {
	      if (typeof nonInteraction !== 'boolean') {
	        (0, _warn["default"])('`args.nonInteraction` must be a boolean.');
	      } else {
	        fieldObject.nonInteraction = nonInteraction;
	      }
	    }
	
	    if (typeof transport !== 'undefined') {
	      if (typeof transport !== 'string') {
	        (0, _warn["default"])('`args.transport` must be a string.');
	      } else {
	        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
	          (0, _warn["default"])('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
	        }
	
	        fieldObject.transport = transport;
	      }
	    }
	
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'dimension'.length) === 'dimension';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    });
	    Object.keys(args).filter(function (key) {
	      return key.substr(0, 'metric'.length) === 'metric';
	    }).forEach(function (key) {
	      fieldObject[key] = args[key];
	    }); // Send to GA
	
	    send(fieldObject, trackerNames);
	  }
	}
	/**
	 * exception:
	 * GA exception tracking
	 * @param args.description {String} optional
	 * @param args.fatal {boolean} optional
	 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
	 */
	
	
	function exception(_ref3, trackerNames) {
	  var description = _ref3.description,
	      fatal = _ref3.fatal;
	
	  if (typeof ga === 'function') {
	    // Required Fields
	    var fieldObject = {
	      hitType: 'exception'
	    }; // Optional Fields
	
	    if (description) {
	      fieldObject.exDescription = _format(description);
	    }
	
	    if (typeof fatal !== 'undefined') {
	      if (typeof fatal !== 'boolean') {
	        (0, _warn["default"])('`args.fatal` must be a boolean.');
	      } else {
	        fieldObject.exFatal = fatal;
	      }
	    } // Send to GA
	
	
	    send(fieldObject, trackerNames);
	  }
	}
	
	var plugin = {
	  /**
	   * require:
	   * GA requires a plugin
	   * @param name {String} e.g. 'ecommerce' or 'myplugin'
	   * @param options {Object} optional e.g {path: '/log', debug: true}
	   * @param trackerName {String} optional e.g 'trackerName'
	   */
	  require: function require(rawName, options, trackerName) {
	    if (typeof ga === 'function') {
	      // Required Fields
	      if (!rawName) {
	        (0, _warn["default"])('`name` is required in .require()');
	        return;
	      }
	
	      var name = (0, _trim["default"])(rawName);
	
	      if (name === '') {
	        (0, _warn["default"])('`name` cannot be an empty string in .require()');
	        return;
	      }
	
	      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields
	
	      if (options) {
	        if (_typeof(options) !== 'object') {
	          (0, _warn["default"])('Expected `options` arg to be an Object');
	          return;
	        }
	
	        if (Object.keys(options).length === 0) {
	          (0, _warn["default"])('Empty `options` given to .require()');
	        }
	
	        ga(requireString, name, options);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
	        }
	      } else {
	        ga(requireString, name);
	
	        if (_debug) {
	          (0, _log["default"])("called ga('require', '".concat(name, "');"));
	        }
	      }
	    }
	  },
	
	  /**
	   * execute:
	   * GA execute action for plugin
	   * Takes variable number of arguments
	   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
	   * @param action {String} e.g. 'addItem' or 'myCustomAction'
	   * @param actionType {String} optional e.g. 'detail'
	   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
	   */
	  execute: function execute(pluginName, action) {
	    var payload;
	    var actionType;
	
	    for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      args[_key3 - 2] = arguments[_key3];
	    }
	
	    if (args.length === 1) {
	      payload = args[0];
	    } else {
	      actionType = args[0];
	      payload = args[1];
	    }
	
	    if (typeof ga === 'function') {
	      if (typeof pluginName !== 'string') {
	        (0, _warn["default"])('Expected `pluginName` arg to be a String.');
	      } else if (typeof action !== 'string') {
	        (0, _warn["default"])('Expected `action` arg to be a String.');
	      } else {
	        var command = "".concat(pluginName, ":").concat(action);
	        payload = payload || null;
	
	        if (actionType && payload) {
	          ga(command, actionType, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
	          }
	        } else if (payload) {
	          ga(command, payload);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	            (0, _log["default"])("with payload: ".concat(JSON.stringify(payload)));
	          }
	        } else {
	          ga(command);
	
	          if (_debug) {
	            (0, _log["default"])("called ga('".concat(command, "');"));
	          }
	        }
	      }
	    }
	  }
	};
	/**
	 * outboundLink:
	 * GA outboundLink tracking
	 * @param args.label {String} e.g. url, or 'Create an Account'
	 * @param {function} hitCallback - Called after processing a hit.
	 */
	
	exports.plugin = plugin;
	
	function outboundLink(args, hitCallback, trackerNames) {
	  if (typeof hitCallback !== 'function') {
	    (0, _warn["default"])('hitCallback function is required');
	    return;
	  }
	
	  if (typeof ga === 'function') {
	    // Simple Validation
	    if (!args || !args.label) {
	      (0, _warn["default"])('args.label is required in outboundLink()');
	      return;
	    } // Required Fields
	
	
	    var fieldObject = {
	      hitType: 'event',
	      eventCategory: 'Outbound',
	      eventAction: 'Click',
	      eventLabel: _format(args.label)
	    };
	    var safetyCallbackCalled = false;
	
	    var safetyCallback = function safetyCallback() {
	      // This prevents a delayed response from GA
	      // causing hitCallback from being fired twice
	      safetyCallbackCalled = true;
	      hitCallback();
	    }; // Using a timeout to ensure the execution of critical application code
	    // in the case when the GA server might be down
	    // or an ad blocker prevents sending the data
	    // register safety net timeout:
	
	
	    var t = setTimeout(safetyCallback, 250);
	
	    var clearableCallbackForGA = function clearableCallbackForGA() {
	      clearTimeout(t);
	
	      if (!safetyCallbackCalled) {
	        hitCallback();
	      }
	    };
	
	    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA
	
	    send(fieldObject, trackerNames);
	  } else {
	    // if ga is not defined, return the callback so the application
	    // continues to work as expected
	    setTimeout(hitCallback, 0);
	  }
	}
	
	var testModeAPI = _testModeAPI["default"];
	exports.testModeAPI = testModeAPI;
	var _default = {
	  initialize: initialize,
	  ga: ga,
	  set: set,
	  send: send,
	  pageview: pageview,
	  modalview: modalview,
	  timing: timing,
	  event: event,
	  exception: exception,
	  plugin: plugin,
	  outboundLink: outboundLink,
	  testModeAPI: _testModeAPI["default"]
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = format;
	
	var _redactEmail = _interopRequireDefault(__webpack_require__(4));
	
	var _toTitleCase = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function format() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var titleCase = arguments.length > 1 ? arguments[1] : undefined;
	  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  var _str = s || '';
	
	  if (titleCase) {
	    _str = (0, _toTitleCase["default"])(s);
	  }
	
	  if (redactingEmail) {
	    _str = (0, _redactEmail["default"])(_str);
	  }
	
	  return _str;
	}
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = redactEmail;
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	var _mightBeEmail = _interopRequireDefault(__webpack_require__(5));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var redacted = 'REDACTED (Potential Email Address)';
	
	function redactEmail(string) {
	  if ((0, _mightBeEmail["default"])(string)) {
	    (0, _warn["default"])('This arg looks like an email address, redacting.');
	    return redacted;
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = mightBeEmail;
	
	// See if s could be an email address. We don't want to send personal data like email.
	// https://support.google.com/analytics/answer/2795983?hl=en
	function mightBeEmail(s) {
	  // There's no point trying to validate rfc822 fully, just look for ...@...
	  return typeof s === 'string' && s.indexOf('@') !== -1;
	}
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = toTitleCase;
	
	var _trim = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * To Title Case 2.1 - http://individed.com/code/to-title-case/
	 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
	 * https://github.com/gouch/to-title-case
	 */
	var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i; // test
	
	function toTitleCase(string) {
	  return (0, _trim["default"])(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
	    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
	      return match.toLowerCase();
	    }
	
	    if (match.substr(1).search(/[A-Z]|\../) > -1) {
	      return match;
	    }
	
	    return match.charAt(0).toUpperCase() + match.substr(1);
	  });
	}
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = removeLeadingSlash;
	
	function removeLeadingSlash(string) {
	  if (string.substring(0, 1) === '/') {
	    return string.substring(1);
	  }
	
	  return string;
	}
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	var isLoaded = false;
	
	function _default(options) {
	  if (isLoaded) return;
	  isLoaded = true;
	  var gaAddress = 'https://www.google-analytics.com/analytics.js';
	
	  if (options && options.gaAddress) {
	    gaAddress = options.gaAddress;
	  } else if (options && options.debug) {
	    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
	  }
	
	  var onerror = options && options.onerror; // https://developers.google.com/analytics/devguides/collection/analyticsjs/
	
	  /* eslint-disable */
	
	  (function (i, s, o, g, r, a, m) {
	    i['GoogleAnalyticsObject'] = r;
	    i[r] = i[r] || function () {
	      (i[r].q = i[r].q || []).push(arguments);
	    }, i[r].l = 1 * new Date();
	    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	    a.async = 1;
	    a.src = g;
	    a.onerror = onerror;
	    m.parentNode.insertBefore(a, m);
	  })(window, document, 'script', gaAddress, 'ga');
	  /* eslint-enable */
	
	}
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = log;
	
	function log(s) {
	  console.info('[react-ga]', s);
	}
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.gaCalls = void 0;
	var gaCalls = [];
	exports.gaCalls = gaCalls;
	var _default = {
	  calls: gaCalls,
	  ga: function ga() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    gaCalls.push([].concat(args));
	  },
	  resetCalls: function resetCalls() {
	    gaCalls.length = 0;
	  }
	};
	exports["default"] = _default;
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OutboundLink = exports.testModeAPI = exports.outboundLink = exports.plugin = exports.exception = exports.event = exports.timing = exports.modalview = exports.pageview = exports.send = exports.set = exports.ga = exports.addTrackers = exports.initialize = void 0;
	
	var _OutboundLink = _interopRequireDefault(__webpack_require__(12));
	
	var Defaults = _interopRequireWildcard(__webpack_require__(2));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialize = Defaults.initialize;
	exports.initialize = initialize;
	var addTrackers = Defaults.addTrackers;
	exports.addTrackers = addTrackers;
	var ga = Defaults.ga;
	exports.ga = ga;
	var set = Defaults.set;
	exports.set = set;
	var send = Defaults.send;
	exports.send = send;
	var pageview = Defaults.pageview;
	exports.pageview = pageview;
	var modalview = Defaults.modalview;
	exports.modalview = modalview;
	var timing = Defaults.timing;
	exports.timing = timing;
	var event = Defaults.event;
	exports.event = event;
	var exception = Defaults.exception;
	exports.exception = exception;
	var plugin = Defaults.plugin;
	exports.plugin = plugin;
	var outboundLink = Defaults.outboundLink;
	exports.outboundLink = outboundLink;
	var testModeAPI = Defaults.testModeAPI;
	exports.testModeAPI = testModeAPI;
	_OutboundLink["default"].origTrackLink = _OutboundLink["default"].trackLink;
	_OutboundLink["default"].trackLink = Defaults.outboundLink;
	var OutboundLink = _OutboundLink["default"];
	exports.OutboundLink = OutboundLink;
	
	var _default = _objectSpread(_objectSpread({}, Defaults), {}, {
	  OutboundLink: OutboundLink
	});
	
	exports["default"] = _default;
	
	/***/ }),
	/* 12 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(13));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(14));
	
	var _warn = _interopRequireDefault(__webpack_require__(0));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NEWTAB = '_blank';
	var MIDDLECLICK = 1;
	
	var OutboundLink = /*#__PURE__*/function (_Component) {
	  _inherits(OutboundLink, _Component);
	
	  var _super = _createSuper(OutboundLink);
	
	  function OutboundLink() {
	    var _this;
	
	    _classCallCheck(this, OutboundLink);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
	      var _this$props = _this.props,
	          target = _this$props.target,
	          eventLabel = _this$props.eventLabel,
	          to = _this$props.to,
	          onClick = _this$props.onClick,
	          trackerNames = _this$props.trackerNames;
	      var eventMeta = {
	        label: eventLabel
	      };
	      var sameTarget = target !== NEWTAB;
	      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);
	
	      if (sameTarget && normalClick) {
	        event.preventDefault();
	        OutboundLink.trackLink(eventMeta, function () {
	          window.location.href = to;
	        }, trackerNames);
	      } else {
	        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
	      }
	
	      if (onClick) {
	        onClick(event);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(OutboundLink, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          href = _this$props2.to,
	          target = _this$props2.target,
	          oldProps = _objectWithoutProperties(_this$props2, ["to", "target"]);
	
	      var props = _objectSpread(_objectSpread({}, oldProps), {}, {
	        target: target,
	        href: href,
	        onClick: this.handleClick
	      });
	
	      if (target === NEWTAB) {
	        props.rel = "".concat(props.rel ? props.rel : '', " noopener noreferrer").trim();
	      }
	
	      delete props.eventLabel;
	      delete props.trackerNames;
	      return /*#__PURE__*/_react["default"].createElement('a', props);
	    }
	  }]);
	
	  return OutboundLink;
	}(_react.Component);
	
	exports["default"] = OutboundLink;
	
	_defineProperty(OutboundLink, "trackLink", function () {
	  (0, _warn["default"])('ga tracking not enabled');
	});
	
	OutboundLink.propTypes = {
	  eventLabel: _propTypes["default"].string.isRequired,
	  target: _propTypes["default"].string,
	  to: _propTypes["default"].string,
	  onClick: _propTypes["default"].func,
	  trackerNames: _propTypes["default"].arrayOf(_propTypes["default"].string)
	};
	OutboundLink.defaultProps = {
	  target: null,
	  to: null,
	  onClick: null,
	  trackerNames: null
	};
	
	/***/ }),
	/* 13 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__13__;
	
	/***/ }),
	/* 14 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE__14__;
	
	/***/ })
	/******/ ]);
	});

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1100);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _debug = __webpack_require__(294);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	var _DEFAULT_CHART_COLORS = __webpack_require__(1086);
	
	var _DEFAULT_CHART_COLORS2 = _interopRequireDefault(_DEFAULT_CHART_COLORS);
	
	var _GoogleChartLoader = __webpack_require__(1085);
	
	var _GoogleChartLoader2 = _interopRequireDefault(_GoogleChartLoader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/forbid-prop-types: "off" */
	
	
	var debug = new _debug2.default('react-google-charts:Chart');
	
	var uniqueID = 0;
	
	var generateUniqueID = function generateUniqueID() {
	  uniqueID += 1;
	  return 'reactgooglegraph-' + uniqueID;
	};
	
	var Chart = function (_React$Component) {
	  _inherits(Chart, _React$Component);
	
	  function Chart(props) {
	    _classCallCheck(this, Chart);
	
	    debug('constructor', props);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = { graphID: props.graph_id || generateUniqueID() };
	    _this.chart = null;
	    _this.wrapper = null;
	    _this.hidden_columns = {};
	    _this.dataTable = [];
	
	    _this.debounce = _this.debounce.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	    _this.drawChart = _this.drawChart.bind(_this);
	    _this.togglePoints = _this.togglePoints.bind(_this);
	    _this.buildDataTableFromProps = _this.buildDataTableFromProps.bind(_this);
	    _this.listenToChartEvents = _this.listenToChartEvents.bind(_this);
	    _this.addChartActions = _this.addChartActions.bind(_this);
	    _this.updateDataTable = _this.updateDataTable.bind(_this);
	    _this.onSelectToggle = _this.onSelectToggle.bind(_this);
	    _this.addSourceColumnTo = _this.addSourceColumnTo.bind(_this);
	    _this.restoreColorTo = _this.restoreColorTo.bind(_this);
	    _this.hideColumn = _this.hideColumn.bind(_this);
	    return _this;
	  }
	
	  Chart.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    debug('componentDidMount');
	    if (typeof window === 'undefined') {
	      return;
	    }
	    if (this.props.loadCharts) {
	      _GoogleChartLoader2.default.init(this.props.chartPackages, this.props.chartVersion).then(function () {
	        _this2.drawChart();
	      });
	      this.onResize = this.debounce(this.onResize, 200);
	      window.addEventListener('resize', this.onResize);
	    } else {
	      this.drawChart();
	    }
	  };
	
	  Chart.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this3 = this;
	
	    debug('componentDidUpdate');
	    if (!this.props.loadCharts) {
	      this.drawChart();
	    } else if (_GoogleChartLoader2.default.isLoading) {
	      _GoogleChartLoader2.default.initPromise.then(function () {
	        _this3.drawChart();
	      });
	    } else if (_GoogleChartLoader2.default.isLoaded) {
	      this.drawChart();
	    }
	  };
	
	  Chart.prototype.componentWillUnmount = function componentWillUnmount() {
	    try {
	      if (window) {
	        if (window.google && window.google.visualization) {
	          window.google.visualization.events.removeAllListeners(this.wrapper);
	        }
	        window.removeEventListener('resize', this.onResize);
	      }
	    } catch (err) {
	      return;
	    }
	  };
	
	  Chart.prototype.onResize = function onResize() {
	    debug('Chart::onResize');
	    this.drawChart();
	  };
	
	  Chart.prototype.onSelectToggle = function onSelectToggle() {
	    debug('onSelectToggle');
	    var selection = this.chart.getSelection();
	    if (selection.length > 0) {
	      if (selection[0].row == null) {
	        var column = selection[0].column;
	        this.togglePoints(column);
	      }
	    }
	  };
	
	  Chart.prototype.getColumnColor = function getColumnColor(columnIndex) {
	    if (this.props.options.colors) {
	      if (this.props.options.colors[columnIndex]) {
	        return this.props.options.colors[columnIndex];
	      }
	    } else if (columnIndex in _DEFAULT_CHART_COLORS2.default) {
	      return _DEFAULT_CHART_COLORS2.default[columnIndex];
	    }
	    return _DEFAULT_CHART_COLORS2.default[0];
	  };
	
	  Chart.prototype.buildDataTableFromProps = function buildDataTableFromProps() {
	    debug('buildDataTableFromProps', this.props);
	
	    if (this.props.diffdata) {
	      var diffdata = this.props.diffdata;
	      var oldData = window.google.visualization.arrayToDataTable(diffdata.old);
	      var newData = window.google.visualization.arrayToDataTable(diffdata.new);
	      // must take computeDiff from prototypes since not available with charts early in process
	      var computeDiff = window.google.visualization[this.props.chartType].prototype.computeDiff;
	      var chartDiff = computeDiff(oldData, newData);
	      return chartDiff;
	    }
	
	    if (this.props.data === null && this.props.rows.length === 0 && !this.props.allowEmptyRows) {
	      throw new Error("Can't build DataTable from rows and columns: rows array in props is empty");
	    } else if (this.props.data === null && this.props.columns.length === 0) {
	      throw new Error("Can't build DataTable from rows and columns: columns array in props is empty");
	    }
	    if (this.props.data !== null) {
	      try {
	        this.wrapper.setDataTable(this.props.data);
	        var _dataTable = this.wrapper.getDataTable();
	        return _dataTable;
	      } catch (err) {
	        // console.error('Failed to set DataTable from data props ! ', err);
	        throw new Error('Failed to set DataTable from data props ! ', err);
	      }
	    }
	
	    var dataTable = new window.google.visualization.DataTable();
	    this.props.columns.forEach(function (column) {
	      dataTable.addColumn(column);
	    });
	    dataTable.addRows(this.props.rows);
	    if (this.props.numberFormat) {
	      var formatter = new window.google.visualization.NumberFormat(this.props.numberFormat.options);
	      formatter.format(dataTable, this.props.numberFormat.column);
	    }
	
	    if (this.props.dateFormat) {
	      var dateFormat = new window.google.visualization.DateFormat(this.props.dateFormat.options);
	      this.props.dateFormat.columns.forEach(function (columnIdx) {
	        dateFormat.format(dataTable, columnIdx);
	      });
	    }
	
	    return dataTable;
	  };
	
	  Chart.prototype.updateDataTable = function updateDataTable() {
	    debug('updateDataTable');
	    window.google.visualization.errors.removeAll(document.getElementById(this.wrapper.getContainerId()));
	    this.dataTable.removeRows(0, this.dataTable.getNumberOfRows());
	    this.dataTable.removeColumns(0, this.dataTable.getNumberOfColumns());
	    this.dataTable = this.buildDataTableFromProps();
	    return this.dataTable;
	  };
	
	  Chart.prototype.drawChart = function drawChart() {
	    var _this4 = this;
	
	    debug('drawChart', this);
	    if (!this.wrapper) {
	      var chartConfig = {
	        chartType: this.props.chartType,
	        options: this.props.options,
	        containerId: this.state.graphID
	      };
	      this.wrapper = new window.google.visualization.ChartWrapper(chartConfig);
	      this.dataTable = this.buildDataTableFromProps();
	      this.wrapper.setDataTable(this.dataTable);
	
	      window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
	        _this4.chart = _this4.wrapper.getChart();
	        _this4.listenToChartEvents();
	        _this4.addChartActions();
	      });
	    } else {
	      this.updateDataTable();
	      this.wrapper.setDataTable(this.dataTable);
	      // this.wrapper.setChartType(this.props.chartType)
	      this.wrapper.setOptions(this.props.options);
	      if (this.wrapper.getChartType() !== this.props.chartType) {
	        window.google.visualization.events.removeAllListeners(this.wrapper);
	        this.wrapper.setChartType(this.props.chartType);
	        var self = this;
	        window.google.visualization.events.addOneTimeListener(this.wrapper, 'ready', function () {
	          self.chart = self.wrapper.getChart();
	          self.listenToChartEvents.call(self);
	        });
	      }
	    }
	    this.wrapper.draw();
	  };
	
	  Chart.prototype.addChartActions = function addChartActions() {
	    var _this5 = this;
	
	    debug('addChartActions', this.props.chartActions);
	    if (this.props.chartActions === null) {
	      return;
	    }
	    this.props.chartActions.forEach(function (chartAction) {
	      _this5.chart.setAction({
	        id: chartAction.id,
	        text: chartAction.text,
	        action: chartAction.action.bind(_this5, _this5.chart)
	      });
	    });
	  };
	
	  Chart.prototype.listenToChartEvents = function listenToChartEvents() {
	    var _this6 = this;
	
	    debug('listenToChartEvents', this.props.legend_toggle, this.props.chartEvents);
	    if (this.props.legend_toggle) {
	      window.google.visualization.events.addListener(this.wrapper, 'select', this.onSelectToggle);
	    }
	    this.props.chartEvents.forEach(function (chartEvent) {
	      if (chartEvent.eventName === 'ready') {
	        chartEvent.callback(_this6);
	      } else {
	        (function (event) {
	          window.google.visualization.events.addListener(_this6.chart, event.eventName, function (e) {
	            event.callback(_this6, e);
	          });
	        })(chartEvent);
	      }
	    });
	  };
	
	  Chart.prototype.buildColumnFromSourceData = function buildColumnFromSourceData(columnIndex) {
	    debug('buildColumnFromSourceData', columnIndex);
	    return {
	      label: this.dataTable.getColumnLabel(columnIndex),
	      type: this.dataTable.getColumnType(columnIndex),
	      sourceColumn: columnIndex
	    };
	  };
	
	  Chart.prototype.buildEmptyColumnFromSourceData = function buildEmptyColumnFromSourceData(columnIndex) {
	    debug('buildEmptyColumnFromSourceData', columnIndex);
	    return {
	      label: this.dataTable.getColumnLabel(columnIndex),
	      type: this.dataTable.getColumnType(columnIndex),
	      calc: function calc() {
	        return null;
	      }
	    };
	  };
	
	  Chart.prototype.addEmptyColumnTo = function addEmptyColumnTo(columns, columnIndex) {
	    debug('addEmptyColumnTo', columns, columnIndex);
	    var emptyColumn = this.buildEmptyColumnFromSourceData(columnIndex);
	    columns.push(emptyColumn);
	  };
	
	  Chart.prototype.hideColumn = function hideColumn(colors, columnIndex) {
	    debug('hideColumn', colors, columnIndex);
	    if (!this.isHidden(columnIndex)) {
	      this.hidden_columns[columnIndex] = { color: this.getColumnColor(columnIndex - 1) };
	    }
	    colors.push('#CCCCCC');
	  };
	
	  Chart.prototype.addSourceColumnTo = function addSourceColumnTo(columns, columnIndex) {
	    debug('addSourceColumnTo', columns, columnIndex);
	    var sourceColumn = this.buildColumnFromSourceData(columnIndex);
	    columns.push(sourceColumn);
	  };
	
	  Chart.prototype.isHidden = function isHidden(columnIndex) {
	    return this.hidden_columns[columnIndex] !== undefined;
	  };
	
	  Chart.prototype.restoreColorTo = function restoreColorTo(colors, columnIndex) {
	    debug('restoreColorTo', colors, columnIndex);
	    debug('hidden_columns', this.hidden_columns);
	    var previousColor = void 0;
	    if (this.isHidden(columnIndex)) {
	      previousColor = this.hidden_columns[columnIndex].color;
	      delete this.hidden_columns[columnIndex];
	    } else {
	      previousColor = this.getColumnColor(columnIndex - 1);
	    }
	    if (columnIndex !== 0) {
	      colors.push(previousColor);
	    }
	  };
	  // eslint-disable-next-line class-methods-use-this
	
	
	  Chart.prototype.debounce = function debounce(func, wait) {
	    var timeout = void 0;
	    return function () {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      var context = this;
	      clearTimeout(timeout);
	      timeout = setTimeout(function () {
	        return func.apply(context, args);
	      }, wait);
	    };
	  };
	
	  Chart.prototype.togglePoints = function togglePoints(column) {
	    debug('togglePoints', column);
	    var view = new window.google.visualization.DataView(this.wrapper.getDataTable());
	    var columnCount = view.getNumberOfColumns();
	    var colors = []; // eslint-disable-line prefer-const
	    var columns = []; // eslint-disable-line prefer-const
	    for (var i = 0; i < columnCount; i += 1) {
	      // If user clicked on legend
	      if (i === 0) {
	        this.addSourceColumnTo(columns, i);
	      } else if (i === column) {
	        if (this.isHidden(i)) {
	          this.addSourceColumnTo(columns, i);
	          this.restoreColorTo(colors, i);
	        } else {
	          this.addEmptyColumnTo(columns, i);
	          this.hideColumn(colors, i);
	        }
	      } else if (this.isHidden(i)) {
	        this.addEmptyColumnTo(columns, i);
	        this.hideColumn(colors, i);
	      } else {
	        this.addSourceColumnTo(columns, i);
	        this.restoreColorTo(colors, i);
	      }
	    }
	    view.setColumns(columns);
	    this.props.options.colors = colors;
	    this.chart.draw(view, this.props.options);
	  };
	
	  Chart.prototype.render = function render() {
	    debug('render', this.props, this.state);
	    var divStyle = {
	      height: this.props.height || this.props.options.height,
	      width: this.props.width || this.props.options.width
	    };
	    return _react2.default.createElement(
	      'div',
	      { id: this.state.graphID, style: divStyle },
	      this.props.loader ? this.props.loader : 'Rendering Chart...'
	    );
	  };
	
	  return Chart;
	}(_react2.default.Component);
	
	exports.default = Chart;
	
	
	 false ? Chart.propTypes = {
	  graph_id: _react2.default.PropTypes.string,
	  chartType: _react2.default.PropTypes.string,
	  rows: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.array),
	  columns: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object),
	  data: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.array),
	  options: _react2.default.PropTypes.any,
	  width: _react2.default.PropTypes.string,
	  height: _react2.default.PropTypes.string,
	  chartEvents: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    // https://github.com/yannickcr/eslint-plugin-react/issues/819
	    eventName: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	    callback: _react2.default.PropTypes.func })),
	  chartActions: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
	    id: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	    text: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	    action: _react2.default.PropTypes.func })),
	  loadCharts: _react2.default.PropTypes.bool,
	  loader: _react2.default.PropTypes.node,
	  legend_toggle: _react2.default.PropTypes.bool,
	  allowEmptyRows: _react2.default.PropTypes.bool,
	  chartPackages: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string),
	  chartVersion: _react2.default.PropTypes.string,
	  numberFormat: _react2.default.PropTypes.shape({
	    column: _react2.default.PropTypes.number, // eslint-disable-line react/no-unused-prop-types
	    options: _react2.default.PropTypes.shape({
	      decimalSymbol: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      fractionDigits: _react2.default.PropTypes.number, // eslint-disable-line react/no-unused-prop-types
	      groupingSymbol: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      negativeColor: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      negativeParens: _react2.default.PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
	      pattern: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      prefix: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      suffix: _react2.default.PropTypes.string })
	  }),
	  dateFormat: _react2.default.PropTypes.shape({
	    columns: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.number), // eslint-disable-line react/no-unused-prop-types
	    options: _react2.default.PropTypes.shape({
	      formatType: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      pattern: _react2.default.PropTypes.string, // eslint-disable-line react/no-unused-prop-types
	      timeZone: _react2.default.PropTypes.number })
	  }),
	  diffdata: _react2.default.PropTypes.shape({
	    on: _react2.default.PropTypes.array, // eslint-disable-line react/no-unused-prop-types
	    off: _react2.default.PropTypes.array })
	} : void 0;
	
	Chart.defaultProps = {
	  chartType: 'LineChart',
	  rows: [],
	  columns: [],
	  options: {
	    chart: {
	      title: 'Chart Title',
	      subtitle: 'Subtitle'
	    },
	    hAxis: { title: 'X Label' },
	    vAxis: { title: 'Y Label' },
	    width: '400px',
	    height: '300px'
	  },
	  width: '400px',
	  height: '300px',
	  chartEvents: [],
	  chartActions: null,
	  data: null,
	  legend_toggle: false,
	  allowEmptyRows: false,
	  loadCharts: true,
	  loader: _react2.default.createElement(
	    'div',
	    null,
	    'Rendering Chart'
	  ),
	  chartPackages: ['corechart'],
	  chartVersion: 'current',
	  numberFormat: null,
	  dateFormat: null,
	  diffdata: null
	};
	module.exports = exports['default'];

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _debug = __webpack_require__(294);
	
	var _debug2 = _interopRequireDefault(_debug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var debug = new _debug2.default('react-google-charts:GoogleChartLoader'); // GoogleChartLoader Singleton
	
	// Based on http://blog.arkency.com/2014/09/react-dot-js-and-google-charts/
	
	var script = typeof window !== 'undefined' ? __webpack_require__(906) : function (link, _ref) {
	  var callback = _ref.success;
	  return callback();
	};
	
	var googleChartLoader = {
	  isLoaded: false,
	  isLoading: false,
	  initPromise: {},
	  init: function init(packages, version) {
	    var _this = this;
	
	    debug('init', packages, version);
	    if (this.isLoading || this.isLoaded) {
	      return this.initPromise;
	    }
	    this.isLoading = true;
	    this.initPromise = new Promise(function (resolve) {
	      script('https://www.gstatic.com/charts/loader.js', { success: function success() {
	          window.google.charts.load(version || 'current', { packages: packages || ['corechart'] });
	          window.google.charts.setOnLoadCallback(function () {
	            debug('Chart Loaded');
	            _this.isLoaded = true;
	            _this.isLoading = false;
	            resolve();
	          });
	        } });
	    });
	    return this.initPromise;
	  }
	};
	
	exports.default = googleChartLoader;
	module.exports = exports['default'];

/***/ },
/* 1086 */
/***/ function(module, exports) {

	'use strict';
	
	// Taken from http://there4development.com/blog/2012/05/02/google-chart-color-list/
	
	module.exports = ['#3366CC', '#DC3912', '#FF9900', '#109618', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#3B3EAC'];

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Chart = __webpack_require__(1084);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = { Chart: _Chart2.default };
	module.exports = exports['default'];

/***/ },
/* 1088 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(156);
	
	var invariant = __webpack_require__(144);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(92);
	
	var ReactBaseClasses = __webpack_require__(466);
	var ReactChildren = __webpack_require__(1091);
	var ReactDOMFactories = __webpack_require__(1092);
	var ReactElement = __webpack_require__(102);
	var ReactPropTypes = __webpack_require__(1093);
	var ReactVersion = __webpack_require__(1094);
	
	var createReactClass = __webpack_require__(1095);
	var onlyChild = __webpack_require__(1098);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1089);
	var ReactElement = __webpack_require__(102);
	
	var emptyFunction = __webpack_require__(296);
	var traverseAllChildren = __webpack_require__(1099);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(102);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(102),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(1016);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1094 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(466),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(102),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(469);
	var factory = __webpack_require__(293);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1096 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(156);
	
	var ReactElement = __webpack_require__(102);
	
	var invariant = __webpack_require__(144);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(156);
	
	var ReactCurrentOwner = __webpack_require__(467);
	var REACT_ELEMENT_TYPE = __webpack_require__(468);
	
	var getIteratorFn = __webpack_require__(1096);
	var invariant = __webpack_require__(144);
	var KeyEscapeUtils = __webpack_require__(1088);
	var warning = __webpack_require__(204);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1090);


/***/ },
/* 1101 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _deepEqual = __webpack_require__(295);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function intersects(array1, array2) {
	  return !!(array1 && array2 && array1.some(function (item) {
	    return ~array2.indexOf(item);
	  }));
	}
	
	var LazyCache = (function () {
	  function LazyCache(component, calculators) {
	    var _this = this;
	
	    _classCallCheck(this, LazyCache);
	
	    this.component = component;
	    this.allProps = [];
	    this.cache = Object.keys(calculators).reduce(function (accumulator, key) {
	      var _extends2;
	
	      var calculator = calculators[key];
	      var fn = calculator.fn;
	      var paramNames = calculator.params;
	      paramNames.forEach(function (param) {
	        if (! ~_this.allProps.indexOf(param)) {
	          _this.allProps.push(param);
	        }
	      });
	      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = {
	        value: undefined,
	        props: paramNames,
	        fn: fn
	      }, _extends2));
	    }, {});
	  }
	
	  LazyCache.prototype.get = function get(key) {
	    var component = this.component;
	    var _cache$key = this.cache[key];
	    var value = _cache$key.value;
	    var fn = _cache$key.fn;
	    var props = _cache$key.props;
	
	    if (value !== undefined) {
	      return value;
	    }
	    var params = props.map(function (prop) {
	      return component.props[prop];
	    });
	    var result = fn.apply(undefined, params);
	    this.cache[key].value = result;
	    return result;
	  };
	
	  LazyCache.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var component = this.component;
	
	    var diffProps = [];
	    this.allProps.forEach(function (prop) {
	      if (!_deepEqual2['default'](component.props[prop], nextProps[prop])) {
	        diffProps.push(prop);
	      }
	    });
	    if (diffProps.length) {
	      Object.keys(this.cache).forEach(function (key) {
	        if (intersects(diffProps, _this2.cache[key].props)) {
	          delete _this2.cache[key].value; // uncache value
	        }
	      });
	    }
	  };
	
	  return LazyCache;
	})();
	
	exports['default'] = LazyCache;
	module.exports = exports['default'];

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1102);


/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(155);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(1105);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(471);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(473);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = 'ReactModalPortal';
	var bodyOpenClassName = exports.bodyOpenClassName = 'ReactModal__Body--open';
	
	var renderSubtreeIntoContainer = _reactDom2.default.unstable_renderSubtreeIntoContainer;
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      parent.removeChild(_this.node);
	    }, _this.renderPortal = function (props) {
	      _this.portal = renderSubtreeIntoContainer(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.node = document.createElement('div');
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      this.renderPortal(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      var isOpen = newProps.isOpen;
	      // Stop unnecessary renders if modal is remaining closed
	
	      if (!this.props.isOpen && !isOpen) return;
	
	      var currentParent = getParentElement(this.props.parentSelector);
	      var newParent = getParentElement(newProps.parentSelector);
	
	      if (newParent !== currentParent) {
	        currentParent.removeChild(this.node);
	        newParent.appendChild(this.node);
	      }
	
	      this.renderPortal(newProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(newProps) {
	      if (newProps.portalClassName !== this.props.portalClassName) {
	        this.node.className = newProps.portalClassName;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'setAppElement',
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable no-console */
	
	  }, {
	    key: 'injectCSS',
	    value: function injectCSS() {
	      ("production") !== "production" && console.warn('React-Modal: injectCSS has been deprecated ' + 'and no longer has any effect. It will be removed in a later version');
	    }
	    /* eslint-enable no-console */
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfter: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnOverlayClick: true,
	  parentSelector: function parentSelector() {
	    return document.body;
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: 'fixed',
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position: 'absolute',
	    top: '40px',
	    left: '40px',
	    right: '40px',
	    bottom: '40px',
	    border: '1px solid #ccc',
	    background: '#fff',
	    overflow: 'auto',
	    WebkitOverflowScrolling: 'touch',
	    borderRadius: '4px',
	    outline: 'none',
	    padding: '20px'
	  }
	};
	exports.default = Modal;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _focusManager = __webpack_require__(1107);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(1108);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(471);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _refCount = __webpack_require__(472);
	
	var refCount = _interopRequireWildcard(_refCount);
	
	var _bodyClassList = __webpack_require__(1106);
	
	var bodyClassList = _interopRequireWildcard(_bodyClassList);
	
	var _safeHTMLElement = __webpack_require__(473);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: 'ReactModal__Overlay',
	  content: 'ReactModal__Content'
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setFocusAfterRender = function (focus) {
	      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
	    };
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	    };
	
	    _this.afterClose = function () {
	      focusManager.returnFocus();
	      focusManager.teardownScopedFocus();
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        focusManager.setupScopedFocus(_this.node);
	        focusManager.markForFocusLater();
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen();
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      _this.beforeClose();
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus();
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	      if (event.keyCode === ESC_KEY) {
	        event.preventDefault();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	      _this.moveFromContentToOverlay = null;
	    };
	
	    _this.handleOverlayOnMouseUp = function () {
	      if (_this.moveFromContentToOverlay === null) {
	        _this.shouldClose = false;
	      }
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function () {
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	      _this.moveFromContentToOverlay = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === 'undefined' ? 'undefined' : _typeof(additional)) === 'object' ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + '--after-open',
	        beforeClose: CLASS_NAMES[which] + '--before-close'
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + ' ' + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + ' ' + classNames.beforeClose;
	      }
	      return typeof additional === 'string' && additional ? className + ' ' + additional : className;
	    };
	
	    _this.ariaAttributes = function (items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc['aria-' + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Focus needs to be set when mounting and already open
	      if (this.props.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      if (false) {
	        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + 'This may cause unexpected behavior when multiple modals are open.');
	        }
	      }
	      // Focus only needs to be set once when the modal is being opened
	      if (!this.props.isOpen && newProps.isOpen) {
	        this.setFocusAfterRender(true);
	        this.open();
	      } else if (this.props.isOpen && !newProps.isOpen) {
	        this.close();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.focusAfterRender) {
	        this.focusContent();
	        this.setFocusAfterRender(false);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.beforeClose();
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: 'beforeOpen',
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          bodyOpenClassName = _props.bodyOpenClassName;
	      // Add body class
	
	      bodyClassList.add(bodyOpenClassName);
	      // Add aria-hidden to appElement
	      if (ariaHideApp) {
	        ariaAppHider.hide(appElement);
	      }
	    }
	  }, {
	    key: 'beforeClose',
	    value: function beforeClose() {
	      var _props2 = this.props,
	          appElement = _props2.appElement,
	          ariaHideApp = _props2.ariaHideApp,
	          bodyOpenClassName = _props2.bodyOpenClassName;
	      // Remove class if no more modals are open
	
	      bodyClassList.remove(bodyOpenClassName);
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && refCount.totalCount() < 1) {
	        ariaAppHider.show(appElement);
	      }
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          overlayClassName = _props3.overlayClassName,
	          defaultStyles = _props3.defaultStyles;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      return this.shouldBeClosed() ? null : _react2.default.createElement(
	        'div',
	        {
	          ref: this.setOverlayRef,
	          className: this.buildClassName('overlay', overlayClassName),
	          style: _extends({}, overlayStyles, this.props.style.overlay),
	          onClick: this.handleOverlayOnClick,
	          onMouseDown: this.handleOverlayOnMouseDown,
	          onMouseUp: this.handleOverlayOnMouseUp },
	        _react2.default.createElement(
	          'div',
	          _extends({
	            ref: this.setContentRef,
	            style: _extends({}, contentStyles, this.props.style.content),
	            className: this.buildClassName('content', className),
	            tabIndex: '-1',
	            onKeyDown: this.handleKeyDown,
	            onMouseDown: this.handleContentOnMouseDown,
	            onMouseUp: this.handleContentOnMouseUp,
	            onClick: this.handleContentOnClick,
	            role: this.props.role,
	            'aria-label': this.props.contentLabel
	          }, this.ariaAttributes(this.props.aria || {})),
	          this.props.children
	        )
	      );
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  }
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes.PropTypes.bool.isRequired,
	  defaultStyles: _propTypes.PropTypes.shape({
	    content: _propTypes.PropTypes.object,
	    overlay: _propTypes.PropTypes.object
	  }),
	  style: _propTypes.PropTypes.shape({
	    content: _propTypes.PropTypes.object,
	    overlay: _propTypes.PropTypes.object
	  }),
	  className: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
	  overlayClassName: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.object]),
	  bodyOpenClassName: _propTypes.PropTypes.string,
	  ariaHideApp: _propTypes.PropTypes.bool,
	  appElement: _propTypes.PropTypes.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes.PropTypes.func,
	  onRequestClose: _propTypes.PropTypes.func,
	  closeTimeoutMS: _propTypes.PropTypes.number,
	  shouldFocusAfterRender: _propTypes.PropTypes.bool,
	  shouldCloseOnOverlayClick: _propTypes.PropTypes.bool,
	  role: _propTypes.PropTypes.string,
	  contentLabel: _propTypes.PropTypes.string,
	  aria: _propTypes.PropTypes.object,
	  children: _propTypes.PropTypes.node
	};
	exports.default = ModalPortal;
	module.exports = exports['default'];

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.add = add;
	exports.remove = remove;
	
	var _refCount = __webpack_require__(472);
	
	var refCount = _interopRequireWildcard(_refCount);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function add(bodyClass) {
	  // Increment class(es) on refCount tracker and add class(es) to body
	  bodyClass.split(' ').map(refCount.add).forEach(function (className) {
	    return document.body.classList.add(className);
	  });
	}
	
	function remove(bodyClass) {
	  var classListMap = refCount.get();
	  // Decrement class(es) from the refCount tracker
	  // and remove unused class(es) from body
	  bodyClass.split(' ').map(refCount.remove).filter(function (className) {
	    return classListMap[className] === 0;
	  }).forEach(function (className) {
	    return document.body.classList.remove(className);
	  });
	}

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(474);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var toFocus = null;
	  try {
	    toFocus = focusLaterElements.pop();
	    toFocus.focus();
	    return;
	  } catch (e) {
	    console.warn(['You tried to return focus to', toFocus, 'but it is not in the DOM anymore'].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	}

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(474);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	  if (!tabbable.length) {
	    event.preventDefault();
	    return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = finalTabbable === document.activeElement ||
	  // handle immediate shift+tab after opening with mouse
	  node === document.activeElement;
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	}
	module.exports = exports['default'];

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(1104);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports['default'];

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';Object.defineProperty(exports,'__esModule',{value:true});var react=__webpack_require__(1),reactDom=__webpack_require__(155);function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	
	  _setPrototypeOf(subClass, superClass);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	  // Also cover shadowRoot node by checking current.host
	
	
	  while (current.parentNode || current.host) {
	    // Only check normal node without shadowRoot
	    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode || current.host;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = {};
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions.passive = !instance.props.preventDefault;
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	          if (_this.initTimeStamp > event.timeStamp) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      _this.initTimeStamp = performance.now();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    }
	    /**
	     * Remove all document's event listeners for this component
	     */
	    ;
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    }
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    ;
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _this$props = this.props;
	          _this$props.excludeScrollbar;
	          var props = _objectWithoutPropertiesLoose(_this$props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}exports.IGNORE_CLASS_NAME=IGNORE_CLASS_NAME;exports.default=onClickOutsideHOC;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(160);
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(237));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(11));
	
	var _PropTypes = __webpack_require__(477);
	
	var _warning = _interopRequireDefault(__webpack_require__(224));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(159));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(161));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(475));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(1120));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1113));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1114));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1115));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1116));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(5);
	
	var _wrapMapToProps = __webpack_require__(476);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(476);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(159));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(478));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(161));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1117));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(55);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(224));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1118 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1119 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 1120 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(119);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(479);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(480);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(481);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _routerWarning = __webpack_require__(104);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(483);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _routerWarning = __webpack_require__(104);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(77);
	
	var _InternalPropTypes = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(77);
	
	var _InternalPropTypes = __webpack_require__(120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(60);
	
	var _createTransitionManager2 = __webpack_require__(487);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(120);
	
	var _RouterContext = __webpack_require__(229);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(77);
	
	var _RouterUtils = __webpack_require__(484);
	
	var _routerWarning = __webpack_require__(104);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(226);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(229);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(104);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(898);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(486);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(103);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(226);
	
	var _PromiseUtils = __webpack_require__(482);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(103);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(899);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(486);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(103);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(145);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(485);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(487);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(77);
	
	var _RouterUtils = __webpack_require__(484);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(226);
	
	var _PromiseUtils = __webpack_require__(482);
	
	var _PatternUtils = __webpack_require__(103);
	
	var _routerWarning = __webpack_require__(104);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(30);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1141);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(227);
	
	var _PropTypes = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(119);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1143);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1143 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(489);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(490);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(157);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(157);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(489);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(1144);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(490);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(492);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(491);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(231);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(493);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(494);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(230);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 1146 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 1147 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'UNSAFE_componentWillReceiveProps',
			value: function UNSAFE_componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 1149 */
/***/ function(module, exports) {

	/**
	 * @license React
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';var l=Symbol.for("react.element"),n=Symbol.for("react.portal"),p=Symbol.for("react.fragment"),q=Symbol.for("react.strict_mode"),r=Symbol.for("react.profiler"),t=Symbol.for("react.provider"),u=Symbol.for("react.context"),v=Symbol.for("react.forward_ref"),w=Symbol.for("react.suspense"),x=Symbol.for("react.memo"),y=Symbol.for("react.lazy"),z=Symbol.iterator;function A(a){if(null===a||"object"!==typeof a)return null;a=z&&a[z]||a["@@iterator"];return"function"===typeof a?a:null}
	var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C=Object.assign,D={};function E(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}E.prototype.isReactComponent={};
	E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=D;this.updater=e||B}var H=G.prototype=new F;
	H.constructor=G;C(H,E.prototype);H.isPureReactComponent=!0;var I=Array.isArray,J=Object.prototype.hasOwnProperty,K={current:null},L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,e){var d,c={},k=null,h=null;if(null!=b)for(d in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)J.call(b,d)&&!L.hasOwnProperty(d)&&(c[d]=b[d]);var g=arguments.length-2;if(1===g)c.children=e;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];c.children=f}if(a&&a.defaultProps)for(d in g=a.defaultProps,g)void 0===c[d]&&(c[d]=g[d]);return{$$typeof:l,type:a,key:k,ref:h,props:c,_owner:K.current}}
	function N(a,b){return{$$typeof:l,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===l}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g;function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	function R(a,b,e,d,c){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case l:case n:h=!0}}if(h)return h=a,c=c(h),a=""===d?"."+Q(h,0):d,I(c)?(e="",null!=a&&(e=a.replace(P,"$&/")+"/"),R(c,b,e,"",function(a){return a})):null!=c&&(O(c)&&(c=N(c,e+(!c.key||h&&h.key===c.key?"":(""+c.key).replace(P,"$&/")+"/")+a)),b.push(c)),1;h=0;d=""===d?".":d+":";if(I(a))for(var g=0;g<a.length;g++){k=
	a[g];var f=d+Q(k,g);h+=R(k,b,e,f,c)}else if(f=A(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=d+Q(k,g++),h+=R(k,b,e,f,c);else if("object"===k)throw b=String(a),Error("Objects are not valid as a React child (found: "+("[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b)+"). If you meant to render a collection of children, use an array instead.");return h}
	function S(a,b,e){if(null==a)return a;var d=[],c=0;R(a,d,"","",function(a){return b.call(e,a,c++)});return d}function T(a){if(-1===a._status){var b=a._result;b=b();b.then(function(b){if(0===a._status||-1===a._status)a._status=1,a._result=b},function(b){if(0===a._status||-1===a._status)a._status=2,a._result=b});-1===a._status&&(a._status=0,a._result=b)}if(1===a._status)return a._result.default;throw a._result;}
	var U={current:null},V={transition:null},W={ReactCurrentDispatcher:U,ReactCurrentBatchConfig:V,ReactCurrentOwner:K};function X(){throw Error("act(...) is not supported in production builds of React.");}
	exports.Children={map:S,forEach:function(a,b,e){S(a,function(){b.apply(this,arguments)},e)},count:function(a){var b=0;S(a,function(){b++});return b},toArray:function(a){return S(a,function(a){return a})||[]},only:function(a){if(!O(a))throw Error("React.Children.only expected to receive a single React element child.");return a}};exports.Component=E;exports.Fragment=p;exports.Profiler=r;exports.PureComponent=G;exports.StrictMode=q;exports.Suspense=w;
	exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=W;exports.act=X;
	exports.cloneElement=function(a,b,e){if(null===a||void 0===a)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+a+".");var d=C({},a.props),c=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=K.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)J.call(b,f)&&!L.hasOwnProperty(f)&&(d[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){g=Array(f);
	for(var m=0;m<f;m++)g[m]=arguments[m+2];d.children=g}return{$$typeof:l,type:a.type,key:c,ref:k,props:d,_owner:h}};exports.createContext=function(a){a={$$typeof:u,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};a.Provider={$$typeof:t,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};
	exports.forwardRef=function(a){return{$$typeof:v,render:a}};exports.isValidElement=O;exports.lazy=function(a){return{$$typeof:y,_payload:{_status:-1,_result:a},_init:T}};exports.memo=function(a,b){return{$$typeof:x,type:a,compare:void 0===b?null:b}};exports.startTransition=function(a){var b=V.transition;V.transition={};try{a()}finally{V.transition=b}};exports.unstable_act=X;exports.useCallback=function(a,b){return U.current.useCallback(a,b)};exports.useContext=function(a){return U.current.useContext(a)};
	exports.useDebugValue=function(){};exports.useDeferredValue=function(a){return U.current.useDeferredValue(a)};exports.useEffect=function(a,b){return U.current.useEffect(a,b)};exports.useId=function(){return U.current.useId()};exports.useImperativeHandle=function(a,b,e){return U.current.useImperativeHandle(a,b,e)};exports.useInsertionEffect=function(a,b){return U.current.useInsertionEffect(a,b)};exports.useLayoutEffect=function(a,b){return U.current.useLayoutEffect(a,b)};
	exports.useMemo=function(a,b){return U.current.useMemo(a,b)};exports.useReducer=function(a,b,e){return U.current.useReducer(a,b,e)};exports.useRef=function(a){return U.current.useRef(a)};exports.useState=function(a){return U.current.useState(a)};exports.useSyncExternalStore=function(a,b,e){return U.current.useSyncExternalStore(a,b,e)};exports.useTransition=function(){return U.current.useTransition()};exports.version="18.3.1";


/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.autoprefix = undefined;
	
	var _forOwn2 = __webpack_require__(219);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transforms = {
	  borderRadius: function borderRadius(value) {
	    return {
	      msBorderRadius: value,
	      MozBorderRadius: value,
	      OBorderRadius: value,
	      WebkitBorderRadius: value,
	      borderRadius: value
	    };
	  },
	  boxShadow: function boxShadow(value) {
	    return {
	      msBoxShadow: value,
	      MozBoxShadow: value,
	      OBoxShadow: value,
	      WebkitBoxShadow: value,
	      boxShadow: value
	    };
	  },
	  userSelect: function userSelect(value) {
	    return {
	      WebkitTouchCallout: value,
	      KhtmlUserSelect: value,
	      MozUserSelect: value,
	      msUserSelect: value,
	      WebkitUserSelect: value,
	      userSelect: value
	    };
	  },
	
	  flex: function flex(value) {
	    return {
	      WebkitBoxFlex: value,
	      MozBoxFlex: value,
	      WebkitFlex: value,
	      msFlex: value,
	      flex: value
	    };
	  },
	  flexBasis: function flexBasis(value) {
	    return {
	      WebkitFlexBasis: value,
	      flexBasis: value
	    };
	  },
	  justifyContent: function justifyContent(value) {
	    return {
	      WebkitJustifyContent: value,
	      justifyContent: value
	    };
	  },
	
	  transition: function transition(value) {
	    return {
	      msTransition: value,
	      MozTransition: value,
	      OTransition: value,
	      WebkitTransition: value,
	      transition: value
	    };
	  },
	
	  transform: function transform(value) {
	    return {
	      msTransform: value,
	      MozTransform: value,
	      OTransform: value,
	      WebkitTransform: value,
	      transform: value
	    };
	  },
	  absolute: function absolute(value) {
	    var direction = value && value.split(' ');
	    return {
	      position: 'absolute',
	      top: direction && direction[0],
	      right: direction && direction[1],
	      bottom: direction && direction[2],
	      left: direction && direction[3]
	    };
	  },
	  extend: function extend(name, otherElementStyles) {
	    var otherStyle = otherElementStyles[name];
	    if (otherStyle) {
	      return otherStyle;
	    }
	    return {
	      'extend': name
	    };
	  }
	};
	
	var autoprefix = exports.autoprefix = function autoprefix(elements) {
	  var prefixed = {};
	  (0, _forOwn3.default)(elements, function (styles, element) {
	    var expanded = {};
	    (0, _forOwn3.default)(styles, function (value, key) {
	      var transform = transforms[key];
	      if (transform) {
	        expanded = _extends({}, expanded, transform(value));
	      } else {
	        expanded[key] = value;
	      }
	    });
	    prefixed[element] = expanded;
	  });
	  return prefixed;
	};
	
	exports.default = autoprefix;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.active = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var active = exports.active = function active(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Active, _React$Component);
	
	    function Active() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Active);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
	        return _this.setState({ active: true });
	      }, _this.handleMouseUp = function () {
	        return _this.setState({ active: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Active;
	  }(_react2.default.Component);
	};
	
	exports.default = active;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hover = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hover = exports.hover = function hover(Component) {
	  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
	
	  return function (_React$Component) {
	    _inherits(Hover, _React$Component);
	
	    function Hover() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Hover);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
	        return _this.setState({ hover: true });
	      }, _this.handleMouseOut = function () {
	        return _this.setState({ hover: false });
	      }, _this.render = function () {
	        return _react2.default.createElement(
	          Span,
	          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
	          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
	        );
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    return Hover;
	  }(_react2.default.Component);
	};
	
	exports.default = hover;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flattenNames = undefined;
	
	var _isString2 = __webpack_require__(1002);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _forOwn2 = __webpack_require__(219);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _isPlainObject2 = __webpack_require__(222);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _map2 = __webpack_require__(76);
	
	var _map3 = _interopRequireDefault(_map2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flattenNames = exports.flattenNames = function flattenNames() {
	  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var names = [];
	
	  (0, _map3.default)(things, function (thing) {
	    if (Array.isArray(thing)) {
	      flattenNames(thing).map(function (name) {
	        return names.push(name);
	      });
	    } else if ((0, _isPlainObject3.default)(thing)) {
	      (0, _forOwn3.default)(thing, function (value, key) {
	        value === true && names.push(key);
	        names.push(key + '-' + value);
	      });
	    } else if ((0, _isString3.default)(thing)) {
	      names.push(thing);
	    }
	  });
	
	  return names;
	};
	
	exports.default = flattenNames;

/***/ },
/* 1154 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var loopable = function loopable(i, length) {
	  var props = {};
	  var setProp = function setProp(name) {
	    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    props[name] = value;
	  };
	
	  i === 0 && setProp('first-child');
	  i === length - 1 && setProp('last-child');
	  (i === 0 || i % 2 === 0) && setProp('even');
	  Math.abs(i % 2) === 1 && setProp('odd');
	  setProp('nth-child', i);
	
	  return props;
	};
	
	exports.default = loopable;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mergeClasses = undefined;
	
	var _forOwn2 = __webpack_require__(219);
	
	var _forOwn3 = _interopRequireDefault(_forOwn2);
	
	var _cloneDeep2 = __webpack_require__(997);
	
	var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
	  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
	  activeNames.map(function (name) {
	    var toMerge = classes[name];
	    if (toMerge) {
	      (0, _forOwn3.default)(toMerge, function (value, key) {
	        if (!styles[key]) {
	          styles[key] = {};
	        }
	
	        styles[key] = _extends({}, styles[key], toMerge[key]);
	      });
	    }
	
	    return name;
	  });
	  return styles;
	};
	
	exports.default = mergeClasses;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = __webpack_require__(282)['default'];
	
	var _regeneratorRuntime = __webpack_require__(283)['default'];
	
	var _interopRequireDefault = __webpack_require__(194)['default'];
	
	exports.__esModule = true;
	
	var _isomorphicFetch = __webpack_require__(304);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _lodashIsplainobject = __webpack_require__(306);
	
	var _lodashIsplainobject2 = _interopRequireDefault(_lodashIsplainobject);
	
	var _CALL_API = __webpack_require__(232);
	
	var _CALL_API2 = _interopRequireDefault(_CALL_API);
	
	var _validation = __webpack_require__(498);
	
	var _errors = __webpack_require__(233);
	
	var _util = __webpack_require__(497);
	
	/**
	 * A Redux middleware that processes RSAA actions.
	 *
	 * @type {ReduxMiddleware}
	 * @access public
	 */
	function apiMiddleware(_ref) {
	  var _this = this;
	
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function callee$2$0(action) {
	      var validationErrors, _callAPI, _requestType, callAPI, endpoint, headers, method, body, credentials, bailout, types, _normalizeTypeDescriptors, requestType, successType, failureType, res;
	
	      return _regeneratorRuntime.async(function callee$2$0$(context$3$0) {
	        while (1) switch (context$3$0.prev = context$3$0.next) {
	          case 0:
	            if (_validation.isRSAA(action)) {
	              context$3$0.next = 2;
	              break;
	            }
	
	            return context$3$0.abrupt('return', next(action));
	
	          case 2:
	            validationErrors = _validation.validateRSAA(action);
	
	            if (!validationErrors.length) {
	              context$3$0.next = 7;
	              break;
	            }
	
	            _callAPI = action[_CALL_API2['default']];
	
	            if (_callAPI.types && Array.isArray(_callAPI.types)) {
	              _requestType = _callAPI.types[0];
	
	              if (_requestType && _requestType.type) {
	                _requestType = _requestType.type;
	              }
	              next({
	                type: _requestType,
	                payload: new _errors.InvalidRSAA(validationErrors),
	                error: true
	              });
	            }
	            return context$3$0.abrupt('return');
	
	          case 7:
	            callAPI = action[_CALL_API2['default']];
	            endpoint = callAPI.endpoint;
	            headers = callAPI.headers;
	            method = callAPI.method;
	            body = callAPI.body;
	            credentials = callAPI.credentials;
	            bailout = callAPI.bailout;
	            types = callAPI.types;
	            _normalizeTypeDescriptors = _util.normalizeTypeDescriptors(types);
	            requestType = _normalizeTypeDescriptors[0];
	            successType = _normalizeTypeDescriptors[1];
	            failureType = _normalizeTypeDescriptors[2];
	            context$3$0.prev = 19;
	
	            if (!(typeof bailout === 'boolean' && bailout || typeof bailout === 'function' && bailout(getState()))) {
	              context$3$0.next = 22;
	              break;
	            }
	
	            return context$3$0.abrupt('return');
	
	          case 22:
	            context$3$0.next = 30;
	            break;
	
	          case 24:
	            context$3$0.prev = 24;
	            context$3$0.t0 = context$3$0['catch'](19);
	            context$3$0.next = 28;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError('[CALL_API].bailout function failed'),
	              error: true
	            }), [action, getState()]));
	
	          case 28:
	            context$3$0.t1 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t1));
	
	          case 30:
	            if (!(typeof endpoint === 'function')) {
	              context$3$0.next = 41;
	              break;
	            }
	
	            context$3$0.prev = 31;
	
	            endpoint = endpoint(getState());
	            context$3$0.next = 41;
	            break;
	
	          case 35:
	            context$3$0.prev = 35;
	            context$3$0.t2 = context$3$0['catch'](31);
	            context$3$0.next = 39;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError('[CALL_API].endpoint function failed'),
	              error: true
	            }), [action, getState()]));
	
	          case 39:
	            context$3$0.t3 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t3));
	
	          case 41:
	            if (!(typeof headers === 'function')) {
	              context$3$0.next = 52;
	              break;
	            }
	
	            context$3$0.prev = 42;
	
	            headers = headers(getState());
	            context$3$0.next = 52;
	            break;
	
	          case 46:
	            context$3$0.prev = 46;
	            context$3$0.t4 = context$3$0['catch'](42);
	            context$3$0.next = 50;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError('[CALL_API].headers function failed'),
	              error: true
	            }), [action, getState()]));
	
	          case 50:
	            context$3$0.t5 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t5));
	
	          case 52:
	            context$3$0.next = 54;
	            return _regeneratorRuntime.awrap(_util.actionWith(requestType, [action, getState()]));
	
	          case 54:
	            context$3$0.t6 = context$3$0.sent;
	            next(context$3$0.t6);
	            context$3$0.prev = 56;
	            context$3$0.next = 59;
	            return _regeneratorRuntime.awrap(_isomorphicFetch2['default'](endpoint, { method: method, body: body, credentials: credentials, headers: headers }));
	
	          case 59:
	            res = context$3$0.sent;
	            context$3$0.next = 68;
	            break;
	
	          case 62:
	            context$3$0.prev = 62;
	            context$3$0.t7 = context$3$0['catch'](56);
	            context$3$0.next = 66;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, requestType, {
	              payload: new _errors.RequestError(context$3$0.t7.message),
	              error: true
	            }), [action, getState()]));
	
	          case 66:
	            context$3$0.t8 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t8));
	
	          case 68:
	            if (!res.ok) {
	              context$3$0.next = 75;
	              break;
	            }
	
	            context$3$0.next = 71;
	            return _regeneratorRuntime.awrap(_util.actionWith(successType, [action, getState(), res]));
	
	          case 71:
	            context$3$0.t9 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t9));
	
	          case 75:
	            context$3$0.next = 77;
	            return _regeneratorRuntime.awrap(_util.actionWith(_extends({}, failureType, {
	              error: true
	            }), [action, getState(), res]));
	
	          case 77:
	            context$3$0.t10 = context$3$0.sent;
	            return context$3$0.abrupt('return', next(context$3$0.t10));
	
	          case 79:
	          case 'end':
	            return context$3$0.stop();
	        }
	      }, null, _this, [[19, 24], [31, 35], [42, 46], [56, 62]]);
	    };
	  };
	}
	
	exports.apiMiddleware = apiMiddleware;
	
	// Do not process actions without a [CALL_API] property
	
	// Try to dispatch an error request FSA for invalid RSAAs
	
	// Parse the validated RSAA action
	
	// Should we bail out?
	
	// Process [CALL_API].endpoint function
	
	// Process [CALL_API].headers function
	
	// We can now dispatch the request FSA
	
	// Make the API call
	
	// The request was malformed, or there was a network error
	
	// Process the server response

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(209);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(158);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (!(0, _isValid2.default)(errors)) {
	        stop(errors);
	        return Promise.reject();
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	exports.default = asyncValidation;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createAll;
	
	var _reducer = __webpack_require__(236);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _createReduxForm = __webpack_require__(1161);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _mapValues = __webpack_require__(235);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _bindActionData = __webpack_require__(500);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _actions = __webpack_require__(499);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _actionTypes = __webpack_require__(234);
	
	var actionTypes = _interopRequireWildcard(_actionTypes);
	
	var _createPropTypes = __webpack_require__(1160);
	
	var _createPropTypes2 = _interopRequireDefault(_createPropTypes);
	
	var _getValuesFromState = __webpack_require__(508);
	
	var _getValuesFromState2 = _interopRequireDefault(_getValuesFromState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// bind form as first parameter of action creators
	var boundActions = _extends({}, (0, _mapValues2.default)(_extends({}, actions, {
	  autofillWithKey: function autofillWithKey(key) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _bindActionData2.default)(actions.autofill, { key: key }).apply(undefined, args);
	  },
	  changeWithKey: function changeWithKey(key) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return (0, _bindActionData2.default)(actions.change, { key: key }).apply(undefined, args);
	  },
	  initializeWithKey: function initializeWithKey(key) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return (0, _bindActionData2.default)(actions.initialize, { key: key }).apply(undefined, args);
	  },
	  reset: function reset(key) {
	    return (0, _bindActionData2.default)(actions.reset, { key: key })();
	  },
	  touchWithKey: function touchWithKey(key) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return (0, _bindActionData2.default)(actions.touch, { key: key }).apply(undefined, args);
	  },
	  untouchWithKey: function untouchWithKey(key) {
	    for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	      args[_key5 - 1] = arguments[_key5];
	    }
	
	    return (0, _bindActionData2.default)(actions.untouch, { key: key }).apply(undefined, args);
	  },
	  destroy: function destroy(key) {
	    return (0, _bindActionData2.default)(actions.destroy, { key: key })();
	  }
	}), function (action) {
	  return function (form) {
	    for (var _len6 = arguments.length, args = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	      args[_key6 - 1] = arguments[_key6];
	    }
	
	    return (0, _bindActionData2.default)(action, { form: form }).apply(undefined, args);
	  };
	}));
	
	var addArrayValue = boundActions.addArrayValue;
	var autofill = boundActions.autofill;
	var autofillWithKey = boundActions.autofillWithKey;
	var blur = boundActions.blur;
	var change = boundActions.change;
	var changeWithKey = boundActions.changeWithKey;
	var destroy = boundActions.destroy;
	var focus = boundActions.focus;
	var initialize = boundActions.initialize;
	var initializeWithKey = boundActions.initializeWithKey;
	var removeArrayValue = boundActions.removeArrayValue;
	var reset = boundActions.reset;
	var startAsyncValidation = boundActions.startAsyncValidation;
	var startSubmit = boundActions.startSubmit;
	var stopAsyncValidation = boundActions.stopAsyncValidation;
	var stopSubmit = boundActions.stopSubmit;
	var submitFailed = boundActions.submitFailed;
	var swapArrayValues = boundActions.swapArrayValues;
	var touch = boundActions.touch;
	var touchWithKey = boundActions.touchWithKey;
	var untouch = boundActions.untouch;
	var untouchWithKey = boundActions.untouchWithKey;
	
	function createAll(isReactNative, React, connect) {
	  return {
	    actionTypes: actionTypes,
	    addArrayValue: addArrayValue,
	    autofill: autofill,
	    autofillWithKey: autofillWithKey,
	    blur: blur,
	    change: change,
	    changeWithKey: changeWithKey,
	    destroy: destroy,
	    focus: focus,
	    getValues: _getValuesFromState2.default,
	    initialize: initialize,
	    initializeWithKey: initializeWithKey,
	    propTypes: (0, _createPropTypes2.default)(),
	    reduxForm: (0, _createReduxForm2.default)(isReactNative, React, connect),
	    reducer: _reducer2.default,
	    removeArrayValue: removeArrayValue,
	    reset: reset,
	    startAsyncValidation: startAsyncValidation,
	    startSubmit: startSubmit,
	    stopAsyncValidation: stopAsyncValidation,
	    stopSubmit: stopSubmit,
	    submitFailed: submitFailed,
	    swapArrayValues: swapArrayValues,
	    touch: touch,
	    touchWithKey: touchWithKey,
	    untouch: untouch,
	    untouchWithKey: untouchWithKey
	  };
	}

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(499);
	
	var importedActions = _interopRequireWildcard(_actions);
	
	var _getDisplayName = __webpack_require__(506);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _reducer = __webpack_require__(236);
	
	var _deepEqual = __webpack_require__(295);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _bindActionData = __webpack_require__(500);
	
	var _bindActionData2 = _interopRequireDefault(_bindActionData);
	
	var _getValues = __webpack_require__(507);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _isValid = __webpack_require__(158);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _readFields = __webpack_require__(1173);
	
	var _readFields2 = _interopRequireDefault(_readFields);
	
	var _handleSubmit2 = __webpack_require__(1168);
	
	var _handleSubmit3 = _interopRequireDefault(_handleSubmit2);
	
	var _asyncValidation = __webpack_require__(1157);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _silenceEvents = __webpack_require__(1167);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _silenceEvent = __webpack_require__(505);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _wrapMapDispatchToProps = __webpack_require__(1179);
	
	var _wrapMapDispatchToProps2 = _interopRequireDefault(_wrapMapDispatchToProps);
	
	var _wrapMapStateToProps = __webpack_require__(1180);
	
	var _wrapMapStateToProps2 = _interopRequireDefault(_wrapMapStateToProps);
	
	var _createInitialState = __webpack_require__(501);
	
	var _createInitialState2 = _interopRequireDefault(_createInitialState);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Creates a HOC that knows how to create redux-connected sub-components.
	 */
	var createHigherOrderComponent = function createHigherOrderComponent(config, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	  var Component = React.Component;
	
	  return function (reduxMountPoint, formName, formKey, getFormState) {
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxForm = function (_Component) {
	      _inherits(ReduxForm, _Component);
	
	      function ReduxForm(props) {
	        _classCallCheck(this, ReduxForm);
	
	        // bind functions
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.asyncValidate = _this.asyncValidate.bind(_this);
	        _this.handleSubmit = _this.handleSubmit.bind(_this);
	        var _this$props = _this.props,
	            initialValues = _this$props.initialValues,
	            submitPassback = _this$props.submitPassback;
	        // Check if form state was initialized, if not, initialize it.
	
	        var form = (0, _deepEqual2.default)(props.form, _reducer.initialState) ? (0, _createInitialState2.default)(initialValues, config.fields, {}, true, false) : props.form;
	        _this.fields = (0, _readFields2.default)(_extends({}, props, { form: form }), {}, {}, _this.asyncValidate, isReactNative);
	        submitPassback(function () {
	          return _this.handleSubmit();
	        }); // wrapped in function to disallow params
	        return _this;
	      }
	
	      ReduxForm.prototype.componentWillMount = function componentWillMount() {
	        var _props = this.props,
	            fields = _props.fields,
	            form = _props.form,
	            initialize = _props.initialize,
	            initialValues = _props.initialValues;
	
	        if (initialValues && !form._initialized) {
	          initialize(initialValues, fields);
	        }
	      };
	
	      ReduxForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!(0, _deepEqual2.default)(this.props.fields, nextProps.fields) || !(0, _deepEqual2.default)(this.props.form, nextProps.form, { strict: true })) {
	          this.fields = (0, _readFields2.default)(nextProps, this.props, this.fields, this.asyncValidate, isReactNative);
	        }
	        if (!(0, _deepEqual2.default)(this.props.initialValues, nextProps.initialValues)) {
	          this.props.initialize(nextProps.initialValues, nextProps.fields, this.props.overwriteOnInitialValuesChange || !this.props.form._initialized);
	        }
	      };
	
	      ReduxForm.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (config.destroyOnUnmount) {
	          this.props.destroy();
	        }
	      };
	
	      ReduxForm.prototype.asyncValidate = function asyncValidate(name, value) {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            alwaysAsyncValidate = _props2.alwaysAsyncValidate,
	            asyncValidate = _props2.asyncValidate,
	            dispatch = _props2.dispatch,
	            fields = _props2.fields,
	            form = _props2.form,
	            startAsyncValidation = _props2.startAsyncValidation,
	            stopAsyncValidation = _props2.stopAsyncValidation,
	            validate = _props2.validate;
	
	        var isSubmitting = !name;
	        if (asyncValidate) {
	          var values = (0, _getValues2.default)(fields, form);
	          if (name) {
	            values[name] = value;
	          }
	          var syncErrors = validate(values, this.props);
	          var allPristine = this.fields._meta.allPristine;
	
	          var initialized = form._initialized;
	
	          // if blur validating, only run async validate if sync validation passes
	          // and submitting (not blur validation) or form is dirty or form was never initialized
	          // unless alwaysAsyncValidate is true
	          var syncValidationPasses = isSubmitting || (0, _isValid2.default)(syncErrors[name]);
	          if (alwaysAsyncValidate || syncValidationPasses && (isSubmitting || !allPristine || !initialized)) {
	            return (0, _asyncValidation2.default)(function () {
	              return asyncValidate(values, dispatch, _this2.props);
	            }, startAsyncValidation, stopAsyncValidation, name);
	          }
	        }
	      };
	
	      ReduxForm.prototype.handleSubmit = function handleSubmit(submitOrEvent) {
	        var _this3 = this;
	
	        var _props3 = this.props,
	            onSubmit = _props3.onSubmit,
	            fields = _props3.fields,
	            form = _props3.form;
	
	        var check = function check(submit) {
	          if (!submit || typeof submit !== 'function') {
	            throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	          }
	          return submit;
	        };
	        return !submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent) ?
	        // submitOrEvent is an event: fire submit
	        (0, _handleSubmit3.default)(check(onSubmit), (0, _getValues2.default)(fields, form), this.props, this.asyncValidate) :
	        // submitOrEvent is the submit function: return deferred submit thunk
	        (0, _silenceEvents2.default)(function () {
	          return (0, _handleSubmit3.default)(check(submitOrEvent), (0, _getValues2.default)(fields, form), _this3.props, _this3.asyncValidate);
	        });
	      };
	
	      ReduxForm.prototype.render = function render() {
	        var _this4 = this,
	            _ref2;
	
	        var allFields = this.fields;
	
	        var _props4 = this.props,
	            addArrayValue = _props4.addArrayValue,
	            asyncBlurFields = _props4.asyncBlurFields,
	            autofill = _props4.autofill,
	            blur = _props4.blur,
	            change = _props4.change,
	            destroy = _props4.destroy,
	            focus = _props4.focus,
	            fields = _props4.fields,
	            form = _props4.form,
	            initialValues = _props4.initialValues,
	            initialize = _props4.initialize,
	            onSubmit = _props4.onSubmit,
	            propNamespace = _props4.propNamespace,
	            reset = _props4.reset,
	            removeArrayValue = _props4.removeArrayValue,
	            returnRejectedSubmitPromise = _props4.returnRejectedSubmitPromise,
	            startAsyncValidation = _props4.startAsyncValidation,
	            startSubmit = _props4.startSubmit,
	            stopAsyncValidation = _props4.stopAsyncValidation,
	            stopSubmit = _props4.stopSubmit,
	            submitFailed = _props4.submitFailed,
	            swapArrayValues = _props4.swapArrayValues,
	            touch = _props4.touch,
	            untouch = _props4.untouch,
	            validate = _props4.validate,
	            passableProps = _objectWithoutProperties(_props4, ['addArrayValue', 'asyncBlurFields', 'autofill', 'blur', 'change', 'destroy', 'focus', 'fields', 'form', 'initialValues', 'initialize', 'onSubmit', 'propNamespace', 'reset', 'removeArrayValue', 'returnRejectedSubmitPromise', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitFailed', 'swapArrayValues', 'touch', 'untouch', 'validate']); // eslint-disable-line no-redeclare
	
	
	        var _allFields$_meta = allFields._meta,
	            allPristine = _allFields$_meta.allPristine,
	            allValid = _allFields$_meta.allValid,
	            errors = _allFields$_meta.errors,
	            formError = _allFields$_meta.formError,
	            values = _allFields$_meta.values;
	
	
	        var props = {
	          // State:
	          active: form._active,
	          asyncValidating: form._asyncValidating,
	          dirty: !allPristine,
	          error: formError,
	          errors: errors,
	          fields: allFields,
	          formKey: formKey,
	          invalid: !allValid,
	          pristine: allPristine,
	          submitting: form._submitting,
	          submitFailed: form._submitFailed,
	          valid: allValid,
	          values: values,
	
	          // Actions:
	          asyncValidate: (0, _silenceEvents2.default)(function () {
	            return _this4.asyncValidate();
	          }),
	          // ^ doesn't just pass this.asyncValidate to disallow values passing
	          destroyForm: (0, _silenceEvents2.default)(destroy),
	          handleSubmit: this.handleSubmit,
	          initializeForm: (0, _silenceEvents2.default)(function (initValues) {
	            return initialize(initValues, fields);
	          }),
	          resetForm: (0, _silenceEvents2.default)(reset),
	          touch: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, arguments);
	          }),
	          touchAll: (0, _silenceEvents2.default)(function () {
	            return touch.apply(undefined, fields);
	          }),
	          untouch: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, arguments);
	          }),
	          untouchAll: (0, _silenceEvents2.default)(function () {
	            return untouch.apply(undefined, fields);
	          })
	        };
	        var passedProps = propNamespace ? (_ref2 = {}, _ref2[propNamespace] = props, _ref2) : props;
	        if (withRef) {
	          return React.createElement(WrappedComponent, _extends({}, _extends({}, passableProps, passedProps), { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(WrappedComponent, _extends({}, passableProps, passedProps));
	      };
	
	      return ReduxForm;
	    }(Component);
	
	    ReduxForm.displayName = 'ReduxForm(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxForm.WrappedComponent = WrappedComponent;
	    ReduxForm.propTypes = {
	      // props:
	      alwaysAsyncValidate: _propTypes2.default.bool,
	      asyncBlurFields: _propTypes2.default.arrayOf(_propTypes2.default.string),
	      asyncValidate: _propTypes2.default.func,
	      dispatch: _propTypes2.default.func.isRequired,
	      fields: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	      form: _propTypes2.default.object,
	      initialValues: _propTypes2.default.any,
	      onSubmit: _propTypes2.default.func,
	      onSubmitSuccess: _propTypes2.default.func,
	      onSubmitFail: _propTypes2.default.func,
	      overwriteOnInitialValuesChange: _propTypes2.default.bool.isRequired,
	      propNamespace: _propTypes2.default.string,
	      readonly: _propTypes2.default.bool,
	      returnRejectedSubmitPromise: _propTypes2.default.bool,
	      submitPassback: _propTypes2.default.func.isRequired,
	      validate: _propTypes2.default.func,
	
	      // actions:
	      addArrayValue: _propTypes2.default.func.isRequired,
	      autofill: _propTypes2.default.func.isRequired,
	      blur: _propTypes2.default.func.isRequired,
	      change: _propTypes2.default.func.isRequired,
	      destroy: _propTypes2.default.func.isRequired,
	      focus: _propTypes2.default.func.isRequired,
	      initialize: _propTypes2.default.func.isRequired,
	      removeArrayValue: _propTypes2.default.func.isRequired,
	      reset: _propTypes2.default.func.isRequired,
	      startAsyncValidation: _propTypes2.default.func.isRequired,
	      startSubmit: _propTypes2.default.func.isRequired,
	      stopAsyncValidation: _propTypes2.default.func.isRequired,
	      stopSubmit: _propTypes2.default.func.isRequired,
	      submitFailed: _propTypes2.default.func.isRequired,
	      swapArrayValues: _propTypes2.default.func.isRequired,
	      touch: _propTypes2.default.func.isRequired,
	      untouch: _propTypes2.default.func.isRequired
	    };
	    ReduxForm.defaultProps = {
	      asyncBlurFields: [],
	      form: _reducer.initialState,
	      readonly: false,
	      returnRejectedSubmitPromise: false,
	      validate: function validate() {
	        return {};
	      }
	    };
	
	    // bind touch flags to blur and change
	    var unboundActions = _extends({}, importedActions, {
	      blur: (0, _bindActionData2.default)(importedActions.blur, {
	        touch: !!config.touchOnBlur
	      }),
	      change: (0, _bindActionData2.default)(importedActions.change, {
	        touch: !!config.touchOnChange
	      })
	    });
	
	    // make redux connector with or without form key
	    var decorate = formKey !== undefined && formKey !== null ? connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName] && formState[formName][formKey];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, {
	      form: formName,
	      key: formKey
	    })), mergeProps, options) : connect((0, _wrapMapStateToProps2.default)(mapStateToProps, function (state) {
	      var formState = getFormState(state, reduxMountPoint);
	      if (!formState) {
	        throw new Error('You need to mount the redux-form reducer at "' + reduxMountPoint + '"');
	      }
	      return formState && formState[formName];
	    }), (0, _wrapMapDispatchToProps2.default)(mapDispatchToProps, (0, _bindActionData2.default)(unboundActions, { form: formName })), mergeProps, options);
	
	    return decorate(ReduxForm);
	  };
	};
	
	exports.default = createHigherOrderComponent;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createPropTypes = function createPropTypes() {
	  return {
	    // State:
	    active: _propTypes2.default.string, // currently active field
	    asyncValidating: _propTypes2.default.bool.isRequired, // true if async validation is running
	    autofilled: _propTypes2.default.bool, // true if set programmatically by autofill
	    dirty: _propTypes2.default.bool.isRequired, // true if any values are different from initialValues
	    error: _propTypes2.default.any, // form-wide error from '_error' key in validation result
	    errors: _propTypes2.default.object, // a map of errors corresponding to structure of form data (result of validation)
	    fields: _propTypes2.default.object.isRequired, // the map of fields
	    formKey: _propTypes2.default.any, // the form key if one was provided (used when doing multirecord forms)
	    invalid: _propTypes2.default.bool.isRequired, // true if there are any validation errors
	    pristine: _propTypes2.default.bool.isRequired, // true if the values are the same as initialValues
	    submitting: _propTypes2.default.bool.isRequired, // true if the form is in the process of being submitted
	    submitFailed: _propTypes2.default.bool.isRequired, // true if the form was submitted and failed for any reason
	    valid: _propTypes2.default.bool.isRequired, // true if there are no validation errors
	    values: _propTypes2.default.object.isRequired, // the values of the form as they will be submitted
	
	    // Actions:
	    asyncValidate: _propTypes2.default.func.isRequired, // function to trigger async validation
	    destroyForm: _propTypes2.default.func.isRequired, // action to destroy the form's data in Redux
	    handleSubmit: _propTypes2.default.func.isRequired, // function to submit the form
	    initializeForm: _propTypes2.default.func.isRequired, // action to initialize form data
	    resetForm: _propTypes2.default.func.isRequired, // action to reset the form data to previously initialized values
	    touch: _propTypes2.default.func.isRequired, // action to mark fields as touched
	    touchAll: _propTypes2.default.func.isRequired, // action to mark ALL fields as touched
	    untouch: _propTypes2.default.func.isRequired, // action to mark fields as untouched
	    untouchAll: _propTypes2.default.func.isRequired // action to mark ALL fields as untouched
	  };
	};
	
	exports.default = createPropTypes;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createReduxFormConnector = __webpack_require__(1162);
	
	var _createReduxFormConnector2 = _interopRequireDefault(_createReduxFormConnector);
	
	var _hoistNonReactStatics = __webpack_require__(901);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(31);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(isReactNative, React, connect) {
	  var Component = React.Component;
	
	  var reduxFormConnector = (0, _createReduxFormConnector2.default)(isReactNative, React, connect);
	  return function (config, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    return function (WrappedComponent) {
	      var ReduxFormConnector = reduxFormConnector(WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options);
	
	      var _ref = options || {},
	          _ref$withRef = _ref.withRef,
	          withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	      var configWithDefaults = _extends({
	        overwriteOnInitialValuesChange: true,
	        touchOnBlur: true,
	        touchOnChange: false,
	        destroyOnUnmount: true
	      }, config);
	
	      var ConnectedForm = function (_Component) {
	        _inherits(ConnectedForm, _Component);
	
	        function ConnectedForm(props) {
	          _classCallCheck(this, ConnectedForm);
	
	          var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	          _this.handleSubmitPassback = _this.handleSubmitPassback.bind(_this);
	          return _this;
	        }
	
	        ConnectedForm.prototype.getWrappedInstance = function getWrappedInstance() {
	          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	          return this.refs.wrappedInstance.refs.wrappedInstance.getWrappedInstance().refs.wrappedInstance;
	        };
	
	        ConnectedForm.prototype.handleSubmitPassback = function handleSubmitPassback(submit) {
	          this.submit = submit;
	        };
	
	        ConnectedForm.prototype.render = function render() {
	          if (withRef) {
	            return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	              ref: 'wrappedInstance',
	              submitPassback: this.handleSubmitPassback }));
	          }
	          return React.createElement(ReduxFormConnector, _extends({}, configWithDefaults, this.props, {
	            submitPassback: this.handleSubmitPassback }));
	        };
	
	        return ConnectedForm;
	      }(Component);
	
	      return (0, _hoistNonReactStatics2.default)(ConnectedForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(11);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _noGetters = __webpack_require__(1103);
	
	var _noGetters2 = _interopRequireDefault(_noGetters);
	
	var _getDisplayName = __webpack_require__(506);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _createHigherOrderComponent = __webpack_require__(1159);
	
	var _createHigherOrderComponent2 = _interopRequireDefault(_createHigherOrderComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * This component tracks props that affect how the form is mounted to the store. Normally these should not change,
	 * but if they do, the connected components below it need to be redefined.
	 */
	var createReduxFormConnector = function createReduxFormConnector(isReactNative, React, connect) {
	  return function (WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options) {
	    var Component = React.Component;
	
	    var _ref = options || {},
	        _ref$withRef = _ref.withRef,
	        withRef = _ref$withRef === undefined ? false : _ref$withRef;
	
	    var ReduxFormConnector = function (_Component) {
	      _inherits(ReduxFormConnector, _Component);
	
	      function ReduxFormConnector(props) {
	        _classCallCheck(this, ReduxFormConnector);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.cache = new _noGetters2.default(_this, {
	          ReduxForm: {
	            params: [
	            // props that effect how redux-form connects to the redux store
	            'reduxMountPoint', 'form', 'formKey', 'getFormState'],
	            fn: (0, _createHigherOrderComponent2.default)(props, isReactNative, React, connect, WrappedComponent, mapStateToProps, mapDispatchToProps, mergeProps, options)
	          }
	        });
	        return _this;
	      }
	
	      ReduxFormConnector.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.cache.componentWillReceiveProps(nextProps);
	      };
	
	      ReduxFormConnector.prototype.render = function render() {
	        var ReduxForm = this.cache.get('ReduxForm');
	        // remove some redux-form config-only props
	
	        var _props = this.props,
	            reduxMountPoint = _props.reduxMountPoint,
	            destroyOnUnmount = _props.destroyOnUnmount,
	            form = _props.form,
	            getFormState = _props.getFormState,
	            touchOnBlur = _props.touchOnBlur,
	            touchOnChange = _props.touchOnChange,
	            passableProps = _objectWithoutProperties(_props, ['reduxMountPoint', 'destroyOnUnmount', 'form', 'getFormState', 'touchOnBlur', 'touchOnChange']); // eslint-disable-line no-redeclare
	
	
	        if (withRef) {
	          return React.createElement(ReduxForm, _extends({}, passableProps, { ref: 'wrappedInstance' }));
	        }
	        return React.createElement(ReduxForm, passableProps);
	      };
	
	      return ReduxFormConnector;
	    }(Component);
	
	    ReduxFormConnector.displayName = 'ReduxFormConnector(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	    ReduxFormConnector.WrappedComponent = WrappedComponent;
	    ReduxFormConnector.propTypes = {
	      destroyOnUnmount: _propTypes2.default.bool,
	      reduxMountPoint: _propTypes2.default.string,
	      form: _propTypes2.default.string.isRequired,
	      formKey: _propTypes2.default.string,
	      getFormState: _propTypes2.default.func,
	      touchOnBlur: _propTypes2.default.bool,
	      touchOnChange: _propTypes2.default.bool
	    };
	    ReduxFormConnector.defaultProps = {
	      reduxMountPoint: 'form',
	      getFormState: function getFormState(state, reduxMountPoint) {
	        return state[reduxMountPoint];
	      }
	    };
	    return ReduxFormConnector;
	  };
	};
	
	exports.default = createReduxFormConnector;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(503);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnBlur = function createOnBlur(name, blur, isReactNative, afterBlur) {
	  return function (event) {
	    var value = (0, _getValue2.default)(event, isReactNative);
	    blur(name, value);
	    if (afterBlur) {
	      afterBlur(name, value);
	    }
	  };
	};
	exports.default = createOnBlur;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getValue = __webpack_require__(503);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createOnChange = function createOnChange(name, change, isReactNative) {
	  return function (event) {
	    return change(name, (0, _getValue2.default)(event, isReactNative));
	  };
	};
	exports.default = createOnChange;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createOnDragStart = __webpack_require__(502);
	
	var createOnDrop = function createOnDrop(name, change) {
	  return function (event) {
	    change(name, event.dataTransfer.getData(_createOnDragStart.dataKey));
	  };
	};
	exports.default = createOnDrop;

/***/ },
/* 1166 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var createOnFocus = function createOnFocus(name, focus) {
	  return function () {
	    return focus(name);
	  };
	};
	exports.default = createOnFocus;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _silenceEvent = __webpack_require__(505);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	
	exports.default = silenceEvents;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(209);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _isValid = __webpack_require__(158);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var handleSubmit = function handleSubmit(submit, values, props, asyncValidate) {
	  var dispatch = props.dispatch,
	      fields = props.fields,
	      onSubmitSuccess = props.onSubmitSuccess,
	      onSubmitFail = props.onSubmitFail,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      submitFailed = props.submitFailed,
	      returnRejectedSubmitPromise = props.returnRejectedSubmitPromise,
	      touch = props.touch,
	      validate = props.validate;
	
	  var syncErrors = validate(values, props);
	  touch.apply(undefined, fields); // touch all fields
	  if ((0, _isValid2.default)(syncErrors)) {
	    var doSubmit = function doSubmit() {
	      var result = submit(values, dispatch, props);
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult);
	          }
	          return submitResult;
	        }, function (submitError) {
	          stopSubmit(submitError);
	          if (onSubmitFail) {
	            onSubmitFail(submitError);
	          }
	          if (returnRejectedSubmitPromise) {
	            return Promise.reject(submitError);
	          }
	        });
	      }
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result);
	      }
	      return result;
	    };
	    var asyncValidateResult = asyncValidate();
	    return (0, _isPromise2.default)(asyncValidateResult) ?
	    // asyncValidateResult will be rejected if async validation failed
	    asyncValidateResult.then(doSubmit, function () {
	      submitFailed();
	      if (onSubmitFail) {
	        onSubmitFail();
	      }
	      return returnRejectedSubmitPromise ? Promise.reject() : Promise.resolve();
	    }) : doSubmit(); // no async validation, so submit
	  }
	  submitFailed();
	
	  if (onSubmitFail) {
	    onSubmitFail(syncErrors);
	  }
	
	  if (returnRejectedSubmitPromise) {
	    return Promise.reject(syncErrors);
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 1169 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (value) {
	  var getType = {};
	  return value && getType.toString.call(value) === '[object Function]';
	};

/***/ },
/* 1170 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isPristine;
	function isPristine(initial, data) {
	  if (initial === data) {
	    return true;
	  }
	  if (typeof initial === 'boolean' || typeof data === 'boolean') {
	    return initial === data;
	  } else if (initial instanceof Date && data instanceof Date) {
	    return initial.getTime() === data.getTime();
	  } else if (initial && typeof initial === 'object') {
	    if (!data || typeof data !== 'object') {
	      return false;
	    }
	    var initialKeys = Object.keys(initial);
	    var dataKeys = Object.keys(data);
	    if (initialKeys.length !== dataKeys.length) {
	      return false;
	    }
	    for (var index = 0; index < dataKeys.length; index++) {
	      var key = dataKeys[index];
	      if (!isPristine(initial[key], data[key])) {
	        return false;
	      }
	    }
	  } else if (initial || data) {
	    // allow '' to equate to undefined or null
	    return initial === data;
	  } else if (initial === null && data === 0 || initial === 0 && data === null) {
	    return false;
	  }
	  return true;
	}

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = normalizeFields;
	
	var _fieldValue = __webpack_require__(105);
	
	function extractKey(field) {
	  var dotIndex = field.indexOf('.');
	  var openIndex = field.indexOf('[');
	  var closeIndex = field.indexOf(']');
	
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  var isArray = openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex);
	  var key = void 0;
	  var nestedPath = void 0;
	
	  if (isArray) {
	    key = field.substring(0, openIndex);
	    nestedPath = field.substring(closeIndex + 1);
	
	    if (nestedPath[0] === '.') {
	      nestedPath = nestedPath.substring(1);
	    }
	  } else if (dotIndex > 0) {
	    key = field.substring(0, dotIndex);
	    nestedPath = field.substring(dotIndex + 1);
	  } else {
	    key = field;
	  }
	
	  return { isArray: isArray, key: key, nestedPath: nestedPath };
	}
	
	function normalizeField(field, fullFieldPath, state, previousState, values, previousValues, normalizers) {
	  if (field.isArray) {
	    if (field.nestedPath) {
	      var array = state && state[field.key] || [];
	      var previousArray = previousState && previousState[field.key] || [];
	      var nestedField = extractKey(field.nestedPath);
	
	      return array.map(function (nestedState, i) {
	        nestedState[nestedField.key] = normalizeField(nestedField, fullFieldPath, nestedState, previousArray[i], values, previousValues, normalizers);
	
	        return nestedState;
	      });
	    }
	
	    var _normalizer = normalizers[fullFieldPath];
	
	    var result = _normalizer(state && state[field.key], previousState && previousState[field.key], values, previousValues);
	    return field.isArray ? result && result.map(_fieldValue.makeFieldValue) : result;
	  } else if (field.nestedPath) {
	    var nestedState = state && state[field.key] || {};
	    var _nestedField = extractKey(field.nestedPath);
	
	    nestedState[_nestedField.key] = normalizeField(_nestedField, fullFieldPath, nestedState, previousState && previousState[field.key], values, previousValues, normalizers);
	
	    return nestedState;
	  }
	
	  var finalField = state && Object.assign({}, state[field.key] || {});
	  var normalizer = normalizers[fullFieldPath];
	
	  finalField.value = normalizer(finalField.value, previousState && previousState[field.key] && previousState[field.key].value, values, previousValues);
	
	  return (0, _fieldValue.makeFieldValue)(finalField);
	}
	
	function normalizeFields(normalizers, state, previousState, values, previousValues) {
	  var newState = Object.keys(normalizers).reduce(function (accumulator, field) {
	    var extracted = extractKey(field);
	
	    accumulator[extracted.key] = normalizeField(extracted, field, state, previousState, values, previousValues, normalizers);
	
	    return accumulator;
	  }, {});
	
	  return _extends({}, state, newState);
	}

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createOnBlur = __webpack_require__(1163);
	
	var _createOnBlur2 = _interopRequireDefault(_createOnBlur);
	
	var _createOnChange = __webpack_require__(1164);
	
	var _createOnChange2 = _interopRequireDefault(_createOnChange);
	
	var _createOnDragStart = __webpack_require__(502);
	
	var _createOnDragStart2 = _interopRequireDefault(_createOnDragStart);
	
	var _createOnDrop = __webpack_require__(1165);
	
	var _createOnDrop2 = _interopRequireDefault(_createOnDrop);
	
	var _createOnFocus = __webpack_require__(1166);
	
	var _createOnFocus2 = _interopRequireDefault(_createOnFocus);
	
	var _silencePromise = __webpack_require__(1177);
	
	var _silencePromise2 = _interopRequireDefault(_silencePromise);
	
	var _read = __webpack_require__(512);
	
	var _read2 = _interopRequireDefault(_read);
	
	var _updateField = __webpack_require__(1178);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _isChecked = __webpack_require__(511);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getSuffix(input, closeIndex) {
	  var suffix = input.substring(closeIndex + 1);
	  if (suffix[0] === '.') {
	    suffix = suffix.substring(1);
	  }
	  return suffix;
	}
	
	var getNextKey = function getNextKey(path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    return path.substring(0, openIndex);
	  }
	  return dotIndex > 0 ? path.substring(0, dotIndex) : path;
	};
	
	var shouldAsyncValidate = function shouldAsyncValidate(name, asyncBlurFields) {
	  return (
	    // remove array indices
	    ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'))
	  );
	};
	
	var readField = function readField(state, fieldName) {
	  var pathToHere = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var fields = arguments[3];
	  var syncErrors = arguments[4];
	  var asyncValidate = arguments[5];
	  var isReactNative = arguments[6];
	  var props = arguments[7];
	  var callback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : function () {
	    return null;
	  };
	  var prefix = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
	  var asyncBlurFields = props.asyncBlurFields,
	      autofill = props.autofill,
	      blur = props.blur,
	      change = props.change,
	      focus = props.focus,
	      form = props.form,
	      initialValues = props.initialValues,
	      readonly = props.readonly,
	      addArrayValue = props.addArrayValue,
	      removeArrayValue = props.removeArrayValue,
	      swapArrayValues = props.swapArrayValues;
	
	  var dotIndex = fieldName.indexOf('.');
	  var openIndex = fieldName.indexOf('[');
	  var closeIndex = fieldName.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = fieldName.substring(0, openIndex);
	    var rest = getSuffix(fieldName, closeIndex);
	    var stateArray = state && state[key] || [];
	    var fullPrefix = prefix + fieldName.substring(0, closeIndex + 1);
	    var subfields = props.fields.reduce(function (accumulator, field) {
	      if (field.indexOf(fullPrefix) === 0) {
	        accumulator.push(field);
	      }
	      return accumulator;
	    }, []).map(function (field) {
	      return getSuffix(field, prefix.length + closeIndex);
	    });
	    var addMethods = function addMethods(dest) {
	      Object.defineProperty(dest, 'addField', {
	        value: function value(_value, index) {
	          return addArrayValue(pathToHere + key, _value, index, subfields);
	        }
	      });
	      Object.defineProperty(dest, 'removeField', {
	        value: function value(index) {
	          return removeArrayValue(pathToHere + key, index);
	        }
	      });
	      Object.defineProperty(dest, 'swapFields', {
	        value: function value(indexA, indexB) {
	          return swapArrayValues(pathToHere + key, indexA, indexB);
	        }
	      });
	      return dest;
	    };
	    if (!fields[key] || fields[key].length !== stateArray.length) {
	      fields[key] = fields[key] ? [].concat(fields[key]) : [];
	      addMethods(fields[key]);
	    }
	    var fieldArray = fields[key];
	    var changed = false;
	    stateArray.forEach(function (fieldState, index) {
	      if (rest && !fieldArray[index]) {
	        fieldArray[index] = {};
	        changed = true;
	      }
	      var dest = rest ? fieldArray[index] : {};
	      var nextPath = '' + pathToHere + key + '[' + index + ']' + (rest ? '.' : '');
	      var nextPrefix = '' + prefix + key + '[]' + (rest ? '.' : '');
	
	      var result = readField(fieldState, rest, nextPath, dest, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	      if (fieldArray[index] !== result) {
	        if (rest) {
	          // if something's after [] in field name, the array item is an object field
	          // we need it to compare !== to the original (so react re-renders appropriately)
	          result = _extends({}, dest);
	        }
	        fieldArray[index] = result;
	        changed = true;
	      }
	    });
	    if (fieldArray.length > stateArray.length) {
	      // remove extra items that aren't in state array
	      fieldArray.splice(stateArray.length, fieldArray.length - stateArray.length);
	    }
	    if (changed) {
	      fieldArray = addMethods([].concat(fieldArray));
	    }
	    fields[key] = fieldArray;
	    return fieldArray;
	  }
	  if (dotIndex > 0) {
	    // subobject field
	    var _key = fieldName.substring(0, dotIndex);
	    var _rest = fieldName.substring(dotIndex + 1);
	    var subobject = fields[_key] || {};
	    var nextPath = pathToHere + _key + '.';
	    var nextKey = getNextKey(_rest);
	    var nextPrefix = prefix + _key + '.';
	    var previous = subobject[nextKey];
	    var result = readField(state[_key] || {}, _rest, nextPath, subobject, syncErrors, asyncValidate, isReactNative, props, callback, nextPrefix);
	    if (result !== previous) {
	      var _extends2;
	
	      subobject = _extends({}, subobject, (_extends2 = {}, _extends2[nextKey] = result, _extends2));
	    }
	    fields[_key] = subobject;
	    return subobject;
	  }
	  var name = pathToHere + fieldName;
	  var field = fields[fieldName] || {};
	  if (field.name !== name) {
	    var onChange = (0, _createOnChange2.default)(name, change, isReactNative);
	    var initialFormValue = (0, _read2.default)(name + '.initial', form);
	    var initialValue = initialFormValue || (0, _read2.default)(name, initialValues);
	    initialValue = initialValue === undefined ? '' : initialValue;
	    field.name = name;
	    field.checked = (0, _isChecked2.default)(initialValue);
	    field.value = initialValue;
	    field.initialValue = initialValue;
	    if (!readonly) {
	      field.autofill = function (value) {
	        return autofill(name, value);
	      };
	      field.onBlur = (0, _createOnBlur2.default)(name, blur, isReactNative, shouldAsyncValidate(name, asyncBlurFields) && function (blurName, blurValue) {
	        return (0, _silencePromise2.default)(asyncValidate(blurName, blurValue));
	      });
	      field.onChange = onChange;
	      field.onDragStart = (0, _createOnDragStart2.default)(name, function () {
	        return field.value;
	      });
	      field.onDrop = (0, _createOnDrop2.default)(name, change);
	      field.onFocus = (0, _createOnFocus2.default)(name, focus);
	      field.onUpdate = onChange; // alias to support belle. https://github.com/nikgraf/belle/issues/58
	    }
	    field.valid = true;
	    field.invalid = false;
	    Object.defineProperty(field, '_isField', { value: true });
	  }
	
	  var fieldState = (fieldName ? state[fieldName] : state) || {};
	  var syncError = (0, _read2.default)(name, syncErrors);
	  var updated = (0, _updateField2.default)(field, fieldState, name === form._active, syncError);
	  if (fieldName || fields[fieldName] !== updated) {
	    fields[fieldName] = updated;
	  }
	  callback(updated);
	  return updated;
	};
	
	exports.default = readField;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _readField = __webpack_require__(1172);
	
	var _readField2 = _interopRequireDefault(_readField);
	
	var _write = __webpack_require__(513);
	
	var _write2 = _interopRequireDefault(_write);
	
	var _getValues = __webpack_require__(507);
	
	var _getValues2 = _interopRequireDefault(_getValues);
	
	var _removeField = __webpack_require__(1174);
	
	var _removeField2 = _interopRequireDefault(_removeField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Reads props and generates (or updates) field structure
	 */
	var readFields = function readFields(props, previousProps, myFields, asyncValidate, isReactNative) {
	  var fields = props.fields,
	      form = props.form,
	      validate = props.validate;
	
	  var previousFields = previousProps.fields;
	  var values = (0, _getValues2.default)(fields, form);
	  var syncErrors = validate(values, props) || {};
	  var errors = {};
	  var formError = syncErrors._error || form._error;
	  var allValid = !formError;
	  var allPristine = true;
	  var tally = function tally(field) {
	    if (field.error) {
	      errors = (0, _write2.default)(field.name, field.error, errors);
	      allValid = false;
	    }
	    if (field.dirty) {
	      allPristine = false;
	    }
	  };
	  var fieldObjects = previousFields ? previousFields.reduce(function (accumulator, previousField) {
	    return ~fields.indexOf(previousField) ? accumulator : (0, _removeField2.default)(accumulator, previousField);
	  }, _extends({}, myFields)) : _extends({}, myFields);
	  fields.forEach(function (name) {
	    (0, _readField2.default)(form, name, undefined, fieldObjects, syncErrors, asyncValidate, isReactNative, props, tally);
	  });
	  Object.defineProperty(fieldObjects, '_meta', {
	    value: {
	      allPristine: allPristine,
	      allValid: allValid,
	      values: values,
	      errors: errors,
	      formError: formError
	    }
	  });
	  return fieldObjects;
	};
	exports.default = readFields;

/***/ },
/* 1174 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var without = function without(object, key) {
	  var copy = _extends({}, object);
	  delete copy[key];
	  return copy;
	};
	
	var removeField = function removeField(fields, path) {
	  var dotIndex = path.indexOf('.');
	  var openIndex = path.indexOf('[');
	  var closeIndex = path.indexOf(']');
	  if (openIndex > 0 && closeIndex !== openIndex + 1) {
	    throw new Error('found [ not followed by ]');
	  }
	  if (openIndex > 0 && (dotIndex < 0 || openIndex < dotIndex)) {
	    // array field
	    var key = path.substring(0, openIndex);
	    if (!Array.isArray(fields[key])) {
	      return without(fields, key);
	    }
	    var rest = path.substring(closeIndex + 1);
	    if (rest[0] === '.') {
	      rest = rest.substring(1);
	    }
	    if (rest) {
	      var _extends2;
	
	      var copy = [];
	      fields[key].forEach(function (item, index) {
	        var result = removeField(item, rest);
	        if (Object.keys(result).length) {
	          copy[index] = result;
	        }
	      });
	      return copy.length ? _extends({}, fields, (_extends2 = {}, _extends2[key] = copy, _extends2)) : without(fields, key);
	    }
	    return without(fields, key);
	  }
	  if (dotIndex > 0) {
	    var _extends3;
	
	    // subobject field
	    var _key = path.substring(0, dotIndex);
	    var _rest = path.substring(dotIndex + 1);
	    if (!fields[_key]) {
	      return fields;
	    }
	    var result = removeField(fields[_key], _rest);
	    return Object.keys(result).length ? _extends({}, fields, (_extends3 = {}, _extends3[_key] = removeField(fields[_key], _rest), _extends3)) : without(fields, _key);
	  }
	  return without(fields, path);
	};
	
	exports.default = removeField;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fieldValue = __webpack_require__(105);
	
	var reset = function reset(value) {
	  return (0, _fieldValue.makeFieldValue)(value === undefined || value && value.initial === undefined ? {} : { initial: value.initial, value: value.initial });
	};
	
	/**
	 * Sets the initial values into the state and returns a new copy of the state
	 */
	var resetState = function resetState(values) {
	  return values ? Object.keys(values).reduce(function (accumulator, key) {
	    var value = values[key];
	    if (Array.isArray(value)) {
	      accumulator[key] = value.map(function (item) {
	        return (0, _fieldValue.isFieldValue)(item) ? reset(item) : resetState(item);
	      });
	    } else if (value) {
	      if ((0, _fieldValue.isFieldValue)(value)) {
	        accumulator[key] = reset(value);
	      } else if (typeof value === 'object' && value !== null) {
	        accumulator[key] = resetState(value);
	      } else {
	        accumulator[key] = value;
	      }
	    }
	    return accumulator;
	  }, {}) : values;
	};
	
	exports.default = resetState;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldValue = __webpack_require__(105);
	
	var isMetaKey = function isMetaKey(key) {
	  return key[0] === '_';
	};
	
	/**
	 * Sets an error on a field deep in the tree, returning a new copy of the state
	 */
	var setErrors = function setErrors(state, errors, destKey) {
	  var clear = function clear() {
	    if (Array.isArray(state)) {
	      return state.map(function (stateItem, index) {
	        return setErrors(stateItem, errors && errors[index], destKey);
	      });
	    }
	    if (state && typeof state === 'object') {
	      var result = Object.keys(state).reduce(function (accumulator, key) {
	        var _extends2;
	
	        return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends2 = {}, _extends2[key] = setErrors(state[key], errors && errors[key], destKey), _extends2));
	      }, state);
	      if ((0, _fieldValue.isFieldValue)(state)) {
	        (0, _fieldValue.makeFieldValue)(result);
	      }
	      return result;
	    }
	    return (0, _fieldValue.makeFieldValue)(state);
	  };
	  if (typeof File !== 'undefined' && state instanceof File) {
	    return state;
	  }
	  if (!errors) {
	    if (!state) {
	      return state;
	    }
	    if (state[destKey]) {
	      var copy = _extends({}, state);
	      delete copy[destKey];
	      return (0, _fieldValue.makeFieldValue)(copy);
	    }
	    return clear();
	  }
	  if (typeof errors === 'string') {
	    var _extends3;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends3 = {}, _extends3[destKey] = errors, _extends3)));
	  }
	  if (Array.isArray(errors)) {
	    if (!state || Array.isArray(state)) {
	      var _copy = (state || []).map(function (stateItem, index) {
	        return setErrors(stateItem, errors[index], destKey);
	      });
	      errors.forEach(function (errorItem, index) {
	        return _copy[index] = setErrors(_copy[index], errorItem, destKey);
	      });
	      return _copy;
	    }
	    return setErrors(state, errors[0], destKey); // use first error
	  }
	  if ((0, _fieldValue.isFieldValue)(state)) {
	    var _extends4;
	
	    return (0, _fieldValue.makeFieldValue)(_extends({}, state, (_extends4 = {}, _extends4[destKey] = errors, _extends4)));
	  }
	  var errorKeys = Object.keys(errors);
	  if (!errorKeys.length && !state) {
	    return state;
	  }
	  return errorKeys.reduce(function (accumulator, key) {
	    var _extends5;
	
	    return isMetaKey(key) ? accumulator : _extends({}, accumulator, (_extends5 = {}, _extends5[key] = setErrors(state && state[key], errors[key], destKey), _extends5));
	  }, clear() || {});
	};
	
	exports.default = setErrors;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isPromise = __webpack_require__(209);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noop = function noop() {
	  return undefined;
	};
	
	var silencePromise = function silencePromise(promise) {
	  return (0, _isPromise2.default)(promise) ? promise.then(noop, noop) : promise;
	};
	
	exports.default = silencePromise;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPristine = __webpack_require__(1170);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _isValid = __webpack_require__(158);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isChecked = __webpack_require__(511);
	
	var _isChecked2 = _interopRequireDefault(_isChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Updates a field object from the store values
	 */
	var updateField = function updateField(field, formField, active, syncError) {
	  var diff = {};
	  var formFieldValue = formField.value === undefined ? '' : formField.value;
	
	  // update field value
	  if (field.value !== formFieldValue) {
	    diff.value = formFieldValue;
	    diff.checked = (0, _isChecked2.default)(formFieldValue);
	  }
	
	  // update dirty/pristine
	  var pristine = (0, _isPristine2.default)(formFieldValue, formField.initial);
	  if (field.pristine !== pristine) {
	    diff.dirty = !pristine;
	    diff.pristine = pristine;
	  }
	
	  // update field error
	  var error = syncError || formField.submitError || formField.asyncError;
	  if (error !== field.error) {
	    diff.error = error;
	  }
	  var valid = (0, _isValid2.default)(error);
	  if (field.valid !== valid) {
	    diff.invalid = !valid;
	    diff.valid = valid;
	  }
	
	  if (active !== field.active) {
	    diff.active = active;
	  }
	  var touched = !!formField.touched;
	  if (touched !== field.touched) {
	    diff.touched = touched;
	  }
	  var visited = !!formField.visited;
	  if (visited !== field.visited) {
	    diff.visited = visited;
	  }
	  var autofilled = !!formField.autofilled;
	  if (autofilled !== field.autofilled) {
	    diff.autofilled = autofilled;
	  }
	
	  if ('initial' in formField && formField.initial !== field.initialValue) {
	    field.initialValue = formField.initial;
	  }
	
	  return Object.keys(diff).length ? _extends({}, field, diff) : field;
	};
	exports.default = updateField;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(5);
	
	var _helpers = __webpack_require__(509);
	
	var wrapMapDispatchToProps = function wrapMapDispatchToProps(mapDispatchToProps, actionCreators) {
	  if (mapDispatchToProps) {
	    if (typeof mapDispatchToProps === 'function') {
	      if ((0, _helpers.getDependsOnOwnProps)(mapDispatchToProps)) {
	        return function (dispatch, ownProps) {
	          return _extends({
	            dispatch: dispatch
	          }, mapDispatchToProps(dispatch, ownProps), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	        };
	      }
	      return function (dispatch) {
	        return _extends({
	          dispatch: dispatch
	        }, mapDispatchToProps(dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	      };
	    }
	    return function (dispatch) {
	      return _extends({
	        dispatch: dispatch
	      }, (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch), (0, _redux.bindActionCreators)(actionCreators, dispatch));
	    };
	  }
	  return function (dispatch) {
	    return _extends({
	      dispatch: dispatch
	    }, (0, _redux.bindActionCreators)(actionCreators, dispatch));
	  };
	};
	
	exports.default = wrapMapDispatchToProps;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _helpers = __webpack_require__(509);
	
	var wrapMapStateToProps = function wrapMapStateToProps(mapStateToProps, getForm) {
	  if (mapStateToProps) {
	    if (typeof mapStateToProps !== 'function') {
	      throw new Error('mapStateToProps must be a function');
	    }
	    if ((0, _helpers.getDependsOnOwnProps)(mapStateToProps)) {
	      return function (state, ownProps) {
	        return _extends({}, mapStateToProps(state, ownProps), {
	          form: getForm(state)
	        });
	      };
	    }
	    return function (state) {
	      return _extends({}, mapStateToProps(state), {
	        form: getForm(state)
	      });
	    };
	  }
	  return function (state) {
	    return {
	      form: getForm(state)
	    };
	  };
	};
	
	exports.default = wrapMapStateToProps;

/***/ },
/* 1181 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(514);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1183 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(515);
	
	var _isPlainObject = __webpack_require__(222);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(516);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof process === "object" && process.domain) {
	      invoke = process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(118)))

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(115);
	var callBind = __webpack_require__(195);
	
	var implementation = __webpack_require__(517);
	var getPolyfill = __webpack_require__(518);
	var shim = __webpack_require__(1187);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(115).supportsDescriptors;
	var getPolyfill = __webpack_require__(518);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {/**
	 * @license React
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	'use strict';function f(a,b){var c=a.length;a.push(b);a:for(;0<c;){var d=c-1>>>1,e=a[d];if(0<g(e,b))a[d]=b,a[c]=e,c=d;else break a}}function h(a){return 0===a.length?null:a[0]}function k(a){if(0===a.length)return null;var b=a[0],c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length,w=e>>>1;d<w;){var m=2*(d+1)-1,C=a[m],n=m+1,x=a[n];if(0>g(C,c))n<e&&0>g(x,C)?(a[d]=x,a[n]=c,d=n):(a[d]=C,a[m]=c,d=m);else if(n<e&&0>g(x,c))a[d]=x,a[n]=c,d=n;else break a}}return b}
	function g(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}var r=[],t=[],u=1,v=null,y=3,z=!1,A=!1,B=!1,D="function"===typeof setTimeout?setTimeout:null,E="function"===typeof clearTimeout?clearTimeout:null,F="undefined"!==typeof setImmediate?setImmediate:null;
	"undefined"!==typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);function G(a){for(var b=h(t);null!==b;){if(null===b.callback)k(t);else if(b.startTime<=a)k(t),b.sortIndex=b.expirationTime,f(r,b);else break;b=h(t)}}function H(a){B=!1;G(a);if(!A)if(null!==h(r))A=!0,I(J);else{var b=h(t);null!==b&&K(H,b.startTime-a)}}
	function J(a,b){A=!1;B&&(B=!1,E(L),L=-1);z=!0;var c=y;try{G(b);for(v=h(r);null!==v&&(!(v.expirationTime>b)||a&&!M());){var d=v.callback;if("function"===typeof d){v.callback=null;y=v.priorityLevel;var e=d(v.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?v.callback=e:v===h(r)&&k(r);G(b)}else k(r);v=h(r)}if(null!==v)var w=!0;else{var m=h(t);null!==m&&K(H,m.startTime-b);w=!1}return w}finally{v=null,y=c,z=!1}}var N=!1,O=null,L=-1,P=5,Q=-1;
	function M(){return exports.unstable_now()-Q<P?!1:!0}function R(){if(null!==O){var a=exports.unstable_now();Q=a;var b=!0;try{b=O(!0,a)}finally{b?S():(N=!1,O=null)}}else N=!1}var S;if("function"===typeof F)S=function(){F(R)};else if("undefined"!==typeof MessageChannel){var T=new MessageChannel,U=T.port2;T.port1.onmessage=R;S=function(){U.postMessage(null)}}else S=function(){D(R,0)};function I(a){O=a;N||(N=!0,S())}function K(a,b){L=D(function(){a(exports.unstable_now())},b)}
	exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){A||z||(A=!0,I(J))};
	exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):P=0<a?Math.floor(1E3/a):5};exports.unstable_getCurrentPriorityLevel=function(){return y};exports.unstable_getFirstCallbackNode=function(){return h(r)};exports.unstable_next=function(a){switch(y){case 1:case 2:case 3:var b=3;break;default:b=y}var c=y;y=b;try{return a()}finally{y=c}};exports.unstable_pauseExecution=function(){};
	exports.unstable_requestPaint=function(){};exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=y;y=a;try{return b()}finally{y=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:u++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,f(t,a),null===h(r)&&a===h(t)&&(B?(E(L),L=-1):B=!0,K(H,c-d))):(a.sortIndex=e,f(r,a),A||z||(A=!0,I(J)));return a};
	exports.unstable_shouldYield=M;exports.unstable_wrapCallback=function(a){var b=y;return function(){var c=y;y=b;try{return a.apply(this,arguments)}finally{y=c}}};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(519).setImmediate))

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1188);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(118)))

/***/ },
/* 1191 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 1192 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1194);


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1195);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(121)(module)))

/***/ },
/* 1195 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.1
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function(Math) {
	
	var trimLeft = /^\s+/,
	    trimRight = /\s+$/,
	    tinyCounter = 0,
	    mathRound = Math.round,
	    mathMin = Math.min,
	    mathMax = Math.max,
	    mathRandom = Math.random;
	
	function tinycolor (color, opts) {
	
	    color = (color) ? color : '';
	    opts = opts || { };
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	       return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	        return new tinycolor(color, opts);
	    }
	
	    var rgb = inputToRGB(color);
	    this._originalInput = color,
	    this._r = rgb.r,
	    this._g = rgb.g,
	    this._b = rgb.b,
	    this._a = rgb.a,
	    this._roundA = mathRound(100*this._a) / 100,
	    this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) { this._r = mathRound(this._r); }
	    if (this._g < 1) { this._g = mathRound(this._g); }
	    if (this._b < 1) { this._b = mathRound(this._b); }
	
	    this._ok = rgb.ok;
	    this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
	    isDark: function() {
	        return this.getBrightness() < 128;
	    },
	    isLight: function() {
	        return !this.isDark();
	    },
	    isValid: function() {
	        return this._ok;
	    },
	    getOriginalInput: function() {
	      return this._originalInput;
	    },
	    getFormat: function() {
	        return this._format;
	    },
	    getAlpha: function() {
	        return this._a;
	    },
	    getBrightness: function() {
	        //http://www.w3.org/TR/AERT#color-contrast
	        var rgb = this.toRgb();
	        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function() {
	        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        var rgb = this.toRgb();
	        var RsRGB, GsRGB, BsRGB, R, G, B;
	        RsRGB = rgb.r/255;
	        GsRGB = rgb.g/255;
	        BsRGB = rgb.b/255;
	
	        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
	        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
	        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
	        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
	    },
	    setAlpha: function(value) {
	        this._a = boundAlpha(value);
	        this._roundA = mathRound(100*this._a) / 100;
	        return this;
	    },
	    toHsv: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	    },
	    toHsvString: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	        return (this._a == 1) ?
	          "hsv("  + h + ", " + s + "%, " + v + "%)" :
	          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	    },
	    toHsl: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	    },
	    toHslString: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	        return (this._a == 1) ?
	          "hsl("  + h + ", " + s + "%, " + l + "%)" :
	          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	    },
	    toHex: function(allow3Char) {
	        return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function(allow3Char) {
	        return '#' + this.toHex(allow3Char);
	    },
	    toHex8: function(allow4Char) {
	        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function(allow4Char) {
	        return '#' + this.toHex8(allow4Char);
	    },
	    toRgb: function() {
	        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	    },
	    toRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function() {
	        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	    },
	    toPercentageRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function() {
	        if (this._a === 0) {
	            return "transparent";
	        }
	
	        if (this._a < 1) {
	            return false;
	        }
	
	        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function(secondColor) {
	        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	        var secondHex8String = hex8String;
	        var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	        if (secondColor) {
	            var s = tinycolor(secondColor);
	            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	        }
	
	        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	    },
	    toString: function(format) {
	        var formatSet = !!format;
	        format = format || this._format;
	
	        var formattedString = false;
	        var hasAlpha = this._a < 1 && this._a >= 0;
	        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	
	        if (needsAlphaFormat) {
	            // Special case for "transparent", all other non-alpha formats
	            // will return rgba when there is transparency.
	            if (format === "name" && this._a === 0) {
	                return this.toName();
	            }
	            return this.toRgbString();
	        }
	        if (format === "rgb") {
	            formattedString = this.toRgbString();
	        }
	        if (format === "prgb") {
	            formattedString = this.toPercentageRgbString();
	        }
	        if (format === "hex" || format === "hex6") {
	            formattedString = this.toHexString();
	        }
	        if (format === "hex3") {
	            formattedString = this.toHexString(true);
	        }
	        if (format === "hex4") {
	            formattedString = this.toHex8String(true);
	        }
	        if (format === "hex8") {
	            formattedString = this.toHex8String();
	        }
	        if (format === "name") {
	            formattedString = this.toName();
	        }
	        if (format === "hsl") {
	            formattedString = this.toHslString();
	        }
	        if (format === "hsv") {
	            formattedString = this.toHsvString();
	        }
	
	        return formattedString || this.toHexString();
	    },
	    clone: function() {
	        return tinycolor(this.toString());
	    },
	
	    _applyModification: function(fn, args) {
	        var color = fn.apply(null, [this].concat([].slice.call(args)));
	        this._r = color._r;
	        this._g = color._g;
	        this._b = color._b;
	        this.setAlpha(color._a);
	        return this;
	    },
	    lighten: function() {
	        return this._applyModification(lighten, arguments);
	    },
	    brighten: function() {
	        return this._applyModification(brighten, arguments);
	    },
	    darken: function() {
	        return this._applyModification(darken, arguments);
	    },
	    desaturate: function() {
	        return this._applyModification(desaturate, arguments);
	    },
	    saturate: function() {
	        return this._applyModification(saturate, arguments);
	    },
	    greyscale: function() {
	        return this._applyModification(greyscale, arguments);
	    },
	    spin: function() {
	        return this._applyModification(spin, arguments);
	    },
	
	    _applyCombination: function(fn, args) {
	        return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function() {
	        return this._applyCombination(analogous, arguments);
	    },
	    complement: function() {
	        return this._applyCombination(complement, arguments);
	    },
	    monochromatic: function() {
	        return this._applyCombination(monochromatic, arguments);
	    },
	    splitcomplement: function() {
	        return this._applyCombination(splitcomplement, arguments);
	    },
	    triad: function() {
	        return this._applyCombination(triad, arguments);
	    },
	    tetrad: function() {
	        return this._applyCombination(tetrad, arguments);
	    }
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
	    if (typeof color == "object") {
	        var newColor = {};
	        for (var i in color) {
	            if (color.hasOwnProperty(i)) {
	                if (i === "a") {
	                    newColor[i] = color[i];
	                }
	                else {
	                    newColor[i] = convertToPercentage(color[i]);
	                }
	            }
	        }
	        color = newColor;
	    }
	
	    return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//     "red"
	//     "#f00" or "f00"
	//     "#ff0000" or "ff0000"
	//     "#ff000000" or "ff000000"
	//     "rgb 255 0 0" or "rgb (255, 0, 0)"
	//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
	    var rgb = { r: 0, g: 0, b: 0 };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	
	    if (typeof color == "string") {
	        color = stringInputToObject(color);
	    }
	
	    if (typeof color == "object") {
	        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	            rgb = rgbToRgb(color.r, color.g, color.b);
	            ok = true;
	            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	            s = convertToPercentage(color.s);
	            v = convertToPercentage(color.v);
	            rgb = hsvToRgb(color.h, s, v);
	            ok = true;
	            format = "hsv";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	            s = convertToPercentage(color.s);
	            l = convertToPercentage(color.l);
	            rgb = hslToRgb(color.h, s, l);
	            ok = true;
	            format = "hsl";
	        }
	
	        if (color.hasOwnProperty("a")) {
	            a = color.a;
	        }
	    }
	
	    a = boundAlpha(a);
	
	    return {
	        ok: ok,
	        format: color.format || format,
	        r: mathMin(255, mathMax(rgb.r, 0)),
	        g: mathMin(255, mathMax(rgb.g, 0)),
	        b: mathMin(255, mathMax(rgb.b, 0)),
	        a: a
	    };
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
	    return {
	        r: bound01(r, 255) * 255,
	        g: bound01(g, 255) * 255,
	        b: bound01(b, 255) * 255
	    };
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, l = (max + min) / 2;
	
	    if(max == min) {
	        h = s = 0; // achromatic
	    }
	    else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
	    var r, g, b;
	
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	
	    function hue2rgb(p, q, t) {
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    if(s === 0) {
	        r = g = b = l; // achromatic
	    }
	    else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1/3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1/3);
	    }
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, v = max;
	
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	
	    if(max == min) {
	        h = 0; // achromatic
	    }
	    else {
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	        h /= 6;
	    }
	    return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	
	    var i = Math.floor(h),
	        f = h - i,
	        p = v * (1 - s),
	        q = v * (1 - f * s),
	        t = v * (1 - (1 - f) * s),
	        mod = i % 6,
	        r = [v, q, p, p, t, v][mod],
	        g = [t, v, v, q, p, p][mod],
	        b = [p, p, t, v, v, q][mod];
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToHex`
	// Converts an RGBA color plus alpha transparency to hex
	// Assumes r, g, b are contained in the set [0, 255] and
	// a in [0, 1]. Returns a 4 or 8 character rgba hex
	function rgbaToHex(r, g, b, a, allow4Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16)),
	        pad2(convertDecimalToHex(a))
	    ];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToArgbHex`
	// Converts an RGBA color to an ARGB Hex8 string
	// Rarely used, but required for "toFilter()"
	function rgbaToArgbHex(r, g, b, a) {
	
	    var hex = [
	        pad2(convertDecimalToHex(a)),
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    return hex.join("");
	}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) { return false; }
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	
	tinycolor.random = function() {
	    return tinycolor.fromRatio({
	        r: mathRandom(),
	        g: mathRandom(),
	        b: mathRandom()
	    });
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function greyscale(color) {
	    return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	    return tinycolor(rgb);
	}
	
	function darken (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	}
	
	function triad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function tetrad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	    ];
	}
	
	function analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	
	    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	        hsl.h = (hsl.h + part) % 360;
	        ret.push(tinycolor(hsl));
	    }
	    return ret;
	}
	
	function monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	
	    while (results--) {
	        ret.push(tinycolor({ h: h, s: s, v: v}));
	        v = (v + modification) % 1;
	    }
	
	    return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
	    amount = (amount === 0) ? 0 : (amount || 50);
	
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	
	    var p = amount / 100;
	
	    var rgba = {
	        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
	        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
	        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
	        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
	    };
	
	    return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//    tinycolor.isReadable("#000", "#111") => false
	//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	tinycolor.isReadable = function(color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	
	    out = false;
	
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	        case "AAsmall":
	        case "AAAlarge":
	            out = readability >= 4.5;
	            break;
	        case "AAlarge":
	            out = readability >= 3;
	            break;
	        case "AAAsmall":
	            out = readability >= 7;
	            break;
	    }
	    return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	tinycolor.mostReadable = function(baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size ;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors ;
	    level = args.level;
	    size = args.size;
	
	    for (var i= 0; i < colorList.length ; i++) {
	        readability = tinycolor.readability(baseColor, colorList[i]);
	        if (readability > bestScore) {
	            bestScore = readability;
	            bestColor = tinycolor(colorList[i]);
	        }
	    }
	
	    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
	        return bestColor;
	    }
	    else {
	        args.includeFallbackColors=false;
	        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
	    }
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
	    var flipped = { };
	    for (var i in o) {
	        if (o.hasOwnProperty(i)) {
	            flipped[o[i]] = i;
	        }
	    }
	    return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
	    a = parseFloat(a);
	
	    if (isNaN(a) || a < 0 || a > 1) {
	        a = 1;
	    }
	
	    return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
	    if (isOnePointZero(n)) { n = "100%"; }
	
	    var processPercent = isPercentage(n);
	    n = mathMin(max, mathMax(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	        n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if ((Math.abs(n - max) < 0.000001)) {
	        return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
	    return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
	    return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
	    return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
	    return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n) {
	    if (n <= 1) {
	        n = (n * 100) + "%";
	    }
	
	    return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
	    return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	    return {
	        CSS_UNIT: new RegExp(CSS_UNIT),
	        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	})();
	
	// `isValidCSSUnit`
	// Take in a single string / number and check to see if it looks like a CSS unit
	// (see `matchers` above for definition).
	function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	}
	
	// `stringInputToObject`
	// Permissive string parsing.  Take in a number of formats, and output an object
	// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
	    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	    var named = false;
	    if (names[color]) {
	        color = names[color];
	        named = true;
	    }
	    else if (color == 'transparent') {
	        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if ((match = matchers.rgb.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3] };
	    }
	    if ((match = matchers.rgba.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsl.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3] };
	    }
	    if ((match = matchers.hsla.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsv.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3] };
	    }
	    if ((match = matchers.hsva.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3], a: match[4] };
	    }
	    if ((match = matchers.hex8.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            a: convertHexToDecimal(match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex6.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	    if ((match = matchers.hex4.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            a: convertHexToDecimal(match[4] + '' + match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex3.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	
	    return false;
	}
	
	function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {"level":"AA", "size":"small"};
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	        level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	        size = "small";
	    }
	    return {"level":level, "size":size};
	}
	
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
	    window.tinycolor = tinycolor;
	}
	
	})(Math);


/***/ },
/* 1197 */
/***/ function(module, exports) {

	tinymce.IconManager.add('default', {
	  icons: {
	    'accessibility-check': '<svg width="24" height="24"><path d="M12 2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2c0-1.1.9-2 2-2zm8 7h-5v12c0 .6-.4 1-1 1a1 1 0 01-1-1v-5c0-.6-.4-1-1-1a1 1 0 00-1 1v5c0 .6-.4 1-1 1a1 1 0 01-1-1V9H4a1 1 0 110-2h16c.6 0 1 .4 1 1s-.4 1-1 1z" fill-rule="nonzero"/></svg>',
	    'action-next': '<svg width="24" height="24"><path fill-rule="nonzero" d="M5.7 7.3a1 1 0 00-1.4 1.4l7.7 7.7 7.7-7.7a1 1 0 10-1.4-1.4L12 13.6 5.7 7.3z"/></svg>',
	    'action-prev': '<svg width="24" height="24"><path fill-rule="nonzero" d="M18.3 15.7a1 1 0 001.4-1.4L12 6.6l-7.7 7.7a1 1 0 001.4 1.4L12 9.4l6.3 6.3z"/></svg>',
	    'align-center': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm3 4h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm-3-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'align-justify': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'align-left': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'align-none': '<svg width="24" height="24"><path d="M14.2 5L13 7H5a1 1 0 110-2h9.2zm4 0h.8a1 1 0 010 2h-2l1.2-2zm-6.4 4l-1.2 2H5a1 1 0 010-2h6.8zm4 0H19a1 1 0 010 2h-4.4l1.2-2zm-6.4 4l-1.2 2H5a1 1 0 010-2h4.4zm4 0H19a1 1 0 010 2h-6.8l1.2-2zM7 17l-1.2 2H5a1 1 0 010-2h2zm4 0h8a1 1 0 010 2H9.8l1.2-2zm5.2-13.5l1.3.7-9.7 16.3-1.3-.7 9.7-16.3z" fill-rule="evenodd"/></svg>',
	    'align-right': '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm6 4h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-6-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'arrow-left': '<svg width="24" height="24"><path d="M5.6 13l12 6a1 1 0 001.4-1V6a1 1 0 00-1.4-.9l-12 6a1 1 0 000 1.8z" fill-rule="evenodd"/></svg>',
	    'arrow-right': '<svg width="24" height="24"><path d="M18.5 13l-12 6A1 1 0 015 18V6a1 1 0 011.4-.9l12 6a1 1 0 010 1.8z" fill-rule="evenodd"/></svg>',
	    'bold': '<svg width="24" height="24"><path d="M7.8 19c-.3 0-.5 0-.6-.2l-.2-.5V5.7c0-.2 0-.4.2-.5l.6-.2h5c1.5 0 2.7.3 3.5 1 .7.6 1.1 1.4 1.1 2.5a3 3 0 01-.6 1.9c-.4.6-1 1-1.6 1.2.4.1.9.3 1.3.6s.8.7 1 1.2c.4.4.5 1 .5 1.6 0 1.3-.4 2.3-1.3 3-.8.7-2.1 1-3.8 1H7.8zm5-8.3c.6 0 1.2-.1 1.6-.5.4-.3.6-.7.6-1.3 0-1.1-.8-1.7-2.3-1.7H9.3v3.5h3.4zm.5 6c.7 0 1.3-.1 1.7-.4.4-.4.6-.9.6-1.5s-.2-1-.7-1.4c-.4-.3-1-.4-2-.4H9.4v3.8h4z" fill-rule="evenodd"/></svg>',
	    'bookmark': '<svg width="24" height="24"><path d="M6 4v17l6-4 6 4V4c0-.6-.4-1-1-1H7a1 1 0 00-1 1z" fill-rule="nonzero"/></svg>',
	    'border-width': '<svg width="24" height="24"><path d="M5 14.8h14a1 1 0 010 2H5a1 1 0 010-2zm-.5 3.7h15c.3 0 .5.2.5.5s-.2.5-.5.5h-15a.5.5 0 110-1zm.5-8.3h14c.6 0 1 .4 1 1v1c0 .5-.4 1-1 1H5a1 1 0 01-1-1v-1c0-.6.4-1 1-1zm0-5.7h14c.6 0 1 .4 1 1v2c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-2c0-.6.4-1 1-1z" fill-rule="evenodd"/></svg>',
	    'brightness': '<svg width="24" height="24"><path d="M12 17c.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .3-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7v-1c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3zm0-10a1 1 0 01-.7-.3A1 1 0 0111 6V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .3-.1.5-.3.7a1 1 0 01-.7.3zm7 4c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 01-.7.3h-1a1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h1zM7 12c0 .3-.1.5-.3.7a1 1 0 01-.7.3H5a1 1 0 01-.7-.3A1 1 0 014 12c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h1c.3 0 .5.1.7.3.2.2.3.4.3.7zm10 3.5l.7.8c.2.1.3.4.3.6 0 .3-.1.6-.3.8a1 1 0 01-.8.3 1 1 0 01-.6-.3l-.8-.7a1 1 0 01-.3-.8c0-.2.1-.5.3-.7a1 1 0 011.4 0zm-10-7l-.7-.8a1 1 0 01-.3-.6c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.2 0 .5.1.7.3l.7.7c.2.2.3.5.3.8 0 .2-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.8-.3zm10 0a1 1 0 01-.8.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.6.3-.8l.8-.7c.1-.2.4-.3.6-.3.3 0 .6.1.8.3.2.2.3.5.3.8 0 .2-.1.5-.3.7l-.7.7zm-10 7c.2-.2.5-.3.8-.3.2 0 .5.1.7.3a1 1 0 010 1.4l-.8.8a1 1 0 01-.6.3 1 1 0 01-.8-.3 1 1 0 01-.3-.8c0-.2.1-.5.3-.6l.7-.8zM12 8a4 4 0 013.7 2.4 4 4 0 010 3.2A4 4 0 0112 16a4 4 0 01-3.7-2.4 4 4 0 010-3.2A4 4 0 0112 8zm0 6.5c.7 0 1.3-.2 1.8-.7.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.7-1.8-.7s-1.3.2-1.8.7c-.5.5-.7 1.1-.7 1.8s.2 1.3.7 1.8c.5.5 1.1.7 1.8.7z" fill-rule="evenodd"/></svg>',
	    'browse': '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2h-4v-2h4V8H5v10h4v2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9.4l-2.3 2.3a1 1 0 11-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 01-1.4 1.4L13 13.4V20a1 1 0 01-2 0v-6.6z" fill-rule="nonzero"/></svg>',
	    'cancel': '<svg width="24" height="24"><path d="M12 4.6a7.4 7.4 0 110 14.8 7.4 7.4 0 010-14.8zM12 3a9 9 0 100 18 9 9 0 000-18zm0 8L14.8 8l1 1.1-2.7 2.8 2.7 2.7-1.1 1.1-2.7-2.7-2.7 2.7-1-1.1 2.6-2.7-2.7-2.7 1-1.1 2.8 2.7z" fill-rule="nonzero"/></svg>',
	    'change-case': '<svg width="24" height="24"><path d="M18.4 18.2v-.6c-.5.8-1.3 1.2-2.4 1.2-2.2 0-3.3-1.6-3.3-4.8 0-3.1 1-4.7 3.3-4.7 1.1 0 1.8.3 2.4 1.1v-.6c0-.5.4-.8.8-.8s.8.3.8.8v8.4c0 .5-.4.8-.8.8a.8.8 0 01-.8-.8zm-2-7.4c-1.3 0-1.8.9-1.8 3.2 0 2.4.5 3.3 1.7 3.3 1.3 0 1.8-.9 1.8-3.2 0-2.4-.5-3.3-1.7-3.3zM10 15.7H5.5l-.8 2.6a1 1 0 01-1 .7h-.2a.7.7 0 01-.7-1l4-12a1 1 0 012 0l4 12a.7.7 0 01-.8 1h-.2a1 1 0 01-1-.7l-.8-2.6zm-.3-1.5l-2-6.5-1.9 6.5h3.9z" fill-rule="evenodd"/></svg>',
	    'character-count': '<svg width="24" height="24"><path d="M4 11.5h16v1H4v-1zm4.8-6.8V10H7.7V5.8h-1v-1h2zM11 8.3V9h2v1h-3V7.7l2-1v-.9h-2v-1h3v2.4l-2 1zm6.3-3.4V10h-3.1V9h2.1V8h-2.1V6.8h2.1v-1h-2.1v-1h3.1zM5.8 16.4c0-.5.2-.8.5-1 .2-.2.6-.3 1.2-.3l.8.1c.2 0 .4.2.5.3l.4.4v2.8l.2.3H8.2v-.1-.2l-.6.3H7c-.4 0-.7 0-1-.2a1 1 0 01-.3-.9c0-.3 0-.6.3-.8.3-.2.7-.4 1.2-.4l.6-.2h.3v-.2l-.1-.2a.8.8 0 00-.5-.1 1 1 0 00-.4 0l-.3.4h-1zm2.3.8h-.2l-.2.1-.4.1a1 1 0 00-.4.2l-.2.2.1.3.5.1h.4l.4-.4v-.6zm2-3.4h1.2v1.7l.5-.3h.5c.5 0 .9.1 1.2.5.3.4.5.8.5 1.4 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.3.6l-.6-.1-.4-.4v.4h-1.1v-5.4zm1.1 3.3c0 .3 0 .6.2.8a.7.7 0 001.2 0l.2-.8c0-.4 0-.6-.2-.8a.7.7 0 00-.6-.3l-.6.3-.2.8zm6.1-.5c0-.2 0-.3-.2-.4a.8.8 0 00-.5-.2c-.3 0-.5.1-.6.3l-.2.9c0 .3 0 .6.2.8.1.2.3.3.6.3.2 0 .4 0 .5-.2l.2-.4h1.1c0 .5-.3.8-.6 1.1a2 2 0 01-1.3.4c-.5 0-1-.2-1.3-.6a2 2 0 01-.5-1.4c0-.6.1-1.1.5-1.5.3-.4.8-.5 1.4-.5.5 0 1 0 1.2.3.4.3.5.7.5 1.2h-1v-.1z" fill-rule="evenodd"/></svg>',
	    'checklist-rtl': '<svg width="24" height="24"><path d="M5 17h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm14.2 11c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 20c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 14c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 8c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8z" fill-rule="evenodd"/></svg>',
	    'checklist': '<svg width="24" height="24"><path d="M11 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8a1 1 0 010 2h-8a1 1 0 010-2zM7.2 16c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 20c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 14c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 8c-.2.3-.7.4-1 0L3.8 6.9a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8z" fill-rule="evenodd"/></svg>',
	    'checkmark': '<svg width="24" height="24"><path d="M18.2 5.4a1 1 0 011.6 1.2l-8 12a1 1 0 01-1.5.1l-5-5a1 1 0 111.4-1.4l4.1 4.1 7.4-11z" fill-rule="nonzero"/></svg>',
	    'chevron-down': '<svg width="10" height="10"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 010-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8z" fill-rule="nonzero"/></svg>',
	    'chevron-left': '<svg width="10" height="10"><path d="M7.8 1.3L4 5l3.8 3.7c.3.3.3.8 0 1-.4.4-.9.4-1.2 0L2.2 5.7a.8.8 0 010-1.2L6.6.2C7 0 7.4 0 7.8.2c.3.3.3.8 0 1.1z" fill-rule="nonzero"/></svg>',
	    'chevron-right': '<svg width="10" height="10"><path d="M2.2 1.3a.8.8 0 010-1c.4-.4.9-.4 1.2 0l4.4 4.1c.3.4.3.9 0 1.2L3.4 9.8c-.3.3-.8.3-1.2 0a.8.8 0 010-1.1L6 5 2.2 1.3z" fill-rule="nonzero"/></svg>',
	    'chevron-up': '<svg width="10" height="10"><path d="M8.7 7.8L5 4 1.3 7.8c-.3.3-.8.3-1 0a.8.8 0 010-1.2l4.1-4.4c.3-.3.9-.3 1.2 0l4.2 4.4c.3.3.3.9 0 1.2-.3.3-.8.3-1.1 0z" fill-rule="nonzero"/></svg>',
	    'close': '<svg width="24" height="24"><path d="M17.3 8.2L13.4 12l3.9 3.8a1 1 0 01-1.5 1.5L12 13.4l-3.8 3.9a1 1 0 01-1.5-1.5l3.9-3.8-3.9-3.8a1 1 0 011.5-1.5l3.8 3.9 3.8-3.9a1 1 0 011.5 1.5z" fill-rule="evenodd"/></svg>',
	    'code-sample': '<svg width="24" height="26"><path d="M7.1 11a2.8 2.8 0 01-.8 2 2.8 2.8 0 01.8 2v1.7c0 .3.1.6.4.8.2.3.5.4.8.4.3 0 .4.2.4.4v.8c0 .2-.1.4-.4.4-.7 0-1.4-.3-2-.8-.5-.6-.8-1.3-.8-2V15c0-.3-.1-.6-.4-.8-.2-.3-.5-.4-.8-.4a.4.4 0 01-.4-.4v-.8c0-.2.2-.4.4-.4.3 0 .6-.1.8-.4.3-.2.4-.5.4-.8V9.3c0-.7.3-1.4.8-2 .6-.5 1.3-.8 2-.8.3 0 .4.2.4.4v.8c0 .2-.1.4-.4.4-.3 0-.6.1-.8.4-.3.2-.4.5-.4.8V11zm9.8 0V9.3c0-.3-.1-.6-.4-.8-.2-.3-.5-.4-.8-.4a.4.4 0 01-.4-.4V7c0-.2.1-.4.4-.4.7 0 1.4.3 2 .8.5.6.8 1.3.8 2V11c0 .3.1.6.4.8.2.3.5.4.8.4.2 0 .4.2.4.4v.8c0 .2-.2.4-.4.4-.3 0-.6.1-.8.4-.3.2-.4.5-.4.8v1.7c0 .7-.3 1.4-.8 2-.6.5-1.3.8-2 .8a.4.4 0 01-.4-.4v-.8c0-.2.1-.4.4-.4.3 0 .6-.1.8-.4.3-.2.4-.5.4-.8V15a2.8 2.8 0 01.8-2 2.8 2.8 0 01-.8-2zm-3.3-.4c0 .4-.1.8-.5 1.1-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.5-.4-.3-.5-.7-.5-1.1 0-.5.1-.9.5-1.2.3-.3.7-.4 1.1-.4.4 0 .8.1 1.1.4.4.3.5.7.5 1.2zM12 13c.4 0 .8.1 1.1.5.4.3.5.7.5 1.1 0 1-.1 1.6-.5 2a3 3 0 01-1.1 1c-.4.3-.8.4-1.1.4a.5.5 0 01-.5-.5V17a3 3 0 001-.2l.6-.6c-.6 0-1-.2-1.3-.5-.2-.3-.3-.7-.3-1 0-.5.1-1 .5-1.2.3-.4.7-.5 1.1-.5z" fill-rule="evenodd"/></svg>',
	    'color-levels': '<svg width="24" height="24"><path d="M17.5 11.4A9 9 0 0118 14c0 .5 0 1-.2 1.4 0 .4-.3.9-.5 1.3a6.2 6.2 0 01-3.7 3 5.7 5.7 0 01-3.2 0A5.9 5.9 0 017.6 18a6.2 6.2 0 01-1.4-2.6 6.7 6.7 0 010-2.8c0-.4.1-.9.3-1.3a13.6 13.6 0 012.3-4A20 20 0 0112 4a26.4 26.4 0 013.2 3.4 18.2 18.2 0 012.3 4zm-2 4.5c.4-.7.5-1.4.5-2a7.3 7.3 0 00-1-3.2c.2.6.2 1.2.2 1.9a4.5 4.5 0 01-1.3 3 5.3 5.3 0 01-2.3 1.5 4.9 4.9 0 01-2 .1 4.3 4.3 0 002.4.8 4 4 0 002-.6 4 4 0 001.5-1.5z" fill-rule="evenodd"/></svg>',
	    'color-picker': '<svg width="24" height="24"><path d="M12 3a9 9 0 000 18 1.5 1.5 0 001.1-2.5c-.2-.3-.4-.6-.4-1 0-.8.7-1.5 1.5-1.5H16a5 5 0 005-5c0-4.4-4-8-9-8zm-5.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" fill-rule="nonzero"/></svg>',
	    'color-swatch-remove-color': '<svg width="24" height="24"><path stroke="#000" stroke-width="2" d="M21 3L3 21" fill-rule="evenodd"/></svg>',
	    'color-swatch': '<svg width="24" height="24"><rect x="3" y="3" width="18" height="18" rx="1" fill-rule="evenodd"/></svg>',
	    'comment-add': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M9 19l3-2h7c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H5a1 1 0 00-1 1v10c0 .6.4 1 1 1h4v2zm-2 4v-4H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3h-6.4L7 23z"/><path d="M13 10h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V8a1 1 0 012 0v2z"/></g></svg>',
	    'comment': '<svg width="24" height="24"><path fill-rule="nonzero" d="M9 19l3-2h7c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H5a1 1 0 00-1 1v10c0 .6.4 1 1 1h4v2zm-2 4v-4H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3h-6.4L7 23z"/></svg>',
	    'contrast': '<svg width="24" height="24"><path d="M12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4zm-6 8a6 6 0 006 6V6a6 6 0 00-6 6z" fill-rule="evenodd"/></svg>',
	    'copy': '<svg width="24" height="24"><path d="M16 3H6a2 2 0 00-2 2v11h2V5h10V3zm1 4a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V9c0-1.2.9-2 2-2h7zm0 12V9h-7v10h7z" fill-rule="nonzero"/></svg>',
	    'crop': '<svg width="24" height="24"><path d="M17 8v7h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1a1 1 0 01-1-1v-2H7V9H5a1 1 0 110-2h2V5c0-.6.4-1 1-1s1 .4 1 1v2h7l3-3 1 1-3 3zM9 9v5l5-5H9zm1 6h5v-5l-5 5z" fill-rule="evenodd"/></svg>',
	    'cut-column': '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.2 4.5c.9 0 1.6.4 2.2 1A3.7 3.7 0 0110.5 8v.5l1 1 4-4 1-.5a3.3 3.3 0 012 0c.4 0 .7.3 1 .5L17 8h4v13h-6V10l-1.5 1.5.5.5v4l-2.5-2.5-1 1v.5c0 .4 0 .8-.3 1.2-.2.5-.4.9-.8 1.2-.6.7-1.3 1-2.2 1-.8.2-1.5 0-2-.6l-.5-.8-.2-1c0-.4 0-.8.3-1.2A3.9 3.9 0 017 12.7c.5-.2 1-.3 1.5-.2l1-1-1-1c-.5 0-1 0-1.5-.2-.5-.1-1-.4-1.4-.9-.4-.3-.6-.7-.8-1.2L4.5 7c0-.4 0-.7.2-1 0-.3.3-.6.5-.8.5-.5 1.2-.8 2-.7zm12.3 5h-3v10h3v-10zM8 13.8h-.3l-.4.2a2.8 2.8 0 00-.7.4v.1a2.8 2.8 0 00-.6.8l-.1.4v.7l.2.5.5.2h.7a2.6 2.6 0 00.8-.3 2.4 2.4 0 00.7-.7 2.5 2.5 0 00.3-.8 1.5 1.5 0 000-.8 1 1 0 00-.2-.4 1 1 0 00-.5-.2H8zm3.5-3.7c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zM7 5.8h-.4a1 1 0 00-.5.3 1 1 0 00-.2.5v.7a2.5 2.5 0 00.3.8l.2.3h.1l.4.4.4.2.4.1h.7L9 9l.2-.4a1.6 1.6 0 000-.8 2.6 2.6 0 00-.3-.8A2.5 2.5 0 007.7 6l-.4-.1H7z"/></svg>',
	    'cut-row': '<svg width="24" height="24"><path fill-rule="evenodd" d="M22 3v5H9l3 3 2-2h4l-4 4 1 1h.5c.4 0 .8 0 1.2.3.5.2.9.4 1.2.8.7.6 1 1.3 1 2.2.2.8 0 1.5-.6 2l-.8.5-1 .2c-.4 0-.8 0-1.2-.3a3.9 3.9 0 01-2.1-2.2c-.2-.5-.3-1-.2-1.5l-1-1-1 1c0 .5 0 1-.2 1.5-.1.5-.4 1-.9 1.4-.3.4-.7.6-1.2.8l-1.2.3c-.4 0-.7 0-1-.2-.3 0-.6-.3-.8-.5-.5-.5-.8-1.2-.7-2 0-.9.4-1.6 1-2.2A3.7 3.7 0 018.6 14H9l1-1-4-4-.5-1a3.3 3.3 0 010-2c0-.4.3-.7.5-1l2 2V3h14zM8.5 15.3h-.3a2.6 2.6 0 00-.8.4 2.5 2.5 0 00-.9 1.1l-.1.4v.7l.2.5.5.2h.7a2.5 2.5 0 00.8-.3L9 18V18l.4-.4.2-.4.1-.4v-.3-.4a1 1 0 00-.2-.5 1 1 0 00-.4-.2h-.5zm7 0H15a1 1 0 00-.4.3 1 1 0 00-.2.5 1.5 1.5 0 000 .7v.4a2.8 2.8 0 00.5.7h.1a2.8 2.8 0 00.8.6l.4.1h.7l.5-.2.2-.5v-.4-.3a2.6 2.6 0 00-.3-.8 2.4 2.4 0 00-.7-.7 2.5 2.5 0 00-.8-.3h-.3zM12 11.6c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zm8.5-7.1h-11v2h11v-2z"/></svg>',
	    'cut': '<svg width="24" height="24"><path d="M18 15c.6.7 1 1.4 1 2.3 0 .8-.2 1.5-.7 2l-.8.5-1 .2c-.4 0-.8 0-1.2-.3a3.9 3.9 0 01-2.1-2.2c-.2-.5-.3-1-.2-1.5l-1-1-1 1c0 .5 0 1-.2 1.5-.1.5-.4 1-.9 1.4-.3.4-.7.6-1.2.8l-1.2.3c-.4 0-.7 0-1-.2-.3 0-.6-.3-.8-.5-.5-.5-.8-1.2-.7-2 0-.9.4-1.6 1-2.2A3.7 3.7 0 018.6 14H9l1-1-4-4-.5-1a3.3 3.3 0 010-2c0-.4.3-.7.5-1l6 6 6-6 .5 1a3.3 3.3 0 010 2c0 .4-.3.7-.5 1l-4 4 1 1h.5c.4 0 .8 0 1.2.3.5.2.9.4 1.2.8zm-8.5 2.2l.1-.4v-.3-.4a1 1 0 00-.2-.5 1 1 0 00-.4-.2 1.6 1.6 0 00-.8 0 2.6 2.6 0 00-.8.3 2.5 2.5 0 00-.9 1.1l-.1.4v.7l.2.5.5.2h.7a2.5 2.5 0 00.8-.3 2.8 2.8 0 001-1zm2.5-2.8c.4 0 .7-.1 1-.4.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4s-.7.1-1 .4c-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4zm5.4 4l.2-.5v-.4-.3a2.6 2.6 0 00-.3-.8 2.4 2.4 0 00-.7-.7 2.5 2.5 0 00-.8-.3 1.5 1.5 0 00-.8 0 1 1 0 00-.4.2 1 1 0 00-.2.5 1.5 1.5 0 000 .7v.4l.3.4.3.4a2.8 2.8 0 00.8.5l.4.1h.7l.5-.2z" fill-rule="evenodd"/></svg>',
	    'document-properties': '<svg width="24" height="24"><path d="M14.4 3H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h10a2 2 0 002-2V7.6L14.4 3zM17 19H7V5h6v4h4v10z" fill-rule="nonzero"/></svg>',
	    'drag': '<svg width="24" height="24"><path d="M13 5h2v2h-2V5zm0 4h2v2h-2V9zM9 9h2v2H9V9zm4 4h2v2h-2v-2zm-4 0h2v2H9v-2zm0 4h2v2H9v-2zm4 0h2v2h-2v-2zM9 5h2v2H9V5z" fill-rule="evenodd"/></svg>',
	    'duplicate-column': '<svg width="24" height="24"><path d="M17 6v16h-7V6h7zm-2 2h-3v12h3V8zm-2-6v2H8v15H6V2h7z"/></svg>',
	    'duplicate-row': '<svg width="24" height="24"><path d="M22 11v7H6v-7h16zm-2 2H8v3h12v-3zm-1-6v2H4v5H2V7h17z"/></svg>',
	    'duplicate': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M16 3v2H6v11H4V5c0-1.1.9-2 2-2h10zm3 8h-2V9h-7v10h9a2 2 0 01-2 2h-7a2 2 0 01-2-2V9c0-1.2.9-2 2-2h7a2 2 0 012 2v2z"/><path d="M17 14h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1z"/></g></svg>',
	    'edit-block': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19.8 8.8l-9.4 9.4c-.2.2-.5.4-.9.4l-5.4 1.2 1.2-5.4.5-.8 9.4-9.4c.7-.7 1.8-.7 2.5 0l2.1 2.1c.7.7.7 1.8 0 2.5zm-2-.2l1-.9v-.3l-2.2-2.2a.3.3 0 00-.3 0l-1 1L18 8.5zm-1 1l-2.5-2.4-6 6 2.5 2.5 6-6zm-7 7.1l-2.6-2.4-.3.3-.1.2-.7 3 3.1-.6h.1l.4-.5z"/></svg>',
	    'edit-image': '<svg width="24" height="24"><path d="M18 16h2V7a2 2 0 00-2-2H7v2h11v9zM6 17h15a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1H6a2 2 0 01-2-2V7H3a1 1 0 110-2h1V4a1 1 0 112 0v13zm3-5.3l1.3 2 3-4.7 3.7 6H7l2-3.3z" fill-rule="nonzero"/></svg>',
	    'embed-page': '<svg width="24" height="24"><path d="M19 6V5H5v14h2A13 13 0 0119 6zm0 1.4c-.8.8-1.6 2.4-2.2 4.6H19V7.4zm0 5.6h-2.4c-.4 1.8-.6 3.8-.6 6h3v-6zm-4 6c0-2.2.2-4.2.6-6H13c-.7 1.8-1.1 3.8-1.1 6h3zm-4 0c0-2.2.4-4.2 1-6H9.6A12 12 0 008 19h3zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm11.8 9c.4-1.9 1-3.4 1.8-4.5a9.2 9.2 0 00-4 4.5h2.2zm-3.4 0a12 12 0 012.8-4 12 12 0 00-5 4h2.2z" fill-rule="nonzero"/></svg>',
	    'embed': '<svg width="24" height="24"><path d="M4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm1 2v14h14V5H5zm4.8 2.6l5.6 4a.5.5 0 010 .8l-5.6 4A.5.5 0 019 16V8a.5.5 0 01.8-.4z" fill-rule="nonzero"/></svg>',
	    'emoji': '<svg width="24" height="24"><path d="M9 11c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 00-1 1c0 .6.4 1 1 1zm6 0c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 00-1 1c0 .6.4 1 1 1zm-3 5.5c2.1 0 4-1.5 4.4-3.5H7.6c.5 2 2.3 3.5 4.4 3.5zM12 4a8 8 0 100 16 8 8 0 000-16zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z" fill-rule="nonzero"/></svg>',
	    'export': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M14.4 3L18 7v1h-5V5H7v14h9a1 1 0 012 0c0 1-.8 2-1.9 2H7c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2h7.5z"/><path d="M18.1 12c.5 0 .9.4.9 1 0 .5-.3 1-.8 1h-7.3c-.5 0-.9-.4-.9-1 0-.5.3-1 .8-1h7.3z"/><path d="M16.4 9.2a1 1 0 011.4.2l2.4 3.6-2.4 3.6a1 1 0 01-1.7-1v-.2l1.7-2.4-1.6-2.4a1 1 0 01.2-1.4z"/></g></svg>',
	    'fill': '<svg width="24" height="26"><path d="M16.6 12l-9-9-1.4 1.4 2.4 2.4-5.2 5.1c-.5.6-.5 1.6 0 2.2L9 19.6a1.5 1.5 0 002.2 0l5.5-5.5c.5-.6.5-1.6 0-2.2zM5.2 13L10 8.2l4.8 4.8H5.2zM19 14.5s-2 2.2-2 3.5c0 1.1.9 2 2 2a2 2 0 002-2c0-1.3-2-3.5-2-3.5z" fill-rule="nonzero"/></svg>',
	    'flip-horizontally': '<svg width="24" height="24"><path d="M14 19h2v-2h-2v2zm4-8h2V9h-2v2zM4 7v10c0 1.1.9 2 2 2h3v-2H6V7h3V5H6a2 2 0 00-2 2zm14-2v2h2a2 2 0 00-2-2zm-7 16h2V3h-2v18zm7-6h2v-2h-2v2zm-4-8h2V5h-2v2zm4 12a2 2 0 002-2h-2v2z" fill-rule="nonzero"/></svg>',
	    'flip-vertically': '<svg width="24" height="24"><path d="M5 14v2h2v-2H5zm8 4v2h2v-2h-2zm4-14H7a2 2 0 00-2 2v3h2V6h10v3h2V6a2 2 0 00-2-2zm2 14h-2v2a2 2 0 002-2zM3 11v2h18v-2H3zm6 7v2h2v-2H9zm8-4v2h2v-2h-2zM5 18c0 1.1.9 2 2 2v-2H5z" fill-rule="nonzero"/></svg>',
	    'format-painter': '<svg width="24" height="24"><path d="M18 5V4c0-.5-.4-1-1-1H5a1 1 0 00-1 1v4c0 .6.5 1 1 1h12c.6 0 1-.4 1-1V7h1v4H9v9c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-7h8V5h-3z" fill-rule="nonzero"/></svg>',
	    'format': '<svg width="24" height="24"><path fill-rule="evenodd" d="M17 5a1 1 0 010 2h-4v11a1 1 0 01-2 0V7H7a1 1 0 110-2h10z"/></svg>',
	    'fullscreen': '<svg width="24" height="24"><path d="M15.3 10l-1.2-1.3 2.9-3h-2.3a.9.9 0 110-1.7H19c.5 0 .9.4.9.9v4.4a.9.9 0 11-1.8 0V7l-2.9 3zm0 4l3 3v-2.3a.9.9 0 111.7 0V19c0 .5-.4.9-.9.9h-4.4a.9.9 0 110-1.8H17l-3-2.9 1.3-1.2zM10 15.4l-2.9 3h2.3a.9.9 0 110 1.7H5a.9.9 0 01-.9-.9v-4.4a.9.9 0 111.8 0V17l2.9-3 1.2 1.3zM8.7 10L5.7 7v2.3a.9.9 0 01-1.7 0V5c0-.5.4-.9.9-.9h4.4a.9.9 0 010 1.8H7l3 2.9-1.3 1.2z" fill-rule="nonzero"/></svg>',
	    'gallery': '<svg width="24" height="24"><path fill-rule="nonzero" d="M5 15.7l2.3-2.2c.3-.3.7-.3 1 0L11 16l5.1-5c.3-.4.8-.4 1 0l2 1.9V8H5v7.7zM5 18V19h3l1.8-1.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 6h16c.6 0 1 .4 1 1v13c0 .6-.4 1-1 1H4a1 1 0 01-1-1V7c0-.6.4-1 1-1zm6 7a2 2 0 110-4 2 2 0 010 4zM4.5 4h15a.5.5 0 110 1h-15a.5.5 0 010-1zm2-2h11a.5.5 0 110 1h-11a.5.5 0 010-1z"/></svg>',
	    'gamma': '<svg width="24" height="24"><path d="M4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm1 2v14h14V5H5zm6.5 11.8V14L9.2 8.7a5.1 5.1 0 00-.4-.8l-.1-.2H8 8v-1l.3-.1.3-.1h.7a1 1 0 01.6.5l.1.3a8.5 8.5 0 01.3.6l1.9 4.6 2-5.2a1 1 0 011-.6.5.5 0 01.5.6L13 14v2.8a.7.7 0 01-1.4 0z" fill-rule="nonzero"/></svg>',
	    'help': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 5.5a6.5 6.5 0 00-6 9 6.3 6.3 0 001.4 2l1 1a6.3 6.3 0 003.6 1 6.5 6.5 0 006-9 6.3 6.3 0 00-1.4-2l-1-1a6.3 6.3 0 00-3.6-1zM12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4z"/><path d="M9.6 9.7a.7.7 0 01-.7-.8c0-1.1 1.5-1.8 3.2-1.8 1.8 0 3.2.8 3.2 2.4 0 1.4-.4 2.1-1.5 2.8-.2 0-.3.1-.3.2a2 2 0 00-.8.8.8.8 0 01-1.4-.6c.3-.7.8-1 1.3-1.5l.4-.2c.7-.4.8-.6.8-1.5 0-.5-.6-.9-1.7-.9-.5 0-1 .1-1.4.3-.2 0-.3.1-.3.2v-.2c0 .4-.4.8-.8.8z" fill-rule="nonzero"/><circle cx="12" cy="16" r="1"/></g></svg>',
	    'highlight-bg-color': '<svg width="24" height="24"><g fill-rule="evenodd"><path id="tox-icon-highlight-bg-color__color" d="M3 18h18v3H3z"/><path fill-rule="nonzero" d="M7.7 16.7H3l3.3-3.3-.7-.8L10.2 8l4 4.1-4 4.2c-.2.2-.6.2-.8 0l-.6-.7-1.1 1.1zm5-7.5L11 7.4l3-2.9a2 2 0 012.6 0L18 6c.7.7.7 2 0 2.7l-2.9 2.9-1.8-1.8-.5-.6"/></g></svg>',
	    'home': '<svg width="24" height="24"><path fill-rule="nonzero" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>',
	    'horizontal-rule': '<svg width="24" height="24"><path d="M4 11h16v2H4z" fill-rule="evenodd"/></svg>',
	    'image-options': '<svg width="24" height="24"><path d="M6 10a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm12 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm-6 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2z" fill-rule="nonzero"/></svg>',
	    'image': '<svg width="24" height="24"><path d="M5 15.7l3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7zM5 18V19h3l2.8-2.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm6 8a2 2 0 100-4 2 2 0 000 4z" fill-rule="nonzero"/></svg>',
	    'indent': '<svg width="24" height="24"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm-2.6-3.8L6.2 12l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"/></svg>',
	    'info': '<svg width="24" height="24"><path d="M12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4zm-1 3v2h2V7h-2zm3 10v-1h-1v-5h-3v1h1v4h-1v1h4z" fill-rule="evenodd"/></svg>',
	    'insert-character': '<svg width="24" height="24"><path d="M15 18h4l1-2v4h-6v-3.3l1.4-1a6 6 0 001.8-2.9 6.3 6.3 0 00-.1-4.1 5.8 5.8 0 00-3-3.2c-.6-.3-1.3-.5-2.1-.5a5.1 5.1 0 00-3.9 1.8 6.3 6.3 0 00-1.3 6 6.2 6.2 0 001.8 3l1.4.9V20H4v-4l1 2h4v-.5l-2-1L5.4 15A6.5 6.5 0 014 11c0-1 .2-1.9.6-2.7A7 7 0 016.3 6C7.1 5.4 8 5 9 4.5c1-.3 2-.5 3.1-.5a8.8 8.8 0 015.7 2 7 7 0 011.7 2.3 6 6 0 01.2 4.8c-.2.7-.6 1.3-1 1.9a7.6 7.6 0 01-3.6 2.5v.5z" fill-rule="evenodd"/></svg>',
	    'insert-time': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M12 19a7 7 0 100-14 7 7 0 000 14zm0 2a9 9 0 110-18 9 9 0 010 18z"/><path d="M16 12h-3V7c0-.6-.4-1-1-1a1 1 0 00-1 1v7h5c.6 0 1-.4 1-1s-.4-1-1-1z"/></g></svg>',
	    'invert': '<svg width="24" height="24"><path d="M18 19.3L16.5 18a5.8 5.8 0 01-3.1 1.9 6.1 6.1 0 01-5.5-1.6A5.8 5.8 0 016 14v-.3l.1-1.2A13.9 13.9 0 017.7 9l-3-3 .7-.8 2.8 2.9 9 8.9 1.5 1.6-.7.6zm0-5.5v.3l-.1 1.1-.4 1-1.2-1.2a4.3 4.3 0 00.2-1v-.2c0-.4 0-.8-.2-1.3l-.5-1.4a14.8 14.8 0 00-3-4.2L12 6a26.1 26.1 0 00-2.2 2.5l-1-1a20.9 20.9 0 012.9-3.3L12 4l1 .8a22.2 22.2 0 014 5.4c.6 1.2 1 2.4 1 3.6z" fill-rule="evenodd"/></svg>',
	    'italic': '<svg width="24" height="24"><path d="M16.7 4.7l-.1.9h-.3c-.6 0-1 0-1.4.3-.3.3-.4.6-.5 1.1l-2.1 9.8v.6c0 .5.4.8 1.4.8h.2l-.2.8H8l.2-.8h.2c1.1 0 1.8-.5 2-1.5l2-9.8.1-.5c0-.6-.4-.8-1.4-.8h-.3l.2-.9h5.8z" fill-rule="evenodd"/></svg>',
	    'line-height': '<svg width="24" height="24"><path d="M21 5a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zM7 3.6l3.7 3.7a1 1 0 01-1.3 1.5h-.1L8 7.3v9.2l1.3-1.3a1 1 0 011.3 0h.1c.4.4.4 1 0 1.3v.1L7 20.4l-3.7-3.7a1 1 0 011.3-1.5h.1L6 16.7V7.4L4.7 8.7a1 1 0 01-1.3 0h-.1a1 1 0 010-1.3v-.1L7 3.6z"/></svg>',
	    'line': '<svg width="24" height="24"><path d="M15 9l-8 8H4v-3l8-8 3 3zm1-1l-3-3 1-1h1c-.2 0 0 0 0 0l2 2s0 .2 0 0v1l-1 1zM4 18h16v2H4v-2z" fill-rule="evenodd"/></svg>',
	    'link': '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2.1 2a2 2 0 102.7 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2-2a2 2 0 10-2.6-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2z" fill-rule="nonzero"/></svg>',
	    'list-bull-circle': '<svg width="48" height="48"><g fill-rule="evenodd"><path d="M11 16a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM11 26a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM11 36a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6z" fill-rule="nonzero"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
	    'list-bull-default': '<svg width="48" height="48"><g fill-rule="evenodd"><circle cx="11" cy="14" r="3"/><circle cx="11" cy="24" r="3"/><circle cx="11" cy="34" r="3"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
	    'list-bull-square': '<svg width="48" height="48"><g fill-rule="evenodd"><path d="M8 11h6v6H8zM8 21h6v6H8zM8 31h6v6H8z"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
	    'list-num-default-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M37.4 17v-4.8l-1.6 1v-1.1l1.6-1h1.2V17zM33.3 17.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm1.7 5.7c0-1.2 1-2 2.2-2 1.3 0 2.1.8 2.1 1.8 0 .7-.3 1.2-1.3 2.2l-1.2 1v.2h2.6v1h-4.3v-.9l2-1.9c.8-.8 1-1.1 1-1.5 0-.5-.4-.8-1-.8-.5 0-.9.3-.9.9H35zm-1.7 4.3c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm3.2 7.3v-1h.7c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7s-1 .3-1 .8H35c0-1.1 1-1.8 2.2-1.8 1.2 0 2.1.6 2.1 1.6 0 .7-.4 1.2-1 1.3v.1c.7.1 1.3.7 1.3 1.4 0 1-1 1.9-2.4 1.9-1.3 0-2.2-.8-2.3-2h1.2c0 .6.5 1 1.1 1 .6 0 1-.4 1-1 0-.5-.3-.8-1-.8h-.7zm-3.3 2.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7z"/></g></svg>',
	    'list-num-default': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10 17v-4.8l-1.5 1v-1.1l1.6-1h1.2V17h-1.2zm3.6.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm-5 5.7c0-1.2.8-2 2.1-2s2.1.8 2.1 1.8c0 .7-.3 1.2-1.4 2.2l-1.1 1v.2h2.6v1H8.6v-.9l2-1.9c.8-.8 1-1.1 1-1.5 0-.5-.4-.8-1-.8-.5 0-.9.3-.9.9H8.5zm6.3 4.3c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM10 34.4v-1h.7c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7s-1 .3-1 .8H8.6c0-1.1 1-1.8 2.2-1.8 1.3 0 2.1.6 2.1 1.6 0 .7-.4 1.2-1 1.3v.1c.8.1 1.3.7 1.3 1.4 0 1-1 1.9-2.4 1.9-1.3 0-2.2-.8-2.3-2h1.2c0 .6.5 1 1.1 1 .7 0 1-.4 1-1 0-.5-.3-.8-1-.8h-.7zm4.7 2.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7z"/></g></svg>',
	    'list-num-lower-alpha-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M36.5 16c-.9 0-1.5-.5-1.5-1.3s.6-1.3 1.8-1.4h1v-.4c0-.4-.2-.6-.7-.6-.4 0-.7.1-.8.4h-1.1c0-.8.8-1.4 2-1.4S39 12 39 13V16h-1.2v-.6c-.3.4-.8.7-1.4.7zm.4-.8c.6 0 1-.4 1-.9V14h-1c-.5.1-.7.3-.7.6 0 .4.3.6.7.6zM33.1 16.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zM37.7 26c-.7 0-1.2-.2-1.5-.7v.7H35v-6.3h1.2v2.5c.3-.5.8-.9 1.5-.9 1.1 0 1.8 1 1.8 2.4 0 1.5-.7 2.4-1.8 2.4zm-.5-3.6c-.6 0-1 .5-1 1.3s.4 1.4 1 1.4c.7 0 1-.6 1-1.4 0-.8-.3-1.3-1-1.3zM33.2 26.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm6 7h-1c-.1-.5-.4-.8-1-.8s-1 .5-1 1.4c0 1 .4 1.4 1 1.4.5 0 .9-.2 1-.7h1c0 1-.8 1.7-2 1.7-1.4 0-2.2-.9-2.2-2.4s.8-2.4 2.2-2.4c1.2 0 2 .7 2 1.7zm-6.1 3c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-alpha': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10.3 15.2c.5 0 1-.4 1-.9V14h-1c-.5.1-.8.3-.8.6 0 .4.3.6.8.6zm-.4.9c-1 0-1.5-.6-1.5-1.4 0-.8.6-1.3 1.7-1.4h1.1v-.4c0-.4-.2-.6-.7-.6-.5 0-.8.1-.9.4h-1c0-.8.8-1.4 2-1.4 1.1 0 1.8.6 1.8 1.6V16h-1.1v-.6h-.1c-.2.4-.7.7-1.3.7zm4.6 0c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-3.2 10c-.6 0-1.2-.3-1.4-.8v.7H8.5v-6.3H10v2.5c.3-.5.8-.9 1.4-.9 1.2 0 1.9 1 1.9 2.4 0 1.5-.7 2.4-1.9 2.4zm-.4-3.7c-.7 0-1 .5-1 1.3s.3 1.4 1 1.4c.6 0 1-.6 1-1.4 0-.8-.4-1.3-1-1.3zm4 3.7c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-2.2 7h-1.2c0-.5-.4-.8-.9-.8-.6 0-1 .5-1 1.4 0 1 .4 1.4 1 1.4.5 0 .8-.2 1-.7h1c0 1-.8 1.7-2 1.7-1.4 0-2.2-.9-2.2-2.4s.8-2.4 2.2-2.4c1.2 0 2 .7 2 1.7zm1.8 3c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-greek-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M37.4 16c-1.2 0-2-.8-2-2.3 0-1.5.8-2.4 2-2.4.6 0 1 .4 1.3 1v-.9H40v3.2c0 .4.1.5.4.5h.2v.9h-.6c-.6 0-1-.2-1-.7h-.2c-.2.4-.7.8-1.3.8zm.3-1c.6 0 1-.5 1-1.3s-.4-1.3-1-1.3-1 .5-1 1.3.4 1.4 1 1.4zM33.3 16.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM36 21.9c0-1.5.8-2.3 2.1-2.3 1.2 0 2 .6 2 1.6 0 .6-.3 1-.9 1.3.9.3 1.3.8 1.3 1.7 0 1.2-.7 1.9-1.8 1.9-.6 0-1.1-.3-1.4-.8v2.2H36V22zm1.8 1.2v-1h.3c.5 0 .9-.2.9-.7 0-.5-.3-.8-.9-.8-.5 0-.8.3-.8 1v2.2c0 .8.4 1.3 1 1.3s1-.4 1-1-.4-1-1.2-1h-.3zM33.3 26.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM37.1 34.6L34.8 30h1.4l1.7 3.5 1.7-3.5h1.1l-2.2 4.6v.1c.5.8.7 1.4.7 1.8 0 .4-.2.8-.4 1-.2.2-.6.3-1 .3-.9 0-1.3-.4-1.3-1.2 0-.5.2-1 .5-1.7l.1-.2zm.7 1a2 2 0 00-.4.9c0 .3.1.4.4.4.3 0 .4-.1.4-.4 0-.2-.1-.6-.4-1zM33.3 36.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-greek': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10.5 15c.7 0 1-.5 1-1.3s-.3-1.3-1-1.3c-.5 0-.9.5-.9 1.3s.4 1.4 1 1.4zm-.3 1c-1.1 0-1.8-.8-1.8-2.3 0-1.5.7-2.4 1.8-2.4.7 0 1.1.4 1.3 1h.1v-.9h1.2v3.2c0 .4.1.5.4.5h.2v.9h-.6c-.6 0-1-.2-1.1-.7h-.1c-.2.4-.7.8-1.4.8zm5 .1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm-4.9 7v-1h.3c.6 0 1-.2 1-.7 0-.5-.4-.8-1-.8-.5 0-.8.3-.8 1v2.2c0 .8.4 1.3 1.1 1.3.6 0 1-.4 1-1s-.5-1-1.3-1h-.3zM8.6 22c0-1.5.7-2.3 2-2.3 1.2 0 2 .6 2 1.6 0 .6-.3 1-.8 1.3.8.3 1.3.8 1.3 1.7 0 1.2-.8 1.9-1.9 1.9-.6 0-1.1-.3-1.3-.8v2.2H8.5V22zm6.2 4.2c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm-4.5 8.5L8 30h1.4l1.7 3.5 1.7-3.5h1.1l-2.2 4.6v.1c.5.8.7 1.4.7 1.8 0 .4-.1.8-.4 1-.2.2-.6.3-1 .3-.9 0-1.3-.4-1.3-1.2 0-.5.2-1 .5-1.7l.1-.2zm.7 1a2 2 0 00-.4.9c0 .3.1.4.4.4.3 0 .4-.1.4-.4 0-.2-.1-.6-.4-1zm4.5.5c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-lower-roman-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M32.9 16v-1.2h-1.3V16H33zm0 10v-1.2h-1.3V26H33zm0 10v-1.2h-1.3V36H33z"/><path fill-rule="nonzero" d="M36 21h-1.5v5H36zM36 31h-1.5v5H36zM39 21h-1.5v5H39zM39 31h-1.5v5H39zM42 31h-1.5v5H42zM36 11h-1.5v5H36zM36 19h-1.5v1H36zM36 29h-1.5v1H36zM39 19h-1.5v1H39zM39 29h-1.5v1H39zM42 29h-1.5v1H42zM36 9h-1.5v1H36z"/></g></svg>',
	    'list-num-lower-roman': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M15.1 16v-1.2h1.3V16H15zm0 10v-1.2h1.3V26H15zm0 10v-1.2h1.3V36H15z"/><path fill-rule="nonzero" d="M12 21h1.5v5H12zM12 31h1.5v5H12zM9 21h1.5v5H9zM9 31h1.5v5H9zM6 31h1.5v5H6zM12 11h1.5v5H12zM12 19h1.5v1H12zM12 29h1.5v1H12zM9 19h1.5v1H9zM9 29h1.5v1H9zM6 29h1.5v1H6zM12 9h1.5v1H12z"/></g></svg>',
	    'list-num-upper-alpha-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M39.3 17l-.5-1.4h-2l-.5 1.4H35l2-6h1.6l2 6h-1.3zm-1.6-4.7l-.7 2.3h1.6l-.8-2.3zM33.4 17c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm4.7 9.9h-2.7v-6H38c1.2 0 1.9.6 1.9 1.5 0 .6-.5 1.2-1 1.3.7.1 1.3.7 1.3 1.5 0 1-.8 1.7-2 1.7zm-1.4-5v1.5h1c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7h-1zm0 4h1.1c.7 0 1.1-.3 1.1-.8 0-.6-.4-.9-1.1-.9h-1.1V26zM33 27.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm4.9 10c-1.8 0-2.8-1.1-2.8-3.1s1-3.1 2.8-3.1c1.4 0 2.5.9 2.6 2.2h-1.3c0-.7-.6-1.1-1.3-1.1-1 0-1.6.7-1.6 2s.6 2 1.6 2c.7 0 1.2-.4 1.4-1h1.2c-.1 1.3-1.2 2.2-2.6 2.2zm-4.5 0c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-upper-alpha': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M12.6 17l-.5-1.4h-2L9.5 17H8.3l2-6H12l2 6h-1.3zM11 12.3l-.7 2.3h1.6l-.8-2.3zm4.7 4.8c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zM11.4 27H8.7v-6h2.6c1.2 0 1.9.6 1.9 1.5 0 .6-.5 1.2-1 1.3.7.1 1.3.7 1.3 1.5 0 1-.8 1.7-2 1.7zM10 22v1.5h1c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7h-1zm0 4H11c.7 0 1.1-.3 1.1-.8 0-.6-.4-.9-1.1-.9H10V26zm5.4 1.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-4.1 10c-1.8 0-2.8-1.1-2.8-3.1s1-3.1 2.8-3.1c1.4 0 2.5.9 2.6 2.2h-1.3c0-.7-.6-1.1-1.3-1.1-1 0-1.6.7-1.6 2s.6 2 1.6 2c.7 0 1.2-.4 1.4-1h1.2c-.1 1.3-1.2 2.2-2.6 2.2zm4.5 0c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
	    'list-num-upper-roman-rtl': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M31.6 17v-1.2H33V17h-1.3zm0 10v-1.2H33V27h-1.3zm0 10v-1.2H33V37h-1.3z"/><path fill-rule="nonzero" d="M34.5 20H36v7h-1.5zM34.5 30H36v7h-1.5zM37.5 20H39v7h-1.5zM37.5 30H39v7h-1.5zM40.5 30H42v7h-1.5zM34.5 10H36v7h-1.5z"/></g></svg>',
	    'list-num-upper-roman': '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M15.1 17v-1.2h1.3V17H15zm0 10v-1.2h1.3V27H15zm0 10v-1.2h1.3V37H15z"/><path fill-rule="nonzero" d="M12 20h1.5v7H12zM12 30h1.5v7H12zM9 20h1.5v7H9zM9 30h1.5v7H9zM6 30h1.5v7H6zM12 10h1.5v7H12z"/></g></svg>',
	    'lock': '<svg width="24" height="24"><path d="M16.3 11c.2 0 .3 0 .5.2l.2.6v7.4c0 .3 0 .4-.2.6l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6v-7.4c0-.3 0-.4.2-.6l.5-.2H8V8c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h2c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v3h.3zM10 8v3h4V8a1 1 0 00-.3-.7A1 1 0 0013 7h-2a1 1 0 00-.7.3 1 1 0 00-.3.7z" fill-rule="evenodd"/></svg>',
	    'ltr': '<svg width="24" height="24"><path d="M11 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 017.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L11 5zM4.4 16.2L6.2 15l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"/></svg>',
	    'more-drawer': '<svg width="24" height="24"><path d="M6 10a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm12 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm-6 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2z" fill-rule="nonzero"/></svg>',
	    'new-document': '<svg width="24" height="24"><path d="M14.4 3H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h10a2 2 0 002-2V7.6L14.4 3zM17 19H7V5h6v4h4v10z" fill-rule="nonzero"/></svg>',
	    'new-tab': '<svg width="24" height="24"><path d="M15 13l2-2v8H5V7h8l-2 2H7v8h8v-4zm4-8v5.5l-2-2-5.6 5.5H10v-1.4L15.5 7l-2-2H19z" fill-rule="evenodd"/></svg>',
	    'non-breaking': '<svg width="24" height="24"><path d="M11 11H8a1 1 0 110-2h3V6c0-.6.4-1 1-1s1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1h-3v3c0 .6-.4 1-1 1a1 1 0 01-1-1v-3zm10 4v5H3v-5c0-.6.4-1 1-1s1 .4 1 1v3h14v-3c0-.6.4-1 1-1s1 .4 1 1z" fill-rule="evenodd"/></svg>',
	    'notice': '<svg width="24" height="24"><path d="M17.8 9.8L15.4 4 20 8.5v7L15.5 20h-7L4 15.5v-7L8.5 4h7l2.3 5.8zm0 0l2.2 5.7-2.3-5.8zM13 17v-2h-2v2h2zm0-4V7h-2v6h2z" fill-rule="evenodd"/></svg>',
	    'ordered-list-rtl': '<svg width="24" height="24"><path d="M6 17h8a1 1 0 010 2H6a1 1 0 010-2zm0-6h8a1 1 0 010 2H6a1 1 0 010-2zm0-6h8a1 1 0 010 2H6a1 1 0 110-2zm13-1v3.5a.5.5 0 11-1 0V5h-.5a.5.5 0 110-1H19zm-1 8.8l.2.2h1.3a.5.5 0 110 1h-1.6a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2h-1.3a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zm2 4.2v2c0 .6-.4 1-1 1h-1.5a.5.5 0 010-1h1.2a.3.3 0 100-.6h-1.3a.4.4 0 110-.8h1.3a.3.3 0 000-.6h-1.2a.5.5 0 110-1H19c.6 0 1 .4 1 1z" fill-rule="evenodd"/></svg>',
	    'ordered-list': '<svg width="24" height="24"><path d="M10 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 110-2zM6 4v3.5c0 .3-.2.5-.5.5a.5.5 0 01-.5-.5V5h-.5a.5.5 0 010-1H6zm-1 8.8l.2.2h1.3c.3 0 .5.2.5.5s-.2.5-.5.5H4.9a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2H4.5a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zM7 17v2c0 .6-.4 1-1 1H4.5a.5.5 0 010-1h1.2c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.4a.4.4 0 110-.8h1.3c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.5a.5.5 0 110-1H6c.6 0 1 .4 1 1z" fill-rule="evenodd"/></svg>',
	    'orientation': '<svg width="24" height="24"><path d="M7.3 6.4L1 13l6.4 6.5 6.5-6.5-6.5-6.5zM3.7 13l3.6-3.7L11 13l-3.7 3.7-3.6-3.7zM12 6l2.8 2.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0L9.2 5.7a.8.8 0 010-1.2L13.6.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L12 4h1a9 9 0 11-4.3 16.9l1.5-1.5A7 7 0 1013 6h-1z" fill-rule="nonzero"/></svg>',
	    'outdent': '<svg width="24" height="24"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm1.6-3.8a1 1 0 01-1.2 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 011.2 1.6L6.8 12l1.8 1.2z" fill-rule="evenodd"/></svg>',
	    'page-break': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M5 11c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm4 0c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1h-1a1 1 0 010-2zm4 0c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zM7 3v5h10V3c0-.6.4-1 1-1s1 .4 1 1v7H5V3c0-.6.4-1 1-1s1 .4 1 1zM6 22a1 1 0 01-1-1v-7h14v7c0 .6-.4 1-1 1a1 1 0 01-1-1v-5H7v5c0 .6-.4 1-1 1z"/></g></svg>',
	    'paragraph': '<svg width="24" height="24"><path fill-rule="evenodd" d="M10 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 016.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L10 5z"/></svg>',
	    'paste-column-after': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V7h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h7v2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm8 7v12h-6V8h6zm-1.5 1.5h-3v9h3v-9zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-column-before': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V18c0 1-.8 2-1.9 2H11v-2h7V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v2H4V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm-2 7v12H4V8h6zM8.5 9.5h-3v9h3v-9zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-row-after': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V11h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h14c0 1-.8 2-1.9 2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm10 11v5H8v-5h14zm-1.5 1.5h-11v2h11v-2zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-row-before': '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V7h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h12v-4h2v4c0 1-.8 2-1.9 2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm10 7v5H8V8h14zm-1.5 1.5h-11v2h11v-2zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
	    'paste-text': '<svg width="24" height="24"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1zm0 9h6v2h-.5l-.5-1h-1v4h.8v1h-3.6v-1h.8v-4h-1l-.5 1H12v-2z" fill-rule="nonzero"/></svg>',
	    'paste': '<svg width="24" height="24"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1z" fill-rule="nonzero"/></svg>',
	    'permanent-pen': '<svg width="24" height="24"><path d="M10.5 17.5L8 20H3v-3l3.5-3.5a2 2 0 010-3L14 3l1 1-7.3 7.3a1 1 0 000 1.4l3.6 3.6c.4.4 1 .4 1.4 0L20 9l1 1-7.6 7.6a2 2 0 01-2.8 0l-.1-.1z" fill-rule="nonzero"/></svg>',
	    'plus': '<svg width="24" height="24"><path d="M12 4c.5 0 1 .4 1 .9V11h6a1 1 0 01.1 2H13v6a1 1 0 01-2 .1V13H5a1 1 0 01-.1-2H11V5c0-.6.4-1 1-1z"/></svg>',
	    'preferences': '<svg width="24" height="24"><path d="M20.1 13.5l-1.9.2a5.8 5.8 0 01-.6 1.5l1.2 1.5c.4.4.3 1 0 1.4l-.7.7a1 1 0 01-1.4 0l-1.5-1.2a6.2 6.2 0 01-1.5.6l-.2 1.9c0 .5-.5.9-1 .9h-1a1 1 0 01-1-.9l-.2-1.9a5.8 5.8 0 01-1.5-.6l-1.5 1.2a1 1 0 01-1.4 0l-.7-.7a1 1 0 010-1.4l1.2-1.5a6.2 6.2 0 01-.6-1.5l-1.9-.2a1 1 0 01-.9-1v-1c0-.5.4-1 .9-1l1.9-.2a5.8 5.8 0 01.6-1.5L5.2 7.3a1 1 0 010-1.4l.7-.7a1 1 0 011.4 0l1.5 1.2a6.2 6.2 0 011.5-.6l.2-1.9c0-.5.5-.9 1-.9h1c.5 0 1 .4 1 .9l.2 1.9a5.8 5.8 0 011.5.6l1.5-1.2a1 1 0 011.4 0l.7.7c.3.4.4 1 0 1.4l-1.2 1.5a6.2 6.2 0 01.6 1.5l1.9.2c.5 0 .9.5.9 1v1c0 .5-.4 1-.9 1zM12 15a3 3 0 100-6 3 3 0 000 6z" fill-rule="evenodd"/></svg>',
	    'preview': '<svg width="24" height="24"><path d="M3.5 12.5c.5.8 1.1 1.6 1.8 2.3 2 2 4.2 3.2 6.7 3.2s4.7-1.2 6.7-3.2a16.2 16.2 0 002.1-2.8 15.7 15.7 0 00-2.1-2.8c-2-2-4.2-3.2-6.7-3.2a9.3 9.3 0 00-6.7 3.2A16.2 16.2 0 003.2 12c0 .2.2.3.3.5zm-2.4-1l.7-1.2L4 7.8C6.2 5.4 8.9 4 12 4c3 0 5.8 1.4 8.1 3.8a18.2 18.2 0 012.8 3.7v1l-.7 1.2-2.1 2.5c-2.3 2.4-5 3.8-8.1 3.8-3 0-5.8-1.4-8.1-3.8a18.2 18.2 0 01-2.8-3.7 1 1 0 010-1zm12-3.3a2 2 0 102.7 2.6 4 4 0 11-2.6-2.6z" fill-rule="nonzero"/></svg>',
	    'print': '<svg width="24" height="24"><path d="M18 8H6a3 3 0 00-3 3v6h2v3h14v-3h2v-6a3 3 0 00-3-3zm-1 10H7v-4h10v4zm.5-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm.5-8H6v2h12V5z" fill-rule="nonzero"/></svg>',
	    'quote': '<svg width="24" height="24"><path d="M7.5 17h.9c.4 0 .7-.2.9-.6L11 13V8c0-.6-.4-1-1-1H6a1 1 0 00-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 00.8 1.3zm8 0h.9c.4 0 .7-.2.9-.6L19 13V8c0-.6-.4-1-1-1h-4a1 1 0 00-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 00.8 1.3z" fill-rule="nonzero"/></svg>',
	    'redo': '<svg width="24" height="24"><path d="M17.6 10H12c-2.8 0-4.4 1.4-4.9 3.5-.4 2 .3 4 1.4 4.6a1 1 0 11-1 1.8c-2-1.2-2.9-4.1-2.3-6.8.6-3 3-5.1 6.8-5.1h5.6l-3.3-3.3a1 1 0 111.4-1.4l5 5a1 1 0 010 1.4l-5 5a1 1 0 01-1.4-1.4l3.3-3.3z" fill-rule="nonzero"/></svg>',
	    'reload': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M5 22.1l-1.2-4.7v-.2a1 1 0 011-1l5 .4a1 1 0 11-.2 2l-2.2-.2a7.8 7.8 0 008.4.2 7.5 7.5 0 003.5-6.4 1 1 0 112 0 9.5 9.5 0 01-4.5 8 9.9 9.9 0 01-10.2 0l.4 1.4a1 1 0 11-2 .5zM13.6 7.4c0-.5.5-1 1-.9l2.8.2a8 8 0 00-9.5-1 7.5 7.5 0 00-3.6 7 1 1 0 01-2 0 9.5 9.5 0 014.5-8.6 10 10 0 0110.9.3l-.3-1a1 1 0 012-.5l1.1 4.8a1 1 0 01-1 1.2l-5-.4a1 1 0 01-.9-1z"/></g></svg>',
	    'remove-formatting': '<svg width="24" height="24"><path d="M13.2 6a1 1 0 010 .2l-2.6 10a1 1 0 01-1 .8h-.2a.8.8 0 01-.8-1l2.6-10H8a1 1 0 110-2h9a1 1 0 010 2h-3.8zM5 18h7a1 1 0 010 2H5a1 1 0 010-2zm13 1.5L16.5 18 15 19.5a.7.7 0 01-1-1l1.5-1.5-1.5-1.5a.7.7 0 011-1l1.5 1.5 1.5-1.5a.7.7 0 011 1L17.5 17l1.5 1.5a.7.7 0 01-1 1z" fill-rule="evenodd"/></svg>',
	    'remove': '<svg width="24" height="24"><path d="M16 7h3a1 1 0 010 2h-1v9a3 3 0 01-3 3H9a3 3 0 01-3-3V9H5a1 1 0 110-2h3V6a3 3 0 013-3h2a3 3 0 013 3v1zm-2 0V6c0-.6-.4-1-1-1h-2a1 1 0 00-1 1v1h4zm2 2H8v9c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V9zm-7 3a1 1 0 012 0v4a1 1 0 01-2 0v-4zm4 0a1 1 0 012 0v4a1 1 0 01-2 0v-4z" fill-rule="nonzero"/></svg>',
	    'resize-handle': '<svg width="10" height="10"><g fill-rule="nonzero"><path d="M8.1 1.1A.5.5 0 119 2l-7 7A.5.5 0 111 8l7-7zM8.1 5.1A.5.5 0 119 6l-3 3A.5.5 0 115 8l3-3z"/></g></svg>',
	    'resize': '<svg width="24" height="24"><path d="M4 5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h6c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 01-.7.3H7.4L18 16.6V13c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7v6c0 .3-.1.5-.3.7a1 1 0 01-.7.3h-6a1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h3.6L6 7.4V11c0 .3-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.7-.3A1 1 0 014 11V5z" fill-rule="evenodd"/></svg>',
	    'restore-draft': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M17 13c0 .6-.4 1-1 1h-4V8c0-.6.4-1 1-1s1 .4 1 1v4h2c.6 0 1 .4 1 1z"/><path d="M4.7 10H9a1 1 0 010 2H3a1 1 0 01-1-1V5a1 1 0 112 0v3l2.5-2.4a9.2 9.2 0 0110.8-1.5A9 9 0 0113.4 21c-2.4.1-4.7-.7-6.5-2.2a1 1 0 111.3-1.5 7.2 7.2 0 0011.6-3.7 7 7 0 00-3.5-7.7A7.2 7.2 0 008 7L4.7 10z" fill-rule="nonzero"/></g></svg>',
	    'rotate-left': '<svg width="24" height="24"><path d="M4.7 10H9a1 1 0 010 2H3a1 1 0 01-1-1V5a1 1 0 112 0v3l2.5-2.4a9.2 9.2 0 0110.8-1.5A9 9 0 0113.4 21c-2.4.1-4.7-.7-6.5-2.2a1 1 0 111.3-1.5 7.2 7.2 0 0011.6-3.7 7 7 0 00-3.5-7.7A7.2 7.2 0 008 7L4.7 10z" fill-rule="nonzero"/></svg>',
	    'rotate-right': '<svg width="24" height="24"><path d="M20 8V5a1 1 0 012 0v6c0 .6-.4 1-1 1h-6a1 1 0 010-2h4.3L16 7A7.2 7.2 0 007.7 6a7 7 0 003 13.1c1.9.1 3.7-.5 5-1.7a1 1 0 011.4 1.5A9.2 9.2 0 012.2 14c-.9-3.9 1-8 4.5-9.9 3.5-1.9 8-1.3 10.8 1.5L20 8z" fill-rule="nonzero"/></svg>',
	    'rtl': '<svg width="24" height="24"><path d="M8 5h8v2h-2v12h-2V7h-2v12H8v-7c-.5 0-1 0-1.4-.3A3.4 3.4 0 014.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L8 5zm12 11.2a1 1 0 11-1 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 111 1.6L18.4 15l1.8 1.2z" fill-rule="evenodd"/></svg>',
	    'save': '<svg width="24" height="24"><path d="M5 16h14a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2c0-1.1.9-2 2-2zm0 2v2h14v-2H5zm10 0h2v2h-2v-2zm-4-6.4L8.7 9.3a1 1 0 10-1.4 1.4l4 4c.4.4 1 .4 1.4 0l4-4a1 1 0 10-1.4-1.4L13 11.6V4a1 1 0 00-2 0v7.6z" fill-rule="nonzero"/></svg>',
	    'search': '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12z" fill-rule="nonzero"/></svg>',
	    'select-all': '<svg width="24" height="24"><path d="M3 5h2V3a2 2 0 00-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2a2 2 0 00-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8a2 2 0 002-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z" fill-rule="nonzero"/></svg>',
	    'selected': '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm3.6 10.9L7 12.3a.7.7 0 00-1 1L9.6 17 18 8.6a.7.7 0 000-1 .7.7 0 00-1 0l-7.4 7.3z"/></svg>',
	    'settings': '<svg width="24" height="24"><path d="M11 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8v.3c0 .2 0 .3-.2.5l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V8H5a1 1 0 110-2h2v-.3c0-.2 0-.3.2-.5l.5-.2h2.5c.3 0 .4 0 .6.2l.2.5V6zM8 8h2V6H8v2zm9 2.8v.2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v.3c0 .2 0 .3-.2.5l-.6.2h-2.4c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V13H5a1 1 0 010-2h8v-.3c0-.2 0-.3.2-.5l.6-.2h2.4c.3 0 .4 0 .6.2l.2.6zM14 13h2v-2h-2v2zm-3 2.8v.2h8c.6 0 1 .4 1 1s-.4 1-1 1h-8v.3c0 .2 0 .3-.2.5l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V18H5a1 1 0 010-2h2v-.3c0-.2 0-.3.2-.5l.5-.2h2.5c.3 0 .4 0 .6.2l.2.6zM8 18h2v-2H8v2z" fill-rule="evenodd"/></svg>',
	    'sharpen': '<svg width="24" height="24"><path d="M16 6l4 4-8 9-8-9 4-4h8zm-4 10.2l5.5-6.2-.1-.1H12v-.3h5.1l-.2-.2H12V9h4.6l-.2-.2H12v-.3h4.1l-.2-.2H12V8h3.6l-.2-.2H8.7L6.5 10l.1.1H12v.3H6.9l.2.2H12v.3H7.3l.2.2H12v.3H7.7l.3.2h4v.3H8.2l.2.2H12v.3H8.6l.3.2H12v.3H9l.3.2H12v.3H9.5l.2.2H12v.3h-2l.2.2H12v.3h-1.6l.2.2H12v.3h-1.1l.2.2h.9v.3h-.7l.2.2h.5v.3h-.3l.3.2z" fill-rule="evenodd"/></svg>',
	    'sourcecode': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M9.8 15.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0l-4.4-4.1a.8.8 0 010-1.2l4.4-4.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L6 12l3.8 3.7zM14.2 15.7c-.3.3-.3.8 0 1 .4.4.9.4 1.2 0l4.4-4.1c.3-.3.3-.9 0-1.2l-4.4-4.2a.8.8 0 00-1.2 0c-.3.3-.3.8 0 1.1L18 12l-3.8 3.7z"/></g></svg>',
	    'spell-check': '<svg width="24" height="24"><path d="M6 8v3H5V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h2c.3 0 .5.1.7.3.2.2.3.4.3.7v6H8V8H6zm0-3v2h2V5H6zm13 0h-3v5h3v1h-3a1 1 0 01-.7-.3 1 1 0 01-.3-.7V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h3v1zm-5 1.5l-.1.7c-.1.2-.3.3-.6.3.3 0 .5.1.6.3l.1.7V10c0 .3-.1.5-.3.7a1 1 0 01-.7.3h-3V4h3c.3 0 .5.1.7.3.2.2.3.4.3.7v1.5zM13 10V8h-2v2h2zm0-3V5h-2v2h2zm3 5l1 1-6.5 7L7 15.5l1.3-1 2.2 2.2L16 12z" fill-rule="evenodd"/></svg>',
	    'strike-through': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M15.6 8.5c-.5-.7-1-1.1-1.3-1.3-.6-.4-1.3-.6-2-.6-2.7 0-2.8 1.7-2.8 2.1 0 1.6 1.8 2 3.2 2.3 4.4.9 4.6 2.8 4.6 3.9 0 1.4-.7 4.1-5 4.1A6.2 6.2 0 017 16.4l1.5-1.1c.4.6 1.6 2 3.7 2 1.6 0 2.5-.4 3-1.2.4-.8.3-2-.8-2.6-.7-.4-1.6-.7-2.9-1-1-.2-3.9-.8-3.9-3.6C7.6 6 10.3 5 12.4 5c2.9 0 4.2 1.6 4.7 2.4l-1.5 1.1z"/><path d="M5 11h14a1 1 0 010 2H5a1 1 0 010-2z" fill-rule="nonzero"/></g></svg>',
	    'subscript': '<svg width="24" height="24"><path d="M10.4 10l4.6 4.6-1.4 1.4L9 11.4 4.4 16 3 14.6 7.6 10 3 5.4 4.4 4 9 8.6 13.6 4 15 5.4 10.4 10zM21 19h-5v-1l1-.8 1.7-1.6c.3-.4.5-.8.5-1.2 0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3a2 2 0 00-.8.2l-.7.3-.4-1.1 1-.6 1.2-.2c.8 0 1.4.3 1.8.7.4.4.6.9.6 1.5s-.2 1.1-.5 1.6a8 8 0 01-1.3 1.3l-.6.6h2.6V19z" fill-rule="nonzero"/></svg>',
	    'superscript': '<svg width="24" height="24"><path d="M15 9.4L10.4 14l4.6 4.6-1.4 1.4L9 15.4 4.4 20 3 18.6 7.6 14 3 9.4 4.4 8 9 12.6 13.6 8 15 9.4zm5.9 1.6h-5v-1l1-.8 1.7-1.6c.3-.5.5-.9.5-1.3 0-.3 0-.5-.2-.7-.2-.2-.5-.3-.9-.3l-.8.2-.7.4-.4-1.2c.2-.2.5-.4 1-.5.3-.2.8-.2 1.2-.2.8 0 1.4.2 1.8.6.4.4.6 1 .6 1.6 0 .5-.2 1-.5 1.5l-1.3 1.4-.6.5h2.6V11z" fill-rule="nonzero"/></svg>',
	    'table-cell-properties': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9H5v5h6v-5zm8 0h-6v5h6v-5zm-8-7H5v5h6V6z"/></svg>',
	    'table-cell-select-all': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v12h14V6z"/><path d="M13 6v5h6v2h-6v5h-2v-5H5v-2h6V6h2z" opacity=".2"/></g></svg>',
	    'table-cell-select-inner': '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v12h14V6z" opacity=".2"/><path d="M13 6v5h6v2h-6v5h-2v-5H5v-2h6V6h2z"/></g></svg>',
	    'table-delete-column': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-4 4h-2V6h-2v2H9V6H5v12h4v-2h2v2h2v-2h2v2h4V6h-4v2zm.3.5l1 1.2-3 2.3 3 2.3-1 1.2L12 13l-3.3 2.6-1-1.2 3-2.3-3-2.3 1-1.2L12 11l3.3-2.5z"/></svg>',
	    'table-delete-row': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v3h2.5v2H5v2h2.5v2H5v3h14v-3h-2.5v-2H19v-2h-2.5V9H19V6zm-4.7 1.8l1.2 1L13 12l2.6 3.3-1.2 1-2.3-3-2.3 3-1.2-1L11 12 8.5 8.7l1.2-1 2.3 3 2.3-3z"/></svg>',
	    'table-delete-table': '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 6v12h14V6H5z"/><path d="M14.4 8.6l1 1-2.3 2.4 2.3 2.4-1 1-2.4-2.3-2.4 2.3-1-1 2.3-2.4-2.3-2.4 1-1 2.4 2.3z"/></g></svg>',
	    'table-insert-column-after': '<svg width="24" height="24"><path fill-rule="nonzero" d="M20 4c.6 0 1 .4 1 1v2a1 1 0 01-2 0V6h-8v12h8v-1a1 1 0 012 0v2c0 .5-.4 1-.9 1H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h15zM9 13H5v5h4v-5zm7-5c.5 0 1 .4 1 .9V11h2a1 1 0 01.1 2H17v2a1 1 0 01-2 .1V13h-2a1 1 0 01-.1-2H15V9c0-.6.4-1 1-1zM9 6H5v5h4V6z"/></svg>',
	    'table-insert-column-before': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H4a1 1 0 01-1-1v-2a1 1 0 012 0v1h8V6H5v1a1 1 0 11-2 0V5c0-.6.4-1 1-1h15zm0 9h-4v5h4v-5zM8 8c.5 0 1 .4 1 .9V11h2a1 1 0 01.1 2H9v2a1 1 0 01-2 .1V13H5a1 1 0 01-.1-2H7V9c0-.6.4-1 1-1zm11-2h-4v5h4V6z"/></svg>',
	    'table-insert-row-above': '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4a1 1 0 110 2H5v6h14V6h-1a1 1 0 010-2h2c.6 0 1 .4 1 1v13a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-.6.4-1 1-1h2zm5 10H5v4h6v-4zm8 0h-6v4h6v-4zM12 3c.5 0 1 .4 1 .9V6h2a1 1 0 010 2h-2v2a1 1 0 01-2 .1V8H9a1 1 0 010-2h2V4c0-.6.4-1 1-1z"/></svg>',
	    'table-insert-row-after': '<svg width="24" height="24"><path fill-rule="nonzero" d="M12 13c.5 0 1 .4 1 .9V16h2a1 1 0 01.1 2H13v2a1 1 0 01-2 .1V18H9a1 1 0 01-.1-2H11v-2c0-.6.4-1 1-1zm6 7a1 1 0 010-2h1v-6H5v6h1a1 1 0 010 2H4a1 1 0 01-1-1V6c0-1.1.9-2 2-2h14a2 2 0 012 2v13c0 .5-.4 1-.9 1H18zM11 6H5v4h6V6zm8 0h-6v4h6V6z"/></svg>',
	    'table-left-header': '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 9h-4v5h4v-5zm-6 0H9v5h4v-5zm0-7H9v5h4V6zm6 0h-4v5h4V6z"/></svg>',
	    'table-merge-cells': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 15.5V18h3v-2.5H5zm14-5h-9V18h9v-7.5zM19 6h-4v2.5h4V6zM8 6H5v2.5h3V6zm5 0h-3v2.5h3V6zm-8 7.5h3v-3H5v3z"/></svg>',
	    'table-row-properties': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 15v3h6v-3H5zm14 0h-6v3h6v-3zm0-9h-6v3h6V6zM5 9h6V6H5v3z"/></svg>',
	    'table-split-cells': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM8 15.5H5V18h3v-2.5zm11-5h-9V18h9v-7.5zm-2.5 1l1 1-2 2 2 2-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2zm-8.5-1H5v3h3v-3zM19 6h-4v2.5h4V6zM8 6H5v2.5h3V6zm5 0h-3v2.5h3V6z"/></svg>',
	    'table-top-header': '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 11H5v3h6v-3zm8 0h-6v3h6v-3zm0-5h-6v3h6v-3zM5 13h6v-3H5v3z"/></svg>',
	    'table': '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 14v4h6v-4H5zm14 0h-6v4h6v-4zm0-6h-6v4h6V8zM5 12h6V8H5v4z"/></svg>',
	    'template': '<svg width="24" height="24"><path d="M19 19v-1H5v1h14zM9 16v-4a5 5 0 116 0v4h4a2 2 0 012 2v3H3v-3c0-1.1.9-2 2-2h4zm4 0v-5l.8-.6a3 3 0 10-3.6 0l.8.6v5h2z" fill-rule="nonzero"/></svg>',
	    'temporary-placeholder': '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M9 7.6V6h2.5V4.5a.5.5 0 111 0V6H15v1.6a8 8 0 11-6 0zm-2.6 5.3a.5.5 0 00.3.6c.3 0 .6 0 .6-.3l.1-.2a5 5 0 013.3-2.8c.3-.1.4-.4.4-.6-.1-.3-.4-.5-.6-.4a6 6 0 00-4.1 3.7z"/><circle cx="14" cy="4" r="1"/><circle cx="12" cy="2" r="1"/><circle cx="10" cy="4" r="1"/></g></svg>',
	    'text-color': '<svg width="24" height="24"><g fill-rule="evenodd"><path id="tox-icon-text-color__color" d="M3 18h18v3H3z"/><path d="M8.7 16h-.8a.5.5 0 01-.5-.6l2.7-9c.1-.3.3-.4.5-.4h2.8c.2 0 .4.1.5.4l2.7 9a.5.5 0 01-.5.6h-.8a.5.5 0 01-.4-.4l-.7-2.2c0-.3-.3-.4-.5-.4h-3.4c-.2 0-.4.1-.5.4l-.7 2.2c0 .3-.2.4-.4.4zm2.6-7.6l-.6 2a.5.5 0 00.5.6h1.6a.5.5 0 00.5-.6l-.6-2c0-.3-.3-.4-.5-.4h-.4c-.2 0-.4.1-.5.4z"/></g></svg>',
	    'toc': '<svg width="24" height="24"><path d="M5 5c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 110-2zm3 0h11c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm-3 8c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h11c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm0-4c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 110-2zm3 0h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-3 8c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'translate': '<svg width="24" height="24"><path d="M12.7 14.3l-.3.7-.4.7-2.2-2.2-3.1 3c-.3.4-.8.4-1 0a.7.7 0 010-1l3.1-3A12.4 12.4 0 016.7 9H8a10.1 10.1 0 001.7 2.4c.5-.5 1-1.1 1.4-1.8l.9-2H4.7a.7.7 0 110-1.5h4.4v-.7c0-.4.3-.8.7-.8.4 0 .7.4.7.8v.7H15c.4 0 .8.3.8.7 0 .4-.4.8-.8.8h-1.4a12.3 12.3 0 01-1 2.4 13.5 13.5 0 01-1.7 2.3l1.9 1.8zm4.3-3l2.7 7.3a.5.5 0 01-.4.7 1 1 0 01-1-.7l-.6-1.5h-3.4l-.6 1.5a1 1 0 01-1 .7.5.5 0 01-.4-.7l2.7-7.4a1 1 0 012 0zm-2.2 4.4h2.4L16 12.5l-1.2 3.2z" fill-rule="evenodd"/></svg>',
	    'underline': '<svg width="24" height="24"><path d="M16 5c.6 0 1 .4 1 1v5.5a4 4 0 01-.4 1.8l-1 1.4a5.3 5.3 0 01-5.5 1 5 5 0 01-1.6-1c-.5-.4-.8-.9-1.1-1.4a4 4 0 01-.4-1.8V6c0-.6.4-1 1-1s1 .4 1 1v5.5c0 .3 0 .6.2 1l.6.7a3.3 3.3 0 002.2.8 3.4 3.4 0 002.2-.8c.3-.2.4-.5.6-.8l.2-.9V6c0-.6.4-1 1-1zM8 17h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
	    'undo': '<svg width="24" height="24"><path d="M6.4 8H12c3.7 0 6.2 2 6.8 5.1.6 2.7-.4 5.6-2.3 6.8a1 1 0 01-1-1.8c1.1-.6 1.8-2.7 1.4-4.6-.5-2.1-2.1-3.5-4.9-3.5H6.4l3.3 3.3a1 1 0 11-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 1.4L6.4 8z" fill-rule="nonzero"/></svg>',
	    'unlink': '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2 2a2 2 0 102.6 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2.1-2a2 2 0 10-2.7-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2zM7.6 6.3a.8.8 0 01-1 1.1L3.3 4.2a.7.7 0 111-1l3.2 3.1zM5.1 8.6a.8.8 0 010 1.5H3a.8.8 0 010-1.5H5zm5-3.5a.8.8 0 01-1.5 0V3a.8.8 0 011.5 0V5zm6 11.8a.8.8 0 011-1l3.2 3.2a.8.8 0 01-1 1L16 17zm-2.2 2a.8.8 0 011.5 0V21a.8.8 0 01-1.5 0V19zm5-3.5a.7.7 0 110-1.5H21a.8.8 0 010 1.5H19z" fill-rule="nonzero"/></svg>',
	    'unlock': '<svg width="24" height="24"><path d="M16 5c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v3h-2V8a1 1 0 00-.3-.7A1 1 0 0016 7h-2a1 1 0 00-.7.3 1 1 0 00-.3.7v3h.3c.2 0 .3 0 .5.2l.2.6v7.4c0 .3 0 .4-.2.6l-.6.2H4.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6v-7.4c0-.3 0-.4.2-.6l.5-.2H11V8c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h2z" fill-rule="evenodd"/></svg>',
	    'unordered-list': '<svg width="24" height="24"><path d="M11 5h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zM4.5 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1z" fill-rule="evenodd"/></svg>',
	    'unselected': '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm0 1a1 1 0 00-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H6z"/></svg>',
	    'upload': '<svg width="24" height="24"><path d="M18 19v-2a1 1 0 012 0v3c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-3a1 1 0 012 0v2h12zM11 6.4L8.7 8.7a1 1 0 01-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 11-1.4 1.4L13 6.4V16a1 1 0 01-2 0V6.4z" fill-rule="nonzero"/></svg>',
	    'user': '<svg width="24" height="24"><path d="M12 24a12 12 0 110-24 12 12 0 010 24zm-8.7-5.3a11 11 0 0017.4 0C19.4 16.3 14.6 15 12 15c-2.6 0-7.4 1.3-8.7 3.7zM12 13c2.2 0 4-2 4-4.5S14.2 4 12 4 8 6 8 8.5 9.8 13 12 13z" fill-rule="nonzero"/></svg>',
	    'visualblocks': '<svg width="24" height="24"><path d="M9 19v2H7v-2h2zm-4 0v2a2 2 0 01-2-2h2zm8 0v2h-2v-2h2zm8 0a2 2 0 01-2 2v-2h2zm-4 0v2h-2v-2h2zM15 7a1 1 0 010 2v7a1 1 0 01-2 0V9h-1v7a1 1 0 01-2 0v-4a2.5 2.5 0 01-.2-5H15zM5 15v2H3v-2h2zm16 0v2h-2v-2h2zM5 11v2H3v-2h2zm16 0v2h-2v-2h2zM5 7v2H3V7h2zm16 0v2h-2V7h2zM5 3v2H3c0-1.1.9-2 2-2zm8 0v2h-2V3h2zm6 0a2 2 0 012 2h-2V3zM9 3v2H7V3h2zm8 0v2h-2V3h2z" fill-rule="evenodd"/></svg>',
	    'visualchars': '<svg width="24" height="24"><path d="M10 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 016.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L10 5z" fill-rule="evenodd"/></svg>',
	    'warning': '<svg width="24" height="24"><path d="M19.8 18.3c.2.5.3.9 0 1.2-.1.3-.5.5-1 .5H5.2c-.5 0-.9-.2-1-.5-.3-.3-.2-.7 0-1.2L11 4.7l.5-.5.5-.2c.2 0 .3 0 .5.2.2 0 .3.3.5.5l6.8 13.6zM12 18c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7a1 1 0 00-.3-.7 1 1 0 00-.7-.3 1 1 0 00-.7.3 1 1 0 00-.3.7c0 .3.1.5.3.7.2.2.4.3.7.3zm.7-3l.3-4a1 1 0 00-.3-.7 1 1 0 00-.7-.3 1 1 0 00-.7.3 1 1 0 00-.3.7l.3 4h1.4z" fill-rule="evenodd"/></svg>',
	    'zoom-in': '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12zm-1-9a1 1 0 012 0v6a1 1 0 01-2 0V8zm-2 4a1 1 0 010-2h6a1 1 0 010 2H8z" fill-rule="nonzero"/></svg>',
	    'zoom-out': '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12zm-3-5a1 1 0 010-2h6a1 1 0 010 2H8z" fill-rule="nonzero"/></svg>',
	  }
	});

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "default" icons for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/icons/default')
	//   ES2015:
	//     import 'tinymce/icons/default'
	__webpack_require__(1197);

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "advlist" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/advlist')
	//   ES2015:
	//     import 'tinymce/plugins/advlist'
	__webpack_require__(1200);

/***/ },
/* 1200 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var applyListFormat = function (editor, listName, styleValue) {
	      var cmd = listName === 'UL' ? 'InsertUnorderedList' : 'InsertOrderedList';
	      editor.execCommand(cmd, false, styleValue === false ? null : { 'list-style-type': styleValue });
	    };
	
	    var register = function (editor) {
	      editor.addCommand('ApplyUnorderedListStyle', function (ui, value) {
	        applyListFormat(editor, 'UL', value['list-style-type']);
	      });
	      editor.addCommand('ApplyOrderedListStyle', function (ui, value) {
	        applyListFormat(editor, 'OL', value['list-style-type']);
	      });
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getNumberStyles = function (editor) {
	      var styles = editor.getParam('advlist_number_styles', 'default,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman');
	      return styles ? styles.split(/[ ,]/) : [];
	    };
	    var getBulletStyles = function (editor) {
	      var styles = editor.getParam('advlist_bullet_styles', 'default,circle,square');
	      return styles ? styles.split(/[ ,]/) : [];
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var isChildOfBody = function (editor, elm) {
	      return editor.$.contains(editor.getBody(), elm);
	    };
	    var isTableCellNode = function (node) {
	      return node && /^(TH|TD)$/.test(node.nodeName);
	    };
	    var isListNode = function (editor) {
	      return function (node) {
	        return node && /^(OL|UL|DL)$/.test(node.nodeName) && isChildOfBody(editor, node);
	      };
	    };
	    var getSelectedStyleType = function (editor) {
	      var listElm = editor.dom.getParent(editor.selection.getNode(), 'ol,ul');
	      var style = editor.dom.getStyle(listElm, 'listStyleType');
	      return Optional.from(style);
	    };
	
	    var findIndex = function (list, predicate) {
	      for (var index = 0; index < list.length; index++) {
	        var element = list[index];
	        if (predicate(element)) {
	          return index;
	        }
	      }
	      return -1;
	    };
	    var styleValueToText = function (styleValue) {
	      return styleValue.replace(/\-/g, ' ').replace(/\b\w/g, function (chr) {
	        return chr.toUpperCase();
	      });
	    };
	    var isWithinList = function (editor, e, nodeName) {
	      var tableCellIndex = findIndex(e.parents, isTableCellNode);
	      var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
	      var lists = global$1.grep(parents, isListNode(editor));
	      return lists.length > 0 && lists[0].nodeName === nodeName;
	    };
	    var addSplitButton = function (editor, id, tooltip, cmd, nodeName, styles) {
	      editor.ui.registry.addSplitButton(id, {
	        tooltip: tooltip,
	        icon: nodeName === 'OL' ? 'ordered-list' : 'unordered-list',
	        presets: 'listpreview',
	        columns: 3,
	        fetch: function (callback) {
	          var items = global$1.map(styles, function (styleValue) {
	            var iconStyle = nodeName === 'OL' ? 'num' : 'bull';
	            var iconName = styleValue === 'disc' || styleValue === 'decimal' ? 'default' : styleValue;
	            var itemValue = styleValue === 'default' ? '' : styleValue;
	            var displayText = styleValueToText(styleValue);
	            return {
	              type: 'choiceitem',
	              value: itemValue,
	              icon: 'list-' + iconStyle + '-' + iconName,
	              text: displayText
	            };
	          });
	          callback(items);
	        },
	        onAction: function () {
	          return editor.execCommand(cmd);
	        },
	        onItemAction: function (_splitButtonApi, value) {
	          applyListFormat(editor, nodeName, value);
	        },
	        select: function (value) {
	          var listStyleType = getSelectedStyleType(editor);
	          return listStyleType.map(function (listStyle) {
	            return value === listStyle;
	          }).getOr(false);
	        },
	        onSetup: function (api) {
	          var nodeChangeHandler = function (e) {
	            api.setActive(isWithinList(editor, e, nodeName));
	          };
	          editor.on('NodeChange', nodeChangeHandler);
	          return function () {
	            return editor.off('NodeChange', nodeChangeHandler);
	          };
	        }
	      });
	    };
	    var addButton = function (editor, id, tooltip, cmd, nodeName, _styles) {
	      editor.ui.registry.addToggleButton(id, {
	        active: false,
	        tooltip: tooltip,
	        icon: nodeName === 'OL' ? 'ordered-list' : 'unordered-list',
	        onSetup: function (api) {
	          var nodeChangeHandler = function (e) {
	            api.setActive(isWithinList(editor, e, nodeName));
	          };
	          editor.on('NodeChange', nodeChangeHandler);
	          return function () {
	            return editor.off('NodeChange', nodeChangeHandler);
	          };
	        },
	        onAction: function () {
	          return editor.execCommand(cmd);
	        }
	      });
	    };
	    var addControl = function (editor, id, tooltip, cmd, nodeName, styles) {
	      if (styles.length > 1) {
	        addSplitButton(editor, id, tooltip, cmd, nodeName, styles);
	      } else {
	        addButton(editor, id, tooltip, cmd, nodeName);
	      }
	    };
	    var register$1 = function (editor) {
	      addControl(editor, 'numlist', 'Numbered list', 'InsertOrderedList', 'OL', getNumberStyles(editor));
	      addControl(editor, 'bullist', 'Bullet list', 'InsertUnorderedList', 'UL', getBulletStyles(editor));
	    };
	
	    function Plugin () {
	      global.add('advlist', function (editor) {
	        if (editor.hasPlugin('lists')) {
	          register$1(editor);
	          register(editor);
	        } else {
	          console.error('Please use the Lists plugin together with the Advanced List plugin.');
	        }
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "anchor" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/anchor')
	//   ES2015:
	//     import 'tinymce/plugins/anchor'
	__webpack_require__(1202);

/***/ },
/* 1202 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var allowHtmlInNamedAnchor = function (editor) {
	      return editor.getParam('allow_html_in_named_anchor', false, 'boolean');
	    };
	
	    var namedAnchorSelector = 'a:not([href])';
	    var isEmptyString = function (str) {
	      return !str;
	    };
	    var getIdFromAnchor = function (elm) {
	      var id = elm.getAttribute('id') || elm.getAttribute('name');
	      return id || '';
	    };
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName.toLowerCase() === 'a';
	    };
	    var isNamedAnchor = function (elm) {
	      return isAnchor(elm) && !elm.getAttribute('href') && getIdFromAnchor(elm) !== '';
	    };
	    var isEmptyNamedAnchor = function (elm) {
	      return isNamedAnchor(elm) && !elm.firstChild;
	    };
	
	    var removeEmptyNamedAnchorsInSelection = function (editor) {
	      var dom = editor.dom;
	      global$1(dom).walk(editor.selection.getRng(), function (nodes) {
	        global$2.each(nodes, function (node) {
	          if (isEmptyNamedAnchor(node)) {
	            dom.remove(node, false);
	          }
	        });
	      });
	    };
	    var isValidId = function (id) {
	      return /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(id);
	    };
	    var getNamedAnchor = function (editor) {
	      return editor.dom.getParent(editor.selection.getStart(), namedAnchorSelector);
	    };
	    var getId = function (editor) {
	      var anchor = getNamedAnchor(editor);
	      if (anchor) {
	        return getIdFromAnchor(anchor);
	      } else {
	        return '';
	      }
	    };
	    var createAnchor = function (editor, id) {
	      editor.undoManager.transact(function () {
	        if (!allowHtmlInNamedAnchor(editor)) {
	          editor.selection.collapse(true);
	        }
	        if (editor.selection.isCollapsed()) {
	          editor.insertContent(editor.dom.createHTML('a', { id: id }));
	        } else {
	          removeEmptyNamedAnchorsInSelection(editor);
	          editor.formatter.remove('namedAnchor', null, null, true);
	          editor.formatter.apply('namedAnchor', { value: id });
	          editor.addVisual();
	        }
	      });
	    };
	    var updateAnchor = function (editor, id, anchorElement) {
	      anchorElement.removeAttribute('name');
	      anchorElement.id = id;
	      editor.addVisual();
	      editor.undoManager.add();
	    };
	    var insert = function (editor, id) {
	      var anchor = getNamedAnchor(editor);
	      if (anchor) {
	        updateAnchor(editor, id, anchor);
	      } else {
	        createAnchor(editor, id);
	      }
	      editor.focus();
	    };
	
	    var insertAnchor = function (editor, newId) {
	      if (!isValidId(newId)) {
	        editor.windowManager.alert('Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.');
	        return false;
	      } else {
	        insert(editor, newId);
	        return true;
	      }
	    };
	    var open = function (editor) {
	      var currentId = getId(editor);
	      editor.windowManager.open({
	        title: 'Anchor',
	        size: 'normal',
	        body: {
	          type: 'panel',
	          items: [{
	              name: 'id',
	              type: 'input',
	              label: 'ID',
	              placeholder: 'example'
	            }]
	        },
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: { id: currentId },
	        onSubmit: function (api) {
	          if (insertAnchor(editor, api.getData().id)) {
	            api.close();
	          }
	        }
	      });
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceAnchor', function () {
	        open(editor);
	      });
	    };
	
	    var isNamedAnchorNode = function (node) {
	      return node && isEmptyString(node.attr('href')) && !isEmptyString(node.attr('id') || node.attr('name'));
	    };
	    var isEmptyNamedAnchorNode = function (node) {
	      return isNamedAnchorNode(node) && !node.firstChild;
	    };
	    var setContentEditable = function (state) {
	      return function (nodes) {
	        for (var i = 0; i < nodes.length; i++) {
	          var node = nodes[i];
	          if (isEmptyNamedAnchorNode(node)) {
	            node.attr('contenteditable', state);
	          }
	        }
	      };
	    };
	    var setup = function (editor) {
	      editor.on('PreInit', function () {
	        editor.parser.addNodeFilter('a', setContentEditable('false'));
	        editor.serializer.addNodeFilter('a', setContentEditable(null));
	      });
	    };
	
	    var registerFormats = function (editor) {
	      editor.formatter.register('namedAnchor', {
	        inline: 'a',
	        selector: namedAnchorSelector,
	        remove: 'all',
	        split: true,
	        deep: true,
	        attributes: { id: '%value' },
	        onmatch: function (node, _fmt, _itemName) {
	          return isNamedAnchor(node);
	        }
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addToggleButton('anchor', {
	        icon: 'bookmark',
	        tooltip: 'Anchor',
	        onAction: function () {
	          return editor.execCommand('mceAnchor');
	        },
	        onSetup: function (buttonApi) {
	          return editor.selection.selectorChangedWithUnbind('a:not([href])', buttonApi.setActive).unbind;
	        }
	      });
	      editor.ui.registry.addMenuItem('anchor', {
	        icon: 'bookmark',
	        text: 'Anchor...',
	        onAction: function () {
	          return editor.execCommand('mceAnchor');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('anchor', function (editor) {
	        setup(editor);
	        register(editor);
	        register$1(editor);
	        editor.on('PreInit', function () {
	          registerFormats(editor);
	        });
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "autolink" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/autolink')
	//   ES2015:
	//     import 'tinymce/plugins/autolink'
	__webpack_require__(1204);

/***/ },
/* 1204 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var getAutoLinkPattern = function (editor) {
	      return editor.getParam('autolink_pattern', /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.|(?:mailto:)?[A-Z0-9._%+\-]+@(?!.*@))(.+)$/i);
	    };
	    var getDefaultLinkTarget = function (editor) {
	      return editor.getParam('default_link_target', false);
	    };
	    var getDefaultLinkProtocol = function (editor) {
	      return editor.getParam('link_default_protocol', 'http', 'string');
	    };
	
	    var rangeEqualsDelimiterOrSpace = function (rangeString, delimiter) {
	      return rangeString === delimiter || rangeString === ' ' || rangeString.charCodeAt(0) === 160;
	    };
	    var handleEclipse = function (editor) {
	      parseCurrentLine(editor, -1, '(');
	    };
	    var handleSpacebar = function (editor) {
	      parseCurrentLine(editor, 0, '');
	    };
	    var handleEnter = function (editor) {
	      parseCurrentLine(editor, -1, '');
	    };
	    var scopeIndex = function (container, index) {
	      if (index < 0) {
	        index = 0;
	      }
	      if (container.nodeType === 3) {
	        var len = container.data.length;
	        if (index > len) {
	          index = len;
	        }
	      }
	      return index;
	    };
	    var setStart = function (rng, container, offset) {
	      if (container.nodeType !== 1 || container.hasChildNodes()) {
	        rng.setStart(container, scopeIndex(container, offset));
	      } else {
	        rng.setStartBefore(container);
	      }
	    };
	    var setEnd = function (rng, container, offset) {
	      if (container.nodeType !== 1 || container.hasChildNodes()) {
	        rng.setEnd(container, scopeIndex(container, offset));
	      } else {
	        rng.setEndAfter(container);
	      }
	    };
	    var parseCurrentLine = function (editor, endOffset, delimiter) {
	      var end, endContainer, bookmark, text, prev, len, rngText;
	      var autoLinkPattern = getAutoLinkPattern(editor);
	      var defaultLinkTarget = getDefaultLinkTarget(editor);
	      if (editor.selection.getNode().tagName === 'A') {
	        return;
	      }
	      var rng = editor.selection.getRng().cloneRange();
	      if (rng.startOffset < 5) {
	        prev = rng.endContainer.previousSibling;
	        if (!prev) {
	          if (!rng.endContainer.firstChild || !rng.endContainer.firstChild.nextSibling) {
	            return;
	          }
	          prev = rng.endContainer.firstChild.nextSibling;
	        }
	        len = prev.length;
	        setStart(rng, prev, len);
	        setEnd(rng, prev, len);
	        if (rng.endOffset < 5) {
	          return;
	        }
	        end = rng.endOffset;
	        endContainer = prev;
	      } else {
	        endContainer = rng.endContainer;
	        if (endContainer.nodeType !== 3 && endContainer.firstChild) {
	          while (endContainer.nodeType !== 3 && endContainer.firstChild) {
	            endContainer = endContainer.firstChild;
	          }
	          if (endContainer.nodeType === 3) {
	            setStart(rng, endContainer, 0);
	            setEnd(rng, endContainer, endContainer.nodeValue.length);
	          }
	        }
	        if (rng.endOffset === 1) {
	          end = 2;
	        } else {
	          end = rng.endOffset - 1 - endOffset;
	        }
	      }
	      var start = end;
	      do {
	        setStart(rng, endContainer, end >= 2 ? end - 2 : 0);
	        setEnd(rng, endContainer, end >= 1 ? end - 1 : 0);
	        end -= 1;
	        rngText = rng.toString();
	      } while (rngText !== ' ' && rngText !== '' && rngText.charCodeAt(0) !== 160 && end - 2 >= 0 && rngText !== delimiter);
	      if (rangeEqualsDelimiterOrSpace(rng.toString(), delimiter)) {
	        setStart(rng, endContainer, end);
	        setEnd(rng, endContainer, start);
	        end += 1;
	      } else if (rng.startOffset === 0) {
	        setStart(rng, endContainer, 0);
	        setEnd(rng, endContainer, start);
	      } else {
	        setStart(rng, endContainer, end);
	        setEnd(rng, endContainer, start);
	      }
	      text = rng.toString();
	      if (text.charAt(text.length - 1) === '.') {
	        setEnd(rng, endContainer, start - 1);
	      }
	      text = rng.toString().trim();
	      var matches = text.match(autoLinkPattern);
	      var protocol = getDefaultLinkProtocol(editor);
	      if (matches) {
	        if (matches[1] === 'www.') {
	          matches[1] = protocol + '://www.';
	        } else if (/@$/.test(matches[1]) && !/^mailto:/.test(matches[1])) {
	          matches[1] = 'mailto:' + matches[1];
	        }
	        bookmark = editor.selection.getBookmark();
	        editor.selection.setRng(rng);
	        editor.execCommand('createlink', false, matches[1] + matches[2]);
	        if (defaultLinkTarget !== false) {
	          editor.dom.setAttrib(editor.selection.getNode(), 'target', defaultLinkTarget);
	        }
	        editor.selection.moveToBookmark(bookmark);
	        editor.nodeChanged();
	      }
	    };
	    var setup = function (editor) {
	      var autoUrlDetectState;
	      editor.on('keydown', function (e) {
	        if (e.keyCode === 13) {
	          return handleEnter(editor);
	        }
	      });
	      if (global$1.browser.isIE()) {
	        editor.on('focus', function () {
	          if (!autoUrlDetectState) {
	            autoUrlDetectState = true;
	            try {
	              editor.execCommand('AutoUrlDetect', false, true);
	            } catch (ex) {
	            }
	          }
	        });
	        return;
	      }
	      editor.on('keypress', function (e) {
	        if (e.keyCode === 41) {
	          return handleEclipse(editor);
	        }
	      });
	      editor.on('keyup', function (e) {
	        if (e.keyCode === 32) {
	          return handleSpacebar(editor);
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('autolink', function (editor) {
	        setup(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "charmap" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/charmap')
	//   ES2015:
	//     import 'tinymce/plugins/charmap'
	__webpack_require__(1206);

/***/ },
/* 1206 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var fireInsertCustomChar = function (editor, chr) {
	      return editor.fire('insertCustomChar', { chr: chr });
	    };
	
	    var insertChar = function (editor, chr) {
	      var evtChr = fireInsertCustomChar(editor, chr).chr;
	      editor.execCommand('mceInsertContent', false, evtChr);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isArray = isType('array');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getCharMap = function (editor) {
	      return editor.getParam('charmap');
	    };
	    var getCharMapAppend = function (editor) {
	      return editor.getParam('charmap_append');
	    };
	
	    var isArray$1 = global$1.isArray;
	    var UserDefined = 'User Defined';
	    var getDefaultCharMap = function () {
	      return [
	        {
	          name: 'Currency',
	          characters: [
	            [
	              36,
	              'dollar sign'
	            ],
	            [
	              162,
	              'cent sign'
	            ],
	            [
	              8364,
	              'euro sign'
	            ],
	            [
	              163,
	              'pound sign'
	            ],
	            [
	              165,
	              'yen sign'
	            ],
	            [
	              164,
	              'currency sign'
	            ],
	            [
	              8352,
	              'euro-currency sign'
	            ],
	            [
	              8353,
	              'colon sign'
	            ],
	            [
	              8354,
	              'cruzeiro sign'
	            ],
	            [
	              8355,
	              'french franc sign'
	            ],
	            [
	              8356,
	              'lira sign'
	            ],
	            [
	              8357,
	              'mill sign'
	            ],
	            [
	              8358,
	              'naira sign'
	            ],
	            [
	              8359,
	              'peseta sign'
	            ],
	            [
	              8360,
	              'rupee sign'
	            ],
	            [
	              8361,
	              'won sign'
	            ],
	            [
	              8362,
	              'new sheqel sign'
	            ],
	            [
	              8363,
	              'dong sign'
	            ],
	            [
	              8365,
	              'kip sign'
	            ],
	            [
	              8366,
	              'tugrik sign'
	            ],
	            [
	              8367,
	              'drachma sign'
	            ],
	            [
	              8368,
	              'german penny symbol'
	            ],
	            [
	              8369,
	              'peso sign'
	            ],
	            [
	              8370,
	              'guarani sign'
	            ],
	            [
	              8371,
	              'austral sign'
	            ],
	            [
	              8372,
	              'hryvnia sign'
	            ],
	            [
	              8373,
	              'cedi sign'
	            ],
	            [
	              8374,
	              'livre tournois sign'
	            ],
	            [
	              8375,
	              'spesmilo sign'
	            ],
	            [
	              8376,
	              'tenge sign'
	            ],
	            [
	              8377,
	              'indian rupee sign'
	            ],
	            [
	              8378,
	              'turkish lira sign'
	            ],
	            [
	              8379,
	              'nordic mark sign'
	            ],
	            [
	              8380,
	              'manat sign'
	            ],
	            [
	              8381,
	              'ruble sign'
	            ],
	            [
	              20870,
	              'yen character'
	            ],
	            [
	              20803,
	              'yuan character'
	            ],
	            [
	              22291,
	              'yuan character, in hong kong and taiwan'
	            ],
	            [
	              22278,
	              'yen/yuan character variant one'
	            ]
	          ]
	        },
	        {
	          name: 'Text',
	          characters: [
	            [
	              169,
	              'copyright sign'
	            ],
	            [
	              174,
	              'registered sign'
	            ],
	            [
	              8482,
	              'trade mark sign'
	            ],
	            [
	              8240,
	              'per mille sign'
	            ],
	            [
	              181,
	              'micro sign'
	            ],
	            [
	              183,
	              'middle dot'
	            ],
	            [
	              8226,
	              'bullet'
	            ],
	            [
	              8230,
	              'three dot leader'
	            ],
	            [
	              8242,
	              'minutes / feet'
	            ],
	            [
	              8243,
	              'seconds / inches'
	            ],
	            [
	              167,
	              'section sign'
	            ],
	            [
	              182,
	              'paragraph sign'
	            ],
	            [
	              223,
	              'sharp s / ess-zed'
	            ]
	          ]
	        },
	        {
	          name: 'Quotations',
	          characters: [
	            [
	              8249,
	              'single left-pointing angle quotation mark'
	            ],
	            [
	              8250,
	              'single right-pointing angle quotation mark'
	            ],
	            [
	              171,
	              'left pointing guillemet'
	            ],
	            [
	              187,
	              'right pointing guillemet'
	            ],
	            [
	              8216,
	              'left single quotation mark'
	            ],
	            [
	              8217,
	              'right single quotation mark'
	            ],
	            [
	              8220,
	              'left double quotation mark'
	            ],
	            [
	              8221,
	              'right double quotation mark'
	            ],
	            [
	              8218,
	              'single low-9 quotation mark'
	            ],
	            [
	              8222,
	              'double low-9 quotation mark'
	            ],
	            [
	              60,
	              'less-than sign'
	            ],
	            [
	              62,
	              'greater-than sign'
	            ],
	            [
	              8804,
	              'less-than or equal to'
	            ],
	            [
	              8805,
	              'greater-than or equal to'
	            ],
	            [
	              8211,
	              'en dash'
	            ],
	            [
	              8212,
	              'em dash'
	            ],
	            [
	              175,
	              'macron'
	            ],
	            [
	              8254,
	              'overline'
	            ],
	            [
	              164,
	              'currency sign'
	            ],
	            [
	              166,
	              'broken bar'
	            ],
	            [
	              168,
	              'diaeresis'
	            ],
	            [
	              161,
	              'inverted exclamation mark'
	            ],
	            [
	              191,
	              'turned question mark'
	            ],
	            [
	              710,
	              'circumflex accent'
	            ],
	            [
	              732,
	              'small tilde'
	            ],
	            [
	              176,
	              'degree sign'
	            ],
	            [
	              8722,
	              'minus sign'
	            ],
	            [
	              177,
	              'plus-minus sign'
	            ],
	            [
	              247,
	              'division sign'
	            ],
	            [
	              8260,
	              'fraction slash'
	            ],
	            [
	              215,
	              'multiplication sign'
	            ],
	            [
	              185,
	              'superscript one'
	            ],
	            [
	              178,
	              'superscript two'
	            ],
	            [
	              179,
	              'superscript three'
	            ],
	            [
	              188,
	              'fraction one quarter'
	            ],
	            [
	              189,
	              'fraction one half'
	            ],
	            [
	              190,
	              'fraction three quarters'
	            ]
	          ]
	        },
	        {
	          name: 'Mathematical',
	          characters: [
	            [
	              402,
	              'function / florin'
	            ],
	            [
	              8747,
	              'integral'
	            ],
	            [
	              8721,
	              'n-ary sumation'
	            ],
	            [
	              8734,
	              'infinity'
	            ],
	            [
	              8730,
	              'square root'
	            ],
	            [
	              8764,
	              'similar to'
	            ],
	            [
	              8773,
	              'approximately equal to'
	            ],
	            [
	              8776,
	              'almost equal to'
	            ],
	            [
	              8800,
	              'not equal to'
	            ],
	            [
	              8801,
	              'identical to'
	            ],
	            [
	              8712,
	              'element of'
	            ],
	            [
	              8713,
	              'not an element of'
	            ],
	            [
	              8715,
	              'contains as member'
	            ],
	            [
	              8719,
	              'n-ary product'
	            ],
	            [
	              8743,
	              'logical and'
	            ],
	            [
	              8744,
	              'logical or'
	            ],
	            [
	              172,
	              'not sign'
	            ],
	            [
	              8745,
	              'intersection'
	            ],
	            [
	              8746,
	              'union'
	            ],
	            [
	              8706,
	              'partial differential'
	            ],
	            [
	              8704,
	              'for all'
	            ],
	            [
	              8707,
	              'there exists'
	            ],
	            [
	              8709,
	              'diameter'
	            ],
	            [
	              8711,
	              'backward difference'
	            ],
	            [
	              8727,
	              'asterisk operator'
	            ],
	            [
	              8733,
	              'proportional to'
	            ],
	            [
	              8736,
	              'angle'
	            ]
	          ]
	        },
	        {
	          name: 'Extended Latin',
	          characters: [
	            [
	              192,
	              'A - grave'
	            ],
	            [
	              193,
	              'A - acute'
	            ],
	            [
	              194,
	              'A - circumflex'
	            ],
	            [
	              195,
	              'A - tilde'
	            ],
	            [
	              196,
	              'A - diaeresis'
	            ],
	            [
	              197,
	              'A - ring above'
	            ],
	            [
	              256,
	              'A - macron'
	            ],
	            [
	              198,
	              'ligature AE'
	            ],
	            [
	              199,
	              'C - cedilla'
	            ],
	            [
	              200,
	              'E - grave'
	            ],
	            [
	              201,
	              'E - acute'
	            ],
	            [
	              202,
	              'E - circumflex'
	            ],
	            [
	              203,
	              'E - diaeresis'
	            ],
	            [
	              274,
	              'E - macron'
	            ],
	            [
	              204,
	              'I - grave'
	            ],
	            [
	              205,
	              'I - acute'
	            ],
	            [
	              206,
	              'I - circumflex'
	            ],
	            [
	              207,
	              'I - diaeresis'
	            ],
	            [
	              298,
	              'I - macron'
	            ],
	            [
	              208,
	              'ETH'
	            ],
	            [
	              209,
	              'N - tilde'
	            ],
	            [
	              210,
	              'O - grave'
	            ],
	            [
	              211,
	              'O - acute'
	            ],
	            [
	              212,
	              'O - circumflex'
	            ],
	            [
	              213,
	              'O - tilde'
	            ],
	            [
	              214,
	              'O - diaeresis'
	            ],
	            [
	              216,
	              'O - slash'
	            ],
	            [
	              332,
	              'O - macron'
	            ],
	            [
	              338,
	              'ligature OE'
	            ],
	            [
	              352,
	              'S - caron'
	            ],
	            [
	              217,
	              'U - grave'
	            ],
	            [
	              218,
	              'U - acute'
	            ],
	            [
	              219,
	              'U - circumflex'
	            ],
	            [
	              220,
	              'U - diaeresis'
	            ],
	            [
	              362,
	              'U - macron'
	            ],
	            [
	              221,
	              'Y - acute'
	            ],
	            [
	              376,
	              'Y - diaeresis'
	            ],
	            [
	              562,
	              'Y - macron'
	            ],
	            [
	              222,
	              'THORN'
	            ],
	            [
	              224,
	              'a - grave'
	            ],
	            [
	              225,
	              'a - acute'
	            ],
	            [
	              226,
	              'a - circumflex'
	            ],
	            [
	              227,
	              'a - tilde'
	            ],
	            [
	              228,
	              'a - diaeresis'
	            ],
	            [
	              229,
	              'a - ring above'
	            ],
	            [
	              257,
	              'a - macron'
	            ],
	            [
	              230,
	              'ligature ae'
	            ],
	            [
	              231,
	              'c - cedilla'
	            ],
	            [
	              232,
	              'e - grave'
	            ],
	            [
	              233,
	              'e - acute'
	            ],
	            [
	              234,
	              'e - circumflex'
	            ],
	            [
	              235,
	              'e - diaeresis'
	            ],
	            [
	              275,
	              'e - macron'
	            ],
	            [
	              236,
	              'i - grave'
	            ],
	            [
	              237,
	              'i - acute'
	            ],
	            [
	              238,
	              'i - circumflex'
	            ],
	            [
	              239,
	              'i - diaeresis'
	            ],
	            [
	              299,
	              'i - macron'
	            ],
	            [
	              240,
	              'eth'
	            ],
	            [
	              241,
	              'n - tilde'
	            ],
	            [
	              242,
	              'o - grave'
	            ],
	            [
	              243,
	              'o - acute'
	            ],
	            [
	              244,
	              'o - circumflex'
	            ],
	            [
	              245,
	              'o - tilde'
	            ],
	            [
	              246,
	              'o - diaeresis'
	            ],
	            [
	              248,
	              'o slash'
	            ],
	            [
	              333,
	              'o macron'
	            ],
	            [
	              339,
	              'ligature oe'
	            ],
	            [
	              353,
	              's - caron'
	            ],
	            [
	              249,
	              'u - grave'
	            ],
	            [
	              250,
	              'u - acute'
	            ],
	            [
	              251,
	              'u - circumflex'
	            ],
	            [
	              252,
	              'u - diaeresis'
	            ],
	            [
	              363,
	              'u - macron'
	            ],
	            [
	              253,
	              'y - acute'
	            ],
	            [
	              254,
	              'thorn'
	            ],
	            [
	              255,
	              'y - diaeresis'
	            ],
	            [
	              563,
	              'y - macron'
	            ],
	            [
	              913,
	              'Alpha'
	            ],
	            [
	              914,
	              'Beta'
	            ],
	            [
	              915,
	              'Gamma'
	            ],
	            [
	              916,
	              'Delta'
	            ],
	            [
	              917,
	              'Epsilon'
	            ],
	            [
	              918,
	              'Zeta'
	            ],
	            [
	              919,
	              'Eta'
	            ],
	            [
	              920,
	              'Theta'
	            ],
	            [
	              921,
	              'Iota'
	            ],
	            [
	              922,
	              'Kappa'
	            ],
	            [
	              923,
	              'Lambda'
	            ],
	            [
	              924,
	              'Mu'
	            ],
	            [
	              925,
	              'Nu'
	            ],
	            [
	              926,
	              'Xi'
	            ],
	            [
	              927,
	              'Omicron'
	            ],
	            [
	              928,
	              'Pi'
	            ],
	            [
	              929,
	              'Rho'
	            ],
	            [
	              931,
	              'Sigma'
	            ],
	            [
	              932,
	              'Tau'
	            ],
	            [
	              933,
	              'Upsilon'
	            ],
	            [
	              934,
	              'Phi'
	            ],
	            [
	              935,
	              'Chi'
	            ],
	            [
	              936,
	              'Psi'
	            ],
	            [
	              937,
	              'Omega'
	            ],
	            [
	              945,
	              'alpha'
	            ],
	            [
	              946,
	              'beta'
	            ],
	            [
	              947,
	              'gamma'
	            ],
	            [
	              948,
	              'delta'
	            ],
	            [
	              949,
	              'epsilon'
	            ],
	            [
	              950,
	              'zeta'
	            ],
	            [
	              951,
	              'eta'
	            ],
	            [
	              952,
	              'theta'
	            ],
	            [
	              953,
	              'iota'
	            ],
	            [
	              954,
	              'kappa'
	            ],
	            [
	              955,
	              'lambda'
	            ],
	            [
	              956,
	              'mu'
	            ],
	            [
	              957,
	              'nu'
	            ],
	            [
	              958,
	              'xi'
	            ],
	            [
	              959,
	              'omicron'
	            ],
	            [
	              960,
	              'pi'
	            ],
	            [
	              961,
	              'rho'
	            ],
	            [
	              962,
	              'final sigma'
	            ],
	            [
	              963,
	              'sigma'
	            ],
	            [
	              964,
	              'tau'
	            ],
	            [
	              965,
	              'upsilon'
	            ],
	            [
	              966,
	              'phi'
	            ],
	            [
	              967,
	              'chi'
	            ],
	            [
	              968,
	              'psi'
	            ],
	            [
	              969,
	              'omega'
	            ]
	          ]
	        },
	        {
	          name: 'Symbols',
	          characters: [
	            [
	              8501,
	              'alef symbol'
	            ],
	            [
	              982,
	              'pi symbol'
	            ],
	            [
	              8476,
	              'real part symbol'
	            ],
	            [
	              978,
	              'upsilon - hook symbol'
	            ],
	            [
	              8472,
	              'Weierstrass p'
	            ],
	            [
	              8465,
	              'imaginary part'
	            ]
	          ]
	        },
	        {
	          name: 'Arrows',
	          characters: [
	            [
	              8592,
	              'leftwards arrow'
	            ],
	            [
	              8593,
	              'upwards arrow'
	            ],
	            [
	              8594,
	              'rightwards arrow'
	            ],
	            [
	              8595,
	              'downwards arrow'
	            ],
	            [
	              8596,
	              'left right arrow'
	            ],
	            [
	              8629,
	              'carriage return'
	            ],
	            [
	              8656,
	              'leftwards double arrow'
	            ],
	            [
	              8657,
	              'upwards double arrow'
	            ],
	            [
	              8658,
	              'rightwards double arrow'
	            ],
	            [
	              8659,
	              'downwards double arrow'
	            ],
	            [
	              8660,
	              'left right double arrow'
	            ],
	            [
	              8756,
	              'therefore'
	            ],
	            [
	              8834,
	              'subset of'
	            ],
	            [
	              8835,
	              'superset of'
	            ],
	            [
	              8836,
	              'not a subset of'
	            ],
	            [
	              8838,
	              'subset of or equal to'
	            ],
	            [
	              8839,
	              'superset of or equal to'
	            ],
	            [
	              8853,
	              'circled plus'
	            ],
	            [
	              8855,
	              'circled times'
	            ],
	            [
	              8869,
	              'perpendicular'
	            ],
	            [
	              8901,
	              'dot operator'
	            ],
	            [
	              8968,
	              'left ceiling'
	            ],
	            [
	              8969,
	              'right ceiling'
	            ],
	            [
	              8970,
	              'left floor'
	            ],
	            [
	              8971,
	              'right floor'
	            ],
	            [
	              9001,
	              'left-pointing angle bracket'
	            ],
	            [
	              9002,
	              'right-pointing angle bracket'
	            ],
	            [
	              9674,
	              'lozenge'
	            ],
	            [
	              9824,
	              'black spade suit'
	            ],
	            [
	              9827,
	              'black club suit'
	            ],
	            [
	              9829,
	              'black heart suit'
	            ],
	            [
	              9830,
	              'black diamond suit'
	            ],
	            [
	              8194,
	              'en space'
	            ],
	            [
	              8195,
	              'em space'
	            ],
	            [
	              8201,
	              'thin space'
	            ],
	            [
	              8204,
	              'zero width non-joiner'
	            ],
	            [
	              8205,
	              'zero width joiner'
	            ],
	            [
	              8206,
	              'left-to-right mark'
	            ],
	            [
	              8207,
	              'right-to-left mark'
	            ]
	          ]
	        }
	      ];
	    };
	    var charmapFilter = function (charmap) {
	      return global$1.grep(charmap, function (item) {
	        return isArray$1(item) && item.length === 2;
	      });
	    };
	    var getCharsFromSetting = function (settingValue) {
	      if (isArray$1(settingValue)) {
	        return [].concat(charmapFilter(settingValue));
	      }
	      if (typeof settingValue === 'function') {
	        return settingValue();
	      }
	      return [];
	    };
	    var extendCharMap = function (editor, charmap) {
	      var userCharMap = getCharMap(editor);
	      if (userCharMap) {
	        charmap = [{
	            name: UserDefined,
	            characters: getCharsFromSetting(userCharMap)
	          }];
	      }
	      var userCharMapAppend = getCharMapAppend(editor);
	      if (userCharMapAppend) {
	        var userDefinedGroup = global$1.grep(charmap, function (cg) {
	          return cg.name === UserDefined;
	        });
	        if (userDefinedGroup.length) {
	          userDefinedGroup[0].characters = [].concat(userDefinedGroup[0].characters).concat(getCharsFromSetting(userCharMapAppend));
	          return charmap;
	        }
	        return [].concat(charmap).concat({
	          name: UserDefined,
	          characters: getCharsFromSetting(userCharMapAppend)
	        });
	      }
	      return charmap;
	    };
	    var getCharMap$1 = function (editor) {
	      var groups = extendCharMap(editor, getDefaultCharMap());
	      return groups.length > 1 ? [{
	          name: 'All',
	          characters: bind(groups, function (g) {
	            return g.characters;
	          })
	        }].concat(groups) : groups;
	    };
	
	    var get = function (editor) {
	      var getCharMap = function () {
	        return getCharMap$1(editor);
	      };
	      var insertChar$1 = function (chr) {
	        insertChar(editor, chr);
	      };
	      return {
	        getCharMap: getCharMap,
	        insertChar: insertChar$1
	      };
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var last = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          clearTimeout(timer);
	        }
	        timer = setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var nativeFromCodePoint = String.fromCodePoint;
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var fromCodePoint = function () {
	      var codePoints = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        codePoints[_i] = arguments[_i];
	      }
	      if (nativeFromCodePoint) {
	        return nativeFromCodePoint.apply(void 0, codePoints);
	      } else {
	        var codeUnits = [];
	        var codeLen = 0;
	        var result = '';
	        for (var index = 0, len = codePoints.length; index !== len; ++index) {
	          var codePoint = +codePoints[index];
	          if (!(codePoint < 1114111 && codePoint >>> 0 === codePoint)) {
	            throw RangeError('Invalid code point: ' + codePoint);
	          }
	          if (codePoint <= 65535) {
	            codeLen = codeUnits.push(codePoint);
	          } else {
	            codePoint -= 65536;
	            codeLen = codeUnits.push((codePoint >> 10) + 55296, codePoint % 1024 + 56320);
	          }
	          if (codeLen >= 16383) {
	            result += String.fromCharCode.apply(null, codeUnits);
	            codeUnits.length = 0;
	          }
	        }
	        return result + String.fromCharCode.apply(null, codeUnits);
	      }
	    };
	
	    var charMatches = function (charCode, name, lowerCasePattern) {
	      if (contains(fromCodePoint(charCode).toLowerCase(), lowerCasePattern)) {
	        return true;
	      } else {
	        return contains(name.toLowerCase(), lowerCasePattern) || contains(name.toLowerCase().replace(/\s+/g, ''), lowerCasePattern);
	      }
	    };
	    var scan = function (group, pattern) {
	      var matches = [];
	      var lowerCasePattern = pattern.toLowerCase();
	      each(group.characters, function (g) {
	        if (charMatches(g[0], g[1], lowerCasePattern)) {
	          matches.push(g);
	        }
	      });
	      return map(matches, function (m) {
	        return {
	          text: m[1],
	          value: fromCodePoint(m[0]),
	          icon: fromCodePoint(m[0])
	        };
	      });
	    };
	
	    var patternName = 'pattern';
	    var open = function (editor, charMap) {
	      var makeGroupItems = function () {
	        return [
	          {
	            label: 'Search',
	            type: 'input',
	            name: patternName
	          },
	          {
	            type: 'collection',
	            name: 'results'
	          }
	        ];
	      };
	      var makeTabs = function () {
	        return map(charMap, function (charGroup) {
	          return {
	            title: charGroup.name,
	            name: charGroup.name,
	            items: makeGroupItems()
	          };
	        });
	      };
	      var makePanel = function () {
	        return {
	          type: 'panel',
	          items: makeGroupItems()
	        };
	      };
	      var makeTabPanel = function () {
	        return {
	          type: 'tabpanel',
	          tabs: makeTabs()
	        };
	      };
	      var currentTab = charMap.length === 1 ? Cell(UserDefined) : Cell('All');
	      var scanAndSet = function (dialogApi, pattern) {
	        find(charMap, function (group) {
	          return group.name === currentTab.get();
	        }).each(function (f) {
	          var items = scan(f, pattern);
	          dialogApi.setData({ results: items });
	        });
	      };
	      var SEARCH_DELAY = 40;
	      var updateFilter = last(function (dialogApi) {
	        var pattern = dialogApi.getData().pattern;
	        scanAndSet(dialogApi, pattern);
	      }, SEARCH_DELAY);
	      var body = charMap.length === 1 ? makePanel() : makeTabPanel();
	      var initialData = {
	        pattern: '',
	        results: scan(charMap[0], '')
	      };
	      var bridgeSpec = {
	        title: 'Special Character',
	        size: 'normal',
	        body: body,
	        buttons: [{
	            type: 'cancel',
	            name: 'close',
	            text: 'Close',
	            primary: true
	          }],
	        initialData: initialData,
	        onAction: function (api, details) {
	          if (details.name === 'results') {
	            insertChar(editor, details.value);
	            api.close();
	          }
	        },
	        onTabChange: function (dialogApi, details) {
	          currentTab.set(details.newTabName);
	          updateFilter.throttle(dialogApi);
	        },
	        onChange: function (dialogApi, changeData) {
	          if (changeData.name === patternName) {
	            updateFilter.throttle(dialogApi);
	          }
	        }
	      };
	      var dialogApi = editor.windowManager.open(bridgeSpec);
	      dialogApi.focus(patternName);
	    };
	
	    var register = function (editor, charMap) {
	      editor.addCommand('mceShowCharmap', function () {
	        open(editor, charMap);
	      });
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var init = function (editor, all) {
	      editor.ui.registry.addAutocompleter('charmap', {
	        ch: ':',
	        columns: 'auto',
	        minChars: 2,
	        fetch: function (pattern, _maxResults) {
	          return new global$2(function (resolve, _reject) {
	            resolve(scan(all, pattern));
	          });
	        },
	        onAction: function (autocompleteApi, rng, value) {
	          editor.selection.setRng(rng);
	          editor.insertContent(value);
	          autocompleteApi.hide();
	        }
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('charmap', {
	        icon: 'insert-character',
	        tooltip: 'Special character',
	        onAction: function () {
	          return editor.execCommand('mceShowCharmap');
	        }
	      });
	      editor.ui.registry.addMenuItem('charmap', {
	        icon: 'insert-character',
	        text: 'Special character...',
	        onAction: function () {
	          return editor.execCommand('mceShowCharmap');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('charmap', function (editor) {
	        var charMap = getCharMap$1(editor);
	        register(editor, charMap);
	        register$1(editor);
	        init(editor, charMap[0]);
	        return get(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "code" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/code')
	//   ES2015:
	//     import 'tinymce/plugins/code'
	__webpack_require__(1208);

/***/ },
/* 1208 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var setContent = function (editor, html) {
	      editor.focus();
	      editor.undoManager.transact(function () {
	        editor.setContent(html);
	      });
	      editor.selection.setCursorLocation();
	      editor.nodeChanged();
	    };
	    var getContent = function (editor) {
	      return editor.getContent({ source_view: true });
	    };
	
	    var open = function (editor) {
	      var editorContent = getContent(editor);
	      editor.windowManager.open({
	        title: 'Source Code',
	        size: 'large',
	        body: {
	          type: 'panel',
	          items: [{
	              type: 'textarea',
	              name: 'code'
	            }]
	        },
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: { code: editorContent },
	        onSubmit: function (api) {
	          setContent(editor, api.getData().code);
	          api.close();
	        }
	      });
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceCodeEditor', function () {
	        open(editor);
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('code', {
	        icon: 'sourcecode',
	        tooltip: 'Source code',
	        onAction: function () {
	          return open(editor);
	        }
	      });
	      editor.ui.registry.addMenuItem('code', {
	        icon: 'sourcecode',
	        text: 'Source code',
	        onAction: function () {
	          return open(editor);
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('code', function (editor) {
	        register(editor);
	        register$1(editor);
	        return {};
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "fullscreen" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/fullscreen')
	//   ES2015:
	//     import 'tinymce/plugins/fullscreen'
	__webpack_require__(1210);

/***/ },
/* 1210 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var get = function (fullscreenState) {
	      return {
	        isFullscreen: function () {
	          return fullscreenState.get() !== null;
	        }
	      };
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isBoolean = isSimpleType('boolean');
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var revocable = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        set: set
	      };
	    };
	    var unbindable = function () {
	      return revocable(function (s) {
	        return s.unbind();
	      });
	    };
	    var value = function () {
	      var subject = Cell(Optional.none());
	      var clear = function () {
	        return subject.set(Optional.none());
	      };
	      var set = function (s) {
	        return subject.set(Optional.some(s));
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var get$1 = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get$1(xs, 0);
	    };
	
	    var keys = Object.keys;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	    var isDocument = isType$1(DOCUMENT);
	    var isDocumentFragment = isType$1(DOCUMENT_FRAGMENT);
	
	    var is = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	
	    var owner = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner(dos);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom;
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = SugarElement.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var siblings = function (element) {
	      var filterSelf = function (elements) {
	        return filter(elements, function (x) {
	          return !eq(element, x);
	        });
	      };
	      return parent(element).map(children).map(filterSelf).getOr([]);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported$1 = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported$1() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	    var getBody = function (doc) {
	      var b = doc.dom.body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var get$2 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var remove = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var setAll = function (element, css) {
	      var dom = element.dom;
	      each$1(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$3 = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: target,
	        x: x,
	        y: y,
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: raw
	      };
	    };
	    var fromRawEvent = function (rawEvent) {
	      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
	      var stop = function () {
	        return rawEvent.stopPropagation();
	      };
	      var prevent = function () {
	        return rawEvent.preventDefault();
	      };
	      var kill = compose(prevent, stop);
	      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	    };
	    var handle = function (filter, handler) {
	      return function (rawEvent) {
	        if (filter(rawEvent)) {
	          handler(fromRawEvent(rawEvent));
	        }
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle(filter, handler);
	      element.dom.addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$1 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom.removeEventListener(event, handler, useCapture);
	    };
	
	    var filter$1 = always;
	    var bind$2 = function (element, event, handler) {
	      return bind$1(element, event, filter$1, handler);
	    };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var get$4 = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	
	    var get$5 = function (_win) {
	      var win = _win === undefined ? window : _win;
	      return Optional.from(win['visualViewport']);
	    };
	    var bounds = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var getBounds = function (_win) {
	      var win = _win === undefined ? window : _win;
	      var doc = win.document;
	      var scroll = get$4(SugarElement.fromDom(doc));
	      return get$5(win).fold(function () {
	        var html = win.document.documentElement;
	        var width = html.clientWidth;
	        var height = html.clientHeight;
	        return bounds(scroll.left, scroll.top, width, height);
	      }, function (visualViewport) {
	        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
	      });
	    };
	    var bind$3 = function (name, callback, _win) {
	      return get$5(_win).map(function (visualViewport) {
	        var handler = function (e) {
	          return callback(fromRawEvent(e));
	        };
	        visualViewport.addEventListener(name, handler);
	        return {
	          unbind: function () {
	            return visualViewport.removeEventListener(name, handler);
	          }
	        };
	      }).getOrThunk(function () {
	        return { unbind: noop };
	      });
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var fireFullscreenStateChanged = function (editor, state) {
	      editor.fire('FullscreenStateChanged', { state: state });
	    };
	
	    var getFullscreenNative = function (editor) {
	      return editor.getParam('fullscreen_native', false, 'boolean');
	    };
	
	    var getFullscreenRoot = function (editor) {
	      var elem = SugarElement.fromDom(editor.getElement());
	      return getShadowRoot(elem).map(getShadowHost).getOrThunk(function () {
	        return getBody(owner(elem));
	      });
	    };
	    var getFullscreenElement = function (root) {
	      if (root.fullscreenElement !== undefined) {
	        return root.fullscreenElement;
	      } else if (root.msFullscreenElement !== undefined) {
	        return root.msFullscreenElement;
	      } else if (root.webkitFullscreenElement !== undefined) {
	        return root.webkitFullscreenElement;
	      } else {
	        return null;
	      }
	    };
	    var getFullscreenchangeEventName = function () {
	      if (document.fullscreenElement !== undefined) {
	        return 'fullscreenchange';
	      } else if (document.msFullscreenElement !== undefined) {
	        return 'MSFullscreenChange';
	      } else if (document.webkitFullscreenElement !== undefined) {
	        return 'webkitfullscreenchange';
	      } else {
	        return 'fullscreenchange';
	      }
	    };
	    var requestFullscreen = function (sugarElem) {
	      var elem = sugarElem.dom;
	      if (elem.requestFullscreen) {
	        elem.requestFullscreen();
	      } else if (elem.msRequestFullscreen) {
	        elem.msRequestFullscreen();
	      } else if (elem.webkitRequestFullScreen) {
	        elem.webkitRequestFullScreen();
	      }
	    };
	    var exitFullscreen = function (sugarDoc) {
	      var doc = sugarDoc.dom;
	      if (doc.exitFullscreen) {
	        doc.exitFullscreen();
	      } else if (doc.msExitFullscreen) {
	        doc.msExitFullscreen();
	      } else if (doc.webkitCancelFullScreen) {
	        doc.webkitCancelFullScreen();
	      }
	    };
	    var isFullscreenElement = function (elem) {
	      return elem.dom === getFullscreenElement(owner(elem).dom);
	    };
	
	    var ancestors = function (scope, predicate, isRoot) {
	      return filter(parents(scope, isRoot), predicate);
	    };
	    var siblings$1 = function (scope, predicate) {
	      return filter(siblings(scope), predicate);
	    };
	
	    var all$1 = function (selector) {
	      return all(selector);
	    };
	    var ancestors$1 = function (scope, selector, isRoot) {
	      return ancestors(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var siblings$2 = function (scope, selector) {
	      return siblings$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	
	    var attr = 'data-ephox-mobile-fullscreen-style';
	    var siblingStyles = 'display:none!important;';
	    var ancestorPosition = 'position:absolute!important;';
	    var ancestorStyles = 'top:0!important;left:0!important;margin:0!important;padding:0!important;width:100%!important;height:100%!important;overflow:visible!important;';
	    var bgFallback = 'background-color:rgb(255,255,255)!important;';
	    var isAndroid = global$2.os.isAndroid();
	    var matchColor = function (editorBody) {
	      var color = get$3(editorBody, 'background-color');
	      return color !== undefined && color !== '' ? 'background-color:' + color + '!important' : bgFallback;
	    };
	    var clobberStyles = function (dom, container, editorBody) {
	      var gatherSiblings = function (element) {
	        return siblings$2(element, '*:not(.tox-silver-sink)');
	      };
	      var clobber = function (clobberStyle) {
	        return function (element) {
	          var styles = get$2(element, 'style');
	          var backup = styles === undefined ? 'no-styles' : styles.trim();
	          if (backup === clobberStyle) {
	            return;
	          } else {
	            set(element, attr, backup);
	            setAll(element, dom.parseStyle(clobberStyle));
	          }
	        };
	      };
	      var ancestors = ancestors$1(container, '*');
	      var siblings = bind(ancestors, gatherSiblings);
	      var bgColor = matchColor(editorBody);
	      each(siblings, clobber(siblingStyles));
	      each(ancestors, clobber(ancestorPosition + ancestorStyles + bgColor));
	      var containerStyles = isAndroid === true ? '' : ancestorPosition;
	      clobber(containerStyles + ancestorStyles + bgColor)(container);
	    };
	    var restoreStyles = function (dom) {
	      var clobberedEls = all$1('[' + attr + ']');
	      each(clobberedEls, function (element) {
	        var restore = get$2(element, attr);
	        if (restore !== 'no-styles') {
	          setAll(element, dom.parseStyle(restore));
	        } else {
	          remove(element, 'style');
	        }
	        remove(element, attr);
	      });
	    };
	
	    var DOM = global$1.DOM;
	    var getScrollPos = function () {
	      var vp = getBounds(window);
	      return {
	        x: vp.x,
	        y: vp.y
	      };
	    };
	    var setScrollPos = function (pos) {
	      window.scrollTo(pos.x, pos.y);
	    };
	    var viewportUpdate = get$5().fold(function () {
	      return {
	        bind: noop,
	        unbind: noop
	      };
	    }, function (visualViewport) {
	      var editorContainer = value();
	      var resizeBinder = unbindable();
	      var scrollBinder = unbindable();
	      var refreshScroll = function () {
	        document.body.scrollTop = 0;
	        document.documentElement.scrollTop = 0;
	      };
	      var refreshVisualViewport = function () {
	        window.requestAnimationFrame(function () {
	          editorContainer.on(function (container) {
	            return setAll(container, {
	              top: visualViewport.offsetTop + 'px',
	              left: visualViewport.offsetLeft + 'px',
	              height: visualViewport.height + 'px',
	              width: visualViewport.width + 'px'
	            });
	          });
	        });
	      };
	      var update = global$3.throttle(function () {
	        refreshScroll();
	        refreshVisualViewport();
	      }, 50);
	      var bind = function (element) {
	        editorContainer.set(element);
	        update();
	        resizeBinder.set(bind$3('resize', update));
	        scrollBinder.set(bind$3('scroll', update));
	      };
	      var unbind = function () {
	        editorContainer.on(function () {
	          resizeBinder.clear();
	          scrollBinder.clear();
	        });
	        editorContainer.clear();
	      };
	      return {
	        bind: bind,
	        unbind: unbind
	      };
	    });
	    var toggleFullscreen = function (editor, fullscreenState) {
	      var body = document.body;
	      var documentElement = document.documentElement;
	      var editorContainer = editor.getContainer();
	      var editorContainerS = SugarElement.fromDom(editorContainer);
	      var fullscreenRoot = getFullscreenRoot(editor);
	      var fullscreenInfo = fullscreenState.get();
	      var editorBody = SugarElement.fromDom(editor.getBody());
	      var isTouch = global$2.deviceType.isTouch();
	      var editorContainerStyle = editorContainer.style;
	      var iframe = editor.iframeElement;
	      var iframeStyle = iframe.style;
	      var handleClasses = function (handler) {
	        handler(body, 'tox-fullscreen');
	        handler(documentElement, 'tox-fullscreen');
	        handler(editorContainer, 'tox-fullscreen');
	        getShadowRoot(editorContainerS).map(function (root) {
	          return getShadowHost(root).dom;
	        }).each(function (host) {
	          handler(host, 'tox-fullscreen');
	          handler(host, 'tox-shadowhost');
	        });
	      };
	      var cleanup = function () {
	        if (isTouch) {
	          restoreStyles(editor.dom);
	        }
	        handleClasses(DOM.removeClass);
	        viewportUpdate.unbind();
	        Optional.from(fullscreenState.get()).each(function (info) {
	          return info.fullscreenChangeHandler.unbind();
	        });
	      };
	      if (!fullscreenInfo) {
	        var fullscreenChangeHandler = bind$2(owner(fullscreenRoot), getFullscreenchangeEventName(), function (_evt) {
	          if (getFullscreenNative(editor)) {
	            if (!isFullscreenElement(fullscreenRoot) && fullscreenState.get() !== null) {
	              toggleFullscreen(editor, fullscreenState);
	            }
	          }
	        });
	        var newFullScreenInfo = {
	          scrollPos: getScrollPos(),
	          containerWidth: editorContainerStyle.width,
	          containerHeight: editorContainerStyle.height,
	          containerTop: editorContainerStyle.top,
	          containerLeft: editorContainerStyle.left,
	          iframeWidth: iframeStyle.width,
	          iframeHeight: iframeStyle.height,
	          fullscreenChangeHandler: fullscreenChangeHandler
	        };
	        if (isTouch) {
	          clobberStyles(editor.dom, editorContainerS, editorBody);
	        }
	        iframeStyle.width = iframeStyle.height = '100%';
	        editorContainerStyle.width = editorContainerStyle.height = '';
	        handleClasses(DOM.addClass);
	        viewportUpdate.bind(editorContainerS);
	        editor.on('remove', cleanup);
	        fullscreenState.set(newFullScreenInfo);
	        if (getFullscreenNative(editor)) {
	          requestFullscreen(fullscreenRoot);
	        }
	        fireFullscreenStateChanged(editor, true);
	      } else {
	        fullscreenInfo.fullscreenChangeHandler.unbind();
	        if (getFullscreenNative(editor) && isFullscreenElement(fullscreenRoot)) {
	          exitFullscreen(owner(fullscreenRoot));
	        }
	        iframeStyle.width = fullscreenInfo.iframeWidth;
	        iframeStyle.height = fullscreenInfo.iframeHeight;
	        editorContainerStyle.width = fullscreenInfo.containerWidth;
	        editorContainerStyle.height = fullscreenInfo.containerHeight;
	        editorContainerStyle.top = fullscreenInfo.containerTop;
	        editorContainerStyle.left = fullscreenInfo.containerLeft;
	        setScrollPos(fullscreenInfo.scrollPos);
	        fullscreenState.set(null);
	        fireFullscreenStateChanged(editor, false);
	        cleanup();
	        editor.off('remove', cleanup);
	      }
	    };
	
	    var register = function (editor, fullscreenState) {
	      editor.addCommand('mceFullScreen', function () {
	        toggleFullscreen(editor, fullscreenState);
	      });
	    };
	
	    var makeSetupHandler = function (editor, fullscreenState) {
	      return function (api) {
	        api.setActive(fullscreenState.get() !== null);
	        var editorEventCallback = function (e) {
	          return api.setActive(e.state);
	        };
	        editor.on('FullscreenStateChanged', editorEventCallback);
	        return function () {
	          return editor.off('FullscreenStateChanged', editorEventCallback);
	        };
	      };
	    };
	    var register$1 = function (editor, fullscreenState) {
	      editor.ui.registry.addToggleMenuItem('fullscreen', {
	        text: 'Fullscreen',
	        icon: 'fullscreen',
	        shortcut: 'Meta+Shift+F',
	        onAction: function () {
	          return editor.execCommand('mceFullScreen');
	        },
	        onSetup: makeSetupHandler(editor, fullscreenState)
	      });
	      editor.ui.registry.addToggleButton('fullscreen', {
	        tooltip: 'Fullscreen',
	        icon: 'fullscreen',
	        onAction: function () {
	          return editor.execCommand('mceFullScreen');
	        },
	        onSetup: makeSetupHandler(editor, fullscreenState)
	      });
	    };
	
	    function Plugin () {
	      global.add('fullscreen', function (editor) {
	        var fullscreenState = Cell(null);
	        if (editor.inline) {
	          return get(fullscreenState);
	        }
	        register(editor, fullscreenState);
	        register$1(editor, fullscreenState);
	        editor.addShortcut('Meta+Shift+F', '', 'mceFullScreen');
	        return get(fullscreenState);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "help" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/help')
	//   ES2015:
	//     import 'tinymce/plugins/help'
	__webpack_require__(1212);

/***/ },
/* 1212 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var get = function (customTabs) {
	      var addTab = function (spec) {
	        var currentCustomTabs = customTabs.get();
	        currentCustomTabs[spec.name] = spec;
	        customTabs.set(currentCustomTabs);
	      };
	      return { addTab: addTab };
	    };
	
	    var register = function (editor, dialogOpener) {
	      editor.addCommand('mceHelp', dialogOpener);
	    };
	
	    var register$1 = function (editor, dialogOpener) {
	      editor.ui.registry.addButton('help', {
	        icon: 'help',
	        tooltip: 'Help',
	        onAction: dialogOpener
	      });
	      editor.ui.registry.addMenuItem('help', {
	        text: 'Help',
	        icon: 'help',
	        shortcut: 'Alt+0',
	        onAction: dialogOpener
	      });
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeIndexOf = Array.prototype.indexOf;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var get$1 = function (obj, key) {
	      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	
	    var getHelpTabs = function (editor) {
	      return Optional.from(editor.getParam('help_tabs'));
	    };
	    var getForcedPlugins = function (editor) {
	      return editor.getParam('forced_plugins');
	    };
	
	    var description = '<h1>Editor UI keyboard navigation</h1>\n\n<h2>Activating keyboard navigation</h2>\n\n<p>The sections of the outer UI of the editor - the menubar, toolbar, sidebar and footer - are all keyboard navigable. As such, there are multiple ways to activate keyboard navigation:</p>\n<ul>\n  <li>Focus the menubar: Alt + F9 (Windows) or &#x2325;F9 (MacOS)</li>\n  <li>Focus the toolbar: Alt + F10 (Windows) or &#x2325;F10 (MacOS)</li>\n  <li>Focus the footer: Alt + F11 (Windows) or &#x2325;F11 (MacOS)</li>\n</ul>\n\n<p>Focusing the menubar or toolbar will start keyboard navigation at the first item in the menubar or toolbar, which will be highlighted with a gray background. Focusing the footer will start keyboard navigation at the first item in the element path, which will be highlighted with an underline. </p>\n\n<h2>Moving between UI sections</h2>\n\n<p>When keyboard navigation is active, pressing tab will move the focus to the next major section of the UI, where applicable. These sections are:</p>\n<ul>\n  <li>the menubar</li>\n  <li>each group of the toolbar </li>\n  <li>the sidebar</li>\n  <li>the element path in the footer </li>\n  <li>the wordcount toggle button in the footer </li>\n  <li>the branding link in the footer </li>\n  <li>the editor resize handle in the footer</li>\n</ul>\n\n<p>Pressing shift + tab will move backwards through the same sections, except when moving from the footer to the toolbar. Focusing the element path then pressing shift + tab will move focus to the first toolbar group, not the last.</p>\n\n<h2>Moving within UI sections</h2>\n\n<p>Keyboard navigation within UI sections can usually be achieved using the left and right arrow keys. This includes:</p>\n<ul>\n  <li>moving between menus in the menubar</li>\n  <li>moving between buttons in a toolbar group</li>\n  <li>moving between items in the element path</li>\n</ul>\n\n<p>In all these UI sections, keyboard navigation will cycle within the section. For example, focusing the last button in a toolbar group then pressing right arrow will move focus to the first item in the same toolbar group. </p>\n\n<h1>Executing buttons</h1>\n\n<p>To execute a button, navigate the selection to the desired button and hit space or enter.</p>\n\n<h1>Opening, navigating and closing menus</h1>\n\n<p>When focusing a menubar button or a toolbar button with a menu, pressing space, enter or down arrow will open the menu. When the menu opens the first item will be selected. To move up or down the menu, press the up or down arrow key respectively. This is the same for submenus, which can also be opened and closed using the left and right arrow keys.</p>\n\n<p>To close any active menu, hit the escape key. When a menu is closed the selection will be restored to its previous selection. This also works for closing submenus.</p>\n\n<h1>Context toolbars and menus</h1>\n\n<p>To focus an open context toolbar such as the table context toolbar, press Ctrl + F9 (Windows) or &#x2303;F9 (MacOS).</p>\n\n<p>Context toolbar navigation is the same as toolbar navigation, and context menu navigation is the same as standard menu navigation.</p>\n\n<h1>Dialog navigation</h1>\n\n<p>There are two types of dialog UIs in TinyMCE: tabbed dialogs and non-tabbed dialogs.</p>\n\n<p>When a non-tabbed dialog is opened, the first interactive component in the dialog will be focused. Users can navigate between interactive components by pressing tab. This includes any footer buttons. Navigation will cycle back to the first dialog component if tab is pressed while focusing the last component in the dialog. Pressing shift + tab will navigate backwards.</p>\n\n<p>When a tabbed dialog is opened, the first button in the tab menu is focused. Pressing tab will navigate to the first interactive component in that tab, and will cycle through the tab\u2019s components, the footer buttons, then back to the tab button. To switch to another tab, focus the tab button for the current tab, then use the arrow keys to cycle through the tab buttons.</p>';
	    var tab = function () {
	      var body = {
	        type: 'htmlpanel',
	        presets: 'document',
	        html: description
	      };
	      return {
	        name: 'keyboardnav',
	        title: 'Keyboard Navigation',
	        items: [body]
	      };
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var convertText = function (source) {
	      var mac = {
	        alt: '&#x2325;',
	        ctrl: '&#x2303;',
	        shift: '&#x21E7;',
	        meta: '&#x2318;',
	        access: '&#x2303;&#x2325;'
	      };
	      var other = {
	        meta: 'Ctrl ',
	        access: 'Shift + Alt '
	      };
	      var replace = global$1.mac ? mac : other;
	      var shortcut = source.split('+');
	      var updated = map(shortcut, function (segment) {
	        var search = segment.toLowerCase().trim();
	        return has(replace, search) ? replace[search] : segment;
	      });
	      return global$1.mac ? updated.join('').replace(/\s/, '') : updated.join('+');
	    };
	
	    var shortcuts = [
	      {
	        shortcuts: ['Meta + B'],
	        action: 'Bold'
	      },
	      {
	        shortcuts: ['Meta + I'],
	        action: 'Italic'
	      },
	      {
	        shortcuts: ['Meta + U'],
	        action: 'Underline'
	      },
	      {
	        shortcuts: ['Meta + A'],
	        action: 'Select all'
	      },
	      {
	        shortcuts: [
	          'Meta + Y',
	          'Meta + Shift + Z'
	        ],
	        action: 'Redo'
	      },
	      {
	        shortcuts: ['Meta + Z'],
	        action: 'Undo'
	      },
	      {
	        shortcuts: ['Access + 1'],
	        action: 'Heading 1'
	      },
	      {
	        shortcuts: ['Access + 2'],
	        action: 'Heading 2'
	      },
	      {
	        shortcuts: ['Access + 3'],
	        action: 'Heading 3'
	      },
	      {
	        shortcuts: ['Access + 4'],
	        action: 'Heading 4'
	      },
	      {
	        shortcuts: ['Access + 5'],
	        action: 'Heading 5'
	      },
	      {
	        shortcuts: ['Access + 6'],
	        action: 'Heading 6'
	      },
	      {
	        shortcuts: ['Access + 7'],
	        action: 'Paragraph'
	      },
	      {
	        shortcuts: ['Access + 8'],
	        action: 'Div'
	      },
	      {
	        shortcuts: ['Access + 9'],
	        action: 'Address'
	      },
	      {
	        shortcuts: ['Alt + 0'],
	        action: 'Open help dialog'
	      },
	      {
	        shortcuts: ['Alt + F9'],
	        action: 'Focus to menubar'
	      },
	      {
	        shortcuts: ['Alt + F10'],
	        action: 'Focus to toolbar'
	      },
	      {
	        shortcuts: ['Alt + F11'],
	        action: 'Focus to element path'
	      },
	      {
	        shortcuts: ['Ctrl + F9'],
	        action: 'Focus to contextual toolbar'
	      },
	      {
	        shortcuts: ['Shift + Enter'],
	        action: 'Open popup menu for split buttons'
	      },
	      {
	        shortcuts: ['Meta + K'],
	        action: 'Insert link (if link plugin activated)'
	      },
	      {
	        shortcuts: ['Meta + S'],
	        action: 'Save (if save plugin activated)'
	      },
	      {
	        shortcuts: ['Meta + F'],
	        action: 'Find (if searchreplace plugin activated)'
	      },
	      {
	        shortcuts: ['Meta + Shift + F'],
	        action: 'Switch to or from fullscreen mode'
	      }
	    ];
	
	    var tab$1 = function () {
	      var shortcutList = map(shortcuts, function (shortcut) {
	        var shortcutText = map(shortcut.shortcuts, convertText).join(' or ');
	        return [
	          shortcut.action,
	          shortcutText
	        ];
	      });
	      var tablePanel = {
	        type: 'table',
	        header: [
	          'Action',
	          'Shortcut'
	        ],
	        cells: shortcutList
	      };
	      return {
	        name: 'shortcuts',
	        title: 'Handy Shortcuts',
	        items: [tablePanel]
	      };
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var premiumType = 'premium';
	    var openSourceType = 'opensource';
	    var urls = map([
	      {
	        key: 'advlist',
	        name: 'Advanced List'
	      },
	      {
	        key: 'anchor',
	        name: 'Anchor'
	      },
	      {
	        key: 'autolink',
	        name: 'Autolink'
	      },
	      {
	        key: 'autoresize',
	        name: 'Autoresize'
	      },
	      {
	        key: 'autosave',
	        name: 'Autosave'
	      },
	      {
	        key: 'bbcode',
	        name: 'BBCode'
	      },
	      {
	        key: 'charmap',
	        name: 'Character Map'
	      },
	      {
	        key: 'code',
	        name: 'Code'
	      },
	      {
	        key: 'codesample',
	        name: 'Code Sample'
	      },
	      {
	        key: 'colorpicker',
	        name: 'Color Picker'
	      },
	      {
	        key: 'directionality',
	        name: 'Directionality'
	      },
	      {
	        key: 'emoticons',
	        name: 'Emoticons'
	      },
	      {
	        key: 'fullpage',
	        name: 'Full Page'
	      },
	      {
	        key: 'fullscreen',
	        name: 'Full Screen'
	      },
	      {
	        key: 'help',
	        name: 'Help'
	      },
	      {
	        key: 'hr',
	        name: 'Horizontal Rule'
	      },
	      {
	        key: 'image',
	        name: 'Image'
	      },
	      {
	        key: 'imagetools',
	        name: 'Image Tools'
	      },
	      {
	        key: 'importcss',
	        name: 'Import CSS'
	      },
	      {
	        key: 'insertdatetime',
	        name: 'Insert Date/Time'
	      },
	      {
	        key: 'legacyoutput',
	        name: 'Legacy Output'
	      },
	      {
	        key: 'link',
	        name: 'Link'
	      },
	      {
	        key: 'lists',
	        name: 'Lists'
	      },
	      {
	        key: 'media',
	        name: 'Media'
	      },
	      {
	        key: 'nonbreaking',
	        name: 'Nonbreaking'
	      },
	      {
	        key: 'noneditable',
	        name: 'Noneditable'
	      },
	      {
	        key: 'pagebreak',
	        name: 'Page Break'
	      },
	      {
	        key: 'paste',
	        name: 'Paste'
	      },
	      {
	        key: 'preview',
	        name: 'Preview'
	      },
	      {
	        key: 'print',
	        name: 'Print'
	      },
	      {
	        key: 'save',
	        name: 'Save'
	      },
	      {
	        key: 'searchreplace',
	        name: 'Search and Replace'
	      },
	      {
	        key: 'spellchecker',
	        name: 'Spell Checker'
	      },
	      {
	        key: 'tabfocus',
	        name: 'Tab Focus'
	      },
	      {
	        key: 'table',
	        name: 'Table'
	      },
	      {
	        key: 'template',
	        name: 'Template'
	      },
	      {
	        key: 'textcolor',
	        name: 'Text Color'
	      },
	      {
	        key: 'textpattern',
	        name: 'Text Pattern'
	      },
	      {
	        key: 'toc',
	        name: 'Table of Contents'
	      },
	      {
	        key: 'visualblocks',
	        name: 'Visual Blocks'
	      },
	      {
	        key: 'visualchars',
	        name: 'Visual Characters'
	      },
	      {
	        key: 'wordcount',
	        name: 'Word Count'
	      },
	      {
	        key: 'advcode',
	        name: 'Advanced Code Editor*',
	        type: premiumType
	      },
	      {
	        key: 'formatpainter',
	        name: 'Format Painter*',
	        type: premiumType
	      },
	      {
	        key: 'powerpaste',
	        name: 'PowerPaste*',
	        type: premiumType
	      },
	      {
	        key: 'tinydrive',
	        name: 'Tiny Drive*',
	        type: premiumType
	      },
	      {
	        key: 'tinymcespellchecker',
	        name: 'Spell Checker Pro*',
	        type: premiumType
	      },
	      {
	        key: 'a11ychecker',
	        name: 'Accessibility Checker*',
	        type: premiumType
	      },
	      {
	        key: 'linkchecker',
	        name: 'Link Checker*',
	        type: premiumType
	      },
	      {
	        key: 'mentions',
	        name: 'Mentions*',
	        type: premiumType
	      },
	      {
	        key: 'mediaembed',
	        name: 'Enhanced Media Embed*',
	        type: premiumType
	      },
	      {
	        key: 'checklist',
	        name: 'Checklist*',
	        type: premiumType
	      },
	      {
	        key: 'casechange',
	        name: 'Case Change*',
	        type: premiumType
	      },
	      {
	        key: 'permanentpen',
	        name: 'Permanent Pen*',
	        type: premiumType
	      },
	      {
	        key: 'pageembed',
	        name: 'Page Embed*',
	        type: premiumType
	      },
	      {
	        key: 'tinycomments',
	        name: 'Tiny Comments*',
	        type: premiumType,
	        slug: 'comments'
	      },
	      {
	        key: 'advtable',
	        name: 'Advanced Tables*',
	        type: premiumType
	      },
	      {
	        key: 'autocorrect',
	        name: 'Autocorrect*',
	        type: premiumType
	      },
	      {
	        key: 'export',
	        name: 'Export*',
	        type: premiumType
	      }
	    ], function (item) {
	      return __assign(__assign({}, item), {
	        type: item.type || openSourceType,
	        slug: item.slug || item.key
	      });
	    });
	
	    var tab$2 = function (editor) {
	      var availablePlugins = function () {
	        var premiumPlugins = [
	          'Accessibility Checker',
	          'Advanced Code Editor',
	          'Advanced Tables',
	          'Case Change',
	          'Checklist',
	          'Export',
	          'Tiny Comments',
	          'Tiny Drive',
	          'Enhanced Media Embed',
	          'Format Painter',
	          'Link Checker',
	          'Mentions',
	          'MoxieManager',
	          'Page Embed',
	          'Permanent Pen',
	          'PowerPaste',
	          'Spell Checker Pro'
	        ];
	        var premiumPluginList = map(premiumPlugins, function (plugin) {
	          return '<li>' + global$2.translate(plugin) + '</li>';
	        }).join('');
	        return '<div data-mce-tabstop="1" tabindex="-1">' + '<p><b>' + global$2.translate('Premium plugins:') + '</b></p>' + '<ul>' + premiumPluginList + '<li class="tox-help__more-link" "><a href="https://www.tiny.cloud/pricing/?utm_campaign=editor_referral&utm_medium=help_dialog&utm_source=tinymce" target="_blank">' + global$2.translate('Learn more...') + '</a></li>' + '</ul>' + '</div>';
	      };
	      var makeLink = function (p) {
	        return '<a href="' + p.url + '" target="_blank" rel="noopener">' + p.name + '</a>';
	      };
	      var maybeUrlize = function (editor, key) {
	        return find(urls, function (x) {
	          return x.key === key;
	        }).fold(function () {
	          var getMetadata = editor.plugins[key].getMetadata;
	          return typeof getMetadata === 'function' ? makeLink(getMetadata()) : key;
	        }, function (x) {
	          return makeLink({
	            name: x.name,
	            url: 'https://www.tiny.cloud/docs/plugins/' + x.type + '/' + x.slug
	          });
	        });
	      };
	      var getPluginKeys = function (editor) {
	        var keys$1 = keys(editor.plugins);
	        var forced_plugins = getForcedPlugins(editor);
	        return forced_plugins === undefined ? keys$1 : filter(keys$1, function (k) {
	          return !contains(forced_plugins, k);
	        });
	      };
	      var pluginLister = function (editor) {
	        var pluginKeys = getPluginKeys(editor);
	        var pluginLis = map(pluginKeys, function (key) {
	          return '<li>' + maybeUrlize(editor, key) + '</li>';
	        });
	        var count = pluginLis.length;
	        var pluginsString = pluginLis.join('');
	        var html = '<p><b>' + global$2.translate([
	          'Plugins installed ({0}):',
	          count
	        ]) + '</b></p>' + '<ul>' + pluginsString + '</ul>';
	        return html;
	      };
	      var installedPlugins = function (editor) {
	        if (editor == null) {
	          return '';
	        }
	        return '<div data-mce-tabstop="1" tabindex="-1">' + pluginLister(editor) + '</div>';
	      };
	      var htmlPanel = {
	        type: 'htmlpanel',
	        presets: 'document',
	        html: [
	          installedPlugins(editor),
	          availablePlugins()
	        ].join('')
	      };
	      return {
	        name: 'plugins',
	        title: 'Plugins',
	        items: [htmlPanel]
	      };
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.EditorManager');
	
	    var tab$3 = function () {
	      var getVersion = function (major, minor) {
	        return major.indexOf('@') === 0 ? 'X.X.X' : major + '.' + minor;
	      };
	      var version = getVersion(global$3.majorVersion, global$3.minorVersion);
	      var changeLogLink = '<a href="https://www.tiny.cloud/docs/changelog/?utm_campaign=editor_referral&utm_medium=help_dialog&utm_source=tinymce" target="_blank">TinyMCE ' + version + '</a>';
	      var htmlPanel = {
	        type: 'htmlpanel',
	        html: '<p>' + global$2.translate([
	          'You are using {0}',
	          changeLogLink
	        ]) + '</p>',
	        presets: 'document'
	      };
	      return {
	        name: 'versions',
	        title: 'Version',
	        items: [htmlPanel]
	      };
	    };
	
	    var parseHelpTabsSetting = function (tabsFromSettings, tabs) {
	      var newTabs = {};
	      var names = map(tabsFromSettings, function (t) {
	        if (typeof t === 'string') {
	          if (has(tabs, t)) {
	            newTabs[t] = tabs[t];
	          }
	          return t;
	        } else {
	          newTabs[t.name] = t;
	          return t.name;
	        }
	      });
	      return {
	        tabs: newTabs,
	        names: names
	      };
	    };
	    var getNamesFromTabs = function (tabs) {
	      var names = keys(tabs);
	      var idx = names.indexOf('versions');
	      if (idx !== -1) {
	        names.splice(idx, 1);
	        names.push('versions');
	      }
	      return {
	        tabs: tabs,
	        names: names
	      };
	    };
	    var parseCustomTabs = function (editor, customTabs) {
	      var _a;
	      var shortcuts = tab$1();
	      var nav = tab();
	      var plugins = tab$2(editor);
	      var versions = tab$3();
	      var tabs = __assign((_a = {}, _a[shortcuts.name] = shortcuts, _a[nav.name] = nav, _a[plugins.name] = plugins, _a[versions.name] = versions, _a), customTabs.get());
	      return getHelpTabs(editor).fold(function () {
	        return getNamesFromTabs(tabs);
	      }, function (tabsFromSettings) {
	        return parseHelpTabsSetting(tabsFromSettings, tabs);
	      });
	    };
	    var init = function (editor, customTabs) {
	      return function () {
	        var _a = parseCustomTabs(editor, customTabs), tabs = _a.tabs, names = _a.names;
	        var foundTabs = map(names, function (name) {
	          return get$1(tabs, name);
	        });
	        var dialogTabs = cat(foundTabs);
	        var body = {
	          type: 'tabpanel',
	          tabs: dialogTabs
	        };
	        editor.windowManager.open({
	          title: 'Help',
	          size: 'medium',
	          body: body,
	          buttons: [{
	              type: 'cancel',
	              name: 'close',
	              text: 'Close',
	              primary: true
	            }],
	          initialData: {}
	        });
	      };
	    };
	
	    function Plugin () {
	      global.add('help', function (editor) {
	        var customTabs = Cell({});
	        var api = get(customTabs);
	        var dialogOpener = init(editor, customTabs);
	        register$1(editor, dialogOpener);
	        register(editor, dialogOpener);
	        editor.shortcuts.add('Alt+0', 'Open help dialog', 'mceHelp');
	        return api;
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "hr" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/hr')
	//   ES2015:
	//     import 'tinymce/plugins/hr'
	__webpack_require__(1214);

/***/ },
/* 1214 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var register = function (editor) {
	      editor.addCommand('InsertHorizontalRule', function () {
	        editor.execCommand('mceInsertContent', false, '<hr />');
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('hr', {
	        icon: 'horizontal-rule',
	        tooltip: 'Horizontal line',
	        onAction: function () {
	          return editor.execCommand('InsertHorizontalRule');
	        }
	      });
	      editor.ui.registry.addMenuItem('hr', {
	        icon: 'horizontal-rule',
	        text: 'Horizontal line',
	        onAction: function () {
	          return editor.execCommand('InsertHorizontalRule');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('hr', function (editor) {
	        register(editor);
	        register$1(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "image" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/image')
	//   ES2015:
	//     import 'tinymce/plugins/image'
	__webpack_require__(1216);

/***/ },
/* 1216 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isNull = eq(null);
	    var isBoolean = isSimpleType('boolean');
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	
	    var nativePush = Array.prototype.push;
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var get = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get(xs, 0);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var remove = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var hasDimensions = function (editor) {
	      return editor.getParam('image_dimensions', true, 'boolean');
	    };
	    var hasAdvTab = function (editor) {
	      return editor.getParam('image_advtab', false, 'boolean');
	    };
	    var hasUploadTab = function (editor) {
	      return editor.getParam('image_uploadtab', true, 'boolean');
	    };
	    var getPrependUrl = function (editor) {
	      return editor.getParam('image_prepend_url', '', 'string');
	    };
	    var getClassList = function (editor) {
	      return editor.getParam('image_class_list');
	    };
	    var hasDescription = function (editor) {
	      return editor.getParam('image_description', true, 'boolean');
	    };
	    var hasImageTitle = function (editor) {
	      return editor.getParam('image_title', false, 'boolean');
	    };
	    var hasImageCaption = function (editor) {
	      return editor.getParam('image_caption', false, 'boolean');
	    };
	    var getImageList = function (editor) {
	      return editor.getParam('image_list', false);
	    };
	    var hasUploadUrl = function (editor) {
	      return isNonNullable(editor.getParam('images_upload_url'));
	    };
	    var hasUploadHandler = function (editor) {
	      return isNonNullable(editor.getParam('images_upload_handler'));
	    };
	    var showAccessibilityOptions = function (editor) {
	      return editor.getParam('a11y_advanced_options', false, 'boolean');
	    };
	    var isAutomaticUploadsEnabled = function (editor) {
	      return editor.getParam('automatic_uploads', true, 'boolean');
	    };
	
	    var parseIntAndGetMax = function (val1, val2) {
	      return Math.max(parseInt(val1, 10), parseInt(val2, 10));
	    };
	    var getImageSize = function (url) {
	      return new global$2(function (callback) {
	        var img = document.createElement('img');
	        var done = function (dimensions) {
	          if (img.parentNode) {
	            img.parentNode.removeChild(img);
	          }
	          callback(dimensions);
	        };
	        img.onload = function () {
	          var width = parseIntAndGetMax(img.width, img.clientWidth);
	          var height = parseIntAndGetMax(img.height, img.clientHeight);
	          var dimensions = {
	            width: width,
	            height: height
	          };
	          done(global$2.resolve(dimensions));
	        };
	        img.onerror = function () {
	          done(global$2.reject('Failed to get image dimensions for: ' + url));
	        };
	        var style = img.style;
	        style.visibility = 'hidden';
	        style.position = 'fixed';
	        style.bottom = style.left = '0px';
	        style.width = style.height = 'auto';
	        document.body.appendChild(img);
	        img.src = url;
	      });
	    };
	    var removePixelSuffix = function (value) {
	      if (value) {
	        value = value.replace(/px$/, '');
	      }
	      return value;
	    };
	    var addPixelSuffix = function (value) {
	      if (value.length > 0 && /^[0-9]+$/.test(value)) {
	        value += 'px';
	      }
	      return value;
	    };
	    var mergeMargins = function (css) {
	      if (css.margin) {
	        var splitMargin = String(css.margin).split(' ');
	        switch (splitMargin.length) {
	        case 1:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[0];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[0];
	          break;
	        case 2:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[0];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 3:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[1];
	          break;
	        case 4:
	          css['margin-top'] = css['margin-top'] || splitMargin[0];
	          css['margin-right'] = css['margin-right'] || splitMargin[1];
	          css['margin-bottom'] = css['margin-bottom'] || splitMargin[2];
	          css['margin-left'] = css['margin-left'] || splitMargin[3];
	        }
	        delete css.margin;
	      }
	      return css;
	    };
	    var createImageList = function (editor, callback) {
	      var imageList = getImageList(editor);
	      if (typeof imageList === 'string') {
	        global$3.send({
	          url: imageList,
	          success: function (text) {
	            callback(JSON.parse(text));
	          }
	        });
	      } else if (typeof imageList === 'function') {
	        imageList(callback);
	      } else {
	        callback(imageList);
	      }
	    };
	    var waitLoadImage = function (editor, data, imgElm) {
	      var selectImage = function () {
	        imgElm.onload = imgElm.onerror = null;
	        if (editor.selection) {
	          editor.selection.select(imgElm);
	          editor.nodeChanged();
	        }
	      };
	      imgElm.onload = function () {
	        if (!data.width && !data.height && hasDimensions(editor)) {
	          editor.dom.setAttribs(imgElm, {
	            width: String(imgElm.clientWidth),
	            height: String(imgElm.clientHeight)
	          });
	        }
	        selectImage();
	      };
	      imgElm.onerror = selectImage;
	    };
	    var blobToDataUri = function (blob) {
	      return new global$2(function (resolve, reject) {
	        var reader = new FileReader();
	        reader.onload = function () {
	          resolve(reader.result);
	        };
	        reader.onerror = function () {
	          reject(reader.error.message);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var isPlaceholderImage = function (imgElm) {
	      return imgElm.nodeName === 'IMG' && (imgElm.hasAttribute('data-mce-object') || imgElm.hasAttribute('data-mce-placeholder'));
	    };
	
	    var DOM = global$1.DOM;
	    var getHspace = function (image) {
	      if (image.style.marginLeft && image.style.marginRight && image.style.marginLeft === image.style.marginRight) {
	        return removePixelSuffix(image.style.marginLeft);
	      } else {
	        return '';
	      }
	    };
	    var getVspace = function (image) {
	      if (image.style.marginTop && image.style.marginBottom && image.style.marginTop === image.style.marginBottom) {
	        return removePixelSuffix(image.style.marginTop);
	      } else {
	        return '';
	      }
	    };
	    var getBorder = function (image) {
	      if (image.style.borderWidth) {
	        return removePixelSuffix(image.style.borderWidth);
	      } else {
	        return '';
	      }
	    };
	    var getAttrib = function (image, name) {
	      if (image.hasAttribute(name)) {
	        return image.getAttribute(name);
	      } else {
	        return '';
	      }
	    };
	    var getStyle = function (image, name) {
	      return image.style[name] ? image.style[name] : '';
	    };
	    var hasCaption = function (image) {
	      return image.parentNode !== null && image.parentNode.nodeName === 'FIGURE';
	    };
	    var updateAttrib = function (image, name, value) {
	      if (value === '') {
	        image.removeAttribute(name);
	      } else {
	        image.setAttribute(name, value);
	      }
	    };
	    var wrapInFigure = function (image) {
	      var figureElm = DOM.create('figure', { class: 'image' });
	      DOM.insertAfter(figureElm, image);
	      figureElm.appendChild(image);
	      figureElm.appendChild(DOM.create('figcaption', { contentEditable: 'true' }, 'Caption'));
	      figureElm.contentEditable = 'false';
	    };
	    var removeFigure = function (image) {
	      var figureElm = image.parentNode;
	      DOM.insertAfter(image, figureElm);
	      DOM.remove(figureElm);
	    };
	    var toggleCaption = function (image) {
	      if (hasCaption(image)) {
	        removeFigure(image);
	      } else {
	        wrapInFigure(image);
	      }
	    };
	    var normalizeStyle = function (image, normalizeCss) {
	      var attrValue = image.getAttribute('style');
	      var value = normalizeCss(attrValue !== null ? attrValue : '');
	      if (value.length > 0) {
	        image.setAttribute('style', value);
	        image.setAttribute('data-mce-style', value);
	      } else {
	        image.removeAttribute('style');
	      }
	    };
	    var setSize = function (name, normalizeCss) {
	      return function (image, name, value) {
	        if (image.style[name]) {
	          image.style[name] = addPixelSuffix(value);
	          normalizeStyle(image, normalizeCss);
	        } else {
	          updateAttrib(image, name, value);
	        }
	      };
	    };
	    var getSize = function (image, name) {
	      if (image.style[name]) {
	        return removePixelSuffix(image.style[name]);
	      } else {
	        return getAttrib(image, name);
	      }
	    };
	    var setHspace = function (image, value) {
	      var pxValue = addPixelSuffix(value);
	      image.style.marginLeft = pxValue;
	      image.style.marginRight = pxValue;
	    };
	    var setVspace = function (image, value) {
	      var pxValue = addPixelSuffix(value);
	      image.style.marginTop = pxValue;
	      image.style.marginBottom = pxValue;
	    };
	    var setBorder = function (image, value) {
	      var pxValue = addPixelSuffix(value);
	      image.style.borderWidth = pxValue;
	    };
	    var setBorderStyle = function (image, value) {
	      image.style.borderStyle = value;
	    };
	    var getBorderStyle = function (image) {
	      return getStyle(image, 'borderStyle');
	    };
	    var isFigure = function (elm) {
	      return elm.nodeName === 'FIGURE';
	    };
	    var isImage = function (elm) {
	      return elm.nodeName === 'IMG';
	    };
	    var getIsDecorative = function (image) {
	      return DOM.getAttrib(image, 'alt').length === 0 && DOM.getAttrib(image, 'role') === 'presentation';
	    };
	    var getAlt = function (image) {
	      if (getIsDecorative(image)) {
	        return '';
	      } else {
	        return getAttrib(image, 'alt');
	      }
	    };
	    var defaultData = function () {
	      return {
	        src: '',
	        alt: '',
	        title: '',
	        width: '',
	        height: '',
	        class: '',
	        style: '',
	        caption: false,
	        hspace: '',
	        vspace: '',
	        border: '',
	        borderStyle: '',
	        isDecorative: false
	      };
	    };
	    var getStyleValue = function (normalizeCss, data) {
	      var image = document.createElement('img');
	      updateAttrib(image, 'style', data.style);
	      if (getHspace(image) || data.hspace !== '') {
	        setHspace(image, data.hspace);
	      }
	      if (getVspace(image) || data.vspace !== '') {
	        setVspace(image, data.vspace);
	      }
	      if (getBorder(image) || data.border !== '') {
	        setBorder(image, data.border);
	      }
	      if (getBorderStyle(image) || data.borderStyle !== '') {
	        setBorderStyle(image, data.borderStyle);
	      }
	      return normalizeCss(image.getAttribute('style'));
	    };
	    var create = function (normalizeCss, data) {
	      var image = document.createElement('img');
	      write(normalizeCss, __assign(__assign({}, data), { caption: false }), image);
	      setAlt(image, data.alt, data.isDecorative);
	      if (data.caption) {
	        var figure = DOM.create('figure', { class: 'image' });
	        figure.appendChild(image);
	        figure.appendChild(DOM.create('figcaption', { contentEditable: 'true' }, 'Caption'));
	        figure.contentEditable = 'false';
	        return figure;
	      } else {
	        return image;
	      }
	    };
	    var read = function (normalizeCss, image) {
	      return {
	        src: getAttrib(image, 'src'),
	        alt: getAlt(image),
	        title: getAttrib(image, 'title'),
	        width: getSize(image, 'width'),
	        height: getSize(image, 'height'),
	        class: getAttrib(image, 'class'),
	        style: normalizeCss(getAttrib(image, 'style')),
	        caption: hasCaption(image),
	        hspace: getHspace(image),
	        vspace: getVspace(image),
	        border: getBorder(image),
	        borderStyle: getStyle(image, 'borderStyle'),
	        isDecorative: getIsDecorative(image)
	      };
	    };
	    var updateProp = function (image, oldData, newData, name, set) {
	      if (newData[name] !== oldData[name]) {
	        set(image, name, newData[name]);
	      }
	    };
	    var setAlt = function (image, alt, isDecorative) {
	      if (isDecorative) {
	        DOM.setAttrib(image, 'role', 'presentation');
	        var sugarImage = SugarElement.fromDom(image);
	        set(sugarImage, 'alt', '');
	      } else {
	        if (isNull(alt)) {
	          var sugarImage = SugarElement.fromDom(image);
	          remove(sugarImage, 'alt');
	        } else {
	          var sugarImage = SugarElement.fromDom(image);
	          set(sugarImage, 'alt', alt);
	        }
	        if (DOM.getAttrib(image, 'role') === 'presentation') {
	          DOM.setAttrib(image, 'role', '');
	        }
	      }
	    };
	    var updateAlt = function (image, oldData, newData) {
	      if (newData.alt !== oldData.alt || newData.isDecorative !== oldData.isDecorative) {
	        setAlt(image, newData.alt, newData.isDecorative);
	      }
	    };
	    var normalized = function (set, normalizeCss) {
	      return function (image, name, value) {
	        set(image, value);
	        normalizeStyle(image, normalizeCss);
	      };
	    };
	    var write = function (normalizeCss, newData, image) {
	      var oldData = read(normalizeCss, image);
	      updateProp(image, oldData, newData, 'caption', function (image, _name, _value) {
	        return toggleCaption(image);
	      });
	      updateProp(image, oldData, newData, 'src', updateAttrib);
	      updateProp(image, oldData, newData, 'title', updateAttrib);
	      updateProp(image, oldData, newData, 'width', setSize('width', normalizeCss));
	      updateProp(image, oldData, newData, 'height', setSize('height', normalizeCss));
	      updateProp(image, oldData, newData, 'class', updateAttrib);
	      updateProp(image, oldData, newData, 'style', normalized(function (image, value) {
	        return updateAttrib(image, 'style', value);
	      }, normalizeCss));
	      updateProp(image, oldData, newData, 'hspace', normalized(setHspace, normalizeCss));
	      updateProp(image, oldData, newData, 'vspace', normalized(setVspace, normalizeCss));
	      updateProp(image, oldData, newData, 'border', normalized(setBorder, normalizeCss));
	      updateProp(image, oldData, newData, 'borderStyle', normalized(setBorderStyle, normalizeCss));
	      updateAlt(image, oldData, newData);
	    };
	
	    var normalizeCss = function (editor, cssText) {
	      var css = editor.dom.styles.parse(cssText);
	      var mergedCss = mergeMargins(css);
	      var compressed = editor.dom.styles.parse(editor.dom.styles.serialize(mergedCss));
	      return editor.dom.styles.serialize(compressed);
	    };
	    var getSelectedImage = function (editor) {
	      var imgElm = editor.selection.getNode();
	      var figureElm = editor.dom.getParent(imgElm, 'figure.image');
	      if (figureElm) {
	        return editor.dom.select('img', figureElm)[0];
	      }
	      if (imgElm && (imgElm.nodeName !== 'IMG' || isPlaceholderImage(imgElm))) {
	        return null;
	      }
	      return imgElm;
	    };
	    var splitTextBlock = function (editor, figure) {
	      var dom = editor.dom;
	      var textBlockElements = filter(editor.schema.getTextBlockElements(), function (_, parentElm) {
	        return !editor.schema.isValidChild(parentElm, 'figure');
	      });
	      var textBlock = dom.getParent(figure.parentNode, function (node) {
	        return hasNonNullableKey(textBlockElements, node.nodeName);
	      }, editor.getBody());
	      if (textBlock) {
	        return dom.split(textBlock, figure);
	      } else {
	        return figure;
	      }
	    };
	    var readImageDataFromSelection = function (editor) {
	      var image = getSelectedImage(editor);
	      return image ? read(function (css) {
	        return normalizeCss(editor, css);
	      }, image) : defaultData();
	    };
	    var insertImageAtCaret = function (editor, data) {
	      var elm = create(function (css) {
	        return normalizeCss(editor, css);
	      }, data);
	      editor.dom.setAttrib(elm, 'data-mce-id', '__mcenew');
	      editor.focus();
	      editor.selection.setContent(elm.outerHTML);
	      var insertedElm = editor.dom.select('*[data-mce-id="__mcenew"]')[0];
	      editor.dom.setAttrib(insertedElm, 'data-mce-id', null);
	      if (isFigure(insertedElm)) {
	        var figure = splitTextBlock(editor, insertedElm);
	        editor.selection.select(figure);
	      } else {
	        editor.selection.select(insertedElm);
	      }
	    };
	    var syncSrcAttr = function (editor, image) {
	      editor.dom.setAttrib(image, 'src', image.getAttribute('src'));
	    };
	    var deleteImage = function (editor, image) {
	      if (image) {
	        var elm = editor.dom.is(image.parentNode, 'figure.image') ? image.parentNode : image;
	        editor.dom.remove(elm);
	        editor.focus();
	        editor.nodeChanged();
	        if (editor.dom.isEmpty(editor.getBody())) {
	          editor.setContent('');
	          editor.selection.setCursorLocation();
	        }
	      }
	    };
	    var writeImageDataToSelection = function (editor, data) {
	      var image = getSelectedImage(editor);
	      write(function (css) {
	        return normalizeCss(editor, css);
	      }, data, image);
	      syncSrcAttr(editor, image);
	      if (isFigure(image.parentNode)) {
	        var figure = image.parentNode;
	        splitTextBlock(editor, figure);
	        editor.selection.select(image.parentNode);
	      } else {
	        editor.selection.select(image);
	        waitLoadImage(editor, data, image);
	      }
	    };
	    var insertOrUpdateImage = function (editor, partialData) {
	      var image = getSelectedImage(editor);
	      if (image) {
	        var selectedImageData = read(function (css) {
	          return normalizeCss(editor, css);
	        }, image);
	        var data = __assign(__assign({}, selectedImageData), partialData);
	        if (data.src) {
	          writeImageDataToSelection(editor, data);
	        } else {
	          deleteImage(editor, image);
	        }
	      } else if (partialData.src) {
	        insertImageAtCaret(editor, __assign(__assign({}, defaultData()), partialData));
	      }
	    };
	
	    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	    var deep = function (old, nu) {
	      var bothObjects = isObject(old) && isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          objects[_i] = arguments[_i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty$1.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var deepMerge = baseMerge(deep);
	
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.ImageUploader');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getValue = function (item) {
	      return isString(item.value) ? item.value : '';
	    };
	    var getText = function (item) {
	      if (isString(item.text)) {
	        return item.text;
	      } else if (isString(item.title)) {
	        return item.title;
	      } else {
	        return '';
	      }
	    };
	    var sanitizeList = function (list, extractValue) {
	      var out = [];
	      global$5.each(list, function (item) {
	        var text = getText(item);
	        if (item.menu !== undefined) {
	          var items = sanitizeList(item.menu, extractValue);
	          out.push({
	            text: text,
	            items: items
	          });
	        } else {
	          var value = extractValue(item);
	          out.push({
	            text: text,
	            value: value
	          });
	        }
	      });
	      return out;
	    };
	    var sanitizer = function (extracter) {
	      if (extracter === void 0) {
	        extracter = getValue;
	      }
	      return function (list) {
	        if (list) {
	          return Optional.from(list).map(function (list) {
	            return sanitizeList(list, extracter);
	          });
	        } else {
	          return Optional.none();
	        }
	      };
	    };
	    var sanitize = function (list) {
	      return sanitizer(getValue)(list);
	    };
	    var isGroup = function (item) {
	      return Object.prototype.hasOwnProperty.call(item, 'items');
	    };
	    var findEntryDelegate = function (list, value) {
	      return findMap(list, function (item) {
	        if (isGroup(item)) {
	          return findEntryDelegate(item.items, value);
	        } else if (item.value === value) {
	          return Optional.some(item);
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var findEntry = function (optList, value) {
	      return optList.bind(function (list) {
	        return findEntryDelegate(list, value);
	      });
	    };
	    var ListUtils = {
	      sanitizer: sanitizer,
	      sanitize: sanitize,
	      findEntry: findEntry
	    };
	
	    var makeTab = function (_info) {
	      return {
	        title: 'Advanced',
	        name: 'advanced',
	        items: [
	          {
	            type: 'input',
	            label: 'Style',
	            name: 'style'
	          },
	          {
	            type: 'grid',
	            columns: 2,
	            items: [
	              {
	                type: 'input',
	                label: 'Vertical space',
	                name: 'vspace',
	                inputMode: 'numeric'
	              },
	              {
	                type: 'input',
	                label: 'Horizontal space',
	                name: 'hspace',
	                inputMode: 'numeric'
	              },
	              {
	                type: 'input',
	                label: 'Border width',
	                name: 'border',
	                inputMode: 'numeric'
	              },
	              {
	                type: 'listbox',
	                name: 'borderstyle',
	                label: 'Border style',
	                items: [
	                  {
	                    text: 'Select...',
	                    value: ''
	                  },
	                  {
	                    text: 'Solid',
	                    value: 'solid'
	                  },
	                  {
	                    text: 'Dotted',
	                    value: 'dotted'
	                  },
	                  {
	                    text: 'Dashed',
	                    value: 'dashed'
	                  },
	                  {
	                    text: 'Double',
	                    value: 'double'
	                  },
	                  {
	                    text: 'Groove',
	                    value: 'groove'
	                  },
	                  {
	                    text: 'Ridge',
	                    value: 'ridge'
	                  },
	                  {
	                    text: 'Inset',
	                    value: 'inset'
	                  },
	                  {
	                    text: 'Outset',
	                    value: 'outset'
	                  },
	                  {
	                    text: 'None',
	                    value: 'none'
	                  },
	                  {
	                    text: 'Hidden',
	                    value: 'hidden'
	                  }
	                ]
	              }
	            ]
	          }
	        ]
	      };
	    };
	    var AdvTab = { makeTab: makeTab };
	
	    var collect = function (editor) {
	      var urlListSanitizer = ListUtils.sanitizer(function (item) {
	        return editor.convertURL(item.value || item.url, 'src');
	      });
	      var futureImageList = new global$2(function (completer) {
	        createImageList(editor, function (imageList) {
	          completer(urlListSanitizer(imageList).map(function (items) {
	            return flatten([
	              [{
	                  text: 'None',
	                  value: ''
	                }],
	              items
	            ]);
	          }));
	        });
	      });
	      var classList = ListUtils.sanitize(getClassList(editor));
	      var hasAdvTab$1 = hasAdvTab(editor);
	      var hasUploadTab$1 = hasUploadTab(editor);
	      var hasUploadUrl$1 = hasUploadUrl(editor);
	      var hasUploadHandler$1 = hasUploadHandler(editor);
	      var image = readImageDataFromSelection(editor);
	      var hasDescription$1 = hasDescription(editor);
	      var hasImageTitle$1 = hasImageTitle(editor);
	      var hasDimensions$1 = hasDimensions(editor);
	      var hasImageCaption$1 = hasImageCaption(editor);
	      var hasAccessibilityOptions = showAccessibilityOptions(editor);
	      var automaticUploads = isAutomaticUploadsEnabled(editor);
	      var prependURL = Optional.some(getPrependUrl(editor)).filter(function (preUrl) {
	        return isString(preUrl) && preUrl.length > 0;
	      });
	      return futureImageList.then(function (imageList) {
	        return {
	          image: image,
	          imageList: imageList,
	          classList: classList,
	          hasAdvTab: hasAdvTab$1,
	          hasUploadTab: hasUploadTab$1,
	          hasUploadUrl: hasUploadUrl$1,
	          hasUploadHandler: hasUploadHandler$1,
	          hasDescription: hasDescription$1,
	          hasImageTitle: hasImageTitle$1,
	          hasDimensions: hasDimensions$1,
	          hasImageCaption: hasImageCaption$1,
	          prependURL: prependURL,
	          hasAccessibilityOptions: hasAccessibilityOptions,
	          automaticUploads: automaticUploads
	        };
	      });
	    };
	
	    var makeItems = function (info) {
	      var imageUrl = {
	        name: 'src',
	        type: 'urlinput',
	        filetype: 'image',
	        label: 'Source'
	      };
	      var imageList = info.imageList.map(function (items) {
	        return {
	          name: 'images',
	          type: 'listbox',
	          label: 'Image list',
	          items: items
	        };
	      });
	      var imageDescription = {
	        name: 'alt',
	        type: 'input',
	        label: 'Alternative description',
	        disabled: info.hasAccessibilityOptions && info.image.isDecorative
	      };
	      var imageTitle = {
	        name: 'title',
	        type: 'input',
	        label: 'Image title'
	      };
	      var imageDimensions = {
	        name: 'dimensions',
	        type: 'sizeinput'
	      };
	      var isDecorative = {
	        type: 'label',
	        label: 'Accessibility',
	        items: [{
	            name: 'isDecorative',
	            type: 'checkbox',
	            label: 'Image is decorative'
	          }]
	      };
	      var classList = info.classList.map(function (items) {
	        return {
	          name: 'classes',
	          type: 'listbox',
	          label: 'Class',
	          items: items
	        };
	      });
	      var caption = {
	        type: 'label',
	        label: 'Caption',
	        items: [{
	            type: 'checkbox',
	            name: 'caption',
	            label: 'Show caption'
	          }]
	      };
	      var getDialogContainerType = function (useColumns) {
	        return useColumns ? {
	          type: 'grid',
	          columns: 2
	        } : { type: 'panel' };
	      };
	      return flatten([
	        [imageUrl],
	        imageList.toArray(),
	        info.hasAccessibilityOptions && info.hasDescription ? [isDecorative] : [],
	        info.hasDescription ? [imageDescription] : [],
	        info.hasImageTitle ? [imageTitle] : [],
	        info.hasDimensions ? [imageDimensions] : [],
	        [__assign(__assign({}, getDialogContainerType(info.classList.isSome() && info.hasImageCaption)), {
	            items: flatten([
	              classList.toArray(),
	              info.hasImageCaption ? [caption] : []
	            ])
	          })]
	      ]);
	    };
	    var makeTab$1 = function (info) {
	      return {
	        title: 'General',
	        name: 'general',
	        items: makeItems(info)
	      };
	    };
	    var MainTab = {
	      makeTab: makeTab$1,
	      makeItems: makeItems
	    };
	
	    var makeTab$2 = function (_info) {
	      var items = [{
	          type: 'dropzone',
	          name: 'fileinput'
	        }];
	      return {
	        title: 'Upload',
	        name: 'upload',
	        items: items
	      };
	    };
	    var UploadTab = { makeTab: makeTab$2 };
	
	    var createState = function (info) {
	      return {
	        prevImage: ListUtils.findEntry(info.imageList, info.image.src),
	        prevAlt: info.image.alt,
	        open: true
	      };
	    };
	    var fromImageData = function (image) {
	      return {
	        src: {
	          value: image.src,
	          meta: {}
	        },
	        images: image.src,
	        alt: image.alt,
	        title: image.title,
	        dimensions: {
	          width: image.width,
	          height: image.height
	        },
	        classes: image.class,
	        caption: image.caption,
	        style: image.style,
	        vspace: image.vspace,
	        border: image.border,
	        hspace: image.hspace,
	        borderstyle: image.borderStyle,
	        fileinput: [],
	        isDecorative: image.isDecorative
	      };
	    };
	    var toImageData = function (data, removeEmptyAlt) {
	      return {
	        src: data.src.value,
	        alt: data.alt.length === 0 && removeEmptyAlt ? null : data.alt,
	        title: data.title,
	        width: data.dimensions.width,
	        height: data.dimensions.height,
	        class: data.classes,
	        style: data.style,
	        caption: data.caption,
	        hspace: data.hspace,
	        vspace: data.vspace,
	        border: data.border,
	        borderStyle: data.borderstyle,
	        isDecorative: data.isDecorative
	      };
	    };
	    var addPrependUrl2 = function (info, srcURL) {
	      if (!/^(?:[a-zA-Z]+:)?\/\//.test(srcURL)) {
	        return info.prependURL.bind(function (prependUrl) {
	          if (srcURL.substring(0, prependUrl.length) !== prependUrl) {
	            return Optional.some(prependUrl + srcURL);
	          }
	          return Optional.none();
	        });
	      }
	      return Optional.none();
	    };
	    var addPrependUrl = function (info, api) {
	      var data = api.getData();
	      addPrependUrl2(info, data.src.value).each(function (srcURL) {
	        api.setData({
	          src: {
	            value: srcURL,
	            meta: data.src.meta
	          }
	        });
	      });
	    };
	    var formFillFromMeta2 = function (info, data, meta) {
	      if (info.hasDescription && isString(meta.alt)) {
	        data.alt = meta.alt;
	      }
	      if (info.hasAccessibilityOptions) {
	        data.isDecorative = meta.isDecorative || data.isDecorative || false;
	      }
	      if (info.hasImageTitle && isString(meta.title)) {
	        data.title = meta.title;
	      }
	      if (info.hasDimensions) {
	        if (isString(meta.width)) {
	          data.dimensions.width = meta.width;
	        }
	        if (isString(meta.height)) {
	          data.dimensions.height = meta.height;
	        }
	      }
	      if (isString(meta.class)) {
	        ListUtils.findEntry(info.classList, meta.class).each(function (entry) {
	          data.classes = entry.value;
	        });
	      }
	      if (info.hasImageCaption) {
	        if (isBoolean(meta.caption)) {
	          data.caption = meta.caption;
	        }
	      }
	      if (info.hasAdvTab) {
	        if (isString(meta.style)) {
	          data.style = meta.style;
	        }
	        if (isString(meta.vspace)) {
	          data.vspace = meta.vspace;
	        }
	        if (isString(meta.border)) {
	          data.border = meta.border;
	        }
	        if (isString(meta.hspace)) {
	          data.hspace = meta.hspace;
	        }
	        if (isString(meta.borderstyle)) {
	          data.borderstyle = meta.borderstyle;
	        }
	      }
	    };
	    var formFillFromMeta = function (info, api) {
	      var data = api.getData();
	      var meta = data.src.meta;
	      if (meta !== undefined) {
	        var newData = deepMerge({}, data);
	        formFillFromMeta2(info, newData, meta);
	        api.setData(newData);
	      }
	    };
	    var calculateImageSize = function (helpers, info, state, api) {
	      var data = api.getData();
	      var url = data.src.value;
	      var meta = data.src.meta || {};
	      if (!meta.width && !meta.height && info.hasDimensions) {
	        if (isNotEmpty(url)) {
	          helpers.imageSize(url).then(function (size) {
	            if (state.open) {
	              api.setData({ dimensions: size });
	            }
	          }).catch(function (e) {
	            return console.error(e);
	          });
	        } else {
	          api.setData({
	            dimensions: {
	              width: '',
	              height: ''
	            }
	          });
	        }
	      }
	    };
	    var updateImagesDropdown = function (info, state, api) {
	      var data = api.getData();
	      var image = ListUtils.findEntry(info.imageList, data.src.value);
	      state.prevImage = image;
	      api.setData({
	        images: image.map(function (entry) {
	          return entry.value;
	        }).getOr('')
	      });
	    };
	    var changeSrc = function (helpers, info, state, api) {
	      addPrependUrl(info, api);
	      formFillFromMeta(info, api);
	      calculateImageSize(helpers, info, state, api);
	      updateImagesDropdown(info, state, api);
	    };
	    var changeImages = function (helpers, info, state, api) {
	      var data = api.getData();
	      var image = ListUtils.findEntry(info.imageList, data.images);
	      image.each(function (img) {
	        var updateAlt = data.alt === '' || state.prevImage.map(function (image) {
	          return image.text === data.alt;
	        }).getOr(false);
	        if (updateAlt) {
	          if (img.value === '') {
	            api.setData({
	              src: img,
	              alt: state.prevAlt
	            });
	          } else {
	            api.setData({
	              src: img,
	              alt: img.text
	            });
	          }
	        } else {
	          api.setData({ src: img });
	        }
	      });
	      state.prevImage = image;
	      changeSrc(helpers, info, state, api);
	    };
	    var calcVSpace = function (css) {
	      var matchingTopBottom = css['margin-top'] && css['margin-bottom'] && css['margin-top'] === css['margin-bottom'];
	      return matchingTopBottom ? removePixelSuffix(String(css['margin-top'])) : '';
	    };
	    var calcHSpace = function (css) {
	      var matchingLeftRight = css['margin-right'] && css['margin-left'] && css['margin-right'] === css['margin-left'];
	      return matchingLeftRight ? removePixelSuffix(String(css['margin-right'])) : '';
	    };
	    var calcBorderWidth = function (css) {
	      return css['border-width'] ? removePixelSuffix(String(css['border-width'])) : '';
	    };
	    var calcBorderStyle = function (css) {
	      return css['border-style'] ? String(css['border-style']) : '';
	    };
	    var calcStyle = function (parseStyle, serializeStyle, css) {
	      return serializeStyle(parseStyle(serializeStyle(css)));
	    };
	    var changeStyle2 = function (parseStyle, serializeStyle, data) {
	      var css = mergeMargins(parseStyle(data.style));
	      var dataCopy = deepMerge({}, data);
	      dataCopy.vspace = calcVSpace(css);
	      dataCopy.hspace = calcHSpace(css);
	      dataCopy.border = calcBorderWidth(css);
	      dataCopy.borderstyle = calcBorderStyle(css);
	      dataCopy.style = calcStyle(parseStyle, serializeStyle, css);
	      return dataCopy;
	    };
	    var changeStyle = function (helpers, api) {
	      var data = api.getData();
	      var newData = changeStyle2(helpers.parseStyle, helpers.serializeStyle, data);
	      api.setData(newData);
	    };
	    var changeAStyle = function (helpers, info, api) {
	      var data = deepMerge(fromImageData(info.image), api.getData());
	      var style = getStyleValue(helpers.normalizeCss, toImageData(data, false));
	      api.setData({ style: style });
	    };
	    var changeFileInput = function (helpers, info, state, api) {
	      var data = api.getData();
	      api.block('Uploading image');
	      head(data.fileinput).fold(function () {
	        api.unblock();
	      }, function (file) {
	        var blobUri = URL.createObjectURL(file);
	        var finalize = function () {
	          api.unblock();
	          URL.revokeObjectURL(blobUri);
	        };
	        var updateSrcAndSwitchTab = function (url) {
	          api.setData({
	            src: {
	              value: url,
	              meta: {}
	            }
	          });
	          api.showTab('general');
	          changeSrc(helpers, info, state, api);
	        };
	        blobToDataUri(file).then(function (dataUrl) {
	          var blobInfo = helpers.createBlobCache(file, blobUri, dataUrl);
	          if (info.automaticUploads) {
	            helpers.uploadImage(blobInfo).then(function (result) {
	              updateSrcAndSwitchTab(result.url);
	              finalize();
	            }).catch(function (err) {
	              finalize();
	              helpers.alertErr(err);
	            });
	          } else {
	            helpers.addToBlobCache(blobInfo);
	            updateSrcAndSwitchTab(blobInfo.blobUri());
	            api.unblock();
	          }
	        });
	      });
	    };
	    var changeHandler = function (helpers, info, state) {
	      return function (api, evt) {
	        if (evt.name === 'src') {
	          changeSrc(helpers, info, state, api);
	        } else if (evt.name === 'images') {
	          changeImages(helpers, info, state, api);
	        } else if (evt.name === 'alt') {
	          state.prevAlt = api.getData().alt;
	        } else if (evt.name === 'style') {
	          changeStyle(helpers, api);
	        } else if (evt.name === 'vspace' || evt.name === 'hspace' || evt.name === 'border' || evt.name === 'borderstyle') {
	          changeAStyle(helpers, info, api);
	        } else if (evt.name === 'fileinput') {
	          changeFileInput(helpers, info, state, api);
	        } else if (evt.name === 'isDecorative') {
	          if (api.getData().isDecorative) {
	            api.disable('alt');
	          } else {
	            api.enable('alt');
	          }
	        }
	      };
	    };
	    var closeHandler = function (state) {
	      return function () {
	        state.open = false;
	      };
	    };
	    var makeDialogBody = function (info) {
	      if (info.hasAdvTab || info.hasUploadUrl || info.hasUploadHandler) {
	        var tabPanel = {
	          type: 'tabpanel',
	          tabs: flatten([
	            [MainTab.makeTab(info)],
	            info.hasAdvTab ? [AdvTab.makeTab(info)] : [],
	            info.hasUploadTab && (info.hasUploadUrl || info.hasUploadHandler) ? [UploadTab.makeTab(info)] : []
	          ])
	        };
	        return tabPanel;
	      } else {
	        var panel = {
	          type: 'panel',
	          items: MainTab.makeItems(info)
	        };
	        return panel;
	      }
	    };
	    var makeDialog = function (helpers) {
	      return function (info) {
	        var state = createState(info);
	        return {
	          title: 'Insert/Edit Image',
	          size: 'normal',
	          body: makeDialogBody(info),
	          buttons: [
	            {
	              type: 'cancel',
	              name: 'cancel',
	              text: 'Cancel'
	            },
	            {
	              type: 'submit',
	              name: 'save',
	              text: 'Save',
	              primary: true
	            }
	          ],
	          initialData: fromImageData(info.image),
	          onSubmit: helpers.onSubmit(info),
	          onChange: changeHandler(helpers, info, state),
	          onClose: closeHandler(state)
	        };
	      };
	    };
	    var submitHandler = function (editor) {
	      return function (info) {
	        return function (api) {
	          var data = deepMerge(fromImageData(info.image), api.getData());
	          editor.execCommand('mceUpdateImage', false, toImageData(data, info.hasAccessibilityOptions));
	          editor.editorUpload.uploadImagesAuto();
	          api.close();
	        };
	      };
	    };
	    var imageSize = function (editor) {
	      return function (url) {
	        return getImageSize(editor.documentBaseURI.toAbsolute(url)).then(function (dimensions) {
	          return {
	            width: String(dimensions.width),
	            height: String(dimensions.height)
	          };
	        });
	      };
	    };
	    var createBlobCache = function (editor) {
	      return function (file, blobUri, dataUrl) {
	        return editor.editorUpload.blobCache.create({
	          blob: file,
	          blobUri: blobUri,
	          name: file.name ? file.name.replace(/\.[^\.]+$/, '') : null,
	          filename: file.name,
	          base64: dataUrl.split(',')[1]
	        });
	      };
	    };
	    var addToBlobCache = function (editor) {
	      return function (blobInfo) {
	        editor.editorUpload.blobCache.add(blobInfo);
	      };
	    };
	    var alertErr = function (editor) {
	      return function (message) {
	        editor.windowManager.alert(message);
	      };
	    };
	    var normalizeCss$1 = function (editor) {
	      return function (cssText) {
	        return normalizeCss(editor, cssText);
	      };
	    };
	    var parseStyle = function (editor) {
	      return function (cssText) {
	        return editor.dom.parseStyle(cssText);
	      };
	    };
	    var serializeStyle = function (editor) {
	      return function (stylesArg, name) {
	        return editor.dom.serializeStyle(stylesArg, name);
	      };
	    };
	    var uploadImage = function (editor) {
	      return function (blobInfo) {
	        return global$4(editor).upload([blobInfo], false).then(function (results) {
	          if (results.length === 0) {
	            return global$2.reject('Failed to upload image');
	          } else if (results[0].status === false) {
	            return global$2.reject(results[0].error.message);
	          } else {
	            return results[0];
	          }
	        });
	      };
	    };
	    var Dialog = function (editor) {
	      var helpers = {
	        onSubmit: submitHandler(editor),
	        imageSize: imageSize(editor),
	        addToBlobCache: addToBlobCache(editor),
	        createBlobCache: createBlobCache(editor),
	        alertErr: alertErr(editor),
	        normalizeCss: normalizeCss$1(editor),
	        parseStyle: parseStyle(editor),
	        serializeStyle: serializeStyle(editor),
	        uploadImage: uploadImage(editor)
	      };
	      var open = function () {
	        collect(editor).then(makeDialog(helpers)).then(editor.windowManager.open);
	      };
	      return { open: open };
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceImage', Dialog(editor).open);
	      editor.addCommand('mceUpdateImage', function (_ui, data) {
	        editor.undoManager.transact(function () {
	          return insertOrUpdateImage(editor, data);
	        });
	      });
	    };
	
	    var hasImageClass = function (node) {
	      var className = node.attr('class');
	      return className && /\bimage\b/.test(className);
	    };
	    var toggleContentEditableState = function (state) {
	      return function (nodes) {
	        var i = nodes.length;
	        var toggleContentEditable = function (node) {
	          node.attr('contenteditable', state ? 'true' : null);
	        };
	        while (i--) {
	          var node = nodes[i];
	          if (hasImageClass(node)) {
	            node.attr('contenteditable', state ? 'false' : null);
	            global$5.each(node.getAll('figcaption'), toggleContentEditable);
	          }
	        }
	      };
	    };
	    var setup = function (editor) {
	      editor.on('PreInit', function () {
	        editor.parser.addNodeFilter('figure', toggleContentEditableState(true));
	        editor.serializer.addNodeFilter('figure', toggleContentEditableState(false));
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addToggleButton('image', {
	        icon: 'image',
	        tooltip: 'Insert/edit image',
	        onAction: Dialog(editor).open,
	        onSetup: function (buttonApi) {
	          return editor.selection.selectorChangedWithUnbind('img:not([data-mce-object],[data-mce-placeholder]),figure.image', buttonApi.setActive).unbind;
	        }
	      });
	      editor.ui.registry.addMenuItem('image', {
	        icon: 'image',
	        text: 'Image...',
	        onAction: Dialog(editor).open
	      });
	      editor.ui.registry.addContextMenu('image', {
	        update: function (element) {
	          return isFigure(element) || isImage(element) && !isPlaceholderImage(element) ? ['image'] : [];
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('image', function (editor) {
	        setup(editor);
	        register$1(editor);
	        register(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "insertdatetime" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/insertdatetime')
	//   ES2015:
	//     import 'tinymce/plugins/insertdatetime'
	__webpack_require__(1218);

/***/ },
/* 1218 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var getDateFormat = function (editor) {
	      return editor.getParam('insertdatetime_dateformat', editor.translate('%Y-%m-%d'));
	    };
	    var getTimeFormat = function (editor) {
	      return editor.getParam('insertdatetime_timeformat', editor.translate('%H:%M:%S'));
	    };
	    var getFormats = function (editor) {
	      return editor.getParam('insertdatetime_formats', [
	        '%H:%M:%S',
	        '%Y-%m-%d',
	        '%I:%M:%S %p',
	        '%D'
	      ]);
	    };
	    var getDefaultDateTime = function (editor) {
	      var formats = getFormats(editor);
	      return formats.length > 0 ? formats[0] : getTimeFormat(editor);
	    };
	    var shouldInsertTimeElement = function (editor) {
	      return editor.getParam('insertdatetime_element', false);
	    };
	
	    var daysShort = 'Sun Mon Tue Wed Thu Fri Sat Sun'.split(' ');
	    var daysLong = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday'.split(' ');
	    var monthsShort = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
	    var monthsLong = 'January February March April May June July August September October November December'.split(' ');
	    var addZeros = function (value, len) {
	      value = '' + value;
	      if (value.length < len) {
	        for (var i = 0; i < len - value.length; i++) {
	          value = '0' + value;
	        }
	      }
	      return value;
	    };
	    var getDateTime = function (editor, fmt, date) {
	      date = date || new Date();
	      fmt = fmt.replace('%D', '%m/%d/%Y');
	      fmt = fmt.replace('%r', '%I:%M:%S %p');
	      fmt = fmt.replace('%Y', '' + date.getFullYear());
	      fmt = fmt.replace('%y', '' + date.getYear());
	      fmt = fmt.replace('%m', addZeros(date.getMonth() + 1, 2));
	      fmt = fmt.replace('%d', addZeros(date.getDate(), 2));
	      fmt = fmt.replace('%H', '' + addZeros(date.getHours(), 2));
	      fmt = fmt.replace('%M', '' + addZeros(date.getMinutes(), 2));
	      fmt = fmt.replace('%S', '' + addZeros(date.getSeconds(), 2));
	      fmt = fmt.replace('%I', '' + ((date.getHours() + 11) % 12 + 1));
	      fmt = fmt.replace('%p', '' + (date.getHours() < 12 ? 'AM' : 'PM'));
	      fmt = fmt.replace('%B', '' + editor.translate(monthsLong[date.getMonth()]));
	      fmt = fmt.replace('%b', '' + editor.translate(monthsShort[date.getMonth()]));
	      fmt = fmt.replace('%A', '' + editor.translate(daysLong[date.getDay()]));
	      fmt = fmt.replace('%a', '' + editor.translate(daysShort[date.getDay()]));
	      fmt = fmt.replace('%%', '%');
	      return fmt;
	    };
	    var updateElement = function (editor, timeElm, computerTime, userTime) {
	      var newTimeElm = editor.dom.create('time', { datetime: computerTime }, userTime);
	      timeElm.parentNode.insertBefore(newTimeElm, timeElm);
	      editor.dom.remove(timeElm);
	      editor.selection.select(newTimeElm, true);
	      editor.selection.collapse(false);
	    };
	    var insertDateTime = function (editor, format) {
	      if (shouldInsertTimeElement(editor)) {
	        var userTime = getDateTime(editor, format);
	        var computerTime = void 0;
	        if (/%[HMSIp]/.test(format)) {
	          computerTime = getDateTime(editor, '%Y-%m-%dT%H:%M');
	        } else {
	          computerTime = getDateTime(editor, '%Y-%m-%d');
	        }
	        var timeElm = editor.dom.getParent(editor.selection.getStart(), 'time');
	        if (timeElm) {
	          updateElement(editor, timeElm, computerTime, userTime);
	        } else {
	          editor.insertContent('<time datetime="' + computerTime + '">' + userTime + '</time>');
	        }
	      } else {
	        editor.insertContent(getDateTime(editor, format));
	      }
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceInsertDate', function () {
	        insertDateTime(editor, getDateFormat(editor));
	      });
	      editor.addCommand('mceInsertTime', function () {
	        insertDateTime(editor, getTimeFormat(editor));
	      });
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var register$1 = function (editor) {
	      var formats = getFormats(editor);
	      var defaultFormat = Cell(getDefaultDateTime(editor));
	      editor.ui.registry.addSplitButton('insertdatetime', {
	        icon: 'insert-time',
	        tooltip: 'Insert date/time',
	        select: function (value) {
	          return value === defaultFormat.get();
	        },
	        fetch: function (done) {
	          done(global$1.map(formats, function (format) {
	            return {
	              type: 'choiceitem',
	              text: getDateTime(editor, format),
	              value: format
	            };
	          }));
	        },
	        onAction: function (_api) {
	          insertDateTime(editor, defaultFormat.get());
	        },
	        onItemAction: function (_api, value) {
	          defaultFormat.set(value);
	          insertDateTime(editor, value);
	        }
	      });
	      var makeMenuItemHandler = function (format) {
	        return function () {
	          defaultFormat.set(format);
	          insertDateTime(editor, format);
	        };
	      };
	      editor.ui.registry.addNestedMenuItem('insertdatetime', {
	        icon: 'insert-time',
	        text: 'Date/time',
	        getSubmenuItems: function () {
	          return global$1.map(formats, function (format) {
	            return {
	              type: 'menuitem',
	              text: getDateTime(editor, format),
	              onAction: makeMenuItemHandler(format)
	            };
	          });
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('insertdatetime', function (editor) {
	        register(editor);
	        register$1(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "link" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/link')
	//   ES2015:
	//     import 'tinymce/plugins/link'
	__webpack_require__(1220);

/***/ },
/* 1220 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isNull = eq(null);
	    var isBoolean = isSimpleType('boolean');
	    var isFunction = isSimpleType('function');
	
	    var assumeExternalTargets = function (editor) {
	      var externalTargets = editor.getParam('link_assume_external_targets', false);
	      if (isBoolean(externalTargets) && externalTargets) {
	        return 1;
	      } else if (isString(externalTargets) && (externalTargets === 'http' || externalTargets === 'https')) {
	        return externalTargets;
	      }
	      return 0;
	    };
	    var hasContextToolbar = function (editor) {
	      return editor.getParam('link_context_toolbar', false, 'boolean');
	    };
	    var getLinkList = function (editor) {
	      return editor.getParam('link_list');
	    };
	    var getDefaultLinkTarget = function (editor) {
	      return editor.getParam('default_link_target');
	    };
	    var getTargetList = function (editor) {
	      return editor.getParam('target_list', true);
	    };
	    var getRelList = function (editor) {
	      return editor.getParam('rel_list', [], 'array');
	    };
	    var getLinkClassList = function (editor) {
	      return editor.getParam('link_class_list', [], 'array');
	    };
	    var shouldShowLinkTitle = function (editor) {
	      return editor.getParam('link_title', true, 'boolean');
	    };
	    var allowUnsafeLinkTarget = function (editor) {
	      return editor.getParam('allow_unsafe_link_target', false, 'boolean');
	    };
	    var useQuickLink = function (editor) {
	      return editor.getParam('link_quicklink', false, 'boolean');
	    };
	    var getDefaultLinkProtocol = function (editor) {
	      return editor.getParam('link_default_protocol', 'http', 'string');
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getValue = function (item) {
	      return isString(item.value) ? item.value : '';
	    };
	    var getText = function (item) {
	      if (isString(item.text)) {
	        return item.text;
	      } else if (isString(item.title)) {
	        return item.title;
	      } else {
	        return '';
	      }
	    };
	    var sanitizeList = function (list, extractValue) {
	      var out = [];
	      global$2.each(list, function (item) {
	        var text = getText(item);
	        if (item.menu !== undefined) {
	          var items = sanitizeList(item.menu, extractValue);
	          out.push({
	            text: text,
	            items: items
	          });
	        } else {
	          var value = extractValue(item);
	          out.push({
	            text: text,
	            value: value
	          });
	        }
	      });
	      return out;
	    };
	    var sanitizeWith = function (extracter) {
	      if (extracter === void 0) {
	        extracter = getValue;
	      }
	      return function (list) {
	        return Optional.from(list).map(function (list) {
	          return sanitizeList(list, extracter);
	        });
	      };
	    };
	    var sanitize = function (list) {
	      return sanitizeWith(getValue)(list);
	    };
	    var createUi = function (name, label) {
	      return function (items) {
	        return {
	          name: name,
	          type: 'listbox',
	          label: label,
	          items: items
	        };
	      };
	    };
	    var ListOptions = {
	      sanitize: sanitize,
	      sanitizeWith: sanitizeWith,
	      createUi: createUi,
	      getValue: getValue
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName.toLowerCase() === 'a';
	    };
	    var isLink = function (elm) {
	      return isAnchor(elm) && !!getHref(elm);
	    };
	    var collectNodesInRange = function (rng, predicate) {
	      if (rng.collapsed) {
	        return [];
	      } else {
	        var contents = rng.cloneContents();
	        var walker = new global$3(contents.firstChild, contents);
	        var elements = [];
	        var current = contents.firstChild;
	        do {
	          if (predicate(current)) {
	            elements.push(current);
	          }
	        } while (current = walker.next());
	        return elements;
	      }
	    };
	    var hasProtocol = function (url) {
	      return /^\w+:/i.test(url);
	    };
	    var getHref = function (elm) {
	      var href = elm.getAttribute('data-mce-href');
	      return href ? href : elm.getAttribute('href');
	    };
	    var applyRelTargetRules = function (rel, isUnsafe) {
	      var rules = ['noopener'];
	      var rels = rel ? rel.split(/\s+/) : [];
	      var toString = function (rels) {
	        return global$2.trim(rels.sort().join(' '));
	      };
	      var addTargetRules = function (rels) {
	        rels = removeTargetRules(rels);
	        return rels.length > 0 ? rels.concat(rules) : rules;
	      };
	      var removeTargetRules = function (rels) {
	        return rels.filter(function (val) {
	          return global$2.inArray(rules, val) === -1;
	        });
	      };
	      var newRels = isUnsafe ? addTargetRules(rels) : removeTargetRules(rels);
	      return newRels.length > 0 ? toString(newRels) : '';
	    };
	    var trimCaretContainers = function (text) {
	      return text.replace(/\uFEFF/g, '');
	    };
	    var getAnchorElement = function (editor, selectedElm) {
	      selectedElm = selectedElm || editor.selection.getNode();
	      if (isImageFigure(selectedElm)) {
	        return editor.dom.select('a[href]', selectedElm)[0];
	      } else {
	        return editor.dom.getParent(selectedElm, 'a[href]');
	      }
	    };
	    var getAnchorText = function (selection, anchorElm) {
	      var text = anchorElm ? anchorElm.innerText || anchorElm.textContent : selection.getContent({ format: 'text' });
	      return trimCaretContainers(text);
	    };
	    var hasLinks = function (elements) {
	      return global$2.grep(elements, isLink).length > 0;
	    };
	    var hasLinksInSelection = function (rng) {
	      return collectNodesInRange(rng, isLink).length > 0;
	    };
	    var isOnlyTextSelected = function (editor) {
	      var inlineTextElements = editor.schema.getTextInlineElements();
	      var isElement = function (elm) {
	        return elm.nodeType === 1 && !isAnchor(elm) && !has(inlineTextElements, elm.nodeName.toLowerCase());
	      };
	      var elements = collectNodesInRange(editor.selection.getRng(), isElement);
	      return elements.length === 0;
	    };
	    var isImageFigure = function (elm) {
	      return elm && elm.nodeName === 'FIGURE' && /\bimage\b/i.test(elm.className);
	    };
	    var getLinkAttrs = function (data) {
	      return foldl([
	        'title',
	        'rel',
	        'class',
	        'target'
	      ], function (acc, key) {
	        data[key].each(function (value) {
	          acc[key] = value.length > 0 ? value : null;
	        });
	        return acc;
	      }, { href: data.href });
	    };
	    var handleExternalTargets = function (href, assumeExternalTargets) {
	      if ((assumeExternalTargets === 'http' || assumeExternalTargets === 'https') && !hasProtocol(href)) {
	        return assumeExternalTargets + '://' + href;
	      }
	      return href;
	    };
	    var applyLinkOverrides = function (editor, linkAttrs) {
	      var newLinkAttrs = __assign({}, linkAttrs);
	      if (!(getRelList(editor).length > 0) && allowUnsafeLinkTarget(editor) === false) {
	        var newRel = applyRelTargetRules(newLinkAttrs.rel, newLinkAttrs.target === '_blank');
	        newLinkAttrs.rel = newRel ? newRel : null;
	      }
	      if (Optional.from(newLinkAttrs.target).isNone() && getTargetList(editor) === false) {
	        newLinkAttrs.target = getDefaultLinkTarget(editor);
	      }
	      newLinkAttrs.href = handleExternalTargets(newLinkAttrs.href, assumeExternalTargets(editor));
	      return newLinkAttrs;
	    };
	    var updateLink = function (editor, anchorElm, text, linkAttrs) {
	      text.each(function (text) {
	        if (anchorElm.hasOwnProperty('innerText')) {
	          anchorElm.innerText = text;
	        } else {
	          anchorElm.textContent = text;
	        }
	      });
	      editor.dom.setAttribs(anchorElm, linkAttrs);
	      editor.selection.select(anchorElm);
	    };
	    var createLink = function (editor, selectedElm, text, linkAttrs) {
	      if (isImageFigure(selectedElm)) {
	        linkImageFigure(editor, selectedElm, linkAttrs);
	      } else {
	        text.fold(function () {
	          editor.execCommand('mceInsertLink', false, linkAttrs);
	        }, function (text) {
	          editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(text)));
	        });
	      }
	    };
	    var linkDomMutation = function (editor, attachState, data) {
	      var selectedElm = editor.selection.getNode();
	      var anchorElm = getAnchorElement(editor, selectedElm);
	      var linkAttrs = applyLinkOverrides(editor, getLinkAttrs(data));
	      editor.undoManager.transact(function () {
	        if (data.href === attachState.href) {
	          attachState.attach();
	        }
	        if (anchorElm) {
	          editor.focus();
	          updateLink(editor, anchorElm, data.text, linkAttrs);
	        } else {
	          createLink(editor, selectedElm, data.text, linkAttrs);
	        }
	      });
	    };
	    var unlinkSelection = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var bookmark = selection.getBookmark();
	      var rng = selection.getRng().cloneRange();
	      var startAnchorElm = dom.getParent(rng.startContainer, 'a[href]', editor.getBody());
	      var endAnchorElm = dom.getParent(rng.endContainer, 'a[href]', editor.getBody());
	      if (startAnchorElm) {
	        rng.setStartBefore(startAnchorElm);
	      }
	      if (endAnchorElm) {
	        rng.setEndAfter(endAnchorElm);
	      }
	      selection.setRng(rng);
	      editor.execCommand('unlink');
	      selection.moveToBookmark(bookmark);
	    };
	    var unlinkDomMutation = function (editor) {
	      editor.undoManager.transact(function () {
	        var node = editor.selection.getNode();
	        if (isImageFigure(node)) {
	          unlinkImageFigure(editor, node);
	        } else {
	          unlinkSelection(editor);
	        }
	        editor.focus();
	      });
	    };
	    var unwrapOptions = function (data) {
	      var cls = data.class, href = data.href, rel = data.rel, target = data.target, text = data.text, title = data.title;
	      return filter({
	        class: cls.getOrNull(),
	        href: href,
	        rel: rel.getOrNull(),
	        target: target.getOrNull(),
	        text: text.getOrNull(),
	        title: title.getOrNull()
	      }, function (v, _k) {
	        return isNull(v) === false;
	      });
	    };
	    var link = function (editor, attachState, data) {
	      editor.hasPlugin('rtc', true) ? editor.execCommand('createlink', false, unwrapOptions(data)) : linkDomMutation(editor, attachState, data);
	    };
	    var unlink = function (editor) {
	      editor.hasPlugin('rtc', true) ? editor.execCommand('unlink') : unlinkDomMutation(editor);
	    };
	    var unlinkImageFigure = function (editor, fig) {
	      var img = editor.dom.select('img', fig)[0];
	      if (img) {
	        var a = editor.dom.getParents(img, 'a[href]', fig)[0];
	        if (a) {
	          a.parentNode.insertBefore(img, a);
	          editor.dom.remove(a);
	        }
	      }
	    };
	    var linkImageFigure = function (editor, fig, attrs) {
	      var img = editor.dom.select('img', fig)[0];
	      if (img) {
	        var a = editor.dom.create('a', attrs);
	        img.parentNode.insertBefore(a, img);
	        a.appendChild(img);
	      }
	    };
	
	    var isListGroup = function (item) {
	      return hasNonNullableKey(item, 'items');
	    };
	    var findTextByValue = function (value, catalog) {
	      return findMap(catalog, function (item) {
	        if (isListGroup(item)) {
	          return findTextByValue(value, item.items);
	        } else {
	          return someIf(item.value === value, item);
	        }
	      });
	    };
	    var getDelta = function (persistentText, fieldName, catalog, data) {
	      var value = data[fieldName];
	      var hasPersistentText = persistentText.length > 0;
	      return value !== undefined ? findTextByValue(value, catalog).map(function (i) {
	        return {
	          url: {
	            value: i.value,
	            meta: {
	              text: hasPersistentText ? persistentText : i.text,
	              attach: noop
	            }
	          },
	          text: hasPersistentText ? persistentText : i.text
	        };
	      }) : Optional.none();
	    };
	    var findCatalog = function (catalogs, fieldName) {
	      if (fieldName === 'link') {
	        return catalogs.link;
	      } else if (fieldName === 'anchor') {
	        return catalogs.anchor;
	      } else {
	        return Optional.none();
	      }
	    };
	    var init = function (initialData, linkCatalog) {
	      var persistentData = {
	        text: initialData.text,
	        title: initialData.title
	      };
	      var getTitleFromUrlChange = function (url) {
	        return someIf(persistentData.title.length <= 0, Optional.from(url.meta.title).getOr(''));
	      };
	      var getTextFromUrlChange = function (url) {
	        return someIf(persistentData.text.length <= 0, Optional.from(url.meta.text).getOr(url.value));
	      };
	      var onUrlChange = function (data) {
	        var text = getTextFromUrlChange(data.url);
	        var title = getTitleFromUrlChange(data.url);
	        if (text.isSome() || title.isSome()) {
	          return Optional.some(__assign(__assign({}, text.map(function (text) {
	            return { text: text };
	          }).getOr({})), title.map(function (title) {
	            return { title: title };
	          }).getOr({})));
	        } else {
	          return Optional.none();
	        }
	      };
	      var onCatalogChange = function (data, change) {
	        var catalog = findCatalog(linkCatalog, change.name).getOr([]);
	        return getDelta(persistentData.text, change.name, catalog, data);
	      };
	      var onChange = function (getData, change) {
	        var name = change.name;
	        if (name === 'url') {
	          return onUrlChange(getData());
	        } else if (contains([
	            'anchor',
	            'link'
	          ], name)) {
	          return onCatalogChange(getData(), change);
	        } else if (name === 'text' || name === 'title') {
	          persistentData[name] = getData()[name];
	          return Optional.none();
	        } else {
	          return Optional.none();
	        }
	      };
	      return { onChange: onChange };
	    };
	    var DialogChanges = {
	      init: init,
	      getDelta: getDelta
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var delayedConfirm = function (editor, message, callback) {
	      var rng = editor.selection.getRng();
	      global$4.setEditorTimeout(editor, function () {
	        editor.windowManager.confirm(message, function (state) {
	          editor.selection.setRng(rng);
	          callback(state);
	        });
	      });
	    };
	    var tryEmailTransform = function (data) {
	      var url = data.href;
	      var suggestMailTo = url.indexOf('@') > 0 && url.indexOf('/') === -1 && url.indexOf('mailto:') === -1;
	      return suggestMailTo ? Optional.some({
	        message: 'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?',
	        preprocess: function (oldData) {
	          return __assign(__assign({}, oldData), { href: 'mailto:' + url });
	        }
	      }) : Optional.none();
	    };
	    var tryProtocolTransform = function (assumeExternalTargets, defaultLinkProtocol) {
	      return function (data) {
	        var url = data.href;
	        var suggestProtocol = assumeExternalTargets === 1 && !hasProtocol(url) || assumeExternalTargets === 0 && /^\s*www(\.|\d\.)/i.test(url);
	        return suggestProtocol ? Optional.some({
	          message: 'The URL you entered seems to be an external link. Do you want to add the required ' + defaultLinkProtocol + ':// prefix?',
	          preprocess: function (oldData) {
	            return __assign(__assign({}, oldData), { href: defaultLinkProtocol + '://' + url });
	          }
	        }) : Optional.none();
	      };
	    };
	    var preprocess = function (editor, data) {
	      return findMap([
	        tryEmailTransform,
	        tryProtocolTransform(assumeExternalTargets(editor), getDefaultLinkProtocol(editor))
	      ], function (f) {
	        return f(data);
	      }).fold(function () {
	        return global$5.resolve(data);
	      }, function (transform) {
	        return new global$5(function (callback) {
	          delayedConfirm(editor, transform.message, function (state) {
	            callback(state ? transform.preprocess(data) : data);
	          });
	        });
	      });
	    };
	    var DialogConfirms = { preprocess: preprocess };
	
	    var getAnchors = function (editor) {
	      var anchorNodes = editor.dom.select('a:not([href])');
	      var anchors = bind(anchorNodes, function (anchor) {
	        var id = anchor.name || anchor.id;
	        return id ? [{
	            text: id,
	            value: '#' + id
	          }] : [];
	      });
	      return anchors.length > 0 ? Optional.some([{
	          text: 'None',
	          value: ''
	        }].concat(anchors)) : Optional.none();
	    };
	    var AnchorListOptions = { getAnchors: getAnchors };
	
	    var getClasses = function (editor) {
	      var list = getLinkClassList(editor);
	      if (list.length > 0) {
	        return ListOptions.sanitize(list);
	      }
	      return Optional.none();
	    };
	    var ClassListOptions = { getClasses: getClasses };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var parseJson = function (text) {
	      try {
	        return Optional.some(JSON.parse(text));
	      } catch (err) {
	        return Optional.none();
	      }
	    };
	    var getLinks = function (editor) {
	      var extractor = function (item) {
	        return editor.convertURL(item.value || item.url, 'href');
	      };
	      var linkList = getLinkList(editor);
	      return new global$5(function (callback) {
	        if (isString(linkList)) {
	          global$6.send({
	            url: linkList,
	            success: function (text) {
	              return callback(parseJson(text));
	            },
	            error: function (_) {
	              return callback(Optional.none());
	            }
	          });
	        } else if (isFunction(linkList)) {
	          linkList(function (output) {
	            return callback(Optional.some(output));
	          });
	        } else {
	          callback(Optional.from(linkList));
	        }
	      }).then(function (optItems) {
	        return optItems.bind(ListOptions.sanitizeWith(extractor)).map(function (items) {
	          if (items.length > 0) {
	            var noneItem = [{
	                text: 'None',
	                value: ''
	              }];
	            return noneItem.concat(items);
	          } else {
	            return items;
	          }
	        });
	      });
	    };
	    var LinkListOptions = { getLinks: getLinks };
	
	    var getRels = function (editor, initialTarget) {
	      var list = getRelList(editor);
	      if (list.length > 0) {
	        var isTargetBlank_1 = initialTarget.is('_blank');
	        var enforceSafe = allowUnsafeLinkTarget(editor) === false;
	        var safeRelExtractor = function (item) {
	          return applyRelTargetRules(ListOptions.getValue(item), isTargetBlank_1);
	        };
	        var sanitizer = enforceSafe ? ListOptions.sanitizeWith(safeRelExtractor) : ListOptions.sanitize;
	        return sanitizer(list);
	      }
	      return Optional.none();
	    };
	    var RelOptions = { getRels: getRels };
	
	    var fallbacks = [
	      {
	        text: 'Current window',
	        value: ''
	      },
	      {
	        text: 'New window',
	        value: '_blank'
	      }
	    ];
	    var getTargets = function (editor) {
	      var list = getTargetList(editor);
	      if (isArray(list)) {
	        return ListOptions.sanitize(list).orThunk(function () {
	          return Optional.some(fallbacks);
	        });
	      } else if (list === false) {
	        return Optional.none();
	      }
	      return Optional.some(fallbacks);
	    };
	    var TargetOptions = { getTargets: getTargets };
	
	    var nonEmptyAttr = function (dom, elem, name) {
	      var val = dom.getAttrib(elem, name);
	      return val !== null && val.length > 0 ? Optional.some(val) : Optional.none();
	    };
	    var extractFromAnchor = function (editor, anchor) {
	      var dom = editor.dom;
	      var onlyText = isOnlyTextSelected(editor);
	      var text = onlyText ? Optional.some(getAnchorText(editor.selection, anchor)) : Optional.none();
	      var url = anchor ? Optional.some(dom.getAttrib(anchor, 'href')) : Optional.none();
	      var target = anchor ? Optional.from(dom.getAttrib(anchor, 'target')) : Optional.none();
	      var rel = nonEmptyAttr(dom, anchor, 'rel');
	      var linkClass = nonEmptyAttr(dom, anchor, 'class');
	      var title = nonEmptyAttr(dom, anchor, 'title');
	      return {
	        url: url,
	        text: text,
	        title: title,
	        target: target,
	        rel: rel,
	        linkClass: linkClass
	      };
	    };
	    var collect = function (editor, linkNode) {
	      return LinkListOptions.getLinks(editor).then(function (links) {
	        var anchor = extractFromAnchor(editor, linkNode);
	        return {
	          anchor: anchor,
	          catalogs: {
	            targets: TargetOptions.getTargets(editor),
	            rels: RelOptions.getRels(editor, anchor.target),
	            classes: ClassListOptions.getClasses(editor),
	            anchor: AnchorListOptions.getAnchors(editor),
	            link: links
	          },
	          optNode: Optional.from(linkNode),
	          flags: { titleEnabled: shouldShowLinkTitle(editor) }
	        };
	      });
	    };
	    var DialogInfo = { collect: collect };
	
	    var handleSubmit = function (editor, info) {
	      return function (api) {
	        var data = api.getData();
	        if (!data.url.value) {
	          unlink(editor);
	          api.close();
	          return;
	        }
	        var getChangedValue = function (key) {
	          return Optional.from(data[key]).filter(function (value) {
	            return !info.anchor[key].is(value);
	          });
	        };
	        var changedData = {
	          href: data.url.value,
	          text: getChangedValue('text'),
	          target: getChangedValue('target'),
	          rel: getChangedValue('rel'),
	          class: getChangedValue('linkClass'),
	          title: getChangedValue('title')
	        };
	        var attachState = {
	          href: data.url.value,
	          attach: data.url.meta !== undefined && data.url.meta.attach ? data.url.meta.attach : noop
	        };
	        DialogConfirms.preprocess(editor, changedData).then(function (pData) {
	          link(editor, attachState, pData);
	        });
	        api.close();
	      };
	    };
	    var collectData = function (editor) {
	      var anchorNode = getAnchorElement(editor);
	      return DialogInfo.collect(editor, anchorNode);
	    };
	    var getInitialData = function (info, defaultTarget) {
	      var anchor = info.anchor;
	      var url = anchor.url.getOr('');
	      return {
	        url: {
	          value: url,
	          meta: { original: { value: url } }
	        },
	        text: anchor.text.getOr(''),
	        title: anchor.title.getOr(''),
	        anchor: url,
	        link: url,
	        rel: anchor.rel.getOr(''),
	        target: anchor.target.or(defaultTarget).getOr(''),
	        linkClass: anchor.linkClass.getOr('')
	      };
	    };
	    var makeDialog = function (settings, onSubmit, editor) {
	      var urlInput = [{
	          name: 'url',
	          type: 'urlinput',
	          filetype: 'file',
	          label: 'URL'
	        }];
	      var displayText = settings.anchor.text.map(function () {
	        return {
	          name: 'text',
	          type: 'input',
	          label: 'Text to display'
	        };
	      }).toArray();
	      var titleText = settings.flags.titleEnabled ? [{
	          name: 'title',
	          type: 'input',
	          label: 'Title'
	        }] : [];
	      var defaultTarget = Optional.from(getDefaultLinkTarget(editor));
	      var initialData = getInitialData(settings, defaultTarget);
	      var catalogs = settings.catalogs;
	      var dialogDelta = DialogChanges.init(initialData, catalogs);
	      var body = {
	        type: 'panel',
	        items: flatten([
	          urlInput,
	          displayText,
	          titleText,
	          cat([
	            catalogs.anchor.map(ListOptions.createUi('anchor', 'Anchors')),
	            catalogs.rels.map(ListOptions.createUi('rel', 'Rel')),
	            catalogs.targets.map(ListOptions.createUi('target', 'Open link in...')),
	            catalogs.link.map(ListOptions.createUi('link', 'Link list')),
	            catalogs.classes.map(ListOptions.createUi('linkClass', 'Class'))
	          ])
	        ])
	      };
	      return {
	        title: 'Insert/Edit Link',
	        size: 'normal',
	        body: body,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: initialData,
	        onChange: function (api, _a) {
	          var name = _a.name;
	          dialogDelta.onChange(api.getData, { name: name }).each(function (newData) {
	            api.setData(newData);
	          });
	        },
	        onSubmit: onSubmit
	      };
	    };
	    var open = function (editor) {
	      var data = collectData(editor);
	      data.then(function (info) {
	        var onSubmit = handleSubmit(editor, info);
	        return makeDialog(info, onSubmit, editor);
	      }).then(function (spec) {
	        editor.windowManager.open(spec);
	      });
	    };
	
	    var appendClickRemove = function (link, evt) {
	      document.body.appendChild(link);
	      link.dispatchEvent(evt);
	      document.body.removeChild(link);
	    };
	    var open$1 = function (url) {
	      var link = document.createElement('a');
	      link.target = '_blank';
	      link.href = url;
	      link.rel = 'noreferrer noopener';
	      var evt = document.createEvent('MouseEvents');
	      evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	      appendClickRemove(link, evt);
	    };
	
	    var getLink = function (editor, elm) {
	      return editor.dom.getParent(elm, 'a[href]');
	    };
	    var getSelectedLink = function (editor) {
	      return getLink(editor, editor.selection.getStart());
	    };
	    var hasOnlyAltModifier = function (e) {
	      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
	    };
	    var gotoLink = function (editor, a) {
	      if (a) {
	        var href = getHref(a);
	        if (/^#/.test(href)) {
	          var targetEl = editor.$(href);
	          if (targetEl.length) {
	            editor.selection.scrollIntoView(targetEl[0], true);
	          }
	        } else {
	          open$1(a.href);
	        }
	      }
	    };
	    var openDialog = function (editor) {
	      return function () {
	        open(editor);
	      };
	    };
	    var gotoSelectedLink = function (editor) {
	      return function () {
	        gotoLink(editor, getSelectedLink(editor));
	      };
	    };
	    var setupGotoLinks = function (editor) {
	      editor.on('click', function (e) {
	        var link = getLink(editor, e.target);
	        if (link && global$1.metaKeyPressed(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	      editor.on('keydown', function (e) {
	        var link = getSelectedLink(editor);
	        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	    };
	    var toggleState = function (editor, toggler) {
	      editor.on('NodeChange', toggler);
	      return function () {
	        return editor.off('NodeChange', toggler);
	      };
	    };
	    var toggleActiveState = function (editor) {
	      return function (api) {
	        return toggleState(editor, function () {
	          api.setActive(!editor.mode.isReadOnly() && getAnchorElement(editor, editor.selection.getNode()) !== null);
	        });
	      };
	    };
	    var toggleEnabledState = function (editor) {
	      return function (api) {
	        var updateState = function () {
	          return api.setDisabled(getAnchorElement(editor, editor.selection.getNode()) === null);
	        };
	        updateState();
	        return toggleState(editor, updateState);
	      };
	    };
	    var toggleUnlinkState = function (editor) {
	      return function (api) {
	        var hasLinks$1 = function (parents) {
	          return hasLinks(parents) || hasLinksInSelection(editor.selection.getRng());
	        };
	        var parents = editor.dom.getParents(editor.selection.getStart());
	        api.setDisabled(!hasLinks$1(parents));
	        return toggleState(editor, function (e) {
	          return api.setDisabled(!hasLinks$1(e.parents));
	        });
	      };
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceLink', function () {
	        if (useQuickLink(editor)) {
	          editor.fire('contexttoolbar-show', { toolbarKey: 'quicklink' });
	        } else {
	          openDialog(editor)();
	        }
	      });
	    };
	
	    var setup = function (editor) {
	      editor.addShortcut('Meta+K', '', function () {
	        editor.execCommand('mceLink');
	      });
	    };
	
	    var setupButtons = function (editor) {
	      editor.ui.registry.addToggleButton('link', {
	        icon: 'link',
	        tooltip: 'Insert/edit link',
	        onAction: openDialog(editor),
	        onSetup: toggleActiveState(editor)
	      });
	      editor.ui.registry.addButton('openlink', {
	        icon: 'new-tab',
	        tooltip: 'Open link',
	        onAction: gotoSelectedLink(editor),
	        onSetup: toggleEnabledState(editor)
	      });
	      editor.ui.registry.addButton('unlink', {
	        icon: 'unlink',
	        tooltip: 'Remove link',
	        onAction: function () {
	          return unlink(editor);
	        },
	        onSetup: toggleUnlinkState(editor)
	      });
	    };
	    var setupMenuItems = function (editor) {
	      editor.ui.registry.addMenuItem('openlink', {
	        text: 'Open link',
	        icon: 'new-tab',
	        onAction: gotoSelectedLink(editor),
	        onSetup: toggleEnabledState(editor)
	      });
	      editor.ui.registry.addMenuItem('link', {
	        icon: 'link',
	        text: 'Link...',
	        shortcut: 'Meta+K',
	        onAction: openDialog(editor)
	      });
	      editor.ui.registry.addMenuItem('unlink', {
	        icon: 'unlink',
	        text: 'Remove link',
	        onAction: function () {
	          return unlink(editor);
	        },
	        onSetup: toggleUnlinkState(editor)
	      });
	    };
	    var setupContextMenu = function (editor) {
	      var inLink = 'link unlink openlink';
	      var noLink = 'link';
	      editor.ui.registry.addContextMenu('link', {
	        update: function (element) {
	          return hasLinks(editor.dom.getParents(element, 'a')) ? inLink : noLink;
	        }
	      });
	    };
	    var setupContextToolbars = function (editor) {
	      var collapseSelectionToEnd = function (editor) {
	        editor.selection.collapse(false);
	      };
	      var onSetupLink = function (buttonApi) {
	        var node = editor.selection.getNode();
	        buttonApi.setDisabled(!getAnchorElement(editor, node));
	        return noop;
	      };
	      editor.ui.registry.addContextForm('quicklink', {
	        launch: {
	          type: 'contextformtogglebutton',
	          icon: 'link',
	          tooltip: 'Link',
	          onSetup: toggleActiveState(editor)
	        },
	        label: 'Link',
	        predicate: function (node) {
	          return !!getAnchorElement(editor, node) && hasContextToolbar(editor);
	        },
	        initValue: function () {
	          var elm = getAnchorElement(editor);
	          return !!elm ? getHref(elm) : '';
	        },
	        commands: [
	          {
	            type: 'contextformtogglebutton',
	            icon: 'link',
	            tooltip: 'Link',
	            primary: true,
	            onSetup: function (buttonApi) {
	              var node = editor.selection.getNode();
	              buttonApi.setActive(!!getAnchorElement(editor, node));
	              return toggleActiveState(editor)(buttonApi);
	            },
	            onAction: function (formApi) {
	              var anchor = getAnchorElement(editor);
	              var value = formApi.getValue();
	              if (!anchor) {
	                var attachState = {
	                  href: value,
	                  attach: noop
	                };
	                var onlyText = isOnlyTextSelected(editor);
	                var text = onlyText ? Optional.some(getAnchorText(editor.selection, anchor)).filter(function (t) {
	                  return t.length > 0;
	                }).or(Optional.from(value)) : Optional.none();
	                link(editor, attachState, {
	                  href: value,
	                  text: text,
	                  title: Optional.none(),
	                  rel: Optional.none(),
	                  target: Optional.none(),
	                  class: Optional.none()
	                });
	                formApi.hide();
	              } else {
	                editor.undoManager.transact(function () {
	                  editor.dom.setAttrib(anchor, 'href', value);
	                  collapseSelectionToEnd(editor);
	                  formApi.hide();
	                });
	              }
	            }
	          },
	          {
	            type: 'contextformbutton',
	            icon: 'unlink',
	            tooltip: 'Remove link',
	            onSetup: onSetupLink,
	            onAction: function (formApi) {
	              unlink(editor);
	              formApi.hide();
	            }
	          },
	          {
	            type: 'contextformbutton',
	            icon: 'new-tab',
	            tooltip: 'Open link',
	            onSetup: onSetupLink,
	            onAction: function (formApi) {
	              gotoSelectedLink(editor)();
	              formApi.hide();
	            }
	          }
	        ]
	      });
	    };
	
	    function Plugin () {
	      global.add('link', function (editor) {
	        setupButtons(editor);
	        setupMenuItems(editor);
	        setupContextMenu(editor);
	        setupContextToolbars(editor);
	        setupGotoLinks(editor);
	        register(editor);
	        setup(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "lists" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/lists')
	//   ES2015:
	//     import 'tinymce/plugins/lists'
	__webpack_require__(1222);

/***/ },
/* 1222 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isBoolean = isSimpleType('boolean');
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]);
	        var r = [];
	        var group = [];
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var get = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get(xs, 0);
	    };
	    var last = function (xs) {
	      return get(xs, xs.length - 1);
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
	        s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	      return r;
	    }
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var contains = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim = blank(/^\s+|\s+$/g);
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	    var isEmpty = function (s) {
	      return !isNotEmpty(s);
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains(uastring, 'edge/') && contains(uastring, 'chrome') && contains(uastring, 'safari') && contains(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'chrome') && !contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains(uastring, 'msie') || contains(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains(uastring, 'safari') || contains(uastring, 'mobile/')) && contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains(uastring, 'iphone') || contains(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$2 = function (userAgent, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, mediaMatch);
	    });
	    var detect$3 = function () {
	      return platform();
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var ELEMENT = 1;
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var is = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	
	    var eq = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains$1 = function (e1, e2) {
	      return detect$3().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	    var is$1 = is;
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var keys = Object.keys;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter$1 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var name = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom;
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var clone = function (element) {
	      return foldl(element.dom.attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var lastChild = function (element) {
	      return child(element, element.dom.childNodes.length - 1);
	    };
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var remove = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	
	    var clone$1 = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var deep = function (original) {
	      return clone$1(original, true);
	    };
	    var shallowAs = function (original, tag) {
	      var nu = SugarElement.fromTag(tag);
	      var attributes = clone(original);
	      setAll(nu, attributes);
	      return nu;
	    };
	    var mutate = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      before(original, nu);
	      var children$1 = children(original);
	      append$1(nu, children$1);
	      remove(original);
	      return nu;
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var matchNodeName = function (name) {
	      return function (node) {
	        return node && node.nodeName.toLowerCase() === name;
	      };
	    };
	    var matchNodeNames = function (regex) {
	      return function (node) {
	        return node && regex.test(node.nodeName);
	      };
	    };
	    var isTextNode = function (node) {
	      return node && node.nodeType === 3;
	    };
	    var isListNode = matchNodeNames(/^(OL|UL|DL)$/);
	    var isOlUlNode = matchNodeNames(/^(OL|UL)$/);
	    var isOlNode = matchNodeName('ol');
	    var isListItemNode = matchNodeNames(/^(LI|DT|DD)$/);
	    var isDlItemNode = matchNodeNames(/^(DT|DD)$/);
	    var isTableCellNode = matchNodeNames(/^(TH|TD)$/);
	    var isBr = matchNodeName('br');
	    var isFirstChild = function (node) {
	      return node.parentNode.firstChild === node;
	    };
	    var isTextBlock = function (editor, node) {
	      return node && !!editor.schema.getTextBlockElements()[node.nodeName];
	    };
	    var isBlock = function (node, blockElements) {
	      return node && node.nodeName in blockElements;
	    };
	    var isBogusBr = function (dom, node) {
	      if (!isBr(node)) {
	        return false;
	      }
	      return dom.isBlock(node.nextSibling) && !isBr(node.previousSibling);
	    };
	    var isEmpty$1 = function (dom, elm, keepBookmarks) {
	      var empty = dom.isEmpty(elm);
	      if (keepBookmarks && dom.select('span[data-mce-type=bookmark]', elm).length > 0) {
	        return false;
	      }
	      return empty;
	    };
	    var isChildOfBody = function (dom, elm) {
	      return dom.isChildOf(elm, dom.getRoot());
	    };
	
	    var shouldIndentOnTab = function (editor) {
	      return editor.getParam('lists_indent_on_tab', true);
	    };
	    var getForcedRootBlock = function (editor) {
	      var block = editor.getParam('forced_root_block', 'p');
	      if (block === false) {
	        return '';
	      } else if (block === true) {
	        return 'p';
	      } else {
	        return block;
	      }
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs', {});
	    };
	
	    var createTextBlock = function (editor, contentNode) {
	      var dom = editor.dom;
	      var blockElements = editor.schema.getBlockElements();
	      var fragment = dom.createFragment();
	      var blockName = getForcedRootBlock(editor);
	      var node, textBlock, hasContentNode;
	      if (blockName) {
	        textBlock = dom.create(blockName);
	        if (textBlock.tagName === blockName.toUpperCase()) {
	          dom.setAttribs(textBlock, getForcedRootBlockAttrs(editor));
	        }
	        if (!isBlock(contentNode.firstChild, blockElements)) {
	          fragment.appendChild(textBlock);
	        }
	      }
	      if (contentNode) {
	        while (node = contentNode.firstChild) {
	          var nodeName = node.nodeName;
	          if (!hasContentNode && (nodeName !== 'SPAN' || node.getAttribute('data-mce-type') !== 'bookmark')) {
	            hasContentNode = true;
	          }
	          if (isBlock(node, blockElements)) {
	            fragment.appendChild(node);
	            textBlock = null;
	          } else {
	            if (blockName) {
	              if (!textBlock) {
	                textBlock = dom.create(blockName);
	                fragment.appendChild(textBlock);
	              }
	              textBlock.appendChild(node);
	            } else {
	              fragment.appendChild(node);
	            }
	          }
	        }
	      }
	      if (!blockName) {
	        fragment.appendChild(dom.create('br'));
	      } else {
	        if (!hasContentNode) {
	          textBlock.appendChild(dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      return fragment;
	    };
	
	    var DOM = global$4.DOM;
	    var splitList = function (editor, ul, li) {
	      var removeAndKeepBookmarks = function (targetNode) {
	        global$5.each(bookmarks, function (node) {
	          targetNode.parentNode.insertBefore(node, li.parentNode);
	        });
	        DOM.remove(targetNode);
	      };
	      var bookmarks = DOM.select('span[data-mce-type="bookmark"]', ul);
	      var newBlock = createTextBlock(editor, li);
	      var tmpRng = DOM.createRng();
	      tmpRng.setStartAfter(li);
	      tmpRng.setEndAfter(ul);
	      var fragment = tmpRng.extractContents();
	      for (var node = fragment.firstChild; node; node = node.firstChild) {
	        if (node.nodeName === 'LI' && editor.dom.isEmpty(node)) {
	          DOM.remove(node);
	          break;
	        }
	      }
	      if (!editor.dom.isEmpty(fragment)) {
	        DOM.insertAfter(fragment, ul);
	      }
	      DOM.insertAfter(newBlock, ul);
	      if (isEmpty$1(editor.dom, li.parentNode)) {
	        removeAndKeepBookmarks(li.parentNode);
	      }
	      DOM.remove(li);
	      if (isEmpty$1(editor.dom, ul)) {
	        DOM.remove(ul);
	      }
	    };
	
	    var outdentDlItem = function (editor, item) {
	      if (is$1(item, 'dd')) {
	        mutate(item, 'dt');
	      } else if (is$1(item, 'dt')) {
	        parent(item).each(function (dl) {
	          return splitList(editor, dl.dom, item.dom);
	        });
	      }
	    };
	    var indentDlItem = function (item) {
	      if (is$1(item, 'dt')) {
	        mutate(item, 'dd');
	      }
	    };
	    var dlIndentation = function (editor, indentation, dlItems) {
	      if (indentation === 'Indent') {
	        each(dlItems, indentDlItem);
	      } else {
	        each(dlItems, function (item) {
	          return outdentDlItem(editor, item);
	        });
	      }
	    };
	
	    var getNormalizedPoint = function (container, offset) {
	      if (isTextNode(container)) {
	        return {
	          container: container,
	          offset: offset
	        };
	      }
	      var node = global$1.getNode(container, offset);
	      if (isTextNode(node)) {
	        return {
	          container: node,
	          offset: offset >= container.childNodes.length ? node.data.length : 0
	        };
	      } else if (node.previousSibling && isTextNode(node.previousSibling)) {
	        return {
	          container: node.previousSibling,
	          offset: node.previousSibling.data.length
	        };
	      } else if (node.nextSibling && isTextNode(node.nextSibling)) {
	        return {
	          container: node.nextSibling,
	          offset: 0
	        };
	      }
	      return {
	        container: container,
	        offset: offset
	      };
	    };
	    var normalizeRange = function (rng) {
	      var outRng = rng.cloneRange();
	      var rangeStart = getNormalizedPoint(rng.startContainer, rng.startOffset);
	      outRng.setStart(rangeStart.container, rangeStart.offset);
	      var rangeEnd = getNormalizedPoint(rng.endContainer, rng.endOffset);
	      outRng.setEnd(rangeEnd.container, rangeEnd.offset);
	      return outRng;
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');
	
	    var getParentList = function (editor, node) {
	      var selectionStart = node || editor.selection.getStart(true);
	      return editor.dom.getParent(selectionStart, 'OL,UL,DL', getClosestListRootElm(editor, selectionStart));
	    };
	    var isParentListSelected = function (parentList, selectedBlocks) {
	      return parentList && selectedBlocks.length === 1 && selectedBlocks[0] === parentList;
	    };
	    var findSubLists = function (parentList) {
	      return global$5.grep(parentList.querySelectorAll('ol,ul,dl'), function (elm) {
	        return isListNode(elm);
	      });
	    };
	    var getSelectedSubLists = function (editor) {
	      var parentList = getParentList(editor);
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      if (isParentListSelected(parentList, selectedBlocks)) {
	        return findSubLists(parentList);
	      } else {
	        return global$5.grep(selectedBlocks, function (elm) {
	          return isListNode(elm) && parentList !== elm;
	        });
	      }
	    };
	    var findParentListItemsNodes = function (editor, elms) {
	      var listItemsElms = global$5.map(elms, function (elm) {
	        var parentLi = editor.dom.getParent(elm, 'li,dd,dt', getClosestListRootElm(editor, elm));
	        return parentLi ? parentLi : elm;
	      });
	      return global$6.unique(listItemsElms);
	    };
	    var getSelectedListItems = function (editor) {
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      return global$5.grep(findParentListItemsNodes(editor, selectedBlocks), function (block) {
	        return isListItemNode(block);
	      });
	    };
	    var getSelectedDlItems = function (editor) {
	      return filter(getSelectedListItems(editor), isDlItemNode);
	    };
	    var getClosestListRootElm = function (editor, elm) {
	      var parentTableCell = editor.dom.getParents(elm, 'TD,TH');
	      var root = parentTableCell.length > 0 ? parentTableCell[0] : editor.getBody();
	      return root;
	    };
	    var findLastParentListNode = function (editor, elm) {
	      var parentLists = editor.dom.getParents(elm, 'ol,ul', getClosestListRootElm(editor, elm));
	      return last(parentLists);
	    };
	    var getSelectedLists = function (editor) {
	      var firstList = findLastParentListNode(editor, editor.selection.getStart());
	      var subsequentLists = filter(editor.selection.getSelectedBlocks(), isOlUlNode);
	      return firstList.toArray().concat(subsequentLists);
	    };
	    var getSelectedListRoots = function (editor) {
	      var selectedLists = getSelectedLists(editor);
	      return getUniqueListRoots(editor, selectedLists);
	    };
	    var getUniqueListRoots = function (editor, lists) {
	      var listRoots = map(lists, function (list) {
	        return findLastParentListNode(editor, list).getOr(list);
	      });
	      return global$6.unique(listRoots);
	    };
	
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || document;
	      var fragment = doc.createDocumentFragment();
	      each(elements, function (element) {
	        fragment.appendChild(element.dom);
	      });
	      return SugarElement.fromDom(fragment);
	    };
	
	    var fireListEvent = function (editor, action, element) {
	      return editor.fire('ListMutation', {
	        action: action,
	        element: element
	      });
	    };
	
	    var isSupported = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var set = function (element, property, value) {
	      var dom = element.dom;
	      internalSet(dom, property, value);
	    };
	
	    var joinSegment = function (parent, child) {
	      append(parent.item, child.list);
	    };
	    var joinSegments = function (segments) {
	      for (var i = 1; i < segments.length; i++) {
	        joinSegment(segments[i - 1], segments[i]);
	      }
	    };
	    var appendSegments = function (head$1, tail) {
	      lift2(last(head$1), head(tail), joinSegment);
	    };
	    var createSegment = function (scope, listType) {
	      var segment = {
	        list: SugarElement.fromTag(listType, scope),
	        item: SugarElement.fromTag('li', scope)
	      };
	      append(segment.list, segment.item);
	      return segment;
	    };
	    var createSegments = function (scope, entry, size) {
	      var segments = [];
	      for (var i = 0; i < size; i++) {
	        segments.push(createSegment(scope, entry.listType));
	      }
	      return segments;
	    };
	    var populateSegments = function (segments, entry) {
	      for (var i = 0; i < segments.length - 1; i++) {
	        set(segments[i].item, 'list-style-type', 'none');
	      }
	      last(segments).each(function (segment) {
	        setAll(segment.list, entry.listAttributes);
	        setAll(segment.item, entry.itemAttributes);
	        append$1(segment.item, entry.content);
	      });
	    };
	    var normalizeSegment = function (segment, entry) {
	      if (name(segment.list) !== entry.listType) {
	        segment.list = mutate(segment.list, entry.listType);
	      }
	      setAll(segment.list, entry.listAttributes);
	    };
	    var createItem = function (scope, attr, content) {
	      var item = SugarElement.fromTag('li', scope);
	      setAll(item, attr);
	      append$1(item, content);
	      return item;
	    };
	    var appendItem = function (segment, item) {
	      append(segment.list, item);
	      segment.item = item;
	    };
	    var writeShallow = function (scope, cast, entry) {
	      var newCast = cast.slice(0, entry.depth);
	      last(newCast).each(function (segment) {
	        var item = createItem(scope, entry.itemAttributes, entry.content);
	        appendItem(segment, item);
	        normalizeSegment(segment, entry);
	      });
	      return newCast;
	    };
	    var writeDeep = function (scope, cast, entry) {
	      var segments = createSegments(scope, entry, entry.depth - cast.length);
	      joinSegments(segments);
	      populateSegments(segments, entry);
	      appendSegments(cast, segments);
	      return cast.concat(segments);
	    };
	    var composeList = function (scope, entries) {
	      var cast = foldl(entries, function (cast, entry) {
	        return entry.depth > cast.length ? writeDeep(scope, cast, entry) : writeShallow(scope, cast, entry);
	      }, []);
	      return head(cast).map(function (segment) {
	        return segment.list;
	      });
	    };
	
	    var isList = function (el) {
	      return is$1(el, 'OL,UL');
	    };
	    var hasFirstChildList = function (el) {
	      return firstChild(el).map(isList).getOr(false);
	    };
	    var hasLastChildList = function (el) {
	      return lastChild(el).map(isList).getOr(false);
	    };
	
	    var isIndented = function (entry) {
	      return entry.depth > 0;
	    };
	    var isSelected = function (entry) {
	      return entry.isSelected;
	    };
	    var cloneItemContent = function (li) {
	      var children$1 = children(li);
	      var content = hasLastChildList(li) ? children$1.slice(0, -1) : children$1;
	      return map(content, deep);
	    };
	    var createEntry = function (li, depth, isSelected) {
	      return parent(li).filter(isElement).map(function (list) {
	        return {
	          depth: depth,
	          dirty: false,
	          isSelected: isSelected,
	          content: cloneItemContent(li),
	          itemAttributes: clone(li),
	          listAttributes: clone(list),
	          listType: name(list)
	        };
	      });
	    };
	
	    var indentEntry = function (indentation, entry) {
	      switch (indentation) {
	      case 'Indent':
	        entry.depth++;
	        break;
	      case 'Outdent':
	        entry.depth--;
	        break;
	      case 'Flatten':
	        entry.depth = 0;
	      }
	      entry.dirty = true;
	    };
	
	    var cloneListProperties = function (target, source) {
	      target.listType = source.listType;
	      target.listAttributes = __assign({}, source.listAttributes);
	    };
	    var cleanListProperties = function (entry) {
	      entry.listAttributes = filter$1(entry.listAttributes, function (_value, key) {
	        return key !== 'start';
	      });
	    };
	    var closestSiblingEntry = function (entries, start) {
	      var depth = entries[start].depth;
	      var matches = function (entry) {
	        return entry.depth === depth && !entry.dirty;
	      };
	      var until = function (entry) {
	        return entry.depth < depth;
	      };
	      return findUntil(reverse(entries.slice(0, start)), matches, until).orThunk(function () {
	        return findUntil(entries.slice(start + 1), matches, until);
	      });
	    };
	    var normalizeEntries = function (entries) {
	      each(entries, function (entry, i) {
	        closestSiblingEntry(entries, i).fold(function () {
	          if (entry.dirty) {
	            cleanListProperties(entry);
	          }
	        }, function (matchingEntry) {
	          return cloneListProperties(entry, matchingEntry);
	        });
	      });
	      return entries;
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var parseItem = function (depth, itemSelection, selectionState, item) {
	      return firstChild(item).filter(isList).fold(function () {
	        itemSelection.each(function (selection) {
	          if (eq(selection.start, item)) {
	            selectionState.set(true);
	          }
	        });
	        var currentItemEntry = createEntry(item, depth, selectionState.get());
	        itemSelection.each(function (selection) {
	          if (eq(selection.end, item)) {
	            selectionState.set(false);
	          }
	        });
	        var childListEntries = lastChild(item).filter(isList).map(function (list) {
	          return parseList(depth, itemSelection, selectionState, list);
	        }).getOr([]);
	        return currentItemEntry.toArray().concat(childListEntries);
	      }, function (list) {
	        return parseList(depth, itemSelection, selectionState, list);
	      });
	    };
	    var parseList = function (depth, itemSelection, selectionState, list) {
	      return bind(children(list), function (element) {
	        var parser = isList(element) ? parseList : parseItem;
	        var newDepth = depth + 1;
	        return parser(newDepth, itemSelection, selectionState, element);
	      });
	    };
	    var parseLists = function (lists, itemSelection) {
	      var selectionState = Cell(false);
	      var initialDepth = 0;
	      return map(lists, function (list) {
	        return {
	          sourceList: list,
	          entries: parseList(initialDepth, itemSelection, selectionState, list)
	        };
	      });
	    };
	
	    var outdentedComposer = function (editor, entries) {
	      var normalizedEntries = normalizeEntries(entries);
	      return map(normalizedEntries, function (entry) {
	        var content = fromElements(entry.content);
	        return SugarElement.fromDom(createTextBlock(editor, content.dom));
	      });
	    };
	    var indentedComposer = function (editor, entries) {
	      var normalizedEntries = normalizeEntries(entries);
	      return composeList(editor.contentDocument, normalizedEntries).toArray();
	    };
	    var composeEntries = function (editor, entries) {
	      return bind(groupBy(entries, isIndented), function (entries) {
	        var groupIsIndented = head(entries).map(isIndented).getOr(false);
	        return groupIsIndented ? indentedComposer(editor, entries) : outdentedComposer(editor, entries);
	      });
	    };
	    var indentSelectedEntries = function (entries, indentation) {
	      each(filter(entries, isSelected), function (entry) {
	        return indentEntry(indentation, entry);
	      });
	    };
	    var getItemSelection = function (editor) {
	      var selectedListItems = map(getSelectedListItems(editor), SugarElement.fromDom);
	      return lift2(find(selectedListItems, not(hasFirstChildList)), find(reverse(selectedListItems), not(hasFirstChildList)), function (start, end) {
	        return {
	          start: start,
	          end: end
	        };
	      });
	    };
	    var listIndentation = function (editor, lists, indentation) {
	      var entrySets = parseLists(lists, getItemSelection(editor));
	      each(entrySets, function (entrySet) {
	        indentSelectedEntries(entrySet.entries, indentation);
	        var composedLists = composeEntries(editor, entrySet.entries);
	        each(composedLists, function (composedList) {
	          fireListEvent(editor, indentation === 'Indent' ? 'IndentList' : 'OutdentList', composedList.dom);
	        });
	        before$1(entrySet.sourceList, composedLists);
	        remove(entrySet.sourceList);
	      });
	    };
	
	    var selectionIndentation = function (editor, indentation) {
	      var lists = map(getSelectedListRoots(editor), SugarElement.fromDom);
	      var dlItems = map(getSelectedDlItems(editor), SugarElement.fromDom);
	      var isHandled = false;
	      if (lists.length || dlItems.length) {
	        var bookmark = editor.selection.getBookmark();
	        listIndentation(editor, lists, indentation);
	        dlIndentation(editor, indentation, dlItems);
	        editor.selection.moveToBookmark(bookmark);
	        editor.selection.setRng(normalizeRange(editor.selection.getRng()));
	        editor.nodeChanged();
	        isHandled = true;
	      }
	      return isHandled;
	    };
	    var indentListSelection = function (editor) {
	      return selectionIndentation(editor, 'Indent');
	    };
	    var outdentListSelection = function (editor) {
	      return selectionIndentation(editor, 'Outdent');
	    };
	    var flattenListSelection = function (editor) {
	      return selectionIndentation(editor, 'Flatten');
	    };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.dom.BookmarkManager');
	
	    var DOM$1 = global$4.DOM;
	    var createBookmark = function (rng) {
	      var bookmark = {};
	      var setupEndPoint = function (start) {
	        var offsetNode, container, offset;
	        container = rng[start ? 'startContainer' : 'endContainer'];
	        offset = rng[start ? 'startOffset' : 'endOffset'];
	        if (container.nodeType === 1) {
	          offsetNode = DOM$1.create('span', { 'data-mce-type': 'bookmark' });
	          if (container.hasChildNodes()) {
	            offset = Math.min(offset, container.childNodes.length - 1);
	            if (start) {
	              container.insertBefore(offsetNode, container.childNodes[offset]);
	            } else {
	              DOM$1.insertAfter(offsetNode, container.childNodes[offset]);
	            }
	          } else {
	            container.appendChild(offsetNode);
	          }
	          container = offsetNode;
	          offset = 0;
	        }
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      };
	      setupEndPoint(true);
	      if (!rng.collapsed) {
	        setupEndPoint();
	      }
	      return bookmark;
	    };
	    var resolveBookmark = function (bookmark) {
	      var restoreEndPoint = function (start) {
	        var container, offset, node;
	        var nodeIndex = function (container) {
	          var node = container.parentNode.firstChild, idx = 0;
	          while (node) {
	            if (node === container) {
	              return idx;
	            }
	            if (node.nodeType !== 1 || node.getAttribute('data-mce-type') !== 'bookmark') {
	              idx++;
	            }
	            node = node.nextSibling;
	          }
	          return -1;
	        };
	        container = node = bookmark[start ? 'startContainer' : 'endContainer'];
	        offset = bookmark[start ? 'startOffset' : 'endOffset'];
	        if (!container) {
	          return;
	        }
	        if (container.nodeType === 1) {
	          offset = nodeIndex(container);
	          container = container.parentNode;
	          DOM$1.remove(node);
	          if (!container.hasChildNodes() && DOM$1.isBlock(container)) {
	            container.appendChild(DOM$1.create('br'));
	          }
	        }
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      };
	      restoreEndPoint(true);
	      restoreEndPoint();
	      var rng = DOM$1.createRng();
	      rng.setStart(bookmark.startContainer, bookmark.startOffset);
	      if (bookmark.endContainer) {
	        rng.setEnd(bookmark.endContainer, bookmark.endOffset);
	      }
	      return normalizeRange(rng);
	    };
	
	    var listToggleActionFromListName = function (listName) {
	      switch (listName) {
	      case 'UL':
	        return 'ToggleUlList';
	      case 'OL':
	        return 'ToggleOlList';
	      case 'DL':
	        return 'ToggleDLList';
	      }
	    };
	
	    var isCustomList = function (list) {
	      return /\btox\-/.test(list.className);
	    };
	    var listState = function (editor, listName, activate) {
	      var nodeChangeHandler = function (e) {
	        var inList = findUntil(e.parents, isListNode, isTableCellNode).filter(function (list) {
	          return list.nodeName === listName && !isCustomList(list);
	        }).isSome();
	        activate(inList);
	      };
	      var parents = editor.dom.getParents(editor.selection.getNode());
	      nodeChangeHandler({ parents: parents });
	      editor.on('NodeChange', nodeChangeHandler);
	      return function () {
	        return editor.off('NodeChange', nodeChangeHandler);
	      };
	    };
	
	    var updateListStyle = function (dom, el, detail) {
	      var type = detail['list-style-type'] ? detail['list-style-type'] : null;
	      dom.setStyle(el, 'list-style-type', type);
	    };
	    var setAttribs = function (elm, attrs) {
	      global$5.each(attrs, function (value, key) {
	        elm.setAttribute(key, value);
	      });
	    };
	    var updateListAttrs = function (dom, el, detail) {
	      setAttribs(el, detail['list-attributes']);
	      global$5.each(dom.select('li', el), function (li) {
	        setAttribs(li, detail['list-item-attributes']);
	      });
	    };
	    var updateListWithDetails = function (dom, el, detail) {
	      updateListStyle(dom, el, detail);
	      updateListAttrs(dom, el, detail);
	    };
	    var removeStyles = function (dom, element, styles) {
	      global$5.each(styles, function (style) {
	        var _a;
	        return dom.setStyle(element, (_a = {}, _a[style] = '', _a));
	      });
	    };
	    var getEndPointNode = function (editor, rng, start, root) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (container.nodeType === 1) {
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	      }
	      if (!start && isBr(container.nextSibling)) {
	        container = container.nextSibling;
	      }
	      while (container.parentNode !== root) {
	        if (isTextBlock(editor, container)) {
	          return container;
	        }
	        if (/^(TD|TH)$/.test(container.parentNode.nodeName)) {
	          return container;
	        }
	        container = container.parentNode;
	      }
	      return container;
	    };
	    var getSelectedTextBlocks = function (editor, rng, root) {
	      var textBlocks = [], dom = editor.dom;
	      var startNode = getEndPointNode(editor, rng, true, root);
	      var endNode = getEndPointNode(editor, rng, false, root);
	      var block;
	      var siblings = [];
	      for (var node = startNode; node; node = node.nextSibling) {
	        siblings.push(node);
	        if (node === endNode) {
	          break;
	        }
	      }
	      global$5.each(siblings, function (node) {
	        if (isTextBlock(editor, node)) {
	          textBlocks.push(node);
	          block = null;
	          return;
	        }
	        if (dom.isBlock(node) || isBr(node)) {
	          if (isBr(node)) {
	            dom.remove(node);
	          }
	          block = null;
	          return;
	        }
	        var nextSibling = node.nextSibling;
	        if (global$7.isBookmarkNode(node)) {
	          if (isListNode(nextSibling) || isTextBlock(editor, nextSibling) || !nextSibling && node.parentNode === root) {
	            block = null;
	            return;
	          }
	        }
	        if (!block) {
	          block = dom.create('p');
	          node.parentNode.insertBefore(block, node);
	          textBlocks.push(block);
	        }
	        block.appendChild(node);
	      });
	      return textBlocks;
	    };
	    var hasCompatibleStyle = function (dom, sib, detail) {
	      var sibStyle = dom.getStyle(sib, 'list-style-type');
	      var detailStyle = detail ? detail['list-style-type'] : '';
	      detailStyle = detailStyle === null ? '' : detailStyle;
	      return sibStyle === detailStyle;
	    };
	    var applyList = function (editor, listName, detail) {
	      var rng = editor.selection.getRng();
	      var listItemName = 'LI';
	      var root = getClosestListRootElm(editor, editor.selection.getStart(true));
	      var dom = editor.dom;
	      if (dom.getContentEditable(editor.selection.getNode()) === 'false') {
	        return;
	      }
	      listName = listName.toUpperCase();
	      if (listName === 'DL') {
	        listItemName = 'DT';
	      }
	      var bookmark = createBookmark(rng);
	      var selectedTextBlocks = getSelectedTextBlocks(editor, rng, root);
	      global$5.each(selectedTextBlocks, function (block) {
	        var listBlock;
	        var sibling = block.previousSibling;
	        var parent = block.parentNode;
	        if (!isListItemNode(parent)) {
	          if (sibling && isListNode(sibling) && sibling.nodeName === listName && hasCompatibleStyle(dom, sibling, detail)) {
	            listBlock = sibling;
	            block = dom.rename(block, listItemName);
	            sibling.appendChild(block);
	          } else {
	            listBlock = dom.create(listName);
	            block.parentNode.insertBefore(listBlock, block);
	            listBlock.appendChild(block);
	            block = dom.rename(block, listItemName);
	          }
	          removeStyles(dom, block, [
	            'margin',
	            'margin-right',
	            'margin-bottom',
	            'margin-left',
	            'margin-top',
	            'padding',
	            'padding-right',
	            'padding-bottom',
	            'padding-left',
	            'padding-top'
	          ]);
	          updateListWithDetails(dom, listBlock, detail);
	          mergeWithAdjacentLists(editor.dom, listBlock);
	        }
	      });
	      editor.selection.setRng(resolveBookmark(bookmark));
	    };
	    var isValidLists = function (list1, list2) {
	      return list1 && list2 && isListNode(list1) && list1.nodeName === list2.nodeName;
	    };
	    var hasSameListStyle = function (dom, list1, list2) {
	      var targetStyle = dom.getStyle(list1, 'list-style-type', true);
	      var style = dom.getStyle(list2, 'list-style-type', true);
	      return targetStyle === style;
	    };
	    var hasSameClasses = function (elm1, elm2) {
	      return elm1.className === elm2.className;
	    };
	    var shouldMerge = function (dom, list1, list2) {
	      return isValidLists(list1, list2) && hasSameListStyle(dom, list1, list2) && hasSameClasses(list1, list2);
	    };
	    var mergeWithAdjacentLists = function (dom, listBlock) {
	      var sibling, node;
	      sibling = listBlock.nextSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while (node = sibling.firstChild) {
	          listBlock.appendChild(node);
	        }
	        dom.remove(sibling);
	      }
	      sibling = listBlock.previousSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while (node = sibling.lastChild) {
	          listBlock.insertBefore(node, listBlock.firstChild);
	        }
	        dom.remove(sibling);
	      }
	    };
	    var updateList = function (editor, list, listName, detail) {
	      if (list.nodeName !== listName) {
	        var newList = editor.dom.rename(list, listName);
	        updateListWithDetails(editor.dom, newList, detail);
	        fireListEvent(editor, listToggleActionFromListName(listName), newList);
	      } else {
	        updateListWithDetails(editor.dom, list, detail);
	        fireListEvent(editor, listToggleActionFromListName(listName), list);
	      }
	    };
	    var toggleMultipleLists = function (editor, parentList, lists, listName, detail) {
	      var parentIsList = isListNode(parentList);
	      if (parentIsList && parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	        flattenListSelection(editor);
	      } else {
	        applyList(editor, listName, detail);
	        var bookmark = createBookmark(editor.selection.getRng(true));
	        var allLists = parentIsList ? __spreadArrays([parentList], lists) : lists;
	        global$5.each(allLists, function (elm) {
	          updateList(editor, elm, listName, detail);
	        });
	        editor.selection.setRng(resolveBookmark(bookmark));
	      }
	    };
	    var hasListStyleDetail = function (detail) {
	      return 'list-style-type' in detail;
	    };
	    var toggleSingleList = function (editor, parentList, listName, detail) {
	      if (parentList === editor.getBody()) {
	        return;
	      }
	      if (parentList) {
	        if (parentList.nodeName === listName && !hasListStyleDetail(detail) && !isCustomList(parentList)) {
	          flattenListSelection(editor);
	        } else {
	          var bookmark = createBookmark(editor.selection.getRng(true));
	          updateListWithDetails(editor.dom, parentList, detail);
	          var newList = editor.dom.rename(parentList, listName);
	          mergeWithAdjacentLists(editor.dom, newList);
	          editor.selection.setRng(resolveBookmark(bookmark));
	          applyList(editor, listName, detail);
	          fireListEvent(editor, listToggleActionFromListName(listName), newList);
	        }
	      } else {
	        applyList(editor, listName, detail);
	        fireListEvent(editor, listToggleActionFromListName(listName), parentList);
	      }
	    };
	    var toggleList = function (editor, listName, _detail) {
	      var parentList = getParentList(editor);
	      var selectedSubLists = getSelectedSubLists(editor);
	      var detail = isObject(_detail) ? _detail : {};
	      if (selectedSubLists.length > 0) {
	        toggleMultipleLists(editor, parentList, selectedSubLists, listName, detail);
	      } else {
	        toggleSingleList(editor, parentList, listName, detail);
	      }
	    };
	
	    var DOM$2 = global$4.DOM;
	    var normalizeList = function (dom, ul) {
	      var sibling;
	      var parentNode = ul.parentNode;
	      if (parentNode.nodeName === 'LI' && parentNode.firstChild === ul) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	          if (isEmpty$1(dom, parentNode)) {
	            DOM$2.remove(parentNode);
	          }
	        } else {
	          DOM$2.setStyle(parentNode, 'listStyleType', 'none');
	        }
	      }
	      if (isListNode(parentNode)) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	        }
	      }
	    };
	    var normalizeLists = function (dom, element) {
	      global$5.each(global$5.grep(dom.select('ol,ul', element)), function (ul) {
	        normalizeList(dom, ul);
	      });
	    };
	
	    var findNextCaretContainer = function (editor, rng, isForward, root) {
	      var node = rng.startContainer;
	      var offset = rng.startOffset;
	      if (isTextNode(node) && (isForward ? offset < node.data.length : offset > 0)) {
	        return node;
	      }
	      var nonEmptyBlocks = editor.schema.getNonEmptyElements();
	      if (node.nodeType === 1) {
	        node = global$1.getNode(node, offset);
	      }
	      var walker = new global$2(node, root);
	      if (isForward) {
	        if (isBogusBr(editor.dom, node)) {
	          walker.next();
	        }
	      }
	      while (node = walker[isForward ? 'next' : 'prev2']()) {
	        if (node.nodeName === 'LI' && !node.hasChildNodes()) {
	          return node;
	        }
	        if (nonEmptyBlocks[node.nodeName]) {
	          return node;
	        }
	        if (isTextNode(node) && node.data.length > 0) {
	          return node;
	        }
	      }
	    };
	    var hasOnlyOneBlockChild = function (dom, elm) {
	      var childNodes = elm.childNodes;
	      return childNodes.length === 1 && !isListNode(childNodes[0]) && dom.isBlock(childNodes[0]);
	    };
	    var unwrapSingleBlockChild = function (dom, elm) {
	      if (hasOnlyOneBlockChild(dom, elm)) {
	        dom.remove(elm.firstChild, true);
	      }
	    };
	    var moveChildren = function (dom, fromElm, toElm) {
	      var node;
	      var targetElm = hasOnlyOneBlockChild(dom, toElm) ? toElm.firstChild : toElm;
	      unwrapSingleBlockChild(dom, fromElm);
	      if (!isEmpty$1(dom, fromElm, true)) {
	        while (node = fromElm.firstChild) {
	          targetElm.appendChild(node);
	        }
	      }
	    };
	    var mergeLiElements = function (dom, fromElm, toElm) {
	      var listNode;
	      var ul = fromElm.parentNode;
	      if (!isChildOfBody(dom, fromElm) || !isChildOfBody(dom, toElm)) {
	        return;
	      }
	      if (isListNode(toElm.lastChild)) {
	        listNode = toElm.lastChild;
	      }
	      if (ul === toElm.lastChild) {
	        if (isBr(ul.previousSibling)) {
	          dom.remove(ul.previousSibling);
	        }
	      }
	      var node = toElm.lastChild;
	      if (node && isBr(node) && fromElm.hasChildNodes()) {
	        dom.remove(node);
	      }
	      if (isEmpty$1(dom, toElm, true)) {
	        dom.$(toElm).empty();
	      }
	      moveChildren(dom, fromElm, toElm);
	      if (listNode) {
	        toElm.appendChild(listNode);
	      }
	      var contains = contains$1(SugarElement.fromDom(toElm), SugarElement.fromDom(fromElm));
	      var nestedLists = contains ? dom.getParents(fromElm, isListNode, toElm) : [];
	      dom.remove(fromElm);
	      each(nestedLists, function (list) {
	        if (isEmpty$1(dom, list) && list !== dom.getRoot()) {
	          dom.remove(list);
	        }
	      });
	    };
	    var mergeIntoEmptyLi = function (editor, fromLi, toLi) {
	      editor.dom.$(toLi).empty();
	      mergeLiElements(editor.dom, fromLi, toLi);
	      editor.selection.setCursorLocation(toLi, 0);
	    };
	    var mergeForward = function (editor, rng, fromLi, toLi) {
	      var dom = editor.dom;
	      if (dom.isEmpty(toLi)) {
	        mergeIntoEmptyLi(editor, fromLi, toLi);
	      } else {
	        var bookmark = createBookmark(rng);
	        mergeLiElements(dom, fromLi, toLi);
	        editor.selection.setRng(resolveBookmark(bookmark));
	      }
	    };
	    var mergeBackward = function (editor, rng, fromLi, toLi) {
	      var bookmark = createBookmark(rng);
	      mergeLiElements(editor.dom, fromLi, toLi);
	      var resolvedBookmark = resolveBookmark(bookmark);
	      editor.selection.setRng(resolvedBookmark);
	    };
	    var backspaceDeleteFromListToListCaret = function (editor, isForward) {
	      var dom = editor.dom, selection = editor.selection;
	      var selectionStartElm = selection.getStart();
	      var root = getClosestListRootElm(editor, selectionStartElm);
	      var li = dom.getParent(selection.getStart(), 'LI', root);
	      if (li) {
	        var ul = li.parentNode;
	        if (ul === editor.getBody() && isEmpty$1(dom, ul)) {
	          return true;
	        }
	        var rng_1 = normalizeRange(selection.getRng());
	        var otherLi_1 = dom.getParent(findNextCaretContainer(editor, rng_1, isForward, root), 'LI', root);
	        if (otherLi_1 && otherLi_1 !== li) {
	          editor.undoManager.transact(function () {
	            if (isForward) {
	              mergeForward(editor, rng_1, otherLi_1, li);
	            } else {
	              if (isFirstChild(li)) {
	                outdentListSelection(editor);
	              } else {
	                mergeBackward(editor, rng_1, li, otherLi_1);
	              }
	            }
	          });
	          return true;
	        } else if (!otherLi_1) {
	          if (!isForward && rng_1.startOffset === 0 && rng_1.endOffset === 0) {
	            editor.undoManager.transact(function () {
	              flattenListSelection(editor);
	            });
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var removeBlock = function (dom, block, root) {
	      var parentBlock = dom.getParent(block.parentNode, dom.isBlock, root);
	      dom.remove(block);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        dom.remove(parentBlock);
	      }
	    };
	    var backspaceDeleteIntoListCaret = function (editor, isForward) {
	      var dom = editor.dom;
	      var selectionStartElm = editor.selection.getStart();
	      var root = getClosestListRootElm(editor, selectionStartElm);
	      var block = dom.getParent(selectionStartElm, dom.isBlock, root);
	      if (block && dom.isEmpty(block)) {
	        var rng = normalizeRange(editor.selection.getRng());
	        var otherLi_2 = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	        if (otherLi_2) {
	          editor.undoManager.transact(function () {
	            removeBlock(dom, block, root);
	            mergeWithAdjacentLists(dom, otherLi_2.parentNode);
	            editor.selection.select(otherLi_2, true);
	            editor.selection.collapse(isForward);
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var backspaceDeleteCaret = function (editor, isForward) {
	      return backspaceDeleteFromListToListCaret(editor, isForward) || backspaceDeleteIntoListCaret(editor, isForward);
	    };
	    var backspaceDeleteRange = function (editor) {
	      var selectionStartElm = editor.selection.getStart();
	      var root = getClosestListRootElm(editor, selectionStartElm);
	      var startListParent = editor.dom.getParent(selectionStartElm, 'LI,DT,DD', root);
	      if (startListParent || getSelectedListItems(editor).length > 0) {
	        editor.undoManager.transact(function () {
	          editor.execCommand('Delete');
	          normalizeLists(editor.dom, editor.getBody());
	        });
	        return true;
	      }
	      return false;
	    };
	    var backspaceDelete = function (editor, isForward) {
	      return editor.selection.isCollapsed() ? backspaceDeleteCaret(editor, isForward) : backspaceDeleteRange(editor);
	    };
	    var setup = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode === global$3.BACKSPACE) {
	          if (backspaceDelete(editor, false)) {
	            e.preventDefault();
	          }
	        } else if (e.keyCode === global$3.DELETE) {
	          if (backspaceDelete(editor, true)) {
	            e.preventDefault();
	          }
	        }
	      });
	    };
	
	    var get$1 = function (editor) {
	      return {
	        backspaceDelete: function (isForward) {
	          backspaceDelete(editor, isForward);
	        }
	      };
	    };
	
	    var updateList$1 = function (editor, update) {
	      var parentList = getParentList(editor);
	      editor.undoManager.transact(function () {
	        if (isObject(update.styles)) {
	          editor.dom.setStyles(parentList, update.styles);
	        }
	        if (isObject(update.attrs)) {
	          each$1(update.attrs, function (v, k) {
	            return editor.dom.setAttrib(parentList, k, v);
	          });
	        }
	      });
	    };
	
	    var parseAlphabeticBase26 = function (str) {
	      var chars = reverse(trim(str).split(''));
	      var values = map(chars, function (char, i) {
	        var charValue = char.toUpperCase().charCodeAt(0) - 'A'.charCodeAt(0) + 1;
	        return Math.pow(26, i) * charValue;
	      });
	      return foldl(values, function (sum, v) {
	        return sum + v;
	      }, 0);
	    };
	    var composeAlphabeticBase26 = function (value) {
	      value--;
	      if (value < 0) {
	        return '';
	      } else {
	        var remainder = value % 26;
	        var quotient = Math.floor(value / 26);
	        var rest = composeAlphabeticBase26(quotient);
	        var char = String.fromCharCode('A'.charCodeAt(0) + remainder);
	        return rest + char;
	      }
	    };
	    var isUppercase = function (str) {
	      return /^[A-Z]+$/.test(str);
	    };
	    var isLowercase = function (str) {
	      return /^[a-z]+$/.test(str);
	    };
	    var isNumeric = function (str) {
	      return /^[0-9]+$/.test(str);
	    };
	    var deduceListType = function (start) {
	      if (isNumeric(start)) {
	        return 2;
	      } else if (isUppercase(start)) {
	        return 0;
	      } else if (isLowercase(start)) {
	        return 1;
	      } else if (isEmpty(start)) {
	        return 3;
	      } else {
	        return 4;
	      }
	    };
	    var parseStartValue = function (start) {
	      switch (deduceListType(start)) {
	      case 2:
	        return Optional.some({
	          listStyleType: Optional.none(),
	          start: start
	        });
	      case 0:
	        return Optional.some({
	          listStyleType: Optional.some('upper-alpha'),
	          start: parseAlphabeticBase26(start).toString()
	        });
	      case 1:
	        return Optional.some({
	          listStyleType: Optional.some('lower-alpha'),
	          start: parseAlphabeticBase26(start).toString()
	        });
	      case 3:
	        return Optional.some({
	          listStyleType: Optional.none(),
	          start: ''
	        });
	      case 4:
	        return Optional.none();
	      }
	    };
	    var parseDetail = function (detail) {
	      var start = parseInt(detail.start, 10);
	      if (detail.listStyleType.is('upper-alpha')) {
	        return composeAlphabeticBase26(start);
	      } else if (detail.listStyleType.is('lower-alpha')) {
	        return composeAlphabeticBase26(start).toLowerCase();
	      } else {
	        return detail.start;
	      }
	    };
	
	    var open = function (editor) {
	      var currentList = getParentList(editor);
	      if (!isOlNode(currentList)) {
	        return;
	      }
	      editor.windowManager.open({
	        title: 'List Properties',
	        body: {
	          type: 'panel',
	          items: [{
	              type: 'input',
	              name: 'start',
	              label: 'Start list at number',
	              inputMode: 'numeric'
	            }]
	        },
	        initialData: {
	          start: parseDetail({
	            start: editor.dom.getAttrib(currentList, 'start', '1'),
	            listStyleType: Optional.some(editor.dom.getStyle(currentList, 'list-style-type'))
	          })
	        },
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        onSubmit: function (api) {
	          var data = api.getData();
	          parseStartValue(data.start).each(function (detail) {
	            editor.execCommand('mceListUpdate', false, {
	              attrs: { start: detail.start === '1' ? '' : detail.start },
	              styles: { 'list-style-type': detail.listStyleType.getOr('') }
	            });
	          });
	          api.close();
	        }
	      });
	    };
	
	    var queryListCommandState = function (editor, listName) {
	      return function () {
	        var parentList = getParentList(editor);
	        return parentList && parentList.nodeName === listName;
	      };
	    };
	    var registerDialog = function (editor) {
	      editor.addCommand('mceListProps', function () {
	        open(editor);
	      });
	    };
	    var register = function (editor) {
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command.toLowerCase();
	        if (cmd === 'indent') {
	          indentListSelection(editor);
	        } else if (cmd === 'outdent') {
	          outdentListSelection(editor);
	        }
	      });
	      editor.addCommand('InsertUnorderedList', function (ui, detail) {
	        toggleList(editor, 'UL', detail);
	      });
	      editor.addCommand('InsertOrderedList', function (ui, detail) {
	        toggleList(editor, 'OL', detail);
	      });
	      editor.addCommand('InsertDefinitionList', function (ui, detail) {
	        toggleList(editor, 'DL', detail);
	      });
	      editor.addCommand('RemoveList', function () {
	        flattenListSelection(editor);
	      });
	      registerDialog(editor);
	      editor.addCommand('mceListUpdate', function (ui, detail) {
	        if (isObject(detail)) {
	          updateList$1(editor, detail);
	        }
	      });
	      editor.addQueryStateHandler('InsertUnorderedList', queryListCommandState(editor, 'UL'));
	      editor.addQueryStateHandler('InsertOrderedList', queryListCommandState(editor, 'OL'));
	      editor.addQueryStateHandler('InsertDefinitionList', queryListCommandState(editor, 'DL'));
	    };
	
	    var setupTabKey = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode !== global$3.TAB || global$3.metaKeyPressed(e)) {
	          return;
	        }
	        editor.undoManager.transact(function () {
	          if (e.shiftKey ? outdentListSelection(editor) : indentListSelection(editor)) {
	            e.preventDefault();
	          }
	        });
	      });
	    };
	    var setup$1 = function (editor) {
	      if (shouldIndentOnTab(editor)) {
	        setupTabKey(editor);
	      }
	      setup(editor);
	    };
	
	    var register$1 = function (editor) {
	      var exec = function (command) {
	        return function () {
	          return editor.execCommand(command);
	        };
	      };
	      if (!editor.hasPlugin('advlist')) {
	        editor.ui.registry.addToggleButton('numlist', {
	          icon: 'ordered-list',
	          active: false,
	          tooltip: 'Numbered list',
	          onAction: exec('InsertOrderedList'),
	          onSetup: function (api) {
	            return listState(editor, 'OL', api.setActive);
	          }
	        });
	        editor.ui.registry.addToggleButton('bullist', {
	          icon: 'unordered-list',
	          active: false,
	          tooltip: 'Bullet list',
	          onAction: exec('InsertUnorderedList'),
	          onSetup: function (api) {
	            return listState(editor, 'UL', api.setActive);
	          }
	        });
	      }
	    };
	
	    var register$2 = function (editor) {
	      var listProperties = {
	        text: 'List properties...',
	        icon: 'ordered-list',
	        onAction: function () {
	          return editor.execCommand('mceListProps');
	        },
	        onSetup: function (api) {
	          return listState(editor, 'OL', function (active) {
	            return api.setDisabled(!active);
	          });
	        }
	      };
	      editor.ui.registry.addMenuItem('listprops', listProperties);
	      editor.ui.registry.addContextMenu('lists', {
	        update: function (node) {
	          var parentList = getParentList(editor, node);
	          return isOlNode(parentList) ? ['listprops'] : [];
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('lists', function (editor) {
	        if (editor.hasPlugin('rtc', true) === false) {
	          setup$1(editor);
	          register(editor);
	        } else {
	          registerDialog(editor);
	        }
	        register$1(editor);
	        register$2(editor);
	        return get$1(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "media" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/media')
	//   ES2015:
	//     import 'tinymce/plugins/media'
	__webpack_require__(1224);

/***/ },
/* 1224 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativePush = Array.prototype.push;
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var get = function (obj, key) {
	      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    var getScripts = function (editor) {
	      return editor.getParam('media_scripts');
	    };
	    var getAudioTemplateCallback = function (editor) {
	      return editor.getParam('audio_template_callback');
	    };
	    var getVideoTemplateCallback = function (editor) {
	      return editor.getParam('video_template_callback');
	    };
	    var hasLiveEmbeds = function (editor) {
	      return editor.getParam('media_live_embeds', true);
	    };
	    var shouldFilterHtml = function (editor) {
	      return editor.getParam('media_filter_html', true);
	    };
	    var getUrlResolver = function (editor) {
	      return editor.getParam('media_url_resolver');
	    };
	    var hasAltSource = function (editor) {
	      return editor.getParam('media_alt_source', true);
	    };
	    var hasPoster = function (editor) {
	      return editor.getParam('media_poster', true);
	    };
	    var hasDimensions = function (editor) {
	      return editor.getParam('media_dimensions', true);
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.html.SaxParser');
	
	    var getVideoScriptMatch = function (prefixes, src) {
	      if (prefixes) {
	        for (var i = 0; i < prefixes.length; i++) {
	          if (src.indexOf(prefixes[i].filter) !== -1) {
	            return prefixes[i];
	          }
	        }
	      }
	    };
	
	    var DOM = global$2.DOM;
	    var trimPx = function (value) {
	      return value.replace(/px$/, '');
	    };
	    var getEphoxEmbedData = function (attrs) {
	      var style = attrs.map.style;
	      var styles = style ? DOM.parseStyle(style) : {};
	      return {
	        type: 'ephox-embed-iri',
	        source: attrs.map['data-ephox-embed-iri'],
	        altsource: '',
	        poster: '',
	        width: get(styles, 'max-width').map(trimPx).getOr(''),
	        height: get(styles, 'max-height').map(trimPx).getOr('')
	      };
	    };
	    var htmlToData = function (prefixes, html) {
	      var isEphoxEmbed = Cell(false);
	      var data = {};
	      global$3({
	        validate: false,
	        allow_conditional_comments: true,
	        start: function (name, attrs) {
	          if (isEphoxEmbed.get()) ; else if (has(attrs.map, 'data-ephox-embed-iri')) {
	            isEphoxEmbed.set(true);
	            data = getEphoxEmbedData(attrs);
	          } else {
	            if (!data.source && name === 'param') {
	              data.source = attrs.map.movie;
	            }
	            if (name === 'iframe' || name === 'object' || name === 'embed' || name === 'video' || name === 'audio') {
	              if (!data.type) {
	                data.type = name;
	              }
	              data = global$1.extend(attrs.map, data);
	            }
	            if (name === 'script') {
	              var videoScript = getVideoScriptMatch(prefixes, attrs.map.src);
	              if (!videoScript) {
	                return;
	              }
	              data = {
	                type: 'script',
	                source: attrs.map.src,
	                width: String(videoScript.width),
	                height: String(videoScript.height)
	              };
	            }
	            if (name === 'source') {
	              if (!data.source) {
	                data.source = attrs.map.src;
	              } else if (!data.altsource) {
	                data.altsource = attrs.map.src;
	              }
	            }
	            if (name === 'img' && !data.poster) {
	              data.poster = attrs.map.src;
	            }
	          }
	        }
	      }).parse(html);
	      data.source = data.source || data.src || data.data;
	      data.altsource = data.altsource || '';
	      data.poster = data.poster || '';
	      return data;
	    };
	
	    var guess = function (url) {
	      var mimes = {
	        mp3: 'audio/mpeg',
	        m4a: 'audio/x-m4a',
	        wav: 'audio/wav',
	        mp4: 'video/mp4',
	        webm: 'video/webm',
	        ogg: 'video/ogg',
	        swf: 'application/x-shockwave-flash'
	      };
	      var fileEnd = url.toLowerCase().split('.').pop();
	      var mime = mimes[fileEnd];
	      return mime ? mime : '';
	    };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.html.Schema');
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.html.Writer');
	
	    var DOM$1 = global$2.DOM;
	    var addPx = function (value) {
	      return /^[0-9.]+$/.test(value) ? value + 'px' : value;
	    };
	    var setAttributes = function (attrs, updatedAttrs) {
	      each$1(updatedAttrs, function (val, name) {
	        var value = '' + val;
	        if (attrs.map[name]) {
	          var i = attrs.length;
	          while (i--) {
	            var attr = attrs[i];
	            if (attr.name === name) {
	              if (value) {
	                attrs.map[name] = value;
	                attr.value = value;
	              } else {
	                delete attrs.map[name];
	                attrs.splice(i, 1);
	              }
	            }
	          }
	        } else if (value) {
	          attrs.push({
	            name: name,
	            value: value
	          });
	          attrs.map[name] = value;
	        }
	      });
	    };
	    var updateEphoxEmbed = function (data, attrs) {
	      var style = attrs.map.style;
	      var styleMap = style ? DOM$1.parseStyle(style) : {};
	      styleMap['max-width'] = addPx(data.width);
	      styleMap['max-height'] = addPx(data.height);
	      setAttributes(attrs, { style: DOM$1.serializeStyle(styleMap) });
	    };
	    var sources = [
	      'source',
	      'altsource'
	    ];
	    var updateHtml = function (html, data, updateAll) {
	      var writer = global$5();
	      var isEphoxEmbed = Cell(false);
	      var sourceCount = 0;
	      var hasImage;
	      global$3({
	        validate: false,
	        allow_conditional_comments: true,
	        comment: function (text) {
	          writer.comment(text);
	        },
	        cdata: function (text) {
	          writer.cdata(text);
	        },
	        text: function (text, raw) {
	          writer.text(text, raw);
	        },
	        start: function (name, attrs, empty) {
	          if (isEphoxEmbed.get()) ; else if (has(attrs.map, 'data-ephox-embed-iri')) {
	            isEphoxEmbed.set(true);
	            updateEphoxEmbed(data, attrs);
	          } else {
	            switch (name) {
	            case 'video':
	            case 'object':
	            case 'embed':
	            case 'img':
	            case 'iframe':
	              if (data.height !== undefined && data.width !== undefined) {
	                setAttributes(attrs, {
	                  width: data.width,
	                  height: data.height
	                });
	              }
	              break;
	            }
	            if (updateAll) {
	              switch (name) {
	              case 'video':
	                setAttributes(attrs, {
	                  poster: data.poster,
	                  src: ''
	                });
	                if (data.altsource) {
	                  setAttributes(attrs, { src: '' });
	                }
	                break;
	              case 'iframe':
	                setAttributes(attrs, { src: data.source });
	                break;
	              case 'source':
	                if (sourceCount < 2) {
	                  setAttributes(attrs, {
	                    src: data[sources[sourceCount]],
	                    type: data[sources[sourceCount] + 'mime']
	                  });
	                  if (!data[sources[sourceCount]]) {
	                    return;
	                  }
	                }
	                sourceCount++;
	                break;
	              case 'img':
	                if (!data.poster) {
	                  return;
	                }
	                hasImage = true;
	                break;
	              }
	            }
	          }
	          writer.start(name, attrs, empty);
	        },
	        end: function (name) {
	          if (!isEphoxEmbed.get()) {
	            if (name === 'video' && updateAll) {
	              for (var index = 0; index < 2; index++) {
	                if (data[sources[index]]) {
	                  var attrs = [];
	                  attrs.map = {};
	                  if (sourceCount <= index) {
	                    setAttributes(attrs, {
	                      src: data[sources[index]],
	                      type: data[sources[index] + 'mime']
	                    });
	                    writer.start('source', attrs, true);
	                  }
	                }
	              }
	            }
	            if (data.poster && name === 'object' && updateAll && !hasImage) {
	              var imgAttrs = [];
	              imgAttrs.map = {};
	              setAttributes(imgAttrs, {
	                src: data.poster,
	                width: data.width,
	                height: data.height
	              });
	              writer.start('img', imgAttrs, true);
	            }
	          }
	          writer.end(name);
	        }
	      }, global$4({})).parse(html);
	      return writer.getContent();
	    };
	
	    var urlPatterns = [
	      {
	        regex: /youtu\.be\/([\w\-_\?&=.]+)/i,
	        type: 'iframe',
	        w: 560,
	        h: 314,
	        url: 'www.youtube.com/embed/$1',
	        allowFullscreen: true
	      },
	      {
	        regex: /youtube\.com(.+)v=([^&]+)(&([a-z0-9&=\-_]+))?/i,
	        type: 'iframe',
	        w: 560,
	        h: 314,
	        url: 'www.youtube.com/embed/$2?$4',
	        allowFullscreen: true
	      },
	      {
	        regex: /youtube.com\/embed\/([a-z0-9\?&=\-_]+)/i,
	        type: 'iframe',
	        w: 560,
	        h: 314,
	        url: 'www.youtube.com/embed/$1',
	        allowFullscreen: true
	      },
	      {
	        regex: /vimeo\.com\/([0-9]+)/,
	        type: 'iframe',
	        w: 425,
	        h: 350,
	        url: 'player.vimeo.com/video/$1?title=0&byline=0&portrait=0&color=8dc7dc',
	        allowFullscreen: true
	      },
	      {
	        regex: /vimeo\.com\/(.*)\/([0-9]+)/,
	        type: 'iframe',
	        w: 425,
	        h: 350,
	        url: 'player.vimeo.com/video/$2?title=0&amp;byline=0',
	        allowFullscreen: true
	      },
	      {
	        regex: /maps\.google\.([a-z]{2,3})\/maps\/(.+)msid=(.+)/,
	        type: 'iframe',
	        w: 425,
	        h: 350,
	        url: 'maps.google.com/maps/ms?msid=$2&output=embed"',
	        allowFullscreen: false
	      },
	      {
	        regex: /dailymotion\.com\/video\/([^_]+)/,
	        type: 'iframe',
	        w: 480,
	        h: 270,
	        url: 'www.dailymotion.com/embed/video/$1',
	        allowFullscreen: true
	      },
	      {
	        regex: /dai\.ly\/([^_]+)/,
	        type: 'iframe',
	        w: 480,
	        h: 270,
	        url: 'www.dailymotion.com/embed/video/$1',
	        allowFullscreen: true
	      }
	    ];
	    var getProtocol = function (url) {
	      var protocolMatches = url.match(/^(https?:\/\/|www\.)(.+)$/i);
	      if (protocolMatches && protocolMatches.length > 1) {
	        return protocolMatches[1] === 'www.' ? 'https://' : protocolMatches[1];
	      } else {
	        return 'https://';
	      }
	    };
	    var getUrl = function (pattern, url) {
	      var protocol = getProtocol(url);
	      var match = pattern.regex.exec(url);
	      var newUrl = protocol + pattern.url;
	      var _loop_1 = function (i) {
	        newUrl = newUrl.replace('$' + i, function () {
	          return match[i] ? match[i] : '';
	        });
	      };
	      for (var i = 0; i < match.length; i++) {
	        _loop_1(i);
	      }
	      return newUrl.replace(/\?$/, '');
	    };
	    var matchPattern = function (url) {
	      var patterns = urlPatterns.filter(function (pattern) {
	        return pattern.regex.test(url);
	      });
	      if (patterns.length > 0) {
	        return global$1.extend({}, patterns[0], { url: getUrl(patterns[0], url) });
	      } else {
	        return null;
	      }
	    };
	
	    var getIframeHtml = function (data) {
	      var allowFullscreen = data.allowfullscreen ? ' allowFullscreen="1"' : '';
	      return '<iframe src="' + data.source + '" width="' + data.width + '" height="' + data.height + '"' + allowFullscreen + '></iframe>';
	    };
	    var getFlashHtml = function (data) {
	      var html = '<object data="' + data.source + '" width="' + data.width + '" height="' + data.height + '" type="application/x-shockwave-flash">';
	      if (data.poster) {
	        html += '<img src="' + data.poster + '" width="' + data.width + '" height="' + data.height + '" />';
	      }
	      html += '</object>';
	      return html;
	    };
	    var getAudioHtml = function (data, audioTemplateCallback) {
	      if (audioTemplateCallback) {
	        return audioTemplateCallback(data);
	      } else {
	        return '<audio controls="controls" src="' + data.source + '">' + (data.altsource ? '\n<source src="' + data.altsource + '"' + (data.altsourcemime ? ' type="' + data.altsourcemime + '"' : '') + ' />\n' : '') + '</audio>';
	      }
	    };
	    var getVideoHtml = function (data, videoTemplateCallback) {
	      if (videoTemplateCallback) {
	        return videoTemplateCallback(data);
	      } else {
	        return '<video width="' + data.width + '" height="' + data.height + '"' + (data.poster ? ' poster="' + data.poster + '"' : '') + ' controls="controls">\n' + '<source src="' + data.source + '"' + (data.sourcemime ? ' type="' + data.sourcemime + '"' : '') + ' />\n' + (data.altsource ? '<source src="' + data.altsource + '"' + (data.altsourcemime ? ' type="' + data.altsourcemime + '"' : '') + ' />\n' : '') + '</video>';
	      }
	    };
	    var getScriptHtml = function (data) {
	      return '<script src="' + data.source + '"></script>';
	    };
	    var dataToHtml = function (editor, dataIn) {
	      var data = global$1.extend({}, dataIn);
	      if (!data.source) {
	        global$1.extend(data, htmlToData(getScripts(editor), data.embed));
	        if (!data.source) {
	          return '';
	        }
	      }
	      if (!data.altsource) {
	        data.altsource = '';
	      }
	      if (!data.poster) {
	        data.poster = '';
	      }
	      data.source = editor.convertURL(data.source, 'source');
	      data.altsource = editor.convertURL(data.altsource, 'source');
	      data.sourcemime = guess(data.source);
	      data.altsourcemime = guess(data.altsource);
	      data.poster = editor.convertURL(data.poster, 'poster');
	      var pattern = matchPattern(data.source);
	      if (pattern) {
	        data.source = pattern.url;
	        data.type = pattern.type;
	        data.allowfullscreen = pattern.allowFullscreen;
	        data.width = data.width || String(pattern.w);
	        data.height = data.height || String(pattern.h);
	      }
	      if (data.embed) {
	        return updateHtml(data.embed, data, true);
	      } else {
	        var videoScript = getVideoScriptMatch(getScripts(editor), data.source);
	        if (videoScript) {
	          data.type = 'script';
	          data.width = String(videoScript.width);
	          data.height = String(videoScript.height);
	        }
	        var audioTemplateCallback = getAudioTemplateCallback(editor);
	        var videoTemplateCallback = getVideoTemplateCallback(editor);
	        data.width = data.width || '300';
	        data.height = data.height || '150';
	        global$1.each(data, function (value, key) {
	          data[key] = editor.dom.encode('' + value);
	        });
	        if (data.type === 'iframe') {
	          return getIframeHtml(data);
	        } else if (data.sourcemime === 'application/x-shockwave-flash') {
	          return getFlashHtml(data);
	        } else if (data.sourcemime.indexOf('audio') !== -1) {
	          return getAudioHtml(data, audioTemplateCallback);
	        } else if (data.type === 'script') {
	          return getScriptHtml(data);
	        } else {
	          return getVideoHtml(data, videoTemplateCallback);
	        }
	      }
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var cache = {};
	    var embedPromise = function (data, dataToHtml, handler) {
	      return new global$6(function (res, rej) {
	        var wrappedResolve = function (response) {
	          if (response.html) {
	            cache[data.source] = response;
	          }
	          return res({
	            url: data.source,
	            html: response.html ? response.html : dataToHtml(data)
	          });
	        };
	        if (cache[data.source]) {
	          wrappedResolve(cache[data.source]);
	        } else {
	          handler({ url: data.source }, wrappedResolve, rej);
	        }
	      });
	    };
	    var defaultPromise = function (data, dataToHtml) {
	      return new global$6(function (res) {
	        res({
	          html: dataToHtml(data),
	          url: data.source
	        });
	      });
	    };
	    var loadedData = function (editor) {
	      return function (data) {
	        return dataToHtml(editor, data);
	      };
	    };
	    var getEmbedHtml = function (editor, data) {
	      var embedHandler = getUrlResolver(editor);
	      return embedHandler ? embedPromise(data, loadedData(editor), embedHandler) : defaultPromise(data, loadedData(editor));
	    };
	    var isCached = function (url) {
	      return cache.hasOwnProperty(url);
	    };
	
	    var extractMeta = function (sourceInput, data) {
	      return get(data, sourceInput).bind(function (mainData) {
	        return get(mainData, 'meta');
	      });
	    };
	    var getValue = function (data, metaData, sourceInput) {
	      return function (prop) {
	        var _a;
	        var getFromData = function () {
	          return get(data, prop);
	        };
	        var getFromMetaData = function () {
	          return get(metaData, prop);
	        };
	        var getNonEmptyValue = function (c) {
	          return get(c, 'value').bind(function (v) {
	            return v.length > 0 ? Optional.some(v) : Optional.none();
	          });
	        };
	        var getFromValueFirst = function () {
	          return getFromData().bind(function (child) {
	            return isObject(child) ? getNonEmptyValue(child).orThunk(getFromMetaData) : getFromMetaData().orThunk(function () {
	              return Optional.from(child);
	            });
	          });
	        };
	        var getFromMetaFirst = function () {
	          return getFromMetaData().orThunk(function () {
	            return getFromData().bind(function (child) {
	              return isObject(child) ? getNonEmptyValue(child) : Optional.from(child);
	            });
	          });
	        };
	        return _a = {}, _a[prop] = (prop === sourceInput ? getFromValueFirst() : getFromMetaFirst()).getOr(''), _a;
	      };
	    };
	    var getDimensions = function (data, metaData) {
	      var dimensions = {};
	      get(data, 'dimensions').each(function (dims) {
	        each([
	          'width',
	          'height'
	        ], function (prop) {
	          get(metaData, prop).orThunk(function () {
	            return get(dims, prop);
	          }).each(function (value) {
	            return dimensions[prop] = value;
	          });
	        });
	      });
	      return dimensions;
	    };
	    var unwrap = function (data, sourceInput) {
	      var metaData = sourceInput ? extractMeta(sourceInput, data).getOr({}) : {};
	      var get = getValue(data, metaData, sourceInput);
	      return __assign(__assign(__assign(__assign(__assign({}, get('source')), get('altsource')), get('poster')), get('embed')), getDimensions(data, metaData));
	    };
	    var wrap = function (data) {
	      var wrapped = __assign(__assign({}, data), {
	        source: { value: get(data, 'source').getOr('') },
	        altsource: { value: get(data, 'altsource').getOr('') },
	        poster: { value: get(data, 'poster').getOr('') }
	      });
	      each([
	        'width',
	        'height'
	      ], function (prop) {
	        get(data, prop).each(function (value) {
	          var dimensions = wrapped.dimensions || {};
	          dimensions[prop] = value;
	          wrapped.dimensions = dimensions;
	        });
	      });
	      return wrapped;
	    };
	    var handleError = function (editor) {
	      return function (error) {
	        var errorMessage = error && error.msg ? 'Media embed handler error: ' + error.msg : 'Media embed handler threw unknown error.';
	        editor.notificationManager.open({
	          type: 'error',
	          text: errorMessage
	        });
	      };
	    };
	    var snippetToData = function (editor, embedSnippet) {
	      return htmlToData(getScripts(editor), embedSnippet);
	    };
	    var isMediaElement = function (element) {
	      return element.getAttribute('data-mce-object') || element.getAttribute('data-ephox-embed-iri');
	    };
	    var getEditorData = function (editor) {
	      var element = editor.selection.getNode();
	      var snippet = isMediaElement(element) ? editor.serializer.serialize(element, { selection: true }) : '';
	      return __assign({ embed: snippet }, htmlToData(getScripts(editor), snippet));
	    };
	    var addEmbedHtml = function (api, editor) {
	      return function (response) {
	        if (isString(response.url) && response.url.trim().length > 0) {
	          var html = response.html;
	          var snippetData = snippetToData(editor, html);
	          var nuData = __assign(__assign({}, snippetData), {
	            source: response.url,
	            embed: html
	          });
	          api.setData(wrap(nuData));
	        }
	      };
	    };
	    var selectPlaceholder = function (editor, beforeObjects) {
	      var afterObjects = editor.dom.select('*[data-mce-object]');
	      for (var i = 0; i < beforeObjects.length; i++) {
	        for (var y = afterObjects.length - 1; y >= 0; y--) {
	          if (beforeObjects[i] === afterObjects[y]) {
	            afterObjects.splice(y, 1);
	          }
	        }
	      }
	      editor.selection.select(afterObjects[0]);
	    };
	    var handleInsert = function (editor, html) {
	      var beforeObjects = editor.dom.select('*[data-mce-object]');
	      editor.insertContent(html);
	      selectPlaceholder(editor, beforeObjects);
	      editor.nodeChanged();
	    };
	    var submitForm = function (prevData, newData, editor) {
	      newData.embed = updateHtml(newData.embed, newData);
	      if (newData.embed && (prevData.source === newData.source || isCached(newData.source))) {
	        handleInsert(editor, newData.embed);
	      } else {
	        getEmbedHtml(editor, newData).then(function (response) {
	          handleInsert(editor, response.html);
	        }).catch(handleError(editor));
	      }
	    };
	    var showDialog = function (editor) {
	      var editorData = getEditorData(editor);
	      var currentData = Cell(editorData);
	      var initialData = wrap(editorData);
	      var handleSource = function (prevData, api) {
	        var serviceData = unwrap(api.getData(), 'source');
	        if (prevData.source !== serviceData.source) {
	          addEmbedHtml(win, editor)({
	            url: serviceData.source,
	            html: ''
	          });
	          getEmbedHtml(editor, serviceData).then(addEmbedHtml(win, editor)).catch(handleError(editor));
	        }
	      };
	      var handleEmbed = function (api) {
	        var data = unwrap(api.getData());
	        var dataFromEmbed = snippetToData(editor, data.embed);
	        api.setData(wrap(dataFromEmbed));
	      };
	      var handleUpdate = function (api, sourceInput) {
	        var data = unwrap(api.getData(), sourceInput);
	        var embed = dataToHtml(editor, data);
	        api.setData(wrap(__assign(__assign({}, data), { embed: embed })));
	      };
	      var mediaInput = [{
	          name: 'source',
	          type: 'urlinput',
	          filetype: 'media',
	          label: 'Source'
	        }];
	      var sizeInput = !hasDimensions(editor) ? [] : [{
	          type: 'sizeinput',
	          name: 'dimensions',
	          label: 'Constrain proportions',
	          constrain: true
	        }];
	      var generalTab = {
	        title: 'General',
	        name: 'general',
	        items: flatten([
	          mediaInput,
	          sizeInput
	        ])
	      };
	      var embedTextarea = {
	        type: 'textarea',
	        name: 'embed',
	        label: 'Paste your embed code below:'
	      };
	      var embedTab = {
	        title: 'Embed',
	        items: [embedTextarea]
	      };
	      var advancedFormItems = [];
	      if (hasAltSource(editor)) {
	        advancedFormItems.push({
	          name: 'altsource',
	          type: 'urlinput',
	          filetype: 'media',
	          label: 'Alternative source URL'
	        });
	      }
	      if (hasPoster(editor)) {
	        advancedFormItems.push({
	          name: 'poster',
	          type: 'urlinput',
	          filetype: 'image',
	          label: 'Media poster (Image URL)'
	        });
	      }
	      var advancedTab = {
	        title: 'Advanced',
	        name: 'advanced',
	        items: advancedFormItems
	      };
	      var tabs = [
	        generalTab,
	        embedTab
	      ];
	      if (advancedFormItems.length > 0) {
	        tabs.push(advancedTab);
	      }
	      var body = {
	        type: 'tabpanel',
	        tabs: tabs
	      };
	      var win = editor.windowManager.open({
	        title: 'Insert/Edit Media',
	        size: 'normal',
	        body: body,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        onSubmit: function (api) {
	          var serviceData = unwrap(api.getData());
	          submitForm(currentData.get(), serviceData, editor);
	          api.close();
	        },
	        onChange: function (api, detail) {
	          switch (detail.name) {
	          case 'source':
	            handleSource(currentData.get(), api);
	            break;
	          case 'embed':
	            handleEmbed(api);
	            break;
	          case 'dimensions':
	          case 'altsource':
	          case 'poster':
	            handleUpdate(api, detail.name);
	            break;
	          }
	          currentData.set(unwrap(api.getData()));
	        },
	        initialData: initialData
	      });
	    };
	
	    var get$1 = function (editor) {
	      var showDialog$1 = function () {
	        showDialog(editor);
	      };
	      return { showDialog: showDialog$1 };
	    };
	
	    var register = function (editor) {
	      var showDialog$1 = function () {
	        showDialog(editor);
	      };
	      editor.addCommand('mceMedia', showDialog$1);
	    };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.html.Node');
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.html.DomParser');
	
	    var sanitize = function (editor, html) {
	      if (shouldFilterHtml(editor) === false) {
	        return html;
	      }
	      var writer = global$5();
	      var blocked;
	      global$3({
	        validate: false,
	        allow_conditional_comments: false,
	        comment: function (text) {
	          if (!blocked) {
	            writer.comment(text);
	          }
	        },
	        cdata: function (text) {
	          if (!blocked) {
	            writer.cdata(text);
	          }
	        },
	        text: function (text, raw) {
	          if (!blocked) {
	            writer.text(text, raw);
	          }
	        },
	        start: function (name, attrs, empty) {
	          blocked = true;
	          if (name === 'script' || name === 'noscript' || name === 'svg') {
	            return;
	          }
	          for (var i = attrs.length - 1; i >= 0; i--) {
	            var attrName = attrs[i].name;
	            if (attrName.indexOf('on') === 0) {
	              delete attrs.map[attrName];
	              attrs.splice(i, 1);
	            }
	            if (attrName === 'style') {
	              attrs[i].value = editor.dom.serializeStyle(editor.dom.parseStyle(attrs[i].value), name);
	            }
	          }
	          writer.start(name, attrs, empty);
	          blocked = false;
	        },
	        end: function (name) {
	          if (blocked) {
	            return;
	          }
	          writer.end(name);
	        }
	      }, global$4({})).parse(html);
	      return writer.getContent();
	    };
	
	    var isLiveEmbedNode = function (node) {
	      var name = node.name;
	      return name === 'iframe' || name === 'video' || name === 'audio';
	    };
	    var getDimension = function (node, styles, dimension, defaultValue) {
	      if (defaultValue === void 0) {
	        defaultValue = null;
	      }
	      var value = node.attr(dimension);
	      if (isNonNullable(value)) {
	        return value;
	      } else if (!has(styles, dimension)) {
	        return defaultValue;
	      } else {
	        return null;
	      }
	    };
	    var setDimensions = function (node, previewNode, styles) {
	      var useDefaults = previewNode.name === 'img' || node.name === 'video';
	      var defaultWidth = useDefaults ? '300' : null;
	      var fallbackHeight = node.name === 'audio' ? '30' : '150';
	      var defaultHeight = useDefaults ? fallbackHeight : null;
	      previewNode.attr({
	        width: getDimension(node, styles, 'width', defaultWidth),
	        height: getDimension(node, styles, 'height', defaultHeight)
	      });
	    };
	    var appendNodeContent = function (editor, nodeName, previewNode, html) {
	      var newNode = global$9({
	        forced_root_block: false,
	        validate: false
	      }, editor.schema).parse(html, { context: nodeName });
	      while (newNode.firstChild) {
	        previewNode.append(newNode.firstChild);
	      }
	    };
	    var createPlaceholderNode = function (editor, node) {
	      var name = node.name;
	      var placeHolder = new global$7('img', 1);
	      placeHolder.shortEnded = true;
	      retainAttributesAndInnerHtml(editor, node, placeHolder);
	      setDimensions(node, placeHolder, {});
	      placeHolder.attr({
	        'style': node.attr('style'),
	        'src': global$8.transparentSrc,
	        'data-mce-object': name,
	        'class': 'mce-object mce-object-' + name
	      });
	      return placeHolder;
	    };
	    var createPreviewNode = function (editor, node) {
	      var name = node.name;
	      var previewWrapper = new global$7('span', 1);
	      previewWrapper.attr({
	        'contentEditable': 'false',
	        'style': node.attr('style'),
	        'data-mce-object': name,
	        'class': 'mce-preview-object mce-object-' + name
	      });
	      retainAttributesAndInnerHtml(editor, node, previewWrapper);
	      var styles = editor.dom.parseStyle(node.attr('style'));
	      var previewNode = new global$7(name, 1);
	      setDimensions(node, previewNode, styles);
	      previewNode.attr({
	        src: node.attr('src'),
	        style: node.attr('style'),
	        class: node.attr('class')
	      });
	      if (name === 'iframe') {
	        previewNode.attr({
	          allowfullscreen: node.attr('allowfullscreen'),
	          frameborder: '0'
	        });
	      } else {
	        var attrs = [
	          'controls',
	          'crossorigin',
	          'currentTime',
	          'loop',
	          'muted',
	          'poster',
	          'preload'
	        ];
	        each(attrs, function (attrName) {
	          previewNode.attr(attrName, node.attr(attrName));
	        });
	        var sanitizedHtml = previewWrapper.attr('data-mce-html');
	        if (isNonNullable(sanitizedHtml)) {
	          appendNodeContent(editor, name, previewNode, sanitizedHtml);
	        }
	      }
	      var shimNode = new global$7('span', 1);
	      shimNode.attr('class', 'mce-shim');
	      previewWrapper.append(previewNode);
	      previewWrapper.append(shimNode);
	      return previewWrapper;
	    };
	    var retainAttributesAndInnerHtml = function (editor, sourceNode, targetNode) {
	      var attribs = sourceNode.attributes;
	      var ai = attribs.length;
	      while (ai--) {
	        var attrName = attribs[ai].name;
	        var attrValue = attribs[ai].value;
	        if (attrName !== 'width' && attrName !== 'height' && attrName !== 'style') {
	          if (attrName === 'data' || attrName === 'src') {
	            attrValue = editor.convertURL(attrValue, attrName);
	          }
	          targetNode.attr('data-mce-p-' + attrName, attrValue);
	        }
	      }
	      var innerHtml = sourceNode.firstChild && sourceNode.firstChild.value;
	      if (innerHtml) {
	        targetNode.attr('data-mce-html', escape(sanitize(editor, innerHtml)));
	        targetNode.firstChild = null;
	      }
	    };
	    var isPageEmbedWrapper = function (node) {
	      var nodeClass = node.attr('class');
	      return nodeClass && /\btiny-pageembed\b/.test(nodeClass);
	    };
	    var isWithinEmbedWrapper = function (node) {
	      while (node = node.parent) {
	        if (node.attr('data-ephox-embed-iri') || isPageEmbedWrapper(node)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var placeHolderConverter = function (editor) {
	      return function (nodes) {
	        var i = nodes.length;
	        var node;
	        var videoScript;
	        while (i--) {
	          node = nodes[i];
	          if (!node.parent) {
	            continue;
	          }
	          if (node.parent.attr('data-mce-object')) {
	            continue;
	          }
	          if (node.name === 'script') {
	            videoScript = getVideoScriptMatch(getScripts(editor), node.attr('src'));
	            if (!videoScript) {
	              continue;
	            }
	          }
	          if (videoScript) {
	            if (videoScript.width) {
	              node.attr('width', videoScript.width.toString());
	            }
	            if (videoScript.height) {
	              node.attr('height', videoScript.height.toString());
	            }
	          }
	          if (isLiveEmbedNode(node) && hasLiveEmbeds(editor) && global$8.ceFalse) {
	            if (!isWithinEmbedWrapper(node)) {
	              node.replace(createPreviewNode(editor, node));
	            }
	          } else {
	            if (!isWithinEmbedWrapper(node)) {
	              node.replace(createPlaceholderNode(editor, node));
	            }
	          }
	        }
	      };
	    };
	
	    var setup = function (editor) {
	      editor.on('preInit', function () {
	        var specialElements = editor.schema.getSpecialElements();
	        global$1.each('video audio iframe object'.split(' '), function (name) {
	          specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
	        });
	        var boolAttrs = editor.schema.getBoolAttrs();
	        global$1.each('webkitallowfullscreen mozallowfullscreen allowfullscreen'.split(' '), function (name) {
	          boolAttrs[name] = {};
	        });
	        editor.parser.addNodeFilter('iframe,video,audio,object,embed,script', placeHolderConverter(editor));
	        editor.serializer.addAttributeFilter('data-mce-object', function (nodes, name) {
	          var i = nodes.length;
	          var node;
	          var realElm;
	          var ai;
	          var attribs;
	          var innerHtml;
	          var innerNode;
	          var realElmName;
	          var className;
	          while (i--) {
	            node = nodes[i];
	            if (!node.parent) {
	              continue;
	            }
	            realElmName = node.attr(name);
	            realElm = new global$7(realElmName, 1);
	            if (realElmName !== 'audio' && realElmName !== 'script') {
	              className = node.attr('class');
	              if (className && className.indexOf('mce-preview-object') !== -1) {
	                realElm.attr({
	                  width: node.firstChild.attr('width'),
	                  height: node.firstChild.attr('height')
	                });
	              } else {
	                realElm.attr({
	                  width: node.attr('width'),
	                  height: node.attr('height')
	                });
	              }
	            }
	            realElm.attr({ style: node.attr('style') });
	            attribs = node.attributes;
	            ai = attribs.length;
	            while (ai--) {
	              var attrName = attribs[ai].name;
	              if (attrName.indexOf('data-mce-p-') === 0) {
	                realElm.attr(attrName.substr(11), attribs[ai].value);
	              }
	            }
	            if (realElmName === 'script') {
	              realElm.attr('type', 'text/javascript');
	            }
	            innerHtml = node.attr('data-mce-html');
	            if (innerHtml) {
	              innerNode = new global$7('#text', 3);
	              innerNode.raw = true;
	              innerNode.value = sanitize(editor, unescape(innerHtml));
	              realElm.append(innerNode);
	            }
	            node.replace(realElm);
	          }
	        });
	      });
	      editor.on('SetContent', function () {
	        editor.$('span.mce-preview-object').each(function (index, elm) {
	          var $elm = editor.$(elm);
	          if ($elm.find('span.mce-shim').length === 0) {
	            $elm.append('<span class="mce-shim"></span>');
	          }
	        });
	      });
	    };
	
	    var setup$1 = function (editor) {
	      editor.on('ResolveName', function (e) {
	        var name;
	        if (e.target.nodeType === 1 && (name = e.target.getAttribute('data-mce-object'))) {
	          e.name = name;
	        }
	      });
	    };
	
	    var setup$2 = function (editor) {
	      editor.on('click keyup touchend', function () {
	        var selectedNode = editor.selection.getNode();
	        if (selectedNode && editor.dom.hasClass(selectedNode, 'mce-preview-object')) {
	          if (editor.dom.getAttrib(selectedNode, 'data-mce-selected')) {
	            selectedNode.setAttribute('data-mce-selected', '2');
	          }
	        }
	      });
	      editor.on('ObjectSelected', function (e) {
	        var objectType = e.target.getAttribute('data-mce-object');
	        if (objectType === 'script') {
	          e.preventDefault();
	        }
	      });
	      editor.on('ObjectResized', function (e) {
	        var target = e.target;
	        var html;
	        if (target.getAttribute('data-mce-object')) {
	          html = target.getAttribute('data-mce-html');
	          if (html) {
	            html = unescape(html);
	            target.setAttribute('data-mce-html', escape(updateHtml(html, {
	              width: String(e.width),
	              height: String(e.height)
	            })));
	          }
	        }
	      });
	    };
	
	    var stateSelectorAdapter = function (editor, selector) {
	      return function (buttonApi) {
	        return editor.selection.selectorChangedWithUnbind(selector.join(','), buttonApi.setActive).unbind;
	      };
	    };
	    var register$1 = function (editor) {
	      editor.ui.registry.addToggleButton('media', {
	        tooltip: 'Insert/edit media',
	        icon: 'embed',
	        onAction: function () {
	          editor.execCommand('mceMedia');
	        },
	        onSetup: stateSelectorAdapter(editor, [
	          'img[data-mce-object]',
	          'span[data-mce-object]',
	          'div[data-ephox-embed-iri]'
	        ])
	      });
	      editor.ui.registry.addMenuItem('media', {
	        icon: 'embed',
	        text: 'Media...',
	        onAction: function () {
	          editor.execCommand('mceMedia');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('media', function (editor) {
	        register(editor);
	        register$1(editor);
	        setup$1(editor);
	        setup(editor);
	        setup$2(editor);
	        return get$1(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "nonbreaking" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/nonbreaking')
	//   ES2015:
	//     import 'tinymce/plugins/nonbreaking'
	__webpack_require__(1226);

/***/ },
/* 1226 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var getKeyboardSpaces = function (editor) {
	      var spaces = editor.getParam('nonbreaking_force_tab', 0);
	      if (typeof spaces === 'boolean') {
	        return spaces === true ? 3 : 0;
	      } else {
	        return spaces;
	      }
	    };
	    var wrapNbsps = function (editor) {
	      return editor.getParam('nonbreaking_wrap', true, 'boolean');
	    };
	
	    var stringRepeat = function (string, repeats) {
	      var str = '';
	      for (var index = 0; index < repeats; index++) {
	        str += string;
	      }
	      return str;
	    };
	    var isVisualCharsEnabled = function (editor) {
	      return editor.plugins.visualchars ? editor.plugins.visualchars.isEnabled() : false;
	    };
	    var insertNbsp = function (editor, times) {
	      var classes = function () {
	        return isVisualCharsEnabled(editor) ? 'mce-nbsp-wrap mce-nbsp' : 'mce-nbsp-wrap';
	      };
	      var nbspSpan = function () {
	        return '<span class="' + classes() + '" contenteditable="false">' + stringRepeat('&nbsp;', times) + '</span>';
	      };
	      var shouldWrap = wrapNbsps(editor);
	      var html = shouldWrap || editor.plugins.visualchars ? nbspSpan() : stringRepeat('&nbsp;', times);
	      editor.undoManager.transact(function () {
	        return editor.insertContent(html);
	      });
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceNonBreaking', function () {
	        insertNbsp(editor, 1);
	      });
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var setup = function (editor) {
	      var spaces = getKeyboardSpaces(editor);
	      if (spaces > 0) {
	        editor.on('keydown', function (e) {
	          if (e.keyCode === global$1.TAB && !e.isDefaultPrevented()) {
	            if (e.shiftKey) {
	              return;
	            }
	            e.preventDefault();
	            e.stopImmediatePropagation();
	            insertNbsp(editor, spaces);
	          }
	        });
	      }
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('nonbreaking', {
	        icon: 'non-breaking',
	        tooltip: 'Nonbreaking space',
	        onAction: function () {
	          return editor.execCommand('mceNonBreaking');
	        }
	      });
	      editor.ui.registry.addMenuItem('nonbreaking', {
	        icon: 'non-breaking',
	        text: 'Nonbreaking space',
	        onAction: function () {
	          return editor.execCommand('mceNonBreaking');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('nonbreaking', function (editor) {
	        register(editor);
	        register$1(editor);
	        setup(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "paste" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/paste')
	//   ES2015:
	//     import 'tinymce/plugins/paste'
	__webpack_require__(1228);

/***/ },
/* 1228 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasProPlugin = function (editor) {
	      if (editor.hasPlugin('powerpaste', true)) {
	        if (typeof window.console !== 'undefined' && window.console.log) {
	          window.console.log('PowerPaste is incompatible with Paste plugin! Remove \'paste\' from the \'plugins\' option.');
	        }
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    var get = function (clipboard, quirks) {
	      return {
	        clipboard: clipboard,
	        quirks: quirks
	      };
	    };
	
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	
	    var value = function () {
	      var subject = Cell(Optional.none());
	      var clear = function () {
	        return subject.set(Optional.none());
	      };
	      var set = function (s) {
	        return subject.set(Optional.some(s));
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var repeat = function (s, count) {
	      return count <= 0 ? '' : new Array(count + 1).join(s);
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var firePastePreProcess = function (editor, html, internal, isWordHtml) {
	      return editor.fire('PastePreProcess', {
	        content: html,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePostProcess = function (editor, node, internal, isWordHtml) {
	      return editor.fire('PastePostProcess', {
	        node: node,
	        internal: internal,
	        wordContent: isWordHtml
	      });
	    };
	    var firePastePlainTextToggle = function (editor, state) {
	      return editor.fire('PastePlainTextToggle', { state: state });
	    };
	    var firePaste = function (editor, ieFake) {
	      return editor.fire('paste', { ieFake: ieFake });
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var shouldBlockDrop = function (editor) {
	      return editor.getParam('paste_block_drop', false);
	    };
	    var shouldPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false);
	    };
	    var shouldFilterDrop = function (editor) {
	      return editor.getParam('paste_filter_drop', true);
	    };
	    var getPreProcess = function (editor) {
	      return editor.getParam('paste_preprocess');
	    };
	    var getPostProcess = function (editor) {
	      return editor.getParam('paste_postprocess');
	    };
	    var getWebkitStyles = function (editor) {
	      return editor.getParam('paste_webkit_styles');
	    };
	    var shouldRemoveWebKitStyles = function (editor) {
	      return editor.getParam('paste_remove_styles_if_webkit', true);
	    };
	    var shouldMergeFormats = function (editor) {
	      return editor.getParam('paste_merge_formats', true);
	    };
	    var isSmartPasteEnabled = function (editor) {
	      return editor.getParam('smart_paste', true);
	    };
	    var isPasteAsTextEnabled = function (editor) {
	      return editor.getParam('paste_as_text', false);
	    };
	    var getRetainStyleProps = function (editor) {
	      return editor.getParam('paste_retain_style_properties');
	    };
	    var getWordValidElements = function (editor) {
	      var defaultValidElements = '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' + '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' + 'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody';
	      return editor.getParam('paste_word_valid_elements', defaultValidElements);
	    };
	    var shouldConvertWordFakeLists = function (editor) {
	      return editor.getParam('paste_convert_word_fake_lists', true);
	    };
	    var shouldUseDefaultFilters = function (editor) {
	      return editor.getParam('paste_enable_default_filters', true);
	    };
	    var getValidate = function (editor) {
	      return editor.getParam('validate');
	    };
	    var getAllowHtmlDataUrls = function (editor) {
	      return editor.getParam('allow_html_data_urls', false, 'boolean');
	    };
	    var getPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false, 'boolean');
	    };
	    var getImagesDataImgFilter = function (editor) {
	      return editor.getParam('images_dataimg_filter');
	    };
	    var getImagesReuseFilename = function (editor) {
	      return editor.getParam('images_reuse_filename');
	    };
	    var getForcedRootBlock = function (editor) {
	      return editor.getParam('forced_root_block');
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs');
	    };
	    var getTabSpaces = function (editor) {
	      return editor.getParam('paste_tab_spaces', 4, 'number');
	    };
	    var getAllowedImageFileTypes = function (editor) {
	      var defaultImageFileTypes = 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp';
	      return global$5.explode(editor.getParam('images_file_types', defaultImageFileTypes, 'string'));
	    };
	
	    var internalMimeType = 'x-tinymce/html';
	    var internalMark = '<!-- ' + internalMimeType + ' -->';
	    var mark = function (html) {
	      return internalMark + html;
	    };
	    var unmark = function (html) {
	      return html.replace(internalMark, '');
	    };
	    var isMarked = function (html) {
	      return html.indexOf(internalMark) !== -1;
	    };
	    var internalHtmlMime = function () {
	      return internalMimeType;
	    };
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.html.Entities');
	
	    var isPlainText = function (text) {
	      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
	    };
	    var toBRs = function (text) {
	      return text.replace(/\r?\n/g, '<br>');
	    };
	    var openContainer = function (rootTag, rootAttrs) {
	      var key;
	      var attrs = [];
	      var tag = '<' + rootTag;
	      if (typeof rootAttrs === 'object') {
	        for (key in rootAttrs) {
	          if (rootAttrs.hasOwnProperty(key)) {
	            attrs.push(key + '="' + global$6.encodeAllRaw(rootAttrs[key]) + '"');
	          }
	        }
	        if (attrs.length) {
	          tag += ' ' + attrs.join(' ');
	        }
	      }
	      return tag + '>';
	    };
	    var toBlockElements = function (text, rootTag, rootAttrs) {
	      var blocks = text.split(/\n\n/);
	      var tagOpen = openContainer(rootTag, rootAttrs);
	      var tagClose = '</' + rootTag + '>';
	      var paragraphs = global$5.map(blocks, function (p) {
	        return p.split(/\n/).join('<br />');
	      });
	      var stitch = function (p) {
	        return tagOpen + p + tagClose;
	      };
	      return paragraphs.length === 1 ? paragraphs[0] : global$5.map(paragraphs, stitch).join('');
	    };
	    var convert = function (text, rootTag, rootAttrs) {
	      return rootTag ? toBlockElements(text, rootTag === true ? 'p' : rootTag, rootAttrs) : toBRs(text);
	    };
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.html.DomParser');
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.html.Serializer');
	
	    var nbsp = '\xA0';
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.html.Node');
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.html.Schema');
	
	    var filter$1 = function (content, items) {
	      global$5.each(items, function (v) {
	        if (v.constructor === RegExp) {
	          content = content.replace(v, '');
	        } else {
	          content = content.replace(v[0], v[1]);
	        }
	      });
	      return content;
	    };
	    var innerText = function (html) {
	      var schema = global$a();
	      var domParser = global$7({}, schema);
	      var text = '';
	      var shortEndedElements = schema.getShortEndedElements();
	      var ignoreElements = global$5.makeMap('script noscript style textarea video audio iframe object', ' ');
	      var blockElements = schema.getBlockElements();
	      var walk = function (node) {
	        var name = node.name, currentNode = node;
	        if (name === 'br') {
	          text += '\n';
	          return;
	        }
	        if (name === 'wbr') {
	          return;
	        }
	        if (shortEndedElements[name]) {
	          text += ' ';
	        }
	        if (ignoreElements[name]) {
	          text += ' ';
	          return;
	        }
	        if (node.type === 3) {
	          text += node.value;
	        }
	        if (!node.shortEnded) {
	          if (node = node.firstChild) {
	            do {
	              walk(node);
	            } while (node = node.next);
	          }
	        }
	        if (blockElements[name] && currentNode.next) {
	          text += '\n';
	          if (name === 'p') {
	            text += '\n';
	          }
	        }
	      };
	      html = filter$1(html, [/<!\[[^\]]+\]>/g]);
	      walk(domParser.parse(html));
	      return text;
	    };
	    var trimHtml = function (html) {
	      var trimSpaces = function (all, s1, s2) {
	        if (!s1 && !s2) {
	          return ' ';
	        }
	        return nbsp;
	      };
	      html = filter$1(html, [
	        /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig,
	        /<!--StartFragment-->|<!--EndFragment-->/g,
	        [
	          /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
	          trimSpaces
	        ],
	        /<br class="Apple-interchange-newline">/g,
	        /<br>$/i
	      ]);
	      return html;
	    };
	    var createIdGenerator = function (prefix) {
	      var count = 0;
	      return function () {
	        return prefix + count++;
	      };
	    };
	    var getImageMimeType = function (ext) {
	      var lowerExt = ext.toLowerCase();
	      var mimeOverrides = {
	        jpg: 'jpeg',
	        jpe: 'jpeg',
	        jfi: 'jpeg',
	        jif: 'jpeg',
	        jfif: 'jpeg',
	        pjpeg: 'jpeg',
	        pjp: 'jpeg',
	        svg: 'svg+xml'
	      };
	      return global$5.hasOwn(mimeOverrides, lowerExt) ? 'image/' + mimeOverrides[lowerExt] : 'image/' + lowerExt;
	    };
	
	    var isWordContent = function (content) {
	      return /<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument/i.test(content) || /class="OutlineElement/.test(content) || /id="?docs\-internal\-guid\-/.test(content);
	    };
	    var isNumericList = function (text) {
	      var found;
	      var patterns = [
	        /^[IVXLMCD]+\.[ \u00a0]/,
	        /^[ivxlmcd]+\.[ \u00a0]/,
	        /^[a-z]{1,2}[\.\)][ \u00a0]/,
	        /^[A-Z]{1,2}[\.\)][ \u00a0]/,
	        /^[0-9]+\.[ \u00a0]/,
	        /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/,
	        /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/
	      ];
	      text = text.replace(/^[\u00a0 ]+/, '');
	      global$5.each(patterns, function (pattern) {
	        if (pattern.test(text)) {
	          found = true;
	          return false;
	        }
	      });
	      return found;
	    };
	    var isBulletList = function (text) {
	      return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
	    };
	    var convertFakeListsToProperLists = function (node) {
	      var currentListNode, prevListNode, lastLevel = 1;
	      var getText = function (node) {
	        var txt = '';
	        if (node.type === 3) {
	          return node.value;
	        }
	        if (node = node.firstChild) {
	          do {
	            txt += getText(node);
	          } while (node = node.next);
	        }
	        return txt;
	      };
	      var trimListStart = function (node, regExp) {
	        if (node.type === 3) {
	          if (regExp.test(node.value)) {
	            node.value = node.value.replace(regExp, '');
	            return false;
	          }
	        }
	        if (node = node.firstChild) {
	          do {
	            if (!trimListStart(node, regExp)) {
	              return false;
	            }
	          } while (node = node.next);
	        }
	        return true;
	      };
	      var removeIgnoredNodes = function (node) {
	        if (node._listIgnore) {
	          node.remove();
	          return;
	        }
	        if (node = node.firstChild) {
	          do {
	            removeIgnoredNodes(node);
	          } while (node = node.next);
	        }
	      };
	      var convertParagraphToLi = function (paragraphNode, listName, start) {
	        var level = paragraphNode._listLevel || lastLevel;
	        if (level !== lastLevel) {
	          if (level < lastLevel) {
	            if (currentListNode) {
	              currentListNode = currentListNode.parent.parent;
	            }
	          } else {
	            prevListNode = currentListNode;
	            currentListNode = null;
	          }
	        }
	        if (!currentListNode || currentListNode.name !== listName) {
	          prevListNode = prevListNode || currentListNode;
	          currentListNode = new global$9(listName, 1);
	          if (start > 1) {
	            currentListNode.attr('start', '' + start);
	          }
	          paragraphNode.wrap(currentListNode);
	        } else {
	          currentListNode.append(paragraphNode);
	        }
	        paragraphNode.name = 'li';
	        if (level > lastLevel && prevListNode) {
	          prevListNode.lastChild.append(currentListNode);
	        }
	        lastLevel = level;
	        removeIgnoredNodes(paragraphNode);
	        trimListStart(paragraphNode, /^\u00a0+/);
	        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
	        trimListStart(paragraphNode, /^\u00a0+/);
	      };
	      var elements = [];
	      var child = node.firstChild;
	      while (typeof child !== 'undefined' && child !== null) {
	        elements.push(child);
	        child = child.walk();
	        if (child !== null) {
	          while (typeof child !== 'undefined' && child.parent !== node) {
	            child = child.walk();
	          }
	        }
	      }
	      for (var i = 0; i < elements.length; i++) {
	        node = elements[i];
	        if (node.name === 'p' && node.firstChild) {
	          var nodeText = getText(node);
	          if (isBulletList(nodeText)) {
	            convertParagraphToLi(node, 'ul');
	            continue;
	          }
	          if (isNumericList(nodeText)) {
	            var matches = /([0-9]+)\./.exec(nodeText);
	            var start = 1;
	            if (matches) {
	              start = parseInt(matches[1], 10);
	            }
	            convertParagraphToLi(node, 'ol', start);
	            continue;
	          }
	          if (node._listLevel) {
	            convertParagraphToLi(node, 'ul', 1);
	            continue;
	          }
	          currentListNode = null;
	        } else {
	          prevListNode = currentListNode;
	          currentListNode = null;
	        }
	      }
	    };
	    var filterStyles = function (editor, validStyles, node, styleValue) {
	      var outputStyles = {}, matches;
	      var styles = editor.dom.parseStyle(styleValue);
	      global$5.each(styles, function (value, name) {
	        switch (name) {
	        case 'mso-list':
	          matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
	          if (matches) {
	            node._listLevel = parseInt(matches[1], 10);
	          }
	          if (/Ignore/i.test(value) && node.firstChild) {
	            node._listIgnore = true;
	            node.firstChild._listIgnore = true;
	          }
	          break;
	        case 'horiz-align':
	          name = 'text-align';
	          break;
	        case 'vert-align':
	          name = 'vertical-align';
	          break;
	        case 'font-color':
	        case 'mso-foreground':
	          name = 'color';
	          break;
	        case 'mso-background':
	        case 'mso-highlight':
	          name = 'background';
	          break;
	        case 'font-weight':
	        case 'font-style':
	          if (value !== 'normal') {
	            outputStyles[name] = value;
	          }
	          return;
	        case 'mso-element':
	          if (/^(comment|comment-list)$/i.test(value)) {
	            node.remove();
	            return;
	          }
	          break;
	        }
	        if (name.indexOf('mso-comment') === 0) {
	          node.remove();
	          return;
	        }
	        if (name.indexOf('mso-') === 0) {
	          return;
	        }
	        if (getRetainStyleProps(editor) === 'all' || validStyles && validStyles[name]) {
	          outputStyles[name] = value;
	        }
	      });
	      if (/(bold)/i.test(outputStyles['font-weight'])) {
	        delete outputStyles['font-weight'];
	        node.wrap(new global$9('b', 1));
	      }
	      if (/(italic)/i.test(outputStyles['font-style'])) {
	        delete outputStyles['font-style'];
	        node.wrap(new global$9('i', 1));
	      }
	      outputStyles = editor.dom.serializeStyle(outputStyles, node.name);
	      if (outputStyles) {
	        return outputStyles;
	      }
	      return null;
	    };
	    var filterWordContent = function (editor, content) {
	      var validStyles;
	      var retainStyleProperties = getRetainStyleProps(editor);
	      if (retainStyleProperties) {
	        validStyles = global$5.makeMap(retainStyleProperties.split(/[, ]/));
	      }
	      content = filter$1(content, [
	        /<br class="?Apple-interchange-newline"?>/gi,
	        /<b[^>]+id="?docs-internal-[^>]*>/gi,
	        /<!--[\s\S]+?-->/gi,
	        /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
	        [
	          /<(\/?)s>/gi,
	          '<$1strike>'
	        ],
	        [
	          /&nbsp;/gi,
	          nbsp
	        ],
	        [
	          /<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
	          function (str, spaces) {
	            return spaces.length > 0 ? spaces.replace(/./, ' ').slice(Math.floor(spaces.length / 2)).split('').join(nbsp) : '';
	          }
	        ]
	      ]);
	      var validElements = getWordValidElements(editor);
	      var schema = global$a({
	        valid_elements: validElements,
	        valid_children: '-li[p]'
	      });
	      global$5.each(schema.elements, function (rule) {
	        if (!rule.attributes.class) {
	          rule.attributes.class = {};
	          rule.attributesOrder.push('class');
	        }
	        if (!rule.attributes.style) {
	          rule.attributes.style = {};
	          rule.attributesOrder.push('style');
	        }
	      });
	      var domParser = global$7({}, schema);
	      domParser.addAttributeFilter('style', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
	          if (node.name === 'span' && node.parent && !node.attributes.length) {
	            node.unwrap();
	          }
	        }
	      });
	      domParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, className;
	        while (i--) {
	          node = nodes[i];
	          className = node.attr('class');
	          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
	            node.remove();
	          }
	          node.attr('class', null);
	        }
	      });
	      domParser.addNodeFilter('del', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].remove();
	        }
	      });
	      domParser.addNodeFilter('a', function (nodes) {
	        var i = nodes.length, node, href, name;
	        while (i--) {
	          node = nodes[i];
	          href = node.attr('href');
	          name = node.attr('name');
	          if (href && href.indexOf('#_msocom_') !== -1) {
	            node.remove();
	            continue;
	          }
	          if (href && href.indexOf('file://') === 0) {
	            href = href.split('#')[1];
	            if (href) {
	              href = '#' + href;
	            }
	          }
	          if (!href && !name) {
	            node.unwrap();
	          } else {
	            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
	              node.unwrap();
	              continue;
	            }
	            node.attr({
	              href: href,
	              name: name
	            });
	          }
	        }
	      });
	      var rootNode = domParser.parse(content);
	      if (shouldConvertWordFakeLists(editor)) {
	        convertFakeListsToProperLists(rootNode);
	      }
	      content = global$8({ validate: getValidate(editor) }, schema).serialize(rootNode);
	      return content;
	    };
	    var preProcess = function (editor, content) {
	      return shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
	    };
	
	    var preProcess$1 = function (editor, html) {
	      var parser = global$7({}, editor.schema);
	      parser.addNodeFilter('meta', function (nodes) {
	        global$5.each(nodes, function (node) {
	          node.remove();
	        });
	      });
	      var fragment = parser.parse(html, {
	        forced_root_block: false,
	        isRootContent: true
	      });
	      return global$8({ validate: getValidate(editor) }, editor.schema).serialize(fragment);
	    };
	    var processResult = function (content, cancelled) {
	      return {
	        content: content,
	        cancelled: cancelled
	      };
	    };
	    var postProcessFilter = function (editor, html, internal, isWordHtml) {
	      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
	      var postProcessArgs = firePastePostProcess(editor, tempBody, internal, isWordHtml);
	      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
	    };
	    var filterContent = function (editor, content, internal, isWordHtml) {
	      var preProcessArgs = firePastePreProcess(editor, content, internal, isWordHtml);
	      var filteredContent = preProcess$1(editor, preProcessArgs.content);
	      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
	        return postProcessFilter(editor, filteredContent, internal, isWordHtml);
	      } else {
	        return processResult(filteredContent, preProcessArgs.isDefaultPrevented());
	      }
	    };
	    var process = function (editor, html, internal) {
	      var isWordHtml = isWordContent(html);
	      var content = isWordHtml ? preProcess(editor, html) : html;
	      return filterContent(editor, content, internal, isWordHtml);
	    };
	
	    var pasteHtml = function (editor, html) {
	      editor.insertContent(html, {
	        merge: shouldMergeFormats(editor),
	        paste: true
	      });
	      return true;
	    };
	    var isAbsoluteUrl = function (url) {
	      return /^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url);
	    };
	    var isImageUrl = function (editor, url) {
	      return isAbsoluteUrl(url) && exists(getAllowedImageFileTypes(editor), function (type) {
	        return endsWith(url.toLowerCase(), '.' + type.toLowerCase());
	      });
	    };
	    var createImage = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.insertContent('<img src="' + url + '">');
	      });
	      return true;
	    };
	    var createLink = function (editor, url, pasteHtmlFn) {
	      editor.undoManager.extra(function () {
	        pasteHtmlFn(editor, url);
	      }, function () {
	        editor.execCommand('mceInsertLink', false, url);
	      });
	      return true;
	    };
	    var linkSelection = function (editor, html, pasteHtmlFn) {
	      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtmlFn) : false;
	    };
	    var insertImage = function (editor, html, pasteHtmlFn) {
	      return isImageUrl(editor, html) ? createImage(editor, html, pasteHtmlFn) : false;
	    };
	    var smartInsertContent = function (editor, html) {
	      global$5.each([
	        linkSelection,
	        insertImage,
	        pasteHtml
	      ], function (action) {
	        return action(editor, html, pasteHtml) !== true;
	      });
	    };
	    var insertContent = function (editor, html, pasteAsText) {
	      if (pasteAsText || isSmartPasteEnabled(editor) === false) {
	        pasteHtml(editor, html);
	      } else {
	        smartInsertContent(editor, html);
	      }
	    };
	
	    var isCollapsibleWhitespace = function (c) {
	      return ' \f\t\x0B'.indexOf(c) !== -1;
	    };
	    var isNewLineChar = function (c) {
	      return c === '\n' || c === '\r';
	    };
	    var isNewline = function (text, idx) {
	      return idx < text.length && idx >= 0 ? isNewLineChar(text[idx]) : false;
	    };
	    var normalizeWhitespace = function (editor, text) {
	      var tabSpace = repeat(' ', getTabSpaces(editor));
	      var normalizedText = text.replace(/\t/g, tabSpace);
	      var result = foldl(normalizedText, function (acc, c) {
	        if (isCollapsibleWhitespace(c) || c === nbsp) {
	          if (acc.pcIsSpace || acc.str === '' || acc.str.length === normalizedText.length - 1 || isNewline(normalizedText, acc.str.length + 1)) {
	            return {
	              pcIsSpace: false,
	              str: acc.str + nbsp
	            };
	          } else {
	            return {
	              pcIsSpace: true,
	              str: acc.str + ' '
	            };
	          }
	        } else {
	          return {
	            pcIsSpace: isNewLineChar(c),
	            str: acc.str + c
	          };
	        }
	      }, {
	        pcIsSpace: false,
	        str: ''
	      });
	      return result.str;
	    };
	
	    var doPaste = function (editor, content, internal, pasteAsText) {
	      var args = process(editor, content, internal);
	      if (args.cancelled === false) {
	        insertContent(editor, args.content, pasteAsText);
	      }
	    };
	    var pasteHtml$1 = function (editor, html, internalFlag) {
	      var internal = internalFlag ? internalFlag : isMarked(html);
	      doPaste(editor, unmark(html), internal, false);
	    };
	    var pasteText = function (editor, text) {
	      var encodedText = editor.dom.encode(text).replace(/\r\n/g, '\n');
	      var normalizedText = normalizeWhitespace(editor, encodedText);
	      var html = convert(normalizedText, getForcedRootBlock(editor), getForcedRootBlockAttrs(editor));
	      doPaste(editor, html, false, true);
	    };
	    var getDataTransferItems = function (dataTransfer) {
	      var items = {};
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      if (dataTransfer) {
	        if (dataTransfer.getData) {
	          var legacyText = dataTransfer.getData('Text');
	          if (legacyText && legacyText.length > 0) {
	            if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
	              items['text/plain'] = legacyText;
	            }
	          }
	        }
	        if (dataTransfer.types) {
	          for (var i = 0; i < dataTransfer.types.length; i++) {
	            var contentType = dataTransfer.types[i];
	            try {
	              items[contentType] = dataTransfer.getData(contentType);
	            } catch (ex) {
	              items[contentType] = '';
	            }
	          }
	        }
	      }
	      return items;
	    };
	    var getClipboardContent = function (editor, clipboardEvent) {
	      return getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
	    };
	    var hasContentType = function (clipboardContent, mimeType) {
	      return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
	    };
	    var hasHtmlOrText = function (content) {
	      return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
	    };
	    var parseDataUri = function (uri) {
	      var matches = /data:([^;]+);base64,([a-z0-9\+\/=]+)/i.exec(uri);
	      if (matches) {
	        return {
	          type: matches[1],
	          data: decodeURIComponent(matches[2])
	        };
	      } else {
	        return {
	          type: null,
	          data: null
	        };
	      }
	    };
	    var isValidDataUriImage = function (editor, imgElm) {
	      var filter = getImagesDataImgFilter(editor);
	      return filter ? filter(imgElm) : true;
	    };
	    var extractFilename = function (editor, str) {
	      var m = str.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);
	      return isNonNullable(m) ? editor.dom.encode(m[1]) : null;
	    };
	    var uniqueId = createIdGenerator('mceclip');
	    var pasteImage = function (editor, imageItem) {
	      var _a = parseDataUri(imageItem.uri), base64 = _a.data, type = _a.type;
	      var id = uniqueId();
	      var file = imageItem.blob;
	      var img = new Image();
	      img.src = imageItem.uri;
	      if (isValidDataUriImage(editor, img)) {
	        var blobCache = editor.editorUpload.blobCache;
	        var blobInfo = void 0;
	        var existingBlobInfo = blobCache.getByData(base64, type);
	        if (!existingBlobInfo) {
	          var useFileName = getImagesReuseFilename(editor) && isNonNullable(file.name);
	          var name_1 = useFileName ? extractFilename(editor, file.name) : id;
	          var filename = useFileName ? file.name : undefined;
	          blobInfo = blobCache.create(id, file, base64, name_1, filename);
	          blobCache.add(blobInfo);
	        } else {
	          blobInfo = existingBlobInfo;
	        }
	        pasteHtml$1(editor, '<img src="' + blobInfo.blobUri() + '">', false);
	      } else {
	        pasteHtml$1(editor, '<img src="' + imageItem.uri + '">', false);
	      }
	    };
	    var isClipboardEvent = function (event) {
	      return event.type === 'paste';
	    };
	    var isDataTransferItem = function (item) {
	      return isNonNullable(item.getAsFile);
	    };
	    var readFilesAsDataUris = function (items) {
	      return global$3.all(map(items, function (item) {
	        return new global$3(function (resolve) {
	          var blob = isDataTransferItem(item) ? item.getAsFile() : item;
	          var reader = new window.FileReader();
	          reader.onload = function () {
	            resolve({
	              blob: blob,
	              uri: reader.result
	            });
	          };
	          reader.readAsDataURL(blob);
	        });
	      }));
	    };
	    var isImage = function (editor) {
	      var allowedExtensions = getAllowedImageFileTypes(editor);
	      return function (file) {
	        return startsWith(file.type, 'image/') && exists(allowedExtensions, function (extension) {
	          return getImageMimeType(extension) === file.type;
	        });
	      };
	    };
	    var getImagesFromDataTransfer = function (editor, dataTransfer) {
	      var items = dataTransfer.items ? map(from$1(dataTransfer.items), function (item) {
	        return item.getAsFile();
	      }) : [];
	      var files = dataTransfer.files ? from$1(dataTransfer.files) : [];
	      return filter(items.length > 0 ? items : files, isImage(editor));
	    };
	    var pasteImageData = function (editor, e, rng) {
	      var dataTransfer = isClipboardEvent(e) ? e.clipboardData : e.dataTransfer;
	      if (getPasteDataImages(editor) && dataTransfer) {
	        var images = getImagesFromDataTransfer(editor, dataTransfer);
	        if (images.length > 0) {
	          e.preventDefault();
	          readFilesAsDataUris(images).then(function (fileResults) {
	            if (rng) {
	              editor.selection.setRng(rng);
	            }
	            each(fileResults, function (result) {
	              pasteImage(editor, result);
	            });
	          });
	          return true;
	        }
	      }
	      return false;
	    };
	    var isBrokenAndroidClipboardEvent = function (e) {
	      var clipboardData = e.clipboardData;
	      return navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
	    };
	    var isKeyboardPasteEvent = function (e) {
	      return global$4.metaKeyPressed(e) && e.keyCode === 86 || e.shiftKey && e.keyCode === 45;
	    };
	    var registerEventHandlers = function (editor, pasteBin, pasteFormat) {
	      var keyboardPasteEvent = value();
	      var keyboardPastePressed = value();
	      var keyboardPastePlainTextState;
	      editor.on('keyup', keyboardPastePressed.clear);
	      editor.on('keydown', function (e) {
	        var removePasteBinOnKeyUp = function (e) {
	          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	            pasteBin.remove();
	          }
	        };
	        if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	          keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
	          if (keyboardPastePlainTextState && global$1.webkit && navigator.userAgent.indexOf('Version/') !== -1) {
	            return;
	          }
	          e.stopImmediatePropagation();
	          keyboardPasteEvent.set(e);
	          keyboardPastePressed.set(true);
	          if (global$1.ie && keyboardPastePlainTextState) {
	            e.preventDefault();
	            firePaste(editor, true);
	            return;
	          }
	          pasteBin.remove();
	          pasteBin.create();
	          editor.once('keyup', removePasteBinOnKeyUp);
	          editor.once('paste', function () {
	            editor.off('keyup', removePasteBinOnKeyUp);
	          });
	        }
	      });
	      var insertClipboardContent = function (editor, clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
	        var content;
	        if (hasContentType(clipboardContent, 'text/html')) {
	          content = clipboardContent['text/html'];
	        } else {
	          content = pasteBin.getHtml();
	          internal = internal ? internal : isMarked(content);
	          if (pasteBin.isDefaultContent(content)) {
	            plainTextMode = true;
	          }
	        }
	        content = trimHtml(content);
	        pasteBin.remove();
	        var isPlainTextHtml = internal === false && isPlainText(content);
	        var isImage = isImageUrl(editor, content);
	        if (!content.length || isPlainTextHtml && !isImage) {
	          plainTextMode = true;
	        }
	        if (plainTextMode || isImage) {
	          if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
	            content = clipboardContent['text/plain'];
	          } else {
	            content = innerText(content);
	          }
	        }
	        if (pasteBin.isDefaultContent(content)) {
	          if (!isKeyBoardPaste) {
	            editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
	          }
	          return;
	        }
	        if (plainTextMode) {
	          pasteText(editor, content);
	        } else {
	          pasteHtml$1(editor, content, internal);
	        }
	      };
	      var getLastRng = function () {
	        return pasteBin.getLastRng() || editor.selection.getRng();
	      };
	      editor.on('paste', function (e) {
	        var isKeyboardPaste = keyboardPasteEvent.isSet() || keyboardPastePressed.isSet();
	        if (isKeyboardPaste) {
	          keyboardPasteEvent.clear();
	        }
	        var clipboardContent = getClipboardContent(editor, e);
	        var plainTextMode = pasteFormat.get() === 'text' || keyboardPastePlainTextState;
	        var internal = hasContentType(clipboardContent, internalHtmlMime());
	        keyboardPastePlainTextState = false;
	        if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
	          pasteBin.remove();
	          return;
	        }
	        if (!hasHtmlOrText(clipboardContent) && pasteImageData(editor, e, getLastRng())) {
	          pasteBin.remove();
	          return;
	        }
	        if (!isKeyboardPaste) {
	          e.preventDefault();
	        }
	        if (global$1.ie && (!isKeyboardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
	          pasteBin.create();
	          editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
	            e.stopPropagation();
	          });
	          editor.getDoc().execCommand('Paste', false, null);
	          clipboardContent['text/html'] = pasteBin.getHtml();
	        }
	        if (hasContentType(clipboardContent, 'text/html')) {
	          e.preventDefault();
	          if (!internal) {
	            internal = isMarked(clipboardContent['text/html']);
	          }
	          insertClipboardContent(editor, clipboardContent, isKeyboardPaste, plainTextMode, internal);
	        } else {
	          global$2.setEditorTimeout(editor, function () {
	            insertClipboardContent(editor, clipboardContent, isKeyboardPaste, plainTextMode, internal);
	          }, 0);
	        }
	      });
	    };
	    var registerEventsAndFilters = function (editor, pasteBin, pasteFormat) {
	      registerEventHandlers(editor, pasteBin, pasteFormat);
	      var src;
	      editor.parser.addNodeFilter('img', function (nodes, name, args) {
	        var isPasteInsert = function (args) {
	          return args.data && args.data.paste === true;
	        };
	        var remove = function (node) {
	          if (!node.attr('data-mce-object') && src !== global$1.transparentSrc) {
	            node.remove();
	          }
	        };
	        var isWebKitFakeUrl = function (src) {
	          return src.indexOf('webkit-fake-url') === 0;
	        };
	        var isDataUri = function (src) {
	          return src.indexOf('data:') === 0;
	        };
	        if (!getPasteDataImages(editor) && isPasteInsert(args)) {
	          var i = nodes.length;
	          while (i--) {
	            src = nodes[i].attr('src');
	            if (!src) {
	              continue;
	            }
	            if (isWebKitFakeUrl(src)) {
	              remove(nodes[i]);
	            } else if (!getAllowHtmlDataUrls(editor) && isDataUri(src)) {
	              remove(nodes[i]);
	            }
	          }
	        }
	      });
	    };
	
	    var getPasteBinParent = function (editor) {
	      return global$1.ie && editor.inline ? document.body : editor.getBody();
	    };
	    var isExternalPasteBin = function (editor) {
	      return getPasteBinParent(editor) !== editor.getBody();
	    };
	    var delegatePasteEvents = function (editor, pasteBinElm, pasteBinDefaultContent) {
	      if (isExternalPasteBin(editor)) {
	        editor.dom.bind(pasteBinElm, 'paste keyup', function (_e) {
	          if (!isDefault(editor, pasteBinDefaultContent)) {
	            editor.fire('paste');
	          }
	        });
	      }
	    };
	    var create = function (editor, lastRngCell, pasteBinDefaultContent) {
	      var dom = editor.dom, body = editor.getBody();
	      lastRngCell.set(editor.selection.getRng());
	      var pasteBinElm = editor.dom.add(getPasteBinParent(editor), 'div', {
	        'id': 'mcepastebin',
	        'class': 'mce-pastebin',
	        'contentEditable': true,
	        'data-mce-bogus': 'all',
	        'style': 'position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0'
	      }, pasteBinDefaultContent);
	      if (global$1.ie || global$1.gecko) {
	        dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 65535 : -65535);
	      }
	      dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
	        e.stopPropagation();
	      });
	      delegatePasteEvents(editor, pasteBinElm, pasteBinDefaultContent);
	      pasteBinElm.focus();
	      editor.selection.select(pasteBinElm, true);
	    };
	    var remove = function (editor, lastRngCell) {
	      if (getEl(editor)) {
	        var pasteBinClone = void 0;
	        var lastRng = lastRngCell.get();
	        while (pasteBinClone = editor.dom.get('mcepastebin')) {
	          editor.dom.remove(pasteBinClone);
	          editor.dom.unbind(pasteBinClone);
	        }
	        if (lastRng) {
	          editor.selection.setRng(lastRng);
	        }
	      }
	      lastRngCell.set(null);
	    };
	    var getEl = function (editor) {
	      return editor.dom.get('mcepastebin');
	    };
	    var getHtml = function (editor) {
	      var copyAndRemove = function (toElm, fromElm) {
	        toElm.appendChild(fromElm);
	        editor.dom.remove(fromElm, true);
	      };
	      var pasteBinClones = global$5.grep(getPasteBinParent(editor).childNodes, function (elm) {
	        return elm.id === 'mcepastebin';
	      });
	      var pasteBinElm = pasteBinClones.shift();
	      global$5.each(pasteBinClones, function (pasteBinClone) {
	        copyAndRemove(pasteBinElm, pasteBinClone);
	      });
	      var dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
	      for (var i = dirtyWrappers.length - 1; i >= 0; i--) {
	        var cleanWrapper = editor.dom.create('div');
	        pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
	        copyAndRemove(cleanWrapper, dirtyWrappers[i]);
	      }
	      return pasteBinElm ? pasteBinElm.innerHTML : '';
	    };
	    var getLastRng = function (lastRng) {
	      return lastRng.get();
	    };
	    var isDefaultContent = function (pasteBinDefaultContent, content) {
	      return content === pasteBinDefaultContent;
	    };
	    var isPasteBin = function (elm) {
	      return elm && elm.id === 'mcepastebin';
	    };
	    var isDefault = function (editor, pasteBinDefaultContent) {
	      var pasteBinElm = getEl(editor);
	      return isPasteBin(pasteBinElm) && isDefaultContent(pasteBinDefaultContent, pasteBinElm.innerHTML);
	    };
	    var PasteBin = function (editor) {
	      var lastRng = Cell(null);
	      var pasteBinDefaultContent = '%MCEPASTEBIN%';
	      return {
	        create: function () {
	          return create(editor, lastRng, pasteBinDefaultContent);
	        },
	        remove: function () {
	          return remove(editor, lastRng);
	        },
	        getEl: function () {
	          return getEl(editor);
	        },
	        getHtml: function () {
	          return getHtml(editor);
	        },
	        getLastRng: function () {
	          return getLastRng(lastRng);
	        },
	        isDefault: function () {
	          return isDefault(editor, pasteBinDefaultContent);
	        },
	        isDefaultContent: function (content) {
	          return isDefaultContent(pasteBinDefaultContent, content);
	        }
	      };
	    };
	
	    var Clipboard = function (editor, pasteFormat) {
	      var pasteBin = PasteBin(editor);
	      editor.on('PreInit', function () {
	        return registerEventsAndFilters(editor, pasteBin, pasteFormat);
	      });
	      return {
	        pasteFormat: pasteFormat,
	        pasteHtml: function (html, internalFlag) {
	          return pasteHtml$1(editor, html, internalFlag);
	        },
	        pasteText: function (text) {
	          return pasteText(editor, text);
	        },
	        pasteImageData: function (e, rng) {
	          return pasteImageData(editor, e, rng);
	        },
	        getDataTransferItems: getDataTransferItems,
	        hasHtmlOrText: hasHtmlOrText,
	        hasContentType: hasContentType
	      };
	    };
	
	    var togglePlainTextPaste = function (editor, clipboard) {
	      if (clipboard.pasteFormat.get() === 'text') {
	        clipboard.pasteFormat.set('html');
	        firePastePlainTextToggle(editor, false);
	      } else {
	        clipboard.pasteFormat.set('text');
	        firePastePlainTextToggle(editor, true);
	      }
	      editor.focus();
	    };
	
	    var register = function (editor, clipboard) {
	      editor.addCommand('mceTogglePlainTextPaste', function () {
	        togglePlainTextPaste(editor, clipboard);
	      });
	      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
	        if (value.content) {
	          clipboard.pasteHtml(value.content, value.internal);
	        }
	        if (value.text) {
	          clipboard.pasteText(value.text);
	        }
	      });
	    };
	
	    var hasWorkingClipboardApi = function (clipboardData) {
	      return global$1.iOS === false && typeof (clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.setData) === 'function';
	    };
	    var setHtml5Clipboard = function (clipboardData, html, text) {
	      if (hasWorkingClipboardApi(clipboardData)) {
	        try {
	          clipboardData.clearData();
	          clipboardData.setData('text/html', html);
	          clipboardData.setData('text/plain', text);
	          clipboardData.setData(internalHtmlMime(), html);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    };
	    var setClipboardData = function (evt, data, fallback, done) {
	      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
	        evt.preventDefault();
	        done();
	      } else {
	        fallback(data.html, done);
	      }
	    };
	    var fallback = function (editor) {
	      return function (html, done) {
	        var markedHtml = mark(html);
	        var outer = editor.dom.create('div', {
	          'contenteditable': 'false',
	          'data-mce-bogus': 'all'
	        });
	        var inner = editor.dom.create('div', { contenteditable: 'true' }, markedHtml);
	        editor.dom.setStyles(outer, {
	          position: 'fixed',
	          top: '0',
	          left: '-3000px',
	          width: '1000px',
	          overflow: 'hidden'
	        });
	        outer.appendChild(inner);
	        editor.dom.add(editor.getBody(), outer);
	        var range = editor.selection.getRng();
	        inner.focus();
	        var offscreenRange = editor.dom.createRng();
	        offscreenRange.selectNodeContents(inner);
	        editor.selection.setRng(offscreenRange);
	        global$2.setTimeout(function () {
	          editor.selection.setRng(range);
	          outer.parentNode.removeChild(outer);
	          done();
	        }, 0);
	      };
	    };
	    var getData = function (editor) {
	      return {
	        html: editor.selection.getContent({ contextual: true }),
	        text: editor.selection.getContent({ format: 'text' })
	      };
	    };
	    var isTableSelection = function (editor) {
	      return !!editor.dom.getParent(editor.selection.getStart(), 'td[data-mce-selected],th[data-mce-selected]', editor.getBody());
	    };
	    var hasSelectedContent = function (editor) {
	      return !editor.selection.isCollapsed() || isTableSelection(editor);
	    };
	    var cut = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), function () {
	            if (global$1.browser.isChrome() || global$1.browser.isFirefox()) {
	              var rng_1 = editor.selection.getRng();
	              global$2.setEditorTimeout(editor, function () {
	                editor.selection.setRng(rng_1);
	                editor.execCommand('Delete');
	              }, 0);
	            } else {
	              editor.execCommand('Delete');
	            }
	          });
	        }
	      };
	    };
	    var copy = function (editor) {
	      return function (evt) {
	        if (hasSelectedContent(editor)) {
	          setClipboardData(evt, getData(editor), fallback(editor), noop);
	        }
	      };
	    };
	    var register$1 = function (editor) {
	      editor.on('cut', cut(editor));
	      editor.on('copy', copy(editor));
	    };
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.dom.RangeUtils');
	
	    var getCaretRangeFromEvent = function (editor, e) {
	      return global$b.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
	    };
	    var isPlainTextFileUrl = function (content) {
	      var plainTextContent = content['text/plain'];
	      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
	    };
	    var setFocusedRange = function (editor, rng) {
	      editor.focus();
	      editor.selection.setRng(rng);
	    };
	    var setup = function (editor, clipboard, draggingInternallyState) {
	      if (shouldBlockDrop(editor)) {
	        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        });
	      }
	      if (!shouldPasteDataImages(editor)) {
	        editor.on('drop', function (e) {
	          var dataTransfer = e.dataTransfer;
	          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
	            e.preventDefault();
	          }
	        });
	      }
	      editor.on('drop', function (e) {
	        var rng = getCaretRangeFromEvent(editor, e);
	        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
	          return;
	        }
	        var dropContent = clipboard.getDataTransferItems(e.dataTransfer);
	        var internal = clipboard.hasContentType(dropContent, internalHtmlMime());
	        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
	          return;
	        }
	        if (rng && shouldFilterDrop(editor)) {
	          var content_1 = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
	          if (content_1) {
	            e.preventDefault();
	            global$2.setEditorTimeout(editor, function () {
	              editor.undoManager.transact(function () {
	                if (dropContent['mce-internal']) {
	                  editor.execCommand('Delete');
	                }
	                setFocusedRange(editor, rng);
	                content_1 = trimHtml(content_1);
	                if (!dropContent['text/html']) {
	                  clipboard.pasteText(content_1);
	                } else {
	                  clipboard.pasteHtml(content_1, internal);
	                }
	              });
	            });
	          }
	        }
	      });
	      editor.on('dragstart', function (_e) {
	        draggingInternallyState.set(true);
	      });
	      editor.on('dragover dragend', function (e) {
	        if (shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
	          e.preventDefault();
	          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
	        }
	        if (e.type === 'dragend') {
	          draggingInternallyState.set(false);
	        }
	      });
	    };
	
	    var setup$1 = function (editor) {
	      var plugin = editor.plugins.paste;
	      var preProcess = getPreProcess(editor);
	      if (preProcess) {
	        editor.on('PastePreProcess', function (e) {
	          preProcess.call(plugin, plugin, e);
	        });
	      }
	      var postProcess = getPostProcess(editor);
	      if (postProcess) {
	        editor.on('PastePostProcess', function (e) {
	          postProcess.call(plugin, plugin, e);
	        });
	      }
	    };
	
	    var addPreProcessFilter = function (editor, filterFunc) {
	      editor.on('PastePreProcess', function (e) {
	        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
	      });
	    };
	    var addPostProcessFilter = function (editor, filterFunc) {
	      editor.on('PastePostProcess', function (e) {
	        filterFunc(editor, e.node);
	      });
	    };
	    var removeExplorerBrElementsAfterBlocks = function (editor, html) {
	      if (!isWordContent(html)) {
	        return html;
	      }
	      var blockElements = [];
	      global$5.each(editor.schema.getBlockElements(), function (block, blockName) {
	        blockElements.push(blockName);
	      });
	      var explorerBlocksRegExp = new RegExp('(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*', 'g');
	      html = filter$1(html, [[
	          explorerBlocksRegExp,
	          '$1'
	        ]]);
	      html = filter$1(html, [
	        [
	          /<br><br>/g,
	          '<BR><BR>'
	        ],
	        [
	          /<br>/g,
	          ' '
	        ],
	        [
	          /<BR><BR>/g,
	          '<br>'
	        ]
	      ]);
	      return html;
	    };
	    var removeWebKitStyles = function (editor, content, internal, isWordHtml) {
	      if (isWordHtml || internal) {
	        return content;
	      }
	      var webKitStylesSetting = getWebkitStyles(editor);
	      var webKitStyles;
	      if (shouldRemoveWebKitStyles(editor) === false || webKitStylesSetting === 'all') {
	        return content;
	      }
	      if (webKitStylesSetting) {
	        webKitStyles = webKitStylesSetting.split(/[, ]/);
	      }
	      if (webKitStyles) {
	        var dom_1 = editor.dom, node_1 = editor.selection.getNode();
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
	          var inputStyles = dom_1.parseStyle(dom_1.decode(value));
	          var outputStyles = {};
	          if (webKitStyles === 'none') {
	            return before + after;
	          }
	          for (var i = 0; i < webKitStyles.length; i++) {
	            var inputValue = inputStyles[webKitStyles[i]], currentValue = dom_1.getStyle(node_1, webKitStyles[i], true);
	            if (/color/.test(webKitStyles[i])) {
	              inputValue = dom_1.toHex(inputValue);
	              currentValue = dom_1.toHex(currentValue);
	            }
	            if (currentValue !== inputValue) {
	              outputStyles[webKitStyles[i]] = inputValue;
	            }
	          }
	          outputStyles = dom_1.serializeStyle(outputStyles, 'span');
	          if (outputStyles) {
	            return before + ' style="' + outputStyles + '"' + after;
	          }
	          return before + after;
	        });
	      } else {
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
	      }
	      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
	        return before + ' style="' + value + '"' + after;
	      });
	      return content;
	    };
	    var removeUnderlineAndFontInAnchor = function (editor, root) {
	      editor.$('a', root).find('font,u').each(function (i, node) {
	        editor.dom.remove(node, true);
	      });
	    };
	    var setup$2 = function (editor) {
	      if (global$1.webkit) {
	        addPreProcessFilter(editor, removeWebKitStyles);
	      }
	      if (global$1.ie) {
	        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
	        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
	      }
	    };
	
	    var makeSetupHandler = function (editor, clipboard) {
	      return function (api) {
	        api.setActive(clipboard.pasteFormat.get() === 'text');
	        var pastePlainTextToggleHandler = function (e) {
	          return api.setActive(e.state);
	        };
	        editor.on('PastePlainTextToggle', pastePlainTextToggleHandler);
	        return function () {
	          return editor.off('PastePlainTextToggle', pastePlainTextToggleHandler);
	        };
	      };
	    };
	    var register$2 = function (editor, clipboard) {
	      editor.ui.registry.addToggleButton('pastetext', {
	        active: false,
	        icon: 'paste-text',
	        tooltip: 'Paste as text',
	        onAction: function () {
	          return editor.execCommand('mceTogglePlainTextPaste');
	        },
	        onSetup: makeSetupHandler(editor, clipboard)
	      });
	      editor.ui.registry.addToggleMenuItem('pastetext', {
	        text: 'Paste as text',
	        icon: 'paste-text',
	        onAction: function () {
	          return editor.execCommand('mceTogglePlainTextPaste');
	        },
	        onSetup: makeSetupHandler(editor, clipboard)
	      });
	    };
	
	    function Plugin () {
	      global.add('paste', function (editor) {
	        if (hasProPlugin(editor) === false) {
	          var draggingInternallyState = Cell(false);
	          var pasteFormat = Cell(isPasteAsTextEnabled(editor) ? 'text' : 'html');
	          var clipboard = Clipboard(editor, pasteFormat);
	          var quirks = setup$2(editor);
	          register$2(editor, clipboard);
	          register(editor, clipboard);
	          setup$1(editor);
	          register$1(editor);
	          setup(editor, clipboard, draggingInternallyState);
	          return get(clipboard, quirks);
	        }
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "preview" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/preview')
	//   ES2015:
	//     import 'tinymce/plugins/preview'
	__webpack_require__(1230);

/***/ },
/* 1230 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getContentStyle = function (editor) {
	      return editor.getParam('content_style', '', 'string');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getBodyClassByHash = function (editor) {
	      var bodyClass = editor.getParam('body_class', '', 'hash');
	      return bodyClass[editor.id] || '';
	    };
	    var getBodyClass = function (editor) {
	      var bodyClass = editor.getParam('body_class', '', 'string');
	      if (bodyClass.indexOf('=') === -1) {
	        return bodyClass;
	      } else {
	        return getBodyClassByHash(editor);
	      }
	    };
	    var getBodyIdByHash = function (editor) {
	      var bodyId = editor.getParam('body_id', '', 'hash');
	      return bodyId[editor.id] || bodyId;
	    };
	    var getBodyId = function (editor) {
	      var bodyId = editor.getParam('body_id', 'tinymce', 'string');
	      if (bodyId.indexOf('=') === -1) {
	        return bodyId;
	      } else {
	        return getBodyIdByHash(editor);
	      }
	    };
	
	    var getPreviewHtml = function (editor) {
	      var headHtml = '';
	      var encode = editor.dom.encode;
	      var contentStyle = getContentStyle(editor);
	      headHtml += '<base href="' + encode(editor.documentBaseURI.getURI()) + '">';
	      var cors = shouldUseContentCssCors(editor) ? ' crossorigin="anonymous"' : '';
	      global$2.each(editor.contentCSS, function (url) {
	        headHtml += '<link type="text/css" rel="stylesheet" href="' + encode(editor.documentBaseURI.toAbsolute(url)) + '"' + cors + '>';
	      });
	      if (contentStyle) {
	        headHtml += '<style type="text/css">' + contentStyle + '</style>';
	      }
	      var bodyId = getBodyId(editor);
	      var bodyClass = getBodyClass(editor);
	      var isMetaKeyPressed = global$1.mac ? 'e.metaKey' : 'e.ctrlKey && !e.altKey';
	      var preventClicksOnLinksScript = '<script>' + 'document.addEventListener && document.addEventListener("click", function(e) {' + 'for (var elm = e.target; elm; elm = elm.parentNode) {' + 'if (elm.nodeName === "A" && !(' + isMetaKeyPressed + ')) {' + 'e.preventDefault();' + '}' + '}' + '}, false);' + '</script> ';
	      var directionality = editor.getBody().dir;
	      var dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : '';
	      var previewHtml = '<!DOCTYPE html>' + '<html>' + '<head>' + headHtml + '</head>' + '<body id="' + encode(bodyId) + '" class="mce-content-body ' + encode(bodyClass) + '"' + dirAttr + '>' + editor.getContent() + preventClicksOnLinksScript + '</body>' + '</html>';
	      return previewHtml;
	    };
	
	    var open = function (editor) {
	      var content = getPreviewHtml(editor);
	      var dataApi = editor.windowManager.open({
	        title: 'Preview',
	        size: 'large',
	        body: {
	          type: 'panel',
	          items: [{
	              name: 'preview',
	              type: 'iframe',
	              sandboxed: true
	            }]
	        },
	        buttons: [{
	            type: 'cancel',
	            name: 'close',
	            text: 'Close',
	            primary: true
	          }],
	        initialData: { preview: content }
	      });
	      dataApi.focus('close');
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mcePreview', function () {
	        open(editor);
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('preview', {
	        icon: 'preview',
	        tooltip: 'Preview',
	        onAction: function () {
	          return editor.execCommand('mcePreview');
	        }
	      });
	      editor.ui.registry.addMenuItem('preview', {
	        icon: 'preview',
	        text: 'Preview',
	        onAction: function () {
	          return editor.execCommand('mcePreview');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('preview', function (editor) {
	        register(editor);
	        register$1(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "print" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/print')
	//   ES2015:
	//     import 'tinymce/plugins/print'
	__webpack_require__(1232);

/***/ },
/* 1232 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var register = function (editor) {
	      editor.addCommand('mcePrint', function () {
	        if (global$1.browser.isIE()) {
	          editor.getDoc().execCommand('print', false, null);
	        } else {
	          editor.getWin().print();
	        }
	      });
	    };
	
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('print', {
	        icon: 'print',
	        tooltip: 'Print',
	        onAction: function () {
	          return editor.execCommand('mcePrint');
	        }
	      });
	      editor.ui.registry.addMenuItem('print', {
	        text: 'Print...',
	        icon: 'print',
	        onAction: function () {
	          return editor.execCommand('mcePrint');
	        }
	      });
	    };
	
	    function Plugin () {
	      global.add('print', function (editor) {
	        register(editor);
	        register$1(editor);
	        editor.addShortcut('Meta+P', '', 'mcePrint');
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "searchreplace" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/searchreplace')
	//   ES2015:
	//     import 'tinymce/plugins/searchreplace'
	__webpack_require__(1234);

/***/ },
/* 1234 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var isString = isType('string');
	    var isArray = isType('array');
	    var isBoolean = isSimpleType('boolean');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var punctuationStr = '[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uff3f\uFF5B\uFF5D\uFF5F-\uFF65]';
	
	    var punctuation = constant(punctuationStr);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var punctuation$1 = punctuation;
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var nativeSlice = Array.prototype.slice;
	    var nativePush = Array.prototype.push;
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]);
	        var r = [];
	        var group = [];
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	
	    var hasOwnProperty = Object.hasOwnProperty;
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isText = isType$1(TEXT);
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_PRECEDING);
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var spot = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	    var leaf = function (element, offset) {
	      var cs = children(element);
	      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
	    };
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var wrap = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api = NodeValue(isText, 'text');
	    var get = function (element) {
	      return api.get(element);
	    };
	
	    var descendants = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var isSimpleBoundary = function (dom, node) {
	      return dom.isBlock(node) || has(dom.schema.getShortEndedElements(), node.nodeName);
	    };
	    var isContentEditableFalse = function (dom, node) {
	      return dom.getContentEditable(node) === 'false';
	    };
	    var isContentEditableTrueInCef = function (dom, node) {
	      return dom.getContentEditable(node) === 'true' && dom.getContentEditableParent(node.parentNode) === 'false';
	    };
	    var isHidden = function (dom, node) {
	      return !dom.isBlock(node) && has(dom.schema.getWhiteSpaceElements(), node.nodeName);
	    };
	    var isBoundary = function (dom, node) {
	      return isSimpleBoundary(dom, node) || isContentEditableFalse(dom, node) || isHidden(dom, node) || isContentEditableTrueInCef(dom, node);
	    };
	    var isText$1 = function (node) {
	      return node.nodeType === 3;
	    };
	    var nuSection = function () {
	      return {
	        sOffset: 0,
	        fOffset: 0,
	        elements: []
	      };
	    };
	    var toLeaf = function (node, offset) {
	      return leaf(SugarElement.fromDom(node), offset);
	    };
	    var walk = function (dom, walkerFn, startNode, callbacks, endNode, skipStart) {
	      if (skipStart === void 0) {
	        skipStart = true;
	      }
	      var next = skipStart ? walkerFn(false) : startNode;
	      while (next) {
	        var isCefNode = isContentEditableFalse(dom, next);
	        if (isCefNode || isHidden(dom, next)) {
	          var stopWalking = isCefNode ? callbacks.cef(next) : callbacks.boundary(next);
	          if (stopWalking) {
	            break;
	          } else {
	            next = walkerFn(true);
	            continue;
	          }
	        } else if (isSimpleBoundary(dom, next)) {
	          if (callbacks.boundary(next)) {
	            break;
	          }
	        } else if (isText$1(next)) {
	          callbacks.text(next);
	        }
	        if (next === endNode) {
	          break;
	        } else {
	          next = walkerFn(false);
	        }
	      }
	    };
	    var collectTextToBoundary = function (dom, section, node, rootNode, forwards) {
	      if (isBoundary(dom, node)) {
	        return;
	      }
	      var rootBlock = dom.getParent(rootNode, dom.isBlock);
	      var walker = new global$2(node, rootBlock);
	      var walkerFn = forwards ? walker.next.bind(walker) : walker.prev.bind(walker);
	      walk(dom, walkerFn, node, {
	        boundary: always,
	        cef: always,
	        text: function (next) {
	          if (forwards) {
	            section.fOffset += next.length;
	          } else {
	            section.sOffset += next.length;
	          }
	          section.elements.push(SugarElement.fromDom(next));
	        }
	      });
	    };
	    var collect = function (dom, rootNode, startNode, endNode, callbacks, skipStart) {
	      if (skipStart === void 0) {
	        skipStart = true;
	      }
	      var walker = new global$2(startNode, rootNode);
	      var sections = [];
	      var current = nuSection();
	      collectTextToBoundary(dom, current, startNode, rootNode, false);
	      var finishSection = function () {
	        if (current.elements.length > 0) {
	          sections.push(current);
	          current = nuSection();
	        }
	        return false;
	      };
	      walk(dom, walker.next.bind(walker), startNode, {
	        boundary: finishSection,
	        cef: function (node) {
	          finishSection();
	          if (callbacks) {
	            sections.push.apply(sections, callbacks.cef(node));
	          }
	          return false;
	        },
	        text: function (next) {
	          current.elements.push(SugarElement.fromDom(next));
	          if (callbacks) {
	            callbacks.text(next, current);
	          }
	        }
	      }, endNode, skipStart);
	      if (endNode) {
	        collectTextToBoundary(dom, current, endNode, rootNode, true);
	      }
	      finishSection();
	      return sections;
	    };
	    var collectRangeSections = function (dom, rng) {
	      var start = toLeaf(rng.startContainer, rng.startOffset);
	      var startNode = start.element.dom;
	      var end = toLeaf(rng.endContainer, rng.endOffset);
	      var endNode = end.element.dom;
	      return collect(dom, rng.commonAncestorContainer, startNode, endNode, {
	        text: function (node, section) {
	          if (node === endNode) {
	            section.fOffset += node.length - end.offset;
	          } else if (node === startNode) {
	            section.sOffset += start.offset;
	          }
	        },
	        cef: function (node) {
	          var sections = bind(descendants(SugarElement.fromDom(node), '*[contenteditable=true]'), function (e) {
	            var ceTrueNode = e.dom;
	            return collect(dom, ceTrueNode, ceTrueNode);
	          });
	          return sort(sections, function (a, b) {
	            return documentPositionPreceding(a.elements[0].dom, b.elements[0].dom) ? 1 : -1;
	          });
	        }
	      }, false);
	    };
	    var fromRng = function (dom, rng) {
	      return rng.collapsed ? [] : collectRangeSections(dom, rng);
	    };
	    var fromNode = function (dom, node) {
	      var rng = dom.createRng();
	      rng.selectNode(node);
	      return fromRng(dom, rng);
	    };
	    var fromNodes = function (dom, nodes) {
	      return bind(nodes, function (node) {
	        return fromNode(dom, node);
	      });
	    };
	
	    var find = function (text, pattern, start, finish) {
	      if (start === void 0) {
	        start = 0;
	      }
	      if (finish === void 0) {
	        finish = text.length;
	      }
	      var regex = pattern.regex;
	      regex.lastIndex = start;
	      var results = [];
	      var match;
	      while (match = regex.exec(text)) {
	        var matchedText = match[pattern.matchIndex];
	        var matchStart = match.index + match[0].indexOf(matchedText);
	        var matchFinish = matchStart + matchedText.length;
	        if (matchFinish > finish) {
	          break;
	        }
	        results.push({
	          start: matchStart,
	          finish: matchFinish
	        });
	        regex.lastIndex = matchFinish;
	      }
	      return results;
	    };
	    var extract = function (elements, matches) {
	      var nodePositions = foldl(elements, function (acc, element) {
	        var content = get(element);
	        var start = acc.last;
	        var finish = start + content.length;
	        var positions = bind(matches, function (match, matchIdx) {
	          if (match.start < finish && match.finish > start) {
	            return [{
	                element: element,
	                start: Math.max(start, match.start) - start,
	                finish: Math.min(finish, match.finish) - start,
	                matchId: matchIdx
	              }];
	          } else {
	            return [];
	          }
	        });
	        return {
	          results: acc.results.concat(positions),
	          last: finish
	        };
	      }, {
	        results: [],
	        last: 0
	      }).results;
	      return groupBy(nodePositions, function (position) {
	        return position.matchId;
	      });
	    };
	
	    var find$1 = function (pattern, sections) {
	      return bind(sections, function (section) {
	        var elements = section.elements;
	        var content = map(elements, get).join('');
	        var positions = find(content, pattern, section.sOffset, content.length - section.fOffset);
	        return extract(elements, positions);
	      });
	    };
	    var mark = function (matches, replacementNode) {
	      eachr(matches, function (match, idx) {
	        eachr(match, function (pos) {
	          var wrapper = SugarElement.fromDom(replacementNode.cloneNode(false));
	          set(wrapper, 'data-mce-index', idx);
	          var textNode = pos.element.dom;
	          if (textNode.length === pos.finish && pos.start === 0) {
	            wrap(pos.element, wrapper);
	          } else {
	            if (textNode.length !== pos.finish) {
	              textNode.splitText(pos.finish);
	            }
	            var matchNode = textNode.splitText(pos.start);
	            wrap(SugarElement.fromDom(matchNode), wrapper);
	          }
	        });
	      });
	    };
	    var findAndMark = function (dom, pattern, node, replacementNode) {
	      var textSections = fromNode(dom, node);
	      var matches = find$1(pattern, textSections);
	      mark(matches, replacementNode);
	      return matches.length;
	    };
	    var findAndMarkInSelection = function (dom, pattern, selection, replacementNode) {
	      var bookmark = selection.getBookmark();
	      var nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
	      var textSections = nodes.length > 0 ? fromNodes(dom, nodes) : fromRng(dom, selection.getRng());
	      var matches = find$1(pattern, textSections);
	      mark(matches, replacementNode);
	      selection.moveToBookmark(bookmark);
	      return matches.length;
	    };
	
	    var getElmIndex = function (elm) {
	      var value = elm.getAttribute('data-mce-index');
	      if (typeof value === 'number') {
	        return '' + value;
	      }
	      return value;
	    };
	    var markAllMatches = function (editor, currentSearchState, pattern, inSelection) {
	      var marker = editor.dom.create('span', { 'data-mce-bogus': 1 });
	      marker.className = 'mce-match-marker';
	      var node = editor.getBody();
	      done(editor, currentSearchState, false);
	      if (inSelection) {
	        return findAndMarkInSelection(editor.dom, pattern, editor.selection, marker);
	      } else {
	        return findAndMark(editor.dom, pattern, node, marker);
	      }
	    };
	    var unwrap = function (node) {
	      var parentNode = node.parentNode;
	      if (node.firstChild) {
	        parentNode.insertBefore(node.firstChild, node);
	      }
	      node.parentNode.removeChild(node);
	    };
	    var findSpansByIndex = function (editor, index) {
	      var spans = [];
	      var nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
	      if (nodes.length) {
	        for (var i = 0; i < nodes.length; i++) {
	          var nodeIndex = getElmIndex(nodes[i]);
	          if (nodeIndex === null || !nodeIndex.length) {
	            continue;
	          }
	          if (nodeIndex === index.toString()) {
	            spans.push(nodes[i]);
	          }
	        }
	      }
	      return spans;
	    };
	    var moveSelection = function (editor, currentSearchState, forward) {
	      var searchState = currentSearchState.get();
	      var testIndex = searchState.index;
	      var dom = editor.dom;
	      forward = forward !== false;
	      if (forward) {
	        if (testIndex + 1 === searchState.count) {
	          testIndex = 0;
	        } else {
	          testIndex++;
	        }
	      } else {
	        if (testIndex - 1 === -1) {
	          testIndex = searchState.count - 1;
	        } else {
	          testIndex--;
	        }
	      }
	      dom.removeClass(findSpansByIndex(editor, searchState.index), 'mce-match-marker-selected');
	      var spans = findSpansByIndex(editor, testIndex);
	      if (spans.length) {
	        dom.addClass(findSpansByIndex(editor, testIndex), 'mce-match-marker-selected');
	        editor.selection.scrollIntoView(spans[0]);
	        return testIndex;
	      }
	      return -1;
	    };
	    var removeNode = function (dom, node) {
	      var parent = node.parentNode;
	      dom.remove(node);
	      if (dom.isEmpty(parent)) {
	        dom.remove(parent);
	      }
	    };
	    var escapeSearchText = function (text, wholeWord) {
	      var escapedText = text.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&').replace(/\s/g, '[^\\S\\r\\n\\uFEFF]');
	      var wordRegex = '(' + escapedText + ')';
	      return wholeWord ? '(?:^|\\s|' + punctuation$1() + ')' + wordRegex + ('(?=$|\\s|' + punctuation$1() + ')') : wordRegex;
	    };
	    var find$2 = function (editor, currentSearchState, text, matchCase, wholeWord, inSelection) {
	      var escapedText = escapeSearchText(text, wholeWord);
	      var pattern = {
	        regex: new RegExp(escapedText, matchCase ? 'g' : 'gi'),
	        matchIndex: 1
	      };
	      var count = markAllMatches(editor, currentSearchState, pattern, inSelection);
	      if (count) {
	        var newIndex = moveSelection(editor, currentSearchState, true);
	        currentSearchState.set({
	          index: newIndex,
	          count: count,
	          text: text,
	          matchCase: matchCase,
	          wholeWord: wholeWord,
	          inSelection: inSelection
	        });
	      }
	      return count;
	    };
	    var next = function (editor, currentSearchState) {
	      var index = moveSelection(editor, currentSearchState, true);
	      currentSearchState.set(__assign(__assign({}, currentSearchState.get()), { index: index }));
	    };
	    var prev = function (editor, currentSearchState) {
	      var index = moveSelection(editor, currentSearchState, false);
	      currentSearchState.set(__assign(__assign({}, currentSearchState.get()), { index: index }));
	    };
	    var isMatchSpan = function (node) {
	      var matchIndex = getElmIndex(node);
	      return matchIndex !== null && matchIndex.length > 0;
	    };
	    var replace = function (editor, currentSearchState, text, forward, all) {
	      var searchState = currentSearchState.get();
	      var currentIndex = searchState.index;
	      var currentMatchIndex, nextIndex = currentIndex;
	      forward = forward !== false;
	      var node = editor.getBody();
	      var nodes = global$1.grep(global$1.toArray(node.getElementsByTagName('span')), isMatchSpan);
	      for (var i = 0; i < nodes.length; i++) {
	        var nodeIndex = getElmIndex(nodes[i]);
	        var matchIndex = currentMatchIndex = parseInt(nodeIndex, 10);
	        if (all || matchIndex === searchState.index) {
	          if (text.length) {
	            nodes[i].firstChild.nodeValue = text;
	            unwrap(nodes[i]);
	          } else {
	            removeNode(editor.dom, nodes[i]);
	          }
	          while (nodes[++i]) {
	            matchIndex = parseInt(getElmIndex(nodes[i]), 10);
	            if (matchIndex === currentMatchIndex) {
	              removeNode(editor.dom, nodes[i]);
	            } else {
	              i--;
	              break;
	            }
	          }
	          if (forward) {
	            nextIndex--;
	          }
	        } else if (currentMatchIndex > currentIndex) {
	          nodes[i].setAttribute('data-mce-index', String(currentMatchIndex - 1));
	        }
	      }
	      currentSearchState.set(__assign(__assign({}, searchState), {
	        count: all ? 0 : searchState.count - 1,
	        index: nextIndex
	      }));
	      if (forward) {
	        next(editor, currentSearchState);
	      } else {
	        prev(editor, currentSearchState);
	      }
	      return !all && currentSearchState.get().count > 0;
	    };
	    var done = function (editor, currentSearchState, keepEditorSelection) {
	      var i, startContainer, endContainer;
	      var searchState = currentSearchState.get();
	      var nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
	      for (i = 0; i < nodes.length; i++) {
	        var nodeIndex = getElmIndex(nodes[i]);
	        if (nodeIndex !== null && nodeIndex.length) {
	          if (nodeIndex === searchState.index.toString()) {
	            if (!startContainer) {
	              startContainer = nodes[i].firstChild;
	            }
	            endContainer = nodes[i].firstChild;
	          }
	          unwrap(nodes[i]);
	        }
	      }
	      currentSearchState.set(__assign(__assign({}, searchState), {
	        index: -1,
	        count: 0,
	        text: ''
	      }));
	      if (startContainer && endContainer) {
	        var rng = editor.dom.createRng();
	        rng.setStart(startContainer, 0);
	        rng.setEnd(endContainer, endContainer.data.length);
	        if (keepEditorSelection !== false) {
	          editor.selection.setRng(rng);
	        }
	        return rng;
	      }
	    };
	    var hasNext = function (editor, currentSearchState) {
	      return currentSearchState.get().count > 1;
	    };
	    var hasPrev = function (editor, currentSearchState) {
	      return currentSearchState.get().count > 1;
	    };
	
	    var get$1 = function (editor, currentState) {
	      var done$1 = function (keepEditorSelection) {
	        return done(editor, currentState, keepEditorSelection);
	      };
	      var find = function (text, matchCase, wholeWord, inSelection) {
	        if (inSelection === void 0) {
	          inSelection = false;
	        }
	        return find$2(editor, currentState, text, matchCase, wholeWord, inSelection);
	      };
	      var next$1 = function () {
	        return next(editor, currentState);
	      };
	      var prev$1 = function () {
	        return prev(editor, currentState);
	      };
	      var replace$1 = function (text, forward, all) {
	        return replace(editor, currentState, text, forward, all);
	      };
	      return {
	        done: done$1,
	        find: find,
	        next: next$1,
	        prev: prev$1,
	        replace: replace$1
	      };
	    };
	
	    var value = function () {
	      var subject = Cell(Optional.none());
	      var clear = function () {
	        return subject.set(Optional.none());
	      };
	      var set = function (s) {
	        return subject.set(Optional.some(s));
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var open = function (editor, currentSearchState) {
	      var dialogApi = value();
	      editor.undoManager.add();
	      var selectedText = global$1.trim(editor.selection.getContent({ format: 'text' }));
	      var updateButtonStates = function (api) {
	        var updateNext = hasNext(editor, currentSearchState) ? api.enable : api.disable;
	        updateNext('next');
	        var updatePrev = hasPrev(editor, currentSearchState) ? api.enable : api.disable;
	        updatePrev('prev');
	      };
	      var updateSearchState = function (api) {
	        var data = api.getData();
	        var current = currentSearchState.get();
	        currentSearchState.set(__assign(__assign({}, current), {
	          matchCase: data.matchcase,
	          wholeWord: data.wholewords,
	          inSelection: data.inselection
	        }));
	      };
	      var disableAll = function (api, disable) {
	        var buttons = [
	          'replace',
	          'replaceall',
	          'prev',
	          'next'
	        ];
	        var toggle = disable ? api.disable : api.enable;
	        each(buttons, toggle);
	      };
	      var notFoundAlert = function (api) {
	        editor.windowManager.alert('Could not find the specified string.', function () {
	          api.focus('findtext');
	        });
	      };
	      var focusButtonIfRequired = function (api, name) {
	        if (global$3.browser.isSafari() && global$3.deviceType.isTouch() && (name === 'find' || name === 'replace' || name === 'replaceall')) {
	          api.focus(name);
	        }
	      };
	      var reset = function (api) {
	        done(editor, currentSearchState, false);
	        disableAll(api, true);
	        updateButtonStates(api);
	      };
	      var doFind = function (api) {
	        var data = api.getData();
	        var last = currentSearchState.get();
	        if (!data.findtext.length) {
	          reset(api);
	          return;
	        }
	        if (last.text === data.findtext && last.matchCase === data.matchcase && last.wholeWord === data.wholewords) {
	          next(editor, currentSearchState);
	        } else {
	          var count = find$2(editor, currentSearchState, data.findtext, data.matchcase, data.wholewords, data.inselection);
	          if (count <= 0) {
	            notFoundAlert(api);
	          }
	          disableAll(api, count === 0);
	        }
	        updateButtonStates(api);
	      };
	      var initialState = currentSearchState.get();
	      var initialData = {
	        findtext: selectedText,
	        replacetext: '',
	        wholewords: initialState.wholeWord,
	        matchcase: initialState.matchCase,
	        inselection: initialState.inSelection
	      };
	      var spec = {
	        title: 'Find and Replace',
	        size: 'normal',
	        body: {
	          type: 'panel',
	          items: [
	            {
	              type: 'bar',
	              items: [
	                {
	                  type: 'input',
	                  name: 'findtext',
	                  placeholder: 'Find',
	                  maximized: true,
	                  inputMode: 'search'
	                },
	                {
	                  type: 'button',
	                  name: 'prev',
	                  text: 'Previous',
	                  icon: 'action-prev',
	                  disabled: true,
	                  borderless: true
	                },
	                {
	                  type: 'button',
	                  name: 'next',
	                  text: 'Next',
	                  icon: 'action-next',
	                  disabled: true,
	                  borderless: true
	                }
	              ]
	            },
	            {
	              type: 'input',
	              name: 'replacetext',
	              placeholder: 'Replace with',
	              inputMode: 'search'
	            }
	          ]
	        },
	        buttons: [
	          {
	            type: 'menu',
	            name: 'options',
	            icon: 'preferences',
	            tooltip: 'Preferences',
	            align: 'start',
	            items: [
	              {
	                type: 'togglemenuitem',
	                name: 'matchcase',
	                text: 'Match case'
	              },
	              {
	                type: 'togglemenuitem',
	                name: 'wholewords',
	                text: 'Find whole words only'
	              },
	              {
	                type: 'togglemenuitem',
	                name: 'inselection',
	                text: 'Find in selection'
	              }
	            ]
	          },
	          {
	            type: 'custom',
	            name: 'find',
	            text: 'Find',
	            primary: true
	          },
	          {
	            type: 'custom',
	            name: 'replace',
	            text: 'Replace',
	            disabled: true
	          },
	          {
	            type: 'custom',
	            name: 'replaceall',
	            text: 'Replace all',
	            disabled: true
	          }
	        ],
	        initialData: initialData,
	        onChange: function (api, details) {
	          if (details.name === 'findtext' && currentSearchState.get().count > 0) {
	            reset(api);
	          }
	        },
	        onAction: function (api, details) {
	          var data = api.getData();
	          switch (details.name) {
	          case 'find':
	            doFind(api);
	            break;
	          case 'replace':
	            if (!replace(editor, currentSearchState, data.replacetext)) {
	              reset(api);
	            } else {
	              updateButtonStates(api);
	            }
	            break;
	          case 'replaceall':
	            replace(editor, currentSearchState, data.replacetext, true, true);
	            reset(api);
	            break;
	          case 'prev':
	            prev(editor, currentSearchState);
	            updateButtonStates(api);
	            break;
	          case 'next':
	            next(editor, currentSearchState);
	            updateButtonStates(api);
	            break;
	          case 'matchcase':
	          case 'wholewords':
	          case 'inselection':
	            updateSearchState(api);
	            reset(api);
	            break;
	          }
	          focusButtonIfRequired(api, details.name);
	        },
	        onSubmit: function (api) {
	          doFind(api);
	          focusButtonIfRequired(api, 'find');
	        },
	        onClose: function () {
	          editor.focus();
	          done(editor, currentSearchState);
	          editor.undoManager.add();
	        }
	      };
	      dialogApi.set(editor.windowManager.open(spec, { inline: 'toolbar' }));
	    };
	
	    var register = function (editor, currentSearchState) {
	      editor.addCommand('SearchReplace', function () {
	        open(editor, currentSearchState);
	      });
	    };
	
	    var showDialog = function (editor, currentSearchState) {
	      return function () {
	        open(editor, currentSearchState);
	      };
	    };
	    var register$1 = function (editor, currentSearchState) {
	      editor.ui.registry.addMenuItem('searchreplace', {
	        text: 'Find and replace...',
	        shortcut: 'Meta+F',
	        onAction: showDialog(editor, currentSearchState),
	        icon: 'search'
	      });
	      editor.ui.registry.addButton('searchreplace', {
	        tooltip: 'Find and replace',
	        onAction: showDialog(editor, currentSearchState),
	        icon: 'search'
	      });
	      editor.shortcuts.add('Meta+F', '', showDialog(editor, currentSearchState));
	    };
	
	    function Plugin () {
	      global.add('searchreplace', function (editor) {
	        var currentSearchState = Cell({
	          index: -1,
	          count: 0,
	          text: '',
	          matchCase: false,
	          wholeWord: false,
	          inSelection: false
	        });
	        register(editor, currentSearchState);
	        register$1(editor, currentSearchState);
	        return get$1(editor, currentSearchState);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "spellchecker" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/spellchecker')
	//   ES2015:
	//     import 'tinymce/plugins/spellchecker'
	__webpack_require__(1236);

/***/ },
/* 1236 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var hasProPlugin = function (editor) {
	      if (editor.hasPlugin('tinymcespellchecker', true)) {
	        if (typeof window.console !== 'undefined' && window.console.log) {
	          window.console.log('Spell Checker Pro is incompatible with Spell Checker plugin! ' + 'Remove \'spellchecker\' from the \'plugins\' option.');
	        }
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    var hasOwnProperty = Object.hasOwnProperty;
	    var isEmpty = function (r) {
	      for (var x in r) {
	        if (hasOwnProperty.call(r, x)) {
	          return false;
	        }
	      }
	      return true;
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.URI');
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var fireSpellcheckStart = function (editor) {
	      return editor.fire('SpellcheckStart');
	    };
	    var fireSpellcheckEnd = function (editor) {
	      return editor.fire('SpellcheckEnd');
	    };
	
	    var getLanguages = function (editor) {
	      var defaultLanguages = 'English=en,Danish=da,Dutch=nl,Finnish=fi,French=fr_FR,German=de,Italian=it,Polish=pl,Portuguese=pt_BR,Spanish=es,Swedish=sv';
	      return editor.getParam('spellchecker_languages', defaultLanguages);
	    };
	    var getLanguage = function (editor) {
	      var defaultLanguage = editor.getParam('language', 'en');
	      return editor.getParam('spellchecker_language', defaultLanguage);
	    };
	    var getRpcUrl = function (editor) {
	      return editor.getParam('spellchecker_rpc_url');
	    };
	    var getSpellcheckerCallback = function (editor) {
	      return editor.getParam('spellchecker_callback');
	    };
	    var getSpellcheckerWordcharPattern = function (editor) {
	      var defaultPattern = new RegExp('[^' + '\\s!"#$%&()*+,-./:;<=>?@[\\]^_{|}`' + '\xA7\xA9\xAB\xAE\xB1\xB6\xB7\xB8\xBB' + '\xBC\xBD\xBE\xBF\xD7\xF7\xA4\u201D\u201C\u201E\xA0\u2002\u2003\u2009' + ']+', 'g');
	      return editor.getParam('spellchecker_wordchar_pattern', defaultPattern);
	    };
	
	    var isContentEditableFalse = function (node) {
	      return node && node.nodeType === 1 && node.contentEditable === 'false';
	    };
	    var DomTextMatcher = function (node, editor) {
	      var m, matches = [];
	      var dom = editor.dom;
	      var blockElementsMap = editor.schema.getBlockElements();
	      var hiddenTextElementsMap = editor.schema.getWhiteSpaceElements();
	      var shortEndedElementsMap = editor.schema.getShortEndedElements();
	      var createMatch = function (m, data) {
	        if (!m[0]) {
	          throw new Error('findAndReplaceDOMText cannot handle zero-length matches');
	        }
	        return {
	          start: m.index,
	          end: m.index + m[0].length,
	          text: m[0],
	          data: data
	        };
	      };
	      var getText = function (node) {
	        var txt;
	        if (node.nodeType === 3) {
	          return node.data;
	        }
	        if (hiddenTextElementsMap[node.nodeName] && !blockElementsMap[node.nodeName]) {
	          return '';
	        }
	        if (isContentEditableFalse(node)) {
	          return '\n';
	        }
	        txt = '';
	        if (blockElementsMap[node.nodeName] || shortEndedElementsMap[node.nodeName]) {
	          txt += '\n';
	        }
	        if (node = node.firstChild) {
	          do {
	            txt += getText(node);
	          } while (node = node.nextSibling);
	        }
	        return txt;
	      };
	      var stepThroughMatches = function (node, matches, replaceFn) {
	        var startNode, endNode, startNodeIndex, endNodeIndex, innerNodes = [], atIndex = 0, curNode = node, matchLocation, matchIndex = 0;
	        matches = matches.slice(0);
	        matches.sort(function (a, b) {
	          return a.start - b.start;
	        });
	        matchLocation = matches.shift();
	        out:
	          while (true) {
	            if (blockElementsMap[curNode.nodeName] || shortEndedElementsMap[curNode.nodeName] || isContentEditableFalse(curNode)) {
	              atIndex++;
	            }
	            if (curNode.nodeType === 3) {
	              if (!endNode && curNode.length + atIndex >= matchLocation.end) {
	                endNode = curNode;
	                endNodeIndex = matchLocation.end - atIndex;
	              } else if (startNode) {
	                innerNodes.push(curNode);
	              }
	              if (!startNode && curNode.length + atIndex > matchLocation.start) {
	                startNode = curNode;
	                startNodeIndex = matchLocation.start - atIndex;
	              }
	              atIndex += curNode.length;
	            }
	            if (startNode && endNode) {
	              curNode = replaceFn({
	                startNode: startNode,
	                startNodeIndex: startNodeIndex,
	                endNode: endNode,
	                endNodeIndex: endNodeIndex,
	                innerNodes: innerNodes,
	                match: matchLocation.text,
	                matchIndex: matchIndex
	              });
	              atIndex -= endNode.length - endNodeIndex;
	              startNode = null;
	              endNode = null;
	              innerNodes = [];
	              matchLocation = matches.shift();
	              matchIndex++;
	              if (!matchLocation) {
	                break;
	              }
	            } else if ((!hiddenTextElementsMap[curNode.nodeName] || blockElementsMap[curNode.nodeName]) && curNode.firstChild) {
	              if (!isContentEditableFalse(curNode)) {
	                curNode = curNode.firstChild;
	                continue;
	              }
	            } else if (curNode.nextSibling) {
	              curNode = curNode.nextSibling;
	              continue;
	            }
	            while (true) {
	              if (curNode.nextSibling) {
	                curNode = curNode.nextSibling;
	                break;
	              } else if (curNode.parentNode !== node) {
	                curNode = curNode.parentNode;
	              } else {
	                break out;
	              }
	            }
	          }
	      };
	      var genReplacer = function (callback) {
	        var makeReplacementNode = function (fill, matchIndex) {
	          var match = matches[matchIndex];
	          if (!match.stencil) {
	            match.stencil = callback(match);
	          }
	          var clone = match.stencil.cloneNode(false);
	          clone.setAttribute('data-mce-index', matchIndex);
	          if (fill) {
	            clone.appendChild(dom.doc.createTextNode(fill));
	          }
	          return clone;
	        };
	        return function (range) {
	          var before;
	          var after;
	          var parentNode;
	          var startNode = range.startNode;
	          var endNode = range.endNode;
	          var matchIndex = range.matchIndex;
	          var doc = dom.doc;
	          if (startNode === endNode) {
	            var node_1 = startNode;
	            parentNode = node_1.parentNode;
	            if (range.startNodeIndex > 0) {
	              before = doc.createTextNode(node_1.data.substring(0, range.startNodeIndex));
	              parentNode.insertBefore(before, node_1);
	            }
	            var el = makeReplacementNode(range.match, matchIndex);
	            parentNode.insertBefore(el, node_1);
	            if (range.endNodeIndex < node_1.length) {
	              after = doc.createTextNode(node_1.data.substring(range.endNodeIndex));
	              parentNode.insertBefore(after, node_1);
	            }
	            node_1.parentNode.removeChild(node_1);
	            return el;
	          }
	          before = doc.createTextNode(startNode.data.substring(0, range.startNodeIndex));
	          after = doc.createTextNode(endNode.data.substring(range.endNodeIndex));
	          var elA = makeReplacementNode(startNode.data.substring(range.startNodeIndex), matchIndex);
	          for (var i = 0, l = range.innerNodes.length; i < l; ++i) {
	            var innerNode = range.innerNodes[i];
	            var innerEl = makeReplacementNode(innerNode.data, matchIndex);
	            innerNode.parentNode.replaceChild(innerEl, innerNode);
	          }
	          var elB = makeReplacementNode(endNode.data.substring(0, range.endNodeIndex), matchIndex);
	          parentNode = startNode.parentNode;
	          parentNode.insertBefore(before, startNode);
	          parentNode.insertBefore(elA, startNode);
	          parentNode.removeChild(startNode);
	          parentNode = endNode.parentNode;
	          parentNode.insertBefore(elB, endNode);
	          parentNode.insertBefore(after, endNode);
	          parentNode.removeChild(endNode);
	          return elB;
	        };
	      };
	      var unwrapElement = function (element) {
	        var parentNode = element.parentNode;
	        while (element.childNodes.length > 0) {
	          parentNode.insertBefore(element.childNodes[0], element);
	        }
	        parentNode.removeChild(element);
	      };
	      var hasClass = function (elm) {
	        return elm.className.indexOf('mce-spellchecker-word') !== -1;
	      };
	      var getWrappersByIndex = function (index) {
	        var elements = node.getElementsByTagName('*'), wrappers = [];
	        index = typeof index === 'number' ? '' + index : null;
	        for (var i = 0; i < elements.length; i++) {
	          var element = elements[i], dataIndex = element.getAttribute('data-mce-index');
	          if (dataIndex !== null && dataIndex.length && hasClass(element)) {
	            if (dataIndex === index || index === null) {
	              wrappers.push(element);
	            }
	          }
	        }
	        return wrappers;
	      };
	      var indexOf = function (match) {
	        var i = matches.length;
	        while (i--) {
	          if (matches[i] === match) {
	            return i;
	          }
	        }
	        return -1;
	      };
	      function filter(callback) {
	        var filteredMatches = [];
	        each(function (match, i) {
	          if (callback(match, i)) {
	            filteredMatches.push(match);
	          }
	        });
	        matches = filteredMatches;
	        return this;
	      }
	      function each(callback) {
	        for (var i = 0, l = matches.length; i < l; i++) {
	          if (callback(matches[i], i) === false) {
	            break;
	          }
	        }
	        return this;
	      }
	      function wrap(callback) {
	        if (matches.length) {
	          stepThroughMatches(node, matches, genReplacer(callback));
	        }
	        return this;
	      }
	      function find(regex, data) {
	        if (text && regex.global) {
	          while (m = regex.exec(text)) {
	            matches.push(createMatch(m, data));
	          }
	        }
	        return this;
	      }
	      function unwrap(match) {
	        var i;
	        var elements = getWrappersByIndex(match ? indexOf(match) : null);
	        i = elements.length;
	        while (i--) {
	          unwrapElement(elements[i]);
	        }
	        return this;
	      }
	      var matchFromElement = function (element) {
	        return matches[element.getAttribute('data-mce-index')];
	      };
	      var elementFromMatch = function (match) {
	        return getWrappersByIndex(indexOf(match))[0];
	      };
	      function add(start, length, data) {
	        matches.push({
	          start: start,
	          end: start + length,
	          text: text.substr(start, length),
	          data: data
	        });
	        return this;
	      }
	      var rangeFromMatch = function (match) {
	        var wrappers = getWrappersByIndex(indexOf(match));
	        var rng = editor.dom.createRng();
	        rng.setStartBefore(wrappers[0]);
	        rng.setEndAfter(wrappers[wrappers.length - 1]);
	        return rng;
	      };
	      var replace = function (match, text) {
	        var rng = rangeFromMatch(match);
	        rng.deleteContents();
	        if (text.length > 0) {
	          rng.insertNode(editor.dom.doc.createTextNode(text));
	        }
	        return rng;
	      };
	      function reset() {
	        matches.splice(0, matches.length);
	        unwrap();
	        return this;
	      }
	      var text = getText(node);
	      return {
	        text: text,
	        matches: matches,
	        each: each,
	        filter: filter,
	        reset: reset,
	        matchFromElement: matchFromElement,
	        elementFromMatch: elementFromMatch,
	        find: find,
	        add: add,
	        wrap: wrap,
	        unwrap: unwrap,
	        replace: replace,
	        rangeFromMatch: rangeFromMatch,
	        indexOf: indexOf
	      };
	    };
	
	    var getTextMatcher = function (editor, textMatcherState) {
	      if (!textMatcherState.get()) {
	        var textMatcher = DomTextMatcher(editor.getBody(), editor);
	        textMatcherState.set(textMatcher);
	      }
	      return textMatcherState.get();
	    };
	    var defaultSpellcheckCallback = function (editor, pluginUrl, currentLanguageState) {
	      return function (method, text, doneCallback, errorCallback) {
	        var data = {
	          method: method,
	          lang: currentLanguageState.get()
	        };
	        var postData = '';
	        data[method === 'addToDictionary' ? 'word' : 'text'] = text;
	        global$1.each(data, function (value, key) {
	          if (postData) {
	            postData += '&';
	          }
	          postData += key + '=' + encodeURIComponent(value);
	        });
	        global$3.send({
	          url: new global$2(pluginUrl).toAbsolute(getRpcUrl(editor)),
	          type: 'post',
	          content_type: 'application/x-www-form-urlencoded',
	          data: postData,
	          success: function (result) {
	            var parseResult = JSON.parse(result);
	            if (!parseResult) {
	              var message = editor.translate('Server response wasn\'t proper JSON.');
	              errorCallback(message);
	            } else if (parseResult.error) {
	              errorCallback(parseResult.error);
	            } else {
	              doneCallback(parseResult);
	            }
	          },
	          error: function () {
	            var message = editor.translate('The spelling service was not found: (') + getRpcUrl(editor) + editor.translate(')');
	            errorCallback(message);
	          }
	        });
	      };
	    };
	    var sendRpcCall = function (editor, pluginUrl, currentLanguageState, name, data, successCallback, errorCallback) {
	      var userSpellcheckCallback = getSpellcheckerCallback(editor);
	      var spellCheckCallback = userSpellcheckCallback ? userSpellcheckCallback : defaultSpellcheckCallback(editor, pluginUrl, currentLanguageState);
	      spellCheckCallback.call(editor.plugins.spellchecker, name, data, successCallback, errorCallback);
	    };
	    var spellcheck = function (editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState) {
	      if (finish(editor, startedState, textMatcherState)) {
	        return;
	      }
	      var errorCallback = function (message) {
	        editor.notificationManager.open({
	          text: message,
	          type: 'error'
	        });
	        editor.setProgressState(false);
	        finish(editor, startedState, textMatcherState);
	      };
	      var successCallback = function (data) {
	        markErrors(editor, startedState, textMatcherState, lastSuggestionsState, data);
	      };
	      editor.setProgressState(true);
	      sendRpcCall(editor, pluginUrl, currentLanguageState, 'spellcheck', getTextMatcher(editor, textMatcherState).text, successCallback, errorCallback);
	      editor.focus();
	    };
	    var checkIfFinished = function (editor, startedState, textMatcherState) {
	      if (!editor.dom.select('span.mce-spellchecker-word').length) {
	        finish(editor, startedState, textMatcherState);
	      }
	    };
	    var addToDictionary = function (editor, pluginUrl, startedState, textMatcherState, currentLanguageState, word, spans) {
	      editor.setProgressState(true);
	      sendRpcCall(editor, pluginUrl, currentLanguageState, 'addToDictionary', word, function () {
	        editor.setProgressState(false);
	        editor.dom.remove(spans, true);
	        checkIfFinished(editor, startedState, textMatcherState);
	      }, function (message) {
	        editor.notificationManager.open({
	          text: message,
	          type: 'error'
	        });
	        editor.setProgressState(false);
	      });
	    };
	    var ignoreWord = function (editor, startedState, textMatcherState, word, spans, all) {
	      editor.selection.collapse();
	      if (all) {
	        global$1.each(editor.dom.select('span.mce-spellchecker-word'), function (span) {
	          if (span.getAttribute('data-mce-word') === word) {
	            editor.dom.remove(span, true);
	          }
	        });
	      } else {
	        editor.dom.remove(spans, true);
	      }
	      checkIfFinished(editor, startedState, textMatcherState);
	    };
	    var finish = function (editor, startedState, textMatcherState) {
	      var bookmark = editor.selection.getBookmark();
	      getTextMatcher(editor, textMatcherState).reset();
	      editor.selection.moveToBookmark(bookmark);
	      textMatcherState.set(null);
	      if (startedState.get()) {
	        startedState.set(false);
	        fireSpellcheckEnd(editor);
	        return true;
	      }
	    };
	    var getElmIndex = function (elm) {
	      var value = elm.getAttribute('data-mce-index');
	      if (typeof value === 'number') {
	        return '' + value;
	      }
	      return value;
	    };
	    var findSpansByIndex = function (editor, index) {
	      var spans = [];
	      var nodes = global$1.toArray(editor.getBody().getElementsByTagName('span'));
	      if (nodes.length) {
	        for (var i = 0; i < nodes.length; i++) {
	          var nodeIndex = getElmIndex(nodes[i]);
	          if (nodeIndex === null || !nodeIndex.length) {
	            continue;
	          }
	          if (nodeIndex === index.toString()) {
	            spans.push(nodes[i]);
	          }
	        }
	      }
	      return spans;
	    };
	    var markErrors = function (editor, startedState, textMatcherState, lastSuggestionsState, data) {
	      var hasDictionarySupport = !!data.dictionary;
	      var suggestions = data.words;
	      editor.setProgressState(false);
	      if (isEmpty(suggestions)) {
	        var message = editor.translate('No misspellings found.');
	        editor.notificationManager.open({
	          text: message,
	          type: 'info'
	        });
	        startedState.set(false);
	        return;
	      }
	      lastSuggestionsState.set({
	        suggestions: suggestions,
	        hasDictionarySupport: hasDictionarySupport
	      });
	      var bookmark = editor.selection.getBookmark();
	      getTextMatcher(editor, textMatcherState).find(getSpellcheckerWordcharPattern(editor)).filter(function (match) {
	        return !!suggestions[match.text];
	      }).wrap(function (match) {
	        return editor.dom.create('span', {
	          'class': 'mce-spellchecker-word',
	          'aria-invalid': 'spelling',
	          'data-mce-bogus': 1,
	          'data-mce-word': match.text
	        });
	      });
	      editor.selection.moveToBookmark(bookmark);
	      startedState.set(true);
	      fireSpellcheckStart(editor);
	    };
	
	    var get = function (editor, startedState, lastSuggestionsState, textMatcherState, currentLanguageState, _url) {
	      var getWordCharPattern = function () {
	        return getSpellcheckerWordcharPattern(editor);
	      };
	      var markErrors$1 = function (data) {
	        markErrors(editor, startedState, textMatcherState, lastSuggestionsState, data);
	      };
	      return {
	        getTextMatcher: textMatcherState.get,
	        getWordCharPattern: getWordCharPattern,
	        markErrors: markErrors$1,
	        getLanguage: currentLanguageState.get
	      };
	    };
	
	    var register = function (editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState) {
	      editor.addCommand('mceSpellCheck', function () {
	        spellcheck(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState);
	      });
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var spellcheckerEvents = 'SpellcheckStart SpellcheckEnd';
	    var buildMenuItems = function (listName, languageValues) {
	      var items = [];
	      global$1.each(languageValues, function (languageValue) {
	        items.push({
	          selectable: true,
	          text: languageValue.name,
	          data: languageValue.value
	        });
	      });
	      return items;
	    };
	    var getItems = function (editor) {
	      return global$1.map(getLanguages(editor).split(','), function (langPair) {
	        var langPairs = langPair.split('=');
	        return {
	          name: langPairs[0],
	          value: langPairs[1]
	        };
	      });
	    };
	    var register$1 = function (editor, pluginUrl, startedState, textMatcherState, currentLanguageState, lastSuggestionsState) {
	      var languageMenuItems = buildMenuItems('Language', getItems(editor));
	      var startSpellchecking = function () {
	        spellcheck(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState);
	      };
	      var buttonArgs = {
	        tooltip: 'Spellcheck',
	        onAction: startSpellchecking,
	        icon: 'spell-check',
	        onSetup: function (buttonApi) {
	          var setButtonState = function () {
	            buttonApi.setActive(startedState.get());
	          };
	          editor.on(spellcheckerEvents, setButtonState);
	          return function () {
	            editor.off(spellcheckerEvents, setButtonState);
	          };
	        }
	      };
	      var splitButtonArgs = __assign(__assign({}, buttonArgs), {
	        type: 'splitbutton',
	        select: function (value) {
	          return value === currentLanguageState.get();
	        },
	        fetch: function (callback) {
	          var items = global$1.map(languageMenuItems, function (languageItem) {
	            return {
	              type: 'choiceitem',
	              value: languageItem.data,
	              text: languageItem.text
	            };
	          });
	          callback(items);
	        },
	        onItemAction: function (splitButtonApi, value) {
	          currentLanguageState.set(value);
	        }
	      });
	      if (languageMenuItems.length > 1) {
	        editor.ui.registry.addSplitButton('spellchecker', splitButtonArgs);
	      } else {
	        editor.ui.registry.addToggleButton('spellchecker', buttonArgs);
	      }
	      editor.ui.registry.addToggleMenuItem('spellchecker', {
	        text: 'Spellcheck',
	        icon: 'spell-check',
	        onSetup: function (menuApi) {
	          menuApi.setActive(startedState.get());
	          var setMenuItemCheck = function () {
	            menuApi.setActive(startedState.get());
	          };
	          editor.on(spellcheckerEvents, setMenuItemCheck);
	          return function () {
	            editor.off(spellcheckerEvents, setMenuItemCheck);
	          };
	        },
	        onAction: startSpellchecking
	      });
	    };
	
	    var ignoreAll = true;
	    var getSuggestions = function (editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState, word, spans) {
	      var items = [];
	      var suggestions = lastSuggestionsState.get().suggestions[word];
	      global$1.each(suggestions, function (suggestion) {
	        items.push({
	          text: suggestion,
	          onAction: function () {
	            editor.insertContent(editor.dom.encode(suggestion));
	            editor.dom.remove(spans);
	            checkIfFinished(editor, startedState, textMatcherState);
	          }
	        });
	      });
	      var hasDictionarySupport = lastSuggestionsState.get().hasDictionarySupport;
	      if (hasDictionarySupport) {
	        items.push({ type: 'separator' });
	        items.push({
	          text: 'Add to dictionary',
	          onAction: function () {
	            addToDictionary(editor, pluginUrl, startedState, textMatcherState, currentLanguageState, word, spans);
	          }
	        });
	      }
	      items.push.apply(items, [
	        { type: 'separator' },
	        {
	          text: 'Ignore',
	          onAction: function () {
	            ignoreWord(editor, startedState, textMatcherState, word, spans);
	          }
	        },
	        {
	          text: 'Ignore all',
	          onAction: function () {
	            ignoreWord(editor, startedState, textMatcherState, word, spans, ignoreAll);
	          }
	        }
	      ]);
	      return items;
	    };
	    var setup = function (editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState) {
	      var update = function (element) {
	        var target = element;
	        if (target.className === 'mce-spellchecker-word') {
	          var spans = findSpansByIndex(editor, getElmIndex(target));
	          if (spans.length > 0) {
	            var rng = editor.dom.createRng();
	            rng.setStartBefore(spans[0]);
	            rng.setEndAfter(spans[spans.length - 1]);
	            editor.selection.setRng(rng);
	            return getSuggestions(editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState, target.getAttribute('data-mce-word'), spans);
	          }
	        } else {
	          return [];
	        }
	      };
	      editor.ui.registry.addContextMenu('spellchecker', { update: update });
	    };
	
	    function Plugin () {
	      global.add('spellchecker', function (editor, pluginUrl) {
	        if (hasProPlugin(editor) === false) {
	          var startedState = Cell(false);
	          var currentLanguageState = Cell(getLanguage(editor));
	          var textMatcherState = Cell(null);
	          var lastSuggestionsState = Cell(null);
	          register$1(editor, pluginUrl, startedState, textMatcherState, currentLanguageState, lastSuggestionsState);
	          setup(editor, pluginUrl, lastSuggestionsState, startedState, textMatcherState, currentLanguageState);
	          register(editor, pluginUrl, startedState, textMatcherState, lastSuggestionsState, currentLanguageState);
	          return get(editor, startedState, lastSuggestionsState, textMatcherState, currentLanguageState);
	        }
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "table" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/table')
	//   ES2015:
	//     import 'tinymce/plugins/table'
	__webpack_require__(1238);

/***/ },
/* 1238 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isBoolean = isSimpleType('boolean');
	    var isUndefined = eq(undefined);
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var range = function (num, f) {
	      var r = [];
	      for (var i = 0; i < num; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(i);
	        }
	      }
	      return Optional.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var pure = function (x) {
	      return [x];
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var get = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get(xs, 0);
	    };
	    var last = function (xs) {
	      return get(xs, xs.length - 1);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
	        s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	      return r;
	    }
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var contains$1 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim = blank(/^\s+|\s+$/g);
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$1(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$2 = function (userAgent, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, mediaMatch);
	    });
	    var detect$3 = function () {
	      return platform();
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var COMMENT = 8;
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var is = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
	    };
	
	    var eq$1 = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains$2 = function (e1, e2) {
	      return detect$3().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	    var is$1 = is;
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$1 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter$1 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each$1(obj, function (value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	    var values = function (obj) {
	      return mapToArray(obj, function (v) {
	        return v;
	      });
	    };
	    var size = function (obj) {
	      return keys(obj).length;
	    };
	    var get$1 = function (obj, key) {
	      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	    var isEmpty = function (r) {
	      for (var x in r) {
	        if (hasOwnProperty.call(r, x)) {
	          return false;
	        }
	      }
	      return true;
	    };
	
	    var validSectionList = [
	      'tfoot',
	      'thead',
	      'tbody',
	      'colgroup'
	    ];
	    var isValidSection = function (parentName) {
	      return contains(validSectionList, parentName);
	    };
	    var grid = function (rows, columns) {
	      return {
	        rows: rows,
	        columns: columns
	      };
	    };
	    var address = function (row, column) {
	      return {
	        row: row,
	        column: column
	      };
	    };
	    var detail = function (element, rowspan, colspan) {
	      return {
	        element: element,
	        rowspan: rowspan,
	        colspan: colspan
	      };
	    };
	    var detailnew = function (element, rowspan, colspan, isNew) {
	      return {
	        element: element,
	        rowspan: rowspan,
	        colspan: colspan,
	        isNew: isNew
	      };
	    };
	    var extended = function (element, rowspan, colspan, row, column, isLocked) {
	      return {
	        element: element,
	        rowspan: rowspan,
	        colspan: colspan,
	        row: row,
	        column: column,
	        isLocked: isLocked
	      };
	    };
	    var rowdata = function (element, cells, section) {
	      return {
	        element: element,
	        cells: cells,
	        section: section
	      };
	    };
	    var elementnew = function (element, isNew, isLocked) {
	      return {
	        element: element,
	        isNew: isNew,
	        isLocked: isLocked
	      };
	    };
	    var rowdatanew = function (element, cells, section, isNew) {
	      return {
	        element: element,
	        cells: cells,
	        section: section,
	        isNew: isNew
	      };
	    };
	    var rowcells = function (cells, section) {
	      return {
	        cells: cells,
	        section: section
	      };
	    };
	    var rowdetails = function (details, section) {
	      return {
	        details: details,
	        section: section
	      };
	    };
	    var bounds = function (startRow, startCol, finishRow, finishCol) {
	      return {
	        startRow: startRow,
	        startCol: startCol,
	        finishRow: finishRow,
	        finishCol: finishCol
	      };
	    };
	    var columnext = function (element, colspan, column) {
	      return {
	        element: element,
	        colspan: colspan,
	        column: column
	      };
	    };
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var name = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isComment = function (element) {
	      return type(element) === COMMENT || name(element) === '#comment';
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	    var isDocument = isType$1(DOCUMENT);
	    var isDocumentFragment = isType$1(DOCUMENT_FRAGMENT);
	    var isTag = function (tag) {
	      return function (e) {
	        return isElement(e) && name(e) === tag;
	      };
	    };
	
	    var owner = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner(dos);
	    };
	    var defaultView = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom;
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = SugarElement.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var offsetParent = function (element) {
	      return Optional.from(element.dom.offsetParent).map(SugarElement.fromDom);
	    };
	    var prevSibling = function (element) {
	      return Optional.from(element.dom.previousSibling).map(SugarElement.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	    var body = function () {
	      return getBody(SugarElement.fromDom(document));
	    };
	    var getBody = function (doc) {
	      var b = doc.dom.body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var ancestors = function (scope, predicate, isRoot) {
	      return filter(parents(scope, isRoot), predicate);
	    };
	    var children$1 = function (scope, predicate) {
	      return filter(children(scope), predicate);
	    };
	    var descendants = function (scope, predicate) {
	      var result = [];
	      each(children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    var ancestors$1 = function (scope, selector, isRoot) {
	      return ancestors(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var children$2 = function (scope, selector) {
	      return children$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	    var descendants$1 = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      if (is(scope, a)) {
	        return Optional.some(scope);
	      } else if (isFunction(isRoot) && isRoot(scope)) {
	        return Optional.none();
	      } else {
	        return ancestor(scope, a, isRoot);
	      }
	    }
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom;
	      var stop = isFunction(isRoot) ? isRoot : never;
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        if (predicate(el)) {
	          return Optional.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	    var child$1 = function (scope, predicate) {
	      var pred = function (node) {
	        return predicate(SugarElement.fromDom(node));
	      };
	      var result = find(scope.dom.childNodes, pred);
	      return result.map(SugarElement.fromDom);
	    };
	    var descendant = function (scope, predicate) {
	      var descend = function (node) {
	        for (var i = 0; i < node.childNodes.length; i++) {
	          var child_1 = SugarElement.fromDom(node.childNodes[i]);
	          if (predicate(child_1)) {
	            return Optional.some(child_1);
	          }
	          var res = descend(node.childNodes[i]);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope.dom);
	    };
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var child$2 = function (scope, selector) {
	      return child$1(scope, function (e) {
	        return is(e, selector);
	      });
	    };
	    var descendant$1 = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      var is$1 = function (element, selector) {
	        return is(element, selector);
	      };
	      return ClosestOrAncestor(is$1, ancestor$1, scope, selector, isRoot);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom;
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get$2 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var getOpt = function (element, key) {
	      return Optional.from(get$2(element, key));
	    };
	    var remove = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	    var clone = function (element) {
	      return foldl(element.dom.attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var isSupported$1 = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported$1(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var internalRemove = function (dom, property) {
	      if (isSupported$1(dom)) {
	        dom.style.removeProperty(property);
	      }
	    };
	    var set$1 = function (element, property, value) {
	      var dom = element.dom;
	      internalSet(dom, property, value);
	    };
	    var setAll$1 = function (element, css) {
	      var dom = element.dom;
	      each$1(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$3 = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom;
	      var raw = getUnsafeProperty(dom, property);
	      return Optional.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var remove$1 = function (element, property) {
	      var dom = element.dom;
	      internalRemove(dom, property);
	      if (getOpt(element, 'style').map(trim).is('')) {
	        remove(element, 'style');
	      }
	    };
	    var copy = function (source, target) {
	      var sourceDom = source.dom;
	      var targetDom = target.dom;
	      if (isSupported$1(sourceDom) && isSupported$1(targetDom)) {
	        targetDom.style.cssText = sourceDom.style.cssText;
	      }
	    };
	
	    var getAttrValue = function (cell, name, fallback) {
	      if (fallback === void 0) {
	        fallback = 0;
	      }
	      return getOpt(cell, name).map(function (value) {
	        return parseInt(value, 10);
	      }).getOr(fallback);
	    };
	    var getSpan = function (cell, type) {
	      return getAttrValue(cell, type, 1);
	    };
	    var hasColspan = function (cell) {
	      return getSpan(cell, 'colspan') > 1;
	    };
	    var hasRowspan = function (cell) {
	      return getSpan(cell, 'rowspan') > 1;
	    };
	    var getCssValue = function (element, property) {
	      return parseInt(get$3(element, property), 10);
	    };
	    var minWidth = constant(10);
	    var minHeight = constant(10);
	
	    var firstLayer = function (scope, selector) {
	      return filterFirstLayer(scope, selector, always);
	    };
	    var filterFirstLayer = function (scope, selector, predicate) {
	      return bind(children(scope), function (x) {
	        if (is(x, selector)) {
	          return predicate(x) ? [x] : [];
	        } else {
	          return filterFirstLayer(x, selector, predicate);
	        }
	      });
	    };
	
	    var lookup = function (tags, element, isRoot) {
	      if (isRoot === void 0) {
	        isRoot = never;
	      }
	      if (isRoot(element)) {
	        return Optional.none();
	      }
	      if (contains(tags, name(element))) {
	        return Optional.some(element);
	      }
	      var isRootOrUpperTable = function (elm) {
	        return is(elm, 'table') || isRoot(elm);
	      };
	      return ancestor$1(element, tags.join(','), isRootOrUpperTable);
	    };
	    var cell = function (element, isRoot) {
	      return lookup([
	        'td',
	        'th'
	      ], element, isRoot);
	    };
	    var cells = function (ancestor) {
	      return firstLayer(ancestor, 'th,td');
	    };
	    var columns = function (ancestor) {
	      if (is(ancestor, 'colgroup')) {
	        return children$2(ancestor, 'col');
	      } else {
	        return bind(columnGroups(ancestor), function (columnGroup) {
	          return children$2(columnGroup, 'col');
	        });
	      }
	    };
	    var table = function (element, isRoot) {
	      return closest$1(element, 'table', isRoot);
	    };
	    var rows = function (ancestor) {
	      return firstLayer(ancestor, 'tr');
	    };
	    var columnGroups = function (ancestor) {
	      return table(ancestor).fold(constant([]), function (table) {
	        return children$2(table, 'colgroup');
	      });
	    };
	
	    var fromRowsOrColGroups = function (elems, getSection) {
	      return map(elems, function (row) {
	        if (name(row) === 'colgroup') {
	          var cells$1 = map(columns(row), function (column) {
	            var colspan = getAttrValue(column, 'span', 1);
	            return detail(column, 1, colspan);
	          });
	          return rowdata(row, cells$1, 'colgroup');
	        } else {
	          var cells$1 = map(cells(row), function (cell) {
	            var rowspan = getAttrValue(cell, 'rowspan', 1);
	            var colspan = getAttrValue(cell, 'colspan', 1);
	            return detail(cell, rowspan, colspan);
	          });
	          return rowdata(row, cells$1, getSection(row));
	        }
	      });
	    };
	    var getParentSection = function (group) {
	      return parent(group).map(function (parent) {
	        var parentName = name(parent);
	        return isValidSection(parentName) ? parentName : 'tbody';
	      }).getOr('tbody');
	    };
	    var fromTable = function (table) {
	      var rows$1 = rows(table);
	      var columnGroups$1 = columnGroups(table);
	      var elems = __spreadArrays(columnGroups$1, rows$1);
	      return fromRowsOrColGroups(elems, getParentSection);
	    };
	    var fromPastedRows = function (elems, section) {
	      return fromRowsOrColGroups(elems, function () {
	        return section;
	      });
	    };
	
	    var addCells = function (gridRow, index, cells) {
	      var existingCells = gridRow.cells;
	      var before = existingCells.slice(0, index);
	      var after = existingCells.slice(index);
	      var newCells = before.concat(cells).concat(after);
	      return setCells(gridRow, newCells);
	    };
	    var addCell = function (gridRow, index, cell) {
	      return addCells(gridRow, index, [cell]);
	    };
	    var mutateCell = function (gridRow, index, cell) {
	      var cells = gridRow.cells;
	      cells[index] = cell;
	    };
	    var setCells = function (gridRow, cells) {
	      return rowcells(cells, gridRow.section);
	    };
	    var mapCells = function (gridRow, f) {
	      var cells = gridRow.cells;
	      var r = map(cells, f);
	      return rowcells(r, gridRow.section);
	    };
	    var getCell = function (gridRow, index) {
	      return gridRow.cells[index];
	    };
	    var getCellElement = function (gridRow, index) {
	      return getCell(gridRow, index).element;
	    };
	    var cellLength = function (gridRow) {
	      return gridRow.cells.length;
	    };
	    var extractGridDetails = function (grid) {
	      var result = partition(grid, function (row) {
	        return row.section === 'colgroup';
	      });
	      return {
	        rows: result.fail,
	        cols: result.pass
	      };
	    };
	
	    var LOCKED_COL_ATTR = 'data-snooker-locked-cols';
	    var getLockedColumnsFromTable = function (table) {
	      return getOpt(table, LOCKED_COL_ATTR).bind(function (lockedColStr) {
	        return Optional.from(lockedColStr.match(/\d+/g));
	      }).map(function (lockedCols) {
	        return mapToObject(lockedCols, always);
	      });
	    };
	    var getLockedColumnsFromGrid = function (grid) {
	      var locked = foldl(extractGridDetails(grid).rows, function (acc, row) {
	        each(row.cells, function (cell, idx) {
	          if (cell.isLocked) {
	            acc[idx] = true;
	          }
	        });
	        return acc;
	      }, {});
	      var lockedArr = mapToArray(locked, function (_val, key) {
	        return parseInt(key, 10);
	      });
	      return sort(lockedArr);
	    };
	
	    var key = function (row, column) {
	      return row + ',' + column;
	    };
	    var getAt = function (warehouse, row, column) {
	      var raw = warehouse.access[key(row, column)];
	      return raw !== undefined ? Optional.some(raw) : Optional.none();
	    };
	    var findItem = function (warehouse, item, comparator) {
	      var filtered = filterItems(warehouse, function (detail) {
	        return comparator(item, detail.element);
	      });
	      return filtered.length > 0 ? Optional.some(filtered[0]) : Optional.none();
	    };
	    var filterItems = function (warehouse, predicate) {
	      var all = bind(warehouse.all, function (r) {
	        return r.cells;
	      });
	      return filter(all, predicate);
	    };
	    var generateColumns = function (rowData) {
	      var columnsGroup = {};
	      var index = 0;
	      each(rowData.cells, function (column) {
	        var colspan = column.colspan;
	        range(colspan, function (columnIndex) {
	          var colIndex = index + columnIndex;
	          columnsGroup[colIndex] = columnext(column.element, colspan, colIndex);
	        });
	        index += colspan;
	      });
	      return columnsGroup;
	    };
	    var generate = function (list) {
	      var access = {};
	      var cells = [];
	      var columns = {};
	      var tableOpt = head(list).map(function (rowData) {
	        return rowData.element;
	      }).bind(table);
	      var lockedColumns = tableOpt.bind(getLockedColumnsFromTable).getOr({});
	      var maxRows = 0;
	      var maxColumns = 0;
	      var rowCount = 0;
	      each(list, function (rowData) {
	        if (rowData.section === 'colgroup') {
	          columns = generateColumns(rowData);
	        } else {
	          var currentRow_1 = [];
	          each(rowData.cells, function (rowCell) {
	            var start = 0;
	            while (access[key(rowCount, start)] !== undefined) {
	              start++;
	            }
	            var isLocked = hasNonNullableKey(lockedColumns, start.toString());
	            var current = extended(rowCell.element, rowCell.rowspan, rowCell.colspan, rowCount, start, isLocked);
	            for (var occupiedColumnPosition = 0; occupiedColumnPosition < rowCell.colspan; occupiedColumnPosition++) {
	              for (var occupiedRowPosition = 0; occupiedRowPosition < rowCell.rowspan; occupiedRowPosition++) {
	                var rowPosition = rowCount + occupiedRowPosition;
	                var columnPosition = start + occupiedColumnPosition;
	                var newpos = key(rowPosition, columnPosition);
	                access[newpos] = current;
	                maxColumns = Math.max(maxColumns, columnPosition + 1);
	              }
	            }
	            currentRow_1.push(current);
	          });
	          maxRows++;
	          cells.push(rowdata(rowData.element, currentRow_1, rowData.section));
	          rowCount++;
	        }
	      });
	      var grid$1 = grid(maxRows, maxColumns);
	      return {
	        grid: grid$1,
	        access: access,
	        all: cells,
	        columns: columns
	      };
	    };
	    var fromTable$1 = function (table) {
	      var list = fromTable(table);
	      return generate(list);
	    };
	    var justCells = function (warehouse) {
	      return bind(warehouse.all, function (w) {
	        return w.cells;
	      });
	    };
	    var justColumns = function (warehouse) {
	      return values(warehouse.columns);
	    };
	    var hasColumns = function (warehouse) {
	      return keys(warehouse.columns).length > 0;
	    };
	    var getColumnAt = function (warehouse, columnIndex) {
	      return Optional.from(warehouse.columns[columnIndex]);
	    };
	    var Warehouse = {
	      fromTable: fromTable$1,
	      generate: generate,
	      getAt: getAt,
	      findItem: findItem,
	      filterItems: filterItems,
	      justCells: justCells,
	      justColumns: justColumns,
	      hasColumns: hasColumns,
	      getColumnAt: getColumnAt
	    };
	
	    var inSelection = function (bounds, detail) {
	      var leftEdge = detail.column;
	      var rightEdge = detail.column + detail.colspan - 1;
	      var topEdge = detail.row;
	      var bottomEdge = detail.row + detail.rowspan - 1;
	      return leftEdge <= bounds.finishCol && rightEdge >= bounds.startCol && (topEdge <= bounds.finishRow && bottomEdge >= bounds.startRow);
	    };
	    var isWithin = function (bounds, detail) {
	      return detail.column >= bounds.startCol && detail.column + detail.colspan - 1 <= bounds.finishCol && detail.row >= bounds.startRow && detail.row + detail.rowspan - 1 <= bounds.finishRow;
	    };
	    var isRectangular = function (warehouse, bounds) {
	      var isRect = true;
	      var detailIsWithin = curry(isWithin, bounds);
	      for (var i = bounds.startRow; i <= bounds.finishRow; i++) {
	        for (var j = bounds.startCol; j <= bounds.finishCol; j++) {
	          isRect = isRect && Warehouse.getAt(warehouse, i, j).exists(detailIsWithin);
	        }
	      }
	      return isRect ? Optional.some(bounds) : Optional.none();
	    };
	
	    var getBounds = function (detailA, detailB) {
	      return bounds(Math.min(detailA.row, detailB.row), Math.min(detailA.column, detailB.column), Math.max(detailA.row + detailA.rowspan - 1, detailB.row + detailB.rowspan - 1), Math.max(detailA.column + detailA.colspan - 1, detailB.column + detailB.colspan - 1));
	    };
	    var getAnyBox = function (warehouse, startCell, finishCell) {
	      var startCoords = Warehouse.findItem(warehouse, startCell, eq$1);
	      var finishCoords = Warehouse.findItem(warehouse, finishCell, eq$1);
	      return startCoords.bind(function (sc) {
	        return finishCoords.map(function (fc) {
	          return getBounds(sc, fc);
	        });
	      });
	    };
	    var getBox = function (warehouse, startCell, finishCell) {
	      return getAnyBox(warehouse, startCell, finishCell).bind(function (bounds) {
	        return isRectangular(warehouse, bounds);
	      });
	    };
	
	    var moveBy = function (warehouse, cell, row, column) {
	      return Warehouse.findItem(warehouse, cell, eq$1).bind(function (detail) {
	        var startRow = row > 0 ? detail.row + detail.rowspan - 1 : detail.row;
	        var startCol = column > 0 ? detail.column + detail.colspan - 1 : detail.column;
	        var dest = Warehouse.getAt(warehouse, startRow + row, startCol + column);
	        return dest.map(function (d) {
	          return d.element;
	        });
	      });
	    };
	    var intercepts = function (warehouse, start, finish) {
	      return getAnyBox(warehouse, start, finish).map(function (bounds) {
	        var inside = Warehouse.filterItems(warehouse, curry(inSelection, bounds));
	        return map(inside, function (detail) {
	          return detail.element;
	        });
	      });
	    };
	    var parentCell = function (warehouse, innerCell) {
	      var isContainedBy = function (c1, c2) {
	        return contains$2(c2, c1);
	      };
	      return Warehouse.findItem(warehouse, innerCell, isContainedBy).map(function (detail) {
	        return detail.element;
	      });
	    };
	
	    var moveBy$1 = function (cell, deltaRow, deltaColumn) {
	      return table(cell).bind(function (table) {
	        var warehouse = getWarehouse(table);
	        return moveBy(warehouse, cell, deltaRow, deltaColumn);
	      });
	    };
	    var intercepts$1 = function (table, first, last) {
	      var warehouse = getWarehouse(table);
	      return intercepts(warehouse, first, last);
	    };
	    var nestedIntercepts = function (table, first, firstTable, last, lastTable) {
	      var warehouse = getWarehouse(table);
	      var optStartCell = eq$1(table, firstTable) ? Optional.some(first) : parentCell(warehouse, first);
	      var optLastCell = eq$1(table, lastTable) ? Optional.some(last) : parentCell(warehouse, last);
	      return optStartCell.bind(function (startCell) {
	        return optLastCell.bind(function (lastCell) {
	          return intercepts(warehouse, startCell, lastCell);
	        });
	      });
	    };
	    var getBox$1 = function (table, first, last) {
	      var warehouse = getWarehouse(table);
	      return getBox(warehouse, first, last);
	    };
	    var getWarehouse = Warehouse.fromTable;
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var after = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom.insertBefore(element.dom, v.dom);
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var wrap = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var after$1 = function (marker, elements) {
	      each(elements, function (x, i) {
	        var e = i === 0 ? marker : elements[i - 1];
	        after(e, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom.textContent = '';
	      each(children(element), function (rogue) {
	        remove$2(rogue);
	      });
	    };
	    var remove$2 = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove$2(wrapper);
	    };
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api = NodeValue(isText, 'text');
	    var get$4 = function (element) {
	      return api.get(element);
	    };
	    var getOption = function (element) {
	      return api.getOption(element);
	    };
	    var set$2 = function (element, value) {
	      return api.set(element, value);
	    };
	
	    var TagBoundaries = [
	      'body',
	      'p',
	      'div',
	      'article',
	      'aside',
	      'figcaption',
	      'figure',
	      'footer',
	      'header',
	      'nav',
	      'section',
	      'ol',
	      'ul',
	      'li',
	      'table',
	      'thead',
	      'tbody',
	      'tfoot',
	      'caption',
	      'tr',
	      'td',
	      'th',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'pre',
	      'address'
	    ];
	
	    function DomUniverse () {
	      var clone$1 = function (element) {
	        return SugarElement.fromDom(element.dom.cloneNode(false));
	      };
	      var document = function (element) {
	        return documentOrOwner(element).dom;
	      };
	      var isBoundary = function (element) {
	        if (!isElement(element)) {
	          return false;
	        }
	        if (name(element) === 'body') {
	          return true;
	        }
	        return contains(TagBoundaries, name(element));
	      };
	      var isEmptyTag = function (element) {
	        if (!isElement(element)) {
	          return false;
	        }
	        return contains([
	          'br',
	          'img',
	          'hr',
	          'input'
	        ], name(element));
	      };
	      var isNonEditable = function (element) {
	        return isElement(element) && get$2(element, 'contenteditable') === 'false';
	      };
	      var comparePosition = function (element, other) {
	        return element.dom.compareDocumentPosition(other.dom);
	      };
	      var copyAttributesTo = function (source, destination) {
	        var as = clone(source);
	        setAll(destination, as);
	      };
	      var isSpecial = function (element) {
	        var tag = name(element);
	        return contains([
	          'script',
	          'noscript',
	          'iframe',
	          'noframes',
	          'noembed',
	          'title',
	          'style',
	          'textarea',
	          'xmp'
	        ], tag);
	      };
	      return {
	        up: constant({
	          selector: ancestor$1,
	          closest: closest$1,
	          predicate: ancestor,
	          all: parents
	        }),
	        down: constant({
	          selector: descendants$1,
	          predicate: descendants
	        }),
	        styles: constant({
	          get: get$3,
	          getRaw: getRaw,
	          set: set$1,
	          remove: remove$1
	        }),
	        attrs: constant({
	          get: get$2,
	          set: set,
	          remove: remove,
	          copyTo: copyAttributesTo
	        }),
	        insert: constant({
	          before: before,
	          after: after,
	          afterAll: after$1,
	          append: append,
	          appendAll: append$1,
	          prepend: prepend,
	          wrap: wrap
	        }),
	        remove: constant({
	          unwrap: unwrap,
	          remove: remove$2
	        }),
	        create: constant({
	          nu: SugarElement.fromTag,
	          clone: clone$1,
	          text: SugarElement.fromText
	        }),
	        query: constant({
	          comparePosition: comparePosition,
	          prevSibling: prevSibling,
	          nextSibling: nextSibling
	        }),
	        property: constant({
	          children: children,
	          name: name,
	          parent: parent,
	          document: document,
	          isText: isText,
	          isComment: isComment,
	          isElement: isElement,
	          isSpecial: isSpecial,
	          getText: get$4,
	          setText: set$2,
	          isBoundary: isBoundary,
	          isEmptyTag: isEmptyTag,
	          isNonEditable: isNonEditable
	        }),
	        eq: eq$1,
	        is: is$1
	      };
	    }
	
	    var all$1 = function (universe, look, elements, f) {
	      var head = elements[0];
	      var tail = elements.slice(1);
	      return f(universe, look, head, tail);
	    };
	    var oneAll = function (universe, look, elements) {
	      return elements.length > 0 ? all$1(universe, look, elements, unsafeOne) : Optional.none();
	    };
	    var unsafeOne = function (universe, look, head, tail) {
	      var start = look(universe, head);
	      return foldr(tail, function (b, a) {
	        var current = look(universe, a);
	        return commonElement(universe, b, current);
	      }, start);
	    };
	    var commonElement = function (universe, start, end) {
	      return start.bind(function (s) {
	        return end.filter(curry(universe.eq, s));
	      });
	    };
	
	    var eq$2 = function (universe, item) {
	      return curry(universe.eq, item);
	    };
	    var ancestors$2 = function (universe, start, end, isRoot) {
	      if (isRoot === void 0) {
	        isRoot = never;
	      }
	      var ps1 = [start].concat(universe.up().all(start));
	      var ps2 = [end].concat(universe.up().all(end));
	      var prune = function (path) {
	        var index = findIndex(path, isRoot);
	        return index.fold(function () {
	          return path;
	        }, function (ind) {
	          return path.slice(0, ind + 1);
	        });
	      };
	      var pruned1 = prune(ps1);
	      var pruned2 = prune(ps2);
	      var shared = find(pruned1, function (x) {
	        return exists(pruned2, eq$2(universe, x));
	      });
	      return {
	        firstpath: pruned1,
	        secondpath: pruned2,
	        shared: shared
	      };
	    };
	
	    var sharedOne = oneAll;
	    var ancestors$3 = ancestors$2;
	
	    var universe = DomUniverse();
	    var sharedOne$1 = function (look, elements) {
	      return sharedOne(universe, function (_universe, element) {
	        return look(element);
	      }, elements);
	    };
	    var ancestors$4 = function (start, finish, isRoot) {
	      return ancestors$3(universe, start, finish, isRoot);
	    };
	
	    var lookupTable = function (container) {
	      return ancestor$1(container, 'table');
	    };
	    var identify = function (start, finish, isRoot) {
	      var getIsRoot = function (rootTable) {
	        return function (element) {
	          return isRoot !== undefined && isRoot(element) || eq$1(element, rootTable);
	        };
	      };
	      if (eq$1(start, finish)) {
	        return Optional.some({
	          boxes: Optional.some([start]),
	          start: start,
	          finish: finish
	        });
	      } else {
	        return lookupTable(start).bind(function (startTable) {
	          return lookupTable(finish).bind(function (finishTable) {
	            if (eq$1(startTable, finishTable)) {
	              return Optional.some({
	                boxes: intercepts$1(startTable, start, finish),
	                start: start,
	                finish: finish
	              });
	            } else if (contains$2(startTable, finishTable)) {
	              var ancestorCells = ancestors$1(finish, 'td,th', getIsRoot(startTable));
	              var finishCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : finish;
	              return Optional.some({
	                boxes: nestedIntercepts(startTable, start, startTable, finish, finishTable),
	                start: start,
	                finish: finishCell
	              });
	            } else if (contains$2(finishTable, startTable)) {
	              var ancestorCells = ancestors$1(start, 'td,th', getIsRoot(finishTable));
	              var startCell = ancestorCells.length > 0 ? ancestorCells[ancestorCells.length - 1] : start;
	              return Optional.some({
	                boxes: nestedIntercepts(finishTable, start, startTable, finish, finishTable),
	                start: start,
	                finish: startCell
	              });
	            } else {
	              return ancestors$4(start, finish).shared.bind(function (lca) {
	                return closest$1(lca, 'table', isRoot).bind(function (lcaTable) {
	                  var finishAncestorCells = ancestors$1(finish, 'td,th', getIsRoot(lcaTable));
	                  var finishCell = finishAncestorCells.length > 0 ? finishAncestorCells[finishAncestorCells.length - 1] : finish;
	                  var startAncestorCells = ancestors$1(start, 'td,th', getIsRoot(lcaTable));
	                  var startCell = startAncestorCells.length > 0 ? startAncestorCells[startAncestorCells.length - 1] : start;
	                  return Optional.some({
	                    boxes: nestedIntercepts(lcaTable, start, startTable, finish, finishTable),
	                    start: startCell,
	                    finish: finishCell
	                  });
	                });
	              });
	            }
	          });
	        });
	      }
	    };
	    var retrieve = function (container, selector) {
	      var sels = descendants$1(container, selector);
	      return sels.length > 0 ? Optional.some(sels) : Optional.none();
	    };
	    var getLast = function (boxes, lastSelectedSelector) {
	      return find(boxes, function (box) {
	        return is(box, lastSelectedSelector);
	      });
	    };
	    var getEdges = function (container, firstSelectedSelector, lastSelectedSelector) {
	      return descendant$1(container, firstSelectedSelector).bind(function (first) {
	        return descendant$1(container, lastSelectedSelector).bind(function (last) {
	          return sharedOne$1(lookupTable, [
	            first,
	            last
	          ]).map(function (table) {
	            return {
	              first: first,
	              last: last,
	              table: table
	            };
	          });
	        });
	      });
	    };
	    var expandTo = function (finish, firstSelectedSelector) {
	      return ancestor$1(finish, 'table').bind(function (table) {
	        return descendant$1(table, firstSelectedSelector).bind(function (start) {
	          return identify(start, finish).bind(function (identified) {
	            return identified.boxes.map(function (boxes) {
	              return {
	                boxes: boxes,
	                start: identified.start,
	                finish: identified.finish
	              };
	            });
	          });
	        });
	      });
	    };
	    var shiftSelection = function (boxes, deltaRow, deltaColumn, firstSelectedSelector, lastSelectedSelector) {
	      return getLast(boxes, lastSelectedSelector).bind(function (last) {
	        return moveBy$1(last, deltaRow, deltaColumn).bind(function (finish) {
	          return expandTo(finish, firstSelectedSelector);
	        });
	      });
	    };
	
	    var retrieve$1 = function (container, selector) {
	      return retrieve(container, selector);
	    };
	    var retrieveBox = function (container, firstSelectedSelector, lastSelectedSelector) {
	      return getEdges(container, firstSelectedSelector, lastSelectedSelector).bind(function (edges) {
	        var isRoot = function (ancestor) {
	          return eq$1(container, ancestor);
	        };
	        var sectionSelector = 'thead,tfoot,tbody,table';
	        var firstAncestor = ancestor$1(edges.first, sectionSelector, isRoot);
	        var lastAncestor = ancestor$1(edges.last, sectionSelector, isRoot);
	        return firstAncestor.bind(function (fA) {
	          return lastAncestor.bind(function (lA) {
	            return eq$1(fA, lA) ? getBox$1(edges.table, edges.first, edges.last) : Optional.none();
	          });
	        });
	      });
	    };
	
	    var generate$1 = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          var argLength = args.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              var foldArgs = [];
	              for (var _i = 0; _i < arguments.length; _i++) {
	                foldArgs[_i] = arguments[_i];
	              }
	              if (foldArgs.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
	              }
	              var target = foldArgs[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate$1 };
	
	    var type$1 = Adt.generate([
	      { none: [] },
	      { multiple: ['elements'] },
	      { single: ['element'] }
	    ]);
	    var cata = function (subject, onNone, onMultiple, onSingle) {
	      return subject.fold(onNone, onMultiple, onSingle);
	    };
	    var none$1 = type$1.none;
	    var multiple = type$1.multiple;
	    var single = type$1.single;
	
	    var Selections = function (lazyRoot, getStart, selectedSelector) {
	      var get = function () {
	        return retrieve$1(lazyRoot(), selectedSelector).fold(function () {
	          return getStart().map(single).getOrThunk(none$1);
	        }, function (cells) {
	          return multiple(cells);
	        });
	      };
	      return { get: get };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var clone$1 = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone$1(original, false);
	    };
	    var deep = function (original) {
	      return clone$1(original, true);
	    };
	    var shallowAs = function (original, tag) {
	      var nu = SugarElement.fromTag(tag);
	      var attributes = clone(original);
	      setAll(nu, attributes);
	      return nu;
	    };
	    var copy$1 = function (original, tag) {
	      var nu = shallowAs(original, tag);
	      var cloneChildren = children(deep(original));
	      append$1(nu, cloneChildren);
	      return nu;
	    };
	
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	    var bindFrom = function (a, f) {
	      return a !== undefined && a !== null ? f(a) : Optional.none();
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var Dimension = function (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom;
	        if (isSupported$1(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$3(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$3(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    };
	
	    var api$1 = Dimension('width', function (element) {
	      return element.dom.offsetWidth;
	    });
	    var get$5 = function (element) {
	      return api$1.get(element);
	    };
	    var getOuter = function (element) {
	      return api$1.getOuter(element);
	    };
	
	    var columns$1 = function (warehouse, isValidCell) {
	      if (isValidCell === void 0) {
	        isValidCell = always;
	      }
	      var grid = warehouse.grid;
	      var cols = range(grid.columns, identity);
	      var rowsArr = range(grid.rows, identity);
	      return map(cols, function (col) {
	        var getBlock = function () {
	          return bind(rowsArr, function (r) {
	            return Warehouse.getAt(warehouse, r, col).filter(function (detail) {
	              return detail.column === col;
	            }).toArray();
	          });
	        };
	        var isValid = function (detail) {
	          return detail.colspan === 1 && isValidCell(detail.element);
	        };
	        var getFallback = function () {
	          return Warehouse.getAt(warehouse, 0, col);
	        };
	        return decide(getBlock, isValid, getFallback);
	      });
	    };
	    var decide = function (getBlock, isValid, getFallback) {
	      var inBlock = getBlock();
	      var validInBlock = find(inBlock, isValid);
	      var detailOption = validInBlock.orThunk(function () {
	        return Optional.from(inBlock[0]).orThunk(getFallback);
	      });
	      return detailOption.map(function (detail) {
	        return detail.element;
	      });
	    };
	    var rows$1 = function (warehouse) {
	      var grid = warehouse.grid;
	      var rowsArr = range(grid.rows, identity);
	      var cols = range(grid.columns, identity);
	      return map(rowsArr, function (row) {
	        var getBlock = function () {
	          return bind(cols, function (c) {
	            return Warehouse.getAt(warehouse, row, c).filter(function (detail) {
	              return detail.row === row;
	            }).fold(constant([]), function (detail) {
	              return [detail];
	            });
	          });
	        };
	        var isSingle = function (detail) {
	          return detail.rowspan === 1;
	        };
	        var getFallback = function () {
	          return Warehouse.getAt(warehouse, row, 0);
	        };
	        return decide(getBlock, isSingle, getFallback);
	      });
	    };
	
	    var deduce = function (xs, index) {
	      if (index < 0 || index >= xs.length - 1) {
	        return Optional.none();
	      }
	      var current = xs[index].fold(function () {
	        var rest = reverse(xs.slice(0, index));
	        return findMap(rest, function (a, i) {
	          return a.map(function (aa) {
	            return {
	              value: aa,
	              delta: i + 1
	            };
	          });
	        });
	      }, function (c) {
	        return Optional.some({
	          value: c,
	          delta: 0
	        });
	      });
	      var next = xs[index + 1].fold(function () {
	        var rest = xs.slice(index + 1);
	        return findMap(rest, function (a, i) {
	          return a.map(function (aa) {
	            return {
	              value: aa,
	              delta: i + 1
	            };
	          });
	        });
	      }, function (n) {
	        return Optional.some({
	          value: n,
	          delta: 1
	        });
	      });
	      return current.bind(function (c) {
	        return next.map(function (n) {
	          var extras = n.delta + c.delta;
	          return Math.abs(n.value - c.value) / extras;
	        });
	      });
	    };
	
	    var onDirection = function (isLtr, isRtl) {
	      return function (element) {
	        return getDirection(element) === 'rtl' ? isRtl : isLtr;
	      };
	    };
	    var getDirection = function (element) {
	      return get$3(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
	    };
	
	    var api$2 = Dimension('height', function (element) {
	      var dom = element.dom;
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$6 = function (element) {
	      return api$2.get(element);
	    };
	    var getOuter$1 = function (element) {
	      return api$2.getOuter(element);
	    };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return SugarPosition(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      if (a !== undefined) {
	        return a;
	      } else {
	        return b !== undefined ? b : 0;
	      }
	    };
	    var absolute = function (element) {
	      var doc = element.dom.ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      if (body === element.dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport = function (element) {
	      var dom = element.dom;
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return SugarPosition(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var rowInfo = function (row, y) {
	      return {
	        row: row,
	        y: y
	      };
	    };
	    var colInfo = function (col, x) {
	      return {
	        col: col,
	        x: x
	      };
	    };
	    var rtlEdge = function (cell) {
	      var pos = absolute(cell);
	      return pos.left + getOuter(cell);
	    };
	    var ltrEdge = function (cell) {
	      return absolute(cell).left;
	    };
	    var getLeftEdge = function (index, cell) {
	      return colInfo(index, ltrEdge(cell));
	    };
	    var getRightEdge = function (index, cell) {
	      return colInfo(index, rtlEdge(cell));
	    };
	    var getTop = function (cell) {
	      return absolute(cell).top;
	    };
	    var getTopEdge = function (index, cell) {
	      return rowInfo(index, getTop(cell));
	    };
	    var getBottomEdge = function (index, cell) {
	      return rowInfo(index, getTop(cell) + getOuter$1(cell));
	    };
	    var findPositions = function (getInnerEdge, getOuterEdge, array) {
	      if (array.length === 0) {
	        return [];
	      }
	      var lines = map(array.slice(1), function (cellOption, index) {
	        return cellOption.map(function (cell) {
	          return getInnerEdge(index, cell);
	        });
	      });
	      var lastLine = array[array.length - 1].map(function (cell) {
	        return getOuterEdge(array.length - 1, cell);
	      });
	      return lines.concat([lastLine]);
	    };
	    var negate = function (step) {
	      return -step;
	    };
	    var height = {
	      delta: identity,
	      positions: function (optElements) {
	        return findPositions(getTopEdge, getBottomEdge, optElements);
	      },
	      edge: getTop
	    };
	    var ltr = {
	      delta: identity,
	      edge: ltrEdge,
	      positions: function (optElements) {
	        return findPositions(getLeftEdge, getRightEdge, optElements);
	      }
	    };
	    var rtl = {
	      delta: negate,
	      edge: rtlEdge,
	      positions: function (optElements) {
	        return findPositions(getRightEdge, getLeftEdge, optElements);
	      }
	    };
	    var detect$4 = onDirection(ltr, rtl);
	    var width = {
	      delta: function (amount, table) {
	        return detect$4(table).delta(amount, table);
	      },
	      positions: function (cols, table) {
	        return detect$4(table).positions(cols, table);
	      },
	      edge: function (cell) {
	        return detect$4(cell).edge(cell);
	      }
	    };
	
	    var units = {
	      unsupportedLength: [
	        'em',
	        'ex',
	        'cap',
	        'ch',
	        'ic',
	        'rem',
	        'lh',
	        'rlh',
	        'vw',
	        'vh',
	        'vi',
	        'vb',
	        'vmin',
	        'vmax',
	        'cm',
	        'mm',
	        'Q',
	        'in',
	        'pc',
	        'pt',
	        'px'
	      ],
	      fixed: [
	        'px',
	        'pt'
	      ],
	      relative: ['%'],
	      empty: ['']
	    };
	    var pattern = function () {
	      var decimalDigits = '[0-9]+';
	      var signedInteger = '[+-]?' + decimalDigits;
	      var exponentPart = '[eE]' + signedInteger;
	      var dot = '\\.';
	      var opt = function (input) {
	        return '(?:' + input + ')?';
	      };
	      var unsignedDecimalLiteral = [
	        'Infinity',
	        decimalDigits + dot + opt(decimalDigits) + opt(exponentPart),
	        dot + decimalDigits + opt(exponentPart),
	        decimalDigits + opt(exponentPart)
	      ].join('|');
	      var float = '[+-]?(?:' + unsignedDecimalLiteral + ')';
	      return new RegExp('^(' + float + ')(.*)$');
	    }();
	    var isUnit = function (unit, accepted) {
	      return exists(accepted, function (acc) {
	        return exists(units[acc], function (check) {
	          return unit === check;
	        });
	      });
	    };
	    var parse = function (input, accepted) {
	      var match = Optional.from(pattern.exec(input));
	      return match.bind(function (array) {
	        var value = Number(array[1]);
	        var unitRaw = array[2];
	        if (isUnit(unitRaw, accepted)) {
	          return Optional.some({
	            value: value,
	            unit: unitRaw
	          });
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	
	    var needManualCalc = function () {
	      var browser = detect$3().browser;
	      return browser.isIE() || browser.isEdge();
	    };
	    var toNumber = function (px, fallback) {
	      var num = parseFloat(px);
	      return isNaN(num) ? fallback : num;
	    };
	    var getProp = function (elm, name, fallback) {
	      return toNumber(get$3(elm, name), fallback);
	    };
	    var getCalculatedHeight = function (cell) {
	      var height = cell.dom.getBoundingClientRect().height;
	      var boxSizing = get$3(cell, 'box-sizing');
	      if (boxSizing === 'border-box') {
	        return height;
	      } else {
	        var paddingTop = getProp(cell, 'padding-top', 0);
	        var paddingBottom = getProp(cell, 'padding-bottom', 0);
	        var borderTop = getProp(cell, 'border-top-width', 0);
	        var borderBottom = getProp(cell, 'border-bottom-width', 0);
	        var borders = borderTop + borderBottom;
	        return height - paddingTop - paddingBottom - borders;
	      }
	    };
	    var getCalculatedWidth = function (cell) {
	      var width = cell.dom.getBoundingClientRect().width;
	      var boxSizing = get$3(cell, 'box-sizing');
	      if (boxSizing === 'border-box') {
	        return width;
	      } else {
	        var paddingLeft = getProp(cell, 'padding-left', 0);
	        var paddingRight = getProp(cell, 'padding-right', 0);
	        var borderLeft = getProp(cell, 'border-left-width', 0);
	        var borderRight = getProp(cell, 'border-right-width', 0);
	        var borders = borderLeft + borderRight;
	        return width - paddingLeft - paddingRight - borders;
	      }
	    };
	    var getHeight = function (cell) {
	      return needManualCalc() ? getCalculatedHeight(cell) : getProp(cell, 'height', get$6(cell));
	    };
	    var getWidth = function (cell) {
	      return needManualCalc() ? getCalculatedWidth(cell) : getProp(cell, 'width', get$5(cell));
	    };
	
	    var rPercentageBasedSizeRegex = /(\d+(\.\d+)?)%/;
	    var rPixelBasedSizeRegex = /(\d+(\.\d+)?)px|em/;
	    var getPercentSize = function (elm, getter) {
	      var relativeParent = offsetParent(elm).getOr(getBody(owner(elm)));
	      return getter(elm) / getter(relativeParent) * 100;
	    };
	    var setPixelWidth = function (cell, amount) {
	      set$1(cell, 'width', amount + 'px');
	    };
	    var setPercentageWidth = function (cell, amount) {
	      set$1(cell, 'width', amount + '%');
	    };
	    var setHeight = function (cell, amount) {
	      set$1(cell, 'height', amount + 'px');
	    };
	    var getHeightValue = function (cell) {
	      return getRaw(cell, 'height').getOrThunk(function () {
	        return getHeight(cell) + 'px';
	      });
	    };
	    var convert = function (cell, number, getter, setter) {
	      var newSize = table(cell).map(function (table) {
	        var total = getter(table);
	        return Math.floor(number / 100 * total);
	      }).getOr(number);
	      setter(cell, newSize);
	      return newSize;
	    };
	    var normalizePixelSize = function (value, cell, getter, setter) {
	      var number = parseInt(value, 10);
	      return endsWith(value, '%') && name(cell) !== 'table' ? convert(cell, number, getter, setter) : number;
	    };
	    var getTotalHeight = function (cell) {
	      var value = getHeightValue(cell);
	      if (!value) {
	        return get$6(cell);
	      }
	      return normalizePixelSize(value, cell, get$6, setHeight);
	    };
	    var get$7 = function (cell, type, f) {
	      var v = f(cell);
	      var span = getSpan(cell, type);
	      return v / span;
	    };
	    var getRawWidth = function (element) {
	      var cssWidth = getRaw(element, 'width');
	      return cssWidth.fold(function () {
	        return Optional.from(get$2(element, 'width'));
	      }, function (width) {
	        return Optional.some(width);
	      });
	    };
	    var normalizePercentageWidth = function (cellWidth, tableSize) {
	      return cellWidth / tableSize.pixelWidth() * 100;
	    };
	    var choosePercentageSize = function (element, width, tableSize) {
	      var percentMatch = rPercentageBasedSizeRegex.exec(width);
	      if (percentMatch !== null) {
	        return parseFloat(percentMatch[1]);
	      } else {
	        var intWidth = getWidth(element);
	        return normalizePercentageWidth(intWidth, tableSize);
	      }
	    };
	    var getPercentageWidth = function (cell, tableSize) {
	      var width = getRawWidth(cell);
	      return width.fold(function () {
	        var intWidth = get$5(cell);
	        return normalizePercentageWidth(intWidth, tableSize);
	      }, function (w) {
	        return choosePercentageSize(cell, w, tableSize);
	      });
	    };
	    var normalizePixelWidth = function (cellWidth, tableSize) {
	      return cellWidth / 100 * tableSize.pixelWidth();
	    };
	    var choosePixelSize = function (element, width, tableSize) {
	      var pixelMatch = rPixelBasedSizeRegex.exec(width);
	      if (pixelMatch !== null) {
	        return parseInt(pixelMatch[1], 10);
	      }
	      var percentMatch = rPercentageBasedSizeRegex.exec(width);
	      if (percentMatch !== null) {
	        var floatWidth = parseFloat(percentMatch[1]);
	        return normalizePixelWidth(floatWidth, tableSize);
	      }
	      return getWidth(element);
	    };
	    var getPixelWidth = function (cell, tableSize) {
	      var width = getRawWidth(cell);
	      return width.fold(function () {
	        return getWidth(cell);
	      }, function (w) {
	        return choosePixelSize(cell, w, tableSize);
	      });
	    };
	    var getHeight$1 = function (cell) {
	      return get$7(cell, 'rowspan', getTotalHeight);
	    };
	    var getGenericWidth = function (cell) {
	      var width = getRawWidth(cell);
	      return width.bind(function (w) {
	        return parse(w, [
	          'fixed',
	          'relative',
	          'empty'
	        ]);
	      });
	    };
	    var setGenericWidth = function (cell, amount, unit) {
	      set$1(cell, 'width', amount + unit);
	    };
	    var getPixelTableWidth = function (table) {
	      return get$5(table) + 'px';
	    };
	    var getPercentTableWidth = function (table) {
	      return getPercentSize(table, get$5) + '%';
	    };
	    var isPercentSizing = function (table) {
	      return getRawWidth(table).exists(function (size) {
	        return rPercentageBasedSizeRegex.test(size);
	      });
	    };
	    var isPixelSizing = function (table) {
	      return getRawWidth(table).exists(function (size) {
	        return rPixelBasedSizeRegex.test(size);
	      });
	    };
	    var isNoneSizing = function (table) {
	      return getRawWidth(table).isNone();
	    };
	    var percentageBasedSizeRegex = constant(rPercentageBasedSizeRegex);
	    var pixelBasedSizeRegex = constant(rPixelBasedSizeRegex);
	
	    var isCol = isTag('col');
	    var getRaw$1 = function (cell, property, getter) {
	      return getRaw(cell, property).fold(function () {
	        return getter(cell) + 'px';
	      }, function (raw) {
	        return raw;
	      });
	    };
	    var getRawW = function (cell, tableSize) {
	      var fallback = function (e) {
	        return isCol(e) ? get$5(e) : getPixelWidth(e, tableSize);
	      };
	      return getRaw$1(cell, 'width', fallback);
	    };
	    var getRawH = function (cell) {
	      return getRaw$1(cell, 'height', getHeight$1);
	    };
	    var justCols = function (warehouse) {
	      return map(Warehouse.justColumns(warehouse), function (column) {
	        return Optional.from(column.element);
	      });
	    };
	    var hasRawStyle = function (cell, prop) {
	      return getRaw(cell, prop).isSome();
	    };
	    var isValidColumn = function (cell) {
	      return !isCol(cell) || hasRawStyle(cell, 'width');
	    };
	    var getDimension = function (cellOpt, index, backups, filter, getter, fallback) {
	      return cellOpt.filter(filter).fold(function () {
	        return fallback(deduce(backups, index));
	      }, function (cell) {
	        return getter(cell);
	      });
	    };
	    var getWidthFrom = function (warehouse, table, getWidth, fallback, tableSize) {
	      var columnCells = columns$1(warehouse, function (cell) {
	        return hasRawStyle(cell, 'width');
	      });
	      var columns = Warehouse.hasColumns(warehouse) ? justCols(warehouse) : columnCells;
	      var backups = [Optional.some(width.edge(table))].concat(map(width.positions(columnCells, table), function (pos) {
	        return pos.map(function (p) {
	          return p.x;
	        });
	      }));
	      var colFilter = not(hasColspan);
	      return map(columns, function (cellOption, c) {
	        return getDimension(cellOption, c, backups, colFilter, function (column) {
	          if (isValidColumn(column)) {
	            return getWidth(column, tableSize);
	          } else {
	            var cell = bindFrom(columnCells[c], identity);
	            return getDimension(cell, c, backups, colFilter, function (cell) {
	              return fallback(Optional.some(get$5(cell)));
	            }, fallback);
	          }
	        }, fallback);
	      });
	    };
	    var getDeduced = function (deduced) {
	      return deduced.map(function (d) {
	        return d + 'px';
	      }).getOr('');
	    };
	    var getRawWidths = function (warehouse, table, tableSize) {
	      return getWidthFrom(warehouse, table, getRawW, getDeduced, tableSize);
	    };
	    var getPercentageWidths = function (warehouse, table, tableSize) {
	      return getWidthFrom(warehouse, table, getPercentageWidth, function (deduced) {
	        return deduced.fold(function () {
	          return tableSize.minCellWidth();
	        }, function (cellWidth) {
	          return cellWidth / tableSize.pixelWidth() * 100;
	        });
	      }, tableSize);
	    };
	    var getPixelWidths = function (warehouse, table, tableSize) {
	      return getWidthFrom(warehouse, table, getPixelWidth, function (deduced) {
	        return deduced.getOrThunk(tableSize.minCellWidth);
	      }, tableSize);
	    };
	    var getHeightFrom = function (warehouse, table, direction, getHeight, fallback) {
	      var rows = rows$1(warehouse);
	      var backups = [Optional.some(direction.edge(table))].concat(map(direction.positions(rows, table), function (pos) {
	        return pos.map(function (p) {
	          return p.y;
	        });
	      }));
	      return map(rows, function (cellOption, c) {
	        return getDimension(cellOption, c, backups, not(hasRowspan), getHeight, fallback);
	      });
	    };
	    var getPixelHeights = function (warehouse, table, direction) {
	      return getHeightFrom(warehouse, table, direction, getHeight$1, function (deduced) {
	        return deduced.getOrThunk(minHeight);
	      });
	    };
	    var getRawHeights = function (warehouse, table, direction) {
	      return getHeightFrom(warehouse, table, direction, getRawH, getDeduced);
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var noneSize = function (table) {
	      var getWidth = function () {
	        return get$5(table);
	      };
	      var zero = constant(0);
	      var getWidths = function (warehouse, tableSize) {
	        return getPixelWidths(warehouse, table, tableSize);
	      };
	      return {
	        width: getWidth,
	        pixelWidth: getWidth,
	        getWidths: getWidths,
	        getCellDelta: zero,
	        singleColumnWidth: constant([0]),
	        minCellWidth: zero,
	        setElementWidth: noop,
	        adjustTableWidth: noop,
	        isRelative: true,
	        label: 'none'
	      };
	    };
	    var percentageSize = function (initialWidth, table) {
	      var floatWidth = Cell(parseFloat(initialWidth));
	      var pixelWidth = Cell(get$5(table));
	      var getCellDelta = function (delta) {
	        return delta / pixelWidth.get() * 100;
	      };
	      var singleColumnWidth = function (w, _delta) {
	        return [100 - w];
	      };
	      var minCellWidth = function () {
	        return minWidth() / pixelWidth.get() * 100;
	      };
	      var adjustTableWidth = function (delta) {
	        var currentWidth = floatWidth.get();
	        var change = delta / 100 * currentWidth;
	        var newWidth = currentWidth + change;
	        setPercentageWidth(table, newWidth);
	        floatWidth.set(newWidth);
	        pixelWidth.set(get$5(table));
	      };
	      var getWidths = function (warehouse, tableSize) {
	        return getPercentageWidths(warehouse, table, tableSize);
	      };
	      return {
	        width: floatWidth.get,
	        pixelWidth: pixelWidth.get,
	        getWidths: getWidths,
	        getCellDelta: getCellDelta,
	        singleColumnWidth: singleColumnWidth,
	        minCellWidth: minCellWidth,
	        setElementWidth: setPercentageWidth,
	        adjustTableWidth: adjustTableWidth,
	        isRelative: true,
	        label: 'percent'
	      };
	    };
	    var pixelSize = function (initialWidth, table) {
	      var width = Cell(initialWidth);
	      var getWidth = width.get;
	      var getCellDelta = identity;
	      var singleColumnWidth = function (w, delta) {
	        var newNext = Math.max(minWidth(), w + delta);
	        return [newNext - w];
	      };
	      var adjustTableWidth = function (delta) {
	        var newWidth = getWidth() + delta;
	        setPixelWidth(table, newWidth);
	        width.set(newWidth);
	      };
	      var getWidths = function (warehouse, tableSize) {
	        return getPixelWidths(warehouse, table, tableSize);
	      };
	      return {
	        width: getWidth,
	        pixelWidth: getWidth,
	        getWidths: getWidths,
	        getCellDelta: getCellDelta,
	        singleColumnWidth: singleColumnWidth,
	        minCellWidth: minWidth,
	        setElementWidth: setPixelWidth,
	        adjustTableWidth: adjustTableWidth,
	        isRelative: false,
	        label: 'pixel'
	      };
	    };
	    var chooseSize = function (element, width) {
	      var percentMatch = percentageBasedSizeRegex().exec(width);
	      if (percentMatch !== null) {
	        return percentageSize(percentMatch[1], element);
	      }
	      var pixelMatch = pixelBasedSizeRegex().exec(width);
	      if (pixelMatch !== null) {
	        var intWidth = parseInt(pixelMatch[1], 10);
	        return pixelSize(intWidth, element);
	      }
	      var fallbackWidth = get$5(element);
	      return pixelSize(fallbackWidth, element);
	    };
	    var getTableSize = function (table) {
	      var width = getRawWidth(table);
	      return width.fold(function () {
	        return noneSize(table);
	      }, function (w) {
	        return chooseSize(table, w);
	      });
	    };
	    var TableSize = {
	      getTableSize: getTableSize,
	      pixelSize: pixelSize,
	      percentageSize: percentageSize,
	      noneSize: noneSize
	    };
	
	    var statsStruct = function (minRow, minCol, maxRow, maxCol, allCells, selectedCells) {
	      return {
	        minRow: minRow,
	        minCol: minCol,
	        maxRow: maxRow,
	        maxCol: maxCol,
	        allCells: allCells,
	        selectedCells: selectedCells
	      };
	    };
	    var findSelectedStats = function (house, isSelected) {
	      var totalColumns = house.grid.columns;
	      var totalRows = house.grid.rows;
	      var minRow = totalRows;
	      var minCol = totalColumns;
	      var maxRow = 0;
	      var maxCol = 0;
	      var allCells = [];
	      var selectedCells = [];
	      each$1(house.access, function (detail) {
	        allCells.push(detail);
	        if (isSelected(detail)) {
	          selectedCells.push(detail);
	          var startRow = detail.row;
	          var endRow = startRow + detail.rowspan - 1;
	          var startCol = detail.column;
	          var endCol = startCol + detail.colspan - 1;
	          if (startRow < minRow) {
	            minRow = startRow;
	          } else if (endRow > maxRow) {
	            maxRow = endRow;
	          }
	          if (startCol < minCol) {
	            minCol = startCol;
	          } else if (endCol > maxCol) {
	            maxCol = endCol;
	          }
	        }
	      });
	      return statsStruct(minRow, minCol, maxRow, maxCol, allCells, selectedCells);
	    };
	    var makeCell = function (list, seenSelected, rowIndex) {
	      var row = list[rowIndex].element;
	      var td = SugarElement.fromTag('td');
	      append(td, SugarElement.fromTag('br'));
	      var f = seenSelected ? append : prepend;
	      f(row, td);
	    };
	    var fillInGaps = function (list, house, stats, isSelected) {
	      var totalColumns = house.grid.columns;
	      var totalRows = house.grid.rows;
	      for (var i = 0; i < totalRows; i++) {
	        var seenSelected = false;
	        for (var j = 0; j < totalColumns; j++) {
	          if (!(i < stats.minRow || i > stats.maxRow || j < stats.minCol || j > stats.maxCol)) {
	            var needCell = Warehouse.getAt(house, i, j).filter(isSelected).isNone();
	            if (needCell) {
	              makeCell(list, seenSelected, i);
	            } else {
	              seenSelected = true;
	            }
	          }
	        }
	      }
	    };
	    var clean = function (replica, stats, house, widthDelta) {
	      each$1(house.columns, function (col) {
	        if (col.column < stats.minCol || col.column > stats.maxCol) {
	          remove$2(col.element);
	        }
	      });
	      var emptyRows = filter(firstLayer(replica, 'tr'), function (row) {
	        return row.dom.childElementCount === 0;
	      });
	      each(emptyRows, remove$2);
	      if (stats.minCol === stats.maxCol || stats.minRow === stats.maxRow) {
	        each(firstLayer(replica, 'th,td'), function (cell) {
	          remove(cell, 'rowspan');
	          remove(cell, 'colspan');
	        });
	      }
	      remove(replica, LOCKED_COL_ATTR);
	      remove(replica, 'data-snooker-col-series');
	      var tableSize = TableSize.getTableSize(replica);
	      tableSize.adjustTableWidth(widthDelta);
	    };
	    var getTableWidthDelta = function (table, warehouse, tableSize, stats) {
	      if (stats.minCol === 0 && warehouse.grid.columns === stats.maxCol + 1) {
	        return 0;
	      }
	      var colWidths = getPixelWidths(warehouse, table, tableSize);
	      var allColsWidth = foldl(colWidths, function (acc, width) {
	        return acc + width;
	      }, 0);
	      var selectedColsWidth = foldl(colWidths.slice(stats.minCol, stats.maxCol + 1), function (acc, width) {
	        return acc + width;
	      }, 0);
	      var newWidth = selectedColsWidth / allColsWidth * tableSize.pixelWidth();
	      var delta = newWidth - tableSize.pixelWidth();
	      return tableSize.getCellDelta(delta);
	    };
	    var extract = function (table, selectedSelector) {
	      var isSelected = function (detail) {
	        return is(detail.element, selectedSelector);
	      };
	      var replica = deep(table);
	      var list = fromTable(replica);
	      var tableSize = TableSize.getTableSize(table);
	      var replicaHouse = Warehouse.generate(list);
	      var replicaStats = findSelectedStats(replicaHouse, isSelected);
	      var selector = 'th:not(' + selectedSelector + ')' + ',td:not(' + selectedSelector + ')';
	      var unselectedCells = filterFirstLayer(replica, 'th,td', function (cell) {
	        return is(cell, selector);
	      });
	      each(unselectedCells, remove$2);
	      fillInGaps(list, replicaHouse, replicaStats, isSelected);
	      var house = Warehouse.fromTable(table);
	      var widthDelta = getTableWidthDelta(table, house, tableSize, replicaStats);
	      clean(replica, replicaStats, replicaHouse, widthDelta);
	      return replica;
	    };
	
	    var nbsp = '\xA0';
	
	    var getEnd = function (element) {
	      return name(element) === 'img' ? 1 : getOption(element).fold(function () {
	        return children(element).length;
	      }, function (v) {
	        return v.length;
	      });
	    };
	    var isTextNodeWithCursorPosition = function (el) {
	      return getOption(el).filter(function (text) {
	        return text.trim().length !== 0 || text.indexOf(nbsp) > -1;
	      }).isSome();
	    };
	    var elementsWithCursorPosition = [
	      'img',
	      'br'
	    ];
	    var isCursorPosition = function (elem) {
	      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
	      return hasCursorPosition || contains(elementsWithCursorPosition, name(elem));
	    };
	
	    var first = function (element) {
	      return descendant(element, isCursorPosition);
	    };
	    var last$1 = function (element) {
	      return descendantRtl(element, isCursorPosition);
	    };
	    var descendantRtl = function (scope, predicate) {
	      var descend = function (element) {
	        var children$1 = children(element);
	        for (var i = children$1.length - 1; i >= 0; i--) {
	          var child = children$1[i];
	          if (predicate(child)) {
	            return Optional.some(child);
	          }
	          var res = descend(child);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope);
	    };
	
	    var transferableAttributes = {
	      scope: [
	        'row',
	        'col'
	      ]
	    };
	    var createCell = function () {
	      var td = SugarElement.fromTag('td');
	      append(td, SugarElement.fromTag('br'));
	      return td;
	    };
	    var createCol = function () {
	      return SugarElement.fromTag('col');
	    };
	    var createColgroup = function () {
	      return SugarElement.fromTag('colgroup');
	    };
	    var replace = function (cell, tag, attrs) {
	      var replica = copy$1(cell, tag);
	      each$1(attrs, function (v, k) {
	        if (v === null) {
	          remove(replica, k);
	        } else {
	          set(replica, k, v);
	        }
	      });
	      return replica;
	    };
	    var pasteReplace = function (cell) {
	      return cell;
	    };
	    var newRow = function (doc) {
	      return function () {
	        return SugarElement.fromTag('tr', doc.dom);
	      };
	    };
	    var cloneFormats = function (oldCell, newCell, formats) {
	      var first$1 = first(oldCell);
	      return first$1.map(function (firstText) {
	        var formatSelector = formats.join(',');
	        var parents = ancestors$1(firstText, formatSelector, function (element) {
	          return eq$1(element, oldCell);
	        });
	        return foldr(parents, function (last, parent) {
	          var clonedFormat = shallow(parent);
	          remove(clonedFormat, 'contenteditable');
	          append(last, clonedFormat);
	          return clonedFormat;
	        }, newCell);
	      }).getOr(newCell);
	    };
	    var cloneAppropriateAttributes = function (original, clone) {
	      each$1(transferableAttributes, function (validAttributes, attributeName) {
	        return getOpt(original, attributeName).filter(function (attribute) {
	          return contains(validAttributes, attribute);
	        }).each(function (attribute) {
	          return set(clone, attributeName, attribute);
	        });
	      });
	    };
	    var cellOperations = function (mutate, doc, formatsToClone) {
	      var cloneCss = function (prev, clone) {
	        copy(prev.element, clone);
	        remove$1(clone, 'height');
	        if (prev.colspan !== 1) {
	          remove$1(clone, 'width');
	        }
	      };
	      var newCell = function (prev) {
	        var docu = owner(prev.element);
	        var td = SugarElement.fromTag(name(prev.element), docu.dom);
	        var formats = formatsToClone.getOr([
	          'strong',
	          'em',
	          'b',
	          'i',
	          'span',
	          'font',
	          'h1',
	          'h2',
	          'h3',
	          'h4',
	          'h5',
	          'h6',
	          'p',
	          'div'
	        ]);
	        var lastNode = formats.length > 0 ? cloneFormats(prev.element, td, formats) : td;
	        append(lastNode, SugarElement.fromTag('br'));
	        cloneCss(prev, td);
	        cloneAppropriateAttributes(prev.element, td);
	        mutate(prev.element, td);
	        return td;
	      };
	      var newCol = function (prev) {
	        var doc = owner(prev.element);
	        var col = SugarElement.fromTag(name(prev.element), doc.dom);
	        cloneCss(prev, col);
	        mutate(prev.element, col);
	        return col;
	      };
	      return {
	        col: newCol,
	        colgroup: createColgroup,
	        row: newRow(doc),
	        cell: newCell,
	        replace: replace,
	        gap: createCell
	      };
	    };
	    var paste = function (doc) {
	      return {
	        col: createCol,
	        colgroup: createColgroup,
	        row: newRow(doc),
	        cell: createCell,
	        replace: pasteReplace,
	        gap: createCell
	      };
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(SugarElement.fromDom(div));
	    };
	    var fromDom$1 = function (nodes) {
	      return map(nodes, SugarElement.fromDom);
	    };
	
	    var getNodeName = function (elm) {
	      return elm.nodeName.toLowerCase();
	    };
	    var getBody$1 = function (editor) {
	      return SugarElement.fromDom(editor.getBody());
	    };
	    var getPixelWidth$1 = function (elm) {
	      return elm.getBoundingClientRect().width;
	    };
	    var getPixelHeight = function (elm) {
	      return elm.getBoundingClientRect().height;
	    };
	    var getIsRoot = function (editor) {
	      return function (element) {
	        return eq$1(element, getBody$1(editor));
	      };
	    };
	    var removePxSuffix = function (size) {
	      return size ? size.replace(/px$/, '') : '';
	    };
	    var addPxSuffix = function (size) {
	      return /^\d+(\.\d+)?$/.test(size) ? size + 'px' : size;
	    };
	    var removeDataStyle = function (table) {
	      remove(table, 'data-mce-style');
	      var removeStyleAttribute = function (element) {
	        return remove(element, 'data-mce-style');
	      };
	      each(cells(table), removeStyleAttribute);
	      each(columns(table), removeStyleAttribute);
	    };
	    var getRawWidth$1 = function (editor, elm) {
	      var raw = editor.dom.getStyle(elm, 'width') || editor.dom.getAttrib(elm, 'width');
	      return Optional.from(raw).filter(isNotEmpty);
	    };
	    var isPercentage = function (value) {
	      return /^(\d+(\.\d+)?)%$/.test(value);
	    };
	    var isPixel = function (value) {
	      return /^(\d+(\.\d+)?)px$/.test(value);
	    };
	    var getSelectionStart = function (editor) {
	      return SugarElement.fromDom(editor.selection.getStart());
	    };
	
	    var selection = function (selections) {
	      return cata(selections.get(), constant([]), identity, pure);
	    };
	    var unmergable = function (selections) {
	      var hasSpan = function (elem, type) {
	        return getOpt(elem, type).exists(function (span) {
	          return parseInt(span, 10) > 1;
	        });
	      };
	      var hasRowOrColSpan = function (elem) {
	        return hasSpan(elem, 'rowspan') || hasSpan(elem, 'colspan');
	      };
	      var candidates = selection(selections);
	      return candidates.length > 0 && forall(candidates, hasRowOrColSpan) ? Optional.some(candidates) : Optional.none();
	    };
	    var mergable = function (table, selections, ephemera) {
	      return cata(selections.get(), Optional.none, function (cells) {
	        if (cells.length <= 1) {
	          return Optional.none();
	        } else {
	          return retrieveBox(table, ephemera.firstSelectedSelector, ephemera.lastSelectedSelector).map(function (bounds) {
	            return {
	              bounds: bounds,
	              cells: cells
	            };
	          });
	        }
	      }, Optional.none);
	    };
	
	    var strSelected = 'data-mce-selected';
	    var strSelectedSelector = 'td[' + strSelected + '],th[' + strSelected + ']';
	    var strAttributeSelector = '[' + strSelected + ']';
	    var strFirstSelected = 'data-mce-first-selected';
	    var strFirstSelectedSelector = 'td[' + strFirstSelected + '],th[' + strFirstSelected + ']';
	    var strLastSelected = 'data-mce-last-selected';
	    var strLastSelectedSelector = 'td[' + strLastSelected + '],th[' + strLastSelected + ']';
	    var attributeSelector = strAttributeSelector;
	    var ephemera = {
	      selected: strSelected,
	      selectedSelector: strSelectedSelector,
	      firstSelected: strFirstSelected,
	      firstSelectedSelector: strFirstSelectedSelector,
	      lastSelected: strLastSelected,
	      lastSelectedSelector: strLastSelectedSelector
	    };
	
	    var noMenu = function (cell) {
	      return {
	        element: cell,
	        mergable: Optional.none(),
	        unmergable: Optional.none(),
	        selection: [cell]
	      };
	    };
	    var forMenu = function (selections, table, cell) {
	      return {
	        element: cell,
	        mergable: mergable(table, selections, ephemera),
	        unmergable: unmergable(selections),
	        selection: selection(selections)
	      };
	    };
	    var paste$1 = function (element, clipboard, generators) {
	      return {
	        element: element,
	        clipboard: clipboard,
	        generators: generators
	      };
	    };
	    var pasteRows = function (selections, cell, clipboard, generators) {
	      return {
	        selection: selection(selections),
	        clipboard: clipboard,
	        generators: generators
	      };
	    };
	
	    var extractSelected = function (cells) {
	      return table(cells[0]).map(function (table) {
	        var replica = extract(table, attributeSelector);
	        removeDataStyle(replica);
	        return [replica];
	      });
	    };
	    var serializeElements = function (editor, elements) {
	      return map(elements, function (elm) {
	        return editor.selection.serializer.serialize(elm.dom, {});
	      }).join('');
	    };
	    var getTextContent = function (elements) {
	      return map(elements, function (element) {
	        return element.dom.innerText;
	      }).join('');
	    };
	    var registerEvents = function (editor, selections, actions, cellSelection) {
	      editor.on('BeforeGetContent', function (e) {
	        var multiCellContext = function (cells) {
	          e.preventDefault();
	          extractSelected(cells).each(function (elements) {
	            e.content = e.format === 'text' ? getTextContent(elements) : serializeElements(editor, elements);
	          });
	        };
	        if (e.selection === true) {
	          cata(selections.get(), noop, multiCellContext, noop);
	        }
	      });
	      editor.on('BeforeSetContent', function (e) {
	        if (e.selection === true && e.paste === true) {
	          var cellOpt = Optional.from(editor.dom.getParent(editor.selection.getStart(), 'th,td'));
	          cellOpt.each(function (domCell) {
	            var cell = SugarElement.fromDom(domCell);
	            table(cell).each(function (table) {
	              var elements = filter(fromHtml$1(e.content), function (content) {
	                return name(content) !== 'meta';
	              });
	              var isTable = function (elm) {
	                return name(elm) === 'table';
	              };
	              if (elements.length === 1 && isTable(elements[0])) {
	                e.preventDefault();
	                var doc = SugarElement.fromDom(editor.getDoc());
	                var generators = paste(doc);
	                var targets = paste$1(cell, elements[0], generators);
	                actions.pasteCells(table, targets).each(function (data) {
	                  editor.selection.setRng(data.rng);
	                  editor.focus();
	                  cellSelection.clear(table);
	                });
	              }
	            });
	          });
	        }
	      });
	    };
	
	    var adt = Adt.generate([
	      { none: [] },
	      { only: ['index'] },
	      {
	        left: [
	          'index',
	          'next'
	        ]
	      },
	      {
	        middle: [
	          'prev',
	          'index',
	          'next'
	        ]
	      },
	      {
	        right: [
	          'prev',
	          'index'
	        ]
	      }
	    ]);
	    var ColumnContext = __assign({}, adt);
	
	    var neighbours = function (input, index) {
	      if (input.length === 0) {
	        return ColumnContext.none();
	      }
	      if (input.length === 1) {
	        return ColumnContext.only(0);
	      }
	      if (index === 0) {
	        return ColumnContext.left(0, 1);
	      }
	      if (index === input.length - 1) {
	        return ColumnContext.right(index - 1, index);
	      }
	      if (index > 0 && index < input.length - 1) {
	        return ColumnContext.middle(index - 1, index, index + 1);
	      }
	      return ColumnContext.none();
	    };
	    var determine = function (input, column, step, tableSize, resize) {
	      var result = input.slice(0);
	      var context = neighbours(input, column);
	      var onNone = constant(map(result, constant(0)));
	      var onOnly = function (index) {
	        return tableSize.singleColumnWidth(result[index], step);
	      };
	      var onLeft = function (index, next) {
	        return resize.calcLeftEdgeDeltas(result, index, next, step, tableSize.minCellWidth(), tableSize.isRelative);
	      };
	      var onMiddle = function (prev, index, next) {
	        return resize.calcMiddleDeltas(result, prev, index, next, step, tableSize.minCellWidth(), tableSize.isRelative);
	      };
	      var onRight = function (prev, index) {
	        return resize.calcRightEdgeDeltas(result, prev, index, step, tableSize.minCellWidth(), tableSize.isRelative);
	      };
	      return context.fold(onNone, onOnly, onLeft, onMiddle, onRight);
	    };
	
	    var total = function (start, end, measures) {
	      var r = 0;
	      for (var i = start; i < end; i++) {
	        r += measures[i] !== undefined ? measures[i] : 0;
	      }
	      return r;
	    };
	    var recalculateWidthForCells = function (warehouse, widths) {
	      var all = Warehouse.justCells(warehouse);
	      return map(all, function (cell) {
	        var width = total(cell.column, cell.column + cell.colspan, widths);
	        return {
	          element: cell.element,
	          width: width,
	          colspan: cell.colspan
	        };
	      });
	    };
	    var recalculateWidthForColumns = function (warehouse, widths) {
	      var groups = Warehouse.justColumns(warehouse);
	      return map(groups, function (column, index) {
	        return {
	          element: column.element,
	          width: widths[index],
	          colspan: column.colspan
	        };
	      });
	    };
	    var recalculateHeightForCells = function (warehouse, heights) {
	      var all = Warehouse.justCells(warehouse);
	      return map(all, function (cell) {
	        var height = total(cell.row, cell.row + cell.rowspan, heights);
	        return {
	          element: cell.element,
	          height: height,
	          rowspan: cell.rowspan
	        };
	      });
	    };
	    var matchRowHeight = function (warehouse, heights) {
	      return map(warehouse.all, function (row, i) {
	        return {
	          element: row.element,
	          height: heights[i]
	        };
	      });
	    };
	
	    var sumUp = function (newSize) {
	      return foldr(newSize, function (b, a) {
	        return b + a;
	      }, 0);
	    };
	    var recalculate = function (warehouse, widths) {
	      if (Warehouse.hasColumns(warehouse)) {
	        return recalculateWidthForColumns(warehouse, widths);
	      } else {
	        return recalculateWidthForCells(warehouse, widths);
	      }
	    };
	    var recalculateAndApply = function (warehouse, widths, tableSize) {
	      var newSizes = recalculate(warehouse, widths);
	      each(newSizes, function (cell) {
	        tableSize.setElementWidth(cell.element, cell.width);
	      });
	    };
	    var adjustWidth = function (table, delta, index, resizing, tableSize) {
	      var warehouse = Warehouse.fromTable(table);
	      var step = tableSize.getCellDelta(delta);
	      var widths = tableSize.getWidths(warehouse, tableSize);
	      var isLastColumn = index === warehouse.grid.columns - 1;
	      var clampedStep = resizing.clampTableDelta(widths, index, step, tableSize.minCellWidth(), isLastColumn);
	      var deltas = determine(widths, index, clampedStep, tableSize, resizing);
	      var newWidths = map(deltas, function (dx, i) {
	        return dx + widths[i];
	      });
	      recalculateAndApply(warehouse, newWidths, tableSize);
	      resizing.resizeTable(tableSize.adjustTableWidth, clampedStep, isLastColumn);
	    };
	    var adjustHeight = function (table, delta, index, direction) {
	      var warehouse = Warehouse.fromTable(table);
	      var heights = getPixelHeights(warehouse, table, direction);
	      var newHeights = map(heights, function (dy, i) {
	        return index === i ? Math.max(delta + dy, minHeight()) : dy;
	      });
	      var newCellSizes = recalculateHeightForCells(warehouse, newHeights);
	      var newRowSizes = matchRowHeight(warehouse, newHeights);
	      each(newRowSizes, function (row) {
	        setHeight(row.element, row.height);
	      });
	      each(newCellSizes, function (cell) {
	        setHeight(cell.element, cell.height);
	      });
	      var total = sumUp(newHeights);
	      setHeight(table, total);
	    };
	    var adjustAndRedistributeWidths = function (_table, list, details, tableSize, resizeBehaviour) {
	      var warehouse = Warehouse.generate(list);
	      var sizes = tableSize.getWidths(warehouse, tableSize);
	      var tablePixelWidth = tableSize.pixelWidth();
	      var _a = resizeBehaviour.calcRedestributedWidths(sizes, tablePixelWidth, details.pixelDelta, tableSize.isRelative), newSizes = _a.newSizes, delta = _a.delta;
	      recalculateAndApply(warehouse, newSizes, tableSize);
	      tableSize.adjustTableWidth(delta);
	    };
	    var adjustWidthTo = function (_table, list, _info, tableSize) {
	      var warehouse = Warehouse.generate(list);
	      var widths = tableSize.getWidths(warehouse, tableSize);
	      recalculateAndApply(warehouse, widths, tableSize);
	    };
	
	    var zero = function (array) {
	      return map(array, constant(0));
	    };
	    var surround = function (sizes, startIndex, endIndex, results, f) {
	      return f(sizes.slice(0, startIndex)).concat(results).concat(f(sizes.slice(endIndex)));
	    };
	    var clampDeltaHelper = function (predicate) {
	      return function (sizes, index, delta, minCellSize) {
	        if (!predicate(delta)) {
	          return delta;
	        } else {
	          var newSize = Math.max(minCellSize, sizes[index] - Math.abs(delta));
	          var diff = Math.abs(newSize - sizes[index]);
	          return delta >= 0 ? diff : -diff;
	        }
	      };
	    };
	    var clampNegativeDelta = clampDeltaHelper(function (delta) {
	      return delta < 0;
	    });
	    var clampDelta = clampDeltaHelper(always);
	    var resizeTable = function () {
	      var calcFixedDeltas = function (sizes, index, next, delta, minCellSize) {
	        var clampedDelta = clampNegativeDelta(sizes, index, delta, minCellSize);
	        return surround(sizes, index, next + 1, [
	          clampedDelta,
	          0
	        ], zero);
	      };
	      var calcRelativeDeltas = function (sizes, index, delta, minCellSize) {
	        var ratio = (100 + delta) / 100;
	        var newThis = Math.max(minCellSize, (sizes[index] + delta) / ratio);
	        return map(sizes, function (size, idx) {
	          var newSize = idx === index ? newThis : size / ratio;
	          return newSize - size;
	        });
	      };
	      var calcLeftEdgeDeltas = function (sizes, index, next, delta, minCellSize, isRelative) {
	        if (isRelative) {
	          return calcRelativeDeltas(sizes, index, delta, minCellSize);
	        } else {
	          return calcFixedDeltas(sizes, index, next, delta, minCellSize);
	        }
	      };
	      var calcMiddleDeltas = function (sizes, _prev, index, next, delta, minCellSize, isRelative) {
	        return calcLeftEdgeDeltas(sizes, index, next, delta, minCellSize, isRelative);
	      };
	      var resizeTable = function (resizer, delta) {
	        return resizer(delta);
	      };
	      var calcRightEdgeDeltas = function (sizes, _prev, index, delta, minCellSize, isRelative) {
	        if (isRelative) {
	          return calcRelativeDeltas(sizes, index, delta, minCellSize);
	        } else {
	          var clampedDelta = clampNegativeDelta(sizes, index, delta, minCellSize);
	          return zero(sizes.slice(0, index)).concat([clampedDelta]);
	        }
	      };
	      var calcRedestributedWidths = function (sizes, totalWidth, pixelDelta, isRelative) {
	        if (isRelative) {
	          var tableWidth = totalWidth + pixelDelta;
	          var ratio_1 = tableWidth / totalWidth;
	          var newSizes = map(sizes, function (size) {
	            return size / ratio_1;
	          });
	          return {
	            delta: ratio_1 * 100 - 100,
	            newSizes: newSizes
	          };
	        } else {
	          return {
	            delta: pixelDelta,
	            newSizes: sizes
	          };
	        }
	      };
	      return {
	        resizeTable: resizeTable,
	        clampTableDelta: clampNegativeDelta,
	        calcLeftEdgeDeltas: calcLeftEdgeDeltas,
	        calcMiddleDeltas: calcMiddleDeltas,
	        calcRightEdgeDeltas: calcRightEdgeDeltas,
	        calcRedestributedWidths: calcRedestributedWidths
	      };
	    };
	    var preserveTable = function () {
	      var calcLeftEdgeDeltas = function (sizes, index, next, delta, minCellSize) {
	        var idx = delta >= 0 ? next : index;
	        var clampedDelta = clampDelta(sizes, idx, delta, minCellSize);
	        return surround(sizes, index, next + 1, [
	          clampedDelta,
	          -clampedDelta
	        ], zero);
	      };
	      var calcMiddleDeltas = function (sizes, _prev, index, next, delta, minCellSize) {
	        return calcLeftEdgeDeltas(sizes, index, next, delta, minCellSize);
	      };
	      var resizeTable = function (resizer, delta, isLastColumn) {
	        if (isLastColumn) {
	          resizer(delta);
	        }
	      };
	      var calcRightEdgeDeltas = function (sizes, _prev, _index, delta, _minCellSize, isRelative) {
	        if (isRelative) {
	          return zero(sizes);
	        } else {
	          var diff = delta / sizes.length;
	          return map(sizes, constant(diff));
	        }
	      };
	      var clampTableDelta = function (sizes, index, delta, minCellSize, isLastColumn) {
	        if (isLastColumn) {
	          if (delta >= 0) {
	            return delta;
	          } else {
	            var maxDelta = foldl(sizes, function (a, b) {
	              return a + b - minCellSize;
	            }, 0);
	            return Math.max(-maxDelta, delta);
	          }
	        } else {
	          return clampNegativeDelta(sizes, index, delta, minCellSize);
	        }
	      };
	      var calcRedestributedWidths = function (sizes, _totalWidth, _pixelDelta, _isRelative) {
	        return {
	          delta: 0,
	          newSizes: sizes
	        };
	      };
	      return {
	        resizeTable: resizeTable,
	        clampTableDelta: clampTableDelta,
	        calcLeftEdgeDeltas: calcLeftEdgeDeltas,
	        calcMiddleDeltas: calcMiddleDeltas,
	        calcRightEdgeDeltas: calcRightEdgeDeltas,
	        calcRedestributedWidths: calcRedestributedWidths
	      };
	    };
	
	    var only = function (element, isResizable) {
	      var parent = Optional.from(element.dom.documentElement).map(SugarElement.fromDom).getOr(element);
	      return {
	        parent: constant(parent),
	        view: constant(element),
	        origin: constant(SugarPosition(0, 0)),
	        isResizable: isResizable
	      };
	    };
	    var detached = function (editable, chrome, isResizable) {
	      var origin = function () {
	        return absolute(chrome);
	      };
	      return {
	        parent: constant(chrome),
	        view: constant(editable),
	        origin: origin,
	        isResizable: isResizable
	      };
	    };
	    var body$1 = function (editable, chrome, isResizable) {
	      return {
	        parent: constant(chrome),
	        view: constant(editable),
	        origin: constant(SugarPosition(0, 0)),
	        isResizable: isResizable
	      };
	    };
	    var ResizeWire = {
	      only: only,
	      detached: detached,
	      body: body$1
	    };
	
	    var adt$1 = Adt.generate([
	      { invalid: ['raw'] },
	      { pixels: ['value'] },
	      { percent: ['value'] }
	    ]);
	    var validateFor = function (suffix, type, value) {
	      var rawAmount = value.substring(0, value.length - suffix.length);
	      var amount = parseFloat(rawAmount);
	      return rawAmount === amount.toString() ? type(amount) : adt$1.invalid(value);
	    };
	    var from$1 = function (value) {
	      if (endsWith(value, '%')) {
	        return validateFor('%', adt$1.percent, value);
	      }
	      if (endsWith(value, 'px')) {
	        return validateFor('px', adt$1.pixels, value);
	      }
	      return adt$1.invalid(value);
	    };
	    var Size = __assign(__assign({}, adt$1), { from: from$1 });
	
	    var redistributeToPercent = function (widths, totalWidth) {
	      return map(widths, function (w) {
	        var colType = Size.from(w);
	        return colType.fold(function () {
	          return w;
	        }, function (px) {
	          var ratio = px / totalWidth * 100;
	          return ratio + '%';
	        }, function (pc) {
	          return pc + '%';
	        });
	      });
	    };
	    var redistributeToPx = function (widths, totalWidth, newTotalWidth) {
	      var scale = newTotalWidth / totalWidth;
	      return map(widths, function (w) {
	        var colType = Size.from(w);
	        return colType.fold(function () {
	          return w;
	        }, function (px) {
	          return px * scale + 'px';
	        }, function (pc) {
	          return pc / 100 * newTotalWidth + 'px';
	        });
	      });
	    };
	    var redistributeEmpty = function (newWidthType, columns) {
	      var f = newWidthType.fold(function () {
	        return constant('');
	      }, function (pixels) {
	        var num = pixels / columns;
	        return constant(num + 'px');
	      }, function () {
	        var num = 100 / columns;
	        return constant(num + '%');
	      });
	      return range(columns, f);
	    };
	    var redistributeValues = function (newWidthType, widths, totalWidth) {
	      return newWidthType.fold(function () {
	        return widths;
	      }, function (px) {
	        return redistributeToPx(widths, totalWidth, px);
	      }, function (_pc) {
	        return redistributeToPercent(widths, totalWidth);
	      });
	    };
	    var redistribute = function (widths, totalWidth, newWidth) {
	      var newType = Size.from(newWidth);
	      var floats = forall(widths, function (s) {
	        return s === '0px';
	      }) ? redistributeEmpty(newType, widths.length) : redistributeValues(newType, widths, totalWidth);
	      return normalize(floats);
	    };
	    var sum = function (values, fallback) {
	      if (values.length === 0) {
	        return fallback;
	      }
	      return foldr(values, function (rest, v) {
	        return Size.from(v).fold(constant(0), identity, identity) + rest;
	      }, 0);
	    };
	    var roundDown = function (num, unit) {
	      var floored = Math.floor(num);
	      return {
	        value: floored + unit,
	        remainder: num - floored
	      };
	    };
	    var add = function (value, amount) {
	      return Size.from(value).fold(constant(value), function (px) {
	        return px + amount + 'px';
	      }, function (pc) {
	        return pc + amount + '%';
	      });
	    };
	    var normalize = function (values) {
	      if (values.length === 0) {
	        return values;
	      }
	      var scan = foldr(values, function (rest, value) {
	        var info = Size.from(value).fold(function () {
	          return {
	            value: value,
	            remainder: 0
	          };
	        }, function (num) {
	          return roundDown(num, 'px');
	        }, function (num) {
	          return {
	            value: num + '%',
	            remainder: 0
	          };
	        });
	        return {
	          output: [info.value].concat(rest.output),
	          remainder: rest.remainder + info.remainder
	        };
	      }, {
	        output: [],
	        remainder: 0
	      });
	      var r = scan.output;
	      return r.slice(0, r.length - 1).concat([add(r[r.length - 1], Math.round(scan.remainder))]);
	    };
	    var validate = Size.from;
	
	    var redistributeToW = function (newWidths, cells, unit) {
	      each(cells, function (cell) {
	        var widths = newWidths.slice(cell.column, cell.colspan + cell.column);
	        var w = sum(widths, minWidth());
	        set$1(cell.element, 'width', w + unit);
	      });
	    };
	    var redistributeToColumns = function (newWidths, columns, unit) {
	      each(columns, function (column, index) {
	        var width = sum([newWidths[index]], minWidth());
	        set$1(column.element, 'width', width + unit);
	      });
	    };
	    var redistributeToH = function (newHeights, rows, cells, unit) {
	      each(cells, function (cell) {
	        var heights = newHeights.slice(cell.row, cell.rowspan + cell.row);
	        var h = sum(heights, minHeight());
	        set$1(cell.element, 'height', h + unit);
	      });
	      each(rows, function (row, i) {
	        set$1(row.element, 'height', newHeights[i]);
	      });
	    };
	    var getUnit = function (newSize) {
	      return validate(newSize).fold(constant('px'), constant('px'), constant('%'));
	    };
	    var redistribute$1 = function (table, optWidth, optHeight, tableSize) {
	      var warehouse = Warehouse.fromTable(table);
	      var rows = warehouse.all;
	      var cells = Warehouse.justCells(warehouse);
	      var columns = Warehouse.justColumns(warehouse);
	      optWidth.each(function (newWidth) {
	        var widthUnit = getUnit(newWidth);
	        var totalWidth = get$5(table);
	        var oldWidths = getRawWidths(warehouse, table, tableSize);
	        var nuWidths = redistribute(oldWidths, totalWidth, newWidth);
	        if (Warehouse.hasColumns(warehouse)) {
	          redistributeToColumns(nuWidths, columns, widthUnit);
	        } else {
	          redistributeToW(nuWidths, cells, widthUnit);
	        }
	        set$1(table, 'width', newWidth);
	      });
	      optHeight.each(function (newHeight) {
	        var hUnit = getUnit(newHeight);
	        var totalHeight = get$6(table);
	        var oldHeights = getRawHeights(warehouse, table, height);
	        var nuHeights = redistribute(oldHeights, totalHeight, newHeight);
	        redistributeToH(nuHeights, rows, cells, hUnit);
	        set$1(table, 'height', newHeight);
	      });
	    };
	    var isPercentSizing$1 = isPercentSizing;
	    var isPixelSizing$1 = isPixelSizing;
	    var isNoneSizing$1 = isNoneSizing;
	    var getPercentTableWidth$1 = getPercentTableWidth;
	
	    var getGridSize = function (table) {
	      var warehouse = Warehouse.fromTable(table);
	      return warehouse.grid;
	    };
	
	    var Event = function (fields) {
	      var handlers = [];
	      var bind = function (handler) {
	        if (handler === undefined) {
	          throw new Error('Event bind error: undefined handler');
	        }
	        handlers.push(handler);
	      };
	      var unbind = function (handler) {
	        handlers = filter(handlers, function (h) {
	          return h !== handler;
	        });
	      };
	      var trigger = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        var event = {};
	        each(fields, function (name, i) {
	          event[name] = args[i];
	        });
	        each(handlers, function (handler) {
	          handler(event);
	        });
	      };
	      return {
	        bind: bind,
	        unbind: unbind,
	        trigger: trigger
	      };
	    };
	
	    var create = function (typeDefs) {
	      var registry = map$1(typeDefs, function (event) {
	        return {
	          bind: event.bind,
	          unbind: event.unbind
	        };
	      });
	      var trigger = map$1(typeDefs, function (event) {
	        return event.trigger;
	      });
	      return {
	        registry: registry,
	        trigger: trigger
	      };
	    };
	
	    var last$2 = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          clearTimeout(timer);
	        }
	        timer = setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var sort$1 = function (arr) {
	      return arr.slice(0).sort();
	    };
	    var reqMessage = function (required, keys) {
	      throw new Error('All required keys (' + sort$1(required).join(', ') + ') were not specified. Specified keys were: ' + sort$1(keys).join(', ') + '.');
	    };
	    var unsuppMessage = function (unsupported) {
	      throw new Error('Unsupported keys for object: ' + sort$1(unsupported).join(', '));
	    };
	    var validateStrArr = function (label, array) {
	      if (!isArray(array)) {
	        throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
	      }
	      each(array, function (a) {
	        if (!isString(a)) {
	          throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
	        }
	      });
	    };
	    var invalidTypeMessage = function (incorrect, type) {
	      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort$1(incorrect).join(', ') + ') were not.');
	    };
	    var checkDupes = function (everything) {
	      var sorted = sort$1(everything);
	      var dupe = find(sorted, function (s, i) {
	        return i < sorted.length - 1 && s === sorted[i + 1];
	      });
	      dupe.each(function (d) {
	        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
	      });
	    };
	
	    var base = function (handleUnsupported, required) {
	      return baseWith(handleUnsupported, required, {
	        validate: isFunction,
	        label: 'function'
	      });
	    };
	    var baseWith = function (handleUnsupported, required, pred) {
	      if (required.length === 0) {
	        throw new Error('You must specify at least one required field.');
	      }
	      validateStrArr('required', required);
	      checkDupes(required);
	      return function (obj) {
	        var keys$1 = keys(obj);
	        var allReqd = forall(required, function (req) {
	          return contains(keys$1, req);
	        });
	        if (!allReqd) {
	          reqMessage(required, keys$1);
	        }
	        handleUnsupported(required, keys$1);
	        var invalidKeys = filter(required, function (key) {
	          return !pred.validate(obj[key], key);
	        });
	        if (invalidKeys.length > 0) {
	          invalidTypeMessage(invalidKeys, pred.label);
	        }
	        return obj;
	      };
	    };
	    var handleExact = function (required, keys) {
	      var unsupported = filter(keys, function (key) {
	        return !contains(required, key);
	      });
	      if (unsupported.length > 0) {
	        unsuppMessage(unsupported);
	      }
	    };
	    var exactly = function (required) {
	      return base(handleExact, required);
	    };
	
	    var DragMode = exactly([
	      'compare',
	      'extract',
	      'mutate',
	      'sink'
	    ]);
	    var DragSink = exactly([
	      'element',
	      'start',
	      'stop',
	      'destroy'
	    ]);
	    var DragApi = exactly([
	      'forceDrop',
	      'drop',
	      'move',
	      'delayDrop'
	    ]);
	
	    var InDrag = function () {
	      var previous = Optional.none();
	      var reset = function () {
	        previous = Optional.none();
	      };
	      var update = function (mode, nu) {
	        var result = previous.map(function (old) {
	          return mode.compare(old, nu);
	        });
	        previous = Optional.some(nu);
	        return result;
	      };
	      var onEvent = function (event, mode) {
	        var dataOption = mode.extract(event);
	        dataOption.each(function (data) {
	          var offset = update(mode, data);
	          offset.each(function (d) {
	            events.trigger.move(d);
	          });
	        });
	      };
	      var events = create({ move: Event(['info']) });
	      return {
	        onEvent: onEvent,
	        reset: reset,
	        events: events.registry
	      };
	    };
	
	    var NoDrag = function () {
	      var events = create({ move: Event(['info']) });
	      return {
	        onEvent: noop,
	        reset: noop,
	        events: events.registry
	      };
	    };
	
	    var Movement = function () {
	      var noDragState = NoDrag();
	      var inDragState = InDrag();
	      var dragState = noDragState;
	      var on = function () {
	        dragState.reset();
	        dragState = inDragState;
	      };
	      var off = function () {
	        dragState.reset();
	        dragState = noDragState;
	      };
	      var onEvent = function (event, mode) {
	        dragState.onEvent(event, mode);
	      };
	      var isOn = function () {
	        return dragState === inDragState;
	      };
	      return {
	        on: on,
	        off: off,
	        isOn: isOn,
	        onEvent: onEvent,
	        events: inDragState.events
	      };
	    };
	
	    var setup = function (mutation, mode, settings) {
	      var active = false;
	      var events = create({
	        start: Event([]),
	        stop: Event([])
	      });
	      var movement = Movement();
	      var drop = function () {
	        sink.stop();
	        if (movement.isOn()) {
	          movement.off();
	          events.trigger.stop();
	        }
	      };
	      var throttledDrop = last$2(drop, 200);
	      var go = function (parent) {
	        sink.start(parent);
	        movement.on();
	        events.trigger.start();
	      };
	      var mousemove = function (event) {
	        throttledDrop.cancel();
	        movement.onEvent(event, mode);
	      };
	      movement.events.move.bind(function (event) {
	        mode.mutate(mutation, event.info);
	      });
	      var on = function () {
	        active = true;
	      };
	      var off = function () {
	        active = false;
	      };
	      var runIfActive = function (f) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          if (active) {
	            f.apply(null, args);
	          }
	        };
	      };
	      var sink = mode.sink(DragApi({
	        forceDrop: drop,
	        drop: runIfActive(drop),
	        move: runIfActive(mousemove),
	        delayDrop: runIfActive(throttledDrop.throttle)
	      }), settings);
	      var destroy = function () {
	        sink.destroy();
	      };
	      return {
	        element: sink.element,
	        go: go,
	        on: on,
	        off: off,
	        destroy: destroy,
	        events: events.registry
	      };
	    };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: target,
	        x: x,
	        y: y,
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: raw
	      };
	    };
	    var fromRawEvent = function (rawEvent) {
	      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
	      var stop = function () {
	        return rawEvent.stopPropagation();
	      };
	      var prevent = function () {
	        return rawEvent.preventDefault();
	      };
	      var kill = compose(prevent, stop);
	      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	    };
	    var handle = function (filter, handler) {
	      return function (rawEvent) {
	        if (filter(rawEvent)) {
	          handler(fromRawEvent(rawEvent));
	        }
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle(filter, handler);
	      element.dom.addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$1 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom.removeEventListener(event, handler, useCapture);
	    };
	
	    var filter$2 = always;
	    var bind$2 = function (element, event, handler) {
	      return bind$1(element, event, filter$2, handler);
	    };
	    var fromRawEvent$1 = fromRawEvent;
	
	    var read = function (element, attr) {
	      var value = get$2(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add$1 = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$3 = function (element, attr, id) {
	      var nu = filter(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set(element, attr, nu.join(' '));
	      } else {
	        remove(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get$8 = function (element) {
	      return read(element, 'class');
	    };
	    var add$2 = function (element, clazz) {
	      return add$1(element, 'class', clazz);
	    };
	    var remove$4 = function (element, clazz) {
	      return remove$3(element, 'class', clazz);
	    };
	
	    var add$3 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$2(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get$8(element);
	      if (classList.length === 0) {
	        remove(element, 'class');
	      }
	    };
	    var remove$5 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$4(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has$1 = function (element, clazz) {
	      return supports(element) && element.dom.classList.contains(clazz);
	    };
	
	    var css = function (namespace) {
	      var dashNamespace = namespace.replace(/\./g, '-');
	      var resolve = function (str) {
	        return dashNamespace + '-' + str;
	      };
	      return { resolve: resolve };
	    };
	
	    var styles = css('ephox-dragster');
	    var resolve = styles.resolve;
	
	    var Blocker = function (options) {
	      var settings = __assign({ layerClass: resolve('blocker') }, options);
	      var div = SugarElement.fromTag('div');
	      set(div, 'role', 'presentation');
	      setAll$1(div, {
	        position: 'fixed',
	        left: '0px',
	        top: '0px',
	        width: '100%',
	        height: '100%'
	      });
	      add$3(div, resolve('blocker'));
	      add$3(div, settings.layerClass);
	      var element = function () {
	        return div;
	      };
	      var destroy = function () {
	        remove$2(div);
	      };
	      return {
	        element: element,
	        destroy: destroy
	      };
	    };
	
	    var compare = function (old, nu) {
	      return SugarPosition(nu.left - old.left, nu.top - old.top);
	    };
	    var extract$1 = function (event) {
	      return Optional.some(SugarPosition(event.x, event.y));
	    };
	    var mutate = function (mutation, info) {
	      mutation.mutate(info.left, info.top);
	    };
	    var sink = function (dragApi, settings) {
	      var blocker = Blocker(settings);
	      var mdown = bind$2(blocker.element(), 'mousedown', dragApi.forceDrop);
	      var mup = bind$2(blocker.element(), 'mouseup', dragApi.drop);
	      var mmove = bind$2(blocker.element(), 'mousemove', dragApi.move);
	      var mout = bind$2(blocker.element(), 'mouseout', dragApi.delayDrop);
	      var destroy = function () {
	        blocker.destroy();
	        mup.unbind();
	        mmove.unbind();
	        mout.unbind();
	        mdown.unbind();
	      };
	      var start = function (parent) {
	        append(parent, blocker.element());
	      };
	      var stop = function () {
	        remove$2(blocker.element());
	      };
	      return DragSink({
	        element: blocker.element,
	        start: start,
	        stop: stop,
	        destroy: destroy
	      });
	    };
	    var MouseDrag = DragMode({
	      compare: compare,
	      extract: extract$1,
	      sink: sink,
	      mutate: mutate
	    });
	
	    var transform = function (mutation, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var mode = settings.mode !== undefined ? settings.mode : MouseDrag;
	      return setup(mutation, mode, settings);
	    };
	
	    var isContentEditableTrue = function (elm) {
	      return get$2(elm, 'contenteditable') === 'true';
	    };
	    var findClosestContentEditable = function (target, isRoot) {
	      return closest$1(target, '[contenteditable]', isRoot);
	    };
	
	    var styles$1 = css('ephox-snooker');
	    var resolve$1 = styles$1.resolve;
	
	    var Mutation = function () {
	      var events = create({
	        drag: Event([
	          'xDelta',
	          'yDelta'
	        ])
	      });
	      var mutate = function (x, y) {
	        events.trigger.drag(x, y);
	      };
	      return {
	        mutate: mutate,
	        events: events.registry
	      };
	    };
	
	    var BarMutation = function () {
	      var events = create({
	        drag: Event([
	          'xDelta',
	          'yDelta',
	          'target'
	        ])
	      });
	      var target = Optional.none();
	      var delegate = Mutation();
	      delegate.events.drag.bind(function (event) {
	        target.each(function (t) {
	          events.trigger.drag(event.xDelta, event.yDelta, t);
	        });
	      });
	      var assign = function (t) {
	        target = Optional.some(t);
	      };
	      var get = function () {
	        return target;
	      };
	      return {
	        assign: assign,
	        get: get,
	        mutate: delegate.mutate,
	        events: events.registry
	      };
	    };
	
	    var col = function (column, x, y, w, h) {
	      var bar = SugarElement.fromTag('div');
	      setAll$1(bar, {
	        position: 'absolute',
	        left: x - w / 2 + 'px',
	        top: y + 'px',
	        height: h + 'px',
	        width: w + 'px'
	      });
	      setAll(bar, {
	        'data-column': column,
	        'role': 'presentation'
	      });
	      return bar;
	    };
	    var row = function (r, x, y, w, h) {
	      var bar = SugarElement.fromTag('div');
	      setAll$1(bar, {
	        position: 'absolute',
	        left: x + 'px',
	        top: y - h / 2 + 'px',
	        height: h + 'px',
	        width: w + 'px'
	      });
	      setAll(bar, {
	        'data-row': r,
	        'role': 'presentation'
	      });
	      return bar;
	    };
	
	    var resizeBar = resolve$1('resizer-bar');
	    var resizeRowBar = resolve$1('resizer-rows');
	    var resizeColBar = resolve$1('resizer-cols');
	    var BAR_THICKNESS = 7;
	    var resizableRows = function (warehouse, isResizable) {
	      return bind(warehouse.all, function (row, i) {
	        return isResizable(row.element) ? [i] : [];
	      });
	    };
	    var resizableColumns = function (warehouse, isResizable) {
	      var resizableCols = [];
	      range(warehouse.grid.columns, function (index) {
	        var colElmOpt = Warehouse.getColumnAt(warehouse, index).map(function (col) {
	          return col.element;
	        });
	        if (colElmOpt.forall(isResizable)) {
	          resizableCols.push(index);
	        }
	      });
	      return filter(resizableCols, function (colIndex) {
	        var columnCells = Warehouse.filterItems(warehouse, function (cell) {
	          return cell.column === colIndex;
	        });
	        return forall(columnCells, function (cell) {
	          return isResizable(cell.element);
	        });
	      });
	    };
	    var destroy = function (wire) {
	      var previous = descendants$1(wire.parent(), '.' + resizeBar);
	      each(previous, remove$2);
	    };
	    var drawBar = function (wire, positions, create) {
	      var origin = wire.origin();
	      each(positions, function (cpOption) {
	        cpOption.each(function (cp) {
	          var bar = create(origin, cp);
	          add$3(bar, resizeBar);
	          append(wire.parent(), bar);
	        });
	      });
	    };
	    var refreshCol = function (wire, colPositions, position, tableHeight) {
	      drawBar(wire, colPositions, function (origin, cp) {
	        var colBar = col(cp.col, cp.x - origin.left, position.top - origin.top, BAR_THICKNESS, tableHeight);
	        add$3(colBar, resizeColBar);
	        return colBar;
	      });
	    };
	    var refreshRow = function (wire, rowPositions, position, tableWidth) {
	      drawBar(wire, rowPositions, function (origin, cp) {
	        var rowBar = row(cp.row, position.left - origin.left, cp.y - origin.top, tableWidth, BAR_THICKNESS);
	        add$3(rowBar, resizeRowBar);
	        return rowBar;
	      });
	    };
	    var refreshGrid = function (warhouse, wire, table, rows, cols) {
	      var position = absolute(table);
	      var isResizable = wire.isResizable;
	      var rowPositions = rows.length > 0 ? height.positions(rows, table) : [];
	      var resizableRowBars = rowPositions.length > 0 ? resizableRows(warhouse, isResizable) : [];
	      var resizableRowPositions = filter(rowPositions, function (_pos, i) {
	        return exists(resizableRowBars, function (barIndex) {
	          return i === barIndex;
	        });
	      });
	      refreshRow(wire, resizableRowPositions, position, getOuter(table));
	      var colPositions = cols.length > 0 ? width.positions(cols, table) : [];
	      var resizableColBars = colPositions.length > 0 ? resizableColumns(warhouse, isResizable) : [];
	      var resizableColPositions = filter(colPositions, function (_pos, i) {
	        return exists(resizableColBars, function (barIndex) {
	          return i === barIndex;
	        });
	      });
	      refreshCol(wire, resizableColPositions, position, getOuter$1(table));
	    };
	    var refresh = function (wire, table) {
	      destroy(wire);
	      if (wire.isResizable(table)) {
	        var warehouse = Warehouse.fromTable(table);
	        var rows = rows$1(warehouse);
	        var cols = columns$1(warehouse);
	        refreshGrid(warehouse, wire, table, rows, cols);
	      }
	    };
	    var each$2 = function (wire, f) {
	      var bars = descendants$1(wire.parent(), '.' + resizeBar);
	      each(bars, f);
	    };
	    var hide = function (wire) {
	      each$2(wire, function (bar) {
	        set$1(bar, 'display', 'none');
	      });
	    };
	    var show = function (wire) {
	      each$2(wire, function (bar) {
	        set$1(bar, 'display', 'block');
	      });
	    };
	    var isRowBar = function (element) {
	      return has$1(element, resizeRowBar);
	    };
	    var isColBar = function (element) {
	      return has$1(element, resizeColBar);
	    };
	
	    var resizeBarDragging = resolve$1('resizer-bar-dragging');
	    var BarManager = function (wire) {
	      var mutation = BarMutation();
	      var resizing = transform(mutation, {});
	      var hoverTable = Optional.none();
	      var getResizer = function (element, type) {
	        return Optional.from(get$2(element, type));
	      };
	      mutation.events.drag.bind(function (event) {
	        getResizer(event.target, 'data-row').each(function (_dataRow) {
	          var currentRow = getCssValue(event.target, 'top');
	          set$1(event.target, 'top', currentRow + event.yDelta + 'px');
	        });
	        getResizer(event.target, 'data-column').each(function (_dataCol) {
	          var currentCol = getCssValue(event.target, 'left');
	          set$1(event.target, 'left', currentCol + event.xDelta + 'px');
	        });
	      });
	      var getDelta = function (target, dir) {
	        var newX = getCssValue(target, dir);
	        var oldX = getAttrValue(target, 'data-initial-' + dir, 0);
	        return newX - oldX;
	      };
	      resizing.events.stop.bind(function () {
	        mutation.get().each(function (target) {
	          hoverTable.each(function (table) {
	            getResizer(target, 'data-row').each(function (row) {
	              var delta = getDelta(target, 'top');
	              remove(target, 'data-initial-top');
	              events.trigger.adjustHeight(table, delta, parseInt(row, 10));
	            });
	            getResizer(target, 'data-column').each(function (column) {
	              var delta = getDelta(target, 'left');
	              remove(target, 'data-initial-left');
	              events.trigger.adjustWidth(table, delta, parseInt(column, 10));
	            });
	            refresh(wire, table);
	          });
	        });
	      });
	      var handler = function (target, dir) {
	        events.trigger.startAdjust();
	        mutation.assign(target);
	        set(target, 'data-initial-' + dir, getCssValue(target, dir));
	        add$3(target, resizeBarDragging);
	        set$1(target, 'opacity', '0.2');
	        resizing.go(wire.parent());
	      };
	      var mousedown = bind$2(wire.parent(), 'mousedown', function (event) {
	        if (isRowBar(event.target)) {
	          handler(event.target, 'top');
	        }
	        if (isColBar(event.target)) {
	          handler(event.target, 'left');
	        }
	      });
	      var isRoot = function (e) {
	        return eq$1(e, wire.view());
	      };
	      var findClosestEditableTable = function (target) {
	        return closest$1(target, 'table', isRoot).filter(function (table) {
	          return findClosestContentEditable(table, isRoot).exists(isContentEditableTrue);
	        });
	      };
	      var mouseover = bind$2(wire.view(), 'mouseover', function (event) {
	        findClosestEditableTable(event.target).fold(function () {
	          if (inBody(event.target)) {
	            destroy(wire);
	          }
	        }, function (table) {
	          hoverTable = Optional.some(table);
	          refresh(wire, table);
	        });
	      });
	      var destroy$1 = function () {
	        mousedown.unbind();
	        mouseover.unbind();
	        resizing.destroy();
	        destroy(wire);
	      };
	      var refresh$1 = function (tbl) {
	        refresh(wire, tbl);
	      };
	      var events = create({
	        adjustHeight: Event([
	          'table',
	          'delta',
	          'row'
	        ]),
	        adjustWidth: Event([
	          'table',
	          'delta',
	          'column'
	        ]),
	        startAdjust: Event([])
	      });
	      return {
	        destroy: destroy$1,
	        refresh: refresh$1,
	        on: resizing.on,
	        off: resizing.off,
	        hideBars: curry(hide, wire),
	        showBars: curry(show, wire),
	        events: events.registry
	      };
	    };
	
	    var create$1 = function (wire, resizing, lazySizing) {
	      var hdirection = height;
	      var vdirection = width;
	      var manager = BarManager(wire);
	      var events = create({
	        beforeResize: Event([
	          'table',
	          'type'
	        ]),
	        afterResize: Event([
	          'table',
	          'type'
	        ]),
	        startDrag: Event([])
	      });
	      manager.events.adjustHeight.bind(function (event) {
	        var table = event.table;
	        events.trigger.beforeResize(table, 'row');
	        var delta = hdirection.delta(event.delta, table);
	        adjustHeight(table, delta, event.row, hdirection);
	        events.trigger.afterResize(table, 'row');
	      });
	      manager.events.startAdjust.bind(function (_event) {
	        events.trigger.startDrag();
	      });
	      manager.events.adjustWidth.bind(function (event) {
	        var table = event.table;
	        events.trigger.beforeResize(table, 'col');
	        var delta = vdirection.delta(event.delta, table);
	        var tableSize = lazySizing(table);
	        adjustWidth(table, delta, event.column, resizing, tableSize);
	        events.trigger.afterResize(table, 'col');
	      });
	      return {
	        on: manager.on,
	        off: manager.off,
	        hideBars: manager.hideBars,
	        showBars: manager.showBars,
	        destroy: manager.destroy,
	        events: events.registry
	      };
	    };
	    var TableResize = { create: create$1 };
	
	    var fireNewRow = function (editor, row) {
	      return editor.fire('newrow', { node: row });
	    };
	    var fireNewCell = function (editor, cell) {
	      return editor.fire('newcell', { node: cell });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var fireTableSelectionChange = function (editor, cells, start, finish, otherCells) {
	      editor.fire('TableSelectionChange', {
	        cells: cells,
	        start: start,
	        finish: finish,
	        otherCells: otherCells
	      });
	    };
	    var fireTableSelectionClear = function (editor) {
	      editor.fire('TableSelectionClear');
	    };
	    var fireTableModified = function (editor, table, data) {
	      editor.fire('TableModified', __assign(__assign({}, data), { table: table }));
	    };
	    var styleModified = {
	      structure: false,
	      style: true
	    };
	    var structureModified = {
	      structure: true,
	      style: false
	    };
	
	    var defaultTableToolbar = 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol';
	    var defaultStyles = {
	      'border-collapse': 'collapse',
	      'width': '100%'
	    };
	    var determineDefaultStyles = function (editor) {
	      if (isPixelsForced(editor)) {
	        var editorWidth = editor.getBody().offsetWidth;
	        return __assign(__assign({}, defaultStyles), { width: editorWidth + 'px' });
	      } else if (isResponsiveForced(editor)) {
	        return filter$1(defaultStyles, function (_value, key) {
	          return key !== 'width';
	        });
	      } else {
	        return defaultStyles;
	      }
	    };
	    var defaultAttributes = { border: '1' };
	    var defaultColumnResizingBehaviour = 'preservetable';
	    var getTableSizingMode = function (editor) {
	      return editor.getParam('table_sizing_mode', 'auto');
	    };
	    var getTableResponseWidth = function (editor) {
	      return editor.getParam('table_responsive_width');
	    };
	    var getDefaultAttributes = function (editor) {
	      return editor.getParam('table_default_attributes', defaultAttributes, 'object');
	    };
	    var getDefaultStyles = function (editor) {
	      return editor.getParam('table_default_styles', determineDefaultStyles(editor), 'object');
	    };
	    var hasTableResizeBars = function (editor) {
	      return editor.getParam('table_resize_bars', true, 'boolean');
	    };
	    var hasTabNavigation = function (editor) {
	      return editor.getParam('table_tab_navigation', true, 'boolean');
	    };
	    var hasAdvancedCellTab = function (editor) {
	      return editor.getParam('table_cell_advtab', true, 'boolean');
	    };
	    var hasAdvancedRowTab = function (editor) {
	      return editor.getParam('table_row_advtab', true, 'boolean');
	    };
	    var hasAdvancedTableTab = function (editor) {
	      return editor.getParam('table_advtab', true, 'boolean');
	    };
	    var hasAppearanceOptions = function (editor) {
	      return editor.getParam('table_appearance_options', true, 'boolean');
	    };
	    var hasTableGrid = function (editor) {
	      return editor.getParam('table_grid', true, 'boolean');
	    };
	    var shouldStyleWithCss = function (editor) {
	      return editor.getParam('table_style_by_css', false, 'boolean');
	    };
	    var getCellClassList = function (editor) {
	      return editor.getParam('table_cell_class_list', [], 'array');
	    };
	    var getRowClassList = function (editor) {
	      return editor.getParam('table_row_class_list', [], 'array');
	    };
	    var getTableClassList = function (editor) {
	      return editor.getParam('table_class_list', [], 'array');
	    };
	    var isPercentagesForced = function (editor) {
	      return getTableSizingMode(editor) === 'relative' || getTableResponseWidth(editor) === true;
	    };
	    var isPixelsForced = function (editor) {
	      return getTableSizingMode(editor) === 'fixed' || getTableResponseWidth(editor) === false;
	    };
	    var isResponsiveForced = function (editor) {
	      return getTableSizingMode(editor) === 'responsive';
	    };
	    var getToolbar = function (editor) {
	      return editor.getParam('table_toolbar', defaultTableToolbar);
	    };
	    var useColumnGroup = function (editor) {
	      return editor.getParam('table_use_colgroups', false, 'boolean');
	    };
	    var getTableHeaderType = function (editor) {
	      var defaultValue = 'section';
	      var value = editor.getParam('table_header_type', defaultValue, 'string');
	      var validValues = [
	        'section',
	        'cells',
	        'sectionCells',
	        'auto'
	      ];
	      if (!contains(validValues, value)) {
	        return defaultValue;
	      } else {
	        return value;
	      }
	    };
	    var getColumnResizingBehaviour = function (editor) {
	      var validModes = [
	        'preservetable',
	        'resizetable'
	      ];
	      var givenMode = editor.getParam('table_column_resizing', defaultColumnResizingBehaviour, 'string');
	      return find(validModes, function (mode) {
	        return mode === givenMode;
	      }).getOr(defaultColumnResizingBehaviour);
	    };
	    var isPreserveTableColumnResizing = function (editor) {
	      return getColumnResizingBehaviour(editor) === 'preservetable';
	    };
	    var isResizeTableColumnResizing = function (editor) {
	      return getColumnResizingBehaviour(editor) === 'resizetable';
	    };
	    var getCloneElements = function (editor) {
	      var cloneElements = editor.getParam('table_clone_elements');
	      if (isString(cloneElements)) {
	        return Optional.some(cloneElements.split(/[ ,]/));
	      } else if (Array.isArray(cloneElements)) {
	        return Optional.some(cloneElements);
	      } else {
	        return Optional.none();
	      }
	    };
	    var hasObjectResizing = function (editor) {
	      var objectResizing = editor.getParam('object_resizing', true);
	      return isString(objectResizing) ? objectResizing === 'table' : objectResizing;
	    };
	
	    var get$9 = function (editor, table) {
	      if (isPercentagesForced(editor)) {
	        var width = getRawWidth$1(editor, table.dom).filter(isPercentage).getOrThunk(function () {
	          return getPercentTableWidth$1(table);
	        });
	        return TableSize.percentageSize(width, table);
	      } else if (isPixelsForced(editor)) {
	        return TableSize.pixelSize(get$5(table), table);
	      } else {
	        return TableSize.getTableSize(table);
	      }
	    };
	
	    var cleanupLegacyAttributes = function (element) {
	      remove(element, 'width');
	    };
	    var convertToPercentSize = function (table, tableSize) {
	      var newWidth = getPercentTableWidth(table);
	      redistribute$1(table, Optional.some(newWidth), Optional.none(), tableSize);
	      cleanupLegacyAttributes(table);
	    };
	    var convertToPixelSize = function (table, tableSize) {
	      var newWidth = getPixelTableWidth(table);
	      redistribute$1(table, Optional.some(newWidth), Optional.none(), tableSize);
	      cleanupLegacyAttributes(table);
	    };
	    var convertToNoneSize = function (table) {
	      remove$1(table, 'width');
	      var columns$1 = columns(table);
	      var rowElements = columns$1.length > 0 ? columns$1 : cells(table);
	      each(rowElements, function (cell) {
	        remove$1(cell, 'width');
	        cleanupLegacyAttributes(cell);
	      });
	      cleanupLegacyAttributes(table);
	    };
	
	    var enforcePercentage = function (editor, table) {
	      var tableSizing = get$9(editor, table);
	      convertToPercentSize(table, tableSizing);
	    };
	    var enforcePixels = function (editor, table) {
	      var tableSizing = get$9(editor, table);
	      convertToPixelSize(table, tableSizing);
	    };
	    var enforceNone = convertToNoneSize;
	    var syncPixels = function (table) {
	      var warehouse = Warehouse.fromTable(table);
	      if (!Warehouse.hasColumns(warehouse)) {
	        each(cells(table), function (cell) {
	          var computedWidth = get$3(cell, 'width');
	          set$1(cell, 'width', computedWidth);
	          remove(cell, 'width');
	        });
	      }
	    };
	
	    var createContainer = function () {
	      var container = SugarElement.fromTag('div');
	      setAll$1(container, {
	        position: 'static',
	        height: '0',
	        width: '0',
	        padding: '0',
	        margin: '0',
	        border: '0'
	      });
	      append(body(), container);
	      return container;
	    };
	    var get$a = function (editor, isResizable) {
	      return editor.inline ? ResizeWire.body(getBody$1(editor), createContainer(), isResizable) : ResizeWire.only(SugarElement.fromDom(editor.getDoc()), isResizable);
	    };
	    var remove$6 = function (editor, wire) {
	      if (editor.inline) {
	        remove$2(wire.parent());
	      }
	    };
	
	    var barResizerPrefix = 'bar-';
	    var isResizable = function (elm) {
	      return get$2(elm, 'data-mce-resize') !== 'false';
	    };
	    var getResizeHandler = function (editor) {
	      var selectionRng = Optional.none();
	      var resize = Optional.none();
	      var wire = Optional.none();
	      var startW;
	      var startRawW;
	      var isTable = function (elm) {
	        return elm.nodeName === 'TABLE';
	      };
	      var lazyResize = function () {
	        return resize;
	      };
	      var lazyWire = function () {
	        return wire.getOr(ResizeWire.only(SugarElement.fromDom(editor.getBody()), isResizable));
	      };
	      var lazySizing = function (table) {
	        return get$9(editor, table);
	      };
	      var lazyResizingBehaviour = function () {
	        return isPreserveTableColumnResizing(editor) ? preserveTable() : resizeTable();
	      };
	      var getNumColumns = function (table) {
	        return getGridSize(table).columns;
	      };
	      var afterCornerResize = function (table, origin, width) {
	        var isRightEdgeResize = endsWith(origin, 'e');
	        if (startRawW === '') {
	          enforcePercentage(editor, table);
	        }
	        if (width !== startW && startRawW !== '') {
	          set$1(table, 'width', startRawW);
	          var resizing = lazyResizingBehaviour();
	          var tableSize = lazySizing(table);
	          var col = isPreserveTableColumnResizing(editor) || isRightEdgeResize ? getNumColumns(table) - 1 : 0;
	          adjustWidth(table, width - startW, col, resizing, tableSize);
	        } else if (isPercentage(startRawW)) {
	          var percentW = parseFloat(startRawW.replace('%', ''));
	          var targetPercentW = width * percentW / startW;
	          set$1(table, 'width', targetPercentW + '%');
	        }
	        if (isPixel(startRawW)) {
	          syncPixels(table);
	        }
	      };
	      var destroy = function () {
	        resize.each(function (sz) {
	          sz.destroy();
	        });
	        wire.each(function (w) {
	          remove$6(editor, w);
	        });
	      };
	      editor.on('init', function () {
	        var rawWire = get$a(editor, isResizable);
	        wire = Optional.some(rawWire);
	        if (hasObjectResizing(editor) && hasTableResizeBars(editor)) {
	          var resizing = lazyResizingBehaviour();
	          var sz = TableResize.create(rawWire, resizing, lazySizing);
	          sz.on();
	          sz.events.startDrag.bind(function (_event) {
	            selectionRng = Optional.some(editor.selection.getRng());
	          });
	          sz.events.beforeResize.bind(function (event) {
	            var rawTable = event.table.dom;
	            fireObjectResizeStart(editor, rawTable, getPixelWidth$1(rawTable), getPixelHeight(rawTable), barResizerPrefix + event.type);
	          });
	          sz.events.afterResize.bind(function (event) {
	            var table = event.table;
	            var rawTable = table.dom;
	            removeDataStyle(table);
	            selectionRng.each(function (rng) {
	              editor.selection.setRng(rng);
	              editor.focus();
	            });
	            fireObjectResized(editor, rawTable, getPixelWidth$1(rawTable), getPixelHeight(rawTable), barResizerPrefix + event.type);
	            editor.undoManager.add();
	          });
	          resize = Optional.some(sz);
	        }
	      });
	      editor.on('ObjectResizeStart', function (e) {
	        var targetElm = e.target;
	        if (isTable(targetElm)) {
	          var table = SugarElement.fromDom(targetElm);
	          each(editor.dom.select('.mce-clonedresizable'), function (clone) {
	            editor.dom.addClass(clone, 'mce-' + getColumnResizingBehaviour(editor) + '-columns');
	          });
	          if (!isPixelSizing$1(table) && isPixelsForced(editor)) {
	            enforcePixels(editor, table);
	          } else if (!isPercentSizing$1(table) && isPercentagesForced(editor)) {
	            enforcePercentage(editor, table);
	          }
	          if (isNoneSizing$1(table) && startsWith(e.origin, barResizerPrefix)) {
	            enforcePercentage(editor, table);
	          }
	          startW = e.width;
	          startRawW = isResponsiveForced(editor) ? '' : getRawWidth$1(editor, targetElm).getOr('');
	        }
	      });
	      editor.on('ObjectResized', function (e) {
	        var targetElm = e.target;
	        if (isTable(targetElm)) {
	          var table = SugarElement.fromDom(targetElm);
	          var origin_1 = e.origin;
	          if (startsWith(origin_1, 'corner-')) {
	            afterCornerResize(table, origin_1, e.width);
	          }
	          removeDataStyle(table);
	          fireTableModified(editor, table.dom, styleModified);
	        }
	      });
	      editor.on('SwitchMode', function () {
	        lazyResize().each(function (resize) {
	          if (editor.mode.isReadOnly()) {
	            resize.hideBars();
	          } else {
	            resize.showBars();
	          }
	        });
	      });
	      return {
	        lazyResize: lazyResize,
	        lazyWire: lazyWire,
	        destroy: destroy
	      };
	    };
	
	    var point = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	
	    var scan = function (universe, element, direction) {
	      if (universe.property().isText(element) && universe.property().getText(element).trim().length === 0 || universe.property().isComment(element)) {
	        return direction(element).bind(function (elem) {
	          return scan(universe, elem, direction).orThunk(function () {
	            return Optional.some(elem);
	          });
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var toEnd = function (universe, element) {
	      if (universe.property().isText(element)) {
	        return universe.property().getText(element).length;
	      }
	      var children = universe.property().children(element);
	      return children.length;
	    };
	    var freefallRtl = function (universe, element) {
	      var candidate = scan(universe, element, universe.query().prevSibling).getOr(element);
	      if (universe.property().isText(candidate)) {
	        return point(candidate, toEnd(universe, candidate));
	      }
	      var children = universe.property().children(candidate);
	      return children.length > 0 ? freefallRtl(universe, children[children.length - 1]) : point(candidate, toEnd(universe, candidate));
	    };
	
	    var freefallRtl$1 = freefallRtl;
	
	    var universe$1 = DomUniverse();
	    var freefallRtl$2 = function (element) {
	      return freefallRtl$1(universe$1, element);
	    };
	
	    var halve = function (main, other) {
	      var colspan = getSpan(main, 'colspan');
	      if (colspan === 1) {
	        var width = getGenericWidth(main);
	        width.each(function (w) {
	          var newWidth = w.value / 2;
	          setGenericWidth(main, newWidth, w.unit);
	          setGenericWidth(other, newWidth, w.unit);
	        });
	      }
	    };
	
	    var setIfNot = function (element, property, value, ignore) {
	      if (value === ignore) {
	        remove(element, property);
	      } else {
	        set(element, property, value);
	      }
	    };
	    var insert = function (table, selector, element) {
	      last(children$2(table, selector)).fold(function () {
	        return prepend(table, element);
	      }, function (child) {
	        return after(child, element);
	      });
	    };
	    var generateSection = function (table, sectionName) {
	      var section = child$2(table, sectionName).getOrThunk(function () {
	        var newSection = SugarElement.fromTag(sectionName, owner(table).dom);
	        if (sectionName === 'thead') {
	          insert(table, 'caption,colgroup', newSection);
	        } else if (sectionName === 'colgroup') {
	          insert(table, 'caption', newSection);
	        } else {
	          append(table, newSection);
	        }
	        return newSection;
	      });
	      empty(section);
	      return section;
	    };
	    var render = function (table, grid) {
	      var newRows = [];
	      var newCells = [];
	      var syncRows = function (gridSection) {
	        return map(gridSection, function (row) {
	          if (row.isNew) {
	            newRows.push(row.element);
	          }
	          var tr = row.element;
	          empty(tr);
	          each(row.cells, function (cell) {
	            if (cell.isNew) {
	              newCells.push(cell.element);
	            }
	            setIfNot(cell.element, 'colspan', cell.colspan, 1);
	            setIfNot(cell.element, 'rowspan', cell.rowspan, 1);
	            append(tr, cell.element);
	          });
	          return tr;
	        });
	      };
	      var syncColGroup = function (gridSection) {
	        return bind(gridSection, function (colGroup) {
	          return map(colGroup.cells, function (col) {
	            setIfNot(col.element, 'span', col.colspan, 1);
	            return col.element;
	          });
	        });
	      };
	      var renderSection = function (gridSection, sectionName) {
	        var section = generateSection(table, sectionName);
	        var sync = sectionName === 'colgroup' ? syncColGroup : syncRows;
	        var sectionElems = sync(gridSection);
	        append$1(section, sectionElems);
	      };
	      var removeSection = function (sectionName) {
	        child$2(table, sectionName).each(remove$2);
	      };
	      var renderOrRemoveSection = function (gridSection, sectionName) {
	        if (gridSection.length > 0) {
	          renderSection(gridSection, sectionName);
	        } else {
	          removeSection(sectionName);
	        }
	      };
	      var headSection = [];
	      var bodySection = [];
	      var footSection = [];
	      var columnGroupsSection = [];
	      each(grid, function (row) {
	        switch (row.section) {
	        case 'thead':
	          headSection.push(row);
	          break;
	        case 'tbody':
	          bodySection.push(row);
	          break;
	        case 'tfoot':
	          footSection.push(row);
	          break;
	        case 'colgroup':
	          columnGroupsSection.push(row);
	          break;
	        }
	      });
	      renderOrRemoveSection(columnGroupsSection, 'colgroup');
	      renderOrRemoveSection(headSection, 'thead');
	      renderOrRemoveSection(bodySection, 'tbody');
	      renderOrRemoveSection(footSection, 'tfoot');
	      return {
	        newRows: newRows,
	        newCells: newCells
	      };
	    };
	    var copy$2 = function (grid) {
	      return map(grid, function (row) {
	        var tr = shallow(row.element);
	        each(row.cells, function (cell) {
	          var clonedCell = deep(cell.element);
	          setIfNot(clonedCell, 'colspan', cell.colspan, 1);
	          setIfNot(clonedCell, 'rowspan', cell.rowspan, 1);
	          append(tr, clonedCell);
	        });
	        return tr;
	      });
	    };
	
	    var getColumn = function (grid, index) {
	      return map(grid, function (row) {
	        return getCell(row, index);
	      });
	    };
	    var getRow = function (grid, index) {
	      return grid[index];
	    };
	    var findDiff = function (xs, comp) {
	      if (xs.length === 0) {
	        return 0;
	      }
	      var first = xs[0];
	      var index = findIndex(xs, function (x) {
	        return !comp(first.element, x.element);
	      });
	      return index.fold(function () {
	        return xs.length;
	      }, function (ind) {
	        return ind;
	      });
	    };
	    var subgrid = function (grid, row, column, comparator) {
	      var restOfRow = getRow(grid, row).cells.slice(column);
	      var endColIndex = findDiff(restOfRow, comparator);
	      var restOfColumn = getColumn(grid, column).slice(row);
	      var endRowIndex = findDiff(restOfColumn, comparator);
	      return {
	        colspan: endColIndex,
	        rowspan: endRowIndex
	      };
	    };
	
	    var toDetails = function (grid, comparator) {
	      var seen = map(grid, function (row) {
	        return map(row.cells, never);
	      });
	      var updateSeen = function (rowIndex, columnIndex, rowspan, colspan) {
	        for (var row = rowIndex; row < rowIndex + rowspan; row++) {
	          for (var column = columnIndex; column < columnIndex + colspan; column++) {
	            seen[row][column] = true;
	          }
	        }
	      };
	      return map(grid, function (row, rowIndex) {
	        var details = bind(row.cells, function (cell, columnIndex) {
	          if (seen[rowIndex][columnIndex] === false) {
	            var result = subgrid(grid, rowIndex, columnIndex, comparator);
	            updateSeen(rowIndex, columnIndex, result.rowspan, result.colspan);
	            return [detailnew(cell.element, result.rowspan, result.colspan, cell.isNew)];
	          } else {
	            return [];
	          }
	        });
	        return rowdetails(details, row.section);
	      });
	    };
	    var toGrid = function (warehouse, generators, isNew) {
	      var grid = [];
	      if (Warehouse.hasColumns(warehouse)) {
	        var groupElementNew = map(Warehouse.justColumns(warehouse), function (column) {
	          return elementnew(column.element, isNew, false);
	        });
	        grid.push(rowcells(groupElementNew, 'colgroup'));
	      }
	      for (var rowIndex = 0; rowIndex < warehouse.grid.rows; rowIndex++) {
	        var rowCells = [];
	        for (var columnIndex = 0; columnIndex < warehouse.grid.columns; columnIndex++) {
	          var element = Warehouse.getAt(warehouse, rowIndex, columnIndex).map(function (item) {
	            return elementnew(item.element, isNew, item.isLocked);
	          }).getOrThunk(function () {
	            return elementnew(generators.gap(), true, false);
	          });
	          rowCells.push(element);
	        }
	        var row = rowcells(rowCells, warehouse.all[rowIndex].section);
	        grid.push(row);
	      }
	      return grid;
	    };
	
	    var fromWarehouse = function (warehouse, generators) {
	      return toGrid(warehouse, generators, false);
	    };
	    var deriveRows = function (rendered, generators) {
	      var findRow = function (details) {
	        var rowOfCells = findMap(details, function (detail) {
	          return parent(detail.element).map(function (row) {
	            var isNew = parent(row).isNone();
	            return elementnew(row, isNew, false);
	          });
	        });
	        return rowOfCells.getOrThunk(function () {
	          return elementnew(generators.row(), true, false);
	        });
	      };
	      return map(rendered, function (details) {
	        var row = findRow(details.details);
	        return rowdatanew(row.element, details.details, details.section, row.isNew);
	      });
	    };
	    var toDetailList = function (grid, generators) {
	      var rendered = toDetails(grid, eq$1);
	      return deriveRows(rendered, generators);
	    };
	    var findInWarehouse = function (warehouse, element) {
	      return findMap(warehouse.all, function (r) {
	        return find(r.cells, function (e) {
	          return eq$1(element, e.element);
	        });
	      });
	    };
	    var extractCells = function (warehouse, target, predicate) {
	      var details = map(target.selection, function (cell$1) {
	        return cell(cell$1).bind(function (lc) {
	          return findInWarehouse(warehouse, lc);
	        }).filter(predicate);
	      });
	      var cells = cat(details);
	      return someIf(cells.length > 0, cells);
	    };
	    var run = function (operation, extract, adjustment, postAction, genWrappers) {
	      return function (wire, table, target, generators, sizing, resizeBehaviour) {
	        var warehouse = Warehouse.fromTable(table);
	        var output = extract(warehouse, target).map(function (info) {
	          var model = fromWarehouse(warehouse, generators);
	          var result = operation(model, info, eq$1, genWrappers(generators));
	          var lockedColumns = getLockedColumnsFromGrid(result.grid);
	          var grid = toDetailList(result.grid, generators);
	          return {
	            info: info,
	            grid: grid,
	            cursor: result.cursor,
	            lockedColumns: lockedColumns
	          };
	        });
	        return output.bind(function (out) {
	          var newElements = render(table, out.grid);
	          var tableSizing = Optional.from(sizing).getOrThunk(function () {
	            return TableSize.getTableSize(table);
	          });
	          var resizing = Optional.from(resizeBehaviour).getOrThunk(preserveTable);
	          adjustment(table, out.grid, out.info, tableSizing, resizing);
	          postAction(table);
	          refresh(wire, table);
	          remove(table, LOCKED_COL_ATTR);
	          if (out.lockedColumns.length > 0) {
	            set(table, LOCKED_COL_ATTR, out.lockedColumns.join(','));
	          }
	          return Optional.some({
	            cursor: out.cursor,
	            newRows: newElements.newRows,
	            newCells: newElements.newCells
	          });
	        });
	      };
	    };
	    var onCell = function (warehouse, target) {
	      return cell(target.element).bind(function (cell) {
	        return findInWarehouse(warehouse, cell);
	      });
	    };
	    var onPaste = function (warehouse, target) {
	      return cell(target.element).bind(function (cell) {
	        return findInWarehouse(warehouse, cell).map(function (details) {
	          var value = __assign(__assign({}, details), {
	            generators: target.generators,
	            clipboard: target.clipboard
	          });
	          return value;
	        });
	      });
	    };
	    var onPasteByEditor = function (warehouse, target) {
	      return extractCells(warehouse, target, always).map(function (cells) {
	        return {
	          cells: cells,
	          generators: target.generators,
	          clipboard: target.clipboard
	        };
	      });
	    };
	    var onMergable = function (_warehouse, target) {
	      return target.mergable;
	    };
	    var onUnmergable = function (_warehouse, target) {
	      return target.unmergable;
	    };
	    var onCells = function (warehouse, target) {
	      return extractCells(warehouse, target, always);
	    };
	    var onUnlockedCell = function (warehouse, target) {
	      return onCell(warehouse, target).filter(function (detail) {
	        return !detail.isLocked;
	      });
	    };
	    var onUnlockedCells = function (warehouse, target) {
	      return extractCells(warehouse, target, function (detail) {
	        return !detail.isLocked;
	      });
	    };
	    var isUnlockedTableCell = function (warehouse, cell) {
	      return findInWarehouse(warehouse, cell).exists(function (detail) {
	        return !detail.isLocked;
	      });
	    };
	    var allUnlocked = function (warehouse, cells) {
	      return forall(cells, function (cell) {
	        return isUnlockedTableCell(warehouse, cell);
	      });
	    };
	    var onUnlockedMergable = function (warehouse, target) {
	      return onMergable(warehouse, target).filter(function (mergeable) {
	        return allUnlocked(warehouse, mergeable.cells);
	      });
	    };
	    var onUnlockedUnmergable = function (warehouse, target) {
	      return onUnmergable(warehouse, target).filter(function (cells) {
	        return allUnlocked(warehouse, cells);
	      });
	    };
	
	    var merge = function (grid, bounds, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      if (rows.length === 0) {
	        return grid;
	      }
	      for (var i = bounds.startRow; i <= bounds.finishRow; i++) {
	        for (var j = bounds.startCol; j <= bounds.finishCol; j++) {
	          var row = rows[i];
	          var isLocked = getCell(row, j).isLocked;
	          mutateCell(row, j, elementnew(substitution(), false, isLocked));
	        }
	      }
	      return grid;
	    };
	    var unmerge = function (grid, target, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      var first = true;
	      for (var i = 0; i < rows.length; i++) {
	        for (var j = 0; j < cellLength(rows[0]); j++) {
	          var row = rows[i];
	          var currentCell = getCell(row, j);
	          var currentCellElm = currentCell.element;
	          var isToReplace = comparator(currentCellElm, target);
	          if (isToReplace === true && first === false) {
	            mutateCell(row, j, elementnew(substitution(), true, currentCell.isLocked));
	          } else if (isToReplace === true) {
	            first = false;
	          }
	        }
	      }
	      return grid;
	    };
	    var uniqueCells = function (row, comparator) {
	      return foldl(row, function (rest, cell) {
	        return exists(rest, function (currentCell) {
	          return comparator(currentCell.element, cell.element);
	        }) ? rest : rest.concat([cell]);
	      }, []);
	    };
	    var splitCols = function (grid, index, comparator, substitution) {
	      if (index > 0 && index < grid[0].cells.length) {
	        each(grid, function (row) {
	          var prevCell = row.cells[index - 1];
	          var current = row.cells[index];
	          var isToReplace = comparator(current.element, prevCell.element);
	          if (isToReplace) {
	            mutateCell(row, index, elementnew(substitution(), true, current.isLocked));
	          }
	        });
	      }
	      return grid;
	    };
	    var splitRows = function (grid, index, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      if (index > 0 && index < rows.length) {
	        var rowPrevCells = rows[index - 1].cells;
	        var cells = uniqueCells(rowPrevCells, comparator);
	        each(cells, function (cell) {
	          var replacement = Optional.none();
	          for (var i = index; i < rows.length; i++) {
	            var _loop_1 = function (j) {
	              var row = rows[i];
	              var current = getCell(row, j);
	              var isToReplace = comparator(current.element, cell.element);
	              if (isToReplace) {
	                if (replacement.isNone()) {
	                  replacement = Optional.some(substitution());
	                }
	                replacement.each(function (sub) {
	                  mutateCell(row, j, elementnew(sub, true, current.isLocked));
	                });
	              }
	            };
	            for (var j = 0; j < cellLength(rows[0]); j++) {
	              _loop_1(j);
	            }
	          }
	        });
	      }
	      return grid;
	    };
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;
	      };
	      var or = function (_opt) {
	        return value(o);
	      };
	      var orThunk = function (_f) {
	        return value(o);
	      };
	      var map = function (f) {
	        return value(f(o));
	      };
	      var mapError = function (_f) {
	        return value(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOptional = function () {
	        return Optional.some(o);
	      };
	      return {
	        is: is,
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOptional: toOptional
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = function (opt) {
	        return opt;
	      };
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (_f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (_f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        is: never,
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOptional: Optional.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value);
	    };
	    var Result = {
	      value: value,
	      error: error,
	      fromOption: fromOption
	    };
	
	    var measure = function (startAddress, gridA, gridB) {
	      if (startAddress.row >= gridA.length || startAddress.column > cellLength(gridA[0])) {
	        return Result.error('invalid start address out of table bounds, row: ' + startAddress.row + ', column: ' + startAddress.column);
	      }
	      var rowRemainder = gridA.slice(startAddress.row);
	      var colRemainder = rowRemainder[0].cells.slice(startAddress.column);
	      var colRequired = cellLength(gridB[0]);
	      var rowRequired = gridB.length;
	      return Result.value({
	        rowDelta: rowRemainder.length - rowRequired,
	        colDelta: colRemainder.length - colRequired
	      });
	    };
	    var measureWidth = function (gridA, gridB) {
	      var colLengthA = cellLength(gridA[0]);
	      var colLengthB = cellLength(gridB[0]);
	      return {
	        rowDelta: 0,
	        colDelta: colLengthA - colLengthB
	      };
	    };
	    var measureHeight = function (gridA, gridB) {
	      var rowLengthA = gridA.length;
	      var rowLengthB = gridB.length;
	      return {
	        rowDelta: rowLengthA - rowLengthB,
	        colDelta: 0
	      };
	    };
	    var generateElements = function (amount, row, generators, isLocked) {
	      var generator = row.section === 'colgroup' ? generators.col : generators.cell;
	      return range(amount, function (idx) {
	        return elementnew(generator(), true, isLocked(idx));
	      });
	    };
	    var rowFill = function (grid, amount, generators, lockedColumns) {
	      return grid.concat(range(amount, function () {
	        var row = grid[grid.length - 1];
	        var elements = generateElements(row.cells.length, row, generators, function (idx) {
	          return has(lockedColumns, idx.toString());
	        });
	        return setCells(row, elements);
	      }));
	    };
	    var colFill = function (grid, amount, generators, startIndex) {
	      return map(grid, function (row) {
	        var newChildren = generateElements(amount, row, generators, never);
	        return addCells(row, startIndex, newChildren);
	      });
	    };
	    var lockedColFill = function (grid, generators, lockedColumns) {
	      return map(grid, function (row) {
	        return foldl(lockedColumns, function (acc, colNum) {
	          var newChild = generateElements(1, row, generators, always)[0];
	          return addCell(acc, colNum, newChild);
	        }, row);
	      });
	    };
	    var tailor = function (gridA, delta, generators) {
	      var fillCols = delta.colDelta < 0 ? colFill : identity;
	      var fillRows = delta.rowDelta < 0 ? rowFill : identity;
	      var lockedColumns = getLockedColumnsFromGrid(gridA);
	      var gridWidth = cellLength(gridA[0]);
	      var isLastColLocked = exists(lockedColumns, function (locked) {
	        return locked === gridWidth - 1;
	      });
	      var modifiedCols = fillCols(gridA, Math.abs(delta.colDelta), generators, isLastColLocked ? gridWidth - 1 : gridWidth);
	      var newLockedColumns = getLockedColumnsFromGrid(modifiedCols);
	      return fillRows(modifiedCols, Math.abs(delta.rowDelta), generators, mapToObject(newLockedColumns, always));
	    };
	
	    var isSpanning = function (grid, row, col, comparator) {
	      var candidate = getCell(grid[row], col);
	      var matching = curry(comparator, candidate.element);
	      var currentRow = grid[row];
	      return grid.length > 1 && cellLength(currentRow) > 1 && (col > 0 && matching(getCellElement(currentRow, col - 1)) || col < currentRow.cells.length - 1 && matching(getCellElement(currentRow, col + 1)) || row > 0 && matching(getCellElement(grid[row - 1], col)) || row < grid.length - 1 && matching(getCellElement(grid[row + 1], col)));
	    };
	    var mergeTables = function (startAddress, gridA, gridB, generator, comparator, lockedColumns) {
	      var startRow = startAddress.row;
	      var startCol = startAddress.column;
	      var mergeHeight = gridB.length;
	      var mergeWidth = cellLength(gridB[0]);
	      var endRow = startRow + mergeHeight;
	      var endCol = startCol + mergeWidth + lockedColumns.length;
	      var lockedColumnObj = mapToObject(lockedColumns, always);
	      for (var r = startRow; r < endRow; r++) {
	        var skippedCol = 0;
	        for (var c = startCol; c < endCol; c++) {
	          if (lockedColumnObj[c]) {
	            skippedCol++;
	            continue;
	          }
	          if (isSpanning(gridA, r, c, comparator)) {
	            unmerge(gridA, getCellElement(gridA[r], c), comparator, generator.cell);
	          }
	          var gridBColIndex = c - startCol - skippedCol;
	          var newCell = getCell(gridB[r - startRow], gridBColIndex);
	          var newCellElm = newCell.element;
	          var replacement = generator.replace(newCellElm);
	          mutateCell(gridA[r], c, elementnew(replacement, true, newCell.isLocked));
	        }
	      }
	      return gridA;
	    };
	    var getValidStartAddress = function (currentStartAddress, grid, lockedColumns) {
	      var gridColLength = cellLength(grid[0]);
	      var possibleColAddresses = range(gridColLength - currentStartAddress.column, function (num) {
	        return num + currentStartAddress.column;
	      });
	      var validColAddress = find(possibleColAddresses, function (num) {
	        return forall(lockedColumns, function (col) {
	          return col !== num;
	        });
	      }).getOr(gridColLength - 1);
	      return __assign(__assign({}, currentStartAddress), { column: validColAddress });
	    };
	    var getLockedColumnsWithinBounds = function (startAddress, grid, lockedColumns) {
	      return filter(lockedColumns, function (colNum) {
	        return colNum >= startAddress.column && colNum <= cellLength(grid[0]) + startAddress.column;
	      });
	    };
	    var merge$1 = function (startAddress, gridA, gridB, generator, comparator) {
	      var lockedColumns = getLockedColumnsFromGrid(gridA);
	      var validStartAddress = getValidStartAddress(startAddress, gridA, lockedColumns);
	      var lockedColumnsWithinBounds = getLockedColumnsWithinBounds(validStartAddress, gridB, lockedColumns);
	      var result = measure(validStartAddress, gridA, gridB);
	      return result.map(function (diff) {
	        var delta = __assign(__assign({}, diff), { colDelta: diff.colDelta - lockedColumnsWithinBounds.length });
	        var fittedGrid = tailor(gridA, delta, generator);
	        var newLockedColumns = getLockedColumnsFromGrid(fittedGrid);
	        var newLockedColumnsWithinBounds = getLockedColumnsWithinBounds(validStartAddress, gridB, newLockedColumns);
	        return mergeTables(validStartAddress, fittedGrid, gridB, generator, comparator, newLockedColumnsWithinBounds);
	      });
	    };
	    var insertCols = function (index, gridA, gridB, generator, comparator) {
	      splitCols(gridA, index, comparator, generator.cell);
	      var delta = measureHeight(gridB, gridA);
	      var fittedNewGrid = tailor(gridB, delta, generator);
	      var secondDelta = measureHeight(gridA, fittedNewGrid);
	      var fittedOldGrid = tailor(gridA, secondDelta, generator);
	      return map(fittedOldGrid, function (gridRow, i) {
	        return addCells(gridRow, index, fittedNewGrid[i].cells);
	      });
	    };
	    var insertRows = function (index, gridA, gridB, generator, comparator) {
	      splitRows(gridA, index, comparator, generator.cell);
	      var locked = getLockedColumnsFromGrid(gridA);
	      var diff = measureWidth(gridA, gridB);
	      var delta = __assign(__assign({}, diff), { colDelta: diff.colDelta - locked.length });
	      var fittedOldGrid = tailor(gridA, delta, generator);
	      var _a = extractGridDetails(fittedOldGrid), oldCols = _a.cols, oldRows = _a.rows;
	      var newLocked = getLockedColumnsFromGrid(fittedOldGrid);
	      var secondDiff = measureWidth(gridB, gridA);
	      var secondDelta = __assign(__assign({}, secondDiff), { colDelta: secondDiff.colDelta + newLocked.length });
	      var fittedGridB = lockedColFill(gridB, generator, newLocked);
	      var fittedNewGrid = tailor(fittedGridB, secondDelta, generator);
	      return oldCols.concat(oldRows.slice(0, index)).concat(fittedNewGrid).concat(oldRows.slice(index, oldRows.length));
	    };
	
	    var insertRowAt = function (grid, index, example, comparator, substitution) {
	      var _a = extractGridDetails(grid), rows = _a.rows, cols = _a.cols;
	      var before = rows.slice(0, index);
	      var after = rows.slice(index);
	      var between = mapCells(rows[example], function (ex, c) {
	        var withinSpan = index > 0 && index < rows.length && comparator(getCellElement(rows[index - 1], c), getCellElement(rows[index], c));
	        var ret = withinSpan ? getCell(rows[index], c) : elementnew(substitution(ex.element, comparator), true, ex.isLocked);
	        return ret;
	      });
	      return cols.concat(before).concat([between]).concat(after);
	    };
	    var getElementFor = function (row, column, section, withinSpan, example, comparator, substitution) {
	      if (section === 'colgroup' || !withinSpan) {
	        var cell = getCell(row, example);
	        return elementnew(substitution(cell.element, comparator), true, false);
	      } else {
	        return getCell(row, column);
	      }
	    };
	    var insertColumnAt = function (grid, index, example, comparator, substitution) {
	      return map(grid, function (row) {
	        var withinSpan = index > 0 && index < cellLength(row) && comparator(getCellElement(row, index - 1), getCellElement(row, index));
	        var sub = getElementFor(row, index, row.section, withinSpan, example, comparator, substitution);
	        return addCell(row, index, sub);
	      });
	    };
	    var deleteColumnsAt = function (grid, columns) {
	      return bind(grid, function (row) {
	        var existingCells = row.cells;
	        var cells = foldr(columns, function (acc, column) {
	          return column >= 0 && column < acc.length ? acc.slice(0, column).concat(acc.slice(column + 1)) : acc;
	        }, existingCells);
	        return cells.length > 0 ? [rowcells(cells, row.section)] : [];
	      });
	    };
	    var deleteRowsAt = function (grid, start, finish) {
	      var _a = extractGridDetails(grid), rows = _a.rows, cols = _a.cols;
	      return cols.concat(rows.slice(0, start)).concat(rows.slice(finish + 1));
	    };
	
	    var replaceIn = function (grid, targets, comparator, substitution) {
	      var isTarget = function (cell) {
	        return exists(targets, function (target) {
	          return comparator(cell.element, target.element);
	        });
	      };
	      return map(grid, function (row) {
	        return mapCells(row, function (cell) {
	          return isTarget(cell) ? elementnew(substitution(cell.element, comparator), true, cell.isLocked) : cell;
	        });
	      });
	    };
	    var notStartRow = function (grid, rowIndex, colIndex, comparator) {
	      return getCellElement(grid[rowIndex], colIndex) !== undefined && (rowIndex > 0 && comparator(getCellElement(grid[rowIndex - 1], colIndex), getCellElement(grid[rowIndex], colIndex)));
	    };
	    var notStartColumn = function (row, index, comparator) {
	      return index > 0 && comparator(getCellElement(row, index - 1), getCellElement(row, index));
	    };
	    var replaceColumn = function (grid, index, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      var targets = bind(rows, function (row, i) {
	        var alreadyAdded = notStartRow(grid, i, index, comparator) || notStartColumn(row, index, comparator);
	        return alreadyAdded ? [] : [getCell(row, index)];
	      });
	      return replaceIn(grid, targets, comparator, substitution);
	    };
	    var replaceRow = function (grid, index, comparator, substitution) {
	      var rows = extractGridDetails(grid).rows;
	      var targetRow = rows[index];
	      var targets = bind(targetRow.cells, function (item, i) {
	        var alreadyAdded = notStartRow(rows, index, i, comparator) || notStartColumn(targetRow, i, comparator);
	        return alreadyAdded ? [] : [item];
	      });
	      return replaceIn(grid, targets, comparator, substitution);
	    };
	
	    var uniqueColumns = function (details) {
	      var uniqueCheck = function (rest, detail) {
	        var columnExists = exists(rest, function (currentDetail) {
	          return currentDetail.column === detail.column;
	        });
	        return columnExists ? rest : rest.concat([detail]);
	      };
	      return foldl(details, uniqueCheck, []).sort(function (detailA, detailB) {
	        return detailA.column - detailB.column;
	      });
	    };
	
	    var elementToData = function (element) {
	      var colspan = getAttrValue(element, 'colspan', 1);
	      var rowspan = getAttrValue(element, 'rowspan', 1);
	      return {
	        element: element,
	        colspan: colspan,
	        rowspan: rowspan
	      };
	    };
	    var modification = function (generators, toData) {
	      if (toData === void 0) {
	        toData = elementToData;
	      }
	      var position = Cell(Optional.none());
	      var nu = function (data) {
	        switch (name(data.element)) {
	        case 'col':
	          return generators.col(data);
	        default:
	          return generators.cell(data);
	        }
	      };
	      var nuFrom = function (element) {
	        var data = toData(element);
	        return nu(data);
	      };
	      var add = function (element) {
	        var replacement = nuFrom(element);
	        if (position.get().isNone()) {
	          position.set(Optional.some(replacement));
	        }
	        recent = Optional.some({
	          item: element,
	          replacement: replacement
	        });
	        return replacement;
	      };
	      var recent = Optional.none();
	      var getOrInit = function (element, comparator) {
	        return recent.fold(function () {
	          return add(element);
	        }, function (p) {
	          return comparator(element, p.item) ? p.replacement : add(element);
	        });
	      };
	      return {
	        getOrInit: getOrInit,
	        cursor: position.get
	      };
	    };
	    var transform$1 = function (scope, tag) {
	      return function (generators) {
	        var position = Cell(Optional.none());
	        var list = [];
	        var find$1 = function (element, comparator) {
	          return find(list, function (x) {
	            return comparator(x.item, element);
	          });
	        };
	        var makeNew = function (element) {
	          var attrs = { scope: scope };
	          var cell = generators.replace(element, tag, attrs);
	          list.push({
	            item: element,
	            sub: cell
	          });
	          if (position.get().isNone()) {
	            position.set(Optional.some(cell));
	          }
	          return cell;
	        };
	        var replaceOrInit = function (element, comparator) {
	          if (name(element) === 'col') {
	            return element;
	          } else {
	            return find$1(element, comparator).fold(function () {
	              return makeNew(element);
	            }, function (p) {
	              return comparator(element, p.item) ? p.sub : makeNew(element);
	            });
	          }
	        };
	        return {
	          replaceOrInit: replaceOrInit,
	          cursor: position.get
	        };
	      };
	    };
	    var getScopeAttribute = function (cell) {
	      return getOpt(cell, 'scope').map(function (attribute) {
	        return attribute.substr(0, 3);
	      });
	    };
	    var merging = function (generators) {
	      var position = Cell(Optional.none());
	      var unmerge = function (cell) {
	        if (position.get().isNone()) {
	          position.set(Optional.some(cell));
	        }
	        var scope = getScopeAttribute(cell);
	        scope.each(function (attribute) {
	          return set(cell, 'scope', attribute);
	        });
	        return function () {
	          var raw = generators.cell({
	            element: cell,
	            colspan: 1,
	            rowspan: 1
	          });
	          remove$1(raw, 'width');
	          remove$1(cell, 'width');
	          scope.each(function (attribute) {
	            return set(raw, 'scope', attribute);
	          });
	          return raw;
	        };
	      };
	      var merge = function (cells) {
	        var getScopeProperty = function () {
	          var stringAttributes = cat(map(cells, getScopeAttribute));
	          if (stringAttributes.length === 0) {
	            return Optional.none();
	          } else {
	            var baseScope_1 = stringAttributes[0];
	            var scopes_1 = [
	              'row',
	              'col'
	            ];
	            var isMixed = exists(stringAttributes, function (attribute) {
	              return attribute !== baseScope_1 && contains(scopes_1, attribute);
	            });
	            return isMixed ? Optional.none() : Optional.from(baseScope_1);
	          }
	        };
	        remove$1(cells[0], 'width');
	        getScopeProperty().fold(function () {
	          return remove(cells[0], 'scope');
	        }, function (attribute) {
	          return set(cells[0], 'scope', attribute + 'group');
	        });
	        return constant(cells[0]);
	      };
	      return {
	        unmerge: unmerge,
	        merge: merge,
	        cursor: position.get
	      };
	    };
	    var Generators = {
	      modification: modification,
	      transform: transform$1,
	      merging: merging
	    };
	
	    var blockList = [
	      'body',
	      'p',
	      'div',
	      'article',
	      'aside',
	      'figcaption',
	      'figure',
	      'footer',
	      'header',
	      'nav',
	      'section',
	      'ol',
	      'ul',
	      'table',
	      'thead',
	      'tfoot',
	      'tbody',
	      'caption',
	      'tr',
	      'td',
	      'th',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'blockquote',
	      'pre',
	      'address'
	    ];
	    var isList = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains([
	        'ol',
	        'ul'
	      ], tagName);
	    };
	    var isBlock = function (universe, item) {
	      var tagName = universe.property().name(item);
	      return contains(blockList, tagName);
	    };
	    var isEmptyTag = function (universe, item) {
	      return contains([
	        'br',
	        'img',
	        'hr',
	        'input'
	      ], universe.property().name(item));
	    };
	
	    var universe$2 = DomUniverse();
	    var isBlock$1 = function (element) {
	      return isBlock(universe$2, element);
	    };
	    var isList$1 = function (element) {
	      return isList(universe$2, element);
	    };
	    var isEmptyTag$1 = function (element) {
	      return isEmptyTag(universe$2, element);
	    };
	
	    var merge$2 = function (cells) {
	      var isBr = function (el) {
	        return name(el) === 'br';
	      };
	      var advancedBr = function (children) {
	        return forall(children, function (c) {
	          return isBr(c) || isText(c) && get$4(c).trim().length === 0;
	        });
	      };
	      var isListItem = function (el) {
	        return name(el) === 'li' || ancestor(el, isList$1).isSome();
	      };
	      var siblingIsBlock = function (el) {
	        return nextSibling(el).map(function (rightSibling) {
	          if (isBlock$1(rightSibling)) {
	            return true;
	          }
	          if (isEmptyTag$1(rightSibling)) {
	            return name(rightSibling) === 'img' ? false : true;
	          }
	          return false;
	        }).getOr(false);
	      };
	      var markCell = function (cell) {
	        return last$1(cell).bind(function (rightEdge) {
	          var rightSiblingIsBlock = siblingIsBlock(rightEdge);
	          return parent(rightEdge).map(function (parent) {
	            return rightSiblingIsBlock === true || isListItem(parent) || isBr(rightEdge) || isBlock$1(parent) && !eq$1(cell, parent) ? [] : [SugarElement.fromTag('br')];
	          });
	        }).getOr([]);
	      };
	      var markContent = function () {
	        var content = bind(cells, function (cell) {
	          var children$1 = children(cell);
	          return advancedBr(children$1) ? [] : children$1.concat(markCell(cell));
	        });
	        return content.length === 0 ? [SugarElement.fromTag('br')] : content;
	      };
	      var contents = markContent();
	      empty(cells[0]);
	      append$1(cells[0], contents);
	    };
	
	    var prune = function (table) {
	      var cells$1 = cells(table);
	      if (cells$1.length === 0) {
	        remove$2(table);
	      }
	    };
	    var outcome = function (grid, cursor) {
	      return {
	        grid: grid,
	        cursor: cursor
	      };
	    };
	    var elementFromGrid = function (grid, row, column) {
	      var rows = extractGridDetails(grid).rows;
	      return findIn(rows, row, column).orThunk(function () {
	        return findIn(rows, 0, 0);
	      });
	    };
	    var findIn = function (grid, row, column) {
	      return Optional.from(grid[row]).bind(function (r) {
	        return Optional.from(r.cells[column]).bind(function (c) {
	          return Optional.from(c.element);
	        });
	      });
	    };
	    var bundle = function (grid, row, column) {
	      var rows = extractGridDetails(grid).rows;
	      return outcome(grid, findIn(rows, row, column));
	    };
	    var uniqueRows = function (details) {
	      var rowCompilation = function (rest, detail) {
	        var rowExists = exists(rest, function (currentDetail) {
	          return currentDetail.row === detail.row;
	        });
	        return rowExists ? rest : rest.concat([detail]);
	      };
	      return foldl(details, rowCompilation, []).sort(function (detailA, detailB) {
	        return detailA.row - detailB.row;
	      });
	    };
	    var opInsertRowsBefore = function (grid, details, comparator, genWrappers) {
	      var targetIndex = details[0].row;
	      var rows = uniqueRows(details);
	      var newGrid = foldr(rows, function (acc, row) {
	        var newG = insertRowAt(acc.grid, targetIndex, row.row + acc.delta, comparator, genWrappers.getOrInit);
	        return {
	          grid: newG,
	          delta: acc.delta + 1
	        };
	      }, {
	        grid: grid,
	        delta: 0
	      }).grid;
	      return bundle(newGrid, targetIndex, details[0].column);
	    };
	    var opInsertRowsAfter = function (grid, details, comparator, genWrappers) {
	      var rows = uniqueRows(details);
	      var target = rows[rows.length - 1];
	      var targetIndex = target.row + target.rowspan;
	      var newGrid = foldr(rows, function (newG, row) {
	        return insertRowAt(newG, targetIndex, row.row, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, targetIndex, details[0].column);
	    };
	    var opInsertColumnsBefore = function (grid, extractDetail, comparator, genWrappers) {
	      var details = extractDetail.details;
	      var columns = uniqueColumns(details);
	      var targetIndex = columns[0].column;
	      var newGrid = foldr(columns, function (acc, col) {
	        var newG = insertColumnAt(acc.grid, targetIndex, col.column + acc.delta, comparator, genWrappers.getOrInit);
	        return {
	          grid: newG,
	          delta: acc.delta + 1
	        };
	      }, {
	        grid: grid,
	        delta: 0
	      }).grid;
	      return bundle(newGrid, details[0].row, targetIndex);
	    };
	    var opInsertColumnsAfter = function (grid, extractDetail, comparator, genWrappers) {
	      var details = extractDetail.details;
	      var target = details[details.length - 1];
	      var targetIndex = target.column + target.colspan;
	      var columns = uniqueColumns(details);
	      var newGrid = foldr(columns, function (newG, col) {
	        return insertColumnAt(newG, targetIndex, col.column, comparator, genWrappers.getOrInit);
	      }, grid);
	      return bundle(newGrid, details[0].row, targetIndex);
	    };
	    var opMakeRowHeader = function (grid, detail, comparator, genWrappers) {
	      var newGrid = replaceRow(grid, detail.row, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row, detail.column);
	    };
	    var opMakeRowsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var rows = uniqueRows(details);
	      var replacer = function (currentGrid, row) {
	        return replaceRow(currentGrid, row.row, comparator, genWrappers.replaceOrInit);
	      };
	      var newGrid = foldl(rows, replacer, initialGrid);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opMakeColumnHeader = function (initialGrid, detail, comparator, genWrappers) {
	      var newGrid = replaceColumn(initialGrid, detail.column, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row, detail.column);
	    };
	    var opMakeColumnsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var columns = uniqueColumns(details);
	      var replacer = function (currentGrid, column) {
	        return replaceColumn(currentGrid, column.column, comparator, genWrappers.replaceOrInit);
	      };
	      var newGrid = foldl(columns, replacer, initialGrid);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opUnmakeRowHeader = function (grid, detail, comparator, genWrappers) {
	      var newGrid = replaceRow(grid, detail.row, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row, detail.column);
	    };
	    var opUnmakeRowsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var rows = uniqueRows(details);
	      var replacer = function (currentGrid, row) {
	        return replaceRow(currentGrid, row.row, comparator, genWrappers.replaceOrInit);
	      };
	      var newGrid = foldl(rows, replacer, initialGrid);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opUnmakeColumnHeader = function (initialGrid, detail, comparator, genWrappers) {
	      var newGrid = replaceColumn(initialGrid, detail.column, comparator, genWrappers.replaceOrInit);
	      return bundle(newGrid, detail.row, detail.column);
	    };
	    var opUnmakeColumnsHeader = function (initialGrid, details, comparator, genWrappers) {
	      var columns = uniqueColumns(details);
	      var replacer = function (currentGrid, column) {
	        return replaceColumn(currentGrid, column.column, comparator, genWrappers.replaceOrInit);
	      };
	      var newGrid = foldl(columns, replacer, initialGrid);
	      return bundle(newGrid, details[0].row, details[0].column);
	    };
	    var opEraseColumns = function (grid, extractDetail, _comparator, _genWrappers) {
	      var columns = uniqueColumns(extractDetail.details);
	      var newGrid = deleteColumnsAt(grid, map(columns, function (column) {
	        return column.column;
	      }));
	      var cursor = elementFromGrid(newGrid, columns[0].row, columns[0].column);
	      return outcome(newGrid, cursor);
	    };
	    var opEraseRows = function (grid, details, _comparator, _genWrappers) {
	      var rows = uniqueRows(details);
	      var newGrid = deleteRowsAt(grid, rows[0].row, rows[rows.length - 1].row);
	      var cursor = elementFromGrid(newGrid, details[0].row, details[0].column);
	      return outcome(newGrid, cursor);
	    };
	    var opMergeCells = function (grid, mergable, comparator, genWrappers) {
	      var cells = mergable.cells;
	      merge$2(cells);
	      var newGrid = merge(grid, mergable.bounds, comparator, genWrappers.merge(cells));
	      return outcome(newGrid, Optional.from(cells[0]));
	    };
	    var opUnmergeCells = function (grid, unmergable, comparator, genWrappers) {
	      var unmerge$1 = function (b, cell) {
	        return unmerge(b, cell, comparator, genWrappers.unmerge(cell));
	      };
	      var newGrid = foldr(unmergable, unmerge$1, grid);
	      return outcome(newGrid, Optional.from(unmergable[0]));
	    };
	    var opPasteCells = function (grid, pasteDetails, comparator, _genWrappers) {
	      var gridify = function (table, generators) {
	        var wh = Warehouse.fromTable(table);
	        return toGrid(wh, generators, true);
	      };
	      var gridB = gridify(pasteDetails.clipboard, pasteDetails.generators);
	      var startAddress = address(pasteDetails.row, pasteDetails.column);
	      var mergedGrid = merge$1(startAddress, grid, gridB, pasteDetails.generators, comparator);
	      return mergedGrid.fold(function () {
	        return outcome(grid, Optional.some(pasteDetails.element));
	      }, function (newGrid) {
	        var cursor = elementFromGrid(newGrid, pasteDetails.row, pasteDetails.column);
	        return outcome(newGrid, cursor);
	      });
	    };
	    var gridifyRows = function (rows, generators, context) {
	      var pasteDetails = fromPastedRows(rows, context.section);
	      var wh = Warehouse.generate(pasteDetails);
	      return toGrid(wh, generators, true);
	    };
	    var opPasteColsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[0].column;
	      var context = rows[pasteDetails.cells[0].row];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertCols(index, grid, gridB, pasteDetails.generators, comparator);
	      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	      return outcome(mergedGrid, cursor);
	    };
	    var opPasteColsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[pasteDetails.cells.length - 1].column + pasteDetails.cells[pasteDetails.cells.length - 1].colspan;
	      var context = rows[pasteDetails.cells[0].row];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertCols(index, grid, gridB, pasteDetails.generators, comparator);
	      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	      return outcome(mergedGrid, cursor);
	    };
	    var opPasteRowsBefore = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[0].row;
	      var context = rows[index];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertRows(index, grid, gridB, pasteDetails.generators, comparator);
	      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	      return outcome(mergedGrid, cursor);
	    };
	    var opPasteRowsAfter = function (grid, pasteDetails, comparator, _genWrappers) {
	      var rows = extractGridDetails(grid).rows;
	      var index = pasteDetails.cells[pasteDetails.cells.length - 1].row + pasteDetails.cells[pasteDetails.cells.length - 1].rowspan;
	      var context = rows[pasteDetails.cells[0].row];
	      var gridB = gridifyRows(pasteDetails.clipboard, pasteDetails.generators, context);
	      var mergedGrid = insertRows(index, grid, gridB, pasteDetails.generators, comparator);
	      var cursor = elementFromGrid(mergedGrid, pasteDetails.cells[0].row, pasteDetails.cells[0].column);
	      return outcome(mergedGrid, cursor);
	    };
	    var opGetColumnType = function (table, target) {
	      var house = Warehouse.fromTable(table);
	      var details = onCells(house, target);
	      return details.bind(function (selectedCells) {
	        var lastSelectedCell = selectedCells[selectedCells.length - 1];
	        var minColRange = selectedCells[0].column;
	        var maxColRange = lastSelectedCell.column + lastSelectedCell.colspan;
	        var selectedColumnCells = flatten(map(house.all, function (row) {
	          return filter(row.cells, function (cell) {
	            return cell.column >= minColRange && cell.column < maxColRange;
	          });
	        }));
	        return getCellsType(selectedColumnCells, function (cell) {
	          return name(cell.element) === 'th';
	        });
	      }).getOr('');
	    };
	    var getCellsType = function (cells, headerPred) {
	      var headerCells = filter(cells, headerPred);
	      if (headerCells.length === 0) {
	        return Optional.some('td');
	      } else if (headerCells.length === cells.length) {
	        return Optional.some('th');
	      } else {
	        return Optional.none();
	      }
	    };
	    var resize = adjustWidthTo;
	    var adjustAndRedistributeWidths$1 = adjustAndRedistributeWidths;
	    var firstColumnIsLocked = function (_warehouse, details) {
	      return exists(details, function (detail) {
	        return detail.column === 0 && detail.isLocked;
	      });
	    };
	    var lastColumnIsLocked = function (warehouse, details) {
	      return exists(details, function (detail) {
	        return detail.column + detail.colspan >= warehouse.grid.columns && detail.isLocked;
	      });
	    };
	    var getColumnsWidth = function (warehouse, details) {
	      var columns = columns$1(warehouse);
	      var uniqueCols = uniqueColumns(details);
	      return foldl(uniqueCols, function (acc, detail) {
	        var column = columns[detail.column];
	        var colWidth = column.map(getOuter).getOr(0);
	        return acc + colWidth;
	      }, 0);
	    };
	    var insertColumnsExtractor = function (before) {
	      return function (warehouse, target) {
	        return onCells(warehouse, target).filter(function (details) {
	          var checkLocked = before ? firstColumnIsLocked : lastColumnIsLocked;
	          return !checkLocked(warehouse, details);
	        }).map(function (details) {
	          return {
	            details: details,
	            pixelDelta: getColumnsWidth(warehouse, details)
	          };
	        });
	      };
	    };
	    var eraseColumnsExtractor = function (warehouse, target) {
	      return onUnlockedCells(warehouse, target).map(function (details) {
	        return {
	          details: details,
	          pixelDelta: -getColumnsWidth(warehouse, details)
	        };
	      });
	    };
	    var pasteColumnsExtractor = function (before) {
	      return function (warehouse, target) {
	        return onPasteByEditor(warehouse, target).filter(function (details) {
	          var checkLocked = before ? firstColumnIsLocked : lastColumnIsLocked;
	          return !checkLocked(warehouse, details.cells);
	        });
	      };
	    };
	    var insertRowsBefore = run(opInsertRowsBefore, onCells, noop, noop, Generators.modification);
	    var insertRowsAfter = run(opInsertRowsAfter, onCells, noop, noop, Generators.modification);
	    var insertColumnsBefore = run(opInsertColumnsBefore, insertColumnsExtractor(true), adjustAndRedistributeWidths$1, noop, Generators.modification);
	    var insertColumnsAfter = run(opInsertColumnsAfter, insertColumnsExtractor(false), adjustAndRedistributeWidths$1, noop, Generators.modification);
	    var eraseColumns = run(opEraseColumns, eraseColumnsExtractor, adjustAndRedistributeWidths$1, prune, Generators.modification);
	    var eraseRows = run(opEraseRows, onCells, noop, prune, Generators.modification);
	    var makeColumnHeader = run(opMakeColumnHeader, onUnlockedCell, noop, noop, Generators.transform('row', 'th'));
	    var makeColumnsHeader = run(opMakeColumnsHeader, onUnlockedCells, noop, noop, Generators.transform('row', 'th'));
	    var unmakeColumnHeader = run(opUnmakeColumnHeader, onUnlockedCell, noop, noop, Generators.transform(null, 'td'));
	    var unmakeColumnsHeader = run(opUnmakeColumnsHeader, onUnlockedCells, noop, noop, Generators.transform(null, 'td'));
	    var makeRowHeader = run(opMakeRowHeader, onCell, noop, noop, Generators.transform('col', 'th'));
	    var makeRowsHeader = run(opMakeRowsHeader, onCells, noop, noop, Generators.transform('col', 'th'));
	    var unmakeRowHeader = run(opUnmakeRowHeader, onCell, noop, noop, Generators.transform(null, 'td'));
	    var unmakeRowsHeader = run(opUnmakeRowsHeader, onCells, noop, noop, Generators.transform(null, 'td'));
	    var mergeCells = run(opMergeCells, onUnlockedMergable, resize, noop, Generators.merging);
	    var unmergeCells = run(opUnmergeCells, onUnlockedUnmergable, resize, noop, Generators.merging);
	    var pasteCells = run(opPasteCells, onPaste, resize, noop, Generators.modification);
	    var pasteColsBefore = run(opPasteColsBefore, pasteColumnsExtractor(true), noop, noop, Generators.modification);
	    var pasteColsAfter = run(opPasteColsAfter, pasteColumnsExtractor(false), noop, noop, Generators.modification);
	    var pasteRowsBefore = run(opPasteRowsBefore, onPasteByEditor, noop, noop, Generators.modification);
	    var pasteRowsAfter = run(opPasteRowsAfter, onPasteByEditor, noop, noop, Generators.modification);
	    var getColumnType = opGetColumnType;
	
	    var getSection = function (elm) {
	      return getNodeName(elm.parentNode);
	    };
	    var mapSectionNameToType = function (section) {
	      if (section === 'thead') {
	        return 'header';
	      } else if (section === 'tfoot') {
	        return 'footer';
	      } else {
	        return 'body';
	      }
	    };
	    var detectHeaderRow = function (editor, elm) {
	      var isThead = getSection(elm) === 'thead';
	      var areAllCellsThs = !exists(elm.cells, function (c) {
	        return getNodeName(c) !== 'th';
	      });
	      return isThead || areAllCellsThs ? Optional.some({
	        thead: isThead,
	        ths: areAllCellsThs
	      }) : Optional.none();
	    };
	    var getRowType = function (editor, elm) {
	      return mapSectionNameToType(detectHeaderRow(editor, elm).fold(function () {
	        return getSection(elm);
	      }, function (_rowConfig) {
	        return 'thead';
	      }));
	    };
	    var switchRowSection = function (dom, rowElm, newSectionName) {
	      var tableElm = dom.getParent(rowElm, 'table');
	      var oldSectionElm = rowElm.parentNode;
	      var oldSectionName = getNodeName(oldSectionElm);
	      if (newSectionName !== oldSectionName) {
	        var sectionElm_1 = dom.select(newSectionName, tableElm)[0];
	        if (!sectionElm_1) {
	          sectionElm_1 = dom.create(newSectionName);
	          var firstTableChild_1 = tableElm.firstChild;
	          if (newSectionName === 'thead') {
	            last(children$2(SugarElement.fromDom(tableElm), 'caption,colgroup')).fold(function () {
	              return tableElm.insertBefore(sectionElm_1, firstTableChild_1);
	            }, function (c) {
	              return dom.insertAfter(sectionElm_1, c.dom);
	            });
	          } else {
	            tableElm.appendChild(sectionElm_1);
	          }
	        }
	        if (newSectionName === 'tbody' && oldSectionName === 'thead' && sectionElm_1.firstChild) {
	          sectionElm_1.insertBefore(rowElm, sectionElm_1.firstChild);
	        } else {
	          sectionElm_1.appendChild(rowElm);
	        }
	        if (!oldSectionElm.hasChildNodes()) {
	          dom.remove(oldSectionElm);
	        }
	      }
	    };
	    var renameCell = function (editor, cell, newCellType) {
	      if (isNonNullable(newCellType) && getNodeName(cell) !== newCellType) {
	        var newCellElm = editor.dom.rename(cell, newCellType);
	        fireNewCell(editor, newCellElm);
	        return newCellElm;
	      } else {
	        return cell;
	      }
	    };
	    var switchCellType = function (editor, cell, newCellType, scope) {
	      var dom = editor.dom;
	      var newCell = renameCell(editor, cell, newCellType);
	      if (!isUndefined(scope)) {
	        dom.setAttrib(newCell, 'scope', scope);
	      }
	      return newCell;
	    };
	    var switchCellsType = function (editor, cells, newCellType, scope) {
	      return each(cells, function (c) {
	        return switchCellType(editor, c, newCellType, scope);
	      });
	    };
	    var switchSectionType = function (editor, rowElm, newType) {
	      var determineHeaderRowType = function () {
	        var allTableRows = table(SugarElement.fromDom(rowElm.cells[0])).map(function (table) {
	          return rows(table);
	        }).getOr([]);
	        return findMap(allTableRows, function (row) {
	          return detectHeaderRow(editor, row.dom);
	        }).map(function (detectedType) {
	          if (detectedType.thead && detectedType.ths) {
	            return 'sectionCells';
	          } else {
	            return detectedType.thead ? 'section' : 'cells';
	          }
	        }).getOr('section');
	      };
	      var dom = editor.dom;
	      if (newType === 'header') {
	        var headerRowTypeSetting = getTableHeaderType(editor);
	        var headerRowType = headerRowTypeSetting === 'auto' ? determineHeaderRowType() : headerRowTypeSetting;
	        switchCellsType(editor, rowElm.cells, headerRowType === 'section' ? 'td' : 'th', 'col');
	        switchRowSection(dom, rowElm, headerRowType === 'cells' ? 'tbody' : 'thead');
	      } else {
	        switchCellsType(editor, rowElm.cells, 'td', null);
	        switchRowSection(dom, rowElm, newType === 'footer' ? 'tfoot' : 'tbody');
	      }
	    };
	
	    var getSelectionStartCellFallback = function (start) {
	      return table(start).bind(function (table) {
	        return retrieve$1(table, ephemera.firstSelectedSelector);
	      }).fold(function () {
	        return start;
	      }, function (cells) {
	        return cells[0];
	      });
	    };
	    var getSelectionStartFromSelector = function (selector) {
	      return function (start, isRoot) {
	        var startCellName = name(start);
	        var startCell = startCellName === 'col' || startCellName === 'colgroup' ? getSelectionStartCellFallback(start) : start;
	        return closest$1(startCell, selector, isRoot);
	      };
	    };
	    var getSelectionStartCell = getSelectionStartFromSelector('th,td');
	    var getSelectionStartCellOrCaption = getSelectionStartFromSelector('th,td,caption');
	    var getCellsFromSelection = function (start, selections, isRoot) {
	      return getSelectionStartCell(start, isRoot).map(function (_cell) {
	        return selection(selections);
	      }).getOr([]);
	    };
	    var getRowsFromSelection = function (start, selector) {
	      var cellOpt = getSelectionStartCell(start);
	      var rowsOpt = cellOpt.bind(function (cell) {
	        return table(cell);
	      }).map(function (table) {
	        return rows(table);
	      });
	      return lift2(cellOpt, rowsOpt, function (cell, rows) {
	        return filter(rows, function (row) {
	          return exists(fromDom$1(row.dom.cells), function (rowCell) {
	            return get$2(rowCell, selector) === '1' || eq$1(rowCell, cell);
	          });
	        });
	      }).getOr([]);
	    };
	
	    var TableActions = function (editor, lazyWire, selections) {
	      var isTableBody = function (editor) {
	        return name(getBody$1(editor)) === 'table';
	      };
	      var lastRowGuard = function (table) {
	        return isTableBody(editor) === false || getGridSize(table).rows > 1;
	      };
	      var lastColumnGuard = function (table) {
	        return isTableBody(editor) === false || getGridSize(table).columns > 1;
	      };
	      var cloneFormats = getCloneElements(editor);
	      var colMutationOp = isResizeTableColumnResizing(editor) ? noop : halve;
	      var execute = function (operation, guard, mutate, lazyWire, effect) {
	        return function (table, target) {
	          removeDataStyle(table);
	          var wire = lazyWire();
	          var doc = SugarElement.fromDom(editor.getDoc());
	          var generators = cellOperations(mutate, doc, cloneFormats);
	          var sizing = get$9(editor, table);
	          var resizeBehaviour = isResizeTableColumnResizing(editor) ? resizeTable() : preserveTable();
	          return guard(table) ? operation(wire, table, target, generators, sizing, resizeBehaviour).bind(function (result) {
	            each(result.newRows, function (row) {
	              fireNewRow(editor, row.dom);
	            });
	            each(result.newCells, function (cell) {
	              fireNewCell(editor, cell.dom);
	            });
	            return result.cursor.map(function (cell) {
	              var des = freefallRtl$2(cell);
	              var rng = editor.dom.createRng();
	              rng.setStart(des.element.dom, des.offset);
	              rng.setEnd(des.element.dom, des.offset);
	              return {
	                rng: rng,
	                effect: effect
	              };
	            });
	          }) : Optional.none();
	        };
	      };
	      var deleteRow = execute(eraseRows, lastRowGuard, noop, lazyWire, structureModified);
	      var deleteColumn = execute(eraseColumns, lastColumnGuard, noop, lazyWire, structureModified);
	      var insertRowsBefore$1 = execute(insertRowsBefore, always, noop, lazyWire, structureModified);
	      var insertRowsAfter$1 = execute(insertRowsAfter, always, noop, lazyWire, structureModified);
	      var insertColumnsBefore$1 = execute(insertColumnsBefore, always, colMutationOp, lazyWire, structureModified);
	      var insertColumnsAfter$1 = execute(insertColumnsAfter, always, colMutationOp, lazyWire, structureModified);
	      var mergeCells$1 = execute(mergeCells, always, noop, lazyWire, structureModified);
	      var unmergeCells$1 = execute(unmergeCells, always, noop, lazyWire, structureModified);
	      var pasteColsBefore$1 = execute(pasteColsBefore, always, noop, lazyWire, structureModified);
	      var pasteColsAfter$1 = execute(pasteColsAfter, always, noop, lazyWire, structureModified);
	      var pasteRowsBefore$1 = execute(pasteRowsBefore, always, noop, lazyWire, structureModified);
	      var pasteRowsAfter$1 = execute(pasteRowsAfter, always, noop, lazyWire, structureModified);
	      var pasteCells$1 = execute(pasteCells, always, noop, lazyWire, structureModified);
	      var extractType = function (args, validTypes) {
	        return get$1(args, 'type').filter(function (type) {
	          return contains(validTypes, type);
	        });
	      };
	      var setTableCellType = function (editor, args) {
	        return extractType(args, [
	          'td',
	          'th'
	        ]).each(function (type) {
	          var cells = map(getCellsFromSelection(getSelectionStart(editor), selections), function (c) {
	            return c.dom;
	          });
	          switchCellsType(editor, cells, type, null);
	        });
	      };
	      var setTableRowType = function (editor, args) {
	        return extractType(args, [
	          'header',
	          'body',
	          'footer'
	        ]).each(function (type) {
	          map(getRowsFromSelection(getSelectionStart(editor), ephemera.selected), function (row) {
	            return switchSectionType(editor, row.dom, type);
	          });
	        });
	      };
	      var makeColumnsHeader$1 = execute(makeColumnsHeader, always, noop, lazyWire, structureModified);
	      var unmakeColumnsHeader$1 = execute(unmakeColumnsHeader, always, noop, lazyWire, structureModified);
	      var getTableRowType = function (editor) {
	        var rows = getRowsFromSelection(getSelectionStart(editor), ephemera.selected);
	        if (rows.length > 0) {
	          var rowTypes = map(rows, function (r) {
	            return getRowType(editor, r.dom);
	          });
	          var hasHeader = contains(rowTypes, 'header');
	          var hasFooter = contains(rowTypes, 'footer');
	          if (!hasHeader && !hasFooter) {
	            return 'body';
	          } else {
	            var hasBody = contains(rowTypes, 'body');
	            if (hasHeader && !hasBody && !hasFooter) {
	              return 'header';
	            } else if (!hasHeader && !hasBody && hasFooter) {
	              return 'footer';
	            } else {
	              return '';
	            }
	          }
	        }
	      };
	      var getTableCellType = function (editor) {
	        return getCellsType(getCellsFromSelection(getSelectionStart(editor), selections), function (cell) {
	          return name(cell) === 'th';
	        }).getOr('');
	      };
	      var getTableColType = getColumnType;
	      return {
	        deleteRow: deleteRow,
	        deleteColumn: deleteColumn,
	        insertRowsBefore: insertRowsBefore$1,
	        insertRowsAfter: insertRowsAfter$1,
	        insertColumnsBefore: insertColumnsBefore$1,
	        insertColumnsAfter: insertColumnsAfter$1,
	        mergeCells: mergeCells$1,
	        unmergeCells: unmergeCells$1,
	        pasteColsBefore: pasteColsBefore$1,
	        pasteColsAfter: pasteColsAfter$1,
	        pasteRowsBefore: pasteRowsBefore$1,
	        pasteRowsAfter: pasteRowsAfter$1,
	        pasteCells: pasteCells$1,
	        setTableCellType: setTableCellType,
	        setTableRowType: setTableRowType,
	        makeColumnsHeader: makeColumnsHeader$1,
	        unmakeColumnsHeader: unmakeColumnsHeader$1,
	        getTableRowType: getTableRowType,
	        getTableCellType: getTableCellType,
	        getTableColType: getTableColType
	      };
	    };
	
	    var DefaultRenderOptions = {
	      styles: {
	        'border-collapse': 'collapse',
	        'width': '100%'
	      },
	      attributes: { border: '1' },
	      colGroups: false
	    };
	    var tableHeaderCell = function () {
	      return SugarElement.fromTag('th');
	    };
	    var tableCell = function () {
	      return SugarElement.fromTag('td');
	    };
	    var tableColumn = function () {
	      return SugarElement.fromTag('col');
	    };
	    var createRow = function (columns, rowHeaders, columnHeaders, rowIndex) {
	      var tr = SugarElement.fromTag('tr');
	      for (var j = 0; j < columns; j++) {
	        var td = rowIndex < rowHeaders || j < columnHeaders ? tableHeaderCell() : tableCell();
	        if (j < columnHeaders) {
	          set(td, 'scope', 'row');
	        }
	        if (rowIndex < rowHeaders) {
	          set(td, 'scope', 'col');
	        }
	        append(td, SugarElement.fromTag('br'));
	        append(tr, td);
	      }
	      return tr;
	    };
	    var createGroupRow = function (columns) {
	      var columnGroup = SugarElement.fromTag('colgroup');
	      range(columns, function () {
	        return append(columnGroup, tableColumn());
	      });
	      return columnGroup;
	    };
	    var createRows = function (rows, columns, rowHeaders, columnHeaders) {
	      return range(rows, function (r) {
	        return createRow(columns, rowHeaders, columnHeaders, r);
	      });
	    };
	    var render$1 = function (rows, columns, rowHeaders, columnHeaders, headerType, renderOpts) {
	      if (renderOpts === void 0) {
	        renderOpts = DefaultRenderOptions;
	      }
	      var table = SugarElement.fromTag('table');
	      var rowHeadersGoInThead = headerType !== 'cells';
	      setAll$1(table, renderOpts.styles);
	      setAll(table, renderOpts.attributes);
	      if (renderOpts.colGroups) {
	        append(table, createGroupRow(columns));
	      }
	      var actualRowHeaders = Math.min(rows, rowHeaders);
	      if (rowHeadersGoInThead && rowHeaders > 0) {
	        var thead = SugarElement.fromTag('thead');
	        append(table, thead);
	        var theadRowHeaders = headerType === 'sectionCells' ? actualRowHeaders : 0;
	        var theadRows = createRows(rowHeaders, columns, theadRowHeaders, columnHeaders);
	        append$1(thead, theadRows);
	      }
	      var tbody = SugarElement.fromTag('tbody');
	      append(table, tbody);
	      var numRows = rowHeadersGoInThead ? rows - actualRowHeaders : rows;
	      var numRowHeaders = rowHeadersGoInThead ? 0 : rowHeaders;
	      var tbodyRows = createRows(numRows, columns, numRowHeaders, columnHeaders);
	      append$1(tbody, tbodyRows);
	      return table;
	    };
	
	    var get$b = function (element) {
	      return element.dom.innerHTML;
	    };
	    var getOuter$2 = function (element) {
	      var container = SugarElement.fromTag('div');
	      var clone = SugarElement.fromDom(element.dom.cloneNode(true));
	      append(container, clone);
	      return get$b(container);
	    };
	
	    var placeCaretInCell = function (editor, cell) {
	      editor.selection.select(cell.dom, true);
	      editor.selection.collapse(true);
	    };
	    var selectFirstCellInTable = function (editor, tableElm) {
	      descendant$1(tableElm, 'td,th').each(curry(placeCaretInCell, editor));
	    };
	    var fireEvents = function (editor, table) {
	      each(descendants$1(table, 'tr'), function (row) {
	        fireNewRow(editor, row.dom);
	        each(descendants$1(row, 'th,td'), function (cell) {
	          fireNewCell(editor, cell.dom);
	        });
	      });
	    };
	    var isPercentage$1 = function (width) {
	      return isString(width) && width.indexOf('%') !== -1;
	    };
	    var insert$1 = function (editor, columns, rows, colHeaders, rowHeaders) {
	      var defaultStyles = getDefaultStyles(editor);
	      var options = {
	        styles: defaultStyles,
	        attributes: getDefaultAttributes(editor),
	        colGroups: useColumnGroup(editor)
	      };
	      editor.undoManager.ignore(function () {
	        var table = render$1(rows, columns, rowHeaders, colHeaders, getTableHeaderType(editor), options);
	        set(table, 'data-mce-id', '__mce');
	        var html = getOuter$2(table);
	        editor.insertContent(html);
	        editor.addVisual();
	      });
	      return descendant$1(getBody$1(editor), 'table[data-mce-id="__mce"]').map(function (table) {
	        if (isPixelsForced(editor)) {
	          enforcePixels(editor, table);
	        } else if (isResponsiveForced(editor)) {
	          enforceNone(table);
	        } else if (isPercentagesForced(editor) || isPercentage$1(defaultStyles.width)) {
	          enforcePercentage(editor, table);
	        }
	        removeDataStyle(table);
	        remove(table, 'data-mce-id');
	        fireEvents(editor, table);
	        selectFirstCellInTable(editor, table);
	        return table.dom;
	      }).getOr(null);
	    };
	    var insertTableWithDataValidation = function (editor, rows, columns, options, errorMsg) {
	      if (options === void 0) {
	        options = {};
	      }
	      var checkInput = function (val) {
	        return isNumber(val) && val > 0;
	      };
	      if (checkInput(rows) && checkInput(columns)) {
	        var headerRows = options.headerRows || 0;
	        var headerColumns = options.headerColumns || 0;
	        return insert$1(editor, columns, rows, headerColumns, headerRows);
	      } else {
	        console.error(errorMsg);
	        return null;
	      }
	    };
	
	    var getClipboardElements = function (getClipboard) {
	      return function () {
	        return getClipboard().fold(function () {
	          return [];
	        }, function (elems) {
	          return map(elems, function (e) {
	            return e.dom;
	          });
	        });
	      };
	    };
	    var setClipboardElements = function (setClipboard) {
	      return function (elems) {
	        var elmsOpt = elems.length > 0 ? Optional.some(fromDom$1(elems)) : Optional.none();
	        setClipboard(elmsOpt);
	      };
	    };
	    var insertTable = function (editor) {
	      return function (columns, rows, options) {
	        if (options === void 0) {
	          options = {};
	        }
	        var table = insertTableWithDataValidation(editor, rows, columns, options, 'Invalid values for insertTable - rows and columns values are required to insert a table.');
	        editor.undoManager.add();
	        return table;
	      };
	    };
	    var getApi = function (editor, clipboard, resizeHandler, selectionTargets) {
	      return {
	        insertTable: insertTable(editor),
	        setClipboardRows: setClipboardElements(clipboard.setRows),
	        getClipboardRows: getClipboardElements(clipboard.getRows),
	        setClipboardCols: setClipboardElements(clipboard.setColumns),
	        getClipboardCols: getClipboardElements(clipboard.getColumns),
	        resizeHandler: resizeHandler,
	        selectionTargets: selectionTargets
	      };
	    };
	
	    var constrainSpan = function (element, property, value) {
	      var currentColspan = getAttrValue(element, property, 1);
	      if (value === 1 || currentColspan <= 1) {
	        remove(element, property);
	      } else {
	        set(element, property, Math.min(value, currentColspan));
	      }
	    };
	    var generateColGroup = function (house, minColRange, maxColRange) {
	      if (Warehouse.hasColumns(house)) {
	        var colsToCopy = filter(Warehouse.justColumns(house), function (col) {
	          return col.column >= minColRange && col.column < maxColRange;
	        });
	        var copiedCols = map(colsToCopy, function (c) {
	          var clonedCol = deep(c.element);
	          constrainSpan(clonedCol, 'span', maxColRange - minColRange);
	          return clonedCol;
	        });
	        var fakeColgroup = SugarElement.fromTag('colgroup');
	        append$1(fakeColgroup, copiedCols);
	        return [fakeColgroup];
	      } else {
	        return [];
	      }
	    };
	    var generateRows = function (house, minColRange, maxColRange) {
	      return map(house.all, function (row) {
	        var cellsToCopy = filter(row.cells, function (cell) {
	          return cell.column >= minColRange && cell.column < maxColRange;
	        });
	        var copiedCells = map(cellsToCopy, function (cell) {
	          var clonedCell = deep(cell.element);
	          constrainSpan(clonedCell, 'colspan', maxColRange - minColRange);
	          return clonedCell;
	        });
	        var fakeTR = SugarElement.fromTag('tr');
	        append$1(fakeTR, copiedCells);
	        return fakeTR;
	      });
	    };
	    var copyCols = function (table, target) {
	      var house = Warehouse.fromTable(table);
	      var details = onUnlockedCells(house, target);
	      return details.map(function (selectedCells) {
	        var lastSelectedCell = selectedCells[selectedCells.length - 1];
	        var minColRange = selectedCells[0].column;
	        var maxColRange = lastSelectedCell.column + lastSelectedCell.colspan;
	        var fakeColGroups = generateColGroup(house, minColRange, maxColRange);
	        var fakeRows = generateRows(house, minColRange, maxColRange);
	        return __spreadArrays(fakeColGroups, fakeRows);
	      });
	    };
	
	    var copyRows = function (table, target, generators) {
	      var warehouse = Warehouse.fromTable(table);
	      var details = onCells(warehouse, target);
	      return details.bind(function (selectedCells) {
	        var grid = toGrid(warehouse, generators, false);
	        var rows = extractGridDetails(grid).rows;
	        var slicedGrid = rows.slice(selectedCells[0].row, selectedCells[selectedCells.length - 1].row + selectedCells[selectedCells.length - 1].rowspan);
	        var filteredGrid = bind(slicedGrid, function (row) {
	          var newCells = filter(row.cells, function (cell) {
	            return !cell.isLocked;
	          });
	          return newCells.length > 0 ? [__assign(__assign({}, row), { cells: newCells })] : [];
	        });
	        var slicedDetails = toDetailList(filteredGrid, generators);
	        return someIf(slicedDetails.length > 0, slicedDetails);
	      }).map(function (slicedDetails) {
	        return copy$2(slicedDetails);
	      });
	    };
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var getTDTHOverallStyle = function (dom, elm, name) {
	      var cells = dom.select('td,th', elm);
	      var firstChildStyle;
	      var checkChildren = function (firstChildStyle, elms) {
	        for (var i = 0; i < elms.length; i++) {
	          var currentStyle = dom.getStyle(elms[i], name);
	          if (typeof firstChildStyle === 'undefined') {
	            firstChildStyle = currentStyle;
	          }
	          if (firstChildStyle !== currentStyle) {
	            return '';
	          }
	        }
	        return firstChildStyle;
	      };
	      return checkChildren(firstChildStyle, cells);
	    };
	    var applyAlign = function (editor, elm, name) {
	      if (name) {
	        editor.formatter.apply('align' + name, {}, elm);
	      }
	    };
	    var applyVAlign = function (editor, elm, name) {
	      if (name) {
	        editor.formatter.apply('valign' + name, {}, elm);
	      }
	    };
	    var unApplyAlign = function (editor, elm) {
	      global$1.each('left center right'.split(' '), function (name) {
	        editor.formatter.remove('align' + name, {}, elm);
	      });
	    };
	    var unApplyVAlign = function (editor, elm) {
	      global$1.each('top middle bottom'.split(' '), function (name) {
	        editor.formatter.remove('valign' + name, {}, elm);
	      });
	    };
	
	    var isListGroup = function (item) {
	      return hasNonNullableKey(item, 'menu');
	    };
	    var buildListItems = function (inputList, startItems) {
	      var appendItems = function (values, acc) {
	        return acc.concat(map(values, function (item) {
	          var text = item.text || item.title;
	          if (isListGroup(item)) {
	            return {
	              text: text,
	              items: buildListItems(item.menu)
	            };
	          } else {
	            return {
	              text: text,
	              value: item.value
	            };
	          }
	        }));
	      };
	      return appendItems(inputList, startItems || []);
	    };
	    var rgbToHex = function (dom) {
	      return function (value) {
	        return startsWith(value, 'rgb') ? dom.toHex(value) : value;
	      };
	    };
	    var extractAdvancedStyles = function (dom, elm) {
	      var element = SugarElement.fromDom(elm);
	      return {
	        borderwidth: getRaw(element, 'border-width').getOr(''),
	        borderstyle: getRaw(element, 'border-style').getOr(''),
	        bordercolor: getRaw(element, 'border-color').map(rgbToHex(dom)).getOr(''),
	        backgroundcolor: getRaw(element, 'background-color').map(rgbToHex(dom)).getOr('')
	      };
	    };
	    var getSharedValues = function (data) {
	      var baseData = data[0];
	      var comparisonData = data.slice(1);
	      each(comparisonData, function (items) {
	        each(keys(baseData), function (key) {
	          each$1(items, function (itemValue, itemKey) {
	            var comparisonValue = baseData[key];
	            if (comparisonValue !== '' && key === itemKey) {
	              if (comparisonValue !== itemValue) {
	                baseData[key] = '';
	              }
	            }
	          });
	        });
	      });
	      return baseData;
	    };
	    var getAdvancedTab = function (dialogName) {
	      var advTabItems = [
	        {
	          name: 'borderstyle',
	          type: 'listbox',
	          label: 'Border style',
	          items: [
	            {
	              text: 'Select...',
	              value: ''
	            },
	            {
	              text: 'Solid',
	              value: 'solid'
	            },
	            {
	              text: 'Dotted',
	              value: 'dotted'
	            },
	            {
	              text: 'Dashed',
	              value: 'dashed'
	            },
	            {
	              text: 'Double',
	              value: 'double'
	            },
	            {
	              text: 'Groove',
	              value: 'groove'
	            },
	            {
	              text: 'Ridge',
	              value: 'ridge'
	            },
	            {
	              text: 'Inset',
	              value: 'inset'
	            },
	            {
	              text: 'Outset',
	              value: 'outset'
	            },
	            {
	              text: 'None',
	              value: 'none'
	            },
	            {
	              text: 'Hidden',
	              value: 'hidden'
	            }
	          ]
	        },
	        {
	          name: 'bordercolor',
	          type: 'colorinput',
	          label: 'Border color'
	        },
	        {
	          name: 'backgroundcolor',
	          type: 'colorinput',
	          label: 'Background color'
	        }
	      ];
	      var borderWidth = {
	        name: 'borderwidth',
	        type: 'input',
	        label: 'Border width'
	      };
	      var items = dialogName === 'cell' ? [borderWidth].concat(advTabItems) : advTabItems;
	      return {
	        title: 'Advanced',
	        name: 'advanced',
	        items: items
	      };
	    };
	    var getAlignment = function (formats, formatName, editor, elm) {
	      return find(formats, function (name) {
	        return editor.formatter.matchNode(elm, formatName + name);
	      }).getOr('');
	    };
	    var getHAlignment = curry(getAlignment, [
	      'left',
	      'center',
	      'right'
	    ], 'align');
	    var getVAlignment = curry(getAlignment, [
	      'top',
	      'middle',
	      'bottom'
	    ], 'valign');
	    var extractDataFromSettings = function (editor, hasAdvTableTab) {
	      var style = getDefaultStyles(editor);
	      var attrs = getDefaultAttributes(editor);
	      var extractAdvancedStyleData = function (dom) {
	        return {
	          borderstyle: get$1(style, 'border-style').getOr(''),
	          bordercolor: rgbToHex(dom)(get$1(style, 'border-color').getOr('')),
	          backgroundcolor: rgbToHex(dom)(get$1(style, 'background-color').getOr(''))
	        };
	      };
	      var defaultData = {
	        height: '',
	        width: '100%',
	        cellspacing: '',
	        cellpadding: '',
	        caption: false,
	        class: '',
	        align: '',
	        border: ''
	      };
	      var getBorder = function () {
	        var borderWidth = style['border-width'];
	        if (shouldStyleWithCss(editor) && borderWidth) {
	          return { border: borderWidth };
	        }
	        return get$1(attrs, 'border').fold(function () {
	          return {};
	        }, function (border) {
	          return { border: border };
	        });
	      };
	      var advStyle = hasAdvTableTab ? extractAdvancedStyleData(editor.dom) : {};
	      var getCellPaddingCellSpacing = function () {
	        var spacing = get$1(style, 'border-spacing').or(get$1(attrs, 'cellspacing')).fold(function () {
	          return {};
	        }, function (cellspacing) {
	          return { cellspacing: cellspacing };
	        });
	        var padding = get$1(style, 'border-padding').or(get$1(attrs, 'cellpadding')).fold(function () {
	          return {};
	        }, function (cellpadding) {
	          return { cellpadding: cellpadding };
	        });
	        return __assign(__assign({}, spacing), padding);
	      };
	      var data = __assign(__assign(__assign(__assign(__assign(__assign({}, defaultData), style), attrs), advStyle), getBorder()), getCellPaddingCellSpacing());
	      return data;
	    };
	    var extractDataFromTableElement = function (editor, elm, hasAdvTableTab) {
	      var getBorder = function (dom, elm) {
	        var optBorderWidth = getRaw(SugarElement.fromDom(elm), 'border-width');
	        if (shouldStyleWithCss(editor) && optBorderWidth.isSome()) {
	          return optBorderWidth.getOr('');
	        }
	        return dom.getAttrib(elm, 'border') || getTDTHOverallStyle(editor.dom, elm, 'border-width') || getTDTHOverallStyle(editor.dom, elm, 'border');
	      };
	      var dom = editor.dom;
	      return __assign({
	        width: dom.getStyle(elm, 'width') || dom.getAttrib(elm, 'width'),
	        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
	        cellspacing: dom.getStyle(elm, 'border-spacing') || dom.getAttrib(elm, 'cellspacing'),
	        cellpadding: dom.getAttrib(elm, 'cellpadding') || getTDTHOverallStyle(editor.dom, elm, 'padding'),
	        border: getBorder(dom, elm),
	        caption: !!dom.select('caption', elm)[0],
	        class: dom.getAttrib(elm, 'class', ''),
	        align: getHAlignment(editor, elm)
	      }, hasAdvTableTab ? extractAdvancedStyles(dom, elm) : {});
	    };
	    var extractDataFromRowElement = function (editor, elm, hasAdvancedRowTab) {
	      var dom = editor.dom;
	      return __assign({
	        height: dom.getStyle(elm, 'height') || dom.getAttrib(elm, 'height'),
	        class: dom.getAttrib(elm, 'class', ''),
	        type: getRowType(editor, elm),
	        align: getHAlignment(editor, elm)
	      }, hasAdvancedRowTab ? extractAdvancedStyles(dom, elm) : {});
	    };
	    var extractDataFromCellElement = function (editor, cell, hasAdvancedCellTab, column) {
	      var dom = editor.dom;
	      var colElm = column.getOr(cell);
	      var getStyle = function (element, style) {
	        return dom.getStyle(element, style) || dom.getAttrib(element, style);
	      };
	      return __assign({
	        width: getStyle(colElm, 'width'),
	        height: getStyle(cell, 'height'),
	        scope: dom.getAttrib(cell, 'scope'),
	        celltype: getNodeName(cell),
	        class: dom.getAttrib(cell, 'class', ''),
	        halign: getHAlignment(editor, cell),
	        valign: getVAlignment(editor, cell)
	      }, hasAdvancedCellTab ? extractAdvancedStyles(dom, cell) : {});
	    };
	
	    var getClassList = function (editor) {
	      var classes = buildListItems(getCellClassList(editor));
	      if (classes.length > 0) {
	        return Optional.some({
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          items: classes
	        });
	      }
	      return Optional.none();
	    };
	    var children$3 = [
	      {
	        name: 'width',
	        type: 'input',
	        label: 'Width'
	      },
	      {
	        name: 'height',
	        type: 'input',
	        label: 'Height'
	      },
	      {
	        name: 'celltype',
	        type: 'listbox',
	        label: 'Cell type',
	        items: [
	          {
	            text: 'Cell',
	            value: 'td'
	          },
	          {
	            text: 'Header cell',
	            value: 'th'
	          }
	        ]
	      },
	      {
	        name: 'scope',
	        type: 'listbox',
	        label: 'Scope',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Row',
	            value: 'row'
	          },
	          {
	            text: 'Column',
	            value: 'col'
	          },
	          {
	            text: 'Row group',
	            value: 'rowgroup'
	          },
	          {
	            text: 'Column group',
	            value: 'colgroup'
	          }
	        ]
	      },
	      {
	        name: 'halign',
	        type: 'listbox',
	        label: 'Horizontal align',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Left',
	            value: 'left'
	          },
	          {
	            text: 'Center',
	            value: 'center'
	          },
	          {
	            text: 'Right',
	            value: 'right'
	          }
	        ]
	      },
	      {
	        name: 'valign',
	        type: 'listbox',
	        label: 'Vertical align',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Top',
	            value: 'top'
	          },
	          {
	            text: 'Middle',
	            value: 'middle'
	          },
	          {
	            text: 'Bottom',
	            value: 'bottom'
	          }
	        ]
	      }
	    ];
	    var getItems = function (editor) {
	      return children$3.concat(getClassList(editor).toArray());
	    };
	
	    var modifiers = function (testTruthy) {
	      return function (editor, node) {
	        var dom = editor.dom;
	        var setAttrib = function (attr, value) {
	          if (!testTruthy || value) {
	            dom.setAttrib(node, attr, value);
	          }
	        };
	        var setStyle = function (prop, value) {
	          if (!testTruthy || value) {
	            dom.setStyle(node, prop, value);
	          }
	        };
	        var setFormat = function (formatName, value) {
	          if (!testTruthy || value) {
	            if (value === '') {
	              editor.formatter.remove(formatName, { value: null }, node, true);
	            } else {
	              editor.formatter.apply(formatName, { value: value }, node);
	            }
	          }
	        };
	        return {
	          setAttrib: setAttrib,
	          setStyle: setStyle,
	          setFormat: setFormat
	        };
	      };
	    };
	    var DomModifier = {
	      normal: modifiers(false),
	      ifTruthy: modifiers(true)
	    };
	
	    var getSelectedCells = function (cells) {
	      return table(cells[0]).map(function (table) {
	        var warehouse = Warehouse.fromTable(table);
	        var allCells = Warehouse.justCells(warehouse);
	        var filtered = filter(allCells, function (cellA) {
	          return exists(cells, function (cellB) {
	            return eq$1(cellA.element, cellB);
	          });
	        });
	        return map(filtered, function (cell) {
	          return {
	            element: cell.element.dom,
	            column: Warehouse.getColumnAt(warehouse, cell.column).map(function (col) {
	              return col.element.dom;
	            })
	          };
	        });
	      });
	    };
	    var updateSimpleProps = function (modifier, colModifier, data) {
	      modifier.setAttrib('scope', data.scope);
	      modifier.setAttrib('class', data.class);
	      modifier.setStyle('height', addPxSuffix(data.height));
	      colModifier.setStyle('width', addPxSuffix(data.width));
	    };
	    var updateAdvancedProps = function (modifier, data) {
	      modifier.setFormat('tablecellbackgroundcolor', data.backgroundcolor);
	      modifier.setFormat('tablecellbordercolor', data.bordercolor);
	      modifier.setFormat('tablecellborderstyle', data.borderstyle);
	      modifier.setFormat('tablecellborderwidth', addPxSuffix(data.borderwidth));
	    };
	    var applyCellData = function (editor, cells, oldData, data) {
	      var isSingleCell = cells.length === 1;
	      var modifiedData = filter$1(data, function (value, key) {
	        return oldData[key] !== value;
	      });
	      if (size(modifiedData) > 0 && cells.length >= 1) {
	        var tableOpt = table(cells[0]);
	        getSelectedCells(cells).each(function (selectedCells) {
	          each(selectedCells, function (item) {
	            var cellElm = switchCellType(editor, item.element, data.celltype);
	            var modifier = isSingleCell ? DomModifier.normal(editor, cellElm) : DomModifier.ifTruthy(editor, cellElm);
	            var colModifier = item.column.map(function (col) {
	              return isSingleCell ? DomModifier.normal(editor, col) : DomModifier.ifTruthy(editor, col);
	            }).getOr(modifier);
	            updateSimpleProps(modifier, colModifier, data);
	            if (hasAdvancedCellTab(editor)) {
	              updateAdvancedProps(modifier, data);
	            }
	            if (isSingleCell) {
	              unApplyAlign(editor, cellElm);
	              unApplyVAlign(editor, cellElm);
	            }
	            if (data.halign) {
	              applyAlign(editor, cellElm, data.halign);
	            }
	            if (data.valign) {
	              applyVAlign(editor, cellElm, data.valign);
	            }
	          });
	        });
	        var styleModified_1 = size(filter$1(modifiedData, function (_value, key) {
	          return key !== 'scope' && key !== 'celltype';
	        })) > 0;
	        tableOpt.each(function (table) {
	          return fireTableModified(editor, table.dom, {
	            structure: has(modifiedData, 'celltype'),
	            style: styleModified_1
	          });
	        });
	      }
	    };
	    var onSubmitCellForm = function (editor, cells, oldData, api) {
	      var data = api.getData();
	      api.close();
	      editor.undoManager.transact(function () {
	        applyCellData(editor, cells, oldData, data);
	        editor.focus();
	      });
	    };
	    var getData = function (editor, cells) {
	      var cellsData = getSelectedCells(cells).map(function (selectedCells) {
	        return map(selectedCells, function (item) {
	          return extractDataFromCellElement(editor, item.element, hasAdvancedCellTab(editor), item.column);
	        });
	      });
	      return getSharedValues(cellsData.getOrDie());
	    };
	    var open = function (editor, selections) {
	      var cells = getCellsFromSelection(getSelectionStart(editor), selections);
	      if (cells.length === 0) {
	        return;
	      }
	      var data = getData(editor, cells);
	      var dialogTabPanel = {
	        type: 'tabpanel',
	        tabs: [
	          {
	            title: 'General',
	            name: 'general',
	            items: getItems(editor)
	          },
	          getAdvancedTab('cell')
	        ]
	      };
	      var dialogPanel = {
	        type: 'panel',
	        items: [{
	            type: 'grid',
	            columns: 2,
	            items: getItems(editor)
	          }]
	      };
	      editor.windowManager.open({
	        title: 'Cell Properties',
	        size: 'normal',
	        body: hasAdvancedCellTab(editor) ? dialogTabPanel : dialogPanel,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: data,
	        onSubmit: curry(onSubmitCellForm, editor, cells, data)
	      });
	    };
	
	    var getClassList$1 = function (editor) {
	      var classes = buildListItems(getRowClassList(editor));
	      if (classes.length > 0) {
	        return Optional.some({
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          items: classes
	        });
	      }
	      return Optional.none();
	    };
	    var formChildren = [
	      {
	        type: 'listbox',
	        name: 'type',
	        label: 'Row type',
	        items: [
	          {
	            text: 'Header',
	            value: 'header'
	          },
	          {
	            text: 'Body',
	            value: 'body'
	          },
	          {
	            text: 'Footer',
	            value: 'footer'
	          }
	        ]
	      },
	      {
	        type: 'listbox',
	        name: 'align',
	        label: 'Alignment',
	        items: [
	          {
	            text: 'None',
	            value: ''
	          },
	          {
	            text: 'Left',
	            value: 'left'
	          },
	          {
	            text: 'Center',
	            value: 'center'
	          },
	          {
	            text: 'Right',
	            value: 'right'
	          }
	        ]
	      },
	      {
	        label: 'Height',
	        name: 'height',
	        type: 'input'
	      }
	    ];
	    var getItems$1 = function (editor) {
	      return formChildren.concat(getClassList$1(editor).toArray());
	    };
	
	    var updateSimpleProps$1 = function (modifier, data) {
	      modifier.setAttrib('class', data.class);
	      modifier.setStyle('height', addPxSuffix(data.height));
	    };
	    var updateAdvancedProps$1 = function (modifier, data) {
	      modifier.setStyle('background-color', data.backgroundcolor);
	      modifier.setStyle('border-color', data.bordercolor);
	      modifier.setStyle('border-style', data.borderstyle);
	    };
	    var applyRowData = function (editor, rows, oldData, data) {
	      var isSingleRow = rows.length === 1;
	      var modifiedData = filter$1(data, function (value, key) {
	        return oldData[key] !== value;
	      });
	      if (size(modifiedData) > 0) {
	        each(rows, function (rowElm) {
	          if (data.type !== getNodeName(rowElm.parentNode)) {
	            switchSectionType(editor, rowElm, data.type);
	          }
	          var modifier = isSingleRow ? DomModifier.normal(editor, rowElm) : DomModifier.ifTruthy(editor, rowElm);
	          updateSimpleProps$1(modifier, data);
	          if (hasAdvancedRowTab(editor)) {
	            updateAdvancedProps$1(modifier, data);
	          }
	          if (data.align !== oldData.align) {
	            unApplyAlign(editor, rowElm);
	            applyAlign(editor, rowElm, data.align);
	          }
	        });
	        var typeModified_1 = has(modifiedData, 'type');
	        var styleModified_1 = typeModified_1 ? size(modifiedData) > 1 : true;
	        table(SugarElement.fromDom(rows[0])).each(function (table) {
	          return fireTableModified(editor, table.dom, {
	            structure: typeModified_1,
	            style: styleModified_1
	          });
	        });
	      }
	    };
	    var onSubmitRowForm = function (editor, rows, oldData, api) {
	      var data = api.getData();
	      api.close();
	      editor.undoManager.transact(function () {
	        applyRowData(editor, rows, oldData, data);
	        editor.focus();
	      });
	    };
	    var open$1 = function (editor) {
	      var rows = getRowsFromSelection(getSelectionStart(editor), ephemera.selected);
	      if (rows.length === 0) {
	        return;
	      }
	      var rowsData = map(rows, function (rowElm) {
	        return extractDataFromRowElement(editor, rowElm.dom, hasAdvancedRowTab(editor));
	      });
	      var data = getSharedValues(rowsData);
	      var dialogTabPanel = {
	        type: 'tabpanel',
	        tabs: [
	          {
	            title: 'General',
	            name: 'general',
	            items: getItems$1(editor)
	          },
	          getAdvancedTab('row')
	        ]
	      };
	      var dialogPanel = {
	        type: 'panel',
	        items: [{
	            type: 'grid',
	            columns: 2,
	            items: getItems$1(editor)
	          }]
	      };
	      editor.windowManager.open({
	        title: 'Row Properties',
	        size: 'normal',
	        body: hasAdvancedRowTab(editor) ? dialogTabPanel : dialogPanel,
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: data,
	        onSubmit: curry(onSubmitRowForm, editor, map(rows, function (r) {
	          return r.dom;
	        }), data)
	      });
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var getItems$2 = function (editor, classes, insertNewTable) {
	      var rowColCountItems = !insertNewTable ? [] : [
	        {
	          type: 'input',
	          name: 'cols',
	          label: 'Cols',
	          inputMode: 'numeric'
	        },
	        {
	          type: 'input',
	          name: 'rows',
	          label: 'Rows',
	          inputMode: 'numeric'
	        }
	      ];
	      var alwaysItems = [
	        {
	          type: 'input',
	          name: 'width',
	          label: 'Width'
	        },
	        {
	          type: 'input',
	          name: 'height',
	          label: 'Height'
	        }
	      ];
	      var appearanceItems = hasAppearanceOptions(editor) ? [
	        {
	          type: 'input',
	          name: 'cellspacing',
	          label: 'Cell spacing',
	          inputMode: 'numeric'
	        },
	        {
	          type: 'input',
	          name: 'cellpadding',
	          label: 'Cell padding',
	          inputMode: 'numeric'
	        },
	        {
	          type: 'input',
	          name: 'border',
	          label: 'Border width'
	        },
	        {
	          type: 'label',
	          label: 'Caption',
	          items: [{
	              type: 'checkbox',
	              name: 'caption',
	              label: 'Show caption'
	            }]
	        }
	      ] : [];
	      var alignmentItem = [{
	          type: 'listbox',
	          name: 'align',
	          label: 'Alignment',
	          items: [
	            {
	              text: 'None',
	              value: ''
	            },
	            {
	              text: 'Left',
	              value: 'left'
	            },
	            {
	              text: 'Center',
	              value: 'center'
	            },
	            {
	              text: 'Right',
	              value: 'right'
	            }
	          ]
	        }];
	      var classListItem = classes.length > 0 ? [{
	          type: 'listbox',
	          name: 'class',
	          label: 'Class',
	          items: classes
	        }] : [];
	      return rowColCountItems.concat(alwaysItems).concat(appearanceItems).concat(alignmentItem).concat(classListItem);
	    };
	
	    var styleTDTH = function (dom, elm, name, value) {
	      if (elm.tagName === 'TD' || elm.tagName === 'TH') {
	        if (isString(name)) {
	          dom.setStyle(elm, name, value);
	        } else {
	          dom.setStyle(elm, name);
	        }
	      } else {
	        if (elm.children) {
	          for (var i = 0; i < elm.children.length; i++) {
	            styleTDTH(dom, elm.children[i], name, value);
	          }
	        }
	      }
	    };
	    var applyDataToElement = function (editor, tableElm, data) {
	      var dom = editor.dom;
	      var attrs = {};
	      var styles = {};
	      attrs.class = data.class;
	      styles.height = addPxSuffix(data.height);
	      if (dom.getAttrib(tableElm, 'width') && !shouldStyleWithCss(editor)) {
	        attrs.width = removePxSuffix(data.width);
	      } else {
	        styles.width = addPxSuffix(data.width);
	      }
	      if (shouldStyleWithCss(editor)) {
	        styles['border-width'] = addPxSuffix(data.border);
	        styles['border-spacing'] = addPxSuffix(data.cellspacing);
	      } else {
	        attrs.border = data.border;
	        attrs.cellpadding = data.cellpadding;
	        attrs.cellspacing = data.cellspacing;
	      }
	      if (shouldStyleWithCss(editor) && tableElm.children) {
	        for (var i = 0; i < tableElm.children.length; i++) {
	          styleTDTH(dom, tableElm.children[i], {
	            'border-width': addPxSuffix(data.border),
	            'padding': addPxSuffix(data.cellpadding)
	          });
	          if (hasAdvancedTableTab(editor)) {
	            styleTDTH(dom, tableElm.children[i], { 'border-color': data.bordercolor });
	          }
	        }
	      }
	      if (hasAdvancedTableTab(editor)) {
	        styles['background-color'] = data.backgroundcolor;
	        styles['border-color'] = data.bordercolor;
	        styles['border-style'] = data.borderstyle;
	      }
	      attrs.style = dom.serializeStyle(__assign(__assign({}, getDefaultStyles(editor)), styles));
	      dom.setAttribs(tableElm, __assign(__assign({}, getDefaultAttributes(editor)), attrs));
	    };
	    var onSubmitTableForm = function (editor, tableElm, oldData, api) {
	      var dom = editor.dom;
	      var captionElm;
	      var data = api.getData();
	      var modifiedData = filter$1(data, function (value, key) {
	        return oldData[key] !== value;
	      });
	      api.close();
	      if (data.class === '') {
	        delete data.class;
	      }
	      editor.undoManager.transact(function () {
	        if (!tableElm) {
	          var cols = parseInt(data.cols, 10) || 1;
	          var rows = parseInt(data.rows, 10) || 1;
	          tableElm = insert$1(editor, cols, rows, 0, 0);
	        }
	        if (size(modifiedData) > 0) {
	          applyDataToElement(editor, tableElm, data);
	          captionElm = dom.select('caption', tableElm)[0];
	          if (captionElm && !data.caption) {
	            dom.remove(captionElm);
	          }
	          if (!captionElm && data.caption) {
	            captionElm = dom.create('caption');
	            captionElm.innerHTML = !global$2.ie ? '<br data-mce-bogus="1"/>' : nbsp;
	            tableElm.insertBefore(captionElm, tableElm.firstChild);
	          }
	          if (data.align === '') {
	            unApplyAlign(editor, tableElm);
	          } else {
	            applyAlign(editor, tableElm, data.align);
	          }
	        }
	        editor.focus();
	        editor.addVisual();
	        if (size(modifiedData) > 0) {
	          var captionModified = has(modifiedData, 'caption');
	          var styleModified = captionModified ? size(modifiedData) > 1 : true;
	          fireTableModified(editor, tableElm, {
	            structure: captionModified,
	            style: styleModified
	          });
	        }
	      });
	    };
	    var open$2 = function (editor, insertNewTable) {
	      var dom = editor.dom;
	      var tableElm;
	      var data = extractDataFromSettings(editor, hasAdvancedTableTab(editor));
	      if (insertNewTable === false) {
	        tableElm = dom.getParent(editor.selection.getStart(), 'table', editor.getBody());
	        if (tableElm) {
	          data = extractDataFromTableElement(editor, tableElm, hasAdvancedTableTab(editor));
	        } else {
	          if (hasAdvancedTableTab(editor)) {
	            data.borderstyle = '';
	            data.bordercolor = '';
	            data.backgroundcolor = '';
	          }
	        }
	      } else {
	        data.cols = '1';
	        data.rows = '1';
	        if (hasAdvancedTableTab(editor)) {
	          data.borderstyle = '';
	          data.bordercolor = '';
	          data.backgroundcolor = '';
	        }
	      }
	      var classes = buildListItems(getTableClassList(editor));
	      if (classes.length > 0) {
	        if (data.class) {
	          data.class = data.class.replace(/\s*mce\-item\-table\s*/g, '');
	        }
	      }
	      var generalPanel = {
	        type: 'grid',
	        columns: 2,
	        items: getItems$2(editor, classes, insertNewTable)
	      };
	      var nonAdvancedForm = function () {
	        return {
	          type: 'panel',
	          items: [generalPanel]
	        };
	      };
	      var advancedForm = function () {
	        return {
	          type: 'tabpanel',
	          tabs: [
	            {
	              title: 'General',
	              name: 'general',
	              items: [generalPanel]
	            },
	            getAdvancedTab('table')
	          ]
	        };
	      };
	      var dialogBody = hasAdvancedTableTab(editor) ? advancedForm() : nonAdvancedForm();
	      editor.windowManager.open({
	        title: 'Table Properties',
	        size: 'normal',
	        body: dialogBody,
	        onSubmit: curry(onSubmitTableForm, editor, tableElm, data),
	        buttons: [
	          {
	            type: 'cancel',
	            name: 'cancel',
	            text: 'Cancel'
	          },
	          {
	            type: 'submit',
	            name: 'save',
	            text: 'Save',
	            primary: true
	          }
	        ],
	        initialData: data
	      });
	    };
	
	    var getSelectionStartCellOrCaption$1 = function (editor) {
	      return getSelectionStartCellOrCaption(getSelectionStart(editor), getIsRoot(editor));
	    };
	    var getSelectionStartCell$1 = function (editor) {
	      return getSelectionStartCell(getSelectionStart(editor), getIsRoot(editor));
	    };
	    var registerCommands = function (editor, actions, cellSelection, selections, clipboard) {
	      var isRoot = getIsRoot(editor);
	      var eraseTable = function () {
	        return getSelectionStartCellOrCaption$1(editor).each(function (cellOrCaption) {
	          table(cellOrCaption, isRoot).filter(not(isRoot)).each(function (table) {
	            var cursor = SugarElement.fromText('');
	            after(table, cursor);
	            remove$2(table);
	            if (editor.dom.isEmpty(editor.getBody())) {
	              editor.setContent('');
	              editor.selection.setCursorLocation();
	            } else {
	              var rng = editor.dom.createRng();
	              rng.setStart(cursor.dom, 0);
	              rng.setEnd(cursor.dom, 0);
	              editor.selection.setRng(rng);
	              editor.nodeChanged();
	            }
	          });
	        });
	      };
	      var setSizingMode = function (sizing) {
	        return getSelectionStartCellOrCaption$1(editor).each(function (cellOrCaption) {
	          var isForcedSizing = isResponsiveForced(editor) || isPixelsForced(editor) || isPercentagesForced(editor);
	          if (!isForcedSizing) {
	            table(cellOrCaption, isRoot).each(function (table) {
	              if (sizing === 'relative' && !isPercentSizing$1(table)) {
	                enforcePercentage(editor, table);
	              } else if (sizing === 'fixed' && !isPixelSizing$1(table)) {
	                enforcePixels(editor, table);
	              } else if (sizing === 'responsive' && !isNoneSizing$1(table)) {
	                enforceNone(table);
	              }
	              removeDataStyle(table);
	              fireTableModified(editor, table.dom, structureModified);
	            });
	          }
	        });
	      };
	      var getTableFromCell = function (cell) {
	        return table(cell, isRoot);
	      };
	      var postExecute = function (table) {
	        return function (data) {
	          editor.selection.setRng(data.rng);
	          editor.focus();
	          cellSelection.clear(table);
	          removeDataStyle(table);
	          fireTableModified(editor, table.dom, data.effect);
	        };
	      };
	      var actOnSelection = function (execute) {
	        return getSelectionStartCell$1(editor).each(function (cell) {
	          getTableFromCell(cell).each(function (table) {
	            var targets = forMenu(selections, table, cell);
	            execute(table, targets).each(postExecute(table));
	          });
	        });
	      };
	      var copyRowSelection = function () {
	        return getSelectionStartCell$1(editor).map(function (cell) {
	          return getTableFromCell(cell).bind(function (table) {
	            var targets = forMenu(selections, table, cell);
	            var generators = cellOperations(noop, SugarElement.fromDom(editor.getDoc()), Optional.none());
	            return copyRows(table, targets, generators);
	          });
	        });
	      };
	      var copyColSelection = function () {
	        return getSelectionStartCell$1(editor).map(function (cell) {
	          return getTableFromCell(cell).bind(function (table) {
	            var targets = forMenu(selections, table, cell);
	            return copyCols(table, targets);
	          });
	        });
	      };
	      var pasteOnSelection = function (execute, getRows) {
	        return getRows().each(function (rows) {
	          var clonedRows = map(rows, function (row) {
	            return deep(row);
	          });
	          getSelectionStartCell$1(editor).each(function (cell) {
	            return getTableFromCell(cell).each(function (table) {
	              var generators = paste(SugarElement.fromDom(editor.getDoc()));
	              var targets = pasteRows(selections, cell, clonedRows, generators);
	              execute(table, targets).each(postExecute(table));
	            });
	          });
	        });
	      };
	      each$1({
	        mceTableSplitCells: function () {
	          return actOnSelection(actions.unmergeCells);
	        },
	        mceTableMergeCells: function () {
	          return actOnSelection(actions.mergeCells);
	        },
	        mceTableInsertRowBefore: function () {
	          return actOnSelection(actions.insertRowsBefore);
	        },
	        mceTableInsertRowAfter: function () {
	          return actOnSelection(actions.insertRowsAfter);
	        },
	        mceTableInsertColBefore: function () {
	          return actOnSelection(actions.insertColumnsBefore);
	        },
	        mceTableInsertColAfter: function () {
	          return actOnSelection(actions.insertColumnsAfter);
	        },
	        mceTableDeleteCol: function () {
	          return actOnSelection(actions.deleteColumn);
	        },
	        mceTableDeleteRow: function () {
	          return actOnSelection(actions.deleteRow);
	        },
	        mceTableCutCol: function (_grid) {
	          return copyColSelection().each(function (selection) {
	            clipboard.setColumns(selection);
	            actOnSelection(actions.deleteColumn);
	          });
	        },
	        mceTableCutRow: function (_grid) {
	          return copyRowSelection().each(function (selection) {
	            clipboard.setRows(selection);
	            actOnSelection(actions.deleteRow);
	          });
	        },
	        mceTableCopyCol: function (_grid) {
	          return copyColSelection().each(function (selection) {
	            return clipboard.setColumns(selection);
	          });
	        },
	        mceTableCopyRow: function (_grid) {
	          return copyRowSelection().each(function (selection) {
	            return clipboard.setRows(selection);
	          });
	        },
	        mceTablePasteColBefore: function (_grid) {
	          return pasteOnSelection(actions.pasteColsBefore, clipboard.getColumns);
	        },
	        mceTablePasteColAfter: function (_grid) {
	          return pasteOnSelection(actions.pasteColsAfter, clipboard.getColumns);
	        },
	        mceTablePasteRowBefore: function (_grid) {
	          return pasteOnSelection(actions.pasteRowsBefore, clipboard.getRows);
	        },
	        mceTablePasteRowAfter: function (_grid) {
	          return pasteOnSelection(actions.pasteRowsAfter, clipboard.getRows);
	        },
	        mceTableDelete: eraseTable,
	        mceTableSizingMode: function (ui, sizing) {
	          return setSizingMode(sizing);
	        }
	      }, function (func, name) {
	        return editor.addCommand(name, func);
	      });
	      var fireTableModifiedForSelection = function (editor, tableOpt) {
	        tableOpt.each(function (table) {
	          fireTableModified(editor, table.dom, structureModified);
	        });
	      };
	      each$1({
	        mceTableCellType: function (_ui, args) {
	          var tableOpt = table(getSelectionStart(editor), isRoot);
	          actions.setTableCellType(editor, args);
	          fireTableModifiedForSelection(editor, tableOpt);
	        },
	        mceTableRowType: function (_ui, args) {
	          var tableOpt = table(getSelectionStart(editor), isRoot);
	          actions.setTableRowType(editor, args);
	          fireTableModifiedForSelection(editor, tableOpt);
	        }
	      }, function (func, name) {
	        return editor.addCommand(name, func);
	      });
	      editor.addCommand('mceTableColType', function (_ui, args) {
	        return get$1(args, 'type').each(function (type) {
	          return actOnSelection(type === 'th' ? actions.makeColumnsHeader : actions.unmakeColumnsHeader);
	        });
	      });
	      each$1({
	        mceTableProps: curry(open$2, editor, false),
	        mceTableRowProps: curry(open$1, editor),
	        mceTableCellProps: curry(open, editor, selections)
	      }, function (func, name) {
	        return editor.addCommand(name, function () {
	          return func();
	        });
	      });
	      editor.addCommand('mceInsertTable', function (_ui, args) {
	        if (isObject(args) && keys(args).length > 0) {
	          insertTableWithDataValidation(editor, args.rows, args.columns, args.options, 'Invalid values for mceInsertTable - rows and columns values are required to insert a table.');
	        } else {
	          open$2(editor, true);
	        }
	      });
	      editor.addCommand('mceTableApplyCellStyle', function (_ui, args) {
	        var getFormatName = function (style) {
	          return 'tablecell' + style.toLowerCase().replace('-', '');
	        };
	        if (!isObject(args)) {
	          return;
	        }
	        var cells = getCellsFromSelection(getSelectionStart(editor), selections, isRoot);
	        if (cells.length === 0) {
	          return;
	        }
	        var validArgs = filter$1(args, function (value, style) {
	          return editor.formatter.has(getFormatName(style)) && isString(value);
	        });
	        if (isEmpty(validArgs)) {
	          return;
	        }
	        each$1(validArgs, function (value, style) {
	          each(cells, function (cell) {
	            DomModifier.normal(editor, cell.dom).setFormat(getFormatName(style), value);
	          });
	        });
	        getTableFromCell(cells[0]).each(function (table) {
	          return fireTableModified(editor, table.dom, styleModified);
	        });
	      });
	    };
	
	    var registerQueryCommands = function (editor, actions, selections) {
	      var isRoot = getIsRoot(editor);
	      var getTableFromCell = function (cell) {
	        return table(cell, isRoot);
	      };
	      each$1({
	        mceTableRowType: function () {
	          return actions.getTableRowType(editor);
	        },
	        mceTableCellType: function () {
	          return actions.getTableCellType(editor);
	        },
	        mceTableColType: function () {
	          return getSelectionStartCell(getSelectionStart(editor)).bind(function (cell) {
	            return getTableFromCell(cell).map(function (table) {
	              var targets = forMenu(selections, table, cell);
	              return actions.getTableColType(table, targets);
	            });
	          }).getOr('');
	        }
	      }, function (func, name) {
	        return editor.addQueryValueHandler(name, func);
	      });
	    };
	
	    var Clipboard = function () {
	      var rows = Cell(Optional.none());
	      var cols = Cell(Optional.none());
	      var clearClipboard = function (clipboard) {
	        clipboard.set(Optional.none());
	      };
	      return {
	        getRows: rows.get,
	        setRows: function (r) {
	          rows.set(r);
	          clearClipboard(cols);
	        },
	        clearRows: function () {
	          return clearClipboard(rows);
	        },
	        getColumns: cols.get,
	        setColumns: function (c) {
	          cols.set(c);
	          clearClipboard(rows);
	        },
	        clearColumns: function () {
	          return clearClipboard(cols);
	        }
	      };
	    };
	
	    var cellFormats = {
	      tablecellbackgroundcolor: {
	        selector: 'td,th',
	        styles: { backgroundColor: '%value' },
	        remove_similar: true
	      },
	      tablecellbordercolor: {
	        selector: 'td,th',
	        styles: { borderColor: '%value' },
	        remove_similar: true
	      },
	      tablecellborderstyle: {
	        selector: 'td,th',
	        styles: { borderStyle: '%value' },
	        remove_similar: true
	      },
	      tablecellborderwidth: {
	        selector: 'td,th',
	        styles: { borderWidth: '%value' },
	        remove_similar: true
	      }
	    };
	    var registerFormats = function (editor) {
	      editor.formatter.register(cellFormats);
	    };
	
	    var adt$2 = Adt.generate([
	      { none: ['current'] },
	      { first: ['current'] },
	      {
	        middle: [
	          'current',
	          'target'
	        ]
	      },
	      { last: ['current'] }
	    ]);
	    var none$2 = function (current) {
	      if (current === void 0) {
	        current = undefined;
	      }
	      return adt$2.none(current);
	    };
	    var CellLocation = __assign(__assign({}, adt$2), { none: none$2 });
	
	    var detect$5 = function (current, isRoot) {
	      return table(current, isRoot).bind(function (table) {
	        var all = cells(table);
	        var index = findIndex(all, function (x) {
	          return eq$1(current, x);
	        });
	        return index.map(function (index) {
	          return {
	            index: index,
	            all: all
	          };
	        });
	      });
	    };
	    var next = function (current, isRoot) {
	      var detection = detect$5(current, isRoot);
	      return detection.fold(function () {
	        return CellLocation.none(current);
	      }, function (info) {
	        return info.index + 1 < info.all.length ? CellLocation.middle(current, info.all[info.index + 1]) : CellLocation.last(current);
	      });
	    };
	    var prev = function (current, isRoot) {
	      var detection = detect$5(current, isRoot);
	      return detection.fold(function () {
	        return CellLocation.none();
	      }, function (info) {
	        return info.index - 1 >= 0 ? CellLocation.middle(current, info.all[info.index - 1]) : CellLocation.first(current);
	      });
	    };
	
	    var create$2 = function (start, soffset, finish, foffset) {
	      return {
	        start: start,
	        soffset: soffset,
	        finish: finish,
	        foffset: foffset
	      };
	    };
	    var SimRange = { create: create$2 };
	
	    var adt$3 = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata$1 = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$2 = adt$3.before;
	    var on = adt$3.on;
	    var after$2 = adt$3.after;
	    var Situ = {
	      before: before$2,
	      on: on,
	      after: after$2,
	      cata: cata$1,
	      getStart: getStart
	    };
	
	    var adt$4 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$4.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return SugarElement.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, _finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, _soffset, _finish, _foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$4.domRange;
	    var relative = adt$4.relative;
	    var exact = adt$4.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range$1 = SimRange.create;
	    var SimSelection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range$1
	    };
	
	    var selectNodeContents = function (win, element) {
	      var rng = win.document.createRange();
	      selectNodeContentsUsing(rng, element);
	      return rng;
	    };
	    var selectNodeContentsUsing = function (rng, element) {
	      return rng.selectNodeContents(element.dom);
	    };
	    var setStart = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setStartBefore(e.dom);
	      }, function (e, o) {
	        rng.setStart(e.dom, o);
	      }, function (e) {
	        rng.setStartAfter(e.dom);
	      });
	    };
	    var setFinish = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setEndBefore(e.dom);
	      }, function (e, o) {
	        rng.setEnd(e.dom, o);
	      }, function (e) {
	        rng.setEndAfter(e.dom);
	      });
	    };
	    var relativeToNative = function (win, startSitu, finishSitu) {
	      var range = win.document.createRange();
	      setStart(range, startSitu);
	      setFinish(range, finishSitu);
	      return range;
	    };
	    var exactToNative = function (win, start, soffset, finish, foffset) {
	      var rng = win.document.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var toRect = function (rect) {
	      return {
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom,
	        width: rect.width,
	        height: rect.height
	      };
	    };
	    var getFirstRect = function (rng) {
	      var rects = rng.getClientRects();
	      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
	      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
	    };
	
	    var adt$5 = Adt.generate([
	      {
	        ltr: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      },
	      {
	        rtl: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var fromRange = function (win, type, range) {
	      return type(SugarElement.fromDom(range.startContainer), range.startOffset, SugarElement.fromDom(range.endContainer), range.endOffset);
	    };
	    var getRanges = function (win, selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return {
	            ltr: constant(rng),
	            rtl: Optional.none
	          };
	        },
	        relative: function (startSitu, finishSitu) {
	          return {
	            ltr: cached(function () {
	              return relativeToNative(win, startSitu, finishSitu);
	            }),
	            rtl: cached(function () {
	              return Optional.some(relativeToNative(win, finishSitu, startSitu));
	            })
	          };
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return {
	            ltr: cached(function () {
	              return exactToNative(win, start, soffset, finish, foffset);
	            }),
	            rtl: cached(function () {
	              return Optional.some(exactToNative(win, finish, foffset, start, soffset));
	            })
	          };
	        }
	      });
	    };
	    var doDiagnose = function (win, ranges) {
	      var rng = ranges.ltr();
	      if (rng.collapsed) {
	        var reversed = ranges.rtl().filter(function (rev) {
	          return rev.collapsed === false;
	        });
	        return reversed.map(function (rev) {
	          return adt$5.rtl(SugarElement.fromDom(rev.endContainer), rev.endOffset, SugarElement.fromDom(rev.startContainer), rev.startOffset);
	        }).getOrThunk(function () {
	          return fromRange(win, adt$5.ltr, rng);
	        });
	      } else {
	        return fromRange(win, adt$5.ltr, rng);
	      }
	    };
	    var diagnose = function (win, selection) {
	      var ranges = getRanges(win, selection);
	      return doDiagnose(win, ranges);
	    };
	    var asLtrRange = function (win, selection) {
	      var diagnosis = diagnose(win, selection);
	      return diagnosis.match({
	        ltr: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(start.dom, soffset);
	          rng.setEnd(finish.dom, foffset);
	          return rng;
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(finish.dom, foffset);
	          rng.setEnd(start.dom, soffset);
	          return rng;
	        }
	      });
	    };
	    var ltr$1 = adt$5.ltr;
	    var rtl$1 = adt$5.rtl;
	
	    var searchForPoint = function (rectForOffset, x, y, maxX, length) {
	      if (length === 0) {
	        return 0;
	      } else if (x === maxX) {
	        return length - 1;
	      }
	      var xDelta = maxX;
	      for (var i = 1; i < length; i++) {
	        var rect = rectForOffset(i);
	        var curDeltaX = Math.abs(x - rect.left);
	        if (y <= rect.bottom) {
	          if (y < rect.top || curDeltaX > xDelta) {
	            return i - 1;
	          } else {
	            xDelta = curDeltaX;
	          }
	        }
	      }
	      return 0;
	    };
	    var inRect = function (rect, x, y) {
	      return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
	    };
	
	    var locateOffset = function (doc, textnode, x, y, rect) {
	      var rangeForOffset = function (o) {
	        var r = doc.dom.createRange();
	        r.setStart(textnode.dom, o);
	        r.collapse(true);
	        return r;
	      };
	      var rectForOffset = function (o) {
	        var r = rangeForOffset(o);
	        return r.getBoundingClientRect();
	      };
	      var length = get$4(textnode).length;
	      var offset = searchForPoint(rectForOffset, x, y, rect.right, length);
	      return rangeForOffset(offset);
	    };
	    var locate = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      r.selectNode(node.dom);
	      var rects = r.getClientRects();
	      var foundRect = findMap(rects, function (rect) {
	        return inRect(rect, x, y) ? Optional.some(rect) : Optional.none();
	      });
	      return foundRect.map(function (rect) {
	        return locateOffset(doc, node, x, y, rect);
	      });
	    };
	
	    var searchInChildren = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      var nodes = children(node);
	      return findMap(nodes, function (n) {
	        r.selectNode(n.dom);
	        return inRect(r.getBoundingClientRect(), x, y) ? locateNode(doc, n, x, y) : Optional.none();
	      });
	    };
	    var locateNode = function (doc, node, x, y) {
	      return isText(node) ? locate(doc, node, x, y) : searchInChildren(doc, node, x, y);
	    };
	    var locate$1 = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      r.selectNode(node.dom);
	      var rect = r.getBoundingClientRect();
	      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
	      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
	      return locateNode(doc, node, boundedX, boundedY);
	    };
	
	    var COLLAPSE_TO_LEFT = true;
	    var COLLAPSE_TO_RIGHT = false;
	    var getCollapseDirection = function (rect, x) {
	      return x - rect.left < rect.right - x ? COLLAPSE_TO_LEFT : COLLAPSE_TO_RIGHT;
	    };
	    var createCollapsedNode = function (doc, target, collapseDirection) {
	      var r = doc.dom.createRange();
	      r.selectNode(target.dom);
	      r.collapse(collapseDirection);
	      return r;
	    };
	    var locateInElement = function (doc, node, x) {
	      var cursorRange = doc.dom.createRange();
	      cursorRange.selectNode(node.dom);
	      var rect = cursorRange.getBoundingClientRect();
	      var collapseDirection = getCollapseDirection(rect, x);
	      var f = collapseDirection === COLLAPSE_TO_LEFT ? first : last$1;
	      return f(node).map(function (target) {
	        return createCollapsedNode(doc, target, collapseDirection);
	      });
	    };
	    var locateInEmpty = function (doc, node, x) {
	      var rect = node.dom.getBoundingClientRect();
	      var collapseDirection = getCollapseDirection(rect, x);
	      return Optional.some(createCollapsedNode(doc, node, collapseDirection));
	    };
	    var search = function (doc, node, x) {
	      var f = children(node).length === 0 ? locateInEmpty : locateInElement;
	      return f(doc, node, x);
	    };
	
	    var caretPositionFromPoint = function (doc, x, y) {
	      return Optional.from(doc.dom.caretPositionFromPoint(x, y)).bind(function (pos) {
	        if (pos.offsetNode === null) {
	          return Optional.none();
	        }
	        var r = doc.dom.createRange();
	        r.setStart(pos.offsetNode, pos.offset);
	        r.collapse();
	        return Optional.some(r);
	      });
	    };
	    var caretRangeFromPoint = function (doc, x, y) {
	      return Optional.from(doc.dom.caretRangeFromPoint(x, y));
	    };
	    var searchTextNodes = function (doc, node, x, y) {
	      var r = doc.dom.createRange();
	      r.selectNode(node.dom);
	      var rect = r.getBoundingClientRect();
	      var boundedX = Math.max(rect.left, Math.min(rect.right, x));
	      var boundedY = Math.max(rect.top, Math.min(rect.bottom, y));
	      return locate$1(doc, node, boundedX, boundedY);
	    };
	    var searchFromPoint = function (doc, x, y) {
	      return SugarElement.fromPoint(doc, x, y).bind(function (elem) {
	        var fallback = function () {
	          return search(doc, elem, x);
	        };
	        return children(elem).length === 0 ? fallback() : searchTextNodes(doc, elem, x, y).orThunk(fallback);
	      });
	    };
	    var availableSearch = function () {
	      if (document.caretPositionFromPoint) {
	        return caretPositionFromPoint;
	      } else if (document.caretRangeFromPoint) {
	        return caretRangeFromPoint;
	      } else {
	        return searchFromPoint;
	      }
	    }();
	    var fromPoint$1 = function (win, x, y) {
	      var doc = SugarElement.fromDom(win.document);
	      return availableSearch(doc, x, y).map(function (rng) {
	        return SimRange.create(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset);
	      });
	    };
	
	    var beforeSpecial = function (element, offset) {
	      var name$1 = name(element);
	      if ('input' === name$1) {
	        return Situ.after(element);
	      } else if (!contains([
	          'br',
	          'img'
	        ], name$1)) {
	        return Situ.on(element, offset);
	      } else {
	        return offset === 0 ? Situ.before(element) : Situ.after(element);
	      }
	    };
	    var preprocessRelative = function (startSitu, finishSitu) {
	      var start = startSitu.fold(Situ.before, beforeSpecial, Situ.after);
	      var finish = finishSitu.fold(Situ.before, beforeSpecial, Situ.after);
	      return SimSelection.relative(start, finish);
	    };
	    var preprocessExact = function (start, soffset, finish, foffset) {
	      var startSitu = beforeSpecial(start, soffset);
	      var finishSitu = beforeSpecial(finish, foffset);
	      return SimSelection.relative(startSitu, finishSitu);
	    };
	    var preprocess = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          var start = SugarElement.fromDom(rng.startContainer);
	          var finish = SugarElement.fromDom(rng.endContainer);
	          return preprocessExact(start, rng.startOffset, finish, rng.endOffset);
	        },
	        relative: preprocessRelative,
	        exact: preprocessExact
	      });
	    };
	
	    var makeRange = function (start, soffset, finish, foffset) {
	      var doc = owner(start);
	      var rng = doc.dom.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var after$3 = function (start, soffset, finish, foffset) {
	      var r = makeRange(start, soffset, finish, foffset);
	      var same = eq$1(start, finish) && soffset === foffset;
	      return r.collapsed && !same;
	    };
	
	    var getNativeSelection = function (win) {
	      return Optional.from(win.getSelection());
	    };
	    var doSetNativeRange = function (win, rng) {
	      getNativeSelection(win).each(function (selection) {
	        selection.removeAllRanges();
	        selection.addRange(rng);
	      });
	    };
	    var doSetRange = function (win, start, soffset, finish, foffset) {
	      var rng = exactToNative(win, start, soffset, finish, foffset);
	      doSetNativeRange(win, rng);
	    };
	    var setLegacyRtlRange = function (win, selection, start, soffset, finish, foffset) {
	      selection.collapse(start.dom, soffset);
	      selection.extend(finish.dom, foffset);
	    };
	    var setRangeFromRelative = function (win, relative) {
	      return diagnose(win, relative).match({
	        ltr: function (start, soffset, finish, foffset) {
	          doSetRange(win, start, soffset, finish, foffset);
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          getNativeSelection(win).each(function (selection) {
	            if (selection.setBaseAndExtent) {
	              selection.setBaseAndExtent(start.dom, soffset, finish.dom, foffset);
	            } else if (selection.extend) {
	              try {
	                setLegacyRtlRange(win, selection, start, soffset, finish, foffset);
	              } catch (e) {
	                doSetRange(win, finish, foffset, start, soffset);
	              }
	            } else {
	              doSetRange(win, finish, foffset, start, soffset);
	            }
	          });
	        }
	      });
	    };
	    var setExact = function (win, start, soffset, finish, foffset) {
	      var relative = preprocessExact(start, soffset, finish, foffset);
	      setRangeFromRelative(win, relative);
	    };
	    var setRelative = function (win, startSitu, finishSitu) {
	      var relative = preprocessRelative(startSitu, finishSitu);
	      setRangeFromRelative(win, relative);
	    };
	    var toNative = function (selection) {
	      var win = SimSelection.getWin(selection).dom;
	      var getDomRange = function (start, soffset, finish, foffset) {
	        return exactToNative(win, start, soffset, finish, foffset);
	      };
	      var filtered = preprocess(selection);
	      return diagnose(win, filtered).match({
	        ltr: getDomRange,
	        rtl: getDomRange
	      });
	    };
	    var readRange = function (selection) {
	      if (selection.rangeCount > 0) {
	        var firstRng = selection.getRangeAt(0);
	        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
	        return Optional.some(SimRange.create(SugarElement.fromDom(firstRng.startContainer), firstRng.startOffset, SugarElement.fromDom(lastRng.endContainer), lastRng.endOffset));
	      } else {
	        return Optional.none();
	      }
	    };
	    var doGetExact = function (selection) {
	      if (selection.anchorNode === null || selection.focusNode === null) {
	        return readRange(selection);
	      } else {
	        var anchor = SugarElement.fromDom(selection.anchorNode);
	        var focus_1 = SugarElement.fromDom(selection.focusNode);
	        return after$3(anchor, selection.anchorOffset, focus_1, selection.focusOffset) ? Optional.some(SimRange.create(anchor, selection.anchorOffset, focus_1, selection.focusOffset)) : readRange(selection);
	      }
	    };
	    var setToElement = function (win, element) {
	      var rng = selectNodeContents(win, element);
	      doSetNativeRange(win, rng);
	    };
	    var getExact = function (win) {
	      return getNativeSelection(win).filter(function (sel) {
	        return sel.rangeCount > 0;
	      }).bind(doGetExact);
	    };
	    var get$c = function (win) {
	      return getExact(win).map(function (range) {
	        return SimSelection.exact(range.start, range.soffset, range.finish, range.foffset);
	      });
	    };
	    var getFirstRect$1 = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return getFirstRect(rng);
	    };
	    var getAtPoint = function (win, x, y) {
	      return fromPoint$1(win, x, y);
	    };
	    var clear = function (win) {
	      getNativeSelection(win).each(function (selection) {
	        return selection.removeAllRanges();
	      });
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var forward = function (editor, isRoot, cell) {
	      return go(editor, isRoot, next(cell));
	    };
	    var backward = function (editor, isRoot, cell) {
	      return go(editor, isRoot, prev(cell));
	    };
	    var getCellFirstCursorPosition = function (editor, cell) {
	      var selection = SimSelection.exact(cell, 0, cell, 0);
	      return toNative(selection);
	    };
	    var getNewRowCursorPosition = function (editor, table) {
	      var rows = descendants$1(table, 'tr');
	      return last(rows).bind(function (last) {
	        return descendant$1(last, 'td,th').map(function (first) {
	          return getCellFirstCursorPosition(editor, first);
	        });
	      });
	    };
	    var go = function (editor, isRoot, cell) {
	      return cell.fold(Optional.none, Optional.none, function (current, next) {
	        return first(next).map(function (cell) {
	          return getCellFirstCursorPosition(editor, cell);
	        });
	      }, function (current) {
	        return table(current, isRoot).bind(function (table) {
	          editor.execCommand('mceTableInsertRowAfter');
	          return getNewRowCursorPosition(editor, table);
	        });
	      });
	    };
	    var rootElements = [
	      'table',
	      'li',
	      'dl'
	    ];
	    var handle$1 = function (event, editor, cellSelection) {
	      if (event.keyCode === global$3.TAB) {
	        var body_1 = getBody$1(editor);
	        var isRoot_1 = function (element) {
	          var name$1 = name(element);
	          return eq$1(element, body_1) || contains(rootElements, name$1);
	        };
	        var rng = editor.selection.getRng();
	        var container = SugarElement.fromDom(event.shiftKey ? rng.startContainer : rng.endContainer);
	        cell(container, isRoot_1).each(function (cell) {
	          event.preventDefault();
	          table(cell, isRoot_1).each(cellSelection.clear);
	          editor.selection.collapse(event.shiftKey);
	          var navigation = event.shiftKey ? backward : forward;
	          var rng = navigation(editor, isRoot_1, cell);
	          rng.each(function (range) {
	            editor.selection.setRng(range);
	          });
	        });
	      }
	    };
	
	    var create$3 = function (selection, kill) {
	      return {
	        selection: selection,
	        kill: kill
	      };
	    };
	    var Response = { create: create$3 };
	
	    var create$4 = function (start, soffset, finish, foffset) {
	      return {
	        start: Situ.on(start, soffset),
	        finish: Situ.on(finish, foffset)
	      };
	    };
	    var Situs = { create: create$4 };
	
	    var convertToRange = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return SimRange.create(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset);
	    };
	    var makeSitus = Situs.create;
	
	    var sync = function (container, isRoot, start, soffset, finish, foffset, selectRange) {
	      if (!(eq$1(start, finish) && soffset === foffset)) {
	        return closest$1(start, 'td,th', isRoot).bind(function (s) {
	          return closest$1(finish, 'td,th', isRoot).bind(function (f) {
	            return detect$6(container, isRoot, s, f, selectRange);
	          });
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var detect$6 = function (container, isRoot, start, finish, selectRange) {
	      if (!eq$1(start, finish)) {
	        return identify(start, finish, isRoot).bind(function (cellSel) {
	          var boxes = cellSel.boxes.getOr([]);
	          if (boxes.length > 0) {
	            selectRange(container, boxes, cellSel.start, cellSel.finish);
	            return Optional.some(Response.create(Optional.some(makeSitus(start, 0, start, getEnd(start))), true));
	          } else {
	            return Optional.none();
	          }
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var update = function (rows, columns, container, selected, annotations) {
	      var updateSelection = function (newSels) {
	        annotations.clearBeforeUpdate(container);
	        annotations.selectRange(container, newSels.boxes, newSels.start, newSels.finish);
	        return newSels.boxes;
	      };
	      return shiftSelection(selected, rows, columns, annotations.firstSelectedSelector, annotations.lastSelectedSelector).map(updateSelection);
	    };
	
	    var traverse = function (item, mode) {
	      return {
	        item: item,
	        mode: mode
	      };
	    };
	    var backtrack = function (universe, item, _direction, transition) {
	      if (transition === void 0) {
	        transition = sidestep;
	      }
	      return universe.property().parent(item).map(function (p) {
	        return traverse(p, transition);
	      });
	    };
	    var sidestep = function (universe, item, direction, transition) {
	      if (transition === void 0) {
	        transition = advance;
	      }
	      return direction.sibling(universe, item).map(function (p) {
	        return traverse(p, transition);
	      });
	    };
	    var advance = function (universe, item, direction, transition) {
	      if (transition === void 0) {
	        transition = advance;
	      }
	      var children = universe.property().children(item);
	      var result = direction.first(children);
	      return result.map(function (r) {
	        return traverse(r, transition);
	      });
	    };
	    var successors = [
	      {
	        current: backtrack,
	        next: sidestep,
	        fallback: Optional.none()
	      },
	      {
	        current: sidestep,
	        next: advance,
	        fallback: Optional.some(backtrack)
	      },
	      {
	        current: advance,
	        next: advance,
	        fallback: Optional.some(sidestep)
	      }
	    ];
	    var go$1 = function (universe, item, mode, direction, rules) {
	      if (rules === void 0) {
	        rules = successors;
	      }
	      var ruleOpt = find(rules, function (succ) {
	        return succ.current === mode;
	      });
	      return ruleOpt.bind(function (rule) {
	        return rule.current(universe, item, direction, rule.next).orThunk(function () {
	          return rule.fallback.bind(function (fb) {
	            return go$1(universe, item, fb, direction);
	          });
	        });
	      });
	    };
	
	    var left = function () {
	      var sibling = function (universe, item) {
	        return universe.query().prevSibling(item);
	      };
	      var first = function (children) {
	        return children.length > 0 ? Optional.some(children[children.length - 1]) : Optional.none();
	      };
	      return {
	        sibling: sibling,
	        first: first
	      };
	    };
	    var right = function () {
	      var sibling = function (universe, item) {
	        return universe.query().nextSibling(item);
	      };
	      var first = function (children) {
	        return children.length > 0 ? Optional.some(children[0]) : Optional.none();
	      };
	      return {
	        sibling: sibling,
	        first: first
	      };
	    };
	    var Walkers = {
	      left: left,
	      right: right
	    };
	
	    var hone = function (universe, item, predicate, mode, direction, isRoot) {
	      var next = go$1(universe, item, mode, direction);
	      return next.bind(function (n) {
	        if (isRoot(n.item)) {
	          return Optional.none();
	        } else {
	          return predicate(n.item) ? Optional.some(n.item) : hone(universe, n.item, predicate, n.mode, direction, isRoot);
	        }
	      });
	    };
	    var left$1 = function (universe, item, predicate, isRoot) {
	      return hone(universe, item, predicate, sidestep, Walkers.left(), isRoot);
	    };
	    var right$1 = function (universe, item, predicate, isRoot) {
	      return hone(universe, item, predicate, sidestep, Walkers.right(), isRoot);
	    };
	
	    var isLeaf = function (universe) {
	      return function (element) {
	        return universe.property().children(element).length === 0;
	      };
	    };
	    var before$3 = function (universe, item, isRoot) {
	      return seekLeft(universe, item, isLeaf(universe), isRoot);
	    };
	    var after$4 = function (universe, item, isRoot) {
	      return seekRight(universe, item, isLeaf(universe), isRoot);
	    };
	    var seekLeft = left$1;
	    var seekRight = right$1;
	
	    var universe$3 = DomUniverse();
	    var before$4 = function (element, isRoot) {
	      return before$3(universe$3, element, isRoot);
	    };
	    var after$5 = function (element, isRoot) {
	      return after$4(universe$3, element, isRoot);
	    };
	    var seekLeft$1 = function (element, predicate, isRoot) {
	      return seekLeft(universe$3, element, predicate, isRoot);
	    };
	    var seekRight$1 = function (element, predicate, isRoot) {
	      return seekRight(universe$3, element, predicate, isRoot);
	    };
	
	    var ancestor$2 = function (scope, predicate, isRoot) {
	      return ancestor(scope, predicate, isRoot).isSome();
	    };
	
	    var adt$6 = Adt.generate([
	      { none: ['message'] },
	      { success: [] },
	      { failedUp: ['cell'] },
	      { failedDown: ['cell'] }
	    ]);
	    var isOverlapping = function (bridge, before, after) {
	      var beforeBounds = bridge.getRect(before);
	      var afterBounds = bridge.getRect(after);
	      return afterBounds.right > beforeBounds.left && afterBounds.left < beforeBounds.right;
	    };
	    var isRow = function (elem) {
	      return closest$1(elem, 'tr');
	    };
	    var verify = function (bridge, before, beforeOffset, after, afterOffset, failure, isRoot) {
	      return closest$1(after, 'td,th', isRoot).bind(function (afterCell) {
	        return closest$1(before, 'td,th', isRoot).map(function (beforeCell) {
	          if (!eq$1(afterCell, beforeCell)) {
	            return sharedOne$1(isRow, [
	              afterCell,
	              beforeCell
	            ]).fold(function () {
	              return isOverlapping(bridge, beforeCell, afterCell) ? adt$6.success() : failure(beforeCell);
	            }, function (_sharedRow) {
	              return failure(beforeCell);
	            });
	          } else {
	            return eq$1(after, afterCell) && getEnd(afterCell) === afterOffset ? failure(beforeCell) : adt$6.none('in same cell');
	          }
	        });
	      }).getOr(adt$6.none('default'));
	    };
	    var cata$2 = function (subject, onNone, onSuccess, onFailedUp, onFailedDown) {
	      return subject.fold(onNone, onSuccess, onFailedUp, onFailedDown);
	    };
	    var BeforeAfter = __assign(__assign({}, adt$6), {
	      verify: verify,
	      cata: cata$2
	    });
	
	    var inParent = function (parent, children, element, index) {
	      return {
	        parent: parent,
	        children: children,
	        element: element,
	        index: index
	      };
	    };
	    var indexInParent = function (element) {
	      return parent(element).bind(function (parent) {
	        var children$1 = children(parent);
	        return indexOf(children$1, element).map(function (index) {
	          return inParent(parent, children$1, element, index);
	        });
	      });
	    };
	    var indexOf = function (elements, element) {
	      return findIndex(elements, curry(eq$1, element));
	    };
	
	    var isBr = function (elem) {
	      return name(elem) === 'br';
	    };
	    var gatherer = function (cand, gather, isRoot) {
	      return gather(cand, isRoot).bind(function (target) {
	        return isText(target) && get$4(target).trim().length === 0 ? gatherer(target, gather, isRoot) : Optional.some(target);
	      });
	    };
	    var handleBr = function (isRoot, element, direction) {
	      return direction.traverse(element).orThunk(function () {
	        return gatherer(element, direction.gather, isRoot);
	      }).map(direction.relative);
	    };
	    var findBr = function (element, offset) {
	      return child(element, offset).filter(isBr).orThunk(function () {
	        return child(element, offset - 1).filter(isBr);
	      });
	    };
	    var handleParent = function (isRoot, element, offset, direction) {
	      return findBr(element, offset).bind(function (br) {
	        return direction.traverse(br).fold(function () {
	          return gatherer(br, direction.gather, isRoot).map(direction.relative);
	        }, function (adjacent) {
	          return indexInParent(adjacent).map(function (info) {
	            return Situ.on(info.parent, info.index);
	          });
	        });
	      });
	    };
	    var tryBr = function (isRoot, element, offset, direction) {
	      var target = isBr(element) ? handleBr(isRoot, element, direction) : handleParent(isRoot, element, offset, direction);
	      return target.map(function (tgt) {
	        return {
	          start: tgt,
	          finish: tgt
	        };
	      });
	    };
	    var process = function (analysis) {
	      return BeforeAfter.cata(analysis, function (_message) {
	        return Optional.none();
	      }, function () {
	        return Optional.none();
	      }, function (cell) {
	        return Optional.some(point(cell, 0));
	      }, function (cell) {
	        return Optional.some(point(cell, getEnd(cell)));
	      });
	    };
	
	    var moveDown = function (caret, amount) {
	      return {
	        left: caret.left,
	        top: caret.top + amount,
	        right: caret.right,
	        bottom: caret.bottom + amount
	      };
	    };
	    var moveUp = function (caret, amount) {
	      return {
	        left: caret.left,
	        top: caret.top - amount,
	        right: caret.right,
	        bottom: caret.bottom - amount
	      };
	    };
	    var translate = function (caret, xDelta, yDelta) {
	      return {
	        left: caret.left + xDelta,
	        top: caret.top + yDelta,
	        right: caret.right + xDelta,
	        bottom: caret.bottom + yDelta
	      };
	    };
	    var getTop$1 = function (caret) {
	      return caret.top;
	    };
	    var getBottom = function (caret) {
	      return caret.bottom;
	    };
	
	    var getPartialBox = function (bridge, element, offset) {
	      if (offset >= 0 && offset < getEnd(element)) {
	        return bridge.getRangedRect(element, offset, element, offset + 1);
	      } else if (offset > 0) {
	        return bridge.getRangedRect(element, offset - 1, element, offset);
	      }
	      return Optional.none();
	    };
	    var toCaret = function (rect) {
	      return {
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom
	      };
	    };
	    var getElemBox = function (bridge, element) {
	      return Optional.some(bridge.getRect(element));
	    };
	    var getBoxAt = function (bridge, element, offset) {
	      if (isElement(element)) {
	        return getElemBox(bridge, element).map(toCaret);
	      } else if (isText(element)) {
	        return getPartialBox(bridge, element, offset).map(toCaret);
	      } else {
	        return Optional.none();
	      }
	    };
	    var getEntireBox = function (bridge, element) {
	      if (isElement(element)) {
	        return getElemBox(bridge, element).map(toCaret);
	      } else if (isText(element)) {
	        return bridge.getRangedRect(element, 0, element, getEnd(element)).map(toCaret);
	      } else {
	        return Optional.none();
	      }
	    };
	
	    var JUMP_SIZE = 5;
	    var NUM_RETRIES = 100;
	    var adt$7 = Adt.generate([
	      { none: [] },
	      { retry: ['caret'] }
	    ]);
	    var isOutside = function (caret, box) {
	      return caret.left < box.left || Math.abs(box.right - caret.left) < 1 || caret.left > box.right;
	    };
	    var inOutsideBlock = function (bridge, element, caret) {
	      return closest(element, isBlock$1).fold(never, function (cell) {
	        return getEntireBox(bridge, cell).exists(function (box) {
	          return isOutside(caret, box);
	        });
	      });
	    };
	    var adjustDown = function (bridge, element, guessBox, original, caret) {
	      var lowerCaret = moveDown(caret, JUMP_SIZE);
	      if (Math.abs(guessBox.bottom - original.bottom) < 1) {
	        return adt$7.retry(lowerCaret);
	      } else if (guessBox.top > caret.bottom) {
	        return adt$7.retry(lowerCaret);
	      } else if (guessBox.top === caret.bottom) {
	        return adt$7.retry(moveDown(caret, 1));
	      } else {
	        return inOutsideBlock(bridge, element, caret) ? adt$7.retry(translate(lowerCaret, JUMP_SIZE, 0)) : adt$7.none();
	      }
	    };
	    var adjustUp = function (bridge, element, guessBox, original, caret) {
	      var higherCaret = moveUp(caret, JUMP_SIZE);
	      if (Math.abs(guessBox.top - original.top) < 1) {
	        return adt$7.retry(higherCaret);
	      } else if (guessBox.bottom < caret.top) {
	        return adt$7.retry(higherCaret);
	      } else if (guessBox.bottom === caret.top) {
	        return adt$7.retry(moveUp(caret, 1));
	      } else {
	        return inOutsideBlock(bridge, element, caret) ? adt$7.retry(translate(higherCaret, JUMP_SIZE, 0)) : adt$7.none();
	      }
	    };
	    var upMovement = {
	      point: getTop$1,
	      adjuster: adjustUp,
	      move: moveUp,
	      gather: before$4
	    };
	    var downMovement = {
	      point: getBottom,
	      adjuster: adjustDown,
	      move: moveDown,
	      gather: after$5
	    };
	    var isAtTable = function (bridge, x, y) {
	      return bridge.elementFromPoint(x, y).filter(function (elm) {
	        return name(elm) === 'table';
	      }).isSome();
	    };
	    var adjustForTable = function (bridge, movement, original, caret, numRetries) {
	      return adjustTil(bridge, movement, original, movement.move(caret, JUMP_SIZE), numRetries);
	    };
	    var adjustTil = function (bridge, movement, original, caret, numRetries) {
	      if (numRetries === 0) {
	        return Optional.some(caret);
	      }
	      if (isAtTable(bridge, caret.left, movement.point(caret))) {
	        return adjustForTable(bridge, movement, original, caret, numRetries - 1);
	      }
	      return bridge.situsFromPoint(caret.left, movement.point(caret)).bind(function (guess) {
	        return guess.start.fold(Optional.none, function (element) {
	          return getEntireBox(bridge, element).bind(function (guessBox) {
	            return movement.adjuster(bridge, element, guessBox, original, caret).fold(Optional.none, function (newCaret) {
	              return adjustTil(bridge, movement, original, newCaret, numRetries - 1);
	            });
	          }).orThunk(function () {
	            return Optional.some(caret);
	          });
	        }, Optional.none);
	      });
	    };
	    var ieTryDown = function (bridge, caret) {
	      return bridge.situsFromPoint(caret.left, caret.bottom + JUMP_SIZE);
	    };
	    var ieTryUp = function (bridge, caret) {
	      return bridge.situsFromPoint(caret.left, caret.top - JUMP_SIZE);
	    };
	    var checkScroll = function (movement, adjusted, bridge) {
	      if (movement.point(adjusted) > bridge.getInnerHeight()) {
	        return Optional.some(movement.point(adjusted) - bridge.getInnerHeight());
	      } else if (movement.point(adjusted) < 0) {
	        return Optional.some(-movement.point(adjusted));
	      } else {
	        return Optional.none();
	      }
	    };
	    var retry = function (movement, bridge, caret) {
	      var moved = movement.move(caret, JUMP_SIZE);
	      var adjusted = adjustTil(bridge, movement, caret, moved, NUM_RETRIES).getOr(moved);
	      return checkScroll(movement, adjusted, bridge).fold(function () {
	        return bridge.situsFromPoint(adjusted.left, movement.point(adjusted));
	      }, function (delta) {
	        bridge.scrollBy(0, delta);
	        return bridge.situsFromPoint(adjusted.left, movement.point(adjusted) - delta);
	      });
	    };
	    var Retries = {
	      tryUp: curry(retry, upMovement),
	      tryDown: curry(retry, downMovement),
	      ieTryUp: ieTryUp,
	      ieTryDown: ieTryDown,
	      getJumpSize: constant(JUMP_SIZE)
	    };
	
	    var MAX_RETRIES = 20;
	    var findSpot = function (bridge, isRoot, direction) {
	      return bridge.getSelection().bind(function (sel) {
	        return tryBr(isRoot, sel.finish, sel.foffset, direction).fold(function () {
	          return Optional.some(point(sel.finish, sel.foffset));
	        }, function (brNeighbour) {
	          var range = bridge.fromSitus(brNeighbour);
	          var analysis = BeforeAfter.verify(bridge, sel.finish, sel.foffset, range.finish, range.foffset, direction.failure, isRoot);
	          return process(analysis);
	        });
	      });
	    };
	    var scan$1 = function (bridge, isRoot, element, offset, direction, numRetries) {
	      if (numRetries === 0) {
	        return Optional.none();
	      }
	      return tryCursor(bridge, isRoot, element, offset, direction).bind(function (situs) {
	        var range = bridge.fromSitus(situs);
	        var analysis = BeforeAfter.verify(bridge, element, offset, range.finish, range.foffset, direction.failure, isRoot);
	        return BeforeAfter.cata(analysis, function () {
	          return Optional.none();
	        }, function () {
	          return Optional.some(situs);
	        }, function (cell) {
	          if (eq$1(element, cell) && offset === 0) {
	            return tryAgain(bridge, element, offset, moveUp, direction);
	          } else {
	            return scan$1(bridge, isRoot, cell, 0, direction, numRetries - 1);
	          }
	        }, function (cell) {
	          if (eq$1(element, cell) && offset === getEnd(cell)) {
	            return tryAgain(bridge, element, offset, moveDown, direction);
	          } else {
	            return scan$1(bridge, isRoot, cell, getEnd(cell), direction, numRetries - 1);
	          }
	        });
	      });
	    };
	    var tryAgain = function (bridge, element, offset, move, direction) {
	      return getBoxAt(bridge, element, offset).bind(function (box) {
	        return tryAt(bridge, direction, move(box, Retries.getJumpSize()));
	      });
	    };
	    var tryAt = function (bridge, direction, box) {
	      var browser = detect$3().browser;
	      if (browser.isChrome() || browser.isSafari() || browser.isFirefox() || browser.isEdge()) {
	        return direction.otherRetry(bridge, box);
	      } else if (browser.isIE()) {
	        return direction.ieRetry(bridge, box);
	      } else {
	        return Optional.none();
	      }
	    };
	    var tryCursor = function (bridge, isRoot, element, offset, direction) {
	      return getBoxAt(bridge, element, offset).bind(function (box) {
	        return tryAt(bridge, direction, box);
	      });
	    };
	    var handle$2 = function (bridge, isRoot, direction) {
	      return findSpot(bridge, isRoot, direction).bind(function (spot) {
	        return scan$1(bridge, isRoot, spot.element, spot.offset, direction, MAX_RETRIES).map(bridge.fromSitus);
	      });
	    };
	
	    var inSameTable = function (elem, table) {
	      return ancestor$2(elem, function (e) {
	        return parent(e).exists(function (p) {
	          return eq$1(p, table);
	        });
	      });
	    };
	    var simulate = function (bridge, isRoot, direction, initial, anchor) {
	      return closest$1(initial, 'td,th', isRoot).bind(function (start) {
	        return closest$1(start, 'table', isRoot).bind(function (table) {
	          if (!inSameTable(anchor, table)) {
	            return Optional.none();
	          }
	          return handle$2(bridge, isRoot, direction).bind(function (range) {
	            return closest$1(range.finish, 'td,th', isRoot).map(function (finish) {
	              return {
	                start: start,
	                finish: finish,
	                range: range
	              };
	            });
	          });
	        });
	      });
	    };
	    var navigate = function (bridge, isRoot, direction, initial, anchor, precheck) {
	      if (detect$3().browser.isIE()) {
	        return Optional.none();
	      } else {
	        return precheck(initial, isRoot).orThunk(function () {
	          return simulate(bridge, isRoot, direction, initial, anchor).map(function (info) {
	            var range = info.range;
	            return Response.create(Optional.some(makeSitus(range.start, range.soffset, range.finish, range.foffset)), true);
	          });
	        });
	      }
	    };
	    var firstUpCheck = function (initial, isRoot) {
	      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
	        return closest$1(startRow, 'table', isRoot).bind(function (table) {
	          var rows = descendants$1(table, 'tr');
	          if (eq$1(startRow, rows[0])) {
	            return seekLeft$1(table, function (element) {
	              return last$1(element).isSome();
	            }, isRoot).map(function (last) {
	              var lastOffset = getEnd(last);
	              return Response.create(Optional.some(makeSitus(last, lastOffset, last, lastOffset)), true);
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	      });
	    };
	    var lastDownCheck = function (initial, isRoot) {
	      return closest$1(initial, 'tr', isRoot).bind(function (startRow) {
	        return closest$1(startRow, 'table', isRoot).bind(function (table) {
	          var rows = descendants$1(table, 'tr');
	          if (eq$1(startRow, rows[rows.length - 1])) {
	            return seekRight$1(table, function (element) {
	              return first(element).isSome();
	            }, isRoot).map(function (first) {
	              return Response.create(Optional.some(makeSitus(first, 0, first, 0)), true);
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	      });
	    };
	    var select = function (bridge, container, isRoot, direction, initial, anchor, selectRange) {
	      return simulate(bridge, isRoot, direction, initial, anchor).bind(function (info) {
	        return detect$6(container, isRoot, info.start, info.finish, selectRange);
	      });
	    };
	
	    var value$1 = function () {
	      var subject = Cell(Optional.none());
	      var clear = function () {
	        return subject.set(Optional.none());
	      };
	      var set = function (s) {
	        return subject.set(Optional.some(s));
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var findCell = function (target, isRoot) {
	      return closest$1(target, 'td,th', isRoot);
	    };
	    var MouseSelection = function (bridge, container, isRoot, annotations) {
	      var cursor = value$1();
	      var clearstate = cursor.clear;
	      var applySelection = function (event) {
	        cursor.on(function (start) {
	          annotations.clearBeforeUpdate(container);
	          findCell(event.target, isRoot).each(function (finish) {
	            identify(start, finish, isRoot).each(function (cellSel) {
	              var boxes = cellSel.boxes.getOr([]);
	              if (boxes.length > 1 || boxes.length === 1 && !eq$1(start, finish)) {
	                annotations.selectRange(container, boxes, cellSel.start, cellSel.finish);
	                bridge.selectContents(finish);
	              }
	            });
	          });
	        });
	      };
	      var mousedown = function (event) {
	        annotations.clear(container);
	        findCell(event.target, isRoot).each(cursor.set);
	      };
	      var mouseover = function (event) {
	        applySelection(event);
	      };
	      var mouseup = function (event) {
	        applySelection(event);
	        clearstate();
	      };
	      return {
	        clearstate: clearstate,
	        mousedown: mousedown,
	        mouseover: mouseover,
	        mouseup: mouseup
	      };
	    };
	
	    var down = {
	      traverse: nextSibling,
	      gather: after$5,
	      relative: Situ.before,
	      otherRetry: Retries.tryDown,
	      ieRetry: Retries.ieTryDown,
	      failure: BeforeAfter.failedDown
	    };
	    var up = {
	      traverse: prevSibling,
	      gather: before$4,
	      relative: Situ.before,
	      otherRetry: Retries.tryUp,
	      ieRetry: Retries.ieTryUp,
	      failure: BeforeAfter.failedUp
	    };
	
	    var isKey = function (key) {
	      return function (keycode) {
	        return keycode === key;
	      };
	    };
	    var isUp = isKey(38);
	    var isDown = isKey(40);
	    var isNavigation = function (keycode) {
	      return keycode >= 37 && keycode <= 40;
	    };
	    var ltr$2 = {
	      isBackward: isKey(37),
	      isForward: isKey(39)
	    };
	    var rtl$2 = {
	      isBackward: isKey(39),
	      isForward: isKey(37)
	    };
	
	    var get$d = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	    var by = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var win = doc.defaultView;
	      if (win) {
	        win.scrollBy(x, y);
	      }
	    };
	
	    var WindowBridge = function (win) {
	      var elementFromPoint = function (x, y) {
	        return SugarElement.fromPoint(SugarElement.fromDom(win.document), x, y);
	      };
	      var getRect = function (element) {
	        return element.dom.getBoundingClientRect();
	      };
	      var getRangedRect = function (start, soffset, finish, foffset) {
	        var sel = SimSelection.exact(start, soffset, finish, foffset);
	        return getFirstRect$1(win, sel);
	      };
	      var getSelection = function () {
	        return get$c(win).map(function (exactAdt) {
	          return convertToRange(win, exactAdt);
	        });
	      };
	      var fromSitus = function (situs) {
	        var relative = SimSelection.relative(situs.start, situs.finish);
	        return convertToRange(win, relative);
	      };
	      var situsFromPoint = function (x, y) {
	        return getAtPoint(win, x, y).map(function (exact) {
	          return Situs.create(exact.start, exact.soffset, exact.finish, exact.foffset);
	        });
	      };
	      var clearSelection = function () {
	        clear(win);
	      };
	      var collapseSelection = function (toStart) {
	        if (toStart === void 0) {
	          toStart = false;
	        }
	        get$c(win).each(function (sel) {
	          return sel.fold(function (rng) {
	            return rng.collapse(toStart);
	          }, function (startSitu, finishSitu) {
	            var situ = toStart ? startSitu : finishSitu;
	            setRelative(win, situ, situ);
	          }, function (start, soffset, finish, foffset) {
	            var node = toStart ? start : finish;
	            var offset = toStart ? soffset : foffset;
	            setExact(win, node, offset, node, offset);
	          });
	        });
	      };
	      var selectContents = function (element) {
	        setToElement(win, element);
	      };
	      var setSelection = function (sel) {
	        setExact(win, sel.start, sel.soffset, sel.finish, sel.foffset);
	      };
	      var setRelativeSelection = function (start, finish) {
	        setRelative(win, start, finish);
	      };
	      var getInnerHeight = function () {
	        return win.innerHeight;
	      };
	      var getScrollY = function () {
	        var pos = get$d(SugarElement.fromDom(win.document));
	        return pos.top;
	      };
	      var scrollBy = function (x, y) {
	        by(x, y, SugarElement.fromDom(win.document));
	      };
	      return {
	        elementFromPoint: elementFromPoint,
	        getRect: getRect,
	        getRangedRect: getRangedRect,
	        getSelection: getSelection,
	        fromSitus: fromSitus,
	        situsFromPoint: situsFromPoint,
	        clearSelection: clearSelection,
	        collapseSelection: collapseSelection,
	        setSelection: setSelection,
	        setRelativeSelection: setRelativeSelection,
	        selectContents: selectContents,
	        getInnerHeight: getInnerHeight,
	        getScrollY: getScrollY,
	        scrollBy: scrollBy
	      };
	    };
	
	    var rc = function (rows, cols) {
	      return {
	        rows: rows,
	        cols: cols
	      };
	    };
	    var mouse = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      var handlers = MouseSelection(bridge, container, isRoot, annotations);
	      return {
	        clearstate: handlers.clearstate,
	        mousedown: handlers.mousedown,
	        mouseover: handlers.mouseover,
	        mouseup: handlers.mouseup
	      };
	    };
	    var keyboard = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      var clearToNavigate = function () {
	        annotations.clear(container);
	        return Optional.none();
	      };
	      var keydown = function (event, start, soffset, finish, foffset, direction) {
	        var realEvent = event.raw;
	        var keycode = realEvent.which;
	        var shiftKey = realEvent.shiftKey === true;
	        var handler = retrieve(container, annotations.selectedSelector).fold(function () {
	          if (isDown(keycode) && shiftKey) {
	            return curry(select, bridge, container, isRoot, down, finish, start, annotations.selectRange);
	          } else if (isUp(keycode) && shiftKey) {
	            return curry(select, bridge, container, isRoot, up, finish, start, annotations.selectRange);
	          } else if (isDown(keycode)) {
	            return curry(navigate, bridge, isRoot, down, finish, start, lastDownCheck);
	          } else if (isUp(keycode)) {
	            return curry(navigate, bridge, isRoot, up, finish, start, firstUpCheck);
	          } else {
	            return Optional.none;
	          }
	        }, function (selected) {
	          var update$1 = function (attempts) {
	            return function () {
	              var navigation = findMap(attempts, function (delta) {
	                return update(delta.rows, delta.cols, container, selected, annotations);
	              });
	              return navigation.fold(function () {
	                return getEdges(container, annotations.firstSelectedSelector, annotations.lastSelectedSelector).map(function (edges) {
	                  var relative = isDown(keycode) || direction.isForward(keycode) ? Situ.after : Situ.before;
	                  bridge.setRelativeSelection(Situ.on(edges.first, 0), relative(edges.table));
	                  annotations.clear(container);
	                  return Response.create(Optional.none(), true);
	                });
	              }, function (_) {
	                return Optional.some(Response.create(Optional.none(), true));
	              });
	            };
	          };
	          if (isDown(keycode) && shiftKey) {
	            return update$1([rc(+1, 0)]);
	          } else if (isUp(keycode) && shiftKey) {
	            return update$1([rc(-1, 0)]);
	          } else if (direction.isBackward(keycode) && shiftKey) {
	            return update$1([
	              rc(0, -1),
	              rc(-1, 0)
	            ]);
	          } else if (direction.isForward(keycode) && shiftKey) {
	            return update$1([
	              rc(0, +1),
	              rc(+1, 0)
	            ]);
	          } else if (isNavigation(keycode) && shiftKey === false) {
	            return clearToNavigate;
	          } else {
	            return Optional.none;
	          }
	        });
	        return handler();
	      };
	      var keyup = function (event, start, soffset, finish, foffset) {
	        return retrieve(container, annotations.selectedSelector).fold(function () {
	          var realEvent = event.raw;
	          var keycode = realEvent.which;
	          var shiftKey = realEvent.shiftKey === true;
	          if (shiftKey === false) {
	            return Optional.none();
	          }
	          if (isNavigation(keycode)) {
	            return sync(container, isRoot, start, soffset, finish, foffset, annotations.selectRange);
	          } else {
	            return Optional.none();
	          }
	        }, Optional.none);
	      };
	      return {
	        keydown: keydown,
	        keyup: keyup
	      };
	    };
	    var external = function (win, container, isRoot, annotations) {
	      var bridge = WindowBridge(win);
	      return function (start, finish) {
	        annotations.clearBeforeUpdate(container);
	        identify(start, finish, isRoot).each(function (cellSel) {
	          var boxes = cellSel.boxes.getOr([]);
	          annotations.selectRange(container, boxes, cellSel.start, cellSel.finish);
	          bridge.selectContents(finish);
	          bridge.collapseSelection();
	        });
	      };
	    };
	
	    var remove$7 = function (element, classes) {
	      each(classes, function (x) {
	        remove$5(element, x);
	      });
	    };
	
	    var addClass = function (clazz) {
	      return function (element) {
	        add$3(element, clazz);
	      };
	    };
	    var removeClasses = function (classes) {
	      return function (element) {
	        remove$7(element, classes);
	      };
	    };
	
	    var byClass = function (ephemera) {
	      var addSelectionClass = addClass(ephemera.selected);
	      var removeSelectionClasses = removeClasses([
	        ephemera.selected,
	        ephemera.lastSelected,
	        ephemera.firstSelected
	      ]);
	      var clear = function (container) {
	        var sels = descendants$1(container, ephemera.selectedSelector);
	        each(sels, removeSelectionClasses);
	      };
	      var selectRange = function (container, cells, start, finish) {
	        clear(container);
	        each(cells, addSelectionClass);
	        add$3(start, ephemera.firstSelected);
	        add$3(finish, ephemera.lastSelected);
	      };
	      return {
	        clearBeforeUpdate: clear,
	        clear: clear,
	        selectRange: selectRange,
	        selectedSelector: ephemera.selectedSelector,
	        firstSelectedSelector: ephemera.firstSelectedSelector,
	        lastSelectedSelector: ephemera.lastSelectedSelector
	      };
	    };
	    var byAttr = function (ephemera, onSelection, onClear) {
	      var removeSelectionAttributes = function (element) {
	        remove(element, ephemera.selected);
	        remove(element, ephemera.firstSelected);
	        remove(element, ephemera.lastSelected);
	      };
	      var addSelectionAttribute = function (element) {
	        set(element, ephemera.selected, '1');
	      };
	      var clear = function (container) {
	        clearBeforeUpdate(container);
	        onClear();
	      };
	      var clearBeforeUpdate = function (container) {
	        var sels = descendants$1(container, ephemera.selectedSelector);
	        each(sels, removeSelectionAttributes);
	      };
	      var selectRange = function (container, cells, start, finish) {
	        clear(container);
	        each(cells, addSelectionAttribute);
	        set(start, ephemera.firstSelected, '1');
	        set(finish, ephemera.lastSelected, '1');
	        onSelection(cells, start, finish);
	      };
	      return {
	        clearBeforeUpdate: clearBeforeUpdate,
	        clear: clear,
	        selectRange: selectRange,
	        selectedSelector: ephemera.selectedSelector,
	        firstSelectedSelector: ephemera.firstSelectedSelector,
	        lastSelectedSelector: ephemera.lastSelectedSelector
	      };
	    };
	    var SelectionAnnotation = {
	      byClass: byClass,
	      byAttr: byAttr
	    };
	
	    var getUpOrLeftCells = function (grid, selectedCells, generators) {
	      var upGrid = grid.slice(0, selectedCells[selectedCells.length - 1].row + 1);
	      var upDetails = toDetailList(upGrid, generators);
	      return bind(upDetails, function (detail) {
	        var slicedCells = detail.cells.slice(0, selectedCells[selectedCells.length - 1].column + 1);
	        return map(slicedCells, function (cell) {
	          return cell.element;
	        });
	      });
	    };
	    var getDownOrRightCells = function (grid, selectedCells, generators) {
	      var downGrid = grid.slice(selectedCells[0].row + selectedCells[0].rowspan - 1, grid.length);
	      var downDetails = toDetailList(downGrid, generators);
	      return bind(downDetails, function (detail) {
	        var slicedCells = detail.cells.slice(selectedCells[0].column + selectedCells[0].colspan - 1, detail.cells.length);
	        return map(slicedCells, function (cell) {
	          return cell.element;
	        });
	      });
	    };
	    var getOtherCells = function (table, target, generators) {
	      var warehouse = Warehouse.fromTable(table);
	      var details = onCells(warehouse, target);
	      return details.map(function (selectedCells) {
	        var grid = toGrid(warehouse, generators, false);
	        var upOrLeftCells = getUpOrLeftCells(grid, selectedCells, generators);
	        var downOrRightCells = getDownOrRightCells(grid, selectedCells, generators);
	        return {
	          upOrLeftCells: upOrLeftCells,
	          downOrRightCells: downOrRightCells
	        };
	      });
	    };
	
	    var hasInternalTarget = function (e) {
	      return has$1(SugarElement.fromDom(e.target), 'ephox-snooker-resizer-bar') === false;
	    };
	    function CellSelection (editor, lazyResize, selectionTargets) {
	      var onSelection = function (cells, start, finish) {
	        selectionTargets.targets().each(function (targets) {
	          var tableOpt = table(start);
	          tableOpt.each(function (table) {
	            var cloneFormats = getCloneElements(editor);
	            var generators = cellOperations(noop, SugarElement.fromDom(editor.getDoc()), cloneFormats);
	            var otherCells = getOtherCells(table, targets, generators);
	            fireTableSelectionChange(editor, cells, start, finish, otherCells);
	          });
	        });
	      };
	      var onClear = function () {
	        return fireTableSelectionClear(editor);
	      };
	      var annotations = SelectionAnnotation.byAttr(ephemera, onSelection, onClear);
	      editor.on('init', function (_e) {
	        var win = editor.getWin();
	        var body = getBody$1(editor);
	        var isRoot = getIsRoot(editor);
	        var syncSelection = function () {
	          var sel = editor.selection;
	          var start = SugarElement.fromDom(sel.getStart());
	          var end = SugarElement.fromDom(sel.getEnd());
	          var shared = sharedOne$1(table, [
	            start,
	            end
	          ]);
	          shared.fold(function () {
	            return annotations.clear(body);
	          }, noop);
	        };
	        var mouseHandlers = mouse(win, body, isRoot, annotations);
	        var keyHandlers = keyboard(win, body, isRoot, annotations);
	        var external$1 = external(win, body, isRoot, annotations);
	        var hasShiftKey = function (event) {
	          return event.raw.shiftKey === true;
	        };
	        editor.on('TableSelectorChange', function (e) {
	          return external$1(e.start, e.finish);
	        });
	        var handleResponse = function (event, response) {
	          if (!hasShiftKey(event)) {
	            return;
	          }
	          if (response.kill) {
	            event.kill();
	          }
	          response.selection.each(function (ns) {
	            var relative = SimSelection.relative(ns.start, ns.finish);
	            var rng = asLtrRange(win, relative);
	            editor.selection.setRng(rng);
	          });
	        };
	        var keyup = function (event) {
	          var wrappedEvent = fromRawEvent$1(event);
	          if (wrappedEvent.raw.shiftKey && isNavigation(wrappedEvent.raw.which)) {
	            var rng = editor.selection.getRng();
	            var start = SugarElement.fromDom(rng.startContainer);
	            var end = SugarElement.fromDom(rng.endContainer);
	            keyHandlers.keyup(wrappedEvent, start, rng.startOffset, end, rng.endOffset).each(function (response) {
	              handleResponse(wrappedEvent, response);
	            });
	          }
	        };
	        var keydown = function (event) {
	          var wrappedEvent = fromRawEvent$1(event);
	          lazyResize().each(function (resize) {
	            return resize.hideBars();
	          });
	          var rng = editor.selection.getRng();
	          var start = SugarElement.fromDom(rng.startContainer);
	          var end = SugarElement.fromDom(rng.endContainer);
	          var direction = onDirection(ltr$2, rtl$2)(SugarElement.fromDom(editor.selection.getStart()));
	          keyHandlers.keydown(wrappedEvent, start, rng.startOffset, end, rng.endOffset, direction).each(function (response) {
	            handleResponse(wrappedEvent, response);
	          });
	          lazyResize().each(function (resize) {
	            return resize.showBars();
	          });
	        };
	        var isLeftMouse = function (raw) {
	          return raw.button === 0;
	        };
	        var isLeftButtonPressed = function (raw) {
	          if (raw.buttons === undefined) {
	            return true;
	          }
	          if (global$2.browser.isEdge() && raw.buttons === 0) {
	            return true;
	          }
	          return (raw.buttons & 1) !== 0;
	        };
	        var dragStart = function (_e) {
	          mouseHandlers.clearstate();
	        };
	        var mouseDown = function (e) {
	          if (isLeftMouse(e) && hasInternalTarget(e)) {
	            mouseHandlers.mousedown(fromRawEvent$1(e));
	          }
	        };
	        var mouseOver = function (e) {
	          if (isLeftButtonPressed(e) && hasInternalTarget(e)) {
	            mouseHandlers.mouseover(fromRawEvent$1(e));
	          }
	        };
	        var mouseUp = function (e) {
	          if (isLeftMouse(e) && hasInternalTarget(e)) {
	            mouseHandlers.mouseup(fromRawEvent$1(e));
	          }
	        };
	        var getDoubleTap = function () {
	          var lastTarget = Cell(SugarElement.fromDom(body));
	          var lastTimeStamp = Cell(0);
	          var touchEnd = function (t) {
	            var target = SugarElement.fromDom(t.target);
	            if (name(target) === 'td' || name(target) === 'th') {
	              var lT = lastTarget.get();
	              var lTS = lastTimeStamp.get();
	              if (eq$1(lT, target) && t.timeStamp - lTS < 300) {
	                t.preventDefault();
	                external$1(target, target);
	              }
	            }
	            lastTarget.set(target);
	            lastTimeStamp.set(t.timeStamp);
	          };
	          return { touchEnd: touchEnd };
	        };
	        var doubleTap = getDoubleTap();
	        editor.on('dragstart', dragStart);
	        editor.on('mousedown', mouseDown);
	        editor.on('mouseover', mouseOver);
	        editor.on('mouseup', mouseUp);
	        editor.on('touchend', doubleTap.touchEnd);
	        editor.on('keyup', keyup);
	        editor.on('keydown', keydown);
	        editor.on('NodeChange', syncSelection);
	      });
	      return { clear: annotations.clear };
	    }
	
	    var getSelectionTargets = function (editor, selections) {
	      var targets = Cell(Optional.none());
	      var changeHandlers = Cell([]);
	      var selectionDetails = Optional.none();
	      var isCaption = isTag('caption');
	      var isDisabledForSelection = function (key) {
	        return selectionDetails.forall(function (details) {
	          return !details[key];
	        });
	      };
	      var findTargets = function () {
	        return getSelectionStartCellOrCaption(getSelectionStart(editor), getIsRoot(editor)).bind(function (cellOrCaption) {
	          var table$1 = table(cellOrCaption);
	          return table$1.map(function (table) {
	            if (isCaption(cellOrCaption)) {
	              return noMenu(cellOrCaption);
	            } else {
	              return forMenu(selections, table, cellOrCaption);
	            }
	          });
	        });
	      };
	      var getExtractedDetails = function (targets) {
	        var tableOpt = table(targets.element);
	        return tableOpt.map(function (table) {
	          var warehouse = Warehouse.fromTable(table);
	          var selectedCells = onCells(warehouse, targets).getOr([]);
	          var locked = foldl(selectedCells, function (acc, cell) {
	            if (cell.isLocked) {
	              acc.onAny = true;
	              if (cell.column === 0) {
	                acc.onFirst = true;
	              } else if (cell.column + cell.colspan >= warehouse.grid.columns) {
	                acc.onLast = true;
	              }
	            }
	            return acc;
	          }, {
	            onAny: false,
	            onFirst: false,
	            onLast: false
	          });
	          return {
	            mergeable: onUnlockedMergable(warehouse, targets).isSome(),
	            unmergeable: onUnlockedUnmergable(warehouse, targets).isSome(),
	            locked: locked
	          };
	        });
	      };
	      var resetTargets = function () {
	        targets.set(cached(findTargets)());
	        selectionDetails = targets.get().bind(getExtractedDetails);
	        each(changeHandlers.get(), function (handler) {
	          return handler();
	        });
	      };
	      var onSetup = function (api, isDisabled) {
	        var handler = function () {
	          return targets.get().fold(function () {
	            api.setDisabled(true);
	          }, function (targets) {
	            api.setDisabled(isDisabled(targets));
	          });
	        };
	        handler();
	        changeHandlers.set(changeHandlers.get().concat([handler]));
	        return function () {
	          changeHandlers.set(filter(changeHandlers.get(), function (h) {
	            return h !== handler;
	          }));
	        };
	      };
	      var isDisabledFromLocked = function (lockedDisable) {
	        return selectionDetails.exists(function (details) {
	          return details.locked[lockedDisable];
	        });
	      };
	      var onSetupTable = function (api) {
	        return onSetup(api, function (_) {
	          return false;
	        });
	      };
	      var onSetupCellOrRow = function (api) {
	        return onSetup(api, function (targets) {
	          return isCaption(targets.element);
	        });
	      };
	      var onSetupColumn = function (lockedDisable) {
	        return function (api) {
	          return onSetup(api, function (targets) {
	            return isCaption(targets.element) || isDisabledFromLocked(lockedDisable);
	          });
	        };
	      };
	      var onSetupPasteable = function (getClipboardData) {
	        return function (api) {
	          return onSetup(api, function (targets) {
	            return isCaption(targets.element) || getClipboardData().isNone();
	          });
	        };
	      };
	      var onSetupPasteableColumn = function (getClipboardData, lockedDisable) {
	        return function (api) {
	          return onSetup(api, function (targets) {
	            return isCaption(targets.element) || getClipboardData().isNone() || isDisabledFromLocked(lockedDisable);
	          });
	        };
	      };
	      var onSetupMergeable = function (api) {
	        return onSetup(api, function (_targets) {
	          return isDisabledForSelection('mergeable');
	        });
	      };
	      var onSetupUnmergeable = function (api) {
	        return onSetup(api, function (_targets) {
	          return isDisabledForSelection('unmergeable');
	        });
	      };
	      editor.on('NodeChange ExecCommand TableSelectorChange', resetTargets);
	      return {
	        onSetupTable: onSetupTable,
	        onSetupCellOrRow: onSetupCellOrRow,
	        onSetupColumn: onSetupColumn,
	        onSetupPasteable: onSetupPasteable,
	        onSetupPasteableColumn: onSetupPasteableColumn,
	        onSetupMergeable: onSetupMergeable,
	        onSetupUnmergeable: onSetupUnmergeable,
	        resetTargets: resetTargets,
	        targets: function () {
	          return targets.get();
	        }
	      };
	    };
	
	    var addButtons = function (editor, selectionTargets, clipboard) {
	      editor.ui.registry.addMenuButton('table', {
	        tooltip: 'Table',
	        icon: 'table',
	        fetch: function (callback) {
	          return callback('inserttable | cell row column | advtablesort | tableprops deletetable');
	        }
	      });
	      var cmd = function (command) {
	        return function () {
	          return editor.execCommand(command);
	        };
	      };
	      editor.ui.registry.addButton('tableprops', {
	        tooltip: 'Table properties',
	        onAction: cmd('mceTableProps'),
	        icon: 'table',
	        onSetup: selectionTargets.onSetupTable
	      });
	      editor.ui.registry.addButton('tabledelete', {
	        tooltip: 'Delete table',
	        onAction: cmd('mceTableDelete'),
	        icon: 'table-delete-table',
	        onSetup: selectionTargets.onSetupTable
	      });
	      editor.ui.registry.addButton('tablecellprops', {
	        tooltip: 'Cell properties',
	        onAction: cmd('mceTableCellProps'),
	        icon: 'table-cell-properties',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablemergecells', {
	        tooltip: 'Merge cells',
	        onAction: cmd('mceTableMergeCells'),
	        icon: 'table-merge-cells',
	        onSetup: selectionTargets.onSetupMergeable
	      });
	      editor.ui.registry.addButton('tablesplitcells', {
	        tooltip: 'Split cell',
	        onAction: cmd('mceTableSplitCells'),
	        icon: 'table-split-cells',
	        onSetup: selectionTargets.onSetupUnmergeable
	      });
	      editor.ui.registry.addButton('tableinsertrowbefore', {
	        tooltip: 'Insert row before',
	        onAction: cmd('mceTableInsertRowBefore'),
	        icon: 'table-insert-row-above',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tableinsertrowafter', {
	        tooltip: 'Insert row after',
	        onAction: cmd('mceTableInsertRowAfter'),
	        icon: 'table-insert-row-after',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tabledeleterow', {
	        tooltip: 'Delete row',
	        onAction: cmd('mceTableDeleteRow'),
	        icon: 'table-delete-row',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablerowprops', {
	        tooltip: 'Row properties',
	        onAction: cmd('mceTableRowProps'),
	        icon: 'table-row-properties',
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tableinsertcolbefore', {
	        tooltip: 'Insert column before',
	        onAction: cmd('mceTableInsertColBefore'),
	        icon: 'table-insert-column-before',
	        onSetup: selectionTargets.onSetupColumn('onFirst')
	      });
	      editor.ui.registry.addButton('tableinsertcolafter', {
	        tooltip: 'Insert column after',
	        onAction: cmd('mceTableInsertColAfter'),
	        icon: 'table-insert-column-after',
	        onSetup: selectionTargets.onSetupColumn('onLast')
	      });
	      editor.ui.registry.addButton('tabledeletecol', {
	        tooltip: 'Delete column',
	        onAction: cmd('mceTableDeleteCol'),
	        icon: 'table-delete-column',
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addButton('tablecutrow', {
	        tooltip: 'Cut row',
	        icon: 'cut-row',
	        onAction: cmd('mceTableCutRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablecopyrow', {
	        tooltip: 'Copy row',
	        icon: 'duplicate-row',
	        onAction: cmd('mceTableCopyRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addButton('tablepasterowbefore', {
	        tooltip: 'Paste row before',
	        icon: 'paste-row-before',
	        onAction: cmd('mceTablePasteRowBefore'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      editor.ui.registry.addButton('tablepasterowafter', {
	        tooltip: 'Paste row after',
	        icon: 'paste-row-after',
	        onAction: cmd('mceTablePasteRowAfter'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      editor.ui.registry.addButton('tablecutcol', {
	        tooltip: 'Cut column',
	        icon: 'cut-column',
	        onAction: cmd('mceTableCutCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addButton('tablecopycol', {
	        tooltip: 'Copy column',
	        icon: 'duplicate-column',
	        onAction: cmd('mceTableCopyCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addButton('tablepastecolbefore', {
	        tooltip: 'Paste column before',
	        icon: 'paste-column-before',
	        onAction: cmd('mceTablePasteColBefore'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onFirst')
	      });
	      editor.ui.registry.addButton('tablepastecolafter', {
	        tooltip: 'Paste column after',
	        icon: 'paste-column-after',
	        onAction: cmd('mceTablePasteColAfter'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onLast')
	      });
	      editor.ui.registry.addButton('tableinsertdialog', {
	        tooltip: 'Insert table',
	        onAction: cmd('mceInsertTable'),
	        icon: 'table'
	      });
	    };
	    var addToolbars = function (editor) {
	      var isTable = function (table) {
	        return editor.dom.is(table, 'table') && editor.getBody().contains(table);
	      };
	      var toolbar = getToolbar(editor);
	      if (toolbar.length > 0) {
	        editor.ui.registry.addContextToolbar('table', {
	          predicate: isTable,
	          items: toolbar,
	          scope: 'node',
	          position: 'node'
	        });
	      }
	    };
	
	    var addMenuItems = function (editor, selectionTargets, clipboard) {
	      var cmd = function (command) {
	        return function () {
	          return editor.execCommand(command);
	        };
	      };
	      var insertTableAction = function (data) {
	        editor.execCommand('mceInsertTable', false, {
	          rows: data.numRows,
	          columns: data.numColumns
	        });
	      };
	      var tableProperties = {
	        text: 'Table properties',
	        onSetup: selectionTargets.onSetupTable,
	        onAction: cmd('mceTableProps')
	      };
	      var deleteTable = {
	        text: 'Delete table',
	        icon: 'table-delete-table',
	        onSetup: selectionTargets.onSetupTable,
	        onAction: cmd('mceTableDelete')
	      };
	      editor.ui.registry.addMenuItem('tableinsertrowbefore', {
	        text: 'Insert row before',
	        icon: 'table-insert-row-above',
	        onAction: cmd('mceTableInsertRowBefore'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tableinsertrowafter', {
	        text: 'Insert row after',
	        icon: 'table-insert-row-after',
	        onAction: cmd('mceTableInsertRowAfter'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tabledeleterow', {
	        text: 'Delete row',
	        icon: 'table-delete-row',
	        onAction: cmd('mceTableDeleteRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablerowprops', {
	        text: 'Row properties',
	        icon: 'table-row-properties',
	        onAction: cmd('mceTableRowProps'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablecutrow', {
	        text: 'Cut row',
	        icon: 'cut-row',
	        onAction: cmd('mceTableCutRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablecopyrow', {
	        text: 'Copy row',
	        icon: 'duplicate-row',
	        onAction: cmd('mceTableCopyRow'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablepasterowbefore', {
	        text: 'Paste row before',
	        icon: 'paste-row-before',
	        onAction: cmd('mceTablePasteRowBefore'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      editor.ui.registry.addMenuItem('tablepasterowafter', {
	        text: 'Paste row after',
	        icon: 'paste-row-after',
	        onAction: cmd('mceTablePasteRowAfter'),
	        onSetup: selectionTargets.onSetupPasteable(clipboard.getRows)
	      });
	      var row = {
	        type: 'nestedmenuitem',
	        text: 'Row',
	        getSubmenuItems: function () {
	          return 'tableinsertrowbefore tableinsertrowafter tabledeleterow tablerowprops | tablecutrow tablecopyrow tablepasterowbefore tablepasterowafter';
	        }
	      };
	      editor.ui.registry.addMenuItem('tableinsertcolumnbefore', {
	        text: 'Insert column before',
	        icon: 'table-insert-column-before',
	        onAction: cmd('mceTableInsertColBefore'),
	        onSetup: selectionTargets.onSetupColumn('onFirst')
	      });
	      editor.ui.registry.addMenuItem('tableinsertcolumnafter', {
	        text: 'Insert column after',
	        icon: 'table-insert-column-after',
	        onAction: cmd('mceTableInsertColAfter'),
	        onSetup: selectionTargets.onSetupColumn('onLast')
	      });
	      editor.ui.registry.addMenuItem('tabledeletecolumn', {
	        text: 'Delete column',
	        icon: 'table-delete-column',
	        onAction: cmd('mceTableDeleteCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addMenuItem('tablecutcolumn', {
	        text: 'Cut column',
	        icon: 'cut-column',
	        onAction: cmd('mceTableCutCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addMenuItem('tablecopycolumn', {
	        text: 'Copy column',
	        icon: 'duplicate-column',
	        onAction: cmd('mceTableCopyCol'),
	        onSetup: selectionTargets.onSetupColumn('onAny')
	      });
	      editor.ui.registry.addMenuItem('tablepastecolumnbefore', {
	        text: 'Paste column before',
	        icon: 'paste-column-before',
	        onAction: cmd('mceTablePasteColBefore'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onFirst')
	      });
	      editor.ui.registry.addMenuItem('tablepastecolumnafter', {
	        text: 'Paste column after',
	        icon: 'paste-column-after',
	        onAction: cmd('mceTablePasteColAfter'),
	        onSetup: selectionTargets.onSetupPasteableColumn(clipboard.getColumns, 'onLast')
	      });
	      var column = {
	        type: 'nestedmenuitem',
	        text: 'Column',
	        getSubmenuItems: function () {
	          return 'tableinsertcolumnbefore tableinsertcolumnafter tabledeletecolumn | tablecutcolumn tablecopycolumn tablepastecolumnbefore tablepastecolumnafter';
	        }
	      };
	      editor.ui.registry.addMenuItem('tablecellprops', {
	        text: 'Cell properties',
	        icon: 'table-cell-properties',
	        onAction: cmd('mceTableCellProps'),
	        onSetup: selectionTargets.onSetupCellOrRow
	      });
	      editor.ui.registry.addMenuItem('tablemergecells', {
	        text: 'Merge cells',
	        icon: 'table-merge-cells',
	        onAction: cmd('mceTableMergeCells'),
	        onSetup: selectionTargets.onSetupMergeable
	      });
	      editor.ui.registry.addMenuItem('tablesplitcells', {
	        text: 'Split cell',
	        icon: 'table-split-cells',
	        onAction: cmd('mceTableSplitCells'),
	        onSetup: selectionTargets.onSetupUnmergeable
	      });
	      var cell = {
	        type: 'nestedmenuitem',
	        text: 'Cell',
	        getSubmenuItems: function () {
	          return 'tablecellprops tablemergecells tablesplitcells';
	        }
	      };
	      if (hasTableGrid(editor) === false) {
	        editor.ui.registry.addMenuItem('inserttable', {
	          text: 'Table',
	          icon: 'table',
	          onAction: cmd('mceInsertTable')
	        });
	      } else {
	        editor.ui.registry.addNestedMenuItem('inserttable', {
	          text: 'Table',
	          icon: 'table',
	          getSubmenuItems: function () {
	            return [{
	                type: 'fancymenuitem',
	                fancytype: 'inserttable',
	                onAction: insertTableAction
	              }];
	          }
	        });
	      }
	      editor.ui.registry.addMenuItem('inserttabledialog', {
	        text: 'Insert table',
	        icon: 'table',
	        onAction: cmd('mceInsertTable')
	      });
	      editor.ui.registry.addMenuItem('tableprops', tableProperties);
	      editor.ui.registry.addMenuItem('deletetable', deleteTable);
	      editor.ui.registry.addNestedMenuItem('row', row);
	      editor.ui.registry.addNestedMenuItem('column', column);
	      editor.ui.registry.addNestedMenuItem('cell', cell);
	      editor.ui.registry.addContextMenu('table', {
	        update: function () {
	          selectionTargets.resetTargets();
	          return selectionTargets.targets().fold(function () {
	            return '';
	          }, function (targets) {
	            if (name(targets.element) === 'caption') {
	              return 'tableprops deletetable';
	            } else {
	              return 'cell row column | advtablesort | tableprops deletetable';
	            }
	          });
	        }
	      });
	    };
	
	    var Plugin = function (editor) {
	      var selections = Selections(function () {
	        return getBody$1(editor);
	      }, function () {
	        return getSelectionStartCellOrCaption(getSelectionStart(editor));
	      }, ephemera.selectedSelector);
	      var selectionTargets = getSelectionTargets(editor, selections);
	      var resizeHandler = getResizeHandler(editor);
	      var cellSelection = CellSelection(editor, resizeHandler.lazyResize, selectionTargets);
	      var actions = TableActions(editor, resizeHandler.lazyWire, selections);
	      var clipboard = Clipboard();
	      registerCommands(editor, actions, cellSelection, selections, clipboard);
	      registerQueryCommands(editor, actions, selections);
	      registerEvents(editor, selections, actions, cellSelection);
	      addMenuItems(editor, selectionTargets, clipboard);
	      addButtons(editor, selectionTargets, clipboard);
	      addToolbars(editor);
	      editor.on('PreInit', function () {
	        editor.serializer.addTempAttr(ephemera.firstSelected);
	        editor.serializer.addTempAttr(ephemera.lastSelected);
	        registerFormats(editor);
	      });
	      if (hasTabNavigation(editor)) {
	        editor.on('keydown', function (e) {
	          handle$1(e, editor, cellSelection);
	        });
	      }
	      editor.on('remove', function () {
	        resizeHandler.destroy();
	      });
	      return getApi(editor, clipboard, resizeHandler, selectionTargets);
	    };
	    function Plugin$1 () {
	      global.add('table', Plugin);
	    }
	
	    Plugin$1();
	
	}());


/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "template" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/template')
	//   ES2015:
	//     import 'tinymce/plugins/template'
	__webpack_require__(1240);

/***/ },
/* 1240 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var noop = function () {
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var never = constant(false);
	    var always = constant(true);
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.XHR');
	
	    var getCreationDateClasses = function (editor) {
	      return editor.getParam('template_cdate_classes', 'cdate');
	    };
	    var getModificationDateClasses = function (editor) {
	      return editor.getParam('template_mdate_classes', 'mdate');
	    };
	    var getSelectedContentClasses = function (editor) {
	      return editor.getParam('template_selected_content_classes', 'selcontent');
	    };
	    var getPreviewReplaceValues = function (editor) {
	      return editor.getParam('template_preview_replace_values');
	    };
	    var getContentStyle = function (editor) {
	      return editor.getParam('content_style', '', 'string');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getTemplateReplaceValues = function (editor) {
	      return editor.getParam('template_replace_values');
	    };
	    var getTemplates = function (editor) {
	      return editor.getParam('templates');
	    };
	    var getCdateFormat = function (editor) {
	      return editor.getParam('template_cdate_format', editor.translate('%Y-%m-%d'));
	    };
	    var getMdateFormat = function (editor) {
	      return editor.getParam('template_mdate_format', editor.translate('%Y-%m-%d'));
	    };
	    var getBodyClassFromHash = function (editor) {
	      var bodyClass = editor.getParam('body_class', '', 'hash');
	      return bodyClass[editor.id] || '';
	    };
	    var getBodyClass = function (editor) {
	      var bodyClass = editor.getParam('body_class', '', 'string');
	      if (bodyClass.indexOf('=') === -1) {
	        return bodyClass;
	      } else {
	        return getBodyClassFromHash(editor);
	      }
	    };
	
	    var addZeros = function (value, len) {
	      value = '' + value;
	      if (value.length < len) {
	        for (var i = 0; i < len - value.length; i++) {
	          value = '0' + value;
	        }
	      }
	      return value;
	    };
	    var getDateTime = function (editor, fmt, date) {
	      var daysShort = 'Sun Mon Tue Wed Thu Fri Sat Sun'.split(' ');
	      var daysLong = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday'.split(' ');
	      var monthsShort = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' ');
	      var monthsLong = 'January February March April May June July August September October November December'.split(' ');
	      date = date || new Date();
	      fmt = fmt.replace('%D', '%m/%d/%Y');
	      fmt = fmt.replace('%r', '%I:%M:%S %p');
	      fmt = fmt.replace('%Y', '' + date.getFullYear());
	      fmt = fmt.replace('%y', '' + date.getYear());
	      fmt = fmt.replace('%m', addZeros(date.getMonth() + 1, 2));
	      fmt = fmt.replace('%d', addZeros(date.getDate(), 2));
	      fmt = fmt.replace('%H', '' + addZeros(date.getHours(), 2));
	      fmt = fmt.replace('%M', '' + addZeros(date.getMinutes(), 2));
	      fmt = fmt.replace('%S', '' + addZeros(date.getSeconds(), 2));
	      fmt = fmt.replace('%I', '' + ((date.getHours() + 11) % 12 + 1));
	      fmt = fmt.replace('%p', '' + (date.getHours() < 12 ? 'AM' : 'PM'));
	      fmt = fmt.replace('%B', '' + editor.translate(monthsLong[date.getMonth()]));
	      fmt = fmt.replace('%b', '' + editor.translate(monthsShort[date.getMonth()]));
	      fmt = fmt.replace('%A', '' + editor.translate(daysLong[date.getDay()]));
	      fmt = fmt.replace('%a', '' + editor.translate(daysShort[date.getDay()]));
	      fmt = fmt.replace('%%', '%');
	      return fmt;
	    };
	
	    var createTemplateList = function (editor, callback) {
	      return function () {
	        var templateList = getTemplates(editor);
	        if (typeof templateList === 'function') {
	          templateList(callback);
	          return;
	        }
	        if (typeof templateList === 'string') {
	          global$2.send({
	            url: templateList,
	            success: function (text) {
	              callback(JSON.parse(text));
	            }
	          });
	        } else {
	          callback(templateList);
	        }
	      };
	    };
	    var replaceTemplateValues = function (html, templateValues) {
	      global$1.each(templateValues, function (v, k) {
	        if (typeof v === 'function') {
	          v = v(k);
	        }
	        html = html.replace(new RegExp('\\{\\$' + k + '\\}', 'g'), v);
	      });
	      return html;
	    };
	    var replaceVals = function (editor, e) {
	      var dom = editor.dom, vl = getTemplateReplaceValues(editor);
	      global$1.each(dom.select('*', e), function (e) {
	        global$1.each(vl, function (v, k) {
	          if (dom.hasClass(e, k)) {
	            if (typeof vl[k] === 'function') {
	              vl[k](e);
	            }
	          }
	        });
	      });
	    };
	    var hasClass = function (n, c) {
	      return new RegExp('\\b' + c + '\\b', 'g').test(n.className);
	    };
	    var insertTemplate = function (editor, _ui, html) {
	      var el;
	      var dom = editor.dom;
	      var sel = editor.selection.getContent();
	      html = replaceTemplateValues(html, getTemplateReplaceValues(editor));
	      el = dom.create('div', null, html);
	      var n = dom.select('.mceTmpl', el);
	      if (n && n.length > 0) {
	        el = dom.create('div', null);
	        el.appendChild(n[0].cloneNode(true));
	      }
	      global$1.each(dom.select('*', el), function (n) {
	        if (hasClass(n, getCreationDateClasses(editor).replace(/\s+/g, '|'))) {
	          n.innerHTML = getDateTime(editor, getCdateFormat(editor));
	        }
	        if (hasClass(n, getModificationDateClasses(editor).replace(/\s+/g, '|'))) {
	          n.innerHTML = getDateTime(editor, getMdateFormat(editor));
	        }
	        if (hasClass(n, getSelectedContentClasses(editor).replace(/\s+/g, '|'))) {
	          n.innerHTML = sel;
	        }
	      });
	      replaceVals(editor, el);
	      editor.execCommand('mceInsertContent', false, el.innerHTML);
	      editor.addVisual();
	    };
	
	    var register = function (editor) {
	      editor.addCommand('mceInsertTemplate', curry(insertTemplate, editor));
	    };
	
	    var setup = function (editor) {
	      editor.on('PreProcess', function (o) {
	        var dom = editor.dom, dateFormat = getMdateFormat(editor);
	        global$1.each(dom.select('div', o.node), function (e) {
	          if (dom.hasClass(e, 'mceTmpl')) {
	            global$1.each(dom.select('*', e), function (e) {
	              if (dom.hasClass(e, getModificationDateClasses(editor).replace(/\s+/g, '|'))) {
	                e.innerHTML = getDateTime(editor, dateFormat);
	              }
	            });
	            replaceVals(editor, e);
	          }
	        });
	      });
	    };
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var hasOwnProperty = Object.hasOwnProperty;
	    var get = function (obj, key) {
	      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	
	    var entitiesAttr = {
	      '"': '&quot;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '&': '&amp;',
	      '\'': '&#039;'
	    };
	    var htmlEscape = function (html) {
	      return html.replace(/["'<>&]/g, function (match) {
	        return get(entitiesAttr, match).getOr(match);
	      });
	    };
	
	    var getPreviewContent = function (editor, html) {
	      if (html.indexOf('<html>') === -1) {
	        var contentCssEntries_1 = '';
	        var contentStyle = getContentStyle(editor);
	        var cors_1 = shouldUseContentCssCors(editor) ? ' crossorigin="anonymous"' : '';
	        global$1.each(editor.contentCSS, function (url) {
	          contentCssEntries_1 += '<link type="text/css" rel="stylesheet" href="' + editor.documentBaseURI.toAbsolute(url) + '"' + cors_1 + '>';
	        });
	        if (contentStyle) {
	          contentCssEntries_1 += '<style type="text/css">' + contentStyle + '</style>';
	        }
	        var bodyClass = getBodyClass(editor);
	        var encode = editor.dom.encode;
	        var isMetaKeyPressed = global$3.mac ? 'e.metaKey' : 'e.ctrlKey && !e.altKey';
	        var preventClicksOnLinksScript = '<script>' + 'document.addEventListener && document.addEventListener("click", function(e) {' + 'for (var elm = e.target; elm; elm = elm.parentNode) {' + 'if (elm.nodeName === "A" && !(' + isMetaKeyPressed + ')) {' + 'e.preventDefault();' + '}' + '}' + '}, false);' + '</script> ';
	        var directionality = editor.getBody().dir;
	        var dirAttr = directionality ? ' dir="' + encode(directionality) + '"' : '';
	        html = '<!DOCTYPE html>' + '<html>' + '<head>' + '<base href="' + encode(editor.documentBaseURI.getURI()) + '">' + contentCssEntries_1 + preventClicksOnLinksScript + '</head>' + '<body class="' + encode(bodyClass) + '"' + dirAttr + '>' + html + '</body>' + '</html>';
	      }
	      return replaceTemplateValues(html, getPreviewReplaceValues(editor));
	    };
	    var open = function (editor, templateList) {
	      var createTemplates = function () {
	        if (!templateList || templateList.length === 0) {
	          var message = editor.translate('No templates defined.');
	          editor.notificationManager.open({
	            text: message,
	            type: 'info'
	          });
	          return Optional.none();
	        }
	        return Optional.from(global$1.map(templateList, function (template, index) {
	          var isUrlTemplate = function (t) {
	            return t.url !== undefined;
	          };
	          return {
	            selected: index === 0,
	            text: template.title,
	            value: {
	              url: isUrlTemplate(template) ? Optional.from(template.url) : Optional.none(),
	              content: !isUrlTemplate(template) ? Optional.from(template.content) : Optional.none(),
	              description: template.description
	            }
	          };
	        }));
	      };
	      var createSelectBoxItems = function (templates) {
	        return map(templates, function (t) {
	          return {
	            text: t.text,
	            value: t.text
	          };
	        });
	      };
	      var findTemplate = function (templates, templateTitle) {
	        return find(templates, function (t) {
	          return t.text === templateTitle;
	        });
	      };
	      var loadFailedAlert = function (api) {
	        editor.windowManager.alert('Could not load the specified template.', function () {
	          return api.focus('template');
	        });
	      };
	      var getTemplateContent = function (t) {
	        return new global$4(function (resolve, reject) {
	          t.value.url.fold(function () {
	            return resolve(t.value.content.getOr(''));
	          }, function (url) {
	            return global$2.send({
	              url: url,
	              success: function (html) {
	                resolve(html);
	              },
	              error: function (e) {
	                reject(e);
	              }
	            });
	          });
	        });
	      };
	      var onChange = function (templates, updateDialog) {
	        return function (api, change) {
	          if (change.name === 'template') {
	            var newTemplateTitle = api.getData().template;
	            findTemplate(templates, newTemplateTitle).each(function (t) {
	              api.block('Loading...');
	              getTemplateContent(t).then(function (previewHtml) {
	                updateDialog(api, t, previewHtml);
	              }).catch(function () {
	                updateDialog(api, t, '');
	                api.disable('save');
	                loadFailedAlert(api);
	              });
	            });
	          }
	        };
	      };
	      var onSubmit = function (templates) {
	        return function (api) {
	          var data = api.getData();
	          findTemplate(templates, data.template).each(function (t) {
	            getTemplateContent(t).then(function (previewHtml) {
	              insertTemplate(editor, false, previewHtml);
	              api.close();
	            }).catch(function () {
	              api.disable('save');
	              loadFailedAlert(api);
	            });
	          });
	        };
	      };
	      var openDialog = function (templates) {
	        var selectBoxItems = createSelectBoxItems(templates);
	        var buildDialogSpec = function (bodyItems, initialData) {
	          return {
	            title: 'Insert Template',
	            size: 'large',
	            body: {
	              type: 'panel',
	              items: bodyItems
	            },
	            initialData: initialData,
	            buttons: [
	              {
	                type: 'cancel',
	                name: 'cancel',
	                text: 'Cancel'
	              },
	              {
	                type: 'submit',
	                name: 'save',
	                text: 'Save',
	                primary: true
	              }
	            ],
	            onSubmit: onSubmit(templates),
	            onChange: onChange(templates, updateDialog)
	          };
	        };
	        var updateDialog = function (dialogApi, template, previewHtml) {
	          var content = getPreviewContent(editor, previewHtml);
	          var bodyItems = [
	            {
	              type: 'selectbox',
	              name: 'template',
	              label: 'Templates',
	              items: selectBoxItems
	            },
	            {
	              type: 'htmlpanel',
	              html: '<p aria-live="polite">' + htmlEscape(template.value.description) + '</p>'
	            },
	            {
	              label: 'Preview',
	              type: 'iframe',
	              name: 'preview',
	              sandboxed: false
	            }
	          ];
	          var initialData = {
	            template: template.text,
	            preview: content
	          };
	          dialogApi.unblock();
	          dialogApi.redial(buildDialogSpec(bodyItems, initialData));
	          dialogApi.focus('template');
	        };
	        var dialogApi = editor.windowManager.open(buildDialogSpec([], {
	          template: '',
	          preview: ''
	        }));
	        dialogApi.block('Loading...');
	        getTemplateContent(templates[0]).then(function (previewHtml) {
	          updateDialog(dialogApi, templates[0], previewHtml);
	        }).catch(function () {
	          updateDialog(dialogApi, templates[0], '');
	          dialogApi.disable('save');
	          loadFailedAlert(dialogApi);
	        });
	      };
	      var optTemplates = createTemplates();
	      optTemplates.each(openDialog);
	    };
	
	    var showDialog = function (editor) {
	      return function (templates) {
	        open(editor, templates);
	      };
	    };
	    var register$1 = function (editor) {
	      editor.ui.registry.addButton('template', {
	        icon: 'template',
	        tooltip: 'Insert template',
	        onAction: createTemplateList(editor, showDialog(editor))
	      });
	      editor.ui.registry.addMenuItem('template', {
	        icon: 'template',
	        text: 'Insert template...',
	        onAction: createTemplateList(editor, showDialog(editor))
	      });
	    };
	
	    function Plugin () {
	      global.add('template', function (editor) {
	        register$1(editor);
	        register(editor);
	        setup(editor);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "visualblocks" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/visualblocks')
	//   ES2015:
	//     import 'tinymce/plugins/visualblocks'
	__webpack_require__(1242);

/***/ },
/* 1242 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var fireVisualBlocks = function (editor, state) {
	      editor.fire('VisualBlocks', { state: state });
	    };
	
	    var toggleVisualBlocks = function (editor, pluginUrl, enabledState) {
	      var dom = editor.dom;
	      dom.toggleClass(editor.getBody(), 'mce-visualblocks');
	      enabledState.set(!enabledState.get());
	      fireVisualBlocks(editor, enabledState.get());
	    };
	
	    var register = function (editor, pluginUrl, enabledState) {
	      editor.addCommand('mceVisualBlocks', function () {
	        toggleVisualBlocks(editor, pluginUrl, enabledState);
	      });
	    };
	
	    var isEnabledByDefault = function (editor) {
	      return editor.getParam('visualblocks_default_state', false, 'boolean');
	    };
	
	    var setup = function (editor, pluginUrl, enabledState) {
	      editor.on('PreviewFormats AfterPreviewFormats', function (e) {
	        if (enabledState.get()) {
	          editor.dom.toggleClass(editor.getBody(), 'mce-visualblocks', e.type === 'afterpreviewformats');
	        }
	      });
	      editor.on('init', function () {
	        if (isEnabledByDefault(editor)) {
	          toggleVisualBlocks(editor, pluginUrl, enabledState);
	        }
	      });
	    };
	
	    var toggleActiveState = function (editor, enabledState) {
	      return function (api) {
	        api.setActive(enabledState.get());
	        var editorEventCallback = function (e) {
	          return api.setActive(e.state);
	        };
	        editor.on('VisualBlocks', editorEventCallback);
	        return function () {
	          return editor.off('VisualBlocks', editorEventCallback);
	        };
	      };
	    };
	    var register$1 = function (editor, enabledState) {
	      editor.ui.registry.addToggleButton('visualblocks', {
	        icon: 'visualblocks',
	        tooltip: 'Show blocks',
	        onAction: function () {
	          return editor.execCommand('mceVisualBlocks');
	        },
	        onSetup: toggleActiveState(editor, enabledState)
	      });
	      editor.ui.registry.addToggleMenuItem('visualblocks', {
	        text: 'Show blocks',
	        icon: 'visualblocks',
	        onAction: function () {
	          return editor.execCommand('mceVisualBlocks');
	        },
	        onSetup: toggleActiveState(editor, enabledState)
	      });
	    };
	
	    function Plugin () {
	      global.add('visualblocks', function (editor, pluginUrl) {
	        var enabledState = Cell(false);
	        register(editor, pluginUrl, enabledState);
	        register$1(editor, enabledState);
	        setup(editor, pluginUrl, enabledState);
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "wordcount" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/wordcount')
	//   ES2015:
	//     import 'tinymce/plugins/wordcount'
	__webpack_require__(1244);

/***/ },
/* 1244 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var global = tinymce.util.Tools.resolve('tinymce.PluginManager');
	
	    var identity = function (x) {
	      return x;
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	
	    var zeroWidth = '\uFEFF';
	    var removeZwsp = function (s) {
	      return s.replace(/\uFEFF/g, '');
	    };
	
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	
	    var punctuationStr = '[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uff3f\uFF5B\uFF5D\uFF5F-\uFF65]';
	    var regExps = {
	      aletter: '[A-Za-z\xaa\xb5\xba\xc0-\xd6\xd8-\xf6\xf8-\u02c1\u02c6-\u02d1\u02e0-\u02e4\u02ec\u02ee\u0370-\u0374\u0376\u0377\u037a-\u037d\u0386\u0388-\u038a\u038c\u038e-\u03a1\u03a3-\u03f5\u03f7-\u0481\u048a-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05d0-\u05ea\u05f0-\u05F3\u0620-\u064a\u066e\u066f\u0671-\u06d3\u06d5\u06e5\u06e6\u06ee\u06ef\u06fa-\u06fc\u06ff\u0710\u0712-\u072f\u074d-\u07a5\u07b1\u07ca-\u07ea\u07f4\u07f5\u07fa\u0800-\u0815\u081a\u0824\u0828\u0840-\u0858\u0904-\u0939\u093d\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097f\u0985-\u098c\u098f\u0990\u0993-\u09a8\u09aa-\u09b0\u09b2\u09b6-\u09b9\u09bd\u09ce\u09dc\u09dd\u09df-\u09e1\u09f0\u09f1\u0a05-\u0a0a\u0a0f\u0a10\u0a13-\u0a28\u0a2a-\u0a30\u0a32\u0a33\u0a35\u0a36\u0a38\u0a39\u0a59-\u0a5c\u0a5e\u0a72-\u0a74\u0a85-\u0a8d\u0a8f-\u0a91\u0a93-\u0aa8\u0aaa-\u0ab0\u0ab2\u0ab3\u0ab5-\u0ab9\u0abd\u0ad0\u0ae0\u0ae1\u0b05-\u0b0c\u0b0f\u0b10\u0b13-\u0b28\u0b2a-\u0b30\u0b32\u0b33\u0b35-\u0b39\u0b3d\u0b5c\u0b5d\u0b5f-\u0b61\u0b71\u0b83\u0b85-\u0b8a\u0b8e-\u0b90\u0b92-\u0b95\u0b99\u0b9a\u0b9c\u0b9e\u0b9f\u0ba3\u0ba4\u0ba8-\u0baa\u0bae-\u0bb9\u0bd0\u0c05-\u0c0c\u0c0e-\u0c10\u0c12-\u0c28\u0c2a-\u0c33\u0c35-\u0c39\u0c3d\u0c58\u0c59\u0c60\u0c61\u0c85-\u0c8c\u0c8e-\u0c90\u0c92-\u0ca8\u0caa-\u0cb3\u0cb5-\u0cb9\u0cbd\u0cde\u0ce0\u0ce1\u0cf1\u0cf2\u0d05-\u0d0c\u0d0e-\u0d10\u0d12-\u0d3a\u0d3d\u0d4e\u0d60\u0d61\u0d7a-\u0d7f\u0d85-\u0d96\u0d9a-\u0db1\u0db3-\u0dbb\u0dbd\u0dc0-\u0dc6\u0f00\u0f40-\u0f47\u0f49-\u0f6c\u0f88-\u0f8c\u10a0-\u10c5\u10d0-\u10fa\u10fc\u1100-\u1248\u124a-\u124d\u1250-\u1256\u1258\u125a-\u125d\u1260-\u1288\u128a-\u128d\u1290-\u12b0\u12b2-\u12b5\u12b8-\u12be\u12c0\u12c2-\u12c5\u12c8-\u12d6\u12d8-\u1310\u1312-\u1315\u1318-\u135a\u1380-\u138f\u13a0-\u13f4\u1401-\u166c\u166f-\u167f\u1681-\u169a\u16a0-\u16ea\u16ee-\u16f0\u1700-\u170c\u170e-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176c\u176e-\u1770\u1820-\u1877\u1880-\u18a8\u18aa\u18b0-\u18f5\u1900-\u191c\u1a00-\u1a16\u1b05-\u1b33\u1b45-\u1b4b\u1b83-\u1ba0\u1bae\u1baf\u1bc0-\u1be5\u1c00-\u1c23\u1c4d-\u1c4f\u1c5a-\u1c7d\u1ce9-\u1cec\u1cee-\u1cf1\u1d00-\u1dbf\u1e00-\u1f15\u1f18-\u1f1d\u1f20-\u1f45\u1f48-\u1f4d\u1f50-\u1f57\u1f59\u1f5b\u1f5d\u1f5f-\u1f7d\u1f80-\u1fb4\u1fb6-\u1fbc\u1fbe\u1fc2-\u1fc4\u1fc6-\u1fcc\u1fd0-\u1fd3\u1fd6-\u1fdb\u1fe0-\u1fec\u1ff2-\u1ff4\u1ff6-\u1ffc\u2071\u207f\u2090-\u209c\u2102\u2107\u210a-\u2113\u2115\u2119-\u211d\u2124\u2126\u2128\u212a-\u212d\u212f-\u2139\u213c-\u213f\u2145-\u2149\u214e\u2160-\u2188\u24B6-\u24E9\u2c00-\u2c2e\u2c30-\u2c5e\u2c60-\u2ce4\u2ceb-\u2cee\u2d00-\u2d25\u2d30-\u2d65\u2d6f\u2d80-\u2d96\u2da0-\u2da6\u2da8-\u2dae\u2db0-\u2db6\u2db8-\u2dbe\u2dc0-\u2dc6\u2dc8-\u2dce\u2dd0-\u2dd6\u2dd8-\u2dde\u2e2f\u3005\u303b\u303c\u3105-\u312d\u3131-\u318e\u31a0-\u31ba\ua000-\ua48c\ua4d0-\ua4fd\ua500-\ua60c\ua610-\ua61f\ua62a\ua62b\ua640-\ua66e\ua67f-\ua697\ua6a0-\ua6ef\ua717-\ua71f\ua722-\ua788\ua78b-\ua78e\ua790\ua791\ua7a0-\ua7a9\ua7fa-\ua801\ua803-\ua805\ua807-\ua80a\ua80c-\ua822\ua840-\ua873\ua882-\ua8b3\ua8f2-\ua8f7\ua8fb\ua90a-\ua925\ua930-\ua946\ua960-\ua97c\ua984-\ua9b2\ua9cf\uaa00-\uaa28\uaa40-\uaa42\uaa44-\uaa4b\uab01-\uab06\uab09-\uab0e\uab11-\uab16\uab20-\uab26\uab28-\uab2e\uabc0-\uabe2\uac00-\ud7a3\ud7b0-\ud7c6\ud7cb-\ud7fb\ufb00-\ufb06\ufb13-\ufb17\ufb1d\ufb1f-\ufb28\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40\ufb41\ufb43\ufb44\ufb46-\ufbb1\ufbd3-\ufd3d\ufd50-\ufd8f\ufd92-\ufdc7\ufdf0-\ufdfb\ufe70-\ufe74\ufe76-\ufefc\uff21-\uff3a\uff41-\uff5a\uffa0-\uffbe\uffc2-\uffc7\uffca-\uffcf\uffd2-\uffd7\uffda-\uffdc]',
	      midnumlet: '[-\'\\.\u2018\u2019\u2024\uFE52\uFF07\uFF0E]',
	      midletter: '[:\xB7\xB7\u05F4\u2027\uFE13\uFE55\uFF1A]',
	      midnum: '[\xB1+*/,;;\u0589\u060C\u060D\u066C\u07F8\u2044\uFE10\uFE14\uFE50\uFE54\uFF0C\uFF1B]',
	      numeric: '[0-9\u0660-\u0669\u066B\u06f0-\u06f9\u07c0-\u07c9\u0966-\u096f\u09e6-\u09ef\u0a66-\u0a6f\u0ae6-\u0aef\u0b66-\u0b6f\u0be6-\u0bef\u0c66-\u0c6f\u0ce6-\u0cef\u0d66-\u0d6f\u0e50-\u0e59\u0ed0-\u0ed9\u0f20-\u0f29\u1040-\u1049\u1090-\u1099\u17e0-\u17e9\u1810-\u1819\u1946-\u194f\u19d0-\u19d9\u1a80-\u1a89\u1a90-\u1a99\u1b50-\u1b59\u1bb0-\u1bb9\u1c40-\u1c49\u1c50-\u1c59\ua620-\ua629\ua8d0-\ua8d9\ua900-\ua909\ua9d0-\ua9d9\uaa50-\uaa59\uabf0-\uabf9]',
	      cr: '\\r',
	      lf: '\\n',
	      newline: '[\x0B\f\x85\u2028\u2029]',
	      extend: '[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u0900-\u0903\u093a-\u093c\u093e-\u094f\u0951-\u0957\u0962\u0963\u0981-\u0983\u09bc\u09be-\u09c4\u09c7\u09c8\u09cb-\u09cd\u09d7\u09e2\u09e3\u0a01-\u0a03\u0a3c\u0a3e-\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81-\u0a83\u0abc\u0abe-\u0ac5\u0ac7-\u0ac9\u0acb-\u0acd\u0ae2\u0ae3\u0b01-\u0b03\u0b3c\u0b3e-\u0b44\u0b47\u0b48\u0b4b-\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe-\u0bc2\u0bc6-\u0bc8\u0bca-\u0bcd\u0bd7\u0c01-\u0c03\u0c3e-\u0c44\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0c82\u0c83\u0cbc\u0cbe-\u0cc4\u0cc6-\u0cc8\u0cca-\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d02\u0d03\u0d3e-\u0d44\u0d46-\u0d48\u0d4a-\u0d4d\u0d57\u0d62\u0d63\u0d82\u0d83\u0dca\u0dcf-\u0dd4\u0dd6\u0dd8-\u0ddf\u0df2\u0df3\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f3e\u0f3f\u0f71-\u0f84\u0f86\u0f87\u0f8d-\u0f97\u0f99-\u0fbc\u0fc6\u102b-\u103e\u1056-\u1059\u105e-\u1060\u1062-\u1064\u1067-\u106d\u1071-\u1074\u1082-\u108d\u108f\u109a-\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b6-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u192b\u1930-\u193b\u19b0-\u19c0\u19c8\u19c9\u1a17-\u1a1b\u1a55-\u1a5e\u1a60-\u1a7c\u1a7f\u1b00-\u1b04\u1b34-\u1b44\u1b6b-\u1b73\u1b80-\u1b82\u1ba1-\u1baa\u1be6-\u1bf3\u1c24-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce8\u1ced\u1cf2\u1dc0-\u1de6\u1dfc-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2d7f\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\uA672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua823-\ua827\ua880\ua881\ua8b4-\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua953\ua980-\ua983\ua9b3-\ua9c0\uaa29-\uaa36\uaa43\uaa4c\uaa4d\uaa7b\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe3-\uabea\uabec\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]',
	      format: '[\xAD\u0600-\u0603\u06DD\u070F\u17b4\u17b5\u200E\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F\uFEFF\uFFF9-\uFFFB]',
	      katakana: '[\u3031-\u3035\u309B\u309C\u30A0-\u30fa\u30fc-\u30ff\u31f0-\u31ff\u32D0-\u32FE\u3300-\u3357\uff66-\uff9d]',
	      extendnumlet: '[=_\u203f\u2040\u2054\ufe33\ufe34\ufe4d-\ufe4f\uff3f\u2200-\u22FF<>]',
	      punctuation: punctuationStr
	    };
	    var characterIndices = {
	      ALETTER: 0,
	      MIDNUMLET: 1,
	      MIDLETTER: 2,
	      MIDNUM: 3,
	      NUMERIC: 4,
	      CR: 5,
	      LF: 6,
	      NEWLINE: 7,
	      EXTEND: 8,
	      FORMAT: 9,
	      KATAKANA: 10,
	      EXTENDNUMLET: 11,
	      AT: 12,
	      OTHER: 13
	    };
	    var SETS = [
	      new RegExp(regExps.aletter),
	      new RegExp(regExps.midnumlet),
	      new RegExp(regExps.midletter),
	      new RegExp(regExps.midnum),
	      new RegExp(regExps.numeric),
	      new RegExp(regExps.cr),
	      new RegExp(regExps.lf),
	      new RegExp(regExps.newline),
	      new RegExp(regExps.extend),
	      new RegExp(regExps.format),
	      new RegExp(regExps.katakana),
	      new RegExp(regExps.extendnumlet),
	      new RegExp('@')
	    ];
	    var EMPTY_STRING = '';
	    var PUNCTUATION = new RegExp('^' + regExps.punctuation + '$');
	    var WHITESPACE = /^\s+$/;
	
	    var SETS$1 = SETS;
	    var OTHER = characterIndices.OTHER;
	    var getType = function (char) {
	      var type = OTHER;
	      var setsLength = SETS$1.length;
	      for (var j = 0; j < setsLength; ++j) {
	        var set = SETS$1[j];
	        if (set && set.test(char)) {
	          type = j;
	          break;
	        }
	      }
	      return type;
	    };
	    var memoize = function (func) {
	      var cache = {};
	      return function (char) {
	        if (cache[char]) {
	          return cache[char];
	        } else {
	          var result = func(char);
	          cache[char] = result;
	          return result;
	        }
	      };
	    };
	    var classify = function (characters) {
	      var memoized = memoize(getType);
	      return map(characters, memoized);
	    };
	
	    var isWordBoundary = function (map, index) {
	      var type = map[index];
	      var nextType = map[index + 1];
	      if (index < 0 || index > map.length - 1 && index !== 0) {
	        return false;
	      }
	      if (type === characterIndices.ALETTER && nextType === characterIndices.ALETTER) {
	        return false;
	      }
	      var nextNextType = map[index + 2];
	      if (type === characterIndices.ALETTER && (nextType === characterIndices.MIDLETTER || nextType === characterIndices.MIDNUMLET || nextType === characterIndices.AT) && nextNextType === characterIndices.ALETTER) {
	        return false;
	      }
	      var prevType = map[index - 1];
	      if ((type === characterIndices.MIDLETTER || type === characterIndices.MIDNUMLET || nextType === characterIndices.AT) && nextType === characterIndices.ALETTER && prevType === characterIndices.ALETTER) {
	        return false;
	      }
	      if ((type === characterIndices.NUMERIC || type === characterIndices.ALETTER) && (nextType === characterIndices.NUMERIC || nextType === characterIndices.ALETTER)) {
	        return false;
	      }
	      if ((type === characterIndices.MIDNUM || type === characterIndices.MIDNUMLET) && nextType === characterIndices.NUMERIC && prevType === characterIndices.NUMERIC) {
	        return false;
	      }
	      if (type === characterIndices.NUMERIC && (nextType === characterIndices.MIDNUM || nextType === characterIndices.MIDNUMLET) && nextNextType === characterIndices.NUMERIC) {
	        return false;
	      }
	      if (type === characterIndices.EXTEND || type === characterIndices.FORMAT || prevType === characterIndices.EXTEND || prevType === characterIndices.FORMAT || nextType === characterIndices.EXTEND || nextType === characterIndices.FORMAT) {
	        return false;
	      }
	      if (type === characterIndices.CR && nextType === characterIndices.LF) {
	        return false;
	      }
	      if (type === characterIndices.NEWLINE || type === characterIndices.CR || type === characterIndices.LF) {
	        return true;
	      }
	      if (nextType === characterIndices.NEWLINE || nextType === characterIndices.CR || nextType === characterIndices.LF) {
	        return true;
	      }
	      if (type === characterIndices.KATAKANA && nextType === characterIndices.KATAKANA) {
	        return false;
	      }
	      if (nextType === characterIndices.EXTENDNUMLET && (type === characterIndices.ALETTER || type === characterIndices.NUMERIC || type === characterIndices.KATAKANA || type === characterIndices.EXTENDNUMLET)) {
	        return false;
	      }
	      if (type === characterIndices.EXTENDNUMLET && (nextType === characterIndices.ALETTER || nextType === characterIndices.NUMERIC || nextType === characterIndices.KATAKANA)) {
	        return false;
	      }
	      if (type === characterIndices.AT) {
	        return false;
	      }
	      return true;
	    };
	
	    var EMPTY_STRING$1 = EMPTY_STRING;
	    var WHITESPACE$1 = WHITESPACE;
	    var PUNCTUATION$1 = PUNCTUATION;
	    var isProtocol = function (str) {
	      return str === 'http' || str === 'https';
	    };
	    var findWordEnd = function (characters, startIndex) {
	      var i;
	      for (i = startIndex; i < characters.length; i++) {
	        if (WHITESPACE$1.test(characters[i])) {
	          break;
	        }
	      }
	      return i;
	    };
	    var findUrlEnd = function (characters, startIndex) {
	      var endIndex = findWordEnd(characters, startIndex + 1);
	      var peakedWord = characters.slice(startIndex + 1, endIndex).join(EMPTY_STRING$1);
	      return peakedWord.substr(0, 3) === '://' ? endIndex : startIndex;
	    };
	    var findWords = function (chars, sChars, characterMap, options) {
	      var words = [];
	      var word = [];
	      for (var i = 0; i < characterMap.length; ++i) {
	        word.push(chars[i]);
	        if (isWordBoundary(characterMap, i)) {
	          var ch = sChars[i];
	          if ((options.includeWhitespace || !WHITESPACE$1.test(ch)) && (options.includePunctuation || !PUNCTUATION$1.test(ch))) {
	            var startOfWord = i - word.length + 1;
	            var endOfWord = i + 1;
	            var str = sChars.slice(startOfWord, endOfWord).join(EMPTY_STRING$1);
	            if (isProtocol(str)) {
	              var endOfUrl = findUrlEnd(sChars, i);
	              var url = chars.slice(endOfWord, endOfUrl);
	              Array.prototype.push.apply(word, url);
	              i = endOfUrl;
	            }
	            words.push(word);
	          }
	          word = [];
	        }
	      }
	      return words;
	    };
	    var getDefaultOptions = function () {
	      return {
	        includeWhitespace: false,
	        includePunctuation: false
	      };
	    };
	    var getWords = function (chars, extract, options) {
	      options = __assign(__assign({}, getDefaultOptions()), options);
	      var filteredChars = [];
	      var extractedChars = [];
	      for (var i = 0; i < chars.length; i++) {
	        var ch = extract(chars[i]);
	        if (ch !== zeroWidth) {
	          filteredChars.push(chars[i]);
	          extractedChars.push(ch);
	        }
	      }
	      var characterMap = classify(extractedChars);
	      return findWords(filteredChars, extractedChars, characterMap, options);
	    };
	
	    var getWords$1 = getWords;
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.dom.TreeWalker');
	
	    var getText = function (node, schema) {
	      var blockElements = schema.getBlockElements();
	      var shortEndedElements = schema.getShortEndedElements();
	      var isNewline = function (node) {
	        return blockElements[node.nodeName] || shortEndedElements[node.nodeName];
	      };
	      var textBlocks = [];
	      var txt = '';
	      var treeWalker = new global$1(node, node);
	      while (node = treeWalker.next()) {
	        if (node.nodeType === 3) {
	          txt += removeZwsp(node.data);
	        } else if (isNewline(node) && txt.length) {
	          textBlocks.push(txt);
	          txt = '';
	        }
	      }
	      if (txt.length) {
	        textBlocks.push(txt);
	      }
	      return textBlocks;
	    };
	
	    var strLen = function (str) {
	      return str.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '_').length;
	    };
	    var countWords = function (node, schema) {
	      var text = getText(node, schema).join('\n');
	      return getWords$1(text.split(''), identity).length;
	    };
	    var countCharacters = function (node, schema) {
	      var text = getText(node, schema).join('');
	      return strLen(text);
	    };
	    var countCharactersWithoutSpaces = function (node, schema) {
	      var text = getText(node, schema).join('').replace(/\s/g, '');
	      return strLen(text);
	    };
	
	    var createBodyCounter = function (editor, count) {
	      return function () {
	        return count(editor.getBody(), editor.schema);
	      };
	    };
	    var createSelectionCounter = function (editor, count) {
	      return function () {
	        return count(editor.selection.getRng().cloneContents(), editor.schema);
	      };
	    };
	    var createBodyWordCounter = function (editor) {
	      return createBodyCounter(editor, countWords);
	    };
	    var get = function (editor) {
	      return {
	        body: {
	          getWordCount: createBodyWordCounter(editor),
	          getCharacterCount: createBodyCounter(editor, countCharacters),
	          getCharacterCountWithoutSpaces: createBodyCounter(editor, countCharactersWithoutSpaces)
	        },
	        selection: {
	          getWordCount: createSelectionCounter(editor, countWords),
	          getCharacterCount: createSelectionCounter(editor, countCharacters),
	          getCharacterCountWithoutSpaces: createSelectionCounter(editor, countCharactersWithoutSpaces)
	        },
	        getCount: createBodyWordCounter(editor)
	      };
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var fireWordCountUpdate = function (editor, api) {
	      editor.fire('wordCountUpdate', {
	        wordCount: {
	          words: api.body.getWordCount(),
	          characters: api.body.getCharacterCount(),
	          charactersWithoutSpaces: api.body.getCharacterCountWithoutSpaces()
	        }
	      });
	    };
	
	    var updateCount = function (editor, api) {
	      fireWordCountUpdate(editor, api);
	    };
	    var setup = function (editor, api, delay) {
	      var debouncedUpdate = global$2.debounce(function () {
	        return updateCount(editor, api);
	      }, delay);
	      editor.on('init', function () {
	        updateCount(editor, api);
	        global$2.setEditorTimeout(editor, function () {
	          editor.on('SetContent BeforeAddUndo Undo Redo keyup', debouncedUpdate);
	        }, 0);
	      });
	    };
	
	    var open = function (editor, api) {
	      editor.windowManager.open({
	        title: 'Word Count',
	        body: {
	          type: 'panel',
	          items: [{
	              type: 'table',
	              header: [
	                'Count',
	                'Document',
	                'Selection'
	              ],
	              cells: [
	                [
	                  'Words',
	                  String(api.body.getWordCount()),
	                  String(api.selection.getWordCount())
	                ],
	                [
	                  'Characters (no spaces)',
	                  String(api.body.getCharacterCountWithoutSpaces()),
	                  String(api.selection.getCharacterCountWithoutSpaces())
	                ],
	                [
	                  'Characters',
	                  String(api.body.getCharacterCount()),
	                  String(api.selection.getCharacterCount())
	                ]
	              ]
	            }]
	        },
	        buttons: [{
	            type: 'cancel',
	            name: 'close',
	            text: 'Close',
	            primary: true
	          }]
	      });
	    };
	
	    var register = function (editor, api) {
	      editor.ui.registry.addButton('wordcount', {
	        tooltip: 'Word count',
	        icon: 'character-count',
	        onAction: function () {
	          return open(editor, api);
	        }
	      });
	      editor.ui.registry.addMenuItem('wordcount', {
	        text: 'Word count',
	        icon: 'character-count',
	        onAction: function () {
	          return open(editor, api);
	        }
	      });
	    };
	
	    function Plugin (delay) {
	      if (delay === void 0) {
	        delay = 300;
	      }
	      global.add('wordcount', function (editor) {
	        var api = get(editor);
	        register(editor, api);
	        setup(editor, api, delay);
	        return api;
	      });
	    }
	
	    Plugin();
	
	}());


/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "silver" theme for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/themes/silver')
	//   ES2015:
	//     import 'tinymce/themes/silver'
	__webpack_require__(1246);

/***/ },
/* 1246 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var typeOf = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isBoolean = isSimpleType('boolean');
	    var isUndefined = eq(undefined);
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	    var isArrayOf = function (value, pred) {
	      if (isArray(value)) {
	        for (var i = 0, len = value.length; i < len; ++i) {
	          if (!pred(value[i])) {
	            return false;
	          }
	        }
	        return true;
	      }
	      return false;
	    };
	
	    var noop = function () {
	    };
	    var noarg = function (f) {
	      return function () {
	        return f();
	      };
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var global$1 = tinymce.util.Tools.resolve('tinymce.ThemeManager');
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s)
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	            t[p[i]] = s[p[i]];
	        }
	      return t;
	    }
	    function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
	        s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	      return r;
	    }
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Optional.none() : Optional.some(r);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var range = function (num, f) {
	      var r = [];
	      for (var i = 0; i < num; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	    var chunk = function (array, size) {
	      var r = [];
	      for (var i = 0; i < array.length; i += size) {
	        var s = nativeSlice.call(array, i, i + size);
	        r.push(s);
	      }
	      return r;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(i);
	        }
	      }
	      return Optional.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var difference = function (a1, a2) {
	      return filter(a1, function (x) {
	        return !contains(a2, x);
	      });
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var sort = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var get = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get(xs, 0);
	    };
	    var last = function (xs) {
	      return get(xs, xs.length - 1);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;
	      };
	      var or = function (_opt) {
	        return value(o);
	      };
	      var orThunk = function (_f) {
	        return value(o);
	      };
	      var map = function (f) {
	        return value(f(o));
	      };
	      var mapError = function (_f) {
	        return value(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOptional = function () {
	        return Optional.some(o);
	      };
	      return {
	        is: is,
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOptional: toOptional
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = function (opt) {
	        return opt;
	      };
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (_f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (_f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        is: never,
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOptional: Optional.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value);
	    };
	    var Result = {
	      value: value,
	      error: error,
	      fromOption: fromOption
	    };
	
	    var SimpleResultType;
	    (function (SimpleResultType) {
	      SimpleResultType[SimpleResultType['Error'] = 0] = 'Error';
	      SimpleResultType[SimpleResultType['Value'] = 1] = 'Value';
	    }(SimpleResultType || (SimpleResultType = {})));
	    var fold = function (res, onError, onValue) {
	      return res.stype === SimpleResultType.Error ? onError(res.serror) : onValue(res.svalue);
	    };
	    var partition$1 = function (results) {
	      var values = [];
	      var errors = [];
	      each(results, function (obj) {
	        fold(obj, function (err) {
	          return errors.push(err);
	        }, function (val) {
	          return values.push(val);
	        });
	      });
	      return {
	        values: values,
	        errors: errors
	      };
	    };
	    var mapError = function (res, f) {
	      if (res.stype === SimpleResultType.Error) {
	        return {
	          stype: SimpleResultType.Error,
	          serror: f(res.serror)
	        };
	      } else {
	        return res;
	      }
	    };
	    var map$1 = function (res, f) {
	      if (res.stype === SimpleResultType.Value) {
	        return {
	          stype: SimpleResultType.Value,
	          svalue: f(res.svalue)
	        };
	      } else {
	        return res;
	      }
	    };
	    var bind$1 = function (res, f) {
	      if (res.stype === SimpleResultType.Value) {
	        return f(res.svalue);
	      } else {
	        return res;
	      }
	    };
	    var bindError = function (res, f) {
	      if (res.stype === SimpleResultType.Error) {
	        return f(res.serror);
	      } else {
	        return res;
	      }
	    };
	    var svalue = function (v) {
	      return {
	        stype: SimpleResultType.Value,
	        svalue: v
	      };
	    };
	    var serror = function (e) {
	      return {
	        stype: SimpleResultType.Error,
	        serror: e
	      };
	    };
	    var toResult = function (res) {
	      return fold(res, Result.error, Result.value);
	    };
	    var fromResult = function (res) {
	      return res.fold(serror, svalue);
	    };
	    var SimpleResult = {
	      fromResult: fromResult,
	      toResult: toResult,
	      svalue: svalue,
	      partition: partition$1,
	      serror: serror,
	      bind: bind$1,
	      bindError: bindError,
	      map: map$1,
	      mapError: mapError,
	      fold: fold
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$2 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var filter$1 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each$1(obj, function (value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	    var find$1 = function (obj, pred) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        if (pred(x, i, obj)) {
	          return Optional.some(x);
	        }
	      }
	      return Optional.none();
	    };
	    var values = function (obj) {
	      return mapToArray(obj, function (v) {
	        return v;
	      });
	    };
	    var get$1 = function (obj, key) {
	      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	
	    var generate = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          var argLength = args.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              var foldArgs = [];
	              for (var _i = 0; _i < arguments.length; _i++) {
	                foldArgs[_i] = arguments[_i];
	              }
	              if (foldArgs.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
	              }
	              var target = foldArgs[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate };
	
	    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	    var shallow = function (old, nu) {
	      return nu;
	    };
	    var deep = function (old, nu) {
	      var bothObjects = isObject(old) && isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          objects[_i] = arguments[_i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty$1.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var deepMerge = baseMerge(deep);
	    var merge = baseMerge(shallow);
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var adt = Adt.generate([
	      { strict: [] },
	      { defaultedThunk: ['fallbackThunk'] },
	      { asOption: [] },
	      { asDefaultedOptionThunk: ['fallbackThunk'] },
	      { mergeWithThunk: ['baseThunk'] }
	    ]);
	    var defaulted = function (fallback) {
	      return adt.defaultedThunk(constant(fallback));
	    };
	    var mergeWith = function (base) {
	      return adt.mergeWithThunk(constant(base));
	    };
	    var strict = adt.strict;
	    var asOption = adt.asOption;
	    var defaultedThunk = adt.defaultedThunk;
	    var asDefaultedOptionThunk = adt.asDefaultedOptionThunk;
	    var mergeWithThunk = adt.mergeWithThunk;
	
	    var comparison = Adt.generate([
	      {
	        bothErrors: [
	          'error1',
	          'error2'
	        ]
	      },
	      {
	        firstError: [
	          'error1',
	          'value2'
	        ]
	      },
	      {
	        secondError: [
	          'value1',
	          'error2'
	        ]
	      },
	      {
	        bothValues: [
	          'value1',
	          'value2'
	        ]
	      }
	    ]);
	    var partition$2 = function (results) {
	      var errors = [];
	      var values = [];
	      each(results, function (result) {
	        result.fold(function (err) {
	          errors.push(err);
	        }, function (value) {
	          values.push(value);
	        });
	      });
	      return {
	        errors: errors,
	        values: values
	      };
	    };
	
	    var exclude = function (obj, fields) {
	      var r = {};
	      each$1(obj, function (v, k) {
	        if (!contains(fields, k)) {
	          r[k] = v;
	        }
	      });
	      return r;
	    };
	
	    var wrap = function (key, value) {
	      var _a;
	      return _a = {}, _a[key] = value, _a;
	    };
	    var wrapAll = function (keyvalues) {
	      var r = {};
	      each(keyvalues, function (kv) {
	        r[kv.key] = kv.value;
	      });
	      return r;
	    };
	
	    var exclude$1 = function (obj, fields) {
	      return exclude(obj, fields);
	    };
	    var wrap$1 = function (key, value) {
	      return wrap(key, value);
	    };
	    var wrapAll$1 = function (keyvalues) {
	      return wrapAll(keyvalues);
	    };
	    var mergeValues = function (values, base) {
	      return values.length === 0 ? Result.value(base) : Result.value(deepMerge(base, merge.apply(undefined, values)));
	    };
	    var mergeErrors = function (errors) {
	      return Result.error(flatten(errors));
	    };
	    var consolidate = function (objs, base) {
	      var partitions = partition$2(objs);
	      return partitions.errors.length > 0 ? mergeErrors(partitions.errors) : mergeValues(partitions.values, base);
	    };
	
	    var mergeValues$1 = function (values, base) {
	      return values.length > 0 ? SimpleResult.svalue(deepMerge(base, merge.apply(undefined, values))) : SimpleResult.svalue(base);
	    };
	    var mergeErrors$1 = function (errors) {
	      return compose(SimpleResult.serror, flatten)(errors);
	    };
	    var consolidateObj = function (objects, base) {
	      var partition = SimpleResult.partition(objects);
	      return partition.errors.length > 0 ? mergeErrors$1(partition.errors) : mergeValues$1(partition.values, base);
	    };
	    var consolidateArr = function (objects) {
	      var partitions = SimpleResult.partition(objects);
	      return partitions.errors.length > 0 ? mergeErrors$1(partitions.errors) : SimpleResult.svalue(partitions.values);
	    };
	    var ResultCombine = {
	      consolidateObj: consolidateObj,
	      consolidateArr: consolidateArr
	    };
	
	    var formatObj = function (input) {
	      return isObject(input) && keys(input).length > 100 ? ' removed due to size' : JSON.stringify(input, null, 2);
	    };
	    var formatErrors = function (errors) {
	      var es = errors.length > 10 ? errors.slice(0, 10).concat([{
	          path: [],
	          getErrorInfo: function () {
	            return '... (only showing first ten failures)';
	          }
	        }]) : errors;
	      return map(es, function (e) {
	        return 'Failed path: (' + e.path.join(' > ') + ')\n' + e.getErrorInfo();
	      });
	    };
	
	    var nu = function (path, getErrorInfo) {
	      return SimpleResult.serror([{
	          path: path,
	          getErrorInfo: getErrorInfo
	        }]);
	    };
	    var missingStrict = function (path, key, obj) {
	      return nu(path, function () {
	        return 'Could not find valid *strict* value for "' + key + '" in ' + formatObj(obj);
	      });
	    };
	    var missingKey = function (path, key) {
	      return nu(path, function () {
	        return 'Choice schema did not contain choice key: "' + key + '"';
	      });
	    };
	    var missingBranch = function (path, branches, branch) {
	      return nu(path, function () {
	        return 'The chosen schema: "' + branch + '" did not exist in branches: ' + formatObj(branches);
	      });
	    };
	    var unsupportedFields = function (path, unsupported) {
	      return nu(path, function () {
	        return 'There are unsupported fields: [' + unsupported.join(', ') + '] specified';
	      });
	    };
	    var custom = function (path, err) {
	      return nu(path, function () {
	        return err;
	      });
	    };
	
	    var adt$1 = Adt.generate([
	      {
	        field: [
	          'key',
	          'okey',
	          'presence',
	          'prop'
	        ]
	      },
	      {
	        state: [
	          'okey',
	          'instantiator'
	        ]
	      }
	    ]);
	    var strictAccess = function (path, obj, key) {
	      return get$1(obj, key).fold(function () {
	        return missingStrict(path, key, obj);
	      }, SimpleResult.svalue);
	    };
	    var fallbackAccess = function (obj, key, fallbackThunk) {
	      var v = get$1(obj, key).fold(function () {
	        return fallbackThunk(obj);
	      }, identity);
	      return SimpleResult.svalue(v);
	    };
	    var optionAccess = function (obj, key) {
	      return SimpleResult.svalue(get$1(obj, key));
	    };
	    var optionDefaultedAccess = function (obj, key, fallback) {
	      var opt = get$1(obj, key).map(function (val) {
	        return val === true ? fallback(obj) : val;
	      });
	      return SimpleResult.svalue(opt);
	    };
	    var cExtractOne = function (path, obj, field, strength) {
	      return field.fold(function (key, okey, presence, prop) {
	        var bundle = function (av) {
	          var result = prop.extract(path.concat([key]), strength, av);
	          return SimpleResult.map(result, function (res) {
	            return wrap(okey, strength(res));
	          });
	        };
	        var bundleAsOption = function (optValue) {
	          return optValue.fold(function () {
	            var outcome = wrap(okey, strength(Optional.none()));
	            return SimpleResult.svalue(outcome);
	          }, function (ov) {
	            var result = prop.extract(path.concat([key]), strength, ov);
	            return SimpleResult.map(result, function (res) {
	              return wrap(okey, strength(Optional.some(res)));
	            });
	          });
	        };
	        return function () {
	          return presence.fold(function () {
	            return SimpleResult.bind(strictAccess(path, obj, key), bundle);
	          }, function (fallbackThunk) {
	            return SimpleResult.bind(fallbackAccess(obj, key, fallbackThunk), bundle);
	          }, function () {
	            return SimpleResult.bind(optionAccess(obj, key), bundleAsOption);
	          }, function (fallbackThunk) {
	            return SimpleResult.bind(optionDefaultedAccess(obj, key, fallbackThunk), bundleAsOption);
	          }, function (baseThunk) {
	            var base = baseThunk(obj);
	            var result = SimpleResult.map(fallbackAccess(obj, key, constant({})), function (v) {
	              return deepMerge(base, v);
	            });
	            return SimpleResult.bind(result, bundle);
	          });
	        }();
	      }, function (okey, instantiator) {
	        var state = instantiator(obj);
	        return SimpleResult.svalue(wrap(okey, strength(state)));
	      });
	    };
	    var cExtract = function (path, obj, fields, strength) {
	      var results = map(fields, function (field) {
	        return cExtractOne(path, obj, field, strength);
	      });
	      return ResultCombine.consolidateObj(results, {});
	    };
	    var valueThunk = function (getDelegate) {
	      var extract = function (path, strength, val) {
	        return getDelegate().extract(path, strength, val);
	      };
	      var toString = function () {
	        return getDelegate().toString();
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var value$1 = function (validator) {
	      var extract = function (path, strength, val) {
	        return SimpleResult.bindError(validator(val, strength), function (err) {
	          return custom(path, err);
	        });
	      };
	      var toString = function () {
	        return 'val';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var getSetKeys = function (obj) {
	      return keys(filter$1(obj, function (value) {
	        return value !== undefined && value !== null;
	      }));
	    };
	    var objOfOnly = function (fields) {
	      var delegate = objOf(fields);
	      var fieldNames = foldr(fields, function (acc, f) {
	        return f.fold(function (key) {
	          return deepMerge(acc, wrap$1(key, true));
	        }, constant(acc));
	      }, {});
	      var extract = function (path, strength, o) {
	        var keys = isBoolean(o) ? [] : getSetKeys(o);
	        var extra = filter(keys, function (k) {
	          return !hasNonNullableKey(fieldNames, k);
	        });
	        return extra.length === 0 ? delegate.extract(path, strength, o) : unsupportedFields(path, extra);
	      };
	      return {
	        extract: extract,
	        toString: delegate.toString
	      };
	    };
	    var objOf = function (fields) {
	      var extract = function (path, strength, o) {
	        return cExtract(path, o, fields, strength);
	      };
	      var toString = function () {
	        var fieldStrings = map(fields, function (field) {
	          return field.fold(function (key, okey, presence, prop) {
	            return key + ' -> ' + prop.toString();
	          }, function (okey, _instantiator) {
	            return 'state(' + okey + ')';
	          });
	        });
	        return 'obj{\n' + fieldStrings.join('\n') + '}';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var arrOf = function (prop) {
	      var extract = function (path, strength, array) {
	        var results = map(array, function (a, i) {
	          return prop.extract(path.concat(['[' + i + ']']), strength, a);
	        });
	        return ResultCombine.consolidateArr(results);
	      };
	      var toString = function () {
	        return 'array(' + prop.toString() + ')';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var oneOf = function (props) {
	      var extract = function (path, strength, val) {
	        var errors = [];
	        for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
	          var prop = props_1[_i];
	          var res = prop.extract(path, strength, val);
	          if (res.stype === SimpleResultType.Value) {
	            return res;
	          }
	          errors.push(res);
	        }
	        return ResultCombine.consolidateArr(errors);
	      };
	      var toString = function () {
	        return 'oneOf(' + map(props, function (prop) {
	          return prop.toString();
	        }).join(', ') + ')';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var setOf = function (validator, prop) {
	      var validateKeys = function (path, keys) {
	        return arrOf(value$1(validator)).extract(path, identity, keys);
	      };
	      var extract = function (path, strength, o) {
	        var keys$1 = keys(o);
	        var validatedKeys = validateKeys(path, keys$1);
	        return SimpleResult.bind(validatedKeys, function (validKeys) {
	          var schema = map(validKeys, function (vk) {
	            return adt$1.field(vk, vk, strict(), prop);
	          });
	          return objOf(schema).extract(path, strength, o);
	        });
	      };
	      var toString = function () {
	        return 'setOf(' + prop.toString() + ')';
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var thunk = function (desc, processor) {
	      var getP = cached(function () {
	        return processor();
	      });
	      var extract = function (path, strength, val) {
	        return getP().extract(path, strength, val);
	      };
	      var toString = function () {
	        return getP().toString();
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	    var anyValue = constant(value$1(SimpleResult.svalue));
	    var arrOfObj = compose(arrOf, objOf);
	    var state = adt$1.state;
	    var field = adt$1.field;
	
	    var chooseFrom = function (path, strength, input, branches, ch) {
	      var fields = get$1(branches, ch);
	      return fields.fold(function () {
	        return missingBranch(path, branches, ch);
	      }, function (vp) {
	        return vp.extract(path.concat(['branch: ' + ch]), strength, input);
	      });
	    };
	    var choose = function (key, branches) {
	      var extract = function (path, strength, input) {
	        var choice = get$1(input, key);
	        return choice.fold(function () {
	          return missingKey(path, key);
	        }, function (chosen) {
	          return chooseFrom(path, strength, input, branches, chosen);
	        });
	      };
	      var toString = function () {
	        return 'chooseOn(' + key + '). Possible values: ' + keys(branches);
	      };
	      return {
	        extract: extract,
	        toString: toString
	      };
	    };
	
	    var _anyValue = value$1(SimpleResult.svalue);
	    var arrOfObj$1 = function (objFields) {
	      return arrOfObj(objFields);
	    };
	    var arrOfVal = function () {
	      return arrOf(_anyValue);
	    };
	    var valueThunkOf = valueThunk;
	    var valueOf = function (validator) {
	      return value$1(function (v) {
	        return validator(v).fold(SimpleResult.serror, SimpleResult.svalue);
	      });
	    };
	    var setOf$1 = function (validator, prop) {
	      return setOf(function (v) {
	        return SimpleResult.fromResult(validator(v));
	      }, prop);
	    };
	    var extract = function (label, prop, strength, obj) {
	      var res = prop.extract([label], strength, obj);
	      return SimpleResult.mapError(res, function (errs) {
	        return {
	          input: obj,
	          errors: errs
	        };
	      });
	    };
	    var asRaw = function (label, prop, obj) {
	      return SimpleResult.toResult(extract(label, prop, identity, obj));
	    };
	    var getOrDie = function (extraction) {
	      return extraction.fold(function (errInfo) {
	        throw new Error(formatError(errInfo));
	      }, identity);
	    };
	    var asRawOrDie = function (label, prop, obj) {
	      return getOrDie(asRaw(label, prop, obj));
	    };
	    var formatError = function (errInfo) {
	      return 'Errors: \n' + formatErrors(errInfo.errors).join('\n') + '\n\nInput object: ' + formatObj(errInfo.input);
	    };
	    var chooseProcessor = function (key, branches) {
	      return choose(key, branches);
	    };
	    var choose$1 = function (key, branches) {
	      return choose(key, map$2(branches, objOf));
	    };
	    var thunkOf = function (desc, schema) {
	      return thunk(desc, schema);
	    };
	    var anyValue$1 = constant(_anyValue);
	    var typedValue = function (validator, expectedType) {
	      return value$1(function (a) {
	        var actualType = typeof a;
	        return validator(a) ? SimpleResult.svalue(a) : SimpleResult.serror('Expected type: ' + expectedType + ' but got: ' + actualType);
	      });
	    };
	    var number = typedValue(isNumber, 'number');
	    var string = typedValue(isString, 'string');
	    var boolean = typedValue(isBoolean, 'boolean');
	    var functionProcessor = typedValue(isFunction, 'function');
	    var isPostMessageable = function (val) {
	      var every = function (iter, callbackFn) {
	        var result = iter.next();
	        while (!result.done) {
	          if (!callbackFn(result.value)) {
	            return false;
	          }
	          result = iter.next();
	        }
	        return true;
	      };
	      if (Object(val) !== val) {
	        return true;
	      }
	      switch ({}.toString.call(val).slice(8, -1)) {
	      case 'Boolean':
	      case 'Number':
	      case 'String':
	      case 'Date':
	      case 'RegExp':
	      case 'Blob':
	      case 'FileList':
	      case 'ImageData':
	      case 'ImageBitmap':
	      case 'ArrayBuffer':
	        return true;
	      case 'Array':
	      case 'Object':
	        return Object.keys(val).every(function (prop) {
	          return isPostMessageable(val[prop]);
	        });
	      case 'Map':
	        return every(val.keys(), isPostMessageable) && every(val.values(), isPostMessageable);
	      case 'Set':
	        return every(val.keys(), isPostMessageable);
	      default:
	        return false;
	      }
	    };
	    var postMessageable = value$1(function (a) {
	      return isPostMessageable(a) ? SimpleResult.svalue(a) : SimpleResult.serror('Expected value to be acceptable for sending via postMessage');
	    });
	
	    var validateEnum = function (values) {
	      return valueOf(function (value) {
	        return contains(values, value) ? Result.value(value) : Result.error('Unsupported value: "' + value + '", choose one of "' + values.join(', ') + '".');
	      });
	    };
	    var strict$1 = function (key) {
	      return field(key, key, strict(), anyValue());
	    };
	    var strictOf = function (key, schema) {
	      return field(key, key, strict(), schema);
	    };
	    var strictNumber = function (key) {
	      return strictOf(key, number);
	    };
	    var strictString = function (key) {
	      return strictOf(key, string);
	    };
	    var strictStringEnum = function (key, values) {
	      return field(key, key, strict(), validateEnum(values));
	    };
	    var strictBoolean = function (key) {
	      return strictOf(key, boolean);
	    };
	    var strictFunction = function (key) {
	      return strictOf(key, functionProcessor);
	    };
	    var forbid = function (key, message) {
	      return field(key, key, asOption(), value$1(function (_v) {
	        return SimpleResult.serror('The field: ' + key + ' is forbidden. ' + message);
	      }));
	    };
	    var strictObjOf = function (key, objSchema) {
	      return field(key, key, strict(), objOf(objSchema));
	    };
	    var strictArrayOfObj = function (key, objFields) {
	      return field(key, key, strict(), arrOfObj(objFields));
	    };
	    var strictArrayOf = function (key, schema) {
	      return field(key, key, strict(), arrOf(schema));
	    };
	    var option = function (key) {
	      return field(key, key, asOption(), anyValue());
	    };
	    var optionOf = function (key, schema) {
	      return field(key, key, asOption(), schema);
	    };
	    var optionNumber = function (key) {
	      return optionOf(key, number);
	    };
	    var optionString = function (key) {
	      return optionOf(key, string);
	    };
	    var optionFunction = function (key) {
	      return optionOf(key, functionProcessor);
	    };
	    var optionArrayOf = function (key, schema) {
	      return optionOf(key, arrOf(schema));
	    };
	    var optionObjOf = function (key, objSchema) {
	      return optionOf(key, objOf(objSchema));
	    };
	    var optionObjOfOnly = function (key, objSchema) {
	      return optionOf(key, objOfOnly(objSchema));
	    };
	    var defaulted$1 = function (key, fallback) {
	      return field(key, key, defaulted(fallback), anyValue());
	    };
	    var defaultedOf = function (key, fallback, schema) {
	      return field(key, key, defaulted(fallback), schema);
	    };
	    var defaultedNumber = function (key, fallback) {
	      return defaultedOf(key, fallback, number);
	    };
	    var defaultedString = function (key, fallback) {
	      return defaultedOf(key, fallback, string);
	    };
	    var defaultedStringEnum = function (key, fallback, values) {
	      return defaultedOf(key, fallback, validateEnum(values));
	    };
	    var defaultedBoolean = function (key, fallback) {
	      return defaultedOf(key, fallback, boolean);
	    };
	    var defaultedFunction = function (key, fallback) {
	      return defaultedOf(key, fallback, functionProcessor);
	    };
	    var defaultedPostMsg = function (key, fallback) {
	      return defaultedOf(key, fallback, postMessageable);
	    };
	    var defaultedArrayOf = function (key, fallback, schema) {
	      return defaultedOf(key, fallback, arrOf(schema));
	    };
	    var defaultedObjOf = function (key, fallback, objSchema) {
	      return defaultedOf(key, fallback, objOf(objSchema));
	    };
	    var state$1 = function (okey, instantiator) {
	      return state(okey, instantiator);
	    };
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$2 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu$1(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$2(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu$1(0, 0);
	    };
	    var nu$1 = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu$1,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var contains$1 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var endsWith = function (str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim = blank(/^\s+|\s+$/g);
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$1(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$2,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown$2 = function () {
	      return nu$3({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$3 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$3,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$2 = function (userAgent, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, mediaMatch);
	    });
	    var detect$3 = function () {
	      return platform();
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var is = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
	    };
	
	    var eq$1 = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains$2 = function (e1, e2) {
	      return detect$3().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	
	    var ensureIsRoot = function (isRoot) {
	      return isFunction(isRoot) ? isRoot : never;
	    };
	    var ancestor = function (scope, transform, isRoot) {
	      var element = scope.dom;
	      var stop = ensureIsRoot(isRoot);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        var transformed = transform(el);
	        if (transformed.isSome()) {
	          return transformed;
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest = function (scope, transform, isRoot) {
	      var current = transform(scope);
	      var stop = ensureIsRoot(isRoot);
	      return current.orThunk(function () {
	        return stop(scope) ? Optional.none() : ancestor(scope, transform, stop);
	      });
	    };
	
	    var isSource = function (component, simulatedEvent) {
	      return eq$1(component.element, simulatedEvent.event.target);
	    };
	
	    var nu$4 = function (parts) {
	      if (!hasNonNullableKey(parts, 'can') && !hasNonNullableKey(parts, 'abort') && !hasNonNullableKey(parts, 'run')) {
	        throw new Error('EventHandler defined by: ' + JSON.stringify(parts, null, 2) + ' does not have can, abort, or run!');
	      }
	      return asRawOrDie('Extracting event.handler', objOfOnly([
	        defaulted$1('can', always),
	        defaulted$1('abort', never),
	        defaulted$1('run', noop)
	      ]), parts);
	    };
	    var all$1 = function (handlers, f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return foldl(handlers, function (acc, handler) {
	          return acc && f(handler).apply(undefined, args);
	        }, true);
	      };
	    };
	    var any = function (handlers, f) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return foldl(handlers, function (acc, handler) {
	          return acc || f(handler).apply(undefined, args);
	        }, false);
	      };
	    };
	    var read = function (handler) {
	      return isFunction(handler) ? {
	        can: always,
	        abort: never,
	        run: handler
	      } : handler;
	    };
	    var fuse = function (handlers) {
	      var can = all$1(handlers, function (handler) {
	        return handler.can;
	      });
	      var abort = any(handlers, function (handler) {
	        return handler.abort;
	      });
	      var run = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        each(handlers, function (handler) {
	          handler.run.apply(undefined, args);
	        });
	      };
	      return nu$4({
	        can: can,
	        abort: abort,
	        run: run
	      });
	    };
	
	    var constant$1 = constant;
	    var touchstart = constant$1('touchstart');
	    var touchmove = constant$1('touchmove');
	    var touchend = constant$1('touchend');
	    var touchcancel = constant$1('touchcancel');
	    var mousedown = constant$1('mousedown');
	    var mousemove = constant$1('mousemove');
	    var mouseout = constant$1('mouseout');
	    var mouseup = constant$1('mouseup');
	    var mouseover = constant$1('mouseover');
	    var focusin = constant$1('focusin');
	    var focusout = constant$1('focusout');
	    var keydown = constant$1('keydown');
	    var keyup = constant$1('keyup');
	    var input = constant$1('input');
	    var change = constant$1('change');
	    var click = constant$1('click');
	    var transitionend = constant$1('transitionend');
	    var selectstart = constant$1('selectstart');
	
	    var prefixName = function (name) {
	      return constant('alloy.' + name);
	    };
	    var alloy = { tap: prefixName('tap') };
	    var focus = prefixName('focus');
	    var postBlur = prefixName('blur.post');
	    var postPaste = prefixName('paste.post');
	    var receive = prefixName('receive');
	    var execute = prefixName('execute');
	    var focusItem = prefixName('focus.item');
	    var tap = alloy.tap;
	    var longpress = prefixName('longpress');
	    var sandboxClose = prefixName('sandbox.close');
	    var typeaheadCancel = prefixName('typeahead.cancel');
	    var systemInit = prefixName('system.init');
	    var documentTouchmove = prefixName('system.touchmove');
	    var documentTouchend = prefixName('system.touchend');
	    var windowScroll = prefixName('system.scroll');
	    var windowResize = prefixName('system.resize');
	    var attachedToDom = prefixName('system.attached');
	    var detachedFromDom = prefixName('system.detached');
	    var dismissRequested = prefixName('system.dismissRequested');
	    var repositionRequested = prefixName('system.repositionRequested');
	    var focusShifted = prefixName('focusmanager.shifted');
	    var slotVisibility = prefixName('slotcontainer.visibility');
	    var changeTab = prefixName('change.tab');
	    var dismissTab = prefixName('dismiss.tab');
	    var highlight = prefixName('highlight');
	    var dehighlight = prefixName('dehighlight');
	
	    var emit = function (component, event) {
	      dispatchWith(component, component.element, event, {});
	    };
	    var emitWith = function (component, event, properties) {
	      dispatchWith(component, component.element, event, properties);
	    };
	    var emitExecute = function (component) {
	      emit(component, execute());
	    };
	    var dispatch = function (component, target, event) {
	      dispatchWith(component, target, event, {});
	    };
	    var dispatchWith = function (component, target, event, properties) {
	      var data = __assign({ target: target }, properties);
	      component.getSystem().triggerEvent(event, target, data);
	    };
	    var dispatchEvent = function (component, target, event, simulatedEvent) {
	      component.getSystem().triggerEvent(event, target, simulatedEvent.event);
	    };
	
	    var derive = function (configs) {
	      return wrapAll$1(configs);
	    };
	    var abort = function (name, predicate) {
	      return {
	        key: name,
	        value: nu$4({ abort: predicate })
	      };
	    };
	    var can = function (name, predicate) {
	      return {
	        key: name,
	        value: nu$4({ can: predicate })
	      };
	    };
	    var preventDefault = function (name) {
	      return {
	        key: name,
	        value: nu$4({
	          run: function (component, simulatedEvent) {
	            simulatedEvent.event.prevent();
	          }
	        })
	      };
	    };
	    var run = function (name, handler) {
	      return {
	        key: name,
	        value: nu$4({ run: handler })
	      };
	    };
	    var runActionExtra = function (name, action, extra) {
	      return {
	        key: name,
	        value: nu$4({
	          run: function (component, simulatedEvent) {
	            action.apply(undefined, [
	              component,
	              simulatedEvent
	            ].concat(extra));
	          }
	        })
	      };
	    };
	    var runOnName = function (name) {
	      return function (handler) {
	        return run(name, handler);
	      };
	    };
	    var runOnSourceName = function (name) {
	      return function (handler) {
	        return {
	          key: name,
	          value: nu$4({
	            run: function (component, simulatedEvent) {
	              if (isSource(component, simulatedEvent)) {
	                handler(component, simulatedEvent);
	              }
	            }
	          })
	        };
	      };
	    };
	    var redirectToUid = function (name, uid) {
	      return run(name, function (component, simulatedEvent) {
	        component.getSystem().getByUid(uid).each(function (redirectee) {
	          dispatchEvent(redirectee, redirectee.element, name, simulatedEvent);
	        });
	      });
	    };
	    var redirectToPart = function (name, detail, partName) {
	      var uid = detail.partUids[partName];
	      return redirectToUid(name, uid);
	    };
	    var runWithTarget = function (name, f) {
	      return run(name, function (component, simulatedEvent) {
	        var ev = simulatedEvent.event;
	        var target = component.getSystem().getByDom(ev.target).fold(function () {
	          var closest$1 = closest(ev.target, function (el) {
	            return component.getSystem().getByDom(el).toOptional();
	          }, never);
	          return closest$1.getOr(component);
	        }, function (c) {
	          return c;
	        });
	        f(component, target, simulatedEvent);
	      });
	    };
	    var cutter = function (name) {
	      return run(name, function (component, simulatedEvent) {
	        simulatedEvent.cut();
	      });
	    };
	    var stopper = function (name) {
	      return run(name, function (component, simulatedEvent) {
	        simulatedEvent.stop();
	      });
	    };
	    var runOnSource = function (name, f) {
	      return runOnSourceName(name)(f);
	    };
	    var runOnAttached = runOnSourceName(attachedToDom());
	    var runOnDetached = runOnSourceName(detachedFromDom());
	    var runOnInit = runOnSourceName(systemInit());
	    var runOnExecute = runOnName(execute());
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var name = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	    var isDocument = isType$1(DOCUMENT);
	    var isDocumentFragment = isType$1(DOCUMENT_FRAGMENT);
	
	    var owner = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner(dos);
	    };
	    var documentElement = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.documentElement);
	    };
	    var defaultView = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parentNode = function (element) {
	      return parent(element);
	    };
	    var offsetParent = function (element) {
	      return Optional.from(element.dom.offsetParent).map(SugarElement.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getContentContainer = function (dos) {
	      return isShadowRoot(dos) ? dos : SugarElement.fromDom(documentOrOwner(dos).dom.body);
	    };
	    var isInShadowRoot = function (e) {
	      return getShadowRoot(e).isSome();
	    };
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var after = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom.insertBefore(element.dom, v.dom);
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var appendAt = function (parent, element, index) {
	      child(parent, index).fold(function () {
	        append(parent, element);
	      }, function (v) {
	        before(v, element);
	      });
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom.textContent = '';
	      each(children(element), function (rogue) {
	        remove(rogue);
	      });
	    };
	    var remove = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove(wrapper);
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(SugarElement.fromDom(div));
	    };
	
	    var get$2 = function (element) {
	      return element.dom.innerHTML;
	    };
	    var set = function (element, content) {
	      var owner$1 = owner(element);
	      var docDom = owner$1.dom;
	      var fragment = SugarElement.fromDom(docDom.createDocumentFragment());
	      var contentElements = fromHtml$1(content, docDom);
	      append$1(fragment, contentElements);
	      empty(element);
	      append(element, fragment);
	    };
	    var getOuter = function (element) {
	      var container = SugarElement.fromTag('div');
	      var clone = SugarElement.fromDom(element.dom.cloneNode(true));
	      append(container, clone);
	      return get$2(container);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set$1 = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom;
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get$3 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var getOpt = function (element, key) {
	      return Optional.from(get$3(element, key));
	    };
	    var has$1 = function (element, key) {
	      var dom = element.dom;
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove$1 = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	
	    var clone = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var shallow$1 = function (original) {
	      return clone(original, false);
	    };
	
	    var getHtml = function (element) {
	      if (isShadowRoot(element)) {
	        return '#shadow-root';
	      } else {
	        var clone = shallow$1(element);
	        return getOuter(clone);
	      }
	    };
	
	    var element = function (elem) {
	      return getHtml(elem);
	    };
	
	    var isRecursive = function (component, originator, target) {
	      return eq$1(originator, component.element) && !eq$1(originator, target);
	    };
	    var events = derive([can(focus(), function (component, simulatedEvent) {
	        var event = simulatedEvent.event;
	        var originator = event.originator;
	        var target = event.target;
	        if (isRecursive(component, originator, target)) {
	          console.warn(focus() + ' did not get interpreted by the desired target. ' + '\nOriginator: ' + element(originator) + '\nTarget: ' + element(target) + '\nCheck the ' + focus() + ' event handlers');
	          return false;
	        } else {
	          return true;
	        }
	      })]);
	
	    var DefaultEvents = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events
	    });
	
	    var unique = 0;
	    var generate$1 = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique++;
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    var prefix = constant('alloy-id-');
	    var idAttr = constant('data-alloy-id');
	
	    var prefix$1 = prefix();
	    var idAttr$1 = idAttr();
	    var write = function (label, elem) {
	      var id = generate$1(prefix$1 + label);
	      writeOnly(elem, id);
	      return id;
	    };
	    var writeOnly = function (elem, uid) {
	      Object.defineProperty(elem.dom, idAttr$1, {
	        value: uid,
	        writable: true
	      });
	    };
	    var read$1 = function (elem) {
	      var id = isElement(elem) ? elem.dom[idAttr$1] : null;
	      return Optional.from(id);
	    };
	    var generate$2 = function (prefix) {
	      return generate$1(prefix);
	    };
	
	    var make = identity;
	
	    var NoContextApi = function (getComp) {
	      var fail = function (event) {
	        return function () {
	          throw new Error('The component must be in a context to send: ' + event + (getComp ? '\n' + element(getComp().element) + ' is not in context.' : ''));
	        };
	      };
	      return {
	        debugInfo: constant('fake'),
	        triggerEvent: fail('triggerEvent'),
	        triggerFocus: fail('triggerFocus'),
	        triggerEscape: fail('triggerEscape'),
	        build: fail('build'),
	        addToWorld: fail('addToWorld'),
	        removeFromWorld: fail('removeFromWorld'),
	        addToGui: fail('addToGui'),
	        removeFromGui: fail('removeFromGui'),
	        getByUid: fail('getByUid'),
	        getByDom: fail('getByDom'),
	        broadcast: fail('broadcast'),
	        broadcastOn: fail('broadcastOn'),
	        broadcastEvent: fail('broadcastEvent'),
	        isConnected: never
	      };
	    };
	    var singleton = NoContextApi();
	
	    var markAsBehaviourApi = function (f, apiName, apiFunction) {
	      var delegate = apiFunction.toString();
	      var endIndex = delegate.indexOf(')') + 1;
	      var openBracketIndex = delegate.indexOf('(');
	      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
	      f.toFunctionAnnotation = function () {
	        return {
	          name: apiName,
	          parameters: cleanParameters(parameters.slice(0, 1).concat(parameters.slice(3)))
	        };
	      };
	      return f;
	    };
	    var cleanParameters = function (parameters) {
	      return map(parameters, function (p) {
	        return endsWith(p, '/*') ? p.substring(0, p.length - '/*'.length) : p;
	      });
	    };
	    var markAsExtraApi = function (f, extraName) {
	      var delegate = f.toString();
	      var endIndex = delegate.indexOf(')') + 1;
	      var openBracketIndex = delegate.indexOf('(');
	      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
	      f.toFunctionAnnotation = function () {
	        return {
	          name: extraName,
	          parameters: cleanParameters(parameters)
	        };
	      };
	      return f;
	    };
	    var markAsSketchApi = function (f, apiFunction) {
	      var delegate = apiFunction.toString();
	      var endIndex = delegate.indexOf(')') + 1;
	      var openBracketIndex = delegate.indexOf('(');
	      var parameters = delegate.substring(openBracketIndex + 1, endIndex - 1).split(/,\s*/);
	      f.toFunctionAnnotation = function () {
	        return {
	          name: 'OVERRIDE',
	          parameters: cleanParameters(parameters.slice(1))
	        };
	      };
	      return f;
	    };
	
	    var premadeTag = generate$1('alloy-premade');
	    var premade = function (comp) {
	      return wrap$1(premadeTag, comp);
	    };
	    var getPremade = function (spec) {
	      return get$1(spec, premadeTag);
	    };
	    var makeApi = function (f) {
	      return markAsSketchApi(function (component) {
	        var rest = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          rest[_i - 1] = arguments[_i];
	        }
	        return f.apply(void 0, __spreadArrays([
	          component.getApis(),
	          component
	        ], rest));
	      }, f);
	    };
	
	    var NoState = {
	      init: function () {
	        return nu$5({
	          readState: function () {
	            return 'No State required';
	          }
	        });
	      }
	    };
	    var nu$5 = function (spec) {
	      return spec;
	    };
	
	    var generateFrom = function (spec, all) {
	      var schema = map(all, function (a) {
	        return optionObjOf(a.name(), [
	          strict$1('config'),
	          defaulted$1('state', NoState)
	        ]);
	      });
	      var validated = asRaw('component.behaviours', objOf(schema), spec.behaviours).fold(function (errInfo) {
	        throw new Error(formatError(errInfo) + '\nComplete spec:\n' + JSON.stringify(spec, null, 2));
	      }, function (v) {
	        return v;
	      });
	      return {
	        list: all,
	        data: map$2(validated, function (optBlobThunk) {
	          var output = optBlobThunk.map(function (blob) {
	            return {
	              config: blob.config,
	              state: blob.state.init(blob.config)
	            };
	          });
	          return function () {
	            return output;
	          };
	        })
	      };
	    };
	    var getBehaviours = function (bData) {
	      return bData.list;
	    };
	    var getData = function (bData) {
	      return bData.data;
	    };
	
	    var byInnerKey = function (data, tuple) {
	      var r = {};
	      each$1(data, function (detail, key) {
	        each$1(detail, function (value, indexKey) {
	          var chain = get$1(r, indexKey).getOr([]);
	          r[indexKey] = chain.concat([tuple(key, value)]);
	        });
	      });
	      return r;
	    };
	
	    var nu$6 = function (s) {
	      return {
	        classes: s.classes !== undefined ? s.classes : [],
	        attributes: s.attributes !== undefined ? s.attributes : {},
	        styles: s.styles !== undefined ? s.styles : {}
	      };
	    };
	    var merge$1 = function (defnA, mod) {
	      return __assign(__assign({}, defnA), {
	        attributes: __assign(__assign({}, defnA.attributes), mod.attributes),
	        styles: __assign(__assign({}, defnA.styles), mod.styles),
	        classes: defnA.classes.concat(mod.classes)
	      });
	    };
	
	    var combine = function (info, baseMod, behaviours, base) {
	      var modsByBehaviour = __assign({}, baseMod);
	      each(behaviours, function (behaviour) {
	        modsByBehaviour[behaviour.name()] = behaviour.exhibit(info, base);
	      });
	      var byAspect = byInnerKey(modsByBehaviour, function (name, modification) {
	        return {
	          name: name,
	          modification: modification
	        };
	      });
	      var combineObjects = function (objects) {
	        return foldr(objects, function (b, a) {
	          return __assign(__assign({}, a.modification), b);
	        }, {});
	      };
	      var combinedClasses = foldr(byAspect.classes, function (b, a) {
	        return a.modification.concat(b);
	      }, []);
	      var combinedAttributes = combineObjects(byAspect.attributes);
	      var combinedStyles = combineObjects(byAspect.styles);
	      return nu$6({
	        classes: combinedClasses,
	        attributes: combinedAttributes,
	        styles: combinedStyles
	      });
	    };
	
	    var sortKeys = function (label, keyName, array, order) {
	      try {
	        var sorted = sort(array, function (a, b) {
	          var aKey = a[keyName];
	          var bKey = b[keyName];
	          var aIndex = order.indexOf(aKey);
	          var bIndex = order.indexOf(bKey);
	          if (aIndex === -1) {
	            throw new Error('The ordering for ' + label + ' does not have an entry for ' + aKey + '.\nOrder specified: ' + JSON.stringify(order, null, 2));
	          }
	          if (bIndex === -1) {
	            throw new Error('The ordering for ' + label + ' does not have an entry for ' + bKey + '.\nOrder specified: ' + JSON.stringify(order, null, 2));
	          }
	          if (aIndex < bIndex) {
	            return -1;
	          } else if (bIndex < aIndex) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	        return Result.value(sorted);
	      } catch (err) {
	        return Result.error([err]);
	      }
	    };
	
	    var uncurried = function (handler, purpose) {
	      return {
	        handler: handler,
	        purpose: purpose
	      };
	    };
	    var curried = function (handler, purpose) {
	      return {
	        cHandler: handler,
	        purpose: purpose
	      };
	    };
	    var curryArgs = function (descHandler, extraArgs) {
	      return curried(curry.apply(undefined, [descHandler.handler].concat(extraArgs)), descHandler.purpose);
	    };
	    var getCurried = function (descHandler) {
	      return descHandler.cHandler;
	    };
	
	    var behaviourTuple = function (name, handler) {
	      return {
	        name: name,
	        handler: handler
	      };
	    };
	    var nameToHandlers = function (behaviours, info) {
	      var r = {};
	      each(behaviours, function (behaviour) {
	        r[behaviour.name()] = behaviour.handlers(info);
	      });
	      return r;
	    };
	    var groupByEvents = function (info, behaviours, base) {
	      var behaviourEvents = __assign(__assign({}, base), nameToHandlers(behaviours, info));
	      return byInnerKey(behaviourEvents, behaviourTuple);
	    };
	    var combine$1 = function (info, eventOrder, behaviours, base) {
	      var byEventName = groupByEvents(info, behaviours, base);
	      return combineGroups(byEventName, eventOrder);
	    };
	    var assemble = function (rawHandler) {
	      var handler = read(rawHandler);
	      return function (component, simulatedEvent) {
	        var rest = [];
	        for (var _i = 2; _i < arguments.length; _i++) {
	          rest[_i - 2] = arguments[_i];
	        }
	        var args = [
	          component,
	          simulatedEvent
	        ].concat(rest);
	        if (handler.abort.apply(undefined, args)) {
	          simulatedEvent.stop();
	        } else if (handler.can.apply(undefined, args)) {
	          handler.run.apply(undefined, args);
	        }
	      };
	    };
	    var missingOrderError = function (eventName, tuples) {
	      return Result.error(['The event (' + eventName + ') has more than one behaviour that listens to it.\nWhen this occurs, you must ' + 'specify an event ordering for the behaviours in your spec (e.g. [ "listing", "toggling" ]).\nThe behaviours that ' + 'can trigger it are: ' + JSON.stringify(map(tuples, function (c) {
	          return c.name;
	        }), null, 2)]);
	    };
	    var fuse$1 = function (tuples, eventOrder, eventName) {
	      var order = eventOrder[eventName];
	      if (!order) {
	        return missingOrderError(eventName, tuples);
	      } else {
	        return sortKeys('Event: ' + eventName, 'name', tuples, order).map(function (sortedTuples) {
	          var handlers = map(sortedTuples, function (tuple) {
	            return tuple.handler;
	          });
	          return fuse(handlers);
	        });
	      }
	    };
	    var combineGroups = function (byEventName, eventOrder) {
	      var r = mapToArray(byEventName, function (tuples, eventName) {
	        var combined = tuples.length === 1 ? Result.value(tuples[0].handler) : fuse$1(tuples, eventOrder, eventName);
	        return combined.map(function (handler) {
	          var assembled = assemble(handler);
	          var purpose = tuples.length > 1 ? filter(eventOrder[eventName], function (o) {
	            return exists(tuples, function (t) {
	              return t.name === o;
	            });
	          }).join(' > ') : tuples[0].name;
	          return wrap$1(eventName, uncurried(assembled, purpose));
	        });
	      });
	      return consolidate(r, {});
	    };
	
	    var baseBehaviour = 'alloy.base.behaviour';
	    var toInfo = function (spec) {
	      var _a;
	      return asRaw('custom.definition', objOf([
	        field('dom', 'dom', strict(), objOf([
	          strict$1('tag'),
	          defaulted$1('styles', {}),
	          defaulted$1('classes', []),
	          defaulted$1('attributes', {}),
	          option('value'),
	          option('innerHtml')
	        ])),
	        strict$1('components'),
	        strict$1('uid'),
	        defaulted$1('events', {}),
	        defaulted$1('apis', {}),
	        field('eventOrder', 'eventOrder', mergeWith((_a = {}, _a[execute()] = [
	          'disabling',
	          baseBehaviour,
	          'toggling',
	          'typeaheadevents'
	        ], _a[focus()] = [
	          baseBehaviour,
	          'focusing',
	          'keying'
	        ], _a[systemInit()] = [
	          baseBehaviour,
	          'disabling',
	          'toggling',
	          'representing'
	        ], _a[input()] = [
	          baseBehaviour,
	          'representing',
	          'streaming',
	          'invalidating'
	        ], _a[detachedFromDom()] = [
	          baseBehaviour,
	          'representing',
	          'item-events',
	          'tooltipping'
	        ], _a[mousedown()] = [
	          'focusing',
	          baseBehaviour,
	          'item-type-events'
	        ], _a[touchstart()] = [
	          'focusing',
	          baseBehaviour,
	          'item-type-events'
	        ], _a[mouseover()] = [
	          'item-type-events',
	          'tooltipping'
	        ], _a[receive()] = [
	          'receiving',
	          'reflecting',
	          'tooltipping'
	        ], _a)), anyValue$1()),
	        option('domModification')
	      ]), spec);
	    };
	    var toDefinition = function (detail) {
	      return __assign(__assign({}, detail.dom), {
	        uid: detail.uid,
	        domChildren: map(detail.components, function (comp) {
	          return comp.element;
	        })
	      });
	    };
	    var toModification = function (detail) {
	      return detail.domModification.fold(function () {
	        return nu$6({});
	      }, nu$6);
	    };
	    var toEvents = function (info) {
	      return info.events;
	    };
	
	    var read$2 = function (element, attr) {
	      var value = get$3(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add = function (element, attr, id) {
	      var old = read$2(element, attr);
	      var nu = old.concat([id]);
	      set$1(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$2 = function (element, attr, id) {
	      var nu = filter(read$2(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set$1(element, attr, nu.join(' '));
	      } else {
	        remove$1(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get$4 = function (element) {
	      return read$2(element, 'class');
	    };
	    var add$1 = function (element, clazz) {
	      return add(element, 'class', clazz);
	    };
	    var remove$3 = function (element, clazz) {
	      return remove$2(element, 'class', clazz);
	    };
	
	    var add$2 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$1(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get$4(element);
	      if (classList.length === 0) {
	        remove$1(element, 'class');
	      }
	    };
	    var remove$4 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$3(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has$2 = function (element, clazz) {
	      return supports(element) && element.dom.classList.contains(clazz);
	    };
	
	    var add$3 = function (element, classes) {
	      each(classes, function (x) {
	        add$2(element, x);
	      });
	    };
	    var remove$5 = function (element, classes) {
	      each(classes, function (x) {
	        remove$4(element, x);
	      });
	    };
	
	    var isSupported$1 = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	    var body = function () {
	      return getBody(SugarElement.fromDom(document));
	    };
	    var getBody = function (doc) {
	      var b = doc.dom.body;
	      if (b === null || b === undefined) {
	        throw new Error('Body is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported$1(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var internalRemove = function (dom, property) {
	      if (isSupported$1(dom)) {
	        dom.style.removeProperty(property);
	      }
	    };
	    var set$2 = function (element, property, value) {
	      var dom = element.dom;
	      internalSet(dom, property, value);
	    };
	    var setAll$1 = function (element, css) {
	      var dom = element.dom;
	      each$1(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var setOptions = function (element, css) {
	      var dom = element.dom;
	      each$1(css, function (v, k) {
	        v.fold(function () {
	          internalRemove(dom, k);
	        }, function (value) {
	          internalSet(dom, k, value);
	        });
	      });
	    };
	    var get$5 = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom;
	      var raw = getUnsafeProperty(dom, property);
	      return Optional.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom;
	      if (isSupported$1(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	    var isValidValue = function (tag, property, value) {
	      var element = SugarElement.fromTag(tag);
	      set$2(element, property, value);
	      var style = getRaw(element, property);
	      return style.isSome();
	    };
	    var remove$6 = function (element, property) {
	      var dom = element.dom;
	      internalRemove(dom, property);
	      if (getOpt(element, 'style').map(trim).is('')) {
	        remove$1(element, 'style');
	      }
	    };
	    var reflow = function (e) {
	      return e.dom.offsetWidth;
	    };
	
	    var get$6 = function (element) {
	      return element.dom.value;
	    };
	    var set$3 = function (element, value) {
	      if (value === undefined) {
	        throw new Error('Value.set was undefined');
	      }
	      element.dom.value = value;
	    };
	
	    var renderToDom = function (definition) {
	      var subject = SugarElement.fromTag(definition.tag);
	      setAll(subject, definition.attributes);
	      add$3(subject, definition.classes);
	      setAll$1(subject, definition.styles);
	      definition.innerHtml.each(function (html) {
	        return set(subject, html);
	      });
	      var children = definition.domChildren;
	      append$1(subject, children);
	      definition.value.each(function (value) {
	        set$3(subject, value);
	      });
	      if (!definition.uid) {
	        debugger;
	      }
	      writeOnly(subject, definition.uid);
	      return subject;
	    };
	
	    var getBehaviours$1 = function (spec) {
	      var behaviours = get$1(spec, 'behaviours').getOr({});
	      var keys$1 = filter(keys(behaviours), function (k) {
	        return behaviours[k] !== undefined;
	      });
	      return map(keys$1, function (k) {
	        return behaviours[k].me;
	      });
	    };
	    var generateFrom$1 = function (spec, all) {
	      return generateFrom(spec, all);
	    };
	    var generate$3 = function (spec) {
	      var all = getBehaviours$1(spec);
	      return generateFrom$1(spec, all);
	    };
	
	    var getDomDefinition = function (info, bList, bData) {
	      var definition = toDefinition(info);
	      var infoModification = toModification(info);
	      var baseModification = { 'alloy.base.modification': infoModification };
	      var modification = bList.length > 0 ? combine(bData, baseModification, bList, definition) : infoModification;
	      return merge$1(definition, modification);
	    };
	    var getEvents = function (info, bList, bData) {
	      var baseEvents = { 'alloy.base.behaviour': toEvents(info) };
	      return combine$1(bData, info.eventOrder, bList, baseEvents).getOrDie();
	    };
	    var build = function (spec) {
	      var getMe = function () {
	        return me;
	      };
	      var systemApi = Cell(singleton);
	      var info = getOrDie(toInfo(spec));
	      var bBlob = generate$3(spec);
	      var bList = getBehaviours(bBlob);
	      var bData = getData(bBlob);
	      var modDefinition = getDomDefinition(info, bList, bData);
	      var item = renderToDom(modDefinition);
	      var events = getEvents(info, bList, bData);
	      var subcomponents = Cell(info.components);
	      var connect = function (newApi) {
	        systemApi.set(newApi);
	      };
	      var disconnect = function () {
	        systemApi.set(NoContextApi(getMe));
	      };
	      var syncComponents = function () {
	        var children$1 = children(item);
	        var subs = bind(children$1, function (child) {
	          return systemApi.get().getByDom(child).fold(function () {
	            return [];
	          }, function (c) {
	            return [c];
	          });
	        });
	        subcomponents.set(subs);
	      };
	      var config = function (behaviour) {
	        var b = bData;
	        var f = isFunction(b[behaviour.name()]) ? b[behaviour.name()] : function () {
	          throw new Error('Could not find ' + behaviour.name() + ' in ' + JSON.stringify(spec, null, 2));
	        };
	        return f();
	      };
	      var hasConfigured = function (behaviour) {
	        return isFunction(bData[behaviour.name()]);
	      };
	      var getApis = function () {
	        return info.apis;
	      };
	      var readState = function (behaviourName) {
	        return bData[behaviourName]().map(function (b) {
	          return b.state.readState();
	        }).getOr('not enabled');
	      };
	      var me = {
	        getSystem: systemApi.get,
	        config: config,
	        hasConfigured: hasConfigured,
	        spec: spec,
	        readState: readState,
	        getApis: getApis,
	        connect: connect,
	        disconnect: disconnect,
	        element: item,
	        syncComponents: syncComponents,
	        components: subcomponents.get,
	        events: events
	      };
	      return me;
	    };
	
	    var buildSubcomponents = function (spec) {
	      var components = get$1(spec, 'components').getOr([]);
	      return map(components, build$1);
	    };
	    var buildFromSpec = function (userSpec) {
	      var _a = make(userSpec), specEvents = _a.events, spec = __rest(_a, ['events']);
	      var components = buildSubcomponents(spec);
	      var completeSpec = __assign(__assign({}, spec), {
	        events: __assign(__assign({}, DefaultEvents), specEvents),
	        components: components
	      });
	      return Result.value(build(completeSpec));
	    };
	    var text = function (textContent) {
	      var element = SugarElement.fromText(textContent);
	      return external({ element: element });
	    };
	    var external = function (spec) {
	      var extSpec = asRawOrDie('external.component', objOfOnly([
	        strict$1('element'),
	        option('uid')
	      ]), spec);
	      var systemApi = Cell(NoContextApi());
	      var connect = function (newApi) {
	        systemApi.set(newApi);
	      };
	      var disconnect = function () {
	        systemApi.set(NoContextApi(function () {
	          return me;
	        }));
	      };
	      extSpec.uid.each(function (uid) {
	        writeOnly(extSpec.element, uid);
	      });
	      var me = {
	        getSystem: systemApi.get,
	        config: Optional.none,
	        hasConfigured: never,
	        connect: connect,
	        disconnect: disconnect,
	        getApis: function () {
	          return {};
	        },
	        element: extSpec.element,
	        spec: spec,
	        readState: constant('No state'),
	        syncComponents: noop,
	        components: constant([]),
	        events: {}
	      };
	      return premade(me);
	    };
	    var uids = generate$2;
	    var build$1 = function (spec) {
	      return getPremade(spec).fold(function () {
	        var userSpecWithUid = spec.hasOwnProperty('uid') ? spec : __assign({ uid: uids('') }, spec);
	        return buildFromSpec(userSpecWithUid).getOrDie();
	      }, function (prebuilt) {
	        return prebuilt;
	      });
	    };
	    var premade$1 = premade;
	
	    var Dimension = function (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom;
	        if (isSupported$1(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$5(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$5(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    };
	
	    var api = Dimension('height', function (element) {
	      var dom = element.dom;
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$7 = function (element) {
	      return api.get(element);
	    };
	    var getOuter$1 = function (element) {
	      return api.getOuter(element);
	    };
	    var setMax = function (element, value) {
	      var inclusions = [
	        'margin-top',
	        'border-top-width',
	        'padding-top',
	        'padding-bottom',
	        'border-bottom-width',
	        'margin-bottom'
	      ];
	      var absMax = api.max(element, value, inclusions);
	      set$2(element, 'max-height', absMax + 'px');
	    };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return SugarPosition(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      if (a !== undefined) {
	        return a;
	      } else {
	        return b !== undefined ? b : 0;
	      }
	    };
	    var absolute = function (element) {
	      var doc = element.dom.ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      if (body === element.dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport = function (element) {
	      var dom = element.dom;
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return SugarPosition(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var api$1 = Dimension('width', function (element) {
	      return element.dom.offsetWidth;
	    });
	    var set$4 = function (element, h) {
	      return api$1.set(element, h);
	    };
	    var get$8 = function (element) {
	      return api$1.get(element);
	    };
	    var getOuter$2 = function (element) {
	      return api$1.getOuter(element);
	    };
	    var setMax$1 = function (element, value) {
	      var inclusions = [
	        'margin-left',
	        'border-left-width',
	        'padding-left',
	        'padding-right',
	        'border-right-width',
	        'margin-right'
	      ];
	      var absMax = api$1.max(element, value, inclusions);
	      set$2(element, 'max-width', absMax + 'px');
	    };
	
	    var mkEvent = function (target, x, y, stop, prevent, kill, raw) {
	      return {
	        target: target,
	        x: x,
	        y: y,
	        stop: stop,
	        prevent: prevent,
	        kill: kill,
	        raw: raw
	      };
	    };
	    var fromRawEvent = function (rawEvent) {
	      var target = SugarElement.fromDom(getOriginalEventTarget(rawEvent).getOr(rawEvent.target));
	      var stop = function () {
	        return rawEvent.stopPropagation();
	      };
	      var prevent = function () {
	        return rawEvent.preventDefault();
	      };
	      var kill = compose(prevent, stop);
	      return mkEvent(target, rawEvent.clientX, rawEvent.clientY, stop, prevent, kill, rawEvent);
	    };
	    var handle = function (filter, handler) {
	      return function (rawEvent) {
	        if (filter(rawEvent)) {
	          handler(fromRawEvent(rawEvent));
	        }
	      };
	    };
	    var binder = function (element, event, filter, handler, useCapture) {
	      var wrapped = handle(filter, handler);
	      element.dom.addEventListener(event, wrapped, useCapture);
	      return { unbind: curry(unbind, element, event, wrapped, useCapture) };
	    };
	    var bind$2 = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, false);
	    };
	    var capture = function (element, event, filter, handler) {
	      return binder(element, event, filter, handler, true);
	    };
	    var unbind = function (element, event, handler, useCapture) {
	      element.dom.removeEventListener(event, handler, useCapture);
	    };
	
	    var get$9 = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	    var to = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var win = doc.defaultView;
	      if (win) {
	        win.scrollTo(x, y);
	      }
	    };
	
	    var get$a = function (_win) {
	      var win = _win === undefined ? window : _win;
	      return Optional.from(win['visualViewport']);
	    };
	    var bounds = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var getBounds = function (_win) {
	      var win = _win === undefined ? window : _win;
	      var doc = win.document;
	      var scroll = get$9(SugarElement.fromDom(doc));
	      return get$a(win).fold(function () {
	        var html = win.document.documentElement;
	        var width = html.clientWidth;
	        var height = html.clientHeight;
	        return bounds(scroll.left, scroll.top, width, height);
	      }, function (visualViewport) {
	        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
	      });
	    };
	
	    var walkUp = function (navigation, doc) {
	      var frame = navigation.view(doc);
	      return frame.fold(constant([]), function (f) {
	        var parent = navigation.owner(f);
	        var rest = walkUp(navigation, parent);
	        return [f].concat(rest);
	      });
	    };
	    var pathTo = function (element, navigation) {
	      var d = navigation.owner(element);
	      var paths = walkUp(navigation, d);
	      return Optional.some(paths);
	    };
	
	    var view = function (doc) {
	      var _a;
	      var element = doc.dom === document ? Optional.none() : Optional.from((_a = doc.dom.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement);
	      return element.map(SugarElement.fromDom);
	    };
	    var owner$1 = function (element) {
	      return owner(element);
	    };
	
	    var Navigation = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        view: view,
	        owner: owner$1
	    });
	
	    var find$3 = function (element) {
	      var doc = SugarElement.fromDom(document);
	      var scroll = get$9(doc);
	      var path = pathTo(element, Navigation);
	      return path.fold(curry(absolute, element), function (frames) {
	        var offset = viewport(element);
	        var r = foldr(frames, function (b, a) {
	          var loc = viewport(a);
	          return {
	            left: b.left + loc.left,
	            top: b.top + loc.top
	          };
	        }, {
	          left: 0,
	          top: 0
	        });
	        return SugarPosition(r.left + offset.left + scroll.left, r.top + offset.top + scroll.top);
	      });
	    };
	
	    var pointed = function (point, width, height) {
	      return {
	        point: point,
	        width: width,
	        height: height
	      };
	    };
	    var rect = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      };
	    };
	    var bounds$1 = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var box = function (element) {
	      var xy = absolute(element);
	      var w = getOuter$2(element);
	      var h = getOuter$1(element);
	      return bounds$1(xy.left, xy.top, w, h);
	    };
	    var absolute$1 = function (element) {
	      var position = find$3(element);
	      var width = getOuter$2(element);
	      var height = getOuter$1(element);
	      return bounds$1(position.left, position.top, width, height);
	    };
	    var win = function () {
	      return getBounds(window);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      if (is(scope, a)) {
	        return Optional.some(scope);
	      } else if (isFunction(isRoot) && isRoot(scope)) {
	        return Optional.none();
	      } else {
	        return ancestor(scope, a, isRoot);
	      }
	    }
	
	    var ancestor$1 = function (scope, predicate, isRoot) {
	      var element = scope.dom;
	      var stop = isFunction(isRoot) ? isRoot : never;
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        if (predicate(el)) {
	          return Optional.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$1 = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor$1, scope, predicate, isRoot);
	    };
	    var descendant = function (scope, predicate) {
	      var descend = function (node) {
	        for (var i = 0; i < node.childNodes.length; i++) {
	          var child_1 = SugarElement.fromDom(node.childNodes[i]);
	          if (predicate(child_1)) {
	            return Optional.some(child_1);
	          }
	          var res = descend(node.childNodes[i]);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope.dom);
	    };
	
	    var closest$2 = function (scope, predicate, isRoot) {
	      return closest$1(scope, predicate, isRoot).isSome();
	    };
	
	    var ancestor$2 = function (scope, selector, isRoot) {
	      return ancestor$1(scope, function (e) {
	        return is(e, selector);
	      }, isRoot);
	    };
	    var descendant$1 = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$3 = function (scope, selector, isRoot) {
	      var is$1 = function (element, selector) {
	        return is(element, selector);
	      };
	      return ClosestOrAncestor(is$1, ancestor$2, scope, selector, isRoot);
	    };
	
	    var find$4 = function (queryElem) {
	      var dependent = closest$1(queryElem, function (elem) {
	        if (!isElement(elem)) {
	          return false;
	        }
	        var id = get$3(elem, 'id');
	        return id !== undefined && id.indexOf('aria-owns') > -1;
	      });
	      return dependent.bind(function (dep) {
	        var id = get$3(dep, 'id');
	        var dos = getRootNode(dep);
	        return descendant$1(dos, '[aria-owns="' + id + '"]');
	      });
	    };
	    var manager = function () {
	      var ariaId = generate$1('aria-owns');
	      var link = function (elem) {
	        set$1(elem, 'aria-owns', ariaId);
	      };
	      var unlink = function (elem) {
	        remove$1(elem, 'aria-owns');
	      };
	      return {
	        id: ariaId,
	        link: link,
	        unlink: unlink
	      };
	    };
	
	    var isAriaPartOf = function (component, queryElem) {
	      return find$4(queryElem).exists(function (owner) {
	        return isPartOf(component, owner);
	      });
	    };
	    var isPartOf = function (component, queryElem) {
	      return closest$2(queryElem, function (el) {
	        return eq$1(el, component.element);
	      }, never) || isAriaPartOf(component, queryElem);
	    };
	
	    var unknown$3 = 'unknown';
	    var EventConfiguration;
	    (function (EventConfiguration) {
	      EventConfiguration[EventConfiguration['STOP'] = 0] = 'STOP';
	      EventConfiguration[EventConfiguration['NORMAL'] = 1] = 'NORMAL';
	      EventConfiguration[EventConfiguration['LOGGING'] = 2] = 'LOGGING';
	    }(EventConfiguration || (EventConfiguration = {})));
	    var eventConfig = Cell({});
	    var makeEventLogger = function (eventName, initialTarget) {
	      var sequence = [];
	      var startTime = new Date().getTime();
	      return {
	        logEventCut: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'cut',
	            target: target,
	            purpose: purpose
	          });
	        },
	        logEventStopped: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'stopped',
	            target: target,
	            purpose: purpose
	          });
	        },
	        logNoParent: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'no-parent',
	            target: target,
	            purpose: purpose
	          });
	        },
	        logEventNoHandlers: function (_name, target) {
	          sequence.push({
	            outcome: 'no-handlers-left',
	            target: target
	          });
	        },
	        logEventResponse: function (_name, target, purpose) {
	          sequence.push({
	            outcome: 'response',
	            purpose: purpose,
	            target: target
	          });
	        },
	        write: function () {
	          var finishTime = new Date().getTime();
	          if (contains([
	              'mousemove',
	              'mouseover',
	              'mouseout',
	              systemInit()
	            ], eventName)) {
	            return;
	          }
	          console.log(eventName, {
	            event: eventName,
	            time: finishTime - startTime,
	            target: initialTarget.dom,
	            sequence: map(sequence, function (s) {
	              if (!contains([
	                  'cut',
	                  'stopped',
	                  'response'
	                ], s.outcome)) {
	                return s.outcome;
	              } else {
	                return '{' + s.purpose + '} ' + s.outcome + ' at (' + element(s.target) + ')';
	              }
	            })
	          });
	        }
	      };
	    };
	    var processEvent = function (eventName, initialTarget, f) {
	      var status = get$1(eventConfig.get(), eventName).orThunk(function () {
	        var patterns = keys(eventConfig.get());
	        return findMap(patterns, function (p) {
	          return eventName.indexOf(p) > -1 ? Optional.some(eventConfig.get()[p]) : Optional.none();
	        });
	      }).getOr(EventConfiguration.NORMAL);
	      switch (status) {
	      case EventConfiguration.NORMAL:
	        return f(noLogger());
	      case EventConfiguration.LOGGING: {
	          var logger = makeEventLogger(eventName, initialTarget);
	          var output = f(logger);
	          logger.write();
	          return output;
	        }
	      case EventConfiguration.STOP:
	        return true;
	      }
	    };
	    var path = [
	      'alloy/data/Fields',
	      'alloy/debugging/Debugging'
	    ];
	    var getTrace = function () {
	      var err = new Error();
	      if (err.stack !== undefined) {
	        var lines = err.stack.split('\n');
	        return find(lines, function (line) {
	          return line.indexOf('alloy') > 0 && !exists(path, function (p) {
	            return line.indexOf(p) > -1;
	          });
	        }).getOr(unknown$3);
	      } else {
	        return unknown$3;
	      }
	    };
	    var ignoreEvent = {
	      logEventCut: noop,
	      logEventStopped: noop,
	      logNoParent: noop,
	      logEventNoHandlers: noop,
	      logEventResponse: noop,
	      write: noop
	    };
	    var monitorEvent = function (eventName, initialTarget, f) {
	      return processEvent(eventName, initialTarget, f);
	    };
	    var noLogger = constant(ignoreEvent);
	
	    var menuFields = constant([
	      strict$1('menu'),
	      strict$1('selectedMenu')
	    ]);
	    var itemFields = constant([
	      strict$1('item'),
	      strict$1('selectedItem')
	    ]);
	    var schema = constant(objOf(itemFields().concat(menuFields())));
	    var itemSchema = constant(objOf(itemFields()));
	
	    var _initSize = strictObjOf('initSize', [
	      strict$1('numColumns'),
	      strict$1('numRows')
	    ]);
	    var itemMarkers = function () {
	      return strictOf('markers', itemSchema());
	    };
	    var tieredMenuMarkers = function () {
	      return strictObjOf('markers', [strict$1('backgroundMenu')].concat(menuFields()).concat(itemFields()));
	    };
	    var markers = function (required) {
	      return strictObjOf('markers', map(required, strict$1));
	    };
	    var onPresenceHandler = function (label, fieldName, presence) {
	      var trace = getTrace();
	      return field(fieldName, fieldName, presence, valueOf(function (f) {
	        return Result.value(function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          return f.apply(undefined, args);
	        });
	      }));
	    };
	    var onHandler = function (fieldName) {
	      return onPresenceHandler('onHandler', fieldName, defaulted(noop));
	    };
	    var onKeyboardHandler = function (fieldName) {
	      return onPresenceHandler('onKeyboardHandler', fieldName, defaulted(Optional.none));
	    };
	    var onStrictHandler = function (fieldName) {
	      return onPresenceHandler('onHandler', fieldName, strict());
	    };
	    var onStrictKeyboardHandler = function (fieldName) {
	      return onPresenceHandler('onKeyboardHandler', fieldName, strict());
	    };
	    var output = function (name, value) {
	      return state$1(name, constant(value));
	    };
	    var snapshot = function (name) {
	      return state$1(name, identity);
	    };
	    var initSize = constant(_initSize);
	
	    var nu$7 = function (x, y, bubble, direction, boundsRestriction, label) {
	      return {
	        x: x,
	        y: y,
	        bubble: bubble,
	        direction: direction,
	        boundsRestriction: boundsRestriction,
	        label: label
	      };
	    };
	
	    var adt$2 = Adt.generate([
	      { southeast: [] },
	      { southwest: [] },
	      { northeast: [] },
	      { northwest: [] },
	      { south: [] },
	      { north: [] },
	      { east: [] },
	      { west: [] }
	    ]);
	    var cata = function (subject, southeast, southwest, northeast, northwest, south, north, east, west) {
	      return subject.fold(southeast, southwest, northeast, northwest, south, north, east, west);
	    };
	    var cataVertical = function (subject, south, middle, north) {
	      return subject.fold(south, south, north, north, south, north, middle, middle);
	    };
	    var cataHorizontal = function (subject, east, middle, west) {
	      return subject.fold(east, west, east, west, middle, middle, east, west);
	    };
	    var southeast = adt$2.southeast;
	    var southwest = adt$2.southwest;
	    var northeast = adt$2.northeast;
	    var northwest = adt$2.northwest;
	    var south = adt$2.south;
	    var north = adt$2.north;
	    var east = adt$2.east;
	    var west = adt$2.west;
	
	    var getRestriction = function (anchor, restriction) {
	      switch (restriction) {
	      case 1:
	        return anchor.x;
	      case 0:
	        return anchor.x + anchor.width;
	      case 2:
	        return anchor.y;
	      case 3:
	        return anchor.y + anchor.height;
	      }
	    };
	    var boundsRestriction = function (anchor, restrictions) {
	      return mapToObject([
	        'left',
	        'right',
	        'top',
	        'bottom'
	      ], function (dir) {
	        return get$1(restrictions, dir).map(function (restriction) {
	          return getRestriction(anchor, restriction);
	        });
	      });
	    };
	    var adjustBounds = function (bounds, boundsRestrictions, bubbleOffsets) {
	      var applyRestriction = function (dir, current) {
	        var bubbleOffset = dir === 'top' || dir === 'bottom' ? bubbleOffsets.top : bubbleOffsets.left;
	        return get$1(boundsRestrictions, dir).bind(identity).bind(function (restriction) {
	          if (dir === 'left' || dir === 'top') {
	            return restriction >= current ? Optional.some(restriction) : Optional.none();
	          } else {
	            return restriction <= current ? Optional.some(restriction) : Optional.none();
	          }
	        }).map(function (restriction) {
	          return restriction + bubbleOffset;
	        }).getOr(current);
	      };
	      var adjustedLeft = applyRestriction('left', bounds.x);
	      var adjustedTop = applyRestriction('top', bounds.y);
	      var adjustedRight = applyRestriction('right', bounds.right);
	      var adjustedBottom = applyRestriction('bottom', bounds.bottom);
	      return bounds$1(adjustedLeft, adjustedTop, adjustedRight - adjustedLeft, adjustedBottom - adjustedTop);
	    };
	
	    var eastX = function (anchor) {
	      return anchor.x;
	    };
	    var middleX = function (anchor, element) {
	      return anchor.x + anchor.width / 2 - element.width / 2;
	    };
	    var westX = function (anchor, element) {
	      return anchor.x + anchor.width - element.width;
	    };
	    var northY = function (anchor, element) {
	      return anchor.y - element.height;
	    };
	    var southY = function (anchor) {
	      return anchor.y + anchor.height;
	    };
	    var centreY = function (anchor, element) {
	      return anchor.y + anchor.height / 2 - element.height / 2;
	    };
	    var eastEdgeX = function (anchor) {
	      return anchor.x + anchor.width;
	    };
	    var westEdgeX = function (anchor, element) {
	      return anchor.x - element.width;
	    };
	    var southeast$1 = function (anchor, element, bubbles) {
	      return nu$7(eastX(anchor), southY(anchor), bubbles.southeast(), southeast(), boundsRestriction(anchor, {
	        left: 1,
	        top: 3
	      }), 'layout-se');
	    };
	    var southwest$1 = function (anchor, element, bubbles) {
	      return nu$7(westX(anchor, element), southY(anchor), bubbles.southwest(), southwest(), boundsRestriction(anchor, {
	        right: 0,
	        top: 3
	      }), 'layout-sw');
	    };
	    var northeast$1 = function (anchor, element, bubbles) {
	      return nu$7(eastX(anchor), northY(anchor, element), bubbles.northeast(), northeast(), boundsRestriction(anchor, {
	        left: 1,
	        bottom: 2
	      }), 'layout-ne');
	    };
	    var northwest$1 = function (anchor, element, bubbles) {
	      return nu$7(westX(anchor, element), northY(anchor, element), bubbles.northwest(), northwest(), boundsRestriction(anchor, {
	        right: 0,
	        bottom: 2
	      }), 'layout-nw');
	    };
	    var north$1 = function (anchor, element, bubbles) {
	      return nu$7(middleX(anchor, element), northY(anchor, element), bubbles.north(), north(), boundsRestriction(anchor, { bottom: 2 }), 'layout-n');
	    };
	    var south$1 = function (anchor, element, bubbles) {
	      return nu$7(middleX(anchor, element), southY(anchor), bubbles.south(), south(), boundsRestriction(anchor, { top: 3 }), 'layout-s');
	    };
	    var east$1 = function (anchor, element, bubbles) {
	      return nu$7(eastEdgeX(anchor), centreY(anchor, element), bubbles.east(), east(), boundsRestriction(anchor, { left: 0 }), 'layout-e');
	    };
	    var west$1 = function (anchor, element, bubbles) {
	      return nu$7(westEdgeX(anchor, element), centreY(anchor, element), bubbles.west(), west(), boundsRestriction(anchor, { right: 1 }), 'layout-w');
	    };
	    var all$2 = function () {
	      return [
	        southeast$1,
	        southwest$1,
	        northeast$1,
	        northwest$1,
	        south$1,
	        north$1,
	        east$1,
	        west$1
	      ];
	    };
	    var allRtl = function () {
	      return [
	        southwest$1,
	        southeast$1,
	        northwest$1,
	        northeast$1,
	        south$1,
	        north$1,
	        east$1,
	        west$1
	      ];
	    };
	    var aboveOrBelow = function () {
	      return [
	        northeast$1,
	        northwest$1,
	        southeast$1,
	        southwest$1,
	        north$1,
	        south$1
	      ];
	    };
	    var aboveOrBelowRtl = function () {
	      return [
	        northwest$1,
	        northeast$1,
	        southwest$1,
	        southeast$1,
	        north$1,
	        south$1
	      ];
	    };
	    var belowOrAbove = function () {
	      return [
	        southeast$1,
	        southwest$1,
	        northeast$1,
	        northwest$1,
	        south$1,
	        north$1
	      ];
	    };
	    var belowOrAboveRtl = function () {
	      return [
	        southwest$1,
	        southeast$1,
	        northwest$1,
	        northeast$1,
	        south$1,
	        north$1
	      ];
	    };
	
	    var chooseChannels = function (channels, message) {
	      return message.universal ? channels : filter(channels, function (ch) {
	        return contains(message.channels, ch);
	      });
	    };
	    var events$1 = function (receiveConfig) {
	      return derive([run(receive(), function (component, message) {
	          var channelMap = receiveConfig.channels;
	          var channels = keys(channelMap);
	          var receivingData = message;
	          var targetChannels = chooseChannels(channels, receivingData);
	          each(targetChannels, function (ch) {
	            var channelInfo = channelMap[ch];
	            var channelSchema = channelInfo.schema;
	            var data = asRawOrDie('channel[' + ch + '] data\nReceiver: ' + element(component.element), channelSchema, receivingData.data);
	            channelInfo.onReceive(component, data);
	          });
	        })]);
	    };
	
	    var ActiveReceiving = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$1
	    });
	
	    var ReceivingSchema = [strictOf('channels', setOf$1(Result.value, objOfOnly([
	        onStrictHandler('onReceive'),
	        defaulted$1('schema', anyValue$1())
	      ])))];
	
	    var executeEvent = function (bConfig, bState, executor) {
	      return runOnExecute(function (component) {
	        executor(component, bConfig, bState);
	      });
	    };
	    var loadEvent = function (bConfig, bState, f) {
	      return runOnInit(function (component, _simulatedEvent) {
	        f(component, bConfig, bState);
	      });
	    };
	    var create = function (schema, name, active, apis, extra, state) {
	      var configSchema = objOfOnly(schema);
	      var schemaSchema = optionObjOf(name, [optionObjOfOnly('config', schema)]);
	      return doCreate(configSchema, schemaSchema, name, active, apis, extra, state);
	    };
	    var createModes = function (modes, name, active, apis, extra, state) {
	      var configSchema = modes;
	      var schemaSchema = optionObjOf(name, [optionOf('config', modes)]);
	      return doCreate(configSchema, schemaSchema, name, active, apis, extra, state);
	    };
	    var wrapApi = function (bName, apiFunction, apiName) {
	      var f = function (component) {
	        var rest = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          rest[_i - 1] = arguments[_i];
	        }
	        var args = [component].concat(rest);
	        return component.config({ name: constant(bName) }).fold(function () {
	          throw new Error('We could not find any behaviour configuration for: ' + bName + '. Using API: ' + apiName);
	        }, function (info) {
	          var rest = Array.prototype.slice.call(args, 1);
	          return apiFunction.apply(undefined, [
	            component,
	            info.config,
	            info.state
	          ].concat(rest));
	        });
	      };
	      return markAsBehaviourApi(f, apiName, apiFunction);
	    };
	    var revokeBehaviour = function (name) {
	      return {
	        key: name,
	        value: undefined
	      };
	    };
	    var doCreate = function (configSchema, schemaSchema, name, active, apis, extra, state) {
	      var getConfig = function (info) {
	        return hasNonNullableKey(info, name) ? info[name]() : Optional.none();
	      };
	      var wrappedApis = map$2(apis, function (apiF, apiName) {
	        return wrapApi(name, apiF, apiName);
	      });
	      var wrappedExtra = map$2(extra, function (extraF, extraName) {
	        return markAsExtraApi(extraF, extraName);
	      });
	      var me = __assign(__assign(__assign({}, wrappedExtra), wrappedApis), {
	        revoke: curry(revokeBehaviour, name),
	        config: function (spec) {
	          var prepared = asRawOrDie(name + '-config', configSchema, spec);
	          return {
	            key: name,
	            value: {
	              config: prepared,
	              me: me,
	              configAsRaw: cached(function () {
	                return asRawOrDie(name + '-config', configSchema, spec);
	              }),
	              initialConfig: spec,
	              state: state
	            }
	          };
	        },
	        schema: constant(schemaSchema),
	        exhibit: function (info, base) {
	          return getConfig(info).bind(function (behaviourInfo) {
	            return get$1(active, 'exhibit').map(function (exhibitor) {
	              return exhibitor(base, behaviourInfo.config, behaviourInfo.state);
	            });
	          }).getOr(nu$6({}));
	        },
	        name: constant(name),
	        handlers: function (info) {
	          return getConfig(info).map(function (behaviourInfo) {
	            var getEvents = get$1(active, 'events').getOr(function () {
	              return {};
	            });
	            return getEvents(behaviourInfo.config, behaviourInfo.state);
	          }).getOr({});
	        }
	      });
	      return me;
	    };
	
	    var derive$1 = function (capabilities) {
	      return wrapAll$1(capabilities);
	    };
	    var simpleSchema = objOfOnly([
	      strict$1('fields'),
	      strict$1('name'),
	      defaulted$1('active', {}),
	      defaulted$1('apis', {}),
	      defaulted$1('state', NoState),
	      defaulted$1('extra', {})
	    ]);
	    var create$1 = function (data) {
	      var value = asRawOrDie('Creating behaviour: ' + data.name, simpleSchema, data);
	      return create(value.fields, value.name, value.active, value.apis, value.extra, value.state);
	    };
	    var modeSchema = objOfOnly([
	      strict$1('branchKey'),
	      strict$1('branches'),
	      strict$1('name'),
	      defaulted$1('active', {}),
	      defaulted$1('apis', {}),
	      defaulted$1('state', NoState),
	      defaulted$1('extra', {})
	    ]);
	    var createModes$1 = function (data) {
	      var value = asRawOrDie('Creating behaviour: ' + data.name, modeSchema, data);
	      return createModes(choose$1(value.branchKey, value.branches), value.name, value.active, value.apis, value.extra, value.state);
	    };
	    var revoke = constant(undefined);
	
	    var Receiving = create$1({
	      fields: ReceivingSchema,
	      name: 'receiving',
	      active: ActiveReceiving
	    });
	
	    var exhibit = function (base, posConfig) {
	      return nu$6({
	        classes: [],
	        styles: posConfig.useFixed() ? {} : { position: 'relative' }
	      });
	    };
	
	    var ActivePosition = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit
	    });
	
	    var getDocument = function () {
	      return SugarElement.fromDom(document);
	    };
	
	    var focus$1 = function (element) {
	      return element.dom.focus();
	    };
	    var blur = function (element) {
	      return element.dom.blur();
	    };
	    var hasFocus = function (element) {
	      var root = getRootNode(element).dom;
	      return element.dom === root.activeElement;
	    };
	    var active = function (root) {
	      if (root === void 0) {
	        root = getDocument();
	      }
	      return Optional.from(root.dom.activeElement).map(SugarElement.fromDom);
	    };
	    var search = function (element) {
	      return active(getRootNode(element)).filter(function (e) {
	        return element.dom.contains(e.dom);
	      });
	    };
	
	    var preserve = function (f, container) {
	      var dos = getRootNode(container);
	      var refocus = active(dos).bind(function (focused) {
	        var hasFocus = function (elem) {
	          return eq$1(focused, elem);
	        };
	        return hasFocus(container) ? Optional.some(container) : descendant(container, hasFocus);
	      });
	      var result = f(container);
	      refocus.each(function (oldFocus) {
	        active(dos).filter(function (newFocus) {
	          return eq$1(newFocus, oldFocus);
	        }).fold(function () {
	          focus$1(oldFocus);
	        }, noop);
	      });
	      return result;
	    };
	
	    var NuPositionCss = function (position, left, top, right, bottom) {
	      return {
	        position: position,
	        left: left,
	        top: top,
	        right: right,
	        bottom: bottom
	      };
	    };
	    var applyPositionCss = function (element, position) {
	      var addPx = function (num) {
	        return num + 'px';
	      };
	      setOptions(element, {
	        position: Optional.some(position.position),
	        left: position.left.map(addPx),
	        top: position.top.map(addPx),
	        right: position.right.map(addPx),
	        bottom: position.bottom.map(addPx)
	      });
	    };
	
	    var adt$3 = Adt.generate([
	      { none: [] },
	      {
	        relative: [
	          'x',
	          'y',
	          'width',
	          'height'
	        ]
	      },
	      {
	        fixed: [
	          'x',
	          'y',
	          'width',
	          'height'
	        ]
	      }
	    ]);
	    var positionWithDirection = function (posName, decision, x, y, width, height) {
	      var decisionX = decision.x - x;
	      var decisionY = decision.y - y;
	      var decisionWidth = decision.width;
	      var decisionHeight = decision.height;
	      var decisionRight = width - (decisionX + decisionWidth);
	      var decisionBottom = height - (decisionY + decisionHeight);
	      var left = Optional.some(decisionX);
	      var top = Optional.some(decisionY);
	      var right = Optional.some(decisionRight);
	      var bottom = Optional.some(decisionBottom);
	      var none = Optional.none();
	      return cata(decision.direction, function () {
	        return NuPositionCss(posName, left, top, none, none);
	      }, function () {
	        return NuPositionCss(posName, none, top, right, none);
	      }, function () {
	        return NuPositionCss(posName, left, none, none, bottom);
	      }, function () {
	        return NuPositionCss(posName, none, none, right, bottom);
	      }, function () {
	        return NuPositionCss(posName, left, top, none, none);
	      }, function () {
	        return NuPositionCss(posName, left, none, none, bottom);
	      }, function () {
	        return NuPositionCss(posName, left, top, none, none);
	      }, function () {
	        return NuPositionCss(posName, none, top, right, none);
	      });
	    };
	    var reposition = function (origin, decision) {
	      return origin.fold(function () {
	        return NuPositionCss('absolute', Optional.some(decision.x), Optional.some(decision.y), Optional.none(), Optional.none());
	      }, function (x, y, width, height) {
	        return positionWithDirection('absolute', decision, x, y, width, height);
	      }, function (x, y, width, height) {
	        return positionWithDirection('fixed', decision, x, y, width, height);
	      });
	    };
	    var toBox = function (origin, element) {
	      var rel = curry(find$3, element);
	      var position = origin.fold(rel, rel, function () {
	        var scroll = get$9();
	        return find$3(element).translate(-scroll.left, -scroll.top);
	      });
	      var width = getOuter$2(element);
	      var height = getOuter$1(element);
	      return bounds$1(position.left, position.top, width, height);
	    };
	    var viewport$1 = function (origin, getBounds) {
	      return getBounds.fold(function () {
	        return origin.fold(win, win, bounds$1);
	      }, function (b) {
	        return origin.fold(b, b, function () {
	          var bounds = b();
	          var pos = translate(origin, bounds.x, bounds.y);
	          return bounds$1(pos.left, pos.top, bounds.width, bounds.height);
	        });
	      });
	    };
	    var translate = function (origin, x, y) {
	      var pos = SugarPosition(x, y);
	      var removeScroll = function () {
	        var outerScroll = get$9();
	        return pos.translate(-outerScroll.left, -outerScroll.top);
	      };
	      return origin.fold(constant(pos), constant(pos), removeScroll);
	    };
	    var cata$1 = function (subject, onNone, onRelative, onFixed) {
	      return subject.fold(onNone, onRelative, onFixed);
	    };
	    var none$1 = adt$3.none;
	    var relative = adt$3.relative;
	    var fixed = adt$3.fixed;
	
	    var anchor = function (anchorBox, origin) {
	      return {
	        anchorBox: anchorBox,
	        origin: origin
	      };
	    };
	    var box$1 = function (anchorBox, origin) {
	      return anchor(anchorBox, origin);
	    };
	
	    var cycleBy = function (value, delta, min, max) {
	      var r = value + delta;
	      if (r > max) {
	        return min;
	      } else if (r < min) {
	        return max;
	      } else {
	        return r;
	      }
	    };
	    var clamp = function (value, min, max) {
	      return Math.min(Math.max(value, min), max);
	    };
	
	    var adt$4 = Adt.generate([
	      { fit: ['reposition'] },
	      {
	        nofit: [
	          'reposition',
	          'deltaW',
	          'deltaH'
	        ]
	      }
	    ]);
	    var calcReposition = function (newX, newY, width, height, bounds) {
	      var boundsX = bounds.x;
	      var boundsY = bounds.y;
	      var boundsWidth = bounds.width;
	      var boundsHeight = bounds.height;
	      var xInBounds = newX >= boundsX;
	      var yInBounds = newY >= boundsY;
	      var originInBounds = xInBounds && yInBounds;
	      var xFit = newX + width <= boundsX + boundsWidth;
	      var yFit = newY + height <= boundsY + boundsHeight;
	      var sizeInBounds = xFit && yFit;
	      var deltaW = Math.abs(Math.min(width, xInBounds ? boundsX + boundsWidth - newX : boundsX - (newX + width)));
	      var deltaH = Math.abs(Math.min(height, yInBounds ? boundsY + boundsHeight - newY : boundsY - (newY + height)));
	      var maxX = Math.max(bounds.x, bounds.right - width);
	      var maxY = Math.max(bounds.y, bounds.bottom - height);
	      var limitX = clamp(newX, bounds.x, maxX);
	      var limitY = clamp(newY, bounds.y, maxY);
	      return {
	        originInBounds: originInBounds,
	        sizeInBounds: sizeInBounds,
	        limitX: limitX,
	        limitY: limitY,
	        deltaW: deltaW,
	        deltaH: deltaH
	      };
	    };
	    var attempt = function (candidate, width, height, bounds) {
	      var candidateX = candidate.x;
	      var candidateY = candidate.y;
	      var bubbleOffsets = candidate.bubble.offset;
	      var bubbleLeft = bubbleOffsets.left;
	      var bubbleTop = bubbleOffsets.top;
	      var adjustedBounds = adjustBounds(bounds, candidate.boundsRestriction, bubbleOffsets);
	      var boundsY = adjustedBounds.y;
	      var boundsBottom = adjustedBounds.bottom;
	      var boundsX = adjustedBounds.x;
	      var boundsRight = adjustedBounds.right;
	      var newX = candidateX + bubbleLeft;
	      var newY = candidateY + bubbleTop;
	      var _a = calcReposition(newX, newY, width, height, adjustedBounds), originInBounds = _a.originInBounds, sizeInBounds = _a.sizeInBounds, limitX = _a.limitX, limitY = _a.limitY, deltaW = _a.deltaW, deltaH = _a.deltaH;
	      var upAvailable = constant(limitY + deltaH - boundsY);
	      var downAvailable = constant(boundsBottom - limitY);
	      var maxHeight = cataVertical(candidate.direction, downAvailable, downAvailable, upAvailable);
	      var westAvailable = constant(limitX + deltaW - boundsX);
	      var eastAvailable = constant(boundsRight - limitX);
	      var maxWidth = cataHorizontal(candidate.direction, eastAvailable, eastAvailable, westAvailable);
	      var reposition = {
	        x: limitX,
	        y: limitY,
	        width: deltaW,
	        height: deltaH,
	        maxHeight: maxHeight,
	        maxWidth: maxWidth,
	        direction: candidate.direction,
	        classes: {
	          on: candidate.bubble.classesOn,
	          off: candidate.bubble.classesOff
	        },
	        label: candidate.label,
	        candidateYforTest: newY
	      };
	      return originInBounds && sizeInBounds ? adt$4.fit(reposition) : adt$4.nofit(reposition, deltaW, deltaH);
	    };
	    var attempts = function (candidates, anchorBox, elementBox, bubbles, bounds) {
	      var panelWidth = elementBox.width;
	      var panelHeight = elementBox.height;
	      var attemptBestFit = function (layout, reposition, deltaW, deltaH) {
	        var next = layout(anchorBox, elementBox, bubbles);
	        var attemptLayout = attempt(next, panelWidth, panelHeight, bounds);
	        return attemptLayout.fold(adt$4.fit, function (newReposition, newDeltaW, newDeltaH) {
	          var improved = newDeltaH > deltaH || newDeltaW > deltaW;
	          return improved ? adt$4.nofit(newReposition, newDeltaW, newDeltaH) : adt$4.nofit(reposition, deltaW, deltaH);
	        });
	      };
	      var abc = foldl(candidates, function (b, a) {
	        var bestNext = curry(attemptBestFit, a);
	        return b.fold(adt$4.fit, bestNext);
	      }, adt$4.nofit({
	        x: anchorBox.x,
	        y: anchorBox.y,
	        width: elementBox.width,
	        height: elementBox.height,
	        maxHeight: elementBox.height,
	        maxWidth: elementBox.width,
	        direction: southeast(),
	        classes: {
	          on: [],
	          off: []
	        },
	        label: 'none',
	        candidateYforTest: anchorBox.y
	      }, -1, -1));
	      return abc.fold(identity, identity);
	    };
	
	    var elementSize = function (p) {
	      return {
	        width: getOuter$2(p),
	        height: getOuter$1(p)
	      };
	    };
	    var layout = function (anchorBox, element, bubbles, options) {
	      remove$6(element, 'max-height');
	      remove$6(element, 'max-width');
	      var elementBox = elementSize(element);
	      return attempts(options.preference, anchorBox, elementBox, bubbles, options.bounds);
	    };
	    var setClasses = function (element, decision) {
	      var classInfo = decision.classes;
	      remove$5(element, classInfo.off);
	      add$3(element, classInfo.on);
	    };
	    var setHeight = function (element, decision, options) {
	      var maxHeightFunction = options.maxHeightFunction;
	      maxHeightFunction(element, decision.maxHeight);
	    };
	    var setWidth = function (element, decision, options) {
	      var maxWidthFunction = options.maxWidthFunction;
	      maxWidthFunction(element, decision.maxWidth);
	    };
	    var position = function (element, decision, options) {
	      applyPositionCss(element, reposition(options.origin, decision));
	    };
	
	    var setMaxHeight = function (element, maxHeight) {
	      setMax(element, Math.floor(maxHeight));
	    };
	    var anchored = constant(function (element, available) {
	      setMaxHeight(element, available);
	      setAll$1(element, {
	        'overflow-x': 'hidden',
	        'overflow-y': 'auto'
	      });
	    });
	    var expandable = constant(function (element, available) {
	      setMaxHeight(element, available);
	    });
	
	    var defaultOr = function (options, key, dephault) {
	      return options[key] === undefined ? dephault : options[key];
	    };
	    var simple = function (anchor, element, bubble, layouts, getBounds, overrideOptions) {
	      var maxHeightFunction = defaultOr(overrideOptions, 'maxHeightFunction', anchored());
	      var maxWidthFunction = defaultOr(overrideOptions, 'maxWidthFunction', noop);
	      var anchorBox = anchor.anchorBox;
	      var origin = anchor.origin;
	      var options = {
	        bounds: viewport$1(origin, getBounds),
	        origin: origin,
	        preference: layouts,
	        maxHeightFunction: maxHeightFunction,
	        maxWidthFunction: maxWidthFunction
	      };
	      go(anchorBox, element, bubble, options);
	    };
	    var go = function (anchorBox, element, bubble, options) {
	      var decision = layout(anchorBox, element, bubble, options);
	      position(element, decision, options);
	      setClasses(element, decision);
	      setHeight(element, decision, options);
	      setWidth(element, decision, options);
	    };
	
	    var allAlignments = [
	      'valignCentre',
	      'alignLeft',
	      'alignRight',
	      'alignCentre',
	      'top',
	      'bottom',
	      'left',
	      'right'
	    ];
	    var nu$8 = function (width, yoffset, classes) {
	      var getClasses = function (prop) {
	        return get$1(classes, prop).getOr([]);
	      };
	      var make = function (xDelta, yDelta, alignmentsOn) {
	        var alignmentsOff = difference(allAlignments, alignmentsOn);
	        return {
	          offset: SugarPosition(xDelta, yDelta),
	          classesOn: bind(alignmentsOn, getClasses),
	          classesOff: bind(alignmentsOff, getClasses)
	        };
	      };
	      return {
	        southeast: function () {
	          return make(-width, yoffset, [
	            'top',
	            'alignLeft'
	          ]);
	        },
	        southwest: function () {
	          return make(width, yoffset, [
	            'top',
	            'alignRight'
	          ]);
	        },
	        south: function () {
	          return make(-width / 2, yoffset, [
	            'top',
	            'alignCentre'
	          ]);
	        },
	        northeast: function () {
	          return make(-width, -yoffset, [
	            'bottom',
	            'alignLeft'
	          ]);
	        },
	        northwest: function () {
	          return make(width, -yoffset, [
	            'bottom',
	            'alignRight'
	          ]);
	        },
	        north: function () {
	          return make(-width / 2, -yoffset, [
	            'bottom',
	            'alignCentre'
	          ]);
	        },
	        east: function () {
	          return make(width, -yoffset / 2, [
	            'valignCentre',
	            'left'
	          ]);
	        },
	        west: function () {
	          return make(-width, -yoffset / 2, [
	            'valignCentre',
	            'right'
	          ]);
	        },
	        innerNorthwest: function () {
	          return make(-width, yoffset, [
	            'top',
	            'alignRight'
	          ]);
	        },
	        innerNortheast: function () {
	          return make(width, yoffset, [
	            'top',
	            'alignLeft'
	          ]);
	        },
	        innerNorth: function () {
	          return make(-width / 2, yoffset, [
	            'top',
	            'alignCentre'
	          ]);
	        },
	        innerSouthwest: function () {
	          return make(-width, -yoffset, [
	            'bottom',
	            'alignRight'
	          ]);
	        },
	        innerSoutheast: function () {
	          return make(width, -yoffset, [
	            'bottom',
	            'alignLeft'
	          ]);
	        },
	        innerSouth: function () {
	          return make(-width / 2, -yoffset, [
	            'bottom',
	            'alignCentre'
	          ]);
	        },
	        innerWest: function () {
	          return make(width, -yoffset / 2, [
	            'valignCentre',
	            'right'
	          ]);
	        },
	        innerEast: function () {
	          return make(-width, -yoffset / 2, [
	            'valignCentre',
	            'left'
	          ]);
	        }
	      };
	    };
	    var fallback = function () {
	      return nu$8(0, 0, {});
	    };
	
	    var nu$9 = function (x) {
	      return x;
	    };
	
	    var onDirection = function (isLtr, isRtl) {
	      return function (element) {
	        return getDirection(element) === 'rtl' ? isRtl : isLtr;
	      };
	    };
	    var getDirection = function (element) {
	      return get$5(element, 'direction') === 'rtl' ? 'rtl' : 'ltr';
	    };
	
	    var AttributeValue;
	    (function (AttributeValue) {
	      AttributeValue['TopToBottom'] = 'toptobottom';
	      AttributeValue['BottomToTop'] = 'bottomtotop';
	    }(AttributeValue || (AttributeValue = {})));
	    var Attribute = 'data-alloy-vertical-dir';
	    var isBottomToTopDir = function (el) {
	      return closest$2(el, function (current) {
	        return isElement(current) && get$3(current, 'data-alloy-vertical-dir') === AttributeValue.BottomToTop;
	      });
	    };
	
	    var schema$1 = function () {
	      return optionObjOf('layouts', [
	        strict$1('onLtr'),
	        strict$1('onRtl'),
	        option('onBottomLtr'),
	        option('onBottomRtl')
	      ]);
	    };
	    var get$b = function (elem, info, defaultLtr, defaultRtl, defaultBottomLtr, defaultBottomRtl, dirElement) {
	      var isBottomToTop = dirElement.map(isBottomToTopDir).getOr(false);
	      var customLtr = info.layouts.map(function (ls) {
	        return ls.onLtr(elem);
	      });
	      var customRtl = info.layouts.map(function (ls) {
	        return ls.onRtl(elem);
	      });
	      var ltr = isBottomToTop ? info.layouts.bind(function (ls) {
	        return ls.onBottomLtr.map(function (f) {
	          return f(elem);
	        });
	      }).or(customLtr).getOr(defaultBottomLtr) : customLtr.getOr(defaultLtr);
	      var rtl = isBottomToTop ? info.layouts.bind(function (ls) {
	        return ls.onBottomRtl.map(function (f) {
	          return f(elem);
	        });
	      }).or(customRtl).getOr(defaultBottomRtl) : customRtl.getOr(defaultRtl);
	      var f = onDirection(ltr, rtl);
	      return f(elem);
	    };
	
	    var placement = function (component, anchorInfo, origin) {
	      var hotspot = anchorInfo.hotspot;
	      var anchorBox = toBox(origin, hotspot.element);
	      var layouts = get$b(component.element, anchorInfo, belowOrAbove(), belowOrAboveRtl(), aboveOrBelow(), aboveOrBelowRtl(), Optional.some(anchorInfo.hotspot.element));
	      return Optional.some(nu$9({
	        anchorBox: anchorBox,
	        bubble: anchorInfo.bubble.getOr(fallback()),
	        overrides: anchorInfo.overrides,
	        layouts: layouts,
	        placer: Optional.none()
	      }));
	    };
	    var HotspotAnchor = [
	      strict$1('hotspot'),
	      option('bubble'),
	      defaulted$1('overrides', {}),
	      schema$1(),
	      output('placement', placement)
	    ];
	
	    var placement$1 = function (component, anchorInfo, origin) {
	      var pos = translate(origin, anchorInfo.x, anchorInfo.y);
	      var anchorBox = bounds$1(pos.left, pos.top, anchorInfo.width, anchorInfo.height);
	      var layouts = get$b(component.element, anchorInfo, all$2(), allRtl(), all$2(), allRtl(), Optional.none());
	      return Optional.some(nu$9({
	        anchorBox: anchorBox,
	        bubble: anchorInfo.bubble,
	        overrides: anchorInfo.overrides,
	        layouts: layouts,
	        placer: Optional.none()
	      }));
	    };
	    var MakeshiftAnchor = [
	      strict$1('x'),
	      strict$1('y'),
	      defaulted$1('height', 0),
	      defaulted$1('width', 0),
	      defaulted$1('bubble', fallback()),
	      defaulted$1('overrides', {}),
	      schema$1(),
	      output('placement', placement$1)
	    ];
	
	    var adt$5 = Adt.generate([
	      { screen: ['point'] },
	      {
	        absolute: [
	          'point',
	          'scrollLeft',
	          'scrollTop'
	        ]
	      }
	    ]);
	    var toFixed = function (pos) {
	      return pos.fold(identity, function (point, scrollLeft, scrollTop) {
	        return point.translate(-scrollLeft, -scrollTop);
	      });
	    };
	    var toAbsolute = function (pos) {
	      return pos.fold(identity, identity);
	    };
	    var sum = function (points) {
	      return foldl(points, function (b, a) {
	        return b.translate(a.left, a.top);
	      }, SugarPosition(0, 0));
	    };
	    var sumAsFixed = function (positions) {
	      var points = map(positions, toFixed);
	      return sum(points);
	    };
	    var sumAsAbsolute = function (positions) {
	      var points = map(positions, toAbsolute);
	      return sum(points);
	    };
	    var screen = adt$5.screen;
	    var absolute$2 = adt$5.absolute;
	
	    var getOffset = function (component, origin, anchorInfo) {
	      var win = defaultView(anchorInfo.root).dom;
	      var hasSameOwner = function (frame) {
	        var frameOwner = owner(frame);
	        var compOwner = owner(component.element);
	        return eq$1(frameOwner, compOwner);
	      };
	      return Optional.from(win.frameElement).map(SugarElement.fromDom).filter(hasSameOwner).map(absolute);
	    };
	    var getRootPoint = function (component, origin, anchorInfo) {
	      var doc = owner(component.element);
	      var outerScroll = get$9(doc);
	      var offset = getOffset(component, origin, anchorInfo).getOr(outerScroll);
	      return absolute$2(offset, outerScroll.left, outerScroll.top);
	    };
	
	    var capRect = function (left, top, width, height) {
	      var newLeft = left, newTop = top, newWidth = width, newHeight = height;
	      if (left < 0) {
	        newLeft = 0;
	        newWidth = width + left;
	      }
	      if (top < 0) {
	        newTop = 0;
	        newHeight = height + top;
	      }
	      var point = screen(SugarPosition(newLeft, newTop));
	      return Optional.some(pointed(point, newWidth, newHeight));
	    };
	    var calcNewAnchor = function (optBox, rootPoint, anchorInfo, origin, elem) {
	      return optBox.map(function (box) {
	        var points = [
	          rootPoint,
	          box.point
	        ];
	        var topLeft = cata$1(origin, function () {
	          return sumAsAbsolute(points);
	        }, function () {
	          return sumAsAbsolute(points);
	        }, function () {
	          return sumAsFixed(points);
	        });
	        var anchorBox = rect(topLeft.left, topLeft.top, box.width, box.height);
	        var layoutsLtr = anchorInfo.showAbove ? aboveOrBelow() : belowOrAbove();
	        var layoutsRtl = anchorInfo.showAbove ? aboveOrBelowRtl() : belowOrAboveRtl();
	        var layouts = get$b(elem, anchorInfo, layoutsLtr, layoutsRtl, layoutsLtr, layoutsRtl, Optional.none());
	        return nu$9({
	          anchorBox: anchorBox,
	          bubble: anchorInfo.bubble.getOr(fallback()),
	          overrides: anchorInfo.overrides,
	          layouts: layouts,
	          placer: Optional.none()
	        });
	      });
	    };
	
	    var placement$2 = function (component, anchorInfo, origin) {
	      var rootPoint = getRootPoint(component, origin, anchorInfo);
	      return anchorInfo.node.filter(inBody).bind(function (target) {
	        var rect = target.dom.getBoundingClientRect();
	        var nodeBox = capRect(rect.left, rect.top, rect.width, rect.height);
	        var elem = anchorInfo.node.getOr(component.element);
	        return calcNewAnchor(nodeBox, rootPoint, anchorInfo, origin, elem);
	      });
	    };
	    var NodeAnchor = [
	      strict$1('node'),
	      strict$1('root'),
	      option('bubble'),
	      schema$1(),
	      defaulted$1('overrides', {}),
	      defaulted$1('showAbove', false),
	      output('placement', placement$2)
	    ];
	
	    var zeroWidth = '\uFEFF';
	    var nbsp = '\xA0';
	
	    var create$2 = function (start, soffset, finish, foffset) {
	      return {
	        start: start,
	        soffset: soffset,
	        finish: finish,
	        foffset: foffset
	      };
	    };
	    var SimRange = { create: create$2 };
	
	    var adt$6 = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata$2 = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$2 = adt$6.before;
	    var on = adt$6.on;
	    var after$1 = adt$6.after;
	    var Situ = {
	      before: before$2,
	      on: on,
	      after: after$1,
	      cata: cata$2,
	      getStart: getStart
	    };
	
	    var adt$7 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$7.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return SugarElement.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, _finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, _soffset, _finish, _foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$7.domRange;
	    var relative$1 = adt$7.relative;
	    var exact = adt$7.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range$1 = SimRange.create;
	    var SimSelection = {
	      domRange: domRange,
	      relative: relative$1,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range$1
	    };
	
	    var setStart = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setStartBefore(e.dom);
	      }, function (e, o) {
	        rng.setStart(e.dom, o);
	      }, function (e) {
	        rng.setStartAfter(e.dom);
	      });
	    };
	    var setFinish = function (rng, situ) {
	      situ.fold(function (e) {
	        rng.setEndBefore(e.dom);
	      }, function (e, o) {
	        rng.setEnd(e.dom, o);
	      }, function (e) {
	        rng.setEndAfter(e.dom);
	      });
	    };
	    var relativeToNative = function (win, startSitu, finishSitu) {
	      var range = win.document.createRange();
	      setStart(range, startSitu);
	      setFinish(range, finishSitu);
	      return range;
	    };
	    var exactToNative = function (win, start, soffset, finish, foffset) {
	      var rng = win.document.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var toRect = function (rect) {
	      return {
	        left: rect.left,
	        top: rect.top,
	        right: rect.right,
	        bottom: rect.bottom,
	        width: rect.width,
	        height: rect.height
	      };
	    };
	    var getFirstRect = function (rng) {
	      var rects = rng.getClientRects();
	      var rect = rects.length > 0 ? rects[0] : rng.getBoundingClientRect();
	      return rect.width > 0 || rect.height > 0 ? Optional.some(rect).map(toRect) : Optional.none();
	    };
	
	    var adt$8 = Adt.generate([
	      {
	        ltr: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      },
	      {
	        rtl: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var fromRange = function (win, type, range) {
	      return type(SugarElement.fromDom(range.startContainer), range.startOffset, SugarElement.fromDom(range.endContainer), range.endOffset);
	    };
	    var getRanges = function (win, selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return {
	            ltr: constant(rng),
	            rtl: Optional.none
	          };
	        },
	        relative: function (startSitu, finishSitu) {
	          return {
	            ltr: cached(function () {
	              return relativeToNative(win, startSitu, finishSitu);
	            }),
	            rtl: cached(function () {
	              return Optional.some(relativeToNative(win, finishSitu, startSitu));
	            })
	          };
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return {
	            ltr: cached(function () {
	              return exactToNative(win, start, soffset, finish, foffset);
	            }),
	            rtl: cached(function () {
	              return Optional.some(exactToNative(win, finish, foffset, start, soffset));
	            })
	          };
	        }
	      });
	    };
	    var doDiagnose = function (win, ranges) {
	      var rng = ranges.ltr();
	      if (rng.collapsed) {
	        var reversed = ranges.rtl().filter(function (rev) {
	          return rev.collapsed === false;
	        });
	        return reversed.map(function (rev) {
	          return adt$8.rtl(SugarElement.fromDom(rev.endContainer), rev.endOffset, SugarElement.fromDom(rev.startContainer), rev.startOffset);
	        }).getOrThunk(function () {
	          return fromRange(win, adt$8.ltr, rng);
	        });
	      } else {
	        return fromRange(win, adt$8.ltr, rng);
	      }
	    };
	    var diagnose = function (win, selection) {
	      var ranges = getRanges(win, selection);
	      return doDiagnose(win, ranges);
	    };
	    var asLtrRange = function (win, selection) {
	      var diagnosis = diagnose(win, selection);
	      return diagnosis.match({
	        ltr: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(start.dom, soffset);
	          rng.setEnd(finish.dom, foffset);
	          return rng;
	        },
	        rtl: function (start, soffset, finish, foffset) {
	          var rng = win.document.createRange();
	          rng.setStart(finish.dom, foffset);
	          rng.setEnd(start.dom, soffset);
	          return rng;
	        }
	      });
	    };
	    var ltr = adt$8.ltr;
	    var rtl = adt$8.rtl;
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api$2 = NodeValue(isText, 'text');
	    var get$c = function (element) {
	      return api$2.get(element);
	    };
	    var getOption = function (element) {
	      return api$2.getOption(element);
	    };
	
	    var getEnd = function (element) {
	      return name(element) === 'img' ? 1 : getOption(element).fold(function () {
	        return children(element).length;
	      }, function (v) {
	        return v.length;
	      });
	    };
	    var isTextNodeWithCursorPosition = function (el) {
	      return getOption(el).filter(function (text) {
	        return text.trim().length !== 0 || text.indexOf(nbsp) > -1;
	      }).isSome();
	    };
	    var elementsWithCursorPosition = [
	      'img',
	      'br'
	    ];
	    var isCursorPosition = function (elem) {
	      var hasCursorPosition = isTextNodeWithCursorPosition(elem);
	      return hasCursorPosition || contains(elementsWithCursorPosition, name(elem));
	    };
	
	    var last$1 = function (element) {
	      return descendantRtl(element, isCursorPosition);
	    };
	    var descendantRtl = function (scope, predicate) {
	      var descend = function (element) {
	        var children$1 = children(element);
	        for (var i = children$1.length - 1; i >= 0; i--) {
	          var child = children$1[i];
	          if (predicate(child)) {
	            return Optional.some(child);
	          }
	          var res = descend(child);
	          if (res.isSome()) {
	            return res;
	          }
	        }
	        return Optional.none();
	      };
	      return descend(scope);
	    };
	
	    var descendants = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var makeRange = function (start, soffset, finish, foffset) {
	      var doc = owner(start);
	      var rng = doc.dom.createRange();
	      rng.setStart(start.dom, soffset);
	      rng.setEnd(finish.dom, foffset);
	      return rng;
	    };
	    var after$2 = function (start, soffset, finish, foffset) {
	      var r = makeRange(start, soffset, finish, foffset);
	      var same = eq$1(start, finish) && soffset === foffset;
	      return r.collapsed && !same;
	    };
	
	    var getNativeSelection = function (win) {
	      return Optional.from(win.getSelection());
	    };
	    var readRange = function (selection) {
	      if (selection.rangeCount > 0) {
	        var firstRng = selection.getRangeAt(0);
	        var lastRng = selection.getRangeAt(selection.rangeCount - 1);
	        return Optional.some(SimRange.create(SugarElement.fromDom(firstRng.startContainer), firstRng.startOffset, SugarElement.fromDom(lastRng.endContainer), lastRng.endOffset));
	      } else {
	        return Optional.none();
	      }
	    };
	    var doGetExact = function (selection) {
	      if (selection.anchorNode === null || selection.focusNode === null) {
	        return readRange(selection);
	      } else {
	        var anchor = SugarElement.fromDom(selection.anchorNode);
	        var focus_1 = SugarElement.fromDom(selection.focusNode);
	        return after$2(anchor, selection.anchorOffset, focus_1, selection.focusOffset) ? Optional.some(SimRange.create(anchor, selection.anchorOffset, focus_1, selection.focusOffset)) : readRange(selection);
	      }
	    };
	    var getExact = function (win) {
	      return getNativeSelection(win).filter(function (sel) {
	        return sel.rangeCount > 0;
	      }).bind(doGetExact);
	    };
	    var getFirstRect$1 = function (win, selection) {
	      var rng = asLtrRange(win, selection);
	      return getFirstRect(rng);
	    };
	
	    var point = function (element, offset) {
	      return {
	        element: element,
	        offset: offset
	      };
	    };
	    var descendOnce = function (element, offset) {
	      var children$1 = children(element);
	      if (children$1.length === 0) {
	        return point(element, offset);
	      } else if (offset < children$1.length) {
	        return point(children$1[offset], 0);
	      } else {
	        var last = children$1[children$1.length - 1];
	        var len = isText(last) ? get$c(last).length : children(last).length;
	        return point(last, len);
	      }
	    };
	
	    var descendOnce$1 = function (element, offset) {
	      return isText(element) ? point(element, offset) : descendOnce(element, offset);
	    };
	    var getAnchorSelection = function (win, anchorInfo) {
	      var getSelection = anchorInfo.getSelection.getOrThunk(function () {
	        return function () {
	          return getExact(win);
	        };
	      });
	      return getSelection().map(function (sel) {
	        var modStart = descendOnce$1(sel.start, sel.soffset);
	        var modFinish = descendOnce$1(sel.finish, sel.foffset);
	        return SimSelection.range(modStart.element, modStart.offset, modFinish.element, modFinish.offset);
	      });
	    };
	    var placement$3 = function (component, anchorInfo, origin) {
	      var win = defaultView(anchorInfo.root).dom;
	      var rootPoint = getRootPoint(component, origin, anchorInfo);
	      var selectionBox = getAnchorSelection(win, anchorInfo).bind(function (sel) {
	        var optRect = getFirstRect$1(win, SimSelection.exactFromRange(sel)).orThunk(function () {
	          var x = SugarElement.fromText(zeroWidth);
	          before(sel.start, x);
	          return getFirstRect$1(win, SimSelection.exact(x, 0, x, 1)).map(function (rect) {
	            remove(x);
	            return rect;
	          });
	        });
	        return optRect.bind(function (rawRect) {
	          return capRect(rawRect.left, rawRect.top, rawRect.width, rawRect.height);
	        });
	      });
	      var targetElement = getAnchorSelection(win, anchorInfo).bind(function (sel) {
	        return isElement(sel.start) ? Optional.some(sel.start) : parentNode(sel.start);
	      });
	      var elem = targetElement.getOr(component.element);
	      return calcNewAnchor(selectionBox, rootPoint, anchorInfo, origin, elem);
	    };
	    var SelectionAnchor = [
	      option('getSelection'),
	      strict$1('root'),
	      option('bubble'),
	      schema$1(),
	      defaulted$1('overrides', {}),
	      defaulted$1('showAbove', false),
	      output('placement', placement$3)
	    ];
	
	    var eastX$1 = function (anchor) {
	      return anchor.x + anchor.width;
	    };
	    var westX$1 = function (anchor, element) {
	      return anchor.x - element.width;
	    };
	    var northY$1 = function (anchor, element) {
	      return anchor.y - element.height + anchor.height;
	    };
	    var southY$1 = function (anchor) {
	      return anchor.y;
	    };
	    var southeast$2 = function (anchor, element, bubbles) {
	      return nu$7(eastX$1(anchor), southY$1(anchor), bubbles.southeast(), southeast(), boundsRestriction(anchor, {
	        left: 0,
	        top: 2
	      }), 'link-layout-se');
	    };
	    var southwest$2 = function (anchor, element, bubbles) {
	      return nu$7(westX$1(anchor, element), southY$1(anchor), bubbles.southwest(), southwest(), boundsRestriction(anchor, {
	        right: 1,
	        top: 2
	      }), 'link-layout-sw');
	    };
	    var northeast$2 = function (anchor, element, bubbles) {
	      return nu$7(eastX$1(anchor), northY$1(anchor, element), bubbles.northeast(), northeast(), boundsRestriction(anchor, {
	        left: 0,
	        bottom: 3
	      }), 'link-layout-ne');
	    };
	    var northwest$2 = function (anchor, element, bubbles) {
	      return nu$7(westX$1(anchor, element), northY$1(anchor, element), bubbles.northwest(), northwest(), boundsRestriction(anchor, {
	        right: 1,
	        bottom: 3
	      }), 'link-layout-nw');
	    };
	    var all$3 = function () {
	      return [
	        southeast$2,
	        southwest$2,
	        northeast$2,
	        northwest$2
	      ];
	    };
	    var allRtl$1 = function () {
	      return [
	        southwest$2,
	        southeast$2,
	        northwest$2,
	        northeast$2
	      ];
	    };
	
	    var placement$4 = function (component, submenuInfo, origin) {
	      var anchorBox = toBox(origin, submenuInfo.item.element);
	      var layouts = get$b(component.element, submenuInfo, all$3(), allRtl$1(), all$3(), allRtl$1(), Optional.none());
	      return Optional.some(nu$9({
	        anchorBox: anchorBox,
	        bubble: fallback(),
	        overrides: submenuInfo.overrides,
	        layouts: layouts,
	        placer: Optional.none()
	      }));
	    };
	    var SubmenuAnchor = [
	      strict$1('item'),
	      schema$1(),
	      defaulted$1('overrides', {}),
	      output('placement', placement$4)
	    ];
	
	    var AnchorSchema = choose$1('anchor', {
	      selection: SelectionAnchor,
	      node: NodeAnchor,
	      hotspot: HotspotAnchor,
	      submenu: SubmenuAnchor,
	      makeshift: MakeshiftAnchor
	    });
	
	    var getFixedOrigin = function () {
	      var html = document.documentElement;
	      return fixed(0, 0, html.clientWidth, html.clientHeight);
	    };
	    var getRelativeOrigin = function (component) {
	      var position = absolute(component.element);
	      var bounds = component.element.dom.getBoundingClientRect();
	      return relative(position.left, position.top, bounds.width, bounds.height);
	    };
	    var place = function (component, origin, anchoring, getBounds, placee) {
	      var anchor = box$1(anchoring.anchorBox, origin);
	      simple(anchor, placee.element, anchoring.bubble, anchoring.layouts, getBounds, anchoring.overrides);
	    };
	    var position$1 = function (component, posConfig, posState, anchor, placee) {
	      positionWithin(component, posConfig, posState, anchor, placee, Optional.none());
	    };
	    var positionWithin = function (component, posConfig, posState, anchor, placee, boxElement) {
	      var boundsBox = boxElement.map(box);
	      return positionWithinBounds(component, posConfig, posState, anchor, placee, boundsBox);
	    };
	    var positionWithinBounds = function (component, posConfig, posState, anchor, placee, bounds) {
	      var anchorage = asRawOrDie('positioning anchor.info', AnchorSchema, anchor);
	      preserve(function () {
	        set$2(placee.element, 'position', 'fixed');
	        var oldVisibility = getRaw(placee.element, 'visibility');
	        set$2(placee.element, 'visibility', 'hidden');
	        var origin = posConfig.useFixed() ? getFixedOrigin() : getRelativeOrigin(component);
	        var placer = anchorage.placement;
	        var getBounds = bounds.map(constant).or(posConfig.getBounds);
	        placer(component, anchorage, origin).each(function (anchoring) {
	          var doPlace = anchoring.placer.getOr(place);
	          doPlace(component, origin, anchoring, getBounds, placee);
	        });
	        oldVisibility.fold(function () {
	          remove$6(placee.element, 'visibility');
	        }, function (vis) {
	          set$2(placee.element, 'visibility', vis);
	        });
	        if (getRaw(placee.element, 'left').isNone() && getRaw(placee.element, 'top').isNone() && getRaw(placee.element, 'right').isNone() && getRaw(placee.element, 'bottom').isNone() && getRaw(placee.element, 'position').is('fixed')) {
	          remove$6(placee.element, 'position');
	        }
	      }, placee.element);
	    };
	    var getMode = function (component, pConfig, _pState) {
	      return pConfig.useFixed() ? 'fixed' : 'absolute';
	    };
	
	    var PositionApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        position: position$1,
	        positionWithin: positionWithin,
	        positionWithinBounds: positionWithinBounds,
	        getMode: getMode
	    });
	
	    var PositionSchema = [
	      defaulted$1('useFixed', never),
	      option('getBounds')
	    ];
	
	    var Positioning = create$1({
	      fields: PositionSchema,
	      name: 'positioning',
	      active: ActivePosition,
	      apis: PositionApis
	    });
	
	    var fireDetaching = function (component) {
	      emit(component, detachedFromDom());
	      var children = component.components();
	      each(children, fireDetaching);
	    };
	    var fireAttaching = function (component) {
	      var children = component.components();
	      each(children, fireAttaching);
	      emit(component, attachedToDom());
	    };
	    var attach = function (parent, child) {
	      append(parent.element, child.element);
	    };
	    var detachChildren = function (component) {
	      each(component.components(), function (childComp) {
	        return remove(childComp.element);
	      });
	      empty(component.element);
	      component.syncComponents();
	    };
	    var replaceChildren = function (component, newChildren) {
	      var subs = component.components();
	      detachChildren(component);
	      var deleted = difference(subs, newChildren);
	      each(deleted, function (comp) {
	        fireDetaching(comp);
	        component.getSystem().removeFromWorld(comp);
	      });
	      each(newChildren, function (childComp) {
	        if (!childComp.getSystem().isConnected()) {
	          component.getSystem().addToWorld(childComp);
	          attach(component, childComp);
	          if (inBody(component.element)) {
	            fireAttaching(childComp);
	          }
	        } else {
	          attach(component, childComp);
	        }
	        component.syncComponents();
	      });
	    };
	
	    var attach$1 = function (parent, child) {
	      attachWith(parent, child, append);
	    };
	    var attachWith = function (parent, child, insertion) {
	      parent.getSystem().addToWorld(child);
	      insertion(parent.element, child.element);
	      if (inBody(parent.element)) {
	        fireAttaching(child);
	      }
	      parent.syncComponents();
	    };
	    var doDetach = function (component) {
	      fireDetaching(component);
	      remove(component.element);
	      component.getSystem().removeFromWorld(component);
	    };
	    var detach = function (component) {
	      var parent$1 = parent(component.element).bind(function (p) {
	        return component.getSystem().getByDom(p).toOptional();
	      });
	      doDetach(component);
	      parent$1.each(function (p) {
	        p.syncComponents();
	      });
	    };
	    var detachChildren$1 = function (component) {
	      var subs = component.components();
	      each(subs, doDetach);
	      empty(component.element);
	      component.syncComponents();
	    };
	    var attachSystem = function (element, guiSystem) {
	      attachSystemWith(element, guiSystem, append);
	    };
	    var attachSystemAfter = function (element, guiSystem) {
	      attachSystemWith(element, guiSystem, after);
	    };
	    var attachSystemWith = function (element, guiSystem, inserter) {
	      inserter(element, guiSystem.element);
	      var children$1 = children(guiSystem.element);
	      each(children$1, function (child) {
	        guiSystem.getByDom(child).each(fireAttaching);
	      });
	    };
	    var detachSystem = function (guiSystem) {
	      var children$1 = children(guiSystem.element);
	      each(children$1, function (child) {
	        guiSystem.getByDom(child).each(fireDetaching);
	      });
	      remove(guiSystem.element);
	    };
	
	    var rebuild = function (sandbox, sConfig, sState, data) {
	      sState.get().each(function (_data) {
	        detachChildren$1(sandbox);
	      });
	      var point = sConfig.getAttachPoint(sandbox);
	      attach$1(point, sandbox);
	      var built = sandbox.getSystem().build(data);
	      attach$1(sandbox, built);
	      sState.set(built);
	      return built;
	    };
	    var open = function (sandbox, sConfig, sState, data) {
	      var newState = rebuild(sandbox, sConfig, sState, data);
	      sConfig.onOpen(sandbox, newState);
	      return newState;
	    };
	    var setContent = function (sandbox, sConfig, sState, data) {
	      return sState.get().map(function () {
	        return rebuild(sandbox, sConfig, sState, data);
	      });
	    };
	    var openWhileCloaked = function (sandbox, sConfig, sState, data, transaction) {
	      cloak(sandbox, sConfig);
	      open(sandbox, sConfig, sState, data);
	      transaction();
	      decloak(sandbox, sConfig);
	    };
	    var close = function (sandbox, sConfig, sState) {
	      sState.get().each(function (data) {
	        detachChildren$1(sandbox);
	        detach(sandbox);
	        sConfig.onClose(sandbox, data);
	        sState.clear();
	      });
	    };
	    var isOpen = function (_sandbox, _sConfig, sState) {
	      return sState.isOpen();
	    };
	    var isPartOf$1 = function (sandbox, sConfig, sState, queryElem) {
	      return isOpen(sandbox, sConfig, sState) && sState.get().exists(function (data) {
	        return sConfig.isPartOf(sandbox, data, queryElem);
	      });
	    };
	    var getState = function (_sandbox, _sConfig, sState) {
	      return sState.get();
	    };
	    var store = function (sandbox, cssKey, attr, newValue) {
	      getRaw(sandbox.element, cssKey).fold(function () {
	        remove$1(sandbox.element, attr);
	      }, function (v) {
	        set$1(sandbox.element, attr, v);
	      });
	      set$2(sandbox.element, cssKey, newValue);
	    };
	    var restore = function (sandbox, cssKey, attr) {
	      getOpt(sandbox.element, attr).fold(function () {
	        return remove$6(sandbox.element, cssKey);
	      }, function (oldValue) {
	        return set$2(sandbox.element, cssKey, oldValue);
	      });
	    };
	    var cloak = function (sandbox, sConfig, _sState) {
	      var sink = sConfig.getAttachPoint(sandbox);
	      set$2(sandbox.element, 'position', Positioning.getMode(sink));
	      store(sandbox, 'visibility', sConfig.cloakVisibilityAttr, 'hidden');
	    };
	    var hasPosition = function (element) {
	      return exists([
	        'top',
	        'left',
	        'right',
	        'bottom'
	      ], function (pos) {
	        return getRaw(element, pos).isSome();
	      });
	    };
	    var decloak = function (sandbox, sConfig, _sState) {
	      if (!hasPosition(sandbox.element)) {
	        remove$6(sandbox.element, 'position');
	      }
	      restore(sandbox, 'visibility', sConfig.cloakVisibilityAttr);
	    };
	
	    var SandboxApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        cloak: cloak,
	        decloak: decloak,
	        open: open,
	        openWhileCloaked: openWhileCloaked,
	        close: close,
	        isOpen: isOpen,
	        isPartOf: isPartOf$1,
	        getState: getState,
	        setContent: setContent
	    });
	
	    var events$2 = function (sandboxConfig, sandboxState) {
	      return derive([run(sandboxClose(), function (sandbox, _simulatedEvent) {
	          close(sandbox, sandboxConfig, sandboxState);
	        })]);
	    };
	
	    var ActiveSandbox = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$2
	    });
	
	    var SandboxSchema = [
	      onHandler('onOpen'),
	      onHandler('onClose'),
	      strict$1('isPartOf'),
	      strict$1('getAttachPoint'),
	      defaulted$1('cloakVisibilityAttr', 'data-precloak-visibility')
	    ];
	
	    var init = function () {
	      var contents = Cell(Optional.none());
	      var readState = constant('not-implemented');
	      var isOpen = function () {
	        return contents.get().isSome();
	      };
	      var set = function (comp) {
	        contents.set(Optional.some(comp));
	      };
	      var get = function () {
	        return contents.get();
	      };
	      var clear = function () {
	        contents.set(Optional.none());
	      };
	      return nu$5({
	        readState: readState,
	        isOpen: isOpen,
	        clear: clear,
	        set: set,
	        get: get
	      });
	    };
	
	    var SandboxState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init
	    });
	
	    var Sandboxing = create$1({
	      fields: SandboxSchema,
	      name: 'sandboxing',
	      active: ActiveSandbox,
	      apis: SandboxApis,
	      state: SandboxState
	    });
	
	    var dismissPopups = constant('dismiss.popups');
	    var repositionPopups = constant('reposition.popups');
	    var mouseReleased = constant('mouse.released');
	
	    var schema$2 = objOfOnly([
	      defaulted$1('isExtraPart', never),
	      optionObjOf('fireEventInstead', [defaulted$1('event', dismissRequested())])
	    ]);
	    var receivingChannel = function (rawSpec) {
	      var _a;
	      var detail = asRawOrDie('Dismissal', schema$2, rawSpec);
	      return _a = {}, _a[dismissPopups()] = {
	        schema: objOfOnly([strict$1('target')]),
	        onReceive: function (sandbox, data) {
	          if (Sandboxing.isOpen(sandbox)) {
	            var isPart = Sandboxing.isPartOf(sandbox, data.target) || detail.isExtraPart(sandbox, data.target);
	            if (!isPart) {
	              detail.fireEventInstead.fold(function () {
	                return Sandboxing.close(sandbox);
	              }, function (fe) {
	                return emit(sandbox, fe.event);
	              });
	            }
	          }
	        }
	      }, _a;
	    };
	
	    var schema$3 = objOfOnly([
	      optionObjOf('fireEventInstead', [defaulted$1('event', repositionRequested())]),
	      strictFunction('doReposition')
	    ]);
	    var receivingChannel$1 = function (rawSpec) {
	      var _a;
	      var detail = asRawOrDie('Reposition', schema$3, rawSpec);
	      return _a = {}, _a[repositionPopups()] = {
	        onReceive: function (sandbox) {
	          if (Sandboxing.isOpen(sandbox)) {
	            detail.fireEventInstead.fold(function () {
	              return detail.doReposition(sandbox);
	            }, function (fe) {
	              return emit(sandbox, fe.event);
	            });
	          }
	        }
	      }, _a;
	    };
	
	    var onLoad = function (component, repConfig, repState) {
	      repConfig.store.manager.onLoad(component, repConfig, repState);
	    };
	    var onUnload = function (component, repConfig, repState) {
	      repConfig.store.manager.onUnload(component, repConfig, repState);
	    };
	    var setValue = function (component, repConfig, repState, data) {
	      repConfig.store.manager.setValue(component, repConfig, repState, data);
	    };
	    var getValue = function (component, repConfig, repState) {
	      return repConfig.store.manager.getValue(component, repConfig, repState);
	    };
	    var getState$1 = function (component, repConfig, repState) {
	      return repState;
	    };
	
	    var RepresentApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        onLoad: onLoad,
	        onUnload: onUnload,
	        setValue: setValue,
	        getValue: getValue,
	        getState: getState$1
	    });
	
	    var events$3 = function (repConfig, repState) {
	      var es = repConfig.resetOnDom ? [
	        runOnAttached(function (comp, _se) {
	          onLoad(comp, repConfig, repState);
	        }),
	        runOnDetached(function (comp, _se) {
	          onUnload(comp, repConfig, repState);
	        })
	      ] : [loadEvent(repConfig, repState, onLoad)];
	      return derive(es);
	    };
	
	    var ActiveRepresenting = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$3
	    });
	
	    var memory = function () {
	      var data = Cell(null);
	      var readState = function () {
	        return {
	          mode: 'memory',
	          value: data.get()
	        };
	      };
	      var isNotSet = function () {
	        return data.get() === null;
	      };
	      var clear = function () {
	        data.set(null);
	      };
	      return nu$5({
	        set: data.set,
	        get: data.get,
	        isNotSet: isNotSet,
	        clear: clear,
	        readState: readState
	      });
	    };
	    var manual = function () {
	      var readState = noop;
	      return nu$5({ readState: readState });
	    };
	    var dataset = function () {
	      var dataByValue = Cell({});
	      var dataByText = Cell({});
	      var readState = function () {
	        return {
	          mode: 'dataset',
	          dataByValue: dataByValue.get(),
	          dataByText: dataByText.get()
	        };
	      };
	      var clear = function () {
	        dataByValue.set({});
	        dataByText.set({});
	      };
	      var lookup = function (itemString) {
	        return get$1(dataByValue.get(), itemString).orThunk(function () {
	          return get$1(dataByText.get(), itemString);
	        });
	      };
	      var update = function (items) {
	        var currentDataByValue = dataByValue.get();
	        var currentDataByText = dataByText.get();
	        var newDataByValue = {};
	        var newDataByText = {};
	        each(items, function (item) {
	          newDataByValue[item.value] = item;
	          get$1(item, 'meta').each(function (meta) {
	            get$1(meta, 'text').each(function (text) {
	              newDataByText[text] = item;
	            });
	          });
	        });
	        dataByValue.set(__assign(__assign({}, currentDataByValue), newDataByValue));
	        dataByText.set(__assign(__assign({}, currentDataByText), newDataByText));
	      };
	      return nu$5({
	        readState: readState,
	        lookup: lookup,
	        update: update,
	        clear: clear
	      });
	    };
	    var init$1 = function (spec) {
	      return spec.store.manager.state(spec);
	    };
	
	    var RepresentState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        memory: memory,
	        dataset: dataset,
	        manual: manual,
	        init: init$1
	    });
	
	    var setValue$1 = function (component, repConfig, repState, data) {
	      var store = repConfig.store;
	      repState.update([data]);
	      store.setValue(component, data);
	      repConfig.onSetValue(component, data);
	    };
	    var getValue$1 = function (component, repConfig, repState) {
	      var store = repConfig.store;
	      var key = store.getDataKey(component);
	      return repState.lookup(key).fold(function () {
	        return store.getFallbackEntry(key);
	      }, function (data) {
	        return data;
	      });
	    };
	    var onLoad$1 = function (component, repConfig, repState) {
	      var store = repConfig.store;
	      store.initialValue.each(function (data) {
	        setValue$1(component, repConfig, repState, data);
	      });
	    };
	    var onUnload$1 = function (component, repConfig, repState) {
	      repState.clear();
	    };
	    var DatasetStore = [
	      option('initialValue'),
	      strict$1('getFallbackEntry'),
	      strict$1('getDataKey'),
	      strict$1('setValue'),
	      output('manager', {
	        setValue: setValue$1,
	        getValue: getValue$1,
	        onLoad: onLoad$1,
	        onUnload: onUnload$1,
	        state: dataset
	      })
	    ];
	
	    var getValue$2 = function (component, repConfig, _repState) {
	      return repConfig.store.getValue(component);
	    };
	    var setValue$2 = function (component, repConfig, _repState, data) {
	      repConfig.store.setValue(component, data);
	      repConfig.onSetValue(component, data);
	    };
	    var onLoad$2 = function (component, repConfig, _repState) {
	      repConfig.store.initialValue.each(function (data) {
	        repConfig.store.setValue(component, data);
	      });
	    };
	    var ManualStore = [
	      strict$1('getValue'),
	      defaulted$1('setValue', noop),
	      option('initialValue'),
	      output('manager', {
	        setValue: setValue$2,
	        getValue: getValue$2,
	        onLoad: onLoad$2,
	        onUnload: noop,
	        state: NoState.init
	      })
	    ];
	
	    var setValue$3 = function (component, repConfig, repState, data) {
	      repState.set(data);
	      repConfig.onSetValue(component, data);
	    };
	    var getValue$3 = function (component, repConfig, repState) {
	      return repState.get();
	    };
	    var onLoad$3 = function (component, repConfig, repState) {
	      repConfig.store.initialValue.each(function (initVal) {
	        if (repState.isNotSet()) {
	          repState.set(initVal);
	        }
	      });
	    };
	    var onUnload$2 = function (component, repConfig, repState) {
	      repState.clear();
	    };
	    var MemoryStore = [
	      option('initialValue'),
	      output('manager', {
	        setValue: setValue$3,
	        getValue: getValue$3,
	        onLoad: onLoad$3,
	        onUnload: onUnload$2,
	        state: memory
	      })
	    ];
	
	    var RepresentSchema = [
	      defaultedOf('store', { mode: 'memory' }, choose$1('mode', {
	        memory: MemoryStore,
	        manual: ManualStore,
	        dataset: DatasetStore
	      })),
	      onHandler('onSetValue'),
	      defaulted$1('resetOnDom', false)
	    ];
	
	    var Representing = create$1({
	      fields: RepresentSchema,
	      name: 'representing',
	      active: ActiveRepresenting,
	      apis: RepresentApis,
	      extra: {
	        setValueFrom: function (component, source) {
	          var value = Representing.getValue(source);
	          Representing.setValue(component, value);
	        }
	      },
	      state: RepresentState
	    });
	
	    var field$1 = function (name, forbidden) {
	      return defaultedObjOf(name, {}, map(forbidden, function (f) {
	        return forbid(f.name(), 'Cannot configure ' + f.name() + ' for ' + name);
	      }).concat([state$1('dump', identity)]));
	    };
	    var get$d = function (data) {
	      return data.dump;
	    };
	    var augment = function (data, original) {
	      return __assign(__assign({}, data.dump), derive$1(original));
	    };
	    var SketchBehaviours = {
	      field: field$1,
	      augment: augment,
	      get: get$d
	    };
	
	    var _placeholder = 'placeholder';
	    var adt$9 = Adt.generate([
	      {
	        single: [
	          'required',
	          'valueThunk'
	        ]
	      },
	      {
	        multiple: [
	          'required',
	          'valueThunks'
	        ]
	      }
	    ]);
	    var isSubstituted = function (spec) {
	      return has(spec, 'uiType');
	    };
	    var subPlaceholder = function (owner, detail, compSpec, placeholders) {
	      if (owner.exists(function (o) {
	          return o !== compSpec.owner;
	        })) {
	        return adt$9.single(true, constant(compSpec));
	      }
	      return get$1(placeholders, compSpec.name).fold(function () {
	        throw new Error('Unknown placeholder component: ' + compSpec.name + '\nKnown: [' + keys(placeholders) + ']\nNamespace: ' + owner.getOr('none') + '\nSpec: ' + JSON.stringify(compSpec, null, 2));
	      }, function (newSpec) {
	        return newSpec.replace();
	      });
	    };
	    var scan = function (owner, detail, compSpec, placeholders) {
	      if (isSubstituted(compSpec) && compSpec.uiType === _placeholder) {
	        return subPlaceholder(owner, detail, compSpec, placeholders);
	      } else {
	        return adt$9.single(false, constant(compSpec));
	      }
	    };
	    var substitute = function (owner, detail, compSpec, placeholders) {
	      var base = scan(owner, detail, compSpec, placeholders);
	      return base.fold(function (req, valueThunk) {
	        var value = isSubstituted(compSpec) ? valueThunk(detail, compSpec.config, compSpec.validated) : valueThunk(detail);
	        var childSpecs = get$1(value, 'components').getOr([]);
	        var substituted = bind(childSpecs, function (c) {
	          return substitute(owner, detail, c, placeholders);
	        });
	        return [__assign(__assign({}, value), { components: substituted })];
	      }, function (req, valuesThunk) {
	        if (isSubstituted(compSpec)) {
	          var values = valuesThunk(detail, compSpec.config, compSpec.validated);
	          var preprocessor = compSpec.validated.preprocess.getOr(identity);
	          return preprocessor(values);
	        } else {
	          return valuesThunk(detail);
	        }
	      });
	    };
	    var substituteAll = function (owner, detail, components, placeholders) {
	      return bind(components, function (c) {
	        return substitute(owner, detail, c, placeholders);
	      });
	    };
	    var oneReplace = function (label, replacements) {
	      var called = false;
	      var used = function () {
	        return called;
	      };
	      var replace = function () {
	        if (called) {
	          throw new Error('Trying to use the same placeholder more than once: ' + label);
	        }
	        called = true;
	        return replacements;
	      };
	      var required = function () {
	        return replacements.fold(function (req, _) {
	          return req;
	        }, function (req, _) {
	          return req;
	        });
	      };
	      return {
	        name: constant(label),
	        required: required,
	        used: used,
	        replace: replace
	      };
	    };
	    var substitutePlaces = function (owner, detail, components, placeholders) {
	      var ps = map$2(placeholders, function (ph, name) {
	        return oneReplace(name, ph);
	      });
	      var outcome = substituteAll(owner, detail, components, ps);
	      each$1(ps, function (p) {
	        if (p.used() === false && p.required()) {
	          throw new Error('Placeholder: ' + p.name() + ' was not found in components list\nNamespace: ' + owner.getOr('none') + '\nComponents: ' + JSON.stringify(detail.components, null, 2));
	        }
	      });
	      return outcome;
	    };
	    var single = adt$9.single;
	    var multiple = adt$9.multiple;
	    var placeholder = constant(_placeholder);
	
	    var adt$a = Adt.generate([
	      { required: ['data'] },
	      { external: ['data'] },
	      { optional: ['data'] },
	      { group: ['data'] }
	    ]);
	    var fFactory = defaulted$1('factory', { sketch: identity });
	    var fSchema = defaulted$1('schema', []);
	    var fName = strict$1('name');
	    var fPname = field('pname', 'pname', defaultedThunk(function (typeSpec) {
	      return '<alloy.' + generate$1(typeSpec.name) + '>';
	    }), anyValue$1());
	    var fGroupSchema = state$1('schema', function () {
	      return [option('preprocess')];
	    });
	    var fDefaults = defaulted$1('defaults', constant({}));
	    var fOverrides = defaulted$1('overrides', constant({}));
	    var requiredSpec = objOf([
	      fFactory,
	      fSchema,
	      fName,
	      fPname,
	      fDefaults,
	      fOverrides
	    ]);
	    var externalSpec = objOf([
	      fFactory,
	      fSchema,
	      fName,
	      fDefaults,
	      fOverrides
	    ]);
	    var optionalSpec = objOf([
	      fFactory,
	      fSchema,
	      fName,
	      fPname,
	      fDefaults,
	      fOverrides
	    ]);
	    var groupSpec = objOf([
	      fFactory,
	      fGroupSchema,
	      fName,
	      strict$1('unit'),
	      fPname,
	      fDefaults,
	      fOverrides
	    ]);
	    var asNamedPart = function (part) {
	      return part.fold(Optional.some, Optional.none, Optional.some, Optional.some);
	    };
	    var name$1 = function (part) {
	      var get = function (data) {
	        return data.name;
	      };
	      return part.fold(get, get, get, get);
	    };
	    var asCommon = function (part) {
	      return part.fold(identity, identity, identity, identity);
	    };
	    var convert = function (adtConstructor, partSchema) {
	      return function (spec) {
	        var data = asRawOrDie('Converting part type', partSchema, spec);
	        return adtConstructor(data);
	      };
	    };
	    var required = convert(adt$a.required, requiredSpec);
	    var external$1 = convert(adt$a.external, externalSpec);
	    var optional = convert(adt$a.optional, optionalSpec);
	    var group = convert(adt$a.group, groupSpec);
	    var original = constant('entirety');
	
	    var PartType = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        required: required,
	        external: external$1,
	        optional: optional,
	        group: group,
	        asNamedPart: asNamedPart,
	        name: name$1,
	        asCommon: asCommon,
	        original: original
	    });
	
	    var combine$2 = function (detail, data, partSpec, partValidated) {
	      return deepMerge(data.defaults(detail, partSpec, partValidated), partSpec, { uid: detail.partUids[data.name] }, data.overrides(detail, partSpec, partValidated));
	    };
	    var subs = function (owner, detail, parts) {
	      var internals = {};
	      var externals = {};
	      each(parts, function (part) {
	        part.fold(function (data) {
	          internals[data.pname] = single(true, function (detail, partSpec, partValidated) {
	            return data.factory.sketch(combine$2(detail, data, partSpec, partValidated));
	          });
	        }, function (data) {
	          var partSpec = detail.parts[data.name];
	          externals[data.name] = constant(data.factory.sketch(combine$2(detail, data, partSpec[original()]), partSpec));
	        }, function (data) {
	          internals[data.pname] = single(false, function (detail, partSpec, partValidated) {
	            return data.factory.sketch(combine$2(detail, data, partSpec, partValidated));
	          });
	        }, function (data) {
	          internals[data.pname] = multiple(true, function (detail, _partSpec, _partValidated) {
	            var units = detail[data.name];
	            return map(units, function (u) {
	              return data.factory.sketch(deepMerge(data.defaults(detail, u, _partValidated), u, data.overrides(detail, u)));
	            });
	          });
	        });
	      });
	      return {
	        internals: constant(internals),
	        externals: constant(externals)
	      };
	    };
	
	    var generate$4 = function (owner, parts) {
	      var r = {};
	      each(parts, function (part) {
	        asNamedPart(part).each(function (np) {
	          var g = doGenerateOne(owner, np.pname);
	          r[np.name] = function (config) {
	            var validated = asRawOrDie('Part: ' + np.name + ' in ' + owner, objOf(np.schema), config);
	            return __assign(__assign({}, g), {
	              config: config,
	              validated: validated
	            });
	          };
	        });
	      });
	      return r;
	    };
	    var doGenerateOne = function (owner, pname) {
	      return {
	        uiType: placeholder(),
	        owner: owner,
	        name: pname
	      };
	    };
	    var generateOne = function (owner, pname, config) {
	      return {
	        uiType: placeholder(),
	        owner: owner,
	        name: pname,
	        config: config,
	        validated: {}
	      };
	    };
	    var schemas = function (parts) {
	      return bind(parts, function (part) {
	        return part.fold(Optional.none, Optional.some, Optional.none, Optional.none).map(function (data) {
	          return strictObjOf(data.name, data.schema.concat([snapshot(original())]));
	        }).toArray();
	      });
	    };
	    var names = function (parts) {
	      return map(parts, name$1);
	    };
	    var substitutes = function (owner, detail, parts) {
	      return subs(owner, detail, parts);
	    };
	    var components = function (owner, detail, internals) {
	      return substitutePlaces(Optional.some(owner), detail, detail.components, internals);
	    };
	    var getPart = function (component, detail, partKey) {
	      var uid = detail.partUids[partKey];
	      return component.getSystem().getByUid(uid).toOptional();
	    };
	    var getPartOrDie = function (component, detail, partKey) {
	      return getPart(component, detail, partKey).getOrDie('Could not find part: ' + partKey);
	    };
	    var getParts = function (component, detail, partKeys) {
	      var r = {};
	      var uids = detail.partUids;
	      var system = component.getSystem();
	      each(partKeys, function (pk) {
	        r[pk] = constant(system.getByUid(uids[pk]));
	      });
	      return r;
	    };
	    var getAllParts = function (component, detail) {
	      var system = component.getSystem();
	      return map$2(detail.partUids, function (pUid, _k) {
	        return constant(system.getByUid(pUid));
	      });
	    };
	    var getAllPartNames = function (detail) {
	      return keys(detail.partUids);
	    };
	    var getPartsOrDie = function (component, detail, partKeys) {
	      var r = {};
	      var uids = detail.partUids;
	      var system = component.getSystem();
	      each(partKeys, function (pk) {
	        r[pk] = constant(system.getByUid(uids[pk]).getOrDie());
	      });
	      return r;
	    };
	    var defaultUids = function (baseUid, partTypes) {
	      var partNames = names(partTypes);
	      return wrapAll$1(map(partNames, function (pn) {
	        return {
	          key: pn,
	          value: baseUid + '-' + pn
	        };
	      }));
	    };
	    var defaultUidsSchema = function (partTypes) {
	      return field('partUids', 'partUids', mergeWithThunk(function (spec) {
	        return defaultUids(spec.uid, partTypes);
	      }), anyValue$1());
	    };
	
	    var AlloyParts = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        generate: generate$4,
	        generateOne: generateOne,
	        schemas: schemas,
	        names: names,
	        substitutes: substitutes,
	        components: components,
	        defaultUids: defaultUids,
	        defaultUidsSchema: defaultUidsSchema,
	        getAllParts: getAllParts,
	        getAllPartNames: getAllPartNames,
	        getPart: getPart,
	        getPartOrDie: getPartOrDie,
	        getParts: getParts,
	        getPartsOrDie: getPartsOrDie
	    });
	
	    var base = function (partSchemas, partUidsSchemas) {
	      var ps = partSchemas.length > 0 ? [strictObjOf('parts', partSchemas)] : [];
	      return ps.concat([
	        strict$1('uid'),
	        defaulted$1('dom', {}),
	        defaulted$1('components', []),
	        snapshot('originalSpec'),
	        defaulted$1('debug.sketcher', {})
	      ]).concat(partUidsSchemas);
	    };
	    var asRawOrDie$1 = function (label, schema, spec, partSchemas, partUidsSchemas) {
	      var baseS = base(partSchemas, partUidsSchemas);
	      return asRawOrDie(label + ' [SpecSchema]', objOfOnly(baseS.concat(schema)), spec);
	    };
	
	    var single$1 = function (owner, schema, factory, spec) {
	      var specWithUid = supplyUid(spec);
	      var detail = asRawOrDie$1(owner, schema, specWithUid, [], []);
	      return factory(detail, specWithUid);
	    };
	    var composite = function (owner, schema, partTypes, factory, spec) {
	      var specWithUid = supplyUid(spec);
	      var partSchemas = schemas(partTypes);
	      var partUidsSchema = defaultUidsSchema(partTypes);
	      var detail = asRawOrDie$1(owner, schema, specWithUid, partSchemas, [partUidsSchema]);
	      var subs = substitutes(owner, detail, partTypes);
	      var components$1 = components(owner, detail, subs.internals());
	      return factory(detail, components$1, specWithUid, subs.externals());
	    };
	    var hasUid = function (spec) {
	      return has(spec, 'uid');
	    };
	    var supplyUid = function (spec) {
	      return hasUid(spec) ? spec : __assign(__assign({}, spec), { uid: generate$2('uid') });
	    };
	
	    var isSketchSpec = function (spec) {
	      return spec.uid !== undefined;
	    };
	    var singleSchema = objOfOnly([
	      strict$1('name'),
	      strict$1('factory'),
	      strict$1('configFields'),
	      defaulted$1('apis', {}),
	      defaulted$1('extraApis', {})
	    ]);
	    var compositeSchema = objOfOnly([
	      strict$1('name'),
	      strict$1('factory'),
	      strict$1('configFields'),
	      strict$1('partFields'),
	      defaulted$1('apis', {}),
	      defaulted$1('extraApis', {})
	    ]);
	    var single$2 = function (rawConfig) {
	      var config = asRawOrDie('Sketcher for ' + rawConfig.name, singleSchema, rawConfig);
	      var sketch = function (spec) {
	        return single$1(config.name, config.configFields, config.factory, spec);
	      };
	      var apis = map$2(config.apis, makeApi);
	      var extraApis = map$2(config.extraApis, function (f, k) {
	        return markAsExtraApi(f, k);
	      });
	      return __assign(__assign({
	        name: config.name,
	        configFields: config.configFields,
	        sketch: sketch
	      }, apis), extraApis);
	    };
	    var composite$1 = function (rawConfig) {
	      var config = asRawOrDie('Sketcher for ' + rawConfig.name, compositeSchema, rawConfig);
	      var sketch = function (spec) {
	        return composite(config.name, config.configFields, config.partFields, config.factory, spec);
	      };
	      var parts = generate$4(config.name, config.partFields);
	      var apis = map$2(config.apis, makeApi);
	      var extraApis = map$2(config.extraApis, function (f, k) {
	        return markAsExtraApi(f, k);
	      });
	      return __assign(__assign({
	        name: config.name,
	        partFields: config.partFields,
	        configFields: config.configFields,
	        sketch: sketch,
	        parts: parts
	      }, apis), extraApis);
	    };
	
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var sequence = function (arr) {
	      var r = [];
	      for (var i = 0; i < arr.length; i++) {
	        var x = arr[i];
	        if (x.isSome()) {
	          r.push(x.getOrDie());
	        } else {
	          return Optional.none();
	        }
	      }
	      return Optional.some(r);
	    };
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	    var lift3 = function (oa, ob, oc, f) {
	      return oa.isSome() && ob.isSome() && oc.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Optional.none();
	    };
	    var mapFrom = function (a, f) {
	      return a !== undefined && a !== null ? Optional.some(f(a)) : Optional.none();
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var inside = function (target) {
	      return name(target) === 'input' && get$3(target, 'type') !== 'radio' || name(target) === 'textarea';
	    };
	
	    var getCurrent = function (component, composeConfig, _composeState) {
	      return composeConfig.find(component);
	    };
	
	    var ComposeApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getCurrent: getCurrent
	    });
	
	    var ComposeSchema = [strict$1('find')];
	
	    var Composing = create$1({
	      fields: ComposeSchema,
	      name: 'composing',
	      apis: ComposeApis
	    });
	
	    var dehighlightAllExcept = function (component, hConfig, hState, skip) {
	      var highlighted = descendants(component.element, '.' + hConfig.highlightClass);
	      each(highlighted, function (h) {
	        if (!exists(skip, function (skipComp) {
	            return skipComp.element === h;
	          })) {
	          remove$4(h, hConfig.highlightClass);
	          component.getSystem().getByDom(h).each(function (target) {
	            hConfig.onDehighlight(component, target);
	            emit(target, dehighlight());
	          });
	        }
	      });
	    };
	    var dehighlightAll = function (component, hConfig, hState) {
	      return dehighlightAllExcept(component, hConfig, hState, []);
	    };
	    var dehighlight$1 = function (component, hConfig, hState, target) {
	      if (isHighlighted(component, hConfig, hState, target)) {
	        remove$4(target.element, hConfig.highlightClass);
	        hConfig.onDehighlight(component, target);
	        emit(target, dehighlight());
	      }
	    };
	    var highlight$1 = function (component, hConfig, hState, target) {
	      dehighlightAllExcept(component, hConfig, hState, [target]);
	      if (!isHighlighted(component, hConfig, hState, target)) {
	        add$2(target.element, hConfig.highlightClass);
	        hConfig.onHighlight(component, target);
	        emit(target, highlight());
	      }
	    };
	    var highlightFirst = function (component, hConfig, hState) {
	      getFirst(component, hConfig).each(function (firstComp) {
	        highlight$1(component, hConfig, hState, firstComp);
	      });
	    };
	    var highlightLast = function (component, hConfig, hState) {
	      getLast(component, hConfig).each(function (lastComp) {
	        highlight$1(component, hConfig, hState, lastComp);
	      });
	    };
	    var highlightAt = function (component, hConfig, hState, index) {
	      getByIndex(component, hConfig, hState, index).fold(function (err) {
	        throw err;
	      }, function (firstComp) {
	        highlight$1(component, hConfig, hState, firstComp);
	      });
	    };
	    var highlightBy = function (component, hConfig, hState, predicate) {
	      var candidates = getCandidates(component, hConfig);
	      var targetComp = find(candidates, predicate);
	      targetComp.each(function (c) {
	        highlight$1(component, hConfig, hState, c);
	      });
	    };
	    var isHighlighted = function (component, hConfig, hState, queryTarget) {
	      return has$2(queryTarget.element, hConfig.highlightClass);
	    };
	    var getHighlighted = function (component, hConfig, _hState) {
	      return descendant$1(component.element, '.' + hConfig.highlightClass).bind(function (e) {
	        return component.getSystem().getByDom(e).toOptional();
	      });
	    };
	    var getByIndex = function (component, hConfig, hState, index) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      return Optional.from(items[index]).fold(function () {
	        return Result.error(new Error('No element found with index ' + index));
	      }, component.getSystem().getByDom);
	    };
	    var getFirst = function (component, hConfig, _hState) {
	      return descendant$1(component.element, '.' + hConfig.itemClass).bind(function (e) {
	        return component.getSystem().getByDom(e).toOptional();
	      });
	    };
	    var getLast = function (component, hConfig, _hState) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      var last = items.length > 0 ? Optional.some(items[items.length - 1]) : Optional.none();
	      return last.bind(function (c) {
	        return component.getSystem().getByDom(c).toOptional();
	      });
	    };
	    var getDelta = function (component, hConfig, hState, delta) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      var current = findIndex(items, function (item) {
	        return has$2(item, hConfig.highlightClass);
	      });
	      return current.bind(function (selected) {
	        var dest = cycleBy(selected, delta, 0, items.length - 1);
	        return component.getSystem().getByDom(items[dest]).toOptional();
	      });
	    };
	    var getPrevious = function (component, hConfig, hState) {
	      return getDelta(component, hConfig, hState, -1);
	    };
	    var getNext = function (component, hConfig, hState) {
	      return getDelta(component, hConfig, hState, +1);
	    };
	    var getCandidates = function (component, hConfig, _hState) {
	      var items = descendants(component.element, '.' + hConfig.itemClass);
	      return cat(map(items, function (i) {
	        return component.getSystem().getByDom(i).toOptional();
	      }));
	    };
	
	    var HighlightApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        dehighlightAll: dehighlightAll,
	        dehighlight: dehighlight$1,
	        highlight: highlight$1,
	        highlightFirst: highlightFirst,
	        highlightLast: highlightLast,
	        highlightAt: highlightAt,
	        highlightBy: highlightBy,
	        isHighlighted: isHighlighted,
	        getHighlighted: getHighlighted,
	        getFirst: getFirst,
	        getLast: getLast,
	        getPrevious: getPrevious,
	        getNext: getNext,
	        getCandidates: getCandidates
	    });
	
	    var HighlightSchema = [
	      strict$1('highlightClass'),
	      strict$1('itemClass'),
	      onHandler('onHighlight'),
	      onHandler('onDehighlight')
	    ];
	
	    var Highlighting = create$1({
	      fields: HighlightSchema,
	      name: 'highlighting',
	      apis: HighlightApis
	    });
	
	    var BACKSPACE = [8];
	    var TAB = [9];
	    var ENTER = [13];
	    var ESCAPE = [27];
	    var SPACE = [32];
	    var LEFT = [37];
	    var UP = [38];
	    var RIGHT = [39];
	    var DOWN = [40];
	
	    var cyclePrev = function (values, index, predicate) {
	      var before = reverse(values.slice(0, index));
	      var after = reverse(values.slice(index + 1));
	      return find(before.concat(after), predicate);
	    };
	    var tryPrev = function (values, index, predicate) {
	      var before = reverse(values.slice(0, index));
	      return find(before, predicate);
	    };
	    var cycleNext = function (values, index, predicate) {
	      var before = values.slice(0, index);
	      var after = values.slice(index + 1);
	      return find(after.concat(before), predicate);
	    };
	    var tryNext = function (values, index, predicate) {
	      var after = values.slice(index + 1);
	      return find(after, predicate);
	    };
	
	    var inSet = function (keys) {
	      return function (event) {
	        var raw = event.raw;
	        return contains(keys, raw.which);
	      };
	    };
	    var and = function (preds) {
	      return function (event) {
	        return forall(preds, function (pred) {
	          return pred(event);
	        });
	      };
	    };
	    var isShift = function (event) {
	      var raw = event.raw;
	      return raw.shiftKey === true;
	    };
	    var isControl = function (event) {
	      var raw = event.raw;
	      return raw.ctrlKey === true;
	    };
	    var isNotShift = not(isShift);
	
	    var rule = function (matches, action) {
	      return {
	        matches: matches,
	        classification: action
	      };
	    };
	    var choose$2 = function (transitions, event) {
	      var transition = find(transitions, function (t) {
	        return t.matches(event);
	      });
	      return transition.map(function (t) {
	        return t.classification;
	      });
	    };
	
	    var reportFocusShifting = function (component, prevFocus, newFocus) {
	      var noChange = prevFocus.exists(function (p) {
	        return newFocus.exists(function (n) {
	          return eq$1(n, p);
	        });
	      });
	      if (!noChange) {
	        emitWith(component, focusShifted(), {
	          prevFocus: prevFocus,
	          newFocus: newFocus
	        });
	      }
	    };
	    var dom = function () {
	      var get = function (component) {
	        return search(component.element);
	      };
	      var set = function (component, focusee) {
	        var prevFocus = get(component);
	        component.getSystem().triggerFocus(focusee, component.element);
	        var newFocus = get(component);
	        reportFocusShifting(component, prevFocus, newFocus);
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	    var highlights = function () {
	      var get = function (component) {
	        return Highlighting.getHighlighted(component).map(function (item) {
	          return item.element;
	        });
	      };
	      var set = function (component, element) {
	        var prevFocus = get(component);
	        component.getSystem().getByDom(element).fold(noop, function (item) {
	          Highlighting.highlight(component, item);
	        });
	        var newFocus = get(component);
	        reportFocusShifting(component, prevFocus, newFocus);
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var FocusInsideModes;
	    (function (FocusInsideModes) {
	      FocusInsideModes['OnFocusMode'] = 'onFocus';
	      FocusInsideModes['OnEnterOrSpaceMode'] = 'onEnterOrSpace';
	      FocusInsideModes['OnApiMode'] = 'onApi';
	    }(FocusInsideModes || (FocusInsideModes = {})));
	
	    var typical = function (infoSchema, stateInit, getKeydownRules, getKeyupRules, optFocusIn) {
	      var schema = function () {
	        return infoSchema.concat([
	          defaulted$1('focusManager', dom()),
	          defaultedOf('focusInside', 'onFocus', valueOf(function (val) {
	            return contains([
	              'onFocus',
	              'onEnterOrSpace',
	              'onApi'
	            ], val) ? Result.value(val) : Result.error('Invalid value for focusInside');
	          })),
	          output('handler', me),
	          output('state', stateInit),
	          output('sendFocusIn', optFocusIn)
	        ]);
	      };
	      var processKey = function (component, simulatedEvent, getRules, keyingConfig, keyingState) {
	        var rules = getRules(component, simulatedEvent, keyingConfig, keyingState);
	        return choose$2(rules, simulatedEvent.event).bind(function (rule) {
	          return rule(component, simulatedEvent, keyingConfig, keyingState);
	        });
	      };
	      var toEvents = function (keyingConfig, keyingState) {
	        var onFocusHandler = keyingConfig.focusInside !== FocusInsideModes.OnFocusMode ? Optional.none() : optFocusIn(keyingConfig).map(function (focusIn) {
	          return run(focus(), function (component, simulatedEvent) {
	            focusIn(component, keyingConfig, keyingState);
	            simulatedEvent.stop();
	          });
	        });
	        var tryGoInsideComponent = function (component, simulatedEvent) {
	          var isEnterOrSpace = inSet(SPACE.concat(ENTER))(simulatedEvent.event);
	          if (keyingConfig.focusInside === FocusInsideModes.OnEnterOrSpaceMode && isEnterOrSpace && isSource(component, simulatedEvent)) {
	            optFocusIn(keyingConfig).each(function (focusIn) {
	              focusIn(component, keyingConfig, keyingState);
	              simulatedEvent.stop();
	            });
	          }
	        };
	        var keyboardEvents = [
	          run(keydown(), function (component, simulatedEvent) {
	            processKey(component, simulatedEvent, getKeydownRules, keyingConfig, keyingState).fold(function () {
	              tryGoInsideComponent(component, simulatedEvent);
	            }, function (_) {
	              simulatedEvent.stop();
	            });
	          }),
	          run(keyup(), function (component, simulatedEvent) {
	            processKey(component, simulatedEvent, getKeyupRules, keyingConfig, keyingState).each(function (_) {
	              simulatedEvent.stop();
	            });
	          })
	        ];
	        return derive(onFocusHandler.toArray().concat(keyboardEvents));
	      };
	      var me = {
	        schema: schema,
	        processKey: processKey,
	        toEvents: toEvents
	      };
	      return me;
	    };
	
	    var create$3 = function (cyclicField) {
	      var schema = [
	        option('onEscape'),
	        option('onEnter'),
	        defaulted$1('selector', '[data-alloy-tabstop="true"]:not(:disabled)'),
	        defaulted$1('firstTabstop', 0),
	        defaulted$1('useTabstopAt', always),
	        option('visibilitySelector')
	      ].concat([cyclicField]);
	      var isVisible = function (tabbingConfig, element) {
	        var target = tabbingConfig.visibilitySelector.bind(function (sel) {
	          return closest$3(element, sel);
	        }).getOr(element);
	        return get$7(target) > 0;
	      };
	      var findInitial = function (component, tabbingConfig) {
	        var tabstops = descendants(component.element, tabbingConfig.selector);
	        var visibles = filter(tabstops, function (elem) {
	          return isVisible(tabbingConfig, elem);
	        });
	        return Optional.from(visibles[tabbingConfig.firstTabstop]);
	      };
	      var findCurrent = function (component, tabbingConfig) {
	        return tabbingConfig.focusManager.get(component).bind(function (elem) {
	          return closest$3(elem, tabbingConfig.selector);
	        });
	      };
	      var isTabstop = function (tabbingConfig, element) {
	        return isVisible(tabbingConfig, element) && tabbingConfig.useTabstopAt(element);
	      };
	      var focusIn = function (component, tabbingConfig, _tabbingState) {
	        findInitial(component, tabbingConfig).each(function (target) {
	          tabbingConfig.focusManager.set(component, target);
	        });
	      };
	      var goFromTabstop = function (component, tabstops, stopIndex, tabbingConfig, cycle) {
	        return cycle(tabstops, stopIndex, function (elem) {
	          return isTabstop(tabbingConfig, elem);
	        }).fold(function () {
	          return tabbingConfig.cyclic ? Optional.some(true) : Optional.none();
	        }, function (target) {
	          tabbingConfig.focusManager.set(component, target);
	          return Optional.some(true);
	        });
	      };
	      var go = function (component, _simulatedEvent, tabbingConfig, cycle) {
	        var tabstops = descendants(component.element, tabbingConfig.selector);
	        return findCurrent(component, tabbingConfig).bind(function (tabstop) {
	          var optStopIndex = findIndex(tabstops, curry(eq$1, tabstop));
	          return optStopIndex.bind(function (stopIndex) {
	            return goFromTabstop(component, tabstops, stopIndex, tabbingConfig, cycle);
	          });
	        });
	      };
	      var goBackwards = function (component, simulatedEvent, tabbingConfig) {
	        var navigate = tabbingConfig.cyclic ? cyclePrev : tryPrev;
	        return go(component, simulatedEvent, tabbingConfig, navigate);
	      };
	      var goForwards = function (component, simulatedEvent, tabbingConfig) {
	        var navigate = tabbingConfig.cyclic ? cycleNext : tryNext;
	        return go(component, simulatedEvent, tabbingConfig, navigate);
	      };
	      var execute = function (component, simulatedEvent, tabbingConfig) {
	        return tabbingConfig.onEnter.bind(function (f) {
	          return f(component, simulatedEvent);
	        });
	      };
	      var exit = function (component, simulatedEvent, tabbingConfig) {
	        return tabbingConfig.onEscape.bind(function (f) {
	          return f(component, simulatedEvent);
	        });
	      };
	      var getKeydownRules = constant([
	        rule(and([
	          isShift,
	          inSet(TAB)
	        ]), goBackwards),
	        rule(inSet(TAB), goForwards),
	        rule(inSet(ESCAPE), exit),
	        rule(and([
	          isNotShift,
	          inSet(ENTER)
	        ]), execute)
	      ]);
	      var getKeyupRules = constant([]);
	      return typical(schema, NoState.init, getKeydownRules, getKeyupRules, function () {
	        return Optional.some(focusIn);
	      });
	    };
	
	    var AcyclicType = create$3(state$1('cyclic', never));
	
	    var CyclicType = create$3(state$1('cyclic', always));
	
	    var doDefaultExecute = function (component, _simulatedEvent, focused) {
	      dispatch(component, focused, execute());
	      return Optional.some(true);
	    };
	    var defaultExecute = function (component, simulatedEvent, focused) {
	      var isComplex = inside(focused) && inSet(SPACE)(simulatedEvent.event);
	      return isComplex ? Optional.none() : doDefaultExecute(component, simulatedEvent, focused);
	    };
	    var stopEventForFirefox = function (_component, _simulatedEvent) {
	      return Optional.some(true);
	    };
	
	    var schema$4 = [
	      defaulted$1('execute', defaultExecute),
	      defaulted$1('useSpace', false),
	      defaulted$1('useEnter', true),
	      defaulted$1('useControlEnter', false),
	      defaulted$1('useDown', false)
	    ];
	    var execute$1 = function (component, simulatedEvent, executeConfig) {
	      return executeConfig.execute(component, simulatedEvent, component.element);
	    };
	    var getKeydownRules = function (component, _simulatedEvent, executeConfig, _executeState) {
	      var spaceExec = executeConfig.useSpace && !inside(component.element) ? SPACE : [];
	      var enterExec = executeConfig.useEnter ? ENTER : [];
	      var downExec = executeConfig.useDown ? DOWN : [];
	      var execKeys = spaceExec.concat(enterExec).concat(downExec);
	      return [rule(inSet(execKeys), execute$1)].concat(executeConfig.useControlEnter ? [rule(and([
	          isControl,
	          inSet(ENTER)
	        ]), execute$1)] : []);
	    };
	    var getKeyupRules = function (component, _simulatedEvent, executeConfig, _executeState) {
	      return executeConfig.useSpace && !inside(component.element) ? [rule(inSet(SPACE), stopEventForFirefox)] : [];
	    };
	    var ExecutionType = typical(schema$4, NoState.init, getKeydownRules, getKeyupRules, function () {
	      return Optional.none();
	    });
	
	    var flatgrid = function () {
	      var dimensions = Cell(Optional.none());
	      var setGridSize = function (numRows, numColumns) {
	        dimensions.set(Optional.some({
	          numRows: numRows,
	          numColumns: numColumns
	        }));
	      };
	      var getNumRows = function () {
	        return dimensions.get().map(function (d) {
	          return d.numRows;
	        });
	      };
	      var getNumColumns = function () {
	        return dimensions.get().map(function (d) {
	          return d.numColumns;
	        });
	      };
	      return nu$5({
	        readState: function () {
	          return dimensions.get().map(function (d) {
	            return {
	              numRows: String(d.numRows),
	              numColumns: String(d.numColumns)
	            };
	          }).getOr({
	            numRows: '?',
	            numColumns: '?'
	          });
	        },
	        setGridSize: setGridSize,
	        getNumRows: getNumRows,
	        getNumColumns: getNumColumns
	      });
	    };
	    var init$2 = function (spec) {
	      return spec.state(spec);
	    };
	
	    var KeyingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        flatgrid: flatgrid,
	        init: init$2
	    });
	
	    var useH = function (movement) {
	      return function (component, simulatedEvent, config, state) {
	        var move = movement(component.element);
	        return use(move, component, simulatedEvent, config, state);
	      };
	    };
	    var west$2 = function (moveLeft, moveRight) {
	      var movement = onDirection(moveLeft, moveRight);
	      return useH(movement);
	    };
	    var east$2 = function (moveLeft, moveRight) {
	      var movement = onDirection(moveRight, moveLeft);
	      return useH(movement);
	    };
	    var useV = function (move) {
	      return function (component, simulatedEvent, config, state) {
	        return use(move, component, simulatedEvent, config, state);
	      };
	    };
	    var use = function (move, component, simulatedEvent, config, state) {
	      var outcome = config.focusManager.get(component).bind(function (focused) {
	        return move(component.element, focused, config, state);
	      });
	      return outcome.map(function (newFocus) {
	        config.focusManager.set(component, newFocus);
	        return true;
	      });
	    };
	    var north$2 = useV;
	    var south$2 = useV;
	    var move = useV;
	
	    var isHidden = function (dom) {
	      return dom.offsetWidth <= 0 && dom.offsetHeight <= 0;
	    };
	    var isVisible = function (element) {
	      return !isHidden(element.dom);
	    };
	
	    var locate = function (candidates, predicate) {
	      return findIndex(candidates, predicate).map(function (index) {
	        return {
	          index: index,
	          candidates: candidates
	        };
	      });
	    };
	
	    var locateVisible = function (container, current, selector) {
	      var predicate = function (x) {
	        return eq$1(x, current);
	      };
	      var candidates = descendants(container, selector);
	      var visible = filter(candidates, isVisible);
	      return locate(visible, predicate);
	    };
	    var findIndex$1 = function (elements, target) {
	      return findIndex(elements, function (elem) {
	        return eq$1(target, elem);
	      });
	    };
	
	    var withGrid = function (values, index, numCols, f) {
	      var oldRow = Math.floor(index / numCols);
	      var oldColumn = index % numCols;
	      return f(oldRow, oldColumn).bind(function (address) {
	        var newIndex = address.row * numCols + address.column;
	        return newIndex >= 0 && newIndex < values.length ? Optional.some(values[newIndex]) : Optional.none();
	      });
	    };
	    var cycleHorizontal = function (values, index, numRows, numCols, delta) {
	      return withGrid(values, index, numCols, function (oldRow, oldColumn) {
	        var onLastRow = oldRow === numRows - 1;
	        var colsInRow = onLastRow ? values.length - oldRow * numCols : numCols;
	        var newColumn = cycleBy(oldColumn, delta, 0, colsInRow - 1);
	        return Optional.some({
	          row: oldRow,
	          column: newColumn
	        });
	      });
	    };
	    var cycleVertical = function (values, index, numRows, numCols, delta) {
	      return withGrid(values, index, numCols, function (oldRow, oldColumn) {
	        var newRow = cycleBy(oldRow, delta, 0, numRows - 1);
	        var onLastRow = newRow === numRows - 1;
	        var colsInRow = onLastRow ? values.length - newRow * numCols : numCols;
	        var newCol = clamp(oldColumn, 0, colsInRow - 1);
	        return Optional.some({
	          row: newRow,
	          column: newCol
	        });
	      });
	    };
	    var cycleRight = function (values, index, numRows, numCols) {
	      return cycleHorizontal(values, index, numRows, numCols, +1);
	    };
	    var cycleLeft = function (values, index, numRows, numCols) {
	      return cycleHorizontal(values, index, numRows, numCols, -1);
	    };
	    var cycleUp = function (values, index, numRows, numCols) {
	      return cycleVertical(values, index, numRows, numCols, -1);
	    };
	    var cycleDown = function (values, index, numRows, numCols) {
	      return cycleVertical(values, index, numRows, numCols, +1);
	    };
	
	    var schema$5 = [
	      strict$1('selector'),
	      defaulted$1('execute', defaultExecute),
	      onKeyboardHandler('onEscape'),
	      defaulted$1('captureTab', false),
	      initSize()
	    ];
	    var focusIn = function (component, gridConfig, _gridState) {
	      descendant$1(component.element, gridConfig.selector).each(function (first) {
	        gridConfig.focusManager.set(component, first);
	      });
	    };
	    var findCurrent = function (component, gridConfig) {
	      return gridConfig.focusManager.get(component).bind(function (elem) {
	        return closest$3(elem, gridConfig.selector);
	      });
	    };
	    var execute$2 = function (component, simulatedEvent, gridConfig, _gridState) {
	      return findCurrent(component, gridConfig).bind(function (focused) {
	        return gridConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var doMove = function (cycle) {
	      return function (element, focused, gridConfig, gridState) {
	        return locateVisible(element, focused, gridConfig.selector).bind(function (identified) {
	          return cycle(identified.candidates, identified.index, gridState.getNumRows().getOr(gridConfig.initSize.numRows), gridState.getNumColumns().getOr(gridConfig.initSize.numColumns));
	        });
	      };
	    };
	    var handleTab = function (_component, _simulatedEvent, gridConfig) {
	      return gridConfig.captureTab ? Optional.some(true) : Optional.none();
	    };
	    var doEscape = function (component, simulatedEvent, gridConfig) {
	      return gridConfig.onEscape(component, simulatedEvent);
	    };
	    var moveLeft = doMove(cycleLeft);
	    var moveRight = doMove(cycleRight);
	    var moveNorth = doMove(cycleUp);
	    var moveSouth = doMove(cycleDown);
	    var getKeydownRules$1 = constant([
	      rule(inSet(LEFT), west$2(moveLeft, moveRight)),
	      rule(inSet(RIGHT), east$2(moveLeft, moveRight)),
	      rule(inSet(UP), north$2(moveNorth)),
	      rule(inSet(DOWN), south$2(moveSouth)),
	      rule(and([
	        isShift,
	        inSet(TAB)
	      ]), handleTab),
	      rule(and([
	        isNotShift,
	        inSet(TAB)
	      ]), handleTab),
	      rule(inSet(ESCAPE), doEscape),
	      rule(inSet(SPACE.concat(ENTER)), execute$2)
	    ]);
	    var getKeyupRules$1 = constant([rule(inSet(SPACE), stopEventForFirefox)]);
	    var FlatgridType = typical(schema$5, flatgrid, getKeydownRules$1, getKeyupRules$1, function () {
	      return Optional.some(focusIn);
	    });
	
	    var horizontal = function (container, selector, current, delta) {
	      var isDisabledButton = function (candidate) {
	        return name(candidate) === 'button' && get$3(candidate, 'disabled') === 'disabled';
	      };
	      var tryCycle = function (initial, index, candidates) {
	        var newIndex = cycleBy(index, delta, 0, candidates.length - 1);
	        if (newIndex === initial) {
	          return Optional.none();
	        } else {
	          return isDisabledButton(candidates[newIndex]) ? tryCycle(initial, newIndex, candidates) : Optional.from(candidates[newIndex]);
	        }
	      };
	      return locateVisible(container, current, selector).bind(function (identified) {
	        var index = identified.index;
	        var candidates = identified.candidates;
	        return tryCycle(index, index, candidates);
	      });
	    };
	
	    var schema$6 = [
	      strict$1('selector'),
	      defaulted$1('getInitial', Optional.none),
	      defaulted$1('execute', defaultExecute),
	      onKeyboardHandler('onEscape'),
	      defaulted$1('executeOnMove', false),
	      defaulted$1('allowVertical', true)
	    ];
	    var findCurrent$1 = function (component, flowConfig) {
	      return flowConfig.focusManager.get(component).bind(function (elem) {
	        return closest$3(elem, flowConfig.selector);
	      });
	    };
	    var execute$3 = function (component, simulatedEvent, flowConfig) {
	      return findCurrent$1(component, flowConfig).bind(function (focused) {
	        return flowConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var focusIn$1 = function (component, flowConfig, _state) {
	      flowConfig.getInitial(component).orThunk(function () {
	        return descendant$1(component.element, flowConfig.selector);
	      }).each(function (first) {
	        flowConfig.focusManager.set(component, first);
	      });
	    };
	    var moveLeft$1 = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, -1);
	    };
	    var moveRight$1 = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, +1);
	    };
	    var doMove$1 = function (movement) {
	      return function (component, simulatedEvent, flowConfig, flowState) {
	        return movement(component, simulatedEvent, flowConfig, flowState).bind(function () {
	          return flowConfig.executeOnMove ? execute$3(component, simulatedEvent, flowConfig) : Optional.some(true);
	        });
	      };
	    };
	    var doEscape$1 = function (component, simulatedEvent, flowConfig) {
	      return flowConfig.onEscape(component, simulatedEvent);
	    };
	    var getKeydownRules$2 = function (_component, _se, flowConfig, _flowState) {
	      var westMovers = LEFT.concat(flowConfig.allowVertical ? UP : []);
	      var eastMovers = RIGHT.concat(flowConfig.allowVertical ? DOWN : []);
	      return [
	        rule(inSet(westMovers), doMove$1(west$2(moveLeft$1, moveRight$1))),
	        rule(inSet(eastMovers), doMove$1(east$2(moveLeft$1, moveRight$1))),
	        rule(inSet(ENTER), execute$3),
	        rule(inSet(SPACE), execute$3),
	        rule(inSet(ESCAPE), doEscape$1)
	      ];
	    };
	    var getKeyupRules$2 = constant([rule(inSet(SPACE), stopEventForFirefox)]);
	    var FlowType = typical(schema$6, NoState.init, getKeydownRules$2, getKeyupRules$2, function () {
	      return Optional.some(focusIn$1);
	    });
	
	    var toCell = function (matrix, rowIndex, columnIndex) {
	      return Optional.from(matrix[rowIndex]).bind(function (row) {
	        return Optional.from(row[columnIndex]).map(function (cell) {
	          return {
	            rowIndex: rowIndex,
	            columnIndex: columnIndex,
	            cell: cell
	          };
	        });
	      });
	    };
	    var cycleHorizontal$1 = function (matrix, rowIndex, startCol, deltaCol) {
	      var row = matrix[rowIndex];
	      var colsInRow = row.length;
	      var newColIndex = cycleBy(startCol, deltaCol, 0, colsInRow - 1);
	      return toCell(matrix, rowIndex, newColIndex);
	    };
	    var cycleVertical$1 = function (matrix, colIndex, startRow, deltaRow) {
	      var nextRowIndex = cycleBy(startRow, deltaRow, 0, matrix.length - 1);
	      var colsInNextRow = matrix[nextRowIndex].length;
	      var nextColIndex = clamp(colIndex, 0, colsInNextRow - 1);
	      return toCell(matrix, nextRowIndex, nextColIndex);
	    };
	    var moveHorizontal = function (matrix, rowIndex, startCol, deltaCol) {
	      var row = matrix[rowIndex];
	      var colsInRow = row.length;
	      var newColIndex = clamp(startCol + deltaCol, 0, colsInRow - 1);
	      return toCell(matrix, rowIndex, newColIndex);
	    };
	    var moveVertical = function (matrix, colIndex, startRow, deltaRow) {
	      var nextRowIndex = clamp(startRow + deltaRow, 0, matrix.length - 1);
	      var colsInNextRow = matrix[nextRowIndex].length;
	      var nextColIndex = clamp(colIndex, 0, colsInNextRow - 1);
	      return toCell(matrix, nextRowIndex, nextColIndex);
	    };
	    var cycleRight$1 = function (matrix, startRow, startCol) {
	      return cycleHorizontal$1(matrix, startRow, startCol, +1);
	    };
	    var cycleLeft$1 = function (matrix, startRow, startCol) {
	      return cycleHorizontal$1(matrix, startRow, startCol, -1);
	    };
	    var cycleUp$1 = function (matrix, startRow, startCol) {
	      return cycleVertical$1(matrix, startCol, startRow, -1);
	    };
	    var cycleDown$1 = function (matrix, startRow, startCol) {
	      return cycleVertical$1(matrix, startCol, startRow, +1);
	    };
	    var moveLeft$2 = function (matrix, startRow, startCol) {
	      return moveHorizontal(matrix, startRow, startCol, -1);
	    };
	    var moveRight$2 = function (matrix, startRow, startCol) {
	      return moveHorizontal(matrix, startRow, startCol, +1);
	    };
	    var moveUp = function (matrix, startRow, startCol) {
	      return moveVertical(matrix, startCol, startRow, -1);
	    };
	    var moveDown = function (matrix, startRow, startCol) {
	      return moveVertical(matrix, startCol, startRow, +1);
	    };
	
	    var schema$7 = [
	      strictObjOf('selectors', [
	        strict$1('row'),
	        strict$1('cell')
	      ]),
	      defaulted$1('cycles', true),
	      defaulted$1('previousSelector', Optional.none),
	      defaulted$1('execute', defaultExecute)
	    ];
	    var focusIn$2 = function (component, matrixConfig, _state) {
	      var focused = matrixConfig.previousSelector(component).orThunk(function () {
	        var selectors = matrixConfig.selectors;
	        return descendant$1(component.element, selectors.cell);
	      });
	      focused.each(function (cell) {
	        matrixConfig.focusManager.set(component, cell);
	      });
	    };
	    var execute$4 = function (component, simulatedEvent, matrixConfig) {
	      return search(component.element).bind(function (focused) {
	        return matrixConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var toMatrix = function (rows, matrixConfig) {
	      return map(rows, function (row) {
	        return descendants(row, matrixConfig.selectors.cell);
	      });
	    };
	    var doMove$2 = function (ifCycle, ifMove) {
	      return function (element, focused, matrixConfig) {
	        var move = matrixConfig.cycles ? ifCycle : ifMove;
	        return closest$3(focused, matrixConfig.selectors.row).bind(function (inRow) {
	          var cellsInRow = descendants(inRow, matrixConfig.selectors.cell);
	          return findIndex$1(cellsInRow, focused).bind(function (colIndex) {
	            var allRows = descendants(element, matrixConfig.selectors.row);
	            return findIndex$1(allRows, inRow).bind(function (rowIndex) {
	              var matrix = toMatrix(allRows, matrixConfig);
	              return move(matrix, rowIndex, colIndex).map(function (next) {
	                return next.cell;
	              });
	            });
	          });
	        });
	      };
	    };
	    var moveLeft$3 = doMove$2(cycleLeft$1, moveLeft$2);
	    var moveRight$3 = doMove$2(cycleRight$1, moveRight$2);
	    var moveNorth$1 = doMove$2(cycleUp$1, moveUp);
	    var moveSouth$1 = doMove$2(cycleDown$1, moveDown);
	    var getKeydownRules$3 = constant([
	      rule(inSet(LEFT), west$2(moveLeft$3, moveRight$3)),
	      rule(inSet(RIGHT), east$2(moveLeft$3, moveRight$3)),
	      rule(inSet(UP), north$2(moveNorth$1)),
	      rule(inSet(DOWN), south$2(moveSouth$1)),
	      rule(inSet(SPACE.concat(ENTER)), execute$4)
	    ]);
	    var getKeyupRules$3 = constant([rule(inSet(SPACE), stopEventForFirefox)]);
	    var MatrixType = typical(schema$7, NoState.init, getKeydownRules$3, getKeyupRules$3, function () {
	      return Optional.some(focusIn$2);
	    });
	
	    var schema$8 = [
	      strict$1('selector'),
	      defaulted$1('execute', defaultExecute),
	      defaulted$1('moveOnTab', false)
	    ];
	    var execute$5 = function (component, simulatedEvent, menuConfig) {
	      return menuConfig.focusManager.get(component).bind(function (focused) {
	        return menuConfig.execute(component, simulatedEvent, focused);
	      });
	    };
	    var focusIn$3 = function (component, menuConfig, _state) {
	      descendant$1(component.element, menuConfig.selector).each(function (first) {
	        menuConfig.focusManager.set(component, first);
	      });
	    };
	    var moveUp$1 = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, -1);
	    };
	    var moveDown$1 = function (element, focused, info) {
	      return horizontal(element, info.selector, focused, +1);
	    };
	    var fireShiftTab = function (component, simulatedEvent, menuConfig, menuState) {
	      return menuConfig.moveOnTab ? move(moveUp$1)(component, simulatedEvent, menuConfig, menuState) : Optional.none();
	    };
	    var fireTab = function (component, simulatedEvent, menuConfig, menuState) {
	      return menuConfig.moveOnTab ? move(moveDown$1)(component, simulatedEvent, menuConfig, menuState) : Optional.none();
	    };
	    var getKeydownRules$4 = constant([
	      rule(inSet(UP), move(moveUp$1)),
	      rule(inSet(DOWN), move(moveDown$1)),
	      rule(and([
	        isShift,
	        inSet(TAB)
	      ]), fireShiftTab),
	      rule(and([
	        isNotShift,
	        inSet(TAB)
	      ]), fireTab),
	      rule(inSet(ENTER), execute$5),
	      rule(inSet(SPACE), execute$5)
	    ]);
	    var getKeyupRules$4 = constant([rule(inSet(SPACE), stopEventForFirefox)]);
	    var MenuType = typical(schema$8, NoState.init, getKeydownRules$4, getKeyupRules$4, function () {
	      return Optional.some(focusIn$3);
	    });
	
	    var schema$9 = [
	      onKeyboardHandler('onSpace'),
	      onKeyboardHandler('onEnter'),
	      onKeyboardHandler('onShiftEnter'),
	      onKeyboardHandler('onLeft'),
	      onKeyboardHandler('onRight'),
	      onKeyboardHandler('onTab'),
	      onKeyboardHandler('onShiftTab'),
	      onKeyboardHandler('onUp'),
	      onKeyboardHandler('onDown'),
	      onKeyboardHandler('onEscape'),
	      defaulted$1('stopSpaceKeyup', false),
	      option('focusIn')
	    ];
	    var getKeydownRules$5 = function (component, simulatedEvent, specialInfo) {
	      return [
	        rule(inSet(SPACE), specialInfo.onSpace),
	        rule(and([
	          isNotShift,
	          inSet(ENTER)
	        ]), specialInfo.onEnter),
	        rule(and([
	          isShift,
	          inSet(ENTER)
	        ]), specialInfo.onShiftEnter),
	        rule(and([
	          isShift,
	          inSet(TAB)
	        ]), specialInfo.onShiftTab),
	        rule(and([
	          isNotShift,
	          inSet(TAB)
	        ]), specialInfo.onTab),
	        rule(inSet(UP), specialInfo.onUp),
	        rule(inSet(DOWN), specialInfo.onDown),
	        rule(inSet(LEFT), specialInfo.onLeft),
	        rule(inSet(RIGHT), specialInfo.onRight),
	        rule(inSet(SPACE), specialInfo.onSpace),
	        rule(inSet(ESCAPE), specialInfo.onEscape)
	      ];
	    };
	    var getKeyupRules$5 = function (component, simulatedEvent, specialInfo) {
	      return specialInfo.stopSpaceKeyup ? [rule(inSet(SPACE), stopEventForFirefox)] : [];
	    };
	    var SpecialType = typical(schema$9, NoState.init, getKeydownRules$5, getKeyupRules$5, function (specialInfo) {
	      return specialInfo.focusIn;
	    });
	
	    var acyclic = AcyclicType.schema();
	    var cyclic = CyclicType.schema();
	    var flow = FlowType.schema();
	    var flatgrid$1 = FlatgridType.schema();
	    var matrix = MatrixType.schema();
	    var execution = ExecutionType.schema();
	    var menu = MenuType.schema();
	    var special = SpecialType.schema();
	
	    var KeyboardBranches = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        acyclic: acyclic,
	        cyclic: cyclic,
	        flow: flow,
	        flatgrid: flatgrid$1,
	        matrix: matrix,
	        execution: execution,
	        menu: menu,
	        special: special
	    });
	
	    var isFlatgridState = function (keyState) {
	      return hasNonNullableKey(keyState, 'setGridSize');
	    };
	    var Keying = createModes$1({
	      branchKey: 'mode',
	      branches: KeyboardBranches,
	      name: 'keying',
	      active: {
	        events: function (keyingConfig, keyingState) {
	          var handler = keyingConfig.handler;
	          return handler.toEvents(keyingConfig, keyingState);
	        }
	      },
	      apis: {
	        focusIn: function (component, keyConfig, keyState) {
	          keyConfig.sendFocusIn(keyConfig).fold(function () {
	            component.getSystem().triggerFocus(component.element, component.element);
	          }, function (sendFocusIn) {
	            sendFocusIn(component, keyConfig, keyState);
	          });
	        },
	        setGridSize: function (component, keyConfig, keyState, numRows, numColumns) {
	          if (!isFlatgridState(keyState)) {
	            console.error('Layout does not support setGridSize');
	          } else {
	            keyState.setGridSize(numRows, numColumns);
	          }
	        }
	      },
	      state: KeyingState
	    });
	
	    var set$5 = function (component, replaceConfig, replaceState, data) {
	      preserve(function () {
	        var newChildren = map(data, component.getSystem().build);
	        replaceChildren(component, newChildren);
	      }, component.element);
	    };
	    var insert = function (component, replaceConfig, insertion, childSpec) {
	      var child = component.getSystem().build(childSpec);
	      attachWith(component, child, insertion);
	    };
	    var append$2 = function (component, replaceConfig, replaceState, appendee) {
	      insert(component, replaceConfig, append, appendee);
	    };
	    var prepend$1 = function (component, replaceConfig, replaceState, prependee) {
	      insert(component, replaceConfig, prepend, prependee);
	    };
	    var remove$7 = function (component, replaceConfig, replaceState, removee) {
	      var children = contents(component);
	      var foundChild = find(children, function (child) {
	        return eq$1(removee.element, child.element);
	      });
	      foundChild.each(detach);
	    };
	    var contents = function (component, _replaceConfig) {
	      return component.components();
	    };
	    var replaceAt = function (component, replaceConfig, replaceState, replaceeIndex, replacer) {
	      var children = contents(component);
	      return Optional.from(children[replaceeIndex]).map(function (replacee) {
	        remove$7(component, replaceConfig, replaceState, replacee);
	        replacer.each(function (r) {
	          insert(component, replaceConfig, function (p, c) {
	            appendAt(p, c, replaceeIndex);
	          }, r);
	        });
	        return replacee;
	      });
	    };
	    var replaceBy = function (component, replaceConfig, replaceState, replaceePred, replacer) {
	      var children = contents(component);
	      return findIndex(children, replaceePred).bind(function (replaceeIndex) {
	        return replaceAt(component, replaceConfig, replaceState, replaceeIndex, replacer);
	      });
	    };
	
	    var ReplaceApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        append: append$2,
	        prepend: prepend$1,
	        remove: remove$7,
	        replaceAt: replaceAt,
	        replaceBy: replaceBy,
	        set: set$5,
	        contents: contents
	    });
	
	    var Replacing = create$1({
	      fields: [],
	      name: 'replacing',
	      apis: ReplaceApis
	    });
	
	    var events$4 = function (name, eventHandlers) {
	      var events = derive(eventHandlers);
	      return create$1({
	        fields: [strict$1('enabled')],
	        name: name,
	        active: { events: constant(events) }
	      });
	    };
	    var config = function (name, eventHandlers) {
	      var me = events$4(name, eventHandlers);
	      return {
	        key: name,
	        value: {
	          config: {},
	          me: me,
	          configAsRaw: constant({}),
	          initialConfig: {},
	          state: NoState
	        }
	      };
	    };
	
	    var focus$2 = function (component, focusConfig) {
	      if (!focusConfig.ignore) {
	        focus$1(component.element);
	        focusConfig.onFocus(component);
	      }
	    };
	    var blur$1 = function (component, focusConfig) {
	      if (!focusConfig.ignore) {
	        blur(component.element);
	      }
	    };
	    var isFocused = function (component) {
	      return hasFocus(component.element);
	    };
	
	    var FocusApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        focus: focus$2,
	        blur: blur$1,
	        isFocused: isFocused
	    });
	
	    var exhibit$1 = function (base, focusConfig) {
	      var mod = focusConfig.ignore ? {} : { attributes: { tabindex: '-1' } };
	      return nu$6(mod);
	    };
	    var events$5 = function (focusConfig) {
	      return derive([run(focus(), function (component, simulatedEvent) {
	          focus$2(component, focusConfig);
	          simulatedEvent.stop();
	        })].concat(focusConfig.stopMousedown ? [run(mousedown(), function (_, simulatedEvent) {
	          simulatedEvent.event.prevent();
	        })] : []));
	    };
	
	    var ActiveFocus = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$1,
	        events: events$5
	    });
	
	    var FocusSchema = [
	      onHandler('onFocus'),
	      defaulted$1('stopMousedown', false),
	      defaulted$1('ignore', false)
	    ];
	
	    var Focusing = create$1({
	      fields: FocusSchema,
	      name: 'focusing',
	      active: ActiveFocus,
	      apis: FocusApis
	    });
	
	    var SetupBehaviourCellState = function (initialState) {
	      var init = function () {
	        var cell = Cell(initialState);
	        var get = function () {
	          return cell.get();
	        };
	        var set = function (newState) {
	          return cell.set(newState);
	        };
	        var clear = function () {
	          return cell.set(initialState);
	        };
	        var readState = function () {
	          return cell.get();
	        };
	        return {
	          get: get,
	          set: set,
	          clear: clear,
	          readState: readState
	        };
	      };
	      return { init: init };
	    };
	
	    var updateAriaState = function (component, toggleConfig, toggleState) {
	      var ariaInfo = toggleConfig.aria;
	      ariaInfo.update(component, ariaInfo, toggleState.get());
	    };
	    var updateClass = function (component, toggleConfig, toggleState) {
	      toggleConfig.toggleClass.each(function (toggleClass) {
	        if (toggleState.get()) {
	          add$2(component.element, toggleClass);
	        } else {
	          remove$4(component.element, toggleClass);
	        }
	      });
	    };
	    var toggle = function (component, toggleConfig, toggleState) {
	      set$6(component, toggleConfig, toggleState, !toggleState.get());
	    };
	    var on$1 = function (component, toggleConfig, toggleState) {
	      toggleState.set(true);
	      updateClass(component, toggleConfig, toggleState);
	      updateAriaState(component, toggleConfig, toggleState);
	    };
	    var off = function (component, toggleConfig, toggleState) {
	      toggleState.set(false);
	      updateClass(component, toggleConfig, toggleState);
	      updateAriaState(component, toggleConfig, toggleState);
	    };
	    var set$6 = function (component, toggleConfig, toggleState, state) {
	      var action = state ? on$1 : off;
	      action(component, toggleConfig, toggleState);
	    };
	    var isOn = function (component, toggleConfig, toggleState) {
	      return toggleState.get();
	    };
	    var onLoad$4 = function (component, toggleConfig, toggleState) {
	      set$6(component, toggleConfig, toggleState, toggleConfig.selected);
	    };
	
	    var ToggleApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        onLoad: onLoad$4,
	        toggle: toggle,
	        isOn: isOn,
	        on: on$1,
	        off: off,
	        set: set$6
	    });
	
	    var exhibit$2 = function () {
	      return nu$6({});
	    };
	    var events$6 = function (toggleConfig, toggleState) {
	      var execute = executeEvent(toggleConfig, toggleState, toggle);
	      var load = loadEvent(toggleConfig, toggleState, onLoad$4);
	      return derive(flatten([
	        toggleConfig.toggleOnExecute ? [execute] : [],
	        [load]
	      ]));
	    };
	
	    var ActiveToggle = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$2,
	        events: events$6
	    });
	
	    var updatePressed = function (component, ariaInfo, status) {
	      set$1(component.element, 'aria-pressed', status);
	      if (ariaInfo.syncWithExpanded) {
	        updateExpanded(component, ariaInfo, status);
	      }
	    };
	    var updateSelected = function (component, ariaInfo, status) {
	      set$1(component.element, 'aria-selected', status);
	    };
	    var updateChecked = function (component, ariaInfo, status) {
	      set$1(component.element, 'aria-checked', status);
	    };
	    var updateExpanded = function (component, ariaInfo, status) {
	      set$1(component.element, 'aria-expanded', status);
	    };
	
	    var ToggleSchema = [
	      defaulted$1('selected', false),
	      option('toggleClass'),
	      defaulted$1('toggleOnExecute', true),
	      defaultedOf('aria', { mode: 'none' }, choose$1('mode', {
	        pressed: [
	          defaulted$1('syncWithExpanded', false),
	          output('update', updatePressed)
	        ],
	        checked: [output('update', updateChecked)],
	        expanded: [output('update', updateExpanded)],
	        selected: [output('update', updateSelected)],
	        none: [output('update', noop)]
	      }))
	    ];
	
	    var Toggling = create$1({
	      fields: ToggleSchema,
	      name: 'toggling',
	      active: ActiveToggle,
	      apis: ToggleApis,
	      state: SetupBehaviourCellState(false)
	    });
	
	    var pointerEvents = function () {
	      var onClick = function (component, simulatedEvent) {
	        simulatedEvent.stop();
	        emitExecute(component);
	      };
	      return [
	        run(click(), onClick),
	        run(tap(), onClick),
	        cutter(touchstart()),
	        cutter(mousedown())
	      ];
	    };
	    var events$7 = function (optAction) {
	      var executeHandler = function (action) {
	        return runOnExecute(function (component, simulatedEvent) {
	          action(component);
	          simulatedEvent.stop();
	        });
	      };
	      return derive(flatten([
	        optAction.map(executeHandler).toArray(),
	        pointerEvents()
	      ]));
	    };
	
	    var hoverEvent = 'alloy.item-hover';
	    var focusEvent = 'alloy.item-focus';
	    var onHover = function (item) {
	      if (search(item.element).isNone() || Focusing.isFocused(item)) {
	        if (!Focusing.isFocused(item)) {
	          Focusing.focus(item);
	        }
	        emitWith(item, hoverEvent, { item: item });
	      }
	    };
	    var onFocus = function (item) {
	      emitWith(item, focusEvent, { item: item });
	    };
	    var hover = constant(hoverEvent);
	    var focus$3 = constant(focusEvent);
	
	    var builder = function (detail) {
	      return {
	        dom: detail.dom,
	        domModification: __assign(__assign({}, detail.domModification), { attributes: __assign(__assign(__assign({ 'role': detail.toggling.isSome() ? 'menuitemcheckbox' : 'menuitem' }, detail.domModification.attributes), { 'aria-haspopup': detail.hasSubmenu }), detail.hasSubmenu ? { 'aria-expanded': false } : {}) }),
	        behaviours: SketchBehaviours.augment(detail.itemBehaviours, [
	          detail.toggling.fold(Toggling.revoke, function (tConfig) {
	            return Toggling.config(__assign({ aria: { mode: 'checked' } }, tConfig));
	          }),
	          Focusing.config({
	            ignore: detail.ignoreFocus,
	            stopMousedown: detail.ignoreFocus,
	            onFocus: function (component) {
	              onFocus(component);
	            }
	          }),
	          Keying.config({ mode: 'execution' }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.data
	            }
	          }),
	          config('item-type-events', __spreadArrays(pointerEvents(), [
	            run(mouseover(), onHover),
	            run(focusItem(), Focusing.focus)
	          ]))
	        ]),
	        components: detail.components,
	        eventOrder: detail.eventOrder
	      };
	    };
	    var schema$a = [
	      strict$1('data'),
	      strict$1('components'),
	      strict$1('dom'),
	      defaulted$1('hasSubmenu', false),
	      option('toggling'),
	      SketchBehaviours.field('itemBehaviours', [
	        Toggling,
	        Focusing,
	        Keying,
	        Representing
	      ]),
	      defaulted$1('ignoreFocus', false),
	      defaulted$1('domModification', {}),
	      output('builder', builder),
	      defaulted$1('eventOrder', {})
	    ];
	
	    var builder$1 = function (detail) {
	      return {
	        dom: detail.dom,
	        components: detail.components,
	        events: derive([stopper(focusItem())])
	      };
	    };
	    var schema$b = [
	      strict$1('dom'),
	      strict$1('components'),
	      output('builder', builder$1)
	    ];
	
	    var owner$2 = constant('item-widget');
	    var parts = constant([required({
	        name: 'widget',
	        overrides: function (detail) {
	          return {
	            behaviours: derive$1([Representing.config({
	                store: {
	                  mode: 'manual',
	                  getValue: function (_component) {
	                    return detail.data;
	                  },
	                  setValue: noop
	                }
	              })])
	          };
	        }
	      })]);
	
	    var builder$2 = function (detail) {
	      var subs = substitutes(owner$2(), detail, parts());
	      var components$1 = components(owner$2(), detail, subs.internals());
	      var focusWidget = function (component) {
	        return getPart(component, detail, 'widget').map(function (widget) {
	          Keying.focusIn(widget);
	          return widget;
	        });
	      };
	      var onHorizontalArrow = function (component, simulatedEvent) {
	        return inside(simulatedEvent.event.target) ? Optional.none() : function () {
	          if (detail.autofocus) {
	            simulatedEvent.setSource(component.element);
	            return Optional.none();
	          } else {
	            return Optional.none();
	          }
	        }();
	      };
	      return {
	        dom: detail.dom,
	        components: components$1,
	        domModification: detail.domModification,
	        events: derive([
	          runOnExecute(function (component, simulatedEvent) {
	            focusWidget(component).each(function (_widget) {
	              simulatedEvent.stop();
	            });
	          }),
	          run(mouseover(), onHover),
	          run(focusItem(), function (component, _simulatedEvent) {
	            if (detail.autofocus) {
	              focusWidget(component);
	            } else {
	              Focusing.focus(component);
	            }
	          })
	        ]),
	        behaviours: SketchBehaviours.augment(detail.widgetBehaviours, [
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.data
	            }
	          }),
	          Focusing.config({
	            ignore: detail.ignoreFocus,
	            onFocus: function (component) {
	              onFocus(component);
	            }
	          }),
	          Keying.config({
	            mode: 'special',
	            focusIn: detail.autofocus ? function (component) {
	              focusWidget(component);
	            } : revoke(),
	            onLeft: onHorizontalArrow,
	            onRight: onHorizontalArrow,
	            onEscape: function (component, simulatedEvent) {
	              if (!Focusing.isFocused(component) && !detail.autofocus) {
	                Focusing.focus(component);
	                return Optional.some(true);
	              } else if (detail.autofocus) {
	                simulatedEvent.setSource(component.element);
	                return Optional.none();
	              } else {
	                return Optional.none();
	              }
	            }
	          })
	        ])
	      };
	    };
	    var schema$c = [
	      strict$1('uid'),
	      strict$1('data'),
	      strict$1('components'),
	      strict$1('dom'),
	      defaulted$1('autofocus', false),
	      defaulted$1('ignoreFocus', false),
	      SketchBehaviours.field('widgetBehaviours', [
	        Representing,
	        Focusing,
	        Keying
	      ]),
	      defaulted$1('domModification', {}),
	      defaultUidsSchema(parts()),
	      output('builder', builder$2)
	    ];
	
	    var itemSchema$1 = choose$1('type', {
	      widget: schema$c,
	      item: schema$a,
	      separator: schema$b
	    });
	    var configureGrid = function (detail, movementInfo) {
	      return {
	        mode: 'flatgrid',
	        selector: '.' + detail.markers.item,
	        initSize: {
	          numColumns: movementInfo.initSize.numColumns,
	          numRows: movementInfo.initSize.numRows
	        },
	        focusManager: detail.focusManager
	      };
	    };
	    var configureMatrix = function (detail, movementInfo) {
	      return {
	        mode: 'matrix',
	        selectors: {
	          row: movementInfo.rowSelector,
	          cell: '.' + detail.markers.item
	        },
	        focusManager: detail.focusManager
	      };
	    };
	    var configureMenu = function (detail, movementInfo) {
	      return {
	        mode: 'menu',
	        selector: '.' + detail.markers.item,
	        moveOnTab: movementInfo.moveOnTab,
	        focusManager: detail.focusManager
	      };
	    };
	    var parts$1 = constant([group({
	        factory: {
	          sketch: function (spec) {
	            var itemInfo = asRawOrDie('menu.spec item', itemSchema$1, spec);
	            return itemInfo.builder(itemInfo);
	          }
	        },
	        name: 'items',
	        unit: 'item',
	        defaults: function (detail, u) {
	          return u.hasOwnProperty('uid') ? u : __assign(__assign({}, u), { uid: generate$2('item') });
	        },
	        overrides: function (detail, u) {
	          return {
	            type: u.type,
	            ignoreFocus: detail.fakeFocus,
	            domModification: { classes: [detail.markers.item] }
	          };
	        }
	      })]);
	    var schema$d = constant([
	      strict$1('value'),
	      strict$1('items'),
	      strict$1('dom'),
	      strict$1('components'),
	      defaulted$1('eventOrder', {}),
	      field$1('menuBehaviours', [
	        Highlighting,
	        Representing,
	        Composing,
	        Keying
	      ]),
	      defaultedOf('movement', {
	        mode: 'menu',
	        moveOnTab: true
	      }, choose$1('mode', {
	        grid: [
	          initSize(),
	          output('config', configureGrid)
	        ],
	        matrix: [
	          output('config', configureMatrix),
	          strict$1('rowSelector')
	        ],
	        menu: [
	          defaulted$1('moveOnTab', true),
	          output('config', configureMenu)
	        ]
	      })),
	      itemMarkers(),
	      defaulted$1('fakeFocus', false),
	      defaulted$1('focusManager', dom()),
	      onHandler('onHighlight')
	    ]);
	
	    var focus$4 = constant('alloy.menu-focus');
	
	    var make$1 = function (detail, components, _spec, _externals) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        markers: detail.markers,
	        behaviours: augment(detail.menuBehaviours, [
	          Highlighting.config({
	            highlightClass: detail.markers.selectedItem,
	            itemClass: detail.markers.item,
	            onHighlight: detail.onHighlight
	          }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.value
	            }
	          }),
	          Composing.config({ find: Optional.some }),
	          Keying.config(detail.movement.config(detail, detail.movement))
	        ]),
	        events: derive([
	          run(focus$3(), function (menu, simulatedEvent) {
	            var event = simulatedEvent.event;
	            menu.getSystem().getByDom(event.target).each(function (item) {
	              Highlighting.highlight(menu, item);
	              simulatedEvent.stop();
	              emitWith(menu, focus$4(), {
	                menu: menu,
	                item: item
	              });
	            });
	          }),
	          run(hover(), function (menu, simulatedEvent) {
	            var item = simulatedEvent.event.item;
	            Highlighting.highlight(menu, item);
	          })
	        ]),
	        components: components,
	        eventOrder: detail.eventOrder,
	        domModification: { attributes: { role: 'menu' } }
	      };
	    };
	
	    var Menu = composite$1({
	      name: 'Menu',
	      configFields: schema$d(),
	      partFields: parts$1(),
	      factory: make$1
	    });
	
	    var transpose = function (obj) {
	      return tupleMap(obj, function (v, k) {
	        return {
	          k: v,
	          v: k
	        };
	      });
	    };
	    var trace = function (items, byItem, byMenu, finish) {
	      return get$1(byMenu, finish).bind(function (triggerItem) {
	        return get$1(items, triggerItem).bind(function (triggerMenu) {
	          var rest = trace(items, byItem, byMenu, triggerMenu);
	          return Optional.some([triggerMenu].concat(rest));
	        });
	      }).getOr([]);
	    };
	    var generate$5 = function (menus, expansions) {
	      var items = {};
	      each$1(menus, function (menuItems, menu) {
	        each(menuItems, function (item) {
	          items[item] = menu;
	        });
	      });
	      var byItem = expansions;
	      var byMenu = transpose(expansions);
	      var menuPaths = map$2(byMenu, function (_triggerItem, submenu) {
	        return [submenu].concat(trace(items, byItem, byMenu, submenu));
	      });
	      return map$2(items, function (menu) {
	        return get$1(menuPaths, menu).getOr([menu]);
	      });
	    };
	
	    var init$3 = function () {
	      var expansions = Cell({});
	      var menus = Cell({});
	      var paths = Cell({});
	      var primary = Cell(Optional.none());
	      var directory = Cell({});
	      var clear = function () {
	        expansions.set({});
	        menus.set({});
	        paths.set({});
	        primary.set(Optional.none());
	      };
	      var isClear = function () {
	        return primary.get().isNone();
	      };
	      var setMenuBuilt = function (menuName, built) {
	        var _a;
	        menus.set(__assign(__assign({}, menus.get()), (_a = {}, _a[menuName] = {
	          type: 'prepared',
	          menu: built
	        }, _a)));
	      };
	      var setContents = function (sPrimary, sMenus, sExpansions, dir) {
	        primary.set(Optional.some(sPrimary));
	        expansions.set(sExpansions);
	        menus.set(sMenus);
	        directory.set(dir);
	        var sPaths = generate$5(dir, sExpansions);
	        paths.set(sPaths);
	      };
	      var getTriggeringItem = function (menuValue) {
	        return find$1(expansions.get(), function (v, _k) {
	          return v === menuValue;
	        });
	      };
	      var getTriggerData = function (menuValue, getItemByValue, path) {
	        return getPreparedMenu(menuValue).bind(function (menu) {
	          return getTriggeringItem(menuValue).bind(function (triggeringItemValue) {
	            return getItemByValue(triggeringItemValue).map(function (triggeredItem) {
	              return {
	                triggeredMenu: menu,
	                triggeringItem: triggeredItem,
	                triggeringPath: path
	              };
	            });
	          });
	        });
	      };
	      var getTriggeringPath = function (itemValue, getItemByValue) {
	        var extraPath = filter(lookupItem(itemValue).toArray(), function (menuValue) {
	          return getPreparedMenu(menuValue).isSome();
	        });
	        return get$1(paths.get(), itemValue).bind(function (path) {
	          var revPath = reverse(extraPath.concat(path));
	          var triggers = bind(revPath, function (menuValue, menuIndex) {
	            return getTriggerData(menuValue, getItemByValue, revPath.slice(0, menuIndex + 1)).fold(function () {
	              return primary.get().is(menuValue) ? [] : [Optional.none()];
	            }, function (data) {
	              return [Optional.some(data)];
	            });
	          });
	          return sequence(triggers);
	        });
	      };
	      var expand = function (itemValue) {
	        return get$1(expansions.get(), itemValue).map(function (menu) {
	          var current = get$1(paths.get(), itemValue).getOr([]);
	          return [menu].concat(current);
	        });
	      };
	      var collapse = function (itemValue) {
	        return get$1(paths.get(), itemValue).bind(function (path) {
	          return path.length > 1 ? Optional.some(path.slice(1)) : Optional.none();
	        });
	      };
	      var refresh = function (itemValue) {
	        return get$1(paths.get(), itemValue);
	      };
	      var getPreparedMenu = function (menuValue) {
	        return lookupMenu(menuValue).bind(extractPreparedMenu);
	      };
	      var lookupMenu = function (menuValue) {
	        return get$1(menus.get(), menuValue);
	      };
	      var lookupItem = function (itemValue) {
	        return get$1(expansions.get(), itemValue);
	      };
	      var otherMenus = function (path) {
	        var menuValues = directory.get();
	        return difference(keys(menuValues), path);
	      };
	      var getPrimary = function () {
	        return primary.get().bind(getPreparedMenu);
	      };
	      var getMenus = function () {
	        return menus.get();
	      };
	      return {
	        setMenuBuilt: setMenuBuilt,
	        setContents: setContents,
	        expand: expand,
	        refresh: refresh,
	        collapse: collapse,
	        lookupMenu: lookupMenu,
	        lookupItem: lookupItem,
	        otherMenus: otherMenus,
	        getPrimary: getPrimary,
	        getMenus: getMenus,
	        clear: clear,
	        isClear: isClear,
	        getTriggeringPath: getTriggeringPath
	      };
	    };
	    var extractPreparedMenu = function (prep) {
	      return prep.type === 'prepared' ? Optional.some(prep.menu) : Optional.none();
	    };
	    var LayeredState = {
	      init: init$3,
	      extractPreparedMenu: extractPreparedMenu
	    };
	
	    var make$2 = function (detail, _rawUiSpec) {
	      var submenuParentItems = Cell(Optional.none());
	      var buildMenus = function (container, primaryName, menus) {
	        return map$2(menus, function (spec, name) {
	          var makeSketch = function () {
	            return Menu.sketch(__assign(__assign({}, spec), {
	              value: name,
	              markers: detail.markers,
	              fakeFocus: detail.fakeFocus,
	              onHighlight: detail.onHighlight,
	              focusManager: detail.fakeFocus ? highlights() : dom()
	            }));
	          };
	          return name === primaryName ? {
	            type: 'prepared',
	            menu: container.getSystem().build(makeSketch())
	          } : {
	            type: 'notbuilt',
	            nbMenu: makeSketch
	          };
	        });
	      };
	      var layeredState = LayeredState.init();
	      var setup = function (container) {
	        var componentMap = buildMenus(container, detail.data.primary, detail.data.menus);
	        var directory = toDirectory();
	        layeredState.setContents(detail.data.primary, componentMap, detail.data.expansions, directory);
	        return layeredState.getPrimary();
	      };
	      var getItemValue = function (item) {
	        return Representing.getValue(item).value;
	      };
	      var getItemByValue = function (_container, menus, itemValue) {
	        return findMap(menus, function (menu) {
	          if (!menu.getSystem().isConnected()) {
	            return Optional.none();
	          }
	          var candidates = Highlighting.getCandidates(menu);
	          return find(candidates, function (c) {
	            return getItemValue(c) === itemValue;
	          });
	        });
	      };
	      var toDirectory = function (_container) {
	        return map$2(detail.data.menus, function (data, _menuName) {
	          return bind(data.items, function (item) {
	            return item.type === 'separator' ? [] : [item.data.value];
	          });
	        });
	      };
	      var setActiveMenu = function (container, menu) {
	        Highlighting.highlight(container, menu);
	        Highlighting.getHighlighted(menu).orThunk(function () {
	          return Highlighting.getFirst(menu);
	        }).each(function (item) {
	          dispatch(container, item.element, focusItem());
	        });
	      };
	      var getMenus = function (state, menuValues) {
	        return cat(map(menuValues, function (mv) {
	          return state.lookupMenu(mv).bind(function (prep) {
	            return prep.type === 'prepared' ? Optional.some(prep.menu) : Optional.none();
	          });
	        }));
	      };
	      var closeOthers = function (container, state, path) {
	        var others = getMenus(state, state.otherMenus(path));
	        each(others, function (o) {
	          remove$5(o.element, [detail.markers.backgroundMenu]);
	          if (!detail.stayInDom) {
	            Replacing.remove(container, o);
	          }
	        });
	      };
	      var getSubmenuParents = function (container) {
	        return submenuParentItems.get().getOrThunk(function () {
	          var r = {};
	          var items = descendants(container.element, '.' + detail.markers.item);
	          var parentItems = filter(items, function (i) {
	            return get$3(i, 'aria-haspopup') === 'true';
	          });
	          each(parentItems, function (i) {
	            container.getSystem().getByDom(i).each(function (itemComp) {
	              var key = getItemValue(itemComp);
	              r[key] = itemComp;
	            });
	          });
	          submenuParentItems.set(Optional.some(r));
	          return r;
	        });
	      };
	      var updateAriaExpansions = function (container, path) {
	        var parentItems = getSubmenuParents(container);
	        each$1(parentItems, function (v, k) {
	          var expanded = contains(path, k);
	          set$1(v.element, 'aria-expanded', expanded);
	        });
	      };
	      var updateMenuPath = function (container, state, path) {
	        return Optional.from(path[0]).bind(function (latestMenuName) {
	          return state.lookupMenu(latestMenuName).bind(function (menuPrep) {
	            if (menuPrep.type === 'notbuilt') {
	              return Optional.none();
	            } else {
	              var activeMenu = menuPrep.menu;
	              var rest = getMenus(state, path.slice(1));
	              each(rest, function (r) {
	                add$2(r.element, detail.markers.backgroundMenu);
	              });
	              if (!inBody(activeMenu.element)) {
	                Replacing.append(container, premade$1(activeMenu));
	              }
	              remove$5(activeMenu.element, [detail.markers.backgroundMenu]);
	              setActiveMenu(container, activeMenu);
	              closeOthers(container, state, path);
	              return Optional.some(activeMenu);
	            }
	          });
	        });
	      };
	      var ExpandHighlightDecision;
	      (function (ExpandHighlightDecision) {
	        ExpandHighlightDecision[ExpandHighlightDecision['HighlightSubmenu'] = 0] = 'HighlightSubmenu';
	        ExpandHighlightDecision[ExpandHighlightDecision['HighlightParent'] = 1] = 'HighlightParent';
	      }(ExpandHighlightDecision || (ExpandHighlightDecision = {})));
	      var buildIfRequired = function (container, menuName, menuPrep) {
	        if (menuPrep.type === 'notbuilt') {
	          var menu = container.getSystem().build(menuPrep.nbMenu());
	          layeredState.setMenuBuilt(menuName, menu);
	          return menu;
	        } else {
	          return menuPrep.menu;
	        }
	      };
	      var expandRight = function (container, item, decision) {
	        if (decision === void 0) {
	          decision = ExpandHighlightDecision.HighlightSubmenu;
	        }
	        var value = getItemValue(item);
	        return layeredState.expand(value).bind(function (path) {
	          updateAriaExpansions(container, path);
	          return Optional.from(path[0]).bind(function (menuName) {
	            return layeredState.lookupMenu(menuName).bind(function (activeMenuPrep) {
	              var activeMenu = buildIfRequired(container, menuName, activeMenuPrep);
	              if (!inBody(activeMenu.element)) {
	                Replacing.append(container, premade$1(activeMenu));
	              }
	              detail.onOpenSubmenu(container, item, activeMenu, reverse(path));
	              if (decision === ExpandHighlightDecision.HighlightSubmenu) {
	                Highlighting.highlightFirst(activeMenu);
	                return updateMenuPath(container, layeredState, path);
	              } else {
	                Highlighting.dehighlightAll(activeMenu);
	                return Optional.some(item);
	              }
	            });
	          });
	        });
	      };
	      var collapseLeft = function (container, item) {
	        var value = getItemValue(item);
	        return layeredState.collapse(value).bind(function (path) {
	          updateAriaExpansions(container, path);
	          return updateMenuPath(container, layeredState, path).map(function (activeMenu) {
	            detail.onCollapseMenu(container, item, activeMenu);
	            return activeMenu;
	          });
	        });
	      };
	      var updateView = function (container, item) {
	        var value = getItemValue(item);
	        return layeredState.refresh(value).bind(function (path) {
	          updateAriaExpansions(container, path);
	          return updateMenuPath(container, layeredState, path);
	        });
	      };
	      var onRight = function (container, item) {
	        return inside(item.element) ? Optional.none() : expandRight(container, item, ExpandHighlightDecision.HighlightSubmenu);
	      };
	      var onLeft = function (container, item) {
	        return inside(item.element) ? Optional.none() : collapseLeft(container, item);
	      };
	      var onEscape = function (container, item) {
	        return collapseLeft(container, item).orThunk(function () {
	          return detail.onEscape(container, item).map(function () {
	            return container;
	          });
	        });
	      };
	      var keyOnItem = function (f) {
	        return function (container, simulatedEvent) {
	          return closest$3(simulatedEvent.getSource(), '.' + detail.markers.item).bind(function (target) {
	            return container.getSystem().getByDom(target).toOptional().bind(function (item) {
	              return f(container, item).map(always);
	            });
	          });
	        };
	      };
	      var events = derive([
	        run(focus$4(), function (sandbox, simulatedEvent) {
	          var item = simulatedEvent.event.item;
	          layeredState.lookupItem(getItemValue(item)).each(function () {
	            var menu = simulatedEvent.event.menu;
	            Highlighting.highlight(sandbox, menu);
	            var value = getItemValue(simulatedEvent.event.item);
	            layeredState.refresh(value).each(function (path) {
	              return closeOthers(sandbox, layeredState, path);
	            });
	          });
	        }),
	        runOnExecute(function (component, simulatedEvent) {
	          var target = simulatedEvent.event.target;
	          component.getSystem().getByDom(target).each(function (item) {
	            var itemValue = getItemValue(item);
	            if (itemValue.indexOf('collapse-item') === 0) {
	              collapseLeft(component, item);
	            }
	            expandRight(component, item, ExpandHighlightDecision.HighlightSubmenu).fold(function () {
	              detail.onExecute(component, item);
	            }, noop);
	          });
	        }),
	        runOnAttached(function (container, _simulatedEvent) {
	          setup(container).each(function (primary) {
	            Replacing.append(container, premade$1(primary));
	            detail.onOpenMenu(container, primary);
	            if (detail.highlightImmediately) {
	              setActiveMenu(container, primary);
	            }
	          });
	        })
	      ].concat(detail.navigateOnHover ? [run(hover(), function (sandbox, simulatedEvent) {
	          var item = simulatedEvent.event.item;
	          updateView(sandbox, item);
	          expandRight(sandbox, item, ExpandHighlightDecision.HighlightParent);
	          detail.onHover(sandbox, item);
	        })] : []));
	      var getActiveItem = function (container) {
	        return Highlighting.getHighlighted(container).bind(Highlighting.getHighlighted);
	      };
	      var collapseMenuApi = function (container) {
	        getActiveItem(container).each(function (currentItem) {
	          collapseLeft(container, currentItem);
	        });
	      };
	      var highlightPrimary = function (container) {
	        layeredState.getPrimary().each(function (primary) {
	          setActiveMenu(container, primary);
	        });
	      };
	      var extractMenuFromContainer = function (container) {
	        return Optional.from(container.components()[0]).filter(function (comp) {
	          return get$3(comp.element, 'role') === 'menu';
	        });
	      };
	      var repositionMenus = function (container) {
	        var maybeActivePrimary = layeredState.getPrimary().bind(function (primary) {
	          return getActiveItem(container).bind(function (currentItem) {
	            var itemValue = getItemValue(currentItem);
	            var allMenus = values(layeredState.getMenus());
	            var preparedMenus = cat(map(allMenus, LayeredState.extractPreparedMenu));
	            return layeredState.getTriggeringPath(itemValue, function (v) {
	              return getItemByValue(container, preparedMenus, v);
	            });
	          }).map(function (triggeringPath) {
	            return {
	              primary: primary,
	              triggeringPath: triggeringPath
	            };
	          });
	        });
	        maybeActivePrimary.fold(function () {
	          extractMenuFromContainer(container).each(function (primaryMenu) {
	            detail.onRepositionMenu(container, primaryMenu, []);
	          });
	        }, function (_a) {
	          var primary = _a.primary, triggeringPath = _a.triggeringPath;
	          detail.onRepositionMenu(container, primary, triggeringPath);
	        });
	      };
	      var apis = {
	        collapseMenu: collapseMenuApi,
	        highlightPrimary: highlightPrimary,
	        repositionMenus: repositionMenus
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        markers: detail.markers,
	        behaviours: augment(detail.tmenuBehaviours, [
	          Keying.config({
	            mode: 'special',
	            onRight: keyOnItem(onRight),
	            onLeft: keyOnItem(onLeft),
	            onEscape: keyOnItem(onEscape),
	            focusIn: function (container, _keyInfo) {
	              layeredState.getPrimary().each(function (primary) {
	                dispatch(container, primary.element, focusItem());
	              });
	            }
	          }),
	          Highlighting.config({
	            highlightClass: detail.markers.selectedMenu,
	            itemClass: detail.markers.menu
	          }),
	          Composing.config({
	            find: function (container) {
	              return Highlighting.getHighlighted(container);
	            }
	          }),
	          Replacing.config({})
	        ]),
	        eventOrder: detail.eventOrder,
	        apis: apis,
	        events: events
	      };
	    };
	    var collapseItem = constant('collapse-item');
	
	    var tieredData = function (primary, menus, expansions) {
	      return {
	        primary: primary,
	        menus: menus,
	        expansions: expansions
	      };
	    };
	    var singleData = function (name, menu) {
	      return {
	        primary: name,
	        menus: wrap$1(name, menu),
	        expansions: {}
	      };
	    };
	    var collapseItem$1 = function (text) {
	      return {
	        value: generate$1(collapseItem()),
	        meta: { text: text }
	      };
	    };
	    var tieredMenu = single$2({
	      name: 'TieredMenu',
	      configFields: [
	        onStrictKeyboardHandler('onExecute'),
	        onStrictKeyboardHandler('onEscape'),
	        onStrictHandler('onOpenMenu'),
	        onStrictHandler('onOpenSubmenu'),
	        onHandler('onRepositionMenu'),
	        onHandler('onCollapseMenu'),
	        defaulted$1('highlightImmediately', true),
	        strictObjOf('data', [
	          strict$1('primary'),
	          strict$1('menus'),
	          strict$1('expansions')
	        ]),
	        defaulted$1('fakeFocus', false),
	        onHandler('onHighlight'),
	        onHandler('onHover'),
	        tieredMenuMarkers(),
	        strict$1('dom'),
	        defaulted$1('navigateOnHover', true),
	        defaulted$1('stayInDom', false),
	        field$1('tmenuBehaviours', [
	          Keying,
	          Highlighting,
	          Composing,
	          Replacing
	        ]),
	        defaulted$1('eventOrder', {})
	      ],
	      apis: {
	        collapseMenu: function (apis, tmenu) {
	          apis.collapseMenu(tmenu);
	        },
	        highlightPrimary: function (apis, tmenu) {
	          apis.highlightPrimary(tmenu);
	        },
	        repositionMenus: function (apis, tmenu) {
	          apis.repositionMenus(tmenu);
	        }
	      },
	      factory: make$2,
	      extraApis: {
	        tieredData: tieredData,
	        singleData: singleData,
	        collapseItem: collapseItem$1
	      }
	    });
	
	    var makeMenu = function (detail, menuSandbox, anchor, menuSpec, getBounds) {
	      var lazySink = function () {
	        return detail.lazySink(menuSandbox);
	      };
	      var layouts = menuSpec.type === 'horizontal' ? {
	        layouts: {
	          onLtr: function () {
	            return belowOrAbove();
	          },
	          onRtl: function () {
	            return belowOrAboveRtl();
	          }
	        }
	      } : {};
	      var isFirstTierSubmenu = function (triggeringPaths) {
	        return triggeringPaths.length === 2;
	      };
	      var getSubmenuLayouts = function (triggeringPaths) {
	        return isFirstTierSubmenu(triggeringPaths) ? layouts : {};
	      };
	      return tieredMenu.sketch({
	        dom: { tag: 'div' },
	        data: menuSpec.data,
	        markers: menuSpec.menu.markers,
	        highlightImmediately: menuSpec.menu.highlightImmediately,
	        onEscape: function () {
	          Sandboxing.close(menuSandbox);
	          detail.onEscape.map(function (handler) {
	            return handler(menuSandbox);
	          });
	          return Optional.some(true);
	        },
	        onExecute: function () {
	          return Optional.some(true);
	        },
	        onOpenMenu: function (tmenu, menu) {
	          Positioning.positionWithinBounds(lazySink().getOrDie(), anchor, menu, getBounds());
	        },
	        onOpenSubmenu: function (tmenu, item, submenu, triggeringPaths) {
	          var sink = lazySink().getOrDie();
	          Positioning.position(sink, __assign({
	            anchor: 'submenu',
	            item: item
	          }, getSubmenuLayouts(triggeringPaths)), submenu);
	        },
	        onRepositionMenu: function (tmenu, primaryMenu, submenuTriggers) {
	          var sink = lazySink().getOrDie();
	          Positioning.positionWithinBounds(sink, anchor, primaryMenu, getBounds());
	          each(submenuTriggers, function (st) {
	            var submenuLayouts = getSubmenuLayouts(st.triggeringPath);
	            Positioning.position(sink, __assign({
	              anchor: 'submenu',
	              item: st.triggeringItem
	            }, submenuLayouts), st.triggeredMenu);
	          });
	        }
	      });
	    };
	    var factory = function (detail, spec) {
	      var isPartOfRelated = function (sandbox, queryElem) {
	        var related = detail.getRelated(sandbox);
	        return related.exists(function (rel) {
	          return isPartOf(rel, queryElem);
	        });
	      };
	      var setContent = function (sandbox, thing) {
	        Sandboxing.setContent(sandbox, thing);
	      };
	      var showAt = function (sandbox, anchor, thing) {
	        showWithin(sandbox, anchor, thing, Optional.none());
	      };
	      var showWithin = function (sandbox, anchor, thing, boxElement) {
	        showWithinBounds(sandbox, anchor, thing, function () {
	          return boxElement.map(function (elem) {
	            return box(elem);
	          });
	        });
	      };
	      var showWithinBounds = function (sandbox, anchor, thing, getBounds) {
	        var sink = detail.lazySink(sandbox).getOrDie();
	        Sandboxing.openWhileCloaked(sandbox, thing, function () {
	          return Positioning.positionWithinBounds(sink, anchor, sandbox, getBounds());
	        });
	        Representing.setValue(sandbox, Optional.some({
	          mode: 'position',
	          anchor: anchor,
	          getBounds: getBounds
	        }));
	      };
	      var showMenuAt = function (sandbox, anchor, menuSpec) {
	        showMenuWithinBounds(sandbox, anchor, menuSpec, function () {
	          return Optional.none();
	        });
	      };
	      var showMenuWithinBounds = function (sandbox, anchor, menuSpec, getBounds) {
	        var menu = makeMenu(detail, sandbox, anchor, menuSpec, getBounds);
	        Sandboxing.open(sandbox, menu);
	        Representing.setValue(sandbox, Optional.some({
	          mode: 'menu',
	          menu: menu
	        }));
	      };
	      var hide = function (sandbox) {
	        if (Sandboxing.isOpen(sandbox)) {
	          Representing.setValue(sandbox, Optional.none());
	          Sandboxing.close(sandbox);
	        }
	      };
	      var getContent = function (sandbox) {
	        return Sandboxing.getState(sandbox);
	      };
	      var reposition = function (sandbox) {
	        if (Sandboxing.isOpen(sandbox)) {
	          Representing.getValue(sandbox).each(function (state) {
	            switch (state.mode) {
	            case 'menu':
	              Sandboxing.getState(sandbox).each(function (tmenu) {
	                tieredMenu.repositionMenus(tmenu);
	              });
	              break;
	            case 'position':
	              var sink = detail.lazySink(sandbox).getOrDie();
	              Positioning.positionWithinBounds(sink, state.anchor, sandbox, state.getBounds());
	              break;
	            }
	          });
	        }
	      };
	      var apis = {
	        setContent: setContent,
	        showAt: showAt,
	        showWithin: showWithin,
	        showWithinBounds: showWithinBounds,
	        showMenuAt: showMenuAt,
	        showMenuWithinBounds: showMenuWithinBounds,
	        hide: hide,
	        getContent: getContent,
	        reposition: reposition,
	        isOpen: Sandboxing.isOpen
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        behaviours: augment(detail.inlineBehaviours, [
	          Sandboxing.config({
	            isPartOf: function (sandbox, data, queryElem) {
	              return isPartOf(data, queryElem) || isPartOfRelated(sandbox, queryElem);
	            },
	            getAttachPoint: function (sandbox) {
	              return detail.lazySink(sandbox).getOrDie();
	            },
	            onOpen: function (sandbox) {
	              detail.onShow(sandbox);
	            },
	            onClose: function (sandbox) {
	              detail.onHide(sandbox);
	            }
	          }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: Optional.none()
	            }
	          }),
	          Receiving.config({
	            channels: __assign(__assign({}, receivingChannel(__assign({ isExtraPart: spec.isExtraPart }, detail.fireDismissalEventInstead.map(function (fe) {
	              return { fireEventInstead: { event: fe.event } };
	            }).getOr({})))), receivingChannel$1(__assign(__assign({}, detail.fireRepositionEventInstead.map(function (fe) {
	              return { fireEventInstead: { event: fe.event } };
	            }).getOr({})), { doReposition: reposition })))
	          })
	        ]),
	        eventOrder: detail.eventOrder,
	        apis: apis
	      };
	    };
	    var InlineView = single$2({
	      name: 'InlineView',
	      configFields: [
	        strict$1('lazySink'),
	        onHandler('onShow'),
	        onHandler('onHide'),
	        optionFunction('onEscape'),
	        field$1('inlineBehaviours', [
	          Sandboxing,
	          Representing,
	          Receiving
	        ]),
	        optionObjOf('fireDismissalEventInstead', [defaulted$1('event', dismissRequested())]),
	        optionObjOf('fireRepositionEventInstead', [defaulted$1('event', repositionRequested())]),
	        defaulted$1('getRelated', Optional.none),
	        defaulted$1('isExtraPart', never),
	        defaulted$1('eventOrder', Optional.none)
	      ],
	      factory: factory,
	      apis: {
	        showAt: function (apis, component, anchor, thing) {
	          apis.showAt(component, anchor, thing);
	        },
	        showWithin: function (apis, component, anchor, thing, boxElement) {
	          apis.showWithin(component, anchor, thing, boxElement);
	        },
	        showWithinBounds: function (apis, component, anchor, thing, bounds) {
	          apis.showWithinBounds(component, anchor, thing, bounds);
	        },
	        showMenuAt: function (apis, component, anchor, menuSpec) {
	          apis.showMenuAt(component, anchor, menuSpec);
	        },
	        showMenuWithinBounds: function (apis, component, anchor, menuSpec, bounds) {
	          apis.showMenuWithinBounds(component, anchor, menuSpec, bounds);
	        },
	        hide: function (apis, component) {
	          apis.hide(component);
	        },
	        isOpen: function (apis, component) {
	          return apis.isOpen(component);
	        },
	        getContent: function (apis, component) {
	          return apis.getContent(component);
	        },
	        setContent: function (apis, component, thing) {
	          apis.setContent(component, thing);
	        },
	        reposition: function (apis, component) {
	          apis.reposition(component);
	        }
	      }
	    });
	
	    var westEdgeX$1 = function (anchor) {
	      return anchor.x;
	    };
	    var middleX$1 = function (anchor, element) {
	      return anchor.x + anchor.width / 2 - element.width / 2;
	    };
	    var eastEdgeX$1 = function (anchor, element) {
	      return anchor.x + anchor.width - element.width;
	    };
	    var northY$2 = function (anchor) {
	      return anchor.y;
	    };
	    var southY$2 = function (anchor, element) {
	      return anchor.y + anchor.height - element.height;
	    };
	    var southeast$3 = function (anchor, element, bubbles) {
	      return nu$7(eastEdgeX$1(anchor, element), southY$2(anchor, element), bubbles.innerSoutheast(), northwest(), boundsRestriction(anchor, {
	        right: 0,
	        bottom: 3
	      }), 'layout-inner-se');
	    };
	    var southwest$3 = function (anchor, element, bubbles) {
	      return nu$7(westEdgeX$1(anchor), southY$2(anchor, element), bubbles.innerSouthwest(), northeast(), boundsRestriction(anchor, {
	        left: 1,
	        bottom: 3
	      }), 'layout-inner-sw');
	    };
	    var northeast$3 = function (anchor, element, bubbles) {
	      return nu$7(eastEdgeX$1(anchor, element), northY$2(anchor), bubbles.innerNortheast(), southwest(), boundsRestriction(anchor, {
	        right: 0,
	        top: 2
	      }), 'layout-inner-ne');
	    };
	    var northwest$3 = function (anchor, element, bubbles) {
	      return nu$7(westEdgeX$1(anchor), northY$2(anchor), bubbles.innerNorthwest(), southeast(), boundsRestriction(anchor, {
	        left: 1,
	        top: 2
	      }), 'layout-inner-nw');
	    };
	    var north$3 = function (anchor, element, bubbles) {
	      return nu$7(middleX$1(anchor, element), northY$2(anchor), bubbles.innerNorth(), south(), boundsRestriction(anchor, { top: 2 }), 'layout-inner-n');
	    };
	    var south$3 = function (anchor, element, bubbles) {
	      return nu$7(middleX$1(anchor, element), southY$2(anchor, element), bubbles.innerSouth(), north(), boundsRestriction(anchor, { bottom: 3 }), 'layout-inner-s');
	    };
	
	    var global$2 = tinymce.util.Tools.resolve('tinymce.util.Delay');
	
	    var factory$1 = function (detail) {
	      var events = events$7(detail.action);
	      var tag = detail.dom.tag;
	      var lookupAttr = function (attr) {
	        return get$1(detail.dom, 'attributes').bind(function (attrs) {
	          return get$1(attrs, attr);
	        });
	      };
	      var getModAttributes = function () {
	        if (tag === 'button') {
	          var type = lookupAttr('type').getOr('button');
	          var roleAttrs = lookupAttr('role').map(function (role) {
	            return { role: role };
	          }).getOr({});
	          return __assign({ type: type }, roleAttrs);
	        } else {
	          var role = lookupAttr('role').getOr('button');
	          return { role: role };
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: detail.components,
	        events: events,
	        behaviours: SketchBehaviours.augment(detail.buttonBehaviours, [
	          Focusing.config({}),
	          Keying.config({
	            mode: 'execution',
	            useSpace: true,
	            useEnter: true
	          })
	        ]),
	        domModification: { attributes: getModAttributes() },
	        eventOrder: detail.eventOrder
	      };
	    };
	    var Button = single$2({
	      name: 'Button',
	      factory: factory$1,
	      configFields: [
	        defaulted$1('uid', undefined),
	        strict$1('dom'),
	        defaulted$1('components', []),
	        SketchBehaviours.field('buttonBehaviours', [
	          Focusing,
	          Keying
	        ]),
	        option('action'),
	        option('role'),
	        defaulted$1('eventOrder', {})
	      ]
	    });
	
	    var record = function (spec) {
	      var uid = isSketchSpec(spec) && hasNonNullableKey(spec, 'uid') ? spec.uid : generate$2('memento');
	      var get = function (anyInSystem) {
	        return anyInSystem.getSystem().getByUid(uid).getOrDie();
	      };
	      var getOpt = function (anyInSystem) {
	        return anyInSystem.getSystem().getByUid(uid).toOptional();
	      };
	      var asSpec = function () {
	        return __assign(__assign({}, spec), { uid: uid });
	      };
	      return {
	        get: get,
	        getOpt: getOpt,
	        asSpec: asSpec
	      };
	    };
	
	    var defaultIcon = function (icons) {
	      return Optional.from(icons()['temporary-placeholder']).getOr('!not found!');
	    };
	    var get$e = function (name, icons) {
	      return Optional.from(icons()[name.toLowerCase()]).getOrThunk(function () {
	        return defaultIcon(icons);
	      });
	    };
	    var getOr = function (name, icons, fallback) {
	      return Optional.from(icons()[name.toLowerCase()]).or(fallback).getOrThunk(function () {
	        return defaultIcon(icons);
	      });
	    };
	    var getFirst$1 = function (names, icons) {
	      return findMap(names, function (name) {
	        return Optional.from(icons()[name.toLowerCase()]);
	      }).getOrThunk(function () {
	        return defaultIcon(icons);
	      });
	    };
	
	    var notificationIconMap = {
	      success: 'checkmark',
	      error: 'warning',
	      err: 'error',
	      warning: 'warning',
	      warn: 'warning',
	      info: 'info'
	    };
	    var factory$2 = function (detail) {
	      var memBannerText = record({
	        dom: {
	          tag: 'p',
	          innerHtml: detail.translationProvider(detail.text)
	        },
	        behaviours: derive$1([Replacing.config({})])
	      });
	      var renderPercentBar = function (percent) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-bar'],
	            attributes: { style: 'width: ' + percent + '%' }
	          }
	        };
	      };
	      var renderPercentText = function (percent) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-text'],
	            innerHtml: percent + '%'
	          }
	        };
	      };
	      var memBannerProgress = record({
	        dom: {
	          tag: 'div',
	          classes: detail.progress ? [
	            'tox-progress-bar',
	            'tox-progress-indicator'
	          ] : ['tox-progress-bar']
	        },
	        components: [
	          {
	            dom: {
	              tag: 'div',
	              classes: ['tox-bar-container']
	            },
	            components: [renderPercentBar(0)]
	          },
	          renderPercentText(0)
	        ],
	        behaviours: derive$1([Replacing.config({})])
	      });
	      var updateProgress = function (comp, percent) {
	        if (comp.getSystem().isConnected()) {
	          memBannerProgress.getOpt(comp).each(function (progress) {
	            Replacing.set(progress, [
	              {
	                dom: {
	                  tag: 'div',
	                  classes: ['tox-bar-container']
	                },
	                components: [renderPercentBar(percent)]
	              },
	              renderPercentText(percent)
	            ]);
	          });
	        }
	      };
	      var updateText = function (comp, text$1) {
	        if (comp.getSystem().isConnected()) {
	          var banner = memBannerText.get(comp);
	          Replacing.set(banner, [text(text$1)]);
	        }
	      };
	      var apis = {
	        updateProgress: updateProgress,
	        updateText: updateText
	      };
	      var iconChoices = flatten([
	        detail.icon.toArray(),
	        detail.level.toArray(),
	        detail.level.bind(function (level) {
	          return Optional.from(notificationIconMap[level]);
	        }).toArray()
	      ]);
	      var memButton = record(Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-notification__dismiss',
	            'tox-button',
	            'tox-button--naked',
	            'tox-button--icon'
	          ]
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-icon'],
	              innerHtml: get$e('close', detail.iconProvider),
	              attributes: { 'aria-label': detail.translationProvider('Close') }
	            }
	          }],
	        action: function (comp) {
	          detail.onAction(comp);
	        }
	      }));
	      var components = [
	        {
	          dom: {
	            tag: 'div',
	            classes: ['tox-notification__icon'],
	            innerHtml: getFirst$1(iconChoices, detail.iconProvider)
	          }
	        },
	        {
	          dom: {
	            tag: 'div',
	            classes: ['tox-notification__body']
	          },
	          components: [memBannerText.asSpec()],
	          behaviours: derive$1([Replacing.config({})])
	        }
	      ];
	      return {
	        uid: detail.uid,
	        dom: {
	          tag: 'div',
	          attributes: { role: 'alert' },
	          classes: detail.level.map(function (level) {
	            return [
	              'tox-notification',
	              'tox-notification--in',
	              'tox-notification--' + level
	            ];
	          }).getOr([
	            'tox-notification',
	            'tox-notification--in'
	          ])
	        },
	        behaviours: derive$1([
	          Focusing.config({}),
	          config('notification-events', [run(focusin(), function (comp) {
	              memButton.getOpt(comp).each(Focusing.focus);
	            })])
	        ]),
	        components: components.concat(detail.progress ? [memBannerProgress.asSpec()] : []).concat(!detail.closeButton ? [] : [memButton.asSpec()]),
	        apis: apis
	      };
	    };
	    var Notification = single$2({
	      name: 'Notification',
	      factory: factory$2,
	      configFields: [
	        option('level'),
	        strict$1('progress'),
	        strict$1('icon'),
	        strict$1('onAction'),
	        strict$1('text'),
	        strict$1('iconProvider'),
	        strict$1('translationProvider'),
	        defaultedBoolean('closeButton', true)
	      ],
	      apis: {
	        updateProgress: function (apis, comp, percent) {
	          apis.updateProgress(comp, percent);
	        },
	        updateText: function (apis, comp, text) {
	          apis.updateText(comp, text);
	        }
	      }
	    });
	
	    function NotificationManagerImpl (editor, extras, uiMothership) {
	      var backstage = extras.backstage;
	      var getLayoutDirection = function (rel) {
	        switch (rel) {
	        case 'bc-bc':
	          return south$3;
	        case 'tc-tc':
	          return north$3;
	        case 'tc-bc':
	          return north$1;
	        case 'bc-tc':
	        default:
	          return south$1;
	        }
	      };
	      var prePositionNotifications = function (notifications) {
	        each(notifications, function (notification) {
	          return notification.moveTo(0, 0);
	        });
	      };
	      var positionNotifications = function (notifications) {
	        if (notifications.length > 0) {
	          head(notifications).each(function (firstItem) {
	            return firstItem.moveRel(null, 'banner');
	          });
	          each(notifications, function (notification, index) {
	            if (index > 0) {
	              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
	            }
	          });
	        }
	      };
	      var reposition = function (notifications) {
	        prePositionNotifications(notifications);
	        positionNotifications(notifications);
	      };
	      var open = function (settings, closeCallback) {
	        var hideCloseButton = !settings.closeButton && settings.timeout && (settings.timeout > 0 || settings.timeout < 0);
	        var close = function () {
	          closeCallback();
	          InlineView.hide(notificationWrapper);
	        };
	        var notification = build$1(Notification.sketch({
	          text: settings.text,
	          level: contains([
	            'success',
	            'error',
	            'warning',
	            'warn',
	            'info'
	          ], settings.type) ? settings.type : undefined,
	          progress: settings.progressBar === true,
	          icon: Optional.from(settings.icon),
	          closeButton: !hideCloseButton,
	          onAction: close,
	          iconProvider: backstage.shared.providers.icons,
	          translationProvider: backstage.shared.providers.translate
	        }));
	        var notificationWrapper = build$1(InlineView.sketch(__assign({
	          dom: {
	            tag: 'div',
	            classes: ['tox-notifications-container']
	          },
	          lazySink: extras.backstage.shared.getSink,
	          fireDismissalEventInstead: {}
	        }, backstage.shared.header.isPositionedAtTop() ? {} : { fireRepositionEventInstead: {} })));
	        uiMothership.add(notificationWrapper);
	        if (settings.timeout > 0) {
	          global$2.setTimeout(function () {
	            close();
	          }, settings.timeout);
	        }
	        return {
	          close: close,
	          moveTo: function (x, y) {
	            InlineView.showAt(notificationWrapper, {
	              anchor: 'makeshift',
	              x: x,
	              y: y
	            }, premade$1(notification));
	          },
	          moveRel: function (element, rel) {
	            if (rel !== 'banner') {
	              var layoutDirection_1 = getLayoutDirection(rel);
	              var nodeAnchor = {
	                anchor: 'node',
	                root: body(),
	                node: Optional.some(SugarElement.fromDom(element)),
	                layouts: {
	                  onRtl: function () {
	                    return [layoutDirection_1];
	                  },
	                  onLtr: function () {
	                    return [layoutDirection_1];
	                  }
	                }
	              };
	              InlineView.showAt(notificationWrapper, nodeAnchor, premade$1(notification));
	            } else {
	              InlineView.showAt(notificationWrapper, extras.backstage.shared.anchors.banner(), premade$1(notification));
	            }
	          },
	          text: function (nuText) {
	            Notification.updateText(notification, nuText);
	          },
	          settings: settings,
	          getEl: function () {
	            return notification.element.dom;
	          },
	          progressBar: {
	            value: function (percent) {
	              Notification.updateProgress(notification, percent);
	            }
	          }
	        };
	      };
	      var close = function (notification) {
	        notification.close();
	      };
	      var getArgs = function (notification) {
	        return notification.settings;
	      };
	      return {
	        open: open,
	        close: close,
	        reposition: reposition,
	        getArgs: getArgs
	      };
	    }
	
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer === null) {
	          timer = setTimeout(function () {
	            fn.apply(null, args);
	            timer = null;
	          }, rate);
	        }
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	    var last$2 = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          clearTimeout(timer);
	        }
	        timer = setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var global$3 = tinymce.util.Tools.resolve('tinymce.dom.TextSeeker');
	
	    var isBoundary = function (dom, node) {
	      return dom.isBlock(node) || contains([
	        'BR',
	        'IMG',
	        'HR',
	        'INPUT'
	      ], node.nodeName) || dom.getContentEditable(node) === 'false';
	    };
	    var repeatLeft = function (dom, node, offset, process, rootNode) {
	      var search = global$3(dom, function (node) {
	        return isBoundary(dom, node);
	      });
	      return Optional.from(search.backwards(node, offset, process, rootNode));
	    };
	
	    var autocompleteSelector = '[data-mce-autocompleter]';
	    var create$4 = function (editor, range) {
	      return detect$4(SugarElement.fromDom(editor.selection.getNode())).getOrThunk(function () {
	        var wrapper = SugarElement.fromHtml('<span data-mce-autocompleter="1" data-mce-bogus="1"></span>', editor.getDoc());
	        append(wrapper, SugarElement.fromDom(range.extractContents()));
	        range.insertNode(wrapper.dom);
	        parent(wrapper).each(function (elm) {
	          return elm.dom.normalize();
	        });
	        last$1(wrapper).map(function (last) {
	          editor.selection.setCursorLocation(last.dom, getEnd(last));
	        });
	        return wrapper;
	      });
	    };
	    var detect$4 = function (elm) {
	      return closest$3(elm, autocompleteSelector);
	    };
	
	    var isValidTextRange = function (rng) {
	      return rng.collapsed && rng.startContainer.nodeType === 3;
	    };
	    var getText = function (rng) {
	      return rng.toString().replace(/\u00A0/g, ' ').replace(/\uFEFF/g, '');
	    };
	    var isWhitespace = function (chr) {
	      return chr !== '' && ' \xA0\f\n\r\t\x0B'.indexOf(chr) !== -1;
	    };
	
	    var stripTriggerChar = function (text, triggerCh) {
	      return text.substring(triggerCh.length);
	    };
	    var findChar = function (text, index, ch) {
	      var i;
	      for (i = index - 1; i >= 0; i--) {
	        var char = text.charAt(i);
	        if (isWhitespace(char)) {
	          return Optional.none();
	        }
	        if (char === ch) {
	          break;
	        }
	      }
	      return Optional.some(i);
	    };
	    var findStart = function (dom, initRange, ch, minChars) {
	      if (minChars === void 0) {
	        minChars = 0;
	      }
	      if (!isValidTextRange(initRange)) {
	        return Optional.none();
	      }
	      var findTriggerChIndex = function (element, offset, text) {
	        return findChar(text, offset, ch).getOr(offset);
	      };
	      var root = dom.getParent(initRange.startContainer, dom.isBlock) || dom.getRoot();
	      return repeatLeft(dom, initRange.startContainer, initRange.startOffset, findTriggerChIndex, root).bind(function (spot) {
	        var range = initRange.cloneRange();
	        range.setStart(spot.container, spot.offset);
	        range.setEnd(initRange.endContainer, initRange.endOffset);
	        if (range.collapsed) {
	          return Optional.none();
	        }
	        var text = getText(range);
	        var triggerCharIndex = text.lastIndexOf(ch);
	        if (triggerCharIndex !== 0 || stripTriggerChar(text, ch).length < minChars) {
	          return Optional.none();
	        } else {
	          return Optional.some({
	            text: stripTriggerChar(text, ch),
	            range: range,
	            triggerChar: ch
	          });
	        }
	      });
	    };
	    var getContext = function (dom, initRange, ch, minChars) {
	      if (minChars === void 0) {
	        minChars = 0;
	      }
	      return detect$4(SugarElement.fromDom(initRange.startContainer)).fold(function () {
	        return findStart(dom, initRange, ch, minChars);
	      }, function (elm) {
	        var range = dom.createRng();
	        range.selectNode(elm.dom);
	        var text = getText(range);
	        return Optional.some({
	          range: range,
	          text: stripTriggerChar(text, ch),
	          triggerChar: ch
	        });
	      });
	    };
	
	    var setup = function (api, editor) {
	      editor.on('keypress compositionend', api.onKeypress.throttle);
	      editor.on('remove', api.onKeypress.cancel);
	      var redirectKeyToItem = function (item, e) {
	        emitWith(item, keydown(), { raw: e });
	      };
	      editor.on('keydown', function (e) {
	        var getItem = function () {
	          return api.getView().bind(Highlighting.getHighlighted);
	        };
	        if (e.which === 8) {
	          api.onKeypress.throttle(e);
	        }
	        if (api.isActive()) {
	          if (e.which === 27) {
	            api.cancelIfNecessary();
	          }
	          if (api.isMenuOpen()) {
	            if (e.which === 13) {
	              getItem().each(emitExecute);
	              e.preventDefault();
	            } else if (e.which === 40) {
	              getItem().fold(function () {
	                api.getView().each(Highlighting.highlightFirst);
	              }, function (item) {
	                redirectKeyToItem(item, e);
	              });
	              e.preventDefault();
	              e.stopImmediatePropagation();
	            } else if (e.which === 37 || e.which === 38 || e.which === 39) {
	              getItem().each(function (item) {
	                redirectKeyToItem(item, e);
	                e.preventDefault();
	                e.stopImmediatePropagation();
	              });
	            }
	          } else {
	            if (e.which === 13 || e.which === 38 || e.which === 40) {
	              api.cancelIfNecessary();
	            }
	          }
	        }
	      });
	      editor.on('NodeChange', function (e) {
	        if (api.isActive() && !api.isProcessingAction() && detect$4(SugarElement.fromDom(e.element)).isNone()) {
	          api.cancelIfNecessary();
	        }
	      });
	    };
	    var AutocompleterEditorEvents = { setup: setup };
	
	    var global$4 = tinymce.util.Tools.resolve('tinymce.util.Promise');
	
	    var point$1 = function (container, offset) {
	      return {
	        container: container,
	        offset: offset
	      };
	    };
	
	    var isText$1 = function (node) {
	      return node.nodeType === TEXT;
	    };
	    var isElement$1 = function (node) {
	      return node.nodeType === ELEMENT;
	    };
	    var toLast = function (node) {
	      if (isText$1(node)) {
	        return point$1(node, node.data.length);
	      } else {
	        var children = node.childNodes;
	        return children.length > 0 ? toLast(children[children.length - 1]) : point$1(node, children.length);
	      }
	    };
	    var toLeaf = function (node, offset) {
	      var children = node.childNodes;
	      if (children.length > 0 && offset < children.length) {
	        return toLeaf(children[offset], 0);
	      } else if (children.length > 0 && isElement$1(node) && children.length === offset) {
	        return toLast(children[children.length - 1]);
	      } else {
	        return point$1(node, offset);
	      }
	    };
	
	    var isPreviousCharContent = function (dom, leaf) {
	      return repeatLeft(dom, leaf.container, leaf.offset, function (element, offset) {
	        return offset === 0 ? -1 : offset;
	      }, dom.getRoot()).filter(function (spot) {
	        var char = spot.container.data.charAt(spot.offset - 1);
	        return !isWhitespace(char);
	      }).isSome();
	    };
	    var isStartOfWord = function (dom) {
	      return function (rng) {
	        var leaf = toLeaf(rng.startContainer, rng.startOffset);
	        return !isPreviousCharContent(dom, leaf);
	      };
	    };
	    var getTriggerContext = function (dom, initRange, database) {
	      return findMap(database.triggerChars, function (ch) {
	        return getContext(dom, initRange, ch);
	      });
	    };
	    var lookup = function (editor, getDatabase) {
	      var database = getDatabase();
	      var rng = editor.selection.getRng();
	      return getTriggerContext(editor.dom, rng, database).bind(function (context) {
	        return lookupWithContext(editor, getDatabase, context);
	      });
	    };
	    var lookupWithContext = function (editor, getDatabase, context, fetchOptions) {
	      if (fetchOptions === void 0) {
	        fetchOptions = {};
	      }
	      var database = getDatabase();
	      var rng = editor.selection.getRng();
	      var startText = rng.startContainer.nodeValue;
	      var autocompleters = filter(database.lookupByChar(context.triggerChar), function (autocompleter) {
	        return context.text.length >= autocompleter.minChars && autocompleter.matches.getOrThunk(function () {
	          return isStartOfWord(editor.dom);
	        })(context.range, startText, context.text);
	      });
	      if (autocompleters.length === 0) {
	        return Optional.none();
	      }
	      var lookupData = global$4.all(map(autocompleters, function (ac) {
	        var fetchResult = ac.fetch(context.text, ac.maxResults, fetchOptions);
	        return fetchResult.then(function (results) {
	          return {
	            matchText: context.text,
	            items: results,
	            columns: ac.columns,
	            onAction: ac.onAction,
	            highlightOn: ac.highlightOn
	          };
	        });
	      }));
	      return Optional.some({
	        lookupData: lookupData,
	        context: context
	      });
	    };
	
	    var separatorMenuItemSchema = objOf([
	      strictString('type'),
	      optionString('text')
	    ]);
	    var createSeparatorMenuItem = function (spec) {
	      return asRaw('separatormenuitem', separatorMenuItemSchema, spec);
	    };
	
	    var autocompleterItemSchema = objOf([
	      defaulted$1('type', 'autocompleteitem'),
	      defaulted$1('active', false),
	      defaulted$1('disabled', false),
	      defaulted$1('meta', {}),
	      strictString('value'),
	      optionString('text'),
	      optionString('icon')
	    ]);
	    var autocompleterSchema = objOf([
	      strictString('type'),
	      strictString('ch'),
	      defaultedNumber('minChars', 1),
	      defaulted$1('columns', 1),
	      defaultedNumber('maxResults', 10),
	      optionFunction('matches'),
	      strictFunction('fetch'),
	      strictFunction('onAction'),
	      defaultedArrayOf('highlightOn', [], string)
	    ]);
	    var createSeparatorItem = function (spec) {
	      return asRaw('Autocompleter.Separator', separatorMenuItemSchema, spec);
	    };
	    var createAutocompleterItem = function (spec) {
	      return asRaw('Autocompleter.Item', autocompleterItemSchema, spec);
	    };
	    var createAutocompleter = function (spec) {
	      return asRaw('Autocompleter', autocompleterSchema, spec);
	    };
	
	    var baseToolbarButtonFields = [
	      defaultedBoolean('disabled', false),
	      optionString('tooltip'),
	      optionString('icon'),
	      optionString('text'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      })
	    ];
	    var toolbarButtonSchema = objOf([
	      strictString('type'),
	      strictFunction('onAction')
	    ].concat(baseToolbarButtonFields));
	    var createToolbarButton = function (spec) {
	      return asRaw('toolbarbutton', toolbarButtonSchema, spec);
	    };
	
	    var baseToolbarToggleButtonFields = [defaultedBoolean('active', false)].concat(baseToolbarButtonFields);
	    var toggleButtonSchema = objOf(baseToolbarToggleButtonFields.concat([
	      strictString('type'),
	      strictFunction('onAction')
	    ]));
	    var createToggleButton = function (spec) {
	      return asRaw('ToggleButton', toggleButtonSchema, spec);
	    };
	
	    var contextBarFields = [
	      defaultedFunction('predicate', never),
	      defaultedStringEnum('scope', 'node', [
	        'node',
	        'editor'
	      ]),
	      defaultedStringEnum('position', 'selection', [
	        'node',
	        'selection',
	        'line'
	      ])
	    ];
	
	    var contextButtonFields = baseToolbarButtonFields.concat([
	      defaulted$1('type', 'contextformbutton'),
	      defaulted$1('primary', false),
	      strictFunction('onAction'),
	      state$1('original', identity)
	    ]);
	    var contextToggleButtonFields = baseToolbarToggleButtonFields.concat([
	      defaulted$1('type', 'contextformbutton'),
	      defaulted$1('primary', false),
	      strictFunction('onAction'),
	      state$1('original', identity)
	    ]);
	    var launchButtonFields = baseToolbarButtonFields.concat([defaulted$1('type', 'contextformbutton')]);
	    var launchToggleButtonFields = baseToolbarToggleButtonFields.concat([defaulted$1('type', 'contextformtogglebutton')]);
	    var toggleOrNormal = choose$1('type', {
	      contextformbutton: contextButtonFields,
	      contextformtogglebutton: contextToggleButtonFields
	    });
	    var contextFormSchema = objOf([
	      defaulted$1('type', 'contextform'),
	      defaultedFunction('initValue', function () {
	        return '';
	      }),
	      optionString('label'),
	      strictArrayOf('commands', toggleOrNormal),
	      optionOf('launch', choose$1('type', {
	        contextformbutton: launchButtonFields,
	        contextformtogglebutton: launchToggleButtonFields
	      }))
	    ].concat(contextBarFields));
	    var createContextForm = function (spec) {
	      return asRaw('ContextForm', contextFormSchema, spec);
	    };
	
	    var contextToolbarSchema = objOf([
	      defaulted$1('type', 'contexttoolbar'),
	      strictString('items')
	    ].concat(contextBarFields));
	    var createContextToolbar = function (spec) {
	      return asRaw('ContextToolbar', contextToolbarSchema, spec);
	    };
	
	    var stringArray = function (a) {
	      var all = {};
	      each(a, function (key) {
	        all[key] = {};
	      });
	      return keys(all);
	    };
	
	    var register = function (editor) {
	      var popups = editor.ui.registry.getAll().popups;
	      var dataset = map$2(popups, function (popup) {
	        return createAutocompleter(popup).fold(function (err) {
	          throw new Error(formatError(err));
	        }, function (x) {
	          return x;
	        });
	      });
	      var triggerChars = stringArray(mapToArray(dataset, function (v) {
	        return v.ch;
	      }));
	      var datasetValues = values(dataset);
	      var lookupByChar = function (ch) {
	        return filter(datasetValues, function (dv) {
	          return dv.ch === ch;
	        });
	      };
	      return {
	        dataset: dataset,
	        triggerChars: triggerChars,
	        lookupByChar: lookupByChar
	      };
	    };
	
	    var ItemResponse;
	    (function (ItemResponse) {
	      ItemResponse[ItemResponse['CLOSE_ON_EXECUTE'] = 0] = 'CLOSE_ON_EXECUTE';
	      ItemResponse[ItemResponse['BUBBLE_TO_SANDBOX'] = 1] = 'BUBBLE_TO_SANDBOX';
	    }(ItemResponse || (ItemResponse = {})));
	    var ItemResponse$1 = ItemResponse;
	
	    var navClass = 'tox-menu-nav__js';
	    var selectableClass = 'tox-collection__item';
	    var colorClass = 'tox-swatch';
	    var presetClasses = {
	      normal: navClass,
	      color: colorClass
	    };
	    var tickedClass = 'tox-collection__item--enabled';
	    var groupHeadingClass = 'tox-collection__group-heading';
	    var iconClass = 'tox-collection__item-icon';
	    var textClass = 'tox-collection__item-label';
	    var accessoryClass = 'tox-collection__item-accessory';
	    var caretClass = 'tox-collection__item-caret';
	    var checkmarkClass = 'tox-collection__item-checkmark';
	    var activeClass = 'tox-collection__item--active';
	    var iconClassRtl = 'tox-collection__item-icon-rtl';
	    var containerClass = 'tox-collection__item-container';
	    var containerColumnClass = 'tox-collection__item-container--column';
	    var containerRowClass = 'tox-collection__item-container--row';
	    var containerAlignRightClass = 'tox-collection__item-container--align-right';
	    var containerAlignLeftClass = 'tox-collection__item-container--align-left';
	    var containerValignTopClass = 'tox-collection__item-container--valign-top';
	    var containerValignMiddleClass = 'tox-collection__item-container--valign-middle';
	    var containerValignBottomClass = 'tox-collection__item-container--valign-bottom';
	    var classForPreset = function (presets) {
	      return get$1(presetClasses, presets).getOr(navClass);
	    };
	
	    var forMenu = function (presets) {
	      if (presets === 'color') {
	        return 'tox-swatches';
	      } else {
	        return 'tox-menu';
	      }
	    };
	    var classes = function (presets) {
	      return {
	        backgroundMenu: 'tox-background-menu',
	        selectedMenu: 'tox-selected-menu',
	        selectedItem: 'tox-collection__item--active',
	        hasIcons: 'tox-menu--has-icons',
	        menu: forMenu(presets),
	        tieredMenu: 'tox-tiered-menu'
	      };
	    };
	
	    var markers$1 = function (presets) {
	      var menuClasses = classes(presets);
	      return {
	        backgroundMenu: menuClasses.backgroundMenu,
	        selectedMenu: menuClasses.selectedMenu,
	        menu: menuClasses.menu,
	        selectedItem: menuClasses.selectedItem,
	        item: classForPreset(presets)
	      };
	    };
	    var dom$1 = function (hasIcons, columns, presets) {
	      var menuClasses = classes(presets);
	      return {
	        tag: 'div',
	        classes: flatten([
	          [
	            menuClasses.menu,
	            'tox-menu-' + columns + '-column'
	          ],
	          hasIcons ? [menuClasses.hasIcons] : []
	        ])
	      };
	    };
	    var components$1 = [Menu.parts.items({})];
	    var part = function (hasIcons, columns, presets) {
	      var menuClasses = classes(presets);
	      var d = {
	        tag: 'div',
	        classes: flatten([[menuClasses.tieredMenu]])
	      };
	      return {
	        dom: d,
	        markers: markers$1(presets)
	      };
	    };
	
	    var chunk$1 = function (rowDom, numColumns) {
	      return function (items) {
	        var chunks = chunk(items, numColumns);
	        return map(chunks, function (c) {
	          return {
	            dom: rowDom,
	            components: c
	          };
	        });
	      };
	    };
	    var forSwatch = function (columns) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-menu',
	            'tox-swatches-menu'
	          ]
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-swatches']
	            },
	            components: [Menu.parts.items({
	                preprocess: columns !== 'auto' ? chunk$1({
	                  tag: 'div',
	                  classes: ['tox-swatches__row']
	                }, columns) : identity
	              })]
	          }]
	      };
	    };
	    var forToolbar = function (columns) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-menu',
	            'tox-collection',
	            'tox-collection--toolbar',
	            'tox-collection--toolbar-lg'
	          ]
	        },
	        components: [Menu.parts.items({
	            preprocess: chunk$1({
	              tag: 'div',
	              classes: ['tox-collection__group']
	            }, columns)
	          })]
	      };
	    };
	    var preprocessCollection = function (items, isSeparator) {
	      var allSplits = [];
	      var currentSplit = [];
	      each(items, function (item, i) {
	        if (isSeparator(item, i)) {
	          if (currentSplit.length > 0) {
	            allSplits.push(currentSplit);
	          }
	          currentSplit = [];
	          if (has(item.dom, 'innerHtml')) {
	            currentSplit.push(item);
	          }
	        } else {
	          currentSplit.push(item);
	        }
	      });
	      if (currentSplit.length > 0) {
	        allSplits.push(currentSplit);
	      }
	      return map(allSplits, function (s) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-collection__group']
	          },
	          components: s
	        };
	      });
	    };
	    var forCollection = function (columns, initItems, _hasIcons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-menu',
	            'tox-collection'
	          ].concat(columns === 1 ? ['tox-collection--list'] : ['tox-collection--grid'])
	        },
	        components: [Menu.parts.items({
	            preprocess: function (items) {
	              if (columns !== 'auto' && columns > 1) {
	                return chunk$1({
	                  tag: 'div',
	                  classes: ['tox-collection__group']
	                }, columns)(items);
	              } else {
	                return preprocessCollection(items, function (_item, i) {
	                  return initItems[i].type === 'separator';
	                });
	              }
	            }
	          })]
	      };
	    };
	    var forHorizontalCollection = function (initItems, _hasIcons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-collection',
	            'tox-collection--horizontal'
	          ]
	        },
	        components: [Menu.parts.items({
	            preprocess: function (items) {
	              return preprocessCollection(items, function (_item, i) {
	                return initItems[i].type === 'separator';
	              });
	            }
	          })]
	      };
	    };
	
	    var menuHasIcons = function (xs) {
	      return exists(xs, function (item) {
	        return 'icon' in item && item.icon !== undefined;
	      });
	    };
	    var handleError = function (error) {
	      console.error(formatError(error));
	      console.log(error);
	      return Optional.none();
	    };
	    var createHorizontalPartialMenuWithAlloyItems = function (value, _hasIcons, items, _columns, _presets) {
	      var structure = forHorizontalCollection(items);
	      return {
	        value: value,
	        dom: structure.dom,
	        components: structure.components,
	        items: items
	      };
	    };
	    var createPartialMenuWithAlloyItems = function (value, hasIcons, items, columns, presets) {
	      if (presets === 'color') {
	        var structure = forSwatch(columns);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'normal' && columns === 'auto') {
	        var structure = forCollection(columns, items);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'normal' && columns === 1) {
	        var structure = forCollection(1, items);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'normal') {
	        var structure = forCollection(columns, items);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      if (presets === 'listpreview' && columns !== 'auto') {
	        var structure = forToolbar(columns);
	        return {
	          value: value,
	          dom: structure.dom,
	          components: structure.components,
	          items: items
	        };
	      }
	      return {
	        value: value,
	        dom: dom$1(hasIcons, columns, presets),
	        components: components$1,
	        items: items
	      };
	    };
	
	    var cardImageFields = [
	      strictString('type'),
	      strictString('src'),
	      optionString('alt'),
	      defaultedArrayOf('classes', [], string)
	    ];
	    var cardImageSchema = objOf(cardImageFields);
	
	    var cardTextFields = [
	      strictString('type'),
	      strictString('text'),
	      optionString('name'),
	      defaultedArrayOf('classes', ['tox-collection__item-label'], string)
	    ];
	    var cardTextSchema = objOf(cardTextFields);
	
	    var itemSchema$2 = valueThunkOf(function () {
	      return chooseProcessor('type', {
	        cardimage: cardImageSchema,
	        cardtext: cardTextSchema,
	        cardcontainer: cardContainerSchema
	      });
	    });
	    var cardContainerSchema = objOf([
	      strictString('type'),
	      defaultedString('direction', 'horizontal'),
	      defaultedString('align', 'left'),
	      defaultedString('valign', 'middle'),
	      strictArrayOf('items', itemSchema$2)
	    ]);
	
	    var commonMenuItemFields = [
	      defaultedBoolean('disabled', false),
	      optionString('text'),
	      optionString('shortcut'),
	      field('value', 'value', defaultedThunk(function () {
	        return generate$1('menuitem-value');
	      }), anyValue$1()),
	      defaulted$1('meta', {})
	    ];
	
	    var cardMenuItemSchema = objOf([
	      strictString('type'),
	      optionString('label'),
	      strictArrayOf('items', itemSchema$2),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      defaultedFunction('onAction', noop)
	    ].concat(commonMenuItemFields));
	    var createCardMenuItem = function (spec) {
	      return asRaw('cardmenuitem', cardMenuItemSchema, spec);
	    };
	
	    var choiceMenuItemSchema = objOf([
	      strictString('type'),
	      defaultedBoolean('active', false),
	      optionString('icon')
	    ].concat(commonMenuItemFields));
	    var createChoiceMenuItem = function (spec) {
	      return asRaw('choicemenuitem', choiceMenuItemSchema, spec);
	    };
	
	    var fancyTypes = [
	      'inserttable',
	      'colorswatch'
	    ];
	    var fancyMenuItemSchema = objOf([
	      strictString('type'),
	      strictStringEnum('fancytype', fancyTypes),
	      defaultedFunction('onAction', noop)
	    ]);
	    var createFancyMenuItem = function (spec) {
	      return asRaw('fancymenuitem', fancyMenuItemSchema, spec);
	    };
	
	    var menuItemSchema = objOf([
	      strictString('type'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      defaultedFunction('onAction', noop),
	      optionString('icon')
	    ].concat(commonMenuItemFields));
	    var createMenuItem = function (spec) {
	      return asRaw('menuitem', menuItemSchema, spec);
	    };
	
	    var nestedMenuItemSchema = objOf([
	      strictString('type'),
	      strictFunction('getSubmenuItems'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      optionString('icon')
	    ].concat(commonMenuItemFields));
	    var createNestedMenuItem = function (spec) {
	      return asRaw('nestedmenuitem', nestedMenuItemSchema, spec);
	    };
	
	    var toggleMenuItemSchema = objOf([
	      strictString('type'),
	      optionString('icon'),
	      defaultedBoolean('active', false),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      strictFunction('onAction')
	    ].concat(commonMenuItemFields));
	    var createToggleMenuItem = function (spec) {
	      return asRaw('togglemenuitem', toggleMenuItemSchema, spec);
	    };
	
	    var detectSize = function (comp, margin, selectorClass) {
	      var descendants$1 = descendants(comp.element, '.' + selectorClass);
	      if (descendants$1.length > 0) {
	        var columnLength = findIndex(descendants$1, function (c) {
	          var thisTop = c.dom.getBoundingClientRect().top;
	          var cTop = descendants$1[0].dom.getBoundingClientRect().top;
	          return Math.abs(thisTop - cTop) > margin;
	        }).getOr(descendants$1.length);
	        return Optional.some({
	          numColumns: columnLength,
	          numRows: Math.ceil(descendants$1.length / columnLength)
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	
	    var namedEvents = function (name, handlers) {
	      return derive$1([config(name, handlers)]);
	    };
	    var unnamedEvents = function (handlers) {
	      return namedEvents(generate$1('unnamed-events'), handlers);
	    };
	    var SimpleBehaviours = {
	      namedEvents: namedEvents,
	      unnamedEvents: unnamedEvents
	    };
	
	    var ExclusivityChannel = generate$1('tooltip.exclusive');
	    var ShowTooltipEvent = generate$1('tooltip.show');
	    var HideTooltipEvent = generate$1('tooltip.hide');
	
	    var hideAllExclusive = function (component, _tConfig, _tState) {
	      component.getSystem().broadcastOn([ExclusivityChannel], {});
	    };
	    var setComponents = function (component, tConfig, tState, specs) {
	      tState.getTooltip().each(function (tooltip) {
	        if (tooltip.getSystem().isConnected()) {
	          Replacing.set(tooltip, specs);
	        }
	      });
	    };
	
	    var TooltippingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        hideAllExclusive: hideAllExclusive,
	        setComponents: setComponents
	    });
	
	    var events$8 = function (tooltipConfig, state) {
	      var hide = function (comp) {
	        state.getTooltip().each(function (p) {
	          detach(p);
	          tooltipConfig.onHide(comp, p);
	          state.clearTooltip();
	        });
	        state.clearTimer();
	      };
	      var show = function (comp) {
	        if (!state.isShowing()) {
	          hideAllExclusive(comp);
	          var sink = tooltipConfig.lazySink(comp).getOrDie();
	          var popup = comp.getSystem().build({
	            dom: tooltipConfig.tooltipDom,
	            components: tooltipConfig.tooltipComponents,
	            events: derive(tooltipConfig.mode === 'normal' ? [
	              run(mouseover(), function (_) {
	                emit(comp, ShowTooltipEvent);
	              }),
	              run(mouseout(), function (_) {
	                emit(comp, HideTooltipEvent);
	              })
	            ] : []),
	            behaviours: derive$1([Replacing.config({})])
	          });
	          state.setTooltip(popup);
	          attach$1(sink, popup);
	          tooltipConfig.onShow(comp, popup);
	          Positioning.position(sink, tooltipConfig.anchor(comp), popup);
	        }
	      };
	      return derive(flatten([
	        [
	          run(ShowTooltipEvent, function (comp) {
	            state.resetTimer(function () {
	              show(comp);
	            }, tooltipConfig.delay);
	          }),
	          run(HideTooltipEvent, function (comp) {
	            state.resetTimer(function () {
	              hide(comp);
	            }, tooltipConfig.delay);
	          }),
	          run(receive(), function (comp, message) {
	            var receivingData = message;
	            if (!receivingData.universal) {
	              if (contains(receivingData.channels, ExclusivityChannel)) {
	                hide(comp);
	              }
	            }
	          }),
	          runOnDetached(function (comp) {
	            hide(comp);
	          })
	        ],
	        tooltipConfig.mode === 'normal' ? [
	          run(focusin(), function (comp) {
	            emit(comp, ShowTooltipEvent);
	          }),
	          run(postBlur(), function (comp) {
	            emit(comp, HideTooltipEvent);
	          }),
	          run(mouseover(), function (comp) {
	            emit(comp, ShowTooltipEvent);
	          }),
	          run(mouseout(), function (comp) {
	            emit(comp, HideTooltipEvent);
	          })
	        ] : [
	          run(highlight(), function (comp, _se) {
	            emit(comp, ShowTooltipEvent);
	          }),
	          run(dehighlight(), function (comp) {
	            emit(comp, HideTooltipEvent);
	          })
	        ]
	      ]));
	    };
	
	    var ActiveTooltipping = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$8
	    });
	
	    var TooltippingSchema = [
	      strict$1('lazySink'),
	      strict$1('tooltipDom'),
	      defaulted$1('exclusive', true),
	      defaulted$1('tooltipComponents', []),
	      defaulted$1('delay', 300),
	      defaultedStringEnum('mode', 'normal', [
	        'normal',
	        'follow-highlight'
	      ]),
	      defaulted$1('anchor', function (comp) {
	        return {
	          anchor: 'hotspot',
	          hotspot: comp,
	          layouts: {
	            onLtr: constant([
	              south$1,
	              north$1,
	              southeast$1,
	              northeast$1,
	              southwest$1,
	              northwest$1
	            ]),
	            onRtl: constant([
	              south$1,
	              north$1,
	              southeast$1,
	              northeast$1,
	              southwest$1,
	              northwest$1
	            ])
	          }
	        };
	      }),
	      onHandler('onHide'),
	      onHandler('onShow')
	    ];
	
	    var init$4 = function () {
	      var timer = Cell(Optional.none());
	      var popup = Cell(Optional.none());
	      var getTooltip = function () {
	        return popup.get();
	      };
	      var setTooltip = function (comp) {
	        popup.set(Optional.some(comp));
	      };
	      var clearTooltip = function () {
	        popup.set(Optional.none());
	      };
	      var clearTimer = function () {
	        timer.get().each(function (t) {
	          clearTimeout(t);
	        });
	      };
	      var resetTimer = function (f, delay) {
	        clearTimer();
	        timer.set(Optional.some(setTimeout(function () {
	          f();
	        }, delay)));
	      };
	      var isShowing = function () {
	        return popup.get().isSome();
	      };
	      var readState = constant('not-implemented');
	      return nu$5({
	        getTooltip: getTooltip,
	        isShowing: isShowing,
	        setTooltip: setTooltip,
	        clearTooltip: clearTooltip,
	        clearTimer: clearTimer,
	        resetTimer: resetTimer,
	        readState: readState
	      });
	    };
	
	    var TooltippingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$4
	    });
	
	    var Tooltipping = create$1({
	      fields: TooltippingSchema,
	      name: 'tooltipping',
	      active: ActiveTooltipping,
	      state: TooltippingState,
	      apis: TooltippingApis
	    });
	
	    var escape = function (text) {
	      return text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	    };
	
	    var global$5 = tinymce.util.Tools.resolve('tinymce.dom.DOMUtils');
	
	    var global$6 = tinymce.util.Tools.resolve('tinymce.util.I18n');
	
	    var nativeDisabled = [
	      'input',
	      'button',
	      'textarea',
	      'select'
	    ];
	    var onLoad$5 = function (component, disableConfig, disableState) {
	      var f = disableConfig.disabled() ? disable : enable;
	      f(component, disableConfig);
	    };
	    var hasNative = function (component, config) {
	      return config.useNative === true && contains(nativeDisabled, name(component.element));
	    };
	    var nativeIsDisabled = function (component) {
	      return has$1(component.element, 'disabled');
	    };
	    var nativeDisable = function (component) {
	      set$1(component.element, 'disabled', 'disabled');
	    };
	    var nativeEnable = function (component) {
	      remove$1(component.element, 'disabled');
	    };
	    var ariaIsDisabled = function (component) {
	      return get$3(component.element, 'aria-disabled') === 'true';
	    };
	    var ariaDisable = function (component) {
	      set$1(component.element, 'aria-disabled', 'true');
	    };
	    var ariaEnable = function (component) {
	      set$1(component.element, 'aria-disabled', 'false');
	    };
	    var disable = function (component, disableConfig, _disableState) {
	      disableConfig.disableClass.each(function (disableClass) {
	        add$2(component.element, disableClass);
	      });
	      var f = hasNative(component, disableConfig) ? nativeDisable : ariaDisable;
	      f(component);
	      disableConfig.onDisabled(component);
	    };
	    var enable = function (component, disableConfig, _disableState) {
	      disableConfig.disableClass.each(function (disableClass) {
	        remove$4(component.element, disableClass);
	      });
	      var f = hasNative(component, disableConfig) ? nativeEnable : ariaEnable;
	      f(component);
	      disableConfig.onEnabled(component);
	    };
	    var isDisabled = function (component, disableConfig) {
	      return hasNative(component, disableConfig) ? nativeIsDisabled(component) : ariaIsDisabled(component);
	    };
	    var set$7 = function (component, disableConfig, disableState, disabled) {
	      var f = disabled ? disable : enable;
	      f(component, disableConfig);
	    };
	
	    var DisableApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        enable: enable,
	        disable: disable,
	        isDisabled: isDisabled,
	        onLoad: onLoad$5,
	        set: set$7
	    });
	
	    var exhibit$3 = function (base, disableConfig) {
	      return nu$6({ classes: disableConfig.disabled() ? disableConfig.disableClass.toArray() : [] });
	    };
	    var events$9 = function (disableConfig, disableState) {
	      return derive([
	        abort(execute(), function (component, _simulatedEvent) {
	          return isDisabled(component, disableConfig);
	        }),
	        loadEvent(disableConfig, disableState, onLoad$5)
	      ]);
	    };
	
	    var ActiveDisable = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$3,
	        events: events$9
	    });
	
	    var DisableSchema = [
	      defaultedFunction('disabled', never),
	      defaulted$1('useNative', true),
	      option('disableClass'),
	      onHandler('onDisabled'),
	      onHandler('onEnabled')
	    ];
	
	    var Disabling = create$1({
	      fields: DisableSchema,
	      name: 'disabling',
	      active: ActiveDisable,
	      apis: DisableApis
	    });
	
	    var global$7 = tinymce.util.Tools.resolve('tinymce.EditorManager');
	
	    var getSkinUrl = function (editor) {
	      var skin = editor.getParam('skin');
	      var skinUrl = editor.getParam('skin_url');
	      if (skin !== false) {
	        var skinName = skin ? skin : 'oxide';
	        if (skinUrl) {
	          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
	        } else {
	          skinUrl = global$7.baseURL + '/skins/ui/' + skinName;
	        }
	      }
	      return skinUrl;
	    };
	    var isReadOnly = function (editor) {
	      return editor.getParam('readonly', false, 'boolean');
	    };
	    var isSkinDisabled = function (editor) {
	      return editor.getParam('skin') === false;
	    };
	    var getHeightSetting = function (editor) {
	      return editor.getParam('height', Math.max(editor.getElement().offsetHeight, 200));
	    };
	    var getWidthSetting = function (editor) {
	      return editor.getParam('width', global$5.DOM.getStyle(editor.getElement(), 'width'));
	    };
	    var getMinWidthSetting = function (editor) {
	      return Optional.from(editor.getParam('min_width')).filter(isNumber);
	    };
	    var getMinHeightSetting = function (editor) {
	      return Optional.from(editor.getParam('min_height')).filter(isNumber);
	    };
	    var getMaxWidthSetting = function (editor) {
	      return Optional.from(editor.getParam('max_width')).filter(isNumber);
	    };
	    var getMaxHeightSetting = function (editor) {
	      return Optional.from(editor.getParam('max_height')).filter(isNumber);
	    };
	    var getUserStyleFormats = function (editor) {
	      return Optional.from(editor.getParam('style_formats')).filter(isArray);
	    };
	    var isMergeStyleFormats = function (editor) {
	      return editor.getParam('style_formats_merge', false, 'boolean');
	    };
	    var getLineHeightFormats = function (editor) {
	      return editor.getParam('lineheight_formats', '1 1.1 1.2 1.3 1.4 1.5 2', 'string').split(' ');
	    };
	    var getRemovedMenuItems = function (editor) {
	      return editor.getParam('removed_menuitems', '');
	    };
	    var isMenubarEnabled = function (editor) {
	      return editor.getParam('menubar', true, 'boolean') !== false;
	    };
	    var isToolbarEnabled = function (editor) {
	      var toolbar = editor.getParam('toolbar', true);
	      var isToolbarTrue = toolbar === true;
	      var isToolbarString = isString(toolbar);
	      var isToolbarObjectArray = isArray(toolbar) && toolbar.length > 0;
	      return !isMultipleToolbars(editor) && (isToolbarObjectArray || isToolbarString || isToolbarTrue);
	    };
	    var getMultipleToolbarsSetting = function (editor) {
	      var toolbars = range(9, function (num) {
	        return editor.getParam('toolbar' + (num + 1), false, 'string');
	      });
	      var toolbarArray = filter(toolbars, function (toolbar) {
	        return typeof toolbar === 'string';
	      });
	      return toolbarArray.length > 0 ? Optional.some(toolbarArray) : Optional.none();
	    };
	    var isMultipleToolbars = function (editor) {
	      return getMultipleToolbarsSetting(editor).fold(function () {
	        var toolbar = editor.getParam('toolbar', [], 'string[]');
	        return toolbar.length > 0;
	      }, always);
	    };
	    var ToolbarMode;
	    (function (ToolbarMode) {
	      ToolbarMode['default'] = 'wrap';
	      ToolbarMode['floating'] = 'floating';
	      ToolbarMode['sliding'] = 'sliding';
	      ToolbarMode['scrolling'] = 'scrolling';
	    }(ToolbarMode || (ToolbarMode = {})));
	    var getToolbarMode = function (editor) {
	      return editor.getParam('toolbar_mode', '', 'string');
	    };
	    var ToolbarLocation;
	    (function (ToolbarLocation) {
	      ToolbarLocation['auto'] = 'auto';
	      ToolbarLocation['top'] = 'top';
	      ToolbarLocation['bottom'] = 'bottom';
	    }(ToolbarLocation || (ToolbarLocation = {})));
	    var getToolbarGroups = function (editor) {
	      return editor.getParam('toolbar_groups', {}, 'object');
	    };
	    var getToolbarLocation = function (editor) {
	      return editor.getParam('toolbar_location', ToolbarLocation.auto, 'string');
	    };
	    var isToolbarLocationBottom = function (editor) {
	      return getToolbarLocation(editor) === ToolbarLocation.bottom;
	    };
	    var fixedContainerSelector = function (editor) {
	      return editor.getParam('fixed_toolbar_container', '', 'string');
	    };
	    var fixedToolbarContainerTarget = function (editor) {
	      return editor.getParam('fixed_toolbar_container_target');
	    };
	    var isToolbarPersist = function (editor) {
	      return editor.getParam('toolbar_persist', false, 'boolean');
	    };
	    var fixedContainerTarget = function (editor) {
	      if (!editor.inline) {
	        return Optional.none();
	      }
	      var selector = fixedContainerSelector(editor);
	      if (selector.length > 0) {
	        return descendant$1(body(), selector);
	      }
	      var element = fixedToolbarContainerTarget(editor);
	      if (isNonNullable(element)) {
	        return Optional.some(SugarElement.fromDom(element));
	      }
	      return Optional.none();
	    };
	    var useFixedContainer = function (editor) {
	      return editor.inline && fixedContainerTarget(editor).isSome();
	    };
	    var getUiContainer = function (editor) {
	      var fixedContainer = fixedContainerTarget(editor);
	      return fixedContainer.getOrThunk(function () {
	        return getContentContainer(getRootNode(SugarElement.fromDom(editor.getElement())));
	      });
	    };
	    var isDistractionFree = function (editor) {
	      return editor.inline && !isMenubarEnabled(editor) && !isToolbarEnabled(editor) && !isMultipleToolbars(editor);
	    };
	    var isStickyToolbar = function (editor) {
	      var isStickyToolbar = editor.getParam('toolbar_sticky', false, 'boolean');
	      return (isStickyToolbar || editor.inline) && !useFixedContainer(editor) && !isDistractionFree(editor);
	    };
	    var isDraggableModal = function (editor) {
	      return editor.getParam('draggable_modal', false, 'boolean');
	    };
	    var getMenus = function (editor) {
	      var menu = editor.getParam('menu');
	      if (menu) {
	        return map$2(menu, function (menu) {
	          return __assign(__assign({}, menu), { items: menu.items });
	        });
	      } else {
	        return {};
	      }
	    };
	    var getMenubar = function (editor) {
	      return editor.getParam('menubar');
	    };
	    var getToolbar = function (editor) {
	      return editor.getParam('toolbar', true);
	    };
	    var getFilePickerCallback = function (editor) {
	      return editor.getParam('file_picker_callback');
	    };
	    var getFilePickerTypes = function (editor) {
	      return editor.getParam('file_picker_types');
	    };
	    var getFileBrowserCallbackTypes = function (editor) {
	      return editor.getParam('file_browser_callback_types');
	    };
	    var noTypeaheadUrls = function (editor) {
	      return editor.getParam('typeahead_urls') === false;
	    };
	    var getAnchorTop = function (editor) {
	      return editor.getParam('anchor_top', '#top');
	    };
	    var getAnchorBottom = function (editor) {
	      return editor.getParam('anchor_bottom', '#bottom');
	    };
	    var getFilePickerValidatorHandler = function (editor) {
	      var handler = editor.getParam('file_picker_validator_handler', undefined, 'function');
	      if (handler === undefined) {
	        return editor.getParam('filepicker_validator_handler', undefined, 'function');
	      } else {
	        return handler;
	      }
	    };
	
	    var ReadOnlyChannel = 'silver.readonly';
	    var ReadOnlyDataSchema = objOf([strictBoolean('readonly')]);
	    var broadcastReadonly = function (uiComponents, readonly) {
	      var outerContainer = uiComponents.outerContainer;
	      var target = outerContainer.element;
	      if (readonly) {
	        uiComponents.mothership.broadcastOn([dismissPopups()], { target: target });
	        uiComponents.uiMothership.broadcastOn([dismissPopups()], { target: target });
	      }
	      uiComponents.mothership.broadcastOn([ReadOnlyChannel], { readonly: readonly });
	      uiComponents.uiMothership.broadcastOn([ReadOnlyChannel], { readonly: readonly });
	    };
	    var setupReadonlyModeSwitch = function (editor, uiComponents) {
	      editor.on('init', function () {
	        if (editor.mode.isReadOnly()) {
	          broadcastReadonly(uiComponents, true);
	        }
	      });
	      editor.on('SwitchMode', function () {
	        return broadcastReadonly(uiComponents, editor.mode.isReadOnly());
	      });
	      if (isReadOnly(editor)) {
	        editor.setMode('readonly');
	      }
	    };
	    var receivingConfig = function () {
	      var _a;
	      return Receiving.config({
	        channels: (_a = {}, _a[ReadOnlyChannel] = {
	          schema: ReadOnlyDataSchema,
	          onReceive: function (comp, data) {
	            Disabling.set(comp, data.readonly);
	          }
	        }, _a)
	      });
	    };
	
	    var item = function (disabled) {
	      return Disabling.config({
	        disabled: disabled,
	        disableClass: 'tox-collection__item--state-disabled'
	      });
	    };
	    var button = function (disabled) {
	      return Disabling.config({ disabled: disabled });
	    };
	    var splitButton = function (disabled) {
	      return Disabling.config({
	        disabled: disabled,
	        disableClass: 'tox-tbtn--disabled'
	      });
	    };
	    var toolbarButton = function (disabled) {
	      return Disabling.config({
	        disabled: disabled,
	        disableClass: 'tox-tbtn--disabled',
	        useNative: false
	      });
	    };
	    var DisablingConfigs = {
	      item: item,
	      button: button,
	      splitButton: splitButton,
	      toolbarButton: toolbarButton
	    };
	
	    var runWithApi = function (info, comp) {
	      var api = info.getApi(comp);
	      return function (f) {
	        f(api);
	      };
	    };
	    var onControlAttached = function (info, editorOffCell) {
	      return runOnAttached(function (comp) {
	        var run = runWithApi(info, comp);
	        run(function (api) {
	          var onDestroy = info.onSetup(api);
	          if (isFunction(onDestroy)) {
	            editorOffCell.set(onDestroy);
	          }
	        });
	      });
	    };
	    var onControlDetached = function (getApi, editorOffCell) {
	      return runOnDetached(function (comp) {
	        return runWithApi(getApi, comp)(editorOffCell.get());
	      });
	    };
	
	    var _a;
	    var onMenuItemExecute = function (info, itemResponse) {
	      return runOnExecute(function (comp, simulatedEvent) {
	        runWithApi(info, comp)(info.onAction);
	        if (!info.triggersSubmenu && itemResponse === ItemResponse$1.CLOSE_ON_EXECUTE) {
	          if (comp.getSystem().isConnected()) {
	            emit(comp, sandboxClose());
	          }
	          simulatedEvent.stop();
	        }
	      });
	    };
	    var menuItemEventOrder = (_a = {}, _a[execute()] = [
	      'disabling',
	      'alloy.base.behaviour',
	      'toggling',
	      'item-events'
	    ], _a);
	
	    var componentRenderPipeline = function (xs) {
	      return bind(xs, function (o) {
	        return o.toArray();
	      });
	    };
	    var renderCommonItem = function (spec, structure, itemResponse, providersbackstage) {
	      var editorOffCell = Cell(noop);
	      return {
	        type: 'item',
	        dom: structure.dom,
	        components: componentRenderPipeline(structure.optComponents),
	        data: spec.data,
	        eventOrder: menuItemEventOrder,
	        hasSubmenu: spec.triggersSubmenu,
	        itemBehaviours: derive$1([
	          config('item-events', [
	            onMenuItemExecute(spec, itemResponse),
	            onControlAttached(spec, editorOffCell),
	            onControlDetached(spec, editorOffCell)
	          ]),
	          DisablingConfigs.item(function () {
	            return spec.disabled || providersbackstage.isDisabled();
	          }),
	          receivingConfig(),
	          Replacing.config({})
	        ].concat(spec.itemBehaviours))
	      };
	    };
	    var buildData = function (source) {
	      return {
	        value: source.value,
	        meta: __assign({ text: source.text.getOr('') }, source.meta)
	      };
	    };
	
	    var global$8 = tinymce.util.Tools.resolve('tinymce.Env');
	
	    var convertText = function (source) {
	      var mac = {
	        alt: '&#x2325;',
	        ctrl: '&#x2303;',
	        shift: '&#x21E7;',
	        meta: '&#x2318;',
	        access: '&#x2303;&#x2325;'
	      };
	      var other = {
	        meta: 'Ctrl',
	        access: 'Shift+Alt'
	      };
	      var replace = global$8.mac ? mac : other;
	      var shortcut = source.split('+');
	      var updated = map(shortcut, function (segment) {
	        var search = segment.toLowerCase().trim();
	        return has(replace, search) ? replace[search] : segment;
	      });
	      return global$8.mac ? updated.join('') : updated.join('+');
	    };
	
	    var renderIcon = function (iconHtml) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [iconClass],
	          innerHtml: iconHtml
	        }
	      };
	    };
	    var renderText = function (text$1) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [textClass]
	        },
	        components: [text(global$6.translate(text$1))]
	      };
	    };
	    var renderHtml = function (html, classes) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: classes,
	          innerHtml: html
	        }
	      };
	    };
	    var renderStyledText = function (style, text$1) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [textClass]
	        },
	        components: [{
	            dom: {
	              tag: style.tag,
	              styles: style.styles
	            },
	            components: [text(global$6.translate(text$1))]
	          }]
	      };
	    };
	    var renderShortcut = function (shortcut) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [accessoryClass],
	          innerHtml: convertText(shortcut)
	        }
	      };
	    };
	    var renderCheckmark = function (icons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [checkmarkClass],
	          innerHtml: get$e('checkmark', icons)
	        }
	      };
	    };
	    var renderSubmenuCaret = function (icons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [caretClass],
	          innerHtml: get$e('chevron-right', icons)
	        }
	      };
	    };
	    var renderDownwardsCaret = function (icons) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [caretClass],
	          innerHtml: get$e('chevron-down', icons)
	        }
	      };
	    };
	    var renderContainer = function (container, components) {
	      var directionClass = container.direction === 'vertical' ? containerColumnClass : containerRowClass;
	      var alignClass = container.align === 'left' ? containerAlignLeftClass : containerAlignRightClass;
	      var getValignClass = function () {
	        switch (container.valign) {
	        case 'top':
	          return containerValignTopClass;
	        case 'middle':
	          return containerValignMiddleClass;
	        case 'bottom':
	          return containerValignBottomClass;
	        }
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            containerClass,
	            directionClass,
	            alignClass,
	            getValignClass()
	          ]
	        },
	        components: components
	      };
	    };
	    var renderImage = function (src, classes, alt) {
	      return {
	        dom: {
	          tag: 'img',
	          classes: classes,
	          attributes: {
	            src: src,
	            alt: alt.getOr('')
	          }
	        }
	      };
	    };
	
	    var renderColorStructure = function (itemText, itemValue, iconSvg, providerBackstage) {
	      var colorPickerCommand = 'custom';
	      var removeColorCommand = 'remove';
	      var getDom = function () {
	        var common = colorClass;
	        var icon = iconSvg.getOr('');
	        var attributes = itemText.map(function (text) {
	          return { title: providerBackstage.translate(text) };
	        }).getOr({});
	        var baseDom = {
	          tag: 'div',
	          attributes: attributes,
	          classes: [common]
	        };
	        if (itemValue === colorPickerCommand) {
	          return __assign(__assign({}, baseDom), {
	            tag: 'button',
	            classes: __spreadArrays(baseDom.classes, ['tox-swatches__picker-btn']),
	            innerHtml: icon
	          });
	        } else if (itemValue === removeColorCommand) {
	          return __assign(__assign({}, baseDom), {
	            classes: __spreadArrays(baseDom.classes, ['tox-swatch--remove']),
	            innerHtml: icon
	          });
	        } else {
	          return __assign(__assign({}, baseDom), {
	            attributes: __assign(__assign({}, baseDom.attributes), { 'data-mce-color': itemValue }),
	            styles: { 'background-color': itemValue }
	          });
	        }
	      };
	      return {
	        dom: getDom(),
	        optComponents: []
	      };
	    };
	    var renderItemDomStructure = function (rtlClass, ariaLabel) {
	      var domTitle = ariaLabel.map(function (label) {
	        return { attributes: { title: global$6.translate(label) } };
	      }).getOr({});
	      return __assign({
	        tag: 'div',
	        classes: [
	          navClass,
	          selectableClass
	        ].concat(rtlClass ? [iconClassRtl] : [])
	      }, domTitle);
	    };
	    var renderNormalItemStructure = function (info, icon, renderIcons, textRender, rtlClass) {
	      var leftIcon = renderIcons ? icon.or(Optional.some('')).map(renderIcon) : Optional.none();
	      var checkmark = info.checkMark;
	      var content = info.htmlContent.fold(function () {
	        return info.textContent.map(textRender);
	      }, function (html) {
	        return Optional.some(renderHtml(html, [textClass]));
	      });
	      var menuItem = {
	        dom: renderItemDomStructure(rtlClass, info.ariaLabel),
	        optComponents: [
	          leftIcon,
	          content,
	          info.shortcutContent.map(renderShortcut),
	          checkmark,
	          info.caret
	        ]
	      };
	      return menuItem;
	    };
	    var rtlIcon = [
	      'list-num-default',
	      'list-num-lower-alpha',
	      'list-num-lower-greek',
	      'list-num-lower-roman',
	      'list-num-upper-alpha',
	      'list-num-upper-roman'
	    ];
	    var rtlTransform = [
	      'list-bull-circle',
	      'list-bull-default',
	      'list-bull-square'
	    ];
	    var renderItemStructure = function (info, providersBackstage, renderIcons, fallbackIcon) {
	      if (fallbackIcon === void 0) {
	        fallbackIcon = Optional.none();
	      }
	      var getIconName = function (iconName) {
	        return iconName.map(function (name) {
	          return global$6.isRtl() && contains(rtlIcon, name) ? name + '-rtl' : name;
	        });
	      };
	      var needRtlClass = global$6.isRtl() && info.iconContent.exists(function (name) {
	        return contains(rtlTransform, name);
	      });
	      var icon = getIconName(info.iconContent).map(function (iconName) {
	        return getOr(iconName, providersBackstage.icons, fallbackIcon);
	      });
	      var textRender = Optional.from(info.meta).fold(function () {
	        return renderText;
	      }, function (meta) {
	        return has(meta, 'style') ? curry(renderStyledText, meta.style) : renderText;
	      });
	      if (info.presets === 'color') {
	        return renderColorStructure(info.ariaLabel, info.value, icon, providersBackstage);
	      } else {
	        return renderNormalItemStructure(info, icon, renderIcons, textRender, needRtlClass);
	      }
	    };
	
	    var tooltipBehaviour = function (meta, sharedBackstage) {
	      return get$1(meta, 'tooltipWorker').map(function (tooltipWorker) {
	        return [Tooltipping.config({
	            lazySink: sharedBackstage.getSink,
	            tooltipDom: {
	              tag: 'div',
	              classes: ['tox-tooltip-worker-container']
	            },
	            tooltipComponents: [],
	            anchor: function (comp) {
	              return {
	                anchor: 'submenu',
	                item: comp,
	                overrides: { maxHeightFunction: expandable }
	              };
	            },
	            mode: 'follow-highlight',
	            onShow: function (component, _tooltip) {
	              tooltipWorker(function (elm) {
	                Tooltipping.setComponents(component, [external({ element: SugarElement.fromDom(elm) })]);
	              });
	            }
	          })];
	      }).getOr([]);
	    };
	    var encodeText = function (text) {
	      return global$5.DOM.encode(text);
	    };
	    var replaceText = function (text, matchText) {
	      var translated = global$6.translate(text);
	      var encoded = encodeText(translated);
	      if (matchText.length > 0) {
	        var escapedMatchRegex = new RegExp(escape(matchText), 'gi');
	        return encoded.replace(escapedMatchRegex, function (match) {
	          return '<span class="tox-autocompleter-highlight">' + match + '</span>';
	        });
	      } else {
	        return encoded;
	      }
	    };
	    var renderAutocompleteItem = function (spec, matchText, useText, presets, onItemValueHandler, itemResponse, sharedBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var structure = renderItemStructure({
	        presets: presets,
	        textContent: Optional.none(),
	        htmlContent: useText ? spec.text.map(function (text) {
	          return replaceText(text, matchText);
	        }) : Optional.none(),
	        ariaLabel: spec.text,
	        iconContent: spec.icon,
	        shortcutContent: Optional.none(),
	        checkMark: Optional.none(),
	        caret: Optional.none(),
	        value: spec.value
	      }, sharedBackstage.providers, renderIcons, spec.icon);
	      return renderCommonItem({
	        data: buildData(spec),
	        disabled: spec.disabled,
	        getApi: constant({}),
	        onAction: function (_api) {
	          return onItemValueHandler(spec.value, spec.meta);
	        },
	        onSetup: constant(noop),
	        triggersSubmenu: false,
	        itemBehaviours: tooltipBehaviour(spec.meta, sharedBackstage)
	      }, structure, itemResponse, sharedBackstage.providers);
	    };
	
	    var render = function (items, extras) {
	      return map(items, function (item) {
	        switch (item.type) {
	        case 'cardcontainer':
	          return renderContainer(item, render(item.items, extras));
	        case 'cardimage':
	          return renderImage(item.src, item.classes, item.alt);
	        case 'cardtext':
	          var shouldHighlight = item.name.exists(function (name) {
	            return contains(extras.cardText.highlightOn, name);
	          });
	          var matchText = shouldHighlight ? Optional.from(extras.cardText.matchText).getOr('') : '';
	          return renderHtml(replaceText(item.text, matchText), item.classes);
	        }
	      });
	    };
	    var renderCardMenuItem = function (spec, itemResponse, sharedBackstage, extras) {
	      var getApi = function (component) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            Disabling.set(component, state);
	            each(descendants(component.element, '*'), function (elm) {
	              component.getSystem().getByDom(elm).each(function (comp) {
	                if (comp.hasConfigured(Disabling)) {
	                  Disabling.set(comp, state);
	                }
	              });
	            });
	          }
	        };
	      };
	      var structure = {
	        dom: renderItemDomStructure(false, spec.label),
	        optComponents: [Optional.some({
	            dom: {
	              tag: 'div',
	              classes: [
	                containerClass,
	                containerRowClass
	              ]
	            },
	            components: render(spec.items, extras)
	          })]
	      };
	      return renderCommonItem({
	        data: buildData(__assign({ text: Optional.none() }, spec)),
	        disabled: spec.disabled,
	        getApi: getApi,
	        onAction: spec.onAction,
	        onSetup: spec.onSetup,
	        triggersSubmenu: false,
	        itemBehaviours: Optional.from(extras.itemBehaviours).getOr([])
	      }, structure, itemResponse, sharedBackstage.providers);
	    };
	
	    var renderChoiceItem = function (spec, useText, presets, onItemValueHandler, isSelected, itemResponse, providersBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var getApi = function (component) {
	        return {
	          setActive: function (state) {
	            Toggling.set(component, state);
	          },
	          isActive: function () {
	            return Toggling.isOn(component);
	          },
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        presets: presets,
	        textContent: useText ? spec.text : Optional.none(),
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        iconContent: spec.icon,
	        shortcutContent: useText ? spec.shortcut : Optional.none(),
	        checkMark: useText ? Optional.some(renderCheckmark(providersBackstage.icons)) : Optional.none(),
	        caret: Optional.none(),
	        value: spec.value
	      }, providersBackstage, renderIcons);
	      return deepMerge(renderCommonItem({
	        data: buildData(spec),
	        disabled: spec.disabled,
	        getApi: getApi,
	        onAction: function (_api) {
	          return onItemValueHandler(spec.value);
	        },
	        onSetup: function (api) {
	          api.setActive(isSelected);
	          return noop;
	        },
	        triggersSubmenu: false,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage), {
	        toggling: {
	          toggleClass: tickedClass,
	          toggleOnExecute: false,
	          selected: spec.active
	        }
	      });
	    };
	
	    var parts$2 = generate$4(owner$2(), parts());
	
	    var hexColour = function (value) {
	      return { value: value };
	    };
	    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
	    var longformRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
	    var isHexString = function (hex) {
	      return shorthandRegex.test(hex) || longformRegex.test(hex);
	    };
	    var getLongForm = function (hex) {
	      var hexString = hex.value.replace(shorthandRegex, function (m, r, g, b) {
	        return r + r + g + g + b + b;
	      });
	      return { value: hexString };
	    };
	    var extractValues = function (hex) {
	      var longForm = getLongForm(hex);
	      var splitForm = longformRegex.exec(longForm.value);
	      return splitForm === null ? [
	        'FFFFFF',
	        'FF',
	        'FF',
	        'FF'
	      ] : splitForm;
	    };
	    var toHex = function (component) {
	      var hex = component.toString(16);
	      return (hex.length === 1 ? '0' + hex : hex).toUpperCase();
	    };
	    var fromRgba = function (rgbaColour) {
	      var value = toHex(rgbaColour.red) + toHex(rgbaColour.green) + toHex(rgbaColour.blue);
	      return hexColour(value);
	    };
	
	    var min = Math.min;
	    var max = Math.max;
	    var round = Math.round;
	    var rgbRegex = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/;
	    var rgbaRegex = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/;
	    var rgbaColour = function (red, green, blue, alpha) {
	      return {
	        red: red,
	        green: green,
	        blue: blue,
	        alpha: alpha
	      };
	    };
	    var isRgbaComponent = function (value) {
	      var num = parseInt(value, 10);
	      return num.toString() === value && num >= 0 && num <= 255;
	    };
	    var fromHsv = function (hsv) {
	      var r;
	      var g;
	      var b;
	      var hue = (hsv.hue || 0) % 360;
	      var saturation = hsv.saturation / 100;
	      var brightness = hsv.value / 100;
	      saturation = max(0, min(saturation, 1));
	      brightness = max(0, min(brightness, 1));
	      if (saturation === 0) {
	        r = g = b = round(255 * brightness);
	        return rgbaColour(r, g, b, 1);
	      }
	      var side = hue / 60;
	      var chroma = brightness * saturation;
	      var x = chroma * (1 - Math.abs(side % 2 - 1));
	      var match = brightness - chroma;
	      switch (Math.floor(side)) {
	      case 0:
	        r = chroma;
	        g = x;
	        b = 0;
	        break;
	      case 1:
	        r = x;
	        g = chroma;
	        b = 0;
	        break;
	      case 2:
	        r = 0;
	        g = chroma;
	        b = x;
	        break;
	      case 3:
	        r = 0;
	        g = x;
	        b = chroma;
	        break;
	      case 4:
	        r = x;
	        g = 0;
	        b = chroma;
	        break;
	      case 5:
	        r = chroma;
	        g = 0;
	        b = x;
	        break;
	      default:
	        r = g = b = 0;
	      }
	      r = round(255 * (r + match));
	      g = round(255 * (g + match));
	      b = round(255 * (b + match));
	      return rgbaColour(r, g, b, 1);
	    };
	    var fromHex = function (hexColour) {
	      var result = extractValues(hexColour);
	      var red = parseInt(result[1], 16);
	      var green = parseInt(result[2], 16);
	      var blue = parseInt(result[3], 16);
	      return rgbaColour(red, green, blue, 1);
	    };
	    var fromStringValues = function (red, green, blue, alpha) {
	      var r = parseInt(red, 10);
	      var g = parseInt(green, 10);
	      var b = parseInt(blue, 10);
	      var a = parseFloat(alpha);
	      return rgbaColour(r, g, b, a);
	    };
	    var fromString = function (rgbaString) {
	      if (rgbaString === 'transparent') {
	        return Optional.some(rgbaColour(0, 0, 0, 0));
	      }
	      var rgbMatch = rgbRegex.exec(rgbaString);
	      if (rgbMatch !== null) {
	        return Optional.some(fromStringValues(rgbMatch[1], rgbMatch[2], rgbMatch[3], '1'));
	      }
	      var rgbaMatch = rgbaRegex.exec(rgbaString);
	      if (rgbaMatch !== null) {
	        return Optional.some(fromStringValues(rgbaMatch[1], rgbaMatch[2], rgbaMatch[3], rgbaMatch[4]));
	      }
	      return Optional.none();
	    };
	    var toString = function (rgba) {
	      return 'rgba(' + rgba.red + ',' + rgba.green + ',' + rgba.blue + ',' + rgba.alpha + ')';
	    };
	    var red = rgbaColour(255, 0, 0, 1);
	
	    var fireSkinLoaded = function (editor) {
	      return editor.fire('SkinLoaded');
	    };
	    var fireSkinLoadError = function (editor, error) {
	      return editor.fire('SkinLoadError', error);
	    };
	    var fireResizeEditor = function (editor) {
	      return editor.fire('ResizeEditor');
	    };
	    var fireResizeContent = function (editor, e) {
	      return editor.fire('ResizeContent', e);
	    };
	    var fireScrollContent = function (editor, e) {
	      return editor.fire('ScrollContent', e);
	    };
	    var fireTextColorChange = function (editor, data) {
	      return editor.fire('TextColorChange', data);
	    };
	
	    var global$9 = tinymce.util.Tools.resolve('tinymce.util.LocalStorage');
	
	    var storageName = 'tinymce-custom-colors';
	    function ColorCache (max) {
	      if (max === void 0) {
	        max = 10;
	      }
	      var storageString = global$9.getItem(storageName);
	      var localstorage = isString(storageString) ? JSON.parse(storageString) : [];
	      var prune = function (list) {
	        var diff = max - list.length;
	        return diff < 0 ? list.slice(0, max) : list;
	      };
	      var cache = prune(localstorage);
	      var add = function (key) {
	        indexOf(cache, key).each(remove);
	        cache.unshift(key);
	        if (cache.length > max) {
	          cache.pop();
	        }
	        global$9.setItem(storageName, JSON.stringify(cache));
	      };
	      var remove = function (idx) {
	        cache.splice(idx, 1);
	      };
	      var state = function () {
	        return cache.slice(0);
	      };
	      return {
	        add: add,
	        state: state
	      };
	    }
	
	    var choiceItem = 'choiceitem';
	    var defaultColors = [
	      {
	        type: choiceItem,
	        text: 'Light Green',
	        value: '#BFEDD2'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Yellow',
	        value: '#FBEEB8'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Red',
	        value: '#F8CAC6'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Purple',
	        value: '#ECCAFA'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Blue',
	        value: '#C2E0F4'
	      },
	      {
	        type: choiceItem,
	        text: 'Green',
	        value: '#2DC26B'
	      },
	      {
	        type: choiceItem,
	        text: 'Yellow',
	        value: '#F1C40F'
	      },
	      {
	        type: choiceItem,
	        text: 'Red',
	        value: '#E03E2D'
	      },
	      {
	        type: choiceItem,
	        text: 'Purple',
	        value: '#B96AD9'
	      },
	      {
	        type: choiceItem,
	        text: 'Blue',
	        value: '#3598DB'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Turquoise',
	        value: '#169179'
	      },
	      {
	        type: choiceItem,
	        text: 'Orange',
	        value: '#E67E23'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Red',
	        value: '#BA372A'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Purple',
	        value: '#843FA1'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Blue',
	        value: '#236FA1'
	      },
	      {
	        type: choiceItem,
	        text: 'Light Gray',
	        value: '#ECF0F1'
	      },
	      {
	        type: choiceItem,
	        text: 'Medium Gray',
	        value: '#CED4D9'
	      },
	      {
	        type: choiceItem,
	        text: 'Gray',
	        value: '#95A5A6'
	      },
	      {
	        type: choiceItem,
	        text: 'Dark Gray',
	        value: '#7E8C8D'
	      },
	      {
	        type: choiceItem,
	        text: 'Navy Blue',
	        value: '#34495E'
	      },
	      {
	        type: choiceItem,
	        text: 'Black',
	        value: '#000000'
	      },
	      {
	        type: choiceItem,
	        text: 'White',
	        value: '#ffffff'
	      }
	    ];
	    var colorCache = ColorCache(10);
	    var mapColors = function (colorMap) {
	      var colors = [];
	      var canvas = document.createElement('canvas');
	      canvas.height = 1;
	      canvas.width = 1;
	      var ctx = canvas.getContext('2d');
	      var byteAsHex = function (colorByte, alphaByte) {
	        var bg = 255;
	        var alpha = alphaByte / 255;
	        var colorByteWithWhiteBg = Math.round(colorByte * alpha + bg * (1 - alpha));
	        return ('0' + colorByteWithWhiteBg.toString(16)).slice(-2).toUpperCase();
	      };
	      var asHexColor = function (color) {
	        if (/^[0-9A-Fa-f]{6}$/.test(color)) {
	          return '#' + color.toUpperCase();
	        }
	        ctx.clearRect(0, 0, canvas.width, canvas.height);
	        ctx.fillStyle = '#FFFFFF';
	        ctx.fillStyle = color;
	        ctx.fillRect(0, 0, 1, 1);
	        var rgba = ctx.getImageData(0, 0, 1, 1).data;
	        var r = rgba[0], g = rgba[1], b = rgba[2], a = rgba[3];
	        return '#' + byteAsHex(r, a) + byteAsHex(g, a) + byteAsHex(b, a);
	      };
	      for (var i = 0; i < colorMap.length; i += 2) {
	        colors.push({
	          text: colorMap[i + 1],
	          value: asHexColor(colorMap[i]),
	          type: 'choiceitem'
	        });
	      }
	      return colors;
	    };
	    var getColorCols = function (editor, defaultCols) {
	      return editor.getParam('color_cols', defaultCols, 'number');
	    };
	    var hasCustomColors = function (editor) {
	      return editor.getParam('custom_colors') !== false;
	    };
	    var getColorMap = function (editor) {
	      return editor.getParam('color_map');
	    };
	    var getColors = function (editor) {
	      var unmapped = getColorMap(editor);
	      return unmapped !== undefined ? mapColors(unmapped) : defaultColors;
	    };
	    var getCurrentColors = function () {
	      return map(colorCache.state(), function (color) {
	        return {
	          type: choiceItem,
	          text: color,
	          value: color
	        };
	      });
	    };
	    var addColor = function (color) {
	      colorCache.add(color);
	    };
	
	    var getCurrentColor = function (editor, format) {
	      var color;
	      editor.dom.getParents(editor.selection.getStart(), function (elm) {
	        var value;
	        if (value = elm.style[format === 'forecolor' ? 'color' : 'background-color']) {
	          color = color ? color : value;
	        }
	      });
	      return color;
	    };
	    var applyFormat = function (editor, format, value) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.apply(format, { value: value });
	        editor.nodeChanged();
	      });
	    };
	    var removeFormat = function (editor, format) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.remove(format, { value: null }, null, true);
	        editor.nodeChanged();
	      });
	    };
	    var registerCommands = function (editor) {
	      editor.addCommand('mceApplyTextcolor', function (format, value) {
	        applyFormat(editor, format, value);
	      });
	      editor.addCommand('mceRemoveTextcolor', function (format) {
	        removeFormat(editor, format);
	      });
	    };
	    var calcCols = function (colors) {
	      return Math.max(5, Math.ceil(Math.sqrt(colors)));
	    };
	    var getColorCols$1 = function (editor) {
	      var colors = getColors(editor);
	      var defaultCols = calcCols(colors.length);
	      return getColorCols(editor, defaultCols);
	    };
	    var getAdditionalColors = function (hasCustom) {
	      var type = 'choiceitem';
	      var remove = {
	        type: type,
	        text: 'Remove color',
	        icon: 'color-swatch-remove-color',
	        value: 'remove'
	      };
	      var custom = {
	        type: type,
	        text: 'Custom color',
	        icon: 'color-picker',
	        value: 'custom'
	      };
	      return hasCustom ? [
	        remove,
	        custom
	      ] : [remove];
	    };
	    var applyColor = function (editor, format, value, onChoice) {
	      if (value === 'custom') {
	        var dialog = colorPickerDialog(editor);
	        dialog(function (colorOpt) {
	          colorOpt.each(function (color) {
	            addColor(color);
	            editor.execCommand('mceApplyTextcolor', format, color);
	            onChoice(color);
	          });
	        }, '#000000');
	      } else if (value === 'remove') {
	        onChoice('');
	        editor.execCommand('mceRemoveTextcolor', format);
	      } else {
	        onChoice(value);
	        editor.execCommand('mceApplyTextcolor', format, value);
	      }
	    };
	    var getColors$1 = function (colors, hasCustom) {
	      return colors.concat(getCurrentColors().concat(getAdditionalColors(hasCustom)));
	    };
	    var getFetch = function (colors, hasCustom) {
	      return function (callback) {
	        callback(getColors$1(colors, hasCustom));
	      };
	    };
	    var setIconColor = function (splitButtonApi, name, newColor) {
	      var id = name === 'forecolor' ? 'tox-icon-text-color__color' : 'tox-icon-highlight-bg-color__color';
	      splitButtonApi.setIconFill(id, newColor);
	    };
	    var registerTextColorButton = function (editor, name, format, tooltip, lastColor) {
	      editor.ui.registry.addSplitButton(name, {
	        tooltip: tooltip,
	        presets: 'color',
	        icon: name === 'forecolor' ? 'text-color' : 'highlight-bg-color',
	        select: function (value) {
	          var optCurrentRgb = Optional.from(getCurrentColor(editor, format));
	          return optCurrentRgb.bind(function (currentRgb) {
	            return fromString(currentRgb).map(function (rgba) {
	              var currentHex = fromRgba(rgba).value;
	              return contains$1(value.toLowerCase(), currentHex);
	            });
	          }).getOr(false);
	        },
	        columns: getColorCols$1(editor),
	        fetch: getFetch(getColors(editor), hasCustomColors(editor)),
	        onAction: function (_splitButtonApi) {
	          if (lastColor.get() !== null) {
	            applyColor(editor, format, lastColor.get(), noop);
	          }
	        },
	        onItemAction: function (_splitButtonApi, value) {
	          applyColor(editor, format, value, function (newColor) {
	            lastColor.set(newColor);
	            fireTextColorChange(editor, {
	              name: name,
	              color: newColor
	            });
	          });
	        },
	        onSetup: function (splitButtonApi) {
	          if (lastColor.get() !== null) {
	            setIconColor(splitButtonApi, name, lastColor.get());
	          }
	          var handler = function (e) {
	            if (e.name === name) {
	              setIconColor(splitButtonApi, e.name, e.color);
	            }
	          };
	          editor.on('TextColorChange', handler);
	          return function () {
	            editor.off('TextColorChange', handler);
	          };
	        }
	      });
	    };
	    var registerTextColorMenuItem = function (editor, name, format, text) {
	      editor.ui.registry.addNestedMenuItem(name, {
	        text: text,
	        icon: name === 'forecolor' ? 'text-color' : 'highlight-bg-color',
	        getSubmenuItems: function () {
	          return [{
	              type: 'fancymenuitem',
	              fancytype: 'colorswatch',
	              onAction: function (data) {
	                applyColor(editor, format, data.value, noop);
	              }
	            }];
	        }
	      });
	    };
	    var colorPickerDialog = function (editor) {
	      return function (callback, value) {
	        var isValid = false;
	        var onSubmit = function (api) {
	          var data = api.getData();
	          var hex = data.colorpicker;
	          if (isValid) {
	            callback(Optional.from(hex));
	            api.close();
	          } else {
	            editor.windowManager.alert(editor.translate([
	              'Invalid hex color code: {0}',
	              hex
	            ]));
	          }
	        };
	        var onAction = function (_api, details) {
	          if (details.name === 'hex-valid') {
	            isValid = details.value;
	          }
	        };
	        var initialData = { colorpicker: value };
	        editor.windowManager.open({
	          title: 'Color Picker',
	          size: 'normal',
	          body: {
	            type: 'panel',
	            items: [{
	                type: 'colorpicker',
	                name: 'colorpicker',
	                label: 'Color'
	              }]
	          },
	          buttons: [
	            {
	              type: 'cancel',
	              name: 'cancel',
	              text: 'Cancel'
	            },
	            {
	              type: 'submit',
	              name: 'save',
	              text: 'Save',
	              primary: true
	            }
	          ],
	          initialData: initialData,
	          onAction: onAction,
	          onSubmit: onSubmit,
	          onClose: noop,
	          onCancel: function () {
	            callback(Optional.none());
	          }
	        });
	      };
	    };
	    var register$1 = function (editor) {
	      registerCommands(editor);
	      var lastForeColor = Cell(null);
	      var lastBackColor = Cell(null);
	      registerTextColorButton(editor, 'forecolor', 'forecolor', 'Text color', lastForeColor);
	      registerTextColorButton(editor, 'backcolor', 'hilitecolor', 'Background color', lastBackColor);
	      registerTextColorMenuItem(editor, 'forecolor', 'forecolor', 'Text color');
	      registerTextColorMenuItem(editor, 'backcolor', 'hilitecolor', 'Background color');
	    };
	
	    var createPartialChoiceMenu = function (value, items, onItemValueHandler, columns, presets, itemResponse, select, providersBackstage) {
	      var hasIcons = menuHasIcons(items);
	      var presetItemTypes = presets !== 'color' ? 'normal' : 'color';
	      var alloyItems = createChoiceItems(items, onItemValueHandler, columns, presetItemTypes, itemResponse, select, providersBackstage);
	      return createPartialMenuWithAlloyItems(value, hasIcons, alloyItems, columns, presets);
	    };
	    var createChoiceItems = function (items, onItemValueHandler, columns, itemPresets, itemResponse, select, providersBackstage) {
	      return cat(map(items, function (item) {
	        if (item.type === 'choiceitem') {
	          return createChoiceMenuItem(item).fold(handleError, function (d) {
	            return Optional.some(renderChoiceItem(d, columns === 1, itemPresets, onItemValueHandler, select(item.value), itemResponse, providersBackstage, menuHasIcons(items)));
	          });
	        } else {
	          return Optional.none();
	        }
	      }));
	    };
	
	    var deriveMenuMovement = function (columns, presets) {
	      var menuMarkers = markers$1(presets);
	      if (columns === 1) {
	        return {
	          mode: 'menu',
	          moveOnTab: true
	        };
	      } else if (columns === 'auto') {
	        return {
	          mode: 'grid',
	          selector: '.' + menuMarkers.item,
	          initSize: {
	            numColumns: 1,
	            numRows: 1
	          }
	        };
	      } else {
	        var rowClass = presets === 'color' ? 'tox-swatches__row' : 'tox-collection__group';
	        return {
	          mode: 'matrix',
	          rowSelector: '.' + rowClass
	        };
	      }
	    };
	    var deriveCollectionMovement = function (columns, presets) {
	      if (columns === 1) {
	        return {
	          mode: 'menu',
	          moveOnTab: false,
	          selector: '.tox-collection__item'
	        };
	      } else if (columns === 'auto') {
	        return {
	          mode: 'flatgrid',
	          selector: '.' + 'tox-collection__item',
	          initSize: {
	            numColumns: 1,
	            numRows: 1
	          }
	        };
	      } else {
	        return {
	          mode: 'matrix',
	          selectors: {
	            row: presets === 'color' ? '.tox-swatches__row' : '.tox-collection__group',
	            cell: presets === 'color' ? '.' + colorClass : '.' + selectableClass
	          }
	        };
	      }
	    };
	
	    var renderColorSwatchItem = function (spec, backstage) {
	      var items = getColors$1(backstage.colorinput.getColors(), backstage.colorinput.hasCustomColors());
	      var columns = backstage.colorinput.getColorCols();
	      var presets = 'color';
	      var menuSpec = createPartialChoiceMenu(generate$1('menu-value'), items, function (value) {
	        spec.onAction({ value: value });
	      }, columns, presets, ItemResponse$1.CLOSE_ON_EXECUTE, never, backstage.shared.providers);
	      var widgetSpec = __assign(__assign({}, menuSpec), {
	        markers: markers$1(presets),
	        movement: deriveMenuMovement(columns, presets)
	      });
	      return {
	        type: 'widget',
	        data: { value: generate$1('widget-id') },
	        dom: {
	          tag: 'div',
	          classes: ['tox-fancymenuitem']
	        },
	        autofocus: true,
	        components: [parts$2.widget(Menu.sketch(widgetSpec))]
	      };
	    };
	
	    var cellOverEvent = generate$1('cell-over');
	    var cellExecuteEvent = generate$1('cell-execute');
	    var makeCell = function (row, col, labelId) {
	      var _a;
	      var emitCellOver = function (c) {
	        return emitWith(c, cellOverEvent, {
	          row: row,
	          col: col
	        });
	      };
	      var emitExecute = function (c) {
	        return emitWith(c, cellExecuteEvent, {
	          row: row,
	          col: col
	        });
	      };
	      var onClick = function (c, se) {
	        se.stop();
	        emitExecute(c);
	      };
	      return build$1({
	        dom: {
	          tag: 'div',
	          attributes: (_a = { role: 'button' }, _a['aria-labelledby'] = labelId, _a)
	        },
	        behaviours: derive$1([
	          config('insert-table-picker-cell', [
	            run(mouseover(), Focusing.focus),
	            run(execute(), emitExecute),
	            run(click(), onClick),
	            run(tap(), onClick)
	          ]),
	          Toggling.config({
	            toggleClass: 'tox-insert-table-picker__selected',
	            toggleOnExecute: false
	          }),
	          Focusing.config({ onFocus: emitCellOver })
	        ])
	      });
	    };
	    var makeCells = function (labelId, numRows, numCols) {
	      var cells = [];
	      for (var i = 0; i < numRows; i++) {
	        var row = [];
	        for (var j = 0; j < numCols; j++) {
	          row.push(makeCell(i, j, labelId));
	        }
	        cells.push(row);
	      }
	      return cells;
	    };
	    var selectCells = function (cells, selectedRow, selectedColumn, numRows, numColumns) {
	      for (var i = 0; i < numRows; i++) {
	        for (var j = 0; j < numColumns; j++) {
	          Toggling.set(cells[i][j], i <= selectedRow && j <= selectedColumn);
	        }
	      }
	    };
	    var makeComponents = function (cells) {
	      return bind(cells, function (cellRow) {
	        return map(cellRow, premade$1);
	      });
	    };
	    var makeLabelText = function (row, col) {
	      return text(col + 1 + 'x' + (row + 1));
	    };
	    var renderInsertTableMenuItem = function (spec) {
	      var numRows = 10;
	      var numColumns = 10;
	      var sizeLabelId = generate$1('size-label');
	      var cells = makeCells(sizeLabelId, numRows, numColumns);
	      var memLabel = record({
	        dom: {
	          tag: 'span',
	          classes: ['tox-insert-table-picker__label'],
	          attributes: { id: sizeLabelId }
	        },
	        components: [text('0x0')],
	        behaviours: derive$1([Replacing.config({})])
	      });
	      return {
	        type: 'widget',
	        data: { value: generate$1('widget-id') },
	        dom: {
	          tag: 'div',
	          classes: ['tox-fancymenuitem']
	        },
	        autofocus: true,
	        components: [parts$2.widget({
	            dom: {
	              tag: 'div',
	              classes: ['tox-insert-table-picker']
	            },
	            components: makeComponents(cells).concat(memLabel.asSpec()),
	            behaviours: derive$1([
	              config('insert-table-picker', [
	                runWithTarget(cellOverEvent, function (c, t, e) {
	                  var row = e.event.row;
	                  var col = e.event.col;
	                  selectCells(cells, row, col, numRows, numColumns);
	                  Replacing.set(memLabel.get(c), [makeLabelText(row, col)]);
	                }),
	                runWithTarget(cellExecuteEvent, function (c, _, e) {
	                  spec.onAction({
	                    numRows: e.event.row + 1,
	                    numColumns: e.event.col + 1
	                  });
	                  emit(c, sandboxClose());
	                })
	              ]),
	              Keying.config({
	                initSize: {
	                  numRows: numRows,
	                  numColumns: numColumns
	                },
	                mode: 'flatgrid',
	                selector: '[role="button"]'
	              })
	            ])
	          })]
	      };
	    };
	
	    var fancyMenuItems = {
	      inserttable: renderInsertTableMenuItem,
	      colorswatch: renderColorSwatchItem
	    };
	    var valueOpt = function (obj, key) {
	      return Object.prototype.hasOwnProperty.call(obj, key) ? Optional.some(obj[key]) : Optional.none();
	    };
	    var renderFancyMenuItem = function (spec, backstage) {
	      return valueOpt(fancyMenuItems, spec.fancytype).map(function (render) {
	        return render(spec, backstage);
	      });
	    };
	
	    var renderNestedItem = function (spec, itemResponse, providersBackstage, renderIcons, downwardsCaret) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      if (downwardsCaret === void 0) {
	        downwardsCaret = false;
	      }
	      var caret = downwardsCaret ? renderDownwardsCaret(providersBackstage.icons) : renderSubmenuCaret(providersBackstage.icons);
	      var getApi = function (component) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        presets: 'normal',
	        iconContent: spec.icon,
	        textContent: spec.text,
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        caret: Optional.some(caret),
	        checkMark: Optional.none(),
	        shortcutContent: spec.shortcut
	      }, providersBackstage, renderIcons);
	      return renderCommonItem({
	        data: buildData(spec),
	        getApi: getApi,
	        disabled: spec.disabled,
	        onAction: noop,
	        onSetup: spec.onSetup,
	        triggersSubmenu: true,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage);
	    };
	
	    var renderNormalItem = function (spec, itemResponse, providersBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var getApi = function (component) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        presets: 'normal',
	        iconContent: spec.icon,
	        textContent: spec.text,
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        caret: Optional.none(),
	        checkMark: Optional.none(),
	        shortcutContent: spec.shortcut
	      }, providersBackstage, renderIcons);
	      return renderCommonItem({
	        data: buildData(spec),
	        getApi: getApi,
	        disabled: spec.disabled,
	        onAction: spec.onAction,
	        onSetup: spec.onSetup,
	        triggersSubmenu: false,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage);
	    };
	
	    var renderSeparatorItem = function (spec) {
	      var innerHtml = spec.text.fold(function () {
	        return {};
	      }, function (text) {
	        return { innerHtml: text };
	      });
	      return {
	        type: 'separator',
	        dom: __assign({
	          tag: 'div',
	          classes: [
	            selectableClass,
	            groupHeadingClass
	          ]
	        }, innerHtml),
	        components: []
	      };
	    };
	
	    var renderToggleMenuItem = function (spec, itemResponse, providersBackstage, renderIcons) {
	      if (renderIcons === void 0) {
	        renderIcons = true;
	      }
	      var getApi = function (component) {
	        return {
	          setActive: function (state) {
	            Toggling.set(component, state);
	          },
	          isActive: function () {
	            return Toggling.isOn(component);
	          },
	          isDisabled: function () {
	            return Disabling.isDisabled(component);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(component, state);
	          }
	        };
	      };
	      var structure = renderItemStructure({
	        iconContent: spec.icon,
	        textContent: spec.text,
	        htmlContent: Optional.none(),
	        ariaLabel: spec.text,
	        checkMark: Optional.some(renderCheckmark(providersBackstage.icons)),
	        caret: Optional.none(),
	        shortcutContent: spec.shortcut,
	        presets: 'normal',
	        meta: spec.meta
	      }, providersBackstage, renderIcons);
	      return deepMerge(renderCommonItem({
	        data: buildData(spec),
	        disabled: spec.disabled,
	        getApi: getApi,
	        onAction: spec.onAction,
	        onSetup: spec.onSetup,
	        triggersSubmenu: false,
	        itemBehaviours: []
	      }, structure, itemResponse, providersBackstage), {
	        toggling: {
	          toggleClass: tickedClass,
	          toggleOnExecute: false,
	          selected: spec.active
	        }
	      });
	    };
	
	    var autocomplete = renderAutocompleteItem;
	    var separator = renderSeparatorItem;
	    var normal = renderNormalItem;
	    var nested = renderNestedItem;
	    var toggle$1 = renderToggleMenuItem;
	    var fancy = renderFancyMenuItem;
	    var card = renderCardMenuItem;
	
	    var FocusMode;
	    (function (FocusMode) {
	      FocusMode[FocusMode['ContentFocus'] = 0] = 'ContentFocus';
	      FocusMode[FocusMode['UiFocus'] = 1] = 'UiFocus';
	    }(FocusMode || (FocusMode = {})));
	    var createMenuItemFromBridge = function (item, itemResponse, backstage, menuHasIcons, isHorizontalMenu) {
	      var providersBackstage = backstage.shared.providers;
	      var parseForHorizontalMenu = function (menuitem) {
	        return !isHorizontalMenu ? menuitem : __assign(__assign({}, menuitem), {
	          shortcut: Optional.none(),
	          icon: menuitem.text.isSome() ? Optional.none() : menuitem.icon
	        });
	      };
	      switch (item.type) {
	      case 'menuitem':
	        return createMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(normal(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons));
	        });
	      case 'nestedmenuitem':
	        return createNestedMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(nested(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons, isHorizontalMenu));
	        });
	      case 'togglemenuitem':
	        return createToggleMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(toggle$1(parseForHorizontalMenu(d), itemResponse, providersBackstage, menuHasIcons));
	        });
	      case 'separator':
	        return createSeparatorMenuItem(item).fold(handleError, function (d) {
	          return Optional.some(separator(d));
	        });
	      case 'fancymenuitem':
	        return createFancyMenuItem(item).fold(handleError, function (d) {
	          return fancy(parseForHorizontalMenu(d), backstage);
	        });
	      default: {
	          console.error('Unknown item in general menu', item);
	          return Optional.none();
	        }
	      }
	    };
	    var createAutocompleteItems = function (items, matchText, onItemValueHandler, columns, itemResponse, sharedBackstage, highlightOn) {
	      var renderText = columns === 1;
	      var renderIcons = !renderText || menuHasIcons(items);
	      return cat(map(items, function (item) {
	        switch (item.type) {
	        case 'separator':
	          return createSeparatorItem(item).fold(handleError, function (d) {
	            return Optional.some(separator(d));
	          });
	        case 'cardmenuitem':
	          return createCardMenuItem(item).fold(handleError, function (d) {
	            return Optional.some(card(__assign(__assign({}, d), {
	              onAction: function (api) {
	                d.onAction(api);
	                onItemValueHandler(d.value, d.meta);
	              }
	            }), itemResponse, sharedBackstage, {
	              itemBehaviours: tooltipBehaviour(d.meta, sharedBackstage),
	              cardText: {
	                matchText: matchText,
	                highlightOn: highlightOn
	              }
	            }));
	          });
	        case 'autocompleteitem':
	        default:
	          return createAutocompleterItem(item).fold(handleError, function (d) {
	            return Optional.some(autocomplete(d, matchText, renderText, 'normal', onItemValueHandler, itemResponse, sharedBackstage, renderIcons));
	          });
	        }
	      }));
	    };
	    var createPartialMenu = function (value, items, itemResponse, backstage, isHorizontalMenu) {
	      var hasIcons = menuHasIcons(items);
	      var alloyItems = cat(map(items, function (item) {
	        var itemHasIcon = function (i) {
	          return isHorizontalMenu ? !i.hasOwnProperty('text') : hasIcons;
	        };
	        var createItem = function (i) {
	          return createMenuItemFromBridge(i, itemResponse, backstage, itemHasIcon(i), isHorizontalMenu);
	        };
	        if (item.type === 'nestedmenuitem' && item.getSubmenuItems().length <= 0) {
	          return createItem(__assign(__assign({}, item), { disabled: true }));
	        } else {
	          return createItem(item);
	        }
	      }));
	      var createPartial = isHorizontalMenu ? createHorizontalPartialMenuWithAlloyItems : createPartialMenuWithAlloyItems;
	      return createPartial(value, hasIcons, alloyItems, 1, 'normal');
	    };
	    var createTieredDataFrom = function (partialMenu) {
	      return tieredMenu.singleData(partialMenu.value, partialMenu);
	    };
	    var createMenuFrom = function (partialMenu, columns, focusMode, presets) {
	      var focusManager = focusMode === FocusMode.ContentFocus ? highlights() : dom();
	      var movement = deriveMenuMovement(columns, presets);
	      var menuMarkers = markers$1(presets);
	      return {
	        dom: partialMenu.dom,
	        components: partialMenu.components,
	        items: partialMenu.items,
	        value: partialMenu.value,
	        markers: {
	          selectedItem: menuMarkers.selectedItem,
	          item: menuMarkers.item
	        },
	        movement: movement,
	        fakeFocus: focusMode === FocusMode.ContentFocus,
	        focusManager: focusManager,
	        menuBehaviours: SimpleBehaviours.unnamedEvents(columns !== 'auto' ? [] : [runOnAttached(function (comp, _se) {
	            detectSize(comp, 4, menuMarkers.item).each(function (_a) {
	              var numColumns = _a.numColumns, numRows = _a.numRows;
	              Keying.setGridSize(comp, numRows, numColumns);
	            });
	          })])
	      };
	    };
	
	    var register$2 = function (editor, sharedBackstage) {
	      var activeAutocompleter = Cell(Optional.none());
	      var processingAction = Cell(false);
	      var autocompleter = build$1(InlineView.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-autocompleter']
	        },
	        components: [],
	        fireDismissalEventInstead: {},
	        inlineBehaviours: derive$1([config('dismissAutocompleter', [run(dismissRequested(), function () {
	              return cancelIfNecessary();
	            })])]),
	        lazySink: sharedBackstage.getSink
	      }));
	      var isMenuOpen = function () {
	        return InlineView.isOpen(autocompleter);
	      };
	      var isActive = function () {
	        return activeAutocompleter.get().isSome();
	      };
	      var hideIfNecessary = function () {
	        if (isActive()) {
	          InlineView.hide(autocompleter);
	        }
	      };
	      var cancelIfNecessary = function () {
	        if (isActive()) {
	          var lastElement = activeAutocompleter.get().map(function (ac) {
	            return ac.element;
	          });
	          detect$4(lastElement.getOr(SugarElement.fromDom(editor.selection.getNode()))).each(unwrap);
	          hideIfNecessary();
	          activeAutocompleter.set(Optional.none());
	          processingAction.set(false);
	        }
	      };
	      var getAutocompleters = cached(function () {
	        return register(editor);
	      });
	      var getCombinedItems = function (triggerChar, matches) {
	        var columns = findMap(matches, function (m) {
	          return Optional.from(m.columns);
	        }).getOr(1);
	        return bind(matches, function (match) {
	          var choices = match.items;
	          return createAutocompleteItems(choices, match.matchText, function (itemValue, itemMeta) {
	            var nr = editor.selection.getRng();
	            getContext(editor.dom, nr, triggerChar).fold(function () {
	              return console.error('Lost context. Cursor probably moved');
	            }, function (_a) {
	              var range = _a.range;
	              var autocompleterApi = {
	                hide: function () {
	                  cancelIfNecessary();
	                },
	                reload: function (fetchOptions) {
	                  hideIfNecessary();
	                  load(fetchOptions);
	                }
	              };
	              processingAction.set(true);
	              match.onAction(autocompleterApi, range, itemValue, itemMeta);
	              processingAction.set(false);
	            });
	          }, columns, ItemResponse$1.BUBBLE_TO_SANDBOX, sharedBackstage, match.highlightOn);
	        });
	      };
	      var commenceIfNecessary = function (context) {
	        if (!isActive()) {
	          var wrapper = create$4(editor, context.range);
	          activeAutocompleter.set(Optional.some({
	            triggerChar: context.triggerChar,
	            element: wrapper,
	            matchLength: context.text.length
	          }));
	          processingAction.set(false);
	        }
	      };
	      var display = function (ac, context, lookupData, items) {
	        ac.matchLength = context.text.length;
	        var columns = findMap(lookupData, function (ld) {
	          return Optional.from(ld.columns);
	        }).getOr(1);
	        InlineView.showAt(autocompleter, {
	          anchor: 'node',
	          root: SugarElement.fromDom(editor.getBody()),
	          node: Optional.from(ac.element)
	        }, Menu.sketch(createMenuFrom(createPartialMenuWithAlloyItems('autocompleter-value', true, items, columns, 'normal'), columns, FocusMode.ContentFocus, 'normal')));
	        InlineView.getContent(autocompleter).each(Highlighting.highlightFirst);
	      };
	      var doLookup = function (fetchOptions) {
	        return activeAutocompleter.get().map(function (ac) {
	          return getContext(editor.dom, editor.selection.getRng(), ac.triggerChar).bind(function (newContext) {
	            return lookupWithContext(editor, getAutocompleters, newContext, fetchOptions);
	          });
	        }).getOrThunk(function () {
	          return lookup(editor, getAutocompleters);
	        });
	      };
	      var load = function (fetchOptions) {
	        doLookup(fetchOptions).fold(cancelIfNecessary, function (lookupInfo) {
	          commenceIfNecessary(lookupInfo.context);
	          lookupInfo.lookupData.then(function (lookupData) {
	            activeAutocompleter.get().map(function (ac) {
	              var context = lookupInfo.context;
	              if (ac.triggerChar === context.triggerChar) {
	                var combinedItems = getCombinedItems(context.triggerChar, lookupData);
	                if (combinedItems.length > 0) {
	                  display(ac, context, lookupData, combinedItems);
	                } else if (context.text.length - ac.matchLength >= 10) {
	                  cancelIfNecessary();
	                } else {
	                  hideIfNecessary();
	                }
	              }
	            });
	          });
	        });
	      };
	      var onKeypress = last$2(function (e) {
	        if (e.which === 27) {
	          return;
	        }
	        load();
	      }, 50);
	      var autocompleterUiApi = {
	        onKeypress: onKeypress,
	        cancelIfNecessary: cancelIfNecessary,
	        isMenuOpen: isMenuOpen,
	        isActive: isActive,
	        isProcessingAction: processingAction.get,
	        getView: function () {
	          return InlineView.getContent(autocompleter);
	        }
	      };
	      if (editor.hasPlugin('rtc') === false) {
	        AutocompleterEditorEvents.setup(autocompleterUiApi, editor);
	      }
	    };
	    var Autocompleter = { register: register$2 };
	
	    var filter$2 = always;
	    var bind$3 = function (element, event, handler) {
	      return bind$2(element, event, filter$2, handler);
	    };
	    var capture$1 = function (element, event, handler) {
	      return capture(element, event, filter$2, handler);
	    };
	    var fromRawEvent$1 = fromRawEvent;
	
	    var closest$4 = function (scope, selector, isRoot) {
	      return closest$3(scope, selector, isRoot).isSome();
	    };
	
	    var DelayedFunction = function (fun, delay) {
	      var ref = null;
	      var schedule = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        ref = setTimeout(function () {
	          fun.apply(null, args);
	          ref = null;
	        }, delay);
	      };
	      var cancel = function () {
	        if (ref !== null) {
	          clearTimeout(ref);
	          ref = null;
	        }
	      };
	      return {
	        cancel: cancel,
	        schedule: schedule
	      };
	    };
	
	    var SIGNIFICANT_MOVE = 5;
	    var LONGPRESS_DELAY = 400;
	    var getTouch = function (event) {
	      var raw = event.raw;
	      if (raw.touches === undefined || raw.touches.length !== 1) {
	        return Optional.none();
	      }
	      return Optional.some(raw.touches[0]);
	    };
	    var isFarEnough = function (touch, data) {
	      var distX = Math.abs(touch.clientX - data.x);
	      var distY = Math.abs(touch.clientY - data.y);
	      return distX > SIGNIFICANT_MOVE || distY > SIGNIFICANT_MOVE;
	    };
	    var monitor = function (settings) {
	      var startData = Cell(Optional.none());
	      var longpressFired = Cell(false);
	      var longpress$1 = DelayedFunction(function (event) {
	        settings.triggerEvent(longpress(), event);
	        longpressFired.set(true);
	      }, LONGPRESS_DELAY);
	      var handleTouchstart = function (event) {
	        getTouch(event).each(function (touch) {
	          longpress$1.cancel();
	          var data = {
	            x: touch.clientX,
	            y: touch.clientY,
	            target: event.target
	          };
	          longpress$1.schedule(event);
	          longpressFired.set(false);
	          startData.set(Optional.some(data));
	        });
	        return Optional.none();
	      };
	      var handleTouchmove = function (event) {
	        longpress$1.cancel();
	        getTouch(event).each(function (touch) {
	          startData.get().each(function (data) {
	            if (isFarEnough(touch, data)) {
	              startData.set(Optional.none());
	            }
	          });
	        });
	        return Optional.none();
	      };
	      var handleTouchend = function (event) {
	        longpress$1.cancel();
	        var isSame = function (data) {
	          return eq$1(data.target, event.target);
	        };
	        return startData.get().filter(isSame).map(function (_data) {
	          if (longpressFired.get()) {
	            event.prevent();
	            return false;
	          } else {
	            return settings.triggerEvent(tap(), event);
	          }
	        });
	      };
	      var handlers = wrapAll$1([
	        {
	          key: touchstart(),
	          value: handleTouchstart
	        },
	        {
	          key: touchmove(),
	          value: handleTouchmove
	        },
	        {
	          key: touchend(),
	          value: handleTouchend
	        }
	      ]);
	      var fireIfReady = function (event, type) {
	        return get$1(handlers, type).bind(function (handler) {
	          return handler(event);
	        });
	      };
	      return { fireIfReady: fireIfReady };
	    };
	
	    var isDangerous = function (event) {
	      var keyEv = event.raw;
	      return keyEv.which === BACKSPACE[0] && !contains([
	        'input',
	        'textarea'
	      ], name(event.target)) && !closest$4(event.target, '[contenteditable="true"]');
	    };
	    var isFirefox = function () {
	      return detect$3().browser.isFirefox();
	    };
	    var settingsSchema = objOfOnly([
	      strictFunction('triggerEvent'),
	      defaulted$1('stopBackspace', true)
	    ]);
	    var bindFocus = function (container, handler) {
	      if (isFirefox()) {
	        return capture$1(container, 'focus', handler);
	      } else {
	        return bind$3(container, 'focusin', handler);
	      }
	    };
	    var bindBlur = function (container, handler) {
	      if (isFirefox()) {
	        return capture$1(container, 'blur', handler);
	      } else {
	        return bind$3(container, 'focusout', handler);
	      }
	    };
	    var setup$1 = function (container, rawSettings) {
	      var settings = asRawOrDie('Getting GUI events settings', settingsSchema, rawSettings);
	      var pointerEvents = [
	        'touchstart',
	        'touchmove',
	        'touchend',
	        'touchcancel',
	        'gesturestart',
	        'mousedown',
	        'mouseup',
	        'mouseover',
	        'mousemove',
	        'mouseout',
	        'click'
	      ];
	      var tapEvent = monitor(settings);
	      var simpleEvents = map(pointerEvents.concat([
	        'selectstart',
	        'input',
	        'contextmenu',
	        'change',
	        'transitionend',
	        'drag',
	        'dragstart',
	        'dragend',
	        'dragenter',
	        'dragleave',
	        'dragover',
	        'drop',
	        'keyup'
	      ]), function (type) {
	        return bind$3(container, type, function (event) {
	          tapEvent.fireIfReady(event, type).each(function (tapStopped) {
	            if (tapStopped) {
	              event.kill();
	            }
	          });
	          var stopped = settings.triggerEvent(type, event);
	          if (stopped) {
	            event.kill();
	          }
	        });
	      });
	      var pasteTimeout = Cell(Optional.none());
	      var onPaste = bind$3(container, 'paste', function (event) {
	        tapEvent.fireIfReady(event, 'paste').each(function (tapStopped) {
	          if (tapStopped) {
	            event.kill();
	          }
	        });
	        var stopped = settings.triggerEvent('paste', event);
	        if (stopped) {
	          event.kill();
	        }
	        pasteTimeout.set(Optional.some(setTimeout(function () {
	          settings.triggerEvent(postPaste(), event);
	        }, 0)));
	      });
	      var onKeydown = bind$3(container, 'keydown', function (event) {
	        var stopped = settings.triggerEvent('keydown', event);
	        if (stopped) {
	          event.kill();
	        } else if (settings.stopBackspace === true && isDangerous(event)) {
	          event.prevent();
	        }
	      });
	      var onFocusIn = bindFocus(container, function (event) {
	        var stopped = settings.triggerEvent('focusin', event);
	        if (stopped) {
	          event.kill();
	        }
	      });
	      var focusoutTimeout = Cell(Optional.none());
	      var onFocusOut = bindBlur(container, function (event) {
	        var stopped = settings.triggerEvent('focusout', event);
	        if (stopped) {
	          event.kill();
	        }
	        focusoutTimeout.set(Optional.some(setTimeout(function () {
	          settings.triggerEvent(postBlur(), event);
	        }, 0)));
	      });
	      var unbind = function () {
	        each(simpleEvents, function (e) {
	          e.unbind();
	        });
	        onKeydown.unbind();
	        onFocusIn.unbind();
	        onFocusOut.unbind();
	        onPaste.unbind();
	        pasteTimeout.get().each(clearTimeout);
	        focusoutTimeout.get().each(clearTimeout);
	      };
	      return { unbind: unbind };
	    };
	
	    var derive$2 = function (rawEvent, rawTarget) {
	      var source = get$1(rawEvent, 'target').getOr(rawTarget);
	      return Cell(source);
	    };
	
	    var fromSource = function (event, source) {
	      var stopper = Cell(false);
	      var cutter = Cell(false);
	      var stop = function () {
	        stopper.set(true);
	      };
	      var cut = function () {
	        cutter.set(true);
	      };
	      return {
	        stop: stop,
	        cut: cut,
	        isStopped: stopper.get,
	        isCut: cutter.get,
	        event: event,
	        setSource: source.set,
	        getSource: source.get
	      };
	    };
	    var fromExternal = function (event) {
	      var stopper = Cell(false);
	      var stop = function () {
	        stopper.set(true);
	      };
	      return {
	        stop: stop,
	        cut: noop,
	        isStopped: stopper.get,
	        isCut: never,
	        event: event,
	        setSource: die('Cannot set source of a broadcasted event'),
	        getSource: die('Cannot get source of a broadcasted event')
	      };
	    };
	
	    var adt$b = Adt.generate([
	      { stopped: [] },
	      { resume: ['element'] },
	      { complete: [] }
	    ]);
	    var doTriggerHandler = function (lookup, eventType, rawEvent, target, source, logger) {
	      var handler = lookup(eventType, target);
	      var simulatedEvent = fromSource(rawEvent, source);
	      return handler.fold(function () {
	        logger.logEventNoHandlers(eventType, target);
	        return adt$b.complete();
	      }, function (handlerInfo) {
	        var descHandler = handlerInfo.descHandler;
	        var eventHandler = getCurried(descHandler);
	        eventHandler(simulatedEvent);
	        if (simulatedEvent.isStopped()) {
	          logger.logEventStopped(eventType, handlerInfo.element, descHandler.purpose);
	          return adt$b.stopped();
	        } else if (simulatedEvent.isCut()) {
	          logger.logEventCut(eventType, handlerInfo.element, descHandler.purpose);
	          return adt$b.complete();
	        } else {
	          return parent(handlerInfo.element).fold(function () {
	            logger.logNoParent(eventType, handlerInfo.element, descHandler.purpose);
	            return adt$b.complete();
	          }, function (parent) {
	            logger.logEventResponse(eventType, handlerInfo.element, descHandler.purpose);
	            return adt$b.resume(parent);
	          });
	        }
	      });
	    };
	    var doTriggerOnUntilStopped = function (lookup, eventType, rawEvent, rawTarget, source, logger) {
	      return doTriggerHandler(lookup, eventType, rawEvent, rawTarget, source, logger).fold(always, function (parent) {
	        return doTriggerOnUntilStopped(lookup, eventType, rawEvent, parent, source, logger);
	      }, never);
	    };
	    var triggerHandler = function (lookup, eventType, rawEvent, target, logger) {
	      var source = derive$2(rawEvent, target);
	      return doTriggerHandler(lookup, eventType, rawEvent, target, source, logger);
	    };
	    var broadcast = function (listeners, rawEvent, _logger) {
	      var simulatedEvent = fromExternal(rawEvent);
	      each(listeners, function (listener) {
	        var descHandler = listener.descHandler;
	        var handler = getCurried(descHandler);
	        handler(simulatedEvent);
	      });
	      return simulatedEvent.isStopped();
	    };
	    var triggerUntilStopped = function (lookup, eventType, rawEvent, logger) {
	      return triggerOnUntilStopped(lookup, eventType, rawEvent, rawEvent.target, logger);
	    };
	    var triggerOnUntilStopped = function (lookup, eventType, rawEvent, rawTarget, logger) {
	      var source = derive$2(rawEvent, rawTarget);
	      return doTriggerOnUntilStopped(lookup, eventType, rawEvent, rawTarget, source, logger);
	    };
	
	    var eventHandler = function (element, descHandler) {
	      return {
	        element: element,
	        descHandler: descHandler
	      };
	    };
	    var broadcastHandler = function (id, handler) {
	      return {
	        id: id,
	        descHandler: handler
	      };
	    };
	    var EventRegistry = function () {
	      var registry = {};
	      var registerId = function (extraArgs, id, events) {
	        each$1(events, function (v, k) {
	          var handlers = registry[k] !== undefined ? registry[k] : {};
	          handlers[id] = curryArgs(v, extraArgs);
	          registry[k] = handlers;
	        });
	      };
	      var findHandler = function (handlers, elem) {
	        return read$1(elem).fold(function () {
	          return Optional.none();
	        }, function (id) {
	          return handlers.bind(function (h) {
	            return get$1(h, id);
	          }).map(function (descHandler) {
	            return eventHandler(elem, descHandler);
	          });
	        });
	      };
	      var filterByType = function (type) {
	        return get$1(registry, type).map(function (handlers) {
	          return mapToArray(handlers, function (f, id) {
	            return broadcastHandler(id, f);
	          });
	        }).getOr([]);
	      };
	      var find = function (isAboveRoot, type, target) {
	        var handlers = get$1(registry, type);
	        return closest(target, function (elem) {
	          return findHandler(handlers, elem);
	        }, isAboveRoot);
	      };
	      var unregisterId = function (id) {
	        each$1(registry, function (handlersById, _eventName) {
	          if (handlersById.hasOwnProperty(id)) {
	            delete handlersById[id];
	          }
	        });
	      };
	      return {
	        registerId: registerId,
	        unregisterId: unregisterId,
	        filterByType: filterByType,
	        find: find
	      };
	    };
	
	    var Registry = function () {
	      var events = EventRegistry();
	      var components = {};
	      var readOrTag = function (component) {
	        var elem = component.element;
	        return read$1(elem).fold(function () {
	          return write('uid-', component.element);
	        }, function (uid) {
	          return uid;
	        });
	      };
	      var failOnDuplicate = function (component, tagId) {
	        var conflict = components[tagId];
	        if (conflict === component) {
	          unregister(component);
	        } else {
	          throw new Error('The tagId "' + tagId + '" is already used by: ' + element(conflict.element) + '\nCannot use it for: ' + element(component.element) + '\n' + 'The conflicting element is' + (inBody(conflict.element) ? ' ' : ' not ') + 'already in the DOM');
	        }
	      };
	      var register = function (component) {
	        var tagId = readOrTag(component);
	        if (hasNonNullableKey(components, tagId)) {
	          failOnDuplicate(component, tagId);
	        }
	        var extraArgs = [component];
	        events.registerId(extraArgs, tagId, component.events);
	        components[tagId] = component;
	      };
	      var unregister = function (component) {
	        read$1(component.element).each(function (tagId) {
	          delete components[tagId];
	          events.unregisterId(tagId);
	        });
	      };
	      var filter = function (type) {
	        return events.filterByType(type);
	      };
	      var find = function (isAboveRoot, type, target) {
	        return events.find(isAboveRoot, type, target);
	      };
	      var getById = function (id) {
	        return get$1(components, id);
	      };
	      return {
	        find: find,
	        filter: filter,
	        register: register,
	        unregister: unregister,
	        getById: getById
	      };
	    };
	
	    var factory$3 = function (detail) {
	      var _a = detail.dom, attributes = _a.attributes, domWithoutAttributes = __rest(_a, ['attributes']);
	      return {
	        uid: detail.uid,
	        dom: __assign({
	          tag: 'div',
	          attributes: __assign({ role: 'presentation' }, attributes)
	        }, domWithoutAttributes),
	        components: detail.components,
	        behaviours: get$d(detail.containerBehaviours),
	        events: detail.events,
	        domModification: detail.domModification,
	        eventOrder: detail.eventOrder
	      };
	    };
	    var Container = single$2({
	      name: 'Container',
	      factory: factory$3,
	      configFields: [
	        defaulted$1('components', []),
	        field$1('containerBehaviours', []),
	        defaulted$1('events', {}),
	        defaulted$1('domModification', {}),
	        defaulted$1('eventOrder', {})
	      ]
	    });
	
	    var takeover = function (root) {
	      var isAboveRoot = function (el) {
	        return parent(root.element).fold(always, function (parent) {
	          return eq$1(el, parent);
	        });
	      };
	      var registry = Registry();
	      var lookup = function (eventName, target) {
	        return registry.find(isAboveRoot, eventName, target);
	      };
	      var domEvents = setup$1(root.element, {
	        triggerEvent: function (eventName, event) {
	          return monitorEvent(eventName, event.target, function (logger) {
	            return triggerUntilStopped(lookup, eventName, event, logger);
	          });
	        }
	      });
	      var systemApi = {
	        debugInfo: constant('real'),
	        triggerEvent: function (eventName, target, data) {
	          monitorEvent(eventName, target, function (logger) {
	            return triggerOnUntilStopped(lookup, eventName, data, target, logger);
	          });
	        },
	        triggerFocus: function (target, originator) {
	          read$1(target).fold(function () {
	            focus$1(target);
	          }, function (_alloyId) {
	            monitorEvent(focus(), target, function (logger) {
	              triggerHandler(lookup, focus(), {
	                originator: originator,
	                kill: noop,
	                prevent: noop,
	                target: target
	              }, target, logger);
	              return false;
	            });
	          });
	        },
	        triggerEscape: function (comp, simulatedEvent) {
	          systemApi.triggerEvent('keydown', comp.element, simulatedEvent.event);
	        },
	        getByUid: function (uid) {
	          return getByUid(uid);
	        },
	        getByDom: function (elem) {
	          return getByDom(elem);
	        },
	        build: build$1,
	        addToGui: function (c) {
	          add(c);
	        },
	        removeFromGui: function (c) {
	          remove$1(c);
	        },
	        addToWorld: function (c) {
	          addToWorld(c);
	        },
	        removeFromWorld: function (c) {
	          removeFromWorld(c);
	        },
	        broadcast: function (message) {
	          broadcast$1(message);
	        },
	        broadcastOn: function (channels, message) {
	          broadcastOn(channels, message);
	        },
	        broadcastEvent: function (eventName, event) {
	          broadcastEvent(eventName, event);
	        },
	        isConnected: always
	      };
	      var addToWorld = function (component) {
	        component.connect(systemApi);
	        if (!isText(component.element)) {
	          registry.register(component);
	          each(component.components(), addToWorld);
	          systemApi.triggerEvent(systemInit(), component.element, { target: component.element });
	        }
	      };
	      var removeFromWorld = function (component) {
	        if (!isText(component.element)) {
	          each(component.components(), removeFromWorld);
	          registry.unregister(component);
	        }
	        component.disconnect();
	      };
	      var add = function (component) {
	        attach$1(root, component);
	      };
	      var remove$1 = function (component) {
	        detach(component);
	      };
	      var destroy = function () {
	        domEvents.unbind();
	        remove(root.element);
	      };
	      var broadcastData = function (data) {
	        var receivers = registry.filter(receive());
	        each(receivers, function (receiver) {
	          var descHandler = receiver.descHandler;
	          var handler = getCurried(descHandler);
	          handler(data);
	        });
	      };
	      var broadcast$1 = function (message) {
	        broadcastData({
	          universal: true,
	          data: message
	        });
	      };
	      var broadcastOn = function (channels, message) {
	        broadcastData({
	          universal: false,
	          channels: channels,
	          data: message
	        });
	      };
	      var broadcastEvent = function (eventName, event) {
	        var listeners = registry.filter(eventName);
	        return broadcast(listeners, event);
	      };
	      var getByUid = function (uid) {
	        return registry.getById(uid).fold(function () {
	          return Result.error(new Error('Could not find component with uid: "' + uid + '" in system.'));
	        }, Result.value);
	      };
	      var getByDom = function (elem) {
	        var uid = read$1(elem).getOr('not found');
	        return getByUid(uid);
	      };
	      addToWorld(root);
	      return {
	        root: root,
	        element: root.element,
	        destroy: destroy,
	        add: add,
	        remove: remove$1,
	        getByUid: getByUid,
	        getByDom: getByDom,
	        addToWorld: addToWorld,
	        removeFromWorld: removeFromWorld,
	        broadcast: broadcast$1,
	        broadcastOn: broadcastOn,
	        broadcastEvent: broadcastEvent
	      };
	    };
	
	    var renderBar = function (spec, backstage) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-bar',
	            'tox-form__controls-h-stack'
	          ]
	        },
	        components: map(spec.items, backstage.interpreter)
	      };
	    };
	
	    var schema$e = constant([
	      defaulted$1('prefix', 'form-field'),
	      field$1('fieldBehaviours', [
	        Composing,
	        Representing
	      ])
	    ]);
	    var parts$3 = constant([
	      optional({
	        schema: [strict$1('dom')],
	        name: 'label'
	      }),
	      optional({
	        factory: {
	          sketch: function (spec) {
	            return {
	              uid: spec.uid,
	              dom: {
	                tag: 'span',
	                styles: { display: 'none' },
	                attributes: { 'aria-hidden': 'true' },
	                innerHtml: spec.text
	              }
	            };
	          }
	        },
	        schema: [strict$1('text')],
	        name: 'aria-descriptor'
	      }),
	      required({
	        factory: {
	          sketch: function (spec) {
	            var excludeFactory = exclude$1(spec, ['factory']);
	            return spec.factory.sketch(excludeFactory);
	          }
	        },
	        schema: [strict$1('factory')],
	        name: 'field'
	      })
	    ]);
	
	    var factory$4 = function (detail, components, _spec, _externals) {
	      var behaviours = augment(detail.fieldBehaviours, [
	        Composing.config({
	          find: function (container) {
	            return getPart(container, detail, 'field');
	          }
	        }),
	        Representing.config({
	          store: {
	            mode: 'manual',
	            getValue: function (field) {
	              return Composing.getCurrent(field).bind(Representing.getValue);
	            },
	            setValue: function (field, value) {
	              Composing.getCurrent(field).each(function (current) {
	                Representing.setValue(current, value);
	              });
	            }
	          }
	        })
	      ]);
	      var events = derive([runOnAttached(function (component, _simulatedEvent) {
	          var ps = getParts(component, detail, [
	            'label',
	            'field',
	            'aria-descriptor'
	          ]);
	          ps.field().each(function (field) {
	            var id = generate$1(detail.prefix);
	            ps.label().each(function (label) {
	              set$1(label.element, 'for', id);
	              set$1(field.element, 'id', id);
	            });
	            ps['aria-descriptor']().each(function (descriptor) {
	              var descriptorId = generate$1(detail.prefix);
	              set$1(descriptor.element, 'id', descriptorId);
	              set$1(field.element, 'aria-describedby', descriptorId);
	            });
	          });
	        })]);
	      var apis = {
	        getField: function (container) {
	          return getPart(container, detail, 'field');
	        },
	        getLabel: function (container) {
	          return getPart(container, detail, 'label');
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: behaviours,
	        events: events,
	        apis: apis
	      };
	    };
	    var FormField = composite$1({
	      name: 'FormField',
	      configFields: schema$e(),
	      partFields: parts$3(),
	      factory: factory$4,
	      apis: {
	        getField: function (apis, comp) {
	          return apis.getField(comp);
	        },
	        getLabel: function (apis, comp) {
	          return apis.getLabel(comp);
	        }
	      }
	    });
	
	    var exhibit$4 = function (base, tabConfig) {
	      return nu$6({
	        attributes: wrapAll$1([{
	            key: tabConfig.tabAttr,
	            value: 'true'
	          }])
	      });
	    };
	
	    var ActiveTabstopping = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$4
	    });
	
	    var TabstopSchema = [defaulted$1('tabAttr', 'data-alloy-tabstop')];
	
	    var Tabstopping = create$1({
	      fields: TabstopSchema,
	      name: 'tabstopping',
	      active: ActiveTabstopping
	    });
	
	    var global$a = tinymce.util.Tools.resolve('tinymce.html.Entities');
	
	    var renderFormFieldWith = function (pLabel, pField, extraClasses, extraBehaviours) {
	      var spec = renderFormFieldSpecWith(pLabel, pField, extraClasses, extraBehaviours);
	      return FormField.sketch(spec);
	    };
	    var renderFormField = function (pLabel, pField) {
	      return renderFormFieldWith(pLabel, pField, [], []);
	    };
	    var renderFormFieldSpecWith = function (pLabel, pField, extraClasses, extraBehaviours) {
	      return {
	        dom: renderFormFieldDomWith(extraClasses),
	        components: pLabel.toArray().concat([pField]),
	        fieldBehaviours: derive$1(extraBehaviours)
	      };
	    };
	    var renderFormFieldDom = function () {
	      return renderFormFieldDomWith([]);
	    };
	    var renderFormFieldDomWith = function (extraClasses) {
	      return {
	        tag: 'div',
	        classes: ['tox-form__group'].concat(extraClasses)
	      };
	    };
	    var renderLabel = function (label, providersBackstage) {
	      return FormField.parts.label({
	        dom: {
	          tag: 'label',
	          classes: ['tox-label'],
	          innerHtml: providersBackstage.translate(label)
	        }
	      });
	    };
	
	    var formChangeEvent = generate$1('form-component-change');
	    var formCloseEvent = generate$1('form-close');
	    var formCancelEvent = generate$1('form-cancel');
	    var formActionEvent = generate$1('form-action');
	    var formSubmitEvent = generate$1('form-submit');
	    var formBlockEvent = generate$1('form-block');
	    var formUnblockEvent = generate$1('form-unblock');
	    var formTabChangeEvent = generate$1('form-tabchange');
	    var formResizeEvent = generate$1('form-resize');
	
	    var renderCollection = function (spec, providersBackstage) {
	      var _a;
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var runOnItem = function (f) {
	        return function (comp, se) {
	          closest$3(se.event.target, '[data-collection-item-value]').each(function (target) {
	            f(comp, se, target, get$3(target, 'data-collection-item-value'));
	          });
	        };
	      };
	      var setContents = function (comp, items) {
	        var htmlLines = map(items, function (item) {
	          var itemText = global$6.translate(item.text);
	          var textContent = spec.columns === 1 ? '<div class="tox-collection__item-label">' + itemText + '</div>' : '';
	          var iconContent = '<div class="tox-collection__item-icon">' + item.icon + '</div>';
	          var mapItemName = {
	            '_': ' ',
	            ' - ': ' ',
	            '-': ' '
	          };
	          var ariaLabel = itemText.replace(/\_| \- |\-/g, function (match) {
	            return mapItemName[match];
	          });
	          var disabledClass = providersBackstage.isDisabled() ? ' tox-collection__item--state-disabled' : '';
	          return '<div class="tox-collection__item' + disabledClass + '" tabindex="-1" data-collection-item-value="' + global$a.encodeAllRaw(item.value) + '" title="' + ariaLabel + '" aria-label="' + ariaLabel + '">' + iconContent + textContent + '</div>';
	        });
	        var chunks = spec.columns !== 'auto' && spec.columns > 1 ? chunk(htmlLines, spec.columns) : [htmlLines];
	        var html = map(chunks, function (ch) {
	          return '<div class="tox-collection__group">' + ch.join('') + '</div>';
	        });
	        set(comp.element, html.join(''));
	      };
	      var onClick = runOnItem(function (comp, se, tgt, itemValue) {
	        se.stop();
	        if (!providersBackstage.isDisabled()) {
	          emitWith(comp, formActionEvent, {
	            name: spec.name,
	            value: itemValue
	          });
	        }
	      });
	      var collectionEvents = [
	        run(mouseover(), runOnItem(function (comp, se, tgt) {
	          focus$1(tgt);
	        })),
	        run(click(), onClick),
	        run(tap(), onClick),
	        run(focusin(), runOnItem(function (comp, se, tgt) {
	          descendant$1(comp.element, '.' + activeClass).each(function (currentActive) {
	            remove$4(currentActive, activeClass);
	          });
	          add$2(tgt, activeClass);
	        })),
	        run(focusout(), runOnItem(function (comp) {
	          descendant$1(comp.element, '.' + activeClass).each(function (currentActive) {
	            remove$4(currentActive, activeClass);
	          });
	        })),
	        runOnExecute(runOnItem(function (comp, se, tgt, itemValue) {
	          emitWith(comp, formActionEvent, {
	            name: spec.name,
	            value: itemValue
	          });
	        }))
	      ];
	      var iterCollectionItems = function (comp, applyAttributes) {
	        return map(descendants(comp.element, '.tox-collection__item'), applyAttributes);
	      };
	      var pField = FormField.parts.field({
	        dom: {
	          tag: 'div',
	          classes: ['tox-collection'].concat(spec.columns !== 1 ? ['tox-collection--grid'] : ['tox-collection--list'])
	        },
	        components: [],
	        factory: { sketch: identity },
	        behaviours: derive$1([
	          Disabling.config({
	            disabled: providersBackstage.isDisabled,
	            onDisabled: function (comp) {
	              iterCollectionItems(comp, function (childElm) {
	                add$2(childElm, 'tox-collection__item--state-disabled');
	                set$1(childElm, 'aria-disabled', true);
	              });
	            },
	            onEnabled: function (comp) {
	              iterCollectionItems(comp, function (childElm) {
	                remove$4(childElm, 'tox-collection__item--state-disabled');
	                remove$1(childElm, 'aria-disabled');
	              });
	            }
	          }),
	          receivingConfig(),
	          Replacing.config({}),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: []
	            },
	            onSetValue: function (comp, items) {
	              setContents(comp, items);
	              if (spec.columns === 'auto') {
	                detectSize(comp, 5, 'tox-collection__item').each(function (_a) {
	                  var numRows = _a.numRows, numColumns = _a.numColumns;
	                  Keying.setGridSize(comp, numRows, numColumns);
	                });
	              }
	              emit(comp, formResizeEvent);
	            }
	          }),
	          Tabstopping.config({}),
	          Keying.config(deriveCollectionMovement(spec.columns, 'normal')),
	          config('collection-events', collectionEvents)
	        ]),
	        eventOrder: (_a = {}, _a[execute()] = [
	          'disabling',
	          'alloy.base.behaviour',
	          'collection-events'
	        ], _a)
	      });
	      var extraClasses = ['tox-form__group--collection'];
	      return renderFormFieldWith(pLabel, pField, extraClasses, []);
	    };
	
	    var schema$f = constant([
	      option('data'),
	      defaulted$1('inputAttributes', {}),
	      defaulted$1('inputStyles', {}),
	      defaulted$1('tag', 'input'),
	      defaulted$1('inputClasses', []),
	      onHandler('onSetValue'),
	      defaulted$1('styles', {}),
	      defaulted$1('eventOrder', {}),
	      field$1('inputBehaviours', [
	        Representing,
	        Focusing
	      ]),
	      defaulted$1('selectOnFocus', true)
	    ]);
	    var focusBehaviours = function (detail) {
	      return derive$1([Focusing.config({
	          onFocus: !detail.selectOnFocus ? noop : function (component) {
	            var input = component.element;
	            var value = get$6(input);
	            input.dom.setSelectionRange(0, value.length);
	          }
	        })]);
	    };
	    var behaviours = function (detail) {
	      return __assign(__assign({}, focusBehaviours(detail)), augment(detail.inputBehaviours, [Representing.config({
	          store: __assign(__assign({ mode: 'manual' }, detail.data.map(function (data) {
	            return { initialValue: data };
	          }).getOr({})), {
	            getValue: function (input) {
	              return get$6(input.element);
	            },
	            setValue: function (input, data) {
	              var current = get$6(input.element);
	              if (current !== data) {
	                set$3(input.element, data);
	              }
	            }
	          }),
	          onSetValue: detail.onSetValue
	        })]));
	    };
	    var dom$2 = function (detail) {
	      return {
	        tag: detail.tag,
	        attributes: __assign({ type: 'text' }, detail.inputAttributes),
	        styles: detail.inputStyles,
	        classes: detail.inputClasses
	      };
	    };
	
	    var factory$5 = function (detail, _spec) {
	      return {
	        uid: detail.uid,
	        dom: dom$2(detail),
	        components: [],
	        behaviours: behaviours(detail),
	        eventOrder: detail.eventOrder
	      };
	    };
	    var Input = single$2({
	      name: 'Input',
	      configFields: schema$f(),
	      factory: factory$5
	    });
	
	    var exports$1 = {}, module = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (f) {
	        if (typeof exports === 'object' && typeof module !== 'undefined') {
	          module.exports = f();
	        } else if (typeof define === 'function' && define.amd) {
	          define([], f);
	        } else {
	          var g;
	          if (typeof window !== 'undefined') {
	            g = window;
	          } else if (typeof global !== 'undefined') {
	            g = global;
	          } else if (typeof self !== 'undefined') {
	            g = self;
	          } else {
	            g = this;
	          }
	          g.EphoxContactWrapper = f();
	        }
	      }(function () {
	        return function () {
	          function r(e, n, t) {
	            function o(i, f) {
	              if (!n[i]) {
	                if (!e[i]) {
	                  var c = 'function' == typeof require && require;
	                  if (!f && c)
	                    return c(i, !0);
	                  if (u)
	                    return u(i, !0);
	                  var a = new Error('Cannot find module \'' + i + '\'');
	                  throw a.code = 'MODULE_NOT_FOUND', a;
	                }
	                var p = n[i] = { exports: {} };
	                e[i][0].call(p.exports, function (r) {
	                  var n = e[i][1][r];
	                  return o(n || r);
	                }, p, p.exports, r, e, n, t);
	              }
	              return n[i].exports;
	            }
	            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
	              o(t[i]);
	            return o;
	          }
	          return r;
	        }()({
	          1: [
	            function (require, module, exports) {
	              var process = module.exports = {};
	              var cachedSetTimeout;
	              var cachedClearTimeout;
	              function defaultSetTimout() {
	                throw new Error('setTimeout has not been defined');
	              }
	              function defaultClearTimeout() {
	                throw new Error('clearTimeout has not been defined');
	              }
	              (function () {
	                try {
	                  if (typeof setTimeout === 'function') {
	                    cachedSetTimeout = setTimeout;
	                  } else {
	                    cachedSetTimeout = defaultSetTimout;
	                  }
	                } catch (e) {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	                try {
	                  if (typeof clearTimeout === 'function') {
	                    cachedClearTimeout = clearTimeout;
	                  } else {
	                    cachedClearTimeout = defaultClearTimeout;
	                  }
	                } catch (e) {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              }());
	              function runTimeout(fun) {
	                if (cachedSetTimeout === setTimeout) {
	                  return setTimeout(fun, 0);
	                }
	                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                  cachedSetTimeout = setTimeout;
	                  return setTimeout(fun, 0);
	                }
	                try {
	                  return cachedSetTimeout(fun, 0);
	                } catch (e) {
	                  try {
	                    return cachedSetTimeout.call(null, fun, 0);
	                  } catch (e) {
	                    return cachedSetTimeout.call(this, fun, 0);
	                  }
	                }
	              }
	              function runClearTimeout(marker) {
	                if (cachedClearTimeout === clearTimeout) {
	                  return clearTimeout(marker);
	                }
	                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                  cachedClearTimeout = clearTimeout;
	                  return clearTimeout(marker);
	                }
	                try {
	                  return cachedClearTimeout(marker);
	                } catch (e) {
	                  try {
	                    return cachedClearTimeout.call(null, marker);
	                  } catch (e) {
	                    return cachedClearTimeout.call(this, marker);
	                  }
	                }
	              }
	              var queue = [];
	              var draining = false;
	              var currentQueue;
	              var queueIndex = -1;
	              function cleanUpNextTick() {
	                if (!draining || !currentQueue) {
	                  return;
	                }
	                draining = false;
	                if (currentQueue.length) {
	                  queue = currentQueue.concat(queue);
	                } else {
	                  queueIndex = -1;
	                }
	                if (queue.length) {
	                  drainQueue();
	                }
	              }
	              function drainQueue() {
	                if (draining) {
	                  return;
	                }
	                var timeout = runTimeout(cleanUpNextTick);
	                draining = true;
	                var len = queue.length;
	                while (len) {
	                  currentQueue = queue;
	                  queue = [];
	                  while (++queueIndex < len) {
	                    if (currentQueue) {
	                      currentQueue[queueIndex].run();
	                    }
	                  }
	                  queueIndex = -1;
	                  len = queue.length;
	                }
	                currentQueue = null;
	                draining = false;
	                runClearTimeout(timeout);
	              }
	              process.nextTick = function (fun) {
	                var args = new Array(arguments.length - 1);
	                if (arguments.length > 1) {
	                  for (var i = 1; i < arguments.length; i++) {
	                    args[i - 1] = arguments[i];
	                  }
	                }
	                queue.push(new Item(fun, args));
	                if (queue.length === 1 && !draining) {
	                  runTimeout(drainQueue);
	                }
	              };
	              function Item(fun, array) {
	                this.fun = fun;
	                this.array = array;
	              }
	              Item.prototype.run = function () {
	                this.fun.apply(null, this.array);
	              };
	              process.title = 'browser';
	              process.browser = true;
	              process.env = {};
	              process.argv = [];
	              process.version = '';
	              process.versions = {};
	              function noop() {
	              }
	              process.on = noop;
	              process.addListener = noop;
	              process.once = noop;
	              process.off = noop;
	              process.removeListener = noop;
	              process.removeAllListeners = noop;
	              process.emit = noop;
	              process.prependListener = noop;
	              process.prependOnceListener = noop;
	              process.listeners = function (name) {
	                return [];
	              };
	              process.binding = function (name) {
	                throw new Error('process.binding is not supported');
	              };
	              process.cwd = function () {
	                return '/';
	              };
	              process.chdir = function (dir) {
	                throw new Error('process.chdir is not supported');
	              };
	              process.umask = function () {
	                return 0;
	              };
	            },
	            {}
	          ],
	          2: [
	            function (require, module, exports) {
	              (function (setImmediate) {
	                (function (root) {
	                  var setTimeoutFunc = setTimeout;
	                  function noop() {
	                  }
	                  function bind(fn, thisArg) {
	                    return function () {
	                      fn.apply(thisArg, arguments);
	                    };
	                  }
	                  function Promise(fn) {
	                    if (typeof this !== 'object')
	                      throw new TypeError('Promises must be constructed via new');
	                    if (typeof fn !== 'function')
	                      throw new TypeError('not a function');
	                    this._state = 0;
	                    this._handled = false;
	                    this._value = undefined;
	                    this._deferreds = [];
	                    doResolve(fn, this);
	                  }
	                  function handle(self, deferred) {
	                    while (self._state === 3) {
	                      self = self._value;
	                    }
	                    if (self._state === 0) {
	                      self._deferreds.push(deferred);
	                      return;
	                    }
	                    self._handled = true;
	                    Promise._immediateFn(function () {
	                      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                      if (cb === null) {
	                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                        return;
	                      }
	                      var ret;
	                      try {
	                        ret = cb(self._value);
	                      } catch (e) {
	                        reject(deferred.promise, e);
	                        return;
	                      }
	                      resolve(deferred.promise, ret);
	                    });
	                  }
	                  function resolve(self, newValue) {
	                    try {
	                      if (newValue === self)
	                        throw new TypeError('A promise cannot be resolved with itself.');
	                      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                        var then = newValue.then;
	                        if (newValue instanceof Promise) {
	                          self._state = 3;
	                          self._value = newValue;
	                          finale(self);
	                          return;
	                        } else if (typeof then === 'function') {
	                          doResolve(bind(then, newValue), self);
	                          return;
	                        }
	                      }
	                      self._state = 1;
	                      self._value = newValue;
	                      finale(self);
	                    } catch (e) {
	                      reject(self, e);
	                    }
	                  }
	                  function reject(self, newValue) {
	                    self._state = 2;
	                    self._value = newValue;
	                    finale(self);
	                  }
	                  function finale(self) {
	                    if (self._state === 2 && self._deferreds.length === 0) {
	                      Promise._immediateFn(function () {
	                        if (!self._handled) {
	                          Promise._unhandledRejectionFn(self._value);
	                        }
	                      });
	                    }
	                    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                      handle(self, self._deferreds[i]);
	                    }
	                    self._deferreds = null;
	                  }
	                  function Handler(onFulfilled, onRejected, promise) {
	                    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	                    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	                    this.promise = promise;
	                  }
	                  function doResolve(fn, self) {
	                    var done = false;
	                    try {
	                      fn(function (value) {
	                        if (done)
	                          return;
	                        done = true;
	                        resolve(self, value);
	                      }, function (reason) {
	                        if (done)
	                          return;
	                        done = true;
	                        reject(self, reason);
	                      });
	                    } catch (ex) {
	                      if (done)
	                        return;
	                      done = true;
	                      reject(self, ex);
	                    }
	                  }
	                  Promise.prototype['catch'] = function (onRejected) {
	                    return this.then(null, onRejected);
	                  };
	                  Promise.prototype.then = function (onFulfilled, onRejected) {
	                    var prom = new this.constructor(noop);
	                    handle(this, new Handler(onFulfilled, onRejected, prom));
	                    return prom;
	                  };
	                  Promise.all = function (arr) {
	                    var args = Array.prototype.slice.call(arr);
	                    return new Promise(function (resolve, reject) {
	                      if (args.length === 0)
	                        return resolve([]);
	                      var remaining = args.length;
	                      function res(i, val) {
	                        try {
	                          if (val && (typeof val === 'object' || typeof val === 'function')) {
	                            var then = val.then;
	                            if (typeof then === 'function') {
	                              then.call(val, function (val) {
	                                res(i, val);
	                              }, reject);
	                              return;
	                            }
	                          }
	                          args[i] = val;
	                          if (--remaining === 0) {
	                            resolve(args);
	                          }
	                        } catch (ex) {
	                          reject(ex);
	                        }
	                      }
	                      for (var i = 0; i < args.length; i++) {
	                        res(i, args[i]);
	                      }
	                    });
	                  };
	                  Promise.resolve = function (value) {
	                    if (value && typeof value === 'object' && value.constructor === Promise) {
	                      return value;
	                    }
	                    return new Promise(function (resolve) {
	                      resolve(value);
	                    });
	                  };
	                  Promise.reject = function (value) {
	                    return new Promise(function (resolve, reject) {
	                      reject(value);
	                    });
	                  };
	                  Promise.race = function (values) {
	                    return new Promise(function (resolve, reject) {
	                      for (var i = 0, len = values.length; i < len; i++) {
	                        values[i].then(resolve, reject);
	                      }
	                    });
	                  };
	                  Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	                    setImmediate(fn);
	                  } : function (fn) {
	                    setTimeoutFunc(fn, 0);
	                  };
	                  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	                    if (typeof console !== 'undefined' && console) {
	                      console.warn('Possible Unhandled Promise Rejection:', err);
	                    }
	                  };
	                  Promise._setImmediateFn = function _setImmediateFn(fn) {
	                    Promise._immediateFn = fn;
	                  };
	                  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	                    Promise._unhandledRejectionFn = fn;
	                  };
	                  if (typeof module !== 'undefined' && module.exports) {
	                    module.exports = Promise;
	                  } else if (!root.Promise) {
	                    root.Promise = Promise;
	                  }
	                }(this));
	              }.call(this, require('timers').setImmediate));
	            },
	            { 'timers': 3 }
	          ],
	          3: [
	            function (require, module, exports) {
	              (function (setImmediate, clearImmediate) {
	                var nextTick = require('process/browser.js').nextTick;
	                var apply = Function.prototype.apply;
	                var slice = Array.prototype.slice;
	                var immediateIds = {};
	                var nextImmediateId = 0;
	                exports.setTimeout = function () {
	                  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	                };
	                exports.setInterval = function () {
	                  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	                };
	                exports.clearTimeout = exports.clearInterval = function (timeout) {
	                  timeout.close();
	                };
	                function Timeout(id, clearFn) {
	                  this._id = id;
	                  this._clearFn = clearFn;
	                }
	                Timeout.prototype.unref = Timeout.prototype.ref = function () {
	                };
	                Timeout.prototype.close = function () {
	                  this._clearFn.call(window, this._id);
	                };
	                exports.enroll = function (item, msecs) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = msecs;
	                };
	                exports.unenroll = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = -1;
	                };
	                exports._unrefActive = exports.active = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  var msecs = item._idleTimeout;
	                  if (msecs >= 0) {
	                    item._idleTimeoutId = setTimeout(function onTimeout() {
	                      if (item._onTimeout)
	                        item._onTimeout();
	                    }, msecs);
	                  }
	                };
	                exports.setImmediate = typeof setImmediate === 'function' ? setImmediate : function (fn) {
	                  var id = nextImmediateId++;
	                  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	                  immediateIds[id] = true;
	                  nextTick(function onNextTick() {
	                    if (immediateIds[id]) {
	                      if (args) {
	                        fn.apply(null, args);
	                      } else {
	                        fn.call(null);
	                      }
	                      exports.clearImmediate(id);
	                    }
	                  });
	                  return id;
	                };
	                exports.clearImmediate = typeof clearImmediate === 'function' ? clearImmediate : function (id) {
	                  delete immediateIds[id];
	                };
	              }.call(this, require('timers').setImmediate, require('timers').clearImmediate));
	            },
	            {
	              'process/browser.js': 1,
	              'timers': 3
	            }
	          ],
	          4: [
	            function (require, module, exports) {
	              var promisePolyfill = require('promise-polyfill');
	              var Global = function () {
	                if (typeof window !== 'undefined') {
	                  return window;
	                } else {
	                  return Function('return this;')();
	                }
	              }();
	              module.exports = { boltExport: Global.Promise || promisePolyfill };
	            },
	            { 'promise-polyfill': 2 }
	          ]
	        }, {}, [4])(4);
	      }));
	    }(undefined, exports$1, module, undefined));
	    var Promise = module.exports.boltExport;
	
	    var nu$a = function (baseFn) {
	      var data = Optional.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu$a(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        if (!isReady()) {
	          data = Optional.some(x);
	          run(callbacks);
	          callbacks = [];
	        }
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure = function (a) {
	      return nu$a(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu$a,
	      pure: pure
	    };
	
	    var errorReporter = function (err) {
	      setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make$3 = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make$3(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make$3(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make$3(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make$3(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$b = function (baseFn) {
	      return make$3(function () {
	        return new Promise(baseFn);
	      });
	    };
	    var pure$1 = function (a) {
	      return make$3(function () {
	        return Promise.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$b,
	      pure: pure$1
	    };
	
	    var ariaElements = [
	      'input',
	      'textarea'
	    ];
	    var isAriaElement = function (elem) {
	      var name$1 = name(elem);
	      return contains(ariaElements, name$1);
	    };
	    var markValid = function (component, invalidConfig) {
	      var elem = invalidConfig.getRoot(component).getOr(component.element);
	      remove$4(elem, invalidConfig.invalidClass);
	      invalidConfig.notify.each(function (notifyInfo) {
	        if (isAriaElement(component.element)) {
	          set$1(component.element, 'aria-invalid', false);
	        }
	        notifyInfo.getContainer(component).each(function (container) {
	          set(container, notifyInfo.validHtml);
	        });
	        notifyInfo.onValid(component);
	      });
	    };
	    var markInvalid = function (component, invalidConfig, invalidState, text) {
	      var elem = invalidConfig.getRoot(component).getOr(component.element);
	      add$2(elem, invalidConfig.invalidClass);
	      invalidConfig.notify.each(function (notifyInfo) {
	        if (isAriaElement(component.element)) {
	          set$1(component.element, 'aria-invalid', true);
	        }
	        notifyInfo.getContainer(component).each(function (container) {
	          set(container, text);
	        });
	        notifyInfo.onInvalid(component, text);
	      });
	    };
	    var query = function (component, invalidConfig, _invalidState) {
	      return invalidConfig.validator.fold(function () {
	        return Future.pure(Result.value(true));
	      }, function (validatorInfo) {
	        return validatorInfo.validate(component);
	      });
	    };
	    var run$1 = function (component, invalidConfig, invalidState) {
	      invalidConfig.notify.each(function (notifyInfo) {
	        notifyInfo.onValidate(component);
	      });
	      return query(component, invalidConfig).map(function (valid) {
	        if (component.getSystem().isConnected()) {
	          return valid.fold(function (err) {
	            markInvalid(component, invalidConfig, invalidState, err);
	            return Result.error(err);
	          }, function (v) {
	            markValid(component, invalidConfig);
	            return Result.value(v);
	          });
	        } else {
	          return Result.error('No longer in system');
	        }
	      });
	    };
	    var isInvalid = function (component, invalidConfig) {
	      var elem = invalidConfig.getRoot(component).getOr(component.element);
	      return has$2(elem, invalidConfig.invalidClass);
	    };
	
	    var InvalidateApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        markValid: markValid,
	        markInvalid: markInvalid,
	        query: query,
	        run: run$1,
	        isInvalid: isInvalid
	    });
	
	    var events$a = function (invalidConfig, invalidState) {
	      return invalidConfig.validator.map(function (validatorInfo) {
	        return derive([run(validatorInfo.onEvent, function (component) {
	            run$1(component, invalidConfig, invalidState).get(identity);
	          })].concat(validatorInfo.validateOnLoad ? [runOnAttached(function (component) {
	            run$1(component, invalidConfig, invalidState).get(noop);
	          })] : []));
	      }).getOr({});
	    };
	
	    var ActiveInvalidate = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$a
	    });
	
	    var InvalidateSchema = [
	      strict$1('invalidClass'),
	      defaulted$1('getRoot', Optional.none),
	      optionObjOf('notify', [
	        defaulted$1('aria', 'alert'),
	        defaulted$1('getContainer', Optional.none),
	        defaulted$1('validHtml', ''),
	        onHandler('onValid'),
	        onHandler('onInvalid'),
	        onHandler('onValidate')
	      ]),
	      optionObjOf('validator', [
	        strict$1('validate'),
	        defaulted$1('onEvent', 'input'),
	        defaulted$1('validateOnLoad', true)
	      ])
	    ];
	
	    var Invalidating = create$1({
	      fields: InvalidateSchema,
	      name: 'invalidating',
	      active: ActiveInvalidate,
	      apis: InvalidateApis,
	      extra: {
	        validation: function (validator) {
	          return function (component) {
	            var v = Representing.getValue(component);
	            return Future.pure(validator(v));
	          };
	        }
	      }
	    });
	
	    var getCoupled = function (component, coupleConfig, coupleState, name) {
	      return coupleState.getOrCreate(component, coupleConfig, name);
	    };
	
	    var CouplingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getCoupled: getCoupled
	    });
	
	    var CouplingSchema = [strictOf('others', setOf$1(Result.value, anyValue$1()))];
	
	    var init$5 = function () {
	      var coupled = {};
	      var getOrCreate = function (component, coupleConfig, name) {
	        var available = keys(coupleConfig.others);
	        if (!available) {
	          throw new Error('Cannot find coupled component: ' + name + '. Known coupled components: ' + JSON.stringify(available, null, 2));
	        } else {
	          return get$1(coupled, name).getOrThunk(function () {
	            var builder = get$1(coupleConfig.others, name).getOrDie('No information found for coupled component: ' + name);
	            var spec = builder(component);
	            var built = component.getSystem().build(spec);
	            coupled[name] = built;
	            return built;
	          });
	        }
	      };
	      var readState = constant({});
	      return nu$5({
	        readState: readState,
	        getOrCreate: getOrCreate
	      });
	    };
	
	    var CouplingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$5
	    });
	
	    var Coupling = create$1({
	      fields: CouplingSchema,
	      name: 'coupling',
	      apis: CouplingApis,
	      state: CouplingState
	    });
	
	    var suffix = constant('sink');
	    var partType = constant(optional({
	      name: suffix(),
	      overrides: constant({
	        dom: { tag: 'div' },
	        behaviours: derive$1([Positioning.config({ useFixed: always })]),
	        events: derive([
	          cutter(keydown()),
	          cutter(mousedown()),
	          cutter(click())
	        ])
	      })
	    }));
	
	    var HighlightOnOpen;
	    (function (HighlightOnOpen) {
	      HighlightOnOpen[HighlightOnOpen['HighlightFirst'] = 0] = 'HighlightFirst';
	      HighlightOnOpen[HighlightOnOpen['HighlightNone'] = 1] = 'HighlightNone';
	    }(HighlightOnOpen || (HighlightOnOpen = {})));
	    var getAnchor = function (detail, component) {
	      var hotspot = detail.getHotspot(component).getOr(component);
	      var anchor = 'hotspot';
	      var overrides = detail.getAnchorOverrides();
	      return detail.layouts.fold(function () {
	        return {
	          anchor: anchor,
	          hotspot: hotspot,
	          overrides: overrides
	        };
	      }, function (layouts) {
	        return {
	          anchor: anchor,
	          hotspot: hotspot,
	          overrides: overrides,
	          layouts: layouts
	        };
	      });
	    };
	    var fetch = function (detail, mapFetch, component) {
	      var fetcher = detail.fetch;
	      return fetcher(component).map(mapFetch);
	    };
	    var openF = function (detail, mapFetch, anchor, component, sandbox, externals, highlightOnOpen) {
	      var futureData = fetch(detail, mapFetch, component);
	      var getLazySink = getSink(component, detail);
	      return futureData.map(function (tdata) {
	        return tdata.bind(function (data) {
	          return Optional.from(tieredMenu.sketch(__assign(__assign({}, externals.menu()), {
	            uid: generate$2(''),
	            data: data,
	            highlightImmediately: highlightOnOpen === HighlightOnOpen.HighlightFirst,
	            onOpenMenu: function (tmenu, menu) {
	              var sink = getLazySink().getOrDie();
	              Positioning.position(sink, anchor, menu);
	              Sandboxing.decloak(sandbox);
	            },
	            onOpenSubmenu: function (tmenu, item, submenu) {
	              var sink = getLazySink().getOrDie();
	              Positioning.position(sink, {
	                anchor: 'submenu',
	                item: item
	              }, submenu);
	              Sandboxing.decloak(sandbox);
	            },
	            onRepositionMenu: function (tmenu, primaryMenu, submenuTriggers) {
	              var sink = getLazySink().getOrDie();
	              Positioning.position(sink, anchor, primaryMenu);
	              each(submenuTriggers, function (st) {
	                Positioning.position(sink, {
	                  anchor: 'submenu',
	                  item: st.triggeringItem
	                }, st.triggeredMenu);
	              });
	            },
	            onEscape: function () {
	              Focusing.focus(component);
	              Sandboxing.close(sandbox);
	              return Optional.some(true);
	            }
	          })));
	        });
	      });
	    };
	    var open$1 = function (detail, mapFetch, hotspot, sandbox, externals, onOpenSync, highlightOnOpen) {
	      var anchor = getAnchor(detail, hotspot);
	      var processed = openF(detail, mapFetch, anchor, hotspot, sandbox, externals, highlightOnOpen);
	      return processed.map(function (tdata) {
	        tdata.fold(function () {
	          if (Sandboxing.isOpen(sandbox)) {
	            Sandboxing.close(sandbox);
	          }
	        }, function (data) {
	          Sandboxing.cloak(sandbox);
	          Sandboxing.open(sandbox, data);
	          onOpenSync(sandbox);
	        });
	        return sandbox;
	      });
	    };
	    var close$1 = function (detail, mapFetch, component, sandbox, _externals, _onOpenSync, _highlightOnOpen) {
	      Sandboxing.close(sandbox);
	      return Future.pure(sandbox);
	    };
	    var togglePopup = function (detail, mapFetch, hotspot, externals, onOpenSync, highlightOnOpen) {
	      var sandbox = Coupling.getCoupled(hotspot, 'sandbox');
	      var showing = Sandboxing.isOpen(sandbox);
	      var action = showing ? close$1 : open$1;
	      return action(detail, mapFetch, hotspot, sandbox, externals, onOpenSync, highlightOnOpen);
	    };
	    var matchWidth = function (hotspot, container, useMinWidth) {
	      var menu = Composing.getCurrent(container).getOr(container);
	      var buttonWidth = get$8(hotspot.element);
	      if (useMinWidth) {
	        set$2(menu.element, 'min-width', buttonWidth + 'px');
	      } else {
	        set$4(menu.element, buttonWidth);
	      }
	    };
	    var getSink = function (anyInSystem, sinkDetail) {
	      return anyInSystem.getSystem().getByUid(sinkDetail.uid + '-' + suffix()).map(function (internalSink) {
	        return function () {
	          return Result.value(internalSink);
	        };
	      }).getOrThunk(function () {
	        return sinkDetail.lazySink.fold(function () {
	          return function () {
	            return Result.error(new Error('No internal sink is specified, nor could an external sink be found'));
	          };
	        }, function (lazySinkFn) {
	          return function () {
	            return lazySinkFn(anyInSystem);
	          };
	        });
	      });
	    };
	    var doRepositionMenus = function (sandbox) {
	      Sandboxing.getState(sandbox).each(function (tmenu) {
	        tieredMenu.repositionMenus(tmenu);
	      });
	    };
	    var makeSandbox = function (detail, hotspot, extras) {
	      var ariaOwner = manager();
	      var onOpen = function (component, menu) {
	        var anchor = getAnchor(detail, hotspot);
	        ariaOwner.link(hotspot.element);
	        if (detail.matchWidth) {
	          matchWidth(anchor.hotspot, menu, detail.useMinWidth);
	        }
	        detail.onOpen(anchor, component, menu);
	        if (extras !== undefined && extras.onOpen !== undefined) {
	          extras.onOpen(component, menu);
	        }
	      };
	      var onClose = function (component, menu) {
	        ariaOwner.unlink(hotspot.element);
	        if (extras !== undefined && extras.onClose !== undefined) {
	          extras.onClose(component, menu);
	        }
	      };
	      var lazySink = getSink(hotspot, detail);
	      return {
	        dom: {
	          tag: 'div',
	          classes: detail.sandboxClasses,
	          attributes: {
	            id: ariaOwner.id,
	            role: 'listbox'
	          }
	        },
	        behaviours: SketchBehaviours.augment(detail.sandboxBehaviours, [
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: hotspot
	            }
	          }),
	          Sandboxing.config({
	            onOpen: onOpen,
	            onClose: onClose,
	            isPartOf: function (container, data, queryElem) {
	              return isPartOf(data, queryElem) || isPartOf(hotspot, queryElem);
	            },
	            getAttachPoint: function () {
	              return lazySink().getOrDie();
	            }
	          }),
	          Composing.config({
	            find: function (sandbox) {
	              return Sandboxing.getState(sandbox).bind(function (menu) {
	                return Composing.getCurrent(menu);
	              });
	            }
	          }),
	          Receiving.config({ channels: __assign(__assign({}, receivingChannel({ isExtraPart: never })), receivingChannel$1({ doReposition: doRepositionMenus })) })
	        ])
	      };
	    };
	    var repositionMenus = function (comp) {
	      var sandbox = Coupling.getCoupled(comp, 'sandbox');
	      doRepositionMenus(sandbox);
	    };
	
	    var sandboxFields = function () {
	      return [
	        defaulted$1('sandboxClasses', []),
	        SketchBehaviours.field('sandboxBehaviours', [
	          Composing,
	          Receiving,
	          Sandboxing,
	          Representing
	        ])
	      ];
	    };
	
	    var schema$g = constant([
	      strict$1('dom'),
	      strict$1('fetch'),
	      onHandler('onOpen'),
	      onKeyboardHandler('onExecute'),
	      defaulted$1('getHotspot', Optional.some),
	      defaulted$1('getAnchorOverrides', constant({})),
	      schema$1(),
	      field$1('dropdownBehaviours', [
	        Toggling,
	        Coupling,
	        Keying,
	        Focusing
	      ]),
	      strict$1('toggleClass'),
	      defaulted$1('eventOrder', {}),
	      option('lazySink'),
	      defaulted$1('matchWidth', false),
	      defaulted$1('useMinWidth', false),
	      option('role')
	    ].concat(sandboxFields()));
	    var parts$4 = constant([
	      external$1({
	        schema: [tieredMenuMarkers()],
	        name: 'menu',
	        defaults: function (detail) {
	          return { onExecute: detail.onExecute };
	        }
	      }),
	      partType()
	    ]);
	
	    var factory$6 = function (detail, components, _spec, externals) {
	      var _a;
	      var lookupAttr = function (attr) {
	        return get$1(detail.dom, 'attributes').bind(function (attrs) {
	          return get$1(attrs, attr);
	        });
	      };
	      var switchToMenu = function (sandbox) {
	        Sandboxing.getState(sandbox).each(function (tmenu) {
	          tieredMenu.highlightPrimary(tmenu);
	        });
	      };
	      var action = function (component) {
	        var onOpenSync = switchToMenu;
	        togglePopup(detail, function (x) {
	          return x;
	        }, component, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	      };
	      var apis = {
	        expand: function (comp) {
	          if (!Toggling.isOn(comp)) {
	            togglePopup(detail, function (x) {
	              return x;
	            }, comp, externals, noop, HighlightOnOpen.HighlightNone).get(noop);
	          }
	        },
	        open: function (comp) {
	          if (!Toggling.isOn(comp)) {
	            togglePopup(detail, function (x) {
	              return x;
	            }, comp, externals, noop, HighlightOnOpen.HighlightFirst).get(noop);
	          }
	        },
	        isOpen: Toggling.isOn,
	        close: function (comp) {
	          if (Toggling.isOn(comp)) {
	            togglePopup(detail, function (x) {
	              return x;
	            }, comp, externals, noop, HighlightOnOpen.HighlightFirst).get(noop);
	          }
	        },
	        repositionMenus: function (comp) {
	          if (Toggling.isOn(comp)) {
	            repositionMenus(comp);
	          }
	        }
	      };
	      var triggerExecute = function (comp, _se) {
	        emitExecute(comp);
	        return Optional.some(true);
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.dropdownBehaviours, [
	          Toggling.config({
	            toggleClass: detail.toggleClass,
	            aria: { mode: 'expanded' }
	          }),
	          Coupling.config({
	            others: {
	              sandbox: function (hotspot) {
	                return makeSandbox(detail, hotspot, {
	                  onOpen: function () {
	                    return Toggling.on(hotspot);
	                  },
	                  onClose: function () {
	                    return Toggling.off(hotspot);
	                  }
	                });
	              }
	            }
	          }),
	          Keying.config({
	            mode: 'special',
	            onSpace: triggerExecute,
	            onEnter: triggerExecute,
	            onDown: function (comp, _se) {
	              if (Dropdown.isOpen(comp)) {
	                var sandbox = Coupling.getCoupled(comp, 'sandbox');
	                switchToMenu(sandbox);
	              } else {
	                Dropdown.open(comp);
	              }
	              return Optional.some(true);
	            },
	            onEscape: function (comp, _se) {
	              if (Dropdown.isOpen(comp)) {
	                Dropdown.close(comp);
	                return Optional.some(true);
	              } else {
	                return Optional.none();
	              }
	            }
	          }),
	          Focusing.config({})
	        ]),
	        events: events$7(Optional.some(action)),
	        eventOrder: __assign(__assign({}, detail.eventOrder), (_a = {}, _a[execute()] = [
	          'disabling',
	          'toggling',
	          'alloy.base.behaviour'
	        ], _a)),
	        apis: apis,
	        domModification: {
	          attributes: __assign(__assign({ 'aria-haspopup': 'true' }, detail.role.fold(function () {
	            return {};
	          }, function (role) {
	            return { role: role };
	          })), detail.dom.tag === 'button' ? { type: lookupAttr('type').getOr('button') } : {})
	        }
	      };
	    };
	    var Dropdown = composite$1({
	      name: 'Dropdown',
	      configFields: schema$g(),
	      partFields: parts$4(),
	      factory: factory$6,
	      apis: {
	        open: function (apis, comp) {
	          return apis.open(comp);
	        },
	        expand: function (apis, comp) {
	          return apis.expand(comp);
	        },
	        close: function (apis, comp) {
	          return apis.close(comp);
	        },
	        isOpen: function (apis, comp) {
	          return apis.isOpen(comp);
	        },
	        repositionMenus: function (apis, comp) {
	          return apis.repositionMenus(comp);
	        }
	      }
	    });
	
	    var exhibit$5 = function () {
	      return nu$6({
	        styles: {
	          '-webkit-user-select': 'none',
	          'user-select': 'none',
	          '-ms-user-select': 'none',
	          '-moz-user-select': '-moz-none'
	        },
	        attributes: { unselectable: 'on' }
	      });
	    };
	    var events$b = function () {
	      return derive([abort(selectstart(), always)]);
	    };
	
	    var ActiveUnselecting = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$b,
	        exhibit: exhibit$5
	    });
	
	    var Unselecting = create$1({
	      fields: [],
	      name: 'unselecting',
	      active: ActiveUnselecting
	    });
	
	    var renderPanelButton = function (spec, sharedBackstage) {
	      return Dropdown.sketch({
	        dom: spec.dom,
	        components: spec.components,
	        toggleClass: 'mce-active',
	        dropdownBehaviours: derive$1([
	          DisablingConfigs.button(sharedBackstage.providers.isDisabled),
	          receivingConfig(),
	          Unselecting.config({}),
	          Tabstopping.config({})
	        ]),
	        layouts: spec.layouts,
	        sandboxClasses: ['tox-dialog__popups'],
	        lazySink: sharedBackstage.getSink,
	        fetch: function (comp) {
	          return Future.nu(function (callback) {
	            return spec.fetch(callback);
	          }).map(function (items) {
	            return Optional.from(createTieredDataFrom(deepMerge(createPartialChoiceMenu(generate$1('menu-value'), items, function (value) {
	              spec.onItemAction(comp, value);
	            }, spec.columns, spec.presets, ItemResponse$1.CLOSE_ON_EXECUTE, never, sharedBackstage.providers), { movement: deriveMenuMovement(spec.columns, spec.presets) })));
	          });
	        },
	        parts: { menu: part(false, 1, spec.presets) }
	      });
	    };
	
	    var colorInputChangeEvent = generate$1('color-input-change');
	    var colorSwatchChangeEvent = generate$1('color-swatch-change');
	    var colorPickerCancelEvent = generate$1('color-picker-cancel');
	    var renderColorInput = function (spec, sharedBackstage, colorInputBackstage) {
	      var pField = FormField.parts.field({
	        factory: Input,
	        inputClasses: ['tox-textfield'],
	        onSetValue: function (c) {
	          return Invalidating.run(c).get(noop);
	        },
	        inputBehaviours: derive$1([
	          Disabling.config({ disabled: sharedBackstage.providers.isDisabled }),
	          receivingConfig(),
	          Tabstopping.config({}),
	          Invalidating.config({
	            invalidClass: 'tox-textbox-field-invalid',
	            getRoot: function (comp) {
	              return parent(comp.element);
	            },
	            notify: {
	              onValid: function (comp) {
	                var val = Representing.getValue(comp);
	                emitWith(comp, colorInputChangeEvent, { color: val });
	              }
	            },
	            validator: {
	              validateOnLoad: false,
	              validate: function (input) {
	                var inputValue = Representing.getValue(input);
	                if (inputValue.length === 0) {
	                  return Future.pure(Result.value(true));
	                } else {
	                  var span = SugarElement.fromTag('span');
	                  set$2(span, 'background-color', inputValue);
	                  var res = getRaw(span, 'background-color').fold(function () {
	                    return Result.error('blah');
	                  }, function (_) {
	                    return Result.value(inputValue);
	                  });
	                  return Future.pure(res);
	                }
	              }
	            }
	          })
	        ]),
	        selectOnFocus: false
	      });
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, sharedBackstage.providers);
	      });
	      var emitSwatchChange = function (colorBit, value) {
	        emitWith(colorBit, colorSwatchChangeEvent, { value: value });
	      };
	      var onItemAction = function (comp, value) {
	        memColorButton.getOpt(comp).each(function (colorBit) {
	          if (value === 'custom') {
	            colorInputBackstage.colorPicker(function (valueOpt) {
	              valueOpt.fold(function () {
	                return emit(colorBit, colorPickerCancelEvent);
	              }, function (value) {
	                emitSwatchChange(colorBit, value);
	                addColor(value);
	              });
	            }, '#ffffff');
	          } else if (value === 'remove') {
	            emitSwatchChange(colorBit, '');
	          } else {
	            emitSwatchChange(colorBit, value);
	          }
	        });
	      };
	      var memColorButton = record(renderPanelButton({
	        dom: {
	          tag: 'span',
	          attributes: { 'aria-label': sharedBackstage.providers.translate('Color swatch') }
	        },
	        layouts: {
	          onRtl: function () {
	            return [
	              southwest$1,
	              southeast$1,
	              south$1
	            ];
	          },
	          onLtr: function () {
	            return [
	              southeast$1,
	              southwest$1,
	              south$1
	            ];
	          }
	        },
	        components: [],
	        fetch: getFetch(colorInputBackstage.getColors(), colorInputBackstage.hasCustomColors()),
	        columns: colorInputBackstage.getColorCols(),
	        presets: 'color',
	        onItemAction: onItemAction
	      }, sharedBackstage));
	      return FormField.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: pLabel.toArray().concat([{
	            dom: {
	              tag: 'div',
	              classes: ['tox-color-input']
	            },
	            components: [
	              pField,
	              memColorButton.asSpec()
	            ]
	          }]),
	        fieldBehaviours: derive$1([config('form-field-events', [
	            run(colorInputChangeEvent, function (comp, se) {
	              memColorButton.getOpt(comp).each(function (colorButton) {
	                set$2(colorButton.element, 'background-color', se.event.color);
	              });
	              emitWith(comp, formChangeEvent, { name: spec.name });
	            }),
	            run(colorSwatchChangeEvent, function (comp, se) {
	              FormField.getField(comp).each(function (field) {
	                Representing.setValue(field, se.event.value);
	                Composing.getCurrent(comp).each(Focusing.focus);
	              });
	            }),
	            run(colorPickerCancelEvent, function (comp, _se) {
	              FormField.getField(comp).each(function (_field) {
	                Composing.getCurrent(comp).each(Focusing.focus);
	              });
	            })
	          ])])
	      });
	    };
	
	    var labelPart = optional({
	      schema: [strict$1('dom')],
	      name: 'label'
	    });
	    var edgePart = function (name) {
	      return optional({
	        name: '' + name + '-edge',
	        overrides: function (detail) {
	          var action = detail.model.manager.edgeActions[name];
	          return action.fold(function () {
	            return {};
	          }, function (a) {
	            return {
	              events: derive([
	                runActionExtra(touchstart(), function (comp, se, d) {
	                  return a(comp, d);
	                }, [detail]),
	                runActionExtra(mousedown(), function (comp, se, d) {
	                  return a(comp, d);
	                }, [detail]),
	                runActionExtra(mousemove(), function (comp, se, det) {
	                  if (det.mouseIsDown.get()) {
	                    a(comp, det);
	                  }
	                }, [detail])
	              ])
	            };
	          });
	        }
	      });
	    };
	    var tlEdgePart = edgePart('top-left');
	    var tedgePart = edgePart('top');
	    var trEdgePart = edgePart('top-right');
	    var redgePart = edgePart('right');
	    var brEdgePart = edgePart('bottom-right');
	    var bedgePart = edgePart('bottom');
	    var blEdgePart = edgePart('bottom-left');
	    var ledgePart = edgePart('left');
	    var thumbPart = required({
	      name: 'thumb',
	      defaults: constant({ dom: { styles: { position: 'absolute' } } }),
	      overrides: function (detail) {
	        return {
	          events: derive([
	            redirectToPart(touchstart(), detail, 'spectrum'),
	            redirectToPart(touchmove(), detail, 'spectrum'),
	            redirectToPart(touchend(), detail, 'spectrum'),
	            redirectToPart(mousedown(), detail, 'spectrum'),
	            redirectToPart(mousemove(), detail, 'spectrum'),
	            redirectToPart(mouseup(), detail, 'spectrum')
	          ])
	        };
	      }
	    });
	    var spectrumPart = required({
	      schema: [state$1('mouseIsDown', function () {
	          return Cell(false);
	        })],
	      name: 'spectrum',
	      overrides: function (detail) {
	        var modelDetail = detail.model;
	        var model = modelDetail.manager;
	        var setValueFrom = function (component, simulatedEvent) {
	          return model.getValueFromEvent(simulatedEvent).map(function (value) {
	            return model.setValueFrom(component, detail, value);
	          });
	        };
	        return {
	          behaviours: derive$1([
	            Keying.config({
	              mode: 'special',
	              onLeft: function (spectrum) {
	                return model.onLeft(spectrum, detail);
	              },
	              onRight: function (spectrum) {
	                return model.onRight(spectrum, detail);
	              },
	              onUp: function (spectrum) {
	                return model.onUp(spectrum, detail);
	              },
	              onDown: function (spectrum) {
	                return model.onDown(spectrum, detail);
	              }
	            }),
	            Focusing.config({})
	          ]),
	          events: derive([
	            run(touchstart(), setValueFrom),
	            run(touchmove(), setValueFrom),
	            run(mousedown(), setValueFrom),
	            run(mousemove(), function (spectrum, se) {
	              if (detail.mouseIsDown.get()) {
	                setValueFrom(spectrum, se);
	              }
	            })
	          ])
	        };
	      }
	    });
	    var SliderParts = [
	      labelPart,
	      ledgePart,
	      redgePart,
	      tedgePart,
	      bedgePart,
	      tlEdgePart,
	      trEdgePart,
	      blEdgePart,
	      brEdgePart,
	      thumbPart,
	      spectrumPart
	    ];
	
	    var _sliderChangeEvent = 'slider.change.value';
	    var sliderChangeEvent = constant(_sliderChangeEvent);
	    var isTouchEvent = function (evt) {
	      return evt.type.indexOf('touch') !== -1;
	    };
	    var getEventSource = function (simulatedEvent) {
	      var evt = simulatedEvent.event.raw;
	      if (isTouchEvent(evt)) {
	        var touchEvent = evt;
	        return touchEvent.touches !== undefined && touchEvent.touches.length === 1 ? Optional.some(touchEvent.touches[0]).map(function (t) {
	          return SugarPosition(t.clientX, t.clientY);
	        }) : Optional.none();
	      } else {
	        var mouseEvent = evt;
	        return mouseEvent.clientX !== undefined ? Optional.some(mouseEvent).map(function (me) {
	          return SugarPosition(me.clientX, me.clientY);
	        }) : Optional.none();
	      }
	    };
	
	    var t = 'top', r$1 = 'right', b = 'bottom', l = 'left';
	    var minX = function (detail) {
	      return detail.model.minX;
	    };
	    var minY = function (detail) {
	      return detail.model.minY;
	    };
	    var min1X = function (detail) {
	      return detail.model.minX - 1;
	    };
	    var min1Y = function (detail) {
	      return detail.model.minY - 1;
	    };
	    var maxX = function (detail) {
	      return detail.model.maxX;
	    };
	    var maxY = function (detail) {
	      return detail.model.maxY;
	    };
	    var max1X = function (detail) {
	      return detail.model.maxX + 1;
	    };
	    var max1Y = function (detail) {
	      return detail.model.maxY + 1;
	    };
	    var range$2 = function (detail, max, min) {
	      return max(detail) - min(detail);
	    };
	    var xRange = function (detail) {
	      return range$2(detail, maxX, minX);
	    };
	    var yRange = function (detail) {
	      return range$2(detail, maxY, minY);
	    };
	    var halfX = function (detail) {
	      return xRange(detail) / 2;
	    };
	    var halfY = function (detail) {
	      return yRange(detail) / 2;
	    };
	    var step = function (detail) {
	      return detail.stepSize;
	    };
	    var snap = function (detail) {
	      return detail.snapToGrid;
	    };
	    var snapStart = function (detail) {
	      return detail.snapStart;
	    };
	    var rounded = function (detail) {
	      return detail.rounded;
	    };
	    var hasEdge = function (detail, edgeName) {
	      return detail[edgeName + '-edge'] !== undefined;
	    };
	    var hasLEdge = function (detail) {
	      return hasEdge(detail, l);
	    };
	    var hasREdge = function (detail) {
	      return hasEdge(detail, r$1);
	    };
	    var hasTEdge = function (detail) {
	      return hasEdge(detail, t);
	    };
	    var hasBEdge = function (detail) {
	      return hasEdge(detail, b);
	    };
	    var currentValue = function (detail) {
	      return detail.model.value.get();
	    };
	
	    var xValue = function (x) {
	      return { x: x };
	    };
	    var yValue = function (y) {
	      return { y: y };
	    };
	    var xyValue = function (x, y) {
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var fireSliderChange = function (component, value) {
	      emitWith(component, sliderChangeEvent(), { value: value });
	    };
	    var setToTLEdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(min1X(detail), min1Y(detail)));
	    };
	    var setToTEdge = function (edge, detail) {
	      fireSliderChange(edge, yValue(min1Y(detail)));
	    };
	    var setToTEdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(halfX(detail), min1Y(detail)));
	    };
	    var setToTREdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(max1X(detail), min1Y(detail)));
	    };
	    var setToREdge = function (edge, detail) {
	      fireSliderChange(edge, xValue(max1X(detail)));
	    };
	    var setToREdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(max1X(detail), halfY(detail)));
	    };
	    var setToBREdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(max1X(detail), max1Y(detail)));
	    };
	    var setToBEdge = function (edge, detail) {
	      fireSliderChange(edge, yValue(max1Y(detail)));
	    };
	    var setToBEdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(halfX(detail), max1Y(detail)));
	    };
	    var setToBLEdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(min1X(detail), max1Y(detail)));
	    };
	    var setToLEdge = function (edge, detail) {
	      fireSliderChange(edge, xValue(min1X(detail)));
	    };
	    var setToLEdgeXY = function (edge, detail) {
	      fireSliderChange(edge, xyValue(min1X(detail), halfY(detail)));
	    };
	
	    var reduceBy = function (value, min, max, step) {
	      if (value < min) {
	        return value;
	      } else if (value > max) {
	        return max;
	      } else if (value === min) {
	        return min - 1;
	      } else {
	        return Math.max(min, value - step);
	      }
	    };
	    var increaseBy = function (value, min, max, step) {
	      if (value > max) {
	        return value;
	      } else if (value < min) {
	        return min;
	      } else if (value === max) {
	        return max + 1;
	      } else {
	        return Math.min(max, value + step);
	      }
	    };
	    var capValue = function (value, min, max) {
	      return Math.max(min, Math.min(max, value));
	    };
	    var snapValueOf = function (value, min, max, step, snapStart) {
	      return snapStart.fold(function () {
	        var initValue = value - min;
	        var extraValue = Math.round(initValue / step) * step;
	        return capValue(min + extraValue, min - 1, max + 1);
	      }, function (start) {
	        var remainder = (value - start) % step;
	        var adjustment = Math.round(remainder / step);
	        var rawSteps = Math.floor((value - start) / step);
	        var maxSteps = Math.floor((max - start) / step);
	        var numSteps = Math.min(maxSteps, rawSteps + adjustment);
	        var r = start + numSteps * step;
	        return Math.max(start, r);
	      });
	    };
	    var findOffsetOf = function (value, min, max) {
	      return Math.min(max, Math.max(value, min)) - min;
	    };
	    var findValueOf = function (args) {
	      var min = args.min, max = args.max, range = args.range, value = args.value, step = args.step, snap = args.snap, snapStart = args.snapStart, rounded = args.rounded, hasMinEdge = args.hasMinEdge, hasMaxEdge = args.hasMaxEdge, minBound = args.minBound, maxBound = args.maxBound, screenRange = args.screenRange;
	      var capMin = hasMinEdge ? min - 1 : min;
	      var capMax = hasMaxEdge ? max + 1 : max;
	      if (value < minBound) {
	        return capMin;
	      } else if (value > maxBound) {
	        return capMax;
	      } else {
	        var offset = findOffsetOf(value, minBound, maxBound);
	        var newValue = capValue(offset / screenRange * range + min, capMin, capMax);
	        if (snap && newValue >= min && newValue <= max) {
	          return snapValueOf(newValue, min, max, step, snapStart);
	        } else if (rounded) {
	          return Math.round(newValue);
	        } else {
	          return newValue;
	        }
	      }
	    };
	    var findOffsetOfValue = function (args) {
	      var min = args.min, max = args.max, range = args.range, value = args.value, hasMinEdge = args.hasMinEdge, hasMaxEdge = args.hasMaxEdge, maxBound = args.maxBound, maxOffset = args.maxOffset, centerMinEdge = args.centerMinEdge, centerMaxEdge = args.centerMaxEdge;
	      if (value < min) {
	        return hasMinEdge ? 0 : centerMinEdge;
	      } else if (value > max) {
	        return hasMaxEdge ? maxBound : centerMaxEdge;
	      } else {
	        return (value - min) / range * maxOffset;
	      }
	    };
	
	    var top = 'top', right = 'right', bottom = 'bottom', left = 'left', width = 'width', height = 'height';
	    var getBounds$1 = function (component) {
	      return component.element.dom.getBoundingClientRect();
	    };
	    var getBoundsProperty = function (bounds, property) {
	      return bounds[property];
	    };
	    var getMinXBounds = function (component) {
	      var bounds = getBounds$1(component);
	      return getBoundsProperty(bounds, left);
	    };
	    var getMaxXBounds = function (component) {
	      var bounds = getBounds$1(component);
	      return getBoundsProperty(bounds, right);
	    };
	    var getMinYBounds = function (component) {
	      var bounds = getBounds$1(component);
	      return getBoundsProperty(bounds, top);
	    };
	    var getMaxYBounds = function (component) {
	      var bounds = getBounds$1(component);
	      return getBoundsProperty(bounds, bottom);
	    };
	    var getXScreenRange = function (component) {
	      var bounds = getBounds$1(component);
	      return getBoundsProperty(bounds, width);
	    };
	    var getYScreenRange = function (component) {
	      var bounds = getBounds$1(component);
	      return getBoundsProperty(bounds, height);
	    };
	    var getCenterOffsetOf = function (componentMinEdge, componentMaxEdge, spectrumMinEdge) {
	      return (componentMinEdge + componentMaxEdge) / 2 - spectrumMinEdge;
	    };
	    var getXCenterOffSetOf = function (component, spectrum) {
	      var componentBounds = getBounds$1(component);
	      var spectrumBounds = getBounds$1(spectrum);
	      var componentMinEdge = getBoundsProperty(componentBounds, left);
	      var componentMaxEdge = getBoundsProperty(componentBounds, right);
	      var spectrumMinEdge = getBoundsProperty(spectrumBounds, left);
	      return getCenterOffsetOf(componentMinEdge, componentMaxEdge, spectrumMinEdge);
	    };
	    var getYCenterOffSetOf = function (component, spectrum) {
	      var componentBounds = getBounds$1(component);
	      var spectrumBounds = getBounds$1(spectrum);
	      var componentMinEdge = getBoundsProperty(componentBounds, top);
	      var componentMaxEdge = getBoundsProperty(componentBounds, bottom);
	      var spectrumMinEdge = getBoundsProperty(spectrumBounds, top);
	      return getCenterOffsetOf(componentMinEdge, componentMaxEdge, spectrumMinEdge);
	    };
	
	    var fireSliderChange$1 = function (spectrum, value) {
	      emitWith(spectrum, sliderChangeEvent(), { value: value });
	    };
	    var sliderValue = function (x) {
	      return { x: x };
	    };
	    var findValueOfOffset = function (spectrum, detail, left) {
	      var args = {
	        min: minX(detail),
	        max: maxX(detail),
	        range: xRange(detail),
	        value: left,
	        step: step(detail),
	        snap: snap(detail),
	        snapStart: snapStart(detail),
	        rounded: rounded(detail),
	        hasMinEdge: hasLEdge(detail),
	        hasMaxEdge: hasREdge(detail),
	        minBound: getMinXBounds(spectrum),
	        maxBound: getMaxXBounds(spectrum),
	        screenRange: getXScreenRange(spectrum)
	      };
	      return findValueOf(args);
	    };
	    var setValueFrom = function (spectrum, detail, value) {
	      var xValue = findValueOfOffset(spectrum, detail, value);
	      var sliderVal = sliderValue(xValue);
	      fireSliderChange$1(spectrum, sliderVal);
	      return xValue;
	    };
	    var setToMin = function (spectrum, detail) {
	      var min = minX(detail);
	      fireSliderChange$1(spectrum, sliderValue(min));
	    };
	    var setToMax = function (spectrum, detail) {
	      var max = maxX(detail);
	      fireSliderChange$1(spectrum, sliderValue(max));
	    };
	    var moveBy = function (direction, spectrum, detail) {
	      var f = direction > 0 ? increaseBy : reduceBy;
	      var xValue = f(currentValue(detail).x, minX(detail), maxX(detail), step(detail));
	      fireSliderChange$1(spectrum, sliderValue(xValue));
	      return Optional.some(xValue);
	    };
	    var handleMovement = function (direction) {
	      return function (spectrum, detail) {
	        return moveBy(direction, spectrum, detail).map(always);
	      };
	    };
	    var getValueFromEvent = function (simulatedEvent) {
	      var pos = getEventSource(simulatedEvent);
	      return pos.map(function (p) {
	        return p.left;
	      });
	    };
	    var findOffsetOfValue$1 = function (spectrum, detail, value, minEdge, maxEdge) {
	      var minOffset = 0;
	      var maxOffset = getXScreenRange(spectrum);
	      var centerMinEdge = minEdge.bind(function (edge) {
	        return Optional.some(getXCenterOffSetOf(edge, spectrum));
	      }).getOr(minOffset);
	      var centerMaxEdge = maxEdge.bind(function (edge) {
	        return Optional.some(getXCenterOffSetOf(edge, spectrum));
	      }).getOr(maxOffset);
	      var args = {
	        min: minX(detail),
	        max: maxX(detail),
	        range: xRange(detail),
	        value: value,
	        hasMinEdge: hasLEdge(detail),
	        hasMaxEdge: hasREdge(detail),
	        minBound: getMinXBounds(spectrum),
	        minOffset: minOffset,
	        maxBound: getMaxXBounds(spectrum),
	        maxOffset: maxOffset,
	        centerMinEdge: centerMinEdge,
	        centerMaxEdge: centerMaxEdge
	      };
	      return findOffsetOfValue(args);
	    };
	    var findPositionOfValue = function (slider, spectrum, value, minEdge, maxEdge, detail) {
	      var offset = findOffsetOfValue$1(spectrum, detail, value, minEdge, maxEdge);
	      return getMinXBounds(spectrum) - getMinXBounds(slider) + offset;
	    };
	    var setPositionFromValue = function (slider, thumb, detail, edges) {
	      var value = currentValue(detail);
	      var pos = findPositionOfValue(slider, edges.getSpectrum(slider), value.x, edges.getLeftEdge(slider), edges.getRightEdge(slider), detail);
	      var thumbRadius = get$8(thumb.element) / 2;
	      set$2(thumb.element, 'left', pos - thumbRadius + 'px');
	    };
	    var onLeft = handleMovement(-1);
	    var onRight = handleMovement(1);
	    var onUp = Optional.none;
	    var onDown = Optional.none;
	    var edgeActions = {
	      'top-left': Optional.none(),
	      'top': Optional.none(),
	      'top-right': Optional.none(),
	      'right': Optional.some(setToREdge),
	      'bottom-right': Optional.none(),
	      'bottom': Optional.none(),
	      'bottom-left': Optional.none(),
	      'left': Optional.some(setToLEdge)
	    };
	
	    var HorizontalModel = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setValueFrom: setValueFrom,
	        setToMin: setToMin,
	        setToMax: setToMax,
	        findValueOfOffset: findValueOfOffset,
	        getValueFromEvent: getValueFromEvent,
	        findPositionOfValue: findPositionOfValue,
	        setPositionFromValue: setPositionFromValue,
	        onLeft: onLeft,
	        onRight: onRight,
	        onUp: onUp,
	        onDown: onDown,
	        edgeActions: edgeActions
	    });
	
	    var fireSliderChange$2 = function (spectrum, value) {
	      emitWith(spectrum, sliderChangeEvent(), { value: value });
	    };
	    var sliderValue$1 = function (y) {
	      return { y: y };
	    };
	    var findValueOfOffset$1 = function (spectrum, detail, top) {
	      var args = {
	        min: minY(detail),
	        max: maxY(detail),
	        range: yRange(detail),
	        value: top,
	        step: step(detail),
	        snap: snap(detail),
	        snapStart: snapStart(detail),
	        rounded: rounded(detail),
	        hasMinEdge: hasTEdge(detail),
	        hasMaxEdge: hasBEdge(detail),
	        minBound: getMinYBounds(spectrum),
	        maxBound: getMaxYBounds(spectrum),
	        screenRange: getYScreenRange(spectrum)
	      };
	      return findValueOf(args);
	    };
	    var setValueFrom$1 = function (spectrum, detail, value) {
	      var yValue = findValueOfOffset$1(spectrum, detail, value);
	      var sliderVal = sliderValue$1(yValue);
	      fireSliderChange$2(spectrum, sliderVal);
	      return yValue;
	    };
	    var setToMin$1 = function (spectrum, detail) {
	      var min = minY(detail);
	      fireSliderChange$2(spectrum, sliderValue$1(min));
	    };
	    var setToMax$1 = function (spectrum, detail) {
	      var max = maxY(detail);
	      fireSliderChange$2(spectrum, sliderValue$1(max));
	    };
	    var moveBy$1 = function (direction, spectrum, detail) {
	      var f = direction > 0 ? increaseBy : reduceBy;
	      var yValue = f(currentValue(detail).y, minY(detail), maxY(detail), step(detail));
	      fireSliderChange$2(spectrum, sliderValue$1(yValue));
	      return Optional.some(yValue);
	    };
	    var handleMovement$1 = function (direction) {
	      return function (spectrum, detail) {
	        return moveBy$1(direction, spectrum, detail).map(always);
	      };
	    };
	    var getValueFromEvent$1 = function (simulatedEvent) {
	      var pos = getEventSource(simulatedEvent);
	      return pos.map(function (p) {
	        return p.top;
	      });
	    };
	    var findOffsetOfValue$2 = function (spectrum, detail, value, minEdge, maxEdge) {
	      var minOffset = 0;
	      var maxOffset = getYScreenRange(spectrum);
	      var centerMinEdge = minEdge.bind(function (edge) {
	        return Optional.some(getYCenterOffSetOf(edge, spectrum));
	      }).getOr(minOffset);
	      var centerMaxEdge = maxEdge.bind(function (edge) {
	        return Optional.some(getYCenterOffSetOf(edge, spectrum));
	      }).getOr(maxOffset);
	      var args = {
	        min: minY(detail),
	        max: maxY(detail),
	        range: yRange(detail),
	        value: value,
	        hasMinEdge: hasTEdge(detail),
	        hasMaxEdge: hasBEdge(detail),
	        minBound: getMinYBounds(spectrum),
	        minOffset: minOffset,
	        maxBound: getMaxYBounds(spectrum),
	        maxOffset: maxOffset,
	        centerMinEdge: centerMinEdge,
	        centerMaxEdge: centerMaxEdge
	      };
	      return findOffsetOfValue(args);
	    };
	    var findPositionOfValue$1 = function (slider, spectrum, value, minEdge, maxEdge, detail) {
	      var offset = findOffsetOfValue$2(spectrum, detail, value, minEdge, maxEdge);
	      return getMinYBounds(spectrum) - getMinYBounds(slider) + offset;
	    };
	    var setPositionFromValue$1 = function (slider, thumb, detail, edges) {
	      var value = currentValue(detail);
	      var pos = findPositionOfValue$1(slider, edges.getSpectrum(slider), value.y, edges.getTopEdge(slider), edges.getBottomEdge(slider), detail);
	      var thumbRadius = get$7(thumb.element) / 2;
	      set$2(thumb.element, 'top', pos - thumbRadius + 'px');
	    };
	    var onLeft$1 = Optional.none;
	    var onRight$1 = Optional.none;
	    var onUp$1 = handleMovement$1(-1);
	    var onDown$1 = handleMovement$1(1);
	    var edgeActions$1 = {
	      'top-left': Optional.none(),
	      'top': Optional.some(setToTEdge),
	      'top-right': Optional.none(),
	      'right': Optional.none(),
	      'bottom-right': Optional.none(),
	      'bottom': Optional.some(setToBEdge),
	      'bottom-left': Optional.none(),
	      'left': Optional.none()
	    };
	
	    var VerticalModel = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setValueFrom: setValueFrom$1,
	        setToMin: setToMin$1,
	        setToMax: setToMax$1,
	        findValueOfOffset: findValueOfOffset$1,
	        getValueFromEvent: getValueFromEvent$1,
	        findPositionOfValue: findPositionOfValue$1,
	        setPositionFromValue: setPositionFromValue$1,
	        onLeft: onLeft$1,
	        onRight: onRight$1,
	        onUp: onUp$1,
	        onDown: onDown$1,
	        edgeActions: edgeActions$1
	    });
	
	    var fireSliderChange$3 = function (spectrum, value) {
	      emitWith(spectrum, sliderChangeEvent(), { value: value });
	    };
	    var sliderValue$2 = function (x, y) {
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var setValueFrom$2 = function (spectrum, detail, value) {
	      var xValue = findValueOfOffset(spectrum, detail, value.left);
	      var yValue = findValueOfOffset$1(spectrum, detail, value.top);
	      var val = sliderValue$2(xValue, yValue);
	      fireSliderChange$3(spectrum, val);
	      return val;
	    };
	    var moveBy$2 = function (direction, isVerticalMovement, spectrum, detail) {
	      var f = direction > 0 ? increaseBy : reduceBy;
	      var xValue = isVerticalMovement ? currentValue(detail).x : f(currentValue(detail).x, minX(detail), maxX(detail), step(detail));
	      var yValue = !isVerticalMovement ? currentValue(detail).y : f(currentValue(detail).y, minY(detail), maxY(detail), step(detail));
	      fireSliderChange$3(spectrum, sliderValue$2(xValue, yValue));
	      return Optional.some(xValue);
	    };
	    var handleMovement$2 = function (direction, isVerticalMovement) {
	      return function (spectrum, detail) {
	        return moveBy$2(direction, isVerticalMovement, spectrum, detail).map(always);
	      };
	    };
	    var setToMin$2 = function (spectrum, detail) {
	      var mX = minX(detail);
	      var mY = minY(detail);
	      fireSliderChange$3(spectrum, sliderValue$2(mX, mY));
	    };
	    var setToMax$2 = function (spectrum, detail) {
	      var mX = maxX(detail);
	      var mY = maxY(detail);
	      fireSliderChange$3(spectrum, sliderValue$2(mX, mY));
	    };
	    var getValueFromEvent$2 = function (simulatedEvent) {
	      return getEventSource(simulatedEvent);
	    };
	    var setPositionFromValue$2 = function (slider, thumb, detail, edges) {
	      var value = currentValue(detail);
	      var xPos = findPositionOfValue(slider, edges.getSpectrum(slider), value.x, edges.getLeftEdge(slider), edges.getRightEdge(slider), detail);
	      var yPos = findPositionOfValue$1(slider, edges.getSpectrum(slider), value.y, edges.getTopEdge(slider), edges.getBottomEdge(slider), detail);
	      var thumbXRadius = get$8(thumb.element) / 2;
	      var thumbYRadius = get$7(thumb.element) / 2;
	      set$2(thumb.element, 'left', xPos - thumbXRadius + 'px');
	      set$2(thumb.element, 'top', yPos - thumbYRadius + 'px');
	    };
	    var onLeft$2 = handleMovement$2(-1, false);
	    var onRight$2 = handleMovement$2(1, false);
	    var onUp$2 = handleMovement$2(-1, true);
	    var onDown$2 = handleMovement$2(1, true);
	    var edgeActions$2 = {
	      'top-left': Optional.some(setToTLEdgeXY),
	      'top': Optional.some(setToTEdgeXY),
	      'top-right': Optional.some(setToTREdgeXY),
	      'right': Optional.some(setToREdgeXY),
	      'bottom-right': Optional.some(setToBREdgeXY),
	      'bottom': Optional.some(setToBEdgeXY),
	      'bottom-left': Optional.some(setToBLEdgeXY),
	      'left': Optional.some(setToLEdgeXY)
	    };
	
	    var TwoDModel = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setValueFrom: setValueFrom$2,
	        setToMin: setToMin$2,
	        setToMax: setToMax$2,
	        getValueFromEvent: getValueFromEvent$2,
	        setPositionFromValue: setPositionFromValue$2,
	        onLeft: onLeft$2,
	        onRight: onRight$2,
	        onUp: onUp$2,
	        onDown: onDown$2,
	        edgeActions: edgeActions$2
	    });
	
	    var SliderSchema = [
	      defaulted$1('stepSize', 1),
	      defaulted$1('onChange', noop),
	      defaulted$1('onChoose', noop),
	      defaulted$1('onInit', noop),
	      defaulted$1('onDragStart', noop),
	      defaulted$1('onDragEnd', noop),
	      defaulted$1('snapToGrid', false),
	      defaulted$1('rounded', true),
	      option('snapStart'),
	      strictOf('model', choose$1('mode', {
	        x: [
	          defaulted$1('minX', 0),
	          defaulted$1('maxX', 100),
	          state$1('value', function (spec) {
	            return Cell(spec.mode.minX);
	          }),
	          strict$1('getInitialValue'),
	          output('manager', HorizontalModel)
	        ],
	        y: [
	          defaulted$1('minY', 0),
	          defaulted$1('maxY', 100),
	          state$1('value', function (spec) {
	            return Cell(spec.mode.minY);
	          }),
	          strict$1('getInitialValue'),
	          output('manager', VerticalModel)
	        ],
	        xy: [
	          defaulted$1('minX', 0),
	          defaulted$1('maxX', 100),
	          defaulted$1('minY', 0),
	          defaulted$1('maxY', 100),
	          state$1('value', function (spec) {
	            return Cell({
	              x: spec.mode.minX,
	              y: spec.mode.minY
	            });
	          }),
	          strict$1('getInitialValue'),
	          output('manager', TwoDModel)
	        ]
	      })),
	      field$1('sliderBehaviours', [
	        Keying,
	        Representing
	      ]),
	      state$1('mouseIsDown', function () {
	        return Cell(false);
	      })
	    ];
	
	    var sketch = function (detail, components, _spec, _externals) {
	      var _a;
	      var getThumb = function (component) {
	        return getPartOrDie(component, detail, 'thumb');
	      };
	      var getSpectrum = function (component) {
	        return getPartOrDie(component, detail, 'spectrum');
	      };
	      var getLeftEdge = function (component) {
	        return getPart(component, detail, 'left-edge');
	      };
	      var getRightEdge = function (component) {
	        return getPart(component, detail, 'right-edge');
	      };
	      var getTopEdge = function (component) {
	        return getPart(component, detail, 'top-edge');
	      };
	      var getBottomEdge = function (component) {
	        return getPart(component, detail, 'bottom-edge');
	      };
	      var modelDetail = detail.model;
	      var model = modelDetail.manager;
	      var refresh = function (slider, thumb) {
	        model.setPositionFromValue(slider, thumb, detail, {
	          getLeftEdge: getLeftEdge,
	          getRightEdge: getRightEdge,
	          getTopEdge: getTopEdge,
	          getBottomEdge: getBottomEdge,
	          getSpectrum: getSpectrum
	        });
	      };
	      var setValue = function (slider, newValue) {
	        modelDetail.value.set(newValue);
	        var thumb = getThumb(slider);
	        refresh(slider, thumb);
	      };
	      var changeValue = function (slider, newValue) {
	        setValue(slider, newValue);
	        var thumb = getThumb(slider);
	        detail.onChange(slider, thumb, newValue);
	        return Optional.some(true);
	      };
	      var resetToMin = function (slider) {
	        model.setToMin(slider, detail);
	      };
	      var resetToMax = function (slider) {
	        model.setToMax(slider, detail);
	      };
	      var choose = function (slider) {
	        var fireOnChoose = function () {
	          getPart(slider, detail, 'thumb').each(function (thumb) {
	            var value = modelDetail.value.get();
	            detail.onChoose(slider, thumb, value);
	          });
	        };
	        var wasDown = detail.mouseIsDown.get();
	        detail.mouseIsDown.set(false);
	        if (wasDown) {
	          fireOnChoose();
	        }
	      };
	      var onDragStart = function (slider, simulatedEvent) {
	        simulatedEvent.stop();
	        detail.mouseIsDown.set(true);
	        detail.onDragStart(slider, getThumb(slider));
	      };
	      var onDragEnd = function (slider, simulatedEvent) {
	        simulatedEvent.stop();
	        detail.onDragEnd(slider, getThumb(slider));
	        choose(slider);
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.sliderBehaviours, [
	          Keying.config({
	            mode: 'special',
	            focusIn: function (slider) {
	              return getPart(slider, detail, 'spectrum').map(Keying.focusIn).map(always);
	            }
	          }),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (_) {
	                return modelDetail.value.get();
	              }
	            }
	          }),
	          Receiving.config({ channels: (_a = {}, _a[mouseReleased()] = { onReceive: choose }, _a) })
	        ]),
	        events: derive([
	          run(sliderChangeEvent(), function (slider, simulatedEvent) {
	            changeValue(slider, simulatedEvent.event.value);
	          }),
	          runOnAttached(function (slider, _simulatedEvent) {
	            var getInitial = modelDetail.getInitialValue();
	            modelDetail.value.set(getInitial);
	            var thumb = getThumb(slider);
	            refresh(slider, thumb);
	            var spectrum = getSpectrum(slider);
	            detail.onInit(slider, thumb, spectrum, modelDetail.value.get());
	          }),
	          run(touchstart(), onDragStart),
	          run(touchend(), onDragEnd),
	          run(mousedown(), onDragStart),
	          run(mouseup(), onDragEnd)
	        ]),
	        apis: {
	          resetToMin: resetToMin,
	          resetToMax: resetToMax,
	          setValue: setValue,
	          refresh: refresh
	        },
	        domModification: { styles: { position: 'relative' } }
	      };
	    };
	
	    var Slider = composite$1({
	      name: 'Slider',
	      configFields: SliderSchema,
	      partFields: SliderParts,
	      factory: sketch,
	      apis: {
	        setValue: function (apis, slider, value) {
	          apis.setValue(slider, value);
	        },
	        resetToMin: function (apis, slider) {
	          apis.resetToMin(slider);
	        },
	        resetToMax: function (apis, slider) {
	          apis.resetToMax(slider);
	        },
	        refresh: function (apis, slider) {
	          apis.refresh(slider);
	        }
	      }
	    });
	
	    var hsvColour = function (hue, saturation, value) {
	      return {
	        hue: hue,
	        saturation: saturation,
	        value: value
	      };
	    };
	    var fromRgb = function (rgbaColour) {
	      var h = 0;
	      var s = 0;
	      var v = 0;
	      var r = rgbaColour.red / 255;
	      var g = rgbaColour.green / 255;
	      var b = rgbaColour.blue / 255;
	      var minRGB = Math.min(r, Math.min(g, b));
	      var maxRGB = Math.max(r, Math.max(g, b));
	      if (minRGB === maxRGB) {
	        v = minRGB;
	        return hsvColour(0, 0, v * 100);
	      }
	      var d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
	      h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
	      h = 60 * (h - d / (maxRGB - minRGB));
	      s = (maxRGB - minRGB) / maxRGB;
	      v = maxRGB;
	      return hsvColour(Math.round(h), Math.round(s * 100), Math.round(v * 100));
	    };
	
	    var hexToHsv = function (hex) {
	      return fromRgb(fromHex(hex));
	    };
	    var hsvToHex = function (hsv) {
	      return fromRgba(fromHsv(hsv));
	    };
	
	    var fieldsUpdate = generate$1('rgb-hex-update');
	    var sliderUpdate = generate$1('slider-update');
	    var paletteUpdate = generate$1('palette-update');
	
	    var sliderFactory = function (translate, getClass) {
	      var spectrum = Slider.parts.spectrum({
	        dom: {
	          tag: 'div',
	          classes: [getClass('hue-slider-spectrum')],
	          attributes: { role: 'presentation' }
	        }
	      });
	      var thumb = Slider.parts.thumb({
	        dom: {
	          tag: 'div',
	          classes: [getClass('hue-slider-thumb')],
	          attributes: { role: 'presentation' }
	        }
	      });
	      return Slider.sketch({
	        dom: {
	          tag: 'div',
	          classes: [getClass('hue-slider')],
	          attributes: { role: 'presentation' }
	        },
	        rounded: false,
	        model: {
	          mode: 'y',
	          getInitialValue: constant({ y: 0 })
	        },
	        components: [
	          spectrum,
	          thumb
	        ],
	        sliderBehaviours: derive$1([Focusing.config({})]),
	        onChange: function (slider, _thumb, value) {
	          emitWith(slider, sliderUpdate, { value: value });
	        }
	      });
	    };
	
	    var owner$3 = 'form';
	    var schema$h = [field$1('formBehaviours', [Representing])];
	    var getPartName = function (name) {
	      return '<alloy.field.' + name + '>';
	    };
	    var sketch$1 = function (fSpec) {
	      var parts = function () {
	        var record = [];
	        var field = function (name, config) {
	          record.push(name);
	          return generateOne(owner$3, getPartName(name), config);
	        };
	        return {
	          field: field,
	          record: function () {
	            return record;
	          }
	        };
	      }();
	      var spec = fSpec(parts);
	      var partNames = parts.record();
	      var fieldParts = map(partNames, function (n) {
	        return required({
	          name: n,
	          pname: getPartName(n)
	        });
	      });
	      return composite(owner$3, schema$h, fieldParts, make$4, spec);
	    };
	    var toResult$1 = function (o, e) {
	      return o.fold(function () {
	        return Result.error(e);
	      }, Result.value);
	    };
	    var make$4 = function (detail, components) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.formBehaviours, [Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (form) {
	                var resPs = getAllParts(form, detail);
	                return map$2(resPs, function (resPThunk, pName) {
	                  return resPThunk().bind(function (v) {
	                    var opt = Composing.getCurrent(v);
	                    return toResult$1(opt, new Error('Cannot find a current component to extract the value from for form part \'' + pName + '\': ' + element(v.element)));
	                  }).map(Representing.getValue);
	                });
	              },
	              setValue: function (form, values) {
	                each$1(values, function (newValue, key) {
	                  getPart(form, detail, key).each(function (wrapper) {
	                    Composing.getCurrent(wrapper).each(function (field) {
	                      Representing.setValue(field, newValue);
	                    });
	                  });
	                });
	              }
	            }
	          })]),
	        apis: {
	          getField: function (form, key) {
	            return getPart(form, detail, key).bind(Composing.getCurrent);
	          }
	        }
	      };
	    };
	    var Form = {
	      getField: makeApi(function (apis, component, key) {
	        return apis.getField(component, key);
	      }),
	      sketch: sketch$1
	    };
	
	    var validInput = generate$1('valid-input');
	    var invalidInput = generate$1('invalid-input');
	    var validatingInput = generate$1('validating-input');
	    var translatePrefix = 'colorcustom.rgb.';
	    var rgbFormFactory = function (translate, getClass, onValidHexx, onInvalidHexx) {
	      var invalidation = function (label, isValid) {
	        return Invalidating.config({
	          invalidClass: getClass('invalid'),
	          notify: {
	            onValidate: function (comp) {
	              emitWith(comp, validatingInput, { type: label });
	            },
	            onValid: function (comp) {
	              emitWith(comp, validInput, {
	                type: label,
	                value: Representing.getValue(comp)
	              });
	            },
	            onInvalid: function (comp) {
	              emitWith(comp, invalidInput, {
	                type: label,
	                value: Representing.getValue(comp)
	              });
	            }
	          },
	          validator: {
	            validate: function (comp) {
	              var value = Representing.getValue(comp);
	              var res = isValid(value) ? Result.value(true) : Result.error(translate('aria.input.invalid'));
	              return Future.pure(res);
	            },
	            validateOnLoad: false
	          }
	        });
	      };
	      var renderTextField = function (isValid, name, label, description, data) {
	        var helptext = translate(translatePrefix + 'range');
	        var pLabel = FormField.parts.label({
	          dom: {
	            tag: 'label',
	            innerHtml: label,
	            attributes: { 'aria-label': description }
	          }
	        });
	        var pField = FormField.parts.field({
	          data: data,
	          factory: Input,
	          inputAttributes: __assign({ type: 'text' }, name === 'hex' ? { 'aria-live': 'polite' } : {}),
	          inputClasses: [getClass('textfield')],
	          inputBehaviours: derive$1([
	            invalidation(name, isValid),
	            Tabstopping.config({})
	          ]),
	          onSetValue: function (input) {
	            if (Invalidating.isInvalid(input)) {
	              var run = Invalidating.run(input);
	              run.get(noop);
	            }
	          }
	        });
	        var comps = [
	          pLabel,
	          pField
	        ];
	        var concats = name !== 'hex' ? [FormField.parts['aria-descriptor']({ text: helptext })] : [];
	        var components = comps.concat(concats);
	        return {
	          dom: {
	            tag: 'div',
	            attributes: { role: 'presentation' }
	          },
	          components: components
	        };
	      };
	      var copyRgbToHex = function (form, rgba) {
	        var hex = fromRgba(rgba);
	        Form.getField(form, 'hex').each(function (hexField) {
	          if (!Focusing.isFocused(hexField)) {
	            Representing.setValue(form, { hex: hex.value });
	          }
	        });
	        return hex;
	      };
	      var copyRgbToForm = function (form, rgb) {
	        var red = rgb.red;
	        var green = rgb.green;
	        var blue = rgb.blue;
	        Representing.setValue(form, {
	          red: red,
	          green: green,
	          blue: blue
	        });
	      };
	      var memPreview = record({
	        dom: {
	          tag: 'div',
	          classes: [getClass('rgba-preview')],
	          styles: { 'background-color': 'white' },
	          attributes: { role: 'presentation' }
	        }
	      });
	      var updatePreview = function (anyInSystem, hex) {
	        memPreview.getOpt(anyInSystem).each(function (preview) {
	          set$2(preview.element, 'background-color', '#' + hex.value);
	        });
	      };
	      var factory = function () {
	        var state = {
	          red: Cell(Optional.some(255)),
	          green: Cell(Optional.some(255)),
	          blue: Cell(Optional.some(255)),
	          hex: Cell(Optional.some('ffffff'))
	        };
	        var copyHexToRgb = function (form, hex) {
	          var rgb = fromHex(hex);
	          copyRgbToForm(form, rgb);
	          setValueRgb(rgb);
	        };
	        var get = function (prop) {
	          return state[prop].get();
	        };
	        var set = function (prop, value) {
	          state[prop].set(value);
	        };
	        var getValueRgb = function () {
	          return get('red').bind(function (red) {
	            return get('green').bind(function (green) {
	              return get('blue').map(function (blue) {
	                return rgbaColour(red, green, blue, 1);
	              });
	            });
	          });
	        };
	        var setValueRgb = function (rgb) {
	          var red = rgb.red;
	          var green = rgb.green;
	          var blue = rgb.blue;
	          set('red', Optional.some(red));
	          set('green', Optional.some(green));
	          set('blue', Optional.some(blue));
	        };
	        var onInvalidInput = function (form, simulatedEvent) {
	          var data = simulatedEvent.event;
	          if (data.type !== 'hex') {
	            set(data.type, Optional.none());
	          } else {
	            onInvalidHexx(form);
	          }
	        };
	        var onValidHex = function (form, value) {
	          onValidHexx(form);
	          var hex = hexColour(value);
	          set('hex', Optional.some(value));
	          var rgb = fromHex(hex);
	          copyRgbToForm(form, rgb);
	          setValueRgb(rgb);
	          emitWith(form, fieldsUpdate, { hex: hex });
	          updatePreview(form, hex);
	        };
	        var onValidRgb = function (form, prop, value) {
	          var val = parseInt(value, 10);
	          set(prop, Optional.some(val));
	          getValueRgb().each(function (rgb) {
	            var hex = copyRgbToHex(form, rgb);
	            emitWith(form, fieldsUpdate, { hex: hex });
	            updatePreview(form, hex);
	          });
	        };
	        var isHexInputEvent = function (data) {
	          return data.type === 'hex';
	        };
	        var onValidInput = function (form, simulatedEvent) {
	          var data = simulatedEvent.event;
	          if (isHexInputEvent(data)) {
	            onValidHex(form, data.value);
	          } else {
	            onValidRgb(form, data.type, data.value);
	          }
	        };
	        var formPartStrings = function (key) {
	          return {
	            label: translate(translatePrefix + key + '.label'),
	            description: translate(translatePrefix + key + '.description')
	          };
	        };
	        var redStrings = formPartStrings('red');
	        var greenStrings = formPartStrings('green');
	        var blueStrings = formPartStrings('blue');
	        var hexStrings = formPartStrings('hex');
	        return deepMerge(Form.sketch(function (parts) {
	          return {
	            dom: {
	              tag: 'form',
	              classes: [getClass('rgb-form')],
	              attributes: { 'aria-label': translate('aria.color.picker') }
	            },
	            components: [
	              parts.field('red', FormField.sketch(renderTextField(isRgbaComponent, 'red', redStrings.label, redStrings.description, 255))),
	              parts.field('green', FormField.sketch(renderTextField(isRgbaComponent, 'green', greenStrings.label, greenStrings.description, 255))),
	              parts.field('blue', FormField.sketch(renderTextField(isRgbaComponent, 'blue', blueStrings.label, blueStrings.description, 255))),
	              parts.field('hex', FormField.sketch(renderTextField(isHexString, 'hex', hexStrings.label, hexStrings.description, 'ffffff'))),
	              memPreview.asSpec()
	            ],
	            formBehaviours: derive$1([
	              Invalidating.config({ invalidClass: getClass('form-invalid') }),
	              config('rgb-form-events', [
	                run(validInput, onValidInput),
	                run(invalidInput, onInvalidInput),
	                run(validatingInput, onInvalidInput)
	              ])
	            ])
	          };
	        }), {
	          apis: {
	            updateHex: function (form, hex) {
	              Representing.setValue(form, { hex: hex.value });
	              copyHexToRgb(form, hex);
	              updatePreview(form, hex);
	            }
	          }
	        });
	      };
	      var rgbFormSketcher = single$2({
	        factory: factory,
	        name: 'RgbForm',
	        configFields: [],
	        apis: {
	          updateHex: function (apis, form, hex) {
	            apis.updateHex(form, hex);
	          }
	        },
	        extraApis: {}
	      });
	      return rgbFormSketcher;
	    };
	
	    var paletteFactory = function (_translate, getClass) {
	      var spectrumPart = Slider.parts.spectrum({
	        dom: {
	          tag: 'canvas',
	          attributes: { role: 'presentation' },
	          classes: [getClass('sv-palette-spectrum')]
	        }
	      });
	      var thumbPart = Slider.parts.thumb({
	        dom: {
	          tag: 'div',
	          attributes: { role: 'presentation' },
	          classes: [getClass('sv-palette-thumb')],
	          innerHtml: '<div class=' + getClass('sv-palette-inner-thumb') + ' role="presentation"></div>'
	        }
	      });
	      var setColour = function (canvas, rgba) {
	        var width = canvas.width, height = canvas.height;
	        var ctx = canvas.getContext('2d');
	        if (ctx === null) {
	          return;
	        }
	        ctx.fillStyle = rgba;
	        ctx.fillRect(0, 0, width, height);
	        var grdWhite = ctx.createLinearGradient(0, 0, width, 0);
	        grdWhite.addColorStop(0, 'rgba(255,255,255,1)');
	        grdWhite.addColorStop(1, 'rgba(255,255,255,0)');
	        ctx.fillStyle = grdWhite;
	        ctx.fillRect(0, 0, width, height);
	        var grdBlack = ctx.createLinearGradient(0, 0, 0, height);
	        grdBlack.addColorStop(0, 'rgba(0,0,0,0)');
	        grdBlack.addColorStop(1, 'rgba(0,0,0,1)');
	        ctx.fillStyle = grdBlack;
	        ctx.fillRect(0, 0, width, height);
	      };
	      var setPaletteHue = function (slider, hue) {
	        var canvas = slider.components()[0].element.dom;
	        var hsv = hsvColour(hue, 100, 100);
	        var rgba = fromHsv(hsv);
	        setColour(canvas, toString(rgba));
	      };
	      var setPaletteThumb = function (slider, hex) {
	        var hsv = fromRgb(fromHex(hex));
	        Slider.setValue(slider, {
	          x: hsv.saturation,
	          y: 100 - hsv.value
	        });
	      };
	      var factory = function (_detail) {
	        var getInitialValue = constant({
	          x: 0,
	          y: 0
	        });
	        var onChange = function (slider, _thumb, value) {
	          emitWith(slider, paletteUpdate, { value: value });
	        };
	        var onInit = function (_slider, _thumb, spectrum, _value) {
	          setColour(spectrum.element.dom, toString(red));
	        };
	        var sliderBehaviours = derive$1([
	          Composing.config({ find: Optional.some }),
	          Focusing.config({})
	        ]);
	        return Slider.sketch({
	          dom: {
	            tag: 'div',
	            attributes: { role: 'presentation' },
	            classes: [getClass('sv-palette')]
	          },
	          model: {
	            mode: 'xy',
	            getInitialValue: getInitialValue
	          },
	          rounded: false,
	          components: [
	            spectrumPart,
	            thumbPart
	          ],
	          onChange: onChange,
	          onInit: onInit,
	          sliderBehaviours: sliderBehaviours
	        });
	      };
	      var saturationBrightnessPaletteSketcher = single$2({
	        factory: factory,
	        name: 'SaturationBrightnessPalette',
	        configFields: [],
	        apis: {
	          setHue: function (_apis, slider, hue) {
	            setPaletteHue(slider, hue);
	          },
	          setThumb: function (_apis, slider, hex) {
	            setPaletteThumb(slider, hex);
	          }
	        },
	        extraApis: {}
	      });
	      return saturationBrightnessPaletteSketcher;
	    };
	
	    var makeFactory = function (translate, getClass) {
	      var factory = function (detail) {
	        var rgbForm = rgbFormFactory(translate, getClass, detail.onValidHex, detail.onInvalidHex);
	        var sbPalette = paletteFactory(translate, getClass);
	        var hueSliderToDegrees = function (hue) {
	          return (100 - hue) / 100 * 360;
	        };
	        var hueDegreesToSlider = function (hue) {
	          return 100 - hue / 360 * 100;
	        };
	        var state = {
	          paletteRgba: Cell(red),
	          paletteHue: Cell(0)
	        };
	        var memSlider = record(sliderFactory(translate, getClass));
	        var memPalette = record(sbPalette.sketch({}));
	        var memRgb = record(rgbForm.sketch({}));
	        var updatePalette = function (anyInSystem, _hex, hue) {
	          memPalette.getOpt(anyInSystem).each(function (palette) {
	            sbPalette.setHue(palette, hue);
	          });
	        };
	        var updateFields = function (anyInSystem, hex) {
	          memRgb.getOpt(anyInSystem).each(function (form) {
	            rgbForm.updateHex(form, hex);
	          });
	        };
	        var updateSlider = function (anyInSystem, _hex, hue) {
	          memSlider.getOpt(anyInSystem).each(function (slider) {
	            Slider.setValue(slider, { y: hueDegreesToSlider(hue) });
	          });
	        };
	        var updatePaletteThumb = function (anyInSystem, hex) {
	          memPalette.getOpt(anyInSystem).each(function (palette) {
	            sbPalette.setThumb(palette, hex);
	          });
	        };
	        var updateState = function (hex, hue) {
	          var rgba = fromHex(hex);
	          state.paletteRgba.set(rgba);
	          state.paletteHue.set(hue);
	        };
	        var runUpdates = function (anyInSystem, hex, hue, updates) {
	          updateState(hex, hue);
	          each(updates, function (update) {
	            update(anyInSystem, hex, hue);
	          });
	        };
	        var onPaletteUpdate = function () {
	          var updates = [updateFields];
	          return function (form, simulatedEvent) {
	            var value = simulatedEvent.event.value;
	            var oldHue = state.paletteHue.get();
	            var newHsv = hsvColour(oldHue, value.x, 100 - value.y);
	            var newHex = hsvToHex(newHsv);
	            runUpdates(form, newHex, oldHue, updates);
	          };
	        };
	        var onSliderUpdate = function () {
	          var updates = [
	            updatePalette,
	            updateFields
	          ];
	          return function (form, simulatedEvent) {
	            var hue = hueSliderToDegrees(simulatedEvent.event.value.y);
	            var oldRgb = state.paletteRgba.get();
	            var oldHsv = fromRgb(oldRgb);
	            var newHsv = hsvColour(hue, oldHsv.saturation, oldHsv.value);
	            var newHex = hsvToHex(newHsv);
	            runUpdates(form, newHex, hue, updates);
	          };
	        };
	        var onFieldsUpdate = function () {
	          var updates = [
	            updatePalette,
	            updateSlider,
	            updatePaletteThumb
	          ];
	          return function (form, simulatedEvent) {
	            var hex = simulatedEvent.event.hex;
	            var hsv = hexToHsv(hex);
	            runUpdates(form, hex, hsv.hue, updates);
	          };
	        };
	        return {
	          uid: detail.uid,
	          dom: detail.dom,
	          components: [
	            memPalette.asSpec(),
	            memSlider.asSpec(),
	            memRgb.asSpec()
	          ],
	          behaviours: derive$1([
	            config('colour-picker-events', [
	              run(fieldsUpdate, onFieldsUpdate()),
	              run(paletteUpdate, onPaletteUpdate()),
	              run(sliderUpdate, onSliderUpdate())
	            ]),
	            Composing.config({
	              find: function (comp) {
	                return memRgb.getOpt(comp);
	              }
	            }),
	            Keying.config({ mode: 'acyclic' })
	          ])
	        };
	      };
	      var colourPickerSketcher = single$2({
	        name: 'ColourPicker',
	        configFields: [
	          strict$1('dom'),
	          defaulted$1('onValidHex', noop),
	          defaulted$1('onInvalidHex', noop)
	        ],
	        factory: factory
	      });
	      return colourPickerSketcher;
	    };
	
	    var self$1 = function () {
	      return Composing.config({ find: Optional.some });
	    };
	    var memento = function (mem) {
	      return Composing.config({ find: mem.getOpt });
	    };
	    var childAt = function (index) {
	      return Composing.config({
	        find: function (comp) {
	          return child(comp.element, index).bind(function (element) {
	            return comp.getSystem().getByDom(element).toOptional();
	          });
	        }
	      });
	    };
	    var ComposingConfigs = {
	      self: self$1,
	      memento: memento,
	      childAt: childAt
	    };
	
	    var english = {
	      'colorcustom.rgb.red.label': 'R',
	      'colorcustom.rgb.red.description': 'Red component',
	      'colorcustom.rgb.green.label': 'G',
	      'colorcustom.rgb.green.description': 'Green component',
	      'colorcustom.rgb.blue.label': 'B',
	      'colorcustom.rgb.blue.description': 'Blue component',
	      'colorcustom.rgb.hex.label': '#',
	      'colorcustom.rgb.hex.description': 'Hex color code',
	      'colorcustom.rgb.range': 'Range 0 to 255',
	      'colorcustom.sb.saturation': 'Saturation',
	      'colorcustom.sb.brightness': 'Brightness',
	      'colorcustom.sb.picker': 'Saturation and Brightness Picker',
	      'colorcustom.sb.palette': 'Saturation and Brightness Palette',
	      'colorcustom.sb.instructions': 'Use arrow keys to select saturation and brightness, on x and y axes',
	      'colorcustom.hue.hue': 'Hue',
	      'colorcustom.hue.slider': 'Hue Slider',
	      'colorcustom.hue.palette': 'Hue Palette',
	      'colorcustom.hue.instructions': 'Use arrow keys to select a hue',
	      'aria.color.picker': 'Color Picker',
	      'aria.input.invalid': 'Invalid input'
	    };
	    var getEnglishText = function (key) {
	      return english[key];
	    };
	    var translate$1 = function (key) {
	      return getEnglishText(key);
	    };
	    var renderColorPicker = function (_spec) {
	      var getClass = function (key) {
	        return 'tox-' + key;
	      };
	      var colourPickerFactory = makeFactory(translate$1, getClass);
	      var onValidHex = function (form) {
	        emitWith(form, formActionEvent, {
	          name: 'hex-valid',
	          value: true
	        });
	      };
	      var onInvalidHex = function (form) {
	        emitWith(form, formActionEvent, {
	          name: 'hex-valid',
	          value: false
	        });
	      };
	      var memPicker = record(colourPickerFactory.sketch({
	        dom: {
	          tag: 'div',
	          classes: [getClass('color-picker-container')],
	          attributes: { role: 'presentation' }
	        },
	        onValidHex: onValidHex,
	        onInvalidHex: onInvalidHex
	      }));
	      return {
	        dom: { tag: 'div' },
	        components: [memPicker.asSpec()],
	        behaviours: derive$1([
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (comp) {
	                var picker = memPicker.get(comp);
	                var optRgbForm = Composing.getCurrent(picker);
	                var optHex = optRgbForm.bind(function (rgbForm) {
	                  var formValues = Representing.getValue(rgbForm);
	                  return formValues.hex;
	                });
	                return optHex.map(function (hex) {
	                  return '#' + hex;
	                }).getOr('');
	              },
	              setValue: function (comp, newValue) {
	                var pattern = /^#([a-fA-F0-9]{3}(?:[a-fA-F0-9]{3})?)/;
	                var m = pattern.exec(newValue);
	                var picker = memPicker.get(comp);
	                var optRgbForm = Composing.getCurrent(picker);
	                optRgbForm.fold(function () {
	                  console.log('Can not find form');
	                }, function (rgbForm) {
	                  Representing.setValue(rgbForm, { hex: Optional.from(m[1]).getOr('') });
	                  Form.getField(rgbForm, 'hex').each(function (hexField) {
	                    emit(hexField, input());
	                  });
	                });
	              }
	            }
	          }),
	          ComposingConfigs.self()
	        ])
	      };
	    };
	
	    var global$b = tinymce.util.Tools.resolve('tinymce.Resource');
	
	    var isOldCustomEditor = function (spec) {
	      return Object.prototype.hasOwnProperty.call(spec, 'init');
	    };
	    var renderCustomEditor = function (spec) {
	      var editorApi = Cell(Optional.none());
	      var memReplaced = record({ dom: { tag: spec.tag } });
	      var initialValue = Cell(Optional.none());
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-custom-editor']
	        },
	        behaviours: derive$1([
	          config('custom-editor-events', [runOnAttached(function (component) {
	              memReplaced.getOpt(component).each(function (ta) {
	                (isOldCustomEditor(spec) ? spec.init(ta.element.dom) : global$b.load(spec.scriptId, spec.scriptUrl).then(function (init) {
	                  return init(ta.element.dom, spec.settings);
	                })).then(function (ea) {
	                  initialValue.get().each(function (cvalue) {
	                    ea.setValue(cvalue);
	                  });
	                  initialValue.set(Optional.none());
	                  editorApi.set(Optional.some(ea));
	                });
	              });
	            })]),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function () {
	                return editorApi.get().fold(function () {
	                  return initialValue.get().getOr('');
	                }, function (ed) {
	                  return ed.getValue();
	                });
	              },
	              setValue: function (component, value) {
	                editorApi.get().fold(function () {
	                  initialValue.set(Optional.some(value));
	                }, function (ed) {
	                  return ed.setValue(value);
	                });
	              }
	            }
	          }),
	          ComposingConfigs.self()
	        ]),
	        components: [memReplaced.asSpec()]
	      };
	    };
	
	    var global$c = tinymce.util.Tools.resolve('tinymce.util.Tools');
	
	    var processors = objOf([
	      defaulted$1('preprocess', identity),
	      defaulted$1('postprocess', identity)
	    ]);
	    var memento$1 = function (mem, rawProcessors) {
	      var ps = asRawOrDie('RepresentingConfigs.memento processors', processors, rawProcessors);
	      return Representing.config({
	        store: {
	          mode: 'manual',
	          getValue: function (comp) {
	            var other = mem.get(comp);
	            var rawValue = Representing.getValue(other);
	            return ps.postprocess(rawValue);
	          },
	          setValue: function (comp, rawValue) {
	            var newValue = ps.preprocess(rawValue);
	            var other = mem.get(comp);
	            Representing.setValue(other, newValue);
	          }
	        }
	      });
	    };
	    var withComp = function (optInitialValue, getter, setter) {
	      return Representing.config(deepMerge({
	        store: {
	          mode: 'manual',
	          getValue: getter,
	          setValue: setter
	        }
	      }, optInitialValue.map(function (initialValue) {
	        return { store: { initialValue: initialValue } };
	      }).getOr({})));
	    };
	    var withElement = function (initialValue, getter, setter) {
	      return withComp(initialValue, function (c) {
	        return getter(c.element);
	      }, function (c, v) {
	        return setter(c.element, v);
	      });
	    };
	    var domValue = function (optInitialValue) {
	      return withElement(optInitialValue, get$6, set$3);
	    };
	    var domHtml = function (optInitialValue) {
	      return withElement(optInitialValue, get$2, set);
	    };
	    var memory$1 = function (initialValue) {
	      return Representing.config({
	        store: {
	          mode: 'memory',
	          initialValue: initialValue
	        }
	      });
	    };
	    var RepresentingConfigs = {
	      memento: memento$1,
	      withElement: withElement,
	      withComp: withComp,
	      domValue: domValue,
	      domHtml: domHtml,
	      memory: memory$1
	    };
	
	    var defaultImageFileTypes = 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp';
	    var filterByExtension = function (files, providersBackstage) {
	      var allowedImageFileTypes = global$c.explode(providersBackstage.getSetting('images_file_types', defaultImageFileTypes, 'string'));
	      var isFileInAllowedTypes = function (file) {
	        return exists(allowedImageFileTypes, function (type) {
	          return endsWith(file.name.toLowerCase(), '.' + type.toLowerCase());
	        });
	      };
	      return filter(from$1(files), isFileInAllowedTypes);
	    };
	    var renderDropZone = function (spec, providersBackstage) {
	      var stopper = function (_, se) {
	        se.stop();
	      };
	      var sequence = function (actions) {
	        return function (comp, se) {
	          each(actions, function (a) {
	            a(comp, se);
	          });
	        };
	      };
	      var onDrop = function (comp, se) {
	        if (!Disabling.isDisabled(comp)) {
	          var transferEvent = se.event.raw;
	          handleFiles(comp, transferEvent.dataTransfer.files);
	        }
	      };
	      var onSelect = function (component, simulatedEvent) {
	        var input = simulatedEvent.event.raw.target;
	        handleFiles(component, input.files);
	      };
	      var handleFiles = function (component, files) {
	        Representing.setValue(component, filterByExtension(files, providersBackstage));
	        emitWith(component, formChangeEvent, { name: spec.name });
	      };
	      var memInput = record({
	        dom: {
	          tag: 'input',
	          attributes: {
	            type: 'file',
	            accept: 'image/*'
	          },
	          styles: { display: 'none' }
	        },
	        behaviours: derive$1([config('input-file-events', [
	            cutter(click()),
	            cutter(tap())
	          ])])
	      });
	      var renderField = function (s) {
	        return {
	          uid: s.uid,
	          dom: {
	            tag: 'div',
	            classes: ['tox-dropzone-container']
	          },
	          behaviours: derive$1([
	            RepresentingConfigs.memory([]),
	            ComposingConfigs.self(),
	            Disabling.config({}),
	            Toggling.config({
	              toggleClass: 'dragenter',
	              toggleOnExecute: false
	            }),
	            config('dropzone-events', [
	              run('dragenter', sequence([
	                stopper,
	                Toggling.toggle
	              ])),
	              run('dragleave', sequence([
	                stopper,
	                Toggling.toggle
	              ])),
	              run('dragover', stopper),
	              run('drop', sequence([
	                stopper,
	                onDrop
	              ])),
	              run(change(), onSelect)
	            ])
	          ]),
	          components: [{
	              dom: {
	                tag: 'div',
	                classes: ['tox-dropzone'],
	                styles: {}
	              },
	              components: [
	                {
	                  dom: {
	                    tag: 'p',
	                    innerHtml: providersBackstage.translate('Drop an image here')
	                  }
	                },
	                Button.sketch({
	                  dom: {
	                    tag: 'button',
	                    innerHtml: providersBackstage.translate('Browse for an image'),
	                    styles: { position: 'relative' },
	                    classes: [
	                      'tox-button',
	                      'tox-button--secondary'
	                    ]
	                  },
	                  components: [memInput.asSpec()],
	                  action: function (comp) {
	                    var inputComp = memInput.get(comp);
	                    inputComp.element.dom.click();
	                  },
	                  buttonBehaviours: derive$1([
	                    Tabstopping.config({}),
	                    DisablingConfigs.button(providersBackstage.isDisabled),
	                    receivingConfig()
	                  ])
	                })
	              ]
	            }]
	        };
	      };
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var pField = FormField.parts.field({ factory: { sketch: renderField } });
	      return renderFormFieldWith(pLabel, pField, ['tox-form__group--stretched'], []);
	    };
	
	    var renderGrid = function (spec, backstage) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-form__grid',
	            'tox-form__grid--' + spec.columns + 'col'
	          ]
	        },
	        components: map(spec.items, backstage.interpreter)
	      };
	    };
	
	    var beforeObject = generate$1('alloy-fake-before-tabstop');
	    var afterObject = generate$1('alloy-fake-after-tabstop');
	    var craftWithClasses = function (classes) {
	      return {
	        dom: {
	          tag: 'div',
	          styles: {
	            width: '1px',
	            height: '1px',
	            outline: 'none'
	          },
	          attributes: { tabindex: '0' },
	          classes: classes
	        },
	        behaviours: derive$1([
	          Focusing.config({ ignore: true }),
	          Tabstopping.config({})
	        ])
	      };
	    };
	    var craft = function (spec) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-navobj']
	        },
	        components: [
	          craftWithClasses([beforeObject]),
	          spec,
	          craftWithClasses([afterObject])
	        ],
	        behaviours: derive$1([ComposingConfigs.childAt(1)])
	      };
	    };
	    var triggerTab = function (placeholder, shiftKey) {
	      emitWith(placeholder, keydown(), {
	        raw: {
	          which: 9,
	          shiftKey: shiftKey
	        }
	      });
	    };
	    var onFocus$1 = function (container, targetComp) {
	      var target = targetComp.element;
	      if (has$2(target, beforeObject)) {
	        triggerTab(container, true);
	      } else if (has$2(target, afterObject)) {
	        triggerTab(container, false);
	      }
	    };
	    var isPseudoStop = function (element) {
	      return closest$4(element, [
	        '.' + beforeObject,
	        '.' + afterObject
	      ].join(','), never);
	    };
	
	    var platformNeedsSandboxing = !(detect$3().browser.isIE() || detect$3().browser.isEdge());
	    var getDynamicSource = function (isSandbox) {
	      var cachedValue = Cell('');
	      return {
	        getValue: function (_frameComponent) {
	          return cachedValue.get();
	        },
	        setValue: function (frameComponent, html) {
	          if (!isSandbox) {
	            set$1(frameComponent.element, 'src', 'javascript:\'\'');
	            var doc = frameComponent.element.dom.contentWindow.document;
	            doc.open();
	            doc.write(html);
	            doc.close();
	          } else {
	            set$1(frameComponent.element, 'srcdoc', html);
	          }
	          cachedValue.set(html);
	        }
	      };
	    };
	    var renderIFrame = function (spec, providersBackstage) {
	      var isSandbox = platformNeedsSandboxing && spec.sandboxed;
	      var attributes = __assign(__assign({}, spec.label.map(function (title) {
	        return { title: title };
	      }).getOr({})), isSandbox ? { sandbox: 'allow-scripts allow-same-origin' } : {});
	      var sourcing = getDynamicSource(isSandbox);
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var factory = function (newSpec) {
	        return craft({
	          uid: newSpec.uid,
	          dom: {
	            tag: 'iframe',
	            attributes: attributes
	          },
	          behaviours: derive$1([
	            Tabstopping.config({}),
	            Focusing.config({}),
	            RepresentingConfigs.withComp(Optional.none(), sourcing.getValue, sourcing.setValue)
	          ])
	        });
	      };
	      var pField = FormField.parts.field({ factory: { sketch: factory } });
	      return renderFormFieldWith(pLabel, pField, ['tox-form__group--stretched'], []);
	    };
	
	    var create$5 = function (width, height) {
	      return resize(document.createElement('canvas'), width, height);
	    };
	    var clone$1 = function (canvas) {
	      var tCanvas = create$5(canvas.width, canvas.height);
	      var ctx = get2dContext(tCanvas);
	      ctx.drawImage(canvas, 0, 0);
	      return tCanvas;
	    };
	    var get2dContext = function (canvas) {
	      return canvas.getContext('2d');
	    };
	    var resize = function (canvas, width, height) {
	      canvas.width = width;
	      canvas.height = height;
	      return canvas;
	    };
	
	    var getWidth = function (image) {
	      return image.naturalWidth || image.width;
	    };
	    var getHeight = function (image) {
	      return image.naturalHeight || image.height;
	    };
	
	    var promise = function () {
	      var Promise = function (fn) {
	        if (typeof this !== 'object') {
	          throw new TypeError('Promises must be constructed via new');
	        }
	        if (typeof fn !== 'function') {
	          throw new TypeError('not a function');
	        }
	        this._state = null;
	        this._value = null;
	        this._deferreds = [];
	        doResolve(fn, bind(resolve, this), bind(reject, this));
	      };
	      var anyWindow = window;
	      var asap = Promise.immediateFn || typeof anyWindow.setImmediate === 'function' && anyWindow.setImmediate || function (fn) {
	        return setTimeout(fn, 1);
	      };
	      var bind = function (fn, thisArg) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          return fn.apply(thisArg, args);
	        };
	      };
	      var isArray = Array.isArray || function (value) {
	        return Object.prototype.toString.call(value) === '[object Array]';
	      };
	      function handle(deferred) {
	        var me = this;
	        if (this._state === null) {
	          this._deferreds.push(deferred);
	          return;
	        }
	        asap(function () {
	          var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
	          if (cb === null) {
	            (me._state ? deferred.resolve : deferred.reject)(me._value);
	            return;
	          }
	          var ret;
	          try {
	            ret = cb(me._value);
	          } catch (e) {
	            deferred.reject(e);
	            return;
	          }
	          deferred.resolve(ret);
	        });
	      }
	      function resolve(newValue) {
	        try {
	          if (newValue === this) {
	            throw new TypeError('A promise cannot be resolved with itself.');
	          }
	          if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	            var then = newValue.then;
	            if (typeof then === 'function') {
	              doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
	              return;
	            }
	          }
	          this._state = true;
	          this._value = newValue;
	          finale.call(this);
	        } catch (e) {
	          reject.call(this, e);
	        }
	      }
	      function reject(newValue) {
	        this._state = false;
	        this._value = newValue;
	        finale.call(this);
	      }
	      function finale() {
	        for (var _i = 0, _a = this._deferreds; _i < _a.length; _i++) {
	          var deferred = _a[_i];
	          handle.call(this, deferred);
	        }
	        this._deferreds = [];
	      }
	      function Handler(onFulfilled, onRejected, resolve, reject) {
	        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	        this.resolve = resolve;
	        this.reject = reject;
	      }
	      var doResolve = function (fn, onFulfilled, onRejected) {
	        var done = false;
	        try {
	          fn(function (value) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onFulfilled(value);
	          }, function (reason) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onRejected(reason);
	          });
	        } catch (ex) {
	          if (done) {
	            return;
	          }
	          done = true;
	          onRejected(ex);
	        }
	      };
	      Promise.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	      };
	      Promise.prototype.then = function (onFulfilled, onRejected) {
	        var me = this;
	        return new Promise(function (resolve, reject) {
	          handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
	        });
	      };
	      Promise.all = function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        var args = Array.prototype.slice.call(values.length === 1 && isArray(values[0]) ? values[0] : values);
	        return new Promise(function (resolve, reject) {
	          if (args.length === 0) {
	            return resolve([]);
	          }
	          var remaining = args.length;
	          var res = function (i, val) {
	            try {
	              if (val && (typeof val === 'object' || typeof val === 'function')) {
	                var then = val.then;
	                if (typeof then === 'function') {
	                  then.call(val, function (val) {
	                    res(i, val);
	                  }, reject);
	                  return;
	                }
	              }
	              args[i] = val;
	              if (--remaining === 0) {
	                resolve(args);
	              }
	            } catch (ex) {
	              reject(ex);
	            }
	          };
	          for (var i = 0; i < args.length; i++) {
	            res(i, args[i]);
	          }
	        });
	      };
	      Promise.resolve = function (value) {
	        if (value && typeof value === 'object' && value.constructor === Promise) {
	          return value;
	        }
	        return new Promise(function (resolve) {
	          resolve(value);
	        });
	      };
	      Promise.reject = function (reason) {
	        return new Promise(function (resolve, reject) {
	          reject(reason);
	        });
	      };
	      Promise.race = function (values) {
	        return new Promise(function (resolve, reject) {
	          for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
	            var value = values_1[_i];
	            value.then(resolve, reject);
	          }
	        });
	      };
	      return Promise;
	    };
	    var Promise$1 = window.Promise ? window.Promise : promise();
	
	    var blobToImage = function (blob) {
	      return new Promise$1(function (resolve, reject) {
	        var blobUrl = URL.createObjectURL(blob);
	        var image = new Image();
	        var removeListeners = function () {
	          image.removeEventListener('load', loaded);
	          image.removeEventListener('error', error);
	        };
	        var loaded = function () {
	          removeListeners();
	          resolve(image);
	        };
	        var error = function () {
	          removeListeners();
	          reject('Unable to load data of type ' + blob.type + ': ' + blobUrl);
	        };
	        image.addEventListener('load', loaded);
	        image.addEventListener('error', error);
	        image.src = blobUrl;
	        if (image.complete) {
	          setTimeout(loaded, 0);
	        }
	      });
	    };
	    var dataUriToBlobSync = function (uri) {
	      var data = uri.split(',');
	      var matches = /data:([^;]+)/.exec(data[0]);
	      if (!matches) {
	        return Optional.none();
	      }
	      var mimetype = matches[1];
	      var base64 = data[1];
	      var sliceSize = 1024;
	      var byteCharacters = atob(base64);
	      var bytesLength = byteCharacters.length;
	      var slicesCount = Math.ceil(bytesLength / sliceSize);
	      var byteArrays = new Array(slicesCount);
	      for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
	        var begin = sliceIndex * sliceSize;
	        var end = Math.min(begin + sliceSize, bytesLength);
	        var bytes = new Array(end - begin);
	        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
	          bytes[i] = byteCharacters[offset].charCodeAt(0);
	        }
	        byteArrays[sliceIndex] = new Uint8Array(bytes);
	      }
	      return Optional.some(new Blob(byteArrays, { type: mimetype }));
	    };
	    var dataUriToBlob = function (uri) {
	      return new Promise$1(function (resolve, reject) {
	        dataUriToBlobSync(uri).fold(function () {
	          reject('uri is not base64: ' + uri);
	        }, resolve);
	      });
	    };
	    var canvasToBlob = function (canvas, type, quality) {
	      type = type || 'image/png';
	      if (isFunction(HTMLCanvasElement.prototype.toBlob)) {
	        return new Promise$1(function (resolve, reject) {
	          canvas.toBlob(function (blob) {
	            if (blob) {
	              resolve(blob);
	            } else {
	              reject();
	            }
	          }, type, quality);
	        });
	      } else {
	        return dataUriToBlob(canvas.toDataURL(type, quality));
	      }
	    };
	    var canvasToDataURL = function (canvas, type, quality) {
	      type = type || 'image/png';
	      return canvas.toDataURL(type, quality);
	    };
	    var blobToCanvas = function (blob) {
	      return blobToImage(blob).then(function (image) {
	        revokeImageUrl(image);
	        var canvas = create$5(getWidth(image), getHeight(image));
	        var context = get2dContext(canvas);
	        context.drawImage(image, 0, 0);
	        return canvas;
	      });
	    };
	    var blobToDataUri = function (blob) {
	      return new Promise$1(function (resolve) {
	        var reader = new FileReader();
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	    var revokeImageUrl = function (image) {
	      URL.revokeObjectURL(image.src);
	    };
	
	    var create$6 = function (getCanvas, blob, uri) {
	      var initialType = blob.type;
	      var getType = constant(initialType);
	      var toBlob = function () {
	        return Promise$1.resolve(blob);
	      };
	      var toDataURL = constant(uri);
	      var toBase64 = function () {
	        return uri.split(',')[1];
	      };
	      var toAdjustedBlob = function (type, quality) {
	        return getCanvas.then(function (canvas) {
	          return canvasToBlob(canvas, type, quality);
	        });
	      };
	      var toAdjustedDataURL = function (type, quality) {
	        return getCanvas.then(function (canvas) {
	          return canvasToDataURL(canvas, type, quality);
	        });
	      };
	      var toAdjustedBase64 = function (type, quality) {
	        return toAdjustedDataURL(type, quality).then(function (dataurl) {
	          return dataurl.split(',')[1];
	        });
	      };
	      var toCanvas = function () {
	        return getCanvas.then(clone$1);
	      };
	      return {
	        getType: getType,
	        toBlob: toBlob,
	        toDataURL: toDataURL,
	        toBase64: toBase64,
	        toAdjustedBlob: toAdjustedBlob,
	        toAdjustedDataURL: toAdjustedDataURL,
	        toAdjustedBase64: toAdjustedBase64,
	        toCanvas: toCanvas
	      };
	    };
	    var fromBlob = function (blob) {
	      return blobToDataUri(blob).then(function (uri) {
	        return create$6(blobToCanvas(blob), blob, uri);
	      });
	    };
	    var fromCanvas = function (canvas, type) {
	      return canvasToBlob(canvas, type).then(function (blob) {
	        return create$6(Promise$1.resolve(canvas), blob, canvas.toDataURL());
	      });
	    };
	
	    var blobToImageResult = function (blob) {
	      return fromBlob(blob);
	    };
	
	    var clamp$1 = function (value, min, max) {
	      var parsedValue = typeof value === 'string' ? parseFloat(value) : value;
	      if (parsedValue > max) {
	        parsedValue = max;
	      } else if (parsedValue < min) {
	        parsedValue = min;
	      }
	      return parsedValue;
	    };
	    var identity$1 = function () {
	      return [
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ];
	    };
	    var DELTA_INDEX = [
	      0,
	      0.01,
	      0.02,
	      0.04,
	      0.05,
	      0.06,
	      0.07,
	      0.08,
	      0.1,
	      0.11,
	      0.12,
	      0.14,
	      0.15,
	      0.16,
	      0.17,
	      0.18,
	      0.2,
	      0.21,
	      0.22,
	      0.24,
	      0.25,
	      0.27,
	      0.28,
	      0.3,
	      0.32,
	      0.34,
	      0.36,
	      0.38,
	      0.4,
	      0.42,
	      0.44,
	      0.46,
	      0.48,
	      0.5,
	      0.53,
	      0.56,
	      0.59,
	      0.62,
	      0.65,
	      0.68,
	      0.71,
	      0.74,
	      0.77,
	      0.8,
	      0.83,
	      0.86,
	      0.89,
	      0.92,
	      0.95,
	      0.98,
	      1,
	      1.06,
	      1.12,
	      1.18,
	      1.24,
	      1.3,
	      1.36,
	      1.42,
	      1.48,
	      1.54,
	      1.6,
	      1.66,
	      1.72,
	      1.78,
	      1.84,
	      1.9,
	      1.96,
	      2,
	      2.12,
	      2.25,
	      2.37,
	      2.5,
	      2.62,
	      2.75,
	      2.87,
	      3,
	      3.2,
	      3.4,
	      3.6,
	      3.8,
	      4,
	      4.3,
	      4.7,
	      4.9,
	      5,
	      5.5,
	      6,
	      6.5,
	      6.8,
	      7,
	      7.3,
	      7.5,
	      7.8,
	      8,
	      8.4,
	      8.7,
	      9,
	      9.4,
	      9.6,
	      9.8,
	      10
	    ];
	    var multiply = function (matrix1, matrix2) {
	      var col = [];
	      var out = new Array(25);
	      var val;
	      for (var i = 0; i < 5; i++) {
	        for (var j = 0; j < 5; j++) {
	          col[j] = matrix2[j + i * 5];
	        }
	        for (var j = 0; j < 5; j++) {
	          val = 0;
	          for (var k = 0; k < 5; k++) {
	            val += matrix1[j + k * 5] * col[k];
	          }
	          out[j + i * 5] = val;
	        }
	      }
	      return out;
	    };
	    var adjustContrast = function (matrix, value) {
	      var x;
	      value = clamp$1(value, -1, 1);
	      value *= 100;
	      if (value < 0) {
	        x = 127 + value / 100 * 127;
	      } else {
	        x = value % 1;
	        if (x === 0) {
	          x = DELTA_INDEX[value];
	        } else {
	          x = DELTA_INDEX[Math.floor(value)] * (1 - x) + DELTA_INDEX[Math.floor(value) + 1] * x;
	        }
	        x = x * 127 + 127;
	      }
	      return multiply(matrix, [
	        x / 127,
	        0,
	        0,
	        0,
	        0.5 * (127 - x),
	        0,
	        x / 127,
	        0,
	        0,
	        0.5 * (127 - x),
	        0,
	        0,
	        x / 127,
	        0,
	        0.5 * (127 - x),
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ]);
	    };
	    var adjustBrightness = function (matrix, value) {
	      value = clamp$1(255 * value, -255, 255);
	      return multiply(matrix, [
	        1,
	        0,
	        0,
	        0,
	        value,
	        0,
	        1,
	        0,
	        0,
	        value,
	        0,
	        0,
	        1,
	        0,
	        value,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ]);
	    };
	    var adjustColors = function (matrix, adjustR, adjustG, adjustB) {
	      adjustR = clamp$1(adjustR, 0, 2);
	      adjustG = clamp$1(adjustG, 0, 2);
	      adjustB = clamp$1(adjustB, 0, 2);
	      return multiply(matrix, [
	        adjustR,
	        0,
	        0,
	        0,
	        0,
	        0,
	        adjustG,
	        0,
	        0,
	        0,
	        0,
	        0,
	        adjustB,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1,
	        0,
	        0,
	        0,
	        0,
	        0,
	        1
	      ]);
	    };
	
	    var colorFilter = function (ir, matrix) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyColorFilter(canvas, ir.getType(), matrix);
	      });
	    };
	    var applyColorFilter = function (canvas, type, matrix) {
	      var context = get2dContext(canvas);
	      var applyMatrix = function (pixelsData, m) {
	        var r, g, b, a;
	        var data = pixelsData.data, m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5], m6 = m[6], m7 = m[7], m8 = m[8], m9 = m[9], m10 = m[10], m11 = m[11], m12 = m[12], m13 = m[13], m14 = m[14], m15 = m[15], m16 = m[16], m17 = m[17], m18 = m[18], m19 = m[19];
	        for (var i = 0; i < data.length; i += 4) {
	          r = data[i];
	          g = data[i + 1];
	          b = data[i + 2];
	          a = data[i + 3];
	          data[i] = r * m0 + g * m1 + b * m2 + a * m3 + m4;
	          data[i + 1] = r * m5 + g * m6 + b * m7 + a * m8 + m9;
	          data[i + 2] = r * m10 + g * m11 + b * m12 + a * m13 + m14;
	          data[i + 3] = r * m15 + g * m16 + b * m17 + a * m18 + m19;
	        }
	        return pixelsData;
	      };
	      var pixels = applyMatrix(context.getImageData(0, 0, canvas.width, canvas.height), matrix);
	      context.putImageData(pixels, 0, 0);
	      return fromCanvas(canvas, type);
	    };
	    var convoluteFilter = function (ir, matrix) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyConvoluteFilter(canvas, ir.getType(), matrix);
	      });
	    };
	    var applyConvoluteFilter = function (canvas, type, matrix) {
	      var context = get2dContext(canvas);
	      var applyMatrix = function (pIn, pOut, aMatrix) {
	        var clamp = function (value, min, max) {
	          if (value > max) {
	            value = max;
	          } else if (value < min) {
	            value = min;
	          }
	          return value;
	        };
	        var side = Math.round(Math.sqrt(aMatrix.length));
	        var halfSide = Math.floor(side / 2);
	        var rgba = pIn.data;
	        var drgba = pOut.data;
	        var w = pIn.width;
	        var h = pIn.height;
	        for (var y = 0; y < h; y++) {
	          for (var x = 0; x < w; x++) {
	            var r = 0;
	            var g = 0;
	            var b = 0;
	            for (var cy = 0; cy < side; cy++) {
	              for (var cx = 0; cx < side; cx++) {
	                var scx = clamp(x + cx - halfSide, 0, w - 1);
	                var scy = clamp(y + cy - halfSide, 0, h - 1);
	                var innerOffset = (scy * w + scx) * 4;
	                var wt = aMatrix[cy * side + cx];
	                r += rgba[innerOffset] * wt;
	                g += rgba[innerOffset + 1] * wt;
	                b += rgba[innerOffset + 2] * wt;
	              }
	            }
	            var offset = (y * w + x) * 4;
	            drgba[offset] = clamp(r, 0, 255);
	            drgba[offset + 1] = clamp(g, 0, 255);
	            drgba[offset + 2] = clamp(b, 0, 255);
	          }
	        }
	        return pOut;
	      };
	      var pixelsIn = context.getImageData(0, 0, canvas.width, canvas.height);
	      var pixelsOut = context.getImageData(0, 0, canvas.width, canvas.height);
	      pixelsOut = applyMatrix(pixelsIn, pixelsOut, matrix);
	      context.putImageData(pixelsOut, 0, 0);
	      return fromCanvas(canvas, type);
	    };
	    var functionColorFilter = function (colorFn) {
	      var filterImpl = function (canvas, type, value) {
	        var context = get2dContext(canvas);
	        var lookup = new Array(256);
	        var applyLookup = function (pixelsData, lookupData) {
	          var data = pixelsData.data;
	          for (var i = 0; i < data.length; i += 4) {
	            data[i] = lookupData[data[i]];
	            data[i + 1] = lookupData[data[i + 1]];
	            data[i + 2] = lookupData[data[i + 2]];
	          }
	          return pixelsData;
	        };
	        for (var i = 0; i < lookup.length; i++) {
	          lookup[i] = colorFn(i, value);
	        }
	        var pixels = applyLookup(context.getImageData(0, 0, canvas.width, canvas.height), lookup);
	        context.putImageData(pixels, 0, 0);
	        return fromCanvas(canvas, type);
	      };
	      return function (ir, value) {
	        return ir.toCanvas().then(function (canvas) {
	          return filterImpl(canvas, ir.getType(), value);
	        });
	      };
	    };
	    var complexAdjustableColorFilter = function (matrixAdjustFn) {
	      return function (ir, adjust) {
	        return colorFilter(ir, matrixAdjustFn(identity$1(), adjust));
	      };
	    };
	    var basicColorFilter = function (matrix) {
	      return function (ir) {
	        return colorFilter(ir, matrix);
	      };
	    };
	    var basicConvolutionFilter = function (kernel) {
	      return function (ir) {
	        return convoluteFilter(ir, kernel);
	      };
	    };
	    var invert = basicColorFilter([
	      -1,
	      0,
	      0,
	      0,
	      255,
	      0,
	      -1,
	      0,
	      0,
	      255,
	      0,
	      0,
	      -1,
	      0,
	      255,
	      0,
	      0,
	      0,
	      1,
	      0,
	      0,
	      0,
	      0,
	      0,
	      1
	    ]);
	    var brightness = complexAdjustableColorFilter(adjustBrightness);
	    var contrast = complexAdjustableColorFilter(adjustContrast);
	    var colorize = function (ir, adjustR, adjustG, adjustB) {
	      return colorFilter(ir, adjustColors(identity$1(), adjustR, adjustG, adjustB));
	    };
	    var sharpen = basicConvolutionFilter([
	      0,
	      -1,
	      0,
	      -1,
	      5,
	      -1,
	      0,
	      -1,
	      0
	    ]);
	    var gamma = functionColorFilter(function (color, value) {
	      return Math.pow(color / 255, 1 - value) * 255;
	    });
	
	    var scale = function (image, dW, dH) {
	      var sW = getWidth(image);
	      var sH = getHeight(image);
	      var wRatio = dW / sW;
	      var hRatio = dH / sH;
	      var scaleCapped = false;
	      if (wRatio < 0.5 || wRatio > 2) {
	        wRatio = wRatio < 0.5 ? 0.5 : 2;
	        scaleCapped = true;
	      }
	      if (hRatio < 0.5 || hRatio > 2) {
	        hRatio = hRatio < 0.5 ? 0.5 : 2;
	        scaleCapped = true;
	      }
	      var scaled = _scale(image, wRatio, hRatio);
	      return !scaleCapped ? scaled : scaled.then(function (tCanvas) {
	        return scale(tCanvas, dW, dH);
	      });
	    };
	    var _scale = function (image, wRatio, hRatio) {
	      return new Promise$1(function (resolve) {
	        var sW = getWidth(image);
	        var sH = getHeight(image);
	        var dW = Math.floor(sW * wRatio);
	        var dH = Math.floor(sH * hRatio);
	        var canvas = create$5(dW, dH);
	        var context = get2dContext(canvas);
	        context.drawImage(image, 0, 0, sW, sH, 0, 0, dW, dH);
	        resolve(canvas);
	      });
	    };
	
	    var ceilWithPrecision = function (num, precision) {
	      if (precision === void 0) {
	        precision = 2;
	      }
	      var mul = Math.pow(10, precision);
	      var upper = Math.round(num * mul);
	      return Math.ceil(upper / mul);
	    };
	    var rotate = function (ir, angle) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyRotate(canvas, ir.getType(), angle);
	      });
	    };
	    var applyRotate = function (image, type, angle) {
	      var degrees = angle < 0 ? 360 + angle : angle;
	      var rad = degrees * Math.PI / 180;
	      var width = image.width;
	      var height = image.height;
	      var sin = Math.sin(rad);
	      var cos = Math.cos(rad);
	      var newWidth = ceilWithPrecision(Math.abs(width * cos) + Math.abs(height * sin));
	      var newHeight = ceilWithPrecision(Math.abs(width * sin) + Math.abs(height * cos));
	      var canvas = create$5(newWidth, newHeight);
	      var context = get2dContext(canvas);
	      context.translate(newWidth / 2, newHeight / 2);
	      context.rotate(rad);
	      context.drawImage(image, -width / 2, -height / 2);
	      return fromCanvas(canvas, type);
	    };
	    var flip = function (ir, axis) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyFlip(canvas, ir.getType(), axis);
	      });
	    };
	    var applyFlip = function (image, type, axis) {
	      var canvas = create$5(image.width, image.height);
	      var context = get2dContext(canvas);
	      if (axis === 'v') {
	        context.scale(1, -1);
	        context.drawImage(image, 0, -canvas.height);
	      } else {
	        context.scale(-1, 1);
	        context.drawImage(image, -canvas.width, 0);
	      }
	      return fromCanvas(canvas, type);
	    };
	    var crop = function (ir, x, y, w, h) {
	      return ir.toCanvas().then(function (canvas) {
	        return applyCrop(canvas, ir.getType(), x, y, w, h);
	      });
	    };
	    var applyCrop = function (image, type, x, y, w, h) {
	      var canvas = create$5(w, h);
	      var context = get2dContext(canvas);
	      context.drawImage(image, -x, -y);
	      return fromCanvas(canvas, type);
	    };
	    var resize$1 = function (ir, w, h) {
	      return ir.toCanvas().then(function (canvas) {
	        return scale(canvas, w, h).then(function (newCanvas) {
	          return fromCanvas(newCanvas, ir.getType());
	        });
	      });
	    };
	
	    var invert$1 = function (ir) {
	      return invert(ir);
	    };
	    var sharpen$1 = function (ir) {
	      return sharpen(ir);
	    };
	    var gamma$1 = function (ir, value) {
	      return gamma(ir, value);
	    };
	    var colorize$1 = function (ir, adjustR, adjustG, adjustB) {
	      return colorize(ir, adjustR, adjustG, adjustB);
	    };
	    var brightness$1 = function (ir, adjust) {
	      return brightness(ir, adjust);
	    };
	    var contrast$1 = function (ir, adjust) {
	      return contrast(ir, adjust);
	    };
	    var flip$1 = function (ir, axis) {
	      return flip(ir, axis);
	    };
	    var crop$1 = function (ir, x, y, w, h) {
	      return crop(ir, x, y, w, h);
	    };
	    var resize$2 = function (ir, w, h) {
	      return resize$1(ir, w, h);
	    };
	    var rotate$1 = function (ir, angle) {
	      return rotate(ir, angle);
	    };
	
	    var renderIcon$1 = function (iconHtml, behaviours) {
	      return __assign({
	        dom: {
	          tag: 'span',
	          innerHtml: iconHtml,
	          classes: [
	            'tox-icon',
	            'tox-tbtn__icon-wrap'
	          ]
	        }
	      }, behaviours);
	    };
	    var renderIconFromPack = function (iconName, iconsProvider) {
	      return renderIcon$1(get$e(iconName, iconsProvider), {});
	    };
	    var renderReplacableIconFromPack = function (iconName, iconsProvider) {
	      return renderIcon$1(get$e(iconName, iconsProvider), { behaviours: derive$1([Replacing.config({})]) });
	    };
	    var renderLabel$1 = function (text, prefix, providersBackstage) {
	      return {
	        dom: {
	          tag: 'span',
	          innerHtml: providersBackstage.translate(text),
	          classes: [prefix + '__select-label']
	        },
	        behaviours: derive$1([Replacing.config({})])
	      };
	    };
	
	    var _a$1;
	    var internalToolbarButtonExecute = generate$1('toolbar.button.execute');
	    var onToolbarButtonExecute = function (info) {
	      return runOnExecute(function (comp, _simulatedEvent) {
	        runWithApi(info, comp)(function (itemApi) {
	          emitWith(comp, internalToolbarButtonExecute, { buttonApi: itemApi });
	          info.onAction(itemApi);
	        });
	      });
	    };
	    var toolbarButtonEventOrder = (_a$1 = {}, _a$1[execute()] = [
	      'disabling',
	      'alloy.base.behaviour',
	      'toggling',
	      'toolbar-button-events'
	    ], _a$1);
	
	    var updateMenuText = generate$1('update-menu-text');
	    var updateMenuIcon = generate$1('update-menu-icon');
	    var renderCommonDropdown = function (spec, prefix, sharedBackstage) {
	      var editorOffCell = Cell(noop);
	      var optMemDisplayText = spec.text.map(function (text) {
	        return record(renderLabel$1(text, prefix, sharedBackstage.providers));
	      });
	      var optMemDisplayIcon = spec.icon.map(function (iconName) {
	        return record(renderReplacableIconFromPack(iconName, sharedBackstage.providers.icons));
	      });
	      var onLeftOrRightInMenu = function (comp, se) {
	        var dropdown = Representing.getValue(comp);
	        Focusing.focus(dropdown);
	        emitWith(dropdown, 'keydown', { raw: se.event.raw });
	        Dropdown.close(dropdown);
	        return Optional.some(true);
	      };
	      var role = spec.role.fold(function () {
	        return {};
	      }, function (role) {
	        return { role: role };
	      });
	      var tooltipAttributes = spec.tooltip.fold(function () {
	        return {};
	      }, function (tooltip) {
	        var translatedTooltip = sharedBackstage.providers.translate(tooltip);
	        return {
	          'title': translatedTooltip,
	          'aria-label': translatedTooltip
	        };
	      });
	      var memDropdown = record(Dropdown.sketch(__assign(__assign(__assign({}, spec.uid ? { uid: spec.uid } : {}), role), {
	        dom: {
	          tag: 'button',
	          classes: [
	            prefix,
	            prefix + '--select'
	          ].concat(map(spec.classes, function (c) {
	            return prefix + '--' + c;
	          })),
	          attributes: __assign({}, tooltipAttributes)
	        },
	        components: componentRenderPipeline([
	          optMemDisplayIcon.map(function (mem) {
	            return mem.asSpec();
	          }),
	          optMemDisplayText.map(function (mem) {
	            return mem.asSpec();
	          }),
	          Optional.some({
	            dom: {
	              tag: 'div',
	              classes: [prefix + '__select-chevron'],
	              innerHtml: get$e('chevron-down', sharedBackstage.providers.icons)
	            }
	          })
	        ]),
	        matchWidth: true,
	        useMinWidth: true,
	        dropdownBehaviours: derive$1(__spreadArrays(spec.dropdownBehaviours, [
	          DisablingConfigs.button(function () {
	            return spec.disabled || sharedBackstage.providers.isDisabled();
	          }),
	          receivingConfig(),
	          Unselecting.config({}),
	          Replacing.config({}),
	          config('dropdown-events', [
	            onControlAttached(spec, editorOffCell),
	            onControlDetached(spec, editorOffCell)
	          ]),
	          config('menubutton-update-display-text', [
	            run(updateMenuText, function (comp, se) {
	              optMemDisplayText.bind(function (mem) {
	                return mem.getOpt(comp);
	              }).each(function (displayText) {
	                Replacing.set(displayText, [text(sharedBackstage.providers.translate(se.event.text))]);
	              });
	            }),
	            run(updateMenuIcon, function (comp, se) {
	              optMemDisplayIcon.bind(function (mem) {
	                return mem.getOpt(comp);
	              }).each(function (displayIcon) {
	                Replacing.set(displayIcon, [renderReplacableIconFromPack(se.event.icon, sharedBackstage.providers.icons)]);
	              });
	            })
	          ])
	        ])),
	        eventOrder: deepMerge(toolbarButtonEventOrder, {
	          mousedown: [
	            'focusing',
	            'alloy.base.behaviour',
	            'item-type-events',
	            'normal-dropdown-events'
	          ]
	        }),
	        sandboxBehaviours: derive$1([Keying.config({
	            mode: 'special',
	            onLeft: onLeftOrRightInMenu,
	            onRight: onLeftOrRightInMenu
	          })]),
	        lazySink: sharedBackstage.getSink,
	        toggleClass: prefix + '--active',
	        parts: { menu: part(false, spec.columns, spec.presets) },
	        fetch: function (comp) {
	          return Future.nu(curry(spec.fetch, comp));
	        }
	      })));
	      return memDropdown.asSpec();
	    };
	
	    var isMenuItemReference = function (item) {
	      return isString(item);
	    };
	    var isSeparator = function (item) {
	      return item.type === 'separator';
	    };
	    var isExpandingMenuItem = function (item) {
	      return has(item, 'getSubmenuItems');
	    };
	    var separator$1 = { type: 'separator' };
	    var unwrapReferences = function (items, menuItems) {
	      var realItems = foldl(items, function (acc, item) {
	        if (isMenuItemReference(item)) {
	          if (item === '') {
	            return acc;
	          } else if (item === '|') {
	            return acc.length > 0 && !isSeparator(acc[acc.length - 1]) ? acc.concat([separator$1]) : acc;
	          } else if (has(menuItems, item.toLowerCase())) {
	            return acc.concat([menuItems[item.toLowerCase()]]);
	          } else {
	            return acc;
	          }
	        } else {
	          return acc.concat([item]);
	        }
	      }, []);
	      if (realItems.length > 0 && isSeparator(realItems[realItems.length - 1])) {
	        realItems.pop();
	      }
	      return realItems;
	    };
	    var getFromExpandingItem = function (item, menuItems) {
	      var submenuItems = item.getSubmenuItems();
	      var rest = expand(submenuItems, menuItems);
	      var newMenus = deepMerge(rest.menus, wrap$1(item.value, rest.items));
	      var newExpansions = deepMerge(rest.expansions, wrap$1(item.value, item.value));
	      return {
	        item: item,
	        menus: newMenus,
	        expansions: newExpansions
	      };
	    };
	    var getFromItem = function (item, menuItems) {
	      return isExpandingMenuItem(item) ? getFromExpandingItem(item, menuItems) : {
	        item: item,
	        menus: {},
	        expansions: {}
	      };
	    };
	    var generateValueIfRequired = function (item) {
	      if (isSeparator(item)) {
	        return item;
	      } else {
	        var itemValue = get$1(item, 'value').getOrThunk(function () {
	          return generate$1('generated-menu-item');
	        });
	        return deepMerge({ value: itemValue }, item);
	      }
	    };
	    var expand = function (items, menuItems) {
	      var realItems = unwrapReferences(isString(items) ? items.split(' ') : items, menuItems);
	      return foldr(realItems, function (acc, item) {
	        var itemWithValue = generateValueIfRequired(item);
	        var newData = getFromItem(itemWithValue, menuItems);
	        return {
	          menus: deepMerge(acc.menus, newData.menus),
	          items: [newData.item].concat(acc.items),
	          expansions: deepMerge(acc.expansions, newData.expansions)
	        };
	      }, {
	        menus: {},
	        expansions: {},
	        items: []
	      });
	    };
	
	    var build$2 = function (items, itemResponse, backstage, isHorizontalMenu) {
	      var primary = generate$1('primary-menu');
	      var data = expand(items, backstage.shared.providers.menuItems());
	      if (data.items.length === 0) {
	        return Optional.none();
	      }
	      var mainMenu = createPartialMenu(primary, data.items, itemResponse, backstage, isHorizontalMenu);
	      var submenus = map$2(data.menus, function (menuItems, menuName) {
	        return createPartialMenu(menuName, menuItems, itemResponse, backstage, false);
	      });
	      var menus = deepMerge(submenus, wrap$1(primary, mainMenu));
	      return Optional.from(tieredMenu.tieredData(primary, menus, data.expansions));
	    };
	
	    var getMenuButtonApi = function (component) {
	      return {
	        isDisabled: function () {
	          return Disabling.isDisabled(component);
	        },
	        setDisabled: function (state) {
	          return Disabling.set(component, state);
	        },
	        setActive: function (state) {
	          var elm = component.element;
	          if (state) {
	            add$2(elm, 'tox-tbtn--enabled');
	            set$1(elm, 'aria-pressed', true);
	          } else {
	            remove$4(elm, 'tox-tbtn--enabled');
	            remove$1(elm, 'aria-pressed');
	          }
	        },
	        isActive: function () {
	          return has$2(component.element, 'tox-tbtn--enabled');
	        }
	      };
	    };
	    var renderMenuButton = function (spec, prefix, backstage, role) {
	      return renderCommonDropdown({
	        text: spec.text,
	        icon: spec.icon,
	        tooltip: spec.tooltip,
	        role: role,
	        fetch: function (_comp, callback) {
	          spec.fetch(function (items) {
	            callback(build$2(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false));
	          });
	        },
	        onSetup: spec.onSetup,
	        getApi: getMenuButtonApi,
	        columns: 1,
	        presets: 'normal',
	        classes: [],
	        dropdownBehaviours: [Tabstopping.config({})]
	      }, prefix, backstage.shared);
	    };
	    var getFetch$1 = function (items, getButton, backstage) {
	      var getMenuItemAction = function (item) {
	        return function (api) {
	          var newValue = !api.isActive();
	          api.setActive(newValue);
	          item.storage.set(newValue);
	          backstage.shared.getSink().each(function (sink) {
	            getButton().getOpt(sink).each(function (orig) {
	              focus$1(orig.element);
	              emitWith(orig, formActionEvent, {
	                name: item.name,
	                value: item.storage.get()
	              });
	            });
	          });
	        };
	      };
	      var getMenuItemSetup = function (item) {
	        return function (api) {
	          api.setActive(item.storage.get());
	        };
	      };
	      return function (success) {
	        success(map(items, function (item) {
	          var text = item.text.fold(function () {
	            return {};
	          }, function (text) {
	            return { text: text };
	          });
	          return __assign(__assign({
	            type: item.type,
	            active: false
	          }, text), {
	            onAction: getMenuItemAction(item),
	            onSetup: getMenuItemSetup(item)
	          });
	        }));
	      };
	    };
	
	    var renderCommonSpec = function (spec, actionOpt, extraBehaviours, dom, components, providersBackstage) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      var action = actionOpt.fold(function () {
	        return {};
	      }, function (action) {
	        return { action: action };
	      });
	      var common = __assign({
	        buttonBehaviours: derive$1([
	          DisablingConfigs.button(function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          }),
	          receivingConfig(),
	          Tabstopping.config({}),
	          config('button press', [
	            preventDefault('click'),
	            preventDefault('mousedown')
	          ])
	        ].concat(extraBehaviours)),
	        eventOrder: {
	          click: [
	            'button press',
	            'alloy.base.behaviour'
	          ],
	          mousedown: [
	            'button press',
	            'alloy.base.behaviour'
	          ]
	        }
	      }, action);
	      var domFinal = deepMerge(common, { dom: dom });
	      return deepMerge(domFinal, { components: components });
	    };
	    var renderIconButtonSpec = function (spec, action, providersBackstage, extraBehaviours) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      var tooltipAttributes = spec.tooltip.map(function (tooltip) {
	        return {
	          'aria-label': providersBackstage.translate(tooltip),
	          'title': providersBackstage.translate(tooltip)
	        };
	      }).getOr({});
	      var dom = {
	        tag: 'button',
	        classes: ['tox-tbtn'],
	        attributes: tooltipAttributes
	      };
	      var icon = spec.icon.map(function (iconName) {
	        return renderIconFromPack(iconName, providersBackstage.icons);
	      });
	      var components = componentRenderPipeline([icon]);
	      return renderCommonSpec(spec, action, extraBehaviours, dom, components, providersBackstage);
	    };
	    var renderIconButton = function (spec, action, providersBackstage, extraBehaviours) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      var iconButtonSpec = renderIconButtonSpec(spec, Optional.some(action), providersBackstage, extraBehaviours);
	      return Button.sketch(iconButtonSpec);
	    };
	    var renderButtonSpec = function (spec, action, providersBackstage, extraBehaviours, extraClasses) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      if (extraClasses === void 0) {
	        extraClasses = [];
	      }
	      var translatedText = providersBackstage.translate(spec.text);
	      var icon = spec.icon ? spec.icon.map(function (iconName) {
	        return renderIconFromPack(iconName, providersBackstage.icons);
	      }) : Optional.none();
	      var components = icon.isSome() ? componentRenderPipeline([icon]) : [];
	      var innerHtml = icon.isSome() ? {} : { innerHtml: translatedText };
	      var classes = __spreadArrays(!spec.primary && !spec.borderless ? [
	        'tox-button',
	        'tox-button--secondary'
	      ] : ['tox-button'], icon.isSome() ? ['tox-button--icon'] : [], spec.borderless ? ['tox-button--naked'] : [], extraClasses);
	      var dom = __assign(__assign({
	        tag: 'button',
	        classes: classes
	      }, innerHtml), { attributes: { title: translatedText } });
	      return renderCommonSpec(spec, action, extraBehaviours, dom, components, providersBackstage);
	    };
	    var renderButton = function (spec, action, providersBackstage, extraBehaviours, extraClasses) {
	      if (extraBehaviours === void 0) {
	        extraBehaviours = [];
	      }
	      if (extraClasses === void 0) {
	        extraClasses = [];
	      }
	      var buttonSpec = renderButtonSpec(spec, Optional.some(action), providersBackstage, extraBehaviours, extraClasses);
	      return Button.sketch(buttonSpec);
	    };
	    var getAction = function (name, buttonType) {
	      return function (comp) {
	        if (buttonType === 'custom') {
	          emitWith(comp, formActionEvent, {
	            name: name,
	            value: {}
	          });
	        } else if (buttonType === 'submit') {
	          emit(comp, formSubmitEvent);
	        } else if (buttonType === 'cancel') {
	          emit(comp, formCancelEvent);
	        } else {
	          console.error('Unknown button type: ', buttonType);
	        }
	      };
	    };
	    var isMenuFooterButtonSpec = function (spec, buttonType) {
	      return buttonType === 'menu';
	    };
	    var isNormalFooterButtonSpec = function (spec, buttonType) {
	      return buttonType === 'custom' || buttonType === 'cancel' || buttonType === 'submit';
	    };
	    var renderFooterButton = function (spec, buttonType, backstage) {
	      if (isMenuFooterButtonSpec(spec, buttonType)) {
	        var getButton = function () {
	          return memButton_1;
	        };
	        var menuButtonSpec = spec;
	        var fixedSpec = __assign(__assign({}, spec), {
	          onSetup: function (api) {
	            api.setDisabled(spec.disabled);
	            return noop;
	          },
	          fetch: getFetch$1(menuButtonSpec.items, getButton, backstage)
	        });
	        var memButton_1 = record(renderMenuButton(fixedSpec, 'tox-tbtn', backstage, Optional.none()));
	        return memButton_1.asSpec();
	      } else if (isNormalFooterButtonSpec(spec, buttonType)) {
	        var action = getAction(spec.name, buttonType);
	        var buttonSpec = __assign(__assign({}, spec), { borderless: false });
	        return renderButton(buttonSpec, action, backstage.shared.providers, []);
	      } else {
	        console.error('Unknown footer button type: ', buttonType);
	      }
	    };
	    var renderDialogButton = function (spec, providersBackstage) {
	      var action = getAction(spec.name, 'custom');
	      return renderFormField(Optional.none(), FormField.parts.field(__assign({ factory: Button }, renderButtonSpec(spec, Optional.some(action), providersBackstage, [
	        RepresentingConfigs.memory(''),
	        ComposingConfigs.self()
	      ]))));
	    };
	
	    var schema$i = constant([
	      defaulted$1('field1Name', 'field1'),
	      defaulted$1('field2Name', 'field2'),
	      onStrictHandler('onLockedChange'),
	      markers(['lockClass']),
	      defaulted$1('locked', false),
	      SketchBehaviours.field('coupledFieldBehaviours', [
	        Composing,
	        Representing
	      ])
	    ]);
	    var getField = function (comp, detail, partName) {
	      return getPart(comp, detail, partName).bind(Composing.getCurrent);
	    };
	    var coupledPart = function (selfName, otherName) {
	      return required({
	        factory: FormField,
	        name: selfName,
	        overrides: function (detail) {
	          return {
	            fieldBehaviours: derive$1([config('coupled-input-behaviour', [run(input(), function (me) {
	                  getField(me, detail, otherName).each(function (other) {
	                    getPart(me, detail, 'lock').each(function (lock) {
	                      if (Toggling.isOn(lock)) {
	                        detail.onLockedChange(me, other, lock);
	                      }
	                    });
	                  });
	                })])])
	          };
	        }
	      });
	    };
	    var parts$5 = constant([
	      coupledPart('field1', 'field2'),
	      coupledPart('field2', 'field1'),
	      required({
	        factory: Button,
	        schema: [strict$1('dom')],
	        name: 'lock',
	        overrides: function (detail) {
	          return {
	            buttonBehaviours: derive$1([Toggling.config({
	                selected: detail.locked,
	                toggleClass: detail.markers.lockClass,
	                aria: { mode: 'pressed' }
	              })])
	          };
	        }
	      })
	    ]);
	
	    var factory$7 = function (detail, components, _spec, _externals) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: SketchBehaviours.augment(detail.coupledFieldBehaviours, [
	          Composing.config({ find: Optional.some }),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (comp) {
	                var _a;
	                var parts = getPartsOrDie(comp, detail, [
	                  'field1',
	                  'field2'
	                ]);
	                return _a = {}, _a[detail.field1Name] = Representing.getValue(parts.field1()), _a[detail.field2Name] = Representing.getValue(parts.field2()), _a;
	              },
	              setValue: function (comp, value) {
	                var parts = getPartsOrDie(comp, detail, [
	                  'field1',
	                  'field2'
	                ]);
	                if (hasNonNullableKey(value, detail.field1Name)) {
	                  Representing.setValue(parts.field1(), value[detail.field1Name]);
	                }
	                if (hasNonNullableKey(value, detail.field2Name)) {
	                  Representing.setValue(parts.field2(), value[detail.field2Name]);
	                }
	              }
	            }
	          })
	        ]),
	        apis: {
	          getField1: function (component) {
	            return getPart(component, detail, 'field1');
	          },
	          getField2: function (component) {
	            return getPart(component, detail, 'field2');
	          },
	          getLock: function (component) {
	            return getPart(component, detail, 'lock');
	          }
	        }
	      };
	    };
	    var FormCoupledInputs = composite$1({
	      name: 'FormCoupledInputs',
	      configFields: schema$i(),
	      partFields: parts$5(),
	      factory: factory$7,
	      apis: {
	        getField1: function (apis, component) {
	          return apis.getField1(component);
	        },
	        getField2: function (apis, component) {
	          return apis.getField2(component);
	        },
	        getLock: function (apis, component) {
	          return apis.getLock(component);
	        }
	      }
	    });
	
	    var formatSize = function (size) {
	      var unitDec = {
	        '': 0,
	        'px': 0,
	        'pt': 1,
	        'mm': 1,
	        'pc': 2,
	        'ex': 2,
	        'em': 2,
	        'ch': 2,
	        'rem': 2,
	        'cm': 3,
	        'in': 4,
	        '%': 4
	      };
	      var maxDecimal = function (unit) {
	        return unit in unitDec ? unitDec[unit] : 1;
	      };
	      var numText = size.value.toFixed(maxDecimal(size.unit));
	      if (numText.indexOf('.') !== -1) {
	        numText = numText.replace(/\.?0*$/, '');
	      }
	      return numText + size.unit;
	    };
	    var parseSize = function (sizeText) {
	      var numPattern = /^\s*(\d+(?:\.\d+)?)\s*(|cm|mm|in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%)\s*$/;
	      var match = numPattern.exec(sizeText);
	      if (match !== null) {
	        var value = parseFloat(match[1]);
	        var unit = match[2];
	        return Result.value({
	          value: value,
	          unit: unit
	        });
	      } else {
	        return Result.error(sizeText);
	      }
	    };
	    var convertUnit = function (size, unit) {
	      var inInch = {
	        '': 96,
	        'px': 96,
	        'pt': 72,
	        'cm': 2.54,
	        'pc': 12,
	        'mm': 25.4,
	        'in': 1
	      };
	      var supported = function (u) {
	        return Object.prototype.hasOwnProperty.call(inInch, u);
	      };
	      if (size.unit === unit) {
	        return Optional.some(size.value);
	      } else if (supported(size.unit) && supported(unit)) {
	        if (inInch[size.unit] === inInch[unit]) {
	          return Optional.some(size.value);
	        } else {
	          return Optional.some(size.value / inInch[size.unit] * inInch[unit]);
	        }
	      } else {
	        return Optional.none();
	      }
	    };
	    var noSizeConversion = function (_input) {
	      return Optional.none();
	    };
	    var ratioSizeConversion = function (scale, unit) {
	      return function (size) {
	        return convertUnit(size, unit).map(function (value) {
	          return {
	            value: value * scale,
	            unit: unit
	          };
	        });
	      };
	    };
	    var makeRatioConverter = function (currentFieldText, otherFieldText) {
	      var cValue = parseSize(currentFieldText).toOptional();
	      var oValue = parseSize(otherFieldText).toOptional();
	      return lift2(cValue, oValue, function (cSize, oSize) {
	        return convertUnit(cSize, oSize.unit).map(function (val) {
	          return oSize.value / val;
	        }).map(function (r) {
	          return ratioSizeConversion(r, oSize.unit);
	        }).getOr(noSizeConversion);
	      }).getOr(noSizeConversion);
	    };
	
	    var renderSizeInput = function (spec, providersBackstage) {
	      var converter = noSizeConversion;
	      var ratioEvent = generate$1('ratio-event');
	      var pLock = FormCoupledInputs.parts.lock({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-lock',
	            'tox-button',
	            'tox-button--naked',
	            'tox-button--icon'
	          ],
	          attributes: { title: providersBackstage.translate(spec.label.getOr('Constrain proportions')) }
	        },
	        components: [
	          {
	            dom: {
	              tag: 'span',
	              classes: [
	                'tox-icon',
	                'tox-lock-icon__lock'
	              ],
	              innerHtml: get$e('lock', providersBackstage.icons)
	            }
	          },
	          {
	            dom: {
	              tag: 'span',
	              classes: [
	                'tox-icon',
	                'tox-lock-icon__unlock'
	              ],
	              innerHtml: get$e('unlock', providersBackstage.icons)
	            }
	          }
	        ],
	        buttonBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            }
	          }),
	          receivingConfig(),
	          Tabstopping.config({})
	        ])
	      });
	      var formGroup = function (components) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__group']
	          },
	          components: components
	        };
	      };
	      var getFieldPart = function (isField1) {
	        return FormField.parts.field({
	          factory: Input,
	          inputClasses: ['tox-textfield'],
	          inputBehaviours: derive$1([
	            Disabling.config({
	              disabled: function () {
	                return spec.disabled || providersBackstage.isDisabled();
	              }
	            }),
	            receivingConfig(),
	            Tabstopping.config({}),
	            config('size-input-events', [
	              run(focusin(), function (component, _simulatedEvent) {
	                emitWith(component, ratioEvent, { isField1: isField1 });
	              }),
	              run(change(), function (component, _simulatedEvent) {
	                emitWith(component, formChangeEvent, { name: spec.name });
	              })
	            ])
	          ]),
	          selectOnFocus: false
	        });
	      };
	      var getLabel = function (label) {
	        return {
	          dom: {
	            tag: 'label',
	            classes: ['tox-label'],
	            innerHtml: providersBackstage.translate(label)
	          }
	        };
	      };
	      var widthField = FormCoupledInputs.parts.field1(formGroup([
	        FormField.parts.label(getLabel('Width')),
	        getFieldPart(true)
	      ]));
	      var heightField = FormCoupledInputs.parts.field2(formGroup([
	        FormField.parts.label(getLabel('Height')),
	        getFieldPart(false)
	      ]));
	      return FormCoupledInputs.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-form__controls-h-stack']
	            },
	            components: [
	              widthField,
	              heightField,
	              formGroup([
	                getLabel('&nbsp;'),
	                pLock
	              ])
	            ]
	          }],
	        field1Name: 'width',
	        field2Name: 'height',
	        locked: true,
	        markers: { lockClass: 'tox-locked' },
	        onLockedChange: function (current, other, _lock) {
	          parseSize(Representing.getValue(current)).each(function (size) {
	            converter(size).each(function (newSize) {
	              Representing.setValue(other, formatSize(newSize));
	            });
	          });
	        },
	        coupledFieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            },
	            onDisabled: function (comp) {
	              FormCoupledInputs.getField1(comp).bind(FormField.getField).each(Disabling.disable);
	              FormCoupledInputs.getField2(comp).bind(FormField.getField).each(Disabling.disable);
	              FormCoupledInputs.getLock(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormCoupledInputs.getField1(comp).bind(FormField.getField).each(Disabling.enable);
	              FormCoupledInputs.getField2(comp).bind(FormField.getField).each(Disabling.enable);
	              FormCoupledInputs.getLock(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig(),
	          config('size-input-events2', [run(ratioEvent, function (component, simulatedEvent) {
	              var isField1 = simulatedEvent.event.isField1;
	              var optCurrent = isField1 ? FormCoupledInputs.getField1(component) : FormCoupledInputs.getField2(component);
	              var optOther = isField1 ? FormCoupledInputs.getField2(component) : FormCoupledInputs.getField1(component);
	              var value1 = optCurrent.map(Representing.getValue).getOr('');
	              var value2 = optOther.map(Representing.getValue).getOr('');
	              converter = makeRatioConverter(value1, value2);
	            })])
	        ])
	      });
	    };
	
	    var undo = constant(generate$1('undo'));
	    var redo = constant(generate$1('redo'));
	    var zoom = constant(generate$1('zoom'));
	    var back = constant(generate$1('back'));
	    var apply = constant(generate$1('apply'));
	    var swap = constant(generate$1('swap'));
	    var transform = constant(generate$1('transform'));
	    var tempTransform = constant(generate$1('temp-transform'));
	    var transformApply = constant(generate$1('transform-apply'));
	    var internal = {
	      undo: undo,
	      redo: redo,
	      zoom: zoom,
	      back: back,
	      apply: apply,
	      swap: swap,
	      transform: transform,
	      tempTransform: tempTransform,
	      transformApply: transformApply
	    };
	    var saveState = constant('save-state');
	    var disable$1 = constant('disable');
	    var enable$1 = constant('enable');
	    var external$2 = {
	      formActionEvent: formActionEvent,
	      saveState: saveState,
	      disable: disable$1,
	      enable: enable$1
	    };
	
	    var renderEditPanel = function (imagePanel, providersBackstage) {
	      var createButton = function (text, action, disabled, primary) {
	        return record(renderButton({
	          name: text,
	          text: text,
	          disabled: disabled,
	          primary: primary,
	          icon: Optional.none(),
	          borderless: false
	        }, action, providersBackstage));
	      };
	      var createIconButton = function (icon, tooltip, action, disabled) {
	        return record(renderIconButton({
	          name: icon,
	          icon: Optional.some(icon),
	          tooltip: Optional.some(tooltip),
	          disabled: disabled,
	          primary: false,
	          borderless: false
	        }, action, providersBackstage));
	      };
	      var disableAllComponents = function (comps, eventcomp) {
	        comps.map(function (mem) {
	          var component = mem.get(eventcomp);
	          if (component.hasConfigured(Disabling)) {
	            Disabling.disable(component);
	          }
	        });
	      };
	      var enableAllComponents = function (comps, eventcomp) {
	        comps.map(function (mem) {
	          var component = mem.get(eventcomp);
	          if (component.hasConfigured(Disabling)) {
	            Disabling.enable(component);
	          }
	        });
	      };
	      var panelDom = {
	        tag: 'div',
	        classes: [
	          'tox-image-tools__toolbar',
	          'tox-image-tools-edit-panel'
	        ]
	      };
	      var noop$1 = noop;
	      var emit$1 = function (comp, event, data) {
	        emitWith(comp, event, data);
	      };
	      var emitDisable = function (component) {
	        return emit(component, external$2.disable());
	      };
	      var emitEnable = function (component) {
	        return emit(component, external$2.enable());
	      };
	      var emitTransform = function (comp, transform) {
	        emitDisable(comp);
	        emit$1(comp, internal.transform(), { transform: transform });
	        emitEnable(comp);
	      };
	      var emitTempTransform = function (comp, transform) {
	        emitDisable(comp);
	        emit$1(comp, internal.tempTransform(), { transform: transform });
	        emitEnable(comp);
	      };
	      var getBackSwap = function (anyInSystem) {
	        return function () {
	          memContainer.getOpt(anyInSystem).each(function (container) {
	            Replacing.set(container, [ButtonPanel]);
	          });
	        };
	      };
	      var emitTransformApply = function (comp, transform) {
	        emitDisable(comp);
	        emit$1(comp, internal.transformApply(), {
	          transform: transform,
	          swap: getBackSwap(comp)
	        });
	        emitEnable(comp);
	      };
	      var createBackButton = function () {
	        return createButton('Back', function (button) {
	          return emit$1(button, internal.back(), { swap: getBackSwap(button) });
	        }, false, false);
	      };
	      var createSpacer = function () {
	        return record({
	          dom: {
	            tag: 'div',
	            classes: ['tox-spacer']
	          },
	          behaviours: derive$1([Disabling.config({})])
	        });
	      };
	      var createApplyButton = function () {
	        return createButton('Apply', function (button) {
	          return emit$1(button, internal.apply(), { swap: getBackSwap(button) });
	        }, true, true);
	      };
	      var makeCropTransform = function () {
	        return function (ir) {
	          var rect = imagePanel.getRect();
	          return crop$1(ir, rect.x, rect.y, rect.w, rect.h);
	        };
	      };
	      var cropPanelComponents = [
	        createBackButton(),
	        createSpacer(),
	        createButton('Apply', function (button) {
	          var transform = makeCropTransform();
	          emitTransformApply(button, transform);
	          imagePanel.hideCrop();
	        }, false, true)
	      ];
	      var CropPanel = Container.sketch({
	        dom: panelDom,
	        components: cropPanelComponents.map(function (mem) {
	          return mem.asSpec();
	        }),
	        containerBehaviours: derive$1([config('image-tools-crop-buttons-events', [
	            run(external$2.disable(), function (comp, _se) {
	              disableAllComponents(cropPanelComponents, comp);
	            }),
	            run(external$2.enable(), function (comp, _se) {
	              enableAllComponents(cropPanelComponents, comp);
	            })
	          ])])
	      });
	      var memSize = record(renderSizeInput({
	        name: 'size',
	        label: Optional.none(),
	        constrain: true,
	        disabled: false
	      }, providersBackstage));
	      var makeResizeTransform = function (width, height) {
	        return function (ir) {
	          return resize$2(ir, width, height);
	        };
	      };
	      var resizePanelComponents = [
	        createBackButton(),
	        createSpacer(),
	        memSize,
	        createSpacer(),
	        createButton('Apply', function (button) {
	          memSize.getOpt(button).each(function (sizeInput) {
	            var value = Representing.getValue(sizeInput);
	            var width = parseInt(value.width, 10);
	            var height = parseInt(value.height, 10);
	            var transform = makeResizeTransform(width, height);
	            emitTransformApply(button, transform);
	          });
	        }, false, true)
	      ];
	      var ResizePanel = Container.sketch({
	        dom: panelDom,
	        components: resizePanelComponents.map(function (mem) {
	          return mem.asSpec();
	        }),
	        containerBehaviours: derive$1([config('image-tools-resize-buttons-events', [
	            run(external$2.disable(), function (comp, _se) {
	              disableAllComponents(resizePanelComponents, comp);
	            }),
	            run(external$2.enable(), function (comp, _se) {
	              enableAllComponents(resizePanelComponents, comp);
	            })
	          ])])
	      });
	      var makeValueTransform = function (transform, value) {
	        return function (ir) {
	          return transform(ir, value);
	        };
	      };
	      var horizontalFlip = makeValueTransform(flip$1, 'h');
	      var verticalFlip = makeValueTransform(flip$1, 'v');
	      var counterclockwiseRotate = makeValueTransform(rotate$1, -90);
	      var clockwiseRotate = makeValueTransform(rotate$1, 90);
	      var flipRotateOnAction = function (comp, operation) {
	        emitTempTransform(comp, operation);
	      };
	      var flipRotateComponents = [
	        createBackButton(),
	        createSpacer(),
	        createIconButton('flip-horizontally', 'Flip horizontally', function (button) {
	          flipRotateOnAction(button, horizontalFlip);
	        }, false),
	        createIconButton('flip-vertically', 'Flip vertically', function (button) {
	          flipRotateOnAction(button, verticalFlip);
	        }, false),
	        createIconButton('rotate-left', 'Rotate counterclockwise', function (button) {
	          flipRotateOnAction(button, counterclockwiseRotate);
	        }, false),
	        createIconButton('rotate-right', 'Rotate clockwise', function (button) {
	          flipRotateOnAction(button, clockwiseRotate);
	        }, false),
	        createSpacer(),
	        createApplyButton()
	      ];
	      var FlipRotatePanel = Container.sketch({
	        dom: panelDom,
	        components: flipRotateComponents.map(function (mem) {
	          return mem.asSpec();
	        }),
	        containerBehaviours: derive$1([config('image-tools-fliprotate-buttons-events', [
	            run(external$2.disable(), function (comp, _se) {
	              disableAllComponents(flipRotateComponents, comp);
	            }),
	            run(external$2.enable(), function (comp, _se) {
	              enableAllComponents(flipRotateComponents, comp);
	            })
	          ])])
	      });
	      var makeSlider = function (label, onChoose, min, value, max) {
	        var labelPart = Slider.parts.label({
	          dom: {
	            tag: 'label',
	            classes: ['tox-label'],
	            innerHtml: providersBackstage.translate(label)
	          }
	        });
	        var spectrum = Slider.parts.spectrum({
	          dom: {
	            tag: 'div',
	            classes: ['tox-slider__rail'],
	            attributes: { role: 'presentation' }
	          }
	        });
	        var thumb = Slider.parts.thumb({
	          dom: {
	            tag: 'div',
	            classes: ['tox-slider__handle'],
	            attributes: { role: 'presentation' }
	          }
	        });
	        return record(Slider.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-slider'],
	            attributes: { role: 'presentation' }
	          },
	          model: {
	            mode: 'x',
	            minX: min,
	            maxX: max,
	            getInitialValue: constant({ x: value })
	          },
	          components: [
	            labelPart,
	            spectrum,
	            thumb
	          ],
	          sliderBehaviours: derive$1([Focusing.config({})]),
	          onChoose: onChoose
	        }));
	      };
	      var makeVariableSlider = function (label, transform, min, value, max) {
	        var onChoose = function (slider, _thumb, value) {
	          var valTransform = makeValueTransform(transform, value.x / 100);
	          emitTransform(slider, valTransform);
	        };
	        return makeSlider(label, onChoose, min, value, max);
	      };
	      var variableFilterPanelComponents = function (label, transform, min, value, max) {
	        return [
	          createBackButton(),
	          makeVariableSlider(label, transform, min, value, max),
	          createApplyButton()
	        ];
	      };
	      var createVariableFilterPanel = function (label, transform, min, value, max) {
	        var filterPanelComponents = variableFilterPanelComponents(label, transform, min, value, max);
	        return Container.sketch({
	          dom: panelDom,
	          components: filterPanelComponents.map(function (mem) {
	            return mem.asSpec();
	          }),
	          containerBehaviours: derive$1([config('image-tools-filter-panel-buttons-events', [
	              run(external$2.disable(), function (comp, _se) {
	                disableAllComponents(filterPanelComponents, comp);
	              }),
	              run(external$2.enable(), function (comp, _se) {
	                enableAllComponents(filterPanelComponents, comp);
	              })
	            ])])
	        });
	      };
	      var filterPanelComponents = [
	        createBackButton(),
	        createSpacer(),
	        createApplyButton()
	      ];
	      var FilterPanel = Container.sketch({
	        dom: panelDom,
	        components: filterPanelComponents.map(function (mem) {
	          return mem.asSpec();
	        })
	      });
	      var BrightnessPanel = createVariableFilterPanel('Brightness', brightness$1, -100, 0, 100);
	      var ContrastPanel = createVariableFilterPanel('Contrast', contrast$1, -100, 0, 100);
	      var GammaPanel = createVariableFilterPanel('Gamma', gamma$1, -100, 0, 100);
	      var makeColorTransform = function (red, green, blue) {
	        return function (ir) {
	          return colorize$1(ir, red, green, blue);
	        };
	      };
	      var makeColorSlider = function (label) {
	        var onChoose = function (slider, _thumb, _value) {
	          var redOpt = memRed.getOpt(slider);
	          var blueOpt = memBlue.getOpt(slider);
	          var greenOpt = memGreen.getOpt(slider);
	          redOpt.each(function (red) {
	            blueOpt.each(function (blue) {
	              greenOpt.each(function (green) {
	                var r = Representing.getValue(red).x / 100;
	                var g = Representing.getValue(green).x / 100;
	                var b = Representing.getValue(blue).x / 100;
	                var transform = makeColorTransform(r, g, b);
	                emitTransform(slider, transform);
	              });
	            });
	          });
	        };
	        return makeSlider(label, onChoose, 0, 100, 200);
	      };
	      var memRed = makeColorSlider('R');
	      var memGreen = makeColorSlider('G');
	      var memBlue = makeColorSlider('B');
	      var colorizePanelComponents = [
	        createBackButton(),
	        memRed,
	        memGreen,
	        memBlue,
	        createApplyButton()
	      ];
	      var ColorizePanel = Container.sketch({
	        dom: panelDom,
	        components: colorizePanelComponents.map(function (mem) {
	          return mem.asSpec();
	        })
	      });
	      var getTransformPanelEvent = function (panel, transform, update) {
	        return function (button) {
	          var swap = function () {
	            memContainer.getOpt(button).each(function (container) {
	              Replacing.set(container, [panel]);
	              update(container);
	            });
	          };
	          emit$1(button, internal.swap(), {
	            transform: transform,
	            swap: swap
	          });
	        };
	      };
	      var cropPanelUpdate = function (_anyInSystem) {
	        imagePanel.showCrop();
	      };
	      var resizePanelUpdate = function (anyInSystem) {
	        memSize.getOpt(anyInSystem).each(function (sizeInput) {
	          var measurements = imagePanel.getMeasurements();
	          var width = measurements.width;
	          var height = measurements.height;
	          Representing.setValue(sizeInput, {
	            width: width,
	            height: height
	          });
	        });
	      };
	      var sharpenTransform = Optional.some(sharpen$1);
	      var invertTransform = Optional.some(invert$1);
	      var buttonPanelComponents = [
	        createIconButton('crop', 'Crop', getTransformPanelEvent(CropPanel, Optional.none(), cropPanelUpdate), false),
	        createIconButton('resize', 'Resize', getTransformPanelEvent(ResizePanel, Optional.none(), resizePanelUpdate), false),
	        createIconButton('orientation', 'Orientation', getTransformPanelEvent(FlipRotatePanel, Optional.none(), noop$1), false),
	        createIconButton('brightness', 'Brightness', getTransformPanelEvent(BrightnessPanel, Optional.none(), noop$1), false),
	        createIconButton('sharpen', 'Sharpen', getTransformPanelEvent(FilterPanel, sharpenTransform, noop$1), false),
	        createIconButton('contrast', 'Contrast', getTransformPanelEvent(ContrastPanel, Optional.none(), noop$1), false),
	        createIconButton('color-levels', 'Color levels', getTransformPanelEvent(ColorizePanel, Optional.none(), noop$1), false),
	        createIconButton('gamma', 'Gamma', getTransformPanelEvent(GammaPanel, Optional.none(), noop$1), false),
	        createIconButton('invert', 'Invert', getTransformPanelEvent(FilterPanel, invertTransform, noop$1), false)
	      ];
	      var ButtonPanel = Container.sketch({
	        dom: panelDom,
	        components: buttonPanelComponents.map(function (mem) {
	          return mem.asSpec();
	        })
	      });
	      var container = Container.sketch({
	        dom: { tag: 'div' },
	        components: [ButtonPanel],
	        containerBehaviours: derive$1([Replacing.config({})])
	      });
	      var memContainer = record(container);
	      var getApplyButton = function (anyInSystem) {
	        return memContainer.getOpt(anyInSystem).map(function (container) {
	          var panel = container.components()[0];
	          return panel.components()[panel.components().length - 1];
	        });
	      };
	      return {
	        memContainer: memContainer,
	        getApplyButton: getApplyButton
	      };
	    };
	
	    var global$d = tinymce.util.Tools.resolve('tinymce.geom.Rect');
	
	    var global$e = tinymce.util.Tools.resolve('tinymce.dom.DomQuery');
	
	    var global$f = tinymce.util.Tools.resolve('tinymce.util.Observable');
	
	    var global$g = tinymce.util.Tools.resolve('tinymce.util.VK');
	
	    var getDocumentSize = function (doc) {
	      var max = Math.max;
	      var documentElement = doc.documentElement;
	      var body = doc.body;
	      var scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
	      var clientWidth = max(documentElement.clientWidth, body.clientWidth);
	      var offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
	      var scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
	      var clientHeight = max(documentElement.clientHeight, body.clientHeight);
	      var offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
	      return {
	        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
	        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
	      };
	    };
	    var updateWithTouchData = function (e) {
	      var keys, i;
	      if (e.changedTouches) {
	        keys = 'screenX screenY pageX pageY clientX clientY'.split(' ');
	        for (i = 0; i < keys.length; i++) {
	          e[keys[i]] = e.changedTouches[0][keys[i]];
	        }
	      }
	    };
	    function DragHelper (id, settings) {
	      var $eventOverlay;
	      var doc = settings.document || document;
	      var downButton;
	      var startX, startY;
	      var handleElement = doc.getElementById(settings.handle || id);
	      var start = function (e) {
	        var docSize = getDocumentSize(doc);
	        var cursor;
	        updateWithTouchData(e);
	        e.preventDefault();
	        downButton = e.button;
	        var handleElm = handleElement;
	        startX = e.screenX;
	        startY = e.screenY;
	        if (window.getComputedStyle) {
	          cursor = window.getComputedStyle(handleElm, null).getPropertyValue('cursor');
	        } else {
	          cursor = handleElm.runtimeStyle.cursor;
	        }
	        $eventOverlay = global$e('<div></div>').css({
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          width: docSize.width,
	          height: docSize.height,
	          zIndex: 2147483647,
	          opacity: 0.0001,
	          cursor: cursor
	        }).appendTo(doc.body);
	        global$e(doc).on('mousemove touchmove', drag).on('mouseup touchend', stop);
	        settings.start(e);
	      };
	      var drag = function (e) {
	        updateWithTouchData(e);
	        if (e.button !== downButton) {
	          return stop(e);
	        }
	        e.deltaX = e.screenX - startX;
	        e.deltaY = e.screenY - startY;
	        e.preventDefault();
	        settings.drag(e);
	      };
	      var stop = function (e) {
	        updateWithTouchData(e);
	        global$e(doc).off('mousemove touchmove', drag).off('mouseup touchend', stop);
	        $eventOverlay.remove();
	        if (settings.stop) {
	          settings.stop(e);
	        }
	      };
	      var destroy = function () {
	        global$e(handleElement).off();
	      };
	      global$e(handleElement).on('mousedown touchstart', start);
	      return { destroy: destroy };
	    }
	
	    var count = 0;
	    var create$7 = function (currentRect, viewPortRect, clampRect, containerElm, action) {
	      var dragHelpers;
	      var prefix = 'tox-';
	      var id = prefix + 'crid-' + count++;
	      var handles = [
	        {
	          name: 'move',
	          xMul: 0,
	          yMul: 0,
	          deltaX: 1,
	          deltaY: 1,
	          deltaW: 0,
	          deltaH: 0,
	          label: 'Crop Mask'
	        },
	        {
	          name: 'nw',
	          xMul: 0,
	          yMul: 0,
	          deltaX: 1,
	          deltaY: 1,
	          deltaW: -1,
	          deltaH: -1,
	          label: 'Top Left Crop Handle'
	        },
	        {
	          name: 'ne',
	          xMul: 1,
	          yMul: 0,
	          deltaX: 0,
	          deltaY: 1,
	          deltaW: 1,
	          deltaH: -1,
	          label: 'Top Right Crop Handle'
	        },
	        {
	          name: 'sw',
	          xMul: 0,
	          yMul: 1,
	          deltaX: 1,
	          deltaY: 0,
	          deltaW: -1,
	          deltaH: 1,
	          label: 'Bottom Left Crop Handle'
	        },
	        {
	          name: 'se',
	          xMul: 1,
	          yMul: 1,
	          deltaX: 0,
	          deltaY: 0,
	          deltaW: 1,
	          deltaH: 1,
	          label: 'Bottom Right Crop Handle'
	        }
	      ];
	      var blockers = [
	        'top',
	        'right',
	        'bottom',
	        'left'
	      ];
	      var getAbsoluteRect = function (outerRect, relativeRect) {
	        return {
	          x: relativeRect.x + outerRect.x,
	          y: relativeRect.y + outerRect.y,
	          w: relativeRect.w,
	          h: relativeRect.h
	        };
	      };
	      var getRelativeRect = function (outerRect, innerRect) {
	        return {
	          x: innerRect.x - outerRect.x,
	          y: innerRect.y - outerRect.y,
	          w: innerRect.w,
	          h: innerRect.h
	        };
	      };
	      var getInnerRect = function () {
	        return getRelativeRect(clampRect, currentRect);
	      };
	      var moveRect = function (handle, startRect, deltaX, deltaY) {
	        var x, y, w, h, rect;
	        x = startRect.x;
	        y = startRect.y;
	        w = startRect.w;
	        h = startRect.h;
	        x += deltaX * handle.deltaX;
	        y += deltaY * handle.deltaY;
	        w += deltaX * handle.deltaW;
	        h += deltaY * handle.deltaH;
	        if (w < 20) {
	          w = 20;
	        }
	        if (h < 20) {
	          h = 20;
	        }
	        rect = currentRect = global$d.clamp({
	          x: x,
	          y: y,
	          w: w,
	          h: h
	        }, clampRect, handle.name === 'move');
	        rect = getRelativeRect(clampRect, rect);
	        instance.fire('updateRect', { rect: rect });
	        setInnerRect(rect);
	      };
	      var render = function () {
	        var createDragHelper = function (handle) {
	          var startRect;
	          return DragHelper(id, {
	            document: containerElm.ownerDocument,
	            handle: id + '-' + handle.name,
	            start: function () {
	              startRect = currentRect;
	            },
	            drag: function (e) {
	              moveRect(handle, startRect, e.deltaX, e.deltaY);
	            }
	          });
	        };
	        global$e('<div id="' + id + '" class="' + prefix + 'croprect-container"' + ' role="grid" aria-dropeffect="execute">').appendTo(containerElm);
	        global$c.each(blockers, function (blocker) {
	          global$e('#' + id, containerElm).append('<div id="' + id + '-' + blocker + '"class="' + prefix + 'croprect-block" style="display: none" data-mce-bogus="all">');
	        });
	        global$c.each(handles, function (handle) {
	          global$e('#' + id, containerElm).append('<div id="' + id + '-' + handle.name + '" class="' + prefix + 'croprect-handle ' + prefix + 'croprect-handle-' + handle.name + '"' + 'style="display: none" data-mce-bogus="all" role="gridcell" tabindex="-1"' + ' aria-label="' + handle.label + '" aria-grabbed="false" title="' + handle.label + '">');
	        });
	        dragHelpers = global$c.map(handles, createDragHelper);
	        repaint(currentRect);
	        global$e(containerElm).on('focusin focusout', function (e) {
	          global$e(e.target).attr('aria-grabbed', e.type === 'focus' ? 'true' : 'false');
	        });
	        global$e(containerElm).on('keydown', function (e) {
	          var activeHandle;
	          global$c.each(handles, function (handle) {
	            if (e.target.id === id + '-' + handle.name) {
	              activeHandle = handle;
	              return false;
	            }
	          });
	          var moveAndBlock = function (evt, handle, startRect, deltaX, deltaY) {
	            evt.stopPropagation();
	            evt.preventDefault();
	            moveRect(activeHandle, startRect, deltaX, deltaY);
	          };
	          switch (e.keyCode) {
	          case global$g.LEFT:
	            moveAndBlock(e, activeHandle, currentRect, -10, 0);
	            break;
	          case global$g.RIGHT:
	            moveAndBlock(e, activeHandle, currentRect, 10, 0);
	            break;
	          case global$g.UP:
	            moveAndBlock(e, activeHandle, currentRect, 0, -10);
	            break;
	          case global$g.DOWN:
	            moveAndBlock(e, activeHandle, currentRect, 0, 10);
	            break;
	          case global$g.ENTER:
	          case global$g.SPACEBAR:
	            e.preventDefault();
	            action();
	            break;
	          }
	        });
	      };
	      var toggleVisibility = function (state) {
	        var selectors = global$c.map(handles, function (handle) {
	          return '#' + id + '-' + handle.name;
	        }).concat(global$c.map(blockers, function (blocker) {
	          return '#' + id + '-' + blocker;
	        })).join(',');
	        if (state) {
	          global$e(selectors, containerElm).show();
	        } else {
	          global$e(selectors, containerElm).hide();
	        }
	      };
	      var repaint = function (rect) {
	        var updateElementRect = function (name, rect) {
	          if (rect.h < 0) {
	            rect.h = 0;
	          }
	          if (rect.w < 0) {
	            rect.w = 0;
	          }
	          global$e('#' + id + '-' + name, containerElm).css({
	            left: rect.x,
	            top: rect.y,
	            width: rect.w,
	            height: rect.h
	          });
	        };
	        global$c.each(handles, function (handle) {
	          global$e('#' + id + '-' + handle.name, containerElm).css({
	            left: rect.w * handle.xMul + rect.x,
	            top: rect.h * handle.yMul + rect.y
	          });
	        });
	        updateElementRect('top', {
	          x: viewPortRect.x,
	          y: viewPortRect.y,
	          w: viewPortRect.w,
	          h: rect.y - viewPortRect.y
	        });
	        updateElementRect('right', {
	          x: rect.x + rect.w,
	          y: rect.y,
	          w: viewPortRect.w - rect.x - rect.w + viewPortRect.x,
	          h: rect.h
	        });
	        updateElementRect('bottom', {
	          x: viewPortRect.x,
	          y: rect.y + rect.h,
	          w: viewPortRect.w,
	          h: viewPortRect.h - rect.y - rect.h + viewPortRect.y
	        });
	        updateElementRect('left', {
	          x: viewPortRect.x,
	          y: rect.y,
	          w: rect.x - viewPortRect.x,
	          h: rect.h
	        });
	        updateElementRect('move', rect);
	      };
	      var setRect = function (rect) {
	        currentRect = rect;
	        repaint(currentRect);
	      };
	      var setViewPortRect = function (rect) {
	        viewPortRect = rect;
	        repaint(currentRect);
	      };
	      var setInnerRect = function (rect) {
	        setRect(getAbsoluteRect(clampRect, rect));
	      };
	      var setClampRect = function (rect) {
	        clampRect = rect;
	        repaint(currentRect);
	      };
	      var destroy = function () {
	        global$c.each(dragHelpers, function (helper) {
	          helper.destroy();
	        });
	        dragHelpers = [];
	      };
	      render();
	      var instance = global$c.extend({
	        toggleVisibility: toggleVisibility,
	        setClampRect: setClampRect,
	        setRect: setRect,
	        getInnerRect: getInnerRect,
	        setInnerRect: setInnerRect,
	        setViewPortRect: setViewPortRect,
	        destroy: destroy
	      }, global$f);
	      return instance;
	    };
	    var CropRect = { create: create$7 };
	
	    var loadImage = function (image) {
	      return new global$4(function (resolve) {
	        var loaded = function () {
	          image.removeEventListener('load', loaded);
	          resolve(image);
	        };
	        if (image.complete) {
	          resolve(image);
	        } else {
	          image.addEventListener('load', loaded);
	        }
	      });
	    };
	    var renderImagePanel = function (initialUrl) {
	      var memBg = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-image-tools__image-bg'],
	          attributes: { role: 'presentation' }
	        }
	      });
	      var zoomState = Cell(1);
	      var cropRect = Cell(Optional.none());
	      var rectState = Cell({
	        x: 0,
	        y: 0,
	        w: 1,
	        h: 1
	      });
	      var viewRectState = Cell({
	        x: 0,
	        y: 0,
	        w: 1,
	        h: 1
	      });
	      var repaintImg = function (anyInSystem, img) {
	        memContainer.getOpt(anyInSystem).each(function (panel) {
	          var zoom = zoomState.get();
	          var panelW = get$8(panel.element);
	          var panelH = get$7(panel.element);
	          var width = img.dom.naturalWidth * zoom;
	          var height = img.dom.naturalHeight * zoom;
	          var left = Math.max(0, panelW / 2 - width / 2);
	          var top = Math.max(0, panelH / 2 - height / 2);
	          var css = {
	            left: left.toString() + 'px',
	            top: top.toString() + 'px',
	            width: width.toString() + 'px',
	            height: height.toString() + 'px',
	            position: 'absolute'
	          };
	          setAll$1(img, css);
	          memBg.getOpt(panel).each(function (bg) {
	            setAll$1(bg.element, css);
	          });
	          cropRect.get().each(function (cRect) {
	            var rect = rectState.get();
	            cRect.setRect({
	              x: rect.x * zoom + left,
	              y: rect.y * zoom + top,
	              w: rect.w * zoom,
	              h: rect.h * zoom
	            });
	            cRect.setClampRect({
	              x: left,
	              y: top,
	              w: width,
	              h: height
	            });
	            cRect.setViewPortRect({
	              x: 0,
	              y: 0,
	              w: panelW,
	              h: panelH
	            });
	          });
	        });
	      };
	      var zoomFit = function (anyInSystem, img) {
	        memContainer.getOpt(anyInSystem).each(function (panel) {
	          var panelW = get$8(panel.element);
	          var panelH = get$7(panel.element);
	          var width = img.dom.naturalWidth;
	          var height = img.dom.naturalHeight;
	          var zoom = Math.min(panelW / width, panelH / height);
	          if (zoom >= 1) {
	            zoomState.set(1);
	          } else {
	            zoomState.set(zoom);
	          }
	        });
	      };
	      var updateSrc = function (anyInSystem, url) {
	        var img = SugarElement.fromTag('img');
	        set$1(img, 'src', url);
	        return loadImage(img.dom).then(function () {
	          return memContainer.getOpt(anyInSystem).map(function (panel) {
	            var aImg = external({ element: img });
	            Replacing.replaceAt(panel, 1, Optional.some(aImg));
	            var lastViewRect = viewRectState.get();
	            var viewRect = {
	              x: 0,
	              y: 0,
	              w: img.dom.naturalWidth,
	              h: img.dom.naturalHeight
	            };
	            viewRectState.set(viewRect);
	            var rect = global$d.inflate(viewRect, -20, -20);
	            rectState.set(rect);
	            if (lastViewRect.w !== viewRect.w || lastViewRect.h !== viewRect.h) {
	              zoomFit(panel, img);
	            }
	            repaintImg(panel, img);
	            return img;
	          });
	        });
	      };
	      var zoom = function (anyInSystem, direction) {
	        var currentZoom = zoomState.get();
	        var newZoom = direction > 0 ? Math.min(2, currentZoom + 0.1) : Math.max(0.1, currentZoom - 0.1);
	        zoomState.set(newZoom);
	        memContainer.getOpt(anyInSystem).each(function (panel) {
	          var img = panel.components()[1].element;
	          repaintImg(panel, img);
	        });
	      };
	      var showCrop = function () {
	        cropRect.get().each(function (cRect) {
	          cRect.toggleVisibility(true);
	        });
	      };
	      var hideCrop = function () {
	        cropRect.get().each(function (cRect) {
	          cRect.toggleVisibility(false);
	        });
	      };
	      var getRect = function () {
	        return rectState.get();
	      };
	      var container = Container.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-image-tools__image']
	        },
	        components: [
	          memBg.asSpec(),
	          {
	            dom: {
	              tag: 'img',
	              attributes: { src: initialUrl }
	            }
	          },
	          {
	            dom: { tag: 'div' },
	            behaviours: derive$1([config('image-panel-crop-events', [runOnAttached(function (comp) {
	                  memContainer.getOpt(comp).each(function (container) {
	                    var el = container.element.dom;
	                    var cRect = CropRect.create({
	                      x: 10,
	                      y: 10,
	                      w: 100,
	                      h: 100
	                    }, {
	                      x: 0,
	                      y: 0,
	                      w: 200,
	                      h: 200
	                    }, {
	                      x: 0,
	                      y: 0,
	                      w: 200,
	                      h: 200
	                    }, el, noop);
	                    cRect.toggleVisibility(false);
	                    cRect.on('updateRect', function (e) {
	                      var rect = e.rect;
	                      var zoom = zoomState.get();
	                      var newRect = {
	                        x: Math.round(rect.x / zoom),
	                        y: Math.round(rect.y / zoom),
	                        w: Math.round(rect.w / zoom),
	                        h: Math.round(rect.h / zoom)
	                      };
	                      rectState.set(newRect);
	                    });
	                    cropRect.set(Optional.some(cRect));
	                  });
	                })])])
	          }
	        ],
	        containerBehaviours: derive$1([
	          Replacing.config({}),
	          config('image-panel-events', [runOnAttached(function (comp) {
	              updateSrc(comp, initialUrl);
	            })])
	        ])
	      });
	      var memContainer = record(container);
	      var getMeasurements = function () {
	        var viewRect = viewRectState.get();
	        return {
	          width: viewRect.w,
	          height: viewRect.h
	        };
	      };
	      return {
	        memContainer: memContainer,
	        updateSrc: updateSrc,
	        zoom: zoom,
	        showCrop: showCrop,
	        hideCrop: hideCrop,
	        getRect: getRect,
	        getMeasurements: getMeasurements
	      };
	    };
	
	    var createButton = function (innerHtml, icon, disabled, action, providersBackstage) {
	      return renderIconButton({
	        name: innerHtml,
	        icon: Optional.some(icon),
	        disabled: disabled,
	        tooltip: Optional.some(innerHtml),
	        primary: false,
	        borderless: false
	      }, action, providersBackstage);
	    };
	    var setButtonEnabled = function (button, enabled) {
	      if (enabled) {
	        Disabling.enable(button);
	      } else {
	        Disabling.disable(button);
	      }
	    };
	    var renderSideBar = function (providersBackstage) {
	      var updateButtonUndoStates = function (anyInSystem, undoEnabled, redoEnabled) {
	        memUndo.getOpt(anyInSystem).each(function (undo) {
	          setButtonEnabled(undo, undoEnabled);
	        });
	        memRedo.getOpt(anyInSystem).each(function (redo) {
	          setButtonEnabled(redo, redoEnabled);
	        });
	      };
	      var memUndo = record(createButton('Undo', 'undo', true, function (button) {
	        emitWith(button, internal.undo(), { direction: 1 });
	      }, providersBackstage));
	      var memRedo = record(createButton('Redo', 'redo', true, function (button) {
	        emitWith(button, internal.redo(), { direction: 1 });
	      }, providersBackstage));
	      var container = Container.sketch({
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-image-tools__toolbar',
	            'tox-image-tools__sidebar'
	          ]
	        },
	        components: [
	          memUndo.asSpec(),
	          memRedo.asSpec(),
	          createButton('Zoom in', 'zoom-in', false, function (button) {
	            emitWith(button, internal.zoom(), { direction: 1 });
	          }, providersBackstage),
	          createButton('Zoom out', 'zoom-out', false, function (button) {
	            emitWith(button, internal.zoom(), { direction: -1 });
	          }, providersBackstage)
	        ]
	      });
	      return {
	        container: container,
	        updateButtonUndoStates: updateButtonUndoStates
	      };
	    };
	
	    function UndoStack () {
	      var data = [];
	      var index = -1;
	      var add = function (state) {
	        var removed = data.splice(++index);
	        data.push(state);
	        return {
	          state: state,
	          removed: removed
	        };
	      };
	      var undo = function () {
	        if (canUndo()) {
	          return data[--index];
	        }
	      };
	      var redo = function () {
	        if (canRedo()) {
	          return data[++index];
	        }
	      };
	      var canUndo = function () {
	        return index > 0;
	      };
	      var canRedo = function () {
	        return index !== -1 && index < data.length - 1;
	      };
	      return {
	        data: data,
	        add: add,
	        undo: undo,
	        redo: redo,
	        canUndo: canUndo,
	        canRedo: canRedo
	      };
	    }
	
	    var makeState = function (initialState) {
	      var blobState = Cell(initialState);
	      var tempState = Cell(Optional.none());
	      var undoStack = UndoStack();
	      undoStack.add(initialState);
	      var getBlobState = function () {
	        return blobState.get();
	      };
	      var setBlobState = function (state) {
	        blobState.set(state);
	      };
	      var getTempState = function () {
	        return tempState.get().fold(function () {
	          return blobState.get();
	        }, function (temp) {
	          return temp;
	        });
	      };
	      var updateTempState = function (blob) {
	        var newTempState = createState(blob);
	        destroyTempState();
	        tempState.set(Optional.some(newTempState));
	        return newTempState.url;
	      };
	      var createState = function (blob) {
	        return {
	          blob: blob,
	          url: URL.createObjectURL(blob)
	        };
	      };
	      var destroyState = function (state) {
	        URL.revokeObjectURL(state.url);
	      };
	      var destroyStates = function (states) {
	        global$c.each(states, destroyState);
	      };
	      var destroyTempState = function () {
	        tempState.get().each(destroyState);
	        tempState.set(Optional.none());
	      };
	      var addBlobState = function (blob) {
	        var newState = createState(blob);
	        setBlobState(newState);
	        var removed = undoStack.add(newState).removed;
	        destroyStates(removed);
	        return newState.url;
	      };
	      var addTempState = function (blob) {
	        var newState = createState(blob);
	        tempState.set(Optional.some(newState));
	        return newState.url;
	      };
	      var applyTempState = function (postApply) {
	        return tempState.get().fold(noop, function (temp) {
	          addBlobState(temp.blob);
	          postApply();
	        });
	      };
	      var undo = function () {
	        var currentState = undoStack.undo();
	        setBlobState(currentState);
	        return currentState.url;
	      };
	      var redo = function () {
	        var currentState = undoStack.redo();
	        setBlobState(currentState);
	        return currentState.url;
	      };
	      var getHistoryStates = function () {
	        var undoEnabled = undoStack.canUndo();
	        var redoEnabled = undoStack.canRedo();
	        return {
	          undoEnabled: undoEnabled,
	          redoEnabled: redoEnabled
	        };
	      };
	      return {
	        getBlobState: getBlobState,
	        setBlobState: setBlobState,
	        addBlobState: addBlobState,
	        getTempState: getTempState,
	        updateTempState: updateTempState,
	        addTempState: addTempState,
	        applyTempState: applyTempState,
	        destroyTempState: destroyTempState,
	        undo: undo,
	        redo: redo,
	        getHistoryStates: getHistoryStates
	      };
	    };
	
	    var renderImageTools = function (detail, providersBackstage) {
	      var state = makeState(detail.currentState);
	      var zoom = function (anyInSystem, simulatedEvent) {
	        var direction = simulatedEvent.event.direction;
	        imagePanel.zoom(anyInSystem, direction);
	      };
	      var updateButtonUndoStates = function (anyInSystem) {
	        var historyStates = state.getHistoryStates();
	        sideBar.updateButtonUndoStates(anyInSystem, historyStates.undoEnabled, historyStates.redoEnabled);
	        emitWith(anyInSystem, external$2.formActionEvent, {
	          name: external$2.saveState(),
	          value: historyStates.undoEnabled
	        });
	      };
	      var disableUndoRedo = function (anyInSystem) {
	        sideBar.updateButtonUndoStates(anyInSystem, false, false);
	      };
	      var undo = function (anyInSystem, _simulatedEvent) {
	        var url = state.undo();
	        updateSrc(anyInSystem, url).then(function (_oImg) {
	          unblock(anyInSystem);
	          updateButtonUndoStates(anyInSystem);
	        });
	      };
	      var redo = function (anyInSystem, _simulatedEvent) {
	        var url = state.redo();
	        updateSrc(anyInSystem, url).then(function (_oImg) {
	          unblock(anyInSystem);
	          updateButtonUndoStates(anyInSystem);
	        });
	      };
	      var imageResultToBlob = function (ir) {
	        return ir.toBlob();
	      };
	      var block = function (anyInSystem) {
	        emitWith(anyInSystem, external$2.formActionEvent, {
	          name: external$2.disable(),
	          value: {}
	        });
	      };
	      var unblock = function (anyInSystem) {
	        editPanel.getApplyButton(anyInSystem).each(function (applyButton) {
	          Disabling.enable(applyButton);
	        });
	        emitWith(anyInSystem, external$2.formActionEvent, {
	          name: external$2.enable(),
	          value: {}
	        });
	      };
	      var updateSrc = function (anyInSystem, src) {
	        block(anyInSystem);
	        return imagePanel.updateSrc(anyInSystem, src);
	      };
	      var blobManipulate = function (anyInSystem, blob, filter, action, swap) {
	        block(anyInSystem);
	        return blobToImageResult(blob).then(filter).then(imageResultToBlob).then(action).then(function (url) {
	          return updateSrc(anyInSystem, url).then(function (oImg) {
	            updateButtonUndoStates(anyInSystem);
	            swap();
	            unblock(anyInSystem);
	            return oImg;
	          });
	        }).catch(function (err) {
	          console.log(err);
	          unblock(anyInSystem);
	          return err;
	        });
	      };
	      var manipulate = function (anyInSystem, filter, swap) {
	        var blob = state.getBlobState().blob;
	        var action = function (blob) {
	          return state.updateTempState(blob);
	        };
	        blobManipulate(anyInSystem, blob, filter, action, swap);
	      };
	      var tempManipulate = function (anyInSystem, filter) {
	        var blob = state.getTempState().blob;
	        var action = function (blob) {
	          return state.addTempState(blob);
	        };
	        blobManipulate(anyInSystem, blob, filter, action, noop);
	      };
	      var manipulateApply = function (anyInSystem, filter, swap) {
	        var blob = state.getBlobState().blob;
	        var action = function (blob) {
	          var url = state.addBlobState(blob);
	          destroyTempState(anyInSystem);
	          return url;
	        };
	        blobManipulate(anyInSystem, blob, filter, action, swap);
	      };
	      var apply = function (anyInSystem, simulatedEvent) {
	        var postApply = function () {
	          destroyTempState(anyInSystem);
	          var swap = simulatedEvent.event.swap;
	          swap();
	        };
	        state.applyTempState(postApply);
	      };
	      var destroyTempState = function (anyInSystem) {
	        var currentUrl = state.getBlobState().url;
	        state.destroyTempState();
	        updateButtonUndoStates(anyInSystem);
	        return currentUrl;
	      };
	      var cancel = function (anyInSystem) {
	        var currentUrl = destroyTempState(anyInSystem);
	        updateSrc(anyInSystem, currentUrl).then(function (_oImg) {
	          unblock(anyInSystem);
	        });
	      };
	      var back = function (anyInSystem, simulatedEvent) {
	        cancel(anyInSystem);
	        var swap = simulatedEvent.event.swap;
	        swap();
	        imagePanel.hideCrop();
	      };
	      var transform = function (anyInSystem, simulatedEvent) {
	        return manipulate(anyInSystem, simulatedEvent.event.transform, noop);
	      };
	      var tempTransform = function (anyInSystem, simulatedEvent) {
	        return tempManipulate(anyInSystem, simulatedEvent.event.transform);
	      };
	      var transformApply = function (anyInSystem, simulatedEvent) {
	        return manipulateApply(anyInSystem, simulatedEvent.event.transform, simulatedEvent.event.swap);
	      };
	      var imagePanel = renderImagePanel(detail.currentState.url);
	      var sideBar = renderSideBar(providersBackstage);
	      var editPanel = renderEditPanel(imagePanel, providersBackstage);
	      var swap = function (anyInSystem, simulatedEvent) {
	        disableUndoRedo(anyInSystem);
	        var transform = simulatedEvent.event.transform;
	        var swap = simulatedEvent.event.swap;
	        transform.fold(function () {
	          swap();
	        }, function (transform) {
	          manipulate(anyInSystem, transform, swap);
	        });
	      };
	      return {
	        dom: {
	          tag: 'div',
	          attributes: { role: 'presentation' }
	        },
	        components: [
	          editPanel.memContainer.asSpec(),
	          imagePanel.memContainer.asSpec(),
	          sideBar.container
	        ],
	        behaviours: derive$1([
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function () {
	                return state.getBlobState();
	              }
	            }
	          }),
	          config('image-tools-events', [
	            run(internal.undo(), undo),
	            run(internal.redo(), redo),
	            run(internal.zoom(), zoom),
	            run(internal.back(), back),
	            run(internal.apply(), apply),
	            run(internal.transform(), transform),
	            run(internal.tempTransform(), tempTransform),
	            run(internal.transformApply(), transformApply),
	            run(internal.swap(), swap)
	          ]),
	          ComposingConfigs.self()
	        ])
	      };
	    };
	
	    var renderLabel$2 = function (spec, backstageShared) {
	      var label = {
	        dom: {
	          tag: 'label',
	          innerHtml: backstageShared.providers.translate(spec.label),
	          classes: ['tox-label']
	        }
	      };
	      var comps = map(spec.items, backstageShared.interpreter);
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: [label].concat(comps),
	        behaviours: derive$1([
	          ComposingConfigs.self(),
	          Replacing.config({}),
	          RepresentingConfigs.domHtml(Optional.none()),
	          Keying.config({ mode: 'acyclic' })
	        ])
	      };
	    };
	
	    var isSingleListItem = function (item) {
	      return !has(item, 'items');
	    };
	    var dataAttribute = 'data-value';
	    var fetchItems = function (dropdownComp, name, items, selectedValue) {
	      return map(items, function (item) {
	        if (!isSingleListItem(item)) {
	          return {
	            type: 'nestedmenuitem',
	            text: item.text,
	            getSubmenuItems: function () {
	              return fetchItems(dropdownComp, name, item.items, selectedValue);
	            }
	          };
	        } else {
	          return {
	            type: 'togglemenuitem',
	            text: item.text,
	            value: item.value,
	            active: item.value === selectedValue,
	            onAction: function () {
	              Representing.setValue(dropdownComp, item.value);
	              emitWith(dropdownComp, formChangeEvent, { name: name });
	              Focusing.focus(dropdownComp);
	            }
	          };
	        }
	      });
	    };
	    var findItemByValue = function (items, value) {
	      return findMap(items, function (item) {
	        if (!isSingleListItem(item)) {
	          return findItemByValue(item.items, value);
	        } else {
	          return someIf(item.value === value, item);
	        }
	      });
	    };
	    var renderListBox = function (spec, backstage) {
	      var providersBackstage = backstage.shared.providers;
	      var initialItem = head(spec.items).filter(isSingleListItem);
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var pField = FormField.parts.field({
	        dom: {},
	        factory: {
	          sketch: function (sketchSpec) {
	            return renderCommonDropdown({
	              uid: sketchSpec.uid,
	              text: initialItem.map(function (item) {
	                return item.text;
	              }),
	              icon: Optional.none(),
	              tooltip: spec.label,
	              role: Optional.none(),
	              fetch: function (comp, callback) {
	                var items = fetchItems(comp, spec.name, spec.items, Representing.getValue(comp));
	                callback(build$2(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false));
	              },
	              onSetup: constant(noop),
	              getApi: constant({}),
	              columns: 1,
	              presets: 'normal',
	              classes: [],
	              dropdownBehaviours: [
	                Tabstopping.config({}),
	                Representing.config({
	                  store: {
	                    mode: 'manual',
	                    initialValue: initialItem.map(function (item) {
	                      return item.value;
	                    }).getOr(''),
	                    getValue: function (comp) {
	                      return get$3(comp.element, dataAttribute);
	                    },
	                    setValue: function (comp, data) {
	                      findItemByValue(spec.items, data).each(function (item) {
	                        set$1(comp.element, dataAttribute, item.value);
	                        emitWith(comp, updateMenuText, { text: item.text });
	                      });
	                    }
	                  }
	                })
	              ]
	            }, 'tox-listbox', backstage.shared);
	          }
	        }
	      });
	      var listBoxWrap = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-listboxfield']
	        },
	        components: [pField]
	      };
	      return FormField.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: flatten([
	          pLabel.toArray(),
	          [listBoxWrap]
	        ]),
	        fieldBehaviours: derive$1([Disabling.config({
	            disabled: constant(spec.disabled),
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	            }
	          })])
	      });
	    };
	
	    var renderPanel = function (spec, backstage) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: spec.classes
	        },
	        components: map(spec.items, backstage.shared.interpreter)
	      };
	    };
	
	    var factory$8 = function (detail, _spec) {
	      var options = map(detail.options, function (option) {
	        return {
	          dom: {
	            tag: 'option',
	            value: option.value,
	            innerHtml: option.text
	          }
	        };
	      });
	      var initialValues = detail.data.map(function (v) {
	        return wrap$1('initialValue', v);
	      }).getOr({});
	      return {
	        uid: detail.uid,
	        dom: {
	          tag: 'select',
	          classes: detail.selectClasses,
	          attributes: detail.selectAttributes
	        },
	        components: options,
	        behaviours: augment(detail.selectBehaviours, [
	          Focusing.config({}),
	          Representing.config({
	            store: __assign({
	              mode: 'manual',
	              getValue: function (select) {
	                return get$6(select.element);
	              },
	              setValue: function (select, newValue) {
	                var found = find(detail.options, function (opt) {
	                  return opt.value === newValue;
	                });
	                if (found.isSome()) {
	                  set$3(select.element, newValue);
	                }
	              }
	            }, initialValues)
	          })
	        ])
	      };
	    };
	    var HtmlSelect = single$2({
	      name: 'HtmlSelect',
	      configFields: [
	        strict$1('options'),
	        field$1('selectBehaviours', [
	          Focusing,
	          Representing
	        ]),
	        defaulted$1('selectClasses', []),
	        defaulted$1('selectAttributes', {}),
	        option('data')
	      ],
	      factory: factory$8
	    });
	
	    var renderSelectBox = function (spec, providersBackstage) {
	      var translatedOptions = map(spec.items, function (item) {
	        return {
	          text: providersBackstage.translate(item.text),
	          value: item.value
	        };
	      });
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var pField = FormField.parts.field({
	        dom: {},
	        selectAttributes: { size: spec.size },
	        options: translatedOptions,
	        factory: HtmlSelect,
	        selectBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            }
	          }),
	          Tabstopping.config({}),
	          config('selectbox-change', [run(change(), function (component, _) {
	              emitWith(component, formChangeEvent, { name: spec.name });
	            })])
	        ])
	      });
	      var chevron = spec.size > 1 ? Optional.none() : Optional.some({
	        dom: {
	          tag: 'div',
	          classes: ['tox-selectfield__icon-js'],
	          innerHtml: get$e('chevron-down', providersBackstage.icons)
	        }
	      });
	      var selectWrap = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-selectfield']
	        },
	        components: flatten([
	          [pField],
	          chevron.toArray()
	        ])
	      };
	      return FormField.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-form__group']
	        },
	        components: flatten([
	          pLabel.toArray(),
	          [selectWrap]
	        ]),
	        fieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            },
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig()
	        ])
	      });
	    };
	
	    var renderTable = function (spec, providersBackstage) {
	      var renderTh = function (text) {
	        return {
	          dom: {
	            tag: 'th',
	            innerHtml: providersBackstage.translate(text)
	          }
	        };
	      };
	      var renderHeader = function (header) {
	        return {
	          dom: { tag: 'thead' },
	          components: [{
	              dom: { tag: 'tr' },
	              components: map(header, renderTh)
	            }]
	        };
	      };
	      var renderTd = function (text) {
	        return {
	          dom: {
	            tag: 'td',
	            innerHtml: providersBackstage.translate(text)
	          }
	        };
	      };
	      var renderTr = function (row) {
	        return {
	          dom: { tag: 'tr' },
	          components: map(row, renderTd)
	        };
	      };
	      var renderRows = function (rows) {
	        return {
	          dom: { tag: 'tbody' },
	          components: map(rows, renderTr)
	        };
	      };
	      return {
	        dom: {
	          tag: 'table',
	          classes: ['tox-dialog__table']
	        },
	        components: [
	          renderHeader(spec.header),
	          renderRows(spec.cells)
	        ],
	        behaviours: derive$1([
	          Tabstopping.config({}),
	          Focusing.config({})
	        ])
	      };
	    };
	
	    var renderTextField = function (spec, providersBackstage) {
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var baseInputBehaviours = [
	        Disabling.config({
	          disabled: function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          }
	        }),
	        receivingConfig(),
	        Keying.config({
	          mode: 'execution',
	          useEnter: spec.multiline !== true,
	          useControlEnter: spec.multiline === true,
	          execute: function (comp) {
	            emit(comp, formSubmitEvent);
	            return Optional.some(true);
	          }
	        }),
	        config('textfield-change', [
	          run(input(), function (component, _) {
	            emitWith(component, formChangeEvent, { name: spec.name });
	          }),
	          run(postPaste(), function (component, _) {
	            emitWith(component, formChangeEvent, { name: spec.name });
	          })
	        ]),
	        Tabstopping.config({})
	      ];
	      var validatingBehaviours = spec.validation.map(function (vl) {
	        return Invalidating.config({
	          getRoot: function (input) {
	            return parent(input.element);
	          },
	          invalidClass: 'tox-invalid',
	          validator: {
	            validate: function (input) {
	              var v = Representing.getValue(input);
	              var result = vl.validator(v);
	              return Future.pure(result === true ? Result.value(v) : Result.error(result));
	            },
	            validateOnLoad: vl.validateOnLoad
	          }
	        });
	      }).toArray();
	      var placeholder = spec.placeholder.fold(constant({}), function (p) {
	        return { placeholder: providersBackstage.translate(p) };
	      });
	      var inputMode = spec.inputMode.fold(constant({}), function (mode) {
	        return { inputmode: mode };
	      });
	      var inputAttributes = __assign(__assign({}, placeholder), inputMode);
	      var pField = FormField.parts.field({
	        tag: spec.multiline === true ? 'textarea' : 'input',
	        inputAttributes: inputAttributes,
	        inputClasses: [spec.classname],
	        inputBehaviours: derive$1(flatten([
	          baseInputBehaviours,
	          validatingBehaviours
	        ])),
	        selectOnFocus: false,
	        factory: Input
	      });
	      var extraClasses = spec.flex ? ['tox-form__group--stretched'] : [];
	      var extraClasses2 = extraClasses.concat(spec.maximized ? ['tox-form-group--maximize'] : []);
	      var extraBehaviours = [
	        Disabling.config({
	          disabled: function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          },
	          onDisabled: function (comp) {
	            FormField.getField(comp).each(Disabling.disable);
	          },
	          onEnabled: function (comp) {
	            FormField.getField(comp).each(Disabling.enable);
	          }
	        }),
	        receivingConfig()
	      ];
	      return renderFormFieldWith(pLabel, pField, extraClasses2, extraBehaviours);
	    };
	    var renderInput = function (spec, providersBackstage) {
	      return renderTextField({
	        name: spec.name,
	        multiline: false,
	        label: spec.label,
	        inputMode: spec.inputMode,
	        placeholder: spec.placeholder,
	        flex: false,
	        disabled: spec.disabled,
	        classname: 'tox-textfield',
	        validation: Optional.none(),
	        maximized: spec.maximized
	      }, providersBackstage);
	    };
	    var renderTextarea = function (spec, providersBackstage) {
	      return renderTextField({
	        name: spec.name,
	        multiline: true,
	        label: spec.label,
	        inputMode: Optional.none(),
	        placeholder: spec.placeholder,
	        flex: true,
	        disabled: spec.disabled,
	        classname: 'tox-textarea',
	        validation: Optional.none(),
	        maximized: spec.maximized
	      }, providersBackstage);
	    };
	
	    var events$c = function (streamConfig, streamState) {
	      var streams = streamConfig.stream.streams;
	      var processor = streams.setup(streamConfig, streamState);
	      return derive([
	        run(streamConfig.event, processor),
	        runOnDetached(function () {
	          return streamState.cancel();
	        })
	      ].concat(streamConfig.cancelEvent.map(function (e) {
	        return [run(e, function () {
	            return streamState.cancel();
	          })];
	      }).getOr([])));
	    };
	
	    var ActiveStreaming = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$c
	    });
	
	    var throttle = function (_config) {
	      var state = Cell(null);
	      var readState = function () {
	        return { timer: state.get() !== null ? 'set' : 'unset' };
	      };
	      var setTimer = function (t) {
	        state.set(t);
	      };
	      var cancel = function () {
	        var t = state.get();
	        if (t !== null) {
	          t.cancel();
	        }
	      };
	      return nu$5({
	        readState: readState,
	        setTimer: setTimer,
	        cancel: cancel
	      });
	    };
	    var init$6 = function (spec) {
	      return spec.stream.streams.state(spec);
	    };
	
	    var StreamingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        throttle: throttle,
	        init: init$6
	    });
	
	    var setup$2 = function (streamInfo, streamState) {
	      var sInfo = streamInfo.stream;
	      var throttler = last$2(streamInfo.onStream, sInfo.delay);
	      streamState.setTimer(throttler);
	      return function (component, simulatedEvent) {
	        throttler.throttle(component, simulatedEvent);
	        if (sInfo.stopEvent) {
	          simulatedEvent.stop();
	        }
	      };
	    };
	    var StreamingSchema = [
	      strictOf('stream', choose$1('mode', {
	        throttle: [
	          strict$1('delay'),
	          defaulted$1('stopEvent', true),
	          output('streams', {
	            setup: setup$2,
	            state: throttle
	          })
	        ]
	      })),
	      defaulted$1('event', 'input'),
	      option('cancelEvent'),
	      onStrictHandler('onStream')
	    ];
	
	    var Streaming = create$1({
	      fields: StreamingSchema,
	      name: 'streaming',
	      active: ActiveStreaming,
	      state: StreamingState
	    });
	
	    var setValueFromItem = function (model, input, item) {
	      var itemData = Representing.getValue(item);
	      Representing.setValue(input, itemData);
	      setCursorAtEnd(input);
	    };
	    var setSelectionOn = function (input, f) {
	      var el = input.element;
	      var value = get$6(el);
	      var node = el.dom;
	      if (get$3(el, 'type') !== 'number') {
	        f(node, value);
	      }
	    };
	    var setCursorAtEnd = function (input) {
	      setSelectionOn(input, function (node, value) {
	        return node.setSelectionRange(value.length, value.length);
	      });
	    };
	    var setSelectionToEnd = function (input, startOffset) {
	      setSelectionOn(input, function (node, value) {
	        return node.setSelectionRange(startOffset, value.length);
	      });
	    };
	    var attemptSelectOver = function (model, input, item) {
	      if (!model.selectsOver) {
	        return Optional.none();
	      } else {
	        var currentValue = Representing.getValue(input);
	        var inputDisplay_1 = model.getDisplayText(currentValue);
	        var itemValue = Representing.getValue(item);
	        var itemDisplay = model.getDisplayText(itemValue);
	        return itemDisplay.indexOf(inputDisplay_1) === 0 ? Optional.some(function () {
	          setValueFromItem(model, input, item);
	          setSelectionToEnd(input, inputDisplay_1.length);
	        }) : Optional.none();
	      }
	    };
	
	    var itemExecute = constant('alloy.typeahead.itemexecute');
	
	    var make$5 = function (detail, components, spec, externals) {
	      var navigateList = function (comp, simulatedEvent, highlighter) {
	        detail.previewing.set(false);
	        var sandbox = Coupling.getCoupled(comp, 'sandbox');
	        if (Sandboxing.isOpen(sandbox)) {
	          Composing.getCurrent(sandbox).each(function (menu) {
	            Highlighting.getHighlighted(menu).fold(function () {
	              highlighter(menu);
	            }, function () {
	              dispatchEvent(sandbox, menu.element, 'keydown', simulatedEvent);
	            });
	          });
	        } else {
	          var onOpenSync = function (sandbox) {
	            Composing.getCurrent(sandbox).each(highlighter);
	          };
	          open$1(detail, mapFetch(comp), comp, sandbox, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	        }
	      };
	      var focusBehaviours$1 = focusBehaviours(detail);
	      var mapFetch = function (comp) {
	        return function (tdata) {
	          return tdata.map(function (data) {
	            var menus = values(data.menus);
	            var items = bind(menus, function (menu) {
	              return filter(menu.items, function (item) {
	                return item.type === 'item';
	              });
	            });
	            var repState = Representing.getState(comp);
	            repState.update(map(items, function (item) {
	              return item.data;
	            }));
	            return data;
	          });
	        };
	      };
	      var behaviours = [
	        Focusing.config({}),
	        Representing.config({
	          onSetValue: detail.onSetValue,
	          store: __assign({
	            mode: 'dataset',
	            getDataKey: function (comp) {
	              return get$6(comp.element);
	            },
	            getFallbackEntry: function (itemString) {
	              return {
	                value: itemString,
	                meta: {}
	              };
	            },
	            setValue: function (comp, data) {
	              set$3(comp.element, detail.model.getDisplayText(data));
	            }
	          }, detail.initialData.map(function (d) {
	            return wrap$1('initialValue', d);
	          }).getOr({}))
	        }),
	        Streaming.config({
	          stream: {
	            mode: 'throttle',
	            delay: detail.responseTime,
	            stopEvent: false
	          },
	          onStream: function (component, _simulatedEvent) {
	            var sandbox = Coupling.getCoupled(component, 'sandbox');
	            var focusInInput = Focusing.isFocused(component);
	            if (focusInInput) {
	              if (get$6(component.element).length >= detail.minChars) {
	                var previousValue_1 = Composing.getCurrent(sandbox).bind(function (menu) {
	                  return Highlighting.getHighlighted(menu).map(Representing.getValue);
	                });
	                detail.previewing.set(true);
	                var onOpenSync = function (_sandbox) {
	                  Composing.getCurrent(sandbox).each(function (menu) {
	                    previousValue_1.fold(function () {
	                      if (detail.model.selectsOver) {
	                        Highlighting.highlightFirst(menu);
	                      }
	                    }, function (pv) {
	                      Highlighting.highlightBy(menu, function (item) {
	                        var itemData = Representing.getValue(item);
	                        return itemData.value === pv.value;
	                      });
	                      Highlighting.getHighlighted(menu).orThunk(function () {
	                        Highlighting.highlightFirst(menu);
	                        return Optional.none();
	                      });
	                    });
	                  });
	                };
	                open$1(detail, mapFetch(component), component, sandbox, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	              }
	            }
	          },
	          cancelEvent: typeaheadCancel()
	        }),
	        Keying.config({
	          mode: 'special',
	          onDown: function (comp, simulatedEvent) {
	            navigateList(comp, simulatedEvent, Highlighting.highlightFirst);
	            return Optional.some(true);
	          },
	          onEscape: function (comp) {
	            var sandbox = Coupling.getCoupled(comp, 'sandbox');
	            if (Sandboxing.isOpen(sandbox)) {
	              Sandboxing.close(sandbox);
	              return Optional.some(true);
	            }
	            return Optional.none();
	          },
	          onUp: function (comp, simulatedEvent) {
	            navigateList(comp, simulatedEvent, Highlighting.highlightLast);
	            return Optional.some(true);
	          },
	          onEnter: function (comp) {
	            var sandbox = Coupling.getCoupled(comp, 'sandbox');
	            var sandboxIsOpen = Sandboxing.isOpen(sandbox);
	            if (sandboxIsOpen && !detail.previewing.get()) {
	              return Composing.getCurrent(sandbox).bind(function (menu) {
	                return Highlighting.getHighlighted(menu);
	              }).map(function (item) {
	                emitWith(comp, itemExecute(), { item: item });
	                return true;
	              });
	            } else {
	              var currentValue = Representing.getValue(comp);
	              emit(comp, typeaheadCancel());
	              detail.onExecute(sandbox, comp, currentValue);
	              if (sandboxIsOpen) {
	                Sandboxing.close(sandbox);
	              }
	              return Optional.some(true);
	            }
	          }
	        }),
	        Toggling.config({
	          toggleClass: detail.markers.openClass,
	          aria: { mode: 'expanded' }
	        }),
	        Coupling.config({
	          others: {
	            sandbox: function (hotspot) {
	              return makeSandbox(detail, hotspot, {
	                onOpen: function () {
	                  return Toggling.on(hotspot);
	                },
	                onClose: function () {
	                  return Toggling.off(hotspot);
	                }
	              });
	            }
	          }
	        }),
	        config('typeaheadevents', [
	          runOnExecute(function (comp) {
	            var onOpenSync = noop;
	            togglePopup(detail, mapFetch(comp), comp, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	          }),
	          run(itemExecute(), function (comp, se) {
	            var sandbox = Coupling.getCoupled(comp, 'sandbox');
	            setValueFromItem(detail.model, comp, se.event.item);
	            emit(comp, typeaheadCancel());
	            detail.onItemExecute(comp, sandbox, se.event.item, Representing.getValue(comp));
	            Sandboxing.close(sandbox);
	            setCursorAtEnd(comp);
	          })
	        ].concat(detail.dismissOnBlur ? [run(postBlur(), function (typeahead) {
	            var sandbox = Coupling.getCoupled(typeahead, 'sandbox');
	            if (search(sandbox.element).isNone()) {
	              Sandboxing.close(sandbox);
	            }
	          })] : []))
	      ];
	      return {
	        uid: detail.uid,
	        dom: dom$2(deepMerge(detail, {
	          inputAttributes: {
	            'role': 'combobox',
	            'aria-autocomplete': 'list',
	            'aria-haspopup': 'true'
	          }
	        })),
	        behaviours: __assign(__assign({}, focusBehaviours$1), augment(detail.typeaheadBehaviours, behaviours)),
	        eventOrder: detail.eventOrder
	      };
	    };
	
	    var schema$j = constant([
	      option('lazySink'),
	      strict$1('fetch'),
	      defaulted$1('minChars', 5),
	      defaulted$1('responseTime', 1000),
	      onHandler('onOpen'),
	      defaulted$1('getHotspot', Optional.some),
	      defaulted$1('getAnchorOverrides', constant({})),
	      defaulted$1('layouts', Optional.none()),
	      defaulted$1('eventOrder', {}),
	      defaultedObjOf('model', {}, [
	        defaulted$1('getDisplayText', function (itemData) {
	          return itemData.meta !== undefined && itemData.meta.text !== undefined ? itemData.meta.text : itemData.value;
	        }),
	        defaulted$1('selectsOver', true),
	        defaulted$1('populateFromBrowse', true)
	      ]),
	      onHandler('onSetValue'),
	      onKeyboardHandler('onExecute'),
	      onHandler('onItemExecute'),
	      defaulted$1('inputClasses', []),
	      defaulted$1('inputAttributes', {}),
	      defaulted$1('inputStyles', {}),
	      defaulted$1('matchWidth', true),
	      defaulted$1('useMinWidth', false),
	      defaulted$1('dismissOnBlur', true),
	      markers(['openClass']),
	      option('initialData'),
	      field$1('typeaheadBehaviours', [
	        Focusing,
	        Representing,
	        Streaming,
	        Keying,
	        Toggling,
	        Coupling
	      ]),
	      state$1('previewing', function () {
	        return Cell(true);
	      })
	    ].concat(schema$f()).concat(sandboxFields()));
	    var parts$6 = constant([external$1({
	        schema: [tieredMenuMarkers()],
	        name: 'menu',
	        overrides: function (detail) {
	          return {
	            fakeFocus: true,
	            onHighlight: function (menu, item) {
	              if (!detail.previewing.get()) {
	                menu.getSystem().getByUid(detail.uid).each(function (input) {
	                  if (detail.model.populateFromBrowse) {
	                    setValueFromItem(detail.model, input, item);
	                  }
	                });
	              } else {
	                menu.getSystem().getByUid(detail.uid).each(function (input) {
	                  attemptSelectOver(detail.model, input, item).fold(function () {
	                    return Highlighting.dehighlight(menu, item);
	                  }, function (fn) {
	                    return fn();
	                  });
	                });
	              }
	              detail.previewing.set(false);
	            },
	            onExecute: function (menu, item) {
	              return menu.getSystem().getByUid(detail.uid).toOptional().map(function (typeahead) {
	                emitWith(typeahead, itemExecute(), { item: item });
	                return true;
	              });
	            },
	            onHover: function (menu, item) {
	              detail.previewing.set(false);
	              menu.getSystem().getByUid(detail.uid).each(function (input) {
	                if (detail.model.populateFromBrowse) {
	                  setValueFromItem(detail.model, input, item);
	                }
	              });
	            }
	          };
	        }
	      })]);
	
	    var Typeahead = composite$1({
	      name: 'Typeahead',
	      configFields: schema$j(),
	      partFields: parts$6(),
	      factory: make$5
	    });
	
	    var wrap$2 = function (delegate) {
	      var toCached = function () {
	        return wrap$2(delegate.toCached());
	      };
	      var bindFuture = function (f) {
	        return wrap$2(delegate.bind(function (resA) {
	          return resA.fold(function (err) {
	            return Future.pure(Result.error(err));
	          }, function (a) {
	            return f(a);
	          });
	        }));
	      };
	      var bindResult = function (f) {
	        return wrap$2(delegate.map(function (resA) {
	          return resA.bind(f);
	        }));
	      };
	      var mapResult = function (f) {
	        return wrap$2(delegate.map(function (resA) {
	          return resA.map(f);
	        }));
	      };
	      var mapError = function (f) {
	        return wrap$2(delegate.map(function (resA) {
	          return resA.mapError(f);
	        }));
	      };
	      var foldResult = function (whenError, whenValue) {
	        return delegate.map(function (res) {
	          return res.fold(whenError, whenValue);
	        });
	      };
	      var withTimeout = function (timeout, errorThunk) {
	        return wrap$2(Future.nu(function (callback) {
	          var timedOut = false;
	          var timer = setTimeout(function () {
	            timedOut = true;
	            callback(Result.error(errorThunk()));
	          }, timeout);
	          delegate.get(function (result) {
	            if (!timedOut) {
	              clearTimeout(timer);
	              callback(result);
	            }
	          });
	        }));
	      };
	      return __assign(__assign({}, delegate), {
	        toCached: toCached,
	        bindFuture: bindFuture,
	        bindResult: bindResult,
	        mapResult: mapResult,
	        mapError: mapError,
	        foldResult: foldResult,
	        withTimeout: withTimeout
	      });
	    };
	    var nu$c = function (worker) {
	      return wrap$2(Future.nu(worker));
	    };
	    var value$2 = function (value) {
	      return wrap$2(Future.pure(Result.value(value)));
	    };
	    var error$1 = function (error) {
	      return wrap$2(Future.pure(Result.error(error)));
	    };
	    var fromResult$1 = function (result) {
	      return wrap$2(Future.pure(result));
	    };
	    var fromFuture = function (future) {
	      return wrap$2(future.map(Result.value));
	    };
	    var fromPromise = function (promise) {
	      return nu$c(function (completer) {
	        promise.then(function (value) {
	          completer(Result.value(value));
	        }, function (error) {
	          completer(Result.error(error));
	        });
	      });
	    };
	    var FutureResult = {
	      nu: nu$c,
	      wrap: wrap$2,
	      pure: value$2,
	      value: value$2,
	      error: error$1,
	      fromResult: fromResult$1,
	      fromFuture: fromFuture,
	      fromPromise: fromPromise
	    };
	
	    var separator$2 = { type: 'separator' };
	    var toMenuItem = function (target) {
	      return {
	        type: 'menuitem',
	        value: target.url,
	        text: target.title,
	        meta: { attach: target.attach },
	        onAction: noop
	      };
	    };
	    var staticMenuItem = function (title, url) {
	      return {
	        type: 'menuitem',
	        value: url,
	        text: title,
	        meta: { attach: undefined },
	        onAction: noop
	      };
	    };
	    var toMenuItems = function (targets) {
	      return map(targets, toMenuItem);
	    };
	    var filterLinkTargets = function (type, targets) {
	      return filter(targets, function (target) {
	        return target.type === type;
	      });
	    };
	    var filteredTargets = function (type, targets) {
	      return toMenuItems(filterLinkTargets(type, targets));
	    };
	    var headerTargets = function (linkInfo) {
	      return filteredTargets('header', linkInfo.targets);
	    };
	    var anchorTargets = function (linkInfo) {
	      return filteredTargets('anchor', linkInfo.targets);
	    };
	    var anchorTargetTop = function (linkInfo) {
	      return Optional.from(linkInfo.anchorTop).map(function (url) {
	        return staticMenuItem('<top>', url);
	      }).toArray();
	    };
	    var anchorTargetBottom = function (linkInfo) {
	      return Optional.from(linkInfo.anchorBottom).map(function (url) {
	        return staticMenuItem('<bottom>', url);
	      }).toArray();
	    };
	    var historyTargets = function (history) {
	      return map(history, function (url) {
	        return staticMenuItem(url, url);
	      });
	    };
	    var joinMenuLists = function (items) {
	      return foldl(items, function (a, b) {
	        var bothEmpty = a.length === 0 || b.length === 0;
	        return bothEmpty ? a.concat(b) : a.concat(separator$2, b);
	      }, []);
	    };
	    var filterByQuery = function (term, menuItems) {
	      var lowerCaseTerm = term.toLowerCase();
	      return filter(menuItems, function (item) {
	        var text = item.meta !== undefined && item.meta.text !== undefined ? item.meta.text : item.text;
	        return contains$1(text.toLowerCase(), lowerCaseTerm) || contains$1(item.value.toLowerCase(), lowerCaseTerm);
	      });
	    };
	
	    var getItems = function (fileType, input, urlBackstage) {
	      var urlInputValue = Representing.getValue(input);
	      var term = urlInputValue.meta.text !== undefined ? urlInputValue.meta.text : urlInputValue.value;
	      var info = urlBackstage.getLinkInformation();
	      return info.fold(function () {
	        return [];
	      }, function (linkInfo) {
	        var history = filterByQuery(term, historyTargets(urlBackstage.getHistory(fileType)));
	        return fileType === 'file' ? joinMenuLists([
	          history,
	          filterByQuery(term, headerTargets(linkInfo)),
	          filterByQuery(term, flatten([
	            anchorTargetTop(linkInfo),
	            anchorTargets(linkInfo),
	            anchorTargetBottom(linkInfo)
	          ]))
	        ]) : history;
	      });
	    };
	    var errorId = generate$1('aria-invalid');
	    var renderUrlInput = function (spec, backstage, urlBackstage) {
	      var _a;
	      var providersBackstage = backstage.shared.providers;
	      var updateHistory = function (component) {
	        var urlEntry = Representing.getValue(component);
	        urlBackstage.addToHistory(urlEntry.value, spec.filetype);
	      };
	      var pField = FormField.parts.field({
	        factory: Typeahead,
	        dismissOnBlur: true,
	        inputClasses: ['tox-textfield'],
	        sandboxClasses: ['tox-dialog__popups'],
	        inputAttributes: {
	          'aria-errormessage': errorId,
	          'type': 'url'
	        },
	        minChars: 0,
	        responseTime: 0,
	        fetch: function (input) {
	          var items = getItems(spec.filetype, input, urlBackstage);
	          var tdata = build$2(items, ItemResponse$1.BUBBLE_TO_SANDBOX, backstage, false);
	          return Future.pure(tdata);
	        },
	        getHotspot: function (comp) {
	          return memUrlBox.getOpt(comp);
	        },
	        onSetValue: function (comp, _newValue) {
	          if (comp.hasConfigured(Invalidating)) {
	            Invalidating.run(comp).get(noop);
	          }
	        },
	        typeaheadBehaviours: derive$1(flatten([
	          urlBackstage.getValidationHandler().map(function (handler) {
	            return Invalidating.config({
	              getRoot: function (comp) {
	                return parent(comp.element);
	              },
	              invalidClass: 'tox-control-wrap--status-invalid',
	              notify: {
	                onInvalid: function (comp, err) {
	                  memInvalidIcon.getOpt(comp).each(function (invalidComp) {
	                    set$1(invalidComp.element, 'title', providersBackstage.translate(err));
	                  });
	                }
	              },
	              validator: {
	                validate: function (input) {
	                  var urlEntry = Representing.getValue(input);
	                  return FutureResult.nu(function (completer) {
	                    handler({
	                      type: spec.filetype,
	                      url: urlEntry.value
	                    }, function (validation) {
	                      if (validation.status === 'invalid') {
	                        var err = Result.error(validation.message);
	                        completer(err);
	                      } else {
	                        var val = Result.value(validation.message);
	                        completer(val);
	                      }
	                    });
	                  });
	                },
	                validateOnLoad: false
	              }
	            });
	          }).toArray(),
	          [
	            Disabling.config({
	              disabled: function () {
	                return spec.disabled || providersBackstage.isDisabled();
	              }
	            }),
	            Tabstopping.config({}),
	            config('urlinput-events', flatten([
	              spec.filetype === 'file' ? [run(input(), function (comp) {
	                  emitWith(comp, formChangeEvent, { name: spec.name });
	                })] : [],
	              [
	                run(change(), function (comp) {
	                  emitWith(comp, formChangeEvent, { name: spec.name });
	                  updateHistory(comp);
	                }),
	                run(postPaste(), function (comp) {
	                  emitWith(comp, formChangeEvent, { name: spec.name });
	                  updateHistory(comp);
	                })
	              ]
	            ]))
	          ]
	        ])),
	        eventOrder: (_a = {}, _a[input()] = [
	          'streaming',
	          'urlinput-events',
	          'invalidating'
	        ], _a),
	        model: {
	          getDisplayText: function (itemData) {
	            return itemData.value;
	          },
	          selectsOver: false,
	          populateFromBrowse: false
	        },
	        markers: { openClass: 'tox-textfield--popup-open' },
	        lazySink: backstage.shared.getSink,
	        parts: { menu: part(false, 1, 'normal') },
	        onExecute: function (_menu, component, _entry) {
	          emitWith(component, formSubmitEvent, {});
	        },
	        onItemExecute: function (typeahead, _sandbox, _item, _value) {
	          updateHistory(typeahead);
	          emitWith(typeahead, formChangeEvent, { name: spec.name });
	        }
	      });
	      var pLabel = spec.label.map(function (label) {
	        return renderLabel(label, providersBackstage);
	      });
	      var makeIcon = function (name, errId, icon, label) {
	        if (icon === void 0) {
	          icon = name;
	        }
	        if (label === void 0) {
	          label = name;
	        }
	        return {
	          dom: {
	            tag: 'div',
	            classes: [
	              'tox-icon',
	              'tox-control-wrap__status-icon-' + name
	            ],
	            innerHtml: get$e(icon, providersBackstage.icons),
	            attributes: __assign({
	              'title': providersBackstage.translate(label),
	              'aria-live': 'polite'
	            }, errId.fold(function () {
	              return {};
	            }, function (id) {
	              return { id: id };
	            }))
	          }
	        };
	      };
	      var memInvalidIcon = record(makeIcon('invalid', Optional.some(errorId), 'warning'));
	      var memStatus = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-control-wrap__status-icon-wrap']
	        },
	        components: [memInvalidIcon.asSpec()]
	      });
	      var optUrlPicker = urlBackstage.getUrlPicker(spec.filetype);
	      var browseUrlEvent = generate$1('browser.url.event');
	      var memUrlBox = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-control-wrap']
	        },
	        components: [
	          pField,
	          memStatus.asSpec()
	        ],
	        behaviours: derive$1([Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            }
	          })])
	      });
	      var memUrlPickerButton = record(renderButton({
	        name: spec.name,
	        icon: Optional.some('browse'),
	        text: spec.label.getOr(''),
	        disabled: spec.disabled,
	        primary: false,
	        borderless: true
	      }, function (component) {
	        return emit(component, browseUrlEvent);
	      }, providersBackstage, [], ['tox-browse-url']));
	      var controlHWrapper = function () {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__controls-h-stack']
	          },
	          components: flatten([
	            [memUrlBox.asSpec()],
	            optUrlPicker.map(function () {
	              return memUrlPickerButton.asSpec();
	            }).toArray()
	          ])
	        };
	      };
	      var openUrlPicker = function (comp) {
	        Composing.getCurrent(comp).each(function (field) {
	          var componentData = Representing.getValue(field);
	          var urlData = __assign({ fieldname: spec.name }, componentData);
	          optUrlPicker.each(function (picker) {
	            picker(urlData).get(function (chosenData) {
	              Representing.setValue(field, chosenData);
	              emitWith(comp, formChangeEvent, { name: spec.name });
	            });
	          });
	        });
	      };
	      return FormField.sketch({
	        dom: renderFormFieldDom(),
	        components: pLabel.toArray().concat([controlHWrapper()]),
	        fieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providersBackstage.isDisabled();
	            },
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	              memUrlPickerButton.getOpt(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	              memUrlPickerButton.getOpt(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig(),
	          config('url-input-events', [run(browseUrlEvent, openUrlPicker)])
	        ])
	      });
	    };
	
	    var renderAlertBanner = function (spec, providersBackstage) {
	      return Container.sketch({
	        dom: {
	          tag: 'div',
	          attributes: { role: 'alert' },
	          classes: [
	            'tox-notification',
	            'tox-notification--in',
	            'tox-notification--' + spec.level
	          ]
	        },
	        components: [
	          {
	            dom: {
	              tag: 'div',
	              classes: ['tox-notification__icon']
	            },
	            components: [Button.sketch({
	                dom: {
	                  tag: 'button',
	                  classes: [
	                    'tox-button',
	                    'tox-button--naked',
	                    'tox-button--icon'
	                  ],
	                  innerHtml: get$e(spec.icon, providersBackstage.icons),
	                  attributes: { title: providersBackstage.translate(spec.iconTooltip) }
	                },
	                action: function (comp) {
	                  emitWith(comp, formActionEvent, {
	                    name: 'alert-banner',
	                    value: spec.url
	                  });
	                }
	              })]
	          },
	          {
	            dom: {
	              tag: 'div',
	              classes: ['tox-notification__body'],
	              innerHtml: providersBackstage.translate(spec.text)
	            }
	          }
	        ]
	      });
	    };
	
	    var renderCheckbox = function (spec, providerBackstage) {
	      var repBehaviour = Representing.config({
	        store: {
	          mode: 'manual',
	          getValue: function (comp) {
	            var el = comp.element.dom;
	            return el.checked;
	          },
	          setValue: function (comp, value) {
	            var el = comp.element.dom;
	            el.checked = value;
	          }
	        }
	      });
	      var toggleCheckboxHandler = function (comp) {
	        comp.element.dom.click();
	        return Optional.some(true);
	      };
	      var pField = FormField.parts.field({
	        factory: { sketch: identity },
	        dom: {
	          tag: 'input',
	          classes: ['tox-checkbox__input'],
	          attributes: { type: 'checkbox' }
	        },
	        behaviours: derive$1([
	          ComposingConfigs.self(),
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providerBackstage.isDisabled();
	            }
	          }),
	          Tabstopping.config({}),
	          Focusing.config({}),
	          repBehaviour,
	          Keying.config({
	            mode: 'special',
	            onEnter: toggleCheckboxHandler,
	            onSpace: toggleCheckboxHandler,
	            stopSpaceKeyup: true
	          }),
	          config('checkbox-events', [run(change(), function (component, _) {
	              emitWith(component, formChangeEvent, { name: spec.name });
	            })])
	        ])
	      });
	      var pLabel = FormField.parts.label({
	        dom: {
	          tag: 'span',
	          classes: ['tox-checkbox__label'],
	          innerHtml: providerBackstage.translate(spec.label)
	        },
	        behaviours: derive$1([Unselecting.config({})])
	      });
	      var makeIcon = function (className) {
	        var iconName = className === 'checked' ? 'selected' : 'unselected';
	        return {
	          dom: {
	            tag: 'span',
	            classes: [
	              'tox-icon',
	              'tox-checkbox-icon__' + className
	            ],
	            innerHtml: get$e(iconName, providerBackstage.icons)
	          }
	        };
	      };
	      var memIcons = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-checkbox__icons']
	        },
	        components: [
	          makeIcon('checked'),
	          makeIcon('unchecked')
	        ]
	      });
	      return FormField.sketch({
	        dom: {
	          tag: 'label',
	          classes: ['tox-checkbox']
	        },
	        components: [
	          pField,
	          memIcons.asSpec(),
	          pLabel
	        ],
	        fieldBehaviours: derive$1([
	          Disabling.config({
	            disabled: function () {
	              return spec.disabled || providerBackstage.isDisabled();
	            },
	            disableClass: 'tox-checkbox--disabled',
	            onDisabled: function (comp) {
	              FormField.getField(comp).each(Disabling.disable);
	            },
	            onEnabled: function (comp) {
	              FormField.getField(comp).each(Disabling.enable);
	            }
	          }),
	          receivingConfig()
	        ])
	      });
	    };
	
	    var renderHtmlPanel = function (spec) {
	      if (spec.presets === 'presentation') {
	        return Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__group'],
	            innerHtml: spec.html
	          }
	        });
	      } else {
	        return Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-form__group'],
	            innerHtml: spec.html,
	            attributes: { role: 'document' }
	          },
	          containerBehaviours: derive$1([
	            Tabstopping.config({}),
	            Focusing.config({})
	          ])
	        });
	      }
	    };
	
	    var make$6 = function (render) {
	      return function (parts, spec, backstage) {
	        return get$1(spec, 'name').fold(function () {
	          return render(spec, backstage);
	        }, function (fieldName) {
	          return parts.field(fieldName, render(spec, backstage));
	        });
	      };
	    };
	    var makeIframe = function (render) {
	      return function (parts, spec, backstage) {
	        var iframeSpec = deepMerge(spec, { source: 'dynamic' });
	        return make$6(render)(parts, iframeSpec, backstage);
	      };
	    };
	    var factories = {
	      bar: make$6(function (spec, backstage) {
	        return renderBar(spec, backstage.shared);
	      }),
	      collection: make$6(function (spec, backstage) {
	        return renderCollection(spec, backstage.shared.providers);
	      }),
	      alertbanner: make$6(function (spec, backstage) {
	        return renderAlertBanner(spec, backstage.shared.providers);
	      }),
	      input: make$6(function (spec, backstage) {
	        return renderInput(spec, backstage.shared.providers);
	      }),
	      textarea: make$6(function (spec, backstage) {
	        return renderTextarea(spec, backstage.shared.providers);
	      }),
	      label: make$6(function (spec, backstage) {
	        return renderLabel$2(spec, backstage.shared);
	      }),
	      iframe: makeIframe(function (spec, backstage) {
	        return renderIFrame(spec, backstage.shared.providers);
	      }),
	      button: make$6(function (spec, backstage) {
	        return renderDialogButton(spec, backstage.shared.providers);
	      }),
	      checkbox: make$6(function (spec, backstage) {
	        return renderCheckbox(spec, backstage.shared.providers);
	      }),
	      colorinput: make$6(function (spec, backstage) {
	        return renderColorInput(spec, backstage.shared, backstage.colorinput);
	      }),
	      colorpicker: make$6(renderColorPicker),
	      dropzone: make$6(function (spec, backstage) {
	        return renderDropZone(spec, backstage.shared.providers);
	      }),
	      grid: make$6(function (spec, backstage) {
	        return renderGrid(spec, backstage.shared);
	      }),
	      listbox: make$6(function (spec, backstage) {
	        return renderListBox(spec, backstage);
	      }),
	      selectbox: make$6(function (spec, backstage) {
	        return renderSelectBox(spec, backstage.shared.providers);
	      }),
	      sizeinput: make$6(function (spec, backstage) {
	        return renderSizeInput(spec, backstage.shared.providers);
	      }),
	      urlinput: make$6(function (spec, backstage) {
	        return renderUrlInput(spec, backstage, backstage.urlinput);
	      }),
	      customeditor: make$6(renderCustomEditor),
	      htmlpanel: make$6(renderHtmlPanel),
	      imagetools: make$6(function (spec, backstage) {
	        return renderImageTools(spec, backstage.shared.providers);
	      }),
	      table: make$6(function (spec, backstage) {
	        return renderTable(spec, backstage.shared.providers);
	      }),
	      panel: make$6(function (spec, backstage) {
	        return renderPanel(spec, backstage);
	      })
	    };
	    var noFormParts = {
	      field: function (_name, spec) {
	        return spec;
	      }
	    };
	    var interpretInForm = function (parts, spec, oldBackstage) {
	      var newBackstage = deepMerge(oldBackstage, {
	        shared: {
	          interpreter: function (childSpec) {
	            return interpretParts(parts, childSpec, newBackstage);
	          }
	        }
	      });
	      return interpretParts(parts, spec, newBackstage);
	    };
	    var interpretParts = function (parts, spec, backstage) {
	      return get$1(factories, spec.type).fold(function () {
	        console.error('Unknown factory type "' + spec.type + '", defaulting to container: ', spec);
	        return spec;
	      }, function (factory) {
	        return factory(parts, spec, backstage);
	      });
	    };
	    var interpretWithoutForm = function (spec, backstage) {
	      var parts = noFormParts;
	      return interpretParts(parts, spec, backstage);
	    };
	
	    var bubbleAlignments = {
	      valignCentre: [],
	      alignCentre: [],
	      alignLeft: [],
	      alignRight: [],
	      right: [],
	      left: [],
	      bottom: [],
	      top: []
	    };
	    var getInlineDialogAnchor = function (contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor) {
	      var bubble = nu$8(-12, 12, bubbleAlignments);
	      var overrides = { maxHeightFunction: expandable() };
	      var editableAreaAnchor = function () {
	        return {
	          anchor: 'node',
	          root: getContentContainer(contentAreaElement()),
	          node: Optional.from(contentAreaElement()),
	          bubble: bubble,
	          layouts: {
	            onRtl: function () {
	              return [northwest$3];
	            },
	            onLtr: function () {
	              return [northeast$3];
	            }
	          },
	          overrides: overrides
	        };
	      };
	      var standardAnchor = function () {
	        return {
	          anchor: 'hotspot',
	          hotspot: lazyAnchorbar(),
	          bubble: bubble,
	          layouts: {
	            onRtl: function () {
	              return [southeast$1];
	            },
	            onLtr: function () {
	              return [southwest$1];
	            }
	          },
	          overrides: overrides
	        };
	      };
	      return function () {
	        return lazyUseEditableAreaAnchor() ? editableAreaAnchor() : standardAnchor();
	      };
	    };
	    var getBannerAnchor = function (contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor) {
	      var editableAreaAnchor = function () {
	        return {
	          anchor: 'node',
	          root: getContentContainer(contentAreaElement()),
	          node: Optional.from(contentAreaElement()),
	          layouts: {
	            onRtl: function () {
	              return [north$3];
	            },
	            onLtr: function () {
	              return [north$3];
	            }
	          }
	        };
	      };
	      var standardAnchor = function () {
	        return {
	          anchor: 'hotspot',
	          hotspot: lazyAnchorbar(),
	          layouts: {
	            onRtl: function () {
	              return [south$1];
	            },
	            onLtr: function () {
	              return [south$1];
	            }
	          }
	        };
	      };
	      return function () {
	        return lazyUseEditableAreaAnchor() ? editableAreaAnchor() : standardAnchor();
	      };
	    };
	    var getCursorAnchor = function (editor, bodyElement) {
	      return function () {
	        return {
	          anchor: 'selection',
	          root: bodyElement(),
	          getSelection: function () {
	            var rng = editor.selection.getRng();
	            return Optional.some(SimSelection.range(SugarElement.fromDom(rng.startContainer), rng.startOffset, SugarElement.fromDom(rng.endContainer), rng.endOffset));
	          }
	        };
	      };
	    };
	    var getNodeAnchor = function (bodyElement) {
	      return function (element) {
	        return {
	          anchor: 'node',
	          root: bodyElement(),
	          node: element
	        };
	      };
	    };
	    var getAnchors = function (editor, lazyAnchorbar, isToolbarTop) {
	      var useFixedToolbarContainer = useFixedContainer(editor);
	      var bodyElement = function () {
	        return SugarElement.fromDom(editor.getBody());
	      };
	      var contentAreaElement = function () {
	        return SugarElement.fromDom(editor.getContentAreaContainer());
	      };
	      var lazyUseEditableAreaAnchor = function () {
	        return useFixedToolbarContainer || !isToolbarTop();
	      };
	      return {
	        inlineDialog: getInlineDialogAnchor(contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor),
	        banner: getBannerAnchor(contentAreaElement, lazyAnchorbar, lazyUseEditableAreaAnchor),
	        cursor: getCursorAnchor(editor, bodyElement),
	        node: getNodeAnchor(bodyElement)
	      };
	    };
	
	    var colorPicker = function (editor) {
	      return function (callback, value) {
	        var dialog = colorPickerDialog(editor);
	        dialog(callback, value);
	      };
	    };
	    var hasCustomColors$1 = function (editor) {
	      return function () {
	        return hasCustomColors(editor);
	      };
	    };
	    var getColors$2 = function (editor) {
	      return function () {
	        return getColors(editor);
	      };
	    };
	    var getColorCols$2 = function (editor) {
	      return function () {
	        return getColorCols$1(editor);
	      };
	    };
	    var ColorInputBackstage = function (editor) {
	      return {
	        colorPicker: colorPicker(editor),
	        hasCustomColors: hasCustomColors$1(editor),
	        getColors: getColors$2(editor),
	        getColorCols: getColorCols$2(editor)
	      };
	    };
	
	    var isDraggableModal$1 = function (editor) {
	      return function () {
	        return isDraggableModal(editor);
	      };
	    };
	    var DialogBackstage = function (editor) {
	      return { isDraggableModal: isDraggableModal$1(editor) };
	    };
	
	    var HeaderBackstage = function (editor) {
	      var mode = Cell(isToolbarLocationBottom(editor) ? 'bottom' : 'top');
	      return {
	        isPositionedAtTop: function () {
	          return mode.get() === 'top';
	        },
	        getDockingMode: mode.get,
	        setDockingMode: mode.set
	      };
	    };
	
	    var defaultStyleFormats = [
	      {
	        title: 'Headings',
	        items: [
	          {
	            title: 'Heading 1',
	            format: 'h1'
	          },
	          {
	            title: 'Heading 2',
	            format: 'h2'
	          },
	          {
	            title: 'Heading 3',
	            format: 'h3'
	          },
	          {
	            title: 'Heading 4',
	            format: 'h4'
	          },
	          {
	            title: 'Heading 5',
	            format: 'h5'
	          },
	          {
	            title: 'Heading 6',
	            format: 'h6'
	          }
	        ]
	      },
	      {
	        title: 'Inline',
	        items: [
	          {
	            title: 'Bold',
	            format: 'bold'
	          },
	          {
	            title: 'Italic',
	            format: 'italic'
	          },
	          {
	            title: 'Underline',
	            format: 'underline'
	          },
	          {
	            title: 'Strikethrough',
	            format: 'strikethrough'
	          },
	          {
	            title: 'Superscript',
	            format: 'superscript'
	          },
	          {
	            title: 'Subscript',
	            format: 'subscript'
	          },
	          {
	            title: 'Code',
	            format: 'code'
	          }
	        ]
	      },
	      {
	        title: 'Blocks',
	        items: [
	          {
	            title: 'Paragraph',
	            format: 'p'
	          },
	          {
	            title: 'Blockquote',
	            format: 'blockquote'
	          },
	          {
	            title: 'Div',
	            format: 'div'
	          },
	          {
	            title: 'Pre',
	            format: 'pre'
	          }
	        ]
	      },
	      {
	        title: 'Align',
	        items: [
	          {
	            title: 'Left',
	            format: 'alignleft'
	          },
	          {
	            title: 'Center',
	            format: 'aligncenter'
	          },
	          {
	            title: 'Right',
	            format: 'alignright'
	          },
	          {
	            title: 'Justify',
	            format: 'alignjustify'
	          }
	        ]
	      }
	    ];
	    var isNestedFormat = function (format) {
	      return has(format, 'items');
	    };
	    var isBlockFormat = function (format) {
	      return has(format, 'block');
	    };
	    var isInlineFormat = function (format) {
	      return has(format, 'inline');
	    };
	    var isSelectorFormat = function (format) {
	      return has(format, 'selector');
	    };
	    var mapFormats = function (userFormats) {
	      return foldl(userFormats, function (acc, fmt) {
	        if (isNestedFormat(fmt)) {
	          var result = mapFormats(fmt.items);
	          return {
	            customFormats: acc.customFormats.concat(result.customFormats),
	            formats: acc.formats.concat([{
	                title: fmt.title,
	                items: result.formats
	              }])
	          };
	        } else if (isInlineFormat(fmt) || isBlockFormat(fmt) || isSelectorFormat(fmt)) {
	          var formatName = isString(fmt.name) ? fmt.name : fmt.title.toLowerCase();
	          var formatNameWithPrefix = 'custom-' + formatName;
	          return {
	            customFormats: acc.customFormats.concat([{
	                name: formatNameWithPrefix,
	                format: fmt
	              }]),
	            formats: acc.formats.concat([{
	                title: fmt.title,
	                format: formatNameWithPrefix,
	                icon: fmt.icon
	              }])
	          };
	        } else {
	          return __assign(__assign({}, acc), { formats: acc.formats.concat(fmt) });
	        }
	      }, {
	        customFormats: [],
	        formats: []
	      });
	    };
	    var registerCustomFormats = function (editor, userFormats) {
	      var result = mapFormats(userFormats);
	      var registerFormats = function (customFormats) {
	        each(customFormats, function (fmt) {
	          if (!editor.formatter.has(fmt.name)) {
	            editor.formatter.register(fmt.name, fmt.format);
	          }
	        });
	      };
	      if (editor.formatter) {
	        registerFormats(result.customFormats);
	      } else {
	        editor.on('init', function () {
	          registerFormats(result.customFormats);
	        });
	      }
	      return result.formats;
	    };
	    var getStyleFormats = function (editor) {
	      return getUserStyleFormats(editor).map(function (userFormats) {
	        var registeredUserFormats = registerCustomFormats(editor, userFormats);
	        return isMergeStyleFormats(editor) ? defaultStyleFormats.concat(registeredUserFormats) : registeredUserFormats;
	      }).getOr(defaultStyleFormats);
	    };
	
	    var processBasic = function (item, isSelectedFor, getPreviewFor) {
	      var formatterSpec = {
	        type: 'formatter',
	        isSelected: isSelectedFor(item.format),
	        getStylePreview: getPreviewFor(item.format)
	      };
	      return deepMerge(item, formatterSpec);
	    };
	    var register$3 = function (editor, formats, isSelectedFor, getPreviewFor) {
	      var enrichSupported = function (item) {
	        return processBasic(item, isSelectedFor, getPreviewFor);
	      };
	      var enrichMenu = function (item) {
	        var submenuSpec = { type: 'submenu' };
	        return deepMerge(item, submenuSpec);
	      };
	      var enrichCustom = function (item) {
	        var formatName = isString(item.name) ? item.name : generate$1(item.title);
	        var formatNameWithPrefix = 'custom-' + formatName;
	        var customSpec = {
	          type: 'formatter',
	          format: formatNameWithPrefix,
	          isSelected: isSelectedFor(formatNameWithPrefix),
	          getStylePreview: getPreviewFor(formatNameWithPrefix)
	        };
	        var newItem = deepMerge(item, customSpec);
	        editor.formatter.register(formatName, newItem);
	        return newItem;
	      };
	      var doEnrich = function (items) {
	        return map(items, function (item) {
	          var keys$1 = keys(item);
	          if (hasNonNullableKey(item, 'items')) {
	            var newItems_1 = doEnrich(item.items);
	            return deepMerge(enrichMenu(item), {
	              getStyleItems: function () {
	                return newItems_1;
	              }
	            });
	          } else if (hasNonNullableKey(item, 'format')) {
	            return enrichSupported(item);
	          } else if (keys$1.length === 1 && contains(keys$1, 'title')) {
	            return deepMerge(item, { type: 'separator' });
	          } else {
	            return enrichCustom(item);
	          }
	        });
	      };
	      return doEnrich(formats);
	    };
	
	    var init$7 = function (editor) {
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (format) {
	        return function () {
	          var fmt = editor.formatter.get(format);
	          return fmt !== undefined ? Optional.some({
	            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
	            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
	          }) : Optional.none();
	        };
	      };
	      var flatten = function (fmt) {
	        var subs = fmt.items;
	        return subs !== undefined && subs.length > 0 ? bind(subs, flatten) : [fmt.format];
	      };
	      var settingsFormats = Cell([]);
	      var settingsFlattenedFormats = Cell([]);
	      var eventsFormats = Cell([]);
	      var eventsFlattenedFormats = Cell([]);
	      var replaceSettings = Cell(false);
	      editor.on('PreInit', function (_e) {
	        var formats = getStyleFormats(editor);
	        var enriched = register$3(editor, formats, isSelectedFor, getPreviewFor);
	        settingsFormats.set(enriched);
	        settingsFlattenedFormats.set(bind(enriched, flatten));
	      });
	      editor.on('addStyleModifications', function (e) {
	        var modifications = register$3(editor, e.items, isSelectedFor, getPreviewFor);
	        eventsFormats.set(modifications);
	        replaceSettings.set(e.replace);
	        eventsFlattenedFormats.set(bind(modifications, flatten));
	      });
	      var getData = function () {
	        var fromSettings = replaceSettings.get() ? [] : settingsFormats.get();
	        var fromEvents = eventsFormats.get();
	        return fromSettings.concat(fromEvents);
	      };
	      var getFlattenedKeys = function () {
	        var fromSettings = replaceSettings.get() ? [] : settingsFlattenedFormats.get();
	        var fromEvents = eventsFlattenedFormats.get();
	        return fromSettings.concat(fromEvents);
	      };
	      return {
	        getData: getData,
	        getFlattenedKeys: getFlattenedKeys
	      };
	    };
	
	    var isElement$2 = function (node) {
	      return isNonNullable(node) && node.nodeType === 1;
	    };
	    var trim$1 = global$c.trim;
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement$2(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var create$8 = function (type, title, url, level, attach) {
	      return {
	        type: type,
	        title: title,
	        url: url,
	        level: level,
	        attach: attach
	      };
	    };
	    var isChildOfContentEditableTrue = function (node) {
	      while (node = node.parentNode) {
	        var value = node.contentEditable;
	        if (value && value !== 'inherit') {
	          return isContentEditableTrue(node);
	        }
	      }
	      return false;
	    };
	    var select = function (selector, root) {
	      return map(descendants(SugarElement.fromDom(root), selector), function (element) {
	        return element.dom;
	      });
	    };
	    var getElementText = function (elm) {
	      return elm.innerText || elm.textContent;
	    };
	    var getOrGenerateId = function (elm) {
	      return elm.id ? elm.id : generate$1('h');
	    };
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName === 'A' && (elm.id || elm.name) !== undefined;
	    };
	    var isValidAnchor = function (elm) {
	      return isAnchor(elm) && isEditable(elm);
	    };
	    var isHeader = function (elm) {
	      return elm && /^(H[1-6])$/.test(elm.nodeName);
	    };
	    var isEditable = function (elm) {
	      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
	    };
	    var isValidHeader = function (elm) {
	      return isHeader(elm) && isEditable(elm);
	    };
	    var getLevel = function (elm) {
	      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
	    };
	    var headerTarget = function (elm) {
	      var headerId = getOrGenerateId(elm);
	      var attach = function () {
	        elm.id = headerId;
	      };
	      return create$8('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
	    };
	    var anchorTarget = function (elm) {
	      var anchorId = elm.id || elm.name;
	      var anchorText = getElementText(elm);
	      return create$8('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, noop);
	    };
	    var getHeaderTargets = function (elms) {
	      return map(filter(elms, isValidHeader), headerTarget);
	    };
	    var getAnchorTargets = function (elms) {
	      return map(filter(elms, isValidAnchor), anchorTarget);
	    };
	    var getTargetElements = function (elm) {
	      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
	      return elms;
	    };
	    var hasTitle = function (target) {
	      return trim$1(target.title).length > 0;
	    };
	    var find$5 = function (elm) {
	      var elms = getTargetElements(elm);
	      return filter(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
	    };
	    var LinkTargets = { find: find$5 };
	
	    var STORAGE_KEY = 'tinymce-url-history';
	    var HISTORY_LENGTH = 5;
	    var isHttpUrl = function (url) {
	      return isString(url) && /^https?/.test(url);
	    };
	    var isArrayOfUrl = function (a) {
	      return isArray(a) && a.length <= HISTORY_LENGTH && forall(a, isHttpUrl);
	    };
	    var isRecordOfUrlArray = function (r) {
	      return isObject(r) && find$1(r, function (value) {
	        return !isArrayOfUrl(value);
	      }).isNone();
	    };
	    var getAllHistory = function () {
	      var unparsedHistory = global$9.getItem(STORAGE_KEY);
	      if (unparsedHistory === null) {
	        return {};
	      }
	      var history;
	      try {
	        history = JSON.parse(unparsedHistory);
	      } catch (e) {
	        if (e instanceof SyntaxError) {
	          console.log('Local storage ' + STORAGE_KEY + ' was not valid JSON', e);
	          return {};
	        }
	        throw e;
	      }
	      if (!isRecordOfUrlArray(history)) {
	        console.log('Local storage ' + STORAGE_KEY + ' was not valid format', history);
	        return {};
	      }
	      return history;
	    };
	    var setAllHistory = function (history) {
	      if (!isRecordOfUrlArray(history)) {
	        throw new Error('Bad format for history:\n' + JSON.stringify(history));
	      }
	      global$9.setItem(STORAGE_KEY, JSON.stringify(history));
	    };
	    var getHistory = function (fileType) {
	      var history = getAllHistory();
	      return Object.prototype.hasOwnProperty.call(history, fileType) ? history[fileType] : [];
	    };
	    var addToHistory = function (url, fileType) {
	      if (!isHttpUrl(url)) {
	        return;
	      }
	      var history = getAllHistory();
	      var items = Object.prototype.hasOwnProperty.call(history, fileType) ? history[fileType] : [];
	      var itemsWithoutUrl = filter(items, function (item) {
	        return item !== url;
	      });
	      history[fileType] = [url].concat(itemsWithoutUrl).slice(0, HISTORY_LENGTH);
	      setAllHistory(history);
	    };
	
	    var isTruthy = function (value) {
	      return !!value;
	    };
	    var makeMap = function (value) {
	      return map$2(global$c.makeMap(value, /[, ]/), isTruthy);
	    };
	    var getPicker = function (editor) {
	      return Optional.from(getFilePickerCallback(editor)).filter(isFunction);
	    };
	    var getPickerTypes = function (editor) {
	      var optFileTypes = Optional.some(getFilePickerTypes(editor)).filter(isTruthy);
	      var optLegacyTypes = Optional.some(getFileBrowserCallbackTypes(editor)).filter(isTruthy);
	      var optTypes = optFileTypes.or(optLegacyTypes).map(makeMap);
	      return getPicker(editor).fold(never, function (_picker) {
	        return optTypes.fold(always, function (types) {
	          return keys(types).length > 0 ? types : false;
	        });
	      });
	    };
	    var getPickerSetting = function (editor, filetype) {
	      var pickerTypes = getPickerTypes(editor);
	      if (isBoolean(pickerTypes)) {
	        return pickerTypes ? getPicker(editor) : Optional.none();
	      } else {
	        return pickerTypes[filetype] ? getPicker(editor) : Optional.none();
	      }
	    };
	    var getUrlPicker = function (editor, filetype) {
	      return getPickerSetting(editor, filetype).map(function (picker) {
	        return function (entry) {
	          return Future.nu(function (completer) {
	            var handler = function (value, meta) {
	              if (!isString(value)) {
	                throw new Error('Expected value to be string');
	              }
	              if (meta !== undefined && !isObject(meta)) {
	                throw new Error('Expected meta to be a object');
	              }
	              var r = {
	                value: value,
	                meta: meta
	              };
	              completer(r);
	            };
	            var meta = __assign({
	              filetype: filetype,
	              fieldname: entry.fieldname
	            }, Optional.from(entry.meta).getOr({}));
	            picker.call(editor, handler, entry.value, meta);
	          });
	        };
	      });
	    };
	    var getTextSetting = function (value) {
	      return Optional.from(value).filter(isString).getOrUndefined();
	    };
	    var getLinkInformation = function (editor) {
	      if (noTypeaheadUrls(editor)) {
	        return Optional.none();
	      }
	      return Optional.some({
	        targets: LinkTargets.find(editor.getBody()),
	        anchorTop: getTextSetting(getAnchorTop(editor)),
	        anchorBottom: getTextSetting(getAnchorBottom(editor))
	      });
	    };
	    var getValidationHandler = function (editor) {
	      return Optional.from(getFilePickerValidatorHandler(editor));
	    };
	    var UrlInputBackstage = function (editor) {
	      return {
	        getHistory: getHistory,
	        addToHistory: addToHistory,
	        getLinkInformation: function () {
	          return getLinkInformation(editor);
	        },
	        getValidationHandler: function () {
	          return getValidationHandler(editor);
	        },
	        getUrlPicker: function (filetype) {
	          return getUrlPicker(editor, filetype);
	        }
	      };
	    };
	
	    var init$8 = function (sink, editor, lazyAnchorbar) {
	      var contextMenuState = Cell(false);
	      var toolbar = HeaderBackstage(editor);
	      var backstage = {
	        shared: {
	          providers: {
	            icons: function () {
	              return editor.ui.registry.getAll().icons;
	            },
	            menuItems: function () {
	              return editor.ui.registry.getAll().menuItems;
	            },
	            translate: global$6.translate,
	            isDisabled: function () {
	              return editor.mode.isReadOnly() || editor.ui.isDisabled();
	            },
	            getSetting: editor.getParam.bind(editor)
	          },
	          interpreter: function (s) {
	            return interpretWithoutForm(s, backstage);
	          },
	          anchors: getAnchors(editor, lazyAnchorbar, toolbar.isPositionedAtTop),
	          header: toolbar,
	          getSink: function () {
	            return Result.value(sink);
	          }
	        },
	        urlinput: UrlInputBackstage(editor),
	        styleselect: init$7(editor),
	        colorinput: ColorInputBackstage(editor),
	        dialog: DialogBackstage(editor),
	        isContextMenuOpen: function () {
	          return contextMenuState.get();
	        },
	        setContextMenuState: function (state) {
	          return contextMenuState.set(state);
	        }
	      };
	      return backstage;
	    };
	
	    var expandable$1 = constant(function (element, available) {
	      setMax$1(element, Math.floor(available));
	    });
	
	    var showContextToolbarEvent = 'contexttoolbar-show';
	    var hideContextToolbarEvent = 'contexttoolbar-hide';
	
	    var schema$k = constant([
	      strict$1('dom'),
	      defaulted$1('shell', true),
	      field$1('toolbarBehaviours', [Replacing])
	    ]);
	    var enhanceGroups = function () {
	      return { behaviours: derive$1([Replacing.config({})]) };
	    };
	    var parts$7 = constant([optional({
	        name: 'groups',
	        overrides: enhanceGroups
	      })]);
	
	    var factory$9 = function (detail, components, _spec, _externals) {
	      var setGroups = function (toolbar, groups) {
	        getGroupContainer(toolbar).fold(function () {
	          console.error('Toolbar was defined to not be a shell, but no groups container was specified in components');
	          throw new Error('Toolbar was defined to not be a shell, but no groups container was specified in components');
	        }, function (container) {
	          Replacing.set(container, groups);
	        });
	      };
	      var getGroupContainer = function (component) {
	        return detail.shell ? Optional.some(component) : getPart(component, detail, 'groups');
	      };
	      var extra = detail.shell ? {
	        behaviours: [Replacing.config({})],
	        components: []
	      } : {
	        behaviours: [],
	        components: components
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: extra.components,
	        behaviours: augment(detail.toolbarBehaviours, extra.behaviours),
	        apis: { setGroups: setGroups },
	        domModification: { attributes: { role: 'group' } }
	      };
	    };
	    var Toolbar = composite$1({
	      name: 'Toolbar',
	      configFields: schema$k(),
	      partFields: parts$7(),
	      factory: factory$9,
	      apis: {
	        setGroups: function (apis, toolbar, groups) {
	          apis.setGroups(toolbar, groups);
	        }
	      }
	    });
	
	    var generate$6 = function (xs, f) {
	      var init = {
	        len: 0,
	        list: []
	      };
	      var r = foldl(xs, function (b, a) {
	        var value = f(a, b.len);
	        return value.fold(constant(b), function (v) {
	          return {
	            len: v.finish,
	            list: b.list.concat([v])
	          };
	        });
	      }, init);
	      return r.list;
	    };
	
	    var output$1 = function (within, extra, withinWidth) {
	      return {
	        within: within,
	        extra: extra,
	        withinWidth: withinWidth
	      };
	    };
	    var apportion = function (units, total, len) {
	      var parray = generate$6(units, function (unit, current) {
	        var width = len(unit);
	        return Optional.some({
	          element: unit,
	          start: current,
	          finish: current + width,
	          width: width
	        });
	      });
	      var within = filter(parray, function (unit) {
	        return unit.finish <= total;
	      });
	      var withinWidth = foldr(within, function (acc, el) {
	        return acc + el.width;
	      }, 0);
	      var extra = parray.slice(within.length);
	      return {
	        within: within,
	        extra: extra,
	        withinWidth: withinWidth
	      };
	    };
	    var toUnit = function (parray) {
	      return map(parray, function (unit) {
	        return unit.element;
	      });
	    };
	    var fitLast = function (within, extra, withinWidth) {
	      var fits = toUnit(within.concat(extra));
	      return output$1(fits, [], withinWidth);
	    };
	    var overflow = function (within, extra, overflower, withinWidth) {
	      var fits = toUnit(within).concat([overflower]);
	      return output$1(fits, toUnit(extra), withinWidth);
	    };
	    var fitAll = function (within, extra, withinWidth) {
	      return output$1(toUnit(within), [], withinWidth);
	    };
	    var tryFit = function (total, units, len) {
	      var divide = apportion(units, total, len);
	      return divide.extra.length === 0 ? Optional.some(divide) : Optional.none();
	    };
	    var partition$3 = function (total, units, len, overflower) {
	      var divide = tryFit(total, units, len).getOrThunk(function () {
	        return apportion(units, total - len(overflower), len);
	      });
	      var within = divide.within;
	      var extra = divide.extra;
	      var withinWidth = divide.withinWidth;
	      if (extra.length === 1 && extra[0].width <= len(overflower)) {
	        return fitLast(within, extra, withinWidth);
	      } else if (extra.length >= 1) {
	        return overflow(within, extra, overflower, withinWidth);
	      } else {
	        return fitAll(within, extra, withinWidth);
	      }
	    };
	
	    var setGroups = function (toolbar, storedGroups) {
	      var bGroups = map(storedGroups, function (g) {
	        return premade$1(g);
	      });
	      Toolbar.setGroups(toolbar, bGroups);
	    };
	    var findFocusedComp = function (comps) {
	      return findMap(comps, function (comp) {
	        return search(comp.element).bind(function (focusedElm) {
	          return comp.getSystem().getByDom(focusedElm).toOptional();
	        });
	      });
	    };
	    var refresh = function (toolbar, detail, setOverflow) {
	      var primary = getPartOrDie(toolbar, detail, 'primary');
	      var overflowGroup = Coupling.getCoupled(toolbar, 'overflowGroup');
	      set$2(primary.element, 'visibility', 'hidden');
	      var groups = detail.builtGroups.get().concat([overflowGroup]);
	      var focusedComp = findFocusedComp(groups);
	      setOverflow([]);
	      setGroups(primary, groups);
	      var availableWidth = get$8(primary.element);
	      var overflows = partition$3(availableWidth, detail.builtGroups.get(), function (comp) {
	        return get$8(comp.element);
	      }, overflowGroup);
	      if (overflows.extra.length === 0) {
	        Replacing.remove(primary, overflowGroup);
	        setOverflow([]);
	      } else {
	        setGroups(primary, overflows.within);
	        setOverflow(overflows.extra);
	      }
	      remove$6(primary.element, 'visibility');
	      reflow(primary.element);
	      focusedComp.each(Focusing.focus);
	    };
	
	    var schema$l = constant([
	      field$1('splitToolbarBehaviours', [Coupling]),
	      state$1('builtGroups', function () {
	        return Cell([]);
	      })
	    ]);
	
	    var schema$m = constant([
	      markers(['overflowToggledClass']),
	      optionFunction('getOverflowBounds'),
	      strict$1('lazySink'),
	      state$1('overflowGroups', function () {
	        return Cell([]);
	      })
	    ].concat(schema$l()));
	    var parts$8 = constant([
	      required({
	        factory: Toolbar,
	        schema: schema$k(),
	        name: 'primary'
	      }),
	      external$1({
	        schema: schema$k(),
	        name: 'overflow'
	      }),
	      external$1({ name: 'overflow-button' }),
	      external$1({ name: 'overflow-group' })
	    ]);
	
	    var schema$n = constant([
	      markers(['toggledClass']),
	      strict$1('lazySink'),
	      strictFunction('fetch'),
	      optionFunction('getBounds'),
	      optionObjOf('fireDismissalEventInstead', [defaulted$1('event', dismissRequested())]),
	      schema$1()
	    ]);
	    var parts$9 = constant([
	      external$1({
	        name: 'button',
	        overrides: function (detail) {
	          return {
	            dom: { attributes: { 'aria-haspopup': 'true' } },
	            buttonBehaviours: derive$1([Toggling.config({
	                toggleClass: detail.markers.toggledClass,
	                aria: { mode: 'expanded' },
	                toggleOnExecute: false
	              })])
	          };
	        }
	      }),
	      external$1({
	        factory: Toolbar,
	        schema: schema$k(),
	        name: 'toolbar',
	        overrides: function (detail) {
	          return {
	            toolbarBehaviours: derive$1([Keying.config({
	                mode: 'cyclic',
	                onEscape: function (comp) {
	                  getPart(comp, detail, 'button').each(Focusing.focus);
	                  return Optional.none();
	                }
	              })])
	          };
	        }
	      })
	    ]);
	
	    var toggle$2 = function (button, externals) {
	      var toolbarSandbox = Coupling.getCoupled(button, 'toolbarSandbox');
	      if (Sandboxing.isOpen(toolbarSandbox)) {
	        Sandboxing.close(toolbarSandbox);
	      } else {
	        Sandboxing.open(toolbarSandbox, externals.toolbar());
	      }
	    };
	    var position$2 = function (button, toolbar, detail, layouts) {
	      var bounds = detail.getBounds.map(function (bounder) {
	        return bounder();
	      });
	      var sink = detail.lazySink(button).getOrDie();
	      Positioning.positionWithinBounds(sink, {
	        anchor: 'hotspot',
	        hotspot: button,
	        layouts: layouts,
	        overrides: { maxWidthFunction: expandable$1() }
	      }, toolbar, bounds);
	    };
	    var setGroups$1 = function (button, toolbar, detail, layouts, groups) {
	      Toolbar.setGroups(toolbar, groups);
	      position$2(button, toolbar, detail, layouts);
	      Toggling.on(button);
	    };
	    var makeSandbox$1 = function (button, spec, detail) {
	      var ariaOwner = manager();
	      var onOpen = function (sandbox, toolbar) {
	        detail.fetch().get(function (groups) {
	          setGroups$1(button, toolbar, detail, spec.layouts, groups);
	          ariaOwner.link(button.element);
	          Keying.focusIn(toolbar);
	        });
	      };
	      var onClose = function () {
	        Toggling.off(button);
	        Focusing.focus(button);
	        ariaOwner.unlink(button.element);
	      };
	      return {
	        dom: {
	          tag: 'div',
	          attributes: { id: ariaOwner.id }
	        },
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'special',
	            onEscape: function (comp) {
	              Sandboxing.close(comp);
	              return Optional.some(true);
	            }
	          }),
	          Sandboxing.config({
	            onOpen: onOpen,
	            onClose: onClose,
	            isPartOf: function (container, data, queryElem) {
	              return isPartOf(data, queryElem) || isPartOf(button, queryElem);
	            },
	            getAttachPoint: function () {
	              return detail.lazySink(button).getOrDie();
	            }
	          }),
	          Receiving.config({
	            channels: __assign(__assign({}, receivingChannel(__assign({ isExtraPart: never }, detail.fireDismissalEventInstead.map(function (fe) {
	              return { fireEventInstead: { event: fe.event } };
	            }).getOr({})))), receivingChannel$1({
	              doReposition: function () {
	                Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
	                  position$2(button, toolbar, detail, spec.layouts);
	                });
	              }
	            }))
	          })
	        ])
	      };
	    };
	    var factory$a = function (detail, components, spec, externals) {
	      return __assign(__assign({}, Button.sketch(__assign(__assign({}, externals.button()), {
	        action: function (button) {
	          toggle$2(button, externals);
	        },
	        buttonBehaviours: SketchBehaviours.augment({ dump: externals.button().buttonBehaviours }, [Coupling.config({
	            others: {
	              toolbarSandbox: function (button) {
	                return makeSandbox$1(button, spec, detail);
	              }
	            }
	          })])
	      }))), {
	        apis: {
	          setGroups: function (button, groups) {
	            Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
	              setGroups$1(button, toolbar, detail, spec.layouts, groups);
	            });
	          },
	          reposition: function (button) {
	            Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox')).each(function (toolbar) {
	              position$2(button, toolbar, detail, spec.layouts);
	            });
	          },
	          toggle: function (button) {
	            toggle$2(button, externals);
	          },
	          getToolbar: function (button) {
	            return Sandboxing.getState(Coupling.getCoupled(button, 'toolbarSandbox'));
	          },
	          isOpen: function (button) {
	            return Sandboxing.isOpen(Coupling.getCoupled(button, 'toolbarSandbox'));
	          }
	        }
	      });
	    };
	    var FloatingToolbarButton = composite$1({
	      name: 'FloatingToolbarButton',
	      factory: factory$a,
	      configFields: schema$n(),
	      partFields: parts$9(),
	      apis: {
	        setGroups: function (apis, button, groups) {
	          apis.setGroups(button, groups);
	        },
	        reposition: function (apis, button) {
	          apis.reposition(button);
	        },
	        toggle: function (apis, button) {
	          apis.toggle(button);
	        },
	        getToolbar: function (apis, button) {
	          return apis.getToolbar(button);
	        },
	        isOpen: function (apis, button) {
	          return apis.isOpen(button);
	        }
	      }
	    });
	
	    var schema$o = constant([
	      strict$1('items'),
	      markers(['itemSelector']),
	      field$1('tgroupBehaviours', [Keying])
	    ]);
	    var parts$a = constant([group({
	        name: 'items',
	        unit: 'item'
	      })]);
	
	    var factory$b = function (detail, components, _spec, _externals) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.tgroupBehaviours, [Keying.config({
	            mode: 'flow',
	            selector: detail.markers.itemSelector
	          })]),
	        domModification: { attributes: { role: 'toolbar' } }
	      };
	    };
	    var ToolbarGroup = composite$1({
	      name: 'ToolbarGroup',
	      configFields: schema$o(),
	      partFields: parts$a(),
	      factory: factory$b
	    });
	
	    var buildGroups = function (comps) {
	      return map(comps, function (g) {
	        return premade$1(g);
	      });
	    };
	    var refresh$1 = function (toolbar, memFloatingToolbarButton, detail) {
	      refresh(toolbar, detail, function (overflowGroups) {
	        detail.overflowGroups.set(overflowGroups);
	        memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
	          FloatingToolbarButton.setGroups(floatingToolbarButton, buildGroups(overflowGroups));
	        });
	      });
	    };
	    var factory$c = function (detail, components, spec, externals) {
	      var memFloatingToolbarButton = record(FloatingToolbarButton.sketch({
	        fetch: function () {
	          return Future.nu(function (resolve) {
	            resolve(buildGroups(detail.overflowGroups.get()));
	          });
	        },
	        layouts: {
	          onLtr: function () {
	            return [
	              southwest$1,
	              southeast$1
	            ];
	          },
	          onRtl: function () {
	            return [
	              southeast$1,
	              southwest$1
	            ];
	          },
	          onBottomLtr: function () {
	            return [
	              northwest$1,
	              northeast$1
	            ];
	          },
	          onBottomRtl: function () {
	            return [
	              northeast$1,
	              northwest$1
	            ];
	          }
	        },
	        getBounds: spec.getOverflowBounds,
	        lazySink: detail.lazySink,
	        fireDismissalEventInstead: {},
	        markers: { toggledClass: detail.markers.overflowToggledClass },
	        parts: {
	          button: externals['overflow-button'](),
	          toolbar: externals.overflow()
	        }
	      }));
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.splitToolbarBehaviours, [Coupling.config({
	            others: {
	              overflowGroup: function () {
	                return ToolbarGroup.sketch(__assign(__assign({}, externals['overflow-group']()), { items: [memFloatingToolbarButton.asSpec()] }));
	              }
	            }
	          })]),
	        apis: {
	          setGroups: function (toolbar, groups) {
	            detail.builtGroups.set(map(groups, toolbar.getSystem().build));
	            refresh$1(toolbar, memFloatingToolbarButton, detail);
	          },
	          refresh: function (toolbar) {
	            return refresh$1(toolbar, memFloatingToolbarButton, detail);
	          },
	          toggle: function (toolbar) {
	            memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
	              FloatingToolbarButton.toggle(floatingToolbarButton);
	            });
	          },
	          isOpen: function (toolbar) {
	            return memFloatingToolbarButton.getOpt(toolbar).map(FloatingToolbarButton.isOpen).getOr(false);
	          },
	          reposition: function (toolbar) {
	            memFloatingToolbarButton.getOpt(toolbar).each(function (floatingToolbarButton) {
	              FloatingToolbarButton.reposition(floatingToolbarButton);
	            });
	          },
	          getOverflow: function (toolbar) {
	            return memFloatingToolbarButton.getOpt(toolbar).bind(FloatingToolbarButton.getToolbar);
	          }
	        },
	        domModification: { attributes: { role: 'group' } }
	      };
	    };
	    var SplitFloatingToolbar = composite$1({
	      name: 'SplitFloatingToolbar',
	      configFields: schema$m(),
	      partFields: parts$8(),
	      factory: factory$c,
	      apis: {
	        setGroups: function (apis, toolbar, groups) {
	          apis.setGroups(toolbar, groups);
	        },
	        refresh: function (apis, toolbar) {
	          apis.refresh(toolbar);
	        },
	        reposition: function (apis, toolbar) {
	          apis.reposition(toolbar);
	        },
	        toggle: function (apis, toolbar) {
	          apis.toggle(toolbar);
	        },
	        isOpen: function (apis, toolbar) {
	          return apis.isOpen(toolbar);
	        },
	        getOverflow: function (apis, toolbar) {
	          return apis.getOverflow(toolbar);
	        }
	      }
	    });
	
	    var getAnimationRoot = function (component, slideConfig) {
	      return slideConfig.getAnimationRoot.fold(function () {
	        return component.element;
	      }, function (get) {
	        return get(component);
	      });
	    };
	
	    var getDimensionProperty = function (slideConfig) {
	      return slideConfig.dimension.property;
	    };
	    var getDimension = function (slideConfig, elem) {
	      return slideConfig.dimension.getDimension(elem);
	    };
	    var disableTransitions = function (component, slideConfig) {
	      var root = getAnimationRoot(component, slideConfig);
	      remove$5(root, [
	        slideConfig.shrinkingClass,
	        slideConfig.growingClass
	      ]);
	    };
	    var setShrunk = function (component, slideConfig) {
	      remove$4(component.element, slideConfig.openClass);
	      add$2(component.element, slideConfig.closedClass);
	      set$2(component.element, getDimensionProperty(slideConfig), '0px');
	      reflow(component.element);
	    };
	    var setGrown = function (component, slideConfig) {
	      remove$4(component.element, slideConfig.closedClass);
	      add$2(component.element, slideConfig.openClass);
	      remove$6(component.element, getDimensionProperty(slideConfig));
	    };
	    var doImmediateShrink = function (component, slideConfig, slideState, _calculatedSize) {
	      slideState.setCollapsed();
	      set$2(component.element, getDimensionProperty(slideConfig), getDimension(slideConfig, component.element));
	      reflow(component.element);
	      disableTransitions(component, slideConfig);
	      setShrunk(component, slideConfig);
	      slideConfig.onStartShrink(component);
	      slideConfig.onShrunk(component);
	    };
	    var doStartShrink = function (component, slideConfig, slideState, calculatedSize) {
	      var size = calculatedSize.getOrThunk(function () {
	        return getDimension(slideConfig, component.element);
	      });
	      slideState.setCollapsed();
	      set$2(component.element, getDimensionProperty(slideConfig), size);
	      reflow(component.element);
	      var root = getAnimationRoot(component, slideConfig);
	      remove$4(root, slideConfig.growingClass);
	      add$2(root, slideConfig.shrinkingClass);
	      setShrunk(component, slideConfig);
	      slideConfig.onStartShrink(component);
	    };
	    var doStartSmartShrink = function (component, slideConfig, slideState) {
	      var size = getDimension(slideConfig, component.element);
	      var shrinker = size === '0px' ? doImmediateShrink : doStartShrink;
	      shrinker(component, slideConfig, slideState, Optional.some(size));
	    };
	    var doStartGrow = function (component, slideConfig, slideState) {
	      var root = getAnimationRoot(component, slideConfig);
	      var wasShrinking = has$2(root, slideConfig.shrinkingClass);
	      var beforeSize = getDimension(slideConfig, component.element);
	      setGrown(component, slideConfig);
	      var fullSize = getDimension(slideConfig, component.element);
	      var startPartialGrow = function () {
	        set$2(component.element, getDimensionProperty(slideConfig), beforeSize);
	        reflow(component.element);
	      };
	      var startCompleteGrow = function () {
	        setShrunk(component, slideConfig);
	      };
	      var setStartSize = wasShrinking ? startPartialGrow : startCompleteGrow;
	      setStartSize();
	      remove$4(root, slideConfig.shrinkingClass);
	      add$2(root, slideConfig.growingClass);
	      setGrown(component, slideConfig);
	      set$2(component.element, getDimensionProperty(slideConfig), fullSize);
	      slideState.setExpanded();
	      slideConfig.onStartGrow(component);
	    };
	    var refresh$2 = function (component, slideConfig, slideState) {
	      if (slideState.isExpanded()) {
	        remove$6(component.element, getDimensionProperty(slideConfig));
	        var fullSize = getDimension(slideConfig, component.element);
	        set$2(component.element, getDimensionProperty(slideConfig), fullSize);
	      }
	    };
	    var grow = function (component, slideConfig, slideState) {
	      if (!slideState.isExpanded()) {
	        doStartGrow(component, slideConfig, slideState);
	      }
	    };
	    var shrink = function (component, slideConfig, slideState) {
	      if (slideState.isExpanded()) {
	        doStartSmartShrink(component, slideConfig, slideState);
	      }
	    };
	    var immediateShrink = function (component, slideConfig, slideState) {
	      if (slideState.isExpanded()) {
	        doImmediateShrink(component, slideConfig, slideState, Optional.none());
	      }
	    };
	    var hasGrown = function (component, slideConfig, slideState) {
	      return slideState.isExpanded();
	    };
	    var hasShrunk = function (component, slideConfig, slideState) {
	      return slideState.isCollapsed();
	    };
	    var isGrowing = function (component, slideConfig, _slideState) {
	      var root = getAnimationRoot(component, slideConfig);
	      return has$2(root, slideConfig.growingClass) === true;
	    };
	    var isShrinking = function (component, slideConfig, _slideState) {
	      var root = getAnimationRoot(component, slideConfig);
	      return has$2(root, slideConfig.shrinkingClass) === true;
	    };
	    var isTransitioning = function (component, slideConfig, slideState) {
	      return isGrowing(component, slideConfig) || isShrinking(component, slideConfig);
	    };
	    var toggleGrow = function (component, slideConfig, slideState) {
	      var f = slideState.isExpanded() ? doStartSmartShrink : doStartGrow;
	      f(component, slideConfig, slideState);
	    };
	
	    var SlidingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        refresh: refresh$2,
	        grow: grow,
	        shrink: shrink,
	        immediateShrink: immediateShrink,
	        hasGrown: hasGrown,
	        hasShrunk: hasShrunk,
	        isGrowing: isGrowing,
	        isShrinking: isShrinking,
	        isTransitioning: isTransitioning,
	        toggleGrow: toggleGrow,
	        disableTransitions: disableTransitions
	    });
	
	    var exhibit$6 = function (base, slideConfig, _slideState) {
	      var expanded = slideConfig.expanded;
	      return expanded ? nu$6({
	        classes: [slideConfig.openClass],
	        styles: {}
	      }) : nu$6({
	        classes: [slideConfig.closedClass],
	        styles: wrap$1(slideConfig.dimension.property, '0px')
	      });
	    };
	    var events$d = function (slideConfig, slideState) {
	      return derive([runOnSource(transitionend(), function (component, simulatedEvent) {
	          var raw = simulatedEvent.event.raw;
	          if (raw.propertyName === slideConfig.dimension.property) {
	            disableTransitions(component, slideConfig);
	            if (slideState.isExpanded()) {
	              remove$6(component.element, slideConfig.dimension.property);
	            }
	            var notify = slideState.isExpanded() ? slideConfig.onGrown : slideConfig.onShrunk;
	            notify(component);
	          }
	        })]);
	    };
	
	    var ActiveSliding = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        exhibit: exhibit$6,
	        events: events$d
	    });
	
	    var SlidingSchema = [
	      strict$1('closedClass'),
	      strict$1('openClass'),
	      strict$1('shrinkingClass'),
	      strict$1('growingClass'),
	      option('getAnimationRoot'),
	      onHandler('onShrunk'),
	      onHandler('onStartShrink'),
	      onHandler('onGrown'),
	      onHandler('onStartGrow'),
	      defaulted$1('expanded', false),
	      strictOf('dimension', choose$1('property', {
	        width: [
	          output('property', 'width'),
	          output('getDimension', function (elem) {
	            return get$8(elem) + 'px';
	          })
	        ],
	        height: [
	          output('property', 'height'),
	          output('getDimension', function (elem) {
	            return get$7(elem) + 'px';
	          })
	        ]
	      }))
	    ];
	
	    var init$9 = function (spec) {
	      var state = Cell(spec.expanded);
	      var readState = function () {
	        return 'expanded: ' + state.get();
	      };
	      return nu$5({
	        isExpanded: function () {
	          return state.get() === true;
	        },
	        isCollapsed: function () {
	          return state.get() === false;
	        },
	        setCollapsed: curry(state.set, false),
	        setExpanded: curry(state.set, true),
	        readState: readState
	      });
	    };
	
	    var SlidingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$9
	    });
	
	    var Sliding = create$1({
	      fields: SlidingSchema,
	      name: 'sliding',
	      active: ActiveSliding,
	      apis: SlidingApis,
	      state: SlidingState
	    });
	
	    var schema$p = constant([
	      markers([
	        'closedClass',
	        'openClass',
	        'shrinkingClass',
	        'growingClass',
	        'overflowToggledClass'
	      ]),
	      onHandler('onOpened'),
	      onHandler('onClosed')
	    ].concat(schema$l()));
	    var parts$b = constant([
	      required({
	        factory: Toolbar,
	        schema: schema$k(),
	        name: 'primary'
	      }),
	      required({
	        factory: Toolbar,
	        schema: schema$k(),
	        name: 'overflow',
	        overrides: function (detail) {
	          return {
	            toolbarBehaviours: derive$1([
	              Sliding.config({
	                dimension: { property: 'height' },
	                closedClass: detail.markers.closedClass,
	                openClass: detail.markers.openClass,
	                shrinkingClass: detail.markers.shrinkingClass,
	                growingClass: detail.markers.growingClass,
	                onShrunk: function (comp) {
	                  getPart(comp, detail, 'overflow-button').each(function (button) {
	                    Toggling.off(button);
	                    Focusing.focus(button);
	                  });
	                  detail.onClosed(comp);
	                },
	                onGrown: function (comp) {
	                  Keying.focusIn(comp);
	                  detail.onOpened(comp);
	                },
	                onStartGrow: function (comp) {
	                  getPart(comp, detail, 'overflow-button').each(Toggling.on);
	                }
	              }),
	              Keying.config({
	                mode: 'acyclic',
	                onEscape: function (comp) {
	                  getPart(comp, detail, 'overflow-button').each(Focusing.focus);
	                  return Optional.some(true);
	                }
	              })
	            ])
	          };
	        }
	      }),
	      external$1({
	        name: 'overflow-button',
	        overrides: function (detail) {
	          return {
	            buttonBehaviours: derive$1([Toggling.config({
	                toggleClass: detail.markers.overflowToggledClass,
	                aria: { mode: 'pressed' },
	                toggleOnExecute: false
	              })])
	          };
	        }
	      }),
	      external$1({ name: 'overflow-group' })
	    ]);
	
	    var isOpen$1 = function (toolbar, detail) {
	      return getPart(toolbar, detail, 'overflow').map(Sliding.hasGrown).getOr(false);
	    };
	    var toggleToolbar = function (toolbar, detail) {
	      getPart(toolbar, detail, 'overflow-button').bind(function () {
	        return getPart(toolbar, detail, 'overflow');
	      }).each(function (overf) {
	        refresh$3(toolbar, detail);
	        Sliding.toggleGrow(overf);
	      });
	    };
	    var refresh$3 = function (toolbar, detail) {
	      getPart(toolbar, detail, 'overflow').each(function (overflow) {
	        refresh(toolbar, detail, function (groups) {
	          var builtGroups = map(groups, function (g) {
	            return premade$1(g);
	          });
	          Toolbar.setGroups(overflow, builtGroups);
	        });
	        getPart(toolbar, detail, 'overflow-button').each(function (button) {
	          if (Sliding.hasGrown(overflow)) {
	            Toggling.on(button);
	          }
	        });
	        Sliding.refresh(overflow);
	      });
	    };
	    var factory$d = function (detail, components, spec, externals) {
	      var toolbarToggleEvent = 'alloy.toolbar.toggle';
	      var doSetGroups = function (toolbar, groups) {
	        var built = map(groups, toolbar.getSystem().build);
	        detail.builtGroups.set(built);
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: augment(detail.splitToolbarBehaviours, [
	          Coupling.config({
	            others: {
	              overflowGroup: function (toolbar) {
	                return ToolbarGroup.sketch(__assign(__assign({}, externals['overflow-group']()), {
	                  items: [Button.sketch(__assign(__assign({}, externals['overflow-button']()), {
	                      action: function (_button) {
	                        emit(toolbar, toolbarToggleEvent);
	                      }
	                    }))]
	                }));
	              }
	            }
	          }),
	          config('toolbar-toggle-events', [run(toolbarToggleEvent, function (toolbar) {
	              toggleToolbar(toolbar, detail);
	            })])
	        ]),
	        apis: {
	          setGroups: function (toolbar, groups) {
	            doSetGroups(toolbar, groups);
	            refresh$3(toolbar, detail);
	          },
	          refresh: function (toolbar) {
	            return refresh$3(toolbar, detail);
	          },
	          toggle: function (toolbar) {
	            return toggleToolbar(toolbar, detail);
	          },
	          isOpen: function (toolbar) {
	            return isOpen$1(toolbar, detail);
	          }
	        },
	        domModification: { attributes: { role: 'group' } }
	      };
	    };
	    var SplitSlidingToolbar = composite$1({
	      name: 'SplitSlidingToolbar',
	      configFields: schema$p(),
	      partFields: parts$b(),
	      factory: factory$d,
	      apis: {
	        setGroups: function (apis, toolbar, groups) {
	          apis.setGroups(toolbar, groups);
	        },
	        refresh: function (apis, toolbar) {
	          apis.refresh(toolbar);
	        },
	        toggle: function (apis, toolbar) {
	          apis.toggle(toolbar);
	        },
	        isOpen: function (apis, toolbar) {
	          return apis.isOpen(toolbar);
	        }
	      }
	    });
	
	    var toolbarHeightChange = constant(generate$1('toolbar-height-change'));
	
	    var renderToolbarGroupCommon = function (toolbarGroup) {
	      var attributes = toolbarGroup.title.fold(function () {
	        return {};
	      }, function (title) {
	        return { attributes: { title: title } };
	      });
	      return {
	        dom: __assign({
	          tag: 'div',
	          classes: ['tox-toolbar__group']
	        }, attributes),
	        components: [ToolbarGroup.parts.items({})],
	        items: toolbarGroup.items,
	        markers: { itemSelector: '*:not(.tox-split-button) > .tox-tbtn:not([disabled]), ' + '.tox-split-button:not([disabled]), ' + '.tox-toolbar-nav-js:not([disabled])' },
	        tgroupBehaviours: derive$1([
	          Tabstopping.config({}),
	          Focusing.config({})
	        ])
	      };
	    };
	    var renderToolbarGroup = function (toolbarGroup) {
	      return ToolbarGroup.sketch(renderToolbarGroupCommon(toolbarGroup));
	    };
	    var getToolbarbehaviours = function (toolbarSpec, modeName) {
	      var onAttached = runOnAttached(function (component) {
	        var groups = map(toolbarSpec.initGroups, renderToolbarGroup);
	        Toolbar.setGroups(component, groups);
	      });
	      return derive$1([
	        DisablingConfigs.toolbarButton(toolbarSpec.providers.isDisabled),
	        receivingConfig(),
	        Keying.config({
	          mode: modeName,
	          onEscape: toolbarSpec.onEscape,
	          selector: '.tox-toolbar__group'
	        }),
	        config('toolbar-events', [onAttached])
	      ]);
	    };
	    var renderMoreToolbarCommon = function (toolbarSpec) {
	      var modeName = toolbarSpec.cyclicKeying ? 'cyclic' : 'acyclic';
	      return {
	        uid: toolbarSpec.uid,
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar-overlord']
	        },
	        parts: {
	          'overflow-group': renderToolbarGroupCommon({
	            title: Optional.none(),
	            items: []
	          }),
	          'overflow-button': renderIconButtonSpec({
	            name: 'more',
	            icon: Optional.some('more-drawer'),
	            disabled: false,
	            tooltip: Optional.some('More...'),
	            primary: false,
	            borderless: false
	          }, Optional.none(), toolbarSpec.providers)
	        },
	        splitToolbarBehaviours: getToolbarbehaviours(toolbarSpec, modeName)
	      };
	    };
	    var renderFloatingMoreToolbar = function (toolbarSpec) {
	      var baseSpec = renderMoreToolbarCommon(toolbarSpec);
	      var overflowXOffset = 4;
	      var primary = SplitFloatingToolbar.parts.primary({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar__primary']
	        }
	      });
	      return SplitFloatingToolbar.sketch(__assign(__assign({}, baseSpec), {
	        lazySink: toolbarSpec.getSink,
	        getOverflowBounds: function () {
	          var headerElem = toolbarSpec.moreDrawerData.lazyHeader().element;
	          var headerBounds = absolute$1(headerElem);
	          var docElem = documentElement(headerElem);
	          var docBounds = absolute$1(docElem);
	          var height = Math.max(docElem.dom.scrollHeight, docBounds.height);
	          return bounds$1(headerBounds.x + overflowXOffset, docBounds.y, headerBounds.width - overflowXOffset * 2, height);
	        },
	        parts: __assign(__assign({}, baseSpec.parts), {
	          overflow: {
	            dom: {
	              tag: 'div',
	              classes: ['tox-toolbar__overflow'],
	              attributes: toolbarSpec.attributes
	            }
	          }
	        }),
	        components: [primary],
	        markers: { overflowToggledClass: 'tox-tbtn--enabled' }
	      }));
	    };
	    var renderSlidingMoreToolbar = function (toolbarSpec) {
	      var primary = SplitSlidingToolbar.parts.primary({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar__primary']
	        }
	      });
	      var overflow = SplitSlidingToolbar.parts.overflow({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar__overflow']
	        }
	      });
	      var baseSpec = renderMoreToolbarCommon(toolbarSpec);
	      return SplitSlidingToolbar.sketch(__assign(__assign({}, baseSpec), {
	        components: [
	          primary,
	          overflow
	        ],
	        markers: {
	          openClass: 'tox-toolbar__overflow--open',
	          closedClass: 'tox-toolbar__overflow--closed',
	          growingClass: 'tox-toolbar__overflow--growing',
	          shrinkingClass: 'tox-toolbar__overflow--shrinking',
	          overflowToggledClass: 'tox-tbtn--enabled'
	        },
	        onOpened: function (comp) {
	          comp.getSystem().broadcastOn([toolbarHeightChange()], { type: 'opened' });
	        },
	        onClosed: function (comp) {
	          comp.getSystem().broadcastOn([toolbarHeightChange()], { type: 'closed' });
	        }
	      }));
	    };
	    var renderToolbar = function (toolbarSpec) {
	      var modeName = toolbarSpec.cyclicKeying ? 'cyclic' : 'acyclic';
	      return Toolbar.sketch({
	        uid: toolbarSpec.uid,
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar'].concat(toolbarSpec.type === ToolbarMode.scrolling ? ['tox-toolbar--scrolling'] : [])
	        },
	        components: [Toolbar.parts.groups({})],
	        toolbarBehaviours: getToolbarbehaviours(toolbarSpec, modeName)
	      });
	    };
	
	    var groupToolbarButtonSchema = objOf([
	      strictString('type'),
	      strictOf('items', oneOf([
	        arrOfObj$1([
	          strictString('name'),
	          strictArrayOf('items', string)
	        ]),
	        string
	      ]))
	    ].concat(baseToolbarButtonFields));
	    var createGroupToolbarButton = function (spec) {
	      return asRaw('GroupToolbarButton', groupToolbarButtonSchema, spec);
	    };
	
	    var baseMenuButtonFields = [
	      optionString('text'),
	      optionString('tooltip'),
	      optionString('icon'),
	      strictFunction('fetch'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      })
	    ];
	
	    var MenuButtonSchema = objOf(__spreadArrays([strictString('type')], baseMenuButtonFields));
	    var createMenuButton = function (spec) {
	      return asRaw('menubutton', MenuButtonSchema, spec);
	    };
	
	    var splitButtonSchema = objOf([
	      strictString('type'),
	      optionString('tooltip'),
	      optionString('icon'),
	      optionString('text'),
	      optionFunction('select'),
	      strictFunction('fetch'),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      }),
	      defaultedStringEnum('presets', 'normal', [
	        'normal',
	        'color',
	        'listpreview'
	      ]),
	      defaulted$1('columns', 1),
	      strictFunction('onAction'),
	      strictFunction('onItemAction')
	    ]);
	    var createSplitButton = function (spec) {
	      return asRaw('SplitButton', splitButtonSchema, spec);
	    };
	
	    var events$e = function (reflectingConfig, reflectingState) {
	      var update = function (component, data) {
	        reflectingConfig.updateState.each(function (updateState) {
	          var newState = updateState(component, data);
	          reflectingState.set(newState);
	        });
	        reflectingConfig.renderComponents.each(function (renderComponents) {
	          var newComponents = renderComponents(data, reflectingState.get());
	          var newChildren = map(newComponents, component.getSystem().build);
	          replaceChildren(component, newChildren);
	        });
	      };
	      return derive([
	        run(receive(), function (component, message) {
	          var receivingData = message;
	          if (!receivingData.universal) {
	            var channel = reflectingConfig.channel;
	            if (contains(receivingData.channels, channel)) {
	              update(component, receivingData.data);
	            }
	          }
	        }),
	        runOnAttached(function (comp, _se) {
	          reflectingConfig.initialData.each(function (rawData) {
	            update(comp, rawData);
	          });
	        })
	      ]);
	    };
	
	    var ActiveReflecting = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$e
	    });
	
	    var getState$2 = function (component, replaceConfig, reflectState) {
	      return reflectState;
	    };
	
	    var ReflectingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getState: getState$2
	    });
	
	    var ReflectingSchema = [
	      strict$1('channel'),
	      option('renderComponents'),
	      option('updateState'),
	      option('initialData')
	    ];
	
	    var init$a = function () {
	      var cell = Cell(Optional.none());
	      var set = function (optS) {
	        return cell.set(optS);
	      };
	      var clear = function () {
	        return cell.set(Optional.none());
	      };
	      var get = function () {
	        return cell.get();
	      };
	      var readState = function () {
	        return cell.get().fold(function () {
	          return 'none';
	        }, function (x) {
	          return x;
	        });
	      };
	      return {
	        readState: readState,
	        get: get,
	        set: set,
	        clear: clear
	      };
	    };
	
	    var ReflectingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$a
	    });
	
	    var Reflecting = create$1({
	      fields: ReflectingSchema,
	      name: 'reflecting',
	      active: ActiveReflecting,
	      apis: ReflectingApis,
	      state: ReflectingState
	    });
	
	    var schema$q = constant([
	      strict$1('toggleClass'),
	      strict$1('fetch'),
	      onStrictHandler('onExecute'),
	      defaulted$1('getHotspot', Optional.some),
	      defaulted$1('getAnchorOverrides', constant({})),
	      schema$1(),
	      onStrictHandler('onItemExecute'),
	      option('lazySink'),
	      strict$1('dom'),
	      onHandler('onOpen'),
	      field$1('splitDropdownBehaviours', [
	        Coupling,
	        Keying,
	        Focusing
	      ]),
	      defaulted$1('matchWidth', false),
	      defaulted$1('useMinWidth', false),
	      defaulted$1('eventOrder', {}),
	      option('role')
	    ].concat(sandboxFields()));
	    var arrowPart = required({
	      factory: Button,
	      schema: [strict$1('dom')],
	      name: 'arrow',
	      defaults: function () {
	        return { buttonBehaviours: derive$1([Focusing.revoke()]) };
	      },
	      overrides: function (detail) {
	        return {
	          dom: {
	            tag: 'span',
	            attributes: { role: 'presentation' }
	          },
	          action: function (arrow) {
	            arrow.getSystem().getByUid(detail.uid).each(emitExecute);
	          },
	          buttonBehaviours: derive$1([Toggling.config({
	              toggleOnExecute: false,
	              toggleClass: detail.toggleClass
	            })])
	        };
	      }
	    });
	    var buttonPart = required({
	      factory: Button,
	      schema: [strict$1('dom')],
	      name: 'button',
	      defaults: function () {
	        return { buttonBehaviours: derive$1([Focusing.revoke()]) };
	      },
	      overrides: function (detail) {
	        return {
	          dom: {
	            tag: 'span',
	            attributes: { role: 'presentation' }
	          },
	          action: function (btn) {
	            btn.getSystem().getByUid(detail.uid).each(function (splitDropdown) {
	              detail.onExecute(splitDropdown, btn);
	            });
	          }
	        };
	      }
	    });
	    var parts$c = constant([
	      arrowPart,
	      buttonPart,
	      optional({
	        factory: {
	          sketch: function (spec) {
	            return {
	              uid: spec.uid,
	              dom: {
	                tag: 'span',
	                styles: { display: 'none' },
	                attributes: { 'aria-hidden': 'true' },
	                innerHtml: spec.text
	              }
	            };
	          }
	        },
	        schema: [strict$1('text')],
	        name: 'aria-descriptor'
	      }),
	      external$1({
	        schema: [tieredMenuMarkers()],
	        name: 'menu',
	        defaults: function (detail) {
	          return {
	            onExecute: function (tmenu, item) {
	              tmenu.getSystem().getByUid(detail.uid).each(function (splitDropdown) {
	                detail.onItemExecute(splitDropdown, tmenu, item);
	              });
	            }
	          };
	        }
	      }),
	      partType()
	    ]);
	
	    var factory$e = function (detail, components, spec, externals) {
	      var _a;
	      var switchToMenu = function (sandbox) {
	        Composing.getCurrent(sandbox).each(function (current) {
	          Highlighting.highlightFirst(current);
	          Keying.focusIn(current);
	        });
	      };
	      var action = function (component) {
	        var onOpenSync = switchToMenu;
	        togglePopup(detail, function (x) {
	          return x;
	        }, component, externals, onOpenSync, HighlightOnOpen.HighlightFirst).get(noop);
	      };
	      var openMenu = function (comp) {
	        action(comp);
	        return Optional.some(true);
	      };
	      var executeOnButton = function (comp) {
	        var button = getPartOrDie(comp, detail, 'button');
	        emitExecute(button);
	        return Optional.some(true);
	      };
	      var buttonEvents = __assign(__assign({}, derive([runOnAttached(function (component, _simulatedEvent) {
	          var ariaDescriptor = getPart(component, detail, 'aria-descriptor');
	          ariaDescriptor.each(function (descriptor) {
	            var descriptorId = generate$1('aria');
	            set$1(descriptor.element, 'id', descriptorId);
	            set$1(component.element, 'aria-describedby', descriptorId);
	          });
	        })])), events$7(Optional.some(action)));
	      var apis = {
	        repositionMenus: function (comp) {
	          if (Toggling.isOn(comp)) {
	            repositionMenus(comp);
	          }
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        apis: apis,
	        eventOrder: __assign(__assign({}, detail.eventOrder), (_a = {}, _a[execute()] = [
	          'disabling',
	          'toggling',
	          'alloy.base.behaviour'
	        ], _a)),
	        events: buttonEvents,
	        behaviours: augment(detail.splitDropdownBehaviours, [
	          Coupling.config({
	            others: {
	              sandbox: function (hotspot) {
	                var arrow = getPartOrDie(hotspot, detail, 'arrow');
	                var extras = {
	                  onOpen: function () {
	                    Toggling.on(arrow);
	                    Toggling.on(hotspot);
	                  },
	                  onClose: function () {
	                    Toggling.off(arrow);
	                    Toggling.off(hotspot);
	                  }
	                };
	                return makeSandbox(detail, hotspot, extras);
	              }
	            }
	          }),
	          Keying.config({
	            mode: 'special',
	            onSpace: executeOnButton,
	            onEnter: executeOnButton,
	            onDown: openMenu
	          }),
	          Focusing.config({}),
	          Toggling.config({
	            toggleOnExecute: false,
	            aria: { mode: 'expanded' }
	          })
	        ]),
	        domModification: {
	          attributes: {
	            'role': detail.role.getOr('button'),
	            'aria-haspopup': true
	          }
	        }
	      };
	    };
	    var SplitDropdown = composite$1({
	      name: 'SplitDropdown',
	      configFields: schema$q(),
	      partFields: parts$c(),
	      factory: factory$e,
	      apis: {
	        repositionMenus: function (apis, comp) {
	          return apis.repositionMenus(comp);
	        }
	      }
	    });
	
	    var getButtonApi = function (component) {
	      return {
	        isDisabled: function () {
	          return Disabling.isDisabled(component);
	        },
	        setDisabled: function (state) {
	          return Disabling.set(component, state);
	        }
	      };
	    };
	    var getToggleApi = function (component) {
	      return {
	        setActive: function (state) {
	          Toggling.set(component, state);
	        },
	        isActive: function () {
	          return Toggling.isOn(component);
	        },
	        isDisabled: function () {
	          return Disabling.isDisabled(component);
	        },
	        setDisabled: function (state) {
	          return Disabling.set(component, state);
	        }
	      };
	    };
	    var getTooltipAttributes = function (tooltip, providersBackstage) {
	      return tooltip.map(function (tooltip) {
	        return {
	          'aria-label': providersBackstage.translate(tooltip),
	          'title': providersBackstage.translate(tooltip)
	        };
	      }).getOr({});
	    };
	    var focusButtonEvent = generate$1('focus-button');
	    var rtlIcon$1 = [
	      'checklist',
	      'ordered-list'
	    ];
	    var rtlTransform$1 = [
	      'indent',
	      'outdent',
	      'table-insert-column-after',
	      'table-insert-column-before',
	      'unordered-list'
	    ];
	    var renderCommonStructure = function (icon, text, tooltip, receiver, behaviours, providersBackstage) {
	      var _d;
	      var getIconName = function (iconName) {
	        return global$6.isRtl() && contains(rtlIcon$1, iconName) ? iconName + '-rtl' : iconName;
	      };
	      var needsRtlClass = global$6.isRtl() && icon.exists(function (name) {
	        return contains(rtlTransform$1, name);
	      });
	      return {
	        dom: {
	          tag: 'button',
	          classes: ['tox-tbtn'].concat(text.isSome() ? ['tox-tbtn--select'] : []).concat(needsRtlClass ? ['tox-tbtn__icon-rtl'] : []),
	          attributes: getTooltipAttributes(tooltip, providersBackstage)
	        },
	        components: componentRenderPipeline([
	          icon.map(function (iconName) {
	            return renderIconFromPack(getIconName(iconName), providersBackstage.icons);
	          }),
	          text.map(function (text) {
	            return renderLabel$1(text, 'tox-tbtn', providersBackstage);
	          })
	        ]),
	        eventOrder: (_d = {}, _d[mousedown()] = [
	          'focusing',
	          'alloy.base.behaviour',
	          'common-button-display-events'
	        ], _d),
	        buttonBehaviours: derive$1([
	          DisablingConfigs.toolbarButton(providersBackstage.isDisabled),
	          receivingConfig(),
	          config('common-button-display-events', [run(mousedown(), function (button, se) {
	              se.event.prevent();
	              emit(button, focusButtonEvent);
	            })])
	        ].concat(receiver.map(function (r) {
	          return Reflecting.config({
	            channel: r,
	            initialData: {
	              icon: icon,
	              text: text
	            },
	            renderComponents: function (data, _state) {
	              return componentRenderPipeline([
	                data.icon.map(function (iconName) {
	                  return renderIconFromPack(getIconName(iconName), providersBackstage.icons);
	                }),
	                data.text.map(function (text) {
	                  return renderLabel$1(text, 'tox-tbtn', providersBackstage);
	                })
	              ]);
	            }
	          });
	        }).toArray()).concat(behaviours.getOr([])))
	      };
	    };
	    var renderFloatingToolbarButton = function (spec, backstage, identifyButtons, attributes) {
	      var sharedBackstage = backstage.shared;
	      return FloatingToolbarButton.sketch({
	        lazySink: sharedBackstage.getSink,
	        fetch: function () {
	          return Future.nu(function (resolve) {
	            resolve(map(identifyButtons(spec.items), renderToolbarGroup));
	          });
	        },
	        markers: { toggledClass: 'tox-tbtn--enabled' },
	        parts: {
	          button: renderCommonStructure(spec.icon, spec.text, spec.tooltip, Optional.none(), Optional.none(), sharedBackstage.providers),
	          toolbar: {
	            dom: {
	              tag: 'div',
	              classes: ['tox-toolbar__overflow'],
	              attributes: attributes
	            }
	          }
	        }
	      });
	    };
	    var renderCommonToolbarButton = function (spec, specialisation, providersBackstage) {
	      var editorOffCell = Cell(noop);
	      var structure = renderCommonStructure(spec.icon, spec.text, spec.tooltip, Optional.none(), Optional.none(), providersBackstage);
	      return Button.sketch({
	        dom: structure.dom,
	        components: structure.components,
	        eventOrder: toolbarButtonEventOrder,
	        buttonBehaviours: derive$1([
	          config('toolbar-button-events', [
	            onToolbarButtonExecute({
	              onAction: spec.onAction,
	              getApi: specialisation.getApi
	            }),
	            onControlAttached(specialisation, editorOffCell),
	            onControlDetached(specialisation, editorOffCell)
	          ]),
	          DisablingConfigs.toolbarButton(function () {
	            return spec.disabled || providersBackstage.isDisabled();
	          }),
	          receivingConfig()
	        ].concat(specialisation.toolbarButtonBehaviours))
	      });
	    };
	    var renderToolbarButton = function (spec, providersBackstage) {
	      return renderToolbarButtonWith(spec, providersBackstage, []);
	    };
	    var renderToolbarButtonWith = function (spec, providersBackstage, bonusEvents) {
	      return renderCommonToolbarButton(spec, {
	        toolbarButtonBehaviours: [].concat(bonusEvents.length > 0 ? [config('toolbarButtonWith', bonusEvents)] : []),
	        getApi: getButtonApi,
	        onSetup: spec.onSetup
	      }, providersBackstage);
	    };
	    var renderToolbarToggleButton = function (spec, providersBackstage) {
	      return renderToolbarToggleButtonWith(spec, providersBackstage, []);
	    };
	    var renderToolbarToggleButtonWith = function (spec, providersBackstage, bonusEvents) {
	      return deepMerge(renderCommonToolbarButton(spec, {
	        toolbarButtonBehaviours: [
	          Replacing.config({}),
	          Toggling.config({
	            toggleClass: 'tox-tbtn--enabled',
	            aria: { mode: 'pressed' },
	            toggleOnExecute: false
	          })
	        ].concat(bonusEvents.length > 0 ? [config('toolbarToggleButtonWith', bonusEvents)] : []),
	        getApi: getToggleApi,
	        onSetup: spec.onSetup
	      }, providersBackstage));
	    };
	    var fetchChoices = function (getApi, spec, providersBackstage) {
	      return function (comp) {
	        return Future.nu(function (callback) {
	          return spec.fetch(callback);
	        }).map(function (items) {
	          return Optional.from(createTieredDataFrom(deepMerge(createPartialChoiceMenu(generate$1('menu-value'), items, function (value) {
	            spec.onItemAction(getApi(comp), value);
	          }, spec.columns, spec.presets, ItemResponse$1.CLOSE_ON_EXECUTE, spec.select.getOr(never), providersBackstage), {
	            movement: deriveMenuMovement(spec.columns, spec.presets),
	            menuBehaviours: SimpleBehaviours.unnamedEvents(spec.columns !== 'auto' ? [] : [runOnAttached(function (comp, _se) {
	                detectSize(comp, 4, classForPreset(spec.presets)).each(function (_d) {
	                  var numRows = _d.numRows, numColumns = _d.numColumns;
	                  Keying.setGridSize(comp, numRows, numColumns);
	                });
	              })])
	          })));
	        });
	      };
	    };
	    var renderSplitButton = function (spec, sharedBackstage) {
	      var _d;
	      var displayChannel = generate$1('channel-update-split-dropdown-display');
	      var getApi = function (comp) {
	        return {
	          isDisabled: function () {
	            return Disabling.isDisabled(comp);
	          },
	          setDisabled: function (state) {
	            return Disabling.set(comp, state);
	          },
	          setIconFill: function (id, value) {
	            descendant$1(comp.element, 'svg path[id="' + id + '"], rect[id="' + id + '"]').each(function (underlinePath) {
	              set$1(underlinePath, 'fill', value);
	            });
	          },
	          setIconStroke: function (id, value) {
	            descendant$1(comp.element, 'svg path[id="' + id + '"], rect[id="' + id + '"]').each(function (underlinePath) {
	              set$1(underlinePath, 'stroke', value);
	            });
	          },
	          setActive: function (state) {
	            set$1(comp.element, 'aria-pressed', state);
	            descendant$1(comp.element, 'span').each(function (button) {
	              comp.getSystem().getByDom(button).each(function (buttonComp) {
	                return Toggling.set(buttonComp, state);
	              });
	            });
	          },
	          isActive: function () {
	            return descendant$1(comp.element, 'span').exists(function (button) {
	              return comp.getSystem().getByDom(button).exists(Toggling.isOn);
	            });
	          }
	        };
	      };
	      var editorOffCell = Cell(noop);
	      var specialisation = {
	        getApi: getApi,
	        onSetup: spec.onSetup
	      };
	      return SplitDropdown.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-split-button'],
	          attributes: __assign({ 'aria-pressed': false }, getTooltipAttributes(spec.tooltip, sharedBackstage.providers))
	        },
	        onExecute: function (button) {
	          spec.onAction(getApi(button));
	        },
	        onItemExecute: function (_a, _b, _c) {
	        },
	        splitDropdownBehaviours: derive$1([
	          DisablingConfigs.splitButton(sharedBackstage.providers.isDisabled),
	          receivingConfig(),
	          config('split-dropdown-events', [
	            run(focusButtonEvent, Focusing.focus),
	            onControlAttached(specialisation, editorOffCell),
	            onControlDetached(specialisation, editorOffCell)
	          ]),
	          Unselecting.config({})
	        ]),
	        eventOrder: (_d = {}, _d[attachedToDom()] = [
	          'alloy.base.behaviour',
	          'split-dropdown-events'
	        ], _d),
	        toggleClass: 'tox-tbtn--enabled',
	        lazySink: sharedBackstage.getSink,
	        fetch: fetchChoices(getApi, spec, sharedBackstage.providers),
	        parts: { menu: part(false, spec.columns, spec.presets) },
	        components: [
	          SplitDropdown.parts.button(renderCommonStructure(spec.icon, spec.text, Optional.none(), Optional.some(displayChannel), Optional.some([Toggling.config({
	              toggleClass: 'tox-tbtn--enabled',
	              toggleOnExecute: false
	            })]), sharedBackstage.providers)),
	          SplitDropdown.parts.arrow({
	            dom: {
	              tag: 'button',
	              classes: [
	                'tox-tbtn',
	                'tox-split-button__chevron'
	              ],
	              innerHtml: get$e('chevron-down', sharedBackstage.providers.icons)
	            },
	            buttonBehaviours: derive$1([
	              DisablingConfigs.splitButton(sharedBackstage.providers.isDisabled),
	              receivingConfig()
	            ])
	          }),
	          SplitDropdown.parts['aria-descriptor']({ text: sharedBackstage.providers.translate('To open the popup, press Shift+Enter') })
	        ]
	      });
	    };
	
	    var getFormApi = function (input) {
	      return {
	        hide: function () {
	          return emit(input, sandboxClose());
	        },
	        getValue: function () {
	          return Representing.getValue(input);
	        }
	      };
	    };
	    var runOnExecute$1 = function (memInput, original) {
	      return run(internalToolbarButtonExecute, function (comp, se) {
	        var input = memInput.get(comp);
	        var formApi = getFormApi(input);
	        original.onAction(formApi, se.event.buttonApi);
	      });
	    };
	    var renderContextButton = function (memInput, button, extras) {
	      var _a = button.original, primary = _a.primary, rest = __rest(_a, ['primary']);
	      var bridged = getOrDie(createToolbarButton(__assign(__assign({}, rest), {
	        type: 'button',
	        onAction: noop
	      })));
	      return renderToolbarButtonWith(bridged, extras.backstage.shared.providers, [runOnExecute$1(memInput, button)]);
	    };
	    var renderContextToggleButton = function (memInput, button, extras) {
	      var _a = button.original, primary = _a.primary, rest = __rest(_a, ['primary']);
	      var bridged = getOrDie(createToggleButton(__assign(__assign({}, rest), {
	        type: 'togglebutton',
	        onAction: noop
	      })));
	      return renderToolbarToggleButtonWith(bridged, extras.backstage.shared.providers, [runOnExecute$1(memInput, button)]);
	    };
	    var generateOne$1 = function (memInput, button, providersBackstage) {
	      var extras = { backstage: { shared: { providers: providersBackstage } } };
	      if (button.type === 'contextformtogglebutton') {
	        return renderContextToggleButton(memInput, button, extras);
	      } else {
	        return renderContextButton(memInput, button, extras);
	      }
	    };
	    var generate$7 = function (memInput, buttons, providersBackstage) {
	      var mementos = map(buttons, function (button) {
	        return record(generateOne$1(memInput, button, providersBackstage));
	      });
	      var asSpecs = function () {
	        return map(mementos, function (mem) {
	          return mem.asSpec();
	        });
	      };
	      var findPrimary = function (compInSystem) {
	        return findMap(buttons, function (button, i) {
	          if (button.primary) {
	            return Optional.from(mementos[i]).bind(function (mem) {
	              return mem.getOpt(compInSystem);
	            }).filter(not(Disabling.isDisabled));
	          } else {
	            return Optional.none();
	          }
	        });
	      };
	      return {
	        asSpecs: asSpecs,
	        findPrimary: findPrimary
	      };
	    };
	
	    var buildInitGroups = function (ctx, providers) {
	      var inputAttributes = ctx.label.fold(function () {
	        return {};
	      }, function (label) {
	        return { 'aria-label': label };
	      });
	      var memInput = record(Input.sketch({
	        inputClasses: [
	          'tox-toolbar-textfield',
	          'tox-toolbar-nav-js'
	        ],
	        data: ctx.initValue(),
	        inputAttributes: inputAttributes,
	        selectOnFocus: true,
	        inputBehaviours: derive$1([Keying.config({
	            mode: 'special',
	            onEnter: function (input) {
	              return commands.findPrimary(input).map(function (primary) {
	                emitExecute(primary);
	                return true;
	              });
	            },
	            onLeft: function (comp, se) {
	              se.cut();
	              return Optional.none();
	            },
	            onRight: function (comp, se) {
	              se.cut();
	              return Optional.none();
	            }
	          })])
	      }));
	      var commands = generate$7(memInput, ctx.commands, providers);
	      return [
	        {
	          title: Optional.none(),
	          items: [memInput.asSpec()]
	        },
	        {
	          title: Optional.none(),
	          items: commands.asSpecs()
	        }
	      ];
	    };
	    var renderContextForm = function (toolbarType, ctx, providers) {
	      return renderToolbar({
	        type: toolbarType,
	        uid: generate$1('context-toolbar'),
	        initGroups: buildInitGroups(ctx, providers),
	        onEscape: Optional.none,
	        cyclicKeying: true,
	        providers: providers
	      });
	    };
	    var ContextForm = {
	      renderContextForm: renderContextForm,
	      buildInitGroups: buildInitGroups
	    };
	
	    var getHorizontalBounds = function (contentAreaBox, viewportBounds) {
	      var x = Math.max(viewportBounds.x, contentAreaBox.x);
	      var contentBoxWidth = contentAreaBox.right - x;
	      var maxViewportWidth = viewportBounds.width - (x - viewportBounds.x);
	      var width = Math.min(contentBoxWidth, maxViewportWidth);
	      return {
	        x: x,
	        width: width
	      };
	    };
	    var getVerticalBounds = function (editor, contentAreaBox, viewportBounds, isToolbarLocationTop) {
	      var container = SugarElement.fromDom(editor.getContainer());
	      var header = descendant$1(container, '.tox-editor-header').getOr(container);
	      var headerBox = box(header);
	      var isToolbarBelowContentArea = headerBox.y >= contentAreaBox.bottom;
	      var isToolbarAbove = isToolbarLocationTop && !isToolbarBelowContentArea;
	      if (editor.inline && isToolbarAbove) {
	        return {
	          y: Math.max(headerBox.bottom, viewportBounds.y),
	          bottom: viewportBounds.bottom
	        };
	      }
	      if (editor.inline && !isToolbarAbove) {
	        return {
	          y: viewportBounds.y,
	          bottom: Math.min(headerBox.y, viewportBounds.bottom)
	        };
	      }
	      var containerBounds = box(container);
	      if (isToolbarAbove) {
	        return {
	          y: Math.max(headerBox.bottom, viewportBounds.y),
	          bottom: Math.min(containerBounds.bottom, viewportBounds.bottom)
	        };
	      }
	      return {
	        y: Math.max(containerBounds.y, viewportBounds.y),
	        bottom: Math.min(headerBox.y, viewportBounds.bottom)
	      };
	    };
	    var getContextToolbarBounds = function (editor, sharedBackstage) {
	      var viewportBounds = getBounds(window);
	      var contentAreaBox = box(SugarElement.fromDom(editor.getContentAreaContainer()));
	      var toolbarOrMenubarEnabled = isMenubarEnabled(editor) || isToolbarEnabled(editor) || isMultipleToolbars(editor);
	      var _a = getHorizontalBounds(contentAreaBox, viewportBounds), x = _a.x, width = _a.width;
	      if (editor.inline && !toolbarOrMenubarEnabled) {
	        return bounds$1(x, viewportBounds.y, width, viewportBounds.height);
	      } else {
	        var isToolbarTop = sharedBackstage.header.isPositionedAtTop();
	        var _b = getVerticalBounds(editor, contentAreaBox, viewportBounds, isToolbarTop), y = _b.y, bottom = _b.bottom;
	        return bounds$1(x, y, width, bottom - y);
	      }
	    };
	
	    var matchTargetWith = function (elem, candidates) {
	      var ctxs = filter(candidates, function (toolbarApi) {
	        return toolbarApi.predicate(elem.dom);
	      });
	      var _a = partition(ctxs, function (t) {
	          return t.type === 'contexttoolbar';
	        }), pass = _a.pass, fail = _a.fail;
	      return {
	        contextToolbars: pass,
	        contextForms: fail
	      };
	    };
	    var filterByPositionForStartNode = function (toolbars) {
	      if (toolbars.length <= 1) {
	        return toolbars;
	      } else {
	        var doesPositionExist = function (value) {
	          return exists(toolbars, function (t) {
	            return t.position === value;
	          });
	        };
	        var filterToolbarsByPosition = function (value) {
	          return filter(toolbars, function (t) {
	            return t.position === value;
	          });
	        };
	        var hasSelectionToolbars = doesPositionExist('selection');
	        var hasNodeToolbars = doesPositionExist('node');
	        if (hasSelectionToolbars || hasNodeToolbars) {
	          if (hasNodeToolbars && hasSelectionToolbars) {
	            var nodeToolbars = filterToolbarsByPosition('node');
	            var selectionToolbars = map(filterToolbarsByPosition('selection'), function (t) {
	              return __assign(__assign({}, t), { position: 'node' });
	            });
	            return nodeToolbars.concat(selectionToolbars);
	          } else {
	            return hasSelectionToolbars ? filterToolbarsByPosition('selection') : filterToolbarsByPosition('node');
	          }
	        } else {
	          return filterToolbarsByPosition('line');
	        }
	      }
	    };
	    var filterByPositionForAncestorNode = function (toolbars) {
	      if (toolbars.length <= 1) {
	        return toolbars;
	      } else {
	        var findPosition_1 = function (value) {
	          return find(toolbars, function (t) {
	            return t.position === value;
	          });
	        };
	        var basePosition = findPosition_1('selection').orThunk(function () {
	          return findPosition_1('node');
	        }).orThunk(function () {
	          return findPosition_1('line');
	        }).map(function (t) {
	          return t.position;
	        });
	        return basePosition.fold(function () {
	          return [];
	        }, function (pos) {
	          return filter(toolbars, function (t) {
	            return t.position === pos;
	          });
	        });
	      }
	    };
	    var matchStartNode = function (elem, nodeCandidates, editorCandidates) {
	      var nodeMatches = matchTargetWith(elem, nodeCandidates);
	      if (nodeMatches.contextForms.length > 0) {
	        return Optional.some({
	          elem: elem,
	          toolbars: [nodeMatches.contextForms[0]]
	        });
	      } else {
	        var editorMatches = matchTargetWith(elem, editorCandidates);
	        if (editorMatches.contextForms.length > 0) {
	          return Optional.some({
	            elem: elem,
	            toolbars: [editorMatches.contextForms[0]]
	          });
	        } else if (nodeMatches.contextToolbars.length > 0 || editorMatches.contextToolbars.length > 0) {
	          var toolbars = filterByPositionForStartNode(nodeMatches.contextToolbars.concat(editorMatches.contextToolbars));
	          return Optional.some({
	            elem: elem,
	            toolbars: toolbars
	          });
	        } else {
	          return Optional.none();
	        }
	      }
	    };
	    var matchAncestor = function (isRoot, startNode, scopes) {
	      if (isRoot(startNode)) {
	        return Optional.none();
	      } else {
	        return ancestor(startNode, function (ancestorElem) {
	          var _a = matchTargetWith(ancestorElem, scopes.inNodeScope), contextToolbars = _a.contextToolbars, contextForms = _a.contextForms;
	          var toolbars = contextForms.length > 0 ? contextForms : filterByPositionForAncestorNode(contextToolbars);
	          return toolbars.length > 0 ? Optional.some({
	            elem: ancestorElem,
	            toolbars: toolbars
	          }) : Optional.none();
	        }, isRoot);
	      }
	    };
	    var lookup$1 = function (scopes, editor) {
	      var rootElem = SugarElement.fromDom(editor.getBody());
	      var isRoot = function (elem) {
	        return eq$1(elem, rootElem);
	      };
	      var isOutsideRoot = function (startNode) {
	        return !isRoot(startNode) && !contains$2(rootElem, startNode);
	      };
	      var startNode = SugarElement.fromDom(editor.selection.getNode());
	      if (isOutsideRoot(startNode)) {
	        return Optional.none();
	      }
	      return matchStartNode(startNode, scopes.inNodeScope, scopes.inEditorScope).orThunk(function () {
	        return matchAncestor(isRoot, startNode, scopes);
	      });
	    };
	
	    var categorise = function (contextToolbars, navigate) {
	      var forms = {};
	      var inNodeScope = [];
	      var inEditorScope = [];
	      var formNavigators = {};
	      var lookupTable = {};
	      var registerForm = function (key, toolbarSpec) {
	        var contextForm = getOrDie(createContextForm(toolbarSpec));
	        forms[key] = contextForm;
	        contextForm.launch.map(function (launch) {
	          formNavigators['form:' + key + ''] = __assign(__assign({}, toolbarSpec.launch), {
	            type: launch.type === 'contextformtogglebutton' ? 'togglebutton' : 'button',
	            onAction: function () {
	              navigate(contextForm);
	            }
	          });
	        });
	        if (contextForm.scope === 'editor') {
	          inEditorScope.push(contextForm);
	        } else {
	          inNodeScope.push(contextForm);
	        }
	        lookupTable[key] = contextForm;
	      };
	      var registerToolbar = function (key, toolbarSpec) {
	        createContextToolbar(toolbarSpec).each(function (contextToolbar) {
	          if (toolbarSpec.scope === 'editor') {
	            inEditorScope.push(contextToolbar);
	          } else {
	            inNodeScope.push(contextToolbar);
	          }
	          lookupTable[key] = contextToolbar;
	        });
	      };
	      var keys$1 = keys(contextToolbars);
	      each(keys$1, function (key) {
	        var toolbarApi = contextToolbars[key];
	        if (toolbarApi.type === 'contextform') {
	          registerForm(key, toolbarApi);
	        } else if (toolbarApi.type === 'contexttoolbar') {
	          registerToolbar(key, toolbarApi);
	        }
	      });
	      return {
	        forms: forms,
	        inNodeScope: inNodeScope,
	        inEditorScope: inEditorScope,
	        lookupTable: lookupTable,
	        formNavigators: formNavigators
	      };
	    };
	
	    var forwardSlideEvent = generate$1('forward-slide');
	    var backSlideEvent = generate$1('backward-slide');
	    var changeSlideEvent = generate$1('change-slide-event');
	    var resizingClass = 'tox-pop--resizing';
	    var renderContextToolbar = function (spec) {
	      var stack = Cell([]);
	      return InlineView.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-pop']
	        },
	        fireDismissalEventInstead: { event: 'doNotDismissYet' },
	        onShow: function (comp) {
	          stack.set([]);
	          InlineView.getContent(comp).each(function (c) {
	            remove$6(c.element, 'visibility');
	          });
	          remove$4(comp.element, resizingClass);
	          remove$6(comp.element, 'width');
	        },
	        inlineBehaviours: derive$1([
	          config('context-toolbar-events', [
	            runOnSource(transitionend(), function (comp, _se) {
	              remove$4(comp.element, resizingClass);
	              remove$6(comp.element, 'width');
	            }),
	            run(changeSlideEvent, function (comp, se) {
	              var elem = comp.element;
	              remove$6(elem, 'width');
	              var currentWidth = get$8(elem);
	              InlineView.setContent(comp, se.event.contents);
	              add$2(elem, resizingClass);
	              var newWidth = get$8(elem);
	              set$2(elem, 'width', currentWidth + 'px');
	              InlineView.getContent(comp).each(function (newContents) {
	                se.event.focus.bind(function (f) {
	                  focus$1(f);
	                  return search(elem);
	                }).orThunk(function () {
	                  Keying.focusIn(newContents);
	                  return active(getRootNode(elem));
	                });
	              });
	              global$2.setTimeout(function () {
	                set$2(comp.element, 'width', newWidth + 'px');
	              }, 0);
	            }),
	            run(forwardSlideEvent, function (comp, se) {
	              InlineView.getContent(comp).each(function (oldContents) {
	                stack.set(stack.get().concat([{
	                    bar: oldContents,
	                    focus: active(getRootNode(comp.element))
	                  }]));
	              });
	              emitWith(comp, changeSlideEvent, {
	                contents: se.event.forwardContents,
	                focus: Optional.none()
	              });
	            }),
	            run(backSlideEvent, function (comp, _se) {
	              last(stack.get()).each(function (last) {
	                stack.set(stack.get().slice(0, stack.get().length - 1));
	                emitWith(comp, changeSlideEvent, {
	                  contents: premade$1(last.bar),
	                  focus: last.focus
	                });
	              });
	            })
	          ]),
	          Keying.config({
	            mode: 'special',
	            onEscape: function (comp) {
	              return last(stack.get()).fold(function () {
	                return spec.onEscape();
	              }, function (_) {
	                emit(comp, backSlideEvent);
	                return Optional.some(true);
	              });
	            }
	          })
	        ]),
	        lazySink: function () {
	          return Result.value(spec.sink);
	        }
	      });
	    };
	
	    var generateSelectItems = function (_editor, backstage, spec) {
	      var generateItem = function (rawItem, response, disabled, value) {
	        var translatedText = backstage.shared.providers.translate(rawItem.title);
	        if (rawItem.type === 'separator') {
	          return Optional.some({
	            type: 'separator',
	            text: translatedText
	          });
	        } else if (rawItem.type === 'submenu') {
	          var items = bind(rawItem.getStyleItems(), function (si) {
	            return validate(si, response, value);
	          });
	          if (response === 0 && items.length <= 0) {
	            return Optional.none();
	          } else {
	            return Optional.some({
	              type: 'nestedmenuitem',
	              text: translatedText,
	              disabled: items.length <= 0,
	              getSubmenuItems: function () {
	                return bind(rawItem.getStyleItems(), function (si) {
	                  return validate(si, response, value);
	                });
	              }
	            });
	          }
	        } else {
	          return Optional.some(__assign({
	            type: 'togglemenuitem',
	            text: translatedText,
	            icon: rawItem.icon,
	            active: rawItem.isSelected(value),
	            disabled: disabled,
	            onAction: spec.onAction(rawItem)
	          }, rawItem.getStylePreview().fold(function () {
	            return {};
	          }, function (preview) {
	            return { meta: { style: preview } };
	          })));
	        }
	      };
	      var validate = function (item, response, value) {
	        var invalid = item.type === 'formatter' && spec.isInvalid(item);
	        if (response === 0) {
	          return invalid ? [] : generateItem(item, response, false, value).toArray();
	        } else {
	          return generateItem(item, response, invalid, value).toArray();
	        }
	      };
	      var validateItems = function (preItems) {
	        var value = spec.getCurrentValue();
	        var response = spec.shouldHide ? 0 : 1;
	        return bind(preItems, function (item) {
	          return validate(item, response, value);
	        });
	      };
	      var getFetch = function (backstage, getStyleItems) {
	        return function (comp, callback) {
	          var preItems = getStyleItems();
	          var items = validateItems(preItems);
	          var menu = build$2(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false);
	          callback(menu);
	        };
	      };
	      return {
	        validateItems: validateItems,
	        getFetch: getFetch
	      };
	    };
	    var createMenuItems = function (editor, backstage, spec) {
	      var dataset = spec.dataset;
	      var getStyleItems = dataset.type === 'basic' ? function () {
	        return map(dataset.data, function (d) {
	          return processBasic(d, spec.isSelectedFor, spec.getPreviewFor);
	        });
	      } : dataset.getData;
	      return {
	        items: generateSelectItems(editor, backstage, spec),
	        getStyleItems: getStyleItems
	      };
	    };
	    var createSelectButton = function (editor, backstage, spec) {
	      var _a = createMenuItems(editor, backstage, spec), items = _a.items, getStyleItems = _a.getStyleItems;
	      var getApi = function (comp) {
	        return {
	          getComponent: function () {
	            return comp;
	          }
	        };
	      };
	      var onSetup = function (api) {
	        spec.setInitialValue.each(function (f) {
	          return f(api.getComponent());
	        });
	        return spec.nodeChangeHandler.map(function (f) {
	          var handler = f(api.getComponent());
	          editor.on('NodeChange', handler);
	          return function () {
	            editor.off('NodeChange', handler);
	          };
	        }).getOr(noop);
	      };
	      return renderCommonDropdown({
	        text: spec.icon.isSome() ? Optional.none() : Optional.some(''),
	        icon: spec.icon,
	        tooltip: Optional.from(spec.tooltip),
	        role: Optional.none(),
	        fetch: items.getFetch(backstage, getStyleItems),
	        onSetup: onSetup,
	        getApi: getApi,
	        columns: 1,
	        presets: 'normal',
	        classes: spec.icon.isSome() ? [] : ['bespoke'],
	        dropdownBehaviours: []
	      }, 'tox-tbtn', backstage.shared);
	    };
	
	    var process = function (rawFormats) {
	      return map(rawFormats, function (item) {
	        var title = item, format = item;
	        var values = item.split('=');
	        if (values.length > 1) {
	          title = values[0];
	          format = values[1];
	        }
	        return {
	          title: title,
	          format: format
	        };
	      });
	    };
	    var buildBasicStaticDataset = function (data) {
	      return {
	        type: 'basic',
	        data: data
	      };
	    };
	    var Delimiter;
	    (function (Delimiter) {
	      Delimiter[Delimiter['SemiColon'] = 0] = 'SemiColon';
	      Delimiter[Delimiter['Space'] = 1] = 'Space';
	    }(Delimiter || (Delimiter = {})));
	    var split = function (rawFormats, delimiter) {
	      if (delimiter === Delimiter.SemiColon) {
	        return rawFormats.replace(/;$/, '').split(';');
	      } else {
	        return rawFormats.split(' ');
	      }
	    };
	    var buildBasicSettingsDataset = function (editor, settingName, defaults, delimiter) {
	      var rawFormats = editor.getParam(settingName, defaults, 'string');
	      var data = process(split(rawFormats, delimiter));
	      return {
	        type: 'basic',
	        data: data
	      };
	    };
	
	    var alignMenuItems = [
	      {
	        title: 'Left',
	        icon: 'align-left',
	        format: 'alignleft',
	        command: 'JustifyLeft'
	      },
	      {
	        title: 'Center',
	        icon: 'align-center',
	        format: 'aligncenter',
	        command: 'JustifyCenter'
	      },
	      {
	        title: 'Right',
	        icon: 'align-right',
	        format: 'alignright',
	        command: 'JustifyRight'
	      },
	      {
	        title: 'Justify',
	        icon: 'align-justify',
	        format: 'alignjustify',
	        command: 'JustifyFull'
	      }
	    ];
	    var getSpec = function (editor) {
	      var getMatchingValue = function () {
	        return find(alignMenuItems, function (item) {
	          return editor.formatter.match(item.format);
	        });
	      };
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (_format) {
	        return function () {
	          return Optional.none();
	        };
	      };
	      var updateSelectMenuIcon = function (comp) {
	        var match = getMatchingValue();
	        var alignment = match.fold(function () {
	          return 'left';
	        }, function (item) {
	          return item.title.toLowerCase();
	        });
	        emitWith(comp, updateMenuIcon, { icon: 'align-' + alignment });
	      };
	      var nodeChangeHandler = Optional.some(function (comp) {
	        return function () {
	          return updateSelectMenuIcon(comp);
	        };
	      });
	      var setInitialValue = Optional.some(function (comp) {
	        return updateSelectMenuIcon(comp);
	      });
	      var dataset = buildBasicStaticDataset(alignMenuItems);
	      var onAction = function (rawItem) {
	        return function () {
	          return find(alignMenuItems, function (item) {
	            return item.format === rawItem.format;
	          }).each(function (item) {
	            return editor.execCommand(item.command);
	          });
	        };
	      };
	      return {
	        tooltip: 'Align',
	        icon: Optional.some('align-left'),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: Optional.none,
	        getPreviewFor: getPreviewFor,
	        onAction: onAction,
	        setInitialValue: setInitialValue,
	        nodeChangeHandler: nodeChangeHandler,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: function (item) {
	          return !editor.formatter.canApply(item.format);
	        }
	      };
	    };
	    var createAlignSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec(editor));
	    };
	    var alignSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec(editor));
	      editor.ui.registry.addNestedMenuItem('align', {
	        text: backstage.shared.providers.translate('Align'),
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var defaultFontsFormats = 'Andale Mono=andale mono,monospace;' + 'Arial=arial,helvetica,sans-serif;' + 'Arial Black=arial black,sans-serif;' + 'Book Antiqua=book antiqua,palatino,serif;' + 'Comic Sans MS=comic sans ms,sans-serif;' + 'Courier New=courier new,courier,monospace;' + 'Georgia=georgia,palatino,serif;' + 'Helvetica=helvetica,arial,sans-serif;' + 'Impact=impact,sans-serif;' + 'Symbol=symbol;' + 'Tahoma=tahoma,arial,helvetica,sans-serif;' + 'Terminal=terminal,monaco,monospace;' + 'Times New Roman=times new roman,times,serif;' + 'Trebuchet MS=trebuchet ms,geneva,sans-serif;' + 'Verdana=verdana,geneva,sans-serif;' + 'Webdings=webdings;' + 'Wingdings=wingdings,zapf dingbats';
	    var systemStackFonts = [
	      '-apple-system',
	      'Segoe UI',
	      'Roboto',
	      'Helvetica Neue',
	      'sans-serif'
	    ];
	    var splitFonts = function (fontFamily) {
	      var fonts = fontFamily.split(/\s*,\s*/);
	      return map(fonts, function (font) {
	        return font.replace(/^['"]+|['"]+$/g, '');
	      });
	    };
	    var isSystemFontStack = function (fontFamily) {
	      var matchesSystemStack = function () {
	        var fonts = splitFonts(fontFamily.toLowerCase());
	        return forall(systemStackFonts, function (font) {
	          return fonts.indexOf(font.toLowerCase()) > -1;
	        });
	      };
	      return fontFamily.indexOf('-apple-system') === 0 && matchesSystemStack();
	    };
	    var getSpec$1 = function (editor) {
	      var getMatchingValue = function () {
	        var getFirstFont = function (fontFamily) {
	          return fontFamily ? splitFonts(fontFamily)[0] : '';
	        };
	        var fontFamily = editor.queryCommandValue('FontName');
	        var items = dataset.data;
	        var font = fontFamily ? fontFamily.toLowerCase() : '';
	        var matchOpt = find(items, function (item) {
	          var format = item.format;
	          return format.toLowerCase() === font || getFirstFont(format).toLowerCase() === getFirstFont(font).toLowerCase();
	        }).orThunk(function () {
	          if (isSystemFontStack(font)) {
	            return Optional.from({
	              title: 'System Font',
	              format: font
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	        return {
	          matchOpt: matchOpt,
	          font: fontFamily
	        };
	      };
	      var isSelectedFor = function (item) {
	        return function (valueOpt) {
	          return valueOpt.exists(function (value) {
	            return value.format === item;
	          });
	        };
	      };
	      var getCurrentValue = function () {
	        var matchOpt = getMatchingValue().matchOpt;
	        return matchOpt;
	      };
	      var getPreviewFor = function (item) {
	        return function () {
	          return Optional.some({
	            tag: 'div',
	            styles: item.indexOf('dings') === -1 ? { 'font-family': item } : {}
	          });
	        };
	      };
	      var onAction = function (rawItem) {
	        return function () {
	          editor.undoManager.transact(function () {
	            editor.focus();
	            editor.execCommand('FontName', false, rawItem.format);
	          });
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var _a = getMatchingValue(), matchOpt = _a.matchOpt, font = _a.font;
	        var text = matchOpt.fold(function () {
	          return font;
	        }, function (item) {
	          return item.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var nodeChangeHandler = Optional.some(function (comp) {
	        return function () {
	          return updateSelectMenuText(comp);
	        };
	      });
	      var setInitialValue = Optional.some(function (comp) {
	        return updateSelectMenuText(comp);
	      });
	      var dataset = buildBasicSettingsDataset(editor, 'font_formats', defaultFontsFormats, Delimiter.SemiColon);
	      return {
	        tooltip: 'Fonts',
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: getCurrentValue,
	        getPreviewFor: getPreviewFor,
	        onAction: onAction,
	        setInitialValue: setInitialValue,
	        nodeChangeHandler: nodeChangeHandler,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: never
	      };
	    };
	    var createFontSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$1(editor));
	    };
	    var fontSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$1(editor));
	      editor.ui.registry.addNestedMenuItem('fontformats', {
	        text: backstage.shared.providers.translate('Fonts'),
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
	    var legacyFontSizes = {
	      '8pt': '1',
	      '10pt': '2',
	      '12pt': '3',
	      '14pt': '4',
	      '18pt': '5',
	      '24pt': '6',
	      '36pt': '7'
	    };
	    var keywordFontSizes = {
	      'xx-small': '7pt',
	      'x-small': '8pt',
	      'small': '10pt',
	      'medium': '12pt',
	      'large': '14pt',
	      'x-large': '18pt',
	      'xx-large': '24pt'
	    };
	    var round$1 = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        return round$1(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      } else {
	        return get$1(keywordFontSizes, fontSize).getOr(fontSize);
	      }
	    };
	    var toLegacy = function (fontSize) {
	      return get$1(legacyFontSizes, fontSize).getOr('');
	    };
	    var getSpec$2 = function (editor) {
	      var getMatchingValue = function () {
	        var matchOpt = Optional.none();
	        var items = dataset.data;
	        var fontSize = editor.queryCommandValue('FontSize');
	        if (fontSize) {
	          var _loop_1 = function (precision) {
	            var pt = toPt(fontSize, precision);
	            var legacy = toLegacy(pt);
	            matchOpt = find(items, function (item) {
	              return item.format === fontSize || item.format === pt || item.format === legacy;
	            });
	          };
	          for (var precision = 3; matchOpt.isNone() && precision >= 0; precision--) {
	            _loop_1(precision);
	          }
	        }
	        return {
	          matchOpt: matchOpt,
	          size: fontSize
	        };
	      };
	      var isSelectedFor = function (item) {
	        return function (valueOpt) {
	          return valueOpt.exists(function (value) {
	            return value.format === item;
	          });
	        };
	      };
	      var getCurrentValue = function () {
	        var matchOpt = getMatchingValue().matchOpt;
	        return matchOpt;
	      };
	      var getPreviewFor = constant(Optional.none);
	      var onAction = function (rawItem) {
	        return function () {
	          editor.undoManager.transact(function () {
	            editor.focus();
	            editor.execCommand('FontSize', false, rawItem.format);
	          });
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var _a = getMatchingValue(), matchOpt = _a.matchOpt, size = _a.size;
	        var text = matchOpt.fold(function () {
	          return size;
	        }, function (match) {
	          return match.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var nodeChangeHandler = Optional.some(function (comp) {
	        return function () {
	          return updateSelectMenuText(comp);
	        };
	      });
	      var setInitialValue = Optional.some(function (comp) {
	        return updateSelectMenuText(comp);
	      });
	      var dataset = buildBasicSettingsDataset(editor, 'fontsize_formats', defaultFontsizeFormats, Delimiter.Space);
	      return {
	        tooltip: 'Font sizes',
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getPreviewFor: getPreviewFor,
	        getCurrentValue: getCurrentValue,
	        onAction: onAction,
	        setInitialValue: setInitialValue,
	        nodeChangeHandler: nodeChangeHandler,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: never
	      };
	    };
	    var createFontsizeSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$2(editor));
	    };
	    var fontsizeSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$2(editor));
	      editor.ui.registry.addNestedMenuItem('fontsizes', {
	        text: 'Font sizes',
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var findNearest = function (editor, getStyles) {
	      var styles = getStyles();
	      var formats = map(styles, function (style) {
	        return style.format;
	      });
	      return Optional.from(editor.formatter.closest(formats)).bind(function (fmt) {
	        return find(styles, function (data) {
	          return data.format === fmt;
	        });
	      }).orThunk(function () {
	        return someIf(editor.formatter.match('p'), {
	          title: 'Paragraph',
	          format: 'p'
	        });
	      });
	    };
	
	    var revocable = function (doRevoke) {
	      var subject = Cell(Optional.none());
	      var revoke = function () {
	        return subject.get().each(doRevoke);
	      };
	      var clear = function () {
	        revoke();
	        subject.set(Optional.none());
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var set = function (s) {
	        revoke();
	        subject.set(Optional.some(s));
	      };
	      return {
	        clear: clear,
	        isSet: isSet,
	        set: set
	      };
	    };
	    var destroyable = function () {
	      return revocable(function (s) {
	        return s.destroy();
	      });
	    };
	    var unbindable = function () {
	      return revocable(function (s) {
	        return s.unbind();
	      });
	    };
	    var value$3 = function () {
	      var subject = Cell(Optional.none());
	      var clear = function () {
	        return subject.set(Optional.none());
	      };
	      var set = function (s) {
	        return subject.set(Optional.some(s));
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var onSetupFormatToggle = function (editor, name) {
	      return function (api) {
	        var boundCallback = unbindable();
	        var init = function () {
	          api.setActive(editor.formatter.match(name));
	          var binding = editor.formatter.formatChanged(name, api.setActive);
	          boundCallback.set(binding);
	        };
	        editor.initialized ? init() : editor.on('init', init);
	        return boundCallback.clear;
	      };
	    };
	    var onActionToggleFormat = function (editor) {
	      return function (rawItem) {
	        return function () {
	          editor.undoManager.transact(function () {
	            editor.focus();
	            editor.execCommand('mceToggleFormat', false, rawItem.format);
	          });
	        };
	      };
	    };
	
	    var defaultBlocks = 'Paragraph=p;' + 'Heading 1=h1;' + 'Heading 2=h2;' + 'Heading 3=h3;' + 'Heading 4=h4;' + 'Heading 5=h5;' + 'Heading 6=h6;' + 'Preformatted=pre';
	    var getSpec$3 = function (editor) {
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (format) {
	        return function () {
	          var fmt = editor.formatter.get(format);
	          return Optional.some({
	            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
	            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
	          });
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var detectedFormat = findNearest(editor, function () {
	          return dataset.data;
	        });
	        var text = detectedFormat.fold(function () {
	          return 'Paragraph';
	        }, function (fmt) {
	          return fmt.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var nodeChangeHandler = Optional.some(function (comp) {
	        return function () {
	          return updateSelectMenuText(comp);
	        };
	      });
	      var setInitialValue = Optional.some(function (comp) {
	        return updateSelectMenuText(comp);
	      });
	      var dataset = buildBasicSettingsDataset(editor, 'block_formats', defaultBlocks, Delimiter.SemiColon);
	      return {
	        tooltip: 'Blocks',
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: Optional.none,
	        getPreviewFor: getPreviewFor,
	        onAction: onActionToggleFormat(editor),
	        setInitialValue: setInitialValue,
	        nodeChangeHandler: nodeChangeHandler,
	        dataset: dataset,
	        shouldHide: false,
	        isInvalid: function (item) {
	          return !editor.formatter.canApply(item.format);
	        }
	      };
	    };
	    var createFormatSelect = function (editor, backstage) {
	      return createSelectButton(editor, backstage, getSpec$3(editor));
	    };
	    var formatSelectMenu = function (editor, backstage) {
	      var menuItems = createMenuItems(editor, backstage, getSpec$3(editor));
	      editor.ui.registry.addNestedMenuItem('blockformats', {
	        text: 'Blocks',
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var getSpec$4 = function (editor, dataset) {
	      var isSelectedFor = function (format) {
	        return function () {
	          return editor.formatter.match(format);
	        };
	      };
	      var getPreviewFor = function (format) {
	        return function () {
	          var fmt = editor.formatter.get(format);
	          return fmt !== undefined ? Optional.some({
	            tag: fmt.length > 0 ? fmt[0].inline || fmt[0].block || 'div' : 'div',
	            styles: editor.dom.parseStyle(editor.formatter.getCssText(format))
	          }) : Optional.none();
	        };
	      };
	      var updateSelectMenuText = function (comp) {
	        var getFormatItems = function (fmt) {
	          var subs = fmt.items;
	          return subs !== undefined && subs.length > 0 ? bind(subs, getFormatItems) : [{
	              title: fmt.title,
	              format: fmt.format
	            }];
	        };
	        var flattenedItems = bind(getStyleFormats(editor), getFormatItems);
	        var detectedFormat = findNearest(editor, function () {
	          return flattenedItems;
	        });
	        var text = detectedFormat.fold(function () {
	          return 'Paragraph';
	        }, function (fmt) {
	          return fmt.title;
	        });
	        emitWith(comp, updateMenuText, { text: text });
	      };
	      var nodeChangeHandler = Optional.some(function (comp) {
	        return function () {
	          return updateSelectMenuText(comp);
	        };
	      });
	      var setInitialValue = Optional.some(function (comp) {
	        return updateSelectMenuText(comp);
	      });
	      return {
	        tooltip: 'Formats',
	        icon: Optional.none(),
	        isSelectedFor: isSelectedFor,
	        getCurrentValue: Optional.none,
	        getPreviewFor: getPreviewFor,
	        onAction: onActionToggleFormat(editor),
	        setInitialValue: setInitialValue,
	        nodeChangeHandler: nodeChangeHandler,
	        shouldHide: editor.getParam('style_formats_autohide', false, 'boolean'),
	        isInvalid: function (item) {
	          return !editor.formatter.canApply(item.format);
	        },
	        dataset: dataset
	      };
	    };
	    var createStyleSelect = function (editor, backstage) {
	      var dataset = __assign({ type: 'advanced' }, backstage.styleselect);
	      return createSelectButton(editor, backstage, getSpec$4(editor, dataset));
	    };
	    var styleSelectMenu = function (editor, backstage) {
	      var dataset = __assign({ type: 'advanced' }, backstage.styleselect);
	      var menuItems = createMenuItems(editor, backstage, getSpec$4(editor, dataset));
	      editor.ui.registry.addNestedMenuItem('formats', {
	        text: 'Formats',
	        getSubmenuItems: function () {
	          return menuItems.items.validateItems(menuItems.getStyleItems());
	        }
	      });
	    };
	
	    var defaultToolbar = [
	      {
	        name: 'history',
	        items: [
	          'undo',
	          'redo'
	        ]
	      },
	      {
	        name: 'styles',
	        items: ['styleselect']
	      },
	      {
	        name: 'formatting',
	        items: [
	          'bold',
	          'italic'
	        ]
	      },
	      {
	        name: 'alignment',
	        items: [
	          'alignleft',
	          'aligncenter',
	          'alignright',
	          'alignjustify'
	        ]
	      },
	      {
	        name: 'indentation',
	        items: [
	          'outdent',
	          'indent'
	        ]
	      },
	      {
	        name: 'permanent pen',
	        items: ['permanentpen']
	      },
	      {
	        name: 'comments',
	        items: ['addcomment']
	      }
	    ];
	    var renderFromBridge = function (bridgeBuilder, render) {
	      return function (spec, extras, editor) {
	        var internal = bridgeBuilder(spec).mapError(function (errInfo) {
	          return formatError(errInfo);
	        }).getOrDie();
	        return render(internal, extras, editor);
	      };
	    };
	    var types = {
	      button: renderFromBridge(createToolbarButton, function (s, extras) {
	        return renderToolbarButton(s, extras.backstage.shared.providers);
	      }),
	      togglebutton: renderFromBridge(createToggleButton, function (s, extras) {
	        return renderToolbarToggleButton(s, extras.backstage.shared.providers);
	      }),
	      menubutton: renderFromBridge(createMenuButton, function (s, extras) {
	        return renderMenuButton(s, 'tox-tbtn', extras.backstage, Optional.none());
	      }),
	      splitbutton: renderFromBridge(createSplitButton, function (s, extras) {
	        return renderSplitButton(s, extras.backstage.shared);
	      }),
	      grouptoolbarbutton: renderFromBridge(createGroupToolbarButton, function (s, extras, editor) {
	        var _a;
	        var buttons = editor.ui.registry.getAll().buttons;
	        var identify = function (toolbar) {
	          return identifyButtons(editor, {
	            buttons: buttons,
	            toolbar: toolbar,
	            allowToolbarGroups: false
	          }, extras, Optional.none());
	        };
	        var attributes = (_a = {}, _a[Attribute] = extras.backstage.shared.header.isPositionedAtTop() ? AttributeValue.TopToBottom : AttributeValue.BottomToTop, _a);
	        switch (getToolbarMode(editor)) {
	        case ToolbarMode.floating:
	          return renderFloatingToolbarButton(s, extras.backstage, identify, attributes);
	        default:
	          throw new Error('Toolbar groups are only supported when using floating toolbar mode');
	        }
	      }),
	      styleSelectButton: function (editor, extras) {
	        return createStyleSelect(editor, extras.backstage);
	      },
	      fontsizeSelectButton: function (editor, extras) {
	        return createFontsizeSelect(editor, extras.backstage);
	      },
	      fontSelectButton: function (editor, extras) {
	        return createFontSelect(editor, extras.backstage);
	      },
	      formatButton: function (editor, extras) {
	        return createFormatSelect(editor, extras.backstage);
	      },
	      alignMenuButton: function (editor, extras) {
	        return createAlignSelect(editor, extras.backstage);
	      }
	    };
	    var extractFrom = function (spec, extras, editor) {
	      return get$1(types, spec.type).fold(function () {
	        console.error('skipping button defined by', spec);
	        return Optional.none();
	      }, function (render) {
	        return Optional.some(render(spec, extras, editor));
	      });
	    };
	    var bespokeButtons = {
	      styleselect: types.styleSelectButton,
	      fontsizeselect: types.fontsizeSelectButton,
	      fontselect: types.fontSelectButton,
	      formatselect: types.formatButton,
	      align: types.alignMenuButton
	    };
	    var removeUnusedDefaults = function (buttons) {
	      var filteredItemGroups = map(defaultToolbar, function (group) {
	        var items = filter(group.items, function (subItem) {
	          return has(buttons, subItem) || has(bespokeButtons, subItem);
	        });
	        return {
	          name: group.name,
	          items: items
	        };
	      });
	      return filter(filteredItemGroups, function (group) {
	        return group.items.length > 0;
	      });
	    };
	    var convertStringToolbar = function (strToolbar) {
	      var groupsStrings = strToolbar.split('|');
	      return map(groupsStrings, function (g) {
	        return { items: g.trim().split(' ') };
	      });
	    };
	    var isToolbarGroupSettingArray = function (toolbar) {
	      return isArrayOf(toolbar, function (t) {
	        return has(t, 'name') && has(t, 'items');
	      });
	    };
	    var createToolbar = function (toolbarConfig) {
	      var toolbar = toolbarConfig.toolbar;
	      var buttons = toolbarConfig.buttons;
	      if (toolbar === false) {
	        return [];
	      } else if (toolbar === undefined || toolbar === true) {
	        return removeUnusedDefaults(buttons);
	      } else if (isString(toolbar)) {
	        return convertStringToolbar(toolbar);
	      } else if (isToolbarGroupSettingArray(toolbar)) {
	        return toolbar;
	      } else {
	        console.error('Toolbar type should be string, string[], boolean or ToolbarGroup[]');
	        return [];
	      }
	    };
	    var lookupButton = function (editor, buttons, toolbarItem, allowToolbarGroups, extras, prefixes) {
	      return get$1(buttons, toolbarItem.toLowerCase()).orThunk(function () {
	        return prefixes.bind(function (ps) {
	          return findMap(ps, function (prefix) {
	            return get$1(buttons, prefix + toolbarItem.toLowerCase());
	          });
	        });
	      }).fold(function () {
	        return get$1(bespokeButtons, toolbarItem.toLowerCase()).map(function (r) {
	          return r(editor, extras);
	        }).orThunk(function () {
	          return Optional.none();
	        });
	      }, function (spec) {
	        if (spec.type === 'grouptoolbarbutton' && !allowToolbarGroups) {
	          console.warn('Ignoring the \'' + toolbarItem + '\' toolbar button. Group toolbar buttons are only supported when using floating toolbar mode and cannot be nested.');
	          return Optional.none();
	        } else {
	          return extractFrom(spec, extras, editor);
	        }
	      });
	    };
	    var identifyButtons = function (editor, toolbarConfig, extras, prefixes) {
	      var toolbarGroups = createToolbar(toolbarConfig);
	      var groups = map(toolbarGroups, function (group) {
	        var items = bind(group.items, function (toolbarItem) {
	          return toolbarItem.trim().length === 0 ? [] : lookupButton(editor, toolbarConfig.buttons, toolbarItem, toolbarConfig.allowToolbarGroups, extras, prefixes).toArray();
	        });
	        return {
	          title: Optional.from(editor.translate(group.name)),
	          items: items
	        };
	      });
	      return filter(groups, function (group) {
	        return group.items.length > 0;
	      });
	    };
	
	    var bubbleSize = 12;
	    var bubbleAlignments$1 = {
	      valignCentre: [],
	      alignCentre: [],
	      alignLeft: ['tox-pop--align-left'],
	      alignRight: ['tox-pop--align-right'],
	      right: ['tox-pop--right'],
	      left: ['tox-pop--left'],
	      bottom: ['tox-pop--bottom'],
	      top: ['tox-pop--top']
	    };
	    var anchorOverrides = {
	      maxHeightFunction: expandable(),
	      maxWidthFunction: expandable$1()
	    };
	    var desktopAnchorSpecLayouts = {
	      onLtr: function () {
	        return [
	          north$1,
	          south$1,
	          northeast$1,
	          southeast$1,
	          northwest$1,
	          southwest$1,
	          north$3,
	          south$3,
	          northeast$3,
	          southeast$3,
	          northwest$3,
	          southwest$3
	        ];
	      },
	      onRtl: function () {
	        return [
	          north$1,
	          south$1,
	          northwest$1,
	          southwest$1,
	          northeast$1,
	          southeast$1,
	          north$3,
	          south$3,
	          northwest$3,
	          southwest$3,
	          northeast$3,
	          southeast$3
	        ];
	      }
	    };
	    var mobileAnchorSpecLayouts = {
	      onLtr: function () {
	        return [
	          south$1,
	          southeast$1,
	          southwest$1,
	          northeast$1,
	          northwest$1,
	          north$1,
	          north$3,
	          south$3,
	          northeast$3,
	          southeast$3,
	          northwest$3,
	          southwest$3
	        ];
	      },
	      onRtl: function () {
	        return [
	          south$1,
	          southwest$1,
	          southeast$1,
	          northwest$1,
	          northeast$1,
	          north$1,
	          north$3,
	          south$3,
	          northwest$3,
	          southwest$3,
	          northeast$3,
	          southeast$3
	        ];
	      }
	    };
	    var getAnchorLayout = function (position, isTouch) {
	      if (position === 'line') {
	        return {
	          bubble: nu$8(bubbleSize, 0, bubbleAlignments$1),
	          layouts: {
	            onLtr: function () {
	              return [east$1];
	            },
	            onRtl: function () {
	              return [west$1];
	            }
	          },
	          overrides: anchorOverrides
	        };
	      } else {
	        return {
	          bubble: nu$8(0, bubbleSize, bubbleAlignments$1),
	          layouts: isTouch ? mobileAnchorSpecLayouts : desktopAnchorSpecLayouts,
	          overrides: anchorOverrides
	        };
	      }
	    };
	    var register$4 = function (editor, registryContextToolbars, sink, extras) {
	      var isTouch = detect$3().deviceType.isTouch;
	      var contextbar = build$1(renderContextToolbar({
	        sink: sink,
	        onEscape: function () {
	          editor.focus();
	          return Optional.some(true);
	        }
	      }));
	      var getBounds = function () {
	        return getContextToolbarBounds(editor, extras.backstage.shared);
	      };
	      var isRangeOverlapping = function (aTop, aBottom, bTop, bBottom) {
	        return Math.max(aTop, bTop) <= Math.min(aBottom, bBottom);
	      };
	      var getLastElementVerticalBound = function () {
	        var nodeBounds = lastElement.get().filter(function (ele) {
	          return inBody(SugarElement.fromDom(ele));
	        }).map(function (ele) {
	          return ele.getBoundingClientRect();
	        }).getOrThunk(function () {
	          return editor.selection.getRng().getBoundingClientRect();
	        });
	        var diffTop = editor.inline ? get$9().top : absolute$1(SugarElement.fromDom(editor.getBody())).y;
	        return {
	          y: nodeBounds.top + diffTop,
	          bottom: nodeBounds.bottom + diffTop
	        };
	      };
	      var shouldContextToolbarHide = function () {
	        if (isTouch() && extras.backstage.isContextMenuOpen()) {
	          return true;
	        }
	        var lastElementBounds = getLastElementVerticalBound();
	        var contextToolbarBounds = getBounds();
	        return !isRangeOverlapping(lastElementBounds.y, lastElementBounds.bottom, contextToolbarBounds.y, contextToolbarBounds.bottom);
	      };
	      var close = function () {
	        lastAnchor.set(Optional.none());
	        InlineView.hide(contextbar);
	      };
	      var forceHide = function () {
	        InlineView.hide(contextbar);
	      };
	      var hideOrRepositionIfNecessary = function () {
	        lastAnchor.get().each(function (anchor) {
	          var contextBarEle = contextbar.element;
	          remove$6(contextBarEle, 'display');
	          if (shouldContextToolbarHide()) {
	            set$2(contextBarEle, 'display', 'none');
	          } else {
	            Positioning.positionWithinBounds(sink, anchor, contextbar, Optional.some(getBounds()));
	          }
	        });
	      };
	      var lastAnchor = Cell(Optional.none());
	      var lastElement = Cell(Optional.none());
	      var timer = Cell(null);
	      var wrapInPopDialog = function (toolbarSpec) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-pop__dialog']
	          },
	          components: [toolbarSpec],
	          behaviours: derive$1([
	            Keying.config({ mode: 'acyclic' }),
	            config('pop-dialog-wrap-events', [
	              runOnAttached(function (comp) {
	                editor.shortcuts.add('ctrl+F9', 'focus statusbar', function () {
	                  return Keying.focusIn(comp);
	                });
	              }),
	              runOnDetached(function (_comp) {
	                editor.shortcuts.remove('ctrl+F9');
	              })
	            ])
	          ])
	        };
	      };
	      var getScopes = cached(function () {
	        return categorise(registryContextToolbars, function (toolbarApi) {
	          var alloySpec = buildToolbar([toolbarApi]);
	          emitWith(contextbar, forwardSlideEvent, { forwardContents: wrapInPopDialog(alloySpec) });
	        });
	      });
	      var buildContextToolbarGroups = function (allButtons, ctx) {
	        return identifyButtons(editor, {
	          buttons: allButtons,
	          toolbar: ctx.items,
	          allowToolbarGroups: false
	        }, extras, Optional.some(['form:']));
	      };
	      var buildContextMenuGroups = function (ctx, providers) {
	        return ContextForm.buildInitGroups(ctx, providers);
	      };
	      var buildToolbar = function (toolbars) {
	        var buttons = editor.ui.registry.getAll().buttons;
	        var scopes = getScopes();
	        var allButtons = __assign(__assign({}, buttons), scopes.formNavigators);
	        var toolbarType = getToolbarMode(editor) === ToolbarMode.scrolling ? ToolbarMode.scrolling : ToolbarMode.default;
	        var initGroups = flatten(map(toolbars, function (ctx) {
	          return ctx.type === 'contexttoolbar' ? buildContextToolbarGroups(allButtons, ctx) : buildContextMenuGroups(ctx, extras.backstage.shared.providers);
	        }));
	        return renderToolbar({
	          type: toolbarType,
	          uid: generate$1('context-toolbar'),
	          initGroups: initGroups,
	          onEscape: Optional.none,
	          cyclicKeying: true,
	          providers: extras.backstage.shared.providers
	        });
	      };
	      editor.on(showContextToolbarEvent, function (e) {
	        var scopes = getScopes();
	        get$1(scopes.lookupTable, e.toolbarKey).each(function (ctx) {
	          launchContext([ctx], e.target === editor ? Optional.none() : Optional.some(e));
	          InlineView.getContent(contextbar).each(Keying.focusIn);
	        });
	      });
	      var getAnchor = function (position, element) {
	        var anchorage = position === 'node' ? extras.backstage.shared.anchors.node(element) : extras.backstage.shared.anchors.cursor();
	        return deepMerge(anchorage, getAnchorLayout(position, isTouch()));
	      };
	      var launchContext = function (toolbarApi, elem) {
	        clearTimer();
	        if (isTouch() && extras.backstage.isContextMenuOpen()) {
	          return;
	        }
	        var toolbarSpec = buildToolbar(toolbarApi);
	        var sElem = elem.map(SugarElement.fromDom);
	        var anchor = getAnchor(toolbarApi[0].position, sElem);
	        lastAnchor.set(Optional.some(anchor));
	        lastElement.set(elem);
	        var contextBarEle = contextbar.element;
	        remove$6(contextBarEle, 'display');
	        InlineView.showWithinBounds(contextbar, anchor, wrapInPopDialog(toolbarSpec), function () {
	          return Optional.some(getBounds());
	        });
	        if (shouldContextToolbarHide()) {
	          set$2(contextBarEle, 'display', 'none');
	        }
	      };
	      var launchContextToolbar = function () {
	        if (!editor.hasFocus()) {
	          return;
	        }
	        var scopes = getScopes();
	        lookup$1(scopes, editor).fold(close, function (info) {
	          launchContext(info.toolbars, Optional.some(info.elem.dom));
	        });
	      };
	      var clearTimer = function () {
	        var current = timer.get();
	        if (current !== null) {
	          global$2.clearTimeout(current);
	          timer.set(null);
	        }
	      };
	      var asyncOpen = function () {
	        clearTimer();
	        timer.set(global$2.setEditorTimeout(editor, launchContextToolbar, 0));
	      };
	      editor.on('init', function () {
	        editor.on(hideContextToolbarEvent, forceHide);
	        editor.on('ScrollContent ScrollWindow longpress', hideOrRepositionIfNecessary);
	        editor.on('click keyup focus SetContent ObjectResized ResizeEditor', function () {
	          asyncOpen();
	        });
	        editor.on('focusout', function (_e) {
	          global$2.setEditorTimeout(editor, function () {
	            if (search(sink.element).isNone() && search(contextbar.element).isNone()) {
	              close();
	            }
	          }, 0);
	        });
	        editor.on('SwitchMode', function () {
	          if (editor.mode.isReadOnly()) {
	            close();
	          }
	        });
	        editor.on('AfterProgressState', function (event) {
	          if (event.state) {
	            close();
	          } else if (editor.hasFocus()) {
	            asyncOpen();
	          }
	        });
	        editor.on('NodeChange', function (_e) {
	          search(contextbar.element).fold(asyncOpen, noop);
	        });
	      });
	    };
	
	    var setup$3 = function (editor, mothership, uiMothership) {
	      var broadcastEvent = function (name, evt) {
	        each([
	          mothership,
	          uiMothership
	        ], function (ship) {
	          ship.broadcastEvent(name, evt);
	        });
	      };
	      var broadcastOn = function (channel, message) {
	        each([
	          mothership,
	          uiMothership
	        ], function (ship) {
	          ship.broadcastOn([channel], message);
	        });
	      };
	      var fireDismissPopups = function (evt) {
	        return broadcastOn(dismissPopups(), { target: evt.target });
	      };
	      var onTouchstart = bind$3(SugarElement.fromDom(document), 'touchstart', fireDismissPopups);
	      var onTouchmove = bind$3(SugarElement.fromDom(document), 'touchmove', function (evt) {
	        return broadcastEvent(documentTouchmove(), evt);
	      });
	      var onTouchend = bind$3(SugarElement.fromDom(document), 'touchend', function (evt) {
	        return broadcastEvent(documentTouchend(), evt);
	      });
	      var onMousedown = bind$3(SugarElement.fromDom(document), 'mousedown', fireDismissPopups);
	      var onMouseup = bind$3(SugarElement.fromDom(document), 'mouseup', function (evt) {
	        if (evt.raw.button === 0) {
	          broadcastOn(mouseReleased(), { target: evt.target });
	        }
	      });
	      var onContentClick = function (raw) {
	        return broadcastOn(dismissPopups(), { target: SugarElement.fromDom(raw.target) });
	      };
	      var onContentMouseup = function (raw) {
	        if (raw.button === 0) {
	          broadcastOn(mouseReleased(), { target: SugarElement.fromDom(raw.target) });
	        }
	      };
	      var onWindowScroll = function (evt) {
	        return broadcastEvent(windowScroll(), fromRawEvent$1(evt));
	      };
	      var onWindowResize = function (evt) {
	        broadcastOn(repositionPopups(), {});
	        broadcastEvent(windowResize(), fromRawEvent$1(evt));
	      };
	      var onEditorResize = function () {
	        return broadcastOn(repositionPopups(), {});
	      };
	      var onEditorProgress = function (evt) {
	        if (evt.state) {
	          broadcastOn(dismissPopups(), { target: SugarElement.fromDom(editor.getContainer()) });
	        }
	      };
	      editor.on('PostRender', function () {
	        editor.on('click', onContentClick);
	        editor.on('tap', onContentClick);
	        editor.on('mouseup', onContentMouseup);
	        editor.on('ScrollWindow', onWindowScroll);
	        editor.on('ResizeWindow', onWindowResize);
	        editor.on('ResizeEditor', onEditorResize);
	        editor.on('AfterProgressState', onEditorProgress);
	      });
	      editor.on('remove', function () {
	        editor.off('click', onContentClick);
	        editor.off('tap', onContentClick);
	        editor.off('mouseup', onContentMouseup);
	        editor.off('ScrollWindow', onWindowScroll);
	        editor.off('ResizeWindow', onWindowResize);
	        editor.off('ResizeEditor', onEditorResize);
	        editor.off('AfterProgressState', onEditorProgress);
	        onMousedown.unbind();
	        onTouchstart.unbind();
	        onTouchmove.unbind();
	        onTouchend.unbind();
	        onMouseup.unbind();
	      });
	      editor.on('detach', function () {
	        detachSystem(mothership);
	        detachSystem(uiMothership);
	        mothership.destroy();
	        uiMothership.destroy();
	      });
	    };
	
	    var parts$d = AlloyParts;
	    var partType$1 = PartType;
	
	    var schema$r = constant([
	      defaulted$1('shell', false),
	      strict$1('makeItem'),
	      defaulted$1('setupItem', noop),
	      SketchBehaviours.field('listBehaviours', [Replacing])
	    ]);
	    var customListDetail = function () {
	      return { behaviours: derive$1([Replacing.config({})]) };
	    };
	    var itemsPart = optional({
	      name: 'items',
	      overrides: customListDetail
	    });
	    var parts$e = constant([itemsPart]);
	    var name$2 = constant('CustomList');
	
	    var factory$f = function (detail, components, _spec, _external) {
	      var setItems = function (list, items) {
	        getListContainer(list).fold(function () {
	          console.error('Custom List was defined to not be a shell, but no item container was specified in components');
	          throw new Error('Custom List was defined to not be a shell, but no item container was specified in components');
	        }, function (container) {
	          var itemComps = Replacing.contents(container);
	          var numListsRequired = items.length;
	          var numListsToAdd = numListsRequired - itemComps.length;
	          var itemsToAdd = numListsToAdd > 0 ? range(numListsToAdd, function () {
	            return detail.makeItem();
	          }) : [];
	          var itemsToRemove = itemComps.slice(numListsRequired);
	          each(itemsToRemove, function (item) {
	            return Replacing.remove(container, item);
	          });
	          each(itemsToAdd, function (item) {
	            return Replacing.append(container, item);
	          });
	          var builtLists = Replacing.contents(container);
	          each(builtLists, function (item, i) {
	            detail.setupItem(list, item, items[i], i);
	          });
	        });
	      };
	      var extra = detail.shell ? {
	        behaviours: [Replacing.config({})],
	        components: []
	      } : {
	        behaviours: [],
	        components: components
	      };
	      var getListContainer = function (component) {
	        return detail.shell ? Optional.some(component) : getPart(component, detail, 'items');
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: extra.components,
	        behaviours: augment(detail.listBehaviours, extra.behaviours),
	        apis: { setItems: setItems }
	      };
	    };
	    var CustomList = composite$1({
	      name: name$2(),
	      configFields: schema$r(),
	      partFields: parts$e(),
	      factory: factory$f,
	      apis: {
	        setItems: function (apis, list, items) {
	          apis.setItems(list, items);
	        }
	      }
	    });
	
	    var setup$4 = noop;
	    var isDocked = never;
	    var getBehaviours$2 = constant([]);
	
	    var StaticHeader = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setup: setup$4,
	        isDocked: isDocked,
	        getBehaviours: getBehaviours$2
	    });
	
	    var getOffsetParent = function (element) {
	      var isFixed = getRaw(element, 'position').is('fixed');
	      var offsetParent$1 = isFixed ? Optional.none() : offsetParent(element);
	      return offsetParent$1.orThunk(function () {
	        var marker = SugarElement.fromTag('span');
	        return parent(element).bind(function (parent) {
	          append(parent, marker);
	          var offsetParent$1 = offsetParent(marker);
	          remove(marker);
	          return offsetParent$1;
	        });
	      });
	    };
	    var getOrigin = function (element) {
	      return getOffsetParent(element).map(absolute).getOrThunk(function () {
	        return SugarPosition(0, 0);
	      });
	    };
	
	    var morphAdt = Adt.generate([
	      { static: [] },
	      { absolute: ['positionCss'] },
	      { fixed: ['positionCss'] }
	    ]);
	    var appear = function (component, contextualInfo) {
	      var elem = component.element;
	      add$2(elem, contextualInfo.transitionClass);
	      remove$4(elem, contextualInfo.fadeOutClass);
	      add$2(elem, contextualInfo.fadeInClass);
	      contextualInfo.onShow(component);
	    };
	    var disappear = function (component, contextualInfo) {
	      var elem = component.element;
	      add$2(elem, contextualInfo.transitionClass);
	      remove$4(elem, contextualInfo.fadeInClass);
	      add$2(elem, contextualInfo.fadeOutClass);
	      contextualInfo.onHide(component);
	    };
	    var isPartiallyVisible = function (box, viewport) {
	      return box.y < viewport.bottom && box.bottom > viewport.y;
	    };
	    var isTopCompletelyVisible = function (box, viewport) {
	      return box.y >= viewport.y;
	    };
	    var isBottomCompletelyVisible = function (box, viewport) {
	      return box.bottom <= viewport.bottom;
	    };
	    var isVisibleForModes = function (modes, box, viewport) {
	      return forall(modes, function (mode) {
	        switch (mode) {
	        case 'bottom':
	          return isBottomCompletelyVisible(box, viewport);
	        case 'top':
	          return isTopCompletelyVisible(box, viewport);
	        }
	      });
	    };
	    var getPrior = function (elem, state) {
	      return state.getInitialPosition().map(function (pos) {
	        return bounds$1(pos.bounds.x, pos.bounds.y, get$8(elem), get$7(elem));
	      });
	    };
	    var storePrior = function (elem, box, state) {
	      state.setInitialPosition(Optional.some({
	        style: getAllRaw(elem),
	        position: get$5(elem, 'position') || 'static',
	        bounds: box
	      }));
	    };
	    var revertToOriginal = function (elem, box$1, state) {
	      return state.getInitialPosition().bind(function (position) {
	        state.setInitialPosition(Optional.none());
	        switch (position.position) {
	        case 'static':
	          return Optional.some(morphAdt.static());
	        case 'absolute':
	          var offsetBox_1 = getOffsetParent(elem).map(box).getOrThunk(function () {
	            return box(body());
	          });
	          return Optional.some(morphAdt.absolute(NuPositionCss('absolute', get$1(position.style, 'left').map(function (_left) {
	            return box$1.x - offsetBox_1.x;
	          }), get$1(position.style, 'top').map(function (_top) {
	            return box$1.y - offsetBox_1.y;
	          }), get$1(position.style, 'right').map(function (_right) {
	            return offsetBox_1.right - box$1.right;
	          }), get$1(position.style, 'bottom').map(function (_bottom) {
	            return offsetBox_1.bottom - box$1.bottom;
	          }))));
	        default:
	          return Optional.none();
	        }
	      });
	    };
	    var morphToOriginal = function (elem, viewport, state) {
	      return getPrior(elem, state).filter(function (box) {
	        return isVisibleForModes(state.getModes(), box, viewport);
	      }).bind(function (box) {
	        return revertToOriginal(elem, box, state);
	      });
	    };
	    var morphToFixed = function (elem, viewport, state) {
	      var box$1 = box(elem);
	      if (!isVisibleForModes(state.getModes(), box$1, viewport)) {
	        storePrior(elem, box$1, state);
	        var winBox = win();
	        var left = box$1.x - winBox.x;
	        var top_1 = viewport.y - winBox.y;
	        var bottom = winBox.bottom - viewport.bottom;
	        var isTop = box$1.y <= viewport.y;
	        return Optional.some(morphAdt.fixed(NuPositionCss('fixed', Optional.some(left), isTop ? Optional.some(top_1) : Optional.none(), Optional.none(), !isTop ? Optional.some(bottom) : Optional.none())));
	      } else {
	        return Optional.none();
	      }
	    };
	    var getMorph = function (component, viewport, state) {
	      var elem = component.element;
	      var isDocked = getRaw(elem, 'position').is('fixed');
	      return isDocked ? morphToOriginal(elem, viewport, state) : morphToFixed(elem, viewport, state);
	    };
	    var getMorphToOriginal = function (component, state) {
	      var elem = component.element;
	      return getPrior(elem, state).bind(function (box) {
	        return revertToOriginal(elem, box, state);
	      });
	    };
	
	    var morphToStatic = function (component, config) {
	      each([
	        'left',
	        'right',
	        'top',
	        'bottom',
	        'position'
	      ], function (prop) {
	        return remove$6(component.element, prop);
	      });
	      config.onUndocked(component);
	    };
	    var morphToCoord = function (component, config, position) {
	      applyPositionCss(component.element, position);
	      var method = position.position === 'fixed' ? config.onDocked : config.onUndocked;
	      method(component);
	    };
	    var updateVisibility = function (component, config, state, viewport, morphToDocked) {
	      if (morphToDocked === void 0) {
	        morphToDocked = false;
	      }
	      config.contextual.each(function (contextInfo) {
	        contextInfo.lazyContext(component).each(function (box) {
	          var isVisible = isPartiallyVisible(box, viewport);
	          if (isVisible !== state.isVisible()) {
	            state.setVisible(isVisible);
	            if (morphToDocked && !isVisible) {
	              add$3(component.element, [contextInfo.fadeOutClass]);
	              contextInfo.onHide(component);
	            } else {
	              var method = isVisible ? appear : disappear;
	              method(component, contextInfo);
	            }
	          }
	        });
	      });
	    };
	    var refreshInternal = function (component, config, state) {
	      var viewport = config.lazyViewport(component);
	      var isDocked = state.isDocked();
	      if (isDocked) {
	        updateVisibility(component, config, state, viewport);
	      }
	      getMorph(component, viewport, state).each(function (morph) {
	        state.setDocked(!isDocked);
	        morph.fold(function () {
	          return morphToStatic(component, config);
	        }, function (position) {
	          return morphToCoord(component, config, position);
	        }, function (position) {
	          updateVisibility(component, config, state, viewport, true);
	          morphToCoord(component, config, position);
	        });
	      });
	    };
	    var resetInternal = function (component, config, state) {
	      var elem = component.element;
	      state.setDocked(false);
	      getMorphToOriginal(component, state).each(function (morph) {
	        morph.fold(function () {
	          return morphToStatic(component, config);
	        }, function (position) {
	          return morphToCoord(component, config, position);
	        }, noop);
	      });
	      state.setVisible(true);
	      config.contextual.each(function (contextInfo) {
	        remove$5(elem, [
	          contextInfo.fadeInClass,
	          contextInfo.fadeOutClass,
	          contextInfo.transitionClass
	        ]);
	        contextInfo.onShow(component);
	      });
	      refresh$4(component, config, state);
	    };
	    var refresh$4 = function (component, config, state) {
	      if (component.getSystem().isConnected()) {
	        refreshInternal(component, config, state);
	      }
	    };
	    var reset = function (component, config, state) {
	      if (state.isDocked()) {
	        resetInternal(component, config, state);
	      }
	    };
	    var isDocked$1 = function (component, config, state) {
	      return state.isDocked();
	    };
	    var setModes = function (component, config, state, modes) {
	      return state.setModes(modes);
	    };
	    var getModes = function (component, config, state) {
	      return state.getModes();
	    };
	
	    var DockingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        refresh: refresh$4,
	        reset: reset,
	        isDocked: isDocked$1,
	        getModes: getModes,
	        setModes: setModes
	    });
	
	    var events$f = function (dockInfo, dockState) {
	      return derive([
	        runOnSource(transitionend(), function (component, simulatedEvent) {
	          dockInfo.contextual.each(function (contextInfo) {
	            if (has$2(component.element, contextInfo.transitionClass)) {
	              remove$5(component.element, [
	                contextInfo.transitionClass,
	                contextInfo.fadeInClass
	              ]);
	              var notify = dockState.isVisible() ? contextInfo.onShown : contextInfo.onHidden;
	              notify(component);
	            }
	            simulatedEvent.stop();
	          });
	        }),
	        run(windowScroll(), function (component, _) {
	          refresh$4(component, dockInfo, dockState);
	        }),
	        run(windowResize(), function (component, _) {
	          reset(component, dockInfo, dockState);
	        })
	      ]);
	    };
	
	    var ActiveDocking = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        events: events$f
	    });
	
	    var DockingSchema = [
	      optionObjOf('contextual', [
	        strictString('fadeInClass'),
	        strictString('fadeOutClass'),
	        strictString('transitionClass'),
	        strictFunction('lazyContext'),
	        onHandler('onShow'),
	        onHandler('onShown'),
	        onHandler('onHide'),
	        onHandler('onHidden')
	      ]),
	      defaultedFunction('lazyViewport', win),
	      defaultedArrayOf('modes', [
	        'top',
	        'bottom'
	      ], string),
	      onHandler('onDocked'),
	      onHandler('onUndocked')
	    ];
	
	    var init$b = function (spec) {
	      var docked = Cell(false);
	      var visible = Cell(true);
	      var initialBounds = Cell(Optional.none());
	      var modes = Cell(spec.modes);
	      var readState = function () {
	        return 'docked:  ' + docked.get() + ', visible: ' + visible.get() + ', modes: ' + modes.get().join(',');
	      };
	      return nu$5({
	        isDocked: docked.get,
	        setDocked: docked.set,
	        getInitialPosition: initialBounds.get,
	        setInitialPosition: initialBounds.set,
	        isVisible: visible.get,
	        setVisible: visible.set,
	        getModes: modes.get,
	        setModes: modes.set,
	        readState: readState
	      });
	    };
	
	    var DockingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$b
	    });
	
	    var Docking = create$1({
	      fields: DockingSchema,
	      name: 'docking',
	      active: ActiveDocking,
	      apis: DockingApis,
	      state: DockingState
	    });
	
	    var visibility = {
	      fadeInClass: 'tox-editor-dock-fadein',
	      fadeOutClass: 'tox-editor-dock-fadeout',
	      transitionClass: 'tox-editor-dock-transition'
	    };
	    var editorStickyOnClass = 'tox-tinymce--toolbar-sticky-on';
	    var editorStickyOffClass = 'tox-tinymce--toolbar-sticky-off';
	    var scrollFromBehindHeader = function (e, containerHeader) {
	      var doc = owner(containerHeader);
	      var viewHeight = doc.dom.defaultView.innerHeight;
	      var scrollPos = get$9(doc);
	      var markerElement = SugarElement.fromDom(e.elm);
	      var markerPos = absolute$1(markerElement);
	      var markerHeight = get$7(markerElement);
	      var markerTop = markerPos.y;
	      var markerBottom = markerTop + markerHeight;
	      var editorHeaderPos = absolute(containerHeader);
	      var editorHeaderHeight = get$7(containerHeader);
	      var editorHeaderTop = editorHeaderPos.top;
	      var editorHeaderBottom = editorHeaderTop + editorHeaderHeight;
	      var editorHeaderDockedAtTop = Math.abs(editorHeaderTop - scrollPos.top) < 2;
	      var editorHeaderDockedAtBottom = Math.abs(editorHeaderBottom - (scrollPos.top + viewHeight)) < 2;
	      if (editorHeaderDockedAtTop && markerTop < editorHeaderBottom) {
	        to(scrollPos.left, markerTop - editorHeaderHeight, doc);
	      } else if (editorHeaderDockedAtBottom && markerBottom > editorHeaderTop) {
	        var y = markerTop - viewHeight + markerHeight + editorHeaderHeight;
	        to(scrollPos.left, y, doc);
	      }
	    };
	    var isDockedMode = function (header, mode) {
	      return contains(Docking.getModes(header), mode);
	    };
	    var updateIframeContentFlow = function (header) {
	      var getOccupiedHeight = function (elm) {
	        return getOuter$1(elm) + (parseInt(get$5(elm, 'margin-top'), 10) || 0) + (parseInt(get$5(elm, 'margin-bottom'), 10) || 0);
	      };
	      var elm = header.element;
	      parent(elm).each(function (parentElem) {
	        var padding = 'padding-' + Docking.getModes(header)[0];
	        if (Docking.isDocked(header)) {
	          var parentWidth = get$8(parentElem);
	          set$2(elm, 'width', parentWidth + 'px');
	          set$2(parentElem, padding, getOccupiedHeight(elm) + 'px');
	        } else {
	          remove$6(elm, 'width');
	          remove$6(parentElem, padding);
	        }
	      });
	    };
	    var updateSinkVisibility = function (sinkElem, visible) {
	      if (visible) {
	        remove$4(sinkElem, visibility.fadeOutClass);
	        add$3(sinkElem, [
	          visibility.transitionClass,
	          visibility.fadeInClass
	        ]);
	      } else {
	        remove$4(sinkElem, visibility.fadeInClass);
	        add$3(sinkElem, [
	          visibility.fadeOutClass,
	          visibility.transitionClass
	        ]);
	      }
	    };
	    var updateEditorClasses = function (editor, docked) {
	      var editorContainer = SugarElement.fromDom(editor.getContainer());
	      if (docked) {
	        add$2(editorContainer, editorStickyOnClass);
	        remove$4(editorContainer, editorStickyOffClass);
	      } else {
	        add$2(editorContainer, editorStickyOffClass);
	        remove$4(editorContainer, editorStickyOnClass);
	      }
	    };
	    var restoreFocus = function (headerElem, focusedElem) {
	      var ownerDoc = owner(focusedElem);
	      active(ownerDoc).filter(function (activeElm) {
	        return !eq$1(focusedElem, activeElm);
	      }).filter(function (activeElm) {
	        return eq$1(activeElm, SugarElement.fromDom(ownerDoc.dom.body)) || contains$2(headerElem, activeElm);
	      }).each(function () {
	        return focus$1(focusedElem);
	      });
	    };
	    var findFocusedElem = function (rootElm, lazySink) {
	      return search(rootElm).orThunk(function () {
	        return lazySink().toOptional().bind(function (sink) {
	          return search(sink.element);
	        });
	      });
	    };
	    var setup$5 = function (editor, sharedBackstage, lazyHeader) {
	      if (!editor.inline) {
	        if (!sharedBackstage.header.isPositionedAtTop()) {
	          editor.on('ResizeEditor', function () {
	            lazyHeader().each(Docking.reset);
	          });
	        }
	        editor.on('ResizeWindow ResizeEditor', function () {
	          lazyHeader().each(updateIframeContentFlow);
	        });
	        editor.on('SkinLoaded', function () {
	          lazyHeader().each(function (comp) {
	            Docking.isDocked(comp) ? Docking.reset(comp) : Docking.refresh(comp);
	          });
	        });
	        editor.on('FullscreenStateChanged', function () {
	          lazyHeader().each(Docking.reset);
	        });
	      }
	      editor.on('AfterScrollIntoView', function (e) {
	        lazyHeader().each(function (header) {
	          Docking.refresh(header);
	          var headerElem = header.element;
	          if (isVisible(headerElem)) {
	            scrollFromBehindHeader(e, headerElem);
	          }
	        });
	      });
	      editor.on('PostRender', function () {
	        updateEditorClasses(editor, false);
	      });
	    };
	    var isDocked$2 = function (lazyHeader) {
	      return lazyHeader().map(Docking.isDocked).getOr(false);
	    };
	    var getIframeBehaviours = function () {
	      var _a;
	      return [Receiving.config({ channels: (_a = {}, _a[toolbarHeightChange()] = { onReceive: updateIframeContentFlow }, _a) })];
	    };
	    var getBehaviours$3 = function (editor, sharedBackstage) {
	      var focusedElm = Cell(Optional.none());
	      var lazySink = sharedBackstage.getSink;
	      var runOnSinkElement = function (f) {
	        lazySink().each(function (sink) {
	          return f(sink.element);
	        });
	      };
	      var onDockingSwitch = function (comp) {
	        if (!editor.inline) {
	          updateIframeContentFlow(comp);
	        }
	        updateEditorClasses(editor, Docking.isDocked(comp));
	        comp.getSystem().broadcastOn([repositionPopups()], {});
	        lazySink().each(function (sink) {
	          return sink.getSystem().broadcastOn([repositionPopups()], {});
	        });
	      };
	      var additionalBehaviours = editor.inline ? [] : getIframeBehaviours();
	      return __spreadArrays([
	        Focusing.config({}),
	        Docking.config({
	          contextual: __assign({
	            lazyContext: function (comp) {
	              var headerHeight = getOuter$1(comp.element);
	              var container = editor.inline ? editor.getContentAreaContainer() : editor.getContainer();
	              var box$1 = box(SugarElement.fromDom(container));
	              var boxHeight = box$1.height - headerHeight;
	              var topBound = box$1.y + (isDockedMode(comp, 'top') ? 0 : headerHeight);
	              return Optional.some(bounds$1(box$1.x, topBound, box$1.width, boxHeight));
	            },
	            onShow: function () {
	              runOnSinkElement(function (elem) {
	                return updateSinkVisibility(elem, true);
	              });
	            },
	            onShown: function (comp) {
	              runOnSinkElement(function (elem) {
	                return remove$5(elem, [
	                  visibility.transitionClass,
	                  visibility.fadeInClass
	                ]);
	              });
	              focusedElm.get().each(function (elem) {
	                restoreFocus(comp.element, elem);
	                focusedElm.set(Optional.none());
	              });
	            },
	            onHide: function (comp) {
	              focusedElm.set(findFocusedElem(comp.element, lazySink));
	              runOnSinkElement(function (elem) {
	                return updateSinkVisibility(elem, false);
	              });
	            },
	            onHidden: function () {
	              runOnSinkElement(function (elem) {
	                return remove$5(elem, [visibility.transitionClass]);
	              });
	            }
	          }, visibility),
	          modes: [sharedBackstage.header.getDockingMode()],
	          onDocked: onDockingSwitch,
	          onUndocked: onDockingSwitch
	        })
	      ], additionalBehaviours);
	    };
	
	    var StickyHeader = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        setup: setup$5,
	        isDocked: isDocked$2,
	        getBehaviours: getBehaviours$3
	    });
	
	    var renderHeader = function (spec) {
	      var editor = spec.editor;
	      var getBehaviours = spec.sticky ? getBehaviours$3 : getBehaviours$2;
	      return {
	        uid: spec.uid,
	        dom: spec.dom,
	        components: spec.components,
	        behaviours: derive$1(getBehaviours(editor, spec.sharedBackstage))
	      };
	    };
	
	    var factory$g = function (detail, spec) {
	      var setMenus = function (comp, menus) {
	        var newMenus = map(menus, function (m) {
	          var buttonSpec = {
	            type: 'menubutton',
	            text: m.text,
	            fetch: function (callback) {
	              callback(m.getItems());
	            }
	          };
	          var internal = createMenuButton(buttonSpec).mapError(function (errInfo) {
	            return formatError(errInfo);
	          }).getOrDie();
	          return renderMenuButton(internal, 'tox-mbtn', spec.backstage, Optional.some('menuitem'));
	        });
	        Replacing.set(comp, newMenus);
	      };
	      var apis = {
	        focus: Keying.focusIn,
	        setMenus: setMenus
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: [],
	        behaviours: derive$1([
	          Replacing.config({}),
	          config('menubar-events', [
	            runOnAttached(function (component) {
	              detail.onSetup(component);
	            }),
	            run(mouseover(), function (comp, se) {
	              descendant$1(comp.element, '.' + 'tox-mbtn--active').each(function (activeButton) {
	                closest$3(se.event.target, '.' + 'tox-mbtn').each(function (hoveredButton) {
	                  if (!eq$1(activeButton, hoveredButton)) {
	                    comp.getSystem().getByDom(activeButton).each(function (activeComp) {
	                      comp.getSystem().getByDom(hoveredButton).each(function (hoveredComp) {
	                        Dropdown.expand(hoveredComp);
	                        Dropdown.close(activeComp);
	                        Focusing.focus(hoveredComp);
	                      });
	                    });
	                  }
	                });
	              });
	            }),
	            run(focusShifted(), function (comp, se) {
	              se.event.prevFocus.bind(function (prev) {
	                return comp.getSystem().getByDom(prev).toOptional();
	              }).each(function (prev) {
	                se.event.newFocus.bind(function (nu) {
	                  return comp.getSystem().getByDom(nu).toOptional();
	                }).each(function (nu) {
	                  if (Dropdown.isOpen(prev)) {
	                    Dropdown.expand(nu);
	                    Dropdown.close(prev);
	                  }
	                });
	              });
	            })
	          ]),
	          Keying.config({
	            mode: 'flow',
	            selector: '.' + 'tox-mbtn',
	            onEscape: function (comp) {
	              detail.onEscape(comp);
	              return Optional.some(true);
	            }
	          }),
	          Tabstopping.config({})
	        ]),
	        apis: apis,
	        domModification: { attributes: { role: 'menubar' } }
	      };
	    };
	    var SilverMenubar = single$2({
	      factory: factory$g,
	      name: 'silver.Menubar',
	      configFields: [
	        strict$1('dom'),
	        strict$1('uid'),
	        strict$1('onEscape'),
	        strict$1('backstage'),
	        defaulted$1('onSetup', noop)
	      ],
	      apis: {
	        focus: function (apis, comp) {
	          apis.focus(comp);
	        },
	        setMenus: function (apis, comp, menus) {
	          apis.setMenus(comp, menus);
	        }
	      }
	    });
	
	    var owner$4 = 'container';
	    var schema$s = [field$1('slotBehaviours', [])];
	    var getPartName$1 = function (name) {
	      return '<alloy.field.' + name + '>';
	    };
	    var sketch$2 = function (sSpec) {
	      var parts = function () {
	        var record = [];
	        var slot = function (name, config) {
	          record.push(name);
	          return generateOne(owner$4, getPartName$1(name), config);
	        };
	        return {
	          slot: slot,
	          record: function () {
	            return record;
	          }
	        };
	      }();
	      var spec = sSpec(parts);
	      var partNames = parts.record();
	      var fieldParts = map(partNames, function (n) {
	        return required({
	          name: n,
	          pname: getPartName$1(n)
	        });
	      });
	      return composite(owner$4, schema$s, fieldParts, make$7, spec);
	    };
	    var make$7 = function (detail, components) {
	      var getSlotNames = function (_) {
	        return getAllPartNames(detail);
	      };
	      var getSlot = function (container, key) {
	        return getPart(container, detail, key);
	      };
	      var onSlot = function (f, def) {
	        return function (container, key) {
	          return getPart(container, detail, key).map(function (slot) {
	            return f(slot, key);
	          }).getOr(def);
	        };
	      };
	      var onSlots = function (f) {
	        return function (container, keys) {
	          each(keys, function (key) {
	            return f(container, key);
	          });
	        };
	      };
	      var doShowing = function (comp, _key) {
	        return get$3(comp.element, 'aria-hidden') !== 'true';
	      };
	      var doShow = function (comp, key) {
	        if (!doShowing(comp)) {
	          var element = comp.element;
	          remove$6(element, 'display');
	          remove$1(element, 'aria-hidden');
	          emitWith(comp, slotVisibility(), {
	            name: key,
	            visible: true
	          });
	        }
	      };
	      var doHide = function (comp, key) {
	        if (doShowing(comp)) {
	          var element = comp.element;
	          set$2(element, 'display', 'none');
	          set$1(element, 'aria-hidden', 'true');
	          emitWith(comp, slotVisibility(), {
	            name: key,
	            visible: false
	          });
	        }
	      };
	      var isShowing = onSlot(doShowing, false);
	      var hideSlot = onSlot(doHide);
	      var hideSlots = onSlots(hideSlot);
	      var hideAllSlots = function (container) {
	        return hideSlots(container, getSlotNames());
	      };
	      var showSlot = onSlot(doShow);
	      var apis = {
	        getSlotNames: getSlotNames,
	        getSlot: getSlot,
	        isShowing: isShowing,
	        hideSlot: hideSlot,
	        hideAllSlots: hideAllSlots,
	        showSlot: showSlot
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: get$d(detail.slotBehaviours),
	        apis: apis
	      };
	    };
	    var slotApis = map$2({
	      getSlotNames: function (apis, c) {
	        return apis.getSlotNames(c);
	      },
	      getSlot: function (apis, c, key) {
	        return apis.getSlot(c, key);
	      },
	      isShowing: function (apis, c, key) {
	        return apis.isShowing(c, key);
	      },
	      hideSlot: function (apis, c, key) {
	        return apis.hideSlot(c, key);
	      },
	      hideAllSlots: function (apis, c) {
	        return apis.hideAllSlots(c);
	      },
	      showSlot: function (apis, c, key) {
	        return apis.showSlot(c, key);
	      }
	    }, function (value) {
	      return makeApi(value);
	    });
	    var SlotContainer = __assign(__assign({}, slotApis), { sketch: sketch$2 });
	
	    var sidebarSchema = objOf([
	      optionString('icon'),
	      optionString('tooltip'),
	      defaultedFunction('onShow', noop),
	      defaultedFunction('onHide', noop),
	      defaultedFunction('onSetup', function () {
	        return noop;
	      })
	    ]);
	    var createSidebar = function (spec) {
	      return asRaw('sidebar', sidebarSchema, spec);
	    };
	
	    var setup$6 = function (editor) {
	      var sidebars = editor.ui.registry.getAll().sidebars;
	      each(keys(sidebars), function (name) {
	        var spec = sidebars[name];
	        var isActive = function () {
	          return Optional.from(editor.queryCommandValue('ToggleSidebar')).is(name);
	        };
	        editor.ui.registry.addToggleButton(name, {
	          icon: spec.icon,
	          tooltip: spec.tooltip,
	          onAction: function (buttonApi) {
	            editor.execCommand('ToggleSidebar', false, name);
	            buttonApi.setActive(isActive());
	          },
	          onSetup: function (buttonApi) {
	            var handleToggle = function () {
	              return buttonApi.setActive(isActive());
	            };
	            editor.on('ToggleSidebar', handleToggle);
	            return function () {
	              editor.off('ToggleSidebar', handleToggle);
	            };
	          }
	        });
	      });
	    };
	    var getApi = function (comp) {
	      return {
	        element: function () {
	          return comp.element.dom;
	        }
	      };
	    };
	    var makePanels = function (parts, panelConfigs) {
	      var specs = map(keys(panelConfigs), function (name) {
	        var spec = panelConfigs[name];
	        var bridged = getOrDie(createSidebar(spec));
	        return {
	          name: name,
	          getApi: getApi,
	          onSetup: bridged.onSetup,
	          onShow: bridged.onShow,
	          onHide: bridged.onHide
	        };
	      });
	      return map(specs, function (spec) {
	        var editorOffCell = Cell(noop);
	        return parts.slot(spec.name, {
	          dom: {
	            tag: 'div',
	            classes: ['tox-sidebar__pane']
	          },
	          behaviours: SimpleBehaviours.unnamedEvents([
	            onControlAttached(spec, editorOffCell),
	            onControlDetached(spec, editorOffCell),
	            run(slotVisibility(), function (sidepanel, se) {
	              var data = se.event;
	              var optSidePanelSpec = find(specs, function (config) {
	                return config.name === data.name;
	              });
	              optSidePanelSpec.each(function (sidePanelSpec) {
	                var handler = data.visible ? sidePanelSpec.onShow : sidePanelSpec.onHide;
	                handler(sidePanelSpec.getApi(sidepanel));
	              });
	            })
	          ])
	        });
	      });
	    };
	    var makeSidebar = function (panelConfigs) {
	      return SlotContainer.sketch(function (parts) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-sidebar__pane-container']
	          },
	          components: makePanels(parts, panelConfigs),
	          slotBehaviours: SimpleBehaviours.unnamedEvents([runOnAttached(function (slotContainer) {
	              return SlotContainer.hideAllSlots(slotContainer);
	            })])
	        };
	      });
	    };
	    var setSidebar = function (sidebar, panelConfigs) {
	      var optSlider = Composing.getCurrent(sidebar);
	      optSlider.each(function (slider) {
	        return Replacing.set(slider, [makeSidebar(panelConfigs)]);
	      });
	    };
	    var toggleSidebar = function (sidebar, name) {
	      var optSlider = Composing.getCurrent(sidebar);
	      optSlider.each(function (slider) {
	        var optSlotContainer = Composing.getCurrent(slider);
	        optSlotContainer.each(function (slotContainer) {
	          if (Sliding.hasGrown(slider)) {
	            if (SlotContainer.isShowing(slotContainer, name)) {
	              Sliding.shrink(slider);
	            } else {
	              SlotContainer.hideAllSlots(slotContainer);
	              SlotContainer.showSlot(slotContainer, name);
	            }
	          } else {
	            SlotContainer.hideAllSlots(slotContainer);
	            SlotContainer.showSlot(slotContainer, name);
	            Sliding.grow(slider);
	          }
	        });
	      });
	    };
	    var whichSidebar = function (sidebar) {
	      var optSlider = Composing.getCurrent(sidebar);
	      return optSlider.bind(function (slider) {
	        var sidebarOpen = Sliding.isGrowing(slider) || Sliding.hasGrown(slider);
	        if (sidebarOpen) {
	          var optSlotContainer = Composing.getCurrent(slider);
	          return optSlotContainer.bind(function (slotContainer) {
	            return find(SlotContainer.getSlotNames(slotContainer), function (name) {
	              return SlotContainer.isShowing(slotContainer, name);
	            });
	          });
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var fixSize = generate$1('FixSizeEvent');
	    var autoSize = generate$1('AutoSizeEvent');
	    var renderSidebar = function (spec) {
	      return {
	        uid: spec.uid,
	        dom: {
	          tag: 'div',
	          classes: ['tox-sidebar'],
	          attributes: { role: 'complementary' }
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-sidebar__slider']
	            },
	            components: [],
	            behaviours: derive$1([
	              Tabstopping.config({}),
	              Focusing.config({}),
	              Sliding.config({
	                dimension: { property: 'width' },
	                closedClass: 'tox-sidebar--sliding-closed',
	                openClass: 'tox-sidebar--sliding-open',
	                shrinkingClass: 'tox-sidebar--sliding-shrinking',
	                growingClass: 'tox-sidebar--sliding-growing',
	                onShrunk: function (slider) {
	                  var optSlotContainer = Composing.getCurrent(slider);
	                  optSlotContainer.each(SlotContainer.hideAllSlots);
	                  emit(slider, autoSize);
	                },
	                onGrown: function (slider) {
	                  emit(slider, autoSize);
	                },
	                onStartGrow: function (slider) {
	                  emitWith(slider, fixSize, { width: getRaw(slider.element, 'width').getOr('') });
	                },
	                onStartShrink: function (slider) {
	                  emitWith(slider, fixSize, { width: get$8(slider.element) + 'px' });
	                }
	              }),
	              Replacing.config({}),
	              Composing.config({
	                find: function (comp) {
	                  var children = Replacing.contents(comp);
	                  return head(children);
	                }
	              })
	            ])
	          }],
	        behaviours: derive$1([
	          ComposingConfigs.childAt(0),
	          config('sidebar-sliding-events', [
	            run(fixSize, function (comp, se) {
	              set$2(comp.element, 'width', se.event.width);
	            }),
	            run(autoSize, function (comp, _se) {
	              remove$6(comp.element, 'width');
	            })
	          ])
	        ])
	      };
	    };
	
	    var getAttrs = function (elem) {
	      var attributes = elem.dom.attributes !== undefined ? elem.dom.attributes : [];
	      return foldl(attributes, function (b, attr) {
	        var _a;
	        if (attr.name === 'class') {
	          return b;
	        } else {
	          return __assign(__assign({}, b), (_a = {}, _a[attr.name] = attr.value, _a));
	        }
	      }, {});
	    };
	    var getClasses = function (elem) {
	      return Array.prototype.slice.call(elem.dom.classList, 0);
	    };
	    var fromHtml$2 = function (html) {
	      var elem = SugarElement.fromHtml(html);
	      var children$1 = children(elem);
	      var attrs = getAttrs(elem);
	      var classes = getClasses(elem);
	      var contents = children$1.length === 0 ? {} : { innerHtml: get$2(elem) };
	      return __assign({
	        tag: name(elem),
	        classes: classes,
	        attributes: attrs
	      }, contents);
	    };
	
	    var renderSpinner = function (providerBackstage) {
	      return {
	        dom: {
	          tag: 'div',
	          attributes: { 'aria-label': providerBackstage.translate('Loading...') },
	          classes: ['tox-throbber__busy-spinner']
	        },
	        components: [{ dom: fromHtml$2('<div class="tox-spinner"><div></div><div></div><div></div></div>') }],
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'special',
	            onTab: function () {
	              return Optional.some(true);
	            },
	            onShiftTab: function () {
	              return Optional.some(true);
	            }
	          }),
	          Focusing.config({})
	        ])
	      };
	    };
	    var toggleThrobber = function (comp, state, providerBackstage) {
	      var element = comp.element;
	      if (state === true) {
	        Replacing.set(comp, [renderSpinner(providerBackstage)]);
	        remove$6(element, 'display');
	        remove$1(element, 'aria-hidden');
	      } else {
	        Replacing.set(comp, []);
	        set$2(element, 'display', 'none');
	        set$1(element, 'aria-hidden', 'true');
	      }
	    };
	    var renderThrobber = function (spec) {
	      return {
	        uid: spec.uid,
	        dom: {
	          tag: 'div',
	          attributes: { 'aria-hidden': 'true' },
	          classes: ['tox-throbber'],
	          styles: { display: 'none' }
	        },
	        behaviours: derive$1([Replacing.config({})]),
	        components: []
	      };
	    };
	    var setup$7 = function (editor, lazyThrobber, sharedBackstage) {
	      var throbberState = Cell(false);
	      var timer = Cell(Optional.none());
	      var toggle = function (state) {
	        if (state !== throbberState.get()) {
	          toggleThrobber(lazyThrobber(), state, sharedBackstage.providers);
	          throbberState.set(state);
	          editor.fire('AfterProgressState', { state: state });
	        }
	      };
	      editor.on('ProgressState', function (e) {
	        timer.get().each(global$2.clearTimeout);
	        if (isNumber(e.time)) {
	          var timerId = global$2.setEditorTimeout(editor, function () {
	            return toggle(e.state);
	          }, e.time);
	          timer.set(Optional.some(timerId));
	        } else {
	          toggle(e.state);
	          timer.set(Optional.none());
	        }
	      });
	    };
	
	    var factory$h = function (detail, components, _spec) {
	      var apis = {
	        getSocket: function (comp) {
	          return parts$d.getPart(comp, detail, 'socket');
	        },
	        setSidebar: function (comp, panelConfigs) {
	          parts$d.getPart(comp, detail, 'sidebar').each(function (sidebar) {
	            return setSidebar(sidebar, panelConfigs);
	          });
	        },
	        toggleSidebar: function (comp, name) {
	          parts$d.getPart(comp, detail, 'sidebar').each(function (sidebar) {
	            return toggleSidebar(sidebar, name);
	          });
	        },
	        whichSidebar: function (comp) {
	          return parts$d.getPart(comp, detail, 'sidebar').bind(whichSidebar).getOrNull();
	        },
	        getHeader: function (comp) {
	          return parts$d.getPart(comp, detail, 'header');
	        },
	        getToolbar: function (comp) {
	          return parts$d.getPart(comp, detail, 'toolbar');
	        },
	        setToolbar: function (comp, groups) {
	          parts$d.getPart(comp, detail, 'toolbar').each(function (toolbar) {
	            toolbar.getApis().setGroups(toolbar, groups);
	          });
	        },
	        setToolbars: function (comp, toolbars) {
	          parts$d.getPart(comp, detail, 'multiple-toolbar').each(function (mToolbar) {
	            CustomList.setItems(mToolbar, toolbars);
	          });
	        },
	        refreshToolbar: function (comp) {
	          var toolbar = parts$d.getPart(comp, detail, 'toolbar');
	          toolbar.each(function (toolbar) {
	            return toolbar.getApis().refresh(toolbar);
	          });
	        },
	        toggleToolbarDrawer: function (comp) {
	          parts$d.getPart(comp, detail, 'toolbar').each(function (toolbar) {
	            mapFrom(toolbar.getApis().toggle, function (toggle) {
	              return toggle(toolbar);
	            });
	          });
	        },
	        isToolbarDrawerToggled: function (comp) {
	          return parts$d.getPart(comp, detail, 'toolbar').bind(function (toolbar) {
	            return Optional.from(toolbar.getApis().isOpen).map(function (isOpen) {
	              return isOpen(toolbar);
	            });
	          }).getOr(false);
	        },
	        getThrobber: function (comp) {
	          return parts$d.getPart(comp, detail, 'throbber');
	        },
	        focusToolbar: function (comp) {
	          var optToolbar = parts$d.getPart(comp, detail, 'toolbar').orThunk(function () {
	            return parts$d.getPart(comp, detail, 'multiple-toolbar');
	          });
	          optToolbar.each(function (toolbar) {
	            Keying.focusIn(toolbar);
	          });
	        },
	        setMenubar: function (comp, menus) {
	          parts$d.getPart(comp, detail, 'menubar').each(function (menubar) {
	            SilverMenubar.setMenus(menubar, menus);
	          });
	        },
	        focusMenubar: function (comp) {
	          parts$d.getPart(comp, detail, 'menubar').each(function (menubar) {
	            SilverMenubar.focus(menubar);
	          });
	        }
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        apis: apis,
	        behaviours: detail.behaviours
	      };
	    };
	    var partMenubar = partType$1.optional({
	      factory: SilverMenubar,
	      name: 'menubar',
	      schema: [strict$1('backstage')]
	    });
	    var toolbarFactory = function (spec) {
	      if (spec.type === ToolbarMode.sliding) {
	        return renderSlidingMoreToolbar;
	      } else if (spec.type === ToolbarMode.floating) {
	        return renderFloatingMoreToolbar;
	      } else {
	        return renderToolbar;
	      }
	    };
	    var partMultipleToolbar = partType$1.optional({
	      factory: {
	        sketch: function (spec) {
	          return CustomList.sketch({
	            uid: spec.uid,
	            dom: spec.dom,
	            listBehaviours: derive$1([Keying.config({
	                mode: 'acyclic',
	                selector: '.tox-toolbar'
	              })]),
	            makeItem: function () {
	              return renderToolbar({
	                type: spec.type,
	                uid: generate$1('multiple-toolbar-item'),
	                cyclicKeying: false,
	                initGroups: [],
	                providers: spec.providers,
	                onEscape: function () {
	                  spec.onEscape();
	                  return Optional.some(true);
	                }
	              });
	            },
	            setupItem: function (_mToolbar, tc, data, _index) {
	              Toolbar.setGroups(tc, data);
	            },
	            shell: true
	          });
	        }
	      },
	      name: 'multiple-toolbar',
	      schema: [
	        strict$1('dom'),
	        strict$1('onEscape')
	      ]
	    });
	    var partToolbar = partType$1.optional({
	      factory: {
	        sketch: function (spec) {
	          var renderer = toolbarFactory(spec);
	          var toolbarSpec = {
	            type: spec.type,
	            uid: spec.uid,
	            onEscape: function () {
	              spec.onEscape();
	              return Optional.some(true);
	            },
	            cyclicKeying: false,
	            initGroups: [],
	            getSink: spec.getSink,
	            providers: spec.providers,
	            moreDrawerData: {
	              lazyToolbar: spec.lazyToolbar,
	              lazyMoreButton: spec.lazyMoreButton,
	              lazyHeader: spec.lazyHeader
	            },
	            attributes: spec.attributes
	          };
	          return renderer(toolbarSpec);
	        }
	      },
	      name: 'toolbar',
	      schema: [
	        strict$1('dom'),
	        strict$1('onEscape'),
	        strict$1('getSink')
	      ]
	    });
	    var partHeader = partType$1.optional({
	      factory: { sketch: renderHeader },
	      name: 'header',
	      schema: [strict$1('dom')]
	    });
	    var partSocket = partType$1.optional({
	      name: 'socket',
	      schema: [strict$1('dom')]
	    });
	    var partSidebar = partType$1.optional({
	      factory: { sketch: renderSidebar },
	      name: 'sidebar',
	      schema: [strict$1('dom')]
	    });
	    var partThrobber = partType$1.optional({
	      factory: { sketch: renderThrobber },
	      name: 'throbber',
	      schema: [strict$1('dom')]
	    });
	    var OuterContainer = composite$1({
	      name: 'OuterContainer',
	      factory: factory$h,
	      configFields: [
	        strict$1('dom'),
	        strict$1('behaviours')
	      ],
	      partFields: [
	        partHeader,
	        partMenubar,
	        partToolbar,
	        partMultipleToolbar,
	        partSocket,
	        partSidebar,
	        partThrobber
	      ],
	      apis: {
	        getSocket: function (apis, comp) {
	          return apis.getSocket(comp);
	        },
	        setSidebar: function (apis, comp, panelConfigs) {
	          apis.setSidebar(comp, panelConfigs);
	        },
	        toggleSidebar: function (apis, comp, name) {
	          apis.toggleSidebar(comp, name);
	        },
	        whichSidebar: function (apis, comp) {
	          return apis.whichSidebar(comp);
	        },
	        getHeader: function (apis, comp) {
	          return apis.getHeader(comp);
	        },
	        getToolbar: function (apis, comp) {
	          return apis.getToolbar(comp);
	        },
	        setToolbar: function (apis, comp, grps) {
	          var groups = map(grps, function (grp) {
	            return renderToolbarGroup(grp);
	          });
	          apis.setToolbar(comp, groups);
	        },
	        setToolbars: function (apis, comp, ts) {
	          var renderedToolbars = map(ts, function (g) {
	            return map(g, renderToolbarGroup);
	          });
	          apis.setToolbars(comp, renderedToolbars);
	        },
	        refreshToolbar: function (apis, comp) {
	          return apis.refreshToolbar(comp);
	        },
	        toggleToolbarDrawer: function (apis, comp) {
	          apis.toggleToolbarDrawer(comp);
	        },
	        isToolbarDrawerToggled: function (apis, comp) {
	          return apis.isToolbarDrawerToggled(comp);
	        },
	        getThrobber: function (apis, comp) {
	          return apis.getThrobber(comp);
	        },
	        setMenubar: function (apis, comp, menus) {
	          apis.setMenubar(comp, menus);
	        },
	        focusMenubar: function (apis, comp) {
	          apis.focusMenubar(comp);
	        },
	        focusToolbar: function (apis, comp) {
	          apis.focusToolbar(comp);
	        }
	      }
	    });
	
	    var defaultMenubar = 'file edit view insert format tools table help';
	    var defaultMenus = {
	      file: {
	        title: 'File',
	        items: 'newdocument restoredraft | preview | export print | deleteallconversations'
	      },
	      edit: {
	        title: 'Edit',
	        items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'
	      },
	      view: {
	        title: 'View',
	        items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments'
	      },
	      insert: {
	        title: 'Insert',
	        items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime'
	      },
	      format: {
	        title: 'Format',
	        items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat'
	      },
	      tools: {
	        title: 'Tools',
	        items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount'
	      },
	      table: {
	        title: 'Table',
	        items: 'inserttable | cell row column | advtablesort | tableprops deletetable'
	      },
	      help: {
	        title: 'Help',
	        items: 'help'
	      }
	    };
	    var make$8 = function (menu, registry, editor) {
	      var removedMenuItems = getRemovedMenuItems(editor).split(/[ ,]/);
	      return {
	        text: menu.title,
	        getItems: function () {
	          return bind(menu.items, function (i) {
	            var itemName = i.toLowerCase();
	            if (itemName.trim().length === 0) {
	              return [];
	            } else if (exists(removedMenuItems, function (removedMenuItem) {
	                return removedMenuItem === itemName;
	              })) {
	              return [];
	            } else if (itemName === 'separator' || itemName === '|') {
	              return [{ type: 'separator' }];
	            } else if (registry.menuItems[itemName]) {
	              return [registry.menuItems[itemName]];
	            } else {
	              return [];
	            }
	          });
	        }
	      };
	    };
	    var parseItemsString = function (items) {
	      if (typeof items === 'string') {
	        return items.split(' ');
	      }
	      return items;
	    };
	    var identifyMenus = function (editor, registry) {
	      var rawMenuData = __assign(__assign({}, defaultMenus), registry.menus);
	      var userDefinedMenus = keys(registry.menus).length > 0;
	      var menubar = registry.menubar === undefined || registry.menubar === true ? parseItemsString(defaultMenubar) : parseItemsString(registry.menubar === false ? '' : registry.menubar);
	      var validMenus = filter(menubar, function (menuName) {
	        return userDefinedMenus ? registry.menus.hasOwnProperty(menuName) && registry.menus[menuName].hasOwnProperty('items') || defaultMenus.hasOwnProperty(menuName) : defaultMenus.hasOwnProperty(menuName);
	      });
	      var menus = map(validMenus, function (menuName) {
	        var menuData = rawMenuData[menuName];
	        return make$8({
	          title: menuData.title,
	          items: parseItemsString(menuData.items)
	        }, registry, editor);
	      });
	      return filter(menus, function (menu) {
	        var isNotSeparator = function (item) {
	          return item.type !== 'separator';
	        };
	        return menu.getItems().length > 0 && exists(menu.getItems(), isNotSeparator);
	      });
	    };
	
	    var fireSkinLoaded$1 = function (editor) {
	      var done = function () {
	        editor._skinLoaded = true;
	        fireSkinLoaded(editor);
	      };
	      return function () {
	        if (editor.initialized) {
	          done();
	        } else {
	          editor.on('init', done);
	        }
	      };
	    };
	    var fireSkinLoadError$1 = function (editor, err) {
	      return function () {
	        return fireSkinLoadError(editor, { message: err });
	      };
	    };
	
	    var loadStylesheet = function (editor, stylesheetUrl, styleSheetLoader) {
	      return new global$4(function (resolve, reject) {
	        styleSheetLoader.load(stylesheetUrl, resolve, reject);
	        editor.on('remove', function () {
	          return styleSheetLoader.unload(stylesheetUrl);
	        });
	      });
	    };
	    var loadUiSkins = function (editor, skinUrl) {
	      var skinUiCss = skinUrl + '/skin.min.css';
	      return loadStylesheet(editor, skinUiCss, editor.ui.styleSheetLoader);
	    };
	    var loadShadowDomUiSkins = function (editor, skinUrl) {
	      var isInShadowRoot$1 = isInShadowRoot(SugarElement.fromDom(editor.getElement()));
	      if (isInShadowRoot$1) {
	        var shadowDomSkinCss = skinUrl + '/skin.shadowdom.min.css';
	        return loadStylesheet(editor, shadowDomSkinCss, global$5.DOM.styleSheetLoader);
	      } else {
	        return global$4.resolve();
	      }
	    };
	    var loadSkin = function (isInline, editor) {
	      var skinUrl = getSkinUrl(editor);
	      if (skinUrl) {
	        editor.contentCSS.push(skinUrl + (isInline ? '/content.inline' : '/content') + '.min.css');
	      }
	      if (isSkinDisabled(editor) === false && isString(skinUrl)) {
	        global$4.all([
	          loadUiSkins(editor, skinUrl),
	          loadShadowDomUiSkins(editor, skinUrl)
	        ]).then(fireSkinLoaded$1(editor), fireSkinLoadError$1(editor, 'Skin could not be loaded'));
	      } else {
	        fireSkinLoaded$1(editor)();
	      }
	    };
	    var iframe = curry(loadSkin, false);
	    var inline = curry(loadSkin, true);
	
	    var setToolbar = function (editor, uiComponents, rawUiConfig, backstage) {
	      var comp = uiComponents.outerContainer;
	      var toolbarConfig = rawUiConfig.toolbar;
	      var toolbarButtonsConfig = rawUiConfig.buttons;
	      if (isArrayOf(toolbarConfig, isString)) {
	        var toolbars = toolbarConfig.map(function (t) {
	          var config = {
	            toolbar: t,
	            buttons: toolbarButtonsConfig,
	            allowToolbarGroups: rawUiConfig.allowToolbarGroups
	          };
	          return identifyButtons(editor, config, { backstage: backstage }, Optional.none());
	        });
	        OuterContainer.setToolbars(comp, toolbars);
	      } else {
	        OuterContainer.setToolbar(comp, identifyButtons(editor, rawUiConfig, { backstage: backstage }, Optional.none()));
	      }
	    };
	
	    var detection = detect$3();
	    var isiOS12 = detection.os.isiOS() && detection.os.version.major <= 12;
	    var setupEvents = function (editor, uiComponents) {
	      var dom = editor.dom;
	      var contentWindow = editor.getWin();
	      var initialDocEle = editor.getDoc().documentElement;
	      var lastWindowDimensions = Cell(SugarPosition(contentWindow.innerWidth, contentWindow.innerHeight));
	      var lastDocumentDimensions = Cell(SugarPosition(initialDocEle.offsetWidth, initialDocEle.offsetHeight));
	      var resizeWindow = function () {
	        var outer = lastWindowDimensions.get();
	        if (outer.left !== contentWindow.innerWidth || outer.top !== contentWindow.innerHeight) {
	          lastWindowDimensions.set(SugarPosition(contentWindow.innerWidth, contentWindow.innerHeight));
	          fireResizeContent(editor);
	        }
	      };
	      var resizeDocument = function () {
	        var docEle = editor.getDoc().documentElement;
	        var inner = lastDocumentDimensions.get();
	        if (inner.left !== docEle.offsetWidth || inner.top !== docEle.offsetHeight) {
	          lastDocumentDimensions.set(SugarPosition(docEle.offsetWidth, docEle.offsetHeight));
	          fireResizeContent(editor);
	        }
	      };
	      var scroll = function (e) {
	        return fireScrollContent(editor, e);
	      };
	      dom.bind(contentWindow, 'resize', resizeWindow);
	      dom.bind(contentWindow, 'scroll', scroll);
	      var elementLoad = capture$1(SugarElement.fromDom(editor.getBody()), 'load', resizeDocument);
	      var mothership = uiComponents.uiMothership.element;
	      editor.on('hide', function () {
	        set$2(mothership, 'display', 'none');
	      });
	      editor.on('show', function () {
	        remove$6(mothership, 'display');
	      });
	      editor.on('NodeChange', resizeDocument);
	      editor.on('remove', function () {
	        elementLoad.unbind();
	        dom.unbind(contentWindow, 'resize', resizeWindow);
	        dom.unbind(contentWindow, 'scroll', scroll);
	        contentWindow = null;
	      });
	    };
	    var render$1 = function (editor, uiComponents, rawUiConfig, backstage, args) {
	      var lastToolbarWidth = Cell(0);
	      var outerContainer = uiComponents.outerContainer;
	      iframe(editor);
	      var eTargetNode = SugarElement.fromDom(args.targetNode);
	      var uiRoot = getContentContainer(getRootNode(eTargetNode));
	      attachSystemAfter(eTargetNode, uiComponents.mothership);
	      attachSystem(uiRoot, uiComponents.uiMothership);
	      editor.on('PostRender', function () {
	        setToolbar(editor, uiComponents, rawUiConfig, backstage);
	        lastToolbarWidth.set(editor.getWin().innerWidth);
	        OuterContainer.setMenubar(outerContainer, identifyMenus(editor, rawUiConfig));
	        OuterContainer.setSidebar(outerContainer, rawUiConfig.sidebar);
	        setupEvents(editor, uiComponents);
	      });
	      var socket = OuterContainer.getSocket(outerContainer).getOrDie('Could not find expected socket element');
	      if (isiOS12) {
	        setAll$1(socket.element, {
	          'overflow': 'scroll',
	          '-webkit-overflow-scrolling': 'touch'
	        });
	        var limit = first(function () {
	          editor.fire('ScrollContent');
	        }, 20);
	        var unbinder = bind$3(socket.element, 'scroll', limit.throttle);
	        editor.on('remove', unbinder.unbind);
	      }
	      setupReadonlyModeSwitch(editor, uiComponents);
	      editor.addCommand('ToggleSidebar', function (_ui, value) {
	        OuterContainer.toggleSidebar(outerContainer, value);
	        editor.fire('ToggleSidebar');
	      });
	      editor.addQueryValueHandler('ToggleSidebar', function () {
	        return OuterContainer.whichSidebar(outerContainer);
	      });
	      var toolbarMode = getToolbarMode(editor);
	      var refreshDrawer = function () {
	        OuterContainer.refreshToolbar(uiComponents.outerContainer);
	      };
	      if (toolbarMode === ToolbarMode.sliding || toolbarMode === ToolbarMode.floating) {
	        editor.on('ResizeWindow ResizeEditor ResizeContent', function () {
	          var width = editor.getWin().innerWidth;
	          if (width !== lastToolbarWidth.get()) {
	            refreshDrawer();
	            lastToolbarWidth.set(width);
	          }
	        });
	      }
	      var api = {
	        enable: function () {
	          broadcastReadonly(uiComponents, false);
	        },
	        disable: function () {
	          broadcastReadonly(uiComponents, true);
	        },
	        isDisabled: function () {
	          return Disabling.isDisabled(outerContainer);
	        }
	      };
	      return {
	        iframeContainer: socket.element.dom,
	        editorContainer: outerContainer.element.dom,
	        api: api
	      };
	    };
	
	    var Iframe = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        render: render$1
	    });
	
	    var parseToInt = function (val) {
	      var re = /^[0-9\.]+(|px)$/i;
	      if (re.test('' + val)) {
	        return Optional.some(parseInt('' + val, 10));
	      }
	      return Optional.none();
	    };
	    var numToPx = function (val) {
	      return isNumber(val) ? val + 'px' : val;
	    };
	    var calcCappedSize = function (size, minSize, maxSize) {
	      var minOverride = minSize.filter(function (min) {
	        return size < min;
	      });
	      var maxOverride = maxSize.filter(function (max) {
	        return size > max;
	      });
	      return minOverride.or(maxOverride).getOr(size);
	    };
	
	    var getHeight$1 = function (editor) {
	      var baseHeight = getHeightSetting(editor);
	      var minHeight = getMinHeightSetting(editor);
	      var maxHeight = getMaxHeightSetting(editor);
	      return parseToInt(baseHeight).map(function (height) {
	        return calcCappedSize(height, minHeight, maxHeight);
	      });
	    };
	    var getHeightWithFallback = function (editor) {
	      var height = getHeight$1(editor);
	      return height.getOr(getHeightSetting(editor));
	    };
	    var getWidth$1 = function (editor) {
	      var baseWidth = getWidthSetting(editor);
	      var minWidth = getMinWidthSetting(editor);
	      var maxWidth = getMaxWidthSetting(editor);
	      return parseToInt(baseWidth).map(function (width) {
	        return calcCappedSize(width, minWidth, maxWidth);
	      });
	    };
	    var getWidthWithFallback = function (editor) {
	      var width = getWidth$1(editor);
	      return width.getOr(getWidthSetting(editor));
	    };
	
	    var InlineHeader = function (editor, targetElm, uiComponents, backstage, floatContainer) {
	      var uiMothership = uiComponents.uiMothership, outerContainer = uiComponents.outerContainer;
	      var DOM = global$5.DOM;
	      var useFixedToolbarContainer = useFixedContainer(editor);
	      var isSticky = isStickyToolbar(editor);
	      var editorMaxWidthOpt = getMaxWidthSetting(editor).or(getWidth$1(editor));
	      var headerBackstage = backstage.shared.header;
	      var isPositionedAtTop = headerBackstage.isPositionedAtTop;
	      var toolbarMode = getToolbarMode(editor);
	      var isSplitToolbar = toolbarMode === ToolbarMode.sliding || toolbarMode === ToolbarMode.floating;
	      var visible = Cell(false);
	      var isVisible = function () {
	        return visible.get() && !editor.removed;
	      };
	      var calcToolbarOffset = function (toolbar) {
	        return isSplitToolbar ? toolbar.fold(function () {
	          return 0;
	        }, function (tbar) {
	          return tbar.components().length > 1 ? get$7(tbar.components()[1].element) : 0;
	        }) : 0;
	      };
	      var calcMode = function (container) {
	        switch (getToolbarLocation(editor)) {
	        case ToolbarLocation.auto:
	          var toolbar_1 = OuterContainer.getToolbar(outerContainer);
	          var offset = calcToolbarOffset(toolbar_1);
	          var toolbarHeight = get$7(container.element) - offset;
	          var targetBounds = box(targetElm);
	          var roomAtTop = targetBounds.y > toolbarHeight;
	          if (roomAtTop) {
	            return 'top';
	          } else {
	            var doc = documentElement(targetElm);
	            var docHeight = Math.max(doc.dom.scrollHeight, get$7(doc));
	            var roomAtBottom = targetBounds.bottom < docHeight - toolbarHeight;
	            if (roomAtBottom) {
	              return 'bottom';
	            } else {
	              var winBounds = win();
	              var isRoomAtBottomViewport = winBounds.bottom < targetBounds.bottom - toolbarHeight;
	              return isRoomAtBottomViewport ? 'bottom' : 'top';
	            }
	          }
	        case ToolbarLocation.bottom:
	          return 'bottom';
	        case ToolbarLocation.top:
	        default:
	          return 'top';
	        }
	      };
	      var setupMode = function (mode) {
	        var container = floatContainer.get();
	        Docking.setModes(container, [mode]);
	        headerBackstage.setDockingMode(mode);
	        var verticalDir = isPositionedAtTop() ? AttributeValue.TopToBottom : AttributeValue.BottomToTop;
	        set$1(container.element, Attribute, verticalDir);
	      };
	      var updateChromeWidth = function () {
	        var maxWidth = editorMaxWidthOpt.getOrThunk(function () {
	          var bodyMargin = parseToInt(get$5(body(), 'margin-left')).getOr(0);
	          return get$8(body()) - absolute(targetElm).left + bodyMargin;
	        });
	        set$2(floatContainer.get().element, 'max-width', maxWidth + 'px');
	      };
	      var updateChromePosition = function () {
	        var toolbar = OuterContainer.getToolbar(outerContainer);
	        var offset = calcToolbarOffset(toolbar);
	        var targetBounds = box(targetElm);
	        var top = isPositionedAtTop() ? Math.max(targetBounds.y - get$7(floatContainer.get().element) + offset, 0) : targetBounds.bottom;
	        setAll$1(outerContainer.element, {
	          position: 'absolute',
	          top: Math.round(top) + 'px',
	          left: Math.round(targetBounds.x) + 'px'
	        });
	      };
	      var repositionPopups$1 = function () {
	        uiMothership.broadcastOn([repositionPopups()], {});
	      };
	      var updateChromeUi = function (resetDocking) {
	        if (resetDocking === void 0) {
	          resetDocking = false;
	        }
	        if (!isVisible()) {
	          return;
	        }
	        if (!useFixedToolbarContainer) {
	          updateChromeWidth();
	        }
	        if (isSplitToolbar) {
	          OuterContainer.refreshToolbar(outerContainer);
	        }
	        if (!useFixedToolbarContainer) {
	          updateChromePosition();
	        }
	        if (isSticky) {
	          var floatContainerComp = floatContainer.get();
	          resetDocking ? Docking.reset(floatContainerComp) : Docking.refresh(floatContainerComp);
	        }
	        repositionPopups$1();
	      };
	      var updateMode = function (updateUi) {
	        if (updateUi === void 0) {
	          updateUi = true;
	        }
	        if (useFixedToolbarContainer || !isSticky || !isVisible()) {
	          return;
	        }
	        var currentMode = headerBackstage.getDockingMode();
	        var newMode = calcMode(floatContainer.get());
	        if (newMode !== currentMode) {
	          setupMode(newMode);
	          if (updateUi) {
	            updateChromeUi(true);
	          }
	        }
	      };
	      var show = function () {
	        visible.set(true);
	        set$2(outerContainer.element, 'display', 'flex');
	        DOM.addClass(editor.getBody(), 'mce-edit-focus');
	        remove$6(uiMothership.element, 'display');
	        updateMode(false);
	        updateChromeUi();
	      };
	      var hide = function () {
	        visible.set(false);
	        if (uiComponents.outerContainer) {
	          set$2(outerContainer.element, 'display', 'none');
	          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
	        }
	        set$2(uiMothership.element, 'display', 'none');
	      };
	      return {
	        isVisible: isVisible,
	        isPositionedAtTop: isPositionedAtTop,
	        show: show,
	        hide: hide,
	        update: updateChromeUi,
	        updateMode: updateMode,
	        repositionPopups: repositionPopups$1
	      };
	    };
	
	    var getTargetPosAndBounds = function (targetElm, isToolbarTop) {
	      var bounds = box(targetElm);
	      return {
	        pos: isToolbarTop ? bounds.y : bounds.bottom,
	        bounds: bounds
	      };
	    };
	    var setupEvents$1 = function (editor, targetElm, ui, toolbarPersist) {
	      var prevPosAndBounds = Cell(getTargetPosAndBounds(targetElm, ui.isPositionedAtTop()));
	      var resizeContent = function (e) {
	        var _a = getTargetPosAndBounds(targetElm, ui.isPositionedAtTop()), pos = _a.pos, bounds = _a.bounds;
	        var _b = prevPosAndBounds.get(), prevPos = _b.pos, prevBounds = _b.bounds;
	        var hasResized = bounds.height !== prevBounds.height || bounds.width !== prevBounds.width;
	        prevPosAndBounds.set({
	          pos: pos,
	          bounds: bounds
	        });
	        if (hasResized) {
	          fireResizeContent(editor, e);
	        }
	        if (ui.isVisible()) {
	          if (prevPos !== pos) {
	            ui.update(true);
	          } else if (hasResized) {
	            ui.updateMode();
	            ui.repositionPopups();
	          }
	        }
	      };
	      if (!toolbarPersist) {
	        editor.on('activate', ui.show);
	        editor.on('deactivate', ui.hide);
	      }
	      editor.on('SkinLoaded ResizeWindow', function () {
	        return ui.update(true);
	      });
	      editor.on('NodeChange keydown', function (e) {
	        global$2.requestAnimationFrame(function () {
	          return resizeContent(e);
	        });
	      });
	      editor.on('ScrollWindow', function () {
	        return ui.updateMode();
	      });
	      var elementLoad = unbindable();
	      elementLoad.set(capture$1(SugarElement.fromDom(editor.getBody()), 'load', resizeContent));
	      editor.on('remove', function () {
	        elementLoad.clear();
	      });
	    };
	    var render$2 = function (editor, uiComponents, rawUiConfig, backstage, args) {
	      var mothership = uiComponents.mothership, uiMothership = uiComponents.uiMothership, outerContainer = uiComponents.outerContainer;
	      var floatContainer = Cell(null);
	      var targetElm = SugarElement.fromDom(args.targetNode);
	      var ui = InlineHeader(editor, targetElm, uiComponents, backstage, floatContainer);
	      var toolbarPersist = isToolbarPersist(editor);
	      inline(editor);
	      var render = function () {
	        if (floatContainer.get()) {
	          ui.show();
	          return;
	        }
	        floatContainer.set(OuterContainer.getHeader(outerContainer).getOrDie());
	        var uiContainer = getUiContainer(editor);
	        attachSystem(uiContainer, mothership);
	        attachSystem(uiContainer, uiMothership);
	        setToolbar(editor, uiComponents, rawUiConfig, backstage);
	        OuterContainer.setMenubar(outerContainer, identifyMenus(editor, rawUiConfig));
	        ui.show();
	        setupEvents$1(editor, targetElm, ui, toolbarPersist);
	        editor.nodeChanged();
	      };
	      editor.on('show', render);
	      editor.on('hide', ui.hide);
	      if (!toolbarPersist) {
	        editor.on('focus', render);
	        editor.on('blur', ui.hide);
	      }
	      editor.on('init', function () {
	        if (editor.hasFocus() || toolbarPersist) {
	          render();
	        }
	      });
	      setupReadonlyModeSwitch(editor, uiComponents);
	      var api = {
	        show: function () {
	          ui.show();
	        },
	        hide: function () {
	          ui.hide();
	        },
	        enable: function () {
	          broadcastReadonly(uiComponents, false);
	        },
	        disable: function () {
	          broadcastReadonly(uiComponents, true);
	        },
	        isDisabled: function () {
	          return Disabling.isDisabled(outerContainer);
	        }
	      };
	      return {
	        editorContainer: outerContainer.element.dom,
	        api: api
	      };
	    };
	
	    var Inline = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        render: render$2
	    });
	
	    var register$5 = function (editor) {
	      var alignToolbarButtons = [
	        {
	          name: 'alignleft',
	          text: 'Align left',
	          cmd: 'JustifyLeft',
	          icon: 'align-left'
	        },
	        {
	          name: 'aligncenter',
	          text: 'Align center',
	          cmd: 'JustifyCenter',
	          icon: 'align-center'
	        },
	        {
	          name: 'alignright',
	          text: 'Align right',
	          cmd: 'JustifyRight',
	          icon: 'align-right'
	        },
	        {
	          name: 'alignjustify',
	          text: 'Justify',
	          cmd: 'JustifyFull',
	          icon: 'align-justify'
	        }
	      ];
	      global$c.each(alignToolbarButtons, function (item) {
	        editor.ui.registry.addToggleButton(item.name, {
	          tooltip: item.text,
	          onAction: function () {
	            return editor.execCommand(item.cmd);
	          },
	          icon: item.icon,
	          onSetup: onSetupFormatToggle(editor, item.name)
	        });
	      });
	      var alignNoneToolbarButton = {
	        name: 'alignnone',
	        text: 'No alignment',
	        cmd: 'JustifyNone',
	        icon: 'align-none'
	      };
	      editor.ui.registry.addButton(alignNoneToolbarButton.name, {
	        tooltip: alignNoneToolbarButton.text,
	        onAction: function () {
	          return editor.execCommand(alignNoneToolbarButton.cmd);
	        },
	        icon: alignNoneToolbarButton.icon
	      });
	    };
	
	    var register$6 = function (editor, backstage) {
	      alignSelectMenu(editor, backstage);
	      fontSelectMenu(editor, backstage);
	      styleSelectMenu(editor, backstage);
	      formatSelectMenu(editor, backstage);
	      fontsizeSelectMenu(editor, backstage);
	    };
	
	    var toggleOutdentState = function (api, editor) {
	      api.setDisabled(!editor.queryCommandState('outdent'));
	      var onNodeChange = function () {
	        api.setDisabled(!editor.queryCommandState('outdent'));
	      };
	      editor.on('NodeChange', onNodeChange);
	      return function () {
	        return editor.off('NodeChange', onNodeChange);
	      };
	    };
	    var registerButtons = function (editor) {
	      editor.ui.registry.addButton('outdent', {
	        tooltip: 'Decrease indent',
	        icon: 'outdent',
	        onSetup: function (api) {
	          return toggleOutdentState(api, editor);
	        },
	        onAction: function () {
	          return editor.execCommand('outdent');
	        }
	      });
	      editor.ui.registry.addButton('indent', {
	        tooltip: 'Increase indent',
	        icon: 'indent',
	        onAction: function () {
	          return editor.execCommand('indent');
	        }
	      });
	    };
	    var register$7 = function (editor) {
	      registerButtons(editor);
	    };
	
	    var units = {
	      unsupportedLength: [
	        'em',
	        'ex',
	        'cap',
	        'ch',
	        'ic',
	        'rem',
	        'lh',
	        'rlh',
	        'vw',
	        'vh',
	        'vi',
	        'vb',
	        'vmin',
	        'vmax',
	        'cm',
	        'mm',
	        'Q',
	        'in',
	        'pc',
	        'pt',
	        'px'
	      ],
	      fixed: [
	        'px',
	        'pt'
	      ],
	      relative: ['%'],
	      empty: ['']
	    };
	    var pattern = function () {
	      var decimalDigits = '[0-9]+';
	      var signedInteger = '[+-]?' + decimalDigits;
	      var exponentPart = '[eE]' + signedInteger;
	      var dot = '\\.';
	      var opt = function (input) {
	        return '(?:' + input + ')?';
	      };
	      var unsignedDecimalLiteral = [
	        'Infinity',
	        decimalDigits + dot + opt(decimalDigits) + opt(exponentPart),
	        dot + decimalDigits + opt(exponentPart),
	        decimalDigits + opt(exponentPart)
	      ].join('|');
	      var float = '[+-]?(?:' + unsignedDecimalLiteral + ')';
	      return new RegExp('^(' + float + ')(.*)$');
	    }();
	    var isUnit = function (unit, accepted) {
	      return exists(accepted, function (acc) {
	        return exists(units[acc], function (check) {
	          return unit === check;
	        });
	      });
	    };
	    var parse = function (input, accepted) {
	      var match = Optional.from(pattern.exec(input));
	      return match.bind(function (array) {
	        var value = Number(array[1]);
	        var unitRaw = array[2];
	        if (isUnit(unitRaw, accepted)) {
	          return Optional.some({
	            value: value,
	            unit: unitRaw
	          });
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var normalise = function (input, accepted) {
	      return parse(input, accepted).map(function (_a) {
	        var value = _a.value, unit = _a.unit;
	        return value + unit;
	      });
	    };
	
	    var normaliseLineHeight = function (input) {
	      return normalise(input, [
	        'fixed',
	        'relative',
	        'empty'
	      ]).getOr(input);
	    };
	    var getLineHeights = function (editor) {
	      var options = getLineHeightFormats(editor);
	      var apis = new Map();
	      var lastApi = destroyable();
	      var callback = function () {
	        var current = normaliseLineHeight(editor.queryCommandValue('LineHeight'));
	        Optional.from(apis.get(current)).fold(function () {
	          return lastApi.clear();
	        }, function (api) {
	          lastApi.set({
	            destroy: function () {
	              api.setActive(false);
	            }
	          });
	          api.setActive(true);
	        });
	      };
	      editor.on('nodeChange', callback);
	      return map(options, function (value, i) {
	        return {
	          type: 'togglemenuitem',
	          text: value,
	          onSetup: function (api) {
	            apis.set(normaliseLineHeight(value), api);
	            if (i + 1 === options.length) {
	              callback();
	            }
	            return function () {
	              if (i === 0) {
	                editor.off('nodeChange', callback);
	                lastApi.clear();
	              }
	            };
	          },
	          onAction: function () {
	            return editor.execCommand('LineHeight', false, value);
	          }
	        };
	      });
	    };
	    var registerMenuItems = function (editor) {
	      editor.ui.registry.addNestedMenuItem('lineheight', {
	        type: 'nestedmenuitem',
	        text: 'Line height',
	        getSubmenuItems: function () {
	          return getLineHeights(editor);
	        }
	      });
	    };
	    var registerButtons$1 = function (editor) {
	      editor.ui.registry.addMenuButton('lineheight', {
	        tooltip: 'Line height',
	        icon: 'line-height',
	        fetch: function (callback) {
	          return callback(getLineHeights(editor));
	        }
	      });
	    };
	    var register$8 = function (editor) {
	      registerMenuItems(editor);
	      registerButtons$1(editor);
	    };
	
	    var toggleFormat = function (editor, fmt) {
	      return function () {
	        editor.execCommand('mceToggleFormat', false, fmt);
	      };
	    };
	    var registerFormatButtons = function (editor) {
	      global$c.each([
	        {
	          name: 'bold',
	          text: 'Bold',
	          icon: 'bold'
	        },
	        {
	          name: 'italic',
	          text: 'Italic',
	          icon: 'italic'
	        },
	        {
	          name: 'underline',
	          text: 'Underline',
	          icon: 'underline'
	        },
	        {
	          name: 'strikethrough',
	          text: 'Strikethrough',
	          icon: 'strike-through'
	        },
	        {
	          name: 'subscript',
	          text: 'Subscript',
	          icon: 'subscript'
	        },
	        {
	          name: 'superscript',
	          text: 'Superscript',
	          icon: 'superscript'
	        }
	      ], function (btn, _idx) {
	        editor.ui.registry.addToggleButton(btn.name, {
	          tooltip: btn.text,
	          icon: btn.icon,
	          onSetup: onSetupFormatToggle(editor, btn.name),
	          onAction: toggleFormat(editor, btn.name)
	        });
	      });
	      for (var i = 1; i <= 6; i++) {
	        var name_1 = 'h' + i;
	        editor.ui.registry.addToggleButton(name_1, {
	          text: name_1.toUpperCase(),
	          tooltip: 'Heading ' + i,
	          onSetup: onSetupFormatToggle(editor, name_1),
	          onAction: toggleFormat(editor, name_1)
	        });
	      }
	    };
	    var registerCommandButtons = function (editor) {
	      global$c.each([
	        {
	          name: 'cut',
	          text: 'Cut',
	          action: 'Cut',
	          icon: 'cut'
	        },
	        {
	          name: 'copy',
	          text: 'Copy',
	          action: 'Copy',
	          icon: 'copy'
	        },
	        {
	          name: 'paste',
	          text: 'Paste',
	          action: 'Paste',
	          icon: 'paste'
	        },
	        {
	          name: 'help',
	          text: 'Help',
	          action: 'mceHelp',
	          icon: 'help'
	        },
	        {
	          name: 'selectall',
	          text: 'Select all',
	          action: 'SelectAll',
	          icon: 'select-all'
	        },
	        {
	          name: 'newdocument',
	          text: 'New document',
	          action: 'mceNewDocument',
	          icon: 'new-document'
	        },
	        {
	          name: 'removeformat',
	          text: 'Clear formatting',
	          action: 'RemoveFormat',
	          icon: 'remove-formatting'
	        },
	        {
	          name: 'remove',
	          text: 'Remove',
	          action: 'Delete',
	          icon: 'remove'
	        }
	      ], function (btn) {
	        editor.ui.registry.addButton(btn.name, {
	          tooltip: btn.text,
	          icon: btn.icon,
	          onAction: function () {
	            return editor.execCommand(btn.action);
	          }
	        });
	      });
	    };
	    var registerCommandToggleButtons = function (editor) {
	      global$c.each([{
	          name: 'blockquote',
	          text: 'Blockquote',
	          action: 'mceBlockQuote',
	          icon: 'quote'
	        }], function (btn) {
	        editor.ui.registry.addToggleButton(btn.name, {
	          tooltip: btn.text,
	          icon: btn.icon,
	          onAction: function () {
	            return editor.execCommand(btn.action);
	          },
	          onSetup: onSetupFormatToggle(editor, btn.name)
	        });
	      });
	    };
	    var registerButtons$2 = function (editor) {
	      registerFormatButtons(editor);
	      registerCommandButtons(editor);
	      registerCommandToggleButtons(editor);
	    };
	    var registerMenuItems$1 = function (editor) {
	      global$c.each([
	        {
	          name: 'bold',
	          text: 'Bold',
	          action: 'Bold',
	          icon: 'bold',
	          shortcut: 'Meta+B'
	        },
	        {
	          name: 'italic',
	          text: 'Italic',
	          action: 'Italic',
	          icon: 'italic',
	          shortcut: 'Meta+I'
	        },
	        {
	          name: 'underline',
	          text: 'Underline',
	          action: 'Underline',
	          icon: 'underline',
	          shortcut: 'Meta+U'
	        },
	        {
	          name: 'strikethrough',
	          text: 'Strikethrough',
	          action: 'Strikethrough',
	          icon: 'strike-through',
	          shortcut: ''
	        },
	        {
	          name: 'subscript',
	          text: 'Subscript',
	          action: 'Subscript',
	          icon: 'subscript',
	          shortcut: ''
	        },
	        {
	          name: 'superscript',
	          text: 'Superscript',
	          action: 'Superscript',
	          icon: 'superscript',
	          shortcut: ''
	        },
	        {
	          name: 'removeformat',
	          text: 'Clear formatting',
	          action: 'RemoveFormat',
	          icon: 'remove-formatting',
	          shortcut: ''
	        },
	        {
	          name: 'newdocument',
	          text: 'New document',
	          action: 'mceNewDocument',
	          icon: 'new-document',
	          shortcut: ''
	        },
	        {
	          name: 'cut',
	          text: 'Cut',
	          action: 'Cut',
	          icon: 'cut',
	          shortcut: 'Meta+X'
	        },
	        {
	          name: 'copy',
	          text: 'Copy',
	          action: 'Copy',
	          icon: 'copy',
	          shortcut: 'Meta+C'
	        },
	        {
	          name: 'paste',
	          text: 'Paste',
	          action: 'Paste',
	          icon: 'paste',
	          shortcut: 'Meta+V'
	        },
	        {
	          name: 'selectall',
	          text: 'Select all',
	          action: 'SelectAll',
	          icon: 'select-all',
	          shortcut: 'Meta+A'
	        }
	      ], function (btn) {
	        editor.ui.registry.addMenuItem(btn.name, {
	          text: btn.text,
	          icon: btn.icon,
	          shortcut: btn.shortcut,
	          onAction: function () {
	            return editor.execCommand(btn.action);
	          }
	        });
	      });
	      editor.ui.registry.addMenuItem('codeformat', {
	        text: 'Code',
	        icon: 'sourcecode',
	        onAction: toggleFormat(editor, 'code')
	      });
	    };
	    var register$9 = function (editor) {
	      registerButtons$2(editor);
	      registerMenuItems$1(editor);
	    };
	
	    var toggleUndoRedoState = function (api, editor, type) {
	      var checkState = function () {
	        return editor.undoManager ? editor.undoManager[type]() : false;
	      };
	      var onUndoStateChange = function () {
	        api.setDisabled(editor.mode.isReadOnly() || !checkState());
	      };
	      api.setDisabled(!checkState());
	      editor.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', onUndoStateChange);
	      return function () {
	        return editor.off('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', onUndoStateChange);
	      };
	    };
	    var registerMenuItems$2 = function (editor) {
	      editor.ui.registry.addMenuItem('undo', {
	        text: 'Undo',
	        icon: 'undo',
	        shortcut: 'Meta+Z',
	        onSetup: function (api) {
	          return toggleUndoRedoState(api, editor, 'hasUndo');
	        },
	        onAction: function () {
	          return editor.execCommand('undo');
	        }
	      });
	      editor.ui.registry.addMenuItem('redo', {
	        text: 'Redo',
	        icon: 'redo',
	        shortcut: 'Meta+Y',
	        onSetup: function (api) {
	          return toggleUndoRedoState(api, editor, 'hasRedo');
	        },
	        onAction: function () {
	          return editor.execCommand('redo');
	        }
	      });
	    };
	    var registerButtons$3 = function (editor) {
	      editor.ui.registry.addButton('undo', {
	        tooltip: 'Undo',
	        icon: 'undo',
	        onSetup: function (api) {
	          return toggleUndoRedoState(api, editor, 'hasUndo');
	        },
	        onAction: function () {
	          return editor.execCommand('undo');
	        }
	      });
	      editor.ui.registry.addButton('redo', {
	        tooltip: 'Redo',
	        icon: 'redo',
	        onSetup: function (api) {
	          return toggleUndoRedoState(api, editor, 'hasRedo');
	        },
	        onAction: function () {
	          return editor.execCommand('redo');
	        }
	      });
	    };
	    var register$a = function (editor) {
	      registerMenuItems$2(editor);
	      registerButtons$3(editor);
	    };
	
	    var toggleVisualAidState = function (api, editor) {
	      api.setActive(editor.hasVisual);
	      var onVisualAid = function (e) {
	        api.setActive(e.hasVisual);
	      };
	      editor.on('VisualAid', onVisualAid);
	      return function () {
	        return editor.off('VisualAid', onVisualAid);
	      };
	    };
	    var registerMenuItems$3 = function (editor) {
	      editor.ui.registry.addToggleMenuItem('visualaid', {
	        text: 'Visual aids',
	        onSetup: function (api) {
	          return toggleVisualAidState(api, editor);
	        },
	        onAction: function () {
	          editor.execCommand('mceToggleVisualAid');
	        }
	      });
	    };
	    var registerToolbarButton = function (editor) {
	      editor.ui.registry.addButton('visualaid', {
	        tooltip: 'Visual aids',
	        text: 'Visual aids',
	        onAction: function () {
	          return editor.execCommand('mceToggleVisualAid');
	        }
	      });
	    };
	    var register$b = function (editor) {
	      registerToolbarButton(editor);
	      registerMenuItems$3(editor);
	    };
	
	    var setup$8 = function (editor, backstage) {
	      register$5(editor);
	      register$9(editor);
	      register$6(editor, backstage);
	      register$a(editor);
	      register$1(editor);
	      register$b(editor);
	      register$7(editor);
	      register$8(editor);
	    };
	
	    var nu$d = function (x, y) {
	      return {
	        anchor: 'makeshift',
	        x: x,
	        y: y
	      };
	    };
	    var transpose$1 = function (pos, dx, dy) {
	      return nu$d(pos.x + dx, pos.y + dy);
	    };
	    var isTouchEvent$1 = function (e) {
	      return e.type === 'longpress' || e.type.indexOf('touch') === 0;
	    };
	    var fromPageXY = function (e) {
	      if (isTouchEvent$1(e)) {
	        var touch = e.touches[0];
	        return nu$d(touch.pageX, touch.pageY);
	      } else {
	        return nu$d(e.pageX, e.pageY);
	      }
	    };
	    var fromClientXY = function (e) {
	      if (isTouchEvent$1(e)) {
	        var touch = e.touches[0];
	        return nu$d(touch.clientX, touch.clientY);
	      } else {
	        return nu$d(e.clientX, e.clientY);
	      }
	    };
	    var transposeContentAreaContainer = function (element, pos) {
	      var containerPos = global$5.DOM.getPos(element);
	      return transpose$1(pos, containerPos.x, containerPos.y);
	    };
	    var getPointAnchor = function (editor, e) {
	      if (e.type === 'contextmenu' || e.type === 'longpress') {
	        if (editor.inline) {
	          return fromPageXY(e);
	        } else {
	          return transposeContentAreaContainer(editor.getContentAreaContainer(), fromClientXY(e));
	        }
	      } else {
	        return getSelectionAnchor(editor);
	      }
	    };
	    var getSelectionAnchor = function (editor) {
	      return {
	        anchor: 'selection',
	        root: SugarElement.fromDom(editor.selection.getNode())
	      };
	    };
	    var getNodeAnchor$1 = function (editor) {
	      return {
	        anchor: 'node',
	        node: Optional.some(SugarElement.fromDom(editor.selection.getNode())),
	        root: SugarElement.fromDom(editor.getBody())
	      };
	    };
	
	    var initAndShow = function (editor, e, buildMenu, backstage, contextmenu, useNodeAnchor) {
	      var items = buildMenu();
	      var anchorSpec = useNodeAnchor ? getNodeAnchor$1(editor) : getPointAnchor(editor, e);
	      build$2(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, false).map(function (menuData) {
	        e.preventDefault();
	        InlineView.showMenuAt(contextmenu, anchorSpec, {
	          menu: { markers: markers$1('normal') },
	          data: menuData
	        });
	      });
	    };
	
	    var layouts = {
	      onLtr: function () {
	        return [
	          south$1,
	          southeast$1,
	          southwest$1,
	          northeast$1,
	          northwest$1,
	          north$1,
	          north$3,
	          south$3,
	          northeast$3,
	          southeast$3,
	          northwest$3,
	          southwest$3
	        ];
	      },
	      onRtl: function () {
	        return [
	          south$1,
	          southwest$1,
	          southeast$1,
	          northwest$1,
	          northeast$1,
	          north$1,
	          north$3,
	          south$3,
	          northwest$3,
	          southwest$3,
	          northeast$3,
	          southeast$3
	        ];
	      }
	    };
	    var bubbleSize$1 = 12;
	    var bubbleAlignments$2 = {
	      valignCentre: [],
	      alignCentre: [],
	      alignLeft: ['tox-pop--align-left'],
	      alignRight: ['tox-pop--align-right'],
	      right: ['tox-pop--right'],
	      left: ['tox-pop--left'],
	      bottom: ['tox-pop--bottom'],
	      top: ['tox-pop--top']
	    };
	    var isTouchWithinSelection = function (editor, e) {
	      var selection = editor.selection;
	      if (selection.isCollapsed() || e.touches.length < 1) {
	        return false;
	      } else {
	        var touch_1 = e.touches[0];
	        var rng = selection.getRng();
	        var rngRectOpt = getFirstRect$1(editor.getWin(), SimSelection.domRange(rng));
	        return rngRectOpt.exists(function (rngRect) {
	          return rngRect.left <= touch_1.clientX && rngRect.right >= touch_1.clientX && rngRect.top <= touch_1.clientY && rngRect.bottom >= touch_1.clientY;
	        });
	      }
	    };
	    var getPointAnchorSpec = function (editor, e) {
	      return __assign({
	        bubble: nu$8(0, bubbleSize$1, bubbleAlignments$2),
	        layouts: layouts,
	        overrides: {
	          maxWidthFunction: expandable$1(),
	          maxHeightFunction: expandable()
	        }
	      }, getPointAnchor(editor, e));
	    };
	    var setupiOSOverrides = function (editor) {
	      var originalSelection = editor.selection.getRng();
	      var selectionReset = function () {
	        global$2.setEditorTimeout(editor, function () {
	          editor.selection.setRng(originalSelection);
	        }, 10);
	        unbindEventListeners();
	      };
	      editor.once('touchend', selectionReset);
	      var preventMousedown = function (e) {
	        e.preventDefault();
	        e.stopImmediatePropagation();
	      };
	      editor.on('mousedown', preventMousedown, true);
	      var clearSelectionReset = function () {
	        return unbindEventListeners();
	      };
	      editor.once('longpresscancel', clearSelectionReset);
	      var unbindEventListeners = function () {
	        editor.off('touchend', selectionReset);
	        editor.off('longpresscancel', clearSelectionReset);
	        editor.off('mousedown', preventMousedown);
	      };
	    };
	    var show = function (editor, e, items, backstage, contextmenu, useNodeAnchor, highlightImmediately) {
	      var anchorSpec = useNodeAnchor ? getNodeAnchor$1(editor) : getPointAnchorSpec(editor, e);
	      build$2(items, ItemResponse$1.CLOSE_ON_EXECUTE, backstage, true).map(function (menuData) {
	        e.preventDefault();
	        InlineView.showMenuWithinBounds(contextmenu, anchorSpec, {
	          menu: {
	            markers: markers$1('normal'),
	            highlightImmediately: highlightImmediately
	          },
	          data: menuData,
	          type: 'horizontal'
	        }, function () {
	          return Optional.some(getContextToolbarBounds(editor, backstage.shared));
	        });
	        editor.fire(hideContextToolbarEvent);
	      });
	    };
	    var initAndShow$1 = function (editor, e, buildMenu, backstage, contextmenu, useNodeAnchor) {
	      var detection = detect$3();
	      var isiOS = detection.os.isiOS();
	      var isOSX = detection.os.isOSX();
	      var isAndroid = detection.os.isAndroid();
	      var isTouch = detection.deviceType.isTouch();
	      var shouldHighlightImmediately = function () {
	        return !(isAndroid || isiOS || isOSX && isTouch);
	      };
	      var open = function () {
	        var items = buildMenu();
	        show(editor, e, items, backstage, contextmenu, useNodeAnchor, shouldHighlightImmediately());
	      };
	      if ((isOSX || isiOS) && !useNodeAnchor) {
	        var openiOS_1 = function () {
	          setupiOSOverrides(editor);
	          open();
	        };
	        if (isTouchWithinSelection(editor, e)) {
	          openiOS_1();
	        } else {
	          editor.once('selectionchange', openiOS_1);
	          editor.once('touchend', function () {
	            return editor.off('selectionchange', openiOS_1);
	          });
	        }
	      } else {
	        if (isAndroid && !useNodeAnchor) {
	          editor.selection.setCursorLocation(e.target, 0);
	        }
	        open();
	      }
	    };
	
	    var patchPipeConfig = function (config) {
	      return typeof config === 'string' ? config.split(/[ ,]/) : config;
	    };
	    var shouldNeverUseNative = function (editor) {
	      return editor.getParam('contextmenu_never_use_native', false, 'boolean');
	    };
	    var getMenuItems = function (editor, name, defaultItems) {
	      var contextMenus = editor.ui.registry.getAll().contextMenus;
	      return Optional.from(editor.getParam(name)).map(patchPipeConfig).getOrThunk(function () {
	        return filter(patchPipeConfig(defaultItems), function (item) {
	          return has(contextMenus, item);
	        });
	      });
	    };
	    var isContextMenuDisabled = function (editor) {
	      return editor.getParam('contextmenu') === false;
	    };
	    var getContextMenu = function (editor) {
	      return getMenuItems(editor, 'contextmenu', 'link linkchecker image imagetools table spellchecker configurepermanentpen');
	    };
	    var getAvoidOverlapSelector = function (editor) {
	      return editor.getParam('contextmenu_avoid_overlap', '', 'string');
	    };
	
	    var isSeparator$1 = function (item) {
	      return isString(item) ? item === '|' : item.type === 'separator';
	    };
	    var separator$3 = { type: 'separator' };
	    var makeContextItem = function (item) {
	      var commonMenuItem = function (item) {
	        return {
	          text: item.text,
	          icon: item.icon,
	          disabled: item.disabled,
	          shortcut: item.shortcut
	        };
	      };
	      if (isString(item)) {
	        return item;
	      } else {
	        switch (item.type) {
	        case 'separator':
	          return separator$3;
	        case 'submenu':
	          return __assign(__assign({ type: 'nestedmenuitem' }, commonMenuItem(item)), {
	            getSubmenuItems: function () {
	              var items = item.getSubmenuItems();
	              if (isString(items)) {
	                return items;
	              } else {
	                return map(items, makeContextItem);
	              }
	            }
	          });
	        default:
	          return __assign(__assign({ type: 'menuitem' }, commonMenuItem(item)), { onAction: noarg(item.onAction) });
	        }
	      }
	    };
	    var addContextMenuGroup = function (xs, groupItems) {
	      if (groupItems.length === 0) {
	        return xs;
	      }
	      var lastMenuItem = last(xs).filter(function (item) {
	        return !isSeparator$1(item);
	      });
	      var before = lastMenuItem.fold(function () {
	        return [];
	      }, function (_) {
	        return [separator$3];
	      });
	      return xs.concat(before).concat(groupItems).concat([separator$3]);
	    };
	    var generateContextMenu = function (contextMenus, menuConfig, selectedElement) {
	      var sections = foldl(menuConfig, function (acc, name) {
	        return get$1(contextMenus, name.toLowerCase()).map(function (menu) {
	          var items = menu.update(selectedElement);
	          if (isString(items)) {
	            return addContextMenuGroup(acc, items.split(' '));
	          } else if (items.length > 0) {
	            var allItems = map(items, makeContextItem);
	            return addContextMenuGroup(acc, allItems);
	          } else {
	            return acc;
	          }
	        }).getOrThunk(function () {
	          return acc.concat([name]);
	        });
	      }, []);
	      if (sections.length > 0 && isSeparator$1(sections[sections.length - 1])) {
	        sections.pop();
	      }
	      return sections;
	    };
	    var isNativeOverrideKeyEvent = function (editor, e) {
	      return e.ctrlKey && !shouldNeverUseNative(editor);
	    };
	    var isTriggeredByKeyboard = function (editor, e) {
	      return e.type !== 'longpress' && (e.button !== 2 || e.target === editor.getBody() && e.pointerType === '');
	    };
	    var getSelectedElement = function (editor, e) {
	      return isTriggeredByKeyboard(editor, e) ? editor.selection.getStart(true) : e.target;
	    };
	    var shouldUseNodeAnchor = function (editor, e) {
	      var selector = getAvoidOverlapSelector(editor);
	      if (isTriggeredByKeyboard(editor, e)) {
	        return true;
	      } else if (selector) {
	        var target = getSelectedElement(editor, e);
	        return closest$4(SugarElement.fromDom(target), selector);
	      } else {
	        return false;
	      }
	    };
	    var setup$9 = function (editor, lazySink, backstage) {
	      var detection = detect$3();
	      var isTouch = detection.deviceType.isTouch;
	      var contextmenu = build$1(InlineView.sketch({
	        dom: { tag: 'div' },
	        lazySink: lazySink,
	        onEscape: function () {
	          return editor.focus();
	        },
	        onShow: function () {
	          return backstage.setContextMenuState(true);
	        },
	        onHide: function () {
	          return backstage.setContextMenuState(false);
	        },
	        fireDismissalEventInstead: {},
	        inlineBehaviours: derive$1([config('dismissContextMenu', [run(dismissRequested(), function (comp, _se) {
	              Sandboxing.close(comp);
	              editor.focus();
	            })])])
	      }));
	      var hideContextMenu = function (_e) {
	        return InlineView.hide(contextmenu);
	      };
	      var showContextMenu = function (e) {
	        if (shouldNeverUseNative(editor)) {
	          e.preventDefault();
	        }
	        if (isNativeOverrideKeyEvent(editor, e) || isContextMenuDisabled(editor)) {
	          return;
	        }
	        var useNodeAnchor = shouldUseNodeAnchor(editor, e);
	        var buildMenu = function () {
	          var selectedElement = getSelectedElement(editor, e);
	          var registry = editor.ui.registry.getAll();
	          var menuConfig = getContextMenu(editor);
	          return generateContextMenu(registry.contextMenus, menuConfig, selectedElement);
	        };
	        var initAndShow$2 = isTouch() ? initAndShow$1 : initAndShow;
	        initAndShow$2(editor, e, buildMenu, backstage, contextmenu, useNodeAnchor);
	      };
	      editor.on('init', function () {
	        var hideEvents = 'ResizeEditor ScrollContent ScrollWindow longpresscancel' + (isTouch() ? '' : ' ResizeWindow');
	        editor.on(hideEvents, hideContextMenu);
	        editor.on('longpress contextmenu', showContextMenu);
	      });
	    };
	
	    var adt$c = Adt.generate([
	      {
	        offset: [
	          'x',
	          'y'
	        ]
	      },
	      {
	        absolute: [
	          'x',
	          'y'
	        ]
	      },
	      {
	        fixed: [
	          'x',
	          'y'
	        ]
	      }
	    ]);
	    var subtract = function (change) {
	      return function (point) {
	        return point.translate(-change.left, -change.top);
	      };
	    };
	    var add$4 = function (change) {
	      return function (point) {
	        return point.translate(change.left, change.top);
	      };
	    };
	    var transform$1 = function (changes) {
	      return function (x, y) {
	        return foldl(changes, function (rest, f) {
	          return f(rest);
	        }, SugarPosition(x, y));
	      };
	    };
	    var asFixed = function (coord, scroll, origin) {
	      return coord.fold(transform$1([
	        add$4(origin),
	        subtract(scroll)
	      ]), transform$1([subtract(scroll)]), transform$1([]));
	    };
	    var asAbsolute = function (coord, scroll, origin) {
	      return coord.fold(transform$1([add$4(origin)]), transform$1([]), transform$1([add$4(scroll)]));
	    };
	    var asOffset = function (coord, scroll, origin) {
	      return coord.fold(transform$1([]), transform$1([subtract(origin)]), transform$1([
	        add$4(scroll),
	        subtract(origin)
	      ]));
	    };
	    var withinRange = function (coord1, coord2, xRange, yRange, scroll, origin) {
	      var a1 = asAbsolute(coord1, scroll, origin);
	      var a2 = asAbsolute(coord2, scroll, origin);
	      return Math.abs(a1.left - a2.left) <= xRange && Math.abs(a1.top - a2.top) <= yRange;
	    };
	    var getDeltas = function (coord1, coord2, xRange, yRange, scroll, origin) {
	      var a1 = asAbsolute(coord1, scroll, origin);
	      var a2 = asAbsolute(coord2, scroll, origin);
	      var left = Math.abs(a1.left - a2.left);
	      var top = Math.abs(a1.top - a2.top);
	      return SugarPosition(left, top);
	    };
	    var toStyles = function (coord, scroll, origin) {
	      var stylesOpt = coord.fold(function (x, y) {
	        return {
	          position: Optional.some('absolute'),
	          left: Optional.some(x + 'px'),
	          top: Optional.some(y + 'px')
	        };
	      }, function (x, y) {
	        return {
	          position: Optional.some('absolute'),
	          left: Optional.some(x - origin.left + 'px'),
	          top: Optional.some(y - origin.top + 'px')
	        };
	      }, function (x, y) {
	        return {
	          position: Optional.some('fixed'),
	          left: Optional.some(x + 'px'),
	          top: Optional.some(y + 'px')
	        };
	      });
	      return __assign({
	        right: Optional.none(),
	        bottom: Optional.none()
	      }, stylesOpt);
	    };
	    var translate$2 = function (coord, deltaX, deltaY) {
	      return coord.fold(function (x, y) {
	        return offset(x + deltaX, y + deltaY);
	      }, function (x, y) {
	        return absolute$3(x + deltaX, y + deltaY);
	      }, function (x, y) {
	        return fixed$1(x + deltaX, y + deltaY);
	      });
	    };
	    var absorb = function (partialCoord, originalCoord, scroll, origin) {
	      var absorbOne = function (stencil, nu) {
	        return function (optX, optY) {
	          var original = stencil(originalCoord, scroll, origin);
	          return nu(optX.getOr(original.left), optY.getOr(original.top));
	        };
	      };
	      return partialCoord.fold(absorbOne(asOffset, offset), absorbOne(asAbsolute, absolute$3), absorbOne(asFixed, fixed$1));
	    };
	    var offset = adt$c.offset;
	    var absolute$3 = adt$c.absolute;
	    var fixed$1 = adt$c.fixed;
	
	    var parseAttrToInt = function (element, name) {
	      var value = get$3(element, name);
	      return isUndefined(value) ? NaN : parseInt(value, 10);
	    };
	    var get$f = function (component, snapsInfo) {
	      var element = component.element;
	      var x = parseAttrToInt(element, snapsInfo.leftAttr);
	      var y = parseAttrToInt(element, snapsInfo.topAttr);
	      return isNaN(x) || isNaN(y) ? Optional.none() : Optional.some(SugarPosition(x, y));
	    };
	    var set$8 = function (component, snapsInfo, pt) {
	      var element = component.element;
	      set$1(element, snapsInfo.leftAttr, pt.left + 'px');
	      set$1(element, snapsInfo.topAttr, pt.top + 'px');
	    };
	    var clear = function (component, snapsInfo) {
	      var element = component.element;
	      remove$1(element, snapsInfo.leftAttr);
	      remove$1(element, snapsInfo.topAttr);
	    };
	
	    var getCoords = function (component, snapInfo, coord, delta) {
	      return get$f(component, snapInfo).fold(function () {
	        return coord;
	      }, function (fixed) {
	        return fixed$1(fixed.left + delta.left, fixed.top + delta.top);
	      });
	    };
	    var moveOrSnap = function (component, snapInfo, coord, delta, scroll, origin) {
	      var newCoord = getCoords(component, snapInfo, coord, delta);
	      var snap = snapInfo.mustSnap ? findClosestSnap(component, snapInfo, newCoord, scroll, origin) : findSnap(component, snapInfo, newCoord, scroll, origin);
	      var fixedCoord = asFixed(newCoord, scroll, origin);
	      set$8(component, snapInfo, fixedCoord);
	      return snap.fold(function () {
	        return {
	          coord: fixed$1(fixedCoord.left, fixedCoord.top),
	          extra: Optional.none()
	        };
	      }, function (spanned) {
	        return {
	          coord: spanned.output,
	          extra: spanned.extra
	        };
	      });
	    };
	    var stopDrag = function (component, snapInfo) {
	      clear(component, snapInfo);
	    };
	    var findMatchingSnap = function (snaps, newCoord, scroll, origin) {
	      return findMap(snaps, function (snap) {
	        var sensor = snap.sensor;
	        var inRange = withinRange(newCoord, sensor, snap.range.left, snap.range.top, scroll, origin);
	        return inRange ? Optional.some({
	          output: absorb(snap.output, newCoord, scroll, origin),
	          extra: snap.extra
	        }) : Optional.none();
	      });
	    };
	    var findClosestSnap = function (component, snapInfo, newCoord, scroll, origin) {
	      var snaps = snapInfo.getSnapPoints(component);
	      var matchSnap = findMatchingSnap(snaps, newCoord, scroll, origin);
	      return matchSnap.orThunk(function () {
	        var bestSnap = foldl(snaps, function (acc, snap) {
	          var sensor = snap.sensor;
	          var deltas = getDeltas(newCoord, sensor, snap.range.left, snap.range.top, scroll, origin);
	          return acc.deltas.fold(function () {
	            return {
	              deltas: Optional.some(deltas),
	              snap: Optional.some(snap)
	            };
	          }, function (bestDeltas) {
	            var currAvg = (deltas.left + deltas.top) / 2;
	            var bestAvg = (bestDeltas.left + bestDeltas.top) / 2;
	            if (currAvg <= bestAvg) {
	              return {
	                deltas: Optional.some(deltas),
	                snap: Optional.some(snap)
	              };
	            } else {
	              return acc;
	            }
	          });
	        }, {
	          deltas: Optional.none(),
	          snap: Optional.none()
	        });
	        return bestSnap.snap.map(function (snap) {
	          return {
	            output: absorb(snap.output, newCoord, scroll, origin),
	            extra: snap.extra
	          };
	        });
	      });
	    };
	    var findSnap = function (component, snapInfo, newCoord, scroll, origin) {
	      var snaps = snapInfo.getSnapPoints(component);
	      return findMatchingSnap(snaps, newCoord, scroll, origin);
	    };
	    var snapTo = function (snap, scroll, origin) {
	      return {
	        coord: absorb(snap.output, snap.output, scroll, origin),
	        extra: snap.extra
	      };
	    };
	
	    var snapTo$1 = function (component, dragConfig, _state, snap) {
	      var target = dragConfig.getTarget(component.element);
	      if (dragConfig.repositionTarget) {
	        var doc = owner(component.element);
	        var scroll_1 = get$9(doc);
	        var origin_1 = getOrigin(target);
	        var snapPin = snapTo(snap, scroll_1, origin_1);
	        var styles = toStyles(snapPin.coord, scroll_1, origin_1);
	        setOptions(target, styles);
	      }
	    };
	
	    var DraggingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        snapTo: snapTo$1
	    });
	
	    var initialAttribute = 'data-initial-z-index';
	    var resetZIndex = function (blocker) {
	      parent(blocker.element).filter(isElement).each(function (root) {
	        getOpt(root, initialAttribute).fold(function () {
	          return remove$6(root, 'z-index');
	        }, function (zIndex) {
	          return set$2(root, 'z-index', zIndex);
	        });
	        remove$1(root, initialAttribute);
	      });
	    };
	    var changeZIndex = function (blocker) {
	      parent(blocker.element).filter(isElement).each(function (root) {
	        getRaw(root, 'z-index').each(function (zindex) {
	          set$1(root, initialAttribute, zindex);
	        });
	        set$2(root, 'z-index', get$5(blocker.element, 'z-index'));
	      });
	    };
	    var instigate = function (anyComponent, blocker) {
	      anyComponent.getSystem().addToGui(blocker);
	      changeZIndex(blocker);
	    };
	    var discard = function (blocker) {
	      resetZIndex(blocker);
	      blocker.getSystem().removeFromGui(blocker);
	    };
	    var createComponent = function (component, blockerClass, blockerEvents) {
	      return component.getSystem().build(Container.sketch({
	        dom: {
	          styles: {
	            'left': '0px',
	            'top': '0px',
	            'width': '100%',
	            'height': '100%',
	            'position': 'fixed',
	            'z-index': '1000000000000000'
	          },
	          classes: [blockerClass]
	        },
	        events: blockerEvents
	      }));
	    };
	
	    var SnapSchema = optionObjOf('snaps', [
	      strict$1('getSnapPoints'),
	      onHandler('onSensor'),
	      strict$1('leftAttr'),
	      strict$1('topAttr'),
	      defaulted$1('lazyViewport', win),
	      defaulted$1('mustSnap', false)
	    ]);
	
	    var schema$t = [
	      defaulted$1('useFixed', never),
	      strict$1('blockerClass'),
	      defaulted$1('getTarget', identity),
	      defaulted$1('onDrag', noop),
	      defaulted$1('repositionTarget', true),
	      defaulted$1('onDrop', noop),
	      defaultedFunction('getBounds', win),
	      SnapSchema
	    ];
	
	    var getCurrentCoord = function (target) {
	      return lift3(getRaw(target, 'left'), getRaw(target, 'top'), getRaw(target, 'position'), function (left, top, position) {
	        var nu = position === 'fixed' ? fixed$1 : offset;
	        return nu(parseInt(left, 10), parseInt(top, 10));
	      }).getOrThunk(function () {
	        var location = absolute(target);
	        return absolute$3(location.left, location.top);
	      });
	    };
	    var clampCoords = function (component, coords, scroll, origin, startData) {
	      var bounds = startData.bounds;
	      var absoluteCoord = asAbsolute(coords, scroll, origin);
	      var newX = clamp(absoluteCoord.left, bounds.x, bounds.x + bounds.width - startData.width);
	      var newY = clamp(absoluteCoord.top, bounds.y, bounds.y + bounds.height - startData.height);
	      var newCoords = absolute$3(newX, newY);
	      return coords.fold(function () {
	        var offset$1 = asOffset(newCoords, scroll, origin);
	        return offset(offset$1.left, offset$1.top);
	      }, function () {
	        return newCoords;
	      }, function () {
	        var fixed = asFixed(newCoords, scroll, origin);
	        return fixed$1(fixed.left, fixed.top);
	      });
	    };
	    var calcNewCoord = function (component, optSnaps, currentCoord, scroll, origin, delta, startData) {
	      var newCoord = optSnaps.fold(function () {
	        var translated = translate$2(currentCoord, delta.left, delta.top);
	        var fixedCoord = asFixed(translated, scroll, origin);
	        return fixed$1(fixedCoord.left, fixedCoord.top);
	      }, function (snapInfo) {
	        var snapping = moveOrSnap(component, snapInfo, currentCoord, delta, scroll, origin);
	        snapping.extra.each(function (extra) {
	          snapInfo.onSensor(component, extra);
	        });
	        return snapping.coord;
	      });
	      return clampCoords(component, newCoord, scroll, origin, startData);
	    };
	    var dragBy = function (component, dragConfig, startData, delta) {
	      var target = dragConfig.getTarget(component.element);
	      if (dragConfig.repositionTarget) {
	        var doc = owner(component.element);
	        var scroll_1 = get$9(doc);
	        var origin_1 = getOrigin(target);
	        var currentCoord = getCurrentCoord(target);
	        var newCoord = calcNewCoord(component, dragConfig.snaps, currentCoord, scroll_1, origin_1, delta, startData);
	        var styles = toStyles(newCoord, scroll_1, origin_1);
	        setOptions(target, styles);
	      }
	      dragConfig.onDrag(component, target, delta);
	    };
	
	    var calcStartData = function (dragConfig, comp) {
	      return {
	        bounds: dragConfig.getBounds(),
	        height: getOuter$1(comp.element),
	        width: getOuter$2(comp.element)
	      };
	    };
	    var move$1 = function (component, dragConfig, dragState, dragMode, event) {
	      var delta = dragState.update(dragMode, event);
	      var dragStartData = dragState.getStartData().getOrThunk(function () {
	        return calcStartData(dragConfig, component);
	      });
	      delta.each(function (dlt) {
	        dragBy(component, dragConfig, dragStartData, dlt);
	      });
	    };
	    var stop = function (component, blocker, dragConfig, dragState) {
	      blocker.each(discard);
	      dragConfig.snaps.each(function (snapInfo) {
	        stopDrag(component, snapInfo);
	      });
	      var target = dragConfig.getTarget(component.element);
	      dragState.reset();
	      dragConfig.onDrop(component, target);
	    };
	    var handlers = function (events) {
	      return function (dragConfig, dragState) {
	        var updateStartState = function (comp) {
	          dragState.setStartData(calcStartData(dragConfig, comp));
	        };
	        return derive(__spreadArrays([run(windowScroll(), function (comp) {
	            dragState.getStartData().each(function () {
	              return updateStartState(comp);
	            });
	          })], events(dragConfig, dragState, updateStartState)));
	      };
	    };
	
	    var init$c = function (dragApi) {
	      return derive([
	        run(mousedown(), dragApi.forceDrop),
	        run(mouseup(), dragApi.drop),
	        run(mousemove(), function (comp, simulatedEvent) {
	          dragApi.move(simulatedEvent.event);
	        }),
	        run(mouseout(), dragApi.delayDrop)
	      ]);
	    };
	
	    var getData$1 = function (event) {
	      return Optional.from(SugarPosition(event.x, event.y));
	    };
	    var getDelta$1 = function (old, nu) {
	      return SugarPosition(nu.left - old.left, nu.top - old.top);
	    };
	
	    var MouseData = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getData: getData$1,
	        getDelta: getDelta$1
	    });
	
	    var events$g = function (dragConfig, dragState, updateStartState) {
	      return [run(mousedown(), function (component, simulatedEvent) {
	          var raw = simulatedEvent.event.raw;
	          if (raw.button !== 0) {
	            return;
	          }
	          simulatedEvent.stop();
	          var stop$1 = function () {
	            return stop(component, Optional.some(blocker), dragConfig, dragState);
	          };
	          var delayDrop = DelayedFunction(stop$1, 200);
	          var dragApi = {
	            drop: stop$1,
	            delayDrop: delayDrop.schedule,
	            forceDrop: stop$1,
	            move: function (event) {
	              delayDrop.cancel();
	              move$1(component, dragConfig, dragState, MouseData, event);
	            }
	          };
	          var blocker = createComponent(component, dragConfig.blockerClass, init$c(dragApi));
	          var start = function () {
	            updateStartState(component);
	            instigate(component, blocker);
	          };
	          start();
	        })];
	    };
	    var schema$u = __spreadArrays(schema$t, [output('dragger', { handlers: handlers(events$g) })]);
	
	    var init$d = function (dragApi) {
	      return derive([
	        run(touchstart(), dragApi.forceDrop),
	        run(touchend(), dragApi.drop),
	        run(touchcancel(), dragApi.drop),
	        run(touchmove(), function (comp, simulatedEvent) {
	          dragApi.move(simulatedEvent.event);
	        })
	      ]);
	    };
	
	    var getDataFrom = function (touches) {
	      var touch = touches[0];
	      return Optional.some(SugarPosition(touch.clientX, touch.clientY));
	    };
	    var getData$2 = function (event) {
	      var raw = event.raw;
	      var touches = raw.touches;
	      return touches.length === 1 ? getDataFrom(touches) : Optional.none();
	    };
	    var getDelta$2 = function (old, nu) {
	      return SugarPosition(nu.left - old.left, nu.top - old.top);
	    };
	
	    var TouchData = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        getData: getData$2,
	        getDelta: getDelta$2
	    });
	
	    var events$h = function (dragConfig, dragState, updateStartState) {
	      var blockerCell = Cell(Optional.none());
	      return [
	        run(touchstart(), function (component, simulatedEvent) {
	          simulatedEvent.stop();
	          var stop$1 = function () {
	            stop(component, blockerCell.get(), dragConfig, dragState);
	            blockerCell.set(Optional.none());
	          };
	          var dragApi = {
	            drop: stop$1,
	            delayDrop: noop,
	            forceDrop: stop$1,
	            move: function (event) {
	              move$1(component, dragConfig, dragState, TouchData, event);
	            }
	          };
	          var blocker = createComponent(component, dragConfig.blockerClass, init$d(dragApi));
	          blockerCell.set(Optional.some(blocker));
	          var start = function () {
	            updateStartState(component);
	            instigate(component, blocker);
	          };
	          start();
	        }),
	        run(touchmove(), function (component, simulatedEvent) {
	          simulatedEvent.stop();
	          move$1(component, dragConfig, dragState, TouchData, simulatedEvent.event);
	        }),
	        run(touchend(), function (component, simulatedEvent) {
	          simulatedEvent.stop();
	          stop(component, blockerCell.get(), dragConfig, dragState);
	          blockerCell.set(Optional.none());
	        }),
	        run(touchcancel(), function (component) {
	          stop(component, blockerCell.get(), dragConfig, dragState);
	          blockerCell.set(Optional.none());
	        })
	      ];
	    };
	    var schema$v = __spreadArrays(schema$t, [output('dragger', { handlers: handlers(events$h) })]);
	
	    var events$i = function (dragConfig, dragState, updateStartState) {
	      return __spreadArrays(events$g(dragConfig, dragState, updateStartState), events$h(dragConfig, dragState, updateStartState));
	    };
	    var schema$w = __spreadArrays(schema$t, [output('dragger', { handlers: handlers(events$i) })]);
	
	    var mouse = schema$u;
	    var touch = schema$v;
	    var mouseOrTouch = schema$w;
	
	    var DraggingBranches = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        mouse: mouse,
	        touch: touch,
	        mouseOrTouch: mouseOrTouch
	    });
	
	    var init$e = function () {
	      var previous = Optional.none();
	      var startData = Optional.none();
	      var reset = function () {
	        previous = Optional.none();
	        startData = Optional.none();
	      };
	      var calculateDelta = function (mode, nu) {
	        var result = previous.map(function (old) {
	          return mode.getDelta(old, nu);
	        });
	        previous = Optional.some(nu);
	        return result;
	      };
	      var update = function (mode, dragEvent) {
	        return mode.getData(dragEvent).bind(function (nuData) {
	          return calculateDelta(mode, nuData);
	        });
	      };
	      var setStartData = function (data) {
	        startData = Optional.some(data);
	      };
	      var getStartData = function () {
	        return startData;
	      };
	      var readState = constant({});
	      return nu$5({
	        readState: readState,
	        reset: reset,
	        update: update,
	        getStartData: getStartData,
	        setStartData: setStartData
	      });
	    };
	
	    var DragState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$e
	    });
	
	    var Dragging = createModes$1({
	      branchKey: 'mode',
	      branches: DraggingBranches,
	      name: 'dragging',
	      active: {
	        events: function (dragConfig, dragState) {
	          var dragger = dragConfig.dragger;
	          return dragger.handlers(dragConfig, dragState);
	        }
	      },
	      extra: {
	        snap: function (sConfig) {
	          return {
	            sensor: sConfig.sensor,
	            range: sConfig.range,
	            output: sConfig.output,
	            extra: Optional.from(sConfig.extra)
	          };
	        }
	      },
	      state: DragState,
	      apis: DraggingApis
	    });
	
	    var snapWidth = 40;
	    var snapOffset = snapWidth / 2;
	    var calcSnap = function (selectorOpt, td, x, y, width, height) {
	      return selectorOpt.fold(function () {
	        return Dragging.snap({
	          sensor: absolute$3(x - snapOffset, y - snapOffset),
	          range: SugarPosition(width, height),
	          output: absolute$3(Optional.some(x), Optional.some(y)),
	          extra: { td: td }
	        });
	      }, function (selectorHandle) {
	        var sensorLeft = x - snapOffset;
	        var sensorTop = y - snapOffset;
	        var sensorWidth = snapWidth;
	        var sensorHeight = snapWidth;
	        var rect = selectorHandle.element.dom.getBoundingClientRect();
	        return Dragging.snap({
	          sensor: absolute$3(sensorLeft, sensorTop),
	          range: SugarPosition(sensorWidth, sensorHeight),
	          output: absolute$3(Optional.some(x - rect.width / 2), Optional.some(y - rect.height / 2)),
	          extra: { td: td }
	        });
	      });
	    };
	    var getSnapsConfig = function (getSnapPoints, cell, onChange) {
	      var isSameCell = function (cellOpt, td) {
	        return cellOpt.exists(function (currentTd) {
	          return eq$1(currentTd, td);
	        });
	      };
	      return {
	        getSnapPoints: getSnapPoints,
	        leftAttr: 'data-drag-left',
	        topAttr: 'data-drag-top',
	        onSensor: function (component, extra) {
	          var td = extra.td;
	          if (!isSameCell(cell.get(), td)) {
	            cell.set(Optional.some(td));
	            onChange(td);
	          }
	        },
	        mustSnap: true
	      };
	    };
	    var createSelector = function (snaps) {
	      return record(Button.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-selector']
	        },
	        buttonBehaviours: derive$1([
	          Dragging.config({
	            mode: 'mouseOrTouch',
	            blockerClass: 'blocker',
	            snaps: snaps
	          }),
	          Unselecting.config({})
	        ]),
	        eventOrder: {
	          mousedown: [
	            'dragging',
	            'alloy.base.behaviour'
	          ],
	          touchstart: [
	            'dragging',
	            'alloy.base.behaviour'
	          ]
	        }
	      }));
	    };
	    var setup$a = function (editor, sink) {
	      var tlTds = Cell([]);
	      var brTds = Cell([]);
	      var isVisible = Cell(false);
	      var startCell = Cell(Optional.none());
	      var finishCell = Cell(Optional.none());
	      var getTopLeftSnap = function (td) {
	        var box = absolute$1(td);
	        return calcSnap(memTopLeft.getOpt(sink), td, box.x, box.y, box.width, box.height);
	      };
	      var getTopLeftSnaps = function () {
	        return map(tlTds.get(), function (td) {
	          return getTopLeftSnap(td);
	        });
	      };
	      var getBottomRightSnap = function (td) {
	        var box = absolute$1(td);
	        return calcSnap(memBottomRight.getOpt(sink), td, box.right, box.bottom, box.width, box.height);
	      };
	      var getBottomRightSnaps = function () {
	        return map(brTds.get(), function (td) {
	          return getBottomRightSnap(td);
	        });
	      };
	      var topLeftSnaps = getSnapsConfig(getTopLeftSnaps, startCell, function (start) {
	        finishCell.get().each(function (finish) {
	          editor.fire('TableSelectorChange', {
	            start: start,
	            finish: finish
	          });
	        });
	      });
	      var bottomRightSnaps = getSnapsConfig(getBottomRightSnaps, finishCell, function (finish) {
	        startCell.get().each(function (start) {
	          editor.fire('TableSelectorChange', {
	            start: start,
	            finish: finish
	          });
	        });
	      });
	      var memTopLeft = createSelector(topLeftSnaps);
	      var memBottomRight = createSelector(bottomRightSnaps);
	      var topLeft = build$1(memTopLeft.asSpec());
	      var bottomRight = build$1(memBottomRight.asSpec());
	      var showOrHideHandle = function (selector, cell, isAbove, isBelow) {
	        var cellRect = cell.dom.getBoundingClientRect();
	        remove$6(selector.element, 'display');
	        var viewportHeight = defaultView(SugarElement.fromDom(editor.getBody())).dom.innerHeight;
	        var aboveViewport = isAbove(cellRect);
	        var belowViewport = isBelow(cellRect, viewportHeight);
	        if (aboveViewport || belowViewport) {
	          set$2(selector.element, 'display', 'none');
	        }
	      };
	      var snapTo = function (selector, cell, getSnapConfig, pos) {
	        var snap = getSnapConfig(cell);
	        Dragging.snapTo(selector, snap);
	        var isAbove = function (rect) {
	          return rect[pos] < 0;
	        };
	        var isBelow = function (rect, viewportHeight) {
	          return rect[pos] > viewportHeight;
	        };
	        showOrHideHandle(selector, cell, isAbove, isBelow);
	      };
	      var snapTopLeft = function (cell) {
	        return snapTo(topLeft, cell, getTopLeftSnap, 'top');
	      };
	      var snapLastTopLeft = function () {
	        return startCell.get().each(snapTopLeft);
	      };
	      var snapBottomRight = function (cell) {
	        return snapTo(bottomRight, cell, getBottomRightSnap, 'bottom');
	      };
	      var snapLastBottomRight = function () {
	        return finishCell.get().each(snapBottomRight);
	      };
	      if (detect$3().deviceType.isTouch()) {
	        editor.on('TableSelectionChange', function (e) {
	          if (!isVisible.get()) {
	            attach$1(sink, topLeft);
	            attach$1(sink, bottomRight);
	            isVisible.set(true);
	          }
	          startCell.set(Optional.some(e.start));
	          finishCell.set(Optional.some(e.finish));
	          e.otherCells.each(function (otherCells) {
	            tlTds.set(otherCells.upOrLeftCells);
	            brTds.set(otherCells.downOrRightCells);
	            snapTopLeft(e.start);
	            snapBottomRight(e.finish);
	          });
	        });
	        editor.on('ResizeEditor ResizeWindow ScrollContent', function () {
	          snapLastTopLeft();
	          snapLastBottomRight();
	        });
	        editor.on('TableSelectionClear', function () {
	          if (isVisible.get()) {
	            detach(topLeft);
	            detach(bottomRight);
	            isVisible.set(false);
	          }
	          startCell.set(Optional.none());
	          finishCell.set(Optional.none());
	        });
	      }
	    };
	
	    var isHidden$1 = function (elm) {
	      if (elm.nodeType === 1) {
	        if (elm.nodeName === 'BR' || !!elm.getAttribute('data-mce-bogus')) {
	          return true;
	        }
	        if (elm.getAttribute('data-mce-type') === 'bookmark') {
	          return true;
	        }
	      }
	      return false;
	    };
	    var renderElementPath = function (editor, settings, providersBackstage) {
	      if (!settings.delimiter) {
	        settings.delimiter = '\xBB';
	      }
	      var getDataPath = function (data) {
	        var parts = data || [];
	        var newPathElements = map(parts, function (part, index) {
	          return Button.sketch({
	            dom: {
	              tag: 'div',
	              classes: ['tox-statusbar__path-item'],
	              attributes: {
	                'role': 'button',
	                'data-index': index,
	                'tab-index': -1,
	                'aria-level': index + 1
	              },
	              innerHtml: part.name
	            },
	            action: function (_btn) {
	              editor.focus();
	              editor.selection.select(part.element);
	              editor.nodeChanged();
	            },
	            buttonBehaviours: derive$1([
	              DisablingConfigs.button(providersBackstage.isDisabled),
	              receivingConfig()
	            ])
	          });
	        });
	        var divider = {
	          dom: {
	            tag: 'div',
	            classes: ['tox-statusbar__path-divider'],
	            attributes: { 'aria-hidden': true },
	            innerHtml: ' ' + settings.delimiter + ' '
	          }
	        };
	        return foldl(newPathElements.slice(1), function (acc, element) {
	          var newAcc = acc;
	          newAcc.push(divider);
	          newAcc.push(element);
	          return newAcc;
	        }, [newPathElements[0]]);
	      };
	      var updatePath = function (parents) {
	        var newPath = [];
	        var i = parents.length;
	        while (i-- > 0) {
	          var parent_1 = parents[i];
	          if (parent_1.nodeType === 1 && !isHidden$1(parent_1)) {
	            var args = editor.fire('ResolveName', {
	              name: parent_1.nodeName.toLowerCase(),
	              target: parent_1
	            });
	            if (!args.isDefaultPrevented()) {
	              newPath.push({
	                name: args.name,
	                element: parent_1
	              });
	            }
	            if (args.isPropagationStopped()) {
	              break;
	            }
	          }
	        }
	        return newPath;
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-statusbar__path'],
	          attributes: { role: 'navigation' }
	        },
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'flow',
	            selector: 'div[role=button]'
	          }),
	          Disabling.config({ disabled: providersBackstage.isDisabled }),
	          receivingConfig(),
	          Tabstopping.config({}),
	          Replacing.config({}),
	          config('elementPathEvents', [runOnAttached(function (comp, _e) {
	              editor.shortcuts.add('alt+F11', 'focus statusbar elementpath', function () {
	                return Keying.focusIn(comp);
	              });
	              editor.on('NodeChange', function (e) {
	                var newPath = updatePath(e.parents);
	                if (newPath.length > 0) {
	                  Replacing.set(comp, getDataPath(newPath));
	                } else {
	                  Replacing.set(comp, []);
	                }
	              });
	            })])
	        ]),
	        components: []
	      };
	    };
	
	    var ResizeTypes;
	    (function (ResizeTypes) {
	      ResizeTypes[ResizeTypes['None'] = 0] = 'None';
	      ResizeTypes[ResizeTypes['Both'] = 1] = 'Both';
	      ResizeTypes[ResizeTypes['Vertical'] = 2] = 'Vertical';
	    }(ResizeTypes || (ResizeTypes = {})));
	    var getDimensions = function (editor, deltas, resizeType, originalHeight, originalWidth) {
	      var dimensions = {};
	      dimensions.height = calcCappedSize(originalHeight + deltas.top, getMinHeightSetting(editor), getMaxHeightSetting(editor));
	      if (resizeType === ResizeTypes.Both) {
	        dimensions.width = calcCappedSize(originalWidth + deltas.left, getMinWidthSetting(editor), getMaxWidthSetting(editor));
	      }
	      return dimensions;
	    };
	    var resize$3 = function (editor, deltas, resizeType) {
	      var container = SugarElement.fromDom(editor.getContainer());
	      var dimensions = getDimensions(editor, deltas, resizeType, get$7(container), get$8(container));
	      each$1(dimensions, function (val, dim) {
	        return set$2(container, dim, numToPx(val));
	      });
	      fireResizeEditor(editor);
	    };
	
	    var getResizeType = function (editor) {
	      var fallback = !editor.hasPlugin('autoresize');
	      var resize = editor.getParam('resize', fallback);
	      if (resize === false) {
	        return ResizeTypes.None;
	      } else if (resize === 'both') {
	        return ResizeTypes.Both;
	      } else {
	        return ResizeTypes.Vertical;
	      }
	    };
	    var keyboardHandler = function (editor, resizeType, x, y) {
	      var scale = 20;
	      var delta = SugarPosition(x * scale, y * scale);
	      resize$3(editor, delta, resizeType);
	      return Optional.some(true);
	    };
	    var renderResizeHandler = function (editor, providersBackstage) {
	      var resizeType = getResizeType(editor);
	      if (resizeType === ResizeTypes.None) {
	        return Optional.none();
	      }
	      return Optional.some({
	        dom: {
	          tag: 'div',
	          classes: ['tox-statusbar__resize-handle'],
	          attributes: { title: providersBackstage.translate('Resize') },
	          innerHtml: get$e('resize-handle', providersBackstage.icons)
	        },
	        behaviours: derive$1([
	          Dragging.config({
	            mode: 'mouse',
	            repositionTarget: false,
	            onDrag: function (_comp, _target, delta) {
	              return resize$3(editor, delta, resizeType);
	            },
	            blockerClass: 'tox-blocker'
	          }),
	          Keying.config({
	            mode: 'special',
	            onLeft: function () {
	              return keyboardHandler(editor, resizeType, -1, 0);
	            },
	            onRight: function () {
	              return keyboardHandler(editor, resizeType, 1, 0);
	            },
	            onUp: function () {
	              return keyboardHandler(editor, resizeType, 0, -1);
	            },
	            onDown: function () {
	              return keyboardHandler(editor, resizeType, 0, 1);
	            }
	          }),
	          Tabstopping.config({}),
	          Focusing.config({})
	        ])
	      });
	    };
	
	    var renderWordCount = function (editor, providersBackstage) {
	      var _a;
	      var replaceCountText = function (comp, count, mode) {
	        return Replacing.set(comp, [text(providersBackstage.translate([
	            '{0} ' + mode,
	            count[mode]
	          ]))]);
	      };
	      return Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: ['tox-statusbar__wordcount']
	        },
	        components: [],
	        buttonBehaviours: derive$1([
	          DisablingConfigs.button(providersBackstage.isDisabled),
	          receivingConfig(),
	          Tabstopping.config({}),
	          Replacing.config({}),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: {
	                mode: 'words',
	                count: {
	                  words: 0,
	                  characters: 0
	                }
	              }
	            }
	          }),
	          config('wordcount-events', [
	            runOnExecute(function (comp) {
	              var currentVal = Representing.getValue(comp);
	              var newMode = currentVal.mode === 'words' ? 'characters' : 'words';
	              Representing.setValue(comp, {
	                mode: newMode,
	                count: currentVal.count
	              });
	              replaceCountText(comp, currentVal.count, newMode);
	            }),
	            runOnAttached(function (comp) {
	              editor.on('wordCountUpdate', function (e) {
	                var mode = Representing.getValue(comp).mode;
	                Representing.setValue(comp, {
	                  mode: mode,
	                  count: e.wordCount
	                });
	                replaceCountText(comp, e.wordCount, mode);
	              });
	            })
	          ])
	        ]),
	        eventOrder: (_a = {}, _a[execute()] = [
	          'disabling',
	          'alloy.base.behaviour',
	          'wordcount-events'
	        ], _a)
	      });
	    };
	
	    var renderStatusbar = function (editor, providersBackstage) {
	      var renderBranding = function () {
	        var label = global$6.translate([
	          'Powered by {0}',
	          'Tiny'
	        ]);
	        var linkHtml = '<a href="https://www.tiny.cloud/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce&amp;utm_content=v5" rel="noopener" target="_blank" tabindex="-1" aria-label="' + label + '">' + label + '</a>';
	        return {
	          dom: {
	            tag: 'span',
	            classes: ['tox-statusbar__branding'],
	            innerHtml: linkHtml
	          }
	        };
	      };
	      var getTextComponents = function () {
	        var components = [];
	        if (editor.getParam('elementpath', true, 'boolean')) {
	          components.push(renderElementPath(editor, {}, providersBackstage));
	        }
	        if (editor.hasPlugin('wordcount')) {
	          components.push(renderWordCount(editor, providersBackstage));
	        }
	        if (editor.getParam('branding', true, 'boolean')) {
	          components.push(renderBranding());
	        }
	        if (components.length > 0) {
	          return [{
	              dom: {
	                tag: 'div',
	                classes: ['tox-statusbar__text-container']
	              },
	              components: components
	            }];
	        }
	        return [];
	      };
	      var getComponents = function () {
	        var components = getTextComponents();
	        var resizeHandler = renderResizeHandler(editor, providersBackstage);
	        return components.concat(resizeHandler.toArray());
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-statusbar']
	        },
	        components: getComponents()
	      };
	    };
	
	    var setup$b = function (editor) {
	      var _a;
	      var isInline = editor.inline;
	      var mode = isInline ? Inline : Iframe;
	      var header = isStickyToolbar(editor) ? StickyHeader : StaticHeader;
	      var lazyOuterContainer = Optional.none();
	      var platform = detect$3();
	      var isIE = platform.browser.isIE();
	      var platformClasses = isIE ? ['tox-platform-ie'] : [];
	      var isTouch = platform.deviceType.isTouch();
	      var touchPlatformClass = 'tox-platform-touch';
	      var deviceClasses = isTouch ? [touchPlatformClass] : [];
	      var isToolbarBottom = isToolbarLocationBottom(editor);
	      var uiContainer = getUiContainer(editor);
	      var dirAttributes = global$6.isRtl() ? { attributes: { dir: 'rtl' } } : {};
	      var verticalDirAttributes = { attributes: (_a = {}, _a[Attribute] = isToolbarBottom ? AttributeValue.BottomToTop : AttributeValue.TopToBottom, _a) };
	      var lazyHeader = function () {
	        return lazyOuterContainer.bind(OuterContainer.getHeader);
	      };
	      var isHeaderDocked = function () {
	        return header.isDocked(lazyHeader);
	      };
	      var resizeUiMothership = function () {
	        set$2(uiMothership.element, 'width', document.body.clientWidth + 'px');
	      };
	      var makeSinkDefinition = function () {
	        var isGridUiContainer = eq$1(body(), uiContainer) && get$5(uiContainer, 'display') === 'grid';
	        var sinkSpec = {
	          dom: __assign({
	            tag: 'div',
	            classes: [
	              'tox',
	              'tox-silver-sink',
	              'tox-tinymce-aux'
	            ].concat(platformClasses).concat(deviceClasses)
	          }, dirAttributes),
	          behaviours: derive$1([Positioning.config({
	              useFixed: function () {
	                return isHeaderDocked();
	              }
	            })])
	        };
	        var reactiveWidthSpec = {
	          dom: { styles: { width: document.body.clientWidth + 'px' } },
	          events: derive([run(windowResize(), resizeUiMothership)])
	        };
	        return deepMerge(sinkSpec, isGridUiContainer ? reactiveWidthSpec : {});
	      };
	      var sink = build$1(makeSinkDefinition());
	      var lazySink = function () {
	        return Result.value(sink);
	      };
	      var memAnchorBar = record({
	        dom: {
	          tag: 'div',
	          classes: ['tox-anchorbar']
	        }
	      });
	      var lazyAnchorBar = function () {
	        return lazyOuterContainer.bind(function (container) {
	          return memAnchorBar.getOpt(container);
	        }).getOrDie('Could not find a anchor bar element');
	      };
	      var lazyToolbar = function () {
	        return lazyOuterContainer.bind(function (container) {
	          return OuterContainer.getToolbar(container);
	        }).getOrDie('Could not find more toolbar element');
	      };
	      var lazyThrobber = function () {
	        return lazyOuterContainer.bind(function (container) {
	          return OuterContainer.getThrobber(container);
	        }).getOrDie('Could not find throbber element');
	      };
	      var backstage = init$8(sink, editor, lazyAnchorBar);
	      var partMenubar = OuterContainer.parts.menubar({
	        dom: {
	          tag: 'div',
	          classes: ['tox-menubar']
	        },
	        backstage: backstage,
	        onEscape: function () {
	          editor.focus();
	        }
	      });
	      var toolbarMode = getToolbarMode(editor);
	      var partToolbar = OuterContainer.parts.toolbar(__assign({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar']
	        },
	        getSink: lazySink,
	        providers: backstage.shared.providers,
	        onEscape: function () {
	          editor.focus();
	        },
	        type: toolbarMode,
	        lazyToolbar: lazyToolbar,
	        lazyHeader: function () {
	          return lazyHeader().getOrDie('Could not find header element');
	        }
	      }, verticalDirAttributes));
	      var partMultipleToolbar = OuterContainer.parts['multiple-toolbar']({
	        dom: {
	          tag: 'div',
	          classes: ['tox-toolbar-overlord']
	        },
	        providers: backstage.shared.providers,
	        onEscape: function () {
	          editor.focus();
	        },
	        type: toolbarMode
	      });
	      var partSocket = OuterContainer.parts.socket({
	        dom: {
	          tag: 'div',
	          classes: ['tox-edit-area']
	        }
	      });
	      var partSidebar = OuterContainer.parts.sidebar({
	        dom: {
	          tag: 'div',
	          classes: ['tox-sidebar']
	        }
	      });
	      var partThrobber = OuterContainer.parts.throbber({
	        dom: {
	          tag: 'div',
	          classes: ['tox-throbber']
	        },
	        backstage: backstage
	      });
	      var sb = editor.getParam('statusbar', true, 'boolean');
	      var statusbar = sb && !isInline ? Optional.some(renderStatusbar(editor, backstage.shared.providers)) : Optional.none();
	      var socketSidebarContainer = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-sidebar-wrap']
	        },
	        components: [
	          partSocket,
	          partSidebar
	        ]
	      };
	      var hasMultipleToolbar = isMultipleToolbars(editor);
	      var hasToolbar = isToolbarEnabled(editor);
	      var hasMenubar = isMenubarEnabled(editor);
	      var getPartToolbar = function () {
	        if (hasMultipleToolbar) {
	          return [partMultipleToolbar];
	        } else if (hasToolbar) {
	          return [partToolbar];
	        } else {
	          return [];
	        }
	      };
	      var partHeader = OuterContainer.parts.header({
	        dom: __assign({
	          tag: 'div',
	          classes: ['tox-editor-header']
	        }, verticalDirAttributes),
	        components: flatten([
	          hasMenubar ? [partMenubar] : [],
	          getPartToolbar(),
	          useFixedContainer(editor) ? [] : [memAnchorBar.asSpec()]
	        ]),
	        sticky: isStickyToolbar(editor),
	        editor: editor,
	        sharedBackstage: backstage.shared
	      });
	      var editorComponents = flatten([
	        isToolbarBottom ? [] : [partHeader],
	        isInline ? [] : [socketSidebarContainer],
	        isToolbarBottom ? [partHeader] : []
	      ]);
	      var editorContainer = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-editor-container']
	        },
	        components: editorComponents
	      };
	      var containerComponents = flatten([
	        [editorContainer],
	        isInline ? [] : statusbar.toArray(),
	        [partThrobber]
	      ]);
	      var isHidden = isDistractionFree(editor);
	      var attributes = __assign(__assign({ role: 'application' }, global$6.isRtl() ? { dir: 'rtl' } : {}), isHidden ? { 'aria-hidden': 'true' } : {});
	      var outerContainer = build$1(OuterContainer.sketch({
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox',
	            'tox-tinymce'
	          ].concat(isInline ? ['tox-tinymce-inline'] : []).concat(isToolbarBottom ? ['tox-tinymce--toolbar-bottom'] : []).concat(deviceClasses).concat(platformClasses),
	          styles: __assign({ visibility: 'hidden' }, isHidden ? {
	            opacity: '0',
	            border: '0'
	          } : {}),
	          attributes: attributes
	        },
	        components: containerComponents,
	        behaviours: derive$1([
	          receivingConfig(),
	          Disabling.config({ disableClass: 'tox-tinymce--disabled' }),
	          Keying.config({
	            mode: 'cyclic',
	            selector: '.tox-menubar, .tox-toolbar, .tox-toolbar__primary, .tox-toolbar__overflow--open, .tox-sidebar__overflow--open, .tox-statusbar__path, .tox-statusbar__wordcount, .tox-statusbar__branding a, .tox-statusbar__resize-handle'
	          })
	        ])
	      }));
	      lazyOuterContainer = Optional.some(outerContainer);
	      editor.shortcuts.add('alt+F9', 'focus menubar', function () {
	        OuterContainer.focusMenubar(outerContainer);
	      });
	      editor.shortcuts.add('alt+F10', 'focus toolbar', function () {
	        OuterContainer.focusToolbar(outerContainer);
	      });
	      editor.addCommand('ToggleToolbarDrawer', function () {
	        OuterContainer.toggleToolbarDrawer(outerContainer);
	      });
	      editor.addQueryStateHandler('ToggleToolbarDrawer', function () {
	        return OuterContainer.isToolbarDrawerToggled(outerContainer);
	      });
	      var mothership = takeover(outerContainer);
	      var uiMothership = takeover(sink);
	      setup$3(editor, mothership, uiMothership);
	      var getUi = function () {
	        var channels = {
	          broadcastAll: uiMothership.broadcast,
	          broadcastOn: uiMothership.broadcastOn,
	          register: noop
	        };
	        return { channels: channels };
	      };
	      var setEditorSize = function () {
	        var parsedHeight = numToPx(getHeightWithFallback(editor));
	        var parsedWidth = numToPx(getWidthWithFallback(editor));
	        if (!editor.inline) {
	          if (isValidValue('div', 'width', parsedWidth)) {
	            set$2(outerContainer.element, 'width', parsedWidth);
	          }
	          if (isValidValue('div', 'height', parsedHeight)) {
	            set$2(outerContainer.element, 'height', parsedHeight);
	          } else {
	            set$2(outerContainer.element, 'height', '200px');
	          }
	        }
	        return parsedHeight;
	      };
	      var renderUI = function () {
	        header.setup(editor, backstage.shared, lazyHeader);
	        setup$8(editor, backstage);
	        setup$9(editor, lazySink, backstage);
	        setup$6(editor);
	        setup$7(editor, lazyThrobber, backstage.shared);
	        map$2(getToolbarGroups(editor), function (toolbarGroupButtonConfig, name) {
	          editor.ui.registry.addGroupToolbarButton(name, toolbarGroupButtonConfig);
	        });
	        var _a = editor.ui.registry.getAll(), buttons = _a.buttons, menuItems = _a.menuItems, contextToolbars = _a.contextToolbars, sidebars = _a.sidebars;
	        var toolbarOpt = getMultipleToolbarsSetting(editor);
	        var rawUiConfig = {
	          menuItems: menuItems,
	          menus: getMenus(editor),
	          menubar: getMenubar(editor),
	          toolbar: toolbarOpt.getOrThunk(function () {
	            return getToolbar(editor);
	          }),
	          allowToolbarGroups: toolbarMode === ToolbarMode.floating,
	          buttons: buttons,
	          sidebar: sidebars
	        };
	        register$4(editor, contextToolbars, sink, { backstage: backstage });
	        setup$a(editor, sink);
	        var elm = editor.getElement();
	        var height = setEditorSize();
	        var uiComponents = {
	          mothership: mothership,
	          uiMothership: uiMothership,
	          outerContainer: outerContainer
	        };
	        var args = {
	          targetNode: elm,
	          height: height
	        };
	        return mode.render(editor, uiComponents, rawUiConfig, backstage, args);
	      };
	      return {
	        mothership: mothership,
	        uiMothership: uiMothership,
	        backstage: backstage,
	        renderUI: renderUI,
	        getUi: getUi
	      };
	    };
	
	    var describedBy = function (describedElement, describeElement) {
	      var describeId = Optional.from(get$3(describedElement, 'id')).fold(function () {
	        var id = generate$1('dialog-describe');
	        set$1(describeElement, 'id', id);
	        return id;
	      }, identity);
	      set$1(describedElement, 'aria-describedby', describeId);
	    };
	
	    var labelledBy = function (labelledElement, labelElement) {
	      var labelId = getOpt(labelledElement, 'id').fold(function () {
	        var id = generate$1('dialog-label');
	        set$1(labelElement, 'id', id);
	        return id;
	      }, identity);
	      set$1(labelledElement, 'aria-labelledby', labelId);
	    };
	
	    var schema$x = constant([
	      strict$1('lazySink'),
	      option('dragBlockClass'),
	      defaultedFunction('getBounds', win),
	      defaulted$1('useTabstopAt', always),
	      defaulted$1('eventOrder', {}),
	      field$1('modalBehaviours', [Keying]),
	      onKeyboardHandler('onExecute'),
	      onStrictKeyboardHandler('onEscape')
	    ]);
	    var basic = { sketch: identity };
	    var parts$f = constant([
	      optional({
	        name: 'draghandle',
	        overrides: function (detail, spec) {
	          return {
	            behaviours: derive$1([Dragging.config({
	                mode: 'mouse',
	                getTarget: function (handle) {
	                  return ancestor$2(handle, '[role="dialog"]').getOr(handle);
	                },
	                blockerClass: detail.dragBlockClass.getOrDie(new Error('The drag blocker class was not specified for a dialog with a drag handle: \n' + JSON.stringify(spec, null, 2)).message),
	                getBounds: detail.getDragBounds
	              })])
	          };
	        }
	      }),
	      required({
	        schema: [strict$1('dom')],
	        name: 'title'
	      }),
	      required({
	        factory: basic,
	        schema: [strict$1('dom')],
	        name: 'close'
	      }),
	      required({
	        factory: basic,
	        schema: [strict$1('dom')],
	        name: 'body'
	      }),
	      optional({
	        factory: basic,
	        schema: [strict$1('dom')],
	        name: 'footer'
	      }),
	      external$1({
	        factory: {
	          sketch: function (spec, detail) {
	            return __assign(__assign({}, spec), {
	              dom: detail.dom,
	              components: detail.components
	            });
	          }
	        },
	        schema: [
	          defaulted$1('dom', {
	            tag: 'div',
	            styles: {
	              position: 'fixed',
	              left: '0px',
	              top: '0px',
	              right: '0px',
	              bottom: '0px'
	            }
	          }),
	          defaulted$1('components', [])
	        ],
	        name: 'blocker'
	      })
	    ]);
	
	    var block = function (component, config, state, getBusySpec) {
	      set$1(component.element, 'aria-busy', true);
	      var root = config.getRoot(component).getOr(component);
	      var blockerBehaviours = derive$1([
	        Keying.config({
	          mode: 'special',
	          onTab: function () {
	            return Optional.some(true);
	          },
	          onShiftTab: function () {
	            return Optional.some(true);
	          }
	        }),
	        Focusing.config({})
	      ]);
	      var blockSpec = getBusySpec(root, blockerBehaviours);
	      var blocker = root.getSystem().build(blockSpec);
	      Replacing.append(root, premade$1(blocker));
	      if (blocker.hasConfigured(Keying)) {
	        Keying.focusIn(blocker);
	      }
	      if (!state.isBlocked()) {
	        config.onBlock(component);
	      }
	      state.blockWith(function () {
	        return Replacing.remove(root, blocker);
	      });
	    };
	    var unblock = function (component, config, state) {
	      remove$1(component.element, 'aria-busy');
	      if (state.isBlocked()) {
	        config.onUnblock(component);
	      }
	      state.clear();
	    };
	
	    var BlockingApis = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        block: block,
	        unblock: unblock
	    });
	
	    var BlockingSchema = [
	      defaultedFunction('getRoot', Optional.none),
	      onHandler('onBlock'),
	      onHandler('onUnblock')
	    ];
	
	    var init$f = function () {
	      var blocker = destroyable();
	      var blockWith = function (destroy) {
	        blocker.set({ destroy: destroy });
	      };
	      return nu$5({
	        readState: blocker.isSet,
	        blockWith: blockWith,
	        clear: blocker.clear,
	        isBlocked: blocker.isSet
	      });
	    };
	
	    var BlockingState = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        init: init$f
	    });
	
	    var Blocking = create$1({
	      fields: BlockingSchema,
	      name: 'blocking',
	      apis: BlockingApis,
	      state: BlockingState
	    });
	
	    var factory$i = function (detail, components, spec, externals) {
	      var _a;
	      var dialogComp = Cell(Optional.none());
	      var showDialog = function (dialog) {
	        dialogComp.set(Optional.some(dialog));
	        var sink = detail.lazySink(dialog).getOrDie();
	        var externalBlocker = externals.blocker();
	        var blocker = sink.getSystem().build(__assign(__assign({}, externalBlocker), {
	          components: externalBlocker.components.concat([premade$1(dialog)]),
	          behaviours: derive$1([
	            Focusing.config({}),
	            config('dialog-blocker-events', [runOnSource(focusin(), function () {
	                Keying.focusIn(dialog);
	              })])
	          ])
	        }));
	        attach$1(sink, blocker);
	        Keying.focusIn(dialog);
	      };
	      var hideDialog = function (dialog) {
	        dialogComp.set(Optional.none());
	        parent(dialog.element).each(function (blockerDom) {
	          dialog.getSystem().getByDom(blockerDom).each(function (blocker) {
	            detach(blocker);
	          });
	        });
	      };
	      var getDialogBody = function (dialog) {
	        return getPartOrDie(dialog, detail, 'body');
	      };
	      var getDialogFooter = function (dialog) {
	        return getPartOrDie(dialog, detail, 'footer');
	      };
	      var setBusy = function (dialog, getBusySpec) {
	        Blocking.block(dialog, getBusySpec);
	      };
	      var setIdle = function (dialog) {
	        Blocking.unblock(dialog);
	      };
	      var modalEventsId = generate$1('modal-events');
	      var eventOrder = __assign(__assign({}, detail.eventOrder), (_a = {}, _a[attachedToDom()] = [modalEventsId].concat(detail.eventOrder['alloy.system.attached'] || []), _a));
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        apis: {
	          show: showDialog,
	          hide: hideDialog,
	          getBody: getDialogBody,
	          getFooter: getDialogFooter,
	          setIdle: setIdle,
	          setBusy: setBusy
	        },
	        eventOrder: eventOrder,
	        domModification: {
	          attributes: {
	            'role': 'dialog',
	            'aria-modal': 'true'
	          }
	        },
	        behaviours: augment(detail.modalBehaviours, [
	          Replacing.config({}),
	          Keying.config({
	            mode: 'cyclic',
	            onEnter: detail.onExecute,
	            onEscape: detail.onEscape,
	            useTabstopAt: detail.useTabstopAt
	          }),
	          Blocking.config({ getRoot: dialogComp.get }),
	          config(modalEventsId, [runOnAttached(function (c) {
	              labelledBy(c.element, getPartOrDie(c, detail, 'title').element);
	              describedBy(c.element, getPartOrDie(c, detail, 'body').element);
	            })])
	        ])
	      };
	    };
	    var ModalDialog = composite$1({
	      name: 'ModalDialog',
	      configFields: schema$x(),
	      partFields: parts$f(),
	      factory: factory$i,
	      apis: {
	        show: function (apis, dialog) {
	          apis.show(dialog);
	        },
	        hide: function (apis, dialog) {
	          apis.hide(dialog);
	        },
	        getBody: function (apis, dialog) {
	          return apis.getBody(dialog);
	        },
	        getFooter: function (apis, dialog) {
	          return apis.getFooter(dialog);
	        },
	        setBusy: function (apis, dialog, getBusySpec) {
	          apis.setBusy(dialog, getBusySpec);
	        },
	        setIdle: function (apis, dialog) {
	          apis.setIdle(dialog);
	        }
	      }
	    });
	
	    var dialogToggleMenuItemSchema = objOf([
	      strictString('type'),
	      strictString('name')
	    ].concat(commonMenuItemFields));
	    var dialogToggleMenuItemDataProcessor = boolean;
	
	    var baseFooterButtonFields = [
	      field('name', 'name', defaultedThunk(function () {
	        return generate$1('button-name');
	      }), string),
	      optionString('icon'),
	      defaultedStringEnum('align', 'end', [
	        'start',
	        'end'
	      ]),
	      defaultedBoolean('primary', false),
	      defaultedBoolean('disabled', false)
	    ];
	    var dialogFooterButtonFields = __spreadArrays(baseFooterButtonFields, [strictString('text')]);
	    var normalFooterButtonFields = __spreadArrays([strictStringEnum('type', [
	        'submit',
	        'cancel',
	        'custom'
	      ])], dialogFooterButtonFields);
	    var menuFooterButtonFields = __spreadArrays([
	      strictStringEnum('type', ['menu']),
	      optionString('text'),
	      optionString('tooltip'),
	      optionString('icon'),
	      strictArrayOf('items', dialogToggleMenuItemSchema)
	    ], baseFooterButtonFields);
	    var dialogFooterButtonSchema = choose$1('type', {
	      submit: normalFooterButtonFields,
	      cancel: normalFooterButtonFields,
	      custom: normalFooterButtonFields,
	      menu: menuFooterButtonFields
	    });
	
	    var alertBannerFields = [
	      strictString('type'),
	      strictString('text'),
	      strictStringEnum('level', [
	        'info',
	        'warn',
	        'error',
	        'success'
	      ]),
	      strictString('icon'),
	      defaulted$1('url', '')
	    ];
	    var alertBannerSchema = objOf(alertBannerFields);
	
	    var createBarFields = function (itemsField) {
	      return [
	        strictString('type'),
	        itemsField
	      ];
	    };
	
	    var buttonFields = [
	      strictString('type'),
	      strictString('text'),
	      defaultedBoolean('disabled', false),
	      defaultedBoolean('primary', false),
	      field('name', 'name', defaultedThunk(function () {
	        return generate$1('button-name');
	      }), string),
	      optionString('icon'),
	      defaultedBoolean('borderless', false)
	    ];
	    var buttonSchema = objOf(buttonFields);
	
	    var checkboxFields = [
	      strictString('type'),
	      strictString('name'),
	      strictString('label'),
	      defaultedBoolean('disabled', false)
	    ];
	    var checkboxSchema = objOf(checkboxFields);
	    var checkboxDataProcessor = boolean;
	
	    var formComponentFields = [
	      strictString('type'),
	      strictString('name')
	    ];
	    var formComponentWithLabelFields = formComponentFields.concat([optionString('label')]);
	
	    var collectionFields = formComponentWithLabelFields.concat([defaulted$1('columns', 'auto')]);
	    var collectionSchema = objOf(collectionFields);
	    var collectionDataProcessor = arrOfObj$1([
	      strictString('value'),
	      strictString('text'),
	      strictString('icon')
	    ]);
	
	    var colorInputFields = formComponentWithLabelFields;
	    var colorInputSchema = objOf(colorInputFields);
	    var colorInputDataProcessor = string;
	
	    var colorPickerFields = formComponentWithLabelFields;
	    var colorPickerSchema = objOf(colorPickerFields);
	    var colorPickerDataProcessor = string;
	
	    var customEditorFields = formComponentFields.concat([
	      defaultedString('tag', 'textarea'),
	      strictString('scriptId'),
	      strictString('scriptUrl'),
	      defaultedPostMsg('settings', undefined)
	    ]);
	    var customEditorFieldsOld = formComponentFields.concat([
	      defaultedString('tag', 'textarea'),
	      strictFunction('init')
	    ]);
	    var customEditorSchema = valueOf(function (v) {
	      return asRaw('customeditor.old', objOfOnly(customEditorFieldsOld), v).orThunk(function () {
	        return asRaw('customeditor.new', objOfOnly(customEditorFields), v);
	      });
	    });
	    var customEditorDataProcessor = string;
	
	    var dropZoneFields = formComponentWithLabelFields;
	    var dropZoneSchema = objOf(dropZoneFields);
	    var dropZoneDataProcessor = arrOfVal();
	
	    var createGridFields = function (itemsField) {
	      return [
	        strictString('type'),
	        strictNumber('columns'),
	        itemsField
	      ];
	    };
	
	    var htmlPanelFields = [
	      strictString('type'),
	      strictString('html'),
	      defaultedStringEnum('presets', 'presentation', [
	        'presentation',
	        'document'
	      ])
	    ];
	    var htmlPanelSchema = objOf(htmlPanelFields);
	
	    var iframeFields = formComponentWithLabelFields.concat([defaultedBoolean('sandboxed', true)]);
	    var iframeSchema = objOf(iframeFields);
	    var iframeDataProcessor = string;
	
	    var imageToolsFields = formComponentWithLabelFields.concat([strictOf('currentState', objOf([
	        strict$1('blob'),
	        strictString('url')
	      ]))]);
	    var imageToolsSchema = objOf(imageToolsFields);
	
	    var inputFields = formComponentWithLabelFields.concat([
	      optionString('inputMode'),
	      optionString('placeholder'),
	      defaultedBoolean('maximized', false),
	      defaultedBoolean('disabled', false)
	    ]);
	    var inputSchema = objOf(inputFields);
	    var inputDataProcessor = string;
	
	    var createLabelFields = function (itemsField) {
	      return [
	        strictString('type'),
	        strictString('label'),
	        itemsField
	      ];
	    };
	
	    var listBoxSingleItemFields = [
	      strictString('text'),
	      strictString('value')
	    ];
	    var listBoxNestedItemFields = [
	      strictString('text'),
	      strictArrayOf('items', thunkOf('items', function () {
	        return listBoxItemSchema;
	      }))
	    ];
	    var listBoxItemSchema = oneOf([
	      objOf(listBoxSingleItemFields),
	      objOf(listBoxNestedItemFields)
	    ]);
	    var listBoxFields = formComponentWithLabelFields.concat([
	      strictArrayOf('items', listBoxItemSchema),
	      defaultedBoolean('disabled', false)
	    ]);
	    var listBoxSchema = objOf(listBoxFields);
	    var listBoxDataProcessor = string;
	
	    var selectBoxFields = formComponentWithLabelFields.concat([
	      strictArrayOfObj('items', [
	        strictString('text'),
	        strictString('value')
	      ]),
	      defaultedNumber('size', 1),
	      defaultedBoolean('disabled', false)
	    ]);
	    var selectBoxSchema = objOf(selectBoxFields);
	    var selectBoxDataProcessor = string;
	
	    var sizeInputFields = formComponentWithLabelFields.concat([
	      defaultedBoolean('constrain', true),
	      defaultedBoolean('disabled', false)
	    ]);
	    var sizeInputSchema = objOf(sizeInputFields);
	    var sizeInputDataProcessor = objOf([
	      strictString('width'),
	      strictString('height')
	    ]);
	
	    var tableFields = [
	      strictString('type'),
	      strictArrayOf('header', string),
	      strictArrayOf('cells', arrOf(string))
	    ];
	    var tableSchema = objOf(tableFields);
	
	    var textAreaFields = formComponentWithLabelFields.concat([
	      optionString('placeholder'),
	      defaultedBoolean('maximized', false),
	      defaultedBoolean('disabled', false)
	    ]);
	    var textAreaSchema = objOf(textAreaFields);
	    var textAreaDataProcessor = string;
	
	    var urlInputFields = formComponentWithLabelFields.concat([
	      defaultedStringEnum('filetype', 'file', [
	        'image',
	        'media',
	        'file'
	      ]),
	      defaulted$1('disabled', false)
	    ]);
	    var urlInputSchema = objOf(urlInputFields);
	    var urlInputDataProcessor = objOf([
	      strictString('value'),
	      defaulted$1('meta', {})
	    ]);
	
	    var createItemsField = function (name) {
	      return field('items', 'items', strict(), arrOf(valueOf(function (v) {
	        return asRaw('Checking item of ' + name, itemSchema$3, v).fold(function (sErr) {
	          return Result.error(formatError(sErr));
	        }, function (passValue) {
	          return Result.value(passValue);
	        });
	      })));
	    };
	    var itemSchema$3 = valueThunkOf(function () {
	      return chooseProcessor('type', {
	        alertbanner: alertBannerSchema,
	        bar: objOf(createBarFields(createItemsField('bar'))),
	        button: buttonSchema,
	        checkbox: checkboxSchema,
	        colorinput: colorInputSchema,
	        colorpicker: colorPickerSchema,
	        dropzone: dropZoneSchema,
	        grid: objOf(createGridFields(createItemsField('grid'))),
	        iframe: iframeSchema,
	        input: inputSchema,
	        listbox: listBoxSchema,
	        selectbox: selectBoxSchema,
	        sizeinput: sizeInputSchema,
	        textarea: textAreaSchema,
	        urlinput: urlInputSchema,
	        customeditor: customEditorSchema,
	        htmlpanel: htmlPanelSchema,
	        imagetools: imageToolsSchema,
	        collection: collectionSchema,
	        label: objOf(createLabelFields(createItemsField('label'))),
	        table: tableSchema,
	        panel: panelSchema
	      });
	    });
	    var panelFields = [
	      strictString('type'),
	      defaulted$1('classes', []),
	      strictArrayOf('items', itemSchema$3)
	    ];
	    var panelSchema = objOf(panelFields);
	
	    var tabFields = [
	      field('name', 'name', defaultedThunk(function () {
	        return generate$1('tab-name');
	      }), string),
	      strictString('title'),
	      strictArrayOf('items', itemSchema$3)
	    ];
	    var tabPanelFields = [
	      strictString('type'),
	      strictArrayOfObj('tabs', tabFields)
	    ];
	    var tabPanelSchema = objOf(tabPanelFields);
	
	    var dialogButtonFields = dialogFooterButtonFields;
	    var dialogButtonSchema = dialogFooterButtonSchema;
	    var dialogSchema = objOf([
	      strictString('title'),
	      strictOf('body', chooseProcessor('type', {
	        panel: panelSchema,
	        tabpanel: tabPanelSchema
	      })),
	      defaultedString('size', 'normal'),
	      strictArrayOf('buttons', dialogButtonSchema),
	      defaulted$1('initialData', {}),
	      defaultedFunction('onAction', noop),
	      defaultedFunction('onChange', noop),
	      defaultedFunction('onSubmit', noop),
	      defaultedFunction('onClose', noop),
	      defaultedFunction('onCancel', noop),
	      defaulted$1('onTabChange', noop)
	    ]);
	    var createDialog = function (spec) {
	      return asRaw('dialog', dialogSchema, spec);
	    };
	
	    var urlDialogButtonSchema = objOf(__spreadArrays([strictStringEnum('type', [
	        'cancel',
	        'custom'
	      ])], dialogButtonFields));
	    var urlDialogSchema = objOf([
	      strictString('title'),
	      strictString('url'),
	      optionNumber('height'),
	      optionNumber('width'),
	      optionArrayOf('buttons', urlDialogButtonSchema),
	      defaultedFunction('onAction', noop),
	      defaultedFunction('onCancel', noop),
	      defaultedFunction('onClose', noop),
	      defaultedFunction('onMessage', noop)
	    ]);
	    var createUrlDialog = function (spec) {
	      return asRaw('dialog', urlDialogSchema, spec);
	    };
	
	    var getAllObjects = function (obj) {
	      if (isObject(obj)) {
	        return [obj].concat(bind(values(obj), getAllObjects));
	      } else if (isArray(obj)) {
	        return bind(obj, getAllObjects);
	      } else {
	        return [];
	      }
	    };
	
	    var isNamedItem = function (obj) {
	      return isString(obj.type) && isString(obj.name);
	    };
	    var dataProcessors = {
	      checkbox: checkboxDataProcessor,
	      colorinput: colorInputDataProcessor,
	      colorpicker: colorPickerDataProcessor,
	      dropzone: dropZoneDataProcessor,
	      input: inputDataProcessor,
	      iframe: iframeDataProcessor,
	      sizeinput: sizeInputDataProcessor,
	      selectbox: selectBoxDataProcessor,
	      listbox: listBoxDataProcessor,
	      size: sizeInputDataProcessor,
	      textarea: textAreaDataProcessor,
	      urlinput: urlInputDataProcessor,
	      customeditor: customEditorDataProcessor,
	      collection: collectionDataProcessor,
	      togglemenuitem: dialogToggleMenuItemDataProcessor
	    };
	    var getDataProcessor = function (item) {
	      return Optional.from(dataProcessors[item.type]);
	    };
	    var getNamedItems = function (structure) {
	      return filter(getAllObjects(structure), isNamedItem);
	    };
	
	    var createDataValidator = function (structure) {
	      var namedItems = getNamedItems(structure);
	      var fields = bind(namedItems, function (item) {
	        return getDataProcessor(item).fold(function () {
	          return [];
	        }, function (schema) {
	          return [strictOf(item.name, schema)];
	        });
	      });
	      return objOf(fields);
	    };
	
	    var extract$1 = function (structure) {
	      var internalDialog = getOrDie(createDialog(structure));
	      var dataValidator = createDataValidator(structure);
	      var initialData = structure.initialData;
	      return {
	        internalDialog: internalDialog,
	        dataValidator: dataValidator,
	        initialData: initialData
	      };
	    };
	    var DialogManager = {
	      open: function (factory, structure) {
	        var extraction = extract$1(structure);
	        return factory(extraction.internalDialog, extraction.initialData, extraction.dataValidator);
	      },
	      openUrl: function (factory, structure) {
	        var internalDialog = getOrDie(createUrlDialog(structure));
	        return factory(internalDialog);
	      },
	      redial: function (structure) {
	        return extract$1(structure);
	      }
	    };
	
	    var toValidValues = function (values) {
	      var errors = [];
	      var result = {};
	      each$1(values, function (value, name) {
	        value.fold(function () {
	          errors.push(name);
	        }, function (v) {
	          result[name] = v;
	        });
	      });
	      return errors.length > 0 ? Result.error(errors) : Result.value(result);
	    };
	
	    var renderBodyPanel = function (spec, backstage) {
	      var memForm = record(Form.sketch(function (parts) {
	        return {
	          dom: {
	            tag: 'div',
	            classes: ['tox-form'].concat(spec.classes)
	          },
	          components: map(spec.items, function (item) {
	            return interpretInForm(parts, item, backstage);
	          })
	        };
	      }));
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__body']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-content']
	            },
	            components: [memForm.asSpec()]
	          }],
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'acyclic',
	            useTabstopAt: not(isPseudoStop)
	          }),
	          ComposingConfigs.memento(memForm),
	          RepresentingConfigs.memento(memForm, {
	            postprocess: function (formValue) {
	              return toValidValues(formValue).fold(function (err) {
	                console.error(err);
	                return {};
	              }, function (vals) {
	                return vals;
	              });
	            }
	          })
	        ])
	      };
	    };
	
	    var factory$j = function (detail, _spec) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: detail.components,
	        events: events$7(detail.action),
	        behaviours: augment(detail.tabButtonBehaviours, [
	          Focusing.config({}),
	          Keying.config({
	            mode: 'execution',
	            useSpace: true,
	            useEnter: true
	          }),
	          Representing.config({
	            store: {
	              mode: 'memory',
	              initialValue: detail.value
	            }
	          })
	        ]),
	        domModification: detail.domModification
	      };
	    };
	    var TabButton = single$2({
	      name: 'TabButton',
	      configFields: [
	        defaulted$1('uid', undefined),
	        strict$1('value'),
	        field('dom', 'dom', mergeWithThunk(function () {
	          return {
	            attributes: {
	              'role': 'tab',
	              'id': generate$1('aria'),
	              'aria-selected': 'false'
	            }
	          };
	        }), anyValue$1()),
	        option('action'),
	        defaulted$1('domModification', {}),
	        field$1('tabButtonBehaviours', [
	          Focusing,
	          Keying,
	          Representing
	        ]),
	        strict$1('view')
	      ],
	      factory: factory$j
	    });
	
	    var schema$y = constant([
	      strict$1('tabs'),
	      strict$1('dom'),
	      defaulted$1('clickToDismiss', false),
	      field$1('tabbarBehaviours', [
	        Highlighting,
	        Keying
	      ]),
	      markers([
	        'tabClass',
	        'selectedClass'
	      ])
	    ]);
	    var tabsPart = group({
	      factory: TabButton,
	      name: 'tabs',
	      unit: 'tab',
	      overrides: function (barDetail) {
	        var dismissTab$1 = function (tabbar, button) {
	          Highlighting.dehighlight(tabbar, button);
	          emitWith(tabbar, dismissTab(), {
	            tabbar: tabbar,
	            button: button
	          });
	        };
	        var changeTab$1 = function (tabbar, button) {
	          Highlighting.highlight(tabbar, button);
	          emitWith(tabbar, changeTab(), {
	            tabbar: tabbar,
	            button: button
	          });
	        };
	        return {
	          action: function (button) {
	            var tabbar = button.getSystem().getByUid(barDetail.uid).getOrDie();
	            var activeButton = Highlighting.isHighlighted(tabbar, button);
	            var response = function () {
	              if (activeButton && barDetail.clickToDismiss) {
	                return dismissTab$1;
	              } else if (!activeButton) {
	                return changeTab$1;
	              } else {
	                return noop;
	              }
	            }();
	            response(tabbar, button);
	          },
	          domModification: { classes: [barDetail.markers.tabClass] }
	        };
	      }
	    });
	    var parts$g = constant([tabsPart]);
	
	    var factory$k = function (detail, components, _spec, _externals) {
	      return {
	        'uid': detail.uid,
	        'dom': detail.dom,
	        components: components,
	        'debug.sketcher': 'Tabbar',
	        'domModification': { attributes: { role: 'tablist' } },
	        'behaviours': augment(detail.tabbarBehaviours, [
	          Highlighting.config({
	            highlightClass: detail.markers.selectedClass,
	            itemClass: detail.markers.tabClass,
	            onHighlight: function (tabbar, tab) {
	              set$1(tab.element, 'aria-selected', 'true');
	            },
	            onDehighlight: function (tabbar, tab) {
	              set$1(tab.element, 'aria-selected', 'false');
	            }
	          }),
	          Keying.config({
	            mode: 'flow',
	            getInitial: function (tabbar) {
	              return Highlighting.getHighlighted(tabbar).map(function (tab) {
	                return tab.element;
	              });
	            },
	            selector: '.' + detail.markers.tabClass,
	            executeOnMove: true
	          })
	        ])
	      };
	    };
	    var Tabbar = composite$1({
	      name: 'Tabbar',
	      configFields: schema$y(),
	      partFields: parts$g(),
	      factory: factory$k
	    });
	
	    var factory$l = function (detail, _spec) {
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        behaviours: augment(detail.tabviewBehaviours, [Replacing.config({})]),
	        domModification: { attributes: { role: 'tabpanel' } }
	      };
	    };
	    var Tabview = single$2({
	      name: 'Tabview',
	      configFields: [field$1('tabviewBehaviours', [Replacing])],
	      factory: factory$l
	    });
	
	    var schema$z = constant([
	      defaulted$1('selectFirst', true),
	      onHandler('onChangeTab'),
	      onHandler('onDismissTab'),
	      defaulted$1('tabs', []),
	      field$1('tabSectionBehaviours', [])
	    ]);
	    var barPart = required({
	      factory: Tabbar,
	      schema: [
	        strict$1('dom'),
	        strictObjOf('markers', [
	          strict$1('tabClass'),
	          strict$1('selectedClass')
	        ])
	      ],
	      name: 'tabbar',
	      defaults: function (detail) {
	        return { tabs: detail.tabs };
	      }
	    });
	    var viewPart = required({
	      factory: Tabview,
	      name: 'tabview'
	    });
	    var parts$h = constant([
	      barPart,
	      viewPart
	    ]);
	
	    var factory$m = function (detail, components, _spec, _externals) {
	      var changeTab$1 = function (button) {
	        var tabValue = Representing.getValue(button);
	        getPart(button, detail, 'tabview').each(function (tabview) {
	          var tabWithValue = find(detail.tabs, function (t) {
	            return t.value === tabValue;
	          });
	          tabWithValue.each(function (tabData) {
	            var panel = tabData.view();
	            getOpt(button.element, 'id').each(function (id) {
	              set$1(tabview.element, 'aria-labelledby', id);
	            });
	            Replacing.set(tabview, panel);
	            detail.onChangeTab(tabview, button, panel);
	          });
	        });
	      };
	      var changeTabBy = function (section, byPred) {
	        getPart(section, detail, 'tabbar').each(function (tabbar) {
	          byPred(tabbar).each(emitExecute);
	        });
	      };
	      return {
	        uid: detail.uid,
	        dom: detail.dom,
	        components: components,
	        behaviours: get$d(detail.tabSectionBehaviours),
	        events: derive(flatten([
	          detail.selectFirst ? [runOnAttached(function (section, _simulatedEvent) {
	              changeTabBy(section, Highlighting.getFirst);
	            })] : [],
	          [
	            run(changeTab(), function (section, simulatedEvent) {
	              var button = simulatedEvent.event.button;
	              changeTab$1(button);
	            }),
	            run(dismissTab(), function (section, simulatedEvent) {
	              var button = simulatedEvent.event.button;
	              detail.onDismissTab(section, button);
	            })
	          ]
	        ])),
	        apis: {
	          getViewItems: function (section) {
	            return getPart(section, detail, 'tabview').map(function (tabview) {
	              return Replacing.contents(tabview);
	            }).getOr([]);
	          },
	          showTab: function (section, tabKey) {
	            var getTabIfNotActive = function (tabbar) {
	              var candidates = Highlighting.getCandidates(tabbar);
	              var optTab = find(candidates, function (c) {
	                return Representing.getValue(c) === tabKey;
	              });
	              return optTab.filter(function (tab) {
	                return !Highlighting.isHighlighted(tabbar, tab);
	              });
	            };
	            changeTabBy(section, getTabIfNotActive);
	          }
	        }
	      };
	    };
	    var TabSection = composite$1({
	      name: 'TabSection',
	      configFields: schema$z(),
	      partFields: parts$h(),
	      factory: factory$m,
	      apis: {
	        getViewItems: function (apis, component) {
	          return apis.getViewItems(component);
	        },
	        showTab: function (apis, component, tabKey) {
	          apis.showTab(component, tabKey);
	        }
	      }
	    });
	
	    var measureHeights = function (allTabs, tabview, tabviewComp) {
	      return map(allTabs, function (_tab, i) {
	        Replacing.set(tabviewComp, allTabs[i].view());
	        var rect = tabview.dom.getBoundingClientRect();
	        Replacing.set(tabviewComp, []);
	        return rect.height;
	      });
	    };
	    var getMaxHeight = function (heights) {
	      return head(sort(heights, function (a, b) {
	        if (a > b) {
	          return -1;
	        } else if (a < b) {
	          return +1;
	        } else {
	          return 0;
	        }
	      }));
	    };
	    var getMaxTabviewHeight = function (dialog, tabview, tablist) {
	      var documentElement$1 = documentElement(dialog).dom;
	      var rootElm = ancestor$2(dialog, '.tox-dialog-wrap').getOr(dialog);
	      var isFixed = get$5(rootElm, 'position') === 'fixed';
	      var maxHeight;
	      if (isFixed) {
	        maxHeight = Math.max(documentElement$1.clientHeight, window.innerHeight);
	      } else {
	        maxHeight = Math.max(documentElement$1.offsetHeight, documentElement$1.scrollHeight);
	      }
	      var tabviewHeight = get$7(tabview);
	      var isTabListBeside = tabview.dom.offsetLeft >= tablist.dom.offsetLeft + get$8(tablist);
	      var currentTabHeight = isTabListBeside ? Math.max(get$7(tablist), tabviewHeight) : tabviewHeight;
	      var dialogTopMargin = parseInt(get$5(dialog, 'margin-top'), 10) || 0;
	      var dialogBottomMargin = parseInt(get$5(dialog, 'margin-bottom'), 10) || 0;
	      var dialogHeight = get$7(dialog) + dialogTopMargin + dialogBottomMargin;
	      var chromeHeight = dialogHeight - currentTabHeight;
	      return maxHeight - chromeHeight;
	    };
	    var showTab = function (allTabs, comp) {
	      head(allTabs).each(function (tab) {
	        return TabSection.showTab(comp, tab.value);
	      });
	    };
	    var setTabviewHeight = function (tabview, height) {
	      set$2(tabview, 'height', height + 'px');
	      if (!detect$3().browser.isIE()) {
	        set$2(tabview, 'flex-basis', height + 'px');
	      } else {
	        remove$6(tabview, 'flex-basis');
	      }
	    };
	    var updateTabviewHeight = function (dialogBody, tabview, maxTabHeight) {
	      ancestor$2(dialogBody, '[role="dialog"]').each(function (dialog) {
	        descendant$1(dialog, '[role="tablist"]').each(function (tablist) {
	          maxTabHeight.get().map(function (height) {
	            set$2(tabview, 'height', '0');
	            set$2(tabview, 'flex-basis', '0');
	            return Math.min(height, getMaxTabviewHeight(dialog, tabview, tablist));
	          }).each(function (height) {
	            setTabviewHeight(tabview, height);
	          });
	        });
	      });
	    };
	    var getTabview = function (dialog) {
	      return descendant$1(dialog, '[role="tabpanel"]');
	    };
	    var setMode = function (allTabs) {
	      var smartTabHeight = function () {
	        var maxTabHeight = Cell(Optional.none());
	        var extraEvents = [
	          runOnAttached(function (comp) {
	            var dialog = comp.element;
	            getTabview(dialog).each(function (tabview) {
	              set$2(tabview, 'visibility', 'hidden');
	              comp.getSystem().getByDom(tabview).toOptional().each(function (tabviewComp) {
	                var heights = measureHeights(allTabs, tabview, tabviewComp);
	                var maxTabHeightOpt = getMaxHeight(heights);
	                maxTabHeight.set(maxTabHeightOpt);
	              });
	              updateTabviewHeight(dialog, tabview, maxTabHeight);
	              remove$6(tabview, 'visibility');
	              showTab(allTabs, comp);
	              global$2.requestAnimationFrame(function () {
	                updateTabviewHeight(dialog, tabview, maxTabHeight);
	              });
	            });
	          }),
	          run(windowResize(), function (comp) {
	            var dialog = comp.element;
	            getTabview(dialog).each(function (tabview) {
	              updateTabviewHeight(dialog, tabview, maxTabHeight);
	            });
	          }),
	          run(formResizeEvent, function (comp, _se) {
	            var dialog = comp.element;
	            getTabview(dialog).each(function (tabview) {
	              var oldFocus = active(getRootNode(tabview));
	              set$2(tabview, 'visibility', 'hidden');
	              var oldHeight = getRaw(tabview, 'height').map(function (h) {
	                return parseInt(h, 10);
	              });
	              remove$6(tabview, 'height');
	              remove$6(tabview, 'flex-basis');
	              var newHeight = tabview.dom.getBoundingClientRect().height;
	              var hasGrown = oldHeight.forall(function (h) {
	                return newHeight > h;
	              });
	              if (hasGrown) {
	                maxTabHeight.set(Optional.from(newHeight));
	                updateTabviewHeight(dialog, tabview, maxTabHeight);
	              } else {
	                oldHeight.each(function (h) {
	                  setTabviewHeight(tabview, h);
	                });
	              }
	              remove$6(tabview, 'visibility');
	              oldFocus.each(focus$1);
	            });
	          })
	        ];
	        var selectFirst = false;
	        return {
	          extraEvents: extraEvents,
	          selectFirst: selectFirst
	        };
	      }();
	      var naiveTabHeight = function () {
	        var extraEvents = [];
	        var selectFirst = true;
	        return {
	          extraEvents: extraEvents,
	          selectFirst: selectFirst
	        };
	      }();
	      return {
	        smartTabHeight: smartTabHeight,
	        naiveTabHeight: naiveTabHeight
	      };
	    };
	
	    var SendDataToSectionChannel = 'send-data-to-section';
	    var SendDataToViewChannel = 'send-data-to-view';
	    var renderTabPanel = function (spec, backstage) {
	      var storedValue = Cell({});
	      var updateDataWithForm = function (form) {
	        var formData = Representing.getValue(form);
	        var validData = toValidValues(formData).getOr({});
	        var currentData = storedValue.get();
	        var newData = deepMerge(currentData, validData);
	        storedValue.set(newData);
	      };
	      var setDataOnForm = function (form) {
	        var tabData = storedValue.get();
	        Representing.setValue(form, tabData);
	      };
	      var oldTab = Cell(null);
	      var allTabs = map(spec.tabs, function (tab) {
	        return {
	          value: tab.name,
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__body-nav-item'],
	            innerHtml: backstage.shared.providers.translate(tab.title)
	          },
	          view: function () {
	            return [Form.sketch(function (parts) {
	                return {
	                  dom: {
	                    tag: 'div',
	                    classes: ['tox-form']
	                  },
	                  components: map(tab.items, function (item) {
	                    return interpretInForm(parts, item, backstage);
	                  }),
	                  formBehaviours: derive$1([
	                    Keying.config({
	                      mode: 'acyclic',
	                      useTabstopAt: not(isPseudoStop)
	                    }),
	                    config('TabView.form.events', [
	                      runOnAttached(setDataOnForm),
	                      runOnDetached(updateDataWithForm)
	                    ]),
	                    Receiving.config({
	                      channels: wrapAll$1([
	                        {
	                          key: SendDataToSectionChannel,
	                          value: { onReceive: updateDataWithForm }
	                        },
	                        {
	                          key: SendDataToViewChannel,
	                          value: { onReceive: setDataOnForm }
	                        }
	                      ])
	                    })
	                  ])
	                };
	              })];
	          }
	        };
	      });
	      var tabMode = setMode(allTabs).smartTabHeight;
	      return TabSection.sketch({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__body']
	        },
	        onChangeTab: function (section, button, _viewItems) {
	          var name = Representing.getValue(button);
	          emitWith(section, formTabChangeEvent, {
	            name: name,
	            oldName: oldTab.get()
	          });
	          oldTab.set(name);
	        },
	        tabs: allTabs,
	        components: [
	          TabSection.parts.tabbar({
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-nav']
	            },
	            components: [Tabbar.parts.tabs({})],
	            markers: {
	              tabClass: 'tox-tab',
	              selectedClass: 'tox-dialog__body-nav-item--active'
	            },
	            tabbarBehaviours: derive$1([Tabstopping.config({})])
	          }),
	          TabSection.parts.tabview({
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-content']
	            }
	          })
	        ],
	        selectFirst: tabMode.selectFirst,
	        tabSectionBehaviours: derive$1([
	          config('tabpanel', tabMode.extraEvents),
	          Keying.config({ mode: 'acyclic' }),
	          Composing.config({
	            find: function (comp) {
	              return head(TabSection.getViewItems(comp));
	            }
	          }),
	          Representing.config({
	            store: {
	              mode: 'manual',
	              getValue: function (tsection) {
	                tsection.getSystem().broadcastOn([SendDataToSectionChannel], {});
	                return storedValue.get();
	              },
	              setValue: function (tsection, value) {
	                storedValue.set(value);
	                tsection.getSystem().broadcastOn([SendDataToViewChannel], {});
	              }
	            }
	          })
	        ])
	      });
	    };
	
	    var dialogChannel = generate$1('update-dialog');
	    var titleChannel = generate$1('update-title');
	    var bodyChannel = generate$1('update-body');
	    var footerChannel = generate$1('update-footer');
	    var bodySendMessageChannel = generate$1('body-send-message');
	
	    var renderBody = function (spec, id, backstage, ariaAttrs) {
	      var renderComponents = function (incoming) {
	        switch (incoming.body.type) {
	        case 'tabpanel': {
	            return [renderTabPanel(incoming.body, backstage)];
	          }
	        default: {
	            return [renderBodyPanel(incoming.body, backstage)];
	          }
	        }
	      };
	      var updateState = function (_comp, incoming) {
	        return Optional.some({
	          isTabPanel: function () {
	            return incoming.body.type === 'tabpanel';
	          }
	        });
	      };
	      var ariaAttributes = { 'aria-live': 'polite' };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__content-js'],
	          attributes: __assign(__assign({}, id.map(function (x) {
	            return { id: x };
	          }).getOr({})), ariaAttrs ? ariaAttributes : {})
	        },
	        components: [],
	        behaviours: derive$1([
	          ComposingConfigs.childAt(0),
	          Reflecting.config({
	            channel: bodyChannel,
	            updateState: updateState,
	            renderComponents: renderComponents,
	            initialData: spec
	          })
	        ])
	      };
	    };
	    var renderInlineBody = function (spec, contentId, backstage, ariaAttrs) {
	      return renderBody(spec, Optional.some(contentId), backstage, ariaAttrs);
	    };
	    var renderModalBody = function (spec, backstage) {
	      var bodySpec = renderBody(spec, Optional.none(), backstage, false);
	      return ModalDialog.parts.body(bodySpec);
	    };
	    var renderIframeBody = function (spec) {
	      var bodySpec = {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__content-js']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-iframe']
	            },
	            components: [craft({
	                dom: {
	                  tag: 'iframe',
	                  attributes: { src: spec.url }
	                },
	                behaviours: derive$1([
	                  Tabstopping.config({}),
	                  Focusing.config({})
	                ])
	              })]
	          }],
	        behaviours: derive$1([Keying.config({
	            mode: 'acyclic',
	            useTabstopAt: not(isPseudoStop)
	          })])
	      };
	      return ModalDialog.parts.body(bodySpec);
	    };
	
	    var isTouch = global$8.deviceType.isTouch();
	    var hiddenHeader = function (title, close) {
	      return {
	        dom: {
	          tag: 'div',
	          styles: { display: 'none' },
	          classes: ['tox-dialog__header']
	        },
	        components: [
	          title,
	          close
	        ]
	      };
	    };
	    var pClose = function (onClose, providersBackstage) {
	      return ModalDialog.parts.close(Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-button',
	            'tox-button--icon',
	            'tox-button--naked'
	          ],
	          attributes: {
	            'type': 'button',
	            'aria-label': providersBackstage.translate('Close')
	          }
	        },
	        action: onClose,
	        buttonBehaviours: derive$1([Tabstopping.config({})])
	      }));
	    };
	    var pUntitled = function () {
	      return ModalDialog.parts.title({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__title'],
	          innerHtml: '',
	          styles: { display: 'none' }
	        }
	      });
	    };
	    var pBodyMessage = function (message, providersBackstage) {
	      return ModalDialog.parts.body({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__body']
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-dialog__body-content']
	            },
	            components: [{ dom: fromHtml$2('<p>' + providersBackstage.translate(message) + '</p>') }]
	          }]
	      });
	    };
	    var pFooter = function (buttons) {
	      return ModalDialog.parts.footer({
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__footer']
	        },
	        components: buttons
	      });
	    };
	    var pFooterGroup = function (startButtons, endButtons) {
	      return [
	        Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__footer-start']
	          },
	          components: startButtons
	        }),
	        Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__footer-end']
	          },
	          components: endButtons
	        })
	      ];
	    };
	    var renderDialog = function (spec) {
	      var _a;
	      var dialogClass = 'tox-dialog';
	      var blockerClass = dialogClass + '-wrap';
	      var blockerBackdropClass = blockerClass + '__backdrop';
	      var scrollLockClass = dialogClass + '__disable-scroll';
	      return ModalDialog.sketch({
	        lazySink: spec.lazySink,
	        onEscape: function (comp) {
	          spec.onEscape(comp);
	          return Optional.some(true);
	        },
	        useTabstopAt: function (elem) {
	          return !isPseudoStop(elem);
	        },
	        dom: {
	          tag: 'div',
	          classes: [dialogClass].concat(spec.extraClasses),
	          styles: __assign({ position: 'relative' }, spec.extraStyles)
	        },
	        components: __spreadArrays([
	          spec.header,
	          spec.body
	        ], spec.footer.toArray()),
	        parts: {
	          blocker: {
	            dom: fromHtml$2('<div class="' + blockerClass + '"></div>'),
	            components: [{
	                dom: {
	                  tag: 'div',
	                  classes: isTouch ? [
	                    blockerBackdropClass,
	                    blockerBackdropClass + '--opaque'
	                  ] : [blockerBackdropClass]
	                }
	              }]
	          }
	        },
	        dragBlockClass: blockerClass,
	        modalBehaviours: derive$1(__spreadArrays([
	          Focusing.config({}),
	          config('dialog-events', spec.dialogEvents.concat([runOnSource(focusin(), function (comp, _se) {
	              Keying.focusIn(comp);
	            })])),
	          config('scroll-lock', [
	            runOnAttached(function () {
	              add$2(body(), scrollLockClass);
	            }),
	            runOnDetached(function () {
	              remove$4(body(), scrollLockClass);
	            })
	          ])
	        ], spec.extraBehaviours)),
	        eventOrder: __assign((_a = {}, _a[execute()] = ['dialog-events'], _a[attachedToDom()] = [
	          'scroll-lock',
	          'dialog-events',
	          'alloy.base.behaviour'
	        ], _a[detachedFromDom()] = [
	          'alloy.base.behaviour',
	          'dialog-events',
	          'scroll-lock'
	        ], _a), spec.eventOrder)
	      });
	    };
	
	    var renderClose = function (providersBackstage) {
	      return Button.sketch({
	        dom: {
	          tag: 'button',
	          classes: [
	            'tox-button',
	            'tox-button--icon',
	            'tox-button--naked'
	          ],
	          attributes: {
	            'type': 'button',
	            'aria-label': providersBackstage.translate('Close'),
	            'title': providersBackstage.translate('Close')
	          }
	        },
	        components: [{
	            dom: {
	              tag: 'div',
	              classes: ['tox-icon'],
	              innerHtml: get$e('close', providersBackstage.icons)
	            }
	          }],
	        action: function (comp) {
	          emit(comp, formCancelEvent);
	        }
	      });
	    };
	    var renderTitle = function (spec, id, providersBackstage) {
	      var renderComponents = function (data) {
	        return [text(providersBackstage.translate(data.title))];
	      };
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__title'],
	          attributes: __assign({}, id.map(function (x) {
	            return { id: x };
	          }).getOr({}))
	        },
	        components: renderComponents(spec),
	        behaviours: derive$1([Reflecting.config({
	            channel: titleChannel,
	            renderComponents: renderComponents
	          })])
	      };
	    };
	    var renderDragHandle = function () {
	      return { dom: fromHtml$2('<div class="tox-dialog__draghandle"></div>') };
	    };
	    var renderInlineHeader = function (spec, titleId, providersBackstage) {
	      return Container.sketch({
	        dom: fromHtml$2('<div class="tox-dialog__header"></div>'),
	        components: [
	          renderTitle(spec, Optional.some(titleId), providersBackstage),
	          renderDragHandle(),
	          renderClose(providersBackstage)
	        ],
	        containerBehaviours: derive$1([Dragging.config({
	            mode: 'mouse',
	            blockerClass: 'blocker',
	            getTarget: function (handle) {
	              return closest$3(handle, '[role="dialog"]').getOrDie();
	            },
	            snaps: {
	              getSnapPoints: function () {
	                return [];
	              },
	              leftAttr: 'data-drag-left',
	              topAttr: 'data-drag-top'
	            }
	          })])
	      });
	    };
	    var renderModalHeader = function (spec, providersBackstage) {
	      var pTitle = ModalDialog.parts.title(renderTitle(spec, Optional.none(), providersBackstage));
	      var pHandle = ModalDialog.parts.draghandle(renderDragHandle());
	      var pClose = ModalDialog.parts.close(renderClose(providersBackstage));
	      var components = [pTitle].concat(spec.draggable ? [pHandle] : []).concat([pClose]);
	      return Container.sketch({
	        dom: fromHtml$2('<div class="tox-dialog__header"></div>'),
	        components: components
	      });
	    };
	
	    var getHeader = function (title, backstage) {
	      return renderModalHeader({
	        title: backstage.shared.providers.translate(title),
	        draggable: backstage.dialog.isDraggableModal()
	      }, backstage.shared.providers);
	    };
	    var getBusySpec = function (message, bs, providers) {
	      return {
	        dom: {
	          tag: 'div',
	          classes: ['tox-dialog__busy-spinner'],
	          attributes: { 'aria-label': providers.translate(message) },
	          styles: {
	            left: '0px',
	            right: '0px',
	            bottom: '0px',
	            top: '0px',
	            position: 'absolute'
	          }
	        },
	        behaviours: bs,
	        components: [{ dom: fromHtml$2('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
	      };
	    };
	    var getEventExtras = function (lazyDialog, providers, extra) {
	      return {
	        onClose: function () {
	          return extra.closeWindow();
	        },
	        onBlock: function (blockEvent) {
	          ModalDialog.setBusy(lazyDialog(), function (_comp, bs) {
	            return getBusySpec(blockEvent.message, bs, providers);
	          });
	        },
	        onUnblock: function () {
	          ModalDialog.setIdle(lazyDialog());
	        }
	      };
	    };
	    var renderModalDialog = function (spec, initialData, dialogEvents, backstage) {
	      var _a;
	      var updateState = function (_comp, incoming) {
	        return Optional.some(incoming);
	      };
	      return build$1(renderDialog(__assign(__assign({}, spec), {
	        lazySink: backstage.shared.getSink,
	        extraBehaviours: __spreadArrays([
	          Reflecting.config({
	            channel: dialogChannel,
	            updateState: updateState,
	            initialData: initialData
	          }),
	          RepresentingConfigs.memory({})
	        ], spec.extraBehaviours),
	        onEscape: function (comp) {
	          emit(comp, formCancelEvent);
	        },
	        dialogEvents: dialogEvents,
	        eventOrder: (_a = {}, _a[receive()] = [
	          Reflecting.name(),
	          Receiving.name()
	        ], _a[attachedToDom()] = [
	          'scroll-lock',
	          Reflecting.name(),
	          'messages',
	          'dialog-events',
	          'alloy.base.behaviour'
	        ], _a[detachedFromDom()] = [
	          'alloy.base.behaviour',
	          'dialog-events',
	          'messages',
	          Reflecting.name(),
	          'scroll-lock'
	        ], _a)
	      })));
	    };
	    var mapMenuButtons = function (buttons) {
	      var mapItems = function (button) {
	        var items = map(button.items, function (item) {
	          var cell = Cell(false);
	          return __assign(__assign({}, item), { storage: cell });
	        });
	        return __assign(__assign({}, button), { items: items });
	      };
	      return map(buttons, function (button) {
	        if (button.type === 'menu') {
	          return mapItems(button);
	        }
	        return button;
	      });
	    };
	    var extractCellsToObject = function (buttons) {
	      return foldl(buttons, function (acc, button) {
	        if (button.type === 'menu') {
	          var menuButton = button;
	          return foldl(menuButton.items, function (innerAcc, item) {
	            innerAcc[item.name] = item.storage;
	            return innerAcc;
	          }, acc);
	        }
	        return acc;
	      }, {});
	    };
	
	    var initCommonEvents = function (fireApiEvent, extras) {
	      return [
	        runWithTarget(focusin(), onFocus$1),
	        fireApiEvent(formCloseEvent, function (_api, spec) {
	          extras.onClose();
	          spec.onClose();
	        }),
	        fireApiEvent(formCancelEvent, function (api, spec, _event, self) {
	          spec.onCancel(api);
	          emit(self, formCloseEvent);
	        }),
	        run(formUnblockEvent, function (_c, _se) {
	          return extras.onUnblock();
	        }),
	        run(formBlockEvent, function (_c, se) {
	          return extras.onBlock(se.event);
	        })
	      ];
	    };
	    var initUrlDialog = function (getInstanceApi, extras) {
	      var fireApiEvent = function (eventName, f) {
	        return run(eventName, function (c, se) {
	          withSpec(c, function (spec, _c) {
	            f(getInstanceApi(), spec, se.event, c);
	          });
	        });
	      };
	      var withSpec = function (c, f) {
	        Reflecting.getState(c).get().each(function (currentDialog) {
	          f(currentDialog, c);
	        });
	      };
	      return __spreadArrays(initCommonEvents(fireApiEvent, extras), [fireApiEvent(formActionEvent, function (api, spec, event) {
	          spec.onAction(api, { name: event.name });
	        })]);
	    };
	    var initDialog = function (getInstanceApi, extras, getSink) {
	      var fireApiEvent = function (eventName, f) {
	        return run(eventName, function (c, se) {
	          withSpec(c, function (spec, _c) {
	            f(getInstanceApi(), spec, se.event, c);
	          });
	        });
	      };
	      var withSpec = function (c, f) {
	        Reflecting.getState(c).get().each(function (currentDialogInit) {
	          f(currentDialogInit.internalDialog, c);
	        });
	      };
	      return __spreadArrays(initCommonEvents(fireApiEvent, extras), [
	        fireApiEvent(formSubmitEvent, function (api, spec) {
	          return spec.onSubmit(api);
	        }),
	        fireApiEvent(formChangeEvent, function (api, spec, event) {
	          spec.onChange(api, { name: event.name });
	        }),
	        fireApiEvent(formActionEvent, function (api, spec, event, component) {
	          var focusIn = function () {
	            return Keying.focusIn(component);
	          };
	          var isDisabled = function (focused) {
	            return has$1(focused, 'disabled') || getOpt(focused, 'aria-disabled').exists(function (val) {
	              return val === 'true';
	            });
	          };
	          var rootNode = getRootNode(component.element);
	          var current = active(rootNode);
	          spec.onAction(api, {
	            name: event.name,
	            value: event.value
	          });
	          active(rootNode).fold(focusIn, function (focused) {
	            if (isDisabled(focused)) {
	              focusIn();
	            } else if (current.exists(function (cur) {
	                return contains$2(focused, cur) && isDisabled(cur);
	              })) {
	              focusIn();
	            } else {
	              getSink().toOptional().filter(function (sink) {
	                return !contains$2(sink.element, focused);
	              }).each(focusIn);
	            }
	          });
	        }),
	        fireApiEvent(formTabChangeEvent, function (api, spec, event) {
	          spec.onTabChange(api, {
	            newTabName: event.name,
	            oldTabName: event.oldName
	          });
	        }),
	        runOnDetached(function (component) {
	          var api = getInstanceApi();
	          Representing.setValue(component, api.getData());
	        })
	      ]);
	    };
	    var SilverDialogEvents = {
	      initUrlDialog: initUrlDialog,
	      initDialog: initDialog
	    };
	
	    var makeButton = function (button, backstage) {
	      return renderFooterButton(button, button.type, backstage);
	    };
	    var lookup$2 = function (compInSystem, footerButtons, buttonName) {
	      return find(footerButtons, function (button) {
	        return button.name === buttonName;
	      }).bind(function (memButton) {
	        return memButton.memento.getOpt(compInSystem);
	      });
	    };
	    var renderComponents = function (_data, state) {
	      var footerButtons = state.map(function (s) {
	        return s.footerButtons;
	      }).getOr([]);
	      var buttonGroups = partition(footerButtons, function (button) {
	        return button.align === 'start';
	      });
	      var makeGroup = function (edge, buttons) {
	        return Container.sketch({
	          dom: {
	            tag: 'div',
	            classes: ['tox-dialog__footer-' + edge]
	          },
	          components: map(buttons, function (button) {
	            return button.memento.asSpec();
	          })
	        });
	      };
	      var startButtons = makeGroup('start', buttonGroups.pass);
	      var endButtons = makeGroup('end', buttonGroups.fail);
	      return [
	        startButtons,
	        endButtons
	      ];
	    };
	    var renderFooter = function (initSpec, backstage) {
	      var updateState = function (_comp, data) {
	        var footerButtons = map(data.buttons, function (button) {
	          var memButton = record(makeButton(button, backstage));
	          return {
	            name: button.name,
	            align: button.align,
	            memento: memButton
	          };
	        });
	        var lookupByName = function (compInSystem, buttonName) {
	          return lookup$2(compInSystem, footerButtons, buttonName);
	        };
	        return Optional.some({
	          lookupByName: lookupByName,
	          footerButtons: footerButtons
	        });
	      };
	      return {
	        dom: fromHtml$2('<div class="tox-dialog__footer"></div>'),
	        components: [],
	        behaviours: derive$1([Reflecting.config({
	            channel: footerChannel,
	            initialData: initSpec,
	            updateState: updateState,
	            renderComponents: renderComponents
	          })])
	      };
	    };
	    var renderInlineFooter = function (initSpec, backstage) {
	      return renderFooter(initSpec, backstage);
	    };
	    var renderModalFooter = function (initSpec, backstage) {
	      return ModalDialog.parts.footer(renderFooter(initSpec, backstage));
	    };
	
	    var getCompByName = function (access, name) {
	      var root = access.getRoot();
	      if (root.getSystem().isConnected()) {
	        var form_1 = Composing.getCurrent(access.getFormWrapper()).getOr(access.getFormWrapper());
	        return Form.getField(form_1, name).fold(function () {
	          var footer = access.getFooter();
	          var footerState = Reflecting.getState(footer);
	          return footerState.get().bind(function (f) {
	            return f.lookupByName(form_1, name);
	          });
	        }, function (comp) {
	          return Optional.some(comp);
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	    var validateData = function (access, data) {
	      var root = access.getRoot();
	      return Reflecting.getState(root).get().map(function (dialogState) {
	        return getOrDie(asRaw('data', dialogState.dataValidator, data));
	      }).getOr(data);
	    };
	    var getDialogApi = function (access, doRedial, menuItemStates) {
	      var withRoot = function (f) {
	        var root = access.getRoot();
	        if (root.getSystem().isConnected()) {
	          f(root);
	        }
	      };
	      var getData = function () {
	        var root = access.getRoot();
	        var valueComp = root.getSystem().isConnected() ? access.getFormWrapper() : root;
	        var representedValues = Representing.getValue(valueComp);
	        var menuItemCurrentState = map$2(menuItemStates, function (cell) {
	          return cell.get();
	        });
	        return __assign(__assign({}, representedValues), menuItemCurrentState);
	      };
	      var setData = function (newData) {
	        withRoot(function (_) {
	          var prevData = instanceApi.getData();
	          var mergedData = __assign(__assign({}, prevData), newData);
	          var newInternalData = validateData(access, mergedData);
	          var form = access.getFormWrapper();
	          Representing.setValue(form, newInternalData);
	          each$1(menuItemStates, function (v, k) {
	            if (has(mergedData, k)) {
	              v.set(mergedData[k]);
	            }
	          });
	        });
	      };
	      var disable = function (name) {
	        getCompByName(access, name).each(Disabling.disable);
	      };
	      var enable = function (name) {
	        getCompByName(access, name).each(Disabling.enable);
	      };
	      var focus = function (name) {
	        getCompByName(access, name).each(Focusing.focus);
	      };
	      var block = function (message) {
	        if (!isString(message)) {
	          throw new Error('The dialogInstanceAPI.block function should be passed a blocking message of type string as an argument');
	        }
	        withRoot(function (root) {
	          emitWith(root, formBlockEvent, { message: message });
	        });
	      };
	      var unblock = function () {
	        withRoot(function (root) {
	          emit(root, formUnblockEvent);
	        });
	      };
	      var showTab = function (name) {
	        withRoot(function (_) {
	          var body = access.getBody();
	          var bodyState = Reflecting.getState(body);
	          if (bodyState.get().exists(function (b) {
	              return b.isTabPanel();
	            })) {
	            Composing.getCurrent(body).each(function (tabSection) {
	              TabSection.showTab(tabSection, name);
	            });
	          }
	        });
	      };
	      var redial = function (d) {
	        withRoot(function (root) {
	          var dialogInit = doRedial(d);
	          root.getSystem().broadcastOn([dialogChannel], dialogInit);
	          root.getSystem().broadcastOn([titleChannel], dialogInit.internalDialog);
	          root.getSystem().broadcastOn([bodyChannel], dialogInit.internalDialog);
	          root.getSystem().broadcastOn([footerChannel], dialogInit.internalDialog);
	          instanceApi.setData(dialogInit.initialData);
	        });
	      };
	      var close = function () {
	        withRoot(function (root) {
	          emit(root, formCloseEvent);
	        });
	      };
	      var instanceApi = {
	        getData: getData,
	        setData: setData,
	        disable: disable,
	        enable: enable,
	        focus: focus,
	        block: block,
	        unblock: unblock,
	        showTab: showTab,
	        redial: redial,
	        close: close
	      };
	      return instanceApi;
	    };
	
	    var getDialogSizeClasses = function (size) {
	      switch (size) {
	      case 'large':
	        return ['tox-dialog--width-lg'];
	      case 'medium':
	        return ['tox-dialog--width-md'];
	      default:
	        return [];
	      }
	    };
	    var renderDialog$1 = function (dialogInit, extra, backstage) {
	      var header = getHeader(dialogInit.internalDialog.title, backstage);
	      var body = renderModalBody({ body: dialogInit.internalDialog.body }, backstage);
	      var storagedMenuButtons = mapMenuButtons(dialogInit.internalDialog.buttons);
	      var objOfCells = extractCellsToObject(storagedMenuButtons);
	      var footer = renderModalFooter({ buttons: storagedMenuButtons }, backstage);
	      var dialogEvents = SilverDialogEvents.initDialog(function () {
	        return instanceApi;
	      }, getEventExtras(function () {
	        return dialog;
	      }, backstage.shared.providers, extra), backstage.shared.getSink);
	      var dialogSize = getDialogSizeClasses(dialogInit.internalDialog.size);
	      var spec = {
	        header: header,
	        body: body,
	        footer: Optional.some(footer),
	        extraClasses: dialogSize,
	        extraBehaviours: [],
	        extraStyles: {}
	      };
	      var dialog = renderModalDialog(spec, dialogInit, dialogEvents, backstage);
	      var modalAccess = function () {
	        var getForm = function () {
	          var outerForm = ModalDialog.getBody(dialog);
	          return Composing.getCurrent(outerForm).getOr(outerForm);
	        };
	        return {
	          getRoot: function () {
	            return dialog;
	          },
	          getBody: function () {
	            return ModalDialog.getBody(dialog);
	          },
	          getFooter: function () {
	            return ModalDialog.getFooter(dialog);
	          },
	          getFormWrapper: getForm
	        };
	      }();
	      var instanceApi = getDialogApi(modalAccess, extra.redial, objOfCells);
	      return {
	        dialog: dialog,
	        instanceApi: instanceApi
	      };
	    };
	
	    var renderInlineDialog = function (dialogInit, extra, backstage, ariaAttrs) {
	      var _a, _b;
	      var dialogLabelId = generate$1('dialog-label');
	      var dialogContentId = generate$1('dialog-content');
	      var updateState = function (_comp, incoming) {
	        return Optional.some(incoming);
	      };
	      var memHeader = record(renderInlineHeader({
	        title: dialogInit.internalDialog.title,
	        draggable: true
	      }, dialogLabelId, backstage.shared.providers));
	      var memBody = record(renderInlineBody({ body: dialogInit.internalDialog.body }, dialogContentId, backstage, ariaAttrs));
	      var storagedMenuButtons = mapMenuButtons(dialogInit.internalDialog.buttons);
	      var objOfCells = extractCellsToObject(storagedMenuButtons);
	      var memFooter = record(renderInlineFooter({ buttons: storagedMenuButtons }, backstage));
	      var dialogEvents = SilverDialogEvents.initDialog(function () {
	        return instanceApi;
	      }, {
	        onBlock: function (event) {
	          Blocking.block(dialog, function (_comp, bs) {
	            return getBusySpec(event.message, bs, backstage.shared.providers);
	          });
	        },
	        onUnblock: function () {
	          Blocking.unblock(dialog);
	        },
	        onClose: function () {
	          return extra.closeWindow();
	        }
	      }, backstage.shared.getSink);
	      var dialog = build$1({
	        dom: {
	          tag: 'div',
	          classes: [
	            'tox-dialog',
	            'tox-dialog-inline'
	          ],
	          attributes: (_a = { role: 'dialog' }, _a['aria-labelledby'] = dialogLabelId, _a['aria-describedby'] = '' + dialogContentId, _a)
	        },
	        eventOrder: (_b = {}, _b[receive()] = [
	          Reflecting.name(),
	          Receiving.name()
	        ], _b[execute()] = ['execute-on-form'], _b[attachedToDom()] = [
	          'reflecting',
	          'execute-on-form'
	        ], _b),
	        behaviours: derive$1([
	          Keying.config({
	            mode: 'cyclic',
	            onEscape: function (c) {
	              emit(c, formCloseEvent);
	              return Optional.some(true);
	            },
	            useTabstopAt: function (elem) {
	              return !isPseudoStop(elem) && (name(elem) !== 'button' || get$3(elem, 'disabled') !== 'disabled');
	            }
	          }),
	          Reflecting.config({
	            channel: dialogChannel,
	            updateState: updateState,
	            initialData: dialogInit
	          }),
	          Focusing.config({}),
	          config('execute-on-form', dialogEvents.concat([runOnSource(focusin(), function (comp, _se) {
	              Keying.focusIn(comp);
	            })])),
	          Blocking.config({
	            getRoot: function () {
	              return Optional.some(dialog);
	            }
	          }),
	          Replacing.config({}),
	          RepresentingConfigs.memory({})
	        ]),
	        components: [
	          memHeader.asSpec(),
	          memBody.asSpec(),
	          memFooter.asSpec()
	        ]
	      });
	      var instanceApi = getDialogApi({
	        getRoot: function () {
	          return dialog;
	        },
	        getFooter: function () {
	          return memFooter.get(dialog);
	        },
	        getBody: function () {
	          return memBody.get(dialog);
	        },
	        getFormWrapper: function () {
	          var body = memBody.get(dialog);
	          return Composing.getCurrent(body).getOr(body);
	        }
	      }, extra.redial, objOfCells);
	      return {
	        dialog: dialog,
	        instanceApi: instanceApi
	      };
	    };
	
	    var global$h = tinymce.util.Tools.resolve('tinymce.util.URI');
	
	    var getUrlDialogApi = function (root) {
	      var withRoot = function (f) {
	        if (root.getSystem().isConnected()) {
	          f(root);
	        }
	      };
	      var block = function (message) {
	        if (!isString(message)) {
	          throw new Error('The urlDialogInstanceAPI.block function should be passed a blocking message of type string as an argument');
	        }
	        withRoot(function (root) {
	          emitWith(root, formBlockEvent, { message: message });
	        });
	      };
	      var unblock = function () {
	        withRoot(function (root) {
	          emit(root, formUnblockEvent);
	        });
	      };
	      var close = function () {
	        withRoot(function (root) {
	          emit(root, formCloseEvent);
	        });
	      };
	      var sendMessage = function (data) {
	        withRoot(function (root) {
	          root.getSystem().broadcastOn([bodySendMessageChannel], data);
	        });
	      };
	      return {
	        block: block,
	        unblock: unblock,
	        close: close,
	        sendMessage: sendMessage
	      };
	    };
	
	    var SUPPORTED_MESSAGE_ACTIONS = [
	      'insertContent',
	      'setContent',
	      'execCommand',
	      'close',
	      'block',
	      'unblock'
	    ];
	    var isSupportedMessage = function (data) {
	      return isObject(data) && SUPPORTED_MESSAGE_ACTIONS.indexOf(data.mceAction) !== -1;
	    };
	    var isCustomMessage = function (data) {
	      return !isSupportedMessage(data) && isObject(data) && has(data, 'mceAction');
	    };
	    var handleMessage = function (editor, api, data) {
	      switch (data.mceAction) {
	      case 'insertContent':
	        editor.insertContent(data.content);
	        break;
	      case 'setContent':
	        editor.setContent(data.content);
	        break;
	      case 'execCommand':
	        var ui = isBoolean(data.ui) ? data.ui : false;
	        editor.execCommand(data.cmd, ui, data.value);
	        break;
	      case 'close':
	        api.close();
	        break;
	      case 'block':
	        api.block(data.message);
	        break;
	      case 'unblock':
	        api.unblock();
	        break;
	      }
	    };
	    var renderUrlDialog = function (internalDialog, extra, editor, backstage) {
	      var _a;
	      var header = getHeader(internalDialog.title, backstage);
	      var body = renderIframeBody(internalDialog);
	      var footer = internalDialog.buttons.bind(function (buttons) {
	        if (buttons.length === 0) {
	          return Optional.none();
	        } else {
	          return Optional.some(renderModalFooter({ buttons: buttons }, backstage));
	        }
	      });
	      var dialogEvents = SilverDialogEvents.initUrlDialog(function () {
	        return instanceApi;
	      }, getEventExtras(function () {
	        return dialog;
	      }, backstage.shared.providers, extra));
	      var styles = __assign(__assign({}, internalDialog.height.fold(function () {
	        return {};
	      }, function (height) {
	        return {
	          'height': height + 'px',
	          'max-height': height + 'px'
	        };
	      })), internalDialog.width.fold(function () {
	        return {};
	      }, function (width) {
	        return {
	          'width': width + 'px',
	          'max-width': width + 'px'
	        };
	      }));
	      var classes = internalDialog.width.isNone() && internalDialog.height.isNone() ? ['tox-dialog--width-lg'] : [];
	      var iframeUri = new global$h(internalDialog.url, { base_uri: new global$h(window.location.href) });
	      var iframeDomain = iframeUri.protocol + '://' + iframeUri.host + (iframeUri.port ? ':' + iframeUri.port : '');
	      var messageHandlerUnbinder = Cell(Optional.none());
	      var extraBehaviours = [
	        config('messages', [
	          runOnAttached(function () {
	            var unbind = bind$3(SugarElement.fromDom(window), 'message', function (e) {
	              if (iframeUri.isSameOrigin(new global$h(e.raw.origin))) {
	                var data = e.raw.data;
	                if (isSupportedMessage(data)) {
	                  handleMessage(editor, instanceApi, data);
	                } else if (isCustomMessage(data)) {
	                  internalDialog.onMessage(instanceApi, data);
	                }
	              }
	            });
	            messageHandlerUnbinder.set(Optional.some(unbind));
	          }),
	          runOnDetached(function () {
	            messageHandlerUnbinder.get().each(function (unbinder) {
	              return unbinder.unbind();
	            });
	          })
	        ]),
	        Receiving.config({
	          channels: (_a = {}, _a[bodySendMessageChannel] = {
	            onReceive: function (comp, data) {
	              descendant$1(comp.element, 'iframe').each(function (iframeEle) {
	                var iframeWin = iframeEle.dom.contentWindow;
	                iframeWin.postMessage(data, iframeDomain);
	              });
	            }
	          }, _a)
	        })
	      ];
	      var spec = {
	        header: header,
	        body: body,
	        footer: footer,
	        extraClasses: classes,
	        extraBehaviours: extraBehaviours,
	        extraStyles: styles
	      };
	      var dialog = renderModalDialog(spec, internalDialog, dialogEvents, backstage);
	      var instanceApi = getUrlDialogApi(dialog);
	      return {
	        dialog: dialog,
	        instanceApi: instanceApi
	      };
	    };
	
	    var setup$c = function (extras) {
	      var sharedBackstage = extras.backstage.shared;
	      var open = function (message, callback) {
	        var closeDialog = function () {
	          ModalDialog.hide(alertDialog);
	          callback();
	        };
	        var memFooterClose = record(renderFooterButton({
	          name: 'close-alert',
	          text: 'OK',
	          primary: true,
	          align: 'end',
	          disabled: false,
	          icon: Optional.none()
	        }, 'cancel', extras.backstage));
	        var titleSpec = pUntitled();
	        var closeSpec = pClose(closeDialog, sharedBackstage.providers);
	        var alertDialog = build$1(renderDialog({
	          lazySink: function () {
	            return sharedBackstage.getSink();
	          },
	          header: hiddenHeader(titleSpec, closeSpec),
	          body: pBodyMessage(message, sharedBackstage.providers),
	          footer: Optional.some(pFooter(pFooterGroup([], [memFooterClose.asSpec()]))),
	          onEscape: closeDialog,
	          extraClasses: ['tox-alert-dialog'],
	          extraBehaviours: [],
	          extraStyles: {},
	          dialogEvents: [run(formCancelEvent, closeDialog)],
	          eventOrder: {}
	        }));
	        ModalDialog.show(alertDialog);
	        var footerCloseButton = memFooterClose.get(alertDialog);
	        Focusing.focus(footerCloseButton);
	      };
	      return { open: open };
	    };
	
	    var setup$d = function (extras) {
	      var sharedBackstage = extras.backstage.shared;
	      var open = function (message, callback) {
	        var closeDialog = function (state) {
	          ModalDialog.hide(confirmDialog);
	          callback(state);
	        };
	        var memFooterYes = record(renderFooterButton({
	          name: 'yes',
	          text: 'Yes',
	          primary: true,
	          align: 'end',
	          disabled: false,
	          icon: Optional.none()
	        }, 'submit', extras.backstage));
	        var footerNo = renderFooterButton({
	          name: 'no',
	          text: 'No',
	          primary: false,
	          align: 'end',
	          disabled: false,
	          icon: Optional.none()
	        }, 'cancel', extras.backstage);
	        var titleSpec = pUntitled();
	        var closeSpec = pClose(function () {
	          return closeDialog(false);
	        }, sharedBackstage.providers);
	        var confirmDialog = build$1(renderDialog({
	          lazySink: function () {
	            return sharedBackstage.getSink();
	          },
	          header: hiddenHeader(titleSpec, closeSpec),
	          body: pBodyMessage(message, sharedBackstage.providers),
	          footer: Optional.some(pFooter(pFooterGroup([], [
	            footerNo,
	            memFooterYes.asSpec()
	          ]))),
	          onEscape: function () {
	            return closeDialog(false);
	          },
	          extraClasses: ['tox-confirm-dialog'],
	          extraBehaviours: [],
	          extraStyles: {},
	          dialogEvents: [
	            run(formCancelEvent, function () {
	              return closeDialog(false);
	            }),
	            run(formSubmitEvent, function () {
	              return closeDialog(true);
	            })
	          ],
	          eventOrder: {}
	        }));
	        ModalDialog.show(confirmDialog);
	        var footerYesButton = memFooterYes.get(confirmDialog);
	        Focusing.focus(footerYesButton);
	      };
	      return { open: open };
	    };
	
	    var validateData$1 = function (data, validator) {
	      return getOrDie(asRaw('data', validator, data));
	    };
	    var isAlertOrConfirmDialog = function (target) {
	      return closest$4(target, '.tox-alert-dialog') || closest$4(target, '.tox-confirm-dialog');
	    };
	    var inlineAdditionalBehaviours = function (editor, isStickyToolbar, isToolbarLocationTop) {
	      if (isStickyToolbar && isToolbarLocationTop) {
	        return [];
	      } else {
	        return [Docking.config({
	            contextual: {
	              lazyContext: function () {
	                return Optional.some(box(SugarElement.fromDom(editor.getContentAreaContainer())));
	              },
	              fadeInClass: 'tox-dialog-dock-fadein',
	              fadeOutClass: 'tox-dialog-dock-fadeout',
	              transitionClass: 'tox-dialog-dock-transition'
	            },
	            modes: ['top']
	          })];
	      }
	    };
	    var setup$e = function (extras) {
	      var backstage = extras.backstage;
	      var editor = extras.editor;
	      var isStickyToolbar$1 = isStickyToolbar(editor);
	      var alertDialog = setup$c(extras);
	      var confirmDialog = setup$d(extras);
	      var open = function (config, params, closeWindow) {
	        if (params !== undefined && params.inline === 'toolbar') {
	          return openInlineDialog(config, backstage.shared.anchors.inlineDialog(), closeWindow, params.ariaAttrs);
	        } else if (params !== undefined && params.inline === 'cursor') {
	          return openInlineDialog(config, backstage.shared.anchors.cursor(), closeWindow, params.ariaAttrs);
	        } else {
	          return openModalDialog(config, closeWindow);
	        }
	      };
	      var openUrl = function (config, closeWindow) {
	        return openModalUrlDialog(config, closeWindow);
	      };
	      var openModalUrlDialog = function (config, closeWindow) {
	        var factory = function (contents) {
	          var dialog = renderUrlDialog(contents, {
	            closeWindow: function () {
	              ModalDialog.hide(dialog.dialog);
	              closeWindow(dialog.instanceApi);
	            }
	          }, editor, backstage);
	          ModalDialog.show(dialog.dialog);
	          return dialog.instanceApi;
	        };
	        return DialogManager.openUrl(factory, config);
	      };
	      var openModalDialog = function (config, closeWindow) {
	        var factory = function (contents, internalInitialData, dataValidator) {
	          var initialData = internalInitialData;
	          var dialogInit = {
	            dataValidator: dataValidator,
	            initialData: initialData,
	            internalDialog: contents
	          };
	          var dialog = renderDialog$1(dialogInit, {
	            redial: DialogManager.redial,
	            closeWindow: function () {
	              ModalDialog.hide(dialog.dialog);
	              closeWindow(dialog.instanceApi);
	            }
	          }, backstage);
	          ModalDialog.show(dialog.dialog);
	          dialog.instanceApi.setData(initialData);
	          return dialog.instanceApi;
	        };
	        return DialogManager.open(factory, config);
	      };
	      var openInlineDialog = function (config$1, anchor, closeWindow, ariaAttrs) {
	        var factory = function (contents, internalInitialData, dataValidator) {
	          var initialData = validateData$1(internalInitialData, dataValidator);
	          var inlineDialog = value$3();
	          var isToolbarLocationTop = backstage.shared.header.isPositionedAtTop();
	          var dialogInit = {
	            dataValidator: dataValidator,
	            initialData: initialData,
	            internalDialog: contents
	          };
	          var refreshDocking = function () {
	            return inlineDialog.on(function (dialog) {
	              InlineView.reposition(dialog);
	              Docking.refresh(dialog);
	            });
	          };
	          var dialogUi = renderInlineDialog(dialogInit, {
	            redial: DialogManager.redial,
	            closeWindow: function () {
	              inlineDialog.on(InlineView.hide);
	              editor.off('ResizeEditor', refreshDocking);
	              inlineDialog.clear();
	              closeWindow(dialogUi.instanceApi);
	            }
	          }, backstage, ariaAttrs);
	          var inlineDialogComp = build$1(InlineView.sketch(__assign(__assign({
	            lazySink: backstage.shared.getSink,
	            dom: {
	              tag: 'div',
	              classes: []
	            },
	            fireDismissalEventInstead: {}
	          }, isToolbarLocationTop ? {} : { fireRepositionEventInstead: {} }), {
	            inlineBehaviours: derive$1(__spreadArrays([config('window-manager-inline-events', [run(dismissRequested(), function (_comp, _se) {
	                  emit(dialogUi.dialog, formCancelEvent);
	                })])], inlineAdditionalBehaviours(editor, isStickyToolbar$1, isToolbarLocationTop))),
	            isExtraPart: function (_comp, target) {
	              return isAlertOrConfirmDialog(target);
	            }
	          })));
	          inlineDialog.set(inlineDialogComp);
	          InlineView.showWithin(inlineDialogComp, anchor, premade$1(dialogUi.dialog), Optional.some(body()));
	          if (!isStickyToolbar$1 || !isToolbarLocationTop) {
	            Docking.refresh(inlineDialogComp);
	            editor.on('ResizeEditor', refreshDocking);
	          }
	          dialogUi.instanceApi.setData(initialData);
	          Keying.focusIn(dialogUi.dialog);
	          return dialogUi.instanceApi;
	        };
	        return DialogManager.open(factory, config$1);
	      };
	      var confirm = function (message, callback) {
	        confirmDialog.open(message, function (state) {
	          callback(state);
	        });
	      };
	      var alert = function (message, callback) {
	        alertDialog.open(message, function () {
	          callback();
	        });
	      };
	      var close = function (instanceApi) {
	        instanceApi.close();
	      };
	      return {
	        open: open,
	        openUrl: openUrl,
	        alert: alert,
	        close: close,
	        confirm: confirm
	      };
	    };
	
	    function Theme () {
	      global$1.add('silver', function (editor) {
	        var _a = setup$b(editor), uiMothership = _a.uiMothership, backstage = _a.backstage, renderUI = _a.renderUI, getUi = _a.getUi;
	        Autocompleter.register(editor, backstage.shared);
	        var windowMgr = setup$e({
	          editor: editor,
	          backstage: backstage
	        });
	        return {
	          renderUI: renderUI,
	          getWindowManagerImpl: constant(windowMgr),
	          getNotificationManagerImpl: function () {
	            return NotificationManagerImpl(editor, { backstage: backstage }, uiMothership);
	          },
	          ui: getUi()
	        };
	      });
	    }
	
	    Theme();
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/**
	 * Copyright (c) Tiny Technologies, Inc. All rights reserved.
	 * Licensed under the LGPL or a commercial license.
	 * For LGPL see License.txt in the project root for license information.
	 * For commercial licenses see https://www.tiny.cloud/
	 *
	 * Version: 5.8.0 (2021-05-06)
	 */
	(function () {
	    'use strict';
	
	    var typeOf = function (x) {
	      if (x === null) {
	        return 'null';
	      }
	      if (x === undefined) {
	        return 'undefined';
	      }
	      var t = typeof x;
	      if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      }
	      if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      }
	      return t;
	    };
	    var isEquatableType = function (x) {
	      return [
	        'undefined',
	        'boolean',
	        'number',
	        'string',
	        'function',
	        'xml',
	        'null'
	      ].indexOf(x) !== -1;
	    };
	
	    var sort = function (xs, compareFn) {
	      var clone = Array.prototype.slice.call(xs);
	      return clone.sort(compareFn);
	    };
	
	    var contramap = function (eqa, f) {
	      return eq(function (x, y) {
	        return eqa.eq(f(x), f(y));
	      });
	    };
	    var eq = function (f) {
	      return { eq: f };
	    };
	    var tripleEq = eq(function (x, y) {
	      return x === y;
	    });
	    var eqString = tripleEq;
	    var eqArray = function (eqa) {
	      return eq(function (x, y) {
	        if (x.length !== y.length) {
	          return false;
	        }
	        var len = x.length;
	        for (var i = 0; i < len; i++) {
	          if (!eqa.eq(x[i], y[i])) {
	            return false;
	          }
	        }
	        return true;
	      });
	    };
	    var eqSortedArray = function (eqa, compareFn) {
	      return contramap(eqArray(eqa), function (xs) {
	        return sort(xs, compareFn);
	      });
	    };
	    var eqRecord = function (eqa) {
	      return eq(function (x, y) {
	        var kx = Object.keys(x);
	        var ky = Object.keys(y);
	        if (!eqSortedArray(eqString).eq(kx, ky)) {
	          return false;
	        }
	        var len = kx.length;
	        for (var i = 0; i < len; i++) {
	          var q = kx[i];
	          if (!eqa.eq(x[q], y[q])) {
	            return false;
	          }
	        }
	        return true;
	      });
	    };
	    var eqAny = eq(function (x, y) {
	      if (x === y) {
	        return true;
	      }
	      var tx = typeOf(x);
	      var ty = typeOf(y);
	      if (tx !== ty) {
	        return false;
	      }
	      if (isEquatableType(tx)) {
	        return x === y;
	      } else if (tx === 'array') {
	        return eqArray(eqAny).eq(x, y);
	      } else if (tx === 'object') {
	        return eqRecord(eqAny).eq(x, y);
	      }
	      return false;
	    });
	
	    var typeOf$1 = function (x) {
	      var t = typeof x;
	      if (x === null) {
	        return 'null';
	      } else if (t === 'object' && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'Array')) {
	        return 'array';
	      } else if (t === 'object' && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === 'String')) {
	        return 'string';
	      } else {
	        return t;
	      }
	    };
	    var isType = function (type) {
	      return function (value) {
	        return typeOf$1(value) === type;
	      };
	    };
	    var isSimpleType = function (type) {
	      return function (value) {
	        return typeof value === type;
	      };
	    };
	    var eq$1 = function (t) {
	      return function (a) {
	        return t === a;
	      };
	    };
	    var isString = isType('string');
	    var isObject = isType('object');
	    var isArray = isType('array');
	    var isNull = eq$1(null);
	    var isBoolean = isSimpleType('boolean');
	    var isUndefined = eq$1(undefined);
	    var isNullable = function (a) {
	      return a === null || a === undefined;
	    };
	    var isNonNullable = function (a) {
	      return !isNullable(a);
	    };
	    var isFunction = isSimpleType('function');
	    var isNumber = isSimpleType('number');
	
	    var noop = function () {
	    };
	    var compose = function (fa, fb) {
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        return fa(fb.apply(null, args));
	      };
	    };
	    var compose1 = function (fbc, fab) {
	      return function (a) {
	        return fbc(fab(a));
	      };
	    };
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	    var identity = function (x) {
	      return x;
	    };
	    function curry(fn) {
	      var initialArgs = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        initialArgs[_i - 1] = arguments[_i];
	      }
	      return function () {
	        var restArgs = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          restArgs[_i] = arguments[_i];
	        }
	        var all = initialArgs.concat(restArgs);
	        return fn.apply(null, all);
	      };
	    }
	    var not = function (f) {
	      return function (t) {
	        return !f(t);
	      };
	    };
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	    var apply = function (f) {
	      return f();
	    };
	    var call = function (f) {
	      f();
	    };
	    var never = constant(false);
	    var always = constant(true);
	
	    var none = function () {
	      return NONE;
	    };
	    var NONE = function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	      var call = function (thunk) {
	        return thunk();
	      };
	      var id = function (n) {
	        return n;
	      };
	      var me = {
	        fold: function (n, _s) {
	          return n();
	        },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        getOrNull: constant(null),
	        getOrUndefined: constant(undefined),
	        or: id,
	        orThunk: call,
	        map: none,
	        each: noop,
	        bind: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () {
	          return [];
	        },
	        toString: constant('none()')
	      };
	      return me;
	    }();
	    var some = function (a) {
	      var constant_a = constant(a);
	      var self = function () {
	        return me;
	      };
	      var bind = function (f) {
	        return f(a);
	      };
	      var me = {
	        fold: function (n, s) {
	          return s(a);
	        },
	        is: function (v) {
	          return a === v;
	        },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        getOrNull: constant_a,
	        getOrUndefined: constant_a,
	        or: self,
	        orThunk: self,
	        map: function (f) {
	          return some(f(a));
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(never, function (b) {
	            return elementEq(a, b);
	          });
	        }
	      };
	      return me;
	    };
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	    var Optional = {
	      some: some,
	      none: none,
	      from: from
	    };
	
	    var nativeSlice = Array.prototype.slice;
	    var nativeIndexOf = Array.prototype.indexOf;
	    var nativePush = Array.prototype.push;
	    var rawIndexOf = function (ts, t) {
	      return nativeIndexOf.call(ts, t);
	    };
	    var indexOf = function (xs, x) {
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Optional.none() : Optional.some(r);
	    };
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	    var exists = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var map = function (xs, f) {
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i);
	      }
	      return r;
	    };
	    var each = function (xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i);
	      }
	    };
	    var partition = function (xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i) ? pass : fail;
	        arr.push(x);
	      }
	      return {
	        pass: pass,
	        fail: fail
	      };
	    };
	    var filter = function (xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	    var findUntil = function (xs, pred, until) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(x);
	        } else if (until(x, i)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var find = function (xs, pred) {
	      return findUntil(xs, pred, never);
	    };
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i)) {
	          return Optional.some(i);
	        }
	      }
	      return Optional.none();
	    };
	    var flatten = function (xs) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (!isArray(xs[i])) {
	          throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        }
	        nativePush.apply(r, xs[i]);
	      }
	      return r;
	    };
	    var bind = function (xs, f) {
	      return flatten(map(xs, f));
	    };
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	    var reverse = function (xs) {
	      var r = nativeSlice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	    var difference = function (a1, a2) {
	      return filter(a1, function (x) {
	        return !contains(a2, x);
	      });
	    };
	    var mapToObject = function (xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	    var sort$1 = function (xs, comparator) {
	      var copy = nativeSlice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	    var get = function (xs, i) {
	      return i >= 0 && i < xs.length ? Optional.some(xs[i]) : Optional.none();
	    };
	    var head = function (xs) {
	      return get(xs, 0);
	    };
	    var last = function (xs) {
	      return get(xs, xs.length - 1);
	    };
	    var from$1 = isFunction(Array.from) ? Array.from : function (x) {
	      return nativeSlice.call(x);
	    };
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Optional.none();
	    };
	
	    var keys = Object.keys;
	    var hasOwnProperty = Object.hasOwnProperty;
	    var each$1 = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i);
	      }
	    };
	    var map$1 = function (obj, f) {
	      return tupleMap(obj, function (x, i) {
	        return {
	          k: i,
	          v: f(x, i)
	        };
	      });
	    };
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        var tuple = f(x, i);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	    var objAcc = function (r) {
	      return function (x, i) {
	        r[i] = x;
	      };
	    };
	    var internalFilter = function (obj, pred, onTrue, onFalse) {
	      var r = {};
	      each$1(obj, function (x, i) {
	        (pred(x, i) ? onTrue : onFalse)(x, i);
	      });
	      return r;
	    };
	    var bifilter = function (obj, pred) {
	      var t = {};
	      var f = {};
	      internalFilter(obj, pred, objAcc(t), objAcc(f));
	      return {
	        t: t,
	        f: f
	      };
	    };
	    var filter$1 = function (obj, pred) {
	      var t = {};
	      internalFilter(obj, pred, objAcc(t), noop);
	      return t;
	    };
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each$1(obj, function (value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	    var values = function (obj) {
	      return mapToArray(obj, function (v) {
	        return v;
	      });
	    };
	    var get$1 = function (obj, key) {
	      return has(obj, key) ? Optional.from(obj[key]) : Optional.none();
	    };
	    var has = function (obj, key) {
	      return hasOwnProperty.call(obj, key);
	    };
	    var hasNonNullableKey = function (obj, key) {
	      return has(obj, key) && obj[key] !== undefined && obj[key] !== null;
	    };
	    var equal = function (a1, a2, eq) {
	      if (eq === void 0) {
	        eq = eqAny;
	      }
	      return eqRecord(eq).eq(a1, a2);
	    };
	
	    var isArray$1 = Array.isArray;
	    var toArray = function (obj) {
	      if (!isArray$1(obj)) {
	        var array = [];
	        for (var i = 0, l = obj.length; i < l; i++) {
	          array[i] = obj[i];
	        }
	        return array;
	      } else {
	        return obj;
	      }
	    };
	    var each$2 = function (o, cb, s) {
	      var n, l;
	      if (!o) {
	        return false;
	      }
	      s = s || o;
	      if (o.length !== undefined) {
	        for (n = 0, l = o.length; n < l; n++) {
	          if (cb.call(s, o[n], n, o) === false) {
	            return false;
	          }
	        }
	      } else {
	        for (n in o) {
	          if (o.hasOwnProperty(n)) {
	            if (cb.call(s, o[n], n, o) === false) {
	              return false;
	            }
	          }
	        }
	      }
	      return true;
	    };
	    var map$2 = function (array, callback) {
	      var out = [];
	      each$2(array, function (item, index) {
	        out.push(callback(item, index, array));
	      });
	      return out;
	    };
	    var filter$2 = function (a, f) {
	      var o = [];
	      each$2(a, function (v, index) {
	        if (!f || f(v, index, a)) {
	          o.push(v);
	        }
	      });
	      return o;
	    };
	    var indexOf$1 = function (a, v) {
	      if (a) {
	        for (var i = 0, l = a.length; i < l; i++) {
	          if (a[i] === v) {
	            return i;
	          }
	        }
	      }
	      return -1;
	    };
	    var reduce = function (collection, iteratee, accumulator, thisArg) {
	      var acc = isUndefined(accumulator) ? collection[0] : accumulator;
	      for (var i = 0; i < collection.length; i++) {
	        acc = iteratee.call(thisArg, acc, collection[i], i);
	      }
	      return acc;
	    };
	    var findIndex$1 = function (array, predicate, thisArg) {
	      var i, l;
	      for (i = 0, l = array.length; i < l; i++) {
	        if (predicate.call(thisArg, array[i], i, array)) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var last$1 = function (collection) {
	      return collection[collection.length - 1];
	    };
	
	    var __assign = function () {
	      __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	          s = arguments[i];
	          for (var p in s)
	            if (Object.prototype.hasOwnProperty.call(s, p))
	              t[p] = s[p];
	        }
	        return t;
	      };
	      return __assign.apply(this, arguments);
	    };
	    function __rest(s, e) {
	      var t = {};
	      for (var p in s)
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	          t[p] = s[p];
	      if (s != null && typeof Object.getOwnPropertySymbols === 'function')
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	            t[p[i]] = s[p[i]];
	        }
	      return t;
	    }
	    function __spreadArrays() {
	      for (var s = 0, i = 0, il = arguments.length; i < il; i++)
	        s += arguments[i].length;
	      for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	          r[k] = a[j];
	      return r;
	    }
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!called) {
	          called = true;
	          r = f.apply(null, args);
	        }
	        return r;
	      };
	    };
	
	    var DeviceType = function (os, browser, userAgent, mediaMatch) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isMobile = os.isiOS() || os.isAndroid();
	      var isTouch = isMobile || mediaMatch('(pointer:coarse)');
	      var isTablet = isiPad || !isiPhone && isMobile && mediaMatch('(min-device-width:768px)');
	      var isPhone = isiPhone || isMobile && !isTablet;
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	      var isDesktop = !isPhone && !isTablet && !iOSwebview;
	      return {
	        isiPad: constant(isiPad),
	        isiPhone: constant(isiPhone),
	        isTablet: constant(isTablet),
	        isPhone: constant(isPhone),
	        isTouch: constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: constant(iOSwebview),
	        isDesktop: constant(isDesktop)
	      };
	    };
	
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) {
	          return x;
	        }
	      }
	      return undefined;
	    };
	    var find$1 = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) {
	        return {
	          major: 0,
	          minor: 0
	        };
	      }
	      var group = function (i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	      if (versionRegexes.length === 0) {
	        return unknown();
	      }
	      return find$1(versionRegexes, cleanedAgent);
	    };
	    var unknown = function () {
	      return nu(0, 0);
	    };
	    var nu = function (major, minor) {
	      return {
	        major: major,
	        minor: minor
	      };
	    };
	    var Version = {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	
	    var detect$1 = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	    var detectBrowser = function (browsers, userAgent) {
	      return detect$1(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	    var detectOs = function (oses, userAgent) {
	      return detect$1(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	    var UaString = {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	
	    var removeFromStart = function (str, numChars) {
	      return str.substring(numChars);
	    };
	
	    var checkRange = function (str, substr, start) {
	      return substr === '' || str.length >= substr.length && str.substr(start, start + substr.length) === substr;
	    };
	    var removeLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? removeFromStart(str, prefix.length) : str;
	    };
	    var contains$1 = function (str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	    var startsWith = function (str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	    var blank = function (r) {
	      return function (s) {
	        return s.replace(r, '');
	      };
	    };
	    var trim = blank(/^\s+|\s+$/g);
	    var lTrim = blank(/^\s+/g);
	    var rTrim = blank(/\s+$/g);
	    var isNotEmpty = function (s) {
	      return s.length > 0;
	    };
	
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	    var checkContains = function (target) {
	      return function (uastring) {
	        return contains$1(uastring, target);
	      };
	    };
	    var browsers = [
	      {
	        name: 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          return contains$1(uastring, 'edge/') && contains$1(uastring, 'chrome') && contains$1(uastring, 'safari') && contains$1(uastring, 'applewebkit');
	        }
	      },
	      {
	        name: 'Chrome',
	        versionRegexes: [
	          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
	          normalVersionRegex
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'chrome') && !contains$1(uastring, 'chromeframe');
	        }
	      },
	      {
	        name: 'IE',
	        versionRegexes: [
	          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
	          /.*?rv:([0-9]+)\.([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return contains$1(uastring, 'msie') || contains$1(uastring, 'trident');
	        }
	      },
	      {
	        name: 'Opera',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?opera\/([0-9]+)\.([0-9]+).*/
	        ],
	        search: checkContains('opera')
	      },
	      {
	        name: 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search: checkContains('firefox')
	      },
	      {
	        name: 'Safari',
	        versionRegexes: [
	          normalVersionRegex,
	          /.*?cpu os ([0-9]+)_([0-9]+).*/
	        ],
	        search: function (uastring) {
	          return (contains$1(uastring, 'safari') || contains$1(uastring, 'mobile/')) && contains$1(uastring, 'applewebkit');
	        }
	      }
	    ];
	    var oses = [
	      {
	        name: 'Windows',
	        search: checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'iOS',
	        search: function (uastring) {
	          return contains$1(uastring, 'iphone') || contains$1(uastring, 'ipad');
	        },
	        versionRegexes: [
	          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
	          /.*cpu os ([0-9]+)_([0-9]+).*/,
	          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
	        ]
	      },
	      {
	        name: 'Android',
	        search: checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name: 'OSX',
	        search: checkContains('mac os x'),
	        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name: 'Linux',
	        search: checkContains('linux'),
	        versionRegexes: []
	      },
	      {
	        name: 'Solaris',
	        search: checkContains('sunos'),
	        versionRegexes: []
	      },
	      {
	        name: 'FreeBSD',
	        search: checkContains('freebsd'),
	        versionRegexes: []
	      },
	      {
	        name: 'ChromeOS',
	        search: checkContains('cros'),
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
	      }
	    ];
	    var PlatformInfo = {
	      browsers: constant(browsers),
	      oses: constant(oses)
	    };
	
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	    var unknown$1 = function () {
	      return nu$1({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$1 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isBrowser = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isEdge: isBrowser(edge),
	        isChrome: isBrowser(chrome),
	        isIE: isBrowser(ie),
	        isOpera: isBrowser(opera),
	        isFirefox: isBrowser(firefox),
	        isSafari: isBrowser(safari)
	      };
	    };
	    var Browser = {
	      unknown: unknown$1,
	      nu: nu$1,
	      edge: constant(edge),
	      chrome: constant(chrome),
	      ie: constant(ie),
	      opera: constant(opera),
	      firefox: constant(firefox),
	      safari: constant(safari)
	    };
	
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	    var chromeos = 'ChromeOS';
	    var unknown$2 = function () {
	      return nu$2({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	    var nu$2 = function (info) {
	      var current = info.current;
	      var version = info.version;
	      var isOS = function (name) {
	        return function () {
	          return current === name;
	        };
	      };
	      return {
	        current: current,
	        version: version,
	        isWindows: isOS(windows),
	        isiOS: isOS(ios),
	        isAndroid: isOS(android),
	        isOSX: isOS(osx),
	        isLinux: isOS(linux),
	        isSolaris: isOS(solaris),
	        isFreeBSD: isOS(freebsd),
	        isChromeOS: isOS(chromeos)
	      };
	    };
	    var OperatingSystem = {
	      unknown: unknown$2,
	      nu: nu$2,
	      windows: constant(windows),
	      ios: constant(ios),
	      android: constant(android),
	      linux: constant(linux),
	      osx: constant(osx),
	      solaris: constant(solaris),
	      freebsd: constant(freebsd),
	      chromeos: constant(chromeos)
	    };
	
	    var detect$2 = function (userAgent, mediaMatch) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(Browser.unknown, Browser.nu);
	      var os = UaString.detectOs(oses, userAgent).fold(OperatingSystem.unknown, OperatingSystem.nu);
	      var deviceType = DeviceType(os, browser, userAgent, mediaMatch);
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	    var PlatformDetection = { detect: detect$2 };
	
	    var mediaMatch = function (query) {
	      return window.matchMedia(query).matches;
	    };
	    var platform = cached(function () {
	      return PlatformDetection.detect(navigator.userAgent, mediaMatch);
	    });
	    var detect$3 = function () {
	      return platform();
	    };
	
	    var userAgent = navigator.userAgent;
	    var platform$1 = detect$3();
	    var browser = platform$1.browser;
	    var os = platform$1.os;
	    var deviceType = platform$1.deviceType;
	    var webkit = /WebKit/.test(userAgent) && !browser.isEdge();
	    var fileApi = 'FormData' in window && 'FileReader' in window && 'URL' in window && !!URL.createObjectURL;
	    var windowsPhone = userAgent.indexOf('Windows Phone') !== -1;
	    var Env = {
	      opera: browser.isOpera(),
	      webkit: webkit,
	      ie: browser.isIE() || browser.isEdge() ? browser.version.major : false,
	      gecko: browser.isFirefox(),
	      mac: os.isOSX() || os.isiOS(),
	      iOS: deviceType.isiPad() || deviceType.isiPhone(),
	      android: os.isAndroid(),
	      contentEditable: true,
	      transparentSrc: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
	      caretAfter: true,
	      range: window.getSelection && 'Range' in window,
	      documentMode: browser.isIE() ? document.documentMode || 7 : 10,
	      fileApi: fileApi,
	      ceFalse: true,
	      cacheSuffix: null,
	      container: null,
	      experimentalShadowDom: false,
	      canHaveCSP: !browser.isIE(),
	      desktop: deviceType.isDesktop(),
	      windowsPhone: windowsPhone,
	      browser: {
	        current: browser.current,
	        version: browser.version,
	        isChrome: browser.isChrome,
	        isEdge: browser.isEdge,
	        isFirefox: browser.isFirefox,
	        isIE: browser.isIE,
	        isOpera: browser.isOpera,
	        isSafari: browser.isSafari
	      },
	      os: {
	        current: os.current,
	        version: os.version,
	        isAndroid: os.isAndroid,
	        isChromeOS: os.isChromeOS,
	        isFreeBSD: os.isFreeBSD,
	        isiOS: os.isiOS,
	        isLinux: os.isLinux,
	        isOSX: os.isOSX,
	        isSolaris: os.isSolaris,
	        isWindows: os.isWindows
	      },
	      deviceType: {
	        isDesktop: deviceType.isDesktop,
	        isiPad: deviceType.isiPad,
	        isiPhone: deviceType.isiPhone,
	        isPhone: deviceType.isPhone,
	        isTablet: deviceType.isTablet,
	        isTouch: deviceType.isTouch,
	        isWebView: deviceType.isWebView
	      }
	    };
	
	    var whiteSpaceRegExp = /^\s*|\s*$/g;
	    var trim$1 = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp, '');
	    };
	    var is = function (obj, type) {
	      if (!type) {
	        return obj !== undefined;
	      }
	      if (type === 'array' && isArray$1(obj)) {
	        return true;
	      }
	      return typeof obj === type;
	    };
	    var makeMap = function (items, delim, map) {
	      var i;
	      items = items || [];
	      delim = delim || ',';
	      if (typeof items === 'string') {
	        items = items.split(delim);
	      }
	      map = map || {};
	      i = items.length;
	      while (i--) {
	        map[items[i]] = {};
	      }
	      return map;
	    };
	    var hasOwnProperty$1 = function (obj, prop) {
	      return Object.prototype.hasOwnProperty.call(obj, prop);
	    };
	    var create = function (s, p, root) {
	      var self = this;
	      var sp, scn, c, de = 0;
	      s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
	      var cn = s[3].match(/(^|\.)(\w+)$/i)[2];
	      var ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
	      if (ns[cn]) {
	        return;
	      }
	      if (s[2] === 'static') {
	        ns[cn] = p;
	        if (this.onCreate) {
	          this.onCreate(s[2], s[3], ns[cn]);
	        }
	        return;
	      }
	      if (!p[cn]) {
	        p[cn] = function () {
	        };
	        de = 1;
	      }
	      ns[cn] = p[cn];
	      self.extend(ns[cn].prototype, p);
	      if (s[5]) {
	        sp = self.resolve(s[5]).prototype;
	        scn = s[5].match(/\.(\w+)$/i)[1];
	        c = ns[cn];
	        if (de) {
	          ns[cn] = function () {
	            return sp[scn].apply(this, arguments);
	          };
	        } else {
	          ns[cn] = function () {
	            this.parent = sp[scn];
	            return c.apply(this, arguments);
	          };
	        }
	        ns[cn].prototype[cn] = ns[cn];
	        self.each(sp, function (f, n) {
	          ns[cn].prototype[n] = sp[n];
	        });
	        self.each(p, function (f, n) {
	          if (sp[n]) {
	            ns[cn].prototype[n] = function () {
	              this.parent = sp[n];
	              return f.apply(this, arguments);
	            };
	          } else {
	            if (n !== cn) {
	              ns[cn].prototype[n] = f;
	            }
	          }
	        });
	      }
	      self.each(p.static, function (f, n) {
	        ns[cn][n] = f;
	      });
	    };
	    var extend = function (obj) {
	      var exts = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        exts[_i - 1] = arguments[_i];
	      }
	      for (var i = 0; i < exts.length; i++) {
	        var ext = exts[i];
	        for (var name_1 in ext) {
	          if (ext.hasOwnProperty(name_1)) {
	            var value = ext[name_1];
	            if (value !== undefined) {
	              obj[name_1] = value;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var walk = function (o, f, n, s) {
	      s = s || this;
	      if (o) {
	        if (n) {
	          o = o[n];
	        }
	        each$2(o, function (o, i) {
	          if (f.call(s, o, i, n) === false) {
	            return false;
	          }
	          walk(o, f, n, s);
	        });
	      }
	    };
	    var createNS = function (n, o) {
	      var i, v;
	      o = o || window;
	      n = n.split('.');
	      for (i = 0; i < n.length; i++) {
	        v = n[i];
	        if (!o[v]) {
	          o[v] = {};
	        }
	        o = o[v];
	      }
	      return o;
	    };
	    var resolve = function (n, o) {
	      var i, l;
	      o = o || window;
	      n = n.split('.');
	      for (i = 0, l = n.length; i < l; i++) {
	        o = o[n[i]];
	        if (!o) {
	          break;
	        }
	      }
	      return o;
	    };
	    var explode = function (s, d) {
	      if (!s || is(s, 'array')) {
	        return s;
	      }
	      return map$2(s.split(d || ','), trim$1);
	    };
	    var _addCacheSuffix = function (url) {
	      var cacheSuffix = Env.cacheSuffix;
	      if (cacheSuffix) {
	        url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
	      }
	      return url;
	    };
	    var Tools = {
	      trim: trim$1,
	      isArray: isArray$1,
	      is: is,
	      toArray: toArray,
	      makeMap: makeMap,
	      each: each$2,
	      map: map$2,
	      grep: filter$2,
	      inArray: indexOf$1,
	      hasOwn: hasOwnProperty$1,
	      extend: extend,
	      create: create,
	      walk: walk,
	      createNS: createNS,
	      resolve: resolve,
	      explode: explode,
	      _addCacheSuffix: _addCacheSuffix
	    };
	
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw new Error('HTML must have a single root node');
	      }
	      return fromDom(div.childNodes[0]);
	    };
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	    var fromDom = function (node) {
	      if (node === null || node === undefined) {
	        throw new Error('Node cannot be null or undefined');
	      }
	      return { dom: node };
	    };
	    var fromPoint = function (docElm, x, y) {
	      return Optional.from(docElm.dom.elementFromPoint(x, y)).map(fromDom);
	    };
	    var SugarElement = {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	
	    var toArray$1 = function (target, f) {
	      var r = [];
	      var recurse = function (e) {
	        r.push(e);
	        return f(e);
	      };
	      var cur = f(target);
	      do {
	        cur = cur.bind(recurse);
	      } while (cur.isSome());
	      return r;
	    };
	
	    var compareDocumentPosition = function (a, b, match) {
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, Node.DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    var COMMENT = 8;
	    var DOCUMENT = 9;
	    var DOCUMENT_FRAGMENT = 11;
	    var ELEMENT = 1;
	    var TEXT = 3;
	
	    var is$1 = function (element, selector) {
	      var dom = element.dom;
	      if (dom.nodeType !== ELEMENT) {
	        return false;
	      } else {
	        var elem = dom;
	        if (elem.matches !== undefined) {
	          return elem.matches(selector);
	        } else if (elem.msMatchesSelector !== undefined) {
	          return elem.msMatchesSelector(selector);
	        } else if (elem.webkitMatchesSelector !== undefined) {
	          return elem.webkitMatchesSelector(selector);
	        } else if (elem.mozMatchesSelector !== undefined) {
	          return elem.mozMatchesSelector(selector);
	        } else {
	          throw new Error('Browser lacks native selectors');
	        }
	      }
	    };
	    var bypassSelector = function (dom) {
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT && dom.nodeType !== DOCUMENT_FRAGMENT || dom.childElementCount === 0;
	    };
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? [] : map(base.querySelectorAll(selector), SugarElement.fromDom);
	    };
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom;
	      return bypassSelector(base) ? Optional.none() : Optional.from(base.querySelector(selector)).map(SugarElement.fromDom);
	    };
	
	    var eq$2 = function (e1, e2) {
	      return e1.dom === e2.dom;
	    };
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom;
	      var d2 = e2.dom;
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	    var ieContains = function (e1, e2) {
	      return documentPositionContainedBy(e1.dom, e2.dom);
	    };
	    var contains$2 = function (e1, e2) {
	      return detect$3().browser.isIE() ? ieContains(e1, e2) : regularContains(e1, e2);
	    };
	
	    var Global = typeof window !== 'undefined' ? window : Function('return this;')();
	
	    var name = function (element) {
	      var r = element.dom.nodeName;
	      return r.toLowerCase();
	    };
	    var type = function (element) {
	      return element.dom.nodeType;
	    };
	    var isType$1 = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	    var isComment = function (element) {
	      return type(element) === COMMENT || name(element) === '#comment';
	    };
	    var isElement = isType$1(ELEMENT);
	    var isText = isType$1(TEXT);
	    var isDocument = isType$1(DOCUMENT);
	    var isDocumentFragment = isType$1(DOCUMENT_FRAGMENT);
	
	    var owner = function (element) {
	      return SugarElement.fromDom(element.dom.ownerDocument);
	    };
	    var documentOrOwner = function (dos) {
	      return isDocument(dos) ? dos : owner(dos);
	    };
	    var documentElement = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.documentElement);
	    };
	    var defaultView = function (element) {
	      return SugarElement.fromDom(documentOrOwner(element).dom.defaultView);
	    };
	    var parent = function (element) {
	      return Optional.from(element.dom.parentNode).map(SugarElement.fromDom);
	    };
	    var parents = function (element, isRoot) {
	      var stop = isFunction(isRoot) ? isRoot : never;
	      var dom = element.dom;
	      var ret = [];
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var p = SugarElement.fromDom(rawParent);
	        ret.push(p);
	        if (stop(p) === true) {
	          break;
	        } else {
	          dom = rawParent;
	        }
	      }
	      return ret;
	    };
	    var siblings = function (element) {
	      var filterSelf = function (elements) {
	        return filter(elements, function (x) {
	          return !eq$2(element, x);
	        });
	      };
	      return parent(element).map(children).map(filterSelf).getOr([]);
	    };
	    var prevSibling = function (element) {
	      return Optional.from(element.dom.previousSibling).map(SugarElement.fromDom);
	    };
	    var nextSibling = function (element) {
	      return Optional.from(element.dom.nextSibling).map(SugarElement.fromDom);
	    };
	    var prevSiblings = function (element) {
	      return reverse(toArray$1(element, prevSibling));
	    };
	    var nextSiblings = function (element) {
	      return toArray$1(element, nextSibling);
	    };
	    var children = function (element) {
	      return map(element.dom.childNodes, SugarElement.fromDom);
	    };
	    var child = function (element, index) {
	      var cs = element.dom.childNodes;
	      return Optional.from(cs[index]).map(SugarElement.fromDom);
	    };
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	    var lastChild = function (element) {
	      return child(element, element.dom.childNodes.length - 1);
	    };
	    var childNodesCount = function (element) {
	      return element.dom.childNodes.length;
	    };
	
	    var getHead = function (doc) {
	      var b = doc.dom.head;
	      if (b === null || b === undefined) {
	        throw new Error('Head is not available yet');
	      }
	      return SugarElement.fromDom(b);
	    };
	
	    var isShadowRoot = function (dos) {
	      return isDocumentFragment(dos) && isNonNullable(dos.dom.host);
	    };
	    var supported = isFunction(Element.prototype.attachShadow) && isFunction(Node.prototype.getRootNode);
	    var isSupported = constant(supported);
	    var getRootNode = supported ? function (e) {
	      return SugarElement.fromDom(e.dom.getRootNode());
	    } : documentOrOwner;
	    var getStyleContainer = function (dos) {
	      return isShadowRoot(dos) ? dos : getHead(documentOrOwner(dos));
	    };
	    var getShadowRoot = function (e) {
	      var r = getRootNode(e);
	      return isShadowRoot(r) ? Optional.some(r) : Optional.none();
	    };
	    var getShadowHost = function (e) {
	      return SugarElement.fromDom(e.dom.host);
	    };
	    var getOriginalEventTarget = function (event) {
	      if (isSupported() && isNonNullable(event.target)) {
	        var el = SugarElement.fromDom(event.target);
	        if (isElement(el) && isOpenShadowHost(el)) {
	          if (event.composed && event.composedPath) {
	            var composedPath = event.composedPath();
	            if (composedPath) {
	              return head(composedPath);
	            }
	          }
	        }
	      }
	      return Optional.from(event.target);
	    };
	    var isOpenShadowHost = function (element) {
	      return isNonNullable(element.dom.shadowRoot);
	    };
	
	    var before = function (marker, element) {
	      var parent$1 = parent(marker);
	      parent$1.each(function (v) {
	        v.dom.insertBefore(element.dom, marker.dom);
	      });
	    };
	    var after = function (marker, element) {
	      var sibling = nextSibling(marker);
	      sibling.fold(function () {
	        var parent$1 = parent(marker);
	        parent$1.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	    var prepend = function (parent, element) {
	      var firstChild$1 = firstChild(parent);
	      firstChild$1.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom.insertBefore(element.dom, v.dom);
	      });
	    };
	    var append = function (parent, element) {
	      parent.dom.appendChild(element.dom);
	    };
	    var wrap = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    var before$1 = function (marker, elements) {
	      each(elements, function (x) {
	        before(marker, x);
	      });
	    };
	    var append$1 = function (parent, elements) {
	      each(elements, function (x) {
	        append(parent, x);
	      });
	    };
	
	    var empty = function (element) {
	      element.dom.textContent = '';
	      each(children(element), function (rogue) {
	        remove(rogue);
	      });
	    };
	    var remove = function (element) {
	      var dom = element.dom;
	      if (dom.parentNode !== null) {
	        dom.parentNode.removeChild(dom);
	      }
	    };
	    var unwrap = function (wrapper) {
	      var children$1 = children(wrapper);
	      if (children$1.length > 0) {
	        before$1(wrapper, children$1);
	      }
	      remove(wrapper);
	    };
	
	    var inBody = function (element) {
	      var dom = isText(element) ? element.dom.parentNode : element.dom;
	      if (dom === undefined || dom === null || dom.ownerDocument === null) {
	        return false;
	      }
	      var doc = dom.ownerDocument;
	      return getShadowRoot(SugarElement.fromDom(dom)).fold(function () {
	        return doc.body.contains(dom);
	      }, compose1(inBody, getShadowHost));
	    };
	
	    var r = function (left, top) {
	      var translate = function (x, y) {
	        return r(left + x, top + y);
	      };
	      return {
	        left: left,
	        top: top,
	        translate: translate
	      };
	    };
	    var SugarPosition = r;
	
	    var boxPosition = function (dom) {
	      var box = dom.getBoundingClientRect();
	      return SugarPosition(box.left, box.top);
	    };
	    var firstDefinedOrZero = function (a, b) {
	      if (a !== undefined) {
	        return a;
	      } else {
	        return b !== undefined ? b : 0;
	      }
	    };
	    var absolute = function (element) {
	      var doc = element.dom.ownerDocument;
	      var body = doc.body;
	      var win = doc.defaultView;
	      var html = doc.documentElement;
	      if (body === element.dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      var scrollTop = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageYOffset, html.scrollTop);
	      var scrollLeft = firstDefinedOrZero(win === null || win === void 0 ? void 0 : win.pageXOffset, html.scrollLeft);
	      var clientTop = firstDefinedOrZero(html.clientTop, body.clientTop);
	      var clientLeft = firstDefinedOrZero(html.clientLeft, body.clientLeft);
	      return viewport(element).translate(scrollLeft - clientLeft, scrollTop - clientTop);
	    };
	    var viewport = function (element) {
	      var dom = element.dom;
	      var doc = dom.ownerDocument;
	      var body = doc.body;
	      if (body === dom) {
	        return SugarPosition(body.offsetLeft, body.offsetTop);
	      }
	      if (!inBody(element)) {
	        return SugarPosition(0, 0);
	      }
	      return boxPosition(dom);
	    };
	
	    var get$2 = function (_DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var x = doc.body.scrollLeft || doc.documentElement.scrollLeft;
	      var y = doc.body.scrollTop || doc.documentElement.scrollTop;
	      return SugarPosition(x, y);
	    };
	    var to = function (x, y, _DOC) {
	      var doc = _DOC !== undefined ? _DOC.dom : document;
	      var win = doc.defaultView;
	      if (win) {
	        win.scrollTo(x, y);
	      }
	    };
	    var intoView = function (element, alignToTop) {
	      var isSafari = detect$3().browser.isSafari();
	      if (isSafari && isFunction(element.dom.scrollIntoViewIfNeeded)) {
	        element.dom.scrollIntoViewIfNeeded(false);
	      } else {
	        element.dom.scrollIntoView(alignToTop);
	      }
	    };
	
	    var get$3 = function (_win) {
	      var win = _win === undefined ? window : _win;
	      return Optional.from(win['visualViewport']);
	    };
	    var bounds = function (x, y, width, height) {
	      return {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        right: x + width,
	        bottom: y + height
	      };
	    };
	    var getBounds = function (_win) {
	      var win = _win === undefined ? window : _win;
	      var doc = win.document;
	      var scroll = get$2(SugarElement.fromDom(doc));
	      return get$3(win).fold(function () {
	        var html = win.document.documentElement;
	        var width = html.clientWidth;
	        var height = html.clientHeight;
	        return bounds(scroll.left, scroll.top, width, height);
	      }, function (visualViewport) {
	        return bounds(Math.max(visualViewport.pageLeft, scroll.left), Math.max(visualViewport.pageTop, scroll.top), visualViewport.width, visualViewport.height);
	      });
	    };
	
	    var isNodeType = function (type) {
	      return function (node) {
	        return !!node && node.nodeType === type;
	      };
	    };
	    var isRestrictedNode = function (node) {
	      return !!node && !Object.getPrototypeOf(node);
	    };
	    var isElement$1 = isNodeType(1);
	    var matchNodeNames = function (names) {
	      var lowercasedNames = names.map(function (s) {
	        return s.toLowerCase();
	      });
	      return function (node) {
	        if (node && node.nodeName) {
	          var nodeName = node.nodeName.toLowerCase();
	          return contains(lowercasedNames, nodeName);
	        }
	        return false;
	      };
	    };
	    var matchStyleValues = function (name, values) {
	      var items = values.toLowerCase().split(' ');
	      return function (node) {
	        var i, cssValue;
	        if (isElement$1(node)) {
	          for (i = 0; i < items.length; i++) {
	            var computed = node.ownerDocument.defaultView.getComputedStyle(node, null);
	            cssValue = computed ? computed.getPropertyValue(name) : null;
	            if (cssValue === items[i]) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	    };
	    var hasAttribute = function (attrName) {
	      return function (node) {
	        return isElement$1(node) && node.hasAttribute(attrName);
	      };
	    };
	    var hasAttributeValue = function (attrName, attrValue) {
	      return function (node) {
	        return isElement$1(node) && node.getAttribute(attrName) === attrValue;
	      };
	    };
	    var isBogus = function (node) {
	      return isElement$1(node) && node.hasAttribute('data-mce-bogus');
	    };
	    var isBogusAll = function (node) {
	      return isElement$1(node) && node.getAttribute('data-mce-bogus') === 'all';
	    };
	    var isTable = function (node) {
	      return isElement$1(node) && node.tagName === 'TABLE';
	    };
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement$1(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var isTextareaOrInput = matchNodeNames([
	      'textarea',
	      'input'
	    ]);
	    var isText$1 = isNodeType(3);
	    var isComment$1 = isNodeType(8);
	    var isDocument$1 = isNodeType(9);
	    var isDocumentFragment$1 = isNodeType(11);
	    var isBr = matchNodeNames(['br']);
	    var isImg = matchNodeNames(['img']);
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	    var isTableCell = matchNodeNames([
	      'td',
	      'th'
	    ]);
	    var isMedia = matchNodeNames([
	      'video',
	      'audio',
	      'object',
	      'embed'
	    ]);
	
	    var isSupported$1 = function (dom) {
	      return dom.style !== undefined && isFunction(dom.style.getPropertyValue);
	    };
	
	    var rawSet = function (dom, key, value) {
	      if (isString(value) || isBoolean(value) || isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attribute.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	    var set = function (element, key, value) {
	      rawSet(element.dom, key, value);
	    };
	    var setAll = function (element, attrs) {
	      var dom = element.dom;
	      each$1(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	    var get$4 = function (element, key) {
	      var v = element.dom.getAttribute(key);
	      return v === null ? undefined : v;
	    };
	    var getOpt = function (element, key) {
	      return Optional.from(get$4(element, key));
	    };
	    var has$1 = function (element, key) {
	      var dom = element.dom;
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	    var remove$1 = function (element, key) {
	      element.dom.removeAttribute(key);
	    };
	    var clone = function (element) {
	      return foldl(element.dom.attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var internalSet = function (dom, property, value) {
	      if (!isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	      if (isSupported$1(dom)) {
	        dom.style.setProperty(property, value);
	      }
	    };
	    var setAll$1 = function (element, css) {
	      var dom = element.dom;
	      each$1(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	    var get$5 = function (element, property) {
	      var dom = element.dom;
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	      return r === '' && !inBody(element) ? getUnsafeProperty(dom, property) : r;
	    };
	    var getUnsafeProperty = function (dom, property) {
	      return isSupported$1(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	    var getRaw = function (element, property) {
	      var dom = element.dom;
	      var raw = getUnsafeProperty(dom, property);
	      return Optional.from(raw).filter(function (r) {
	        return r.length > 0;
	      });
	    };
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom;
	      if (isSupported$1(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	    var reflow = function (e) {
	      return e.dom.offsetWidth;
	    };
	
	    var browser$1 = detect$3().browser;
	    var firstElement = function (nodes) {
	      return find(nodes, isElement);
	    };
	    var getTableCaptionDeltaY = function (elm) {
	      if (browser$1.isFirefox() && name(elm) === 'table') {
	        return firstElement(children(elm)).filter(function (elm) {
	          return name(elm) === 'caption';
	        }).bind(function (caption) {
	          return firstElement(nextSiblings(caption)).map(function (body) {
	            var bodyTop = body.dom.offsetTop;
	            var captionTop = caption.dom.offsetTop;
	            var captionHeight = caption.dom.offsetHeight;
	            return bodyTop <= captionTop ? -captionHeight : 0;
	          });
	        }).getOr(0);
	      } else {
	        return 0;
	      }
	    };
	    var hasChild = function (elm, child) {
	      return elm.children && contains(elm.children, child);
	    };
	    var getPos = function (body, elm, rootElm) {
	      var x = 0, y = 0, offsetParent;
	      var doc = body.ownerDocument;
	      var pos;
	      rootElm = rootElm ? rootElm : body;
	      if (elm) {
	        if (rootElm === body && elm.getBoundingClientRect && get$5(SugarElement.fromDom(body), 'position') === 'static') {
	          pos = elm.getBoundingClientRect();
	          x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
	          y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
	          return {
	            x: x,
	            y: y
	          };
	        }
	        offsetParent = elm;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType && !hasChild(offsetParent, rootElm)) {
	          x += offsetParent.offsetLeft || 0;
	          y += offsetParent.offsetTop || 0;
	          offsetParent = offsetParent.offsetParent;
	        }
	        offsetParent = elm.parentNode;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType && !hasChild(offsetParent, rootElm)) {
	          x -= offsetParent.scrollLeft || 0;
	          y -= offsetParent.scrollTop || 0;
	          offsetParent = offsetParent.parentNode;
	        }
	        y += getTableCaptionDeltaY(SugarElement.fromDom(elm));
	      }
	      return {
	        x: x,
	        y: y
	      };
	    };
	
	    var exports$1 = {}, module$1 = { exports: exports$1 };
	    (function (define, exports, module, require) {
	      (function (f) {
	        if (typeof exports === 'object' && typeof module !== 'undefined') {
	          module.exports = f();
	        } else if (typeof define === 'function' && define.amd) {
	          define([], f);
	        } else {
	          var g;
	          if (typeof window !== 'undefined') {
	            g = window;
	          } else if (typeof global !== 'undefined') {
	            g = global;
	          } else if (typeof self !== 'undefined') {
	            g = self;
	          } else {
	            g = this;
	          }
	          g.EphoxContactWrapper = f();
	        }
	      }(function () {
	        return function () {
	          function r(e, n, t) {
	            function o(i, f) {
	              if (!n[i]) {
	                if (!e[i]) {
	                  var c = 'function' == typeof require && require;
	                  if (!f && c)
	                    return c(i, !0);
	                  if (u)
	                    return u(i, !0);
	                  var a = new Error('Cannot find module \'' + i + '\'');
	                  throw a.code = 'MODULE_NOT_FOUND', a;
	                }
	                var p = n[i] = { exports: {} };
	                e[i][0].call(p.exports, function (r) {
	                  var n = e[i][1][r];
	                  return o(n || r);
	                }, p, p.exports, r, e, n, t);
	              }
	              return n[i].exports;
	            }
	            for (var u = 'function' == typeof require && require, i = 0; i < t.length; i++)
	              o(t[i]);
	            return o;
	          }
	          return r;
	        }()({
	          1: [
	            function (require, module, exports) {
	              var process = module.exports = {};
	              var cachedSetTimeout;
	              var cachedClearTimeout;
	              function defaultSetTimout() {
	                throw new Error('setTimeout has not been defined');
	              }
	              function defaultClearTimeout() {
	                throw new Error('clearTimeout has not been defined');
	              }
	              (function () {
	                try {
	                  if (typeof setTimeout === 'function') {
	                    cachedSetTimeout = setTimeout;
	                  } else {
	                    cachedSetTimeout = defaultSetTimout;
	                  }
	                } catch (e) {
	                  cachedSetTimeout = defaultSetTimout;
	                }
	                try {
	                  if (typeof clearTimeout === 'function') {
	                    cachedClearTimeout = clearTimeout;
	                  } else {
	                    cachedClearTimeout = defaultClearTimeout;
	                  }
	                } catch (e) {
	                  cachedClearTimeout = defaultClearTimeout;
	                }
	              }());
	              function runTimeout(fun) {
	                if (cachedSetTimeout === setTimeout) {
	                  return setTimeout(fun, 0);
	                }
	                if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	                  cachedSetTimeout = setTimeout;
	                  return setTimeout(fun, 0);
	                }
	                try {
	                  return cachedSetTimeout(fun, 0);
	                } catch (e) {
	                  try {
	                    return cachedSetTimeout.call(null, fun, 0);
	                  } catch (e) {
	                    return cachedSetTimeout.call(this, fun, 0);
	                  }
	                }
	              }
	              function runClearTimeout(marker) {
	                if (cachedClearTimeout === clearTimeout) {
	                  return clearTimeout(marker);
	                }
	                if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	                  cachedClearTimeout = clearTimeout;
	                  return clearTimeout(marker);
	                }
	                try {
	                  return cachedClearTimeout(marker);
	                } catch (e) {
	                  try {
	                    return cachedClearTimeout.call(null, marker);
	                  } catch (e) {
	                    return cachedClearTimeout.call(this, marker);
	                  }
	                }
	              }
	              var queue = [];
	              var draining = false;
	              var currentQueue;
	              var queueIndex = -1;
	              function cleanUpNextTick() {
	                if (!draining || !currentQueue) {
	                  return;
	                }
	                draining = false;
	                if (currentQueue.length) {
	                  queue = currentQueue.concat(queue);
	                } else {
	                  queueIndex = -1;
	                }
	                if (queue.length) {
	                  drainQueue();
	                }
	              }
	              function drainQueue() {
	                if (draining) {
	                  return;
	                }
	                var timeout = runTimeout(cleanUpNextTick);
	                draining = true;
	                var len = queue.length;
	                while (len) {
	                  currentQueue = queue;
	                  queue = [];
	                  while (++queueIndex < len) {
	                    if (currentQueue) {
	                      currentQueue[queueIndex].run();
	                    }
	                  }
	                  queueIndex = -1;
	                  len = queue.length;
	                }
	                currentQueue = null;
	                draining = false;
	                runClearTimeout(timeout);
	              }
	              process.nextTick = function (fun) {
	                var args = new Array(arguments.length - 1);
	                if (arguments.length > 1) {
	                  for (var i = 1; i < arguments.length; i++) {
	                    args[i - 1] = arguments[i];
	                  }
	                }
	                queue.push(new Item(fun, args));
	                if (queue.length === 1 && !draining) {
	                  runTimeout(drainQueue);
	                }
	              };
	              function Item(fun, array) {
	                this.fun = fun;
	                this.array = array;
	              }
	              Item.prototype.run = function () {
	                this.fun.apply(null, this.array);
	              };
	              process.title = 'browser';
	              process.browser = true;
	              process.env = {};
	              process.argv = [];
	              process.version = '';
	              process.versions = {};
	              function noop() {
	              }
	              process.on = noop;
	              process.addListener = noop;
	              process.once = noop;
	              process.off = noop;
	              process.removeListener = noop;
	              process.removeAllListeners = noop;
	              process.emit = noop;
	              process.prependListener = noop;
	              process.prependOnceListener = noop;
	              process.listeners = function (name) {
	                return [];
	              };
	              process.binding = function (name) {
	                throw new Error('process.binding is not supported');
	              };
	              process.cwd = function () {
	                return '/';
	              };
	              process.chdir = function (dir) {
	                throw new Error('process.chdir is not supported');
	              };
	              process.umask = function () {
	                return 0;
	              };
	            },
	            {}
	          ],
	          2: [
	            function (require, module, exports) {
	              (function (setImmediate) {
	                (function (root) {
	                  var setTimeoutFunc = setTimeout;
	                  function noop() {
	                  }
	                  function bind(fn, thisArg) {
	                    return function () {
	                      fn.apply(thisArg, arguments);
	                    };
	                  }
	                  function Promise(fn) {
	                    if (typeof this !== 'object')
	                      throw new TypeError('Promises must be constructed via new');
	                    if (typeof fn !== 'function')
	                      throw new TypeError('not a function');
	                    this._state = 0;
	                    this._handled = false;
	                    this._value = undefined;
	                    this._deferreds = [];
	                    doResolve(fn, this);
	                  }
	                  function handle(self, deferred) {
	                    while (self._state === 3) {
	                      self = self._value;
	                    }
	                    if (self._state === 0) {
	                      self._deferreds.push(deferred);
	                      return;
	                    }
	                    self._handled = true;
	                    Promise._immediateFn(function () {
	                      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	                      if (cb === null) {
	                        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	                        return;
	                      }
	                      var ret;
	                      try {
	                        ret = cb(self._value);
	                      } catch (e) {
	                        reject(deferred.promise, e);
	                        return;
	                      }
	                      resolve(deferred.promise, ret);
	                    });
	                  }
	                  function resolve(self, newValue) {
	                    try {
	                      if (newValue === self)
	                        throw new TypeError('A promise cannot be resolved with itself.');
	                      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	                        var then = newValue.then;
	                        if (newValue instanceof Promise) {
	                          self._state = 3;
	                          self._value = newValue;
	                          finale(self);
	                          return;
	                        } else if (typeof then === 'function') {
	                          doResolve(bind(then, newValue), self);
	                          return;
	                        }
	                      }
	                      self._state = 1;
	                      self._value = newValue;
	                      finale(self);
	                    } catch (e) {
	                      reject(self, e);
	                    }
	                  }
	                  function reject(self, newValue) {
	                    self._state = 2;
	                    self._value = newValue;
	                    finale(self);
	                  }
	                  function finale(self) {
	                    if (self._state === 2 && self._deferreds.length === 0) {
	                      Promise._immediateFn(function () {
	                        if (!self._handled) {
	                          Promise._unhandledRejectionFn(self._value);
	                        }
	                      });
	                    }
	                    for (var i = 0, len = self._deferreds.length; i < len; i++) {
	                      handle(self, self._deferreds[i]);
	                    }
	                    self._deferreds = null;
	                  }
	                  function Handler(onFulfilled, onRejected, promise) {
	                    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	                    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	                    this.promise = promise;
	                  }
	                  function doResolve(fn, self) {
	                    var done = false;
	                    try {
	                      fn(function (value) {
	                        if (done)
	                          return;
	                        done = true;
	                        resolve(self, value);
	                      }, function (reason) {
	                        if (done)
	                          return;
	                        done = true;
	                        reject(self, reason);
	                      });
	                    } catch (ex) {
	                      if (done)
	                        return;
	                      done = true;
	                      reject(self, ex);
	                    }
	                  }
	                  Promise.prototype['catch'] = function (onRejected) {
	                    return this.then(null, onRejected);
	                  };
	                  Promise.prototype.then = function (onFulfilled, onRejected) {
	                    var prom = new this.constructor(noop);
	                    handle(this, new Handler(onFulfilled, onRejected, prom));
	                    return prom;
	                  };
	                  Promise.all = function (arr) {
	                    var args = Array.prototype.slice.call(arr);
	                    return new Promise(function (resolve, reject) {
	                      if (args.length === 0)
	                        return resolve([]);
	                      var remaining = args.length;
	                      function res(i, val) {
	                        try {
	                          if (val && (typeof val === 'object' || typeof val === 'function')) {
	                            var then = val.then;
	                            if (typeof then === 'function') {
	                              then.call(val, function (val) {
	                                res(i, val);
	                              }, reject);
	                              return;
	                            }
	                          }
	                          args[i] = val;
	                          if (--remaining === 0) {
	                            resolve(args);
	                          }
	                        } catch (ex) {
	                          reject(ex);
	                        }
	                      }
	                      for (var i = 0; i < args.length; i++) {
	                        res(i, args[i]);
	                      }
	                    });
	                  };
	                  Promise.resolve = function (value) {
	                    if (value && typeof value === 'object' && value.constructor === Promise) {
	                      return value;
	                    }
	                    return new Promise(function (resolve) {
	                      resolve(value);
	                    });
	                  };
	                  Promise.reject = function (value) {
	                    return new Promise(function (resolve, reject) {
	                      reject(value);
	                    });
	                  };
	                  Promise.race = function (values) {
	                    return new Promise(function (resolve, reject) {
	                      for (var i = 0, len = values.length; i < len; i++) {
	                        values[i].then(resolve, reject);
	                      }
	                    });
	                  };
	                  Promise._immediateFn = typeof setImmediate === 'function' ? function (fn) {
	                    setImmediate(fn);
	                  } : function (fn) {
	                    setTimeoutFunc(fn, 0);
	                  };
	                  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	                    if (typeof console !== 'undefined' && console) {
	                      console.warn('Possible Unhandled Promise Rejection:', err);
	                    }
	                  };
	                  Promise._setImmediateFn = function _setImmediateFn(fn) {
	                    Promise._immediateFn = fn;
	                  };
	                  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
	                    Promise._unhandledRejectionFn = fn;
	                  };
	                  if (typeof module !== 'undefined' && module.exports) {
	                    module.exports = Promise;
	                  } else if (!root.Promise) {
	                    root.Promise = Promise;
	                  }
	                }(this));
	              }.call(this, require('timers').setImmediate));
	            },
	            { 'timers': 3 }
	          ],
	          3: [
	            function (require, module, exports) {
	              (function (setImmediate, clearImmediate) {
	                var nextTick = require('process/browser.js').nextTick;
	                var apply = Function.prototype.apply;
	                var slice = Array.prototype.slice;
	                var immediateIds = {};
	                var nextImmediateId = 0;
	                exports.setTimeout = function () {
	                  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	                };
	                exports.setInterval = function () {
	                  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	                };
	                exports.clearTimeout = exports.clearInterval = function (timeout) {
	                  timeout.close();
	                };
	                function Timeout(id, clearFn) {
	                  this._id = id;
	                  this._clearFn = clearFn;
	                }
	                Timeout.prototype.unref = Timeout.prototype.ref = function () {
	                };
	                Timeout.prototype.close = function () {
	                  this._clearFn.call(window, this._id);
	                };
	                exports.enroll = function (item, msecs) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = msecs;
	                };
	                exports.unenroll = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  item._idleTimeout = -1;
	                };
	                exports._unrefActive = exports.active = function (item) {
	                  clearTimeout(item._idleTimeoutId);
	                  var msecs = item._idleTimeout;
	                  if (msecs >= 0) {
	                    item._idleTimeoutId = setTimeout(function onTimeout() {
	                      if (item._onTimeout)
	                        item._onTimeout();
	                    }, msecs);
	                  }
	                };
	                exports.setImmediate = typeof setImmediate === 'function' ? setImmediate : function (fn) {
	                  var id = nextImmediateId++;
	                  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	                  immediateIds[id] = true;
	                  nextTick(function onNextTick() {
	                    if (immediateIds[id]) {
	                      if (args) {
	                        fn.apply(null, args);
	                      } else {
	                        fn.call(null);
	                      }
	                      exports.clearImmediate(id);
	                    }
	                  });
	                  return id;
	                };
	                exports.clearImmediate = typeof clearImmediate === 'function' ? clearImmediate : function (id) {
	                  delete immediateIds[id];
	                };
	              }.call(this, require('timers').setImmediate, require('timers').clearImmediate));
	            },
	            {
	              'process/browser.js': 1,
	              'timers': 3
	            }
	          ],
	          4: [
	            function (require, module, exports) {
	              var promisePolyfill = require('promise-polyfill');
	              var Global = function () {
	                if (typeof window !== 'undefined') {
	                  return window;
	                } else {
	                  return Function('return this;')();
	                }
	              }();
	              module.exports = { boltExport: Global.Promise || promisePolyfill };
	            },
	            { 'promise-polyfill': 2 }
	          ]
	        }, {}, [4])(4);
	      }));
	    }(undefined, exports$1, module$1, undefined));
	    var Promise = module$1.exports.boltExport;
	
	    var nu$3 = function (baseFn) {
	      var data = Optional.none();
	      var callbacks = [];
	      var map = function (f) {
	        return nu$3(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	      var get = function (nCallback) {
	        if (isReady()) {
	          call(nCallback);
	        } else {
	          callbacks.push(nCallback);
	        }
	      };
	      var set = function (x) {
	        if (!isReady()) {
	          data = Optional.some(x);
	          run(callbacks);
	          callbacks = [];
	        }
	      };
	      var isReady = function () {
	        return data.isSome();
	      };
	      var run = function (cbs) {
	        each(cbs, call);
	      };
	      var call = function (cb) {
	        data.each(function (x) {
	          setTimeout(function () {
	            cb(x);
	          }, 0);
	        });
	      };
	      baseFn(set);
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	    var pure = function (a) {
	      return nu$3(function (callback) {
	        callback(a);
	      });
	    };
	    var LazyValue = {
	      nu: nu$3,
	      pure: pure
	    };
	
	    var errorReporter = function (err) {
	      setTimeout(function () {
	        throw err;
	      }, 0);
	    };
	    var make = function (run) {
	      var get = function (callback) {
	        run().then(callback, errorReporter);
	      };
	      var map = function (fab) {
	        return make(function () {
	          return run().then(fab);
	        });
	      };
	      var bind = function (aFutureB) {
	        return make(function () {
	          return run().then(function (v) {
	            return aFutureB(v).toPromise();
	          });
	        });
	      };
	      var anonBind = function (futureB) {
	        return make(function () {
	          return run().then(function () {
	            return futureB.toPromise();
	          });
	        });
	      };
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	      var toCached = function () {
	        var cache = null;
	        return make(function () {
	          if (cache === null) {
	            cache = run();
	          }
	          return cache;
	        });
	      };
	      var toPromise = run;
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        toCached: toCached,
	        toPromise: toPromise,
	        get: get
	      };
	    };
	    var nu$4 = function (baseFn) {
	      return make(function () {
	        return new Promise(baseFn);
	      });
	    };
	    var pure$1 = function (a) {
	      return make(function () {
	        return Promise.resolve(a);
	      });
	    };
	    var Future = {
	      nu: nu$4,
	      pure: pure$1
	    };
	
	    var par = function (asyncValues, nu) {
	      return nu(function (callback) {
	        var r = [];
	        var count = 0;
	        var cb = function (i) {
	          return function (value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          each(asyncValues, function (asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    var par$1 = function (futures) {
	      return par(futures, Future.nu);
	    };
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;
	      };
	      var or = function (_opt) {
	        return value(o);
	      };
	      var orThunk = function (_f) {
	        return value(o);
	      };
	      var map = function (f) {
	        return value(f(o));
	      };
	      var mapError = function (_f) {
	        return value(o);
	      };
	      var each = function (f) {
	        f(o);
	      };
	      var bind = function (f) {
	        return f(o);
	      };
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	      var exists = function (f) {
	        return f(o);
	      };
	      var forall = function (f) {
	        return f(o);
	      };
	      var toOptional = function () {
	        return Optional.some(o);
	      };
	      return {
	        is: is,
	        isValue: always,
	        isError: never,
	        getOr: constant(o),
	        getOrThunk: constant(o),
	        getOrDie: constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOptional: toOptional
	      };
	    };
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	      var getOrDie = function () {
	        return die(String(message))();
	      };
	      var or = function (opt) {
	        return opt;
	      };
	      var orThunk = function (f) {
	        return f();
	      };
	      var map = function (_f) {
	        return error(message);
	      };
	      var mapError = function (f) {
	        return error(f(message));
	      };
	      var bind = function (_f) {
	        return error(message);
	      };
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	      return {
	        is: never,
	        isValue: never,
	        isError: always,
	        getOr: identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        mapError: mapError,
	        each: noop,
	        bind: bind,
	        exists: never,
	        forall: always,
	        toOptional: Optional.none
	      };
	    };
	    var fromOption = function (opt, err) {
	      return opt.fold(function () {
	        return error(err);
	      }, value);
	    };
	    var Result = {
	      value: value,
	      error: error,
	      fromOption: fromOption
	    };
	
	    var generate = function (cases) {
	      if (!isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	      var constructors = [];
	      var adt = {};
	      each(cases, function (acase, count) {
	        var keys$1 = keys(acase);
	        if (keys$1.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	        var key = keys$1[0];
	        var value = acase[key];
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!isArray(value)) {
	          throw new Error('case arguments must be an array');
	        }
	        constructors.push(key);
	        adt[key] = function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          var argLength = args.length;
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	          var match = function (branches) {
	            var branchKeys = keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	            var allReqd = forall(constructors, function (reqKey) {
	              return contains(branchKeys, reqKey);
	            });
	            if (!allReqd) {
	              throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	            }
	            return branches[key].apply(null, args);
	          };
	          return {
	            fold: function () {
	              var foldArgs = [];
	              for (var _i = 0; _i < arguments.length; _i++) {
	                foldArgs[_i] = arguments[_i];
	              }
	              if (foldArgs.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + foldArgs.length);
	              }
	              var target = foldArgs[count];
	              return target.apply(null, args);
	            },
	            match: match,
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	      return adt;
	    };
	    var Adt = { generate: generate };
	
	    var comparison = Adt.generate([
	      {
	        bothErrors: [
	          'error1',
	          'error2'
	        ]
	      },
	      {
	        firstError: [
	          'error1',
	          'value2'
	        ]
	      },
	      {
	        secondError: [
	          'value1',
	          'error2'
	        ]
	      },
	      {
	        bothValues: [
	          'value1',
	          'value2'
	        ]
	      }
	    ]);
	    var unite = function (result) {
	      return result.fold(identity, identity);
	    };
	
	    function ClosestOrAncestor (is, ancestor, scope, a, isRoot) {
	      if (is(scope, a)) {
	        return Optional.some(scope);
	      } else if (isFunction(isRoot) && isRoot(scope)) {
	        return Optional.none();
	      } else {
	        return ancestor(scope, a, isRoot);
	      }
	    }
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom;
	      var stop = isFunction(isRoot) ? isRoot : never;
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        if (predicate(el)) {
	          return Optional.some(el);
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest = function (scope, predicate, isRoot) {
	      var is = function (s, test) {
	        return test(s);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	    var sibling = function (scope, predicate) {
	      var element = scope.dom;
	      if (!element.parentNode) {
	        return Optional.none();
	      }
	      return child$1(SugarElement.fromDom(element.parentNode), function (x) {
	        return !eq$2(scope, x) && predicate(x);
	      });
	    };
	    var child$1 = function (scope, predicate) {
	      var pred = function (node) {
	        return predicate(SugarElement.fromDom(node));
	      };
	      var result = find(scope.dom.childNodes, pred);
	      return result.map(SugarElement.fromDom);
	    };
	
	    var ancestor$1 = function (scope, selector, isRoot) {
	      return ancestor(scope, function (e) {
	        return is$1(e, selector);
	      }, isRoot);
	    };
	    var descendant = function (scope, selector) {
	      return one(selector, scope);
	    };
	    var closest$1 = function (scope, selector, isRoot) {
	      var is = function (element, selector) {
	        return is$1(element, selector);
	      };
	      return ClosestOrAncestor(is, ancestor$1, scope, selector, isRoot);
	    };
	
	    var promise = function () {
	      var bind = function (fn, thisArg) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          fn.apply(thisArg, args);
	        };
	      };
	      var isArray = Array.isArray || function (value) {
	        return Object.prototype.toString.call(value) === '[object Array]';
	      };
	      var Promise = function (fn) {
	        if (typeof this !== 'object') {
	          throw new TypeError('Promises must be constructed via new');
	        }
	        if (typeof fn !== 'function') {
	          throw new TypeError('not a function');
	        }
	        this._state = null;
	        this._value = null;
	        this._deferreds = [];
	        doResolve(fn, bind(resolve, this), bind(reject, this));
	      };
	      var asap = Promise.immediateFn || typeof setImmediate === 'function' && setImmediate || function (fn) {
	        return setTimeout(fn, 1);
	      };
	      function handle(deferred) {
	        var me = this;
	        if (this._state === null) {
	          this._deferreds.push(deferred);
	          return;
	        }
	        asap(function () {
	          var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
	          if (cb === null) {
	            (me._state ? deferred.resolve : deferred.reject)(me._value);
	            return;
	          }
	          var ret;
	          try {
	            ret = cb(me._value);
	          } catch (e) {
	            deferred.reject(e);
	            return;
	          }
	          deferred.resolve(ret);
	        });
	      }
	      function resolve(newValue) {
	        try {
	          if (newValue === this) {
	            throw new TypeError('A promise cannot be resolved with itself.');
	          }
	          if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	            var then = newValue.then;
	            if (typeof then === 'function') {
	              doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
	              return;
	            }
	          }
	          this._state = true;
	          this._value = newValue;
	          finale.call(this);
	        } catch (e) {
	          reject.call(this, e);
	        }
	      }
	      function reject(newValue) {
	        this._state = false;
	        this._value = newValue;
	        finale.call(this);
	      }
	      function finale() {
	        for (var i = 0, len = this._deferreds.length; i < len; i++) {
	          handle.call(this, this._deferreds[i]);
	        }
	        this._deferreds = null;
	      }
	      function Handler(onFulfilled, onRejected, resolve, reject) {
	        this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	        this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	        this.resolve = resolve;
	        this.reject = reject;
	      }
	      var doResolve = function (fn, onFulfilled, onRejected) {
	        var done = false;
	        try {
	          fn(function (value) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onFulfilled(value);
	          }, function (reason) {
	            if (done) {
	              return;
	            }
	            done = true;
	            onRejected(reason);
	          });
	        } catch (ex) {
	          if (done) {
	            return;
	          }
	          done = true;
	          onRejected(ex);
	        }
	      };
	      Promise.prototype.catch = function (onRejected) {
	        return this.then(null, onRejected);
	      };
	      Promise.prototype.then = function (onFulfilled, onRejected) {
	        var me = this;
	        return new Promise(function (resolve, reject) {
	          handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
	        });
	      };
	      Promise.all = function () {
	        var values = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          values[_i] = arguments[_i];
	        }
	        var args = Array.prototype.slice.call(values.length === 1 && isArray(values[0]) ? values[0] : values);
	        return new Promise(function (resolve, reject) {
	          if (args.length === 0) {
	            return resolve([]);
	          }
	          var remaining = args.length;
	          var res = function (i, val) {
	            try {
	              if (val && (typeof val === 'object' || typeof val === 'function')) {
	                var then = val.then;
	                if (typeof then === 'function') {
	                  then.call(val, function (val) {
	                    res(i, val);
	                  }, reject);
	                  return;
	                }
	              }
	              args[i] = val;
	              if (--remaining === 0) {
	                resolve(args);
	              }
	            } catch (ex) {
	              reject(ex);
	            }
	          };
	          for (var i = 0; i < args.length; i++) {
	            res(i, args[i]);
	          }
	        });
	      };
	      Promise.resolve = function (value) {
	        if (value && typeof value === 'object' && value.constructor === Promise) {
	          return value;
	        }
	        return new Promise(function (resolve) {
	          resolve(value);
	        });
	      };
	      Promise.reject = function (value) {
	        return new Promise(function (resolve, reject) {
	          reject(value);
	        });
	      };
	      Promise.race = function (values) {
	        return new Promise(function (resolve, reject) {
	          for (var i = 0, len = values.length; i < len; i++) {
	            values[i].then(resolve, reject);
	          }
	        });
	      };
	      return Promise;
	    };
	    var promiseObj = window.Promise ? window.Promise : promise();
	
	    var requestAnimationFramePromise;
	    var requestAnimationFrame = function (callback, element) {
	      var requestAnimationFrameFunc = window.requestAnimationFrame;
	      var vendors = [
	        'ms',
	        'moz',
	        'webkit'
	      ];
	      var featurefill = function (cb) {
	        window.setTimeout(cb, 0);
	      };
	      for (var i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
	        requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame'];
	      }
	      if (!requestAnimationFrameFunc) {
	        requestAnimationFrameFunc = featurefill;
	      }
	      requestAnimationFrameFunc(callback, element);
	    };
	    var wrappedSetTimeout = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 0;
	      }
	      return setTimeout(callback, time);
	    };
	    var wrappedSetInterval = function (callback, time) {
	      if (typeof time !== 'number') {
	        time = 1;
	      }
	      return setInterval(callback, time);
	    };
	    var wrappedClearTimeout = function (id) {
	      return clearTimeout(id);
	    };
	    var wrappedClearInterval = function (id) {
	      return clearInterval(id);
	    };
	    var debounce = function (callback, time) {
	      var timer;
	      var func = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        clearTimeout(timer);
	        timer = wrappedSetTimeout(function () {
	          callback.apply(this, args);
	        }, time);
	      };
	      func.stop = function () {
	        clearTimeout(timer);
	      };
	      return func;
	    };
	    var Delay = {
	      requestAnimationFrame: function (callback, element) {
	        if (requestAnimationFramePromise) {
	          requestAnimationFramePromise.then(callback);
	          return;
	        }
	        requestAnimationFramePromise = new promiseObj(function (resolve) {
	          if (!element) {
	            element = document.body;
	          }
	          requestAnimationFrame(resolve, element);
	        }).then(callback);
	      },
	      setTimeout: wrappedSetTimeout,
	      setInterval: wrappedSetInterval,
	      setEditorTimeout: function (editor, callback, time) {
	        return wrappedSetTimeout(function () {
	          if (!editor.removed) {
	            callback();
	          }
	        }, time);
	      },
	      setEditorInterval: function (editor, callback, time) {
	        var timer = wrappedSetInterval(function () {
	          if (!editor.removed) {
	            callback();
	          } else {
	            clearInterval(timer);
	          }
	        }, time);
	        return timer;
	      },
	      debounce: debounce,
	      throttle: debounce,
	      clearInterval: wrappedClearInterval,
	      clearTimeout: wrappedClearTimeout
	    };
	
	    var StyleSheetLoader = function (documentOrShadowRoot, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var idCount = 0;
	      var loadedStates = {};
	      var edos = SugarElement.fromDom(documentOrShadowRoot);
	      var doc = documentOrOwner(edos);
	      var maxLoadTime = settings.maxLoadTime || 5000;
	      var _setReferrerPolicy = function (referrerPolicy) {
	        settings.referrerPolicy = referrerPolicy;
	      };
	      var addStyle = function (element) {
	        append(getStyleContainer(edos), element);
	      };
	      var removeStyle = function (id) {
	        var styleContainer = getStyleContainer(edos);
	        descendant(styleContainer, '#' + id).each(remove);
	      };
	      var getOrCreateState = function (url) {
	        return get$1(loadedStates, url).getOrThunk(function () {
	          return {
	            id: 'mce-u' + idCount++,
	            passed: [],
	            failed: [],
	            count: 0
	          };
	        });
	      };
	      var load = function (url, success, failure) {
	        var link;
	        var urlWithSuffix = Tools._addCacheSuffix(url);
	        var state = getOrCreateState(urlWithSuffix);
	        loadedStates[urlWithSuffix] = state;
	        state.count++;
	        var resolve = function (callbacks, status) {
	          var i = callbacks.length;
	          while (i--) {
	            callbacks[i]();
	          }
	          state.status = status;
	          state.passed = [];
	          state.failed = [];
	          if (link) {
	            link.onload = null;
	            link.onerror = null;
	            link = null;
	          }
	        };
	        var passed = function () {
	          return resolve(state.passed, 2);
	        };
	        var failed = function () {
	          return resolve(state.failed, 3);
	        };
	        var wait = function (testCallback, waitCallback) {
	          if (!testCallback()) {
	            if (Date.now() - startTime < maxLoadTime) {
	              Delay.setTimeout(waitCallback);
	            } else {
	              failed();
	            }
	          }
	        };
	        var waitForWebKitLinkLoaded = function () {
	          wait(function () {
	            var styleSheets = documentOrShadowRoot.styleSheets;
	            var i = styleSheets.length;
	            while (i--) {
	              var styleSheet = styleSheets[i];
	              var owner = styleSheet.ownerNode;
	              if (owner && owner.id === link.id) {
	                passed();
	                return true;
	              }
	            }
	            return false;
	          }, waitForWebKitLinkLoaded);
	        };
	        if (success) {
	          state.passed.push(success);
	        }
	        if (failure) {
	          state.failed.push(failure);
	        }
	        if (state.status === 1) {
	          return;
	        }
	        if (state.status === 2) {
	          passed();
	          return;
	        }
	        if (state.status === 3) {
	          failed();
	          return;
	        }
	        state.status = 1;
	        var linkElem = SugarElement.fromTag('link', doc.dom);
	        setAll(linkElem, {
	          rel: 'stylesheet',
	          type: 'text/css',
	          id: state.id
	        });
	        var startTime = Date.now();
	        if (settings.contentCssCors) {
	          set(linkElem, 'crossOrigin', 'anonymous');
	        }
	        if (settings.referrerPolicy) {
	          set(linkElem, 'referrerpolicy', settings.referrerPolicy);
	        }
	        link = linkElem.dom;
	        link.onload = waitForWebKitLinkLoaded;
	        link.onerror = failed;
	        addStyle(linkElem);
	        set(linkElem, 'href', urlWithSuffix);
	      };
	      var loadF = function (url) {
	        return Future.nu(function (resolve) {
	          load(url, compose(resolve, constant(Result.value(url))), compose(resolve, constant(Result.error(url))));
	        });
	      };
	      var loadAll = function (urls, success, failure) {
	        par$1(map(urls, loadF)).get(function (result) {
	          var parts = partition(result, function (r) {
	            return r.isValue();
	          });
	          if (parts.fail.length > 0) {
	            failure(parts.fail.map(unite));
	          } else {
	            success(parts.pass.map(unite));
	          }
	        });
	      };
	      var unload = function (url) {
	        var urlWithSuffix = Tools._addCacheSuffix(url);
	        get$1(loadedStates, urlWithSuffix).each(function (state) {
	          var count = --state.count;
	          if (count === 0) {
	            delete loadedStates[urlWithSuffix];
	            removeStyle(state.id);
	          }
	        });
	      };
	      var unloadAll = function (urls) {
	        each(urls, function (url) {
	          unload(url);
	        });
	      };
	      return {
	        load: load,
	        loadAll: loadAll,
	        unload: unload,
	        unloadAll: unloadAll,
	        _setReferrerPolicy: _setReferrerPolicy
	      };
	    };
	
	    var create$1 = function () {
	      var map = new WeakMap();
	      var forElement = function (referenceElement, settings) {
	        var root = getRootNode(referenceElement);
	        var rootDom = root.dom;
	        return Optional.from(map.get(rootDom)).getOrThunk(function () {
	          var sl = StyleSheetLoader(rootDom, settings);
	          map.set(rootDom, sl);
	          return sl;
	        });
	      };
	      return { forElement: forElement };
	    };
	    var instance = create$1();
	
	    var DomTreeWalker = function () {
	      function DomTreeWalker(startNode, rootNode) {
	        this.node = startNode;
	        this.rootNode = rootNode;
	        this.current = this.current.bind(this);
	        this.next = this.next.bind(this);
	        this.prev = this.prev.bind(this);
	        this.prev2 = this.prev2.bind(this);
	      }
	      DomTreeWalker.prototype.current = function () {
	        return this.node;
	      };
	      DomTreeWalker.prototype.next = function (shallow) {
	        this.node = this.findSibling(this.node, 'firstChild', 'nextSibling', shallow);
	        return this.node;
	      };
	      DomTreeWalker.prototype.prev = function (shallow) {
	        this.node = this.findSibling(this.node, 'lastChild', 'previousSibling', shallow);
	        return this.node;
	      };
	      DomTreeWalker.prototype.prev2 = function (shallow) {
	        this.node = this.findPreviousNode(this.node, 'lastChild', 'previousSibling', shallow);
	        return this.node;
	      };
	      DomTreeWalker.prototype.findSibling = function (node, startName, siblingName, shallow) {
	        var sibling, parent;
	        if (node) {
	          if (!shallow && node[startName]) {
	            return node[startName];
	          }
	          if (node !== this.rootNode) {
	            sibling = node[siblingName];
	            if (sibling) {
	              return sibling;
	            }
	            for (parent = node.parentNode; parent && parent !== this.rootNode; parent = parent.parentNode) {
	              sibling = parent[siblingName];
	              if (sibling) {
	                return sibling;
	              }
	            }
	          }
	        }
	      };
	      DomTreeWalker.prototype.findPreviousNode = function (node, startName, siblingName, shallow) {
	        var sibling, parent, child;
	        if (node) {
	          sibling = node[siblingName];
	          if (this.rootNode && sibling === this.rootNode) {
	            return;
	          }
	          if (sibling) {
	            if (!shallow) {
	              for (child = sibling[startName]; child; child = child[startName]) {
	                if (!child[startName]) {
	                  return child;
	                }
	              }
	            }
	            return sibling;
	          }
	          parent = node.parentNode;
	          if (parent && parent !== this.rootNode) {
	            return parent;
	          }
	        }
	      };
	      return DomTreeWalker;
	    }();
	
	    var blocks = [
	      'article',
	      'aside',
	      'details',
	      'div',
	      'dt',
	      'figcaption',
	      'footer',
	      'form',
	      'fieldset',
	      'header',
	      'hgroup',
	      'html',
	      'main',
	      'nav',
	      'section',
	      'summary',
	      'body',
	      'p',
	      'dl',
	      'multicol',
	      'dd',
	      'figure',
	      'address',
	      'center',
	      'blockquote',
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'listing',
	      'xmp',
	      'pre',
	      'plaintext',
	      'menu',
	      'dir',
	      'ul',
	      'ol',
	      'li',
	      'hr',
	      'table',
	      'tbody',
	      'thead',
	      'tfoot',
	      'th',
	      'tr',
	      'td',
	      'caption'
	    ];
	    var tableCells = [
	      'td',
	      'th'
	    ];
	    var tableSections = [
	      'thead',
	      'tbody',
	      'tfoot'
	    ];
	    var textBlocks = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6',
	      'p',
	      'div',
	      'address',
	      'pre',
	      'form',
	      'blockquote',
	      'center',
	      'dir',
	      'fieldset',
	      'header',
	      'footer',
	      'article',
	      'section',
	      'hgroup',
	      'aside',
	      'nav',
	      'figure'
	    ];
	    var headings = [
	      'h1',
	      'h2',
	      'h3',
	      'h4',
	      'h5',
	      'h6'
	    ];
	    var listItems = [
	      'li',
	      'dd',
	      'dt'
	    ];
	    var lists = [
	      'ul',
	      'ol',
	      'dl'
	    ];
	    var wsElements = [
	      'pre',
	      'script',
	      'textarea',
	      'style'
	    ];
	    var lazyLookup = function (items) {
	      var lookup;
	      return function (node) {
	        lookup = lookup ? lookup : mapToObject(items, always);
	        return lookup.hasOwnProperty(name(node));
	      };
	    };
	    var isHeading = lazyLookup(headings);
	    var isBlock = lazyLookup(blocks);
	    var isTable$1 = function (node) {
	      return name(node) === 'table';
	    };
	    var isInline = function (node) {
	      return isElement(node) && !isBlock(node);
	    };
	    var isBr$1 = function (node) {
	      return isElement(node) && name(node) === 'br';
	    };
	    var isTextBlock = lazyLookup(textBlocks);
	    var isList = lazyLookup(lists);
	    var isListItem = lazyLookup(listItems);
	    var isTableSection = lazyLookup(tableSections);
	    var isTableCell$1 = lazyLookup(tableCells);
	    var isWsPreserveElement = lazyLookup(wsElements);
	
	    var ancestor$2 = function (scope, selector, isRoot) {
	      return ancestor$1(scope, selector, isRoot).isSome();
	    };
	
	    var zeroWidth = '\uFEFF';
	    var nbsp = '\xA0';
	    var isZwsp = function (char) {
	      return char === zeroWidth;
	    };
	    var removeZwsp = function (s) {
	      return s.replace(/\uFEFF/g, '');
	    };
	
	    var ZWSP = zeroWidth;
	    var isZwsp$1 = isZwsp;
	    var trim$2 = removeZwsp;
	
	    var isElement$2 = isElement$1;
	    var isText$2 = isText$1;
	    var isCaretContainerBlock = function (node) {
	      if (isText$2(node)) {
	        node = node.parentNode;
	      }
	      return isElement$2(node) && node.hasAttribute('data-mce-caret');
	    };
	    var isCaretContainerInline = function (node) {
	      return isText$2(node) && isZwsp$1(node.data);
	    };
	    var isCaretContainer = function (node) {
	      return isCaretContainerBlock(node) || isCaretContainerInline(node);
	    };
	    var hasContent = function (node) {
	      return node.firstChild !== node.lastChild || !isBr(node.firstChild);
	    };
	    var insertInline = function (node, before) {
	      var sibling;
	      var doc = node.ownerDocument;
	      var textNode = doc.createTextNode(ZWSP);
	      var parentNode = node.parentNode;
	      if (!before) {
	        sibling = node.nextSibling;
	        if (isText$2(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	          if (startsWithCaretContainer(sibling)) {
	            sibling.splitText(1);
	            return sibling;
	          }
	        }
	        if (node.nextSibling) {
	          parentNode.insertBefore(textNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(textNode);
	        }
	      } else {
	        sibling = node.previousSibling;
	        if (isText$2(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	          if (endsWithCaretContainer(sibling)) {
	            return sibling.splitText(sibling.data.length - 1);
	          }
	        }
	        parentNode.insertBefore(textNode, node);
	      }
	      return textNode;
	    };
	    var isBeforeInline = function (pos) {
	      var container = pos.container();
	      if (!isText$1(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset()) === ZWSP || pos.isAtStart() && isCaretContainerInline(container.previousSibling);
	    };
	    var isAfterInline = function (pos) {
	      var container = pos.container();
	      if (!isText$1(container)) {
	        return false;
	      }
	      return container.data.charAt(pos.offset() - 1) === ZWSP || pos.isAtEnd() && isCaretContainerInline(container.nextSibling);
	    };
	    var createBogusBr = function () {
	      var br = document.createElement('br');
	      br.setAttribute('data-mce-bogus', '1');
	      return br;
	    };
	    var insertBlock = function (blockName, node, before) {
	      var doc = node.ownerDocument;
	      var blockNode = doc.createElement(blockName);
	      blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
	      blockNode.setAttribute('data-mce-bogus', 'all');
	      blockNode.appendChild(createBogusBr());
	      var parentNode = node.parentNode;
	      if (!before) {
	        if (node.nextSibling) {
	          parentNode.insertBefore(blockNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(blockNode);
	        }
	      } else {
	        parentNode.insertBefore(blockNode, node);
	      }
	      return blockNode;
	    };
	    var startsWithCaretContainer = function (node) {
	      return isText$2(node) && node.data[0] === ZWSP;
	    };
	    var endsWithCaretContainer = function (node) {
	      return isText$2(node) && node.data[node.data.length - 1] === ZWSP;
	    };
	    var trimBogusBr = function (elm) {
	      var brs = elm.getElementsByTagName('br');
	      var lastBr = brs[brs.length - 1];
	      if (isBogus(lastBr)) {
	        lastBr.parentNode.removeChild(lastBr);
	      }
	    };
	    var showCaretContainerBlock = function (caretContainer) {
	      if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
	        trimBogusBr(caretContainer);
	        caretContainer.removeAttribute('data-mce-caret');
	        caretContainer.removeAttribute('data-mce-bogus');
	        caretContainer.removeAttribute('style');
	        caretContainer.removeAttribute('_moz_abspos');
	        return caretContainer;
	      }
	      return null;
	    };
	    var isRangeInCaretContainerBlock = function (range) {
	      return isCaretContainerBlock(range.startContainer);
	    };
	
	    var isContentEditableTrue$1 = isContentEditableTrue;
	    var isContentEditableFalse$1 = isContentEditableFalse;
	    var isBr$2 = isBr;
	    var isText$3 = isText$1;
	    var isInvalidTextElement = matchNodeNames([
	      'script',
	      'style',
	      'textarea'
	    ]);
	    var isAtomicInline = matchNodeNames([
	      'img',
	      'input',
	      'textarea',
	      'hr',
	      'iframe',
	      'video',
	      'audio',
	      'object',
	      'embed'
	    ]);
	    var isTable$2 = matchNodeNames(['table']);
	    var isCaretContainer$1 = isCaretContainer;
	    var isCaretCandidate = function (node) {
	      if (isCaretContainer$1(node)) {
	        return false;
	      }
	      if (isText$3(node)) {
	        return !isInvalidTextElement(node.parentNode);
	      }
	      return isAtomicInline(node) || isBr$2(node) || isTable$2(node) || isNonUiContentEditableFalse(node);
	    };
	    var isUnselectable = function (node) {
	      return isElement$1(node) && node.getAttribute('unselectable') === 'true';
	    };
	    var isNonUiContentEditableFalse = function (node) {
	      return isUnselectable(node) === false && isContentEditableFalse$1(node);
	    };
	    var isInEditable = function (node, root) {
	      for (node = node.parentNode; node && node !== root; node = node.parentNode) {
	        if (isNonUiContentEditableFalse(node)) {
	          return false;
	        }
	        if (isContentEditableTrue$1(node)) {
	          return true;
	        }
	      }
	      return true;
	    };
	    var isAtomicContentEditableFalse = function (node) {
	      if (!isNonUiContentEditableFalse(node)) {
	        return false;
	      }
	      return foldl(from$1(node.getElementsByTagName('*')), function (result, elm) {
	        return result || isContentEditableTrue$1(elm);
	      }, false) !== true;
	    };
	    var isAtomic = function (node) {
	      return isAtomicInline(node) || isAtomicContentEditableFalse(node);
	    };
	    var isEditableCaretCandidate = function (node, root) {
	      return isCaretCandidate(node) && isInEditable(node, root);
	    };
	
	    var whiteSpaceRegExp$1 = /^[ \t\r\n]*$/;
	    var isWhitespaceText = function (text) {
	      return whiteSpaceRegExp$1.test(text);
	    };
	
	    var hasWhitespacePreserveParent = function (node, rootNode) {
	      var rootElement = SugarElement.fromDom(rootNode);
	      var startNode = SugarElement.fromDom(node);
	      return ancestor$2(startNode, 'pre,code', curry(eq$2, rootElement));
	    };
	    var isWhitespace = function (node, rootNode) {
	      return isText$1(node) && isWhitespaceText(node.data) && hasWhitespacePreserveParent(node, rootNode) === false;
	    };
	    var isNamedAnchor = function (node) {
	      return isElement$1(node) && node.nodeName === 'A' && !node.hasAttribute('href') && (node.hasAttribute('name') || node.hasAttribute('id'));
	    };
	    var isContent = function (node, rootNode) {
	      return isCaretCandidate(node) && isWhitespace(node, rootNode) === false || isNamedAnchor(node) || isBookmark(node);
	    };
	    var isBookmark = hasAttribute('data-mce-bookmark');
	    var isBogus$1 = hasAttribute('data-mce-bogus');
	    var isBogusAll$1 = hasAttributeValue('data-mce-bogus', 'all');
	    var isEmptyNode = function (targetNode, skipBogus) {
	      var node, brCount = 0;
	      if (isContent(targetNode, targetNode)) {
	        return false;
	      } else {
	        node = targetNode.firstChild;
	        if (!node) {
	          return true;
	        }
	        var walker = new DomTreeWalker(node, targetNode);
	        do {
	          if (skipBogus) {
	            if (isBogusAll$1(node)) {
	              node = walker.next(true);
	              continue;
	            }
	            if (isBogus$1(node)) {
	              node = walker.next();
	              continue;
	            }
	          }
	          if (isBr(node)) {
	            brCount++;
	            node = walker.next();
	            continue;
	          }
	          if (isContent(node, targetNode)) {
	            return false;
	          }
	          node = walker.next();
	        } while (node);
	        return brCount <= 1;
	      }
	    };
	    var isEmpty = function (elm, skipBogus) {
	      if (skipBogus === void 0) {
	        skipBogus = true;
	      }
	      return isEmptyNode(elm.dom, skipBogus);
	    };
	
	    var isSpan = function (node) {
	      return node.nodeName.toLowerCase() === 'span';
	    };
	    var isInlineContent = function (node, root) {
	      return isNonNullable(node) && (isContent(node, root) || isInline(SugarElement.fromDom(node)));
	    };
	    var surroundedByInlineContent = function (node, root) {
	      var prev = new DomTreeWalker(node, root).prev(false);
	      var next = new DomTreeWalker(node, root).next(false);
	      var prevIsInline = isUndefined(prev) || isInlineContent(prev, root);
	      var nextIsInline = isUndefined(next) || isInlineContent(next, root);
	      return prevIsInline && nextIsInline;
	    };
	    var isBookmarkNode = function (node) {
	      return isSpan(node) && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	    var isKeepTextNode = function (node, root) {
	      return isText$1(node) && node.data.length > 0 && surroundedByInlineContent(node, root);
	    };
	    var isKeepElement = function (node) {
	      return isElement$1(node) ? node.childNodes.length > 0 : false;
	    };
	    var isDocument$2 = function (node) {
	      return isDocumentFragment$1(node) || isDocument$1(node);
	    };
	    var trimNode = function (dom, node, root) {
	      var rootNode = root || node;
	      if (isElement$1(node) && isBookmarkNode(node)) {
	        return node;
	      }
	      var children = node.childNodes;
	      for (var i = children.length - 1; i >= 0; i--) {
	        trimNode(dom, children[i], rootNode);
	      }
	      if (isElement$1(node)) {
	        var currentChildren = node.childNodes;
	        if (currentChildren.length === 1 && isBookmarkNode(currentChildren[0])) {
	          node.parentNode.insertBefore(currentChildren[0], node);
	        }
	      }
	      if (!isDocument$2(node) && !isContent(node, rootNode) && !isKeepElement(node) && !isKeepTextNode(node, rootNode)) {
	        dom.remove(node);
	      }
	      return node;
	    };
	
	    var makeMap$1 = Tools.makeMap;
	    var attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	    var rawCharsRegExp = /[<>&\"\']/g;
	    var entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi;
	    var asciiMap = {
	      128: '\u20AC',
	      130: '\u201A',
	      131: '\u0192',
	      132: '\u201E',
	      133: '\u2026',
	      134: '\u2020',
	      135: '\u2021',
	      136: '\u02c6',
	      137: '\u2030',
	      138: '\u0160',
	      139: '\u2039',
	      140: '\u0152',
	      142: '\u017d',
	      145: '\u2018',
	      146: '\u2019',
	      147: '\u201C',
	      148: '\u201D',
	      149: '\u2022',
	      150: '\u2013',
	      151: '\u2014',
	      152: '\u02DC',
	      153: '\u2122',
	      154: '\u0161',
	      155: '\u203A',
	      156: '\u0153',
	      158: '\u017e',
	      159: '\u0178'
	    };
	    var baseEntities = {
	      '"': '&quot;',
	      '\'': '&#39;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '&': '&amp;',
	      '`': '&#96;'
	    };
	    var reverseEntities = {
	      '&lt;': '<',
	      '&gt;': '>',
	      '&amp;': '&',
	      '&quot;': '"',
	      '&apos;': '\''
	    };
	    var nativeDecode = function (text) {
	      var elm = SugarElement.fromTag('div').dom;
	      elm.innerHTML = text;
	      return elm.textContent || elm.innerText || text;
	    };
	    var buildEntitiesLookup = function (items, radix) {
	      var i, chr, entity;
	      var lookup = {};
	      if (items) {
	        items = items.split(',');
	        radix = radix || 10;
	        for (i = 0; i < items.length; i += 2) {
	          chr = String.fromCharCode(parseInt(items[i], radix));
	          if (!baseEntities[chr]) {
	            entity = '&' + items[i + 1] + ';';
	            lookup[chr] = entity;
	            lookup[entity] = chr;
	          }
	        }
	        return lookup;
	      }
	    };
	    var namedEntities = buildEntitiesLookup('50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' + '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' + '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' + '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' + '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' + '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' + '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' + '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' + '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' + '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' + 'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' + 'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' + 't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' + 'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' + 'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' + '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' + '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' + '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' + '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' + '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' + 'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' + 'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' + 'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' + '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' + '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
	    var encodeRaw = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeAllRaw = function (text) {
	      return ('' + text).replace(rawCharsRegExp, function (chr) {
	        return baseEntities[chr] || chr;
	      });
	    };
	    var encodeNumeric = function (text, attr) {
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        if (chr.length > 1) {
	          return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	        }
	        return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
	      });
	    };
	    var encodeNamed = function (text, attr, entities) {
	      entities = entities || namedEntities;
	      return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	        return baseEntities[chr] || entities[chr] || chr;
	      });
	    };
	    var getEncodeFunc = function (name, entities) {
	      var entitiesMap = buildEntitiesLookup(entities) || namedEntities;
	      var encodeNamedAndNumeric = function (text, attr) {
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          if (baseEntities[chr] !== undefined) {
	            return baseEntities[chr];
	          }
	          if (entitiesMap[chr] !== undefined) {
	            return entitiesMap[chr];
	          }
	          if (chr.length > 1) {
	            return '&#' + ((chr.charCodeAt(0) - 55296) * 1024 + (chr.charCodeAt(1) - 56320) + 65536) + ';';
	          }
	          return '&#' + chr.charCodeAt(0) + ';';
	        });
	      };
	      var encodeCustomNamed = function (text, attr) {
	        return encodeNamed(text, attr, entitiesMap);
	      };
	      var nameMap = makeMap$1(name.replace(/\+/g, ','));
	      if (nameMap.named && nameMap.numeric) {
	        return encodeNamedAndNumeric;
	      }
	      if (nameMap.named) {
	        if (entities) {
	          return encodeCustomNamed;
	        }
	        return encodeNamed;
	      }
	      if (nameMap.numeric) {
	        return encodeNumeric;
	      }
	      return encodeRaw;
	    };
	    var decode = function (text) {
	      return text.replace(entityRegExp, function (all, numeric) {
	        if (numeric) {
	          if (numeric.charAt(0).toLowerCase() === 'x') {
	            numeric = parseInt(numeric.substr(1), 16);
	          } else {
	            numeric = parseInt(numeric, 10);
	          }
	          if (numeric > 65535) {
	            numeric -= 65536;
	            return String.fromCharCode(55296 + (numeric >> 10), 56320 + (numeric & 1023));
	          }
	          return asciiMap[numeric] || String.fromCharCode(numeric);
	        }
	        return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
	      });
	    };
	    var Entities = {
	      encodeRaw: encodeRaw,
	      encodeAllRaw: encodeAllRaw,
	      encodeNumeric: encodeNumeric,
	      encodeNamed: encodeNamed,
	      getEncodeFunc: getEncodeFunc,
	      decode: decode
	    };
	
	    var mapCache = {}, dummyObj = {};
	    var makeMap$2 = Tools.makeMap, each$3 = Tools.each, extend$1 = Tools.extend, explode$1 = Tools.explode, inArray = Tools.inArray;
	    var split = function (items, delim) {
	      items = Tools.trim(items);
	      return items ? items.split(delim || ' ') : [];
	    };
	    var compileSchema = function (type) {
	      var schema = {};
	      var globalAttributes, blockContent;
	      var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
	      var add = function (name, attributes, children) {
	        var ni, attributesOrder, element;
	        var arrayToMap = function (array, obj) {
	          var map = {};
	          var i, l;
	          for (i = 0, l = array.length; i < l; i++) {
	            map[array[i]] = obj || {};
	          }
	          return map;
	        };
	        children = children || [];
	        attributes = attributes || '';
	        if (typeof children === 'string') {
	          children = split(children);
	        }
	        var names = split(name);
	        ni = names.length;
	        while (ni--) {
	          attributesOrder = split([
	            globalAttributes,
	            attributes
	          ].join(' '));
	          element = {
	            attributes: arrayToMap(attributesOrder),
	            attributesOrder: attributesOrder,
	            children: arrayToMap(children, dummyObj)
	          };
	          schema[names[ni]] = element;
	        }
	      };
	      var addAttrs = function (name, attributes) {
	        var ni, schemaItem, i, l;
	        var names = split(name);
	        ni = names.length;
	        var attrs = split(attributes);
	        while (ni--) {
	          schemaItem = schema[names[ni]];
	          for (i = 0, l = attrs.length; i < l; i++) {
	            schemaItem.attributes[attrs[i]] = {};
	            schemaItem.attributesOrder.push(attrs[i]);
	          }
	        }
	      };
	      if (mapCache[type]) {
	        return mapCache[type];
	      }
	      globalAttributes = 'id accesskey class dir lang style tabindex title role';
	      blockContent = 'address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul';
	      phrasingContent = 'a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd ' + 'label map noscript object q s samp script select small span strong sub sup ' + 'textarea u var #text #comment';
	      if (type !== 'html4') {
	        globalAttributes += ' contenteditable contextmenu draggable dropzone ' + 'hidden spellcheck translate';
	        blockContent += ' article aside details dialog figure main header footer hgroup section nav';
	        phrasingContent += ' audio canvas command datalist mark meter output picture ' + 'progress time wbr video ruby bdi keygen';
	      }
	      if (type !== 'html5-strict') {
	        globalAttributes += ' xml:lang';
	        html4PhrasingContent = 'acronym applet basefont big font strike tt';
	        phrasingContent = [
	          phrasingContent,
	          html4PhrasingContent
	        ].join(' ');
	        each$3(split(html4PhrasingContent), function (name) {
	          add(name, '', phrasingContent);
	        });
	        html4BlockContent = 'center dir isindex noframes';
	        blockContent = [
	          blockContent,
	          html4BlockContent
	        ].join(' ');
	        flowContent = [
	          blockContent,
	          phrasingContent
	        ].join(' ');
	        each$3(split(html4BlockContent), function (name) {
	          add(name, '', flowContent);
	        });
	      }
	      flowContent = flowContent || [
	        blockContent,
	        phrasingContent
	      ].join(' ');
	      add('html', 'manifest', 'head body');
	      add('head', '', 'base command link meta noscript script style title');
	      add('title hr noscript br');
	      add('base', 'href target');
	      add('link', 'href rel media hreflang type sizes hreflang');
	      add('meta', 'name http-equiv content charset');
	      add('style', 'media type scoped');
	      add('script', 'src async defer type charset');
	      add('body', 'onafterprint onbeforeprint onbeforeunload onblur onerror onfocus ' + 'onhashchange onload onmessage onoffline ononline onpagehide onpageshow ' + 'onpopstate onresize onscroll onstorage onunload', flowContent);
	      add('address dt dd div caption', '', flowContent);
	      add('h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn', '', phrasingContent);
	      add('blockquote', 'cite', flowContent);
	      add('ol', 'reversed start type', 'li');
	      add('ul', '', 'li');
	      add('li', 'value', flowContent);
	      add('dl', '', 'dt dd');
	      add('a', 'href target rel media hreflang type', phrasingContent);
	      add('q', 'cite', phrasingContent);
	      add('ins del', 'cite datetime', flowContent);
	      add('img', 'src sizes srcset alt usemap ismap width height');
	      add('iframe', 'src name width height', flowContent);
	      add('embed', 'src type width height');
	      add('object', 'data type typemustmatch name usemap form width height', [
	        flowContent,
	        'param'
	      ].join(' '));
	      add('param', 'name value');
	      add('map', 'name', [
	        flowContent,
	        'area'
	      ].join(' '));
	      add('area', 'alt coords shape href target rel media hreflang type');
	      add('table', 'border', 'caption colgroup thead tfoot tbody tr' + (type === 'html4' ? ' col' : ''));
	      add('colgroup', 'span', 'col');
	      add('col', 'span');
	      add('tbody thead tfoot', '', 'tr');
	      add('tr', '', 'td th');
	      add('td', 'colspan rowspan headers', flowContent);
	      add('th', 'colspan rowspan headers scope abbr', flowContent);
	      add('form', 'accept-charset action autocomplete enctype method name novalidate target', flowContent);
	      add('fieldset', 'disabled form name', [
	        flowContent,
	        'legend'
	      ].join(' '));
	      add('label', 'form for', phrasingContent);
	      add('input', 'accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate ' + 'formtarget height list max maxlength min multiple name pattern readonly required size src step type value width');
	      add('button', 'disabled form formaction formenctype formmethod formnovalidate formtarget name type value', type === 'html4' ? flowContent : phrasingContent);
	      add('select', 'disabled form multiple name required size', 'option optgroup');
	      add('optgroup', 'disabled label', 'option');
	      add('option', 'disabled label selected value');
	      add('textarea', 'cols dirname disabled form maxlength name readonly required rows wrap');
	      add('menu', 'type label', [
	        flowContent,
	        'li'
	      ].join(' '));
	      add('noscript', '', flowContent);
	      if (type !== 'html4') {
	        add('wbr');
	        add('ruby', '', [
	          phrasingContent,
	          'rt rp'
	        ].join(' '));
	        add('figcaption', '', flowContent);
	        add('mark rt rp summary bdi', '', phrasingContent);
	        add('canvas', 'width height', flowContent);
	        add('video', 'src crossorigin poster preload autoplay mediagroup loop ' + 'muted controls width height buffered', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('audio', 'src crossorigin preload autoplay mediagroup loop muted controls ' + 'buffered volume', [
	          flowContent,
	          'track source'
	        ].join(' '));
	        add('picture', '', 'img source');
	        add('source', 'src srcset type media sizes');
	        add('track', 'kind src srclang label default');
	        add('datalist', '', [
	          phrasingContent,
	          'option'
	        ].join(' '));
	        add('article section nav aside main header footer', '', flowContent);
	        add('hgroup', '', 'h1 h2 h3 h4 h5 h6');
	        add('figure', '', [
	          flowContent,
	          'figcaption'
	        ].join(' '));
	        add('time', 'datetime', phrasingContent);
	        add('dialog', 'open', flowContent);
	        add('command', 'type label icon disabled checked radiogroup command');
	        add('output', 'for form name', phrasingContent);
	        add('progress', 'value max', phrasingContent);
	        add('meter', 'value min max low high optimum', phrasingContent);
	        add('details', 'open', [
	          flowContent,
	          'summary'
	        ].join(' '));
	        add('keygen', 'autofocus challenge disabled form keytype name');
	      }
	      if (type !== 'html5-strict') {
	        addAttrs('script', 'language xml:space');
	        addAttrs('style', 'xml:space');
	        addAttrs('object', 'declare classid code codebase codetype archive standby align border hspace vspace');
	        addAttrs('embed', 'align name hspace vspace');
	        addAttrs('param', 'valuetype type');
	        addAttrs('a', 'charset name rev shape coords');
	        addAttrs('br', 'clear');
	        addAttrs('applet', 'codebase archive code object alt name width height align hspace vspace');
	        addAttrs('img', 'name longdesc align border hspace vspace');
	        addAttrs('iframe', 'longdesc frameborder marginwidth marginheight scrolling align');
	        addAttrs('font basefont', 'size color face');
	        addAttrs('input', 'usemap align');
	        addAttrs('select');
	        addAttrs('textarea');
	        addAttrs('h1 h2 h3 h4 h5 h6 div p legend caption', 'align');
	        addAttrs('ul', 'type compact');
	        addAttrs('li', 'type');
	        addAttrs('ol dl menu dir', 'compact');
	        addAttrs('pre', 'width xml:space');
	        addAttrs('hr', 'align noshade size width');
	        addAttrs('isindex', 'prompt');
	        addAttrs('table', 'summary width frame rules cellspacing cellpadding align bgcolor');
	        addAttrs('col', 'width align char charoff valign');
	        addAttrs('colgroup', 'width align char charoff valign');
	        addAttrs('thead', 'align char charoff valign');
	        addAttrs('tr', 'align char charoff valign bgcolor');
	        addAttrs('th', 'axis align char charoff valign nowrap bgcolor width height');
	        addAttrs('form', 'accept');
	        addAttrs('td', 'abbr axis scope align char charoff valign nowrap bgcolor width height');
	        addAttrs('tfoot', 'align char charoff valign');
	        addAttrs('tbody', 'align char charoff valign');
	        addAttrs('area', 'nohref');
	        addAttrs('body', 'background bgcolor text link vlink alink');
	      }
	      if (type !== 'html4') {
	        addAttrs('input button select textarea', 'autofocus');
	        addAttrs('input textarea', 'placeholder');
	        addAttrs('a', 'download');
	        addAttrs('link script img', 'crossorigin');
	        addAttrs('img', 'loading');
	        addAttrs('iframe', 'sandbox seamless allowfullscreen loading');
	      }
	      each$3(split('a form meter progress dfn'), function (name) {
	        if (schema[name]) {
	          delete schema[name].children[name];
	        }
	      });
	      delete schema.caption.children.table;
	      delete schema.script;
	      mapCache[type] = schema;
	      return schema;
	    };
	    var compileElementMap = function (value, mode) {
	      var styles;
	      if (value) {
	        styles = {};
	        if (typeof value === 'string') {
	          value = { '*': value };
	        }
	        each$3(value, function (value, key) {
	          styles[key] = styles[key.toUpperCase()] = mode === 'map' ? makeMap$2(value, /[, ]/) : explode$1(value, /[, ]/);
	        });
	      }
	      return styles;
	    };
	    var Schema = function (settings) {
	      var elements = {};
	      var children = {};
	      var patternElements = [];
	      var customElementsMap = {}, specialElements = {};
	      var createLookupTable = function (option, defaultValue, extendWith) {
	        var value = settings[option];
	        if (!value) {
	          value = mapCache[option];
	          if (!value) {
	            value = makeMap$2(defaultValue, ' ', makeMap$2(defaultValue.toUpperCase(), ' '));
	            value = extend$1(value, extendWith);
	            mapCache[option] = value;
	          }
	        } else {
	          value = makeMap$2(value, /[, ]/, makeMap$2(value.toUpperCase(), /[, ]/));
	        }
	        return value;
	      };
	      settings = settings || {};
	      var schemaItems = compileSchema(settings.schema);
	      if (settings.verify_html === false) {
	        settings.valid_elements = '*[*]';
	      }
	      var validStyles = compileElementMap(settings.valid_styles);
	      var invalidStyles = compileElementMap(settings.invalid_styles, 'map');
	      var validClasses = compileElementMap(settings.valid_classes, 'map');
	      var whiteSpaceElementsMap = createLookupTable('whitespace_elements', 'pre script noscript style textarea video audio iframe object code');
	      var selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
	      var shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' + 'meta param embed source wbr track');
	      var boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' + 'noshade nowrap readonly selected autoplay loop controls');
	      var nonEmptyOrMoveCaretBeforeOnEnter = 'td th iframe video audio object script code';
	      var nonEmptyElementsMap = createLookupTable('non_empty_elements', nonEmptyOrMoveCaretBeforeOnEnter + ' pre', shortEndedElementsMap);
	      var moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', nonEmptyOrMoveCaretBeforeOnEnter + ' table', shortEndedElementsMap);
	      var textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' + 'blockquote center dir fieldset header footer article section hgroup aside main nav figure');
	      var blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' + 'th tr td li ol ul caption dl dt dd noscript menu isindex option ' + 'datalist select optgroup figcaption details summary', textBlockElementsMap);
	      var textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' + 'dfn code mark q sup sub samp');
	      each$3((settings.special || 'script noscript iframe noframes noembed title style textarea xmp').split(' '), function (name) {
	        specialElements[name] = new RegExp('</' + name + '[^>]*>', 'gi');
	      });
	      var patternToRegExp = function (str) {
	        return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
	      };
	      var addValidElements = function (validElements) {
	        var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder, prefix, outputName, globalAttributes, globalAttributesOrder, value;
	        var elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/, attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, hasPatternsRegExp = /[*?+]/;
	        if (validElements) {
	          var validElementsArr = split(validElements, ',');
	          if (elements['@']) {
	            globalAttributes = elements['@'].attributes;
	            globalAttributesOrder = elements['@'].attributesOrder;
	          }
	          for (ei = 0, el = validElementsArr.length; ei < el; ei++) {
	            matches = elementRuleRegExp.exec(validElementsArr[ei]);
	            if (matches) {
	              prefix = matches[1];
	              elementName = matches[2];
	              outputName = matches[3];
	              attrData = matches[5];
	              attributes = {};
	              attributesOrder = [];
	              element = {
	                attributes: attributes,
	                attributesOrder: attributesOrder
	              };
	              if (prefix === '#') {
	                element.paddEmpty = true;
	              }
	              if (prefix === '-') {
	                element.removeEmpty = true;
	              }
	              if (matches[4] === '!') {
	                element.removeEmptyAttrs = true;
	              }
	              if (globalAttributes) {
	                each$1(globalAttributes, function (value, key) {
	                  attributes[key] = value;
	                });
	                attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
	              }
	              if (attrData) {
	                attrData = split(attrData, '|');
	                for (ai = 0, al = attrData.length; ai < al; ai++) {
	                  matches = attrRuleRegExp.exec(attrData[ai]);
	                  if (matches) {
	                    attr = {};
	                    attrType = matches[1];
	                    attrName = matches[2].replace(/[\\:]:/g, ':');
	                    prefix = matches[3];
	                    value = matches[4];
	                    if (attrType === '!') {
	                      element.attributesRequired = element.attributesRequired || [];
	                      element.attributesRequired.push(attrName);
	                      attr.required = true;
	                    }
	                    if (attrType === '-') {
	                      delete attributes[attrName];
	                      attributesOrder.splice(inArray(attributesOrder, attrName), 1);
	                      continue;
	                    }
	                    if (prefix) {
	                      if (prefix === '=') {
	                        element.attributesDefault = element.attributesDefault || [];
	                        element.attributesDefault.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.defaultValue = value;
	                      }
	                      if (prefix === ':') {
	                        element.attributesForced = element.attributesForced || [];
	                        element.attributesForced.push({
	                          name: attrName,
	                          value: value
	                        });
	                        attr.forcedValue = value;
	                      }
	                      if (prefix === '<') {
	                        attr.validValues = makeMap$2(value, '?');
	                      }
	                    }
	                    if (hasPatternsRegExp.test(attrName)) {
	                      element.attributePatterns = element.attributePatterns || [];
	                      attr.pattern = patternToRegExp(attrName);
	                      element.attributePatterns.push(attr);
	                    } else {
	                      if (!attributes[attrName]) {
	                        attributesOrder.push(attrName);
	                      }
	                      attributes[attrName] = attr;
	                    }
	                  }
	                }
	              }
	              if (!globalAttributes && elementName === '@') {
	                globalAttributes = attributes;
	                globalAttributesOrder = attributesOrder;
	              }
	              if (outputName) {
	                element.outputName = elementName;
	                elements[outputName] = element;
	              }
	              if (hasPatternsRegExp.test(elementName)) {
	                element.pattern = patternToRegExp(elementName);
	                patternElements.push(element);
	              } else {
	                elements[elementName] = element;
	              }
	            }
	          }
	        }
	      };
	      var setValidElements = function (validElements) {
	        elements = {};
	        patternElements = [];
	        addValidElements(validElements);
	        each$3(schemaItems, function (element, name) {
	          children[name] = element.children;
	        });
	      };
	      var addCustomElements = function (customElements) {
	        var customElementRegExp = /^(~)?(.+)$/;
	        if (customElements) {
	          mapCache.text_block_elements = mapCache.block_elements = null;
	          each$3(split(customElements, ','), function (rule) {
	            var matches = customElementRegExp.exec(rule), inline = matches[1] === '~', cloneName = inline ? 'span' : 'div', name = matches[2];
	            children[name] = children[cloneName];
	            customElementsMap[name] = cloneName;
	            if (!inline) {
	              blockElementsMap[name.toUpperCase()] = {};
	              blockElementsMap[name] = {};
	            }
	            if (!elements[name]) {
	              var customRule = elements[cloneName];
	              customRule = extend$1({}, customRule);
	              delete customRule.removeEmptyAttrs;
	              delete customRule.removeEmpty;
	              elements[name] = customRule;
	            }
	            each$3(children, function (element, elmName) {
	              if (element[cloneName]) {
	                children[elmName] = element = extend$1({}, children[elmName]);
	                element[name] = element[cloneName];
	              }
	            });
	          });
	        }
	      };
	      var addValidChildren = function (validChildren) {
	        var childRuleRegExp = /^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;
	        mapCache[settings.schema] = null;
	        if (validChildren) {
	          each$3(split(validChildren, ','), function (rule) {
	            var matches = childRuleRegExp.exec(rule);
	            var parent, prefix;
	            if (matches) {
	              prefix = matches[1];
	              if (prefix) {
	                parent = children[matches[2]];
	              } else {
	                parent = children[matches[2]] = { '#comment': {} };
	              }
	              parent = children[matches[2]];
	              each$3(split(matches[3], '|'), function (child) {
	                if (prefix === '-') {
	                  delete parent[child];
	                } else {
	                  parent[child] = {};
	                }
	              });
	            }
	          });
	        }
	      };
	      var getElementRule = function (name) {
	        var element = elements[name], i;
	        if (element) {
	          return element;
	        }
	        i = patternElements.length;
	        while (i--) {
	          element = patternElements[i];
	          if (element.pattern.test(name)) {
	            return element;
	          }
	        }
	      };
	      if (!settings.valid_elements) {
	        each$3(schemaItems, function (element, name) {
	          elements[name] = {
	            attributes: element.attributes,
	            attributesOrder: element.attributesOrder
	          };
	          children[name] = element.children;
	        });
	        if (settings.schema !== 'html5') {
	          each$3(split('strong/b em/i'), function (item) {
	            var items = split(item, '/');
	            elements[items[1]].outputName = items[0];
	          });
	        }
	        each$3(split('ol ul sub sup blockquote span font a table tbody strong em b i'), function (name) {
	          if (elements[name]) {
	            elements[name].removeEmpty = true;
	          }
	        });
	        each$3(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
	          elements[name].paddEmpty = true;
	        });
	        each$3(split('span'), function (name) {
	          elements[name].removeEmptyAttrs = true;
	        });
	      } else {
	        setValidElements(settings.valid_elements);
	      }
	      addCustomElements(settings.custom_elements);
	      addValidChildren(settings.valid_children);
	      addValidElements(settings.extended_valid_elements);
	      addValidChildren('+ol[ul|ol],+ul[ul|ol]');
	      each$3({
	        dd: 'dl',
	        dt: 'dl',
	        li: 'ul ol',
	        td: 'tr',
	        th: 'tr',
	        tr: 'tbody thead tfoot',
	        tbody: 'table',
	        thead: 'table',
	        tfoot: 'table',
	        legend: 'fieldset',
	        area: 'map',
	        param: 'video audio object'
	      }, function (parents, item) {
	        if (elements[item]) {
	          elements[item].parentsRequired = split(parents);
	        }
	      });
	      if (settings.invalid_elements) {
	        each$3(explode$1(settings.invalid_elements), function (item) {
	          if (elements[item]) {
	            delete elements[item];
	          }
	        });
	      }
	      if (!getElementRule('span')) {
	        addValidElements('span[!data-mce-type|*]');
	      }
	      var getValidStyles = function () {
	        return validStyles;
	      };
	      var getInvalidStyles = function () {
	        return invalidStyles;
	      };
	      var getValidClasses = function () {
	        return validClasses;
	      };
	      var getBoolAttrs = function () {
	        return boolAttrMap;
	      };
	      var getBlockElements = function () {
	        return blockElementsMap;
	      };
	      var getTextBlockElements = function () {
	        return textBlockElementsMap;
	      };
	      var getTextInlineElements = function () {
	        return textInlineElementsMap;
	      };
	      var getShortEndedElements = function () {
	        return shortEndedElementsMap;
	      };
	      var getSelfClosingElements = function () {
	        return selfClosingElementsMap;
	      };
	      var getNonEmptyElements = function () {
	        return nonEmptyElementsMap;
	      };
	      var getMoveCaretBeforeOnEnterElements = function () {
	        return moveCaretBeforeOnEnterElementsMap;
	      };
	      var getWhiteSpaceElements = function () {
	        return whiteSpaceElementsMap;
	      };
	      var getSpecialElements = function () {
	        return specialElements;
	      };
	      var isValidChild = function (name, child) {
	        var parent = children[name.toLowerCase()];
	        return !!(parent && parent[child.toLowerCase()]);
	      };
	      var isValid = function (name, attr) {
	        var attrPatterns, i;
	        var rule = getElementRule(name);
	        if (rule) {
	          if (attr) {
	            if (rule.attributes[attr]) {
	              return true;
	            }
	            attrPatterns = rule.attributePatterns;
	            if (attrPatterns) {
	              i = attrPatterns.length;
	              while (i--) {
	                if (attrPatterns[i].pattern.test(name)) {
	                  return true;
	                }
	              }
	            }
	          } else {
	            return true;
	          }
	        }
	        return false;
	      };
	      var getCustomElements = function () {
	        return customElementsMap;
	      };
	      return {
	        children: children,
	        elements: elements,
	        getValidStyles: getValidStyles,
	        getValidClasses: getValidClasses,
	        getBlockElements: getBlockElements,
	        getInvalidStyles: getInvalidStyles,
	        getShortEndedElements: getShortEndedElements,
	        getTextBlockElements: getTextBlockElements,
	        getTextInlineElements: getTextInlineElements,
	        getBoolAttrs: getBoolAttrs,
	        getElementRule: getElementRule,
	        getSelfClosingElements: getSelfClosingElements,
	        getNonEmptyElements: getNonEmptyElements,
	        getMoveCaretBeforeOnEnterElements: getMoveCaretBeforeOnEnterElements,
	        getWhiteSpaceElements: getWhiteSpaceElements,
	        getSpecialElements: getSpecialElements,
	        isValidChild: isValidChild,
	        isValid: isValid,
	        getCustomElements: getCustomElements,
	        addValidElements: addValidElements,
	        setValidElements: setValidElements,
	        addCustomElements: addCustomElements,
	        addValidChildren: addValidChildren
	      };
	    };
	
	    var toHex = function (match, r, g, b) {
	      var hex = function (val) {
	        val = parseInt(val, 10).toString(16);
	        return val.length > 1 ? val : '0' + val;
	      };
	      return '#' + hex(r) + hex(g) + hex(b);
	    };
	    var Styles = function (settings, schema) {
	      var _this = this;
	      var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi;
	      var urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi;
	      var styleRegExp = /\s*([^:]+):\s*([^;]+);?/g;
	      var trimRightRegExp = /\s+$/;
	      var i;
	      var encodingLookup = {};
	      var validStyles;
	      var invalidStyles;
	      var invisibleChar = zeroWidth;
	      settings = settings || {};
	      if (schema) {
	        validStyles = schema.getValidStyles();
	        invalidStyles = schema.getInvalidStyles();
	      }
	      var encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
	      for (i = 0; i < encodingItems.length; i++) {
	        encodingLookup[encodingItems[i]] = invisibleChar + i;
	        encodingLookup[invisibleChar + i] = encodingItems[i];
	      }
	      return {
	        toHex: function (color) {
	          return color.replace(rgbRegExp, toHex);
	        },
	        parse: function (css) {
	          var styles = {};
	          var matches, name, value, isEncoded;
	          var urlConverter = settings.url_converter;
	          var urlConverterScope = settings.url_converter_scope || _this;
	          var compress = function (prefix, suffix, noJoin) {
	            var top = styles[prefix + '-top' + suffix];
	            if (!top) {
	              return;
	            }
	            var right = styles[prefix + '-right' + suffix];
	            if (!right) {
	              return;
	            }
	            var bottom = styles[prefix + '-bottom' + suffix];
	            if (!bottom) {
	              return;
	            }
	            var left = styles[prefix + '-left' + suffix];
	            if (!left) {
	              return;
	            }
	            var box = [
	              top,
	              right,
	              bottom,
	              left
	            ];
	            i = box.length - 1;
	            while (i--) {
	              if (box[i] !== box[i + 1]) {
	                break;
	              }
	            }
	            if (i > -1 && noJoin) {
	              return;
	            }
	            styles[prefix + suffix] = i === -1 ? box[0] : box.join(' ');
	            delete styles[prefix + '-top' + suffix];
	            delete styles[prefix + '-right' + suffix];
	            delete styles[prefix + '-bottom' + suffix];
	            delete styles[prefix + '-left' + suffix];
	          };
	          var canCompress = function (key) {
	            var value = styles[key], i;
	            if (!value) {
	              return;
	            }
	            value = value.split(' ');
	            i = value.length;
	            while (i--) {
	              if (value[i] !== value[0]) {
	                return false;
	              }
	            }
	            styles[key] = value[0];
	            return true;
	          };
	          var compress2 = function (target, a, b, c) {
	            if (!canCompress(a)) {
	              return;
	            }
	            if (!canCompress(b)) {
	              return;
	            }
	            if (!canCompress(c)) {
	              return;
	            }
	            styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
	            delete styles[a];
	            delete styles[b];
	            delete styles[c];
	          };
	          var encode = function (str) {
	            isEncoded = true;
	            return encodingLookup[str];
	          };
	          var decode = function (str, keepSlashes) {
	            if (isEncoded) {
	              str = str.replace(/\uFEFF[0-9]/g, function (str) {
	                return encodingLookup[str];
	              });
	            }
	            if (!keepSlashes) {
	              str = str.replace(/\\([\'\";:])/g, '$1');
	            }
	            return str;
	          };
	          var decodeSingleHexSequence = function (escSeq) {
	            return String.fromCharCode(parseInt(escSeq.slice(1), 16));
	          };
	          var decodeHexSequences = function (value) {
	            return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
	          };
	          var processUrl = function (match, url, url2, url3, str, str2) {
	            str = str || str2;
	            if (str) {
	              str = decode(str);
	              return '\'' + str.replace(/\'/g, '\\\'') + '\'';
	            }
	            url = decode(url || url2 || url3);
	            if (!settings.allow_script_urls) {
	              var scriptUrl = url.replace(/[\s\r\n]+/g, '');
	              if (/(java|vb)script:/i.test(scriptUrl)) {
	                return '';
	              }
	              if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
	                return '';
	              }
	            }
	            if (urlConverter) {
	              url = urlConverter.call(urlConverterScope, url, 'style');
	            }
	            return 'url(\'' + url.replace(/\'/g, '\\\'') + '\')';
	          };
	          if (css) {
	            css = css.replace(/[\u0000-\u001F]/g, '');
	            css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
	              return str.replace(/[;:]/g, encode);
	            });
	            while (matches = styleRegExp.exec(css)) {
	              styleRegExp.lastIndex = matches.index + matches[0].length;
	              name = matches[1].replace(trimRightRegExp, '').toLowerCase();
	              value = matches[2].replace(trimRightRegExp, '');
	              if (name && value) {
	                name = decodeHexSequences(name);
	                value = decodeHexSequences(value);
	                if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
	                  continue;
	                }
	                if (!settings.allow_script_urls && (name === 'behavior' || /expression\s*\(|\/\*|\*\//.test(value))) {
	                  continue;
	                }
	                if (name === 'font-weight' && value === '700') {
	                  value = 'bold';
	                } else if (name === 'color' || name === 'background-color') {
	                  value = value.toLowerCase();
	                }
	                value = value.replace(rgbRegExp, toHex);
	                value = value.replace(urlOrStrRegExp, processUrl);
	                styles[name] = isEncoded ? decode(value, true) : value;
	              }
	            }
	            compress('border', '', true);
	            compress('border', '-width');
	            compress('border', '-color');
	            compress('border', '-style');
	            compress('padding', '');
	            compress('margin', '');
	            compress2('border', 'border-width', 'border-style', 'border-color');
	            if (styles.border === 'medium none') {
	              delete styles.border;
	            }
	            if (styles['border-image'] === 'none') {
	              delete styles['border-image'];
	            }
	          }
	          return styles;
	        },
	        serialize: function (styles, elementName) {
	          var css = '';
	          var serializeStyles = function (name) {
	            var value;
	            var styleList = validStyles[name];
	            if (styleList) {
	              for (var i_1 = 0, l = styleList.length; i_1 < l; i_1++) {
	                name = styleList[i_1];
	                value = styles[name];
	                if (value) {
	                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	                }
	              }
	            }
	          };
	          var isValid = function (name, elementName) {
	            var styleMap = invalidStyles['*'];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	            styleMap = invalidStyles[elementName];
	            return !(styleMap && styleMap[name]);
	          };
	          if (elementName && validStyles) {
	            serializeStyles('*');
	            serializeStyles(elementName);
	          } else {
	            each$1(styles, function (value, name) {
	              if (value && (!invalidStyles || isValid(name, elementName))) {
	                css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	              }
	            });
	          }
	          return css;
	        }
	      };
	    };
	
	    var eventExpandoPrefix = 'mce-data-';
	    var mouseEventRe = /^(?:mouse|contextmenu)|click/;
	    var deprecated = {
	      keyLocation: 1,
	      layerX: 1,
	      layerY: 1,
	      returnValue: 1,
	      webkitMovementX: 1,
	      webkitMovementY: 1,
	      keyIdentifier: 1,
	      mozPressure: 1
	    };
	    var hasIsDefaultPrevented = function (event) {
	      return event.isDefaultPrevented === returnTrue || event.isDefaultPrevented === returnFalse;
	    };
	    var returnFalse = never;
	    var returnTrue = always;
	    var addEvent = function (target, name, callback, capture) {
	      if (target.addEventListener) {
	        target.addEventListener(name, callback, capture || false);
	      } else if (target.attachEvent) {
	        target.attachEvent('on' + name, callback);
	      }
	    };
	    var removeEvent = function (target, name, callback, capture) {
	      if (target.removeEventListener) {
	        target.removeEventListener(name, callback, capture || false);
	      } else if (target.detachEvent) {
	        target.detachEvent('on' + name, callback);
	      }
	    };
	    var isMouseEvent = function (event) {
	      return mouseEventRe.test(event.type);
	    };
	    var fix = function (originalEvent, data) {
	      var name;
	      var event = data || {};
	      for (name in originalEvent) {
	        if (!deprecated[name]) {
	          event[name] = originalEvent[name];
	        }
	      }
	      if (!event.target) {
	        event.target = event.srcElement || document;
	      }
	      if (event.composedPath) {
	        event.composedPath = function () {
	          return originalEvent.composedPath();
	        };
	      }
	      if (originalEvent && isMouseEvent(originalEvent) && originalEvent.pageX === undefined && originalEvent.clientX !== undefined) {
	        var eventDoc = event.target.ownerDocument || document;
	        var doc = eventDoc.documentElement;
	        var body = eventDoc.body;
	        event.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	        event.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	      }
	      event.preventDefault = function () {
	        event.defaultPrevented = true;
	        event.isDefaultPrevented = returnTrue;
	        if (originalEvent) {
	          if (originalEvent.preventDefault) {
	            originalEvent.preventDefault();
	          } else {
	            originalEvent.returnValue = false;
	          }
	        }
	      };
	      event.stopPropagation = function () {
	        event.cancelBubble = true;
	        event.isPropagationStopped = returnTrue;
	        if (originalEvent) {
	          if (originalEvent.stopPropagation) {
	            originalEvent.stopPropagation();
	          } else {
	            originalEvent.cancelBubble = true;
	          }
	        }
	      };
	      event.stopImmediatePropagation = function () {
	        event.isImmediatePropagationStopped = returnTrue;
	        event.stopPropagation();
	      };
	      if (hasIsDefaultPrevented(event) === false) {
	        event.isDefaultPrevented = event.defaultPrevented === true ? returnTrue : returnFalse;
	        event.isPropagationStopped = event.cancelBubble === true ? returnTrue : returnFalse;
	        event.isImmediatePropagationStopped = returnFalse;
	      }
	      if (typeof event.metaKey === 'undefined') {
	        event.metaKey = false;
	      }
	      return event;
	    };
	    var bindOnReady = function (win, callback, eventUtils) {
	      var doc = win.document, event = { type: 'ready' };
	      if (eventUtils.domLoaded) {
	        callback(event);
	        return;
	      }
	      var isDocReady = function () {
	        return doc.readyState === 'complete' || doc.readyState === 'interactive' && doc.body;
	      };
	      var readyHandler = function () {
	        removeEvent(win, 'DOMContentLoaded', readyHandler);
	        removeEvent(win, 'load', readyHandler);
	        if (!eventUtils.domLoaded) {
	          eventUtils.domLoaded = true;
	          callback(event);
	        }
	        win = null;
	      };
	      if (isDocReady()) {
	        readyHandler();
	      } else {
	        addEvent(win, 'DOMContentLoaded', readyHandler);
	      }
	      if (!eventUtils.domLoaded) {
	        addEvent(win, 'load', readyHandler);
	      }
	    };
	    var EventUtils = function () {
	      function EventUtils() {
	        this.domLoaded = false;
	        this.events = {};
	        this.count = 1;
	        this.expando = eventExpandoPrefix + (+new Date()).toString(32);
	        this.hasMouseEnterLeave = 'onmouseenter' in document.documentElement;
	        this.hasFocusIn = 'onfocusin' in document.documentElement;
	        this.count = 1;
	      }
	      EventUtils.prototype.bind = function (target, names, callback, scope) {
	        var self = this;
	        var id, callbackList, i, name, fakeName, nativeHandler, capture;
	        var win = window;
	        var defaultNativeHandler = function (evt) {
	          self.executeHandlers(fix(evt || win.event), id);
	        };
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return;
	        }
	        if (!target[self.expando]) {
	          id = self.count++;
	          target[self.expando] = id;
	          self.events[id] = {};
	        } else {
	          id = target[self.expando];
	        }
	        scope = scope || target;
	        var namesList = names.split(' ');
	        i = namesList.length;
	        while (i--) {
	          name = namesList[i];
	          nativeHandler = defaultNativeHandler;
	          fakeName = capture = false;
	          if (name === 'DOMContentLoaded') {
	            name = 'ready';
	          }
	          if (self.domLoaded && name === 'ready' && target.readyState === 'complete') {
	            callback.call(scope, fix({ type: name }));
	            continue;
	          }
	          if (!self.hasMouseEnterLeave) {
	            fakeName = self.mouseEnterLeave[name];
	            if (fakeName) {
	              nativeHandler = function (evt) {
	                var current = evt.currentTarget;
	                var related = evt.relatedTarget;
	                if (related && current.contains) {
	                  related = current.contains(related);
	                } else {
	                  while (related && related !== current) {
	                    related = related.parentNode;
	                  }
	                }
	                if (!related) {
	                  evt = fix(evt || win.event);
	                  evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
	                  evt.target = current;
	                  self.executeHandlers(evt, id);
	                }
	              };
	            }
	          }
	          if (!self.hasFocusIn && (name === 'focusin' || name === 'focusout')) {
	            capture = true;
	            fakeName = name === 'focusin' ? 'focus' : 'blur';
	            nativeHandler = function (evt) {
	              evt = fix(evt || win.event);
	              evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
	              self.executeHandlers(evt, id);
	            };
	          }
	          callbackList = self.events[id][name];
	          if (!callbackList) {
	            self.events[id][name] = callbackList = [{
	                func: callback,
	                scope: scope
	              }];
	            callbackList.fakeName = fakeName;
	            callbackList.capture = capture;
	            callbackList.nativeHandler = nativeHandler;
	            if (name === 'ready') {
	              bindOnReady(target, nativeHandler, self);
	            } else {
	              addEvent(target, fakeName || name, nativeHandler, capture);
	            }
	          } else {
	            if (name === 'ready' && self.domLoaded) {
	              callback(fix({ type: name }));
	            } else {
	              callbackList.push({
	                func: callback,
	                scope: scope
	              });
	            }
	          }
	        }
	        target = callbackList = null;
	        return callback;
	      };
	      EventUtils.prototype.unbind = function (target, names, callback) {
	        var callbackList, i, ci, name, eventMap;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return this;
	        }
	        var id = target[this.expando];
	        if (id) {
	          eventMap = this.events[id];
	          if (names) {
	            var namesList = names.split(' ');
	            i = namesList.length;
	            while (i--) {
	              name = namesList[i];
	              callbackList = eventMap[name];
	              if (callbackList) {
	                if (callback) {
	                  ci = callbackList.length;
	                  while (ci--) {
	                    if (callbackList[ci].func === callback) {
	                      var nativeHandler = callbackList.nativeHandler;
	                      var fakeName = callbackList.fakeName, capture = callbackList.capture;
	                      callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
	                      callbackList.nativeHandler = nativeHandler;
	                      callbackList.fakeName = fakeName;
	                      callbackList.capture = capture;
	                      eventMap[name] = callbackList;
	                    }
	                  }
	                }
	                if (!callback || callbackList.length === 0) {
	                  delete eventMap[name];
	                  removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	                }
	              }
	            }
	          } else {
	            each$1(eventMap, function (callbackList, name) {
	              removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	            });
	            eventMap = {};
	          }
	          for (name in eventMap) {
	            if (has(eventMap, name)) {
	              return this;
	            }
	          }
	          delete this.events[id];
	          try {
	            delete target[this.expando];
	          } catch (ex) {
	            target[this.expando] = null;
	          }
	        }
	        return this;
	      };
	      EventUtils.prototype.fire = function (target, name, args) {
	        var id;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return this;
	        }
	        var event = fix(null, args);
	        event.type = name;
	        event.target = target;
	        do {
	          id = target[this.expando];
	          if (id) {
	            this.executeHandlers(event, id);
	          }
	          target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
	        } while (target && !event.isPropagationStopped());
	        return this;
	      };
	      EventUtils.prototype.clean = function (target) {
	        var i, children;
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return this;
	        }
	        if (target[this.expando]) {
	          this.unbind(target);
	        }
	        if (!target.getElementsByTagName) {
	          target = target.document;
	        }
	        if (target && target.getElementsByTagName) {
	          this.unbind(target);
	          children = target.getElementsByTagName('*');
	          i = children.length;
	          while (i--) {
	            target = children[i];
	            if (target[this.expando]) {
	              this.unbind(target);
	            }
	          }
	        }
	        return this;
	      };
	      EventUtils.prototype.destroy = function () {
	        this.events = {};
	      };
	      EventUtils.prototype.cancel = function (e) {
	        if (e) {
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	        return false;
	      };
	      EventUtils.prototype.executeHandlers = function (evt, id) {
	        var container = this.events[id];
	        var callbackList = container && container[evt.type];
	        if (callbackList) {
	          for (var i = 0, l = callbackList.length; i < l; i++) {
	            var callback = callbackList[i];
	            if (callback && callback.func.call(callback.scope, evt) === false) {
	              evt.preventDefault();
	            }
	            if (evt.isImmediatePropagationStopped()) {
	              return;
	            }
	          }
	        }
	      };
	      EventUtils.Event = new EventUtils();
	      return EventUtils;
	    }();
	
	    var support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, setDocument, document$1, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains$3, expando = 'sizzle' + -new Date(), preferredDoc = window.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	        }
	        return 0;
	      }, strundefined = typeof undefined, MAX_NEGATIVE = 1 << 31, hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push = arr.push, slice = arr.slice, indexOf$2 = arr.indexOf || function (elem) {
	        var i = 0, len = this.length;
	        for (; i < len; i++) {
	          if (this[i] === elem) {
	            return i;
	          }
	        }
	        return -1;
	      }, booleans = 'checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped', whitespace = '[\\x20\\t\\r\\n\\f]', identifier = '(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+', attributes = '\\[' + whitespace + '*(' + identifier + ')(?:' + whitespace + '*([*^$|!~]?=)' + whitespace + '*(?:\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)"|(' + identifier + '))|)' + whitespace + '*\\]', pseudos = ':(' + identifier + ')(?:\\((' + '(\'((?:\\\\.|[^\\\\\'])*)\'|"((?:\\\\.|[^\\\\"])*)")|' + '((?:\\\\.|[^\\\\()[\\]]|' + attributes + ')*)|' + '.*' + ')\\)|)', rtrim = new RegExp('^' + whitespace + '+|((?:^|[^\\\\])(?:\\\\.)*)' + whitespace + '+$', 'g'), rcomma = new RegExp('^' + whitespace + '*,' + whitespace + '*'), rcombinators = new RegExp('^' + whitespace + '*([>+~]|' + whitespace + ')' + whitespace + '*'), rattributeQuotes = new RegExp('=' + whitespace + '*([^\\]\'"]*?)' + whitespace + '*\\]', 'g'), rpseudo = new RegExp(pseudos), ridentifier = new RegExp('^' + identifier + '$'), matchExpr = {
	        ID: new RegExp('^#(' + identifier + ')'),
	        CLASS: new RegExp('^\\.(' + identifier + ')'),
	        TAG: new RegExp('^(' + identifier + '|[*])'),
	        ATTR: new RegExp('^' + attributes),
	        PSEUDO: new RegExp('^' + pseudos),
	        CHILD: new RegExp('^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(' + whitespace + '*(even|odd|(([+-]|)(\\d*)n|)' + whitespace + '*(?:([+-]|)' + whitespace + '*(\\d+)|))' + whitespace + '*\\)|)', 'i'),
	        bool: new RegExp('^(?:' + booleans + ')$', 'i'),
	        needsContext: new RegExp('^' + whitespace + '*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(' + whitespace + '*((?:-\\d)?\\d*)' + whitespace + '*\\)|)(?=[^-]|$)', 'i')
	      }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, rescape = /'|\\/g, runescape = new RegExp('\\\\([\\da-f]{1,6}' + whitespace + '?|(' + whitespace + ')|.)', 'ig'), funescape = function (_, escaped, escapedWhitespace) {
	        var high = '0x' + escaped - 65536;
	        return high !== high || escapedWhitespace ? escaped : high < 0 ? String.fromCharCode(high + 65536) : String.fromCharCode(high >> 10 | 55296, high & 1023 | 56320);
	      };
	    try {
	      push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
	      arr[preferredDoc.childNodes.length].nodeType;
	    } catch (e) {
	      push = {
	        apply: arr.length ? function (target, els) {
	          push_native.apply(target, slice.call(els));
	        } : function (target, els) {
	          var j = target.length, i = 0;
	          while (target[j++] = els[i++]) {
	          }
	          target.length = j - 1;
	        }
	      };
	    }
	    var Sizzle = function (selector, context, results, seed) {
	      var match, elem, m, nodeType, i, groups, old, nid, newContext, newSelector;
	      if ((context ? context.ownerDocument || context : preferredDoc) !== document$1) {
	        setDocument(context);
	      }
	      context = context || document$1;
	      results = results || [];
	      if (!selector || typeof selector !== 'string') {
	        return results;
	      }
	      if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
	        return [];
	      }
	      if (documentIsHTML && !seed) {
	        if (match = rquickExpr.exec(selector)) {
	          if (m = match[1]) {
	            if (nodeType === 9) {
	              elem = context.getElementById(m);
	              if (elem && elem.parentNode) {
	                if (elem.id === m) {
	                  results.push(elem);
	                  return results;
	                }
	              } else {
	                return results;
	              }
	            } else {
	              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) && contains$3(context, elem) && elem.id === m) {
	                results.push(elem);
	                return results;
	              }
	            }
	          } else if (match[2]) {
	            push.apply(results, context.getElementsByTagName(selector));
	            return results;
	          } else if ((m = match[3]) && support.getElementsByClassName) {
	            push.apply(results, context.getElementsByClassName(m));
	            return results;
	          }
	        }
	        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	          nid = old = expando;
	          newContext = context;
	          newSelector = nodeType === 9 && selector;
	          if (nodeType === 1 && context.nodeName.toLowerCase() !== 'object') {
	            groups = tokenize(selector);
	            if (old = context.getAttribute('id')) {
	              nid = old.replace(rescape, '\\$&');
	            } else {
	              context.setAttribute('id', nid);
	            }
	            nid = '[id=\'' + nid + '\'] ';
	            i = groups.length;
	            while (i--) {
	              groups[i] = nid + toSelector(groups[i]);
	            }
	            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
	            newSelector = groups.join(',');
	          }
	          if (newSelector) {
	            try {
	              push.apply(results, newContext.querySelectorAll(newSelector));
	              return results;
	            } catch (qsaError) {
	            } finally {
	              if (!old) {
	                context.removeAttribute('id');
	              }
	            }
	          }
	        }
	      }
	      return select(selector.replace(rtrim, '$1'), context, results, seed);
	    };
	    function createCache() {
	      var keys = [];
	      function cache(key, value) {
	        if (keys.push(key + ' ') > Expr.cacheLength) {
	          delete cache[keys.shift()];
	        }
	        return cache[key + ' '] = value;
	      }
	      return cache;
	    }
	    function markFunction(fn) {
	      fn[expando] = true;
	      return fn;
	    }
	    function siblingCheck(a, b) {
	      var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && (~b.sourceIndex || MAX_NEGATIVE) - (~a.sourceIndex || MAX_NEGATIVE);
	      if (diff) {
	        return diff;
	      }
	      if (cur) {
	        while (cur = cur.nextSibling) {
	          if (cur === b) {
	            return -1;
	          }
	        }
	      }
	      return a ? 1 : -1;
	    }
	    function createInputPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return name === 'input' && elem.type === type;
	      };
	    }
	    function createButtonPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return (name === 'input' || name === 'button') && elem.type === type;
	      };
	    }
	    function createPositionalPseudo(fn) {
	      return markFunction(function (argument) {
	        argument = +argument;
	        return markFunction(function (seed, matches) {
	          var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
	          while (i--) {
	            if (seed[j = matchIndexes[i]]) {
	              seed[j] = !(matches[j] = seed[j]);
	            }
	          }
	        });
	      });
	    }
	    function testContext(context) {
	      return context && typeof context.getElementsByTagName !== strundefined && context;
	    }
	    support = Sizzle.support = {};
	    isXML = Sizzle.isXML = function (elem) {
	      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	      return documentElement ? documentElement.nodeName !== 'HTML' : false;
	    };
	    setDocument = Sizzle.setDocument = function (node) {
	      var hasCompare, doc = node ? node.ownerDocument || node : preferredDoc, parent = doc.defaultView;
	      function getTop(win) {
	        try {
	          return win.top;
	        } catch (ex) {
	        }
	        return null;
	      }
	      if (doc === document$1 || doc.nodeType !== 9 || !doc.documentElement) {
	        return document$1;
	      }
	      document$1 = doc;
	      docElem = doc.documentElement;
	      documentIsHTML = !isXML(doc);
	      if (parent && parent !== getTop(parent)) {
	        if (parent.addEventListener) {
	          parent.addEventListener('unload', function () {
	            setDocument();
	          }, false);
	        } else if (parent.attachEvent) {
	          parent.attachEvent('onunload', function () {
	            setDocument();
	          });
	        }
	      }
	      support.attributes = true;
	      support.getElementsByTagName = true;
	      support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
	      support.getById = true;
	      Expr.find.ID = function (id, context) {
	        if (typeof context.getElementById !== strundefined && documentIsHTML) {
	          var m = context.getElementById(id);
	          return m && m.parentNode ? [m] : [];
	        }
	      };
	      Expr.filter.ID = function (id) {
	        var attrId = id.replace(runescape, funescape);
	        return function (elem) {
	          return elem.getAttribute('id') === attrId;
	        };
	      };
	      Expr.find.TAG = support.getElementsByTagName ? function (tag, context) {
	        if (typeof context.getElementsByTagName !== strundefined) {
	          return context.getElementsByTagName(tag);
	        }
	      } : function (tag, context) {
	        var elem, tmp = [], i = 0, results = context.getElementsByTagName(tag);
	        if (tag === '*') {
	          while (elem = results[i++]) {
	            if (elem.nodeType === 1) {
	              tmp.push(elem);
	            }
	          }
	          return tmp;
	        }
	        return results;
	      };
	      Expr.find.CLASS = support.getElementsByClassName && function (className, context) {
	        if (documentIsHTML) {
	          return context.getElementsByClassName(className);
	        }
	      };
	      rbuggyMatches = [];
	      rbuggyQSA = [];
	      support.disconnectedMatch = true;
	      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join('|'));
	      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join('|'));
	      hasCompare = rnative.test(docElem.compareDocumentPosition);
	      contains$3 = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
	        var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
	        return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
	      } : function (a, b) {
	        if (b) {
	          while (b = b.parentNode) {
	            if (b === a) {
	              return true;
	            }
	          }
	        }
	        return false;
	      };
	      sortOrder = hasCompare ? function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	        if (compare) {
	          return compare;
	        }
	        compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : 1;
	        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
	          if (a === doc || a.ownerDocument === preferredDoc && contains$3(preferredDoc, a)) {
	            return -1;
	          }
	          if (b === doc || b.ownerDocument === preferredDoc && contains$3(preferredDoc, b)) {
	            return 1;
	          }
	          return sortInput ? indexOf$2.call(sortInput, a) - indexOf$2.call(sortInput, b) : 0;
	        }
	        return compare & 4 ? -1 : 1;
	      } : function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	          return 0;
	        }
	        var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [a], bp = [b];
	        if (!aup || !bup) {
	          return a === doc ? -1 : b === doc ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf$2.call(sortInput, a) - indexOf$2.call(sortInput, b) : 0;
	        } else if (aup === bup) {
	          return siblingCheck(a, b);
	        }
	        cur = a;
	        while (cur = cur.parentNode) {
	          ap.unshift(cur);
	        }
	        cur = b;
	        while (cur = cur.parentNode) {
	          bp.unshift(cur);
	        }
	        while (ap[i] === bp[i]) {
	          i++;
	        }
	        return i ? siblingCheck(ap[i], bp[i]) : ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
	      };
	      return doc;
	    };
	    Sizzle.matches = function (expr, elements) {
	      return Sizzle(expr, null, null, elements);
	    };
	    Sizzle.matchesSelector = function (elem, expr) {
	      if ((elem.ownerDocument || elem) !== document$1) {
	        setDocument(elem);
	      }
	      expr = expr.replace(rattributeQuotes, '=\'$1\']');
	      if (support.matchesSelector && documentIsHTML && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	        try {
	          var ret = matches.call(elem, expr);
	          if (ret || support.disconnectedMatch || elem.document && elem.document.nodeType !== 11) {
	            return ret;
	          }
	        } catch (e) {
	        }
	      }
	      return Sizzle(expr, document$1, null, [elem]).length > 0;
	    };
	    Sizzle.contains = function (context, elem) {
	      if ((context.ownerDocument || context) !== document$1) {
	        setDocument(context);
	      }
	      return contains$3(context, elem);
	    };
	    Sizzle.attr = function (elem, name) {
	      if ((elem.ownerDocument || elem) !== document$1) {
	        setDocument(elem);
	      }
	      var fn = Expr.attrHandle[name.toLowerCase()], val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
	      return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
	    };
	    Sizzle.error = function (msg) {
	      throw new Error('Syntax error, unrecognized expression: ' + msg);
	    };
	    Sizzle.uniqueSort = function (results) {
	      var elem, duplicates = [], j = 0, i = 0;
	      hasDuplicate = !support.detectDuplicates;
	      sortInput = !support.sortStable && results.slice(0);
	      results.sort(sortOrder);
	      if (hasDuplicate) {
	        while (elem = results[i++]) {
	          if (elem === results[i]) {
	            j = duplicates.push(i);
	          }
	        }
	        while (j--) {
	          results.splice(duplicates[j], 1);
	        }
	      }
	      sortInput = null;
	      return results;
	    };
	    getText = Sizzle.getText = function (elem) {
	      var node, ret = '', i = 0, nodeType = elem.nodeType;
	      if (!nodeType) {
	        while (node = elem[i++]) {
	          ret += getText(node);
	        }
	      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
	        if (typeof elem.textContent === 'string') {
	          return elem.textContent;
	        } else {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            ret += getText(elem);
	          }
	        }
	      } else if (nodeType === 3 || nodeType === 4) {
	        return elem.nodeValue;
	      }
	      return ret;
	    };
	    Expr = Sizzle.selectors = {
	      cacheLength: 50,
	      createPseudo: markFunction,
	      match: matchExpr,
	      attrHandle: {},
	      find: {},
	      relative: {
	        '>': {
	          dir: 'parentNode',
	          first: true
	        },
	        ' ': { dir: 'parentNode' },
	        '+': {
	          dir: 'previousSibling',
	          first: true
	        },
	        '~': { dir: 'previousSibling' }
	      },
	      preFilter: {
	        ATTR: function (match) {
	          match[1] = match[1].replace(runescape, funescape);
	          match[3] = (match[3] || match[4] || match[5] || '').replace(runescape, funescape);
	          if (match[2] === '~=') {
	            match[3] = ' ' + match[3] + ' ';
	          }
	          return match.slice(0, 4);
	        },
	        CHILD: function (match) {
	          match[1] = match[1].toLowerCase();
	          if (match[1].slice(0, 3) === 'nth') {
	            if (!match[3]) {
	              Sizzle.error(match[0]);
	            }
	            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === 'even' || match[3] === 'odd'));
	            match[5] = +(match[7] + match[8] || match[3] === 'odd');
	          } else if (match[3]) {
	            Sizzle.error(match[0]);
	          }
	          return match;
	        },
	        PSEUDO: function (match) {
	          var excess, unquoted = !match[6] && match[2];
	          if (matchExpr.CHILD.test(match[0])) {
	            return null;
	          }
	          if (match[3]) {
	            match[2] = match[4] || match[5] || '';
	          } else if (unquoted && rpseudo.test(unquoted) && (excess = tokenize(unquoted, true)) && (excess = unquoted.indexOf(')', unquoted.length - excess) - unquoted.length)) {
	            match[0] = match[0].slice(0, excess);
	            match[2] = unquoted.slice(0, excess);
	          }
	          return match.slice(0, 3);
	        }
	      },
	      filter: {
	        TAG: function (nodeNameSelector) {
	          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
	          return nodeNameSelector === '*' ? function () {
	            return true;
	          } : function (elem) {
	            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	          };
	        },
	        CLASS: function (className) {
	          var pattern = classCache[className + ' '];
	          return pattern || (pattern = new RegExp('(^|' + whitespace + ')' + className + '(' + whitespace + '|$)')) && classCache(className, function (elem) {
	            return pattern.test(typeof elem.className === 'string' && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute('class') || '');
	          });
	        },
	        ATTR: function (name, operator, check) {
	          return function (elem) {
	            var result = Sizzle.attr(elem, name);
	            if (result == null) {
	              return operator === '!=';
	            }
	            if (!operator) {
	              return true;
	            }
	            result += '';
	            return operator === '=' ? result === check : operator === '!=' ? result !== check : operator === '^=' ? check && result.indexOf(check) === 0 : operator === '*=' ? check && result.indexOf(check) > -1 : operator === '$=' ? check && result.slice(-check.length) === check : operator === '~=' ? (' ' + result + ' ').indexOf(check) > -1 : operator === '|=' ? result === check || result.slice(0, check.length + 1) === check + '-' : false;
	          };
	        },
	        CHILD: function (type, what, argument, first, last) {
	          var simple = type.slice(0, 3) !== 'nth', forward = type.slice(-4) !== 'last', ofType = what === 'of-type';
	          return first === 1 && last === 0 ? function (elem) {
	            return !!elem.parentNode;
	          } : function (elem, context, xml) {
	            var cache, outerCache, node, diff, nodeIndex, start, dir = simple !== forward ? 'nextSibling' : 'previousSibling', parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType;
	            if (parent) {
	              if (simple) {
	                while (dir) {
	                  node = elem;
	                  while (node = node[dir]) {
	                    if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	                      return false;
	                    }
	                  }
	                  start = dir = type === 'only' && !start && 'nextSibling';
	                }
	                return true;
	              }
	              start = [forward ? parent.firstChild : parent.lastChild];
	              if (forward && useCache) {
	                outerCache = parent[expando] || (parent[expando] = {});
	                cache = outerCache[type] || [];
	                nodeIndex = cache[0] === dirruns && cache[1];
	                diff = cache[0] === dirruns && cache[2];
	                node = nodeIndex && parent.childNodes[nodeIndex];
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if (node.nodeType === 1 && ++diff && node === elem) {
	                    outerCache[type] = [
	                      dirruns,
	                      nodeIndex,
	                      diff
	                    ];
	                    break;
	                  }
	                }
	              } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
	                diff = cache[1];
	              } else {
	                while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
	                  if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	                    if (useCache) {
	                      (node[expando] || (node[expando] = {}))[type] = [
	                        dirruns,
	                        diff
	                      ];
	                    }
	                    if (node === elem) {
	                      break;
	                    }
	                  }
	                }
	              }
	              diff -= last;
	              return diff === first || diff % first === 0 && diff / first >= 0;
	            }
	          };
	        },
	        PSEUDO: function (pseudo, argument) {
	          var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error('unsupported pseudo: ' + pseudo);
	          if (fn[expando]) {
	            return fn(argument);
	          }
	          if (fn.length > 1) {
	            args = [
	              pseudo,
	              pseudo,
	              '',
	              argument
	            ];
	            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
	              var idx, matched = fn(seed, argument), i = matched.length;
	              while (i--) {
	                idx = indexOf$2.call(seed, matched[i]);
	                seed[idx] = !(matches[idx] = matched[i]);
	              }
	            }) : function (elem) {
	              return fn(elem, 0, args);
	            };
	          }
	          return fn;
	        }
	      },
	      pseudos: {
	        not: markFunction(function (selector) {
	          var input = [], results = [], matcher = compile(selector.replace(rtrim, '$1'));
	          return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
	            var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
	            while (i--) {
	              if (elem = unmatched[i]) {
	                seed[i] = !(matches[i] = elem);
	              }
	            }
	          }) : function (elem, context, xml) {
	            input[0] = elem;
	            matcher(input, null, xml, results);
	            input[0] = null;
	            return !results.pop();
	          };
	        }),
	        has: markFunction(function (selector) {
	          return function (elem) {
	            return Sizzle(selector, elem).length > 0;
	          };
	        }),
	        contains: markFunction(function (text) {
	          text = text.replace(runescape, funescape);
	          return function (elem) {
	            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
	          };
	        }),
	        lang: markFunction(function (lang) {
	          if (!ridentifier.test(lang || '')) {
	            Sizzle.error('unsupported lang: ' + lang);
	          }
	          lang = lang.replace(runescape, funescape).toLowerCase();
	          return function (elem) {
	            var elemLang;
	            do {
	              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute('xml:lang') || elem.getAttribute('lang')) {
	                elemLang = elemLang.toLowerCase();
	                return elemLang === lang || elemLang.indexOf(lang + '-') === 0;
	              }
	            } while ((elem = elem.parentNode) && elem.nodeType === 1);
	            return false;
	          };
	        }),
	        target: function (elem) {
	          var hash = window.location && window.location.hash;
	          return hash && hash.slice(1) === elem.id;
	        },
	        root: function (elem) {
	          return elem === docElem;
	        },
	        focus: function (elem) {
	          return elem === document$1.activeElement && (!document$1.hasFocus || document$1.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	        },
	        enabled: function (elem) {
	          return elem.disabled === false;
	        },
	        disabled: function (elem) {
	          return elem.disabled === true;
	        },
	        checked: function (elem) {
	          var nodeName = elem.nodeName.toLowerCase();
	          return nodeName === 'input' && !!elem.checked || nodeName === 'option' && !!elem.selected;
	        },
	        selected: function (elem) {
	          if (elem.parentNode) {
	            elem.parentNode.selectedIndex;
	          }
	          return elem.selected === true;
	        },
	        empty: function (elem) {
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            if (elem.nodeType < 6) {
	              return false;
	            }
	          }
	          return true;
	        },
	        parent: function (elem) {
	          return !Expr.pseudos.empty(elem);
	        },
	        header: function (elem) {
	          return rheader.test(elem.nodeName);
	        },
	        input: function (elem) {
	          return rinputs.test(elem.nodeName);
	        },
	        button: function (elem) {
	          var name = elem.nodeName.toLowerCase();
	          return name === 'input' && elem.type === 'button' || name === 'button';
	        },
	        text: function (elem) {
	          var attr;
	          return elem.nodeName.toLowerCase() === 'input' && elem.type === 'text' && ((attr = elem.getAttribute('type')) == null || attr.toLowerCase() === 'text');
	        },
	        first: createPositionalPseudo(function () {
	          return [0];
	        }),
	        last: createPositionalPseudo(function (matchIndexes, length) {
	          return [length - 1];
	        }),
	        eq: createPositionalPseudo(function (matchIndexes, length, argument) {
	          return [argument < 0 ? argument + length : argument];
	        }),
	        even: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 0;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        odd: createPositionalPseudo(function (matchIndexes, length) {
	          var i = 1;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        lt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; --i >= 0;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	        gt: createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; ++i < length;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        })
	      }
	    };
	    Expr.pseudos.nth = Expr.pseudos.eq;
	    each([
	      'radio',
	      'checkbox',
	      'file',
	      'password',
	      'image'
	    ], function (i) {
	      Expr.pseudos[i] = createInputPseudo(i);
	    });
	    each([
	      'submit',
	      'reset'
	    ], function (i) {
	      Expr.pseudos[i] = createButtonPseudo(i);
	    });
	    function setFilters() {
	    }
	    setFilters.prototype = Expr.filters = Expr.pseudos;
	    Expr.setFilters = new setFilters();
	    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
	      var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + ' '];
	      if (cached) {
	        return parseOnly ? 0 : cached.slice(0);
	      }
	      soFar = selector;
	      groups = [];
	      preFilters = Expr.preFilter;
	      while (soFar) {
	        if (!matched || (match = rcomma.exec(soFar))) {
	          if (match) {
	            soFar = soFar.slice(match[0].length) || soFar;
	          }
	          groups.push(tokens = []);
	        }
	        matched = false;
	        if (match = rcombinators.exec(soFar)) {
	          matched = match.shift();
	          tokens.push({
	            value: matched,
	            type: match[0].replace(rtrim, ' ')
	          });
	          soFar = soFar.slice(matched.length);
	        }
	        for (type in Expr.filter) {
	          if (!Expr.filter.hasOwnProperty(type)) {
	            continue;
	          }
	          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
	            matched = match.shift();
	            tokens.push({
	              value: matched,
	              type: type,
	              matches: match
	            });
	            soFar = soFar.slice(matched.length);
	          }
	        }
	        if (!matched) {
	          break;
	        }
	      }
	      return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : tokenCache(selector, groups).slice(0);
	    };
	    function toSelector(tokens) {
	      var i = 0, len = tokens.length, selector = '';
	      for (; i < len; i++) {
	        selector += tokens[i].value;
	      }
	      return selector;
	    }
	    function addCombinator(matcher, combinator, base) {
	      var dir = combinator.dir, checkNonElements = base && dir === 'parentNode', doneName = done++;
	      return combinator.first ? function (elem, context, xml) {
	        while (elem = elem[dir]) {
	          if (elem.nodeType === 1 || checkNonElements) {
	            return matcher(elem, context, xml);
	          }
	        }
	      } : function (elem, context, xml) {
	        var oldCache, outerCache, newCache = [
	            dirruns,
	            doneName
	          ];
	        if (xml) {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              if (matcher(elem, context, xml)) {
	                return true;
	              }
	            }
	          }
	        } else {
	          while (elem = elem[dir]) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              outerCache = elem[expando] || (elem[expando] = {});
	              if ((oldCache = outerCache[dir]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
	                return newCache[2] = oldCache[2];
	              } else {
	                outerCache[dir] = newCache;
	                if (newCache[2] = matcher(elem, context, xml)) {
	                  return true;
	                }
	              }
	            }
	          }
	        }
	      };
	    }
	    function elementMatcher(matchers) {
	      return matchers.length > 1 ? function (elem, context, xml) {
	        var i = matchers.length;
	        while (i--) {
	          if (!matchers[i](elem, context, xml)) {
	            return false;
	          }
	        }
	        return true;
	      } : matchers[0];
	    }
	    function multipleContexts(selector, contexts, results) {
	      var i = 0, len = contexts.length;
	      for (; i < len; i++) {
	        Sizzle(selector, contexts[i], results);
	      }
	      return results;
	    }
	    function condense(unmatched, map, filter, context, xml) {
	      var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
	      for (; i < len; i++) {
	        if (elem = unmatched[i]) {
	          if (!filter || filter(elem, context, xml)) {
	            newUnmatched.push(elem);
	            if (mapped) {
	              map.push(i);
	            }
	          }
	        }
	      }
	      return newUnmatched;
	    }
	    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
	      if (postFilter && !postFilter[expando]) {
	        postFilter = setMatcher(postFilter);
	      }
	      if (postFinder && !postFinder[expando]) {
	        postFinder = setMatcher(postFinder, postSelector);
	      }
	      return markFunction(function (seed, results, context, xml) {
	        var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, elems = seed || multipleContexts(selector || '*', context.nodeType ? [context] : context, []), matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? postFinder || (seed ? preFilter : preexisting || postFilter) ? [] : results : matcherIn;
	        if (matcher) {
	          matcher(matcherIn, matcherOut, context, xml);
	        }
	        if (postFilter) {
	          temp = condense(matcherOut, postMap);
	          postFilter(temp, [], context, xml);
	          i = temp.length;
	          while (i--) {
	            if (elem = temp[i]) {
	              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
	            }
	          }
	        }
	        if (seed) {
	          if (postFinder || preFilter) {
	            if (postFinder) {
	              temp = [];
	              i = matcherOut.length;
	              while (i--) {
	                if (elem = matcherOut[i]) {
	                  temp.push(matcherIn[i] = elem);
	                }
	              }
	              postFinder(null, matcherOut = [], temp, xml);
	            }
	            i = matcherOut.length;
	            while (i--) {
	              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf$2.call(seed, elem) : preMap[i]) > -1) {
	                seed[temp] = !(results[temp] = elem);
	              }
	            }
	          }
	        } else {
	          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
	          if (postFinder) {
	            postFinder(null, results, matcherOut, xml);
	          } else {
	            push.apply(results, matcherOut);
	          }
	        }
	      });
	    }
	    function matcherFromTokens(tokens) {
	      var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[' '], i = leadingRelative ? 1 : 0, matchContext = addCombinator(function (elem) {
	          return elem === checkContext;
	        }, implicitRelative, true), matchAnyContext = addCombinator(function (elem) {
	          return indexOf$2.call(checkContext, elem) > -1;
	        }, implicitRelative, true), matchers = [function (elem, context, xml) {
	            var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
	            checkContext = null;
	            return ret;
	          }];
	      for (; i < len; i++) {
	        if (matcher = Expr.relative[tokens[i].type]) {
	          matchers = [addCombinator(elementMatcher(matchers), matcher)];
	        } else {
	          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	          if (matcher[expando]) {
	            j = ++i;
	            for (; j < len; j++) {
	              if (Expr.relative[tokens[j].type]) {
	                break;
	              }
	            }
	            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === ' ' ? '*' : '' })).replace(rtrim, '$1'), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
	          }
	          matchers.push(matcher);
	        }
	      }
	      return elementMatcher(matchers);
	    }
	    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
	      var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function (seed, context, xml, results, outermost) {
	          var elem, j, matcher, matchedCount = 0, i = '0', unmatched = seed && [], setMatched = [], contextBackup = outermostContext, elems = seed || byElement && Expr.find.TAG('*', outermost), dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
	          if (outermost) {
	            outermostContext = context !== document$1 && context;
	          }
	          for (; i !== len && (elem = elems[i]) != null; i++) {
	            if (byElement && elem) {
	              j = 0;
	              while (matcher = elementMatchers[j++]) {
	                if (matcher(elem, context, xml)) {
	                  results.push(elem);
	                  break;
	                }
	              }
	              if (outermost) {
	                dirruns = dirrunsUnique;
	              }
	            }
	            if (bySet) {
	              if (elem = !matcher && elem) {
	                matchedCount--;
	              }
	              if (seed) {
	                unmatched.push(elem);
	              }
	            }
	          }
	          matchedCount += i;
	          if (bySet && i !== matchedCount) {
	            j = 0;
	            while (matcher = setMatchers[j++]) {
	              matcher(unmatched, setMatched, context, xml);
	            }
	            if (seed) {
	              if (matchedCount > 0) {
	                while (i--) {
	                  if (!(unmatched[i] || setMatched[i])) {
	                    setMatched[i] = pop.call(results);
	                  }
	                }
	              }
	              setMatched = condense(setMatched);
	            }
	            push.apply(results, setMatched);
	            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
	              Sizzle.uniqueSort(results);
	            }
	          }
	          if (outermost) {
	            dirruns = dirrunsUnique;
	            outermostContext = contextBackup;
	          }
	          return unmatched;
	        };
	      return bySet ? markFunction(superMatcher) : superMatcher;
	    }
	    compile = Sizzle.compile = function (selector, match) {
	      var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + ' '];
	      if (!cached) {
	        if (!match) {
	          match = tokenize(selector);
	        }
	        i = match.length;
	        while (i--) {
	          cached = matcherFromTokens(match[i]);
	          if (cached[expando]) {
	            setMatchers.push(cached);
	          } else {
	            elementMatchers.push(cached);
	          }
	        }
	        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	        cached.selector = selector;
	      }
	      return cached;
	    };
	    select = Sizzle.select = function (selector, context, results, seed) {
	      var i, tokens, token, type, find, compiled = typeof selector === 'function' && selector, match = !seed && tokenize(selector = compiled.selector || selector);
	      results = results || [];
	      if (match.length === 1) {
	        tokens = match[0] = match[0].slice(0);
	        if (tokens.length > 2 && (token = tokens[0]).type === 'ID' && support.getById && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
	          context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
	          if (!context) {
	            return results;
	          } else if (compiled) {
	            context = context.parentNode;
	          }
	          selector = selector.slice(tokens.shift().value.length);
	        }
	        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
	        while (i--) {
	          token = tokens[i];
	          if (Expr.relative[type = token.type]) {
	            break;
	          }
	          if (find = Expr.find[type]) {
	            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
	              tokens.splice(i, 1);
	              selector = seed.length && toSelector(tokens);
	              if (!selector) {
	                push.apply(results, seed);
	                return results;
	              }
	              break;
	            }
	          }
	        }
	      }
	      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, rsibling.test(selector) && testContext(context.parentNode) || context);
	      return results;
	    };
	    support.sortStable = expando.split('').sort(sortOrder).join('') === expando;
	    support.detectDuplicates = !!hasDuplicate;
	    setDocument();
	    support.sortDetached = true;
	
	    var doc = document;
	    var push$1 = Array.prototype.push;
	    var slice$1 = Array.prototype.slice;
	    var rquickExpr$1 = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	    var Event = EventUtils.Event;
	    var skipUniques = Tools.makeMap('children,contents,next,prev');
	    var isDefined = function (obj) {
	      return typeof obj !== 'undefined';
	    };
	    var isString$1 = function (obj) {
	      return typeof obj === 'string';
	    };
	    var isWindow = function (obj) {
	      return obj && obj === obj.window;
	    };
	    var createFragment = function (html, fragDoc) {
	      fragDoc = fragDoc || doc;
	      var container = fragDoc.createElement('div');
	      var frag = fragDoc.createDocumentFragment();
	      container.innerHTML = html;
	      var node;
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
	      var i;
	      if (isString$1(sourceItem)) {
	        sourceItem = createFragment(sourceItem, getElementDocument(targetNodes[0]));
	      } else if (sourceItem.length && !sourceItem.nodeType) {
	        sourceItem = DomQuery.makeArray(sourceItem);
	        if (reverse) {
	          for (i = sourceItem.length - 1; i >= 0; i--) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        } else {
	          for (i = 0; i < sourceItem.length; i++) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        }
	        return targetNodes;
	      }
	      if (sourceItem.nodeType) {
	        i = targetNodes.length;
	        while (i--) {
	          callback.call(targetNodes[i], sourceItem);
	        }
	      }
	      return targetNodes;
	    };
	    var hasClass = function (node, className) {
	      return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    };
	    var wrap$1 = function (elements, wrapper, all) {
	      var lastParent, newWrapper;
	      wrapper = DomQuery(wrapper)[0];
	      elements.each(function () {
	        var self = this;
	        if (!all || lastParent !== self.parentNode) {
	          lastParent = self.parentNode;
	          newWrapper = wrapper.cloneNode(false);
	          self.parentNode.insertBefore(newWrapper, self);
	          newWrapper.appendChild(self);
	        } else {
	          newWrapper.appendChild(self);
	        }
	      });
	      return elements;
	    };
	    var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
	    var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
	    var propFix = {
	      for: 'htmlFor',
	      class: 'className',
	      readonly: 'readOnly'
	    };
	    var cssFix = { float: 'cssFloat' };
	    var attrHooks = {}, cssHooks = {};
	    var DomQueryConstructor = function (selector, context) {
	      return new DomQuery.fn.init(selector, context);
	    };
	    var inArray$1 = function (item, array) {
	      var i;
	      if (array.indexOf) {
	        return array.indexOf(item);
	      }
	      i = array.length;
	      while (i--) {
	        if (array[i] === item) {
	          return i;
	        }
	      }
	      return -1;
	    };
	    var whiteSpaceRegExp$2 = /^\s*|\s*$/g;
	    var trim$3 = function (str) {
	      return str === null || str === undefined ? '' : ('' + str).replace(whiteSpaceRegExp$2, '');
	    };
	    var each$4 = function (obj, callback) {
	      var length, key, i, value;
	      if (obj) {
	        length = obj.length;
	        if (length === undefined) {
	          for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	              value = obj[key];
	              if (callback.call(value, key, value) === false) {
	                break;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < length; i++) {
	            value = obj[i];
	            if (callback.call(value, i, value) === false) {
	              break;
	            }
	          }
	        }
	      }
	      return obj;
	    };
	    var grep = function (array, callback) {
	      var out = [];
	      each$4(array, function (i, item) {
	        if (callback(item, i)) {
	          out.push(item);
	        }
	      });
	      return out;
	    };
	    var getElementDocument = function (element) {
	      if (!element) {
	        return doc;
	      }
	      if (element.nodeType === 9) {
	        return element;
	      }
	      return element.ownerDocument;
	    };
	    DomQueryConstructor.fn = DomQueryConstructor.prototype = {
	      constructor: DomQueryConstructor,
	      selector: '',
	      context: null,
	      length: 0,
	      init: function (selector, context) {
	        var self = this;
	        var match, node;
	        if (!selector) {
	          return self;
	        }
	        if (selector.nodeType) {
	          self.context = self[0] = selector;
	          self.length = 1;
	          return self;
	        }
	        if (context && context.nodeType) {
	          self.context = context;
	        } else {
	          if (context) {
	            return DomQuery(selector).attr(context);
	          }
	          self.context = context = document;
	        }
	        if (isString$1(selector)) {
	          self.selector = selector;
	          if (selector.charAt(0) === '<' && selector.charAt(selector.length - 1) === '>' && selector.length >= 3) {
	            match = [
	              null,
	              selector,
	              null
	            ];
	          } else {
	            match = rquickExpr$1.exec(selector);
	          }
	          if (match) {
	            if (match[1]) {
	              node = createFragment(selector, getElementDocument(context)).firstChild;
	              while (node) {
	                push$1.call(self, node);
	                node = node.nextSibling;
	              }
	            } else {
	              node = getElementDocument(context).getElementById(match[2]);
	              if (!node) {
	                return self;
	              }
	              if (node.id !== match[2]) {
	                return self.find(selector);
	              }
	              self.length = 1;
	              self[0] = node;
	            }
	          } else {
	            return DomQuery(context).find(selector);
	          }
	        } else {
	          this.add(selector, false);
	        }
	        return self;
	      },
	      toArray: function () {
	        return Tools.toArray(this);
	      },
	      add: function (items, sort) {
	        var self = this;
	        var nodes, i;
	        if (isString$1(items)) {
	          return self.add(DomQuery(items));
	        }
	        if (sort !== false) {
	          nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
	          self.length = nodes.length;
	          for (i = 0; i < nodes.length; i++) {
	            self[i] = nodes[i];
	          }
	        } else {
	          push$1.apply(self, DomQuery.makeArray(items));
	        }
	        return self;
	      },
	      attr: function (name, value) {
	        var self = this;
	        var hook;
	        if (typeof name === 'object') {
	          each$4(name, function (name, value) {
	            self.attr(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            var hook;
	            if (this.nodeType === 1) {
	              hook = attrHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              if (value === null) {
	                this.removeAttribute(name, 2);
	              } else {
	                this.setAttribute(name, value, 2);
	              }
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType === 1) {
	            hook = attrHooks[name];
	            if (hook && hook.get) {
	              return hook.get(self[0], name);
	            }
	            if (booleanMap[name]) {
	              return self.prop(name) ? name : undefined;
	            }
	            value = self[0].getAttribute(name, 2);
	            if (value === null) {
	              value = undefined;
	            }
	          }
	          return value;
	        }
	        return self;
	      },
	      removeAttr: function (name) {
	        return this.attr(name, null);
	      },
	      prop: function (name, value) {
	        var self = this;
	        name = propFix[name] || name;
	        if (typeof name === 'object') {
	          each$4(name, function (name, value) {
	            self.prop(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            if (this.nodeType === 1) {
	              this[name] = value;
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType && name in self[0]) {
	            return self[0][name];
	          }
	          return value;
	        }
	        return self;
	      },
	      css: function (name, value) {
	        var self = this;
	        var elm, hook;
	        var camel = function (name) {
	          return name.replace(/-(\D)/g, function (a, b) {
	            return b.toUpperCase();
	          });
	        };
	        var dashed = function (name) {
	          return name.replace(/[A-Z]/g, function (a) {
	            return '-' + a;
	          });
	        };
	        if (typeof name === 'object') {
	          each$4(name, function (name, value) {
	            self.css(name, value);
	          });
	        } else {
	          if (isDefined(value)) {
	            name = camel(name);
	            if (typeof value === 'number' && !numericCssMap[name]) {
	              value = value.toString() + 'px';
	            }
	            self.each(function () {
	              var style = this.style;
	              hook = cssHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	              try {
	                this.style[cssFix[name] || name] = value;
	              } catch (ex) {
	              }
	              if (value === null || value === '') {
	                if (style.removeProperty) {
	                  style.removeProperty(dashed(name));
	                } else {
	                  style.removeAttribute(name);
	                }
	              }
	            });
	          } else {
	            elm = self[0];
	            hook = cssHooks[name];
	            if (hook && hook.get) {
	              return hook.get(elm);
	            }
	            if (elm.ownerDocument.defaultView) {
	              try {
	                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
	              } catch (ex) {
	                return undefined;
	              }
	            } else if (elm.currentStyle) {
	              return elm.currentStyle[camel(name)];
	            } else {
	              return '';
	            }
	          }
	        }
	        return self;
	      },
	      remove: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          Event.clean(node);
	          if (node.parentNode) {
	            node.parentNode.removeChild(node);
	          }
	        }
	        return this;
	      },
	      empty: function () {
	        var self = this;
	        var node, i = this.length;
	        while (i--) {
	          node = self[i];
	          while (node.firstChild) {
	            node.removeChild(node.firstChild);
	          }
	        }
	        return this;
	      },
	      html: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          try {
	            while (i--) {
	              self[i].innerHTML = value;
	            }
	          } catch (ex) {
	            DomQuery(self[i]).empty().append(value);
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerHTML : '';
	      },
	      text: function (value) {
	        var self = this;
	        var i;
	        if (isDefined(value)) {
	          i = self.length;
	          while (i--) {
	            if ('innerText' in self[i]) {
	              self[i].innerText = value;
	            } else {
	              self[0].textContent = value;
	            }
	          }
	          return self;
	        }
	        return self[0] ? self[0].innerText || self[0].textContent : '';
	      },
	      append: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.appendChild(node);
	          }
	        });
	      },
	      prepend: function () {
	        return domManipulate(this, arguments, function (node) {
	          if (this.nodeType === 1 || this.host && this.host.nodeType === 1) {
	            this.insertBefore(node, this.firstChild);
	          }
	        }, true);
	      },
	      before: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this);
	          });
	        }
	        return self;
	      },
	      after: function () {
	        var self = this;
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this.nextSibling);
	          }, true);
	        }
	        return self;
	      },
	      appendTo: function (val) {
	        DomQuery(val).append(this);
	        return this;
	      },
	      prependTo: function (val) {
	        DomQuery(val).prepend(this);
	        return this;
	      },
	      replaceWith: function (content) {
	        return this.before(content).remove();
	      },
	      wrap: function (content) {
	        return wrap$1(this, content);
	      },
	      wrapAll: function (content) {
	        return wrap$1(this, content, true);
	      },
	      wrapInner: function (content) {
	        this.each(function () {
	          DomQuery(this).contents().wrapAll(content);
	        });
	        return this;
	      },
	      unwrap: function () {
	        return this.parent().each(function () {
	          DomQuery(this).replaceWith(this.childNodes);
	        });
	      },
	      clone: function () {
	        var result = [];
	        this.each(function () {
	          result.push(this.cloneNode(true));
	        });
	        return DomQuery(result);
	      },
	      addClass: function (className) {
	        return this.toggleClass(className, true);
	      },
	      removeClass: function (className) {
	        return this.toggleClass(className, false);
	      },
	      toggleClass: function (className, state) {
	        var self = this;
	        if (typeof className !== 'string') {
	          return self;
	        }
	        if (className.indexOf(' ') !== -1) {
	          each$4(className.split(' '), function () {
	            self.toggleClass(this, state);
	          });
	        } else {
	          self.each(function (index, node) {
	            var classState = hasClass(node, className);
	            if (classState !== state) {
	              var existingClassName = node.className;
	              if (classState) {
	                node.className = trim$3((' ' + existingClassName + ' ').replace(' ' + className + ' ', ' '));
	              } else {
	                node.className += existingClassName ? ' ' + className : className;
	              }
	            }
	          });
	        }
	        return self;
	      },
	      hasClass: function (className) {
	        return hasClass(this[0], className);
	      },
	      each: function (callback) {
	        return each$4(this, callback);
	      },
	      on: function (name, callback) {
	        return this.each(function () {
	          Event.bind(this, name, callback);
	        });
	      },
	      off: function (name, callback) {
	        return this.each(function () {
	          Event.unbind(this, name, callback);
	        });
	      },
	      trigger: function (name) {
	        return this.each(function () {
	          if (typeof name === 'object') {
	            Event.fire(this, name.type, name);
	          } else {
	            Event.fire(this, name);
	          }
	        });
	      },
	      show: function () {
	        return this.css('display', '');
	      },
	      hide: function () {
	        return this.css('display', 'none');
	      },
	      slice: function () {
	        return DomQuery(slice$1.apply(this, arguments));
	      },
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	      first: function () {
	        return this.eq(0);
	      },
	      last: function () {
	        return this.eq(-1);
	      },
	      find: function (selector) {
	        var i, l;
	        var ret = [];
	        for (i = 0, l = this.length; i < l; i++) {
	          DomQuery.find(selector, this[i], ret);
	        }
	        return DomQuery(ret);
	      },
	      filter: function (selector) {
	        if (typeof selector === 'function') {
	          return DomQuery(grep(this.toArray(), function (item, i) {
	            return selector(i, item);
	          }));
	        }
	        return DomQuery(DomQuery.filter(selector, this.toArray()));
	      },
	      closest: function (selector) {
	        var result = [];
	        if (selector instanceof DomQuery) {
	          selector = selector[0];
	        }
	        this.each(function (i, node) {
	          while (node) {
	            if (typeof selector === 'string' && DomQuery(node).is(selector)) {
	              result.push(node);
	              break;
	            } else if (node === selector) {
	              result.push(node);
	              break;
	            }
	            node = node.parentNode;
	          }
	        });
	        return DomQuery(result);
	      },
	      offset: function (offset) {
	        var elm, doc, docElm;
	        var x = 0, y = 0, pos;
	        if (!offset) {
	          elm = this[0];
	          if (elm) {
	            doc = elm.ownerDocument;
	            docElm = doc.documentElement;
	            if (elm.getBoundingClientRect) {
	              pos = elm.getBoundingClientRect();
	              x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
	              y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
	            }
	          }
	          return {
	            left: x,
	            top: y
	          };
	        }
	        return this.css(offset);
	      },
	      push: push$1,
	      sort: Array.prototype.sort,
	      splice: Array.prototype.splice
	    };
	    Tools.extend(DomQueryConstructor, {
	      extend: Tools.extend,
	      makeArray: function (object) {
	        if (isWindow(object) || object.nodeType) {
	          return [object];
	        }
	        return Tools.toArray(object);
	      },
	      inArray: inArray$1,
	      isArray: Tools.isArray,
	      each: each$4,
	      trim: trim$3,
	      grep: grep,
	      find: Sizzle,
	      expr: Sizzle.selectors,
	      unique: Sizzle.uniqueSort,
	      text: Sizzle.getText,
	      contains: Sizzle.contains,
	      filter: function (expr, elems, not) {
	        var i = elems.length;
	        if (not) {
	          expr = ':not(' + expr + ')';
	        }
	        while (i--) {
	          if (elems[i].nodeType !== 1) {
	            elems.splice(i, 1);
	          }
	        }
	        if (elems.length === 1) {
	          elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
	        } else {
	          elems = DomQuery.find.matches(expr, elems);
	        }
	        return elems;
	      }
	    });
	    var dir = function (el, prop, until) {
	      var matched = [];
	      var cur = el[prop];
	      if (typeof until !== 'string' && until instanceof DomQuery) {
	        until = until[0];
	      }
	      while (cur && cur.nodeType !== 9) {
	        if (until !== undefined) {
	          if (cur === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(cur).is(until)) {
	            break;
	          }
	        }
	        if (cur.nodeType === 1) {
	          matched.push(cur);
	        }
	        cur = cur[prop];
	      }
	      return matched;
	    };
	    var sibling$1 = function (node, siblingName, nodeType, until) {
	      var result = [];
	      if (until instanceof DomQuery) {
	        until = until[0];
	      }
	      for (; node; node = node[siblingName]) {
	        if (nodeType && node.nodeType !== nodeType) {
	          continue;
	        }
	        if (until !== undefined) {
	          if (node === until) {
	            break;
	          }
	          if (typeof until === 'string' && DomQuery(node).is(until)) {
	            break;
	          }
	        }
	        result.push(node);
	      }
	      return result;
	    };
	    var firstSibling = function (node, siblingName, nodeType) {
	      for (node = node[siblingName]; node; node = node[siblingName]) {
	        if (node.nodeType === nodeType) {
	          return node;
	        }
	      }
	      return null;
	    };
	    each$4({
	      parent: function (node) {
	        var parent = node.parentNode;
	        return parent && parent.nodeType !== 11 ? parent : null;
	      },
	      parents: function (node) {
	        return dir(node, 'parentNode');
	      },
	      next: function (node) {
	        return firstSibling(node, 'nextSibling', 1);
	      },
	      prev: function (node) {
	        return firstSibling(node, 'previousSibling', 1);
	      },
	      children: function (node) {
	        return sibling$1(node.firstChild, 'nextSibling', 1);
	      },
	      contents: function (node) {
	        return Tools.toArray((node.nodeName === 'iframe' ? node.contentDocument || node.contentWindow.document : node).childNodes);
	      }
	    }, function (name, fn) {
	      DomQueryConstructor.fn[name] = function (selector) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          if (!skipUniques[name]) {
	            result = DomQuery.unique(result);
	          }
	          if (name.indexOf('parents') === 0) {
	            result = result.reverse();
	          }
	        }
	        var wrappedResult = DomQuery(result);
	        if (selector) {
	          return wrappedResult.filter(selector);
	        }
	        return wrappedResult;
	      };
	    });
	    each$4({
	      parentsUntil: function (node, until) {
	        return dir(node, 'parentNode', until);
	      },
	      nextUntil: function (node, until) {
	        return sibling$1(node, 'nextSibling', 1, until).slice(1);
	      },
	      prevUntil: function (node, until) {
	        return sibling$1(node, 'previousSibling', 1, until).slice(1);
	      }
	    }, function (name, fn) {
	      DomQueryConstructor.fn[name] = function (selector, filter) {
	        var self = this;
	        var result = [];
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	        if (this.length > 1) {
	          result = DomQuery.unique(result);
	          if (name.indexOf('parents') === 0 || name === 'prevUntil') {
	            result = result.reverse();
	          }
	        }
	        var wrappedResult = DomQuery(result);
	        if (filter) {
	          return wrappedResult.filter(filter);
	        }
	        return wrappedResult;
	      };
	    });
	    DomQueryConstructor.fn.is = function (selector) {
	      return !!selector && this.filter(selector).length > 0;
	    };
	    DomQueryConstructor.fn.init.prototype = DomQueryConstructor.fn;
	    DomQueryConstructor.overrideDefaults = function (callback) {
	      var defaults;
	      var sub = function (selector, context) {
	        defaults = defaults || callback();
	        if (arguments.length === 0) {
	          selector = defaults.element;
	        }
	        if (!context) {
	          context = defaults.context;
	        }
	        return new sub.fn.init(selector, context);
	      };
	      DomQuery.extend(sub, this);
	      return sub;
	    };
	    DomQueryConstructor.attrHooks = attrHooks;
	    DomQueryConstructor.cssHooks = cssHooks;
	    var DomQuery = DomQueryConstructor;
	
	    var each$5 = Tools.each;
	    var grep$1 = Tools.grep;
	    var isIE = Env.ie;
	    var simpleSelectorRe = /^([a-z0-9],?)+$/i;
	    var setupAttrHooks = function (styles, settings, getContext) {
	      var keepValues = settings.keep_values;
	      var keepUrlHook = {
	        set: function ($elm, value, name) {
	          if (settings.url_converter) {
	            value = settings.url_converter.call(settings.url_converter_scope || getContext(), value, name, $elm[0]);
	          }
	          $elm.attr('data-mce-' + name, value).attr(name, value);
	        },
	        get: function ($elm, name) {
	          return $elm.attr('data-mce-' + name) || $elm.attr(name);
	        }
	      };
	      var attrHooks = {
	        style: {
	          set: function ($elm, value) {
	            if (value !== null && typeof value === 'object') {
	              $elm.css(value);
	              return;
	            }
	            if (keepValues) {
	              $elm.attr('data-mce-style', value);
	            }
	            if (value !== null && typeof value === 'string') {
	              $elm.removeAttr('style');
	              $elm.css(styles.parse(value));
	            } else {
	              $elm.attr('style', value);
	            }
	          },
	          get: function ($elm) {
	            var value = $elm.attr('data-mce-style') || $elm.attr('style');
	            value = styles.serialize(styles.parse(value), $elm[0].nodeName);
	            return value;
	          }
	        }
	      };
	      if (keepValues) {
	        attrHooks.href = attrHooks.src = keepUrlHook;
	      }
	      return attrHooks;
	    };
	    var updateInternalStyleAttr = function (styles, $elm) {
	      var rawValue = $elm.attr('style');
	      var value = styles.serialize(styles.parse(rawValue), $elm[0].nodeName);
	      if (!value) {
	        value = null;
	      }
	      $elm.attr('data-mce-style', value);
	    };
	    var findNodeIndex = function (node, normalized) {
	      var idx = 0, lastNodeType, nodeType;
	      if (node) {
	        for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
	          nodeType = node.nodeType;
	          if (normalized && nodeType === 3) {
	            if (nodeType === lastNodeType || !node.nodeValue.length) {
	              continue;
	            }
	          }
	          idx++;
	          lastNodeType = nodeType;
	        }
	      }
	      return idx;
	    };
	    var DOMUtils = function (doc, settings) {
	      if (settings === void 0) {
	        settings = {};
	      }
	      var addedStyles = {};
	      var win = window;
	      var files = {};
	      var counter = 0;
	      var stdMode = true;
	      var boxModel = true;
	      var styleSheetLoader = instance.forElement(SugarElement.fromDom(doc), {
	        contentCssCors: settings.contentCssCors,
	        referrerPolicy: settings.referrerPolicy
	      });
	      var boundEvents = [];
	      var schema = settings.schema ? settings.schema : Schema({});
	      var styles = Styles({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope
	      }, settings.schema);
	      var events = settings.ownEvents ? new EventUtils() : EventUtils.Event;
	      var blockElementsMap = schema.getBlockElements();
	      var $ = DomQuery.overrideDefaults(function () {
	        return {
	          context: doc,
	          element: self.getRoot()
	        };
	      });
	      var isBlock = function (node) {
	        if (typeof node === 'string') {
	          return !!blockElementsMap[node];
	        } else if (node) {
	          var type = node.nodeType;
	          if (type) {
	            return !!(type === 1 && blockElementsMap[node.nodeName]);
	          }
	        }
	        return false;
	      };
	      var get = function (elm) {
	        return elm && doc && isString(elm) ? doc.getElementById(elm) : elm;
	      };
	      var $$ = function (elm) {
	        return $(typeof elm === 'string' ? get(elm) : elm);
	      };
	      var getAttrib = function (elm, name, defaultVal) {
	        var hook, value;
	        var $elm = $$(elm);
	        if ($elm.length) {
	          hook = attrHooks[name];
	          if (hook && hook.get) {
	            value = hook.get($elm, name);
	          } else {
	            value = $elm.attr(name);
	          }
	        }
	        if (typeof value === 'undefined') {
	          value = defaultVal || '';
	        }
	        return value;
	      };
	      var getAttribs = function (elm) {
	        var node = get(elm);
	        if (!node) {
	          return [];
	        }
	        return node.attributes;
	      };
	      var setAttrib = function (elm, name, value) {
	        if (value === '') {
	          value = null;
	        }
	        var $elm = $$(elm);
	        var originalValue = $elm.attr(name);
	        if (!$elm.length) {
	          return;
	        }
	        var hook = attrHooks[name];
	        if (hook && hook.set) {
	          hook.set($elm, value, name);
	        } else {
	          $elm.attr(name, value);
	        }
	        if (originalValue !== value && settings.onSetAttrib) {
	          settings.onSetAttrib({
	            attrElm: $elm,
	            attrName: name,
	            attrValue: value
	          });
	        }
	      };
	      var clone = function (node, deep) {
	        if (!isIE || node.nodeType !== 1 || deep) {
	          return node.cloneNode(deep);
	        } else {
	          var clone_1 = doc.createElement(node.nodeName);
	          each$5(getAttribs(node), function (attr) {
	            setAttrib(clone_1, attr.nodeName, getAttrib(node, attr.nodeName));
	          });
	          return clone_1;
	        }
	      };
	      var getRoot = function () {
	        return settings.root_element || doc.body;
	      };
	      var getViewPort = function (argWin) {
	        var vp = getBounds(argWin);
	        return {
	          x: vp.x,
	          y: vp.y,
	          w: vp.width,
	          h: vp.height
	        };
	      };
	      var getPos$1 = function (elm, rootElm) {
	        return getPos(doc.body, get(elm), rootElm);
	      };
	      var setStyle = function (elm, name, value) {
	        var $elm = isString(name) ? $$(elm).css(name, value) : $$(elm).css(name);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var setStyles = function (elm, stylesArg) {
	        var $elm = $$(elm).css(stylesArg);
	        if (settings.update_styles) {
	          updateInternalStyleAttr(styles, $elm);
	        }
	      };
	      var getStyle = function (elm, name, computed) {
	        var $elm = $$(elm);
	        if (computed) {
	          return $elm.css(name);
	        }
	        name = name.replace(/-(\D)/g, function (a, b) {
	          return b.toUpperCase();
	        });
	        if (name === 'float') {
	          name = Env.browser.isIE() ? 'styleFloat' : 'cssFloat';
	        }
	        return $elm[0] && $elm[0].style ? $elm[0].style[name] : undefined;
	      };
	      var getSize = function (elm) {
	        var w, h;
	        elm = get(elm);
	        w = getStyle(elm, 'width');
	        h = getStyle(elm, 'height');
	        if (w.indexOf('px') === -1) {
	          w = 0;
	        }
	        if (h.indexOf('px') === -1) {
	          h = 0;
	        }
	        return {
	          w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
	          h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
	        };
	      };
	      var getRect = function (elm) {
	        elm = get(elm);
	        var pos = getPos$1(elm);
	        var size = getSize(elm);
	        return {
	          x: pos.x,
	          y: pos.y,
	          w: size.w,
	          h: size.h
	        };
	      };
	      var is = function (elm, selector) {
	        var i;
	        if (!elm) {
	          return false;
	        }
	        if (!Array.isArray(elm)) {
	          if (selector === '*') {
	            return elm.nodeType === 1;
	          }
	          if (simpleSelectorRe.test(selector)) {
	            var selectors = selector.toLowerCase().split(/,/);
	            var elmName = elm.nodeName.toLowerCase();
	            for (i = selectors.length - 1; i >= 0; i--) {
	              if (selectors[i] === elmName) {
	                return true;
	              }
	            }
	            return false;
	          }
	          if (elm.nodeType && elm.nodeType !== 1) {
	            return false;
	          }
	        }
	        var elms = !Array.isArray(elm) ? [elm] : elm;
	        return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
	      };
	      var getParents = function (elm, selector, root, collect) {
	        var result = [];
	        var selectorVal;
	        var node = get(elm);
	        collect = collect === undefined;
	        root = root || (getRoot().nodeName !== 'BODY' ? getRoot().parentNode : null);
	        if (Tools.is(selector, 'string')) {
	          selectorVal = selector;
	          if (selector === '*') {
	            selector = function (node) {
	              return node.nodeType === 1;
	            };
	          } else {
	            selector = function (node) {
	              return is(node, selectorVal);
	            };
	          }
	        }
	        while (node) {
	          if (node === root || isNullable(node.nodeType) || isDocument$1(node) || isDocumentFragment$1(node)) {
	            break;
	          }
	          if (!selector || typeof selector === 'function' && selector(node)) {
	            if (collect) {
	              result.push(node);
	            } else {
	              return [node];
	            }
	          }
	          node = node.parentNode;
	        }
	        return collect ? result : null;
	      };
	      var getParent = function (node, selector, root) {
	        var parents = getParents(node, selector, root, false);
	        return parents && parents.length > 0 ? parents[0] : null;
	      };
	      var _findSib = function (node, selector, name) {
	        var func = selector;
	        if (node) {
	          if (typeof selector === 'string') {
	            func = function (node) {
	              return is(node, selector);
	            };
	          }
	          for (node = node[name]; node; node = node[name]) {
	            if (typeof func === 'function' && func(node)) {
	              return node;
	            }
	          }
	        }
	        return null;
	      };
	      var getNext = function (node, selector) {
	        return _findSib(node, selector, 'nextSibling');
	      };
	      var getPrev = function (node, selector) {
	        return _findSib(node, selector, 'previousSibling');
	      };
	      var select = function (selector, scope) {
	        return Sizzle(selector, get(scope) || settings.root_element || doc, []);
	      };
	      var run = function (elm, func, scope) {
	        var result;
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        if (!node) {
	          return false;
	        }
	        if (Tools.isArray(node) && (node.length || node.length === 0)) {
	          result = [];
	          each$5(node, function (elm, i) {
	            if (elm) {
	              result.push(func.call(scope, typeof elm === 'string' ? get(elm) : elm, i));
	            }
	          });
	          return result;
	        }
	        var context = scope ? scope : this;
	        return func.call(context, node);
	      };
	      var setAttribs = function (elm, attrs) {
	        $$(elm).each(function (i, node) {
	          each$5(attrs, function (value, name) {
	            setAttrib(node, name, value);
	          });
	        });
	      };
	      var setHTML = function (elm, html) {
	        var $elm = $$(elm);
	        if (isIE) {
	          $elm.each(function (i, target) {
	            if (target.canHaveHTML === false) {
	              return;
	            }
	            while (target.firstChild) {
	              target.removeChild(target.firstChild);
	            }
	            try {
	              target.innerHTML = '<br>' + html;
	              target.removeChild(target.firstChild);
	            } catch (ex) {
	              DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
	            }
	            return html;
	          });
	        } else {
	          $elm.html(html);
	        }
	      };
	      var add = function (parentElm, name, attrs, html, create) {
	        return run(parentElm, function (parentElm) {
	          var newElm = typeof name === 'string' ? doc.createElement(name) : name;
	          setAttribs(newElm, attrs);
	          if (html) {
	            if (typeof html !== 'string' && html.nodeType) {
	              newElm.appendChild(html);
	            } else if (typeof html === 'string') {
	              setHTML(newElm, html);
	            }
	          }
	          return !create ? parentElm.appendChild(newElm) : newElm;
	        });
	      };
	      var create = function (name, attrs, html) {
	        return add(doc.createElement(name), name, attrs, html, true);
	      };
	      var decode = Entities.decode;
	      var encode = Entities.encodeAllRaw;
	      var createHTML = function (name, attrs, html) {
	        var outHtml = '', key;
	        outHtml += '<' + name;
	        for (key in attrs) {
	          if (attrs.hasOwnProperty(key) && attrs[key] !== null && typeof attrs[key] !== 'undefined') {
	            outHtml += ' ' + key + '="' + encode(attrs[key]) + '"';
	          }
	        }
	        if (typeof html !== 'undefined') {
	          return outHtml + '>' + html + '</' + name + '>';
	        }
	        return outHtml + ' />';
	      };
	      var createFragment = function (html) {
	        var node;
	        var container = doc.createElement('div');
	        var frag = doc.createDocumentFragment();
	        frag.appendChild(container);
	        if (html) {
	          container.innerHTML = html;
	        }
	        while (node = container.firstChild) {
	          frag.appendChild(node);
	        }
	        frag.removeChild(container);
	        return frag;
	      };
	      var remove = function (node, keepChildren) {
	        var $node = $$(node);
	        if (keepChildren) {
	          $node.each(function () {
	            var child;
	            while (child = this.firstChild) {
	              if (child.nodeType === 3 && child.data.length === 0) {
	                this.removeChild(child);
	              } else {
	                this.parentNode.insertBefore(child, this);
	              }
	            }
	          }).remove();
	        } else {
	          $node.remove();
	        }
	        return $node.length > 1 ? $node.toArray() : $node[0];
	      };
	      var removeAllAttribs = function (e) {
	        return run(e, function (e) {
	          var i;
	          var attrs = e.attributes;
	          for (i = attrs.length - 1; i >= 0; i--) {
	            e.removeAttributeNode(attrs.item(i));
	          }
	        });
	      };
	      var parseStyle = function (cssText) {
	        return styles.parse(cssText);
	      };
	      var serializeStyle = function (stylesArg, name) {
	        return styles.serialize(stylesArg, name);
	      };
	      var addStyle = function (cssText) {
	        var head, styleElm;
	        if (self !== DOMUtils.DOM && doc === document) {
	          if (addedStyles[cssText]) {
	            return;
	          }
	          addedStyles[cssText] = true;
	        }
	        styleElm = doc.getElementById('mceDefaultStyles');
	        if (!styleElm) {
	          styleElm = doc.createElement('style');
	          styleElm.id = 'mceDefaultStyles';
	          styleElm.type = 'text/css';
	          head = doc.getElementsByTagName('head')[0];
	          if (head.firstChild) {
	            head.insertBefore(styleElm, head.firstChild);
	          } else {
	            head.appendChild(styleElm);
	          }
	        }
	        if (styleElm.styleSheet) {
	          styleElm.styleSheet.cssText += cssText;
	        } else {
	          styleElm.appendChild(doc.createTextNode(cssText));
	        }
	      };
	      var loadCSS = function (urls) {
	        if (!urls) {
	          urls = '';
	        }
	        each(urls.split(','), function (url) {
	          files[url] = true;
	          styleSheetLoader.load(url, noop);
	        });
	      };
	      var toggleClass = function (elm, cls, state) {
	        $$(elm).toggleClass(cls, state).each(function () {
	          if (this.className === '') {
	            DomQuery(this).attr('class', null);
	          }
	        });
	      };
	      var addClass = function (elm, cls) {
	        $$(elm).addClass(cls);
	      };
	      var removeClass = function (elm, cls) {
	        toggleClass(elm, cls, false);
	      };
	      var hasClass = function (elm, cls) {
	        return $$(elm).hasClass(cls);
	      };
	      var show = function (elm) {
	        $$(elm).show();
	      };
	      var hide = function (elm) {
	        $$(elm).hide();
	      };
	      var isHidden = function (elm) {
	        return $$(elm).css('display') === 'none';
	      };
	      var uniqueId = function (prefix) {
	        return (!prefix ? 'mce_' : prefix) + counter++;
	      };
	      var getOuterHTML = function (elm) {
	        var node = typeof elm === 'string' ? get(elm) : elm;
	        return isElement$1(node) ? node.outerHTML : DomQuery('<div></div>').append(DomQuery(node).clone()).html();
	      };
	      var setOuterHTML = function (elm, html) {
	        $$(elm).each(function () {
	          try {
	            if ('outerHTML' in this) {
	              this.outerHTML = html;
	              return;
	            }
	          } catch (ex) {
	          }
	          remove(DomQuery(this).html(html), true);
	        });
	      };
	      var insertAfter = function (node, reference) {
	        var referenceNode = get(reference);
	        return run(node, function (node) {
	          var parent = referenceNode.parentNode;
	          var nextSibling = referenceNode.nextSibling;
	          if (nextSibling) {
	            parent.insertBefore(node, nextSibling);
	          } else {
	            parent.appendChild(node);
	          }
	          return node;
	        });
	      };
	      var replace = function (newElm, oldElm, keepChildren) {
	        return run(oldElm, function (oldElm) {
	          if (Tools.is(oldElm, 'array')) {
	            newElm = newElm.cloneNode(true);
	          }
	          if (keepChildren) {
	            each$5(grep$1(oldElm.childNodes), function (node) {
	              newElm.appendChild(node);
	            });
	          }
	          return oldElm.parentNode.replaceChild(newElm, oldElm);
	        });
	      };
	      var rename = function (elm, name) {
	        var newElm;
	        if (elm.nodeName !== name.toUpperCase()) {
	          newElm = create(name);
	          each$5(getAttribs(elm), function (attrNode) {
	            setAttrib(newElm, attrNode.nodeName, getAttrib(elm, attrNode.nodeName));
	          });
	          replace(newElm, elm, true);
	        }
	        return newElm || elm;
	      };
	      var findCommonAncestor = function (a, b) {
	        var ps = a, pe;
	        while (ps) {
	          pe = b;
	          while (pe && ps !== pe) {
	            pe = pe.parentNode;
	          }
	          if (ps === pe) {
	            break;
	          }
	          ps = ps.parentNode;
	        }
	        if (!ps && a.ownerDocument) {
	          return a.ownerDocument.documentElement;
	        }
	        return ps;
	      };
	      var toHex = function (rgbVal) {
	        return styles.toHex(Tools.trim(rgbVal));
	      };
	      var isNonEmptyElement = function (node) {
	        if (isElement$1(node)) {
	          var isNamedAnchor = node.nodeName.toLowerCase() === 'a' && !getAttrib(node, 'href') && getAttrib(node, 'id');
	          if (getAttrib(node, 'name') || getAttrib(node, 'data-mce-bookmark') || isNamedAnchor) {
	            return true;
	          }
	        }
	        return false;
	      };
	      var isEmpty = function (node, elements) {
	        var type, name, brCount = 0;
	        if (isNonEmptyElement(node)) {
	          return false;
	        }
	        node = node.firstChild;
	        if (node) {
	          var walker = new DomTreeWalker(node, node.parentNode);
	          var whitespace = schema ? schema.getWhiteSpaceElements() : {};
	          elements = elements || (schema ? schema.getNonEmptyElements() : null);
	          do {
	            type = node.nodeType;
	            if (isElement$1(node)) {
	              var bogusVal = node.getAttribute('data-mce-bogus');
	              if (bogusVal) {
	                node = walker.next(bogusVal === 'all');
	                continue;
	              }
	              name = node.nodeName.toLowerCase();
	              if (elements && elements[name]) {
	                if (name === 'br') {
	                  brCount++;
	                  node = walker.next();
	                  continue;
	                }
	                return false;
	              }
	              if (isNonEmptyElement(node)) {
	                return false;
	              }
	            }
	            if (type === 8) {
	              return false;
	            }
	            if (type === 3 && !isWhitespaceText(node.nodeValue)) {
	              return false;
	            }
	            if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && isWhitespaceText(node.nodeValue)) {
	              return false;
	            }
	            node = walker.next();
	          } while (node);
	        }
	        return brCount <= 1;
	      };
	      var createRng = function () {
	        return doc.createRange();
	      };
	      var split = function (parentElm, splitElm, replacementElm) {
	        var range = createRng();
	        var beforeFragment;
	        var afterFragment;
	        var parentNode;
	        if (parentElm && splitElm) {
	          range.setStart(parentElm.parentNode, findNodeIndex(parentElm));
	          range.setEnd(splitElm.parentNode, findNodeIndex(splitElm));
	          beforeFragment = range.extractContents();
	          range = createRng();
	          range.setStart(splitElm.parentNode, findNodeIndex(splitElm) + 1);
	          range.setEnd(parentElm.parentNode, findNodeIndex(parentElm) + 1);
	          afterFragment = range.extractContents();
	          parentNode = parentElm.parentNode;
	          parentNode.insertBefore(trimNode(self, beforeFragment), parentElm);
	          if (replacementElm) {
	            parentNode.insertBefore(replacementElm, parentElm);
	          } else {
	            parentNode.insertBefore(splitElm, parentElm);
	          }
	          parentNode.insertBefore(trimNode(self, afterFragment), parentElm);
	          remove(parentElm);
	          return replacementElm || splitElm;
	        }
	      };
	      var bind = function (target, name, func, scope) {
	        if (Tools.isArray(target)) {
	          var i = target.length;
	          var rv = [];
	          while (i--) {
	            rv[i] = bind(target[i], name, func, scope);
	          }
	          return rv;
	        }
	        if (settings.collect && (target === doc || target === win)) {
	          boundEvents.push([
	            target,
	            name,
	            func,
	            scope
	          ]);
	        }
	        var output = events.bind(target, name, func, scope || self);
	        return output;
	      };
	      var unbind = function (target, name, func) {
	        if (Tools.isArray(target)) {
	          var i = target.length;
	          var rv = [];
	          while (i--) {
	            rv[i] = unbind(target[i], name, func);
	          }
	          return rv;
	        } else {
	          if (boundEvents.length > 0 && (target === doc || target === win)) {
	            var i = boundEvents.length;
	            while (i--) {
	              var item = boundEvents[i];
	              if (target === item[0] && (!name || name === item[1]) && (!func || func === item[2])) {
	                events.unbind(item[0], item[1], item[2]);
	              }
	            }
	          }
	          return events.unbind(target, name, func);
	        }
	      };
	      var fire = function (target, name, evt) {
	        return events.fire(target, name, evt);
	      };
	      var getContentEditable = function (node) {
	        if (node && isElement$1(node)) {
	          var contentEditable = node.getAttribute('data-mce-contenteditable');
	          if (contentEditable && contentEditable !== 'inherit') {
	            return contentEditable;
	          }
	          return node.contentEditable !== 'inherit' ? node.contentEditable : null;
	        } else {
	          return null;
	        }
	      };
	      var getContentEditableParent = function (node) {
	        var root = getRoot();
	        var state = null;
	        for (; node && node !== root; node = node.parentNode) {
	          state = getContentEditable(node);
	          if (state !== null) {
	            break;
	          }
	        }
	        return state;
	      };
	      var destroy = function () {
	        if (boundEvents.length > 0) {
	          var i = boundEvents.length;
	          while (i--) {
	            var item = boundEvents[i];
	            events.unbind(item[0], item[1], item[2]);
	          }
	        }
	        each$1(files, function (_, url) {
	          styleSheetLoader.unload(url);
	          delete files[url];
	        });
	        if (Sizzle.setDocument) {
	          Sizzle.setDocument();
	        }
	      };
	      var isChildOf = function (node, parent) {
	        while (node) {
	          if (parent === node) {
	            return true;
	          }
	          node = node.parentNode;
	        }
	        return false;
	      };
	      var dumpRng = function (r) {
	        return 'startContainer: ' + r.startContainer.nodeName + ', startOffset: ' + r.startOffset + ', endContainer: ' + r.endContainer.nodeName + ', endOffset: ' + r.endOffset;
	      };
	      var self = {
	        doc: doc,
	        settings: settings,
	        win: win,
	        files: files,
	        stdMode: stdMode,
	        boxModel: boxModel,
	        styleSheetLoader: styleSheetLoader,
	        boundEvents: boundEvents,
	        styles: styles,
	        schema: schema,
	        events: events,
	        isBlock: isBlock,
	        $: $,
	        $$: $$,
	        root: null,
	        clone: clone,
	        getRoot: getRoot,
	        getViewPort: getViewPort,
	        getRect: getRect,
	        getSize: getSize,
	        getParent: getParent,
	        getParents: getParents,
	        get: get,
	        getNext: getNext,
	        getPrev: getPrev,
	        select: select,
	        is: is,
	        add: add,
	        create: create,
	        createHTML: createHTML,
	        createFragment: createFragment,
	        remove: remove,
	        setStyle: setStyle,
	        getStyle: getStyle,
	        setStyles: setStyles,
	        removeAllAttribs: removeAllAttribs,
	        setAttrib: setAttrib,
	        setAttribs: setAttribs,
	        getAttrib: getAttrib,
	        getPos: getPos$1,
	        parseStyle: parseStyle,
	        serializeStyle: serializeStyle,
	        addStyle: addStyle,
	        loadCSS: loadCSS,
	        addClass: addClass,
	        removeClass: removeClass,
	        hasClass: hasClass,
	        toggleClass: toggleClass,
	        show: show,
	        hide: hide,
	        isHidden: isHidden,
	        uniqueId: uniqueId,
	        setHTML: setHTML,
	        getOuterHTML: getOuterHTML,
	        setOuterHTML: setOuterHTML,
	        decode: decode,
	        encode: encode,
	        insertAfter: insertAfter,
	        replace: replace,
	        rename: rename,
	        findCommonAncestor: findCommonAncestor,
	        toHex: toHex,
	        run: run,
	        getAttribs: getAttribs,
	        isEmpty: isEmpty,
	        createRng: createRng,
	        nodeIndex: findNodeIndex,
	        split: split,
	        bind: bind,
	        unbind: unbind,
	        fire: fire,
	        getContentEditable: getContentEditable,
	        getContentEditableParent: getContentEditableParent,
	        destroy: destroy,
	        isChildOf: isChildOf,
	        dumpRng: dumpRng
	      };
	      var attrHooks = setupAttrHooks(styles, settings, function () {
	        return self;
	      });
	      return self;
	    };
	    DOMUtils.DOM = DOMUtils(document);
	    DOMUtils.nodeIndex = findNodeIndex;
	
	    var DOM = DOMUtils.DOM;
	    var each$6 = Tools.each, grep$2 = Tools.grep;
	    var QUEUED = 0;
	    var LOADING = 1;
	    var LOADED = 2;
	    var FAILED = 3;
	    var ScriptLoader = function () {
	      function ScriptLoader(settings) {
	        if (settings === void 0) {
	          settings = {};
	        }
	        this.states = {};
	        this.queue = [];
	        this.scriptLoadedCallbacks = {};
	        this.queueLoadedCallbacks = [];
	        this.loading = 0;
	        this.settings = settings;
	      }
	      ScriptLoader.prototype._setReferrerPolicy = function (referrerPolicy) {
	        this.settings.referrerPolicy = referrerPolicy;
	      };
	      ScriptLoader.prototype.loadScript = function (url, success, failure) {
	        var dom = DOM;
	        var elm;
	        var cleanup = function () {
	          dom.remove(id);
	          if (elm) {
	            elm.onerror = elm.onload = elm = null;
	          }
	        };
	        var done = function () {
	          cleanup();
	          success();
	        };
	        var error = function () {
	          cleanup();
	          if (isFunction(failure)) {
	            failure();
	          } else {
	            if (typeof console !== 'undefined' && console.log) {
	              console.log('Failed to load script: ' + url);
	            }
	          }
	        };
	        var id = dom.uniqueId();
	        elm = document.createElement('script');
	        elm.id = id;
	        elm.type = 'text/javascript';
	        elm.src = Tools._addCacheSuffix(url);
	        if (this.settings.referrerPolicy) {
	          dom.setAttrib(elm, 'referrerpolicy', this.settings.referrerPolicy);
	        }
	        elm.onload = done;
	        elm.onerror = error;
	        (document.getElementsByTagName('head')[0] || document.body).appendChild(elm);
	      };
	      ScriptLoader.prototype.isDone = function (url) {
	        return this.states[url] === LOADED;
	      };
	      ScriptLoader.prototype.markDone = function (url) {
	        this.states[url] = LOADED;
	      };
	      ScriptLoader.prototype.add = function (url, success, scope, failure) {
	        var state = this.states[url];
	        this.queue.push(url);
	        if (state === undefined) {
	          this.states[url] = QUEUED;
	        }
	        if (success) {
	          if (!this.scriptLoadedCallbacks[url]) {
	            this.scriptLoadedCallbacks[url] = [];
	          }
	          this.scriptLoadedCallbacks[url].push({
	            success: success,
	            failure: failure,
	            scope: scope || this
	          });
	        }
	      };
	      ScriptLoader.prototype.load = function (url, success, scope, failure) {
	        return this.add(url, success, scope, failure);
	      };
	      ScriptLoader.prototype.remove = function (url) {
	        delete this.states[url];
	        delete this.scriptLoadedCallbacks[url];
	      };
	      ScriptLoader.prototype.loadQueue = function (success, scope, failure) {
	        this.loadScripts(this.queue, success, scope, failure);
	      };
	      ScriptLoader.prototype.loadScripts = function (scripts, success, scope, failure) {
	        var self = this;
	        var failures = [];
	        var execCallbacks = function (name, url) {
	          each$6(self.scriptLoadedCallbacks[url], function (callback) {
	            if (isFunction(callback[name])) {
	              callback[name].call(callback.scope);
	            }
	          });
	          self.scriptLoadedCallbacks[url] = undefined;
	        };
	        self.queueLoadedCallbacks.push({
	          success: success,
	          failure: failure,
	          scope: scope || this
	        });
	        var loadScripts = function () {
	          var loadingScripts = grep$2(scripts);
	          scripts.length = 0;
	          each$6(loadingScripts, function (url) {
	            if (self.states[url] === LOADED) {
	              execCallbacks('success', url);
	              return;
	            }
	            if (self.states[url] === FAILED) {
	              execCallbacks('failure', url);
	              return;
	            }
	            if (self.states[url] !== LOADING) {
	              self.states[url] = LOADING;
	              self.loading++;
	              self.loadScript(url, function () {
	                self.states[url] = LOADED;
	                self.loading--;
	                execCallbacks('success', url);
	                loadScripts();
	              }, function () {
	                self.states[url] = FAILED;
	                self.loading--;
	                failures.push(url);
	                execCallbacks('failure', url);
	                loadScripts();
	              });
	            }
	          });
	          if (!self.loading) {
	            var notifyCallbacks = self.queueLoadedCallbacks.slice(0);
	            self.queueLoadedCallbacks.length = 0;
	            each$6(notifyCallbacks, function (callback) {
	              if (failures.length === 0) {
	                if (isFunction(callback.success)) {
	                  callback.success.call(callback.scope);
	                }
	              } else {
	                if (isFunction(callback.failure)) {
	                  callback.failure.call(callback.scope, failures);
	                }
	              }
	            });
	          }
	        };
	        loadScripts();
	      };
	      ScriptLoader.ScriptLoader = new ScriptLoader();
	      return ScriptLoader;
	    }();
	
	    var Cell = function (initial) {
	      var value = initial;
	      var get = function () {
	        return value;
	      };
	      var set = function (v) {
	        value = v;
	      };
	      return {
	        get: get,
	        set: set
	      };
	    };
	
	    var isRaw = function (str) {
	      return isObject(str) && has(str, 'raw');
	    };
	    var isTokenised = function (str) {
	      return isArray(str) && str.length > 1;
	    };
	    var data = {};
	    var currentCode = Cell('en');
	    var getLanguageData = function () {
	      return get$1(data, currentCode.get());
	    };
	    var getData = function () {
	      return map$1(data, function (value) {
	        return __assign({}, value);
	      });
	    };
	    var setCode = function (newCode) {
	      if (newCode) {
	        currentCode.set(newCode);
	      }
	    };
	    var getCode = function () {
	      return currentCode.get();
	    };
	    var add = function (code, items) {
	      var langData = data[code];
	      if (!langData) {
	        data[code] = langData = {};
	      }
	      each$1(items, function (translation, name) {
	        langData[name.toLowerCase()] = translation;
	      });
	    };
	    var translate = function (text) {
	      var langData = getLanguageData().getOr({});
	      var toString = function (obj) {
	        if (isFunction(obj)) {
	          return Object.prototype.toString.call(obj);
	        }
	        return !isEmpty(obj) ? '' + obj : '';
	      };
	      var isEmpty = function (text) {
	        return text === '' || text === null || text === undefined;
	      };
	      var getLangData = function (text) {
	        var textstr = toString(text);
	        return get$1(langData, textstr.toLowerCase()).map(toString).getOr(textstr);
	      };
	      var removeContext = function (str) {
	        return str.replace(/{context:\w+}$/, '');
	      };
	      if (isEmpty(text)) {
	        return '';
	      }
	      if (isRaw(text)) {
	        return toString(text.raw);
	      }
	      if (isTokenised(text)) {
	        var values_1 = text.slice(1);
	        var substitued = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
	          return has(values_1, $2) ? toString(values_1[$2]) : $1;
	        });
	        return removeContext(substitued);
	      }
	      return removeContext(getLangData(text));
	    };
	    var isRtl = function () {
	      return getLanguageData().bind(function (items) {
	        return get$1(items, '_dir');
	      }).exists(function (dir) {
	        return dir === 'rtl';
	      });
	    };
	    var hasCode = function (code) {
	      return has(data, code);
	    };
	    var I18n = {
	      getData: getData,
	      setCode: setCode,
	      getCode: getCode,
	      add: add,
	      translate: translate,
	      isRtl: isRtl,
	      hasCode: hasCode
	    };
	
	    var AddOnManager = function () {
	      var items = [];
	      var urls = {};
	      var lookup = {};
	      var _listeners = [];
	      var runListeners = function (name, state) {
	        var matchedListeners = filter(_listeners, function (listener) {
	          return listener.name === name && listener.state === state;
	        });
	        each(matchedListeners, function (listener) {
	          return listener.callback();
	        });
	      };
	      var get = function (name) {
	        if (lookup[name]) {
	          return lookup[name].instance;
	        }
	        return undefined;
	      };
	      var dependencies = function (name) {
	        var result;
	        if (lookup[name]) {
	          result = lookup[name].dependencies;
	        }
	        return result || [];
	      };
	      var requireLangPack = function (name, languages) {
	        if (AddOnManager.languageLoad !== false) {
	          waitFor(name, function () {
	            var language = I18n.getCode();
	            var wrappedLanguages = ',' + (languages || '') + ',';
	            if (!language || languages && wrappedLanguages.indexOf(',' + language + ',') === -1) {
	              return;
	            }
	            ScriptLoader.ScriptLoader.add(urls[name] + '/langs/' + language + '.js');
	          }, 'loaded');
	        }
	      };
	      var add = function (id, addOn, dependencies) {
	        var addOnConstructor = addOn;
	        items.push(addOnConstructor);
	        lookup[id] = {
	          instance: addOnConstructor,
	          dependencies: dependencies
	        };
	        runListeners(id, 'added');
	        return addOnConstructor;
	      };
	      var remove = function (name) {
	        delete urls[name];
	        delete lookup[name];
	      };
	      var createUrl = function (baseUrl, dep) {
	        if (typeof dep === 'object') {
	          return dep;
	        }
	        return typeof baseUrl === 'string' ? {
	          prefix: '',
	          resource: dep,
	          suffix: ''
	        } : {
	          prefix: baseUrl.prefix,
	          resource: dep,
	          suffix: baseUrl.suffix
	        };
	      };
	      var addComponents = function (pluginName, scripts) {
	        var pluginUrl = urls[pluginName];
	        each(scripts, function (script) {
	          ScriptLoader.ScriptLoader.add(pluginUrl + '/' + script);
	        });
	      };
	      var loadDependencies = function (name, addOnUrl, success, scope) {
	        var deps = dependencies(name);
	        each(deps, function (dep) {
	          var newUrl = createUrl(addOnUrl, dep);
	          load(newUrl.resource, newUrl, undefined, undefined);
	        });
	        if (success) {
	          if (scope) {
	            success.call(scope);
	          } else {
	            success.call(ScriptLoader);
	          }
	        }
	      };
	      var load = function (name, addOnUrl, success, scope, failure) {
	        if (urls[name]) {
	          return;
	        }
	        var urlString = typeof addOnUrl === 'string' ? addOnUrl : addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
	        if (urlString.indexOf('/') !== 0 && urlString.indexOf('://') === -1) {
	          urlString = AddOnManager.baseURL + '/' + urlString;
	        }
	        urls[name] = urlString.substring(0, urlString.lastIndexOf('/'));
	        var done = function () {
	          runListeners(name, 'loaded');
	          loadDependencies(name, addOnUrl, success, scope);
	        };
	        if (lookup[name]) {
	          done();
	        } else {
	          ScriptLoader.ScriptLoader.add(urlString, done, scope, failure);
	        }
	      };
	      var waitFor = function (name, callback, state) {
	        if (state === void 0) {
	          state = 'added';
	        }
	        if (has(lookup, name) && state === 'added') {
	          callback();
	        } else if (has(urls, name) && state === 'loaded') {
	          callback();
	        } else {
	          _listeners.push({
	            name: name,
	            state: state,
	            callback: callback
	          });
	        }
	      };
	      return {
	        items: items,
	        urls: urls,
	        lookup: lookup,
	        _listeners: _listeners,
	        get: get,
	        dependencies: dependencies,
	        requireLangPack: requireLangPack,
	        add: add,
	        remove: remove,
	        createUrl: createUrl,
	        addComponents: addComponents,
	        load: load,
	        waitFor: waitFor
	      };
	    };
	    AddOnManager.languageLoad = true;
	    AddOnManager.baseURL = '';
	    AddOnManager.PluginManager = AddOnManager();
	    AddOnManager.ThemeManager = AddOnManager();
	
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer === null) {
	          timer = setTimeout(function () {
	            fn.apply(null, args);
	            timer = null;
	          }, rate);
	        }
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	    var last$2 = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (timer !== null) {
	          clearTimeout(timer);
	        }
	        timer = setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	        }, rate);
	      };
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    var read = function (element, attr) {
	      var value = get$4(element, attr);
	      return value === undefined || value === '' ? [] : value.split(' ');
	    };
	    var add$1 = function (element, attr, id) {
	      var old = read(element, attr);
	      var nu = old.concat([id]);
	      set(element, attr, nu.join(' '));
	      return true;
	    };
	    var remove$2 = function (element, attr, id) {
	      var nu = filter(read(element, attr), function (v) {
	        return v !== id;
	      });
	      if (nu.length > 0) {
	        set(element, attr, nu.join(' '));
	      } else {
	        remove$1(element, attr);
	      }
	      return false;
	    };
	
	    var supports = function (element) {
	      return element.dom.classList !== undefined;
	    };
	    var get$6 = function (element) {
	      return read(element, 'class');
	    };
	    var add$2 = function (element, clazz) {
	      return add$1(element, 'class', clazz);
	    };
	    var remove$3 = function (element, clazz) {
	      return remove$2(element, 'class', clazz);
	    };
	
	    var add$3 = function (element, clazz) {
	      if (supports(element)) {
	        element.dom.classList.add(clazz);
	      } else {
	        add$2(element, clazz);
	      }
	    };
	    var cleanClass = function (element) {
	      var classList = supports(element) ? element.dom.classList : get$6(element);
	      if (classList.length === 0) {
	        remove$1(element, 'class');
	      }
	    };
	    var remove$4 = function (element, clazz) {
	      if (supports(element)) {
	        var classList = element.dom.classList;
	        classList.remove(clazz);
	      } else {
	        remove$3(element, clazz);
	      }
	      cleanClass(element);
	    };
	    var has$2 = function (element, clazz) {
	      return supports(element) && element.dom.classList.contains(clazz);
	    };
	
	    var descendants = function (scope, predicate) {
	      var result = [];
	      each(children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([x]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    var descendants$1 = function (scope, selector) {
	      return all(selector, scope);
	    };
	
	    var annotation = constant('mce-annotation');
	    var dataAnnotation = constant('data-mce-annotation');
	    var dataAnnotationId = constant('data-mce-annotation-uid');
	
	    var identify = function (editor, annotationName) {
	      var rng = editor.selection.getRng();
	      var start = SugarElement.fromDom(rng.startContainer);
	      var root = SugarElement.fromDom(editor.getBody());
	      var selector = annotationName.fold(function () {
	        return '.' + annotation();
	      }, function (an) {
	        return '[' + dataAnnotation() + '="' + an + '"]';
	      });
	      var newStart = child(start, rng.startOffset).getOr(start);
	      var closest = closest$1(newStart, selector, function (n) {
	        return eq$2(n, root);
	      });
	      var getAttr = function (c, property) {
	        if (has$1(c, property)) {
	          return Optional.some(get$4(c, property));
	        } else {
	          return Optional.none();
	        }
	      };
	      return closest.bind(function (c) {
	        return getAttr(c, '' + dataAnnotationId()).bind(function (uid) {
	          return getAttr(c, '' + dataAnnotation()).map(function (name) {
	            var elements = findMarkers(editor, uid);
	            return {
	              uid: uid,
	              name: name,
	              elements: elements
	            };
	          });
	        });
	      });
	    };
	    var isAnnotation = function (elem) {
	      return isElement(elem) && has$2(elem, annotation());
	    };
	    var findMarkers = function (editor, uid) {
	      var body = SugarElement.fromDom(editor.getBody());
	      return descendants$1(body, '[' + dataAnnotationId() + '="' + uid + '"]');
	    };
	    var findAll = function (editor, name) {
	      var body = SugarElement.fromDom(editor.getBody());
	      var markers = descendants$1(body, '[' + dataAnnotation() + '="' + name + '"]');
	      var directory = {};
	      each(markers, function (m) {
	        var uid = get$4(m, dataAnnotationId());
	        var nodesAlready = directory.hasOwnProperty(uid) ? directory[uid] : [];
	        directory[uid] = nodesAlready.concat([m]);
	      });
	      return directory;
	    };
	
	    var setup = function (editor, _registry) {
	      var changeCallbacks = Cell({});
	      var initData = function () {
	        return {
	          listeners: [],
	          previous: Cell(Optional.none())
	        };
	      };
	      var withCallbacks = function (name, f) {
	        updateCallbacks(name, function (data) {
	          f(data);
	          return data;
	        });
	      };
	      var updateCallbacks = function (name, f) {
	        var callbackMap = changeCallbacks.get();
	        var data = callbackMap.hasOwnProperty(name) ? callbackMap[name] : initData();
	        var outputData = f(data);
	        callbackMap[name] = outputData;
	        changeCallbacks.set(callbackMap);
	      };
	      var fireCallbacks = function (name, uid, elements) {
	        withCallbacks(name, function (data) {
	          each(data.listeners, function (f) {
	            return f(true, name, {
	              uid: uid,
	              nodes: map(elements, function (elem) {
	                return elem.dom;
	              })
	            });
	          });
	        });
	      };
	      var fireNoAnnotation = function (name) {
	        withCallbacks(name, function (data) {
	          each(data.listeners, function (f) {
	            return f(false, name);
	          });
	        });
	      };
	      var onNodeChange = last$2(function () {
	        var callbackMap = changeCallbacks.get();
	        var annotations = sort$1(keys(callbackMap));
	        each(annotations, function (name) {
	          updateCallbacks(name, function (data) {
	            var prev = data.previous.get();
	            identify(editor, Optional.some(name)).fold(function () {
	              if (prev.isSome()) {
	                fireNoAnnotation(name);
	                data.previous.set(Optional.none());
	              }
	            }, function (_a) {
	              var uid = _a.uid, name = _a.name, elements = _a.elements;
	              if (!prev.is(uid)) {
	                fireCallbacks(name, uid, elements);
	                data.previous.set(Optional.some(uid));
	              }
	            });
	            return {
	              previous: data.previous,
	              listeners: data.listeners
	            };
	          });
	        });
	      }, 30);
	      editor.on('remove', function () {
	        onNodeChange.cancel();
	      });
	      editor.on('NodeChange', function () {
	        onNodeChange.throttle();
	      });
	      var addListener = function (name, f) {
	        updateCallbacks(name, function (data) {
	          return {
	            previous: data.previous,
	            listeners: data.listeners.concat([f])
	          };
	        });
	      };
	      return { addListener: addListener };
	    };
	
	    var setup$1 = function (editor, registry) {
	      var identifyParserNode = function (span) {
	        return Optional.from(span.attr(dataAnnotation())).bind(registry.lookup);
	      };
	      editor.on('init', function () {
	        editor.serializer.addNodeFilter('span', function (spans) {
	          each(spans, function (span) {
	            identifyParserNode(span).each(function (settings) {
	              if (settings.persistent === false) {
	                span.unwrap();
	              }
	            });
	          });
	        });
	      });
	    };
	
	    var create$2 = function () {
	      var annotations = {};
	      var register = function (name, settings) {
	        annotations[name] = {
	          name: name,
	          settings: settings
	        };
	      };
	      var lookup = function (name) {
	        return annotations.hasOwnProperty(name) ? Optional.from(annotations[name]).map(function (a) {
	          return a.settings;
	        }) : Optional.none();
	      };
	      return {
	        register: register,
	        lookup: lookup
	      };
	    };
	
	    var unique = 0;
	    var generate$1 = function (prefix) {
	      var date = new Date();
	      var time = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	      unique++;
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    var add$4 = function (element, classes) {
	      each(classes, function (x) {
	        add$3(element, x);
	      });
	    };
	
	    var fromHtml$1 = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      return children(SugarElement.fromDom(div));
	    };
	
	    var get$7 = function (element) {
	      return element.dom.innerHTML;
	    };
	    var set$1 = function (element, content) {
	      var owner$1 = owner(element);
	      var docDom = owner$1.dom;
	      var fragment = SugarElement.fromDom(docDom.createDocumentFragment());
	      var contentElements = fromHtml$1(content, docDom);
	      append$1(fragment, contentElements);
	      empty(element);
	      append(element, fragment);
	    };
	
	    var clone$1 = function (original, isDeep) {
	      return SugarElement.fromDom(original.dom.cloneNode(isDeep));
	    };
	    var shallow = function (original) {
	      return clone$1(original, false);
	    };
	    var deep = function (original) {
	      return clone$1(original, true);
	    };
	
	    var TextWalker = function (startNode, rootNode, isBoundary) {
	      if (isBoundary === void 0) {
	        isBoundary = never;
	      }
	      var walker = new DomTreeWalker(startNode, rootNode);
	      var walk = function (direction) {
	        var next;
	        do {
	          next = walker[direction]();
	        } while (next && !isText$1(next) && !isBoundary(next));
	        return Optional.from(next).filter(isText$1);
	      };
	      return {
	        current: function () {
	          return Optional.from(walker.current()).filter(isText$1);
	        },
	        next: function () {
	          return walk('next');
	        },
	        prev: function () {
	          return walk('prev');
	        },
	        prev2: function () {
	          return walk('prev2');
	        }
	      };
	    };
	
	    var TextSeeker = function (dom, isBoundary) {
	      var isBlockBoundary = isBoundary ? isBoundary : function (node) {
	        return dom.isBlock(node) || isBr(node) || isContentEditableFalse(node);
	      };
	      var walk = function (node, offset, walker, process) {
	        if (isText$1(node)) {
	          var newOffset = process(node, offset, node.data);
	          if (newOffset !== -1) {
	            return Optional.some({
	              container: node,
	              offset: newOffset
	            });
	          }
	        }
	        return walker().bind(function (next) {
	          return walk(next.container, next.offset, walker, process);
	        });
	      };
	      var backwards = function (node, offset, process, root) {
	        var walker = TextWalker(node, root, isBlockBoundary);
	        return walk(node, offset, function () {
	          return walker.prev().map(function (prev) {
	            return {
	              container: prev,
	              offset: prev.length
	            };
	          });
	        }, process).getOrNull();
	      };
	      var forwards = function (node, offset, process, root) {
	        var walker = TextWalker(node, root, isBlockBoundary);
	        return walk(node, offset, function () {
	          return walker.next().map(function (next) {
	            return {
	              container: next,
	              offset: 0
	            };
	          });
	        }, process).getOrNull();
	      };
	      return {
	        backwards: backwards,
	        forwards: forwards
	      };
	    };
	
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	    var lift2 = function (oa, ob, f) {
	      return oa.isSome() && ob.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie())) : Optional.none();
	    };
	    var lift3 = function (oa, ob, oc, f) {
	      return oa.isSome() && ob.isSome() && oc.isSome() ? Optional.some(f(oa.getOrDie(), ob.getOrDie(), oc.getOrDie())) : Optional.none();
	    };
	    var someIf = function (b, a) {
	      return b ? Optional.some(a) : Optional.none();
	    };
	
	    var round = Math.round;
	    var clone$2 = function (rect) {
	      if (!rect) {
	        return {
	          left: 0,
	          top: 0,
	          bottom: 0,
	          right: 0,
	          width: 0,
	          height: 0
	        };
	      }
	      return {
	        left: round(rect.left),
	        top: round(rect.top),
	        bottom: round(rect.bottom),
	        right: round(rect.right),
	        width: round(rect.width),
	        height: round(rect.height)
	      };
	    };
	    var collapse = function (rect, toStart) {
	      rect = clone$2(rect);
	      if (toStart) {
	        rect.right = rect.left;
	      } else {
	        rect.left = rect.left + rect.width;
	        rect.right = rect.left;
	      }
	      rect.width = 0;
	      return rect;
	    };
	    var isEqual = function (rect1, rect2) {
	      return rect1.left === rect2.left && rect1.top === rect2.top && rect1.bottom === rect2.bottom && rect1.right === rect2.right;
	    };
	    var isValidOverflow = function (overflowY, rect1, rect2) {
	      return overflowY >= 0 && overflowY <= Math.min(rect1.height, rect2.height) / 2;
	    };
	    var isAbove = function (rect1, rect2) {
	      var halfHeight = Math.min(rect2.height / 2, rect1.height / 2);
	      if (rect1.bottom - halfHeight < rect2.top) {
	        return true;
	      }
	      if (rect1.top > rect2.bottom) {
	        return false;
	      }
	      return isValidOverflow(rect2.top - rect1.bottom, rect1, rect2);
	    };
	    var isBelow = function (rect1, rect2) {
	      if (rect1.top > rect2.bottom) {
	        return true;
	      }
	      if (rect1.bottom < rect2.top) {
	        return false;
	      }
	      return isValidOverflow(rect2.bottom - rect1.top, rect1, rect2);
	    };
	    var containsXY = function (rect, clientX, clientY) {
	      return clientX >= rect.left && clientX <= rect.right && clientY >= rect.top && clientY <= rect.bottom;
	    };
	
	    var getSelectedNode = function (range) {
	      var startContainer = range.startContainer, startOffset = range.startOffset;
	      if (startContainer.hasChildNodes() && range.endOffset === startOffset + 1) {
	        return startContainer.childNodes[startOffset];
	      }
	      return null;
	    };
	    var getNode = function (container, offset) {
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        if (offset >= container.childNodes.length) {
	          offset = container.childNodes.length - 1;
	        }
	        container = container.childNodes[offset];
	      }
	      return container;
	    };
	
	    var extendingChars = new RegExp('[\u0300-\u036f\u0483-\u0487\u0488-\u0489\u0591-\u05bd\u05bf\u05c1-\u05c2\u05c4-\u05c5\u05c7\u0610-\u061a' + '\u064b-\u065f\u0670\u06d6-\u06dc\u06df-\u06e4\u06e7-\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0' + '\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0859-\u085b\u08e3-\u0902\u093a\u093c' + '\u0941-\u0948\u094d\u0951-\u0957\u0962-\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2-\u09e3' + '\u0a01-\u0a02\u0a3c\u0a41-\u0a42\u0a47-\u0a48\u0a4b-\u0a4d\u0a51\u0a70-\u0a71\u0a75\u0a81-\u0a82\u0abc' + '\u0ac1-\u0ac5\u0ac7-\u0ac8\u0acd\u0ae2-\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57' + '\u0b62-\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c00\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55-\u0c56' + '\u0c62-\u0c63\u0c81\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc-\u0ccd\u0cd5-\u0cd6\u0ce2-\u0ce3\u0d01\u0d3e\u0d41-\u0d44' + '\u0d4d\u0d57\u0d62-\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9' + '\u0ebb-\u0ebc\u0ec8-\u0ecd\u0f18-\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86-\u0f87\u0f8d-\u0f97' + '\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039-\u103a\u103d-\u103e\u1058-\u1059\u105e-\u1060\u1071-\u1074' + '\u1082\u1085-\u1086\u108d\u109d\u135d-\u135f\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17b4-\u17b5' + '\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193b\u1a17-\u1a18' + '\u1a1b\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1ab0-\u1abd\u1ABE\u1b00-\u1b03\u1b34' + '\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80-\u1b81\u1ba2-\u1ba5\u1ba8-\u1ba9\u1bab-\u1bad\u1be6\u1be8-\u1be9' + '\u1bed\u1bef-\u1bf1\u1c2c-\u1c33\u1c36-\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1cf4\u1cf8-\u1cf9' + '\u1dc0-\u1df5\u1dfc-\u1dff\u200c-\u200d\u20d0-\u20dc\u20DD-\u20E0\u20e1\u20E2-\u20E4\u20e5-\u20f0\u2cef-\u2cf1' + '\u2d7f\u2de0-\u2dff\u302a-\u302d\u302e-\u302f\u3099-\u309a\ua66f\uA670-\uA672\ua674-\ua67d\ua69e-\ua69f\ua6f0-\ua6f1' + '\ua802\ua806\ua80b\ua825-\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc' + '\ua9e5\uaa29-\uaa2e\uaa31-\uaa32\uaa35-\uaa36\uaa43\uaa4c\uaa7c\uaab0\uaab2-\uaab4\uaab7-\uaab8\uaabe-\uaabf\uaac1' + '\uaaec-\uaaed\uaaf6\uabe5\uabe8\uabed\ufb1e\ufe00-\ufe0f\ufe20-\ufe2f\uff9e-\uff9f]');
	    var isExtendingChar = function (ch) {
	      return typeof ch === 'string' && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	    };
	
	    var or = function () {
	      var args = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	      }
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (args[i](x)) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	    var and = function () {
	      var args = [];
	      for (var _i = 0; _i < arguments.length; _i++) {
	        args[_i] = arguments[_i];
	      }
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (!args[i](x)) {
	            return false;
	          }
	        }
	        return true;
	      };
	    };
	
	    var isElement$3 = isElement$1;
	    var isCaretCandidate$1 = isCaretCandidate;
	    var isBlock$1 = matchStyleValues('display', 'block table');
	    var isFloated = matchStyleValues('float', 'left right');
	    var isValidElementCaretCandidate = and(isElement$3, isCaretCandidate$1, not(isFloated));
	    var isNotPre = not(matchStyleValues('white-space', 'pre pre-line pre-wrap'));
	    var isText$4 = isText$1;
	    var isBr$3 = isBr;
	    var nodeIndex = DOMUtils.nodeIndex;
	    var resolveIndex = getNode;
	    var createRange = function (doc) {
	      return 'createRange' in doc ? doc.createRange() : DOMUtils.DOM.createRng();
	    };
	    var isWhiteSpace = function (chr) {
	      return chr && /[\r\n\t ]/.test(chr);
	    };
	    var isRange = function (rng) {
	      return !!rng.setStart && !!rng.setEnd;
	    };
	    var isHiddenWhiteSpaceRange = function (range) {
	      var container = range.startContainer;
	      var offset = range.startOffset;
	      var text;
	      if (isWhiteSpace(range.toString()) && isNotPre(container.parentNode) && isText$1(container)) {
	        text = container.data;
	        if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var getBrClientRect = function (brNode) {
	      var doc = brNode.ownerDocument;
	      var rng = createRange(doc);
	      var nbsp$1 = doc.createTextNode(nbsp);
	      var parentNode = brNode.parentNode;
	      parentNode.insertBefore(nbsp$1, brNode);
	      rng.setStart(nbsp$1, 0);
	      rng.setEnd(nbsp$1, 1);
	      var clientRect = clone$2(rng.getBoundingClientRect());
	      parentNode.removeChild(nbsp$1);
	      return clientRect;
	    };
	    var getBoundingClientRectWebKitText = function (rng) {
	      var sc = rng.startContainer;
	      var ec = rng.endContainer;
	      var so = rng.startOffset;
	      var eo = rng.endOffset;
	      if (sc === ec && isText$1(ec) && so === 0 && eo === 1) {
	        var newRng = rng.cloneRange();
	        newRng.setEndAfter(ec);
	        return getBoundingClientRect(newRng);
	      } else {
	        return null;
	      }
	    };
	    var isZeroRect = function (r) {
	      return r.left === 0 && r.right === 0 && r.top === 0 && r.bottom === 0;
	    };
	    var getBoundingClientRect = function (item) {
	      var clientRect;
	      var clientRects = item.getClientRects();
	      if (clientRects.length > 0) {
	        clientRect = clone$2(clientRects[0]);
	      } else {
	        clientRect = clone$2(item.getBoundingClientRect());
	      }
	      if (!isRange(item) && isBr$3(item) && isZeroRect(clientRect)) {
	        return getBrClientRect(item);
	      }
	      if (isZeroRect(clientRect) && isRange(item)) {
	        return getBoundingClientRectWebKitText(item);
	      }
	      return clientRect;
	    };
	    var collapseAndInflateWidth = function (clientRect, toStart) {
	      var newClientRect = collapse(clientRect, toStart);
	      newClientRect.width = 1;
	      newClientRect.right = newClientRect.left + 1;
	      return newClientRect;
	    };
	    var getCaretPositionClientRects = function (caretPosition) {
	      var clientRects = [];
	      var beforeNode, node;
	      var addUniqueAndValidRect = function (clientRect) {
	        if (clientRect.height === 0) {
	          return;
	        }
	        if (clientRects.length > 0) {
	          if (isEqual(clientRect, clientRects[clientRects.length - 1])) {
	            return;
	          }
	        }
	        clientRects.push(clientRect);
	      };
	      var addCharacterOffset = function (container, offset) {
	        var range = createRange(container.ownerDocument);
	        if (offset < container.data.length) {
	          if (isExtendingChar(container.data[offset])) {
	            return clientRects;
	          }
	          if (isExtendingChar(container.data[offset - 1])) {
	            range.setStart(container, offset);
	            range.setEnd(container, offset + 1);
	            if (!isHiddenWhiteSpaceRange(range)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	              return clientRects;
	            }
	          }
	        }
	        if (offset > 0) {
	          range.setStart(container, offset - 1);
	          range.setEnd(container, offset);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	          }
	        }
	        if (offset < container.data.length) {
	          range.setStart(container, offset);
	          range.setEnd(container, offset + 1);
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), true));
	          }
	        }
	      };
	      if (isText$4(caretPosition.container())) {
	        addCharacterOffset(caretPosition.container(), caretPosition.offset());
	        return clientRects;
	      }
	      if (isElement$3(caretPosition.container())) {
	        if (caretPosition.isAtEnd()) {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText$4(node)) {
	            addCharacterOffset(node, node.data.length);
	          }
	          if (isValidElementCaretCandidate(node) && !isBr$3(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	          }
	        } else {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText$4(node)) {
	            addCharacterOffset(node, 0);
	          }
	          if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	            return clientRects;
	          }
	          beforeNode = resolveIndex(caretPosition.container(), caretPosition.offset() - 1);
	          if (isValidElementCaretCandidate(beforeNode) && !isBr$3(beforeNode)) {
	            if (isBlock$1(beforeNode) || isBlock$1(node) || !isValidElementCaretCandidate(node)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false));
	            }
	          }
	          if (isValidElementCaretCandidate(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true));
	          }
	        }
	      }
	      return clientRects;
	    };
	    var CaretPosition = function (container, offset, clientRects) {
	      var isAtStart = function () {
	        if (isText$4(container)) {
	          return offset === 0;
	        }
	        return offset === 0;
	      };
	      var isAtEnd = function () {
	        if (isText$4(container)) {
	          return offset >= container.data.length;
	        }
	        return offset >= container.childNodes.length;
	      };
	      var toRange = function () {
	        var range = createRange(container.ownerDocument);
	        range.setStart(container, offset);
	        range.setEnd(container, offset);
	        return range;
	      };
	      var getClientRects = function () {
	        if (!clientRects) {
	          clientRects = getCaretPositionClientRects(CaretPosition(container, offset));
	        }
	        return clientRects;
	      };
	      var isVisible = function () {
	        return getClientRects().length > 0;
	      };
	      var isEqual = function (caretPosition) {
	        return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
	      };
	      var getNode = function (before) {
	        return resolveIndex(container, before ? offset - 1 : offset);
	      };
	      return {
	        container: constant(container),
	        offset: constant(offset),
	        toRange: toRange,
	        getClientRects: getClientRects,
	        isVisible: isVisible,
	        isAtStart: isAtStart,
	        isAtEnd: isAtEnd,
	        isEqual: isEqual,
	        getNode: getNode
	      };
	    };
	    CaretPosition.fromRangeStart = function (range) {
	      return CaretPosition(range.startContainer, range.startOffset);
	    };
	    CaretPosition.fromRangeEnd = function (range) {
	      return CaretPosition(range.endContainer, range.endOffset);
	    };
	    CaretPosition.after = function (node) {
	      return CaretPosition(node.parentNode, nodeIndex(node) + 1);
	    };
	    CaretPosition.before = function (node) {
	      return CaretPosition(node.parentNode, nodeIndex(node));
	    };
	    CaretPosition.isAbove = function (pos1, pos2) {
	      return lift2(head(pos2.getClientRects()), last(pos1.getClientRects()), isAbove).getOr(false);
	    };
	    CaretPosition.isBelow = function (pos1, pos2) {
	      return lift2(last(pos2.getClientRects()), head(pos1.getClientRects()), isBelow).getOr(false);
	    };
	    CaretPosition.isAtStart = function (pos) {
	      return pos ? pos.isAtStart() : false;
	    };
	    CaretPosition.isAtEnd = function (pos) {
	      return pos ? pos.isAtEnd() : false;
	    };
	    CaretPosition.isTextPosition = function (pos) {
	      return pos ? isText$1(pos.container()) : false;
	    };
	    CaretPosition.isElementPosition = function (pos) {
	      return CaretPosition.isTextPosition(pos) === false;
	    };
	
	    var trimEmptyTextNode = function (dom, node) {
	      if (isText$1(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var insertNode = function (dom, rng, node) {
	      rng.insertNode(node);
	      trimEmptyTextNode(dom, node.previousSibling);
	      trimEmptyTextNode(dom, node.nextSibling);
	    };
	    var insertFragment = function (dom, rng, frag) {
	      var firstChild = Optional.from(frag.firstChild);
	      var lastChild = Optional.from(frag.lastChild);
	      rng.insertNode(frag);
	      firstChild.each(function (child) {
	        return trimEmptyTextNode(dom, child.previousSibling);
	      });
	      lastChild.each(function (child) {
	        return trimEmptyTextNode(dom, child.nextSibling);
	      });
	    };
	    var rangeInsertNode = function (dom, rng, node) {
	      if (isDocumentFragment$1(node)) {
	        insertFragment(dom, rng, node);
	      } else {
	        insertNode(dom, rng, node);
	      }
	    };
	
	    var isText$5 = isText$1;
	    var isBogus$2 = isBogus;
	    var nodeIndex$1 = DOMUtils.nodeIndex;
	    var normalizedParent = function (node) {
	      var parentNode = node.parentNode;
	      if (isBogus$2(parentNode)) {
	        return normalizedParent(parentNode);
	      }
	      return parentNode;
	    };
	    var getChildNodes = function (node) {
	      if (!node) {
	        return [];
	      }
	      return reduce(node.childNodes, function (result, node) {
	        if (isBogus$2(node) && node.nodeName !== 'BR') {
	          result = result.concat(getChildNodes(node));
	        } else {
	          result.push(node);
	        }
	        return result;
	      }, []);
	    };
	    var normalizedTextOffset = function (node, offset) {
	      while (node = node.previousSibling) {
	        if (!isText$5(node)) {
	          break;
	        }
	        offset += node.data.length;
	      }
	      return offset;
	    };
	    var equal$1 = function (a) {
	      return function (b) {
	        return a === b;
	      };
	    };
	    var normalizedNodeIndex = function (node) {
	      var nodes, index;
	      nodes = getChildNodes(normalizedParent(node));
	      index = findIndex$1(nodes, equal$1(node), node);
	      nodes = nodes.slice(0, index + 1);
	      var numTextFragments = reduce(nodes, function (result, node, i) {
	        if (isText$5(node) && isText$5(nodes[i - 1])) {
	          result++;
	        }
	        return result;
	      }, 0);
	      nodes = filter$2(nodes, matchNodeNames([node.nodeName]));
	      index = findIndex$1(nodes, equal$1(node), node);
	      return index - numTextFragments;
	    };
	    var createPathItem = function (node) {
	      var name;
	      if (isText$5(node)) {
	        name = 'text()';
	      } else {
	        name = node.nodeName.toLowerCase();
	      }
	      return name + '[' + normalizedNodeIndex(node) + ']';
	    };
	    var parentsUntil = function (root, node, predicate) {
	      var parents = [];
	      for (node = node.parentNode; node !== root; node = node.parentNode) {
	        if (predicate && predicate(node)) {
	          break;
	        }
	        parents.push(node);
	      }
	      return parents;
	    };
	    var create$3 = function (root, caretPosition) {
	      var container, offset, path = [], outputOffset, childNodes, parents;
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	      if (isText$5(container)) {
	        outputOffset = normalizedTextOffset(container, offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length) {
	          outputOffset = 'after';
	          offset = childNodes.length - 1;
	        } else {
	          outputOffset = 'before';
	        }
	        container = childNodes[offset];
	      }
	      path.push(createPathItem(container));
	      parents = parentsUntil(root, container);
	      parents = filter$2(parents, not(isBogus));
	      path = path.concat(map$2(parents, function (node) {
	        return createPathItem(node);
	      }));
	      return path.reverse().join('/') + ',' + outputOffset;
	    };
	    var resolvePathItem = function (node, name, index) {
	      var nodes = getChildNodes(node);
	      nodes = filter$2(nodes, function (node, index) {
	        return !isText$5(node) || !isText$5(nodes[index - 1]);
	      });
	      nodes = filter$2(nodes, matchNodeNames([name]));
	      return nodes[index];
	    };
	    var findTextPosition = function (container, offset) {
	      var node = container, targetOffset = 0, dataLen;
	      while (isText$5(node)) {
	        dataLen = node.data.length;
	        if (offset >= targetOffset && offset <= targetOffset + dataLen) {
	          container = node;
	          offset = offset - targetOffset;
	          break;
	        }
	        if (!isText$5(node.nextSibling)) {
	          container = node;
	          offset = dataLen;
	          break;
	        }
	        targetOffset += dataLen;
	        node = node.nextSibling;
	      }
	      if (isText$5(container) && offset > container.data.length) {
	        offset = container.data.length;
	      }
	      return CaretPosition(container, offset);
	    };
	    var resolve$1 = function (root, path) {
	      var offset;
	      if (!path) {
	        return null;
	      }
	      var parts = path.split(',');
	      var paths = parts[0].split('/');
	      offset = parts.length > 1 ? parts[1] : 'before';
	      var container = reduce(paths, function (result, value) {
	        var match = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
	        if (!match) {
	          return null;
	        }
	        if (match[1] === 'text()') {
	          match[1] = '#text';
	        }
	        return resolvePathItem(result, match[1], parseInt(match[2], 10));
	      }, root);
	      if (!container) {
	        return null;
	      }
	      if (!isText$5(container)) {
	        if (offset === 'after') {
	          offset = nodeIndex$1(container) + 1;
	        } else {
	          offset = nodeIndex$1(container);
	        }
	        return CaretPosition(container.parentNode, offset);
	      }
	      return findTextPosition(container, parseInt(offset, 10));
	    };
	
	    var isContentEditableFalse$2 = isContentEditableFalse;
	    var getNormalizedTextOffset = function (trim, container, offset) {
	      var node, trimmedOffset;
	      trimmedOffset = trim(container.data.slice(0, offset)).length;
	      for (node = container.previousSibling; node && isText$1(node); node = node.previousSibling) {
	        trimmedOffset += trim(node.data).length;
	      }
	      return trimmedOffset;
	    };
	    var getPoint = function (dom, trim, normalized, rng, start) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'];
	      var point = [];
	      var childNodes, after = 0;
	      var root = dom.getRoot();
	      if (isText$1(container)) {
	        point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length && childNodes.length) {
	          after = 1;
	          offset = Math.max(0, childNodes.length - 1);
	        }
	        point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
	      }
	      for (; container && container !== root; container = container.parentNode) {
	        point.push(dom.nodeIndex(container, normalized));
	      }
	      return point;
	    };
	    var getLocation = function (trim, selection, normalized, rng) {
	      var dom = selection.dom, bookmark = {};
	      bookmark.start = getPoint(dom, trim, normalized, rng, true);
	      if (!selection.isCollapsed()) {
	        bookmark.end = getPoint(dom, trim, normalized, rng, false);
	      }
	      return bookmark;
	    };
	    var findIndex$2 = function (dom, name, element) {
	      var count = 0;
	      Tools.each(dom.select(name), function (node) {
	        if (node.getAttribute('data-mce-bogus') === 'all') {
	          return;
	        }
	        if (node === element) {
	          return false;
	        }
	        count++;
	      });
	      return count;
	    };
	    var moveEndPoint = function (rng, start) {
	      var container, offset, childNodes;
	      var prefix = start ? 'start' : 'end';
	      container = rng[prefix + 'Container'];
	      offset = rng[prefix + 'Offset'];
	      if (isElement$1(container) && container.nodeName === 'TR') {
	        childNodes = container.childNodes;
	        container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
	        if (container) {
	          offset = start ? 0 : container.childNodes.length;
	          rng['set' + (start ? 'Start' : 'End')](container, offset);
	        }
	      }
	    };
	    var normalizeTableCellSelection = function (rng) {
	      moveEndPoint(rng, true);
	      moveEndPoint(rng, false);
	      return rng;
	    };
	    var findSibling = function (node, offset) {
	      var sibling;
	      if (isElement$1(node)) {
	        node = getNode(node, offset);
	        if (isContentEditableFalse$2(node)) {
	          return node;
	        }
	      }
	      if (isCaretContainer(node)) {
	        if (isText$1(node) && isCaretContainerBlock(node)) {
	          node = node.parentNode;
	        }
	        sibling = node.previousSibling;
	        if (isContentEditableFalse$2(sibling)) {
	          return sibling;
	        }
	        sibling = node.nextSibling;
	        if (isContentEditableFalse$2(sibling)) {
	          return sibling;
	        }
	      }
	    };
	    var findAdjacentContentEditableFalseElm = function (rng) {
	      return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
	    };
	    var getOffsetBookmark = function (trim, normalized, selection) {
	      var element = selection.getNode();
	      var name = element ? element.nodeName : null;
	      var rng = selection.getRng();
	      if (isContentEditableFalse$2(element) || name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex$2(selection.dom, name, element)
	        };
	      }
	      var sibling = findAdjacentContentEditableFalseElm(rng);
	      if (sibling) {
	        name = sibling.tagName;
	        return {
	          name: name,
	          index: findIndex$2(selection.dom, name, sibling)
	        };
	      }
	      return getLocation(trim, selection, normalized, rng);
	    };
	    var getCaretBookmark = function (selection) {
	      var rng = selection.getRng();
	      return {
	        start: create$3(selection.dom.getRoot(), CaretPosition.fromRangeStart(rng)),
	        end: create$3(selection.dom.getRoot(), CaretPosition.fromRangeEnd(rng))
	      };
	    };
	    var getRangeBookmark = function (selection) {
	      return { rng: selection.getRng() };
	    };
	    var createBookmarkSpan = function (dom, id, filled) {
	      var args = {
	        'data-mce-type': 'bookmark',
	        id: id,
	        'style': 'overflow:hidden;line-height:0px'
	      };
	      return filled ? dom.create('span', args, '&#xFEFF;') : dom.create('span', args);
	    };
	    var getPersistentBookmark = function (selection, filled) {
	      var dom = selection.dom;
	      var rng = selection.getRng();
	      var id = dom.uniqueId();
	      var collapsed = selection.isCollapsed();
	      var element = selection.getNode();
	      var name = element.nodeName;
	      if (name === 'IMG') {
	        return {
	          name: name,
	          index: findIndex$2(dom, name, element)
	        };
	      }
	      var rng2 = normalizeTableCellSelection(rng.cloneRange());
	      if (!collapsed) {
	        rng2.collapse(false);
	        var endBookmarkNode = createBookmarkSpan(dom, id + '_end', filled);
	        rangeInsertNode(dom, rng2, endBookmarkNode);
	      }
	      rng = normalizeTableCellSelection(rng);
	      rng.collapse(true);
	      var startBookmarkNode = createBookmarkSpan(dom, id + '_start', filled);
	      rangeInsertNode(dom, rng, startBookmarkNode);
	      selection.moveToBookmark({
	        id: id,
	        keep: true
	      });
	      return { id: id };
	    };
	    var getBookmark = function (selection, type, normalized) {
	      if (type === 2) {
	        return getOffsetBookmark(trim$2, normalized, selection);
	      } else if (type === 3) {
	        return getCaretBookmark(selection);
	      } else if (type) {
	        return getRangeBookmark(selection);
	      } else {
	        return getPersistentBookmark(selection, false);
	      }
	    };
	    var getUndoBookmark = curry(getOffsetBookmark, identity, true);
	
	    var DOM$1 = DOMUtils.DOM;
	    var defaultPreviewStyles = 'font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow';
	    var getBodySetting = function (editor, name, defaultValue) {
	      var value = editor.getParam(name, defaultValue);
	      if (value.indexOf('=') !== -1) {
	        var bodyObj = editor.getParam(name, '', 'hash');
	        return bodyObj.hasOwnProperty(editor.id) ? bodyObj[editor.id] : defaultValue;
	      } else {
	        return value;
	      }
	    };
	    var getIframeAttrs = function (editor) {
	      return editor.getParam('iframe_attrs', {});
	    };
	    var getDocType = function (editor) {
	      return editor.getParam('doctype', '<!DOCTYPE html>');
	    };
	    var getDocumentBaseUrl = function (editor) {
	      return editor.getParam('document_base_url', '');
	    };
	    var getBodyId = function (editor) {
	      return getBodySetting(editor, 'body_id', 'tinymce');
	    };
	    var getBodyClass = function (editor) {
	      return getBodySetting(editor, 'body_class', '');
	    };
	    var getContentSecurityPolicy = function (editor) {
	      return editor.getParam('content_security_policy', '');
	    };
	    var shouldPutBrInPre = function (editor) {
	      return editor.getParam('br_in_pre', true);
	    };
	    var getForcedRootBlock = function (editor) {
	      if (editor.getParam('force_p_newlines', false)) {
	        return 'p';
	      }
	      var block = editor.getParam('forced_root_block', 'p');
	      if (block === false) {
	        return '';
	      } else if (block === true) {
	        return 'p';
	      } else {
	        return block;
	      }
	    };
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs', {});
	    };
	    var getBrNewLineSelector = function (editor) {
	      return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
	    };
	    var getNoNewLineSelector = function (editor) {
	      return editor.getParam('no_newline_selector', '');
	    };
	    var shouldKeepStyles = function (editor) {
	      return editor.getParam('keep_styles', true);
	    };
	    var shouldEndContainerOnEmptyBlock = function (editor) {
	      return editor.getParam('end_container_on_empty_block', false);
	    };
	    var getFontStyleValues = function (editor) {
	      return Tools.explode(editor.getParam('font_size_style_values', 'xx-small,x-small,small,medium,large,x-large,xx-large'));
	    };
	    var getFontSizeClasses = function (editor) {
	      return Tools.explode(editor.getParam('font_size_classes', ''));
	    };
	    var getImagesDataImgFilter = function (editor) {
	      return editor.getParam('images_dataimg_filter', always, 'function');
	    };
	    var isAutomaticUploadsEnabled = function (editor) {
	      return editor.getParam('automatic_uploads', true, 'boolean');
	    };
	    var shouldReuseFileName = function (editor) {
	      return editor.getParam('images_reuse_filename', false, 'boolean');
	    };
	    var shouldReplaceBlobUris = function (editor) {
	      return editor.getParam('images_replace_blob_uris', true, 'boolean');
	    };
	    var getIconPackName = function (editor) {
	      return editor.getParam('icons', '', 'string');
	    };
	    var getIconsUrl = function (editor) {
	      return editor.getParam('icons_url', '', 'string');
	    };
	    var getImageUploadUrl = function (editor) {
	      return editor.getParam('images_upload_url', '', 'string');
	    };
	    var getImageUploadBasePath = function (editor) {
	      return editor.getParam('images_upload_base_path', '', 'string');
	    };
	    var getImagesUploadCredentials = function (editor) {
	      return editor.getParam('images_upload_credentials', false, 'boolean');
	    };
	    var getImagesUploadHandler = function (editor) {
	      return editor.getParam('images_upload_handler', null, 'function');
	    };
	    var shouldUseContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors', false, 'boolean');
	    };
	    var getReferrerPolicy = function (editor) {
	      return editor.getParam('referrer_policy', '', 'string');
	    };
	    var getLanguageCode = function (editor) {
	      return editor.getParam('language', 'en', 'string');
	    };
	    var getLanguageUrl = function (editor) {
	      return editor.getParam('language_url', '', 'string');
	    };
	    var shouldIndentUseMargin = function (editor) {
	      return editor.getParam('indent_use_margin', false);
	    };
	    var getIndentation = function (editor) {
	      return editor.getParam('indentation', '40px', 'string');
	    };
	    var getContentCss = function (editor) {
	      var contentCss = editor.getParam('content_css');
	      if (isString(contentCss)) {
	        return map(contentCss.split(','), trim);
	      } else if (isArray(contentCss)) {
	        return contentCss;
	      } else if (contentCss === false || editor.inline) {
	        return [];
	      } else {
	        return ['default'];
	      }
	    };
	    var getFontCss = function (editor) {
	      var fontCss = editor.getParam('font_css', []);
	      return isArray(fontCss) ? fontCss : map(fontCss.split(','), trim);
	    };
	    var getDirectionality = function (editor) {
	      return editor.getParam('directionality', I18n.isRtl() ? 'rtl' : undefined);
	    };
	    var getInlineBoundarySelector = function (editor) {
	      return editor.getParam('inline_boundaries_selector', 'a[href],code,.mce-annotation', 'string');
	    };
	    var getObjectResizing = function (editor) {
	      var selector = editor.getParam('object_resizing');
	      if (selector === false || Env.iOS) {
	        return false;
	      } else {
	        return isString(selector) ? selector : 'table,img,figure.image,div,video,iframe';
	      }
	    };
	    var getResizeImgProportional = function (editor) {
	      return editor.getParam('resize_img_proportional', true, 'boolean');
	    };
	    var getPlaceholder = function (editor) {
	      return editor.getParam('placeholder', DOM$1.getAttrib(editor.getElement(), 'placeholder'), 'string');
	    };
	    var getEventRoot = function (editor) {
	      return editor.getParam('event_root');
	    };
	    var getServiceMessage = function (editor) {
	      return editor.getParam('service_message');
	    };
	    var getTheme = function (editor) {
	      return editor.getParam('theme');
	    };
	    var shouldValidate = function (editor) {
	      return editor.getParam('validate');
	    };
	    var isInlineBoundariesEnabled = function (editor) {
	      return editor.getParam('inline_boundaries') !== false;
	    };
	    var getFormats = function (editor) {
	      return editor.getParam('formats');
	    };
	    var getPreviewStyles = function (editor) {
	      var style = editor.getParam('preview_styles', defaultPreviewStyles);
	      if (isString(style)) {
	        return style;
	      } else {
	        return '';
	      }
	    };
	    var canFormatEmptyLines = function (editor) {
	      return editor.getParam('format_empty_lines', false, 'boolean');
	    };
	    var getCustomUiSelector = function (editor) {
	      return editor.getParam('custom_ui_selector', '', 'string');
	    };
	    var getThemeUrl = function (editor) {
	      return editor.getParam('theme_url');
	    };
	    var isInline$1 = function (editor) {
	      return editor.getParam('inline');
	    };
	    var hasHiddenInput = function (editor) {
	      return editor.getParam('hidden_input');
	    };
	    var shouldPatchSubmit = function (editor) {
	      return editor.getParam('submit_patch');
	    };
	    var isEncodingXml = function (editor) {
	      return editor.getParam('encoding') === 'xml';
	    };
	    var shouldAddFormSubmitTrigger = function (editor) {
	      return editor.getParam('add_form_submit_trigger');
	    };
	    var shouldAddUnloadTrigger = function (editor) {
	      return editor.getParam('add_unload_trigger');
	    };
	    var hasForcedRootBlock = function (editor) {
	      return getForcedRootBlock(editor) !== '';
	    };
	    var getCustomUndoRedoLevels = function (editor) {
	      return editor.getParam('custom_undo_redo_levels', 0, 'number');
	    };
	    var shouldDisableNodeChange = function (editor) {
	      return editor.getParam('disable_nodechange');
	    };
	    var isReadOnly = function (editor) {
	      return editor.getParam('readonly');
	    };
	    var hasContentCssCors = function (editor) {
	      return editor.getParam('content_css_cors');
	    };
	    var getPlugins = function (editor) {
	      return editor.getParam('plugins', '', 'string');
	    };
	    var getExternalPlugins = function (editor) {
	      return editor.getParam('external_plugins');
	    };
	    var shouldBlockUnsupportedDrop = function (editor) {
	      return editor.getParam('block_unsupported_drop', true, 'boolean');
	    };
	    var isVisualAidsEnabled = function (editor) {
	      return editor.getParam('visual', true, 'boolean');
	    };
	    var getVisualAidsTableClass = function (editor) {
	      return editor.getParam('visual_table_class', 'mce-item-table', 'string');
	    };
	    var getVisualAidsAnchorClass = function (editor) {
	      return editor.getParam('visual_anchor_class', 'mce-item-anchor', 'string');
	    };
	
	    var isElement$4 = isElement$1;
	    var isText$6 = isText$1;
	    var removeNode = function (node) {
	      var parentNode = node.parentNode;
	      if (parentNode) {
	        parentNode.removeChild(node);
	      }
	    };
	    var trimCount = function (text) {
	      var trimmedText = trim$2(text);
	      return {
	        count: text.length - trimmedText.length,
	        text: trimmedText
	      };
	    };
	    var deleteZwspChars = function (caretContainer) {
	      var idx;
	      while ((idx = caretContainer.data.lastIndexOf(ZWSP)) !== -1) {
	        caretContainer.deleteData(idx, 1);
	      }
	    };
	    var removeUnchanged = function (caretContainer, pos) {
	      remove$5(caretContainer);
	      return pos;
	    };
	    var removeTextAndReposition = function (caretContainer, pos) {
	      var before = trimCount(caretContainer.data.substr(0, pos.offset()));
	      var after = trimCount(caretContainer.data.substr(pos.offset()));
	      var text = before.text + after.text;
	      if (text.length > 0) {
	        deleteZwspChars(caretContainer);
	        return CaretPosition(caretContainer, pos.offset() - before.count);
	      } else {
	        return pos;
	      }
	    };
	    var removeElementAndReposition = function (caretContainer, pos) {
	      var parentNode = pos.container();
	      var newPosition = indexOf(from$1(parentNode.childNodes), caretContainer).map(function (index) {
	        return index < pos.offset() ? CaretPosition(parentNode, pos.offset() - 1) : pos;
	      }).getOr(pos);
	      remove$5(caretContainer);
	      return newPosition;
	    };
	    var removeTextCaretContainer = function (caretContainer, pos) {
	      return isText$6(caretContainer) && pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeElementCaretContainer = function (caretContainer, pos) {
	      return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	    var removeAndReposition = function (container, pos) {
	      return CaretPosition.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
	    };
	    var remove$5 = function (caretContainerNode) {
	      if (isElement$4(caretContainerNode) && isCaretContainer(caretContainerNode)) {
	        if (hasContent(caretContainerNode)) {
	          caretContainerNode.removeAttribute('data-mce-caret');
	        } else {
	          removeNode(caretContainerNode);
	        }
	      }
	      if (isText$6(caretContainerNode)) {
	        deleteZwspChars(caretContainerNode);
	        if (caretContainerNode.data.length === 0) {
	          removeNode(caretContainerNode);
	        }
	      }
	    };
	
	    var browser$2 = detect$3().browser;
	    var isContentEditableFalse$3 = isContentEditableFalse;
	    var isMedia$1 = isMedia;
	    var isTableCell$2 = isTableCell;
	    var inlineFakeCaretSelector = '*[contentEditable=false],video,audio,embed,object';
	    var getAbsoluteClientRect = function (root, element, before) {
	      var clientRect = collapse(element.getBoundingClientRect(), before);
	      var docElm, scrollX, scrollY, margin, rootRect;
	      if (root.tagName === 'BODY') {
	        docElm = root.ownerDocument.documentElement;
	        scrollX = root.scrollLeft || docElm.scrollLeft;
	        scrollY = root.scrollTop || docElm.scrollTop;
	      } else {
	        rootRect = root.getBoundingClientRect();
	        scrollX = root.scrollLeft - rootRect.left;
	        scrollY = root.scrollTop - rootRect.top;
	      }
	      clientRect.left += scrollX;
	      clientRect.right += scrollX;
	      clientRect.top += scrollY;
	      clientRect.bottom += scrollY;
	      clientRect.width = 1;
	      margin = element.offsetWidth - element.clientWidth;
	      if (margin > 0) {
	        if (before) {
	          margin *= -1;
	        }
	        clientRect.left += margin;
	        clientRect.right += margin;
	      }
	      return clientRect;
	    };
	    var trimInlineCaretContainers = function (root) {
	      var fakeCaretTargetNodes = descendants$1(SugarElement.fromDom(root), inlineFakeCaretSelector);
	      for (var i = 0; i < fakeCaretTargetNodes.length; i++) {
	        var node = fakeCaretTargetNodes[i].dom;
	        var sibling = node.previousSibling;
	        if (endsWithCaretContainer(sibling)) {
	          var data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(data.length - 1, 1);
	          }
	        }
	        sibling = node.nextSibling;
	        if (startsWithCaretContainer(sibling)) {
	          var data = sibling.data;
	          if (data.length === 1) {
	            sibling.parentNode.removeChild(sibling);
	          } else {
	            sibling.deleteData(0, 1);
	          }
	        }
	      }
	    };
	    var FakeCaret = function (editor, root, isBlock, hasFocus) {
	      var lastVisualCaret = Cell(Optional.none());
	      var cursorInterval, caretContainerNode;
	      var rootBlock = getForcedRootBlock(editor);
	      var caretBlock = rootBlock.length > 0 ? rootBlock : 'p';
	      var show = function (before, element) {
	        var clientRect, rng;
	        hide();
	        if (isTableCell$2(element)) {
	          return null;
	        }
	        if (isBlock(element)) {
	          caretContainerNode = insertBlock(caretBlock, element, before);
	          clientRect = getAbsoluteClientRect(root, element, before);
	          DomQuery(caretContainerNode).css('top', clientRect.top);
	          var caret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(root)[0];
	          lastVisualCaret.set(Optional.some({
	            caret: caret,
	            element: element,
	            before: before
	          }));
	          lastVisualCaret.get().each(function (caretState) {
	            if (before) {
	              DomQuery(caretState.caret).addClass('mce-visual-caret-before');
	            }
	          });
	          startBlink();
	          rng = element.ownerDocument.createRange();
	          rng.setStart(caretContainerNode, 0);
	          rng.setEnd(caretContainerNode, 0);
	        } else {
	          caretContainerNode = insertInline(element, before);
	          rng = element.ownerDocument.createRange();
	          if (isInlineFakeCaretTarget(caretContainerNode.nextSibling)) {
	            rng.setStart(caretContainerNode, 0);
	            rng.setEnd(caretContainerNode, 0);
	          } else {
	            rng.setStart(caretContainerNode, 1);
	            rng.setEnd(caretContainerNode, 1);
	          }
	          return rng;
	        }
	        return rng;
	      };
	      var hide = function () {
	        trimInlineCaretContainers(root);
	        if (caretContainerNode) {
	          remove$5(caretContainerNode);
	          caretContainerNode = null;
	        }
	        lastVisualCaret.get().each(function (caretState) {
	          DomQuery(caretState.caret).remove();
	          lastVisualCaret.set(Optional.none());
	        });
	        if (cursorInterval) {
	          Delay.clearInterval(cursorInterval);
	          cursorInterval = null;
	        }
	      };
	      var startBlink = function () {
	        cursorInterval = Delay.setInterval(function () {
	          if (hasFocus()) {
	            DomQuery('div.mce-visual-caret', root).toggleClass('mce-visual-caret-hidden');
	          } else {
	            DomQuery('div.mce-visual-caret', root).addClass('mce-visual-caret-hidden');
	          }
	        }, 500);
	      };
	      var reposition = function () {
	        lastVisualCaret.get().each(function (caretState) {
	          var clientRect = getAbsoluteClientRect(root, caretState.element, caretState.before);
	          DomQuery(caretState.caret).css(__assign({}, clientRect));
	        });
	      };
	      var destroy = function () {
	        return Delay.clearInterval(cursorInterval);
	      };
	      var getCss = function () {
	        return '.mce-visual-caret {' + 'position: absolute;' + 'background-color: black;' + 'background-color: currentcolor;' + '}' + '.mce-visual-caret-hidden {' + 'display: none;' + '}' + '*[data-mce-caret] {' + 'position: absolute;' + 'left: -1000px;' + 'right: auto;' + 'top: 0;' + 'margin: 0;' + 'padding: 0;' + '}';
	      };
	      return {
	        show: show,
	        hide: hide,
	        getCss: getCss,
	        reposition: reposition,
	        destroy: destroy
	      };
	    };
	    var isFakeCaretTableBrowser = function () {
	      return browser$2.isIE() || browser$2.isEdge() || browser$2.isFirefox();
	    };
	    var isInlineFakeCaretTarget = function (node) {
	      return isContentEditableFalse$3(node) || isMedia$1(node);
	    };
	    var isFakeCaretTarget = function (node) {
	      return isInlineFakeCaretTarget(node) || isTable(node) && isFakeCaretTableBrowser();
	    };
	
	    var isContentEditableFalse$4 = isContentEditableFalse;
	    var isMedia$2 = isMedia;
	    var isBlockLike = matchStyleValues('display', 'block table table-cell table-caption list-item');
	    var isCaretContainer$2 = isCaretContainer;
	    var isCaretContainerBlock$1 = isCaretContainerBlock;
	    var isElement$5 = isElement$1;
	    var isCaretCandidate$2 = isCaretCandidate;
	    var isForwards = function (direction) {
	      return direction > 0;
	    };
	    var isBackwards = function (direction) {
	      return direction < 0;
	    };
	    var skipCaretContainers = function (walk, shallow) {
	      var node;
	      while (node = walk(shallow)) {
	        if (!isCaretContainerBlock$1(node)) {
	          return node;
	        }
	      }
	      return null;
	    };
	    var findNode = function (node, direction, predicateFn, rootNode, shallow) {
	      var walker = new DomTreeWalker(node, rootNode);
	      var isCefOrCaretContainer = isContentEditableFalse$4(node) || isCaretContainerBlock$1(node);
	      if (isBackwards(direction)) {
	        if (isCefOrCaretContainer) {
	          node = skipCaretContainers(walker.prev.bind(walker), true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.prev.bind(walker), shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      if (isForwards(direction)) {
	        if (isCefOrCaretContainer) {
	          node = skipCaretContainers(walker.next.bind(walker), true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	        while (node = skipCaretContainers(walker.next.bind(walker), shallow)) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var getParentBlock = function (node, rootNode) {
	      while (node && node !== rootNode) {
	        if (isBlockLike(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
	      return getParentBlock(caretPosition1.container(), rootNode) === getParentBlock(caretPosition2.container(), rootNode);
	    };
	    var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
	      if (!caretPosition) {
	        return null;
	      }
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (!isElement$5(container)) {
	        return null;
	      }
	      return container.childNodes[offset + relativeOffset];
	    };
	    var beforeAfter = function (before, node) {
	      var range = node.ownerDocument.createRange();
	      if (before) {
	        range.setStartBefore(node);
	        range.setEndBefore(node);
	      } else {
	        range.setStartAfter(node);
	        range.setEndAfter(node);
	      }
	      return range;
	    };
	    var isNodesInSameBlock = function (root, node1, node2) {
	      return getParentBlock(node1, root) === getParentBlock(node2, root);
	    };
	    var lean = function (left, root, node) {
	      var sibling, siblingName;
	      if (left) {
	        siblingName = 'previousSibling';
	      } else {
	        siblingName = 'nextSibling';
	      }
	      while (node && node !== root) {
	        sibling = node[siblingName];
	        if (isCaretContainer$2(sibling)) {
	          sibling = sibling[siblingName];
	        }
	        if (isContentEditableFalse$4(sibling) || isMedia$2(sibling)) {
	          if (isNodesInSameBlock(root, sibling, node)) {
	            return sibling;
	          }
	          break;
	        }
	        if (isCaretCandidate$2(sibling)) {
	          break;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var before$2 = curry(beforeAfter, true);
	    var after$1 = curry(beforeAfter, false);
	    var normalizeRange = function (direction, root, range) {
	      var node, container, location;
	      var leanLeft = curry(lean, true, root);
	      var leanRight = curry(lean, false, root);
	      container = range.startContainer;
	      var offset = range.startOffset;
	      if (isCaretContainerBlock(container)) {
	        if (!isElement$5(container)) {
	          container = container.parentNode;
	        }
	        location = container.getAttribute('data-mce-caret');
	        if (location === 'before') {
	          node = container.nextSibling;
	          if (isFakeCaretTarget(node)) {
	            return before$2(node);
	          }
	        }
	        if (location === 'after') {
	          node = container.previousSibling;
	          if (isFakeCaretTarget(node)) {
	            return after$1(node);
	          }
	        }
	      }
	      if (!range.collapsed) {
	        return range;
	      }
	      if (isText$1(container)) {
	        if (isCaretContainer$2(container)) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	          }
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (endsWithCaretContainer(container) && offset >= container.data.length - 1) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before$2(node);
	            }
	          }
	          return range;
	        }
	        if (startsWithCaretContainer(container) && offset <= 1) {
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after$1(node);
	            }
	          }
	          return range;
	        }
	        if (offset === container.data.length) {
	          node = leanRight(container);
	          if (node) {
	            return before$2(node);
	          }
	          return range;
	        }
	        if (offset === 0) {
	          node = leanLeft(container);
	          if (node) {
	            return after$1(node);
	          }
	          return range;
	        }
	      }
	      return range;
	    };
	    var getRelativeCefElm = function (forward, caretPosition) {
	      return Optional.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, caretPosition)).filter(isContentEditableFalse$4);
	    };
	    var getNormalizedRangeEndPoint = function (direction, root, range) {
	      var normalizedRange = normalizeRange(direction, root, range);
	      if (direction === -1) {
	        return CaretPosition.fromRangeStart(normalizedRange);
	      }
	      return CaretPosition.fromRangeEnd(normalizedRange);
	    };
	    var getElementFromPosition = function (pos) {
	      return Optional.from(pos.getNode()).map(SugarElement.fromDom);
	    };
	    var getElementFromPrevPosition = function (pos) {
	      return Optional.from(pos.getNode(true)).map(SugarElement.fromDom);
	    };
	    var getVisualCaretPosition = function (walkFn, caretPosition) {
	      while (caretPosition = walkFn(caretPosition)) {
	        if (caretPosition.isVisible()) {
	          return caretPosition;
	        }
	      }
	      return caretPosition;
	    };
	    var isMoveInsideSameBlock = function (from, to) {
	      var inSameBlock = isInSameBlock(from, to);
	      if (!inSameBlock && isBr(from.getNode())) {
	        return true;
	      }
	      return inSameBlock;
	    };
	
	    var HDirection;
	    (function (HDirection) {
	      HDirection[HDirection['Backwards'] = -1] = 'Backwards';
	      HDirection[HDirection['Forwards'] = 1] = 'Forwards';
	    }(HDirection || (HDirection = {})));
	    var isContentEditableFalse$5 = isContentEditableFalse;
	    var isText$7 = isText$1;
	    var isElement$6 = isElement$1;
	    var isBr$4 = isBr;
	    var isCaretCandidate$3 = isCaretCandidate;
	    var isAtomic$1 = isAtomic;
	    var isEditableCaretCandidate$1 = isEditableCaretCandidate;
	    var getParents = function (node, root) {
	      var parents = [];
	      while (node && node !== root) {
	        parents.push(node);
	        node = node.parentNode;
	      }
	      return parents;
	    };
	    var nodeAtIndex = function (container, offset) {
	      if (container.hasChildNodes() && offset < container.childNodes.length) {
	        return container.childNodes[offset];
	      }
	      return null;
	    };
	    var getCaretCandidatePosition = function (direction, node) {
	      if (isForwards(direction)) {
	        if (isCaretCandidate$3(node.previousSibling) && !isText$7(node.previousSibling)) {
	          return CaretPosition.before(node);
	        }
	        if (isText$7(node)) {
	          return CaretPosition(node, 0);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isCaretCandidate$3(node.nextSibling) && !isText$7(node.nextSibling)) {
	          return CaretPosition.after(node);
	        }
	        if (isText$7(node)) {
	          return CaretPosition(node, node.data.length);
	        }
	      }
	      if (isBackwards(direction)) {
	        if (isBr$4(node)) {
	          return CaretPosition.before(node);
	        }
	        return CaretPosition.after(node);
	      }
	      return CaretPosition.before(node);
	    };
	    var moveForwardFromBr = function (root, nextNode) {
	      var nextSibling = nextNode.nextSibling;
	      if (nextSibling && isCaretCandidate$3(nextSibling)) {
	        if (isText$7(nextSibling)) {
	          return CaretPosition(nextSibling, 0);
	        } else {
	          return CaretPosition.before(nextSibling);
	        }
	      } else {
	        return findCaretPosition(HDirection.Forwards, CaretPosition.after(nextNode), root);
	      }
	    };
	    var findCaretPosition = function (direction, startPos, root) {
	      var node, nextNode, innerNode;
	      var caretPosition;
	      if (!isElement$6(root) || !startPos) {
	        return null;
	      }
	      if (startPos.isEqual(CaretPosition.after(root)) && root.lastChild) {
	        caretPosition = CaretPosition.after(root.lastChild);
	        if (isBackwards(direction) && isCaretCandidate$3(root.lastChild) && isElement$6(root.lastChild)) {
	          return isBr$4(root.lastChild) ? CaretPosition.before(root.lastChild) : caretPosition;
	        }
	      } else {
	        caretPosition = startPos;
	      }
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	      if (isText$7(container)) {
	        if (isBackwards(direction) && offset > 0) {
	          return CaretPosition(container, --offset);
	        }
	        if (isForwards(direction) && offset < container.length) {
	          return CaretPosition(container, ++offset);
	        }
	        node = container;
	      } else {
	        if (isBackwards(direction) && offset > 0) {
	          nextNode = nodeAtIndex(container, offset - 1);
	          if (isCaretCandidate$3(nextNode)) {
	            if (!isAtomic$1(nextNode)) {
	              innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
	              if (innerNode) {
	                if (isText$7(innerNode)) {
	                  return CaretPosition(innerNode, innerNode.data.length);
	                }
	                return CaretPosition.after(innerNode);
	              }
	            }
	            if (isText$7(nextNode)) {
	              return CaretPosition(nextNode, nextNode.data.length);
	            }
	            return CaretPosition.before(nextNode);
	          }
	        }
	        if (isForwards(direction) && offset < container.childNodes.length) {
	          nextNode = nodeAtIndex(container, offset);
	          if (isCaretCandidate$3(nextNode)) {
	            if (isBr$4(nextNode)) {
	              return moveForwardFromBr(root, nextNode);
	            }
	            if (!isAtomic$1(nextNode)) {
	              innerNode = findNode(nextNode, direction, isEditableCaretCandidate$1, nextNode);
	              if (innerNode) {
	                if (isText$7(innerNode)) {
	                  return CaretPosition(innerNode, 0);
	                }
	                return CaretPosition.before(innerNode);
	              }
	            }
	            if (isText$7(nextNode)) {
	              return CaretPosition(nextNode, 0);
	            }
	            return CaretPosition.after(nextNode);
	          }
	        }
	        node = nextNode ? nextNode : caretPosition.getNode();
	      }
	      if (isForwards(direction) && caretPosition.isAtEnd() || isBackwards(direction) && caretPosition.isAtStart()) {
	        node = findNode(node, direction, always, root, true);
	        if (isEditableCaretCandidate$1(node, root)) {
	          return getCaretCandidatePosition(direction, node);
	        }
	      }
	      nextNode = findNode(node, direction, isEditableCaretCandidate$1, root);
	      var rootContentEditableFalseElm = last$1(filter(getParents(container, root), isContentEditableFalse$5));
	      if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
	        if (isForwards(direction)) {
	          caretPosition = CaretPosition.after(rootContentEditableFalseElm);
	        } else {
	          caretPosition = CaretPosition.before(rootContentEditableFalseElm);
	        }
	        return caretPosition;
	      }
	      if (nextNode) {
	        return getCaretCandidatePosition(direction, nextNode);
	      }
	      return null;
	    };
	    var CaretWalker = function (root) {
	      return {
	        next: function (caretPosition) {
	          return findCaretPosition(HDirection.Forwards, caretPosition, root);
	        },
	        prev: function (caretPosition) {
	          return findCaretPosition(HDirection.Backwards, caretPosition, root);
	        }
	      };
	    };
	
	    var walkToPositionIn = function (forward, root, start) {
	      var position = forward ? CaretPosition.before(start) : CaretPosition.after(start);
	      return fromPosition(forward, root, position);
	    };
	    var afterElement = function (node) {
	      return isBr(node) ? CaretPosition.before(node) : CaretPosition.after(node);
	    };
	    var isBeforeOrStart = function (position) {
	      if (CaretPosition.isTextPosition(position)) {
	        return position.offset() === 0;
	      } else {
	        return isCaretCandidate(position.getNode());
	      }
	    };
	    var isAfterOrEnd = function (position) {
	      if (CaretPosition.isTextPosition(position)) {
	        var container = position.container();
	        return position.offset() === container.data.length;
	      } else {
	        return isCaretCandidate(position.getNode(true));
	      }
	    };
	    var isBeforeAfterSameElement = function (from, to) {
	      return !CaretPosition.isTextPosition(from) && !CaretPosition.isTextPosition(to) && from.getNode() === to.getNode(true);
	    };
	    var isAtBr = function (position) {
	      return !CaretPosition.isTextPosition(position) && isBr(position.getNode());
	    };
	    var shouldSkipPosition = function (forward, from, to) {
	      if (forward) {
	        return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
	      } else {
	        return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
	      }
	    };
	    var fromPosition = function (forward, root, pos) {
	      var walker = CaretWalker(root);
	      return Optional.from(forward ? walker.next(pos) : walker.prev(pos));
	    };
	    var navigate = function (forward, root, from) {
	      return fromPosition(forward, root, from).bind(function (to) {
	        if (isInSameBlock(from, to, root) && shouldSkipPosition(forward, from, to)) {
	          return fromPosition(forward, root, to);
	        } else {
	          return Optional.some(to);
	        }
	      });
	    };
	    var navigateIgnore = function (forward, root, from, ignoreFilter) {
	      return navigate(forward, root, from).bind(function (pos) {
	        return ignoreFilter(pos) ? navigateIgnore(forward, root, pos, ignoreFilter) : Optional.some(pos);
	      });
	    };
	    var positionIn = function (forward, element) {
	      var startNode = forward ? element.firstChild : element.lastChild;
	      if (isText$1(startNode)) {
	        return Optional.some(CaretPosition(startNode, forward ? 0 : startNode.data.length));
	      } else if (startNode) {
	        if (isCaretCandidate(startNode)) {
	          return Optional.some(forward ? CaretPosition.before(startNode) : afterElement(startNode));
	        } else {
	          return walkToPositionIn(forward, element, startNode);
	        }
	      } else {
	        return Optional.none();
	      }
	    };
	    var nextPosition = curry(fromPosition, true);
	    var prevPosition = curry(fromPosition, false);
	    var firstPositionIn = curry(positionIn, true);
	    var lastPositionIn = curry(positionIn, false);
	
	    var CARET_ID = '_mce_caret';
	    var isCaretNode = function (node) {
	      return isElement$1(node) && node.id === CARET_ID;
	    };
	    var getParentCaretContainer = function (body, node) {
	      while (node && node !== body) {
	        if (node.id === CARET_ID) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	
	    var isStringPathBookmark = function (bookmark) {
	      return isString(bookmark.start);
	    };
	    var isRangeBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('rng');
	    };
	    var isIdBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('id');
	    };
	    var isIndexBookmark = function (bookmark) {
	      return bookmark.hasOwnProperty('name');
	    };
	    var isPathBookmark = function (bookmark) {
	      return Tools.isArray(bookmark.start);
	    };
	
	    var addBogus = function (dom, node) {
	      if (isElement$1(node) && dom.isBlock(node) && !node.innerHTML && !Env.ie) {
	        node.innerHTML = '<br data-mce-bogus="1" />';
	      }
	      return node;
	    };
	    var resolveCaretPositionBookmark = function (dom, bookmark) {
	      var pos;
	      var rng = dom.createRng();
	      pos = resolve$1(dom.getRoot(), bookmark.start);
	      rng.setStart(pos.container(), pos.offset());
	      pos = resolve$1(dom.getRoot(), bookmark.end);
	      rng.setEnd(pos.container(), pos.offset());
	      return rng;
	    };
	    var insertZwsp = function (node, rng) {
	      var textNode = node.ownerDocument.createTextNode(ZWSP);
	      node.appendChild(textNode);
	      rng.setStart(textNode, 0);
	      rng.setEnd(textNode, 0);
	    };
	    var isEmpty$1 = function (node) {
	      return node.hasChildNodes() === false;
	    };
	    var tryFindRangePosition = function (node, rng) {
	      return lastPositionIn(node).fold(never, function (pos) {
	        rng.setStart(pos.container(), pos.offset());
	        rng.setEnd(pos.container(), pos.offset());
	        return true;
	      });
	    };
	    var padEmptyCaretContainer = function (root, node, rng) {
	      if (isEmpty$1(node) && getParentCaretContainer(root, node)) {
	        insertZwsp(node, rng);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var setEndPoint = function (dom, start, bookmark, rng) {
	      var point = bookmark[start ? 'start' : 'end'];
	      var i, node, offset, children;
	      var root = dom.getRoot();
	      if (point) {
	        offset = point[0];
	        for (node = root, i = point.length - 1; i >= 1; i--) {
	          children = node.childNodes;
	          if (padEmptyCaretContainer(root, node, rng)) {
	            return true;
	          }
	          if (point[i] > children.length - 1) {
	            if (padEmptyCaretContainer(root, node, rng)) {
	              return true;
	            }
	            return tryFindRangePosition(node, rng);
	          }
	          node = children[point[i]];
	        }
	        if (node.nodeType === 3) {
	          offset = Math.min(point[0], node.nodeValue.length);
	        }
	        if (node.nodeType === 1) {
	          offset = Math.min(point[0], node.childNodes.length);
	        }
	        if (start) {
	          rng.setStart(node, offset);
	        } else {
	          rng.setEnd(node, offset);
	        }
	      }
	      return true;
	    };
	    var isValidTextNode = function (node) {
	      return isText$1(node) && node.data.length > 0;
	    };
	    var restoreEndPoint = function (dom, suffix, bookmark) {
	      var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev;
	      var keep = bookmark.keep;
	      var container, offset;
	      if (marker) {
	        node = marker.parentNode;
	        if (suffix === 'start') {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.nextSibling)) {
	              node = marker.nextSibling;
	              idx = 0;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker) + 1;
	            }
	          }
	          container = node;
	          offset = idx;
	        } else {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            if (marker.hasChildNodes()) {
	              node = marker.firstChild;
	              idx = 1;
	            } else if (isValidTextNode(marker.previousSibling)) {
	              node = marker.previousSibling;
	              idx = marker.previousSibling.data.length;
	            } else {
	              node = marker.parentNode;
	              idx = dom.nodeIndex(marker);
	            }
	          }
	          container = node;
	          offset = idx;
	        }
	        if (!keep) {
	          prev = marker.previousSibling;
	          next = marker.nextSibling;
	          Tools.each(Tools.grep(marker.childNodes), function (node) {
	            if (isText$1(node)) {
	              node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
	            }
	          });
	          while (marker = dom.get(bookmark.id + '_' + suffix)) {
	            dom.remove(marker, true);
	          }
	          if (prev && next && prev.nodeType === next.nodeType && isText$1(prev) && !Env.opera) {
	            idx = prev.nodeValue.length;
	            prev.appendData(next.nodeValue);
	            dom.remove(next);
	            container = prev;
	            offset = idx;
	          }
	        }
	        return Optional.some(CaretPosition(container, offset));
	      } else {
	        return Optional.none();
	      }
	    };
	    var resolvePaths = function (dom, bookmark) {
	      var rng = dom.createRng();
	      if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
	        return Optional.some(rng);
	      } else {
	        return Optional.none();
	      }
	    };
	    var resolveId = function (dom, bookmark) {
	      var startPos = restoreEndPoint(dom, 'start', bookmark);
	      var endPos = restoreEndPoint(dom, 'end', bookmark);
	      return lift2(startPos, endPos.or(startPos), function (spos, epos) {
	        var rng = dom.createRng();
	        rng.setStart(addBogus(dom, spos.container()), spos.offset());
	        rng.setEnd(addBogus(dom, epos.container()), epos.offset());
	        return rng;
	      });
	    };
	    var resolveIndex$1 = function (dom, bookmark) {
	      return Optional.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
	        var rng = dom.createRng();
	        rng.selectNode(elm);
	        return rng;
	      });
	    };
	    var resolve$2 = function (selection, bookmark) {
	      var dom = selection.dom;
	      if (bookmark) {
	        if (isPathBookmark(bookmark)) {
	          return resolvePaths(dom, bookmark);
	        } else if (isStringPathBookmark(bookmark)) {
	          return Optional.some(resolveCaretPositionBookmark(dom, bookmark));
	        } else if (isIdBookmark(bookmark)) {
	          return resolveId(dom, bookmark);
	        } else if (isIndexBookmark(bookmark)) {
	          return resolveIndex$1(dom, bookmark);
	        } else if (isRangeBookmark(bookmark)) {
	          return Optional.some(bookmark.rng);
	        }
	      }
	      return Optional.none();
	    };
	
	    var getBookmark$1 = function (selection, type, normalized) {
	      return getBookmark(selection, type, normalized);
	    };
	    var moveToBookmark = function (selection, bookmark) {
	      resolve$2(selection, bookmark).each(function (rng) {
	        selection.setRng(rng);
	      });
	    };
	    var isBookmarkNode$1 = function (node) {
	      return isElement$1(node) && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	
	    var is$2 = function (expected) {
	      return function (actual) {
	        return expected === actual;
	      };
	    };
	    var isNbsp = is$2(nbsp);
	    var isWhiteSpace$1 = function (chr) {
	      return chr !== '' && ' \f\n\r\t\x0B'.indexOf(chr) !== -1;
	    };
	    var isContent$1 = function (chr) {
	      return !isWhiteSpace$1(chr) && !isNbsp(chr);
	    };
	
	    var isNode = function (node) {
	      return !!node.nodeType;
	    };
	    var isInlineBlock = function (node) {
	      return node && /^(IMG)$/.test(node.nodeName);
	    };
	    var moveStart = function (dom, selection, rng) {
	      var offset = rng.startOffset;
	      var container = rng.startContainer, walker, node, nodes;
	      if (rng.startContainer === rng.endContainer) {
	        if (isInlineBlock(rng.startContainer.childNodes[rng.startOffset])) {
	          return;
	        }
	      }
	      if (container.nodeType === 1) {
	        nodes = container.childNodes;
	        if (offset < nodes.length) {
	          container = nodes[offset];
	          walker = new DomTreeWalker(container, dom.getParent(container, dom.isBlock));
	        } else {
	          container = nodes[nodes.length - 1];
	          walker = new DomTreeWalker(container, dom.getParent(container, dom.isBlock));
	          walker.next(true);
	        }
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3 && !isWhiteSpaceNode(node)) {
	            rng.setStart(node, 0);
	            selection.setRng(rng);
	            return;
	          }
	        }
	      }
	    };
	    var getNonWhiteSpaceSibling = function (node, next, inc) {
	      if (node) {
	        var nextName = next ? 'nextSibling' : 'previousSibling';
	        for (node = inc ? node : node[nextName]; node; node = node[nextName]) {
	          if (node.nodeType === 1 || !isWhiteSpaceNode(node)) {
	            return node;
	          }
	        }
	      }
	    };
	    var isTextBlock$1 = function (editor, name) {
	      if (isNode(name)) {
	        name = name.nodeName;
	      }
	      return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
	    };
	    var isValid = function (ed, parent, child) {
	      return ed.schema.isValidChild(parent, child);
	    };
	    var isWhiteSpaceNode = function (node, allowSpaces) {
	      if (allowSpaces === void 0) {
	        allowSpaces = false;
	      }
	      if (isNonNullable(node) && isText$1(node)) {
	        var data = allowSpaces ? node.data.replace(/ /g, '\xA0') : node.data;
	        return isWhitespaceText(data);
	      } else {
	        return false;
	      }
	    };
	    var isEmptyTextNode = function (node) {
	      return isNonNullable(node) && isText$1(node) && node.length === 0;
	    };
	    var replaceVars = function (value, vars) {
	      if (typeof value !== 'string') {
	        value = value(vars);
	      } else if (vars) {
	        value = value.replace(/%(\w+)/g, function (str, name) {
	          return vars[name] || str;
	        });
	      }
	      return value;
	    };
	    var isEq = function (str1, str2) {
	      str1 = str1 || '';
	      str2 = str2 || '';
	      str1 = '' + (str1.nodeName || str1);
	      str2 = '' + (str2.nodeName || str2);
	      return str1.toLowerCase() === str2.toLowerCase();
	    };
	    var normalizeStyleValue = function (dom, value, name) {
	      if (name === 'color' || name === 'backgroundColor') {
	        value = dom.toHex(value);
	      }
	      if (name === 'fontWeight' && value === 700) {
	        value = 'bold';
	      }
	      if (name === 'fontFamily') {
	        value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
	      }
	      return '' + value;
	    };
	    var getStyle = function (dom, node, name) {
	      return normalizeStyleValue(dom, dom.getStyle(node, name), name);
	    };
	    var getTextDecoration = function (dom, node) {
	      var decoration;
	      dom.getParent(node, function (n) {
	        decoration = dom.getStyle(n, 'text-decoration');
	        return decoration && decoration !== 'none';
	      });
	      return decoration;
	    };
	    var getParents$1 = function (dom, node, selector) {
	      return dom.getParents(node, selector, dom.getRoot());
	    };
	    var isVariableFormatName = function (editor, formatName) {
	      var hasVariableValues = function (format) {
	        var isVariableValue = function (val) {
	          return val.length > 1 && val.charAt(0) === '%';
	        };
	        return exists([
	          'styles',
	          'attributes'
	        ], function (key) {
	          return get$1(format, key).exists(function (field) {
	            var fieldValues = isArray(field) ? field : values(field);
	            return exists(fieldValues, isVariableValue);
	          });
	        });
	      };
	      return exists(editor.formatter.get(formatName), hasVariableValues);
	    };
	    var areSimilarFormats = function (editor, formatName, otherFormatName) {
	      var validKeys = [
	        'inline',
	        'block',
	        'selector',
	        'attributes',
	        'styles',
	        'classes'
	      ];
	      var filterObj = function (format) {
	        return filter$1(format, function (_, key) {
	          return exists(validKeys, function (validKey) {
	            return validKey === key;
	          });
	        });
	      };
	      return exists(editor.formatter.get(formatName), function (fmt1) {
	        var filteredFmt1 = filterObj(fmt1);
	        return exists(editor.formatter.get(otherFormatName), function (fmt2) {
	          var filteredFmt2 = filterObj(fmt2);
	          return equal(filteredFmt1, filteredFmt2);
	        });
	      });
	    };
	    var isBlockFormat = function (format) {
	      return hasNonNullableKey(format, 'block');
	    };
	    var isSelectorFormat = function (format) {
	      return hasNonNullableKey(format, 'selector');
	    };
	    var isInlineFormat = function (format) {
	      return hasNonNullableKey(format, 'inline');
	    };
	    var hasBlockChildren = function (dom, elm) {
	      return exists(elm.childNodes, dom.isBlock);
	    };
	
	    var isBookmarkNode$2 = isBookmarkNode$1;
	    var getParents$2 = getParents$1;
	    var isWhiteSpaceNode$1 = isWhiteSpaceNode;
	    var isTextBlock$2 = isTextBlock$1;
	    var isBogusBr = function (node) {
	      return isBr(node) && node.getAttribute('data-mce-bogus') && !node.nextSibling;
	    };
	    var findParentContentEditable = function (dom, node) {
	      var parent = node;
	      while (parent) {
	        if (isElement$1(parent) && dom.getContentEditable(parent)) {
	          return dom.getContentEditable(parent) === 'false' ? parent : node;
	        }
	        parent = parent.parentNode;
	      }
	      return node;
	    };
	    var walkText = function (start, node, offset, predicate) {
	      var str = node.data;
	      for (var i = offset; start ? i >= 0 : i < str.length; start ? i-- : i++) {
	        if (predicate(str.charAt(i))) {
	          return start ? i + 1 : i;
	        }
	      }
	      return -1;
	    };
	    var findSpace = function (start, node, offset) {
	      return walkText(start, node, offset, function (c) {
	        return isNbsp(c) || isWhiteSpace$1(c);
	      });
	    };
	    var findContent = function (start, node, offset) {
	      return walkText(start, node, offset, isContent$1);
	    };
	    var findWordEndPoint = function (dom, body, container, offset, start, includeTrailingSpaces) {
	      var lastTextNode;
	      var rootNode = dom.getParent(container, dom.isBlock) || body;
	      var walk = function (container, offset, pred) {
	        var textSeeker = TextSeeker(dom);
	        var walker = start ? textSeeker.backwards : textSeeker.forwards;
	        return Optional.from(walker(container, offset, function (text, textOffset) {
	          if (isBookmarkNode$2(text.parentNode)) {
	            return -1;
	          } else {
	            lastTextNode = text;
	            return pred(start, text, textOffset);
	          }
	        }, rootNode));
	      };
	      var spaceResult = walk(container, offset, findSpace);
	      return spaceResult.bind(function (result) {
	        return includeTrailingSpaces ? walk(result.container, result.offset + (start ? -1 : 0), findContent) : Optional.some(result);
	      }).orThunk(function () {
	        return lastTextNode ? Optional.some({
	          container: lastTextNode,
	          offset: start ? 0 : lastTextNode.length
	        }) : Optional.none();
	      });
	    };
	    var findSelectorEndPoint = function (dom, format, rng, container, siblingName) {
	      if (isText$1(container) && container.nodeValue.length === 0 && container[siblingName]) {
	        container = container[siblingName];
	      }
	      var parents = getParents$2(dom, container);
	      for (var i = 0; i < parents.length; i++) {
	        for (var y = 0; y < format.length; y++) {
	          var curFormat = format[y];
	          if ('collapsed' in curFormat && curFormat.collapsed !== rng.collapsed) {
	            continue;
	          }
	          if (dom.is(parents[i], curFormat.selector)) {
	            return parents[i];
	          }
	        }
	      }
	      return container;
	    };
	    var findBlockEndPoint = function (editor, format, container, siblingName) {
	      var node;
	      var dom = editor.dom;
	      var root = dom.getRoot();
	      if (!format[0].wrapper) {
	        node = dom.getParent(container, format[0].block, root);
	      }
	      if (!node) {
	        var scopeRoot = dom.getParent(container, 'LI,TD,TH');
	        node = dom.getParent(isText$1(container) ? container.parentNode : container, function (node) {
	          return node !== root && isTextBlock$2(editor, node);
	        }, scopeRoot);
	      }
	      if (node && format[0].wrapper) {
	        node = getParents$2(dom, node, 'ul,ol').reverse()[0] || node;
	      }
	      if (!node) {
	        node = container;
	        while (node[siblingName] && !dom.isBlock(node[siblingName])) {
	          node = node[siblingName];
	          if (isEq(node, 'br')) {
	            break;
	          }
	        }
	      }
	      return node || container;
	    };
	    var isAtBlockBoundary = function (dom, root, container, siblingName) {
	      var parent = container.parentNode;
	      if (isNonNullable(container[siblingName])) {
	        return false;
	      } else if (parent === root || isNullable(parent) || dom.isBlock(parent)) {
	        return true;
	      } else {
	        return isAtBlockBoundary(dom, root, parent, siblingName);
	      }
	    };
	    var findParentContainer = function (dom, format, container, offset, start) {
	      var parent = container;
	      var sibling;
	      var siblingName = start ? 'previousSibling' : 'nextSibling';
	      var root = dom.getRoot();
	      if (isText$1(container) && !isWhiteSpaceNode$1(container)) {
	        if (start ? offset > 0 : offset < container.data.length) {
	          return container;
	        }
	      }
	      while (true) {
	        if (!format[0].block_expand && dom.isBlock(parent)) {
	          return parent;
	        }
	        for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
	          var allowSpaces = isText$1(sibling) && !isAtBlockBoundary(dom, root, sibling, siblingName);
	          if (!isBookmarkNode$2(sibling) && !isBogusBr(sibling) && !isWhiteSpaceNode$1(sibling, allowSpaces)) {
	            return parent;
	          }
	        }
	        if (parent === root || parent.parentNode === root) {
	          container = parent;
	          break;
	        }
	        parent = parent.parentNode;
	      }
	      return container;
	    };
	    var isSelfOrParentBookmark = function (container) {
	      return isBookmarkNode$2(container.parentNode) || isBookmarkNode$2(container);
	    };
	    var expandRng = function (editor, rng, format, includeTrailingSpace) {
	      if (includeTrailingSpace === void 0) {
	        includeTrailingSpace = false;
	      }
	      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      var dom = editor.dom;
	      if (isElement$1(startContainer) && startContainer.hasChildNodes()) {
	        startContainer = getNode(startContainer, startOffset);
	        if (isText$1(startContainer)) {
	          startOffset = 0;
	        }
	      }
	      if (isElement$1(endContainer) && endContainer.hasChildNodes()) {
	        endContainer = getNode(endContainer, rng.collapsed ? endOffset : endOffset - 1);
	        if (isText$1(endContainer)) {
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      startContainer = findParentContentEditable(dom, startContainer);
	      endContainer = findParentContentEditable(dom, endContainer);
	      if (isSelfOrParentBookmark(startContainer)) {
	        startContainer = isBookmarkNode$2(startContainer) ? startContainer : startContainer.parentNode;
	        if (rng.collapsed) {
	          startContainer = startContainer.previousSibling || startContainer;
	        } else {
	          startContainer = startContainer.nextSibling || startContainer;
	        }
	        if (isText$1(startContainer)) {
	          startOffset = rng.collapsed ? startContainer.length : 0;
	        }
	      }
	      if (isSelfOrParentBookmark(endContainer)) {
	        endContainer = isBookmarkNode$2(endContainer) ? endContainer : endContainer.parentNode;
	        if (rng.collapsed) {
	          endContainer = endContainer.nextSibling || endContainer;
	        } else {
	          endContainer = endContainer.previousSibling || endContainer;
	        }
	        if (isText$1(endContainer)) {
	          endOffset = rng.collapsed ? 0 : endContainer.length;
	        }
	      }
	      if (rng.collapsed) {
	        var startPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, includeTrailingSpace);
	        startPoint.each(function (_a) {
	          var container = _a.container, offset = _a.offset;
	          startContainer = container;
	          startOffset = offset;
	        });
	        var endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, includeTrailingSpace);
	        endPoint.each(function (_a) {
	          var container = _a.container, offset = _a.offset;
	          endContainer = container;
	          endOffset = offset;
	        });
	      }
	      if (format[0].inline || format[0].block_expand) {
	        if (!format[0].inline || (!isText$1(startContainer) || startOffset === 0)) {
	          startContainer = findParentContainer(dom, format, startContainer, startOffset, true);
	        }
	        if (!format[0].inline || (!isText$1(endContainer) || endOffset === endContainer.nodeValue.length)) {
	          endContainer = findParentContainer(dom, format, endContainer, endOffset, false);
	        }
	      }
	      if (format[0].selector && format[0].expand !== false && !format[0].inline) {
	        startContainer = findSelectorEndPoint(dom, format, rng, startContainer, 'previousSibling');
	        endContainer = findSelectorEndPoint(dom, format, rng, endContainer, 'nextSibling');
	      }
	      if (format[0].block || format[0].selector) {
	        startContainer = findBlockEndPoint(editor, format, startContainer, 'previousSibling');
	        endContainer = findBlockEndPoint(editor, format, endContainer, 'nextSibling');
	        if (format[0].block) {
	          if (!dom.isBlock(startContainer)) {
	            startContainer = findParentContainer(dom, format, startContainer, startOffset, true);
	          }
	          if (!dom.isBlock(endContainer)) {
	            endContainer = findParentContainer(dom, format, endContainer, endOffset, false);
	          }
	        }
	      }
	      if (isElement$1(startContainer)) {
	        startOffset = dom.nodeIndex(startContainer);
	        startContainer = startContainer.parentNode;
	      }
	      if (isElement$1(endContainer)) {
	        endOffset = dom.nodeIndex(endContainer) + 1;
	        endContainer = endContainer.parentNode;
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	
	    var clampToExistingChildren = function (container, index) {
	      var childNodes = container.childNodes;
	      if (index >= childNodes.length) {
	        index = childNodes.length - 1;
	      } else if (index < 0) {
	        index = 0;
	      }
	      return childNodes[index] || container;
	    };
	    var getEndChild = function (container, index) {
	      return clampToExistingChildren(container, index - 1);
	    };
	    var walk$1 = function (dom, rng, callback) {
	      var startContainer = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endContainer = rng.endContainer;
	      var endOffset = rng.endOffset;
	      var exclude = function (nodes) {
	        var node;
	        node = nodes[0];
	        if (node.nodeType === 3 && node === startContainer && startOffset >= node.nodeValue.length) {
	          nodes.splice(0, 1);
	        }
	        node = nodes[nodes.length - 1];
	        if (endOffset === 0 && nodes.length > 0 && node === endContainer && node.nodeType === 3) {
	          nodes.splice(nodes.length - 1, 1);
	        }
	        return nodes;
	      };
	      var collectSiblings = function (node, name, endNode) {
	        var siblings = [];
	        for (; node && node !== endNode; node = node[name]) {
	          siblings.push(node);
	        }
	        return siblings;
	      };
	      var findEndPoint = function (node, root) {
	        do {
	          if (node.parentNode === root) {
	            return node;
	          }
	          node = node.parentNode;
	        } while (node);
	      };
	      var walkBoundary = function (startNode, endNode, next) {
	        var siblingName = next ? 'nextSibling' : 'previousSibling';
	        for (var node = startNode, parent_1 = node.parentNode; node && node !== endNode; node = parent_1) {
	          parent_1 = node.parentNode;
	          var siblings_1 = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
	          if (siblings_1.length) {
	            if (!next) {
	              siblings_1.reverse();
	            }
	            callback(exclude(siblings_1));
	          }
	        }
	      };
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = clampToExistingChildren(startContainer, startOffset);
	      }
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = getEndChild(endContainer, endOffset);
	      }
	      if (startContainer === endContainer) {
	        return callback(exclude([startContainer]));
	      }
	      var ancestor = dom.findCommonAncestor(startContainer, endContainer);
	      for (var node = startContainer; node; node = node.parentNode) {
	        if (node === endContainer) {
	          return walkBoundary(startContainer, ancestor, true);
	        }
	        if (node === ancestor) {
	          break;
	        }
	      }
	      for (var node = endContainer; node; node = node.parentNode) {
	        if (node === startContainer) {
	          return walkBoundary(endContainer, ancestor);
	        }
	        if (node === ancestor) {
	          break;
	        }
	      }
	      var startPoint = findEndPoint(startContainer, ancestor) || startContainer;
	      var endPoint = findEndPoint(endContainer, ancestor) || endContainer;
	      walkBoundary(startContainer, startPoint, true);
	      var siblings = collectSiblings(startPoint === startContainer ? startPoint : startPoint.nextSibling, 'nextSibling', endPoint === endContainer ? endPoint.nextSibling : endPoint);
	      if (siblings.length) {
	        callback(exclude(siblings));
	      }
	      walkBoundary(endContainer, endPoint);
	    };
	
	    var getRanges = function (selection) {
	      var ranges = [];
	      if (selection) {
	        for (var i = 0; i < selection.rangeCount; i++) {
	          ranges.push(selection.getRangeAt(i));
	        }
	      }
	      return ranges;
	    };
	    var getSelectedNodes = function (ranges) {
	      return bind(ranges, function (range) {
	        var node = getSelectedNode(range);
	        return node ? [SugarElement.fromDom(node)] : [];
	      });
	    };
	    var hasMultipleRanges = function (selection) {
	      return getRanges(selection).length > 1;
	    };
	
	    var getCellsFromRanges = function (ranges) {
	      return filter(getSelectedNodes(ranges), isTableCell$1);
	    };
	    var getCellsFromElement = function (elm) {
	      return descendants$1(elm, 'td[data-mce-selected],th[data-mce-selected]');
	    };
	    var getCellsFromElementOrRanges = function (ranges, element) {
	      var selectedCells = getCellsFromElement(element);
	      return selectedCells.length > 0 ? selectedCells : getCellsFromRanges(ranges);
	    };
	    var getCellsFromEditor = function (editor) {
	      return getCellsFromElementOrRanges(getRanges(editor.selection.getSel()), SugarElement.fromDom(editor.getBody()));
	    };
	
	    var getStartNode = function (rng) {
	      var sc = rng.startContainer, so = rng.startOffset;
	      if (isText$1(sc)) {
	        return so === 0 ? Optional.some(SugarElement.fromDom(sc)) : Optional.none();
	      } else {
	        return Optional.from(sc.childNodes[so]).map(SugarElement.fromDom);
	      }
	    };
	    var getEndNode = function (rng) {
	      var ec = rng.endContainer, eo = rng.endOffset;
	      if (isText$1(ec)) {
	        return eo === ec.data.length ? Optional.some(SugarElement.fromDom(ec)) : Optional.none();
	      } else {
	        return Optional.from(ec.childNodes[eo - 1]).map(SugarElement.fromDom);
	      }
	    };
	    var getFirstChildren = function (node) {
	      return firstChild(node).fold(constant([node]), function (child) {
	        return [node].concat(getFirstChildren(child));
	      });
	    };
	    var getLastChildren = function (node) {
	      return lastChild(node).fold(constant([node]), function (child) {
	        if (name(child) === 'br') {
	          return prevSibling(child).map(function (sibling) {
	            return [node].concat(getLastChildren(sibling));
	          }).getOr([]);
	        } else {
	          return [node].concat(getLastChildren(child));
	        }
	      });
	    };
	    var hasAllContentsSelected = function (elm, rng) {
	      return lift2(getStartNode(rng), getEndNode(rng), function (startNode, endNode) {
	        var start = find(getFirstChildren(elm), curry(eq$2, startNode));
	        var end = find(getLastChildren(elm), curry(eq$2, endNode));
	        return start.isSome() && end.isSome();
	      }).getOr(false);
	    };
	    var moveEndPoint$1 = function (dom, rng, node, start) {
	      var root = node, walker = new DomTreeWalker(node, root);
	      var moveCaretBeforeOnEnterElementsMap = filter$1(dom.schema.getMoveCaretBeforeOnEnterElements(), function (_, name) {
	        return !contains([
	          'td',
	          'th',
	          'table'
	        ], name.toLowerCase());
	      });
	      do {
	        if (isText$1(node) && Tools.trim(node.nodeValue).length !== 0) {
	          if (start) {
	            rng.setStart(node, 0);
	          } else {
	            rng.setEnd(node, node.nodeValue.length);
	          }
	          return;
	        }
	        if (moveCaretBeforeOnEnterElementsMap[node.nodeName]) {
	          if (start) {
	            rng.setStartBefore(node);
	          } else {
	            if (node.nodeName === 'BR') {
	              rng.setEndBefore(node);
	            } else {
	              rng.setEndAfter(node);
	            }
	          }
	          return;
	        }
	      } while (node = start ? walker.next() : walker.prev());
	      if (root.nodeName === 'BODY') {
	        if (start) {
	          rng.setStart(root, 0);
	        } else {
	          rng.setEnd(root, root.childNodes.length);
	        }
	      }
	    };
	    var hasAnyRanges = function (editor) {
	      var sel = editor.selection.getSel();
	      return sel && sel.rangeCount > 0;
	    };
	    var runOnRanges = function (editor, executor) {
	      var fakeSelectionNodes = getCellsFromEditor(editor);
	      if (fakeSelectionNodes.length > 0) {
	        each(fakeSelectionNodes, function (elem) {
	          var node = elem.dom;
	          var fakeNodeRng = editor.dom.createRng();
	          fakeNodeRng.setStartBefore(node);
	          fakeNodeRng.setEndAfter(node);
	          executor(fakeNodeRng, true);
	        });
	      } else {
	        executor(editor.selection.getRng(), false);
	      }
	    };
	    var preserve = function (selection, fillBookmark, executor) {
	      var bookmark = getPersistentBookmark(selection, fillBookmark);
	      executor(bookmark);
	      selection.moveToBookmark(bookmark);
	    };
	
	    var NodeValue = function (is, name) {
	      var get = function (element) {
	        if (!is(element)) {
	          throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        }
	        return getOption(element).getOr('');
	      };
	      var getOption = function (element) {
	        return is(element) ? Optional.from(element.dom.nodeValue) : Optional.none();
	      };
	      var set = function (element, value) {
	        if (!is(element)) {
	          throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        }
	        element.dom.nodeValue = value;
	      };
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	
	    var api = NodeValue(isText, 'text');
	    var get$8 = function (element) {
	      return api.get(element);
	    };
	
	    var isZeroWidth = function (elem) {
	      return isText(elem) && get$8(elem) === ZWSP;
	    };
	    var context = function (editor, elem, wrapName, nodeName) {
	      return parent(elem).fold(function () {
	        return 'skipping';
	      }, function (parent) {
	        if (nodeName === 'br' || isZeroWidth(elem)) {
	          return 'valid';
	        } else if (isAnnotation(elem)) {
	          return 'existing';
	        } else if (isCaretNode(elem.dom)) {
	          return 'caret';
	        } else if (!isValid(editor, wrapName, nodeName) || !isValid(editor, name(parent), wrapName)) {
	          return 'invalid-child';
	        } else {
	          return 'valid';
	        }
	      });
	    };
	
	    var applyWordGrab = function (editor, rng) {
	      var r = expandRng(editor, rng, [{ inline: true }]);
	      rng.setStart(r.startContainer, r.startOffset);
	      rng.setEnd(r.endContainer, r.endOffset);
	      editor.selection.setRng(rng);
	    };
	    var makeAnnotation = function (eDoc, _a, annotationName, decorate) {
	      var _b = _a.uid, uid = _b === void 0 ? generate$1('mce-annotation') : _b, data = __rest(_a, ['uid']);
	      var master = SugarElement.fromTag('span', eDoc);
	      add$3(master, annotation());
	      set(master, '' + dataAnnotationId(), uid);
	      set(master, '' + dataAnnotation(), annotationName);
	      var _c = decorate(uid, data), _d = _c.attributes, attributes = _d === void 0 ? {} : _d, _e = _c.classes, classes = _e === void 0 ? [] : _e;
	      setAll(master, attributes);
	      add$4(master, classes);
	      return master;
	    };
	    var annotate = function (editor, rng, annotationName, decorate, data) {
	      var newWrappers = [];
	      var master = makeAnnotation(editor.getDoc(), data, annotationName, decorate);
	      var wrapper = Cell(Optional.none());
	      var finishWrapper = function () {
	        wrapper.set(Optional.none());
	      };
	      var getOrOpenWrapper = function () {
	        return wrapper.get().getOrThunk(function () {
	          var nu = shallow(master);
	          newWrappers.push(nu);
	          wrapper.set(Optional.some(nu));
	          return nu;
	        });
	      };
	      var processElements = function (elems) {
	        each(elems, processElement);
	      };
	      var processElement = function (elem) {
	        var ctx = context(editor, elem, 'span', name(elem));
	        switch (ctx) {
	        case 'invalid-child': {
	            finishWrapper();
	            var children$1 = children(elem);
	            processElements(children$1);
	            finishWrapper();
	            break;
	          }
	        case 'valid': {
	            var w = getOrOpenWrapper();
	            wrap(elem, w);
	            break;
	          }
	        }
	      };
	      var processNodes = function (nodes) {
	        var elems = map(nodes, SugarElement.fromDom);
	        processElements(elems);
	      };
	      walk$1(editor.dom, rng, function (nodes) {
	        finishWrapper();
	        processNodes(nodes);
	      });
	      return newWrappers;
	    };
	    var annotateWithBookmark = function (editor, name, settings, data) {
	      editor.undoManager.transact(function () {
	        var selection = editor.selection;
	        var initialRng = selection.getRng();
	        var hasFakeSelection = getCellsFromEditor(editor).length > 0;
	        if (initialRng.collapsed && !hasFakeSelection) {
	          applyWordGrab(editor, initialRng);
	        }
	        if (selection.getRng().collapsed && !hasFakeSelection) {
	          var wrapper = makeAnnotation(editor.getDoc(), data, name, settings.decorate);
	          set$1(wrapper, nbsp);
	          selection.getRng().insertNode(wrapper.dom);
	          selection.select(wrapper.dom);
	        } else {
	          preserve(selection, false, function () {
	            runOnRanges(editor, function (selectionRng) {
	              annotate(editor, selectionRng, name, settings.decorate, data);
	            });
	          });
	        }
	      });
	    };
	
	    var Annotator = function (editor) {
	      var registry = create$2();
	      setup$1(editor, registry);
	      var changes = setup(editor);
	      return {
	        register: function (name, settings) {
	          registry.register(name, settings);
	        },
	        annotate: function (name, data) {
	          registry.lookup(name).each(function (settings) {
	            annotateWithBookmark(editor, name, settings, data);
	          });
	        },
	        annotationChanged: function (name, callback) {
	          changes.addListener(name, callback);
	        },
	        remove: function (name) {
	          identify(editor, Optional.some(name)).each(function (_a) {
	            var elements = _a.elements;
	            each(elements, unwrap);
	          });
	        },
	        getAll: function (name) {
	          var directory = findAll(editor, name);
	          return map$1(directory, function (elems) {
	            return map(elems, function (elem) {
	              return elem.dom;
	            });
	          });
	        }
	      };
	    };
	
	    var BookmarkManager = function (selection) {
	      return {
	        getBookmark: curry(getBookmark$1, selection),
	        moveToBookmark: curry(moveToBookmark, selection)
	      };
	    };
	    BookmarkManager.isBookmarkNode = isBookmarkNode$1;
	
	    var getContentEditableRoot = function (root, node) {
	      while (node && node !== root) {
	        if (isContentEditableTrue(node) || isContentEditableFalse(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	
	    var isXYWithinRange = function (clientX, clientY, range) {
	      if (range.collapsed) {
	        return false;
	      }
	      if (Env.browser.isIE() && range.startOffset === range.endOffset - 1 && range.startContainer === range.endContainer) {
	        var elm = range.startContainer.childNodes[range.startOffset];
	        if (isElement$1(elm)) {
	          return exists(elm.getClientRects(), function (rect) {
	            return containsXY(rect, clientX, clientY);
	          });
	        }
	      }
	      return exists(range.getClientRects(), function (rect) {
	        return containsXY(rect, clientX, clientY);
	      });
	    };
	
	    var firePreProcess = function (editor, args) {
	      return editor.fire('PreProcess', args);
	    };
	    var firePostProcess = function (editor, args) {
	      return editor.fire('PostProcess', args);
	    };
	    var fireRemove = function (editor) {
	      return editor.fire('remove');
	    };
	    var fireDetach = function (editor) {
	      return editor.fire('detach');
	    };
	    var fireSwitchMode = function (editor, mode) {
	      return editor.fire('SwitchMode', { mode: mode });
	    };
	    var fireObjectResizeStart = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResizeStart', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var fireObjectResized = function (editor, target, width, height, origin) {
	      editor.fire('ObjectResized', {
	        target: target,
	        width: width,
	        height: height,
	        origin: origin
	      });
	    };
	    var firePreInit = function (editor) {
	      return editor.fire('PreInit');
	    };
	    var firePostRender = function (editor) {
	      return editor.fire('PostRender');
	    };
	    var fireInit = function (editor) {
	      return editor.fire('Init');
	    };
	    var firePlaceholderToggle = function (editor, state) {
	      return editor.fire('PlaceholderToggle', { state: state });
	    };
	    var fireError = function (editor, errorType, error) {
	      return editor.fire(errorType, error);
	    };
	
	    var VK = {
	      BACKSPACE: 8,
	      DELETE: 46,
	      DOWN: 40,
	      ENTER: 13,
	      LEFT: 37,
	      RIGHT: 39,
	      SPACEBAR: 32,
	      TAB: 9,
	      UP: 38,
	      PAGE_UP: 33,
	      PAGE_DOWN: 34,
	      END: 35,
	      HOME: 36,
	      modifierPressed: function (e) {
	        return e.shiftKey || e.ctrlKey || e.altKey || VK.metaKeyPressed(e);
	      },
	      metaKeyPressed: function (e) {
	        return Env.mac ? e.metaKey : e.ctrlKey && !e.altKey;
	      }
	    };
	
	    var isContentEditableFalse$6 = isContentEditableFalse;
	    var ControlSelection = function (selection, editor) {
	      var elementSelectionAttr = 'data-mce-selected';
	      var dom = editor.dom, each$2 = Tools.each;
	      var selectedElm, selectedElmGhost, resizeHelper, selectedHandle, resizeBackdrop;
	      var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
	      var width, height;
	      var editableDoc = editor.getDoc(), rootDocument = document;
	      var abs = Math.abs, round = Math.round, rootElement = editor.getBody();
	      var startScrollWidth, startScrollHeight;
	      var resizeHandles = {
	        nw: [
	          0,
	          0,
	          -1,
	          -1
	        ],
	        ne: [
	          1,
	          0,
	          1,
	          -1
	        ],
	        se: [
	          1,
	          1,
	          1,
	          1
	        ],
	        sw: [
	          0,
	          1,
	          -1,
	          1
	        ]
	      };
	      var isImage = function (elm) {
	        return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
	      };
	      var isMedia$1 = function (elm) {
	        return isMedia(elm) || dom.hasClass(elm, 'mce-preview-object');
	      };
	      var isEventOnImageOutsideRange = function (evt, range) {
	        if (evt.type === 'longpress' || evt.type.indexOf('touch') === 0) {
	          var touch = evt.touches[0];
	          return isImage(evt.target) && !isXYWithinRange(touch.clientX, touch.clientY, range);
	        } else {
	          return isImage(evt.target) && !isXYWithinRange(evt.clientX, evt.clientY, range);
	        }
	      };
	      var contextMenuSelectImage = function (evt) {
	        var target = evt.target;
	        if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
	          editor.selection.select(target);
	        }
	      };
	      var getResizeTargets = function (elm) {
	        if (dom.is(elm, 'figure.image')) {
	          return [elm.querySelector('img')];
	        } else if (dom.hasClass(elm, 'mce-preview-object') && isNonNullable(elm.firstElementChild)) {
	          return [
	            elm,
	            elm.firstElementChild
	          ];
	        } else {
	          return [elm];
	        }
	      };
	      var isResizable = function (elm) {
	        var selector = getObjectResizing(editor);
	        if (!selector) {
	          return false;
	        }
	        if (elm.getAttribute('data-mce-resize') === 'false') {
	          return false;
	        }
	        if (elm === editor.getBody()) {
	          return false;
	        }
	        if (dom.hasClass(elm, 'mce-preview-object')) {
	          return is$1(SugarElement.fromDom(elm.firstElementChild), selector);
	        } else {
	          return is$1(SugarElement.fromDom(elm), selector);
	        }
	      };
	      var createGhostElement = function (elm) {
	        if (isMedia$1(elm)) {
	          return dom.create('img', { src: Env.transparentSrc });
	        } else {
	          return elm.cloneNode(true);
	        }
	      };
	      var setSizeProp = function (element, name, value) {
	        if (isNonNullable(value)) {
	          var targets = getResizeTargets(element);
	          each(targets, function (target) {
	            if (target.style[name] || !editor.schema.isValid(target.nodeName.toLowerCase(), name)) {
	              dom.setStyle(target, name, value);
	            } else {
	              dom.setAttrib(target, name, '' + value);
	            }
	          });
	        }
	      };
	      var setGhostElmSize = function (ghostElm, width, height) {
	        setSizeProp(ghostElm, 'width', width);
	        setSizeProp(ghostElm, 'height', height);
	      };
	      var resizeGhostElement = function (e) {
	        var deltaX, deltaY, proportional;
	        var resizeHelperX, resizeHelperY;
	        deltaX = e.screenX - startX;
	        deltaY = e.screenY - startY;
	        width = deltaX * selectedHandle[2] + startW;
	        height = deltaY * selectedHandle[3] + startH;
	        width = width < 5 ? 5 : width;
	        height = height < 5 ? 5 : height;
	        if ((isImage(selectedElm) || isMedia$1(selectedElm)) && getResizeImgProportional(editor) !== false) {
	          proportional = !VK.modifierPressed(e);
	        } else {
	          proportional = VK.modifierPressed(e);
	        }
	        if (proportional) {
	          if (abs(deltaX) > abs(deltaY)) {
	            height = round(width * ratio);
	            width = round(height / ratio);
	          } else {
	            width = round(height / ratio);
	            height = round(width * ratio);
	          }
	        }
	        setGhostElmSize(selectedElmGhost, width, height);
	        resizeHelperX = selectedHandle.startPos.x + deltaX;
	        resizeHelperY = selectedHandle.startPos.y + deltaY;
	        resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
	        resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
	        dom.setStyles(resizeHelper, {
	          left: resizeHelperX,
	          top: resizeHelperY,
	          display: 'block'
	        });
	        resizeHelper.innerHTML = width + ' &times; ' + height;
	        if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
	          dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
	        }
	        if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
	          dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
	        }
	        deltaX = rootElement.scrollWidth - startScrollWidth;
	        deltaY = rootElement.scrollHeight - startScrollHeight;
	        if (deltaX + deltaY !== 0) {
	          dom.setStyles(resizeHelper, {
	            left: resizeHelperX - deltaX,
	            top: resizeHelperY - deltaY
	          });
	        }
	        if (!resizeStarted) {
	          fireObjectResizeStart(editor, selectedElm, startW, startH, 'corner-' + selectedHandle.name);
	          resizeStarted = true;
	        }
	      };
	      var endGhostResize = function () {
	        var wasResizeStarted = resizeStarted;
	        resizeStarted = false;
	        if (wasResizeStarted) {
	          setSizeProp(selectedElm, 'width', width);
	          setSizeProp(selectedElm, 'height', height);
	        }
	        dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
	        dom.unbind(editableDoc, 'mouseup', endGhostResize);
	        if (rootDocument !== editableDoc) {
	          dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
	          dom.unbind(rootDocument, 'mouseup', endGhostResize);
	        }
	        dom.remove(selectedElmGhost);
	        dom.remove(resizeHelper);
	        dom.remove(resizeBackdrop);
	        showResizeRect(selectedElm);
	        if (wasResizeStarted) {
	          fireObjectResized(editor, selectedElm, width, height, 'corner-' + selectedHandle.name);
	          dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
	        }
	        editor.nodeChanged();
	      };
	      var showResizeRect = function (targetElm) {
	        unbindResizeHandleEvents();
	        var position = dom.getPos(targetElm, rootElement);
	        var selectedElmX = position.x;
	        var selectedElmY = position.y;
	        var rect = targetElm.getBoundingClientRect();
	        var targetWidth = rect.width || rect.right - rect.left;
	        var targetHeight = rect.height || rect.bottom - rect.top;
	        if (selectedElm !== targetElm) {
	          hideResizeRect();
	          selectedElm = targetElm;
	          width = height = 0;
	        }
	        var e = editor.fire('ObjectSelected', { target: targetElm });
	        var selectedValue = dom.getAttrib(selectedElm, elementSelectionAttr, '1');
	        if (isResizable(targetElm) && !e.isDefaultPrevented()) {
	          each$2(resizeHandles, function (handle, name) {
	            var handleElm;
	            var startDrag = function (e) {
	              var target = getResizeTargets(selectedElm)[0];
	              startX = e.screenX;
	              startY = e.screenY;
	              startW = target.clientWidth;
	              startH = target.clientHeight;
	              ratio = startH / startW;
	              selectedHandle = handle;
	              selectedHandle.name = name;
	              selectedHandle.startPos = {
	                x: targetWidth * handle[0] + selectedElmX,
	                y: targetHeight * handle[1] + selectedElmY
	              };
	              startScrollWidth = rootElement.scrollWidth;
	              startScrollHeight = rootElement.scrollHeight;
	              resizeBackdrop = dom.add(rootElement, 'div', { class: 'mce-resize-backdrop' });
	              dom.setStyles(resizeBackdrop, {
	                position: 'fixed',
	                left: '0',
	                top: '0',
	                width: '100%',
	                height: '100%'
	              });
	              selectedElmGhost = createGhostElement(selectedElm);
	              dom.addClass(selectedElmGhost, 'mce-clonedresizable');
	              dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
	              selectedElmGhost.contentEditable = 'false';
	              dom.setStyles(selectedElmGhost, {
	                left: selectedElmX,
	                top: selectedElmY,
	                margin: 0
	              });
	              setGhostElmSize(selectedElmGhost, targetWidth, targetHeight);
	              selectedElmGhost.removeAttribute(elementSelectionAttr);
	              rootElement.appendChild(selectedElmGhost);
	              dom.bind(editableDoc, 'mousemove', resizeGhostElement);
	              dom.bind(editableDoc, 'mouseup', endGhostResize);
	              if (rootDocument !== editableDoc) {
	                dom.bind(rootDocument, 'mousemove', resizeGhostElement);
	                dom.bind(rootDocument, 'mouseup', endGhostResize);
	              }
	              resizeHelper = dom.add(rootElement, 'div', {
	                'class': 'mce-resize-helper',
	                'data-mce-bogus': 'all'
	              }, startW + ' &times; ' + startH);
	            };
	            handleElm = dom.get('mceResizeHandle' + name);
	            if (handleElm) {
	              dom.remove(handleElm);
	            }
	            handleElm = dom.add(rootElement, 'div', {
	              'id': 'mceResizeHandle' + name,
	              'data-mce-bogus': 'all',
	              'class': 'mce-resizehandle',
	              'unselectable': true,
	              'style': 'cursor:' + name + '-resize; margin:0; padding:0'
	            });
	            if (Env.ie === 11) {
	              handleElm.contentEditable = false;
	            }
	            dom.bind(handleElm, 'mousedown', function (e) {
	              e.stopImmediatePropagation();
	              e.preventDefault();
	              startDrag(e);
	            });
	            handle.elm = handleElm;
	            dom.setStyles(handleElm, {
	              left: targetWidth * handle[0] + selectedElmX - handleElm.offsetWidth / 2,
	              top: targetHeight * handle[1] + selectedElmY - handleElm.offsetHeight / 2
	            });
	          });
	        } else {
	          hideResizeRect();
	        }
	        if (!dom.getAttrib(selectedElm, elementSelectionAttr)) {
	          selectedElm.setAttribute(elementSelectionAttr, selectedValue);
	        }
	      };
	      var hideResizeRect = function () {
	        unbindResizeHandleEvents();
	        if (selectedElm) {
	          selectedElm.removeAttribute(elementSelectionAttr);
	        }
	        each$1(resizeHandles, function (value, name) {
	          var handleElm = dom.get('mceResizeHandle' + name);
	          if (handleElm) {
	            dom.unbind(handleElm);
	            dom.remove(handleElm);
	          }
	        });
	      };
	      var updateResizeRect = function (e) {
	        var startElm, controlElm;
	        var isChildOrEqual = function (node, parent) {
	          if (node) {
	            do {
	              if (node === parent) {
	                return true;
	              }
	            } while (node = node.parentNode);
	          }
	        };
	        if (resizeStarted || editor.removed) {
	          return;
	        }
	        each$2(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
	          img.removeAttribute(elementSelectionAttr);
	        });
	        controlElm = e.type === 'mousedown' ? e.target : selection.getNode();
	        controlElm = dom.$(controlElm).closest('table,img,figure.image,hr,video,span.mce-preview-object')[0];
	        if (isChildOrEqual(controlElm, rootElement)) {
	          disableGeckoResize();
	          startElm = selection.getStart(true);
	          if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
	            showResizeRect(controlElm);
	            return;
	          }
	        }
	        hideResizeRect();
	      };
	      var isWithinContentEditableFalse = function (elm) {
	        return isContentEditableFalse$6(getContentEditableRoot(editor.getBody(), elm));
	      };
	      var unbindResizeHandleEvents = function () {
	        each$1(resizeHandles, function (handle) {
	          if (handle.elm) {
	            dom.unbind(handle.elm);
	            delete handle.elm;
	          }
	        });
	      };
	      var disableGeckoResize = function () {
	        try {
	          editor.getDoc().execCommand('enableObjectResizing', false, 'false');
	        } catch (ex) {
	        }
	      };
	      editor.on('init', function () {
	        disableGeckoResize();
	        if (Env.browser.isIE() || Env.browser.isEdge()) {
	          editor.on('mousedown click', function (e) {
	            var target = e.target, nodeName = target.nodeName;
	            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
	              if (e.button !== 2) {
	                editor.selection.select(target, nodeName === 'TABLE');
	              }
	              if (e.type === 'mousedown') {
	                editor.nodeChanged();
	              }
	            }
	          });
	          var handleMSControlSelect_1 = function (e) {
	            var delayedSelect = function (node) {
	              Delay.setEditorTimeout(editor, function () {
	                return editor.selection.select(node);
	              });
	            };
	            if (isWithinContentEditableFalse(e.target) || isMedia(e.target)) {
	              e.preventDefault();
	              delayedSelect(e.target);
	              return;
	            }
	            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
	              e.preventDefault();
	              if (e.target.tagName === 'IMG') {
	                delayedSelect(e.target);
	              }
	            }
	          };
	          dom.bind(rootElement, 'mscontrolselect', handleMSControlSelect_1);
	          editor.on('remove', function () {
	            return dom.unbind(rootElement, 'mscontrolselect', handleMSControlSelect_1);
	          });
	        }
	        var throttledUpdateResizeRect = Delay.throttle(function (e) {
	          if (!editor.composing) {
	            updateResizeRect(e);
	          }
	        });
	        editor.on('nodechange ResizeEditor ResizeWindow ResizeContent drop FullscreenStateChanged', throttledUpdateResizeRect);
	        editor.on('keyup compositionend', function (e) {
	          if (selectedElm && selectedElm.nodeName === 'TABLE') {
	            throttledUpdateResizeRect(e);
	          }
	        });
	        editor.on('hide blur', hideResizeRect);
	        editor.on('contextmenu longpress', contextMenuSelectImage, true);
	      });
	      editor.on('remove', unbindResizeHandleEvents);
	      var destroy = function () {
	        selectedElm = selectedElmGhost = resizeBackdrop = null;
	      };
	      return {
	        isResizable: isResizable,
	        showResizeRect: showResizeRect,
	        hideResizeRect: hideResizeRect,
	        updateResizeRect: updateResizeRect,
	        destroy: destroy
	      };
	    };
	
	    var hasCeProperty = function (node) {
	      return isContentEditableTrue(node) || isContentEditableFalse(node);
	    };
	    var findParent = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var findClosestIeRange = function (clientX, clientY, doc) {
	      var rects;
	      var element = doc.elementFromPoint(clientX, clientY);
	      var rng = doc.body.createTextRange();
	      if (!element || element.tagName === 'HTML') {
	        element = doc.body;
	      }
	      rng.moveToElementText(element);
	      rects = Tools.toArray(rng.getClientRects());
	      rects = rects.sort(function (a, b) {
	        a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
	        b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
	        return a - b;
	      });
	      if (rects.length > 0) {
	        clientY = (rects[0].bottom + rects[0].top) / 2;
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	          return rng;
	        } catch (ex) {
	        }
	      }
	      return null;
	    };
	    var moveOutOfContentEditableFalse = function (rng, rootNode) {
	      var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
	      return isContentEditableFalse(findParent(parentElement, rootNode, hasCeProperty)) ? null : rng;
	    };
	    var fromPoint$1 = function (clientX, clientY, doc) {
	      var rng, point;
	      var pointDoc = doc;
	      if (pointDoc.caretPositionFromPoint) {
	        point = pointDoc.caretPositionFromPoint(clientX, clientY);
	        if (point) {
	          rng = doc.createRange();
	          rng.setStart(point.offsetNode, point.offset);
	          rng.collapse(true);
	        }
	      } else if (doc.caretRangeFromPoint) {
	        rng = doc.caretRangeFromPoint(clientX, clientY);
	      } else if (pointDoc.body.createTextRange) {
	        rng = pointDoc.body.createTextRange();
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	        } catch (ex) {
	          rng = findClosestIeRange(clientX, clientY, doc);
	        }
	        return moveOutOfContentEditableFalse(rng, doc.body);
	      }
	      return rng;
	    };
	
	    var isEq$1 = function (rng1, rng2) {
	      return rng1 && rng2 && (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) && (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
	    };
	
	    var findParent$1 = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	        node = node.parentNode;
	      }
	      return null;
	    };
	    var hasParent = function (node, rootNode, predicate) {
	      return findParent$1(node, rootNode, predicate) !== null;
	    };
	    var hasParentWithName = function (node, rootNode, name) {
	      return hasParent(node, rootNode, function (node) {
	        return node.nodeName === name;
	      });
	    };
	    var isTable$3 = function (node) {
	      return node && node.nodeName === 'TABLE';
	    };
	    var isTableCell$3 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var isCeFalseCaretContainer = function (node, rootNode) {
	      return isCaretContainer(node) && hasParent(node, rootNode, isCaretNode) === false;
	    };
	    var hasBrBeforeAfter = function (dom, node, left) {
	      var walker = new DomTreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (isBr(node)) {
	          return true;
	        }
	      }
	    };
	    var isPrevNode = function (node, name) {
	      return node.previousSibling && node.previousSibling.nodeName === name;
	    };
	    var hasContentEditableFalseParent = function (body, node) {
	      while (node && node !== body) {
	        if (isContentEditableFalse(node)) {
	          return true;
	        }
	        node = node.parentNode;
	      }
	      return false;
	    };
	    var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
	      var lastInlineElement;
	      var body = dom.getRoot();
	      var node;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      var parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
	      if (left && isBr(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
	        return Optional.some(CaretPosition(startNode.parentNode, dom.nodeIndex(startNode)));
	      }
	      var walker = new DomTreeWalker(startNode, parentBlockContainer);
	      while (node = walker[left ? 'prev' : 'next']()) {
	        if (dom.getContentEditableParent(node) === 'false' || isCeFalseCaretContainer(node, body)) {
	          return Optional.none();
	        }
	        if (isText$1(node) && node.nodeValue.length > 0) {
	          if (hasParentWithName(node, body, 'A') === false) {
	            return Optional.some(CaretPosition(node, left ? node.nodeValue.length : 0));
	          }
	          return Optional.none();
	        }
	        if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          return Optional.none();
	        }
	        lastInlineElement = node;
	      }
	      if (collapsed && lastInlineElement) {
	        return Optional.some(CaretPosition(lastInlineElement, 0));
	      }
	      return Optional.none();
	    };
	    var normalizeEndPoint = function (dom, collapsed, start, rng) {
	      var container, offset;
	      var body = dom.getRoot();
	      var node;
	      var directionLeft, normalized = false;
	      container = rng[(start ? 'start' : 'end') + 'Container'];
	      offset = rng[(start ? 'start' : 'end') + 'Offset'];
	      var isAfterNode = isElement$1(container) && offset === container.childNodes.length;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      directionLeft = start;
	      if (isCaretContainer(container)) {
	        return Optional.none();
	      }
	      if (isElement$1(container) && offset > container.childNodes.length - 1) {
	        directionLeft = false;
	      }
	      if (isDocument$1(container)) {
	        container = body;
	        offset = 0;
	      }
	      if (container === body) {
	        if (directionLeft) {
	          node = container.childNodes[offset > 0 ? offset - 1 : 0];
	          if (node) {
	            if (isCaretContainer(node)) {
	              return Optional.none();
	            }
	            if (nonEmptyElementsMap[node.nodeName] || isTable$3(node)) {
	              return Optional.none();
	            }
	          }
	        }
	        if (container.hasChildNodes()) {
	          offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
	          container = container.childNodes[offset];
	          offset = isText$1(container) && isAfterNode ? container.data.length : 0;
	          if (!collapsed && container === body.lastChild && isTable$3(container)) {
	            return Optional.none();
	          }
	          if (hasContentEditableFalseParent(body, container) || isCaretContainer(container)) {
	            return Optional.none();
	          }
	          if (container.hasChildNodes() && isTable$3(container) === false) {
	            node = container;
	            var walker = new DomTreeWalker(container, body);
	            do {
	              if (isContentEditableFalse(node) || isCaretContainer(node)) {
	                normalized = false;
	                break;
	              }
	              if (isText$1(node) && node.nodeValue.length > 0) {
	                offset = directionLeft ? 0 : node.nodeValue.length;
	                container = node;
	                normalized = true;
	                break;
	              }
	              if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell$3(node)) {
	                offset = dom.nodeIndex(node);
	                container = node.parentNode;
	                if (!directionLeft) {
	                  offset++;
	                }
	                normalized = true;
	                break;
	              }
	            } while (node = directionLeft ? walker.next() : walker.prev());
	          }
	        }
	      }
	      if (collapsed) {
	        if (isText$1(container) && offset === 0) {
	          findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
	            container = pos.container();
	            offset = pos.offset();
	            normalized = true;
	          });
	        }
	        if (isElement$1(container)) {
	          node = container.childNodes[offset];
	          if (!node) {
	            node = container.childNodes[offset - 1];
	          }
	          if (node && isBr(node) && !isPrevNode(node, 'A') && !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
	            findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
	              container = pos.container();
	              offset = pos.offset();
	              normalized = true;
	            });
	          }
	        }
	      }
	      if (directionLeft && !collapsed && isText$1(container) && offset === container.nodeValue.length) {
	        findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
	          container = pos.container();
	          offset = pos.offset();
	          normalized = true;
	        });
	      }
	      return normalized ? Optional.some(CaretPosition(container, offset)) : Optional.none();
	    };
	    var normalize = function (dom, rng) {
	      var collapsed = rng.collapsed, normRng = rng.cloneRange();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
	        if (!collapsed || !CaretPosition.isAbove(startPos, pos)) {
	          normRng.setStart(pos.container(), pos.offset());
	        }
	      });
	      if (!collapsed) {
	        normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
	          normRng.setEnd(pos.container(), pos.offset());
	        });
	      }
	      if (collapsed) {
	        normRng.collapse(true);
	      }
	      return isEq$1(rng, normRng) ? Optional.none() : Optional.some(normRng);
	    };
	
	    var splitText = function (node, offset) {
	      return node.splitText(offset);
	    };
	    var split$1 = function (rng) {
	      var startContainer = rng.startContainer, startOffset = rng.startOffset, endContainer = rng.endContainer, endOffset = rng.endOffset;
	      if (startContainer === endContainer && isText$1(startContainer)) {
	        if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          endContainer = splitText(startContainer, startOffset);
	          startContainer = endContainer.previousSibling;
	          if (endOffset > startOffset) {
	            endOffset = endOffset - startOffset;
	            startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
	            endOffset = endContainer.nodeValue.length;
	            startOffset = 0;
	          } else {
	            endOffset = 0;
	          }
	        }
	      } else {
	        if (isText$1(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          startContainer = splitText(startContainer, startOffset);
	          startOffset = 0;
	        }
	        if (isText$1(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
	          endContainer = splitText(endContainer, endOffset).previousSibling;
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	
	    var RangeUtils = function (dom) {
	      var walk = function (rng, callback) {
	        return walk$1(dom, rng, callback);
	      };
	      var split = split$1;
	      var normalize$1 = function (rng) {
	        return normalize(dom, rng).fold(never, function (normalizedRng) {
	          rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
	          rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
	          return true;
	        });
	      };
	      return {
	        walk: walk,
	        split: split,
	        normalize: normalize$1
	      };
	    };
	    RangeUtils.compareRanges = isEq$1;
	    RangeUtils.getCaretRangeFromPoint = fromPoint$1;
	    RangeUtils.getSelectedNode = getSelectedNode;
	    RangeUtils.getNode = getNode;
	
	    var Dimension = function (name, getOffset) {
	      var set = function (element, h) {
	        if (!isNumber(h) && !h.match(/^[0-9]+$/)) {
	          throw new Error(name + '.set accepts only positive integer values. Value was ' + h);
	        }
	        var dom = element.dom;
	        if (isSupported$1(dom)) {
	          dom.style[name] = h + 'px';
	        }
	      };
	      var get = function (element) {
	        var r = getOffset(element);
	        if (r <= 0 || r === null) {
	          var css = get$5(element, name);
	          return parseFloat(css) || 0;
	        }
	        return r;
	      };
	      var getOuter = get;
	      var aggregate = function (element, properties) {
	        return foldl(properties, function (acc, property) {
	          var val = get$5(element, property);
	          var value = val === undefined ? 0 : parseInt(val, 10);
	          return isNaN(value) ? acc : acc + value;
	        }, 0);
	      };
	      var max = function (element, value, properties) {
	        var cumulativeInclusions = aggregate(element, properties);
	        var absoluteMax = value > cumulativeInclusions ? value - cumulativeInclusions : 0;
	        return absoluteMax;
	      };
	      return {
	        set: set,
	        get: get,
	        getOuter: getOuter,
	        aggregate: aggregate,
	        max: max
	      };
	    };
	
	    var api$1 = Dimension('height', function (element) {
	      var dom = element.dom;
	      return inBody(element) ? dom.getBoundingClientRect().height : dom.offsetHeight;
	    });
	    var get$9 = function (element) {
	      return api$1.get(element);
	    };
	
	    var walkUp = function (navigation, doc) {
	      var frame = navigation.view(doc);
	      return frame.fold(constant([]), function (f) {
	        var parent = navigation.owner(f);
	        var rest = walkUp(navigation, parent);
	        return [f].concat(rest);
	      });
	    };
	    var pathTo = function (element, navigation) {
	      var d = navigation.owner(element);
	      return walkUp(navigation, d);
	    };
	
	    var view = function (doc) {
	      var _a;
	      var element = doc.dom === document ? Optional.none() : Optional.from((_a = doc.dom.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement);
	      return element.map(SugarElement.fromDom);
	    };
	    var owner$1 = function (element) {
	      return documentOrOwner(element);
	    };
	
	    var Navigation = /*#__PURE__*/Object.freeze({
	        __proto__: null,
	        view: view,
	        owner: owner$1
	    });
	
	    var find$2 = function (element) {
	      var doc = SugarElement.fromDom(document);
	      var scroll = get$2(doc);
	      var frames = pathTo(element, Navigation);
	      var offset = viewport(element);
	      var r = foldr(frames, function (b, a) {
	        var loc = viewport(a);
	        return {
	          left: b.left + loc.left,
	          top: b.top + loc.top
	        };
	      }, {
	        left: 0,
	        top: 0
	      });
	      return SugarPosition(r.left + offset.left + scroll.left, r.top + offset.top + scroll.top);
	    };
	
	    var excludeFromDescend = function (element) {
	      return name(element) === 'textarea';
	    };
	    var fireScrollIntoViewEvent = function (editor, data) {
	      var scrollEvent = editor.fire('ScrollIntoView', data);
	      return scrollEvent.isDefaultPrevented();
	    };
	    var fireAfterScrollIntoViewEvent = function (editor, data) {
	      editor.fire('AfterScrollIntoView', data);
	    };
	    var descend = function (element, offset) {
	      var children$1 = children(element);
	      if (children$1.length === 0 || excludeFromDescend(element)) {
	        return {
	          element: element,
	          offset: offset
	        };
	      } else if (offset < children$1.length && !excludeFromDescend(children$1[offset])) {
	        return {
	          element: children$1[offset],
	          offset: 0
	        };
	      } else {
	        var last = children$1[children$1.length - 1];
	        if (excludeFromDescend(last)) {
	          return {
	            element: element,
	            offset: offset
	          };
	        } else {
	          if (name(last) === 'img') {
	            return {
	              element: last,
	              offset: 1
	            };
	          } else if (isText(last)) {
	            return {
	              element: last,
	              offset: get$8(last).length
	            };
	          } else {
	            return {
	              element: last,
	              offset: children(last).length
	            };
	          }
	        }
	      }
	    };
	    var markerInfo = function (element, cleanupFun) {
	      var pos = absolute(element);
	      var height = get$9(element);
	      return {
	        element: element,
	        bottom: pos.top + height,
	        height: height,
	        pos: pos,
	        cleanup: cleanupFun
	      };
	    };
	    var createMarker = function (element, offset) {
	      var startPoint = descend(element, offset);
	      var span = SugarElement.fromHtml('<span data-mce-bogus="all">' + ZWSP + '</span>');
	      before(startPoint.element, span);
	      return markerInfo(span, function () {
	        return remove(span);
	      });
	    };
	    var elementMarker = function (element) {
	      return markerInfo(SugarElement.fromDom(element), noop);
	    };
	    var withMarker = function (editor, f, rng, alignToTop) {
	      preserveWith(editor, function (_s, _e) {
	        return applyWithMarker(editor, f, rng, alignToTop);
	      }, rng);
	    };
	    var withScrollEvents = function (editor, doc, f, marker, alignToTop) {
	      var data = {
	        elm: marker.element.dom,
	        alignToTop: alignToTop
	      };
	      if (fireScrollIntoViewEvent(editor, data)) {
	        return;
	      }
	      var scrollTop = get$2(doc).top;
	      f(doc, scrollTop, marker, alignToTop);
	      fireAfterScrollIntoViewEvent(editor, data);
	    };
	    var applyWithMarker = function (editor, f, rng, alignToTop) {
	      var body = SugarElement.fromDom(editor.getBody());
	      var doc = SugarElement.fromDom(editor.getDoc());
	      reflow(body);
	      var marker = createMarker(SugarElement.fromDom(rng.startContainer), rng.startOffset);
	      withScrollEvents(editor, doc, f, marker, alignToTop);
	      marker.cleanup();
	    };
	    var withElement = function (editor, element, f, alignToTop) {
	      var doc = SugarElement.fromDom(editor.getDoc());
	      withScrollEvents(editor, doc, f, elementMarker(element), alignToTop);
	    };
	    var preserveWith = function (editor, f, rng) {
	      var startElement = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endElement = rng.endContainer;
	      var endOffset = rng.endOffset;
	      f(SugarElement.fromDom(startElement), SugarElement.fromDom(endElement));
	      var newRng = editor.dom.createRng();
	      newRng.setStart(startElement, startOffset);
	      newRng.setEnd(endElement, endOffset);
	      editor.selection.setRng(rng);
	    };
	    var scrollToMarker = function (marker, viewHeight, alignToTop, doc) {
	      var pos = marker.pos;
	      if (alignToTop) {
	        to(pos.left, pos.top, doc);
	      } else {
	        var y = pos.top - viewHeight + marker.height;
	        to(pos.left, y, doc);
	      }
	    };
	    var intoWindowIfNeeded = function (doc, scrollTop, viewHeight, marker, alignToTop) {
	      var viewportBottom = viewHeight + scrollTop;
	      var markerTop = marker.pos.top;
	      var markerBottom = marker.bottom;
	      var largerThanViewport = markerBottom - markerTop >= viewHeight;
	      if (markerTop < scrollTop) {
	        scrollToMarker(marker, viewHeight, alignToTop !== false, doc);
	      } else if (markerTop > viewportBottom) {
	        var align = largerThanViewport ? alignToTop !== false : alignToTop === true;
	        scrollToMarker(marker, viewHeight, align, doc);
	      } else if (markerBottom > viewportBottom && !largerThanViewport) {
	        scrollToMarker(marker, viewHeight, alignToTop === true, doc);
	      }
	    };
	    var intoWindow = function (doc, scrollTop, marker, alignToTop) {
	      var viewHeight = doc.dom.defaultView.innerHeight;
	      intoWindowIfNeeded(doc, scrollTop, viewHeight, marker, alignToTop);
	    };
	    var intoFrame = function (doc, scrollTop, marker, alignToTop) {
	      var frameViewHeight = doc.dom.defaultView.innerHeight;
	      intoWindowIfNeeded(doc, scrollTop, frameViewHeight, marker, alignToTop);
	      var op = find$2(marker.element);
	      var viewportBounds = getBounds(window);
	      if (op.top < viewportBounds.y) {
	        intoView(marker.element, alignToTop !== false);
	      } else if (op.top > viewportBounds.bottom) {
	        intoView(marker.element, alignToTop === true);
	      }
	    };
	    var rangeIntoWindow = function (editor, rng, alignToTop) {
	      return withMarker(editor, intoWindow, rng, alignToTop);
	    };
	    var elementIntoWindow = function (editor, element, alignToTop) {
	      return withElement(editor, element, intoWindow, alignToTop);
	    };
	    var rangeIntoFrame = function (editor, rng, alignToTop) {
	      return withMarker(editor, intoFrame, rng, alignToTop);
	    };
	    var elementIntoFrame = function (editor, element, alignToTop) {
	      return withElement(editor, element, intoFrame, alignToTop);
	    };
	    var scrollElementIntoView = function (editor, element, alignToTop) {
	      var scroller = editor.inline ? elementIntoWindow : elementIntoFrame;
	      scroller(editor, element, alignToTop);
	    };
	    var scrollRangeIntoView = function (editor, rng, alignToTop) {
	      var scroller = editor.inline ? rangeIntoWindow : rangeIntoFrame;
	      scroller(editor, rng, alignToTop);
	    };
	
	    var getDocument = function () {
	      return SugarElement.fromDom(document);
	    };
	
	    var focus = function (element) {
	      return element.dom.focus();
	    };
	    var hasFocus = function (element) {
	      var root = getRootNode(element).dom;
	      return element.dom === root.activeElement;
	    };
	    var active = function (root) {
	      if (root === void 0) {
	        root = getDocument();
	      }
	      return Optional.from(root.dom.activeElement).map(SugarElement.fromDom);
	    };
	    var search = function (element) {
	      return active(getRootNode(element)).filter(function (e) {
	        return element.dom.contains(e.dom);
	      });
	    };
	
	    var create$4 = function (start, soffset, finish, foffset) {
	      return {
	        start: start,
	        soffset: soffset,
	        finish: finish,
	        foffset: foffset
	      };
	    };
	    var SimRange = { create: create$4 };
	
	    var adt = Adt.generate([
	      { before: ['element'] },
	      {
	        on: [
	          'element',
	          'offset'
	        ]
	      },
	      { after: ['element'] }
	    ]);
	    var cata = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	    var getStart = function (situ) {
	      return situ.fold(identity, identity, identity);
	    };
	    var before$3 = adt.before;
	    var on = adt.on;
	    var after$2 = adt.after;
	    var Situ = {
	      before: before$3,
	      on: on,
	      after: after$2,
	      cata: cata,
	      getStart: getStart
	    };
	
	    var adt$1 = Adt.generate([
	      { domRange: ['rng'] },
	      {
	        relative: [
	          'startSitu',
	          'finishSitu'
	        ]
	      },
	      {
	        exact: [
	          'start',
	          'soffset',
	          'finish',
	          'foffset'
	        ]
	      }
	    ]);
	    var exactFromRange = function (simRange) {
	      return adt$1.exact(simRange.start, simRange.soffset, simRange.finish, simRange.foffset);
	    };
	    var getStart$1 = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return SugarElement.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, _finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, _soffset, _finish, _foffset) {
	          return start;
	        }
	      });
	    };
	    var domRange = adt$1.domRange;
	    var relative = adt$1.relative;
	    var exact = adt$1.exact;
	    var getWin = function (selection) {
	      var start = getStart$1(selection);
	      return defaultView(start);
	    };
	    var range = SimRange.create;
	    var SimSelection = {
	      domRange: domRange,
	      relative: relative,
	      exact: exact,
	      exactFromRange: exactFromRange,
	      getWin: getWin,
	      range: range
	    };
	
	    var browser$3 = detect$3().browser;
	    var clamp = function (offset, element) {
	      var max = isText(element) ? get$8(element).length : children(element).length + 1;
	      if (offset > max) {
	        return max;
	      } else if (offset < 0) {
	        return 0;
	      }
	      return offset;
	    };
	    var normalizeRng = function (rng) {
	      return SimSelection.range(rng.start, clamp(rng.soffset, rng.start), rng.finish, clamp(rng.foffset, rng.finish));
	    };
	    var isOrContains = function (root, elm) {
	      return !isRestrictedNode(elm.dom) && (contains$2(root, elm) || eq$2(root, elm));
	    };
	    var isRngInRoot = function (root) {
	      return function (rng) {
	        return isOrContains(root, rng.start) && isOrContains(root, rng.finish);
	      };
	    };
	    var shouldStore = function (editor) {
	      return editor.inline === true || browser$3.isIE();
	    };
	    var nativeRangeToSelectionRange = function (r) {
	      return SimSelection.range(SugarElement.fromDom(r.startContainer), r.startOffset, SugarElement.fromDom(r.endContainer), r.endOffset);
	    };
	    var readRange = function (win) {
	      var selection = win.getSelection();
	      var rng = !selection || selection.rangeCount === 0 ? Optional.none() : Optional.from(selection.getRangeAt(0));
	      return rng.map(nativeRangeToSelectionRange);
	    };
	    var getBookmark$2 = function (root) {
	      var win = defaultView(root);
	      return readRange(win.dom).filter(isRngInRoot(root));
	    };
	    var validate = function (root, bookmark) {
	      return Optional.from(bookmark).filter(isRngInRoot(root)).map(normalizeRng);
	    };
	    var bookmarkToNativeRng = function (bookmark) {
	      var rng = document.createRange();
	      try {
	        rng.setStart(bookmark.start.dom, bookmark.soffset);
	        rng.setEnd(bookmark.finish.dom, bookmark.foffset);
	        return Optional.some(rng);
	      } catch (_) {
	        return Optional.none();
	      }
	    };
	    var store = function (editor) {
	      var newBookmark = shouldStore(editor) ? getBookmark$2(SugarElement.fromDom(editor.getBody())) : Optional.none();
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var storeNative = function (editor, rng) {
	      var root = SugarElement.fromDom(editor.getBody());
	      var range = shouldStore(editor) ? Optional.from(rng) : Optional.none();
	      var newBookmark = range.map(nativeRangeToSelectionRange).filter(isRngInRoot(root));
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	    var getRng = function (editor) {
	      var bookmark = editor.bookmark ? editor.bookmark : Optional.none();
	      return bookmark.bind(function (x) {
	        return validate(SugarElement.fromDom(editor.getBody()), x);
	      }).bind(bookmarkToNativeRng);
	    };
	    var restore = function (editor) {
	      getRng(editor).each(function (rng) {
	        return editor.selection.setRng(rng);
	      });
	    };
	
	    var isEditorUIElement = function (elm) {
	      var className = elm.className.toString();
	      return className.indexOf('tox-') !== -1 || className.indexOf('mce-') !== -1;
	    };
	    var FocusManager = { isEditorUIElement: isEditorUIElement };
	
	    var isManualNodeChange = function (e) {
	      return e.type === 'nodechange' && e.selectionChange;
	    };
	    var registerPageMouseUp = function (editor, throttledStore) {
	      var mouseUpPage = function () {
	        throttledStore.throttle();
	      };
	      DOMUtils.DOM.bind(document, 'mouseup', mouseUpPage);
	      editor.on('remove', function () {
	        DOMUtils.DOM.unbind(document, 'mouseup', mouseUpPage);
	      });
	    };
	    var registerFocusOut = function (editor) {
	      editor.on('focusout', function () {
	        store(editor);
	      });
	    };
	    var registerMouseUp = function (editor, throttledStore) {
	      editor.on('mouseup touchend', function (_e) {
	        throttledStore.throttle();
	      });
	    };
	    var registerEditorEvents = function (editor, throttledStore) {
	      var browser = detect$3().browser;
	      if (browser.isIE()) {
	        registerFocusOut(editor);
	      } else {
	        registerMouseUp(editor, throttledStore);
	      }
	      editor.on('keyup NodeChange', function (e) {
	        if (!isManualNodeChange(e)) {
	          store(editor);
	        }
	      });
	    };
	    var register = function (editor) {
	      var throttledStore = first(function () {
	        store(editor);
	      }, 0);
	      editor.on('init', function () {
	        if (editor.inline) {
	          registerPageMouseUp(editor, throttledStore);
	        }
	        registerEditorEvents(editor, throttledStore);
	      });
	      editor.on('remove', function () {
	        throttledStore.cancel();
	      });
	    };
	
	    var documentFocusInHandler;
	    var DOM$2 = DOMUtils.DOM;
	    var isEditorUIElement$1 = function (elm) {
	      return FocusManager.isEditorUIElement(elm);
	    };
	    var isEditorContentAreaElement = function (elm) {
	      var classList = elm.classList;
	      if (classList !== undefined) {
	        return classList.contains('tox-edit-area') || classList.contains('tox-edit-area__iframe') || classList.contains('mce-content-body');
	      } else {
	        return false;
	      }
	    };
	    var isUIElement = function (editor, elm) {
	      var customSelector = getCustomUiSelector(editor);
	      var parent = DOM$2.getParent(elm, function (elm) {
	        return isEditorUIElement$1(elm) || (customSelector ? editor.dom.is(elm, customSelector) : false);
	      });
	      return parent !== null;
	    };
	    var getActiveElement = function (editor) {
	      try {
	        var root = getRootNode(SugarElement.fromDom(editor.getElement()));
	        return active(root).fold(function () {
	          return document.body;
	        }, function (x) {
	          return x.dom;
	        });
	      } catch (ex) {
	        return document.body;
	      }
	    };
	    var registerEvents = function (editorManager, e) {
	      var editor = e.editor;
	      register(editor);
	      editor.on('focusin', function () {
	        var focusedEditor = editorManager.focusedEditor;
	        if (focusedEditor !== editor) {
	          if (focusedEditor) {
	            focusedEditor.fire('blur', { focusedEditor: editor });
	          }
	          editorManager.setActive(editor);
	          editorManager.focusedEditor = editor;
	          editor.fire('focus', { blurredEditor: focusedEditor });
	          editor.focus(true);
	        }
	      });
	      editor.on('focusout', function () {
	        Delay.setEditorTimeout(editor, function () {
	          var focusedEditor = editorManager.focusedEditor;
	          if (!isUIElement(editor, getActiveElement(editor)) && focusedEditor === editor) {
	            editor.fire('blur', { focusedEditor: null });
	            editorManager.focusedEditor = null;
	          }
	        });
	      });
	      if (!documentFocusInHandler) {
	        documentFocusInHandler = function (e) {
	          var activeEditor = editorManager.activeEditor;
	          if (activeEditor) {
	            getOriginalEventTarget(e).each(function (target) {
	              if (target.ownerDocument === document) {
	                if (target !== document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
	                  activeEditor.fire('blur', { focusedEditor: null });
	                  editorManager.focusedEditor = null;
	                }
	              }
	            });
	          }
	        };
	        DOM$2.bind(document, 'focusin', documentFocusInHandler);
	      }
	    };
	    var unregisterDocumentEvents = function (editorManager, e) {
	      if (editorManager.focusedEditor === e.editor) {
	        editorManager.focusedEditor = null;
	      }
	      if (!editorManager.activeEditor) {
	        DOM$2.unbind(document, 'focusin', documentFocusInHandler);
	        documentFocusInHandler = null;
	      }
	    };
	    var setup$2 = function (editorManager) {
	      editorManager.on('AddEditor', curry(registerEvents, editorManager));
	      editorManager.on('RemoveEditor', curry(unregisterDocumentEvents, editorManager));
	    };
	
	    var getContentEditableHost = function (editor, node) {
	      return editor.dom.getParent(node, function (node) {
	        return editor.dom.getContentEditable(node) === 'true';
	      });
	    };
	    var getCollapsedNode = function (rng) {
	      return rng.collapsed ? Optional.from(getNode(rng.startContainer, rng.startOffset)).map(SugarElement.fromDom) : Optional.none();
	    };
	    var getFocusInElement = function (root, rng) {
	      return getCollapsedNode(rng).bind(function (node) {
	        if (isTableSection(node)) {
	          return Optional.some(node);
	        } else if (contains$2(root, node) === false) {
	          return Optional.some(root);
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var normalizeSelection = function (editor, rng) {
	      getFocusInElement(SugarElement.fromDom(editor.getBody()), rng).bind(function (elm) {
	        return firstPositionIn(elm.dom);
	      }).fold(function () {
	        editor.selection.normalize();
	        return;
	      }, function (caretPos) {
	        return editor.selection.setRng(caretPos.toRange());
	      });
	    };
	    var focusBody = function (body) {
	      if (body.setActive) {
	        try {
	          body.setActive();
	        } catch (ex) {
	          body.focus();
	        }
	      } else {
	        body.focus();
	      }
	    };
	    var hasElementFocus = function (elm) {
	      return hasFocus(elm) || search(elm).isSome();
	    };
	    var hasIframeFocus = function (editor) {
	      return editor.iframeElement && hasFocus(SugarElement.fromDom(editor.iframeElement));
	    };
	    var hasInlineFocus = function (editor) {
	      var rawBody = editor.getBody();
	      return rawBody && hasElementFocus(SugarElement.fromDom(rawBody));
	    };
	    var hasUiFocus = function (editor) {
	      var dos = getRootNode(SugarElement.fromDom(editor.getElement()));
	      return active(dos).filter(function (elem) {
	        return !isEditorContentAreaElement(elem.dom) && isUIElement(editor, elem.dom);
	      }).isSome();
	    };
	    var hasFocus$1 = function (editor) {
	      return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
	    };
	    var hasEditorOrUiFocus = function (editor) {
	      return hasFocus$1(editor) || hasUiFocus(editor);
	    };
	    var focusEditor = function (editor) {
	      var selection = editor.selection;
	      var body = editor.getBody();
	      var rng = selection.getRng();
	      editor.quirks.refreshContentEditable();
	      if (editor.bookmark !== undefined && hasFocus$1(editor) === false) {
	        getRng(editor).each(function (bookmarkRng) {
	          editor.selection.setRng(bookmarkRng);
	          rng = bookmarkRng;
	        });
	      }
	      var contentEditableHost = getContentEditableHost(editor, selection.getNode());
	      if (editor.$.contains(body, contentEditableHost)) {
	        focusBody(contentEditableHost);
	        normalizeSelection(editor, rng);
	        activateEditor(editor);
	        return;
	      }
	      if (!editor.inline) {
	        if (!Env.opera) {
	          focusBody(body);
	        }
	        editor.getWin().focus();
	      }
	      if (Env.gecko || editor.inline) {
	        focusBody(body);
	        normalizeSelection(editor, rng);
	      }
	      activateEditor(editor);
	    };
	    var activateEditor = function (editor) {
	      return editor.editorManager.setActive(editor);
	    };
	    var focus$1 = function (editor, skipFocus) {
	      if (editor.removed) {
	        return;
	      }
	      skipFocus ? activateEditor(editor) : focusEditor(editor);
	    };
	
	    var getEndpointElement = function (root, rng, start, real, resolve) {
	      var container = start ? rng.startContainer : rng.endContainer;
	      var offset = start ? rng.startOffset : rng.endOffset;
	      return Optional.from(container).map(SugarElement.fromDom).map(function (elm) {
	        return !real || !rng.collapsed ? child(elm, resolve(elm, offset)).getOr(elm) : elm;
	      }).bind(function (elm) {
	        return isElement(elm) ? Optional.some(elm) : parent(elm).filter(isElement);
	      }).map(function (elm) {
	        return elm.dom;
	      }).getOr(root);
	    };
	    var getStart$2 = function (root, rng, real) {
	      return getEndpointElement(root, rng, true, real, function (elm, offset) {
	        return Math.min(childNodesCount(elm), offset);
	      });
	    };
	    var getEnd = function (root, rng, real) {
	      return getEndpointElement(root, rng, false, real, function (elm, offset) {
	        return offset > 0 ? offset - 1 : offset;
	      });
	    };
	    var skipEmptyTextNodes = function (node, forwards) {
	      var orig = node;
	      while (node && isText$1(node) && node.length === 0) {
	        node = forwards ? node.nextSibling : node.previousSibling;
	      }
	      return node || orig;
	    };
	    var getNode$1 = function (root, rng) {
	      var elm, startContainer, endContainer;
	      if (!rng) {
	        return root;
	      }
	      startContainer = rng.startContainer;
	      endContainer = rng.endContainer;
	      var startOffset = rng.startOffset;
	      var endOffset = rng.endOffset;
	      elm = rng.commonAncestorContainer;
	      if (!rng.collapsed) {
	        if (startContainer === endContainer) {
	          if (endOffset - startOffset < 2) {
	            if (startContainer.hasChildNodes()) {
	              elm = startContainer.childNodes[startOffset];
	            }
	          }
	        }
	        if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
	          if (startContainer.length === startOffset) {
	            startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
	          } else {
	            startContainer = startContainer.parentNode;
	          }
	          if (endOffset === 0) {
	            endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
	          } else {
	            endContainer = endContainer.parentNode;
	          }
	          if (startContainer && startContainer === endContainer) {
	            return startContainer;
	          }
	        }
	      }
	      if (elm && elm.nodeType === 3) {
	        return elm.parentNode;
	      }
	      return elm;
	    };
	    var getSelectedBlocks = function (dom, rng, startElm, endElm) {
	      var node;
	      var selectedBlocks = [];
	      var root = dom.getRoot();
	      startElm = dom.getParent(startElm || getStart$2(root, rng, rng.collapsed), dom.isBlock);
	      endElm = dom.getParent(endElm || getEnd(root, rng, rng.collapsed), dom.isBlock);
	      if (startElm && startElm !== root) {
	        selectedBlocks.push(startElm);
	      }
	      if (startElm && endElm && startElm !== endElm) {
	        node = startElm;
	        var walker = new DomTreeWalker(startElm, root);
	        while ((node = walker.next()) && node !== endElm) {
	          if (dom.isBlock(node)) {
	            selectedBlocks.push(node);
	          }
	        }
	      }
	      if (endElm && startElm !== endElm && endElm !== root) {
	        selectedBlocks.push(endElm);
	      }
	      return selectedBlocks;
	    };
	    var select$1 = function (dom, node, content) {
	      return Optional.from(node).map(function (node) {
	        var idx = dom.nodeIndex(node);
	        var rng = dom.createRng();
	        rng.setStart(node.parentNode, idx);
	        rng.setEnd(node.parentNode, idx + 1);
	        if (content) {
	          moveEndPoint$1(dom, rng, node, true);
	          moveEndPoint$1(dom, rng, node, false);
	        }
	        return rng;
	      });
	    };
	
	    var processRanges = function (editor, ranges) {
	      return map(ranges, function (range) {
	        var evt = editor.fire('GetSelectionRange', { range: range });
	        return evt.range !== range ? evt.range : range;
	      });
	    };
	
	    var typeLookup = {
	      '#text': 3,
	      '#comment': 8,
	      '#cdata': 4,
	      '#pi': 7,
	      '#doctype': 10,
	      '#document-fragment': 11
	    };
	    var walk$2 = function (node, root, prev) {
	      var startName = prev ? 'lastChild' : 'firstChild';
	      var siblingName = prev ? 'prev' : 'next';
	      if (node[startName]) {
	        return node[startName];
	      }
	      if (node !== root) {
	        var sibling = node[siblingName];
	        if (sibling) {
	          return sibling;
	        }
	        for (var parent_1 = node.parent; parent_1 && parent_1 !== root; parent_1 = parent_1.parent) {
	          sibling = parent_1[siblingName];
	          if (sibling) {
	            return sibling;
	          }
	        }
	      }
	    };
	    var isEmptyTextNode$1 = function (node) {
	      if (!isWhitespaceText(node.value)) {
	        return false;
	      }
	      var parentNode = node.parent;
	      if (parentNode && (parentNode.name !== 'span' || parentNode.attr('style')) && /^[ ]+$/.test(node.value)) {
	        return false;
	      }
	      return true;
	    };
	    var isNonEmptyElement = function (node) {
	      var isNamedAnchor = node.name === 'a' && !node.attr('href') && node.attr('id');
	      return node.attr('name') || node.attr('id') && !node.firstChild || node.attr('data-mce-bookmark') || isNamedAnchor;
	    };
	    var AstNode = function () {
	      function AstNode(name, type) {
	        this.name = name;
	        this.type = type;
	        if (type === 1) {
	          this.attributes = [];
	          this.attributes.map = {};
	        }
	      }
	      AstNode.create = function (name, attrs) {
	        var node = new AstNode(name, typeLookup[name] || 1);
	        if (attrs) {
	          each$1(attrs, function (value, attrName) {
	            node.attr(attrName, value);
	          });
	        }
	        return node;
	      };
	      AstNode.prototype.replace = function (node) {
	        var self = this;
	        if (node.parent) {
	          node.remove();
	        }
	        self.insert(node, self);
	        self.remove();
	        return self;
	      };
	      AstNode.prototype.attr = function (name, value) {
	        var self = this;
	        var attrs;
	        if (typeof name !== 'string') {
	          if (name !== undefined && name !== null) {
	            each$1(name, function (value, key) {
	              self.attr(key, value);
	            });
	          }
	          return self;
	        }
	        if (attrs = self.attributes) {
	          if (value !== undefined) {
	            if (value === null) {
	              if (name in attrs.map) {
	                delete attrs.map[name];
	                var i = attrs.length;
	                while (i--) {
	                  if (attrs[i].name === name) {
	                    attrs.splice(i, 1);
	                    return self;
	                  }
	                }
	              }
	              return self;
	            }
	            if (name in attrs.map) {
	              var i = attrs.length;
	              while (i--) {
	                if (attrs[i].name === name) {
	                  attrs[i].value = value;
	                  break;
	                }
	              }
	            } else {
	              attrs.push({
	                name: name,
	                value: value
	              });
	            }
	            attrs.map[name] = value;
	            return self;
	          }
	          return attrs.map[name];
	        }
	      };
	      AstNode.prototype.clone = function () {
	        var self = this;
	        var clone = new AstNode(self.name, self.type);
	        var selfAttrs;
	        if (selfAttrs = self.attributes) {
	          var cloneAttrs = [];
	          cloneAttrs.map = {};
	          for (var i = 0, l = selfAttrs.length; i < l; i++) {
	            var selfAttr = selfAttrs[i];
	            if (selfAttr.name !== 'id') {
	              cloneAttrs[cloneAttrs.length] = {
	                name: selfAttr.name,
	                value: selfAttr.value
	              };
	              cloneAttrs.map[selfAttr.name] = selfAttr.value;
	            }
	          }
	          clone.attributes = cloneAttrs;
	        }
	        clone.value = self.value;
	        clone.shortEnded = self.shortEnded;
	        return clone;
	      };
	      AstNode.prototype.wrap = function (wrapper) {
	        var self = this;
	        self.parent.insert(wrapper, self);
	        wrapper.append(self);
	        return self;
	      };
	      AstNode.prototype.unwrap = function () {
	        var self = this;
	        for (var node = self.firstChild; node;) {
	          var next = node.next;
	          self.insert(node, self, true);
	          node = next;
	        }
	        self.remove();
	      };
	      AstNode.prototype.remove = function () {
	        var self = this, parent = self.parent, next = self.next, prev = self.prev;
	        if (parent) {
	          if (parent.firstChild === self) {
	            parent.firstChild = next;
	            if (next) {
	              next.prev = null;
	            }
	          } else {
	            prev.next = next;
	          }
	          if (parent.lastChild === self) {
	            parent.lastChild = prev;
	            if (prev) {
	              prev.next = null;
	            }
	          } else {
	            next.prev = prev;
	          }
	          self.parent = self.next = self.prev = null;
	        }
	        return self;
	      };
	      AstNode.prototype.append = function (node) {
	        var self = this;
	        if (node.parent) {
	          node.remove();
	        }
	        var last = self.lastChild;
	        if (last) {
	          last.next = node;
	          node.prev = last;
	          self.lastChild = node;
	        } else {
	          self.lastChild = self.firstChild = node;
	        }
	        node.parent = self;
	        return node;
	      };
	      AstNode.prototype.insert = function (node, refNode, before) {
	        if (node.parent) {
	          node.remove();
	        }
	        var parent = refNode.parent || this;
	        if (before) {
	          if (refNode === parent.firstChild) {
	            parent.firstChild = node;
	          } else {
	            refNode.prev.next = node;
	          }
	          node.prev = refNode.prev;
	          node.next = refNode;
	          refNode.prev = node;
	        } else {
	          if (refNode === parent.lastChild) {
	            parent.lastChild = node;
	          } else {
	            refNode.next.prev = node;
	          }
	          node.next = refNode.next;
	          node.prev = refNode;
	          refNode.next = node;
	        }
	        node.parent = parent;
	        return node;
	      };
	      AstNode.prototype.getAll = function (name) {
	        var self = this;
	        var collection = [];
	        for (var node = self.firstChild; node; node = walk$2(node, self)) {
	          if (node.name === name) {
	            collection.push(node);
	          }
	        }
	        return collection;
	      };
	      AstNode.prototype.empty = function () {
	        var self = this;
	        if (self.firstChild) {
	          var nodes = [];
	          for (var node = self.firstChild; node; node = walk$2(node, self)) {
	            nodes.push(node);
	          }
	          var i = nodes.length;
	          while (i--) {
	            var node = nodes[i];
	            node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
	          }
	        }
	        self.firstChild = self.lastChild = null;
	        return self;
	      };
	      AstNode.prototype.isEmpty = function (elements, whitespace, predicate) {
	        if (whitespace === void 0) {
	          whitespace = {};
	        }
	        var self = this;
	        var node = self.firstChild;
	        if (isNonEmptyElement(self)) {
	          return false;
	        }
	        if (node) {
	          do {
	            if (node.type === 1) {
	              if (node.attr('data-mce-bogus')) {
	                continue;
	              }
	              if (elements[node.name]) {
	                return false;
	              }
	              if (isNonEmptyElement(node)) {
	                return false;
	              }
	            }
	            if (node.type === 8) {
	              return false;
	            }
	            if (node.type === 3 && !isEmptyTextNode$1(node)) {
	              return false;
	            }
	            if (node.type === 3 && node.parent && whitespace[node.parent.name] && isWhitespaceText(node.value)) {
	              return false;
	            }
	            if (predicate && predicate(node)) {
	              return false;
	            }
	          } while (node = walk$2(node, self));
	        }
	        return true;
	      };
	      AstNode.prototype.walk = function (prev) {
	        return walk$2(this, null, prev);
	      };
	      return AstNode;
	    }();
	
	    var extractBase64DataUris = function (html) {
	      var dataImageUri = /data:[^;]+;base64,([a-z0-9\+\/=]+)/gi;
	      var chunks = [];
	      var uris = {};
	      var prefix = generate$1('img');
	      var matches;
	      var index = 0;
	      var count = 0;
	      while (matches = dataImageUri.exec(html)) {
	        var uri = matches[0];
	        var imageId = prefix + '_' + count++;
	        uris[imageId] = uri;
	        if (index < matches.index) {
	          chunks.push(html.substr(index, matches.index - index));
	        }
	        chunks.push(imageId);
	        index = matches.index + uri.length;
	      }
	      var re = new RegExp(prefix + '_[0-9]+', 'g');
	      if (index === 0) {
	        return {
	          prefix: prefix,
	          uris: uris,
	          html: html,
	          re: re
	        };
	      } else {
	        if (index < html.length) {
	          chunks.push(html.substr(index));
	        }
	        return {
	          prefix: prefix,
	          uris: uris,
	          html: chunks.join(''),
	          re: re
	        };
	      }
	    };
	    var restoreDataUris = function (html, result) {
	      return html.replace(result.re, function (imageId) {
	        return get$1(result.uris, imageId).getOr(imageId);
	      });
	    };
	    var parseDataUri = function (uri) {
	      var matches = /data:([^;]+);base64,([a-z0-9\+\/=]+)/i.exec(uri);
	      if (matches) {
	        return Optional.some({
	          type: matches[1],
	          data: decodeURIComponent(matches[2])
	        });
	      } else {
	        return Optional.none();
	      }
	    };
	
	    var safeSvgDataUrlElements = [
	      'img',
	      'video'
	    ];
	    var isValidPrefixAttrName = function (name) {
	      return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
	    };
	    var blockSvgDataUris = function (allowSvgDataUrls, tagName) {
	      var allowed = isNullable(allowSvgDataUrls) ? contains(safeSvgDataUrlElements, tagName) : allowSvgDataUrls;
	      return !allowed;
	    };
	    var isInvalidUri = function (settings, uri, tagName) {
	      if (settings.allow_html_data_urls) {
	        return false;
	      } else if (/^data:image\//i.test(uri)) {
	        return blockSvgDataUris(settings.allow_svg_data_urls, tagName) && /^data:image\/svg\+xml/i.test(uri);
	      } else {
	        return /^data:/i.test(uri);
	      }
	    };
	    var findEndTagIndex = function (schema, html, startIndex) {
	      var count = 1, index, matches;
	      var shortEndedElements = schema.getShortEndedElements();
	      var tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_:.]+)(\s(?:[^'">]+(?:"[^"]*"|'[^']*'))*[^"'>]*(?:"[^">]*|'[^'>]*)?|\s*|\/)>/g;
	      tokenRegExp.lastIndex = index = startIndex;
	      while (matches = tokenRegExp.exec(html)) {
	        index = tokenRegExp.lastIndex;
	        if (matches[1] === '/') {
	          count--;
	        } else if (!matches[1]) {
	          if (matches[2] in shortEndedElements) {
	            continue;
	          }
	          count++;
	        }
	        if (count === 0) {
	          break;
	        }
	      }
	      return index;
	    };
	    var isConditionalComment = function (html, startIndex) {
	      return /^\s*\[if [\w\W]+\]>.*<!\[endif\](--!?)?>/.test(html.substr(startIndex));
	    };
	    var findCommentEndIndex = function (html, isBogus, startIndex) {
	      if (startIndex === void 0) {
	        startIndex = 0;
	      }
	      var lcHtml = html.toLowerCase();
	      if (lcHtml.indexOf('[if ', startIndex) !== -1 && isConditionalComment(lcHtml, startIndex)) {
	        var endIfIndex = lcHtml.indexOf('[endif]', startIndex);
	        return lcHtml.indexOf('>', endIfIndex);
	      } else {
	        if (isBogus) {
	          var endIndex = lcHtml.indexOf('>', startIndex);
	          return endIndex !== -1 ? endIndex : lcHtml.length;
	        } else {
	          var endCommentRegexp = /--!?>/g;
	          endCommentRegexp.lastIndex = startIndex;
	          var match = endCommentRegexp.exec(html);
	          return match ? match.index + match[0].length : lcHtml.length;
	        }
	      }
	    };
	    var checkBogusAttribute = function (regExp, attrString) {
	      var matches = regExp.exec(attrString);
	      if (matches) {
	        var name_1 = matches[1];
	        var value = matches[2];
	        return typeof name_1 === 'string' && name_1.toLowerCase() === 'data-mce-bogus' ? value : null;
	      } else {
	        return null;
	      }
	    };
	    var SaxParser = function (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      settings = settings || {};
	      if (settings.fix_self_closing !== false) {
	        settings.fix_self_closing = true;
	      }
	      var comment = settings.comment ? settings.comment : noop;
	      var cdata = settings.cdata ? settings.cdata : noop;
	      var text = settings.text ? settings.text : noop;
	      var start = settings.start ? settings.start : noop;
	      var end = settings.end ? settings.end : noop;
	      var pi = settings.pi ? settings.pi : noop;
	      var doctype = settings.doctype ? settings.doctype : noop;
	      var parseInternal = function (base64Extract, format) {
	        if (format === void 0) {
	          format = 'html';
	        }
	        var html = base64Extract.html;
	        var matches, index = 0, value, endRegExp;
	        var stack = [];
	        var attrList, i, textData, name;
	        var isInternalElement, isShortEnded;
	        var elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
	        var attributesRequired, attributesDefault, attributesForced;
	        var anyAttributesRequired, attrValue, idCount = 0;
	        var decode = Entities.decode;
	        var filteredUrlAttrs = Tools.makeMap('src,href,data,background,action,formaction,poster,xlink:href');
	        var scriptUriRegExp = /((java|vb)script|mhtml):/i;
	        var parsingMode = format === 'html' ? 0 : 1;
	        var processEndTag = function (name) {
	          var pos, i;
	          pos = stack.length;
	          while (pos--) {
	            if (stack[pos].name === name) {
	              break;
	            }
	          }
	          if (pos >= 0) {
	            for (i = stack.length - 1; i >= pos; i--) {
	              name = stack[i];
	              if (name.valid) {
	                end(name.name);
	              }
	            }
	            stack.length = pos;
	          }
	        };
	        var processText = function (value, raw) {
	          return text(restoreDataUris(value, base64Extract), raw);
	        };
	        var processComment = function (value) {
	          if (value === '') {
	            return;
	          }
	          if (value.charAt(0) === '>') {
	            value = ' ' + value;
	          }
	          if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
	            value = ' ' + value;
	          }
	          comment(restoreDataUris(value, base64Extract));
	        };
	        var processAttr = function (value) {
	          return restoreDataUris(value, base64Extract);
	        };
	        var processMalformedComment = function (value, startIndex) {
	          var startTag = value || '';
	          var isBogus = !startsWith(startTag, '--');
	          var endIndex = findCommentEndIndex(html, isBogus, startIndex);
	          value = html.substr(startIndex, endIndex - startIndex);
	          processComment(isBogus ? startTag + value : value);
	          return endIndex + 1;
	        };
	        var parseAttribute = function (tagName, name, value, val2, val3) {
	          var attrRule, i;
	          var trimRegExp = /[\s\u0000-\u001F]+/g;
	          name = name.toLowerCase();
	          value = processAttr(name in fillAttrsMap ? name : decode(value || val2 || val3 || ''));
	          if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
	            attrRule = validAttributesMap[name];
	            if (!attrRule && validAttributePatterns) {
	              i = validAttributePatterns.length;
	              while (i--) {
	                attrRule = validAttributePatterns[i];
	                if (attrRule.pattern.test(name)) {
	                  break;
	                }
	              }
	              if (i === -1) {
	                attrRule = null;
	              }
	            }
	            if (!attrRule) {
	              return;
	            }
	            if (attrRule.validValues && !(value in attrRule.validValues)) {
	              return;
	            }
	          }
	          if (filteredUrlAttrs[name] && !settings.allow_script_urls) {
	            var uri = value.replace(trimRegExp, '');
	            try {
	              uri = decodeURIComponent(uri);
	            } catch (ex) {
	              uri = unescape(uri);
	            }
	            if (scriptUriRegExp.test(uri)) {
	              return;
	            }
	            if (isInvalidUri(settings, uri, tagName)) {
	              return;
	            }
	          }
	          if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
	            return;
	          }
	          attrList.map[name] = value;
	          attrList.push({
	            name: name,
	            value: value
	          });
	        };
	        var tokenRegExp = new RegExp('<(?:' + '(?:!--([\\w\\W]*?)--!?>)|' + '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + '(?:![Dd][Oo][Cc][Tt][Yy][Pp][Ee]([\\w\\W]*?)>)|' + '(?:!(--)?)|' + '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + '(?:([A-Za-z][A-Za-z0-9\\-_:.]*)(\\s(?:[^\'">]+(?:"[^"]*"|\'[^\']*\'))*[^"\'>]*(?:"[^">]*|\'[^\'>]*)?|\\s*|\\/)>)' + ')', 'g');
	        var attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
	        var shortEndedElements = schema.getShortEndedElements();
	        var selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
	        var fillAttrsMap = schema.getBoolAttrs();
	        var validate = settings.validate;
	        var removeInternalElements = settings.remove_internals;
	        var fixSelfClosing = settings.fix_self_closing;
	        var specialElements = schema.getSpecialElements();
	        var processHtml = html + '>';
	        while (matches = tokenRegExp.exec(processHtml)) {
	          var matchText = matches[0];
	          if (index < matches.index) {
	            processText(decode(html.substr(index, matches.index - index)));
	          }
	          if (value = matches[7]) {
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            processEndTag(value);
	          } else if (value = matches[8]) {
	            if (matches.index + matchText.length > html.length) {
	              processText(decode(html.substr(matches.index)));
	              index = matches.index + matchText.length;
	              continue;
	            }
	            value = value.toLowerCase();
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	            isShortEnded = value in shortEndedElements;
	            if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
	              processEndTag(value);
	            }
	            var bogusValue = checkBogusAttribute(attrRegExp, matches[9]);
	            if (bogusValue !== null) {
	              if (bogusValue === 'all') {
	                index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                tokenRegExp.lastIndex = index;
	                continue;
	              }
	              isValidElement = false;
	            }
	            if (!validate || (elementRule = schema.getElementRule(value))) {
	              isValidElement = true;
	              if (validate) {
	                validAttributesMap = elementRule.attributes;
	                validAttributePatterns = elementRule.attributePatterns;
	              }
	              if (attribsValue = matches[9]) {
	                isInternalElement = attribsValue.indexOf('data-mce-type') !== -1;
	                if (isInternalElement && removeInternalElements) {
	                  isValidElement = false;
	                }
	                attrList = [];
	                attrList.map = {};
	                attribsValue.replace(attrRegExp, function (match, name, val, val2, val3) {
	                  parseAttribute(value, name, val, val2, val3);
	                  return '';
	                });
	              } else {
	                attrList = [];
	                attrList.map = {};
	              }
	              if (validate && !isInternalElement) {
	                attributesRequired = elementRule.attributesRequired;
	                attributesDefault = elementRule.attributesDefault;
	                attributesForced = elementRule.attributesForced;
	                anyAttributesRequired = elementRule.removeEmptyAttrs;
	                if (anyAttributesRequired && !attrList.length) {
	                  isValidElement = false;
	                }
	                if (attributesForced) {
	                  i = attributesForced.length;
	                  while (i--) {
	                    attr = attributesForced[i];
	                    name = attr.name;
	                    attrValue = attr.value;
	                    if (attrValue === '{$uid}') {
	                      attrValue = 'mce_' + idCount++;
	                    }
	                    attrList.map[name] = attrValue;
	                    attrList.push({
	                      name: name,
	                      value: attrValue
	                    });
	                  }
	                }
	                if (attributesDefault) {
	                  i = attributesDefault.length;
	                  while (i--) {
	                    attr = attributesDefault[i];
	                    name = attr.name;
	                    if (!(name in attrList.map)) {
	                      attrValue = attr.value;
	                      if (attrValue === '{$uid}') {
	                        attrValue = 'mce_' + idCount++;
	                      }
	                      attrList.map[name] = attrValue;
	                      attrList.push({
	                        name: name,
	                        value: attrValue
	                      });
	                    }
	                  }
	                }
	                if (attributesRequired) {
	                  i = attributesRequired.length;
	                  while (i--) {
	                    if (attributesRequired[i] in attrList.map) {
	                      break;
	                    }
	                  }
	                  if (i === -1) {
	                    isValidElement = false;
	                  }
	                }
	                if (attr = attrList.map['data-mce-bogus']) {
	                  if (attr === 'all') {
	                    index = findEndTagIndex(schema, html, tokenRegExp.lastIndex);
	                    tokenRegExp.lastIndex = index;
	                    continue;
	                  }
	                  isValidElement = false;
	                }
	              }
	              if (isValidElement) {
	                start(value, attrList, isShortEnded);
	              }
	            } else {
	              isValidElement = false;
	            }
	            if (endRegExp = specialElements[value]) {
	              endRegExp.lastIndex = index = matches.index + matchText.length;
	              if (matches = endRegExp.exec(html)) {
	                if (isValidElement) {
	                  textData = html.substr(index, matches.index - index);
	                }
	                index = matches.index + matches[0].length;
	              } else {
	                textData = html.substr(index);
	                index = html.length;
	              }
	              if (isValidElement) {
	                if (textData.length > 0) {
	                  processText(textData, true);
	                }
	                end(value);
	              }
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	            if (!isShortEnded) {
	              if (!attribsValue || attribsValue.indexOf('/') !== attribsValue.length - 1) {
	                stack.push({
	                  name: value,
	                  valid: isValidElement
	                });
	              } else if (isValidElement) {
	                end(value);
	              }
	            }
	          } else if (value = matches[1]) {
	            processComment(value);
	          } else if (value = matches[2]) {
	            var isValidCdataSection = parsingMode === 1 || settings.preserve_cdata || stack.length > 0 && schema.isValidChild(stack[stack.length - 1].name, '#cdata');
	            if (isValidCdataSection) {
	              cdata(value);
	            } else {
	              index = processMalformedComment('', matches.index + 2);
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	          } else if (value = matches[3]) {
	            doctype(value);
	          } else if ((value = matches[4]) || matchText === '<!') {
	            index = processMalformedComment(value, matches.index + matchText.length);
	            tokenRegExp.lastIndex = index;
	            continue;
	          } else if (value = matches[5]) {
	            if (parsingMode === 1) {
	              pi(value, matches[6]);
	            } else {
	              index = processMalformedComment('?', matches.index + 2);
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	          }
	          index = matches.index + matchText.length;
	        }
	        if (index < html.length) {
	          processText(decode(html.substr(index)));
	        }
	        for (i = stack.length - 1; i >= 0; i--) {
	          value = stack[i];
	          if (value.valid) {
	            end(value.name);
	          }
	        }
	      };
	      var parse = function (html, format) {
	        if (format === void 0) {
	          format = 'html';
	        }
	        parseInternal(extractBase64DataUris(html), format);
	      };
	      return { parse: parse };
	    };
	    SaxParser.findEndTag = findEndTagIndex;
	
	    var trimHtml = function (tempAttrs, html) {
	      var trimContentRegExp = new RegExp(['\\s?(' + tempAttrs.join('|') + ')="[^"]+"'].join('|'), 'gi');
	      return html.replace(trimContentRegExp, '');
	    };
	    var trimInternal = function (serializer, html) {
	      var content = html;
	      var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
	      var endTagIndex, index, matchLength, matches;
	      var schema = serializer.schema;
	      content = trimHtml(serializer.getTempAttrs(), content);
	      var shortEndedElements = schema.getShortEndedElements();
	      while (matches = bogusAllRegExp.exec(content)) {
	        index = bogusAllRegExp.lastIndex;
	        matchLength = matches[0].length;
	        if (shortEndedElements[matches[1]]) {
	          endTagIndex = index;
	        } else {
	          endTagIndex = SaxParser.findEndTag(schema, content, index);
	        }
	        content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
	        bogusAllRegExp.lastIndex = index - matchLength;
	      }
	      return trim$2(content);
	    };
	    var trimExternal = trimInternal;
	
	    var trimEmptyContents = function (editor, html) {
	      var blockName = getForcedRootBlock(editor);
	      var emptyRegExp = new RegExp('^(<' + blockName + '[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/' + blockName + '>[\r\n]*|<br \\/>[\r\n]*)$');
	      return html.replace(emptyRegExp, '');
	    };
	    var getContentFromBody = function (editor, args, format, body) {
	      var content;
	      args.format = format;
	      args.get = true;
	      args.getInner = true;
	      if (!args.no_events) {
	        editor.fire('BeforeGetContent', args);
	      }
	      if (args.format === 'raw') {
	        content = Tools.trim(trimExternal(editor.serializer, body.innerHTML));
	      } else if (args.format === 'text') {
	        content = editor.dom.isEmpty(body) ? '' : trim$2(body.innerText || body.textContent);
	      } else if (args.format === 'tree') {
	        content = editor.serializer.serialize(body, args);
	      } else {
	        content = trimEmptyContents(editor, editor.serializer.serialize(body, args));
	      }
	      if (!contains([
	          'text',
	          'tree'
	        ], args.format) && !isWsPreserveElement(SugarElement.fromDom(body))) {
	        args.content = Tools.trim(content);
	      } else {
	        args.content = content;
	      }
	      if (!args.no_events) {
	        editor.fire('GetContent', args);
	      }
	      return args.content;
	    };
	    var getContentInternal = function (editor, args, format) {
	      return Optional.from(editor.getBody()).fold(constant(args.format === 'tree' ? new AstNode('body', 11) : ''), function (body) {
	        return getContentFromBody(editor, args, format, body);
	      });
	    };
	
	    var each$7 = Tools.each;
	    var ElementUtils = function (dom) {
	      var compare = function (node1, node2) {
	        if (node1.nodeName !== node2.nodeName) {
	          return false;
	        }
	        var getAttribs = function (node) {
	          var attribs = {};
	          each$7(dom.getAttribs(node), function (attr) {
	            var name = attr.nodeName.toLowerCase();
	            if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
	              attribs[name] = dom.getAttrib(node, name);
	            }
	          });
	          return attribs;
	        };
	        var compareObjects = function (obj1, obj2) {
	          var value, name;
	          for (name in obj1) {
	            if (obj1.hasOwnProperty(name)) {
	              value = obj2[name];
	              if (typeof value === 'undefined') {
	                return false;
	              }
	              if (obj1[name] !== value) {
	                return false;
	              }
	              delete obj2[name];
	            }
	          }
	          for (name in obj2) {
	            if (obj2.hasOwnProperty(name)) {
	              return false;
	            }
	          }
	          return true;
	        };
	        if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
	          return false;
	        }
	        if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
	          return false;
	        }
	        return !isBookmarkNode$1(node1) && !isBookmarkNode$1(node2);
	      };
	      return { compare: compare };
	    };
	
	    var makeMap$3 = Tools.makeMap;
	    var Writer = function (settings) {
	      var html = [];
	      settings = settings || {};
	      var indent = settings.indent;
	      var indentBefore = makeMap$3(settings.indent_before || '');
	      var indentAfter = makeMap$3(settings.indent_after || '');
	      var encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
	      var htmlOutput = settings.element_format === 'html';
	      return {
	        start: function (name, attrs, empty) {
	          var i, l, attr, value;
	          if (indent && indentBefore[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	          html.push('<', name);
	          if (attrs) {
	            for (i = 0, l = attrs.length; i < l; i++) {
	              attr = attrs[i];
	              html.push(' ', attr.name, '="', encode(attr.value, true), '"');
	            }
	          }
	          if (!empty || htmlOutput) {
	            html[html.length] = '>';
	          } else {
	            html[html.length] = ' />';
	          }
	          if (empty && indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        end: function (name) {
	          var value;
	          html.push('</', name, '>');
	          if (indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	        text: function (text, raw) {
	          if (text.length > 0) {
	            html[html.length] = raw ? text : encode(text);
	          }
	        },
	        cdata: function (text) {
	          html.push('<![CDATA[', text, ']]>');
	        },
	        comment: function (text) {
	          html.push('<!--', text, '-->');
	        },
	        pi: function (name, text) {
	          if (text) {
	            html.push('<?', name, ' ', encode(text), '?>');
	          } else {
	            html.push('<?', name, '?>');
	          }
	          if (indent) {
	            html.push('\n');
	          }
	        },
	        doctype: function (text) {
	          html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
	        },
	        reset: function () {
	          html.length = 0;
	        },
	        getContent: function () {
	          return html.join('').replace(/\n$/, '');
	        }
	      };
	    };
	
	    var HtmlSerializer = function (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var writer = Writer(settings);
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      var serialize = function (node) {
	        var validate = settings.validate;
	        var handlers = {
	          3: function (node) {
	            writer.text(node.value, node.raw);
	          },
	          8: function (node) {
	            writer.comment(node.value);
	          },
	          7: function (node) {
	            writer.pi(node.name, node.value);
	          },
	          10: function (node) {
	            writer.doctype(node.value);
	          },
	          4: function (node) {
	            writer.cdata(node.value);
	          },
	          11: function (node) {
	            if (node = node.firstChild) {
	              do {
	                walk(node);
	              } while (node = node.next);
	            }
	          }
	        };
	        writer.reset();
	        var walk = function (node) {
	          var handler = handlers[node.type];
	          var name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
	          if (!handler) {
	            name = node.name;
	            isEmpty = node.shortEnded;
	            attrs = node.attributes;
	            if (validate && attrs && attrs.length > 1) {
	              sortedAttrs = [];
	              sortedAttrs.map = {};
	              elementRule = schema.getElementRule(node.name);
	              if (elementRule) {
	                for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
	                  attrName = elementRule.attributesOrder[i];
	                  if (attrName in attrs.map) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                for (i = 0, l = attrs.length; i < l; i++) {
	                  attrName = attrs[i].name;
	                  if (!(attrName in sortedAttrs.map)) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({
	                      name: attrName,
	                      value: attrValue
	                    });
	                  }
	                }
	                attrs = sortedAttrs;
	              }
	            }
	            writer.start(node.name, attrs, isEmpty);
	            if (!isEmpty) {
	              if (node = node.firstChild) {
	                do {
	                  walk(node);
	                } while (node = node.next);
	              }
	              writer.end(name);
	            }
	          } else {
	            handler(node);
	          }
	        };
	        if (node.type === 1 && !settings.inner) {
	          walk(node);
	        } else {
	          handlers[11](node);
	        }
	        return writer.getContent();
	      };
	      return { serialize: serialize };
	    };
	
	    var nonInheritableStyles = new Set();
	    (function () {
	      var nonInheritableStylesArr = [
	        'margin',
	        'margin-left',
	        'margin-right',
	        'margin-top',
	        'margin-bottom',
	        'padding',
	        'padding-left',
	        'padding-right',
	        'padding-top',
	        'padding-bottom',
	        'border',
	        'border-width',
	        'border-style',
	        'border-color',
	        'background',
	        'background-attachment',
	        'background-clip',
	        'background-color',
	        'background-image',
	        'background-origin',
	        'background-position',
	        'background-repeat',
	        'background-size',
	        'float',
	        'position',
	        'left',
	        'right',
	        'top',
	        'bottom',
	        'z-index',
	        'display',
	        'transform',
	        'width',
	        'max-width',
	        'min-width',
	        'height',
	        'max-height',
	        'min-height',
	        'overflow',
	        'overflow-x',
	        'overflow-y',
	        'text-overflow',
	        'vertical-align',
	        'transition',
	        'transition-delay',
	        'transition-duration',
	        'transition-property',
	        'transition-timing-function'
	      ];
	      each(nonInheritableStylesArr, function (style) {
	        nonInheritableStyles.add(style);
	      });
	    }());
	    var shorthandStyleProps = [
	      'font',
	      'text-decoration',
	      'text-emphasis'
	    ];
	    var getStyleProps = function (dom, node) {
	      return keys(dom.parseStyle(dom.getAttrib(node, 'style')));
	    };
	    var isNonInheritableStyle = function (style) {
	      return nonInheritableStyles.has(style);
	    };
	    var hasInheritableStyles = function (dom, node) {
	      return forall(getStyleProps(dom, node), function (style) {
	        return !isNonInheritableStyle(style);
	      });
	    };
	    var getLonghandStyleProps = function (styles) {
	      return filter(styles, function (style) {
	        return exists(shorthandStyleProps, function (prop) {
	          return startsWith(style, prop);
	        });
	      });
	    };
	    var hasStyleConflict = function (dom, node, parentNode) {
	      var nodeStyleProps = getStyleProps(dom, node);
	      var parentNodeStyleProps = getStyleProps(dom, parentNode);
	      var valueMismatch = function (prop) {
	        var nodeValue = dom.getStyle(node, prop);
	        var parentValue = dom.getStyle(parentNode, prop);
	        return isNotEmpty(nodeValue) && isNotEmpty(parentValue) && nodeValue !== parentValue;
	      };
	      return exists(nodeStyleProps, function (nodeStyleProp) {
	        var propExists = function (props) {
	          return exists(props, function (prop) {
	            return prop === nodeStyleProp;
	          });
	        };
	        if (!propExists(parentNodeStyleProps) && propExists(shorthandStyleProps)) {
	          var longhandProps = getLonghandStyleProps(parentNodeStyleProps);
	          return exists(longhandProps, valueMismatch);
	        } else {
	          return valueMismatch(nodeStyleProp);
	        }
	      });
	    };
	
	    var isChar = function (forward, predicate, pos) {
	      return Optional.from(pos.container()).filter(isText$1).exists(function (text) {
	        var delta = forward ? 0 : -1;
	        return predicate(text.data.charAt(pos.offset() + delta));
	      });
	    };
	    var isBeforeSpace = curry(isChar, true, isWhiteSpace$1);
	    var isAfterSpace = curry(isChar, false, isWhiteSpace$1);
	    var isEmptyText = function (pos) {
	      var container = pos.container();
	      return isText$1(container) && (container.data.length === 0 || isZwsp$1(container.data) && BookmarkManager.isBookmarkNode(container.parentNode));
	    };
	    var matchesElementPosition = function (before, predicate) {
	      return function (pos) {
	        return Optional.from(getChildNodeAtRelativeOffset(before ? 0 : -1, pos)).filter(predicate).isSome();
	      };
	    };
	    var isImageBlock = function (node) {
	      return isImg(node) && get$5(SugarElement.fromDom(node), 'display') === 'block';
	    };
	    var isCefNode = function (node) {
	      return isContentEditableFalse(node) && !isBogusAll(node);
	    };
	    var isBeforeImageBlock = matchesElementPosition(true, isImageBlock);
	    var isAfterImageBlock = matchesElementPosition(false, isImageBlock);
	    var isBeforeMedia = matchesElementPosition(true, isMedia);
	    var isAfterMedia = matchesElementPosition(false, isMedia);
	    var isBeforeTable = matchesElementPosition(true, isTable);
	    var isAfterTable = matchesElementPosition(false, isTable);
	    var isBeforeContentEditableFalse = matchesElementPosition(true, isCefNode);
	    var isAfterContentEditableFalse = matchesElementPosition(false, isCefNode);
	
	    var getLastChildren$1 = function (elm) {
	      var children = [];
	      var rawNode = elm.dom;
	      while (rawNode) {
	        children.push(SugarElement.fromDom(rawNode));
	        rawNode = rawNode.lastChild;
	      }
	      return children;
	    };
	    var removeTrailingBr = function (elm) {
	      var allBrs = descendants$1(elm, 'br');
	      var brs = filter(getLastChildren$1(elm).slice(-1), isBr$1);
	      if (allBrs.length === brs.length) {
	        each(brs, remove);
	      }
	    };
	    var fillWithPaddingBr = function (elm) {
	      empty(elm);
	      append(elm, SugarElement.fromHtml('<br data-mce-bogus="1">'));
	    };
	    var trimBlockTrailingBr = function (elm) {
	      lastChild(elm).each(function (lastChild) {
	        prevSibling(lastChild).each(function (lastChildPrevSibling) {
	          if (isBlock(elm) && isBr$1(lastChild) && isBlock(lastChildPrevSibling)) {
	            remove(lastChild);
	          }
	        });
	      });
	    };
	
	    var dropLast = function (xs) {
	      return xs.slice(0, -1);
	    };
	    var parentsUntil$1 = function (start, root, predicate) {
	      if (contains$2(root, start)) {
	        return dropLast(parents(start, function (elm) {
	          return predicate(elm) || eq$2(elm, root);
	        }));
	      } else {
	        return [];
	      }
	    };
	    var parents$1 = function (start, root) {
	      return parentsUntil$1(start, root, never);
	    };
	    var parentsAndSelf = function (start, root) {
	      return [start].concat(parents$1(start, root));
	    };
	
	    var navigateIgnoreEmptyTextNodes = function (forward, root, from) {
	      return navigateIgnore(forward, root, from, isEmptyText);
	    };
	    var getClosestBlock = function (root, pos) {
	      return find(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock);
	    };
	    var isAtBeforeAfterBlockBoundary = function (forward, root, pos) {
	      return navigateIgnoreEmptyTextNodes(forward, root.dom, pos).forall(function (newPos) {
	        return getClosestBlock(root, pos).fold(function () {
	          return isInSameBlock(newPos, pos, root.dom) === false;
	        }, function (fromBlock) {
	          return isInSameBlock(newPos, pos, root.dom) === false && contains$2(fromBlock, SugarElement.fromDom(newPos.container()));
	        });
	      });
	    };
	    var isAtBlockBoundary$1 = function (forward, root, pos) {
	      return getClosestBlock(root, pos).fold(function () {
	        return navigateIgnoreEmptyTextNodes(forward, root.dom, pos).forall(function (newPos) {
	          return isInSameBlock(newPos, pos, root.dom) === false;
	        });
	      }, function (parent) {
	        return navigateIgnoreEmptyTextNodes(forward, parent.dom, pos).isNone();
	      });
	    };
	    var isAtStartOfBlock = curry(isAtBlockBoundary$1, false);
	    var isAtEndOfBlock = curry(isAtBlockBoundary$1, true);
	    var isBeforeBlock = curry(isAtBeforeAfterBlockBoundary, false);
	    var isAfterBlock = curry(isAtBeforeAfterBlockBoundary, true);
	
	    var isBr$5 = function (pos) {
	      return getElementFromPosition(pos).exists(isBr$1);
	    };
	    var findBr = function (forward, root, pos) {
	      var parentBlocks = filter(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock);
	      var scope = head(parentBlocks).getOr(root);
	      return fromPosition(forward, scope.dom, pos).filter(isBr$5);
	    };
	    var isBeforeBr = function (root, pos) {
	      return getElementFromPosition(pos).exists(isBr$1) || findBr(true, root, pos).isSome();
	    };
	    var isAfterBr = function (root, pos) {
	      return getElementFromPrevPosition(pos).exists(isBr$1) || findBr(false, root, pos).isSome();
	    };
	    var findPreviousBr = curry(findBr, false);
	    var findNextBr = curry(findBr, true);
	
	    var isInMiddleOfText = function (pos) {
	      return CaretPosition.isTextPosition(pos) && !pos.isAtStart() && !pos.isAtEnd();
	    };
	    var getClosestBlock$1 = function (root, pos) {
	      var parentBlocks = filter(parentsAndSelf(SugarElement.fromDom(pos.container()), root), isBlock);
	      return head(parentBlocks).getOr(root);
	    };
	    var hasSpaceBefore = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isAfterSpace(pos);
	      } else {
	        return isAfterSpace(pos) || prevPosition(getClosestBlock$1(root, pos).dom, pos).exists(isAfterSpace);
	      }
	    };
	    var hasSpaceAfter = function (root, pos) {
	      if (isInMiddleOfText(pos)) {
	        return isBeforeSpace(pos);
	      } else {
	        return isBeforeSpace(pos) || nextPosition(getClosestBlock$1(root, pos).dom, pos).exists(isBeforeSpace);
	      }
	    };
	    var isPreValue = function (value) {
	      return contains([
	        'pre',
	        'pre-wrap'
	      ], value);
	    };
	    var isInPre = function (pos) {
	      return getElementFromPosition(pos).bind(function (elm) {
	        return closest(elm, isElement);
	      }).exists(function (elm) {
	        return isPreValue(get$5(elm, 'white-space'));
	      });
	    };
	    var isAtBeginningOfBody = function (root, pos) {
	      return prevPosition(root.dom, pos).isNone();
	    };
	    var isAtEndOfBody = function (root, pos) {
	      return nextPosition(root.dom, pos).isNone();
	    };
	    var isAtLineBoundary = function (root, pos) {
	      return isAtBeginningOfBody(root, pos) || isAtEndOfBody(root, pos) || isAtStartOfBlock(root, pos) || isAtEndOfBlock(root, pos) || isAfterBr(root, pos) || isBeforeBr(root, pos);
	    };
	    var needsToHaveNbsp = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtLineBoundary(root, pos) || hasSpaceBefore(root, pos) || hasSpaceAfter(root, pos);
	      }
	    };
	    var needsToBeNbspLeft = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtStartOfBlock(root, pos) || isBeforeBlock(root, pos) || isAfterBr(root, pos) || hasSpaceBefore(root, pos);
	      }
	    };
	    var leanRight = function (pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (isText$1(container) && offset < container.data.length) {
	        return CaretPosition(container, offset + 1);
	      } else {
	        return pos;
	      }
	    };
	    var needsToBeNbspRight = function (root, pos) {
	      if (isInPre(pos)) {
	        return false;
	      } else {
	        return isAtEndOfBlock(root, pos) || isAfterBlock(root, pos) || isBeforeBr(root, pos) || hasSpaceAfter(root, pos);
	      }
	    };
	    var needsToBeNbsp = function (root, pos) {
	      return needsToBeNbspLeft(root, pos) || needsToBeNbspRight(root, leanRight(pos));
	    };
	    var isNbspAt = function (text, offset) {
	      return isNbsp(text.charAt(offset));
	    };
	    var hasNbsp = function (pos) {
	      var container = pos.container();
	      return isText$1(container) && contains$1(container.data, nbsp);
	    };
	    var normalizeNbspMiddle = function (text) {
	      var chars = text.split('');
	      return map(chars, function (chr, i) {
	        if (isNbsp(chr) && i > 0 && i < chars.length - 1 && isContent$1(chars[i - 1]) && isContent$1(chars[i + 1])) {
	          return ' ';
	        } else {
	          return chr;
	        }
	      }).join('');
	    };
	    var normalizeNbspAtStart = function (root, node) {
	      var text = node.data;
	      var firstPos = CaretPosition(node, 0);
	      if (isNbspAt(text, 0) && !needsToBeNbsp(root, firstPos)) {
	        node.data = ' ' + text.slice(1);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspInMiddleOfTextNode = function (node) {
	      var text = node.data;
	      var newText = normalizeNbspMiddle(text);
	      if (newText !== text) {
	        node.data = newText;
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbspAtEnd = function (root, node) {
	      var text = node.data;
	      var lastPos = CaretPosition(node, text.length - 1);
	      if (isNbspAt(text, text.length - 1) && !needsToBeNbsp(root, lastPos)) {
	        node.data = text.slice(0, -1) + ' ';
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var normalizeNbsps = function (root, pos) {
	      return Optional.some(pos).filter(hasNbsp).bind(function (pos) {
	        var container = pos.container();
	        var normalized = normalizeNbspAtStart(root, container) || normalizeNbspInMiddleOfTextNode(container) || normalizeNbspAtEnd(root, container);
	        return normalized ? Optional.some(pos) : Optional.none();
	      });
	    };
	    var normalizeNbspsInEditor = function (editor) {
	      var root = SugarElement.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        normalizeNbsps(root, CaretPosition.fromRangeStart(editor.selection.getRng())).each(function (pos) {
	          editor.selection.setRng(pos.toRange());
	        });
	      }
	    };
	
	    var normalizeContent = function (content, isStartOfContent, isEndOfContent) {
	      var result = foldl(content, function (acc, c) {
	        if (isWhiteSpace$1(c) || isNbsp(c)) {
	          if (acc.previousCharIsSpace || acc.str === '' && isStartOfContent || acc.str.length === content.length - 1 && isEndOfContent) {
	            return {
	              previousCharIsSpace: false,
	              str: acc.str + nbsp
	            };
	          } else {
	            return {
	              previousCharIsSpace: true,
	              str: acc.str + ' '
	            };
	          }
	        } else {
	          return {
	            previousCharIsSpace: false,
	            str: acc.str + c
	          };
	        }
	      }, {
	        previousCharIsSpace: false,
	        str: ''
	      });
	      return result.str;
	    };
	    var normalize$1 = function (node, offset, count) {
	      if (count === 0) {
	        return;
	      }
	      var elm = SugarElement.fromDom(node);
	      var root = ancestor(elm, isBlock).getOr(elm);
	      var whitespace = node.data.slice(offset, offset + count);
	      var isEndOfContent = offset + count >= node.data.length && needsToBeNbspRight(root, CaretPosition(node, node.data.length));
	      var isStartOfContent = offset === 0 && needsToBeNbspLeft(root, CaretPosition(node, 0));
	      node.replaceData(offset, count, normalizeContent(whitespace, isStartOfContent, isEndOfContent));
	    };
	    var normalizeWhitespaceAfter = function (node, offset) {
	      var content = node.data.slice(offset);
	      var whitespaceCount = content.length - lTrim(content).length;
	      return normalize$1(node, offset, whitespaceCount);
	    };
	    var normalizeWhitespaceBefore = function (node, offset) {
	      var content = node.data.slice(0, offset);
	      var whitespaceCount = content.length - rTrim(content).length;
	      return normalize$1(node, offset - whitespaceCount, whitespaceCount);
	    };
	    var mergeTextNodes = function (prevNode, nextNode, normalizeWhitespace, mergeToPrev) {
	      if (mergeToPrev === void 0) {
	        mergeToPrev = true;
	      }
	      var whitespaceOffset = rTrim(prevNode.data).length;
	      var newNode = mergeToPrev ? prevNode : nextNode;
	      var removeNode = mergeToPrev ? nextNode : prevNode;
	      if (mergeToPrev) {
	        newNode.appendData(removeNode.data);
	      } else {
	        newNode.insertData(0, removeNode.data);
	      }
	      remove(SugarElement.fromDom(removeNode));
	      if (normalizeWhitespace) {
	        normalizeWhitespaceAfter(newNode, whitespaceOffset);
	      }
	      return newNode;
	    };
	
	    var needsReposition = function (pos, elm) {
	      var container = pos.container();
	      var offset = pos.offset();
	      return CaretPosition.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition.before(elm).offset();
	    };
	    var reposition = function (elm, pos) {
	      return needsReposition(pos, elm) ? CaretPosition(pos.container(), pos.offset() - 1) : pos;
	    };
	    var beforeOrStartOf = function (node) {
	      return isText$1(node) ? CaretPosition(node, 0) : CaretPosition.before(node);
	    };
	    var afterOrEndOf = function (node) {
	      return isText$1(node) ? CaretPosition(node, node.data.length) : CaretPosition.after(node);
	    };
	    var getPreviousSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate(elm.previousSibling)) {
	        return Optional.some(afterOrEndOf(elm.previousSibling));
	      } else {
	        return elm.previousSibling ? lastPositionIn(elm.previousSibling) : Optional.none();
	      }
	    };
	    var getNextSiblingCaretPosition = function (elm) {
	      if (isCaretCandidate(elm.nextSibling)) {
	        return Optional.some(beforeOrStartOf(elm.nextSibling));
	      } else {
	        return elm.nextSibling ? firstPositionIn(elm.nextSibling) : Optional.none();
	      }
	    };
	    var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
	      var startPosition = CaretPosition.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
	      return prevPosition(rootElement, startPosition).fold(function () {
	        return nextPosition(rootElement, CaretPosition.after(elm));
	      }, Optional.some);
	    };
	    var findCaretPositionForwardsFromElm = function (rootElement, elm) {
	      return nextPosition(rootElement, CaretPosition.after(elm)).fold(function () {
	        return prevPosition(rootElement, CaretPosition.before(elm));
	      }, Optional.some);
	    };
	    var findCaretPositionBackwards = function (rootElement, elm) {
	      return getPreviousSiblingCaretPosition(elm).orThunk(function () {
	        return getNextSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionBackwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPositionForward = function (rootElement, elm) {
	      return getNextSiblingCaretPosition(elm).orThunk(function () {
	        return getPreviousSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionForwardsFromElm(rootElement, elm);
	      });
	    };
	    var findCaretPosition$1 = function (forward, rootElement, elm) {
	      return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
	    };
	    var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
	      return findCaretPosition$1(forward, rootElement, elm).map(curry(reposition, elm));
	    };
	    var setSelection = function (editor, forward, pos) {
	      pos.fold(function () {
	        editor.focus();
	      }, function (pos) {
	        editor.selection.setRng(pos.toRange(), forward);
	      });
	    };
	    var eqRawNode = function (rawNode) {
	      return function (elm) {
	        return elm.dom === rawNode;
	      };
	    };
	    var isBlock$2 = function (editor, elm) {
	      return elm && has(editor.schema.getBlockElements(), name(elm));
	    };
	    var paddEmptyBlock = function (elm) {
	      if (isEmpty(elm)) {
	        var br = SugarElement.fromHtml('<br data-mce-bogus="1">');
	        empty(elm);
	        append(elm, br);
	        return Optional.some(CaretPosition.before(br.dom));
	      } else {
	        return Optional.none();
	      }
	    };
	    var deleteNormalized = function (elm, afterDeletePosOpt, normalizeWhitespace) {
	      var prevTextOpt = prevSibling(elm).filter(isText);
	      var nextTextOpt = nextSibling(elm).filter(isText);
	      remove(elm);
	      return lift3(prevTextOpt, nextTextOpt, afterDeletePosOpt, function (prev, next, pos) {
	        var prevNode = prev.dom, nextNode = next.dom;
	        var offset = prevNode.data.length;
	        mergeTextNodes(prevNode, nextNode, normalizeWhitespace);
	        return pos.container() === nextNode ? CaretPosition(prevNode, offset) : pos;
	      }).orThunk(function () {
	        if (normalizeWhitespace) {
	          prevTextOpt.each(function (elm) {
	            return normalizeWhitespaceBefore(elm.dom, elm.dom.length);
	          });
	          nextTextOpt.each(function (elm) {
	            return normalizeWhitespaceAfter(elm.dom, 0);
	          });
	        }
	        return afterDeletePosOpt;
	      });
	    };
	    var isInlineElement = function (editor, element) {
	      return has(editor.schema.getTextInlineElements(), name(element));
	    };
	    var deleteElement = function (editor, forward, elm, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom);
	      var parentBlock = ancestor(elm, curry(isBlock$2, editor), eqRawNode(editor.getBody()));
	      var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos, isInlineElement(editor, elm));
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        editor.selection.setCursorLocation();
	      } else {
	        parentBlock.bind(paddEmptyBlock).fold(function () {
	          if (moveCaret) {
	            setSelection(editor, forward, normalizedAfterDeletePos);
	          }
	        }, function (paddPos) {
	          if (moveCaret) {
	            setSelection(editor, forward, Optional.some(paddPos));
	          }
	        });
	      }
	    };
	
	    var tableCellRng = function (start, end) {
	      return {
	        start: start,
	        end: end
	      };
	    };
	    var tableSelection = function (rng, table, cells) {
	      return {
	        rng: rng,
	        table: table,
	        cells: cells
	      };
	    };
	    var deleteAction = Adt.generate([
	      { removeTable: ['element'] },
	      { emptyCells: ['cells'] },
	      {
	        deleteCellSelection: [
	          'rng',
	          'cell'
	        ]
	      }
	    ]);
	    var isRootFromElement = function (root) {
	      return function (cur) {
	        return eq$2(root, cur);
	      };
	    };
	    var getClosestCell = function (container, isRoot) {
	      return closest$1(SugarElement.fromDom(container), 'td,th', isRoot);
	    };
	    var getClosestTable = function (cell, isRoot) {
	      return ancestor$1(cell, 'table', isRoot);
	    };
	    var isExpandedCellRng = function (cellRng) {
	      return !eq$2(cellRng.start, cellRng.end);
	    };
	    var getTableFromCellRng = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start, isRoot).bind(function (startParentTable) {
	        return getClosestTable(cellRng.end, isRoot).bind(function (endParentTable) {
	          return someIf(eq$2(startParentTable, endParentTable), startParentTable);
	        });
	      });
	    };
	    var isSingleCellTable = function (cellRng, isRoot) {
	      return !isExpandedCellRng(cellRng) && getTableFromCellRng(cellRng, isRoot).exists(function (table) {
	        var rows = table.dom.rows;
	        return rows.length === 1 && rows[0].cells.length === 1;
	      });
	    };
	    var getTableCells = function (table) {
	      return descendants$1(table, 'td,th');
	    };
	    var getCellRng = function (rng, isRoot) {
	      var startCell = getClosestCell(rng.startContainer, isRoot);
	      var endCell = getClosestCell(rng.endContainer, isRoot);
	      return lift2(startCell, endCell, tableCellRng);
	    };
	    var getCellRangeFromStartTable = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start, isRoot).bind(function (table) {
	        return last(getTableCells(table)).map(function (endCell) {
	          return tableCellRng(cellRng.start, endCell);
	        });
	      });
	    };
	    var partialSelection = function (isRoot, rng) {
	      var startCell = getClosestCell(rng.startContainer, isRoot);
	      var endCell = getClosestCell(rng.endContainer, isRoot);
	      return rng.collapsed ? Optional.none() : lift2(startCell, endCell, tableCellRng).fold(function () {
	        return startCell.fold(function () {
	          return endCell.bind(function (endCell) {
	            return getClosestTable(endCell, isRoot).bind(function (table) {
	              return head(getTableCells(table)).map(function (startCell) {
	                return tableCellRng(startCell, endCell);
	              });
	            });
	          });
	        }, function (startCell) {
	          return getClosestTable(startCell, isRoot).bind(function (table) {
	            return last(getTableCells(table)).map(function (endCell) {
	              return tableCellRng(startCell, endCell);
	            });
	          });
	        });
	      }, function (cellRng) {
	        return isWithinSameTable(isRoot, cellRng) ? Optional.none() : getCellRangeFromStartTable(cellRng, isRoot);
	      });
	    };
	    var isWithinSameTable = function (isRoot, cellRng) {
	      return getTableFromCellRng(cellRng, isRoot).isSome();
	    };
	    var getTableSelectionFromCellRng = function (cellRng, isRoot) {
	      return getTableFromCellRng(cellRng, isRoot).map(function (table) {
	        return tableSelection(cellRng, table, getTableCells(table));
	      });
	    };
	    var getTableSelection = function (optCellRng, rng, isRoot) {
	      return optCellRng.filter(function (cellRng) {
	        return isExpandedCellRng(cellRng) && isWithinSameTable(isRoot, cellRng);
	      }).orThunk(function () {
	        return partialSelection(isRoot, rng);
	      }).bind(function (cRng) {
	        return getTableSelectionFromCellRng(cRng, isRoot);
	      });
	    };
	    var getCellIndex = function (cells, cell) {
	      return findIndex(cells, function (x) {
	        return eq$2(x, cell);
	      });
	    };
	    var getSelectedCells = function (tableSelection) {
	      return lift2(getCellIndex(tableSelection.cells, tableSelection.rng.start), getCellIndex(tableSelection.cells, tableSelection.rng.end), function (startIndex, endIndex) {
	        return tableSelection.cells.slice(startIndex, endIndex + 1);
	      });
	    };
	    var isSingleCellTableContentSelected = function (optCellRng, rng, isRoot) {
	      return optCellRng.filter(function (cellRng) {
	        return isSingleCellTable(cellRng, isRoot) && hasAllContentsSelected(cellRng.start, rng);
	      }).map(function (cellRng) {
	        return cellRng.start;
	      });
	    };
	    var getAction = function (tableSelection) {
	      return getSelectedCells(tableSelection).map(function (selected) {
	        var cells = tableSelection.cells;
	        return selected.length === cells.length ? deleteAction.removeTable(tableSelection.table) : deleteAction.emptyCells(selected);
	      });
	    };
	    var getActionFromRange = function (root, rng) {
	      var isRoot = isRootFromElement(root);
	      var optCellRng = getCellRng(rng, isRoot);
	      return isSingleCellTableContentSelected(optCellRng, rng, isRoot).map(function (cell) {
	        return deleteAction.deleteCellSelection(rng, cell);
	      }).orThunk(function () {
	        return getTableSelection(optCellRng, rng, isRoot).bind(getAction);
	      });
	    };
	
	    var freefallRtl = function (root) {
	      var child = isComment(root) ? prevSibling(root) : lastChild(root);
	      return child.bind(freefallRtl).orThunk(function () {
	        return Optional.some(root);
	      });
	    };
	    var emptyCells = function (editor, cells) {
	      each(cells, fillWithPaddingBr);
	      editor.selection.setCursorLocation(cells[0].dom, 0);
	      return true;
	    };
	    var deleteCellContents = function (editor, rng, cell) {
	      rng.deleteContents();
	      var lastNode = freefallRtl(cell).getOr(cell);
	      var lastBlock = SugarElement.fromDom(editor.dom.getParent(lastNode.dom, editor.dom.isBlock));
	      if (isEmpty(lastBlock)) {
	        fillWithPaddingBr(lastBlock);
	        editor.selection.setCursorLocation(lastBlock.dom, 0);
	      }
	      if (!eq$2(cell, lastBlock)) {
	        var additionalCleanupNodes = parent(lastBlock).is(cell) ? [] : siblings(lastBlock);
	        each(additionalCleanupNodes.concat(children(cell)), function (node) {
	          if (!eq$2(node, lastBlock) && !contains$2(node, lastBlock)) {
	            remove(node);
	          }
	        });
	      }
	      return true;
	    };
	    var deleteTableElement = function (editor, table) {
	      deleteElement(editor, false, table);
	      return true;
	    };
	    var deleteCellRange = function (editor, rootElm, rng) {
	      return getActionFromRange(rootElm, rng).map(function (action) {
	        return action.fold(curry(deleteTableElement, editor), curry(emptyCells, editor), curry(deleteCellContents, editor));
	      });
	    };
	    var deleteCaptionRange = function (editor, caption) {
	      return emptyElement(editor, caption);
	    };
	    var deleteTableRange = function (editor, rootElm, rng, startElm) {
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCellRange(editor, rootElm, rng);
	      }, function (caption) {
	        return deleteCaptionRange(editor, caption);
	      }).getOr(false);
	    };
	    var deleteRange = function (editor, startElm) {
	      var rootNode = SugarElement.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      var selectedCells = getCellsFromEditor(editor);
	      return selectedCells.length !== 0 ? emptyCells(editor, selectedCells) : deleteTableRange(editor, rootNode, rng, startElm);
	    };
	    var getParentCell = function (rootElm, elm) {
	      return find(parentsAndSelf(elm, rootElm), isTableCell$1);
	    };
	    var getParentCaption = function (rootElm, elm) {
	      return find(parentsAndSelf(elm, rootElm), function (elm) {
	        return name(elm) === 'caption';
	      });
	    };
	    var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
	      return navigate(forward, editor.getBody(), from).bind(function (to) {
	        return getParentCell(rootElm, SugarElement.fromDom(to.getNode())).map(function (toCell) {
	          return eq$2(toCell, fromCell) === false;
	        });
	      });
	    };
	    var emptyElement = function (editor, elm) {
	      fillWithPaddingBr(elm);
	      editor.selection.setCursorLocation(elm.dom, 0);
	      return Optional.some(true);
	    };
	    var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
	      return firstPositionIn(fromCaption.dom).bind(function (first) {
	        return lastPositionIn(fromCaption.dom).map(function (last) {
	          return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
	        });
	      }).getOr(true);
	    };
	    var emptyCaretCaption = function (editor, elm) {
	      return emptyElement(editor, elm);
	    };
	    var validateCaretCaption = function (rootElm, fromCaption, to) {
	      return getParentCaption(rootElm, SugarElement.fromDom(to.getNode())).map(function (toCaption) {
	        return eq$2(toCaption, fromCaption) === false;
	      });
	    };
	    var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
	      return navigate(forward, editor.getBody(), from).bind(function (to) {
	        return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
	      }).or(Optional.some(true));
	    };
	    var deleteCaretCells = function (editor, forward, rootElm, startElm) {
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return getParentCell(rootElm, startElm).bind(function (fromCell) {
	        return isEmpty(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
	      }).getOr(false);
	    };
	    var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return isEmpty(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
	    };
	    var isNearTable = function (forward, pos) {
	      return forward ? isBeforeTable(pos) : isAfterTable(pos);
	    };
	    var isBeforeOrAfterTable = function (editor, forward) {
	      var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return isNearTable(forward, fromPos) || fromPosition(forward, editor.getBody(), fromPos).exists(function (pos) {
	        return isNearTable(forward, pos);
	      });
	    };
	    var deleteCaret = function (editor, forward, startElm) {
	      var rootElm = SugarElement.fromDom(editor.getBody());
	      return getParentCaption(rootElm, startElm).fold(function () {
	        return deleteCaretCells(editor, forward, rootElm, startElm) || isBeforeOrAfterTable(editor, forward);
	      }, function (fromCaption) {
	        return deleteCaretCaption(editor, forward, rootElm, fromCaption).getOr(false);
	      });
	    };
	    var backspaceDelete = function (editor, forward) {
	      var startElm = SugarElement.fromDom(editor.selection.getStart(true));
	      var cells = getCellsFromEditor(editor);
	      return editor.selection.isCollapsed() && cells.length === 0 ? deleteCaret(editor, forward, startElm) : deleteRange(editor, startElm);
	    };
	
	    var createRange$1 = function (sc, so, ec, eo) {
	      var rng = document.createRange();
	      rng.setStart(sc, so);
	      rng.setEnd(ec, eo);
	      return rng;
	    };
	    var normalizeBlockSelectionRange = function (rng) {
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      var rootNode = rng.commonAncestorContainer;
	      return fromPosition(false, rootNode, endPos).map(function (newEndPos) {
	        if (!isInSameBlock(startPos, endPos, rootNode) && isInSameBlock(startPos, newEndPos, rootNode)) {
	          return createRange$1(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
	        } else {
	          return rng;
	        }
	      }).getOr(rng);
	    };
	    var normalize$2 = function (rng) {
	      return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
	    };
	
	    var hasOnlyOneChild = function (node) {
	      return node.firstChild && node.firstChild === node.lastChild;
	    };
	    var isPaddingNode = function (node) {
	      return node.name === 'br' || node.value === nbsp;
	    };
	    var isPaddedEmptyBlock = function (schema, node) {
	      var blockElements = schema.getBlockElements();
	      return blockElements[node.name] && hasOnlyOneChild(node) && isPaddingNode(node.firstChild);
	    };
	    var isEmptyFragmentElement = function (schema, node) {
	      var nonEmptyElements = schema.getNonEmptyElements();
	      return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
	    };
	    var isListFragment = function (schema, fragment) {
	      var firstChild = fragment.firstChild;
	      var lastChild = fragment.lastChild;
	      if (firstChild && firstChild.name === 'meta') {
	        firstChild = firstChild.next;
	      }
	      if (lastChild && lastChild.attr('id') === 'mce_marker') {
	        lastChild = lastChild.prev;
	      }
	      if (isEmptyFragmentElement(schema, lastChild)) {
	        lastChild = lastChild.prev;
	      }
	      if (!firstChild || firstChild !== lastChild) {
	        return false;
	      }
	      return firstChild.name === 'ul' || firstChild.name === 'ol';
	    };
	    var cleanupDomFragment = function (domFragment) {
	      var firstChild = domFragment.firstChild;
	      var lastChild = domFragment.lastChild;
	      if (firstChild && firstChild.nodeName === 'META') {
	        firstChild.parentNode.removeChild(firstChild);
	      }
	      if (lastChild && lastChild.id === 'mce_marker') {
	        lastChild.parentNode.removeChild(lastChild);
	      }
	      return domFragment;
	    };
	    var toDomFragment = function (dom, serializer, fragment) {
	      var html = serializer.serialize(fragment);
	      var domFragment = dom.createFragment(html);
	      return cleanupDomFragment(domFragment);
	    };
	    var listItems$1 = function (elm) {
	      return Tools.grep(elm.childNodes, function (child) {
	        return child.nodeName === 'LI';
	      });
	    };
	    var isPadding = function (node) {
	      return node.data === nbsp || isBr(node);
	    };
	    var isListItemPadded = function (node) {
	      return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
	    };
	    var isEmptyOrPadded = function (elm) {
	      return !elm.firstChild || isListItemPadded(elm);
	    };
	    var trimListItems = function (elms) {
	      return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
	    };
	    var getParentLi = function (dom, node) {
	      var parentBlock = dom.getParent(node, dom.isBlock);
	      return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
	    };
	    var isParentBlockLi = function (dom, node) {
	      return !!getParentLi(dom, node);
	    };
	    var getSplit = function (parentNode, rng) {
	      var beforeRng = rng.cloneRange();
	      var afterRng = rng.cloneRange();
	      beforeRng.setStartBefore(parentNode);
	      afterRng.setEndAfter(parentNode);
	      return [
	        beforeRng.cloneContents(),
	        afterRng.cloneContents()
	      ];
	    };
	    var findFirstIn = function (node, rootNode) {
	      var caretPos = CaretPosition.before(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.next(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var findLastOf = function (node, rootNode) {
	      var caretPos = CaretPosition.after(node);
	      var caretWalker = CaretWalker(rootNode);
	      var newCaretPos = caretWalker.prev(caretPos);
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	    var insertMiddle = function (target, elms, rootNode, rng) {
	      var parts = getSplit(target, rng);
	      var parentElm = target.parentNode;
	      parentElm.insertBefore(parts[0], target);
	      Tools.each(elms, function (li) {
	        parentElm.insertBefore(li, target);
	      });
	      parentElm.insertBefore(parts[1], target);
	      parentElm.removeChild(target);
	      return findLastOf(elms[elms.length - 1], rootNode);
	    };
	    var insertBefore = function (target, elms, rootNode) {
	      var parentElm = target.parentNode;
	      Tools.each(elms, function (elm) {
	        parentElm.insertBefore(elm, target);
	      });
	      return findFirstIn(target, rootNode);
	    };
	    var insertAfter = function (target, elms, rootNode, dom) {
	      dom.insertAfter(elms.reverse(), target);
	      return findLastOf(elms[0], rootNode);
	    };
	    var insertAtCaret = function (serializer, dom, rng, fragment) {
	      var domFragment = toDomFragment(dom, serializer, fragment);
	      var liTarget = getParentLi(dom, rng.startContainer);
	      var liElms = trimListItems(listItems$1(domFragment.firstChild));
	      var BEGINNING = 1, END = 2;
	      var rootNode = dom.getRoot();
	      var isAt = function (location) {
	        var caretPos = CaretPosition.fromRangeStart(rng);
	        var caretWalker = CaretWalker(dom.getRoot());
	        var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
	        return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
	      };
	      if (isAt(BEGINNING)) {
	        return insertBefore(liTarget, liElms, rootNode);
	      } else if (isAt(END)) {
	        return insertAfter(liTarget, liElms, rootNode, dom);
	      }
	      return insertMiddle(liTarget, liElms, rootNode, rng);
	    };
	
	    var trimOrPadLeftRight = function (dom, rng, html) {
	      var root = SugarElement.fromDom(dom.getRoot());
	      if (needsToBeNbspLeft(root, CaretPosition.fromRangeStart(rng))) {
	        html = html.replace(/^ /, '&nbsp;');
	      } else {
	        html = html.replace(/^&nbsp;/, ' ');
	      }
	      if (needsToBeNbspRight(root, CaretPosition.fromRangeEnd(rng))) {
	        html = html.replace(/(&nbsp;| )(<br( \/)>)?$/, '&nbsp;');
	      } else {
	        html = html.replace(/&nbsp;(<br( \/)?>)?$/, ' ');
	      }
	      return html;
	    };
	
	    var isTableCell$4 = isTableCell;
	    var isTableCellContentSelected = function (dom, rng, cell) {
	      if (cell !== null) {
	        var endCell = dom.getParent(rng.endContainer, isTableCell$4);
	        return cell === endCell && hasAllContentsSelected(SugarElement.fromDom(cell), rng);
	      } else {
	        return false;
	      }
	    };
	    var validInsertion = function (editor, value, parentNode) {
	      if (parentNode.getAttribute('data-mce-bogus') === 'all') {
	        parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
	      } else {
	        var node = parentNode.firstChild;
	        var node2 = parentNode.lastChild;
	        if (!node || node === node2 && node.nodeName === 'BR') {
	          editor.dom.setHTML(parentNode, value);
	        } else {
	          editor.selection.setContent(value);
	        }
	      }
	    };
	    var trimBrsFromTableCell = function (dom, elm) {
	      Optional.from(dom.getParent(elm, 'td,th')).map(SugarElement.fromDom).each(trimBlockTrailingBr);
	    };
	    var reduceInlineTextElements = function (editor, merge) {
	      var textInlineElements = editor.schema.getTextInlineElements();
	      var dom = editor.dom;
	      if (merge) {
	        var root_1 = editor.getBody();
	        var elementUtils_1 = ElementUtils(dom);
	        Tools.each(dom.select('*[data-mce-fragment]'), function (node) {
	          var isInline = isNonNullable(textInlineElements[node.nodeName.toLowerCase()]);
	          if (isInline && hasInheritableStyles(dom, node)) {
	            for (var parentNode = node.parentNode; isNonNullable(parentNode) && parentNode !== root_1; parentNode = parentNode.parentNode) {
	              var styleConflict = hasStyleConflict(dom, node, parentNode);
	              if (styleConflict) {
	                break;
	              }
	              if (elementUtils_1.compare(parentNode, node)) {
	                dom.remove(node, true);
	                break;
	              }
	            }
	          }
	        });
	      }
	    };
	    var markFragmentElements = function (fragment) {
	      var node = fragment;
	      while (node = node.walk()) {
	        if (node.type === 1) {
	          node.attr('data-mce-fragment', '1');
	        }
	      }
	    };
	    var unmarkFragmentElements = function (elm) {
	      Tools.each(elm.getElementsByTagName('*'), function (elm) {
	        elm.removeAttribute('data-mce-fragment');
	      });
	    };
	    var isPartOfFragment = function (node) {
	      return !!node.getAttribute('data-mce-fragment');
	    };
	    var canHaveChildren = function (editor, node) {
	      return node && !editor.schema.getShortEndedElements()[node.nodeName];
	    };
	    var moveSelectionToMarker = function (editor, marker) {
	      var nextRng;
	      var dom = editor.dom, selection = editor.selection;
	      var node2;
	      var getContentEditableFalseParent = function (node) {
	        var root = editor.getBody();
	        for (; node && node !== root; node = node.parentNode) {
	          if (dom.getContentEditable(node) === 'false') {
	            return node;
	          }
	        }
	        return null;
	      };
	      if (!marker) {
	        return;
	      }
	      selection.scrollIntoView(marker);
	      var parentEditableFalseElm = getContentEditableFalseParent(marker);
	      if (parentEditableFalseElm) {
	        dom.remove(marker);
	        selection.select(parentEditableFalseElm);
	        return;
	      }
	      var rng = dom.createRng();
	      var node = marker.previousSibling;
	      if (node && node.nodeType === 3) {
	        rng.setStart(node, node.nodeValue.length);
	        if (!Env.ie) {
	          node2 = marker.nextSibling;
	          if (node2 && node2.nodeType === 3) {
	            node.appendData(node2.data);
	            node2.parentNode.removeChild(node2);
	          }
	        }
	      } else {
	        rng.setStartBefore(marker);
	        rng.setEndBefore(marker);
	      }
	      var findNextCaretRng = function (rng) {
	        var caretPos = CaretPosition.fromRangeStart(rng);
	        var caretWalker = CaretWalker(editor.getBody());
	        caretPos = caretWalker.next(caretPos);
	        if (caretPos) {
	          return caretPos.toRange();
	        }
	      };
	      var parentBlock = dom.getParent(marker, dom.isBlock);
	      dom.remove(marker);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        editor.$(parentBlock).empty();
	        rng.setStart(parentBlock, 0);
	        rng.setEnd(parentBlock, 0);
	        if (!isTableCell$4(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
	          rng = nextRng;
	          dom.remove(parentBlock);
	        } else {
	          dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	      selection.setRng(rng);
	    };
	    var deleteSelectedContent = function (editor) {
	      var dom = editor.dom;
	      var rng = normalize$2(editor.selection.getRng());
	      editor.selection.setRng(rng);
	      var startCell = dom.getParent(rng.startContainer, isTableCell$4);
	      if (isTableCellContentSelected(dom, rng, startCell)) {
	        deleteCellContents(editor, rng, SugarElement.fromDom(startCell));
	      } else {
	        editor.getDoc().execCommand('Delete', false, null);
	      }
	    };
	    var insertHtmlAtCaret = function (editor, value, details) {
	      var parentNode, rootNode, args;
	      var marker, rng, node;
	      var selection = editor.selection, dom = editor.dom;
	      if (/^ | $/.test(value)) {
	        value = trimOrPadLeftRight(dom, selection.getRng(), value);
	      }
	      var parser = editor.parser;
	      var merge = details.merge;
	      var serializer = HtmlSerializer({ validate: shouldValidate(editor) }, editor.schema);
	      var bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>';
	      args = {
	        content: value,
	        format: 'html',
	        selection: true,
	        paste: details.paste
	      };
	      args = editor.fire('BeforeSetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('SetContent', {
	          content: args.content,
	          format: 'html',
	          selection: true,
	          paste: details.paste
	        });
	        return;
	      }
	      value = args.content;
	      if (value.indexOf('{$caret}') === -1) {
	        value += '{$caret}';
	      }
	      value = value.replace(/\{\$caret\}/, bookmarkHtml);
	      rng = selection.getRng();
	      var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
	      var body = editor.getBody();
	      if (caretElement === body && selection.isCollapsed()) {
	        if (dom.isBlock(body.firstChild) && canHaveChildren(editor, body.firstChild) && dom.isEmpty(body.firstChild)) {
	          rng = dom.createRng();
	          rng.setStart(body.firstChild, 0);
	          rng.setEnd(body.firstChild, 0);
	          selection.setRng(rng);
	        }
	      }
	      if (!selection.isCollapsed()) {
	        deleteSelectedContent(editor);
	      }
	      parentNode = selection.getNode();
	      var parserArgs = {
	        context: parentNode.nodeName.toLowerCase(),
	        data: details.data,
	        insert: true
	      };
	      var fragment = parser.parse(value, parserArgs);
	      if (details.paste === true && isListFragment(editor.schema, fragment) && isParentBlockLi(dom, parentNode)) {
	        rng = insertAtCaret(serializer, dom, selection.getRng(), fragment);
	        selection.setRng(rng);
	        editor.fire('SetContent', args);
	        return;
	      }
	      markFragmentElements(fragment);
	      node = fragment.lastChild;
	      if (node.attr('id') === 'mce_marker') {
	        marker = node;
	        for (node = node.prev; node; node = node.walk(true)) {
	          if (node.type === 3 || !dom.isBlock(node.name)) {
	            if (editor.schema.isValidChild(node.parent.name, 'span')) {
	              node.parent.insert(marker, node, node.name === 'br');
	            }
	            break;
	          }
	        }
	      }
	      editor._selectionOverrides.showBlockCaretContainer(parentNode);
	      if (!parserArgs.invalid) {
	        value = serializer.serialize(fragment);
	        validInsertion(editor, value, parentNode);
	      } else {
	        editor.selection.setContent(bookmarkHtml);
	        parentNode = selection.getNode();
	        rootNode = editor.getBody();
	        if (parentNode.nodeType === 9) {
	          parentNode = node = rootNode;
	        } else {
	          node = parentNode;
	        }
	        while (node !== rootNode) {
	          parentNode = node;
	          node = node.parentNode;
	        }
	        value = parentNode === rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
	        value = serializer.serialize(parser.parse(value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
	          return serializer.serialize(fragment);
	        })));
	        if (parentNode === rootNode) {
	          dom.setHTML(rootNode, value);
	        } else {
	          dom.setOuterHTML(parentNode, value);
	        }
	      }
	      reduceInlineTextElements(editor, merge);
	      moveSelectionToMarker(editor, dom.get('mce_marker'));
	      unmarkFragmentElements(editor.getBody());
	      trimBrsFromTableCell(dom, selection.getStart());
	      editor.fire('SetContent', args);
	      editor.addVisual();
	    };
	
	    var traverse = function (node, fn) {
	      fn(node);
	      if (node.firstChild) {
	        traverse(node.firstChild, fn);
	      }
	      if (node.next) {
	        traverse(node.next, fn);
	      }
	    };
	    var findMatchingNodes = function (nodeFilters, attributeFilters, node) {
	      var nodeMatches = {};
	      var attrMatches = {};
	      var matches = [];
	      if (node.firstChild) {
	        traverse(node.firstChild, function (node) {
	          each(nodeFilters, function (filter) {
	            if (filter.name === node.name) {
	              if (nodeMatches[filter.name]) {
	                nodeMatches[filter.name].nodes.push(node);
	              } else {
	                nodeMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	          each(attributeFilters, function (filter) {
	            if (typeof node.attr(filter.name) === 'string') {
	              if (attrMatches[filter.name]) {
	                attrMatches[filter.name].nodes.push(node);
	              } else {
	                attrMatches[filter.name] = {
	                  filter: filter,
	                  nodes: [node]
	                };
	              }
	            }
	          });
	        });
	      }
	      for (var name_1 in nodeMatches) {
	        if (nodeMatches.hasOwnProperty(name_1)) {
	          matches.push(nodeMatches[name_1]);
	        }
	      }
	      for (var name_2 in attrMatches) {
	        if (attrMatches.hasOwnProperty(name_2)) {
	          matches.push(attrMatches[name_2]);
	        }
	      }
	      return matches;
	    };
	    var filter$3 = function (nodeFilters, attributeFilters, node) {
	      var matches = findMatchingNodes(nodeFilters, attributeFilters, node);
	      each(matches, function (match) {
	        each(match.filter.callbacks, function (callback) {
	          callback(match.nodes, match.filter.name, {});
	        });
	      });
	    };
	
	    var defaultFormat = 'html';
	    var isTreeNode = function (content) {
	      return content instanceof AstNode;
	    };
	    var moveSelection = function (editor) {
	      if (hasFocus$1(editor)) {
	        firstPositionIn(editor.getBody()).each(function (pos) {
	          var node = pos.getNode();
	          var caretPos = isTable(node) ? firstPositionIn(node).getOr(pos) : pos;
	          editor.selection.setRng(caretPos.toRange());
	        });
	      }
	    };
	    var setEditorHtml = function (editor, html) {
	      editor.dom.setHTML(editor.getBody(), html);
	      moveSelection(editor);
	    };
	    var setContentString = function (editor, body, content, args) {
	      var forcedRootBlockName, padd;
	      if (content.length === 0 || /^\s+$/.test(content)) {
	        padd = '<br data-mce-bogus="1">';
	        if (body.nodeName === 'TABLE') {
	          content = '<tr><td>' + padd + '</td></tr>';
	        } else if (/^(UL|OL)$/.test(body.nodeName)) {
	          content = '<li>' + padd + '</li>';
	        }
	        forcedRootBlockName = getForcedRootBlock(editor);
	        if (forcedRootBlockName && editor.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
	          content = padd;
	          content = editor.dom.createHTML(forcedRootBlockName, getForcedRootBlockAttrs(editor), content);
	        } else if (!content) {
	          content = '<br data-mce-bogus="1">';
	        }
	        setEditorHtml(editor, content);
	        editor.fire('SetContent', args);
	      } else {
	        if (args.format !== 'raw') {
	          content = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(editor.parser.parse(content, {
	            isRootContent: true,
	            insert: true
	          }));
	        }
	        args.content = isWsPreserveElement(SugarElement.fromDom(body)) ? content : Tools.trim(content);
	        setEditorHtml(editor, args.content);
	        if (!args.no_events) {
	          editor.fire('SetContent', args);
	        }
	      }
	      return args.content;
	    };
	    var setContentTree = function (editor, body, content, args) {
	      filter$3(editor.parser.getNodeFilters(), editor.parser.getAttributeFilters(), content);
	      var html = HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(content);
	      args.content = isWsPreserveElement(SugarElement.fromDom(body)) ? html : Tools.trim(html);
	      setEditorHtml(editor, args.content);
	      if (!args.no_events) {
	        editor.fire('SetContent', args);
	      }
	      return content;
	    };
	    var setContentInternal = function (editor, content, args) {
	      args.format = args.format ? args.format : defaultFormat;
	      args.set = true;
	      args.content = isTreeNode(content) ? '' : content;
	      if (!args.no_events) {
	        editor.fire('BeforeSetContent', args);
	      }
	      if (!isTreeNode(content)) {
	        content = args.content;
	      }
	      return Optional.from(editor.getBody()).fold(constant(content), function (body) {
	        return isTreeNode(content) ? setContentTree(editor, body, content, args) : setContentString(editor, body, content, args);
	      });
	    };
	
	    var sibling$2 = function (scope, predicate) {
	      return sibling(scope, predicate).isSome();
	    };
	
	    var ensureIsRoot = function (isRoot) {
	      return isFunction(isRoot) ? isRoot : never;
	    };
	    var ancestor$3 = function (scope, transform, isRoot) {
	      var element = scope.dom;
	      var stop = ensureIsRoot(isRoot);
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = SugarElement.fromDom(element);
	        var transformed = transform(el);
	        if (transformed.isSome()) {
	          return transformed;
	        } else if (stop(el)) {
	          break;
	        }
	      }
	      return Optional.none();
	    };
	    var closest$2 = function (scope, transform, isRoot) {
	      var current = transform(scope);
	      var stop = ensureIsRoot(isRoot);
	      return current.orThunk(function () {
	        return stop(scope) ? Optional.none() : ancestor$3(scope, transform, stop);
	      });
	    };
	
	    var isEq$2 = isEq;
	    var matchesUnInheritedFormatSelector = function (ed, node, name) {
	      var formatList = ed.formatter.get(name);
	      if (formatList) {
	        for (var i = 0; i < formatList.length; i++) {
	          if (formatList[i].inherit === false && ed.dom.is(node, formatList[i].selector)) {
	            return true;
	          }
	        }
	      }
	      return false;
	    };
	    var matchParents = function (editor, node, name, vars) {
	      var root = editor.dom.getRoot();
	      if (node === root) {
	        return false;
	      }
	      node = editor.dom.getParent(node, function (node) {
	        if (matchesUnInheritedFormatSelector(editor, node, name)) {
	          return true;
	        }
	        return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
	      });
	      return matchNode(editor, node, name, vars);
	    };
	    var matchName = function (dom, node, format) {
	      if (isEq$2(node, format.inline)) {
	        return true;
	      }
	      if (isEq$2(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return node.nodeType === 1 && dom.is(node, format.selector);
	      }
	    };
	    var matchItems = function (dom, node, format, itemName, similar, vars) {
	      var key, value;
	      var items = format[itemName];
	      var i;
	      if (format.onmatch) {
	        return format.onmatch(node, format, itemName);
	      }
	      if (items) {
	        if (typeof items.length === 'undefined') {
	          for (key in items) {
	            if (items.hasOwnProperty(key)) {
	              if (itemName === 'attributes') {
	                value = dom.getAttrib(node, key);
	              } else {
	                value = getStyle(dom, node, key);
	              }
	              if (similar && !value && !format.exact) {
	                return;
	              }
	              if ((!similar || format.exact) && !isEq$2(value, normalizeStyleValue(dom, replaceVars(items[key], vars), key))) {
	                return;
	              }
	            }
	          }
	        } else {
	          for (i = 0; i < items.length; i++) {
	            if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : getStyle(dom, node, items[i])) {
	              return format;
	            }
	          }
	        }
	      }
	      return format;
	    };
	    var matchNode = function (ed, node, name, vars, similar) {
	      var formatList = ed.formatter.get(name);
	      var format, i, x, classes;
	      var dom = ed.dom;
	      if (formatList && node) {
	        for (i = 0; i < formatList.length; i++) {
	          format = formatList[i];
	          if (matchName(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
	            if (classes = format.classes) {
	              for (x = 0; x < classes.length; x++) {
	                if (!ed.dom.hasClass(node, replaceVars(classes[x], vars))) {
	                  return;
	                }
	              }
	            }
	            return format;
	          }
	        }
	      }
	    };
	    var match = function (editor, name, vars, node) {
	      if (node) {
	        return matchParents(editor, node, name, vars);
	      }
	      node = editor.selection.getNode();
	      if (matchParents(editor, node, name, vars)) {
	        return true;
	      }
	      var startNode = editor.selection.getStart();
	      if (startNode !== node) {
	        if (matchParents(editor, startNode, name, vars)) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var matchAll = function (editor, names, vars) {
	      var matchedFormatNames = [];
	      var checkedMap = {};
	      var startElement = editor.selection.getStart();
	      editor.dom.getParent(startElement, function (node) {
	        for (var i = 0; i < names.length; i++) {
	          var name_1 = names[i];
	          if (!checkedMap[name_1] && matchNode(editor, node, name_1, vars)) {
	            checkedMap[name_1] = true;
	            matchedFormatNames.push(name_1);
	          }
	        }
	      }, editor.dom.getRoot());
	      return matchedFormatNames;
	    };
	    var closest$3 = function (editor, names) {
	      var isRoot = function (elm) {
	        return eq$2(elm, SugarElement.fromDom(editor.getBody()));
	      };
	      var match = function (elm, name) {
	        return matchNode(editor, elm.dom, name) ? Optional.some(name) : Optional.none();
	      };
	      return Optional.from(editor.selection.getStart(true)).bind(function (rawElm) {
	        return closest$2(SugarElement.fromDom(rawElm), function (elm) {
	          return findMap(names, function (name) {
	            return match(elm, name);
	          });
	        }, isRoot);
	      }).getOrNull();
	    };
	    var canApply = function (editor, name) {
	      var formatList = editor.formatter.get(name);
	      var startNode, parents, i, x, selector;
	      var dom = editor.dom;
	      if (formatList) {
	        startNode = editor.selection.getStart();
	        parents = getParents$1(dom, startNode);
	        for (x = formatList.length - 1; x >= 0; x--) {
	          selector = formatList[x].selector;
	          if (!selector || formatList[x].defaultBlock) {
	            return true;
	          }
	          for (i = parents.length - 1; i >= 0; i--) {
	            if (dom.is(parents[i], selector)) {
	              return true;
	            }
	          }
	        }
	      }
	      return false;
	    };
	    var matchAllOnNode = function (editor, node, formatNames) {
	      return foldl(formatNames, function (acc, name) {
	        var matchSimilar = isVariableFormatName(editor, name);
	        if (editor.formatter.matchNode(node, name, {}, matchSimilar)) {
	          return acc.concat([name]);
	        } else {
	          return acc;
	        }
	      }, []);
	    };
	
	    var ZWSP$1 = ZWSP, CARET_ID$1 = '_mce_caret';
	    var importNode = function (ownerDocument, node) {
	      return ownerDocument.importNode(node, true);
	    };
	    var getEmptyCaretContainers = function (node) {
	      var nodes = [];
	      while (node) {
	        if (node.nodeType === 3 && node.nodeValue !== ZWSP$1 || node.childNodes.length > 1) {
	          return [];
	        }
	        if (node.nodeType === 1) {
	          nodes.push(node);
	        }
	        node = node.firstChild;
	      }
	      return nodes;
	    };
	    var isCaretContainerEmpty = function (node) {
	      return getEmptyCaretContainers(node).length > 0;
	    };
	    var findFirstTextNode = function (node) {
	      if (node) {
	        var walker = new DomTreeWalker(node, node);
	        for (node = walker.current(); node; node = walker.next()) {
	          if (isText$1(node)) {
	            return node;
	          }
	        }
	      }
	      return null;
	    };
	    var createCaretContainer = function (fill) {
	      var caretContainer = SugarElement.fromTag('span');
	      setAll(caretContainer, {
	        'id': CARET_ID$1,
	        'data-mce-bogus': '1',
	        'data-mce-type': 'format-caret'
	      });
	      if (fill) {
	        append(caretContainer, SugarElement.fromText(ZWSP$1));
	      }
	      return caretContainer;
	    };
	    var trimZwspFromCaretContainer = function (caretContainerNode) {
	      var textNode = findFirstTextNode(caretContainerNode);
	      if (textNode && textNode.nodeValue.charAt(0) === ZWSP$1) {
	        textNode.deleteData(0, 1);
	      }
	      return textNode;
	    };
	    var removeCaretContainerNode = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (isCaretContainerEmpty(node)) {
	        deleteElement(editor, false, SugarElement.fromDom(node), moveCaret);
	      } else {
	        var rng = selection.getRng();
	        var block = dom.getParent(node, dom.isBlock);
	        var startContainer = rng.startContainer;
	        var startOffset = rng.startOffset;
	        var endContainer = rng.endContainer;
	        var endOffset = rng.endOffset;
	        var textNode = trimZwspFromCaretContainer(node);
	        dom.remove(node, true);
	        if (startContainer === textNode && startOffset > 0) {
	          rng.setStart(textNode, startOffset - 1);
	        }
	        if (endContainer === textNode && endOffset > 0) {
	          rng.setEnd(textNode, endOffset - 1);
	        }
	        if (block && dom.isEmpty(block)) {
	          fillWithPaddingBr(SugarElement.fromDom(block));
	        }
	        selection.setRng(rng);
	      }
	    };
	    var removeCaretContainer = function (editor, node, moveCaret) {
	      if (moveCaret === void 0) {
	        moveCaret = true;
	      }
	      var dom = editor.dom, selection = editor.selection;
	      if (!node) {
	        node = getParentCaretContainer(editor.getBody(), selection.getStart());
	        if (!node) {
	          while (node = dom.get(CARET_ID$1)) {
	            removeCaretContainerNode(editor, node, false);
	          }
	        }
	      } else {
	        removeCaretContainerNode(editor, node, moveCaret);
	      }
	    };
	    var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
	      var dom = editor.dom, block = dom.getParent(formatNode, curry(isTextBlock$1, editor));
	      if (block && dom.isEmpty(block)) {
	        formatNode.parentNode.replaceChild(caretContainer, formatNode);
	      } else {
	        removeTrailingBr(SugarElement.fromDom(formatNode));
	        if (dom.isEmpty(formatNode)) {
	          formatNode.parentNode.replaceChild(caretContainer, formatNode);
	        } else {
	          dom.insertAfter(caretContainer, formatNode);
	        }
	      }
	    };
	    var appendNode = function (parentNode, node) {
	      parentNode.appendChild(node);
	      return node;
	    };
	    var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
	      var innerMostFormatNode = foldr(formatNodes, function (parentNode, formatNode) {
	        return appendNode(parentNode, formatNode.cloneNode(false));
	      }, caretContainer);
	      return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP$1));
	    };
	    var cleanFormatNode = function (editor, caretContainer, formatNode, name, vars, similar) {
	      var formatter = editor.formatter;
	      var dom = editor.dom;
	      var validFormats = filter(keys(formatter.get()), function (formatName) {
	        return formatName !== name && !contains$1(formatName, 'removeformat');
	      });
	      var matchedFormats = matchAllOnNode(editor, formatNode, validFormats);
	      var uniqueFormats = filter(matchedFormats, function (fmtName) {
	        return !areSimilarFormats(editor, fmtName, name);
	      });
	      if (uniqueFormats.length > 0) {
	        var clonedFormatNode = formatNode.cloneNode(false);
	        dom.add(caretContainer, clonedFormatNode);
	        formatter.remove(name, vars, clonedFormatNode, similar);
	        dom.remove(clonedFormatNode);
	        return Optional.some(clonedFormatNode);
	      } else {
	        return Optional.none();
	      }
	    };
	    var applyCaretFormat = function (editor, name, vars) {
	      var caretContainer, textNode;
	      var selection = editor.selection;
	      var selectionRng = selection.getRng();
	      var offset = selectionRng.startOffset;
	      var container = selectionRng.startContainer;
	      var text = container.nodeValue;
	      caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
	      if (caretContainer) {
	        textNode = findFirstTextNode(caretContainer);
	      }
	      var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
	      if (text && offset > 0 && offset < text.length && wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
	        var bookmark = selection.getBookmark();
	        selectionRng.collapse(true);
	        var rng = expandRng(editor, selectionRng, editor.formatter.get(name));
	        rng = split$1(rng);
	        editor.formatter.apply(name, vars, rng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        if (!caretContainer || textNode.nodeValue !== ZWSP$1) {
	          caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom);
	          textNode = caretContainer.firstChild;
	          selectionRng.insertNode(caretContainer);
	          offset = 1;
	          editor.formatter.apply(name, vars, caretContainer);
	        } else {
	          editor.formatter.apply(name, vars, caretContainer);
	        }
	        selection.setCursorLocation(textNode, offset);
	      }
	    };
	    var removeCaretFormat = function (editor, name, vars, similar) {
	      var dom = editor.dom;
	      var selection = editor.selection;
	      var hasContentAfter, node, formatNode;
	      var parents = [];
	      var rng = selection.getRng();
	      var container = rng.startContainer;
	      var offset = rng.startOffset;
	      node = container;
	      if (container.nodeType === 3) {
	        if (offset !== container.nodeValue.length) {
	          hasContentAfter = true;
	        }
	        node = node.parentNode;
	      }
	      while (node) {
	        if (matchNode(editor, node, name, vars, similar)) {
	          formatNode = node;
	          break;
	        }
	        if (node.nextSibling) {
	          hasContentAfter = true;
	        }
	        parents.push(node);
	        node = node.parentNode;
	      }
	      if (!formatNode) {
	        return;
	      }
	      if (hasContentAfter) {
	        var bookmark = selection.getBookmark();
	        rng.collapse(true);
	        var expandedRng = expandRng(editor, rng, editor.formatter.get(name), true);
	        expandedRng = split$1(expandedRng);
	        editor.formatter.remove(name, vars, expandedRng, similar);
	        selection.moveToBookmark(bookmark);
	      } else {
	        var caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
	        var newCaretContainer = createCaretContainer(false).dom;
	        insertCaretContainerNode(editor, newCaretContainer, caretContainer !== null ? caretContainer : formatNode);
	        var cleanedFormatNode = cleanFormatNode(editor, newCaretContainer, formatNode, name, vars, similar);
	        var caretTextNode = insertFormatNodesIntoCaretContainer(parents.concat(cleanedFormatNode.toArray()), newCaretContainer);
	        removeCaretContainerNode(editor, caretContainer, false);
	        selection.setCursorLocation(caretTextNode, 1);
	        if (dom.isEmpty(formatNode)) {
	          dom.remove(formatNode);
	        }
	      }
	    };
	    var disableCaretContainer = function (editor, keyCode) {
	      var selection = editor.selection, body = editor.getBody();
	      removeCaretContainer(editor, null, false);
	      if ((keyCode === 8 || keyCode === 46) && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP$1) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	      if (keyCode === 37 || keyCode === 39) {
	        removeCaretContainer(editor, getParentCaretContainer(body, selection.getStart()));
	      }
	    };
	    var setup$3 = function (editor) {
	      editor.on('mouseup keydown', function (e) {
	        disableCaretContainer(editor, e.keyCode);
	      });
	    };
	    var replaceWithCaretFormat = function (targetNode, formatNodes) {
	      var caretContainer = createCaretContainer(false);
	      var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom);
	      before(SugarElement.fromDom(targetNode), caretContainer);
	      remove(SugarElement.fromDom(targetNode));
	      return CaretPosition(innerMost, 0);
	    };
	    var isFormatElement = function (editor, element) {
	      var inlineElements = editor.schema.getTextInlineElements();
	      return inlineElements.hasOwnProperty(name(element)) && !isCaretNode(element.dom) && !isBogus(element.dom);
	    };
	    var isEmptyCaretFormatElement = function (element) {
	      return isCaretNode(element.dom) && isCaretContainerEmpty(element.dom);
	    };
	
	    var postProcessHooks = {};
	    var filter$4 = filter$2;
	    var each$8 = each$2;
	    var addPostProcessHook = function (name, hook) {
	      var hooks = postProcessHooks[name];
	      if (!hooks) {
	        postProcessHooks[name] = [];
	      }
	      postProcessHooks[name].push(hook);
	    };
	    var postProcess = function (name, editor) {
	      each$8(postProcessHooks[name], function (hook) {
	        hook(editor);
	      });
	    };
	    addPostProcessHook('pre', function (editor) {
	      var rng = editor.selection.getRng();
	      var blocks;
	      var hasPreSibling = function (pre) {
	        return isPre(pre.previousSibling) && indexOf$1(blocks, pre.previousSibling) !== -1;
	      };
	      var joinPre = function (pre1, pre2) {
	        DomQuery(pre2).remove();
	        DomQuery(pre1).append('<br><br>').append(pre2.childNodes);
	      };
	      var isPre = matchNodeNames(['pre']);
	      if (!rng.collapsed) {
	        blocks = editor.selection.getSelectedBlocks();
	        each$8(filter$4(filter$4(blocks, isPre), hasPreSibling), function (pre) {
	          joinPre(pre.previousSibling, pre);
	        });
	      }
	    });
	
	    var each$9 = Tools.each;
	    var isElementNode = function (node) {
	      return isElement$1(node) && !isBookmarkNode$1(node) && !isCaretNode(node) && !isBogus(node);
	    };
	    var findElementSibling = function (node, siblingName) {
	      var sibling;
	      for (sibling = node; sibling; sibling = sibling[siblingName]) {
	        if (isText$1(sibling) && sibling.nodeValue.length !== 0) {
	          return node;
	        }
	        if (isElement$1(sibling) && !isBookmarkNode$1(sibling)) {
	          return sibling;
	        }
	      }
	      return node;
	    };
	    var mergeSiblingsNodes = function (dom, prev, next) {
	      var sibling, tmpSibling;
	      var elementUtils = ElementUtils(dom);
	      if (prev && next) {
	        prev = findElementSibling(prev, 'previousSibling');
	        next = findElementSibling(next, 'nextSibling');
	        if (elementUtils.compare(prev, next)) {
	          for (sibling = prev.nextSibling; sibling && sibling !== next;) {
	            tmpSibling = sibling;
	            sibling = sibling.nextSibling;
	            prev.appendChild(tmpSibling);
	          }
	          dom.remove(next);
	          Tools.each(Tools.grep(next.childNodes), function (node) {
	            prev.appendChild(node);
	          });
	          return prev;
	        }
	      }
	      return next;
	    };
	    var mergeSiblings = function (dom, format, vars, node) {
	      if (node && format.merge_siblings !== false) {
	        var newNode = mergeSiblingsNodes(dom, getNonWhiteSpaceSibling(node), node);
	        mergeSiblingsNodes(dom, newNode, getNonWhiteSpaceSibling(newNode, true));
	      }
	    };
	    var clearChildStyles = function (dom, format, node) {
	      if (format.clear_child_styles) {
	        var selector = format.links ? '*:not(a)' : '*';
	        each$9(dom.select(selector, node), function (node) {
	          if (isElementNode(node)) {
	            each$9(format.styles, function (value, name) {
	              dom.setStyle(node, name, '');
	            });
	          }
	        });
	      }
	    };
	    var processChildElements = function (node, filter, process) {
	      each$9(node.childNodes, function (node) {
	        if (isElementNode(node)) {
	          if (filter(node)) {
	            process(node);
	          }
	          if (node.hasChildNodes()) {
	            processChildElements(node, filter, process);
	          }
	        }
	      });
	    };
	    var unwrapEmptySpan = function (dom, node) {
	      if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
	        dom.remove(node, true);
	      }
	    };
	    var hasStyle = function (dom, name) {
	      return function (node) {
	        return !!(node && getStyle(dom, node, name));
	      };
	    };
	    var applyStyle = function (dom, name, value) {
	      return function (node) {
	        dom.setStyle(node, name, value);
	        if (node.getAttribute('style') === '') {
	          node.removeAttribute('style');
	        }
	        unwrapEmptySpan(dom, node);
	      };
	    };
	
	    var removeResult = Adt.generate([
	      { keep: [] },
	      { rename: ['name'] },
	      { removed: [] }
	    ]);
	    var MCE_ATTR_RE = /^(src|href|style)$/;
	    var each$a = Tools.each;
	    var isEq$3 = isEq;
	    var isTableCellOrRow = function (node) {
	      return /^(TR|TH|TD)$/.test(node.nodeName);
	    };
	    var isChildOfInlineParent = function (dom, node, parent) {
	      return dom.isChildOf(node, parent) && node !== parent && !dom.isBlock(parent);
	    };
	    var getContainer = function (ed, rng, start) {
	      var container, offset;
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	      if (isElement$1(container)) {
	        var lastIdx = container.childNodes.length - 1;
	        if (!start && offset) {
	          offset--;
	        }
	        container = container.childNodes[offset > lastIdx ? lastIdx : offset];
	      }
	      if (isText$1(container) && start && offset >= container.nodeValue.length) {
	        container = new DomTreeWalker(container, ed.getBody()).next() || container;
	      }
	      if (isText$1(container) && !start && offset === 0) {
	        container = new DomTreeWalker(container, ed.getBody()).prev() || container;
	      }
	      return container;
	    };
	    var normalizeTableSelection = function (node, start) {
	      var prop = start ? 'firstChild' : 'lastChild';
	      if (isTableCellOrRow(node) && node[prop]) {
	        var childNode = node[prop];
	        if (node.nodeName === 'TR') {
	          return childNode[prop] || childNode;
	        } else {
	          return childNode;
	        }
	      }
	      return node;
	    };
	    var wrap$2 = function (dom, node, name, attrs) {
	      var wrapper = dom.create(name, attrs);
	      node.parentNode.insertBefore(wrapper, node);
	      wrapper.appendChild(node);
	      return wrapper;
	    };
	    var wrapWithSiblings = function (dom, node, next, name, attrs) {
	      var start = SugarElement.fromDom(node);
	      var wrapper = SugarElement.fromDom(dom.create(name, attrs));
	      var siblings = next ? nextSiblings(start) : prevSiblings(start);
	      append$1(wrapper, siblings);
	      if (next) {
	        before(start, wrapper);
	        prepend(wrapper, start);
	      } else {
	        after(start, wrapper);
	        append(wrapper, start);
	      }
	      return wrapper.dom;
	    };
	    var matchName$1 = function (dom, node, format) {
	      if (isEq$3(node, format.inline)) {
	        return true;
	      }
	      if (isEq$3(node, format.block)) {
	        return true;
	      }
	      if (format.selector) {
	        return isElement$1(node) && dom.is(node, format.selector);
	      }
	    };
	    var isColorFormatAndAnchor = function (node, format) {
	      return format.links && node.nodeName === 'A';
	    };
	    var find$3 = function (dom, node, next, inc) {
	      node = getNonWhiteSpaceSibling(node, next, inc);
	      return !node || (node.nodeName === 'BR' || dom.isBlock(node));
	    };
	    var removeNode$1 = function (ed, node, format) {
	      var parentNode = node.parentNode;
	      var rootBlockElm;
	      var dom = ed.dom, forcedRootBlock = getForcedRootBlock(ed);
	      if (format.block) {
	        if (!forcedRootBlock) {
	          if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
	            if (!find$3(dom, node, false) && !find$3(dom, node.firstChild, true, true)) {
	              node.insertBefore(dom.create('br'), node.firstChild);
	            }
	            if (!find$3(dom, node, true) && !find$3(dom, node.lastChild, false, true)) {
	              node.appendChild(dom.create('br'));
	            }
	          }
	        } else {
	          if (parentNode === dom.getRoot()) {
	            if (!format.list_block || !isEq$3(node, format.list_block)) {
	              each(from$1(node.childNodes), function (node) {
	                if (isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
	                  if (!rootBlockElm) {
	                    rootBlockElm = wrap$2(dom, node, forcedRootBlock);
	                    dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
	                  } else {
	                    rootBlockElm.appendChild(node);
	                  }
	                } else {
	                  rootBlockElm = 0;
	                }
	              });
	            }
	          }
	        }
	      }
	      if (format.selector && format.inline && !isEq$3(format.inline, node)) {
	        return;
	      }
	      dom.remove(node, true);
	    };
	    var removeFormatInternal = function (ed, format, vars, node, compareNode) {
	      var stylesModified;
	      var dom = ed.dom;
	      if (!matchName$1(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
	        return removeResult.keep();
	      }
	      var elm = node;
	      if (format.inline && format.remove === 'all' && isArray(format.preserve_attributes)) {
	        var attrsToPreserve = filter(dom.getAttribs(elm), function (attr) {
	          return contains(format.preserve_attributes, attr.name.toLowerCase());
	        });
	        dom.removeAllAttribs(elm);
	        each(attrsToPreserve, function (attr) {
	          return dom.setAttrib(elm, attr.name, attr.value);
	        });
	        if (attrsToPreserve.length > 0) {
	          return removeResult.rename('span');
	        }
	      }
	      if (format.remove !== 'all') {
	        each$a(format.styles, function (value, name) {
	          value = normalizeStyleValue(dom, replaceVars(value, vars), name + '');
	          if (isNumber(name)) {
	            name = value;
	            compareNode = null;
	          }
	          if (format.remove_similar || (!compareNode || isEq$3(getStyle(dom, compareNode, name), value))) {
	            dom.setStyle(elm, name, '');
	          }
	          stylesModified = true;
	        });
	        if (stylesModified && dom.getAttrib(elm, 'style') === '') {
	          elm.removeAttribute('style');
	          elm.removeAttribute('data-mce-style');
	        }
	        each$a(format.attributes, function (value, name) {
	          var valueOut;
	          value = replaceVars(value, vars);
	          if (isNumber(name)) {
	            name = value;
	            compareNode = null;
	          }
	          if (format.remove_similar || (!compareNode || isEq$3(dom.getAttrib(compareNode, name), value))) {
	            if (name === 'class') {
	              value = dom.getAttrib(elm, name);
	              if (value) {
	                valueOut = '';
	                each(value.split(/\s+/), function (cls) {
	                  if (/mce\-\w+/.test(cls)) {
	                    valueOut += (valueOut ? ' ' : '') + cls;
	                  }
	                });
	                if (valueOut) {
	                  dom.setAttrib(elm, name, valueOut);
	                  return;
	                }
	              }
	            }
	            if (name === 'class') {
	              elm.removeAttribute('className');
	            }
	            if (MCE_ATTR_RE.test(name)) {
	              elm.removeAttribute('data-mce-' + name);
	            }
	            elm.removeAttribute(name);
	          }
	        });
	        each$a(format.classes, function (value) {
	          value = replaceVars(value, vars);
	          if (!compareNode || dom.hasClass(compareNode, value)) {
	            dom.removeClass(elm, value);
	          }
	        });
	        var attrs = dom.getAttribs(elm);
	        for (var i = 0; i < attrs.length; i++) {
	          var attrName = attrs[i].nodeName;
	          if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
	            return removeResult.keep();
	          }
	        }
	      }
	      if (format.remove !== 'none') {
	        removeNode$1(ed, elm, format);
	        return removeResult.removed();
	      }
	      return removeResult.keep();
	    };
	    var removeFormat = function (ed, format, vars, node, compareNode) {
	      return removeFormatInternal(ed, format, vars, node, compareNode).fold(never, function (newName) {
	        ed.dom.rename(node, newName);
	        return true;
	      }, always);
	    };
	    var findFormatRoot = function (editor, container, name, vars, similar) {
	      var formatRoot;
	      each(getParents$1(editor.dom, container.parentNode).reverse(), function (parent) {
	        if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
	          var format = matchNode(editor, parent, name, vars, similar);
	          if (format && format.split !== false) {
	            formatRoot = parent;
	          }
	        }
	      });
	      return formatRoot;
	    };
	    var removeFormatFromClone = function (editor, format, vars, clone) {
	      return removeFormatInternal(editor, format, vars, clone, clone).fold(constant(clone), function (newName) {
	        var fragment = editor.dom.createFragment();
	        fragment.appendChild(clone);
	        return editor.dom.rename(clone, newName);
	      }, constant(null));
	    };
	    var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
	      var clone, lastClone, firstClone;
	      var dom = editor.dom;
	      if (formatRoot) {
	        var formatRootParent = formatRoot.parentNode;
	        for (var parent_1 = container.parentNode; parent_1 && parent_1 !== formatRootParent; parent_1 = parent_1.parentNode) {
	          clone = dom.clone(parent_1, false);
	          for (var i = 0; i < formatList.length; i++) {
	            clone = removeFormatFromClone(editor, formatList[i], vars, clone);
	            if (clone === null) {
	              break;
	            }
	          }
	          if (clone) {
	            if (lastClone) {
	              clone.appendChild(lastClone);
	            }
	            if (!firstClone) {
	              firstClone = clone;
	            }
	            lastClone = clone;
	          }
	        }
	        if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
	          container = dom.split(formatRoot, container);
	        }
	        if (lastClone) {
	          target.parentNode.insertBefore(lastClone, target);
	          firstClone.appendChild(target);
	          if (format.inline) {
	            mergeSiblings(dom, format, vars, lastClone);
	          }
	        }
	      }
	      return container;
	    };
	    var remove$6 = function (ed, name, vars, node, similar) {
	      var formatList = ed.formatter.get(name);
	      var format = formatList[0];
	      var contentEditable = true;
	      var dom = ed.dom;
	      var selection = ed.selection;
	      var splitToFormatRoot = function (container) {
	        var formatRoot = findFormatRoot(ed, container, name, vars, similar);
	        return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
	      };
	      var isRemoveBookmarkNode = function (node) {
	        return isBookmarkNode$1(node) && isElement$1(node) && (node.id === '_start' || node.id === '_end');
	      };
	      var process = function (node) {
	        var lastContentEditable, hasContentEditableState;
	        var parentNode = node.parentNode;
	        if (isText$1(node) && hasBlockChildren(dom, parentNode)) {
	          removeFormat(ed, format, vars, parentNode, parentNode);
	        }
	        if (isElement$1(node) && dom.getContentEditable(node)) {
	          lastContentEditable = contentEditable;
	          contentEditable = dom.getContentEditable(node) === 'true';
	          hasContentEditableState = true;
	        }
	        var children = from$1(node.childNodes);
	        if (contentEditable && !hasContentEditableState) {
	          for (var i = 0; i < formatList.length; i++) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        if (format.deep) {
	          if (children.length) {
	            for (var i = 0; i < children.length; i++) {
	              process(children[i]);
	            }
	            if (hasContentEditableState) {
	              contentEditable = lastContentEditable;
	            }
	          }
	        }
	      };
	      var unwrap = function (start) {
	        var node = dom.get(start ? '_start' : '_end');
	        var out = node[start ? 'firstChild' : 'lastChild'];
	        if (isRemoveBookmarkNode(out)) {
	          out = out[start ? 'firstChild' : 'lastChild'];
	        }
	        if (isText$1(out) && out.data.length === 0) {
	          out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
	        }
	        dom.remove(node, true);
	        return out;
	      };
	      var removeRngStyle = function (rng) {
	        var startContainer, endContainer;
	        var expandedRng = expandRng(ed, rng, formatList, rng.collapsed);
	        if (format.split) {
	          expandedRng = split$1(expandedRng);
	          startContainer = getContainer(ed, expandedRng, true);
	          endContainer = getContainer(ed, expandedRng);
	          if (startContainer !== endContainer) {
	            startContainer = normalizeTableSelection(startContainer, true);
	            endContainer = normalizeTableSelection(endContainer, false);
	            if (isChildOfInlineParent(dom, startContainer, endContainer)) {
	              var marker = Optional.from(startContainer.firstChild).getOr(startContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, true, 'span', {
	                'id': '_start',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(true);
	              return;
	            }
	            if (isChildOfInlineParent(dom, endContainer, startContainer)) {
	              var marker = Optional.from(endContainer.lastChild).getOr(endContainer);
	              splitToFormatRoot(wrapWithSiblings(dom, marker, false, 'span', {
	                'id': '_end',
	                'data-mce-type': 'bookmark'
	              }));
	              unwrap(false);
	              return;
	            }
	            startContainer = wrap$2(dom, startContainer, 'span', {
	              'id': '_start',
	              'data-mce-type': 'bookmark'
	            });
	            endContainer = wrap$2(dom, endContainer, 'span', {
	              'id': '_end',
	              'data-mce-type': 'bookmark'
	            });
	            var newRng = dom.createRng();
	            newRng.setStartAfter(startContainer);
	            newRng.setEndBefore(endContainer);
	            walk$1(dom, newRng, function (nodes) {
	              each(nodes, function (n) {
	                if (!isBookmarkNode$1(n) && !isBookmarkNode$1(n.parentNode)) {
	                  splitToFormatRoot(n);
	                }
	              });
	            });
	            splitToFormatRoot(startContainer);
	            splitToFormatRoot(endContainer);
	            startContainer = unwrap(true);
	            endContainer = unwrap();
	          } else {
	            startContainer = endContainer = splitToFormatRoot(startContainer);
	          }
	          expandedRng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
	          expandedRng.startOffset = dom.nodeIndex(startContainer);
	          expandedRng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
	          expandedRng.endOffset = dom.nodeIndex(endContainer) + 1;
	        }
	        walk$1(dom, expandedRng, function (nodes) {
	          each(nodes, function (node) {
	            process(node);
	            var textDecorations = [
	              'underline',
	              'line-through',
	              'overline'
	            ];
	            each(textDecorations, function (decoration) {
	              if (isElement$1(node) && ed.dom.getStyle(node, 'text-decoration') === decoration && node.parentNode && getTextDecoration(dom, node.parentNode) === decoration) {
	                removeFormat(ed, {
	                  deep: false,
	                  exact: true,
	                  inline: 'span',
	                  styles: { textDecoration: decoration }
	                }, null, node);
	              }
	            });
	          });
	        });
	      };
	      if (node) {
	        if (isNode(node)) {
	          var rng = dom.createRng();
	          rng.setStartBefore(node);
	          rng.setEndAfter(node);
	          removeRngStyle(rng);
	        } else {
	          removeRngStyle(node);
	        }
	        return;
	      }
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0; i < formatList.length; i++) {
	          if (formatList[i].ceFalseOverride) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	        return;
	      }
	      if (!selection.isCollapsed() || !format.inline || getCellsFromEditor(ed).length) {
	        preserve(selection, true, function () {
	          runOnRanges(ed, removeRngStyle);
	        });
	        if (format.inline && match(ed, name, vars, selection.getStart())) {
	          moveStart(dom, selection, selection.getRng());
	        }
	        ed.nodeChanged();
	      } else {
	        removeCaretFormat(ed, name, vars, similar);
	      }
	    };
	
	    var each$b = Tools.each;
	    var mergeTextDecorationsAndColor = function (dom, format, vars, node) {
	      var processTextDecorationsAndColor = function (n) {
	        if (n.nodeType === 1 && n.parentNode && n.parentNode.nodeType === 1) {
	          var textDecoration = getTextDecoration(dom, n.parentNode);
	          if (dom.getStyle(n, 'color') && textDecoration) {
	            dom.setStyle(n, 'text-decoration', textDecoration);
	          } else if (dom.getStyle(n, 'text-decoration') === textDecoration) {
	            dom.setStyle(n, 'text-decoration', null);
	          }
	        }
	      };
	      if (format.styles && (format.styles.color || format.styles.textDecoration)) {
	        Tools.walk(node, processTextDecorationsAndColor, 'childNodes');
	        processTextDecorationsAndColor(node);
	      }
	    };
	    var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
	      if (format.styles && format.styles.backgroundColor) {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'backgroundColor', replaceVars(format.styles.backgroundColor, vars)));
	      }
	    };
	    var mergeSubSup = function (dom, format, vars, node) {
	      if (format.inline === 'sub' || format.inline === 'sup') {
	        processChildElements(node, hasStyle(dom, 'fontSize'), applyStyle(dom, 'fontSize', ''));
	        dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
	      }
	    };
	    var mergeWithChildren = function (editor, formatList, vars, node) {
	      each$b(formatList, function (format) {
	        each$b(editor.dom.select(format.inline, node), function (child) {
	          if (!isElementNode(child)) {
	            return;
	          }
	          removeFormat(editor, format, vars, child, format.exact ? child : null);
	        });
	        clearChildStyles(editor.dom, format, node);
	      });
	    };
	    var mergeWithParents = function (editor, format, name, vars, node) {
	      if (matchNode(editor, node.parentNode, name, vars)) {
	        if (removeFormat(editor, format, vars, node)) {
	          return;
	        }
	      }
	      if (format.merge_with_parents) {
	        editor.dom.getParent(node.parentNode, function (parent) {
	          if (matchNode(editor, parent, name, vars)) {
	            removeFormat(editor, format, vars, node);
	            return true;
	          }
	        });
	      }
	    };
	
	    var each$c = Tools.each;
	    var hasFormatProperty = function (format, prop) {
	      return hasNonNullableKey(format, prop);
	    };
	    var isElementNode$1 = function (node) {
	      return node && node.nodeType === 1 && !isBookmarkNode$1(node) && !isCaretNode(node) && !isBogus(node);
	    };
	    var canFormatBR = function (editor, format, node, parentName) {
	      if (canFormatEmptyLines(editor) && isInlineFormat(format)) {
	        var validBRParentElements = __assign(__assign({}, editor.schema.getTextBlockElements()), {
	          td: {},
	          th: {},
	          li: {},
	          dt: {},
	          dd: {},
	          figcaption: {},
	          caption: {},
	          details: {},
	          summary: {}
	        });
	        var hasCaretNodeSibling = sibling$2(SugarElement.fromDom(node), function (sibling) {
	          return isCaretNode(sibling.dom);
	        });
	        return hasNonNullableKey(validBRParentElements, parentName) && isEmpty(SugarElement.fromDom(node.parentNode), false) && !hasCaretNodeSibling;
	      } else {
	        return false;
	      }
	    };
	    var applyFormat = function (ed, name, vars, node) {
	      var formatList = ed.formatter.get(name);
	      var format = formatList[0];
	      var isCollapsed = !node && ed.selection.isCollapsed();
	      var dom = ed.dom;
	      var selection = ed.selection;
	      var setElementFormat = function (elm, fmt) {
	        fmt = fmt || format;
	        if (elm) {
	          if (fmt.onformat) {
	            fmt.onformat(elm, fmt, vars, node);
	          }
	          each$c(fmt.styles, function (value, name) {
	            dom.setStyle(elm, name, replaceVars(value, vars));
	          });
	          if (fmt.styles) {
	            var styleVal = dom.getAttrib(elm, 'style');
	            if (styleVal) {
	              dom.setAttrib(elm, 'data-mce-style', styleVal);
	            }
	          }
	          each$c(fmt.attributes, function (value, name) {
	            dom.setAttrib(elm, name, replaceVars(value, vars));
	          });
	          each$c(fmt.classes, function (value) {
	            value = replaceVars(value, vars);
	            if (!dom.hasClass(elm, value)) {
	              dom.addClass(elm, value);
	            }
	          });
	        }
	      };
	      var applyNodeStyle = function (formatList, node) {
	        var found = false;
	        if (!isSelectorFormat(format)) {
	          return false;
	        }
	        each$c(formatList, function (format) {
	          if ('collapsed' in format && format.collapsed !== isCollapsed) {
	            return;
	          }
	          if (dom.is(node, format.selector) && !isCaretNode(node)) {
	            setElementFormat(node, format);
	            found = true;
	            return false;
	          }
	        });
	        return found;
	      };
	      var applyRngStyle = function (dom, rng, bookmark, nodeSpecific) {
	        var newWrappers = [];
	        var contentEditable = true;
	        var wrapName = format.inline || format.block;
	        var wrapElm = dom.create(wrapName);
	        setElementFormat(wrapElm);
	        walk$1(dom, rng, function (nodes) {
	          var currentWrapElm;
	          var process = function (node) {
	            var hasContentEditableState = false;
	            var lastContentEditable = contentEditable;
	            var nodeName = node.nodeName.toLowerCase();
	            var parentName = node.parentNode.nodeName.toLowerCase();
	            if (isElement$1(node) && dom.getContentEditable(node)) {
	              lastContentEditable = contentEditable;
	              contentEditable = dom.getContentEditable(node) === 'true';
	              hasContentEditableState = true;
	            }
	            if (isBr(node) && !canFormatBR(ed, format, node, parentName)) {
	              currentWrapElm = null;
	              if (isBlockFormat(format)) {
	                dom.remove(node);
	              }
	              return;
	            }
	            if (format.wrapper && matchNode(ed, node, name, vars)) {
	              currentWrapElm = null;
	              return;
	            }
	            if (contentEditable && !hasContentEditableState && isBlockFormat(format) && !format.wrapper && isTextBlock$1(ed, nodeName) && isValid(ed, parentName, wrapName)) {
	              var elm = dom.rename(node, wrapName);
	              setElementFormat(elm);
	              newWrappers.push(elm);
	              currentWrapElm = null;
	              return;
	            }
	            if (isSelectorFormat(format)) {
	              var found = applyNodeStyle(formatList, node);
	              if (isText$1(node) && hasBlockChildren(dom, node.parentNode)) {
	                applyNodeStyle(formatList, node.parentNode);
	              }
	              if (!hasFormatProperty(format, 'inline') || found) {
	                currentWrapElm = null;
	                return;
	              }
	            }
	            if (contentEditable && !hasContentEditableState && isValid(ed, wrapName, nodeName) && isValid(ed, parentName, wrapName) && !(!nodeSpecific && node.nodeType === 3 && node.nodeValue.length === 1 && node.nodeValue.charCodeAt(0) === 65279) && !isCaretNode(node) && (!hasFormatProperty(format, 'inline') || !dom.isBlock(node))) {
	              if (!currentWrapElm) {
	                currentWrapElm = dom.clone(wrapElm, false);
	                node.parentNode.insertBefore(currentWrapElm, node);
	                newWrappers.push(currentWrapElm);
	              }
	              currentWrapElm.appendChild(node);
	            } else {
	              currentWrapElm = null;
	              each$c(Tools.grep(node.childNodes), process);
	              if (hasContentEditableState) {
	                contentEditable = lastContentEditable;
	              }
	              currentWrapElm = null;
	            }
	          };
	          each$c(nodes, process);
	        });
	        if (format.links === true) {
	          each$c(newWrappers, function (node) {
	            var process = function (node) {
	              if (node.nodeName === 'A') {
	                setElementFormat(node, format);
	              }
	              each$c(Tools.grep(node.childNodes), process);
	            };
	            process(node);
	          });
	        }
	        each$c(newWrappers, function (node) {
	          var getChildCount = function (node) {
	            var count = 0;
	            each$c(node.childNodes, function (node) {
	              if (!isEmptyTextNode(node) && !isBookmarkNode$1(node)) {
	                count++;
	              }
	            });
	            return count;
	          };
	          var getChildElementNode = function (root) {
	            var child = false;
	            each$c(root.childNodes, function (node) {
	              if (isElementNode$1(node)) {
	                child = node;
	                return false;
	              }
	            });
	            return child;
	          };
	          var mergeStyles = function (node) {
	            var clone;
	            var child = getChildElementNode(node);
	            if (child && !isBookmarkNode$1(child) && matchName(dom, child, format)) {
	              clone = dom.clone(child, false);
	              setElementFormat(clone);
	              dom.replace(clone, node, true);
	              dom.remove(child, true);
	            }
	            return clone || node;
	          };
	          var childCount = getChildCount(node);
	          if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
	            dom.remove(node, true);
	            return;
	          }
	          if (isInlineFormat(format) || format.wrapper) {
	            if (!format.exact && childCount === 1) {
	              node = mergeStyles(node);
	            }
	            mergeWithChildren(ed, formatList, vars, node);
	            mergeWithParents(ed, format, name, vars, node);
	            mergeBackgroundColorAndFontSize(dom, format, vars, node);
	            mergeTextDecorationsAndColor(dom, format, vars, node);
	            mergeSubSup(dom, format, vars, node);
	            mergeSiblings(dom, format, vars, node);
	          }
	        });
	      };
	      if (dom.getContentEditable(selection.getNode()) === 'false') {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          var formatItem = formatList[i];
	          if (formatItem.ceFalseOverride && isSelectorFormat(formatItem) && dom.is(node, formatItem.selector)) {
	            setElementFormat(node, formatItem);
	            return;
	          }
	        }
	        return;
	      }
	      if (format) {
	        if (node) {
	          if (isNode(node)) {
	            if (!applyNodeStyle(formatList, node)) {
	              var rng = dom.createRng();
	              rng.setStartBefore(node);
	              rng.setEndAfter(node);
	              applyRngStyle(dom, expandRng(ed, rng, formatList), null, true);
	            }
	          } else {
	            applyRngStyle(dom, node, null, true);
	          }
	        } else {
	          if (!isCollapsed || !isInlineFormat(format) || getCellsFromEditor(ed).length) {
	            var curSelNode = selection.getNode();
	            var firstFormat = formatList[0];
	            if (!ed.settings.forced_root_block && firstFormat.defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
	              applyFormat(ed, firstFormat.defaultBlock);
	            }
	            selection.setRng(normalize$2(selection.getRng()));
	            preserve(selection, true, function (bookmark) {
	              runOnRanges(ed, function (selectionRng, fake) {
	                var expandedRng = fake ? selectionRng : expandRng(ed, selectionRng, formatList);
	                applyRngStyle(dom, expandedRng);
	              });
	            });
	            moveStart(dom, selection, selection.getRng());
	            ed.nodeChanged();
	          } else {
	            applyCaretFormat(ed, name, vars);
	          }
	        }
	        postProcess(name, ed);
	      }
	    };
	
	    var setup$4 = function (registeredFormatListeners, editor) {
	      var currentFormats = Cell({});
	      registeredFormatListeners.set({});
	      editor.on('NodeChange', function (e) {
	        updateAndFireChangeCallbacks(editor, e.element, currentFormats, registeredFormatListeners.get());
	      });
	    };
	    var updateAndFireChangeCallbacks = function (editor, elm, currentFormats, formatChangeData) {
	      var formatsList = keys(currentFormats.get());
	      var newFormats = {};
	      var matchedFormats = {};
	      var parents = filter(getParents$1(editor.dom, elm), function (node) {
	        return node.nodeType === 1 && !node.getAttribute('data-mce-bogus');
	      });
	      each$1(formatChangeData, function (data, format) {
	        Tools.each(parents, function (node) {
	          if (editor.formatter.matchNode(node, format, {}, data.similar)) {
	            if (formatsList.indexOf(format) === -1) {
	              each(data.callbacks, function (callback) {
	                callback(true, {
	                  node: node,
	                  format: format,
	                  parents: parents
	                });
	              });
	              newFormats[format] = data.callbacks;
	            }
	            matchedFormats[format] = data.callbacks;
	            return false;
	          }
	          if (matchesUnInheritedFormatSelector(editor, node, format)) {
	            return false;
	          }
	        });
	      });
	      var remainingFormats = filterRemainingFormats(currentFormats.get(), matchedFormats, elm, parents);
	      currentFormats.set(__assign(__assign({}, newFormats), remainingFormats));
	    };
	    var filterRemainingFormats = function (currentFormats, matchedFormats, elm, parents) {
	      return bifilter(currentFormats, function (callbacks, format) {
	        if (!has(matchedFormats, format)) {
	          each(callbacks, function (callback) {
	            callback(false, {
	              node: elm,
	              format: format,
	              parents: parents
	            });
	          });
	          return false;
	        } else {
	          return true;
	        }
	      }).t;
	    };
	    var addListeners = function (registeredFormatListeners, formats, callback, similar) {
	      var formatChangeItems = registeredFormatListeners.get();
	      each(formats.split(','), function (format) {
	        if (!formatChangeItems[format]) {
	          formatChangeItems[format] = {
	            similar: similar,
	            callbacks: []
	          };
	        }
	        formatChangeItems[format].callbacks.push(callback);
	      });
	      registeredFormatListeners.set(formatChangeItems);
	    };
	    var removeListeners = function (registeredFormatListeners, formats, callback) {
	      var formatChangeItems = registeredFormatListeners.get();
	      each(formats.split(','), function (format) {
	        formatChangeItems[format].callbacks = filter(formatChangeItems[format].callbacks, function (c) {
	          return c !== callback;
	        });
	        if (formatChangeItems[format].callbacks.length === 0) {
	          delete formatChangeItems[format];
	        }
	      });
	      registeredFormatListeners.set(formatChangeItems);
	    };
	    var formatChangedInternal = function (editor, registeredFormatListeners, formats, callback, similar) {
	      if (registeredFormatListeners.get() === null) {
	        setup$4(registeredFormatListeners, editor);
	      }
	      addListeners(registeredFormatListeners, formats, callback, similar);
	      return {
	        unbind: function () {
	          return removeListeners(registeredFormatListeners, formats, callback);
	        }
	      };
	    };
	
	    var toggle = function (editor, name, vars, node) {
	      var fmt = editor.formatter.get(name);
	      if (match(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
	        remove$6(editor, name, vars, node);
	      } else {
	        applyFormat(editor, name, vars, node);
	      }
	    };
	
	    var fromElements = function (elements, scope) {
	      var doc = scope || document;
	      var fragment = doc.createDocumentFragment();
	      each(elements, function (element) {
	        fragment.appendChild(element.dom);
	      });
	      return SugarElement.fromDom(fragment);
	    };
	
	    var tableModel = function (element, width, rows) {
	      return {
	        element: element,
	        width: width,
	        rows: rows
	      };
	    };
	    var tableRow = function (element, cells) {
	      return {
	        element: element,
	        cells: cells
	      };
	    };
	    var cellPosition = function (x, y) {
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var getSpan = function (td, key) {
	      var value = parseInt(get$4(td, key), 10);
	      return isNaN(value) ? 1 : value;
	    };
	    var fillout = function (table, x, y, tr, td) {
	      var rowspan = getSpan(td, 'rowspan');
	      var colspan = getSpan(td, 'colspan');
	      var rows = table.rows;
	      for (var y2 = y; y2 < y + rowspan; y2++) {
	        if (!rows[y2]) {
	          rows[y2] = tableRow(deep(tr), []);
	        }
	        for (var x2 = x; x2 < x + colspan; x2++) {
	          var cells = rows[y2].cells;
	          cells[x2] = y2 === y && x2 === x ? td : shallow(td);
	        }
	      }
	    };
	    var cellExists = function (table, x, y) {
	      var rows = table.rows;
	      var cells = rows[y] ? rows[y].cells : [];
	      return !!cells[x];
	    };
	    var skipCellsX = function (table, x, y) {
	      while (cellExists(table, x, y)) {
	        x++;
	      }
	      return x;
	    };
	    var getWidth = function (rows) {
	      return foldl(rows, function (acc, row) {
	        return row.cells.length > acc ? row.cells.length : acc;
	      }, 0);
	    };
	    var findElementPos = function (table, element) {
	      var rows = table.rows;
	      for (var y = 0; y < rows.length; y++) {
	        var cells = rows[y].cells;
	        for (var x = 0; x < cells.length; x++) {
	          if (eq$2(cells[x], element)) {
	            return Optional.some(cellPosition(x, y));
	          }
	        }
	      }
	      return Optional.none();
	    };
	    var extractRows = function (table, sx, sy, ex, ey) {
	      var newRows = [];
	      var rows = table.rows;
	      for (var y = sy; y <= ey; y++) {
	        var cells = rows[y].cells;
	        var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
	        newRows.push(tableRow(rows[y].element, slice));
	      }
	      return newRows;
	    };
	    var subTable = function (table, startPos, endPos) {
	      var sx = startPos.x, sy = startPos.y;
	      var ex = endPos.x, ey = endPos.y;
	      var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
	      return tableModel(table.element, getWidth(newRows), newRows);
	    };
	    var createDomTable = function (table, rows) {
	      var tableElement = shallow(table.element);
	      var tableBody = SugarElement.fromTag('tbody');
	      append$1(tableBody, rows);
	      append(tableElement, tableBody);
	      return tableElement;
	    };
	    var modelRowsToDomRows = function (table) {
	      return map(table.rows, function (row) {
	        var cells = map(row.cells, function (cell) {
	          var td = deep(cell);
	          remove$1(td, 'colspan');
	          remove$1(td, 'rowspan');
	          return td;
	        });
	        var tr = shallow(row.element);
	        append$1(tr, cells);
	        return tr;
	      });
	    };
	    var fromDom$1 = function (tableElm) {
	      var table = tableModel(shallow(tableElm), 0, []);
	      each(descendants$1(tableElm, 'tr'), function (tr, y) {
	        each(descendants$1(tr, 'td,th'), function (td, x) {
	          fillout(table, skipCellsX(table, x, y), y, tr, td);
	        });
	      });
	      return tableModel(table.element, getWidth(table.rows), table.rows);
	    };
	    var toDom = function (table) {
	      return createDomTable(table, modelRowsToDomRows(table));
	    };
	    var subsection = function (table, startElement, endElement) {
	      return findElementPos(table, startElement).bind(function (startPos) {
	        return findElementPos(table, endElement).map(function (endPos) {
	          return subTable(table, startPos, endPos);
	        });
	      });
	    };
	
	    var findParentListContainer = function (parents) {
	      return find(parents, function (elm) {
	        return name(elm) === 'ul' || name(elm) === 'ol';
	      });
	    };
	    var getFullySelectedListWrappers = function (parents, rng) {
	      return find(parents, function (elm) {
	        return name(elm) === 'li' && hasAllContentsSelected(elm, rng);
	      }).fold(constant([]), function (_li) {
	        return findParentListContainer(parents).map(function (listCont) {
	          var listElm = SugarElement.fromTag(name(listCont));
	          var listStyles = filter$1(getAllRaw(listCont), function (_style, name) {
	            return startsWith(name, 'list-style');
	          });
	          setAll$1(listElm, listStyles);
	          return [
	            SugarElement.fromTag('li'),
	            listElm
	          ];
	        }).getOr([]);
	      });
	    };
	    var wrap$3 = function (innerElm, elms) {
	      var wrapped = foldl(elms, function (acc, elm) {
	        append(elm, acc);
	        return elm;
	      }, innerElm);
	      return elms.length > 0 ? fromElements([wrapped]) : wrapped;
	    };
	    var directListWrappers = function (commonAnchorContainer) {
	      if (isListItem(commonAnchorContainer)) {
	        return parent(commonAnchorContainer).filter(isList).fold(constant([]), function (listElm) {
	          return [
	            commonAnchorContainer,
	            listElm
	          ];
	        });
	      } else {
	        return isList(commonAnchorContainer) ? [commonAnchorContainer] : [];
	      }
	    };
	    var getWrapElements = function (rootNode, rng) {
	      var commonAnchorContainer = SugarElement.fromDom(rng.commonAncestorContainer);
	      var parents = parentsAndSelf(commonAnchorContainer, rootNode);
	      var wrapElements = filter(parents, function (elm) {
	        return isInline(elm) || isHeading(elm);
	      });
	      var listWrappers = getFullySelectedListWrappers(parents, rng);
	      var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
	      return map(allWrappers, shallow);
	    };
	    var emptyFragment = function () {
	      return fromElements([]);
	    };
	    var getFragmentFromRange = function (rootNode, rng) {
	      return wrap$3(SugarElement.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
	    };
	    var getParentTable = function (rootElm, cell) {
	      return ancestor$1(cell, 'table', curry(eq$2, rootElm));
	    };
	    var getTableFragment = function (rootNode, selectedTableCells) {
	      return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
	        var firstCell = selectedTableCells[0];
	        var lastCell = selectedTableCells[selectedTableCells.length - 1];
	        var fullTableModel = fromDom$1(tableElm);
	        return subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
	          return fromElements([toDom(sectionedTableModel)]);
	        });
	      }).getOrThunk(emptyFragment);
	    };
	    var getSelectionFragment = function (rootNode, ranges) {
	      return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
	    };
	    var read$1 = function (rootNode, ranges) {
	      var selectedCells = getCellsFromElementOrRanges(ranges, rootNode);
	      return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
	    };
	
	    var trimLeadingCollapsibleText = function (text) {
	      return text.replace(/^[ \f\n\r\t\v]+/, '');
	    };
	    var isCollapsibleWhitespace = function (text, index) {
	      return index >= 0 && index < text.length && isWhiteSpace$1(text.charAt(index));
	    };
	    var getInnerText = function (bin, shouldTrim) {
	      var text = trim$2(bin.innerText);
	      return shouldTrim ? trimLeadingCollapsibleText(text) : text;
	    };
	    var getContextNodeName = function (parentBlockOpt) {
	      return parentBlockOpt.map(function (block) {
	        return block.nodeName;
	      }).getOr('div').toLowerCase();
	    };
	    var getTextContent = function (editor) {
	      return Optional.from(editor.selection.getRng()).map(function (rng) {
	        var parentBlockOpt = Optional.from(editor.dom.getParent(rng.commonAncestorContainer, editor.dom.isBlock));
	        var body = editor.getBody();
	        var contextNodeName = getContextNodeName(parentBlockOpt);
	        var shouldTrimSpaces = Env.browser.isIE() && contextNodeName !== 'pre';
	        var bin = editor.dom.add(body, contextNodeName, {
	          'data-mce-bogus': 'all',
	          'style': 'overflow: hidden; opacity: 0;'
	        }, rng.cloneContents());
	        var text = getInnerText(bin, shouldTrimSpaces);
	        var nonRenderedText = trim$2(bin.textContent);
	        editor.dom.remove(bin);
	        if (isCollapsibleWhitespace(nonRenderedText, 0) || isCollapsibleWhitespace(nonRenderedText, nonRenderedText.length - 1)) {
	          var parentBlock = parentBlockOpt.getOr(body);
	          var parentBlockText = getInnerText(parentBlock, shouldTrimSpaces);
	          var textIndex = parentBlockText.indexOf(text);
	          if (textIndex === -1) {
	            return text;
	          } else {
	            var hasProceedingSpace = isCollapsibleWhitespace(parentBlockText, textIndex - 1);
	            var hasTrailingSpace = isCollapsibleWhitespace(parentBlockText, textIndex + text.length);
	            return (hasProceedingSpace ? ' ' : '') + text + (hasTrailingSpace ? ' ' : '');
	          }
	        } else {
	          return text;
	        }
	      }).getOr('');
	    };
	    var getSerializedContent = function (editor, args) {
	      var rng = editor.selection.getRng(), tmpElm = editor.dom.create('body');
	      var sel = editor.selection.getSel();
	      var ranges = processRanges(editor, getRanges(sel));
	      var fragment = args.contextual ? read$1(SugarElement.fromDom(editor.getBody()), ranges).dom : rng.cloneContents();
	      if (fragment) {
	        tmpElm.appendChild(fragment);
	      }
	      return editor.selection.serializer.serialize(tmpElm, args);
	    };
	    var getSelectedContentInternal = function (editor, format, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      args.get = true;
	      args.format = format;
	      args.selection = true;
	      args = editor.fire('BeforeGetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('GetContent', args);
	        return args.content;
	      }
	      if (args.format === 'text') {
	        return getTextContent(editor);
	      } else {
	        args.getInner = true;
	        var content = getSerializedContent(editor, args);
	        if (args.format === 'tree') {
	          return content;
	        } else {
	          args.content = editor.selection.isCollapsed() ? '' : content;
	          editor.fire('GetContent', args);
	          return args.content;
	        }
	      }
	    };
	
	    var KEEP = 0, INSERT = 1, DELETE = 2;
	    var diff = function (left, right) {
	      var size = left.length + right.length + 2;
	      var vDown = new Array(size);
	      var vUp = new Array(size);
	      var snake = function (start, end, diag) {
	        return {
	          start: start,
	          end: end,
	          diag: diag
	        };
	      };
	      var buildScript = function (start1, end1, start2, end2, script) {
	        var middle = getMiddleSnake(start1, end1, start2, end2);
	        if (middle === null || middle.start === end1 && middle.diag === end1 - end2 || middle.end === start1 && middle.diag === start1 - start2) {
	          var i = start1;
	          var j = start2;
	          while (i < end1 || j < end2) {
	            if (i < end1 && j < end2 && left[i] === right[j]) {
	              script.push([
	                KEEP,
	                left[i]
	              ]);
	              ++i;
	              ++j;
	            } else {
	              if (end1 - start1 > end2 - start2) {
	                script.push([
	                  DELETE,
	                  left[i]
	                ]);
	                ++i;
	              } else {
	                script.push([
	                  INSERT,
	                  right[j]
	                ]);
	                ++j;
	              }
	            }
	          }
	        } else {
	          buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
	          for (var i2 = middle.start; i2 < middle.end; ++i2) {
	            script.push([
	              KEEP,
	              left[i2]
	            ]);
	          }
	          buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
	        }
	      };
	      var buildSnake = function (start, diag, end1, end2) {
	        var end = start;
	        while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
	          ++end;
	        }
	        return snake(start, end, diag);
	      };
	      var getMiddleSnake = function (start1, end1, start2, end2) {
	        var m = end1 - start1;
	        var n = end2 - start2;
	        if (m === 0 || n === 0) {
	          return null;
	        }
	        var delta = m - n;
	        var sum = n + m;
	        var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
	        vDown[1 + offset] = start1;
	        vUp[1 + offset] = end1 + 1;
	        var d, k, i, x, y;
	        for (d = 0; d <= offset; ++d) {
	          for (k = -d; k <= d; k += 2) {
	            i = k + offset;
	            if (k === -d || k !== d && vDown[i - 1] < vDown[i + 1]) {
	              vDown[i] = vDown[i + 1];
	            } else {
	              vDown[i] = vDown[i - 1] + 1;
	            }
	            x = vDown[i];
	            y = x - start1 + start2 - k;
	            while (x < end1 && y < end2 && left[x] === right[y]) {
	              vDown[i] = ++x;
	              ++y;
	            }
	            if (delta % 2 !== 0 && delta - d <= k && k <= delta + d) {
	              if (vUp[i - delta] <= vDown[i]) {
	                return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	          for (k = delta - d; k <= delta + d; k += 2) {
	            i = k + offset - delta;
	            if (k === delta - d || k !== delta + d && vUp[i + 1] <= vUp[i - 1]) {
	              vUp[i] = vUp[i + 1] - 1;
	            } else {
	              vUp[i] = vUp[i - 1];
	            }
	            x = vUp[i] - 1;
	            y = x - start1 + start2 - k;
	            while (x >= start1 && y >= start2 && left[x] === right[y]) {
	              vUp[i] = x--;
	              y--;
	            }
	            if (delta % 2 === 0 && -d <= k && k <= d) {
	              if (vUp[i] <= vDown[i + delta]) {
	                return buildSnake(vUp[i], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	        }
	      };
	      var script = [];
	      buildScript(0, left.length, 0, right.length, script);
	      return script;
	    };
	
	    var getOuterHtml = function (elm) {
	      if (isElement$1(elm)) {
	        return elm.outerHTML;
	      } else if (isText$1(elm)) {
	        return Entities.encodeRaw(elm.data, false);
	      } else if (isComment$1(elm)) {
	        return '<!--' + elm.data + '-->';
	      }
	      return '';
	    };
	    var createFragment$1 = function (html) {
	      var node;
	      var container = document.createElement('div');
	      var frag = document.createDocumentFragment();
	      if (html) {
	        container.innerHTML = html;
	      }
	      while (node = container.firstChild) {
	        frag.appendChild(node);
	      }
	      return frag;
	    };
	    var insertAt = function (elm, html, index) {
	      var fragment = createFragment$1(html);
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.insertBefore(fragment, target);
	      } else {
	        elm.appendChild(fragment);
	      }
	    };
	    var removeAt = function (elm, index) {
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.removeChild(target);
	      }
	    };
	    var applyDiff = function (diff, elm) {
	      var index = 0;
	      each(diff, function (action) {
	        if (action[0] === KEEP) {
	          index++;
	        } else if (action[0] === INSERT) {
	          insertAt(elm, action[1], index);
	          index++;
	        } else if (action[0] === DELETE) {
	          removeAt(elm, index);
	        }
	      });
	    };
	    var read$2 = function (elm) {
	      return filter(map(from$1(elm.childNodes), getOuterHtml), function (item) {
	        return item.length > 0;
	      });
	    };
	    var write = function (fragments, elm) {
	      var currentFragments = map(from$1(elm.childNodes), getOuterHtml);
	      applyDiff(diff(currentFragments, fragments), elm);
	      return elm;
	    };
	
	    var undoLevelDocument = Cell(Optional.none());
	    var lazyTempDocument = function () {
	      return undoLevelDocument.get().getOrThunk(function () {
	        var doc = document.implementation.createHTMLDocument('undo');
	        undoLevelDocument.set(Optional.some(doc));
	        return doc;
	      });
	    };
	    var hasIframes = function (html) {
	      return html.indexOf('</iframe>') !== -1;
	    };
	    var createFragmentedLevel = function (fragments) {
	      return {
	        type: 'fragmented',
	        fragments: fragments,
	        content: '',
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createCompleteLevel = function (content) {
	      return {
	        type: 'complete',
	        fragments: null,
	        content: content,
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	    var createFromEditor = function (editor) {
	      var fragments = read$2(editor.getBody());
	      var trimmedFragments = bind(fragments, function (html) {
	        var trimmed = trimInternal(editor.serializer, html);
	        return trimmed.length > 0 ? [trimmed] : [];
	      });
	      var content = trimmedFragments.join('');
	      return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
	    };
	    var applyToEditor = function (editor, level, before) {
	      if (level.type === 'fragmented') {
	        write(level.fragments, editor.getBody());
	      } else {
	        editor.setContent(level.content, { format: 'raw' });
	      }
	      editor.selection.moveToBookmark(before ? level.beforeBookmark : level.bookmark);
	    };
	    var getLevelContent = function (level) {
	      return level.type === 'fragmented' ? level.fragments.join('') : level.content;
	    };
	    var getCleanLevelContent = function (level) {
	      var elm = SugarElement.fromTag('body', lazyTempDocument());
	      set$1(elm, getLevelContent(level));
	      each(descendants$1(elm, '*[data-mce-bogus]'), unwrap);
	      return get$7(elm);
	    };
	    var hasEqualContent = function (level1, level2) {
	      return getLevelContent(level1) === getLevelContent(level2);
	    };
	    var hasEqualCleanedContent = function (level1, level2) {
	      return getCleanLevelContent(level1) === getCleanLevelContent(level2);
	    };
	    var isEq$4 = function (level1, level2) {
	      if (!level1 || !level2) {
	        return false;
	      } else if (hasEqualContent(level1, level2)) {
	        return true;
	      } else {
	        return hasEqualCleanedContent(level1, level2);
	      }
	    };
	
	    var isUnlocked = function (locks) {
	      return locks.get() === 0;
	    };
	
	    var setTyping = function (undoManager, typing, locks) {
	      if (isUnlocked(locks)) {
	        undoManager.typing = typing;
	      }
	    };
	    var endTyping = function (undoManager, locks) {
	      if (undoManager.typing) {
	        setTyping(undoManager, false, locks);
	        undoManager.add();
	      }
	    };
	    var endTypingLevelIgnoreLocks = function (undoManager) {
	      if (undoManager.typing) {
	        undoManager.typing = false;
	        undoManager.add();
	      }
	    };
	
	    var beforeChange = function (editor, locks, beforeBookmark) {
	      if (isUnlocked(locks)) {
	        beforeBookmark.set(Optional.some(getUndoBookmark(editor.selection)));
	      }
	    };
	    var addUndoLevel = function (editor, undoManager, index, locks, beforeBookmark, level, event) {
	      var currentLevel = createFromEditor(editor);
	      level = level || {};
	      level = Tools.extend(level, currentLevel);
	      if (isUnlocked(locks) === false || editor.removed) {
	        return null;
	      }
	      var lastLevel = undoManager.data[index.get()];
	      if (editor.fire('BeforeAddUndo', {
	          level: level,
	          lastLevel: lastLevel,
	          originalEvent: event
	        }).isDefaultPrevented()) {
	        return null;
	      }
	      if (lastLevel && isEq$4(lastLevel, level)) {
	        return null;
	      }
	      if (undoManager.data[index.get()]) {
	        beforeBookmark.get().each(function (bm) {
	          undoManager.data[index.get()].beforeBookmark = bm;
	        });
	      }
	      var customUndoRedoLevels = getCustomUndoRedoLevels(editor);
	      if (customUndoRedoLevels) {
	        if (undoManager.data.length > customUndoRedoLevels) {
	          for (var i = 0; i < undoManager.data.length - 1; i++) {
	            undoManager.data[i] = undoManager.data[i + 1];
	          }
	          undoManager.data.length--;
	          index.set(undoManager.data.length);
	        }
	      }
	      level.bookmark = getUndoBookmark(editor.selection);
	      if (index.get() < undoManager.data.length - 1) {
	        undoManager.data.length = index.get() + 1;
	      }
	      undoManager.data.push(level);
	      index.set(undoManager.data.length - 1);
	      var args = {
	        level: level,
	        lastLevel: lastLevel,
	        originalEvent: event
	      };
	      if (index.get() > 0) {
	        editor.setDirty(true);
	        editor.fire('AddUndo', args);
	        editor.fire('change', args);
	      } else {
	        editor.fire('AddUndo', args);
	      }
	      return level;
	    };
	    var clear = function (editor, undoManager, index) {
	      undoManager.data = [];
	      index.set(0);
	      undoManager.typing = false;
	      editor.fire('ClearUndos');
	    };
	    var extra = function (editor, undoManager, index, callback1, callback2) {
	      if (undoManager.transact(callback1)) {
	        var bookmark = undoManager.data[index.get()].bookmark;
	        var lastLevel = undoManager.data[index.get() - 1];
	        applyToEditor(editor, lastLevel, true);
	        if (undoManager.transact(callback2)) {
	          undoManager.data[index.get() - 1].beforeBookmark = bookmark;
	        }
	      }
	    };
	    var redo = function (editor, index, data) {
	      var level;
	      if (index.get() < data.length - 1) {
	        index.set(index.get() + 1);
	        level = data[index.get()];
	        applyToEditor(editor, level, false);
	        editor.setDirty(true);
	        editor.fire('Redo', { level: level });
	      }
	      return level;
	    };
	    var undo = function (editor, undoManager, locks, index) {
	      var level;
	      if (undoManager.typing) {
	        undoManager.add();
	        undoManager.typing = false;
	        setTyping(undoManager, false, locks);
	      }
	      if (index.get() > 0) {
	        index.set(index.get() - 1);
	        level = undoManager.data[index.get()];
	        applyToEditor(editor, level, true);
	        editor.setDirty(true);
	        editor.fire('Undo', { level: level });
	      }
	      return level;
	    };
	    var reset = function (undoManager) {
	      undoManager.clear();
	      undoManager.add();
	    };
	    var hasUndo = function (editor, undoManager, index) {
	      return index.get() > 0 || undoManager.typing && undoManager.data[0] && !isEq$4(createFromEditor(editor), undoManager.data[0]);
	    };
	    var hasRedo = function (undoManager, index) {
	      return index.get() < undoManager.data.length - 1 && !undoManager.typing;
	    };
	    var transact = function (undoManager, locks, callback) {
	      endTyping(undoManager, locks);
	      undoManager.beforeChange();
	      undoManager.ignore(callback);
	      return undoManager.add();
	    };
	    var ignore = function (locks, callback) {
	      try {
	        locks.set(locks.get() + 1);
	        callback();
	      } finally {
	        locks.set(locks.get() - 1);
	      }
	    };
	
	    var addVisualInternal = function (editor, elm) {
	      var dom = editor.dom;
	      var scope = isNonNullable(elm) ? elm : editor.getBody();
	      if (isUndefined(editor.hasVisual)) {
	        editor.hasVisual = isVisualAidsEnabled(editor);
	      }
	      each(dom.select('table,a', scope), function (matchedElm) {
	        switch (matchedElm.nodeName) {
	        case 'TABLE':
	          var cls = getVisualAidsTableClass(editor);
	          var value = dom.getAttrib(matchedElm, 'border');
	          if ((!value || value === '0') && editor.hasVisual) {
	            dom.addClass(matchedElm, cls);
	          } else {
	            dom.removeClass(matchedElm, cls);
	          }
	          break;
	        case 'A':
	          if (!dom.getAttrib(matchedElm, 'href')) {
	            var value_1 = dom.getAttrib(matchedElm, 'name') || matchedElm.id;
	            var cls_1 = getVisualAidsAnchorClass(editor);
	            if (value_1 && editor.hasVisual) {
	              dom.addClass(matchedElm, cls_1);
	            } else {
	              dom.removeClass(matchedElm, cls_1);
	            }
	          }
	          break;
	        }
	      });
	      editor.fire('VisualAid', {
	        element: elm,
	        hasVisual: editor.hasVisual
	      });
	    };
	
	    var makePlainAdaptor = function (editor) {
	      return {
	        undoManager: {
	          beforeChange: function (locks, beforeBookmark) {
	            return beforeChange(editor, locks, beforeBookmark);
	          },
	          addUndoLevel: function (undoManager, index, locks, beforeBookmark, level, event) {
	            return addUndoLevel(editor, undoManager, index, locks, beforeBookmark, level, event);
	          },
	          undo: function (undoManager, locks, index) {
	            return undo(editor, undoManager, locks, index);
	          },
	          redo: function (index, data) {
	            return redo(editor, index, data);
	          },
	          clear: function (undoManager, index) {
	            return clear(editor, undoManager, index);
	          },
	          reset: function (undoManager) {
	            return reset(undoManager);
	          },
	          hasUndo: function (undoManager, index) {
	            return hasUndo(editor, undoManager, index);
	          },
	          hasRedo: function (undoManager, index) {
	            return hasRedo(undoManager, index);
	          },
	          transact: function (undoManager, locks, callback) {
	            return transact(undoManager, locks, callback);
	          },
	          ignore: function (locks, callback) {
	            return ignore(locks, callback);
	          },
	          extra: function (undoManager, index, callback1, callback2) {
	            return extra(editor, undoManager, index, callback1, callback2);
	          }
	        },
	        formatter: {
	          match: function (name, vars, node) {
	            return match(editor, name, vars, node);
	          },
	          matchAll: function (names, vars) {
	            return matchAll(editor, names, vars);
	          },
	          matchNode: function (node, name, vars, similar) {
	            return matchNode(editor, node, name, vars, similar);
	          },
	          canApply: function (name) {
	            return canApply(editor, name);
	          },
	          closest: function (names) {
	            return closest$3(editor, names);
	          },
	          apply: function (name, vars, node) {
	            return applyFormat(editor, name, vars, node);
	          },
	          remove: function (name, vars, node, similar) {
	            return remove$6(editor, name, vars, node, similar);
	          },
	          toggle: function (name, vars, node) {
	            return toggle(editor, name, vars, node);
	          },
	          formatChanged: function (registeredFormatListeners, formats, callback, similar) {
	            return formatChangedInternal(editor, registeredFormatListeners, formats, callback, similar);
	          }
	        },
	        editor: {
	          getContent: function (args, format) {
	            return getContentInternal(editor, args, format);
	          },
	          setContent: function (content, args) {
	            return setContentInternal(editor, content, args);
	          },
	          insertContent: function (value, details) {
	            return insertHtmlAtCaret(editor, value, details);
	          },
	          addVisual: function (elm) {
	            return addVisualInternal(editor, elm);
	          }
	        },
	        selection: {
	          getContent: function (format, args) {
	            return getSelectedContentInternal(editor, format, args);
	          }
	        },
	        raw: {
	          getModel: function () {
	            return Optional.none();
	          }
	        }
	      };
	    };
	    var makeRtcAdaptor = function (rtcEditor) {
	      var defaultVars = function (vars) {
	        return isObject(vars) ? vars : {};
	      };
	      var unsupported = die('Unimplemented feature for rtc');
	      var undoManager = rtcEditor.undoManager, formatter = rtcEditor.formatter, editor = rtcEditor.editor, selection = rtcEditor.selection, raw = rtcEditor.raw;
	      var ignore = noop;
	      return {
	        undoManager: {
	          beforeChange: ignore,
	          addUndoLevel: unsupported,
	          undo: function () {
	            return undoManager.undo();
	          },
	          redo: function () {
	            return undoManager.redo();
	          },
	          clear: function () {
	            return undoManager.clear();
	          },
	          reset: function () {
	            return undoManager.reset();
	          },
	          hasUndo: function () {
	            return undoManager.hasUndo();
	          },
	          hasRedo: function () {
	            return undoManager.hasRedo();
	          },
	          transact: function (_undoManager, _locks, fn) {
	            return undoManager.transact(fn);
	          },
	          ignore: function (_locks, callback) {
	            return undoManager.ignore(callback);
	          },
	          extra: function (_undoManager, _index, callback1, callback2) {
	            return undoManager.extra(callback1, callback2);
	          }
	        },
	        formatter: {
	          match: function (name, vars, _node) {
	            return formatter.match(name, defaultVars(vars));
	          },
	          matchAll: unsupported,
	          matchNode: unsupported,
	          canApply: function (name) {
	            return formatter.canApply(name);
	          },
	          closest: function (names) {
	            return formatter.closest(names);
	          },
	          apply: function (name, vars, _node) {
	            return formatter.apply(name, defaultVars(vars));
	          },
	          remove: function (name, vars, _node, _similar) {
	            return formatter.remove(name, defaultVars(vars));
	          },
	          toggle: function (name, vars, _node) {
	            return formatter.toggle(name, defaultVars(vars));
	          },
	          formatChanged: function (_rfl, formats, callback, similar) {
	            return formatter.formatChanged(formats, callback, similar);
	          }
	        },
	        editor: {
	          getContent: function (args, _format) {
	            return editor.getContent(args);
	          },
	          setContent: function (content, args) {
	            return editor.setContent(content, args);
	          },
	          insertContent: function (content, _details) {
	            return editor.insertContent(content);
	          },
	          addVisual: ignore
	        },
	        selection: {
	          getContent: function (_format, args) {
	            return selection.getContent(args);
	          }
	        },
	        raw: {
	          getModel: function () {
	            return Optional.some(raw.getRawModel());
	          }
	        }
	      };
	    };
	    var makeNoopAdaptor = function () {
	      var nul = constant(null);
	      var empty = constant('');
	      return {
	        undoManager: {
	          beforeChange: noop,
	          addUndoLevel: nul,
	          undo: nul,
	          redo: nul,
	          clear: noop,
	          reset: noop,
	          hasUndo: never,
	          hasRedo: never,
	          transact: nul,
	          ignore: noop,
	          extra: noop
	        },
	        formatter: {
	          match: never,
	          matchAll: constant([]),
	          matchNode: never,
	          canApply: never,
	          closest: empty,
	          apply: noop,
	          remove: noop,
	          toggle: noop,
	          formatChanged: constant({ unbind: noop })
	        },
	        editor: {
	          getContent: empty,
	          setContent: empty,
	          insertContent: noop,
	          addVisual: noop
	        },
	        selection: { getContent: empty },
	        raw: { getModel: constant(Optional.none()) }
	      };
	    };
	    var isRtc = function (editor) {
	      return has(editor.plugins, 'rtc');
	    };
	    var getRtcSetup = function (editor) {
	      return get$1(editor.plugins, 'rtc').bind(function (rtcPlugin) {
	        return Optional.from(rtcPlugin.setup);
	      });
	    };
	    var setup$5 = function (editor) {
	      var editorCast = editor;
	      return getRtcSetup(editor).fold(function () {
	        editorCast.rtcInstance = makePlainAdaptor(editor);
	        return Optional.none();
	      }, function (setup) {
	        return Optional.some(setup().then(function (rtcEditor) {
	          editorCast.rtcInstance = makeRtcAdaptor(rtcEditor);
	          return rtcEditor.rtc.isRemote;
	        }, function (err) {
	          editorCast.rtcInstance = makeNoopAdaptor();
	          return promiseObj.reject(err);
	        }));
	      });
	    };
	    var getRtcInstanceWithFallback = function (editor) {
	      return editor.rtcInstance ? editor.rtcInstance : makePlainAdaptor(editor);
	    };
	    var getRtcInstanceWithError = function (editor) {
	      var rtcInstance = editor.rtcInstance;
	      if (!rtcInstance) {
	        throw new Error('Failed to get RTC instance not yet initialized.');
	      } else {
	        return rtcInstance;
	      }
	    };
	    var beforeChange$1 = function (editor, locks, beforeBookmark) {
	      getRtcInstanceWithError(editor).undoManager.beforeChange(locks, beforeBookmark);
	    };
	    var addUndoLevel$1 = function (editor, undoManager, index, locks, beforeBookmark, level, event) {
	      return getRtcInstanceWithError(editor).undoManager.addUndoLevel(undoManager, index, locks, beforeBookmark, level, event);
	    };
	    var undo$1 = function (editor, undoManager, locks, index) {
	      return getRtcInstanceWithError(editor).undoManager.undo(undoManager, locks, index);
	    };
	    var redo$1 = function (editor, index, data) {
	      return getRtcInstanceWithError(editor).undoManager.redo(index, data);
	    };
	    var clear$1 = function (editor, undoManager, index) {
	      getRtcInstanceWithError(editor).undoManager.clear(undoManager, index);
	    };
	    var reset$1 = function (editor, undoManager) {
	      getRtcInstanceWithError(editor).undoManager.reset(undoManager);
	    };
	    var hasUndo$1 = function (editor, undoManager, index) {
	      return getRtcInstanceWithError(editor).undoManager.hasUndo(undoManager, index);
	    };
	    var hasRedo$1 = function (editor, undoManager, index) {
	      return getRtcInstanceWithError(editor).undoManager.hasRedo(undoManager, index);
	    };
	    var transact$1 = function (editor, undoManager, locks, callback) {
	      return getRtcInstanceWithError(editor).undoManager.transact(undoManager, locks, callback);
	    };
	    var ignore$1 = function (editor, locks, callback) {
	      getRtcInstanceWithError(editor).undoManager.ignore(locks, callback);
	    };
	    var extra$1 = function (editor, undoManager, index, callback1, callback2) {
	      getRtcInstanceWithError(editor).undoManager.extra(undoManager, index, callback1, callback2);
	    };
	    var matchFormat = function (editor, name, vars, node) {
	      return getRtcInstanceWithError(editor).formatter.match(name, vars, node);
	    };
	    var matchAllFormats = function (editor, names, vars) {
	      return getRtcInstanceWithError(editor).formatter.matchAll(names, vars);
	    };
	    var matchNodeFormat = function (editor, node, name, vars, similar) {
	      return getRtcInstanceWithError(editor).formatter.matchNode(node, name, vars, similar);
	    };
	    var canApplyFormat = function (editor, name) {
	      return getRtcInstanceWithError(editor).formatter.canApply(name);
	    };
	    var closestFormat = function (editor, names) {
	      return getRtcInstanceWithError(editor).formatter.closest(names);
	    };
	    var applyFormat$1 = function (editor, name, vars, node) {
	      getRtcInstanceWithError(editor).formatter.apply(name, vars, node);
	    };
	    var removeFormat$1 = function (editor, name, vars, node, similar) {
	      getRtcInstanceWithError(editor).formatter.remove(name, vars, node, similar);
	    };
	    var toggleFormat = function (editor, name, vars, node) {
	      getRtcInstanceWithError(editor).formatter.toggle(name, vars, node);
	    };
	    var formatChanged = function (editor, registeredFormatListeners, formats, callback, similar) {
	      if (similar === void 0) {
	        similar = false;
	      }
	      return getRtcInstanceWithError(editor).formatter.formatChanged(registeredFormatListeners, formats, callback, similar);
	    };
	    var getContent = function (editor, args, format) {
	      return getRtcInstanceWithFallback(editor).editor.getContent(args, format);
	    };
	    var setContent = function (editor, content, args) {
	      return getRtcInstanceWithFallback(editor).editor.setContent(content, args);
	    };
	    var insertContent = function (editor, value, details) {
	      return getRtcInstanceWithFallback(editor).editor.insertContent(value, details);
	    };
	    var getSelectedContent = function (editor, format, args) {
	      return getRtcInstanceWithError(editor).selection.getContent(format, args);
	    };
	    var addVisual = function (editor, elm) {
	      return getRtcInstanceWithError(editor).editor.addVisual(elm);
	    };
	
	    var getContent$1 = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var format = args.format ? args.format : 'html';
	      return getSelectedContent(editor, format, args);
	    };
	
	    var removeEmpty = function (text) {
	      if (text.dom.length === 0) {
	        remove(text);
	        return Optional.none();
	      } else {
	        return Optional.some(text);
	      }
	    };
	    var walkPastBookmark = function (node, start) {
	      return node.filter(function (elm) {
	        return BookmarkManager.isBookmarkNode(elm.dom);
	      }).bind(start ? nextSibling : prevSibling);
	    };
	    var merge = function (outer, inner, rng, start) {
	      var outerElm = outer.dom;
	      var innerElm = inner.dom;
	      var oldLength = start ? outerElm.length : innerElm.length;
	      if (start) {
	        mergeTextNodes(outerElm, innerElm, false, !start);
	        rng.setStart(innerElm, oldLength);
	      } else {
	        mergeTextNodes(innerElm, outerElm, false, !start);
	        rng.setEnd(innerElm, oldLength);
	      }
	    };
	    var normalizeTextIfRequired = function (inner, start) {
	      parent(inner).each(function (root) {
	        var text = inner.dom;
	        if (start && needsToBeNbspLeft(root, CaretPosition(text, 0))) {
	          normalizeWhitespaceAfter(text, 0);
	        } else if (!start && needsToBeNbspRight(root, CaretPosition(text, text.length))) {
	          normalizeWhitespaceBefore(text, text.length);
	        }
	      });
	    };
	    var mergeAndNormalizeText = function (outerNode, innerNode, rng, start) {
	      outerNode.bind(function (outer) {
	        var normalizer = start ? normalizeWhitespaceBefore : normalizeWhitespaceAfter;
	        normalizer(outer.dom, start ? outer.dom.length : 0);
	        return innerNode.filter(isText).map(function (inner) {
	          return merge(outer, inner, rng, start);
	        });
	      }).orThunk(function () {
	        var innerTextNode = walkPastBookmark(innerNode, start).or(innerNode).filter(isText);
	        return innerTextNode.map(function (inner) {
	          return normalizeTextIfRequired(inner, start);
	        });
	      });
	    };
	    var rngSetContent = function (rng, fragment) {
	      var firstChild = Optional.from(fragment.firstChild).map(SugarElement.fromDom);
	      var lastChild = Optional.from(fragment.lastChild).map(SugarElement.fromDom);
	      rng.deleteContents();
	      rng.insertNode(fragment);
	      var prevText = firstChild.bind(prevSibling).filter(isText).bind(removeEmpty);
	      var nextText = lastChild.bind(nextSibling).filter(isText).bind(removeEmpty);
	      mergeAndNormalizeText(prevText, firstChild, rng, true);
	      mergeAndNormalizeText(nextText, lastChild, rng, false);
	      rng.collapse(false);
	    };
	    var setupArgs = function (args, content) {
	      return __assign(__assign({ format: 'html' }, args), {
	        set: true,
	        selection: true,
	        content: content
	      });
	    };
	    var cleanContent = function (editor, args) {
	      if (args.format !== 'raw') {
	        var rng = editor.selection.getRng();
	        var contextBlock = editor.dom.getParent(rng.commonAncestorContainer, editor.dom.isBlock);
	        var contextArgs = contextBlock ? { context: contextBlock.nodeName.toLowerCase() } : {};
	        var node = editor.parser.parse(args.content, __assign(__assign({
	          isRootContent: true,
	          forced_root_block: false
	        }, contextArgs), args));
	        return HtmlSerializer({ validate: editor.validate }, editor.schema).serialize(node);
	      } else {
	        return args.content;
	      }
	    };
	    var setContent$1 = function (editor, content, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var contentArgs = setupArgs(args, content);
	      if (!contentArgs.no_events) {
	        contentArgs = editor.fire('BeforeSetContent', contentArgs);
	        if (contentArgs.isDefaultPrevented()) {
	          editor.fire('SetContent', contentArgs);
	          return;
	        }
	      }
	      args.content = cleanContent(editor, contentArgs);
	      var rng = editor.selection.getRng();
	      rngSetContent(rng, rng.createContextualFragment(args.content));
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, rng);
	      if (!contentArgs.no_events) {
	        editor.fire('SetContent', contentArgs);
	      }
	    };
	
	    var deleteFromCallbackMap = function (callbackMap, selector, callback) {
	      if (callbackMap && callbackMap.hasOwnProperty(selector)) {
	        var newCallbacks = filter(callbackMap[selector], function (cb) {
	          return cb !== callback;
	        });
	        if (newCallbacks.length === 0) {
	          delete callbackMap[selector];
	        } else {
	          callbackMap[selector] = newCallbacks;
	        }
	      }
	    };
	    function SelectorChanged (dom, editor) {
	      var selectorChangedData;
	      var currentSelectors;
	      return {
	        selectorChangedWithUnbind: function (selector, callback) {
	          if (!selectorChangedData) {
	            selectorChangedData = {};
	            currentSelectors = {};
	            editor.on('NodeChange', function (e) {
	              var node = e.element, parents = dom.getParents(node, null, dom.getRoot()), matchedSelectors = {};
	              Tools.each(selectorChangedData, function (callbacks, selector) {
	                Tools.each(parents, function (node) {
	                  if (dom.is(node, selector)) {
	                    if (!currentSelectors[selector]) {
	                      Tools.each(callbacks, function (callback) {
	                        callback(true, {
	                          node: node,
	                          selector: selector,
	                          parents: parents
	                        });
	                      });
	                      currentSelectors[selector] = callbacks;
	                    }
	                    matchedSelectors[selector] = callbacks;
	                    return false;
	                  }
	                });
	              });
	              Tools.each(currentSelectors, function (callbacks, selector) {
	                if (!matchedSelectors[selector]) {
	                  delete currentSelectors[selector];
	                  Tools.each(callbacks, function (callback) {
	                    callback(false, {
	                      node: node,
	                      selector: selector,
	                      parents: parents
	                    });
	                  });
	                }
	              });
	            });
	          }
	          if (!selectorChangedData[selector]) {
	            selectorChangedData[selector] = [];
	          }
	          selectorChangedData[selector].push(callback);
	          return {
	            unbind: function () {
	              deleteFromCallbackMap(selectorChangedData, selector, callback);
	              deleteFromCallbackMap(currentSelectors, selector, callback);
	            }
	          };
	        }
	      };
	    }
	
	    var isNativeIeSelection = function (rng) {
	      return !!rng.select;
	    };
	    var isAttachedToDom = function (node) {
	      return !!(node && node.ownerDocument) && contains$2(SugarElement.fromDom(node.ownerDocument), SugarElement.fromDom(node));
	    };
	    var isValidRange = function (rng) {
	      if (!rng) {
	        return false;
	      } else if (isNativeIeSelection(rng)) {
	        return true;
	      } else {
	        return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
	      }
	    };
	    var EditorSelection = function (dom, win, serializer, editor) {
	      var selectedRange;
	      var explicitRange;
	      var selectorChangedWithUnbind = SelectorChanged(dom, editor).selectorChangedWithUnbind;
	      var setCursorLocation = function (node, offset) {
	        var rng = dom.createRng();
	        if (isNonNullable(node) && isNonNullable(offset)) {
	          rng.setStart(node, offset);
	          rng.setEnd(node, offset);
	          setRng(rng);
	          collapse(false);
	        } else {
	          moveEndPoint$1(dom, rng, editor.getBody(), true);
	          setRng(rng);
	        }
	      };
	      var getContent = function (args) {
	        return getContent$1(editor, args);
	      };
	      var setContent = function (content, args) {
	        return setContent$1(editor, content, args);
	      };
	      var getStart = function (real) {
	        return getStart$2(editor.getBody(), getRng$1(), real);
	      };
	      var getEnd$1 = function (real) {
	        return getEnd(editor.getBody(), getRng$1(), real);
	      };
	      var getBookmark = function (type, normalized) {
	        return bookmarkManager.getBookmark(type, normalized);
	      };
	      var moveToBookmark = function (bookmark) {
	        return bookmarkManager.moveToBookmark(bookmark);
	      };
	      var select = function (node, content) {
	        select$1(dom, node, content).each(setRng);
	        return node;
	      };
	      var isCollapsed = function () {
	        var rng = getRng$1(), sel = getSel();
	        if (!rng || rng.item) {
	          return false;
	        }
	        if (rng.compareEndPoints) {
	          return rng.compareEndPoints('StartToEnd', rng) === 0;
	        }
	        return !sel || rng.collapsed;
	      };
	      var collapse = function (toStart) {
	        var rng = getRng$1();
	        rng.collapse(!!toStart);
	        setRng(rng);
	      };
	      var getSel = function () {
	        return win.getSelection ? win.getSelection() : win.document.selection;
	      };
	      var getRng$1 = function () {
	        var selection, rng, elm;
	        var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
	          try {
	            return sourceRange.compareBoundaryPoints(how, destinationRange);
	          } catch (ex) {
	            return -1;
	          }
	        };
	        var doc = win.document;
	        if (editor.bookmark !== undefined && hasFocus$1(editor) === false) {
	          var bookmark = getRng(editor);
	          if (bookmark.isSome()) {
	            return bookmark.map(function (r) {
	              return processRanges(editor, [r])[0];
	            }).getOr(doc.createRange());
	          }
	        }
	        try {
	          if ((selection = getSel()) && !isRestrictedNode(selection.anchorNode)) {
	            if (selection.rangeCount > 0) {
	              rng = selection.getRangeAt(0);
	            } else {
	              rng = selection.createRange ? selection.createRange() : doc.createRange();
	            }
	            rng = processRanges(editor, [rng])[0];
	          }
	        } catch (ex) {
	        }
	        if (!rng) {
	          rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
	        }
	        if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
	          elm = dom.getRoot();
	          rng.setStart(elm, 0);
	          rng.setEnd(elm, 0);
	        }
	        if (selectedRange && explicitRange) {
	          if (tryCompareBoundaryPoints(rng.START_TO_START, rng, selectedRange) === 0 && tryCompareBoundaryPoints(rng.END_TO_END, rng, selectedRange) === 0) {
	            rng = explicitRange;
	          } else {
	            selectedRange = null;
	            explicitRange = null;
	          }
	        }
	        return rng;
	      };
	      var setRng = function (rng, forward) {
	        var node;
	        if (!isValidRange(rng)) {
	          return;
	        }
	        var ieRange = isNativeIeSelection(rng) ? rng : null;
	        if (ieRange) {
	          explicitRange = null;
	          try {
	            ieRange.select();
	          } catch (ex) {
	          }
	          return;
	        }
	        var sel = getSel();
	        var evt = editor.fire('SetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	        rng = evt.range;
	        if (sel) {
	          explicitRange = rng;
	          try {
	            sel.removeAllRanges();
	            sel.addRange(rng);
	          } catch (ex) {
	          }
	          if (forward === false && sel.extend) {
	            sel.collapse(rng.endContainer, rng.endOffset);
	            sel.extend(rng.startContainer, rng.startOffset);
	          }
	          selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
	        }
	        if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
	          if (rng.endOffset - rng.startOffset < 2) {
	            if (rng.startContainer.hasChildNodes()) {
	              node = rng.startContainer.childNodes[rng.startOffset];
	              if (node && node.tagName === 'IMG') {
	                sel.setBaseAndExtent(rng.startContainer, rng.startOffset, rng.endContainer, rng.endOffset);
	                if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
	                  sel.setBaseAndExtent(node, 0, node, 1);
	                }
	              }
	            }
	          }
	        }
	        editor.fire('AfterSetSelectionRange', {
	          range: rng,
	          forward: forward
	        });
	      };
	      var setNode = function (elm) {
	        setContent(dom.getOuterHTML(elm));
	        return elm;
	      };
	      var getNode = function () {
	        return getNode$1(editor.getBody(), getRng$1());
	      };
	      var getSelectedBlocks$1 = function (startElm, endElm) {
	        return getSelectedBlocks(dom, getRng$1(), startElm, endElm);
	      };
	      var isForward = function () {
	        var sel = getSel();
	        var anchorNode = sel === null || sel === void 0 ? void 0 : sel.anchorNode;
	        var focusNode = sel === null || sel === void 0 ? void 0 : sel.focusNode;
	        if (!sel || !anchorNode || !focusNode || isRestrictedNode(anchorNode) || isRestrictedNode(focusNode)) {
	          return true;
	        }
	        var anchorRange = dom.createRng();
	        anchorRange.setStart(anchorNode, sel.anchorOffset);
	        anchorRange.collapse(true);
	        var focusRange = dom.createRng();
	        focusRange.setStart(focusNode, sel.focusOffset);
	        focusRange.collapse(true);
	        return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
	      };
	      var normalize$1 = function () {
	        var rng = getRng$1();
	        var sel = getSel();
	        if (!hasMultipleRanges(sel) && hasAnyRanges(editor)) {
	          var normRng = normalize(dom, rng);
	          normRng.each(function (normRng) {
	            setRng(normRng, isForward());
	          });
	          return normRng.getOr(rng);
	        }
	        return rng;
	      };
	      var selectorChanged = function (selector, callback) {
	        selectorChangedWithUnbind(selector, callback);
	        return exports;
	      };
	      var getScrollContainer = function () {
	        var scrollContainer;
	        var node = dom.getRoot();
	        while (node && node.nodeName !== 'BODY') {
	          if (node.scrollHeight > node.clientHeight) {
	            scrollContainer = node;
	            break;
	          }
	          node = node.parentNode;
	        }
	        return scrollContainer;
	      };
	      var scrollIntoView = function (elm, alignToTop) {
	        return scrollElementIntoView(editor, elm, alignToTop);
	      };
	      var placeCaretAt = function (clientX, clientY) {
	        return setRng(fromPoint$1(clientX, clientY, editor.getDoc()));
	      };
	      var getBoundingClientRect = function () {
	        var rng = getRng$1();
	        return rng.collapsed ? CaretPosition.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
	      };
	      var destroy = function () {
	        win = selectedRange = explicitRange = null;
	        controlSelection.destroy();
	      };
	      var exports = {
	        bookmarkManager: null,
	        controlSelection: null,
	        dom: dom,
	        win: win,
	        serializer: serializer,
	        editor: editor,
	        collapse: collapse,
	        setCursorLocation: setCursorLocation,
	        getContent: getContent,
	        setContent: setContent,
	        getBookmark: getBookmark,
	        moveToBookmark: moveToBookmark,
	        select: select,
	        isCollapsed: isCollapsed,
	        isForward: isForward,
	        setNode: setNode,
	        getNode: getNode,
	        getSel: getSel,
	        setRng: setRng,
	        getRng: getRng$1,
	        getStart: getStart,
	        getEnd: getEnd$1,
	        getSelectedBlocks: getSelectedBlocks$1,
	        normalize: normalize$1,
	        selectorChanged: selectorChanged,
	        selectorChangedWithUnbind: selectorChangedWithUnbind,
	        getScrollContainer: getScrollContainer,
	        scrollIntoView: scrollIntoView,
	        placeCaretAt: placeCaretAt,
	        getBoundingClientRect: getBoundingClientRect,
	        destroy: destroy
	      };
	      var bookmarkManager = BookmarkManager(exports);
	      var controlSelection = ControlSelection(exports, editor);
	      exports.bookmarkManager = bookmarkManager;
	      exports.controlSelection = controlSelection;
	      return exports;
	    };
	
	    var removeAttrs = function (node, names) {
	      each(names, function (name) {
	        node.attr(name, null);
	      });
	    };
	    var addFontToSpansFilter = function (domParser, styles, fontSizes) {
	      domParser.addNodeFilter('font', function (nodes) {
	        each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          var color = node.attr('color');
	          var face = node.attr('face');
	          var size = node.attr('size');
	          if (color) {
	            props.color = color;
	          }
	          if (face) {
	            props['font-family'] = face;
	          }
	          if (size) {
	            props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
	          }
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	          removeAttrs(node, [
	            'color',
	            'face',
	            'size'
	          ]);
	        });
	      });
	    };
	    var addStrikeToSpanFilter = function (domParser, styles) {
	      domParser.addNodeFilter('strike', function (nodes) {
	        each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          props['text-decoration'] = 'line-through';
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	        });
	      });
	    };
	    var addFilters = function (domParser, settings) {
	      var styles = Styles();
	      if (settings.convert_fonts_to_spans) {
	        addFontToSpansFilter(domParser, styles, Tools.explode(settings.font_size_legacy_values));
	      }
	      addStrikeToSpanFilter(domParser, styles);
	    };
	    var register$1 = function (domParser, settings) {
	      if (settings.inline_styles) {
	        addFilters(domParser, settings);
	      }
	    };
	
	    var blobUriToBlob = function (url) {
	      return new promiseObj(function (resolve, reject) {
	        var rejectWithError = function () {
	          reject('Cannot convert ' + url + ' to Blob. Resource might not exist or is inaccessible.');
	        };
	        try {
	          var xhr_1 = new XMLHttpRequest();
	          xhr_1.open('GET', url, true);
	          xhr_1.responseType = 'blob';
	          xhr_1.onload = function () {
	            if (xhr_1.status === 200) {
	              resolve(xhr_1.response);
	            } else {
	              rejectWithError();
	            }
	          };
	          xhr_1.onerror = rejectWithError;
	          xhr_1.send();
	        } catch (ex) {
	          rejectWithError();
	        }
	      });
	    };
	    var parseDataUri$1 = function (uri) {
	      var type;
	      var uriParts = decodeURIComponent(uri).split(',');
	      var matches = /data:([^;]+)/.exec(uriParts[0]);
	      if (matches) {
	        type = matches[1];
	      }
	      return {
	        type: type,
	        data: uriParts[1]
	      };
	    };
	    var buildBlob = function (type, data) {
	      var str;
	      try {
	        str = atob(data);
	      } catch (e) {
	        return Optional.none();
	      }
	      var arr = new Uint8Array(str.length);
	      for (var i = 0; i < arr.length; i++) {
	        arr[i] = str.charCodeAt(i);
	      }
	      return Optional.some(new Blob([arr], { type: type }));
	    };
	    var dataUriToBlob = function (uri) {
	      return new promiseObj(function (resolve) {
	        var _a = parseDataUri$1(uri), type = _a.type, data = _a.data;
	        buildBlob(type, data).fold(function () {
	          return resolve(new Blob([]));
	        }, resolve);
	      });
	    };
	    var uriToBlob = function (url) {
	      if (url.indexOf('blob:') === 0) {
	        return blobUriToBlob(url);
	      }
	      if (url.indexOf('data:') === 0) {
	        return dataUriToBlob(url);
	      }
	      return null;
	    };
	    var blobToDataUri = function (blob) {
	      return new promiseObj(function (resolve) {
	        var reader = new FileReader();
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	        reader.readAsDataURL(blob);
	      });
	    };
	
	    var count = 0;
	    var uniqueId = function (prefix) {
	      return (prefix || 'blobid') + count++;
	    };
	    var imageToBlobInfo = function (blobCache, img, resolve, reject) {
	      var base64, blobInfo;
	      if (img.src.indexOf('blob:') === 0) {
	        blobInfo = blobCache.getByUri(img.src);
	        if (blobInfo) {
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        } else {
	          uriToBlob(img.src).then(function (blob) {
	            blobToDataUri(blob).then(function (dataUri) {
	              base64 = parseDataUri$1(dataUri).data;
	              blobInfo = blobCache.create(uniqueId(), blob, base64);
	              blobCache.add(blobInfo);
	              resolve({
	                image: img,
	                blobInfo: blobInfo
	              });
	            });
	          }, function (err) {
	            reject(err);
	          });
	        }
	        return;
	      }
	      var _a = parseDataUri$1(img.src), data = _a.data, type = _a.type;
	      base64 = data;
	      blobInfo = blobCache.getByData(base64, type);
	      if (blobInfo) {
	        resolve({
	          image: img,
	          blobInfo: blobInfo
	        });
	      } else {
	        uriToBlob(img.src).then(function (blob) {
	          blobInfo = blobCache.create(uniqueId(), blob, base64);
	          blobCache.add(blobInfo);
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }
	    };
	    var getAllImages = function (elm) {
	      return elm ? from$1(elm.getElementsByTagName('img')) : [];
	    };
	    var ImageScanner = function (uploadStatus, blobCache) {
	      var cachedPromises = {};
	      var findAll = function (elm, predicate) {
	        if (!predicate) {
	          predicate = always;
	        }
	        var images = filter(getAllImages(elm), function (img) {
	          var src = img.src;
	          if (!Env.fileApi) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-bogus')) {
	            return false;
	          }
	          if (img.hasAttribute('data-mce-placeholder')) {
	            return false;
	          }
	          if (!src || src === Env.transparentSrc) {
	            return false;
	          }
	          if (src.indexOf('blob:') === 0) {
	            return !uploadStatus.isUploaded(src) && predicate(img);
	          }
	          if (src.indexOf('data:') === 0) {
	            return predicate(img);
	          }
	          return false;
	        });
	        var promises = map(images, function (img) {
	          if (cachedPromises[img.src] !== undefined) {
	            return new promiseObj(function (resolve) {
	              cachedPromises[img.src].then(function (imageInfo) {
	                if (typeof imageInfo === 'string') {
	                  return imageInfo;
	                }
	                resolve({
	                  image: img,
	                  blobInfo: imageInfo.blobInfo
	                });
	              });
	            });
	          }
	          var newPromise = new promiseObj(function (resolve, reject) {
	            imageToBlobInfo(blobCache, img, resolve, reject);
	          }).then(function (result) {
	            delete cachedPromises[result.image.src];
	            return result;
	          }).catch(function (error) {
	            delete cachedPromises[img.src];
	            return error;
	          });
	          cachedPromises[img.src] = newPromise;
	          return newPromise;
	        });
	        return promiseObj.all(promises);
	      };
	      return { findAll: findAll };
	    };
	
	    var paddEmptyNode = function (settings, args, blockElements, node) {
	      var brPreferred = settings.padd_empty_with_br || args.insert;
	      if (brPreferred && blockElements[node.name]) {
	        node.empty().append(new AstNode('br', 1)).shortEnded = true;
	      } else {
	        node.empty().append(new AstNode('#text', 3)).value = nbsp;
	      }
	    };
	    var isPaddedWithNbsp = function (node) {
	      return hasOnlyChild(node, '#text') && node.firstChild.value === nbsp;
	    };
	    var hasOnlyChild = function (node, name) {
	      return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
	    };
	    var isPadded = function (schema, node) {
	      var rule = schema.getElementRule(node.name);
	      return rule && rule.paddEmpty;
	    };
	    var isEmpty$2 = function (schema, nonEmptyElements, whitespaceElements, node) {
	      return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
	        return isPadded(schema, node);
	      });
	    };
	    var isLineBreakNode = function (node, blockElements) {
	      return node && (blockElements[node.name] || node.name === 'br');
	    };
	
	    var isBogusImage = function (img) {
	      return img.attr('data-mce-bogus');
	    };
	    var isInternalImageSource = function (img) {
	      return img.attr('src') === Env.transparentSrc || img.attr('data-mce-placeholder');
	    };
	    var isValidDataImg = function (img, settings) {
	      if (settings.images_dataimg_filter) {
	        var imgElem_1 = new Image();
	        imgElem_1.src = img.attr('src');
	        each$1(img.attributes.map, function (value, key) {
	          imgElem_1.setAttribute(key, value);
	        });
	        return settings.images_dataimg_filter(imgElem_1);
	      } else {
	        return true;
	      }
	    };
	    var registerBase64ImageFilter = function (parser, settings) {
	      var blobCache = settings.blob_cache;
	      var processImage = function (img) {
	        var inputSrc = img.attr('src');
	        if (isInternalImageSource(img) || isBogusImage(img)) {
	          return;
	        }
	        parseDataUri(inputSrc).filter(function () {
	          return isValidDataImg(img, settings);
	        }).bind(function (_a) {
	          var type = _a.type, data = _a.data;
	          return Optional.from(blobCache.getByData(data, type)).orThunk(function () {
	            return buildBlob(type, data).map(function (blob) {
	              var blobInfo = blobCache.create(uniqueId(), blob, data);
	              blobCache.add(blobInfo);
	              return blobInfo;
	            });
	          });
	        }).each(function (blobInfo) {
	          img.attr('src', blobInfo.blobUri());
	        });
	      };
	      if (blobCache) {
	        parser.addAttributeFilter('src', function (nodes) {
	          return each(nodes, processImage);
	        });
	      }
	    };
	    var register$2 = function (parser, settings) {
	      var schema = parser.schema;
	      if (settings.remove_trailing_brs) {
	        parser.addNodeFilter('br', function (nodes, _, args) {
	          var i;
	          var l = nodes.length;
	          var node;
	          var blockElements = Tools.extend({}, schema.getBlockElements());
	          var nonEmptyElements = schema.getNonEmptyElements();
	          var parent, lastParent, prev, prevName;
	          var whiteSpaceElements = schema.getWhiteSpaceElements();
	          var elementRule, textNode;
	          blockElements.body = 1;
	          for (i = 0; i < l; i++) {
	            node = nodes[i];
	            parent = node.parent;
	            if (blockElements[node.parent.name] && node === parent.lastChild) {
	              prev = node.prev;
	              while (prev) {
	                prevName = prev.name;
	                if (prevName !== 'span' || prev.attr('data-mce-type') !== 'bookmark') {
	                  if (prevName === 'br') {
	                    node = null;
	                  }
	                  break;
	                }
	                prev = prev.prev;
	              }
	              if (node) {
	                node.remove();
	                if (isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, parent)) {
	                  elementRule = schema.getElementRule(parent.name);
	                  if (elementRule) {
	                    if (elementRule.removeEmpty) {
	                      parent.remove();
	                    } else if (elementRule.paddEmpty) {
	                      paddEmptyNode(settings, args, blockElements, parent);
	                    }
	                  }
	                }
	              }
	            } else {
	              lastParent = node;
	              while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
	                lastParent = parent;
	                if (blockElements[parent.name]) {
	                  break;
	                }
	                parent = parent.parent;
	              }
	              if (lastParent === parent && settings.padd_empty_with_br !== true) {
	                textNode = new AstNode('#text', 3);
	                textNode.value = nbsp;
	                node.replace(textNode);
	              }
	            }
	          }
	        });
	      }
	      parser.addAttributeFilter('href', function (nodes) {
	        var i = nodes.length;
	        var appendRel = function (rel) {
	          var parts = rel.split(' ').filter(function (p) {
	            return p.length > 0;
	          });
	          return parts.concat(['noopener']).sort().join(' ');
	        };
	        var addNoOpener = function (rel) {
	          var newRel = rel ? Tools.trim(rel) : '';
	          if (!/\b(noopener)\b/g.test(newRel)) {
	            return appendRel(newRel);
	          } else {
	            return newRel;
	          }
	        };
	        if (!settings.allow_unsafe_link_target) {
	          while (i--) {
	            var node = nodes[i];
	            if (node.name === 'a' && node.attr('target') === '_blank') {
	              node.attr('rel', addNoOpener(node.attr('rel')));
	            }
	          }
	        }
	      });
	      if (!settings.allow_html_in_named_anchor) {
	        parser.addAttributeFilter('id,name', function (nodes) {
	          var i = nodes.length, sibling, prevSibling, parent, node;
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.firstChild && !node.attr('href')) {
	              parent = node.parent;
	              sibling = node.lastChild;
	              do {
	                prevSibling = sibling.prev;
	                parent.insert(sibling, node);
	                sibling = prevSibling;
	              } while (sibling);
	            }
	          }
	        });
	      }
	      if (settings.fix_list_elements) {
	        parser.addNodeFilter('ul,ol', function (nodes) {
	          var i = nodes.length, node, parentNode;
	          while (i--) {
	            node = nodes[i];
	            parentNode = node.parent;
	            if (parentNode.name === 'ul' || parentNode.name === 'ol') {
	              if (node.prev && node.prev.name === 'li') {
	                node.prev.append(node);
	              } else {
	                var li = new AstNode('li', 1);
	                li.attr('style', 'list-style-type: none');
	                node.wrap(li);
	              }
	            }
	          }
	        });
	      }
	      if (settings.validate && schema.getValidClasses()) {
	        parser.addAttributeFilter('class', function (nodes) {
	          var i = nodes.length, node, classList, ci, className, classValue;
	          var validClasses = schema.getValidClasses();
	          var validClassesMap, valid;
	          while (i--) {
	            node = nodes[i];
	            classList = node.attr('class').split(' ');
	            classValue = '';
	            for (ci = 0; ci < classList.length; ci++) {
	              className = classList[ci];
	              valid = false;
	              validClassesMap = validClasses['*'];
	              if (validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              validClassesMap = validClasses[node.name];
	              if (!valid && validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	              if (valid) {
	                if (classValue) {
	                  classValue += ' ';
	                }
	                classValue += className;
	              }
	            }
	            if (!classValue.length) {
	              classValue = null;
	            }
	            node.attr('class', classValue);
	          }
	        });
	      }
	      registerBase64ImageFilter(parser, settings);
	    };
	
	    var makeMap$4 = Tools.makeMap, each$d = Tools.each, explode$2 = Tools.explode, extend$2 = Tools.extend;
	    var DomParser = function (settings, schema) {
	      if (schema === void 0) {
	        schema = Schema();
	      }
	      var nodeFilters = {};
	      var attributeFilters = [];
	      var matchedNodes = {};
	      var matchedAttributes = {};
	      settings = settings || {};
	      settings.validate = 'validate' in settings ? settings.validate : true;
	      settings.root_name = settings.root_name || 'body';
	      var fixInvalidChildren = function (nodes) {
	        var ni, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
	        var sibling, nextNode;
	        var nonSplitableElements = makeMap$4('tr,td,th,tbody,thead,tfoot,table');
	        var nonEmptyElements = schema.getNonEmptyElements();
	        var whitespaceElements = schema.getWhiteSpaceElements();
	        var textBlockElements = schema.getTextBlockElements();
	        var specialElements = schema.getSpecialElements();
	        for (ni = 0; ni < nodes.length; ni++) {
	          node = nodes[ni];
	          if (!node.parent || node.fixed) {
	            continue;
	          }
	          if (textBlockElements[node.name] && node.parent.name === 'li') {
	            sibling = node.next;
	            while (sibling) {
	              if (textBlockElements[sibling.name]) {
	                sibling.name = 'li';
	                sibling.fixed = true;
	                node.parent.insert(sibling, node.parent);
	              } else {
	                break;
	              }
	              sibling = sibling.next;
	            }
	            node.unwrap(node);
	            continue;
	          }
	          parents = [node];
	          for (parent = node.parent; parent && !schema.isValidChild(parent.name, node.name) && !nonSplitableElements[parent.name]; parent = parent.parent) {
	            parents.push(parent);
	          }
	          if (parent && parents.length > 1) {
	            parents.reverse();
	            newParent = currentNode = filterNode(parents[0].clone());
	            for (i = 0; i < parents.length - 1; i++) {
	              if (schema.isValidChild(currentNode.name, parents[i].name)) {
	                tempNode = filterNode(parents[i].clone());
	                currentNode.append(tempNode);
	              } else {
	                tempNode = currentNode;
	              }
	              for (childNode = parents[i].firstChild; childNode && childNode !== parents[i + 1];) {
	                nextNode = childNode.next;
	                tempNode.append(childNode);
	                childNode = nextNode;
	              }
	              currentNode = tempNode;
	            }
	            if (!isEmpty$2(schema, nonEmptyElements, whitespaceElements, newParent)) {
	              parent.insert(newParent, parents[0], true);
	              parent.insert(node, newParent);
	            } else {
	              parent.insert(node, parents[0], true);
	            }
	            parent = parents[0];
	            if (isEmpty$2(schema, nonEmptyElements, whitespaceElements, parent) || hasOnlyChild(parent, 'br')) {
	              parent.empty().remove();
	            }
	          } else if (node.parent) {
	            if (node.name === 'li') {
	              sibling = node.prev;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ol')) {
	                sibling.append(node);
	                continue;
	              }
	              sibling = node.next;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ol')) {
	                sibling.insert(node, sibling.firstChild, true);
	                continue;
	              }
	              node.wrap(filterNode(new AstNode('ul', 1)));
	              continue;
	            }
	            if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
	              node.wrap(filterNode(new AstNode('div', 1)));
	            } else {
	              if (specialElements[node.name]) {
	                node.empty().remove();
	              } else {
	                node.unwrap();
	              }
	            }
	          }
	        }
	      };
	      var filterNode = function (node) {
	        var i, name, list;
	        name = node.name;
	        if (name in nodeFilters) {
	          list = matchedNodes[name];
	          if (list) {
	            list.push(node);
	          } else {
	            matchedNodes[name] = [node];
	          }
	        }
	        i = attributeFilters.length;
	        while (i--) {
	          name = attributeFilters[i].name;
	          if (name in node.attributes.map) {
	            list = matchedAttributes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedAttributes[name] = [node];
	            }
	          }
	        }
	        return node;
	      };
	      var addNodeFilter = function (name, callback) {
	        each$d(explode$2(name), function (name) {
	          var list = nodeFilters[name];
	          if (!list) {
	            nodeFilters[name] = list = [];
	          }
	          list.push(callback);
	        });
	      };
	      var getNodeFilters = function () {
	        var out = [];
	        for (var name_1 in nodeFilters) {
	          if (nodeFilters.hasOwnProperty(name_1)) {
	            out.push({
	              name: name_1,
	              callbacks: nodeFilters[name_1]
	            });
	          }
	        }
	        return out;
	      };
	      var addAttributeFilter = function (name, callback) {
	        each$d(explode$2(name), function (name) {
	          var i;
	          for (i = 0; i < attributeFilters.length; i++) {
	            if (attributeFilters[i].name === name) {
	              attributeFilters[i].callbacks.push(callback);
	              return;
	            }
	          }
	          attributeFilters.push({
	            name: name,
	            callbacks: [callback]
	          });
	        });
	      };
	      var getAttributeFilters = function () {
	        return [].concat(attributeFilters);
	      };
	      var parse = function (html, args) {
	        var nodes, i, l, fi, fl, list, name;
	        var invalidChildren = [];
	        var isInWhiteSpacePreservedElement;
	        var node;
	        var getRootBlockName = function (name) {
	          if (name === false) {
	            return '';
	          } else if (name === true) {
	            return 'p';
	          } else {
	            return name;
	          }
	        };
	        args = args || {};
	        matchedNodes = {};
	        matchedAttributes = {};
	        var blockElements = extend$2(makeMap$4('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
	        var nonEmptyElements = schema.getNonEmptyElements();
	        var children = schema.children;
	        var validate = settings.validate;
	        var forcedRootBlockName = 'forced_root_block' in args ? args.forced_root_block : settings.forced_root_block;
	        var rootBlockName = getRootBlockName(forcedRootBlockName);
	        var whiteSpaceElements = schema.getWhiteSpaceElements();
	        var startWhiteSpaceRegExp = /^[ \t\r\n]+/;
	        var endWhiteSpaceRegExp = /[ \t\r\n]+$/;
	        var allWhiteSpaceRegExp = /[ \t\r\n]+/g;
	        var isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
	        isInWhiteSpacePreservedElement = whiteSpaceElements.hasOwnProperty(args.context) || whiteSpaceElements.hasOwnProperty(settings.root_name);
	        var addRootBlocks = function () {
	          var node = rootNode.firstChild, next, rootBlockNode;
	          var trim = function (rootBlockNode) {
	            if (rootBlockNode) {
	              node = rootBlockNode.firstChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(startWhiteSpaceRegExp, '');
	              }
	              node = rootBlockNode.lastChild;
	              if (node && node.type === 3) {
	                node.value = node.value.replace(endWhiteSpaceRegExp, '');
	              }
	            }
	          };
	          if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
	            return;
	          }
	          while (node) {
	            next = node.next;
	            if (node.type === 3 || node.type === 1 && node.name !== 'p' && !blockElements[node.name] && !node.attr('data-mce-type')) {
	              if (!rootBlockNode) {
	                rootBlockNode = createNode(rootBlockName, 1);
	                rootBlockNode.attr(settings.forced_root_block_attrs);
	                rootNode.insert(rootBlockNode, node);
	                rootBlockNode.append(node);
	              } else {
	                rootBlockNode.append(node);
	              }
	            } else {
	              trim(rootBlockNode);
	              rootBlockNode = null;
	            }
	            node = next;
	          }
	          trim(rootBlockNode);
	        };
	        var createNode = function (name, type) {
	          var node = new AstNode(name, type);
	          var list;
	          if (name in nodeFilters) {
	            list = matchedNodes[name];
	            if (list) {
	              list.push(node);
	            } else {
	              matchedNodes[name] = [node];
	            }
	          }
	          return node;
	        };
	        var removeWhitespaceBefore = function (node) {
	          var textNode, textNodeNext, textVal, sibling;
	          var blockElements = schema.getBlockElements();
	          for (textNode = node.prev; textNode && textNode.type === 3;) {
	            textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
	            if (textVal.length > 0) {
	              textNode.value = textVal;
	              return;
	            }
	            textNodeNext = textNode.next;
	            if (textNodeNext) {
	              if (textNodeNext.type === 3 && textNodeNext.value.length) {
	                textNode = textNode.prev;
	                continue;
	              }
	              if (!blockElements[textNodeNext.name] && textNodeNext.name !== 'script' && textNodeNext.name !== 'style') {
	                textNode = textNode.prev;
	                continue;
	              }
	            }
	            sibling = textNode.prev;
	            textNode.remove();
	            textNode = sibling;
	          }
	        };
	        var cloneAndExcludeBlocks = function (input) {
	          var name;
	          var output = {};
	          for (name in input) {
	            if (name !== 'li' && name !== 'p') {
	              output[name] = input[name];
	            }
	          }
	          return output;
	        };
	        var parser = SaxParser({
	          validate: validate,
	          allow_html_data_urls: settings.allow_html_data_urls,
	          allow_svg_data_urls: settings.allow_svg_data_urls,
	          allow_script_urls: settings.allow_script_urls,
	          allow_conditional_comments: settings.allow_conditional_comments,
	          preserve_cdata: settings.preserve_cdata,
	          self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
	          cdata: function (text) {
	            node.append(createNode('#cdata', 4)).value = text;
	          },
	          text: function (text, raw) {
	            var textNode;
	            if (!isInWhiteSpacePreservedElement) {
	              text = text.replace(allWhiteSpaceRegExp, ' ');
	              if (isLineBreakNode(node.lastChild, blockElements)) {
	                text = text.replace(startWhiteSpaceRegExp, '');
	              }
	            }
	            if (text.length !== 0) {
	              textNode = createNode('#text', 3);
	              textNode.raw = !!raw;
	              node.append(textNode).value = text;
	            }
	          },
	          comment: function (text) {
	            node.append(createNode('#comment', 8)).value = text;
	          },
	          pi: function (name, text) {
	            node.append(createNode(name, 7)).value = text;
	            removeWhitespaceBefore(node);
	          },
	          doctype: function (text) {
	            var newNode = node.append(createNode('#doctype', 10));
	            newNode.value = text;
	            removeWhitespaceBefore(node);
	          },
	          start: function (name, attrs, empty) {
	            var newNode, attrFiltersLen, attrName, parent;
	            var elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              newNode = createNode(elementRule.outputName || name, 1);
	              newNode.attributes = attrs;
	              newNode.shortEnded = empty;
	              node.append(newNode);
	              parent = children[node.name];
	              if (parent && children[newNode.name] && !parent[newNode.name]) {
	                invalidChildren.push(newNode);
	              }
	              attrFiltersLen = attributeFilters.length;
	              while (attrFiltersLen--) {
	                attrName = attributeFilters[attrFiltersLen].name;
	                if (attrName in attrs.map) {
	                  list = matchedAttributes[attrName];
	                  if (list) {
	                    list.push(newNode);
	                  } else {
	                    matchedAttributes[attrName] = [newNode];
	                  }
	                }
	              }
	              if (blockElements[name]) {
	                removeWhitespaceBefore(newNode);
	              }
	              if (!empty) {
	                node = newNode;
	              }
	              if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = true;
	              }
	            }
	          },
	          end: function (name) {
	            var textNode, text, sibling, tempNode;
	            var elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              if (blockElements[name]) {
	                if (!isInWhiteSpacePreservedElement) {
	                  textNode = node.firstChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(startWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.next;
	                    } else {
	                      sibling = textNode.next;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.next;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                  textNode = node.lastChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(endWhiteSpaceRegExp, '');
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.prev;
	                    } else {
	                      sibling = textNode.prev;
	                      textNode.remove();
	                      textNode = sibling;
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.prev;
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                }
	              }
	              if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = false;
	              }
	              if (elementRule.removeEmpty && isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node)) {
	                tempNode = node.parent;
	                if (blockElements[node.name]) {
	                  node.empty().remove();
	                } else {
	                  node.unwrap();
	                }
	                node = tempNode;
	                return;
	              }
	              if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isEmpty$2(schema, nonEmptyElements, whiteSpaceElements, node))) {
	                paddEmptyNode(settings, args, blockElements, node);
	              }
	              node = node.parent;
	            }
	          }
	        }, schema);
	        var rootNode = node = new AstNode(args.context || settings.root_name, 11);
	        parser.parse(html, args.format);
	        if (validate && invalidChildren.length) {
	          if (!args.context) {
	            fixInvalidChildren(invalidChildren);
	          } else {
	            args.invalid = true;
	          }
	        }
	        if (rootBlockName && (rootNode.name === 'body' || args.isRootContent)) {
	          addRootBlocks();
	        }
	        if (!args.invalid) {
	          for (name in matchedNodes) {
	            if (!matchedNodes.hasOwnProperty(name)) {
	              continue;
	            }
	            list = nodeFilters[name];
	            nodes = matchedNodes[name];
	            fi = nodes.length;
	            while (fi--) {
	              if (!nodes[fi].parent) {
	                nodes.splice(fi, 1);
	              }
	            }
	            for (i = 0, l = list.length; i < l; i++) {
	              list[i](nodes, name, args);
	            }
	          }
	          for (i = 0, l = attributeFilters.length; i < l; i++) {
	            list = attributeFilters[i];
	            if (list.name in matchedAttributes) {
	              nodes = matchedAttributes[list.name];
	              fi = nodes.length;
	              while (fi--) {
	                if (!nodes[fi].parent) {
	                  nodes.splice(fi, 1);
	                }
	              }
	              for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
	                list.callbacks[fi](nodes, list.name, args);
	              }
	            }
	          }
	        }
	        return rootNode;
	      };
	      var exports = {
	        schema: schema,
	        addAttributeFilter: addAttributeFilter,
	        getAttributeFilters: getAttributeFilters,
	        addNodeFilter: addNodeFilter,
	        getNodeFilters: getNodeFilters,
	        filterNode: filterNode,
	        parse: parse
	      };
	      register$2(exports, settings);
	      register$1(exports, settings);
	      return exports;
	    };
	
	    var register$3 = function (htmlParser, settings, dom) {
	      htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          node.attr('tabindex', node.attr('data-mce-tabindex'));
	          node.attr(name, null);
	        }
	      });
	      htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
	        var i = nodes.length, node, value;
	        var internalName = 'data-mce-' + name;
	        var urlConverter = settings.url_converter;
	        var urlConverterScope = settings.url_converter_scope;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr(internalName);
	          if (value !== undefined) {
	            node.attr(name, value.length > 0 ? value : null);
	            node.attr(internalName, null);
	          } else {
	            value = node.attr(name);
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	            } else if (urlConverter) {
	              value = urlConverter.call(urlConverterScope, value, name, node.name);
	            }
	            node.attr(name, value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, value;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr('class');
	          if (value) {
	            value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
	            node.attr('class', value.length > 0 ? value : null);
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.attr('data-mce-type') === 'bookmark' && !args.cleanup) {
	            var hasChildren = Optional.from(node.firstChild).exists(function (firstChild) {
	              return !isZwsp$1(firstChild.value);
	            });
	            if (hasChildren) {
	              node.unwrap();
	            } else {
	              node.remove();
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('noscript', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i].firstChild;
	          if (node) {
	            node.value = Entities.decode(node.value);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('script,style', function (nodes, name) {
	        var i = nodes.length, node, value, type;
	        var trim = function (value) {
	          return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n').replace(/^[\r\n]*|[\r\n]*$/g, '').replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '').replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	        };
	        while (i--) {
	          node = nodes[i];
	          value = node.firstChild ? node.firstChild.value : '';
	          if (name === 'script') {
	            type = node.attr('type');
	            if (type) {
	              node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
	            }
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
	            }
	          } else {
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
	            }
	          }
	        }
	      });
	      htmlParser.addNodeFilter('#comment', function (nodes) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (settings.preserve_cdata && node.value.indexOf('[CDATA[') === 0) {
	            node.name = '#cdata';
	            node.type = 4;
	            node.value = dom.decode(node.value.replace(/^\[CDATA\[|\]\]$/g, ''));
	          } else if (node.value.indexOf('mce:protected ') === 0) {
	            node.name = '#text';
	            node.type = 3;
	            node.raw = true;
	            node.value = unescape(node.value).substr(14);
	          }
	        }
	      });
	      htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
	        var i = nodes.length, node;
	        while (i--) {
	          node = nodes[i];
	          if (node.type === 7) {
	            node.remove();
	          } else if (node.type === 1) {
	            if (name === 'input' && !node.attr('type')) {
	              node.attr('type', 'text');
	            }
	          }
	        }
	      });
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
	        each(nodes, function (node) {
	          if (node.attr('data-mce-type') === 'format-caret') {
	            if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
	              node.remove();
	            } else {
	              node.unwrap();
	            }
	          }
	        });
	      });
	      htmlParser.addAttributeFilter('data-mce-src,data-mce-href,data-mce-style,' + 'data-mce-selected,data-mce-expando,' + 'data-mce-type,data-mce-resize,data-mce-placeholder', function (nodes, name) {
	        var i = nodes.length;
	        while (i--) {
	          nodes[i].attr(name, null);
	        }
	      });
	    };
	    var trimTrailingBr = function (rootNode) {
	      var isBr = function (node) {
	        return node && node.name === 'br';
	      };
	      var brNode1 = rootNode.lastChild;
	      if (isBr(brNode1)) {
	        var brNode2 = brNode1.prev;
	        if (isBr(brNode2)) {
	          brNode1.remove();
	          brNode2.remove();
	        }
	      }
	    };
	
	    var preProcess = function (editor, node, args) {
	      var doc, oldDoc;
	      var dom = editor.dom;
	      node = node.cloneNode(true);
	      var impl = document.implementation;
	      if (impl.createHTMLDocument) {
	        doc = impl.createHTMLDocument('');
	        Tools.each(node.nodeName === 'BODY' ? node.childNodes : [node], function (node) {
	          doc.body.appendChild(doc.importNode(node, true));
	        });
	        if (node.nodeName !== 'BODY') {
	          node = doc.body.firstChild;
	        } else {
	          node = doc.body;
	        }
	        oldDoc = dom.doc;
	        dom.doc = doc;
	      }
	      firePreProcess(editor, __assign(__assign({}, args), { node: node }));
	      if (oldDoc) {
	        dom.doc = oldDoc;
	      }
	      return node;
	    };
	    var shouldFireEvent = function (editor, args) {
	      return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
	    };
	    var process = function (editor, node, args) {
	      return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
	    };
	
	    var addTempAttr = function (htmlParser, tempAttrs, name) {
	      if (Tools.inArray(tempAttrs, name) === -1) {
	        htmlParser.addAttributeFilter(name, function (nodes, name) {
	          var i = nodes.length;
	          while (i--) {
	            nodes[i].attr(name, null);
	          }
	        });
	        tempAttrs.push(name);
	      }
	    };
	    var postProcess$1 = function (editor, args, content) {
	      if (!args.no_events && editor) {
	        var outArgs = firePostProcess(editor, __assign(__assign({}, args), { content: content }));
	        return outArgs.content;
	      } else {
	        return content;
	      }
	    };
	    var getHtmlFromNode = function (dom, node, args) {
	      var html = trim$2(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
	      return args.selection || isWsPreserveElement(SugarElement.fromDom(node)) ? html : Tools.trim(html);
	    };
	    var parseHtml = function (htmlParser, html, args) {
	      var parserArgs = args.selection ? __assign({ forced_root_block: false }, args) : args;
	      var rootNode = htmlParser.parse(html, parserArgs);
	      trimTrailingBr(rootNode);
	      return rootNode;
	    };
	    var serializeNode = function (settings, schema, node) {
	      var htmlSerializer = HtmlSerializer(settings, schema);
	      return htmlSerializer.serialize(node);
	    };
	    var toHtml = function (editor, settings, schema, rootNode, args) {
	      var content = serializeNode(settings, schema, rootNode);
	      return postProcess$1(editor, args, content);
	    };
	    var DomSerializerImpl = function (settings, editor) {
	      var tempAttrs = ['data-mce-selected'];
	      var dom = editor && editor.dom ? editor.dom : DOMUtils.DOM;
	      var schema = editor && editor.schema ? editor.schema : Schema(settings);
	      settings.entity_encoding = settings.entity_encoding || 'named';
	      settings.remove_trailing_brs = 'remove_trailing_brs' in settings ? settings.remove_trailing_brs : true;
	      var htmlParser = DomParser(settings, schema);
	      register$3(htmlParser, settings, dom);
	      var serialize = function (node, parserArgs) {
	        if (parserArgs === void 0) {
	          parserArgs = {};
	        }
	        var args = __assign({ format: 'html' }, parserArgs);
	        var targetNode = process(editor, node, args);
	        var html = getHtmlFromNode(dom, targetNode, args);
	        var rootNode = parseHtml(htmlParser, html, args);
	        return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
	      };
	      return {
	        schema: schema,
	        addNodeFilter: htmlParser.addNodeFilter,
	        addAttributeFilter: htmlParser.addAttributeFilter,
	        serialize: serialize,
	        addRules: function (rules) {
	          schema.addValidElements(rules);
	        },
	        setRules: function (rules) {
	          schema.setValidElements(rules);
	        },
	        addTempAttr: curry(addTempAttr, htmlParser, tempAttrs),
	        getTempAttrs: constant(tempAttrs),
	        getNodeFilters: htmlParser.getNodeFilters,
	        getAttributeFilters: htmlParser.getAttributeFilters
	      };
	    };
	
	    var DomSerializer = function (settings, editor) {
	      var domSerializer = DomSerializerImpl(settings, editor);
	      return {
	        schema: domSerializer.schema,
	        addNodeFilter: domSerializer.addNodeFilter,
	        addAttributeFilter: domSerializer.addAttributeFilter,
	        serialize: domSerializer.serialize,
	        addRules: domSerializer.addRules,
	        setRules: domSerializer.setRules,
	        addTempAttr: domSerializer.addTempAttr,
	        getTempAttrs: domSerializer.getTempAttrs,
	        getNodeFilters: domSerializer.getNodeFilters,
	        getAttributeFilters: domSerializer.getAttributeFilters
	      };
	    };
	
	    var defaultFormat$1 = 'html';
	    var getContent$2 = function (editor, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      var format = args.format ? args.format : defaultFormat$1;
	      return getContent(editor, args, format);
	    };
	
	    var setContent$2 = function (editor, content, args) {
	      if (args === void 0) {
	        args = {};
	      }
	      return setContent(editor, content, args);
	    };
	
	    var DOM$3 = DOMUtils.DOM;
	    var restoreOriginalStyles = function (editor) {
	      DOM$3.setStyle(editor.id, 'display', editor.orgDisplay);
	    };
	    var safeDestroy = function (x) {
	      return Optional.from(x).each(function (x) {
	        return x.destroy();
	      });
	    };
	    var clearDomReferences = function (editor) {
	      editor.contentAreaContainer = editor.formElement = editor.container = editor.editorContainer = null;
	      editor.bodyElement = editor.contentDocument = editor.contentWindow = null;
	      editor.iframeElement = editor.targetElm = null;
	      if (editor.selection) {
	        editor.selection = editor.selection.win = editor.selection.dom = editor.selection.dom.doc = null;
	      }
	    };
	    var restoreForm = function (editor) {
	      var form = editor.formElement;
	      if (form) {
	        if (form._mceOldSubmit) {
	          form.submit = form._mceOldSubmit;
	          form._mceOldSubmit = null;
	        }
	        DOM$3.unbind(form, 'submit reset', editor.formEventDelegate);
	      }
	    };
	    var remove$7 = function (editor) {
	      if (!editor.removed) {
	        var _selectionOverrides = editor._selectionOverrides, editorUpload = editor.editorUpload;
	        var body = editor.getBody();
	        var element = editor.getElement();
	        if (body) {
	          editor.save({ is_removing: true });
	        }
	        editor.removed = true;
	        editor.unbindAllNativeEvents();
	        if (editor.hasHiddenInput && element) {
	          DOM$3.remove(element.nextSibling);
	        }
	        fireRemove(editor);
	        editor.editorManager.remove(editor);
	        if (!editor.inline && body) {
	          restoreOriginalStyles(editor);
	        }
	        fireDetach(editor);
	        DOM$3.remove(editor.getContainer());
	        safeDestroy(_selectionOverrides);
	        safeDestroy(editorUpload);
	        editor.destroy();
	      }
	    };
	    var destroy = function (editor, automatic) {
	      var selection = editor.selection, dom = editor.dom;
	      if (editor.destroyed) {
	        return;
	      }
	      if (!automatic && !editor.removed) {
	        editor.remove();
	        return;
	      }
	      if (!automatic) {
	        editor.editorManager.off('beforeunload', editor._beforeUnload);
	        if (editor.theme && editor.theme.destroy) {
	          editor.theme.destroy();
	        }
	        safeDestroy(selection);
	        safeDestroy(dom);
	      }
	      restoreForm(editor);
	      clearDomReferences(editor);
	      editor.destroyed = true;
	    };
	
	    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
	    var deep$1 = function (old, nu) {
	      var bothObjects = isObject(old) && isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	    var baseMerge = function (merger) {
	      return function () {
	        var objects = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          objects[_i] = arguments[_i];
	        }
	        if (objects.length === 0) {
	          throw new Error('Can\'t merge zero objects');
	        }
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) {
	            if (hasOwnProperty$2.call(curObject, key)) {
	              ret[key] = merger(ret[key], curObject[key]);
	            }
	          }
	        }
	        return ret;
	      };
	    };
	    var deepMerge = baseMerge(deep$1);
	
	    var sectionResult = function (sections, settings) {
	      return {
	        sections: constant(sections),
	        settings: constant(settings)
	      };
	    };
	    var deviceDetection = detect$3().deviceType;
	    var isTouch = deviceDetection.isTouch();
	    var isPhone = deviceDetection.isPhone();
	    var isTablet = deviceDetection.isTablet();
	    var legacyMobilePlugins = [
	      'lists',
	      'autolink',
	      'autosave'
	    ];
	    var defaultTouchSettings = {
	      table_grid: false,
	      object_resizing: false,
	      resize: false
	    };
	    var normalizePlugins = function (plugins) {
	      var pluginNames = isArray(plugins) ? plugins.join(' ') : plugins;
	      var trimmedPlugins = map(isString(pluginNames) ? pluginNames.split(' ') : [], trim);
	      return filter(trimmedPlugins, function (item) {
	        return item.length > 0;
	      });
	    };
	    var filterLegacyMobilePlugins = function (plugins) {
	      return filter(plugins, curry(contains, legacyMobilePlugins));
	    };
	    var extractSections = function (keys, settings) {
	      var result = bifilter(settings, function (value, key) {
	        return contains(keys, key);
	      });
	      return sectionResult(result.t, result.f);
	    };
	    var getSection = function (sectionResult, name, defaults) {
	      if (defaults === void 0) {
	        defaults = {};
	      }
	      var sections = sectionResult.sections();
	      var sectionSettings = sections.hasOwnProperty(name) ? sections[name] : {};
	      return Tools.extend({}, defaults, sectionSettings);
	    };
	    var hasSection = function (sectionResult, name) {
	      return sectionResult.sections().hasOwnProperty(name);
	    };
	    var isSectionTheme = function (sectionResult, name, theme) {
	      var section = sectionResult.sections();
	      return hasSection(sectionResult, name) && section[name].theme === theme;
	    };
	    var getSectionConfig = function (sectionResult, name) {
	      return hasSection(sectionResult, name) ? sectionResult.sections()[name] : {};
	    };
	    var getToolbarMode = function (settings, defaultVal) {
	      return get$1(settings, 'toolbar_mode').orThunk(function () {
	        return get$1(settings, 'toolbar_drawer').map(function (val) {
	          return val === false ? 'wrap' : val;
	        });
	      }).getOr(defaultVal);
	    };
	    var getDefaultSettings = function (settings, id, documentBaseUrl, isTouch, editor) {
	      var baseDefaults = {
	        id: id,
	        theme: 'silver',
	        toolbar_mode: getToolbarMode(settings, 'floating'),
	        plugins: '',
	        document_base_url: documentBaseUrl,
	        add_form_submit_trigger: true,
	        submit_patch: true,
	        add_unload_trigger: true,
	        convert_urls: true,
	        relative_urls: true,
	        remove_script_host: true,
	        object_resizing: true,
	        doctype: '<!DOCTYPE html>',
	        visual: true,
	        font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
	        forced_root_block: 'p',
	        hidden_input: true,
	        inline_styles: true,
	        convert_fonts_to_spans: true,
	        indent: true,
	        indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' + 'tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        entity_encoding: 'named',
	        url_converter: editor.convertURL,
	        url_converter_scope: editor
	      };
	      return __assign(__assign({}, baseDefaults), isTouch ? defaultTouchSettings : {});
	    };
	    var getDefaultMobileSettings = function (mobileSettings, isPhone) {
	      var defaultMobileSettings = {
	        resize: false,
	        toolbar_mode: getToolbarMode(mobileSettings, 'scrolling'),
	        toolbar_sticky: false
	      };
	      var defaultPhoneSettings = { menubar: false };
	      return __assign(__assign(__assign({}, defaultTouchSettings), defaultMobileSettings), isPhone ? defaultPhoneSettings : {});
	    };
	    var getExternalPlugins$1 = function (overrideSettings, settings) {
	      var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : {};
	      if (overrideSettings && overrideSettings.external_plugins) {
	        return Tools.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
	      } else {
	        return userDefinedExternalPlugins;
	      }
	    };
	    var combinePlugins = function (forcedPlugins, plugins) {
	      return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
	    };
	    var getPlatformPlugins = function (isMobileDevice, sectionResult, desktopPlugins, mobilePlugins) {
	      if (isMobileDevice && isSectionTheme(sectionResult, 'mobile', 'mobile')) {
	        return filterLegacyMobilePlugins(mobilePlugins);
	      } else if (isMobileDevice && hasSection(sectionResult, 'mobile')) {
	        return mobilePlugins;
	      } else {
	        return desktopPlugins;
	      }
	    };
	    var processPlugins = function (isMobileDevice, sectionResult, defaultOverrideSettings, settings) {
	      var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
	      var desktopPlugins = normalizePlugins(settings.plugins);
	      var mobileConfig = getSectionConfig(sectionResult, 'mobile');
	      var mobilePlugins = mobileConfig.plugins ? normalizePlugins(mobileConfig.plugins) : desktopPlugins;
	      var platformPlugins = getPlatformPlugins(isMobileDevice, sectionResult, desktopPlugins, mobilePlugins);
	      var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
	      if (Env.browser.isIE() && contains(combinedPlugins, 'rtc')) {
	        throw new Error('RTC plugin is not supported on IE 11.');
	      }
	      return Tools.extend(settings, { plugins: combinedPlugins.join(' ') });
	    };
	    var isOnMobile = function (isMobileDevice, sectionResult) {
	      return isMobileDevice && hasSection(sectionResult, 'mobile');
	    };
	    var combineSettings = function (isMobileDevice, isPhone, defaultSettings, defaultOverrideSettings, settings) {
	      var defaultDeviceSettings = isMobileDevice ? { mobile: getDefaultMobileSettings(settings.mobile || {}, isPhone) } : {};
	      var sectionResult = extractSections(['mobile'], deepMerge(defaultDeviceSettings, settings));
	      var extendedSettings = Tools.extend(defaultSettings, defaultOverrideSettings, sectionResult.settings(), isOnMobile(isMobileDevice, sectionResult) ? getSection(sectionResult, 'mobile') : {}, {
	        validate: true,
	        external_plugins: getExternalPlugins$1(defaultOverrideSettings, sectionResult.settings())
	      });
	      return processPlugins(isMobileDevice, sectionResult, defaultOverrideSettings, extendedSettings);
	    };
	    var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
	      var defaultSettings = getDefaultSettings(settings, id, documentBaseUrl, isTouch, editor);
	      return combineSettings(isPhone || isTablet, isPhone, defaultSettings, defaultOverrideSettings, settings);
	    };
	    var getFiltered = function (predicate, editor, name) {
	      return Optional.from(editor.settings[name]).filter(predicate);
	    };
	    var getParamObject = function (value) {
	      var output = {};
	      if (typeof value === 'string') {
	        each(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (val) {
	          var arr = val.split('=');
	          if (arr.length > 1) {
	            output[Tools.trim(arr[0])] = Tools.trim(arr[1]);
	          } else {
	            output[Tools.trim(arr[0])] = Tools.trim(arr[0]);
	          }
	        });
	      } else {
	        output = value;
	      }
	      return output;
	    };
	    var isArrayOf = function (p) {
	      return function (a) {
	        return isArray(a) && forall(a, p);
	      };
	    };
	    var getParam = function (editor, name, defaultVal, type) {
	      var value = name in editor.settings ? editor.settings[name] : defaultVal;
	      if (type === 'hash') {
	        return getParamObject(value);
	      } else if (type === 'string') {
	        return getFiltered(isString, editor, name).getOr(defaultVal);
	      } else if (type === 'number') {
	        return getFiltered(isNumber, editor, name).getOr(defaultVal);
	      } else if (type === 'boolean') {
	        return getFiltered(isBoolean, editor, name).getOr(defaultVal);
	      } else if (type === 'object') {
	        return getFiltered(isObject, editor, name).getOr(defaultVal);
	      } else if (type === 'array') {
	        return getFiltered(isArray, editor, name).getOr(defaultVal);
	      } else if (type === 'string[]') {
	        return getFiltered(isArrayOf(isString), editor, name).getOr(defaultVal);
	      } else if (type === 'function') {
	        return getFiltered(isFunction, editor, name).getOr(defaultVal);
	      } else {
	        return value;
	      }
	    };
	
	    var CreateIconManager = function () {
	      var lookup = {};
	      var add = function (id, iconPack) {
	        lookup[id] = iconPack;
	      };
	      var get = function (id) {
	        if (lookup[id]) {
	          return lookup[id];
	        }
	        return { icons: {} };
	      };
	      var has$1 = function (id) {
	        return has(lookup, id);
	      };
	      return {
	        add: add,
	        get: get,
	        has: has$1
	      };
	    };
	    var IconManager = CreateIconManager();
	
	    var getProp = function (propName, elm) {
	      var rawElm = elm.dom;
	      return rawElm[propName];
	    };
	    var getComputedSizeProp = function (propName, elm) {
	      return parseInt(get$5(elm, propName), 10);
	    };
	    var getClientWidth = curry(getProp, 'clientWidth');
	    var getClientHeight = curry(getProp, 'clientHeight');
	    var getMarginTop = curry(getComputedSizeProp, 'margin-top');
	    var getMarginLeft = curry(getComputedSizeProp, 'margin-left');
	    var getBoundingClientRect$1 = function (elm) {
	      return elm.dom.getBoundingClientRect();
	    };
	    var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
	      var clientWidth = getClientWidth(bodyElm);
	      var clientHeight = getClientHeight(bodyElm);
	      return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
	    };
	    var transpose = function (inline, elm, clientX, clientY) {
	      var clientRect = getBoundingClientRect$1(elm);
	      var deltaX = inline ? clientRect.left + elm.dom.clientLeft + getMarginLeft(elm) : 0;
	      var deltaY = inline ? clientRect.top + elm.dom.clientTop + getMarginTop(elm) : 0;
	      var x = clientX - deltaX;
	      var y = clientY - deltaY;
	      return {
	        x: x,
	        y: y
	      };
	    };
	    var isXYInContentArea = function (editor, clientX, clientY) {
	      var bodyElm = SugarElement.fromDom(editor.getBody());
	      var targetElm = editor.inline ? bodyElm : documentElement(bodyElm);
	      var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
	      return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
	    };
	    var fromDomSafe = function (node) {
	      return Optional.from(node).map(SugarElement.fromDom);
	    };
	    var isEditorAttachedToDom = function (editor) {
	      var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
	      return fromDomSafe(rawContainer).map(inBody).getOr(false);
	    };
	
	    var NotificationManagerImpl = function () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a NotificationManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        close: unimplemented,
	        reposition: unimplemented,
	        getArgs: unimplemented
	      };
	    };
	
	    var NotificationManager = function (editor) {
	      var notifications = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
	      };
	      var getTopNotification = function () {
	        return Optional.from(notifications[0]);
	      };
	      var isEqual = function (a, b) {
	        return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
	      };
	      var reposition = function () {
	        if (notifications.length > 0) {
	          getImplementation().reposition(notifications);
	        }
	      };
	      var addNotification = function (notification) {
	        notifications.push(notification);
	      };
	      var closeNotification = function (notification) {
	        findIndex(notifications, function (otherNotification) {
	          return otherNotification === notification;
	        }).each(function (index) {
	          notifications.splice(index, 1);
	        });
	      };
	      var open = function (spec, fireEvent) {
	        if (fireEvent === void 0) {
	          fireEvent = true;
	        }
	        if (editor.removed || !isEditorAttachedToDom(editor)) {
	          return;
	        }
	        if (fireEvent) {
	          editor.fire('BeforeOpenNotification', { notification: spec });
	        }
	        return find(notifications, function (notification) {
	          return isEqual(getImplementation().getArgs(notification), spec);
	        }).getOrThunk(function () {
	          editor.editorManager.setActive(editor);
	          var notification = getImplementation().open(spec, function () {
	            closeNotification(notification);
	            reposition();
	            getTopNotification().fold(function () {
	              return editor.focus();
	            }, function (top) {
	              return focus(SugarElement.fromDom(top.getEl()));
	            });
	          });
	          addNotification(notification);
	          reposition();
	          editor.fire('OpenNotification', __assign({}, notification));
	          return notification;
	        });
	      };
	      var close = function () {
	        getTopNotification().each(function (notification) {
	          getImplementation().close(notification);
	          closeNotification(notification);
	          reposition();
	        });
	      };
	      var getNotifications = function () {
	        return notifications;
	      };
	      var registerEvents = function (editor) {
	        editor.on('SkinLoaded', function () {
	          var serviceMessage = getServiceMessage(editor);
	          if (serviceMessage) {
	            open({
	              text: serviceMessage,
	              type: 'warning',
	              timeout: 0
	            }, false);
	          }
	        });
	        editor.on('ResizeEditor ResizeWindow NodeChange', function () {
	          Delay.requestAnimationFrame(reposition);
	        });
	        editor.on('remove', function () {
	          each(notifications.slice(), function (notification) {
	            getImplementation().close(notification);
	          });
	        });
	      };
	      registerEvents(editor);
	      return {
	        open: open,
	        close: close,
	        getNotifications: getNotifications
	      };
	    };
	
	    var PluginManager = AddOnManager.PluginManager;
	
	    var ThemeManager = AddOnManager.ThemeManager;
	
	    function WindowManagerImpl () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a WindowManager implementation.');
	      };
	      return {
	        open: unimplemented,
	        openUrl: unimplemented,
	        alert: unimplemented,
	        confirm: unimplemented,
	        close: unimplemented,
	        getParams: unimplemented,
	        setParams: unimplemented
	      };
	    }
	
	    var WindowManager = function (editor) {
	      var dialogs = [];
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
	      };
	      var funcBind = function (scope, f) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          return f ? f.apply(scope, args) : undefined;
	        };
	      };
	      var fireOpenEvent = function (dialog) {
	        editor.fire('OpenWindow', { dialog: dialog });
	      };
	      var fireCloseEvent = function (dialog) {
	        editor.fire('CloseWindow', { dialog: dialog });
	      };
	      var addDialog = function (dialog) {
	        dialogs.push(dialog);
	        fireOpenEvent(dialog);
	      };
	      var closeDialog = function (dialog) {
	        fireCloseEvent(dialog);
	        dialogs = filter(dialogs, function (otherDialog) {
	          return otherDialog !== dialog;
	        });
	        if (dialogs.length === 0) {
	          editor.focus();
	        }
	      };
	      var getTopDialog = function () {
	        return Optional.from(dialogs[dialogs.length - 1]);
	      };
	      var storeSelectionAndOpenDialog = function (openDialog) {
	        editor.editorManager.setActive(editor);
	        store(editor);
	        var dialog = openDialog();
	        addDialog(dialog);
	        return dialog;
	      };
	      var open = function (args, params) {
	        return storeSelectionAndOpenDialog(function () {
	          return getImplementation().open(args, params, closeDialog);
	        });
	      };
	      var openUrl = function (args) {
	        return storeSelectionAndOpenDialog(function () {
	          return getImplementation().openUrl(args, closeDialog);
	        });
	      };
	      var alert = function (message, callback, scope) {
	        var windowManagerImpl = getImplementation();
	        windowManagerImpl.alert(message, funcBind(scope ? scope : windowManagerImpl, callback));
	      };
	      var confirm = function (message, callback, scope) {
	        var windowManagerImpl = getImplementation();
	        windowManagerImpl.confirm(message, funcBind(scope ? scope : windowManagerImpl, callback));
	      };
	      var close = function () {
	        getTopDialog().each(function (dialog) {
	          getImplementation().close(dialog);
	          closeDialog(dialog);
	        });
	      };
	      editor.on('remove', function () {
	        each(dialogs, function (dialog) {
	          getImplementation().close(dialog);
	        });
	      });
	      return {
	        open: open,
	        openUrl: openUrl,
	        alert: alert,
	        confirm: confirm,
	        close: close
	      };
	    };
	
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        type: 'error',
	        text: message
	      });
	    };
	    var displayError = function (editor, message) {
	      if (editor._skinLoaded) {
	        displayNotification(editor, message);
	      } else {
	        editor.on('SkinLoaded', function () {
	          displayNotification(editor, message);
	        });
	      }
	    };
	    var uploadError = function (editor, message) {
	      displayError(editor, I18n.translate([
	        'Failed to upload image: {0}',
	        message
	      ]));
	    };
	    var logError = function (editor, errorType, msg) {
	      fireError(editor, errorType, { message: msg });
	      console.error(msg);
	    };
	    var createLoadError = function (type, url, name) {
	      return name ? 'Failed to load ' + type + ': ' + name + ' from url ' + url : 'Failed to load ' + type + ' url: ' + url;
	    };
	    var pluginLoadError = function (editor, url, name) {
	      logError(editor, 'PluginLoadError', createLoadError('plugin', url, name));
	    };
	    var iconsLoadError = function (editor, url, name) {
	      logError(editor, 'IconsLoadError', createLoadError('icons', url, name));
	    };
	    var languageLoadError = function (editor, url, name) {
	      logError(editor, 'LanguageLoadError', createLoadError('language', url, name));
	    };
	    var pluginInitError = function (editor, name, err) {
	      var message = I18n.translate([
	        'Failed to initialize plugin: {0}',
	        name
	      ]);
	      fireError(editor, 'PluginLoadError', { message: message });
	      initError(message, err);
	      displayError(editor, message);
	    };
	    var initError = function (message) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      var console = window.console;
	      if (console) {
	        if (console.error) {
	          console.error.apply(console, __spreadArrays([message], x));
	        } else {
	          console.log.apply(console, __spreadArrays([message], x));
	        }
	      }
	    };
	
	    var isContentCssSkinName = function (url) {
	      return /^[a-z0-9\-]+$/i.test(url);
	    };
	    var getContentCssUrls = function (editor) {
	      return transformToUrls(editor, getContentCss(editor));
	    };
	    var getFontCssUrls = function (editor) {
	      return transformToUrls(editor, getFontCss(editor));
	    };
	    var transformToUrls = function (editor, cssLinks) {
	      var skinUrl = editor.editorManager.baseURL + '/skins/content';
	      var suffix = editor.editorManager.suffix;
	      var contentCssFile = 'content' + suffix + '.css';
	      var inline = editor.inline === true;
	      return map(cssLinks, function (url) {
	        if (isContentCssSkinName(url) && !inline) {
	          return skinUrl + '/' + url + '/' + contentCssFile;
	        } else {
	          return editor.documentBaseURI.toAbsolute(url);
	        }
	      });
	    };
	    var appendContentCssFromSettings = function (editor) {
	      editor.contentCSS = editor.contentCSS.concat(getContentCssUrls(editor), getFontCssUrls(editor));
	    };
	
	    var UploadStatus = function () {
	      var PENDING = 1, UPLOADED = 2;
	      var blobUriStatuses = {};
	      var createStatus = function (status, resultUri) {
	        return {
	          status: status,
	          resultUri: resultUri
	        };
	      };
	      var hasBlobUri = function (blobUri) {
	        return blobUri in blobUriStatuses;
	      };
	      var getResultUri = function (blobUri) {
	        var result = blobUriStatuses[blobUri];
	        return result ? result.resultUri : null;
	      };
	      var isPending = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
	      };
	      var isUploaded = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
	      };
	      var markPending = function (blobUri) {
	        blobUriStatuses[blobUri] = createStatus(PENDING, null);
	      };
	      var markUploaded = function (blobUri, resultUri) {
	        blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
	      };
	      var removeFailed = function (blobUri) {
	        delete blobUriStatuses[blobUri];
	      };
	      var destroy = function () {
	        blobUriStatuses = {};
	      };
	      return {
	        hasBlobUri: hasBlobUri,
	        getResultUri: getResultUri,
	        isPending: isPending,
	        isUploaded: isUploaded,
	        markPending: markPending,
	        markUploaded: markUploaded,
	        removeFailed: removeFailed,
	        destroy: destroy
	      };
	    };
	
	    var count$1 = 0;
	    var seed = function () {
	      var rnd = function () {
	        return Math.round(Math.random() * 4294967295).toString(36);
	      };
	      var now = new Date().getTime();
	      return 's' + now.toString(36) + rnd() + rnd() + rnd();
	    };
	    var uuid = function (prefix) {
	      return prefix + count$1++ + seed();
	    };
	
	    var BlobCache = function () {
	      var cache = [];
	      var mimeToExt = function (mime) {
	        var mimes = {
	          'image/jpeg': 'jpg',
	          'image/jpg': 'jpg',
	          'image/gif': 'gif',
	          'image/png': 'png',
	          'image/apng': 'apng',
	          'image/avif': 'avif',
	          'image/svg+xml': 'svg',
	          'image/webp': 'webp',
	          'image/bmp': 'bmp',
	          'image/tiff': 'tiff'
	        };
	        return mimes[mime.toLowerCase()] || 'dat';
	      };
	      var create = function (o, blob, base64, name, filename) {
	        if (isString(o)) {
	          var id = o;
	          return toBlobInfo({
	            id: id,
	            name: name,
	            filename: filename,
	            blob: blob,
	            base64: base64
	          });
	        } else if (isObject(o)) {
	          return toBlobInfo(o);
	        } else {
	          throw new Error('Unknown input type');
	        }
	      };
	      var toBlobInfo = function (o) {
	        if (!o.blob || !o.base64) {
	          throw new Error('blob and base64 representations of the image are required for BlobInfo to be created');
	        }
	        var id = o.id || uuid('blobid');
	        var name = o.name || id;
	        var blob = o.blob;
	        return {
	          id: constant(id),
	          name: constant(name),
	          filename: constant(o.filename || name + '.' + mimeToExt(blob.type)),
	          blob: constant(blob),
	          base64: constant(o.base64),
	          blobUri: constant(o.blobUri || URL.createObjectURL(blob)),
	          uri: constant(o.uri)
	        };
	      };
	      var add = function (blobInfo) {
	        if (!get(blobInfo.id())) {
	          cache.push(blobInfo);
	        }
	      };
	      var findFirst = function (predicate) {
	        return find(cache, predicate).getOrUndefined();
	      };
	      var get = function (id) {
	        return findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.id() === id;
	        });
	      };
	      var getByUri = function (blobUri) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.blobUri() === blobUri;
	        });
	      };
	      var getByData = function (base64, type) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.base64() === base64 && blobInfo.blob().type === type;
	        });
	      };
	      var removeByUri = function (blobUri) {
	        cache = filter(cache, function (blobInfo) {
	          if (blobInfo.blobUri() === blobUri) {
	            URL.revokeObjectURL(blobInfo.blobUri());
	            return false;
	          }
	          return true;
	        });
	      };
	      var destroy = function () {
	        each(cache, function (cachedBlobInfo) {
	          URL.revokeObjectURL(cachedBlobInfo.blobUri());
	        });
	        cache = [];
	      };
	      return {
	        create: create,
	        add: add,
	        get: get,
	        getByUri: getByUri,
	        getByData: getByData,
	        findFirst: findFirst,
	        removeByUri: removeByUri,
	        destroy: destroy
	      };
	    };
	
	    var Uploader = function (uploadStatus, settings) {
	      var pendingPromises = {};
	      var pathJoin = function (path1, path2) {
	        if (path1) {
	          return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	        }
	        return path2;
	      };
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr = new XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	        xhr.onerror = function () {
	          failure('Image upload failed due to a XHR Transport error. Code: ' + xhr.status);
	        };
	        xhr.onload = function () {
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure('HTTP Error: ' + xhr.status);
	            return;
	          }
	          var json = JSON.parse(xhr.responseText);
	          if (!json || typeof json.location !== 'string') {
	            failure('Invalid JSON: ' + xhr.responseText);
	            return;
	          }
	          success(pathJoin(settings.basePath, json.location));
	        };
	        var formData = new FormData();
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	        xhr.send(formData);
	      };
	      var noUpload = function () {
	        return new promiseObj(function (resolve) {
	          resolve([]);
	        });
	      };
	      var handlerSuccess = function (blobInfo, url) {
	        return {
	          url: url,
	          blobInfo: blobInfo,
	          status: true
	        };
	      };
	      var handlerFailure = function (blobInfo, message, options) {
	        return {
	          url: '',
	          blobInfo: blobInfo,
	          status: false,
	          error: {
	            message: message,
	            options: options
	          }
	        };
	      };
	      var resolvePending = function (blobUri, result) {
	        Tools.each(pendingPromises[blobUri], function (resolve) {
	          resolve(result);
	        });
	        delete pendingPromises[blobUri];
	      };
	      var uploadBlobInfo = function (blobInfo, handler, openNotification) {
	        uploadStatus.markPending(blobInfo.blobUri());
	        return new promiseObj(function (resolve) {
	          var notification, progress;
	          try {
	            var closeNotification_1 = function () {
	              if (notification) {
	                notification.close();
	                progress = noop;
	              }
	            };
	            var success = function (url) {
	              closeNotification_1();
	              uploadStatus.markUploaded(blobInfo.blobUri(), url);
	              resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
	              resolve(handlerSuccess(blobInfo, url));
	            };
	            var failure = function (error, options) {
	              var failureOptions = options ? options : {};
	              closeNotification_1();
	              uploadStatus.removeFailed(blobInfo.blobUri());
	              resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error, failureOptions));
	              resolve(handlerFailure(blobInfo, error, failureOptions));
	            };
	            progress = function (percent) {
	              if (percent < 0 || percent > 100) {
	                return;
	              }
	              Optional.from(notification).orThunk(function () {
	                return Optional.from(openNotification).map(apply);
	              }).each(function (n) {
	                notification = n;
	                n.progressBar.value(percent);
	              });
	            };
	            handler(blobInfo, success, failure, progress);
	          } catch (ex) {
	            resolve(handlerFailure(blobInfo, ex.message, {}));
	          }
	        });
	      };
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	      var pendingUploadBlobInfo = function (blobInfo) {
	        var blobUri = blobInfo.blobUri();
	        return new promiseObj(function (resolve) {
	          pendingPromises[blobUri] = pendingPromises[blobUri] || [];
	          pendingPromises[blobUri].push(resolve);
	        });
	      };
	      var uploadBlobs = function (blobInfos, openNotification) {
	        blobInfos = Tools.grep(blobInfos, function (blobInfo) {
	          return !uploadStatus.isUploaded(blobInfo.blobUri());
	        });
	        return promiseObj.all(Tools.map(blobInfos, function (blobInfo) {
	          return uploadStatus.isPending(blobInfo.blobUri()) ? pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
	        }));
	      };
	      var upload = function (blobInfos, openNotification) {
	        return !settings.url && isDefaultHandler(settings.handler) ? noUpload() : uploadBlobs(blobInfos, openNotification);
	      };
	      if (isFunction(settings.handler) === false) {
	        settings.handler = defaultHandler;
	      }
	      return { upload: upload };
	    };
	
	    var openNotification = function (editor) {
	      return function () {
	        return editor.notificationManager.open({
	          text: editor.translate('Image uploading...'),
	          type: 'info',
	          timeout: -1,
	          progressBar: true
	        });
	      };
	    };
	    var createUploader = function (editor, uploadStatus) {
	      return Uploader(uploadStatus, {
	        url: getImageUploadUrl(editor),
	        basePath: getImageUploadBasePath(editor),
	        credentials: getImagesUploadCredentials(editor),
	        handler: getImagesUploadHandler(editor)
	      });
	    };
	    var ImageUploader = function (editor) {
	      var uploadStatus = UploadStatus();
	      var uploader = createUploader(editor, uploadStatus);
	      return {
	        upload: function (blobInfos, showNotification) {
	          if (showNotification === void 0) {
	            showNotification = true;
	          }
	          return uploader.upload(blobInfos, showNotification ? openNotification(editor) : undefined);
	        }
	      };
	    };
	
	    var UploadChangeHandler = function (editor) {
	      var lastChangedLevel = Cell(null);
	      editor.on('change AddUndo', function (e) {
	        lastChangedLevel.set(__assign({}, e.level));
	      });
	      var fireIfChanged = function () {
	        var data = editor.undoManager.data;
	        last(data).filter(function (level) {
	          return !isEq$4(lastChangedLevel.get(), level);
	        }).each(function (level) {
	          editor.setDirty(true);
	          editor.fire('change', {
	            level: level,
	            lastLevel: get(data, data.length - 2).getOrNull()
	          });
	        });
	      };
	      return { fireIfChanged: fireIfChanged };
	    };
	    var EditorUpload = function (editor) {
	      var blobCache = BlobCache();
	      var uploader, imageScanner;
	      var uploadStatus = UploadStatus();
	      var urlFilters = [];
	      var changeHandler = UploadChangeHandler(editor);
	      var aliveGuard = function (callback) {
	        return function (result) {
	          if (editor.selection) {
	            return callback(result);
	          }
	          return [];
	        };
	      };
	      var cacheInvalidator = function (url) {
	        return url + (url.indexOf('?') === -1 ? '?' : '&') + new Date().getTime();
	      };
	      var replaceString = function (content, search, replace) {
	        var index = 0;
	        do {
	          index = content.indexOf(search, index);
	          if (index !== -1) {
	            content = content.substring(0, index) + replace + content.substr(index + search.length);
	            index += replace.length - search.length + 1;
	          }
	        } while (index !== -1);
	        return content;
	      };
	      var replaceImageUrl = function (content, targetUrl, replacementUrl) {
	        var replacementString = 'src="' + replacementUrl + '"' + (replacementUrl === Env.transparentSrc ? ' data-mce-placeholder="1"' : '');
	        content = replaceString(content, 'src="' + targetUrl + '"', replacementString);
	        content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
	        return content;
	      };
	      var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
	        each(editor.undoManager.data, function (level) {
	          if (level.type === 'fragmented') {
	            level.fragments = map(level.fragments, function (fragment) {
	              return replaceImageUrl(fragment, targetUrl, replacementUrl);
	            });
	          } else {
	            level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
	          }
	        });
	      };
	      var replaceImageUriInView = function (image, resultUri) {
	        var src = editor.convertURL(resultUri, 'src');
	        replaceUrlInUndoStack(image.src, resultUri);
	        editor.$(image).attr({
	          'src': shouldReuseFileName(editor) ? cacheInvalidator(resultUri) : resultUri,
	          'data-mce-src': src
	        });
	      };
	      var uploadImages = function (callback) {
	        if (!uploader) {
	          uploader = createUploader(editor, uploadStatus);
	        }
	        return scanForImages().then(aliveGuard(function (imageInfos) {
	          var blobInfos = map(imageInfos, function (imageInfo) {
	            return imageInfo.blobInfo;
	          });
	          return uploader.upload(blobInfos, openNotification(editor)).then(aliveGuard(function (result) {
	            var imagesToRemove = [];
	            var filteredResult = map(result, function (uploadInfo, index) {
	              var blobInfo = imageInfos[index].blobInfo;
	              var image = imageInfos[index].image;
	              if (uploadInfo.status && shouldReplaceBlobUris(editor)) {
	                blobCache.removeByUri(image.src);
	                replaceImageUriInView(image, uploadInfo.url);
	              } else if (uploadInfo.error) {
	                if (uploadInfo.error.options.remove) {
	                  replaceUrlInUndoStack(image.getAttribute('src'), Env.transparentSrc);
	                  imagesToRemove.push(image);
	                }
	                uploadError(editor, uploadInfo.error.message);
	              }
	              return {
	                element: image,
	                status: uploadInfo.status,
	                uploadUri: uploadInfo.url,
	                blobInfo: blobInfo
	              };
	            });
	            if (filteredResult.length > 0) {
	              changeHandler.fireIfChanged();
	            }
	            if (imagesToRemove.length > 0) {
	              if (isRtc(editor)) {
	                console.error('Removing images on failed uploads is currently unsupported for RTC');
	              } else {
	                editor.undoManager.transact(function () {
	                  each(imagesToRemove, function (element) {
	                    editor.dom.remove(element);
	                    blobCache.removeByUri(element.src);
	                  });
	                });
	              }
	            }
	            if (callback) {
	              callback(filteredResult);
	            }
	            return filteredResult;
	          }));
	        }));
	      };
	      var uploadImagesAuto = function (callback) {
	        if (isAutomaticUploadsEnabled(editor)) {
	          return uploadImages(callback);
	        }
	      };
	      var isValidDataUriImage = function (imgElm) {
	        if (forall(urlFilters, function (filter) {
	            return filter(imgElm);
	          }) === false) {
	          return false;
	        }
	        if (imgElm.getAttribute('src').indexOf('data:') === 0) {
	          var dataImgFilter = getImagesDataImgFilter(editor);
	          return dataImgFilter(imgElm);
	        }
	        return true;
	      };
	      var addFilter = function (filter) {
	        urlFilters.push(filter);
	      };
	      var scanForImages = function () {
	        if (!imageScanner) {
	          imageScanner = ImageScanner(uploadStatus, blobCache);
	        }
	        return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
	          result = filter(result, function (resultItem) {
	            if (typeof resultItem === 'string') {
	              displayError(editor, resultItem);
	              return false;
	            }
	            return true;
	          });
	          each(result, function (resultItem) {
	            replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
	            resultItem.image.src = resultItem.blobInfo.blobUri();
	            resultItem.image.removeAttribute('data-mce-src');
	          });
	          return result;
	        }));
	      };
	      var destroy = function () {
	        blobCache.destroy();
	        uploadStatus.destroy();
	        imageScanner = uploader = null;
	      };
	      var replaceBlobUris = function (content) {
	        return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
	          var resultUri = uploadStatus.getResultUri(blobUri);
	          if (resultUri) {
	            return 'src="' + resultUri + '"';
	          }
	          var blobInfo = blobCache.getByUri(blobUri);
	          if (!blobInfo) {
	            blobInfo = foldl(editor.editorManager.get(), function (result, editor) {
	              return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
	            }, null);
	          }
	          if (blobInfo) {
	            var blob = blobInfo.blob();
	            return 'src="data:' + blob.type + ';base64,' + blobInfo.base64() + '"';
	          }
	          return match;
	        });
	      };
	      editor.on('SetContent', function () {
	        if (isAutomaticUploadsEnabled(editor)) {
	          uploadImagesAuto();
	        } else {
	          scanForImages();
	        }
	      });
	      editor.on('RawSaveContent', function (e) {
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('GetContent', function (e) {
	        if (e.source_view || e.format === 'raw' || e.format === 'tree') {
	          return;
	        }
	        e.content = replaceBlobUris(e.content);
	      });
	      editor.on('PostRender', function () {
	        editor.parser.addNodeFilter('img', function (images) {
	          each(images, function (img) {
	            var src = img.attr('src');
	            if (blobCache.getByUri(src)) {
	              return;
	            }
	            var resultUri = uploadStatus.getResultUri(src);
	            if (resultUri) {
	              img.attr('src', resultUri);
	            }
	          });
	        });
	      });
	      return {
	        blobCache: blobCache,
	        addFilter: addFilter,
	        uploadImages: uploadImages,
	        uploadImagesAuto: uploadImagesAuto,
	        scanForImages: scanForImages,
	        destroy: destroy
	      };
	    };
	
	    var get$a = function (dom) {
	      var formats = {
	        valigntop: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'top' }
	          }],
	        valignmiddle: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'middle' }
	          }],
	        valignbottom: [{
	            selector: 'td,th',
	            styles: { verticalAlign: 'bottom' }
	          }],
	        alignleft: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-left',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'left' },
	            inherit: false,
	            preview: false,
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table,audio,video',
	            collapsed: false,
	            styles: { float: 'left' },
	            preview: 'font-family font-size'
	          }
	        ],
	        aligncenter: [
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'center' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-center',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'img,audio,video',
	            collapsed: false,
	            styles: {
	              display: 'block',
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: false
	          },
	          {
	            selector: 'table',
	            collapsed: false,
	            styles: {
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignright: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-right',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'right' },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table,audio,video',
	            collapsed: false,
	            styles: { float: 'right' },
	            preview: 'font-family font-size'
	          }
	        ],
	        alignjustify: [{
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: { textAlign: 'justify' },
	            inherit: false,
	            defaultBlock: 'div',
	            preview: 'font-family font-size'
	          }],
	        bold: [
	          {
	            inline: 'strong',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          },
	          {
	            inline: 'span',
	            styles: { fontWeight: 'bold' }
	          },
	          {
	            inline: 'b',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        italic: [
	          {
	            inline: 'em',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          },
	          {
	            inline: 'span',
	            styles: { fontStyle: 'italic' }
	          },
	          {
	            inline: 'i',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        underline: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'underline' },
	            exact: true
	          },
	          {
	            inline: 'u',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        strikethrough: [
	          {
	            inline: 'span',
	            styles: { textDecoration: 'line-through' },
	            exact: true
	          },
	          {
	            inline: 'strike',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          },
	          {
	            inline: 's',
	            remove: 'all',
	            preserve_attributes: [
	              'class',
	              'style'
	            ]
	          }
	        ],
	        forecolor: {
	          inline: 'span',
	          styles: { color: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        hilitecolor: {
	          inline: 'span',
	          styles: { backgroundColor: '%value' },
	          links: true,
	          remove_similar: true,
	          clear_child_styles: true
	        },
	        fontname: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontFamily: '%value' },
	          clear_child_styles: true
	        },
	        fontsize: {
	          inline: 'span',
	          toggle: false,
	          styles: { fontSize: '%value' },
	          clear_child_styles: true
	        },
	        lineheight: {
	          selector: 'h1,h2,h3,h4,h5,h6,p,li,td,th,div',
	          defaultBlock: 'p',
	          styles: { lineHeight: '%value' }
	        },
	        fontsize_class: {
	          inline: 'span',
	          attributes: { class: '%value' }
	        },
	        blockquote: {
	          block: 'blockquote',
	          wrapper: true,
	          remove: 'all'
	        },
	        subscript: { inline: 'sub' },
	        superscript: { inline: 'sup' },
	        code: { inline: 'code' },
	        link: {
	          inline: 'a',
	          selector: 'a',
	          remove: 'all',
	          split: true,
	          deep: true,
	          onmatch: function (node, _fmt, _itemName) {
	            return isElement$1(node) && node.hasAttribute('href');
	          },
	          onformat: function (elm, _fmt, vars) {
	            Tools.each(vars, function (value, key) {
	              dom.setAttrib(elm, key, value);
	            });
	          }
	        },
	        removeformat: [
	          {
	            selector: 'b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small',
	            remove: 'all',
	            split: true,
	            expand: false,
	            block_expand: true,
	            deep: true
	          },
	          {
	            selector: 'span',
	            attributes: [
	              'style',
	              'class'
	            ],
	            remove: 'empty',
	            split: true,
	            expand: false,
	            deep: true
	          },
	          {
	            selector: '*',
	            attributes: [
	              'style',
	              'class'
	            ],
	            split: false,
	            expand: false,
	            deep: true
	          }
	        ]
	      };
	      Tools.each('p h1 h2 h3 h4 h5 h6 div address pre dt dd samp'.split(/\s/), function (name) {
	        formats[name] = {
	          block: name,
	          remove: 'all'
	        };
	      });
	      return formats;
	    };
	
	    var FormatRegistry = function (editor) {
	      var formats = {};
	      var get = function (name) {
	        return name ? formats[name] : formats;
	      };
	      var has$1 = function (name) {
	        return has(formats, name);
	      };
	      var register = function (name, format) {
	        if (name) {
	          if (typeof name !== 'string') {
	            Tools.each(name, function (format, name) {
	              register(name, format);
	            });
	          } else {
	            if (!isArray(format)) {
	              format = [format];
	            }
	            Tools.each(format, function (format) {
	              if (typeof format.deep === 'undefined') {
	                format.deep = !format.selector;
	              }
	              if (typeof format.split === 'undefined') {
	                format.split = !format.selector || format.inline;
	              }
	              if (typeof format.remove === 'undefined' && format.selector && !format.inline) {
	                format.remove = 'none';
	              }
	              if (format.selector && format.inline) {
	                format.mixed = true;
	                format.block_expand = true;
	              }
	              if (typeof format.classes === 'string') {
	                format.classes = format.classes.split(/\s+/);
	              }
	            });
	            formats[name] = format;
	          }
	        }
	      };
	      var unregister = function (name) {
	        if (name && formats[name]) {
	          delete formats[name];
	        }
	        return formats;
	      };
	      register(get$a(editor.dom));
	      register(getFormats(editor));
	      return {
	        get: get,
	        has: has$1,
	        register: register,
	        unregister: unregister
	      };
	    };
	
	    var each$e = Tools.each;
	    var dom = DOMUtils.DOM;
	    var parsedSelectorToHtml = function (ancestry, editor) {
	      var elm, item, fragment;
	      var schema = editor && editor.schema || Schema({});
	      var decorate = function (elm, item) {
	        if (item.classes.length) {
	          dom.addClass(elm, item.classes.join(' '));
	        }
	        dom.setAttribs(elm, item.attrs);
	      };
	      var createElement = function (sItem) {
	        item = typeof sItem === 'string' ? {
	          name: sItem,
	          classes: [],
	          attrs: {}
	        } : sItem;
	        var elm = dom.create(item.name);
	        decorate(elm, item);
	        return elm;
	      };
	      var getRequiredParent = function (elm, candidate) {
	        var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
	        var elmRule = schema.getElementRule(name);
	        var parentsRequired = elmRule && elmRule.parentsRequired;
	        if (parentsRequired && parentsRequired.length) {
	          return candidate && Tools.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
	        } else {
	          return false;
	        }
	      };
	      var wrapInHtml = function (elm, ancestry, siblings) {
	        var parent, parentCandidate;
	        var ancestor = ancestry.length > 0 && ancestry[0];
	        var ancestorName = ancestor && ancestor.name;
	        var parentRequired = getRequiredParent(elm, ancestorName);
	        if (parentRequired) {
	          if (ancestorName === parentRequired) {
	            parentCandidate = ancestry[0];
	            ancestry = ancestry.slice(1);
	          } else {
	            parentCandidate = parentRequired;
	          }
	        } else if (ancestor) {
	          parentCandidate = ancestry[0];
	          ancestry = ancestry.slice(1);
	        } else if (!siblings) {
	          return elm;
	        }
	        if (parentCandidate) {
	          parent = createElement(parentCandidate);
	          parent.appendChild(elm);
	        }
	        if (siblings) {
	          if (!parent) {
	            parent = dom.create('div');
	            parent.appendChild(elm);
	          }
	          Tools.each(siblings, function (sibling) {
	            var siblingElm = createElement(sibling);
	            parent.insertBefore(siblingElm, elm);
	          });
	        }
	        return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
	      };
	      if (ancestry && ancestry.length) {
	        item = ancestry[0];
	        elm = createElement(item);
	        fragment = dom.create('div');
	        fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
	        return fragment;
	      } else {
	        return '';
	      }
	    };
	    var parseSelectorItem = function (item) {
	      var tagName;
	      var obj = {
	        classes: [],
	        attrs: {}
	      };
	      item = obj.selector = Tools.trim(item);
	      if (item !== '*') {
	        tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
	          switch ($1) {
	          case '#':
	            obj.attrs.id = $2;
	            break;
	          case '.':
	            obj.classes.push($2);
	            break;
	          case ':':
	            if (Tools.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
	              obj.attrs[$2] = $2;
	            }
	            break;
	          }
	          if ($3 === '[') {
	            var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
	            if (m) {
	              obj.attrs[m[1]] = m[2];
	            }
	          }
	          return '';
	        });
	      }
	      obj.name = tagName || 'div';
	      return obj;
	    };
	    var parseSelector = function (selector) {
	      if (!selector || typeof selector !== 'string') {
	        return [];
	      }
	      selector = selector.split(/\s*,\s*/)[0];
	      selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
	      return Tools.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
	        var siblings = Tools.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
	        var obj = siblings.pop();
	        if (siblings.length) {
	          obj.siblings = siblings;
	        }
	        return obj;
	      }).reverse();
	    };
	    var getCssText = function (editor, format) {
	      var name, previewFrag;
	      var previewCss = '', parentFontSize;
	      var previewStyles = getPreviewStyles(editor);
	      if (previewStyles === '') {
	        return '';
	      }
	      var removeVars = function (val) {
	        return val.replace(/%(\w+)/g, '');
	      };
	      if (typeof format === 'string') {
	        format = editor.formatter.get(format);
	        if (!format) {
	          return;
	        }
	        format = format[0];
	      }
	      if ('preview' in format) {
	        var previewOpt = get$1(format, 'preview');
	        if (previewOpt.is(false)) {
	          return '';
	        } else {
	          previewStyles = previewOpt.getOr(previewStyles);
	        }
	      }
	      name = format.block || format.inline || 'span';
	      var items = parseSelector(format.selector);
	      if (items.length) {
	        if (!items[0].name) {
	          items[0].name = name;
	        }
	        name = format.selector;
	        previewFrag = parsedSelectorToHtml(items, editor);
	      } else {
	        previewFrag = parsedSelectorToHtml([name], editor);
	      }
	      var previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
	      each$e(format.styles, function (value, name) {
	        var newValue = removeVars(value);
	        if (newValue) {
	          dom.setStyle(previewElm, name, newValue);
	        }
	      });
	      each$e(format.attributes, function (value, name) {
	        var newValue = removeVars(value);
	        if (newValue) {
	          dom.setAttrib(previewElm, name, newValue);
	        }
	      });
	      each$e(format.classes, function (value) {
	        var newValue = removeVars(value);
	        if (!dom.hasClass(previewElm, newValue)) {
	          dom.addClass(previewElm, newValue);
	        }
	      });
	      editor.fire('PreviewFormats');
	      dom.setStyles(previewFrag, {
	        position: 'absolute',
	        left: -65535
	      });
	      editor.getBody().appendChild(previewFrag);
	      parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
	      parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
	      each$e(previewStyles.split(' '), function (name) {
	        var value = dom.getStyle(previewElm, name, true);
	        if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
	          value = dom.getStyle(editor.getBody(), name, true);
	          if (dom.toHex(value).toLowerCase() === '#ffffff') {
	            return;
	          }
	        }
	        if (name === 'color') {
	          if (dom.toHex(value).toLowerCase() === '#000000') {
	            return;
	          }
	        }
	        if (name === 'font-size') {
	          if (/em|%$/.test(value)) {
	            if (parentFontSize === 0) {
	              return;
	            }
	            var numValue = parseFloat(value) / (/%$/.test(value) ? 100 : 1);
	            value = numValue * parentFontSize + 'px';
	          }
	        }
	        if (name === 'border' && value) {
	          previewCss += 'padding:0 2px;';
	        }
	        previewCss += name + ':' + value + ';';
	      });
	      editor.fire('AfterPreviewFormats');
	      dom.remove(previewFrag);
	      return previewCss;
	    };
	
	    var setup$6 = function (editor) {
	      editor.addShortcut('meta+b', '', 'Bold');
	      editor.addShortcut('meta+i', '', 'Italic');
	      editor.addShortcut('meta+u', '', 'Underline');
	      for (var i = 1; i <= 6; i++) {
	        editor.addShortcut('access+' + i, '', [
	          'FormatBlock',
	          false,
	          'h' + i
	        ]);
	      }
	      editor.addShortcut('access+7', '', [
	        'FormatBlock',
	        false,
	        'p'
	      ]);
	      editor.addShortcut('access+8', '', [
	        'FormatBlock',
	        false,
	        'div'
	      ]);
	      editor.addShortcut('access+9', '', [
	        'FormatBlock',
	        false,
	        'address'
	      ]);
	    };
	
	    var Formatter = function (editor) {
	      var formats = FormatRegistry(editor);
	      var formatChangeState = Cell(null);
	      setup$6(editor);
	      setup$3(editor);
	      return {
	        get: formats.get,
	        has: formats.has,
	        register: formats.register,
	        unregister: formats.unregister,
	        apply: function (name, vars, node) {
	          applyFormat$1(editor, name, vars, node);
	        },
	        remove: function (name, vars, node, similar) {
	          removeFormat$1(editor, name, vars, node, similar);
	        },
	        toggle: function (name, vars, node) {
	          toggleFormat(editor, name, vars, node);
	        },
	        match: function (name, vars, node) {
	          return matchFormat(editor, name, vars, node);
	        },
	        closest: function (names) {
	          return closestFormat(editor, names);
	        },
	        matchAll: function (names, vars) {
	          return matchAllFormats(editor, names, vars);
	        },
	        matchNode: function (node, names, vars, similar) {
	          return matchNodeFormat(editor, node, names, vars, similar);
	        },
	        canApply: function (name) {
	          return canApplyFormat(editor, name);
	        },
	        formatChanged: function (formats, callback, similar) {
	          return formatChanged(editor, formatChangeState, formats, callback, similar);
	        },
	        getCssText: curry(getCssText, editor)
	      };
	    };
	
	    var registerEvents$1 = function (editor, undoManager, locks) {
	      var isFirstTypedCharacter = Cell(false);
	      var addNonTypingUndoLevel = function (e) {
	        setTyping(undoManager, false, locks);
	        undoManager.add({}, e);
	      };
	      editor.on('init', function () {
	        undoManager.add();
	      });
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command.toLowerCase();
	        if (cmd !== 'undo' && cmd !== 'redo' && cmd !== 'mcerepaint') {
	          endTyping(undoManager, locks);
	          undoManager.beforeChange();
	        }
	      });
	      editor.on('ExecCommand', function (e) {
	        var cmd = e.command.toLowerCase();
	        if (cmd !== 'undo' && cmd !== 'redo' && cmd !== 'mcerepaint') {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.on('ObjectResizeStart cut', function () {
	        undoManager.beforeChange();
	      });
	      editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
	      editor.on('dragend', addNonTypingUndoLevel);
	      editor.on('keyup', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45 || e.ctrlKey) {
	          addNonTypingUndoLevel();
	          editor.nodeChanged();
	        }
	        if (keyCode === 46 || keyCode === 8) {
	          editor.nodeChanged();
	        }
	        if (isFirstTypedCharacter.get() && undoManager.typing && isEq$4(createFromEditor(editor), undoManager.data[0]) === false) {
	          if (editor.isDirty() === false) {
	            editor.setDirty(true);
	            editor.fire('change', {
	              level: undoManager.data[0],
	              lastLevel: null
	            });
	          }
	          editor.fire('TypingUndo');
	          isFirstTypedCharacter.set(false);
	          editor.nodeChanged();
	        }
	      });
	      editor.on('keydown', function (e) {
	        var keyCode = e.keyCode;
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	        if (keyCode >= 33 && keyCode <= 36 || keyCode >= 37 && keyCode <= 40 || keyCode === 45) {
	          if (undoManager.typing) {
	            addNonTypingUndoLevel(e);
	          }
	          return;
	        }
	        var modKey = e.ctrlKey && !e.altKey || e.metaKey;
	        if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !undoManager.typing && !modKey) {
	          undoManager.beforeChange();
	          setTyping(undoManager, true, locks);
	          undoManager.add({}, e);
	          isFirstTypedCharacter.set(true);
	        }
	      });
	      editor.on('mousedown', function (e) {
	        if (undoManager.typing) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      var isInsertReplacementText = function (event) {
	        return event.inputType === 'insertReplacementText';
	      };
	      var isInsertTextDataNull = function (event) {
	        return event.inputType === 'insertText' && event.data === null;
	      };
	      var isInsertFromPasteOrDrop = function (event) {
	        return event.inputType === 'insertFromPaste' || event.inputType === 'insertFromDrop';
	      };
	      editor.on('input', function (e) {
	        if (e.inputType && (isInsertReplacementText(e) || isInsertTextDataNull(e) || isInsertFromPasteOrDrop(e))) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	      editor.on('AddUndo Undo Redo ClearUndos', function (e) {
	        if (!e.isDefaultPrevented()) {
	          editor.nodeChanged();
	        }
	      });
	    };
	    var addKeyboardShortcuts = function (editor) {
	      editor.addShortcut('meta+z', '', 'Undo');
	      editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
	    };
	
	    var UndoManager = function (editor) {
	      var beforeBookmark = Cell(Optional.none());
	      var locks = Cell(0);
	      var index = Cell(0);
	      var undoManager = {
	        data: [],
	        typing: false,
	        beforeChange: function () {
	          beforeChange$1(editor, locks, beforeBookmark);
	        },
	        add: function (level, event) {
	          return addUndoLevel$1(editor, undoManager, index, locks, beforeBookmark, level, event);
	        },
	        undo: function () {
	          return undo$1(editor, undoManager, locks, index);
	        },
	        redo: function () {
	          return redo$1(editor, index, undoManager.data);
	        },
	        clear: function () {
	          clear$1(editor, undoManager, index);
	        },
	        reset: function () {
	          reset$1(editor, undoManager);
	        },
	        hasUndo: function () {
	          return hasUndo$1(editor, undoManager, index);
	        },
	        hasRedo: function () {
	          return hasRedo$1(editor, undoManager, index);
	        },
	        transact: function (callback) {
	          return transact$1(editor, undoManager, locks, callback);
	        },
	        ignore: function (callback) {
	          ignore$1(editor, locks, callback);
	        },
	        extra: function (callback1, callback2) {
	          extra$1(editor, undoManager, index, callback1, callback2);
	        }
	      };
	      if (!isRtc(editor)) {
	        registerEvents$1(editor, undoManager, locks);
	      }
	      addKeyboardShortcuts(editor);
	      return undoManager;
	    };
	
	    var nonTypingKeycodes = [
	      9,
	      27,
	      VK.HOME,
	      VK.END,
	      19,
	      20,
	      44,
	      144,
	      145,
	      33,
	      34,
	      45,
	      16,
	      17,
	      18,
	      91,
	      92,
	      93,
	      VK.DOWN,
	      VK.UP,
	      VK.LEFT,
	      VK.RIGHT
	    ].concat(Env.browser.isFirefox() ? [224] : []);
	    var placeholderAttr = 'data-mce-placeholder';
	    var isKeyboardEvent = function (e) {
	      return e.type === 'keydown' || e.type === 'keyup';
	    };
	    var isDeleteEvent = function (e) {
	      var keyCode = e.keyCode;
	      return keyCode === VK.BACKSPACE || keyCode === VK.DELETE;
	    };
	    var isNonTypingKeyboardEvent = function (e) {
	      if (isKeyboardEvent(e)) {
	        var keyCode = e.keyCode;
	        return !isDeleteEvent(e) && (VK.metaKeyPressed(e) || e.altKey || keyCode >= 112 && keyCode <= 123 || contains(nonTypingKeycodes, keyCode));
	      } else {
	        return false;
	      }
	    };
	    var isTypingKeyboardEvent = function (e) {
	      return isKeyboardEvent(e) && !(isDeleteEvent(e) || e.type === 'keyup' && e.keyCode === 229);
	    };
	    var isVisuallyEmpty = function (dom, rootElm, forcedRootBlock) {
	      if (isEmpty(SugarElement.fromDom(rootElm), false)) {
	        var isForcedRootBlockFalse = forcedRootBlock === '';
	        var firstElement = rootElm.firstElementChild;
	        if (!firstElement) {
	          return true;
	        } else if (dom.getStyle(rootElm.firstElementChild, 'padding-left') || dom.getStyle(rootElm.firstElementChild, 'padding-right')) {
	          return false;
	        } else {
	          return isForcedRootBlockFalse ? !dom.isBlock(firstElement) : forcedRootBlock === firstElement.nodeName.toLowerCase();
	        }
	      } else {
	        return false;
	      }
	    };
	    var setup$7 = function (editor) {
	      var dom = editor.dom;
	      var rootBlock = getForcedRootBlock(editor);
	      var placeholder = getPlaceholder(editor);
	      var updatePlaceholder = function (e, initial) {
	        if (isNonTypingKeyboardEvent(e)) {
	          return;
	        }
	        var body = editor.getBody();
	        var showPlaceholder = isTypingKeyboardEvent(e) ? false : isVisuallyEmpty(dom, body, rootBlock);
	        var isPlaceholderShown = dom.getAttrib(body, placeholderAttr) !== '';
	        if (isPlaceholderShown !== showPlaceholder || initial) {
	          dom.setAttrib(body, placeholderAttr, showPlaceholder ? placeholder : null);
	          dom.setAttrib(body, 'aria-placeholder', showPlaceholder ? placeholder : null);
	          firePlaceholderToggle(editor, showPlaceholder);
	          editor.on(showPlaceholder ? 'keydown' : 'keyup', updatePlaceholder);
	          editor.off(showPlaceholder ? 'keyup' : 'keydown', updatePlaceholder);
	        }
	      };
	      if (placeholder) {
	        editor.on('init', function (e) {
	          updatePlaceholder(e, true);
	          editor.on('change SetContent ExecCommand', updatePlaceholder);
	          editor.on('paste', function (e) {
	            return Delay.setEditorTimeout(editor, function () {
	              return updatePlaceholder(e);
	            });
	          });
	        });
	      }
	    };
	
	    var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
	    var hasStrongRtl = function (text) {
	      return strongRtl.test(text);
	    };
	
	    var isInlineTarget = function (editor, elm) {
	      return is$1(SugarElement.fromDom(elm), getInlineBoundarySelector(editor));
	    };
	    var isRtl$1 = function (element) {
	      return DOMUtils.DOM.getStyle(element, 'direction', true) === 'rtl' || hasStrongRtl(element.textContent);
	    };
	    var findInlineParents = function (isInlineTarget, rootNode, pos) {
	      return filter(DOMUtils.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
	    };
	    var findRootInline = function (isInlineTarget, rootNode, pos) {
	      var parents = findInlineParents(isInlineTarget, rootNode, pos);
	      return Optional.from(parents[parents.length - 1]);
	    };
	    var hasSameParentBlock = function (rootNode, node1, node2) {
	      var block1 = getParentBlock(node1, rootNode);
	      var block2 = getParentBlock(node2, rootNode);
	      return block1 && block1 === block2;
	    };
	    var isAtZwsp = function (pos) {
	      return isBeforeInline(pos) || isAfterInline(pos);
	    };
	    var normalizePosition = function (forward, pos) {
	      if (!pos) {
	        return pos;
	      }
	      var container = pos.container(), offset = pos.offset();
	      if (forward) {
	        if (isCaretContainerInline(container)) {
	          if (isText$1(container.nextSibling)) {
	            return CaretPosition(container.nextSibling, 0);
	          } else {
	            return CaretPosition.after(container);
	          }
	        } else {
	          return isBeforeInline(pos) ? CaretPosition(container, offset + 1) : pos;
	        }
	      } else {
	        if (isCaretContainerInline(container)) {
	          if (isText$1(container.previousSibling)) {
	            return CaretPosition(container.previousSibling, container.previousSibling.data.length);
	          } else {
	            return CaretPosition.before(container);
	          }
	        } else {
	          return isAfterInline(pos) ? CaretPosition(container, offset - 1) : pos;
	        }
	      }
	    };
	    var normalizeForwards = curry(normalizePosition, true);
	    var normalizeBackwards = curry(normalizePosition, false);
	
	    var isBeforeRoot = function (rootNode) {
	      return function (elm) {
	        return eq$2(rootNode, SugarElement.fromDom(elm.dom.parentNode));
	      };
	    };
	    var getParentBlock$1 = function (rootNode, elm) {
	      return contains$2(rootNode, elm) ? closest(elm, function (element) {
	        return isTextBlock(element) || isListItem(element);
	      }, isBeforeRoot(rootNode)) : Optional.none();
	    };
	    var placeCaretInEmptyBody = function (editor) {
	      var body = editor.getBody();
	      var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
	      editor.selection.setCursorLocation(node, 0);
	    };
	    var paddEmptyBody = function (editor) {
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        placeCaretInEmptyBody(editor);
	      }
	    };
	    var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
	      return lift2(firstPositionIn(elm), lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = normalizePosition(true, firstPos);
	        var normalizedLastPos = normalizePosition(false, lastPos);
	        var normalizedFromPos = normalizePosition(false, fromPos);
	        if (forward) {
	          return nextPosition(elm, normalizedFromPos).exists(function (nextPos) {
	            return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
	          });
	        } else {
	          return prevPosition(elm, normalizedFromPos).exists(function (prevPos) {
	            return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
	          });
	        }
	      }).getOr(true);
	    };
	
	    var blockPosition = function (block, position) {
	      return {
	        block: block,
	        position: position
	      };
	    };
	    var blockBoundary = function (from, to) {
	      return {
	        from: from,
	        to: to
	      };
	    };
	    var getBlockPosition = function (rootNode, pos) {
	      var rootElm = SugarElement.fromDom(rootNode);
	      var containerElm = SugarElement.fromDom(pos.container());
	      return getParentBlock$1(rootElm, containerElm).map(function (block) {
	        return blockPosition(block, pos);
	      });
	    };
	    var isDifferentBlocks = function (blockBoundary) {
	      return eq$2(blockBoundary.from.block, blockBoundary.to.block) === false;
	    };
	    var hasSameParent = function (blockBoundary) {
	      return parent(blockBoundary.from.block).bind(function (parent1) {
	        return parent(blockBoundary.to.block).filter(function (parent2) {
	          return eq$2(parent1, parent2);
	        });
	      }).isSome();
	    };
	    var isEditable = function (blockBoundary) {
	      return isContentEditableFalse(blockBoundary.from.block.dom) === false && isContentEditableFalse(blockBoundary.to.block.dom) === false;
	    };
	    var skipLastBr = function (rootNode, forward, blockPosition) {
	      if (isBr(blockPosition.position.getNode()) && isEmpty(blockPosition.block) === false) {
	        return positionIn(false, blockPosition.block.dom).bind(function (lastPositionInBlock) {
	          if (lastPositionInBlock.isEqual(blockPosition.position)) {
	            return fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
	              return getBlockPosition(rootNode, to);
	            });
	          } else {
	            return Optional.some(blockPosition);
	          }
	        }).getOr(blockPosition);
	      } else {
	        return blockPosition;
	      }
	    };
	    var readFromRange = function (rootNode, forward, rng) {
	      var fromBlockPos = getBlockPosition(rootNode, CaretPosition.fromRangeStart(rng));
	      var toBlockPos = fromBlockPos.bind(function (blockPos) {
	        return fromPosition(forward, rootNode, blockPos.position).bind(function (to) {
	          return getBlockPosition(rootNode, to).map(function (blockPos) {
	            return skipLastBr(rootNode, forward, blockPos);
	          });
	        });
	      });
	      return lift2(fromBlockPos, toBlockPos, blockBoundary).filter(function (blockBoundary) {
	        return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable(blockBoundary);
	      });
	    };
	    var read$3 = function (rootNode, forward, rng) {
	      return rng.collapsed ? readFromRange(rootNode, forward, rng) : Optional.none();
	    };
	
	    var getChildrenUntilBlockBoundary = function (block) {
	      var children$1 = children(block);
	      return findIndex(children$1, isBlock).fold(function () {
	        return children$1;
	      }, function (index) {
	        return children$1.slice(0, index);
	      });
	    };
	    var extractChildren = function (block) {
	      var children = getChildrenUntilBlockBoundary(block);
	      each(children, remove);
	      return children;
	    };
	    var removeEmptyRoot = function (rootNode, block) {
	      var parents = parentsAndSelf(block, rootNode);
	      return find(parents.reverse(), function (element) {
	        return isEmpty(element);
	      }).each(remove);
	    };
	    var isEmptyBefore = function (el) {
	      return filter(prevSiblings(el), function (el) {
	        return !isEmpty(el);
	      }).length === 0;
	    };
	    var nestedBlockMerge = function (rootNode, fromBlock, toBlock, insertionPoint) {
	      if (isEmpty(toBlock)) {
	        fillWithPaddingBr(toBlock);
	        return firstPositionIn(toBlock.dom);
	      }
	      if (isEmptyBefore(insertionPoint) && isEmpty(fromBlock)) {
	        before(insertionPoint, SugarElement.fromTag('br'));
	      }
	      var position = prevPosition(toBlock.dom, CaretPosition.before(insertionPoint.dom));
	      each(extractChildren(fromBlock), function (child) {
	        before(insertionPoint, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var sidelongBlockMerge = function (rootNode, fromBlock, toBlock) {
	      if (isEmpty(toBlock)) {
	        remove(toBlock);
	        if (isEmpty(fromBlock)) {
	          fillWithPaddingBr(fromBlock);
	        }
	        return firstPositionIn(fromBlock.dom);
	      }
	      var position = lastPositionIn(toBlock.dom);
	      each(extractChildren(fromBlock), function (child) {
	        append(toBlock, child);
	      });
	      removeEmptyRoot(rootNode, fromBlock);
	      return position;
	    };
	    var findInsertionPoint = function (toBlock, block) {
	      var parentsAndSelf$1 = parentsAndSelf(block, toBlock);
	      return Optional.from(parentsAndSelf$1[parentsAndSelf$1.length - 1]);
	    };
	    var getInsertionPoint = function (fromBlock, toBlock) {
	      return contains$2(toBlock, fromBlock) ? findInsertionPoint(toBlock, fromBlock) : Optional.none();
	    };
	    var trimBr = function (first, block) {
	      positionIn(first, block.dom).map(function (position) {
	        return position.getNode();
	      }).map(SugarElement.fromDom).filter(isBr$1).each(remove);
	    };
	    var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
	      trimBr(true, fromBlock);
	      trimBr(false, toBlock);
	      return getInsertionPoint(fromBlock, toBlock).fold(curry(sidelongBlockMerge, rootNode, fromBlock, toBlock), curry(nestedBlockMerge, rootNode, fromBlock, toBlock));
	    };
	    var mergeBlocks = function (rootNode, forward, block1, block2) {
	      return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
	    };
	
	    var backspaceDelete$1 = function (editor, forward) {
	      var rootNode = SugarElement.fromDom(editor.getBody());
	      var position = read$3(rootNode.dom, forward, editor.selection.getRng()).bind(function (blockBoundary) {
	        return mergeBlocks(rootNode, forward, blockBoundary.from.block, blockBoundary.to.block);
	      });
	      position.each(function (pos) {
	        editor.selection.setRng(pos.toRange());
	      });
	      return position.isSome();
	    };
	
	    var deleteRangeMergeBlocks = function (rootNode, selection) {
	      var rng = selection.getRng();
	      return lift2(getParentBlock$1(rootNode, SugarElement.fromDom(rng.startContainer)), getParentBlock$1(rootNode, SugarElement.fromDom(rng.endContainer)), function (block1, block2) {
	        if (eq$2(block1, block2) === false) {
	          rng.deleteContents();
	          mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
	            selection.setRng(pos.toRange());
	          });
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	    var isRawNodeInTable = function (root, rawNode) {
	      var node = SugarElement.fromDom(rawNode);
	      var isRoot = curry(eq$2, root);
	      return ancestor(node, isTableCell$1, isRoot).isSome();
	    };
	    var isSelectionInTable = function (root, rng) {
	      return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
	    };
	    var isEverythingSelected = function (root, rng) {
	      var noPrevious = prevPosition(root.dom, CaretPosition.fromRangeStart(rng)).isNone();
	      var noNext = nextPosition(root.dom, CaretPosition.fromRangeEnd(rng)).isNone();
	      return !isSelectionInTable(root, rng) && noPrevious && noNext;
	    };
	    var emptyEditor = function (editor) {
	      editor.setContent('');
	      editor.selection.setCursorLocation();
	      return true;
	    };
	    var deleteRange$1 = function (editor) {
	      var rootNode = SugarElement.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
	    };
	    var backspaceDelete$2 = function (editor, _forward) {
	      return editor.selection.isCollapsed() ? false : deleteRange$1(editor);
	    };
	
	    var isContentEditableTrue$2 = isContentEditableTrue;
	    var isContentEditableFalse$7 = isContentEditableFalse;
	    var showCaret = function (direction, editor, node, before, scrollIntoView) {
	      return Optional.from(editor._selectionOverrides.showCaret(direction, node, before, scrollIntoView));
	    };
	    var getNodeRange = function (node) {
	      var rng = node.ownerDocument.createRange();
	      rng.selectNode(node);
	      return rng;
	    };
	    var selectNode = function (editor, node) {
	      var e = editor.fire('BeforeObjectSelected', { target: node });
	      if (e.isDefaultPrevented()) {
	        return Optional.none();
	      }
	      return Optional.some(getNodeRange(node));
	    };
	    var renderCaretAtRange = function (editor, range, scrollIntoView) {
	      var normalizedRange = normalizeRange(1, editor.getBody(), range);
	      var caretPosition = CaretPosition.fromRangeStart(normalizedRange);
	      var caretPositionNode = caretPosition.getNode();
	      if (isInlineFakeCaretTarget(caretPositionNode)) {
	        return showCaret(1, editor, caretPositionNode, !caretPosition.isAtEnd(), false);
	      }
	      var caretPositionBeforeNode = caretPosition.getNode(true);
	      if (isInlineFakeCaretTarget(caretPositionBeforeNode)) {
	        return showCaret(1, editor, caretPositionBeforeNode, false, false);
	      }
	      var ceRoot = editor.dom.getParent(caretPosition.getNode(), function (node) {
	        return isContentEditableFalse$7(node) || isContentEditableTrue$2(node);
	      });
	      if (isInlineFakeCaretTarget(ceRoot)) {
	        return showCaret(1, editor, ceRoot, false, scrollIntoView);
	      }
	      return Optional.none();
	    };
	    var renderRangeCaret = function (editor, range, scrollIntoView) {
	      return range.collapsed ? renderCaretAtRange(editor, range, scrollIntoView).getOr(range) : range;
	    };
	
	    var isBeforeBoundary = function (pos) {
	      return isBeforeContentEditableFalse(pos) || isBeforeMedia(pos);
	    };
	    var isAfterBoundary = function (pos) {
	      return isAfterContentEditableFalse(pos) || isAfterMedia(pos);
	    };
	    var trimEmptyTextNode$1 = function (dom, node) {
	      if (isText$1(node) && node.data.length === 0) {
	        dom.remove(node);
	      }
	    };
	    var deleteContentAndShowCaret = function (editor, range, node, direction, forward, peekCaretPosition) {
	      showCaret(direction, editor, peekCaretPosition.getNode(!forward), forward, true).each(function (caretRange) {
	        if (range.collapsed) {
	          var deleteRange = range.cloneRange();
	          if (forward) {
	            deleteRange.setEnd(caretRange.startContainer, caretRange.startOffset);
	          } else {
	            deleteRange.setStart(caretRange.endContainer, caretRange.endOffset);
	          }
	          deleteRange.deleteContents();
	        } else {
	          range.deleteContents();
	        }
	        editor.selection.setRng(caretRange);
	      });
	      trimEmptyTextNode$1(editor.dom, node);
	      return true;
	    };
	    var deleteBoundaryText = function (editor, forward) {
	      var range = editor.selection.getRng();
	      if (!isText$1(range.commonAncestorContainer)) {
	        return false;
	      }
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextPosFn = curry(getVisualCaretPosition, forward ? caretWalker.next : caretWalker.prev);
	      var isBeforeFn = forward ? isBeforeBoundary : isAfterBoundary;
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      var nextCaretPosition = normalizePosition(forward, getNextPosFn(caretPosition));
	      if (!nextCaretPosition || !isMoveInsideSameBlock(caretPosition, nextCaretPosition)) {
	        return false;
	      } else if (isBeforeFn(nextCaretPosition)) {
	        return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, nextCaretPosition);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return deleteContentAndShowCaret(editor, range, caretPosition.getNode(), direction, forward, peekCaretPosition);
	        }
	      }
	      return false;
	    };
	    var backspaceDelete$3 = function (editor, forward) {
	      return deleteBoundaryText(editor, forward);
	    };
	
	    var isCompoundElement = function (node) {
	      return isTableCell$1(SugarElement.fromDom(node)) || isListItem(SugarElement.fromDom(node));
	    };
	    var DeleteAction = Adt.generate([
	      { remove: ['element'] },
	      { moveToElement: ['element'] },
	      { moveToPosition: ['position'] }
	    ]);
	    var isAtContentEditableBlockCaret = function (forward, from) {
	      var elm = from.getNode(forward === false);
	      var caretLocation = forward ? 'after' : 'before';
	      return isElement$1(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
	    };
	    var isDeleteFromCefDifferentBlocks = function (root, forward, from, to) {
	      var inSameBlock = function (elm) {
	        return isInline(SugarElement.fromDom(elm)) && !isInSameBlock(from, to, root);
	      };
	      return getRelativeCefElm(!forward, from).fold(function () {
	        return getRelativeCefElm(forward, to).fold(never, inSameBlock);
	      }, inSameBlock);
	    };
	    var deleteEmptyBlockOrMoveToCef = function (root, forward, from, to) {
	      var toCefElm = to.getNode(forward === false);
	      return getParentBlock$1(SugarElement.fromDom(root), SugarElement.fromDom(from.getNode())).map(function (blockElm) {
	        return isEmpty(blockElm) ? DeleteAction.remove(blockElm.dom) : DeleteAction.moveToElement(toCefElm);
	      }).orThunk(function () {
	        return Optional.some(DeleteAction.moveToElement(toCefElm));
	      });
	    };
	    var findCefPosition = function (root, forward, from) {
	      return fromPosition(forward, root, from).bind(function (to) {
	        if (isCompoundElement(to.getNode())) {
	          return Optional.none();
	        } else if (isDeleteFromCefDifferentBlocks(root, forward, from, to)) {
	          return Optional.none();
	        } else if (forward && isContentEditableFalse(to.getNode())) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward === false && isContentEditableFalse(to.getNode(true))) {
	          return deleteEmptyBlockOrMoveToCef(root, forward, from, to);
	        } else if (forward && isAfterContentEditableFalse(from)) {
	          return Optional.some(DeleteAction.moveToPosition(to));
	        } else if (forward === false && isBeforeContentEditableFalse(from)) {
	          return Optional.some(DeleteAction.moveToPosition(to));
	        } else {
	          return Optional.none();
	        }
	      });
	    };
	    var getContentEditableBlockAction = function (forward, elm) {
	      if (forward && isContentEditableFalse(elm.nextSibling)) {
	        return Optional.some(DeleteAction.moveToElement(elm.nextSibling));
	      } else if (forward === false && isContentEditableFalse(elm.previousSibling)) {
	        return Optional.some(DeleteAction.moveToElement(elm.previousSibling));
	      } else {
	        return Optional.none();
	      }
	    };
	    var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
	      return deleteAction.fold(function (elm) {
	        return Optional.some(DeleteAction.remove(elm));
	      }, function (elm) {
	        return Optional.some(DeleteAction.moveToElement(elm));
	      }, function (to) {
	        if (isInSameBlock(from, to, root)) {
	          return Optional.none();
	        } else {
	          return Optional.some(DeleteAction.moveToPosition(to));
	        }
	      });
	    };
	    var getContentEditableAction = function (root, forward, from) {
	      if (isAtContentEditableBlockCaret(forward, from)) {
	        return getContentEditableBlockAction(forward, from.getNode(forward === false)).fold(function () {
	          return findCefPosition(root, forward, from);
	        }, Optional.some);
	      } else {
	        return findCefPosition(root, forward, from).bind(function (deleteAction) {
	          return skipMoveToActionFromInlineCefToContent(root, from, deleteAction);
	        });
	      }
	    };
	    var read$4 = function (root, forward, rng) {
	      var normalizedRange = normalizeRange(forward ? 1 : -1, root, rng);
	      var from = CaretPosition.fromRangeStart(normalizedRange);
	      var rootElement = SugarElement.fromDom(root);
	      if (forward === false && isAfterContentEditableFalse(from)) {
	        return Optional.some(DeleteAction.remove(from.getNode(true)));
	      } else if (forward && isBeforeContentEditableFalse(from)) {
	        return Optional.some(DeleteAction.remove(from.getNode()));
	      } else if (forward === false && isBeforeContentEditableFalse(from) && isAfterBr(rootElement, from)) {
	        return findPreviousBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else if (forward && isAfterContentEditableFalse(from) && isBeforeBr(rootElement, from)) {
	        return findNextBr(rootElement, from).map(function (br) {
	          return DeleteAction.remove(br.getNode());
	        });
	      } else {
	        return getContentEditableAction(root, forward, from);
	      }
	    };
	
	    var deleteElement$1 = function (editor, forward) {
	      return function (element) {
	        editor._selectionOverrides.hideFakeCaret();
	        deleteElement(editor, forward, SugarElement.fromDom(element));
	        return true;
	      };
	    };
	    var moveToElement = function (editor, forward) {
	      return function (element) {
	        var pos = forward ? CaretPosition.before(element) : CaretPosition.after(element);
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var moveToPosition = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	    var getAncestorCe = function (editor, node) {
	      return Optional.from(getContentEditableRoot(editor.getBody(), node));
	    };
	    var backspaceDeleteCaret = function (editor, forward) {
	      var selectedNode = editor.selection.getNode();
	      return getAncestorCe(editor, selectedNode).filter(isContentEditableFalse).fold(function () {
	        return read$4(editor.getBody(), forward, editor.selection.getRng()).exists(function (deleteAction) {
	          return deleteAction.fold(deleteElement$1(editor, forward), moveToElement(editor, forward), moveToPosition(editor));
	        });
	      }, always);
	    };
	    var deleteOffscreenSelection = function (rootElement) {
	      each(descendants$1(rootElement, '.mce-offscreen-selection'), remove);
	    };
	    var backspaceDeleteRange = function (editor, forward) {
	      var selectedNode = editor.selection.getNode();
	      if (isContentEditableFalse(selectedNode)) {
	        var hasCefAncestor = getAncestorCe(editor, selectedNode.parentNode).filter(isContentEditableFalse);
	        return hasCefAncestor.fold(function () {
	          deleteOffscreenSelection(SugarElement.fromDom(editor.getBody()));
	          deleteElement(editor, forward, SugarElement.fromDom(editor.selection.getNode()));
	          paddEmptyBody(editor);
	          return true;
	        }, always);
	      }
	      return false;
	    };
	    var paddEmptyElement = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var ceRoot = getContentEditableRoot(editor.getBody(), selection.getNode());
	      if (isContentEditableTrue(ceRoot) && dom.isBlock(ceRoot) && dom.isEmpty(ceRoot)) {
	        var br = dom.create('br', { 'data-mce-bogus': '1' });
	        dom.setHTML(ceRoot, '');
	        ceRoot.appendChild(br);
	        selection.setRng(CaretPosition.before(br).toRange());
	      }
	      return true;
	    };
	    var backspaceDelete$4 = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return backspaceDeleteCaret(editor, forward);
	      } else {
	        return backspaceDeleteRange(editor, forward);
	      }
	    };
	
	    var deleteCaret$1 = function (editor, forward) {
	      var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return fromPosition(forward, editor.getBody(), fromPos).filter(function (pos) {
	        return forward ? isBeforeImageBlock(pos) : isAfterImageBlock(pos);
	      }).bind(function (pos) {
	        return Optional.from(getChildNodeAtRelativeOffset(forward ? 0 : -1, pos));
	      }).exists(function (elm) {
	        editor.selection.select(elm);
	        return true;
	      });
	    };
	    var backspaceDelete$5 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$1(editor, forward) : false;
	    };
	
	    var isText$8 = isText$1;
	    var startsWithCaretContainer$1 = function (node) {
	      return isText$8(node) && node.data[0] === ZWSP;
	    };
	    var endsWithCaretContainer$1 = function (node) {
	      return isText$8(node) && node.data[node.data.length - 1] === ZWSP;
	    };
	    var createZwsp = function (node) {
	      return node.ownerDocument.createTextNode(ZWSP);
	    };
	    var insertBefore$1 = function (node) {
	      if (isText$8(node.previousSibling)) {
	        if (endsWithCaretContainer$1(node.previousSibling)) {
	          return node.previousSibling;
	        } else {
	          node.previousSibling.appendData(ZWSP);
	          return node.previousSibling;
	        }
	      } else if (isText$8(node)) {
	        if (startsWithCaretContainer$1(node)) {
	          return node;
	        } else {
	          node.insertData(0, ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        node.parentNode.insertBefore(newNode, node);
	        return newNode;
	      }
	    };
	    var insertAfter$1 = function (node) {
	      if (isText$8(node.nextSibling)) {
	        if (startsWithCaretContainer$1(node.nextSibling)) {
	          return node.nextSibling;
	        } else {
	          node.nextSibling.insertData(0, ZWSP);
	          return node.nextSibling;
	        }
	      } else if (isText$8(node)) {
	        if (endsWithCaretContainer$1(node)) {
	          return node;
	        } else {
	          node.appendData(ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        if (node.nextSibling) {
	          node.parentNode.insertBefore(newNode, node.nextSibling);
	        } else {
	          node.parentNode.appendChild(newNode);
	        }
	        return newNode;
	      }
	    };
	    var insertInline$1 = function (before, node) {
	      return before ? insertBefore$1(node) : insertAfter$1(node);
	    };
	    var insertInlineBefore = curry(insertInline$1, true);
	    var insertInlineAfter = curry(insertInline$1, false);
	
	    var insertInlinePos = function (pos, before) {
	      if (isText$1(pos.container())) {
	        return insertInline$1(before, pos.container());
	      } else {
	        return insertInline$1(before, pos.getNode());
	      }
	    };
	    var isPosCaretContainer = function (pos, caret) {
	      var caretNode = caret.get();
	      return caretNode && pos.container() === caretNode && isCaretContainerInline(caretNode);
	    };
	    var renderCaret = function (caret, location) {
	      return location.fold(function (element) {
	        remove$5(caret.get());
	        var text = insertInlineBefore(element);
	        caret.set(text);
	        return Optional.some(CaretPosition(text, text.length - 1));
	      }, function (element) {
	        return firstPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            remove$5(caret.get());
	            var text = insertInlinePos(pos, true);
	            caret.set(text);
	            return CaretPosition(text, 1);
	          } else {
	            return CaretPosition(caret.get(), 1);
	          }
	        });
	      }, function (element) {
	        return lastPositionIn(element).map(function (pos) {
	          if (!isPosCaretContainer(pos, caret)) {
	            remove$5(caret.get());
	            var text = insertInlinePos(pos, false);
	            caret.set(text);
	            return CaretPosition(text, text.length - 1);
	          } else {
	            return CaretPosition(caret.get(), caret.get().length - 1);
	          }
	        });
	      }, function (element) {
	        remove$5(caret.get());
	        var text = insertInlineAfter(element);
	        caret.set(text);
	        return Optional.some(CaretPosition(text, 1));
	      });
	    };
	
	    var evaluateUntil = function (fns, args) {
	      for (var i = 0; i < fns.length; i++) {
	        var result = fns[i].apply(null, args);
	        if (result.isSome()) {
	          return result;
	        }
	      }
	      return Optional.none();
	    };
	
	    var Location = Adt.generate([
	      { before: ['element'] },
	      { start: ['element'] },
	      { end: ['element'] },
	      { after: ['element'] }
	    ]);
	    var rescope = function (rootNode, node) {
	      var parentBlock = getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var before$4 = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeForwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return nextPosition(scope, nPos).bind(curry(findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.before(inline);
	        });
	      }, Optional.none);
	    };
	    var isNotInsideFormatCaretContainer = function (rootNode, elm) {
	      return getParentCaretContainer(rootNode, elm) === null;
	    };
	    var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
	      return findRootInline(isInlineTarget, rootNode, pos).filter(curry(isNotInsideFormatCaretContainer, rootNode));
	    };
	    var start = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeBackwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var prevPos = prevPosition(inline, nPos);
	        return prevPos.isNone() ? Optional.some(Location.start(inline)) : Optional.none();
	      });
	    };
	    var end = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeForwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var nextPos = nextPosition(inline, nPos);
	        return nextPos.isNone() ? Optional.some(Location.end(inline)) : Optional.none();
	      });
	    };
	    var after$3 = function (isInlineTarget, rootNode, pos) {
	      var nPos = normalizeBackwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return findRootInline(isInlineTarget, scope, nPos).fold(function () {
	        return prevPosition(scope, nPos).bind(curry(findRootInline, isInlineTarget, scope)).map(function (inline) {
	          return Location.after(inline);
	        });
	      }, Optional.none);
	    };
	    var isValidLocation = function (location) {
	      return isRtl$1(getElement(location)) === false;
	    };
	    var readLocation = function (isInlineTarget, rootNode, pos) {
	      var location = evaluateUntil([
	        before$4,
	        start,
	        end,
	        after$3
	      ], [
	        isInlineTarget,
	        rootNode,
	        pos
	      ]);
	      return location.filter(isValidLocation);
	    };
	    var getElement = function (location) {
	      return location.fold(identity, identity, identity, identity);
	    };
	    var getName = function (location) {
	      return location.fold(constant('before'), constant('start'), constant('end'), constant('after'));
	    };
	    var outside = function (location) {
	      return location.fold(Location.before, Location.before, Location.after, Location.after);
	    };
	    var inside = function (location) {
	      return location.fold(Location.start, Location.start, Location.end, Location.end);
	    };
	    var isEq$5 = function (location1, location2) {
	      return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
	    };
	    var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
	      return lift2(findRootInline(isInlineTarget, rootNode, from), findRootInline(isInlineTarget, rootNode, to), function (fromInline, toInline) {
	        if (fromInline !== toInline && hasSameParentBlock(rootNode, fromInline, toInline)) {
	          return Location.after(forward ? fromInline : toInline);
	        } else {
	          return location;
	        }
	      }).getOr(location);
	    };
	    var skipNoMovement = function (fromLocation, toLocation) {
	      return fromLocation.fold(always, function (fromLocation) {
	        return !isEq$5(fromLocation, toLocation);
	      });
	    };
	    var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
	      var from = normalizePosition(forward, pos);
	      var to = fromPosition(forward, rootNode, from).map(curry(normalizePosition, forward));
	      var location = to.fold(function () {
	        return fromLocation.map(outside);
	      }, function (to) {
	        return readLocation(isInlineTarget, rootNode, to).map(curry(betweenInlines, forward, isInlineTarget, rootNode, from, to)).filter(curry(skipNoMovement, fromLocation));
	      });
	      return location.filter(isValidLocation);
	    };
	    var findLocationSimple = function (forward, location) {
	      if (forward) {
	        return location.fold(compose(Optional.some, Location.start), Optional.none, compose(Optional.some, Location.after), Optional.none);
	      } else {
	        return location.fold(Optional.none, compose(Optional.some, Location.before), Optional.none, compose(Optional.some, Location.end));
	      }
	    };
	    var findLocation = function (forward, isInlineTarget, rootNode, pos) {
	      var from = normalizePosition(forward, pos);
	      var fromLocation = readLocation(isInlineTarget, rootNode, from);
	      return readLocation(isInlineTarget, rootNode, from).bind(curry(findLocationSimple, forward)).orThunk(function () {
	        return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
	      });
	    };
	    var prevLocation = curry(findLocation, false);
	    var nextLocation = curry(findLocation, true);
	
	    var hasSelectionModifyApi = function (editor) {
	      return isFunction(editor.selection.getSel().modify);
	    };
	    var moveRel = function (forward, selection, pos) {
	      var delta = forward ? 1 : -1;
	      selection.setRng(CaretPosition(pos.container(), pos.offset() + delta).toRange());
	      selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
	      return true;
	    };
	    var moveByWord = function (forward, editor) {
	      var rng = editor.selection.getRng();
	      var pos = forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
	      if (!hasSelectionModifyApi(editor)) {
	        return false;
	      } else if (forward && isBeforeInline(pos)) {
	        return moveRel(true, editor.selection, pos);
	      } else if (!forward && isAfterInline(pos)) {
	        return moveRel(false, editor.selection, pos);
	      } else {
	        return false;
	      }
	    };
	
	    var BreakType;
	    (function (BreakType) {
	      BreakType[BreakType['Br'] = 0] = 'Br';
	      BreakType[BreakType['Block'] = 1] = 'Block';
	      BreakType[BreakType['Wrap'] = 2] = 'Wrap';
	      BreakType[BreakType['Eol'] = 3] = 'Eol';
	    }(BreakType || (BreakType = {})));
	    var flip = function (direction, positions) {
	      return direction === HDirection.Backwards ? reverse(positions) : positions;
	    };
	    var walk$3 = function (direction, caretWalker, pos) {
	      return direction === HDirection.Forwards ? caretWalker.next(pos) : caretWalker.prev(pos);
	    };
	    var getBreakType = function (scope, direction, currentPos, nextPos) {
	      if (isBr(nextPos.getNode(direction === HDirection.Forwards))) {
	        return BreakType.Br;
	      } else if (isInSameBlock(currentPos, nextPos) === false) {
	        return BreakType.Block;
	      } else {
	        return BreakType.Wrap;
	      }
	    };
	    var getPositionsUntil = function (predicate, direction, scope, start) {
	      var caretWalker = CaretWalker(scope);
	      var currentPos = start, nextPos;
	      var positions = [];
	      while (currentPos) {
	        nextPos = walk$3(direction, caretWalker, currentPos);
	        if (!nextPos) {
	          break;
	        }
	        if (isBr(nextPos.getNode(false))) {
	          if (direction === HDirection.Forwards) {
	            return {
	              positions: flip(direction, positions).concat([nextPos]),
	              breakType: BreakType.Br,
	              breakAt: Optional.some(nextPos)
	            };
	          } else {
	            return {
	              positions: flip(direction, positions),
	              breakType: BreakType.Br,
	              breakAt: Optional.some(nextPos)
	            };
	          }
	        }
	        if (!nextPos.isVisible()) {
	          currentPos = nextPos;
	          continue;
	        }
	        if (predicate(currentPos, nextPos)) {
	          var breakType = getBreakType(scope, direction, currentPos, nextPos);
	          return {
	            positions: flip(direction, positions),
	            breakType: breakType,
	            breakAt: Optional.some(nextPos)
	          };
	        }
	        positions.push(nextPos);
	        currentPos = nextPos;
	      }
	      return {
	        positions: flip(direction, positions),
	        breakType: BreakType.Eol,
	        breakAt: Optional.none()
	      };
	    };
	    var getAdjacentLinePositions = function (direction, getPositionsUntilBreak, scope, start) {
	      return getPositionsUntilBreak(scope, start).breakAt.map(function (pos) {
	        var positions = getPositionsUntilBreak(scope, pos).positions;
	        return direction === HDirection.Backwards ? positions.concat(pos) : [pos].concat(positions);
	      }).getOr([]);
	    };
	    var findClosestHorizontalPositionFromPoint = function (positions, x) {
	      return foldl(positions, function (acc, newPos) {
	        return acc.fold(function () {
	          return Optional.some(newPos);
	        }, function (lastPos) {
	          return lift2(head(lastPos.getClientRects()), head(newPos.getClientRects()), function (lastRect, newRect) {
	            var lastDist = Math.abs(x - lastRect.left);
	            var newDist = Math.abs(x - newRect.left);
	            return newDist <= lastDist ? newPos : lastPos;
	          }).or(acc);
	        });
	      }, Optional.none());
	    };
	    var findClosestHorizontalPosition = function (positions, pos) {
	      return head(pos.getClientRects()).bind(function (targetRect) {
	        return findClosestHorizontalPositionFromPoint(positions, targetRect.left);
	      });
	    };
	    var getPositionsUntilPreviousLine = curry(getPositionsUntil, CaretPosition.isAbove, -1);
	    var getPositionsUntilNextLine = curry(getPositionsUntil, CaretPosition.isBelow, 1);
	    var isAtFirstLine = function (scope, pos) {
	      return getPositionsUntilPreviousLine(scope, pos).breakAt.isNone();
	    };
	    var isAtLastLine = function (scope, pos) {
	      return getPositionsUntilNextLine(scope, pos).breakAt.isNone();
	    };
	    var getPositionsAbove = curry(getAdjacentLinePositions, -1, getPositionsUntilPreviousLine);
	    var getPositionsBelow = curry(getAdjacentLinePositions, 1, getPositionsUntilNextLine);
	    var getFirstLinePositions = function (scope) {
	      return firstPositionIn(scope).map(function (pos) {
	        return [pos].concat(getPositionsUntilNextLine(scope, pos).positions);
	      }).getOr([]);
	    };
	    var getLastLinePositions = function (scope) {
	      return lastPositionIn(scope).map(function (pos) {
	        return getPositionsUntilPreviousLine(scope, pos).positions.concat(pos);
	      }).getOr([]);
	    };
	
	    var getNodeClientRects = function (node) {
	      var toArrayWithNode = function (clientRects) {
	        return map(clientRects, function (clientRect) {
	          clientRect = clone$2(clientRect);
	          clientRect.node = node;
	          return clientRect;
	        });
	      };
	      if (isElement$1(node)) {
	        return toArrayWithNode(node.getClientRects());
	      }
	      if (isText$1(node)) {
	        var rng = node.ownerDocument.createRange();
	        rng.setStart(node, 0);
	        rng.setEnd(node, node.data.length);
	        return toArrayWithNode(rng.getClientRects());
	      }
	    };
	    var getClientRects = function (nodes) {
	      return bind(nodes, getNodeClientRects);
	    };
	
	    var VDirection;
	    (function (VDirection) {
	      VDirection[VDirection['Up'] = -1] = 'Up';
	      VDirection[VDirection['Down'] = 1] = 'Down';
	    }(VDirection || (VDirection = {})));
	    var findUntil$1 = function (direction, root, predicateFn, node) {
	      while (node = findNode(node, direction, isEditableCaretCandidate, root)) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	    var walkUntil = function (direction, isAboveFn, isBeflowFn, root, predicateFn, caretPosition) {
	      var line = 0;
	      var result = [];
	      var add = function (node) {
	        var i, clientRect, clientRects;
	        clientRects = getClientRects([node]);
	        if (direction === -1) {
	          clientRects = clientRects.reverse();
	        }
	        for (i = 0; i < clientRects.length; i++) {
	          clientRect = clientRects[i];
	          if (isBeflowFn(clientRect, targetClientRect)) {
	            continue;
	          }
	          if (result.length > 0 && isAboveFn(clientRect, last$1(result))) {
	            line++;
	          }
	          clientRect.line = line;
	          if (predicateFn(clientRect)) {
	            return true;
	          }
	          result.push(clientRect);
	        }
	      };
	      var targetClientRect = last$1(caretPosition.getClientRects());
	      if (!targetClientRect) {
	        return result;
	      }
	      var node = caretPosition.getNode();
	      add(node);
	      findUntil$1(direction, root, add, node);
	      return result;
	    };
	    var aboveLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line > lineNumber;
	    };
	    var isLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line === lineNumber;
	    };
	    var upUntil = curry(walkUntil, VDirection.Up, isAbove, isBelow);
	    var downUntil = curry(walkUntil, VDirection.Down, isBelow, isAbove);
	    var positionsUntil = function (direction, root, predicateFn, node) {
	      var caretWalker = CaretWalker(root);
	      var walkFn, isBelowFn, isAboveFn, caretPosition;
	      var result = [];
	      var line = 0, clientRect;
	      var getClientRect = function (caretPosition) {
	        if (direction === 1) {
	          return last$1(caretPosition.getClientRects());
	        }
	        return last$1(caretPosition.getClientRects());
	      };
	      if (direction === 1) {
	        walkFn = caretWalker.next;
	        isBelowFn = isBelow;
	        isAboveFn = isAbove;
	        caretPosition = CaretPosition.after(node);
	      } else {
	        walkFn = caretWalker.prev;
	        isBelowFn = isAbove;
	        isAboveFn = isBelow;
	        caretPosition = CaretPosition.before(node);
	      }
	      var targetClientRect = getClientRect(caretPosition);
	      do {
	        if (!caretPosition.isVisible()) {
	          continue;
	        }
	        clientRect = getClientRect(caretPosition);
	        if (isAboveFn(clientRect, targetClientRect)) {
	          continue;
	        }
	        if (result.length > 0 && isBelowFn(clientRect, last$1(result))) {
	          line++;
	        }
	        clientRect = clone$2(clientRect);
	        clientRect.position = caretPosition;
	        clientRect.line = line;
	        if (predicateFn(clientRect)) {
	          return result;
	        }
	        result.push(clientRect);
	      } while (caretPosition = walkFn(caretPosition));
	      return result;
	    };
	    var isAboveLine = function (lineNumber) {
	      return function (clientRect) {
	        return aboveLineNumber(lineNumber, clientRect);
	      };
	    };
	    var isLine = function (lineNumber) {
	      return function (clientRect) {
	        return isLineNumber(lineNumber, clientRect);
	      };
	    };
	
	    var isContentEditableFalse$8 = isContentEditableFalse;
	    var findNode$1 = findNode;
	    var distanceToRectLeft = function (clientRect, clientX) {
	      return Math.abs(clientRect.left - clientX);
	    };
	    var distanceToRectRight = function (clientRect, clientX) {
	      return Math.abs(clientRect.right - clientX);
	    };
	    var isInsideX = function (clientX, clientRect) {
	      return clientX >= clientRect.left && clientX <= clientRect.right;
	    };
	    var isInsideY = function (clientY, clientRect) {
	      return clientY >= clientRect.top && clientY <= clientRect.bottom;
	    };
	    var findClosestClientRect = function (clientRects, clientX) {
	      return reduce(clientRects, function (oldClientRect, clientRect) {
	        var oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
	        var newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
	        if (isInsideX(clientX, clientRect)) {
	          return clientRect;
	        }
	        if (isInsideX(clientX, oldClientRect)) {
	          return oldClientRect;
	        }
	        if (newDistance === oldDistance && isContentEditableFalse$8(clientRect.node)) {
	          return clientRect;
	        }
	        if (newDistance < oldDistance) {
	          return clientRect;
	        }
	        return oldClientRect;
	      });
	    };
	    var walkUntil$1 = function (direction, root, predicateFn, startNode, includeChildren) {
	      var node = findNode$1(startNode, direction, isEditableCaretCandidate, root, !includeChildren);
	      do {
	        if (!node || predicateFn(node)) {
	          return;
	        }
	      } while (node = findNode$1(node, direction, isEditableCaretCandidate, root));
	    };
	    var findLineNodeRects = function (root, targetNodeRect, includeChildren) {
	      if (includeChildren === void 0) {
	        includeChildren = true;
	      }
	      var clientRects = [];
	      var collect = function (checkPosFn, node) {
	        var lineRects = filter(getClientRects([node]), function (clientRect) {
	          return !checkPosFn(clientRect, targetNodeRect);
	        });
	        clientRects = clientRects.concat(lineRects);
	        return lineRects.length === 0;
	      };
	      clientRects.push(targetNodeRect);
	      walkUntil$1(VDirection.Up, root, curry(collect, isAbove), targetNodeRect.node, includeChildren);
	      walkUntil$1(VDirection.Down, root, curry(collect, isBelow), targetNodeRect.node, includeChildren);
	      return clientRects;
	    };
	    var getFakeCaretTargets = function (root) {
	      return filter(from$1(root.getElementsByTagName('*')), isFakeCaretTarget);
	    };
	    var caretInfo = function (clientRect, clientX) {
	      return {
	        node: clientRect.node,
	        before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
	      };
	    };
	    var closestFakeCaret = function (root, clientX, clientY) {
	      var fakeTargetNodeRects = getClientRects(getFakeCaretTargets(root));
	      var targetNodeRects = filter(fakeTargetNodeRects, curry(isInsideY, clientY));
	      var closestNodeRect = findClosestClientRect(targetNodeRects, clientX);
	      if (closestNodeRect) {
	        var includeChildren = !isTable(closestNodeRect.node) && !isMedia(closestNodeRect.node);
	        closestNodeRect = findClosestClientRect(findLineNodeRects(root, closestNodeRect, includeChildren), clientX);
	        if (closestNodeRect && isFakeCaretTarget(closestNodeRect.node)) {
	          return caretInfo(closestNodeRect, clientX);
	        }
	      }
	      return null;
	    };
	
	    var moveToRange = function (editor, rng) {
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, editor.selection.getRng());
	    };
	    var renderRangeCaretOpt = function (editor, range, scrollIntoView) {
	      return Optional.some(renderRangeCaret(editor, range, scrollIntoView));
	    };
	    var moveHorizontally = function (editor, direction, range, isBefore, isAfter, isElement) {
	      var forwards = direction === HDirection.Forwards;
	      var caretWalker = CaretWalker(editor.getBody());
	      var getNextPosFn = curry(getVisualCaretPosition, forwards ? caretWalker.next : caretWalker.prev);
	      var isBeforeFn = forwards ? isBefore : isAfter;
	      if (!range.collapsed) {
	        var node = getSelectedNode(range);
	        if (isElement(node)) {
	          return showCaret(direction, editor, node, direction === HDirection.Backwards, false);
	        }
	      }
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      if (isBeforeFn(caretPosition)) {
	        return selectNode(editor, caretPosition.getNode(!forwards));
	      }
	      var nextCaretPosition = normalizePosition(forwards, getNextPosFn(caretPosition));
	      var rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
	      if (!nextCaretPosition) {
	        return rangeIsInContainerBlock ? Optional.some(range) : Optional.none();
	      }
	      if (isBeforeFn(nextCaretPosition)) {
	        return showCaret(direction, editor, nextCaretPosition.getNode(!forwards), forwards, false);
	      }
	      var peekCaretPosition = getNextPosFn(nextCaretPosition);
	      if (peekCaretPosition && isBeforeFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(nextCaretPosition, peekCaretPosition)) {
	          return showCaret(direction, editor, peekCaretPosition.getNode(!forwards), forwards, false);
	        }
	      }
	      if (rangeIsInContainerBlock) {
	        return renderRangeCaretOpt(editor, nextCaretPosition.toRange(), false);
	      }
	      return Optional.none();
	    };
	    var moveVertically = function (editor, direction, range, isBefore, isAfter, isElement) {
	      var caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      var caretClientRect = last$1(caretPosition.getClientRects());
	      var forwards = direction === VDirection.Down;
	      if (!caretClientRect) {
	        return Optional.none();
	      }
	      var walkerFn = forwards ? downUntil : upUntil;
	      var linePositions = walkerFn(editor.getBody(), isAboveLine(1), caretPosition);
	      var nextLinePositions = filter(linePositions, isLine(1));
	      var clientX = caretClientRect.left;
	      var nextLineRect = findClosestClientRect(nextLinePositions, clientX);
	      if (nextLineRect && isElement(nextLineRect.node)) {
	        var dist1 = Math.abs(clientX - nextLineRect.left);
	        var dist2 = Math.abs(clientX - nextLineRect.right);
	        return showCaret(direction, editor, nextLineRect.node, dist1 < dist2, false);
	      }
	      var currentNode;
	      if (isBefore(caretPosition)) {
	        currentNode = caretPosition.getNode();
	      } else if (isAfter(caretPosition)) {
	        currentNode = caretPosition.getNode(true);
	      } else {
	        currentNode = getSelectedNode(range);
	      }
	      if (currentNode) {
	        var caretPositions = positionsUntil(direction, editor.getBody(), isAboveLine(1), currentNode);
	        var closestNextLineRect = findClosestClientRect(filter(caretPositions, isLine(1)), clientX);
	        if (closestNextLineRect) {
	          return renderRangeCaretOpt(editor, closestNextLineRect.position.toRange(), false);
	        }
	        closestNextLineRect = last$1(filter(caretPositions, isLine(0)));
	        if (closestNextLineRect) {
	          return renderRangeCaretOpt(editor, closestNextLineRect.position.toRange(), false);
	        }
	      }
	      if (nextLinePositions.length === 0) {
	        return getLineEndPoint(editor, forwards).filter(forwards ? isAfter : isBefore).map(function (pos) {
	          return renderRangeCaret(editor, pos.toRange(), false);
	        });
	      }
	      return Optional.none();
	    };
	    var getLineEndPoint = function (editor, forward) {
	      var rng = editor.selection.getRng();
	      var body = editor.getBody();
	      if (forward) {
	        var from = CaretPosition.fromRangeEnd(rng);
	        var result = getPositionsUntilNextLine(body, from);
	        return last(result.positions);
	      } else {
	        var from = CaretPosition.fromRangeStart(rng);
	        var result = getPositionsUntilPreviousLine(body, from);
	        return head(result.positions);
	      }
	    };
	    var moveToLineEndPoint = function (editor, forward, isElementPosition) {
	      return getLineEndPoint(editor, forward).filter(isElementPosition).exists(function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      });
	    };
	
	    var setCaretPosition = function (editor, pos) {
	      var rng = editor.dom.createRng();
	      rng.setStart(pos.container(), pos.offset());
	      rng.setEnd(pos.container(), pos.offset());
	      editor.selection.setRng(rng);
	    };
	    var setSelected = function (state, elm) {
	      if (state) {
	        elm.setAttribute('data-mce-selected', 'inline-boundary');
	      } else {
	        elm.removeAttribute('data-mce-selected');
	      }
	    };
	    var renderCaretLocation = function (editor, caret, location) {
	      return renderCaret(caret, location).map(function (pos) {
	        setCaretPosition(editor, pos);
	        return location;
	      });
	    };
	    var findLocation$1 = function (editor, caret, forward) {
	      var rootNode = editor.getBody();
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      var location = findLocation(forward, isInlineTarget$1, rootNode, from);
	      return location.bind(function (location) {
	        return renderCaretLocation(editor, caret, location);
	      });
	    };
	    var toggleInlines = function (isInlineTarget, dom, elms) {
	      var inlineBoundaries = map(descendants$1(SugarElement.fromDom(dom.getRoot()), '*[data-mce-selected="inline-boundary"]'), function (e) {
	        return e.dom;
	      });
	      var selectedInlines = filter(inlineBoundaries, isInlineTarget);
	      var targetInlines = filter(elms, isInlineTarget);
	      each(difference(selectedInlines, targetInlines), curry(setSelected, false));
	      each(difference(targetInlines, selectedInlines), curry(setSelected, true));
	    };
	    var safeRemoveCaretContainer = function (editor, caret) {
	      if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
	        var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	        if (CaretPosition.isTextPosition(pos) && isAtZwsp(pos) === false) {
	          setCaretPosition(editor, removeAndReposition(caret.get(), pos));
	          caret.set(null);
	        }
	      }
	    };
	    var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
	      if (editor.selection.isCollapsed()) {
	        var inlines = filter(elms, isInlineTarget);
	        each(inlines, function (_inline) {
	          var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	          readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
	            return renderCaretLocation(editor, caret, location);
	          });
	        });
	      }
	    };
	    var move = function (editor, caret, forward) {
	      return isInlineBoundariesEnabled(editor) ? findLocation$1(editor, caret, forward).isSome() : false;
	    };
	    var moveWord = function (forward, editor, _caret) {
	      return isInlineBoundariesEnabled(editor) ? moveByWord(forward, editor) : false;
	    };
	    var setupSelectedState = function (editor) {
	      var caret = Cell(null);
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      editor.on('NodeChange', function (e) {
	        if (isInlineBoundariesEnabled(editor) && !(Env.browser.isIE() && e.initial)) {
	          toggleInlines(isInlineTarget$1, editor.dom, e.parents);
	          safeRemoveCaretContainer(editor, caret);
	          renderInsideInlineCaret(isInlineTarget$1, editor, caret, e.parents);
	        }
	      });
	      return caret;
	    };
	    var moveNextWord = curry(moveWord, true);
	    var movePrevWord = curry(moveWord, false);
	    var moveToLineEndPoint$1 = function (editor, forward, caret) {
	      if (isInlineBoundariesEnabled(editor)) {
	        var linePoint = getLineEndPoint(editor, forward).getOrThunk(function () {
	          var rng = editor.selection.getRng();
	          return forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
	        });
	        return readLocation(curry(isInlineTarget, editor), editor.getBody(), linePoint).exists(function (loc) {
	          var outsideLoc = outside(loc);
	          return renderCaret(caret, outsideLoc).exists(function (pos) {
	            setCaretPosition(editor, pos);
	            return true;
	          });
	        });
	      } else {
	        return false;
	      }
	    };
	
	    var rangeFromPositions = function (from, to) {
	      var range = document.createRange();
	      range.setStart(from.container(), from.offset());
	      range.setEnd(to.container(), to.offset());
	      return range;
	    };
	    var hasOnlyTwoOrLessPositionsLeft = function (elm) {
	      return lift2(firstPositionIn(elm), lastPositionIn(elm), function (firstPos, lastPos) {
	        var normalizedFirstPos = normalizePosition(true, firstPos);
	        var normalizedLastPos = normalizePosition(false, lastPos);
	        return nextPosition(elm, normalizedFirstPos).forall(function (pos) {
	          return pos.isEqual(normalizedLastPos);
	        });
	      }).getOr(true);
	    };
	    var setCaretLocation = function (editor, caret) {
	      return function (location) {
	        return renderCaret(caret, location).exists(function (pos) {
	          setCaretPosition(editor, pos);
	          return true;
	        });
	      };
	    };
	    var deleteFromTo = function (editor, caret, from, to) {
	      var rootNode = editor.getBody();
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      editor.undoManager.ignore(function () {
	        editor.selection.setRng(rangeFromPositions(from, to));
	        editor.execCommand('Delete');
	        readLocation(isInlineTarget$1, rootNode, CaretPosition.fromRangeStart(editor.selection.getRng())).map(inside).map(setCaretLocation(editor, caret));
	      });
	      editor.nodeChanged();
	    };
	    var rescope$1 = function (rootNode, node) {
	      var parentBlock = getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	    var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
	      var rootNode = rescope$1(editor.getBody(), from.container());
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      var fromLocation = readLocation(isInlineTarget$1, rootNode, from);
	      return fromLocation.bind(function (location) {
	        if (forward) {
	          return location.fold(constant(Optional.some(inside(location))), Optional.none, constant(Optional.some(outside(location))), Optional.none);
	        } else {
	          return location.fold(Optional.none, constant(Optional.some(outside(location))), Optional.none, constant(Optional.some(inside(location))));
	        }
	      }).map(setCaretLocation(editor, caret)).getOrThunk(function () {
	        var toPosition = navigate(forward, rootNode, from);
	        var toLocation = toPosition.bind(function (pos) {
	          return readLocation(isInlineTarget$1, rootNode, pos);
	        });
	        return lift2(fromLocation, toLocation, function () {
	          return findRootInline(isInlineTarget$1, rootNode, from).exists(function (elm) {
	            if (hasOnlyTwoOrLessPositionsLeft(elm)) {
	              deleteElement(editor, forward, SugarElement.fromDom(elm));
	              return true;
	            } else {
	              return false;
	            }
	          });
	        }).orThunk(function () {
	          return toLocation.bind(function (_) {
	            return toPosition.map(function (to) {
	              if (forward) {
	                deleteFromTo(editor, caret, from, to);
	              } else {
	                deleteFromTo(editor, caret, to, from);
	              }
	              return true;
	            });
	          });
	        }).getOr(false);
	      });
	    };
	    var backspaceDelete$6 = function (editor, caret, forward) {
	      if (editor.selection.isCollapsed() && isInlineBoundariesEnabled(editor)) {
	        var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	        return backspaceDeleteCollapsed(editor, caret, forward, from);
	      }
	      return false;
	    };
	
	    var getParentInlines = function (rootElm, startElm) {
	      var parents = parentsAndSelf(startElm, rootElm);
	      return findIndex(parents, isBlock).fold(constant(parents), function (index) {
	        return parents.slice(0, index);
	      });
	    };
	    var hasOnlyOneChild$1 = function (elm) {
	      return children(elm).length === 1;
	    };
	    var deleteLastPosition = function (forward, editor, target, parentInlines) {
	      var isFormatElement$1 = curry(isFormatElement, editor);
	      var formatNodes = map(filter(parentInlines, isFormatElement$1), function (elm) {
	        return elm.dom;
	      });
	      if (formatNodes.length === 0) {
	        deleteElement(editor, forward, target);
	      } else {
	        var pos = replaceWithCaretFormat(target.dom, formatNodes);
	        editor.selection.setRng(pos.toRange());
	      }
	    };
	    var deleteCaret$2 = function (editor, forward) {
	      var rootElm = SugarElement.fromDom(editor.getBody());
	      var startElm = SugarElement.fromDom(editor.selection.getStart());
	      var parentInlines = filter(getParentInlines(rootElm, startElm), hasOnlyOneChild$1);
	      return last(parentInlines).exists(function (target) {
	        var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	        if (willDeleteLastPositionInElement(forward, fromPos, target.dom) && !isEmptyCaretFormatElement(target)) {
	          deleteLastPosition(forward, editor, target, parentInlines);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    };
	    var backspaceDelete$7 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$2(editor, forward) : false;
	    };
	
	    var deleteElement$2 = function (editor, forward, element) {
	      editor._selectionOverrides.hideFakeCaret();
	      deleteElement(editor, forward, SugarElement.fromDom(element));
	      return true;
	    };
	    var deleteCaret$3 = function (editor, forward) {
	      var isNearMedia = forward ? isBeforeMedia : isAfterMedia;
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var fromPos = getNormalizedRangeEndPoint(direction, editor.getBody(), editor.selection.getRng());
	      if (isNearMedia(fromPos)) {
	        return deleteElement$2(editor, forward, fromPos.getNode(!forward));
	      } else {
	        return Optional.from(normalizePosition(forward, fromPos)).filter(function (pos) {
	          return isNearMedia(pos) && isMoveInsideSameBlock(fromPos, pos);
	        }).exists(function (pos) {
	          return deleteElement$2(editor, forward, pos.getNode(!forward));
	        });
	      }
	    };
	    var deleteRange$2 = function (editor, forward) {
	      var selectedNode = editor.selection.getNode();
	      return isMedia(selectedNode) ? deleteElement$2(editor, forward, selectedNode) : false;
	    };
	    var backspaceDelete$8 = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret$3(editor, forward) : deleteRange$2(editor, forward);
	    };
	
	    var isEditable$1 = function (target) {
	      return closest(target, function (elm) {
	        return isContentEditableTrue(elm.dom) || isContentEditableFalse(elm.dom);
	      }).exists(function (elm) {
	        return isContentEditableTrue(elm.dom);
	      });
	    };
	    var parseIndentValue = function (value) {
	      var number = parseInt(value, 10);
	      return isNaN(number) ? 0 : number;
	    };
	    var getIndentStyleName = function (useMargin, element) {
	      var indentStyleName = useMargin || isTable$1(element) ? 'margin' : 'padding';
	      var suffix = get$5(element, 'direction') === 'rtl' ? '-right' : '-left';
	      return indentStyleName + suffix;
	    };
	    var indentElement = function (dom, command, useMargin, value, unit, element) {
	      var indentStyleName = getIndentStyleName(useMargin, SugarElement.fromDom(element));
	      if (command === 'outdent') {
	        var styleValue = Math.max(0, parseIndentValue(element.style[indentStyleName]) - value);
	        dom.setStyle(element, indentStyleName, styleValue ? styleValue + unit : '');
	      } else {
	        var styleValue = parseIndentValue(element.style[indentStyleName]) + value + unit;
	        dom.setStyle(element, indentStyleName, styleValue);
	      }
	    };
	    var validateBlocks = function (editor, blocks) {
	      return forall(blocks, function (block) {
	        var indentStyleName = getIndentStyleName(shouldIndentUseMargin(editor), block);
	        var intentValue = getRaw(block, indentStyleName).map(parseIndentValue).getOr(0);
	        var contentEditable = editor.dom.getContentEditable(block.dom);
	        return contentEditable !== 'false' && intentValue > 0;
	      });
	    };
	    var canOutdent = function (editor) {
	      var blocks = getBlocksToIndent(editor);
	      return !editor.mode.isReadOnly() && (blocks.length > 1 || validateBlocks(editor, blocks));
	    };
	    var isListComponent = function (el) {
	      return isList(el) || isListItem(el);
	    };
	    var parentIsListComponent = function (el) {
	      return parent(el).map(isListComponent).getOr(false);
	    };
	    var getBlocksToIndent = function (editor) {
	      return filter(map(editor.selection.getSelectedBlocks(), SugarElement.fromDom), function (el) {
	        return !isListComponent(el) && !parentIsListComponent(el) && isEditable$1(el);
	      });
	    };
	    var handle = function (editor, command) {
	      var dom = editor.dom, selection = editor.selection, formatter = editor.formatter;
	      var indentation = getIndentation(editor);
	      var indentUnit = /[a-z%]+$/i.exec(indentation)[0];
	      var indentValue = parseInt(indentation, 10);
	      var useMargin = shouldIndentUseMargin(editor);
	      var forcedRootBlock = getForcedRootBlock(editor);
	      if (!editor.queryCommandState('InsertUnorderedList') && !editor.queryCommandState('InsertOrderedList')) {
	        if (forcedRootBlock === '' && !dom.getParent(selection.getNode(), dom.isBlock)) {
	          formatter.apply('div');
	        }
	      }
	      each(getBlocksToIndent(editor), function (block) {
	        indentElement(dom, command, useMargin, indentValue, indentUnit, block.dom);
	      });
	    };
	
	    var backspaceDelete$9 = function (editor, _forward) {
	      if (editor.selection.isCollapsed() && canOutdent(editor)) {
	        var dom = editor.dom;
	        var rng = editor.selection.getRng();
	        var pos = CaretPosition.fromRangeStart(rng);
	        var block = dom.getParent(rng.startContainer, dom.isBlock);
	        if (block !== null && isAtStartOfBlock(SugarElement.fromDom(block), pos)) {
	          handle(editor, 'outdent');
	          return true;
	        }
	      }
	      return false;
	    };
	
	    var nativeCommand = function (editor, command) {
	      editor.getDoc().execCommand(command, false, null);
	    };
	    var deleteCommand = function (editor, caret) {
	      if (backspaceDelete$9(editor)) {
	        return;
	      } else if (backspaceDelete$4(editor, false)) {
	        return;
	      } else if (backspaceDelete$3(editor, false)) {
	        return;
	      } else if (backspaceDelete$6(editor, caret, false)) {
	        return;
	      } else if (backspaceDelete$1(editor, false)) {
	        return;
	      } else if (backspaceDelete(editor)) {
	        return;
	      } else if (backspaceDelete$5(editor, false)) {
	        return;
	      } else if (backspaceDelete$8(editor, false)) {
	        return;
	      } else if (backspaceDelete$2(editor)) {
	        return;
	      } else if (backspaceDelete$7(editor, false)) {
	        return;
	      } else {
	        nativeCommand(editor, 'Delete');
	        paddEmptyBody(editor);
	      }
	    };
	    var forwardDeleteCommand = function (editor, caret) {
	      if (backspaceDelete$4(editor, true)) {
	        return;
	      } else if (backspaceDelete$3(editor, true)) {
	        return;
	      } else if (backspaceDelete$6(editor, caret, true)) {
	        return;
	      } else if (backspaceDelete$1(editor, true)) {
	        return;
	      } else if (backspaceDelete(editor)) {
	        return;
	      } else if (backspaceDelete$5(editor, true)) {
	        return;
	      } else if (backspaceDelete$8(editor, true)) {
	        return;
	      } else if (backspaceDelete$2(editor)) {
	        return;
	      } else if (backspaceDelete$7(editor, true)) {
	        return;
	      } else {
	        nativeCommand(editor, 'ForwardDelete');
	      }
	    };
	    var setup$8 = function (editor, caret) {
	      editor.addCommand('delete', function () {
	        deleteCommand(editor, caret);
	      });
	      editor.addCommand('forwardDelete', function () {
	        forwardDeleteCommand(editor, caret);
	      });
	    };
	
	    var SIGNIFICANT_MOVE = 5;
	    var LONGPRESS_DELAY = 400;
	    var getTouch = function (event) {
	      if (event.touches === undefined || event.touches.length !== 1) {
	        return Optional.none();
	      }
	      return Optional.some(event.touches[0]);
	    };
	    var isFarEnough = function (touch, data) {
	      var distX = Math.abs(touch.clientX - data.x);
	      var distY = Math.abs(touch.clientY - data.y);
	      return distX > SIGNIFICANT_MOVE || distY > SIGNIFICANT_MOVE;
	    };
	    var setup$9 = function (editor) {
	      var startData = Cell(Optional.none());
	      var longpressFired = Cell(false);
	      var debounceLongpress = last$2(function (e) {
	        editor.fire('longpress', __assign(__assign({}, e), { type: 'longpress' }));
	        longpressFired.set(true);
	      }, LONGPRESS_DELAY);
	      editor.on('touchstart', function (e) {
	        getTouch(e).each(function (touch) {
	          debounceLongpress.cancel();
	          var data = {
	            x: touch.clientX,
	            y: touch.clientY,
	            target: e.target
	          };
	          debounceLongpress.throttle(e);
	          longpressFired.set(false);
	          startData.set(Optional.some(data));
	        });
	      }, true);
	      editor.on('touchmove', function (e) {
	        debounceLongpress.cancel();
	        getTouch(e).each(function (touch) {
	          startData.get().each(function (data) {
	            if (isFarEnough(touch, data)) {
	              startData.set(Optional.none());
	              longpressFired.set(false);
	              editor.fire('longpresscancel');
	            }
	          });
	        });
	      }, true);
	      editor.on('touchend touchcancel', function (e) {
	        debounceLongpress.cancel();
	        if (e.type === 'touchcancel') {
	          return;
	        }
	        startData.get().filter(function (data) {
	          return data.target.isEqualNode(e.target);
	        }).each(function () {
	          if (longpressFired.get()) {
	            e.preventDefault();
	          } else {
	            editor.fire('tap', __assign(__assign({}, e), { type: 'tap' }));
	          }
	        });
	      }, true);
	    };
	
	    var isBlockElement = function (blockElements, node) {
	      return blockElements.hasOwnProperty(node.nodeName);
	    };
	    var isValidTarget = function (blockElements, node) {
	      if (isText$1(node)) {
	        return true;
	      } else if (isElement$1(node)) {
	        return !isBlockElement(blockElements, node) && !isBookmarkNode$1(node);
	      } else {
	        return false;
	      }
	    };
	    var hasBlockParent = function (blockElements, root, node) {
	      return exists(parents$1(SugarElement.fromDom(node), SugarElement.fromDom(root)), function (elm) {
	        return isBlockElement(blockElements, elm.dom);
	      });
	    };
	    var shouldRemoveTextNode = function (blockElements, node) {
	      if (isText$1(node)) {
	        if (node.nodeValue.length === 0) {
	          return true;
	        } else if (/^\s+$/.test(node.nodeValue) && (!node.nextSibling || isBlockElement(blockElements, node.nextSibling))) {
	          return true;
	        }
	      }
	      return false;
	    };
	    var addRootBlocks = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var schema = editor.schema, blockElements = schema.getBlockElements();
	      var node = selection.getStart();
	      var rootNode = editor.getBody();
	      var rootBlockNode, tempNode, wrapped;
	      var forcedRootBlock = getForcedRootBlock(editor);
	      if (!node || !isElement$1(node) || !forcedRootBlock) {
	        return;
	      }
	      var rootNodeName = rootNode.nodeName.toLowerCase();
	      if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
	        return;
	      }
	      var rng = selection.getRng();
	      var startContainer = rng.startContainer;
	      var startOffset = rng.startOffset;
	      var endContainer = rng.endContainer;
	      var endOffset = rng.endOffset;
	      var restoreSelection = hasFocus$1(editor);
	      node = rootNode.firstChild;
	      while (node) {
	        if (isValidTarget(blockElements, node)) {
	          if (shouldRemoveTextNode(blockElements, node)) {
	            tempNode = node;
	            node = node.nextSibling;
	            dom.remove(tempNode);
	            continue;
	          }
	          if (!rootBlockNode) {
	            rootBlockNode = dom.create(forcedRootBlock, getForcedRootBlockAttrs(editor));
	            node.parentNode.insertBefore(rootBlockNode, node);
	            wrapped = true;
	          }
	          tempNode = node;
	          node = node.nextSibling;
	          rootBlockNode.appendChild(tempNode);
	        } else {
	          rootBlockNode = null;
	          node = node.nextSibling;
	        }
	      }
	      if (wrapped && restoreSelection) {
	        rng.setStart(startContainer, startOffset);
	        rng.setEnd(endContainer, endOffset);
	        selection.setRng(rng);
	        editor.nodeChanged();
	      }
	    };
	    var setup$a = function (editor) {
	      if (getForcedRootBlock(editor)) {
	        editor.on('NodeChange', curry(addRootBlocks, editor));
	      }
	    };
	
	    var findBlockCaretContainer = function (editor) {
	      return descendant(SugarElement.fromDom(editor.getBody()), '*[data-mce-caret]').fold(constant(null), function (elm) {
	        return elm.dom;
	      });
	    };
	    var removeIeControlRect = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	    var showBlockCaretContainer = function (editor, blockCaretContainer) {
	      if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	        showCaretContainerBlock(blockCaretContainer);
	        removeIeControlRect(editor);
	        editor.selection.scrollIntoView(blockCaretContainer);
	      }
	    };
	    var handleBlockContainer = function (editor, e) {
	      var blockCaretContainer = findBlockCaretContainer(editor);
	      if (!blockCaretContainer) {
	        return;
	      }
	      if (e.type === 'compositionstart') {
	        e.preventDefault();
	        e.stopPropagation();
	        showBlockCaretContainer(editor, blockCaretContainer);
	        return;
	      }
	      if (hasContent(blockCaretContainer)) {
	        showBlockCaretContainer(editor, blockCaretContainer);
	        editor.undoManager.add();
	      }
	    };
	    var setup$b = function (editor) {
	      editor.on('keyup compositionstart', curry(handleBlockContainer, editor));
	    };
	
	    var isContentEditableFalse$9 = isContentEditableFalse;
	    var moveToCeFalseHorizontally = function (direction, editor, range) {
	      return moveHorizontally(editor, direction, range, isBeforeContentEditableFalse, isAfterContentEditableFalse, isContentEditableFalse$9);
	    };
	    var moveToCeFalseVertically = function (direction, editor, range) {
	      var isBefore = function (caretPosition) {
	        return isBeforeContentEditableFalse(caretPosition) || isBeforeTable(caretPosition);
	      };
	      var isAfter = function (caretPosition) {
	        return isAfterContentEditableFalse(caretPosition) || isAfterTable(caretPosition);
	      };
	      return moveVertically(editor, direction, range, isBefore, isAfter, isContentEditableFalse$9);
	    };
	    var createTextBlock = function (editor) {
	      var textBlock = editor.dom.create(getForcedRootBlock(editor));
	      if (!Env.ie || Env.ie >= 11) {
	        textBlock.innerHTML = '<br data-mce-bogus="1">';
	      }
	      return textBlock;
	    };
	    var exitPreBlock = function (editor, direction, range) {
	      var caretWalker = CaretWalker(editor.getBody());
	      var getVisualCaretPosition$1 = curry(getVisualCaretPosition, direction === 1 ? caretWalker.next : caretWalker.prev);
	      if (range.collapsed && hasForcedRootBlock(editor)) {
	        var pre = editor.dom.getParent(range.startContainer, 'PRE');
	        if (!pre) {
	          return;
	        }
	        var caretPos = getVisualCaretPosition$1(CaretPosition.fromRangeStart(range));
	        if (!caretPos) {
	          var newBlock = createTextBlock(editor);
	          if (direction === 1) {
	            editor.$(pre).after(newBlock);
	          } else {
	            editor.$(pre).before(newBlock);
	          }
	          editor.selection.select(newBlock, true);
	          editor.selection.collapse();
	        }
	      }
	    };
	    var getHorizontalRange = function (editor, forward) {
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var range = editor.selection.getRng();
	      return moveToCeFalseHorizontally(direction, editor, range).orThunk(function () {
	        exitPreBlock(editor, direction, range);
	        return Optional.none();
	      });
	    };
	    var getVerticalRange = function (editor, down) {
	      var direction = down ? 1 : -1;
	      var range = editor.selection.getRng();
	      return moveToCeFalseVertically(direction, editor, range).orThunk(function () {
	        exitPreBlock(editor, direction, range);
	        return Optional.none();
	      });
	    };
	    var moveH = function (editor, forward) {
	      return getHorizontalRange(editor, forward).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveV = function (editor, down) {
	      return getVerticalRange(editor, down).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveToLineEndPoint$2 = function (editor, forward) {
	      var isCefPosition = forward ? isAfterContentEditableFalse : isBeforeContentEditableFalse;
	      return moveToLineEndPoint(editor, forward, isCefPosition);
	    };
	
	    var isTarget = function (node) {
	      return contains(['figcaption'], name(node));
	    };
	    var rangeBefore = function (target) {
	      var rng = document.createRange();
	      rng.setStartBefore(target.dom);
	      rng.setEndBefore(target.dom);
	      return rng;
	    };
	    var insertElement = function (root, elm, forward) {
	      if (forward) {
	        append(root, elm);
	      } else {
	        prepend(root, elm);
	      }
	    };
	    var insertBr = function (root, forward) {
	      var br = SugarElement.fromTag('br');
	      insertElement(root, br, forward);
	      return rangeBefore(br);
	    };
	    var insertBlock$1 = function (root, forward, blockName, attrs) {
	      var block = SugarElement.fromTag(blockName);
	      var br = SugarElement.fromTag('br');
	      setAll(block, attrs);
	      append(block, br);
	      insertElement(root, block, forward);
	      return rangeBefore(br);
	    };
	    var insertEmptyLine = function (root, rootBlockName, attrs, forward) {
	      if (rootBlockName === '') {
	        return insertBr(root, forward);
	      } else {
	        return insertBlock$1(root, forward, rootBlockName, attrs);
	      }
	    };
	    var getClosestTargetBlock = function (pos, root) {
	      var isRoot = curry(eq$2, root);
	      return closest(SugarElement.fromDom(pos.container()), isBlock, isRoot).filter(isTarget);
	    };
	    var isAtFirstOrLastLine = function (root, forward, pos) {
	      return forward ? isAtLastLine(root.dom, pos) : isAtFirstLine(root.dom, pos);
	    };
	    var moveCaretToNewEmptyLine = function (editor, forward) {
	      var root = SugarElement.fromDom(editor.getBody());
	      var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var rootBlock = getForcedRootBlock(editor);
	      var rootBlockAttrs = getForcedRootBlockAttrs(editor);
	      return getClosestTargetBlock(pos, root).exists(function () {
	        if (isAtFirstOrLastLine(root, forward, pos)) {
	          var rng = insertEmptyLine(root, rootBlock, rootBlockAttrs, forward);
	          editor.selection.setRng(rng);
	          return true;
	        } else {
	          return false;
	        }
	      });
	    };
	    var moveV$1 = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return moveCaretToNewEmptyLine(editor, forward);
	      } else {
	        return false;
	      }
	    };
	
	    var defaultPatterns = function (patterns) {
	      return map(patterns, function (pattern) {
	        return __assign({
	          shiftKey: false,
	          altKey: false,
	          ctrlKey: false,
	          metaKey: false,
	          keyCode: 0,
	          action: noop
	        }, pattern);
	      });
	    };
	    var matchesEvent = function (pattern, evt) {
	      return evt.keyCode === pattern.keyCode && evt.shiftKey === pattern.shiftKey && evt.altKey === pattern.altKey && evt.ctrlKey === pattern.ctrlKey && evt.metaKey === pattern.metaKey;
	    };
	    var match$1 = function (patterns, evt) {
	      return bind(defaultPatterns(patterns), function (pattern) {
	        return matchesEvent(pattern, evt) ? [pattern] : [];
	      });
	    };
	    var action = function (f) {
	      var x = [];
	      for (var _i = 1; _i < arguments.length; _i++) {
	        x[_i - 1] = arguments[_i];
	      }
	      return function () {
	        return f.apply(null, x);
	      };
	    };
	    var execute = function (patterns, evt) {
	      return find(match$1(patterns, evt), function (pattern) {
	        return pattern.action();
	      });
	    };
	
	    var moveH$1 = function (editor, forward) {
	      var direction = forward ? HDirection.Forwards : HDirection.Backwards;
	      var range = editor.selection.getRng();
	      return moveHorizontally(editor, direction, range, isBeforeMedia, isAfterMedia, isMedia).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveV$2 = function (editor, down) {
	      var direction = down ? 1 : -1;
	      var range = editor.selection.getRng();
	      return moveVertically(editor, direction, range, isBeforeMedia, isAfterMedia, isMedia).exists(function (newRange) {
	        moveToRange(editor, newRange);
	        return true;
	      });
	    };
	    var moveToLineEndPoint$3 = function (editor, forward) {
	      var isNearMedia = forward ? isAfterMedia : isBeforeMedia;
	      return moveToLineEndPoint(editor, forward, isNearMedia);
	    };
	
	    var deflate = function (rect, delta) {
	      return {
	        left: rect.left - delta,
	        top: rect.top - delta,
	        right: rect.right + delta * 2,
	        bottom: rect.bottom + delta * 2,
	        width: rect.width + delta,
	        height: rect.height + delta
	      };
	    };
	    var getCorners = function (getYAxisValue, tds) {
	      return bind(tds, function (td) {
	        var rect = deflate(clone$2(td.getBoundingClientRect()), -1);
	        return [
	          {
	            x: rect.left,
	            y: getYAxisValue(rect),
	            cell: td
	          },
	          {
	            x: rect.right,
	            y: getYAxisValue(rect),
	            cell: td
	          }
	        ];
	      });
	    };
	    var findClosestCorner = function (corners, x, y) {
	      return foldl(corners, function (acc, newCorner) {
	        return acc.fold(function () {
	          return Optional.some(newCorner);
	        }, function (oldCorner) {
	          var oldDist = Math.sqrt(Math.abs(oldCorner.x - x) + Math.abs(oldCorner.y - y));
	          var newDist = Math.sqrt(Math.abs(newCorner.x - x) + Math.abs(newCorner.y - y));
	          return Optional.some(newDist < oldDist ? newCorner : oldCorner);
	        });
	      }, Optional.none());
	    };
	    var getClosestCell$1 = function (getYAxisValue, isTargetCorner, table, x, y) {
	      var cells = descendants$1(SugarElement.fromDom(table), 'td,th,caption').map(function (e) {
	        return e.dom;
	      });
	      var corners = filter(getCorners(getYAxisValue, cells), function (corner) {
	        return isTargetCorner(corner, y);
	      });
	      return findClosestCorner(corners, x, y).map(function (corner) {
	        return corner.cell;
	      });
	    };
	    var getBottomValue = function (rect) {
	      return rect.bottom;
	    };
	    var getTopValue = function (rect) {
	      return rect.top;
	    };
	    var isAbove$1 = function (corner, y) {
	      return corner.y < y;
	    };
	    var isBelow$1 = function (corner, y) {
	      return corner.y > y;
	    };
	    var getClosestCellAbove = curry(getClosestCell$1, getBottomValue, isAbove$1);
	    var getClosestCellBelow = curry(getClosestCell$1, getTopValue, isBelow$1);
	    var findClosestPositionInAboveCell = function (table, pos) {
	      return head(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellAbove(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getLastLinePositions(cell), pos);
	      });
	    };
	    var findClosestPositionInBelowCell = function (table, pos) {
	      return last(pos.getClientRects()).bind(function (rect) {
	        return getClosestCellBelow(table, rect.left, rect.top);
	      }).bind(function (cell) {
	        return findClosestHorizontalPosition(getFirstLinePositions(cell), pos);
	      });
	    };
	
	    var hasNextBreak = function (getPositionsUntil, scope, lineInfo) {
	      return lineInfo.breakAt.exists(function (breakPos) {
	        return getPositionsUntil(scope, breakPos).breakAt.isSome();
	      });
	    };
	    var startsWithWrapBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Wrap && lineInfo.positions.length === 0;
	    };
	    var startsWithBrBreak = function (lineInfo) {
	      return lineInfo.breakType === BreakType.Br && lineInfo.positions.length === 1;
	    };
	    var isAtTableCellLine = function (getPositionsUntil, scope, pos) {
	      var lineInfo = getPositionsUntil(scope, pos);
	      if (startsWithWrapBreak(lineInfo) || !isBr(pos.getNode()) && startsWithBrBreak(lineInfo)) {
	        return !hasNextBreak(getPositionsUntil, scope, lineInfo);
	      } else {
	        return lineInfo.breakAt.isNone();
	      }
	    };
	    var isAtFirstTableCellLine = curry(isAtTableCellLine, getPositionsUntilPreviousLine);
	    var isAtLastTableCellLine = curry(isAtTableCellLine, getPositionsUntilNextLine);
	    var isCaretAtStartOrEndOfTable = function (forward, rng, table) {
	      var caretPos = CaretPosition.fromRangeStart(rng);
	      return positionIn(!forward, table).exists(function (pos) {
	        return pos.isEqual(caretPos);
	      });
	    };
	    var navigateHorizontally = function (editor, forward, table, _td) {
	      var rng = editor.selection.getRng();
	      var direction = forward ? 1 : -1;
	      if (isFakeCaretTableBrowser() && isCaretAtStartOrEndOfTable(forward, rng, table)) {
	        showCaret(direction, editor, table, !forward, false).each(function (newRng) {
	          moveToRange(editor, newRng);
	        });
	        return true;
	      }
	      return false;
	    };
	    var getClosestAbovePosition = function (root, table, start) {
	      return findClosestPositionInAboveCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsAbove(root, CaretPosition.before(table)), rect.left);
	        });
	      }).getOr(CaretPosition.before(table));
	    };
	    var getClosestBelowPosition = function (root, table, start) {
	      return findClosestPositionInBelowCell(table, start).orThunk(function () {
	        return head(start.getClientRects()).bind(function (rect) {
	          return findClosestHorizontalPositionFromPoint(getPositionsBelow(root, CaretPosition.after(table)), rect.left);
	        });
	      }).getOr(CaretPosition.after(table));
	    };
	    var getTable = function (previous, pos) {
	      var node = pos.getNode(previous);
	      return isElement$1(node) && node.nodeName === 'TABLE' ? Optional.some(node) : Optional.none();
	    };
	    var renderBlock = function (down, editor, table, pos) {
	      var forcedRootBlock = getForcedRootBlock(editor);
	      if (forcedRootBlock) {
	        editor.undoManager.transact(function () {
	          var element = SugarElement.fromTag(forcedRootBlock);
	          setAll(element, getForcedRootBlockAttrs(editor));
	          append(element, SugarElement.fromTag('br'));
	          if (down) {
	            after(SugarElement.fromDom(table), element);
	          } else {
	            before(SugarElement.fromDom(table), element);
	          }
	          var rng = editor.dom.createRng();
	          rng.setStart(element.dom, 0);
	          rng.setEnd(element.dom, 0);
	          moveToRange(editor, rng);
	        });
	      } else {
	        moveToRange(editor, pos.toRange());
	      }
	    };
	    var moveCaret = function (editor, down, pos) {
	      var table = down ? getTable(true, pos) : getTable(false, pos);
	      var last = down === false;
	      table.fold(function () {
	        return moveToRange(editor, pos.toRange());
	      }, function (table) {
	        return positionIn(last, editor.getBody()).filter(function (lastPos) {
	          return lastPos.isEqual(pos);
	        }).fold(function () {
	          return moveToRange(editor, pos.toRange());
	        }, function (_) {
	          return renderBlock(down, editor, table, pos);
	        });
	      });
	    };
	    var navigateVertically = function (editor, down, table, td) {
	      var rng = editor.selection.getRng();
	      var pos = CaretPosition.fromRangeStart(rng);
	      var root = editor.getBody();
	      if (!down && isAtFirstTableCellLine(td, pos)) {
	        var newPos = getClosestAbovePosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else if (down && isAtLastTableCellLine(td, pos)) {
	        var newPos = getClosestBelowPosition(root, table, pos);
	        moveCaret(editor, down, newPos);
	        return true;
	      } else {
	        return false;
	      }
	    };
	    var move$1 = function (editor, forward, mover) {
	      return Optional.from(editor.dom.getParent(editor.selection.getNode(), 'td,th')).bind(function (td) {
	        return Optional.from(editor.dom.getParent(td, 'table')).map(function (table) {
	          return mover(editor, forward, table, td);
	        });
	      }).getOr(false);
	    };
	    var moveH$2 = function (editor, forward) {
	      return move$1(editor, forward, navigateHorizontally);
	    };
	    var moveV$3 = function (editor, forward) {
	      return move$1(editor, forward, navigateVertically);
	    };
	
	    var executeKeydownOverride = function (editor, caret, evt) {
	      var os = detect$3().os;
	      execute([
	        {
	          keyCode: VK.RIGHT,
	          action: action(moveH, editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(moveH, editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV, editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: action(moveH$2, editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(moveH$2, editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV$3, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV$3, editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: action(moveH$1, editor, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(moveH$1, editor, false)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV$2, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV$2, editor, true)
	        },
	        {
	          keyCode: VK.RIGHT,
	          action: action(move, editor, caret, true)
	        },
	        {
	          keyCode: VK.LEFT,
	          action: action(move, editor, caret, false)
	        },
	        {
	          keyCode: VK.RIGHT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: action(moveNextWord, editor, caret)
	        },
	        {
	          keyCode: VK.LEFT,
	          ctrlKey: !os.isOSX(),
	          altKey: os.isOSX(),
	          action: action(movePrevWord, editor, caret)
	        },
	        {
	          keyCode: VK.UP,
	          action: action(moveV$1, editor, false)
	        },
	        {
	          keyCode: VK.DOWN,
	          action: action(moveV$1, editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$c = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, caret, evt);
	        }
	      });
	    };
	
	    var executeKeydownOverride$1 = function (editor, caret, evt) {
	      execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$9, editor, false)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$4, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$4, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$3, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$3, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$6, editor, caret, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$6, editor, caret, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$5, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$5, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$8, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$8, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$2, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$2, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$1, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$1, editor, true)
	        },
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(backspaceDelete$7, editor, false)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(backspaceDelete$7, editor, true)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var executeKeyupOverride = function (editor, evt) {
	      execute([
	        {
	          keyCode: VK.BACKSPACE,
	          action: action(paddEmptyElement, editor)
	        },
	        {
	          keyCode: VK.DELETE,
	          action: action(paddEmptyElement, editor)
	        }
	      ], evt);
	    };
	    var setup$d = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$1(editor, caret, evt);
	        }
	      });
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupOverride(editor, evt);
	        }
	      });
	    };
	
	    var firstNonWhiteSpaceNodeSibling = function (node) {
	      while (node) {
	        if (node.nodeType === 1 || node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data)) {
	          return node;
	        }
	        node = node.nextSibling;
	      }
	    };
	    var moveToCaretPosition = function (editor, root) {
	      var node, lastNode = root;
	      var dom = editor.dom;
	      var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
	      if (!root) {
	        return;
	      }
	      if (/^(LI|DT|DD)$/.test(root.nodeName)) {
	        var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
	        if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
	          root.insertBefore(dom.doc.createTextNode(nbsp), root.firstChild);
	        }
	      }
	      var rng = dom.createRng();
	      root.normalize();
	      if (root.hasChildNodes()) {
	        var walker = new DomTreeWalker(root, root);
	        while (node = walker.current()) {
	          if (isText$1(node)) {
	            rng.setStart(node, 0);
	            rng.setEnd(node, 0);
	            break;
	          }
	          if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
	            rng.setStartBefore(node);
	            rng.setEndBefore(node);
	            break;
	          }
	          lastNode = node;
	          node = walker.next();
	        }
	        if (!node) {
	          rng.setStart(lastNode, 0);
	          rng.setEnd(lastNode, 0);
	        }
	      } else {
	        if (isBr(root)) {
	          if (root.nextSibling && dom.isBlock(root.nextSibling)) {
	            rng.setStartBefore(root);
	            rng.setEndBefore(root);
	          } else {
	            rng.setStartAfter(root);
	            rng.setEndAfter(root);
	          }
	        } else {
	          rng.setStart(root, 0);
	          rng.setEnd(root, 0);
	        }
	      }
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, rng);
	    };
	    var getEditableRoot = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var getParentBlock$2 = function (editor) {
	      return Optional.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
	    };
	    var getParentBlockName = function (editor) {
	      return getParentBlock$2(editor).fold(constant(''), function (parentBlock) {
	        return parentBlock.nodeName.toUpperCase();
	      });
	    };
	    var isListItemParentBlock = function (editor) {
	      return getParentBlock$2(editor).filter(function (elm) {
	        return isListItem(SugarElement.fromDom(elm));
	      }).isSome();
	    };
	
	    var hasFirstChild = function (elm, name) {
	      return elm.firstChild && elm.firstChild.nodeName === name;
	    };
	    var isFirstChild = function (elm) {
	      var _a;
	      return ((_a = elm.parentNode) === null || _a === void 0 ? void 0 : _a.firstChild) === elm;
	    };
	    var hasParent$1 = function (elm, parentName) {
	      return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
	    };
	    var isListBlock = function (elm) {
	      return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
	    };
	    var isNestedList = function (elm) {
	      return isListBlock(elm) && isListBlock(elm.parentNode);
	    };
	    var getContainerBlock = function (containerBlock) {
	      var containerBlockParent = containerBlock.parentNode;
	      if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
	        return containerBlockParent;
	      }
	      return containerBlock;
	    };
	    var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
	      var node = containerBlock[first ? 'firstChild' : 'lastChild'];
	      while (node) {
	        if (isElement$1(node)) {
	          break;
	        }
	        node = node[first ? 'nextSibling' : 'previousSibling'];
	      }
	      return node === parentBlock;
	    };
	    var insert = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
	      var dom = editor.dom;
	      var rng = editor.selection.getRng();
	      if (containerBlock === editor.getBody()) {
	        return;
	      }
	      if (isNestedList(containerBlock)) {
	        newBlockName = 'LI';
	      }
	      var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
	      if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        if (hasParent$1(containerBlock, 'LI')) {
	          var containerBlockParent = getContainerBlock(containerBlock);
	          dom.insertAfter(newBlock, containerBlockParent);
	          if (isFirstChild(containerBlock)) {
	            dom.remove(containerBlockParent);
	          } else {
	            dom.remove(containerBlock);
	          }
	        } else {
	          dom.replace(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
	        if (hasParent$1(containerBlock, 'LI')) {
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	          newBlock.appendChild(dom.doc.createTextNode(' '));
	          newBlock.appendChild(containerBlock);
	        } else {
	          containerBlock.parentNode.insertBefore(newBlock, containerBlock);
	        }
	        dom.remove(parentBlock);
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	        dom.remove(parentBlock);
	      } else {
	        containerBlock = getContainerBlock(containerBlock);
	        var tmpRng = rng.cloneRange();
	        tmpRng.setStartAfter(parentBlock);
	        tmpRng.setEndAfter(containerBlock);
	        var fragment = tmpRng.extractContents();
	        if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
	          newBlock = fragment.firstChild;
	          dom.insertAfter(fragment, containerBlock);
	        } else {
	          dom.insertAfter(fragment, containerBlock);
	          dom.insertAfter(newBlock, containerBlock);
	        }
	        dom.remove(parentBlock);
	      }
	      moveToCaretPosition(editor, newBlock);
	    };
	
	    var trimZwsp = function (fragment) {
	      each(descendants(SugarElement.fromDom(fragment), isText), function (text) {
	        var rawNode = text.dom;
	        rawNode.nodeValue = trim$2(rawNode.nodeValue);
	      });
	    };
	    var isEmptyAnchor = function (dom, elm) {
	      return elm && elm.nodeName === 'A' && dom.isEmpty(elm);
	    };
	    var isTableCell$5 = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	    var emptyBlock = function (elm) {
	      elm.innerHTML = '<br data-mce-bogus="1">';
	    };
	    var containerAndSiblingName = function (container, nodeName) {
	      return container.nodeName === nodeName || container.previousSibling && container.previousSibling.nodeName === nodeName;
	    };
	    var canSplitBlock = function (dom, node) {
	      return node && dom.isBlock(node) && !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) && !/^(fixed|absolute)/i.test(node.style.position) && dom.getContentEditable(node) !== 'true';
	    };
	    var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
	      var node = block;
	      var firstChilds = [];
	      var i;
	      if (!node) {
	        return;
	      }
	      while (node = node.firstChild) {
	        if (dom.isBlock(node)) {
	          return;
	        }
	        if (isElement$1(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          firstChilds.push(node);
	        }
	      }
	      i = firstChilds.length;
	      while (i--) {
	        node = firstChilds[i];
	        if (!node.hasChildNodes() || node.firstChild === node.lastChild && node.firstChild.nodeValue === '') {
	          dom.remove(node);
	        } else {
	          if (isEmptyAnchor(dom, node)) {
	            dom.remove(node);
	          }
	        }
	      }
	    };
	    var normalizeZwspOffset = function (start, container, offset) {
	      if (isText$1(container) === false) {
	        return offset;
	      } else if (start) {
	        return offset === 1 && container.data.charAt(offset - 1) === ZWSP ? 0 : offset;
	      } else {
	        return offset === container.data.length - 1 && container.data.charAt(offset) === ZWSP ? container.data.length : offset;
	      }
	    };
	    var includeZwspInRange = function (rng) {
	      var newRng = rng.cloneRange();
	      newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
	      newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
	      return newRng;
	    };
	    var trimLeadingLineBreaks = function (node) {
	      do {
	        if (isText$1(node)) {
	          node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
	        }
	        node = node.firstChild;
	      } while (node);
	    };
	    var getEditableRoot$1 = function (dom, node) {
	      var root = dom.getRoot();
	      var parent, editableRoot;
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== 'false') {
	        if (dom.getContentEditable(parent) === 'true') {
	          editableRoot = parent;
	        }
	        parent = parent.parentNode;
	      }
	      return parent !== root ? editableRoot : root;
	    };
	    var applyAttributes = function (editor, node, forcedRootBlockAttrs) {
	      var dom = editor.dom;
	      Optional.from(forcedRootBlockAttrs.style).map(dom.parseStyle).each(function (attrStyles) {
	        var currentStyles = getAllRaw(SugarElement.fromDom(node));
	        var newStyles = __assign(__assign({}, currentStyles), attrStyles);
	        dom.setStyles(node, newStyles);
	      });
	      var attrClassesOpt = Optional.from(forcedRootBlockAttrs.class).map(function (attrClasses) {
	        return attrClasses.split(/\s+/);
	      });
	      var currentClassesOpt = Optional.from(node.className).map(function (currentClasses) {
	        return filter(currentClasses.split(/\s+/), function (clazz) {
	          return clazz !== '';
	        });
	      });
	      lift2(attrClassesOpt, currentClassesOpt, function (attrClasses, currentClasses) {
	        var filteredClasses = filter(currentClasses, function (clazz) {
	          return !contains(attrClasses, clazz);
	        });
	        var newClasses = __spreadArrays(attrClasses, filteredClasses);
	        dom.setAttrib(node, 'class', newClasses.join(' '));
	      });
	      var appliedAttrs = [
	        'style',
	        'class'
	      ];
	      var remainingAttrs = filter$1(forcedRootBlockAttrs, function (_, attrs) {
	        return !contains(appliedAttrs, attrs);
	      });
	      dom.setAttribs(node, remainingAttrs);
	    };
	    var setForcedBlockAttrs = function (editor, node) {
	      var forcedRootBlockName = getForcedRootBlock(editor);
	      if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
	        var forcedRootBlockAttrs = getForcedRootBlockAttrs(editor);
	        applyAttributes(editor, node, forcedRootBlockAttrs);
	      }
	    };
	    var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
	      var newBlock, parentBlock, startNode, node, next, rootBlockName;
	      var blockName = newBlockName || 'P';
	      var dom = editor.dom, editableRoot = getEditableRoot$1(dom, container);
	      parentBlock = dom.getParent(container, dom.isBlock);
	      if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
	        parentBlock = parentBlock || editableRoot;
	        if (parentBlock === editor.getBody() || isTableCell$5(parentBlock)) {
	          rootBlockName = parentBlock.nodeName.toLowerCase();
	        } else {
	          rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
	        }
	        if (!parentBlock.hasChildNodes()) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          parentBlock.appendChild(newBlock);
	          rng.setStart(newBlock, 0);
	          rng.setEnd(newBlock, 0);
	          return newBlock;
	        }
	        node = container;
	        while (node.parentNode !== parentBlock) {
	          node = node.parentNode;
	        }
	        while (node && !dom.isBlock(node)) {
	          startNode = node;
	          node = node.previousSibling;
	        }
	        if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          startNode.parentNode.insertBefore(newBlock, startNode);
	          node = startNode;
	          while (node && !dom.isBlock(node)) {
	            next = node.nextSibling;
	            newBlock.appendChild(node);
	            node = next;
	          }
	          rng.setStart(container, offset);
	          rng.setEnd(container, offset);
	        }
	      }
	      return container;
	    };
	    var addBrToBlockIfNeeded = function (dom, block) {
	      block.normalize();
	      var lastChild = block.lastChild;
	      if (!lastChild || /^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true))) {
	        dom.add(block, 'br');
	      }
	    };
	    var insert$1 = function (editor, evt) {
	      var tmpRng, container, offset, parentBlock;
	      var newBlock, fragment, containerBlock, parentBlockName, newBlockName, isAfterLastNodeInContainer;
	      var dom = editor.dom;
	      var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
	      var rng = editor.selection.getRng();
	      var createNewBlock = function (name) {
	        var node = container, block, clonedNode, caretNode;
	        var textInlineElements = schema.getTextInlineElements();
	        if (name || parentBlockName === 'TABLE' || parentBlockName === 'HR') {
	          block = dom.create(name || newBlockName);
	        } else {
	          block = parentBlock.cloneNode(false);
	        }
	        caretNode = block;
	        if (shouldKeepStyles(editor) === false) {
	          dom.setAttrib(block, 'style', null);
	          dom.setAttrib(block, 'class', null);
	        } else {
	          do {
	            if (textInlineElements[node.nodeName]) {
	              if (isCaretNode(node) || isBookmarkNode$1(node)) {
	                continue;
	              }
	              clonedNode = node.cloneNode(false);
	              dom.setAttrib(clonedNode, 'id', '');
	              if (block.hasChildNodes()) {
	                clonedNode.appendChild(block.firstChild);
	                block.appendChild(clonedNode);
	              } else {
	                caretNode = clonedNode;
	                block.appendChild(clonedNode);
	              }
	            }
	          } while ((node = node.parentNode) && node !== editableRoot);
	        }
	        setForcedBlockAttrs(editor, block);
	        emptyBlock(caretNode);
	        return block;
	      };
	      var isCaretAtStartOrEndOfBlock = function (start) {
	        var node, name;
	        var normalizedOffset = normalizeZwspOffset(start, container, offset);
	        if (isText$1(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
	          return false;
	        }
	        if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
	          return true;
	        }
	        if (start && isElement$1(container) && container === parentBlock.firstChild) {
	          return true;
	        }
	        if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
	          return isAfterLastNodeInContainer && !start || !isAfterLastNodeInContainer && start;
	        }
	        var walker = new DomTreeWalker(container, parentBlock);
	        if (isText$1(container)) {
	          if (start && normalizedOffset === 0) {
	            walker.prev();
	          } else if (!start && normalizedOffset === container.nodeValue.length) {
	            walker.next();
	          }
	        }
	        while (node = walker.current()) {
	          if (isElement$1(node)) {
	            if (!node.getAttribute('data-mce-bogus')) {
	              name = node.nodeName.toLowerCase();
	              if (nonEmptyElementsMap[name] && name !== 'br') {
	                return false;
	              }
	            }
	          } else if (isText$1(node) && !isWhitespaceText(node.nodeValue)) {
	            return false;
	          }
	          if (start) {
	            walker.prev();
	          } else {
	            walker.next();
	          }
	        }
	        return true;
	      };
	      var insertNewBlockAfter = function () {
	        if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
	          newBlock = createNewBlock(newBlockName);
	        } else {
	          newBlock = createNewBlock();
	        }
	        if (shouldEndContainerOnEmptyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
	          newBlock = dom.split(containerBlock, parentBlock);
	        } else {
	          dom.insertAfter(newBlock, parentBlock);
	        }
	        moveToCaretPosition(editor, newBlock);
	      };
	      normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      newBlockName = getForcedRootBlock(editor);
	      var shiftKey = !!(evt && evt.shiftKey);
	      var ctrlKey = !!(evt && evt.ctrlKey);
	      if (isElement$1(container) && container.hasChildNodes()) {
	        isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && isText$1(container)) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      var editableRoot = getEditableRoot$1(dom, container);
	      if (!editableRoot) {
	        return;
	      }
	      if (newBlockName && !shiftKey || !newBlockName && shiftKey) {
	        container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
	      }
	      parentBlock = dom.getParent(container, dom.isBlock);
	      containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : '';
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      if (containerBlockName === 'LI' && !ctrlKey) {
	        parentBlock = containerBlock;
	        containerBlock = containerBlock.parentNode;
	        parentBlockName = containerBlockName;
	      }
	      if (/^(LI|DT|DD)$/.test(parentBlockName)) {
	        if (dom.isEmpty(parentBlock)) {
	          insert(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
	          return;
	        }
	      }
	      if (newBlockName && parentBlock === editor.getBody()) {
	        return;
	      }
	      newBlockName = newBlockName || 'P';
	      if (isCaretContainerBlock(parentBlock)) {
	        newBlock = showCaretContainerBlock(parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        setForcedBlockAttrs(editor, newBlock);
	        moveToCaretPosition(editor, newBlock);
	      } else if (isCaretAtStartOrEndOfBlock()) {
	        insertNewBlockAfter();
	      } else if (isCaretAtStartOrEndOfBlock(true)) {
	        newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
	        moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
	      } else {
	        tmpRng = includeZwspInRange(rng).cloneRange();
	        tmpRng.setEndAfter(parentBlock);
	        fragment = tmpRng.extractContents();
	        trimZwsp(fragment);
	        trimLeadingLineBreaks(fragment);
	        newBlock = fragment.firstChild;
	        dom.insertAfter(fragment, parentBlock);
	        trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
	        addBrToBlockIfNeeded(dom, parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        newBlock.normalize();
	        if (dom.isEmpty(newBlock)) {
	          dom.remove(newBlock);
	          insertNewBlockAfter();
	        } else {
	          setForcedBlockAttrs(editor, newBlock);
	          moveToCaretPosition(editor, newBlock);
	        }
	      }
	      dom.setAttrib(newBlock, 'id', '');
	      editor.fire('NewBlock', { newBlock: newBlock });
	    };
	
	    var hasRightSideContent = function (schema, container, parentBlock) {
	      var walker = new DomTreeWalker(container, parentBlock);
	      var node;
	      var nonEmptyElementsMap = schema.getNonEmptyElements();
	      while (node = walker.next()) {
	        if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
	          return true;
	        }
	      }
	    };
	    var moveSelectionToBr = function (editor, brElm, extraBr) {
	      var rng = editor.dom.createRng();
	      if (!extraBr) {
	        rng.setStartAfter(brElm);
	        rng.setEndAfter(brElm);
	      } else {
	        rng.setStartBefore(brElm);
	        rng.setEndBefore(brElm);
	      }
	      editor.selection.setRng(rng);
	      scrollRangeIntoView(editor, rng);
	    };
	    var insertBrAtCaret = function (editor, evt) {
	      var selection = editor.selection;
	      var dom = editor.dom;
	      var rng = selection.getRng();
	      var brElm;
	      var extraBr;
	      normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	      var offset = rng.startOffset;
	      var container = rng.startContainer;
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && container.nodeType === 3) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	      var parentBlock = dom.getParent(container, dom.isBlock);
	      var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : '';
	      var isControlKey = !!(evt && evt.ctrlKey);
	      if (containerBlockName === 'LI' && !isControlKey) {
	        parentBlock = containerBlock;
	      }
	      if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
	        if (!hasRightSideContent(editor.schema, container, parentBlock)) {
	          brElm = dom.create('br');
	          rng.insertNode(brElm);
	          rng.setStartAfter(brElm);
	          rng.setEndAfter(brElm);
	          extraBr = true;
	        }
	      }
	      brElm = dom.create('br');
	      rangeInsertNode(dom, rng, brElm);
	      moveSelectionToBr(editor, brElm, extraBr);
	      editor.undoManager.add();
	    };
	    var insertBrBefore = function (editor, inline) {
	      var br = SugarElement.fromTag('br');
	      before(SugarElement.fromDom(inline), br);
	      editor.undoManager.add();
	    };
	    var insertBrAfter = function (editor, inline) {
	      if (!hasBrAfter(editor.getBody(), inline)) {
	        after(SugarElement.fromDom(inline), SugarElement.fromTag('br'));
	      }
	      var br = SugarElement.fromTag('br');
	      after(SugarElement.fromDom(inline), br);
	      moveSelectionToBr(editor, br.dom, false);
	      editor.undoManager.add();
	    };
	    var isBeforeBr$1 = function (pos) {
	      return isBr(pos.getNode());
	    };
	    var hasBrAfter = function (rootNode, startNode) {
	      if (isBeforeBr$1(CaretPosition.after(startNode))) {
	        return true;
	      } else {
	        return nextPosition(rootNode, CaretPosition.after(startNode)).map(function (pos) {
	          return isBr(pos.getNode());
	        }).getOr(false);
	      }
	    };
	    var isAnchorLink = function (elm) {
	      return elm && elm.nodeName === 'A' && 'href' in elm;
	    };
	    var isInsideAnchor = function (location) {
	      return location.fold(never, isAnchorLink, isAnchorLink, never);
	    };
	    var readInlineAnchorLocation = function (editor) {
	      var isInlineTarget$1 = curry(isInlineTarget, editor);
	      var position = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return readLocation(isInlineTarget$1, editor.getBody(), position).filter(isInsideAnchor);
	    };
	    var insertBrOutsideAnchor = function (editor, location) {
	      location.fold(noop, curry(insertBrBefore, editor), curry(insertBrAfter, editor), noop);
	    };
	    var insert$2 = function (editor, evt) {
	      var anchorLocation = readInlineAnchorLocation(editor);
	      if (anchorLocation.isSome()) {
	        anchorLocation.each(curry(insertBrOutsideAnchor, editor));
	      } else {
	        insertBrAtCaret(editor, evt);
	      }
	    };
	
	    var matchesSelector = function (editor, selector) {
	      return getParentBlock$2(editor).filter(function (parentBlock) {
	        return selector.length > 0 && is$1(SugarElement.fromDom(parentBlock), selector);
	      }).isSome();
	    };
	    var shouldInsertBr = function (editor) {
	      return matchesSelector(editor, getBrNewLineSelector(editor));
	    };
	    var shouldBlockNewLine = function (editor) {
	      return matchesSelector(editor, getNoNewLineSelector(editor));
	    };
	
	    var newLineAction = Adt.generate([
	      { br: [] },
	      { block: [] },
	      { none: [] }
	    ]);
	    var shouldBlockNewLine$1 = function (editor, _shiftKey) {
	      return shouldBlockNewLine(editor);
	    };
	    var isBrMode = function (requiredState) {
	      return function (editor, _shiftKey) {
	        var brMode = getForcedRootBlock(editor) === '';
	        return brMode === requiredState;
	      };
	    };
	    var inListBlock = function (requiredState) {
	      return function (editor, _shiftKey) {
	        return isListItemParentBlock(editor) === requiredState;
	      };
	    };
	    var inBlock = function (blockName, requiredState) {
	      return function (editor, _shiftKey) {
	        var state = getParentBlockName(editor) === blockName.toUpperCase();
	        return state === requiredState;
	      };
	    };
	    var inPreBlock = function (requiredState) {
	      return inBlock('pre', requiredState);
	    };
	    var inSummaryBlock = function () {
	      return inBlock('summary', true);
	    };
	    var shouldPutBrInPre$1 = function (requiredState) {
	      return function (editor, _shiftKey) {
	        return shouldPutBrInPre(editor) === requiredState;
	      };
	    };
	    var inBrContext = function (editor, _shiftKey) {
	      return shouldInsertBr(editor);
	    };
	    var hasShiftKey = function (_editor, shiftKey) {
	      return shiftKey;
	    };
	    var canInsertIntoEditableRoot = function (editor) {
	      var forcedRootBlock = getForcedRootBlock(editor);
	      var rootEditable = getEditableRoot(editor.dom, editor.selection.getStart());
	      return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
	    };
	    var match$2 = function (predicates, action) {
	      return function (editor, shiftKey) {
	        var isMatch = foldl(predicates, function (res, p) {
	          return res && p(editor, shiftKey);
	        }, true);
	        return isMatch ? Optional.some(action) : Optional.none();
	      };
	    };
	    var getAction$1 = function (editor, evt) {
	      return evaluateUntil([
	        match$2([shouldBlockNewLine$1], newLineAction.none()),
	        match$2([inSummaryBlock()], newLineAction.br()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(false)
	        ], newLineAction.block()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(true),
	          hasShiftKey
	        ], newLineAction.block()),
	        match$2([
	          inPreBlock(true),
	          shouldPutBrInPre$1(true)
	        ], newLineAction.br()),
	        match$2([
	          inListBlock(true),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([inListBlock(true)], newLineAction.block()),
	        match$2([
	          isBrMode(true),
	          hasShiftKey,
	          canInsertIntoEditableRoot
	        ], newLineAction.block()),
	        match$2([isBrMode(true)], newLineAction.br()),
	        match$2([inBrContext], newLineAction.br()),
	        match$2([
	          isBrMode(false),
	          hasShiftKey
	        ], newLineAction.br()),
	        match$2([canInsertIntoEditableRoot], newLineAction.block())
	      ], [
	        editor,
	        !!(evt && evt.shiftKey)
	      ]).getOr(newLineAction.none());
	    };
	
	    var insert$3 = function (editor, evt) {
	      getAction$1(editor, evt).fold(function () {
	        insert$2(editor, evt);
	      }, function () {
	        insert$1(editor, evt);
	      }, noop);
	    };
	
	    var handleEnterKeyEvent = function (editor, event) {
	      if (event.isDefaultPrevented()) {
	        return;
	      }
	      event.preventDefault();
	      endTypingLevelIgnoreLocks(editor.undoManager);
	      editor.undoManager.transact(function () {
	        if (editor.selection.isCollapsed() === false) {
	          editor.execCommand('Delete');
	        }
	        insert$3(editor, event);
	      });
	    };
	    var setup$e = function (editor) {
	      editor.on('keydown', function (event) {
	        if (event.keyCode === VK.ENTER) {
	          handleEnterKeyEvent(editor, event);
	        }
	      });
	    };
	
	    var executeKeydownOverride$2 = function (editor, caret, evt) {
	      execute([
	        {
	          keyCode: VK.END,
	          action: action(moveToLineEndPoint$2, editor, true)
	        },
	        {
	          keyCode: VK.HOME,
	          action: action(moveToLineEndPoint$2, editor, false)
	        },
	        {
	          keyCode: VK.END,
	          action: action(moveToLineEndPoint$3, editor, true)
	        },
	        {
	          keyCode: VK.HOME,
	          action: action(moveToLineEndPoint$3, editor, false)
	        },
	        {
	          keyCode: VK.END,
	          action: action(moveToLineEndPoint$1, editor, true, caret)
	        },
	        {
	          keyCode: VK.HOME,
	          action: action(moveToLineEndPoint$1, editor, false, caret)
	        }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$f = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$2(editor, caret, evt);
	        }
	      });
	    };
	
	    var browser$4 = detect$3().browser;
	    var setupIeInput = function (editor) {
	      var keypressThrotter = first(function () {
	        if (!editor.composing) {
	          normalizeNbspsInEditor(editor);
	        }
	      }, 0);
	      if (browser$4.isIE()) {
	        editor.on('keypress', function (_e) {
	          keypressThrotter.throttle();
	        });
	        editor.on('remove', function (_e) {
	          keypressThrotter.cancel();
	        });
	      }
	    };
	    var setup$g = function (editor) {
	      setupIeInput(editor);
	      editor.on('input', function (e) {
	        if (e.isComposing === false) {
	          normalizeNbspsInEditor(editor);
	        }
	      });
	    };
	
	    var platform$2 = detect$3();
	    var executeKeyupAction = function (editor, caret, evt) {
	      execute([
	        {
	          keyCode: VK.PAGE_UP,
	          action: action(moveToLineEndPoint$1, editor, false, caret)
	        },
	        {
	          keyCode: VK.PAGE_DOWN,
	          action: action(moveToLineEndPoint$1, editor, true, caret)
	        }
	      ], evt);
	    };
	    var stopImmediatePropagation = function (e) {
	      return e.stopImmediatePropagation();
	    };
	    var isPageUpDown = function (evt) {
	      return evt.keyCode === VK.PAGE_UP || evt.keyCode === VK.PAGE_DOWN;
	    };
	    var setNodeChangeBlocker = function (blocked, editor, block) {
	      if (block && !blocked.get()) {
	        editor.on('NodeChange', stopImmediatePropagation, true);
	      } else if (!block && blocked.get()) {
	        editor.off('NodeChange', stopImmediatePropagation);
	      }
	      blocked.set(block);
	    };
	    var setup$h = function (editor, caret) {
	      if (platform$2.os.isOSX()) {
	        return;
	      }
	      var blocked = Cell(false);
	      editor.on('keydown', function (evt) {
	        if (isPageUpDown(evt)) {
	          setNodeChangeBlocker(blocked, editor, true);
	        }
	      });
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupAction(editor, caret, evt);
	        }
	        if (isPageUpDown(evt) && blocked.get()) {
	          setNodeChangeBlocker(blocked, editor, false);
	          editor.nodeChanged();
	        }
	      });
	    };
	
	    var insertTextAtPosition = function (text, pos) {
	      var container = pos.container();
	      var offset = pos.offset();
	      if (isText$1(container)) {
	        container.insertData(offset, text);
	        return Optional.some(CaretPosition(container, offset + text.length));
	      } else {
	        return getElementFromPosition(pos).map(function (elm) {
	          var textNode = SugarElement.fromText(text);
	          if (pos.isAtEnd()) {
	            after(elm, textNode);
	          } else {
	            before(elm, textNode);
	          }
	          return CaretPosition(textNode.dom, text.length);
	        });
	      }
	    };
	    var insertNbspAtPosition = curry(insertTextAtPosition, nbsp);
	    var insertSpaceAtPosition = curry(insertTextAtPosition, ' ');
	
	    var locationToCaretPosition = function (root) {
	      return function (location) {
	        return location.fold(function (element) {
	          return prevPosition(root.dom, CaretPosition.before(element));
	        }, function (element) {
	          return firstPositionIn(element);
	        }, function (element) {
	          return lastPositionIn(element);
	        }, function (element) {
	          return nextPosition(root.dom, CaretPosition.after(element));
	        });
	      };
	    };
	    var insertInlineBoundarySpaceOrNbsp = function (root, pos) {
	      return function (checkPos) {
	        return needsToHaveNbsp(root, checkPos) ? insertNbspAtPosition(pos) : insertSpaceAtPosition(pos);
	      };
	    };
	    var setSelection$1 = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        editor.nodeChanged();
	        return true;
	      };
	    };
	    var insertSpaceOrNbspAtSelection = function (editor) {
	      var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var root = SugarElement.fromDom(editor.getBody());
	      if (editor.selection.isCollapsed()) {
	        var isInlineTarget$1 = curry(isInlineTarget, editor);
	        var caretPosition = CaretPosition.fromRangeStart(editor.selection.getRng());
	        return readLocation(isInlineTarget$1, editor.getBody(), caretPosition).bind(locationToCaretPosition(root)).bind(insertInlineBoundarySpaceOrNbsp(root, pos)).exists(setSelection$1(editor));
	      } else {
	        return false;
	      }
	    };
	
	    var executeKeydownOverride$3 = function (editor, evt) {
	      execute([{
	          keyCode: VK.SPACEBAR,
	          action: action(insertSpaceOrNbspAtSelection, editor)
	        }], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	    var setup$i = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride$3(editor, evt);
	        }
	      });
	    };
	
	    var registerKeyboardOverrides = function (editor) {
	      var caret = setupSelectedState(editor);
	      setup$b(editor);
	      setup$c(editor, caret);
	      setup$d(editor, caret);
	      setup$e(editor);
	      setup$i(editor);
	      setup$g(editor);
	      setup$f(editor, caret);
	      setup$h(editor, caret);
	      return caret;
	    };
	    var setup$j = function (editor) {
	      if (!isRtc(editor)) {
	        return registerKeyboardOverrides(editor);
	      } else {
	        return Cell(null);
	      }
	    };
	
	    var NodeChange = function () {
	      function NodeChange(editor) {
	        this.lastPath = [];
	        this.editor = editor;
	        var lastRng;
	        var self = this;
	        if (!('onselectionchange' in editor.getDoc())) {
	          editor.on('NodeChange click mouseup keyup focus', function (e) {
	            var nativeRng = editor.selection.getRng();
	            var fakeRng = {
	              startContainer: nativeRng.startContainer,
	              startOffset: nativeRng.startOffset,
	              endContainer: nativeRng.endContainer,
	              endOffset: nativeRng.endOffset
	            };
	            if (e.type === 'nodechange' || !isEq$1(fakeRng, lastRng)) {
	              editor.fire('SelectionChange');
	            }
	            lastRng = fakeRng;
	          });
	        }
	        editor.on('contextmenu', function () {
	          editor.fire('SelectionChange');
	        });
	        editor.on('SelectionChange', function () {
	          var startElm = editor.selection.getStart(true);
	          if (!startElm || !Env.range && editor.selection.isCollapsed()) {
	            return;
	          }
	          if (hasAnyRanges(editor) && !self.isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
	            editor.nodeChanged({ selectionChange: true });
	          }
	        });
	        editor.on('mouseup', function (e) {
	          if (!e.isDefaultPrevented() && hasAnyRanges(editor)) {
	            if (editor.selection.getNode().nodeName === 'IMG') {
	              Delay.setEditorTimeout(editor, function () {
	                editor.nodeChanged();
	              });
	            } else {
	              editor.nodeChanged();
	            }
	          }
	        });
	      }
	      NodeChange.prototype.nodeChanged = function (args) {
	        var selection = this.editor.selection;
	        var node, parents, root;
	        if (this.editor.initialized && selection && !shouldDisableNodeChange(this.editor) && !this.editor.mode.isReadOnly()) {
	          root = this.editor.getBody();
	          node = selection.getStart(true) || root;
	          if (node.ownerDocument !== this.editor.getDoc() || !this.editor.dom.isChildOf(node, root)) {
	            node = root;
	          }
	          parents = [];
	          this.editor.dom.getParent(node, function (node) {
	            if (node === root) {
	              return true;
	            }
	            parents.push(node);
	          });
	          args = args || {};
	          args.element = node;
	          args.parents = parents;
	          this.editor.fire('NodeChange', args);
	        }
	      };
	      NodeChange.prototype.isSameElementPath = function (startElm) {
	        var i;
	        var currentPath = this.editor.$(startElm).parentsUntil(this.editor.getBody()).add(startElm);
	        if (currentPath.length === this.lastPath.length) {
	          for (i = currentPath.length; i >= 0; i--) {
	            if (currentPath[i] !== this.lastPath[i]) {
	              break;
	            }
	          }
	          if (i === -1) {
	            this.lastPath = currentPath;
	            return true;
	          }
	        }
	        this.lastPath = currentPath;
	        return false;
	      };
	      return NodeChange;
	    }();
	
	    var preventSummaryToggle = function (editor) {
	      editor.on('click', function (e) {
	        if (editor.dom.getParent(e.target, 'details')) {
	          e.preventDefault();
	        }
	      });
	    };
	    var filterDetails = function (editor) {
	      editor.parser.addNodeFilter('details', function (elms) {
	        each(elms, function (details) {
	          details.attr('data-mce-open', details.attr('open'));
	          details.attr('open', 'open');
	        });
	      });
	      editor.serializer.addNodeFilter('details', function (elms) {
	        each(elms, function (details) {
	          var open = details.attr('data-mce-open');
	          details.attr('open', isString(open) ? open : null);
	          details.attr('data-mce-open', null);
	        });
	      });
	    };
	    var setup$k = function (editor) {
	      preventSummaryToggle(editor);
	      filterDetails(editor);
	    };
	
	    var isTextBlockNode = function (node) {
	      return isElement$1(node) && isTextBlock(SugarElement.fromDom(node));
	    };
	    var normalizeSelection$1 = function (editor) {
	      var rng = editor.selection.getRng();
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      if (CaretPosition.isElementPosition(startPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          firstPositionIn(container).each(function (pos) {
	            return rng.setStart(pos.container(), pos.offset());
	          });
	        }
	      }
	      if (CaretPosition.isElementPosition(endPos)) {
	        var container = startPos.container();
	        if (isTextBlockNode(container)) {
	          lastPositionIn(container).each(function (pos) {
	            return rng.setEnd(pos.container(), pos.offset());
	          });
	        }
	      }
	      editor.selection.setRng(normalize$2(rng));
	    };
	    var setup$l = function (editor) {
	      editor.on('click', function (e) {
	        if (e.detail >= 3) {
	          normalizeSelection$1(editor);
	        }
	      });
	    };
	
	    var value$1 = function () {
	      var subject = Cell(Optional.none());
	      var clear = function () {
	        return subject.set(Optional.none());
	      };
	      var set = function (s) {
	        return subject.set(Optional.some(s));
	      };
	      var isSet = function () {
	        return subject.get().isSome();
	      };
	      var on = function (f) {
	        return subject.get().each(f);
	      };
	      return {
	        clear: clear,
	        set: set,
	        isSet: isSet,
	        on: on
	      };
	    };
	
	    var getAbsolutePosition = function (elm) {
	      var clientRect = elm.getBoundingClientRect();
	      var doc = elm.ownerDocument;
	      var docElem = doc.documentElement;
	      var win = doc.defaultView;
	      return {
	        top: clientRect.top + win.pageYOffset - docElem.clientTop,
	        left: clientRect.left + win.pageXOffset - docElem.clientLeft
	      };
	    };
	    var getBodyPosition = function (editor) {
	      return editor.inline ? getAbsolutePosition(editor.getBody()) : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getScrollPosition = function (editor) {
	      var body = editor.getBody();
	      return editor.inline ? {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      } : {
	        left: 0,
	        top: 0
	      };
	    };
	    var getBodyScroll = function (editor) {
	      var body = editor.getBody(), docElm = editor.getDoc().documentElement;
	      var inlineScroll = {
	        left: body.scrollLeft,
	        top: body.scrollTop
	      };
	      var iframeScroll = {
	        left: body.scrollLeft || docElm.scrollLeft,
	        top: body.scrollTop || docElm.scrollTop
	      };
	      return editor.inline ? inlineScroll : iframeScroll;
	    };
	    var getMousePosition = function (editor, event) {
	      if (event.target.ownerDocument !== editor.getDoc()) {
	        var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
	        var scrollPosition = getBodyScroll(editor);
	        return {
	          left: event.pageX - iframePosition.left + scrollPosition.left,
	          top: event.pageY - iframePosition.top + scrollPosition.top
	        };
	      }
	      return {
	        left: event.pageX,
	        top: event.pageY
	      };
	    };
	    var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
	      return {
	        pageX: mousePosition.left - bodyPosition.left + scrollPosition.left,
	        pageY: mousePosition.top - bodyPosition.top + scrollPosition.top
	      };
	    };
	    var calc = function (editor, event) {
	      return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
	    };
	
	    var isContentEditableFalse$a = isContentEditableFalse, isContentEditableTrue$3 = isContentEditableTrue;
	    var isDraggable = function (rootElm, elm) {
	      return isContentEditableFalse$a(elm) && elm !== rootElm;
	    };
	    var isValidDropTarget = function (editor, targetElement, dragElement) {
	      if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
	        return false;
	      }
	      return !isContentEditableFalse$a(targetElement);
	    };
	    var cloneElement = function (elm) {
	      var cloneElm = elm.cloneNode(true);
	      cloneElm.removeAttribute('data-mce-selected');
	      return cloneElm;
	    };
	    var createGhost = function (editor, elm, width, height) {
	      var dom = editor.dom;
	      var clonedElm = elm.cloneNode(true);
	      dom.setStyles(clonedElm, {
	        width: width,
	        height: height
	      });
	      dom.setAttrib(clonedElm, 'data-mce-selected', null);
	      var ghostElm = dom.create('div', {
	        'class': 'mce-drag-container',
	        'data-mce-bogus': 'all',
	        'unselectable': 'on',
	        'contenteditable': 'false'
	      });
	      dom.setStyles(ghostElm, {
	        position: 'absolute',
	        opacity: 0.5,
	        overflow: 'hidden',
	        border: 0,
	        padding: 0,
	        margin: 0,
	        width: width,
	        height: height
	      });
	      dom.setStyles(clonedElm, {
	        margin: 0,
	        boxSizing: 'border-box'
	      });
	      ghostElm.appendChild(clonedElm);
	      return ghostElm;
	    };
	    var appendGhostToBody = function (ghostElm, bodyElm) {
	      if (ghostElm.parentNode !== bodyElm) {
	        bodyElm.appendChild(ghostElm);
	      }
	    };
	    var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
	      var overflowX = 0, overflowY = 0;
	      ghostElm.style.left = position.pageX + 'px';
	      ghostElm.style.top = position.pageY + 'px';
	      if (position.pageX + width > maxX) {
	        overflowX = position.pageX + width - maxX;
	      }
	      if (position.pageY + height > maxY) {
	        overflowY = position.pageY + height - maxY;
	      }
	      ghostElm.style.width = width - overflowX + 'px';
	      ghostElm.style.height = height - overflowY + 'px';
	    };
	    var removeElement = function (elm) {
	      if (elm && elm.parentNode) {
	        elm.parentNode.removeChild(elm);
	      }
	    };
	    var isLeftMouseButtonPressed = function (e) {
	      return e.button === 0;
	    };
	    var applyRelPos = function (state, position) {
	      return {
	        pageX: position.pageX - state.relX,
	        pageY: position.pageY + 5
	      };
	    };
	    var start$1 = function (state, editor) {
	      return function (e) {
	        if (isLeftMouseButtonPressed(e)) {
	          var ceElm = find(editor.dom.getParents(e.target), or(isContentEditableFalse$a, isContentEditableTrue$3)).getOr(null);
	          if (isDraggable(editor.getBody(), ceElm)) {
	            var elmPos = editor.dom.getPos(ceElm);
	            var bodyElm = editor.getBody();
	            var docElm = editor.getDoc().documentElement;
	            state.set({
	              element: ceElm,
	              dragging: false,
	              screenX: e.screenX,
	              screenY: e.screenY,
	              maxX: (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2,
	              maxY: (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2,
	              relX: e.pageX - elmPos.x,
	              relY: e.pageY - elmPos.y,
	              width: ceElm.offsetWidth,
	              height: ceElm.offsetHeight,
	              ghost: createGhost(editor, ceElm, ceElm.offsetWidth, ceElm.offsetHeight)
	            });
	          }
	        }
	      };
	    };
	    var move$2 = function (state, editor) {
	      var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
	        editor._selectionOverrides.hideFakeCaret();
	        editor.selection.placeCaretAt(clientX, clientY);
	      }, 0);
	      editor.on('remove', throttledPlaceCaretAt.stop);
	      return function (e) {
	        return state.on(function (state) {
	          var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
	          if (!state.dragging && movement > 10) {
	            var args = editor.fire('dragstart', { target: state.element });
	            if (args.isDefaultPrevented()) {
	              return;
	            }
	            state.dragging = true;
	            editor.focus();
	          }
	          if (state.dragging) {
	            var targetPos = applyRelPos(state, calc(editor, e));
	            appendGhostToBody(state.ghost, editor.getBody());
	            moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
	            throttledPlaceCaretAt(e.clientX, e.clientY);
	          }
	        });
	      };
	    };
	    var getRawTarget = function (selection) {
	      var rng = selection.getSel().getRangeAt(0);
	      var startContainer = rng.startContainer;
	      return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
	    };
	    var drop = function (state, editor) {
	      return function (e) {
	        state.on(function (state) {
	          if (state.dragging) {
	            if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
	              var targetClone_1 = cloneElement(state.element);
	              var args = editor.fire('drop', {
	                clientX: e.clientX,
	                clientY: e.clientY
	              });
	              if (!args.isDefaultPrevented()) {
	                editor.undoManager.transact(function () {
	                  removeElement(state.element);
	                  editor.insertContent(editor.dom.getOuterHTML(targetClone_1));
	                  editor._selectionOverrides.hideFakeCaret();
	                });
	              }
	            }
	          }
	        });
	        removeDragState(state);
	      };
	    };
	    var stop = function (state, editor) {
	      return function () {
	        state.on(function (state) {
	          if (state.dragging) {
	            editor.fire('dragend');
	          }
	        });
	        removeDragState(state);
	      };
	    };
	    var removeDragState = function (state) {
	      state.on(function (state) {
	        removeElement(state.ghost);
	      });
	      state.clear();
	    };
	    var bindFakeDragEvents = function (editor) {
	      var state = value$1();
	      var pageDom = DOMUtils.DOM;
	      var rootDocument = document;
	      var dragStartHandler = start$1(state, editor);
	      var dragHandler = move$2(state, editor);
	      var dropHandler = drop(state, editor);
	      var dragEndHandler = stop(state, editor);
	      editor.on('mousedown', dragStartHandler);
	      editor.on('mousemove', dragHandler);
	      editor.on('mouseup', dropHandler);
	      pageDom.bind(rootDocument, 'mousemove', dragHandler);
	      pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
	      editor.on('remove', function () {
	        pageDom.unbind(rootDocument, 'mousemove', dragHandler);
	        pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
	      });
	    };
	    var blockIeDrop = function (editor) {
	      editor.on('drop', function (e) {
	        var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
	        if (isContentEditableFalse$a(realTarget) || editor.dom.getContentEditableParent(realTarget) === 'false') {
	          e.preventDefault();
	        }
	      });
	    };
	    var blockUnsupportedFileDrop = function (editor) {
	      var preventFileDrop = function (e) {
	        if (!e.isDefaultPrevented()) {
	          var dataTransfer = e.dataTransfer;
	          if (dataTransfer && (contains(dataTransfer.types, 'Files') || dataTransfer.files.length > 0)) {
	            e.preventDefault();
	            if (e.type === 'drop') {
	              displayError(editor, 'Dropped file type is not supported');
	            }
	          }
	        }
	      };
	      var preventFileDropIfUIElement = function (e) {
	        if (isUIElement(editor, e.target)) {
	          preventFileDrop(e);
	        }
	      };
	      var setup = function () {
	        var pageDom = DOMUtils.DOM;
	        var dom = editor.dom;
	        var doc = document;
	        var editorRoot = editor.inline ? editor.getBody() : editor.getDoc();
	        var eventNames = [
	          'drop',
	          'dragover'
	        ];
	        each(eventNames, function (name) {
	          pageDom.bind(doc, name, preventFileDropIfUIElement);
	          dom.bind(editorRoot, name, preventFileDrop);
	        });
	        editor.on('remove', function () {
	          each(eventNames, function (name) {
	            pageDom.unbind(doc, name, preventFileDropIfUIElement);
	            dom.unbind(editorRoot, name, preventFileDrop);
	          });
	        });
	      };
	      editor.on('init', function () {
	        Delay.setEditorTimeout(editor, setup, 0);
	      });
	    };
	    var init = function (editor) {
	      bindFakeDragEvents(editor);
	      blockIeDrop(editor);
	      if (shouldBlockUnsupportedDrop(editor)) {
	        blockUnsupportedFileDrop(editor);
	      }
	    };
	
	    var setup$m = function (editor) {
	      var renderFocusCaret = first(function () {
	        if (!editor.removed && editor.getBody().contains(document.activeElement)) {
	          var rng = editor.selection.getRng();
	          if (rng.collapsed) {
	            var caretRange = renderRangeCaret(editor, rng, false);
	            editor.selection.setRng(caretRange);
	          }
	        }
	      }, 0);
	      editor.on('focus', function () {
	        renderFocusCaret.throttle();
	      });
	      editor.on('blur', function () {
	        renderFocusCaret.cancel();
	      });
	    };
	
	    var setup$n = function (editor) {
	      editor.on('init', function () {
	        editor.on('focusin', function (e) {
	          var target = e.target;
	          if (isMedia(target)) {
	            var ceRoot = getContentEditableRoot(editor.getBody(), target);
	            var node = isContentEditableFalse(ceRoot) ? ceRoot : target;
	            if (editor.selection.getNode() !== node) {
	              selectNode(editor, node).each(function (rng) {
	                return editor.selection.setRng(rng);
	              });
	            }
	          }
	        });
	      });
	    };
	
	    var isContentEditableTrue$4 = isContentEditableTrue;
	    var isContentEditableFalse$b = isContentEditableFalse;
	    var getContentEditableRoot$1 = function (editor, node) {
	      return getContentEditableRoot(editor.getBody(), node);
	    };
	    var SelectionOverrides = function (editor) {
	      var selection = editor.selection, dom = editor.dom;
	      var isBlock = dom.isBlock;
	      var rootNode = editor.getBody();
	      var fakeCaret = FakeCaret(editor, rootNode, isBlock, function () {
	        return hasFocus$1(editor);
	      });
	      var realSelectionId = 'sel-' + dom.uniqueId();
	      var elementSelectionAttr = 'data-mce-selected';
	      var selectedElement;
	      var isFakeSelectionElement = function (node) {
	        return dom.hasClass(node, 'mce-offscreen-selection');
	      };
	      var isFakeSelectionTargetElement = function (node) {
	        return node !== rootNode && (isContentEditableFalse$b(node) || isMedia(node)) && dom.isChildOf(node, rootNode);
	      };
	      var isNearFakeSelectionElement = function (pos) {
	        return isBeforeContentEditableFalse(pos) || isAfterContentEditableFalse(pos) || isBeforeMedia(pos) || isAfterMedia(pos);
	      };
	      var getRealSelectionElement = function () {
	        var container = dom.get(realSelectionId);
	        return container ? container.getElementsByTagName('*')[0] : container;
	      };
	      var setRange = function (range) {
	        if (range) {
	          selection.setRng(range);
	        }
	      };
	      var getRange = selection.getRng;
	      var showCaret = function (direction, node, before, scrollIntoView) {
	        if (scrollIntoView === void 0) {
	          scrollIntoView = true;
	        }
	        var e = editor.fire('ShowCaret', {
	          target: node,
	          direction: direction,
	          before: before
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        if (scrollIntoView) {
	          selection.scrollIntoView(node, direction === -1);
	        }
	        return fakeCaret.show(before, node);
	      };
	      var showBlockCaretContainer = function (blockCaretContainer) {
	        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	          showCaretContainerBlock(blockCaretContainer);
	          setRange(getRange());
	          selection.scrollIntoView(blockCaretContainer);
	        }
	      };
	      var registerEvents = function () {
	        editor.on('mouseup', function (e) {
	          var range = getRange();
	          if (range.collapsed && isXYInContentArea(editor, e.clientX, e.clientY)) {
	            renderCaretAtRange(editor, range, false).each(setRange);
	          }
	        });
	        editor.on('click', function (e) {
	          var contentEditableRoot = getContentEditableRoot$1(editor, e.target);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse$b(contentEditableRoot)) {
	              e.preventDefault();
	              editor.focus();
	            }
	            if (isContentEditableTrue$4(contentEditableRoot)) {
	              if (dom.isChildOf(contentEditableRoot, selection.getNode())) {
	                removeElementSelection();
	              }
	            }
	          }
	        });
	        editor.on('blur NewBlock', removeElementSelection);
	        editor.on('ResizeWindow FullscreenStateChanged', fakeCaret.reposition);
	        var hasNormalCaretPosition = function (elm) {
	          var caretWalker = CaretWalker(elm);
	          if (!elm.firstChild) {
	            return false;
	          }
	          var startPos = CaretPosition.before(elm.firstChild);
	          var newPos = caretWalker.next(startPos);
	          return newPos && !isNearFakeSelectionElement(newPos);
	        };
	        var isInSameBlock = function (node1, node2) {
	          var block1 = dom.getParent(node1, isBlock);
	          var block2 = dom.getParent(node2, isBlock);
	          return block1 === block2;
	        };
	        var hasBetterMouseTarget = function (targetNode, caretNode) {
	          var targetBlock = dom.getParent(targetNode, isBlock);
	          var caretBlock = dom.getParent(caretNode, isBlock);
	          if (targetBlock && targetNode !== caretBlock && dom.isChildOf(targetBlock, caretBlock) && isContentEditableFalse$b(getContentEditableRoot$1(editor, targetBlock)) === false) {
	            return true;
	          }
	          return targetBlock && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
	        };
	        editor.on('tap', function (e) {
	          var targetElm = e.target;
	          var contentEditableRoot = getContentEditableRoot$1(editor, targetElm);
	          if (isContentEditableFalse$b(contentEditableRoot)) {
	            e.preventDefault();
	            selectNode(editor, contentEditableRoot).each(setElementSelection);
	          } else if (isFakeSelectionTargetElement(targetElm)) {
	            selectNode(editor, targetElm).each(setElementSelection);
	          }
	        }, true);
	        editor.on('mousedown', function (e) {
	          var targetElm = e.target;
	          if (targetElm !== rootNode && targetElm.nodeName !== 'HTML' && !dom.isChildOf(targetElm, rootNode)) {
	            return;
	          }
	          if (isXYInContentArea(editor, e.clientX, e.clientY) === false) {
	            return;
	          }
	          var contentEditableRoot = getContentEditableRoot$1(editor, targetElm);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse$b(contentEditableRoot)) {
	              e.preventDefault();
	              selectNode(editor, contentEditableRoot).each(setElementSelection);
	            } else {
	              removeElementSelection();
	              if (!(isContentEditableTrue$4(contentEditableRoot) && e.shiftKey) && !isXYWithinRange(e.clientX, e.clientY, selection.getRng())) {
	                hideFakeCaret();
	                selection.placeCaretAt(e.clientX, e.clientY);
	              }
	            }
	          } else if (isFakeSelectionTargetElement(targetElm)) {
	            selectNode(editor, targetElm).each(setElementSelection);
	          } else if (isFakeCaretTarget(targetElm) === false) {
	            removeElementSelection();
	            hideFakeCaret();
	            var fakeCaretInfo = closestFakeCaret(rootNode, e.clientX, e.clientY);
	            if (fakeCaretInfo) {
	              if (!hasBetterMouseTarget(targetElm, fakeCaretInfo.node)) {
	                e.preventDefault();
	                var range = showCaret(1, fakeCaretInfo.node, fakeCaretInfo.before, false);
	                editor.getBody().focus();
	                setRange(range);
	              }
	            }
	          }
	        });
	        editor.on('keypress', function (e) {
	          if (VK.modifierPressed(e)) {
	            return;
	          }
	          if (isContentEditableFalse$b(selection.getNode())) {
	            e.preventDefault();
	          }
	        });
	        editor.on('GetSelectionRange', function (e) {
	          var rng = e.range;
	          if (selectedElement) {
	            if (!selectedElement.parentNode) {
	              selectedElement = null;
	              return;
	            }
	            rng = rng.cloneRange();
	            rng.selectNode(selectedElement);
	            e.range = rng;
	          }
	        });
	        editor.on('SetSelectionRange', function (e) {
	          e.range = normalizeShortEndedElementSelection(e.range);
	          var rng = setElementSelection(e.range, e.forward);
	          if (rng) {
	            e.range = rng;
	          }
	        });
	        var isPasteBin = function (node) {
	          return node.id === 'mcepastebin';
	        };
	        editor.on('AfterSetSelectionRange', function (e) {
	          var rng = e.range;
	          var parentNode = rng.startContainer.parentNode;
	          if (!isRangeInCaretContainer(rng) && !isPasteBin(parentNode)) {
	            hideFakeCaret();
	          }
	          if (!isFakeSelectionElement(parentNode)) {
	            removeElementSelection();
	          }
	        });
	        editor.on('copy', function (e) {
	          var clipboardData = e.clipboardData;
	          if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
	            var realSelectionElement = getRealSelectionElement();
	            if (realSelectionElement) {
	              e.preventDefault();
	              clipboardData.clearData();
	              clipboardData.setData('text/html', realSelectionElement.outerHTML);
	              clipboardData.setData('text/plain', realSelectionElement.outerText || realSelectionElement.innerText);
	            }
	          }
	        });
	        init(editor);
	        setup$m(editor);
	        setup$n(editor);
	      };
	      var isWithinCaretContainer = function (node) {
	        return isCaretContainer(node) || startsWithCaretContainer(node) || endsWithCaretContainer(node);
	      };
	      var isRangeInCaretContainer = function (rng) {
	        return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
	      };
	      var normalizeShortEndedElementSelection = function (rng) {
	        var shortEndedElements = editor.schema.getShortEndedElements();
	        var newRng = dom.createRng();
	        var startContainer = rng.startContainer;
	        var startOffset = rng.startOffset;
	        var endContainer = rng.endContainer;
	        var endOffset = rng.endOffset;
	        if (has(shortEndedElements, startContainer.nodeName.toLowerCase())) {
	          if (startOffset === 0) {
	            newRng.setStartBefore(startContainer);
	          } else {
	            newRng.setStartAfter(startContainer);
	          }
	        } else {
	          newRng.setStart(startContainer, startOffset);
	        }
	        if (has(shortEndedElements, endContainer.nodeName.toLowerCase())) {
	          if (endOffset === 0) {
	            newRng.setEndBefore(endContainer);
	          } else {
	            newRng.setEndAfter(endContainer);
	          }
	        } else {
	          newRng.setEnd(endContainer, endOffset);
	        }
	        return newRng;
	      };
	      var setupOffscreenSelection = function (node, targetClone, origTargetClone) {
	        var $ = editor.$;
	        var $realSelectionContainer = descendant(SugarElement.fromDom(editor.getBody()), '#' + realSelectionId).fold(function () {
	          return $([]);
	        }, function (elm) {
	          return $([elm.dom]);
	        });
	        if ($realSelectionContainer.length === 0) {
	          $realSelectionContainer = $('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr('id', realSelectionId);
	          $realSelectionContainer.appendTo(editor.getBody());
	        }
	        var newRange = dom.createRng();
	        if (targetClone === origTargetClone && Env.ie) {
	          $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(targetClone);
	          newRange.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
	          newRange.setEndAfter(targetClone);
	        } else {
	          $realSelectionContainer.empty().append(nbsp).append(targetClone).append(nbsp);
	          newRange.setStart($realSelectionContainer[0].firstChild, 1);
	          newRange.setEnd($realSelectionContainer[0].lastChild, 0);
	        }
	        $realSelectionContainer.css({ top: dom.getPos(node, editor.getBody()).y });
	        $realSelectionContainer[0].focus();
	        var sel = selection.getSel();
	        sel.removeAllRanges();
	        sel.addRange(newRange);
	        return newRange;
	      };
	      var selectElement = function (elm) {
	        var targetClone = elm.cloneNode(true);
	        var e = editor.fire('ObjectSelected', {
	          target: elm,
	          targetClone: targetClone
	        });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	        var range = setupOffscreenSelection(elm, e.targetClone, targetClone);
	        var nodeElm = SugarElement.fromDom(elm);
	        each(descendants$1(SugarElement.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
	          if (!eq$2(nodeElm, elm)) {
	            remove$1(elm, elementSelectionAttr);
	          }
	        });
	        if (!dom.getAttrib(elm, elementSelectionAttr)) {
	          elm.setAttribute(elementSelectionAttr, '1');
	        }
	        selectedElement = elm;
	        hideFakeCaret();
	        return range;
	      };
	      var setElementSelection = function (range, forward) {
	        if (!range) {
	          return null;
	        }
	        if (range.collapsed) {
	          if (!isRangeInCaretContainer(range)) {
	            var dir = forward ? 1 : -1;
	            var caretPosition = getNormalizedRangeEndPoint(dir, rootNode, range);
	            var beforeNode = caretPosition.getNode(!forward);
	            if (isFakeCaretTarget(beforeNode)) {
	              return showCaret(dir, beforeNode, forward ? !caretPosition.isAtEnd() : false, false);
	            }
	            var afterNode = caretPosition.getNode(forward);
	            if (isFakeCaretTarget(afterNode)) {
	              return showCaret(dir, afterNode, forward ? false : !caretPosition.isAtEnd(), false);
	            }
	          }
	          return null;
	        }
	        var startContainer = range.startContainer;
	        var startOffset = range.startOffset;
	        var endOffset = range.endOffset;
	        if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse$b(startContainer.parentNode)) {
	          startContainer = startContainer.parentNode;
	          startOffset = dom.nodeIndex(startContainer);
	          startContainer = startContainer.parentNode;
	        }
	        if (startContainer.nodeType !== 1) {
	          return null;
	        }
	        if (endOffset === startOffset + 1 && startContainer === range.endContainer) {
	          var node = startContainer.childNodes[startOffset];
	          if (isFakeSelectionTargetElement(node)) {
	            return selectElement(node);
	          }
	        }
	        return null;
	      };
	      var removeElementSelection = function () {
	        if (selectedElement) {
	          selectedElement.removeAttribute(elementSelectionAttr);
	        }
	        descendant(SugarElement.fromDom(editor.getBody()), '#' + realSelectionId).each(remove);
	        selectedElement = null;
	      };
	      var destroy = function () {
	        fakeCaret.destroy();
	        selectedElement = null;
	      };
	      var hideFakeCaret = function () {
	        fakeCaret.hide();
	      };
	      if (Env.ceFalse && !isRtc(editor)) {
	        registerEvents();
	      }
	      return {
	        showCaret: showCaret,
	        showBlockCaretContainer: showBlockCaretContainer,
	        hideFakeCaret: hideFakeCaret,
	        destroy: destroy
	      };
	    };
	
	    var Quirks = function (editor) {
	      var each = Tools.each;
	      var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection, parser = editor.parser;
	      var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      var mceInternalDataType = isIE ? 'Text' : 'URL';
	      var setEditorCommandState = function (cmd, state) {
	        try {
	          editor.getDoc().execCommand(cmd, false, state);
	        } catch (ex) {
	        }
	      };
	      var isDefaultPrevented = function (e) {
	        return e.isDefaultPrevented();
	      };
	      var setMceInternalContent = function (e) {
	        var selectionHtml, internalContent;
	        if (e.dataTransfer) {
	          if (editor.selection.isCollapsed() && e.target.tagName === 'IMG') {
	            selection.select(e.target);
	          }
	          selectionHtml = editor.selection.getContent();
	          if (selectionHtml.length > 0) {
	            internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
	            e.dataTransfer.setData(mceInternalDataType, internalContent);
	          }
	        }
	      };
	      var getMceInternalContent = function (e) {
	        var internalContent;
	        if (e.dataTransfer) {
	          internalContent = e.dataTransfer.getData(mceInternalDataType);
	          if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
	            internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
	            return {
	              id: unescape(internalContent[0]),
	              html: unescape(internalContent[1])
	            };
	          }
	        }
	        return null;
	      };
	      var insertClipboardContents = function (content, internal) {
	        if (editor.queryCommandSupported('mceInsertClipboardContent')) {
	          editor.execCommand('mceInsertClipboardContent', false, {
	            content: content,
	            internal: internal
	          });
	        } else {
	          editor.execCommand('mceInsertContent', false, content);
	        }
	      };
	      var emptyEditorWhenDeleting = function () {
	        var serializeRng = function (rng) {
	          var body = dom.create('body');
	          var contents = rng.cloneContents();
	          body.appendChild(contents);
	          return selection.serializer.serialize(body, { format: 'html' });
	        };
	        var allContentsSelected = function (rng) {
	          var selection = serializeRng(rng);
	          var allRng = dom.createRng();
	          allRng.selectNode(editor.getBody());
	          var allSelection = serializeRng(allRng);
	          return selection === allSelection;
	        };
	        editor.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	          var isCollapsed, body;
	          if (!isDefaultPrevented(e) && (keyCode === DELETE || keyCode === BACKSPACE)) {
	            isCollapsed = editor.selection.isCollapsed();
	            body = editor.getBody();
	            if (isCollapsed && !dom.isEmpty(body)) {
	              return;
	            }
	            if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
	              return;
	            }
	            e.preventDefault();
	            editor.setContent('');
	            if (body.firstChild && dom.isBlock(body.firstChild)) {
	              editor.selection.setCursorLocation(body.firstChild, 0);
	            } else {
	              editor.selection.setCursorLocation(body, 0);
	            }
	            editor.nodeChanged();
	          }
	        });
	      };
	      var selectAll = function () {
	        editor.shortcuts.add('meta+a', null, 'SelectAll');
	      };
	      var inputMethodFocus = function () {
	        if (!editor.inline) {
	          dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
	            var rng;
	            if (e.target === editor.getDoc().documentElement) {
	              rng = selection.getRng();
	              editor.getBody().focus();
	              if (e.type === 'mousedown') {
	                if (isCaretContainer(rng.startContainer)) {
	                  return;
	                }
	                selection.placeCaretAt(e.clientX, e.clientY);
	              } else {
	                selection.setRng(rng);
	              }
	            }
	          });
	        }
	      };
	      var removeHrOnBackspace = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (!editor.getBody().getElementsByTagName('hr').length) {
	              return;
	            }
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var node = selection.getNode();
	              var previousSibling = node.previousSibling;
	              if (node.nodeName === 'HR') {
	                dom.remove(node);
	                e.preventDefault();
	                return;
	              }
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'hr') {
	                dom.remove(previousSibling);
	                e.preventDefault();
	              }
	            }
	          }
	        });
	      };
	      var focusBody = function () {
	        if (!Range.prototype.getClientRects) {
	          editor.on('mousedown', function (e) {
	            if (!isDefaultPrevented(e) && e.target.nodeName === 'HTML') {
	              var body_1 = editor.getBody();
	              body_1.blur();
	              Delay.setEditorTimeout(editor, function () {
	                body_1.focus();
	              });
	            }
	          });
	        }
	      };
	      var selectControlElements = function () {
	        editor.on('click', function (e) {
	          var target = e.target;
	          if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== 'false') {
	            e.preventDefault();
	            editor.selection.select(target);
	            editor.nodeChanged();
	          }
	          if (target.nodeName === 'A' && dom.hasClass(target, 'mce-item-anchor')) {
	            e.preventDefault();
	            selection.select(target);
	          }
	        });
	      };
	      var removeStylesWhenDeletingAcrossBlockElements = function () {
	        var getAttributeApplyFunction = function () {
	          var template = dom.getAttribs(selection.getStart().cloneNode(false));
	          return function () {
	            var target = selection.getStart();
	            if (target !== editor.getBody()) {
	              dom.setAttrib(target, 'style', null);
	              each(template, function (attr) {
	                target.setAttributeNode(attr.cloneNode(true));
	              });
	            }
	          };
	        };
	        var isSelectionAcrossElements = function () {
	          return !selection.isCollapsed() && dom.getParent(selection.getStart(), dom.isBlock) !== dom.getParent(selection.getEnd(), dom.isBlock);
	        };
	        editor.on('keypress', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && (e.keyCode === 8 || e.keyCode === 46) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            editor.getDoc().execCommand('delete', false, null);
	            applyAttributes();
	            e.preventDefault();
	            return false;
	          }
	        });
	        dom.bind(editor.getDoc(), 'cut', function (e) {
	          var applyAttributes;
	          if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            Delay.setEditorTimeout(editor, function () {
	              applyAttributes();
	            });
	          }
	        });
	      };
	      var disableBackspaceIntoATable = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (selection.isCollapsed() && selection.getRng().startOffset === 0) {
	              var previousSibling = selection.getNode().previousSibling;
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === 'table') {
	                e.preventDefault();
	                return false;
	              }
	            }
	          }
	        });
	      };
	      var removeBlockQuoteOnBackSpace = function () {
	        editor.on('keydown', function (e) {
	          var rng, parent;
	          if (isDefaultPrevented(e) || e.keyCode !== VK.BACKSPACE) {
	            return;
	          }
	          rng = selection.getRng();
	          var container = rng.startContainer;
	          var offset = rng.startOffset;
	          var root = dom.getRoot();
	          parent = container;
	          if (!rng.collapsed || offset !== 0) {
	            return;
	          }
	          while (parent && parent.parentNode && parent.parentNode.firstChild === parent && parent.parentNode !== root) {
	            parent = parent.parentNode;
	          }
	          if (parent.tagName === 'BLOCKQUOTE') {
	            editor.formatter.toggle('blockquote', null, parent);
	            rng = dom.createRng();
	            rng.setStart(container, 0);
	            rng.setEnd(container, 0);
	            selection.setRng(rng);
	          }
	        });
	      };
	      var setGeckoEditingOptions = function () {
	        var setOpts = function () {
	          setEditorCommandState('StyleWithCSS', false);
	          setEditorCommandState('enableInlineTableEditing', false);
	          if (!getObjectResizing(editor)) {
	            setEditorCommandState('enableObjectResizing', false);
	          }
	        };
	        if (!isReadOnly(editor)) {
	          editor.on('BeforeExecCommand mousedown', setOpts);
	        }
	      };
	      var addBrAfterLastLinks = function () {
	        var fixLinks = function () {
	          each(dom.select('a'), function (node) {
	            var parentNode = node.parentNode;
	            var root = dom.getRoot();
	            if (parentNode.lastChild === node) {
	              while (parentNode && !dom.isBlock(parentNode)) {
	                if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
	                  return;
	                }
	                parentNode = parentNode.parentNode;
	              }
	              dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
	            }
	          });
	        };
	        editor.on('SetContent ExecCommand', function (e) {
	          if (e.type === 'setcontent' || e.command === 'mceInsertLink') {
	            fixLinks();
	          }
	        });
	      };
	      var setDefaultBlockType = function () {
	        if (getForcedRootBlock(editor)) {
	          editor.on('init', function () {
	            setEditorCommandState('DefaultParagraphSeparator', getForcedRootBlock(editor));
	          });
	        }
	      };
	      var normalizeSelection = function () {
	        editor.on('keyup focusin mouseup', function (e) {
	          if (!VK.modifierPressed(e)) {
	            selection.normalize();
	          }
	        }, true);
	      };
	      var showBrokenImageIcon = function () {
	        editor.contentStyles.push('img:-moz-broken {' + '-moz-force-broken-image-icon:1;' + 'min-width:24px;' + 'min-height:24px' + '}');
	      };
	      var restoreFocusOnKeyDown = function () {
	        if (!editor.inline) {
	          editor.on('keydown', function () {
	            if (document.activeElement === document.body) {
	              editor.getWin().focus();
	            }
	          });
	        }
	      };
	      var bodyHeight = function () {
	        if (!editor.inline) {
	          editor.contentStyles.push('body {min-height: 150px}');
	          editor.on('click', function (e) {
	            var rng;
	            if (e.target.nodeName === 'HTML') {
	              if (Env.ie > 11) {
	                editor.getBody().focus();
	                return;
	              }
	              rng = editor.selection.getRng();
	              editor.getBody().focus();
	              editor.selection.setRng(rng);
	              editor.selection.normalize();
	              editor.nodeChanged();
	            }
	          });
	        }
	      };
	      var blockCmdArrowNavigation = function () {
	        if (Env.mac) {
	          editor.on('keydown', function (e) {
	            if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode === 37 || e.keyCode === 39)) {
	              e.preventDefault();
	              var selection_1 = editor.selection.getSel();
	              selection_1.modify('move', e.keyCode === 37 ? 'backward' : 'forward', 'lineboundary');
	            }
	          });
	        }
	      };
	      var disableAutoUrlDetect = function () {
	        setEditorCommandState('AutoUrlDetect', false);
	      };
	      var tapLinksAndImages = function () {
	        editor.on('click', function (e) {
	          var elm = e.target;
	          do {
	            if (elm.tagName === 'A') {
	              e.preventDefault();
	              return;
	            }
	          } while (elm = elm.parentNode);
	        });
	        editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
	      };
	      var blockFormSubmitInsideEditor = function () {
	        editor.on('init', function () {
	          editor.dom.bind(editor.getBody(), 'submit', function (e) {
	            e.preventDefault();
	          });
	        });
	      };
	      var removeAppleInterchangeBrs = function () {
	        parser.addNodeFilter('br', function (nodes) {
	          var i = nodes.length;
	          while (i--) {
	            if (nodes[i].attr('class') === 'Apple-interchange-newline') {
	              nodes[i].remove();
	            }
	          }
	        });
	      };
	      var ieInternalDragAndDrop = function () {
	        editor.on('dragstart', function (e) {
	          setMceInternalContent(e);
	        });
	        editor.on('drop', function (e) {
	          if (!isDefaultPrevented(e)) {
	            var internalContent = getMceInternalContent(e);
	            if (internalContent && internalContent.id !== editor.id) {
	              e.preventDefault();
	              var rng = fromPoint$1(e.x, e.y, editor.getDoc());
	              selection.setRng(rng);
	              insertClipboardContents(internalContent.html, true);
	            }
	          }
	        });
	      };
	      var refreshContentEditable = noop;
	      var isHidden = function () {
	        if (!isGecko || editor.removed) {
	          return false;
	        }
	        var sel = editor.selection.getSel();
	        return !sel || !sel.rangeCount || sel.rangeCount === 0;
	      };
	      var setupRtc = function () {
	        if (isWebKit) {
	          selectControlElements();
	          blockFormSubmitInsideEditor();
	          selectAll();
	          if (Env.iOS) {
	            restoreFocusOnKeyDown();
	            bodyHeight();
	            tapLinksAndImages();
	          }
	        }
	        if (isGecko) {
	          focusBody();
	          setGeckoEditingOptions();
	          showBrokenImageIcon();
	          blockCmdArrowNavigation();
	        }
	      };
	      var setup = function () {
	        removeBlockQuoteOnBackSpace();
	        emptyEditorWhenDeleting();
	        if (!Env.windowsPhone) {
	          normalizeSelection();
	        }
	        if (isWebKit) {
	          inputMethodFocus();
	          selectControlElements();
	          setDefaultBlockType();
	          blockFormSubmitInsideEditor();
	          disableBackspaceIntoATable();
	          removeAppleInterchangeBrs();
	          if (Env.iOS) {
	            restoreFocusOnKeyDown();
	            bodyHeight();
	            tapLinksAndImages();
	          } else {
	            selectAll();
	          }
	        }
	        if (Env.ie >= 11) {
	          bodyHeight();
	          disableBackspaceIntoATable();
	        }
	        if (Env.ie) {
	          selectAll();
	          disableAutoUrlDetect();
	          ieInternalDragAndDrop();
	        }
	        if (isGecko) {
	          removeHrOnBackspace();
	          focusBody();
	          removeStylesWhenDeletingAcrossBlockElements();
	          setGeckoEditingOptions();
	          addBrAfterLastLinks();
	          showBrokenImageIcon();
	          blockCmdArrowNavigation();
	          disableBackspaceIntoATable();
	        }
	      };
	      if (isRtc(editor)) {
	        setupRtc();
	      } else {
	        setup();
	      }
	      return {
	        refreshContentEditable: refreshContentEditable,
	        isHidden: isHidden
	      };
	    };
	
	    var DOM$4 = DOMUtils.DOM;
	    var appendStyle = function (editor, text) {
	      var body = SugarElement.fromDom(editor.getBody());
	      var container = getStyleContainer(getRootNode(body));
	      var style = SugarElement.fromTag('style');
	      set(style, 'type', 'text/css');
	      append(style, SugarElement.fromText(text));
	      append(container, style);
	      editor.on('remove', function () {
	        remove(style);
	      });
	    };
	    var getRootName = function (editor) {
	      return editor.inline ? editor.getElement().nodeName.toLowerCase() : undefined;
	    };
	    var removeUndefined = function (obj) {
	      return filter$1(obj, function (v) {
	        return isUndefined(v) === false;
	      });
	    };
	    var mkParserSettings = function (editor) {
	      var settings = editor.settings;
	      var blobCache = editor.editorUpload.blobCache;
	      return removeUndefined({
	        allow_conditional_comments: settings.allow_conditional_comments,
	        allow_html_data_urls: settings.allow_html_data_urls,
	        allow_svg_data_urls: settings.allow_svg_data_urls,
	        allow_html_in_named_anchor: settings.allow_html_in_named_anchor,
	        allow_script_urls: settings.allow_script_urls,
	        allow_unsafe_link_target: settings.allow_unsafe_link_target,
	        convert_fonts_to_spans: settings.convert_fonts_to_spans,
	        fix_list_elements: settings.fix_list_elements,
	        font_size_legacy_values: settings.font_size_legacy_values,
	        forced_root_block: settings.forced_root_block,
	        forced_root_block_attrs: settings.forced_root_block_attrs,
	        padd_empty_with_br: settings.padd_empty_with_br,
	        preserve_cdata: settings.preserve_cdata,
	        remove_trailing_brs: settings.remove_trailing_brs,
	        inline_styles: settings.inline_styles,
	        root_name: getRootName(editor),
	        validate: true,
	        blob_cache: blobCache,
	        images_dataimg_filter: settings.images_dataimg_filter
	      });
	    };
	    var mkSerializerSettings = function (editor) {
	      var settings = editor.settings;
	      return __assign(__assign({}, mkParserSettings(editor)), removeUndefined({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope,
	        element_format: settings.element_format,
	        entities: settings.entities,
	        entity_encoding: settings.entity_encoding,
	        indent: settings.indent,
	        indent_after: settings.indent_after,
	        indent_before: settings.indent_before,
	        block_elements: settings.block_elements,
	        boolean_attributes: settings.boolean_attributes,
	        custom_elements: settings.custom_elements,
	        extended_valid_elements: settings.extended_valid_elements,
	        invalid_elements: settings.invalid_elements,
	        invalid_styles: settings.invalid_styles,
	        move_caret_before_on_enter_elements: settings.move_caret_before_on_enter_elements,
	        non_empty_elements: settings.non_empty_elements,
	        schema: settings.schema,
	        self_closing_elements: settings.self_closing_elements,
	        short_ended_elements: settings.short_ended_elements,
	        special: settings.special,
	        text_block_elements: settings.text_block_elements,
	        text_inline_elements: settings.text_inline_elements,
	        valid_children: settings.valid_children,
	        valid_classes: settings.valid_classes,
	        valid_elements: settings.valid_elements,
	        valid_styles: settings.valid_styles,
	        verify_html: settings.verify_html,
	        whitespace_elements: settings.whitespace_elements
	      }));
	    };
	    var createParser = function (editor) {
	      var parser = DomParser(mkParserSettings(editor), editor.schema);
	      parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
	        var i = nodes.length, node, value;
	        var dom = editor.dom;
	        var internalName = 'data-mce-' + name;
	        while (i--) {
	          node = nodes[i];
	          value = node.attr(name);
	          if (value && !node.attr(internalName)) {
	            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
	              continue;
	            }
	            if (name === 'style') {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	              if (!value.length) {
	                value = null;
	              }
	              node.attr(internalName, value);
	              node.attr(name, value);
	            } else if (name === 'tabindex') {
	              node.attr(internalName, value);
	              node.attr(name, null);
	            } else {
	              node.attr(internalName, editor.convertURL(value, name, node.name));
	            }
	          }
	        }
	      });
	      parser.addNodeFilter('script', function (nodes) {
	        var i = nodes.length;
	        while (i--) {
	          var node = nodes[i];
	          var type = node.attr('type') || 'no/type';
	          if (type.indexOf('mce-') !== 0) {
	            node.attr('type', 'mce-' + type);
	          }
	        }
	      });
	      if (editor.settings.preserve_cdata) {
	        parser.addNodeFilter('#cdata', function (nodes) {
	          var i = nodes.length;
	          while (i--) {
	            var node = nodes[i];
	            node.type = 8;
	            node.name = '#comment';
	            node.value = '[CDATA[' + editor.dom.encode(node.value) + ']]';
	          }
	        });
	      }
	      parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
	        var i = nodes.length;
	        var nonEmptyElements = editor.schema.getNonEmptyElements();
	        while (i--) {
	          var node = nodes[i];
	          if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
	            node.append(new AstNode('br', 1)).shortEnded = true;
	          }
	        }
	      });
	      return parser;
	    };
	    var autoFocus = function (editor) {
	      if (editor.settings.auto_focus) {
	        Delay.setEditorTimeout(editor, function () {
	          var focusEditor;
	          if (editor.settings.auto_focus === true) {
	            focusEditor = editor;
	          } else {
	            focusEditor = editor.editorManager.get(editor.settings.auto_focus);
	          }
	          if (!focusEditor.destroyed) {
	            focusEditor.focus();
	          }
	        }, 100);
	      }
	    };
	    var moveSelectionToFirstCaretPosition = function (editor) {
	      var root = editor.dom.getRoot();
	      if (!editor.inline && (!hasAnyRanges(editor) || editor.selection.getStart(true) === root)) {
	        firstPositionIn(root).each(function (pos) {
	          var node = pos.getNode();
	          var caretPos = isTable(node) ? firstPositionIn(node).getOr(pos) : pos;
	          if (Env.browser.isIE()) {
	            storeNative(editor, caretPos.toRange());
	          } else {
	            editor.selection.setRng(caretPos.toRange());
	          }
	        });
	      }
	    };
	    var initEditor = function (editor) {
	      editor.bindPendingEventDelegates();
	      editor.initialized = true;
	      fireInit(editor);
	      editor.focus(true);
	      moveSelectionToFirstCaretPosition(editor);
	      editor.nodeChanged({ initial: true });
	      editor.execCallback('init_instance_callback', editor);
	      autoFocus(editor);
	    };
	    var getStyleSheetLoader = function (editor) {
	      return editor.inline ? editor.ui.styleSheetLoader : editor.dom.styleSheetLoader;
	    };
	    var makeStylesheetLoadingPromises = function (editor, css, framedFonts) {
	      var promises = [new promiseObj(function (resolve, reject) {
	          return getStyleSheetLoader(editor).loadAll(css, resolve, reject);
	        })];
	      if (editor.inline) {
	        return promises;
	      } else {
	        return promises.concat([new promiseObj(function (resolve, reject) {
	            return editor.ui.styleSheetLoader.loadAll(framedFonts, resolve, reject);
	          })]);
	      }
	    };
	    var loadContentCss = function (editor, css) {
	      var styleSheetLoader = getStyleSheetLoader(editor);
	      var fontCss = getFontCss(editor);
	      var removeCss = function () {
	        styleSheetLoader.unloadAll(css);
	        if (!editor.inline) {
	          editor.ui.styleSheetLoader.unloadAll(fontCss);
	        }
	      };
	      var loaded = function () {
	        if (editor.removed) {
	          removeCss();
	        } else {
	          editor.on('remove', removeCss);
	          initEditor(editor);
	        }
	      };
	      promiseObj.all(makeStylesheetLoadingPromises(editor, css, fontCss)).then(loaded).catch(loaded);
	    };
	    var preInit = function (editor) {
	      var settings = editor.settings, doc = editor.getDoc(), body = editor.getBody();
	      if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
	        doc.body.spellcheck = false;
	        DOM$4.setAttrib(body, 'spellcheck', 'false');
	      }
	      editor.quirks = Quirks(editor);
	      firePostRender(editor);
	      var directionality = getDirectionality(editor);
	      if (directionality !== undefined) {
	        body.dir = directionality;
	      }
	      if (settings.protect) {
	        editor.on('BeforeSetContent', function (e) {
	          Tools.each(settings.protect, function (pattern) {
	            e.content = e.content.replace(pattern, function (str) {
	              return '<!--mce:protected ' + escape(str) + '-->';
	            });
	          });
	        });
	      }
	      editor.on('SetContent', function () {
	        editor.addVisual(editor.getBody());
	      });
	      if (!isRtc(editor)) {
	        editor.load({
	          initial: true,
	          format: 'html'
	        });
	      }
	      editor.startContent = editor.getContent({ format: 'raw' });
	      editor.on('compositionstart compositionend', function (e) {
	        editor.composing = e.type === 'compositionstart';
	      });
	      if (editor.contentStyles.length > 0) {
	        var contentCssText_1 = '';
	        Tools.each(editor.contentStyles, function (style) {
	          contentCssText_1 += style + '\r\n';
	        });
	        editor.dom.addStyle(contentCssText_1);
	      }
	      loadContentCss(editor, editor.contentCSS);
	      if (settings.content_style) {
	        appendStyle(editor, settings.content_style);
	      }
	    };
	    var initContentBody = function (editor, skipWrite) {
	      var settings = editor.settings;
	      var targetElm = editor.getElement();
	      var doc = editor.getDoc();
	      if (!settings.inline) {
	        editor.getElement().style.visibility = editor.orgVisibility;
	      }
	      if (!skipWrite && !editor.inline) {
	        doc.open();
	        doc.write(editor.iframeHTML);
	        doc.close();
	      }
	      if (editor.inline) {
	        DOM$4.addClass(targetElm, 'mce-content-body');
	        editor.contentDocument = doc = document;
	        editor.contentWindow = window;
	        editor.bodyElement = targetElm;
	        editor.contentAreaContainer = targetElm;
	      }
	      var body = editor.getBody();
	      body.disabled = true;
	      editor.readonly = !!settings.readonly;
	      if (!editor.readonly) {
	        if (editor.inline && DOM$4.getStyle(body, 'position', true) === 'static') {
	          body.style.position = 'relative';
	        }
	        body.contentEditable = editor.getParam('content_editable_state', true);
	      }
	      body.disabled = false;
	      editor.editorUpload = EditorUpload(editor);
	      editor.schema = Schema(settings);
	      editor.dom = DOMUtils(doc, {
	        keep_values: true,
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        hex_colors: settings.force_hex_style_colors,
	        update_styles: true,
	        root_element: editor.inline ? editor.getBody() : null,
	        collect: function () {
	          return editor.inline;
	        },
	        schema: editor.schema,
	        contentCssCors: shouldUseContentCssCors(editor),
	        referrerPolicy: getReferrerPolicy(editor),
	        onSetAttrib: function (e) {
	          editor.fire('SetAttrib', e);
	        }
	      });
	      editor.parser = createParser(editor);
	      editor.serializer = DomSerializer(mkSerializerSettings(editor), editor);
	      editor.selection = EditorSelection(editor.dom, editor.getWin(), editor.serializer, editor);
	      editor.annotator = Annotator(editor);
	      editor.formatter = Formatter(editor);
	      editor.undoManager = UndoManager(editor);
	      editor._nodeChangeDispatcher = new NodeChange(editor);
	      editor._selectionOverrides = SelectionOverrides(editor);
	      setup$9(editor);
	      setup$k(editor);
	      if (!isRtc(editor)) {
	        setup$l(editor);
	      }
	      var caret = setup$j(editor);
	      setup$8(editor, caret);
	      setup$a(editor);
	      setup$7(editor);
	      firePreInit(editor);
	      setup$5(editor).fold(function () {
	        preInit(editor);
	      }, function (loadingRtc) {
	        editor.setProgressState(true);
	        loadingRtc.then(function (_rtcMode) {
	          editor.setProgressState(false);
	          preInit(editor);
	        }, function (err) {
	          editor.notificationManager.open({
	            type: 'error',
	            text: String(err)
	          });
	          preInit(editor);
	        });
	      });
	    };
	
	    var DOM$5 = DOMUtils.DOM;
	    var relaxDomain = function (editor, ifr) {
	      if (document.domain !== window.location.hostname && Env.browser.isIE()) {
	        var bodyUuid = uuid('mce');
	        editor[bodyUuid] = function () {
	          initContentBody(editor);
	        };
	        var domainRelaxUrl = 'javascript:(function(){' + 'document.open();document.domain="' + document.domain + '";' + 'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' + 'document.close();ed.' + bodyUuid + '(true);})()';
	        DOM$5.setAttrib(ifr, 'src', domainRelaxUrl);
	        return true;
	      }
	      return false;
	    };
	    var createIframeElement = function (id, title, height, customAttrs) {
	      var iframe = SugarElement.fromTag('iframe');
	      setAll(iframe, customAttrs);
	      setAll(iframe, {
	        id: id + '_ifr',
	        frameBorder: '0',
	        allowTransparency: 'true',
	        title: title
	      });
	      add$3(iframe, 'tox-edit-area__iframe');
	      return iframe;
	    };
	    var getIframeHtml = function (editor) {
	      var iframeHTML = getDocType(editor) + '<html><head>';
	      if (getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
	        iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
	      }
	      iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
	      var bodyId = getBodyId(editor);
	      var bodyClass = getBodyClass(editor);
	      if (getContentSecurityPolicy(editor)) {
	        iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + getContentSecurityPolicy(editor) + '" />';
	      }
	      iframeHTML += '</head><body id="' + bodyId + '" class="mce-content-body ' + bodyClass + '" data-id="' + editor.id + '"><br></body></html>';
	      return iframeHTML;
	    };
	    var createIframe = function (editor, o) {
	      var title = editor.editorManager.translate('Rich Text Area. Press ALT-0 for help.');
	      var ifr = createIframeElement(editor.id, title, o.height, getIframeAttrs(editor)).dom;
	      ifr.onload = function () {
	        ifr.onload = null;
	        editor.fire('load');
	      };
	      var isDomainRelaxed = relaxDomain(editor, ifr);
	      editor.contentAreaContainer = o.iframeContainer;
	      editor.iframeElement = ifr;
	      editor.iframeHTML = getIframeHtml(editor);
	      DOM$5.add(o.iframeContainer, ifr);
	      return isDomainRelaxed;
	    };
	    var init$1 = function (editor, boxInfo) {
	      var isDomainRelaxed = createIframe(editor, boxInfo);
	      if (boxInfo.editorContainer) {
	        DOM$5.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
	        editor.hidden = DOM$5.isHidden(boxInfo.editorContainer);
	      }
	      editor.getElement().style.display = 'none';
	      DOM$5.setAttrib(editor.id, 'aria-hidden', 'true');
	      if (!isDomainRelaxed) {
	        initContentBody(editor);
	      }
	    };
	
	    var DOM$6 = DOMUtils.DOM;
	    var initPlugin = function (editor, initializedPlugins, plugin) {
	      var Plugin = PluginManager.get(plugin);
	      var pluginUrl = PluginManager.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
	      plugin = Tools.trim(plugin);
	      if (Plugin && Tools.inArray(initializedPlugins, plugin) === -1) {
	        Tools.each(PluginManager.dependencies(plugin), function (dep) {
	          initPlugin(editor, initializedPlugins, dep);
	        });
	        if (editor.plugins[plugin]) {
	          return;
	        }
	        try {
	          var pluginInstance = new Plugin(editor, pluginUrl, editor.$);
	          editor.plugins[plugin] = pluginInstance;
	          if (pluginInstance.init) {
	            pluginInstance.init(editor, pluginUrl);
	            initializedPlugins.push(plugin);
	          }
	        } catch (e) {
	          pluginInitError(editor, plugin, e);
	        }
	      }
	    };
	    var trimLegacyPrefix = function (name) {
	      return name.replace(/^\-/, '');
	    };
	    var initPlugins = function (editor) {
	      var initializedPlugins = [];
	      Tools.each(getPlugins(editor).split(/[ ,]/), function (name) {
	        initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
	      });
	    };
	    var initIcons = function (editor) {
	      var iconPackName = Tools.trim(getIconPackName(editor));
	      var currentIcons = editor.ui.registry.getAll().icons;
	      var loadIcons = __assign(__assign({}, IconManager.get('default').icons), IconManager.get(iconPackName).icons);
	      each$1(loadIcons, function (svgData, icon) {
	        if (!has(currentIcons, icon)) {
	          editor.ui.registry.addIcon(icon, svgData);
	        }
	      });
	    };
	    var initTheme = function (editor) {
	      var theme = getTheme(editor);
	      if (isString(theme)) {
	        editor.settings.theme = trimLegacyPrefix(theme);
	        var Theme = ThemeManager.get(theme);
	        editor.theme = new Theme(editor, ThemeManager.urls[theme]);
	        if (editor.theme.init) {
	          editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
	        }
	      } else {
	        editor.theme = {};
	      }
	    };
	    var renderFromLoadedTheme = function (editor) {
	      return editor.theme.renderUI();
	    };
	    var renderFromThemeFunc = function (editor) {
	      var elm = editor.getElement();
	      var theme = getTheme(editor);
	      var info = theme(editor, elm);
	      if (info.editorContainer.nodeType) {
	        info.editorContainer.id = info.editorContainer.id || editor.id + '_parent';
	      }
	      if (info.iframeContainer && info.iframeContainer.nodeType) {
	        info.iframeContainer.id = info.iframeContainer.id || editor.id + '_iframecontainer';
	      }
	      info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
	      return info;
	    };
	    var createThemeFalseResult = function (element) {
	      return {
	        editorContainer: element,
	        iframeContainer: element,
	        api: {}
	      };
	    };
	    var renderThemeFalseIframe = function (targetElement) {
	      var iframeContainer = DOM$6.create('div');
	      DOM$6.insertAfter(iframeContainer, targetElement);
	      return createThemeFalseResult(iframeContainer);
	    };
	    var renderThemeFalse = function (editor) {
	      var targetElement = editor.getElement();
	      return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
	    };
	    var renderThemeUi = function (editor) {
	      var elm = editor.getElement();
	      editor.orgDisplay = elm.style.display;
	      if (isString(getTheme(editor))) {
	        return renderFromLoadedTheme(editor);
	      } else if (isFunction(getTheme(editor))) {
	        return renderFromThemeFunc(editor);
	      } else {
	        return renderThemeFalse(editor);
	      }
	    };
	    var augmentEditorUiApi = function (editor, api) {
	      var uiApiFacade = {
	        show: Optional.from(api.show).getOr(noop),
	        hide: Optional.from(api.hide).getOr(noop),
	        disable: Optional.from(api.disable).getOr(noop),
	        isDisabled: Optional.from(api.isDisabled).getOr(never),
	        enable: function () {
	          if (!editor.mode.isReadOnly()) {
	            Optional.from(api.enable).map(call);
	          }
	        }
	      };
	      editor.ui = __assign(__assign({}, editor.ui), uiApiFacade);
	    };
	    var init$2 = function (editor) {
	      editor.fire('ScriptsLoaded');
	      initIcons(editor);
	      initTheme(editor);
	      initPlugins(editor);
	      var renderInfo = renderThemeUi(editor);
	      augmentEditorUiApi(editor, Optional.from(renderInfo.api).getOr({}));
	      var boxInfo = {
	        editorContainer: renderInfo.editorContainer,
	        iframeContainer: renderInfo.iframeContainer
	      };
	      editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
	      appendContentCssFromSettings(editor);
	      if (editor.inline) {
	        return initContentBody(editor);
	      } else {
	        return init$1(editor, boxInfo);
	      }
	    };
	
	    var DOM$7 = DOMUtils.DOM;
	    var hasSkipLoadPrefix = function (name) {
	      return name.charAt(0) === '-';
	    };
	    var loadLanguage = function (scriptLoader, editor) {
	      var languageCode = getLanguageCode(editor);
	      var languageUrl = getLanguageUrl(editor);
	      if (I18n.hasCode(languageCode) === false && languageCode !== 'en') {
	        var url_1 = languageUrl !== '' ? languageUrl : editor.editorManager.baseURL + '/langs/' + languageCode + '.js';
	        scriptLoader.add(url_1, noop, undefined, function () {
	          languageLoadError(editor, url_1, languageCode);
	        });
	      }
	    };
	    var loadTheme = function (scriptLoader, editor, suffix, callback) {
	      var theme = getTheme(editor);
	      if (isString(theme)) {
	        if (!hasSkipLoadPrefix(theme) && !ThemeManager.urls.hasOwnProperty(theme)) {
	          var themeUrl = getThemeUrl(editor);
	          if (themeUrl) {
	            ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
	          } else {
	            ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
	          }
	        }
	        scriptLoader.loadQueue(function () {
	          ThemeManager.waitFor(theme, callback);
	        });
	      } else {
	        callback();
	      }
	    };
	    var getIconsUrlMetaFromUrl = function (editor) {
	      return Optional.from(getIconsUrl(editor)).filter(function (url) {
	        return url.length > 0;
	      }).map(function (url) {
	        return {
	          url: url,
	          name: Optional.none()
	        };
	      });
	    };
	    var getIconsUrlMetaFromName = function (editor, name, suffix) {
	      return Optional.from(name).filter(function (name) {
	        return name.length > 0 && !IconManager.has(name);
	      }).map(function (name) {
	        return {
	          url: editor.editorManager.baseURL + '/icons/' + name + '/icons' + suffix + '.js',
	          name: Optional.some(name)
	        };
	      });
	    };
	    var loadIcons = function (scriptLoader, editor, suffix) {
	      var defaultIconsUrl = getIconsUrlMetaFromName(editor, 'default', suffix);
	      var customIconsUrl = getIconsUrlMetaFromUrl(editor).orThunk(function () {
	        return getIconsUrlMetaFromName(editor, getIconPackName(editor), '');
	      });
	      each(cat([
	        defaultIconsUrl,
	        customIconsUrl
	      ]), function (urlMeta) {
	        scriptLoader.add(urlMeta.url, noop, undefined, function () {
	          iconsLoadError(editor, urlMeta.url, urlMeta.name.getOrUndefined());
	        });
	      });
	    };
	    var loadPlugins = function (editor, suffix) {
	      Tools.each(getExternalPlugins(editor), function (url, name) {
	        PluginManager.load(name, url, noop, undefined, function () {
	          pluginLoadError(editor, url, name);
	        });
	        editor.settings.plugins += ' ' + name;
	      });
	      Tools.each(getPlugins(editor).split(/[ ,]/), function (plugin) {
	        plugin = Tools.trim(plugin);
	        if (plugin && !PluginManager.urls[plugin]) {
	          if (hasSkipLoadPrefix(plugin)) {
	            plugin = plugin.substr(1, plugin.length);
	            var dependencies = PluginManager.dependencies(plugin);
	            Tools.each(dependencies, function (depPlugin) {
	              var defaultSettings = {
	                prefix: 'plugins/',
	                resource: depPlugin,
	                suffix: '/plugin' + suffix + '.js'
	              };
	              var dep = PluginManager.createUrl(defaultSettings, depPlugin);
	              PluginManager.load(dep.resource, dep, noop, undefined, function () {
	                pluginLoadError(editor, dep.prefix + dep.resource + dep.suffix, dep.resource);
	              });
	            });
	          } else {
	            var url_2 = {
	              prefix: 'plugins/',
	              resource: plugin,
	              suffix: '/plugin' + suffix + '.js'
	            };
	            PluginManager.load(plugin, url_2, noop, undefined, function () {
	              pluginLoadError(editor, url_2.prefix + url_2.resource + url_2.suffix, plugin);
	            });
	          }
	        }
	      });
	    };
	    var loadScripts = function (editor, suffix) {
	      var scriptLoader = ScriptLoader.ScriptLoader;
	      loadTheme(scriptLoader, editor, suffix, function () {
	        loadLanguage(scriptLoader, editor);
	        loadIcons(scriptLoader, editor, suffix);
	        loadPlugins(editor, suffix);
	        scriptLoader.loadQueue(function () {
	          if (!editor.removed) {
	            init$2(editor);
	          }
	        }, editor, function () {
	          if (!editor.removed) {
	            init$2(editor);
	          }
	        });
	      });
	    };
	    var getStyleSheetLoader$1 = function (element, editor) {
	      return instance.forElement(element, {
	        contentCssCors: hasContentCssCors(editor),
	        referrerPolicy: getReferrerPolicy(editor)
	      });
	    };
	    var render = function (editor) {
	      var id = editor.id;
	      I18n.setCode(getLanguageCode(editor));
	      var readyHandler = function () {
	        DOM$7.unbind(window, 'ready', readyHandler);
	        editor.render();
	      };
	      if (!EventUtils.Event.domLoaded) {
	        DOM$7.bind(window, 'ready', readyHandler);
	        return;
	      }
	      if (!editor.getElement()) {
	        return;
	      }
	      if (!Env.contentEditable) {
	        return;
	      }
	      var element = SugarElement.fromDom(editor.getElement());
	      var snapshot = clone(element);
	      editor.on('remove', function () {
	        eachr(element.dom.attributes, function (attr) {
	          return remove$1(element, attr.name);
	        });
	        setAll(element, snapshot);
	      });
	      editor.ui.styleSheetLoader = getStyleSheetLoader$1(element, editor);
	      if (!isInline$1(editor)) {
	        editor.orgVisibility = editor.getElement().style.visibility;
	        editor.getElement().style.visibility = 'hidden';
	      } else {
	        editor.inline = true;
	      }
	      var form = editor.getElement().form || DOM$7.getParent(id, 'form');
	      if (form) {
	        editor.formElement = form;
	        if (hasHiddenInput(editor) && !isTextareaOrInput(editor.getElement())) {
	          DOM$7.insertAfter(DOM$7.create('input', {
	            type: 'hidden',
	            name: id
	          }), id);
	          editor.hasHiddenInput = true;
	        }
	        editor.formEventDelegate = function (e) {
	          editor.fire(e.type, e);
	        };
	        DOM$7.bind(form, 'submit reset', editor.formEventDelegate);
	        editor.on('reset', function () {
	          editor.resetContent();
	        });
	        if (shouldPatchSubmit(editor) && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
	          form._mceOldSubmit = form.submit;
	          form.submit = function () {
	            editor.editorManager.triggerSave();
	            editor.setDirty(false);
	            return form._mceOldSubmit(form);
	          };
	        }
	      }
	      editor.windowManager = WindowManager(editor);
	      editor.notificationManager = NotificationManager(editor);
	      if (isEncodingXml(editor)) {
	        editor.on('GetContent', function (e) {
	          if (e.save) {
	            e.content = DOM$7.encode(e.content);
	          }
	        });
	      }
	      if (shouldAddFormSubmitTrigger(editor)) {
	        editor.on('submit', function () {
	          if (editor.initialized) {
	            editor.save();
	          }
	        });
	      }
	      if (shouldAddUnloadTrigger(editor)) {
	        editor._beforeUnload = function () {
	          if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
	            editor.save({
	              format: 'raw',
	              no_events: true,
	              set_dirty: false
	            });
	          }
	        };
	        editor.editorManager.on('BeforeUnload', editor._beforeUnload);
	      }
	      editor.editorManager.add(editor);
	      loadScripts(editor, editor.suffix);
	    };
	
	    var addVisual$1 = function (editor, elm) {
	      return addVisual(editor, elm);
	    };
	
	    var legacyPropNames = {
	      'font-size': 'size',
	      'font-family': 'face'
	    };
	    var getSpecifiedFontProp = function (propName, rootElm, elm) {
	      var getProperty = function (elm) {
	        return getRaw(elm, propName).orThunk(function () {
	          if (name(elm) === 'font') {
	            return get$1(legacyPropNames, propName).bind(function (legacyPropName) {
	              return getOpt(elm, legacyPropName);
	            });
	          } else {
	            return Optional.none();
	          }
	        });
	      };
	      var isRoot = function (elm) {
	        return eq$2(SugarElement.fromDom(rootElm), elm);
	      };
	      return closest$2(SugarElement.fromDom(elm), function (elm) {
	        return getProperty(elm);
	      }, isRoot);
	    };
	    var normalizeFontFamily = function (fontFamily) {
	      return fontFamily.replace(/[\'\"\\]/g, '').replace(/,\s+/g, ',');
	    };
	    var getComputedFontProp = function (propName, elm) {
	      return Optional.from(DOMUtils.DOM.getStyle(elm, propName, true));
	    };
	    var getFontProp = function (propName) {
	      return function (rootElm, elm) {
	        return Optional.from(elm).map(SugarElement.fromDom).filter(isElement).bind(function (element) {
	          return getSpecifiedFontProp(propName, rootElm, element.dom).or(getComputedFontProp(propName, element.dom));
	        }).getOr('');
	      };
	    };
	    var getFontSize = getFontProp('font-size');
	    var getFontFamily = compose(normalizeFontFamily, getFontProp('font-family'));
	
	    var findFirstCaretElement = function (editor) {
	      return firstPositionIn(editor.getBody()).map(function (caret) {
	        var container = caret.container();
	        return isText$1(container) ? container.parentNode : container;
	      });
	    };
	    var getCaretElement = function (editor) {
	      return Optional.from(editor.selection.getRng()).bind(function (rng) {
	        var root = editor.getBody();
	        var atStartOfNode = rng.startContainer === root && rng.startOffset === 0;
	        return atStartOfNode ? Optional.none() : Optional.from(editor.selection.getStart(true));
	      });
	    };
	    var mapRange = function (editor, mapper) {
	      return getCaretElement(editor).orThunk(curry(findFirstCaretElement, editor)).map(SugarElement.fromDom).filter(isElement).map(mapper);
	    };
	
	    var fromFontSizeNumber = function (editor, value) {
	      if (/^[0-9.]+$/.test(value)) {
	        var fontSizeNumber = parseInt(value, 10);
	        if (fontSizeNumber >= 1 && fontSizeNumber <= 7) {
	          var fontSizes = getFontStyleValues(editor);
	          var fontClasses = getFontSizeClasses(editor);
	          if (fontClasses) {
	            return fontClasses[fontSizeNumber - 1] || value;
	          } else {
	            return fontSizes[fontSizeNumber - 1] || value;
	          }
	        } else {
	          return value;
	        }
	      } else {
	        return value;
	      }
	    };
	    var normalizeFontNames = function (font) {
	      var fonts = font.split(/\s*,\s*/);
	      return map(fonts, function (font) {
	        if (font.indexOf(' ') !== -1 && !(startsWith(font, '"') || startsWith(font, '\''))) {
	          return '\'' + font + '\'';
	        } else {
	          return font;
	        }
	      }).join(',');
	    };
	    var fontNameAction = function (editor, value) {
	      var font = fromFontSizeNumber(editor, value);
	      editor.formatter.toggle('fontname', { value: normalizeFontNames(font) });
	      editor.nodeChanged();
	    };
	    var fontNameQuery = function (editor) {
	      return mapRange(editor, function (elm) {
	        return getFontFamily(editor.getBody(), elm.dom);
	      }).getOr('');
	    };
	    var fontSizeAction = function (editor, value) {
	      editor.formatter.toggle('fontsize', { value: fromFontSizeNumber(editor, value) });
	      editor.nodeChanged();
	    };
	    var fontSizeQuery = function (editor) {
	      return mapRange(editor, function (elm) {
	        return getFontSize(editor.getBody(), elm.dom);
	      }).getOr('');
	    };
	
	    var lineHeightQuery = function (editor) {
	      return mapRange(editor, function (elm) {
	        var root = SugarElement.fromDom(editor.getBody());
	        var specifiedStyle = closest$2(elm, function (elm) {
	          return getRaw(elm, 'line-height');
	        }, curry(eq$2, root));
	        var computedStyle = function () {
	          var lineHeight = parseFloat(get$5(elm, 'line-height'));
	          var fontSize = parseFloat(get$5(elm, 'font-size'));
	          return String(lineHeight / fontSize);
	        };
	        return specifiedStyle.getOrThunk(computedStyle);
	      }).getOr('');
	    };
	    var lineHeightAction = function (editor, lineHeight) {
	      editor.formatter.toggle('lineheight', { value: String(lineHeight) });
	      editor.nodeChanged();
	    };
	
	    var processValue = function (value) {
	      var details;
	      if (typeof value !== 'string') {
	        details = Tools.extend({
	          paste: value.paste,
	          data: { paste: value.paste }
	        }, value);
	        return {
	          content: value.content,
	          details: details
	        };
	      }
	      return {
	        content: value,
	        details: {}
	      };
	    };
	    var insertAtCaret$1 = function (editor, value) {
	      var result = processValue(value);
	      insertContent(editor, result.content, result.details);
	    };
	
	    var each$f = Tools.each;
	    var map$3 = Tools.map, inArray$2 = Tools.inArray;
	    var EditorCommands = function () {
	      function EditorCommands(editor) {
	        this.commands = {
	          state: {},
	          exec: {},
	          value: {}
	        };
	        this.editor = editor;
	        this.setupCommands(editor);
	      }
	      EditorCommands.prototype.execCommand = function (command, ui, value, args) {
	        var func, state = false;
	        var self = this;
	        if (self.editor.removed) {
	          return;
	        }
	        if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
	          self.editor.focus();
	        } else {
	          restore(self.editor);
	        }
	        args = self.editor.fire('BeforeExecCommand', {
	          command: command,
	          ui: ui,
	          value: value
	        });
	        if (args.isDefaultPrevented()) {
	          return false;
	        }
	        var customCommand = command.toLowerCase();
	        if (func = self.commands.exec[customCommand]) {
	          func(customCommand, ui, value);
	          self.editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        each$f(this.editor.plugins, function (p) {
	          if (p.execCommand && p.execCommand(command, ui, value)) {
	            self.editor.fire('ExecCommand', {
	              command: command,
	              ui: ui,
	              value: value
	            });
	            state = true;
	            return false;
	          }
	        });
	        if (state) {
	          return state;
	        }
	        if (self.editor.theme && self.editor.theme.execCommand && self.editor.theme.execCommand(command, ui, value)) {
	          self.editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        try {
	          state = self.editor.getDoc().execCommand(command, ui, value);
	        } catch (ex) {
	        }
	        if (state) {
	          self.editor.fire('ExecCommand', {
	            command: command,
	            ui: ui,
	            value: value
	          });
	          return true;
	        }
	        return false;
	      };
	      EditorCommands.prototype.queryCommandState = function (command) {
	        var func;
	        if (this.editor.quirks.isHidden() || this.editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = this.commands.state[command]) {
	          return func(command);
	        }
	        try {
	          return this.editor.getDoc().queryCommandState(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      EditorCommands.prototype.queryCommandValue = function (command) {
	        var func;
	        if (this.editor.quirks.isHidden() || this.editor.removed) {
	          return;
	        }
	        command = command.toLowerCase();
	        if (func = this.commands.value[command]) {
	          return func(command);
	        }
	        try {
	          return this.editor.getDoc().queryCommandValue(command);
	        } catch (ex) {
	        }
	      };
	      EditorCommands.prototype.addCommands = function (commandList, type) {
	        if (type === void 0) {
	          type = 'exec';
	        }
	        var self = this;
	        each$f(commandList, function (callback, command) {
	          each$f(command.toLowerCase().split(','), function (command) {
	            self.commands[type][command] = callback;
	          });
	        });
	      };
	      EditorCommands.prototype.addCommand = function (command, callback, scope) {
	        var _this = this;
	        command = command.toLowerCase();
	        this.commands.exec[command] = function (command, ui, value, args) {
	          return callback.call(scope || _this.editor, ui, value, args);
	        };
	      };
	      EditorCommands.prototype.queryCommandSupported = function (command) {
	        command = command.toLowerCase();
	        if (this.commands.exec[command]) {
	          return true;
	        }
	        try {
	          return this.editor.getDoc().queryCommandSupported(command);
	        } catch (ex) {
	        }
	        return false;
	      };
	      EditorCommands.prototype.addQueryStateHandler = function (command, callback, scope) {
	        var _this = this;
	        command = command.toLowerCase();
	        this.commands.state[command] = function () {
	          return callback.call(scope || _this.editor);
	        };
	      };
	      EditorCommands.prototype.addQueryValueHandler = function (command, callback, scope) {
	        var _this = this;
	        command = command.toLowerCase();
	        this.commands.value[command] = function () {
	          return callback.call(scope || _this.editor);
	        };
	      };
	      EditorCommands.prototype.hasCustomCommand = function (command) {
	        command = command.toLowerCase();
	        return !!this.commands.exec[command];
	      };
	      EditorCommands.prototype.execNativeCommand = function (command, ui, value) {
	        if (ui === undefined) {
	          ui = false;
	        }
	        if (value === undefined) {
	          value = null;
	        }
	        return this.editor.getDoc().execCommand(command, ui, value);
	      };
	      EditorCommands.prototype.isFormatMatch = function (name) {
	        return this.editor.formatter.match(name);
	      };
	      EditorCommands.prototype.toggleFormat = function (name, value) {
	        this.editor.formatter.toggle(name, value ? { value: value } : undefined);
	        this.editor.nodeChanged();
	      };
	      EditorCommands.prototype.storeSelection = function (type) {
	        this.selectionBookmark = this.editor.selection.getBookmark(type);
	      };
	      EditorCommands.prototype.restoreSelection = function () {
	        this.editor.selection.moveToBookmark(this.selectionBookmark);
	      };
	      EditorCommands.prototype.setupCommands = function (editor) {
	        var self = this;
	        this.addCommands({
	          'mceResetDesignMode,mceBeginUndoLevel': noop,
	          'mceEndUndoLevel,mceAddUndoLevel': function () {
	            editor.undoManager.add();
	          },
	          'Cut,Copy,Paste': function (command) {
	            var doc = editor.getDoc();
	            var failed;
	            try {
	              self.execNativeCommand(command);
	            } catch (ex) {
	              failed = true;
	            }
	            if (command === 'paste' && !doc.queryCommandEnabled(command)) {
	              failed = true;
	            }
	            if (failed || !doc.queryCommandSupported(command)) {
	              var msg = editor.translate('Your browser doesn\'t support direct access to the clipboard. ' + 'Please use the Ctrl+X/C/V keyboard shortcuts instead.');
	              if (Env.mac) {
	                msg = msg.replace(/Ctrl\+/g, '\u2318+');
	              }
	              editor.notificationManager.open({
	                text: msg,
	                type: 'error'
	              });
	            }
	          },
	          'unlink': function () {
	            if (editor.selection.isCollapsed()) {
	              var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
	              if (elm) {
	                editor.dom.remove(elm, true);
	              }
	              return;
	            }
	            editor.formatter.remove('link');
	          },
	          'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
	            var align = command.substring(7);
	            if (align === 'full') {
	              align = 'justify';
	            }
	            each$f('left,center,right,justify'.split(','), function (name) {
	              if (align !== name) {
	                editor.formatter.remove('align' + name);
	              }
	            });
	            if (align !== 'none') {
	              self.toggleFormat('align' + align);
	            }
	          },
	          'InsertUnorderedList,InsertOrderedList': function (command) {
	            var listParent;
	            self.execNativeCommand(command);
	            var listElm = editor.dom.getParent(editor.selection.getNode(), 'ol,ul');
	            if (listElm) {
	              listParent = listElm.parentNode;
	              if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
	                self.storeSelection();
	                editor.dom.split(listParent, listElm);
	                self.restoreSelection();
	              }
	            }
	          },
	          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	            self.toggleFormat(command);
	          },
	          'ForeColor,HiliteColor': function (command, ui, value) {
	            self.toggleFormat(command, value);
	          },
	          'FontName': function (command, ui, value) {
	            fontNameAction(editor, value);
	          },
	          'FontSize': function (command, ui, value) {
	            fontSizeAction(editor, value);
	          },
	          'LineHeight': function (command, ui, value) {
	            lineHeightAction(editor, value);
	          },
	          'RemoveFormat': function (command) {
	            editor.formatter.remove(command);
	          },
	          'mceBlockQuote': function () {
	            self.toggleFormat('blockquote');
	          },
	          'FormatBlock': function (command, ui, value) {
	            return self.toggleFormat(value || 'p');
	          },
	          'mceCleanup': function () {
	            var bookmark = editor.selection.getBookmark();
	            editor.setContent(editor.getContent());
	            editor.selection.moveToBookmark(bookmark);
	          },
	          'mceRemoveNode': function (command, ui, value) {
	            var node = value || editor.selection.getNode();
	            if (node !== editor.getBody()) {
	              self.storeSelection();
	              editor.dom.remove(node, true);
	              self.restoreSelection();
	            }
	          },
	          'mceSelectNodeDepth': function (command, ui, value) {
	            var counter = 0;
	            editor.dom.getParent(editor.selection.getNode(), function (node) {
	              if (node.nodeType === 1 && counter++ === value) {
	                editor.selection.select(node);
	                return false;
	              }
	            }, editor.getBody());
	          },
	          'mceSelectNode': function (command, ui, value) {
	            editor.selection.select(value);
	          },
	          'mceInsertContent': function (command, ui, value) {
	            insertAtCaret$1(editor, value);
	          },
	          'mceInsertRawHTML': function (command, ui, value) {
	            editor.selection.setContent('tiny_mce_marker');
	            var content = editor.getContent();
	            editor.setContent(content.replace(/tiny_mce_marker/g, function () {
	              return value;
	            }));
	          },
	          'mceInsertNewLine': function (command, ui, value) {
	            insert$3(editor, value);
	          },
	          'mceToggleFormat': function (command, ui, value) {
	            self.toggleFormat(value);
	          },
	          'mceSetContent': function (command, ui, value) {
	            editor.setContent(value);
	          },
	          'Indent,Outdent': function (command) {
	            handle(editor, command);
	          },
	          'mceRepaint': noop,
	          'InsertHorizontalRule': function () {
	            editor.execCommand('mceInsertContent', false, '<hr />');
	          },
	          'mceToggleVisualAid': function () {
	            editor.hasVisual = !editor.hasVisual;
	            editor.addVisual();
	          },
	          'mceReplaceContent': function (command, ui, value) {
	            editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, editor.selection.getContent({ format: 'text' })));
	          },
	          'mceInsertLink': function (command, ui, value) {
	            if (typeof value === 'string') {
	              value = { href: value };
	            }
	            var anchor = editor.dom.getParent(editor.selection.getNode(), 'a');
	            value.href = value.href.replace(/ /g, '%20');
	            if (!anchor || !value.href) {
	              editor.formatter.remove('link');
	            }
	            if (value.href) {
	              editor.formatter.apply('link', value, anchor);
	            }
	          },
	          'selectAll': function () {
	            var editingHost = editor.dom.getParent(editor.selection.getStart(), isContentEditableTrue);
	            if (editingHost) {
	              var rng = editor.dom.createRng();
	              rng.selectNodeContents(editingHost);
	              editor.selection.setRng(rng);
	            }
	          },
	          'mceNewDocument': function () {
	            editor.setContent('');
	          },
	          'InsertLineBreak': function (command, ui, value) {
	            insert$2(editor, value);
	            return true;
	          }
	        });
	        var alignStates = function (name) {
	          return function () {
	            var selection = editor.selection;
	            var nodes = selection.isCollapsed() ? [editor.dom.getParent(selection.getNode(), editor.dom.isBlock)] : selection.getSelectedBlocks();
	            var matches = map$3(nodes, function (node) {
	              return !!editor.formatter.matchNode(node, name);
	            });
	            return inArray$2(matches, true) !== -1;
	          };
	        };
	        self.addCommands({
	          'JustifyLeft': alignStates('alignleft'),
	          'JustifyCenter': alignStates('aligncenter'),
	          'JustifyRight': alignStates('alignright'),
	          'JustifyFull': alignStates('alignjustify'),
	          'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	            return self.isFormatMatch(command);
	          },
	          'mceBlockQuote': function () {
	            return self.isFormatMatch('blockquote');
	          },
	          'Outdent': function () {
	            return canOutdent(editor);
	          },
	          'InsertUnorderedList,InsertOrderedList': function (command) {
	            var list = editor.dom.getParent(editor.selection.getNode(), 'ul,ol');
	            return list && (command === 'insertunorderedlist' && list.tagName === 'UL' || command === 'insertorderedlist' && list.tagName === 'OL');
	          }
	        }, 'state');
	        self.addCommands({
	          Undo: function () {
	            editor.undoManager.undo();
	          },
	          Redo: function () {
	            editor.undoManager.redo();
	          }
	        });
	        self.addQueryValueHandler('FontName', function () {
	          return fontNameQuery(editor);
	        }, this);
	        self.addQueryValueHandler('FontSize', function () {
	          return fontSizeQuery(editor);
	        }, this);
	        self.addQueryValueHandler('LineHeight', function () {
	          return lineHeightQuery(editor);
	        }, this);
	      };
	      return EditorCommands;
	    }();
	
	    var internalContentEditableAttr = 'data-mce-contenteditable';
	    var toggleClass = function (elm, cls, state) {
	      if (has$2(elm, cls) && state === false) {
	        remove$4(elm, cls);
	      } else if (state) {
	        add$3(elm, cls);
	      }
	    };
	    var setEditorCommandState = function (editor, cmd, state) {
	      try {
	        editor.getDoc().execCommand(cmd, false, String(state));
	      } catch (ex) {
	      }
	    };
	    var setContentEditable = function (elm, state) {
	      elm.dom.contentEditable = state ? 'true' : 'false';
	    };
	    var switchOffContentEditableTrue = function (elm) {
	      each(descendants$1(elm, '*[contenteditable="true"]'), function (elm) {
	        set(elm, internalContentEditableAttr, 'true');
	        setContentEditable(elm, false);
	      });
	    };
	    var switchOnContentEditableTrue = function (elm) {
	      each(descendants$1(elm, '*[' + internalContentEditableAttr + '="true"]'), function (elm) {
	        remove$1(elm, internalContentEditableAttr);
	        setContentEditable(elm, true);
	      });
	    };
	    var removeFakeSelection = function (editor) {
	      Optional.from(editor.selection.getNode()).each(function (elm) {
	        elm.removeAttribute('data-mce-selected');
	      });
	    };
	    var restoreFakeSelection = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	    var toggleReadOnly = function (editor, state) {
	      var body = SugarElement.fromDom(editor.getBody());
	      toggleClass(body, 'mce-content-readonly', state);
	      if (state) {
	        editor.selection.controlSelection.hideResizeRect();
	        editor._selectionOverrides.hideFakeCaret();
	        removeFakeSelection(editor);
	        editor.readonly = true;
	        setContentEditable(body, false);
	        switchOffContentEditableTrue(body);
	      } else {
	        editor.readonly = false;
	        setContentEditable(body, true);
	        switchOnContentEditableTrue(body);
	        setEditorCommandState(editor, 'StyleWithCSS', false);
	        setEditorCommandState(editor, 'enableInlineTableEditing', false);
	        setEditorCommandState(editor, 'enableObjectResizing', false);
	        if (hasEditorOrUiFocus(editor)) {
	          editor.focus();
	        }
	        restoreFakeSelection(editor);
	        editor.nodeChanged();
	      }
	    };
	    var isReadOnly$1 = function (editor) {
	      return editor.readonly;
	    };
	    var registerFilters = function (editor) {
	      editor.parser.addAttributeFilter('contenteditable', function (nodes) {
	        if (isReadOnly$1(editor)) {
	          each(nodes, function (node) {
	            node.attr(internalContentEditableAttr, node.attr('contenteditable'));
	            node.attr('contenteditable', 'false');
	          });
	        }
	      });
	      editor.serializer.addAttributeFilter(internalContentEditableAttr, function (nodes) {
	        if (isReadOnly$1(editor)) {
	          each(nodes, function (node) {
	            node.attr('contenteditable', node.attr(internalContentEditableAttr));
	          });
	        }
	      });
	      editor.serializer.addTempAttr(internalContentEditableAttr);
	    };
	    var registerReadOnlyContentFilters = function (editor) {
	      if (editor.serializer) {
	        registerFilters(editor);
	      } else {
	        editor.on('PreInit', function () {
	          registerFilters(editor);
	        });
	      }
	    };
	    var isClickEvent = function (e) {
	      return e.type === 'click';
	    };
	    var getAnchorHrefOpt = function (editor, elm) {
	      var isRoot = function (elm) {
	        return eq$2(elm, SugarElement.fromDom(editor.getBody()));
	      };
	      return closest$1(elm, 'a', isRoot).bind(function (a) {
	        return getOpt(a, 'href');
	      });
	    };
	    var processReadonlyEvents = function (editor, e) {
	      if (isClickEvent(e) && !VK.metaKeyPressed(e)) {
	        var elm = SugarElement.fromDom(e.target);
	        getAnchorHrefOpt(editor, elm).each(function (href) {
	          e.preventDefault();
	          if (/^#/.test(href)) {
	            var targetEl = editor.dom.select(href + ',[name="' + removeLeading(href, '#') + '"]');
	            if (targetEl.length) {
	              editor.selection.scrollIntoView(targetEl[0], true);
	            }
	          } else {
	            window.open(href, '_blank', 'rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes');
	          }
	        });
	      }
	    };
	    var registerReadOnlySelectionBlockers = function (editor) {
	      editor.on('ShowCaret', function (e) {
	        if (isReadOnly$1(editor)) {
	          e.preventDefault();
	        }
	      });
	      editor.on('ObjectSelected', function (e) {
	        if (isReadOnly$1(editor)) {
	          e.preventDefault();
	        }
	      });
	    };
	
	    var nativeEvents = Tools.makeMap('focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange ' + 'mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover ' + 'draggesture dragdrop drop drag submit ' + 'compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel', ' ');
	    var EventDispatcher = function () {
	      function EventDispatcher(settings) {
	        this.bindings = {};
	        this.settings = settings || {};
	        this.scope = this.settings.scope || this;
	        this.toggleEvent = this.settings.toggleEvent || never;
	      }
	      EventDispatcher.isNative = function (name) {
	        return !!nativeEvents[name.toLowerCase()];
	      };
	      EventDispatcher.prototype.fire = function (nameIn, argsIn) {
	        var name = nameIn.toLowerCase();
	        var args = argsIn || {};
	        args.type = name;
	        if (!args.target) {
	          args.target = this.scope;
	        }
	        if (!args.preventDefault) {
	          args.preventDefault = function () {
	            args.isDefaultPrevented = always;
	          };
	          args.stopPropagation = function () {
	            args.isPropagationStopped = always;
	          };
	          args.stopImmediatePropagation = function () {
	            args.isImmediatePropagationStopped = always;
	          };
	          args.isDefaultPrevented = never;
	          args.isPropagationStopped = never;
	          args.isImmediatePropagationStopped = never;
	        }
	        if (this.settings.beforeFire) {
	          this.settings.beforeFire(args);
	        }
	        var handlers = this.bindings[name];
	        if (handlers) {
	          for (var i = 0, l = handlers.length; i < l; i++) {
	            var callback = handlers[i];
	            if (callback.once) {
	              this.off(name, callback.func);
	            }
	            if (args.isImmediatePropagationStopped()) {
	              args.stopPropagation();
	              return args;
	            }
	            if (callback.func.call(this.scope, args) === false) {
	              args.preventDefault();
	              return args;
	            }
	          }
	        }
	        return args;
	      };
	      EventDispatcher.prototype.on = function (name, callback, prepend, extra) {
	        if (callback === false) {
	          callback = never;
	        }
	        if (callback) {
	          var wrappedCallback = { func: callback };
	          if (extra) {
	            Tools.extend(wrappedCallback, extra);
	          }
	          var names = name.toLowerCase().split(' ');
	          var i = names.length;
	          while (i--) {
	            var currentName = names[i];
	            var handlers = this.bindings[currentName];
	            if (!handlers) {
	              handlers = this.bindings[currentName] = [];
	              this.toggleEvent(currentName, true);
	            }
	            if (prepend) {
	              handlers.unshift(wrappedCallback);
	            } else {
	              handlers.push(wrappedCallback);
	            }
	          }
	        }
	        return this;
	      };
	      EventDispatcher.prototype.off = function (name, callback) {
	        var _this = this;
	        if (name) {
	          var names = name.toLowerCase().split(' ');
	          var i = names.length;
	          while (i--) {
	            var currentName = names[i];
	            var handlers = this.bindings[currentName];
	            if (!currentName) {
	              each$1(this.bindings, function (_value, bindingName) {
	                _this.toggleEvent(bindingName, false);
	                delete _this.bindings[bindingName];
	              });
	              return this;
	            }
	            if (handlers) {
	              if (!callback) {
	                handlers.length = 0;
	              } else {
	                var hi = handlers.length;
	                while (hi--) {
	                  if (handlers[hi].func === callback) {
	                    handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
	                    this.bindings[currentName] = handlers;
	                  }
	                }
	              }
	              if (!handlers.length) {
	                this.toggleEvent(name, false);
	                delete this.bindings[currentName];
	              }
	            }
	          }
	        } else {
	          each$1(this.bindings, function (_value, name) {
	            _this.toggleEvent(name, false);
	          });
	          this.bindings = {};
	        }
	        return this;
	      };
	      EventDispatcher.prototype.once = function (name, callback, prepend) {
	        return this.on(name, callback, prepend, { once: true });
	      };
	      EventDispatcher.prototype.has = function (name) {
	        name = name.toLowerCase();
	        return !(!this.bindings[name] || this.bindings[name].length === 0);
	      };
	      return EventDispatcher;
	    }();
	
	    var getEventDispatcher = function (obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new EventDispatcher({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (EventDispatcher.isNative(name) && obj.toggleNativeEvent) {
	              obj.toggleNativeEvent(name, state);
	            }
	          }
	        });
	      }
	      return obj._eventDispatcher;
	    };
	    var Observable = {
	      fire: function (name, args, bubble) {
	        var self = this;
	        if (self.removed && name !== 'remove' && name !== 'detach') {
	          return args;
	        }
	        var dispatcherArgs = getEventDispatcher(self).fire(name, args);
	        if (bubble !== false && self.parent) {
	          var parent_1 = self.parent();
	          while (parent_1 && !dispatcherArgs.isPropagationStopped()) {
	            parent_1.fire(name, dispatcherArgs, false);
	            parent_1 = parent_1.parent();
	          }
	        }
	        return dispatcherArgs;
	      },
	      on: function (name, callback, prepend) {
	        return getEventDispatcher(this).on(name, callback, prepend);
	      },
	      off: function (name, callback) {
	        return getEventDispatcher(this).off(name, callback);
	      },
	      once: function (name, callback) {
	        return getEventDispatcher(this).once(name, callback);
	      },
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      }
	    };
	
	    var DOM$8 = DOMUtils.DOM;
	    var customEventRootDelegates;
	    var getEventTarget = function (editor, eventName) {
	      if (eventName === 'selectionchange') {
	        return editor.getDoc();
	      }
	      if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
	        return editor.getDoc().documentElement;
	      }
	      var eventRoot = getEventRoot(editor);
	      if (eventRoot) {
	        if (!editor.eventRoot) {
	          editor.eventRoot = DOM$8.select(eventRoot)[0];
	        }
	        return editor.eventRoot;
	      }
	      return editor.getBody();
	    };
	    var isListening = function (editor) {
	      return !editor.hidden && !isReadOnly$1(editor);
	    };
	    var fireEvent = function (editor, eventName, e) {
	      if (isListening(editor)) {
	        editor.fire(eventName, e);
	      } else if (isReadOnly$1(editor)) {
	        processReadonlyEvents(editor, e);
	      }
	    };
	    var bindEventDelegate = function (editor, eventName) {
	      var delegate;
	      if (!editor.delegates) {
	        editor.delegates = {};
	      }
	      if (editor.delegates[eventName] || editor.removed) {
	        return;
	      }
	      var eventRootElm = getEventTarget(editor, eventName);
	      if (getEventRoot(editor)) {
	        if (!customEventRootDelegates) {
	          customEventRootDelegates = {};
	          editor.editorManager.on('removeEditor', function () {
	            if (!editor.editorManager.activeEditor) {
	              if (customEventRootDelegates) {
	                each$1(customEventRootDelegates, function (_value, name) {
	                  editor.dom.unbind(getEventTarget(editor, name));
	                });
	                customEventRootDelegates = null;
	              }
	            }
	          });
	        }
	        if (customEventRootDelegates[eventName]) {
	          return;
	        }
	        delegate = function (e) {
	          var target = e.target;
	          var editors = editor.editorManager.get();
	          var i = editors.length;
	          while (i--) {
	            var body = editors[i].getBody();
	            if (body === target || DOM$8.isChildOf(target, body)) {
	              fireEvent(editors[i], eventName, e);
	            }
	          }
	        };
	        customEventRootDelegates[eventName] = delegate;
	        DOM$8.bind(eventRootElm, eventName, delegate);
	      } else {
	        delegate = function (e) {
	          fireEvent(editor, eventName, e);
	        };
	        DOM$8.bind(eventRootElm, eventName, delegate);
	        editor.delegates[eventName] = delegate;
	      }
	    };
	    var EditorObservable = __assign(__assign({}, Observable), {
	      bindPendingEventDelegates: function () {
	        var self = this;
	        Tools.each(self._pendingNativeEvents, function (name) {
	          bindEventDelegate(self, name);
	        });
	      },
	      toggleNativeEvent: function (name, state) {
	        var self = this;
	        if (name === 'focus' || name === 'blur') {
	          return;
	        }
	        if (state) {
	          if (self.initialized) {
	            bindEventDelegate(self, name);
	          } else {
	            if (!self._pendingNativeEvents) {
	              self._pendingNativeEvents = [name];
	            } else {
	              self._pendingNativeEvents.push(name);
	            }
	          }
	        } else if (self.initialized) {
	          self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          delete self.delegates[name];
	        }
	      },
	      unbindAllNativeEvents: function () {
	        var self = this;
	        var body = self.getBody();
	        var dom = self.dom;
	        if (self.delegates) {
	          each$1(self.delegates, function (value, name) {
	            self.dom.unbind(getEventTarget(self, name), name, value);
	          });
	          delete self.delegates;
	        }
	        if (!self.inline && body && dom) {
	          body.onload = null;
	          dom.unbind(self.getWin());
	          dom.unbind(self.getDoc());
	        }
	        if (dom) {
	          dom.unbind(body);
	          dom.unbind(self.getContainer());
	        }
	      }
	    });
	
	    var defaultModes = [
	      'design',
	      'readonly'
	    ];
	    var switchToMode = function (editor, activeMode, availableModes, mode) {
	      var oldMode = availableModes[activeMode.get()];
	      var newMode = availableModes[mode];
	      try {
	        newMode.activate();
	      } catch (e) {
	        console.error('problem while activating editor mode ' + mode + ':', e);
	        return;
	      }
	      oldMode.deactivate();
	      if (oldMode.editorReadOnly !== newMode.editorReadOnly) {
	        toggleReadOnly(editor, newMode.editorReadOnly);
	      }
	      activeMode.set(mode);
	      fireSwitchMode(editor, mode);
	    };
	    var setMode = function (editor, availableModes, activeMode, mode) {
	      if (mode === activeMode.get()) {
	        return;
	      } else if (!has(availableModes, mode)) {
	        throw new Error('Editor mode \'' + mode + '\' is invalid');
	      }
	      if (editor.initialized) {
	        switchToMode(editor, activeMode, availableModes, mode);
	      } else {
	        editor.on('init', function () {
	          return switchToMode(editor, activeMode, availableModes, mode);
	        });
	      }
	    };
	    var registerMode = function (availableModes, mode, api) {
	      var _a;
	      if (contains(defaultModes, mode)) {
	        throw new Error('Cannot override default mode ' + mode);
	      }
	      return __assign(__assign({}, availableModes), (_a = {}, _a[mode] = __assign(__assign({}, api), {
	        deactivate: function () {
	          try {
	            api.deactivate();
	          } catch (e) {
	            console.error('problem while deactivating editor mode ' + mode + ':', e);
	          }
	        }
	      }), _a));
	    };
	
	    var create$5 = function (editor) {
	      var activeMode = Cell('design');
	      var availableModes = Cell({
	        design: {
	          activate: noop,
	          deactivate: noop,
	          editorReadOnly: false
	        },
	        readonly: {
	          activate: noop,
	          deactivate: noop,
	          editorReadOnly: true
	        }
	      });
	      registerReadOnlyContentFilters(editor);
	      registerReadOnlySelectionBlockers(editor);
	      return {
	        isReadOnly: function () {
	          return isReadOnly$1(editor);
	        },
	        set: function (mode) {
	          return setMode(editor, availableModes.get(), activeMode, mode);
	        },
	        get: function () {
	          return activeMode.get();
	        },
	        register: function (mode, api) {
	          availableModes.set(registerMode(availableModes.get(), mode, api));
	        }
	      };
	    };
	
	    var each$g = Tools.each, explode$3 = Tools.explode;
	    var keyCodeLookup = {
	      f1: 112,
	      f2: 113,
	      f3: 114,
	      f4: 115,
	      f5: 116,
	      f6: 117,
	      f7: 118,
	      f8: 119,
	      f9: 120,
	      f10: 121,
	      f11: 122,
	      f12: 123
	    };
	    var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
	    var parseShortcut = function (pattern) {
	      var key;
	      var shortcut = {};
	      each$g(explode$3(pattern.toLowerCase(), '+'), function (value) {
	        if (value in modifierNames) {
	          shortcut[value] = true;
	        } else {
	          if (/^[0-9]{2,}$/.test(value)) {
	            shortcut.keyCode = parseInt(value, 10);
	          } else {
	            shortcut.charCode = value.charCodeAt(0);
	            shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
	          }
	        }
	      });
	      var id = [shortcut.keyCode];
	      for (key in modifierNames) {
	        if (shortcut[key]) {
	          id.push(key);
	        } else {
	          shortcut[key] = false;
	        }
	      }
	      shortcut.id = id.join(',');
	      if (shortcut.access) {
	        shortcut.alt = true;
	        if (Env.mac) {
	          shortcut.ctrl = true;
	        } else {
	          shortcut.shift = true;
	        }
	      }
	      if (shortcut.meta) {
	        if (Env.mac) {
	          shortcut.meta = true;
	        } else {
	          shortcut.ctrl = true;
	          shortcut.meta = false;
	        }
	      }
	      return shortcut;
	    };
	    var Shortcuts = function () {
	      function Shortcuts(editor) {
	        this.shortcuts = {};
	        this.pendingPatterns = [];
	        this.editor = editor;
	        var self = this;
	        editor.on('keyup keypress keydown', function (e) {
	          if ((self.hasModifier(e) || self.isFunctionKey(e)) && !e.isDefaultPrevented()) {
	            each$g(self.shortcuts, function (shortcut) {
	              if (self.matchShortcut(e, shortcut)) {
	                self.pendingPatterns = shortcut.subpatterns.slice(0);
	                if (e.type === 'keydown') {
	                  self.executeShortcutAction(shortcut);
	                }
	                return true;
	              }
	            });
	            if (self.matchShortcut(e, self.pendingPatterns[0])) {
	              if (self.pendingPatterns.length === 1) {
	                if (e.type === 'keydown') {
	                  self.executeShortcutAction(self.pendingPatterns[0]);
	                }
	              }
	              self.pendingPatterns.shift();
	            }
	          }
	        });
	      }
	      Shortcuts.prototype.add = function (pattern, desc, cmdFunc, scope) {
	        var self = this;
	        var func = self.normalizeCommandFunc(cmdFunc);
	        each$g(explode$3(Tools.trim(pattern)), function (pattern) {
	          var shortcut = self.createShortcut(pattern, desc, func, scope);
	          self.shortcuts[shortcut.id] = shortcut;
	        });
	        return true;
	      };
	      Shortcuts.prototype.remove = function (pattern) {
	        var shortcut = this.createShortcut(pattern);
	        if (this.shortcuts[shortcut.id]) {
	          delete this.shortcuts[shortcut.id];
	          return true;
	        }
	        return false;
	      };
	      Shortcuts.prototype.normalizeCommandFunc = function (cmdFunc) {
	        var self = this;
	        var cmd = cmdFunc;
	        if (typeof cmd === 'string') {
	          return function () {
	            self.editor.execCommand(cmd, false, null);
	          };
	        } else if (Tools.isArray(cmd)) {
	          return function () {
	            self.editor.execCommand(cmd[0], cmd[1], cmd[2]);
	          };
	        } else {
	          return cmd;
	        }
	      };
	      Shortcuts.prototype.createShortcut = function (pattern, desc, cmdFunc, scope) {
	        var shortcuts = Tools.map(explode$3(pattern, '>'), parseShortcut);
	        shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
	          func: cmdFunc,
	          scope: scope || this.editor
	        });
	        return Tools.extend(shortcuts[0], {
	          desc: this.editor.translate(desc),
	          subpatterns: shortcuts.slice(1)
	        });
	      };
	      Shortcuts.prototype.hasModifier = function (e) {
	        return e.altKey || e.ctrlKey || e.metaKey;
	      };
	      Shortcuts.prototype.isFunctionKey = function (e) {
	        return e.type === 'keydown' && e.keyCode >= 112 && e.keyCode <= 123;
	      };
	      Shortcuts.prototype.matchShortcut = function (e, shortcut) {
	        if (!shortcut) {
	          return false;
	        }
	        if (shortcut.ctrl !== e.ctrlKey || shortcut.meta !== e.metaKey) {
	          return false;
	        }
	        if (shortcut.alt !== e.altKey || shortcut.shift !== e.shiftKey) {
	          return false;
	        }
	        if (e.keyCode === shortcut.keyCode || e.charCode && e.charCode === shortcut.charCode) {
	          e.preventDefault();
	          return true;
	        }
	        return false;
	      };
	      Shortcuts.prototype.executeShortcutAction = function (shortcut) {
	        return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
	      };
	      return Shortcuts;
	    }();
	
	    var create$6 = function () {
	      var buttons = {};
	      var menuItems = {};
	      var popups = {};
	      var icons = {};
	      var contextMenus = {};
	      var contextToolbars = {};
	      var sidebars = {};
	      var add = function (collection, type) {
	        return function (name, spec) {
	          return collection[name.toLowerCase()] = __assign(__assign({}, spec), { type: type });
	        };
	      };
	      var addIcon = function (name, svgData) {
	        return icons[name.toLowerCase()] = svgData;
	      };
	      return {
	        addButton: add(buttons, 'button'),
	        addGroupToolbarButton: add(buttons, 'grouptoolbarbutton'),
	        addToggleButton: add(buttons, 'togglebutton'),
	        addMenuButton: add(buttons, 'menubutton'),
	        addSplitButton: add(buttons, 'splitbutton'),
	        addMenuItem: add(menuItems, 'menuitem'),
	        addNestedMenuItem: add(menuItems, 'nestedmenuitem'),
	        addToggleMenuItem: add(menuItems, 'togglemenuitem'),
	        addAutocompleter: add(popups, 'autocompleter'),
	        addContextMenu: add(contextMenus, 'contextmenu'),
	        addContextToolbar: add(contextToolbars, 'contexttoolbar'),
	        addContextForm: add(contextToolbars, 'contextform'),
	        addSidebar: add(sidebars, 'sidebar'),
	        addIcon: addIcon,
	        getAll: function () {
	          return {
	            buttons: buttons,
	            menuItems: menuItems,
	            icons: icons,
	            popups: popups,
	            contextMenus: contextMenus,
	            contextToolbars: contextToolbars,
	            sidebars: sidebars
	          };
	        }
	      };
	    };
	
	    var registry = function () {
	      var bridge = create$6();
	      return {
	        addAutocompleter: bridge.addAutocompleter,
	        addButton: bridge.addButton,
	        addContextForm: bridge.addContextForm,
	        addContextMenu: bridge.addContextMenu,
	        addContextToolbar: bridge.addContextToolbar,
	        addIcon: bridge.addIcon,
	        addMenuButton: bridge.addMenuButton,
	        addMenuItem: bridge.addMenuItem,
	        addNestedMenuItem: bridge.addNestedMenuItem,
	        addSidebar: bridge.addSidebar,
	        addSplitButton: bridge.addSplitButton,
	        addToggleButton: bridge.addToggleButton,
	        addGroupToolbarButton: bridge.addGroupToolbarButton,
	        addToggleMenuItem: bridge.addToggleMenuItem,
	        getAll: bridge.getAll
	      };
	    };
	
	    var each$h = Tools.each, trim$4 = Tools.trim;
	    var queryParts = 'source protocol authority userInfo user password host port relative path directory file query anchor'.split(' ');
	    var DEFAULT_PORTS = {
	      ftp: 21,
	      http: 80,
	      https: 443,
	      mailto: 25
	    };
	    var URI = function () {
	      function URI(url, settings) {
	        url = trim$4(url);
	        this.settings = settings || {};
	        var baseUri = this.settings.base_uri;
	        var self = this;
	        if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
	          self.source = url;
	          return;
	        }
	        var isProtocolRelative = url.indexOf('//') === 0;
	        if (url.indexOf('/') === 0 && !isProtocolRelative) {
	          url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
	        }
	        if (!/^[\w\-]*:?\/\//.test(url)) {
	          var baseUrl = this.settings.base_uri ? this.settings.base_uri.path : new URI(document.location.href).directory;
	          if (this.settings.base_uri && this.settings.base_uri.protocol == '') {
	            url = '//mce_host' + self.toAbsPath(baseUrl, url);
	          } else {
	            var match = /([^#?]*)([#?]?.*)/.exec(url);
	            url = (baseUri && baseUri.protocol || 'http') + '://mce_host' + self.toAbsPath(baseUrl, match[1]) + match[2];
	          }
	        }
	        url = url.replace(/@@/g, '(mce_at)');
	        var urlMatch = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
	        each$h(queryParts, function (v, i) {
	          var part = urlMatch[i];
	          if (part) {
	            part = part.replace(/\(mce_at\)/g, '@@');
	          }
	          self[v] = part;
	        });
	        if (baseUri) {
	          if (!self.protocol) {
	            self.protocol = baseUri.protocol;
	          }
	          if (!self.userInfo) {
	            self.userInfo = baseUri.userInfo;
	          }
	          if (!self.port && self.host === 'mce_host') {
	            self.port = baseUri.port;
	          }
	          if (!self.host || self.host === 'mce_host') {
	            self.host = baseUri.host;
	          }
	          self.source = '';
	        }
	        if (isProtocolRelative) {
	          self.protocol = '';
	        }
	      }
	      URI.parseDataUri = function (uri) {
	        var type;
	        var uriComponents = decodeURIComponent(uri).split(',');
	        var matches = /data:([^;]+)/.exec(uriComponents[0]);
	        if (matches) {
	          type = matches[1];
	        }
	        return {
	          type: type,
	          data: uriComponents[1]
	        };
	      };
	      URI.getDocumentBaseUrl = function (loc) {
	        var baseUrl;
	        if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
	          baseUrl = loc.href;
	        } else {
	          baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
	        }
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
	          baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	          if (!/[\/\\]$/.test(baseUrl)) {
	            baseUrl += '/';
	          }
	        }
	        return baseUrl;
	      };
	      URI.prototype.setPath = function (path) {
	        var pathMatch = /^(.*?)\/?(\w+)?$/.exec(path);
	        this.path = pathMatch[0];
	        this.directory = pathMatch[1];
	        this.file = pathMatch[2];
	        this.source = '';
	        this.getURI();
	      };
	      URI.prototype.toRelative = function (uri) {
	        var output;
	        if (uri === './') {
	          return uri;
	        }
	        var relativeUri = new URI(uri, { base_uri: this });
	        if (relativeUri.host !== 'mce_host' && this.host !== relativeUri.host && relativeUri.host || this.port !== relativeUri.port || this.protocol !== relativeUri.protocol && relativeUri.protocol !== '') {
	          return relativeUri.getURI();
	        }
	        var tu = this.getURI(), uu = relativeUri.getURI();
	        if (tu === uu || tu.charAt(tu.length - 1) === '/' && tu.substr(0, tu.length - 1) === uu) {
	          return tu;
	        }
	        output = this.toRelPath(this.path, relativeUri.path);
	        if (relativeUri.query) {
	          output += '?' + relativeUri.query;
	        }
	        if (relativeUri.anchor) {
	          output += '#' + relativeUri.anchor;
	        }
	        return output;
	      };
	      URI.prototype.toAbsolute = function (uri, noHost) {
	        var absoluteUri = new URI(uri, { base_uri: this });
	        return absoluteUri.getURI(noHost && this.isSameOrigin(absoluteUri));
	      };
	      URI.prototype.isSameOrigin = function (uri) {
	        if (this.host == uri.host && this.protocol == uri.protocol) {
	          if (this.port == uri.port) {
	            return true;
	          }
	          var defaultPort = DEFAULT_PORTS[this.protocol];
	          if (defaultPort && (this.port || defaultPort) == (uri.port || defaultPort)) {
	            return true;
	          }
	        }
	        return false;
	      };
	      URI.prototype.toRelPath = function (base, path) {
	        var breakPoint = 0, out = '', i, l;
	        var normalizedBase = base.substring(0, base.lastIndexOf('/')).split('/');
	        var items = path.split('/');
	        if (normalizedBase.length >= items.length) {
	          for (i = 0, l = normalizedBase.length; i < l; i++) {
	            if (i >= items.length || normalizedBase[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (normalizedBase.length < items.length) {
	          for (i = 0, l = items.length; i < l; i++) {
	            if (i >= normalizedBase.length || normalizedBase[i] !== items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	        if (breakPoint === 1) {
	          return path;
	        }
	        for (i = 0, l = normalizedBase.length - (breakPoint - 1); i < l; i++) {
	          out += '../';
	        }
	        for (i = breakPoint - 1, l = items.length; i < l; i++) {
	          if (i !== breakPoint - 1) {
	            out += '/' + items[i];
	          } else {
	            out += items[i];
	          }
	        }
	        return out;
	      };
	      URI.prototype.toAbsPath = function (base, path) {
	        var i, nb = 0, o = [], outPath;
	        var tr = /\/$/.test(path) ? '/' : '';
	        var normalizedBase = base.split('/');
	        var normalizedPath = path.split('/');
	        each$h(normalizedBase, function (k) {
	          if (k) {
	            o.push(k);
	          }
	        });
	        normalizedBase = o;
	        for (i = normalizedPath.length - 1, o = []; i >= 0; i--) {
	          if (normalizedPath[i].length === 0 || normalizedPath[i] === '.') {
	            continue;
	          }
	          if (normalizedPath[i] === '..') {
	            nb++;
	            continue;
	          }
	          if (nb > 0) {
	            nb--;
	            continue;
	          }
	          o.push(normalizedPath[i]);
	        }
	        i = normalizedBase.length - nb;
	        if (i <= 0) {
	          outPath = reverse(o).join('/');
	        } else {
	          outPath = normalizedBase.slice(0, i).join('/') + '/' + reverse(o).join('/');
	        }
	        if (outPath.indexOf('/') !== 0) {
	          outPath = '/' + outPath;
	        }
	        if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
	          outPath += tr;
	        }
	        return outPath;
	      };
	      URI.prototype.getURI = function (noProtoHost) {
	        if (noProtoHost === void 0) {
	          noProtoHost = false;
	        }
	        var s;
	        if (!this.source || noProtoHost) {
	          s = '';
	          if (!noProtoHost) {
	            if (this.protocol) {
	              s += this.protocol + '://';
	            } else {
	              s += '//';
	            }
	            if (this.userInfo) {
	              s += this.userInfo + '@';
	            }
	            if (this.host) {
	              s += this.host;
	            }
	            if (this.port) {
	              s += ':' + this.port;
	            }
	          }
	          if (this.path) {
	            s += this.path;
	          }
	          if (this.query) {
	            s += '?' + this.query;
	          }
	          if (this.anchor) {
	            s += '#' + this.anchor;
	          }
	          this.source = s;
	        }
	        return this.source;
	      };
	      return URI;
	    }();
	
	    var DOM$9 = DOMUtils.DOM;
	    var extend$3 = Tools.extend, each$i = Tools.each;
	    var resolve$3 = Tools.resolve;
	    var ie$1 = Env.ie;
	    var Editor = function () {
	      function Editor(id, settings, editorManager) {
	        var _this = this;
	        this.plugins = {};
	        this.contentCSS = [];
	        this.contentStyles = [];
	        this.loadedCSS = {};
	        this.isNotDirty = false;
	        this.editorManager = editorManager;
	        this.documentBaseUrl = editorManager.documentBaseURL;
	        extend$3(this, EditorObservable);
	        this.settings = getEditorSettings(this, id, this.documentBaseUrl, editorManager.defaultSettings, settings);
	        if (this.settings.suffix) {
	          editorManager.suffix = this.settings.suffix;
	        }
	        this.suffix = editorManager.suffix;
	        if (this.settings.base_url) {
	          editorManager._setBaseUrl(this.settings.base_url);
	        }
	        this.baseUri = editorManager.baseURI;
	        if (this.settings.referrer_policy) {
	          ScriptLoader.ScriptLoader._setReferrerPolicy(this.settings.referrer_policy);
	          DOMUtils.DOM.styleSheetLoader._setReferrerPolicy(this.settings.referrer_policy);
	        }
	        AddOnManager.languageLoad = this.settings.language_load;
	        AddOnManager.baseURL = editorManager.baseURL;
	        this.id = id;
	        this.setDirty(false);
	        this.documentBaseURI = new URI(this.settings.document_base_url, { base_uri: this.baseUri });
	        this.baseURI = this.baseUri;
	        this.inline = !!this.settings.inline;
	        this.shortcuts = new Shortcuts(this);
	        this.editorCommands = new EditorCommands(this);
	        if (this.settings.cache_suffix) {
	          Env.cacheSuffix = this.settings.cache_suffix.replace(/^[\?\&]+/, '');
	        }
	        this.ui = {
	          registry: registry(),
	          styleSheetLoader: undefined,
	          show: noop,
	          hide: noop,
	          enable: noop,
	          disable: noop,
	          isDisabled: never
	        };
	        var self = this;
	        var modeInstance = create$5(self);
	        this.mode = modeInstance;
	        this.setMode = modeInstance.set;
	        editorManager.fire('SetupEditor', { editor: this });
	        this.execCallback('setup', this);
	        this.$ = DomQuery.overrideDefaults(function () {
	          return {
	            context: _this.inline ? _this.getBody() : _this.getDoc(),
	            element: _this.getBody()
	          };
	        });
	      }
	      Editor.prototype.render = function () {
	        render(this);
	      };
	      Editor.prototype.focus = function (skipFocus) {
	        focus$1(this, skipFocus);
	      };
	      Editor.prototype.hasFocus = function () {
	        return hasFocus$1(this);
	      };
	      Editor.prototype.execCallback = function (name) {
	        var x = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	          x[_i - 1] = arguments[_i];
	        }
	        var self = this;
	        var callback = self.settings[name], scope;
	        if (!callback) {
	          return;
	        }
	        if (self.callbackLookup && (scope = self.callbackLookup[name])) {
	          callback = scope.func;
	          scope = scope.scope;
	        }
	        if (typeof callback === 'string') {
	          scope = callback.replace(/\.\w+$/, '');
	          scope = scope ? resolve$3(scope) : 0;
	          callback = resolve$3(callback);
	          self.callbackLookup = self.callbackLookup || {};
	          self.callbackLookup[name] = {
	            func: callback,
	            scope: scope
	          };
	        }
	        return callback.apply(scope || self, x);
	      };
	      Editor.prototype.translate = function (text) {
	        return I18n.translate(text);
	      };
	      Editor.prototype.getParam = function (name, defaultVal, type) {
	        return getParam(this, name, defaultVal, type);
	      };
	      Editor.prototype.hasPlugin = function (name, loaded) {
	        var hasPlugin = contains(getPlugins(this).split(/[ ,]/), name);
	        if (hasPlugin) {
	          return loaded ? PluginManager.get(name) !== undefined : true;
	        } else {
	          return false;
	        }
	      };
	      Editor.prototype.nodeChanged = function (args) {
	        this._nodeChangeDispatcher.nodeChanged(args);
	      };
	      Editor.prototype.addCommand = function (name, callback, scope) {
	        this.editorCommands.addCommand(name, callback, scope);
	      };
	      Editor.prototype.addQueryStateHandler = function (name, callback, scope) {
	        this.editorCommands.addQueryStateHandler(name, callback, scope);
	      };
	      Editor.prototype.addQueryValueHandler = function (name, callback, scope) {
	        this.editorCommands.addQueryValueHandler(name, callback, scope);
	      };
	      Editor.prototype.addShortcut = function (pattern, desc, cmdFunc, scope) {
	        this.shortcuts.add(pattern, desc, cmdFunc, scope);
	      };
	      Editor.prototype.execCommand = function (cmd, ui, value, args) {
	        return this.editorCommands.execCommand(cmd, ui, value, args);
	      };
	      Editor.prototype.queryCommandState = function (cmd) {
	        return this.editorCommands.queryCommandState(cmd);
	      };
	      Editor.prototype.queryCommandValue = function (cmd) {
	        return this.editorCommands.queryCommandValue(cmd);
	      };
	      Editor.prototype.queryCommandSupported = function (cmd) {
	        return this.editorCommands.queryCommandSupported(cmd);
	      };
	      Editor.prototype.show = function () {
	        var self = this;
	        if (self.hidden) {
	          self.hidden = false;
	          if (self.inline) {
	            self.getBody().contentEditable = 'true';
	          } else {
	            DOM$9.show(self.getContainer());
	            DOM$9.hide(self.id);
	          }
	          self.load();
	          self.fire('show');
	        }
	      };
	      Editor.prototype.hide = function () {
	        var self = this, doc = self.getDoc();
	        if (!self.hidden) {
	          if (ie$1 && doc && !self.inline) {
	            doc.execCommand('SelectAll');
	          }
	          self.save();
	          if (self.inline) {
	            self.getBody().contentEditable = 'false';
	            if (self === self.editorManager.focusedEditor) {
	              self.editorManager.focusedEditor = null;
	            }
	          } else {
	            DOM$9.hide(self.getContainer());
	            DOM$9.setStyle(self.id, 'display', self.orgDisplay);
	          }
	          self.hidden = true;
	          self.fire('hide');
	        }
	      };
	      Editor.prototype.isHidden = function () {
	        return !!this.hidden;
	      };
	      Editor.prototype.setProgressState = function (state, time) {
	        this.fire('ProgressState', {
	          state: state,
	          time: time
	        });
	      };
	      Editor.prototype.load = function (args) {
	        var self = this;
	        var elm = self.getElement(), html;
	        if (self.removed) {
	          return '';
	        }
	        if (elm) {
	          args = args || {};
	          args.load = true;
	          var value = isTextareaOrInput(elm) ? elm.value : elm.innerHTML;
	          html = self.setContent(value, args);
	          args.element = elm;
	          if (!args.no_events) {
	            self.fire('LoadContent', args);
	          }
	          args.element = elm = null;
	          return html;
	        }
	      };
	      Editor.prototype.save = function (args) {
	        var self = this;
	        var elm = self.getElement(), html, form;
	        if (!elm || !self.initialized || self.removed) {
	          return;
	        }
	        args = args || {};
	        args.save = true;
	        args.element = elm;
	        html = args.content = self.getContent(args);
	        if (!args.no_events) {
	          self.fire('SaveContent', args);
	        }
	        if (args.format === 'raw') {
	          self.fire('RawSaveContent', args);
	        }
	        html = args.content;
	        if (!isTextareaOrInput(elm)) {
	          if (args.is_removing || !self.inline) {
	            elm.innerHTML = html;
	          }
	          if (form = DOM$9.getParent(self.id, 'form')) {
	            each$i(form.elements, function (elm) {
	              if (elm.name === self.id) {
	                elm.value = html;
	                return false;
	              }
	            });
	          }
	        } else {
	          elm.value = html;
	        }
	        args.element = elm = null;
	        if (args.set_dirty !== false) {
	          self.setDirty(false);
	        }
	        return html;
	      };
	      Editor.prototype.setContent = function (content, args) {
	        return setContent$2(this, content, args);
	      };
	      Editor.prototype.getContent = function (args) {
	        return getContent$2(this, args);
	      };
	      Editor.prototype.insertContent = function (content, args) {
	        if (args) {
	          content = extend$3({ content: content }, args);
	        }
	        this.execCommand('mceInsertContent', false, content);
	      };
	      Editor.prototype.resetContent = function (initialContent) {
	        if (initialContent === undefined) {
	          setContent$2(this, this.startContent, { format: 'raw' });
	        } else {
	          setContent$2(this, initialContent);
	        }
	        this.undoManager.reset();
	        this.setDirty(false);
	        this.nodeChanged();
	      };
	      Editor.prototype.isDirty = function () {
	        return !this.isNotDirty;
	      };
	      Editor.prototype.setDirty = function (state) {
	        var oldState = !this.isNotDirty;
	        this.isNotDirty = !state;
	        if (state && state !== oldState) {
	          this.fire('dirty');
	        }
	      };
	      Editor.prototype.getContainer = function () {
	        var self = this;
	        if (!self.container) {
	          self.container = DOM$9.get(self.editorContainer || self.id + '_parent');
	        }
	        return self.container;
	      };
	      Editor.prototype.getContentAreaContainer = function () {
	        return this.contentAreaContainer;
	      };
	      Editor.prototype.getElement = function () {
	        if (!this.targetElm) {
	          this.targetElm = DOM$9.get(this.id);
	        }
	        return this.targetElm;
	      };
	      Editor.prototype.getWin = function () {
	        var self = this;
	        var elm;
	        if (!self.contentWindow) {
	          elm = self.iframeElement;
	          if (elm) {
	            self.contentWindow = elm.contentWindow;
	          }
	        }
	        return self.contentWindow;
	      };
	      Editor.prototype.getDoc = function () {
	        var self = this;
	        var win;
	        if (!self.contentDocument) {
	          win = self.getWin();
	          if (win) {
	            self.contentDocument = win.document;
	          }
	        }
	        return self.contentDocument;
	      };
	      Editor.prototype.getBody = function () {
	        var doc = this.getDoc();
	        return this.bodyElement || (doc ? doc.body : null);
	      };
	      Editor.prototype.convertURL = function (url, name, elm) {
	        var self = this, settings = self.settings;
	        if (settings.urlconverter_callback) {
	          return self.execCallback('urlconverter_callback', url, elm, true, name);
	        }
	        if (!settings.convert_urls || elm && elm.nodeName === 'LINK' || url.indexOf('file:') === 0 || url.length === 0) {
	          return url;
	        }
	        if (settings.relative_urls) {
	          return self.documentBaseURI.toRelative(url);
	        }
	        url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
	        return url;
	      };
	      Editor.prototype.addVisual = function (elm) {
	        addVisual$1(this, elm);
	      };
	      Editor.prototype.remove = function () {
	        remove$7(this);
	      };
	      Editor.prototype.destroy = function (automatic) {
	        destroy(this, automatic);
	      };
	      Editor.prototype.uploadImages = function (callback) {
	        return this.editorUpload.uploadImages(callback);
	      };
	      Editor.prototype._scanForImages = function () {
	        return this.editorUpload.scanForImages();
	      };
	      Editor.prototype.addButton = function () {
	        throw new Error('editor.addButton has been removed in tinymce 5x, use editor.ui.registry.addButton or editor.ui.registry.addToggleButton or editor.ui.registry.addSplitButton instead');
	      };
	      Editor.prototype.addSidebar = function () {
	        throw new Error('editor.addSidebar has been removed in tinymce 5x, use editor.ui.registry.addSidebar instead');
	      };
	      Editor.prototype.addMenuItem = function () {
	        throw new Error('editor.addMenuItem has been removed in tinymce 5x, use editor.ui.registry.addMenuItem instead');
	      };
	      Editor.prototype.addContextToolbar = function () {
	        throw new Error('editor.addContextToolbar has been removed in tinymce 5x, use editor.ui.registry.addContextToolbar instead');
	      };
	      return Editor;
	    }();
	
	    var DOM$a = DOMUtils.DOM;
	    var explode$4 = Tools.explode, each$j = Tools.each, extend$4 = Tools.extend;
	    var instanceCounter = 0, boundGlobalEvents = false;
	    var beforeUnloadDelegate;
	    var legacyEditors = [];
	    var editors = [];
	    var isValidLegacyKey = function (id) {
	      return id !== 'length';
	    };
	    var globalEventDelegate = function (e) {
	      var type = e.type;
	      each$j(EditorManager.get(), function (editor) {
	        switch (type) {
	        case 'scroll':
	          editor.fire('ScrollWindow', e);
	          break;
	        case 'resize':
	          editor.fire('ResizeWindow', e);
	          break;
	        }
	      });
	    };
	    var toggleGlobalEvents = function (state) {
	      if (state !== boundGlobalEvents) {
	        if (state) {
	          DomQuery(window).on('resize scroll', globalEventDelegate);
	        } else {
	          DomQuery(window).off('resize scroll', globalEventDelegate);
	        }
	        boundGlobalEvents = state;
	      }
	    };
	    var removeEditorFromList = function (targetEditor) {
	      var oldEditors = editors;
	      delete legacyEditors[targetEditor.id];
	      for (var i = 0; i < legacyEditors.length; i++) {
	        if (legacyEditors[i] === targetEditor) {
	          legacyEditors.splice(i, 1);
	          break;
	        }
	      }
	      editors = filter(editors, function (editor) {
	        return targetEditor !== editor;
	      });
	      if (EditorManager.activeEditor === targetEditor) {
	        EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
	      }
	      if (EditorManager.focusedEditor === targetEditor) {
	        EditorManager.focusedEditor = null;
	      }
	      return oldEditors.length !== editors.length;
	    };
	    var purgeDestroyedEditor = function (editor) {
	      if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
	        removeEditorFromList(editor);
	        editor.unbindAllNativeEvents();
	        editor.destroy(true);
	        editor.removed = true;
	        editor = null;
	      }
	      return editor;
	    };
	    var isQuirksMode = document.compatMode !== 'CSS1Compat';
	    var EditorManager = __assign(__assign({}, Observable), {
	      baseURI: null,
	      baseURL: null,
	      defaultSettings: {},
	      documentBaseURL: null,
	      suffix: null,
	      $: DomQuery,
	      majorVersion: '5',
	      minorVersion: '8.0',
	      releaseDate: '2021-05-06',
	      editors: legacyEditors,
	      i18n: I18n,
	      activeEditor: null,
	      focusedEditor: null,
	      settings: {},
	      setup: function () {
	        var self = this;
	        var baseURL, documentBaseURL, suffix = '';
	        documentBaseURL = URI.getDocumentBaseUrl(document.location);
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
	          documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	          if (!/[\/\\]$/.test(documentBaseURL)) {
	            documentBaseURL += '/';
	          }
	        }
	        var preInit = window.tinymce || window.tinyMCEPreInit;
	        if (preInit) {
	          baseURL = preInit.base || preInit.baseURL;
	          suffix = preInit.suffix;
	        } else {
	          var scripts = document.getElementsByTagName('script');
	          for (var i = 0; i < scripts.length; i++) {
	            var src = scripts[i].src || '';
	            if (src === '') {
	              continue;
	            }
	            var srcScript = src.substring(src.lastIndexOf('/'));
	            if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
	              if (srcScript.indexOf('.min') !== -1) {
	                suffix = '.min';
	              }
	              baseURL = src.substring(0, src.lastIndexOf('/'));
	              break;
	            }
	          }
	          if (!baseURL && document.currentScript) {
	            var src = document.currentScript.src;
	            if (src.indexOf('.min') !== -1) {
	              suffix = '.min';
	            }
	            baseURL = src.substring(0, src.lastIndexOf('/'));
	          }
	        }
	        self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
	        self.documentBaseURL = documentBaseURL;
	        self.baseURI = new URI(self.baseURL);
	        self.suffix = suffix;
	        setup$2(self);
	      },
	      overrideDefaults: function (defaultSettings) {
	        var baseUrl = defaultSettings.base_url;
	        if (baseUrl) {
	          this._setBaseUrl(baseUrl);
	        }
	        var suffix = defaultSettings.suffix;
	        if (defaultSettings.suffix) {
	          this.suffix = suffix;
	        }
	        this.defaultSettings = defaultSettings;
	        var pluginBaseUrls = defaultSettings.plugin_base_urls;
	        if (pluginBaseUrls !== undefined) {
	          each$1(pluginBaseUrls, function (pluginBaseUrl, pluginName) {
	            AddOnManager.PluginManager.urls[pluginName] = pluginBaseUrl;
	          });
	        }
	      },
	      init: function (settings) {
	        var self = this;
	        var result;
	        var invalidInlineTargets = Tools.makeMap('area base basefont br col frame hr img input isindex link meta param embed source wbr track ' + 'colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu', ' ');
	        var isInvalidInlineTarget = function (settings, elm) {
	          return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
	        };
	        var createId = function (elm) {
	          var id = elm.id;
	          if (!id) {
	            id = get$1(elm, 'name').filter(function (name) {
	              return !DOM$a.get(name);
	            }).getOrThunk(DOM$a.uniqueId);
	            elm.setAttribute('id', id);
	          }
	          return id;
	        };
	        var execCallback = function (name) {
	          var callback = settings[name];
	          if (!callback) {
	            return;
	          }
	          return callback.apply(self, []);
	        };
	        var hasClass = function (elm, className) {
	          return className.constructor === RegExp ? className.test(elm.className) : DOM$a.hasClass(elm, className);
	        };
	        var findTargets = function (settings) {
	          var targets = [];
	          if (Env.browser.isIE() && Env.browser.version.major < 11) {
	            initError('TinyMCE does not support the browser you are using. For a list of supported' + ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/');
	            return [];
	          } else if (isQuirksMode) {
	            initError('Failed to initialize the editor as the document is not in standards mode. ' + 'TinyMCE requires standards mode.');
	            return [];
	          }
	          if (settings.types) {
	            each$j(settings.types, function (type) {
	              targets = targets.concat(DOM$a.select(type.selector));
	            });
	            return targets;
	          } else if (settings.selector) {
	            return DOM$a.select(settings.selector);
	          } else if (settings.target) {
	            return [settings.target];
	          }
	          switch (settings.mode) {
	          case 'exact':
	            var l = settings.elements || '';
	            if (l.length > 0) {
	              each$j(explode$4(l), function (id) {
	                var elm = DOM$a.get(id);
	                if (elm) {
	                  targets.push(elm);
	                } else {
	                  each$j(document.forms, function (f) {
	                    each$j(f.elements, function (e) {
	                      if (e.name === id) {
	                        id = 'mce_editor_' + instanceCounter++;
	                        DOM$a.setAttrib(e, 'id', id);
	                        targets.push(e);
	                      }
	                    });
	                  });
	                }
	              });
	            }
	            break;
	          case 'textareas':
	          case 'specific_textareas':
	            each$j(DOM$a.select('textarea'), function (elm) {
	              if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
	                return;
	              }
	              if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
	                targets.push(elm);
	              }
	            });
	            break;
	          }
	          return targets;
	        };
	        var provideResults = function (editors) {
	          result = editors;
	        };
	        var initEditors = function () {
	          var initCount = 0;
	          var editors = [];
	          var targets;
	          var createEditor = function (id, settings, targetElm) {
	            var editor = new Editor(id, settings, self);
	            editors.push(editor);
	            editor.on('init', function () {
	              if (++initCount === targets.length) {
	                provideResults(editors);
	              }
	            });
	            editor.targetElm = editor.targetElm || targetElm;
	            editor.render();
	          };
	          DOM$a.unbind(window, 'ready', initEditors);
	          execCallback('onpageload');
	          targets = DomQuery.unique(findTargets(settings));
	          if (settings.types) {
	            each$j(settings.types, function (type) {
	              Tools.each(targets, function (elm) {
	                if (DOM$a.is(elm, type.selector)) {
	                  createEditor(createId(elm), extend$4({}, settings, type), elm);
	                  return false;
	                }
	                return true;
	              });
	            });
	            return;
	          }
	          Tools.each(targets, function (elm) {
	            purgeDestroyedEditor(self.get(elm.id));
	          });
	          targets = Tools.grep(targets, function (elm) {
	            return !self.get(elm.id);
	          });
	          if (targets.length === 0) {
	            provideResults([]);
	          } else {
	            each$j(targets, function (elm) {
	              if (isInvalidInlineTarget(settings, elm)) {
	                initError('Could not initialize inline editor on invalid inline target element', elm);
	              } else {
	                createEditor(createId(elm), settings, elm);
	              }
	            });
	          }
	        };
	        self.settings = settings;
	        DOM$a.bind(window, 'ready', initEditors);
	        return new promiseObj(function (resolve) {
	          if (result) {
	            resolve(result);
	          } else {
	            provideResults = function (editors) {
	              resolve(editors);
	            };
	          }
	        });
	      },
	      get: function (id) {
	        if (arguments.length === 0) {
	          return editors.slice(0);
	        } else if (isString(id)) {
	          return find(editors, function (editor) {
	            return editor.id === id;
	          }).getOr(null);
	        } else if (isNumber(id)) {
	          return editors[id] ? editors[id] : null;
	        } else {
	          return null;
	        }
	      },
	      add: function (editor) {
	        var self = this;
	        var existingEditor = legacyEditors[editor.id];
	        if (existingEditor === editor) {
	          return editor;
	        }
	        if (self.get(editor.id) === null) {
	          if (isValidLegacyKey(editor.id)) {
	            legacyEditors[editor.id] = editor;
	          }
	          legacyEditors.push(editor);
	          editors.push(editor);
	        }
	        toggleGlobalEvents(true);
	        self.activeEditor = editor;
	        self.fire('AddEditor', { editor: editor });
	        if (!beforeUnloadDelegate) {
	          beforeUnloadDelegate = function (e) {
	            var event = self.fire('BeforeUnload');
	            if (event.returnValue) {
	              e.preventDefault();
	              e.returnValue = event.returnValue;
	              return event.returnValue;
	            }
	          };
	          window.addEventListener('beforeunload', beforeUnloadDelegate);
	        }
	        return editor;
	      },
	      createEditor: function (id, settings) {
	        return this.add(new Editor(id, settings, this));
	      },
	      remove: function (selector) {
	        var self = this;
	        var i, editor;
	        if (!selector) {
	          for (i = editors.length - 1; i >= 0; i--) {
	            self.remove(editors[i]);
	          }
	          return;
	        }
	        if (isString(selector)) {
	          each$j(DOM$a.select(selector), function (elm) {
	            editor = self.get(elm.id);
	            if (editor) {
	              self.remove(editor);
	            }
	          });
	          return;
	        }
	        editor = selector;
	        if (isNull(self.get(editor.id))) {
	          return null;
	        }
	        if (removeEditorFromList(editor)) {
	          self.fire('RemoveEditor', { editor: editor });
	        }
	        if (editors.length === 0) {
	          window.removeEventListener('beforeunload', beforeUnloadDelegate);
	        }
	        editor.remove();
	        toggleGlobalEvents(editors.length > 0);
	        return editor;
	      },
	      execCommand: function (cmd, ui, value) {
	        var self = this, editor = self.get(value);
	        switch (cmd) {
	        case 'mceAddEditor':
	          if (!self.get(value)) {
	            new Editor(value, self.settings, self).render();
	          }
	          return true;
	        case 'mceRemoveEditor':
	          if (editor) {
	            editor.remove();
	          }
	          return true;
	        case 'mceToggleEditor':
	          if (!editor) {
	            self.execCommand('mceAddEditor', false, value);
	            return true;
	          }
	          if (editor.isHidden()) {
	            editor.show();
	          } else {
	            editor.hide();
	          }
	          return true;
	        }
	        if (self.activeEditor) {
	          return self.activeEditor.execCommand(cmd, ui, value);
	        }
	        return false;
	      },
	      triggerSave: function () {
	        each$j(editors, function (editor) {
	          editor.save();
	        });
	      },
	      addI18n: function (code, items) {
	        I18n.add(code, items);
	      },
	      translate: function (text) {
	        return I18n.translate(text);
	      },
	      setActive: function (editor) {
	        var activeEditor = this.activeEditor;
	        if (this.activeEditor !== editor) {
	          if (activeEditor) {
	            activeEditor.fire('deactivate', { relatedTarget: editor });
	          }
	          editor.fire('activate', { relatedTarget: activeEditor });
	        }
	        this.activeEditor = editor;
	      },
	      _setBaseUrl: function (baseUrl) {
	        this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
	        this.baseURI = new URI(this.baseURL);
	      }
	    });
	    EditorManager.setup();
	
	    var min = Math.min, max = Math.max, round$1 = Math.round;
	    var relativePosition = function (rect, targetRect, rel) {
	      var x = targetRect.x;
	      var y = targetRect.y;
	      var w = rect.w;
	      var h = rect.h;
	      var targetW = targetRect.w;
	      var targetH = targetRect.h;
	      var relChars = (rel || '').split('');
	      if (relChars[0] === 'b') {
	        y += targetH;
	      }
	      if (relChars[1] === 'r') {
	        x += targetW;
	      }
	      if (relChars[0] === 'c') {
	        y += round$1(targetH / 2);
	      }
	      if (relChars[1] === 'c') {
	        x += round$1(targetW / 2);
	      }
	      if (relChars[3] === 'b') {
	        y -= h;
	      }
	      if (relChars[4] === 'r') {
	        x -= w;
	      }
	      if (relChars[3] === 'c') {
	        y -= round$1(h / 2);
	      }
	      if (relChars[4] === 'c') {
	        x -= round$1(w / 2);
	      }
	      return create$7(x, y, w, h);
	    };
	    var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
	      var pos, i;
	      for (i = 0; i < rels.length; i++) {
	        pos = relativePosition(rect, targetRect, rels[i]);
	        if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x && pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
	          return rels[i];
	        }
	      }
	      return null;
	    };
	    var inflate = function (rect, w, h) {
	      return create$7(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
	    };
	    var intersect = function (rect, cropRect) {
	      var x1 = max(rect.x, cropRect.x);
	      var y1 = max(rect.y, cropRect.y);
	      var x2 = min(rect.x + rect.w, cropRect.x + cropRect.w);
	      var y2 = min(rect.y + rect.h, cropRect.y + cropRect.h);
	      if (x2 - x1 < 0 || y2 - y1 < 0) {
	        return null;
	      }
	      return create$7(x1, y1, x2 - x1, y2 - y1);
	    };
	    var clamp$1 = function (rect, clampRect, fixedSize) {
	      var x1 = rect.x;
	      var y1 = rect.y;
	      var x2 = rect.x + rect.w;
	      var y2 = rect.y + rect.h;
	      var cx2 = clampRect.x + clampRect.w;
	      var cy2 = clampRect.y + clampRect.h;
	      var underflowX1 = max(0, clampRect.x - x1);
	      var underflowY1 = max(0, clampRect.y - y1);
	      var overflowX2 = max(0, x2 - cx2);
	      var overflowY2 = max(0, y2 - cy2);
	      x1 += underflowX1;
	      y1 += underflowY1;
	      if (fixedSize) {
	        x2 += underflowX1;
	        y2 += underflowY1;
	        x1 -= overflowX2;
	        y1 -= overflowY2;
	      }
	      x2 -= overflowX2;
	      y2 -= overflowY2;
	      return create$7(x1, y1, x2 - x1, y2 - y1);
	    };
	    var create$7 = function (x, y, w, h) {
	      return {
	        x: x,
	        y: y,
	        w: w,
	        h: h
	      };
	    };
	    var fromClientRect = function (clientRect) {
	      return create$7(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
	    };
	    var Rect = {
	      inflate: inflate,
	      relativePosition: relativePosition,
	      findBestRelativePosition: findBestRelativePosition,
	      intersect: intersect,
	      clamp: clamp$1,
	      create: create$7,
	      fromClientRect: fromClientRect
	    };
	
	    var awaiter = function (resolveCb, rejectCb, timeout) {
	      if (timeout === void 0) {
	        timeout = 1000;
	      }
	      var done = false;
	      var timer = null;
	      var complete = function (completer) {
	        return function () {
	          var args = [];
	          for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	          }
	          if (!done) {
	            done = true;
	            if (timer !== null) {
	              clearTimeout(timer);
	              timer = null;
	            }
	            completer.apply(null, args);
	          }
	        };
	      };
	      var resolve = complete(resolveCb);
	      var reject = complete(rejectCb);
	      var start = function () {
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	          args[_i] = arguments[_i];
	        }
	        if (!done && timer === null) {
	          timer = setTimeout(function () {
	            return reject.apply(null, args);
	          }, timeout);
	        }
	      };
	      return {
	        start: start,
	        resolve: resolve,
	        reject: reject
	      };
	    };
	    var create$8 = function () {
	      var tasks = {};
	      var resultFns = {};
	      var load = function (id, url) {
	        var loadErrMsg = 'Script at URL "' + url + '" failed to load';
	        var runErrMsg = 'Script at URL "' + url + '" did not call `tinymce.Resource.add(\'' + id + '\', data)` within 1 second';
	        if (tasks[id] !== undefined) {
	          return tasks[id];
	        } else {
	          var task = new promiseObj(function (resolve, reject) {
	            var waiter = awaiter(resolve, reject);
	            resultFns[id] = waiter.resolve;
	            ScriptLoader.ScriptLoader.loadScript(url, function () {
	              return waiter.start(runErrMsg);
	            }, function () {
	              return waiter.reject(loadErrMsg);
	            });
	          });
	          tasks[id] = task;
	          return task;
	        }
	      };
	      var add = function (id, data) {
	        if (resultFns[id] !== undefined) {
	          resultFns[id](data);
	          delete resultFns[id];
	        }
	        tasks[id] = promiseObj.resolve(data);
	      };
	      return {
	        load: load,
	        add: add
	      };
	    };
	    var Resource = create$8();
	
	    var each$k = Tools.each, extend$5 = Tools.extend;
	    var extendClass, initializing;
	    var Class = function () {
	    };
	    Class.extend = extendClass = function (props) {
	      var self = this;
	      var _super = self.prototype;
	      var Class = function () {
	        var i, mixins, mixin;
	        var self = this;
	        if (!initializing) {
	          if (self.init) {
	            self.init.apply(self, arguments);
	          }
	          mixins = self.Mixins;
	          if (mixins) {
	            i = mixins.length;
	            while (i--) {
	              mixin = mixins[i];
	              if (mixin.init) {
	                mixin.init.apply(self, arguments);
	              }
	            }
	          }
	        }
	      };
	      var dummy = function () {
	        return this;
	      };
	      var createMethod = function (name, fn) {
	        return function () {
	          var self = this;
	          var tmp = self._super;
	          self._super = _super[name];
	          var ret = fn.apply(self, arguments);
	          self._super = tmp;
	          return ret;
	        };
	      };
	      initializing = true;
	      var prototype = new self();
	      initializing = false;
	      if (props.Mixins) {
	        each$k(props.Mixins, function (mixin) {
	          for (var name_1 in mixin) {
	            if (name_1 !== 'init') {
	              props[name_1] = mixin[name_1];
	            }
	          }
	        });
	        if (_super.Mixins) {
	          props.Mixins = _super.Mixins.concat(props.Mixins);
	        }
	      }
	      if (props.Methods) {
	        each$k(props.Methods.split(','), function (name) {
	          props[name] = dummy;
	        });
	      }
	      if (props.Properties) {
	        each$k(props.Properties.split(','), function (name) {
	          var fieldName = '_' + name;
	          props[name] = function (value) {
	            var self = this;
	            if (value !== undefined) {
	              self[fieldName] = value;
	              return self;
	            }
	            return self[fieldName];
	          };
	        });
	      }
	      if (props.Statics) {
	        each$k(props.Statics, function (func, name) {
	          Class[name] = func;
	        });
	      }
	      if (props.Defaults && _super.Defaults) {
	        props.Defaults = extend$5({}, _super.Defaults, props.Defaults);
	      }
	      each$1(props, function (member, name) {
	        if (typeof member === 'function' && _super[name]) {
	          prototype[name] = createMethod(name, member);
	        } else {
	          prototype[name] = member;
	        }
	      });
	      Class.prototype = prototype;
	      Class.constructor = Class;
	      Class.extend = extendClass;
	      return Class;
	    };
	
	    var min$1 = Math.min, max$1 = Math.max, round$2 = Math.round;
	    var Color = function (value) {
	      var self = {};
	      var r = 0, g = 0, b = 0;
	      var rgb2hsv = function (r, g, b) {
	        var h, s, v;
	        h = 0;
	        s = 0;
	        v = 0;
	        r = r / 255;
	        g = g / 255;
	        b = b / 255;
	        var minRGB = min$1(r, min$1(g, b));
	        var maxRGB = max$1(r, max$1(g, b));
	        if (minRGB === maxRGB) {
	          v = minRGB;
	          return {
	            h: 0,
	            s: 0,
	            v: v * 100
	          };
	        }
	        var d = r === minRGB ? g - b : b === minRGB ? r - g : b - r;
	        h = r === minRGB ? 3 : b === minRGB ? 1 : 5;
	        h = 60 * (h - d / (maxRGB - minRGB));
	        s = (maxRGB - minRGB) / maxRGB;
	        v = maxRGB;
	        return {
	          h: round$2(h),
	          s: round$2(s * 100),
	          v: round$2(v * 100)
	        };
	      };
	      var hsvToRgb = function (hue, saturation, brightness) {
	        hue = (parseInt(hue, 10) || 0) % 360;
	        saturation = parseInt(saturation, 10) / 100;
	        brightness = parseInt(brightness, 10) / 100;
	        saturation = max$1(0, min$1(saturation, 1));
	        brightness = max$1(0, min$1(brightness, 1));
	        if (saturation === 0) {
	          r = g = b = round$2(255 * brightness);
	          return;
	        }
	        var side = hue / 60;
	        var chroma = brightness * saturation;
	        var x = chroma * (1 - Math.abs(side % 2 - 1));
	        var match = brightness - chroma;
	        switch (Math.floor(side)) {
	        case 0:
	          r = chroma;
	          g = x;
	          b = 0;
	          break;
	        case 1:
	          r = x;
	          g = chroma;
	          b = 0;
	          break;
	        case 2:
	          r = 0;
	          g = chroma;
	          b = x;
	          break;
	        case 3:
	          r = 0;
	          g = x;
	          b = chroma;
	          break;
	        case 4:
	          r = x;
	          g = 0;
	          b = chroma;
	          break;
	        case 5:
	          r = chroma;
	          g = 0;
	          b = x;
	          break;
	        default:
	          r = g = b = 0;
	        }
	        r = round$2(255 * (r + match));
	        g = round$2(255 * (g + match));
	        b = round$2(255 * (b + match));
	      };
	      var toHex = function () {
	        var hex = function (val) {
	          val = parseInt(val, 10).toString(16);
	          return val.length > 1 ? val : '0' + val;
	        };
	        return '#' + hex(r) + hex(g) + hex(b);
	      };
	      var toRgb = function () {
	        return {
	          r: r,
	          g: g,
	          b: b
	        };
	      };
	      var toHsv = function () {
	        return rgb2hsv(r, g, b);
	      };
	      var parse = function (value) {
	        var matches;
	        if (typeof value === 'object') {
	          if ('r' in value) {
	            r = value.r;
	            g = value.g;
	            b = value.b;
	          } else if ('v' in value) {
	            hsvToRgb(value.h, value.s, value.v);
	          }
	        } else {
	          if (matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value)) {
	            r = parseInt(matches[1], 10);
	            g = parseInt(matches[2], 10);
	            b = parseInt(matches[3], 10);
	          } else if (matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value)) {
	            r = parseInt(matches[1], 16);
	            g = parseInt(matches[2], 16);
	            b = parseInt(matches[3], 16);
	          } else if (matches = /#([0-F])([0-F])([0-F])/gi.exec(value)) {
	            r = parseInt(matches[1] + matches[1], 16);
	            g = parseInt(matches[2] + matches[2], 16);
	            b = parseInt(matches[3] + matches[3], 16);
	          }
	        }
	        r = r < 0 ? 0 : r > 255 ? 255 : r;
	        g = g < 0 ? 0 : g > 255 ? 255 : g;
	        b = b < 0 ? 0 : b > 255 ? 255 : b;
	        return self;
	      };
	      if (value) {
	        parse(value);
	      }
	      self.toRgb = toRgb;
	      self.toHsv = toHsv;
	      self.toHex = toHex;
	      self.parse = parse;
	      return self;
	    };
	
	    var serialize = function (obj) {
	      var data = JSON.stringify(obj);
	      if (!isString(data)) {
	        return data;
	      }
	      return data.replace(/[\u0080-\uFFFF]/g, function (match) {
	        var hexCode = match.charCodeAt(0).toString(16);
	        return '\\u' + '0000'.substring(hexCode.length) + hexCode;
	      });
	    };
	    var JSONUtils = {
	      serialize: serialize,
	      parse: function (text) {
	        try {
	          return JSON.parse(text);
	        } catch (ex) {
	        }
	      }
	    };
	
	    var JSONP = {
	      callbacks: {},
	      count: 0,
	      send: function (settings) {
	        var self = this, dom = DOMUtils.DOM, count = settings.count !== undefined ? settings.count : self.count;
	        var id = 'tinymce_jsonp_' + count;
	        self.callbacks[count] = function (json) {
	          dom.remove(id);
	          delete self.callbacks[count];
	          settings.callback(json);
	        };
	        dom.add(dom.doc.body, 'script', {
	          id: id,
	          src: settings.url,
	          type: 'text/javascript'
	        });
	        self.count++;
	      }
	    };
	
	    var XHR = __assign(__assign({}, Observable), {
	      send: function (settings) {
	        var xhr, count = 0;
	        var ready = function () {
	          if (!settings.async || xhr.readyState === 4 || count++ > 10000) {
	            if (settings.success && count < 10000 && xhr.status === 200) {
	              settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
	            } else if (settings.error) {
	              settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
	            }
	            xhr = null;
	          } else {
	            Delay.setTimeout(ready, 10);
	          }
	        };
	        settings.scope = settings.scope || this;
	        settings.success_scope = settings.success_scope || settings.scope;
	        settings.error_scope = settings.error_scope || settings.scope;
	        settings.async = settings.async !== false;
	        settings.data = settings.data || '';
	        XHR.fire('beforeInitialize', { settings: settings });
	        xhr = new XMLHttpRequest();
	        if (xhr.overrideMimeType) {
	          xhr.overrideMimeType(settings.content_type);
	        }
	        xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
	        if (settings.crossDomain) {
	          xhr.withCredentials = true;
	        }
	        if (settings.content_type) {
	          xhr.setRequestHeader('Content-Type', settings.content_type);
	        }
	        if (settings.requestheaders) {
	          Tools.each(settings.requestheaders, function (header) {
	            xhr.setRequestHeader(header.key, header.value);
	          });
	        }
	        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	        xhr = XHR.fire('beforeSend', {
	          xhr: xhr,
	          settings: settings
	        }).xhr;
	        xhr.send(settings.data);
	        if (!settings.async) {
	          return ready();
	        }
	        Delay.setTimeout(ready, 10);
	      }
	    });
	
	    var extend$6 = Tools.extend;
	    var JSONRequest = function () {
	      function JSONRequest(settings) {
	        this.settings = extend$6({}, settings);
	        this.count = 0;
	      }
	      JSONRequest.sendRPC = function (o) {
	        return new JSONRequest().send(o);
	      };
	      JSONRequest.prototype.send = function (args) {
	        var ecb = args.error, scb = args.success;
	        var xhrArgs = extend$6(this.settings, args);
	        xhrArgs.success = function (c, x) {
	          c = JSONUtils.parse(c);
	          if (typeof c === 'undefined') {
	            c = { error: 'JSON Parse error.' };
	          }
	          if (c.error) {
	            ecb.call(xhrArgs.error_scope || xhrArgs.scope, c.error, x);
	          } else {
	            scb.call(xhrArgs.success_scope || xhrArgs.scope, c.result);
	          }
	        };
	        xhrArgs.error = function (ty, x) {
	          if (ecb) {
	            ecb.call(xhrArgs.error_scope || xhrArgs.scope, ty, x);
	          }
	        };
	        xhrArgs.data = JSONUtils.serialize({
	          id: args.id || 'c' + this.count++,
	          method: args.method,
	          params: args.params
	        });
	        xhrArgs.content_type = 'application/json';
	        XHR.send(xhrArgs);
	      };
	      return JSONRequest;
	    }();
	
	    var create$9 = function () {
	      return function () {
	        var data = {};
	        var keys = [];
	        var storage = {
	          getItem: function (key) {
	            var item = data[key];
	            return item ? item : null;
	          },
	          setItem: function (key, value) {
	            keys.push(key);
	            data[key] = String(value);
	          },
	          key: function (index) {
	            return keys[index];
	          },
	          removeItem: function (key) {
	            keys = keys.filter(function (k) {
	              return k === key;
	            });
	            delete data[key];
	          },
	          clear: function () {
	            keys = [];
	            data = {};
	          },
	          length: 0
	        };
	        Object.defineProperty(storage, 'length', {
	          get: function () {
	            return keys.length;
	          },
	          configurable: false,
	          enumerable: false
	        });
	        return storage;
	      }();
	    };
	
	    var localStorage;
	    try {
	      var test = '__storage_test__';
	      localStorage = window.localStorage;
	      localStorage.setItem(test, test);
	      localStorage.removeItem(test);
	    } catch (e) {
	      localStorage = create$9();
	    }
	    var LocalStorage = localStorage;
	
	    var publicApi = {
	      geom: { Rect: Rect },
	      util: {
	        Promise: promiseObj,
	        Delay: Delay,
	        Tools: Tools,
	        VK: VK,
	        URI: URI,
	        Class: Class,
	        EventDispatcher: EventDispatcher,
	        Observable: Observable,
	        I18n: I18n,
	        XHR: XHR,
	        JSON: JSONUtils,
	        JSONRequest: JSONRequest,
	        JSONP: JSONP,
	        LocalStorage: LocalStorage,
	        Color: Color,
	        ImageUploader: ImageUploader
	      },
	      dom: {
	        EventUtils: EventUtils,
	        Sizzle: Sizzle,
	        DomQuery: DomQuery,
	        TreeWalker: DomTreeWalker,
	        TextSeeker: TextSeeker,
	        DOMUtils: DOMUtils,
	        ScriptLoader: ScriptLoader,
	        RangeUtils: RangeUtils,
	        Serializer: DomSerializer,
	        StyleSheetLoader: StyleSheetLoader,
	        ControlSelection: ControlSelection,
	        BookmarkManager: BookmarkManager,
	        Selection: EditorSelection,
	        Event: EventUtils.Event
	      },
	      html: {
	        Styles: Styles,
	        Entities: Entities,
	        Node: AstNode,
	        Schema: Schema,
	        SaxParser: SaxParser,
	        DomParser: DomParser,
	        Writer: Writer,
	        Serializer: HtmlSerializer
	      },
	      Env: Env,
	      AddOnManager: AddOnManager,
	      Annotator: Annotator,
	      Formatter: Formatter,
	      UndoManager: UndoManager,
	      EditorCommands: EditorCommands,
	      WindowManager: WindowManager,
	      NotificationManager: NotificationManager,
	      EditorObservable: EditorObservable,
	      Shortcuts: Shortcuts,
	      Editor: Editor,
	      FocusManager: FocusManager,
	      EditorManager: EditorManager,
	      DOM: DOMUtils.DOM,
	      ScriptLoader: ScriptLoader.ScriptLoader,
	      PluginManager: PluginManager,
	      ThemeManager: ThemeManager,
	      IconManager: IconManager,
	      Resource: Resource,
	      trim: Tools.trim,
	      isArray: Tools.isArray,
	      is: Tools.is,
	      toArray: Tools.toArray,
	      makeMap: Tools.makeMap,
	      each: Tools.each,
	      map: Tools.map,
	      grep: Tools.grep,
	      inArray: Tools.inArray,
	      extend: Tools.extend,
	      create: Tools.create,
	      walk: Tools.walk,
	      createNS: Tools.createNS,
	      resolve: Tools.resolve,
	      explode: Tools.explode,
	      _addCacheSuffix: Tools._addCacheSuffix,
	      isOpera: Env.opera,
	      isWebKit: Env.webkit,
	      isIE: Env.ie,
	      isGecko: Env.gecko,
	      isMac: Env.mac
	    };
	    var tinymce = Tools.extend(EditorManager, publicApi);
	
	    var exportToModuleLoaders = function (tinymce) {
	      if (true) {
	        try {
	          module.exports = tinymce;
	        } catch (_) {
	        }
	      }
	    };
	    var exportToWindowGlobal = function (tinymce) {
	      window.tinymce = tinymce;
	      window.tinyMCE = tinymce;
	    };
	    exportToWindowGlobal(tinymce);
	    exportToModuleLoaders(tinymce);
	
	}());
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(519).setImmediate))

/***/ },
/* 1248 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./flag-en.png": 890,
		"./flag-lt.png": 891
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1249;


/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./chevron-left.svg": 643,
		"./chevron-right.svg": 644,
		"./facebook.svg": 645,
		"./instagram.svg": 646,
		"./loading.svg": 647,
		"./mastercard.svg": 648,
		"./menu.svg": 649,
		"./spinner.svg": 650,
		"./trash.svg": 651,
		"./upload.svg": 652,
		"./visa.svg": 653,
		"./xlsx-file.svg": 654,
		"./youtube.svg": 655
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1250;


/***/ }
/******/ ]);


// WEBPACK FOOTER //
// bce2de29cf1eb7c7ba0d_bundle.js